(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1211],{

/***/ 79027:
/***/ (function(module) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 79027;
module.exports = webpackEmptyAsyncContext;

/***/ }),

/***/ 91429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AppRouter": function() { return /* binding */ AppRouter; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@ionic/react/dist/index.esm.js + 16 modules
var index_esm = __webpack_require__(34158);
// EXTERNAL MODULE: ../../node_modules/history/esm/history.js + 2 modules
var esm_history = __webpack_require__(9677);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/oaf-react-router/dist/index.js
var dist = __webpack_require__(65551);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
// EXTERNAL MODULE: ./src/config/config.ts
var config_config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/auth/index.ts + 4 modules
var auth = __webpack_require__(16083);
// EXTERNAL MODULE: ./src/core/analytics/AnalyticsProvider.tsx
var AnalyticsProvider = __webpack_require__(34814);
// EXTERNAL MODULE: ./src/core/membership/useSettingUserInfoModal.tsx + 3 modules
var useSettingUserInfoModal = __webpack_require__(91535);
// EXTERNAL MODULE: ./src/core/myFavorite/useSettingMyFavoriteModal.tsx + 1 modules
var useSettingMyFavoriteModal = __webpack_require__(21657);
// EXTERNAL MODULE: ./src/core/native/device/index.ts
var device = __webpack_require__(81291);
// EXTERNAL MODULE: ../../node_modules/@capacitor/status-bar/dist/esm/index.js + 1 modules
var esm = __webpack_require__(74928);
// EXTERNAL MODULE: ../../node_modules/@capawesome/capacitor-android-edge-to-edge-support/dist/esm/index.js
var dist_esm = __webpack_require__(12051);
;// CONCATENATED MODULE: ./src/core/native/statusBar/index.ts




var setStatusBarStyleDark = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(platform) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(platform === "android")) return [
                        3,
                        2
                    ];
                    // 2025年9月時点で、CapacitorのStatusBarプラグインでは、Android15以降のStatusBar背景色の変更をサポートしていない
                    // EdgeToEdgeプラグインを使用して背景色を変更する
                    return [
                        4,
                        dist_esm/* EdgeToEdge.setBackgroundColor */.M.setBackgroundColor({
                            color: "#000000"
                        }).catch(function(e) {
                        // catch error not support platform
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        esm/* StatusBar.setStyle */.A_.setStyle({
                            style: esm/* Style.Dark */.bg.Dark
                        }).catch(function(e) {
                        //TODO catch error not support platform
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function setStatusBarStyleDark(platform) {
        return _ref.apply(this, arguments);
    };
}();
var setStatusBarStyleLight = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(platform) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(platform === "android")) return [
                        3,
                        2
                    ];
                    // 2025年9月時点で、CapacitorのStatusBarプラグインでは、Android15以降のStatusBar背景色の変更をサポートしていない
                    // EdgeToEdgeプラグインを使用して背景色を変更する
                    return [
                        4,
                        dist_esm/* EdgeToEdge.setBackgroundColor */.M.setBackgroundColor({
                            color: "#ffffff"
                        }).catch(function(e) {
                        // catch error not support platform
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        esm/* StatusBar.setStyle */.A_.setStyle({
                            style: esm/* Style.Light */.bg.Light
                        }).catch(function(e) {
                        //TODO catch error not support platform
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function setStatusBarStyleLight(platform) {
        return _ref.apply(this, arguments);
    };
}();
var setStatusBarStyle = function(platform, isDark) {
    return isDark ? setStatusBarStyleDark(platform) : setStatusBarStyleLight(platform);
};

// EXTERNAL MODULE: ./src/core/native/app/index.tsx + 35 modules
var app = __webpack_require__(76250);
// EXTERNAL MODULE: ./src/lib/errorHandler/chunkLoadError.ts
var chunkLoadError = __webpack_require__(91386);
// EXTERNAL MODULE: ../../node_modules/@sentry/capacitor/dist/esm/index.js + 179 modules
var capacitor_dist_esm = __webpack_require__(2528);
// EXTERNAL MODULE: ../../node_modules/lodash/keys.js
var keys = __webpack_require__(90249);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);
;// CONCATENATED MODULE: ./src/lib/sentry/index.tsx
/* provided dependency */ var process = __webpack_require__(34406);




function init() {
    var _CI_BUILD_NUMBER;
    var sentryOptions = {
        dsn: "https://2b2c9947a30b4df79e3346d26f1050c3@o268566.ingest.sentry.io/5946968",
        release: "utoniq-mono@" + packageJson.version,
        maxBreadcrumbs: 50,
        attachStacktrace: true,
        environment: config.environment,
        dist: (_CI_BUILD_NUMBER = process.env.CI_BUILD_NUMBER) !== null && _CI_BUILD_NUMBER !== void 0 ? _CI_BUILD_NUMBER : undefined,
        integrations: [
            Sentry.browserTracingIntegration()
        ],
        tracePropagationTargets: [
            "localhost",
            /^capacitor:\/\//,
            "capacitor://localhost",
            "http://localhost:*",
            "https://localhost:*",
            "ionic://localhost",
            config.domain, 
        ]
    };
    // When we're developing locally
    if (false) {}
    /**
   * @Note missing tags if init sentry after add tags
   */ Sentry.init(sentryOptions);
    Sentry.setTag("application", packageJson.name);
    Sentry.setTag("applicationKey", config.applicationKey);
}
function setTags(tags) {
    var tagKeys = keys_default()(tags);
    tagKeys.forEach(function(key) {
        if (tags === null || tags === void 0 ? void 0 : tags[key]) {
            capacitor_dist_esm/* setTag */.YA(key, tags[key]);
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/@capacitor/app/dist/esm/index.js
var app_dist_esm = __webpack_require__(68339);
// EXTERNAL MODULE: ../../node_modules/@pantrist/capacitor-firebase-dynamic-links/dist/esm/index.js
var capacitor_firebase_dynamic_links_dist_esm = __webpack_require__(7106);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
;// CONCATENATED MODULE: ./src/app/router/DeepLink.tsx





var AppUrlListener = function() {
    var router = (0,useRouter/* useRouter */.tv)().router;
    // firebaseダイナミックリンクpage.linkを読み込むための記述
    // ダイナミックリンク削除の際にこちらは削除する
    capacitor_firebase_dynamic_links_dist_esm/* FirebaseDynamicLinks.addListener */.p.addListener("deepLinkOpen", function(event) {
        var url = new URL(event.url);
        var path = url.pathname;
        router.push(path);
    });
    app_dist_esm/* App.addListener */.g.addListener("appUrlOpen", function(event) {
        // configで指定されたdeeplinkUrlを含まない場合画面遷移しない
        if (![
            config_config/* config.deeplinkDev */.v.deeplinkDev,
            config_config/* config.deeplinkStg */.v.deeplinkStg,
            config_config/* config.deeplinkProd */.v.deeplinkProd
        ].some(function(link) {
            return link && event.url.includes(link);
        })) return;
        var url = new URL(event.url);
        var path = url.pathname;
        router.push(path);
    });
    return null;
};
/* harmony default export */ var DeepLink = (AppUrlListener);

// EXTERNAL MODULE: ./src/components/pages/Errors/NotFoundWeb/index.tsx + 1 modules
var NotFoundWeb = __webpack_require__(5978);
// EXTERNAL MODULE: ./src/core/native/storage/index.ts
var storage = __webpack_require__(57782);
// EXTERNAL MODULE: ./src/app/router/ConsoleRouter.tsx
var ConsoleRouter = __webpack_require__(60133);
// EXTERNAL MODULE: ./src/app/router/GuestOnlyRoute.tsx
var GuestOnlyRoute = __webpack_require__(59854);
// EXTERNAL MODULE: ./src/app/router/routes.ts
var routes = __webpack_require__(78351);
;// CONCATENATED MODULE: ./src/app/router/NativeOnlyRouter.tsx
/**
 * @description
 * Diicaなど、ネイティブのみでアプリを表示するが、アーティスト管理画面をWebでホスティングしたいケースのため、ログインページとconsole下のみルーティングを設定する
 * https://app.clickup.com/t/908127/UT-9697
 */ 















var Login = dynamic_default()(__webpack_require__.e(/* import() */ 5157).then(__webpack_require__.bind(__webpack_require__, 95157)).then(function(m) {
    return m.Login;
}).catch(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95157)
            ];
        }
    },
    ssr: false
});
/**
 * This routing is for Organization App.
 * To build artist stand alone app, we need to create its app router.
 */ var NativeOnlyRouter = function(param) {
    var user = param.user, isConsole = param.isConsole;
    var ref, ref1;
    (0,app/* useBackButtonListener */.EJ)();
    var ref2 = (0,useRouter/* useRouter */.tv)(), pathname = ref2.router.pathname;
    var ref3 = (0,react.useState)(routes/* routes.GlobalHome.path */._j.GlobalHome.path), redirectPath = ref3[0], setRedirectPath = ref3[1];
    var ref4 = (0,react.useState)(true), loading = ref4[0], setLoading = ref4[1];
    (0,react.useEffect)(function() {
        setLoading(true);
        (0,storage/* getRedirectAfterLoginPath */.CT)().then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var value;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    value = param.value;
                    return [
                        2,
                        setRedirectPath(value || routes/* routes.ConsoleDashboard.path */._j.ConsoleDashboard.path)
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()).finally(function() {
            return setLoading(false);
        });
        return function() {};
    }, []);
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    (0,useRouter/* useTrackPageView */.Px)(function(param) {
        var location = param.location;
        /**
     * HACK:
     * SPAのHTMLが切り替わる前にanalytics.pageが発火してしまい前ページの情報が入ってしまうため、0.2秒待つ
     * ref: https://github.com/DavidWells/analytics/issues/177
     */ setTimeout(function() {
            return analytics === null || analytics === void 0 ? void 0 : analytics.page();
        }, 200);
    });
    (0,auth/* useTrackIdentify */.yL)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var user, applicationKey;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        user = param.user, applicationKey = param.applicationKey;
                        return [
                            4,
                            analytics === null || analytics === void 0 ? void 0 : analytics.identify(user, {
                                application_key: applicationKey
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    if (loading) return null;
    // ログインしているが、アーティストではない場合は404を返す
    if (!!user && !isConsole) return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: "*",
        render: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundWeb/* NotFoundWeb */.c, {});
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestOnlyRoute/* GuestOnlyRoute */.w, {
                exact: true,
                path: routes/* routes.Login.path */._j.Login.path,
                element: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {}),
                isLogin: !!user,
                redirectPath: redirectPath
            }),
            pathname.includes("console") && ((ref = (0,ConsoleRouter/* ConsoleRouter */.h)({
                user: user
            })) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.children),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
                path: "*",
                render: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundWeb/* NotFoundWeb */.c, {});
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/app/router/AppRouter.tsx
"use client";




















(0,index_esm/* setupIonicReact */.bg)({
    mode: "ios"
});
var AppRouter_history = (0,esm_history/* createBrowserHistory */.lX)();
(0,dist.wrapHistory)(AppRouter_history);
var OrganizationRouter = dynamic_default()(config_config/* config.applicationType */.v.applicationType === "organization" ? Promise.all(/* import() */[__webpack_require__.e(4550), __webpack_require__.e(8689)]).then(__webpack_require__.bind(__webpack_require__, 48689)).then(function(m) {
    return m.OrganizationRouter;
}).catch(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48689)
            ];
        }
    },
    ssr: false
});
var StandaloneRouter = dynamic_default()(config_config/* config.applicationType */.v.applicationType === "standalone" ? Promise.all(/* import() */[__webpack_require__.e(4550), __webpack_require__.e(1275)]).then(__webpack_require__.bind(__webpack_require__, 21275)).then(function(m) {
    return m.StandaloneRouter;
}).catch(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21275)
            ];
        }
    },
    ssr: false
});
var AppRouter = function() {
    var ref, ref1, ref2, ref3;
    var deviceInfo = device/* useDeviceInfo */.u().deviceInfo;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var appVersion = (0,app/* useAppVersion */.Ql)();
    var ref4 = (0,auth/* useCurrentUser */.xJ)(), user = ref4.user, userLoading = ref4.loading, userClaims = ref4.userClaims;
    var isConsole = !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist);
    (0,react.useEffect)(function() {
        var ref;
        setStatusBarStyle((ref = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) !== null && ref !== void 0 ? ref : "", config_config/* config.theme.dark */.v.theme.dark);
    }, [
        deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform
    ]);
    (0,react.useEffect)(function() {
        if (user) {
            var ref, ref1;
            var providerId = (ref = user.providers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.providerId;
            analytics === null || analytics === void 0 ? void 0 : analytics.track("login", {
                loginMethod: providerId === "password" ? "email" : providerId,
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                isAnonymous: user.isAnonymous
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    // add sentry tags
    (0,react.useEffect)(function() {
        setTags({
            userId: user === null || user === void 0 ? void 0 : user.uid,
            appVersion: appVersion,
            liveupdate: config_config/* config.buildId.slice */.v.buildId.slice(0, 6)
        });
    }, [
        user === null || user === void 0 ? void 0 : user.uid,
        appVersion
    ]);
    if (userLoading || !(deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform)) {
        return null;
    }
    /**
   * ネイティブのみのアプリをWebで開いた場合(例：Diica, Playdeck)
   * ログイン画面と管理画面のみのルーターに遷移する
   *
   * diicaはWebなしSTG環境ではNativeOnlyRouterに遷移する
   * playdeckでも同様の処理を追加
   */ if (!config_config/* config.platform.includes */.v.platform.includes("web") && (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) === "web" && !isConsole && (config_config/* config.environment */.v.environment === "production" || location.host === "diica-stg-webview.netlify.app" || location.host === "playdeck-stg.netlify.app")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IonApp */.dr, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router/* Router */.F0, {
                history: AppRouter_history,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepLink, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeOnlyRouter, {
                        user: user,
                        isConsole: isConsole
                    })
                ]
            })
        });
    }
    if (config_config/* config.applicationType */.v.applicationType === "standalone") {
        var ref5, ref6;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IonApp */.dr, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router/* Router */.F0, {
                history: AppRouter_history,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepLink, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(useSettingUserInfoModal/* SettingUserInfoModalProvider */.Q, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useSettingMyFavoriteModal/* SettingMyFavoriteModalProvider */.E, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StandaloneRouter, {
                                isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref5 = userClaims.orgs) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[config_config/* config.organizationId */.v.organizationId]) === null || ref6 === void 0 ? void 0 : ref6.artist),
                                user: user,
                                isConsole: isConsole
                            })
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IonApp */.dr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router/* Router */.F0, {
            history: AppRouter_history,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepLink, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(useSettingUserInfoModal/* SettingUserInfoModalProvider */.Q, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useSettingMyFavoriteModal/* SettingMyFavoriteModalProvider */.E, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationRouter, {
                            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref2 = userClaims.orgs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[config_config/* config.organizationId */.v.organizationId]) === null || ref3 === void 0 ? void 0 : ref3.artist),
                            user: user,
                            isConsole: isConsole
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 60133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ConsoleRouter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16550);
/* harmony import */ var _components_pages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51207);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90860);
/* harmony import */ var _lib_errorHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91386);
/* harmony import */ var _PrivateRoute__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78727);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78351);










var ConsoleLiveSetting = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(_config__WEBPACK_IMPORTED_MODULE_3__/* .config.modules.liveStream */ .v.modules.liveStream ? __webpack_require__.e(/* import() */ 7098).then(__webpack_require__.bind(__webpack_require__, 7098)).then(function(m) {
    return m.ConsoleLiveSetting;
}).catch(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_6__/* .handleChunkLoadError */ .Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7098)
            ];
        }
    },
    ssr: false
});
var ConsoleLiveDetail = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(_config__WEBPACK_IMPORTED_MODULE_3__/* .config.modules.liveStream */ .v.modules.liveStream ? __webpack_require__.e(/* import() */ 9214).then(__webpack_require__.bind(__webpack_require__, 9214)).then(function(m) {
    return m.ConsoleLiveDetail;
}).catch(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_6__/* .handleChunkLoadError */ .Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9214)
            ];
        }
    },
    ssr: false
});
var ConsoleLiveFinish = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(_config__WEBPACK_IMPORTED_MODULE_3__/* .config.modules.liveStream */ .v.modules.liveStream ? __webpack_require__.e(/* import() */ 1772).then(__webpack_require__.bind(__webpack_require__, 31772)).then(function(m) {
    return m.ConsoleLiveFinish;
}).catch(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_6__/* .handleChunkLoadError */ .Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31772)
            ];
        }
    },
    ssr: false
});
var ConsoleData = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.all(/* import() */[__webpack_require__.e(5232), __webpack_require__.e(3723)]).then(__webpack_require__.bind(__webpack_require__, 33723)).then(function(m) {
    return m.ConsoleData;
}).catch(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_6__/* .handleChunkLoadError */ .Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33723)
            ];
        }
    },
    ssr: false
});
/**
 * This routing is for Console App.
 * To build artist management , we need to create its app router.
 */ var ConsoleRouter = function(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDashboard.path */ ._j.ConsoleDashboard.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleHome */ .N3D, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUserDetail.path */ ._j.ConsoleUserDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUserDetail */ .EVb, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUserOwnedItems.path */ ._j.ConsoleUserOwnedItems.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUserOwnedItems */ .Cxh, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUserOwnedItemDetail.path */ ._j.ConsoleUserOwnedItemDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUserOwnedItemDetail */ .c_t, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCampaigns.path */ ._j.ConsoleCampaigns.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCampaigns */ .gC_, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCampaignDetail.path */ ._j.ConsoleCampaignDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCampaignDetail */ .fjw, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMembership.path */ ._j.ConsoleMembership.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMembership */ .OhI, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDigitalMembershipCard.path */ ._j.ConsoleDigitalMembershipCard.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDigitalMembershipCard */ .L7K, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDigitalMembershipDefaultCardDesignEdit.path */ ._j.ConsoleDigitalMembershipDefaultCardDesignEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDigitalMembershipDefaultCardDesignEdit */ .G3B, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDigitalMembershipCardDesignEdit.path */ ._j.ConsoleDigitalMembershipCardDesignEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDigitalMembershipCardDesignEdit */ .XdA, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleFavoriteMemberSettings.path */ ._j.ConsoleFavoriteMemberSettings.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleFavoriteMemberSettings */ .co7, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleFavoriteMemberCreate.path */ ._j.ConsoleFavoriteMemberCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleFavoriteMemberCreate */ .Ksz, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleFavoriteMemberEdit.path */ ._j.ConsoleFavoriteMemberEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleFavoriteMemberEdit */ .BYx, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleFans.path */ ._j.ConsoleFans.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleFans */ .Uxg, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMembershipDetail.path */ ._j.ConsoleMembershipDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMembershipDetail */ .cEH, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleOfficialInformations.path */ ._j.ConsoleOfficialInformations.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleOfficialInformations */ .NV8, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleOfficialInformationCreate.path */ ._j.ConsoleOfficialInformationCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleOfficialInformationCreate */ .d4r, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleOfficialInformationEdit.path */ ._j.ConsoleOfficialInformationEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleOfficialInformationEdit */ .SXj, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePost.path */ ._j.ConsolePost.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePosts */ .fxg, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUnpublishedPosts.path */ ._j.ConsoleUnpublishedPosts.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUnpublishedPosts */ .yJV, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePostDetail.path */ ._j.ConsolePostDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePostDetail */ .Ftt, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePostCreate.path */ ._j.ConsolePostCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePostCreate */ .qt_, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePostEdit.path */ ._j.ConsolePostEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePostEdit */ .dKc, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePostCategories.path */ ._j.ConsolePostCategories.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePostCategories */ .rmN, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleAccountSetting.path */ ._j.ConsoleAccountSetting.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleAccountSetting */ .ZSW, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMyProfileEdit.path */ ._j.ConsoleMyProfileEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMyProfileEdit */ .wZl, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleRevenue.path */ ._j.ConsoleRevenue.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleRevenue */ .lye, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleBankEdit.path */ ._j.ConsoleBankEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleBankEdit */ .HOA, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItems.path */ ._j.ConsoleItems.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItems */ .YRc, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemCreate.path */ ._j.ConsoleItemCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemCreate */ .oWE, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemEdit.path */ ._j.ConsoleItemEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemEdit */ .n7G, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemOrders.path */ ._j.ConsoleItemOrders.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemOrders */ .T_7, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemDetail.path */ ._j.ConsoleItemDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemDetail */ .Q1z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemInformation.path */ ._j.ConsoleItemInformation.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemInformation */ .pCC, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleItemInformationLimitUser.path */ ._j.ConsoleItemInformationLimitUser.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleItemInformationLimitUser */ .ljQ, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleBusinessEdit.path */ ._j.ConsoleBusinessEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleBusinessEdit */ .gwy, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCollections.path */ ._j.ConsoleCollections.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCollections */ .or1, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCollectionCreate.path */ ._j.ConsoleCollectionCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCollectionCreate */ .Zsy, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCollectionEdit.path */ ._j.ConsoleCollectionEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCollectionEdit */ .FJR, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCollectionDetail.path */ ._j.ConsoleCollectionDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCollectionDetail */ .XF0, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCryptocurrencyWallet.path */ ._j.ConsoleCryptocurrencyWallet.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCryptocurrencyWallet */ .a60, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMissions.path */ ._j.ConsoleMissions.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMissions */ .MN2, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMissionCreate.path */ ._j.ConsoleMissionCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMissionCreate */ .AKH, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMissionEdit.path */ ._j.ConsoleMissionEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMissionEdit */ .ugd, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMembershipExplain.path */ ._j.ConsoleMembershipExplain.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMembershipExplain */ .Ucn, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMembershipCreate.path */ ._j.ConsoleMembershipCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMembershipCreate */ .sSr, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleMembershipEdit.path */ ._j.ConsoleMembershipEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleMembershipEdit */ ._15, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDmRooms.path */ ._j.ConsoleDmRooms.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDmRooms */ .Lnk, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDmRoomCreate.path */ ._j.ConsoleDmRoomCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDmRoomCreate */ .hZN, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDmRoomDetail.path */ ._j.ConsoleDmRoomDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDmRoomDetail */ .dvk, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleShokufesEvents.path */ ._j.ConsoleShokufesEvents.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleEvents */ .lnt, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleShokufesEventCreate.path */ ._j.ConsoleShokufesEventCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleEventCreate */ .AVD, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleShokufesEventEdit.path */ ._j.ConsoleShokufesEventEdit.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleEventEdit */ .sI5, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleShokufesEventDetail.path */ ._j.ConsoleShokufesEventDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleEventDetail */ .FSQ, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleQuantityManagements.path */ ._j.ConsoleQuantityManagements.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleQuantityManagements */ .Zgz, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleTicketReceives.path */ ._j.ConsoleTicketReceives.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleTicketReceives */ .PCT, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleTicketReceiveDetail.path */ ._j.ConsoleTicketReceiveDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleTicketReceiveDetail */ .X2Y, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleOrders.path */ ._j.ConsoleOrders.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleOrders */ .uri, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUsers.path */ ._j.ConsoleUsers.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUsers */ .ZWJ, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUserOrders.path */ ._j.ConsoleUserOrders.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUserOrders */ .QMV, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleOrderDetail.path */ ._j.ConsoleOrderDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleOrderDetail */ .Zf9, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleUsers.path */ ._j.ConsoleUsers.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleUsers */ .ZWJ, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleData.path */ ._j.ConsoleData.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConsoleData, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleCampaignBannerSetting.path */ ._j.ConsoleCampaignBannerSetting.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleCampaignBannerSetting */ .uOF, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleDeliveryManagement.path */ ._j.ConsoleDeliveryManagement.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleDeliveryManagement */ .S4W, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePreSaleCreate.path */ ._j.ConsolePreSaleCreate.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePreSaleCreate */ .Hmn, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePreSaleDetail.path */ ._j.ConsolePreSaleDetail.path,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePreSaleDetail */ .tJA, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsolePreSaleEdit */ .lqo, {}),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsolePreSaleEdit.path */ ._j.ConsolePreSaleEdit.path
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleLotteryManagementDetail */ .xSR, {}),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLotteryManagementDetail.path */ ._j.ConsoleLotteryManagementDetail.path
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleLotteryCsvUpload */ .s8B, {}),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLotteryCsvUpload.path */ ._j.ConsoleLotteryCsvUpload.path
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                exact: true,
                isLogin: !!user,
                element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages__WEBPACK_IMPORTED_MODULE_2__/* .ConsoleLotteryManagements */ .BTm, {}),
                path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLotteryManagements.path */ ._j.ConsoleLotteryManagements.path
            }),
            _config__WEBPACK_IMPORTED_MODULE_3__/* .config.modules.liveStream */ .v.modules.liveStream && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_router_dom__WEBPACK_IMPORTED_MODULE_9__/* .Switch */ .rs, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                        exact: true,
                        isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                        path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLiveSetting.path */ ._j.ConsoleLiveSetting.path,
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConsoleLiveSetting, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                        exact: true,
                        isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                        path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLiveDetail.path */ ._j.ConsoleLiveDetail.path,
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConsoleLiveDetail, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PrivateRoute__WEBPACK_IMPORTED_MODULE_7__/* .PrivateRoute */ .M, {
                        exact: true,
                        isLogin: !!(user === null || user === void 0 ? void 0 : user.isSigned),
                        path: _routes__WEBPACK_IMPORTED_MODULE_8__/* .routes.ConsoleLiveFinish.path */ ._j.ConsoleLiveFinish.path,
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConsoleLiveFinish, {})
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 59854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ GuestOnlyRoute; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16550);





/**
 * @param isLogin boolean ログインしているかどうか
 * @param redirectPath ログインしていない場合のリダイレクト先 ない場合はGlobalHomeへ
 * @returns
 */ var GuestOnlyRoute = function(_param) {
    var isLogin = _param.isLogin, redirectPath = _param.redirectPath, element = _param.element, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isLogin",
        "redirectPath",
        "element"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Route */ .AW, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        render: function(param) {
            var location = param.location;
            // ログインしていれば、リダイレクト
            if (isLogin) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Redirect */ .l_, {
                to: {
                    pathname: redirectPath,
                    state: {
                        from: location
                    }
                }
            });
            return element;
        }
    }));
};


/***/ }),

/***/ 78727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PrivateRoute; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16550);





/**
 * ユーザーのみみれるページ。ログインしていなければ、ログインページに飛ばす。
 *
 */ var PrivateRoute = function(_param) {
    var element = _param.element, isLogin = _param.isLogin, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "element",
        "isLogin"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Route */ .AW, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        render: function(param) {
            var location = param.location;
            if (!isLogin) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Redirect */ .l_, {
                to: {
                    pathname: "/login",
                    state: {
                        from: location
                    },
                    search: "redirectUri=".concat(encodeURIComponent(location.pathname))
                }
            });
            return element;
        }
    }));
};


/***/ }),

/***/ 54040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oz": function() { return /* binding */ useLinkingAnonymousAccountState; },
/* harmony export */   "Zk": function() { return /* binding */ useCurrentArtistState; },
/* harmony export */   "ag": function() { return /* binding */ currentArtistVar; },
/* harmony export */   "xN": function() { return /* binding */ linkingAnonymousAccount; }
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17600);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49566);
/**
 * Datum that manage in reactive var local state.
 */ 
/**
 * Current Artist State from utoniq-core on current page.
 */ var currentArtistVar = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .makeVar */ .QS)(null);
var useCurrentArtistState = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useReactiveVar */ .l)(currentArtistVar);
};
var linkingAnonymousAccount = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .makeVar */ .QS)(false);
var useLinkingAnonymousAccountState = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useReactiveVar */ .l)(linkingAnonymousAccount);
};


/***/ }),

/***/ 60722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ArtistHeaderItemsRight; },
/* harmony export */   "p": function() { return /* binding */ ArtistHeaderItemsLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38677);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61631);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var _ArtistSideMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43815);






var ArtistHeaderItemsLeft = function() {
    var routerPages = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)().routerPages;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openSideMenu = ref[0], setOpenSideMenu = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Menu, {
                        onClick: function() {
                            return setOpenSideMenu(true);
                        },
                        edge: "start",
                        color: "white",
                        bgcolor: "transparent",
                        sx: {
                            display: {
                                md: "none"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Notice, {
                        href: routerPages.Notifications,
                        color: "white",
                        bgcolor: "transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ArtistSideMenu__WEBPACK_IMPORTED_MODULE_5__/* .ArtistSideMenu */ .u, {
                open: openSideMenu,
                onClose: function() {
                    return setOpenSideMenu(false);
                }
            })
        ]
    });
};
var ArtistHeaderItemsRight = function(param) {
    var artistId = param.artistId;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("consoleHome").t;
    var ref = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        sx: {
            minWidth: 124,
            mr: -3,
            color: "white"
        },
        variant: "text",
        href: generatePath(routerPages.ArtistTop, {
            artistId: artistId
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Window, {
                color: "inherit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    ml: 1
                },
                color: "inherit",
                variant: "subtitle1",
                children: t("viewTheApp")
            })
        ]
    });
};


/***/ }),

/***/ 43815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ArtistSideMenu; },
  "i": function() { return /* binding */ ArtistSideMenuForPC; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@capacitor/browser/dist/esm/index.js
var esm = __webpack_require__(18260);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(35460);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(87639);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(81714);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(18960);
// EXTERNAL MODULE: ../../node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(95341);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(41075);
// EXTERNAL MODULE: ../../node_modules/@mui/material/List/List.js
var List = __webpack_require__(81774);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListSubheader/ListSubheader.js
var ListSubheader = __webpack_require__(89098);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var schema = __webpack_require__(66517);
// EXTERNAL MODULE: ./src/components/styles/AppThemeProvider.tsx
var AppThemeProvider = __webpack_require__(2943);
// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(45269);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/liveStream/index.ts
var liveStream = __webpack_require__(17470);
// EXTERNAL MODULE: ./src/core/native/app/index.tsx + 35 modules
var app = __webpack_require__(76250);
// EXTERNAL MODULE: ./src/lib/array/index.ts
var array = __webpack_require__(79832);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ./src/core/auth/index.ts + 4 modules
var auth = __webpack_require__(16083);
;// CONCATENATED MODULE: ./src/components/layouts/ConsoleBaseLayout/useGetArtistSideMenuInfo.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleSideMenuInfo($artistId: ID) {\n    artist(id: $artistId) {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n    organization {\n      id\n      modules {\n        dmRoom\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// コンソール画面のサイドバーの表示に必要なデータを取得する
var useGetArtistSideMenuInfo = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var data = (0,useQuery/* useQuery */.aM)(QUERY, {
        variables: {
            artistId: user === null || user === void 0 ? void 0 : user.uid
        }
    }).data;
    var ref6, ref7;
    return {
        user: user,
        paymentType: (ref6 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.paymentType) !== null && ref6 !== void 0 ? ref6 : null,
        hasArrangingDeliveryItems: data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.hasArrangingDeliveryItems,
        membership: (ref7 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products) !== null && ref7 !== void 0 ? ref7 : undefined,
        enableDmRoom: !!(data === null || data === void 0 ? void 0 : (ref4 = data.organization) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.modules) === null || ref5 === void 0 ? void 0 : ref5.dmRoom)
    };
};
var QUERY = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/components/layouts/ArtistSideMenu/index.tsx














// 画面幅 md 未満で使用するトグル可能なサイドメニュー
var ArtistSideMenu = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppThemeProvider/* AppThemeProvider */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuDrawer, {
            anchor: "left",
            open: open,
            onClose: onClose,
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
                    display: "none"
                });
            },
            PaperProps: {
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                    backgroundImage: "none",
                    left: "initial"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuContainer, {})
        })
    });
};
// 画面幅 md 以上で常時表示するサイドメニュー
var ArtistSideMenuForPC = function(param) {
    var onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppThemeProvider/* AppThemeProvider */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuDrawer, {
            anchor: "left",
            onClose: onClose,
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({
                    width: "100%"
                }, theme.breakpoints.down("md"), {
                    display: "none"
                });
            },
            PaperProps: {
                sx: {
                    borderRight: "none"
                }
            },
            // Drawer を常時表示するための指定
            variant: "permanent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuContainer, {})
        })
    });
};
// サイドメニュー本体
var SideMenuContainer = function() {
    var ref = useGetArtistSideMenuInfo(), currentUser = ref.user, paymentType = ref.paymentType, hasArrangingDeliveryItems = ref.hasArrangingDeliveryItems, membership = ref.membership, enableDmRoom = ref.enableDmRoom;
    var t = (0,i18n/* useTranslation */.$G)("artistSideMenu").t;
    var ref1 = (0,useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router, generatePath = ref1.generatePath;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var isWeb = (0,app/* getPlatform */.Xf)() === "web";
    var ref3 = (0,react.useState)(false), openInNativeLiveStreamModal = ref3[0], setOpenInNativeLiveStreamModal = ref3[1];
    var listService = (0,react.useMemo)(function() {
        return [
            {
                title: t("home"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Home, {
                    href: routerPages.ConsoleDashboard,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("officialInfo"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Info, {
                    size: "medium",
                    href: routerPages.ConsoleOfficialInformations,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("posts"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Post, {
                    size: "medium",
                    href: routerPages.ConsolePost,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("items"),
                hidden: !config/* config.modules.item */.v.modules.item,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.OwnedItems, {
                    href: routerPages.ConsoleItems,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("collections"),
                hidden: !config/* config.modules.item */.v.modules.item,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Collection, {
                    href: routerPages.ConsoleCollections,
                    size: "medium",
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("missions"),
                hidden: !config/* config.modules.mission */.v.modules.mission,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Mission, {
                    href: routerPages.ConsoleMissions,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            // {
            //   title: t('communityManagement'),
            //   href:routerPages.MyOwnedItems,
            //   Icon: <Icons.Thread />,
            // },
            {
                title: t("DmRooms"),
                hidden: !enableDmRoom,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.DM, {
                    href: routerPages.ConsoleDmRooms,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("liveStream"),
                hidden: !(0,liveStream/* isAvailableLiveStream */.v)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Live, {
                    onClick: function() {
                        if (isWeb) router.push(generatePath(routerPages.ConsoleLiveSetting));
                        setOpenInNativeLiveStreamModal(true);
                    },
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                hidden: !config/* config.modules.event */.v.modules.event,
                title: t("events"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.ShokufesEvent, {
                    href: routerPages.ConsoleShokufesEvents,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("data"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Level, {
                    href: routerPages.ConsoleData,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                title: t("setting"),
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Setting, {
                    href: routerPages.ConsoleAccountSetting,
                    sx: {
                        color: "grey.700"
                    },
                    bgcolor: "grey.50"
                })
            }, 
        ];
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid,
        generatePath,
        isWeb,
        router,
        routerPages.ConsoleAccountSetting,
        routerPages.ConsoleCollections,
        routerPages.ConsoleDashboard,
        routerPages.ConsoleData,
        routerPages.ConsoleDmRooms,
        routerPages.ConsoleItems,
        routerPages.ConsoleLiveSetting,
        routerPages.ConsoleMissions,
        routerPages.ConsolePost,
        routerPages.ConsoleShokufesEvents,
        t,
        enableDmRoom, 
    ]);
    var earnings = (0,react.useMemo)(function() {
        return [
            {
                title: t("orders"),
                href: routerPages.ConsoleOrders,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Cart, {
                    sx: {
                        color: "grey.700"
                    }
                })
            },
            {
                title: t("customerInfo"),
                href: routerPages.ConsoleUsers,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.User, {
                    sx: {
                        color: "grey.700"
                    }
                })
            },
            {
                title: t("revenue", "収益管理"),
                // Billingアカウントの場合、収益管理は見えないようにする。
                hidden: !paymentType || paymentType === schema/* ArtistPaymentType.Billing */.bBx.Billing,
                href: routerPages.ConsoleRevenue,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Money, {
                    sx: {
                        color: "grey.700"
                    }
                })
            },
            {
                title: t("membership"),
                hidden: !membership && paymentType === schema/* ArtistPaymentType.Billing */.bBx.Billing,
                href: routerPages.ConsoleMembership,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Group, {
                    sx: {
                        color: "grey.700"
                    }
                })
            },
            {
                title: t("delivery"),
                href: routerPages.ConsoleDeliveryManagement,
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: hasArrangingDeliveryItems ? "" : undefined,
                    color: "like",
                    sx: {
                        "& > span": {
                            top: 0,
                            right: 0,
                            minWidth: 12,
                            height: 12,
                            bgcolor: "like.tap"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Delivery, {
                        sx: {
                            color: "grey.700"
                        }
                    })
                }),
                secondaryAction: hasArrangingDeliveryItems ? t("hasItemWaitingDelivery") : ""
            }, 
        ];
    }, [
        hasArrangingDeliveryItems,
        paymentType,
        routerPages.ConsoleDeliveryManagement,
        routerPages.ConsoleMembership,
        routerPages.ConsoleOrders,
        routerPages.ConsoleRevenue,
        routerPages.ConsoleUsers,
        t, 
    ]);
    var secondCreation = (0,react.useMemo)(function() {
        return [
            {
                title: t("derivativeWorks"),
                href: "#",
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Image, {
                    sx: {
                        color: "grey.700"
                    }
                })
            },
            {
                title: t("rights"),
                href: "#",
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Right, {
                    sx: {
                        color: "grey.700"
                    }
                })
            }, 
        ];
    }, [
        t
    ]);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var mobileSideMenuWidth = constants/* constants.ui.layout.mobileSideMenuWidth */._.ui.layout.mobileSideMenuWidth;
    var desktopSideMenuWidth = constants/* constants.ui.layout.desktopSideMenuWidth */._.ui.layout.desktopSideMenuWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    width: {
                        xs: mobileSideMenuWidth,
                        md: desktopSideMenuWidth
                    },
                    bgcolor: "background.default"
                },
                disableGutters: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        sx: {
                            py: 3,
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl) || "",
                                        sx: {
                                            width: 36,
                                            height: 36
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        sx: {
                                            fontSize: {
                                                md: 14
                                            }
                                        },
                                        children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                                size: "small",
                                color: "grey.700",
                                bgcolor: "grey.50",
                                onClick: handleClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                anchorEl: anchorEl,
                                open: Boolean(anchorEl),
                                onClose: handleClose,
                                transformOrigin: {
                                    horizontal: "right",
                                    vertical: "top"
                                },
                                anchorOrigin: {
                                    horizontal: "right",
                                    vertical: "bottom"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        onClick: function() {
                                            handleClose();
                                            router.push(routerPages.ConsoleMyProfileEdit);
                                        },
                                        sx: {
                                            width: 200,
                                            py: 3
                                        },
                                        children: t("consoleMyProfileEdit")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        onClick: function() {
                                            handleClose();
                                            router.push(routerPages.ConsoleCampaignBannerSetting);
                                        },
                                        sx: {
                                            width: 200,
                                            py: 3
                                        },
                                        children: t("consoleCampaignBannerSetting")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        rowSpacing: 5,
                        columnSpacing: 1,
                        sx: {
                            py: 3,
                            px: 5
                        },
                        children: (0,array/* filterHiddenItem */.s)(listService).map(function(param, index) {
                            var Icon = param.Icon, title = param.title;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    flex: 1,
                                    alignItems: "center",
                                    spacing: 2,
                                    children: [
                                        Icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: title
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    (config/* config.modules.membership */.v.modules.membership || paymentType === schema/* ArtistPaymentType.Connect */.bBx.Connect || config/* config.modules.preSale */.v.modules.preSale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                            sx: {
                                pb: "2px",
                                pt: 4,
                                px: 5,
                                bgcolor: "background.default"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                sx: {
                                    fontSize: {
                                        md: 12
                                    }
                                },
                                children: t("earnings")
                            })
                        }),
                        children: (0,array/* filterHiddenItem */.s)(earnings).map(function(param, index) {
                            var href = param.href, title = param.title, Icon = param.Icon, secondaryAction = param.secondaryAction;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                href: href,
                                title: title,
                                icon: Icon,
                                sx: {
                                    px: 5
                                },
                                primaryTypographyProps: {
                                    fontSize: {
                                        md: 16
                                    }
                                },
                                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "like.tap",
                                    children: secondaryAction
                                })
                            }, index);
                        })
                    }),
                    config/* config.modules.nft */.v.modules.nft && false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openInNativeLiveStreamModal,
                onClose: function() {
                    return setOpenInNativeLiveStreamModal(false);
                },
                title: t("inNativeLiveStreamModalTitle"),
                content: t("inNativeLiveStreamModalContent"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    size: "large",
                    fullWidth: true,
                    onClick: function() {
                        esm/* Browser.open */.A.open({
                            url: "".concat(config/* config.domain */.v.domain).concat(routerPages.ConsoleLiveSetting)
                        }).then(function() {
                            return setOpenInNativeLiveStreamModal(false);
                        });
                    },
                    children: t("openBrowser")
                }),
                cancelText: t("close")
            })
        ]
    });
};


/***/ }),

/***/ 24038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ BaseLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@capacitor/core/dist/index.js
var dist = __webpack_require__(23807);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(12363);
// EXTERNAL MODULE: ../../node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(16305);
// EXTERNAL MODULE: ../../node_modules/lodash/merge.js
var merge = __webpack_require__(98537);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(66582);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/material/BottomNavigation/BottomNavigation.js
var BottomNavigation = __webpack_require__(64316);
// EXTERNAL MODULE: ../../node_modules/@mui/material/BottomNavigationAction/BottomNavigationAction.js
var BottomNavigationAction = __webpack_require__(56984);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(35460);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var utoniq_ui_dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/components/lib/BrowserLink/index.tsx
var BrowserLink = __webpack_require__(3405);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/lib/privateAction/index.ts
var privateAction = __webpack_require__(14514);
;// CONCATENATED MODULE: ./src/components/organisms/navigation/GlobalBottomNavigation/TabList.tsx







var useTabList = function(param) {
    var hasManagementTask = param.hasManagementTask, hasSettingTask = param.hasSettingTask, _unreadNotificationCount = param.unreadNotificationCount, unreadNotificationCount = _unreadNotificationCount === void 0 ? 0 : _unreadNotificationCount;
    var t = (0,i18n/* useTranslation */.$G)().t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var _calendarUrl;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)((_calendarUrl = config/* config.calendarUrl */.v.calendarUrl) !== null && _calendarUrl !== void 0 ? _calendarUrl : "", {
        presentationStyle: "popover"
    }), onCalenderClick = ref1.onClick;
    return {
        home: {
            label: t("home"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Home, {
                color: "inherit"
            }),
            value: "home",
            href: routerPages.GlobalHome
        },
        "campaign-events": {
            label: t("event"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Event, {
                color: "inherit"
            }),
            value: "campaign-events",
            href: generatePath(routerPages.GlobalEvents),
            onClick: handleLoginModal()
        },
        calendar: {
            label: t("calendar"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Calendar, {
                color: "inherit"
            }),
            value: "calendar",
            href: "",
            onClick: onCalenderClick
        },
        notifications: {
            label: t("notification"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "inline-flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        badgeContent: unreadNotificationCount ? "" : undefined,
                        color: "like",
                        sx: {
                            position: "absolute",
                            color: "white",
                            top: 4,
                            right: -2,
                            width: 12,
                            height: 12,
                            "& > span": {
                                fontWeight: "bold",
                                fontSize: 9,
                                minWidth: 12,
                                height: 12,
                                bgcolor: "like.tap"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Notice, {
                        color: "inherit"
                    })
                ]
            }),
            value: "notifications",
            href: routerPages.Notifications,
            onClick: handleLoginModal()
        },
        myProfile: {
            label: t("myProfile"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "inline-flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        badgeContent: hasManagementTask || hasSettingTask ? "" : undefined,
                        color: "like",
                        sx: {
                            position: "absolute",
                            color: "white",
                            top: 4,
                            right: -2,
                            width: 12,
                            height: 12,
                            "& > span": {
                                fontWeight: "bold",
                                fontSize: 9,
                                minWidth: 12,
                                height: 12,
                                bgcolor: "like.tap"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.MyPage, {
                        color: "inherit"
                    })
                ]
            }),
            value: "myProfile",
            href: routerPages.MyProfile,
            onClick: handleLoginModal()
        },
        myCollections: {
            label: t("myCollections"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Collection, {
                color: "inherit"
            }),
            value: "myCollections",
            href: routerPages.GlobalCollections,
            onClick: handleLoginModal()
        },
        artist: {
            label: t("artistSearch"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Search, {
                color: "inherit"
            }),
            value: "artist",
            href: routerPages.GlobalArtist
        },
        events: {
            label: t("event"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.ShokufesEvent, {
                color: "inherit"
            }),
            value: "events",
            href: routerPages.ShokufesEvents
        },
        pickup: {
            label: t("pickup"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.PickUp, {
                color: "inherit"
            }),
            value: "pickup",
            href: routerPages.MyOwnedTicketsEventSelection,
            onClick: handleLoginModal()
        }
    };
};

;// CONCATENATED MODULE: ./src/components/organisms/navigation/GlobalBottomNavigation/GlobalNavigation.tsx








var GlobalBottomNavigation = function(param) {
    var tabKeys = param.tabKeys, hasManagementTask = param.hasManagementTask, hasSettingTask = param.hasSettingTask, unreadNotificationCount = param.unreadNotificationCount, _defaultTab = param.defaultTab, defaultTab = _defaultTab === void 0 ? null : _defaultTab;
    var tabs = useTabList({
        unreadNotificationCount: unreadNotificationCount,
        hasManagementTask: hasManagementTask,
        hasSettingTask: hasSettingTask
    });
    var ref = (0,react.useState)(defaultTab), value = ref[0], setValue = ref[1];
    var router = (0,useRouter/* useRouter */.tv)().router;
    (0,react.useEffect)(function() {
        var ref;
        var index = tabKeys.findIndex(function(key) {
            return router.pathname.includes(tabs[key]["value"]);
        });
        if (index >= 0 && ((ref = tabs[tabKeys[index]]) === null || ref === void 0 ? void 0 : ref.value)) {
            setValue(tabs[tabKeys[index]].value);
            return;
        }
        /**
     * /:tabのURLから初回のtabKeyの値をセットする
     */ setValue(router.query.tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabKeys,
        tabs,
        router.pathname
    ]);
    /**
   * @todo
   * https://app.clickup.com/t/908127/UT-8948
   * お知らせ未読分のバッジ表示データ組み込み
   */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigation/* default */.Z, {
        value: value,
        showLabels: true,
        sx: {
            bgcolor: "grey.50"
        },
        children: tabKeys.map(function(key, i) {
            var _key = tabs[key], icon = _key.icon, content = (0,_object_without_properties/* default */.Z)(_key, [
                "icon"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigationAction/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                icon: icon
            }, content), {
                sx: {
                    maxWidth: 600 / tabKeys.length
                }
            }), i);
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(47746);
// EXTERNAL MODULE: ./src/clients/utoniq-core/state/vars.ts
var vars = __webpack_require__(54040);
// EXTERNAL MODULE: ./src/lib/url/index.ts
var url = __webpack_require__(36604);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(31117);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(81714);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(65992);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(97423);
// EXTERNAL MODULE: ./src/core/auth/index.ts + 4 modules
var auth = __webpack_require__(16083);
;// CONCATENATED MODULE: ./src/components/organisms/navigation/ArtistBottomNavigation/TabList.tsx







var TabList_useTabList = function(param) {
    var avatarUri = param.avatarUri, appLink = param.appLink, isLive = param.isLive, _unreadNotificationCount = param.unreadNotificationCount, unreadNotificationCount = _unreadNotificationCount === void 0 ? 0 : _unreadNotificationCount, _totalUnreadMentionCount = param.totalUnreadMentionCount, totalUnreadMentionCount = _totalUnreadMentionCount === void 0 ? 0 : _totalUnreadMentionCount, _hasManagementTask = param.hasManagementTask, hasManagementTask = _hasManagementTask === void 0 ? false : _hasManagementTask;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98;
    var t = (0,i18n/* useTranslation */.$G)().t;
    var ref99 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref99.user;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref100 = (0,useRouter/* useRouter */.tv)(), routerPages = ref100.routerPages, generatePath = ref100.generatePath, router = ref100.router;
    var artistId = router.query.artistId || config/* config.artistId */.v.artistId;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)(appLink !== null && appLink !== void 0 ? appLink : "", {
        presentationStyle: "popover"
    }).onClick;
    /**
   * @todo
   * https://app.clickup.com/t/908127/UT-8948
   * お知らせ未読分のバッジ表示データ組み込み
   */ var hasNotificationBadge = false;
    var theme = (0,useTheme/* default */.Z)();
    return {
        home: {
            label: (theme === null || theme === void 0 ? void 0 : (ref = theme.palette) === null || ref === void 0 ? void 0 : (ref1 = ref.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.artistNavigation) === null || ref2 === void 0 ? void 0 : ref2.home) ? t("home") : null,
            icon: (theme === null || theme === void 0 ? void 0 : (ref3 = theme.palette) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.custom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.artistNavigation) === null || ref5 === void 0 ? void 0 : ref5.home) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Home, {
                        sx: {
                            color: (theme === null || theme === void 0 ? void 0 : (ref6 = theme.palette) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.custom) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.artistNavigation) === null || ref8 === void 0 ? void 0 : ref8.home) || "inherit"
                        }
                    }),
                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipStyled, {
                        label: "LIVE",
                        sx: {
                            mb: 2
                        }
                    })
                ]
            }) : !avatarUri ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "circular",
                width: 40,
                height: 40
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: avatarUri,
                        sx: {
                            border: function(theme) {
                                var ref, ref1;
                                return isLive ? "1px solid ".concat(theme === null || theme === void 0 ? void 0 : (ref = theme.palette) === null || ref === void 0 ? void 0 : (ref1 = ref.like) === null || ref1 === void 0 ? void 0 : ref1.tap) : "none";
                            }
                        }
                    }),
                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipStyled, {
                        label: "LIVE"
                    })
                ]
            }),
            value: "home",
            href: generatePath(routerPages.ArtistTop, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref9 = theme.palette) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.custom) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.artistNavigation) === null || ref11 === void 0 ? void 0 : ref11.home
        },
        collections: {
            label: t("collection"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Collection, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref12 = theme.palette) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.custom) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.artistNavigation) === null || ref14 === void 0 ? void 0 : ref14.collections) || "inherit"
                }
            }),
            value: "collections",
            href: generatePath(routerPages.ArtistCollections, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref15 = theme.palette) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.custom) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.artistNavigation) === null || ref17 === void 0 ? void 0 : ref17.collections
        },
        myCollections: {
            label: t("collection"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Collection, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref18 = theme.palette) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.custom) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.artistNavigation) === null || ref20 === void 0 ? void 0 : ref20.myCollections) || "inherit"
                }
            }),
            value: "myCollections",
            href: generatePath(routerPages.ArtistMyCollections, {
                artistId: artistId
            }),
            onClick: handleLoginModal(),
            color: theme === null || theme === void 0 ? void 0 : (ref21 = theme.palette) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.custom) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.artistNavigation) === null || ref23 === void 0 ? void 0 : ref23.myCollections
        },
        gachas: {
            label: t("gacha"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Gacha, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref24 = theme.palette) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.custom) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.artistNavigation) === null || ref26 === void 0 ? void 0 : ref26.gachas) || "inherit"
                }
            }),
            value: "gachas",
            href: generatePath(routerPages.ArtistGachaDetailLatest, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref27 = theme.palette) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.custom) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.artistNavigation) === null || ref29 === void 0 ? void 0 : ref29.gachas
        },
        missions: {
            label: t("mission"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Mission, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref30 = theme.palette) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.custom) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.artistNavigation) === null || ref32 === void 0 ? void 0 : ref32.missions) || "inherit"
                }
            }),
            value: "missions",
            href: generatePath(routerPages.ArtistMissions, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref33 = theme.palette) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.custom) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.artistNavigation) === null || ref35 === void 0 ? void 0 : ref35.missions
        },
        trade: {
            label: t("trade"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Market, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref36 = theme.palette) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.custom) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.artistNavigation) === null || ref38 === void 0 ? void 0 : ref38.trade) || "inherit"
                }
            }),
            value: "trade",
            href: generatePath(routerPages.ArtistTrade, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref39 = theme.palette) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.custom) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.artistNavigation) === null || ref41 === void 0 ? void 0 : ref41.trade
        },
        cart: {
            label: t("cart"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Store, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref42 = theme.palette) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.custom) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.artistNavigation) === null || ref44 === void 0 ? void 0 : ref44.cart) || "inherit"
                }
            }),
            value: "cart",
            href: routerPages.StoreCartList,
            // カートには匿名ログイン状態でもアクセスできる
            onClick: function(event) {
                return currentUser ? function() {} : handleLoginModal()(event);
            },
            color: theme === null || theme === void 0 ? void 0 : (ref45 = theme.palette) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.custom) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.artistNavigation) === null || ref47 === void 0 ? void 0 : ref47.cart
        },
        notifications: {
            label: t("notification"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "inline-flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                        badgeContent: hasNotificationBadge && unreadNotificationCount ? "" : undefined,
                        color: "like"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Notice, {
                        sx: {
                            color: (theme === null || theme === void 0 ? void 0 : (ref48 = theme.palette) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.custom) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.artistNavigation) === null || ref50 === void 0 ? void 0 : ref50.notifications) || "inherit"
                        }
                    })
                ]
            }),
            value: "notifications",
            href: routerPages.Notifications,
            onClick: handleLoginModal(),
            color: theme === null || theme === void 0 ? void 0 : (ref51 = theme.palette) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.custom) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.artistNavigation) === null || ref53 === void 0 ? void 0 : ref53.notifications
        },
        myProfile: {
            label: t("myProfile"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "inline-flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                        badgeContent: hasManagementTask ? "" : undefined,
                        color: "like"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.MyPage, {
                        sx: {
                            color: (theme === null || theme === void 0 ? void 0 : (ref54 = theme.palette) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.custom) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.artistNavigation) === null || ref56 === void 0 ? void 0 : ref56.myProfile) || "inherit"
                        }
                    })
                ]
            }),
            value: "myProfile",
            href: routerPages.MyProfile,
            onClick: handleLoginModal(),
            color: theme === null || theme === void 0 ? void 0 : (ref57 = theme.palette) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.custom) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.artistNavigation) === null || ref59 === void 0 ? void 0 : ref59.myProfile
        },
        posts: {
            label: t("post"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Post, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref60 = theme.palette) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.custom) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.artistNavigation) === null || ref62 === void 0 ? void 0 : ref62.posts) || "inherit"
                }
            }),
            value: "posts",
            href: generatePath(routerPages.ArtistPosts, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref63 = theme.palette) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.custom) === null || ref64 === void 0 ? void 0 : (ref65 = ref64.artistNavigation) === null || ref65 === void 0 ? void 0 : ref65.posts
        },
        threads: {
            label: t("community"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "inline-flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                        badgeContent: totalUnreadMentionCount,
                        color: "like",
                        sx: {
                            "& > span": {
                                fontWeight: "bold",
                                fontSize: 9,
                                minWidth: 20,
                                height: 20
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Thread, {
                        sx: {
                            color: (theme === null || theme === void 0 ? void 0 : (ref66 = theme.palette) === null || ref66 === void 0 ? void 0 : (ref67 = ref66.custom) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.artistNavigation) === null || ref68 === void 0 ? void 0 : ref68.threads) || "inherit"
                        }
                    })
                ]
            }),
            value: "threads",
            href: generatePath(routerPages.ArtistThreads, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref69 = theme.palette) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.custom) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.artistNavigation) === null || ref71 === void 0 ? void 0 : ref71.threads
        },
        store: {
            label: t("store"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Artist, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref72 = theme.palette) === null || ref72 === void 0 ? void 0 : (ref73 = ref72.custom) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.artistNavigation) === null || ref74 === void 0 ? void 0 : ref74.store) || "inherit"
                }
            }),
            value: "store",
            href: generatePath(routerPages.ArtistStore, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref75 = theme.palette) === null || ref75 === void 0 ? void 0 : (ref76 = ref75.custom) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.artistNavigation) === null || ref77 === void 0 ? void 0 : ref77.store
        },
        ownedItems: {
            label: t("ownedItems"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.OwnedItems, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref78 = theme.palette) === null || ref78 === void 0 ? void 0 : (ref79 = ref78.custom) === null || ref79 === void 0 ? void 0 : (ref80 = ref79.artistNavigation) === null || ref80 === void 0 ? void 0 : ref80.ownedItems) || "inherit"
                }
            }),
            value: "ownedItems",
            href: generatePath(routerPages.MyOwnedItems),
            onClick: handleLoginModal(),
            color: theme === null || theme === void 0 ? void 0 : (ref81 = theme.palette) === null || ref81 === void 0 ? void 0 : (ref82 = ref81.custom) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.artistNavigation) === null || ref83 === void 0 ? void 0 : ref83.ownedItems
        },
        events: {
            label: t("event"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.ShokufesEvent, {
                sx: {
                    color: (theme === null || theme === void 0 ? void 0 : (ref84 = theme.palette) === null || ref84 === void 0 ? void 0 : (ref85 = ref84.custom) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.artistNavigation) === null || ref86 === void 0 ? void 0 : ref86.events) || "inherit"
                }
            }),
            value: "events",
            href: generatePath(routerPages.ArtistEvents, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref87 = theme.palette) === null || ref87 === void 0 ? void 0 : (ref88 = ref87.custom) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.artistNavigation) === null || ref89 === void 0 ? void 0 : ref89.events
        },
        postVideos: {
            label: t("postVideos"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.AudioPlay, {
                color: "inherit",
                sx: {
                    height: "20px",
                    width: "20px",
                    my: "2px"
                }
            }),
            value: "postVideos",
            href: generatePath(routerPages.ArtistPostVideos, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref90 = theme.palette) === null || ref90 === void 0 ? void 0 : (ref91 = ref90.custom) === null || ref91 === void 0 ? void 0 : (ref92 = ref91.artistNavigation) === null || ref92 === void 0 ? void 0 : ref92.postVideos
        },
        gallery: {
            label: t("gallery"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.Gallery, {
                color: "inherit"
            }),
            value: "gallery",
            href: generatePath(routerPages.ArtistGallery, {
                artistId: artistId
            }),
            color: theme === null || theme === void 0 ? void 0 : (ref93 = theme.palette) === null || ref93 === void 0 ? void 0 : (ref94 = ref93.custom) === null || ref94 === void 0 ? void 0 : (ref95 = ref94.artistNavigation) === null || ref95 === void 0 ? void 0 : ref95.gallery
        },
        artistProfile: {
            label: t("artistProfile"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.Icons.MyPage, {
                color: "inherit"
            }),
            value: "artistProfile",
            onClick: function() {
                return onClick();
            },
            color: theme === null || theme === void 0 ? void 0 : (ref96 = theme.palette) === null || ref96 === void 0 ? void 0 : (ref97 = ref96.custom) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.artistNavigation) === null || ref98 === void 0 ? void 0 : ref98.artistProfile
        }
    };
};
var ChipStyled = (0,styled/* default */.ZP)(Chip/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        color: "white",
        backgroundColor: theme.palette.like.tap,
        position: "absolute",
        bottom: 0,
        height: "auto",
        width: "auto",
        padding: 2,
        borderRadius: 2,
        left: "50%",
        transform: "translateX(-50%)",
        "& .MuiChip-label": {
            paddingLeft: 4,
            paddingRight: 4
        }
    };
});
var StyledBadge = (0,styled/* default */.ZP)(Badge/* default */.Z)(function() {
    return {
        position: "absolute",
        color: "white",
        top: 4,
        right: -2,
        width: 12,
        height: 12,
        "& > span": {
            fontWeight: "bold",
            fontSize: 9,
            minWidth: 12,
            height: 12
        }
    };
});

;// CONCATENATED MODULE: ./src/components/organisms/navigation/ArtistBottomNavigation/ArtistNavigation.tsx











var ArtistBottomNavigation = function(param) {
    var tabKeys = param.tabKeys, isLive = param.isLive, hasManagementTask = param.hasManagementTask, _defaultTab = param.defaultTab, defaultTab = _defaultTab === void 0 ? null : _defaultTab, unreadNotificationCount = param.unreadNotificationCount;
    var ref, ref1;
    var router = (0,useRouter/* useRouter */.tv)().router;
    var ref2 = (0,react.useState)(defaultTab), currentTab = ref2[0], setCurrentTab = ref2[1];
    var artist = (0,vars/* useCurrentArtistState */.Zk)();
    var artistAppLink = (ref = (0,url/* getArtistAppLink */.Kh)(artist === null || artist === void 0 ? void 0 : artist.appLinks, "bottomTab:profile")) === null || ref === void 0 ? void 0 : ref.link;
    var theme = (0,useTheme/* default */.Z)();
    var ref3;
    /**
   * @description
   * Open when function is implemented in the future
   * https://app.clickup.com/t/908127/UT-6887
   */ var tabs = TabList_useTabList({
        avatarUri: (artist === null || artist === void 0 ? void 0 : (ref1 = artist.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || undefined,
        appLink: artistAppLink,
        isLive: isLive,
        hasManagementTask: hasManagementTask,
        unreadNotificationCount: unreadNotificationCount,
        totalUnreadMentionCount: (ref3 = artist === null || artist === void 0 ? void 0 : artist.totalUnreadMentionCount) !== null && ref3 !== void 0 ? ref3 : 0
    });
    (0,react.useEffect)(function() {
        /**
     * /artists/:artistId/:tabKeyのURLからtabKeyの値をvセットする
     * /:tabKeyのURLからtabKeyの値をvセットする
     */ var index = config/* config.applicationType */.v.applicationType === "standalone" ? 0 : 2;
        var path = router.pathname.split("/").filter(Boolean)[index];
        setCurrentTab(path);
    }, [
        router.pathname
    ]);
    var filteredTabKeys = tabKeys.filter(function(tab) {
        if (tab !== "artistProfile") return true;
        return !!artistAppLink;
    });
    var _color, _color1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomNavigation/* default */.Z, {
        id: "artist-bottom-navigation",
        className: "artist-bottom-navigation",
        value: currentTab,
        showLabels: true,
        sx: {
            bgcolor: "grey.50"
        },
        children: filteredTabKeys.map(function(key) {
            return /*#__PURE__*/ (0,react.createElement)(BottomNavigationAction/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabs[key]), {
                key: key,
                sx: {
                    opacity: key === "home" && currentTab !== "home" ? 0.4 : 1,
                    maxWidth: 600 / filteredTabKeys.length,
                    ".MuiBottomNavigationAction-label": {
                        // fontFamily:
                        //   theme.mixins.artistNavigation?.fontFamily ?? undefined,
                        color: (_color = tabs[key].color) !== null && _color !== void 0 ? _color : undefined
                    },
                    "&.Mui-selected .MuiBottomNavigationAction-label": {
                        // fontFamily:
                        //   theme.mixins.artistNavigation?.fontFamily ?? undefined,
                        color: (_color1 = tabs[key].color) !== null && _color1 !== void 0 ? _color1 : undefined
                    }
                }
            }));
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/reply/ReplyForm/index.tsx
var ReplyForm = __webpack_require__(44545);
// EXTERNAL MODULE: ./src/components/pages/ThreadCreate/template/index.tsx + 2 modules
var template = __webpack_require__(32988);
// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/components/styles/ArtistThemeProvider.tsx
var ArtistThemeProvider = __webpack_require__(58015);
// EXTERNAL MODULE: ./src/lib/safeAreaView/index.tsx
var safeAreaView = __webpack_require__(35288);
// EXTERNAL MODULE: ./src/components/layouts/ConsoleFooter.tsx
var ConsoleFooter = __webpack_require__(37034);
// EXTERNAL MODULE: ./src/components/layouts/Header.tsx
var Header = __webpack_require__(92016);
;// CONCATENATED MODULE: ./src/components/layouts/BaseLayout.tsx




















var BaseLayout = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, header = param.header, margin = param.margin, sx = param.sx, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, _showScrollBar = param.showScrollBar, showScrollBar = _showScrollBar === void 0 ? false : _showScrollBar, navigation = param.navigation, customNavigation = param.customNavigation, customNavigationSx = param.customNavigationSx, safeArea = param.safeArea, black = param.black, hasConsoleFooter = param.hasConsoleFooter, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? 600 : _maxWidth;
    var isNative = dist/* Capacitor.isNativePlatform */.dV.isNativePlatform();
    var isNativeIOS = isNative && lib/* isIOS */.gn;
    var _$ref = (0,useRouter/* useRouter */.tv)(), pathname = _$ref.router.pathname;
    (0,safeAreaView/* useSafeAreaSetting */.nH)(function(prevState) {
        return merge_default()(prevState, pathname.includes("console") ? safeAreaView/* CONSOLE_HEADER */.O8 : {});
    });
    var _$ref1 = (0,_sliced_to_array/* default */.Z)((0,ArtistThemeProvider/* useArtistThemeContext */.ff)(), 1), bgImage = _$ref1[0].bgImage;
    var _$ref2 = (0,react.useState)({}), bgStyle = _$ref2[0], setBgStyle = _$ref2[1];
    var _$ref3 = (0,react.useState)(0), bottomMargin = _$ref3[0], setBottomMarginHeight = _$ref3[1];
    var router = (0,useRouter/* useRouter */.tv)().router;
    var contentRef = (0,react.useRef)(null);
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    // 余白の大きさを決定する
    (0,react.useEffect)(function() {
        if (!navigation && !customNavigation && !hasConsoleFooter || !contentRef.current) {
            setBottomMarginHeight(0);
            return;
        }
        var footerElm = contentRef.current.nextSibling;
        var _$ref;
        var footerHeight = (_$ref = footerElm === null || footerElm === void 0 ? void 0 : footerElm.offsetHeight) !== null && _$ref !== void 0 ? _$ref : 0;
        var _scrollHeight;
        var scrollHeight = (_scrollHeight = contentRef.current.scrollHeight) !== null && _scrollHeight !== void 0 ? _scrollHeight : 0;
        if (!(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("bottomNavigation")) && !(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("customBottomNavigation")) && !(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("consoleFooter")) || (scrollHeight !== null && scrollHeight !== void 0 ? scrollHeight : 0) <= windowHeight - footerHeight) {
            setBottomMarginHeight(0);
        } else {
            var _$ref1;
            setBottomMarginHeight((_$ref1 = footerElm === null || footerElm === void 0 ? void 0 : footerElm.offsetHeight) !== null && _$ref1 !== void 0 ? _$ref1 : 0);
        }
    }, [
        navigation,
        customNavigation,
        contentRef.current
    ]);
    // アーティストの背景色、またはsvgを設定する
    (0,react.useEffect)(function() {
        setBgStyle((0,_define_property/* default */.Z)({}, isNativeIOS ? ".artist-theme-provider & .BgImage" : ".artist-theme-provider &", {
            backgroundImage: bgImage ? "url(".concat(bgImage, ")") : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
            bgcolor: bgImage ? undefined : black ? "#222" : "background.default",
            height: "100%"
        }));
    }, [
        bgImage,
        router.pathname,
        black
    ]);
    var _$ref4, _$ref5, _$ref6, _$ref7, _$ref8, _$ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: "BaseLayout ".concat(pathname.includes("console") ? "Console" : ""),
            ref: ref,
            sx: (0,_object_spread/* default */.Z)({
                position: "relative",
                zIndex: 1,
                width: responsive ? undefined : "100%",
                pt: (_$ref4 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pt) !== null && _$ref4 !== void 0 ? _$ref4 : styles/* styles.safeAreaTop */.W2.safeAreaTop,
                pb: (_$ref5 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pb) !== null && _$ref5 !== void 0 ? _$ref5 : styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                minHeight: "calc(100dvh - ".concat((_$ref6 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pt) !== null && _$ref6 !== void 0 ? _$ref6 : styles/* styles.safeAreaTop */.W2.safeAreaTop, "px - ").concat((_$ref7 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pb) !== null && _$ref7 !== void 0 ? _$ref7 : styles/* styles.safeAreaBottom */.W2.safeAreaBottom, " - ").concat(bottomMargin, "px - ").concat(header ? "56px" : "0px", ")"),
                overflowX: isNativeIOS ? undefined : "hidden",
                height: isNativeIOS ? "100%" : undefined
            }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar(), bgStyle, sx),
            children: [
                header && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, header), {
                    color: pathname.includes("console") ? "white" : header.color,
                    bgcolor: pathname.includes("console") ? "primary.main" : header.color,
                    position: "fixed"
                })),
                !!bgImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "BgImage",
                    sx: {
                        position: "fixed",
                        inset: 0,
                        zIndex: -1,
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                left: 0,
                                top: 0,
                                bgcolor: "background.default",
                                width: "calc((100% - ".concat(maxWidth, "px) / 2)"),
                                height: "100%",
                                pointerEvents: "none",
                                zIndex: -1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                right: 0,
                                top: 0,
                                bgcolor: "background.default",
                                width: "calc((100% - ".concat(maxWidth, "px) / 2)"),
                                height: "100%",
                                pointerEvents: "none",
                                zIndex: -1
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "BaseLayoutContent",
                    ref: contentRef,
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, showScrollBar ? {} : styles/* styleSets.hideScrollbar */.k$.hideScrollbar()), {
                        maxWidth: responsive ? "100%" : maxWidth,
                        margin: "0 auto",
                        width: "100%",
                        height: "100%",
                        px: margin === true ? 5 : +(margin !== null && margin !== void 0 ? margin : 0),
                        bgcolor: black ? "#222" : "transparent",
                        pt: header ? "56px" : 0,
                        minHeight: bgImage ? "calc(100dvh - ".concat((_$ref8 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pt) !== null && _$ref8 !== void 0 ? _$ref8 : styles/* styles.safeAreaTop */.W2.safeAreaTop, " - ").concat((_$ref9 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pb) !== null && _$ref9 !== void 0 ? _$ref9 : styles/* styles.safeAreaBottom */.W2.safeAreaBottom, " - ").concat(bottomMargin, "px - ").concat(header ? "56px" : 0, ")") : "auto",
                        "&:focus": {
                            border: "none",
                            outline: "none"
                        }
                    }),
                    children: [
                        children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: "bottomMargin",
                            sx: {
                                height: bottomMargin !== null && bottomMargin !== void 0 ? bottomMargin : 0,
                                width: "100%"
                            }
                        })
                    ]
                }),
                !!navigation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "bottomNavigation",
                    sx: {
                        position: "fixed",
                        insetX: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        margin: "0 auto",
                        width: "100%",
                        zIndex: 10,
                        bgcolor: "grey.50",
                        pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                        maxWidth: navigation.responsive ? "100%" : maxWidth
                    },
                    children: [
                        navigation.type === "global" && /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalBottomNavigation, (0,_object_spread/* default */.Z)({
                            tabKeys: config/* config.globalTabs */.v.globalTabs
                        }, navigation.props)),
                        navigation.type === "artist" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistBottomNavigation, (0,_object_spread/* default */.Z)({
                            tabKeys: config/* config.artistTabs */.v.artistTabs
                        }, navigation.props)),
                        navigation.type === "replyForm" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyForm/* ReplyForm */.I, (0,_object_spread/* default */.Z)({
                            maxWidth: maxWidth
                        }, navigation.props)),
                        navigation.type === "threadForm" && /*#__PURE__*/ (0,jsx_runtime.jsx)(template/* ActionLinkCell */.DS, (0,_object_spread/* default */.Z)({}, navigation.props))
                    ]
                }),
                !!customNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "customBottomNavigation",
                    sx: (0,_object_spread/* default */.Z)({
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: "100%",
                        zIndex: 10,
                        maxWidth: responsive ? "100%" : maxWidth,
                        margin: "0 auto",
                        bgcolor: "grey.50",
                        pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                    }, customNavigationSx),
                    children: customNavigation
                }),
                hasConsoleFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: "consoleFooter",
                    sx: {
                        position: "fixed",
                        insetX: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        margin: "0 auto",
                        width: "100%",
                        zIndex: 10,
                        bgcolor: "background.default",
                        maxWidth: responsive ? "100%" : maxWidth
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFooter/* default */.Z, {})
                })
            ]
        })
    });
});


/***/ }),

/***/ 68074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ BottomSafeArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12363);
/* harmony import */ var _lib_safeAreaView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35288);




/**
 *
 * @description settings bottom safe area view
 *
 * @param children
 * @param defaultProps
 * @param props
 * @constructor
 *
 * @example
 *
 * <BottomSafeArea>
 *   ...
 * </BottomSafeArea>
 */ var BottomSafeArea = function(_param) {
    var children = _param.children, defaultProps = _param.defaultProps, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "defaultProps"
    ]);
    (0,_lib_safeAreaView__WEBPACK_IMPORTED_MODULE_2__/* .useSafeAreaFooterSetting */ .Xg)(props, defaultProps);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: children
    });
};


/***/ }),

/***/ 91456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ConsoleBaseLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@capacitor/core/dist/index.js
var dist = __webpack_require__(23807);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(12363);
// EXTERNAL MODULE: ../../node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(16305);
// EXTERNAL MODULE: ../../node_modules/lodash/merge.js
var merge = __webpack_require__(98537);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(66582);
// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(45269);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/lib/safeAreaView/index.tsx
var safeAreaView = __webpack_require__(35288);
// EXTERNAL MODULE: ./src/components/styles/themes/defaultTheme.ts
var defaultTheme = __webpack_require__(44315);
// EXTERNAL MODULE: ./src/components/layouts/ArtistSideMenu/index.tsx + 1 modules
var ArtistSideMenu = __webpack_require__(43815);
// EXTERNAL MODULE: ./src/components/layouts/ConsoleFooter.tsx
var ConsoleFooter = __webpack_require__(37034);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/material/AppBar/AppBar.js
var AppBar = __webpack_require__(13961);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(26482);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var utoniq_ui_dist = __webpack_require__(63588);
;// CONCATENATED MODULE: ./src/components/layouts/ConsoleHeader.tsx













var ConsoleHeader = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _back = _param.back, back = _back === void 0 ? false : _back, defaultBackPage = _param.defaultBackPage, type = _param.type, left = _param.left, title = _param.title, leftTitle = _param.leftTitle, color = _param.color, right = _param.right, _position = _param.position, position = _position === void 0 ? "fixed" : _position, bgcolor = _param.bgcolor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "back",
        "defaultBackPage",
        "type",
        "left",
        "title",
        "leftTitle",
        "color",
        "right",
        "position",
        "bgcolor"
    ]);
    var router = (0,useRouter/* useRouter */.tv)().router;
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var desktopSideMenuWidth = constants/* constants.ui.layout.desktopSideMenuWidth */._.ui.layout.desktopSideMenuWidth;
    var _$ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: position
    }, props), {
        sx: (0,_object_spread/* default */.Z)({
            width: {
                xs: "100%",
                // PC 表示の場合はサイドメニューの幅分幅を小さくする
                md: "calc(100% - ".concat(desktopSideMenuWidth, "px)")
            },
            minWidth: 0,
            margin: "0 auto",
            pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
            left: {
                xs: 0,
                // PC 表示の場合はサイドメニューの幅分左に間隔をとる
                md: "".concat(desktopSideMenuWidth, "px")
            },
            boxShadow: 0,
            backgroundColor: bgcolor || "background.default",
            // override property backgroundImage of Material-ui to display as designed
            backgroundImage: "none",
            zIndex: 10
        }, props.sx || {}),
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            disableGutters: true,
            sx: function(theme) {
                var _$ref1, _$ref2;
                return (0,_define_property/* default */.Z)({
                    margin: "0 auto",
                    width: {
                        xs: "calc(100% - 40px)",
                        lg: width - desktopSideMenuWidth - 40
                    },
                    maxWidth: {
                        lg: (_$ref = (_$ref1 = defaultTheme/* defaultTheme.breakpoints */.u.breakpoints) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.values) === null || _$ref2 === void 0 ? void 0 : _$ref2.lg) !== null && _$ref !== void 0 ? _$ref : 1440
                    },
                    color: "text.primary",
                    minHeight: 56
                }, theme.breakpoints.up("sm"), {
                    minHeight: 56
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    flex: 1,
                    direction: "row",
                    justifyContent: "flex-start",
                    children: [
                        back && (type === "modal" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.IconButton.Close, {
                            onClick: function() {
                                return router === null || router === void 0 ? void 0 : router.goBack(defaultBackPage);
                            },
                            size: "medium",
                            sx: {
                                ml: "-8px"
                            },
                            color: color,
                            bgcolor: "transparent"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(utoniq_ui_dist.IconButton.Back, {
                            onClick: function() {
                                return router === null || router === void 0 ? void 0 : router.goBack(defaultBackPage);
                            },
                            size: "medium",
                            color: color,
                            bgcolor: "transparent",
                            sx: {
                                ml: "-8px"
                            }
                        })),
                        left
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    flex: 6,
                    sx: {
                        minWidth: 0
                    },
                    children: typeof title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h5",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                        align: leftTitle ? "left" : "center",
                        color: color ? "white" : "text.primary",
                        children: title
                    }) : title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    flex: 1,
                    direction: "row",
                    justifyContent: "flex-end",
                    children: right
                })
            ]
        })
    }));
});

;// CONCATENATED MODULE: ./src/components/layouts/ConsoleBaseLayout/index.tsx


















var ConsoleBaseLayout = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, header = param.header, margin = param.margin, sx = param.sx, _showScrollBar = param.showScrollBar, showScrollBar = _showScrollBar === void 0 ? false : _showScrollBar, customNavigation = param.customNavigation, customNavigationSx = param.customNavigationSx, safeArea = param.safeArea, black = param.black, hasConsoleFooter = param.hasConsoleFooter, _fullWidth = param.// 全コンソール画面のレスポンシブ対応が完了したら
    // 1. ConsoleBaseLayout から fullWidth そのものを削除
    // 2. ConsoleBaseLayout 内の CSS 条件分岐を削除
    // という対応を行う
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var _$ref, _$ref1;
    var isNative = dist/* Capacitor.isNativePlatform */.dV.isNativePlatform();
    var isNativeIOS = isNative && lib/* isIOS */.gn;
    var _$ref2 = (0,useRouter/* useRouter */.tv)(), pathname = _$ref2.router.pathname;
    (0,safeAreaView/* useSafeAreaSetting */.nH)(function(prevState) {
        return merge_default()(prevState, safeAreaView/* CONSOLE_HEADER */.O8);
    });
    var _$ref3 = (0,react.useState)({}), bgStyle = _$ref3[0], setBgStyle = _$ref3[1];
    var _$ref4 = (0,react.useState)(0), bottomMargin = _$ref4[0], setBottomMarginHeight = _$ref4[1];
    var router = (0,useRouter/* useRouter */.tv)().router;
    var contentRef = (0,react.useRef)();
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    // 余白の大きさを決定する
    (0,react.useEffect)(function() {
        if (!customNavigation && !hasConsoleFooter || !contentRef.current) {
            setBottomMarginHeight(0);
            return;
        }
        var footerElm = contentRef.current.nextSibling;
        var _$ref;
        var footerHeight = (_$ref = footerElm === null || footerElm === void 0 ? void 0 : footerElm.offsetHeight) !== null && _$ref !== void 0 ? _$ref : 0;
        var _scrollHeight;
        var scrollHeight = (_scrollHeight = contentRef.current.scrollHeight) !== null && _scrollHeight !== void 0 ? _scrollHeight : 0;
        if (!(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("bottomNavigation")) && !(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("customBottomNavigation")) && !(footerElm === null || footerElm === void 0 ? void 0 : footerElm.classList.contains("consoleFooter")) || (scrollHeight !== null && scrollHeight !== void 0 ? scrollHeight : 0) <= windowHeight - footerHeight) {
            setBottomMarginHeight(0);
        } else {
            var _$ref1;
            setBottomMarginHeight((_$ref1 = footerElm === null || footerElm === void 0 ? void 0 : footerElm.offsetHeight) !== null && _$ref1 !== void 0 ? _$ref1 : 0);
        }
    }, [
        customNavigation,
        contentRef.current
    ]);
    // アーティストの背景色、またはsvgを設定する
    (0,react.useEffect)(function() {
        setBgStyle((0,_define_property/* default */.Z)({}, isNativeIOS ? ".artist-theme-provider & .BgImage" : ".artist-theme-provider &", {
            bgcolor: black ? "#222" : "background.default"
        }));
    }, [
        router.pathname,
        black
    ]);
    var desktopSideMenuWidth = constants/* constants.ui.layout.desktopSideMenuWidth */._.ui.layout.desktopSideMenuWidth;
    var width = (0,dist_module/* useWindowWidth */.Lm)();
    var _$ref5, _$ref6, _$ref7, _$ref8, _$ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistSideMenu/* ArtistSideMenuForPC */.i, {
                onClose: function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ref: ref,
                className: "BaseLayout Console",
                sx: (0,_object_spread/* default */.Z)({
                    position: "relative",
                    zIndex: 1,
                    pt: (_$ref5 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pt) !== null && _$ref5 !== void 0 ? _$ref5 : styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    pb: (_$ref6 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pb) !== null && _$ref6 !== void 0 ? _$ref6 : styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                    minHeight: "calc(100dvh - ".concat((_$ref7 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pt) !== null && _$ref7 !== void 0 ? _$ref7 : styles/* styles.safeAreaTop */.W2.safeAreaTop, "px - ").concat((_$ref8 = safeArea === null || safeArea === void 0 ? void 0 : safeArea.pb) !== null && _$ref8 !== void 0 ? _$ref8 : styles/* styles.safeAreaBottom */.W2.safeAreaBottom, " - ").concat(bottomMargin, "px - ").concat(header ? "56px" : "0px", ")"),
                    overflowX: isNativeIOS ? undefined : "hidden",
                    height: "100%",
                    width: {
                        md: "calc(100% - ".concat(desktopSideMenuWidth, "px)")
                    },
                    ml: {
                        md: "".concat(desktopSideMenuWidth, "px")
                    }
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar(), bgStyle, sx),
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, header), {
                        color: "white",
                        bgcolor: "primary.main",
                        position: "fixed"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: "BaseLayoutContent",
                        ref: contentRef,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, showScrollBar ? {} : styles/* styleSets.hideScrollbar */.k$.hideScrollbar()), {
                            // レスポンシブ対応が済んでいない場合は最大幅 600px に限定する
                            // 全コンソール画面のレスポンシブ対応が完了したら条件分岐を削除し
                            // maxWidth: { lg: defaultTheme.breakpoints?.values?.lg ?? 1440 }
                            // という指定に変える
                            maxWidth: fullWidth ? {
                                lg: (_$ref9 = (_$ref = defaultTheme/* defaultTheme.breakpoints */.u.breakpoints) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.values) === null || _$ref1 === void 0 ? void 0 : _$ref1.lg) !== null && _$ref9 !== void 0 ? _$ref9 : 1440
                            } : 600,
                            margin: "0 auto",
                            width: {
                                sx: "100%",
                                md: width - desktopSideMenuWidth
                            },
                            height: "100%",
                            px: margin === true ? 5 : +(margin !== null && margin !== void 0 ? margin : 0),
                            bgcolor: black ? "#222" : "transparent",
                            pt: header ? "56px" : 0,
                            minHeight: "auto",
                            "&:focus": {
                                border: "none",
                                outline: "none"
                            }
                        }),
                        children: [
                            children,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "bottomMargin",
                                sx: {
                                    height: bottomMargin !== null && bottomMargin !== void 0 ? bottomMargin : 0,
                                    width: "100%"
                                }
                            })
                        ]
                    }),
                    !!customNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "customBottomNavigation",
                        sx: (0,_object_spread/* default */.Z)({
                            position: "fixed",
                            bottom: 0,
                            left: {
                                xs: 0,
                                // PC 表示の場合はサイドメニューの幅分左に間隔をとる
                                md: "".concat(desktopSideMenuWidth, "px")
                            },
                            right: 0,
                            width: {
                                xs: "100%",
                                // PC 表示の場合はサイドメニューの幅分幅を小さくする
                                md: "calc(100% - ".concat(desktopSideMenuWidth, "px)")
                            },
                            zIndex: 10,
                            margin: "0 auto",
                            bgcolor: "grey.50",
                            pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                        }, customNavigationSx),
                        children: customNavigation
                    }),
                    hasConsoleFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "consoleFooter",
                        sx: {
                            position: "fixed",
                            insetX: 0,
                            bottom: 0,
                            right: 0,
                            left: {
                                xs: 0,
                                // PC 表示の場合はサイドメニューの幅分左に間隔をとる
                                md: "".concat(desktopSideMenuWidth, "px")
                            },
                            margin: "0 auto",
                            width: {
                                xs: "100%",
                                // PC 表示の場合はサイドメニューの幅分幅を小さくする
                                md: "calc(100% - ".concat(desktopSideMenuWidth, "px)")
                            },
                            zIndex: 10,
                            bgcolor: "background.default"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFooter/* default */.Z, {})
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 37034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65992);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);
/* harmony import */ var _lib_safeAreaView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35288);





var ConsoleFooter = function() {
    (0,_lib_safeAreaView__WEBPACK_IMPORTED_MODULE_1__/* .useSafeAreaFooterSetting */ .Xg)({
        safeArea: true
    });
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            bgcolor: "grey.50",
            pt: 6,
            pb: function(theme) {
                return "calc(".concat(theme.spacing(6), " + ").concat(_components_styles__WEBPACK_IMPORTED_MODULE_4__/* .styles.safeAreaBottom */ .W2.safeAreaBottom, ")");
            }
        },
        spacing: 3,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                spacing: 5,
                sx: {
                    maxWidth: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalLink, {
                        href: "https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            color: "text.secondary",
                            variant: "subtitle1",
                            children: t("termsOfService")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalLink, {
                        href: "https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            color: "text.secondary",
                            variant: "subtitle1",
                            children: t("privacyPolicy")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExternalLink, {
                        href: "https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            color: "text.secondary",
                            variant: "subtitle1",
                            children: t("companyProfile")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                variant: "overline",
                color: "text.secondary",
                children: "\xa9 2021 Utoniq,Inc."
            })
        ]
    });
};
var ExternalLink = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)("a")(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.text.primary,
        textDecoration: "none"
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (ConsoleFooter);


/***/ }),

/***/ 67983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ContentFrame; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12363);





/**
 * @description
 * コンテンツの表示領域を上限付きで画面横幅に合わせる
 * 上限を超過した場合は上限値に合わせて画面中央にコンテンツを配置する
 * 背景は画面横幅または親要素横幅に合わせたいが、中のコンテンツの表示横幅のみ制限したい場合に使用する
 *
 * @param children： コンテンツ
 * @param contentWidth：コンテンツの表示領域の上限横幅
 * @param props：BoxProps
 */ var ContentFrame = function(_param) {
    var children = _param.children, _contentWidth = _param.contentWidth, contentWidth = _contentWidth === void 0 ? "1120px" : _contentWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "contentWidth"
    ]);
    var sx = props.sx, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, [
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: "100%",
            maxWidth: contentWidth,
            mx: "auto"
        }, sx),
        children: children
    }));
};


/***/ }),

/***/ 15512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);




var Head = function(param) {
    var title = param.title, description = param.description, ogImage = param.ogImage, children = param.children;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var commonTitle = t("metaTitle");
    var titleValue = title ? "".concat(Array.isArray(title) ? title.filter(function(_) {
        return _;
    }).join(" | ") : title, " | ").concat(commonTitle) : commonTitle;
    var descriptionValue = description !== null && description !== void 0 ? description : t("metaDescription");
    /**
   * @todo
   * itemDetailとcollectionDetailはOGP画像を動的生成する。API実装後対応する
   * https://app.clickup.com/t/908127/UT-5146
   */ var ogImageValue = ogImage !== null && ogImage !== void 0 ? ogImage : _config__WEBPACK_IMPORTED_MODULE_3__/* .config.meta.ogImage */ .v.meta.ogImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: titleValue
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: titleValue,
                property: "og:title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: descriptionValue,
                name: "description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: descriptionValue,
                property: "og:description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: descriptionValue,
                name: "twitter:description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: ogImageValue,
                property: "og:image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: ogImageValue,
                name: "twitter:image"
            }),
            children
        ]
    });
};


/***/ }),

/***/ 92016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13961);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26482);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61631);










var Header = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var _back = _param.back, back = _back === void 0 ? false : _back, defaultBackPage = _param.defaultBackPage, type = _param.type, left = _param.left, title = _param.title, leftTitle = _param.leftTitle, color = _param.color, right = _param.right, _position = _param.position, position = _position === void 0 ? "fixed" : _position, bgcolor = _param.bgcolor, _responsive = _param.responsive, responsive = _responsive === void 0 ? false : _responsive, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? 600 : _maxWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "back",
        "defaultBackPage",
        "type",
        "left",
        "title",
        "leftTitle",
        "color",
        "right",
        "position",
        "bgcolor",
        "responsive",
        "maxWidth"
    ]);
    var router = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useRouter */ .tv)().router;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        position: position
    }, props), {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            width: "100%",
            maxWidth: responsive ? "100%" : maxWidth,
            minWidth: 0,
            margin: "0 auto",
            pt: _components_styles__WEBPACK_IMPORTED_MODULE_8__/* .styles.safeAreaTop */ .W2.safeAreaTop,
            left: 0,
            boxShadow: 0,
            backgroundColor: bgcolor || "background.default",
            // override property backgroundImage of Material-ui to display as designed
            backgroundImage: "none",
            zIndex: 10
        }, props.sx || {}),
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            disableGutters: true,
            sx: function(theme) {
                return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    margin: "0 auto",
                    maxWidth: responsive ? maxWidth ? "".concat(maxWidth - 40, "px") : "100%" : undefined,
                    width: "calc(100% - 40px)",
                    mx: responsive ? undefined : 5,
                    color: "text.primary",
                    minHeight: 56
                }, theme.breakpoints.up("sm"), {
                    minHeight: 56
                });
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    flex: 1,
                    direction: "row",
                    justifyContent: "flex-start",
                    children: [
                        back && (type === "modal" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Close, {
                            onClick: function() {
                                return router === null || router === void 0 ? void 0 : router.goBack(defaultBackPage);
                            },
                            size: "medium",
                            sx: {
                                ml: "-8px"
                            },
                            color: color,
                            bgcolor: "transparent"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Back, {
                            onClick: function() {
                                return router === null || router === void 0 ? void 0 : router.goBack(defaultBackPage);
                            },
                            size: "medium",
                            color: color,
                            bgcolor: "transparent",
                            sx: {
                                ml: "-8px"
                            }
                        })),
                        left
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    flex: 6,
                    sx: {
                        minWidth: 0
                    },
                    children: typeof title === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "h5",
                        sx: _components_styles__WEBPACK_IMPORTED_MODULE_8__/* .styleSets.lineCamp */ .k$.lineCamp(1),
                        align: leftTitle ? "left" : "center",
                        color: color ? "white" : "text.primary",
                        children: title
                    }) : title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    flex: 1,
                    direction: "row",
                    justifyContent: "flex-end",
                    children: right
                })
            ]
        })
    }));
});


/***/ }),

/***/ 3405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ BrowserLink; },
/* harmony export */   "i": function() { return /* binding */ useBrowserLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _capacitor_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18260);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);










/**
 *
 * @param link
 * @param options
 */ var useBrowserLink = function(link, options) {
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _capacitor_browser__WEBPACK_IMPORTED_MODULE_1__/* .Browser.open */ .A.open((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            url: link
                        }, options))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        link,
        options
    ]);
    return {
        onClick: onClick
    };
};
/**
 * Open external link inside app via Browser
 * @param href
 * @param children
 * @param props
 * @constructor
 */ var BrowserLink = function(_param) {
    var href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "href",
        "children"
    ]);
    var onClick = useBrowserLink(href).onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        onClick: onClick,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            color: "primary.main",
            cursor: "pointer"
        }, props.sx),
        children: children
    }));
};


/***/ }),

/***/ 33684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BottomSheet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _ionic_react_css_core_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91760);
/* harmony import */ var _ionic_react_css_core_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ionic_react_css_core_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _capacitor_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23807);
/* harmony import */ var _ionic_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47746);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16445);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66582);







var BottomSheet = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.forwardRef)(function(param, ref) {
    var open = param.open, onClose = param.onClose, animated = param.animated, breakpoints = param.breakpoints, initialBreakpoint = param.initialBreakpoint, handle = param.handle, _backdropDismiss = param.backdropDismiss, backdropDismiss = _backdropDismiss === void 0 ? true : _backdropDismiss, swipeToClose = param.swipeToClose, canDismiss = param.canDismiss, children = param.children, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var _$ref, _$ref1, _$ref2, _$ref3;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var isNative = _capacitor_core__WEBPACK_IMPORTED_MODULE_2__/* .Capacitor.isNativePlatform */ .dV.isNativePlatform();
    var styles = {
        "ion-content": {
            "--overflow": "scroll",
            "--background": responsive ? (_$ref = theme.palette) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.background) === null || _$ref1 === void 0 ? void 0 : _$ref1.default : undefined
        },
        "ion-content::part(scroll)": {
            backgroundColor: (_$ref2 = theme.palette) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.background) === null || _$ref3 === void 0 ? void 0 : _$ref3.default,
            width: responsive ? "100%" : undefined,
            margin: responsive ? "0 auto" : undefined
        },
        "ion-modal::part(content)": {
            maxWidth: responsive ? "100%" : 600
        },
        "ion-modal.parent-modal::part(content)": {
            // IonModalの背景を広げる
            // IonModalから更にダイアログ等を出した時に子の背景も広がってしまうため、第一階層のIonModalにのみ限定する
            width: responsive ? "100%" : undefined
        },
        "ion-modal": {
            position: "fixed"
        },
        /**
       * @hack
       * 見た目はそのまま
       * アクションシートのスワイプ可能領域サイズを大きくする
       */ "::part(handle)": {
            opacity: handle ? "1" : 0,
            backgroundColor: "initial",
            // content（背景）の幅を広げるとhandleの領域も広くなりクローズボタンの操作を阻害するためmaxWidthは600px基準とする
            maxWidth: responsive ? "calc(600px - 92px)" : undefined,
            width: "calc(100% - 92px)",
            marginTop: 8,
            height: 30,
            outline: 0,
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            "&::before": {
                background: "var(--ion-color-step-350, #d0d0ce)",
                borderRadius: 8,
                height: 0,
                padding: "2.7px 3.3px"
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!document) return;
        if (open) {
            document.body.style.overflowY = "hidden";
            return;
        }
        if (react_device_detect__WEBPACK_IMPORTED_MODULE_5__/* .isIOS */ .gn && isNative) {
            document.body.style.overflowY = "unset";
            return;
        }
        document.body.style.overflowY = "auto";
        return function() {
            document.body.style.overflowY = "auto";
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                styles: styles
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ionic_react__WEBPACK_IMPORTED_MODULE_3__/* .IonModal */ .ki, {
                className: "parent-modal",
                ref: ref,
                isOpen: open,
                mode: "ios",
                animated: animated,
                onDidDismiss: onClose,
                breakpoints: breakpoints,
                initialBreakpoint: initialBreakpoint,
                handle: handle,
                swipeToClose: swipeToClose,
                canDismiss: canDismiss,
                backdropDismiss: backdropDismiss,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ionic_react__WEBPACK_IMPORTED_MODULE_3__/* .IonContent */ .W2, {
                    children: children
                })
            })
        ]
    });
});


/***/ }),

/***/ 14971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ThreadCategory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97423);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);





var ThreadCategory = function(param) {
    var isOfficial = param.isOfficial, category = param.category, sx = param.sx;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("artistThreads").t;
    var label = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (isOfficial) {
            return t("officialCommunity");
        }
        return t([
            "category_".concat(category),
            category
        ]);
    }, [
        isOfficial,
        t,
        category
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (isOfficial) {
            return {
                bgcolor: "secondary.dark",
                color: "white"
            };
        }
        return {
            bgcolor: "grey.100",
            color: "text.secondary"
        };
    }, [
        isOfficial
    ]), color = ref.color, bgcolor = ref.bgcolor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            variant: "subtitle2",
            color: color,
            children: label
        }),
        size: "small",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            bgcolor: bgcolor,
            height: 20,
            borderRadius: "2px"
        }, sx)
    });
};


/***/ }),

/***/ 2977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FullscreenModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41883);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12363);





var FullscreenModal = function(_param) {
    var _enableScroll = _param.enableScroll, enableScroll = _enableScroll === void 0 ? true : _enableScroll, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "enableScroll",
        "children"
    ]);
    if (!props.open) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            bgcolor: "background.default",
            sx: {
                ".BaseLayout": {
                    height: "100dvh",
                    overflowY: "auto"
                }
            },
            children: children
        })
    }));
};


/***/ }),

/***/ 72739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ IonInformationModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _ionic_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38677);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65992);



var IonInformationModal = function(param) {
    var open = param.open, title = param.title, content = param.content, buttons = param.buttons, cancelText = param.cancelText, onClose = param.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IonModalStyled, {
        isOpen: open,
        animated: false,
        onDidDismiss: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                px: 5,
                py: 7,
                width: function(theme) {
                    return "calc(280px - ".concat(theme.spacing(5), " * 2)");
                },
                textAlign: "center",
                bgcolor: "grey.100"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    variant: "h5",
                    sx: {
                        pb: 3
                    },
                    children: title
                }),
                typeof content === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    variant: "body2",
                    sx: {
                        pb: 7
                    },
                    children: content
                }) : content,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    spacing: 4,
                    alignItems: "center",
                    children: [
                        buttons,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            variant: "text",
                            color: "primary",
                            onClick: onClose,
                            children: cancelText
                        })
                    ]
                })
            ]
        })
    });
};
var IonModalStyled = (0,_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_ionic_react__WEBPACK_IMPORTED_MODULE_1__/* .IonModal */ .ki)(function(param) {
    var theme = param.theme;
    return {
        "--width": "fit-content",
        "--height": "fit-content",
        "--border-radius": theme.spacing(3)
    };
});


/***/ }),

/***/ 98653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TableScrollFetcher; },
/* harmony export */   "x": function() { return /* binding */ ScrollFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39899);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36908);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70969);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27104);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51637);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_organisms_loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27637);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);









/**
 *
 * @description useInfinitieScroll
 * 無限スクロールによるページを行うためのフック
 * 戻り値のrefを持つ要素を監視し、画面内に入ったときにonFetchMore関数を実行する。
 *
 * @param onFetchMore observerが画面内に表示された時実行されるフェッチ関数
 * @param hasNextPage 次のページが存在するか、なければobserverの監視を停止する
 * @param inverted スクロールが下→上の方向で行われるかどうか
 * @returns observe 画面内にいるかどうか監視されているref、これをページ要素の一番最後の要素に注入する
 */ var useInfinitieScroll = function(onFetchMore, hasNextPage, inverted) {
    var observe = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        onEnter: function(param) {
            var unobserve = param.unobserve, observe = param.observe;
            unobserve();
            if (!hasNextPage) return;
            onFetchMore().then(function() {
                observe();
                if (inverted) {
                    /**
           * @hack
           * 下→上にスクロールする場合、リスト要素を取り囲む要素にスクロールすることで現在のスクロール位置が崩れることを防ぐ
           */ var node = document.getElementById("scrollWrapper");
                    node === null || node === void 0 ? void 0 : node.scrollIntoView();
                }
            });
        }
    }).observe;
    return observe;
};
/**
 * @description
 * 無限スクロールによるページネーションを行うためのコンポーネント
 *
 * @returns
 */ var ScrollFetcher = function(param) {
    var inverted = param.inverted, nodes = param.nodes, loading = param.loading, hiddenLoading = param.hiddenLoading, onFetchMore = param.onFetchMore, hasNextPage = param.hasNextPage, tmp = param.component, Component = tmp === void 0 ? _mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : tmp, componentProps = param.componentProps, tmp1 = param.itemComponent, ItemComponent = tmp1 === void 0 ? _mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : tmp1, itemComponentProps = param.itemComponentProps, emptyMessage = param.emptyMessage, _loadingComponent = param.loadingComponent, loadingComponent = _loadingComponent === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}) : _loadingComponent, fadeSx = param.fadeSx, modalRef = param.modalRef;
    var observe = useInfinitieScroll(onFetchMore, hasNextPage, inverted);
    var fetcherAreaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // スクロール位置が一番下に達したかどうかの判定
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBottom = ref[0], setIsBottom = ref[1];
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    /**
   * 初回レンダリング実行後、全要素の高さが画面以下の場合にページネーションを行う処理
   * スクロール領域の縦の高さを監視し、それが画面よりも小さい場合は再度onFetchMoreを実行する
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetcherArea = fetcherAreaRef.current;
        if (!fetcherArea || !hasNextPage || !(nodes === null || nodes === void 0 ? void 0 : nodes.length)) return;
        var observer = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    if (entry.contentRect.height >= window.innerHeight) {
                        return;
                    }
                    onFetchMore();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        observer.observe(fetcherArea);
        return function() {
            observer.disconnect();
        };
    }, [
        fetcherAreaRef,
        onFetchMore,
        nodes === null || nodes === void 0 ? void 0 : nodes.length,
        hasNextPage
    ]);
    /**
   * スクロール位置が一番下に達したかどうかの判定
   * modalRefが指定されていればそちらを監視、なければwindowを監視
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // モーダルの場合
        if (modalRef && modalRef.current) {
            var el = modalRef.current;
            var handleScroll = function() {
                var scrollTop = el.scrollTop;
                var scrollHeight = el.scrollHeight;
                var clientHeight = el.clientHeight;
                var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
                setIsBottom(scrolledToBottom);
            };
            el.addEventListener("scroll", handleScroll);
            return function() {
                el.removeEventListener("scroll", handleScroll);
            };
        }
        // 通常のコンポーネントの場合
        var handleScroll1 = function() {
            var scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
            var scrollHeight = document.documentElement && document.documentElement.scrollHeight || document.body.scrollHeight;
            var clientHeight = document.documentElement.clientHeight || window.innerHeight;
            var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
            setIsBottom(scrolledToBottom);
        };
        window.addEventListener("scroll", handleScroll1);
        return function() {
            return window.removeEventListener("scroll", handleScroll1);
        };
    }, [
        modalRef === null || modalRef === void 0 ? void 0 : modalRef.current
    ]);
    /**
   * observerが動かない場合でもスクロールページネーションを行うための処理
   * スクロール位置が一番下に達したかどうかを監視し、達した場合はonFetchMoreを実行する
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isBottom && hasNextPage) {
            onFetchMore();
        }
    }, [
        isBottom,
        hasNextPage,
        onFetchMore
    ]);
    // show loading
    if (loading && !(nodes && nodes.length)) {
        return loadingComponent;
    }
    if (!nodes) return null;
    // show empty
    if (!nodes.length) {
        if (typeof emptyMessage !== "string") {
            return emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            variant: "body1",
            align: "center",
            sx: {
                py: 6
            },
            color: "text.secondary",
            children: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : t("emptyMessage")
        });
    }
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            pb: 2
        },
        ref: fetcherAreaRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            spacing: 4
        }, inverted ? {
            direction: "column-reverse"
        } : {}, componentProps), {
            id: "scrollWrapper",
            children: [
                nodes.map(function(node, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        /** 下→上スクロールの場合は1番上の要素がobserver */ /** 上→下スクロールの場合は1番下の要素がobserver */ ref: index === nodes.length - 1 ? observe : null
                    }, itemComponentProps), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__.Fade, {
                            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, fadeSx),
                            timeout: 225,
                            in: true,
                            children: node
                        })
                    }), (ref1 = node === null || node === void 0 ? void 0 : node.key) !== null && ref1 !== void 0 ? ref1 : index);
                }),
                hasNextPage && !hiddenLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    size: {
                        xs: 12
                    },
                    sx: {
                        m: "auto",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_loading__WEBPACK_IMPORTED_MODULE_11__/* .Loading */ .g, {})
                })
            ]
        }))
    });
};
var TableScrollFetcher = function(param) {
    var onFetchMore = param.onFetchMore, loading = param.loading, nodes = param.nodes, colSpan = param.colSpan, hasNextPage = param.hasNextPage, _loadingComponent = param.loadingComponent, loadingComponent = _loadingComponent === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}) : _loadingComponent, emptyMessage = param.emptyMessage, tmp = param.component, Component = tmp === void 0 ? _mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : tmp;
    var observe = useInfinitieScroll(onFetchMore, hasNextPage);
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)().t;
    // show loading
    if (loading && !(nodes && nodes.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            children: loadingComponent
        });
    }
    if (!nodes) return null;
    // show empty
    if (!nodes.length) {
        if (typeof emptyMessage !== "string") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        align: "center",
                        colSpan: colSpan,
                        sx: {
                            borderBottom: "none"
                        },
                        children: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : null
                    })
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    align: "center",
                    colSpan: colSpan,
                    sx: {
                        borderBottom: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        align: "center",
                        sx: {
                            py: 6
                        },
                        color: "text.secondary",
                        children: emptyMessage !== null && emptyMessage !== void 0 ? emptyMessage : t("emptyMessage")
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        children: [
            nodes.map(function(node, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                    ref: index === nodes.length - 1 ? observe : null,
                    sx: {
                        "&:hover": {
                            bgcolor: "grey.50"
                        }
                    },
                    children: node
                }, index);
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    align: "center",
                    colSpan: colSpan,
                    sx: {
                        borderBottom: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            m: "auto"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_loading__WEBPACK_IMPORTED_MODULE_11__/* .Loading */ .g, {})
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 92054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MC": function() { return /* binding */ getCropBySize; },
/* harmony export */   "qe": function() { return /* binding */ ImageEditModal; }
/* harmony export */ });
/* unused harmony export convertCropToPx */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_image_crop_dist_ReactCrop_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17001);
/* harmony import */ var react_image_crop_dist_ReactCrop_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_image_crop_dist_ReactCrop_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38677);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(65992);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_image_crop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68555);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24038);
/* harmony import */ var _components_layouts_ConsoleBaseLayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91456);
/* harmony import */ var _components_organisms_functionals__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2977);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30226);
/* harmony import */ var _core_native_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81291);















var ImageEditModal = function(param) {
    var open = param.open, src = param.src, onClose = param.onClose, _ratio = param.ratio, ratio = _ratio === void 0 ? 375 / 281 : _ratio, onSave = param.onSave, onUploadFile = param.onUploadFile, _isConsole = param.isConsole, isConsole = _isConsole === void 0 ? false : _isConsole;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("threadCreate").t;
    var deviceInfo = (0,_core_native_device__WEBPACK_IMPORTED_MODULE_6__/* .useDeviceInfo */ .u)().deviceInfo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), saving = ref[0], setSaving = ref[1];
    var showError = (0,_core__WEBPACK_IMPORTED_MODULE_7__/* .useMessage */ .UD)().showError;
    var imageRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var cropRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        x: 0,
        y: 0,
        width: 100,
        height: 100 / ratio,
        unit: "%"
    }), crop = ref1[0], setCrop = ref1[1];
    var handleImageLoaded = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(event) {
        imageRef.current = event.currentTarget;
        var newCrop = getCropBySize(event.currentTarget.width, event.currentTarget.height, ratio);
        cropRef.current = newCrop;
        setCrop(newCrop);
        return false;
    }, [
        ratio
    ]);
    var handleCropImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var newCrop, localFile, data, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!imageRef.current || !cropRef.current) {
                        return [
                            2
                        ];
                    }
                    setSaving(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    newCrop = convertCropToPx(imageRef.current, cropRef.current);
                    return [
                        4,
                        getCroppedImg(imageRef.current, newCrop, (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem) === "ios")
                    ];
                case 2:
                    localFile = _state.sent();
                    return [
                        4,
                        onUploadFile(localFile)
                    ];
                case 3:
                    data = _state.sent();
                    onSave(data, localFile);
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    /**
       * @todo エラーハンドリングの型付け
       * https://app.clickup.com/t/908127/UT-5180
       */ if (typeof err === "string") {
                        showError(new Error(t(err)));
                    } else {
                        showError(err);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    setSaving(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem,
        onUploadFile,
        onSave,
        showError,
        t
    ]);
    var Layout = isConsole ? _components_layouts_ConsoleBaseLayout__WEBPACK_IMPORTED_MODULE_10__/* .ConsoleBaseLayout */ .f : _components_layouts__WEBPACK_IMPORTED_MODULE_11__/* .BaseLayout */ .I;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_functionals__WEBPACK_IMPORTED_MODULE_12__/* .FullscreenModal */ .O, {
        open: open,
        onClose: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Layout, {
            header: {
                left: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.IconButton.Back, {
                    edge: "start",
                    onClick: onClose
                }),
                title: t("imageEditTitle"),
                right: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    loading: saving,
                    color: "primary",
                    sx: {
                        mr: -1
                    },
                    onClick: handleCropImage,
                    children: t("keep")
                })
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                flex: 1,
                justifyContent: "center",
                sx: {
                    height: "100%",
                    backgroundColor: "black"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactCropStyled, {
                    crop: crop,
                    aspect: ratio,
                    onChange: function(newCrop) {
                        setCrop(newCrop);
                        cropRef.current = newCrop;
                    },
                    renderSelectionAddon: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "body2",
                            align: "center",
                            color: "white",
                            children: t("imageEditDesc")
                        });
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: src,
                        alt: "",
                        onLoad: handleImageLoaded
                    })
                })
            })
        })
    });
};
function getCropBySize(width, height, ratio) {
    var newWidth = width / ratio < height * ratio ? 100 : height * ratio / width * 100;
    var newHeight = width / ratio > height * ratio ? 100 : width / ratio / height * 100;
    var y = (100 - newHeight) / 2;
    var x = (100 - newWidth) / 2;
    return {
        unit: "%",
        width: newWidth,
        height: newHeight,
        x: x,
        y: y
    };
}
function getCroppedImg(image, crop, isIOS) {
    var // iOSのCanvasで描画できるピクセル面積の限界の1/4のサイズを画像の許容値とし、それより大きな画像はこれに収まるようにリサイズする
    maximumPixels = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 4096 * 4096 * 0.25;
    var canvas = document.createElement("canvas");
    var pixelRatio = window.devicePixelRatio;
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    var ctx = canvas.getContext("2d");
    if (!ctx) {
        return Promise.reject("Can not get context");
    }
    var requiredPixels = image.naturalWidth * pixelRatio * image.naturalHeight * pixelRatio;
    var scalar = 1;
    // リサイズ係数の算出
    if (requiredPixels > maximumPixels) {
        scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);
    }
    canvas.width = crop.width * pixelRatio * scaleX * scalar;
    canvas.height = crop.height * pixelRatio * scaleY * scalar;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width * scaleX * scalar, crop.height * scaleY * scalar);
    // As a blob
    return new Promise(function(resolve, reject) {
        canvas.toBlob(function(blob) {
            if (!blob) {
                return reject(/**
             * @todo
             * iOSサイズ制限のため縦横幅が大きい画像をcanvasで出力できない。トリムなしで画像アップできるようにリサイズ処理などを実装する。
             *
             * https://app.clickup.com/t/908127/UT-5179
             */ crop.width * scaleX > 2355 ? "canvasSizeOver" : "canvasIsEmpty");
            }
            return resolve(blob);
        }, "image/jpeg", 1);
    });
}
function convertCropToPx(img, crop) {
    if (crop.unit === "px") {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, crop);
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, crop), {
        unit: "px",
        width: crop.width * img.width / 100,
        height: crop.height * img.height / 100,
        x: crop.x * img.width / 100,
        y: crop.y * img.height / 100
    });
}
var ReactCropStyled = (0,_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(react_image_crop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function() {
    return {
        "&&": {
            ".ReactCrop__drag-handle": {
                margin: 0,
                "&.ord-nw": {
                    "&::after": {
                        borderTopWidth: 4,
                        borderLeftWidth: 4
                    }
                },
                "&.ord-ne": {
                    "&::after": {
                        borderTopWidth: 4,
                        borderRightWidth: 4
                    }
                },
                "&.ord-sw": {
                    "&::after": {
                        borderBottomWidth: 4,
                        borderLeftWidth: 4
                    }
                },
                "&.ord-se": {
                    "&::after": {
                        borderBottomWidth: 4,
                        borderRightWidth: 4
                    }
                },
                "&::after": {
                    width: 40,
                    height: 40,
                    borderWidth: 0,
                    borderStyle: "solid",
                    borderColor: "white",
                    backgroundColor: "transparent"
                }
            },
            "& .ReactCrop__crop-selection": {
                borderStyle: "solid",
                animation: "none",
                backgroundImage: "none",
                borderWidth: 2
            },
            ".ReactCrop__selection-addon": {
                position: "absolute",
                bottom: -50,
                left: 0,
                right: 0,
                width: "100%"
            }
        }
    };
});


/***/ }),

/***/ 22019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useImageEditor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30226);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21366);
/* harmony import */ var _core_native__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23087);
/* harmony import */ var _ImageEditModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92054);







/**
 *
 * @description useImageEditor
 * 画像を選択するとトリム編集用のモーダルを表示し、編集後に処理をして必要な値を返すカスタムフック
 *
 * @param {string | undefined} userId ログインユーザーのuserId
 * @param {initialPath} string 初期の画像パス
 * @param {data => Promise<void>} callback 画像保存後にデータ値を使って呼び出すコールバック
 *
 * @returns ItemEditModal モーダルコンポーネントのJSX
 * @returns ModalProps モーダルコンポーネント呼び出し時に渡すprops
 * @returns handleChoseFile 画像を選択し、選択するとモーダルを開く関数
 * @returns handleRemoveFile トリムして一時保存した画像を削除する関数
 * @returns filePathAfterCrop トリム後に画像を表示する用のURL
 *
 * 使い方
 * - ItemEditModalコンポーネントをJSXに配置し、ModalPropsを渡す。
 * - handleChoseFileを呼び出すことで「ファイル選択→選択後モーダル表示」の挙動を実現できる。
 * - 第二引数のcallbackで画像トリム後の挙動を設定できるので、これでフォームの値を変更するなどを行う
 */ var useImageEditor = function(param) {
    var userId = param.userId, callback = param.callback, _initialPath = param.initialPath, initialPath = _initialPath === void 0 ? "" : _initialPath;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var showError = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useMessage */ .UD)().showError;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), open = ref[0], setOpen = ref[1];
    var getImage = _core_native__WEBPACK_IMPORTED_MODULE_3__/* .getImage */ .g;
    var upload = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useUserTmpUploader */ .x)(userId !== null && userId !== void 0 ? userId : "").upload;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), filePathBeforeCrop = ref1[0], setFilePathBeforeCrop = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), filePathAfterCrop = ref2[0], setFilePathAfterCrop = ref2[1];
    var handleGetImage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return getImage(_config__WEBPACK_IMPORTED_MODULE_5__/* .config.upload.mimeTypes.image */ .v.upload.mimeTypes.image).then(function(file) {
            if (file.size > _config__WEBPACK_IMPORTED_MODULE_5__/* .config.upload.limit.image */ .v.upload.limit.image) {
                throw new Error("uploadErrorMaximumSize");
            }
            return file;
        }).catch(function(error) {
            if (error.message === "User denied access to photos") {
                showError(new Error(t("uploadErrorAccessDenied")));
                return;
            }
            if (error.message === "uploadErrorMaximumSize") {
                showError(new Error(t("uploadErrorMaximumSize")));
                return;
            }
            if (error.message === "uploadErrorImageOnly") {
                showError(new Error(t("uploadErrorImageOnly")));
                return;
            }
            showError(error);
            return;
        });
    }, [
        getImage,
        showError,
        t
    ]);
    var handleChoseFile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var file;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        handleGetImage()
                    ];
                case 1:
                    file = _state.sent();
                    if (!file) return [
                        2
                    ];
                    setFilePathBeforeCrop(URL.createObjectURL(file));
                    setOpen(true);
                    return [
                        2
                    ];
            }
        });
    }), [
        handleGetImage
    ]);
    var handleRemoveFile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setFilePathAfterCrop("");
    }, []);
    var handleSave = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(data) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFilePathAfterCrop(data.fileUrl);
                        return [
                            4,
                            callback(data)
                        ];
                    case 1:
                        _state.sent();
                        setOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setFilePathAfterCrop(initialPath);
    }, [
        initialPath
    ]);
    var ModalProps = {
        open: open,
        src: filePathBeforeCrop !== null && filePathBeforeCrop !== void 0 ? filePathBeforeCrop : "",
        onClose: function() {
            return setOpen(false);
        },
        onUploadFile: function(file) {
            return upload(file);
        },
        onSave: handleSave
    };
    return {
        ImageEditModal: _ImageEditModal__WEBPACK_IMPORTED_MODULE_8__/* .ImageEditModal */ .qe,
        ModalProps: ModalProps,
        handleChoseFile: handleChoseFile,
        handleRemoveFile: handleRemoveFile,
        filePathAfterCrop: filePathAfterCrop
    };
};


/***/ }),

/***/ 99850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ItemDetailBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97423);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38677);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80537);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16550);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7702);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66517);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30047);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61631);
/* harmony import */ var _core_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34814);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93893);
/* harmony import */ var _core_individual__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85362);
/* harmony import */ var _lib_array__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79832);
















var ItemDetailBox = function(param) {
    var userItem = param.userItem, userId = param.userId, viewable = param.viewable, showPreSale = param.showPreSale, purchasablePlanNames = param.purchasablePlanNames, isPremium = param.isPremium, formattedSerialNumber = param.formattedSerialNumber, hidden = param.hidden, hiddenSupplementLink = param.hiddenSupplementLink, hiddenInfo = param.hiddenInfo, onClickSerial = param.onClickSerial, onClickExpansion = param.onClickExpansion, onClickTrade = param.onClickTrade, onClickNftIcon = param.onClickNftIcon, onClickShare = param.onClickShare, _hiddenPurchaseLimit = param.hiddenPurchaseLimit, hiddenPurchaseLimit = _hiddenPurchaseLimit === void 0 ? true : _hiddenPurchaseLimit, skuUnit = param.skuUnit, isPickUp = param.isPickUp, isMerch = param.isMerch, purchaseLimitByUser = param.purchaseLimitByUser;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var analytics = (0,_core_analytics__WEBPACK_IMPORTED_MODULE_5__/* .useAnalytics */ .z$)().analytics;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("userItemDetail").t;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref33 = (0,_core__WEBPACK_IMPORTED_MODULE_7__/* .useRouter */ .tv)(), generatePath = ref33.generatePath, routerPages = ref33.routerPages;
    var ref34 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), index = ref34[0], setIndex = ref34[1];
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_8__/* .useLocation */ .TH)();
    var disabledTrade = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        return !!((userItem === null || userItem === void 0 ? void 0 : userItem.isUserProtected) || (userItem === null || userItem === void 0 ? void 0 : userItem.isSystemProtected) || (userItem === null || userItem === void 0 ? void 0 : userItem.item.type) === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Merch */ .qGq.Merch && (userItem === null || userItem === void 0 ? void 0 : (ref = userItem.serials) === null || ref === void 0 ? void 0 : ref.filter(function(serial) {
            return !serial.isProtected;
        })));
    }, [
        userItem === null || userItem === void 0 ? void 0 : userItem.isUserProtected,
        userItem === null || userItem === void 0 ? void 0 : userItem.isSystemProtected
    ]);
    var isNft = !!(userItem === null || userItem === void 0 ? void 0 : (ref = userItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.nft) === null || ref1 === void 0 ? void 0 : ref1.chains);
    var itemIcon = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        switch(userItem === null || userItem === void 0 ? void 0 : (ref = userItem.item) === null || ref === void 0 ? void 0 : ref.type){
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Audio */ .qGq.Audio:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Audio, {
                    fontSize: "xSmall"
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Video */ .qGq.Video:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Video, {
                    fontSize: "xSmall"
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Magazine */ .qGq.Magazine:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Magazine, {
                    fontSize: "xSmall"
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Merch */ .qGq.Merch:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Merch, {
                    fontSize: "xSmall"
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Wallpaper */ .qGq.Wallpaper:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Wallpaper, {
                    fontSize: "xSmall"
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .ItemType.Ticket */ .qGq.Ticket:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Ticket, {
                    fontSize: "xSmall"
                });
            default:
                return null;
        }
    }, [
        userItem === null || userItem === void 0 ? void 0 : (ref2 = userItem.item) === null || ref2 === void 0 ? void 0 : ref2.type
    ]);
    var ref35, ref36, ref37, ref38, ref39, ref40;
    var info = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        return [
            {
                label: t("rarity"),
                value: (ref35 = userItem === null || userItem === void 0 ? void 0 : (ref = userItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.rarity) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref35 !== void 0 ? ref35 : "-",
                hidden: ((ref36 = userItem === null || userItem === void 0 ? void 0 : (ref2 = userItem.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rarity) === null || ref3 === void 0 ? void 0 : ref3.name) !== null && ref36 !== void 0 ? ref36 : "-") === "-"
            },
            {
                label: t("issueNumber"),
                value: (ref37 = userItem === null || userItem === void 0 ? void 0 : (ref4 = userItem.item) === null || ref4 === void 0 ? void 0 : ref4.issuedNumber) !== null && ref37 !== void 0 ? ref37 : "∞",
                hidden: hiddenInfo || (0,_core_individual__WEBPACK_IMPORTED_MODULE_10__/* .individualHideItemIssuedNumber */ .DG)()
            },
            {
                label: t((userItem === null || userItem === void 0 ? void 0 : (ref5 = userItem.item) === null || ref5 === void 0 ? void 0 : ref5.price) && userItem.item.price > 0 ? "purchaseLimit" : "acquisitionLimit"),
                value: (ref38 = purchaseLimitByUser !== null && purchaseLimitByUser !== void 0 ? purchaseLimitByUser : userItem === null || userItem === void 0 ? void 0 : (ref6 = userItem.item) === null || ref6 === void 0 ? void 0 : ref6.purchaseLimitByUser) !== null && ref38 !== void 0 ? ref38 : 0,
                hidden: hiddenPurchaseLimit || !lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(userItem === null || userItem === void 0 ? void 0 : (ref7 = userItem.item) === null || ref7 === void 0 ? void 0 : ref7.purchaseLimitByUser) || (userItem === null || userItem === void 0 ? void 0 : (ref8 = userItem.item) === null || ref8 === void 0 ? void 0 : ref8.purchaseLimitByUser) === 0 || !lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(userItem === null || userItem === void 0 ? void 0 : (ref9 = userItem.item) === null || ref9 === void 0 ? void 0 : ref9.price)
            },
            {
                label: t("possessionsNumber"),
                value: (ref39 = userItem === null || userItem === void 0 ? void 0 : userItem.number) !== null && ref39 !== void 0 ? ref39 : 0,
                hidden: ((ref40 = userItem === null || userItem === void 0 ? void 0 : userItem.number) !== null && ref40 !== void 0 ? ref40 : 0) === 0
            },
            {
                label: t("type"),
                value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    direction: "row",
                    children: [
                        itemIcon,
                        "\xa0\xa0",
                        t((userItem === null || userItem === void 0 ? void 0 : (ref10 = userItem.item) === null || ref10 === void 0 ? void 0 : ref10.type) || "")
                    ]
                })
            }, 
        ];
    }, [
        t,
        userItem === null || userItem === void 0 ? void 0 : (ref3 = userItem.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.rarity) === null || ref4 === void 0 ? void 0 : ref4.name,
        userItem === null || userItem === void 0 ? void 0 : (ref5 = userItem.item) === null || ref5 === void 0 ? void 0 : ref5.issuedNumber,
        userItem === null || userItem === void 0 ? void 0 : (ref6 = userItem.item) === null || ref6 === void 0 ? void 0 : ref6.price,
        userItem === null || userItem === void 0 ? void 0 : (ref7 = userItem.item) === null || ref7 === void 0 ? void 0 : ref7.purchaseLimitByUser,
        userItem === null || userItem === void 0 ? void 0 : (ref8 = userItem.item) === null || ref8 === void 0 ? void 0 : ref8.type,
        userItem === null || userItem === void 0 ? void 0 : userItem.number,
        hiddenInfo,
        hiddenPurchaseLimit,
        itemIcon, 
    ]);
    var images = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6;
        var imageArr = (ref6 = userItem === null || userItem === void 0 ? void 0 : (ref = userItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
            var mediumUri = param.mediumUri, caption = param.caption;
            return {
                src: mediumUri || "",
                caption: caption
            };
        })) !== null && ref6 !== void 0 ? ref6 : [];
        if (skuUnit === null || skuUnit === void 0 ? void 0 : (ref2 = skuUnit.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) {
            imageArr.unshift({
                src: skuUnit.thumbnail.mediumUri,
                caption: ""
            });
        } else if (userItem === null || userItem === void 0 ? void 0 : (ref3 = userItem.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.front) === null || ref5 === void 0 ? void 0 : ref5.mediumUri) {
            imageArr.unshift({
                src: userItem.item.thumbnail.front.mediumUri,
                caption: ""
            });
        }
        return imageArr.filter(function(param) {
            var src = param.src;
            return !!src;
        });
    }, [
        skuUnit === null || skuUnit === void 0 ? void 0 : (ref9 = skuUnit.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.mediumUri,
        userItem === null || userItem === void 0 ? void 0 : (ref10 = userItem.item) === null || ref10 === void 0 ? void 0 : ref10.images,
        userItem === null || userItem === void 0 ? void 0 : (ref11 = userItem.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.thumbnail) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.front) === null || ref13 === void 0 ? void 0 : ref13.mediumUri, 
    ]);
    // set index = 0 when select sku
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (skuUnit === null || skuUnit === void 0 ? void 0 : (ref = skuUnit.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) {
            var ref1;
            setIndex(0);
            (ref1 = swiperRef.current) === null || ref1 === void 0 ? void 0 : ref1.slideTo(1);
        }
    }, [
        skuUnit === null || skuUnit === void 0 ? void 0 : (ref14 = skuUnit.thumbnail) === null || ref14 === void 0 ? void 0 : ref14.mediumUri
    ]);
    // キャッシュが残っていた場合indexがリセットされないため強制的に戻す
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(0);
        (ref1 = swiperRef.current) === null || ref1 === void 0 ? void 0 : ref1.update();
    }, [
        location.pathname
    ]);
    var ref41, ref42, ref43;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_12__/* .OrganismFrame */ .o, {
        sx: {
            py: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                alignItems: "center",
                sx: {
                    position: "relative",
                    mx: -5,
                    //fixed swiper scroll
                    ".swiper": {
                        maxWidth: "100%"
                    }
                },
                children: [
                    images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        sx: {
                            position: "absolute",
                            top: 16,
                            right: 16,
                            bgcolor: "grey.900",
                            borderRadius: "40px",
                            p: "3px 6px",
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            variant: "subtitle2",
                            color: "white",
                            children: [
                                index + 1,
                                "/",
                                images.length
                            ]
                        })
                    }),
                    images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextArrow, {
                                disabled: index + 1 === images.length,
                                onClick: function() {
                                    var ref;
                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevArrow, {
                                disabled: !index,
                                onClick: function() {
                                    var ref;
                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                        loop: false,
                        slidesPerView: 1,
                        centeredSlides: true,
                        enabled: true,
                        spaceBetween: 0,
                        initialSlide: 0,
                        onActiveIndexChange: function(swiper) {
                            return setIndex(swiper.activeIndex);
                        },
                        onSwiper: function(swiper) {
                            return swiperRef.current = swiper;
                        },
                        children: images.map(function(param, index) {
                            var src = param.src, caption = param.caption;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    flex: 1,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    sx: {
                                        button: {
                                            height: 375
                                        },
                                        position: "relative",
                                        mb: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.ItemImageArea, {
                                            src: src,
                                            size: "large",
                                            noItem: !viewable,
                                            fullWidth: true
                                        }),
                                        !!caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            sx: {
                                                position: "absolute",
                                                bottom: 16,
                                                px: 2,
                                                py: "2px",
                                                bgcolor: "rgba(32, 52, 63, 0.6)",
                                                borderRadius: 1
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                component: "p",
                                                variant: "caption",
                                                color: "white",
                                                children: caption
                                            })
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    !!(userItem === null || userItem === void 0 ? void 0 : (ref15 = userItem.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.purchasableUsers) === null || ref16 === void 0 ? void 0 : ref16.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mt: 5,
                            gap: 1,
                            px: 5,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.MembersOnly, {
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                color: "text.hint",
                                variant: "subtitle2",
                                children: t("forLimitedUser", "対象者限定")
                            })
                        ]
                    }),
                    isPremium && purchasablePlanNames && purchasablePlanNames.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mb: 2,
                            gap: 1,
                            px: 5,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.MembersOnly, {
                                fontSize: "small",
                                sx: {
                                    color: "info.main"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                color: "text.hint",
                                variant: "subtitle2",
                                children: purchasablePlanNames.join(", ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        flex: 1,
                        alignItems: "center",
                        sx: {
                            px: 5,
                            width: "100%"
                        },
                        children: [
                            isNft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.IconButton.Nft, {
                                onClick: onClickNftIcon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "h3",
                                children: userItem === null || userItem === void 0 ? void 0 : (ref17 = userItem.item) === null || ref17 === void 0 ? void 0 : ref17.title
                            })
                        ]
                    }),
                    (userItem === null || userItem === void 0 ? void 0 : (ref18 = userItem.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.metadata) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.ticket) === null || ref20 === void 0 ? void 0 : ref20.isThroughTicket) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        width: "100%",
                        px: 5,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_15__/* .ThroughTicketTag */ .w, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoticeCell, {
                        isEventPickup: !!isPickUp,
                        isMerch: !!isMerch
                    }),
                    showPreSale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            pt: 5,
                            px: 5,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.CautionText, {
                            type: "error",
                            sx: {
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                bgcolor: "grey.50",
                                border: "none",
                                minHeight: 44
                            },
                            children: t("availableFoPreSaleNote", "この商品は先行販売で購入できます。")
                        })
                    }),
                    formattedSerialNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        sx: {
                            pt: 4,
                            px: 5,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("serialNumber")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    variant: "overline",
                                    children: formattedSerialNumber
                                }),
                                size: "small",
                                sx: {
                                    minWidth: 44,
                                    bgcolor: "grey.200"
                                }
                            })
                        ]
                    }),
                    !!((ref41 = userItem === null || userItem === void 0 ? void 0 : (ref21 = userItem.item) === null || ref21 === void 0 ? void 0 : ref21.description) !== null && ref41 !== void 0 ? ref41 : userItem === null || userItem === void 0 ? void 0 : (ref22 = userItem.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.metadata) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.ticket) === null || ref24 === void 0 ? void 0 : ref24.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "body2",
                        sx: {
                            pt: 5,
                            px: 5,
                            width: "100%"
                        },
                        children: (ref42 = userItem === null || userItem === void 0 ? void 0 : (ref25 = userItem.item) === null || ref25 === void 0 ? void 0 : ref25.description) !== null && ref42 !== void 0 ? ref42 : userItem === null || userItem === void 0 ? void 0 : (ref26 = userItem.item) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.metadata) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.ticket) === null || ref28 === void 0 ? void 0 : ref28.description
                    })
                ]
            }),
            !(0,_core_individual__WEBPACK_IMPORTED_MODULE_10__/* .individualHideStoreItemInfo */ .Mq)() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                direction: "row",
                justifyContent: "space-between",
                sx: {
                    pt: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        children: (0,_lib_array__WEBPACK_IMPORTED_MODULE_17__/* .filterHiddenItem */ .s)(info).map(function(param, index) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Divider, {
                                        orientation: "vertical"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        sx: {
                                            px: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                sx: {
                                                    py: 2
                                                },
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                variant: "overline",
                                                children: value
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    }),
                    hiddenSupplementLink && (userItem === null || userItem === void 0 ? void 0 : userItem.item.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        variant: "text",
                        sx: {
                            p: 1,
                            borderRadius: 0,
                            minWidth: 44,
                            alignSelf: "stretch",
                            display: "flex",
                            height: "unset",
                            color: "text.secondary"
                        },
                        onClick: function() {
                            var ref, ref1;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_comment", {
                                applicationKey: _config__WEBPACK_IMPORTED_MODULE_19__/* .config.applicationKey */ .v.applicationKey,
                                artistId: userItem === null || userItem === void 0 ? void 0 : (ref = userItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                                name: "store_detail"
                            });
                        },
                        href: generatePath(routerPages.ItemComment, {
                            itemId: userItem === null || userItem === void 0 ? void 0 : (ref29 = userItem.item) === null || ref29 === void 0 ? void 0 : ref29.id
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Reply, {
                                sx: {
                                    color: "grey.600"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "body2",
                                sx: {
                                    pl: 1,
                                    color: "inherit"
                                },
                                children: userItem === null || userItem === void 0 ? void 0 : (ref30 = userItem.item) === null || ref30 === void 0 ? void 0 : ref30.commentCount
                            })
                        ]
                    })
                ]
            }),
            !hiddenSupplementLink && (userItem === null || userItem === void 0 ? void 0 : userItem.item.id) && !(0,_core_individual__WEBPACK_IMPORTED_MODULE_10__/* .individualHideStoreSupplementLink */ .lb)() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupplementLinkSetCell, {
                itemId: userItem.item.id,
                artistId: (ref43 = userItem === null || userItem === void 0 ? void 0 : (ref31 = userItem.item) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.issuedArtist) === null || ref32 === void 0 ? void 0 : ref32.id) !== null && ref43 !== void 0 ? ref43 : "",
                viewable: viewable,
                disabledTrade: disabledTrade,
                commentCount: userItem.item.commentCount,
                userId: userId,
                hidden: hidden,
                onClickSerial: onClickSerial,
                onClickExpansion: onClickExpansion,
                onClickTrade: onClickTrade,
                userItem: userItem,
                onClickShare: onClickShare
            })
        ]
    });
};
var SupplementLinkSetCell = function(param) {
    var itemId = param.itemId, artistId = param.artistId, userId = param.userId, commentCount = param.commentCount, disabledTrade = param.disabledTrade, hidden = param.hidden, viewable = param.viewable, onClickSerial = param.onClickSerial, onClickExpansion = param.onClickExpansion, userItem = param.userItem, onClickTrade = param.onClickTrade, onClickShare = param.onClickShare;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("userItemDetail").t;
    var analytics = (0,_core_analytics__WEBPACK_IMPORTED_MODULE_5__/* .useAnalytics */ .z$)().analytics;
    var ref = (0,_core__WEBPACK_IMPORTED_MODULE_7__/* .useRouter */ .tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openNotTradeConfirm = ref1[0], setOpenNotTradeConfirm = ref1[1];
    var supplements = [
        {
            title: "expansion",
            hidden: hidden === null || hidden === void 0 ? void 0 : hidden.expansion,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Expansion, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            onClick: onClickExpansion,
            disabled: !viewable
        },
        {
            title: "itemInfo",
            hidden: (hidden === null || hidden === void 0 ? void 0 : hidden.itemInfo) || (0,_core_individual__WEBPACK_IMPORTED_MODULE_10__/* .individualHiddenItemInfo */ .Ek)(),
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.ItemInfo, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            onClick: onClickSerial,
            href: onClickSerial ? undefined : generatePath(userId ? routerPages.UserItemInformation : routerPages.OwnedItemInformation, {
                itemId: itemId,
                userId: userId
            }),
            disabled: false
        },
        {
            title: "share",
            hidden: !onClickShare,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Share, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            onClick: onClickShare
        },
        {
            title: "trade",
            hidden: (hidden === null || hidden === void 0 ? void 0 : hidden.trade) || !_config__WEBPACK_IMPORTED_MODULE_19__/* .config.modules.trade */ .v.modules.trade,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.TradeRequest, {
                sx: {
                    mx: "auto",
                    color: disabledTrade ? "text.disabled" : "inherit"
                }
            }),
            onClick: disabledTrade ? function() {
                return setOpenNotTradeConfirm(true);
            } : onClickTrade,
            disabled: disabledTrade
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_12__/* .CellFrame */ .p, {
        sx: {
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        direction: "row",
                        children: (0,_lib_array__WEBPACK_IMPORTED_MODULE_17__/* .filterHiddenItem */ .s)(supplements).map(function(param, index) {
                            var title = param.title, icon = param.icon, onClick = param.onClick, disabled = param.disabled, href = param.href;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                sx: {
                                    display: "grid",
                                    gridTemplateColumns: "1fr",
                                    p: 1,
                                    color: "text.primary",
                                    borderRadius: 0,
                                    textAlign: "center",
                                    "&.Mui-disabled": {
                                        background: "inherit",
                                        color: "text.disabled"
                                    }
                                },
                                href: href,
                                onClick: onClick,
                                variant: "text",
                                disabled: disabled,
                                children: [
                                    icon,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        variant: "overline",
                                        color: disabled ? "text.disabled" : "text.hint",
                                        sx: {
                                            pt: 1
                                        },
                                        children: t(title)
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        variant: "text",
                        sx: {
                            p: 1,
                            borderRadius: 0,
                            minWidth: 44,
                            alignSelf: "stretch",
                            display: "flex",
                            height: "unset",
                            color: "text.secondary"
                        },
                        onClick: function() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_comment", {
                                applicationKey: _config__WEBPACK_IMPORTED_MODULE_19__/* .config.applicationKey */ .v.applicationKey,
                                artistId: artistId,
                                name: "store_detail"
                            });
                        },
                        href: generatePath(routerPages.ItemComment, {
                            itemId: itemId
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Reply, {
                                sx: {
                                    color: "grey.600"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "body2",
                                sx: {
                                    pl: 1,
                                    color: "inherit"
                                },
                                children: commentCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.InformationModal, {
                open: openNotTradeConfirm,
                onClose: function() {
                    return setOpenNotTradeConfirm(false);
                },
                title: t("notTradeConfirmTitle"),
                content: t((userItem === null || userItem === void 0 ? void 0 : userItem.item.sku) ? "notTradeConfirmSKUDesc" : "notTradeConfirmDesc"),
                buttons: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    onClick: function() {
                        return setOpenNotTradeConfirm(false);
                    },
                    children: "OK"
                })
            })
        ]
    });
};
var NextArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.IconButton.NextArrow, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
        size: "large",
        sx: {
            bgcolor: "transparent",
            position: "absolute",
            top: (375 - 52) / 2,
            right: 8,
            zIndex: 2,
            svg: {
                color: "grey.400",
                fontSize: 27
            }
        }
    }, props));
};
var PrevArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.IconButton.PrevArrow, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
        size: "large",
        sx: {
            bgcolor: "transparent",
            position: "absolute",
            top: (375 - 52) / 2,
            left: 8,
            zIndex: 2,
            svg: {
                color: "grey.400",
                fontSize: 27
            }
        }
    }, props));
};
var NoticeCell = function(param) {
    var isEventPickup = param.isEventPickup, isMerch = param.isMerch;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("storeItemDetail").t;
    if (!(isEventPickup || isMerch)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        sx: {
            width: "100%",
            px: 5,
            mt: 4
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            sx: {
                display: "grid",
                placeItems: "center",
                bgcolor: "grey.50",
                py: 3,
                mb: 2
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_4__.Icons.Error, {
                        color: "error"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: isMerch ? t("isMerch", "この商品は配送される商品です") : t("isPickupItem", "この商品は会場での受け取りが必要な商品です")
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 75334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ItemDetailBoxSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31117);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38677);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79312);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93893);
/* harmony import */ var _lib_array__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79832);






var ItemDetailBoxSkeleton = function(param) {
    var hiddenSupplementLink = param.hiddenSupplementLink, hidden = param.hidden;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_2__/* .OrganismFrame */ .o, {
        sx: {
            py: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: 5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: 280,
                        height: 280
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                        variant: "large",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                            variant: "medium",
                            numberOfLine: 3,
                            lastWidth: "75%"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    pt: 1
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                        variant: "small",
                        width: "50%"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                        variant: "small",
                        width: "50%"
                    })
                ]
            }),
            !hiddenSupplementLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SupplementLinkSetCell, {
                hidden: hidden
            })
        ]
    });
};
var SupplementLinkSetCell = function(param) {
    var hidden = param.hidden;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("userItemDetail").t;
    var supplements = [
        {
            title: "expansion",
            hidden: hidden === null || hidden === void 0 ? void 0 : hidden.expansion,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.Expansion, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            disabled: false
        },
        {
            title: "serial",
            hidden: hidden === null || hidden === void 0 ? void 0 : hidden.serial,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.Serial, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            disabled: false
        },
        {
            title: "trade",
            hidden: hidden === null || hidden === void 0 ? void 0 : hidden.trade,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.TradeRequest, {
                sx: {
                    mx: "auto",
                    color: "inherit"
                }
            }),
            disabled: false
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_2__/* .CellFrame */ .p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            direction: "row",
            sx: {
                justifyContent: "flex-end",
                py: 2
            },
            children: (0,_lib_array__WEBPACK_IMPORTED_MODULE_7__/* .filterHiddenItem */ .s)(supplements).map(function(param, index) {
                var title = param.title, icon = param.icon, disabled = param.disabled;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        p: 1,
                        color: "text.primary",
                        borderRadius: 0,
                        textAlign: "center",
                        "&.Mui-disabled": {
                            backgroundColor: "transparent"
                        }
                    },
                    disabled: disabled,
                    variant: "text",
                    children: [
                        icon,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            variant: "overline",
                            color: disabled ? "text.disabled" : "text.hint",
                            sx: {
                                pt: 1
                            },
                            children: t(title)
                        })
                    ]
                }, index);
            })
        })
    });
};


/***/ }),

/***/ 30176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ItemIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12363);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66517);







var ItemIcon = function(param) {
    var _type = param.type, type = _type === void 0 ? _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Image */ .qGq.Image : _type, _size = param.size, size = _size === void 0 ? "xSmall" : _size;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        switch(size){
            case "small":
                return {
                    width: 24,
                    height: 24
                };
            default:
                return {
                    width: 16,
                    height: 16
                };
        }
    }, [
        size
    ]), width = ref.width, height = ref.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            bgcolor: "grey.50",
            borderRadius: "100%",
            width: width,
            height: height,
            p: 0,
            display: "grid",
            placeItems: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            iconType: type,
            sx: {
                color: "grey.700"
            },
            fontSize: size
        })
    });
};
var Icon = function(_param) {
    var iconType = _param.iconType, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "iconType"
    ]);
    switch(iconType){
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Ticket */ .qGq.Ticket:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Ticket, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Audio */ .qGq.Audio:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Audio, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Video */ .qGq.Video:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Video, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Image */ .qGq.Image:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Image, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Magazine */ .qGq.Magazine:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.MagazineOn, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Avatar */ .qGq.Avatar:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Avatar, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Wallpaper */ .qGq.Wallpaper:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Wallpaper, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_3__/* .ItemType.Merch */ .qGq.Merch:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Merch, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
    }
};


/***/ }),

/***/ 23350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ItemImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55504);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81714);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66517);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30176);
/* harmony import */ var _components_pages_GachaResult_template_TenGachaResult_LightFrame__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10273);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95626);











var ItemImage = function(_param) {
    var item = _param.item, noItem = _param.noItem, ownedCount = _param.ownedCount, showShadow = _param.showShadow, _showIcon = _param.showIcon, showIcon = _showIcon === void 0 ? false : _showIcon, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "item",
        "noItem",
        "ownedCount",
        "showShadow",
        "showIcon"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("userOwnedItems").t;
    var ref11;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        sx: {
            flexDirection: "column",
            width: "100%",
            position: "relative"
        },
        children: [
            showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: {
                    zIndex: 1,
                    marginInline: "auto",
                    pl: 1,
                    width: 104,
                    position: "absolute",
                    top: 8
                },
                children: ((item === null || item === void 0 ? void 0 : item.isDownloadable) || ((ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.wallpaper) === null || ref1 === void 0 ? void 0 : ref1.isPrintEnabled)) && item.type === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__/* .ItemType.Wallpaper */ .qGq.Wallpaper ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    direction: "row",
                    spacing: "2px",
                    sx: {
                        bgcolor: "grey.50",
                        borderRadius: 100,
                        height: 24,
                        width: (item === null || item === void 0 ? void 0 : item.isDownloadable) && ((ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.wallpaper) === null || ref3 === void 0 ? void 0 : ref3.isPrintEnabled) ? 40 : 24,
                        p: 1
                    },
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        (item === null || item === void 0 ? void 0 : item.isDownloadable) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.WallpaperDownload, {
                            sx: {
                                color: "grey.700",
                                width: "14px",
                                height: "14px"
                            }
                        }),
                        ((ref4 = item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.wallpaper) === null || ref5 === void 0 ? void 0 : ref5.isPrintEnabled) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.WallpaperPrinter, {
                            sx: {
                                color: "grey.700",
                                width: "14px",
                                height: "14px"
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_9__/* .ItemIcon */ .S, {
                    type: item.type,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                sx: !noItem && showShadow ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    position: "absolute",
                    top: 0,
                    width: 104,
                    height: 166
                }, (0,_components_pages_GachaResult_template_TenGachaResult_LightFrame__WEBPACK_IMPORTED_MODULE_11__/* .getEmphasisRaritySx */ .Qc)((ref6 = item.rarity) === null || ref6 === void 0 ? void 0 : ref6.id, 12)) : undefined
            }),
            (item === null || item === void 0 ? void 0 : item.isPrinted) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: {
                    position: "absolute",
                    top: 0,
                    width: 104,
                    height: 166,
                    zIndex: 1,
                    bgcolor: "Background",
                    opacity: 0.9,
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    variant: "overline",
                    color: "text.secondary",
                    children: t("printed", "プリント済")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.ItemImageArea, {
                noItem: noItem,
                src: (ref11 = (ref7 = item.thumbnail) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.front) === null || ref8 === void 0 ? void 0 : ref8.mediumUri) !== null && ref11 !== void 0 ? ref11 : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: {
                    pt: 2,
                    width: "100%",
                    height: "100%",
                    minHeight: "48px"
                },
                spacing: 1,
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        spacing: 1,
                        flex: 1,
                        sx: {
                            minWidth: 0,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                variant: "overline",
                                sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_13__/* .styleSets.lineCamp */ .k$.lineCamp(2)), {
                                    wordBreak: "break-all"
                                }),
                                align: "left",
                                children: item.title
                            }),
                            ((ref9 = item.rarityIconImage) === null || ref9 === void 0 ? void 0 : ref9.smallUri) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "square",
                                src: item.rarityIconImage.smallUri,
                                sx: {
                                    height: 12,
                                    width: 12,
                                    mx: "auto"
                                }
                            })
                        ]
                    }),
                    !!item.sku && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "overline",
                        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_13__/* .styleSets.lineCamp */ .k$.lineCamp(3)), {
                            wordBreak: "break-all",
                            width: "100%"
                        }),
                        align: "left",
                        children: item.sku.unitName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.OwnedItems, {
                                fontSize: "xSmall",
                                sx: {
                                    color: "grey.600"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                variant: "overline",
                                children: ownedCount !== null && ownedCount !== void 0 ? ownedCount : 0
                            })
                        ]
                    })
                ]
            }),
            showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: {
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    gap: "2px",
                    position: "absolute",
                    width: 104,
                    marginInline: "auto",
                    bottom: 52,
                    zIndex: 1,
                    pr: 1
                },
                children: [
                    item.isResaleAvailable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.Resale, {
                        fontSize: "small",
                        filledColor: true
                    }),
                    (item.isUserProtected || item.isSystemProtected) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.Protect, {
                        fontSize: "small",
                        filledColor: true
                    }),
                    !!(item === null || item === void 0 ? void 0 : (ref10 = item.nft) === null || ref10 === void 0 ? void 0 : ref10.chains) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.Nft, {
                        fontSize: "small",
                        filledColor: true
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 30047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ThroughTicketTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97423);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79312);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95626);



var ThroughTicketTag = function(param) {
    var disabled = param.disabled;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("consoleItems").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            variant: "overline",
            color: "white",
            children: t("throughTicket", "通し券")
        }),
        sx: {
            bgcolor: disabled ? "grey.300" : "secondary.main",
            px: 1,
            borderRadius: "2px",
            height: 20,
            ".MuiChip-label": {
                px: 0,
                py: 0,
                lineHeight: "20px"
            }
        }
    });
};


/***/ }),

/***/ 14575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ ThumbnailFullScreenModal; }
});

// UNUSED EXPORTS: usePrivacyScreen

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(12363);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(81714);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ButtonBase/ButtonBase.js + 3 modules
var ButtonBase = __webpack_require__(55504);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/components/layouts/Header.tsx
var Header = __webpack_require__(92016);
// EXTERNAL MODULE: ./src/components/layouts/BaseLayout.tsx + 4 modules
var BaseLayout = __webpack_require__(24038);
// EXTERNAL MODULE: ./src/components/organisms/functionals/FullscreenModal/index.tsx
var FullscreenModal = __webpack_require__(2977);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(31117);
// EXTERNAL MODULE: ./src/components/organisms/resourcePlayer/TheoPlayerView.tsx
var TheoPlayerView = __webpack_require__(78811);
// EXTERNAL MODULE: ./src/core/messages/useMessage.tsx
var useMessage = __webpack_require__(30226);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/resources/useDRMPlayer.ts
var useDRMPlayer = __webpack_require__(42109);
;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/ImagePlayer/index.tsx









var ImagePlayer = function(_param) {
    var resource = _param.resource, open = _param.open, imageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "resource",
        "open"
    ]);
    var ref;
    var ref1 = (0,react.useState)(true), showSkeleton = ref1[0], setShowSkeleton = ref1[1];
    if (((ref = resource.drm) === null || ref === void 0 ? void 0 : ref.encryptingStatus) === "encrypted") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageDRMPlayer, {
            open: open,
            resource: resource,
            width: imageProps === null || imageProps === void 0 ? void 0 : imageProps.width
        });
    }
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        justifyContent: "center",
        flex: 1,
        sx: {
            width: imageProps === null || imageProps === void 0 ? void 0 : imageProps.width,
            maxWidth: 600,
            margin: "auto",
            height: "100%",
            placeItems: "center"
        },
        children: [
            showSkeleton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 300,
                height: 480,
                style: {
                    objectFit: "contain"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, (0,_object_spread/* default */.Z)({
                src: (ref2 = resource === null || resource === void 0 ? void 0 : resource.compressedUri) !== null && ref2 !== void 0 ? ref2 : resource.uri,
                style: {
                    width: showSkeleton ? 0 : "100%",
                    height: showSkeleton ? 0 : "100%",
                    maxWidth: 600,
                    objectFit: "contain",
                    visibility: showSkeleton ? "hidden" : "visible"
                },
                onLoad: function() {
                    return setShowSkeleton(false);
                }
            }, imageProps))
        ]
    });
};
var ImageDRMPlayer = function(param) {
    var resource = param.resource, width = param.width, open = param.open;
    var showError = (0,useMessage/* useMessage */.UD)().showError;
    var t = (0,i18n/* useTranslation */.$G)().t;
    var ref = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            mutedAutoplay: "all"
        }
    }), ref1 = ref.ref, player = ref.player, accessToken = ref.accessToken;
    (0,react.useEffect)(function() {
        if (player && accessToken) {
            player.play();
        }
        if (open && !accessToken) {
            showError(t("drmAuthorizingError"));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessToken,
        open
    ]);
    if (!accessToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            width: width,
            maxWidth: 600,
            margin: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerImageView */.D, {
                ref: ref1,
                playable: !!(player === null || player === void 0 ? void 0 : player.duration)
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/core/native/privacy/index.ts
var privacy = __webpack_require__(7268);
;// CONCATENATED MODULE: ./src/components/organisms/item/ThumbnailFullScreenModal/index.tsx












/**
 * アイテムの全画面表示ビュワー
 */ var ThumbnailFullScreenModal = function(param) {
    var open = param.open, thumbnail = param.thumbnail, resource = param.resource, onClose = param.onClose, isFlipped = param.isFlipped, showMultipleImage = param.showMultipleImage, images = param.images, isDrm = param.isDrm;
    usePrivacyScreen(open);
    var t = (0,i18n/* useTranslation */.$G)("ownedItemDetail").t;
    if (showMultipleImage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
            onClose: onClose,
            open: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleImageFullScreenDisplayView, {
                    images: images,
                    onClose: onClose
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1.0, viewport-fit=cover, minimum-scale=1.0, maximum-scale=2.0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
                onClose: onClose,
                // NOTE: DRMの読み込みにrefを参照する必要があるため、モーダル内部のDOM要素は常に出力し、スタイルで表示を制御する
                sx: {
                    display: open ? "block" : "none"
                },
                open: isDrm ? true : open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: thumbnail || resource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFullScreenDisplayView, {
                        thumbnail: thumbnail,
                        resource: resource,
                        onClose: onClose,
                        open: open,
                        isFlipped: isFlipped
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        sx: {
                            textAlign: "center"
                        },
                        children: t("itemNotFound")
                    })
                })
            })
        ]
    });
};
var ImageFullScreenDisplayView = function(param) {
    var thumbnail = param.thumbnail, resource = param.resource, open = param.open, isFlipped = param.isFlipped, onClose = param.onClose;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        sx: {
            height: "100vh",
            bgcolor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "column",
            flex: 1,
            sx: {
                position: "absolute",
                top: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                left: 0,
                right: 0,
                bottom: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                height: "calc(100% - ".concat(styles/* styles.safeAreaTop */.W2.safeAreaTop, " - $").concat(styles/* styles.safeAreaBottom */.W2.safeAreaBottom, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: onClose,
                        bgcolor: "grey.50"
                    }),
                    sx: {
                        height: 0,
                        zIndex: 100
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    flex: 1,
                    height: "100%",
                    justifyContent: "center",
                    children: [
                        resource && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlayer, {
                            open: open,
                            resource: resource,
                            width: "100%",
                            height: "100%"
                        }),
                        thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        display: isFlipped ? "none" : "block"
                                    },
                                    children: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.front) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlayer, {
                                        open: open,
                                        resource: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.front,
                                        width: "100%",
                                        height: "100%"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        display: isFlipped ? "block" : "none"
                                    },
                                    children: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.back) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlayer, {
                                        open: open,
                                        resource: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.back,
                                        width: "100%",
                                        height: "100%"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var usePrivacyScreen = function(enable) {
    (0,react.useEffect)(function() {
        enable ? privacy/* enablePrivacyScreen */.a() : privacy/* disablePrivacyScreen */.G();
    });
};
var MultipleImageFullScreenDisplayView = function(param) {
    var images = param.images, onClose = param.onClose;
    var ref, ref1;
    var t = (0,i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref2 = (0,react.useState)(0), index = ref2[0], setIndex = ref2[1];
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            sx: {
                textAlign: "center"
            },
            children: t("itemNotFound")
        });
    }
    var ref3, _mediumUri;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                edge: "start",
                onClick: onClose,
                bgcolor: "grey.50"
            })
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            flex: 1,
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: (ref3 = (ref = images[index]) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref3 !== void 0 ? ref3 : "",
                            sx: {
                                width: "100%",
                                height: 375
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            width: "100%",
                            direction: "row",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            sx: {
                                px: 5,
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "caption",
                                    children: (ref1 = images[index]) === null || ref1 === void 0 ? void 0 : ref1.caption
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        bgcolor: "grey.900",
                                        borderRadius: "40px",
                                        p: "3px 6px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        color: "white",
                                        children: [
                                            index + 1,
                                            "/",
                                            images.length
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    flexWrap: "wrap",
                    sx: (0,_object_spread/* default */.Z)({
                        px: 5,
                        pb: 5,
                        overflowY: "auto"
                    }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        flexWrap: "nowrap",
                        overflow: "hidden",
                        spacing: 2,
                        children: images.map(function(img, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                onClick: function() {
                                    return setIndex(idx);
                                },
                                sx: {
                                    border: function(theme) {
                                        return index === idx ? "2px solid ".concat(theme.palette.primary.main) : "none";
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (_mediumUri = img.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : "",
                                    sx: {
                                        width: index === idx ? 38 : 40,
                                        height: index === idx ? 38 : 40
                                    }
                                })
                            });
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 27637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ LoadingWithBackdrop; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90838);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88546);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83587);





/**
 * @description
 * CircularProgress型共通ローディングアイコン
 * Storageにpng画像がない場合、materia-uiデフォルトのCircularProgressを表示する
 */ var Loading = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), fallback = ref[0], setFallback = ref[1];
    return fallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Fade, {
        sx: {
            display: "grid",
            placeItems: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Fade, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core__WEBPACK_IMPORTED_MODULE_4__/* .StorageImage */ .s, {
            src: "images/loading.png",
            height: 50,
            width: 50,
            alt: "loading",
            onError: function(e) {
                return setFallback(true);
            }
        })
    });
};
var LoadingWithBackdrop = function(param) {
    var open = param.open;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        open: open,
        sx: {
            display: "grid",
            placeItems: "center",
            height: "100%",
            width: "100%",
            maxWidth: 600,
            margin: "auto",
            zIndex: 1
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Loading, {})
    });
};


/***/ }),

/***/ 53302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ RequiredMembershipInfoBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95626);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93893);
/* harmony import */ var _core_membership_useSettingUserInfoModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91535);
/* harmony import */ var _core_native_storage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57782);











var RequiredMembershipInfoBox = function(param) {
    var visibleLink = param.visibleLink;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("personalInfoSettings").t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRegisterNewMembership = ref[0], setIsRegisterNewMembership = ref[1];
    var showModal = (0,_core_membership_useSettingUserInfoModal__WEBPACK_IMPORTED_MODULE_4__/* .useSettingUserInfoModal */ .C)().showModal;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), ref1 = ref1 !== null ? ref1 : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_core_native_storage__WEBPACK_IMPORTED_MODULE_8__/* .getRegisterNewMembership */ .bs)()
                        ];
                    case 1:
                        setIsRegisterNewMembership.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_9__/* .OrganismFrame */ .o, {
        sx: {
            p: 3,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "error.main"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                pb: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Info, {
                        sx: {
                            width: 16,
                            height: 16,
                            color: "error.main"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        variant: "subtitle2",
                        children: t("requireInfoTitle", "お客様情報の登録が必要です")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                variant: "caption",
                component: "p",
                children: t(isRegisterNewMembership ? "requireMembershipInfoDesc" : "requireInfoDesc")
            }),
            visibleLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                variant: "caption",
                onClick: function() {
                    return showModal();
                },
                width: "fit-content",
                sx: {
                    display: "block",
                    color: "primary.main",
                    cursor: "pointer"
                },
                pt: 1,
                children: t("enterYourInfo", "入力する")
            })
        ]
    });
};


/***/ }),

/***/ 49678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ PointDisplayPurchase; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43411);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61631);






var PointDisplayPurchase = function(param) {
    var point = param.point, onClick = param.onClick;
    var ref, ref1;
    var routerPages = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)().routerPages;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        alignItems: "center",
        justifyContent: "center",
        direction: "row",
        sx: {
            position: "relative",
            bgcolor: "grey.100",
            borderRadius: 3,
            height: 20,
            pl: 7,
            pr: ((ref = _config__WEBPACK_IMPORTED_MODULE_5__/* .config.modules.prepaidPoint */ .v.modules.prepaidPoint) === null || ref === void 0 ? void 0 : ref.chargeable) ? 7 : 4
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Point, {
                fontSize: "medium",
                sx: {
                    position: "absolute",
                    left: -2,
                    top: -2
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.EmphasizedNumber, {
                variant: "subtitle1",
                children: point
            }),
            !!((ref1 = _config__WEBPACK_IMPORTED_MODULE_5__/* .config.modules.prepaidPoint */ .v.modules.prepaidPoint) === null || ref1 === void 0 ? void 0 : ref1.chargeable) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Plus, {
                size: "small",
                href: routerPages.PrepaidPointCharge,
                onClick: function(event) {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                },
                color: "white",
                bgcolor: "primary.main",
                sx: {
                    width: 24,
                    height: 24,
                    position: "absolute",
                    right: 0,
                    svg: {
                        width: 15,
                        height: 15
                    }
                }
            })
        ]
    });
};


/***/ }),

/***/ 38877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ HtmlRenderer; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/lib/reactLinkify/index.tsx
var reactLinkify = __webpack_require__(86819);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ../../node_modules/@capacitor/inappbrowser/dist/plugin.mjs
var dist_plugin = __webpack_require__(46299);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/native/app/index.tsx + 35 modules
var app = __webpack_require__(76250);
// EXTERNAL MODULE: ./src/components/organisms/post/HtmlRenderer/useSafeHtml.ts
var useSafeHtml = __webpack_require__(85911);
;// CONCATENATED MODULE: ./src/components/organisms/post/HtmlRenderer/SafeHtml.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      mutation GeneratePartnerClientToken(\n        $input: GeneratePartnerClientTokenInput!\n      ) {\n        generatePartnerClientToken(input: $input) {\n          token\n          expiredAt\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var SafeHtml = function(param) {
    var text = param.text, enable = param.enable;
    /**
   * formのsubmitを外部ブラウザで開く際に許可するドメイン
   * ポスト内に入れるformタグのactionがこのドメインに含まれている場合に限り、formタグのsubmitをフックする。
   * - チケットぴあ
   */ var nativeHookAllowedDomains = [
        "ticket.pia.jp"
    ];
    var containerRef = (0,react.useRef)(null);
    var generateQueryPath = (0,useRouter/* useRouter */.tv)().generateQueryPath;
    var t = (0,i18n/* useTranslation */.$G)().t;
    var result = (0,useSafeHtml/* useSafeHtml */.Y)({
        text: text
    });
    /**
   * ネイティブアプリから外部ブラウザ経由でUDomにアクセスする際に、カスタムヘッダが付与できないため、
   * ワンタイムトークンを発行して付与する
   */ var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,lib/* gql */.Ps)(_templateObject())), 1), generatePartnerClientToken = ref[0];
    /**
   * ネイティブアプリの場合はポストにformタグを埋め込まれると、外部ドメインへのPOST処理が行えない。
   * そのため、ネイティブアプリの場合はformタグのsubmitをフックして、formのパラメータとともに外部ブラウザへGET処理を行う。
   */ (0,react.useEffect)(function() {
        if (result !== "safe") return;
        if (!(0,app/* isNativePlatform */.gx)()) return;
        var container = containerRef.current;
        if (!container) return;
        container.innerHTML = text;
        var forms = container.getElementsByTagName("form");
        if (!forms.length) return;
        var cleanupFuncs = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var form = _step.value;
                try {
                    var action = form.getAttribute("action");
                    if (!action) return "continue";
                    var url = new URL(action);
                    if (!nativeHookAllowedDomains.includes(url.hostname)) return "continue";
                    var submitHandler = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                            var formData, inputs, generatedToken, ref, data, query, to;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        formData = new FormData(form);
                                        inputs = Array.from(formData.entries()).map(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], value = _param[1];
                                            return {
                                                name: name,
                                                value: String(value)
                                            };
                                        });
                                        if (!(config/* config.partnerClientId */.v.partnerClientId && config/* config.partnerClientToken */.v.partnerClientToken)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            generatePartnerClientToken({
                                                variables: {
                                                    input: {
                                                        clientId: config/* config.partnerClientId */.v.partnerClientId,
                                                        clientToken: config/* config.partnerClientToken */.v.partnerClientToken
                                                    }
                                                }
                                            })
                                        ];
                                    case 1:
                                        data = _state.sent().data;
                                        generatedToken = data === null || data === void 0 ? void 0 : (ref = data.generatePartnerClientToken) === null || ref === void 0 ? void 0 : ref.token;
                                        _state.label = 2;
                                    case 2:
                                        query = (0,_object_spread/* default */.Z)({
                                            action: action,
                                            method: form.method || "post",
                                            inputs: JSON.stringify(inputs)
                                        }, generatedToken ? {
                                            clientId: config/* config.partnerClientId */.v.partnerClientId,
                                            token: generatedToken
                                        } : {});
                                        to = generateQueryPath("/htmlFormRelay", undefined, query);
                                        dist_plugin/* InAppBrowser.openInExternalBrowser */.is.openInExternalBrowser({
                                            url: "".concat(config/* config.domain */.v.domain).concat(to)
                                        }).catch(function(e) {
                                            // リトライするしか方法がないので、エラーメッセージは共通のものを使用
                                            throw new Error(t("otherErrorMessage"));
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function submitHandler(e) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    form.addEventListener("submit", submitHandler);
                    cleanupFuncs.push(function() {
                        return form.removeEventListener("submit", submitHandler);
                    });
                } catch (e) {
                    // 予期せぬエラーが発生してもコンテンツの閲覧はできるよう処理は継続する
                    return "continue";
                }
            };
            for(var _iterator = forms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            cleanupFuncs.forEach(function(f) {
                return f();
            });
        };
    }, [
        text
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            result === "safe" && (enable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: containerRef,
                dangerouslySetInnerHTML: {
                    __html: text
                }
            }) : null),
            result === "unsafe" && /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/post/HtmlRenderer/useSplitText.ts
/**
 * @description 文字列を指定されたタグで分割する
 * @param {string} inputText  分割対象の文字列
 * @param {keyof JSX.IntrisicElements} tagName HTMLのタグ名
 * @returns { {type: "html" | "string", text: string }[] } 分割後の配列 指定のHTML要素であればtype="html"、そうでないならtype="string"で示される
 */ var useSplitText = function(inputText, tagName) {
    var pattern = new RegExp("(<".concat(tagName, "[\\s\\S]*?<\\/").concat(tagName, ">)"), "gi");
    var splitStr = inputText.split(pattern);
    var result = splitStr.map(function(text) {
        return {
            type: text.match(new RegExp("^<".concat(tagName), "i")) ? "html" : "string",
            text: text
        };
    });
    return result;
};

;// CONCATENATED MODULE: ./src/components/organisms/post/HtmlRenderer/index.tsx





/**
 *
 * @param {string} text 埋め込むテキスト文字列
 * @param {boolean} enableEmbedHtml falseの場合、HTML判定された箇所は表示しない
 */ var HtmlRenderer = function(param) {
    var text = param.text, enableEmbedHtml = param.enableEmbedHtml, tagName = param.tagName;
    var textBlocks = useSplitText(text, tagName);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: textBlocks.map(function(block, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    block.type === "html" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml, {
                        enable: enableEmbedHtml,
                        text: block.text
                    }),
                    block.type === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                        children: block.text
                    })
                ]
            }, index);
        })
    });
};


/***/ }),

/***/ 85911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useSafeHtml; }
/* harmony export */ });
/* unused harmony export useIsValidElement */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27856);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



/**
 *
 * @description 特定の構造のformタグのみHTMLレンダーを許容するための判定機能
 */ var useSafeHtml = function(param) {
    var text = param.text;
    var checker = useIsValidElement();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), results = ref[0], setResults = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var clean = dompurify__WEBPACK_IMPORTED_MODULE_0___default().sanitize(text, {
            ALLOWED_TAGS: [
                "form",
                "input",
                "button"
            ],
            ALLOWED_ATTR: [
                "type",
                "value",
                "action",
                "method",
                "name"
            ],
            RETURN_DOM: true
        });
        // sanitize後、取り除かれた要素が2つ以上の場合、optionで許容したタグ・属性以外のものが含まれていたと判断し、unsafeとする
        // ※必ずbodyタグが取り除かれるため、1つは許容する
        if ((dompurify__WEBPACK_IMPORTED_MODULE_0___default().removed.length) > 1) {
            setResults([
                {
                    result: "unsafe",
                    error: new Error("two or more elements removed")
                }, 
            ]);
            return;
        }
        // さらに、取り除かれた要素が1つかつその要素がbodyでなかった場合にもunsafeとする
        if ((dompurify__WEBPACK_IMPORTED_MODULE_0___default().removed.length) === 1 && (dompurify__WEBPACK_IMPORTED_MODULE_0___default().removed[0].element.nodeName) !== "BODY") {
            setResults([
                {
                    result: "unsafe",
                    error: new Error('removed element was not "body"')
                }, 
            ]);
            return;
        }
        // 最上位がFormタグのみかをチェックする
        var topLevelNodes = clean.childNodes;
        topLevelNodes.forEach(function(node) {
            if (node.nodeType !== Node.ELEMENT_NODE) {
                setResults([
                    {
                        result: "unsafe",
                        error: new Error("unexpected element")
                    }, 
                ]);
                return;
            }
            // NOTE HTML要素である前提で進める
            var element = node;
            if (element.tagName !== "FORM") {
                setResults([
                    {
                        result: "unsafe",
                        error: new Error("unexpected element")
                    }, 
                ]);
            }
        });
        // Sanitize後のDOMの各要素に対して、適切な属性のみ持っているかの検査を行う
        var elements = clean.querySelectorAll("*");
        elements.forEach(function(node) {
            switch(node.tagName){
                case "FORM":
                    setResults(function(prev) {
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat([
                            checker.isValidForm(node)
                        ]);
                    });
                    break;
                case "INPUT":
                    setResults(function(prev) {
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat([
                            checker.isValidInput(node)
                        ]);
                    });
                    break;
                case "BUTTON":
                    setResults(function(prev) {
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat([
                            checker.isValidButton(node)
                        ]);
                    });
                    break;
                default:
                    setResults(function(prev) {
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat([
                            {
                                result: "unsafe",
                                error: new Error("unexpected element")
                            }, 
                        ]);
                    });
                    break;
            }
        });
    }, []);
    // NOTE 以上の判定を経て、一つでも条件に一致しない箇所があればunsafeとして判定する
    return (results === null || results === void 0 ? void 0 : results.some(function(r) {
        return r.result === "unsafe";
    })) ? "unsafe" : "safe";
};
var useIsValidElement = function() {
    var isValidForm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(element) {
        if (element.hasAttribute("type")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have type"))
            };
        }
        if (element.hasAttribute("value")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have value"))
            };
        }
        if (element.hasAttribute("name")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have name"))
            };
        }
        if (!element.hasAttribute("action")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must have action"))
            };
        }
        var childNodes = element.childNodes;
        if (childNodes.length === 0) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have childNode"))
            };
        }
        // Form内部の要素が、1つ以上のinputと1つのbuttonと0つ以上のTextNodeのみであることを確認する
        var hasNonInputOrNonButtonOrNonTextNode = Array.from(childNodes).some(function(node) {
            switch(node.nodeType){
                case Node.TEXT_NODE:
                    return false;
                case Node.ELEMENT_NODE:
                    {
                        var elm = node;
                        return elm.tagName !== "INPUT" && elm.tagName !== "BUTTON";
                    }
                default:
                    return true;
            }
        });
        if (hasNonInputOrNonButtonOrNonTextNode) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have non button or non input element"))
            };
        }
        // NOTE buttonが2つ以上あることを許容しない
        var hasMultipleButtons = Array.from(childNodes).filter(function(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }).filter(function(node) {
            var elm = node;
            return elm.tagName === "BUTTON";
        }).length > 1;
        if (hasMultipleButtons) return {
            result: "unsafe",
            error: new Error("".concat(element.nodeName, " must not have two or more buttons"))
        };
        return {
            result: "safe"
        };
    }, []);
    var isValidInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(element) {
        if (!element.hasAttribute("type") || element.getAttribute("type") !== "hidden" && element.getAttribute("type") !== "submit") {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must have type, and that must be 'hidden' or 'submit'"))
            };
        }
        if (!element.hasAttribute("value")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must have value"))
            };
        }
        if (element.hasAttribute("action")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have action"))
            };
        }
        var childNodes = element.childNodes;
        if (childNodes.length > 0) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have childNode"))
            };
        }
        return {
            result: "safe"
        };
    }, []);
    var isValidButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(element) {
        if (!element.hasAttribute("type") || element.getAttribute("type") !== "submit") {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must have type, and that must be 'submit'"))
            };
        }
        if (element.hasAttribute("value")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have value"))
            };
        }
        if (element.hasAttribute("action")) {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must not have action"))
            };
        }
        var childNodes = element.childNodes;
        if (!childNodes || childNodes.length === 0 || childNodes.length > 1 || childNodes[0].nodeName !== "#text") {
            return {
                result: "unsafe",
                error: new Error("".concat(element.nodeName, " must have just one childNode, and that must be a text node"))
            };
        }
        return {
            result: "safe"
        };
    }, []);
    return {
        isValidForm: isValidForm,
        isValidInput: isValidInput,
        isValidButton: isValidButton
    };
};


/***/ }),

/***/ 97678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ThumbnailImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);




var ThumbnailImage = function(param) {
    var src = param.src, alt = param.alt, _withBorderRadius = param.withBorderRadius, withBorderRadius = _withBorderRadius === void 0 ? false : _withBorderRadius, _positionAbsolute = param.positionAbsolute, positionAbsolute = _positionAbsolute === void 0 ? false : _positionAbsolute;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Image, {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            width: "100%",
            height: "100%",
            borderRadius: withBorderRadius ? "8px" : "inherit",
            objectFit: "cover"
        }, positionAbsolute && {
            position: "absolute"
        }),
        alt: alt,
        src: src
    });
};


/***/ }),

/***/ 44545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ReplyForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68074);
/* harmony import */ var _components_organisms_imageEditor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22019);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30226);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95626);
/* harmony import */ var _core_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38679);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93893);
/* harmony import */ var _core_form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35625);
/* harmony import */ var _lib_privateAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14514);















var schema = function(o) {
    return {
        content: o.string().max(200),
        resources: o.array().items(o.object({
            tmpPath: o.string().allow("").optional()
        })).allow(null).optional()
    };
};
var schemaExclusiveMode = function(o) {
    return {
        content: o.when("resources", {
            is: null,
            then: o.string().max(200).required(),
            otherwise: o.string().valid("").max(0)
        }),
        resources: o.array().items(o.object({
            tmpPath: o.string().allow("").optional()
        })).allow(null).optional()
    };
};
var defaultValues = {
    content: "",
    resources: null
};
var ReplyForm = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var visibleImage = param.visibleImage, onReply = param.onReply, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, userId = param.userId, replyToDisplayName = param.replyToDisplayName, onRemoveReplyToReply = param.onRemoveReplyToReply, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "600px" : _maxWidth, _isConsole = param.isConsole, isConsole = _isConsole === void 0 ? false : _isConsole, _singleInputMode = param.singleInputMode, singleInputMode = _singleInputMode === void 0 ? false : _singleInputMode;
    var _$ref;
    var showError = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useMessage */ .UD)().showError;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("postDetail").t;
    var _$ref1 = (0,_lib_privateAction__WEBPACK_IMPORTED_MODULE_5__/* .usePrivateAction */ .r)(), isLoggedIn = _$ref1.isLoggedIn, handleLoginModal = _$ref1.handleLoginModal;
    var formAreaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var _$ref2 = (0,_core_form__WEBPACK_IMPORTED_MODULE_6__/* .useForm */ .cI)({
        schema: singleInputMode ? schemaExclusiveMode : schema,
        defaultValues: defaultValues
    }), handleSubmit = _$ref2.handleSubmit, register = _$ref2.register, reset = _$ref2.reset, watch = _$ref2.watch, setValue = _$ref2.setValue, _formState = _$ref2.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, touchedFields = _formState.touchedFields, dirtyFields = _formState.dirtyFields, setFocus = _$ref2.setFocus, setError = _$ref2.setError;
    var watchContent = watch("content");
    var color = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!isLoggedIn) {
            return "primary";
        }
        return !isValid || isSubmitting ? "inherit" : "primary";
    }, [
        isLoggedIn,
        isValid,
        isSubmitting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            focus: function focus() {
                setFocus("content");
            }
        };
    });
    var _$ref3 = (0,_components_organisms_imageEditor__WEBPACK_IMPORTED_MODULE_7__/* .useImageEditor */ .O)({
        userId: userId,
        callback: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
                var tmpPath;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    tmpPath = param.tmpPath;
                    setValue("resources", [
                        {
                            tmpPath: tmpPath
                        }
                    ], {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }), ImageEditModal = _$ref3.ImageEditModal, ModalProps = _$ref3.ModalProps, handleChoseFile = _$ref3.handleChoseFile, handleRemoveFile = _$ref3.handleRemoveFile, filePathAfterCrop = _$ref3.filePathAfterCrop;
    // 画像未選択、もしくは単一入力モード時にコメントが入力されていない場合は画像選択可能
    var canChooseImage = !filePathAfterCrop || singleInputMode && watchContent.length !== 0;
    // 通常モード、もしくは単一入力モード時に画像が選択されていない場合はコメント編集可能
    var canEditComment = !singleInputMode || !filePathAfterCrop;
    //Handle resizing the height of the footer input
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var observer = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    var node = document.getElementById("bottomMargin");
                    if (node === null || node === void 0 ? void 0 : node.style) {
                        var _height;
                        node.style.height = "calc(".concat((_height = entry.contentRect.height) !== null && _height !== void 0 ? _height : 0, "px + ").concat(_components_styles__WEBPACK_IMPORTED_MODULE_10__/* .styles.safeAreaBottom */ .W2.safeAreaBottom, ")");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        if (formAreaRef.current) {
            observer.observe(formAreaRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, []);
    var onSubmit = handleSubmit(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(values) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onReply(values).then(function() {
                                reset();
                                handleRemoveFile();
                            }).catch(function(error) {
                                return (0,_core_form__WEBPACK_IMPORTED_MODULE_6__/* .handleError */ .S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_11__/* .OrganismFrame */ .o, {
        sx: {
            bgcolor: "grey.50",
            maxWidth: maxWidth,
            margin: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts__WEBPACK_IMPORTED_MODULE_12__/* .BottomSafeArea */ .p, {
                sx: {
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    ref: formAreaRef,
                    children: [
                        !!replyToDisplayName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            flex: 1,
                            direction: "row",
                            sx: {
                                bgcolor: "grey.100",
                                px: 4,
                                minHeight: 28
                            },
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("reply")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    flex: 1,
                                    sx: {
                                        minWidth: 0
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: "overline",
                                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_10__/* .styleSets.lineCamp */ .k$.lineCamp(1)),
                                        children: replyToDisplayName
                                    })
                                }),
                                onRemoveReplyToReply && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Close, {
                                    size: "xSmall",
                                    onClick: onRemoveReplyToReply,
                                    sx: {
                                        mr: -2
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_form__WEBPACK_IMPORTED_MODULE_17__/* .Form */ .l, {
                            onSubmit: onSubmit,
                            sx: {
                                bgcolor: "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 4,
                                    sx: {
                                        px: 5,
                                        overflowX: "auto"
                                    },
                                    children: filePathAfterCrop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        sx: {
                                            position: "relative",
                                            pt: 4,
                                            pb: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                variant: "square",
                                                src: filePathAfterCrop,
                                                sx: {
                                                    width: 56,
                                                    height: 56,
                                                    borderRadius: 2,
                                                    img: {
                                                        objectFit: "contain"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Close, {
                                                size: "xSmall",
                                                bgcolor: "grey.100",
                                                sx: {
                                                    position: "absolute",
                                                    top: 4,
                                                    right: -12
                                                },
                                                onClick: handleRemoveFile
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    sx: {
                                        pr: 4,
                                        pl: !visibleImage || filePathAfterCrop ? 4 : "52px"
                                    },
                                    children: (touchedFields.content || dirtyFields.content || errors.content) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: "overline",
                                        sx: {
                                            pt: 2,
                                            color: ((_$ref = errors.content) === null || _$ref === void 0 ? void 0 : _$ref.message) ? "error.main" : "text.secondary"
                                        },
                                        children: [
                                            watchContent.length,
                                            "/200"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    direction: "row",
                                    flex: 1,
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    sx: {
                                        pl: visibleImage ? 2 : 4,
                                        pb: 1,
                                        pr: 2
                                    },
                                    children: [
                                        visibleImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Image, {
                                            onClick: handleChoseFile,
                                            size: "medium",
                                            color: canChooseImage ? "default" : "inherit",
                                            disabled: !canChooseImage
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextInputCell, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                            type: "text",
                                            error: errors === null || errors === void 0 ? void 0 : errors.content
                                        }, register("content")), {
                                            textFieldProps: {
                                                sx: {
                                                    p: 0,
                                                    pb: 2,
                                                    m: 0,
                                                    bgcolor: "transparent",
                                                    width: "100%"
                                                },
                                                multiline: true,
                                                minRows: 1,
                                                autoFocus: autoFocus,
                                                maxRows: 5,
                                                variant: "standard",
                                                helperText: "",
                                                InputProps: {
                                                    sx: {
                                                        border: "none",
                                                        px: 0,
                                                        pt: 0,
                                                        bgcolor: "grey.50",
                                                        "& textarea": {
                                                            cursor: canEditComment ? "auto" : "default"
                                                        }
                                                    },
                                                    disableUnderline: true,
                                                    readOnly: !canEditComment
                                                }
                                            }
                                        })),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Send, {
                                            type: "submit",
                                            size: "medium",
                                            onClick: handleLoginModal(),
                                            disabled: isLoggedIn ? !isValid || isSubmitting : false,
                                            color: color
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageEditModal, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                isConsole: isConsole
            }, ModalProps))
        ]
    });
});
var TextInputCell = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("postDetail").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_11__/* .CellFrame */ .p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.TextInputField, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});


/***/ }),

/***/ 69482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SwipeBackdrop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88546);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66517);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95626);









var SwipeBackdrop = function(props) {
    var open = props.open, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "open"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        open: open,
        sx: {
            zIndex: 2000,
            pointerEvents: "none"
        }
    }, otherProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackdropContent, {
            direction: otherProps.direction
        })
    }));
};
var BackdropContent = function(param) {
    var direction = param.direction;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common").t;
    var Icon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (direction === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__/* .MagazinePageDirection.Right */ .md6.Right) {
            return utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Prev;
        }
        if (direction === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__/* .MagazinePageDirection.Left */ .md6.Left) {
            return utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Next;
        }
        return utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.DownArrow;
    }, [
        direction
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            margin: "auto",
            marginTop: "250px",
            height: "200px",
            width: "200px",
            backgroundColor: "background.default",
            opacity: 0.6,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            sx: {
                height: "40px"
            },
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    sx: {
                        width: 64,
                        height: 64,
                        color: "grey.900"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    variant: "h2",
                    sx: {
                        textAlign: "center",
                        color: "grey.900",
                        fontSize: 16,
                        fontWeight: "600"
                    },
                    children: direction === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_8__/* .MagazinePageDirection.Vertical */ .md6.Vertical ? t("verticalSwipe") : t("horizontalSwipe")
                })
            ]
        })
    });
};


/***/ }),

/***/ 27186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SoundPlayerControl; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41587);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79312);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);



var SoundPlayerControl = function(param) {
    var isPlaying = param.isPlaying, duration = param.duration, sliderValue = param.sliderValue, onPlay = param.onPlay, onPause = param.onPause, onRewind = param.onRewind, onForward = param.onForward, onChange = param.onChange, onChangeCommitted = param.onChangeCommitted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            display: "grid",
            placeItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                min: 0,
                max: duration,
                defaultValue: 0,
                value: sliderValue,
                onChange: onChange,
                onChangeCommitted: onChangeCommitted
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                direction: "row",
                sx: {
                    width: 1,
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: secondToMmss(sliderValue)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: Number.isFinite(duration) && secondToMmss(Math.floor(duration) - Math.floor(sliderValue))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                spacing: 4,
                direction: "row",
                sx: {
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.AudioRewind, {
                        onClick: onRewind
                    }),
                    isPlaying ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.AudioPause, {
                        onClick: onPause
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.AudioPlay, {
                        onClick: onPlay
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.AudioForward, {
                        onClick: onForward
                    })
                ]
            })
        ]
    });
};
var secondToMmss = function(second) {
    return [
        Math.floor(second / 60),
        Math.floor(second % 60)
    ].map(function(timeNum) {
        return String(timeNum).padStart(2, "0");
    }).join(":");
};


/***/ }),

/***/ 72819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ SoundPurePlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80960);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95626);
/* harmony import */ var _core_resources__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47536);
/* harmony import */ var _SoundPlayerControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27186);








var SoundPurePlayer = function(param) {
    var uri = param.uri, autoplay = param.autoplay;
    var ref = (0,_core_resources__WEBPACK_IMPORTED_MODULE_4__/* .useSoundPlayer */ .u)(uri), isUriUnavailable = ref.isUriUnavailable, player = ref.player, playing = ref.playing, duration = ref.duration, sliderValue = ref.sliderValue, handleDuration = ref.handleDuration, handleProgress = ref.handleProgress, change = ref.change, commitChange = ref.commitChange, rewind = ref.rewind, end = ref.end, play = ref.play, pause = ref.pause, forward = ref.forward, handleError = ref.handleError;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("postDetail").t;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!(player && player.current)) return;
        autoplay ? play() : pause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        player,
        autoplay
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                isUriUnavailable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    sx: {
                        zIndex: 1,
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "grid",
                        placeItems: "center",
                        userSelect: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        spacing: 2,
                        alignItems: "center",
                        sx: {
                            color: "white"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                spacing: 1,
                                direction: "row",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__.Icons.Error, {
                                        fontSize: "medium"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        color: "grey.300",
                                        children: t("resourceError")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "caption",
                                color: "grey.300",
                                children: t("resourceErrorDetail")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    url: uri,
                    ref: player,
                    playing: playing,
                    onDuration: handleDuration,
                    onProgress: handleProgress,
                    onEnded: end,
                    onError: handleError,
                    progressInterval: 100,
                    style: {
                        display: "none"
                    },
                    config: {
                        file: {
                            forceAudio: true,
                            attributes: {
                                controlsList: "nodownload"
                            }
                        }
                    }
                }),
                player && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SoundPlayerControl__WEBPACK_IMPORTED_MODULE_9__/* .SoundPlayerControl */ .Q, {
                    isPlaying: playing,
                    duration: duration,
                    onChange: change,
                    onChangeCommitted: commitChange,
                    sliderValue: sliderValue,
                    onPlay: play,
                    onPause: pause,
                    onRewind: rewind,
                    onForward: forward
                })
            ]
        })
    });
};


/***/ }),

/***/ 78811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TheoPlayerImageView; },
/* harmony export */   "m": function() { return /* binding */ TheoPlayerView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12363);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90860);






/**
 * @description
 * THEOPlayerの再生UI
 * https://docs.theoplayer.com/getting-started/01-sdks/01-web/00-getting-started.md#theoplayer-css-library
 *
 * @param {boolean} chromeless 再生UIを表示しない場合はtrue
 */ var TheoPlayerView = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var _chromeless = param.chromeless, chromeless = _chromeless === void 0 ? false : _chromeless, _type = param.type, type = _type === void 0 ? "audio" : _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !chromeless && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .config.theoPlayerLibraryLocation */ .v.theoPlayerLibraryLocation, "/ui.css")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: chromeless ? "" : "theoplayer-container video-js theoplayer-skin vjs-16-9 THEOplayer",
                ref: ref,
                sx: chromeless ? {
                    /**
                   * HACK: display: noneとするとSafariでの再生に失敗するため、CSSで非表示に見せている。
                   * また、透明度・サイズを設定しないと遷移時に画面キャプチャイベントが発火しないため、要素は完全に非表示にしていない。
                   */ padding: 0,
                    height: type === "video" ? "100%" : "1px",
                    width: type === "video" ? "100%" : "1px",
                    opacity: type === "video" ? 1 : 0.01,
                    bgcolor: type === "video" ? "inherit" : "background.default",
                    userSelect: "none",
                    "& > *": {
                        visibility: "visible",
                        pointerEvents: "none"
                    }
                } : {}
            })
        ]
    });
});
// 動画を1枚の画像として表示する
var TheoPlayerImageView = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var playable = param.playable, isMagazine = param.isMagazine;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .config.theoPlayerLibraryLocation */ .v.theoPlayerLibraryLocation, "/ui.css")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_3__.Fade, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    sx: {
                        display: "grid",
                        placeItems: "center",
                        // DRMマガジンの場合、シークバー分の高さを引く
                        height: isMagazine ? "calc(100dvh - 48px)" : "100dvh"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        ref: ref,
                        sx: {
                            width: "100%",
                            height: "auto",
                            userSelect: "none",
                            ".theo-player-wrapper": {
                                "& > *:not(.vjs-tech, .vjs-loading-spinner)": {
                                    display: "none!important"
                                },
                                ".vjs-tech": {
                                    position: "relative!important",
                                    "& > *:not(video)": {
                                        display: "none"
                                    },
                                    video: {
                                        display: playable ? "block" : "none!important"
                                    }
                                }
                            }
                        }
                    })
                })
            })
        ]
    });
});


/***/ }),

/***/ 92238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ StoreItemArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45150);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74020);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16881);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28879);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1246);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73727);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66517);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61631);
/* harmony import */ var _core_native__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76250);
/* harmony import */ var _lib_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34814);














var Size;
(function(Size) {
    Size["SMALL"] = "small";
    Size["MEDIUM"] = "medium";
})(Size || (Size = {}));
var Orientation;
(function(Orientation) {
    Orientation["VERTICAL"] = "vertical";
    Orientation["HORIZONTAL"] = "horizontal";
})(Orientation || (Orientation = {}));
var StoreItemArea = function(param) {
    var canGoBack = param.canGoBack, artistId = param.artistId, item = param.item, _size = param.size, size = _size === void 0 ? Size.MEDIUM : _size, _orientation = param.orientation, orientation = _orientation === void 0 ? Orientation.VERTICAL : _orientation, _trackView = param.trackView, trackView = _trackView === void 0 ? false : _trackView, onClick = param.onClick, collectionTitle = param.collectionTitle, eventId = param.eventId, collectionId = param.collectionId, showMenberOnlyIcon = param.showMenberOnlyIcon, responsive = param.responsive, aspectRatio = param.aspectRatio;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("artistStore").t;
    var ref11 = (0,_core__WEBPACK_IMPORTED_MODULE_7__/* .useRouter */ .tv)(), generatePath = ref11.generatePath, routerPages = ref11.routerPages;
    var analytics = (0,_lib_analytics__WEBPACK_IMPORTED_MODULE_8__/* .useAnalytics */ .z$)().analytics;
    var smUp = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("sm");
    });
    var mdUp = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    // アイテムの値段表記
    var formattedPrice = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var _Math;
        // SKUがなければ、そのままフォーマットして返す
        if (!item.skuSettings) return numeral__WEBPACK_IMPORTED_MODULE_3___default()(item.price).format("0,0");
        var _price;
        // SKUがある場合、最小の値段をフォーマットして返す
        var prices = item.skuSettings.units.map(function(unit) {
            return (_price = unit.price) !== null && _price !== void 0 ? _price : 0;
        });
        var isAllSame = prices.every(function(price) {
            return price === prices[0];
        });
        if (isAllSame) return numeral__WEBPACK_IMPORTED_MODULE_3___default()(prices[0] ? prices[0] : item.price).format("0,0");
        var minPrice = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(prices));
        return "".concat(numeral__WEBPACK_IMPORTED_MODULE_3___default()(minPrice).format("0,0"), "〜");
    }, [
        item
    ]);
    var isNft = !!(item === null || item === void 0 ? void 0 : (ref = item.nft) === null || ref === void 0 ? void 0 : ref.chains);
    var _pendingPurchaseNumber;
    var remainingNumber = typeof item.issuedNumber === "number" ? item.issuedNumber - item.purchasedNumber - ((_pendingPurchaseNumber = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0) : null;
    var nftIconSize = {
        small: "small",
        medium: "large"
    };
    var itemIconSize = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var size = responsive ? mdUp ? "medium" : smUp ? "small" : "xSmall" : "xSmall";
        return size;
    }, [
        smUp,
        mdUp,
        responsive
    ]);
    var itemIcon = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        switch(item === null || item === void 0 ? void 0 : item.type){
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Audio */ .qGq.Audio:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Audio, {
                    fontSize: itemIconSize
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Video */ .qGq.Video:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Video, {
                    fontSize: itemIconSize
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Magazine */ .qGq.Magazine:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Magazine, {
                    fontSize: itemIconSize
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Merch */ .qGq.Merch:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Merch, {
                    fontSize: itemIconSize
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Wallpaper */ .qGq.Wallpaper:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Wallpaper, {
                    fontSize: itemIconSize
                });
            case _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Ticket */ .qGq.Ticket:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Ticket, {
                    fontSize: itemIconSize
                });
            default:
                return null;
        }
    }, [
        item === null || item === void 0 ? void 0 : item.type,
        itemIconSize
    ]);
    var isResaleAvailable = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        //リセールを許可していないもの
        if (!item.resaleEnabled) {
            return false;
        }
        //非限定アイテムであるもの
        var issuedNumber = Number(item.issuedNumber) || null;
        if (issuedNumber === null) {
            return false;
        }
        //リセールを許可しているが、完売していないもの
        var purchasedNumber = Number(item.purchasedNumber) || 0;
        var pendingPurchaseNumber = Number(item.pendingPurchaseNumber) || 0;
        if (issuedNumber > purchasedNumber + pendingPurchaseNumber) {
            return false;
        }
        // リセールを許可しており、完売しているが、リセール期間中でないもの
        var now = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().unix();
        var startedAt = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(item, "metadata.ticket.resalePeriod.startedAt._seconds");
        var endedAt = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(item, "metadata.ticket.resalePeriod.endedAt._seconds");
        if (!startedAt || !endedAt || dayjs__WEBPACK_IMPORTED_MODULE_1___default()(startedAt * 1000).unix() > now || dayjs__WEBPACK_IMPORTED_MODULE_1___default()(endedAt * 1000).unix() < now) {
            return false;
        }
        return true;
    }, [
        item
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var ref;
        if (!item || !trackView) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item", {
            currency: "JPY",
            value: item.price,
            items: [
                {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: _core_native__WEBPACK_IMPORTED_MODULE_12__/* .getPlatform */ .Xf(),
                    item_category4: 1,
                    item_category5: (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                    price: item.price
                }, 
            ]
        });
    }, [
        item,
        analytics
    ]);
    var _id, ref12, ref13, _paymentType;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        elevation: 0,
        sx: {
            bgcolor: "unset",
            mb: size === Size.MEDIUM ? 4 : 0,
            borderRadius: 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            component: react_router_dom__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .rU,
            onClick: onClick,
            to: {
                pathname: generatePath(routerPages.ArtistStoreItemDetail, {
                    artistId: artistId,
                    itemId: (_id = item.id) !== null && _id !== void 0 ? _id : "#"
                }),
                state: {
                    canGoBack: true
                }
            },
            sx: responsive ? {
                width: size === Size.MEDIUM ? "100%" : {
                    xs: 80,
                    md: 108
                }
            } : {
                maxWidth: size === Size.MEDIUM ? 108 : 80
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    alignItems: "center",
                    sx: {
                        position: "relative"
                    },
                    children: [
                        isNft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.Nft, {
                            fontSize: nftIconSize[size],
                            filledColor: true,
                            sx: {
                                position: "absolute",
                                right: 0,
                                bottom: 4,
                                zIndex: 1
                            }
                        }),
                        isResaleAvailable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            sx: {
                                position: "absolute",
                                inset: "1px auto auto 0",
                                py: "2px",
                                px: 1,
                                zIndex: 1,
                                bgcolor: "rgba(0, 0, 0, 0.8)"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                component: "p",
                                variant: "overline",
                                color: "white",
                                children: t("resale")
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.StoreItemImageArea, {
                            responsive: responsive,
                            aspectRatio: aspectRatio,
                            src: (ref13 = (ref12 = (ref1 = item.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref12 !== void 0 ? ref12 : (ref2 = item.thumbnail.front) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref13 !== void 0 ? ref13 : "",
                            size: size
                        }),
                        size === Size.MEDIUM && (((item === null || item === void 0 ? void 0 : item.isDownloadable) || ((ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.wallpaper) === null || ref4 === void 0 ? void 0 : ref4.isPrintEnabled)) && item.type === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .ItemType.Wallpaper */ .qGq.Wallpaper ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            direction: "row",
                            spacing: "2px",
                            sx: {
                                position: "absolute",
                                top: "6px",
                                left: "6px",
                                zIndex: 1,
                                bgcolor: "grey.50",
                                borderRadius: 100,
                                height: responsive ? {
                                    xs: "20px",
                                    sm: "28px",
                                    md: "32px"
                                } : "20px",
                                width: responsive ? (item === null || item === void 0 ? void 0 : item.isDownloadable) && ((ref5 = item.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.wallpaper) === null || ref6 === void 0 ? void 0 : ref6.isPrintEnabled) ? {
                                    xs: "42px",
                                    sm: "50px",
                                    md: "58px"
                                } : {
                                    xs: "20px",
                                    sm: "28px",
                                    md: "32px"
                                } : (item === null || item === void 0 ? void 0 : item.isDownloadable) && ((ref7 = item.metadata) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.wallpaper) === null || ref8 === void 0 ? void 0 : ref8.isPrintEnabled) ? 42 : 20,
                                p: 1
                            },
                            alignItems: "center",
                            justifyContent: "center",
                            children: [
                                (item === null || item === void 0 ? void 0 : item.isDownloadable) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.WallpaperDownload, {
                                    sx: {
                                        color: "grey.700"
                                    },
                                    fontSize: itemIconSize
                                }),
                                ((ref9 = item.metadata) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.wallpaper) === null || ref10 === void 0 ? void 0 : ref10.isPrintEnabled) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.WallpaperPrinter, {
                                    sx: {
                                        color: "grey.700"
                                    },
                                    fontSize: itemIconSize
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            sx: {
                                borderRadius: "100%",
                                bgcolor: "grey.50",
                                width: responsive ? {
                                    xs: "20px",
                                    sm: "28px",
                                    md: "32px"
                                } : "20px",
                                height: responsive ? {
                                    xs: "20px",
                                    sm: "28px",
                                    md: "32px"
                                } : "20px",
                                position: "absolute",
                                top: "6px",
                                left: "6px",
                                zIndex: 1,
                                display: "grid",
                                placeItems: "center"
                            },
                            children: itemIcon
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        pt: size === Size.MEDIUM ? 2 : 0,
                        px: 0,
                        pb: 0
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        spacing: 1,
                        children: [
                            !!collectionTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: "overline",
                                color: "text.secondary",
                                sx: _components_styles__WEBPACK_IMPORTED_MODULE_20__/* .styleSets.lineCamp */ .k$.lineCamp(2),
                                children: collectionTitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    size === Size.MEDIUM && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        variant: "subtitle2",
                                        sx: _components_styles__WEBPACK_IMPORTED_MODULE_20__/* .styleSets.lineCamp */ .k$.lineCamp(2),
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        flexGrow: 1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        direction: "row",
                                        spacing: 1,
                                        children: showMenberOnlyIcon && item.isPremium && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.Icons.MembersOnly, {
                                            fontSize: "small",
                                            sx: {
                                                color: "primary.main",
                                                height: responsive ? {
                                                    xs: 12,
                                                    sm: 18,
                                                    md: 24
                                                } : 12,
                                                width: responsive ? {
                                                    xs: 12,
                                                    sm: 18,
                                                    md: 24
                                                } : 12,
                                                ml: 1
                                            }
                                        })
                                    })
                                ]
                            }),
                            item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_5__.PointDisplay, {
                                point: formattedPrice,
                                size: size,
                                paymentType: (_paymentType = item.paymentType) !== null && _paymentType !== void 0 ? _paymentType : "prepaid_point"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: "overline",
                                color: "primary",
                                sx: {
                                    pt: size === Size.SMALL ? "5px" : 0
                                },
                                children: t("free", "無料")
                            }),
                            size === Size.MEDIUM && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                direction: "row",
                                spacing: 1,
                                sx: {
                                    height: 16
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SalesStatusCell, {
                                    item: item,
                                    remainingNumber: remainingNumber
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
// アイテムの在庫状況を表示する
var SalesStatusCell = function(param) {
    var item = param.item, remainingNumber = param.remainingNumber;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("artistStore").t;
    if (item.salesStatus === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .SalesStatus.Stopped */ .Qsp.Stopped) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            variant: "caption",
            color: "text.secondary",
            children: t("stopped", "販売停止")
        });
    }
    if (item.salesCondition === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .SalesCondition.Before */ .HrV.Before) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            variant: "caption",
            color: "text.secondary",
            children: t("beforeSelling", "販売開始前")
        });
    }
    if (item.salesCondition === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_11__/* .SalesCondition.End */ .HrV.End) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            variant: "caption",
            color: "text.secondary",
            children: t("endSelling", "販売終了")
        });
    }
    if (!!item.issuedNumber && remainingNumber === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            variant: "caption",
            color: "error.main",
            children: t("soldout")
        });
    }
    if (!item.hideSalesNumber && item.issuedNumber && !!remainingNumber) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("remaining", "残り")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    variant: "caption",
                    sx: {
                        color: remainingNumber > 9 ? "text.primary" : "error.main"
                    },
                    children: "".concat(remainingNumber, "/").concat(item.issuedNumber || 0)
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 12683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ StoreItemAreaSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31117);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43411);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);



var Size;
(function(Size) {
    Size["SMALL"] = "small";
    Size["DEFAULT"] = "default";
})(Size || (Size = {}));
var Orientation;
(function(Orientation) {
    Orientation["VERTICAL"] = "vertical";
    Orientation["HORIZONTAL"] = "horizontal";
})(Orientation || (Orientation = {}));
var StoreItemAreaSkeleton = function(param) {
    var _size = param.size, size = _size === void 0 ? Size.DEFAULT : _size, _orientation = param.orientation, orientation = _orientation === void 0 ? Orientation.VERTICAL : _orientation, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var width = responsive ? "100%" : size === Size.SMALL ? 60 : 104;
    if (size === Size.SMALL) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            variant: "rectangular",
            sx: {
                width: width,
                height: 96
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "rectangular",
                sx: {
                    width: width,
                    height: 166
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                variant: "small",
                width: "50%"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                variant: "small",
                width: "30%"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.SkeletonText, {
                variant: "medium",
                width: "50%"
            })
        ]
    });
};


/***/ }),

/***/ 77277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TradeDetailBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16881);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56961);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18951);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81714);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66517);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80042);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61631);








var TradeDetailBox = function(param) {
    var trade = param.trade, disableClick = param.disableClick, hiddenDivider = param.hiddenDivider, myUserId = param.myUserId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("myTradeDetail").t;
    var ref37 = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)(), routerPages = ref37.routerPages, generatePath = ref37.generatePath;
    /**
   * 自分が関連するトレードかどうか
   */ var isMyTrade = myUserId === ((ref = trade.request.requestedByUser) === null || ref === void 0 ? void 0 : ref.id) || myUserId === ((ref1 = trade.candidates) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.id);
    var _requestedByUser, ref38, ref39, ref40, ref41, ref42, ref43;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                elevation: 0,
                sx: {
                    position: "relative",
                    bgcolor: "background.default"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    sx: {
                        px: 5,
                        py: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "row",
                            flex: 1,
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                pb: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarCell, {
                                    user: (_requestedByUser = trade.request.requestedByUser) !== null && _requestedByUser !== void 0 ? _requestedByUser : null,
                                    href: disableClick || !trade.request.requestedByUser ? undefined : generatePath(routerPages.UserProfile, {
                                        userId: (ref38 = (ref4 = trade.request.requestedByUser) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref38 !== void 0 ? ref38 : ""
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.TradeArrow, {
                                    sx: {
                                        color: "grey.500"
                                    },
                                    status: trade.status
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarCell, {
                                    user: (ref39 = (ref5 = trade.candidates) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.user) !== null && ref39 !== void 0 ? ref39 : null,
                                    direction: "ltr",
                                    href: disableClick || !((ref7 = trade.candidates) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.user) ? undefined : generatePath(routerPages.UserProfile, {
                                        userId: (ref40 = (ref9 = trade.candidates) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.user) === null || ref11 === void 0 ? void 0 : ref11.id) !== null && ref40 !== void 0 ? ref40 : ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "row",
                            flex: 1,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.ItemImageArea, {
                                    size: "small",
                                    src: (ref41 = (ref13 = (ref12 = trade.request.providableItems[0]) === null || ref12 === void 0 ? void 0 : ref12.item.thumbnail.front) === null || ref13 === void 0 ? void 0 : ref13.mediumUri) !== null && ref41 !== void 0 ? ref41 : "",
                                    alignItems: "flex-start"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    flex: 1,
                                    justifyContent: "space-between",
                                    sx: {
                                        maxWidth: "calc(100% - 136px)"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            sx: {
                                                mr: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                        variant: "subtitle2",
                                                        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_10__/* .styleSets.lineCamp */ .k$.lineCamp(1)), {
                                                            whiteSpace: "nowrap",
                                                            maxWidth: "100%"
                                                        }),
                                                        children: (ref14 = trade.request.providableItems[0]) === null || ref14 === void 0 ? void 0 : ref14.item.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    direction: "row",
                                                    spacing: 2,
                                                    alignItems: "center",
                                                    sx: {
                                                        pt: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: (ref15 = trade.request.providableItems[0]) === null || ref15 === void 0 ? void 0 : ref15.itemSerial.formattedSerialNumber
                                                        }),
                                                        /**
                     * @description
                     * 自分が関わるトレードの場合、トレード元・トレード先アイテムの保持枚数を表示する
                     */ isMyTrade && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    orientation: "vertical",
                                                                    sx: {
                                                                        height: 10
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.OwnedItems, {
                                                                            fontSize: "xSmall"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                            variant: "overline",
                                                                            color: "text.secondary",
                                                                            children: ((ref17 = (ref16 = trade.request.providableItems) === null || ref16 === void 0 ? void 0 : ref16[0].item) === null || ref17 === void 0 ? void 0 : ref17.ownedCount) ? t("ownedCount", {
                                                                                ownedCount: (ref19 = (ref18 = trade.request.providableItems) === null || ref18 === void 0 ? void 0 : ref18[0].item) === null || ref19 === void 0 ? void 0 : ref19.ownedCount
                                                                            }) : t("notOwned")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            sx: {
                                                ml: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    variant: "subtitle2",
                                                    align: "right",
                                                    sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_10__/* .styleSets.lineCamp */ .k$.lineCamp(1)), {
                                                        maxWidth: "100%"
                                                    }),
                                                    children: (ref21 = (ref20 = trade.candidates[0]) === null || ref20 === void 0 ? void 0 : ref20.candidateItems[0]) === null || ref21 === void 0 ? void 0 : ref21.item.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    direction: "row",
                                                    spacing: 2,
                                                    alignItems: "center",
                                                    justifyContent: "flex-end",
                                                    sx: {
                                                        pt: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: (ref23 = (ref22 = trade.candidates[0]) === null || ref22 === void 0 ? void 0 : ref22.candidateItems[0]) === null || ref23 === void 0 ? void 0 : ref23.itemSerial.formattedSerialNumber
                                                        }),
                                                        /**
                     * @description
                     * 自分が関わるトレードの場合、トレード元・トレード先アイテムの自分の保持枚数を表示する
                     */ isMyTrade && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    orientation: "vertical",
                                                                    sx: {
                                                                        height: 10
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                    direction: "row",
                                                                    spacing: 1,
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Icons.OwnedItems, {
                                                                            fontSize: "xSmall"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                            variant: "overline",
                                                                            color: "text.secondary",
                                                                            children: ((ref24 = trade === null || trade === void 0 ? void 0 : trade.candidates[0]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.candidateItems) === null || ref25 === void 0 ? void 0 : (ref26 = ref25[0]) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.item) === null || ref27 === void 0 ? void 0 : ref27.ownedCount) ? t("ownedCount", {
                                                                                ownedCount: (ref28 = trade === null || trade === void 0 ? void 0 : trade.candidates[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.candidateItems) === null || ref29 === void 0 ? void 0 : (ref30 = ref29[0]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.item) === null || ref31 === void 0 ? void 0 : ref31.ownedCount
                                                                            }) : t("notOwned")
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.ItemImageArea, {
                                    size: "small",
                                    alignItems: "flex-end",
                                    src: (ref42 = (ref34 = (ref33 = (ref32 = trade.candidates[0]) === null || ref32 === void 0 ? void 0 : ref32.candidateItems[0]) === null || ref33 === void 0 ? void 0 : ref33.item.thumbnail.front) === null || ref34 === void 0 ? void 0 : ref34.mediumUri) !== null && ref42 !== void 0 ? ref42 : ""
                                })
                            ]
                        }),
                        trade.formattedCreatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "row",
                            justifyContent: "flex-end",
                            sx: {
                                mt: 2
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "caption",
                                textAlign: "right",
                                color: "text.secondary",
                                children: trade.formattedCreatedAt
                            })
                        })
                    ]
                })
            }),
            !hiddenDivider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    trade.status === _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_12__/* .TradeNegotiationStatus.InProgress */ ._JF.InProgress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "subtitle2",
                        color: "text.secondary",
                        align: "center",
                        sx: {
                            pb: 4
                        },
                        children: t("waitingForApproval", {
                            displayName: (ref43 = (ref35 = trade.candidates[0]) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.user) === null || ref36 === void 0 ? void 0 : ref36.displayName) !== null && ref43 !== void 0 ? ref43 : ""
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            mx: 5
                        }
                    })
                ]
            })
        ]
    });
};
var AvatarCell = function(param) {
    var user = param.user, href = param.href, _direction = param.direction, direction = _direction === void 0 ? "rtl" : _direction;
    var ref;
    var ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        direction: direction === "rtl" ? "row" : "row-reverse",
        flex: "1 1 0",
        sx: {
            width: "calc((100% - 40px) / 2)"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            href: href,
            component: href ? _mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z : _mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            direction: direction === "rtl" ? "row" : "row-reverse",
            alignItems: "center",
            spacing: 2,
            sx: {
                textDecoration: "none",
                width: "fit-content"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    src: (ref1 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                    alt: (ref2 = user === null || user === void 0 ? void 0 : user.displayName) !== null && ref2 !== void 0 ? ref2 : "",
                    sx: {
                        width: 28,
                        height: 28
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    color: "text.secondary",
                    variant: "overline",
                    sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, _components_styles__WEBPACK_IMPORTED_MODULE_10__/* .styleSets.lineCamp */ .k$.lineCamp(1)), {
                        maxWidth: "100%",
                        textTransform: "none"
                    }),
                    children: user === null || user === void 0 ? void 0 : user.displayName
                })
            ]
        })
    });
};


/***/ }),

/***/ 25941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ BuyNowSMSVerification; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79312);
/* harmony import */ var _components_layouts_ContentFrame__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67983);
/* harmony import */ var _components_pages_SMSVerification_template_SMSVerificationForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53906);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95626);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66951);







var BuyNowSMSVerification = function(param) {
    var verifyingSMSCode = param.verifyingSMSCode, phoneNumber = param.phoneNumber, onVerificationPhoneNumber = param.onVerificationPhoneNumber, onResendVerificationSMS = param.onResendVerificationSMS, onClose = param.onClose;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("smsVerification").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_2__/* .OrganismFrame */ .o, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h, {
                back: true,
                title: t("smsVerificationTitle", "SMS認証"),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_ContentFrame__WEBPACK_IMPORTED_MODULE_4__/* .ContentFrame */ .y, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    sx: {
                        px: 5,
                        pt: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "body2",
                            sx: {
                                pt: 2
                            },
                            children: t("description", {
                                phoneNumber: phoneNumber
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_SMSVerification_template_SMSVerificationForm__WEBPACK_IMPORTED_MODULE_7__/* .SMSVerificationForm */ .I, {
                            loading: verifyingSMSCode,
                            onSubmit: onVerificationPhoneNumber,
                            onResend: onResendVerificationSMS
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 66951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56961);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93893);
/* harmony import */ var _core_individual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85362);







var Header = function(param) {
    var title = param.title, onClose = param.onClose, back = param.back;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_2__/* .OrganismFrame */ .o, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                direction: "row",
                sx: {
                    height: 55,
                    px: 3
                },
                alignItems: "center"
            }, (0,_core_individual__WEBPACK_IMPORTED_MODULE_6__/* .individualDisplayResponsive */ .f0)() ? {
                maxWidth: "1120px",
                margin: "0 auto"
            } : {}), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.Back, {
                        size: "small",
                        onClick: onClose,
                        sx: {
                            visibility: !back ? "hidden" : undefined
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.IconButton.Close, {
                        size: "small",
                        onClick: onClose,
                        sx: {
                            visibility: back ? "hidden" : undefined
                        }
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ }),

/***/ 24128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ NotFound; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
;// CONCATENATED MODULE: ./src/components/pages/Errors/NotFound/template/index.tsx





var NotFoundTemplate = function(param) {
    var _state = param.state, _useNextRouter = _state.useNextRouter, useNextRouter = _useNextRouter === void 0 ? true : _useNextRouter;
    var t = (0,i18n/* useTranslation */.$G)("notFound").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            maxWidth: 600,
            width: "100%",
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                sx: {
                    pt: 5
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                sx: {
                    p: 7,
                    mt: 6
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                        variant: "h1",
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            pt: 2
                        },
                        children: t("message")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            pt: 5
                        },
                        align: "center",
                        children: t("desc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                alignItems: "center",
                children: useNextRouter ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/home",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        component: "div",
                        size: "large",
                        children: t("goToTopPage")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    href: "/home",
                    size: "large",
                    children: t("goToTopPage")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Errors/NotFound/index.tsx


/**
 * NotFound Page
 * Implemented as a practical sample.
 */ var NotFound = function(param) {
    var _useNextRouter = param.useNextRouter, useNextRouter = _useNextRouter === void 0 ? true : _useNextRouter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundTemplate, {
        state: {
            useNextRouter: useNextRouter
        }
    });
};


/***/ }),

/***/ 5978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ NotFoundWeb; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(66582);
// EXTERNAL MODULE: ./src/components/pages/Ulink/viewModel.ts
var viewModel = __webpack_require__(74389);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/resources/Image.tsx
var Image = __webpack_require__(83587);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
;// CONCATENATED MODULE: ./src/components/pages/Errors/NotFoundWeb/template/index.tsx









/**
 * Webのないアプリ(DiiCa, はるまき, CLAZYVODKATONIC)の場合、Webページが存在しないことを示すページ
 * ネイティブアプリ(インストールしていない場合はストア)へのリンクを表示する
 */ var NotFoundWebTemplate = function() {
    var t = (0,i18n/* useTranslation */.$G)("notFoundWeb").t;
    var ref = (0,react.useState)(""), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react.useState)(""), finalAppUrl = ref1[0], setFinalAppUrl = ref1[1];
    // ページがUlinkの場合、URLを展開する
    var isUlinkPath = url.includes("ulink/");
    var shortLinkId = url.split("ulink/").pop();
    var data = (0,useQuery/* useQuery */.aM)(viewModel/* QUERY */.Qq, {
        variables: {
            shortLinkId: shortLinkId !== null && shortLinkId !== void 0 ? shortLinkId : ""
        },
        skip: !isUlinkPath || !shortLinkId
    }).data;
    var strippedUrl = url.replace(/^https?:\/\//, "");
    var appUrl = lib/* isAndroid */.Dt ? "".concat(config/* config.appInfo.android.bundleId */.v.appInfo.android.bundleId, "://").concat(strippedUrl) : lib/* isIOS */.gn ? "".concat(config/* config.appInfo.ios.bundleId */.v.appInfo.ios.bundleId, "://").concat(strippedUrl) : "";
    (0,react.useEffect)(function() {
        // Ulinkの場合redirectUrlをURLスキーマにして保存する
        if (isUlinkPath && (data === null || data === void 0 ? void 0 : data.shortLink)) {
            var redirectUrl = data.shortLink.redirectUrl;
            var shortStrippedUrl = redirectUrl.replace(/^https?:\/\//, "");
            var shortAppUrl = lib/* isAndroid */.Dt ? "".concat(config/* config.appInfo.android.bundleId */.v.appInfo.android.bundleId, "://").concat(shortStrippedUrl) : lib/* isIOS */.gn ? "".concat(config/* config.appInfo.ios.bundleId */.v.appInfo.ios.bundleId, "://").concat(shortStrippedUrl) : "";
            setFinalAppUrl(shortAppUrl);
        } else {
            setFinalAppUrl(appUrl);
        }
    }, [
        url,
        isUlinkPath,
        appUrl,
        data
    ]);
    var handleClick = function() {
        if (!lib/* isAndroid */.Dt && !lib/* isIOS */.gn) return;
        // URLスキーマでアプリを開き遷移する処理
        var targetUrl = finalAppUrl || appUrl;
        if (lib/* isIOS */.gn) window.location.href = targetUrl;
        if (lib/* isAndroid */.Dt) {
            var link = document.createElement("a");
            link.href = targetUrl;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        // 一定時間後にストアへリダイレクト
        var now = Date.now();
        var timeout = 2000;
        setTimeout(function() {
            if (Date.now() - now < timeout + 100) {
                window.location.href = lib/* isAndroid */.Dt ? "https://play.google.com/store/apps/details?id=".concat(config/* config.appInfo.android.bundleId */.v.appInfo.android.bundleId) : "https://apps.apple.com/app/id".concat(config/* config.appInfo.ios.storeId */.v.appInfo.ios.storeId);
            }
        }, timeout);
    };
    (0,react.useEffect)(function() {
        setUrl(window.location.href);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            maxWidth: 600,
            width: "100%",
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                sx: {
                    p: 7,
                    mt: "154px"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        src: "images/icon.png",
                        style: {
                            objectFit: "contain",
                            width: 120,
                            height: 120
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            pt: 5
                        },
                        align: "center",
                        children: t("description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    component: "a",
                    size: "large",
                    onClick: handleClick,
                    sx: {
                        width: 244
                    },
                    children: t("openApp")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Errors/NotFoundWeb/index.tsx


var NotFoundWeb = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundWebTemplate, {});
};


/***/ }),

/***/ 10273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ AnimationRareGrowLightCell; },
/* harmony export */   "Qc": function() { return /* binding */ getEmphasisRaritySx; },
/* harmony export */   "Y9": function() { return /* binding */ LightFrame; },
/* harmony export */   "fA": function() { return /* binding */ AnimationGrowLightCell; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12363);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28165);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { \n    box-shadow: \n      inset 0 0 120px whitesmoke,\n      0 0 200px white;\n    background: white;\n    z-index: 1;\n  }\n  30% {\n    box-shadow: \n      inset 0 0 80px whitesmoke,\n      0 0 80px white;\n    background: white;\n    z-index: 1;\n  }\n  60%{\n    box-shadow: none;\n    background: white;\n    z-index: 1;\n  }\n  100% {  \n    box-shadow: ",
        ";\n    background: ",
        ";\n    filter: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { \n    box-shadow: \n      inset 0 0 200px 200px whitesmoke,\n      0 0 200px white;\n    background: white;\n    z-index: 1;\n  }\n  15% {\n    box-shadow: \n      inset 0 0 80px 80px whitesmoke,\n      0 0 80px white;\n    background: white;\n    z-index: 1;\n  }\n  50%{\n    box-shadow: 0 0 80px 1000px white;\n    background: white;\n    z-index: 1;\n  }\n  90%{\n    box-shadow: 0 0 80px 1000px white;\n    background: white;\n    z-index: 1;\n  }\n  91%{\n    box-shadow: none;\n  }\n  100% {\n    box-shadow: ",
        ";\n    background: ",
        ";\n    filter: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 * アイテム強調表示用フレーム
 * - 黄色に発光
 */ var LightFrame = function(param) {
    var _emphasisRarityId = param.emphasisRarityId, emphasisRarityId = _emphasisRarityId === void 0 ? "common" : _emphasisRarityId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: "grow-light-frame",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, commonFrameStyle, getEmphasisRaritySx(emphasisRarityId))
    });
};
/**
 * アニメーション付きのアイテム強調表示用フレーム
 * - 白に発光後、レアであれば黄色に発光
 */ var AnimationGrowLightCell = function(param) {
    var flipped = param.flipped, emphasisRarityId = param.emphasisRarityId, animationTime = param.animationTime;
    var growLight = growLightKeyframe(emphasisRarityId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: "grow-light-wrapper",
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, commonFrameStyle), {
            willChange: "box-shadow, background-color, z-index",
            backfaceVisibility: "hidden",
            animation: flipped ? "".concat(growLight, " ").concat(animationTime, "ms ease both") : undefined
        })
    });
};
/**
 * アニメーション付きのアイテム大強調表示用フレーム
 * - 白に画面全体サイズ発光後、黄色に発光
 */ var AnimationRareGrowLightCell = function(param) {
    var flipped = param.flipped, emphasisRarityId = param.emphasisRarityId, animationTime = param.animationTime;
    var rareGrowLight = rareGrowLightKeyframe(emphasisRarityId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: "rare-grow-Light-frame",
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, commonFrameStyle), {
            willChange: "box-shadow, background-color, z-index",
            backfaceVisibility: "hidden",
            animation: flipped ? "".concat(rareGrowLight, " ").concat(animationTime, "ms ease both") : undefined
        })
    });
};
var commonFrameStyle = {
    position: "absolute",
    borderRadius: 1,
    height: 115,
    width: 72
};
var growLightKeyframe = function(emphasisRarityId) {
    var ref = getEmphasisRaritySx(emphasisRarityId), boxShadow = ref.boxShadow, background = ref.background, filter = ref.filter;
    return (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject(), boxShadow, background, filter);
};
var rareGrowLightKeyframe = function(emphasisRarityId) {
    var ref = getEmphasisRaritySx(emphasisRarityId), boxShadow = ref.boxShadow, background = ref.background, filter = ref.filter;
    return (0,_mui_system__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject1(), boxShadow, background, filter);
};
/**
 * return emphasis rarity style
 * @param emphasisRarityId
 * @param size
 */ function getEmphasisRaritySx(emphasisRarityId) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    return ({
        common: {
            boxShadow: "none"
        },
        rare: {
            boxShadow: "0px 0px ".concat(size, "px 0px rgba(255, 139, 3, 0.80)")
        },
        superrare: {
            boxShadow: "0px 0px ".concat(size, "px 0px rgba(255, 15, 0, 0.80)")
        },
        ultrarare: {
            background: "conic-gradient(from 90deg at 50% 50%, rgba(255, 7, 147, 0.70) 0deg, rgba(255, 0, 9, 0.70) 52.77951657772064deg, rgba(255, 132, 0, 0.70) 130.75308680534363deg, rgba(255, 224, 0, 0.70) 179.44134950637817deg, rgba(113, 255, 12, 0.70) 235.81891536712646deg, rgba(0, 203, 255, 0.70) 307.67319202423096deg, rgba(154, 36, 255, 0.70) 360deg)",
            filter: "blur(10px)"
        },
        limited: {
            background: "conic-gradient(from 90deg at 50% 50%, #5100FF 0deg, #EB00FF 52.78deg, #5100FF 130.75deg, #EB00FF 179.44deg, #5100FF 235.82deg, #EB00FF 307.67deg, #5100FF 360deg)",
            filter: "blur(10px)"
        }
    })[emphasisRarityId !== null && emphasisRarityId !== void 0 ? emphasisRarityId : "common"] || {};
}


/***/ }),

/***/ 33769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useTwitterConnection; },
/* harmony export */   "D": function() { return /* binding */ useViewModel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22970);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33379);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81548);
/* harmony import */ var _capacitor_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18260);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66517);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30226);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16083);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89693);
/* harmony import */ var _core_native_app__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76250);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation RemoveOauthToken($providerId: ProviderType!) {\n    removeOauthToken(providerId: $providerId) {\n      ... on User {\n        id\n      }\n      ... on Artist {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var useViewModel = (0,_core_architecture__WEBPACK_IMPORTED_MODULE_3__/* .makeViewModel */ .e)(function() {
    var ref = useTwitterConnection(), loading = ref.loading, connected = ref.connected, displayName = ref.displayName, connectTwitter = ref.connectTwitter, disConnectTwitter = ref.disConnectTwitter, isBoundWithTwitter = ref.isBoundWithTwitter;
    return {
        state: {
            integrations: {
                twitter: {
                    loading: loading,
                    connected: connected,
                    displayName: displayName,
                    isBound: isBoundWithTwitter
                }
            }
        },
        actions: {
            connectTwitter: connectTwitter,
            disConnectTwitter: disConnectTwitter
        }
    };
});
/**
 * @description
 * twitterとの連携状態・連携メソッド・連携解除メソッドを呼び出すhook
 *
 * @returns loading ローディング状態
 * @returns connected 連携状態
 * @returns displayName snsアカウント名
 * @returns onConnectTwitter twitter連携メソッド
 * @returns onDisConnectTwitter twitter連携解除メソッド
 * @returns isBoundWithTwitter twitterのみで登録しているユーザーかどうか
 */ var useTwitterConnection = function(opt) {
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("integrations").t;
    var ref = (0,_core__WEBPACK_IMPORTED_MODULE_5__/* .useMessage */ .UD)(), showError = ref.showError, showMessage = ref.showMessage;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), connected = ref2[0], setConnected = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), displayName = ref3[0], setDisplayName = ref3[1];
    var ref4 = (0,_core__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)(), user = ref4.user, linkTwitter = ref4.linkTwitter, unLinkTwitter = ref4.unLinkTwitter, reloadUser = ref4.reloadUser, isBoundWithSNS = ref4.isBoundWithSNS;
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)(_clients_utoniq_core_schema__WEBPACK_IMPORTED_MODULE_9__/* .SaveOauthToken */ .R3y), 1), saveTwitterToken = ref5[0];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)(REMOVE_OAUTH_TOKEN), 1), removeTwitterToken = ref6[0];
    // twitterで新規登録したユーザーかどうかの確認
    var isBoundWithTwitter = isBoundWithSNS && (user === null || user === void 0 ? void 0 : user.providers[0].providerId) === "twitter.com";
    /**
   * 既にtwitterアカウントと連携済みかどうか確認
   */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        if (!user) return;
        (ref = user.providers) === null || ref === void 0 ? void 0 : ref.forEach(function(param) {
            var providerId = param.providerId, displayName = param.displayName;
            if (providerId !== "twitter.com") return;
            if (displayName) setDisplayName(displayName);
            setConnected(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        reloadWhenFinishBrowser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * アプリ内部ブラウザから戻ってきた時にユーザーの状態を更新する
   */ var reloadWhenFinishBrowser = function() {
        // On mobile, the popup will open in the web browser,
        // so this event is only handled when the popup closes,
        // but not when the browser is closed.
        // Therefore, I will set a 5-second delay to call the user again.
        var DELAY = (0,_core_native_app__WEBPACK_IMPORTED_MODULE_10__/* .getPlatform */ .Xf)() === "android" ? 5000 : 0;
        _capacitor_browser__WEBPACK_IMPORTED_MODULE_1__/* .Browser.addListener */ .A.addListener("browserFinished", function() {
            setTimeout(function() {
                reloadUser().catch(showError);
            }, DELAY);
        });
    };
    var connectTwitter = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            linkTwitter().then(function(res) {
                                if (!res) return;
                                var credential = res.credential, providerId = res.providerId;
                                return saveTwitterToken({
                                    variables: {
                                        inputs: {
                                            providerId: providerId,
                                            oauthToken: credential === null || credential === void 0 ? void 0 : credential.oauthToken,
                                            oauthTokenSecret: credential === null || credential === void 0 ? void 0 : credential.oauthTokenSecret
                                        }
                                    }
                                });
                            }).then(function() {
                                var ref;
                                setConnected(true);
                                var ref1;
                                showMessage((ref1 = opt === null || opt === void 0 ? void 0 : (ref = opt.messages) === null || ref === void 0 ? void 0 : ref.connected) !== null && ref1 !== void 0 ? ref1 : t("connectedTwitter"));
                            }).catch(function(e) {
                                showError(e);
                            }).finally(function() {
                                return setLoading(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function connectTwitter() {
            return _ref.apply(this, arguments);
        };
    }();
    var disConnectTwitter = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                setLoading(true);
                unLinkTwitter().then(function() {
                    return removeTwitterToken({
                        variables: {
                            providerId: "twitter"
                        }
                    });
                }).then(function() {
                    showMessage(t("disConnectTwitter"));
                    setConnected(false);
                    setDisplayName("");
                    reloadUser();
                }).catch(function(e) {
                    return showError(e);
                }).finally(function() {
                    return setLoading(false);
                });
                return [
                    2
                ];
            });
        });
        return function disConnectTwitter() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: loading,
        connected: connected,
        displayName: displayName,
        connectTwitter: connectTwitter,
        disConnectTwitter: disConnectTwitter,
        isBoundWithTwitter: isBoundWithTwitter
    };
};
var REMOVE_OAUTH_TOKEN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_13__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 59473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aH": function() { return /* binding */ PersonalInfoForm; },
  "Pg": function() { return /* binding */ defaultValues; },
  "fK": function() { return /* binding */ PersonalInfoForm_schema; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/core/form/index.ts + 1 modules
var core_form = __webpack_require__(38679);
// EXTERNAL MODULE: ./src/core/architecture/components/index.tsx
var components = __webpack_require__(93893);
// EXTERNAL MODULE: ./src/core/entities/values/PostalCode.ts
var PostalCode = __webpack_require__(56903);
// EXTERNAL MODULE: ./src/core/validators/index.ts
var validators = __webpack_require__(17745);
// EXTERNAL MODULE: ./src/components/pages/PersonalInfoSettings/template/components/Common.tsx
var Common = __webpack_require__(20506);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/BirthdayInputCell.tsx







var BirthdayInputCell = function(param) {
    var value = param.value, isRequired = param.isRequired, error = param.error, setValue = param.setValue;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var birthday = (0,react.useMemo)(function() {
        return value ? dayjs_min_default()(value) : null;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 6,
            mb: 4,
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DatePickerField, {
            error: error,
            onChange: function(date) {
                setValue("birthday", date, {
                    shouldValidate: true,
                    shouldDirty: true
                });
            },
            value: birthday,
            placeholder: t("birthdayPlaceholder"),
            textFieldProps: {
                inputProps: {
                    value: value ? dayjs_min_default()(value).format("YYYY/MM/DD") : ""
                }
            },
            titleProps: {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("birthday")
                        }),
                        isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            color: "error.main",
                            component: "p",
                            ml: 1,
                            mt: -1,
                            children: t("required", "※必須")
                        })
                    ]
                })
            }
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(96758);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30721);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(85151);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var schema = __webpack_require__(66517);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/GenderInputCell.tsx





var GenderInputCell = function(param) {
    var value = param.value, isRequired = param.isRequired, setValue = param.setValue;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 6,
            mb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("gender", "性別")
                    }),
                    isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "error.main",
                        component: "p",
                        ml: 1,
                        mt: -1,
                        children: t("required", "※必須")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                value: value,
                onChange: function(_, value) {
                    return setValue("gender", value, {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                },
                sx: {
                    display: "flex",
                    flexDirection: "row",
                    gap: 3
                },
                children: [
                    schema/* Gender.Male */.Y0t.Male,
                    schema/* Gender.Female */.Y0t.Female,
                    schema/* Gender.None */.Y0t.None
                ].map(function(gender) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: gender,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: t(gender)
                    }, gender);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/UserAccountCell.tsx





var UserAccountCell = function(param) {
    var user = param.user;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var routerPages = (0,useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("emailAddress", "メールアドレス")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                flex: 1,
                                minWidth: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: user === null || user === void 0 ? void 0 : user.email
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outlined",
                                size: "small",
                                href: routerPages.EmailSetting,
                                sx: {
                                    color: "primary.main",
                                    borderColor: "primary.main"
                                },
                                children: t("change", "変更する")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                pt: 4,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("password", "パスワード")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                flex: 1,
                                minWidth: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: "***************"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outlined",
                                size: "small",
                                href: routerPages.PasswordSetting,
                                sx: {
                                    color: "primary.main",
                                    borderColor: "primary.main"
                                },
                                children: t("change", "変更する")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/pages/PersonalInfoSettings/template/components/PhoneNumberInputCell.tsx
var PhoneNumberInputCell = __webpack_require__(90025);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/AddressInputCell.tsx






var AddressInputCell = function(param) {
    var register = param.register, errors = param.errors, isRequired = param.isRequired;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                pb: 4,
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("shippingAddress", "住所（配送先）")
                    }),
                    isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "error.main",
                        component: "p",
                        ml: 1,
                        mt: -1,
                        children: t("required", "※必須")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.postalCode
            }, register("postalCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.prefecture
            }, register("prefecture"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.city
            }, register("city"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line1
            }, register("line1"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line2
            }, register("line2")))
        ]
    });
};

// EXTERNAL MODULE: ./src/core/resources/Image.tsx
var Image = __webpack_require__(83587);
// EXTERNAL MODULE: ./src/core/creditCard/index.ts
var creditCard = __webpack_require__(11534);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/PaymentMethodCell.tsx





var PaymentMethodCell = function(param) {
    var paymentSource = param.paymentSource;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var routerPages = (0,useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                pb: 4,
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("paymentMethod", "支払い方法")
                    }),
                    paymentSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        href: routerPages.PaymentDetail,
                        sx: {
                            color: "primary.main",
                            borderColor: "primary.main"
                        },
                        children: t("change", "変更する")
                    })
                ]
            }),
            paymentSource ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 6,
                    px: 5
                },
                spacing: 5,
                justifyContent: "flex-start",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        width: 40,
                        height: 32,
                        src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource.brand),
                        target: "common"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                children: "**** **** **** ".concat(paymentSource.last4)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "caption",
                                children: paymentSource.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                children: [
                                    t("dateOfExpiry"),
                                    ":",
                                    " ",
                                    "".concat(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.expMonth, "/").concat(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.expYear)
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.secondary",
                    children: t("emptyPaymentMethodMessage", "支払い方法の登録はありません")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/components/BankAccountCell.tsx






var BankAccountCell = function(param) {
    var bank = param.bank;
    var t = (0,i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var routerPages = (0,useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                pb: 4,
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("bankAccount", "振込先口座")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        href: routerPages.BankCreate,
                        sx: {
                            color: "primary.main",
                            borderColor: "primary.main"
                        },
                        children: t("change", "変更する")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                children: bank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        children: t("bankDetail", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bank), {
                            accountType: t(bank.accountType)
                        }))
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.secondary",
                    children: t("emptyBankDetailMessage", "振込先口座の登録はありません")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/PersonalInfoForm.tsx









var PersonalInfoForm_schema = function(o) {
    return {
        fullName: (0,validators/* validateFullNameConditional */.DD)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.fullName"
        }, "hasFullName"),
        phoneNumber: (0,validators/* validatePhoneNumberConditional */.bA)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.phoneNumber"
        }, "hasPhoneNumber"),
        gender: o.string().when("isMembershipPersonalInformationRequired", {
            is: true,
            then: o.string().label((0,core_form/* tLabel */.TQ)("personalInfo.gender")),
            otherwise: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("personalInfo.gender"))
        }),
        birthday: (0,validators/* validateBirthdayConditional */.Ol)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.birthday"
        }, "hasBirthday"),
        postalCode: (0,validators/* validatePostalCodeConditional */.A6)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.postalCode"
        }, "hasPostalCode"),
        prefecture: (0,validators/* validatePrefectureConditional */.Fy)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.prefecture"
        }, "hasPrefecture"),
        city: (0,validators/* validateCityConditional */.Su)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.city"
        }, "hasCity"),
        line1: (0,validators/* validateLine1Conditional */.c0)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.line1"
        }, "hasLine1"),
        line2: (0,validators/* validateLine2Conditional */.Nm)(o, {
            field: "isMembershipPersonalInformationRequired",
            value: true,
            labelKey: "personalInfo.line2"
        }),
        isMembershipPersonalInformationRequired: o.boolean(),
        hasFullName: o.boolean().optional(),
        hasPhoneNumber: o.boolean().optional(),
        hasBirthday: o.boolean().optional(),
        hasGender: o.boolean().optional(),
        hasPostalCode: o.boolean().optional(),
        hasPrefecture: o.boolean().optional(),
        hasCity: o.boolean().optional(),
        hasLine1: o.boolean().optional()
    };
};
var PersonalInfoForm = function(param) {
    var submitting = param.submitting, user = param.user, visibleMoreInfo = param.visibleMoreInfo, paymentSource = param.paymentSource, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, onSubmit = param.onSubmit, personalInfoForm = param.personalInfoForm, sendingSMSCode = param.sendingSMSCode, verifyingSMSCode = param.verifyingSMSCode, needVerifyPhoneNumber = param.needVerifyPhoneNumber, onChangeNeedVerifyPhoneNumber = param.onChangeNeedVerifyPhoneNumber, onVerificationPhoneNumber = param.onVerificationPhoneNumber, onSendVerificationSMS = param.onSendVerificationSMS, onResendVerificationSMS = param.onResendVerificationSMS;
    var register = personalInfoForm.register, _formState = personalInfoForm.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, watch = personalInfoForm.watch, setValue = personalInfoForm.setValue, handleSubmit = personalInfoForm.handleSubmit;
    var onSubmitForm = handleSubmit(function(values) {
        var normalizedValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
            postalCode: PostalCode/* PostalCode.normalize */.R.normalize(values.postalCode)
        });
        return onSubmit(normalizedValues);
    });
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* TextInputCell */.n, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "text"
            }, register("fullName")), {
                error: errors === null || errors === void 0 ? void 0 : errors.fullName,
                isRequired: isMembershipPersonalInformationRequired
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BirthdayInputCell, {
                value: watch("birthday"),
                setValue: setValue,
                error: errors === null || errors === void 0 ? void 0 : errors.birthday,
                isRequired: isMembershipPersonalInformationRequired
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderInputCell, {
                value: watch("gender"),
                setValue: setValue,
                isRequired: isMembershipPersonalInformationRequired
            }),
            visibleMoreInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAccountCell, {
                        user: user
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberInputCell/* PhoneNumberInputCell */.y, {
                isRequired: isMembershipPersonalInformationRequired,
                isPhoneNumberVerified: !!(user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified),
                formattedPhoneNumber: (ref = user === null || user === void 0 ? void 0 : user.formattedPhoneNumber) !== null && ref !== void 0 ? ref : "",
                inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("phoneNumber")), {
                    error: errors.phoneNumber
                }),
                phoneNumber: watch("phoneNumber"),
                sendingSMSCode: sendingSMSCode,
                verifyingSMSCode: verifyingSMSCode,
                needVerifyPhoneNumber: needVerifyPhoneNumber,
                onChangeNeedVerifyPhoneNumber: onChangeNeedVerifyPhoneNumber,
                onVerificationPhoneNumber: onVerificationPhoneNumber,
                onSendVerificationSMS: onSendVerificationSMS,
                onResendVerificationSMS: onResendVerificationSMS
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputCell, {
                register: register,
                errors: errors,
                isRequired: isMembershipPersonalInformationRequired
            }),
            visibleMoreInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodCell, {
                        paymentSource: paymentSource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BankAccountCell, {
                        bank: user === null || user === void 0 ? void 0 : user.bank
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* ButtonCell */.T, {
                disabled: isMembershipPersonalInformationRequired ? !isValid || isSubmitting : isSubmitting,
                loading: isSubmitting || submitting,
                onSubmit: onSubmitForm
            })
        ]
    });
};
var defaultValues = {
    gender: null,
    birthday: null,
    fullName: "",
    phoneNumber: "",
    postalCode: "",
    prefecture: "",
    city: "",
    line1: "",
    line2: "",
    isMembershipPersonalInformationRequired: false,
    hasFullName: false,
    hasPhoneNumber: false,
    hasBirthday: false,
    hasGender: false,
    hasPostalCode: false,
    hasPrefecture: false,
    hasCity: false,
    hasLine1: false
};


/***/ }),

/***/ 20506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ButtonCell; },
/* harmony export */   "n": function() { return /* binding */ TextInputCell; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38677);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95626);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93893);









var ButtonCell = function(param) {
    var loading = param.loading, disabled = param.disabled, onSubmit = param.onSubmit;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("personalInfoSettings").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_4__/* .CellFrame */ .p, {
        sx: {
            py: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            size: "large",
            sx: {
                width: 244
            },
            disabled: disabled,
            loading: loading,
            onClick: onSubmit,
            children: t("submit")
        })
    });
};
var TextInputCell = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, isRequired = _param.isRequired, error = _param.error, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "titleProps",
        "textFieldProps",
        "isRequired",
        "error"
    ]);
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("personalInfoSettings").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_4__/* .CellFrame */ .p, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.TextInputField, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            titleProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("".concat(props.name, "Title"))
                        }),
                        isRequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            variant: "caption",
                            color: "error.main",
                            component: "p",
                            ml: 1,
                            mt: -1,
                            children: t("required", "※必須")
                        })
                    ]
                })
            }, titleProps), {
                variant: "subtitle1",
                color: "text.secondary"
            }),
            textFieldProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, textFieldProps), {
                sx: {
                    mb: 1
                }
            }),
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});


/***/ }),

/***/ 90025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ SMSVerificationDrawer; },
/* harmony export */   "y": function() { return /* binding */ PhoneNumberInputCell; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43411);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28207);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(38677);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clients_utoniq_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55148);
/* harmony import */ var _components_pages_ArtistStoreItemDetail_template_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(25941);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30226);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93893);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20506);












var PhoneNumberInputCell = function(_param) {
    var formattedPhoneNumber = _param.formattedPhoneNumber, isPhoneNumberVerified = _param.isPhoneNumberVerified, needVerifyPhoneNumber = _param.needVerifyPhoneNumber, isRequired = _param.isRequired, inputProps = _param.inputProps, onChangeNeedVerifyPhoneNumber = _param.onChangeNeedVerifyPhoneNumber, buyNowSMSVerificationProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "formattedPhoneNumber",
        "isPhoneNumberVerified",
        "needVerifyPhoneNumber",
        "isRequired",
        "inputProps",
        "onChangeNeedVerifyPhoneNumber"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openSMSVerificationModal = ref[0], setOpenSMSVerificationModal = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setOpenSMSVerificationModal(!!needVerifyPhoneNumber);
    }, [
        needVerifyPhoneNumber
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_4__/* .CellFrame */ .p, {
        sx: {
            pt: 6
        },
        children: [
            isPhoneNumberVerified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                spacing: 2,
                pb: 6,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelCell, {
                        isRequired: isRequired,
                        isPhoneNumberVerified: isPhoneNumberVerified
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body2",
                        children: formattedPhoneNumber
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_7__/* .TextInputCell */ .n, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                type: "number"
            }, inputProps), {
                titleProps: {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelCell, {
                        isRequired: isRequired,
                        isPhoneNumberVerified: isPhoneNumberVerified
                    })
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SMSVerificationDrawer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, buyNowSMSVerificationProps), {
                open: openSMSVerificationModal,
                onClose: function() {
                    setOpenSMSVerificationModal(false);
                    onChangeNeedVerifyPhoneNumber(false);
                },
                formattedPhoneNumber: (0,_clients_utoniq_core__WEBPACK_IMPORTED_MODULE_10__/* .formatPhoneNumber */ .un)(buyNowSMSVerificationProps.phoneNumber)
            }))
        ]
    });
};
var LabelCell = function(param) {
    var isRequired = param.isRequired, isPhoneNumberVerified = param.isPhoneNumberVerified;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)("personalInfoSettings").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_4__/* .CellFrame */ .p, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("phoneNumber", "電話番号")
                        }),
                        isRequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "caption",
                            color: "error.main",
                            component: "p",
                            ml: 1,
                            mt: -1,
                            children: t("required", "※必須")
                        })
                    ]
                }),
                isPhoneNumberVerified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Success, {
                            fontSize: "small",
                            sx: {
                                color: "grey.700"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "body2",
                            color: "text.hint",
                            children: t("verified")
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.Icons.Info, {
                            fontSize: "small",
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            variant: "body2",
                            color: "error",
                            children: t("unverify", "未認証")
                        })
                    ]
                })
            ]
        })
    });
};
var SMSVerificationDrawer = function(_param) {
    var open = _param.open, sendingSMSCode = _param.sendingSMSCode, onClose = _param.onClose, formattedPhoneNumber = _param.formattedPhoneNumber, onSendVerificationSMS = _param.onSendVerificationSMS, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "open",
        "sendingSMSCode",
        "onClose",
        "formattedPhoneNumber",
        "onSendVerificationSMS"
    ]);
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)("personalInfoSettings").t;
    var showError = (0,_core__WEBPACK_IMPORTED_MODULE_12__/* .useMessage */ .UD)().showError;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openEnterSMSVerification = ref[0], setOpenEnterSMSVerification = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                open: openEnterSMSVerification,
                onClose: function() {
                    return setOpenEnterSMSVerification(false);
                },
                sx: {
                    zIndex: function(theme) {
                        return theme.zIndex.modal + 3;
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    sx: {
                        bgcolor: "background.default",
                        height: "90dvh"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_ArtistStoreItemDetail_template_components__WEBPACK_IMPORTED_MODULE_14__/* .BuyNowSMSVerification */ .y, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                        onVerificationPhoneNumber: function(value) {
                            return props.onVerificationPhoneNumber(value).then(function() {
                                return setOpenEnterSMSVerification(false);
                            });
                        },
                        phoneNumber: formattedPhoneNumber,
                        onClose: function() {
                            return setOpenEnterSMSVerification(false);
                        }
                    }))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.InformationModal, {
                open: open,
                onClose: onClose,
                title: t("verifyTitle"),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    align: "left",
                    children: t("verifyDesc2", {
                        phoneNumber: formattedPhoneNumber
                    })
                }),
                buttons: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    sx: {
                        minWidth: 212,
                        mt: 4
                    },
                    size: "large",
                    loading: sendingSMSCode,
                    disabled: sendingSMSCode,
                    onClick: function() {
                        onSendVerificationSMS().then(function() {
                            onClose();
                            setOpenEnterSMSVerification(true);
                        }).catch(showError);
                    },
                    children: t("verify")
                }),
                cancelText: t("close")
            })
        ]
    });
};


/***/ }),

/***/ 53906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SMSVerificationForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38677);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38679);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95626);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30226);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93893);
/* harmony import */ var _core_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35625);









var schema = function(o) {
    return {
        code: o.string().length(6).label((0,_core__WEBPACK_IMPORTED_MODULE_3__/* .tLabel */ .TQ)("smsVerification.code"))
    };
};
var SMSVerificationForm = function(param) {
    var loading = param.loading, onSubmit = param.onSubmit, onResend = param.onResend;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("smsVerification").t;
    var ref = (0,_core__WEBPACK_IMPORTED_MODULE_5__/* .useMessage */ .UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        schema: schema
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    var handleVerify = handleSubmit(function(values) {
        return onSubmit(values).catch(showError);
    });
    var handleReSend = function() {
        return onResend().then(function() {
            return showMessage(t("resended"));
        }).catch(showError);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_form__WEBPACK_IMPORTED_MODULE_6__/* .Form */ .l, {
        onSubmit: handleVerify,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextInputCell, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.code
            }, register("code"))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonCell, {
                loading: isSubmitting,
                disabled: !isValid || isSubmitting
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResendButtonCell, {
                onResendAuthMail: handleReSend,
                loading: loading
            })
        ]
    });
};
var TextInputCell = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("smsVerification").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_8__/* .CellFrame */ .p, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.TextInputField, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
            ref: ref,
            t: t,
            titleProps: {
                sx: {
                    display: "none"
                }
            }
        }))
    });
});
var ButtonCell = function(props) {
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("smsVerification").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_8__/* .CellFrame */ .p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            type: "submit",
            size: "large",
            sx: {
                width: 244
            }
        }, props), {
            children: t("submit")
        }))
    });
};
var ResendButtonCell = function(param) {
    var onResendAuthMail = param.onResendAuthMail, loading = param.loading;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("smsVerification").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_8__/* .CellFrame */ .p, {
        sx: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            variant: "text",
            color: "primary",
            onClick: onResendAuthMail,
            disabled: loading,
            children: t("resend")
        })
    });
};


/***/ }),

/***/ 79465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ useSavingSocialUserInfo; },
  "D": function() { return /* binding */ useViewModel; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var schema = __webpack_require__(66517);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/auth/index.ts + 4 modules
var auth = __webpack_require__(16083);
// EXTERNAL MODULE: ./src/core/messages/useMessage.tsx
var useMessage = __webpack_require__(30226);
// EXTERNAL MODULE: ./src/core/analytics/AnalyticsProvider.tsx
var AnalyticsProvider = __webpack_require__(34814);
// EXTERNAL MODULE: ./src/core/architecture/ViewModel.ts
var ViewModel = __webpack_require__(89693);
// EXTERNAL MODULE: ./src/core/native/device/index.ts
var device = __webpack_require__(81291);
// EXTERNAL MODULE: ./src/core/native/storage/index.ts
var storage = __webpack_require__(57782);
;// CONCATENATED MODULE: ./src/components/pages/SignUp/template/fragments.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SignUpUser on User {\n      id\n      displayName\n      avatar {\n        uri\n      }\n      introduction\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment VerifyCode on EmailVerification {\n      id\n      verified\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment UserProfile on User {\n      id\n      accountId\n      formattedAccountId @client\n      displayName\n      avatar {\n        uri\n        mediumUri\n        smallUri\n      }\n      introduction\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var fragments = {
    user: (0,lib/* gql */.Ps)(_templateObject()),
    verifyCode: (0,lib/* gql */.Ps)(_templateObject1()),
    updateProfile: (0,lib/* gql */.Ps)(_templateObject2())
};

;// CONCATENATED MODULE: ./src/components/pages/SignUp/viewModel.ts




function viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyCode($email: String!, $code: String!) {\n    verifyCode(email: $email, code: $code) {\n      id\n      verified\n    }\n  }\n"
    ]);
    viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SendVerificationEmail($email: String!) {\n    sendVerificationEmail(email: $email) {\n      id\n      email\n    }\n  }\n"
    ]);
    viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SignupAsUser($inputs: SignupAsUserInput!) {\n    signupAsUser(inputs: $inputs) {\n      ...SignUpUser\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateProfile($inputs: UpdateProfileInput!) {\n    updateUserProfile(inputs: $inputs) {\n      ...UserProfile\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation linkAnonymousAccount($inputs: LinkAnonymousAccountInput!) {\n    linkAnonymousAccount(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var VERIFY_CODE = (0,lib/* gql */.Ps)(viewModel_templateObject());
var SEND_VERIFICATION_EMAIL = (0,lib/* gql */.Ps)(viewModel_templateObject1());
var SIGNUP_AS_User = (0,lib/* gql */.Ps)(viewModel_templateObject2(), schema/* SignUpUserFragmentDoc */.DQs);
var initialValues = {
    displayName: "",
    email: "",
    password: ""
};
var useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,i18n/* useTranslation */.$G)("mailAuth"), tMailAuth = ref1.t;
    var ref2 = (0,useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    var ref3 = (0,auth/* useAuth */.aC)(), loginWithEmail = ref3.loginWithEmail, signInWithApple = ref3.signInWithApple;
    var ref4 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref4.user;
    var ref5 = (0,react.useState)(initialValues), account = ref5[0], setAccount = ref5[1];
    var showError = (0,useMessage/* useMessage */.UD)().showError;
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,useQuery/* useQuery */.aM)(schema/* Login */.m35, {
        skip: true
    }), refetchUser = ref7.refetch;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VERIFY_CODE), 1), verifyCode = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SEND_VERIFICATION_EMAIL), 2), sendVerifyEmail = ref9[0], ref10 = ref9[1], verifyEmailSending = ref10.loading;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SIGNUP_AS_User), 1), signupAsUser = ref11[0];
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var redirectUriRef = (0,react.useRef)((ref = router.query) === null || ref === void 0 ? void 0 : ref.redirectUri);
    var handleSignUpSuccess = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, data, userInfoRegisterRedirect;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        refetchUser()
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        4,
                        (0,storage/* getUserInfoRegisterRedirect */.j6)()
                    ];
                case 2:
                    userInfoRegisterRedirect = _state.sent();
                    if (!(userInfoRegisterRedirect === null || userInfoRegisterRedirect === void 0 ? void 0 : userInfoRegisterRedirect.direction)) {
                        return [
                            2
                        ];
                    }
                    redirectUriRef.current = userInfoRegisterRedirect.direction;
                    if ((userInfoRegisterRedirect === null || userInfoRegisterRedirect === void 0 ? void 0 : userInfoRegisterRedirect.phoneNumber) && !((data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.phoneNumber) && (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.isPhoneNumberVerified))) {
                        redirectUriRef.current = routerPages.StoreUserInfo;
                    } else if ((userInfoRegisterRedirect === null || userInfoRegisterRedirect === void 0 ? void 0 : userInfoRegisterRedirect.address) && !(data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.fullAddress)) {
                        redirectUriRef.current = routerPages.StoreDeliveryInfo;
                    }
                    return [
                        4,
                        (0,storage/* setRedirectAfterLoginPath */.fu)(redirectUriRef.current)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        refetchUser,
        routerPages.StoreDeliveryInfo,
        routerPages.StoreUserInfo
    ]);
    return {
        state: {
            verifyEmailSending: verifyEmailSending,
            loading: loading
        },
        actions: {
            signUp: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(inputs) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_register", {
                                        loginMethod: "email",
                                        applicationKey: config/* config.applicationKey */.v.applicationKey,
                                        isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: inputs.email
                                        }
                                    }).then(function() {
                                        setAccount(inputs);
                                        return;
                                    }).catch(function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            analytics === null || analytics === void 0 ? void 0 : analytics.track("error_register", {
                                                                loginMethod: "email",
                                                                error: e.message,
                                                                applicationKey: config/* config.applicationKey */.v.applicationKey,
                                                                isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        throw e;
                                                }
                                            });
                                        });
                                        return function(e) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }(),
            signUpWithGoogle: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            signUpWithApple: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                7
                            ]);
                            return [
                                4,
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_register", {
                                    loginMethod: "apple.com",
                                    applicationKey: config/* config.applicationKey */.v.applicationKey,
                                    isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                signInWithApple(handleSignUpSuccess)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("register", {
                                    loginMethod: "apple.com",
                                    applicationKey: config/* config.applicationKey */.v.applicationKey,
                                    isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                })
                            ];
                        case 4:
                            _state.sent();
                            if (config/* config.modules.tutorial */.v.modules.tutorial) {
                                return [
                                    2,
                                    router.replace(routerPages.Tutorial)
                                ];
                            }
                            (0,storage/* getRedirectAfterLoginPath */.CT)().then(function(param) {
                                var value = param.value;
                                return router.replace(value !== null && value !== void 0 ? value : routerPages.GlobalHome);
                            });
                            setLoading(false);
                            return [
                                3,
                                7
                            ];
                        case 5:
                            e = _state.sent();
                            return [
                                4,
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("error_register", {
                                    loginMethod: "apple.com",
                                    applicationKey: config/* config.applicationKey */.v.applicationKey,
                                    isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                })
                            ];
                        case 6:
                            _state.sent();
                            setLoading(false);
                            showError(e, {
                                browserName: (0,device/* browserDetect */.A)()
                            });
                            return [
                                3,
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            }),
            verifyAccount: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                    var code, ref, _data, verified, redirectAfterLoginPath;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                code = param.code;
                                return [
                                    4,
                                    verifyCode({
                                        variables: {
                                            email: account.email,
                                            code: code
                                        }
                                    })
                                ];
                            case 1:
                                ref = _state.sent(), _data = ref.data, verified = _data.verifyCode.verified;
                                if (!verified) throw new Error(tMailAuth("emailVerificationCodeNotMatchOrExpired"));
                                return [
                                    4,
                                    signupAsUser({
                                        variables: {
                                            inputs: account
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("register", {
                                        loginMethod: "email",
                                        applicationKey: config/* config.applicationKey */.v.applicationKey,
                                        isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* getRedirectAfterLoginPath */.CT)()
                                ];
                            case 4:
                                redirectAfterLoginPath = _state.sent();
                                return [
                                    4,
                                    loginWithEmail(account.email, account.password, handleSignUpSuccess)
                                ];
                            case 5:
                                _state.sent();
                                if (config/* config.modules.tutorial */.v.modules.tutorial) {
                                    return [
                                        2,
                                        router.replace(routerPages.Tutorial)
                                    ];
                                }
                                if (!redirectUriRef.current) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    (0,storage/* setRedirectAfterLoginPath */.fu)(redirectUriRef.current)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                if (redirectAfterLoginPath.value) {
                                    router.replace(redirectAfterLoginPath.value);
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            resendVerifyMail: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                sendVerifyEmail({
                                    variables: {
                                        email: account.email
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
/**
 * @description
 * sns認証のリダイレクト時に、以下行うhook
 * - userDocを生成する
 * - sns認証のcredentialをuserDocに保持する
 */ var useSavingSocialUserInfo = function() {
    var getRedirectResult = (0,auth/* useAuth */.aC)().getRedirectResult;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(schema/* SaveOauthToken */.R3y), 1), saveOauthToken = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_PROFILE), 1), updateProfile = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(schema/* LinkAnonymousAccount */.W7l), 1), linkAnonymousAccount = ref3[0];
    var saveSocialUserInfo = function() {
        setLoading(true);
        return getRedirectResult().then(function(res) {
            if (!res) return;
            var credential = res.credential, info = res.additionalUserInfo, providerId = res.providerId;
            return updateProfile({
                variables: {
                    inputs: {
                        accountId: info.accountId,
                        displayName: info.displayName,
                        introduction: info.introduction,
                        avatarPath: info.profileUrl
                    }
                }
            }).then(function() {
                if (!credential) return;
                saveOauthToken({
                    variables: {
                        inputs: {
                            providerId: providerId,
                            oauthToken: credential.oauthToken,
                            oauthTokenSecret: credential.oauthTokenSecret
                        }
                    }
                });
            });
        }).catch(function(error) {
            throw error;
        }).finally(function() {
            return setLoading(false);
        });
    };
    return {
        saveSocialUserInfo: saveSocialUserInfo,
        loading: loading,
        linkAnonymousAccount: linkAnonymousAccount
    };
};
var UPDATE_PROFILE = (0,lib/* gql */.Ps)(_templateObject3(), fragments.updateProfile);
var LINK_ANONYMOUS_ACCOUNT = (0,lib/* gql */.Ps)(_templateObject4());


/***/ }),

/***/ 72432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pf": function() { return /* binding */ StoreRequestProvidableItemSearchTemplate; },
/* harmony export */   "Zx": function() { return /* binding */ StoreStateResults; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39899);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(79312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30907);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93873);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16818);
/* harmony import */ var react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(96662);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15512);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24038);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49678);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(12683);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(92238);
/* harmony import */ var _components_organisms_functionals__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(98653);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58015);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61631);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95626);
/* harmony import */ var _core_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34814);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(93893);
/* harmony import */ var _core_entities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81822);
/* harmony import */ var _core_native__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76250);
/* harmony import */ var _lib_algolia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40681);




















var client = _lib_algolia__WEBPACK_IMPORTED_MODULE_2__/* .client */ .Lp();
var StoreRequestProvidableItemSearchTemplate = function(param) {
    var state = param.state;
    var routerNames = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .tv)().routerNames;
    var analytics = (0,_core_analytics__WEBPACK_IMPORTED_MODULE_4__/* .useAnalytics */ .z$)().analytics;
    var itemResultRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        items: [],
        page: 1
    });
    var publishedAtTimestampRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(_core_entities__WEBPACK_IMPORTED_MODULE_5__/* .DateTime.nowUnixMilliseconds */ .o.nowUnixMilliseconds());
    var handleOnCompleted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(items, param) {
        var page = param.page;
        itemResultRef.current = {
            items: items,
            page: page
        };
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "artist_store_list",
            item_list_name: "Artist Store Items",
            items: items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: _core_native__WEBPACK_IMPORTED_MODULE_6__/* .getPlatform */ .Xf(),
                    item_category4: page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var handleSelectItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            items: itemResultRef.current.items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: _core_native__WEBPACK_IMPORTED_MODULE_6__/* .getPlatform */ .Xf(),
                    item_category4: itemResultRef.current.page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_styles__WEBPACK_IMPORTED_MODULE_7__/* .ArtistThemeProvider */ .rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts__WEBPACK_IMPORTED_MODULE_8__/* .Head */ .F, {
                title: routerNames.StoreRequestProvidableItemSearch
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts__WEBPACK_IMPORTED_MODULE_9__/* .BaseLayout */ .I, {
                header: {
                    back: true,
                    title: state.keyword,
                    right: state.isLoggedIn && !!_config__WEBPACK_IMPORTED_MODULE_10__/* .config.modules.prepaidPoint */ .v.modules.prepaidPoint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_11__/* .PointDisplayPurchase */ .u, {
                        point: state.point
                    })
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    indexName: _lib_algolia__WEBPACK_IMPORTED_MODULE_2__/* .indexes.items */ .RG.items,
                    searchClient: client,
                    refresh: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            hitsPerPage: 10,
                            query: state.keyword,
                            filters: _lib_algolia__WEBPACK_IMPORTED_MODULE_2__/* .filters.itemStoreArtist */ .u8.itemStoreArtist(state.artistId, publishedAtTimestampRef.current, undefined, true)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreStateResults, {
                            onCompleted: handleOnCompleted
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreItemsInfiniteHits, {
                            artistId: state.artistId,
                            userLoggedInId: state.userLoggedInId,
                            onSelectItem: handleSelectItem
                        })
                    ]
                })
            })
        ]
    });
};
var StoreStateResults = (0,react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(param) {
    var searching = param.searching, searchResults = param.searchResults, onCompleted = param.onCompleted;
    var ref, ref1, ref2;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_15__/* .useTranslation */ .$G)("storeRequestProvidableItemSearch").t;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!searching && (searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.hits) === null || ref === void 0 ? void 0 : ref.length) != undefined) {
            var items = searchResults.hits.map(function(_param) {
                var objectID = _param.objectID, item = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_param, [
                    "objectID"
                ]);
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                    id: objectID
                }, item);
            });
            var ref1;
            onCompleted && onCompleted(items, {
                page: ((ref1 = searchResults === null || searchResults === void 0 ? void 0 : searchResults.page) !== null && ref1 !== void 0 ? ref1 : 0) + 1
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searching,
        searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.hits) === null || ref === void 0 ? void 0 : ref.length,
        onCompleted
    ]);
    if (searching && !(searchResults === null || searchResults === void 0 ? void 0 : (ref1 = searchResults.hits) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            sx: {
                px: 5,
                py: 2
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                container: true,
                spacing: 3,
                children: Array.from(Array(9).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        size: {
                            xs: 4,
                            md: 3
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_20__/* .StoreItemAreaSkeleton */ .E, {})
                    }, key);
                })
            })
        });
    }
    if (!searching && !(searchResults === null || searchResults === void 0 ? void 0 : (ref2 = searchResults.hits) === null || ref2 === void 0 ? void 0 : ref2.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
            variant: "body1",
            align: "center",
            sx: {
                py: 6
            },
            color: "text.secondary",
            children: t("itemEmpty")
        });
    }
    return null;
});
var StoreItemsInfiniteHits = (0,react_instantsearch_dom__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, artistId = param.artistId, userLoggedInId = param.userLoggedInId, onSelectItem = param.onSelectItem, refineNext = param.refineNext;
    var items = hits.map(function(_param) {
        var objectID = _param.objectID, item = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_param, [
            "objectID"
        ]);
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
            id: objectID
        }, item);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreItemsCell, {
        items: items,
        artistId: artistId,
        userLoggedInId: userLoggedInId,
        hasNextPage: hasMore,
        onSelectItem: onSelectItem,
        onFetchMore: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                return [
                    2,
                    refineNext()
                ];
            });
        })
    });
});
var StoreItemsCell = function(param) {
    var hasNextPage = param.hasNextPage, artistId = param.artistId, userLoggedInId = param.userLoggedInId, items = param.items, onFetchMore = param.onFetchMore, onSelectItem = param.onSelectItem;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_25__/* .CellFrame */ .p, {
        sx: {
            px: 5,
            py: 2
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_functionals__WEBPACK_IMPORTED_MODULE_26__/* .ScrollFetcher */ .x, {
            loading: false,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: _mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z,
            componentProps: {
                spacing: 3,
                container: true
            },
            itemComponent: _mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z,
            itemComponentProps: {
                size: {
                    xs: 4,
                    md: 3
                }
            },
            nodes: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_27__/* .StoreItemArea */ .S, {
                    item: item,
                    artistId: artistId,
                    onClick: onSelectItem,
                    showMenberOnlyIcon: true
                }, index);
            }),
            emptyMessage: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
        })
    });
};


/***/ }),

/***/ 48354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ThreadCreatePreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81714);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12363);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79312);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43411);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24038);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14971);
/* harmony import */ var _components_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58015);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95626);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93893);









var ThreadCreatePreview = function(param) {
    var artistId = param.artistId, thread = param.thread, user = param.user, categoryOptions = param.categoryOptions, onClose = param.onClose;
    var t = (0,_core__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("threadCreate").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styles__WEBPACK_IMPORTED_MODULE_4__/* .ArtistThemeProvider */ .rr, {
        artistId: artistId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts__WEBPACK_IMPORTED_MODULE_5__/* .BaseLayout */ .I, {
            header: {
                left: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_2__.IconButton.Back, {
                    edge: "start",
                    size: "medium",
                    onClick: onClose
                }),
                title: t("titlePreview")
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ThreadTitleCell, {
                    thread: thread,
                    user: user,
                    categoryOptions: categoryOptions
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ThreadTextAreaCell, {
                    description: thread.description
                })
            ]
        })
    });
};
var ThreadTitleCell = function(param) {
    var thread = param.thread, user = param.user, categoryOptions = param.categoryOptions;
    var ref, ref1, ref2;
    var category = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return categoryOptions === null || categoryOptions === void 0 ? void 0 : categoryOptions.find(function(category) {
            return category.value === thread.category;
        });
    }, [
        categoryOptions,
        thread.category
    ]);
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_core_architecture__WEBPACK_IMPORTED_MODULE_6__/* .CellFrame */ .p, {
        children: [
            ((ref = thread.thumbnail) === null || ref === void 0 ? void 0 : ref.fileUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                src: (ref1 = thread.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.fileUrl,
                variant: "square",
                sx: {
                    width: "100%",
                    height: 281,
                    pb: 5
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        variant: "h4",
                        children: thread.name
                    }),
                    !!category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms__WEBPACK_IMPORTED_MODULE_10__/* .ThreadCategory */ .v, {
                        category: category.label,
                        isOfficial: false,
                        sx: {
                            mt: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            pt: 3
                        },
                        spacing: 2,
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                src: (ref3 = user === null || user === void 0 ? void 0 : (ref2 = user.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref3 !== void 0 ? ref3 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ThreadTextAreaCell = function(param) {
    var description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_architecture__WEBPACK_IMPORTED_MODULE_6__/* .CellFrame */ .p, {
        sx: {
            px: 5,
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            variant: "body1",
            sx: {
                wordBreak: "break-all"
            },
            children: description
        })
    });
};


/***/ }),

/***/ 32988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DS": function() { return /* binding */ ActionLinkCell; },
  "e$": function() { return /* binding */ ThreadCreateTemplate; }
});

// UNUSED EXPORTS: fragments

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var schema = __webpack_require__(66517);
// EXTERNAL MODULE: ./src/components/layouts/Head.tsx
var Head = __webpack_require__(15512);
// EXTERNAL MODULE: ./src/components/layouts/BaseLayout.tsx + 4 modules
var BaseLayout = __webpack_require__(24038);
// EXTERNAL MODULE: ./src/components/lib/BrowserLink/index.tsx
var BrowserLink = __webpack_require__(3405);
// EXTERNAL MODULE: ./src/components/organisms/functionals/FullscreenModal/index.tsx
var FullscreenModal = __webpack_require__(2977);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/messages/useMessage.tsx
var useMessage = __webpack_require__(30226);
// EXTERNAL MODULE: ./src/core/form/index.ts + 1 modules
var core_form = __webpack_require__(38679);
// EXTERNAL MODULE: ./src/core/architecture/components/index.tsx
var components = __webpack_require__(93893);
// EXTERNAL MODULE: ./src/lib/helpUrl/index.tsx
var helpUrl = __webpack_require__(16);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/components/pages/ThreadCreate/template/CommunityNoteModal.tsx








var CommunityNoteModal_schema = function(o) {
    return {
        accept: o.boolean().optional().label((0,core_form/* tLabel */.TQ)("threadCreate.accept"))
    };
};
var CommunityNoteModal = function(param) {
    var open = param.open, onSubmit = param.onSubmit;
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: CommunityNoteModal_schema,
        defaultValues: {
            accept: false
        }
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: function() {},
        title: t("communityNoteTitle"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    align: "left",
                    children: t("communityNoteDesc1")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "caption",
                    align: "left",
                    children: t("communityNoteDesc2")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        pb: 7,
                        pt: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxButtonCell, (0,_object_spread/* default */.Z)({
                        label: t("notDisplayNextTime"),
                        error: errors === null || errors === void 0 ? void 0 : errors.accept
                    }, register("accept")))
                })
            ]
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            loading: isSubmitting,
            disabled: isSubmitting,
            onClick: handleSubmit(onSubmit),
            children: t("ok")
        })
    });
};
var CheckboxButtonCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CheckboxButtonField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(12363);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(81714);
// EXTERNAL MODULE: ../../node_modules/@mui/material/List/List.js
var List = __webpack_require__(81774);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItem/ListItem.js
var ListItem = __webpack_require__(35488);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(82056);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(94106);
// EXTERNAL MODULE: ./src/components/organisms/imageEditor/useImageEditor.tsx
var useImageEditor = __webpack_require__(22019);
// EXTERNAL MODULE: ./src/core/form/Form.tsx
var Form = __webpack_require__(35625);
;// CONCATENATED MODULE: ./src/components/pages/ThreadCreate/template/ThreadCreateForm.tsx














var ThreadCreateForm_schema = function(o) {
    return {
        thumbnail: o.object({
            tmpPath: o.string().allow("").optional(),
            fileUrl: o.string().allow("").optional()
        }).allow("").optional(),
        name: o.string().label((0,core_form/* tLabel */.TQ)("threadCreate.name")),
        description: o.string().label((0,core_form/* tLabel */.TQ)("threadCreate.description")),
        category: o.string().label((0,core_form/* tLabel */.TQ)("threadCreate.category")).allow("").optional(),
        isPremium: o.boolean().label((0,core_form/* tLabel */.TQ)("threadCreate.isPremium")).allow(false).optional()
    };
};
var defaultValues = {
    name: "",
    description: "",
    thumbnail: {
        tmpPath: "",
        fileUrl: ""
    },
    isPremium: false,
    category: undefined
};
var ThreadCreateForm = function(param) {
    var hasPatron = param.hasPatron, onSubmit = param.onSubmit, register = param.register, errors = param.errors, control = param.control, setValue = param.setValue, categoryOptions = param.categoryOptions, userId = param.userId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCell, {
                setValue: setValue,
                userId: userId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.name
                    }, register("name")), {
                        textFieldProps: {
                            minRows: 1,
                            maxRows: 5,
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography.h4;
                                }
                            },
                            variant: "standard",
                            InputProps: {
                                sx: {
                                    border: "none",
                                    px: 0,
                                    pt: 5,
                                    pb: 0
                                },
                                disableUnderline: true
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.description
                    }, register("description")), {
                        textFieldProps: {
                            minRows: 3,
                            maxRows: 10,
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography.body1;
                                }
                            },
                            variant: "standard",
                            InputProps: {
                                sx: {
                                    border: "none",
                                    px: 0,
                                    pt: 5,
                                    pb: 0
                                },
                                disableUnderline: true
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingTextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadTypeCell, {
                        control: control,
                        setValue: setValue,
                        categoryOptions: categoryOptions
                    }),
                    hasPatron && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberSetCell, {
                        control: control,
                        setValue: setValue
                    })
                ]
            })
        ]
    });
};
var ImageCell = function(param) {
    var setValue = param.setValue, userId = param.userId;
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    var ref = (0,useImageEditor/* useImageEditor */.O)({
        userId: userId,
        callback: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        setValue("thumbnail", data, {
                            shouldDirty: true
                        })
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    }), ImageEditModal = ref.ImageEditModal, ModalProps = ref.ModalProps, handleChoseFile = ref.handleChoseFile, handleRemoveFile = ref.handleRemoveFile, filePathAfterCrop = ref.filePathAfterCrop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            filePathAfterCrop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: filePathAfterCrop,
                        variant: "square",
                        sx: {
                            width: "100%",
                            height: 281
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        onClick: handleRemoveFile,
                        size: "small",
                        bgcolor: "grey.50",
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 1
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        ml: -2
                    },
                    onClick: handleChoseFile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Image, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            sx: {
                                ml: 2
                            },
                            children: t("attachImage")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageEditModal, (0,_object_spread/* default */.Z)({}, ModalProps))
        ]
    });
};
var TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var textFieldProps = _param.textFieldProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "textFieldProps"
    ]);
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            textFieldProps: (0,_object_spread/* default */.Z)({
                sx: {
                    p: 0,
                    m: 0,
                    bgcolor: "transparent",
                    width: "100%"
                },
                multiline: true,
                helperText: ""
            }, textFieldProps)
        }))
    });
});
var HeadingTextCell = function() {
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: t("selectCategory")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "overline",
                    children: t("any")
                })
            ]
        })
    });
};
var ThreadTypeCell = function(param) {
    var control = param.control, setValue = param.setValue, categoryOptions = param.categoryOptions;
    var category = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "category"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
            value: category,
            tags: categoryOptions,
            onClick: function(value) {
                return setValue("category", category === value ? undefined : value);
            }
        })
    });
};
var MemberSetCell = function(param) {
    var control = param.control, setValue = param.setValue;
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    var isPremium = (0,index_esm/* useWatch */.qo)({
        control: control,
        name: "isPremium"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                    secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                        checked: isPremium,
                        onChange: function(event, checked) {
                            setValue("isPremium", checked);
                        }
                    }),
                    sx: {
                        p: 0,
                        ".MuiListItemSecondaryAction-root": {
                            right: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                        primary: t("membersOnly"),
                        slotProps: {
                            primary: {
                                variant: "subtitle1"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                sx: {
                    pt: 3,
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                        fontSize: "xSmall"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("membersOnlyNote")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/pages/ThreadCreate/template/ThreadCreatePreview.tsx
var ThreadCreatePreview = __webpack_require__(48354);
;// CONCATENATED MODULE: ./src/components/pages/ThreadCreate/template/index.tsx

















var ThreadCreateTemplate = function(param) {
    var state = param.state, onCreateThread = param.onCreateThread, // onSaveDraft,
    onAcceptCommunityNote = param.onAcceptCommunityNote;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    var ref5 = (0,useRouter/* useRouter */.tv)(), router = ref5.router, generatePath = ref5.generatePath, routerPages = ref5.routerPages, routerNames = ref5.routerNames;
    var ref6;
    var defaultBackPage = generatePath(routerPages.ArtistThreads, {
        artistId: (ref6 = (ref = state.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref6 !== void 0 ? ref6 : "#"
    });
    var ref7 = (0,useMessage/* useMessage */.UD)(), showMessage = ref7.showMessage, showError = ref7.showError;
    var ref8 = (0,react.useState)(false), open = ref8[0], setOpen = ref8[1];
    var ref9 = (0,react.useState)(false), artistDraftSaving = ref9[0], setArtistDraftSaving = ref9[1];
    var ref10 = (0,react.useState)(false), artistCreating = ref10[0], setArtistCreating = ref10[1];
    var ref11 = (0,react.useState)(false), openPreview = ref11[0], setOpenPreview = ref11[1];
    var ref12 = (0,core_form/* useForm */.cI)({
        schema: ThreadCreateForm_schema,
        defaultValues: defaultValues
    }), handleSubmit = ref12.handleSubmit, register = ref12.register, control = ref12.control, setValue = ref12.setValue, getValues = ref12.getValues, setError = ref12.setError, _formState = ref12.formState, errors = _formState.errors, isValid = _formState.isValid;
    var categoryOptions = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            return {
                value: category,
                label: t([
                    "category_".concat(category),
                    category
                ])
            };
        });
    }, [
        t
    ]);
    var onSubmit = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setArtistCreating(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            onCreateThread(values)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            router.goBack(defaultBackPage)
                        ];
                    case 3:
                        _state.sent();
                        showMessage(t("postComplete"), "success");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        (0,core_form/* handleError */.S3)(error, setError, showError);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setArtistCreating(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleSaveDraft = handleSubmit(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            setArtistDraftSaving(true);
            try {
                ;
                ;
                /**
       * @description
       * 下書き保存機能は別タスクにて実装
       * https://app.clickup.com/t/908127/UT-5151
       *
       * await onSaveDraft(values)
       * setOpen(false)
       */ router.goBack(generatePath(routerPages.ArtistThreads, {
                    artistId: (ref1 = (ref = state.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "#"
                }));
            } catch (error) {
                showError(error);
            }
            setArtistDraftSaving(false);
            return [
                2
            ];
        });
    }));
    var handleShowPreview = (0,react.useCallback)(function() {
        setOpenPreview(true);
    }, []);
    var handleCloseWithoutSave = (0,react.useCallback)(function() {
        setOpen(false);
        router.goBack(defaultBackPage);
    }, [
        router,
        (ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    var ref13, _user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistThreadCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "threadForm",
                    props: {
                        disabled: !isValid,
                        onConfirmSaveDraft: handleSaveDraft,
                        onShowPreview: handleShowPreview
                    }
                },
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: function() {
                            /**
                 * @description
                 * 下書き保存機能は別タスクにて実装
                 * https://app.clickup.com/t/908127/UT-5151
                 *
                 * if (isDirty) {
                 *  setOpen(true)
                 *  return
                 * }
                 */ return router.goBack(defaultBackPage);
                        }
                    }),
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        size: "small",
                        disabled: !isValid,
                        loading: artistCreating,
                        onClick: onSubmit,
                        sx: {
                            mr: -1
                        },
                        children: t("public")
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCreateForm, {
                        hasPatron: !!((ref2 = state.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.patron) === null || ref3 === void 0 ? void 0 : ref3.id),
                        control: control,
                        errors: errors,
                        onSubmit: onSubmit,
                        register: register,
                        setValue: setValue,
                        categoryOptions: categoryOptions,
                        userId: (ref13 = (ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref13 !== void 0 ? ref13 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeTextCell, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityNoteModal, {
                open: state.openCommunityNote,
                onSubmit: onAcceptCommunityNote
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("draftTitle"),
                content: t("draftDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            loading: artistDraftSaving,
                            onClick: handleSaveDraft,
                            children: t("saveToDraft")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "outlined",
                            color: "primary",
                            size: "large",
                            disabled: artistDraftSaving,
                            onClick: handleCloseWithoutSave,
                            children: t("closeWithoutSave")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
                open: openPreview,
                onClose: function() {
                    return setOpenPreview(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCreatePreview/* ThreadCreatePreview */.d, {
                    onClose: function() {
                        return setOpenPreview(false);
                    },
                    thread: getValues(),
                    categoryOptions: categoryOptions,
                    user: (_user = state.user) !== null && _user !== void 0 ? _user : null
                })
            })
        ]
    });
};
var ActionLinkCell = function(param) {
    var onConfirmSaveDraft = param.onConfirmSaveDraft, onShowPreview = param.onShowPreview, disabled = param.disabled;
    var t = (0,i18n/* useTranslation */.$G)("threadCreate").t;
    var actions = [
        {
            title: t("saveDraft"),
            onClick: onConfirmSaveDraft
        },
        {
            title: t("preview"),
            onClick: onShowPreview
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            bgcolor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            spacing: 3,
            sx: {
                p: 3
            },
            children: actions.map(function(action, index) {
                /**
           * @description
           * 下書き保存機能は別タスクにて実装
           * https://app.clickup.com/t/908127/UT-5151
           */ if (action.title === t("saveDraft")) return;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "text",
                    onClick: action.onClick,
                    disabled: disabled,
                    disableElevation: true,
                    sx: {
                        bgcolor: "transparent",
                        color: "text.primary",
                        "&.Mui-disabled": {
                            bgcolor: "transparent",
                            color: "text.disabled"
                        }
                    },
                    children: action.title
                }, index);
            })
        })
    });
};
var categories = [
    schema/* ArtistThreadCategory.TradeCall */.KCB.TradeCall,
    schema/* ArtistThreadCategory.Event */.KCB.Event,
    schema/* ArtistThreadCategory.Request */.KCB.Request,
    schema/* ArtistThreadCategory.Faq */.KCB.Faq, 
];
var NoticeTextCell = function() {
    var t = (0,i18n/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 1,
            px: 5,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                        variant: "caption",
                        href: (0,helpUrl/* getHelpUrl */.R)("thread"),
                        children: t("noticePrefix")
                    }),
                    t("noticeSuffix")
                ]
            })
        })
    });
};


/***/ }),

/***/ 74389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dz": function() { return /* binding */ useViewModel; },
/* harmony export */   "Qq": function() { return /* binding */ QUERY; },
/* harmony export */   "T8": function() { return /* binding */ CREATE_SHORT_LINK_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85697);
/* harmony import */ var _capacitor_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23807);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81548);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66582);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90860);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61631);
/* harmony import */ var _core_architecture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89693);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query shortLink($shortLinkId: ID!) {\n    shortLink(id: $shortLinkId) {\n      id\n      redirectUrl\n      shortLink\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateShortLink($redirectUrl: String!) {\n    createShortLink(redirectUrl: $redirectUrl) {\n      createdAt\n      id\n      redirectUrl\n      shortLink\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var useViewModel = (0,_core_architecture__WEBPACK_IMPORTED_MODULE_4__/* .makeViewModel */ .e)(function() {
    var router = (0,_core__WEBPACK_IMPORTED_MODULE_5__/* .useRouter */ .tv)().router;
    var shortLinkId = router.pathname.split("ulink/").pop();
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .aM)(QUERY, {
        variables: {
            shortLinkId: shortLinkId !== null && shortLinkId !== void 0 ? shortLinkId : ""
        }
    }).data;
    var isMobile = react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt || react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isIOS */ .gn;
    var isNative = _capacitor_core__WEBPACK_IMPORTED_MODULE_1__/* .Capacitor.isNativePlatform */ .dV.isNativePlatform();
    var isWebOnly = !_config__WEBPACK_IMPORTED_MODULE_7__/* .config.platform.includes */ .v.platform.includes("native");
    var isNativeOpenRequired = isMobile && !isNative && !isWebOnly;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // ネイティブで開く処理の必要がある場合はディープリンク起動・ストア遷移を行う
        if (!isNativeOpenRequired) return;
        var url = window.location.href;
        var strippedUrl = url.replace(/^https?:\/\//, "");
        // URLスキーマを使用してディープリンクURLを生成
        var appUrl = react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt ? "".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .config.appInfo.android.bundleId */ .v.appInfo.android.bundleId, "://").concat(strippedUrl) : "".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .config.appInfo.ios.bundleId */ .v.appInfo.ios.bundleId, "://").concat(strippedUrl);
        // ディープリンクを開く処理
        if (react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isIOS */ .gn) window.location.href = appUrl;
        if (react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt) {
            var link = document.createElement("a");
            link.href = appUrl;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        // 一定時間後にストアへリダイレクト
        var now = Date.now();
        var timeout = 2000;
        setTimeout(function() {
            if (Date.now() - now < timeout + 100) {
                window.location.href = react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt ? "https://play.google.com/store/apps/details?id=".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .config.appInfo.android.bundleId */ .v.appInfo.android.bundleId) : "https://apps.apple.com/app/id".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* .config.appInfo.ios.storeId */ .v.appInfo.ios.storeId);
            }
        }, timeout);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // ネイティブで開く処理の必要がない場合はリンク先に遷移
        if (!isNativeOpenRequired && (data === null || data === void 0 ? void 0 : data.shortLink)) {
            var redirectUrl = new URL(data.shortLink.redirectUrl);
            // deepLinkの場合stateにフラグを追加
            router.replace(redirectUrl.pathname, {
                fromDeeplink: _capacitor_core__WEBPACK_IMPORTED_MODULE_1__/* .Capacitor.isNativePlatform */ .dV.isNativePlatform()
            });
        }
    }, [
        data
    ]);
    return {
        state: {},
        actions: {}
    };
});
var QUERY = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_templateObject());
var CREATE_SHORT_LINK_QUERY = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_templateObject1());


/***/ }),

/***/ 51207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H6l": function() { return /* reexport */ AccountSettings; },
  "V$s": function() { return /* reexport */ ArtistCollections; },
  "AZI": function() { return /* reexport */ ArtistEvents; },
  "DKl": function() { return /* reexport */ ArtistGachas; },
  "yyr": function() { return /* reexport */ ArtistGallery; },
  "wuo": function() { return /* reexport */ ArtistMembership; },
  "pMe": function() { return /* reexport */ ArtistMembershipCompletion; },
  "_W": function() { return /* reexport */ ArtistMembershipFavoriteMembersSelect; },
  "mS": function() { return /* reexport */ ArtistMembershipPaymentEdit; },
  "lss": function() { return /* reexport */ ArtistMembershipPurchaseConfirmation; },
  "lJr": function() { return /* reexport */ ArtistMembershipPurchaseProceed; },
  "hs0": function() { return /* reexport */ ArtistMissions; },
  "vBf": function() { return /* reexport */ ArtistMyCollections; },
  "FHq": function() { return /* reexport */ ArtistOfficialInformation; },
  "lQ": function() { return /* reexport */ ArtistPostVideos; },
  "OhA": function() { return /* reexport */ ArtistPosts; },
  "_Dp": function() { return /* reexport */ ArtistRanking; },
  "mOt": function() { return /* reexport */ ArtistSearch; },
  "Dmk": function() { return /* reexport */ ArtistStore; },
  "EJh": function() { return /* reexport */ ArtistStoreItemDetail; },
  "Qqj": function() { return /* reexport */ ArtistThreads; },
  "kMv": function() { return /* reexport */ ArtistTop; },
  "jBn": function() { return /* reexport */ ArtistTrade; },
  "$OV": function() { return /* reexport */ AutoFollowSettings; },
  "qVm": function() { return /* reexport */ BankCreate; },
  "MP7": function() { return /* reexport */ CampaignDetail; },
  "xOh": function() { return /* reexport */ CollectionDetail; },
  "fz": function() { return /* reexport */ CollectionItemDetail_CollectionItemDetail; },
  "ZSW": function() { return /* reexport */ ConsoleAccountSetting; },
  "HOA": function() { return /* reexport */ ConsoleBankEdit; },
  "gwy": function() { return /* reexport */ ConsoleBusinessEdit; },
  "uOF": function() { return /* reexport */ ConsoleCampaignBannerSetting; },
  "fjw": function() { return /* reexport */ ConsoleCampaignDetail; },
  "gC_": function() { return /* reexport */ ConsoleCampaigns; },
  "Zsy": function() { return /* reexport */ ConsoleCollectionCreate; },
  "XF0": function() { return /* reexport */ ConsoleCollectionDetail; },
  "FJR": function() { return /* reexport */ ConsoleCollectionEdit; },
  "or1": function() { return /* reexport */ ConsoleCollections; },
  "a60": function() { return /* reexport */ ConsoleCryptocurrencyWallet; },
  "S4W": function() { return /* reexport */ ConsoleDeliveryManagement; },
  "L7K": function() { return /* reexport */ ConsoleDigitalMembershipCard; },
  "XdA": function() { return /* reexport */ ConsoleDigitalMembershipCardDesignEdit; },
  "G3B": function() { return /* reexport */ ConsoleDigitalMembershipDefaultCardDesignEdit; },
  "hZN": function() { return /* reexport */ ConsoleDmRoomCreate; },
  "dvk": function() { return /* reexport */ ConsoleDmRoomDetail; },
  "Lnk": function() { return /* reexport */ ConsoleDmRooms; },
  "aPE": function() { return /* reexport */ ConsoleEventCollectionReceiveTimeEdit; },
  "AVD": function() { return /* reexport */ ConsoleEventCreate; },
  "FSQ": function() { return /* reexport */ ConsoleEventDetail_ConsoleEventDetail; },
  "sI5": function() { return /* reexport */ ConsoleEventEdit; },
  "lnt": function() { return /* reexport */ ConsoleEvents; },
  "Uxg": function() { return /* reexport */ ConsoleFans; },
  "Ksz": function() { return /* reexport */ ConsoleFavoriteMemberCreate; },
  "BYx": function() { return /* reexport */ ConsoleFavoriteMemberEdit; },
  "co7": function() { return /* reexport */ ConsoleFavoriteMemberSettings; },
  "N3D": function() { return /* reexport */ ConsoleHome; },
  "oWE": function() { return /* reexport */ ConsoleItemCreate; },
  "Q1z": function() { return /* reexport */ ConsoleItemDetail; },
  "n7G": function() { return /* reexport */ ConsoleItemEdit; },
  "pCC": function() { return /* reexport */ ConsoleItemInformation; },
  "ljQ": function() { return /* reexport */ ConsoleItemInformationLimitUser; },
  "T_7": function() { return /* reexport */ ConsoleItemOrders; },
  "YRc": function() { return /* reexport */ ConsoleItems; },
  "s8B": function() { return /* reexport */ ConsoleLotteryCsvUpload; },
  "xSR": function() { return /* reexport */ ConsoleLotteryManagementDetail; },
  "BTm": function() { return /* reexport */ ConsoleLotteryManagements; },
  "OhI": function() { return /* reexport */ ConsoleMembership; },
  "sSr": function() { return /* reexport */ ConsoleMembershipCreate; },
  "cEH": function() { return /* reexport */ ConsoleMembershipDetail; },
  "_15": function() { return /* reexport */ ConsoleMembershipEdit; },
  "Ucn": function() { return /* reexport */ ConsoleMembershipExplain; },
  "AKH": function() { return /* reexport */ ConsoleMissionCreate; },
  "ugd": function() { return /* reexport */ ConsoleMissionEdit; },
  "MN2": function() { return /* reexport */ ConsoleMissions; },
  "wZl": function() { return /* reexport */ ConsoleMyProfileEdit; },
  "d4r": function() { return /* reexport */ ConsoleOfficialInformationCreate; },
  "SXj": function() { return /* reexport */ ConsoleOfficialInformationEdit; },
  "NV8": function() { return /* reexport */ ConsoleOfficialInformations; },
  "Zf9": function() { return /* reexport */ ConsoleOrderDetail; },
  "uri": function() { return /* reexport */ ConsoleOrders; },
  "rmN": function() { return /* reexport */ ConsolePostCategories; },
  "qt_": function() { return /* reexport */ ConsolePostCreate; },
  "Ftt": function() { return /* reexport */ ConsolePostDetail; },
  "dKc": function() { return /* reexport */ ConsolePostEdit; },
  "fxg": function() { return /* reexport */ ConsolePosts; },
  "Hmn": function() { return /* reexport */ ConsolePreSaleCreate; },
  "tJA": function() { return /* reexport */ ConsolePreSaleDetail; },
  "lqo": function() { return /* reexport */ ConsolePreSaleEdit; },
  "Zgz": function() { return /* reexport */ ConsoleQuantityManagements; },
  "lye": function() { return /* reexport */ ConsoleRevenue; },
  "X2Y": function() { return /* reexport */ ConsoleTicketReceiveDetail; },
  "PCT": function() { return /* reexport */ ConsoleTicketReceives; },
  "yJV": function() { return /* reexport */ ConsoleUnpublishedPosts; },
  "EVb": function() { return /* reexport */ ConsoleUserDetail; },
  "QMV": function() { return /* reexport */ ConsoleUserOrders; },
  "c_t": function() { return /* reexport */ ConsoleUserOwnedItemDetail; },
  "Cxh": function() { return /* reexport */ ConsoleUserOwnedItems; },
  "ZWJ": function() { return /* reexport */ ConsoleUsers; },
  "kXB": function() { return /* reexport */ CustomProfileEditAvatar; },
  "Ynv": function() { return /* reexport */ CustomProfileEditWallPaper; },
  "gFD": function() { return /* reexport */ Deactivation; },
  "yYb": function() { return /* reexport */ DeactivationCompletion; },
  "iMT": function() { return /* reexport */ DeactivationConfirm; },
  "ulh": function() { return /* reexport */ DeliveryInfoSetting; },
  "dSy": function() { return /* reexport */ DeliveryManagement; },
  "PCb": function() { return /* reexport */ DigitalMembershipCardDetail; },
  "uIQ": function() { return /* reexport */ DmRoomDetail; },
  "xNg": function() { return /* reexport */ DmRooms; },
  "iKq": function() { return /* reexport */ EmailAddressSettings; },
  "Mey": function() { return /* reexport */ EmailNotificationSettings; },
  "aCz": function() { return /* reexport */ EventCollectionDetail; },
  "XzK": function() { return /* reexport */ EventDetail; },
  "zW2": function() { return /* reexport */ Events; },
  "VHT": function() { return /* reexport */ FavoriteMembersSelect; },
  "uRn": function() { return /* reexport */ FirstComeFirstServedComplete; },
  "$Lu": function() { return /* reexport */ FirstComeFirstServedConfirmation; },
  "n$4": function() { return /* reexport */ FirstComeFirstServedDetail; },
  "AoV": function() { return /* reexport */ GachaDetail; },
  "nvJ": function() { return /* reexport */ GachaItemList; },
  "q$b": function() { return /* reexport */ GachaResult; },
  "rr": function() { return /* reexport */ GlobalArtist; },
  "NwO": function() { return /* reexport */ GlobalCollections; },
  "xN8": function() { return /* reexport */ GlobalEvents; },
  "XC0": function() { return /* reexport */ GlobalHome; },
  "pv4": function() { return /* reexport */ HtmlFormRelay; },
  "jK": function() { return /* reexport */ Integrations; },
  "p0J": function() { return /* reexport */ ItemComment; },
  "fNm": function() { return /* reexport */ ItemInformation; },
  "iJD": function() { return /* reexport */ ItemMissions; },
  "u_n": function() { return /* reexport */ ItemOrders; },
  "W8D": function() { return /* reexport */ LanguageSetting; },
  "IDo": function() { return /* reexport */ LotteryApplicationDetail; },
  "vvH": function() { return /* reexport */ LotteryApplicationDetailCancelCompletion; },
  "N9T": function() { return /* reexport */ LotteryApplicationDetailPaymentConfirmation; },
  "Wwf": function() { return /* reexport */ LotteryApplications; },
  "Eed": function() { return /* reexport */ LotteryCompletion; },
  "pZd": function() { return /* reexport */ LotteryConfirmation; },
  "kaH": function() { return /* reexport */ LotteryDeliveryInfo; },
  "q$1": function() { return /* reexport */ LotteryDetail; },
  "tJe": function() { return /* reexport */ LotteryUserInfo; },
  "VVl": function() { return /* reexport */ MailAuth; },
  "ffM": function() { return /* reexport */ MailAuthArtist; },
  "cpb": function() { return /* reexport */ MailRegister; },
  "O_g": function() { return /* reexport */ Management; },
  "EAI": function() { return /* reexport */ Membership; },
  "xc3": function() { return /* reexport */ MissionAccomplished; },
  "txQ": function() { return /* reexport */ MissionDetail; },
  "vDy": function() { return /* reexport */ MyOwnedTicketDetail; },
  "ctU": function() { return /* reexport */ MyOwnedTickets; },
  "D0g": function() { return /* reexport */ MyOwnedTicketsEventSelection; },
  "xzH": function() { return /* reexport */ MyOwnedTicketsHistory; },
  "F9T": function() { return /* reexport */ MyProfile; },
  "vKD": function() { return /* reexport */ MyProfileEdit; },
  "vyk": function() { return /* reexport */ MyRanking; },
  "utA": function() { return /* reexport */ MyTickets; },
  "_Ut": function() { return /* reexport */ MyTrade; },
  "H5z": function() { return /* reexport */ MyTradeDetail; },
  "sP8": function() { return /* reexport */ NewStoreItems; },
  "d7Q": function() { return /* reexport */ NftItemDetail; },
  "xOD": function() { return /* reexport */ NftItems; },
  "TXS": function() { return /* reexport */ NotFound/* NotFound */.T; },
  "Da7": function() { return /* reexport */ NotificationDetail; },
  "Tx5": function() { return /* reexport */ Notifications; },
  "Cg3": function() { return /* reexport */ OfficialInformation; },
  "FDG": function() { return /* reexport */ OfficialInformationDetail; },
  "eCe": function() { return /* reexport */ OwnedItemDetail; },
  "dcQ": function() { return /* reexport */ OwnedItems; },
  "CVq": function() { return /* reexport */ PasswordReset; },
  "qo2": function() { return /* reexport */ PasswordResetSend; },
  "B4r": function() { return /* reexport */ PasswordSettings; },
  "iwk": function() { return /* reexport */ PaymentCreate; },
  "bEB": function() { return /* reexport */ PaymentDetail; },
  "wIn": function() { return /* reexport */ PaymentStatusDetail; },
  "dnk": function() { return /* reexport */ PaymentStatuses; },
  "xgR": function() { return /* reexport */ PersonalInfoSettings; },
  "Zxd": function() { return /* reexport */ PostDetail; },
  "_BU": function() { return /* reexport */ PostVideoDetailModal; },
  "QS7": function() { return /* reexport */ PrepaidPointCharge; },
  "qaz": function() { return /* reexport */ PrepaidPointOrders; },
  "bEj": function() { return /* reexport */ PrivacySettings; },
  "wCB": function() { return /* reexport */ ProfileInputArtist; },
  "a3T": function() { return /* reexport */ PushNotificationSettings; },
  "Tgj": function() { return /* reexport */ QRCodeGetGachaTicket; },
  "iub": function() { return /* reexport */ QRcodeGetItem; },
  "ipW": function() { return /* reexport */ QRcodeGetItemMulti; },
  "$Sw": function() { return /* reexport */ RecentViewedItems; },
  "ohc": function() { return /* reexport */ RecommendCollections; },
  "gnz": function() { return /* reexport */ ReplyDetail; },
  "TMm": function() { return /* reexport */ ResaleApplicationCreate; },
  "P12": function() { return /* reexport */ ResaleApplicationCreateCompletion; },
  "WCg": function() { return /* reexport */ ResaleApplicationCreateConfirmation; },
  "yBq": function() { return /* reexport */ ResaleApplicationCreatePrecaution; },
  "sOt": function() { return /* reexport */ ResaleApplicationDetail; },
  "vt_": function() { return /* reexport */ ResaleCreate; },
  "I6m": function() { return /* reexport */ ResaleCreateCompletion; },
  "dsu": function() { return /* reexport */ ResaleCreateConfirmation; },
  "T5q": function() { return /* reexport */ ResaleCreatePrecaution; },
  "YJt": function() { return /* reexport */ ResaleDetail; },
  "KH6": function() { return /* reexport */ ResaleManagement; },
  "SA9": function() { return /* reexport */ ResaleRaffleDetail; },
  "qd9": function() { return /* reexport */ ResaleRaffleDetailCancelCompletion; },
  "Mtd": function() { return /* reexport */ ResaleRaffleRepaymentCompletion; },
  "wUo": function() { return /* reexport */ ResaleRaffleRepaymentConfirmation; },
  "dHm": function() { return /* reexport */ SMSVerification; },
  "AQK": function() { return /* reexport */ SerialNumberSelect_SerialNumberSelect; },
  "Zrf": function() { return /* reexport */ Settings; },
  "Mo2": function() { return /* reexport */ SignUp; },
  "XiG": function() { return /* reexport */ SignUpArtist; },
  "r9D": function() { return /* reexport */ StoreCartDetail; },
  "hdV": function() { return /* reexport */ StoreCartList; },
  "IjM": function() { return /* reexport */ StoreCollectionDetails; },
  "cAB": function() { return /* reexport */ StoreCollectionsSelect; },
  "W1F": function() { return /* reexport */ StoreDeliveryInfo; },
  "F5d": function() { return /* reexport */ StoreItemCompleteFree; },
  "MoX": function() { return /* reexport */ StoreItemPurchaseComplete; },
  "hov": function() { return /* reexport */ StoreItemPurchaseConfirmation; },
  "S70": function() { return /* reexport */ StoreItemPurchaseProceed; },
  "PIV": function() { return /* reexport */ StorePurchaseOrderDetail; },
  "B0p": function() { return /* reexport */ StorePurchaseOrders; },
  "u4O": function() { return /* reexport */ StoreRequestProvidableItemSearch; },
  "EUp": function() { return /* reexport */ StoreUserInfo; },
  "ORV": function() { return /* reexport */ ThreadCreate; },
  "WI6": function() { return /* reexport */ ThreadDetail; },
  "E5t": function() { return /* reexport */ ThreadEdit; },
  "r$3": function() { return /* reexport */ TicketCharge; },
  "gan": function() { return /* reexport */ TicketOrders; },
  "xRu": function() { return /* reexport */ TicketShareConfirm; },
  "mW0": function() { return /* reexport */ TicketShareCopy; },
  "Mje": function() { return /* reexport */ TicketShareSelect; },
  "e4k": function() { return /* reexport */ Top; },
  "Cg1": function() { return /* reexport */ Tutorial; },
  "$mS": function() { return /* reexport */ Ulink; },
  "ieO": function() { return /* reexport */ UserItemDetail; },
  "pJI": function() { return /* reexport */ UserOwnedItems; },
  "Iw3": function() { return /* reexport */ UserProfile; },
  "K3K": function() { return /* reexport */ UserTradeDetail; },
  "w5x": function() { return /* reexport */ Wallet; }
});

// UNUSED EXPORTS: Component, ConsoleData, ServerError

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/List/List.js
var List_List = __webpack_require__(81774);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography_Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/components/layouts/BaseLayout.tsx + 4 modules
var BaseLayout = __webpack_require__(24038);
// EXTERNAL MODULE: ./src/components/layouts/Head.tsx
var Head = __webpack_require__(15512);
// EXTERNAL MODULE: ./src/config/config.ts
var config_config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var core_i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var router_useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/individual/index.ts
var individual = __webpack_require__(85362);
// EXTERNAL MODULE: ./src/lib/array/index.ts
var array = __webpack_require__(79832);
;// CONCATENATED MODULE: ./src/components/pages/AccountSettings/template/index.tsx










var AccountSettingsTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("accountSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, routerNames = ref.routerNames;
    var list = (0,react.useMemo)(function() {
        return [
            {
                title: t("emailAddressSetting"),
                href: routerPages.EmailSetting
            },
            {
                title: t("passwordSetting"),
                href: routerPages.PasswordSetting
            },
            {
                title: t("personalInfoSetting"),
                href: routerPages.PersonalInfoSettings,
                notificationText: state.isMembershipPersonalInformationRequired ? t("personalInfoSettingNotification") : ""
            },
            {
                title: t("deliveryAddressSetting"),
                href: routerPages.DeliveryInfoSetting,
                hidden: (0,individual/* individualHideDelivery */.QV)()
            },
            {
                title: t("bankCreate"),
                href: routerPages.BankCreate,
                hidden: !config_config/* config.modules.resale */.v.modules.resale
            },
            {
                title: t("integration"),
                href: routerPages.Integrations,
                hidden: !config_config/* config.platform.includes */.v.platform.includes("web") || (0,individual/* individualHideTwitterAuth */.SH)()
            },
            {
                title: t("deactivation"),
                href: routerPages.Deactivation
            }, 
        ];
    }, [
        routerPages.BankCreate,
        routerPages.Deactivation,
        routerPages.DeliveryInfoSetting,
        routerPages.EmailSetting,
        routerPages.Integrations,
        routerPages.PasswordSetting,
        routerPages.PersonalInfoSettings,
        state.isMembershipPersonalInformationRequired,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Setting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.AccountSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                sx: {
                    bgcolor: "grey.50"
                },
                children: (0,array/* filterHiddenItem */.s)(list).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                        divider: true,
                        title: item.title,
                        href: item.href,
                        sx: {
                            backgroundColor: "grey.50",
                            py: 2,
                            px: 5,
                            height: {
                                xs: 52,
                                md: 56
                            }
                        },
                        primaryTypographyProps: {
                            variant: "body1"
                        },
                        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "like.tap",
                            children: item.notificationText
                        })
                    }, index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ./src/core/architecture/ViewModel.ts
var ViewModel = __webpack_require__(89693);
;// CONCATENATED MODULE: ./src/components/pages/AccountSettings/viewModel.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AccountSettings {\n    user {\n      id\n      isMembershipPersonalInformationRequired\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var data = (0,useQuery/* useQuery */.aM)(QUERY).data;
    return {
        state: {
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired)
        },
        actions: {}
    };
});
var QUERY = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/AccountSettings/index.tsx



/**
 * AccountSettings Page
 * Implemented as a practical sample.
 */ var AccountSettings = function() {
    var ref = useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountSettingsTemplate, {
        state: state
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack_Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@mui/material/IconButton/IconButton.js
var IconButton_IconButton = __webpack_require__(87037);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(87639);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItem/ListItem.js
var ListItem_ListItem = __webpack_require__(35488);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton_ListItemButton = __webpack_require__(14117);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(61087);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText_ListItemText = __webpack_require__(82056);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ListItemAvatar/ListItemAvatar.js
var ListItemAvatar_ListItemAvatar = __webpack_require__(91969);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(81714);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(12115);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(18951);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(12363);
// EXTERNAL MODULE: ./src/components/styles/AppThemeProvider.tsx
var AppThemeProvider = __webpack_require__(2943);
// EXTERNAL MODULE: ./src/components/styles/index.ts
var styles = __webpack_require__(80042);
// EXTERNAL MODULE: ./src/core/auth/index.ts + 4 modules
var auth = __webpack_require__(16083);
// EXTERNAL MODULE: ./src/core/architecture/components/index.tsx
var components = __webpack_require__(93893);
// EXTERNAL MODULE: ./src/core/analytics/AnalyticsProvider.tsx
var AnalyticsProvider = __webpack_require__(34814);
// EXTERNAL MODULE: ./src/lib/privateAction/index.ts
var privateAction = __webpack_require__(14514);
;// CONCATENATED MODULE: ./src/components/layouts/SideMenu/index.tsx













var SideMenu = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, followArtists = param.followArtists, memberArtists = param.memberArtists, _user = param.user, user = _user === void 0 ? null : _user, _isArtist = param.isArtist, isArtist = _isArtist === void 0 ? false : _isArtist, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, onClose = param.onClose, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? 600 : _maxWidth, _enableDmRoom = param.enableDmRoom, enableDmRoom = _enableDmRoom === void 0 ? false : _enableDmRoom;
    var ref, ref1;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var t = (0,core_i18n/* useTranslation */.$G)("sideMenu").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath, router = ref2.router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref3 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref3.user;
    var listService = (0,react.useMemo)(function() {
        return [
            {
                title: t("home"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Home, {
                    bgcolor: "icon.background",
                    href: routerPages.GlobalHome
                })
            },
            {
                title: t("wallet"),
                hidden: !config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint || (0,individual/* individualHideWallet */.Bd)(),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Wallet, {
                    href: routerPages.Wallet,
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background"
                })
            },
            {
                title: t("ownedItems"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.OwnedItems, {
                    href: routerPages.MyOwnedItems,
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background"
                })
            },
            {
                title: t("pickup"),
                hidden: !config_config/* config.modules.pickup */.v.modules.pickup,
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    href: routerPages.MyOwnedTicketsEventSelection,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventPickupList", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            type: "sideMenu"
                        });
                        return handleLoginModal();
                    }(),
                    sx: {
                        bgcolor: "grey.50"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.PickUp, {
                        sx: {
                            color: "grey.600"
                        }
                    })
                })
            },
            {
                title: t("cart"),
                hidden: !config_config/* config.modules.cart */.v.modules.cart,
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    href: routerPages.StoreCartList,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cart", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            type: "sideMenu",
                            isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                        });
                        // カートには匿名ログイン状態でもアクセスできる
                        return currentUser ? function() {} : handleLoginModal();
                    }(),
                    sx: {
                        bgcolor: "grey.50"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Store, {
                        sx: {
                            color: "grey.600"
                        }
                    })
                })
            },
            {
                title: t("tradeRequest"),
                hidden: !config_config/* config.modules.trade */.v.modules.trade,
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Market, {
                    href: routerPages.MyTrade,
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background"
                })
            },
            {
                title: t("dmRooms"),
                hidden: !enableDmRoom,
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.DM, {
                    href: routerPages.DmRooms,
                    sx: {
                        color: "grey.700"
                    },
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background"
                })
            },
            {
                title: t("manager"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Management, {
                    href: routerPages.Management,
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background",
                    badge: (user === null || user === void 0 ? void 0 : user.hasUnappliedDeliveryItems) || (user === null || user === void 0 ? void 0 : user.hasWaitingPaymentItems) || (user === null || user === void 0 ? void 0 : user.hasWaitingResaleRafflePaymentItems) || (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) ? {
                        badgeContent: "",
                        color: "like",
                        sx: {
                            "& > span": {
                                top: -4,
                                right: -4,
                                minWidth: 12,
                                height: 12,
                                bgcolor: "like.tap"
                            }
                        }
                    } : undefined
                })
            },
            {
                title: t("setting"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Setting, {
                    href: routerPages.Setting,
                    color: "text.secondary",
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background",
                    badge: (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) ? {
                        badgeContent: "",
                        color: "like",
                        sx: {
                            "& > span": {
                                top: -4,
                                right: -4,
                                minWidth: 12,
                                height: 12,
                                bgcolor: "like.tap"
                            }
                        }
                    } : undefined
                })
            },
            {
                title: t("notification"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Notice, {
                    href: routerPages.Notifications,
                    onClick: handleLoginModal(),
                    color: "text.secondary",
                    bgcolor: "icon.background",
                    badge: (user === null || user === void 0 ? void 0 : user.unreadNotificationCount) ? {
                        badgeContent: "",
                        color: "like",
                        sx: {
                            "& > span": {
                                top: -4,
                                right: -4,
                                minWidth: 12,
                                height: 12,
                                bgcolor: "like.tap"
                            }
                        }
                    } : undefined
                })
            },
            {
                title: t("console"),
                hidden: !isArtist,
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Artist, {
                    href: routerPages.ConsoleDashboard,
                    onClick: handleLoginModal(),
                    bgcolor: "icon.background"
                })
            }, 
        ];
    }, [
        handleLoginModal,
        isArtist,
        enableDmRoom,
        routerPages.ConsoleDashboard,
        routerPages.DmRooms,
        routerPages.GlobalHome,
        routerPages.Management,
        routerPages.MyOwnedItems,
        routerPages.MyTrade,
        routerPages.Notifications,
        routerPages.Setting,
        routerPages.Wallet,
        t,
        user === null || user === void 0 ? void 0 : user.hasUnappliedDeliveryItems,
        user === null || user === void 0 ? void 0 : user.hasWaitingPaymentItems,
        user === null || user === void 0 ? void 0 : user.unreadNotificationCount, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppThemeProvider/* AppThemeProvider */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuDrawer, {
            anchor: "left",
            open: open,
            onClose: onClose,
            sx: {
                maxWidth: responsive ? "100%" : maxWidth,
                width: "100%",
                margin: "0 auto"
            },
            PaperProps: {
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                    bgcolor: "background.default",
                    backgroundImage: "none",
                    left: "initial"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                disableGutters: true,
                sx: {
                    width: "280px",
                    bgcolor: "background.default",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                    disablePadding: true,
                                    sx: {
                                        borderBottom: "1px solid",
                                        borderColor: "grey.100"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                                        sx: {
                                            height: 76,
                                            px: 5
                                        },
                                        href: !currentUser ? routerPages.Top : routerPages.MyProfile,
                                        children: [
                                            !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MemberShip, {
                                                            fontSize: "medium",
                                                            sx: {
                                                                mr: 3
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                                        slotProps: {
                                                            primary: {
                                                                variant: "subtitle1"
                                                            }
                                                        },
                                                        primary: t("newRegisterOrLogin")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                            src: (user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.mediumUri) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl) || ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                                        primary: (user === null || user === void 0 ? void 0 : user.displayName) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                                                    fontSize: "medium"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                ((user === null || user === void 0 ? void 0 : user.hasUnappliedDeliveryItems) || (user === null || user === void 0 ? void 0 : user.hasWaitingPaymentItems) || (user === null || user === void 0 ? void 0 : user.hasWaitingResaleRafflePaymentItems) || (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                    elevation: 3,
                                    sx: {
                                        borderRadius: 0,
                                        pb: "unset !important"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        px: 4,
                                        py: 3,
                                        component: Link/* default */.Z,
                                        href: routerPages.Management,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                                fontSize: "small",
                                                sx: {
                                                    color: "like.tap"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                color: "like.tap",
                                                children: t("managementNotification", "確認が必要な項目があります。")
                                            })
                                        ]
                                    })
                                }),
                                currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        flexWrap: "wrap",
                                        px: 5,
                                        py: 3,
                                        borderBottom: "1px solid",
                                        borderColor: "grey.100"
                                    },
                                    children: (0,array/* filterHiddenItem */.s)(listService).map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                pl: {
                                                    xs: 1,
                                                    sm: 1
                                                },
                                                pr: {
                                                    xs: 1,
                                                    sm: 2
                                                },
                                                color: "grey.400"
                                            },
                                            children: [
                                                item.IconButton,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: {
                                                        color: "text.secondary",
                                                        textAlign: "center",
                                                        mt: 2,
                                                        height: "44px",
                                                        width: "51px",
                                                        whiteSpace: "pre-line"
                                                    },
                                                    children: item.title
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                config_config/* config.modules.membership */.v.modules.membership && !!(memberArtists === null || memberArtists === void 0 ? void 0 : memberArtists.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                                    sx: {
                                        py: 3,
                                        pb: 6,
                                        borderBottom: "1px solid",
                                        borderColor: "grey.100"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                color: "grey.600",
                                                py: 2,
                                                pb: 3,
                                                px: 5
                                            },
                                            children: t("artistMember")
                                        }),
                                        memberArtists.map(function(param) {
                                            var artist = param.artist;
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                                sx: {
                                                    backgroundColor: "grey.50",
                                                    height: 56,
                                                    px: 5,
                                                    py: 0
                                                },
                                                title: artist.displayName || "",
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: ((ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) || "",
                                                    sx: {
                                                        width: 28,
                                                        height: 28
                                                    }
                                                }),
                                                href: generatePath(routerPages.ArtistTop, {
                                                    artistId: artist.id
                                                }),
                                                onClick: function() {
                                                    return onClose();
                                                },
                                                primaryTypographyProps: {
                                                    variant: "body1",
                                                    color: "text.primary"
                                                }
                                            }, artist.id);
                                        })
                                    ]
                                }),
                                !!(followArtists === null || followArtists === void 0 ? void 0 : (ref1 = followArtists.edges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                                    sx: {
                                        py: 3,
                                        pb: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                color: "grey.600",
                                                py: 2,
                                                pb: 3,
                                                px: 5
                                            },
                                            children: t("artistFollowing")
                                        }),
                                        followArtists.edges.map(function(param) {
                                            var node = param.node;
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                                sx: {
                                                    backgroundColor: "grey.50",
                                                    height: 56,
                                                    px: 5,
                                                    py: 0,
                                                    borderBottom: "1px solid",
                                                    borderColor: "grey.100",
                                                    ".css-tlelie-MuiListItemText-root": {
                                                        width: 210
                                                    }
                                                },
                                                title: node.artist.displayName,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: ((ref = node.artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) || "",
                                                    sx: {
                                                        width: 28,
                                                        height: 28
                                                    }
                                                }),
                                                href: generatePath(routerPages.ArtistTop, {
                                                    artistId: node.artist.id
                                                }),
                                                onClick: function() {
                                                    return onClose();
                                                },
                                                primaryTypographyProps: {
                                                    variant: "body1",
                                                    color: "text.primary",
                                                    sx: (0,src_object_spread/* default */.Z)({
                                                        mr: 8
                                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1))
                                                },
                                                secondaryAction: config_config/* config.modules.membership */.v.modules.membership ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Thread, {
                                                    badge: {
                                                        badgeContent: node.artist.totalUnreadMentionCount,
                                                        sx: {
                                                            span: {
                                                                bgcolor: "like.tap",
                                                                color: "white",
                                                                minWidth: 16,
                                                                width: 16,
                                                                height: 16,
                                                                fontSize: "8px",
                                                                lineHeight: "16px",
                                                                top: 4,
                                                                right: 4,
                                                                zIndex: 3,
                                                                fontWeight: "bold"
                                                            }
                                                        }
                                                    },
                                                    sx: {
                                                        position: "relative",
                                                        zIndex: 2
                                                    },
                                                    onClick: function(event) {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        onClose();
                                                        router.push(generatePath(routerPages.ArtistThreads, {
                                                            artistId: node.artist.id
                                                        }));
                                                    }
                                                }) : null
                                            }, node.artist.id);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            flexGrow: 1
                        })
                    ]
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Card/Card.js
var Card_Card = __webpack_require__(86120);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardActionArea/CardActionArea.js
var CardActionArea_CardActionArea = __webpack_require__(74020);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(65992);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Slider/Slider.js + 4 modules
var Slider = __webpack_require__(41587);
;// CONCATENATED MODULE: ./src/components/organisms/collection/CollectionIndicator/index.tsx





var CollectionIndicator = function(param) {
    var _itemCount = param.itemCount, itemCount = _itemCount === void 0 ? 0 : _itemCount, _totalCount = param.totalCount, totalCount = _totalCount === void 0 ? 1 : _totalCount, sx = param.sx, _successColor = param.successColor, successColor = _successColor === void 0 ? "primary" : _successColor;
    var itemCompletionRatio = (0,react.useMemo)(function() {
        return !totalCount ? 0 : itemCount / totalCount * 100;
    }, [
        itemCount,
        totalCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            sx: (0,src_object_spread/* default */.Z)({
                mx: 4,
                pt: 1,
                pb: 2,
                color: "background.default",
                alignItems: "center"
            }, sx),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionIndicator_Slider, {
                    sx: {
                        flex: 1
                    },
                    value: itemCompletionRatio,
                    color: itemCount === totalCount ? successColor : "primary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: "subtitle2",
                    sx: {
                        ml: 4,
                        minWidth: 36
                    },
                    children: [
                        itemCount,
                        "/",
                        totalCount
                    ]
                })
            ]
        })
    });
};
var CollectionIndicator_Slider = (0,styled/* default */.ZP)(Slider/* default */.ZP)(function(param) {
    var theme = param.theme;
    return {
        "&.MuiSlider-colorPrimary": {
            height: 16,
            padding: 0,
            width: "100%",
            color: theme.palette.primary.main
        },
        "&.MuiSlider-colorSecondary": {
            height: 16,
            padding: 0,
            width: "100%",
            color: theme.palette.secondary.main
        },
        "> .MuiSlider-thumb": {
            display: "none"
        },
        "> .MuiSlider-active": {},
        "> .MuiSlider-valueLabel": {
            left: "calc(-50% + 4px)"
        },
        "> .MuiSlider-track": {
            height: 6,
            borderLeftWidth: 0,
            borderRightWidth: 0
        },
        ".MuiSlider-rail": {
            height: 8,
            borderRadius: 4,
            color: "white"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/organisms/collection/CollectionBox/index.tsx








var CollectionBox = function(param) {
    var collection = param.collection, sx = param.sx, fullWidth = param.fullWidth, userId = param.userId, actionAreaProps = param.actionAreaProps;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var ref3 = (0,react.useMemo)(function() {
        if (isCollection(collection)) {
            return {
                collection: collection,
                userCollection: collection.userCollection
            };
        }
        return {
            collection: collection.collection,
            userCollection: collection
        };
    }, [
        collection
    ]), currentCollection = ref3.collection, userCollection = ref3.userCollection;
    var ref4, ref5;
    var thumbnailUri = (ref5 = (ref4 = currentCollection === null || currentCollection === void 0 ? void 0 : (ref = currentCollection.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref4 !== void 0 ? ref4 : currentCollection === null || currentCollection === void 0 ? void 0 : (ref1 = currentCollection.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            width: fullWidth ? "100%" : 315,
            height: sx && "height" in sx ? sx.height : 190,
            borderRadius: 2
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            sx: {
                height: "100%"
            },
            href: userId ? generatePath(routerPages.UserCollectionDetail, {
                collectionId: (ref6 = currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.id) !== null && ref6 !== void 0 ? ref6 : "#",
                userId: userId
            }) : generatePath(routerPages.CollectionDetail, {
                collectionId: (ref7 = currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.id) !== null && ref7 !== void 0 ? ref7 : "#"
            })
        }, actionAreaProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "column-reverse",
                sx: {
                    height: "100%",
                    width: "100%",
                    backgroundImage: 'url("'.concat(thumbnailUri, '")'),
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    justifyContent: "flex-end",
                    sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.backgroundImageWithGradient */.k$.backgroundImageWithGradient()), {
                        mt: 4,
                        width: "100%",
                        height: 56
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: {
                                mx: 4,
                                pt: 1,
                                pb: userCollection ? 0 : 4
                            },
                            children: currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.title
                        }),
                        userCollection && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionIndicator, {
                            itemCount: (ref8 = userCollection === null || userCollection === void 0 ? void 0 : userCollection.totalOwnedItemCount) !== null && ref8 !== void 0 ? ref8 : 0,
                            totalCount: (ref9 = currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.itemCount) !== null && ref9 !== void 0 ? ref9 : 1
                        })
                    ]
                })
            })
        }))
    });
};
function isCollection(collection) {
    return "title" in collection;
}

// EXTERNAL MODULE: ../../node_modules/@mui/material/Skeleton/Skeleton.js
var Skeleton_Skeleton = __webpack_require__(31117);
;// CONCATENATED MODULE: ./src/components/organisms/collection/CollectionBoxSkeleton/index.tsx


var CollectionBoxSkeleton = function(param) {
    var fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
        variant: "rectangular",
        width: fullWidth ? "100%" : 315,
        height: 190
    });
};

// EXTERNAL MODULE: ./src/components/organisms/functionals/ScrollFetcher/index.tsx
var ScrollFetcher = __webpack_require__(98653);
// EXTERNAL MODULE: ./src/components/styles/ArtistThemeProvider.tsx
var ArtistThemeProvider = __webpack_require__(58015);
;// CONCATENATED MODULE: ./src/components/pages/ArtistCollections/template/index.tsx













var ArtistCollectionsTemplate = function(param) {
    var state = param.state, onFetchMoreArtistCollection = param.onFetchMoreArtistCollection;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistCollections").t;
    var ref4 = (0,react.useState)(false), openSideMenu = ref4[0], setOpenSideMenu = ref4[1];
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    isLive: !!state.liveStreamId,
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                }
            },
            margin: true,
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasManagementTask) || !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.unreadNotificationCount),
                    color: "icon.line",
                    bgcolor: "icon.background"
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistCollections,
                        state.artistName
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionBannerCell, {
                    userCollections: state.userCollections,
                    loading: state.loading,
                    artistId: state.artistId,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMoreArtistCollection
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                })
            ]
        })
    });
};
var CollectionBannerCell = function(param) {
    var loading = param.loading, artistId = param.artistId, userCollections = param.userCollections, onFetchMore = param.onFetchMore, hasNextPage = param.hasNextPage;
    var t = (0,core_i18n/* useTranslation */.$G)("artistCollections").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            onFetchMore: onFetchMore,
            hasNextPage: hasNextPage,
            componentProps: {
                spacing: 5
            },
            emptyMessage: t("collectionEmptyMessage"),
            nodes: userCollections === null || userCollections === void 0 ? void 0 : userCollections.edges.map(function(param, index) {
                var collection = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionBox, {
                    collection: collection,
                    fullWidth: true,
                    sx: {
                        height: "calc((100vw - 40px) * 190 / 335)",
                        maxHeight: "calc(560px * 190 / 335)"
                    },
                    actionAreaProps: {
                        onClick: function onClick() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: artistId,
                                collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
                                name: "artistCollections"
                            });
                        }
                    }
                }, index);
            }),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: Array.from(Array(3).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionBoxSkeleton, {
                        fullWidth: true
                    }, key);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(56675);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/lodash/isString.js
var isString = __webpack_require__(85505);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ../../node_modules/lodash/keys.js
var keys = __webpack_require__(90249);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);
// EXTERNAL MODULE: ../../node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(84636);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./src/clients/utoniq-core/state/index.ts + 48 modules
var state = __webpack_require__(55148);
;// CONCATENATED MODULE: ./src/clients/utoniq-core/state/getNewestData.ts












/**
 * @description auto get new data if user go back the page
 * @param query
 * @param variables
 * @param fields
 * @param identify cacheID
 * @param onCompleted
 */ var useGetNewestData = function(param) {
    var query = param.query, variables = param.variables, fields = param.fields, identify = param.identify, onCompleted = param.onCompleted;
    var isFirstLoadRef = (0,react.useRef)(true);
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(query, {
        variables: variables,
        // Always call api and not save data into cache
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache",
        // handle and save data to cache
        onCompleted: storeNewestDataToCache(fields, identify, {
            variables: variables,
            client: client,
            callback: onCompleted
        })
    }), 1), getNewestData = ref[0];
    (0,react.useEffect)(function() {
        /**
     * @hack
     * When upgrading @apollo/client to a higher version, the hook execution flow changed.
     * I added a delay to ensure useQuery completes first
     */ setTimeout(function() {
            if (!isFirstLoadRef.current) {
                getNewestData({});
            }
        }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isFirstLoadRef: isFirstLoadRef
    };
};
/**
 * @description
 * @param identify
 * @param {Field[]} fields
 * @param variables
 * @param client
 * @param callback
 * @example:
 * const [] = useLazyQuery({
 *   fetchPolicy: 'network-only',
 *   onCompleted: storeNewestDataToCache(fields, identify),
 * })
 */ var storeNewestDataToCache = function(fields, identify, param) {
    var variables = param.variables, client = param.client, callback = param.callback;
    return function onCompleted(data) {
        var cache = client === null || client === void 0 ? void 0 : client.cache;
        var cacheFields = {};
        fields.forEach(function(param) {
            var fieldName = param.fieldName, _uniqByKey = param.uniqByKey, uniqByKey = _uniqByKey === void 0 ? "node.__ref" : _uniqByKey, fragment = param.fragment, fragmentName = param.fragmentName, generateNode = param.generateNode, responsePath = param.responsePath;
            cacheFields[fieldName] = function() {
                var existingData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    edges: []
                }, storeFieldName = (arguments.length > 1 ? arguments[1] : void 0).storeFieldName;
                // convert variable string to JSON object
                var inputs = (0,state/* parseVariables */.e7)(storeFieldName);
                // check variables with storeFieldName have equal value
                if (inputs && !compareTwoObject(inputs, variables)) {
                    return existingData;
                }
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, existingData), {
                    edges: uniqBy_default()((0,src_to_consumable_array/* default */.Z)(get_default()(data, responsePath !== null && responsePath !== void 0 ? responsePath : fieldName, {
                        edges: []
                    }).edges.map(function(param) {
                        var _$data = param.node;
                        return {
                            node: generateNode ? generateNode(cache, _$data) : cache.writeFragment({
                                fragment: fragment,
                                data: _$data,
                                fragmentName: fragmentName
                            }),
                            __typename: "Edge"
                        };
                    })).concat((0,src_to_consumable_array/* default */.Z)(get_default()(existingData, "edges", {}))), uniqByKey)
                });
            };
        });
        cache === null || cache === void 0 ? void 0 : cache.modify({
            id: identify ? cache === null || cache === void 0 ? void 0 : cache.identify({
                __typename: identify.__typename,
                // return id from response data if id is function
                id: isString_default()(identify.id) ? identify.id : identify.id(data)
            }) : "ROOT_QUERY",
            fields: cacheFields
        });
        callback === null || callback === void 0 ? void 0 : callback(data);
    };
};
function compareTwoObject(objectOne, objectTwo) {
    return keys_default()(objectOne).every(function(key) {
        return isEqual_default()(objectOne === null || objectOne === void 0 ? void 0 : objectOne[key], objectTwo === null || objectTwo === void 0 ? void 0 : objectTwo[key]);
    });
}

// EXTERNAL MODULE: ./src/clients/utoniq-core/state/vars.ts
var vars = __webpack_require__(54040);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var utoniq_core_schema = __webpack_require__(66517);
;// CONCATENATED MODULE: ./src/components/pages/ArtistCollections/viewModel.ts



function viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistCollections(\n    $userCollectionsPageInput: PageInputDate\n    $userCollectionsArtistId: ID\n  ) {\n    artist(id: $userCollectionsArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n    userCollections(\n      pageInput: $userCollectionsPageInput\n      artistId: $userCollectionsArtistId\n    ) {\n      edges {\n        node {\n          ...CollectionBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistCollections($pageInput: PageInputDate, $artistId: ID) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    userCollections(pageInput: $pageInput, artistId: $artistId) {\n      edges {\n        node {\n          ...CollectionBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_COLLECTION,
        variables: {
            artistId: artistId,
            pageInput: {
                limit: 20
            }
        },
        fields: [
            {
                fieldName: "userCollections",
                fragment: utoniq_core_schema/* CollectionBoxFragmentDoc */.SYQ
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref9 = (0,useQuery/* useQuery */.aM)(viewModel_QUERY, {
        variables: {
            userCollectionsArtistId: artistId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(param) {
            var userCollections = param.userCollections, artist = param.artist;
            var ref;
            isFirstLoadRef.current = false;
            if (!(userCollections === null || userCollections === void 0 ? void 0 : (ref = userCollections.edges) === null || ref === void 0 ? void 0 : ref.length)) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    artistId: artistId,
                    name: "artistCollections"
                });
            }
            if (artist) {
                (0,vars/* currentArtistVar */.ag)(artist);
            }
        }
    }), data = ref9.data, fetchMore = ref9.fetchMore, loading = ref9.loading;
    var isNextFetch = !!data;
    var ref10, ref11, ref12;
    return {
        state: {
            loading: loading && !isNextFetch,
            artistName: (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.displayName) || "",
            user: (data === null || data === void 0 ? void 0 : data.user) || null,
            artistId: artistId,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref1 = userClaims.orgs) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[config_config/* config.organizationId */.v.organizationId]) === null || ref2 === void 0 ? void 0 : ref2.artist),
            followArtists: (ref10 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.organizationFollowees) !== null && ref10 !== void 0 ? ref10 : null,
            memberArtists: (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationPatrons) !== null && ref11 !== void 0 ? ref11 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref5 = data.userCollections) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pageInfo) === null || ref6 === void 0 ? void 0 : ref6.hasNextPage),
            userCollections: (ref12 = data === null || data === void 0 ? void 0 : data.userCollections) !== null && ref12 !== void 0 ? ref12 : null,
            liveStreamId: data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.currentLive) === null || ref8 === void 0 ? void 0 : ref8.id
        },
        actions: {
            onFetchMoreArtistCollection: function onFetchMoreArtistCollection() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            userCollectionsArtistId: artistId,
                                            userCollectionsPageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.userCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var viewModel_QUERY = (0,lib/* gql */.Ps)(viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* CollectionBoxFragmentDoc */.SYQ, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_COLLECTION = (0,lib/* gql */.Ps)(_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* CollectionBoxFragmentDoc */.SYQ);

;// CONCATENATED MODULE: ./src/components/pages/ArtistCollections/index.tsx



/**
 * ArtistCollections Page
 * Implemented as a practical sample.
 */ var ArtistCollections = function() {
    var ref = viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistCollectionsTemplate, {
        state: state,
        onFetchMoreArtistCollection: actions.onFetchMoreArtistCollection
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/CardMedia/CardMedia.js
var CardMedia_CardMedia = __webpack_require__(14036);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardContent/CardContent.js
var CardContent_CardContent = __webpack_require__(16881);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(45269);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/organisms/event/EventScheduledCard/index.tsx










var EventScheduledCard = function(param) {
    var scheduledEvent = param.scheduledEvent, month = param.month, className = param.className;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        className: className,
        direction: "row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                minWidth: "57px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    children: dayjs_min_default()(scheduledEvent === null || scheduledEvent === void 0 ? void 0 : scheduledEvent.date).format("D(ddd)")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 1,
                p: "1",
                width: "100%",
                children: scheduledEvent === null || scheduledEvent === void 0 ? void 0 : (ref = scheduledEvent.events) === null || ref === void 0 ? void 0 : ref.map(function(event) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        sx: {
                            borderRadius: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                            href: generatePath(routerPages.ShokufesEventDetail, {
                                eventId: event.id
                            }),
                            sx: {
                                height: "100%",
                                p: 1
                            },
                            onClick: function() {
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: event.id,
                                    name: "eventFes"
                                });
                                sessionStorage.setItem(constants/* constants.storageKeys.EVENT_MONTH */._.storageKeys.EVENT_MONTH, month);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "flex-start",
                                spacing: 2,
                                sx: {
                                    p: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                        sx: {
                                            minWidth: "68px",
                                            height: "68px"
                                        },
                                        image: (ref2 = (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref2 !== void 0 ? ref2 : "",
                                        title: event.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                                        sx: {
                                            padding: "0!important"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                sx: (0,src_object_spread/* default */.Z)({
                                                    pb: 1
                                                }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                                children: event.title
                                            }),
                                            event.dateRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                                        fontSize: "small",
                                                        sx: {
                                                            color: "grey.700"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.secondary",
                                                        children: event.dateRange.replace(/（/g, "(").replace(/）/g, ")")
                                                    })
                                                ]
                                            }),
                                            event.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                sx: {
                                                    pt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {
                                                        fontSize: "small",
                                                        sx: {
                                                            color: "grey.700"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.secondary",
                                                        children: (ref1 = event.location) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, event.id);
                })
            })
        ]
    });
};
var EventScheduledCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        py: "10px",
        width: "100%",
        spacing: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    minWidth: "85px",
                    minHeight: "68px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                width: "100%",
                minHeight: "68px",
                maxHeight: "68px",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h4",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h4",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h4",
                        width: "100%"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/x-date-pickers/StaticDatePicker/StaticDatePicker.js
var StaticDatePicker = __webpack_require__(66112);
// EXTERNAL MODULE: ../../node_modules/@mui/x-date-pickers/PickersDay/PickersDay.js
var PickersDay = __webpack_require__(71188);
// EXTERNAL MODULE: ../../node_modules/react-swipeable/es/index.js
var es = __webpack_require__(28249);
;// CONCATENATED MODULE: ./src/components/organisms/event/EventCalendar/index.tsx











// @mui/x-date-pickers アップデートで仕様が変わるとstyle指定が効かなくなる場合がある
var StyledDatePicker = (0,styled/* default */.ZP)(StaticDatePicker/* StaticDatePicker */.w)({
    width: "100%",
    "& .MuiDateCalendar-root": {
        width: "100%",
        height: "unset"
    },
    "& .MuiDateCalendar-root div": {
        width: "100%"
    },
    "& .MuiDayCalendar-weekContainer, & .MuiDayCalendar-header": {
        justifyContent: "space-between",
        padding: "0 20px"
    },
    "& .MuiDayCalendar-header": {
        maxHeight: "20px",
        paddingLeft: "22px"
    },
    "& .MuiDayCalendar-header > *": {
        maxWidth: "24px"
    },
    "& .MuiDayCalendar-weekContainer > *": {
        maxWidth: "32px",
        minWidth: "32px",
        textAlign: "center"
    },
    "& .MuiDayCalendar-slideTransition": {
        minHeight: "256px"
    },
    "& .MuiPickersCalendarHeader-root": {
        display: "none"
    },
    "& .MuiDayCalendar-weekContainer > div": {
        minWidth: "32px"
    },
    "& .MuiDayCalendar-weekContainer": {
        margin: "8px 0"
    },
    "& .MuiButtonBase-root": {
        maxWidth: "32px",
        maxHeight: "32px"
    }
});
var convertToFullWeekday = function(weekday) {
    var weekdays = [
        "SUN",
        "MON",
        "TUE",
        "WED",
        "THU",
        "FRI",
        "SAT"
    ];
    switch(weekday){
        case "日":
            return weekdays[0];
        case "月":
            return weekdays[1];
        case "火":
            return weekdays[2];
        case "水":
            return weekdays[3];
        case "木":
            return weekdays[4];
        case "金":
            return weekdays[5];
        case "土":
            return weekdays[6];
        default:
            return weekday;
    }
};
var TOOLBAR_HEIGHT = 44;
var BODY_HEIGHT = 276;
var CONTENT_HEIGHT = TOOLBAR_HEIGHT + BODY_HEIGHT;
function scrollTo(targetY, duration, callback) {
    // HACK: 最上位要素ではなくBaseLayoutがoveflowしているので、element指定でスクロールさせる
    var baseLayoutElement = document.getElementsByClassName("BaseLayout")[0];
    var ref;
    var startY = (ref = baseLayoutElement === null || baseLayoutElement === void 0 ? void 0 : baseLayoutElement.scrollTop) !== null && ref !== void 0 ? ref : 0;
    var distance = targetY - startY;
    var startTime = performance.now();
    function scrollStep(currentTime) {
        var timeElapsed = currentTime - startTime;
        var progress = Math.min(timeElapsed / duration, 1);
        if (baseLayoutElement) {
            baseLayoutElement.scrollTop = startY + distance * progress;
        }
        if (progress < 1) requestAnimationFrame(scrollStep);
        else {
            if (callback) callback();
        }
    }
    requestAnimationFrame(scrollStep);
}
var EventCalendar = function(param) {
    var dates = param.dates, onFetch = param.onFetch, month = param.month, className = param.className;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), isInitializing = ref1[0], setIsInitializing = ref1[1];
    // 日付ごとのコンポーネントの位置
    var ref2 = (0,react.useState)([]), datePositionList = ref2[0], setDatePositionList = ref2[1];
    var ref3 = (0,react.useState)(new Date()), currentMonth = ref3[0], setCurrentMonth = ref3[1];
    var ref4 = (0,react.useState)(new Date()), selectedDate = ref4[0], setSelectedDate = ref4[1];
    var datePositionListRef = (0,react.useRef)(datePositionList);
    var selectedDateRef = (0,react.useRef)(selectedDate);
    var datesRef = (0,react.useRef)(dates);
    var scrollPaddingTop = 16;
    var baseLayoutElement = document.getElementsByClassName("BaseLayout")[0];
    var updateMonth = function(offset) {
        if (isInitializing) return;
        var newMonth = new Date(currentMonth);
        newMonth.setMonth(currentMonth.getMonth() + offset, 1);
        onFetch(dayjs_min_default()(newMonth).format("YYYYMM"));
    };
    var handlePreviousMonth = function() {
        return updateMonth(-1);
    };
    var handleNextMonth = function() {
        return updateMonth(1);
    };
    var renderDay = function(_param) {
        var day = _param.day, pickersDayProps = (0,_object_without_properties/* default */.Z)(_param, [
            "day"
        ]);
        var typedDay = day;
        var typedPickersDayProps = pickersDayProps;
        var formattedDate = dayjs_min_default()(typedDay).format("YYYY/MM/DD");
        var isHighlighted = dates.includes(formattedDate);
        var selected = dayjs_min_default()(typedDay).isSame(dayjs_min_default()(selectedDateRef.current), "day");
        var defaultStyle = {
            fontSize: "16px!important"
        };
        var selectedStyle = {
            "&&:focus": {
                backgroundColor: "primary.main",
                color: "white"
            }
        };
        var sx = selected ? (0,src_object_spread/* default */.Z)({}, defaultStyle, selectedStyle) : defaultStyle;
        var DefaultDay = /*#__PURE__*/ (0,jsx_runtime.jsx)(PickersDay/* PickersDay */.H, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, typedPickersDayProps), {
            day: typedDay,
            selected: selected,
            disabled: !isHighlighted,
            today: false,
            sx: sx
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                position: "relative"
            },
            children: [
                DefaultDay,
                isHighlighted && !selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        top: "27px",
                        left: "calc(50% - 1px)",
                        maxWidth: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "primary.main"
                    }
                })
            ]
        });
    };
    var handleScroll = function() {
        var positions = datePositionListRef.current;
        var dates = datesRef.current;
        if (!positions.length) return;
        var ref;
        var position = (ref = baseLayoutElement === null || baseLayoutElement === void 0 ? void 0 : baseLayoutElement.scrollTop) !== null && ref !== void 0 ? ref : 0;
        var findLastIndex = function(arr, predicate) {
            for(var i = arr.length - 1; i >= 0; i--){
                if (predicate(arr[i], i, arr)) {
                    return i;
                }
            }
            return -1;
        };
        var index = findLastIndex(positions, function(pos) {
            return pos <= position - scrollPaddingTop;
        });
        if (index >= 0 && dates[index]) {
            setSelectedDate(new Date(dates[index]));
            setCurrentMonth(new Date(dates[index]));
        }
    };
    var swipeHandlers = (0,es/* useSwipeable */.QS)({
        onSwipedLeft: handleNextMonth,
        onSwipedRight: handlePreviousMonth
    });
    (0,react.useEffect)(function() {
        datePositionListRef.current = datePositionList;
        selectedDateRef.current = selectedDate;
        datesRef.current = dates;
    }, [
        datePositionList,
        selectedDate,
        dates
    ]);
    (0,react.useEffect)(function() {
        baseLayoutElement === null || baseLayoutElement === void 0 ? void 0 : baseLayoutElement.addEventListener("scroll", handleScroll);
        return function() {
            baseLayoutElement === null || baseLayoutElement === void 0 ? void 0 : baseLayoutElement.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (dates.length) {
            setIsInitializing(true);
            setTimeout(function() {
                var ref;
                var dateElements = document.getElementsByClassName(className);
                var ref1;
                var positions = Array.from(dateElements).map(function(element) {
                    var ref;
                    return (ref1 = (ref = element.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.top) !== null && ref1 !== void 0 ? ref1 : 0;
                });
                var ref2;
                var normalizedPositions = (ref2 = positions === null || positions === void 0 ? void 0 : positions.map(function(pos) {
                    return pos - positions[0];
                })) !== null && ref2 !== void 0 ? ref2 : [];
                setDatePositionList(normalizedPositions);
                var today = dayjs_min_default()().format("YYYY/MM/DD");
                var index = (ref = datesRef.current) === null || ref === void 0 ? void 0 : ref.map(function(date) {
                    return dayjs_min_default()(date);
                }).findIndex(function(date) {
                    return date.isSame(today, "month") && date.isSame(today, "day") || date.isAfter(today, "day");
                });
                var scrollIndex = index >= 0 ? index : 0;
                scrollTo(normalizedPositions[scrollIndex] + scrollPaddingTop, 300, function() {
                    setSelectedDate(dayjs_min_default()(datesRef.current[scrollIndex]).toDate());
                    setCurrentMonth(dayjs_min_default()(datesRef.current[scrollIndex]).toDate());
                });
                setIsInitializing(false);
            }, 1500) // レンダリングが完了しないとpositionを取得できないためバッファを設定する
            ;
        }
    }, [
        dates.length
    ]);
    (0,react.useEffect)(function() {
        setCurrentMonth(dayjs_min_default()(month).toDate());
    }, [
        month
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxWidth: 600,
                    position: "fixed",
                    top: 56,
                    zIndex: 9,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            height: 44,
                            backgroundColor: "background.default",
                            padding: "0 20px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.PrevArrow, {
                                fontSize: "xSmall",
                                onClick: handlePreviousMonth,
                                sx: {
                                    cursor: "pointer"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                onClick: function() {
                                    setIsOpen(!isOpen);
                                    var ref;
                                    var index = (ref = dates === null || dates === void 0 ? void 0 : dates.findIndex(function(date) {
                                        return date === dayjs_min_default()(selectedDate).format("YYYY/MM/DD");
                                    })) !== null && ref !== void 0 ? ref : null;
                                    if (index !== null) {
                                        scrollTo(datePositionList[index] + scrollPaddingTop, 300);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        sx: {
                                            cursor: "pointer",
                                            pr: 1
                                        },
                                        children: dayjs_min_default()(currentMonth).format("M月")
                                    }),
                                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.UpArrow, {
                                        fontSize: "small",
                                        sx: {
                                            cursor: "pointer"
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                        fontSize: "small",
                                        sx: {
                                            cursor: "pointer"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.NextArrow, {
                                fontSize: "xSmall",
                                onClick: handleNextMonth,
                                sx: {
                                    cursor: "pointer"
                                }
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, swipeHandlers), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDatePicker, {
                            displayStaticWrapperAs: "desktop",
                            value: currentMonth ? dayjs_min_default()(currentMonth) : null,
                            onChange: function(value) {
                                if (value && dayjs_min_default().isDayjs(value)) {
                                    var ref;
                                    var index = (ref = dates === null || dates === void 0 ? void 0 : dates.findIndex(function(date) {
                                        return date === dayjs_min_default()(value).format("YYYY/MM/DD");
                                    })) !== null && ref !== void 0 ? ref : null;
                                    var dateElements = document.getElementsByClassName(className);
                                    var ref1;
                                    var positions = Array.from(dateElements).map(function(element) {
                                        var ref;
                                        return (ref1 = (ref = element.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.top) !== null && ref1 !== void 0 ? ref1 : 0;
                                    });
                                    var ref2;
                                    var normalizedPositions = (ref2 = positions === null || positions === void 0 ? void 0 : positions.map(function(pos) {
                                        return pos - positions[0];
                                    })) !== null && ref2 !== void 0 ? ref2 : [];
                                    setDatePositionList(normalizedPositions);
                                    if (index !== null) {
                                        scrollTo(normalizedPositions[index] + scrollPaddingTop, 300, function() {
                                            setSelectedDate(value.toDate());
                                            setCurrentMonth(value.toDate());
                                        });
                                    }
                                }
                            },
                            dayOfWeekFormatter: function(day) {
                                return convertToFullWeekday(day);
                            },
                            slots: {
                                day: renderDay
                            }
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                height: isOpen ? CONTENT_HEIGHT : TOOLBAR_HEIGHT
            })
        ]
    });
};
/* harmony default export */ var event_EventCalendar = (EventCalendar);

;// CONCATENATED MODULE: ./src/components/pages/ArtistEvents/template/index.tsx














var EVENT_CARD_CLASS_NAME = "eventCard";
var ArtistEventsTemplate = function(param) {
    var state = param.state, onFetch = param.onFetch;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistEvents").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref4 = (0,react.useState)(false), openSideMenu = ref4[0], setOpenSideMenu = ref4[1];
    var scheduledEventList = (0,react.useMemo)(function() {
        var monthlyEvents = state === null || state === void 0 ? void 0 : state.monthlyEventsByArtist;
        if (!(monthlyEvents === null || monthlyEvents === void 0 ? void 0 : monthlyEvents.length)) return [];
        var uniqueSortedDates = (0,src_to_consumable_array/* default */.Z)(new Set(monthlyEvents.flatMap(function(event) {
            return (0,array/* buildEventDateArray */.E)(event, state.month);
        }))).sort(function(a, b) {
            return String(a).localeCompare(String(b));
        }).filter(function(date) {
            var ref;
            var ref1 = (0,_sliced_to_array/* default */.Z)((ref = date === null || date === void 0 ? void 0 : date.split("/")) !== null && ref !== void 0 ? ref : [], 2), year = ref1[0], month = ref1[1];
            return "".concat(year).concat(month) === state.month;
        });
        return uniqueSortedDates.map(function(date) {
            return {
                date: date || "",
                events: monthlyEvents.filter(function(event) {
                    var ref;
                    return (ref = (0,array/* buildEventDateArray */.E)(event, state.month)) === null || ref === void 0 ? void 0 : ref.includes(date || "");
                }).sort(function(a, b) {
                    return a.startedAt - b.startedAt;
                })
            };
        });
    }, [
        state === null || state === void 0 ? void 0 : state.monthlyEventsByArtist,
        state.month
    ]);
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    isLive: !!state.liveStreamId,
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                }
            },
            margin: true,
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasManagementTask) || !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.unreadNotificationCount),
                    color: "icon.line",
                    bgcolor: "icon.background"
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ArtistEvents
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(event_EventCalendar, {
                    dates: (ref5 = scheduledEventList.map(function(param) {
                        var date = param.date;
                        return date;
                    })) !== null && ref5 !== void 0 ? ref5 : [],
                    onFetch: onFetch,
                    month: state.month,
                    className: EVENT_CARD_CLASS_NAME
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventScheduledCardSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventScheduledCardSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventScheduledCardSkeleton, {})
                    ]
                }) : (scheduledEventList === null || scheduledEventList === void 0 ? void 0 : scheduledEventList.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    pt: 4,
                    sx: {
                        pb: 1
                    },
                    children: [
                        scheduledEventList.map(function(scheduledEvent, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventScheduledCard, {
                                scheduledEvent: scheduledEvent,
                                month: state.month,
                                className: EVENT_CARD_CLASS_NAME
                            }, scheduledEvent.date);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            height: window.innerHeight - 220
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    height: "76px",
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        children: t("eventEmpty")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistEvents/viewModel.ts



function ArtistEvents_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MonthlyEventsByArtist($id: ID, $artistId: String!, $month: String!) {\n    artist(id: $id) {\n      ...ArtistBottomTab\n      id\n      currentLive {\n        id\n      }\n    }\n    monthlyEventsByArtist(month: $month, artistId: $artistId) {\n      ...MonthlyEventsByArtist\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistEvents_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistSearch {\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ArtistEvents_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(dayjs_min_default()().format("YYYYMM")), month = ref7[0], setMonth = ref7[1];
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref8 = (0,useQuery/* useQuery */.aM)(ArtistEvents_viewModel_QUERY, {
        variables: {
            artistId: artistId,
            month: month,
            id: artistId
        },
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref8.data, loading = ref8.loading;
    var ref9 = (0,useQuery/* useQuery */.aM)(USER_QUERY), userData = ref9.data;
    (0,react.useEffect)(function() {
        var month = sessionStorage.getItem(constants/* constants.storageKeys.EVENT_MONTH */._.storageKeys.EVENT_MONTH);
        if (month) {
            setMonth(month);
            sessionStorage.removeItem(constants/* constants.storageKeys.EVENT_MONTH */._.storageKeys.EVENT_MONTH);
        }
    }, []);
    var ref10, ref11, ref12;
    return {
        state: {
            loading: loading,
            month: month,
            user: (userData === null || userData === void 0 ? void 0 : userData.user) || null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist),
            followArtists: (ref10 = userData === null || userData === void 0 ? void 0 : (ref2 = userData.user) === null || ref2 === void 0 ? void 0 : ref2.organizationFollowees) !== null && ref10 !== void 0 ? ref10 : null,
            memberArtists: (ref11 = userData === null || userData === void 0 ? void 0 : (ref3 = userData.user) === null || ref3 === void 0 ? void 0 : ref3.organizationPatrons) !== null && ref11 !== void 0 ? ref11 : null,
            liveStreamId: (data === null || data === void 0 ? void 0 : (ref4 = data.monthlyEventsByArtist) === null || ref4 === void 0 ? void 0 : ref4.length) ? (ref5 = data.monthlyEventsByArtist[0].artist) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currentLive) === null || ref6 === void 0 ? void 0 : ref6.id : undefined,
            monthlyEventsByArtist: (ref12 = data === null || data === void 0 ? void 0 : data.monthlyEventsByArtist) !== null && ref12 !== void 0 ? ref12 : null
        },
        actions: {
            onFetch: function onFetch(month) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setMonth(month);
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var ArtistEvents_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistEvents_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* MonthlyEventsByArtistFragmentDoc */.q2X);
var USER_QUERY = (0,lib/* gql */.Ps)(viewModel_templateObject1(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/ArtistEvents/index.tsx




/**
 * ArtistEvents Page
 * Implemented as a practical sample.
 */ var ArtistEvents = function() {
    var ref = ArtistEvents_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistEventsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(97423);
;// CONCATENATED MODULE: ./src/components/organisms/gacha/GachaBox/GachaBox.tsx







var GachaBox = function(param) {
    var gacha = param.gacha, artistId = param.artistId, fullWidth = param.fullWidth;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var href = (0,react.useMemo)(function() {
        if (artistId) {
            return generatePath(routerPages.ArtistGachaDetail, {
                gachaId: gacha.id,
                artistId: artistId
            });
        }
        return generatePath(routerPages.ArtistGachaDetail, {
            gachaId: gacha.id
        });
    }, [
        artistId,
        gacha.id,
        generatePath,
        routerPages.ArtistGachaDetail
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            width: fullWidth ? "100%" : 315,
            background: "none",
            boxShadow: "none",
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "grid",
                    gridTemplateColumns: fullWidth ? "40.6% 1fr" : "136px 1fr",
                    gap: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            // HACK: 画像アスペクト比を4:3に固定する
                            position: "relative",
                            pt: "75%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                            component: "img",
                            alt: gacha.name,
                            image: gacha.thumbnail.smallUri || "",
                            sx: {
                                borderRadius: 2,
                                aspectRatio: "4 / 3",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: 1,
                                height: 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        justifyContent: "center",
                        children: [
                            !!(gacha.gpsData || gacha.isPremium) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    gacha.gpsData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckInChip, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                    gacha.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                        fontSize: "medium",
                                        sx: {
                                            color: "info.main"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                        children: gacha.name
                                    }),
                                    gacha.formattedEndAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.hint",
                                        children: t("until", {
                                            string: gacha.formattedEndAt,
                                            interpolation: {
                                                escapeValue: false
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var CheckInChip = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "white",
                display: "block",
                children: "CHECK-IN"
            }),
            sx: {
                borderRadius: "2px",
                height: 20,
                bgcolor: "secondary.dark",
                ".MuiChip-label": {
                    px: 1
                }
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistGachas/template/index.tsx








var ArtistGachasTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("artistGachas").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    isLive: !!state.liveStreamId,
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                }
            },
            header: {
                title: t("title")
            },
            margin: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistGachas,
                        state.artistName
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutAreaCell, {
                    artistId: state.artistId,
                    artistGachas: state.artistGachas,
                    hasNextPage: state.hasNextPage,
                    loading: state.loading,
                    onFetchMore: onFetchMore
                })
            ]
        })
    });
};
var LayoutAreaCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, artistId = param.artistId, artistGachas = param.artistGachas, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistGachas").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: artistGachas === null || artistGachas === void 0 ? void 0 : (ref = artistGachas.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var node = param.node;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBox, {
                    gacha: node,
                    artistId: artistId,
                    fullWidth: true
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 5
            },
            emptyMessage: t("gachaEmptyMessage")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistGachas/viewModel.ts



function ArtistGachas_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistGachas($gachasArtistId: ID, $gachasPageInput: PageInputDate) {\n    user {\n      ...CurrentUser\n    }\n    artist(id: $gachasArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    gachas(artistId: $gachasArtistId, pageInput: $gachasPageInput) {\n      ...GachasConnection\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistGachas_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistGachas_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistGachas(\n    $gachasArtistId: ID\n    $gachasPageInput: PageInputDate\n  ) {\n    artist(id: $gachasArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    gachas(artistId: $gachasArtistId, pageInput: $gachasPageInput) {\n      ...GachasConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistGachas_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ArtistGachas_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_GACHA,
        variables: {
            gachasArtistId: artistId
        },
        fields: [
            {
                fieldName: "gachas",
                fragmentName: "GachaBox",
                fragment: utoniq_core_schema/* GachaBoxFragmentDoc */.gop
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref4 = (0,useQuery/* useQuery */.aM)(ArtistGachas_viewModel_QUERY, {
        variables: {
            gachasArtistId: artistId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(param) {
            var artist = param.artist;
            isFirstLoadRef.current = false;
            if (artist) {
                (0,vars/* currentArtistVar */.ag)(artist);
            }
        }
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var isNextFetch = !!data;
    var ref5, ref6;
    return {
        state: {
            loading: loading && !isNextFetch,
            artistId: artistId,
            artistName: (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.displayName) || "",
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.gachas) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            artistGachas: (ref5 = data === null || data === void 0 ? void 0 : data.gachas) !== null && ref5 !== void 0 ? ref5 : null,
            liveStreamId: data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.currentLive) === null || ref3 === void 0 ? void 0 : ref3.id,
            user: (ref6 = data === null || data === void 0 ? void 0 : data.user) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            gachasArtistId: artistId,
                                            gachasPageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.gachas) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistGachas_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistGachas_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* GachasConnectionFragmentDoc */.M$Q, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_GACHA = (0,lib/* gql */.Ps)(ArtistGachas_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* GachasConnectionFragmentDoc */.M$Q);

;// CONCATENATED MODULE: ./src/components/pages/ArtistGachas/index.tsx



/**
 * ArtistGachas Page
 * Implemented as a practical sample.
 */ var ArtistGachas = function() {
    var ref = ArtistGachas_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistGachasTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Tabs/Tabs.js + 2 modules
var Tabs = __webpack_require__(30377);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Tab/Tab.js
var Tab = __webpack_require__(41574);
// EXTERNAL MODULE: ../../node_modules/react-swipeable-views/lib/index.js
var react_swipeable_views_lib = __webpack_require__(9069);
;// CONCATENATED MODULE: ./src/components/organisms/functionals/Tabs/TabPanel.tsx


var TabPanel = function(param) {
    var children = param.children, value = param.value, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        role: "tabpanel",
        hidden: value !== index,
        id: "tabpanel-".concat(index),
        "aria-labelledby": "utoniq-tab-".concat(index),
        children: value === index && children
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/functionals/Tabs/index.tsx







var Tabs_Tabs = function(param) {
    var labels = param.labels, value = param.value, onChange = param.onChange, hiddenLabel = param.hiddenLabel, disableAnimateTransitions = param.disableAnimateTransitions, children = param.children;
    var width = useScreenWidth();
    var handleChange = (0,react.useCallback)(function(event, newValue) {
        onChange(newValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            !hiddenLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                value: value,
                onChange: handleChange,
                variant: "scrollable",
                scrollButtons: width > 600,
                sx: {
                    pb: 4,
                    "& .MuiTabs-flexContainer": {
                        borderBottomWidth: 1,
                        borderBottomStyle: "solid",
                        borderBottomColor: "grey.100",
                        width: "fit-content",
                        minWidth: "100%"
                    }
                },
                children: labels.map(function(label, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        label: label
                    }, a11yProps(index)), {
                        sx: {
                            whiteSpace: "nowrap",
                            minWidth: "calc(100% / ".concat(labels.length, ")")
                        }
                    }), index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swipeable_views_lib/* default */.ZP, {
                index: value,
                onChangeIndex: onChange,
                disabled: hiddenLabel,
                animateTransitions: !(hiddenLabel || disableAnimateTransitions),
                children: react.Children.map(children, function(child, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                        index: index,
                        value: value,
                        children: child
                    }, index);
                })
            })
        ]
    });
};
function a11yProps(index) {
    return {
        id: "utoniq-tab-".concat(index),
        "aria-controls": "tabpanel-".concat(index)
    };
}
// 画面幅の取得
var useScreenWidth = function() {
    var getInnerWidth = function() {
        return window === null || window === void 0 ? void 0 : window.innerWidth;
    };
    var ref = (0,react.useState)(getInnerWidth()), width = ref[0], setWidth = ref[1];
    (0,react.useEffect)(function() {
        if (!window) return;
        var onResize = function() {
            setWidth(getInnerWidth());
        };
        window.addEventListener("resize", onResize);
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, []);
    return width;
};

// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/Box/Box.js + 1 modules
var esm_Box_Box = __webpack_require__(94131);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(98614);
;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/EmptyGalleryList.tsx




/**
 * ArtistGallery Page
 * Implemented as a practical sample.
 */ var EmptyGalleryList = function() {
    var t = (0,dist_es/* useTranslation */.$G)("artistGallery").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "primary.main",
            sx: {
                textAlign: "center"
            },
            children: t("postNotExist")
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Grid2/Grid2.js + 4 modules
var Grid2 = __webpack_require__(39899);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button_Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/@mui/material/useMediaQuery/index.js + 1 modules
var useMediaQuery = __webpack_require__(45150);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(40687);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CardActions/CardActions.js
var CardActions = __webpack_require__(34252);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Drawer/Drawer.js
var Drawer_Drawer = __webpack_require__(28207);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Divider/Divider.js
var Divider_Divider = __webpack_require__(56961);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress_CircularProgress = __webpack_require__(90838);
// EXTERNAL MODULE: ../../node_modules/react-youtube/dist/index.esm.js
var index_esm = __webpack_require__(2570);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(7702);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Popper/Popper.js + 55 modules
var Popper = __webpack_require__(58229);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(6693);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(37742);
// EXTERNAL MODULE: ../../node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(19181);
// EXTERNAL MODULE: ../../node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem_MenuItem = __webpack_require__(95341);
;// CONCATENATED MODULE: ../utoniq-ui/src/components/Input/InlineMenu/index.tsx




/**
 * 呼び出し元の付近にメニューを表示するコンポーネント
 *
 * @param menuItems メニュー項目情報 { label: 表示文言, disabled: 無効化フラグ, onClick: メニュー項目選択イベント }
 * @param open メニュー表示フラグ
 * @param placement メニュー表示位置
 * @param anchorEl メニュー表示位置の参照
 * @param PaperProps メニューの外枠スタイル
 * @param MenuListProps メニューの内枠スタイル
 * @param MenuItemProps メニューの項目スタイル
 * @param onClose メニュー選択時にメニューを閉じるイベント
 */ var InlineMenu = function(param) {
    var menuItems = param.menuItems, _placement = param.placement, placement = _placement === void 0 ? "bottom-start" : _placement, _open = param.open, open = _open === void 0 ? false : _open, anchorEl = param.anchorEl, PaperProps = param.PaperProps, MenuListProps = param.MenuListProps, MenuItemProps = param.MenuItemProps, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        open: open,
        anchorEl: anchorEl,
        placement: placement,
        transition: true,
        disablePortal: true,
        sx: {
            // Material-UIデフォルトのモーダルのz-indexに合わせる
            zIndex: 1300,
            minWidth: "200px",
            backgroundColor: "transparent",
            borderRadius: "4px"
        },
        children: function(param) {
            var TransitionProps = param.TransitionProps, placement = param.placement;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grow/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, TransitionProps), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    elevation: 2
                }, PaperProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
                        onClickAway: function() {
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            id: "inline-menu",
                            "aria-labelledby": "inline-button",
                            sx: {
                                backgroundColor: "gray.100"
                            }
                        }, MenuListProps), {
                            children: menuItems.map(function(i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    onClick: function() {
                                        if (i.onClick) {
                                            i.onClick();
                                        }
                                        onClose === null || onClose === void 0 ? void 0 : onClose();
                                    },
                                    disabled: i.disabled
                                }, MenuItemProps), {
                                    children: i.label
                                }), i.label);
                            })
                        }))
                    })
                }))
            }));
        }
    });
};

// EXTERNAL MODULE: ./src/components/organisms/item/ThumbnailFullScreenModal/index.tsx + 1 modules
var ThumbnailFullScreenModal = __webpack_require__(14575);
// EXTERNAL MODULE: ./src/components/organisms/resourcePlayer/SoundPlayer/SoundPurePlayer.tsx
var SoundPurePlayer = __webpack_require__(72819);
// EXTERNAL MODULE: ./src/core/messages/useMessage.tsx
var messages_useMessage = __webpack_require__(30226);
// EXTERNAL MODULE: ./src/core/membership/useSettingUserInfoModal.tsx + 3 modules
var useSettingUserInfoModal = __webpack_require__(91535);
// EXTERNAL MODULE: ./src/core/resources/usePlayingResource.tsx
var resources_usePlayingResource = __webpack_require__(31986);
// EXTERNAL MODULE: ./src/components/organisms/post/HtmlRenderer/index.tsx + 2 modules
var HtmlRenderer = __webpack_require__(38877);
// EXTERNAL MODULE: ./src/components/organisms/post/ThumbnailImage/index.tsx
var ThumbnailImage = __webpack_require__(97678);
;// CONCATENATED MODULE: ./src/components/organisms/post/PostBox/index.tsx

























var PostBox = function(param) {
    var p = param.post, fullWidth = param.fullWidth, _clickable = param.clickable, clickable = _clickable === void 0 ? true : _clickable, sx = param.sx, mediaProps = param.mediaProps, fullContent = param.fullContent, onLike = param.onLike, onReply = param.onReply, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, _detail = param.detail, detail = _detail === void 0 ? false : _detail, onReportArtist = param.onReportArtist, onBlockArtist = param.onBlockArtist, isConsole = param.isConsole, onDeletePost = param.onDeletePost, loadingDeletePost = param.loadingDeletePost, userId = param.userId, _enableEmbedHtml = param.enableEmbedHtml, enableEmbedHtml = _enableEmbedHtml === void 0 ? false : _enableEmbedHtml, onClickShare = param.onClickShare;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref11.showMessage, showError = ref11.showError;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref12 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref12.routerPages, generatePath = ref12.generatePath;
    var ref13 = (0,react.useState)(false), open = ref13[0], setOpen = ref13[1];
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var ref14 = (0,react.useState)(false), openInformationModal = ref14[0], setOpenInformationModal = ref14[1];
    var ref15 = (0,react.useState)(null), anchorEl = ref15[0], setAnchorEl = ref15[1];
    var mdUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var isShowModalPersonalInfoRequire = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!p.isPremium) {
            return false;
        }
        return isMembershipPersonalInformationRequired && ((ref = p.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired);
    }, [
        isMembershipPersonalInformationRequired,
        (ref = p.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired,
        p.isPremium, 
    ]);
    /**
   * @description
   * コメント機能を無効化しているか否か
   * 無効化している場合はリプライのトグルボタンを表示しない
   */ var disableReplies = (ref2 = p.artist.settings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.features) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.post) === null || ref4 === void 0 ? void 0 : ref4.disableReplies;
    /**
   * @description
   * いいね機能を無効化しているか否か
   * 無効化している場合はいいねボタンを表示しない
   */ var disableLikes = (ref5 = p.artist.settings) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.features) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.post) === null || ref7 === void 0 ? void 0 : ref7.disableLikes;
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var actions = [
        {
            title: t("report"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!onReportArtist) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    onReportArtist()
                                ];
                            case 1:
                                _state.sent();
                                setOpen(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            divider: false
        },
        {
            title: t("block"),
            hidden: config_config/* config.applicationType */.v.applicationType === "standalone",
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!onBlockArtist) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    onBlockArtist()
                                ];
                            case 1:
                                _state.sent();
                                setOpen(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            divider: true
        },
        {
            title: t("cancel"),
            onClick: toggleDrawer(false),
            divider: false,
            titleColor: "primary.main"
        }, 
    ];
    var _planId, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                component: Stack_Stack/* default */.Z,
                sx: (0,src_object_spread/* default */.Z)({
                    display: "flex",
                    width: fullWidth || responsive ? "100%" : 315,
                    minHeight: responsive ? 356 : undefined,
                    height: "auto"
                }, sx),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostDetailCell, {
                    postId: p.id,
                    planId: (_planId = p.planId) !== null && _planId !== void 0 ? _planId : "",
                    clickable: clickable,
                    isAccessible: p.isAccessible,
                    artist: p.artist,
                    isConsole: isConsole,
                    isShowModalPersonalInfoRequire: !!isShowModalPersonalInfoRequire,
                    planTitle: (ref16 = (ref8 = p.plan) === null || ref8 === void 0 ? void 0 : ref8.planTitle) !== null && ref16 !== void 0 ? ref16 : "",
                    children: [
                        (p.isAccessible && p.resourceType !== utoniq_core_schema/* PostType.Image */.hQF.Image || !p.isAccessible || p.resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostMedia, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            clickable: clickable
                        }, mediaProps), {
                            post: p,
                            isConsole: isConsole,
                            responsive: responsive,
                            detail: detail
                        })),
                        p.status === utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled && !p.isStory && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            sx: {
                                px: 4,
                                pt: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                    fontSize: "xSmall",
                                    sx: {
                                        color: "primary.main"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "primary",
                                    sx: {
                                        textTransform: "unset"
                                    },
                                    children: t("scheduleMessage", {
                                        date: p.formattedPublishedAt
                                    })
                                })
                            ]
                        }),
                        p.isStory && isConsole && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryStatusTag, {
                            publishedAt: p.publishedAt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                            sx: {
                                pb: 2,
                                color: "inherit",
                                width: "100%",
                                "& .MuiCardHeader-action": {
                                    m: "auto"
                                }
                            },
                            avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                onClick: handleLoginModal(),
                                href: generatePath(routerPages.UserProfile, {
                                    userId: p.artist.id
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: ((ref9 = p.artist.avatar) === null || ref9 === void 0 ? void 0 : ref9.smallUri) || undefined,
                                    sx: {
                                        width: 36,
                                        height: 36,
                                        mr: -2,
                                        position: "relative",
                                        zIndex: 2
                                    }
                                })
                            }),
                            onClick: function(event) {
                                event.stopPropagation();
                            },
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                underline: "none",
                                onClick: handleLoginModal(),
                                href: generatePath(routerPages.UserProfile, {
                                    userId: p.artist.id
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    sx: {
                                        position: "relative",
                                        zIndex: 2,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            color: "text.secondary",
                                            children: p.artist.displayName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "caption",
                                            color: "text.hint",
                                            children: p.formattedRelativePublishedAt
                                        })
                                    ]
                                })
                            }),
                            titleTypographyProps: {
                                sx: {
                                    width: "fit-content"
                                }
                            },
                            action: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                justifyContent: "flex-end",
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    p.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                        fontSize: "medium",
                                        sx: {
                                            color: "primary.main"
                                        }
                                    }),
                                    !clickable && !isConsole && userId !== p.artist.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                                size: "small",
                                                onClick: function(e) {
                                                    setAnchorEl(e.currentTarget);
                                                    toggleDrawer(true)();
                                                }
                                            }),
                                            responsive && mdUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineMenu, {
                                                menuItems: (0,array/* filterHiddenItem */.s)(actions.filter(function(action) {
                                                    return action.title !== t("cancel");
                                                })).map(function(param, index) {
                                                    var title = param.title, onClick = param.onClick;
                                                    return {
                                                        label: title,
                                                        disabled: false,
                                                        onClick: function() {
                                                            return onClick();
                                                        }
                                                    };
                                                }),
                                                open: open,
                                                anchorEl: anchorEl || undefined,
                                                onClose: function() {
                                                    return toggleDrawer(false)();
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        p.category ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                padding: "8px 16px 8px",
                                width: "fit-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "white",
                                bgcolor: "text.secondary",
                                sx: {
                                    padding: 1,
                                    borderRadius: 1
                                },
                                children: (ref10 = p.category) === null || ref10 === void 0 ? void 0 : ref10.name
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                    sx: {
                                        pt: 1,
                                        pb: 2,
                                        display: "flex",
                                        flexGrow: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body1",
                                        sx: {
                                            wordBreak: "break-all",
                                            "&": fullContent || !p.isAccessible ? {} : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(getLineCamp(p))), {
                                                whiteSpace: "pre-wrap",
                                                /**
                             * @description
                             * iosの一部画面のみ、特定のCSSが効かない(ex: -webkit-box-orient)
                             * hotfixとして文字数分の高さを明示的に指定し、overflow: hiddenによりはみ出た文字が隠されレイアウト崩れを防ぐ対応を入れる。
                             * https://app.clickup.com/t/908127/UT-4232
                             */ maxHeight: getMaxHeight(get_default()(sx, "height", 0), p)
                                            })
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlRenderer/* HtmlRenderer */.V, {
                                            text: p.content,
                                            enableEmbedHtml: enableEmbedHtml,
                                            tagName: "form"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                                    sx: {
                                        pt: 0,
                                        pb: 3,
                                        px: 5,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            children: isConsole && userId === p.artist.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 3,
                                                sx: {
                                                    position: "relative",
                                                    zIndex: 2,
                                                    color: "text.secondary"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                                                        size: "small",
                                                        href: generatePath(routerPages.ConsolePostEdit, {
                                                            postId: p.id
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                                        onClick: function() {
                                                            if (!onDeletePost) return;
                                                            setOpenInformationModal(true);
                                                        },
                                                        size: "small"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 5,
                                            children: [
                                                !disableLikes && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    sx: !(!p.isAccessible || isShowModalPersonalInfoRequire) ? {
                                                        position: "relative",
                                                        zIndex: 2
                                                    } : {},
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Like, {
                                                            disabled: !p.isAccessible || !!isShowModalPersonalInfoRequire,
                                                            onClick: handleLoginModal(function(e) {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                onLike && onLike();
                                                            }),
                                                            onMouseDown: function(e) {
                                                                //disable ripple on parent
                                                                e.stopPropagation();
                                                            },
                                                            onTouchStart: function(e) {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                            },
                                                            disableTouchRipple: !onLike,
                                                            liked: p.isLike
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "caption",
                                                            children: p.likeCount
                                                        })
                                                    ]
                                                }),
                                                !disableReplies && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Reply, {
                                                            disabled: !p.isAccessible,
                                                            onClick: handleLoginModal(onReply),
                                                            disableTouchRipple: !onReply
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "caption",
                                                            children: p.replyCount
                                                        })
                                                    ]
                                                }),
                                                onClickShare && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Share, {
                                                        onClick: onClickShare
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, p.id),
            (!mdUp || !responsive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: toggleDrawer(false),
                sx: {
                    "& .MuiPaper-root": {
                        maxWidth: responsive ? "100%" : undefined
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: p.artist.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        children: (0,array/* filterHiddenItem */.s)(actions).map(function(param, index) {
                            var title = param.title, onClick = param.onClick, divider = param.divider, titleColor = param.titleColor;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                divider: divider,
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52,
                                    justifyContent: "center"
                                },
                                onClick: handleLoginModal(onClick),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    color: titleColor,
                                    children: title
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openInformationModal,
                onClose: function() {
                    return setOpenInformationModal(false);
                },
                title: t("titleModalDelete"),
                content: t("contentModalDelete"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        width: 212
                    },
                    size: "large",
                    loading: !!loadingDeletePost,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        var e;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!onDeletePost) return [
                                        2
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        onDeletePost(p.id)
                                    ];
                                case 2:
                                    _state.sent();
                                    showMessage(t("theDeletionIsComplete"));
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    e = _state.sent();
                                    showError(t("anErrorHasOccurred"));
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    setOpenInformationModal(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("textButtonOkModalDelete")
                }),
                cancelText: t("textButtonCloseModalDelete")
            })
        ]
    });
};
var PostDetailCell = function(param) {
    var clickable = param.clickable, postId = param.postId, planTitle = param.planTitle, artist = param.artist, isAccessible = param.isAccessible, isConsole = param.isConsole, children = param.children, planId = param.planId, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    // ユーザーが加入しているメンバーシップよりも上位プランであるかどうか
    var isGraterPlan = !isAccessible && planId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        sx: {
            width: "100%",
            position: "relative",
            bgcolor: clickable ? "grey.50" : "unset"
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                disabled: !clickable,
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1
                },
                onClick: function() {
                    !isAccessible && setOpen(true);
                    isShowModalPersonalInfoRequire && showModal();
                },
                href: isAccessible && !isShowModalPersonalInfoRequire ? generatePath(isConsole ? routerPages.ConsolePostDetail : routerPages.PostDetail, {
                    postId: postId
                }) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: isGraterPlan ? t("viewMemberInfoTitleWithDiff") : t("viewMemberInfoTitle"),
                content: isGraterPlan ? t("viewMemberInfoDescWithDiff", {
                    planTitle: planTitle
                }) : t("viewMemberInfoDesc", {
                    displayName: artist.displayName
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    href: (artist === null || artist === void 0 ? void 0 : artist.id) ? generatePath(routerPages.ArtistMembership, {
                        artistId: artist.id
                    }) : undefined,
                    children: t("seeDetail")
                })
            })
        ]
    });
};
var PostMedia = function(param) {
    var _post = param.post, resourceType = _post.resourceType, resource = _post.resource, isAccessible = _post.isAccessible, content = _post.content, id = _post.id, resources = _post.resources, planId = _post.planId, planTitle = _post.planTitle, videoThumbnail = _post.videoThumbnail, imageThumbnail = _post.imageThumbnail, isStory = _post.isStory, plan = _post.plan, sx = param.sx, clickable = param.clickable, _isConsole = param.isConsole, isConsole = _isConsole === void 0 ? false : _isConsole, responsive = param.responsive, detail = param.detail;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var youTubeRef = (0,react.useRef)(null);
    var videoRef = (0,react.useRef)(null);
    var swiperRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(0), activeIndex = ref3[0], setActiveIndex = ref3[1];
    var ref4 = (0,resources_usePlayingResource/* usePlayingResource */.p)(), playingResource = ref4.playingResource, playResource = ref4.playResource;
    var ref5 = (0,react.useState)(false), isPlaying = ref5[0], setIsPlaying = ref5[1];
    var uri = (resource === null || resource === void 0 ? void 0 : resource.uri) || "";
    var ref6, ref7;
    var imageUri = (ref7 = (ref6 = resources === null || resources === void 0 ? void 0 : (ref = resources[0]) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref6 !== void 0 ? ref6 : resources === null || resources === void 0 ? void 0 : (ref1 = resources[0]) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8 = (0,react.useState)(), currentResource = ref8[0], setCurrentResource = ref8[1];
    var ref9 = (0,react.useState)(""), videoDuration = ref9[0], setVideoDuration = ref9[1];
    var ref10 = (0,react.useState)(true), isVideoLoading = ref10[0], setIsVideoLoading = ref10[1];
    // 動画の再生時間を取得
    (0,react.useEffect)(function() {
        if (!videoRef.current) return;
        var videoElement = videoRef.current;
        setIsVideoLoading(true);
        var handleLoadedMetadata = function() {
            var seconds = Math.floor(videoElement.duration || 0);
            var minutes = Math.floor(seconds / 60);
            var remainingSeconds = seconds % 60;
            setVideoDuration("".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, "0")));
            setIsVideoLoading(false);
        };
        videoElement.addEventListener("loadedmetadata", handleLoadedMetadata);
        // すでにメタデータがロード済みの場合の処理
        if (videoElement.readyState >= 1) {
            handleLoadedMetadata();
        }
        return function() {
            videoElement.removeEventListener("loadedmetadata", handleLoadedMetadata);
        };
    }, [
        videoRef.current
    ]);
    (0,react.useEffect)(function() {
        if (playingResource !== (resource === null || resource === void 0 ? void 0 : resource.videoId)) {
            var ref, ref1;
            (ref1 = (ref = youTubeRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer()) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        }
    }, [
        playingResource,
        resource === null || resource === void 0 ? void 0 : resource.videoId
    ]);
    var renderVideoContent = function() {
        // プレミアムコンテンツで未購入の場合
        if (!isAccessible) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                        sx: Limited24hTagPositionStyle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumOverlay, {
                        planId: planId !== null && planId !== void 0 ? planId : "",
                        planTitle: (ref = plan === null || plan === void 0 ? void 0 : plan.planTitle) !== null && ref !== void 0 ? ref : "",
                        planInterval: plan === null || plan === void 0 ? void 0 : plan.interval
                    }),
                    (videoThumbnail === null || videoThumbnail === void 0 ? void 0 : videoThumbnail.blurUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage/* ThumbnailImage */.a, {
                        src: (ref1 = videoThumbnail === null || videoThumbnail === void 0 ? void 0 : videoThumbnail.blurUri) !== null && ref1 !== void 0 ? ref1 : "",
                        alt: "membership only video thumbnail"
                    })
                ]
            });
        }
        var ref2;
        // 通常の動画表示
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                    sx: Limited24hTagPositionStyle
                }),
                !isPlaying && isVideoLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        position: "absolute",
                        justifyContent: "center",
                        alignItems: "center",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        bgcolor: "grey.100",
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress_CircularProgress/* default */.Z, {})
                }),
                !isPlaying && !isVideoLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnail, {
                    videoThumbnailUri: (ref2 = videoThumbnail === null || videoThumbnail === void 0 ? void 0 : videoThumbnail.uri) !== null && ref2 !== void 0 ? ref2 : "",
                    onClick: function() {
                        if (videoRef.current) {
                            setIsPlaying(true);
                            videoRef.current.play();
                        }
                    },
                    videoDuration: videoDuration
                }),
                (resource === null || resource === void 0 ? void 0 : resource.uri) && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    width: "100%",
                    height: "100%",
                    ref: videoRef,
                    onEnded: function() {
                        return setIsPlaying(false);
                    },
                    controls: isPlaying,
                    style: {
                        display: isPlaying ? "block" : "none"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: resource.uri,
                        type: "video/mp4"
                    })
                })
            ]
        });
    };
    switch(resourceType){
        case utoniq_core_schema/* PostType.Video */.hQF.Video:
            if (!resource) {
                return null;
            }
            var ref11;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                component: clickable && isAccessible ? Link/* default */.Z : Box_Box/* default */.Z,
                href: isConsole ? generatePath(routerPages.ConsolePostDetail, {
                    postId: id
                }) : clickable && isAccessible ? generatePath(routerPages.PostDetail, {
                    postId: id
                }) : undefined,
                sx: (0,src_object_spread/* default */.Z)({
                    position: "relative",
                    width: responsive ? "100%" : undefined,
                    maxHeight: detail ? 532 : 266,
                    minHeight: responsive ? 160 : undefined,
                    height: responsive ? undefined : 160,
                    aspectRatio: responsive ? "335 / 160" : undefined,
                    overflow: "hidden",
                    "& iframe": (0,src_object_spread/* default */.Z)({
                        pointerEvents: clickable ? "none" : "unset",
                        display: "block",
                        height: responsive ? "100%" : 160,
                        width: "100%",
                        position: responsive ? "absolute" : undefined
                    }, sx)
                }, sx),
                children: [
                    (resource === null || resource === void 0 ? void 0 : resource.videoId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                                sx: Limited24hTagPositionStyle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                                ref: youTubeRef,
                                id: resource.videoId,
                                videoId: resource.videoId,
                                opts: {
                                    playerVars: {
                                        controls: +isAccessible ? 1 : 0
                                    }
                                },
                                onPlay: function() {
                                    return playResource((ref11 = resource === null || resource === void 0 ? void 0 : resource.videoId) !== null && ref11 !== void 0 ? ref11 : "");
                                }
                            })
                        ]
                    }),
                    (resource === null || resource === void 0 ? void 0 : resource.uri) && renderVideoContent()
                ]
            });
        case utoniq_core_schema/* PostType.Sound */.hQF.Sound:
            if (!resource) {
                return null;
            }
            var ref12;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: (0,src_object_spread/* default */.Z)({
                    position: "relative",
                    pt: 5,
                    px: 5,
                    pb: 3,
                    bgcolor: "grey.50",
                    height: 160
                }, sx),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundPurePlayer/* SoundPurePlayer */.z, {
                        uri: uri
                    }),
                    !isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumOverlay, {
                        planId: planId !== null && planId !== void 0 ? planId : "",
                        planTitle: (ref12 = plan === null || plan === void 0 ? void 0 : plan.planTitle) !== null && ref12 !== void 0 ? ref12 : "",
                        planInterval: plan === null || plan === void 0 ? void 0 : plan.interval
                    })
                ]
            });
        case utoniq_core_schema/* PostType.Image */.hQF.Image:
            if (!imageUri && !(resources === null || resources === void 0 ? void 0 : resources.length)) {
                return null;
            }
            var ref13, ref14, ref15;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: (0,src_object_spread/* default */.Z)({
                    position: "relative",
                    width: responsive ? "100%" : undefined,
                    maxHeight: detail ? undefined : 266,
                    minHeight: responsive ? 160 : undefined,
                    height: responsive ? undefined : 160,
                    aspectRatio: detail ? undefined : "335 / 160",
                    overflow: "hidden",
                    ".image-swiper .swiper-wrapper": {
                        display: "flex",
                        alignItems: "center"
                    }
                }, sx),
                children: [
                    isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                        sx: Limited24hTagPositionStyle
                    }),
                    !isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumOverlay, {
                        planId: planId !== null && planId !== void 0 ? planId : "",
                        planTitle: (ref13 = plan === null || plan === void 0 ? void 0 : plan.planTitle) !== null && ref13 !== void 0 ? ref13 : "",
                        planInterval: plan === null || plan === void 0 ? void 0 : plan.interval
                    }),
                    clickable || !(((resources === null || resources === void 0 ? void 0 : resources.length) || 0) > 1) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                        component: "img",
                        image: isAccessible ? imageUri !== null && imageUri !== void 0 ? imageUri : "" : (ref14 = imageThumbnail === null || imageThumbnail === void 0 ? void 0 : imageThumbnail.blurUri) !== null && ref14 !== void 0 ? ref14 : "",
                        alt: content,
                        sx: {
                            width: responsive ? "100%" : undefined,
                            height: "100%",
                            objectFit: detail ? undefined : "cover"
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                ref: swiperRef,
                                loop: false,
                                slidesPerView: 1,
                                centeredSlides: true,
                                spaceBetween: 0,
                                initialSlide: 0,
                                enabled: ((resources === null || resources === void 0 ? void 0 : resources.length) || 0) > 1 && isAccessible,
                                className: "image-swiper",
                                onSlideChange: function(param) {
                                    var activeIndex = param.activeIndex;
                                    return setActiveIndex(activeIndex);
                                },
                                children: [
                                    resources === null || resources === void 0 ? void 0 : resources.map(function(param, index) {
                                        var uri = param.uri, mediumUri = param.mediumUri;
                                        return uri && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                sx: {
                                                    width: "100%",
                                                    height: detail ? "100%" : 469,
                                                    bgcolor: "grey.50"
                                                },
                                                onClick: function() {
                                                    if (!isAccessible) return;
                                                    setCurrentResource({
                                                        uri: uri
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    variant: "square",
                                                    src: (ref15 = mediumUri !== null && mediumUri !== void 0 ? mediumUri : uri) !== null && ref15 !== void 0 ? ref15 : "",
                                                    alt: content,
                                                    sx: {
                                                        height: detail ? "100%" : 469,
                                                        width: "100%",
                                                        img: {
                                                            objectFit: "contain"
                                                        }
                                                    }
                                                })
                                            })
                                        }, index);
                                    }),
                                    isAccessible && activeIndex > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {
                                        onClick: function() {
                                            var ref;
                                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slidePrev();
                                        }
                                    }),
                                    isAccessible && activeIndex < ((resources === null || resources === void 0 ? void 0 : resources.length) || 0) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {
                                        onClick: function() {
                                            var ref;
                                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideNext();
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    right: 12,
                                    bottom: 12,
                                    bgcolor: "grey.900",
                                    borderRadius: "40px",
                                    zIndex: 3,
                                    p: "3px 6px",
                                    display: isAccessible ? "block" : "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    sx: {
                                        color: "grey.50"
                                    },
                                    children: [
                                        (activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0) + 1,
                                        "/",
                                        resources === null || resources === void 0 ? void 0 : resources.length
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailFullScreenModal/* ThumbnailFullScreenModal */.e, {
                                resource: currentResource,
                                open: !!currentResource,
                                onClose: function() {
                                    return setCurrentResource(null);
                                }
                            })
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
var VideoThumbnail = function(param) {
    var videoThumbnailUri = param.videoThumbnailUri, onClick = param.onClick, videoDuration = param.videoDuration;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            position: "absolute",
            justifyContent: "center",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url(".concat(videoThumbnailUri, ")"),
            backgroundSize: "cover",
            backgroundPosition: "center",
            cursor: "pointer",
            zIndex: 2
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "column",
                spacing: 1,
                sx: {
                    placeItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.AudioPlay, {
                    sx: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        zIndex: 2,
                        color: "primary",
                        bgcolor: "white",
                        borderRadius: "50%",
                        p: 1,
                        transform: "translate(-50%, -50%)",
                        fontSize: 64
                    }
                })
            }),
            videoDuration && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                sx: {
                    position: "absolute",
                    bottom: 8,
                    left: 8,
                    color: "white",
                    bgcolor: "rgba(0, 0, 0, 0.6)",
                    padding: "2px 4px",
                    borderRadius: 1
                },
                children: videoDuration
            })
        ]
    });
};
var PremiumOverlay = function(param) {
    var planId = param.planId, planTitle = param.planTitle, planInterval = param.planInterval;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPosts").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        sx: {
            position: "absolute",
            justifyContent: "center",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "black",
            filter: "opacity(0.72)",
            zIndex: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            spacing: 1,
            sx: {
                placeItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "white",
                    sx: {
                        textAlign: "center",
                        px: 5
                    },
                    children: planId && planTitle ? planInterval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? planTitle : t("isPremiumPlan", {
                        planTitle: planTitle
                    }) : t("isPremium")
                })
            ]
        })
    });
};
var NextArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Next, (0,src_object_spread/* default */.Z)({
        size: "large",
        sx: {
            bgcolor: "transparent",
            position: "absolute",
            top: "calc(50% - 15px)",
            right: 8,
            zIndex: 2,
            svg: {
                color: "white",
                fontSize: 64
            }
        }
    }, props));
};
var PrevArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Prev, (0,src_object_spread/* default */.Z)({
        size: "large",
        sx: {
            bgcolor: "transparent",
            position: "absolute",
            top: "calc(50% - 15px)",
            left: 8,
            zIndex: 2,
            svg: {
                color: "white",
                fontSize: 64
            }
        }
    }, props));
};
/**
 * ストーリー公開状態のタグ
 * @param publishedAt 公開開始日時
 * @returns ストーリー公開状態のタグ
 */ var StoryStatusTag = function(param) {
    var publishedAt = param.publishedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var ref = (0,react.useMemo)(function() {
        var now = dayjs_min_default()();
        var publishStart = dayjs_min_default()(publishedAt);
        var publishEnd = publishStart.add(24, "hour");
        // 公開前
        if (now.isBefore(publishStart)) {
            return {
                bgcolor: "info.light",
                color: "text.primary",
                text: t("beforePublished"),
                hasCaption: true
            };
        // 公開中
        } else if (now.isBefore(publishEnd)) {
            return {
                bgcolor: "primary.main",
                color: "white",
                text: t("duringPublished"),
                hasCaption: false
            };
        // 公開終了
        } else {
            return {
                bgcolor: "grey.100",
                color: "text.secondary",
                text: t("afterPublished"),
                hasCaption: false
            };
        }
    }, [
        publishedAt
    ]), bgcolor = ref.bgcolor, color = ref.color, text = ref.text, hasCaption = ref.hasCaption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        spacing: 2,
        sx: {
            pt: 5,
            px: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                size: "small",
                sx: {
                    height: 20,
                    borderRadius: "2px",
                    minWidth: 40,
                    bgcolor: bgcolor,
                    ".MuiChip-label": {
                        px: 1,
                        py: "2px"
                    }
                },
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    color: color,
                    variant: "overline",
                    component: "p",
                    children: text
                })
            }),
            hasCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: "info.main",
                children: t("storyScheduleMessage", {
                    date: dayjs_min_default()(publishedAt).format("YYYY年MM月DD日 HH:mm")
                })
            })
        ]
    });
};
// 24時間限定公開のタグの配置用共通スタイル
var Limited24hTagPositionStyle = {
    position: "absolute",
    top: "8px",
    left: "8px",
    zIndex: 3
};
/**
 * @description
 * 24時間限定公開のタグ
 */ var Limited24hTag = function(param) {
    var sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        spacing: 1,
        sx: (0,src_object_spread/* default */.Z)({
            px: 1,
            py: "2px",
            color: "white",
            borderRadius: 1,
            bgcolor: "like.tap",
            width: "74px"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.HourGlass, {
                sx: {
                    color: "white",
                    width: "16px",
                    height: "16px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "white",
                children: t("limited24h")
            })
        ]
    });
};
/**
 * avatar height = 60px
 * action button height = 56px
 * @param height
 * @param p
 */ function getMaxHeight(height, p) {
    //height of image, video, audio
    if (p.resourceType !== utoniq_core_schema/* PostType.Text */.hQF.Text) {
        height -= 160;
    }
    //height of schedule
    if (p.status === utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled) {
        height -= 32;
    }
    return height - 60 - 56;
}
function getLineCamp(p) {
    var lineCamp = p.resourceType === utoniq_core_schema/* PostType.Text */.hQF.Text ? 8 : 3;
    if (p.status === utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled) {
        lineCamp -= 1;
    }
    return lineCamp;
}

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/Thumbnaillmage.tsx



var Thumbnaillmage_ThumbnailImage = function(param) {
    var src = param.src, alt = param.alt, _withBorderRadius = param.withBorderRadius, withBorderRadius = _withBorderRadius === void 0 ? false : _withBorderRadius, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
        style: {
            width: width !== null && width !== void 0 ? width : "100%",
            height: height !== null && height !== void 0 ? height : "100%",
            borderRadius: withBorderRadius ? "8px" : "inherit",
            objectFit: "cover"
        },
        alt: alt,
        src: src
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/GalleryListItem.tsx










var GalleryListItem = function(param) {
    var post = param.post, user = param.user;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref10.routerPages, generatePath = ref10.generatePath;
    var ref11 = (0,react.useState)(false), open = ref11[0], setOpen = ref11[1];
    var isPersonalInfoRequired = (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) && post.isPremium && ((ref = post.artist.patron) === null || ref === void 0 ? void 0 : ref.isPersonalInformationRequired);
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var ref12, ref13;
    var imageUri = (ref13 = (ref12 = (ref1 = post.resources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) !== null && ref12 !== void 0 ? ref12 : (ref3 = post.resources) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.uri) !== null && ref13 !== void 0 ? ref13 : "";
    // ユーザーが加入しているメンバーシップよりも上位プランであるかどうか
    var isGraterPlan = !post.isAccessible && post.planId;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    // 24時間限定公開のタグの配置用共通スタイル
    var Limited24hTagPositionStyle = {
        position: "absolute",
        top: "8px",
        left: "8px",
        zIndex: 3
    };
    var ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            post.isAccessible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: !isPersonalInfoRequired ? generatePath(routerPages.PostDetail, {
                    postId: post.id
                }) : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        width: "99%",
                        height: "98%",
                        aspectRatio: "1/1",
                        position: "relative"
                    },
                    onClick: function() {
                        return isPersonalInfoRequired && showModal();
                    },
                    children: [
                        post.isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                            sx: Limited24hTagPositionStyle
                        }),
                        post.resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
                            src: imageUri,
                            style: {
                                width: "99%",
                                height: "98%",
                                objectFit: "cover",
                                borderRadius: "8px"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnaillmage_ThumbnailImage, {
                                    src: ((ref5 = post.videoThumbnail) === null || ref5 === void 0 ? void 0 : ref5.mediumUri) || "",
                                    alt: "thumbnail",
                                    withBorderRadius: true,
                                    width: "99%",
                                    height: "98%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.AudioPlay, {
                                    fontSize: "large",
                                    sx: {
                                        position: "absolute",
                                        top: "20%",
                                        left: "80%",
                                        transform: "translate(-50%, -50%)",
                                        color: "white"
                                    }
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "99%",
                    height: "98%",
                    aspectRatio: "1/1",
                    position: "relative"
                },
                onClick: function() {
                    return setOpen(true);
                },
                children: [
                    post.isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                        sx: Limited24hTagPositionStyle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnaillmage_ThumbnailImage, {
                        src: post.resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image ? ((ref6 = post.imageThumbnail) === null || ref6 === void 0 ? void 0 : ref6.blurUri) || "" : post.resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video ? ((ref7 = post.videoThumbnail) === null || ref7 === void 0 ? void 0 : ref7.blurUri) || "" : "",
                        alt: "membership_only",
                        withBorderRadius: true,
                        width: "99%",
                        height: "98%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                        fontSize: "xLarge",
                        sx: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: isGraterPlan ? t("viewMemberInfoTitleWithDiff") : t("viewMemberInfoTitle"),
                content: isGraterPlan ? t("viewMemberInfoDescWithDiff", {
                    planTitle: (ref14 = (ref8 = post.plan) === null || ref8 === void 0 ? void 0 : ref8.planTitle) !== null && ref14 !== void 0 ? ref14 : ""
                }) : t("viewMemberInfoDesc", {
                    displayName: post.artist.displayName
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    href: ((ref9 = post.artist) === null || ref9 === void 0 ? void 0 : ref9.id) ? generatePath(routerPages.ArtistMembership, {
                        artistId: post.artist.id
                    }) : undefined,
                    children: t("seeDetail")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/useGalleryList.ts



function useGalleryList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GalleryPosts(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter!\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      id\n      displayName\n      postCategory {\n        id\n        categories {\n          id\n          name\n          description\n          createdAt\n          updatedAt\n        }\n      }\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n        categoryId: $categoryId\n      ) {\n        ...GalleryPosts\n      }\n      currentLive {\n        id\n      }\n      totalUnreadMentionCount\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    useGalleryList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 *
 */ var useGalleryList = function(param) {
    var categoryId = param.categoryId;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var variables = {
        artistId: artistId,
        pageInput: {
            limit: 15
        },
        pageInputById: {
            limit: 15
        },
        resourceTypes: [
            utoniq_core_schema/* PostType.Image */.hQF.Image,
            utoniq_core_schema/* PostType.Video */.hQF.Video
        ],
        storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
        categoryId: categoryId
    };
    var ref6 = (0,useQuery/* useQuery */.aM)(GALLERY_POSTS, {
        variables: variables,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true
    }), data = ref6.data, fetchMore = ref6.fetchMore, networkStatus = ref6.networkStatus;
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.posts);
    var pageInfo = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.pageInfo;
    var fetchMorePosts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(pageInfo && pageInfo.hasNextPage)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMore({
                                variables: {
                                    artistId: artistId,
                                    // NOTE: utoniqPaginationのmerge処理に必要なため残す
                                    pageInput: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 15
                                    },
                                    pageInputById: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 15
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var nodes = (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.posts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.map(function(param) {
        var node = param.node;
        return node;
    })// NOTE YouTube動画は対象外とする
    .filter(function(node) {
        var ref;
        return ((ref = node.resource) === null || ref === void 0 ? void 0 : ref.uri) !== null;
    })) || [];
    return {
        state: {
            posts: nodes,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: fetchMorePosts
        }
    };
};
var GALLERY_POSTS = (0,lib/* gql */.Ps)(useGalleryList_templateObject(), utoniq_core_schema/* GalleryPostsFragmentDoc */.o$6, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/GalleryList.tsx






var GalleryList = function(param) {
    var categoryId = param.categoryId, user = param.user, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var ref = useGalleryList({
        categoryId: categoryId
    }), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            component: Grid2/* default */.Z,
            componentProps: {
                container: true,
                spacing: 0,
                padding: "0 3px"
            },
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: {
                size: responsive ? {
                    xs: 4,
                    md: 3
                } : {
                    xs: 4
                }
            },
            nodes: state.posts.map(function(post) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryListItem, {
                    post: post,
                    user: user
                }, post.id);
            }),
            onFetchMore: actions.onFetchMore,
            loading: state.refetching || state.loading,
            hasNextPage: state.hasNextPage,
            emptyMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyGalleryList, {}),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 1,
                sx: {
                    width: "100%"
                },
                children: Array.from(Array(30).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: responsive ? {
                            xs: 4,
                            md: 3
                        } : {
                            xs: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rounded",
                            sx: {
                                width: "100%",
                                paddingTop: "100%"
                            }
                        })
                    }, key);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/template/index.tsx












var ArtistGalleryTemplate = function(param) {
    var _state = param.state, categories = _state.categories, loading = _state.loading, artistName = _state.artistName, liveStreamId = _state.liveStreamId, user = _state.user;
    var ref = (0,core_i18n/* useTranslation */.$G)("artistGallery"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages, routerNames = ref1.routerNames, generatePath = ref1.generatePath;
    var ref2 = (0,react.useState)(0), currentTab = ref2[0], setCurrentTab = ref2[1];
    var handleTabChange = function(value) {
        setCurrentTab(value);
        router.replace(generatePath(routerPages.ArtistGalleryTabs, {
            artistId: router.query.artistId,
            tab: categories ? categories[value].id : ""
        }));
    };
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    (0,react.useEffect)(function() {
        var index = categories ? categories.findIndex(function(element) {
            return element.id === router.query.tab;
        }) : 0;
        setCurrentTab(index >= 0 ? index : 0);
    }, [
        categories,
        router.query.tab
    ]);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: config_config/* config.artistTabs.includes */.v.artistTabs.includes("home") ? {
                type: "artist",
                props: {
                    hasManagementTask: !!(user === null || user === void 0 ? void 0 : user.hasManagementTask),
                    unreadNotificationCount: user === null || user === void 0 ? void 0 : user.unreadNotificationCount,
                    isLive: !!liveStreamId
                },
                responsive: displayResponsive
            } : undefined,
            header: (0,src_object_spread/* default */.Z)({
                title: t("title"),
                back: true,
                defaultBackPage: generatePath(routerPages.ArtistTop, {
                    artistId: (ref3 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref3 !== void 0 ? ref3 : "#"
                })
            }, displayResponsive ? {
                responsive: true,
                maxWidth: 1120
            } : {}),
            maxWidth: displayResponsive ? 1120 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: i18n.exists("artistGallery:ogTitle") ? [
                        t("ogTitle"),
                        artistName
                    ] : [
                        routerNames.ArtistGallery,
                        artistName
                    ]
                }),
                categories ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                    labels: categories.map(function(category) {
                        return category.name;
                    }),
                    value: currentTab,
                    onChange: handleTabChange,
                    children: categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: "primary.main",
                                    sx: {
                                        marginLeft: "12px",
                                        marginBottom: "3%"
                                    },
                                    children: category.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryList, {
                                    categoryId: category.id,
                                    user: user,
                                    responsive: displayResponsive
                                }, category.id)
                            ]
                        });
                    })
                }) : // NOTE ローディングが完了した後、カテゴリーが存在しなければ投稿なしの表示をする
                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyGalleryList, {})
            ]
        })
    });
};
var SomethingCell = function() {
    return null;
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/viewModel.ts

function ArtistGallery_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GalleryCategory($artistId: ID!) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      postCategory {\n        id\n        categories {\n          id\n          name\n          description\n          createdAt\n          updatedAt\n        }\n      }\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistGallery_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ArtistGallery_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref5 = (0,useQuery/* useQuery */.aM)(GALLERY_CATEGORY, {
        variables: {
            artistId: artistId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref5.data, networkStatus = ref5.networkStatus, loading = ref5.loading;
    return {
        state: {
            categories: data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.postCategory) === null || ref1 === void 0 ? void 0 : ref1.categories,
            user: data === null || data === void 0 ? void 0 : data.user,
            loading: loading,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            artistName: (data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName) || "",
            liveStreamId: data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.currentLive) === null || ref4 === void 0 ? void 0 : ref4.id
        },
        actions: {}
    };
});
var GALLERY_CATEGORY = (0,lib/* gql */.Ps)(ArtistGallery_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/ArtistGallery/index.tsx




/**
 * ArtistGallery Page
 * Implemented as a practical sample.
 */ var ArtistGallery = function() {
    var ref = ArtistGallery_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistGalleryTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@capacitor/core/dist/index.js
var core_dist = __webpack_require__(23807);
// EXTERNAL MODULE: ../../node_modules/@mui/material/AppBar/AppBar.js
var AppBar = __webpack_require__(13961);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(26482);
// EXTERNAL MODULE: ./src/lib/image/index.ts
var lib_image = __webpack_require__(66419);
;// CONCATENATED MODULE: ./src/components/layouts/HeaderImageArea.tsx










var HeaderImageArea = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var imageUri = _param.imageUri, hasSafeArea = _param.hasSafeArea, bgImage = _param.bgImage, gradationMask = _param.gradationMask, children = _param.children, _responsive = _param.responsive, responsive = _responsive === void 0 ? false : _responsive, maxWidth = _param.maxWidth, imageProps = _param.imageProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "imageUri",
        "hasSafeArea",
        "bgImage",
        "gradationMask",
        "children",
        "responsive",
        "maxWidth",
        "imageProps"
    ]);
    var image = (0,lib_image/* useImage */.d)(imageUri || "");
    var bannerAspectRatio = !!(image === null || image === void 0 ? void 0 : image.naturalWidth) && !!(image === null || image === void 0 ? void 0 : image.naturalHeight) ? image.naturalHeight / image.naturalWidth : null;
    var _$ref = (0,react.useState)( true ? window.innerWidth : 0), windowWidth = _$ref[0], setWindowWidth = _$ref[1];
    (0,react.useEffect)(function() {
        if (!responsive) return function() {};
        var handleResize = function() {
            return setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    var displayWidth = (0,react.useMemo)(function() {
        if (!bannerAspectRatio || !maxWidth || !responsive) return null;
        var widthByMaxWidth = maxWidth !== null && maxWidth !== void 0 ? maxWidth : windowWidth;
        var widthByHeightLimit = bannerAspectRatio > 0 ? 768 / bannerAspectRatio : widthByMaxWidth;
        return Math.min(windowWidth, widthByMaxWidth, widthByHeightLimit);
    }, [
        bannerAspectRatio,
        maxWidth,
        windowWidth,
        responsive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        sx: (0,src_object_spread/* default */.Z)({
            height: styles/* styleSets.bgImageHeight */.k$.bgImageHeight(bannerAspectRatio, maxWidth, responsive),
            maxHeight: 768,
            pt: hasSafeArea ? styles/* styles.safeAreaTop */.W2.safeAreaTop : 0,
            position: "relative",
            zIndex: 0,
            overflow: "hidden"
        }, props === null || props === void 0 ? void 0 : props.sx),
        children: [
            !!imageUri && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    ref: ref,
                    sx: (0,src_object_spread/* default */.Z)({
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: -1,
                        backgroundImage: "url(".concat(imageUri, ")"),
                        backgroundSize: responsive ? "contain" : "cover",
                        backgroundRepeat: responsive ? "no-repeat" : undefined,
                        backgroundPosition: "center",
                        visibility: !!(image === null || image === void 0 ? void 0 : image.naturalWidth) && !!(image === null || image === void 0 ? void 0 : image.naturalHeight) ? "visible" : "hidden"
                    }, imageProps === null || imageProps === void 0 ? void 0 : imageProps.sx)
                })
            }),
            gradationMask && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                ref: ref,
                sx: {
                    pointerEvents: "none",
                    bgcolor: "background.default",
                    // レスポンシブの時は画像が画面外にはみ出るケースがあるのでマスクの高さはvhではなく%で計算する
                    // レスポンシブ非適用のサイトでは画像がはみ出ることがほぼあり得ないためvhでも問題なし、かつ%使用時の挙動が未確認のため
                    // レスポンシブ適用時のみを対象とする
                    height: responsive ? "100%" : "100vh",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "absolute",
                    zIndex: 1,
                    top: 0,
                    width: "100%",
                    // レスポンシブの時は画像が画面外にはみ出るケースがあるのでマスクの高さはvhではなく%で計算する
                    // レスポンシブ非適用のサイトでは画像がはみ出ることがほぼあり得ないためvhでも問題なし、かつ%使用時の挙動が未確認のため
                    // レスポンシブ適用時のみを対象とする
                    maskImage: function() {
                        var gradationStyle = function(width) {
                            return "linear-gradient(0deg, black calc(".concat(responsive ? "100%" : "100vh", " - ").concat(width, " * ").concat(bannerAspectRatio !== null && bannerAspectRatio !== void 0 ? bannerAspectRatio : 0, " + 24px), transparent calc(").concat(responsive ? "100%" : "100vh", " - ").concat(width, " * ").concat(bannerAspectRatio !== null && bannerAspectRatio !== void 0 ? bannerAspectRatio : 0, " + 140px))");
                        };
                        // レスポンシブの時は画像の大きさ・アスペクト比に関わらず常に一定のグラデーション幅になるよう画像横幅から計算する
                        return displayWidth ? gradationStyle("".concat(displayWidth, "px")) : {
                            xs: gradationStyle("100vw"),
                            sm: gradationStyle("600px")
                        };
                    },
                    backgroundImage: bgImage ? "url(".concat(bgImage, ")") : "none"
                }
            }),
            children
        ]
    }));
});

// EXTERNAL MODULE: ./src/components/organisms/membership/RequiredMembershipInfoBox/index.tsx
var RequiredMembershipInfoBox = __webpack_require__(53302);
// EXTERNAL MODULE: ../../node_modules/numeral/numeral.js
var numeral = __webpack_require__(1246);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/components/lib/BrowserLink/index.tsx
var BrowserLink = __webpack_require__(3405);
// EXTERNAL MODULE: ./src/core/entities/values/Date.ts
var values_Date = __webpack_require__(81822);
;// CONCATENATED MODULE: ./src/components/organisms/membership/ProductBox/index.tsx











var ProductBox = function(param) {
    var product = param.product, activeProduct = param.activeProduct, downgradeProduct = param.downgradeProduct, upgradeProduct = param.upgradeProduct, loading = param.loading, onClickButton = param.onClickButton, expiredAt = param.expiredAt, patronType = param.patronType, store = param.store, pendingPurchasePatron = param.pendingPurchasePatron, enableMembershipCarrierPayment = param.enableMembershipCarrierPayment;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    var ref;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((ref = pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : pendingPurchasePatron.voucherUrl) !== null && ref !== void 0 ? ref : "").onClick;
    var isActiveProduct = (0,react.useMemo)(function() {
        return (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId) === product.productId;
    }, [
        activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId,
        product.productId
    ]);
    var _interval;
    var plan = (0,react.useMemo)(function() {
        return product.plans.find(function(plan) {
            return plan.interval === ((_interval = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.interval) !== null && _interval !== void 0 ? _interval : utoniq_core_schema/* MembershipInterval.Month */.ls9.Month);
        });
    }, [
        activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.interval,
        product.plans
    ]);
    var ref1 = (0,react.useMemo)(function() {
        var ref, ref1;
        var monthlyPlan = product === null || product === void 0 ? void 0 : (ref = product.plans) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
            return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month && plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
        });
        var yearlyPlan = product === null || product === void 0 ? void 0 : (ref1 = product.plans) === null || ref1 === void 0 ? void 0 : ref1.find(function(plan) {
            return plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year && plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
        });
        return {
            monthlyPlan: monthlyPlan,
            yearlyPlan: yearlyPlan
        };
    }, [
        product === null || product === void 0 ? void 0 : product.plans
    ]), monthlyPlan = ref1.monthlyPlan, yearlyPlan = ref1.yearlyPlan;
    var lowestAmount = (0,react.useMemo)(function() {
        var _Math;
        var ref, ref1;
        var amounts = [
            (ref = monthlyPlan === null || monthlyPlan === void 0 ? void 0 : monthlyPlan.amount) !== null && ref !== void 0 ? ref : 0,
            ((ref1 = yearlyPlan === null || yearlyPlan === void 0 ? void 0 : yearlyPlan.amount) !== null && ref1 !== void 0 ? ref1 : 0) / 12, 
        ].filter(function(amount) {
            return amount > 0;
        });
        return (_Math = Math).min.apply(_Math, (0,src_to_consumable_array/* default */.Z)(amounts)) || 0;
    }, [
        monthlyPlan,
        yearlyPlan
    ]);
    /**
   * ボタンのテキスト表示と挙動
   */ var ref2 = (0,react.useMemo)(function() {
        switch(plan === null || plan === void 0 ? void 0 : plan.planRelationship){
            case "forLeave":
                return {
                    buttonText: t("cancelChange"),
                    disabled: false,
                    color: "inherit",
                    button: (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId) === (downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.productId)
                };
            /**
       * carrier_forLeave
       * キャリア決済のプラン切り替えで離脱予定の現在のプラン
       * アーティスト側でキャリア決済オプションが OFF になった場合
       * 解約申請はできるが、解約申請のキャンセルは行えない
       * ref. https://app.clickup.com/t/908127/UT-20671
       */ case "carrier_forLeave":
                return {
                    buttonText: t("cancelChange"),
                    disabled: !enableMembershipCarrierPayment,
                    color: "inherit",
                    button: (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId) === (downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.productId)
                };
            case "forJoinedUpper":
            case "forJoinedLower":
                return {
                    buttonText: t("cancelChange"),
                    disabled: false,
                    color: "inherit",
                    button: true
                };
            /**
       * carrier_forJoinedUpper
       * キャリア決済のプラン切り替えで加入予定の今より上位のプラン
       * アーティスト側でキャリア決済オプションが OFF になった場合
       * アップグレード申請中のアップグレード申請キャンセルは行えない
       * ref. https://app.clickup.com/t/908127/UT-20671
       *
       * carrier_forJoinedLower
       * キャリア決済のプラン切り替えで加入予定の今より下位のプラン
       * アーティスト側でキャリア決済オプションが OFF になった場合
       * ダウングレード申請中のダウングレード申請キャンセルは行えない
       * ref. https://app.clickup.com/t/908127/UT-20671
       */ case "carrier_forJoinedUpper":
            case "carrier_forJoinedLower":
                return {
                    buttonText: t("cancelChange"),
                    disabled: !enableMembershipCarrierPayment,
                    color: "inherit",
                    button: true
                };
            case "stopping":
            case "joined":
            case "konbini_joined":
            case "konbini_waitingPayment":
                return {
                    button: false
                };
            case "notDowngradingUpper":
            case "carrier_notUpgradingUpper":
            case "konbini_notDowngradingUpper":
            case "stoppingUpper":
                return {
                    buttonText: t("upgrade"),
                    disabled: true,
                    color: "primary",
                    button: true
                };
            case "upper":
            case "konbini_upper":
                return {
                    buttonText: t("upgrade"),
                    disabled: false,
                    color: "primary",
                    button: true
                };
            /**
       * carrier_upper
       * キャリア決済で加入中の現在のプランより上位のプラン
       * アーティスト側でキャリア決済オプションが OFF になった場合
       * 新規でのアップグレード申請は行えない
       * ref. https://app.clickup.com/t/908127/UT-20671
       */ case "carrier_upper":
                return {
                    buttonText: t("upgrade"),
                    disabled: !enableMembershipCarrierPayment,
                    color: "primary",
                    button: true
                };
            case "notDowngradingLower":
            case "konbini_notDowngradingLower":
            case "carrier_notUpgradingLower":
            case "stoppingLower":
                return {
                    buttonText: t("downgrade"),
                    disabled: true,
                    color: "primary",
                    button: true
                };
            case "lower":
            case "konbini_lower":
                return {
                    buttonText: t("downgrade"),
                    disabled: false,
                    color: "primary",
                    button: true
                };
            /**
       * carrier_lower
       * キャリア決済で加入中の現在のプランより下位のプラン
       * アーティスト側でキャリア決済オプションが OFF になった場合
       * 新規でのダウングレード申請は行えない
       * ref. https://app.clickup.com/t/908127/UT-20671
       */ case "carrier_lower":
                return {
                    buttonText: t("downgrade"),
                    disabled: !enableMembershipCarrierPayment,
                    color: "primary",
                    button: true
                };
            default:
                return {
                    buttonText: t("selectPlan"),
                    disabled: false,
                    color: "primary",
                    button: true
                };
        }
    }, [
        activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId,
        downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.productId,
        plan === null || plan === void 0 ? void 0 : plan.planRelationship,
        t, 
    ]), buttonText = ref2.buttonText, disabled = ref2.disabled, color = ref2.color, button = ref2.button;
    var textNote = (0,react.useMemo)(function() {
        switch(plan === null || plan === void 0 ? void 0 : plan.planRelationship){
            case "forLeave":
                if ((downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.productId) === product.productId) {
                    return t("changeNextPlanNote", {
                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt)
                    });
                }
                if ((downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.plan.amount) && (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount) && (downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.plan.amount) > (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount)) {
                    return t("forLeaveUpgradeNote", {
                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt),
                        title: downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title
                    });
                }
                if ((downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.plan.amount) && (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount) && (downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.plan.amount) < (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount)) {
                    return t("forLeaveDowngradeNote", {
                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt),
                        title: downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title
                    });
                }
                return null;
            // キャリア決済を行なっている離脱予定の現在のプラン
            case "carrier_forLeave":
                // アップグレード予定の場合
                if (upgradeProduct) return t("carrierForLeaveNote", {
                    expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt),
                    title: upgradeProduct === null || upgradeProduct === void 0 ? void 0 : upgradeProduct.title
                });
                // ダウングレード予定の場合
                if (downgradeProduct) return t("carrierForLeaveNote", {
                    expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt),
                    title: downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title
                });
                return null;
            /**
       * carrier_notUpgradingLower
       * キャリア決済のアップグレードで加入予定でない今より下位のプラン
       * 中位プランから最上位プランにアップグレードする際の最下位プランが該当する
       */ case "notDowngradingLower":
            case "carrier_notUpgradingLower":
            case "stoppingLower":
            case "konbini_notDowngradingLower":
                return t("notDowngradePlanNote");
            /**
       * carrier_notUpgradingUpper
       * キャリア決済のアップグレードで加入予定でない今より上位のプラン
       * 最下位プランから中位プランにアップグレードする際の最上位プランが該当する
       */ case "notDowngradingUpper":
            case "stoppingUpper":
            case "carrier_notUpgradingUpper":
            case "konbini_notDowngradingUpper":
                return t("notUpgradePlanNote");
            case "forJoinedLower":
            case "carrier_forJoinedLower":
                return t("changeDowngradeNextPlanNote", {
                    expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt)
                });
            /**
       * carrier_forJoinedUpper
       * キャリア決済のプラン切り替えで加入予定の今より上位のプラン
       */ case "forJoinedUpper":
            case "carrier_forJoinedUpper":
                return t("changeUpgradeNextPlanNote", {
                    expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt)
                });
            case "konbini_waitingPayment":
                return t("konbiniJoinedNote");
            default:
                return null;
        }
    }, [
        activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount,
        downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.plan.amount,
        downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.productId,
        downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title,
        expiredAt,
        plan === null || plan === void 0 ? void 0 : plan.planRelationship,
        product.productId,
        t, 
    ]);
    if (!plan) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2,
                bgcolor: "grey.100"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        sx: {
                            pb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: product.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: isActiveProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    children: t("".concat(activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.interval, "Fee"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: t("amount", {
                                                        amount: activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.formattedAmount
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: yearlyPlan && monthlyPlan ? t("yearlyPlanNote", {
                                                amountPerYear: yearlyPlan === null || yearlyPlan === void 0 ? void 0 : yearlyPlan.formattedAmount,
                                                amountPerMonth: monthlyPlan === null || monthlyPlan === void 0 ? void 0 : monthlyPlan.formattedAmount
                                            }) : monthlyPlan ? t("monthlyAmount", {
                                                amount: numeral_default()(lowestAmount).format("0,0")
                                            }) : t("yearlyAmount", {
                                                amount: numeral_default()(lowestAmount).format("0,0")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanLabel, {
                                        planRelationship: plan.planRelationship || "unjoined",
                                        interval: plan === null || plan === void 0 ? void 0 : plan.interval
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        sx: {
                            borderColor: "grey.200"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 5,
                        sx: {
                            py: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: product.content
                            }),
                            !!product.annualContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        fontWeight: 600,
                                        children: t("annualContentTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: product.annualContent
                                    })
                                ]
                            })
                        ]
                    }),
                    (button || textNote) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        sx: {
                            borderColor: "grey.200"
                        }
                    }),
                    !!textNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        children: textNote
                    }),
                    button && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignItems: "center",
                        sx: {
                            pt: 5
                        },
                        children: [
                            (!patronType || patronType === "stripe" || patronType === "escott") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                color: color,
                                sx: {
                                    width: 240,
                                    bgcolor: color === "inherit" ? "grey.50" : undefined,
                                    "&.Mui-disabled": {
                                        bgcolor: "grey.50"
                                    }
                                },
                                loading: loading,
                                disabled: disabled,
                                onClick: function(event) {
                                    return plan && onClickButton(event, plan);
                                },
                                children: buttonText
                            }),
                            store === "app_store" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("cancelAtIOS")
                            }),
                            store === "play_store" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("cancelAtAndroid")
                            })
                        ]
                    }),
                    plan.planRelationship === "konbini_waitingPayment" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        pt: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("paymentDeadlineKonbini")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : pendingPurchasePatron.formattedExpiredAt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                onClick: onClick,
                                children: t("confirmPayment")
                            })
                        ]
                    }),
                    plan.planRelationship === "stopping" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                sx: {
                                    borderColor: "grey.200"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                sx: {
                                    pt: 5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "error.main",
                                    children: t("cancelSubscriptionNote", {
                                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(expiredAt)
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var UnregisteredInfoLabel = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "white",
            display: "block",
            children: t("unregisteredInfo")
        }),
        sx: {
            height: 16,
            bgcolor: "error.main",
            borderRadius: "2px",
            padding: "2px 4px",
            ".MuiChip-label": {
                px: 0
            }
        }
    });
};
var PlanLabel = function(param) {
    var interval = param.interval, planRelationship = param.planRelationship;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    var ref = (0,react.useMemo)(function() {
        switch(planRelationship){
            // ダウングレード先 翌月から入会
            case "forJoinedLower":
            case "forJoinedUpper":
            case "carrier_forJoinedUpper":
            case "carrier_forJoinedLower":
                return {
                    label: t("".concat(interval || "", "JoinPlanLabel")),
                    bgcolor: "grey.200",
                    color: "text.secondary"
                };
            // ダウングレード元 期間まで入会中扱い
            case "forLeave":
            case "carrier_forLeave":
            case "joined":
            case "stopping":
            case "konbini_waitingPayment":
            case "konbini_joined":
                return {
                    label: t("".concat(interval || "", "Joining")),
                    bgcolor: "primary.main",
                    color: "white"
                };
            // ダウングレード時のその他のプラン
            case "notDowngradingUpper":
            case "notDowngradingLower":
            case "upper":
            case "lower":
            case "konbini_upper":
            case "konbini_lower":
            case "unjoined":
            default:
                return {
                    label: t("non-member"),
                    bgcolor: "grey.50",
                    color: "text.hint"
                };
        }
    }, [
        planRelationship,
        t
    ]), label = ref.label, bgcolor = ref.bgcolor, color = ref.color;
    if (!planRelationship) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: color,
            display: "block",
            children: label
        }),
        sx: {
            height: 16,
            bgcolor: bgcolor,
            borderRadius: "2px",
            padding: "2px 4px",
            ".MuiChip-label": {
                px: 0
            }
        }
    });
};

// EXTERNAL MODULE: ./src/core/native/storage/index.ts
var storage = __webpack_require__(57782);
;// CONCATENATED MODULE: ./src/components/organisms/functionals/PaymentErrorModal/index.tsx







var PaymentErrorBaseModal = function(param) {
    var open = param.open, title = param.title, content = param.content, actionText = param.actionText, cancelText = param.cancelText, onClose = param.onClose;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                    fontSize: "large",
                    sx: {
                        color: "error.main"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        pb: 3
                    },
                    children: title
                })
            ]
        }),
        content: content,
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
            size: "large",
            sx: {
                width: 212
            },
            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* setRedirectAfterCreditCardRegisterPath */.qD)(router.pathname)
                            ];
                        case 1:
                            _state.sent();
                            router.push("".concat(routerPages.PaymentDetail, "?reRegister=true"));
                            return [
                                2
                            ];
                    }
                });
            }),
            children: actionText
        }),
        cancelText: cancelText
    });
};
var PaymentErrorModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentError").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorBaseModal, {
        open: open,
        title: t("paymentErrorTitle"),
        content: t("paymentErrorDesc"),
        actionText: t("updatePaymentMethod"),
        cancelText: t("cancel"),
        onClose: onClose
    });
};
var ExpiredCardModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentError").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorBaseModal, {
        open: open,
        title: t("expiredCardTitle"),
        content: t("expiredCardDesc"),
        actionText: t("updatePaymentMethod"),
        cancelText: t("cancel"),
        onClose: onClose
    });
};
var Require3DSecureModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentError").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorBaseModal, {
        open: open,
        title: t("require3DSecureTitle"),
        content: t("require3DSecureDesc"),
        actionText: t("reRegisterCard"),
        cancelText: t("cancel"),
        onClose: onClose
    });
};

// EXTERNAL MODULE: ./src/lib/helpUrl/index.tsx
var helpUrl = __webpack_require__(16);
;// CONCATENATED MODULE: ./src/components/organisms/legalInformation/index.tsx







/**
 * 法的情報へのリンクを表示するセルコンポーネント
 *
 * @description
 * - 特定商取引法に基づく表記へのリンク
 * - 決済方法に関する説明へのリンク
 * - 購入キャンセルに関する注意書き
 * を表示
 *
 * @example
 * ```tsx
 * <LegalInformationLinksCell sx={{ mt: 2 }} />
 * ```
 */ var LegalInformationLinksCell = function(param) {
    var sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: (0,src_object_spread/* default */.Z)({
            pb: 4
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 4,
                    "&:last-child": {
                        pb: 4
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCautionText, {
                            variant: "caption"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WageSettlementMethodLink, {
                                    variant: "subtitle1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificCommercialTransactionLawLink, {
                                    variant: "subtitle1"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/**
 * 購入後のキャンセルに関する注意書きを表示するコンポーネント
 *
 * @description
 * 購入後のキャンセルができない旨をユーザーに通知
 *
 * @param props.variant - テキストのタイポグラフィバリアント（デフォルト: 'caption'）
 * @param props.sx - カスタムスタイル
 *
 * @example
 * ```tsx
 * <PurchaseCautionText variant="body2" sx={{ mt: 2 }} />
 * ```
 */ var PurchaseCautionText = function(param) {
    var sx = param.sx, _variant = param.variant, variant = _variant === void 0 ? "caption" : _variant;
    var t = (0,dist_es/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        variant: variant,
        color: "text.secondary",
        sx: sx,
        children: t("cancelPurchaseNote")
    });
};
/**
 * 決済方法に関する説明へのリンクを表示するコンポーネント
 *
 * @description
 * 決済方法の詳細な説明が記載されているヘルプページへのリンクを提供
 *
 * @param props.variant - リンクのタイポグラフィバリアント（デフォルト: 'subtitle1'）
 * @param props.sx - カスタムスタイル
 *
 * @example
 * ```tsx
 * <WageSettlementMethodLink variant="body1" sx={{ textDecoration: 'underline' }} />
 * ```
 */ var WageSettlementMethodLink = function(param) {
    var sx = param.sx, _variant = param.variant, variant = _variant === void 0 ? "subtitle1" : _variant;
    var t = (0,dist_es/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
        variant: variant,
        href: (0,helpUrl/* getHelpUrl */.R)("wageSettlementMethod"),
        sx: sx,
        children: t("wageSettlementMethod")
    });
};
/**
 * 特定商取引法に基づく表記へのリンクを表示するコンポーネント
 *
 * @description
 * 特定商取引法に基づく表記が記載されているページへのリンクを提供
 *
 * @param props.variant - リンクのタイポグラフィバリアント（デフォルト: 'subtitle1'）
 * @param props.sx - カスタムスタイル
 *
 * @example
 * ```tsx
 * <SpecificCommercialTransactionLawLink variant="body1" sx={{ color: 'primary.main' }} />
 * ```
 */ var SpecificCommercialTransactionLawLink = function(param) {
    var sx = param.sx, _variant = param.variant, variant = _variant === void 0 ? "subtitle1" : _variant;
    var t = (0,dist_es/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
        variant: variant,
        href: (0,helpUrl/* getHelpUrl */.R)("specifiedCommercialTransactionLaw"),
        sx: sx,
        children: t("specifiedCommercialTransactionLaw")
    });
};

// EXTERNAL MODULE: ./src/core/errors/index.ts + 3 modules
var core_errors = __webpack_require__(83342);
// EXTERNAL MODULE: ./src/lib/escott/index.ts
var escott = __webpack_require__(13770);
;// CONCATENATED MODULE: ./src/components/pages/ArtistMembership/template/index.tsx


























var ArtistMembershipTemplate = function(param) {
    var state = param.state, onSubscribePlan = param.onSubscribePlan, onDowngradePlan = param.onDowngradePlan, onUpgradePlan = param.onUpgradePlan, onPreviewSubscriptionUpdate = param.onPreviewSubscriptionUpdate, onStopSubscription = param.onStopSubscription, onCancelChangePlan = param.onCancelChangePlan, onClearSelectFavoriteMember = param.onClearSelectFavoriteMember;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), router = ref8.router, routerNames = ref8.routerNames, generatePath = ref8.generatePath, routerPages = ref8.routerPages;
    var ref9;
    var defaultBackPage = generatePath(routerPages.ArtistTop, {
        artistId: (ref9 = (ref = state.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref9 !== void 0 ? ref9 : "#"
    });
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref10 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref10.showMessage, showError = ref10.showError;
    var ref11 = (0,react.useState)(), currentSelectPlan = ref11[0], setCurrentSelectPlan = ref11[1];
    var ref12 = (0,react.useState)(false), openConfirm = ref12[0], setOpenConfirm = ref12[1];
    var ref13 = (0,react.useState)(false), openDowngradeConfirm = ref13[0], setOpenDowngradeConfirm = ref13[1];
    var ref14 = (0,react.useState)(false), openUpgradeConfirm = ref14[0], setOpenUpgradeConfirm = ref14[1];
    var ref15 = (0,react.useState)(false), openStopConfirm = ref15[0], setOpenStopConfirm = ref15[1];
    var ref16 = (0,react.useState)(false), openCancelChangePlanConfirm = ref16[0], setOpenCancelChangePlanConfirm = ref16[1];
    var ref17 = (0,react.useState)(false), openCarrierUpgradeConfirm = ref17[0], setOpenCarrierUpgradeConfirm = ref17[1];
    var ref18 = (0,react.useState)(false), openKonbiniUpgradeConfirm = ref18[0], setOpenKonbiniUpgradeConfirm = ref18[1];
    var ref19 = (0,react.useState)(false), openExpiredCardModal = ref19[0], setOpenExpiredCardModal = ref19[1];
    var ref20 = (0,react.useState)(false), openPaymentErrorModal = ref20[0], setOpenPaymentErrorModal = ref20[1];
    var ref21 = (0,react.useState)(false), openRequire3DSecureModal = ref21[0], setOpenRequire3DSecureModal = ref21[1];
    var handleSubscribePlan = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId)) return [
                        2
                    ];
                    return [
                        4,
                        onSubscribePlan(currentSelectPlan.planId).then(function() {
                            return showMessage(t("completeSubscribe"));
                        }).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "ArtistMembership");
                            showError(e);
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpenConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId,
        onSubscribePlan,
        showError,
        showMessage,
        t
    ]);
    var handleDowngradePlan = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId) || !state.paymentMethod) return [
                        2
                    ];
                    return [
                        4,
                        onDowngradePlan(currentSelectPlan.planId, state.paymentMethod, {
                            // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                            successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=downgrade"),
                            // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                            cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=downgrade"),
                            // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                            errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=downgrade")
                        }).then(function() {
                            // キャリア決済の場合は外部キャリア決済画面にて
                            // 追加手続きが必要なためトーストメッセージを表示しない
                            if (!!state.paymentMethod && (0,escott/* isCarrierPaymentMethod */.ln)(state.paymentMethod)) return;
                            showMessage(t("completeDowngradeSubscribe"));
                        }).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "ArtistMembership");
                            showError(e);
                        })
                    ];
                case 1:
                    _state.sent();
                    // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                    // 画面内で操作が行われてしまうことを防ぐため
                    // キャリア決済の場合はモーダルを閉じない
                    if (!(0,escott/* isCarrierPaymentMethod */.ln)(state.paymentMethod)) setOpenDowngradeConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId,
        state.paymentMethod,
        router.query.artistId,
        onDowngradePlan,
        showError,
        showMessage,
        t, 
    ]);
    var handleUpgradePlan = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId)) return [
                        2
                    ];
                    return [
                        4,
                        onUpgradePlan(currentSelectPlan.planId).then(function() {
                            return showMessage(t("completeUpgradeSubscribe"));
                        }).catch(function(e) {
                            var ref, ref1, ref2;
                            (0,core_errors/* captureError */.O)(e, "ArtistMembership");
                            switch((ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                /**
           * @description
           * 3Dセキュア認証が必要な場合
           */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                    setOpenRequire3DSecureModal(true);
                                    break;
                                /**
           * @description
           * カードが有効期限切れの場合
           */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                    setOpenExpiredCardModal(true);
                                    break;
                                /**
           * @description
           * 何かしらの決済エラーの場合
           */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                    setOpenPaymentErrorModal(true);
                                    break;
                                default:
                                    showError(e);
                                    break;
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpenUpgradeConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId,
        onUpgradePlan,
        showError,
        showMessage,
        t
    ]);
    var handleStopSubscription = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onStopSubscription().then(function() {
                            return showMessage(t("completeStopSubscribe"));
                        }).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "ArtistMembership");
                            showError(new Error(t("error")));
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpenStopConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onStopSubscription,
        showError,
        showMessage,
        t
    ]);
    var handleCancelChangePlan = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!state.paymentMethod) return [
                        2
                    ];
                    return [
                        4,
                        onCancelChangePlan(state.paymentMethod, {
                            // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                            successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=changePlanCancel"),
                            // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                            cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=changePlanCancel"),
                            // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                            errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=changePlanCancel")
                        }).then(function() {
                            // キャリア決済の場合は外部キャリア決済画面にて
                            // 追加手続きが必要なためトーストメッセージを表示しない
                            if (!!state.paymentMethod && (0,escott/* isCarrierPaymentMethod */.ln)(state.paymentMethod)) return;
                            showMessage(t("completeCancelChangePlanSubscribe"));
                        }).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "ArtistMembership");
                            showError(new Error(t("error")));
                        })
                    ];
                case 1:
                    _state.sent();
                    // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                    // 画面内で操作が行われてしまうことを防ぐため
                    // キャリア決済の場合はモーダルを閉じない
                    if (!state.paymentMethod || !(0,escott/* isCarrierPaymentMethod */.ln)(state.paymentMethod)) setOpenCancelChangePlanConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onCancelChangePlan,
        state.paymentMethod,
        router.query.artistId,
        showError,
        showMessage,
        t, 
    ]);
    var handleCarrierUpgradePlan = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId) || !state.paymentMethod) return [
                        2
                    ];
                    return [
                        4,
                        onUpgradePlan(currentSelectPlan.planId, state.paymentMethod, {
                            // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                            successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=upgrade"),
                            // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                            cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=upgrade"),
                            // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                            errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembership, {
                                artistId: router.query.artistId
                            }), "?process=upgrade")
                        }).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "CarrierUpgradePlan");
                            showError(new Error(t("error")));
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId,
        state.paymentMethod,
        router.query.artistId,
        onUpgradePlan,
        showError,
        showMessage,
        t, 
    ]);
    var isNative = core_dist/* Capacitor.isNativePlatform */.dV.isNativePlatform();
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    // プランのアップグレード実行時
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        // プランのアップグレード実行時以外は何もしない
        if (router.query.process !== "upgrade") return;
        switch(router.query.status){
            case "success":
                showMessage(t("carrierUpgradeSuccess"));
                break;
            case "cancel":
                showMessage(t("carrierUpgradeCancel"));
                break;
            case "error":
                showError(t("carrierUpgradeError"));
                break;
            default:
                break;
        }
    }, [
        router.query.process,
        router.query.status
    ]);
    // プランのダウングレード実行時
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        // プランのダウングレード実行時以外は何もしない
        if (router.query.process !== "downgrade") return;
        switch(router.query.status){
            case "success":
                showMessage(t("completeDowngradeSubscribe"));
                break;
            case "cancel":
                showMessage(t("cancelDowngradeSubscribe"));
                break;
            case "error":
                showError(t("error"));
                break;
            default:
                break;
        }
    }, [
        router.query.process,
        router.query.status
    ]);
    // プラン変更キャンセル実行時
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        // プラン変更キャンセル実行時以外は何もしない
        if (router.query.process !== "changePlanCancel") return;
        switch(router.query.status){
            case "success":
                showMessage(t("completeCancelChangePlanSubscribe"));
                break;
            case "cancel":
                showMessage(t("cancelChangePlanSubscribe"));
                break;
            case "error":
                showError(t("error"));
                break;
            default:
                break;
        }
    }, [
        router.query.process,
        router.query.status
    ]);
    var ref22, ref23, ref24, ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: [
                    routerNames.ArtistMembership,
                    (ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                safeArea: {
                    pt: 0
                },
                maxWidth: displayResponsive ? 1120 : undefined,
                children: [
                    state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMemberLoadingCell, {
                        onClose: function() {
                            return router.goBack(defaultBackPage);
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, displayResponsive ? {
                        width: "100%",
                        alignItems: "center"
                    } : {}), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCell, {
                                artist: state.artist,
                                onClose: function() {
                                    return router.goBack(defaultBackPage);
                                },
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: (0,src_object_spread/* default */.Z)({
                                    mt: state.appName ? "-48px" : "-60px",
                                    px: 5,
                                    position: "relative",
                                    zIndex: 1
                                }, displayResponsive ? {
                                    maxWidth: 600,
                                    mx: "auto"
                                } : {}),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            py: 3
                                        },
                                        align: "center",
                                        children: config_config/* config.applicationKey */.v.applicationKey === "rocomacoaco" ? config_config/* config.appName */.v.appName : (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body1",
                                        children: t("memberDesc", {
                                            displayName: (ref22 = (ref3 = state.artist) === null || ref3 === void 0 ? void 0 : ref3.displayName) !== null && ref22 !== void 0 ? ref22 : ""
                                        })
                                    })
                                ]
                            }),
                            state.isPersonalInformationRequired && state.isMembershipPersonalInformationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                px: 5,
                                pt: 5,
                                pb: 1
                            }, displayResponsive ? {
                                maxWidth: 600,
                                mx: "auto"
                            } : {}), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredMembershipInfoBox/* RequiredMembershipInfoBox */.k, {
                                    visibleLink: true
                                })
                            })),
                            !state.appName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                sx: {
                                    px: 5
                                }
                            }, displayResponsive ? {
                                maxWidth: 600,
                                mx: "auto"
                            } : {}), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    spacing: 5,
                                    sx: {
                                        pt: 4,
                                        pb: 6
                                    },
                                    children: (ref4 = state.products) === null || ref4 === void 0 ? void 0 : ref4.filter(function(product) {
                                        // interval: month のプランが存在し、かつそれがactiveでない場合は除外
                                        // yearプランのみの場合は表示しない
                                        var monthPlan = product.plans.find(function(plan) {
                                            return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month;
                                        });
                                        if (monthPlan && monthPlan.status !== utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active) {
                                            return false;
                                        }
                                        return true;
                                    }).filter(function(product) {
                                        return product.plans.length > 0;
                                    }).map(function(product) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductBox, {
                                            product: product,
                                            expiredAt: state.expiredAtSubscription,
                                            activeProduct: state.activeProduct,
                                            downgradeProduct: state.downgradeProduct,
                                            loading: product.plans.some(function(plan) {
                                                return (currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId) === plan.planId;
                                            }) && state.fetchingDiffAmountSubscription,
                                            pendingPurchasePatron: state.pendingPurchasePatron,
                                            // プランごとに表示されるボタンを押したときの挙動
                                            onClickButton: function(event, plan) {
                                                handleLoginModal(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                    var _, ref, ref1, _productId, ref2, ref3, ref4, ref5, ref6, ref7;
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                // テンプレートの状態に「現在選択しているプラン」をセット
                                                                setCurrentSelectPlan(plan);
                                                                // 選択済み推しメンバー情報を削除する
                                                                onClearSelectFavoriteMember();
                                                                /**
                             * ネイティブの場合は複数プランが作れないので、サブスク購入モーダルを開いてreturn
                             */ if (isNative) {
                                                                    setOpenConfirm(true);
                                                                    return [
                                                                        2
                                                                    ];
                                                                }
                                                                _ = plan === null || plan === void 0 ? void 0 : plan.planRelationship;
                                                                switch(_){
                                                                    case "forLeave":
                                                                        return [
                                                                            3,
                                                                            1
                                                                        ];
                                                                    case "forJoinedUpper":
                                                                        return [
                                                                            3,
                                                                            1
                                                                        ];
                                                                    case "forJoinedLower":
                                                                        return [
                                                                            3,
                                                                            1
                                                                        ];
                                                                    case "carrier_forJoinedLower":
                                                                        return [
                                                                            3,
                                                                            1
                                                                        ];
                                                                    case "carrier_forJoinedUpper":
                                                                        return [
                                                                            3,
                                                                            2
                                                                        ];
                                                                    case "lower":
                                                                        return [
                                                                            3,
                                                                            3
                                                                        ];
                                                                    case "carrier_lower":
                                                                        return [
                                                                            3,
                                                                            4
                                                                        ];
                                                                    case "upper":
                                                                        return [
                                                                            3,
                                                                            5
                                                                        ];
                                                                    case "carrier_upper":
                                                                        return [
                                                                            3,
                                                                            7
                                                                        ];
                                                                    case "konbini_upper":
                                                                        return [
                                                                            3,
                                                                            8
                                                                        ];
                                                                    case "konbini_lower":
                                                                        return [
                                                                            3,
                                                                            9
                                                                        ];
                                                                    case "joined":
                                                                        return [
                                                                            3,
                                                                            10
                                                                        ];
                                                                    case "unjoined":
                                                                        return [
                                                                            3,
                                                                            11
                                                                        ];
                                                                }
                                                                return [
                                                                    3,
                                                                    12
                                                                ];
                                                            case 1:
                                                                return [
                                                                    2,
                                                                    setOpenCancelChangePlanConfirm(true)
                                                                ];
                                                            case 2:
                                                                return [
                                                                    2,
                                                                    setOpenCancelChangePlanConfirm(true)
                                                                ];
                                                            case 3:
                                                                return [
                                                                    2,
                                                                    setOpenDowngradeConfirm(true)
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2,
                                                                    setOpenDowngradeConfirm(true)
                                                                ];
                                                            case 5:
                                                                return [
                                                                    4,
                                                                    onPreviewSubscriptionUpdate(plan.planId)
                                                                ];
                                                            case 6:
                                                                _state.sent();
                                                                return [
                                                                    2,
                                                                    setOpenUpgradeConfirm(true)
                                                                ];
                                                            case 7:
                                                                return [
                                                                    2,
                                                                    setOpenCarrierUpgradeConfirm(true)
                                                                ];
                                                            case 8:
                                                                return [
                                                                    2,
                                                                    setOpenKonbiniUpgradeConfirm(true)
                                                                ];
                                                            case 9:
                                                                return [
                                                                    2,
                                                                    router.push(generatePath(routerPages.ArtistMembershipPaymentEdit, {
                                                                        artistId: (ref1 = (ref = state.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "#",
                                                                        productId: (_productId = product.productId) !== null && _productId !== void 0 ? _productId : "#"
                                                                    }))
                                                                ];
                                                            case 10:
                                                                return [
                                                                    2,
                                                                    setOpenStopConfirm(true)
                                                                ];
                                                            case 11:
                                                                if (state.selectFavoriteMemberRequired) {
                                                                    ;
                                                                    return [
                                                                        2,
                                                                        router.push(generatePath(routerPages.ArtistMembershipFavoriteMembersSelect, {
                                                                            artistId: (ref4 = state.artist) === null || ref4 === void 0 ? void 0 : ref4.id,
                                                                            productId: (ref5 = product.productId) === null || ref5 === void 0 ? void 0 : ref5.toString()
                                                                        }))
                                                                    ];
                                                                }
                                                                return [
                                                                    2,
                                                                    router.push(generatePath(routerPages.ArtistMembershipPurchaseProceed, {
                                                                        artistId: (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : ref2.id,
                                                                        productId: (ref3 = product.productId) === null || ref3 === void 0 ? void 0 : ref3.toString()
                                                                    }))
                                                                ];
                                                            case 12:
                                                                return [
                                                                    2,
                                                                    router.push(generatePath(routerPages.ArtistMembershipPurchaseProceed, {
                                                                        artistId: (ref6 = state.artist) === null || ref6 === void 0 ? void 0 : ref6.id,
                                                                        productId: (ref7 = product.productId) === null || ref7 === void 0 ? void 0 : ref7.toString()
                                                                    }))
                                                                ];
                                                            case 13:
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }))(event);
                                            },
                                            patronType: state.patronType,
                                            store: state.store,
                                            enableMembershipCarrierPayment: state.enableMembershipCarrierPayment
                                        }, product.productId);
                                    })
                                })
                            })),
                            !!state.appName && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebInductionCell, {
                                    appName: state.appName
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {
                                sx: {
                                    px: 5,
                                    maxWidth: 600,
                                    mx: "auto"
                                }
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openConfirm,
                        onClose: function() {
                            return setOpenConfirm(false);
                        },
                        title: t("confirm"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("confirmContent", {
                                        price: (ref23 = currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.amount) !== null && ref23 !== void 0 ? ref23 : 0
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        py: 6,
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCautionText, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WageSettlementMethodLink, {
                                            variant: "caption"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificCommercialTransactionLawLink, {
                                            variant: "caption"
                                        })
                                    ]
                                })
                            ]
                        }),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleSubscribePlan,
                            loading: state.subscribing,
                            children: t("becomeMember")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openDowngradeConfirm,
                        onClose: function() {
                            return setOpenDowngradeConfirm(false);
                        },
                        title: t("downgradeConfirm"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            sx: {
                                pb: 7
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("downgradeConfirmContent")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("downgradeConfirmExpired", {
                                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(state.expiredAtSubscription)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 6,
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCautionText, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WageSettlementMethodLink, {
                                            variant: "caption"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificCommercialTransactionLawLink, {
                                            variant: "caption"
                                        })
                                    ]
                                })
                            ]
                        }),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleDowngradePlan,
                            loading: state.subscribing,
                            children: t("downgrade")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openUpgradeConfirm,
                        onClose: function() {
                            return setOpenUpgradeConfirm(false);
                        },
                        title: t("upgradeConfirm"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            sx: {
                                pb: 7
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("upgradeConfirmContent", {
                                        diff: state.diffAmountSubscription
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 6,
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCautionText, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WageSettlementMethodLink, {
                                            variant: "caption"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificCommercialTransactionLawLink, {
                                            variant: "caption"
                                        })
                                    ]
                                })
                            ]
                        }),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleUpgradePlan,
                            loading: state.subscribing,
                            children: t("upgrade")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openStopConfirm,
                        onClose: function() {
                            return setOpenStopConfirm(false);
                        },
                        title: t("stopConfirm"),
                        content: t("stopConfirmContent"),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleStopSubscription,
                            loading: state.subscribing,
                            children: t("stop")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openCancelChangePlanConfirm,
                        onClose: function() {
                            return setOpenCancelChangePlanConfirm(false);
                        },
                        title: t("cancelChangePlanConfirm"),
                        content: t("cancelChangePlanConfirmContent"),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleCancelChangePlan,
                            loading: state.subscribing,
                            children: t("cancelChangePlan")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openCarrierUpgradeConfirm,
                        onClose: function() {
                            return setOpenCarrierUpgradeConfirm(false);
                        },
                        title: t("confirm"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            sx: {
                                pb: 7
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("carrierUpgradeConfirmContent")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("carrierUpgradeConfirmExpired", {
                                        expiredAt: values_Date/* DateTime.formatDate */.o.formatDate(state.expiredAtSubscription)
                                    })
                                })
                            ]
                        }),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                minWidth: 212
                            },
                            onClick: handleCarrierUpgradePlan,
                            loading: state.subscribing,
                            children: t("upgrade")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openKonbiniUpgradeConfirm,
                        onClose: function() {
                            return setOpenKonbiniUpgradeConfirm(false);
                        },
                        title: t("konbiniUpgradeConfirm"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            pt: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    align: "left",
                                    children: t("konbiniUpgradeConfirmContent")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    align: "center",
                                    children: t("nextUpdatedAt", {
                                        date: state.expiredAtSubscription
                                    })
                                })
                            ]
                        }),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 4,
                            pt: 7,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    size: "large",
                                    sx: {
                                        minWidth: 212
                                    },
                                    href: generatePath(routerPages.ArtistMembershipPaymentEdit, {
                                        artistId: (ref24 = (ref5 = state.artist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref24 !== void 0 ? ref24 : "#",
                                        productId: (ref25 = (ref7 = (ref6 = state.products) === null || ref6 === void 0 ? void 0 : ref6.find(function(product) {
                                            return product.plans.some(function(plan) {
                                                return plan.planId === (currentSelectPlan === null || currentSelectPlan === void 0 ? void 0 : currentSelectPlan.planId);
                                            });
                                        })) === null || ref7 === void 0 ? void 0 : ref7.productId) !== null && ref25 !== void 0 ? ref25 : "#"
                                    }),
                                    children: t("changePaymentMethod")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    sx: {
                                        minWidth: 212
                                    },
                                    onClick: function() {
                                        return setOpenKonbiniUpgradeConfirm(false);
                                    },
                                    children: "閉じる"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                        open: openExpiredCardModal,
                        onClose: function() {
                            return setOpenExpiredCardModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                        open: openPaymentErrorModal,
                        onClose: function() {
                            return setOpenPaymentErrorModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                        open: openRequire3DSecureModal,
                        onClose: function() {
                            return setOpenRequire3DSecureModal(false);
                        }
                    })
                ]
            })
        ]
    });
};
var BannerCell = function(param) {
    var artist = param.artist, onClose = param.onClose, children = param.children, responsive = param.responsive;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,ArtistThemeProvider/* useArtistThemeContext */.ff)(), 1), bgImage = ref1[0].bgImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
        hasSafeArea: true,
        gradationMask: true,
        bgImage: bgImage,
        imageUri: artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.mediumUri,
        maxWidth: responsive ? 1120 : undefined,
        responsive: responsive,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                width: "100%",
                height: {
                    xs: 280,
                    md: 584
                }
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                position: "static",
                sx: {
                    bgcolor: "transparent",
                    backgroundImage: "none",
                    boxShadow: "none",
                    color: "text.primary"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        onClick: onClose,
                        bgcolor: "grey.50"
                    })
                })
            })
        })
    });
};
var ArtistMemberLoadingCell = function(param) {
    var onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: {
                        xs: 280,
                        md: 584
                    },
                    "& header": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                    position: "static",
                    sx: {
                        pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                        bgcolor: "transparent",
                        backgroundImage: "none",
                        boxShadow: "none",
                        color: "text.primary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            onClick: onClose,
                            bgcolor: "grey.50"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    mt: "60px",
                    pt: 5
                },
                spacing: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 348,
                        width: "100%",
                        sx: {
                            borderRadius: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 348,
                        width: "100%",
                        sx: {
                            borderRadius: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 348,
                        width: "100%",
                        sx: {
                            borderRadius: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 7
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    sx: {
                        py: 1
                    },
                    variant: "small",
                    numberOfLine: 5,
                    lastWidth: "75%"
                })
            })
        ]
    });
};
var WebInductionCell = function(param) {
    var appName = param.appName;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            mt: 4,
            mx: 5,
            mb: -2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                borderRadius: 2,
                border: 1,
                borderColor: "grey.100",
                pt: 5,
                px: 7,
                pb: 6
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t("cannotOpen")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.hint",
                    sx: {
                        mt: 4
                    },
                    children: t("searchBrowser")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Search, {
                            fontSize: "medium"
                        })
                    }),
                    sx: {
                        width: 275,
                        mt: 2
                    },
                    disabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        width: "100%",
                        sx: {
                            ml: 7
                        },
                        children: appName
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v1.js
var v1 = __webpack_require__(43833);
// EXTERNAL MODULE: ./src/core/membership/index.ts
var core_membership = __webpack_require__(117);
// EXTERNAL MODULE: ./src/core/native/app/index.tsx + 35 modules
var native_app = __webpack_require__(76250);
// EXTERNAL MODULE: ./src/lib/revenueCat/index.ts
var revenueCat = __webpack_require__(81186);
// EXTERNAL MODULE: ../../node_modules/@revenuecat/purchases-capacitor/dist/esm/index.js + 1 modules
var esm = __webpack_require__(77127);
;// CONCATENATED MODULE: ./src/core/payment/purchase.ts



/**
 * RevenueCat経由でアプリ内課金を実行する
 * この処理の中で、日本円による決済で、サーバーで保持している最新価格とRevenueCat(Apple/Google)の価格が一致しているかをチェックする
 *
 * @param productId - 購入する商品のID
 * @param apiKey - RevenueCatのAPIキー
 * @param expectedPriceJpy - 期待される価格（日本円）。サーバーで保持している最新価格
 * @param userId - ユーザーID（オプション）
 * @param isSubscription - サブスクリプション商品かどうか（オプション）
 * @param t - 翻訳関数（オプション）
 * @returns 購入結果
 * @throws エラーが発生した場合は適切なエラーメッセージをthrowする
 */ var purchase = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(productId, apiKey, expectedPriceJpy, userId, isSubscription, t) {
        var product, selectedProduct, res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        esm/* Purchases.configure */.vL.configure({
                            apiKey: apiKey,
                            appUserID: userId
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        esm/* Purchases.getProducts */.vL.getProducts({
                            productIdentifiers: [
                                productId
                            ],
                            type: isSubscription ? esm/* PRODUCT_CATEGORY.SUBSCRIPTION */.ru.SUBSCRIPTION : esm/* PRODUCT_CATEGORY.NON_SUBSCRIPTION */.ru.NON_SUBSCRIPTION
                        })
                    ];
                case 2:
                    product = _state.sent();
                    if (!(product === null || product === void 0 ? void 0 : product.products) || product.products.length === 0) {
                        throw new Error(t && t("iapProductNotPurchasable"));
                    }
                    selectedProduct = product.products[0];
                    if ((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.currencyCode) === "JPY" && expectedPriceJpy !== selectedProduct.price) {
                        throw new Error(t && t("iapPriceMismatch"));
                    }
                    return [
                        4,
                        esm/* Purchases.purchaseStoreProduct */.vL.purchaseStoreProduct({
                            product: product.products[0]
                        }).catch(function(e) {
                            switch(e === null || e === void 0 ? void 0 : e.code){
                                case esm/* PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR */.wb.PURCHASE_CANCELLED_ERROR:
                                    throw new Error(t && t("iapPurchaseCanceled"));
                                case esm/* PURCHASES_ERROR_CODE.API_ENDPOINT_BLOCKED */.wb.API_ENDPOINT_BLOCKED:
                                    throw new Error(t && t("iapApiBlocked"));
                                case esm/* PURCHASES_ERROR_CODE.OFFLINE_CONNECTION_ERROR */.wb.OFFLINE_CONNECTION_ERROR:
                                    throw new Error(t && t("iapOfflineError"));
                                default:
                                    var ref;
                                    var ref1;
                                    throw new Error((ref1 = e === null || e === void 0 ? void 0 : (ref = e.error) === null || ref === void 0 ? void 0 : ref.messsage) !== null && ref1 !== void 0 ? ref1 : t && t("iapPaymentFailed"));
                            }
                        })
                    ];
                case 3:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function purchase(productId, apiKey, expectedPriceJpy, userId, isSubscription, t) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembership/viewModel.ts




function ArtistMembership_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembership($id: ID) {\n    artist(id: $id) {\n      ...ArtistWithSubscription\n      ...ArtistMembershipSubscriptionDetail\n      ...ArtistMembershipFavoriteMembersSettings\n      ...ArtistMembershipFavoriteMembersId\n    }\n    user {\n      id\n      isMembershipPersonalInformationRequired\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMembership_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistMembership_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PreviewSubscriptionUpdate($planId: String!, $artistId: String!) {\n    previewSubscriptionUpdate(planId: $planId, artistId: $artistId) {\n      planId\n      diffAmount\n    }\n  }\n"
    ]);
    ArtistMembership_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipForGuest($id: ID) {\n    artist(id: $id) {\n      ...ArtistWithSubscription\n      ...ArtistMembershipSubscriptionDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation startSubscription($artistId: ID!, $planId: ID!) {\n    startSubscription(artistId: $artistId, planId: $planId) {\n      ...PatronDetail\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation upgradeSubscriptionPlanProcess(\n    $planId: String!\n    $artistId: String!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n  ) {\n    upgradeSubscriptionPlanProcess(\n      planId: $planId\n      artistId: $artistId\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n    ) {\n      __typename\n      ... on Patron {\n        id\n        isPersonalInformationRequired\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation downgradeSubscriptionPlanProcess(\n    $planId: String!\n    $artistId: String!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n  ) {\n    downgradeSubscriptionPlanProcess(\n      planId: $planId\n      artistId: $artistId\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n    ) {\n      __typename\n      ... on Patron {\n        id\n        isPersonalInformationRequired\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation cancelDowngradeSubscriptionPlanProcess(\n    $artistId: String!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n  ) {\n    cancelDowngradeSubscriptionPlanProcess(\n      artistId: $artistId\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n    ) {\n      __typename\n      ... on Patron {\n        id\n        isPersonalInformationRequired\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          merchantId\n          operateId\n          encryptValue\n          openID\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation tryPaymentLock($uuid: String!, $artistId: String) {\n    tryPaymentLock(uuid: $uuid, artistId: $artistId) {\n      success\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation createIapSubscription(\n    $productId: String!\n    $uuid: String\n    $app: String\n    $artistId: String\n  ) {\n    createIapSubscription(\n      productId: $productId\n      uuid: $uuid\n      app: $app\n      artistId: $artistId\n    ) {\n      ...PatronDetail\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}















var ArtistMembership_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isWeb = native_app/* getPlatform */.Xf() === "web";
    var isIOs = native_app/* getPlatform */.Xf() === "ios";
    var ref21 = (0,react.useState)(false), nativeSubscribing = ref21[0], setNativeSubscribing = ref21[1];
    var ref22 = (0,useQuery/* useQuery */.aM)(ArtistMembership_viewModel_QUERY, {
        variables: {
            id: artistId
        },
        skip: !user
    }), data = ref22.data, loading = ref22.loading;
    var ref23 = (0,useQuery/* useQuery */.aM)(QUERY_FOR_GUEST, {
        variables: {
            id: artistId
        },
        skip: !!user
    }), dataGuest = ref23.data, loadingGuest = ref23.loading;
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(PREVIEW_SUBSCRIPTION_UPDATE), 2), previewSubscriptionUpdate = ref24[0], ref25 = ref24[1], previewSubscriptionUpdateData = ref25.data, fetchingDiffAmountSubscription = ref25.loading;
    // 外部キャリア決済画面（escott）へのリダイレクト中かどうかを管理するフラグ
    // mutation の完了から escott フォーム送信までに
    // submit ボタンが活性化してしまうのを防ぐために用いている
    var ref26 = (0,react.useState)(false), isRedirectingToEscott = ref26[0], setIsRedirectingToEscott = ref26[1];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPGRADE_SUBSCRIPTION_PLAN, {
        refetchQueries: function() {
            return [
                {
                    query: ArtistMembership_viewModel_QUERY,
                    variables: {
                        id: artistId
                    }
                }
            ];
        },
        awaitRefetchQueries: true,
        onCompleted: function onCompleted(param) {
            var upgradeSubscriptionPlanProcess = param.upgradeSubscriptionPlanProcess;
            switch(upgradeSubscriptionPlanProcess.__typename){
                // 追加手続きが不要なケース
                // ステータスの更新された Patron が返される
                case "Patron":
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(upgradeSubscriptionPlanProcess.nextActionUrl, upgradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), upgradeSubscriptionPlanProcess = ref27[0], ref28 = ref27[1], upgradingSubscriptionPlan = ref28.loading;
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DOWNGRADE_SUBSCRIPTION_PLAN_PROCESS, {
        refetchQueries: function() {
            return [
                {
                    query: ArtistMembership_viewModel_QUERY,
                    variables: {
                        id: artistId
                    }
                }
            ];
        },
        awaitRefetchQueries: true,
        onCompleted: function onCompleted(param) {
            var downgradeSubscriptionPlanProcess = param.downgradeSubscriptionPlanProcess;
            switch(downgradeSubscriptionPlanProcess.__typename){
                // 追加手続きが不要なケース
                // ステータスの更新された Patron が返される
                case "Patron":
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(downgradeSubscriptionPlanProcess.nextActionUrl, downgradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), downgradeSubscriptionPlanProcess = ref29[0], ref30 = ref29[1], downgradingSubscriptionPlan = ref30.loading;
    /**
   * プラン変更のキャンセル
   * アップグレードのキャンセルもダウングレードのキャンセルも
   * API の実装としては同一の処理であるため
   * cancelDowngradeSubscriptionPlanProcess を参照している
   * ref. https://utoniq.slack.com/archives/C089QSPGB27/p1747637183291179?thread_ts=1747635734.465719&cid=C089QSPGB27
   */ var ref31 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_DOWNGRADE_SUBSCRIPTION_PLAN_PROCESS, {
        refetchQueries: function() {
            return [
                {
                    query: ArtistMembership_viewModel_QUERY,
                    variables: {
                        id: artistId
                    }
                }
            ];
        },
        awaitRefetchQueries: true,
        onCompleted: function onCompleted(param) {
            var cancelDowngradeSubscriptionPlanProcess = param.cancelDowngradeSubscriptionPlanProcess;
            switch(cancelDowngradeSubscriptionPlanProcess.__typename){
                // 追加手続きが不要なケース
                // ステータスの更新された Patron が返される
                case "Patron":
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(cancelDowngradeSubscriptionPlanProcess.nextActionUrl, cancelDowngradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), cancelChangeSubscriptionPlanProcess = ref31[0], ref32 = ref31[1], cancelingChangeSubscriptionPlan = ref32.loading;
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* StopSubscriptionProcess */.ZSk, {
        refetchQueries: function() {
            return [
                {
                    query: ArtistMembership_viewModel_QUERY,
                    variables: {
                        id: artistId
                    }
                }
            ];
        },
        awaitRefetchQueries: true
    }), 2), stopSubscriptionProcess = ref33[0], ref34 = ref33[1], stoppingSubscription = ref34.loading;
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(TRY_PAYMENT_LOCK), 1), tryPaymentLock = ref35[0];
    var ref36 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_IAP_SUBSCRIPTION, {
        onCompleted: function onCompleted(param) {
            var createIapSubscription = param.createIapSubscription;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* setRegisterNewMembership */.oj)()
                            ];
                        case 1:
                            _state.sent();
                            if (createIapSubscription === null || createIapSubscription === void 0 ? void 0 : createIapSubscription.isPersonalInformationRequired) {
                                showModal({
                                    showSnackbarWhenClose: true,
                                    isRegisterNewMembership: true
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), 1), createIapSubscription = ref36[0];
    var artist = ((data !== null && data !== void 0 ? data : dataGuest) || {}).artist;
    var appName = (0,react.useMemo)(/**
     * @description
     * Open when function is implemented in the future
     * https://app.clickup.com/t/908127/UT-15031
     */ //@ts-ignore
    function() {
        return getAppNameByPlatformAndSubscription(artist === null || artist === void 0 ? void 0 : artist.subscription);
    }, [
        artist === null || artist === void 0 ? void 0 : artist.subscription
    ]);
    /**
   * サブスク契約（ネイティブ用）
   */ var subscribeByNative = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, apiKey, productId, uuid, ref2, tryLockForNativePurchase, _amount, ref3, tryLockForSync, app;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setNativeSubscribing(true);
                        apiKey = native_app/* getPlatformResult */.NA({
                            ios: config_config/* config.revenueCatApiKey.ios */.v.revenueCatApiKey.ios,
                            android: config_config/* config.revenueCatApiKey.android */.v.revenueCatApiKey.android,
                            web: ""
                        });
                        return [
                            4,
                            (0,revenueCat/* getSubscriptionById */.R)((artist === null || artist === void 0 ? void 0 : artist.id) || "", apiKey, (user === null || user === void 0 ? void 0 : user.uid) || "", isIOs)
                        ];
                    case 1:
                        productId = _state.sent();
                        uuid = (0,v1/* default */.Z)();
                        return [
                            4,
                            tryPaymentLock({
                                variables: {
                                    uuid: uuid,
                                    artistId: artist === null || artist === void 0 ? void 0 : artist.id
                                }
                            })
                        ];
                    case 2:
                        ref2 = _state.sent(), tryLockForNativePurchase = ref2.data;
                        // 二重支払い防止用のロック取得に失敗した場合はエラーを返す
                        if (!(tryLockForNativePurchase === null || tryLockForNativePurchase === void 0 ? void 0 : (ref = tryLockForNativePurchase.tryPaymentLock) === null || ref === void 0 ? void 0 : ref.success)) {
                            throw new Error(t("tryLockForNativePurchaseError"));
                        }
                        // ネイティブ機能でrevenueCat経由でサブスク契約
                        return [
                            4,
                            purchase(productId, apiKey, (_amount = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.plan.amount) !== null && _amount !== void 0 ? _amount : 0, user === null || user === void 0 ? void 0 : user.uid, true, t)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            tryPaymentLock({
                                variables: {
                                    uuid: uuid
                                }
                            })
                        ];
                    case 4:
                        ref3 = _state.sent(), tryLockForSync = ref3.data;
                        // 前段で取得した支払いロックに対し、同じuuidで再度ロックを取得。ロックに失敗した場合はエラーを返す
                        if (!(tryLockForSync === null || tryLockForSync === void 0 ? void 0 : (ref1 = tryLockForSync.tryPaymentLock) === null || ref1 === void 0 ? void 0 : ref1.success)) {
                            throw new Error(t("tryLockForSyncError"));
                        }
                        app = isIOs && (config_config/* config.applicationKey */.v.applicationKey === "lite" || config_config/* config.applicationKey */.v.applicationKey === "crazyvodkatonic") ? "utoniq" : config_config/* config.applicationKey */.v.applicationKey;
                        return [
                            2,
                            createIapSubscription({
                                variables: {
                                    productId: productId,
                                    uuid: uuid,
                                    app: app,
                                    artistId: artistId
                                },
                                refetchQueries: function() {
                                    return [
                                        {
                                            query: ArtistMembership_viewModel_QUERY,
                                            variables: {
                                                id: artistId
                                            }
                                        }
                                    ];
                                },
                                awaitRefetchQueries: true
                            })
                        ];
                }
            });
        });
        return function subscribeByNative() {
            return _ref.apply(this, arguments);
        };
    }();
    var activeProduct = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, // ネイティブが複数プラン対応になった場合、ここも合わせて変更が必要となる。
        ref7, ref8, ref9, ref10, ref11, ref12;
        var ref13, ref14;
        var selectedPlanId = (ref14 = (ref13 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.pendingPurchasePatron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.membership) === null || ref3 === void 0 ? void 0 : ref3.planId) !== null && ref13 !== void 0 ? ref13 : data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.patron) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.subscription) === null || ref6 === void 0 ? void 0 : ref6.planId) !== null && ref14 !== void 0 ? ref14 : !isWeb ? data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.subscription) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.products) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.plans) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.planId : undefined;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(data === null || data === void 0 ? void 0 : data.artist, selectedPlanId);
    }, [
        data === null || data === void 0 ? void 0 : data.artist,
        isWeb
    ]);
    var upgradeProduct = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(data === null || data === void 0 ? void 0 : data.artist, data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.upgradePlanId);
    }, [
        data === null || data === void 0 ? void 0 : data.artist
    ]);
    var downgradeProduct = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(data === null || data === void 0 ? void 0 : data.artist, data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.downgradePlanId);
    }, [
        data === null || data === void 0 ? void 0 : data.artist
    ]);
    // 外部キャリア決済画面（escott）からブラウザバックした際
    // リダイレクト中かどうかを管理するフラグをリセットする
    // ブラウザバック時に BFCache が効き再読み込みが走らない環境で
    // ローディング状態が解除されないことを防ぐ
    (0,escott/* useBFCacheRestore */.Hy)(function() {
        setIsRedirectingToEscott(false);
    });
    var ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, _diffAmount, ref45;
    return {
        state: {
            isLoggedIn: !!user,
            loading: loading || loadingGuest,
            subscribing: upgradingSubscriptionPlan || downgradingSubscriptionPlan || cancelingChangeSubscriptionPlan || stoppingSubscription || nativeSubscribing || isRedirectingToEscott,
            isMember: !!(artist === null || artist === void 0 ? void 0 : artist.patron),
            paymentMethod: (ref37 = artist === null || artist === void 0 ? void 0 : (ref = artist.patron) === null || ref === void 0 ? void 0 : ref.paymentMethod) !== null && ref37 !== void 0 ? ref37 : null,
            patronType: (ref38 = artist === null || artist === void 0 ? void 0 : (ref1 = artist.patron) === null || ref1 === void 0 ? void 0 : ref1.type) !== null && ref38 !== void 0 ? ref38 : null,
            store: (ref39 = artist === null || artist === void 0 ? void 0 : (ref2 = artist.patron) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.iapSubscription) === null || ref3 === void 0 ? void 0 : ref3.store) !== null && ref39 !== void 0 ? ref39 : null,
            /**
       * @description
       * Open when function is implemented in the future
       * https://app.clickup.com/t/908127/UT-15031
       */ //@ts-ignore
            stopSubscription: (artist === null || artist === void 0 ? void 0 : (ref4 = artist.subscription) === null || ref4 === void 0 ? void 0 : ref4.status) === "stopped",
            requireRegisteredCredit: isWeb && !(data === null || data === void 0 ? void 0 : data.paymentSource) && !!user,
            artist: artist,
            appName: appName,
            subscription: (ref40 = artist === null || artist === void 0 ? void 0 : (ref5 = artist.patron) === null || ref5 === void 0 ? void 0 : ref5.subscription) !== null && ref40 !== void 0 ? ref40 : null,
            downgradeAtNextPeriod: !!(artist === null || artist === void 0 ? void 0 : (ref6 = artist.patron) === null || ref6 === void 0 ? void 0 : ref6.downgradeAtNextPeriod),
            products: (ref42 = (ref41 = data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.subscription) === null || ref8 === void 0 ? void 0 : ref8.products) !== null && ref41 !== void 0 ? ref41 : dataGuest === null || dataGuest === void 0 ? void 0 : (ref9 = dataGuest.artist) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : ref10.products) !== null && ref42 !== void 0 ? ref42 : null,
            activeProduct: activeProduct,
            downgradeProduct: downgradeProduct,
            upgradeProduct: upgradeProduct,
            isPersonalInformationRequired: !!(artist === null || artist === void 0 ? void 0 : (ref11 = artist.patron) === null || ref11 === void 0 ? void 0 : ref11.isPersonalInformationRequired),
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref12 = data.user) === null || ref12 === void 0 ? void 0 : ref12.isMembershipPersonalInformationRequired),
            enableMembershipCarrierPayment: !!(artist === null || artist === void 0 ? void 0 : (ref13 = artist.subscription) === null || ref13 === void 0 ? void 0 : ref13.carrierPayment),
            expiredAtSubscription: (ref43 = artist === null || artist === void 0 ? void 0 : (ref14 = artist.patron) === null || ref14 === void 0 ? void 0 : ref14.formattedExpiredAt) !== null && ref43 !== void 0 ? ref43 : null,
            pendingPurchasePatron: (ref44 = artist === null || artist === void 0 ? void 0 : artist.pendingPurchasePatron) !== null && ref44 !== void 0 ? ref44 : null,
            diffAmountSubscription: (_diffAmount = previewSubscriptionUpdateData === null || previewSubscriptionUpdateData === void 0 ? void 0 : previewSubscriptionUpdateData.previewSubscriptionUpdate.diffAmount) !== null && _diffAmount !== void 0 ? _diffAmount : 0,
            fetchingDiffAmountSubscription: fetchingDiffAmountSubscription,
            selectFavoriteMemberRequired: !!(data === null || data === void 0 ? void 0 : (ref15 = data.artist) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.settings) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.features) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.subscription) === null || ref18 === void 0 ? void 0 : ref18.enableFavoriteMembers) && ((ref45 = data === null || data === void 0 ? void 0 : (ref19 = data.artist) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.favoriteMembers) === null || ref20 === void 0 ? void 0 : ref20.length) !== null && ref45 !== void 0 ? ref45 : 0) > 0
        },
        actions: {
            onPreviewSubscriptionUpdate: // アップデート時に支払う日割差額を取得する
            function onPreviewSubscriptionUpdate(planId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    previewSubscriptionUpdate({
                                        variables: {
                                            artistId: artistId,
                                            planId: planId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubscribePlan: // サブスクを開始する
            function onSubscribePlan() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (isWeb) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    subscribeByNative().finally(function() {
                                        return setNativeSubscribing(false);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUpgradePlan: // 上位プランへのアップグレード
            function onUpgradePlan(planId, paymentMethod, escottInput) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // キャリア決済の場合はローディング状態を表す
                                // state.subscribing に渡している
                                // isRedirectingToEscott を true にする
                                // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                                // submit ボタンが活性化するのを防ぐために行う
                                if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                                    setIsRedirectingToEscott(true);
                                }
                                return [
                                    4,
                                    upgradeSubscriptionPlanProcess({
                                        variables: {
                                            artistId: artistId,
                                            planId: planId,
                                            paymentMethod: paymentMethod,
                                            escottInput: escottInput
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDowngradePlan: // 下位プランへのダウングレード
            function onDowngradePlan(planId, paymentMethod, escottInput) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // キャリア決済の場合はローディング状態を表す
                                // state.subscribing に渡している
                                // isRedirectingToEscott を true にする
                                // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                                // submit ボタンが活性化するのを防ぐために行う
                                if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                                    setIsRedirectingToEscott(true);
                                }
                                return [
                                    4,
                                    downgradeSubscriptionPlanProcess({
                                        variables: {
                                            artistId: artistId,
                                            planId: planId,
                                            paymentMethod: paymentMethod,
                                            escottInput: escottInput
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onStopSubscription: // サブスク自体の停止
            function onStopSubscription() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    stopSubscriptionProcess({
                                        variables: {
                                            artistId: artistId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCancelChangePlan: // プラン変更のキャンセル
            function onCancelChangePlan(paymentMethod, escottInput) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // キャリア決済の場合はローディング状態を表す
                                // state.subscribing に渡している
                                // isRedirectingToEscott を true にする
                                // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                                // submit ボタンが活性化するのを防ぐために行う
                                if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                                    setIsRedirectingToEscott(true);
                                }
                                return [
                                    4,
                                    cancelChangeSubscriptionPlanProcess({
                                        variables: {
                                            artistId: artistId,
                                            paymentMethod: paymentMethod,
                                            escottInput: escottInput
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClearSelectFavoriteMember: function onClearSelectFavoriteMember() {
                localStorage.removeItem("artistMembershipFavoriteMembersSelect");
            }
        }
    };
});
var ArtistMembership_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembership_viewModel_templateObject(), utoniq_core_schema/* ArtistWithSubscriptionFragmentDoc */.kZH, utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9, utoniq_core_schema/* ArtistMembershipFavoriteMembersSettingsFragmentDoc */.A$X, utoniq_core_schema/* ArtistMembershipFavoriteMembersIdFragmentDoc */.la$, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var PREVIEW_SUBSCRIPTION_UPDATE = (0,lib/* gql */.Ps)(ArtistMembership_viewModel_templateObject1());
var QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(_templateObject2(), utoniq_core_schema/* ArtistWithSubscriptionFragmentDoc */.kZH, utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9);
var START_SUBSCRIPTION = (0,lib/* gql */.Ps)(_templateObject3(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var UPGRADE_SUBSCRIPTION_PLAN = (0,lib/* gql */.Ps)(_templateObject4(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var DOWNGRADE_SUBSCRIPTION_PLAN_PROCESS = (0,lib/* gql */.Ps)(_templateObject5(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var CANCEL_DOWNGRADE_SUBSCRIPTION_PLAN_PROCESS = (0,lib/* gql */.Ps)(_templateObject6(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var TRY_PAYMENT_LOCK = (0,lib/* gql */.Ps)(_templateObject7());
var CREATE_IAP_SUBSCRIPTION = (0,lib/* gql */.Ps)(_templateObject8(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
/**
 * @description return app name by platform and subscription
 * if platform = web return undefined
 * if platform = android and playstore not existed return app name
 * if platform = ios and appstore not existed return app name
 * @param {MembershipSubscription} subscription
 */ function getAppNameByPlatformAndSubscription(subscription) {
    var ref, ref1, ref2, ref3;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var url = new URL(config_config/* config.deepLinkUrl */.v.deepLinkUrl);
    if (platform === "web") return undefined;
    // @note productsは配列だが、ネイティブは現状1プランしか存在できないため、配列の先頭をとる
    if (platform === "android" && !(subscription === null || subscription === void 0 ? void 0 : (ref = subscription.products) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.plans.some(function(plan) {
        return !!plan.playstore;
    }))) {
        return url.host;
    }
    if (platform === "ios" && !(subscription === null || subscription === void 0 ? void 0 : (ref2 = subscription.products) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.plans.some(function(plan) {
        return !!plan.appstore;
    }))) {
        return url.host;
    }
    return undefined;
}

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembership/index.tsx




/**
 * ArtistMembership Page
 * Implemented as a practical sample.
 */ var ArtistMembership = function() {
    var ref = ArtistMembership_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/loading/index.tsx
var organisms_loading = __webpack_require__(27637);
;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipCompletion/template/index.tsx













var ArtistMembershipCompletionTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipCompletion").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, routerNames = ref.routerNames, router = ref.router;
    // 個人情報入力が必要な場合に
    // メンバーシップ登録完了画面を表示しないために用いる
    var ref1 = (0,react.useState)(true), isWaitingForPersonalInfo = ref1[0], setIsWaitingForPersonalInfo = ref1[1];
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // メンバーシップ利用のためお客様情報の登録が必要だった場合に
    // お客様情報入力用のモーダルを表示する処理
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // キャリア決済の成功時以外は何もしない
                // キャリア決済の成功時はクエリパラメータに status=success が付与される
                if (!state.user || router.query.status !== "success") return [
                    2
                ];
                setIsWaitingForPersonalInfo(false);
                if (state.user.isMembershipPersonalInformationRequired) {
                    showModal({
                        onClose: function onClose() {
                            // 入力を完了せず入力モーダルを閉じてしまった場合
                            // アーティストトップ画面に遷移する
                            router.push(generatePath(routerPages.ArtistTop, {
                                artistId: state.artistId
                            }));
                        }
                    });
                }
                return [
                    2
                ];
            });
        })();
    }, [
        state.user,
        router.query.status
    ]);
    var _formattedExpiredAt, _voucherUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: state.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini ? routerNames.ArtistMembershipKonbiniCompletion : routerNames.ArtistMembershipCompletion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    title: t("".concat(state.paymentMethod, "Title")),
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: function() {
                            router.goBack();
                        }
                    })
                },
                children: state.loading || // キャリア決済かつ個人情報入力が必要な場合はローディングを表示する
                router.query.status === "success" && isWaitingForPersonalInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                pt: 7,
                                pb: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                align: "center",
                                children: t("".concat(state.paymentMethod, "SuccessTitle"))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("".concat(state.paymentMethod, "SuccessDesc"))
                        }),
                        state.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                mt: 5,
                                py: 2,
                                borderColor: "error.main",
                                borderWidth: 1,
                                borderStyle: "solid"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "error",
                                align: "center",
                                children: t("paymentDeadline", {
                                    date: (_formattedExpiredAt = state.formattedExpiredAt) !== null && _formattedExpiredAt !== void 0 ? _formattedExpiredAt : ""
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            justifyContent: "center",
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                py: 5,
                                mt: 5
                            },
                            children: state.paymentMethod === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "large",
                                        href: routerPages.MembershipManagement,
                                        sx: {
                                            minWidth: 244
                                        },
                                        children: t("viewMembershipManagement", "メンバーシップ管理を見る")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        href: generatePath(routerPages.ArtistTop, {
                                            artistId: state.artistId
                                        }),
                                        sx: {
                                            minWidth: 244
                                        },
                                        children: t("viewTOP", "TOPページへ")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        component: "a",
                                        target: "_blank",
                                        size: "large",
                                        href: (_voucherUrl = state.voucherUrl) !== null && _voucherUrl !== void 0 ? _voucherUrl : "#",
                                        sx: {
                                            minWidth: 244
                                        },
                                        children: t("proceedPaymentProcedure", "決済手順へすすむ")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        href: routerPages.PaymentStatuses,
                                        sx: {
                                            minWidth: 244
                                        },
                                        children: t("checkPaymentStatus", "決済状況を確認する")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: "90dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipCompletion/viewModel.ts

function ArtistMembershipCompletion_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipCompletion($pendingPurchaseId: ID!) {\n    pendingPurchaseItem(pendingPurchaseId: $pendingPurchaseId) {\n      id\n      expiredAt\n      formattedExpiredAt @client\n      voucherUrl\n    }\n  }\n"
    ]);
    ArtistMembershipCompletion_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var ArtistMembershipCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _pendingPurchaseId;
    var ref2 = (0,useQuery/* useQuery */.aM)(ArtistMembershipCompletion_viewModel_QUERY, {
        variables: {
            pendingPurchaseId: (_pendingPurchaseId = router.query.pendingPurchaseId) !== null && _pendingPurchaseId !== void 0 ? _pendingPurchaseId : ""
        },
        skip: !router.query.pendingPurchaseId
    }), data = ref2.data, loading = ref2.loading;
    var ref3 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* AccountSettings */.H6l), userData = ref3.data;
    var ref4, ref5, ref6;
    return {
        state: {
            loading: loading,
            user: userData === null || userData === void 0 ? void 0 : userData.user,
            artistId: (ref4 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref4 !== void 0 ? ref4 : "#",
            paymentMethod: router.query.pendingPurchaseId ? utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
            formattedExpiredAt: (ref5 = data === null || data === void 0 ? void 0 : (ref = data.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.formattedExpiredAt) !== null && ref5 !== void 0 ? ref5 : null,
            voucherUrl: (ref6 = data === null || data === void 0 ? void 0 : (ref1 = data.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.voucherUrl) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {}
    };
});
var ArtistMembershipCompletion_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembershipCompletion_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipCompletion/index.tsx




/**
 * ArtistMembershipCompletion Page
 * Implemented as a practical sample.
 */ var ArtistMembershipCompletion = function() {
    var ref = ArtistMembershipCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
;// CONCATENATED MODULE: ./src/components/organisms/membership/membershipFavoriteMembersSelect/index.tsx





/**
 * FavoriteMemberSelect
 * 推しメンバーを選択するコンポーネント
 */ var MembershipFavoriteMemberSelect = function(param) {
    var favoriteMembers = param.favoriteMembers, selectedFavoriteMember = param.selectedFavoriteMember, onSelectFavoriteMember = param.onSelectFavoriteMember;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row",
        flexWrap: "wrap",
        sx: {
            justifyContent: "space-between",
            "&::after": {
                content: '""',
                display: "block",
                height: "100%",
                width: "calc(33.33% - 8px)",
                mb: 2
            }
        },
        children: favoriteMembers.map(function(member) {
            var ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    height: "100%",
                    width: "calc(33.33% - 8px)",
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                    elevation: 0,
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                        onClick: function() {
                            return onSelectFavoriteMember((ref = member === null || member === void 0 ? void 0 : member.id) !== null && ref !== void 0 ? ref : "");
                        },
                        sx: {
                            bgcolor: selectedFavoriteMember === (member === null || member === void 0 ? void 0 : member.id) ? "primary.light" : "background.default",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    my: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            top: -4,
                                            left: -4,
                                            right: -4,
                                            bottom: -4,
                                            borderRadius: "50%",
                                            border: "4px solid",
                                            borderColor: selectedFavoriteMember === (member === null || member === void 0 ? void 0 : member.id) ? "primary.main" : "grey.100",
                                            pointerEvents: "none"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            top: -1,
                                            left: -1,
                                            right: -1,
                                            bottom: -1,
                                            borderRadius: "50%",
                                            border: "1px solid",
                                            borderColor: "background.default",
                                            pointerEvents: "none"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: (ref1 = member === null || member === void 0 ? void 0 : (ref2 = member.avatar) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref1 !== void 0 ? ref1 : "",
                                        sx: {
                                            width: "56px",
                                            height: "56px"
                                        }
                                    }),
                                    selectedFavoriteMember === (member === null || member === void 0 ? void 0 : member.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            top: -4,
                                            right: -4,
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            bgcolor: "primary.main",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                            fontSize: "small",
                                            sx: {
                                                color: "white"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                sx: (0,src_object_spread/* default */.Z)({
                                    textAlign: "center",
                                    mb: 1,
                                    width: "100%"
                                }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                children: member === null || member === void 0 ? void 0 : member.name
                            })
                        ]
                    })
                })
            }, member === null || member === void 0 ? void 0 : member.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/membership/membershipJoinedModal/index.tsx



var MembershipJoinedModal = function(param) {
    var artistId = param.artistId;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var t = (0,core_i18n/* useTranslation */.$G)("membershipJoinedModal").t;
    var onClose = function() {
        router.replace(generatePath(routerPages.ArtistMembership, {
            artistId: artistId
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                maxWidth: 600,
                width: "100%",
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 5
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 7,
                        mt: 6
                    },
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            children: t("title", "メンバーシップに加入済みです")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                pt: 2
                            },
                            children: t("message", "既に加入中のプランがあります。プランを変更する場合は、プランのアップグレードまたはダウングレードを行ってください。")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: onClose,
                        size: "large",
                        children: t("confirm", "プランを選択する")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipFavoriteMembersSelect/template/index.tsx









var ArtistMembershipFavoriteMembersSelectTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onSelectFavoriteMember = param.onSelectFavoriteMember;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipFavoriteMembersSelect").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerNames = ref3.routerNames, routerPages = ref3.routerPages;
    var defaultBackPage = (0,react_router/* generatePath */.Gn)(routerPages.ArtistMembership, {
        artistId: state.artistId
    });
    var ref4, _favoriteMembers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistMembershipFavoriteMembersSelect
            }),
            state.joined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipJoinedModal, {
                artistId: state.artistId
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: defaultBackPage,
                    title: t("title", "推し設定")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 2,
                            bgcolor: "grey.50",
                            m: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                p: 2,
                                "&:last-child": {
                                    pb: 2
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: (ref4 = (ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref4 !== void 0 ? ref4 : "",
                                        sx: {
                                            width: 44,
                                            height: 44,
                                            m: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body1",
                                        sx: {
                                            width: "fit-content"
                                        },
                                        children: (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                        sx: {
                            m: 5,
                            height: "320px",
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipFavoriteMemberSelect, {
                            favoriteMembers: (_favoriteMembers = state.favoriteMembers) !== null && _favoriteMembers !== void 0 ? _favoriteMembers : [],
                            selectedFavoriteMember: state.selectedFavoriteMember,
                            onSelectFavoriteMember: onSelectFavoriteMember
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                            sx: {
                                mx: 5,
                                mb: 1.5,
                                p: 2,
                                border: "solid 1px",
                                borderColor: "info.main",
                                width: "50%",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "info.main",
                                children: t("note", "※ 推しは設定から90日間変更できません")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            my: 5
                        },
                        alignItems: "center",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                disabled: !state.selectedFavoriteMember,
                                loading: state.loading,
                                sx: {
                                    width: 212
                                },
                                onClick: onSubmit,
                                children: t("submit", "支払い方法選択に進む")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                size: "small",
                                sx: {
                                    width: 212
                                },
                                onClick: function() {
                                    return router.goBack(defaultBackPage);
                                },
                                children: t("back", "戻る")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipFavoriteMembersSelect/viewModel.ts



function ArtistMembershipFavoriteMembersSelect_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipFavoriteMembersSelect($artistId: ID) {\n    artist(id: $artistId) {\n      displayName\n      avatar {\n        uri\n      }\n      ...ArtistMembershipFavoriteMembers\n      ...ArtistWithPatron\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMembershipFavoriteMembersSelect_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ArtistMembershipFavoriteMembersSelect_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var localStorageKey = "artistMembershipFavoriteMembersSelect";
    var ref3 = (0,useQuery/* useQuery */.aM)(ArtistMembershipFavoriteMembersSelect_viewModel_QUERY, {
        variables: {
            artistId: artistId
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,react.useState)(function() {
        try {
            var storedData = localStorage.getItem(localStorageKey);
            if (storedData) {
                var parsedData = JSON.parse(storedData);
                return parsedData.id;
            }
            return undefined;
        } catch (e) {
            return undefined;
        }
    }), selectedFavoriteMember = ref4[0], setSelectedFavoriteMember = ref4[1];
    return {
        state: {
            artist: data === null || data === void 0 ? void 0 : data.artist,
            artistId: artistId,
            selectedFavoriteMember: selectedFavoriteMember,
            favoriteMembers: data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.favoriteMembers,
            loading: loading,
            joined: !!(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.patron)
        },
        actions: {
            onSubmit: function onSubmit() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, selectedFavoriteMemberInfo;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        selectedFavoriteMemberInfo = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.favoriteMembers) === null || ref1 === void 0 ? void 0 : ref1.find(function(member) {
                            return (member === null || member === void 0 ? void 0 : member.id) === selectedFavoriteMember;
                        });
                        localStorage.setItem(localStorageKey, JSON.stringify({
                            id: selectedFavoriteMemberInfo === null || selectedFavoriteMemberInfo === void 0 ? void 0 : selectedFavoriteMemberInfo.id,
                            name: selectedFavoriteMemberInfo === null || selectedFavoriteMemberInfo === void 0 ? void 0 : selectedFavoriteMemberInfo.name,
                            avatar: selectedFavoriteMemberInfo === null || selectedFavoriteMemberInfo === void 0 ? void 0 : (ref2 = selectedFavoriteMemberInfo.avatar) === null || ref2 === void 0 ? void 0 : ref2.uri
                        }));
                        return [
                            2,
                            router.push(generatePath(routerPages.ArtistMembershipPurchaseProceed, {
                                artistId: artistId,
                                productId: router.query.productId
                            }))
                        ];
                    });
                })();
            },
            onSelectFavoriteMember: function onSelectFavoriteMember(favoriteMemberId) {
                setSelectedFavoriteMember(favoriteMemberId);
            }
        }
    };
});
var ArtistMembershipFavoriteMembersSelect_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembershipFavoriteMembersSelect_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipFavoriteMembersFragmentDoc */.kGH, utoniq_core_schema/* ArtistWithPatronFragmentDoc */.xsZ);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipFavoriteMembersSelect/index.tsx




/**
 * ArtistMembershipFavoriteMembersSelect Page
 * Implemented as a practical sample.
 */ var ArtistMembershipFavoriteMembersSelect = function() {
    var ref = ArtistMembershipFavoriteMembersSelect_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipFavoriteMembersSelectTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(96758);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30721);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(85151);
// EXTERNAL MODULE: ./src/core/form/index.ts + 1 modules
var core_form = __webpack_require__(38679);
// EXTERNAL MODULE: ./src/core/resources/Image.tsx
var Image = __webpack_require__(83587);
// EXTERNAL MODULE: ./src/core/creditCard/index.ts
var creditCard = __webpack_require__(11534);
;// CONCATENATED MODULE: ./src/components/pages/PaymentDetail/template/index.tsx










var PaymentDetailTemplate = function(param) {
    var state = param.state, onDeletePaymentSource = param.onDeletePaymentSource;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerNames = ref.routerNames, routerPages = ref.routerPages;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    // HACK: PointChargeDrawerから遷移した時、モーダルを非表示にする
    (0,react.useEffect)(function() {
        var elms = document === null || document === void 0 ? void 0 : document.getElementsByClassName("show-modal");
        Array.from(elms).forEach(function(elm) {
            return elm.setAttribute("is-open", "false");
        });
    }, []);
    /**
   * @description
   * 決済エラー時に表示されるカードの再登録を促すモーダルから
   * 遷移してきた場合にトーストメッセージを表示する
   */ (0,react.useEffect)(function() {
        if (router.query.reRegister) {
            showMessage(t("reRegisterInfo"), "info");
        }
    /**
     * 依存配列に showMessage を渡すと無限ループが発生するため空配列を渡し、
     *  eslint を無効化して Warning を消している
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PaymentDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: routerPages.Setting
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardCell, {
                    cardNumber: state.cardNumber,
                    name: state.name,
                    expirationDate: state.expirationDate,
                    visible: state.visible,
                    onDeletePaymentSource: onDeletePaymentSource,
                    brand: state.brand
                })
            })
        ]
    });
};
var CreditCardCell = function(param) {
    var cardNumber = param.cardNumber, name = param.name, expirationDate = param.expirationDate, visible = param.visible, onDeletePaymentSource = param.onDeletePaymentSource, brand = param.brand;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref2.showMessage, showError = ref2.showError;
    var handleDeleteCreditCard = function() {
        setLoading(true);
        onDeletePaymentSource().then(function() {
            return showMessage(t("deleteSuccess"));
        }).catch(function(e) {
            return showError(e);
        }).finally(function() {
            setLoading(false);
            setOpen(false);
        });
    };
    if (cardNumber && !visible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                pt: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        py: 6,
                        px: 5,
                        border: "1px solid",
                        borderColor: "grey.200",
                        borderRadius: 2
                    },
                    spacing: 5,
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                            width: 40,
                            height: 32,
                            src: (0,creditCard/* generateCreditCardLogoPath */.n)(brand),
                            target: "common"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: "**** **** **** ".concat(cardNumber)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: [
                                        t("dateOfExpiry"),
                                        ": ",
                                        expirationDate
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            onClick: function() {
                                return setOpen(true);
                            },
                            size: "small",
                            sx: {
                                minWidth: "auto",
                                p: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "primary.main",
                                children: t("delete")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: open,
                    onClose: function() {
                        return setOpen(false);
                    },
                    title: t("deleteTitle"),
                    content: t("deleteConfirm"),
                    cancelText: t("cancel"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: handleDeleteCreditCard,
                        size: "large",
                        sx: {
                            minWidth: 212
                        },
                        loading: loading,
                        children: "OK"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        sx: {
            height: "100%"
        },
        children: [
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
            }),
            !cardNumber && !visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    height: "100%"
                },
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            textAlign: "center",
                            sx: {
                                py: 4
                            },
                            children: t("noPaymentMethod")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            href: routerPages.PaymentMethodSetting,
                            sx: {
                                width: 244,
                                margin: "auto"
                            },
                            color: "primary",
                            children: t("registerCredit")
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/core/form/Form.tsx
var Form = __webpack_require__(35625);
;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPaymentEdit/template/RegisterPaymentMethodForm.tsx









var schema = function(o) {
    return {
        cardNumber: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.cardNumber")),
        cardHolder: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.cardHolder")),
        securityCode: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.securityCode")),
        expirationDate: o.string().pattern(new RegExp("^(0[1-9]|1[0-2])/?([0-9]{2})$")).label((0,core_form/* tLabel */.TQ)("paymentCreate.expirationDate"))
    };
};
var RegisterPaymentMethodForm = function(param) {
    var onSubmitCreatePayment = param.onSubmitCreatePayment, submitting = param.submitting, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: schema,
        defaultValues: defaultValues
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, setError = ref1.setError, reset = ref1.reset, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onSubmit = handleSubmit(function(values) {
        return onSubmitCreatePayment(values).then(function() {
            showMessage(t("registerSuccess"));
            reset(defaultValues);
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            px: 5
        },
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                children: t("registerCreditCard", "クレジットカード情報を登録してください。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                onSubmit: onSubmit,
                sx: {
                    mt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInputCell, (0,src_object_spread/* default */.Z)({
                        type: "text",
                        inputProps: {
                            pattern: "[0-9\\s]*",
                            inputMode: "numeric"
                        },
                        mask: "0000 0000 0000 0000",
                        error: errors === null || errors === void 0 ? void 0 : errors.cardNumber
                    }, register("cardNumber"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell, (0,src_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.cardHolder
                    }, register("cardHolder"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInputCell, (0,src_object_spread/* default */.Z)({
                        type: "text",
                        inputProps: {
                            pattern: "[0-9\\s]*",
                            inputMode: "numeric"
                        },
                        mask: "0000",
                        placeholder: t(""),
                        error: errors === null || errors === void 0 ? void 0 : errors.securityCode
                    }, register("securityCode"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInputCell, (0,src_object_spread/* default */.Z)({
                        type: "text",
                        inputProps: {
                            pattern: "[0-9/]*",
                            inputMode: "numeric"
                        },
                        mask: "00/00",
                        error: errors === null || errors === void 0 ? void 0 : errors.expirationDate
                    }, register("expirationDate"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                        sx: {
                            px: 4,
                            py: 3,
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "contained",
                            type: "submit",
                            size: "large",
                            sx: {
                                width: 244
                            },
                            loading: submitting,
                            children: t("register")
                        })
                    })
                ]
            })
        ]
    });
};
var defaultValues = {
    cardNumber: "",
    cardHolder: "",
    securityCode: "",
    expirationDate: ""
};
var TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            placeholder: t("".concat(props.name, "Placeholder"))
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPaymentEdit/template/ArtistMembershipPaymentEditForm.tsx












var ArtistMembershipPaymentEditForm_schema = function(o) {
    return {
        interval: o.string()
    };
};
var ArtistMembershipPaymentEditForm_defaultValues = {
    interval: utoniq_core_schema/* MembershipInterval.Year */.ls9.Year
};
var ArtistMembershipPaymentEditForm = function(param) {
    var plans = param.plans, patron = param.patron, paymentSource = param.paymentSource, loading = param.loading, submitting = param.submitting, onSubmit = param.onSubmit, onSubmitDeletePayment = param.onSubmitDeletePayment, onSubmitCreatePayment = param.onSubmitCreatePayment, submittingCreatePayment = param.submittingCreatePayment;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: ArtistMembershipPaymentEditForm_schema,
        defaultValues: ArtistMembershipPaymentEditForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, isSubmitting = ref1.formState.isSubmitting, watch = ref1.watch, setValue = ref1.setValue, reset = ref1.reset;
    var intervalWatch = watch("interval");
    (0,react.useEffect)(function() {
        if (patron) {
            var ref;
            var ref1;
            reset({
                interval: (ref1 = (ref = plans.find(function(plan) {
                    var ref;
                    return plan.planId === (patron === null || patron === void 0 ? void 0 : (ref = patron.subscription) === null || ref === void 0 ? void 0 : ref.planId);
                })) === null || ref === void 0 ? void 0 : ref.interval) !== null && ref1 !== void 0 ? ref1 : utoniq_core_schema/* MembershipInterval.Year */.ls9.Year
            });
        }
    }, [
        plans,
        patron
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                pb: 5,
                pt: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        color: "text.secondary",
                        children: t("course")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        value: intervalWatch,
                        onChange: function(_, value) {
                            setValue("interval", value, {
                                shouldValidate: true
                            });
                        },
                        sx: {
                            gap: function(theme) {
                                return theme.spacing(4);
                            },
                            px: 5
                        },
                        children: plans.map(function(plan, index) {
                            // NOTE: 年間 → 月間への変更APIは使用できないため、月額への切り替え導線を非表示にする
                            // https://app.clickup.com/t/908127/UT-15353
                            if (plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: plan.interval,
                                        checked: intervalWatch === plan.interval,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h5",
                                                    children: t("".concat(plan.interval, "Course"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            children: t("".concat(plan.interval, "CoursePrice"), {
                                                                amount: plan.formattedAmount
                                                            })
                                                        }),
                                                        plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "body2",
                                                            children: [
                                                                "(",
                                                                t("monthCoursePrice", {
                                                                    amount: numeral_default()(Math.ceil(plan.amount / 12)).format("0,0")
                                                                }),
                                                                ")"
                                                            ]
                                                        }),
                                                        plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year && !!plan.annualDiscountText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle2",
                                                            color: "primary.main",
                                                            sx: {
                                                                ml: 1
                                                            },
                                                            children: plan.annualDiscountText
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    plans.length - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                ]
                            }, plan.interval);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                pb: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        bgcolor: "grey.50",
                        px: 5,
                        py: 2
                    },
                    color: "text.secondary",
                    children: t("method", "支払い方法の変更")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    pb: 5
                },
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        color: "text.secondary",
                        children: t("currentMethod", "現在の支払い方法")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: (patron === null || patron === void 0 ? void 0 : patron.paymentMethod) === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard ? t("creditCard", "クレジットカード") : t("convenienceStore", "コンビニ決済")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Box_Box/* default */.Z, {
                        sx: {
                            height: "1px",
                            bgcolor: "grey.100"
                        }
                    })
                ]
            }),
            paymentSource ? // クレカ登録済みの場合
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisteredCreditCardCell, {
                loading: loading,
                paymentSource: paymentSource,
                onSubmitDeletePayment: onSubmitDeletePayment,
                isSubmitting: isSubmitting || !!submitting,
                handleOnSubmit: handleOnSubmit
            }) : // クレカ未登録の場合
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterPaymentMethodForm, {
                onSubmitCreatePayment: onSubmitCreatePayment,
                submitting: submittingCreatePayment,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    my: 5
                },
                alignItems: "center",
                gap: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back", "戻る")
                })
            })
        ]
    });
};
var RegisteredCreditCardCell = function(param) {
    var loading = param.loading, paymentSource = param.paymentSource, onSubmitDeletePayment = param.onSubmitDeletePayment, isSubmitting = param.isSubmitting, handleOnSubmit = param.handleOnSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    if (!paymentSource) /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            px: 5
        },
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                children: t("changeMethod", "下記のクレジットカードに支払い方法を変更します。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardCell, {
                cardNumber: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4,
                name: (ref = paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.name) !== null && ref !== void 0 ? ref : "",
                visible: loading,
                onDeletePaymentSource: onSubmitDeletePayment,
                brand: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand,
                expirationDate: "".concat(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.expMonth, "/").concat(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.expYear)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {
                sx: {
                    pt: 6,
                    pb: 0
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 4,
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    sx: {
                        width: 212
                    },
                    onClick: handleOnSubmit,
                    children: t("submit", "変更する")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPaymentEdit/template/index.tsx







var ArtistMembershipPaymentEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onSubmitDeletePayment = param.onSubmitDeletePayment, onSubmitCreatePayment = param.onSubmitCreatePayment, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistMembershipPurchaseProceed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    title: t("title", "支払い方法を変更")
                },
                children: [
                    !!((ref = state.plans) === null || ref === void 0 ? void 0 : ref.length) && !!state.patron && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPaymentEditForm, {
                        plans: state.plans,
                        patron: state.patron,
                        paymentSource: state.paymentSource,
                        onSubmit: onSubmit,
                        loading: state.loading,
                        submittingCreatePayment: state.submittingCreatePayment,
                        submitting: state.submitting,
                        onSubmitDeletePayment: onSubmitDeletePayment,
                        onSubmitCreatePayment: onSubmitCreatePayment
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                        open: state.openRequire3DSecureModal,
                        onClose: onCloseRequire3DSecureModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                        open: state.openExpiredCardModal,
                        onClose: onCloseExpiredCardModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                        open: state.openPaymentErrorModal,
                        onClose: onClosePaymentErrorModal
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(34498);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
;// CONCATENATED MODULE: ./src/lib/sleep/index.ts
function sleep(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
}

// EXTERNAL MODULE: ./src/lib/stripe/index.ts + 2 modules
var stripe = __webpack_require__(37452);
;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPaymentEdit/viewModel.ts




function ArtistMembershipPaymentEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipPaymentEdit($id: ID) {\n    artist(id: $id) {\n      id\n      ...ArtistMembershipSubscriptionDetail\n      patron {\n        id\n        amount\n        paymentMethod\n        subscription {\n          ...SubscriptionDetail\n        }\n      }\n    }\n    user {\n      id\n      credit {\n        ...PaymentDetail\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMembershipPaymentEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ArtistMembershipPaymentEdit_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, routerPages = ref4.routerPages;
    var ref5 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref5.showMessage, showError = ref5.showError;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPaymentEdit").t;
    var ref6 = (0,useQuery/* useQuery */.aM)(ArtistMembershipPaymentEdit_viewModel_QUERY, {
        variables: {
            id: config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId
        }
    }), data = ref6.data, loading = ref6.loading, refetch = ref6.refetch;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreatePaymentMethod */.Xs1, {
        onCompleted: function onCompleted() {
            refetch();
        }
    }), 2), createPaymentMethod = ref7[0], ref8 = ref7[1], submittingCreatePayment = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeletePaymentSource */.Cpo), 1), deletePaymentSource = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpgradeSubscriptionPlanProcess */.lKk, {
        onCompleted: function onCompleted() {
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    showMessage(t("updateSuccess"));
                    router.goBack(routerPages.MembershipManagement);
                    return [
                        2
                    ];
                });
            })();
        }
    }), 2), upgradeSubscriptionPlanProcess = ref10[0], ref11 = ref10[1], upgradingSubscriptionPlan = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DowngradeSubscriptionPlanProcess */.A1e, {
        onCompleted: function onCompleted() {
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    showMessage(t("updateSuccess"));
                    router.goBack(routerPages.MembershipManagement);
                    return [
                        2
                    ];
                });
            })();
        }
    }), 2), downgradeSubscriptionPlanProcess = ref12[0], ref13 = ref12[1], downgradingSubscriptionPlan = ref13.loading;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            return [];
        }
        var product = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.products.find(function(param) {
            var productId = param.productId;
            return router.query.productId === productId;
        });
        if (!product || !((ref5 = product.plans) === null || ref5 === void 0 ? void 0 : ref5.length)) {
            return [];
        }
        var _formattedAmount, _annualDiscountText;
        return orderBy_default()(product.plans.map(function(plan) {
            return {
                interval: plan.interval,
                amount: plan.amount,
                formattedAmount: (_formattedAmount = plan.formattedAmount) !== null && _formattedAmount !== void 0 ? _formattedAmount : "0",
                annualDiscountText: (_annualDiscountText = product.annualDiscountText) !== null && _annualDiscountText !== void 0 ? _annualDiscountText : "",
                planId: plan.planId
            };
        }), [
            "interval"
        ], [
            "desc"
        ]);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.products,
        router.query.productId
    ]);
    var ref14 = (0,react.useState)(false), openExpiredCardModal = ref14[0], setOpenExpiredCardModal = ref14[1];
    var ref15 = (0,react.useState)(false), openPaymentErrorModal = ref15[0], setOpenPaymentErrorModal = ref15[1];
    var ref16 = (0,react.useState)(false), openRequire3DSecureModal = ref16[0], setOpenRequire3DSecureModal = ref16[1];
    var ref17;
    return {
        state: {
            loading: loading,
            artistId: config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId,
            paymentSource: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.credit) !== null && ref17 !== void 0 ? ref17 : null,
            plans: plans,
            patron: data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.patron,
            submitting: upgradingSubscriptionPlan || downgradingSubscriptionPlan,
            submittingCreatePayment: submittingCreatePayment,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal
        },
        actions: {
            onSubmit: /**
       * NOTE:
       * 年間/月額の支払い方法変更APIが現在ないため、現在可能な支払い方法変更は
       * 年間コンビニ → 年間クレカ へのアップグレードのみである
       * https://app.clickup.com/t/908127/UT-15353
       */ function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, plan, ref5, ref6, ref7, ref8, ref9;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                plan = plans.find(function(plan) {
                                    return plan.interval === values.interval;
                                });
                                if (!(plan === null || plan === void 0 ? void 0 : plan.amount) || !(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.amount)) {
                                    return [
                                        2
                                    ];
                                }
                                if (!((plan === null || plan === void 0 ? void 0 : plan.amount) > (data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.patron) === null || ref3 === void 0 ? void 0 : ref3.amount))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    upgradeSubscriptionPlanProcess({
                                        variables: {
                                            planId: (ref6 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref6 !== void 0 ? ref6 : "",
                                            artistId: (ref7 = data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref7 !== void 0 ? ref7 : "",
                                            paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
                                        }
                                    }).catch(function(error) {
                                        var ref, ref1, ref2;
                                        switch((ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                            /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                                setOpenRequire3DSecureModal(true);
                                                return;
                                            /**
               * @description
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                                setOpenExpiredCardModal(true);
                                                return;
                                            /**
               * @description
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                                setOpenPaymentErrorModal(true);
                                                return;
                                            default:
                                                showError(error);
                                                break;
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    downgradeSubscriptionPlanProcess({
                                        variables: {
                                            planId: (ref8 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref8 !== void 0 ? ref8 : "",
                                            artistId: (ref9 = data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref9 !== void 0 ? ref9 : "",
                                            paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmitCreatePayment: function onSubmitCreatePayment(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, expMonth, expYear, token, ref1, paymentResponse, clientSecret, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = (0,_sliced_to_array/* default */.Z)(values.expirationDate.split("/"), 2), expMonth = ref[0], expYear = ref[1];
                                return [
                                    4,
                                    (0,stripe/* createTokenWithCard */.xE)({
                                        number: values.cardNumber.replace(/\s/g, ""),
                                        name: values.cardHolder,
                                        cvc: values.securityCode.replace(/\s/g, ""),
                                        expMonth: expMonth,
                                        expYear: expYear
                                    }).catch(function(error) {
                                        throw new Error(t(error.message));
                                    })
                                ];
                            case 1:
                                token = _state.sent();
                                return [
                                    4,
                                    createPaymentMethod({
                                        variables: {
                                            createPaymentMethodToken: token
                                        }
                                    })
                                ];
                            case 2:
                                ref1 = _state.sent(), paymentResponse = ref1.data;
                                if (!(paymentResponse && "clientSecret" in paymentResponse.createPaymentMethod)) return [
                                    3,
                                    4
                                ];
                                clientSecret = paymentResponse.createPaymentMethod.clientSecret;
                                return [
                                    4,
                                    (0,stripe/* confirmCardSetupWithStripe */.gC)(clientSecret)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result.error) throw new Error(result.error.message);
                                _state.label = 4;
                            case 4:
                                /**
         * @description
         * webhook通知〜クレジットカード登録の完了を待つため
         * 暫定的に sleep を加えている
         */ return [
                                    4,
                                    sleep(2000)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmitDeletePayment: function onSubmitDeletePayment() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePaymentSource().then(function() {
                                        return showMessage(t("deleteSuccess"));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
};
var ArtistMembershipPaymentEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembershipPaymentEdit_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* SubscriptionDetailFragmentDoc */.iAR);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPaymentEdit/index.tsx




/**
 * ArtistMembershipPaymentEdit Page
 * Implemented as a practical sample.
 */ var ArtistMembershipPaymentEdit = function() {
    var ref = ArtistMembershipPaymentEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPaymentEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/core/terms/index.ts
var terms = __webpack_require__(80321);
;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseConfirmation/template/index.tsx

















var ArtistMembershipPurchaseConfirmationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseConfirmation").t;
    var ref18 = (0,router_useRouter/* useRouter */.tv)(), router = ref18.router, generatePath = ref18.generatePath, routerNames = ref18.routerNames, routerPages = ref18.routerPages;
    var ref19 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref19.showMessage, showError = ref19.showError;
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        switch(router.query.status){
            case "cancel":
                showMessage(t("carrierCancel"));
                break;
            case "error":
                showError(t("carrierError"));
                break;
            default:
                break;
        }
    }, [
        router.query.status
    ]);
    var ref20;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistMembershipPurchaseConfirmation
            }),
            state.joined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipJoinedModal, {
                artistId: state.artistId
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("title"),
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "medium",
                        sx: {
                            ml: "-8px"
                        },
                        onClick: function() {
                            var ref;
                            return router.replace(generatePath(routerPages.ArtistMembershipPurchaseProceed, {
                                artistId: state.artistId,
                                productId: (ref20 = (ref = state.product) === null || ref === void 0 ? void 0 : ref.productId) !== null && ref20 !== void 0 ? ref20 : "#"
                            }));
                        }
                    })
                },
                children: [
                    state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_LoadingCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    bgcolor: "grey.50",
                                    px: 5,
                                    py: 2,
                                    mt: 2
                                },
                                color: "text.secondary",
                                children: t("plan", "プラン")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                gap: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        children: (ref = state.product) === null || ref === void 0 ? void 0 : ref.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "primary.main",
                                        children: t("".concat((ref1 = state.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.plan) === null || ref2 === void 0 ? void 0 : ref2.interval, "Course"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: t("".concat((ref3 = state.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.plan) === null || ref4 === void 0 ? void 0 : ref4.interval, "CoursePrice"), {
                                            amount: (ref5 = state.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.plan) === null || ref6 === void 0 ? void 0 : ref6.formattedAmount
                                        })
                                    })
                                ]
                            }),
                            state.favoriteMemberInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        sx: {
                                            bgcolor: "grey.50",
                                            px: 5,
                                            py: 2,
                                            mt: 2
                                        },
                                        color: "text.secondary",
                                        children: t("favoriteMember", "推しメンバー")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        spacing: 2,
                                        sx: {
                                            px: 5,
                                            pt: 4,
                                            pb: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: state.favoriteMemberInfo.avatar,
                                                    alt: "favorite member avatar",
                                                    sx: {
                                                        width: 64,
                                                        height: 64
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    children: state.favoriteMemberInfo.name
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    bgcolor: "grey.50",
                                    px: 5,
                                    py: 2,
                                    mt: 2
                                },
                                color: "text.secondary",
                                children: t("paymentInformation")
                            }),
                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("creditCard")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                                height: 25,
                                                src: (0,creditCard/* generateCreditCardLogoPath */.n)((ref7 = state.paymentSource) === null || ref7 === void 0 ? void 0 : ref7.brand),
                                                target: "common"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: t("last4Digits", {
                                                    number: (ref8 = state.paymentSource) === null || ref8 === void 0 ? void 0 : ref8.last4
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("".concat((ref9 = state.product) === null || ref9 === void 0 ? void 0 : ref9.plan.interval, "CreditCardNote"))
                                    })
                                ]
                            }),
                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.Au */.XL7.Au && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("au")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("carrierDesc")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("carrierDesc2")
                                    })
                                ]
                            }),
                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.Softbank */.XL7.Softbank && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("softbank")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("carrierDesc")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("carrierDesc2")
                                    })
                                ]
                            }),
                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.Docomo */.XL7.Docomo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("docomo")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("carrierDesc")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("carrierDesc2")
                                    })
                                ]
                            }),
                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("convenienceStore")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("convenienceStoreDesc")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("convenienceStoreDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    bgcolor: "grey.50",
                                    px: 5,
                                    py: 2,
                                    mt: 2
                                },
                                color: "text.secondary",
                                children: t("totalPaymentAmount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    p: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        sx: {
                                            py: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: t("".concat((ref10 = state.product) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.plan) === null || ref11 === void 0 ? void 0 : ref11.interval, "Fee"))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: [
                                                    "￥",
                                                    (ref12 = state.product) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.plan) === null || ref13 === void 0 ? void 0 : ref13.formattedAmount
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        sx: {
                                            py: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: t("total")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                children: [
                                                    "￥",
                                                    (ref14 = state.product) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.plan) === null || ref15 === void 0 ? void 0 : ref15.formattedAmount
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        gap: 2,
                                        children: [
                                            state.paymentMethod === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "caption",
                                                                children: "・"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "caption",
                                                                children: t("".concat((ref16 = state.product) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.plan) === null || ref17 === void 0 ? void 0 : ref17.interval, "NoteCreditCard1"))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "caption",
                                                                children: "・"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "caption",
                                                                children: t("noteCreditCard2")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: t("agreeTerm")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTextCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {
                                sx: {
                                    px: 5
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    pb: 8
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    size: "large",
                                    disabled: state.isSubmitting,
                                    loading: state.isSubmitting,
                                    sx: {
                                        width: 212
                                    },
                                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        onSubmit()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }),
                                    children: t("join", "加入する")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                        open: state.openRequire3DSecureModal,
                        onClose: onCloseRequire3DSecureModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                        open: state.openExpiredCardModal,
                        onClose: onCloseExpiredCardModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                        open: state.openPaymentErrorModal,
                        onClose: onClosePaymentErrorModal
                    })
                ]
            })
        ]
    });
};
var LinkTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembership").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        sx: {
            px: 5,
            py: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                component: "a",
                variant: "caption",
                underline: "none",
                target: "_blank",
                href: (0,terms/* termsOfServiceUrl */.o)(),
                children: t("termsOfService")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                component: "a",
                variant: "caption",
                target: "_blank",
                href: "https://about.utoniq.com/privacy-policy",
                underline: "none",
                sx: {
                    pt: 2
                },
                children: t("privacyPolicy")
            })
        ]
    });
};
var template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: "90dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseConfirmation/viewModel.ts





function ArtistMembershipPurchaseConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipPurchaseConfirmation($id: ID) {\n    artist(id: $id) {\n      id\n      ...ArtistMembershipSubscriptionDetail\n      ...ArtistWithPatron\n    }\n    user {\n      id\n      credit {\n        ...PaymentDetail\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMembershipPurchaseConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistMembershipPurchaseConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation StartSubscriptionProcess(\n    $artistId: ID!\n    $planId: ID!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n    $options: StartSubscriptionOptions\n  ) {\n    startSubscriptionProcess(\n      artistId: $artistId\n      planId: $planId\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n      options: $options\n    ) {\n      __typename\n      ... on PendingPurchaseItem {\n        id\n      }\n      ... on Patron {\n        id\n        isPersonalInformationRequired\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n"
    ]);
    ArtistMembershipPurchaseConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation StartPendinggSubscription(\n    $artistId: ID!\n    $planId: String!\n    $options: StartSubscriptionOptions\n  ) {\n    startPendinggSubscription(\n      artistId: $artistId\n      planId: $planId\n      options: $options\n    ) {\n      ... on PendingPurchaseItem {\n        id\n      }\n      ... on Patron {\n        id\n        artist {\n          id\n          pendingPurchasePatron {\n            id\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










/**
 *
 */ var ArtistMembershipPurchaseConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseConfirmation").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var ref3 = (0,react.useState)(), initialPlan = ref3[0], setInitialPlan = ref3[1];
    var ref4;
    var artistId = (ref4 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref4 !== void 0 ? ref4 : "#";
    var ref5 = (0,useQuery/* useQuery */.aM)(ArtistMembershipPurchaseConfirmation_viewModel_QUERY, {
        variables: {
            id: artistId
        }
    }), data = ref5.data, loading = ref5.loading;
    // 外部キャリア決済画面（escott）へのリダイレクト中かどうかを管理するフラグ
    // mutation の完了から escott フォーム送信までに
    // submit ボタンが活性化してしまうのを防ぐために用いている
    var ref6 = (0,react.useState)(false), isRedirectingToEscott = ref6[0], setIsRedirectingToEscott = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(START_SUBSCRIPTION_PROCESS, {
        onCompleted: function onCompleted(param) {
            var startSubscriptionProcess = param.startSubscriptionProcess;
            return (0,src_async_to_generator/* default */.Z)(function() {
                var _;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ = startSubscriptionProcess.__typename;
                            switch(_){
                                case "EscottMasterResult":
                                    return [
                                        3,
                                        1
                                    ];
                                case "Patron":
                                    return [
                                        3,
                                        2
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                            // 後続処理が外部画面とバックエンドで実行された後に
                            // ステータスに応じて escottInput で指定した画面に復帰する
                            (0,escott/* submitEscottForm */.uF)(startSubscriptionProcess.nextActionUrl, startSubscriptionProcess.parameter);
                            return [
                                3,
                                6
                            ];
                        case 2:
                            return [
                                4,
                                (0,storage/* removePrefernce */.Tq)("artistMembershipPurchaseInput")
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                (0,storage/* setRegisterNewMembership */.oj)()
                            ];
                        case 4:
                            _state.sent();
                            // 推しメンバー情報を削除
                            removeFavoriteMemberInfo();
                            if (startSubscriptionProcess === null || startSubscriptionProcess === void 0 ? void 0 : startSubscriptionProcess.isPersonalInformationRequired) {
                                router.replace(generatePath(routerPages.ArtistTop, {
                                    artistId: artistId
                                }));
                                return [
                                    2,
                                    showModal({
                                        showSnackbarWhenClose: true,
                                        isRegisterNewMembership: true
                                    })
                                ];
                            }
                            return [
                                2,
                                router.replace(generatePath(routerPages.ArtistMembershipCompletion, {
                                    artistId: artistId,
                                    productId: router.query.productId
                                }))
                            ];
                        case 5:
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), 2), startSubscriptionProcess = ref7[0], ref8 = ref7[1], startingSubscriptionProcess = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(START_PENDING_SUBSCRIPTION, {
        onCompleted: function onCompleted(param) {
            var startPendinggSubscription = param.startPendinggSubscription;
            return (0,src_async_to_generator/* default */.Z)(function() {
                var pendingPurchaseId, ref, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* removePrefernce */.Tq)("artistMembershipPurchaseInput")
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                (0,storage/* setRegisterNewMembership */.oj)()
                            ];
                        case 2:
                            _state.sent();
                            // 推しメンバー情報を削除
                            removeFavoriteMemberInfo();
                            pendingPurchaseId = startPendinggSubscription.id;
                            if ("artist" in startPendinggSubscription) {
                                ;
                                ;
                                pendingPurchaseId = (ref2 = (ref = startPendinggSubscription.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.pendingPurchasePatron) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "#";
                            }
                            return [
                                2,
                                router.replace(generatePath(routerPages.ArtistMembershipKonbiniCompletion, {
                                    artistId: artistId,
                                    productId: router.query.productId,
                                    pendingPurchaseId: pendingPurchaseId
                                }))
                            ];
                    }
                });
            })();
        }
    }), 2), startPendingSubscription = ref9[0], ref10 = ref9[1], startingPendingSubscription = ref10.loading;
    var product = (0,react.useMemo)(function() {
        var activeProduct = (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(data === null || data === void 0 ? void 0 : data.artist, initialPlan === null || initialPlan === void 0 ? void 0 : initialPlan.planId);
        if ((activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.productId) !== router.query.productId) {
            return;
        }
        return activeProduct;
    }, [
        data === null || data === void 0 ? void 0 : data.artist,
        initialPlan === null || initialPlan === void 0 ? void 0 : initialPlan.planId,
        router.query.productId
    ]);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("artistMembershipPurchaseInput")
                        ];
                    case 1:
                        v = _state.sent();
                        setInitialPlan({
                            interval: v.interval,
                            paymentMethod: v.paymentMethod,
                            planId: v.planId
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    // 外部キャリア決済画面（escott）からブラウザバックした際
    // リダイレクト中かどうかを管理するフラグをリセットする
    // ブラウザバック時に BFCache が効き再読み込みが走らない環境で
    // ローディング状態が解除されないことを防ぐ
    (0,escott/* useBFCacheRestore */.Hy)(function() {
        setIsRedirectingToEscott(false);
    });
    var ref11 = (0,react.useState)(false), openExpiredCardModal = ref11[0], setOpenExpiredCardModal = ref11[1];
    var ref12 = (0,react.useState)(false), openPaymentErrorModal = ref12[0], setOpenPaymentErrorModal = ref12[1];
    var ref13 = (0,react.useState)(false), openRequire3DSecureModal = ref13[0], setOpenRequire3DSecureModal = ref13[1];
    // 推しメンバー情報を取得
    var favoriteMemberInfo = (0,react.useMemo)(function() {
        try {
            var storedData = localStorage.getItem("artistMembershipFavoriteMembersSelect");
            if (storedData) {
                var parsedData = JSON.parse(storedData);
                return parsedData;
            }
        } catch (error) {
            showError(error);
        }
        return undefined;
    }, [
        artistId
    ]);
    // 推しメンバー情報を削除する関数
    var removeFavoriteMemberInfo = function() {
        try {
            localStorage.removeItem("artistMembershipFavoriteMembersSelect");
        } catch (error) {
            showError(error);
        }
    };
    var ref14;
    return {
        state: {
            loading: loading,
            artistId: artistId,
            product: product,
            paymentMethod: initialPlan === null || initialPlan === void 0 ? void 0 : initialPlan.paymentMethod,
            paymentSource: (ref14 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.credit) !== null && ref14 !== void 0 ? ref14 : null,
            favoriteMemberInfo: favoriteMemberInfo,
            isSubmitting: (initialPlan === null || initialPlan === void 0 ? void 0 : initialPlan.paymentMethod) !== undefined && (0,src_to_consumable_array/* default */.Z)(escott/* CARRIER_PAYMENT_METHODS */.K7).concat([
                utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
            ]).includes(initialPlan === null || initialPlan === void 0 ? void 0 : initialPlan.paymentMethod) ? startingSubscriptionProcess || isRedirectingToEscott : startingPendingSubscription,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal,
            joined: !!(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.patron)
        },
        actions: {
            onSubmit: function onSubmit() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!initialPlan) {
                                    return [
                                        2
                                    ];
                                }
                                if (!(initialPlan.paymentMethod === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    startSubscriptionProcess({
                                        variables: {
                                            artistId: artistId,
                                            planId: initialPlan.planId,
                                            options: favoriteMemberInfo ? {
                                                favoriteMemberId: favoriteMemberInfo.id
                                            } : undefined
                                        }
                                    }).catch(function(error) {
                                        var ref, ref1, ref2;
                                        switch((ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                            /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                                setOpenRequire3DSecureModal(true);
                                                return;
                                            /**
               * @description
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                                setOpenExpiredCardModal(true);
                                                return;
                                            /**
               * @description
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                                setOpenPaymentErrorModal(true);
                                                return;
                                            default:
                                                showError(error);
                                                break;
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                if (!(0,escott/* isCarrierPaymentMethod */.ln)(initialPlan.paymentMethod)) return [
                                    3,
                                    4
                                ];
                                setIsRedirectingToEscott(true);
                                return [
                                    4,
                                    startSubscriptionProcess({
                                        variables: {
                                            artistId: artistId,
                                            planId: initialPlan.planId,
                                            paymentMethod: initialPlan.paymentMethod,
                                            options: favoriteMemberInfo ? {
                                                favoriteMemberId: favoriteMemberInfo.id
                                            } : undefined,
                                            escottInput: {
                                                // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                                                successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembershipCompletion, {
                                                    artistId: artistId,
                                                    productId: router.query.productId
                                                })),
                                                // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                                                cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembershipPurchaseConfirmation, {
                                                    artistId: artistId,
                                                    productId: router.query.productId
                                                })),
                                                // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                                                errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistMembershipPurchaseConfirmation, {
                                                    artistId: artistId,
                                                    productId: router.query.productId
                                                }))
                                            }
                                        }
                                    }).catch(function(error) {
                                        var ref, ref1, ref2;
                                        switch((ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                            // メンバーシップが閉じられていた場合
                                            case constants/* constants.errorCodes.SUBSCRIPTION_PLAN_NOT_ACTIVE */._.errorCodes.SUBSCRIPTION_PLAN_NOT_ACTIVE:
                                                showError(t("subscriptionPlanNotActive"));
                                                break;
                                            default:
                                                showError(error);
                                                break;
                                        }
                                        setIsRedirectingToEscott(false);
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                // コンビニ払いの場合
                                return [
                                    4,
                                    startPendingSubscription({
                                        variables: {
                                            artistId: artistId,
                                            planId: initialPlan.planId,
                                            options: favoriteMemberInfo ? {
                                                favoriteMemberId: favoriteMemberInfo.id
                                            } : undefined
                                        }
                                    }).catch(showError)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
});
var ArtistMembershipPurchaseConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembershipPurchaseConfirmation_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9, utoniq_core_schema/* ArtistWithPatronFragmentDoc */.xsZ, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var START_SUBSCRIPTION_PROCESS = (0,lib/* gql */.Ps)(ArtistMembershipPurchaseConfirmation_viewModel_templateObject1());
var START_PENDING_SUBSCRIPTION = (0,lib/* gql */.Ps)(viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseConfirmation/index.tsx




/**
 * ArtistMembershipPurchaseConfirmation Page
 * Implemented as a practical sample.
 */ var ArtistMembershipPurchaseConfirmation = function() {
    var ref = ArtistMembershipPurchaseConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPurchaseConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/payment/CreditCardPayment/index.tsx






// クレジットカード決済のラジオボタン用のコンポーネント
var CreditCardPayment = function(param) {
    var paymentSource = param.paymentSource, goBackPath = param.goBackPath, _queryParams = param.queryParams, queryParams = _queryParams === void 0 ? {} : _queryParams, onNavigate = param.onNavigate;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseProceed").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var handleRegister = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var path;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate()
                        ];
                    case 1:
                        _state.sent();
                        path = generatePath(goBackPath, queryParams);
                        router.push(routerPages.PaymentMethodSetting, {
                            goBackPath: path
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRegister() {
            return _ref.apply(this, arguments);
        };
    }();
    if (paymentSource) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("creditCard", "クレジットカード決済")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                            height: 25,
                            src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource.brand),
                            target: "common"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("last4Digits", {
                                number: paymentSource.last4
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("creditCard", "クレジットカード決済")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        color: "primary",
                        onClick: handleRegister,
                        children: t("register", "登録")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.hint",
                children: t("creditCardNotRegistered", "支払い情報が登録されていません")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/payment/CarrierPaymentOption/index.tsx


// キャリア決済のラジオボタン用のコンポーネント
var CarrierPaymentOption = function(param) {
    var carrier = param.carrier;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: carrier
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseProceed/template/ArtistMembershipPurchaseForm.tsx












var ArtistMembershipPurchaseForm_schema = function(o) {
    return {
        interval: o.string(),
        paymentMethod: o.string()
    };
};
var ArtistMembershipPurchaseForm = function(param) {
    var plans = param.plans, initialPlan = param.initialPlan, paymentSource = param.paymentSource, paymentFees = param.paymentFees, onSubmit = param.onSubmit, enableMembershipCarrierPayment = param.enableMembershipCarrierPayment;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseProceed").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: ArtistMembershipPurchaseForm_schema,
        defaultValues: ArtistMembershipPurchaseForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, isSubmitting = ref1.formState.isSubmitting, watch = ref1.watch, setValue = ref1.setValue, reset = ref1.reset;
    var intervalWatch = watch("interval");
    var paymentMethodWatch = watch("paymentMethod");
    (0,react.useEffect)(function() {
        if (!plans.length) {
            return;
        }
        var yearPlan = plans.find(function(plan) {
            return plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year;
        });
        if (!yearPlan) {
            reset({
                interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month,
                paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
            });
        }
    }, [
        plans
    ]);
    (0,react.useEffect)(function() {
        if (initialPlan) {
            reset(initialPlan);
        }
    }, [
        initialPlan
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                pb: 5,
                pt: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        color: "text.secondary",
                        children: t("course")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        value: intervalWatch,
                        onChange: function(event, value) {
                            handleLoginModal(function() {
                                setValue("interval", value, {
                                    shouldValidate: true
                                });
                                if (value === "month") {
                                    setValue("paymentMethod", utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard);
                                }
                            })(event);
                        },
                        sx: {
                            gap: function(theme) {
                                return theme.spacing(4);
                            },
                            px: 5
                        },
                        children: plans.map(function(plan, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: plan.interval,
                                        checked: intervalWatch === plan.interval,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h5",
                                                    children: t("".concat(plan.interval, "Course"))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            children: t("".concat(plan.interval, "CoursePrice"), {
                                                                amount: plan.formattedAmount
                                                            })
                                                        }),
                                                        plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "body2",
                                                            children: [
                                                                "(",
                                                                t("monthCoursePrice", {
                                                                    amount: numeral_default()(Math.ceil(plan.amount / 12)).format("0,0")
                                                                }),
                                                                ")"
                                                            ]
                                                        }),
                                                        plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year && !!plan.annualDiscountText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle2",
                                                            color: "primary.main",
                                                            sx: {
                                                                ml: 1
                                                            },
                                                            children: plan.annualDiscountText
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    plans.length - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                ]
                            }, plan.interval);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                pb: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        color: "text.secondary",
                        children: t("method", "支払い方法")
                    }),
                    intervalWatch === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                        value: paymentMethodWatch,
                        onChange: function(event, value) {
                            handleLoginModal(function() {
                                setValue("paymentMethod", value, {
                                    shouldValidate: true
                                });
                            })(event);
                        },
                        sx: {
                            gap: function(theme) {
                                return theme.spacing(4);
                            },
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardPayment, {
                                    paymentSource: paymentSource,
                                    goBackPath: routerPages.ArtistMembershipPurchaseProceed,
                                    queryParams: {
                                        artistId: (ref2 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref2 !== void 0 ? ref2 : "#",
                                        productId: router.query.productId
                                    }
                                })
                            }),
                            enableMembershipCarrierPayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h5",
                                                children: t("carrier", "キャリア決済")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    pt: 2
                                                },
                                                children: t("carrierDesc", "携帯料金と一緒にお支払いできます")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                value: utoniq_core_schema/* PaymentMethod.Au */.XL7.Au,
                                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Au */.XL7.Au,
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                                    carrier: t("au", "au")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                value: utoniq_core_schema/* PaymentMethod.Softbank */.XL7.Softbank,
                                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Softbank */.XL7.Softbank,
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                                    carrier: t("softbank", "Softbank")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                value: utoniq_core_schema/* PaymentMethod.Docomo */.XL7.Docomo,
                                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Docomo */.XL7.Docomo,
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                                    carrier: t("docomo", "docomo")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : // 年払いの場合クレジットカード決済もしくはコンビニ決済が選択できる
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                        value: paymentMethodWatch,
                        onChange: function(event, value) {
                            handleLoginModal(function() {
                                setValue("paymentMethod", value, {
                                    shouldValidate: true
                                });
                            })(event);
                        },
                        sx: {
                            gap: function(theme) {
                                return theme.spacing(4);
                            },
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardPayment, {
                                    paymentSource: paymentSource,
                                    goBackPath: routerPages.ArtistMembershipPurchaseProceed,
                                    queryParams: {
                                        artistId: (ref3 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref3 !== void 0 ? ref3 : "#",
                                        productId: router.query.productId
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(KonbiniPayment, {
                                    paymentFees: paymentFees
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {
                sx: {
                    px: 5
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    my: 5
                },
                alignItems: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        disabled: isSubmitting || paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && !paymentSource,
                        loading: isSubmitting,
                        sx: {
                            width: 212
                        },
                        onClick: handleOnSubmit,
                        children: t("submit", "確認画面に進む")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        size: "small",
                        sx: {
                            width: 212
                        },
                        onClick: function() {
                            return router.goBack();
                        },
                        children: t("back", "戻る")
                    })
                ]
            })
        ]
    });
};
var KonbiniPayment = function(param) {
    var paymentFees = param.paymentFees;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseProceed").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    children: t("convenienceStore", "コンビニ決済")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                children: t("convenienceStoreDesc", "ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: t("convenienceStoreDesc2", "※コンビニ決済の振り込み期限は7日間となります。")
            })
        ]
    });
};
var ArtistMembershipPurchaseForm_defaultValues = {
    interval: utoniq_core_schema/* MembershipInterval.Year */.ls9.Year,
    paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseProceed/template/index.tsx









var ArtistMembershipPurchaseProceedTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMembershipPurchaseProceed").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistMembershipPurchaseProceed
            }),
            state.joined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipJoinedModal, {
                artistId: state.artistId
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    title: t("title", "支払い方法を選択")
                },
                children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPurchaseProceed_template_LoadingCell, {}) : !!state.plans.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPurchaseForm, {
                    plans: state.plans,
                    initialPlan: state === null || state === void 0 ? void 0 : state.initialPlan,
                    paymentSource: state.paymentSource,
                    paymentFees: state.paymentFees,
                    onSubmit: onSubmit,
                    enableMembershipCarrierPayment: state.enableMembershipCarrierPayment
                })
            })
        ]
    });
};
var ArtistMembershipPurchaseProceed_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: "90dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseProceed/viewModel.ts





function ArtistMembershipPurchaseProceed_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMembershipPurchaseProceed($id: ID) {\n    artist(id: $id) {\n      id\n      ...ArtistMembershipSubscriptionDetail\n      ...ArtistWithPatron\n    }\n    user {\n      id\n      credit {\n        ...PaymentDetail\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMembershipPurchaseProceed_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 *
 */ var ArtistMembershipPurchaseProceed_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var ref7 = (0,react.useState)(), initialPlan = ref7[0], setInitialPlan = ref7[1];
    var ref8;
    var artistId = (ref8 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref8 !== void 0 ? ref8 : "#";
    var ref9 = (0,useQuery/* useQuery */.aM)(ArtistMembershipPurchaseProceed_viewModel_QUERY, {
        variables: {
            id: artistId
        }
    }), data = ref9.data, loading = ref9.loading;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            return [];
        }
        var product = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.products.find(function(param) {
            var productId = param.productId;
            return router.query.productId === productId;
        });
        if (!product || !((ref5 = product.plans) === null || ref5 === void 0 ? void 0 : ref5.length)) {
            return [];
        }
        var _formattedAmount, _annualDiscountText;
        return orderBy_default()(product.plans.map(function(plan) {
            return {
                interval: plan.interval,
                amount: plan.amount,
                formattedAmount: (_formattedAmount = plan.formattedAmount) !== null && _formattedAmount !== void 0 ? _formattedAmount : "0",
                annualDiscountText: (_annualDiscountText = product.annualDiscountText) !== null && _annualDiscountText !== void 0 ? _annualDiscountText : "",
                planId: plan.planId
            };
        }), [
            "interval"
        ], [
            "desc"
        ]);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.products,
        router.query.productId
    ]);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("artistMembershipPurchaseInput")
                        ];
                    case 1:
                        v = _state.sent();
                        if (!(plans === null || plans === void 0 ? void 0 : plans.find(function(plan) {
                            return plan.planId === v.planId;
                        }))) return [
                            3,
                            3
                        ];
                        setInitialPlan({
                            interval: v.interval,
                            paymentMethod: v.paymentMethod
                        });
                        return [
                            4,
                            (0,storage/* removePrefernce */.Tq)("artistMembershipPurchaseInput")
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        plans
    ]);
    var ref10;
    return {
        state: {
            loading: loading,
            artistId: artistId,
            plans: plans,
            paymentSource: (ref10 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.credit) !== null && ref10 !== void 0 ? ref10 : null,
            paymentFees: null,
            initialPlan: initialPlan,
            /** アーティスト毎に設定されているメンバーシップのキャリア決済加入が有効かどうか */ enableMembershipCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.carrierPayment),
            joined: !!(data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : ref5.patron)
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, planId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                planId = (ref = plans === null || plans === void 0 ? void 0 : plans.find(function(plan) {
                                    return plan.interval === values.interval;
                                })) === null || ref === void 0 ? void 0 : ref.planId;
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("artistMembershipPurchaseInput", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                                        planId: planId
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    router.replace(generatePath(routerPages.ArtistMembershipPurchaseConfirmation, {
                                        artistId: artistId,
                                        productId: router.query.productId
                                    }))
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistMembershipPurchaseProceed_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMembershipPurchaseProceed_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9, utoniq_core_schema/* ArtistWithPatronFragmentDoc */.xsZ, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMembershipPurchaseProceed/index.tsx




/**
 * ArtistMembershipPurchaseProceed Page
 * Implemented as a practical sample.
 */ var ArtistMembershipPurchaseProceed = function() {
    var ref = ArtistMembershipPurchaseProceed_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMembershipPurchaseProceedTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/mission/MissionBoxSkeleton/index.tsx




var MissionBoxSkeleton = function(param) {
    var fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2,
            width: fullWidth ? "100%" : 315
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "50%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 48,
                        height: 76
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/mission/MissionLabel/index.tsx





var MissionLabel = function(param) {
    var label = param.label, sx = param.sx;
    switch(label){
        case utoniq_core_schema/* MissionLabel.Clear */.lH5.Clear:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionText, {
                    text: "clear",
                    sx: {
                        color: "black"
                    }
                }),
                size: "small",
                sx: (0,src_object_spread/* default */.Z)({
                    backgroundColor: "secondary.main"
                }, sx)
            });
        case utoniq_core_schema/* MissionLabel.Expired */.lH5.Expired:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionText, {
                    text: "expired",
                    sx: {
                        color: "text.secondary"
                    }
                }),
                size: "small",
                sx: (0,src_object_spread/* default */.Z)({
                    backgroundColor: "grey.100"
                }, sx)
            });
        case utoniq_core_schema/* MissionLabel.New */.lH5.New:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionText, {
                    text: "new",
                    sx: {
                        color: "white"
                    }
                }),
                size: "small",
                sx: (0,src_object_spread/* default */.Z)({
                    backgroundColor: "warning.main",
                    borderRadius: "100px",
                    pr: "12px",
                    pl: "12px",
                    height: "20px"
                }, sx)
            });
        default:
            return null;
    }
};
var MissionText = function(param) {
    var text = param.text, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        variant: "subtitle2",
        sx: sx,
        children: t(text)
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/mission/MissionBox/index.tsx







var MissionBox = function(param) {
    var artistId = param.artistId, mission = param.mission, sx = param.sx, fullWidth = param.fullWidth, withArtistName = param.withArtistName, onClick = param.onClick;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref9.generatePath, routerPages = ref9.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    var _label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: (0,src_object_spread/* default */.Z)({
            mt: 3,
            position: "relative",
            width: fullWidth ? "100%" : 315,
            overflow: "visible",
            borderRadius: 2,
            backgroundImage: "none",
            bgcolor: "grey.50"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionLabel, {
                label: (_label = mission.label) !== null && _label !== void 0 ? _label : null,
                sx: {
                    position: "absolute",
                    top: -10,
                    left: 20,
                    zIndex: 1,
                    width: 72,
                    height: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    p: 5,
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    borderRadius: 2
                },
                href: artistId ? generatePath(routerPages.ArtistMissionDetail, {
                    missionId: mission === null || mission === void 0 ? void 0 : mission.id,
                    artistId: artistId
                }) : generatePath(routerPages.MissionDetail, {
                    missionId: mission === null || mission === void 0 ? void 0 : mission.id
                }),
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                        component: Stack_Stack/* default */.Z,
                        flex: 1,
                        sx: {
                            p: 0,
                            pr: 4,
                            overflow: "hidden"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        sx: {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap"
                                        },
                                        variant: "h5",
                                        children: mission.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            wordBreak: "break-all"
                                        }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                        children: mission.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            pt: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                label: t("".concat(mission === null || mission === void 0 ? void 0 : mission.type)),
                                                size: "small",
                                                sx: {
                                                    borderRadius: 1,
                                                    typography: "overline",
                                                    bgcolor: "grey.100",
                                                    color: "text.secondary"
                                                }
                                            }),
                                            mission.gpsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                label: "CHECK-IN",
                                                size: "small",
                                                sx: {
                                                    ml: 2,
                                                    borderRadius: 1,
                                                    typography: "overline",
                                                    bgcolor: "warning.dark",
                                                    color: "white"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            withArtistName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "right",
                                color: "#798a94",
                                children: (ref = mission.artist) === null || ref === void 0 ? void 0 : ref.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "x-small",
                        src: ((ref4 = mission === null || mission === void 0 ? void 0 : (ref1 = mission.reward) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.thumbnail.front) === null || ref4 === void 0 ? void 0 : ref4.smallUri) || ((ref7 = mission === null || mission === void 0 ? void 0 : (ref5 = mission.reward) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.gachaTicket) === null || ref6 === void 0 ? void 0 : ref6.gachaTicket.thumbnails) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.reward) === null || ref8 === void 0 ? void 0 : ref8.smallUri) || ""
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Modal/Modal.js + 1 modules
var Modal_Modal = __webpack_require__(41883);
;// CONCATENATED MODULE: ./src/components/organisms/mission/StepMissionBox/index.tsx













var StepMissionBox = function(param) {
    var mission = param.mission, onGetStepMissionReward = param.onGetStepMissionReward;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMissions").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), openModal = ref2[0], setOpenModal = ref2[1];
    var ref3;
    var count = (ref3 = mission === null || mission === void 0 ? void 0 : mission.progress) !== null && ref3 !== void 0 ? ref3 : 0;
    var ref4;
    var totalCount = (ref4 = mission === null || mission === void 0 ? void 0 : (ref = mission.step) === null || ref === void 0 ? void 0 : ref.requiredCount) !== null && ref4 !== void 0 ? ref4 : 0;
    var isAcquirable = mission.isAccomplished && !mission.isRewardReceived;
    var handleOnGet = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    return [
                        4,
                        onGetStepMissionReward((ref = mission === null || mission === void 0 ? void 0 : mission.id) !== null && ref !== void 0 ? ref : "").then(function() {
                            setOpenModal(true);
                            analytics && analytics.track("receive_reward", {
                                id: mission === null || mission === void 0 ? void 0 : mission.id,
                                artistId: mission === null || mission === void 0 ? void 0 : mission.artistId,
                                type: mission === null || mission === void 0 ? void 0 : mission.type
                            });
                        }).catch(showError).finally(function() {
                            return setLoading(false);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onGetStepMissionReward,
        showError,
        mission === null || mission === void 0 ? void 0 : mission.id
    ]);
    var _label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            mt: 3,
            position: "relative",
            overflow: "visible",
            borderRadius: 2,
            bgcolor: "grey.50"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionLabel, {
                label: (_label = mission.label) !== null && _label !== void 0 ? _label : null,
                sx: {
                    position: "absolute",
                    top: -10,
                    left: 20,
                    zIndex: 1,
                    width: 72,
                    height: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    width: "100%",
                    px: 5,
                    pb: 4,
                    "&:last-child": {
                        pb: 4
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: "1fr auto",
                            gap: "16px 12px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: (0,src_object_spread/* default */.Z)({
                                        width: "100%",
                                        wordBreak: "break-all"
                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                    variant: "h5",
                                    children: getStepMissionTitleByType(mission, t)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepMissionRewardContent, {
                                stepMission: mission
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionIndicator, {
                                    itemCount: count,
                                    totalCount: totalCount,
                                    sx: {
                                        mx: 0,
                                        py: 2
                                    },
                                    successColor: "secondary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: isAcquirable ? "outlined" : "contained",
                                    disabled: !isAcquirable,
                                    onClick: handleOnGet,
                                    loading: loading,
                                    children: t(mission.isRewardReceived ? "earned" : "get")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStepMissionRewardModal, {
                        open: openModal,
                        onClose: function() {
                            return setOpenModal(false);
                        },
                        stepMission: mission
                    })
                ]
            })
        ]
    });
};
var GetStepMissionRewardModal = function(param) {
    var open = param.open, onClose = param.onClose, stepMission = param.stepMission;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMissions").t;
    var RewardContent = function(param) {
        var stepMission = param.stepMission;
        var ref, ref1;
        switch(stepMission === null || stepMission === void 0 ? void 0 : (ref = stepMission.step) === null || ref === void 0 ? void 0 : (ref1 = ref.reward) === null || ref1 === void 0 ? void 0 : ref1.type){
            case utoniq_core_schema/* StepMissionRewardType.PrepaidPoint */.vZX.PrepaidPoint:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                    sx: {
                        fontSize: "80px"
                    }
                });
            case utoniq_core_schema/* StepMissionRewardType.GachaTicket */.vZX.GachaTicket:
                var ref2, ref3, ref4, ref5, ref6, ref7;
                var ref8;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    component: "img",
                    style: {
                        width: 80,
                        height: 80
                    },
                    src: (ref8 = stepMission === null || stepMission === void 0 ? void 0 : (ref2 = stepMission.step) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reward) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gachaTicket) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.thumbnails) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.reward) === null || ref7 === void 0 ? void 0 : ref7.smallUri) !== null && ref8 !== void 0 ? ref8 : ""
                });
            case utoniq_core_schema/* StepMissionRewardType.Item */.vZX.Item:
                var ref9, ref10, ref11, ref12, ref13, ref14;
                var ref15;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    size: "small",
                    src: (ref15 = stepMission === null || stepMission === void 0 ? void 0 : (ref9 = stepMission.step) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.reward) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.metadata) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.thumbnail) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.front) === null || ref14 === void 0 ? void 0 : ref14.smallUri) !== null && ref15 !== void 0 ? ref15 : ""
                });
            case utoniq_core_schema/* StepMissionRewardType.ArtistPoint */.vZX.ArtistPoint:
                return null;
            default:
                return null;
        }
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                width: 264,
                borderRadius: 3,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "grey.100",
                outline: "none",
                textAlign: "center",
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        px: 6,
                        pt: 6,
                        backgroundImage: "url(".concat(config_config/* config.commonStorageUrl */.v.commonStorageUrl, "images/bonus/loginbonus_bg_anime.png)"),
                        backgroundPosition: "center",
                        backgroundSize: "cover"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                position: "relative",
                                height: "fit-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "grid",
                                        placeItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                        width: "100%",
                                        target: "common",
                                        src: "images/bonus/loginbonus_title_bg.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            top: 4,
                                            width: "100%",
                                            height: "100%",
                                            display: "grid",
                                            placeItems: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            textAlign: "center",
                                            variant: "h5",
                                            sx: {
                                                height: "100%",
                                                color: "white",
                                                pt: "2px"
                                            },
                                            children: t("missionAccomplishedTitle")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardContent, {
                                    stepMission: stepMission
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        bgcolor: "grey.100",
                                        borderRadius: 100,
                                        minWidth: 64,
                                        mt: 2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        textAlign: "center",
                                        children: [
                                            "\xd7",
                                            (ref4 = stepMission === null || stepMission === void 0 ? void 0 : (ref = stepMission.step) === null || ref === void 0 ? void 0 : (ref1 = ref.reward) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref4 !== void 0 ? ref4 : 0
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    color: "white",
                                    sx: {
                                        pt: 3,
                                        pb: 4
                                    },
                                    children: t("stepMissionAccomplishedDesc.".concat(stepMission === null || stepMission === void 0 ? void 0 : (ref2 = stepMission.step) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reward) === null || ref3 === void 0 ? void 0 : ref3.type))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        py: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: onClose,
                        children: t("close")
                    })
                })
            ]
        })
    });
};
var getStepMissionTitleByType = function(stepMission, t) {
    switch(stepMission === null || stepMission === void 0 ? void 0 : stepMission.type){
        case utoniq_core_schema/* StepMissionType.SumCardsets */.pkj.SumCardsets:
            var ref;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.SumCardsets */.pkj.SumCardsets), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref = stepMission.step) === null || ref === void 0 ? void 0 : ref.requiredCount
            });
        case utoniq_core_schema/* StepMissionType.SumRarities */.pkj.SumRarities:
            var ref1;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.SumRarities */.pkj.SumRarities), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref1 = stepMission.step) === null || ref1 === void 0 ? void 0 : ref1.requiredCount
            });
        case utoniq_core_schema/* StepMissionType.SumComments */.pkj.SumComments:
            var ref2;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.SumComments */.pkj.SumComments), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref2 = stepMission.step) === null || ref2 === void 0 ? void 0 : ref2.requiredCount
            });
        case utoniq_core_schema/* StepMissionType.SumTrades */.pkj.SumTrades:
            var ref3;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.SumTrades */.pkj.SumTrades), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref3 = stepMission.step) === null || ref3 === void 0 ? void 0 : ref3.requiredCount
            });
        case utoniq_core_schema/* StepMissionType.CompletesCollections */.pkj.CompletesCollections:
            var ref4;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.CompletesCollections */.pkj.CompletesCollections), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref4 = stepMission.step) === null || ref4 === void 0 ? void 0 : ref4.requiredCount
            });
        case utoniq_core_schema/* StepMissionType.ContinuousMembership */.pkj.ContinuousMembership:
            var ref5;
            return t("stepMissionTitle.".concat(utoniq_core_schema/* StepMissionType.ContinuousMembership */.pkj.ContinuousMembership), {
                requiredCount: stepMission === null || stepMission === void 0 ? void 0 : (ref5 = stepMission.step) === null || ref5 === void 0 ? void 0 : ref5.requiredCount
            });
        default:
            return null;
    }
};
var StepMissionRewardContent = function(param) {
    var stepMission = param.stepMission;
    var ref, ref1;
    switch(stepMission === null || stepMission === void 0 ? void 0 : (ref = stepMission.step) === null || ref === void 0 ? void 0 : (ref1 = ref.reward) === null || ref1 === void 0 ? void 0 : ref1.type){
        case utoniq_core_schema/* StepMissionRewardType.PrepaidPoint */.vZX.PrepaidPoint:
            var ref2, ref3;
            var ref4;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                        sx: {
                            fontSize: "48px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        align: "center",
                        variant: "subtitle2",
                        sx: {
                            width: 56,
                            borderRadius: "100px",
                            bgcolor: "grey.100",
                            mt: -2
                        },
                        children: [
                            "\xd7",
                            (ref4 = stepMission === null || stepMission === void 0 ? void 0 : (ref2 = stepMission.step) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reward) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : 0
                        ]
                    })
                ]
            });
        case utoniq_core_schema/* StepMissionRewardType.GachaTicket */.vZX.GachaTicket:
            var ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            var ref13, ref14;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "img",
                        style: {
                            width: 48,
                            height: 48
                        },
                        src: (ref13 = stepMission === null || stepMission === void 0 ? void 0 : (ref5 = stepMission.step) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.reward) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.metadata) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gachaTicket) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnails) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.reward) === null || ref10 === void 0 ? void 0 : ref10.smallUri) !== null && ref13 !== void 0 ? ref13 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        align: "center",
                        variant: "subtitle2",
                        sx: {
                            width: 56,
                            borderRadius: "100px",
                            bgcolor: "grey.100",
                            mt: -2
                        },
                        children: [
                            "\xd7",
                            (ref14 = stepMission === null || stepMission === void 0 ? void 0 : (ref11 = stepMission.step) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.reward) === null || ref12 === void 0 ? void 0 : ref12.value) !== null && ref14 !== void 0 ? ref14 : 0
                        ]
                    })
                ]
            });
        case utoniq_core_schema/* StepMissionRewardType.Item */.vZX.Item:
            var ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
            var ref23, ref24;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "x-small",
                        src: (ref23 = stepMission === null || stepMission === void 0 ? void 0 : (ref15 = stepMission.step) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.reward) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.metadata) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.thumbnail) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.front) === null || ref20 === void 0 ? void 0 : ref20.smallUri) !== null && ref23 !== void 0 ? ref23 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        align: "center",
                        variant: "subtitle2",
                        sx: {
                            width: 56,
                            borderRadius: "100px",
                            bgcolor: "grey.100",
                            mt: -2,
                            zIndex: 1
                        },
                        children: [
                            "\xd7",
                            (ref24 = stepMission === null || stepMission === void 0 ? void 0 : (ref21 = stepMission.step) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.reward) === null || ref22 === void 0 ? void 0 : ref22.value) !== null && ref24 !== void 0 ? ref24 : 0
                        ]
                    })
                ]
            });
        case utoniq_core_schema/* StepMissionRewardType.ArtistPoint */.vZX.ArtistPoint:
            return null;
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMissions/template/index.tsx















var ArtistMissionsTemplate = function(param) {
    var state = param.state, // onFilterArtistMission,
    onFetchMoreArtistMissions = param.onFetchMoreArtistMissions, onGetStepMissionReward = param.onGetStepMissionReward, onFetchMoreStepMission = param.onFetchMoreStepMission;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMissions").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref4 = (0,react.useState)(false), openSideMenu = ref4[0], setOpenSideMenu = ref4[1];
    var ref5 = (0,react.useState)(false), drawerIsOpen = ref5[0], setDrawerIsOpen = ref5[1];
    var ref6 = (0,react.useState)(0), currentTab = ref6[0], setCurrentTab = ref6[1];
    var handleFetchMore = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onFetchMoreArtistMissions([
                                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFetchMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTabChange = (0,react.useCallback)(function(value) {
        setCurrentTab(value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    isLive: !!state.liveStreamId,
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                }
            },
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    color: "icon.line",
                    bgcolor: "icon.background",
                    badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasManagementTask) || !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.unreadNotificationCount)
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistMissions,
                        state.artistName
                    ]
                }),
                (config_config/* config.applicationKey */.v.applicationKey === "diica" || config_config/* config.environment */.v.environment !== "production") && state.user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                    labels: [
                        t("event"),
                        t("accomplishment")
                    ],
                    value: currentTab,
                    disableAnimateTransitions: true,
                    onChange: handleTabChange,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionsCell, {
                            artistId: state.artistId,
                            missions: state.missions,
                            loading: state.fetching,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: handleFetchMore
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepMissionsCell, {
                            artistStepMissions: state.artistStepMissions,
                            loading: state.fetching,
                            hasNextPage: state.hasNextPageArtistStepMission,
                            onGetStepMissionReward: onGetStepMissionReward,
                            onFetchMore: onFetchMoreStepMission
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionsCell, {
                    missions: state.missions,
                    artistId: state.artistId,
                    loading: state.fetching,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: handleFetchMore
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                })
            ]
        })
    });
};
var MissionsCell = function(param) {
    var artistId = param.artistId, missions = param.missions, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMissions").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            onFetchMore: onFetchMore,
            hasNextPage: hasNextPage,
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 6,
                sx: {
                    py: 4
                },
                children: Array.from(Array(5).keys()).map(function(i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBoxSkeleton, {
                        fullWidth: true
                    }, i);
                })
            }),
            nodes: missions === null || missions === void 0 ? void 0 : missions.edges.map(function(param) {
                var node = param.node;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBox, {
                    fullWidth: true,
                    mission: node,
                    artistId: artistId
                }, node.id);
            }),
            emptyMessage: t("missionEmptyMessage")
        })
    });
};
var StepMissionsCell = function(param) {
    var artistStepMissions = param.artistStepMissions, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, onGetStepMissionReward = param.onGetStepMissionReward;
    var t = (0,core_i18n/* useTranslation */.$G)("artistMissions").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            onFetchMore: onFetchMore,
            hasNextPage: hasNextPage,
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 6,
                sx: {
                    py: 4
                },
                children: Array.from(Array(5).keys()).map(function(i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBoxSkeleton, {
                        fullWidth: true
                    }, i);
                })
            }),
            nodes: artistStepMissions === null || artistStepMissions === void 0 ? void 0 : artistStepMissions.edges.map(function(param) {
                var node = param.node;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepMissionBox, {
                    mission: node,
                    onGetStepMissionReward: onGetStepMissionReward
                }, node.id);
            }),
            emptyMessage: t("missionEmptyMessage")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMissions/viewModel.ts




function ArtistMissions_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMissions(\n    $missionsTypeFilter: [MissionType!]\n    $missionsPageInput: PageInput\n    $missionsArtistId: ID!\n    $stepMissionsType: StepMissionType\n    $stepMissionsFilter: StepMissionFilter\n    $stepMissionsPageInput: PageInput\n  ) {\n    user {\n      ...CurrentUser\n    }\n    missionsWithFilteres(\n      typeFilter: $missionsTypeFilter\n      pageInput: $missionsPageInput\n      artistId: $missionsArtistId\n    ) {\n      ...MissionsConnection\n    }\n    artist(id: $missionsArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    artistStepMissions(\n      artistId: $missionsArtistId\n      type: $stepMissionsType\n      filter: $stepMissionsFilter\n      pageInput: $stepMissionsPageInput\n    ) {\n      ...UserStepMissionsConnection\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMissions_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistMissions_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMissionsForGuest(\n    $missionsTypeFilter: [MissionType!]\n    $missionsPageInput: PageInput\n    $missionsArtistId: ID!\n  ) {\n    missionsWithFilteres(\n      typeFilter: $missionsTypeFilter\n      pageInput: $missionsPageInput\n      artistId: $missionsArtistId\n    ) {\n      ...MissionsConnection\n    }\n    artist(id: $missionsArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMissions_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistMissions_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistMissions(\n    $missionsTypeFilter: [MissionType!]\n    $missionsPageInput: PageInput\n    $missionsArtistId: ID!\n  ) {\n    artist(id: $missionsArtistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    missionsWithFilteres(\n      typeFilter: $missionsTypeFilter\n      pageInput: $missionsPageInput\n      artistId: $missionsArtistId\n    ) {\n      ...MissionsConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistMissions_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GetStepMissionReward($stepMissionId: String!) {\n    getStepMissionReward(stepMissionId: $stepMissionId) {\n      ...UserStepMissionBox\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var ArtistMissions_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var ref13 = (0,auth/* useCurrentUser */.xJ)(), user = ref13.user, userClaims = ref13.userClaims;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_MISSIONS,
        variables: {
            missionsArtistId: artistId,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        fields: [
            {
                fragmentName: "MissionBox",
                fieldName: "missionsWithFilteres",
                fragment: utoniq_core_schema/* MissionBoxFragmentDoc */.zID
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref14 = (0,useQuery/* useQuery */.aM)(ArtistMissions_viewModel_QUERY, {
        variables: {
            missionsArtistId: artistId,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        skip: !user,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref14.data, refetch = ref14.refetch, fetchMore = ref14.fetchMore, networkStatus = ref14.networkStatus, loading = ref14.loading;
    var ref15 = (0,useQuery/* useQuery */.aM)(viewModel_QUERY_FOR_GUEST, {
        variables: {
            missionsArtistId: artistId,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        skip: !!user,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), dataGuest = ref15.data, refetchGurest = ref15.refetch, fetchMoreGurest = ref15.fetchMore, loadingGurest = ref15.loading, networkStatusGurest = ref15.networkStatus;
    var isNextFetch = !!(data || dataGuest);
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GET_STEP_MISSION_REWARD), 1), getStepMissionReward = ref16[0];
    var ref17, ref18, ref19, ref20, ref21;
    return {
        state: {
            loading: (loadingGurest || loading) && !isNextFetch,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore || networkStatusGurest === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            artistName: ((ref = data || dataGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName) || "",
            hasNextPage: !!((ref2 = data || dataGuest) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.missionsWithFilteres) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.hasNextPage),
            hasNextPageArtistStepMission: !!(data === null || data === void 0 ? void 0 : (ref4 = data.artistStepMissions) === null || ref4 === void 0 ? void 0 : ref4.pageInfo.hasNextPage),
            missions: (ref17 = (ref5 = data || dataGuest) === null || ref5 === void 0 ? void 0 : ref5.missionsWithFilteres) !== null && ref17 !== void 0 ? ref17 : null,
            user: (ref18 = data === null || data === void 0 ? void 0 : data.user) !== null && ref18 !== void 0 ? ref18 : null,
            artistId: artistId,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref6 = userClaims.orgs) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[config_config/* config.organizationId */.v.organizationId]) === null || ref7 === void 0 ? void 0 : ref7.artist),
            followArtists: (ref19 = data === null || data === void 0 ? void 0 : (ref8 = data.user) === null || ref8 === void 0 ? void 0 : ref8.organizationFollowees) !== null && ref19 !== void 0 ? ref19 : null,
            memberArtists: (ref20 = data === null || data === void 0 ? void 0 : (ref9 = data.user) === null || ref9 === void 0 ? void 0 : ref9.organizationPatrons) !== null && ref20 !== void 0 ? ref20 : null,
            liveStreamId: (ref10 = data || dataGuest) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.artist) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.currentLive) === null || ref12 === void 0 ? void 0 : ref12.id,
            artistStepMissions: (ref21 = data === null || data === void 0 ? void 0 : data.artistStepMissions) !== null && ref21 !== void 0 ? ref21 : null
        },
        actions: {
            onFilterArtistMission: function onFilterArtistMission(missionTypes) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetch({
                                        missionsArtistId: artistId,
                                        missionsTypeFilter: missionTypes
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    refetchGurest({
                                        missionsArtistId: artistId,
                                        missionsTypeFilter: missionTypes
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGetStepMissionReward: function onGetStepMissionReward(stepMissionId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getStepMissionReward({
                                        variables: {
                                            stepMissionId: stepMissionId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMoreArtistMissions: function onFetchMoreArtistMissions(missionTypes) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            missionsArtistId: artistId,
                                            missionsTypeFilter: missionTypes,
                                            missionsPageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref2 = data.missionsWithFilteres) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMoreGurest({
                                        variables: {
                                            missionsArtistId: artistId,
                                            missionsTypeFilter: missionTypes,
                                            missionsPageInput: {
                                                cursor: dataGuest === null || dataGuest === void 0 ? void 0 : (ref = dataGuest.missionsWithFilteres) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMoreStepMission: function onFetchMoreStepMission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            missionsArtistId: artistId,
                                            missionsTypeFilter: [
                                                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                                                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
                                            ],
                                            stepMissionsPageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistStepMissions) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistMissions_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMissions_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* UserStepMissionsConnectionFragmentDoc */.qx9, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(ArtistMissions_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN);
var FETCH_NEW_MISSIONS = (0,lib/* gql */.Ps)(ArtistMissions_viewModel_templateObject2(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN);
var GET_STEP_MISSION_REWARD = (0,lib/* gql */.Ps)(viewModel_templateObject3(), utoniq_core_schema/* UserStepMissionBoxFragmentDoc */.yMn);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMissions/index.tsx




/**
 * ArtistMissions Page
 * Implemented as a practical sample.
 */ var ArtistMissions = function() {
    var ref = ArtistMissions_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMissionsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistMyCollections/template/index.tsx












var ArtistMyCollectionsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("artistCollections").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref6 = (0,react.useState)(false), openSideMenu = ref6[0], setOpenSideMenu = ref6[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                    hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
                }
            },
            margin: true,
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    color: "icon.line",
                    bgcolor: "icon.background",
                    badge: ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount) || !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ArtistMyCollections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CollectionBannerCell, {
                    userCollections: state.userCollections,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore
                })
            ]
        })
    });
};
var template_CollectionBannerCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, userCollections = param.userCollections, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("artistCollections").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: "60px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    py: 2
                },
                children: t("collectionAll")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref = userCollections === null || userCollections === void 0 ? void 0 : userCollections.map(function(param, index) {
                    var collection = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionBox, {
                        collection: collection,
                        fullWidth: true,
                        sx: {
                            height: "calc((100vw - 40px) * 190 / 335)",
                            maxHeight: "calc(560px * 190 / 335)"
                        },
                        actionAreaProps: {
                            onClick: function onClick() {
                                var ref;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    artistId: (ref = collection.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                    collectionId: collection.id,
                                    name: "ArtistMyCollections"
                                });
                            }
                        }
                    }, index);
                })) !== null && ref !== void 0 ? ref : [],
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                componentProps: {
                    spacing: 5
                },
                emptyMessage: t("collectionEmptyMessage"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 6,
                    flexDirection: "column",
                    sx: {
                        py: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionBoxSkeleton, {
                            fullWidth: true
                        }, key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalArtist/viewModel.ts

function GlobalArtist_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetUserFollowees {\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n"
    ]);
    GlobalArtist_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var GlobalArtist_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref5.user, userClaims = ref5.userClaims;
    var ref6 = (0,useQuery/* useQuery */.aM)(GET_USER_FOLLOWEES, {
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned)
    }), data = ref6.data, loading = ref6.loading;
    var ref7, ref8, ref9, ref10;
    return {
        state: {
            loading: loading,
            artists: [],
            followees: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationFollowees) !== null && ref7 !== void 0 ? ref7 : null,
            user: (ref8 = data === null || data === void 0 ? void 0 : data.user) !== null && ref8 !== void 0 ? ref8 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref1 = userClaims.orgs) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[config_config/* config.organizationId */.v.organizationId]) === null || ref2 === void 0 ? void 0 : ref2.artist),
            followArtists: (ref9 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.organizationFollowees) !== null && ref9 !== void 0 ? ref9 : null,
            memberArtists: (ref10 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationPatrons) !== null && ref10 !== void 0 ? ref10 : null
        },
        actions: {}
    };
});
var GET_USER_FOLLOWEES = (0,lib/* gql */.Ps)(GlobalArtist_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMyCollections/viewModel.ts



function ArtistMyCollections_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistMyCollections(\n    $artistId: ID!\n    $userId: String\n    $pageInput: PageInput\n  ) {\n    ownedUserCollectionsByArtistId(\n      artistId: $artistId\n      pageInput: $pageInput\n      userId: $userId\n    ) {\n      edges {\n        node {\n          ...UserCollectionBox\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistMyCollections_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ArtistMyCollections_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref8.user, userClaims = ref8.userClaims;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref9 = (0,useQuery/* useQuery */.aM)(GET_USER_FOLLOWEES, {
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned)
    }), userData = ref9.data;
    var ref10;
    var isFirstLoadRef = useGetNewestData({
        query: ArtistMyCollections_viewModel_QUERY,
        variables: {
            artistId: artistId,
            userId: (ref10 = userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref10 !== void 0 ? ref10 : "",
            pageInput: {
                limit: 20
            }
        },
        fields: [
            {
                fieldName: "ownedUserCollectionsByArtistId",
                fragment: utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU
            }, 
        ]
    }).isFirstLoadRef;
    var ref11;
    var ref12 = (0,useQuery/* useQuery */.aM)(ArtistMyCollections_viewModel_QUERY, {
        variables: {
            artistId: artistId,
            userId: (ref11 = userData === null || userData === void 0 ? void 0 : (ref1 = userData.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref11 !== void 0 ? ref11 : "",
            pageInput: {
                limit: 20
            }
        },
        onCompleted: function onCompleted(param) {
            var ownedUserCollectionsByArtistId = param.ownedUserCollectionsByArtistId;
            isFirstLoadRef.current = false;
            if (!ownedUserCollectionsByArtistId.edges.length) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    name: "artistMyCollections"
                });
            }
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true
    }), data = ref12.data, loading = ref12.loading, fetchMore = ref12.fetchMore;
    var isNextFetch = !!data;
    var ref13, ref14, ref15, ref16;
    return {
        state: {
            loading: loading && !isNextFetch,
            artistId: artistId,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref2 = data.ownedUserCollectionsByArtistId) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            userCollections: (ref13 = data === null || data === void 0 ? void 0 : (ref3 = data.ownedUserCollectionsByArtistId) === null || ref3 === void 0 ? void 0 : ref3.edges.filter(function(param) {
                var node = param.node;
                return (node === null || node === void 0 ? void 0 : node.itemOwnedCount) >= 1;
            })) !== null && ref13 !== void 0 ? ref13 : null,
            user: (ref14 = userData === null || userData === void 0 ? void 0 : userData.user) !== null && ref14 !== void 0 ? ref14 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref4 = userClaims.orgs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[config_config/* config.organizationId */.v.organizationId]) === null || ref5 === void 0 ? void 0 : ref5.artist),
            followArtists: (ref15 = userData === null || userData === void 0 ? void 0 : (ref6 = userData.user) === null || ref6 === void 0 ? void 0 : ref6.organizationFollowees) !== null && ref15 !== void 0 ? ref15 : null,
            memberArtists: (ref16 = userData === null || userData === void 0 ? void 0 : (ref7 = userData.user) === null || ref7 === void 0 ? void 0 : ref7.organizationPatrons) !== null && ref16 !== void 0 ? ref16 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.ownedUserCollectionsByArtistId) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistMyCollections_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistMyCollections_viewModel_templateObject(), utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU);

;// CONCATENATED MODULE: ./src/components/pages/ArtistMyCollections/index.tsx



var ArtistMyCollections = function() {
    var ref = ArtistMyCollections_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistMyCollectionsTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

// EXTERNAL MODULE: ./src/lib/url/index.ts
var lib_url = __webpack_require__(36604);
;// CONCATENATED MODULE: ./src/components/organisms/notification/NotificationBox/index.tsx








var NotificationBox = function(param) {
    var divider = param.divider, notification = param.notification, artist = param.artist;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("notifications").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var _link;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((_link = notification.link) !== null && _link !== void 0 ? _link : "").onClick;
    var openExternalLink = notification.link ? (0,lib_url/* isExternalLink */.Bm)(notification.link) : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
        href: notification.link || generatePath(isOfficial(notification) ? routerPages.OfficialInformationDetail : routerPages.NotificationDetail, {
            notificationId: notification.id
        }),
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isOfficial(notification) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    gap: 2,
                    mb: 2,
                    children: [
                        (artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: artist === null || artist === void 0 ? void 0 : (ref1 = artist.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri,
                            sx: {
                                height: 20,
                                width: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                            size: "small",
                            sx: {
                                height: 20,
                                borderRadius: "2px",
                                bgcolor: "secondary.dark",
                                py: 1,
                                ".MuiChip-label": {
                                    px: 1
                                }
                            },
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "white",
                                variant: "subtitle2",
                                children: t("official")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                    children: notification.title
                })
            ]
        }),
        subTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    sx: (0,src_object_spread/* default */.Z)({
                        pt: 2,
                        wordBreak: "break-word"
                    }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                    variant: "body2",
                    children: notification.body
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    sx: {
                        pt: 2
                    },
                    variant: "overline",
                    color: "text.hint",
                    children: isOfficial(notification) ? notification.formattedCreatedAt : notification.formattedDate
                })
            ]
        }),
        sx: {
            height: "auto",
            gridGap: 0,
            py: 4,
            color: "text.primary"
        },
        component: openExternalLink ? "p" : Link/* default */.Z,
        onClick: openExternalLink ? onClick : undefined,
        divider: divider
    });
};
function isOfficial(notification) {
    return !("date" in notification);
}

;// CONCATENATED MODULE: ./src/components/organisms/notification/NotificationBoxSkeleton/index.tsx



var NotificationBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
        sx: {
            px: 0,
            mx: 5,
            width: "auto"
        },
        divider: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
            primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "medium",
                numberOfLine: 2,
                sx: {
                    mt: 2
                },
                lastWidth: "75%"
            }),
            secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "25%",
                sx: {
                    mt: 2
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistOfficialInformation/template/index.tsx













var ArtistOfficialInformationTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistOfficialInformation").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, generatePath = ref1.generatePath, routerPages = ref1.routerPages, router = ref1.router;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: (0,src_object_spread/* default */.Z)({
            back: true,
            title: t("title", {
                displayName: (ref = state.artist) === null || ref === void 0 ? void 0 : ref.displayName
            }),
            defaultBackPage: generatePath(routerPages.ArtistTop, {
                artistId: (ref2 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref2 !== void 0 ? ref2 : "#"
            })
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        maxWidth: displayResponsive ? 1120 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.OfficialInformation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationListCell, {
                loading: state.loading || state.refetching,
                notifications: state.notifications,
                hasNextPage: state.hasNextPage,
                artist: state.artist,
                onFetchMore: onFetchMore
            })
        ]
    });
};
var NotificationListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, notifications = param.notifications, artist = param.artist, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("officialInformation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: notifications === null || notifications === void 0 ? void 0 : notifications.edges.map(function(param, index) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBox, {
                            notification: node,
                            artist: artist
                        }),
                        (notifications === null || notifications === void 0 ? void 0 : notifications.edges.length) - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                mx: 5
                            }
                        })
                    ]
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 0
            },
            component: List_List/* default */.Z,
            emptyMessage: t("notExist"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: [
                    1,
                    2,
                    3,
                    4,
                    5
                ].map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBoxSkeleton, {}, index);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistOfficialInformation/viewModel.ts



function ArtistOfficialInformation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistOfficialInformation(\n    $id: ID!\n    $artistId: String!\n    $pageInput: PageInput\n  ) {\n    organizationOfficialArtistNotifications(\n      artistId: $artistId\n      pageInput: $pageInput\n    ) {\n      ...OrganizationNotificationConnection\n    }\n    artist(id: $id) {\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistOfficialInformation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistOfficialInformation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistOfficialInformation(\n    $id: ID!\n    $artistId: String!\n    $pageInput: PageInput\n  ) {\n    organizationOfficialArtistNotifications(\n      artistId: $artistId\n      pageInput: $pageInput\n    ) {\n      ...OrganizationNotificationConnection\n    }\n    artist(id: $id) {\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistOfficialInformation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ArtistOfficialInformation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_QUERY,
        variables: {
            pageInput: {
                limit: 20
            },
            artistId: artistId,
            id: artistId
        },
        fields: [
            {
                fieldName: "notifications",
                fragment: utoniq_core_schema/* NotificationBoxFragmentDoc */.IEM
            }, 
        ]
    }).isFirstLoadRef;
    var ref1 = (0,useQuery/* useQuery */.aM)(ArtistOfficialInformation_viewModel_QUERY, {
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        variables: {
            pageInput: {
                limit: 5
            },
            artistId: artistId,
            id: artistId
        },
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref1.data, loading = ref1.loading, networkStatus = ref1.networkStatus, fetchMore = ref1.fetchMore;
    var isNextFetch = !!data;
    var ref2, ref3;
    return {
        state: {
            loading: loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.organizationOfficialArtistNotifications) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            notifications: (ref2 = data === null || data === void 0 ? void 0 : data.organizationOfficialArtistNotifications) !== null && ref2 !== void 0 ? ref2 : null,
            artist: (ref3 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref3 !== void 0 ? ref3 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                limit: 5,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.organizationOfficialArtistNotifications) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistOfficialInformation_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistOfficialInformation_viewModel_templateObject(), utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf);
var FETCH_NEW_QUERY = (0,lib/* gql */.Ps)(ArtistOfficialInformation_viewModel_templateObject1(), utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf);

;// CONCATENATED MODULE: ./src/components/pages/ArtistOfficialInformation/index.tsx




/**
 * ArtistOfficialInformation Page
 * Implemented as a practical sample.
 */ var ArtistOfficialInformation = function() {
    var ref = ArtistOfficialInformation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistOfficialInformationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/post/PostBoxSkeleton/index.tsx



var PostBoxSkeleton = function(param) {
    var fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        sx: {
            width: fullWidth ? "100%" : 315,
            minHeight: 196
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                sx: {
                    pb: 0
                },
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 36,
                    height: 36
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "75%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    numberOfLine: 3,
                    lastWidth: "75%"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPosts/template/index.tsx















var ArtistPostsTemplate = function(param) {
    var _state = param.state, filter = _state.filter, posts = _state.posts, loading = _state.loading, refetching = _state.refetching, hasNextPage = _state.hasNextPage, artistName = _state.artistName, liveStreamId = _state.liveStreamId, user = _state.user, onFilter = param.onFilter, onFetchMore = param.onFetchMore, onLikePost = param.onLikePost;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPosts").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, routerNames = ref.routerNames, generatePath = ref.generatePath;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: config_config/* config.artistTabs.includes */.v.artistTabs.includes("posts") ? {
                type: "artist",
                props: {
                    hasManagementTask: !!(user === null || user === void 0 ? void 0 : user.hasManagementTask),
                    unreadNotificationCount: user === null || user === void 0 ? void 0 : user.unreadNotificationCount,
                    isLive: !!liveStreamId
                },
                responsive: displayResponsive
            } : undefined,
            margin: true,
            header: (0,src_object_spread/* default */.Z)({
                title: t("title"),
                back: true,
                defaultBackPage: generatePath(routerPages.ArtistTop, {
                    artistId: (ref1 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref1 !== void 0 ? ref1 : "#"
                })
            }, displayResponsive ? {
                responsive: true,
                maxWidth: 1120
            } : {}),
            maxWidth: displayResponsive ? 600 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistPosts,
                        artistName
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMenu, {
                    filter: filter,
                    onFilter: onFilter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    componentProps: {
                        sx: {
                            pt: 2
                        },
                        spacing: 5
                    },
                    nodes: posts.map(function(post, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(PostBox, (0,src_object_spread/* default */.Z)({
                            onLike: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onLikePost(post.id, post.isLike, post.likeCount)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            isMembershipPersonalInformationRequired: !!(user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired),
                            post: post
                        }, displayResponsive ? {
                            responsive: true
                        } : {
                            fullWidth: true,
                            sx: {
                                height: 356
                            }
                        }), index);
                    }),
                    onFetchMore: onFetchMore,
                    loading: refetching || loading,
                    hasNextPage: hasNextPage,
                    emptyMessage: t("postNotExist"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        sx: {
                            pt: 2
                        },
                        children: Array.from(Array(3).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBoxSkeleton, {
                                fullWidth: true
                            }, key);
                        })
                    })
                })
            ]
        })
    });
};
var FilterMenu = function(param) {
    var filter = param.filter, onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPosts").t;
    var handleSelect = (0,react.useCallback)(function(value) {
        onFilter(value);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
        value: filter,
        onClick: handleSelect,
        tags: [
            {
                value: "general",
                label: t("general")
            },
            {
                value: "video",
                label: t("video")
            },
            {
                value: "sound",
                label: t("sound")
            },
            {
                value: "image",
                label: t("image")
            },
            {
                value: "text",
                label: t("text")
            }, 
        ].concat((0,src_to_consumable_array/* default */.Z)((0,individual/* individualShowStory */.IG)() ? [
            {
                value: "story",
                label: t("story")
            }
        ] : []))
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPosts/viewModel.ts






function ArtistPosts_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistPosts(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceType: PostType\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceType: $resourceType\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n      ) {\n        ...ArtistPosts\n      }\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistPosts_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistPosts_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistPosts(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceType: PostType\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceType: $resourceType\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n      ) {\n        ...ArtistPosts\n      }\n      currentLive {\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistPosts_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ArtistPosts_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    /**
   *  TODO:
   * - filterを@connection directiveなどでキャッシュから取得
   * - refetchの際にpostsのキャッシュを一新するロジックの実装
   *  */ //
    var ref9 = (0,react.useState)("general"), filter = ref9[0], setFilter = ref9[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    /**
   * フィルターに応じてクエリ変数を生成する
   * story → resourceType: null, resourceTypes: [PostType.Video, PostType.Image], storyFilter: StoryFilter.Only
   * general → resourceType: null
   * それ以外 → resourceType: filter
   * @param filter
   * @returns
   *
   * useMemo は用いていない
   * 既存の実装では filter 切り替え時に手動で refetch を行っており、
   * useMemo を挟むと filter が 1 つ前の値でリクエストされてしまうため
   */ var varsByFilter = function(filter) {
        var isStory = filter === "story";
        var isGeneral = filter === "general";
        if (isStory) {
            return {
                resourceTypes: [
                    utoniq_core_schema/* PostType.Video */.hQF.Video,
                    utoniq_core_schema/* PostType.Image */.hQF.Image
                ],
                storyFilter: utoniq_core_schema/* StoryFilter.Only */.CkM.Only
            };
        }
        if (isGeneral) {
            return {
                resourceType: null,
                storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include
            };
        }
        return {
            resourceType: filter
        };
    };
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_ARTIST_POSTS,
        variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            artistId: artistId
        }, varsByFilter(filter)), {
            pageInput: {
                limit: 10
            },
            pageInputById: {
                limit: 10
            }
        }),
        identify: {
            __typename: "Artist",
            id: artistId
        },
        fields: [
            {
                fieldName: "posts",
                responsePath: "artist.posts",
                fragment: utoniq_core_schema/* PostBoxFragmentDoc */.cSz
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref10 = (0,useQuery/* useQuery */.aM)(ARTIST_POSTS, {
        variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            artistId: artistId
        }, varsByFilter(filter)), {
            pageInput: {
                limit: 10
            },
            pageInputById: {
                limit: 10
            }
        }),
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref10.data, fetchMore = ref10.fetchMore, refetch = ref10.refetch, networkStatus = ref10.networkStatus;
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.posts);
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikePost */.UEr), 1), likePost = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikePost */.UsN), 1), unlikePost = ref12[0];
    var pageInfo = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.pageInfo;
    var handleFilter = function(filterType) {
        if (filterType === filter) return;
        refetch((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, varsByFilter(filterType)), {
            // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
            pageInput: {
                cursor: null,
                limit: 10
            },
            pageInputById: {
                cursor: null,
                limit: 10
            }
        }));
        setFilter(filterType);
    };
    var fetchMorePosts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(pageInfo && pageInfo.hasNextPage)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMore({
                                variables: {
                                    artistId: artistId,
                                    // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                    pageInput: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 3
                                    },
                                    pageInputById: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 3
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var nodes = (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.posts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.map(function(param) {
        var node = param.node;
        return node;
    })) || [];
    return {
        state: {
            user: data === null || data === void 0 ? void 0 : data.user,
            posts: nodes,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            filter: filter,
            artistName: (data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : ref6.displayName) || "",
            hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
            liveStreamId: data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.currentLive) === null || ref8 === void 0 ? void 0 : ref8.id
        },
        actions: {
            onFilter: handleFilter,
            onFetchMore: fetchMorePosts,
            onLikePost: function onLikePost(postId, isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ARTIST_POSTS = (0,lib/* gql */.Ps)(ArtistPosts_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_ARTIST_POSTS = (0,lib/* gql */.Ps)(ArtistPosts_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);

;// CONCATENATED MODULE: ./src/components/pages/ArtistPosts/index.tsx




var ArtistPosts = function() {
    var ref = ArtistPosts_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistPostsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/ButtonBase/ButtonBase.js + 3 modules
var ButtonBase = __webpack_require__(55504);
;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ThumbnailImage.tsx



var ThumbnailImage_ThumbnailImage = function(param) {
    var src = param.src, alt = param.alt, _withBorderRadius = param.withBorderRadius, withBorderRadius = _withBorderRadius === void 0 ? false : _withBorderRadius;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
        style: {
            width: "100%",
            height: "100%",
            borderRadius: withBorderRadius ? "8px" : "inherit",
            objectFit: "cover"
        },
        alt: alt,
        src: src
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ShortVideo.tsx






var ShortVideo = function(param) {
    var post = param.post, onClick = param.onClick;
    var ref, ref1, ref2;
    var isAccessible = post.isAccessible;
    if (!(post === null || post === void 0 ? void 0 : (ref = post.resource) === null || ref === void 0 ? void 0 : ref.uri)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        component: ButtonBase/* default */.Z,
        sx: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        onClick: onClick,
        children: [
            post.isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                sx: {
                    position: "absolute",
                    top: "8px",
                    left: "8px"
                }
            }),
            isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage_ThumbnailImage, {
                src: ((ref1 = post.videoThumbnail) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) || "",
                alt: "thumbnail",
                withBorderRadius: true
            }),
            !isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage_ThumbnailImage, {
                        src: ((ref2 = post.videoThumbnail) === null || ref2 === void 0 ? void 0 : ref2.blurUri) || "",
                        alt: "membership_only",
                        withBorderRadius: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                        fontSize: "xLarge",
                        sx: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white"
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/index.tsx














var ArtistPostVideosTemplate = function(_param) {
    var state = _param.state, _state = _param.state, liveStreamId = _state.liveStreamId, user = _state.user, action = (0,_object_without_properties/* default */.Z)(_param, [
        "state",
        "state"
    ]);
    var ref = (0,core_i18n/* useTranslation */.$G)("artistPostVideos"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages, routerNames = ref1.routerNames, generatePath = ref1.generatePath;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: i18n.exists("artistPostVideos:ogTitle") ? t("ogTitle") : routerNames.ArtistPostVideos
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "artist",
                    props: {
                        hasManagementTask: !!(user === null || user === void 0 ? void 0 : user.hasManagementTask),
                        unreadNotificationCount: user === null || user === void 0 ? void 0 : user.unreadNotificationCount,
                        isLive: !!liveStreamId
                    },
                    responsive: displayResponsive
                },
                header: (0,src_object_spread/* default */.Z)({
                    title: t("title"),
                    back: true,
                    defaultBackPage: generatePath(routerPages.ArtistTop, {
                        artistId: (ref2 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref2 !== void 0 ? ref2 : "#"
                    })
                }, displayResponsive ? {
                    responsive: true,
                    maxWidth: 1120
                } : {}),
                maxWidth: displayResponsive ? 1120 : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortVideoCell, {
                    state: state,
                    action: action,
                    responsive: displayResponsive
                })
            })
        ]
    });
};
var ShortVideoCell = function(param) {
    var _state = param.state, posts = _state.posts, refetching = _state.refetching, loading = _state.loading, hasNextPage = _state.hasNextPage, isMembershipPersonalInformationRequired = _state.isMembershipPersonalInformationRequired, onFetchMore = param.action.onFetchMore, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPostVideos").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            component: Grid2/* default */.Z,
            componentProps: {
                container: true,
                spacing: 0
            },
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: responsive ? {
                size: {
                    xs: 4,
                    md: 3
                }
            } : {
                size: {
                    xs: 4
                }
            },
            fadeSx: {
                aspectRatio: "9/16"
            },
            nodes: posts.map(function(post, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ShortVideo, {
                    post: post,
                    onClick: function() {
                        var ref, ref1;
                        if (post.isAccessible && post.isPremium && isMembershipPersonalInformationRequired && ((ref = post.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired)) {
                            showModal();
                        } else {
                            router.push(generatePath(routerPages.PostVideoDetailModal, {
                                postId: post.id
                            }));
                        }
                    }
                }, index);
            }),
            onFetchMore: onFetchMore,
            loading: refetching || loading,
            hasNextPage: hasNextPage,
            emptyMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyMessage, {
                message: t("postNotExist")
            }),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 1,
                sx: {
                    width: "100%"
                },
                children: Array.from(Array(9).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: {
                            xs: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rounded",
                            sx: {
                                width: "100%",
                                height: "100%",
                                minHeight: "30vh"
                            }
                        })
                    }, key);
                })
            })
        })
    });
};
var EmptyMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "85dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "text.secondary",
            sx: {
                textAlign: "center"
            },
            children: message
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/viewModel.ts



function ArtistPostVideos_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistPostVideos(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter!\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n        categoryId: $categoryId\n      ) {\n        ...ArtistPosts\n      }\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistPostVideos_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistPostVideos_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistPostVideos(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter!\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n        categoryId: $categoryId\n      ) {\n        ...ArtistPosts\n      }\n      currentLive {\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistPostVideos_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var ArtistPostVideos_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_ARTIST_POST_VIDEOS,
        variables: {
            artistId: artistId,
            resourceTypes: [
                utoniq_core_schema/* PostType.Video */.hQF.Video
            ],
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            pageInput: {
                limit: 12
            },
            pageInputById: {
                limit: 12
            },
            categoryId: null
        },
        identify: {
            __typename: "Artist",
            id: artistId
        },
        fields: [
            {
                fieldName: "posts",
                responsePath: "artist.posts",
                fragment: utoniq_core_schema/* PostBoxFragmentDoc */.cSz
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref8 = (0,useQuery/* useQuery */.aM)(ARTIST_POST_VIDEOS, {
        variables: {
            artistId: artistId,
            resourceTypes: [
                utoniq_core_schema/* PostType.Video */.hQF.Video
            ],
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            pageInput: {
                limit: 12
            },
            pageInputById: {
                limit: 12
            },
            categoryId: null
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref8.data, fetchMore = ref8.fetchMore, networkStatus = ref8.networkStatus;
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.posts);
    var pageInfo = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.pageInfo;
    var fetchMorePosts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(pageInfo && pageInfo.hasNextPage)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMore({
                                variables: {
                                    artistId: artistId,
                                    // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                    pageInput: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 6
                                    },
                                    pageInputById: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 6
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var nodes = (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.posts.edges// NOTE YouTube動画は対象外とする
    .filter(function(param) {
        var node = param.node;
        var ref, ref1;
        return ((ref = node.resource) === null || ref === void 0 ? void 0 : ref.uri) !== null && ((ref1 = node.resource) === null || ref1 === void 0 ? void 0 : ref1.videoId) === null;
    }).map(function(param) {
        var node = param.node;
        return node;
    })) || [];
    return {
        state: {
            user: data === null || data === void 0 ? void 0 : data.user,
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.isMembershipPersonalInformationRequired),
            posts: nodes,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            artistName: (data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : ref5.displayName) || "",
            hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
            liveStreamId: data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.currentLive) === null || ref7 === void 0 ? void 0 : ref7.id
        },
        actions: {
            onFetchMore: fetchMorePosts
        }
    };
});
var ARTIST_POST_VIDEOS = (0,lib/* gql */.Ps)(ArtistPostVideos_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_ARTIST_POST_VIDEOS = (0,lib/* gql */.Ps)(ArtistPostVideos_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/index.tsx




/**
 * ArtistPostVideos Page
 * Implemented as a practical sample.
 */ var ArtistPostVideos = function() {
    var ref = ArtistPostVideos_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistPostVideosTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/Rank/index.tsx






var Rank = function(param) {
    var _size = param.size, size = _size === void 0 ? "medium" : _size, rank = param.rank, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("myRanking").t;
    var sizePx = (0,react.useMemo)(function() {
        return getSizePixel(size);
    }, [
        size
    ]);
    var ref = (0,react.useMemo)(function() {
        switch(rank){
            case 1:
                return {
                    borderColor: "#f3af3d",
                    backgroundImage: "linear-gradient(180deg, #f3cb70 25%, #f3cb70 50%, #f5bc49 50%, #f5bc49 96%)"
                };
            case 2:
                return {
                    borderColor: "#b4bbbd",
                    backgroundImage: "linear-gradient(180deg, #eaebe9 25%, #eaebe9 58%, #d0d0cf 58%, #d0d0cf 96%)"
                };
            case 3:
                return {
                    borderColor: "#d28f60",
                    backgroundImage: "linear-gradient(180deg, #f9dcc3 25%, #f9dcc3 58%, #edc2a0 58%, #edc2a0 96%)"
                };
            default:
                return {
                    bgcolor: "grey.50",
                    borderColor: "grey.200"
                };
        }
    }, [
        rank
    ]), backgroundImage = ref.backgroundImage, borderColor = ref.borderColor, bgcolor = ref.bgcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        component: Stack_Stack/* default */.Z,
        sx: (0,src_object_spread/* default */.Z)({
            position: "relative",
            width: sizePx
        }, sx),
        justifyContent: "center",
        alignItems: "center",
        children: [
            rank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    zIndex: 2,
                    WebkitTextStrokeWidth: rank > 3 ? 0 : 0.5,
                    WebkitTextStrokeColor: "black"
                },
                children: rank
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    zIndex: 2
                },
                children: t("notAttended")
            }),
            !!rank && rank <= 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    zIndex: 0,
                    position: "absolute",
                    transform: "rotate(-45deg)",
                    width: "calc(".concat(sizePx, "px/(0.707*2))"),
                    height: "calc(".concat(sizePx, "px/(0.707*2))"),
                    backgroundImage: backgroundImage
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    zIndex: 1,
                    position: "absolute",
                    borderWidth: 3,
                    borderStyle: "solid",
                    borderColor: borderColor,
                    transform: "rotate(-45deg)",
                    width: "calc(".concat(sizePx - (rank && rank <= 3 ? 6 : 0), "px/(0.707*2))"),
                    height: "calc(".concat(sizePx - (rank && rank <= 3 ? 6 : 0), "px/(0.707*2))"),
                    backgroundImage: backgroundImage,
                    bgcolor: bgcolor
                }
            })
        ]
    });
};
var getSizePixel = function(size) {
    switch(size){
        case "xSmall":
            return 48;
        case "small":
            return 52;
        case "medium":
            return 56;
        default:
            return 68;
    }
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankingUserDataListItem/index.tsx










var RankingUserDataListItem = function(param) {
    var rankingUser = param.rankingUser, _clickable = param.clickable, clickable = _clickable === void 0 ? true : _clickable, user = param.user;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var rankingArrowIcon = (0,react.useMemo)(function() {
        if (!(rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.rank)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: 24
                }
            });
        }
        if ((rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.previousRank) === (rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.rank)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ArrowForward, {
                sx: {
                    color: "white"
                }
            });
        }
        if (!(rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.previousRank) || (rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.previousRank) > (rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.rank)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ArrowUpward, {
                sx: {
                    color: "like.tap"
                }
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ArrowDownward, {
            sx: {
                color: "info.dark"
            }
        });
    }, [
        rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.previousRank,
        rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.rank
    ]);
    var ref5, ref6, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionAreaCell, {
            clickable: clickable,
            sx: {
                width: "100%",
                bgcolor: "grey.100",
                height: 60,
                borderRadius: 1,
                overflow: "hidden"
            },
            href: (rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.userId) ? generatePath(routerPages.ArtistRanking, {
                artistId: rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.userId
            }) : undefined,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                flex: 1,
                sx: {
                    minWidth: 0,
                    width: "100%"
                },
                spacing: 3,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                                rank: (ref5 = rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.rank) !== null && ref5 !== void 0 ? ref5 : 0,
                                size: "small",
                                sx: {
                                    position: "absolute",
                                    zIndex: 1,
                                    top: 6,
                                    left: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: 36,
                                    height: 36,
                                    ml: "50px"
                                },
                                src: (ref7 = (ref6 = rankingUser === null || rankingUser === void 0 ? void 0 : (ref = rankingUser.user) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref6 !== void 0 ? ref6 : user === null || user === void 0 ? void 0 : (ref2 = user.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref7 !== void 0 ? ref7 : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            align: "left",
                            sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                                width: "100%"
                            }),
                            children: (ref8 = rankingUser === null || rankingUser === void 0 ? void 0 : (ref3 = rankingUser.user) === null || ref3 === void 0 ? void 0 : ref3.displayName) !== null && ref8 !== void 0 ? ref8 : user === null || user === void 0 ? void 0 : user.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            borderRadius: 3,
                            width: 80,
                            height: 20,
                            position: "relative"
                        },
                        alignItems: "center",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: {
                                    mt: "2px"
                                },
                                children: (rankingUser === null || rankingUser === void 0 ? void 0 : rankingUser.point) || "---"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.EventPoint, {
                                sx: {
                                    position: "absolute",
                                    left: -4,
                                    top: -2
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            pr: 3
                        },
                        children: rankingArrowIcon
                    })
                ]
            })
        })
    });
};
var ActionAreaCell = function(param) {
    var clickable = param.clickable, href = param.href, sx = param.sx, children = param.children;
    if (clickable && href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            sx: sx,
            href: href,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        sx: sx,
        flex: 1,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankingUserDataListItemSkeleton/index.tsx


var RankingUserDataListItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
        height: 60,
        variant: "rectangular",
        sx: {
            borderRadius: 1
        }
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/ToggleButtonGroup/ToggleButtonGroup.js
var ToggleButtonGroup = __webpack_require__(16140);
// EXTERNAL MODULE: ../../node_modules/@mui/material/ToggleButton/ToggleButton.js + 1 modules
var ToggleButton = __webpack_require__(46253);
;// CONCATENATED MODULE: ./src/components/organisms/functionals/Segment/index.tsx





var Segment = function(param) {
    var labels = param.labels, value = param.value, onChange = param.onChange, children = param.children, hiddenLabel = param.hiddenLabel, disableAnimateTransitions = param.disableAnimateTransitions;
    var handleChange = (0,react.useCallback)(function(event, newValue) {
        if (newValue === null) {
            return;
        }
        onChange(newValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            !hiddenLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButtonGroup/* default */.Z, {
                value: value,
                fullWidth: true,
                exclusive: true,
                sx: {
                    pt: 2,
                    pb: 4
                },
                onChange: handleChange,
                children: labels.map(function(label, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                        value: index,
                        sx: {
                            py: 1,
                            borderRadius: 1,
                            border: "none",
                            bgcolor: "grey.50",
                            "&.Mui-selected": {
                                bgcolor: "grey.100"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: value === index ? "text.primary" : "text.hint",
                            children: label
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_swipeable_views_lib/* default */.ZP, {
                index: value,
                onChangeIndex: onChange,
                disabled: hiddenLabel,
                animateTransitions: !(hiddenLabel || disableAnimateTransitions),
                children: react.Children.map(children, function(child, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                        index: index,
                        value: value,
                        children: child
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistRanking/template/index.tsx
















var ArtistRankingTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onChangePeriod = param.onChangePeriod;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("artistRanking").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ranking")).onClick;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, router = ref2.router, generatePath = ref2.generatePath;
    var ref3 = (0,react.useState)(0), currentSegment = ref3[0], setCurrentSegment = ref3[1];
    var handleChangeSegment = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(segment) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCurrentSegment(segment);
                        return [
                            4,
                            onChangePeriod(segment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(segment) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangePeriod
    ]);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: t("title", {
                    displayName: (ref = state.artist) === null || ref === void 0 ? void 0 : ref.displayName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ArtistTop, {
                        artistId: (ref4 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref4 !== void 0 ? ref4 : "#"
                    }),
                    title: t("title", {
                        displayName: (ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName
                    }),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                        edge: "end",
                        color: "primary.main",
                        onClick: onClick
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Segment, {
                    labels: [
                        t("month"),
                        t("total")
                    ],
                    value: currentSegment,
                    disableAnimateTransitions: true,
                    onChange: handleChangeSegment,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingsCell, {
                            loading: state.loading,
                            refetching: state.refetching,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: function() {
                                return onFetchMore(currentSegment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly);
                            },
                            user: state.user,
                            rankings: state.periodType === utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly ? state.rankings : null,
                            myRanking: state.myRanking,
                            note: state.period ? t("aggregationPeriod", {
                                period: state.period
                            }) : undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingsCell, {
                            loading: state.loading,
                            refetching: state.refetching,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: function() {
                                return onFetchMore(currentSegment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly);
                            },
                            user: state.user,
                            rankings: state.periodType === utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly ? state.rankings : null,
                            myRanking: state.myRanking
                        })
                    ]
                })
            })
        ]
    });
};
var RankingsCell = function(param) {
    var user = param.user, rankings = param.rankings, myRanking = param.myRanking, loading = param.loading, refetching = param.refetching, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, note = param.note;
    var t = (0,core_i18n/* useTranslation */.$G)("artistRanking").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pb: 4
                },
                children: [
                    !!note && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.hint",
                        children: note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("currentStanding")
                    }),
                    (myRanking || user) && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataListItem, {
                        rankingUser: myRanking,
                        user: user,
                        clickable: false
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataListItemSkeleton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("top10")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: rankings === null || rankings === void 0 ? void 0 : rankings.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataListItem, {
                                    rankingUser: node,
                                    user: null,
                                    clickable: false
                                }, node.id);
                            }),
                            componentProps: {
                                spacing: 3
                            },
                            loading: loading || refetching,
                            hasNextPage: hasNextPage,
                            onFetchMore: onFetchMore,
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                children: Array.from(Array(4).keys()).map(function(index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataListItemSkeleton, {}, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistRanking/viewModel.ts



function ArtistRanking_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistRanking(\n    $artistId: String!\n    $periodType: RankingPeriodType!\n    $pageInput: PageInput\n  ) {\n    user {\n      id\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n    artistRankings(artistId: $artistId) {\n      artist {\n        id\n        displayName\n      }\n      latestRankingPeriod(periodType: $periodType) {\n        ...RankingPeriodBaseConnection\n        myRanking {\n          ...RankingUserWithoutIdConnection\n        }\n        rankings(pageInput: $pageInput) {\n          ...RankingsConnection\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistRanking_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ArtistRanking_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var artistId = router.query.artistId;
    var ref7 = (0,useQuery/* useQuery */.aM)(ArtistRanking_viewModel_QUERY, {
        variables: {
            artistId: artistId,
            periodType: utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly,
            pageInput: {
                limit: 10
            }
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref7.data, refetch = ref7.refetch, networkStatus = ref7.networkStatus, fetchMore = ref7.fetchMore;
    var period = (0,react.useMemo)(function() {
        return "".concat(dayjs_min_default()().startOf("month").format("ll"), "〜").concat(dayjs_min_default()().format("ll"));
    }, []);
    var ref8, ref9, ref10, ref11, ref12;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: false,
            myRanking: (ref8 = data === null || data === void 0 ? void 0 : (ref = data.artistRankings) === null || ref === void 0 ? void 0 : (ref1 = ref.latestRankingPeriod) === null || ref1 === void 0 ? void 0 : ref1.myRanking) !== null && ref8 !== void 0 ? ref8 : null,
            rankings: (ref9 = data === null || data === void 0 ? void 0 : (ref2 = data.artistRankings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.latestRankingPeriod) === null || ref3 === void 0 ? void 0 : ref3.rankings) !== null && ref9 !== void 0 ? ref9 : null,
            periodType: (ref10 = data === null || data === void 0 ? void 0 : (ref4 = data.artistRankings) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.latestRankingPeriod) === null || ref5 === void 0 ? void 0 : ref5.periodType) !== null && ref10 !== void 0 ? ref10 : null,
            period: period,
            user: (ref11 = data === null || data === void 0 ? void 0 : data.user) !== null && ref11 !== void 0 ? ref11 : null,
            artist: (ref12 = data === null || data === void 0 ? void 0 : (ref6 = data.artistRankings) === null || ref6 === void 0 ? void 0 : ref6.artist) !== null && ref12 !== void 0 ? ref12 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onChangePeriod: function onChangePeriod(periodType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        artistId: artistId,
                                        periodType: periodType
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistRanking_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistRanking_viewModel_templateObject(), utoniq_core_schema/* RankingPeriodBaseConnectionFragmentDoc */.CqK, utoniq_core_schema/* RankingUserWithoutIdConnectionFragmentDoc */.u1C, utoniq_core_schema/* RankingsConnectionFragmentDoc */.oND);

;// CONCATENATED MODULE: ./src/components/pages/ArtistRanking/index.tsx




/**
 * ArtistRanking Page
 * Implemented as a practical sample.
 */ var ArtistRanking = function() {
    var ref = ArtistRanking_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistRankingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(41075);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(30907);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(93873);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(77893);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectInfiniteHits.js
var connectInfiniteHits = __webpack_require__(96662);
// EXTERNAL MODULE: ./src/lib/algolia/index.ts
var algolia = __webpack_require__(40681);
;// CONCATENATED MODULE: ./src/components/pages/ArtistSearch/template/index.tsx













var client = algolia/* client */.Lp();
var ArtistSearchTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                indexName: algolia/* indexes.organizationArtists */.RG.organizationArtists,
                searchClient: client,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                        filters: algolia/* filters.organizationId */.u8.organizationId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistsInfiniteHits, {})
                ]
            })
        ]
    });
};
var SearchBox = (0,connectSearchBox/* default */.Z)(function(param) {
    var refine = param.refine, currentRefinement = param.currentRefinement;
    var t = (0,core_i18n/* useTranslation */.$G)("artistSearch").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Search, {
        value: currentRefinement,
        fullWidth: true,
        placeholder: t("searchPlaceholder"),
        onChange: function(e) {
            return refine(e.currentTarget.value);
        },
        size: "small",
        sx: {
            minHeight: 40,
            bgcolor: function(param) {
                var palette = param.palette;
                return "".concat(palette.grey[50], "!important");
            },
            ".MuiInputBase-root, input": {
                bgcolor: "unset"
            }
        }
    });
});
var HeaderCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("artistSearch").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: 3,
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "text",
                color: "primary",
                href: routerPages.GlobalArtist,
                children: t("cancel")
            })
        ]
    });
};
var ArtistsInfiniteHits = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, refineNext = param.refineNext;
    var items = hits.map(function(_param) {
        var objectID = _param.objectID, item = (0,_object_without_properties/* default */.Z)(_param, [
            "objectID"
        ]);
        return (0,src_object_spread/* default */.Z)({
            id: objectID
        }, item);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistsCell, {
        items: items,
        hasNextPage: hasMore,
        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    refineNext()
                ];
            });
        })
    });
});
var ArtistsCell = function(param) {
    var onFetchMore = param.onFetchMore, hasNextPage = param.hasNextPage, items = param.items;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1, ref2, _displayName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: false,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: Grid/* default */.ZP,
            componentProps: {
                spacing: 5,
                container: true
            },
            itemComponent: Grid/* default */.ZP,
            itemComponentProps: {
                item: true,
                xs: 6,
                md: 4
            },
            emptyMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
            nodes: items === null || items === void 0 ? void 0 : items.map(function(artist) {
                var ref, ref3;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                    sx: {
                        display: "grid",
                        gap: 3,
                        height: "100%",
                        boxShadow: 0,
                        bgcolor: "background.default",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                        href: generatePath(routerPages.ArtistTop, {
                            artistId: artist.id
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: 158,
                                    height: 158,
                                    mb: 3
                                },
                                src: (ref2 = (ref1 = (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : (ref3 = artist.avatar) === null || ref3 === void 0 ? void 0 : ref3.uri) !== null && ref2 !== void 0 ? ref2 : "",
                                alt: (_displayName = artist.displayName) !== null && _displayName !== void 0 ? _displayName : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                align: "center",
                                children: artist.displayName
                            })
                        ]
                    })
                }, artist.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistSearch/viewModel.ts

function ArtistSearch_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistSearch {\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistSearch_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ArtistSearch_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var data = (0,useQuery/* useQuery */.aM)(ArtistSearch_viewModel_QUERY).data;
    var ref;
    return {
        state: {
            user: (ref = data === null || data === void 0 ? void 0 : data.user) !== null && ref !== void 0 ? ref : null
        },
        actions: {}
    };
});
var ArtistSearch_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistSearch_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/ArtistSearch/index.tsx



var ArtistSearch = function() {
    var ref = ArtistSearch_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistSearchTemplate, {
        state: state
    });
};

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/styles/useCustomDesign.tsx




var useCustomDesign = function(param) {
    var type = param.type, artistId = param.artistId;
    var ref = (0,react.useState)(null), customDesign = ref[0], setCustomDesign = ref[1];
    var ref1 = function() {
        switch(type){
            case "ArtistTop":
                return {
                    path: "".concat(config_config/* config.appStorageUrl */.v.appStorageUrl, "customDesign/artists/").concat(artistId, "/ArtistTop.json"),
                    localStorageKey: "CUSTOM_DESIGN_ARTIST_TOP_".concat(artistId)
                };
            case "ArtistStore":
                return {
                    path: "".concat(config_config/* config.appStorageUrl */.v.appStorageUrl, "customDesign/artists/").concat(artistId, "/ArtistStore.json"),
                    localStorageKey: "CUSTOM_DESIGN_ARTIST_STORE_".concat(artistId)
                };
            default:
                throw new Error("Unknown custom design type: ".concat(type));
        }
    }(), path = ref1.path, localStorageKey = ref1.localStorageKey;
    (0,react.useEffect)(function() {
        var loadDesign = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var cached, res, json, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cached = localStorage.getItem(localStorageKey);
                            if (cached) {
                                setCustomDesign(JSON.parse(cached));
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch(path)
                            ];
                        case 2:
                            res = _state.sent();
                            return [
                                4,
                                res.json()
                            ];
                        case 3:
                            json = _state.sent();
                            localStorage.setItem(localStorageKey, JSON.stringify(json));
                            setCustomDesign(json);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            // ２回目以降nullを返さないようにして、未設定の場合もloadingのラグを無くす
                            setCustomDesign({});
                            localStorage.setItem(localStorageKey, JSON.stringify({}));
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadDesign() {
                return _ref.apply(this, arguments);
            };
        }();
        loadDesign();
    }, [
        path,
        localStorageKey
    ]);
    return {
        customDesign: customDesign
    };
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Menu/Menu.js
var Menu_Menu = __webpack_require__(18960);
// EXTERNAL MODULE: ./src/components/organisms/point/PointDisplayPurchase/index.tsx
var PointDisplayPurchase = __webpack_require__(49678);
;// CONCATENATED MODULE: ./src/components/organisms/store/ArtistStoreCollectionBox/index.tsx







var ArtistStoreCollectionBox = function(param) {
    var collection = param.collection, width = param.width, _height = param.height, height = _height === void 0 ? 90 : _height, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? "1000 / 560" : _aspectRatio, conductorName = param.conductorName, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCollectionsSelect").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var _mediumUri, ref1;
    var thumbnailUri = (ref1 = (_mediumUri = collection.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : collection.thumbnail.uri) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                bgcolor: "transparent",
                width: width
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.StoreCollectionDetail, {
                    artistId: collection.artistId,
                    collectionId: collection.id
                }),
                onClick: function() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: collection.artistId,
                        collectionId: collection.id,
                        name: conductorName
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                        component: "img",
                        image: thumbnailUri,
                        sx: {
                            borderRadius: 1,
                            width: responsive ? "100%" : width,
                            height: responsive ? "100%" : height,
                            objectFit: responsive ? "cover" : undefined,
                            aspectRatio: responsive ? aspectRatio : undefined
                        },
                        alt: collection.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                        children: collection.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        sx: {
                            display: "block"
                        },
                        children: t("itemCount", {
                            count: collection.publishedItemCount
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/store/StoreItemArea/index.tsx
var StoreItemArea = __webpack_require__(92238);
;// CONCATENATED MODULE: ./src/components/organisms/store/StoreItemAreaTemporarySkeleton/index.tsx



var StoreItemAreaTemporarySkeleton = function(param) {
    var _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 1,
        width: responsive ? {
            xs: 80,
            md: 108
        } : 80,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    width: 60,
                    height: 80
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "overline",
                width: "60%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "overline",
                width: "60%"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/StoreItemAreaTemporary/index.tsx








var StoreItemAreaTemporary = function(param) {
    var item = param.item, conductorName = param.conductorName, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var mdUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        sx: {
            width: responsive ? {
                xs: 80,
                md: 108
            } : 80,
            flexDirection: "column",
            textAlign: "left"
        },
        href: generatePath(routerPages.ArtistStoreItemDetail, {
            artistId: (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
            itemId: item.id
        }),
        onClick: function() {
            var ref;
            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                artistId: (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                itemId: item.id,
                name: conductorName
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    size: responsive ? !mdUp ? "x-small" : "medium-small" : "x-small",
                    src: (ref5 = (ref1 = item.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref5 !== void 0 ? ref5 : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    px: 1,
                    py: "6px",
                    minWidth: 0,
                    width: "100%"
                },
                children: [
                    ((ref2 = item.collection) === null || ref2 === void 0 ? void 0 : ref2.title) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secondary",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                        flexGrow: 1,
                                        children: (ref3 = item.collection) === null || ref3 === void 0 ? void 0 : ref3.title
                                    }),
                                    item.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                        fontSize: "small",
                                        sx: {
                                            color: "info.main",
                                            height: 12,
                                            width: 12,
                                            ml: 1
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: item.title
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    flexGrow: 1,
                                    children: item.title
                                }),
                                item.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                    fontSize: "small",
                                    sx: {
                                        color: "info.main",
                                        height: 12,
                                        width: 12,
                                        ml: 1
                                    }
                                })
                            ]
                        })
                    }),
                    item.price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        children: item.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                            variant: "subtitle1",
                            children: [
                                "\xa5 ",
                                item.formattedPrice
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                    variant: "subtitle1",
                                    children: item.formattedPrice
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "primary",
                        children: t("free", "無料")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/ArtistStoreCollectionBoxSkeleton/index.tsx




var ArtistStoreCollectionBoxSkeleton = function(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                bgcolor: "transparent",
                borderRadius: 0,
                width: width
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    height: 90,
                    sx: {
                        borderRadius: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "subtitle1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "caption",
                            width: "50%"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(47746);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Popover/Popover.js
var Popover = __webpack_require__(47019);
// EXTERNAL MODULE: ../../node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js
var connectStateResults = __webpack_require__(16818);
// EXTERNAL MODULE: ./src/components/layouts/Header.tsx
var Header = __webpack_require__(92016);
// EXTERNAL MODULE: ./src/components/organisms/store/StoreItemAreaSkeleton/index.tsx
var StoreItemAreaSkeleton = __webpack_require__(12683);
;// CONCATENATED MODULE: ./src/components/organisms/gacha/GachaBoxSkeleton/index.tsx



var GachaBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            display: "flex"
        },
        direction: "row",
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 136,
                height: 102
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                sx: {
                    flex: 1,
                    width: 163
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "60%"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/event/EventCardSkeleton/index.tsx




var EventCardSkeleton = function(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 160
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h3",
                            width: "10%",
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h3",
                            width: "100%",
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                numberOfLine: 2
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/event/EventCard/useEventCategoryTag.ts



/**
 * イベントの状態（開催前、開催中、終了、先行販売の状態など）を判定するフック
 * 表示用のスタイル情報（色、背景色、テキスト）を返す
 */ var useEventCategoryTag = function(event, t) {
    var ref;
    return (0,react.useMemo)(function() {
        var ref, ref1;
        var havePreSales = !!((ref = event.preSales) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length);
        if (havePreSales) {
            var ref2, ref3, ref4;
            //先行販売(先着・抽選)が期間前 → 受付前
            var upcomingPreSale = (ref2 = event.preSales) === null || ref2 === void 0 ? void 0 : ref2.edges.every(function(param) {
                var node = param.node;
                var ref;
                if (node.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery) {
                    var ref1;
                    return values_Date/* DateTime.isGt */.o.isGt((ref1 = node.lottery) === null || ref1 === void 0 ? void 0 : ref1.applicationStartedAt);
                }
                return values_Date/* DateTime.isGt */.o.isGt((ref = node.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.purchasableStartedAt);
            });
            if (upcomingPreSale) {
                return {
                    color: "text.primary",
                    bgcolor: "info.light",
                    text: t("upcomingPreSale", "受付前")
                };
            }
            //先行販売(先着・抽選)が期間内 → 受付中
            var ongoingPreSale = (ref3 = event.preSales) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.edges) === null || ref4 === void 0 ? void 0 : ref4.some(function(param) {
                var node = param.node;
                var ref, ref1;
                if (node.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery) {
                    var ref2, ref3;
                    return values_Date/* DateTime.isBetween */.o.isBetween((ref2 = node.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationStartedAt, (ref3 = node.lottery) === null || ref3 === void 0 ? void 0 : ref3.applicationEndedAt);
                }
                return values_Date/* DateTime.isBetween */.o.isBetween((ref = node.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.purchasableStartedAt, (ref1 = node.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableEndedAt);
            });
            if (ongoingPreSale) {
                return {
                    color: "text.primary",
                    bgcolor: "info.light",
                    text: t("ongoingPreSale", "受付中")
                };
            }
        }
        //先行販売期間後
        // event not set endedAt & startedAt → 開催日設定なし
        if (!event.endedAt && !event.startedAt) {
            return {
                color: "text.secondary",
                bgcolor: "grey.100",
                text: t("noDateSet", "開催日設定なし")
            };
        }
        //イベント期間が過去 → 終了
        if (event.endedAt && values_Date/* DateTime.isLt */.o.isLt(event.endedAt)) {
            return {
                color: "text.disabled",
                bgcolor: "grey.100",
                text: t("end", "終了")
            };
        }
        //イベント期間が未来 → 開催前
        if (values_Date/* DateTime.isGt */.o.isGt(event.startedAt)) {
            return {
                color: "text.primary",
                bgcolor: "info.light",
                text: t("upcoming", "開催前")
            };
        }
        //イベント中 → 開催中
        return {
            color: "white",
            bgcolor: "secondary.main",
            text: t("ongoing", "開催中")
        };
    }, [
        event.endedAt,
        (ref = event.preSales) === null || ref === void 0 ? void 0 : ref.edges,
        event.startedAt,
        t
    ]);
};

;// CONCATENATED MODULE: ./src/components/organisms/event/EventCard/index.tsx









var EventCard = function(param) {
    var event = param.event, sx = param.sx;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            borderRadius: 2
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
            href: generatePath(routerPages.ShokufesEventDetail, {
                eventId: event.id
            }),
            sx: {
                height: "100%"
            },
            onClick: function() {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    eventId: event.id,
                    name: "eventFes"
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                    sx: {
                        height: 160
                    },
                    image: (ref3 = (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref3 !== void 0 ? ref3 : "",
                    title: event.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        !!(event.startedAt || event.endedAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                            event: event
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: (0,src_object_spread/* default */.Z)({
                                pt: 2
                            }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                            children: event.title
                        }),
                        event.dateRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.700"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    children: event.dateRange
                                })
                            ]
                        }),
                        event.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            sx: {
                                pt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.700"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    children: (ref1 = event.location) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var EventCategory = function(param) {
    var event = param.event;
    var t = (0,core_i18n/* useTranslation */.$G)("events").t;
    var ref = useEventCategoryTag(event, t), color = ref.color, bgcolor = ref.bgcolor, text = ref.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 20,
            borderRadius: "2px",
            minWidth: 40,
            bgcolor: bgcolor,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: color,
            variant: "overline",
            display: "block",
            children: text
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/community/ThreadBoxSkeleton/index.tsx


var ThreadBoxSkeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? "100%" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 7,
        sx: {
            width: width
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 85,
                height: 68
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 15
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 15
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "40%",
                                height: 15
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "20%",
                                height: 15
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(35460);
// EXTERNAL MODULE: ../../node_modules/geopattern/geopattern.js
var geopattern = __webpack_require__(60092);
var geopattern_default = /*#__PURE__*/__webpack_require__.n(geopattern);
// EXTERNAL MODULE: ./src/components/organisms/community/ThreadCategory/index.tsx
var ThreadCategory = __webpack_require__(14971);
;// CONCATENATED MODULE: ./src/components/organisms/community/ThreadBox/index.tsx









var ThreadBox = function(param) {
    var thread = param.thread, hasPatron = param.hasPatron, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire, _width = param.width, width = _width === void 0 ? "100%" : _width, onClick = param.onClick;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var isAccessible = thread.isAccessible || hasPatron;
    var ref7, ref8, ref9, _category, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 0,
            width: width,
            bgcolor: "transparent"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadBoxCell, {
            isAccessible: isAccessible,
            isShowModalPersonalInfoRequire: isShowModalPersonalInfoRequire && thread.isPremium,
            id: thread.id,
            artistId: (ref7 = (ref = thread.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref7 !== void 0 ? ref7 : "",
            displayName: (ref8 = (ref1 = thread.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName) !== null && ref8 !== void 0 ? ref8 : "",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 0,
                    "&:last-child": {
                        pb: 0
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "relative"
                            },
                            children: ((ref2 = thread.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        variant: "square",
                                        src: (ref9 = (ref3 = thread.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.mediumUri) !== null && ref9 !== void 0 ? ref9 : "",
                                        sx: {
                                            width: 85,
                                            height: 64,
                                            borderRadius: "8px"
                                        }
                                    }),
                                    thread.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        sx: {
                                            inset: 0,
                                            position: "absolute",
                                            bgcolor: "rgba(0, 0, 0, 0.5)",
                                            borderRadius: "8px"
                                        },
                                        alignItems: "center",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                            sx: {
                                                color: "white"
                                            }
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            width: 85,
                                            height: 64,
                                            borderRadius: "8px",
                                            backgroundImage: geopattern_default().generate(thread.id).toDataUrl(),
                                            backgroundSize: "150px",
                                            filter: "contrast(1.3) brightness(1.3)"
                                        }
                                    }),
                                    thread.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        sx: {
                                            inset: 0,
                                            position: "absolute",
                                            bgcolor: "rgba(0, 0, 0, 0.5)",
                                            borderRadius: "8px"
                                        },
                                        alignItems: "center",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                            sx: {
                                                color: "white"
                                            }
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            flex: 1,
                            sx: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            spacing: 2,
                                            sx: {
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: thread.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: (ref4 = thread.latestComment) === null || ref4 === void 0 ? void 0 : ref4.content
                                                })
                                            ]
                                        }),
                                        !!((ref5 = thread.userUnread) === null || ref5 === void 0 ? void 0 : ref5.unreadMentionCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                            badgeContent: thread.userUnread.unreadMentionCount,
                                            color: "like",
                                            sx: {
                                                position: "relative",
                                                color: "white",
                                                top: 36,
                                                right: 15,
                                                width: 20,
                                                height: 20,
                                                "& > span": {
                                                    fontWeight: "bold",
                                                    fontSize: 9,
                                                    minWidth: 20,
                                                    height: 20,
                                                    p: "2px",
                                                    bgcolor: "like.tap"
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        !(!thread.isOfficial && !thread.category) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCategory/* ThreadCategory */.v, {
                                            isOfficial: thread.isOfficial,
                                            category: (_category = thread.category) !== null && _category !== void 0 ? _category : ""
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                !thread.isAllowNotification && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.AudioOff, {
                                                    sx: {
                                                        color: "grey.300"
                                                    },
                                                    fontSize: "small"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "text.hint",
                                                    children: (ref10 = (ref6 = thread.latestComment) === null || ref6 === void 0 ? void 0 : ref6.formattedCreatedAt) !== null && ref10 !== void 0 ? ref10 : thread.formattedCreatedAt
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var ThreadBoxCell = function(param) {
    var isAccessible = param.isAccessible, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire, id = param.id, artistId = param.artistId, displayName = param.displayName, children = param.children, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        sx: {
            width: "100%",
            height: "100%",
            position: "relative"
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1
                },
                onClick: function() {
                    !isAccessible && setOpen(true);
                    isShowModalPersonalInfoRequire && showModal();
                    onClick && onClick();
                },
                href: isAccessible && !isShowModalPersonalInfoRequire ? generatePath(routerPages.ArtistThreadDetail, {
                    threadId: id
                }) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("viewMemberInfoTitle"),
                content: t("viewMemberInfoDesc", {
                    displayName: displayName
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    href: generatePath(routerPages.ArtistMembership, {
                        artistId: artistId
                    }),
                    children: t("seeDetail")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(43524);
// EXTERNAL MODULE: ./src/components/pages/Errors/NotFound/index.tsx + 1 modules
var NotFound = __webpack_require__(24128);
;// CONCATENATED MODULE: ./src/components/pages/ArtistTop/template/index.tsx































var template_client = algolia/* client */.Lp();
var ArtistTopTemplate = function(param) {
    var state = param.state, onFollow = param.onFollow, onUnfollow = param.onUnfollow, onLikePost = param.onLikePost, onClickShare = param.onClickShare, onUnBlock = param.onUnBlock;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var publishedAtTimestampRef = (0,react.useRef)(values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds());
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var itemResultRef = (0,react.useRef)({
        items: [],
        page: 1
    });
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var isActive = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref = state.membership) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.some(function(product) {
            var ref;
            return product === null || product === void 0 ? void 0 : (ref = product.plans) === null || ref === void 0 ? void 0 : ref.some(function(plan) {
                return plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
            });
        });
    }, [
        (ref = state.membership) === null || ref === void 0 ? void 0 : ref.products
    ]);
    var membershipContent = (0,react.useMemo)(function() {
        var ref, ref1;
        var product = (ref = state.membership) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.find(function(product) {
            var ref;
            return product === null || product === void 0 ? void 0 : (ref = product.plans) === null || ref === void 0 ? void 0 : ref.some(function(plan) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                return ((ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId) ? plan.planId === ((ref3 = state.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.patron) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription) === null || ref5 === void 0 ? void 0 : ref5.planId) : plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
            });
        });
        return product === null || product === void 0 ? void 0 : product.content;
    }, [
        (ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.patron,
        (ref2 = state.membership) === null || ref2 === void 0 ? void 0 : ref2.products
    ]);
    var handleOnCompleted = (0,react.useCallback)(function(items, param) {
        var page = param.page;
        itemResultRef.current = {
            items: items,
            page: page
        };
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "artist_store_list",
            item_list_name: "Artist Store Items",
            items: items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var handleSelectItem = (0,react.useCallback)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            items: itemResultRef.current.items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: itemResultRef.current.page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var handleToList = (0,react.useCallback)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
            item_list_id: "artist_store_list_related_".concat(state.artistId),
            item_list_name: "Artist Store Related Items",
            items: itemResultRef.current.items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: itemResultRef.current.page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    return !(!state.loading && state.artist === null) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            safeArea: {
                pt: 0
            },
            navigation: {
                type: "artist",
                props: {
                    isLive: !!((ref3 = state.liveStream) === null || ref3 === void 0 ? void 0 : ref3.id),
                    hasManagementTask: !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.hasManagementTask),
                    unreadNotificationCount: (ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.unreadNotificationCount
                },
                responsive: displayResponsive
            },
            maxWidth: displayResponsive ? 1120 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistTop,
                        (ref6 = state.artist) === null || ref6 === void 0 ? void 0 : ref6.displayName
                    ]
                }),
                (state === null || state === void 0 ? void 0 : state.isBlocked) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockedArtistCell, {
                            loading: state.loading,
                            artist: state.artist,
                            user: state.user,
                            isArtist: state.isArtist,
                            followArtists: state.followArtists,
                            memberArtists: state.memberArtists,
                            onUnBlock: onUnBlock,
                            responsive: displayResponsive
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                px: 5,
                                py: 3
                            },
                            children: t("blockedArtistDescription")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistCell, {
                            loading: state.loading,
                            artist: state.artist,
                            artistId: state.artistId,
                            onFollow: onFollow,
                            onUnfollow: onUnfollow,
                            user: state.user,
                            isArtist: state.isArtist,
                            liveStream: state.liveStream,
                            followArtists: state.followArtists,
                            memberArtists: state.memberArtists,
                            isMember: !!((ref7 = state.artist) === null || ref7 === void 0 ? void 0 : ref7.patron),
                            myRanking: state.myRanking,
                            hasMission: state.hasMission,
                            responsive: displayResponsive
                        }),
                        state.artist && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroductionCell, {
                            id: state.artist.id,
                            profileText: state.artist.profileText,
                            displayName: state.artist.displayName,
                            sns: state.artist.sns,
                            textLink: state.artist.textLink,
                            onClickShare: onClickShare
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannersCell, {
                            loading: state.loading,
                            banners: state.banners,
                            user: state.user
                        }),
                        isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCell, {
                            loading: state.loading,
                            membership: state.membership,
                            artistId: (ref8 = state.artist) === null || ref8 === void 0 ? void 0 : ref8.id,
                            content: membershipContent,
                            isMember: !!((ref9 = state.artist) === null || ref9 === void 0 ? void 0 : ref9.patron),
                            isPersonalInformationRequired: !!((ref10 = state.artist) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.patron) === null || ref11 === void 0 ? void 0 : ref11.isPersonalInformationRequired),
                            isMembershipPersonalInformationRequired: !!((ref12 = state.user) === null || ref12 === void 0 ? void 0 : ref12.isMembershipPersonalInformationRequired)
                        }),
                        !!((ref13 = state.notifications) === null || ref13 === void 0 ? void 0 : ref13.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationListsCell, {
                            notifications: state.notifications,
                            artistId: state === null || state === void 0 ? void 0 : state.artistId
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEventsCell, {
                            artistId: state.artistId,
                            loading: state.loading,
                            events: state.events
                        }),
                        !(0,individual/* individualHideArtistNewPosts */.H9)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPostsCell, {
                            loading: state.loading,
                            newPosts: state.newPosts,
                            artistId: state.artistId,
                            onLikePost: onLikePost,
                            isMembershipPersonalInformationRequired: !!((ref14 = state.user) === null || ref14 === void 0 ? void 0 : ref14.isMembershipPersonalInformationRequired)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewThreadsCell, {
                            loading: state.loading,
                            newThreads: state.newThreads,
                            artistId: state.artistId,
                            isMember: !!((ref15 = state.artist) === null || ref15 === void 0 ? void 0 : ref15.patron),
                            isShowModalPersonalInfoRequire: !!((state === null || state === void 0 ? void 0 : (ref16 = state.user) === null || ref16 === void 0 ? void 0 : ref16.isMembershipPersonalInformationRequired) && (state === null || state === void 0 ? void 0 : (ref17 = state.artist) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.patron) === null || ref18 === void 0 ? void 0 : ref18.isPersonalInformationRequired))
                        }),
                        config_config/* config.modules.store */.v.modules.store && config_config/* config.modules.item */.v.modules.item && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                            indexName: algolia/* indexes.items */.RG.items,
                            searchClient: template_client,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                                    hitsPerPage: 10,
                                    filters: algolia/* filters.itemStoreArtist */.u8.itemStoreArtist(state.artistId, publishedAtTimestampRef.current)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoresCellWithAlgolia, {
                                    loading: state.loading,
                                    artistId: state.artistId,
                                    onSelectItem: handleSelectItem,
                                    onToList: handleToList,
                                    responsive: displayResponsive
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreStateResults, {
                                    onCompleted: handleOnCompleted
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMissionsCell, {
                            loading: state.loading,
                            newMissions: state.newMissions,
                            artistId: state.artistId
                        }),
                        config_config/* config.modules.gacha */.v.modules.gacha && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGachasCell, {
                            loading: state.loading,
                            newGachas: state.newGachas,
                            artistId: state.artistId
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
        useNextRouter: false
    });
};
var ArtistCell = function(param) {
    var loading = param.loading, artist = param.artist, artistId = param.artistId, liveStream = param.liveStream, followArtists = param.followArtists, memberArtists = param.memberArtists, user = param.user, isArtist = param.isArtist, isMember = param.isMember, onFollow = param.onFollow, onUnfollow = param.onUnfollow, myRanking = param.myRanking, hasMission = param.hasMission, responsive = param.responsive;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,ArtistThemeProvider/* useArtistThemeContext */.ff)(), 1), bgImage = ref1[0].bgImage;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: "100vw",
                    maxHeight: 744,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    "& header": {
                        visibility: "visible"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderCell, {
                        artist: artist,
                        liveStream: liveStream,
                        artistId: artistId,
                        followArtists: followArtists,
                        memberArtists: memberArtists,
                        user: user,
                        isArtist: isArtist,
                        isMember: isMember,
                        myRanking: myRanking,
                        hasMission: hasMission,
                        responsive: responsive
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistInfoCell, {
                        artist: artist,
                        artistId: artistId,
                        onFollow: onFollow,
                        onUnfollow: onUnfollow
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
                maxWidth: responsive ? 1120 : undefined,
                hasSafeArea: true,
                // グラデーションマスクを表示しないアプリを指定
                gradationMask: false,
                bgImage: bgImage,
                imageUri: artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.mediumUri,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    sx: {
                        height: "100%"
                    },
                    in: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderCell, {
                        artist: artist,
                        liveStream: liveStream,
                        artistId: artistId,
                        followArtists: followArtists,
                        memberArtists: memberArtists,
                        user: user,
                        isArtist: isArtist,
                        isMember: isMember,
                        myRanking: myRanking,
                        hasMission: hasMission,
                        responsive: responsive
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistInfoCell, {
                artist: artist,
                artistId: artistId,
                onFollow: onFollow,
                onUnfollow: onUnfollow
            })
        ]
    });
};
var ArtistHeaderCell = function(param) {
    var artist = param.artist, liveStream = param.liveStream, artistId = param.artistId, myRanking = param.myRanking, followArtists = param.followArtists, memberArtists = param.memberArtists, user = param.user, isArtist = param.isArtist, isMember = param.isMember, hasMission = param.hasMission, responsive = param.responsive;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var ref2 = (0,react.useState)(false), openSideMenu = ref2[0], setOpenSideMenu = ref2[1];
    var ref3 = (0,react.useState)(false), openMembershipOnlyModal = ref3[0], setOpenMembershipOnlyModal = ref3[1];
    var liveStreamButtonAction = (0,react.useMemo)(function() {
        var ref;
        // メンバー限定配信ではない時
        if (!(liveStream === null || liveStream === void 0 ? void 0 : liveStream.isPremium)) {
            return {
                href: (liveStream === null || liveStream === void 0 ? void 0 : liveStream.id) ? generatePath(routerPages.LiveDetail, {
                    liveStreamId: liveStream.id
                }) : undefined
            };
        }
        // is member and user need enter information
        if (isMember && (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) && (artist === null || artist === void 0 ? void 0 : (ref = artist.patron) === null || ref === void 0 ? void 0 : ref.isPersonalInformationRequired)) {
            return {
                onClick: function onClick() {
                    showModal();
                }
            };
        }
        // メンバー限定配信且つメンバーの時
        if (isMember) {
            return {
                href: (liveStream === null || liveStream === void 0 ? void 0 : liveStream.id) ? generatePath(routerPages.LiveDetail, {
                    liveStreamId: liveStream.id
                }) : undefined
            };
        }
        // メンバー限定配信且つメンバーではない時
        return {
            onClick: liveStream.isPremium ? function() {
                return setOpenMembershipOnlyModal(true);
            } : undefined
        };
    }, [
        liveStream === null || liveStream === void 0 ? void 0 : liveStream.isPremium,
        liveStream === null || liveStream === void 0 ? void 0 : liveStream.id,
        isMember,
        user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired,
        artist === null || artist === void 0 ? void 0 : (ref = artist.patron) === null || ref === void 0 ? void 0 : ref.isPersonalInformationRequired,
        generatePath,
        routerPages.LiveDetail,
        showModal, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        justifyContent: "space-between",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        color: "transparent",
                        elevation: 0,
                        position: "absolute",
                        sx: {
                            backgroundColor: "transparent"
                        },
                        left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                            edge: "start",
                            onClick: function() {
                                return setOpenSideMenu(!openSideMenu);
                            },
                            badge: (user === null || user === void 0 ? void 0 : user.hasManagementTask) || !!(user === null || user === void 0 ? void 0 : user.unreadNotificationCount),
                            color: "icon.line",
                            bgcolor: "icon.background"
                        }),
                        right: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 3,
                            alignItems: "center",
                            children: [
                                (liveStream === null || liveStream === void 0 ? void 0 : liveStream.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    variant: "contained",
                                    color: "like",
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Live, {
                                        sx: {
                                            color: "white"
                                        }
                                    }),
                                    sx: {
                                        color: "white",
                                        borderRadius: 1,
                                        width: 82,
                                        bgcolor: "like.tap"
                                    }
                                }, liveStreamButtonAction), {
                                    children: "LIVE"
                                })),
                                (myRanking === null || myRanking === void 0 ? void 0 : myRanking.rank) && myRanking.rank <= 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    sx: {
                                        width: 48,
                                        height: 48,
                                        borderRadius: 1
                                    },
                                    href: generatePath(routerPages.ArtistRanking, {
                                        artistId: artistId
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                                        rank: myRanking.rank,
                                        size: "xSmall"
                                    })
                                }),
                                /**
                 * @description
                 * 暫定対応でdiicaのみミッション一覧への動線追加
                 * https://app.clickup.com/t/908127/UT-9852
                 */ hasMission && config_config/* config.modules.mission */.v.modules.mission && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Mission, {
                                    color: "icon.line",
                                    bgcolor: "icon.background",
                                    size: "medium",
                                    href: generatePath(routerPages.ArtistMissions, {
                                        artistId: artistId
                                    })
                                }),
                                user && config_config/* config.applicationType */.v.applicationType === "standalone" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    children: [
                                        config_config/* config.modules.campaign */.v.modules.campaign && config_config/* config.modules.mission */.v.modules.mission && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Event, {
                                            size: "medium",
                                            href: generatePath(routerPages.GlobalEvents),
                                            color: "icon.line",
                                            bgcolor: "icon.background"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Notice, {
                                            size: "medium",
                                            href: routerPages.Notifications,
                                            color: "icon.line",
                                            bgcolor: "icon.background"
                                        })
                                    ]
                                })
                            ]
                        }),
                        maxWidth: responsive ? 1120 : undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        followArtists: followArtists,
                        memberArtists: memberArtists,
                        open: openSideMenu,
                        onClose: function() {
                            return setOpenSideMenu(false);
                        },
                        user: user,
                        isArtist: isArtist,
                        responsive: responsive
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipOnlyModalCell, {
                open: openMembershipOnlyModal,
                onClose: function() {
                    return setOpenMembershipOnlyModal(false);
                },
                artistId: artistId,
                displayName: (artist === null || artist === void 0 ? void 0 : artist.displayName) || ""
            })
        ]
    });
};
var ArtistInfoCell = function(param) {
    var artist = param.artist, artistId = param.artistId, onFollow = param.onFollow, onUnfollow = param.onUnfollow;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,react.useState)(false), openMembershipOnlyModal = ref[0], setOpenMembershipOnlyModal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        sx: {
            mt: 4,
            mb: (artist === null || artist === void 0 ? void 0 : artist.profileText) ? 2 : 6
        },
        children: [
            config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pl: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "text.primary",
                                variant: "h2",
                                children: artist === null || artist === void 0 ? void 0 : artist.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "text.secondary",
                                variant: "caption",
                                children: artist === null || artist === void 0 ? void 0 : artist.formattedAccountId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pr: 5,
                            ml: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: (artist === null || artist === void 0 ? void 0 : artist.follower) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                size: "small",
                                onClick: handleLoginModal(onUnfollow),
                                sx: {
                                    px: 4,
                                    width: "100px"
                                },
                                children: t("following")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "small",
                                onClick: handleLoginModal(onFollow),
                                sx: {
                                    px: 4,
                                    width: "100px"
                                },
                                children: t("follow")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipOnlyModalCell, {
                open: openMembershipOnlyModal,
                onClose: function() {
                    return setOpenMembershipOnlyModal(false);
                },
                artistId: artistId,
                displayName: (artist === null || artist === void 0 ? void 0 : artist.displayName) || ""
            })
        ]
    });
};
var IntroductionCell = function(param) {
    var id = param.id, profileText = param.profileText, displayName = param.displayName, sns = param.sns, textLink = param.textLink, onClickShare = param.onClickShare;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: profileText ? 6 : 0
        },
        children: [
            profileText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                children: profileText
            }),
            !!profileText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "text",
                sx: {
                    p: 0,
                    mt: 1
                },
                onClick: function() {
                    return setOpen(true);
                },
                children: t("seeArtistProfile")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                        px: 5,
                        pb: 6
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            sx: {
                                py: 5
                            },
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        width: "100%",
                                        variant: "h6",
                                        align: "center",
                                        children: displayName
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                    edge: "end",
                                    size: "small",
                                    onClick: function() {
                                        return setOpen(false);
                                    }
                                })
                            ]
                        }),
                        !!profileText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: profileText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 4,
                            sx: {
                                pb: 3
                            },
                            children: [
                                (sns === null || sns === void 0 ? void 0 : sns.instagram) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Instagram, {
                                    component: "a",
                                    size: "xLarge",
                                    disabled: !(sns === null || sns === void 0 ? void 0 : sns.instagram),
                                    href: (ref1 = sns === null || sns === void 0 ? void 0 : sns.instagram) !== null && ref1 !== void 0 ? ref1 : "#",
                                    target: "_blank"
                                }),
                                (sns === null || sns === void 0 ? void 0 : sns.twitter) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Twitter, {
                                    component: "a",
                                    size: "xLarge",
                                    disabled: !(sns === null || sns === void 0 ? void 0 : sns.twitter),
                                    href: (ref2 = sns === null || sns === void 0 ? void 0 : sns.twitter) !== null && ref2 !== void 0 ? ref2 : "#",
                                    target: "_blank"
                                }),
                                (sns === null || sns === void 0 ? void 0 : sns.tiktok) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Tiktok, {
                                    component: "a",
                                    size: "xLarge",
                                    disabled: !(sns === null || sns === void 0 ? void 0 : sns.tiktok),
                                    href: (ref3 = sns === null || sns === void 0 ? void 0 : sns.tiktok) !== null && ref3 !== void 0 ? ref3 : "#",
                                    target: "_blank"
                                }),
                                (sns === null || sns === void 0 ? void 0 : sns.facebook) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Facebook, {
                                    component: "a",
                                    size: "xLarge",
                                    disabled: !(sns === null || sns === void 0 ? void 0 : sns.facebook),
                                    href: (ref4 = sns === null || sns === void 0 ? void 0 : sns.facebook) !== null && ref4 !== void 0 ? ref4 : "#",
                                    target: "_blank"
                                }),
                                (sns === null || sns === void 0 ? void 0 : sns.youtube) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Youtube, {
                                    component: "a",
                                    size: "xLarge",
                                    disabled: !(sns === null || sns === void 0 ? void 0 : sns.youtube),
                                    href: (ref5 = sns === null || sns === void 0 ? void 0 : sns.youtube) !== null && ref5 !== void 0 ? ref5 : "#",
                                    target: "_blank"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SNSIconButton.Share, {
                                    size: "xLarge",
                                    onClick: onClickShare
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                            children: !!textLink && (textLink === null || textLink === void 0 ? void 0 : textLink.length) > 0 && (textLink === null || textLink === void 0 ? void 0 : textLink.map(function(textLink) {
                                if (!textLink) return;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                    sx: {
                                        height: 52,
                                        px: 0
                                    },
                                    divider: true,
                                    href: (textLink === null || textLink === void 0 ? void 0 : textLink.uri) || "",
                                    component: "a",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: textLink === null || textLink === void 0 ? void 0 : textLink.content
                                    })
                                });
                            }))
                        })
                    ]
                })
            })
        ]
    });
};
var BannersCell = function(param) {
    var banners = param.banners, loading = param.loading, user = param.user;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: banners.length > 0 ? 6 : 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            children: [
                loading && [
                    1,
                    2
                ].map(function(i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 140
                    }, i);
                }),
                banners.map(function(b, i) {
                    var ref3, ref4, ref5;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                        in: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                            children: ((ref3 = b.link) === null || ref3 === void 0 ? void 0 : ref3.externalUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                component: "a",
                                target: "_blank",
                                href: (0,lib_url/* replaceParameters */.yB)((ref4 = b.link) === null || ref4 === void 0 ? void 0 : ref4.externalUrl, {
                                    uid: (ref = user === null || user === void 0 ? void 0 : user.id) !== null && ref !== void 0 ? ref : ""
                                }) || "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                    component: "img",
                                    image: b.thumbnail.mediumUri || ""
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                href: (0,lib_url/* replaceParameters */.yB)((ref1 = (ref5 = b.link) === null || ref5 === void 0 ? void 0 : ref5.innerPath) !== null && ref1 !== void 0 ? ref1 : "", {
                                    uid: (ref2 = user === null || user === void 0 ? void 0 : user.id) !== null && ref2 !== void 0 ? ref2 : ""
                                }) || "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                    component: "img",
                                    image: b.thumbnail.mediumUri || ""
                                })
                            })
                        })
                    }, i);
                })
            ]
        })
    });
};
/**
 * 漫画アプリ用のバナー表示
 * こちらはカルーセル
 * https://zpl.io/MdMJ8nd
 */ var MagazineBannersCell = function(param) {
    var banners = param.banners, loading = param.loading, user = param.user;
    var isMultiple = !!banners && (banners === null || banners === void 0 ? void 0 : banners.length) > 1;
    if (loading) {
        return /*#__PURE__*/ _jsx(Skeleton, {
            variant: "rectangular",
            sx: {
                width: "90vw",
                maxWidth: "600px",
                margin: "8px auto 0",
                borderRadius: 2,
                height: "calc(90vw * 184 / 335)",
                maxHeight: "calc(540px * 184 / 335)"
            }
        });
    }
    var ref, ref1, ref2;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            px: 5,
            py: 5,
            ".swiper-pagination-bullet-active": {
                bgcolor: "grey.700"
            }
        },
        children: /*#__PURE__*/ _jsx(Swiper, {
            pagination: {
                clickable: true
            },
            modules: [
                Pagination
            ],
            loop: isMultiple,
            slidesPerView: 1.2,
            centeredSlides: true,
            spaceBetween: 10,
            enabled: isMultiple,
            style: {
                paddingBottom: isMultiple ? 40 : 0
            },
            children: banners.map(function(b, i) {
                var ref3, ref4, ref5;
                /*#__PURE__*/ return _jsx(SwiperSlide, {
                    children: /*#__PURE__*/ _jsx(Card, {
                        children: ((ref3 = b.link) === null || ref3 === void 0 ? void 0 : ref3.externalUrl) ? /*#__PURE__*/ _jsx(CardActionArea, {
                            component: "a",
                            target: "_blank",
                            href: replaceParameters((ref4 = b.link) === null || ref4 === void 0 ? void 0 : ref4.externalUrl, {
                                uid: (ref = user === null || user === void 0 ? void 0 : user.id) !== null && ref !== void 0 ? ref : ""
                            }) || "",
                            children: /*#__PURE__*/ _jsx(CardMedia, {
                                component: "img",
                                image: b.thumbnail.mediumUri || ""
                            })
                        }) : /*#__PURE__*/ _jsx(CardActionArea, {
                            href: replaceParameters((ref1 = (ref5 = b.link) === null || ref5 === void 0 ? void 0 : ref5.innerPath) !== null && ref1 !== void 0 ? ref1 : "", {
                                uid: (ref2 = user === null || user === void 0 ? void 0 : user.id) !== null && ref2 !== void 0 ? ref2 : ""
                            }) || "",
                            children: /*#__PURE__*/ _jsx(CardMedia, {
                                component: "img",
                                height: 140,
                                image: b.thumbnail.mediumUri || ""
                            })
                        })
                    })
                }, i);
            })
        })
    });
};
var MembershipCell = function(param) {
    var loading = param.loading, membership = param.membership, artistId = param.artistId, content = param.content, isMember = param.isMember, isPersonalInformationRequired = param.isPersonalInformationRequired, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "medium",
                width: "50%",
                sx: {
                    pb: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                numberOfLine: 3,
                lastWidth: "75%"
            })
        ]
    });
    if (!membership || !config_config/* config.modules.membership */.v.modules.membership) return null;
    // ろこまこあこアプリの場合、メンバーシップの詳細項目を非表示
    if (config_config/* config.applicationKey */.v.applicationKey === "rocomacoaco") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: {
                py: 5,
                pb: 8
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                href: artistId ? generatePath(routerPages.ArtistMembership, {
                    artistId: artistId
                }) : undefined,
                sx: {
                    mx: "auto",
                    width: 244,
                    mt: 6
                },
                color: isMember ? "inherit" : "primary",
                children: t(isMember ? "seeOther" : "seeMember")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        in: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                pb: 6
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                variant: "outlined",
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            p: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        children: t("benefit")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            isMember && isPersonalInformationRequired && isMembershipPersonalInformationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnregisteredInfoLabel, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanLabel, {
                                                planRelationship: isMember ? "joined" : "unjoined"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                sx: {
                                    mt: 3
                                },
                                children: content
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            href: artistId ? generatePath(routerPages.ArtistMembership, {
                                artistId: artistId
                            }) : undefined,
                            sx: {
                                mx: "auto",
                                width: 244,
                                mt: 6
                            },
                            color: isMember ? "inherit" : "primary",
                            children: t(isMember ? "seeOther" : "becomeMember")
                        })
                    })
                ]
            })
        })
    });
};
var NotificationListsCell = function(param) {
    var notifications = param.notifications, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 4,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        children: t("officialNotificationLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "h6",
                        href: generatePath(routerPages.ArtistOfficialInformation, {
                            artistId: artistId
                        }),
                        children: t("toList")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: notifications === null || notifications === void 0 ? void 0 : notifications.map(function(param, index) {
                    var node = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(NotificationItemCell, {
                        notification: node,
                        divider: (notifications === null || notifications === void 0 ? void 0 : notifications.length) - 1 > index,
                        isExternalLink: node.link ? (0,lib_url/* isExternalLink */.Bm)(node.link) : false
                    }, node.id);
                })
            })
        ]
    });
};
var NotificationItemCell = function(param) {
    var notification = param.notification, divider = param.divider, isExternalLink = param.isExternalLink;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var _link;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((_link = notification.link) !== null && _link !== void 0 ? _link : "").onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
        component: isExternalLink ? "p" : Link/* default */.Z,
        href: notification.link || generatePath(routerPages.OfficialInformationDetail, {
            notificationId: notification.id
        }),
        onClick: isExternalLink ? onClick : undefined,
        sx: {
            height: "auto",
            py: 3,
            px: 0
        },
        divider: divider,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                primary: notification.title,
                slotProps: {
                    primary: {
                        variant: "body2",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2)
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Transition, {
                    fontSize: "xSmall"
                })
            })
        ]
    });
};
var NewStoresCellWithAlgolia = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var loading = param.loading, hits = param.hits, artistId = param.artistId, onSelectItem = param.onSelectItem, onToList = param.onToList, responsive = param.responsive;
    var newStores = hits.map(function(_param) {
        var objectID = _param.objectID, item = (0,_object_without_properties/* default */.Z)(_param, [
            "objectID"
        ]);
        return (0,src_object_spread/* default */.Z)({
            id: objectID
        }, item);
    });
    // アイテムがない場合、ストア項目を非表示
    if (!newStores.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoresCell, {
        loading: loading,
        newStores: newStores,
        artistId: artistId,
        onSelectItem: onSelectItem,
        onToList: onToList,
        responsive: responsive
    });
});
var NewStoresCell = function(param) {
    var loading = param.loading, newStores = param.newStores, artistId = param.artistId, onSelectItem = param.onSelectItem, onToList = param.onToList, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        loadingItemLength: 7,
        title: t("newStore"),
        spacing: 1,
        transTypographyProps: {
            onClick: onToList
        },
        listHref: generatePath(routerPages.ArtistStore, {
            artistId: artistId
        }),
        items: newStores,
        trans: t("toList"),
        LoadingComponent: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemAreaSkeleton/* StoreItemAreaSkeleton */.E, {
                size: "small"
            });
        },
        renderItem: function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemArea/* StoreItemArea */.S, (0,src_object_spread/* default */.Z)({
                item: item,
                size: "small",
                artistId: artistId,
                onClick: onSelectItem
            }, responsive ? {
                responsive: true,
                aspectRatio: "1 / 1"
            } : {}), i);
        }
    });
};
var StoreStateResults = (0,connectStateResults/* default */.Z)(function(param) {
    var searchResults = param.searchResults, onCompleted = param.onCompleted;
    var ref;
    (0,react.useEffect)(function() {
        var ref;
        if ((searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.hits) === null || ref === void 0 ? void 0 : ref.length) != undefined) {
            var items = searchResults.hits.map(function(_param) {
                var objectID = _param.objectID, item = (0,_object_without_properties/* default */.Z)(_param, [
                    "objectID"
                ]);
                return (0,src_object_spread/* default */.Z)({
                    id: objectID
                }, item);
            });
            var ref1;
            onCompleted && onCompleted(items, {
                page: ((ref1 = searchResults === null || searchResults === void 0 ? void 0 : searchResults.page) !== null && ref1 !== void 0 ? ref1 : 0) + 1
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchResults === null || searchResults === void 0 ? void 0 : searchResults.page,
        searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.hits) === null || ref === void 0 ? void 0 : ref.length,
        onCompleted
    ]);
    return null;
});
var NewGachasCell = function(param) {
    var loading = param.loading, newGachas = param.newGachas, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading || (newGachas === null || newGachas === void 0 ? void 0 : newGachas.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            loading: loading,
            title: t("gachaLabel"),
            listHref: artistId && generatePath(routerPages.ArtistGachas, {
                artistId: artistId
            }),
            items: newGachas,
            trans: t("toList"),
            LoadingComponent: GachaBoxSkeleton,
            renderItem: function(gacha, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    in: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBox, {
                        gacha: gacha,
                        artistId: artistId
                    })
                }, i);
            }
        }) : null
    });
};
var NewMissionsCell = function(param) {
    var loading = param.loading, newMissions = param.newMissions, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!newMissions.length || !config_config/* config.modules.mission */.v.modules.mission) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("missionLabel"),
        listHref: artistId && generatePath(routerPages.ArtistMissions, {
            artistId: artistId
        }),
        items: newMissions,
        trans: t("toList"),
        LoadingComponent: MissionBoxSkeleton,
        renderItem: function(mission, i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBox, {
                    sx: {
                        mt: 0
                    },
                    mission: mission,
                    artistId: artistId,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: mission === null || mission === void 0 ? void 0 : mission.artist.id,
                            missionId: mission === null || mission === void 0 ? void 0 : mission.id,
                            type: mission === null || mission === void 0 ? void 0 : mission.type,
                            name: "missions"
                        });
                    }
                })
            }, i);
        }
    });
};
var NewEventsCell = function(param) {
    var artistId = param.artistId, events = param.events, loading = param.loading;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    if (!(events === null || events === void 0 ? void 0 : (ref = events.edges) === null || ref === void 0 ? void 0 : ref.length) && !loading || !config_config/* config.modules.event */.v.modules.event) return null;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        spacing: 4,
        title: t("newEventsLabel"),
        listHref: generatePath(routerPages.ArtistEvents, {
            artistId: artistId
        }),
        items: (ref2 = events === null || events === void 0 ? void 0 : events.edges) !== null && ref2 !== void 0 ? ref2 : [],
        trans: t("toList"),
        LoadingComponent: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCardSkeleton, {
                width: 315
            });
        },
        renderItem: function(event, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                    event: event.node,
                    sx: {
                        width: 315,
                        height: "100%"
                    }
                })
            }, i);
        }
    });
};
var NewPostsCell = function(param) {
    var loading = param.loading, newPosts = param.newPosts, artistId = param.artistId, onLikePost = param.onLikePost, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!newPosts.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("postLabel"),
        listHref: artistId && generatePath(routerPages.ArtistPosts, {
            artistId: artistId
        }),
        items: newPosts,
        trans: t("toList"),
        LoadingComponent: PostBoxSkeleton,
        renderItem: function(p, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, {
                    post: p,
                    sx: {
                        height: 356
                    },
                    onLike: function() {
                        return onLikePost(p.id, p.isLike, p.likeCount);
                    },
                    isMembershipPersonalInformationRequired: isMembershipPersonalInformationRequired
                })
            }, i);
        }
    });
};
var NewThreadsCell = function(param) {
    var loading = param.loading, newThreads = param.newThreads, artistId = param.artistId, isMember = param.isMember, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!config_config/* config.modules.thread */.v.modules.thread) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading || newThreads.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            loading: loading,
            loadingItemLength: 3,
            title: t("communityLabel"),
            listHref: artistId && generatePath(routerPages.ArtistThreads, {
                artistId: artistId
            }),
            LoadingComponent: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadBoxSkeleton, {
                    width: 315
                });
            },
            items: newThreads,
            trans: t("toList"),
            renderItem: function(thread, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadBox, {
                    thread: thread,
                    hasPatron: isMember,
                    isShowModalPersonalInfoRequire: isShowModalPersonalInfoRequire,
                    width: 315,
                    fixedHeight: true
                }, i);
            }
        }) : null
    });
};
var Empty = function(param) {
    var title = param.title, description = param.description;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            px: 6,
            py: 5,
            textAlign: "center"
        },
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                color: "text.secondary",
                children: description || t("emptyMessage")
            })
        ]
    });
};
var MembershipOnlyModalCell = function(param) {
    var open = param.open, onClose = param.onClose, artistId = param.artistId, displayName = param.displayName;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("liveViewMemberTitle"),
        content: t("liveViewMemberDesc", {
            displayName: displayName
        }),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            href: generatePath(routerPages.ArtistMembership, {
                artistId: artistId
            }),
            children: t("seeMore")
        })
    });
};
var BlockedArtistCell = function(param) {
    var loading = param.loading, artist = param.artist, followArtists = param.followArtists, memberArtists = param.memberArtists, user = param.user, isArtist = param.isArtist, onUnBlock = param.onUnBlock, responsive = param.responsive;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,ArtistThemeProvider/* useArtistThemeContext */.ff)(), 1), bgImage = ref1[0].bgImage;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: "100vw",
                    maxHeight: 744,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    "& header": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockedArtistInfoCell, {
                    artist: artist,
                    followArtists: followArtists,
                    memberArtists: memberArtists,
                    user: user,
                    isArtist: isArtist,
                    onUnBlock: onUnBlock,
                    responsive: responsive
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
        hasSafeArea: true,
        gradationMask: true,
        bgImage: bgImage,
        imageUri: artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.mediumUri,
        maxWidth: responsive ? 1120 : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            sx: {
                height: "100%"
            },
            in: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockedArtistInfoCell, {
                artist: artist,
                followArtists: followArtists,
                memberArtists: memberArtists,
                user: user,
                isArtist: isArtist,
                onUnBlock: onUnBlock,
                responsive: responsive
            })
        })
    });
};
var BlockedArtistInfoCell = function(param) {
    var artist = param.artist, memberArtists = param.memberArtists, followArtists = param.followArtists, user = param.user, isArtist = param.isArtist, onUnBlock = param.onUnBlock, responsive = param.responsive;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var palette = (0,useTheme/* default */.Z)().palette;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var ref3 = (0,react.useState)(false), openSideMenu = ref3[0], setOpenSideMenu = ref3[1];
    var ref4 = (0,react.useState)(null), anchorEl = ref4[0], setAnchorEl = ref4[1];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var open = Boolean(anchorEl);
    var id = open ? "unblock-popover" : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        justifyContent: "space-between",
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, (0,src_object_spread/* default */.Z)({
                        color: "transparent",
                        elevation: 0,
                        sx: {
                            backgroundColor: "transparent"
                        },
                        left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                            edge: "start",
                            onClick: function() {
                                return setOpenSideMenu(!openSideMenu);
                            },
                            color: "icon.line",
                            bgcolor: "icon.background",
                            badge: (user === null || user === void 0 ? void 0 : user.hasManagementTask) || !!(user === null || user === void 0 ? void 0 : user.unreadNotificationCount)
                        }),
                        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: user && config_config/* config.applicationType */.v.applicationType === "standalone" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                children: [
                                    config_config/* config.modules.campaign */.v.modules.campaign && config_config/* config.modules.mission */.v.modules.mission && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Event, {
                                        color: "icon.line",
                                        bgcolor: "icon.background",
                                        size: "medium",
                                        href: generatePath(routerPages.GlobalEvents)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Notice, {
                                        color: "icon.line",
                                        bgcolor: "icon.background",
                                        size: "medium",
                                        href: routerPages.Notifications
                                    })
                                ]
                            })
                        })
                    }, responsive ? {
                        responsive: true,
                        maxWidth: 1120
                    } : {})),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        followArtists: followArtists,
                        memberArtists: memberArtists,
                        open: openSideMenu,
                        onClose: function() {
                            return setOpenSideMenu(false);
                        },
                        user: user,
                        isArtist: isArtist,
                        responsive: responsive
                    })
                ]
            }),
            config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    mb: 3,
                    zIndex: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.primary",
                        variant: "h1",
                        sx: {
                            mb: 1
                        },
                        children: artist === null || artist === void 0 ? void 0 : artist.displayName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "caption",
                        sx: {
                            mb: 4
                        },
                        children: artist === null || artist === void 0 ? void 0 : artist.formattedAccountId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                "aria-describedby": id,
                                variant: "outlined",
                                size: "small",
                                color: "error",
                                /**
               * @todo
               * ブロック解除API本格実装後コメントアウト
               * https://app.clickup.com/t/908127/UT-8682
               * onClick={handleClick}
               */ sx: {
                                    color: palette === null || palette === void 0 ? void 0 : (ref = palette.error) === null || ref === void 0 ? void 0 : ref.main,
                                    borderColor: palette === null || palette === void 0 ? void 0 : (ref1 = palette.error) === null || ref1 === void 0 ? void 0 : ref1.main
                                },
                                children: t("blocking")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                                id: id,
                                open: open,
                                anchorEl: anchorEl,
                                onClose: handleClose,
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                onClick: function() {
                                    onUnBlock();
                                    handleClose();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        py: 3,
                                        px: 4,
                                        bgcolor: "grey.100"
                                    },
                                    children: t("unBlock", {
                                        artistAccountId: artist === null || artist === void 0 ? void 0 : artist.formattedAccountId
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/functionals/HorizontalList/index.tsx







var HorizontalList = function(param) {
    var loading = param.loading, _loadingItemLength = param.loadingItemLength, loadingItemLength = _loadingItemLength === void 0 ? 5 : _loadingItemLength, title = param.title, titleTypographyProps = param.titleTypographyProps, subTitle = param.subTitle, subTitleTypographyProps = param.subTitleTypographyProps, TitleLoadingComponent = param.TitleLoadingComponent, TitleIcon = param.TitleIcon, listHref = param.listHref, items = param.items, renderItem = param.renderItem, _LoadingComponent = param.LoadingComponent, LoadingComponent = _LoadingComponent === void 0 ? Box_Box/* default */.Z : _LoadingComponent, sx = param.sx, _spacing = param.spacing, spacing = _spacing === void 0 ? 5 : _spacing, trans = param.trans, transTypographyProps = param.transTypographyProps, _EmptyComponent = param.EmptyComponent, EmptyComponent = _EmptyComponent === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {}) : _EmptyComponent, allwayShowList = param.allwayShowList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: (0,src_object_spread/* default */.Z)({
            position: "relative"
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                pb: 6,
                pt: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    sx: {
                        py: 2,
                        px: 5
                    },
                    children: [
                        TitleLoadingComponent ? loading && !(items === null || items === void 0 ? void 0 : items.length) ? TitleLoadingComponent : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            variant: "h3"
                        }, titleTypographyProps), {
                            children: title
                        })) : null,
                        !TitleLoadingComponent && (loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "large",
                            width: "50%"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                TitleIcon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    variant: "h3"
                                }, titleTypographyProps), {
                                    children: title
                                }))
                            ]
                        })),
                        !!listHref && loading && !allwayShowList && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "large",
                            width: "10%"
                        }),
                        listHref && (!!(items === null || items === void 0 ? void 0 : items.length) || allwayShowList) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            variant: "h5",
                            underline: "none",
                            sx: {
                                color: "primary.main"
                            },
                            href: listHref
                        }, transTypographyProps), {
                            children: trans
                        }))
                    ]
                }),
                !!subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        variant: "caption"
                    }, subTitleTypographyProps), {
                        children: subTitle
                    }))
                }),
                !!(loading || (items === null || items === void 0 ? void 0 : items.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    flexWrap: "wrap",
                    sx: {
                        overflowY: "auto",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "::-webkit-scrollbar": {
                            height: 0,
                            width: 0,
                            display: "none",
                            MozAppearance: "none",
                            WebkitAppearance: "none"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        className: "items",
                        direction: "row",
                        spacing: spacing,
                        flexWrap: "nowrap",
                        overflow: "hidden",
                        sx: {
                            pt: 3,
                            pb: 6,
                            "& > *:first-of-type": {
                                ml: 5
                            },
                            "& > *:last-child": {
                                mr: 5
                            }
                        },
                        children: loading ? Array.from(Array(loadingItemLength).keys()).map(function(i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponent, {}, i);
                        }) : items === null || items === void 0 ? void 0 : items.map(renderItem)
                    })
                }),
                !loading && !(items === null || items === void 0 ? void 0 : items.length) && EmptyComponent
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/pages/StoreRequestProvidableItemSearch/template/index.tsx
var template = __webpack_require__(72432);
;// CONCATENATED MODULE: ./src/components/pages/ArtistStore/template/SearchForm.tsx







var SearchForm_schema = function(o) {
    return {
        keyword: o.string().required()
    };
};
var SearchForm_defaultValues = {
    keyword: ""
};
var SearchForm = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: SearchForm_schema,
        defaultValues: SearchForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            px: 5,
            pb: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            onSubmit: handleSubmit(onSubmit),
            sx: {
                bgcolor: "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputCell, (0,src_object_spread/* default */.Z)({}, register("keyword")))
        })
    });
};
var SearchInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("artistStore").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SearchInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ArtistStore/template/index.tsx

























var ArtistStore_template_client = algolia/* client */.Lp();
var ArtistStoreTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("artistStore").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref5 = (0,react.useState)(false), openSideMenu = ref5[0], setOpenSideMenu = ref5[1];
    var itemResultRef = (0,react.useRef)({
        items: [],
        page: 1
    });
    var publishedAtTimestampRef = (0,react.useRef)(values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds());
    var ref6 = (0,react.useState)({
        searchState: {},
        indexName: algolia/* indexes.items */.RG.items
    }), instantSearchState = ref6[0], setInstantSearchState = ref6[1];
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref7.routerNames, router = ref7.router, routerPages = ref7.routerPages, generatePath = ref7.generatePath;
    var handleOnSearchStateChange = (0,react.useCallback)(function(newState) {
        setInstantSearchState(function(prevState) {
            return {
                indexName: prevState.indexName,
                searchState: newState
            };
        });
    }, []);
    var handleFilter = (0,react.useCallback)(function(order) {
        switch(order){
            case "price_desc":
                return setInstantSearchState(function(prevState) {
                    return {
                        indexName: algolia/* indexes.itemsPriceDesc */.RG.itemsPriceDesc,
                        searchState: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState.searchState), {
                            page: 1
                        })
                    };
                });
            case "price_asc":
                return setInstantSearchState(function(prevState) {
                    return {
                        indexName: algolia/* indexes.itemsPriceAsc */.RG.itemsPriceAsc,
                        searchState: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState.searchState), {
                            page: 1
                        })
                    };
                });
            default:
                return setInstantSearchState(function(prevState) {
                    return {
                        indexName: algolia/* indexes.items */.RG.items,
                        searchState: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState.searchState), {
                            page: 1
                        })
                    };
                });
        }
    }, []);
    var handleOnCompleted = (0,react.useCallback)(function(items, param) {
        var page = param.page;
        itemResultRef.current = {
            items: items,
            page: page
        };
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "artist_store_list",
            item_list_name: "Artist Store Items",
            items: items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var handleSelectItem = (0,react.useCallback)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            items: itemResultRef.current.items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: "store_item",
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: itemResultRef.current.page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistStore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                maxWidth: displayResponsive ? 1120 : undefined,
                navigation: {
                    type: "artist",
                    props: {
                        isLive: !!state.liveStreamId,
                        hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                        unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                    },
                    responsive: displayResponsive
                },
                header: (0,src_object_spread/* default */.Z)({
                    title: t("title"),
                    left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                        edge: "start",
                        onClick: function() {
                            return setOpenSideMenu(!openSideMenu);
                        },
                        badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasUnappliedDeliveryItems) || ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasWaitingPaymentItems) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount),
                        color: "icon.line",
                        bgcolor: "icon.background"
                    }),
                    right: state.isLoggedIn && !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayPurchase/* PointDisplayPurchase */.u, {
                        point: state.point
                    })
                }, displayResponsive ? {
                    responsive: true,
                    maxWidth: 1120
                } : {}),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                        indexName: instantSearchState.indexName,
                        searchClient: ArtistStore_template_client,
                        refresh: true,
                        searchState: instantSearchState.searchState,
                        onSearchStateChange: handleOnSearchStateChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                                hitsPerPage: 10,
                                filters: algolia/* filters.itemStoreArtist */.u8.itemStoreArtist(state.artistId, publishedAtTimestampRef.current)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {
                                onSubmit: function() {
                                    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                                        var keyword;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            keyword = param.keyword;
                                            return [
                                                2,
                                                router.push({
                                                    pathname: generatePath(routerPages.StoreRequestProvidableItemSearch, {
                                                        artistId: state.artistId
                                                    }),
                                                    search: "?keyword=".concat(keyword)
                                                })
                                            ];
                                        });
                                    });
                                    return function(_) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCell, {
                                loading: state.loading,
                                artistId: state.artistId,
                                collections: state.collections,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyStoreViewedItemsLabel, {
                                artistId: state.artistId,
                                loading: state.loading,
                                newMagazines: state.newMagazines,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentlyViewedCollectionsCell, {
                                artistId: state.artistId,
                                loading: state.loading,
                                newCollections: state.newCollections,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemsInfiniteHits, {
                                artistId: state.artistId,
                                userLoggedInId: state.userLoggedInId,
                                onFilter: handleFilter,
                                onSelectItem: handleSelectItem,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(template/* StoreStateResults */.Zx, {
                                onCompleted: handleOnCompleted
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        followArtists: state.followArtists,
                        memberArtists: state.memberArtists,
                        open: openSideMenu,
                        onClose: function() {
                            return setOpenSideMenu(false);
                        },
                        user: state.user,
                        isArtist: state.isArtist,
                        responsive: displayResponsive
                    })
                ]
            })
        ]
    });
};
var CollectionCell = function(param) {
    var artistId = param.artistId, loading = param.loading, collections = param.collections, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistStore").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (!(collections === null || collections === void 0 ? void 0 : collections.edges.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        children: t("collectionTitle", "コレクションから探す")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                        variant: "h5",
                        underline: "none",
                        href: generatePath(routerPages.StoreCollectionsSelect, {
                            artistId: artistId
                        }),
                        sx: {
                            color: "primary.main"
                        },
                        children: t("toList", "一覧へ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                component: Grid2/* default */.Z,
                componentProps: {
                    spacing: 3,
                    container: true
                },
                itemComponent: Grid2/* default */.Z,
                itemComponentProps: responsive ? {
                    size: {
                        xs: 6,
                        sm: 4
                    }
                } : {
                    size: {
                        xs: 6,
                        md: 6
                    }
                },
                nodes: collections === null || collections === void 0 ? void 0 : collections.edges.map(function(param, index) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreCollectionBox, (0,src_object_spread/* default */.Z)({
                        conductorName: "artistStore",
                        collection: node
                    }, responsive ? {
                        responsive: true,
                        height: "auto"
                    } : {}), index);
                }),
                loading: loading,
                hasNextPage: false,
                onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                }),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    container: true,
                    spacing: 3,
                    sx: {
                        py: 2
                    },
                    children: Array.from(Array(6).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                            size: responsive ? {
                                xs: 6,
                                sm: 4
                            } : {
                                xs: 6,
                                md: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 166
                            })
                        }, key);
                    })
                })
            })
        ]
    });
};
var StoreItemsInfiniteHits = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, artistId = param.artistId, userLoggedInId = param.userLoggedInId, onFilter = param.onFilter, onSelectItem = param.onSelectItem, refineNext = param.refineNext, responsive = param.responsive;
    var items = hits.map(function(_param) {
        var objectID = _param.objectID, item = (0,_object_without_properties/* default */.Z)(_param, [
            "objectID"
        ]);
        return (0,src_object_spread/* default */.Z)({
            id: objectID
        }, item);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemsCell, {
        items: items,
        artistId: artistId,
        userLoggedInId: userLoggedInId,
        onFilter: onFilter,
        onSelectItem: onSelectItem,
        hasNextPage: hasMore,
        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    refineNext()
                ];
            });
        }),
        responsive: responsive
    });
});
var StoreItemsCell = function(param) {
    var artistId = param.artistId, userLoggedInId = param.userLoggedInId, items = param.items, hasNextPage = param.hasNextPage, onFilter = param.onFilter, onFetchMore = param.onFetchMore, onSelectItem = param.onSelectItem, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistStore").t;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort");
    var ref = (0,react.useState)(sort !== null && sort !== void 0 ? sort : undefined), selectedOption = ref[0], setSelectedOption = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var open = Boolean(anchorEl);
    var options = [
        {
            value: undefined,
            label: t("newArrivalOrder")
        },
        {
            value: "price_asc",
            label: t("cheapestFirst")
        },
        {
            value: "price_desc",
            label: t("highestFirst")
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(newVal) {
        setAnchorEl(null);
        setSelectedOption(newVal);
        onFilter(newVal);
    }, [
        onFilter
    ]);
    (0,react.useEffect)(function() {
        onFilter(sort !== null && sort !== void 0 ? sort : undefined);
    }, [
        sort
    ]);
    (0,react.useEffect)(function() {
        if (selectedOption) {
            var UrlParams = "?sort=".concat(selectedOption);
            // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
            window.history.replaceState(null, "", UrlParams);
        } else {
            window.history.replaceState(null, "", location.pathname);
        }
    }, [
        selectedOption
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            py: 2
                        },
                        children: t("itemsForSale")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Slider, {
                        edge: "end",
                        size: "medium",
                        onClick: function(event) {
                            return setAnchorEl(event.currentTarget);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        PaperProps: {
                            sx: {
                                width: 200
                            }
                        },
                        children: options.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                selected: option.value === selectedOption,
                                onClick: function() {
                                    return handleClick(option.value);
                                },
                                children: option.label
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: false,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                component: Grid2/* default */.Z,
                componentProps: {
                    spacing: 2,
                    container: true
                },
                itemComponent: Grid2/* default */.Z,
                itemComponentProps: responsive ? {
                    size: {
                        xs: 4,
                        sm: 3
                    }
                } : {
                    size: {
                        xs: 4,
                        md: 3
                    }
                },
                emptyMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                nodes: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemArea/* StoreItemArea */.S, (0,src_object_spread/* default */.Z)({
                        item: item,
                        artistId: artistId,
                        onClick: onSelectItem,
                        showMenberOnlyIcon: true
                    }, responsive ? {
                        responsive: true,
                        aspectRatio: "1 / 1"
                    } : {}), index);
                })
            })
        ]
    });
};
var RecentlyStoreViewedItemsLabel = function(param) {
    var loading = param.loading, artistId = param.artistId, newMagazines = param.newMagazines, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!loading && !newMagazines.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            pt: 4,
            mb: -5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            loading: loading,
            title: t("recentlyStoreViewedItemsLabel"),
            items: newMagazines,
            trans: t("toList"),
            listHref: generatePath(routerPages.RecentViewedItems, {
                artistId: artistId
            }),
            spacing: 1,
            TitleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Bookmark, {
                fontSize: "medium",
                sx: {
                    color: "grey.700"
                }
            }),
            LoadingComponent: StoreItemAreaTemporarySkeleton,
            renderItem: function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    in: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemAreaTemporary, {
                        item: item,
                        conductorName: "artistTopRecentryStoreView",
                        responsive: responsive
                    })
                }, item.id);
            }
        })
    });
};
var RecentlyViewedCollectionsCell = function(param) {
    var loading = param.loading, newCollections = param.newCollections, artistId = param.artistId, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!loading && !newCollections.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("recentlyViewedCollectionsLabel"),
        items: newCollections,
        trans: t("toList"),
        listHref: generatePath(routerPages.RecommendCollections, {
            artistId: artistId
        }),
        TitleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Time, {
            fontSize: "medium",
            sx: {
                color: "grey.700"
            }
        }),
        LoadingComponent: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreCollectionBoxSkeleton, {
                width: 160
            });
        },
        renderItem: function(collection) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreCollectionBox, {
                    conductorName: "artistTopRecentryViewCollection",
                    width: 160,
                    collection: collection,
                    responsive: responsive
                })
            }, collection.id);
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStore/viewModel.ts

function ArtistStore_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistStore($artistId: ID!, $storeArtistId: String!) {\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n    user {\n      ...CurrentUser\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      currentLive {\n        id\n      }\n    }\n    storeCollections(artistId: $storeArtistId, pageInput: { limit: 6 }) {\n      edges {\n        node {\n          ... on Collection {\n            ...ArtistStoreCollectionBox\n          }\n        }\n      }\n    }\n    recentlyViewedCollections(artistId: $storeArtistId) {\n      ...RecommendCollectionConnection\n    }\n    recentlyStoreViewedItems(artistId: $storeArtistId) {\n      ...RecentViewedItemConnection\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistStore_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistStore_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistStoreForGuest($artistId: ID!, $storeArtistId: String!) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      currentLive {\n        id\n      }\n    }\n    storeCollections(artistId: $storeArtistId, pageInput: { limit: 6 }) {\n      edges {\n        node {\n          ... on Collection {\n            ...ArtistStoreCollectionBox\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistStore_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistStore_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreCart($pageInput: PageInput) {\n    userCarts(pageInput: $pageInput) {\n      edges {\n        node {\n          ... on UserCart {\n            items {\n              count\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ArtistStore_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ArtistStore_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref10 = (0,auth/* useCurrentUser */.xJ)(), user = ref10.user, userClaims = ref10.userClaims;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref11 = (0,useQuery/* useQuery */.aM)(ArtistStore_viewModel_QUERY, {
        variables: {
            artistId: artistId,
            storeArtistId: artistId
        },
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref11.data, loading = ref11.loading;
    var ref12 = (0,useQuery/* useQuery */.aM)(ArtistStore_viewModel_QUERY_FOR_GUEST, {
        variables: {
            artistId: artistId,
            storeArtistId: artistId
        },
        skip: user === null || user === void 0 ? void 0 : user.isSigned,
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), dataForGuest = ref12.data;
    var ref13 = (0,useQuery/* useQuery */.aM)(STORE_CART_QUERY, {
        variables: {
            pageInput: {
                limit: 100
            }
        }
    }), storeCartData = ref13.data;
    var ref14;
    var storeCartCount = (ref14 = storeCartData === null || storeCartData === void 0 ? void 0 : (ref = storeCartData.userCarts) === null || ref === void 0 ? void 0 : ref.edges.reduce(function(sum, edge) {
        var ref;
        var ref1;
        var itemCounts = (ref1 = (ref = edge.node.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.count || 0;
        })) !== null && ref1 !== void 0 ? ref1 : [];
        return sum + itemCounts.reduce(function(a, b) {
            return a + b;
        }, 0);
    }, 0)) !== null && ref14 !== void 0 ? ref14 : 0;
    var ref15, ref16, ref17, ref18, ref19, ref20;
    return {
        state: {
            artistId: artistId,
            isLoggedIn: !!user,
            userLoggedInId: (ref15 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref15 !== void 0 ? ref15 : "",
            point: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.prepaidPointBalance) === null || ref1 === void 0 ? void 0 : ref1.formattedPrepaidPointBarance) !== null && ref16 !== void 0 ? ref16 : "",
            user: (ref17 = data === null || data === void 0 ? void 0 : data.user) !== null && ref17 !== void 0 ? ref17 : null,
            loading: loading,
            collections: (ref18 = (ref2 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref2 === void 0 ? void 0 : ref2.storeCollections) !== null && ref18 !== void 0 ? ref18 : null,
            liveStreamId: (ref3 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.currentLive) === null || ref5 === void 0 ? void 0 : ref5.id,
            followArtists: (ref19 = data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : ref6.organizationFollowees) !== null && ref19 !== void 0 ? ref19 : null,
            memberArtists: (ref20 = data === null || data === void 0 ? void 0 : (ref7 = data.user) === null || ref7 === void 0 ? void 0 : ref7.organizationPatrons) !== null && ref20 !== void 0 ? ref20 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref8 = userClaims.orgs) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[config_config/* config.organizationId */.v.organizationId]) === null || ref9 === void 0 ? void 0 : ref9.artist),
            newMagazines: (data === null || data === void 0 ? void 0 : data.recentlyStoreViewedItems.edges.map(function(e) {
                return e.node.item;
            })) || [],
            newCollections: (data === null || data === void 0 ? void 0 : data.recentlyViewedCollections.edges.map(function(e) {
                return e.node.collection;
            })) || [],
            storeCartCount: storeCartCount
        },
        actions: {}
    };
});
var ArtistStore_viewModel_QUERY = (0,lib/* default */.ZP)(ArtistStore_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* ArtistStoreCollectionBoxFragmentDoc */.CaL, utoniq_core_schema/* RecommendCollectionConnectionFragmentDoc */._1v, utoniq_core_schema/* RecentViewedItemConnectionFragmentDoc */.z19);
var ArtistStore_viewModel_QUERY_FOR_GUEST = (0,lib/* default */.ZP)(ArtistStore_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistStoreCollectionBoxFragmentDoc */.CaL);
var STORE_CART_QUERY = (0,lib/* default */.ZP)(ArtistStore_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ArtistStore/index.tsx







var artistStoreCustomDesignMap = {
    "ArtistStore_tmpl0001_v1.0": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1857).then(__webpack_require__.bind(__webpack_require__, 41857));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(41857)
                ];
            }
        }
    })
};
var ArtistStore = function() {
    var ref = ArtistStore_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    var customDesign = useCustomDesign({
        type: "ArtistStore",
        artistId: state.artistId
    }).customDesign;
    if (!customDesign) return null;
    var ref1;
    var CustomTemplate = (customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId) ? (ref1 = artistStoreCustomDesignMap[customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId]) !== null && ref1 !== void 0 ? ref1 : ArtistStoreTemplate : ArtistStoreTemplate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTemplate, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        state: state
    }, actions), {
        customDesign: (customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId) ? customDesign : undefined
    }));
};

;// CONCATENATED MODULE: ./src/components/organisms/event/QuantityPicker/index.tsx




var QuantityPicker = function(param) {
    var value = param.value, onPlus = param.onPlus, onMinus = param.onMinus, error = param.error, disabledPlus = param.disabledPlus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 5,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    size: "xSmall",
                    onClick: onMinus,
                    sx: {
                        width: 24,
                        height: 24,
                        bgcolor: "grey.100",
                        "&.Mui-disabled": {
                            bgcolor: "grey.100"
                        }
                    },
                    disabled: value <= 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Minus, {
                        sx: {
                            width: 16,
                            height: 16,
                            color: value <= 1 ? "text.disabled" : "grey.700"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.primary",
                    children: value
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    size: "xSmall",
                    onClick: onPlus,
                    disabled: error || disabledPlus,
                    sx: {
                        width: 24,
                        height: 24,
                        bgcolor: "grey.100",
                        "&.Mui-disabled": {
                            bgcolor: "grey.100"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Plus, {
                        sx: {
                            width: 16,
                            height: 16,
                            color: error || disabledPlus ? "text.disabled" : "grey.700"
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/core/sku/index.ts


/**
 * アイテムオブジェクトから指定したskuIdに一致するSKUを取得し、 sku プロパティに設定する。
 * サムネイルも変換する
 * @param item アイテム
 * @param skuId skuのユニットID。おもにクエリパラメータから取得する
 */ var setItemSku = function(item, skuId, i) {
    var ref, ref1, ref2;
    if (!item || !skuId || !item.skuSettings) return item;
    // skuIdに一致するunitを探す
    var sku = item.skuSettings.units.find(function(unit) {
        return unit.id === decodeSkuId(skuId);
    });
    if (!sku) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item.thumbnail), {
            front: (0,src_object_spread/* default */.Z)({}, (ref = item.thumbnail) === null || ref === void 0 ? void 0 : ref.front, (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.thumbnail)
        })
    });
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        sku: sku,
        thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item.thumbnail), {
            front: (0,src_object_spread/* default */.Z)({}, (ref2 = item.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.front, sku === null || sku === void 0 ? void 0 : sku.thumbnail)
        })
    });
};
/**
 * ユーザー所持アイテム一覧のうち、SKUが設定されているものがあればSKU単位で展開する。
 * portfolios: {
 *   edges: [item, item, item, SKUありのitem, ]
 * }
 * を
 * portfolios: {
 *   edges: [item, item, item, item1, item2, item3 ]
 * }
 * にする
 */ var spreadPortfoliosBySku = function(portfolios) {
    var ref;
    if (!portfolios) return null;
    var edges = (ref = portfolios.edges) === null || ref === void 0 ? void 0 : ref.flatMap(function(param) {
        var node = param.node;
        var ref, ref1, ref2;
        if (!(node === null || node === void 0 ? void 0 : (ref = node.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.units) === null || ref2 === void 0 ? void 0 : ref2.length)) return {
            node: node
        };
        var ref3;
        return node.item.skuSettings.units.map(function(unit) {
            var ref;
            return {
                node: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    number: node.serials.filter(function(param) {
                        var serial = param.serial;
                        var ref;
                        return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === unit.id;
                    }).length,
                    serials: (ref3 = (ref = node.serials) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                        var serial = param.serial;
                        var ref;
                        return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === unit.id;
                    })) !== null && ref3 !== void 0 ? ref3 : node.serials,
                    item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node.item), {
                        sku: unit,
                        thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node.item.thumbnail), {
                            front: (0,src_object_spread/* default */.Z)({}, node.item.thumbnail.front, unit.thumbnail)
                        })
                    })
                })
            };
        });
    })// @ts-ignore
    .filter(function(m) {
        return !!m.node.number;
    });
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, portfolios), {
        edges: edges
    });
};
/**
 * コレクション一覧のうち、SKUが設定されているものがあればSKU単位で展開する。
 * collectionItems: {
 *   edges: [item, item, item, SKUありのitem, ]
 * }
 * を
 * collectionItems: {
 *   edges: [item, item, item, item1, item2, item3 ]
 * }
 * にする
 */ var spreadCollectionItemsBySku = function(collectionItems) {
    var ref;
    if (!collectionItems) return null;
    var edges = (ref = collectionItems.edges) === null || ref === void 0 ? void 0 : ref.flatMap(function(param) {
        var node = param.node;
        var ref, ref1, ref2;
        if (!(node === null || node === void 0 ? void 0 : (ref = node.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.units) === null || ref2 === void 0 ? void 0 : ref2.length)) return {
            node: node
        };
        return node.item.skuSettings.units.map(function(unit) {
            return {
                node: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node.item), {
                        sku: unit,
                        thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node.item.thumbnail), {
                            front: (0,src_object_spread/* default */.Z)({}, node.item.thumbnail.front, unit.thumbnail)
                        })
                    })
                })
            };
        });
    });
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, collectionItems), {
        edges: edges
    });
};
/**
 * ユーザーの所持アイテム(詳細)のパラメータをSKUのものに変換する
 */ var convertPortfolioItemToSku = function(portfolio, skuId) {
    var ref, ref1;
    if (!portfolio) return null;
    if (!skuId) return portfolio;
    var ref2;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, portfolio), {
        number: portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var serial = param.serial;
            var ref;
            return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === decodeSkuId(skuId);
        }).length,
        serials: (ref2 = portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
            var serial = param.serial;
            var ref;
            return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === decodeSkuId(skuId);
        })) !== null && ref2 !== void 0 ? ref2 : portfolio.serials,
        item: setItemSku(portfolio.item, skuId)
    });
};
/**
 * カートの中身のアイテムをSKU単位で並べ、アイテムの合計金額を算出する
 */ var convertUserCartItemsToSku = function(items) {
    if (!items) return null;
    return items.flatMap(function(item) {
        var ref;
        if (!((ref = item.skus) === null || ref === void 0 ? void 0 : ref.length)) {
            return item;
        }
        return item.skus.map(function(sku) {
            var ref;
            if (!sku) return item;
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                totalPrice: item.item.price * sku.count,
                count: sku.count,
                item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item.item), {
                    sku: sku.sku,
                    thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item.item.thumbnail), {
                        front: (0,src_object_spread/* default */.Z)({}, item.item.thumbnail.front, sku === null || sku === void 0 ? void 0 : (ref = sku.sku) === null || ref === void 0 ? void 0 : ref.thumbnail)
                    })
                })
            });
        });
    });
};
/** クエリパラメータに設定するために、skuIdのコロンをハイフンに変換する */ var encodeSkuId = function(skuId) {
    return skuId.replace(":", "-");
};
/** クエリパラメータからskuIdを取得するため、ハイフンをコロンに戻す */ var decodeSkuId = function(skuId) {
    return skuId.replace("-", ":");
};
/**
 * userItems型の配列をsku単位で展開する
 */ var spreadUserItemsBySku = function(userItems) {
    if (!userItems || !userItems.length) return [];
    return userItems.flatMap(function(userItem) {
        if (!userItem.item.skuSettings) return userItem;
        return userItem.item.skuSettings.units.map(function(unit) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userItem), {
                number: userItem.serials.filter(function(param) {
                    var serial = param.serial;
                    var ref;
                    return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === unit.id;
                }).length,
                item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userItem.item), {
                    sku: unit,
                    thumbnail: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userItem.item.thumbnail), {
                        front: (0,src_object_spread/* default */.Z)({}, userItem.item.thumbnail.front, unit.thumbnail)
                    })
                })
            });
        }).filter(function(m) {
            return !!m.number;
        });
    });
};
/**
 * get item price width sku
 */ var getItemSkuPrice = function(item) {
    var ref;
    var ref1;
    if (!isNaN(Number((ref1 = item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.price) !== null && ref1 !== void 0 ? ref1 : undefined))) {
        var ref2, ref3;
        var ref4;
        return {
            price: (item === null || item === void 0 ? void 0 : (ref2 = item.sku) === null || ref2 === void 0 ? void 0 : ref2.price) || 0,
            formattedPrice: (ref4 = item === null || item === void 0 ? void 0 : (ref3 = item.sku) === null || ref3 === void 0 ? void 0 : ref3.formattedPrice) !== null && ref4 !== void 0 ? ref4 : "0"
        };
    }
    var ref5;
    return {
        price: (item === null || item === void 0 ? void 0 : item.price) || 0,
        formattedPrice: (ref5 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref5 !== void 0 ? ref5 : "0"
    };
};
/**
 * 売り切れかどうかを判定する
 * @param item アイテム詳細
 * @param skuId SKUのID
 * @returns 売り切れの場合true
 */ var getIsSoldOut = function(item, skuId) {
    var ref, ref1;
    if (!item) return false;
    var sku = (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.find(function(sku) {
        return sku.id === skuId;
    });
    if (!sku) {
        /** アイテム発行数が設定されており残数が0であれば売り切れとする */ return !!item.issuedNumber && item.remainingNumber === 0;
    }
    /** 発行数が設定されていない場合は購入可能とする */ if (!item.issuedNumber) return false;
    if (!item.isResaleAvailable) {
        var _stock, _purchasedNumber, _pendingPurchaseNumber;
        /** SKUの在庫数が購入済み数と保留中購入数の合計以下であれば売り切れとする */ return ((_stock = sku.stock) !== null && _stock !== void 0 ? _stock : 0) <= ((_purchasedNumber = sku.purchasedNumber) !== null && _purchasedNumber !== void 0 ? _purchasedNumber : 0) + ((_pendingPurchaseNumber = sku.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0);
    }
    /** 再販利用可能時はアイテム発行数が設定されており残数が0であれば売り切れとする */ return !!item.issuedNumber && item.remainingNumber === 0;
};

;// CONCATENATED MODULE: ./src/components/organisms/store/StoreButtonBox/index.tsx










var StoreButtonBox = function(param) {
    var label = param.label, disabled = param.disabled, item = param.item, onBuyNow = param.onBuyNow, onAddToCart = param.onAddToCart, formattedItemPrice = param.formattedItemPrice, onChangePurchaseNumber = param.onChangePurchaseNumber, purchaseNumber = param.purchaseNumber, maximumPurchasableNumber = param.maximumPurchasableNumber, purchaseLimitPerOrder = param.purchaseLimitPerOrder, purchaseLimitByUser = param.purchaseLimitByUser, loading = param.loading, skuId = param.skuId, willResaleAvailable = param.willResaleAvailable, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? 600 : _maxWidth;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var color = (0,react.useMemo)(function() {
        if (item.salesStatus === utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped) {
            return "text.primary";
        }
        return (item.remainingNumber || 0) < 10 ? "error" : "text.primary";
    }, [
        item.remainingNumber,
        item.salesStatus
    ]);
    var isSoldOut = (0,react.useMemo)(function() {
        return getIsSoldOut(item, skuId);
    }, [
        item,
        skuId
    ]);
    // 購入制限の表記
    var purchaseLimitText = !!purchaseLimitPerOrder && purchaseLimitByUser ? t("purchaseLimitTextBoth", {
        purchaseLimitByUser: purchaseLimitByUser,
        purchaseLimitPerOrder: purchaseLimitPerOrder
    }) : purchaseLimitPerOrder ? t("purchaseLimitTextOrder", {
        purchaseLimitPerOrder: purchaseLimitPerOrder
    }) : purchaseLimitByUser ? t("purchaseLimitTextUser", {
        purchaseLimitByUser: purchaseLimitByUser
    }) : "";
    if (// リセール可能で、期間中の場合
    (item.isResaleAvailable || // リセール期間前のリセールアイテム
    willResaleAvailable) && !!item) {
        return null;
    }
    if (item.preSale) {
        var href = item.preSale.firstComeFirstServed ? generatePath(routerPages.FirstComeFirstServedDetail, {
            preSaleId: item.preSale.id
        }) : generatePath(routerPages.LotteryDetail, {
            preSaleId: item.preSale.id
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                py: 3,
                px: 5,
                maxWidth: responsive && maxWidth ? maxWidth : undefined,
                margin: responsive ? "0 auto" : undefined,
                alignItems: responsive ? "center" : undefined
            },
            spacing: 2,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                fullWidth: !responsive,
                size: "large",
                sx: responsive ? {
                    width: 244,
                    margin: "0 auto"
                } : undefined,
                color: "primary",
                href: href,
                children: t("seePreSale", "先行販売を見る")
            })
        });
    }
    var _paymentType, _id;
    // リセール可能でない場合の表示
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            py: 3,
            px: 5,
            maxWidth: responsive && maxWidth ? maxWidth : undefined,
            width: responsive ? "100%" : undefined,
            margin: responsive ? "0 auto" : undefined
        },
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    minHeight: 44
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            formattedItemPrice !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                point: formattedItemPrice !== null && formattedItemPrice !== void 0 ? formattedItemPrice : 0,
                                custom: {
                                    fontSize: "medium",
                                    variant: "h2",
                                    spacing: 2
                                },
                                paymentType: (_paymentType = item.paymentType) !== null && _paymentType !== void 0 ? _paymentType : "prepaid_point"
                            }),
                            !item.preSale && (item.issuedNumber || 0) > 0 && !item.hideSalesNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: t("remaining", "残り")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: color,
                                        children: [
                                            item.salesStatus === utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped ? "-" : item.remainingNumber,
                                            "/",
                                            item.issuedNumber
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        alignItems: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityPicker, {
                                error: disabled,
                                value: purchaseNumber,
                                onMinus: function() {
                                    return onChangePurchaseNumber(--purchaseNumber);
                                },
                                onPlus: function() {
                                    return onChangePurchaseNumber(++purchaseNumber);
                                },
                                disabledPlus: maximumPurchasableNumber <= purchaseNumber
                            }),
                            (!!item.purchaseLimitByUser || !!item.purchaseLimitPerOrder) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: purchaseLimitText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroupCell, {
                onAddToCart: onAddToCart,
                label: label,
                disabled: disabled,
                loading: loading,
                onBuyNow: onBuyNow,
                sellingStatus: item.salesCondition,
                isSoldOut: isSoldOut,
                preSaleId: (ref = item.preSale) === null || ref === void 0 ? void 0 : ref.id,
                purchaseNumber: purchaseNumber,
                itemId: (_id = item.id) !== null && _id !== void 0 ? _id : "",
                skuId: skuId,
                formattedItemPrice: formattedItemPrice,
                isEventPickUp: !!(item === null || item === void 0 ? void 0 : (ref1 = item.collection) === null || ref1 === void 0 ? void 0 : ref1.isEventPickup),
                responsive: responsive
            })
        ]
    });
};
var ButtonGroupCell = function(param) {
    var disabled = param.disabled, loading = param.loading, label = param.label, onBuyNow = param.onBuyNow, onAddToCart = param.onAddToCart, sellingStatus = param.sellingStatus, isSoldOut = param.isSoldOut, preSaleId = param.preSaleId, itemId = param.itemId, skuId = param.skuId, purchaseNumber = param.purchaseNumber, formattedItemPrice = param.formattedItemPrice, isEventPickUp = param.isEventPickUp, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var options = (0,react.useMemo)(function() {
        // 発売中以外のパターン
        if (sellingStatus !== utoniq_core_schema/* SalesCondition.Active */.HrV.Active) {
            var label1 = function() {
                switch(sellingStatus){
                    case utoniq_core_schema/* SalesCondition.Before */.HrV.Before:
                        return t("beforeSelling");
                    case utoniq_core_schema/* SalesCondition.End */.HrV.End:
                        return t("endSelling");
                    case utoniq_core_schema/* SalesCondition.Stopped */.HrV.Stopped:
                        return t("stopSelling");
                }
            };
            return [
                {
                    label: label1(),
                    disabled: true,
                    loading: loading,
                    onClick: function() {}
                }, 
            ];
        }
        if (isSoldOut) {
            return [
                {
                    label: t("soldOut"),
                    disabled: true,
                    loading: loading,
                    onClick: function() {}
                }, 
            ];
        }
        if (preSaleId) {
            return [
                {
                    label: t("applyForLottery"),
                    disabled: false,
                    loading: loading,
                    onClick: function() {
                        router.push({
                            pathname: generatePath(routerPages.LotteryDetail, {
                                preSaleId: preSaleId
                            }),
                            search: "?itemId=".concat(itemId, "&quantity=").concat(purchaseNumber).concat(skuId ? "&skuId=".concat(encodeSkuId(skuId)) : "")
                        });
                    }
                }, 
            ];
        }
        if (config_config/* config.modules.cart */.v.modules.cart && formattedItemPrice !== "0") {
            // カート機能ONの場合、「カートに追加」「今すぐ購入」の2ボタンが表示
            // https://app.zeplin.io/project/609b6cbdf2ec09be6da76b28/screen/61b8050a169f444d2077ae20
            return [
                {
                    label: t("addToCart", "カートに追加"),
                    disabled: disabled || loading,
                    loading: loading,
                    onClick: onAddToCart
                }, 
            ].concat(// NOTE: 受け取りONのアイテムの場合、「今すぐ購入」のボタンを非表示
            (0,src_to_consumable_array/* default */.Z)(isEventPickUp ? [] : [
                {
                    label: label,
                    loading: loading,
                    disabled: disabled || loading,
                    onClick: onBuyNow
                }, 
            ]));
        }
        return [
            {
                label: label,
                loading: loading,
                disabled: disabled || loading,
                onClick: onBuyNow
            }, 
        ];
    }, [
        sellingStatus,
        isSoldOut,
        preSaleId,
        formattedItemPrice,
        label,
        loading,
        disabled,
        onBuyNow,
        t,
        router,
        generatePath,
        routerPages.LotteryDetail,
        itemId,
        purchaseNumber,
        skuId,
        onAddToCart,
        isEventPickUp, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: responsive ? options.length > 1 ? 2 : 0 : 2,
        alignItems: responsive ? "center" : undefined,
        children: options.map(function(param, index, array) {
            var label = param.label, disabled = param.disabled, loading = param.loading, onClick = param.onClick;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                fullWidth: responsive ? options.length > 1 : true,
                sx: responsive ? {
                    width: options.length > 1 ? undefined : 244,
                    margin: "0 auto"
                } : undefined,
                size: "large",
                color: "primary",
                variant: array.length === 2 && index === 0 ? "outlined" : "contained",
                onClick: onClick,
                disabled: loading || disabled,
                loading: loading,
                children: label
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/item/ItemDetailBoxSkeleton/index.tsx
var ItemDetailBoxSkeleton = __webpack_require__(75334);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
;// CONCATENATED MODULE: ./src/components/organisms/store/StoreButtonBoxSkeleton/index.tsx




var StoreButtonBoxSkeleton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        sx: {
            minHeight: 76
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "25%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 160,
                    height: 38,
                    sx: {
                        borderRadius: "2px"
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/organisms/item/ItemDetailBox/index.tsx
var ItemDetailBox = __webpack_require__(99850);
// EXTERNAL MODULE: ./src/lib/dayjs/index.ts
var dayjs = __webpack_require__(61755);
;// CONCATENATED MODULE: ./src/components/organisms/store/StoreButtonResaleBox/index.tsx








var StoreButtonResaleBox = function(param) {
    var item = param.item, skuId = param.skuId, userActiveResaleItemRaffle = param.userActiveResaleItemRaffle, restrected = param.restrected, skuButtonActive = param.skuButtonActive, willResaleAvailable = param.willResaleAvailable;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    /** リセール応募重複モーダルの表示状態 */ var ref = (0,react.useState)(false), openResaleAppliedModal = ref[0], setOpenResaleAppliedModal = ref[1];
    if (item.preSale) {
        return null;
    }
    if (!skuButtonActive) {
        if (item.salesStatus === utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: "text.secondary",
                variant: "button",
                textAlign: "center",
                sx: {
                    pb: 5
                },
                children: t("forStopSelling", "現在販売しておりません")
            });
        }
    }
    if (restrected) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        color: "text.secondary",
        variant: "button",
        textAlign: "center",
        sx: {
            pb: 5
        },
        children: t("forLimitedOnly", "対象の方のみ購入できる商品です。")
    });
    if (// リセール可能で、期間中の場合
    (item.isResaleAvailable || // リセール期間前のリセールアイテム
    willResaleAvailable) && !!item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCard, {
                        item: item,
                        skuId: skuId,
                        willResaleAvailable: willResaleAvailable,
                        userActiveResaleItemRaffle: userActiveResaleItemRaffle,
                        openResaleAppliedModal: function() {
                            return setOpenResaleAppliedModal(true);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppliedResaleModal, {
                    open: openResaleAppliedModal,
                    onClose: function() {
                        return setOpenResaleAppliedModal(false);
                    }
                })
            ]
        });
    }
    return null;
};
var ResaleCard = function(param) {
    var item = param.item, skuId = param.skuId, userActiveResaleItemRaffle = param.userActiveResaleItemRaffle, willResaleAvailable = param.willResaleAvailable, openResaleAppliedModal = param.openResaleAppliedModal;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), router = ref9.router, generatePath = ref9.generatePath, routerPages = ref9.routerPages, generateQueryPath = ref9.generateQueryPath;
    var ref10 = (0,react.useState)(""), time = ref10[0], setTime = ref10[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            var nextRaffle = (0,dayjs/* nextRaffleDateTime */.N7)("YYYY/MM/DD HH:mm:ss");
            var diff = dayjs_min_default()(nextRaffle, "YYYY/MM/DD HH:mm:ss").diff(dayjs_min_default()(), "s");
            if (diff < 0) {
                setTime("00:00:00");
                return;
            }
            var ref = (0,dayjs/* secondsToHms */.qt)(diff), hours = ref.hours, minutes = ref.minutes, seconds = ref.seconds;
            setTime("".concat(pad(hours), ":").concat(pad(minutes), ":").concat(pad(seconds)));
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, []);
    var _resaleOpenCount, _resaleRaffleAppliedCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            cursor: item.isResaleAvailable ? "pointer" : "initial"
        },
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
            onClick: function() {
                if (!item.isResaleAvailable) return;
                // すでにリセール応募/購入済みの場合、再応募不可
                if (userActiveResaleItemRaffle) {
                    openResaleAppliedModal();
                    return;
                }
                router.push(generateQueryPath(routerPages.ResaleApplicationDetail, {
                    itemId: item.id
                }, {
                    skuId: encodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "")
                }));
            },
            disableTouchRipple: !!willResaleAvailable,
            sx: {
                p: 5,
                "&:last-child": {
                    pb: 5
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                borderRadius: 1,
                                bgcolor: "primary.dark",
                                color: "white",
                                typography: "button",
                                textAlign: "center",
                                py: "6px"
                            },
                            children: item.isResaleAvailable ? t("underResaleExhibition", "リセール出品中") : t("beforeResaleExhibition", "リセール出品待ち")
                        }),
                        willResaleAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            justifyContent: "center",
                            sx: {
                                pt: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    align: "center",
                                    children: t("resaleApplicationPeriod", "リセール応募期間")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    align: "center",
                                    children: [
                                        (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.formattedStartedAt,
                                        " 〜",
                                        " ",
                                        (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.formattedEndedAt
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 4
                                    },
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    color: "text.secondary",
                                                    children: t("exhibitNumber", "出品枚数")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 2,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Ticket, {
                                                            fontSize: "medium"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                            variant: "h2",
                                                            children: t("numberValue", "枚", {
                                                                number: (_resaleOpenCount = item.resaleOpenCount) !== null && _resaleOpenCount !== void 0 ? _resaleOpenCount : 0
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 2,
                                                    sx: {
                                                        pt: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: t("applicationNumber", "応募枚数")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            children: t("numberValue", {
                                                                number: (_resaleRaffleAppliedCount = item.resaleRaffleAppliedCount) !== null && _resaleRaffleAppliedCount !== void 0 ? _resaleRaffleAppliedCount : 0
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    color: "error.main",
                                                    align: "right",
                                                    children: t("nextLottery", {
                                                        date: time
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    color: "text.secondary",
                                                    align: "right",
                                                    children: t("resaleApplicationPeriod", "リセール応募期間")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    align: "right",
                                                    children: t("to", {
                                                        date: (ref6 = item.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ticket) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.resalePeriod) === null || ref8 === void 0 ? void 0 : ref8.formattedEndedAt
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            color: "primary.main",
                                            variant: "caption",
                                            align: "right",
                                            children: t("checkResaleTicket", "詳細を確認する")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                            sx: {
                                                width: 8,
                                                height: 8
                                            },
                                            color: "primary"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: "100%",
                        zIndex: 10,
                        maxWidth: "600px",
                        margin: "0 auto",
                        bgcolor: "grey.50",
                        pb: "env(safe-area-inset-bottom, 0)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            py: 3,
                            px: 5,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "contained",
                            size: "large",
                            disabled: !!willResaleAvailable,
                            sx: {
                                width: "100%"
                            },
                            children: t("beforeResaleExhibition")
                        })
                    })
                })
            ]
        })
    });
};
function pad(d) {
    return d < 10 ? "0".concat(d) : d.toString();
}
/**
 * すでにアイテムの転売応募をしている状態のとき、その旨を表示するモーダル
 */ var AppliedResaleModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("resaleAlreadyApplied", "すでにリセールに応募しています。"),
        content: t("resaleAlreadyAppliedDesc", "このアイテムのリセール応募をすでに行なっているため、重ねて応募することはできません。"),
        cancelText: t("close", "閉じる"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            href: generatePath(routerPages.ResaleManagement, {
                tab: "raffle"
            }),
            children: t("toResaleManagement", "リセール管理画面へ")
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@react-hook/window-size/dist/module/index.js + 3 modules
var dist_module = __webpack_require__(16305);
// EXTERNAL MODULE: ./src/components/layouts/ContentFrame.tsx
var ContentFrame = __webpack_require__(67983);
// EXTERNAL MODULE: ./src/components/organisms/bottomSheet/index.tsx
var bottomSheet = __webpack_require__(33684);
;// CONCATENATED MODULE: ./src/components/organisms/item/SkuTag/index.tsx




var SkuTag = function(param) {
    var skuUnit = param.skuUnit, active = param.active, disabled = param.disabled, onClick = param.onClick, paymentType = param.paymentType, issuedNumber = param.issuedNumber, isResaleEnable = param.isResaleEnable;
    var isSoldOut = !!(skuUnit.stock && skuUnit.remainingNumber === 0 && !isResaleEnable);
    var isStockNotSet = skuUnit.stock === null && issuedNumber !== null;
    var ref = (0,react.useMemo)(function() {
        if (disabled || isStockNotSet || isSoldOut) {
            return {
                color: "text.disabled",
                bgcolor: "grey.100",
                borderColor: "grey.100"
            };
        }
        if (active) {
            return {
                color: "white",
                bgcolor: "primary.main",
                borderColor: "primary.main"
            };
        }
        return {
            color: "text.secondary",
            bgcolor: "transparent",
            borderColor: "grey.100"
        };
    }, [
        active,
        skuUnit.remainingNumber,
        disabled
    ]), borderColor = ref.borderColor, color = ref.color, bgcolor = ref.bgcolor;
    var _formattedPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
        onClick: onClick,
        disabled: disabled || isStockNotSet || isSoldOut,
        sx: {
            borderRadius: "14px",
            px: 3,
            py: 1,
            minWidth: "fit-content",
            borderColor: borderColor,
            bgcolor: bgcolor,
            borderWidth: 1,
            borderStyle: "solid",
            ".MuiTypography-root": {
                color: color
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            color: color,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: skuUnit.unitName
                }),
                skuUnit.formattedPrice !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                    point: (_formattedPrice = skuUnit.formattedPrice) !== null && _formattedPrice !== void 0 ? _formattedPrice : 0,
                    size: "small",
                    paymentType: paymentType !== null && paymentType !== void 0 ? paymentType : "prepaid_point"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    children: function() {
                        if (isSoldOut || isStockNotSet) return "\xd7";
                        if (issuedNumber === null) return "◯";
                        if (!skuUnit.remainingNumber) return "\xd7";
                        return skuUnit.remainingNumber > 9 ? "◯" : "△";
                    }()
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/SkuType/index.tsx








var SkuType = function(param) {
    var value = param.value, onSelect = param.onSelect, skuSettings = param.skuSettings, paymentType = param.paymentType, issuedNumber = param.issuedNumber, isResaleEnable = param.isResaleEnable, disabled = param.disabled, hasAlertText = param.hasAlertText;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    if (!(skuSettings === null || skuSettings === void 0 ? void 0 : skuSettings.units.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pb: 1
        },
        children: [
            hasAlertText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                        fontSize: "small",
                        color: "error"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "error.main",
                        sx: {
                            textAlign: "center"
                        },
                        children: t("types")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                children: t("types")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flexWrap: "wrap",
                sx: (0,src_object_spread/* default */.Z)({
                    py: 2,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    direction: "row",
                    children: skuSettings.units.map(function(skuUnit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuTag, {
                            skuUnit: skuUnit,
                            active: skuUnit.id === value,
                            disabled: disabled,
                            paymentType: paymentType,
                            issuedNumber: issuedNumber,
                            isResaleEnable: isResaleEnable,
                            onClick: function() {
                                return onSelect(skuUnit.id === value ? undefined : skuUnit);
                            }
                        }, skuUnit.id);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/SkuUnitSelectBottomSheet/index.tsx











var SkuUnitSelectBottomSheet = function(param) {
    var open = param.open, loading = param.loading, disabled = param.disabled, label = param.label, onClose = param.onClose, itemId = param.itemId, item = param.item, skuValue = param.skuValue, skuSettings = param.skuSettings, onSelect = param.onSelect, formattedItemPrice = param.formattedItemPrice, purchaseNumber = param.purchaseNumber, maximumPurchasableNumber = param.maximumPurchasableNumber, onChangePurchaseNumber = param.onChangePurchaseNumber, onPurchase = param.onPurchase, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var bottomSheetRef = (0,react.useRef)(null);
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    (0,react.useEffect)(function() {
        if (!open) {
            var ref;
            (ref = bottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.dismiss();
        }
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        var bottomSheet = bottomSheetRef.current;
        return function() {
            bottomSheet === null || bottomSheet === void 0 ? void 0 : bottomSheet.dismiss();
        };
    }, []);
    var isSoldOut = (0,react.useMemo)(function() {
        return getIsSoldOut(item, skuValue);
    }, [
        item,
        skuValue
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomSheet/* BottomSheet */.R, {
            ref: bottomSheetRef,
            open: open,
            onClose: onClose,
            breakpoints: [
                0,
                330 / windowHeight
            ],
            initialBreakpoint: 330 / windowHeight,
            responsive: responsive,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        sx: {
                            py: 4,
                            px: 3
                        },
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                align: "center",
                                width: "100%",
                                children: t("typeSelection", "種類選択")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                size: "small",
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuType, {
                            value: skuValue,
                            skuSettings: skuSettings,
                            onSelect: onSelect,
                            paymentType: item === null || item === void 0 ? void 0 : item.paymentType,
                            issuedNumber: item === null || item === void 0 ? void 0 : item.issuedNumber,
                            hasAlertText: !skuValue
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        sx: {
                            px: 5,
                            minHeight: 44
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 1,
                                children: formattedItemPrice !== "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                    point: formattedItemPrice !== null && formattedItemPrice !== void 0 ? formattedItemPrice : "0",
                                    custom: {
                                        fontSize: "medium",
                                        variant: "h2",
                                        spacing: 2
                                    },
                                    paymentType: (ref = item === null || item === void 0 ? void 0 : item.paymentType) !== null && ref !== void 0 ? ref : "prepaid_point"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 2,
                                alignItems: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityPicker, {
                                    value: purchaseNumber,
                                    onMinus: function() {
                                        return onChangePurchaseNumber(--purchaseNumber);
                                    },
                                    onPlus: function() {
                                        return onChangePurchaseNumber(++purchaseNumber);
                                    },
                                    disabledPlus: maximumPurchasableNumber <= purchaseNumber
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        sx: {
                            p: 5,
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuUnitSelectBottomSheet_ButtonGroupCell, {
                            disabled: disabled,
                            loading: loading,
                            isSoldOut: isSoldOut,
                            label: label,
                            onPurchase: onPurchase,
                            itemId: itemId,
                            skuId: skuValue,
                            isResaleAvailable: !!(item === null || item === void 0 ? void 0 : item.isResaleAvailable) || !!(item === null || item === void 0 ? void 0 : item.willResaleAvailable)
                        })
                    })
                ]
            })
        })
    });
};
var SkuUnitSelectBottomSheet_ButtonGroupCell = function(param) {
    var isSoldOut = param.isSoldOut, isResaleAvailable = param.isResaleAvailable, disabled = param.disabled, loading = param.loading, onPurchase = param.onPurchase, label = param.label, itemId = param.itemId, skuId = param.skuId, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (isSoldOut) {
        // TODO レスポンシブ対応確認 横幅変わる
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            fullWidth: !responsive,
            sx: responsive ? {
                width: 244,
                margin: "0 auto"
            } : undefined,
            size: "large",
            color: "primary",
            disabled: true,
            children: t("soldOut")
        });
    }
    if (isResaleAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            fullWidth: !responsive,
            sx: responsive ? {
                width: 244,
                margin: "0 auto"
            } : undefined,
            size: "large",
            color: "primary",
            onClick: function() {
                return router.push({
                    pathname: generatePath(routerPages.ResaleApplicationDetail, {
                        itemId: itemId
                    }),
                    search: "".concat(skuId ? "?skuId=".concat(encodeSkuId(skuId)) : "")
                });
            },
            children: t("duringResale")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        fullWidth: !responsive,
        sx: responsive ? {
            width: 244,
            margin: "0 auto"
        } : undefined,
        size: "large",
        onClick: onPurchase,
        color: "primary",
        disabled: disabled || loading,
        loading: loading,
        children: label
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/point/PaymentMethodSelectDrawer/index.tsx













/**
 * ポイントチャージ実行時に表示される
 * 支払い方法を選択するためのドロワー
 *
 * 「課金を確定する」ボタン押下時に
 * ユーザーが選択した paymentMethod を
 * onSubmit コールバックを通じて親コンポーネントに通知し責務を委譲する
 */ var PaymentMethodSelectDrawer = function(param) {
    var open = param.open, paymentSource = param.paymentSource, chargeLoading = param.chargeLoading, enablePointCarrierPayment = param.enablePointCarrierPayment, onSubmit = param.onSubmit, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodSelectDrawerHeader, {
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodSelectDrawerContent, {
                paymentSource: paymentSource,
                chargeLoading: chargeLoading,
                enablePointCarrierPayment: enablePointCarrierPayment,
                onSubmit: onSubmit
            })
        ]
    });
};
var PaymentMethodSelectDrawerHeader = function(param) {
    var onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                height: 55,
                px: 3
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    align: "center",
                    width: "100%",
                    children: t("confirmPayment")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    size: "small",
                    onClick: onClose
                })
            ]
        })
    });
};
var PaymentMethodSelectDrawerContent = function(param) {
    var paymentSource = param.paymentSource, chargeLoading = param.chargeLoading, enablePointCarrierPayment = param.enablePointCarrierPayment, onSubmit = param.onSubmit, onNavigate = param.onNavigate;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var isWeb = native_app/* getPlatform */.Xf() === "web";
    var schema = function(o) {
        return {
            paymentMethod: o.string()
        };
    };
    var ref = (0,core_form/* useForm */.cI)({
        schema: schema
    }), watch = ref.watch, setValue = ref.setValue;
    var paymentMethodWatch = watch("paymentMethod");
    // ── Drawer 内の「課金確定ボタン」押下時に呼ぶ関数 ──
    var submitHandler = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!paymentMethodWatch) return [
                            2
                        ];
                        // ── 親コンポーネントに支払い方法を渡して本来の課金ロジックを走らせる ──
                        return [
                            4,
                            onSubmit(paymentMethodWatch)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function submitHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                value: paymentMethodWatch !== null && paymentMethodWatch !== void 0 ? paymentMethodWatch : "",
                onChange: function(_, value) {
                    setValue("paymentMethod", value, {
                        shouldValidate: true
                    });
                },
                sx: {
                    gap: function(theme) {
                        return theme.spacing(4);
                    },
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("paymentMethod")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                        checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCardPayment, {
                            paymentSource: paymentSource,
                            goBackPath: routerPages.PrepaidPointCharge,
                            onNavigate: onNavigate
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    isWeb && enablePointCarrierPayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        children: t("carrierPayment")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: {
                                            pt: 2
                                        },
                                        children: t("carrierPaymentDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: utoniq_core_schema/* PaymentMethod.Au */.XL7.Au,
                                        checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Au */.XL7.Au,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                            carrier: t("au")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: utoniq_core_schema/* PaymentMethod.Softbank */.XL7.Softbank,
                                        checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Softbank */.XL7.Softbank,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                            carrier: t("softbank")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: utoniq_core_schema/* PaymentMethod.Docomo */.XL7.Docomo,
                                        checked: paymentMethodWatch === utoniq_core_schema/* PaymentMethod.Docomo */.XL7.Docomo,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarrierPaymentOption, {
                                            carrier: t("docomo")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 6,
                    display: "grid",
                    placeItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 244
                    },
                    disabled: chargeLoading || !paymentMethodWatch || paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && !(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4),
                    onClick: submitHandler,
                    loading: chargeLoading,
                    children: !paymentMethodWatch || paymentMethodWatch === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard ? t("toBuy") : t("confirmCarrierPayment")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/point/PointChargeDrawer/index.tsx
















/**
 * ポイントを購入できるボトムシート
 */ var PointChargeDrawer = function(param) {
    var open = param.open, point = param.point, onClose = param.onClose, loading = param.loading, chargeLoading = param.chargeLoading, onPurchase = param.onPurchase, purchasablePrepaidPoints = param.purchasablePrepaidPoints, paymentSource = param.paymentSource, pageName = param.pageName, enablePointCarrierPayment = param.enablePointCarrierPayment, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var isWeb = (0,native_app/* getPlatform */.Xf)() === "web";
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    // ドロワー内部の画面（購入プラン選択・決済手段選択など）を切り替えるための state
    var ref1 = (0,react.useState)("plan"), view = ref1[0], setView = ref1[1];
    var ref2 = (0,react.useState)(null), currentPlan = ref2[0], setCurrentPlan = ref2[1];
    // 決済手段選択にて選択された決済手段を保持する state
    var ref3 = (0,react.useState)(null), selectedPaymentMethod = ref3[0], setSelectedPaymentMethod = ref3[1];
    var ref4 = (0,react.useState)(false), openConfirmModal = ref4[0], setOpenConfirmModal = ref4[1];
    var ref5 = (0,react.useState)(false), openPurchaseComplete = ref5[0], setOpenPurchaseComplete = ref5[1];
    var ref6 = (0,react.useState)(false), openExpiredCardModal = ref6[0], setOpenExpiredCardModal = ref6[1];
    var ref7 = (0,react.useState)(false), openPaymentErrorModal = ref7[0], setOpenPaymentErrorModal = ref7[1];
    var ref8 = (0,react.useState)(false), openRequire3DSecureModal = ref8[0], setOpenRequire3DSecureModal = ref8[1];
    var handlePurchase = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(selectedPaymentMethod) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!currentPlan) return [
                    2
                ];
                onPurchase(currentPlan, selectedPaymentMethod).then(function() {
                    // キャリア決済の場合は外部キャリア決済画面にて
                    // 追加手続きが必要なため完了モーダルを表示しない
                    if ((0,escott/* isCarrierPaymentMethod */.ln)(selectedPaymentMethod)) return;
                    setView("plan");
                    setOpenConfirmModal(false);
                    onClose();
                    setOpenPurchaseComplete(true);
                }).catch(function(e) {
                    var ref, ref1, ref2;
                    switch((ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                        /**
             * @description
             * 3Dセキュア認証が必要な場合
             */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                            setOpenConfirmModal(false);
                            onClose();
                            setOpenRequire3DSecureModal(true);
                            break;
                        /**
             * @desciption
             * カードが有効期限切れの場合
             */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                            setOpenConfirmModal(false);
                            onClose();
                            setOpenExpiredCardModal(true);
                            break;
                        /**
             * @description
             * 何かしらの決済エラーの場合
             */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                            setOpenConfirmModal(false);
                            onClose();
                            setOpenPaymentErrorModal(true);
                            break;
                        default:
                            showError(e);
                            break;
                    }
                });
                return [
                    2
                ];
            });
        });
        return function(selectedPaymentMethod) {
            return _ref.apply(this, arguments);
        };
    }(), [
        currentPlan,
        onPurchase,
        onClose,
        showError
    ]);
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        // キャリア決済画面からのリダイレクトで戻ってきたとき以外は何もしない
        // リダイレクト時にはクエリパラメータに status が含まれる
        if (!router.query.status) return;
        // ローディング中もしくはポイント残高が取得できていない場合は何もしない
        if (loading || point === null) return;
        switch(router.query.status){
            case "success":
                setOpenPurchaseComplete(true);
                break;
            case "cancel":
                showMessage(t("carrierCancel"));
                break;
            case "error":
                showError(t("carrierError"));
                break;
            // ここには到達しない想定
            default:
                break;
        }
    }, [
        loading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomSheet/* BottomSheet */.R, {
                open: open,
                onClose: function() {
                    onClose();
                    setView("plan");
                },
                breakpoints: [
                    0,
                    0.6,
                    1
                ],
                initialBreakpoint: 0.6,
                responsive: responsive,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                    header: {
                        title: t("title"),
                        left: view === "payment" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Prev, {
                            edge: "start",
                            size: "large",
                            onClick: function() {
                                return setView("plan");
                            }
                        }),
                        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "small",
                            onClick: function() {
                                onClose();
                                setView("plan");
                            }
                        }),
                        sx: {
                            pt: 0
                        },
                        responsive: responsive,
                        maxWidth: responsive ? 1120 : undefined
                    },
                    safeArea: {
                        pt: 0
                    },
                    maxWidth: responsive ? 1120 : undefined,
                    children: [
                        view === "plan" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                px: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayCell, {
                                    point: point
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        py: 4
                                    },
                                    spacing: 4,
                                    children: [
                                        purchasablePrepaidPoints === null || purchasablePrepaidPoints === void 0 ? void 0 : purchasablePrepaidPoints.edges.map(function(param) {
                                            var node = param.node;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(PointChargeButton, {
                                                prepaidPoint: node,
                                                onClick: function() {
                                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_point", {
                                                        productId: node.metadata.id,
                                                        prepaidPointId: node.prepaidPointId,
                                                        pageName: pageName
                                                    });
                                                    setCurrentPlan(node);
                                                    if (isWeb) {
                                                        setView("payment");
                                                    } else {
                                                        // ネイティブの場合ポイントを含むデジタルアイテムの決済は
                                                        // IAP を経由して実行するため
                                                        // プラン選択後すぐに確認モーダルを表示する
                                                        setOpenConfirmModal(true);
                                                    }
                                                }
                                            }, node.id);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLinkCell, {})
                                    ]
                                })
                            ]
                        }),
                        view === "payment" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodSelectDrawerContent, {
                            paymentSource: paymentSource,
                            chargeLoading: chargeLoading,
                            enablePointCarrierPayment: enablePointCarrierPayment,
                            onNavigate: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onClose()
                                            ];
                                        case 1:
                                            _state.sent();
                                            setView("plan");
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            onSubmit: function(paymentMethod) {
                                setSelectedPaymentMethod(paymentMethod);
                                onClose();
                                setView("plan");
                                setOpenConfirmModal(true);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirmModal,
                onClose: function() {
                    return setOpenConfirmModal(false);
                },
                title: t("confirmCharge"),
                content: t("confirmChargeDescription", {
                    point: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.points,
                    price: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.price
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            onClick: function() {
                                handlePurchase(selectedPaymentMethod);
                            },
                            loading: chargeLoading,
                            children: t("toBuy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "text",
                            color: "primary",
                            onClick: function() {
                                return setOpenConfirmModal(false);
                            },
                            disabled: chargeLoading,
                            children: t("cancel")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openPurchaseComplete,
                onClose: function() {
                    return setOpenPurchaseComplete(false);
                },
                title: t("completeCharge"),
                content: t("completeChargeDescription", {
                    // キャリア決済画面からのリダイレクトで戻ってきた場合は
                    // クエリパラメータから points を読み込み表示する
                    point: (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.points) || router.query.points
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        minWidth: 212,
                        pointerEvents: "auto"
                    },
                    variant: "contained",
                    color: "primary",
                    size: "large",
                    onClick: function(event) {
                        event.stopPropagation();
                        event.preventDefault();
                        setOpenPurchaseComplete(false);
                    },
                    children: t("ok")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: openExpiredCardModal,
                onClose: function() {
                    return setOpenExpiredCardModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: openPaymentErrorModal,
                onClose: function() {
                    return setOpenPaymentErrorModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: openRequire3DSecureModal,
                onClose: function() {
                    return setOpenRequire3DSecureModal(false);
                }
            })
        ]
    });
};
var PointDisplayCell = function(param) {
    var point = param.point;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    children: t("pointBalance")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                    size: "large",
                    point: point
                })
            ]
        })
    });
};
var PointChargeButton = function(param) {
    var onClick = param.onClick, prepaidPoint = param.prepaidPoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
        sx: {
            bgcolor: "grey.100",
            borderRadius: 2,
            p: 5
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            flex: 1,
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                            point: prepaidPoint.points
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                            variant: "overline",
                            color: "primary.main",
                            children: prepaidPoint.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                    variant: "h5",
                    children: [
                        "\xa5",
                        prepaidPoint.price
                    ]
                })
            ]
        })
    });
};
var TextLinkCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: t("cancelPurchaseNote")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/nft/CryptoWalletConnectDrawer/index.tsx










var CryptoWalletConnectDrawer = function(param) {
    var open = param.open, onClose = param.onClose, connecting = param.connecting, onConnectWallet = param.onConnectWallet, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    var isWeb = (0,native_app/* getPlatform */.Xf)() === "web";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        sx: (0,src_object_spread/* default */.Z)({
            zIndex: zIndex.modal + 1
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                bgcolor: "grey.50"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            py: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                align: "center",
                                children: t("nftConnectDescription")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    color: "error.main"
                                },
                                align: "center",
                                children: t("nftConnectNote")
                            })
                        ]
                    }),
                    isWeb && /*#__PURE__*/ (0,jsx_runtime.jsx)(Web3AuthConnect, {
                        t: t,
                        onConnect: function() {
                            return onConnectWallet("web3auth");
                        },
                        disabled: connecting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetamaskConnect, {
                        t: t,
                        onConnect: function() {
                            return onConnectWallet("metamask");
                        },
                        disabled: connecting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: onClose,
                            variant: "text",
                            fullWidth: true,
                            disabled: connecting,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                color: "primary",
                                children: t("cancel")
                            })
                        })
                    })
                ]
            })
        })
    });
};
var MetamaskConnect = function(param) {
    var onConnect = param.onConnect, disabled = param.disabled, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        sx: {
            px: 5,
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        target: "common",
                        src: "images/nft/metaMask.png",
                        width: 35,
                        height: 35
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            ml: 3
                        },
                        children: "MetaMask"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                color: "primary",
                variant: "contained",
                onClick: onConnect,
                disabled: disabled,
                children: t("toConnect")
            })
        ]
    });
};
var Web3AuthConnect = function(param) {
    var onConnect = param.onConnect, disabled = param.disabled, t = param.t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("createCryptoWallet")).onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        sx: {
            px: 5,
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("createCryptWalletInApp")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                        onClick: onClick
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                color: "primary",
                variant: "contained",
                onClick: onConnect,
                disabled: disabled,
                children: t("create")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/nft/CreateCryptoWalletConfirmModal/index.tsx




var CreateCryptoWalletConfirmModal = function(param) {
    var open = param.open, loading = param.loading, onClose = param.onClose, onCreate = param.onCreate;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("confirm"),
        content: t("confirmModalContent"),
        buttons: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    minWidth: 212
                },
                onClick: onCreate,
                loading: loading,
                children: t("create")
            }), 
        ],
        cancelText: t("close"),
        sx: {
            zIndex: zIndex.modal + 999
        }
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/StoreButtonBox/useStoreButton.ts



var useStoreButton = function(param) {
    var isLoggedIn = param.isLoggedIn, isNft = param.isNft, userId = param.userId, isWalletConnect = param.isWalletConnect, item = param.item, purchaseLimitByUser = param.purchaseLimitByUser;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    // 1度に購入できる個数。制限が設定されてなければ10
    var maximumPurchasableNumber = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (item === null || item === void 0 ? void 0 : (ref = item.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.lottery) === null || ref1 === void 0 ? void 0 : ref1.purchasableCount) {
            return item.preSale.lottery.purchasableCount;
        }
        if (item === null || item === void 0 ? void 0 : (ref2 = item.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.firstComeFirstServed) === null || ref3 === void 0 ? void 0 : ref3.purchasableCount) {
            return item.preSale.firstComeFirstServed.purchasableCount;
        }
        if (item === null || item === void 0 ? void 0 : item.purchaseLimitPerOrder) {
            return item === null || item === void 0 ? void 0 : item.purchaseLimitPerOrder;
        }
        if (purchaseLimitByUser) {
            return purchaseLimitByUser;
        }
        return 10;
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableCount,
        item === null || item === void 0 ? void 0 : (ref2 = item.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lottery) === null || ref3 === void 0 ? void 0 : ref3.purchasableCount,
        item === null || item === void 0 ? void 0 : item.purchaseLimitPerOrder,
        purchaseLimitByUser, 
    ]);
    // 対象者限定かつユーザーが対象者でない場合
    var restrected = !!(item === null || item === void 0 ? void 0 : (ref4 = item.purchasableUsers) === null || ref4 === void 0 ? void 0 : ref4.length) && !item.purchasableUsers.map(function(param) {
        var userId = param.userId;
        return userId;
    }).includes("".concat(userId));
    var ref5 = (0,react.useMemo)(function() {
        if (!item) {
            return {
                label: "",
                disabled: true
            };
        }
        if (isLoggedIn && isNft && !isWalletConnect) {
            return {
                label: t("purchaseNow"),
                disabled: true
            };
        }
        if (!!item.purchaseLimitByUser && !!item.purchasedByPointNumber && item.purchaseLimitByUser <= item.purchasedByPointNumber) {
            return {
                label: t(item.price > 0 ? "purchased" : "earned"),
                disabled: true
            };
        }
        if (item.salesStatus === utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped) {
            return {
                label: t("stopSelling"),
                disabled: true
            };
        }
        if (item.isResaleEnable) {
            return {
                label: t(item.price > 0 ? "purchaseNow" : "openAcquire"),
                disabled: false
            };
        }
        if (item.issuedNumber && +(item.remainingNumber || 0) === 0) {
            return {
                label: t("soldOut"),
                disabled: true
            };
        }
        return {
            label: t(item.price > 0 ? "purchaseNow" : "openAcquire"),
            disabled: false
        };
    }, [
        item,
        isLoggedIn,
        isNft,
        isWalletConnect,
        t
    ]), label = ref5.label, disabled = ref5.disabled;
    return {
        label: label,
        disabled: disabled,
        maximumPurchasableNumber: maximumPurchasableNumber,
        restrected: restrected
    };
};

// EXTERNAL MODULE: ../../node_modules/@ionic/react/dist/index.esm.js + 16 modules
var dist_index_esm = __webpack_require__(34158);
// EXTERNAL MODULE: ../../node_modules/@mui/material/GlobalStyles/GlobalStyles.js + 1 modules
var GlobalStyles = __webpack_require__(16445);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(66582);
;// CONCATENATED MODULE: ./src/components/layouts/ResultPlus.tsx



/**
 * @description
 * S2O案件で行うアフィリエイトスクリプトのタグ
 * ストア詳細ページと、ストア完了画面それぞれのスクリプトを設置する
 * https://app.clickup.com/t/908127/UT-15040
 */ var ResultPlusScript = /*#__PURE__*/ (0,react.memo)(function(param) {
    var title = param.title, isCompleted = param.isCompleted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
        title: title,
        children: isCompleted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            id: "resultPlusComplete",
            dangerouslySetInnerHTML: {
                __html: '\n      (function() {\n        var uqid = "cf26S373Sef9aai9";\n        var gid  = 1009;\n        var uid = "";\n        var uid2 = "";\n        var af = "";\n        var pid = "";\n        var amount = "";\n        var a = document.createElement("script");\n        a.src = "//ad.resultplus2.jp/ac/action_js.php";\n        a.id = "afadaction-" + Date.now();\n        a.addEventListener("load", function () { (new fpcAction(a.id)).groupAction(gid, af, [uid, uid2], pid, amount, uqid) });\n        document.head.appendChild(a)\n      })();\n      '
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            id: "resultPlusCommon",
            dangerouslySetInnerHTML: {
                __html: '\n      (function() {\n        var uqid = "cf26S373Sef9aai9";\n        var gid  = 1009;\n        var a=document.createElement("script");\n        a.dataset.uqid=uqid;a.dataset.gid=gid;a.id="afadfpc-cf26S373Sef9aai9gid548-"+Date.now();\n        a.src="//ad.resultplus2.jp/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);\n        document.head.appendChild(a);\n        })();'
            }
        })
    });
});

// EXTERNAL MODULE: ../../node_modules/@mui/material/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(72887);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Table/Table.js
var Table = __webpack_require__(50075);
// EXTERNAL MODULE: ../../node_modules/@mui/material/TableBody/TableBody.js
var TableBody = __webpack_require__(36908);
// EXTERNAL MODULE: ../../node_modules/@mui/material/TableRow/TableRow.js
var TableRow = __webpack_require__(70969);
// EXTERNAL MODULE: ../../node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(27104);
// EXTERNAL MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/Header.tsx
var components_Header = __webpack_require__(66951);
;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowItemDetail.tsx

















var StepKey;
(function(StepKey) {
    StepKey["ITEM_DETAIL"] = "ITEM_DETAIL";
    StepKey["USER_INFO"] = "USER_INFO";
    StepKey["DELIVERY_INFO"] = "DELIVERY_INFO";
    StepKey["PAYMENT_CREATE"] = "PAYMENT_CREATE";
    StepKey["COMPLETION"] = "COMPLETION";
    StepKey["SMS_VERIFICATION"] = "SMS_VERIFICATION";
})(StepKey || (StepKey = {}));
var BuyNowItemDetail = function(param) {
    var user = param.user, item = param.item, sku = param.sku, formattedItemPrice = param.formattedItemPrice, sendingVerificationLoading = param.sendingVerificationLoading, paymentSource = param.paymentSource, prepaidPointBalance = param.prepaidPointBalance, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, onClose = param.onClose, onClickClose = param.onClickClose, onNextStep = param.onNextStep, onConfirmOrder = param.onConfirmOrder, onSendVerificationSMS = param.onSendVerificationSMS, onOpenPointPurchaseDrawer = param.onOpenPointPurchaseDrawer, totalPrice = param.totalPrice, statements = param.statements;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref5 = (0,react.useState)(false), open = ref5[0], setOpen = ref5[1];
    var rows = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var ref6, ref7, ref8;
        return [
            {
                label: t("fullName", "氏名"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    color: (user === null || user === void 0 ? void 0 : user.fullName) ? undefined : "primary.main",
                    children: (user === null || user === void 0 ? void 0 : user.fullName) || t("registerName", "氏名を登録してください")
                }),
                onClick: function() {
                    return onNextStep(StepKey.USER_INFO);
                },
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                    sx: {
                        color: (user === null || user === void 0 ? void 0 : user.fullName) ? undefined : "primary.main"
                    }
                }),
                hidden: !(item === null || item === void 0 ? void 0 : (ref = item.personalInformationRequirements) === null || ref === void 0 ? void 0 : ref.some(function(req) {
                    return req === utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName;
                }))
            },
            {
                label: t("phoneNumber", "電話番号"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !!(user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: user === null || user === void 0 ? void 0 : user.formattedPhoneNumber
                                }),
                                !(user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                            fontSize: "small",
                                            sx: {
                                                color: "error.main",
                                                mt: -1
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "error.main",
                                            sx: {
                                                width: "max-content"
                                            },
                                            children: t("unverify")
                                        }),
                                        (user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            color: "primary",
                                            sx: {
                                                p: 0,
                                                zIndex: 1,
                                                position: "relative"
                                            },
                                            loading: sendingVerificationLoading,
                                            onClick: function() {
                                                var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                return [
                                                                    4,
                                                                    onSendVerificationSMS()
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                                return function(event) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }(),
                                            children: t("verify")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                            fontSize: "small",
                                            sx: {
                                                color: "text.hint",
                                                mt: -1
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.hint",
                                            children: t("verified")
                                        })
                                    ]
                                })
                            ]
                        }),
                        !(user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "primary.main",
                            children: t("registerPhoneNumber", "電話番号を登録してください")
                        })
                    ]
                }),
                onClick: function() {
                    return onNextStep(StepKey.USER_INFO);
                },
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                    sx: {
                        color: (user === null || user === void 0 ? void 0 : user.phoneNumber) ? undefined : "primary.main"
                    }
                }),
                hidden: !(item === null || item === void 0 ? void 0 : (ref1 = item.personalInformationRequirements) === null || ref1 === void 0 ? void 0 : ref1.some(function(req) {
                    return req === utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber;
                }))
            },
            {
                label: (item === null || item === void 0 ? void 0 : item.type) ? t("".concat(item.type, "Delivery"), "お客様住所") : "",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    color: (user === null || user === void 0 ? void 0 : (ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.fullAddress) ? undefined : "primary.main",
                    children: (user === null || user === void 0 ? void 0 : (ref3 = user.address) === null || ref3 === void 0 ? void 0 : ref3.fullAddress) || t("registerAddress", "住所を登録してください")
                }),
                onClick: function() {
                    return onNextStep(StepKey.DELIVERY_INFO);
                },
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                    sx: {
                        color: (user === null || user === void 0 ? void 0 : (ref4 = user.address) === null || ref4 === void 0 ? void 0 : ref4.fullAddress) ? undefined : "primary.main"
                    }
                }),
                hidden: !(item === null || item === void 0 ? void 0 : (ref5 = item.personalInformationRequirements) === null || ref5 === void 0 ? void 0 : ref5.some(function(req) {
                    return req === utoniq_core_schema/* PersonalInformationType.Address */.APM.Address;
                }))
            },
            {
                label: t("paymentInfo"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && ((ref6 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref6 !== void 0 ? ref6 : 0) >= totalPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("point", "ポイント")
                        }),
                        (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && ((ref7 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref7 !== void 0 ? ref7 : 0) < totalPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "primary.main",
                            children: t("chargePoints", "ポイントをチャージしてください")
                        }),
                        (item === null || item === void 0 ? void 0 : item.paymentType) === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && !!(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                    width: 30,
                                    height: 24,
                                    src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                    target: "common"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("last4", {
                                        number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                    })
                                })
                            ]
                        }),
                        (item === null || item === void 0 ? void 0 : item.paymentType) === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && !(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "primary.main",
                            children: t("registerPaymentInfo", "支払い情報を登録してください")
                        })
                    ]
                }),
                onClick: function() {
                    if ((item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash) {
                        onOpenPointPurchaseDrawer();
                        return;
                    }
                    onNextStep(StepKey.PAYMENT_CREATE);
                },
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                    sx: {
                        color: (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && ((ref8 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref8 !== void 0 ? ref8 : 0) >= totalPrice || (item === null || item === void 0 ? void 0 : item.paymentType) === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && !!(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4) ? undefined : "primary.main"
                    }
                }),
                hidden: !(item === null || item === void 0 ? void 0 : item.price)
            }, 
        ];
    }, [
        t,
        user === null || user === void 0 ? void 0 : user.fullName,
        user === null || user === void 0 ? void 0 : user.phoneNumber,
        user === null || user === void 0 ? void 0 : user.formattedPhoneNumber,
        user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified,
        user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress,
        item === null || item === void 0 ? void 0 : item.personalInformationRequirements,
        item === null || item === void 0 ? void 0 : item.paymentType,
        sendingVerificationLoading,
        onSendVerificationSMS,
        prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance,
        totalPrice,
        paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4,
        paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand,
        onNextStep,
        onOpenPointPurchaseDrawer, 
    ]);
    var disabledButton = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        //check fullName
        if (!(user === null || user === void 0 ? void 0 : user.fullName) && (item === null || item === void 0 ? void 0 : (ref = item.personalInformationRequirements) === null || ref === void 0 ? void 0 : ref.some(function(req) {
            return req === utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName;
        }))) {
            return true;
        }
        //check phoneNumber
        if ((!(user === null || user === void 0 ? void 0 : user.phoneNumber) || !(user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified)) && (item === null || item === void 0 ? void 0 : (ref1 = item.personalInformationRequirements) === null || ref1 === void 0 ? void 0 : ref1.some(function(req) {
            return req === utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber;
        }))) {
            return true;
        }
        //check fullAddress
        if (!(user === null || user === void 0 ? void 0 : (ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.fullAddress) && (item === null || item === void 0 ? void 0 : (ref3 = item.personalInformationRequirements) === null || ref3 === void 0 ? void 0 : ref3.some(function(req) {
            return req === utoniq_core_schema/* PersonalInformationType.Address */.APM.Address;
        }))) {
            return true;
        }
        var ref4;
        if ((item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && ((ref4 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref4 !== void 0 ? ref4 : 0) < totalPrice) {
            return true;
        }
        if ((item === null || item === void 0 ? void 0 : item.paymentType) === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && !(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4)) {
            return true;
        }
        return false;
    }, [
        item === null || item === void 0 ? void 0 : item.paymentType,
        item === null || item === void 0 ? void 0 : item.personalInformationRequirements,
        paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4,
        prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance,
        totalPrice,
        user === null || user === void 0 ? void 0 : (ref1 = user.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress,
        user === null || user === void 0 ? void 0 : user.fullName,
        user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified,
        user === null || user === void 0 ? void 0 : user.phoneNumber, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {
                title: t("itemDetailTitle", "注文確認"),
                onClose: onClickClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemCell, {
                            item: item,
                            sku: sku,
                            quantity: quantity,
                            formattedItemPrice: formattedItemPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            sx: {
                                color: "grey.100"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                    children: [
                                        (0,array/* filterHiddenItem */.s)(rows).map(function(row, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                                                component: TableRow/* default */.Z,
                                                sx: {
                                                    display: "table-row"
                                                },
                                                disableRipple: true,
                                                onClick: row.onClick,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            px: 0,
                                                            py: 3,
                                                            width: 160
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            color: "text.secondary",
                                                            children: row.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            pl: 2,
                                                            pr: 0,
                                                            py: 3
                                                        },
                                                        children: row.content
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        align: "right",
                                                        sx: {
                                                            px: 0,
                                                            py: 3
                                                        },
                                                        children: row.right
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        !!(item === null || item === void 0 ? void 0 : item.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    sx: {
                                                        px: 0,
                                                        pt: 3,
                                                        pb: 1,
                                                        width: 160,
                                                        border: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "text.secondary",
                                                        children: (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? t("paymentPoints", "支払いポイント") : t("paymentAmount", "支払い金額")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    sx: {
                                                        pl: 2,
                                                        pr: 0,
                                                        pt: 3,
                                                        pb: 1,
                                                        border: "none"
                                                    },
                                                    colSpan: 2,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        alignItems: "center",
                                                        direction: "row",
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                                direction: "row",
                                                                alignItems: "center",
                                                                children: (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                                    size: "medium",
                                                                    point: numeral_default()(totalPrice).format("0,0")
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                                                    variant: "h6",
                                                                    children: [
                                                                        "￥",
                                                                        numeral_default()(totalPrice).format("0,0")
                                                                    ]
                                                                })
                                                            }),
                                                            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.UpArrow, {
                                                                size: "small",
                                                                onClick: function() {
                                                                    return setOpen(function(prevState) {
                                                                        return !prevState;
                                                                    });
                                                                }
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.DownArrow, {
                                                                size: "small",
                                                                onClick: function() {
                                                                    return setOpen(function(prevState) {
                                                                        return !prevState;
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        open && (0,array/* filterHiddenItem */.s)(statements).map(function(row, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            px: 0,
                                                            pt: "2px",
                                                            pb: 1,
                                                            width: 160,
                                                            border: "none"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "caption",
                                                            color: "text.secondary",
                                                            children: row.label
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            pl: 2,
                                                            pr: 0,
                                                            pt: "2px",
                                                            pb: 1,
                                                            border: "none"
                                                        },
                                                        colSpan: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                            alignItems: "center",
                                                            direction: "row",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                                direction: "row",
                                                                alignItems: "center",
                                                                children: (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                                    size: "small",
                                                                    point: numeral_default()(row.value).format("0,0")
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                                                    variant: "body2",
                                                                    children: [
                                                                        "￥",
                                                                        numeral_default()(row.value).format("0,0")
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                py: 4
                            },
                            children: [
                                !!(item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.note) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: t("agreeNotes", "注意事項に同意して")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.LongPressButton, {
                                            size: "large",
                                            onSubmit: onConfirmOrder,
                                            disabled: disabledButton,
                                            dark: (ref4 = config_config/* config.theme */.v.theme) === null || ref4 === void 0 ? void 0 : ref4.dark,
                                            children: t("confirmOrder", "長押しで注文を確定する")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            size: "large",
                                            onClick: onClickClose,
                                            children: t("back", "戻る")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var OrderItemCell = function(param) {
    var item = param.item, sku = param.sku, formattedItemPrice = param.formattedItemPrice, quantity = param.quantity;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    size: "small",
                    src: (ref7 = (ref6 = (ref5 = (ref4 = sku === null || sku === void 0 ? void 0 : (ref = sku.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref4 !== void 0 ? ref4 : sku === null || sku === void 0 ? void 0 : (ref1 = sku.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref5 !== void 0 ? ref5 : sku === null || sku === void 0 ? void 0 : (ref2 = sku.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref6 !== void 0 ? ref6 : (ref3 = item === null || item === void 0 ? void 0 : item.thumbnail.front) === null || ref3 === void 0 ? void 0 : ref3.mediumUri) !== null && ref7 !== void 0 ? ref7 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    flex: 1,
                    minWidth: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: (0,src_object_spread/* default */.Z)({
                                pr: "64px"
                            }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                            children: item === null || item === void 0 ? void 0 : item.title
                        }),
                        !!(sku === null || sku === void 0 ? void 0 : sku.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            children: sku.unitName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    children: (item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                        size: "small",
                                        point: formattedItemPrice
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                        variant: "h6",
                                        children: [
                                            "￥",
                                            formattedItemPrice
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        component: "p",
                                        children: t("quantity", {
                                            quantity: quantity
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/functionals/IonInformationModal/index.tsx
var IonInformationModal = __webpack_require__(72739);
// EXTERNAL MODULE: ./src/core/validators/index.ts
var validators = __webpack_require__(17745);
;// CONCATENATED MODULE: ./src/components/pages/StoreUserInfo/template/StoreUserInfoForm.tsx











var StoreUserInfoForm_schema = function(o) {
    return {
        phoneNumber: (0,validators/* validatePhoneNumber */.Y0)(o, "storeUserInfo.phoneNumber"),
        fullName: (0,validators/* validateFullName */.fy)(o, (0,individual/* individualUseFullNameKatakana */.DV)() ? "storeUserInfo.fullNameKatakana" : "storeUserInfo.fullName")
    };
};
var StoreUserInfoForm = function(param) {
    var deliveryInfo = param.deliveryInfo, onSubmitSetting = param.onSubmitSetting;
    var t = (0,core_i18n/* useTranslation */.$G)("storeUserInfo").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: StoreUserInfoForm_schema,
        defaultValues: StoreUserInfoForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, register = ref1.register, reset = ref1.reset, setError = ref1.setError;
    (0,react.useEffect)(function() {
        if (!deliveryInfo) return;
        var phoneNumber = deliveryInfo.phoneNumber, fullName = deliveryInfo.fullName;
        reset({
            phoneNumber: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : "",
            fullName: fullName !== null && fullName !== void 0 ? fullName : ""
        });
    }, [
        deliveryInfo,
        reset
    ]);
    var onSubmit = handleSubmit(function(values) {
        return onSubmitSetting(values).then(function(res) {
            return res !== "verifyPhoneNumber" && showMessage(t("submitSuccess"), "success");
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreUserInfoForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: errors === null || errors === void 0 ? void 0 : errors.fullName
                }, register("fullName")), {
                    titleProps: {
                        children: t((0,individual/* individualUseFullNameKatakana */.DV)() ? "fullNameTitleKatakana" : "fullNameTitle")
                    },
                    textFieldProps: {
                        placeholder: t((0,individual/* individualUseFullNameKatakana */.DV)() ? "fullNamePlaceholderKatakana" : "fullNamePlaceholder")
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreUserInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors === null || errors === void 0 ? void 0 : errors.phoneNumber
            }, register("phoneNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var StoreUserInfoForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("storeUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("storeUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var DividerCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
    });
};
var StoreUserInfoForm_defaultValues = {
    phoneNumber: "",
    fullName: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowUserInfo.tsx








var BuyNowUserInfo = function(param) {
    var user = param.user, onUserInfoSetting = param.onUserInfoSetting, openSMSVerificationModal = param.openSMSVerificationModal, sendingVerificationLoading = param.sendingVerificationLoading, onCloseSMSVerificationModal = param.onCloseSMSVerificationModal, onSendVerificationSMS = param.onSendVerificationSMS, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {
                back: true,
                title: t("title", "お客様情報の入力"),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    py: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("userInfoNote", "商品の購入に必要な情報をご入力ください。")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreUserInfoForm, {
                                onSubmitSetting: onUserInfoSetting,
                                deliveryInfo: user || {}
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IonInformationModal/* IonInformationModal */.S, {
                        open: openSMSVerificationModal,
                        onClose: onCloseSMSVerificationModal,
                        title: t("verifyTitle"),
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            align: "left",
                            children: t("verifyDesc2", {
                                phoneNumber: user === null || user === void 0 ? void 0 : user.formattedPhoneNumber
                            })
                        }),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212,
                                mt: 4
                            },
                            size: "large",
                            onClick: onSendVerificationSMS,
                            loading: sendingVerificationLoading,
                            children: t("verify")
                        }),
                        cancelText: t("close")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/core/entities/values/PostalCode.ts
var PostalCode = __webpack_require__(56903);
;// CONCATENATED MODULE: ./src/components/pages/StoreDeliveryInfo/template/StoreDeliveryInfoForm.tsx












var StoreDeliveryInfoForm_schema = function(o) {
    return {
        postalCode: o.string().custom(PostalCode/* PostalCode.createValidator */.R.createValidator()).label((0,core_form/* tLabel */.TQ)("deliveryInfoSetting.postalCode")),
        prefecture: (0,validators/* validatePrefecture */.f6)(o, "deliveryInfoSetting.prefecture"),
        city: (0,validators/* validateCity */.Co)(o, "deliveryInfoSetting.city"),
        line1: (0,validators/* validateLine1 */.lT)(o, "deliveryInfoSetting.line1"),
        line2: (0,validators/* validateLine2 */.iT)(o, "deliveryInfoSetting.line2")
    };
};
var StoreDeliveryInfoForm = function(param) {
    var deliveryInfo = param.deliveryInfo, onSubmitSetting = param.onSubmitSetting, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: StoreDeliveryInfoForm_schema,
        defaultValues: StoreDeliveryInfoForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, register = ref1.register, reset = ref1.reset, setError = ref1.setError;
    (0,react.useEffect)(function() {
        if (!deliveryInfo) return;
        var phoneNumber = deliveryInfo.phoneNumber, fullName = deliveryInfo.fullName, address = deliveryInfo.address;
        /**
     * @description
     * データをフォームに合わせるため、__typenameとfullAddressをaddressから除外する
     */ var _ref = address || {}, fullAddress = _ref.fullAddress, __typename = _ref.__typename, addressInput = (0,_object_without_properties/* default */.Z)(_ref, [
            "fullAddress",
            "__typename"
        ]);
        reset(addressInput);
    }, [
        deliveryInfo,
        reset
    ]);
    var onSubmit = handleSubmit(function(values) {
        var normalizedValues = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
            postalCode: PostalCode/* PostalCode.normalize */.R.normalize(values.postalCode)
        });
        return onSubmitSetting(normalizedValues).then(function() {
            showMessage(t("submitSuccess"), "success");
            onClose();
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                textFieldProps: {
                    InputProps: {
                        inputProps: {
                            pattern: "\\d{3}-?\\d{4}|\\d{7}",
                            inputMode: "tel",
                            sx: {
                                px: 4,
                                py: 3
                            }
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.postalCode
            }, register("postalCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.prefecture
            }, register("prefecture"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.city
            }, register("city"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line1
            }, register("line1"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line2
            }, register("line2"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var StoreDeliveryInfoForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var StoreDeliveryInfoForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var StoreDeliveryInfoForm_defaultValues = {
    postalCode: "",
    prefecture: "",
    city: "",
    line1: "",
    line2: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowDeliveryInfo.tsx







var BuyNowDeliveryInfo = function(param) {
    var user = param.user, onDeliveryInfoSetting = param.onDeliveryInfoSetting, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {
                back: true,
                title: t("customerInformation", "お客様情報の入力"),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm, {
                        onSubmitSetting: onDeliveryInfoSetting,
                        deliveryInfo: user || {},
                        onClose: onClose
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentCreate/template/PaymentCreateForm.tsx









var PaymentCreateForm_schema = function(o) {
    return {
        cardNumber: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.cardNumber")),
        cardHolder: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.cardHolder")),
        securityCode: o.string().label((0,core_form/* tLabel */.TQ)("paymentCreate.securityCode")),
        expirationDate: o.string().pattern(new RegExp("^(0[1-9]|1[0-2])/?([0-9]{2})$")).label((0,core_form/* tLabel */.TQ)("paymentCreate.expirationDate"))
    };
};
var PaymentCreateForm_defaultValues = {
    cardNumber: "",
    cardHolder: "",
    securityCode: "",
    expirationDate: ""
};
var PaymentCreateForm = function(param) {
    var onSubmitCreatePayment = param.onSubmitCreatePayment;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentCreate").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: PaymentCreateForm_schema,
        defaultValues: PaymentCreateForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, setError = ref1.setError, reset = ref1.reset, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onSubmit = handleSubmit(function(values) {
        return onSubmitCreatePayment(values).then(function() {
            showMessage(t("success"));
            reset(PaymentCreateForm_defaultValues);
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mt: 2,
                    mb: 4
                },
                children: t("register")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                inputProps: {
                    pattern: "[0-9\\s]*",
                    inputMode: "numeric"
                },
                mask: "0000 0000 0000 0000",
                error: errors === null || errors === void 0 ? void 0 : errors.cardNumber
            }, register("cardNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.cardHolder
            }, register("cardHolder"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                inputProps: {
                    pattern: "[0-9\\s]*",
                    inputMode: "numeric"
                },
                mask: "0000",
                placeholder: t(""),
                error: errors === null || errors === void 0 ? void 0 : errors.securityCode
            }, register("securityCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                inputProps: {
                    pattern: "[0-9/]*",
                    inputMode: "numeric"
                },
                mask: "00/00",
                error: errors === null || errors === void 0 ? void 0 : errors.expirationDate
            }, register("expirationDate"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var PaymentCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("paymentCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var PaymentCreateForm_MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("paymentCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            placeholder: t("".concat(props.name, "Placeholder"))
        }))
    });
});
var PaymentCreateForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: "contained",
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowPaymentCreate.tsx







var BuyNowPaymentCreate = function(param) {
    var onCreatePayment = param.onCreatePayment, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {
                back: true,
                title: t("paymentCreateTitle", "支払い方法"),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm, {
                        onSubmitCreatePayment: onCreatePayment
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowCompletion.tsx









var BuyNowCompletion = function(param) {
    var itemId = param.itemId, skuId = param.skuId, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header/* Header */.h, {
                title: t("completionTitle", "購入完了"),
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                alignItems: "center",
                sx: {
                    pt: 6,
                    pb: 5
                },
                spacing: 2
            }, displayResponsive ? {
                maxWidth: "1120px",
                margin: "0 auto"
            } : {}), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("orderCompleted", "ご注文が完了しました。")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("thankForYourPurchase", "ご購入いただきありがとうございます！")
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    py: 5
                },
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: function() {
                            onClose();
                            setTimeout(function() {
                                router.push({
                                    pathname: generatePath(routerPages.OwnedItemDetail, {
                                        itemId: itemId
                                    }),
                                    search: skuId ? "?skuId=".concat(encodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "")) : ""
                                });
                            });
                        },
                        children: t("checkPurchasedItem", "購入した商品を確認する")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        variant: "text",
                        onClick: function() {
                            onClose();
                            setTimeout(function() {
                                router.push(generatePath(routerPages.Top));
                            });
                        },
                        children: t("goToTOP", "TOPページへ")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/pages/ArtistStoreItemDetail/template/components/BuyNowSMSVerification.tsx
var BuyNowSMSVerification = __webpack_require__(25941);
;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/BuyNowModal.tsx

















var BuyNowModal = function(_param) {
    var open = _param.open, onClose = _param.onClose, onPurchaseItem = _param.onPurchaseItem, onCreatePayment = _param.onCreatePayment, onUserInfoSetting = _param.onUserInfoSetting, onSendVerificationSMS = _param.onSendVerificationSMS, onVerificationPhoneNumber = _param.onVerificationPhoneNumber, props = (0,_object_without_properties/* default */.Z)(_param, [
        "open",
        "onClose",
        "onPurchaseItem",
        "onCreatePayment",
        "onUserInfoSetting",
        "onSendVerificationSMS",
        "onVerificationPhoneNumber"
    ]);
    var isNativeIOS = core_dist/* Capacitor.isNativePlatform */.dV.isNativePlatform() && dist_lib/* isIOS */.gn;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var modalRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(StepKey.ITEM_DETAIL), currentStep = ref[0], setCurrentStep = ref[1];
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var STEPS = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            ITEM_DETAIL: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowItemDetail, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                    onClose: function() {
                        var ref;
                        if ((ref = modalRef.current) === null || ref === void 0 ? void 0 : ref.canDismiss) {
                            onClose();
                        }
                    },
                    onClickClose: onClose,
                    onNextStep: setCurrentStep,
                    onConfirmOrder: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!modalRef.current) {
                                        return [
                                            2
                                        ];
                                    }
                                    modalRef.current.canDismiss = false;
                                    return [
                                        4,
                                        onPurchaseItem().then(function() {
                                            return setCurrentStep(StepKey.COMPLETION);
                                        }).catch(function() {})
                                    ];
                                case 1:
                                    _state.sent();
                                    modalRef.current.canDismiss = true;
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    onSendVerificationSMS: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onSendVerificationSMS().then(function() {
                                            return setCurrentStep(StepKey.SMS_VERIFICATION);
                                        }).catch(showError)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                }))
            }),
            USER_INFO: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowUserInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                    onClose: function() {
                        return setCurrentStep(StepKey.ITEM_DETAIL);
                    },
                    onUserInfoSetting: function(inputs) {
                        return onUserInfoSetting(inputs).then(function(isPhoneNumberVerified) {
                            if (isPhoneNumberVerified) {
                                setCurrentStep(StepKey.ITEM_DETAIL);
                            }
                        });
                    },
                    onSendVerificationSMS: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onSendVerificationSMS().then(function() {
                                            return setCurrentStep(StepKey.SMS_VERIFICATION);
                                        }).catch(showError)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    })
                }))
            }),
            DELIVERY_INFO: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowDeliveryInfo, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                    onClose: function() {
                        return setCurrentStep(StepKey.ITEM_DETAIL);
                    }
                }))
            }),
            PAYMENT_CREATE: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowPaymentCreate, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                    onCreatePayment: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onCreatePayment(values).then(function() {
                                                return setCurrentStep(StepKey.ITEM_DETAIL);
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onClose: function() {
                        return setCurrentStep(StepKey.ITEM_DETAIL);
                    }
                }))
            }),
            COMPLETION: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowCompletion, {
                    onClose: onClose,
                    itemId: (ref = props.item) === null || ref === void 0 ? void 0 : ref.id,
                    skuId: (ref1 = props.sku) === null || ref1 === void 0 ? void 0 : ref1.id
                })
            }),
            SMS_VERIFICATION: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowSMSVerification/* BuyNowSMSVerification */.y, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                    onVerificationPhoneNumber: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onVerificationPhoneNumber(inputs).then(function() {
                                                return setCurrentStep(StepKey.ITEM_DETAIL);
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(inputs) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onClose: function() {
                        return setCurrentStep(StepKey.ITEM_DETAIL);
                    }
                }))
            })
        };
    }, [
        onClose,
        onPurchaseItem,
        onCreatePayment,
        onUserInfoSetting,
        onSendVerificationSMS,
        onVerificationPhoneNumber,
        props,
        showError, 
    ]);
    (0,react.useEffect)(function() {
        var ionicModal = modalRef.current;
        return function() {
            ionicModal === null || ionicModal === void 0 ? void 0 : ionicModal.dismiss();
        };
    }, []);
    /*
   * To avoid the situation where when the user scrolls the modal,
   * the website content below the modal will be scrolled.
   * When BuyNowModal is open, overflowY of body have 'hidden' value
   * and it'll be reset when Buy Now Modal is close
   */ (0,react.useEffect)(function() {
        if (!document) return;
        if (open) {
            document.body.style.overflowY = "hidden";
            return;
        }
        if (isNativeIOS) {
            document.body.style.overflowY = "unset";
            return;
        }
        document.body.style.overflowY = "auto";
        return function() {
            document.body.style.overflowY = "auto";
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
                styles: {
                    "ion-modal": {
                        "--height": "90%",
                        position: "fixed",
                        bottom: 0
                    }
                }
            }),
            config_config/* config.applicationKey */.v.applicationKey === "utoniq" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPlusScript, {
                title: routerNames.ArtistStoreItemDetail,
                isCompleted: currentStep === StepKey.COMPLETION
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* IonModal */.ki, {
                className: "parent-modal",
                ref: modalRef,
                mode: "ios",
                isOpen: open,
                onDidDismiss: function() {
                    onClose();
                    setCurrentStep(StepKey.ITEM_DETAIL);
                },
                breakpoints: [
                    0,
                    1
                ],
                initialBreakpoint: 1,
                swipeToClose: false,
                handle: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: (0,src_object_spread/* default */.Z)({
                        height: "100%",
                        overflowX: "auto",
                        backgroundColor: "background.default"
                    }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                    children: STEPS[currentStep]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/core/analytics/ConversionKeys.ts
/**
 * Conversionのカテゴリー
 */ var ConversionCategories = {
    // プリペイドポイント
    prepaidPoint: "prepaid_point",
    gachaTicket: "gacha_ticket",
    storeItem: "store_item",
    preSaleItem: "preSale_item"
};
/**
 * Conversionアイテムが表示されるリスト
 */ var ConversionListName = {
    // 購入可能プリペイドポイントリスト
    purchasablePrepaidPointList: "purchasable_prepaid_point_list"
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/template/index.tsx



































var ArtistStoreItemDetail_template_client = algolia/* client */.Lp();
var ArtistStoreItemDetailTemplate = function(param) {
    var state = param.state, onAddToCart = param.onAddToCart, connectMetamask = param.connectMetamask, connectToWeb3auth = param.connectToWeb3auth, onPurchaseCharge = param.onPurchaseCharge, onPurchaseItem = param.onPurchaseItem, onUserInfoSetting = param.onUserInfoSetting, onSendVerificationSMS = param.onSendVerificationSMS, onCloseSMSVerificationModal = param.onCloseSMSVerificationModal, onCreatePayment = param.onCreatePayment, onDeliveryInfoSetting = param.onDeliveryInfoSetting, onResendVerificationSMS = param.onResendVerificationSMS, onVerificationPhoneNumber = param.onVerificationPhoneNumber, onClickShare = param.onClickShare, onGetArtistStoreItemDetailWithSku = param.onGetArtistStoreItemDetailWithSku, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref38 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref38.routerNames, generatePath = ref38.generatePath, routerPages = ref38.routerPages, router = ref38.router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref39 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref39.showMessage, showError = ref39.showError;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var publishedAtTimestampRef = (0,react.useRef)(values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds());
    var itemResultRef = (0,react.useRef)({
        items: [],
        page: 1
    });
    var instantSearchRef = (0,react.useRef)(null);
    var ref40 = (0,react.useState)(false), openConfirmFreeItem = ref40[0], setOpenConfirmFreeItem = ref40[1];
    var ref41 = (0,react.useState)({
        page: 1
    }), searchState = ref41[0], setSearchState = ref41[1];
    var ref42 = (0,react.useState)(false), openNoEnoughPoint = ref42[0], setOpenNoEnoughPoint = ref42[1];
    var ref43 = (0,react.useState)(), skuId = ref43[0], setSkuId = ref43[1];
    var ref44 = (0,react.useState)(undefined), skuTag = ref44[0], setSkuTag = ref44[1];
    var ref45 = (0,react.useState)(false), openNftConnectDrawer = ref45[0], setOpenNftConnectDrawer = ref45[1];
    var ref46 = (0,react.useState)(false), connecting = ref46[0], setConnecting = ref46[1];
    var ref47 = (0,react.useState)(false), openWalletCreateConfirmModal = ref47[0], setOpenWalletCreateConfirmModal = ref47[1];
    var ref48 = (0,react.useState)(false), openNftInfoModal = ref48[0], setOpenNftInfoModal = ref48[1];
    var ref49 = (0,react.useState)(1), purchaseNumber = ref49[0], setPurchaseNumber = ref49[1];
    var ref50 = (0,react.useState)(false), openPersonalInfoModal = ref50[0], setOpenPersonalInfoModal = ref50[1];
    /** ポイントチャージ用ドロワーの表示状態 */ var ref51 = (0,react.useState)(false), openPointPurchaseDrawer = ref51[0], setOpenPointPurchaseDrawer = ref51[1];
    /** SKUを選択していない状態で購入しようとした時に表示されるUI */ var ref52 = (0,react.useState)("close"), skuUnitSelectBottomSheetType = ref52[0], setSkuUnitSelectBottomSheetType = ref52[1];
    var ref53 = (0,react.useState)(false), openBuyNow = ref53[0], setOpenBuyNow = ref53[1];
    var isNftItem = !!((ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.nft) === null || ref1 === void 0 ? void 0 : ref1.chains);
    var totalPurchasableCount = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!((ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.purchasableUsers) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            return 0;
        }
        var _purchasableCount;
        return (ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.purchasableUsers.filter(function(purchasableUser) {
            return purchasableUser.userId === state.userLoggedInId;
        }).reduce(function(total, purchasableUser) {
            return total + ((_purchasableCount = purchasableUser.purchasableCount) !== null && _purchasableCount !== void 0 ? _purchasableCount : 0);
        }, 0);
    }, [
        (ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.purchasableUsers,
        state.userLoggedInId
    ]);
    var purchaseLimitByUser = (0,react.useMemo)(function() {
        var ref;
        if (typeof ((ref = state.item) === null || ref === void 0 ? void 0 : ref.purchaseLimitByUser) !== "number") {
            return totalPurchasableCount !== null && totalPurchasableCount !== void 0 ? totalPurchasableCount : 10;
        }
        if (state.item.purchaseLimitByUser < totalPurchasableCount) {
            return state.item.purchaseLimitByUser;
        }
        return state.item.purchaseLimitByUser - totalPurchasableCount;
    }, [
        (ref3 = state.item) === null || ref3 === void 0 ? void 0 : ref3.purchaseLimitByUser,
        totalPurchasableCount
    ]);
    var ref54 = useStoreButton({
        item: state.item,
        isNft: isNftItem,
        userId: (ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.id,
        isLoggedIn: state.isLoggedIn,
        isWalletConnect: state.isConnect,
        purchaseLimitByUser: purchaseLimitByUser
    }), buttonLabel = ref54.label, buttonDisabled = ref54.disabled, restrected = ref54.restrected, maximumPurchasableNumber = ref54.maximumPurchasableNumber;
    var ref55 = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        if (!isNaN(Number((ref1 = skuTag === null || skuTag === void 0 ? void 0 : skuTag.price) !== null && ref1 !== void 0 ? ref1 : undefined))) {
            var ref2;
            return {
                itemPrice: skuTag === null || skuTag === void 0 ? void 0 : skuTag.price,
                formattedItemPrice: (ref2 = skuTag === null || skuTag === void 0 ? void 0 : skuTag.formattedPrice) !== null && ref2 !== void 0 ? ref2 : "0"
            };
        }
        if ((ref = state.item) === null || ref === void 0 ? void 0 : ref.price) {
            var ref3, ref4;
            var ref5;
            return {
                itemPrice: (ref3 = state.item) === null || ref3 === void 0 ? void 0 : ref3.price,
                formattedItemPrice: (ref5 = (ref4 = state.item) === null || ref4 === void 0 ? void 0 : ref4.formattedPrice) !== null && ref5 !== void 0 ? ref5 : "0"
            };
        }
        return {
            itemPrice: 0,
            formattedItemPrice: "0"
        };
    }, [
        skuTag === null || skuTag === void 0 ? void 0 : skuTag.formattedPrice,
        skuTag === null || skuTag === void 0 ? void 0 : skuTag.price,
        (ref5 = state.item) === null || ref5 === void 0 ? void 0 : ref5.formattedPrice,
        (ref6 = state.item) === null || ref6 === void 0 ? void 0 : ref6.price, 
    ]), formattedItemPrice = ref55.formattedItemPrice, itemPrice = ref55.itemPrice;
    var handleChangePurchaseNumber = function(number) {
        return setPurchaseNumber(number);
    };
    var onConnectWeb3auth = function() {
        setConnecting(true);
        return connectToWeb3auth().catch(function(e) {
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenWalletCreateConfirmModal(false);
            setOpenNftConnectDrawer(false);
        });
    };
    var onConnectMetamask = function() {
        setConnecting(true);
        return connectMetamask().then(function() {
            showMessage(t("connected"));
        }).catch(function(e) {
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenNftConnectDrawer(false);
        });
    };
    (0,react.useEffect)(function() {
        setSearchState(function(prevState) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                page: 1
            });
        });
    }, [
        state.item
    ]);
    /**
   * hack to reset sku value when url path changed
   */ (0,react.useEffect)(function() {
        setSkuTag(undefined);
        setSkuId(undefined);
        setPurchaseNumber(1);
        setOpenPointPurchaseDrawer(false);
    }, [
        router.pathname
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var baseLayoutElement = document.getElementsByClassName("BaseLayout");
        baseLayoutElement === null || baseLayoutElement === void 0 ? void 0 : (ref = baseLayoutElement[0]) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0
        });
    }, [
        router.pathname
    ]);
    (0,react.useEffect)(function() {
        if (state.item) {
            analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item", {
                currency: "JPY",
                value: state.item.price,
                items: itemResultRef.current.items.map(function(item) {
                    return {
                        item_id: item.id,
                        item_name: item.title,
                        item_category: ConversionCategories.storeItem,
                        item_category2: item.type,
                        item_category3: native_app/* getPlatform */.Xf(),
                        item_category4: itemResultRef.current.page,
                        item_category5: state.artistId,
                        price: item.price
                    };
                })
            });
        }
    }, [
        analytics,
        state.artistId,
        state.item
    ]);
    var handleOnCompleted = (0,react.useCallback)(function(items, param) {
        var page = param.page;
        itemResultRef.current = {
            items: items,
            page: page
        };
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "artist_store_list_related_".concat(state.artistId),
            item_list_name: "Artist Store Related Items",
            items: items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: ConversionCategories.storeItem,
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var handleOnSelectItem = (0,react.useCallback)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            items: itemResultRef.current.items.map(function(item) {
                return {
                    item_id: item.id,
                    item_name: item.title,
                    item_category: ConversionCategories.storeItem,
                    item_category2: item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: itemResultRef.current.page,
                    item_category5: state.artistId,
                    price: item.price
                };
            })
        });
    }, [
        analytics,
        state.artistId
    ]);
    var onAnalyzeCheckout = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("add_to_cart", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            isInstant: true,
            items: [
                {
                    item_id: (ref = state.item) === null || ref === void 0 ? void 0 : ref.id,
                    item_name: (ref1 = state.item) === null || ref1 === void 0 ? void 0 : ref1.title,
                    item_category: ConversionCategories.storeItem,
                    item_category2: (ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: null,
                    item_category5: state.artistId,
                    price: (ref3 = state.item) === null || ref3 === void 0 ? void 0 : ref3.price,
                    quantity: purchaseNumber
                }, 
            ]
        });
        analytics === null || analytics === void 0 ? void 0 : analytics.track("begin_checkout", {
            item_list_id: "artist_store_list_".concat(state.artistId),
            item_list_name: "Artist Store Items",
            isInstant: true,
            items: [
                {
                    item_id: (ref4 = state.item) === null || ref4 === void 0 ? void 0 : ref4.id,
                    item_name: (ref5 = state.item) === null || ref5 === void 0 ? void 0 : ref5.title,
                    item_category: ConversionCategories.storeItem,
                    item_category2: (ref6 = state.item) === null || ref6 === void 0 ? void 0 : ref6.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: null,
                    item_category5: state.artistId,
                    price: (ref7 = state.item) === null || ref7 === void 0 ? void 0 : ref7.price,
                    quantity: purchaseNumber
                }, 
            ]
        });
    };
    /** カート追加処理。未ログインの場合、ゲストログインを許可する */ var handleAddToCart = function() {
        var ref, ref1, ref2;
        if (((ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : ref1.units.length) && !(skuTag === null || skuTag === void 0 ? void 0 : skuTag.id)) {
            return setSkuUnitSelectBottomSheetType("cart");
        }
        onAddToCart({
            itemId: ((ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.id) || router.query.itemId,
            skuId: skuTag === null || skuTag === void 0 ? void 0 : skuTag.id,
            count: purchaseNumber
        });
    };
    var handleBuyNow = handleLoginModal(function() {
        var ref, ref1;
        if (((ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : ref1.units.length) && !(skuTag === null || skuTag === void 0 ? void 0 : skuTag.id)) {
            return setSkuUnitSelectBottomSheetType("buyNow");
        }
        if (!itemPrice) {
            setOpenConfirmFreeItem(true);
            return;
        }
        setOpenBuyNow(true);
    });
    // 代金や手数料など、支払のすべてをブレイクダウンした配列
    var statements = [
        {
            label: ((ref7 = state.item) === null || ref7 === void 0 ? void 0 : ref7.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? t("totalItemPoints") : t("totalItemAmount"),
            value: (itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0) * purchaseNumber
        }, 
    ].concat((0,src_to_consumable_array/* default */.Z)((((ref8 = state.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fees) === null || ref9 === void 0 ? void 0 : ref9.collections) || []).map(function(fee) {
        var ref;
        var feeValue = (ref = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref !== void 0 ? ref : 0;
        return {
            label: fee === null || fee === void 0 ? void 0 : fee.feeName,
            value: (fee === null || fee === void 0 ? void 0 : fee.per) === "order" ? feeValue : feeValue * purchaseNumber
        };
    })), (0,src_to_consumable_array/* default */.Z)(((ref10 = state.item) === null || ref10 === void 0 ? void 0 : ref10.type) === utoniq_core_schema/* ItemType.Merch */.qGq.Merch ? [
        {
            label: (ref11 = state.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fees) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.shipping) === null || ref13 === void 0 ? void 0 : ref13.feeName,
            value: (ref14 = state.item) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.fees) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.shipping) === null || ref16 === void 0 ? void 0 : ref16.fee
        }, 
    ] : []));
    //skuがあればsku単位のwillResaleAvailable,なければitem単位のwillResaleAvailableを使う
    var willResaleAvailable = ((ref17 = state.item) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.skuSettings) === null || ref18 === void 0 ? void 0 : ref18.units) ? !!state.skuWillResaleAvailable : !!((ref19 = state.item) === null || ref19 === void 0 ? void 0 : ref19.willResaleAvailable);
    var skuButtonActive = !state.skuButtonActive ? !!((ref20 = state.item) === null || ref20 === void 0 ? void 0 : ref20.willResaleAvailable) : state.skuButtonActive;
    var ref56;
    var totalPrice = statements.reduce(function(acc, curr) {
        return acc + ((ref56 = curr === null || curr === void 0 ? void 0 : curr.value) !== null && ref56 !== void 0 ? ref56 : 0);
    }, 0);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    if (!config_config/* config.modules.item */.v.modules.item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    if (!state.loading && !state.item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    /**
   * NFT 停止に向けて、NFTアイテムの詳細ページを表示しない
   * NFT 機能停止後には削除して問題ない
   */ if (isNftItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    var ref57, ref58, ref59, _point;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistStoreItemDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                header: (0,src_object_spread/* default */.Z)({
                    back: true,
                    defaultBackPage: state.artistId && generatePath(routerPages.ArtistTop, {
                        artistId: state.artistId
                    }),
                    right: state.isLoggedIn && !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && !(0,individual/* individualHideWallet */.Bd)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayPurchase/* PointDisplayPurchase */.u, {
                        point: state.formattedPoint,
                        onClick: function() {
                            return setOpenPointPurchaseDrawer(true);
                        }
                    })
                }, displayResponsive ? {
                    responsive: true,
                    maxWidth: 1120
                } : {}),
                customNavigation: state.item && !restrected && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreButtonBox, {
                    label: buttonLabel,
                    disabled: buttonDisabled,
                    purchaseLimitPerOrder: state.item.purchaseLimitPerOrder,
                    purchaseLimitByUser: purchaseLimitByUser,
                    item: state.item,
                    formattedItemPrice: formattedItemPrice,
                    maximumPurchasableNumber: maximumPurchasableNumber,
                    paymentType: state.item.paymentType,
                    loading: state.addingToCart || state.loadingItemWithSku,
                    purchaseNumber: purchaseNumber,
                    onChangePurchaseNumber: handleChangePurchaseNumber,
                    onAddToCart: handleAddToCart,
                    onBuyNow: handleBuyNow,
                    skuId: skuId,
                    willResaleAvailable: willResaleAvailable,
                    responsive: displayResponsive,
                    maxWidth: displayResponsive ? 1120 : undefined
                })
            }, displayResponsive ? {
                customNavigationSx: {
                    maxWidth: "100%"
                },
                maxWidth: 1120
            } : {}), {
                children: [
                    state.loading || !(state === null || state === void 0 ? void 0 : state.item) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailBoxSkeleton/* ItemDetailBoxSkeleton */.F, {
                                hiddenSupplementLink: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreButtonBoxSkeleton, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: [
                            config_config/* config.modules.nft */.v.modules.nft && isNftItem && !state.isConnect && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 4,
                                sx: {
                                    px: 6,
                                    py: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        display: "flex",
                                        flexDirection: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                                sx: {
                                                    color: "red",
                                                    height: 20,
                                                    width: 20,
                                                    mr: 2
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: t("nftConnectTitle")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            onClick: function() {
                                                return setOpenNftConnectDrawer(true);
                                            },
                                            sx: {
                                                width: 244,
                                                mx: "auto"
                                            },
                                            children: t("nftConnect")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        pb: 4
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailBox/* ItemDetailBox */.L, {
                                        userItem: {
                                            item: state.item,
                                            number: 0,
                                            isSystemProtected: false,
                                            isUserProtected: false,
                                            serials: []
                                        },
                                        showPreSale: !!state.item.preSale,
                                        isPremium: state.item.isPremium,
                                        purchasablePlanNames: state.purchasablePlanNames,
                                        skuUnit: skuTag,
                                        userId: (ref21 = state.user) === null || ref21 === void 0 ? void 0 : ref21.id,
                                        hiddenPurchaseLimit: false,
                                        viewable: true,
                                        hiddenInfo: !!state.item.hideSalesNumber,
                                        hidden: {
                                            trade: true,
                                            expansion: true
                                        },
                                        onClickNftIcon: function() {
                                            return setOpenNftInfoModal(true);
                                        },
                                        isPickUp: !!((ref22 = state.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.collection) === null || ref23 === void 0 ? void 0 : ref23.isEventPickup),
                                        isMerch: state.item.type === utoniq_core_schema/* ItemType.Merch */.qGq.Merch,
                                        onClickShare: onClickShare,
                                        purchaseLimitByUser: purchaseLimitByUser
                                    })
                                })
                            }),
                            !state.item.preSale && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuType, {
                                value: skuId,
                                disabled: skuButtonActive === true ? false : buttonDisabled,
                                paymentType: (ref24 = state.item) === null || ref24 === void 0 ? void 0 : ref24.paymentType,
                                skuSettings: (ref25 = state.item) === null || ref25 === void 0 ? void 0 : ref25.skuSettings,
                                issuedNumber: (ref26 = state.item) === null || ref26 === void 0 ? void 0 : ref26.issuedNumber,
                                isResaleEnable: skuButtonActive ? skuButtonActive : (ref57 = (ref27 = state.item) === null || ref27 === void 0 ? void 0 : ref27.isResaleEnable) !== null && ref57 !== void 0 ? ref57 : (ref28 = state.item) === null || ref28 === void 0 ? void 0 : ref28.isResaleAvailable,
                                onSelect: function(sku) {
                                    setSkuId(sku === null || sku === void 0 ? void 0 : sku.id);
                                    setSkuTag(sku);
                                    onGetArtistStoreItemDetailWithSku(sku === null || sku === void 0 ? void 0 : sku.id);
                                },
                                hasAlertText: false
                            }),
                            ((ref29 = state.item.metadata) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.ticket) === null || ref30 === void 0 ? void 0 : ref30.note) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    my: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                                fontSize: "small",
                                                sx: {
                                                    color: "grey.600"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                color: "text.secondary",
                                                children: t("ticketNote")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: (ref31 = state.item) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.metadata) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.ticket) === null || ref33 === void 0 ? void 0 : ref33.note
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreButtonResaleBox, {
                                item: state.item,
                                skuId: skuId,
                                userActiveResaleItemRaffle: state.userActiveResaleItemRaffle,
                                skuButtonActive: skuButtonActive,
                                willResaleAvailable: willResaleAvailable,
                                // 対象者限定かつユーザーが対象者でない場合
                                restrected: restrected
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuUnitSelectBottomSheet, {
                                open: !!skuUnitSelectBottomSheetType && skuUnitSelectBottomSheetType !== "close",
                                item: state.item,
                                itemId: state.itemId,
                                skuValue: skuId,
                                disabled: !skuId,
                                label: skuUnitSelectBottomSheetType === "buyNow" ? t("purchaseNow", "今すぐ購入") : t("addToCart", "カートに追加"),
                                formattedItemPrice: formattedItemPrice,
                                skuSettings: (ref34 = state.item) === null || ref34 === void 0 ? void 0 : ref34.skuSettings,
                                purchaseNumber: purchaseNumber,
                                maximumPurchasableNumber: maximumPurchasableNumber,
                                onChangePurchaseNumber: handleChangePurchaseNumber,
                                onClose: function() {
                                    return setSkuUnitSelectBottomSheetType("close");
                                },
                                onSelect: function(sku) {
                                    setSkuId(sku === null || sku === void 0 ? void 0 : sku.id);
                                    setSkuTag(sku);
                                    onGetArtistStoreItemDetailWithSku(sku === null || sku === void 0 ? void 0 : sku.id);
                                },
                                loading: state.addingToCart,
                                onPurchase: skuUnitSelectBottomSheetType === "cart" ? handleAddToCart : handleBuyNow,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNowModal, {
                                item: state.item,
                                user: state.user,
                                open: openBuyNow,
                                sku: skuTag,
                                onClose: function() {
                                    return setOpenBuyNow(function() {
                                        return false;
                                    });
                                },
                                prepaidPointBalance: {
                                    balance: state.point
                                },
                                paymentSource: state.paymentSource,
                                quantity: purchaseNumber,
                                onPurchaseItem: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                onAnalyzeCheckout();
                                                return [
                                                    4,
                                                    onPurchaseItem(purchaseNumber, totalPrice, skuId)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                statements: statements,
                                totalPrice: totalPrice,
                                formattedItemPrice: formattedItemPrice,
                                verifyingSMSCode: state.verifyingSMSCode,
                                sendingVerificationLoading: state.sendingVerificationLoading,
                                openSMSVerificationModal: state.openSMSVerificationModal,
                                onCloseSMSVerificationModal: onCloseSMSVerificationModal,
                                onUserInfoSetting: onUserInfoSetting,
                                onSendVerificationSMS: onSendVerificationSMS,
                                onCreatePayment: onCreatePayment,
                                onDeliveryInfoSetting: onDeliveryInfoSetting,
                                onResendVerificationSMS: onResendVerificationSMS,
                                onVerificationPhoneNumber: onVerificationPhoneNumber,
                                phoneNumber: (ref58 = (ref35 = state.user) === null || ref35 === void 0 ? void 0 : ref35.formattedPhoneNumber) !== null && ref58 !== void 0 ? ref58 : "",
                                onOpenPointPurchaseDrawer: function() {
                                    return setOpenPointPurchaseDrawer(true);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModal, {
                                hasItem: state.hasItem,
                                open: openConfirmFreeItem,
                                itemPurchasing: state.itemPurchasing,
                                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    onPurchaseItem(purchaseNumber, itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0, skuId).then(function() {
                                                        var _artistId, _itemId;
                                                        router.push({
                                                            pathname: generatePath(routerPages.StoreItemCompleteFree, {
                                                                artistId: (_artistId = state.artistId) !== null && _artistId !== void 0 ? _artistId : "#",
                                                                itemId: (_itemId = state.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
                                                            }),
                                                            search: "".concat(skuId ? "?skuId=".concat(encodeSkuId(skuId)) : "")
                                                        });
                                                    }).catch(function(e) {
                                                        return showError(e);
                                                    }).finally(function() {
                                                        setOpenConfirmFreeItem(false);
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                onClose: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        itemId: state.itemId,
                                        artistId: state.artistId,
                                        type: "modal",
                                        name: "itemDetailConfirm"
                                    });
                                    setOpenConfirmFreeItem(false);
                                },
                                name: (ref36 = state.item) === null || ref36 === void 0 ? void 0 : ref36.title,
                                point: itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0,
                                formattedPoint: (ref59 = (ref37 = state.item) === null || ref37 === void 0 ? void 0 : ref37.formattedPrice) !== null && ref59 !== void 0 ? ref59 : 0,
                                purchaseNumber: purchaseNumber
                            })
                        ]
                    }),
                    config_config/* config.modules.store */.v.modules.store && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                        ref: instantSearchRef,
                        indexName: algolia/* indexes.items */.RG.items,
                        searchClient: ArtistStoreItemDetail_template_client,
                        refresh: true,
                        searchState: searchState,
                        onSearchStateChange: function(newSearchState) {
                            return setSearchState(newSearchState);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                                hitsPerPage: 10,
                                filters: algolia/* filters.itemStoreArtist */.u8.itemStoreArtist(state.artistId, publishedAtTimestampRef.current, state.itemId)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_StoreItemsInfiniteHits, {
                                artistId: state.artistId,
                                userLoggedInId: state.userLoggedInId,
                                onSelectItem: handleOnSelectItem,
                                responsive: displayResponsive
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(template/* StoreStateResults */.Zx, {
                                onCompleted: handleOnCompleted
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoEnoughPointModal, {
                        itemId: state.itemId,
                        artistId: state.artistId,
                        prepaidPointId: state.prepaidPointId,
                        open: openNoEnoughPoint,
                        openPointPurchaseDrawer: function() {
                            setOpenPointPurchaseDrawer(true);
                            setOpenNoEnoughPoint(false);
                        },
                        onClose: function() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                prepaidPointId: state.prepaidPointId,
                                itemId: state.itemId,
                                artistId: state.artistId,
                                name: "itemDetailPoint",
                                type: "modal"
                            });
                            setOpenNoEnoughPoint(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeDrawer, {
                        point: (_point = state.point) !== null && _point !== void 0 ? _point : 0,
                        onPurchase: function(plan, paymentMethod) {
                            return onPurchaseCharge(plan, paymentMethod, {
                                // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                                successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistStoreItemDetail, {
                                    artistId: router.query.artistId,
                                    itemId: router.query.itemId
                                }), "?points=").concat(plan.points),
                                // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                                cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistStoreItemDetail, {
                                    artistId: router.query.artistId,
                                    itemId: router.query.itemId
                                })),
                                // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                                errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistStoreItemDetail, {
                                    artistId: router.query.artistId,
                                    itemId: router.query.itemId
                                }))
                            });
                        },
                        open: openPointPurchaseDrawer,
                        purchasablePrepaidPoints: state.purchasablePrepaidPoints,
                        onClose: function() {
                            return setOpenPointPurchaseDrawer(false);
                        },
                        chargeLoading: state.pointChargeLoading,
                        paymentSource: state.paymentSource,
                        loading: state.loading,
                        enablePointCarrierPayment: state.enablePointCarrierPayment,
                        pageName: "artistStoreDetail",
                        responsive: displayResponsive
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletConnectDrawer, (0,src_object_spread/* default */.Z)({
                        open: openNftConnectDrawer,
                        onClose: function() {
                            return setOpenNftConnectDrawer(false);
                        },
                        connecting: false,
                        onConnectWallet: function(walletType) {
                            switch(walletType){
                                case "web3auth":
                                    return setOpenWalletCreateConfirmModal(true);
                                case "metamask":
                                    return onConnectMetamask();
                            }
                        }
                    }, displayResponsive ? {
                        sx: {
                            "& .MuiPaper-root": {
                                maxWidth: "100%"
                            }
                        }
                    } : {})),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCryptoWalletConfirmModal, {
                        open: openWalletCreateConfirmModal,
                        loading: connecting,
                        onClose: function() {
                            return setOpenWalletCreateConfirmModal(false);
                        },
                        onCreate: onConnectWeb3auth
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInfoModal, {
                        open: openPersonalInfoModal,
                        onClose: function() {
                            return setOpenPersonalInfoModal(false);
                        },
                        user: state.user
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NftInfoModal, {
                        open: openNftInfoModal,
                        onClose: function() {
                            return setOpenNftInfoModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                        open: state.openRequire3DSecureModal,
                        onClose: onCloseRequire3DSecureModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                        open: state.openExpiredCardModal,
                        onClose: onCloseExpiredCardModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                        open: state.openPaymentErrorModal,
                        onClose: onClosePaymentErrorModal
                    })
                ]
            }))
        ]
    });
};
var template_StoreItemsInfiniteHits = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, artistId = param.artistId, userLoggedInId = param.userLoggedInId, refineNext = param.refineNext, onSelectItem = param.onSelectItem, responsive = param.responsive;
    var items = hits.map(function(_param) {
        var objectID = _param.objectID, item = (0,_object_without_properties/* default */.Z)(_param, [
            "objectID"
        ]);
        return (0,src_object_spread/* default */.Z)({
            id: objectID
        }, item);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_StoreItemsCell, {
        items: items,
        artistId: artistId,
        userLoggedInId: userLoggedInId,
        hasNextPage: hasMore,
        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    refineNext()
                ];
            });
        }),
        onSelectItem: onSelectItem,
        responsive: responsive
    });
});
var template_StoreItemsCell = function(param) {
    var hasNextPage = param.hasNextPage, items = param.items, userLoggedInId = param.userLoggedInId, onFetchMore = param.onFetchMore, artistId = param.artistId, onSelectItem = param.onSelectItem, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            py: 2
                        },
                        children: t("otherItem")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            mr: -2
                        },
                        href: generatePath(routerPages.ArtistStore, {
                            artistId: artistId
                        }),
                        children: t("toList")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: false,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                component: Grid/* default */.ZP,
                componentProps: {
                    spacing: 3,
                    container: true
                },
                itemComponent: Grid/* default */.ZP,
                itemComponentProps: responsive ? {
                    item: true,
                    xs: 4,
                    sm: 3
                } : {
                    item: true,
                    xs: 4,
                    md: 3
                },
                nodes: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemArea/* StoreItemArea */.S, (0,src_object_spread/* default */.Z)({
                        item: item,
                        artistId: artistId,
                        onClick: function() {
                            return onSelectItem(item);
                        },
                        showMenberOnlyIcon: true
                    }, responsive ? {
                        responsive: true,
                        aspectRatio: "1 / 1"
                    } : {}), index);
                })
            })
        ]
    });
};
var ConfirmModal = function(param) {
    var open = param.open, hasItem = param.hasItem, itemPurchasing = param.itemPurchasing, onClose = param.onClose, onClick = param.onClick, name = param.name, point = param.point, purchaseNumber = param.purchaseNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        title: point ? t("confirmPurchaseModalTitle") : t("confirmAcquireModalTitle"),
        content: point ? hasItem ? t("confirmAcquiredItemContent", {
            name: name
        }) : t("confirmAcquireModalContent", {
            name: name,
            purchaseNumber: purchaseNumber
        }) : t("confirmAcquireModalContent", {
            name: name,
            purchaseNumber: purchaseNumber
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            size: "large",
            loading: itemPurchasing,
            onClick: onClick,
            children: t("acquire")
        }),
        cancelText: t("close"),
        onClose: onClose
    });
};
var NoEnoughPointModal = function(param) {
    var open = param.open, onClose = param.onClose, itemId = param.itemId, artistId = param.artistId, prepaidPointId = param.prepaidPointId, openPointPurchaseDrawer = param.openPointPurchaseDrawer;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        title: t("noEnoughPoint"),
        content: t("noEnoughPointContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            size: "large",
            onClick: function() {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_getPrepaidPoint", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    name: "itemDetail",
                    itemId: itemId,
                    artistId: artistId,
                    prepaidPointId: prepaidPointId,
                    type: "modal"
                });
                openPointPurchaseDrawer();
            },
            children: t("buyPoint")
        }),
        cancelText: t("close"),
        onClose: onClose
    });
};
var NftConnectModal = function(param) {
    var open = param.open, onClose = param.onClose, onConnectMetamask = param.onConnectMetamask;
    var t = useTranslation("nftItemDetail").t;
    var showError = useMessage().showError;
    var ref = useState(false), connecting = ref[0], setConnecting = ref[1];
    var wallets = [
        {
            src: "images/nft/metaMask.png",
            title: "MetaMask",
            onClick: onConnectMetamask
        }
    ];
    var onClickConnectWallet = function() {
        var _ref = _async_to_generator(function(onClick) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setConnecting(true);
                        return [
                            4,
                            onClick().catch(function(e) {
                                showError(e);
                            }).finally(function() {
                                setConnecting(false);
                                onClose();
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickConnectWallet(onClick) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Drawer, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 2,
                sx: {
                    py: 4
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        align: "center",
                        children: t("nftConnectTitle")
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "caption",
                        sx: {
                            color: "error.main"
                        },
                        align: "center",
                        children: t("nftConnectNote")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx(List, {
                children: wallets.map(function(wallet) {
                    return /*#__PURE__*/ _jsxs(ListItem, {
                        sx: {
                            minHeight: 68
                        },
                        divider: true,
                        secondaryAction: /*#__PURE__*/ _jsx(Button, {
                            size: "medium",
                            onClick: function() {
                                return onClickConnectWallet(wallet.onClick);
                            },
                            disabled: connecting,
                            children: t("workTogether")
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(ListItemAvatar, {
                                sx: {
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ _jsx(StorageImage, {
                                    target: "common",
                                    src: wallet.src,
                                    width: 35,
                                    height: 35
                                })
                            }),
                            /*#__PURE__*/ _jsx(ListItemText, {
                                primary: wallet.title,
                                slotProps: {
                                    primary: {
                                        variant: "subtitle1"
                                    }
                                }
                            })
                        ]
                    }, wallet.title);
                })
            }),
            /*#__PURE__*/ _jsx(ListItemButton, {
                component: Stack,
                alignItems: "center",
                onClick: onClose,
                disabled: connecting,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    align: "center",
                    sx: {
                        py: 2,
                        color: "primary.main"
                    },
                    children: t("cancel")
                })
            })
        ]
    });
};
/**
 * チケットアイテム購入時に、個人情報を登録していない・電話番号認証を行なっていない場合表示するモーダル
 * https://zpl.io/z8067Ez
 */ var PersonalInfoModal = function(param) {
    var open = param.open, onClose = param.onClose, user = param.user;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    // ユーザーが「個人情報は登録している状態」かどうか
    var isRegistered = !!(user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: isRegistered ? t("PhoneNumberVerifyModalTitle", "電話番号の認証が必要です。") : t("PersonalInfoModalTitle", "お客様情報の登録が必要です。"),
        content: isRegistered ? t("PhoneNumberVerifyModalContent", "チケットアイテムを購入するには、登録されている電話番号の認証が必要です。") : t("PersonalInfoModalContent", "チケットアイテムを購入するには氏名、住所、電話番号の登録が必要です。"),
        cancelText: t("PersonalInfoModalClose", "閉じる"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            href: isRegistered ? routerPages.DeliveryManagement : routerPages.DeliveryInfoSetting,
            children: isRegistered ? t("PhoneNumberVerifyModalButton", "電番認証する") : t("PersonalInfoModalButton", "登録画面へ")
        })
    });
};
var NftInfoModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InfoModal, {
        open: open,
        onClose: onClose,
        title: t("nftInfoModalTitle"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    textAlign: "justify",
                    sx: {
                        pb: 4
                    },
                    children: t("nftInfoModalDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                            filledColor: true,
                            sx: {
                                mr: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            textAlign: "justify",
                            sx: {
                                pb: 4
                            },
                            children: t("nftInfoModalDescriptionForActive")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                            sx: {
                                p: 1,
                                border: "1px solid",
                                borderRadius: 10,
                                mr: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            textAlign: "justify",
                            children: t("nftInfoModalDescriptionForInactive")
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/flatten.js
var flatten = __webpack_require__(35676);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
;// CONCATENATED MODULE: ./src/components/lib/initialLoading/index.tsx

/**
 * 初回ロード状態判定フック
 * データ未取得の状態も含めてロードが完了しているかどうかを判別する
 * データがない場合に404エラーを出す場合はこれを使うこと
 * @param data useQueryのdata
 * @param loading useQueryのloading
 * @param error [optional]useQueryのerror
 * @return boolean
 */ var useInitialLoading = function(data, loading, error) {
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    (0,react.useEffect)(function() {
        // NOTE: ロード中かデータが未取得の場合
        if (loading || data === undefined && !error) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [
        loading,
        data,
        error
    ]);
    return isLoading;
};

// EXTERNAL MODULE: ./src/core/analytics/index.ts + 13 modules
var analytics = __webpack_require__(11338);
// EXTERNAL MODULE: ./src/core/native/device/index.ts
var device = __webpack_require__(81291);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(71941);
;// CONCATENATED MODULE: ./src/lib/analytics/index.ts




/**
 * GoogleAnalyticsのECommerce用にtransactionIdを生成する
 * 購入ごとにユニークであれば良いため、userId/timestamp/random数 を用いてHash文字列を取得する
 * @param uid userId
 * @returns hash化された文字列
 */ function generateTransactionId(uid) {
    var md5 = crypto_browserify.createHash("md5");
    var currentTimestamp = dayjs_min_default()().unix();
    var randomNumber = Math.random();
    return md5.update("".concat(uid, ":").concat(currentTimestamp, ":").concat(randomNumber), "binary").digest("hex");
}

;// CONCATENATED MODULE: ./src/lib/uuid/index.ts

var createUuid = function() {
    return (0,v1/* default */.Z)();
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointCharge/template/fragments.ts

function fragments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PurchasablePrepaidPointConnection on PageResult {\n      edges {\n        node {\n          ...PurchasablePrepaidPointDetail\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    fragment PrepaidPointsPaymentSource on CreditCard {\n      id\n      last4\n      brand\n    }\n    fragment PurchasablePrepaidPointDetail on PurchasablePrepaidPoint {\n      id\n      points\n      price\n      description\n      prepaidPointId\n      metadata {\n        id\n        platform\n      }\n    }\n  "
    ]);
    fragments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function fragments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PrepaidPointChargeResult on PrepaidPointTransaction {\n      id\n      prepaidPointBalance\n      prepaidPointBalanceBefore\n      transactionPrepaidPoint\n      prepaidPointId\n      expiredPrepaidPoint\n      type\n      createdAt\n      formattedCreatedAt @client\n    }\n  "
    ]);
    fragments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var fragments = {
    purchasablePrepaidPoints: (0,lib/* gql */.Ps)(fragments_templateObject()),
    prepaidPointTransaction: (0,lib/* gql */.Ps)(fragments_templateObject1())
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointCharge/viewModel.ts




function PrepaidPointCharge_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query purchasablePrepaidPoints($platform: String!, $pageInput: PageInput) {\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n    }\n    purchasablePrepaidPoints(platform: $platform, pageInput: $pageInput) {\n      ...PurchasablePrepaidPointConnection\n    }\n    paymentSource {\n      ...PrepaidPointsPaymentSource\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    PrepaidPointCharge_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrepaidPointCharge_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ChargePrepaidPointProcess(\n    $inputs: ChargePrepaidPointInput!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n  ) {\n    chargePrepaidPointProcess(\n      inputs: $inputs\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n    ) {\n      __typename\n      ... on PrepaidPointTransaction {\n        ...PrepaidPointChargeResult\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    PrepaidPointCharge_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrepaidPointCharge_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ChargePrepaidPointByIapMutation(\n    $inputs: ChargePrepaidPointIapInput!\n  ) {\n    chargePrepaidPointByIap(inputs: $inputs) {\n      ...PrepaidPointChargeResult\n    }\n  }\n  ",
        "\n"
    ]);
    PrepaidPointCharge_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
















var PrepaidPointCharge_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,device/* useDeviceInfo */.u)(), deviceInfoLoading = ref5.loading, deviceInfo = ref5.deviceInfo;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref6 = usePointPurchase(user === null || user === void 0 ? void 0 : user.uid, deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform, "prepaidPointCharge"), purchaseByIosAndAndroid = ref6.purchaseByIosAndAndroid, purchaseByWeb = ref6.purchaseByWeb, completeNativePurchase = ref6.completeNativePurchase, setCompleteNativePurchase = ref6.setCompleteNativePurchase, chargeLoading = ref6.chargeLoading;
    var ref7 = (0,useQuery/* useQuery */.aM)(PURCHASABLE_PREPAID_POINTS, {
        variables: {
            platform: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) || ""
        },
        skip: deviceInfoLoading,
        pollInterval: completeNativePurchase ? 2000 : 0
    }), data = ref7.data, loading = ref7.loading, fetchMore = ref7.fetchMore;
    // 決済後、prepaidPointBalanceが更新されたらpollingを停止する
    (0,react.useEffect)(function() {
        setCompleteNativePurchase(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.prepaidPointBalance
    ]);
    // GA: view_itemの計測
    (0,analytics/* useTrackViewItem */.r2)(data, function(data) {
        return data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints.edges.map(function(edge) {
            var plan = edge.node;
            return {
                item_category: ConversionCategories.prepaidPoint,
                item_category2: plan.prepaidPointId,
                item_category3: plan.metadata.platform,
                item_list_name: ConversionListName.purchasablePrepaidPointList,
                item_id: plan.metadata.id,
                item_name: plan.metadata.id,
                price: plan.price,
                quantity: 1
            };
        });
    });
    var ref8, ref9, ref10;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.purchasablePrepaidPoints) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
            chargeLoading: chargeLoading,
            point: (ref8 = data === null || data === void 0 ? void 0 : (ref2 = data.prepaidPointBalance) === null || ref2 === void 0 ? void 0 : ref2.balance) !== null && ref8 !== void 0 ? ref8 : null,
            purchasablePrepaidPoints: (ref9 = data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints) !== null && ref9 !== void 0 ? ref9 : null,
            paymentSource: (ref10 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref10 !== void 0 ? ref10 : null,
            /** アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref3 = data.organization) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.modules) === null || ref4 === void 0 ? void 0 : ref4.pointCarrierPayment)
        },
        actions: {
            onClickCharge: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) === "web" ? purchaseByWeb : purchaseByIosAndAndroid,
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            platform: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) || "",
                                            pageInput: {
                                                cursor: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.purchasablePrepaidPoints) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor) !== null && ref2 !== void 0 ? ref2 : null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PURCHASABLE_PREPAID_POINTS = (0,lib/* gql */.Ps)(PrepaidPointCharge_viewModel_templateObject(), fragments.purchasablePrepaidPoints);
var CHARGE_PREPAID_POINT_PROCESS = (0,lib/* gql */.Ps)(PrepaidPointCharge_viewModel_templateObject1(), fragments.prepaidPointTransaction);
var CHARGE_PREPAID_POINTS_BY_IAP = (0,lib/* gql */.Ps)(PrepaidPointCharge_viewModel_templateObject2(), fragments.prepaidPointTransaction);
var usePointPurchase = function(userId, platform, /** ページ名測定用 */ pageName) {
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    // 外部キャリア決済画面（escott）へのリダイレクト中かどうかを管理するフラグ
    // mutation の完了から escott フォーム送信までに
    // submit ボタンが活性化してしまうのを防ぐために用いている
    var ref = (0,react.useState)(false), isRedirectingToEscott = ref[0], setIsRedirectingToEscott = ref[1];
    // ネイティブで決済モーダルが出る前のボタンのローディング
    var ref1 = (0,react.useState)(false), purchaseCalling = ref1[0], setPurchaseCalling = ref1[1];
    // ネイティブ決済完了後、増加分のポイント取得クエリをポーリングするフラグ
    var ref2 = (0,react.useState)(false), completeNativePurchase = ref2[0], setCompleteNativePurchase = ref2[1];
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    // ポイント残高を取得するクエリ
    var ref3 = (0,useQuery/* useQuery */.aM)(PURCHASABLE_PREPAID_POINTS, {
        variables: {
            platform: platform || ""
        },
        skip: true
    }), refetchPoints = ref3.refetch;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CHARGE_PREPAID_POINT_PROCESS, {
        onCompleted: function onCompleted(param) {
            var chargePrepaidPointProcess = param.chargePrepaidPointProcess;
            switch(chargePrepaidPointProcess.__typename){
                // 決済がすぐに完了する場合
                case "PrepaidPointTransaction":
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 現在保有しているポイントを再取得する
                    refetchPoints({
                        platform: platform || ""
                    });
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(chargePrepaidPointProcess.nextActionUrl, chargePrepaidPointProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), chargePrepaidPointProcess = ref4[0], ref5 = ref4[1], prepaidPointCharging = ref5.loading;
    var purchaseByWeb = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(plan, paymentMethod, escottInput) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // キャリア決済の場合はローディング状態を表す
                        // state.subscribing に渡している
                        // isRedirectingToEscott を true にする
                        // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                        // submit ボタンが活性化するのを防ぐために行う
                        if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                            setIsRedirectingToEscott(true);
                        }
                        return [
                            4,
                            chargePrepaidPointProcess({
                                variables: {
                                    inputs: {
                                        prepaidPointId: plan.prepaidPointId,
                                        purchasablePrepaidPointId: plan.id
                                    },
                                    paymentMethod: paymentMethod,
                                    escottInput: escottInput
                                },
                                context: {
                                    headers: {
                                        "x-utoniq-idempotency-key": createUuid()
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        // GA:Conevrsion計測イベント
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_purchase", {
                            item_id: plan.metadata.id,
                            item_name: plan.prepaidPointId,
                            platform: plan.metadata.platform,
                            pageName: pageName
                        });
                        analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                            transaction_id: generateTransactionId(userId),
                            currency: "JPY",
                            type: "credit_card",
                            items: [
                                {
                                    item_category: ConversionCategories.prepaidPoint,
                                    item_category2: plan.prepaidPointId,
                                    item_category3: plan.metadata.platform,
                                    item_list_name: ConversionListName.purchasablePrepaidPointList,
                                    item_id: plan.metadata.id,
                                    item_name: plan.metadata.id,
                                    price: plan.price,
                                    quantity: 1
                                }
                            ]
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(plan, paymentMethod, escottInput) {
            return _ref.apply(this, arguments);
        };
    }(), [
        analytics,
        chargePrepaidPointProcess,
        userId
    ]);
    var purchaseByIosAndAndroid = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(plan) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPurchaseCalling(true);
                        return [
                            4,
                            purchase(plan.metadata.id, native_app/* getPlatformResult */.NA({
                                ios: config_config/* config.revenueCatApiKey.ios */.v.revenueCatApiKey.ios,
                                android: config_config/* config.revenueCatApiKey.android */.v.revenueCatApiKey.android,
                                web: ""
                            }), plan.price, userId, undefined, t).finally(function() {
                                setPurchaseCalling(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        // ネイティブ決済完了後、webhookでの反映が遅い場合の対策として10秒毎にpolling
                        setCompleteNativePurchase(true);
                        // GA:Conevrsion計測イベント
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_purchase", {
                            id: plan.id,
                            name: plan.prepaidPointId,
                            pageName: pageName,
                            platform: platform
                        });
                        analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                            transaction_id: generateTransactionId(userId),
                            currency: "JPY",
                            type: "credit_card",
                            items: [
                                {
                                    item_category: ConversionCategories.prepaidPoint,
                                    item_category2: plan.prepaidPointId,
                                    item_category3: plan.metadata.platform,
                                    item_list_name: "purchasable_prepaid_point_list",
                                    item_id: plan.metadata.id,
                                    item_name: plan.metadata.id,
                                    price: plan.price,
                                    quantity: 1
                                }
                            ]
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(plan) {
            return _ref.apply(this, arguments);
        };
    }(), [
        analytics,
        platform,
        userId
    ]);
    // 外部キャリア決済画面（escott）からブラウザバックした際
    // リダイレクト中かどうかを管理するフラグをリセットする
    // ブラウザバック時に BFCache が効き再読み込みが走らない環境で
    // ローディング状態が解除されないことを防ぐ
    (0,escott/* useBFCacheRestore */.Hy)(function() {
        setIsRedirectingToEscott(false);
    });
    return {
        purchaseByWeb: purchaseByWeb,
        purchaseByIosAndAndroid: purchaseByIosAndAndroid,
        completeNativePurchase: completeNativePurchase,
        setCompleteNativePurchase: setCompleteNativePurchase,
        chargeLoading: purchaseCalling || prepaidPointCharging || isRedirectingToEscott
    };
};

// EXTERNAL MODULE: ./src/core/native/share/index.ts
var share = __webpack_require__(47440);
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/web3-provider.js
var web3_provider = __webpack_require__(241);
// EXTERNAL MODULE: ./node_modules/@ethersproject/providers/lib.esm/json-rpc-provider.js + 17 modules
var json_rpc_provider = __webpack_require__(38230);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 2 modules
var lib_esm = __webpack_require__(35553);
// EXTERNAL MODULE: ../../node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(24991);
;// CONCATENATED MODULE: ./src/core/web3/network.ts
var network_networks = {
    polygon: {
        chainId: "0x89",
        rpcUrls: [
            "https://polygon-rpc.com/"
        ],
        chainName: "Polygon Mainnet",
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://polygonscan.com/"
        ]
    },
    mumbai: {
        chainId: "0x13881",
        rpcUrls: [
            "https://rpc-mumbai.maticvigil.com/"
        ],
        chainName: "Matic mumbai",
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://polygonscan.com/"
        ]
    }
};

;// CONCATENATED MODULE: ./src/core/web3/metamask/index.ts




function metamask_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateWalletSignatureMessage {\n    generateWalletSignatureMessage(inputs: { cryptoWalletType: metamask }) {\n      authToken {\n        signatureMessage\n      }\n    }\n  }\n"
    ]);
    metamask_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function metamask_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateWalletSignatureMessage {\n    artistGenerateWalletSignatureMessage(\n      inputs: { cryptoWalletType: metamask }\n    ) {\n      authToken {\n        signatureMessage\n      }\n    }\n  }\n"
    ]);
    metamask_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function metamask_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AuthorizeWallet($inputs: AuthorizeWalletInput!) {\n    authorizeWallet(inputs: $inputs) {\n      address\n      authToken {\n        nonce\n        used\n        createdAt\n        expiredAt\n      }\n      connectedAt\n      status\n      walletType\n    }\n  }\n"
    ]);
    metamask_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function metamask_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AuthorizeWallet($inputs: AuthorizeWalletInput!) {\n    artistAuthorizeWallet(inputs: $inputs) {\n      address\n      authToken {\n        nonce\n        used\n        createdAt\n        expiredAt\n      }\n      connectedAt\n      status\n      walletType\n    }\n  }\n"
    ]);
    metamask_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







/**
 * Metamask clientがインストール済みかどうか
 */ var checkMetamaskInstalled = function() {
    if (isMetamaskInstalled()) return true;
    /**
   * PCブラウザ:
   * metamaskクライアントがない場合、取得を促す
   */ var platform = (0,native_app/* getPlatform */.Xf)();
    if (platform === "web" && !navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        window.open("https://metamask.io/download/");
        throw new Error(i18next/* default.t */.ZP.t("confirmMetamaskClient", {
            ns: "wallet"
        }));
    }
    /**
   * native or nativeブラウザ:
   * - MetamaskMobileアプリインストール済： MetamaskMobileアプリ内で開く
   * - MetamaskMobile未インストール： MetamaskMobileのストアを開く
   */ window.open("https://metamask.app.link/dapp/".concat(config_config/* config.domain */.v.domain, "/login?redirectUri=").concat(location.pathname));
    throw new Error(i18next/* default.t */.ZP.t("requestMetamaskMobile", {
        ns: "wallet"
    }));
};
var isMetamaskInstalled = function() {
    var ref;
    return !!(window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isMetaMask);
};
/**
 * Metamask clientとの接続
 * @return 接続済みのウォレットのpublic address
 */ var connectMetamaskClient = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var provider, accounts;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkMetamaskInstalled();
                    provider = new web3_provider/* Web3Provider */.Q(window.ethereum);
                    return [
                        4,
                        provider.send("eth_requestAccounts", [])
                    ];
                case 1:
                    accounts = _state.sent();
                    return [
                        2,
                        accounts[0]
                    ];
            }
        });
    });
    return function connectMetamaskClient() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * メッセージによるウォレットクライアントでの認証
 */ var signWalletBySignatureMessage = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(signer, signatureMessage) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        signer.signMessage(signatureMessage)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function signWalletBySignatureMessage(signer, signatureMessage) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * アカウントの残高を取得
 */ var getBalance = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(walletAddress) {
        var provider, balance;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = new json_rpc_provider/* JsonRpcProvider */.r(network_networks[config_config/* config.environment */.v.environment === "production" ? "polygon" : "mumbai"].rpcUrls[0]);
                    return [
                        4,
                        provider.getBalance(walletAddress)
                    ];
                case 1:
                    balance = _state.sent();
                    return [
                        2,
                        lib_esm/* formatEther */.dF(balance)
                    ];
            }
        });
    });
    return function getBalance(walletAddress) {
        return _ref.apply(this, arguments);
    };
}();
var useMetamask = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    /**
   * user用ウォレット連携認証メッセージ発行・ウォレット連携
   */ var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GENERATE_WALLET_SIGNATURE_MESSAGE), 1), generateWalletSignatureMessage = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(AUTHORIZE_WALLET), 1), authorizeWallet = ref1[0];
    /**
   * artist用ウォレット連携認証メッセージ発行・ウォレット連携
   */ var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_GENERATE_WALLET_SIGNATURE_MESSAGE), 1), artistGenerateWalletSignatureMessage = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_AUTHORIZE_WALLET), 1), artistAuthorizeWallet = ref3[0];
    /**
   * 認証メッセージによるウォレット認証・firestore userDocへのウォレットアドレス登録
   * @return true: 完了 error: 各種エラー
   */ var userAuthorizeWalletBySignatureMessage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, provider, signer, account, data, signatureMessage, signature;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkMetamaskInstalled();
                        if (!window.ethereum) throw new Error(t("confirmMetamaskClient"));
                        provider = new web3_provider/* Web3Provider */.Q(window.ethereum);
                        signer = provider.getSigner();
                        return [
                            4,
                            connectMetamaskClient()
                        ];
                    case 1:
                        account = _state.sent();
                        return [
                            4,
                            generateWalletSignatureMessage()
                        ];
                    case 2:
                        data = _state.sent().data;
                        signatureMessage = data === null || data === void 0 ? void 0 : (ref = data.generateWalletSignatureMessage) === null || ref === void 0 ? void 0 : (ref1 = ref.authToken) === null || ref1 === void 0 ? void 0 : ref1.signatureMessage;
                        if (!signatureMessage) throw new Error(t("signatureError"));
                        return [
                            4,
                            signWalletBySignatureMessage(signer, signatureMessage)
                        ];
                    case 3:
                        signature = _state.sent();
                        /**
     * バックエンド側にてアドレス登録（ユーザー用）
     */ return [
                            4,
                            authorizeWallet({
                                variables: {
                                    inputs: {
                                        publicAddress: account,
                                        signature: signature
                                    }
                                }
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function userAuthorizeWalletBySignatureMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 認証メッセージによるウォレット認証・firestore artistDocへのウォレットアドレス登録
   * @return true: 完了 error: 各種エラー
   */ var artistAuthorizeWalletBySignatureMessage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, provider, signer, account, data, signatureMessage, signature;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checkMetamaskInstalled();
                        if (!window.ethereum) throw new Error(t("confirmMetamaskClient"));
                        provider = new web3_provider/* Web3Provider */.Q(window.ethereum);
                        signer = provider.getSigner();
                        return [
                            4,
                            connectMetamaskClient()
                        ];
                    case 1:
                        account = _state.sent();
                        return [
                            4,
                            artistGenerateWalletSignatureMessage()
                        ];
                    case 2:
                        data = _state.sent().data;
                        signatureMessage = data === null || data === void 0 ? void 0 : (ref = data.artistGenerateWalletSignatureMessage) === null || ref === void 0 ? void 0 : (ref1 = ref.authToken) === null || ref1 === void 0 ? void 0 : ref1.signatureMessage;
                        if (!signatureMessage) throw new Error(t("signatureError"));
                        return [
                            4,
                            signWalletBySignatureMessage(signer, signatureMessage)
                        ];
                    case 3:
                        signature = _state.sent();
                        /**
     * バックエンド側にてアドレス登録（アーティスト用）
     */ return [
                            4,
                            artistAuthorizeWallet({
                                variables: {
                                    inputs: {
                                        publicAddress: account,
                                        signature: signature
                                    }
                                }
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function artistAuthorizeWalletBySignatureMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        userAuthorizeWalletBySignatureMessage: userAuthorizeWalletBySignatureMessage,
        artistAuthorizeWalletBySignatureMessage: artistAuthorizeWalletBySignatureMessage
    };
};
function checkChain(chainName) {
    return _checkChain.apply(this, arguments);
}
function _checkChain() {
    _checkChain = _async_to_generator(function(chainName) {
        var provider, signer, networkName, chainId;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = new ethers.providers.Web3Provider(window.ethereum);
                    signer = provider.getSigner();
                    networkName = ({
                        polygon: "matic"
                    })[chainName] || chainName;
                    return [
                        4,
                        signer.getChainId()
                    ];
                case 1:
                    chainId = _state.sent();
                    return [
                        2,
                        ethers.providers.getNetwork(chainId).name === networkName
                    ];
            }
        });
    });
    return _checkChain.apply(this, arguments);
}
function switchChain(chainName) {
    return _switchChain.apply(this, arguments);
}
function _switchChain() {
    _switchChain = _async_to_generator(function(chainName) {
        return _ts_generator(this, function(_state) {
            window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                    networks[chainName]
                ]
            });
            return [
                2
            ];
        });
    });
    return _switchChain.apply(this, arguments);
}
var GENERATE_WALLET_SIGNATURE_MESSAGE = (0,lib/* gql */.Ps)(metamask_templateObject());
var ARTIST_GENERATE_WALLET_SIGNATURE_MESSAGE = (0,lib/* gql */.Ps)(metamask_templateObject1());
var AUTHORIZE_WALLET = (0,lib/* gql */.Ps)(metamask_templateObject2());
var ARTIST_AUTHORIZE_WALLET = (0,lib/* gql */.Ps)(metamask_templateObject3());

;// CONCATENATED MODULE: ./src/core/web3/web3auth/hooks.ts




function hooks_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateWalletSignatureMessage {\n    generateWalletSignatureMessage(inputs: { cryptoWalletType: web3auth }) {\n      authToken {\n        signatureMessage\n      }\n    }\n  }\n"
    ]);
    hooks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hooks_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateWalletSignatureMessage {\n    artistGenerateWalletSignatureMessage(\n      inputs: { cryptoWalletType: web3auth }\n    ) {\n      authToken {\n        signatureMessage\n      }\n    }\n  }\n"
    ]);
    hooks_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hooks_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AuthorizeWallet($inputs: AuthorizeWalletInput!) {\n    authorizeWallet(inputs: $inputs) {\n      address\n      authToken {\n        nonce\n        used\n        createdAt\n        expiredAt\n      }\n      connectedAt\n      status\n      walletType\n    }\n  }\n"
    ]);
    hooks_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hooks_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AuthorizeWallet($inputs: AuthorizeWalletInput!) {\n    artistAuthorizeWallet(inputs: $inputs) {\n      address\n      authToken {\n        nonce\n        used\n        createdAt\n        expiredAt\n      }\n      connectedAt\n      status\n      walletType\n    }\n  }\n"
    ]);
    hooks_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var useWeb3authWalletConnect = function(param) {
    var loading = param.loading, walletAddress = param.walletAddress, isArtist = param.isArtist, refetch = param.refetch;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(), web3auth = ref1[0], setWeb3auth = ref1[1];
    /**
   * user用ウォレット連携認証メッセージ発行・ウォレット連携
   */ var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(hooks_GENERATE_WALLET_SIGNATURE_MESSAGE), 1), generateWalletSignatureMessage = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(hooks_AUTHORIZE_WALLET), 1), authorizeWallet = ref3[0];
    /**
   * artist用ウォレット連携認証メッセージ発行・ウォレット連携
   */ var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(hooks_ARTIST_GENERATE_WALLET_SIGNATURE_MESSAGE), 1), artistGenerateWalletSignatureMessage = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(hooks_ARTIST_AUTHORIZE_WALLET), 1), artistAuthorizeWallet = ref5[0];
    /**
   * 認証メッセージによるウォレット認証・firestore userDocへのウォレットアドレス登録
   * @return true: 完了 error: 各種エラー
   */ var userAuthorizeWalletBySignatureMessage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, web3auth, provider, signer, account, data, signatureMessage, signature;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.web3auth;
                            })
                        ];
                    case 1:
                        web3auth = _state.sent();
                        setWeb3auth(web3auth);
                        if (!web3auth.provider) throw new Error("web3auth provider not found");
                        provider = new web3_provider/* Web3Provider */.Q(web3auth.provider);
                        signer = provider.getSigner();
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.getWalletAddress();
                            })
                        ];
                    case 2:
                        account = _state.sent();
                        return [
                            4,
                            generateWalletSignatureMessage()
                        ];
                    case 3:
                        data = _state.sent().data;
                        signatureMessage = data === null || data === void 0 ? void 0 : (ref = data.generateWalletSignatureMessage) === null || ref === void 0 ? void 0 : (ref1 = ref.authToken) === null || ref1 === void 0 ? void 0 : ref1.signatureMessage;
                        if (!signatureMessage) throw new Error(t("signatureError"));
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.signWalletBySignatureMessage(signer, signatureMessage);
                            })
                        ];
                    case 4:
                        signature = _state.sent();
                        /**
     * バックエンド側にてアドレス登録（ユーザー用）
     */ return [
                            4,
                            authorizeWallet({
                                variables: {
                                    inputs: {
                                        publicAddress: account,
                                        signature: signature
                                    }
                                }
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function userAuthorizeWalletBySignatureMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 認証メッセージによるウォレット認証・firestore artistDocへのウォレットアドレス登録
   * @return true: 完了 error: 各種エラー
   */ var artistAuthorizeWalletBySignatureMessage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1, web3auth, provider, signer, account, data, signatureMessage, signature;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.web3auth;
                            })
                        ];
                    case 1:
                        web3auth = _state.sent();
                        setWeb3auth(web3auth);
                        if (!web3auth.provider) throw new Error("web3auth provider not found");
                        provider = new web3_provider/* Web3Provider */.Q(web3auth.provider);
                        signer = provider.getSigner();
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.getWalletAddress();
                            })
                        ];
                    case 2:
                        account = _state.sent();
                        return [
                            4,
                            artistGenerateWalletSignatureMessage()
                        ];
                    case 3:
                        data = _state.sent().data;
                        signatureMessage = data === null || data === void 0 ? void 0 : (ref = data.artistGenerateWalletSignatureMessage) === null || ref === void 0 ? void 0 : (ref1 = ref.authToken) === null || ref1 === void 0 ? void 0 : ref1.signatureMessage;
                        if (!signatureMessage) throw new Error(t("signatureError"));
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                return m.signWalletBySignatureMessage(signer, signatureMessage);
                            })
                        ];
                    case 4:
                        signature = _state.sent();
                        /**
     * バックエンド側にてアドレス登録（アーティスト用）
     */ return [
                            4,
                            artistAuthorizeWallet({
                                variables: {
                                    inputs: {
                                        publicAddress: account,
                                        signature: signature
                                    }
                                }
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function artistAuthorizeWalletBySignatureMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = (0,react.useState)(false), web3authWalletLoading = ref6[0], setWeb3authWalletLoading = ref6[1];
    (0,react.useEffect)(function() {
        Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
            return m.initWeb3auth();
        });
        setWeb3auth(web3auth);
        var setCryptoWalletAddressFromWeb3auth = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var web3auth, _tmp, _tmp1, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.web3auth;
                                })
                            ];
                        case 1:
                            web3auth = _state.sent();
                            if (!web3auth.provider) return [
                                2
                            ];
                            if (loading || walletAddress) return [
                                2
                            ];
                            setWeb3authWalletLoading(true);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                9,
                                10,
                                11
                            ]);
                            if (!isArtist) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                artistAuthorizeWalletBySignatureMessage()
                            ];
                        case 3:
                            _tmp = _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 4:
                            return [
                                4,
                                userAuthorizeWalletBySignatureMessage()
                            ];
                        case 5:
                            _tmp = _state.sent();
                            _state.label = 6;
                        case 6:
                            _tmp;
                            _tmp1 = refetch;
                            if (!_tmp1) return [
                                3,
                                8
                            ];
                            return [
                                4,
                                refetch()
                            ];
                        case 7:
                            _tmp1 = _state.sent();
                            _state.label = 8;
                        case 8:
                            _tmp1;
                            showMessage(t("walletCreated"));
                            return [
                                3,
                                11
                            ];
                        case 9:
                            e = _state.sent();
                            showError(e);
                            return [
                                3,
                                11
                            ];
                        case 10:
                            setWeb3authWalletLoading(false);
                            return [
                                7
                            ];
                        case 11:
                            return [
                                2
                            ];
                    }
                });
            });
            return function setCryptoWalletAddressFromWeb3auth() {
                return _ref.apply(this, arguments);
            };
        }();
        setCryptoWalletAddressFromWeb3auth();
    }, [
        loading,
        walletAddress,
        web3auth === null || web3auth === void 0 ? void 0 : web3auth.provider
    ]);
    return {
        web3authWalletLoading: web3authWalletLoading
    };
};
var hooks_GENERATE_WALLET_SIGNATURE_MESSAGE = (0,lib/* gql */.Ps)(hooks_templateObject());
var hooks_ARTIST_GENERATE_WALLET_SIGNATURE_MESSAGE = (0,lib/* gql */.Ps)(hooks_templateObject1());
var hooks_AUTHORIZE_WALLET = (0,lib/* gql */.Ps)(hooks_templateObject2());
var hooks_ARTIST_AUTHORIZE_WALLET = (0,lib/* gql */.Ps)(hooks_templateObject3());

// EXTERNAL MODULE: ./src/lib/url/shortLink.tsx
var shortLink = __webpack_require__(74465);
;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/viewModel.tsx







function ArtistStoreItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistStoreItemDetail(\n    $id: ID!\n    $artistId: ID!\n    $itemId: String!\n    $platform: String!\n    $purchasablePrepaidPointPageInput: PageInput\n    $skuId: String\n  ) {\n    artist(id: $artistId) {\n      ...ArtistSubscriptionPlan\n    }\n    user {\n      id\n      phoneNumber\n      fullName\n      isPhoneNumberVerified\n      formattedPhoneNumber @client\n      ...UserDeliveryInfo\n      cryptoWallet {\n        address\n      }\n    }\n    userCartCount\n    item(id: $id) {\n      ...StoreItemDetailGuest\n    }\n    userActiveResaleItemRaffle(itemId: $itemId) {\n      id\n      itemId\n      skuId\n    }\n    prepaidPointBalance {\n      balance\n      prepaidPointId\n      formattedPrepaidPointBarance @client\n    }\n    purchasablePrepaidPoints(\n      platform: $platform\n      pageInput: $purchasablePrepaidPointPageInput\n    ) {\n      ...PurchasablePrepaidPointConnection\n    }\n    paymentSource {\n      ...paymentCreateDetail\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistStoreItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistStoreItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistStoreItemDetailWithSku(\n    $id: ID!\n    $itemId: String!\n    $skuId: String\n  ) {\n    item(id: $id) {\n      ...StoreItemDetailGuestSku\n    }\n    userActiveResaleItemRaffle(itemId: $itemId, skuId: $skuId) {\n      id\n      itemId\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistStoreItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistStoreItemDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistStoreItemDetailForGuest(\n    $id: ID!\n    $skuId: String\n    $artistId: ID!\n  ) {\n    artist(id: $artistId) {\n      ...ArtistSubscriptionPlan\n    }\n    item(id: $id) {\n      ...StoreItemDetailGuest\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistStoreItemDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ArtistStoreItemDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddItemToCart($inputs: AddToCartInput!) {\n    addToCart(inputs: $inputs) {\n      id\n      totalCount\n    }\n  }\n"
    ]);
    ArtistStoreItemDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseItemByPoint(\n    $itemId: ID!\n    $purchaseNumber: Int\n    $prepaidPoint: Int\n    $skuId: String\n  ) {\n    purchaseItemByPoint(\n      itemId: $itemId\n      purchaseNumber: $purchaseNumber\n      prepaidPoint: $prepaidPoint\n      skuId: $skuId\n    ) {\n      id\n      price\n      userId\n      item {\n        ...StoreItemDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function viewModel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ViewStoreItem($inputs: ViewStoreItemInput!) {\n    viewStoreItem(inputs: $inputs) {\n      id\n      userId\n      itemId\n      viewCount\n    }\n  }\n"
    ]);
    viewModel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function viewModel_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseItemImmediately(\n    $inputs: PurchaseItemImmediatelyInput!\n    $skuId: String\n  ) {\n    purchaseItemImmediately(inputs: $inputs) {\n      id\n      paymentType\n      items {\n        item {\n          ...StoreItemDetail\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
























var ArtistStoreItemDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var signInAnonymously = (0,auth/* useAuth */.aC)().signInAnonymously;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemDetail").t;
    var ref25 = (0,router_useRouter/* useRouter */.tv)(), router = ref25.router, generatePath = ref25.generatePath, routerPages = ref25.routerPages;
    var ref26 = (0,react.useState)(false), openSMSVerificationModal = ref26[0], setOpenSMSVerificationModal = ref26[1];
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var itemId = router.query.itemId;
    var ref27 = (0,react.useState)(false), signingAnonymously = ref27[0], setSigningAnonymously = ref27[1];
    var ref28 = (0,react.useState)(), skuWillResaleAvailable = ref28[0], setSkuWillResaleAvailable = ref28[1];
    var ref29 = (0,react.useState)(), skuId = ref29[0], setSkuId = ref29[1];
    var ref30 = (0,react.useState)(), skuButtonActive = ref30[0], setSkuButtonActive = ref30[1];
    var userAuthorizeWalletBySignatureMessage = useMetamask().userAuthorizeWalletBySignatureMessage;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var ref31 = usePointPurchase(user === null || user === void 0 ? void 0 : user.uid, platform, "artistStoreItemDetail"), purchaseByIosAndAndroid = ref31.purchaseByIosAndAndroid, purchaseByWeb = ref31.purchaseByWeb, chargeLoading = ref31.chargeLoading, completeNativePurchase = ref31.completeNativePurchase, setCompleteNativePurchase = ref31.setCompleteNativePurchase;
    var ref32 = (0,useQuery/* useQuery */.aM)(ArtistStoreItemDetail_viewModel_QUERY, {
        variables: {
            id: itemId,
            artistId: artistId,
            itemId: itemId,
            purchasablePrepaidPointPageInput: {
                limit: 30
            },
            platform: platform
        },
        returnPartialData: true,
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        pollInterval: completeNativePurchase ? 2000 : 0
    }), data = ref32.data, loading = ref32.loading, refetch = ref32.refetch;
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(QUERY_ITEM_WITH_SKU), 2), getArtistStoreItemDetailWithSku = ref33[0], ref34 = ref33[1], dataSku = ref34.data, loadingItemWithSku = ref34.loading;
    var ref35 = (0,useQuery/* useQuery */.aM)(ArtistStoreItemDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            id: itemId,
            artistId: artistId
        },
        returnPartialData: true,
        skip: user === null || user === void 0 ? void 0 : user.isSigned
    }), dataForGuest = ref35.data, loadingForGuest = ref35.loading;
    var ref36 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ADD_ITEM_TO_CART), 2), addToCart = ref36[0], ref37 = ref36[1], addingToCart = ref37.loading;
    var web3authWalletLoading = useWeb3authWalletConnect({
        loading: loading || loadingForGuest,
        walletAddress: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.cryptoWallet) === null || ref1 === void 0 ? void 0 : ref1.address,
        isArtist: false,
        refetch: refetch
    }).web3authWalletLoading;
    var ref38 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VIEW_STORE_ITEM), 1), viewStoreItem = ref38[0];
    var hasItem = !!((ref2 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* HasItemUserItemDetail */.Iz4, {
        variables: {
            itemId: itemId,
            userId: user === null || user === void 0 ? void 0 : user.uid
        }
    }).data) === null || ref2 === void 0 ? void 0 : ref2.portfolio);
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_ITEM_BY_POINT), 2), purchaseItemByPoint = ref39[0], ref40 = ref39[1], itemPurchasing = ref40.loading;
    var ref41 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_ITEM_IMMEDIATELY), 1), purchaseItemImmediately = ref41[0];
    var ref42 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref42[0], ref43 = ref42[1], sendingVerificationLoading = ref43.loading;
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserDeliveryInfo */.p2K), 1), updateUserDeliveryInfo = ref44[0];
    var ref45 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* VerifySmsCode */.gkA), 2), verifySMSCode = ref45[0], ref46 = ref45[1], verifyingSMSCode = ref46.loading;
    var ref47 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreatePaymentMethod */.Xs1), 1), createPaymentMethod = ref47[0];
    // 決済後、prepaidPointBalanceが更新されたらpollingを停止する
    (0,react.useEffect)(function() {
        setCompleteNativePurchase(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.prepaidPointBalance
    ]);
    // ストア閲覧履歴ミューテーションを送信する
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.id)) return;
        viewStoreItem({
            variables: {
                inputs: {
                    itemId: data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : ref1.id
                }
            }
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : ref3.id
    ]);
    var ref48 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref48.showError, showMessage = ref48.showMessage, handleClose = ref48.handleClose;
    /**
   * 購入前に電話番号(個人情報)登録を必要とするか
   * チケットアイテムの購入において必須となる
   *  */ var requirePersonalInfo = !!(user && (data === null || data === void 0 ? void 0 : (ref4 = data.item) === null || ref4 === void 0 ? void 0 : ref4.requirePersonalInformation) && !(data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : ref5.isPhoneNumberVerified));
    var item = (0,react.useMemo)(function() {
        var ref;
        if ((dataSku === null || dataSku === void 0 ? void 0 : (ref = dataSku.item) === null || ref === void 0 ? void 0 : ref.id) === router.query.itemId) {
            var ref1, ref2, ref3;
            return (ref3 = (ref2 = (ref1 = dataSku === null || dataSku === void 0 ? void 0 : dataSku.item) !== null && ref1 !== void 0 ? ref1 : data === null || data === void 0 ? void 0 : data.item) !== null && ref2 !== void 0 ? ref2 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item) !== null && ref3 !== void 0 ? ref3 : null;
        }
        var ref4, ref5;
        return (ref5 = (ref4 = data === null || data === void 0 ? void 0 : data.item) !== null && ref4 !== void 0 ? ref4 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item) !== null && ref5 !== void 0 ? ref5 : null;
    }, [
        data === null || data === void 0 ? void 0 : data.item,
        dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item,
        dataSku === null || dataSku === void 0 ? void 0 : dataSku.item,
        router.query.itemId
    ]);
    var userActiveResaleItemRaffle = (0,react.useMemo)(function() {
        var ref;
        if ((dataSku === null || dataSku === void 0 ? void 0 : (ref = dataSku.item) === null || ref === void 0 ? void 0 : ref.id) === router.query.itemId) {
            var ref1;
            return (ref1 = dataSku === null || dataSku === void 0 ? void 0 : dataSku.userActiveResaleItemRaffle) !== null && ref1 !== void 0 ? ref1 : null;
        }
        var ref2;
        return (ref2 = data === null || data === void 0 ? void 0 : data.userActiveResaleItemRaffle) !== null && ref2 !== void 0 ? ref2 : null;
    }, [
        data === null || data === void 0 ? void 0 : data.userActiveResaleItemRaffle,
        dataSku === null || dataSku === void 0 ? void 0 : (ref6 = dataSku.item) === null || ref6 === void 0 ? void 0 : ref6.id,
        dataSku === null || dataSku === void 0 ? void 0 : dataSku.userActiveResaleItemRaffle,
        router.query.itemId, 
    ]);
    // アーティストプランのリストを作成
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var ref4;
        var artist = (ref4 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref4 !== void 0 ? ref4 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.artist;
        if (artist === null || artist === void 0 ? void 0 : (ref = artist.subscription) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) {
            var ref5;
            return flatten_default()(artist === null || artist === void 0 ? void 0 : (ref5 = artist.subscription) === null || ref5 === void 0 ? void 0 : ref5.products.map(function(product) {
                var monthPlan = product.plans.find(function(plan) {
                    return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month;
                });
                if (monthPlan) {
                    return [
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, monthPlan), {
                            title: product.title
                        })
                    ];
                }
                return product.plans.map(function(plan) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                        title: product.title
                    });
                });
            }));
        }
        if (artist === null || artist === void 0 ? void 0 : (ref2 = artist.subscription) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.plans) === null || ref3 === void 0 ? void 0 : ref3.length) {
            return artist.subscription.plans;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.subscription) === null || ref8 === void 0 ? void 0 : ref8.plans,
        data === null || data === void 0 ? void 0 : (ref9 = data.artist) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : ref10.products,
        dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref11 = dataForGuest.artist) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.subscription) === null || ref12 === void 0 ? void 0 : ref12.plans,
        dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref13 = dataForGuest.artist) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.subscription) === null || ref14 === void 0 ? void 0 : ref14.products, 
    ]);
    // アイテムを購入可能なプラン名のリスト
    var purchasablePlanNames = (0,react.useMemo)(function() {
        var ref;
        var item = (ref = data === null || data === void 0 ? void 0 : data.item) !== null && ref !== void 0 ? ref : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item;
        if ((item === null || item === void 0 ? void 0 : item.isPremium) && !(item === null || item === void 0 ? void 0 : item.purchesablePlanIds)) {
            // isPremuimがtrueかつpurchesablePlanIdsが空の場合は、全てのプランを表示
            return plans.map(function(plan) {
                return plan.title;
            });
        }
        return plans.filter(function(plan) {
            var ref;
            return item === null || item === void 0 ? void 0 : (ref = item.purchesablePlanIds) === null || ref === void 0 ? void 0 : ref.includes(plan.planId);
        }).map(function(plan) {
            return plan.title;
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref15 = data.item) === null || ref15 === void 0 ? void 0 : ref15.purchesablePlanIds,
        plans,
        dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item
    ]);
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: generatePath(routerPages.ArtistStoreItemDetail, router.query)
    });
    var ref49 = (0,react.useState)(false), openExpiredCardModal = ref49[0], setOpenExpiredCardModal = ref49[1];
    var ref50 = (0,react.useState)(false), openPaymentErrorModal = ref50[0], setOpenPaymentErrorModal = ref50[1];
    var ref51 = (0,react.useState)(false), openRequire3DSecureModal = ref51[0], setOpenRequire3DSecureModal = ref51[1];
    //リセール前か判定するwillResaleAvailableがsku単位で取得できないため、フロントでsku単位ごとのwillResaleAvailableを作成
    var IsSkuWillResaleAvailable = function(skuId) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var sku = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : ref1.units.find(function(sku) {
            return sku.id === skuId;
        });
        if (!sku) return false;
        // チケットアイテムでないものはfalse
        if ((data === null || data === void 0 ? void 0 : (ref2 = data.item) === null || ref2 === void 0 ? void 0 : ref2.type) !== "ticket") return false;
        // リセール有効でないものはfalse
        if (!(data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : ref3.resaleEnabled)) return false;
        // リセール期間前ではないものはfalse
        if (new Date() > (data === null || data === void 0 ? void 0 : (ref4 = data.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.resalePeriod) === null || ref7 === void 0 ? void 0 : ref7.startedAt)) return false;
        var _stock;
        // アイテム在庫があればfalse
        var stock = (_stock = sku.stock) !== null && _stock !== void 0 ? _stock : 0;
        var _purchasedNumber, _pendingPurchaseNumber;
        var purchaseQuantity = ((_purchasedNumber = sku.purchasedNumber) !== null && _purchasedNumber !== void 0 ? _purchasedNumber : 0) + ((_pendingPurchaseNumber = sku.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0);
        if (stock > purchaseQuantity) return false;
        return true;
    };
    //skuの種類をクリックした時に、クリックしたskuのwillResaleAvailableがtrueかどうか判定
    (0,react.useEffect)(function() {
        var IsSkuWillResale = IsSkuWillResaleAvailable(skuId);
        setSkuWillResaleAvailable(IsSkuWillResale);
    }, [
        skuId,
        data,
        dataForGuest
    ]);
    //データを取得した時に、一つでもskuのwillResaleAvailableがtrueだった場合、ボタンを活性にするための処理
    (0,react.useEffect)(function() {
        var ref, ref1;
        var willResaleEnable = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : ref1.units.some(function(sku) {
            return IsSkuWillResaleAvailable(sku.id);
        });
        setSkuButtonActive(willResaleEnable);
    }, [
        data,
        dataForGuest
    ]);
    var ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60;
    return {
        state: {
            currentUser: user,
            user: (ref52 = data === null || data === void 0 ? void 0 : data.user) !== null && ref52 !== void 0 ? ref52 : null,
            artistId: artistId,
            loading: useInitialLoading(data !== null && data !== void 0 ? data : dataForGuest, loading || loadingForGuest || web3authWalletLoading),
            hasItem: hasItem,
            loadingItemWithSku: loadingItemWithSku,
            addingToCart: addingToCart || signingAnonymously,
            isLoggedIn: !!user,
            itemId: router.query.itemId,
            userLoggedInId: (ref53 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref53 !== void 0 ? ref53 : "",
            item: item,
            purchasablePlanNames: purchasablePlanNames,
            point: (ref54 = data === null || data === void 0 ? void 0 : (ref16 = data.prepaidPointBalance) === null || ref16 === void 0 ? void 0 : ref16.balance) !== null && ref54 !== void 0 ? ref54 : 0,
            prepaidPointId: (ref55 = data === null || data === void 0 ? void 0 : (ref17 = data.prepaidPointBalance) === null || ref17 === void 0 ? void 0 : ref17.prepaidPointId) !== null && ref55 !== void 0 ? ref55 : "",
            formattedPoint: (ref56 = data === null || data === void 0 ? void 0 : (ref18 = data.prepaidPointBalance) === null || ref18 === void 0 ? void 0 : ref18.formattedPrepaidPointBarance) !== null && ref56 !== void 0 ? ref56 : "",
            userActiveResaleItemRaffle: userActiveResaleItemRaffle,
            isConnect: !!(data === null || data === void 0 ? void 0 : (ref19 = data.user) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.cryptoWallet) === null || ref20 === void 0 ? void 0 : ref20.address),
            paymentType: (ref57 = data === null || data === void 0 ? void 0 : (ref21 = data.item) === null || ref21 === void 0 ? void 0 : ref21.paymentType) !== null && ref57 !== void 0 ? ref57 : "",
            purchasablePrepaidPoints: (ref58 = data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints) !== null && ref58 !== void 0 ? ref58 : null,
            pointChargeLoading: chargeLoading,
            paymentSource: (ref59 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref59 !== void 0 ? ref59 : null,
            isCardRegistered: !!(data === null || data === void 0 ? void 0 : (ref22 = data.paymentSource) === null || ref22 === void 0 ? void 0 : ref22.last4),
            verifyingSMSCode: verifyingSMSCode,
            openSMSVerificationModal: openSMSVerificationModal,
            sendingVerificationLoading: sendingVerificationLoading,
            itemPurchasing: itemPurchasing,
            userCartCount: (ref60 = data === null || data === void 0 ? void 0 : data.userCartCount) !== null && ref60 !== void 0 ? ref60 : 0,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal,
            skuButtonActive: skuButtonActive,
            skuWillResaleAvailable: skuWillResaleAvailable,
            /**  アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref23 = data.organization) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.modules) === null || ref24 === void 0 ? void 0 : ref24.pointCarrierPayment)
        },
        actions: {
            onPurchaseItem: function onPurchaseItem(count, price, skuId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var purchasePromise;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 無料アイテムの場合、purchaseItemByPointミューテーションで購入処理を行う
                                if (!price) {
                                    purchasePromise = purchaseItemByPoint({
                                        variables: {
                                            itemId: router.query.itemId,
                                            prepaidPoint: 0,
                                            purchaseNumber: count,
                                            skuId: skuId !== null && skuId !== void 0 ? skuId : null
                                        }
                                    });
                                } else {
                                    purchasePromise = purchaseItemImmediately({
                                        variables: {
                                            inputs: {
                                                itemId: router.query.itemId,
                                                count: count,
                                                price: price,
                                                skuId: skuId !== null && skuId !== void 0 ? skuId : null
                                            }
                                        },
                                        context: {
                                            headers: {
                                                "x-utoniq-idempotency-key": createUuid()
                                            }
                                        }
                                    });
                                }
                                return [
                                    4,
                                    purchasePromise.then(function() {
                                        var ref, ref1, ref2;
                                        var ref3, ref4;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                                            transaction_id: generateTransactionId(user === null || user === void 0 ? void 0 : user.uid),
                                            currency: "JPY",
                                            type: "convenience_store",
                                            items: [
                                                {
                                                    item_id: (ref3 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "",
                                                    item_name: (ref4 = data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref4 !== void 0 ? ref4 : "",
                                                    item_category: ConversionCategories.storeItem,
                                                    item_category2: data === null || data === void 0 ? void 0 : (ref2 = data.item) === null || ref2 === void 0 ? void 0 : ref2.type,
                                                    item_category3: platform,
                                                    item_category4: "artistStoreItemDetail",
                                                    item_category5: artistId,
                                                    price: price,
                                                    quantity: count
                                                }, 
                                            ]
                                        });
                                    }).catch(function(error) {
                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: artistId,
                                            error: error === null || error === void 0 ? void 0 : error.name,
                                            errorCode: error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode
                                        });
                                        switch((ref3 = error.graphQLErrors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.extensions) === null || ref5 === void 0 ? void 0 : ref5.errorCode){
                                            case constants/* constants.errorCodes.NEED_PATRON */._.errorCodes.NEED_PATRON:
                                                {
                                                    var e = new Error(t("needPatronErrorMessage"));
                                                    showError(e);
                                                    throw e;
                                                }
                                            /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                                setOpenRequire3DSecureModal(true);
                                                throw error;
                                            /**
               * @desciption
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                                setOpenExpiredCardModal(true);
                                                throw error;
                                            /**
               * @desciption
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                                setOpenPaymentErrorModal(true);
                                                throw error;
                                            default:
                                                showError(error);
                                                throw error;
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            connectMetamask: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                userAuthorizeWalletBySignatureMessage()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            connectToWeb3auth: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var idToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,auth/* getAccessToken */.hP)({
                                    forceUpdateToken: true
                                })
                            ];
                        case 1:
                            idToken = _state.sent();
                            if (!idToken) throw new Error("get jwtToke failed");
                            /**
         * web3auth <=> firebase auth連携
         */ return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.connectToWeb3Auth(idToken);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            // ポイントをチャージ
            onPurchaseCharge: platform === "web" ? purchaseByWeb : purchaseByIosAndAndroid,
            onUserInfoSetting: function onUserInfoSetting(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _ref, fullAddress, __typename, addressInput;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.address) || {
                                    postalCode: "",
                                    prefecture: "",
                                    city: "",
                                    line1: "",
                                    line2: ""
                                }, fullAddress = _ref.fullAddress, __typename = _ref.__typename, addressInput = (0,_object_without_properties/* default */.Z)(_ref, [
                                    "fullAddress",
                                    "__typename"
                                ]);
                                return [
                                    4,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: values.fullName,
                                                phoneNumber: values.phoneNumber,
                                                address: addressInput
                                            }
                                        }
                                    }).then(function(param) {
                                        var data = param.data;
                                        if (!(data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo.isPhoneNumberVerified)) {
                                            setOpenSMSVerificationModal(true);
                                        }
                                        return !!(data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo.isPhoneNumberVerified);
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            },
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            },
            onCloseSMSVerificationModal: function onCloseSMSVerificationModal() {
                setOpenSMSVerificationModal(false);
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS().then(function() {
                                        setOpenSMSVerificationModal(false);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCreatePayment: /**
       * @description
       * 一連の処理の流れは以下の通り
       * 1. カード登録に必要なトークンの発行
       * 2. 登録リクエストを投げると、正常終了 or 3DSecure 認証要求
       * 3. （3DSecure 認証が求められた場合のみ）
       *    3DSecure モーダルで認証を行う
       */ function onCreatePayment(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, expMonth, expYear, token, ref1, paymentResponse, clientSecret, result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = (0,_sliced_to_array/* default */.Z)(values.expirationDate.split("/"), 2), expMonth = ref[0], expYear = ref[1];
                                return [
                                    4,
                                    (0,stripe/* createTokenWithCard */.xE)({
                                        number: values.cardNumber.replace(/\s/g, ""),
                                        name: values.cardHolder,
                                        cvc: values.securityCode.replace(/\s/g, ""),
                                        expMonth: expMonth,
                                        expYear: expYear
                                    }).catch(function(error) {
                                        throw new Error(t(error.message));
                                    })
                                ];
                            case 1:
                                token = _state.sent();
                                return [
                                    4,
                                    createPaymentMethod({
                                        variables: {
                                            createPaymentMethodToken: token
                                        }
                                    })
                                ];
                            case 2:
                                ref1 = _state.sent(), paymentResponse = ref1.data;
                                if (!(paymentResponse && "clientSecret" in paymentResponse.createPaymentMethod)) return [
                                    3,
                                    4
                                ];
                                clientSecret = paymentResponse.createPaymentMethod.clientSecret;
                                return [
                                    4,
                                    (0,stripe/* confirmCardSetupWithStripe */.gC)(clientSecret)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result.error) throw new Error(result.error.message);
                                _state.label = 4;
                            case 4:
                                /**
         * @description
         * webhook通知〜クレジットカード登録の完了を待つため
         * 暫定的に sleep を加えている
         */ return [
                                    4,
                                    sleep(2000)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onResendVerificationSMS: function onResendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onVerificationPhoneNumber: function onVerificationPhoneNumber(param) {
                var code = param.code;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    verifySMSCode({
                                        variables: {
                                            code: code
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeliveryInfoSetting: function onDeliveryInfoSetting(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var user, _fullName, _phoneNumber;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                user = data === null || data === void 0 ? void 0 : data.user;
                                if (!user) return [
                                    2
                                ];
                                return [
                                    4,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: (_fullName = user.fullName) !== null && _fullName !== void 0 ? _fullName : "",
                                                phoneNumber: (_phoneNumber = user.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "",
                                                address: {
                                                    postalCode: values.postalCode,
                                                    prefecture: values.prefecture,
                                                    city: values.city,
                                                    line1: values.line1,
                                                    line2: values.line2
                                                }
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            // カートに入れる
            onAddToCart: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!user) return [
                                    3,
                                    2
                                ];
                                setSigningAnonymously(true);
                                return [
                                    4,
                                    signInAnonymously().then(function(user) {
                                        if (!user) return;
                                        (0,storage/* setAnonymousUser */.$w)({
                                            uid: user === null || user === void 0 ? void 0 : user.uid,
                                            displayName: user === null || user === void 0 ? void 0 : user.displayName
                                        });
                                    }).finally(function() {
                                        return setSigningAnonymously(false);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    addToCart({
                                        variables: {
                                            inputs: inputs
                                        }
                                    }).then(function(param) {
                                        var _data = param.data;
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                                        // イベントコレクションに関連づくアイテムの場合、イベントコレクション詳細に遷移する。それ以外のアイテムの場合、ストアアイテム一覧に遷移する
                                        var eventId = (ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.id;
                                        var collectionId = (ref4 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.item) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.collection) === null || ref6 === void 0 ? void 0 : ref6.id;
                                        if (collectionId && eventId) {
                                            router.replace(generatePath(routerPages.ShokufesEventCollectionDetail, {
                                                eventId: eventId,
                                                collectionId: collectionId
                                            }));
                                        } else {
                                            router.replace(generatePath(routerPages.ArtistStore, {
                                                artistId: artistId
                                            }));
                                        }
                                        var ref10;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("add_to_cart", {
                                            item_list_id: "artist_store_list_".concat(artistId),
                                            item_list_name: "Artist Store Items",
                                            isAnonymous: !!(user === null || user === void 0 ? void 0 : user.isAnonymous),
                                            items: [
                                                {
                                                    item_id: inputs.itemId,
                                                    item_name: data === null || data === void 0 ? void 0 : (ref7 = data.item) === null || ref7 === void 0 ? void 0 : ref7.title,
                                                    item_category: "store_item",
                                                    item_category2: data === null || data === void 0 ? void 0 : (ref8 = data.item) === null || ref8 === void 0 ? void 0 : ref8.type,
                                                    item_category3: native_app/* getPlatform */.Xf(),
                                                    item_category4: inputs.skuId,
                                                    item_category5: artistId,
                                                    price: inputs.count * ((ref10 = data === null || data === void 0 ? void 0 : (ref9 = data.item) === null || ref9 === void 0 ? void 0 : ref9.price) !== null && ref10 !== void 0 ? ref10 : 0),
                                                    quantity: inputs.count
                                                }, 
                                            ]
                                        });
                                        showMessage(t("addedToCart"), "success", undefined, /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cart", {
                                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                                    type: "snackBar",
                                                    isAnonymous: user === null || user === void 0 ? void 0 : user.isAnonymous
                                                });
                                                router.push(generatePath(routerPages.StoreCartDetail, {
                                                    cartId: _data === null || _data === void 0 ? void 0 : _data.addToCart.id
                                                }));
                                                handleClose();
                                            },
                                            variant: "subtitle1",
                                            color: "white",
                                            children: t("showCart")
                                        }), false);
                                    }).catch(function(e) {
                                        var ref, ref1, ref2, ref3;
                                        var ref4;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: artistId,
                                            error: e.name,
                                            errorCode: (ref4 = (ref = e.graphQLErrors[0].extensions) === null || ref === void 0 ? void 0 : ref.errorCode) !== null && ref4 !== void 0 ? ref4 : ""
                                        });
                                        if ((e === null || e === void 0 ? void 0 : (ref1 = e.graphQLErrors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.extensions) === null || ref3 === void 0 ? void 0 : ref3.errorCode) === "NEED_PATRON") {
                                            showError(new Error(t("needPatronErrorMessage")));
                                            return;
                                        }
                                        showError(e);
                                    })
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onClickShare: function onClickShare() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    artistId: router,
                                    itemId: router.query.itemId,
                                    name: "artistStoreItemDetail"
                                });
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.title,
                                        text: (data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : ref1.description) || "",
                                        url: url,
                                        dialogTitle: data === null || data === void 0 ? void 0 : (ref2 = data.item) === null || ref2 === void 0 ? void 0 : ref2.title
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId,
                                            itemId: router.query.itemId,
                                            name: "artistStoreItemDetail"
                                        });
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGetArtistStoreItemDetailWithSku: function onGetArtistStoreItemDetailWithSku(skuId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(user === null || user === void 0 ? void 0 : user.isSigned)) return [
                                    2
                                ];
                                setSkuId(skuId);
                                return [
                                    4,
                                    getArtistStoreItemDetailWithSku({
                                        variables: {
                                            skuId: skuId,
                                            id: router.query.itemId,
                                            itemId: router.query.itemId
                                        }
                                    })
                                ];
                            case 1:
                                error = _state.sent().error;
                                if (error) {
                                    showError(error);
                                    throw error;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistStoreItemDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistStoreItemDetail_viewModel_templateObject(), utoniq_core_schema/* ArtistSubscriptionPlanFragmentDoc */.Nph, utoniq_core_schema/* UserDeliveryInfoFragmentDoc */.I0h, utoniq_core_schema/* StoreItemDetailGuestFragmentDoc */.wi$, utoniq_core_schema/* PurchasablePrepaidPointConnectionFragmentDoc */.oBq, utoniq_core_schema/* PaymentCreateDetailFragmentDoc */.grT);
var QUERY_ITEM_WITH_SKU = (0,lib/* gql */.Ps)(ArtistStoreItemDetail_viewModel_templateObject1(), utoniq_core_schema/* StoreItemDetailGuestSkuFragmentDoc */.CiG);
var ArtistStoreItemDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(ArtistStoreItemDetail_viewModel_templateObject2(), utoniq_core_schema/* ArtistSubscriptionPlanFragmentDoc */.Nph, utoniq_core_schema/* StoreItemDetailGuestFragmentDoc */.wi$);
var ADD_ITEM_TO_CART = (0,lib/* gql */.Ps)(ArtistStoreItemDetail_viewModel_templateObject3());
var PURCHASE_ITEM_BY_POINT = (0,lib/* gql */.Ps)(viewModel_templateObject4(), utoniq_core_schema/* StoreItemDetailFragmentDoc */.puk);
var VIEW_STORE_ITEM = (0,lib/* gql */.Ps)(viewModel_templateObject5());
var PURCHASE_ITEM_IMMEDIATELY = (0,lib/* gql */.Ps)(viewModel_templateObject6(), utoniq_core_schema/* StoreItemDetailFragmentDoc */.puk);

;// CONCATENATED MODULE: ./src/components/pages/ArtistStoreItemDetail/index.tsx




var ArtistStoreItemDetail = function() {
    var ref = ArtistStoreItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Fab/Fab.js
var Fab = __webpack_require__(25296);
// EXTERNAL MODULE: ./src/components/layouts/BottomSafeArea.tsx
var BottomSafeArea = __webpack_require__(68074);
// EXTERNAL MODULE: ./src/components/organisms/functionals/FullscreenModal/index.tsx
var FullscreenModal = __webpack_require__(2977);
;// CONCATENATED MODULE: ./src/components/pages/ArtistThreads/template/index.tsx



















var ArtistThreadsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onRefetch = param.onRefetch;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref4 = (0,react.useState)(false), open = ref4[0], setOpen = ref4[1];
    var ref5 = (0,react.useState)(false), openSideMenu = ref5[0], setOpenSideMenu = ref5[1];
    var ref6 = (0,react.useState)({
        filter: state.filter.filter,
        orderBy: state.filter.orderBy
    }), options = ref6[0], setOptions = ref6[1];
    var params = new URLSearchParams(window.location.search);
    var tab = params.get("tab");
    var handleOrderBy = (0,react.useCallback)(function(orderBy) {
        setOptions(function(prevState) {
            onRefetch((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                orderBy: orderBy
            }));
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                orderBy: orderBy
            });
        });
    }, [
        onRefetch
    ]);
    var handleFilter = (0,react.useCallback)(function(filter) {
        setOptions(function(prevState) {
            onRefetch((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                filter: filter
            }));
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                filter: filter
            });
        });
    }, [
        onRefetch
    ]);
    (0,react.useEffect)(function() {
        var _filter;
        var UrlParams = "?tab=".concat((_filter = options.filter) !== null && _filter !== void 0 ? _filter : "all", "&sort=").concat(options.orderBy);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        options.orderBy,
        options.filter
    ]);
    (0,react.useEffect)(function() {
        var eventTab = tab === "all" ? undefined : tab;
        if (eventTab !== options.filter) {
            setOptions({
                filter: options.filter,
                orderBy: utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt
            });
        }
    }, [
        options.filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "artist",
                props: {
                    isLive: !!state.liveStreamId,
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                }
            },
            header: {
                title: t("title"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                    edge: "end",
                    color: "primary",
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_help", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: state.artistId
                        });
                        setOpen(true);
                    }
                }),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    color: "icon.line",
                    bgcolor: "icon.background",
                    badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasManagementTask) || !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.unreadNotificationCount)
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.ArtistThreads,
                        state.artistName
                    ]
                }),
                state.isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadTypeCell, {
                    onFilter: handleFilter,
                    filter: options
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectButtonCell, {
                    onOrderBy: handleOrderBy,
                    filter: options
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadListCell, {
                    loading: state.loading || state.refetching,
                    hasNextPage: state.hasNextPage,
                    hasPatron: state.hasPatron,
                    threads: state.threads,
                    isShowModalPersonalInfoRequire: state.isShowModalPersonalInfoRequire,
                    onFetchMore: function() {
                        return onFetchMore(options);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseCell, {
                    artistId: state.artistId
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadHelpModal, {
                    open: open,
                    onClose: function() {
                        return setOpen(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                })
            ]
        })
    });
};
var channelFilterTypes = [
    undefined,
    utoniq_core_schema/* ArtistThreadChannelFilterType.MyThread */.Vjp.MyThread,
    utoniq_core_schema/* ArtistThreadChannelFilterType.MyComment */.Vjp.MyComment,
    utoniq_core_schema/* ArtistThreadChannelFilterType.Official */.Vjp.Official,
    utoniq_core_schema/* ArtistThreadChannelFilterType.TradeCall */.Vjp.TradeCall,
    utoniq_core_schema/* ArtistThreadChannelFilterType.Request */.Vjp.Request,
    utoniq_core_schema/* ArtistThreadChannelFilterType.Event */.Vjp.Event,
    utoniq_core_schema/* ArtistThreadChannelFilterType.Faq */.Vjp.Faq, 
];
var ThreadTypeCell = function(param) {
    var onFilter = param.onFilter, filter = param.filter;
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    var _filter;
    var ref = (0,react.useState)((_filter = filter.filter) !== null && _filter !== void 0 ? _filter : undefined), value = ref[0], setValue = ref[1];
    var tags = (0,react.useMemo)(function() {
        return channelFilterTypes.map(function(type) {
            return {
                value: type,
                label: t("category_".concat(type !== null && type !== void 0 ? type : "all"))
            };
        });
    }, [
        t
    ]);
    var handleSelectType = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValue(newValue);
                        return [
                            4,
                            onFilter(newValue)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
            onClick: handleSelectType,
            value: value,
            tags: tags
        })
    });
};
var orderByTypes = [
    utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt,
    utoniq_core_schema/* ArtistThreadChannelOrderByType.Recommend */.TuN.Recommend,
    utoniq_core_schema/* ArtistThreadChannelOrderByType.LikeCount */.TuN.LikeCount,
    utoniq_core_schema/* ArtistThreadChannelOrderByType.CommentCount */.TuN.CommentCount, 
];
var SelectButtonCell = function(param) {
    var onOrderBy = param.onOrderBy, filter = param.filter;
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    var ref = (0,react.useState)([
        t("newArrivalOrder"),
        t("recommendOrder"),
        t("likeOrder"),
        t("commentCountOrder"), 
    ]), options = ref[0];
    var sortIndex = orderByTypes.findIndex(function(order) {
        return order === filter.orderBy;
    });
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(sortIndex), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var open = Boolean(anchorEl);
    var params = new URLSearchParams(window.location.search);
    var tab = params.get("tab");
    var handleClickListItem = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleMenuItemClick = (0,react.useCallback)(function(event, index) {
        setSelectedIndex(index);
        onOrderBy(orderByTypes[index]);
        setAnchorEl(null);
    }, [
        onOrderBy
    ]);
    (0,react.useEffect)(function() {
        var eventTab = tab === "all" ? undefined : tab;
        if (eventTab !== filter.filter) {
            setSelectedIndex(0);
        }
    }, [
        filter.filter
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    onClick: handleClickListItem,
                    sx: {
                        mr: -1
                    },
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        fontSize: "xSmall"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: options[selectedIndex]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        selected: index === selectedIndex,
                        sx: {
                            minWidth: 200
                        },
                        onClick: function(event) {
                            return handleMenuItemClick(event, index);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: option
                        })
                    }, index);
                })
            })
        ]
    });
};
var ThreadListCell = function(param) {
    var threads = param.threads, loading = param.loading, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire, hasPatron = param.hasPatron, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: threads === null || threads === void 0 ? void 0 : (ref = threads.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ThreadBox, {
                    thread: node,
                    hasPatron: hasPatron,
                    isShowModalPersonalInfoRequire: isShowModalPersonalInfoRequire,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: node.artistId,
                            threadId: node.id,
                            name: "thread"
                        });
                    }
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            emptyMessage: t("threadListEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 6,
                sx: {
                    py: 2
                },
                children: Array.from(Array(3).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadBoxSkeleton, {}, key);
                })
            })
        })
    });
};
var BaseCell = function(param) {
    var artistId = param.artistId;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                position: "fixed",
                bottom: 72,
                zIndex: 5,
                maxWidth: 600,
                margin: "0 auto",
                px: 4,
                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "medium",
                color: "primary",
                onClick: handleLoginModal(),
                href: generatePath(routerPages.ArtistThreadCreate, {
                    artistId: artistId
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pencil, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                })
            })
        })
    });
};
var ThreadHelpModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var theme = config_config/* config.theme.dark */.v.theme.dark ? "dark" : "light";
    var t = (0,core_i18n/* useTranslation */.$G)("artistThreads").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("howToThread"),
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: onClose
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
                    sx: {
                        bgcolor: "background.default"
                    },
                    defaultProps: {
                        sx: {
                            bgcolor: "grey.50"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        target: "common",
                        width: "100%",
                        src: "images/info/threadInfo--".concat(theme, ".png")
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistThreads/viewModel.ts



function ArtistThreads_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistThreads(\n    $inputs: ArtistThreadChannelsInput!\n    $pageInput: PageInput\n    $artistId: ID\n  ) {\n    artistThreadChannels(inputs: $inputs, pageInput: $pageInput) {\n      ...ArtistThreadChannelConnection\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      accountId\n      formattedAccountId @client\n      patron {\n        id\n        isPersonalInformationRequired\n      }\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistThreads_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistThreads_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistThreads(\n    $inputs: ArtistThreadChannelsInput!\n    $pageInput: PageInput\n    $artistId: ID\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      accountId\n      formattedAccountId @client\n      patron {\n        id\n        isPersonalInformationRequired\n      }\n      currentLive {\n        id\n      }\n    }\n    artistThreadChannels(inputs: $inputs, pageInput: $pageInput) {\n      ...ArtistThreadChannelConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistThreads_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistThreads_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistThreadsForGuest(\n    $inputs: ArtistThreadChannelsInput!\n    $pageInput: PageInput\n    $artistId: ID\n  ) {\n    artistThreadChannels(inputs: $inputs, pageInput: $pageInput) {\n      ...ArtistThreadChannelConnection\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      ...ArtistSmallDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistThreads_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ArtistThreads_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref16 = (0,auth/* useCurrentUser */.xJ)(), user = ref16.user, userClaims = ref16.userClaims;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort");
    var tab = params.get("tab");
    var ref17;
    var machingFilter = (ref17 = Object.values(utoniq_core_schema/* ArtistThreadChannelFilterType */.Vjp).find(function(value) {
        return value === tab;
    })) !== null && ref17 !== void 0 ? ref17 : undefined;
    var ref18;
    var machingSort = (ref18 = Object.values(utoniq_core_schema/* ArtistThreadChannelOrderByType */.TuN).find(function(value) {
        return value === sort;
    })) !== null && ref18 !== void 0 ? ref18 : utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt;
    var eventFilter = {
        filter: machingFilter,
        orderBy: machingSort
    };
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_THREAD,
        fields: [
            {
                fieldName: "artistThreadChannels",
                fragment: utoniq_core_schema/* ThreadBoxFragmentDoc */.bid
            }, 
        ],
        variables: {
            inputs: {
                artistId: artistId,
                options: {
                    filter: machingFilter,
                    orderBy: machingSort
                }
            },
            pageInput: {
                limit: 30
            },
            artistId: artistId
        },
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref19 = (0,useQuery/* useQuery */.aM)(ArtistThreads_viewModel_QUERY, {
        variables: {
            inputs: {
                artistId: artistId,
                options: {
                    orderBy: machingSort,
                    filter: machingFilter
                }
            },
            artistId: artistId
        },
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        fetchPolicy: "cache-and-network",
        // Get cache first in second time
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        // - On the first time: data has not cached,
        //      should call api first -> onCompleted run after useEffect with isFirstLoadRef = true (getNewThreads)
        // - From second time: data has been cached,
        //      no need to call api -> onCompleted run before useEffect with isFirstLoadRef = false (getNewThreads)
        onCompleted: function(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref19.data, fetchMore = ref19.fetchMore, refetch = ref19.refetch, networkStatus = ref19.networkStatus;
    var isNextFetch = !!data;
    var ref20 = (0,useQuery/* useQuery */.aM)(ArtistThreads_viewModel_QUERY_FOR_GUEST, {
        variables: {
            inputs: {
                artistId: artistId,
                options: {
                    orderBy: machingSort,
                    filter: machingFilter
                }
            },
            artistId: artistId
        },
        skip: !!(user === null || user === void 0 ? void 0 : user.isSigned),
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), dataForGuest = ref20.data, networkStatusForGuest = ref20.networkStatus, fetchMoreForGuest = ref20.fetchMore, refetchForGuest = ref20.refetch;
    var isNextFetchForGuest = !!dataForGuest;
    var ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch || networkStatusForGuest === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetchForGuest,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore || networkStatusForGuest === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!((ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.artistThreadChannels) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            artistId: artistId,
            artistName: (ref22 = (ref21 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName) !== null && ref21 !== void 0 ? ref21 : dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref3 = dataForGuest.artist) === null || ref3 === void 0 ? void 0 : ref3.displayName) !== null && ref22 !== void 0 ? ref22 : "",
            hasPatron: !!(data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.patron) === null || ref5 === void 0 ? void 0 : ref5.id),
            isShowModalPersonalInfoRequire: !!((data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : ref6.isMembershipPersonalInformationRequired) && (data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.patron) === null || ref8 === void 0 ? void 0 : ref8.isPersonalInformationRequired)),
            threads: (ref24 = (ref23 = data === null || data === void 0 ? void 0 : data.artistThreadChannels) !== null && ref23 !== void 0 ? ref23 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.artistThreadChannels) !== null && ref24 !== void 0 ? ref24 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref9 = userClaims.orgs) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[config_config/* config.organizationId */.v.organizationId]) === null || ref10 === void 0 ? void 0 : ref10.artist),
            followArtists: (ref25 = data === null || data === void 0 ? void 0 : (ref11 = data.user) === null || ref11 === void 0 ? void 0 : ref11.organizationFollowees) !== null && ref25 !== void 0 ? ref25 : null,
            memberArtists: (ref26 = data === null || data === void 0 ? void 0 : (ref12 = data.user) === null || ref12 === void 0 ? void 0 : ref12.organizationPatrons) !== null && ref26 !== void 0 ? ref26 : null,
            isLogin: user ? true : false,
            user: (ref27 = data === null || data === void 0 ? void 0 : data.user) !== null && ref27 !== void 0 ? ref27 : null,
            liveStreamId: (ref13 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.artist) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.currentLive) === null || ref15 === void 0 ? void 0 : ref15.id,
            filter: eventFilter
        },
        actions: {
            onFetchMore: function onFetchMore(options) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreForGuest({
                                        variables: {
                                            inputs: {
                                                artistId: artistId,
                                                options: options
                                            },
                                            pageInput: {
                                                cursor: dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref1 = dataForGuest.artistThreadChannels) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            inputs: {
                                                artistId: artistId,
                                                options: options
                                            },
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistThreadChannels) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRefetch: function onRefetch(options) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetchForGuest({
                                        inputs: {
                                            artistId: artistId,
                                            options: options
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    refetch({
                                        inputs: {
                                            artistId: artistId,
                                            options: options
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ArtistThreads_viewModel_QUERY = (0,lib/* gql */.Ps)(ArtistThreads_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistThreadChannelConnectionFragmentDoc */.Dxh, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_THREAD = (0,lib/* gql */.Ps)(ArtistThreads_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistThreadChannelConnectionFragmentDoc */.Dxh);
var ArtistThreads_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(ArtistThreads_viewModel_templateObject2(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* ArtistThreadChannelConnectionFragmentDoc */.Dxh, utoniq_core_schema/* ArtistSmallDetailFragmentDoc */.ZCT);

;// CONCATENATED MODULE: ./src/components/pages/ArtistThreads/index.tsx




/**
 * ArtistThreads Page
 * Implemented as a practical sample.
 */ var ArtistThreads = function() {
    var ref = ArtistThreads_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThreadsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistTop/viewModel.ts




function ArtistTop_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation unfollow($artistId: ID!) {\n    unfollow(artistId: $artistId) {\n      ...Follower\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistTop_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistTop_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation follow($artistId: ID!) {\n    follow(artistId: $artistId) {\n      ...Follower\n    }\n  }\n  ",
        "\n"
    ]);
    ArtistTop_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistTop_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistTop(\n    $artistId: ID!\n    $artistIdString: String!\n    $rankingArtistId: String!\n    $missionsTypeFilter: [MissionType!]\n    $artistThreadChannelsInput: ArtistThreadChannelsInput!\n    $filters: ItemsFilterInput\n    $pageInput: PageInputDate\n    $resourceType: PostType\n    $categoryId: String\n  ) {\n    user {\n      ...CurrentUser\n    }\n    artistRankings(artistId: $rankingArtistId) {\n      ...RankingBaseConnection\n      latestRankingPeriod(periodType: monthly) {\n        myRanking {\n          ...RankingUserWithoutIdConnection\n        }\n      }\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      accountId\n      introduction\n      formattedAccountId @client\n      profileText\n      textLink {\n        content\n        uri\n      }\n      avatar {\n        uri\n        mediumUri\n        smallUri\n      }\n      follower {\n        id\n        artistId\n      }\n      subscription {\n        products {\n          plans {\n            planId\n            status\n            interval\n            amount\n          }\n          content\n        }\n      }\n      sns {\n        facebook\n        instagram\n        tiktok\n        twitter\n        youtube\n      }\n      postCategory {\n        id\n        categories {\n          id\n          name\n        }\n      }\n      posts {\n        edges {\n          node {\n            ...PostBox\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      postVideos: posts(\n        pageInput: $pageInput\n        resourceType: $resourceType\n        categoryId: $categoryId\n      ) {\n        ...ArtistPosts\n      }\n      patron {\n        id\n        isPersonalInformationRequired\n        subscription {\n          planId\n        }\n      }\n      isBlocked\n    }\n    gachas(artistId: $artistId) {\n      ...GachasConnection\n    }\n    missionsWithFilteres(artistId: $artistId, typeFilter: $missionsTypeFilter) {\n      ...MissionsConnection\n    }\n    artistStepMissions(artistId: $artistId) {\n      ...UserStepMissionsConnection\n    }\n    artistThreadChannels(inputs: $artistThreadChannelsInput) {\n      ...ArtistThreadChannelConnection\n    }\n    items(artistId: $artistId, filters: $filters) {\n      ...NewStoreItemConnection\n    }\n    eventsByArtist(artistId: $artistIdString) {\n      ...EventsByArtistConnection\n    }\n    organizationOfficialArtistNotifications(\n      artistId: $artistIdString\n      pageInput: { limit: 3 }\n    ) {\n      ...OrganizationNotificationConnection\n    }\n    userArtistBanners(artistId: $artistId) {\n      ...ArtistBannerDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistTop_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ArtistTop_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistTopForGuest(\n    $artistId: ID!\n    $artistIdString: String!\n    $missionsTypeFilter: [MissionType!]\n    $artistThreadChannelsInput: ArtistThreadChannelsInput!\n    $filters: ItemsFilterInput\n    $pageInput: PageInputDate\n    $resourceType: PostType\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      accountId\n      formattedAccountId @client\n      profileText\n      textLink {\n        content\n        uri\n      }\n      introduction\n      avatar {\n        uri\n        mediumUri\n        smallUri\n      }\n      follower {\n        id\n        artistId\n      }\n      subscription {\n        products {\n          plans {\n            planId\n            status\n            interval\n            amount\n          }\n          content\n        }\n      }\n      sns {\n        facebook\n        instagram\n        tiktok\n        twitter\n        youtube\n      }\n      postCategory {\n        id\n        categories {\n          id\n          name\n        }\n      }\n      posts {\n        edges {\n          node {\n            ...PostBox\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      postVideos: posts(\n        pageInput: $pageInput\n        resourceType: $resourceType\n        categoryId: $categoryId\n      ) {\n        ...ArtistPosts\n      }\n      patron {\n        id\n      }\n    }\n    gachas(artistId: $artistId) {\n      ...GachasConnection\n    }\n    missionsWithFilteres(artistId: $artistId, typeFilter: $missionsTypeFilter) {\n      ...MissionsConnection\n    }\n    artistThreadChannels(inputs: $artistThreadChannelsInput) {\n      ...ArtistThreadChannelConnection\n    }\n    items(artistId: $artistId, filters: $filters) {\n      ...NewStoreItemConnection\n    }\n    eventsByArtist(artistId: $artistIdString) {\n      ...EventsByArtistConnection\n    }\n    organizationOfficialArtistNotifications(\n      artistId: $artistIdString\n      pageInput: { limit: 3 }\n    ) {\n      ...OrganizationNotificationConnection\n    }\n    userArtistBanners(artistId: $artistId) {\n      ...ArtistBannerDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistTop_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ArtistTop_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistLiveStream($artistId: ID!) {\n    artist(id: $artistId) {\n      id\n      currentLive {\n        id\n        isPremium\n      }\n    }\n  }\n"
    ]);
    ArtistTop_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var ArtistTop_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTop").t;
    var ref32 = (0,auth/* useCurrentUser */.xJ)(), user = ref32.user, userClaims = ref32.userClaims;
    var ref33 = (0,router_useRouter/* useRouter */.tv)(), router = ref33.router, location = ref33.location;
    var reloadUser = (0,auth/* useAuth */.aC)().reloadUser;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var resourceType = utoniq_core_schema/* PostType.Video */.hQF.Video;
    (0,router_useRouter/* useTrackPageView */.Px)(function() {
        /**
     * HACK: delay for save
     */ setTimeout(function() {
            return (0,storage/* setRedirectAfterLoginPath */.fu)(location.pathname);
        }, 300);
    });
    var ref34 = (0,useQuery/* useQuery */.aM)(ARTIST_TOP, {
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        variables: {
            artistId: artistId,
            artistIdString: artistId,
            rankingArtistId: artistId,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ],
            artistThreadChannelsInput: {
                artistId: artistId,
                options: {
                    orderBy: utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt
                }
            },
            filters: {
                isPublished: true,
                reviewStatus: "accepted",
                salesStatus: "active"
            },
            resourceType: resourceType,
            pageInput: {
                limit: 12
            },
            categoryId: null
        },
        onCompleted: function(data) {
            if (!(data === null || data === void 0 ? void 0 : data.artist)) return;
            (0,vars/* currentArtistVar */.ag)(data.artist);
        }
    }), data = ref34.data, loading = ref34.loading;
    var isNextFetch = !!data;
    var ref35 = (0,useQuery/* useQuery */.aM)(ARTIST_TOP_FOR_GUEST, {
        skip: !!(user === null || user === void 0 ? void 0 : user.isSigned),
        variables: {
            artistId: artistId,
            artistIdString: artistId,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ],
            artistThreadChannelsInput: {
                artistId: artistId,
                options: {
                    orderBy: utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt
                }
            },
            filters: {
                isPublished: true,
                reviewStatus: "accepted",
                salesStatus: "active"
            },
            resourceType: resourceType,
            pageInput: {
                limit: 12
            },
            categoryId: null
        },
        onCompleted: function(data) {
            if (!(data === null || data === void 0 ? void 0 : data.artist)) return;
            (0,vars/* currentArtistVar */.ag)(data.artist);
        }
    }), dataForGuest = ref35.data, loadingForGuest = ref35.loading;
    var isNextFetchForGuest = !!dataForGuest;
    /**
   * @description
   * ライブ配信開始・終了検知のため10秒毎にcurrentLiveのみpollingする
   */ var ref36 = (0,useQuery/* useQuery */.aM)(ARTIST_LIVE_STREAM, {
        variables: {
            artistId: artistId
        },
        pollInterval: 10000,
        fetchPolicy: "network-only",
        skip: !config_config/* config.modules.liveStream */.v.modules.liveStream
    }), dataLiveStream = ref36.data;
    var ref37 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(FOLLOW), 1), follow = ref37[0];
    var ref38 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNFOLLOW), 1), unfollow = ref38[0];
    var ref39 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikePost */.UEr), 1), likePost = ref39[0];
    var ref40 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikePost */.UsN), 1), unlikePost = ref40[0];
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: config_config/* config.applicationType */.v.applicationType === "standalone" ? "/home" : "/artists/".concat(artistId, "/home")
    });
    (0,react.useEffect)(function() {
        var ref;
        // スタンドアローンの場合、アーティストをフォローする
        if (!user || config_config/* config.applicationType */.v.applicationType !== "standalone" || !!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.follower) || !config_config/* config.artistId */.v.artistId) return;
        follow({
            variables: {
                artistId: artistId
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.uid
    ]);
    (0,react.useEffect)(function() {
        if (user && !loading && config_config/* config.applicationType */.v.applicationType === "standalone") {
            reloadUser().catch(showError);
        }
    }, [
        loading
    ]);
    var ref41, ref42, ref43, ref44, ref45, ref46;
    return {
        state: {
            loading: loading && !isNextFetch || loadingForGuest && !isNextFetchForGuest,
            artistId: artistId,
            artist: ((ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : ref.artist) || null,
            newGachas: ((ref1 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gachas) === null || ref2 === void 0 ? void 0 : ref2.edges.map(function(e) {
                return e.node;
            })) || [],
            newMissions: ((ref3 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.missionsWithFilteres) === null || ref4 === void 0 ? void 0 : ref4.edges.map(function(e) {
                return e.node;
            })) || [],
            postCategories: ((ref5 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.postCategory) === null || ref7 === void 0 ? void 0 : ref7.categories) || [],
            newPosts: ((ref8 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.artist) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.posts) === null || ref10 === void 0 ? void 0 : ref10.edges.map(function(e) {
                return e.node;
            })) || [],
            membership: ((ref11 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.artist) === null || ref12 === void 0 ? void 0 : ref12.subscription) || null,
            banners: ((ref13 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref13 === void 0 ? void 0 : ref13.userArtistBanners) || [],
            postVideos: ((ref14 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.artist) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.postVideos) === null || ref16 === void 0 ? void 0 : ref16.edges.map(function(e) {
                return e.node;
            })) || [],
            memberArtists: user ? data === null || data === void 0 ? void 0 : (ref17 = data.user) === null || ref17 === void 0 ? void 0 : ref17.organizationPatrons : null,
            followArtists: user ? data === null || data === void 0 ? void 0 : (ref18 = data.user) === null || ref18 === void 0 ? void 0 : ref18.organizationFollowees : null,
            user: (ref41 = data === null || data === void 0 ? void 0 : data.user) !== null && ref41 !== void 0 ? ref41 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref19 = userClaims.orgs) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[config_config/* config.organizationId */.v.organizationId]) === null || ref20 === void 0 ? void 0 : ref20.artist),
            liveStream: (ref42 = dataLiveStream === null || dataLiveStream === void 0 ? void 0 : (ref21 = dataLiveStream.artist) === null || ref21 === void 0 ? void 0 : ref21.currentLive) !== null && ref42 !== void 0 ? ref42 : null,
            newThreads: ((ref22 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.artistThreadChannels) === null || ref23 === void 0 ? void 0 : ref23.edges.map(function(e) {
                return e.node;
            })) || [],
            isBlocked: !!(data === null || data === void 0 ? void 0 : (ref24 = data.artist) === null || ref24 === void 0 ? void 0 : ref24.isBlocked),
            myRanking: (data === null || data === void 0 ? void 0 : (ref25 = data.artistRankings) === null || ref25 === void 0 ? void 0 : ref25.status) === utoniq_core_schema/* RankingStatus.Active */.HBK.Active ? (ref43 = data === null || data === void 0 ? void 0 : (ref26 = data.artistRankings) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.latestRankingPeriod) === null || ref27 === void 0 ? void 0 : ref27.myRanking) !== null && ref43 !== void 0 ? ref43 : null : null,
            hasMission: !!(data === null || data === void 0 ? void 0 : (ref28 = data.missionsWithFilteres) === null || ref28 === void 0 ? void 0 : ref28.edges.length) || !!(data === null || data === void 0 ? void 0 : (ref29 = data.artistStepMissions) === null || ref29 === void 0 ? void 0 : ref29.edges.length),
            events: (ref45 = (ref44 = data === null || data === void 0 ? void 0 : data.eventsByArtist) !== null && ref44 !== void 0 ? ref44 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.eventsByArtist) !== null && ref45 !== void 0 ? ref45 : null,
            notifications: (ref46 = (ref30 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.organizationOfficialArtistNotifications) === null || ref31 === void 0 ? void 0 : ref31.edges.slice(0, 3)) !== null && ref46 !== void 0 ? ref46 : null
        },
        actions: {
            onFollow: function onFollow() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    follow({
                                        variables: {
                                            artistId: artistId
                                        },
                                        optimisticResponse: function() {
                                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                            var ref8, ref9, ref10;
                                            return {
                                                follow: {
                                                    __typename: "Follower",
                                                    id: "".concat(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id, ":").concat(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.id),
                                                    user: {
                                                        id: (ref8 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref8 !== void 0 ? ref8 : "",
                                                        __typename: "User"
                                                    },
                                                    artist: {
                                                        id: artistId,
                                                        displayName: (ref9 = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.displayName) !== null && ref9 !== void 0 ? ref9 : "",
                                                        avatar: {
                                                            uri: (ref10 = data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.avatar) === null || ref5 === void 0 ? void 0 : ref5.smallUri) !== null && ref10 !== void 0 ? ref10 : "",
                                                            __typename: "Avatar"
                                                        },
                                                        follower: {
                                                            artistId: artistId,
                                                            id: "".concat(data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : ref6.id, ":").concat(data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : ref7.id),
                                                            __typename: "Follower"
                                                        },
                                                        __typename: "Artist"
                                                    }
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUnfollow: function onUnfollow() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    unfollow({
                                        variables: {
                                            artistId: artistId
                                        },
                                        optimisticResponse: function() {
                                            var ref2, ref3, ref4, ref5, ref6;
                                            return {
                                                unfollow: {
                                                    __typename: "Follower",
                                                    id: "".concat(data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.id, ":").concat(data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.id),
                                                    user: {
                                                        id: (ref = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref !== void 0 ? ref : "",
                                                        __typename: "User"
                                                    },
                                                    artist: {
                                                        id: artistId,
                                                        displayName: (ref1 = data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : ref5.displayName) !== null && ref1 !== void 0 ? ref1 : "",
                                                        avatar: data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : ref6.avatar,
                                                        follower: null,
                                                        __typename: "Artist"
                                                    }
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikePost: function onLikePost(postId, isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: function onClickShare() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, url, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: "".concat(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.displayName, " | ").concat(t("metaTitle")),
                                        text: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.profileText) !== null && ref3 !== void 0 ? ref3 : "".concat(t("metaTitle")),
                                        url: url,
                                        dialogTitle: "".concat(data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName, " | ").concat(t("metaTitle"))
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUnBlock: function onUnBlock() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                /**
         * @todo
         * ブロック解除API本格実装後に実装
         * https://app.clickup.com/t/908127/UT-8682
         */ })();
            }
        }
    };
});
var UNFOLLOW = (0,lib/* gql */.Ps)(ArtistTop_viewModel_templateObject(), utoniq_core_schema/* FollowerFragmentDoc */.$zt);
var FOLLOW = (0,lib/* gql */.Ps)(ArtistTop_viewModel_templateObject1(), utoniq_core_schema/* FollowerFragmentDoc */.$zt);
var ARTIST_TOP = (0,lib/* gql */.Ps)(ArtistTop_viewModel_templateObject2(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* RankingBaseConnectionFragmentDoc */.MHS, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* RankingUserWithoutIdConnectionFragmentDoc */.u1C, utoniq_core_schema/* GachaBoxFragmentDoc */.gop, utoniq_core_schema/* MissionBoxFragmentDoc */.zID, utoniq_core_schema/* PostBoxFragmentDoc */.cSz, utoniq_core_schema/* GachasConnectionFragmentDoc */.M$Q, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN, utoniq_core_schema/* ArtistThreadChannelConnectionFragmentDoc */.Dxh, utoniq_core_schema/* UserStepMissionsConnectionFragmentDoc */.qx9, utoniq_core_schema/* NewStoreItemConnectionFragmentDoc */.$NO, utoniq_core_schema/* EventsByArtistConnectionFragmentDoc */._Cn, utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf, utoniq_core_schema/* ArtistBannerDetailFragmentDoc */.jU6, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);
var ARTIST_TOP_FOR_GUEST = (0,lib/* gql */.Ps)(ArtistTop_viewModel_templateObject3(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* GachaBoxFragmentDoc */.gop, utoniq_core_schema/* MissionBoxFragmentDoc */.zID, utoniq_core_schema/* PostBoxFragmentDoc */.cSz, utoniq_core_schema/* GachasConnectionFragmentDoc */.M$Q, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN, utoniq_core_schema/* ArtistThreadChannelConnectionFragmentDoc */.Dxh, utoniq_core_schema/* NewStoreItemConnectionFragmentDoc */.$NO, utoniq_core_schema/* EventsByArtistConnectionFragmentDoc */._Cn, utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf, utoniq_core_schema/* ArtistBannerDetailFragmentDoc */.jU6, utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);
var ARTIST_LIVE_STREAM = (0,lib/* gql */.Ps)(ArtistTop_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/ArtistTop/index.tsx







var artistTopCustomDesignMap = {
    "ArtistTop_tmpl0001_v1.0": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 9654).then(__webpack_require__.bind(__webpack_require__, 39654));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(39654)
                ];
            }
        }
    }),
    "ArtistTop_tmpl_abarerukun_v1.0": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 7727).then(__webpack_require__.bind(__webpack_require__, 27727));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(27727)
                ];
            }
        }
    }),
    "ArtistTop_tmpl_etoneigefc_v1.0": dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 7320).then(__webpack_require__.bind(__webpack_require__, 97320));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(97320)
                ];
            }
        }
    })
};
var ArtistTop = function() {
    var ref = ArtistTop_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    var customDesign = useCustomDesign({
        type: "ArtistTop",
        artistId: state.artistId
    }).customDesign;
    if (!customDesign) return null;
    var ref1;
    var CustomTemplate = (customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId) ? (ref1 = artistTopCustomDesignMap[customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId]) !== null && ref1 !== void 0 ? ref1 : ArtistTopTemplate : ArtistTopTemplate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTemplate, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        state: state
    }, actions), {
        customDesign: (customDesign === null || customDesign === void 0 ? void 0 : customDesign.templateId) ? customDesign : undefined
    }));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Alert/Alert.js + 4 modules
var Alert = __webpack_require__(701);
;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeBoxSkeleton/index.tsx



var TradeBoxSkeleton = function(param) {
    var _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            position: "relative",
            overflow: "visible",
            width: fullWidth ? "100%" : 315
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    flex: 1,
                    alignItems: "center",
                    spacing: 2,
                    pb: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TradeArrow, {
                            sx: {
                                color: "grey.100"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName, {
                            reverse: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    flex: 1,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                            size: "x-small"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    mr: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: 144,
                                        lastWidth: 64,
                                        numberOfLine: 2
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    ml: 4,
                                    alignItems: "flex-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: 144,
                                        lastWidth: 64,
                                        numberOfLine: 2
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                            size: "x-small"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row-reverse",
                    sx: {
                        pt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: 48
                    })
                })
            ]
        })
    });
};
var AvatarWithName = function(param) {
    var _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: reverse ? "row-reverse" : "row",
        alignItems: "center",
        flex: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "circular",
                width: 28,
                height: 28
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "small",
                width: 80
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeTag/index.tsx






var TradeTag = function(param) {
    var status = param.status, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("myTrade").t;
    if (status === utoniq_core_schema/* TradeNegotiationStatus.Completed */._JF.Completed || status === utoniq_core_schema/* TradeNegotiationStatus.Error */._JF.Error) return null;
    var _obj;
    var statusData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress, {
        text: t("inProgress"),
        bgcolor: "primary.main"
    }), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* TradeNegotiationStatus.Dropped */._JF.Dropped, {
        text: t("dropped"),
        bgcolor: "grey.100"
    }), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* TradeNegotiationStatus.BrokenOff */._JF.BrokenOff, {
        text: t("brokenOff"),
        bgcolor: "grey.100"
    }), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* TradeNegotiationStatus.Agreed */._JF.Agreed, {
        text: t("agreed"),
        bgcolor: "secondary.main"
    }), _obj)[status];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle2",
            color: "white",
            children: statusData.text
        }),
        size: "small",
        sx: (0,src_object_spread/* default */.Z)({
            height: 20,
            minWidth: 72,
            bgcolor: statusData.bgcolor,
            borderRadius: "10px"
        }, sx)
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeBox/index.tsx









var TradeBox = function(param) {
    var trades = param.trades, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _imgSize = param.imgSize, imgSize = _imgSize === void 0 ? "small" : _imgSize, href = param.href, myUserId = param.myUserId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    /**
   * 自分が関連するトレードかどうか
   */ var isMyTrade = myUserId === ((ref = trades.request.requestedByUser) === null || ref === void 0 ? void 0 : ref.id) || myUserId === ((ref1 = trades.candidates) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.id);
    var _requestedByUser, _user, ref25, ref26;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            pt: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                position: "relative",
                overflow: "visible",
                width: fullWidth ? "100%" : 315,
                borderRadius: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeTag, {
                    status: trades.status,
                    sx: {
                        position: "absolute",
                        top: -10,
                        left: 20,
                        zIndex: 2
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                    href: href,
                    onClick: handleLoginModal(),
                    sx: {
                        borderRadius: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                flex: 1,
                                alignItems: "center",
                                spacing: 2,
                                sx: {
                                    pb: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBox_AvatarWithName, {
                                        user: (_requestedByUser = trades.request.requestedByUser) !== null && _requestedByUser !== void 0 ? _requestedByUser : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TradeArrow, {
                                        sx: {
                                            color: "grey.200"
                                        },
                                        status: trades.status
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBox_AvatarWithName, {
                                        user: (_user = trades.candidates[0].user) !== null && _user !== void 0 ? _user : null,
                                        reverse: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                flex: 1,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        src: (ref25 = (ref5 = (ref4 = trades.request) === null || ref4 === void 0 ? void 0 : ref4.providableItems[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.thumbnail) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.front) === null || ref8 === void 0 ? void 0 : ref8.mediumUri) !== null && ref25 !== void 0 ? ref25 : "",
                                        size: imgSize,
                                        alignItems: "flex-start"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        justifyContent: "space-between",
                                        sx: {
                                            maxWidth: "calc(100% - ".concat(imgSize === "small" ? 136 : 112, "px)")
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    mr: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle2",
                                                            sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                                                                whiteSpace: "nowrap",
                                                                maxWidth: "100%"
                                                            }),
                                                            children: trades.request.providableItems[0].item.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 2,
                                                        alignItems: "center",
                                                        sx: {
                                                            pt: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "overline",
                                                                color: "text.secondary",
                                                                children: trades.request.providableItems[0].itemSerial.formattedSerialNumber
                                                            }),
                                                            /**
                       * @description
                       * 自分が関わるトレードの場合、トレード元・トレード先アイテムの自分の保持枚数を表示する
                       */ isMyTrade && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                                                        orientation: "vertical",
                                                                        sx: {
                                                                            height: 10
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                                        direction: "row",
                                                                        spacing: 1,
                                                                        alignItems: "center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.OwnedItems, {
                                                                                fontSize: "xSmall"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                                variant: "overline",
                                                                                color: "text.secondary",
                                                                                children: ((ref10 = (ref9 = trades.request.providableItems) === null || ref9 === void 0 ? void 0 : ref9[0].item) === null || ref10 === void 0 ? void 0 : ref10.ownedCount) ? t("ownedCount", {
                                                                                    ownedCount: (ref12 = (ref11 = trades.request.providableItems) === null || ref11 === void 0 ? void 0 : ref11[0].item) === null || ref12 === void 0 ? void 0 : ref12.ownedCount
                                                                                }) : t("notOwned")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    ml: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        align: "right",
                                                        sx: {
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            maxWidth: "100%"
                                                        },
                                                        children: trades.candidates[0].candidateItems[0].item.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 2,
                                                        alignItems: "center",
                                                        justifyContent: "flex-end",
                                                        sx: {
                                                            pt: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "overline",
                                                                color: "text.secondary",
                                                                sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                                                                    maxWidth: "100%"
                                                                }),
                                                                children: trades.candidates[0].candidateItems[0].itemSerial.formattedSerialNumber
                                                            }),
                                                            /**
                       * @description
                       * 自分が関わるトレードの場合、トレード元・トレード先アイテムの自分の保持枚数を表示する
                       */ isMyTrade && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                                                        orientation: "vertical",
                                                                        sx: {
                                                                            height: 10
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                                        direction: "row",
                                                                        spacing: 1,
                                                                        alignItems: "center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.OwnedItems, {
                                                                                fontSize: "xSmall"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                                variant: "overline",
                                                                                color: "text.secondary",
                                                                                children: ((ref13 = trades === null || trades === void 0 ? void 0 : trades.candidates[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.candidateItems) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.item) === null || ref16 === void 0 ? void 0 : ref16.ownedCount) ? t("ownedCount", {
                                                                                    ownedCount: (ref17 = trades === null || trades === void 0 ? void 0 : trades.candidates[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.candidateItems) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.item) === null || ref20 === void 0 ? void 0 : ref20.ownedCount
                                                                                }) : t("notOwned")
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        src: (ref26 = (ref21 = trades.candidates[0].candidateItems[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.thumbnail) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.front) === null || ref24 === void 0 ? void 0 : ref24.mediumUri) !== null && ref26 !== void 0 ? ref26 : "",
                                        size: imgSize,
                                        alignItems: "flex-end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "flex-end",
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    textAlign: "right",
                                    color: "text.secondary",
                                    children: trades.formattedCreatedAt
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var TradeBox_AvatarWithName = function(param) {
    var user = param.user, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    var ref;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: reverse ? "row-reverse" : "row",
        alignItems: "center",
        flex: "1 1 0",
        spacing: 2,
        sx: {
            textDecoration: "none",
            width: "calc((100% - 40px) / 2)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                src: (ref1 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                alt: (ref2 = user === null || user === void 0 ? void 0 : user.displayName) !== null && ref2 !== void 0 ? ref2 : "",
                sx: {
                    width: 28,
                    height: 28
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                    maxWidth: "100%",
                    textTransform: "none"
                }),
                children: user === null || user === void 0 ? void 0 : user.displayName
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistTrade/template/index.tsx














var ArtistTradeTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTrade").t;
    var ref6 = (0,react.useState)(false), openModal = ref6[0], setOpenModal = ref6[1];
    var ref7 = (0,react.useState)(false), openSideMenu = ref7[0], setOpenSideMenu = ref7[1];
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "artist",
                    props: {
                        isLive: !!state.liveStreamId,
                        hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                        unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                    }
                },
                header: {
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                        edge: "end",
                        color: "primary",
                        onClick: function() {
                            return setOpenModal(true);
                        }
                    }),
                    left: state.user && config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                        edge: "start",
                        onClick: function() {
                            return setOpenSideMenu(!openSideMenu);
                        },
                        color: "icon.line",
                        bgcolor: "icon.background",
                        badge: ((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.hasUnappliedDeliveryItems) || ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasWaitingPaymentItems) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount)
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                        title: [
                            routerNames.ArtistTrade,
                            state.artistName
                        ]
                    }),
                    state.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingDuringTradingCell, {
                        myInProgressTrades: state.myInProgressTrades,
                        loading: state.loading,
                        myUserId: state.user.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EveryOneTradeCell, {
                        loading: state.loading || state.refetching,
                        hasNextPage: state.hasNextPage,
                        trades: state.trades,
                        onFetchMore: onFetchMore,
                        myUserId: (ref8 = (ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref8 !== void 0 ? ref8 : ""
                    }),
                    !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_BaseCell, {
                        artistId: state.artistId,
                        isLoggedIn: !!state.user
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        followArtists: state.followArtists,
                        memberArtists: state.memberArtists,
                        open: openSideMenu,
                        onClose: function() {
                            return setOpenSideMenu(false);
                        },
                        user: state.user,
                        isArtist: state.isArtist
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeHelpModal, {
                open: openModal,
                onClose: function() {
                    return setOpenModal(false);
                }
            })
        ]
    });
};
var TradingDuringTradingCell = function(param) {
    var myInProgressTrades = param.myInProgressTrades, loading = param.loading, myUserId = param.myUserId;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTrade").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            loading: loading,
            sx: {
                mb: -6
            },
            LoadingComponent: TradeBoxSkeleton,
            loadingItemLength: 5,
            title: t("newMyTradeTitle"),
            titleTypographyProps: {
                variant: "h4"
            },
            items: myInProgressTrades,
            trans: t("viewTradeBox"),
            transTypographyProps: {
                variant: "button"
            },
            listHref: routerPages.MyTrade,
            EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pb: 4,
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body1",
                        color: "text.secondary",
                        sx: {
                            py: 6
                        },
                        align: "center",
                        children: t("tradeEmptyMessage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        icon: false,
                        sx: {
                            bgcolor: "grey.50",
                            borderRadius: 2,
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "text.secondary",
                            children: t("tradeEmptyDesc")
                        })
                    })
                ]
            }),
            renderItem: function(trade, i) {
                if (!trade) return;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    timeout: 225,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBox, {
                        fullWidth: false,
                        trades: trade,
                        imgSize: "x-small",
                        href: generatePath(routerPages.MyTradeDetail, {
                            tradeNegotiationId: trade.id
                        }),
                        myUserId: myUserId
                    })
                }, i);
            }
        })
    });
};
var EveryOneTradeCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, trades = param.trades, onFetchMore = param.onFetchMore, myUserId = param.myUserId;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTrade").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    py: 2
                },
                children: t("everyOneTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    loading: loading,
                    hasNextPage: hasNextPage,
                    componentProps: {
                        spacing: 4
                    },
                    onFetchMore: onFetchMore,
                    emptyMessage: t("tradeEmptyMessage"),
                    nodes: trades === null || trades === void 0 ? void 0 : trades.edges.map(function(param, i) {
                        var node = param.node;
                        if (!node) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBox, {
                            href: generatePath(routerPages.UserTradeDetail, {
                                tradeNegotiationId: node.id
                            }),
                            myUserId: myUserId,
                            fullWidth: true,
                            trades: node
                        }, i);
                    }),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBoxSkeleton, {
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBoxSkeleton, {
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBoxSkeleton, {
                                fullWidth: true
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var TradeHelpModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var theme = config_config/* config.theme.dark */.v.theme.dark ? "dark" : "light";
    var t = (0,core_i18n/* useTranslation */.$G)("artistTrade").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("howToTrade"),
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: onClose
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
                    sx: {
                        bgcolor: "background.default"
                    },
                    defaultProps: {
                        sx: {
                            bgcolor: "grey.50"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        target: "common",
                        width: "100%",
                        src: "images/info/artistTradeInfo--".concat(theme, ".png")
                    })
                })
            })
        })
    });
};
var template_BaseCell = function(param) {
    var artistId = param.artistId, isLoggedIn = param.isLoggedIn;
    var t = (0,core_i18n/* useTranslation */.$G)("artistTrade").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 76,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: handleLoginModal(function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_trade", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: artistId
                        });
                        setOpen(true);
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TradeRequest, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CampaignModal, {
                type: "square",
                open: open,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                    width: "100%",
                    height: "100%",
                    src: "images/info/TradeRequestInfo.png",
                    target: "common"
                }),
                onClose: function() {
                    return setOpen(false);
                },
                content: t("tradeRequestModalContent"),
                ok: {
                    title: t("tradeRequestModalOK"),
                    onClick: function onClick() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_toMyCollection", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: artistId
                        });
                        router.push(generatePath(routerPages.ArtistCollections, {
                            artistId: artistId
                        }));
                    }
                },
                cancel: {
                    title: t("tradeRequestModalCancel")
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistTrade/viewModel.ts




function ArtistTrade_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistTrade($artistId: ID!, $pageInput: PageInput) {\n    tradeNegotiationsMyRequests(\n      artistId: $artistId\n      status: [in_progress, broken_off, dropped, agreed]\n    ) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n    }\n    tradeMyCandidates(\n      artistId: $artistId\n      status: [in_progress, rejected, accepted, expired, dropped]\n    ) {\n      edges {\n        node {\n          ... on TradeCandidate {\n            tradeNegotiation {\n              ...TradeBox\n            }\n          }\n        }\n      }\n    }\n    artistTradeNegotiations(artistId: $artistId, pageInput: $pageInput) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistTrade_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArtistTrade_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistTrade($artistId: ID!, $pageInput: PageInput) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n    tradeNegotiationsMyRequests(\n      artistId: $artistId\n      status: [in_progress, broken_off, dropped, agreed]\n    ) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n    }\n    tradeMyCandidates(\n      artistId: $artistId\n      status: [in_progress, rejected, accepted, expired, dropped]\n    ) {\n      edges {\n        node {\n          ... on TradeCandidate {\n            tradeNegotiation {\n              ...TradeBox\n            }\n          }\n        }\n      }\n    }\n    artistTradeNegotiations(artistId: $artistId, pageInput: $pageInput) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistTrade_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArtistTrade_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistTradeForGuest($artistId: ID!, $pageInput: PageInput) {\n    tradeNegotiationsMyRequests(\n      artistId: $artistId\n      status: [in_progress, broken_off, dropped, agreed]\n    ) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n    }\n    tradeMyCandidates(\n      artistId: $artistId\n      status: [in_progress, rejected, accepted, expired, dropped]\n    ) {\n      edges {\n        node {\n          ... on TradeCandidate {\n            tradeNegotiation {\n              ...TradeBox\n            }\n          }\n        }\n      }\n    }\n    artistTradeNegotiations(artistId: $artistId, pageInput: $pageInput) {\n      edges {\n        node {\n          ...TradeBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      id\n      displayName\n      currentLive {\n        id\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ArtistTrade_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ArtistTrade_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref14.user, userClaims = ref14.userClaims;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_TRADE,
        variables: {
            artistId: artistId,
            pageInput: {
                limit: 10
            }
        },
        fields: [
            {
                fieldName: "tradeNegotiationsMyRequests",
                fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA
            },
            {
                fieldName: "artistTradeNegotiations",
                fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA
            },
            {
                fieldName: "tradeMyCandidates",
                fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA,
                uniqByKey: "node.tradeNegotiation.__ref",
                generateNode: function generateNode(cache, data) {
                    return {
                        __typename: "TradeCandidate",
                        tradeNegotiation: cache.writeFragment({
                            fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA,
                            data: get_default()(data, "tradeNegotiation")
                        })
                    };
                }
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref15 = (0,useQuery/* useQuery */.aM)(ARTIST_TRADE, {
        variables: {
            artistId: artistId
        },
        skip: !currentUser,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref15.data, fetchMore = ref15.fetchMore, networkStatus = ref15.networkStatus;
    var isNextFetch = !!data;
    var ref16 = (0,useQuery/* useQuery */.aM)(ArtistTrade_viewModel_QUERY_FOR_GUEST, {
        variables: {
            artistId: artistId
        },
        skip: !!currentUser,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), dataForGuest = ref16.data, networkStatusForGuest = ref16.networkStatus, fetchMoreForGuest = ref16.fetchMore;
    var isNextFetchForGuest = !!dataForGuest;
    var pageInfo = (ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.artistTradeNegotiations) === null || ref1 === void 0 ? void 0 : ref1.pageInfo;
    var ref17;
    var myCandidateTrades = (ref17 = (ref2 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tradeMyCandidates) === null || ref3 === void 0 ? void 0 : ref3.edges.map(function(param) {
        var node = param.node;
        return node.tradeNegotiation;
    })) !== null && ref17 !== void 0 ? ref17 : [];
    var ref18;
    var myRequestTrades = (ref18 = (ref4 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.tradeNegotiationsMyRequests) === null || ref5 === void 0 ? void 0 : ref5.edges.map(function(param) {
        var node = param.node;
        return node;
    })) !== null && ref18 !== void 0 ? ref18 : [];
    var myInProgressTrades = (0,src_to_consumable_array/* default */.Z)(myRequestTrades).concat((0,src_to_consumable_array/* default */.Z)(myCandidateTrades));
    var ref19, ref20, ref21, ref22, ref23, ref24;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch || networkStatusForGuest === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetchForGuest,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore || networkStatusForGuest === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: (ref19 = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) !== null && ref19 !== void 0 ? ref19 : false,
            artistId: artistId,
            artistName: (data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : ref6.displayName) || "",
            // 取引中のトレード
            myInProgressTrades: myInProgressTrades,
            // みんなのトレード
            trades: (ref21 = (ref20 = data === null || data === void 0 ? void 0 : data.artistTradeNegotiations) !== null && ref20 !== void 0 ? ref20 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.artistTradeNegotiations) !== null && ref21 !== void 0 ? ref21 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref7 = userClaims.orgs) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[config_config/* config.organizationId */.v.organizationId]) === null || ref8 === void 0 ? void 0 : ref8.artist),
            followArtists: (ref22 = data === null || data === void 0 ? void 0 : (ref9 = data.user) === null || ref9 === void 0 ? void 0 : ref9.organizationFollowees) !== null && ref22 !== void 0 ? ref22 : null,
            memberArtists: (ref23 = data === null || data === void 0 ? void 0 : (ref10 = data.user) === null || ref10 === void 0 ? void 0 : ref10.organizationPatrons) !== null && ref23 !== void 0 ? ref23 : null,
            user: (ref24 = data === null || data === void 0 ? void 0 : data.user) !== null && ref24 !== void 0 ? ref24 : null,
            liveStreamId: (ref11 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.artist) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.currentLive) === null || ref13 === void 0 ? void 0 : ref13.id
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!currentUser) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreForGuest({
                                        variables: {
                                            pageInput: {
                                                cursor: (ref = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor) !== null && ref !== void 0 ? ref : null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: (ref1 = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor) !== null && ref1 !== void 0 ? ref1 : null
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ARTIST_TRADE = (0,lib/* gql */.Ps)(ArtistTrade_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* TradeBoxFragmentDoc */.CCA, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_TRADE = (0,lib/* gql */.Ps)(ArtistTrade_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* TradeBoxFragmentDoc */.CCA);
var ArtistTrade_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(ArtistTrade_viewModel_templateObject2(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* TradeBoxFragmentDoc */.CCA);

;// CONCATENATED MODULE: ./src/components/pages/ArtistTrade/index.tsx



/**
 * ArtistTrade Page
 * Implemented as a practical sample.
 */ var ArtistTrade = function() {
    var ref = ArtistTrade_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistTradeTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/pages/AutoFollowSettings/template/index.tsx







var AutoFollowSettingsTemplate = function(param) {
    var state = param.state, onToggle = param.onToggle;
    var t = (0,core_i18n/* useTranslation */.$G)("autoFollowSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.AutoFollowSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: routerPages.Setting
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            divider: true,
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                checked: state.autoFollow,
                                onChange: function() {
                                    return onToggle(!state.autoFollow);
                                }
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                primary: t("autoFollow"),
                                slotProps: {
                                    primary: {
                                        variant: "body1"
                                    }
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var NoteCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("autoFollowSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 4,
            pb: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle2",
            color: "text.hint",
            children: t("note")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/AutoFollowSettings/viewModel.ts




function AutoFollowSettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AutoFollowSettings {\n    user {\n      id\n      settings {\n        follow {\n          autoFollow\n        }\n      }\n    }\n  }\n"
    ]);
    AutoFollowSettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutoFollowSettings_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateUserFollowSettings($inputs: UserFollowSettingsInput!) {\n    updateUserFollowSettings(inputs: $inputs) {\n      id\n      settings {\n        follow {\n          autoFollow\n        }\n      }\n    }\n  }\n"
    ]);
    AutoFollowSettings_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var AutoFollowSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var data = (0,useQuery/* useQuery */.aM)(AutoFollowSettings_viewModel_QUERY).data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_USER_FOLLOW_SETTINGS), 1), updateUserFollowSettings = ref3[0];
    return {
        state: {
            autoFollow: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.follow) === null || ref2 === void 0 ? void 0 : ref2.autoFollow)
        },
        actions: {
            onToggle: function onToggle(autoFollow) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserFollowSettings({
                                        variables: {
                                            inputs: {
                                                autoFollow: autoFollow
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var inputs = param.inputs;
                                            var ref;
                                            var ref1;
                                            return {
                                                updateUserFollowSettings: {
                                                    id: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "",
                                                    settings: {
                                                        follow: {
                                                            autoFollow: inputs.autoFollow,
                                                            __typename: "Follow"
                                                        },
                                                        __typename: "UserSettings"
                                                    },
                                                    __typename: "User"
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var AutoFollowSettings_viewModel_QUERY = (0,lib/* gql */.Ps)(AutoFollowSettings_viewModel_templateObject());
var UPDATE_USER_FOLLOW_SETTINGS = (0,lib/* gql */.Ps)(AutoFollowSettings_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/AutoFollowSettings/index.tsx




/**
 * AutoFollowSettings Page
 * Implemented as a practical sample.
 */ var AutoFollowSettings = function() {
    var ref = AutoFollowSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoFollowSettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ResaleItem/index.tsx



var ResaleItem = function(param) {
    var children = param.children, title = param.title, Icon = param.Icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 3,
            sx: {
                pb: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    sx: {
                        bgcolor: "grey.50",
                        py: 1,
                        px: 2
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            fontSize: "small",
                            sx: {
                                color: "grey.600"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "text.secondary",
                            children: title
                        })
                    ]
                }),
                children
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(95512);
;// CONCATENATED MODULE: ./src/components/pages/BankCreate/template/BankCreateForm.tsx











var BankCreateForm_schema = function(o) {
    return {
        bankName: o.string().label((0,core_form/* tLabel */.TQ)("bankCreate.bankName")),
        branchName: o.string().label((0,core_form/* tLabel */.TQ)("bankCreate.branchName")),
        branchCode: o.string().length(3).regex(/^[0-9]+$/).messages({
            "string.pattern.base": (0,core_form/* tLabel */.TQ)("bankCreate.branchCodePattern")
        }).label((0,core_form/* tLabel */.TQ)("bankCreate.branchCode")),
        accountType: o.string().label((0,core_form/* tLabel */.TQ)("bankCreate.accountType")),
        accountNumber: o.string().length(7).regex(/^[0-9]+$/).messages({
            "string.pattern.base": (0,core_form/* tLabel */.TQ)("bankCreate.accountNumberPattern")
        }).label((0,core_form/* tLabel */.TQ)("bankCreate.accountNumber")),
        accountHolderName: o.string().regex(/^[ァ-ヴ]+$/).messages({
            "string.pattern.base": (0,core_form/* tLabel */.TQ)("bankCreate.accountHolderNamePattern")
        }).label((0,core_form/* tLabel */.TQ)("bankCreate.accountHolderName"))
    };
};
var BankCreateForm = function(param) {
    var bank = param.bank, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = (0,core_form/* useForm */.cI)({
        schema: BankCreateForm_schema,
        defaultValues: BankCreateForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, register = ref.register, watch = ref.watch, setValue = ref.setValue, reset = ref.reset;
    var accountTypeWatch = watch("accountType");
    (0,react.useEffect)(function() {
        if (!bank) return;
        reset({
            bankName: bank.bankName,
            branchName: bank.branchName,
            branchCode: bank.branchCode,
            accountType: bank.accountType,
            accountNumber: bank.accountNumber,
            accountHolderName: bank.accountHolderName
        });
    }, [
        bank,
        reset
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(input) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(input)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.bankName
            }, register("bankName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.branchName
            }, register("branchName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors === null || errors === void 0 ? void 0 : errors.branchCode
            }, register("branchCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCell, {
                value: accountTypeWatch,
                error: errors === null || errors === void 0 ? void 0 : errors.accountType,
                setValue: setValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors === null || errors === void 0 ? void 0 : errors.accountNumber
            }, register("accountNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.accountHolderName
            }, register("accountHolderName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    px: 4,
                    pb: 8
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 244
                        },
                        loading: isSubmitting,
                        disabled: isSubmitting,
                        onClick: handleOnSubmit,
                        children: t("submit")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: function() {
                            return router.goBack();
                        },
                        children: t("back")
                    })
                ]
            })
        ]
    });
};
var BankCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var SelectCell = function(param) {
    var value = param.value, setValue = param.setValue, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            mb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            sx: {
                pb: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.secondary",
                    children: t("accountTypeTitle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                            listItems: [
                                {
                                    value: utoniq_core_schema/* BankAccountType.Futsu */.Jb8.Futsu,
                                    label: t("futsu")
                                },
                                {
                                    value: utoniq_core_schema/* BankAccountType.Toza */.Jb8.Toza,
                                    label: t("toza")
                                }, 
                            ],
                            placeholder: t("accountTypePlaceholder"),
                            value: value,
                            onChange: function(value) {
                                return setValue("accountType", value);
                            },
                            formControlProps: {
                                sx: {
                                    minWidth: 120,
                                    width: 120,
                                    bgcolor: "grey.50",
                                    minHeight: "auto"
                                }
                            }
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: error === null || error === void 0 ? void 0 : error.message
                        })
                    ]
                })
            ]
        })
    });
};
var BankCreateForm_defaultValues = {
    bankName: "",
    branchName: "",
    branchCode: "",
    accountNumber: "",
    accountType: utoniq_core_schema/* BankAccountType.Futsu */.Jb8.Futsu,
    accountHolderName: ""
};

;// CONCATENATED MODULE: ./src/components/pages/BankCreate/template/index.tsx










var BankCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.BankCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.Setting,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentBankCell, {
                        bank: state.bank
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateForm, {
                        bank: state.bank,
                        onSubmit: onSubmit
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BankNoteCell, {})
                ]
            })
        ]
    });
};
var CurrentBankCell = function(param) {
    var bank = param.bank;
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.secondary",
                    children: t("registeredTransferAccount")
                }),
                !bank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.secondary",
                    children: t("registeredTransferAccountEmpty")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    children: t("registeredTransferAccountValue", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, bank), {
                        accountType: t(bank.accountType)
                    }))
                })
            ]
        })
    });
};
var BankNoteCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
            title: t("bankNoteTitle"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("bankNoteDesc1")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.jp-bank.japanpost.jp/kojin/sokin/furikomi/kouza/kj_sk_fm_kz_1.html",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            color: "primary.main",
                            variant: "caption",
                            children: t("bankNoteDescLink")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("bankNoteDesc2")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/BankCreate/viewModel.ts




function BankCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query bankCreate {\n    user {\n      id\n      bank {\n        accountHolderName\n        accountNumber\n        accountType\n        bankName\n        branchCode\n        branchName\n      }\n    }\n  }\n"
    ]);
    BankCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BankCreate_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation registerUserBank($inputs: UserBankInput!) {\n    registerUserBank(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    BankCreate_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 *
 */ var BankCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("bankCreate").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(BankCreate_viewModel_QUERY).data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REGISTER_USER_BANK), 2), registerUserBank = ref3[0], ref4 = ref3[1], submitting = ref4.loading;
    var ref5;
    return {
        state: {
            bank: (ref5 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.bank) !== null && ref5 !== void 0 ? ref5 : null,
            submitting: submitting
        },
        actions: {
            onSubmit: function onSubmit(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            registerUserBank({
                                variables: {
                                    inputs: inputs
                                }
                            }).then(function() {
                                showMessage(t("success"));
                                return router.goBack(routerPages.AccountSetting);
                            }).catch(showError)
                        ];
                    });
                })();
            }
        }
    };
});
var BankCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(BankCreate_viewModel_templateObject());
var REGISTER_USER_BANK = (0,lib/* gql */.Ps)(BankCreate_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/BankCreate/index.tsx




/**
 * BankCreate Page
 * Implemented as a practical sample.
 */ var BankCreate = function() {
    var ref = BankCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(37453);
// EXTERNAL MODULE: ../../node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(53711);
// EXTERNAL MODULE: ../../node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(6341);
;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankingUserDataSkeleton/index.tsx




var RankingUserDataSkeleton = function(param) {
    var isSolo = param.isSolo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 3,
        direction: "row",
        sx: (0,src_object_spread/* default */.Z)({
            pt: 3,
            borderRadius: 1
        }, isSolo ? {
            bgcolor: "grey.50",
            px: 3
        } : {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 36,
                height: 36
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        sx: {
                            pb: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 36,
                                height: 36
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "50%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "25%"
                                    })
                                ]
                            })
                        ]
                    }),
                    !isSolo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 1
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/campaign/Rank/index.tsx




var Rank_Rank = function(param) {
    var rank = param.rank;
    var color = (0,react.useMemo)(function() {
        switch(rank){
            case 1:
                return "primary.main";
            case 2:
                return "grey.700";
            case 3:
                return "grey.200";
        }
    }, [
        rank
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        sx: {
            width: 40
        },
        children: [
            rank && rank <= 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Rank, {
                fontSize: "medium",
                sx: {
                    color: color
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: rank
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankingUserData/index.tsx






var RankingUserData = function(param) {
    var ranker = param.ranker, isSolo = param.isSolo, onClick = param.onClick;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var url = (0,react.useMemo)(function() {
        if ("artistId" in ranker) {
            var _artistId;
            return generatePath(routerPages.ArtistTop, {
                artistId: (_artistId = ranker.artistId) !== null && _artistId !== void 0 ? _artistId : "#"
            });
        }
        if ("userId" in ranker) {
            var _userId;
            return generatePath(routerPages.UserProfile, {
                userId: (_userId = ranker.userId) !== null && _userId !== void 0 ? _userId : "#"
            });
        }
        return "";
    }, [
        generatePath,
        ranker,
        routerPages.ArtistTop,
        routerPages.UserProfile
    ]);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: url,
        onClick: onClick,
        underline: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 3,
            sx: (0,src_object_spread/* default */.Z)({}, isSolo ? {
                bgcolor: "grey.100",
                borderRadius: 1,
                px: 3
            } : {}),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank_Rank, {
                    rank: ranker.rank
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    flex: 1,
                    sx: {
                        borderBottom: "1px solid",
                        borderColor: "grey.100",
                        pb: 3,
                        pt: 2
                    },
                    spacing: 3,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: (ref2 = (ref = ranker.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                            sx: {
                                width: 36,
                                height: 36
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: ranker.displayName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    sx: {
                                        textTransform: "lowercase"
                                    },
                                    children: [
                                        ranker.point,
                                        "pt"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CampaignDetail/template/index.tsx
















var CampaignDetailTemplate = function(param) {
    var state = param.state, onClickTab = param.onClickTab, onFetchCampaignRanking = param.onFetchCampaignRanking;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("campaignDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref6.routerNames, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var ref7 = (0,react.useState)(0), value = ref7[0], setValue = ref7[1];
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = state.campaign) === null || ref === void 0 ? void 0 : ref.rankingType) === utoniq_core_schema/* CampaignRankingType.User */.p8D.User && state.campaignUserRanking) {
            setValue(1);
        }
    }, [
        (ref = state.campaign) === null || ref === void 0 ? void 0 : ref.rankingType,
        state.campaignUserRanking
    ]);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = state.campaign) === null || ref === void 0 ? void 0 : ref.rankingType)) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            onFetchCampaignRanking(state.campaign.rankingType)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref1 = state.campaign) === null || ref1 === void 0 ? void 0 : ref1.rankingType
    ]);
    var handleChangeValue = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (newValue === null) {
                            return [
                                2
                            ];
                        }
                        setValue(newValue);
                        return [
                            4,
                            onClickTab(!!newValue)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeValue(newValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.GlobalEvents, {
                tab: "campaign"
            }),
            title: (ref2 = state.campaign) === null || ref2 === void 0 ? void 0 : ref2.title
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.CampaignDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_BannerCell, {
                            image: (ref8 = (ref3 = state.campaign) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnail) === null || ref4 === void 0 ? void 0 : ref4.mediumUri) !== null && ref8 !== void 0 ? ref8 : "",
                            loading: state.loading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionCell, {
                            campaign: state.campaign,
                            campaignRanking: state.campaignArtistRanking || state.campaignUserRanking,
                            loading: state.loading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Segment, {
                                labels: [
                                    t("artist"),
                                    t("user")
                                ],
                                value: value,
                                onChange: handleChangeValue,
                                hiddenLabel: ((ref5 = state.campaign) === null || ref5 === void 0 ? void 0 : ref5.rankingType) !== "both" && !state.loading,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignRankingCell, {
                                        loading: state.loading || state.campaignArtistRankGetting,
                                        campaignRanking: state.campaignArtistRanking,
                                        isArtist: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignRankingCell, {
                                        loading: state.loading || state.campaignUserRankGetting,
                                        campaignRanking: state.campaignUserRanking
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var template_BannerCell = function(param) {
    var image = param.image, loading = param.loading;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            sx: {
                width: "100%",
                height: 212
            }
        });
    }
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%",
            height: 212,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundImage: "url('".concat(image, "')")
        }
    });
};
var DescriptionCell = function(param) {
    var campaign = param.campaign, campaignRanking = param.campaignRanking, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("campaignDetail").t;
    var acquisitionMethod = (0,react.useMemo)(function() {
        var ref;
        // check condition if there are no acquisitionPoints in the campaign then return empty string
        if (!(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.acquisitionPoints) === null || ref === void 0 ? void 0 : ref.length)) {
            return "";
        }
        // check if ItemRarity exists in array of types ['item_rarity_common', 'item_rarity_rare', 'item_rarity_superrare'] ?
        var hasItemRarity = campaign.acquisitionPoints.some(function(param) {
            var type = param.type;
            return [
                utoniq_core_schema/* CampaignAcquisitionType.ItemRarityRare */.cqg.ItemRarityRare,
                utoniq_core_schema/* CampaignAcquisitionType.ItemRarityCommon */.cqg.ItemRarityCommon,
                utoniq_core_schema/* CampaignAcquisitionType.ItemRaritySuperrare */.cqg.ItemRaritySuperrare, 
            ].indexOf(type) >= 0;
        });
        if (hasItemRarity) {
            // if ItemRarity exists in an array of types ['item_rarity_common', 'item_rarity_rare', 'item_rarity_superrare'],
            // the string '保有カードのレアリティに基づく獲得ポイント' is returned.
            return t("earnedPoints");
        }
        // if not of the type above, will return 'ガチャを回す {{number}}pt'
        return campaign.acquisitionPoints.map(function(param) {
            var type = param.type, point = param.point;
            return type === utoniq_core_schema/* CampaignAcquisitionType.GachaRoll */.cqg.GachaRoll ? "".concat(t("gachaRoll", {
                number: point
            }), " ") : t("itemBuy", {
                number: point
            });
        }).join(" ");
    }, [
        campaign === null || campaign === void 0 ? void 0 : campaign.acquisitionPoints,
        t
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 6,
                    px: 4
                },
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "25%"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            px: 7,
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            sx: {
                p: 4,
                bgcolor: "transparent",
                backgroundImage: "unset",
                border: "1px solid",
                borderColor: "grey.100",
                "&:last-of-type, &:first-of-type": {
                    borderRadius: 2
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        fontSize: "medium"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    t("holdingPeriod"),
                                    "：",
                                    campaign === null || campaign === void 0 ? void 0 : campaign.formattedStartedAt,
                                    " 〜",
                                    " ",
                                    campaign === null || campaign === void 0 ? void 0 : campaign.formattedEndedAt
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    t("acquisitionMethod"),
                                    "：",
                                    acquisitionMethod
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("aggregationDuration")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mr: 6,
                            mb: 4
                        },
                        children: campaign === null || campaign === void 0 ? void 0 : campaign.description
                    })
                })
            ]
        })
    });
};
var CampaignRankingCell = function(param) {
    var loading = param.loading, campaignRanking = param.campaignRanking;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("campaignDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var getUserIdOrArtistId = (0,react.useCallback)(function(ranking) {
        if (!ranking) {
            return {};
        }
        if ("artistId" in ranking) {
            return {
                artistId: ranking.artistId
            };
        }
        if ("userId" in ranking) {
            return {
                userId: ranking.userId
            };
        }
        return {};
    }, []);
    // check condition for render loading
    if (loading && campaignRanking === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataSkeleton, {
                            isSolo: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: Array.from(Array(4).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserDataSkeleton, {}, key);
                        })
                    })
                ]
            })
        });
    }
    // check condition for render empty
    if (!loading && (campaignRanking === null || campaignRanking === void 0 ? void 0 : (ref = campaignRanking.ranker) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                py: 6
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                color: "text.secondary",
                align: "center",
                children: t("rankerEmptyMessage")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            children: [
                (campaignRanking === null || campaignRanking === void 0 ? void 0 : campaignRanking.myRank) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        py: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserData, {
                        isSolo: true,
                        ranker: campaignRanking.myRank,
                        onClick: function() {
                            var ref = getUserIdOrArtistId(campaignRanking === null || campaignRanking === void 0 ? void 0 : campaignRanking.myRank), artistId = ref.artistId, userId = ref.userId;
                            var _obj;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", (_obj = {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey
                            }, (0,_define_property/* default */.Z)(_obj, artistId ? "artistId" : "userId", artistId !== null && artistId !== void 0 ? artistId : userId), (0,_define_property/* default */.Z)(_obj, "name", "campaignDetail"), (0,_define_property/* default */.Z)(_obj, "tab", artistId ? "artist" : "user"), _obj));
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    children: campaignRanking === null || campaignRanking === void 0 ? void 0 : campaignRanking.ranker.map(function(ranker, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingUserData, {
                                ranker: ranker,
                                onClick: function() {
                                    var ref = getUserIdOrArtistId(ranker), artistId = ref.artistId, userId = ref.userId;
                                    var _obj;
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", (_obj = {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey
                                    }, (0,_define_property/* default */.Z)(_obj, artistId ? "artistId" : "userId", artistId !== null && artistId !== void 0 ? artistId : userId), (0,_define_property/* default */.Z)(_obj, "name", "campaignDetail"), (0,_define_property/* default */.Z)(_obj, "tab", artistId ? "artist" : "user"), _obj));
                                }
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CampaignDetail/viewModel.ts




function CampaignDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CampaignDetail($code: String) {\n    campaign(code: $code) {\n      ...CampaignDetail\n    }\n  }\n  ",
        "\n"
    ]);
    CampaignDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CampaignDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CampaignUserRanking($inputs: CampaignRankingInput) {\n    campaignRanking(inputs: $inputs) {\n      ... on UserCampaignRanking {\n        ...UserCampaignRanking\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CampaignDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CampaignDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CampaignArtistRanking($inputs: CampaignRankingInput) {\n    campaignRanking(inputs: $inputs) {\n      ... on ArtistCampaignRanking {\n        ...ArtistCampaignRanking\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CampaignDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var CampaignDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref = (0,useQuery/* useQuery */.aM)(CampaignDetail_viewModel_QUERY, {
        variables: {
            code: router.query.campaignId
        }
    }), campaignDetail = ref.data, loading = ref.loading;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(CAMPAIGN_ARTIST_RANKING, {
        variables: {
            inputs: {
                code: router.query.campaignId,
                type: utoniq_core_schema/* CampaignRankingType.Artist */.p8D.Artist,
                artistId: artistId
            }
        },
        onCompleted: function onCompleted(param) {
            var campaignRanking = param.campaignRanking;
            if (!(campaignRanking === null || campaignRanking === void 0 ? void 0 : campaignRanking.ranker.length)) analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                campaignId: router.query.campaignId,
                name: "campaignDetail"
            });
        }
    }), 2), getCampaignArtistRanking = ref1[0], ref2 = ref1[1], campaignArtistRanking = ref2.data, campaignArtistRankGetting = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(CAMPAIGN_USER_RANKING, {
        variables: {
            inputs: {
                code: router.query.campaignId,
                type: utoniq_core_schema/* CampaignRankingType.User */.p8D.User,
                artistId: artistId
            }
        },
        onCompleted: function onCompleted(param) {
            var campaignRanking = param.campaignRanking;
            if (!(campaignRanking === null || campaignRanking === void 0 ? void 0 : campaignRanking.ranker.length)) analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                campaignId: router.query.campaignId,
                name: "campaignDetail"
            });
        }
    }), 2), getCampaignUserRanking = ref3[0], ref4 = ref3[1], campaignUserRanking = ref4.data, campaignUserRankGetting = ref4.loading;
    var ref5, ref6, ref7;
    return {
        state: {
            campaign: (ref5 = campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.campaign) !== null && ref5 !== void 0 ? ref5 : null,
            campaignArtistRanking: (ref6 = campaignArtistRanking === null || campaignArtistRanking === void 0 ? void 0 : campaignArtistRanking.campaignRanking) !== null && ref6 !== void 0 ? ref6 : null,
            campaignUserRanking: (ref7 = campaignUserRanking === null || campaignUserRanking === void 0 ? void 0 : campaignUserRanking.campaignRanking) !== null && ref7 !== void 0 ? ref7 : null,
            loading: loading,
            campaignArtistRankGetting: campaignArtistRankGetting,
            campaignUserRankGetting: campaignUserRankGetting
        },
        actions: {
            onFetchCampaignRanking: function onFetchCampaignRanking(rankingType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(rankingType === utoniq_core_schema/* CampaignRankingType.User */.p8D.User)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getCampaignUserRanking({
                                        variables: {
                                            inputs: {
                                                code: router.query.campaignId,
                                                type: utoniq_core_schema/* CampaignRankingType.User */.p8D.User,
                                                artistId: artistId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    getCampaignArtistRanking({
                                        variables: {
                                            inputs: {
                                                code: router.query.campaignId,
                                                type: utoniq_core_schema/* CampaignRankingType.Artist */.p8D.Artist,
                                                artistId: artistId
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickTab: function onClickTab(isArtist) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isArtist) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getCampaignUserRanking({
                                        variables: {
                                            inputs: {
                                                code: router.query.campaignId,
                                                type: utoniq_core_schema/* CampaignRankingType.User */.p8D.User,
                                                artistId: artistId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    getCampaignArtistRanking({
                                        variables: {
                                            inputs: {
                                                code: router.query.campaignId,
                                                type: utoniq_core_schema/* CampaignRankingType.Artist */.p8D.Artist,
                                                artistId: artistId
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CampaignDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(CampaignDetail_viewModel_templateObject(), utoniq_core_schema/* CampaignDetailFragmentDoc */.UvM);
var CAMPAIGN_USER_RANKING = (0,lib/* gql */.Ps)(CampaignDetail_viewModel_templateObject1(), utoniq_core_schema/* UserCampaignRankingFragmentDoc */.lvL);
var CAMPAIGN_ARTIST_RANKING = (0,lib/* gql */.Ps)(CampaignDetail_viewModel_templateObject2(), utoniq_core_schema/* ArtistCampaignRankingFragmentDoc */.tmU);

;// CONCATENATED MODULE: ./src/components/pages/CampaignDetail/index.tsx




var CampaignDetail = function() {
    var ref = CampaignDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/item/ItemImage/index.tsx
var ItemImage = __webpack_require__(23350);
;// CONCATENATED MODULE: ./src/components/pages/CollectionDetail/template/index.tsx



















var defaultLabels = [
    null
];
/**
 * アーティストのコレクション詳細
 * https://zpl.io/2EQ56Ky
 */ var CollectionDetailTemplate = function(param) {
    var _state = param.state, collection = _state.collection, collectionItems = _state.collectionItems, loading = _state.loading, fetching = _state.fetching, hasNextPage = _state.hasNextPage, user = _state.user, userId = _state.userId, onChangeLabel = param.onChangeLabel, onClickShare = param.onClickShare, onFetchMore = param.onFetchMore;
    var ref, ref1;
    var ref2 = (0,react.useState)(0), currentTab = ref2[0], setCurrentTab = ref2[1];
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var labels = (0,react.useMemo)(function() {
        var ref;
        if (collection === null || collection === void 0 ? void 0 : (ref = collection.labels) === null || ref === void 0 ? void 0 : ref.length) {
            return collection.labels;
        }
        return defaultLabels;
    }, [
        collection === null || collection === void 0 ? void 0 : collection.labels
    ]);
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(number) {
            var ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(collection === null || collection === void 0 ? void 0 : (ref = collection.labels) === null || ref === void 0 ? void 0 : ref.length)) {
                            return [
                                2
                            ];
                        }
                        setCurrentTab(number);
                        return [
                            4,
                            onChangeLabel(number === 0, (ref2 = (ref1 = collection.labels[number]) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : "")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(number) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeLabel,
        collection === null || collection === void 0 ? void 0 : collection.labels
    ]);
    var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: collection === null || collection === void 0 ? void 0 : collection.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            safeArea: {
                pt: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.CollectionDetail,
                        collection === null || collection === void 0 ? void 0 : collection.title,
                        user === null || user === void 0 ? void 0 : user.displayName, 
                    ]
                }),
                loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDetailLoading, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSetCell, {
                            loading: loading,
                            onClickShare: onClickShare
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDetail_template_BannerCell, {
                            title: (ref3 = collection === null || collection === void 0 ? void 0 : collection.title) !== null && ref3 !== void 0 ? ref3 : "",
                            thumbnail: (ref4 = collection === null || collection === void 0 ? void 0 : collection.thumbnail) !== null && ref4 !== void 0 ? ref4 : null,
                            artistId: collection === null || collection === void 0 ? void 0 : collection.artistId
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionOverviewTextCell, {
                            title: (ref5 = collection === null || collection === void 0 ? void 0 : collection.title) !== null && ref5 !== void 0 ? ref5 : null,
                            description: (ref6 = collection === null || collection === void 0 ? void 0 : collection.description) !== null && ref6 !== void 0 ? ref6 : null,
                            artist: (ref7 = collection === null || collection === void 0 ? void 0 : collection.artist) !== null && ref7 !== void 0 ? ref7 : null
                        }),
                        user && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionRateCell, {
                            user: user,
                            userCollection: (ref8 = collection === null || collection === void 0 ? void 0 : collection.userCollection) !== null && ref8 !== void 0 ? ref8 : null,
                            itemCount: (ref9 = collection === null || collection === void 0 ? void 0 : collection.itemCount) !== null && ref9 !== void 0 ? ref9 : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSetCell, {
                            onClickShare: onClickShare
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                    labels: (ref11 = collection === null || collection === void 0 ? void 0 : (ref = collection.labels) === null || ref === void 0 ? void 0 : ref.map(function(label) {
                        return (ref10 = label === null || label === void 0 ? void 0 : label.name) !== null && ref10 !== void 0 ? ref10 : "";
                    })) !== null && ref11 !== void 0 ? ref11 : [],
                    hiddenLabel: !(collection === null || collection === void 0 ? void 0 : (ref1 = collection.labels) === null || ref1 === void 0 ? void 0 : ref1.length) || loading,
                    value: currentTab,
                    disableAnimateTransitions: true,
                    onChange: handleChangeTab,
                    children: labels.map(function(label, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemImageListCell, {
                            loading: loading || fetching,
                            userId: userId,
                            hasNextPage: hasNextPage,
                            collectionId: (ref12 = collection === null || collection === void 0 ? void 0 : collection.id) !== null && ref12 !== void 0 ? ref12 : "",
                            artistId: (ref13 = collection === null || collection === void 0 ? void 0 : collection.artistId) !== null && ref13 !== void 0 ? ref13 : "",
                            collectionItems: collectionItems !== null && collectionItems !== void 0 ? collectionItems : null,
                            userCollection: (ref14 = collection === null || collection === void 0 ? void 0 : collection.userCollection) !== null && ref14 !== void 0 ? ref14 : null,
                            onFetchMore: function() {
                                return onFetchMore(index === 0, label === null || label === void 0 ? void 0 : label.name);
                            }
                        }, index);
                    })
                })
            ]
        })
    });
};
var CollectionDetail_template_BannerCell = function(param) {
    var thumbnail = param.thumbnail, title = param.title, artistId = param.artistId;
    var headerRef = (0,react.useRef)();
    var headerImageAreaRef = (0,react.useRef)();
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1, ref2;
    var thumbnailUri = (ref2 = (ref1 = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.mediumUri) !== null && ref1 !== void 0 ? ref1 : thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri) !== null && ref2 !== void 0 ? ref2 : "";
    (0,react.useEffect)(function() {
        var handleScroll = function handleScroll() {
            if (headerRef.current && headerImageAreaRef.current) {
                var ref;
                var ref1;
                var bannerImageHeight = (ref1 = (ref = headerImageAreaRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) !== null && ref1 !== void 0 ? ref1 : 1;
                headerRef.current.style.opacity = "".concat((this.scrollY - 20) / bannerImageHeight);
                headerRef.current.style.display = "".concat(this.scrollY > 20 ? "unset" : "none");
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var handleClose = function() {
        return router === null || router === void 0 ? void 0 : router.goBack(artistId && generatePath(routerPages[// アーティストタブにmyCollectionsが含まれている場合ブラウザバックURLを変更
        config_config/* config.artistTabs.includes */.v.artistTabs.includes("myCollections") ? "ArtistMyCollections" : "ArtistCollections"], {
            artistId: artistId
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                elevation: 0,
                position: "fixed",
                color: "transparent",
                sx: {
                    maxWidth: 600,
                    bgcolor: "transparent",
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    onClick: handleClose,
                    bgcolor: "grey.50"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                ref: headerRef,
                position: "fixed",
                color: "primary",
                sx: {
                    maxWidth: 600,
                    opacity: 0,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    onClick: handleClose,
                    color: "white"
                }),
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
                ref: headerImageAreaRef,
                imageUri: thumbnailUri,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            })
        ]
    });
};
var CollectionOverviewTextCell = function(param) {
    var artist = param.artist, title = param.title, description = param.description;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        p: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "text.hint",
                children: artist === null || artist === void 0 ? void 0 : artist.displayName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                pt: 1,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                pt: 3,
                children: description
            })
        ]
    });
};
var CollectionRateCell = function(param) {
    var userCollection = param.userCollection, user = param.user, itemCount = param.itemCount;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("collectionDetail").t;
    var ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                sx: {
                    pt: 2
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        component: Link/* default */.Z,
                        href: generatePath(routerPages.UserProfile, {
                            userId: user === null || user === void 0 ? void 0 : user.id
                        }),
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref2 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("numberOfOwned", {
                                number: (ref3 = userCollection === null || userCollection === void 0 ? void 0 : userCollection.totalOwnedCount) !== null && ref3 !== void 0 ? ref3 : 0
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionIndicator, {
                sx: {
                    py: 2,
                    mx: 0
                },
                itemCount: (ref4 = userCollection === null || userCollection === void 0 ? void 0 : userCollection.totalOwnedItemCount) !== null && ref4 !== void 0 ? ref4 : 0,
                totalCount: itemCount !== null && itemCount !== void 0 ? itemCount : 0
            })
        ]
    });
};
var SupplementLinkSetCell = function(param) {
    var loading = param.loading, onClickShare = param.onClickShare;
    var t = (0,core_i18n/* useTranslation */.$G)("collectionDetail").t;
    var supplements = (0,react.useMemo)(function() {
        return [
            {
                id: 1,
                label: t("share"),
                buttonProps: {
                    onClick: onClickShare
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Share, {
                    sx: {
                        mx: "auto"
                    }
                })
            }, 
        ];
    }, [
        onClickShare,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                py: 2,
                px: 5
            },
            spacing: 3,
            justifyContent: "end",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 36,
                    height: 36,
                    sx: {
                        borderRadius: 0.5
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 36,
                    height: 36,
                    sx: {
                        borderRadius: 0.5
                    }
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                justifyContent: "flex-end",
                pt: 2
            },
            children: supplements.map(function(supplement, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, supplement.buttonProps), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        p: 1,
                        color: "text.primary"
                    },
                    variant: "text",
                    children: [
                        supplement.icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "hint",
                            sx: {
                                pt: 1
                            },
                            children: supplement.label
                        })
                    ]
                }), index);
            })
        })
    });
};
var ItemImageListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, userId = param.userId, artistId = param.artistId, collectionId = param.collectionId, collectionItems = param.collectionItems, userCollection = param.userCollection, onFetchMore = param.onFetchMore;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var getData = (0,react.useCallback)(function(node) {
        var ref;
        var ownedItem = userCollection === null || userCollection === void 0 ? void 0 : (ref = userCollection.ownedItems) === null || ref === void 0 ? void 0 : ref.find(function(o) {
            return o.itemId === node.id;
        });
        var ownedCount = node.item.sku && (ownedItem === null || ownedItem === void 0 ? void 0 : ownedItem.userItem) ? ownedItem === null || ownedItem === void 0 ? void 0 : ownedItem.userItem.serials.filter(function(serial) {
            var ref, ref1;
            return ((ref = serial.serial) === null || ref === void 0 ? void 0 : ref.skuId) === ((ref1 = node.item.sku) === null || ref1 === void 0 ? void 0 : ref1.id);
        }).length : ownedItem === null || ownedItem === void 0 ? void 0 : ownedItem.ownedCount;
        var isNoItem = !ownedItem || !ownedCount;
        var href;
        if (isNoItem) {
            var ref1;
            href = "".concat(generatePath(routerPages.CollectionItemDetail, {
                itemId: node.item.id,
                collectionId: collectionId
            })).concat(node.item.sku ? "?skuId=".concat(encodeSkuId((ref1 = node.item.sku) === null || ref1 === void 0 ? void 0 : ref1.id)) : "");
        } else {
            var ref2, ref3;
            var ref4;
            href = userId ? "".concat(generatePath(routerPages.UserItemDetail, {
                itemId: node.item.id,
                userId: userId
            })).concat(node.item.sku ? "?skuId=".concat(encodeSkuId((ref2 = node.item.sku) === null || ref2 === void 0 ? void 0 : ref2.id)) : "") : "".concat(generatePath(routerPages.OwnedItemDetail, {
                itemId: node.item.id
            })).concat(node.item.sku ? "?skuId=".concat(encodeSkuId((ref4 = (ref3 = node.item.sku) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref4 !== void 0 ? ref4 : "")) : "");
        }
        return {
            ownedCount: ownedCount,
            isNoItem: isNoItem,
            href: href
        };
    }, [
        collectionId,
        generatePath,
        routerPages.CollectionItemDetail,
        routerPages.OwnedItemDetail,
        routerPages.UserItemDetail,
        userCollection === null || userCollection === void 0 ? void 0 : userCollection.ownedItems,
        userId, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: Grid2/* default */.Z,
            componentProps: {
                spacing: 3,
                container: true
            },
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: {
                size: {
                    xs: 4,
                    md: 3
                }
            },
            nodes: collectionItems === null || collectionItems === void 0 ? void 0 : (ref = collectionItems.edges) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                var node = param.node;
                var ref = getData(node), ownedCount = ref.ownedCount, isNoItem = ref.isNoItem, href = ref.href;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage/* ItemImage */.R, {
                    href: href,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: artistId,
                            collectionId: collectionId,
                            itemId: node === null || node === void 0 ? void 0 : node.item.id,
                            name: "collectionDetail"
                        });
                    },
                    showShadow: true,
                    item: node.item,
                    noItem: isNoItem,
                    ownedCount: ownedCount || 0
                }, index);
            }),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 3,
                sx: {
                    py: 2
                },
                children: Array.from(Array(12).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: {
                            xs: 4,
                            md: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: "100%",
                            height: 166
                        })
                    }, key);
                })
            })
        })
    });
};
var CollectionDetailLoading = function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: "calc(100vw *  212 / 375)",
                    maxHeight: "calc(600px * 212 / 375)",
                    "& header": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    color: "transparent",
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        size: "medium",
                        onClick: function() {
                            return router === null || router === void 0 ? void 0 : router.goBack();
                        },
                        bgcolor: "grey.50"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5,
                    px: 5,
                    pb: 3
                },
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: 84,
                            height: 10,
                            borderRadius: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: 252,
                            height: 20,
                            borderRadius: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: 300,
                            height: 15,
                            borderRadius: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: 252,
                            height: 15,
                            borderRadius: 0.5
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    py: 2,
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                width: "25%",
                                variant: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                width: "25%",
                                variant: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                width: 30,
                                sx: {
                                    borderRadius: 0.5,
                                    minHeight: 11
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CollectionDetail/viewModel.ts



function CollectionDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CollectionDetail(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n    $userId: ID\n  ) {\n    user(id: $userId) {\n      id\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      artist {\n        id\n        displayName\n      }\n      thumbnail {\n        uri\n        mediumUri\n      }\n      userCollection(userId: $userId) {\n        ogp {\n          uri\n          smallUri\n        }\n        itemOwnedCount\n        totalOwnedCount\n        totalOwnedItemCount @client\n        ownedItems {\n          itemId\n          ownedCount\n          userItem {\n            serials {\n              serial {\n                skuId\n              }\n            }\n          }\n        }\n        id\n        userId\n      }\n      itemCount\n      description\n      labels {\n        name\n        id\n      }\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        pageInput: $pageInput\n      ) {\n        ...CollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CollectionDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectionDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CollectionDetailForGuest(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n  ) {\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      artist {\n        id\n        displayName\n      }\n      thumbnail {\n        uri\n        mediumUri\n      }\n      itemCount\n      description\n      labels {\n        name\n        id\n      }\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        pageInput: $pageInput\n      ) {\n        ...CollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CollectionDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var CollectionDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref12 = (0,auth/* useAuth */.aC)(), currentUser = ref12.user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref13 = (0,useQuery/* useQuery */.aM)(CollectionDetail_viewModel_QUERY, {
        variables: {
            userId: router.query.userId,
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            pageInput: {
                limit: 12
            }
        },
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        returnPartialData: true
    }), data = ref13.data, refetch = ref13.refetch, fetchMore = ref13.fetchMore, networkStatus = ref13.networkStatus;
    var ref14 = (0,useQuery/* useQuery */.aM)(CollectionDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            pageInput: {
                limit: 12
            }
        },
        skip: !!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        returnPartialData: true
    }), dataForGuest = ref14.data, refetchForGuest = ref14.refetch, fetchMoreForGuest = ref14.fetchMore, networkStatusForGuest = ref14.networkStatus;
    var isNextFetch = !!((ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : ref.collection);
    var _userId;
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        /**
     * ログインしている場合、ログインユーザーのUserCollectionDetailページのリンクを生成する
     * 未ログインの場合、collectionDetailページのリンクを生成する
     */ path: currentUser ? "/userProfile/".concat((_userId = router.query.userId) !== null && _userId !== void 0 ? _userId : currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid, "/collections/").concat(data === null || data === void 0 ? void 0 : (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : ref1.id) : "/collections/".concat(data === null || data === void 0 ? void 0 : (ref2 = data.collection) === null || ref2 === void 0 ? void 0 : ref2.id)
    });
    var ref15, ref16;
    return {
        state: {
            loading: (networkStatus !== null && networkStatus !== void 0 ? networkStatus : networkStatusForGuest) === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            fetching: (networkStatus !== null && networkStatus !== void 0 ? networkStatus : networkStatusForGuest) === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            user: (ref15 = data === null || data === void 0 ? void 0 : data.user) !== null && ref15 !== void 0 ? ref15 : null,
            userId: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid) === (data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.id) ? undefined : data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.id,
            hasNextPage: !!((ref5 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.collection) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.collectionItems) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.pageInfo) === null || ref8 === void 0 ? void 0 : ref8.hasNextPage),
            collection: (ref16 = (ref9 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref9 === void 0 ? void 0 : ref9.collection) !== null && ref16 !== void 0 ? ref16 : null,
            collectionItems: spreadCollectionItemsBySku((ref10 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.collection) === null || ref11 === void 0 ? void 0 : ref11.collectionItems)
        },
        actions: {
            onChangeLabel: function onChangeLabel(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!currentUser) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetchForGuest({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    refetch({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                collectionId: router.query.collectionId,
                                name: "collectionDetail"
                            });
                            return [
                                4,
                                getShortLinkUrl()
                            ];
                        case 1:
                            url = _state.sent();
                            return [
                                4,
                                share/* share */.B({
                                    title: data === null || data === void 0 ? void 0 : (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : ref1.title,
                                    text: (data === null || data === void 0 ? void 0 : (ref2 = data.collection) === null || ref2 === void 0 ? void 0 : ref2.description) || "",
                                    url: url,
                                    dialogTitle: data === null || data === void 0 ? void 0 : (ref3 = data.collection) === null || ref3 === void 0 ? void 0 : ref3.title
                                }).then(function() {
                                    var ref;
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        artistId: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                        collectionId: router.query.collectionId,
                                        name: "collectionDetail"
                                    });
                                }).catch(function(e) {
                                    return showError(e);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            onFetchMore: function onFetchMore(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!currentUser) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreForGuest({
                                        variables: {
                                            collectionId: router.query.collectionId,
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                limit: 12,
                                                cursor: dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref2 = dataForGuest.collection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collectionItems) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            collectionId: router.query.collectionId,
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                limit: 12,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.collectionItems) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CollectionDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(CollectionDetail_viewModel_templateObject(), utoniq_core_schema/* CollectionItemsConnectionFragmentDoc */.euq);
var CollectionDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(CollectionDetail_viewModel_templateObject1(), utoniq_core_schema/* CollectionItemsConnectionFragmentDoc */.euq);

;// CONCATENATED MODULE: ./src/components/pages/CollectionDetail/index.tsx



/**
 * CollectionDetail Page
 * Implemented as a practical sample.
 */ var CollectionDetail = function() {
    var ref = CollectionDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDetailTemplate, {
        state: state,
        onChangeLabel: actions.onChangeLabel,
        onClickShare: actions.onClickShare,
        onFetchMore: actions.onFetchMore
    });
};

// EXTERNAL MODULE: ../../node_modules/react-card-flip/lib/ReactCardFlip.js
var ReactCardFlip = __webpack_require__(81648);
var ReactCardFlip_default = /*#__PURE__*/__webpack_require__.n(ReactCardFlip);
;// CONCATENATED MODULE: ./src/components/organisms/item/ItemReversableThumbnail/index.tsx






/**
 * @description
 * 回転できるアイテムイメージコンポーネント
 * ref: https://github.com/AaronCCWong/react-card-flip
 */ var ItemReversibleThumbnail = function(param) {
    var loading = param.loading, imageAreaProps = param.imageAreaProps, flipProps = param.flipProps, btnPlay = param.btnPlay;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, // 裏面のデータがなければ、フロントのデータを表示する
    ref8, ref9, ref10, ref11;
    var ref12, ref13, ref14, ref15, ref16, ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((ReactCardFlip_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, flipProps), {
        children: [
            // front image
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                size: imageAreaProps.size
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, imageAreaProps), {
                        src: (ref13 = (ref12 = imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref = imageAreaProps.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref12 !== void 0 ? ref12 : imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref2 = imageAreaProps.thumbnail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.front) === null || ref3 === void 0 ? void 0 : ref3.uri) !== null && ref13 !== void 0 ? ref13 : ""
                    })),
                    (btnPlay === null || btnPlay === void 0 ? void 0 : btnPlay.type) === "front" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Play, {
                        onClick: btnPlay === null || btnPlay === void 0 ? void 0 : btnPlay.onClick,
                        fontSize: "large",
                        sx: {
                            zIndex: 0,
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white"
                        }
                    })
                ]
            }),
            // back image
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                size: imageAreaProps.size
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, imageAreaProps), {
                        src: (ref17 = (ref16 = (ref15 = (ref14 = imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref4 = imageAreaProps.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.back) === null || ref5 === void 0 ? void 0 : ref5.mediumUri) !== null && ref14 !== void 0 ? ref14 : imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref6 = imageAreaProps.thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.back) === null || ref7 === void 0 ? void 0 : ref7.uri) !== null && ref15 !== void 0 ? ref15 : imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref8 = imageAreaProps.thumbnail) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.front) === null || ref9 === void 0 ? void 0 : ref9.mediumUri) !== null && ref16 !== void 0 ? ref16 : imageAreaProps === null || imageAreaProps === void 0 ? void 0 : (ref10 = imageAreaProps.thumbnail) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.front) === null || ref11 === void 0 ? void 0 : ref11.uri) !== null && ref17 !== void 0 ? ref17 : ""
                    })),
                    (btnPlay === null || btnPlay === void 0 ? void 0 : btnPlay.type) === "back" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Play, {
                        fontSize: "large",
                        onClick: btnPlay === null || btnPlay === void 0 ? void 0 : btnPlay.onClick,
                        sx: {
                            zIndex: 0,
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white"
                        }
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ItemImageArea/index.tsx







var ItemImageArea = function(param) {
    var item = param.item, loading = param.loading, noItem = param.noItem, children = param.children, possessionNumber = param.possessionNumber, avatarUri = param.avatarUri;
    var ref = (0,react.useState)(false), reverse = ref[0], setReverse = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        component: Stack_Stack/* default */.Z,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                    loading: loading,
                    flipProps: {
                        isFlipped: reverse
                    },
                    imageAreaProps: {
                        thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                        size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "large-square" : "large",
                        onClick: function() {
                            var ref;
                            if (!((ref = item === null || item === void 0 ? void 0 : item.thumbnail.back) === null || ref === void 0 ? void 0 : ref.uri)) return;
                            setReverse(function(prev) {
                                return !prev;
                            });
                        },
                        noItem: noItem
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescriptionCell, {
                item: item,
                possessionNumber: possessionNumber,
                avatarUri: avatarUri
            }),
            children
        ]
    });
};
var ItemDescriptionCell = function(param) {
    var item = param.item, possessionNumber = param.possessionNumber, avatarUri = param.avatarUri;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("collectionItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 2
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: item === null || item === void 0 ? void 0 : item.title
                    }),
                    (item === null || item === void 0 ? void 0 : item.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: item.sku.unitName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 4,
                children: [
                    (item === null || item === void 0 ? void 0 : item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("rarity")
                            }),
                            (item === null || item === void 0 ? void 0 : (ref = item.rarityIconImage) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                src: item.rarityIconImage.smallUri,
                                sx: {
                                    height: 12,
                                    width: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: (item === null || item === void 0 ? void 0 : (ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.name) ? t(item === null || item === void 0 ? void 0 : item.rarity.name) : "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("possessionNumber")
                            }),
                            !!avatarUri && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: avatarUri,
                                sx: {
                                    height: 12,
                                    width: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: possessionNumber !== null && possessionNumber !== void 0 ? possessionNumber : 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/SupplementLinkArea/index.tsx











var SupplementLinkArea = function(param) {
    var startItems = param.startItems, endItems = param.endItems, itemId = param.itemId, artistId = param.artistId, pageName = param.pageName, transparent = param.transparent;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var defaultSupplement = {
        expansion: {
            type: "expansion",
            title: "expansion",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Expansion, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled"
        },
        itemInfo: {
            hidden: (0,individual/* individualHiddenItemInfo */.Ek)(),
            type: "itemInfo",
            title: "itemInfo",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ItemInfo, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: generatePath(routerPages.OwnedItemInformation, {
                itemId: itemId
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled"
        },
        serial: {
            type: "serial",
            title: "serial",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Serial, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled"
        },
        trade: {
            type: "trade",
            title: "trade",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TradeRequest, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            activeColor: "text.secondary",
            inactiveColor: "text.disabled"
        },
        share: {
            type: "share",
            title: "share",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Share, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled"
        },
        protect: {
            type: "protect",
            title: "protect",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Protect, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            activeColor: "primary.main",
            inactiveColor: "text.disabled"
        },
        wallpaper: {
            type: "wallpaper",
            title: "wallpaper",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Wallpaper, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled"
        },
        comment: {
            type: "comment",
            title: "comment",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Reply, {
                sx: {
                    color: "grey.600"
                }
            }),
            onClick: function onClick() {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_comment", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    artistId: artistId,
                    name: pageName
                });
            },
            href: generatePath(routerPages.ItemComment, {
                itemId: itemId
            }),
            color: "text.secondary",
            inactiveColor: "text.disabled",
            sx: {
                alignSelf: "stretch",
                display: "flex",
                height: "unset"
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            bgcolor: transparent ? "transparent" : "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: {
                py: 2,
                px: 4,
                minHeight: 64
            },
            children: [
                startItems,
                endItems
            ].map(function(items, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "flex-start",
                    alignSelf: "stretch",
                    children: items === null || items === void 0 ? void 0 : items.map(function(item) {
                        var _ref = (0,src_object_spread/* default */.Z)({}, defaultSupplement[item.type], item), type = _ref.type, sx = _ref.sx, color = _ref.color, icon = _ref.icon, title = _ref.title, hidden = _ref.hidden, active = _ref.active, activeColor = _ref.activeColor, inactiveColor = _ref.inactiveColor, props = (0,_object_without_properties/* default */.Z)(_ref, [
                            "type",
                            "sx",
                            "color",
                            "icon",
                            "title",
                            "hidden",
                            "active",
                            "activeColor",
                            "inactiveColor"
                        ]);
                        if ((!config_config/* config.modules.trade */.v.modules.trade || !props.onClick && !props.href) && type === "trade") return;
                        if (!props.onClick && !props.href && type === "wallpaper") return;
                        if (!props.onClick && !props.href && type === "share") return;
                        if (!props.onClick && !props.href && type === "expansion") return;
                        if ((!config_config/* config.modules.trade */.v.modules.trade || !props.onClick && !props.href) && type === "protect") return;
                        if (hidden && type === "itemInfo") return;
                        if (hidden && type === "trade") return;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            variant: "text",
                            sx: (0,src_object_spread/* default */.Z)({
                                display: "grid",
                                gridTemplateColumns: "1fr",
                                p: 1,
                                color: active !== undefined ? active ? activeColor : inactiveColor : color,
                                borderRadius: 0,
                                textAlign: "center",
                                minWidth: 44,
                                "&.Mui-disabled": {
                                    background: "inherit",
                                    color: "text.disabled",
                                    ".MuiSvgIcon-root": {
                                        color: "inherit"
                                    }
                                },
                                ".MuiSvgIcon-root, .MuiTypography-root": active !== undefined && !active ? {
                                    color: "inherit"
                                } : undefined
                            }, sx)
                        }, props), {
                            children: [
                                icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: index ? "body2" : "overline",
                                    color: props.disabled ? "text.disabled" : "text.hint",
                                    sx: {
                                        pt: 1
                                    },
                                    children: t(title !== null && title !== void 0 ? title : "")
                                })
                            ]
                        }), index);
                    })
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/functionals/Step/index.tsx



var Steps = function(param) {
    var value = param.value, children = param.children, _sx = param.sx, sx = _sx === void 0 ? {} : _sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: sx,
        children: react.Children.map(children, function(child, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                index: index,
                value: value,
                sx: sx,
                children: child
            }, index);
        })
    });
};
var Step = function(param) {
    var index = param.index, value = param.value, sx = param.sx, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        hidden: value !== index,
        sx: sx,
        children: value === index && children
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/SkeletonLoader.tsx



var SkeletonLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                flex: "1 0 auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                            size: "xx-large"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                mt: 6,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 30,
                                height: 30
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        justifyContent: "flex-start",
                        py: 2,
                        px: 4
                    },
                    children: [
                        1,
                        2,
                        3,
                        4
                    ].map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 40,
                            width: 40,
                            sx: {
                                m: 1
                            }
                        }, index);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/trade/UserTradeBox/index.tsx




var UserTradeBox = function(param) {
    var itemId = param.itemId, userTrade = param.userTrade;
    var ref, ref1, ref2;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("tradeRequestUserSelect").t;
    var serialsLength = (0,react.useMemo)(function() {
        return userTrade.serials.filter(function(o) {
            return !o.isProtected;
        }).length;
    }, [
        userTrade.serials
    ]);
    if (!serialsLength) {
        return null;
    }
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        divider: true,
        sx: {
            py: 4
        },
        disablePadding: true,
        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            href: generatePath(routerPages.SerialNumberSelect, {
                itemId: itemId,
                userId: userTrade.user.id
            }),
            children: t("choice")
        }),
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    width: "fit-content"
                },
                href: generatePath(routerPages.UserProfile, {
                    userId: (ref4 = (ref = userTrade.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : "#"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                        sx: {
                            mr: 2,
                            minWidth: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: (ref5 = (ref1 = userTrade.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref5 !== void 0 ? ref5 : "",
                            sx: {
                                width: 36,
                                height: 36
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                        sx: {
                            flex: "0 0 auto",
                            mr: 2
                        },
                        primary: userTrade.user.displayName,
                        slotProps: {
                            primary: {
                                variant: "subtitle1",
                                color: "text.secondary"
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                primary: t("numberOfPossessions", {
                    number: serialsLength
                }),
                slotProps: {
                    primary: {
                        variant: "overline",
                        color: "text.hint"
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/trade/UserTradeBoxSkeleton/index.tsx




var UserTradeBoxSkeleton = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("tradeRequestUserSelect").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        divider: true,
        sx: {
            py: 4
        },
        disablePadding: true,
        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            children: t("choice")
        }),
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                sx: {
                    mr: 2,
                    minWidth: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    height: 36,
                    width: 36,
                    variant: "circular"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "25%"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CollectionItemDetail/template/TradeRequestUserSelect.tsx







var TradeRequestUserSelect = function(param) {
    var loading = param.loading, itemId = param.itemId, hasNextPage = param.hasNextPage, tradableUsers = param.tradableUsers, onClose = param.onClose, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("tradeRequestUserSelect").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                onClick: onClose
            }),
            title: t("title")
        },
        sx: {
            height: "100%"
        },
        children: [
            (!!(tradableUsers === null || tradableUsers === void 0 ? void 0 : (ref = tradableUsers.edges) === null || ref === void 0 ? void 0 : ref.length) || loading && !(tradableUsers === null || tradableUsers === void 0 ? void 0 : (ref1 = tradableUsers.edges) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    pt: 2,
                    pb: 3
                },
                variant: "body2",
                color: "text.secondary",
                children: t("yourChoice")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                componentProps: {
                    spacing: 0
                },
                emptyMessage: t("emptyMessage"),
                nodes: tradableUsers === null || tradableUsers === void 0 ? void 0 : (ref2 = tradableUsers.edges) === null || ref2 === void 0 ? void 0 : ref2.map(function(param, index) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTradeBox, {
                        userTrade: node,
                        itemId: itemId
                    }, index);
                }),
                component: List_List/* default */.Z,
                loading: loading,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTradeBoxSkeleton, {}, i);
                    })
                }),
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CollectionItemDetail/template/index.tsx



















var CollectionItemDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onGetTradableUsers = param.onGetTradableUsers;
    var ref, ref1, ref2, ref3, ref4;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref5 = (0,react.useState)(0), currentStep = ref5[0], setCurrentStep = ref5[1];
    if (!state.loading && !state.item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    /**
   * NFT 停止に向けて、NFTアイテムの詳細ページを表示しない
   * NFT 機能停止後には削除して問題ない
   */ if ((ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.nft) === null || ref1 === void 0 ? void 0 : ref1.chains) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref2 = state.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.issuedArtist) === null || ref3 === void 0 ? void 0 : ref3.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps, {
            sx: {
                height: "100%"
            },
            value: currentStep,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItemDetail, {
                    item: state.item,
                    loading: state.loading,
                    isLoggedIn: state.isLoggedIn,
                    onNextStep: handleLoginModal(function() {
                        var ref;
                        var ref1;
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_tradableUsers", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            itemId: (ref1 = (ref = state.item) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "#"
                        });
                        onGetTradableUsers();
                        setCurrentStep(1);
                    })
                }),
                !!currentStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeRequestUserSelect, {
                    loading: state.fetching || state.loadingTradableUsers,
                    itemId: (ref6 = (ref4 = state.item) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref6 !== void 0 ? ref6 : "",
                    tradableUsers: state.tradableUsers,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    onClose: function() {
                        return setCurrentStep(0);
                    }
                })
            ]
        })
    });
};
var CollectionItemDetail = function(param) {
    var item = param.item, loading = param.loading, onNextStep = param.onNextStep;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerNames = ref.routerNames, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var _collectionId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.CollectionDetail, {
                collectionId: (_collectionId = router.query.collectionId) !== null && _collectionId !== void 0 ? _collectionId : "#"
            }),
            type: "modal"
        },
        sx: {
            height: "100dvh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.CollectionItemDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItemDetailCell, {
                    loading: loading,
                    item: item,
                    onNextStep: onNextStep
                })
            })
        ]
    });
};
var CollectionItemDetailCell = function(param) {
    var loading = param.loading, item = param.item, onNextStep = param.onNextStep;
    var ref, ref1, ref2, ref3, ref4;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("collectionItemDetail").t;
    var ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageArea, {
                item: item,
                loading: loading,
                noItem: true,
                children: (item === null || item === void 0 ? void 0 : (ref = item.collection) === null || ref === void 0 ? void 0 : ref.isPublishOnStore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                    sx: {
                        bgcolor: "grey.50",
                        height: 56,
                        width: 335,
                        borderRadius: 1,
                        justifyContent: "space-between",
                        px: 4,
                        py: 2,
                        mt: 6
                    },
                    href: generatePath(routerPages.ArtistStoreItemDetail, {
                        artistId: item === null || item === void 0 ? void 0 : (ref1 = item.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                        itemId: item === null || item === void 0 ? void 0 : item.id
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            color: "text.primary",
                            variant: "subtitle1",
                            children: t("buyInStore")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                !(0,individual/* individualHideWallet */.Bd)() && ((item === null || item === void 0 ? void 0 : item.paymentType) !== utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                    size: "medium",
                                    point: (ref6 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref6 !== void 0 ? ref6 : 0
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                    variant: "h4",
                                    children: [
                                        "￥",
                                        (ref7 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref7 !== void 0 ? ref7 : 0
                                    ]
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                    fontSize: "xSmall"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: config_config/* config.modules.trade */.v.modules.trade && !(item === null || item === void 0 ? void 0 : item.hideSalesNumber) && !(item === null || item === void 0 ? void 0 : item.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 6,
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "medium",
                            variant: "outlined",
                            onClick: onNextStep,
                            children: t("checkWhoCanTrade")
                        })
                    })
                })
            }),
            config_config/* config.modules.gacha */.v.modules.gacha && !loading && !!(item === null || item === void 0 ? void 0 : (ref2 = item.gachas) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GachasLinkCell, {
                gachas: item === null || item === void 0 ? void 0 : item.gachas,
                artistId: (ref8 = item === null || item === void 0 ? void 0 : (ref3 = item.issuedArtist) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref8 !== void 0 ? ref8 : "#"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkArea, {
                transparent: true,
                itemId: item === null || item === void 0 ? void 0 : item.id,
                artistId: (ref9 = item === null || item === void 0 ? void 0 : (ref4 = item.issuedArtist) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref9 !== void 0 ? ref9 : "",
                startItems: [
                    {
                        type: "itemInfo",
                        hidden: (0,individual/* individualHiddenItemInfo */.Ek)(),
                        href: generatePath(routerPages.OwnedItemInformation, {
                            itemId: (ref10 = item === null || item === void 0 ? void 0 : item.id) !== null && ref10 !== void 0 ? ref10 : "#"
                        }),
                        onClick: handleLoginModal()
                    }, 
                ],
                endItems: [
                    {
                        type: "comment",
                        title: (ref11 = item === null || item === void 0 ? void 0 : item.commentCount) !== null && ref11 !== void 0 ? ref11 : 0
                    }
                ],
                pageName: "collection_item_detail"
            })
        ]
    });
};
var GachasLinkCell = function(param) {
    var gachas = param.gachas, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("collectionItemDetail").t;
    if (!(gachas === null || gachas === void 0 ? void 0 : gachas.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 9
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            title: t("gachaLabel", "以下のガチャに含まれています"),
            titleTypographyProps: {
                variant: "overline"
            },
            items: gachas,
            renderItem: function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBoxCell, {
                    gacha: item,
                    artistId: artistId
                });
            }
        })
    });
};
var GachaBoxCell = function(param) {
    var gacha = param.gacha, artistId = param.artistId;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var _mediumUri;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                bgcolor: "transparent",
                width: 160
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ArtistGachaDetail, {
                    artistId: artistId,
                    gachaId: gacha.id
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                        component: "img",
                        height: "90",
                        image: (_mediumUri = gacha.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : "",
                        sx: {
                            borderRadius: 1
                        },
                        alt: gacha.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                        children: gacha.name
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/core/auth/useLoginModal.tsx
var useLoginModal = __webpack_require__(60705);
;// CONCATENATED MODULE: ./src/components/pages/CollectionItemDetail/viewModel.ts






function CollectionItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CollectionItemDetail($itemId: ID!) {\n    item(id: $itemId) {\n      id\n      issuedArtist {\n        id\n      }\n      price\n      formattedPrice @client\n      paymentType\n      serials(pageInput: { limit: 1 }) {\n        ...SerialItemOwners\n      }\n      collection {\n        id\n        isPublishOnStore\n      }\n      ...ItemImageArea\n      description\n      commentCount\n      isPublished\n      gachas {\n        id\n        name\n        thumbnail {\n          uri\n          mediumUri\n        }\n      }\n      nft {\n        chains {\n          chainName\n        }\n      }\n    }\n    user {\n      id\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    CollectionItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectionItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TradableUsers($itemId: ID!, $pageInput: PageInput) {\n    item(id: $itemId) {\n      id\n      tradableUsers(pageInput: $pageInput) {\n        ...TradableUsersConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CollectionItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var CollectionItemDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var showModal = (0,useLoginModal/* useLoginModal */.N)().showModal;
    var ref7 = (0,useQuery/* useQuery */.aM)(CollectionItemDetail_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId
        },
        returnPartialData: true
    }), data = ref7.data, loading = ref7.loading;
    var hasSkuItem = function(serials) {
        // NOTE: serialsがないかskuIdがない場合はチェックをパス
        if (!serials || !router.query.skuId) return true;
        var list = serials.find(function(s) {
            var ref;
            return ((ref = s.serial) === null || ref === void 0 ? void 0 : ref.skuId) === decodeSkuId(router.query.skuId);
        });
        return list ? true : false;
    };
    var ref8 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* HasItemUserItemDetail */.Iz4, {
        variables: {
            itemId: router.query.itemId,
            userId: user === null || user === void 0 ? void 0 : user.uid
        },
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        onCompleted: function onCompleted(param) {
            var portfolio = param.portfolio;
            //If the user owns the item, navigate to the OwnedItemDetail screen
            if ((portfolio === null || portfolio === void 0 ? void 0 : portfolio.id) && hasSkuItem(portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials)) {
                router.replace("".concat(generatePath(routerPages.OwnedItemDetail, {
                    itemId: router.query.itemId
                })).concat(router.query.skuId ? "?skuId=".concat(router.query.skuId) : ""));
            }
        }
    }), loadingItemUserItemDetail = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(QUERY_TRADABLE_USERS), 2), getTradableUsers = ref9[0], ref10 = ref9[1], dataTradableUsers = ref10.data, fetchMore = ref10.fetchMore, networkStatus = ref10.networkStatus, loadingTradableUsers = ref10.loading;
    var unit = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : ref1.units.find(function(unit) {
        var _skuId;
        return unit.id === decodeSkuId((_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : "");
    });
    var item = (data === null || data === void 0 ? void 0 : data.item) ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.item), {
        sku: unit !== null && unit !== void 0 ? unit : data.item.sku
    }) : null;
    (0,react.useEffect)(function() {
        if (!user) {
            showModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    var ref11;
    return {
        state: {
            loading: useInitialLoading(data, loading || loadingItemUserItemDetail),
            isLoggedIn: !!user,
            loadingTradableUsers: loadingTradableUsers,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(dataTradableUsers === null || dataTradableUsers === void 0 ? void 0 : (ref2 = dataTradableUsers.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tradableUsers) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage),
            item: item,
            tradableUsers: (ref11 = dataTradableUsers === null || dataTradableUsers === void 0 ? void 0 : (ref5 = dataTradableUsers.item) === null || ref5 === void 0 ? void 0 : ref5.tradableUsers) !== null && ref11 !== void 0 ? ref11 : null
        },
        actions: {
            onReply: function onReply() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onGetTradableUsers: function onGetTradableUsers() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, data, ref3, ref4;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getTradableUsers({
                                        variables: {
                                            itemId: router.query.itemId,
                                            pageInput: {
                                                /**
               * FIXME: トレード可能ユーザー一覧の表示にて、item.tradableUsersから
               * 「手持ちの(itemIdの)アイテムをすべてプロテクトしている」ユーザーを非表示にする処理を行なっており、ページネーションの動作が悪い。
               * そのため暫定的にlimitを上げることで解消している
               * https://app.clickup.com/t/908127/UT-15015
               */ limit: 100
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                if (!(data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.tradableUsers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.length)) {
                                    ;
                                    ;
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        itemId: (ref4 = data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref4 !== void 0 ? ref4 : "#",
                                        name: "tradableUsers"
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            itemId: router.query.itemId,
                                            pageInput: {
                                                cursor: dataTradableUsers === null || dataTradableUsers === void 0 ? void 0 : (ref = dataTradableUsers.item) === null || ref === void 0 ? void 0 : (ref1 = ref.tradableUsers) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor,
                                                limit: 100
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CollectionItemDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(CollectionItemDetail_viewModel_templateObject(), utoniq_core_schema/* ItemImageAreaFragmentDoc */.XMo, utoniq_core_schema/* SerialItemOwnersFragmentDoc */.o7b);
var QUERY_TRADABLE_USERS = (0,lib/* gql */.Ps)(CollectionItemDetail_viewModel_templateObject1(), utoniq_core_schema/* TradableUsersConnectionFragmentDoc */.cMJ);

;// CONCATENATED MODULE: ./src/components/pages/CollectionItemDetail/index.tsx




/**
 * CollectionItemDetail Page
 * Implemented as a practical sample.
 */ var CollectionItemDetail_CollectionItemDetail = function() {
    var ref = CollectionItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/layouts/ArtistHeaderItems.tsx
var ArtistHeaderItems = __webpack_require__(60722);
// EXTERNAL MODULE: ./src/components/layouts/ConsoleBaseLayout/index.tsx + 1 modules
var ConsoleBaseLayout = __webpack_require__(91456);
// EXTERNAL MODULE: ./src/lib/intercom/index.ts
var intercom = __webpack_require__(24316);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleAccountSetting/template/index.tsx













var ConsoleAccountSettingTemplate = function(param) {
    var state = param.state;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleAccountSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingTextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountManageListCell, {
                        user: state.user,
                        paymentType: state.paymentType
                    })
                ]
            })
        ]
    });
};
var HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleAccountSetting").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            sx: {
                py: 3
            },
            children: t("accountSetting")
        })
    });
};
var AccountManageListCell = function(param) {
    var user = param.user, paymentType = param.paymentType;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleAccountSetting").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var isBoundWithSNS = (0,auth/* useAuth */.aC)().isBoundWithSNS;
    var manages = [
        {
            title: t("emailAddressSetting"),
            href: routerPages.EmailSetting,
            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {})
            })
        },
        {
            title: t("passwordSetting"),
            href: routerPages.PasswordSetting,
            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {})
            })
        },
        {
            title: t("integrations"),
            href: routerPages.Integrations,
            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {})
            })
        },
        {
            title: t("profileSetting"),
            href: routerPages.ConsoleMyProfileEdit
        },
        {
            title: t("accountInformationSetting"),
            href: routerPages.ConsoleBankEdit
        },
        {
            title: t("businessInformationSetting"),
            href: routerPages.ConsoleBusinessEdit
        },
        {
            title: t("cryptoWalletSetting"),
            href: routerPages.ConsoleCryptocurrencyWallet
        },
        {
            title: t("inquiry"),
            component: "button",
            onClick: function onClick() {
                (0,intercom/* updateIntercom */.dC)(user);
                (0,intercom/* openIntercom */.B6)();
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
            children: manages.map(function(manage) {
                if (paymentType !== utoniq_core_schema/* ArtistPaymentType.Connect */.bBx.Connect && (manage.title === t("accountInformationSetting") || manage.title === t("businessInformationSetting"))) {
                    return null;
                }
                if ((!config_config/* config.platform.includes */.v.platform.includes("web") || /**
               * @description
               * Diica以外の場合、SNS認証機能解放
               * （DiicaはSNS連携時のUtoniqアイコンの表示をしてはいけないため、SNSリンク機能を隠す）
               */ config_config/* config.applicationKey */.v.applicationKey === "diica") && manage.title === t("integrations")) return null;
                if (!config_config/* config.nft */.v.nft && manage.title === t("cryptoWalletSetting")) return null;
                if (manage.title === t("passwordSetting") && isBoundWithSNS) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, (0,src_object_spread/* default */.Z)({
                    divider: true,
                    sx: {
                        bgcolor: "grey.50",
                        width: "100%"
                    }
                }, manage), manage.title);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleAccountSetting/viewModel.ts

function ConsoleAccountSetting_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleAccountSetting($artistId: ID) {\n    artist(id: $artistId) {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleAccountSetting_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ConsoleAccountSetting_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleAccountSetting_viewModel_QUERY, {
        variables: {
            artistId: user === null || user === void 0 ? void 0 : user.uid
        }
    }).data;
    var ref4, ref5, ref6;
    return {
        state: {
            user: user,
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            currentUser: user !== null && user !== void 0 ? user : null,
            paymentType: (ref5 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.paymentType) !== null && ref5 !== void 0 ? ref5 : null,
            hasArrangingDeliveryItems: data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.hasArrangingDeliveryItems,
            membership: (ref6 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products) !== null && ref6 !== void 0 ? ref6 : undefined
        },
        actions: {}
    };
});
var ConsoleAccountSetting_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleAccountSetting_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleAccountSetting/index.tsx




/**
 * ConsoleAccountSetting Page
 * Implemented as a practical sample.
 */ var ConsoleAccountSetting = function() {
    var ref = ConsoleAccountSetting_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleAccountSettingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleBankEdit/template/BankEditForm.tsx











var BankEditForm_schema = function(o) {
    return {
        bankCode: o.string().regex(/^[0-9]{4}$/).label((0,core_form/* tLabel */.TQ)("consoleBankEdit.bankCode")),
        branchCode: o.string().regex(/^[0-9]{3}$/).label((0,core_form/* tLabel */.TQ)("consoleBankEdit.branchCode")),
        accountNumber: o.string().regex(/^[0-9]{7}$/).label((0,core_form/* tLabel */.TQ)("consoleBankEdit.accountNumber")),
        accountHolderName: o.string().label((0,core_form/* tLabel */.TQ)("consoleBankEdit.accountHolderName"))
    };
};
var BankEditForm = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBankEdit").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), openBankCode = ref1[0], setOpenBankCode = ref1[1];
    var ref2 = (0,react.useState)(false), openBranchCode = ref2[0], setOpenBranchCode = ref2[1];
    var ref3 = (0,core_form/* useForm */.cI)({
        schema: BankEditForm_schema,
        defaultValues: BankEditForm_defaultValues
    }), handleSubmit = ref3.handleSubmit, _formState = ref3.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, register = ref3.register, reset = ref3.reset, setError = ref3.setError;
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).then(function() {
                                reset(BankEditForm_defaultValues);
                                showMessage(t("registerSuccess"), "success");
                            }).catch(function(error) {
                                return (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        sx: {
            px: 5,
            bgcolor: "background.default"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankEditForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                mask: "0000",
                titleProps: {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            t("bankCodeTitle"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                                size: "small",
                                onClick: function() {
                                    return setOpenBankCode(true);
                                },
                                color: "primary.main"
                            })
                        ]
                    })
                },
                error: errors === null || errors === void 0 ? void 0 : errors.bankCode
            }, register("bankCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankEditForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                mask: "000",
                titleProps: {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            t("branchCodeTitle"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                                size: "small",
                                onClick: function() {
                                    return setOpenBranchCode(true);
                                },
                                color: "primary.main"
                            })
                        ]
                    })
                },
                error: errors === null || errors === void 0 ? void 0 : errors.branchCode
            }, register("branchCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankEditForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                mask: "0000000",
                error: errors === null || errors === void 0 ? void 0 : errors.accountNumber
            }, register("accountNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BankEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.accountHolderName
            }, register("accountHolderName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 4,
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        loading: isSubmitting,
                        type: "submit",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        disabled: !isValid || isSubmitting,
                        children: t("register")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                        variant: "subtitle1",
                        color: "primary",
                        href: "https://about.utoniq.com/#contact",
                        target: "_blank",
                        component: "a",
                        rel: "noopener noreferrer",
                        children: t("clickHere")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InfoModal, {
                type: "help",
                open: openBankCode,
                onClose: function() {
                    return setOpenBankCode(false);
                },
                title: t("bankCodeModalTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("bankCodeModalDesc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                            variant: "caption",
                            color: "primary",
                            href: "https://zengin.ajtw.net/",
                            target: "_blank",
                            component: "a",
                            rel: "noopener noreferrer",
                            children: t("linkToOtherBank")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InfoModal, {
                type: "help",
                open: openBranchCode,
                onClose: function() {
                    return setOpenBranchCode(false);
                },
                title: t("branchCodeModalTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t("branchCodeModalDesc")
                })
            })
        ]
    });
};
var BankEditForm_MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBankEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: (0,src_object_spread/* default */.Z)({
                variant: "h5",
                color: "text.primary",
                sx: {
                    alignItems: "center",
                    display: "flex"
                }
            }, titleProps),
            textFieldProps: textFieldProps,
            ref: ref,
            t: t,
            error: error,
            placeholder: t("".concat(props.name, "Placeholder"))
        }))
    });
});
var BankEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBankEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: (0,src_object_spread/* default */.Z)({
                variant: "h5",
                color: "text.primary",
                sx: {
                    alignItems: "center",
                    display: "flex"
                }
            }, titleProps),
            textFieldProps: textFieldProps,
            error: error,
            ref: ref,
            t: t
        }))
    });
});
var BankEditForm_defaultValues = {
    bankCode: "",
    branchCode: "",
    accountNumber: "",
    accountHolderName: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleBankEdit/template/index.tsx










var ConsoleBankEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBankEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleBankEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                hasConsoleFooter: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleAccountSetting,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentAccountCell, {
                        artist: state.artist
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BankEditForm, {
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};
var CurrentAccountCell = function(param) {
    var artist = param.artist;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBankEdit").t;
    var bankInfo = (0,react.useMemo)(function() {
        if (!(artist === null || artist === void 0 ? void 0 : artist.bank)) {
            return;
        }
        var _bank = artist.bank, bankName = _bank.bankName, routingNumber = _bank.routingNumber, accountHolderName = _bank.accountHolderName, last4 = _bank.last4;
        return [
            bankName,
            "".concat(routingNumber.slice(4), " ***").concat(last4),
            accountHolderName, 
        ].join("\n");
    }, [
        artist === null || artist === void 0 ? void 0 : artist.bank
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 5,
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("registeredAccountInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 5
                },
                children: bankInfo !== null && bankInfo !== void 0 ? bankInfo : t("unregistered")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleBankEdit/viewModel.ts




function ConsoleBankEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleBankEdit {\n    artist {\n      id\n      bank {\n        id\n        accountHolderName\n        accountHolderType\n        bankName\n        last4\n        routingNumber\n      }\n    }\n  }\n"
    ]);
    ConsoleBankEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleBankEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateBank($inputs: BankInput) {\n    updateBank(inputs: $inputs) {\n      id\n      bank {\n        id\n        accountHolderName\n        accountHolderType\n        bankName\n        last4\n        routingNumber\n      }\n    }\n  }\n"
    ]);
    ConsoleBankEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ConsoleBankEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleBankEdit_viewModel_QUERY).data;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_BANK), 1), updateBank = ref[0];
    var ref1, ref2;
    return {
        state: {
            artistId: (ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : "",
            artist: (ref2 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateBank({
                                        variables: {
                                            inputs: values
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleBankEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleBankEdit_viewModel_templateObject());
var UPDATE_BANK = (0,lib/* gql */.Ps)(ConsoleBankEdit_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleBankEdit/index.tsx




/**
 * ConsoleBankEdit Page
 * Implemented as a practical sample.
 */ var ConsoleBankEdit = function() {
    var ref = ConsoleBankEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBankEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/lib/errorHandler/chunkLoadError.ts
var chunkLoadError = __webpack_require__(91386);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleBusinessEdit/template/index.tsx











var ConsoleBusinessEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onGetAddressInfoByCode = param.onGetAddressInfoByCode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBusinessEdit").t;
    var ref32 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref32.routerNames, routerPages = ref32.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                title: t("businessInformationSettings"),
                back: true,
                defaultBackPage: routerPages.ConsoleAccountSetting
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleBusinessEdit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 5,
                        pb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pb: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("registeredContactInformation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: ((ref = state.artistData) === null || ref === void 0 ? void 0 : (ref1 = ref.artist) === null || ref1 === void 0 ? void 0 : ref1.business) ? [
                                        "".concat((ref2 = state.artistData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.artist) === null || ref3 === void 0 ? void 0 : ref3.business.lastNameKanji).concat((ref4 = state.artistData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.artist) === null || ref5 === void 0 ? void 0 : ref5.business.firstNameKanji),
                                        t("".concat((ref6 = state.artistData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.artist) === null || ref7 === void 0 ? void 0 : ref7.business.gender)),
                                        (ref8 = state.artistData) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.artist) === null || ref9 === void 0 ? void 0 : ref9.business.formattedBirthday,
                                        (ref10 = state.artistData) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.artist) === null || ref11 === void 0 ? void 0 : ref11.business.phone, 
                                    ].join("\n") : t("Unregistered")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pb: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("registeredAddress")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: ((ref12 = state.artistData) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.artist) === null || ref13 === void 0 ? void 0 : ref13.business) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (ref16 = (ref14 = state.artistData) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.artist) === null || ref15 === void 0 ? void 0 : ref15.business.addressKanji) === null || ref16 === void 0 ? void 0 : ref16.postalCode.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                                                return String.fromCharCode(s.charCodeAt(0) - 65248);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            (ref19 = (ref17 = state.artistData) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.artist) === null || ref18 === void 0 ? void 0 : ref18.business.addressKanji) === null || ref19 === void 0 ? void 0 : ref19.state,
                                            (ref22 = (ref20 = state.artistData) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.artist) === null || ref21 === void 0 ? void 0 : ref21.business.addressKanji) === null || ref22 === void 0 ? void 0 : ref22.city,
                                            (ref25 = (ref23 = state.artistData) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.artist) === null || ref24 === void 0 ? void 0 : ref24.business.addressKanji) === null || ref25 === void 0 ? void 0 : ref25.town,
                                            (ref28 = (ref26 = state.artistData) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.artist) === null || ref27 === void 0 ? void 0 : ref27.business.addressKanji) === null || ref28 === void 0 ? void 0 : ref28.line1,
                                            (ref31 = (ref29 = state.artistData) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.artist) === null || ref30 === void 0 ? void 0 : ref30.business.addressKanji) === null || ref31 === void 0 ? void 0 : ref31.line2
                                        ]
                                    }) : t("Unregistered")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBusinessEditForm, {
                            onSubmit: onSubmit,
                            onGetAddressInfoByCode: onGetAddressInfoByCode
                        })
                    ]
                })
            ]
        })
    });
};
var ConsoleBusinessEditForm = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 28340)).then(function(m) {
    return m.ConsoleBusinessEditForm;
}).catch(function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28340)
            ];
        }
    },
    ssr: false
});

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
;// CONCATENATED MODULE: ./src/lib/zipCloud/index.ts

var api = axios/* default.create */.Z.create({
    baseURL: "https://zipcloud.ibsnet.co.jp/api/"
});
var getAddressInfoByZipcode = function(code) {
    return api.get("/search?zipcode=".concat(code)).then(function(res) {
        return res.data;
    });
};


;// CONCATENATED MODULE: ./src/components/pages/ConsoleBusinessEdit/viewModel.ts






function ConsoleBusinessEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleBusinessEdit {\n    artist {\n      id\n      bank {\n        id\n        accountHolderName\n        accountHolderType\n        bankName\n        last4\n        routingNumber\n      }\n      business {\n        ...BusinessDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleBusinessEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleBusinessEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation BusinessEdit($updateBusinessInputs: BusinessInput) {\n    updateBusiness(inputs: $updateBusinessInputs) {\n      id\n      business {\n        ...BusinessDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleBusinessEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConsoleBusinessEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleBusinessEdit_viewModel_QUERY).data;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(MUTATION), 1), businessEdit = ref[0];
    var ref1;
    return {
        state: {
            artistData: data !== null && data !== void 0 ? data : null,
            artistId: (ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : ""
        },
        actions: {
            onSubmit: function onSubmit(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var city, cityKana, line1, line1Kana, line2, line2Kana, postalCode, state, stateKana, town, townKana, birthday, inputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                city = _param.city, cityKana = _param.cityKana, line1 = _param.line1, line1Kana = _param.line1Kana, line2 = _param.line2, line2Kana = _param.line2Kana, postalCode = _param.postalCode, state = _param.state, stateKana = _param.stateKana, town = _param.town, townKana = _param.townKana, birthday = _param.birthday, inputs = (0,_object_without_properties/* default */.Z)(_param, [
                                    "city",
                                    "cityKana",
                                    "line1",
                                    "line1Kana",
                                    "line2",
                                    "line2Kana",
                                    "postalCode",
                                    "state",
                                    "stateKana",
                                    "town",
                                    "townKana",
                                    "birthday"
                                ]);
                                return [
                                    4,
                                    businessEdit({
                                        variables: {
                                            updateBusinessInputs: (0,src_object_spread/* default */.Z)({
                                                addressKanji: {
                                                    city: city,
                                                    line1: line1,
                                                    line2: line2,
                                                    postalCode: postalCode,
                                                    state: state,
                                                    town: town
                                                },
                                                addressKana: {
                                                    city: cityKana,
                                                    line1: line1Kana,
                                                    line2: line2Kana,
                                                    postalCode: postalCode,
                                                    state: stateKana,
                                                    town: townKana
                                                },
                                                birthday: dayjs_min_default()(birthday).format("YYYY-MM-DD")
                                            }, inputs)
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGetAddressInfoByCode: function onGetAddressInfoByCode(postalCode) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var results;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getAddressInfoByZipcode(postalCode)
                                ];
                            case 1:
                                results = _state.sent().results;
                                return [
                                    2,
                                    results
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleBusinessEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleBusinessEdit_viewModel_templateObject(), utoniq_core_schema/* BusinessDetailFragmentDoc */.zow);
var MUTATION = (0,lib/* gql */.Ps)(ConsoleBusinessEdit_viewModel_templateObject1(), utoniq_core_schema/* BusinessDetailFragmentDoc */.zow);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleBusinessEdit/index.tsx




/**
 * ConsoleCampaignDetail Page
 * Implemented as a practical sample.
 */ var ConsoleBusinessEdit = function() {
    var ref = ConsoleBusinessEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBusinessEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.js
var react_hook_form_dist_index_esm = __webpack_require__(94106);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignBannerSetting/template/ConsoleCampaignBannerSettingForm.tsx
















var ConsoleCampaignBannerSettingForm_schema = function(o) {
    return {
        banners: o.array().items(o.object({
            tmpPath: o.string().allow("").optional(),
            link: o.object().when("tmpPath", {
                is: "",
                then: o.object({
                    externalUrl: o.string().optional().allow(""),
                    innerPath: o.string().optional().allow("")
                }).optional(),
                otherwise: o.object({
                    externalUrl: o.string().label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.link.externalUrl")),
                    innerPath: o.string().optional().allow("")
                })
            })
        })),
        bannersStartedAt: o.date().allow(null, "").optional().custom(function(value, helpers) {
            var ref;
            if (!value) {
                return value;
            }
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            // 開始日・終了日の順序チェック
            var dateOrderResult = (0,validators/* validateBannerDateOrder */.n$)(value, helpers, data, "bannersStartedAt", "bannersEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.invalidDateOrder");
            if (dateOrderResult !== value) {
                return dateOrderResult;
            }
            // 予約バナーとの重複チェック
            var overlapResult = (0,validators/* validatePublicBannerOverlap */.$h)(value, helpers, data, "reservationBannerStartedAt", "reservationBannerEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.overlapReservation");
            if (overlapResult !== value) {
                return overlapResult;
            }
            // 予約バナーとの前後関係チェック
            var orderResult = (0,validators/* validatePublicBannerEndDate */.zv)(value, helpers, data, "bannersStartedAt", "reservationBannerStartedAt", "reservationBannerEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.overlapReservation", "consoleCampaignBannerSetting.bannersStartedAt.custom.publicBeforeReservation");
            if (orderResult !== value) {
                return orderResult;
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.startedAt")),
        bannersEndedAt: o.date().allow(null, "").optional().custom(function(value, helpers) {
            var ref;
            if (!value) {
                return value;
            }
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            // 開始日・終了日の順序チェック
            var dateOrderResult = (0,validators/* validateBannerDateOrder */.n$)(value, helpers, data, "bannersStartedAt", "bannersEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.invalidDateOrder");
            if (dateOrderResult !== value) {
                return dateOrderResult;
            }
            // 予約バナーとの重複チェック
            var overlapResult = (0,validators/* validatePublicBannerOverlap */.$h)(value, helpers, data, "reservationBannerStartedAt", "reservationBannerEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.overlapReservation");
            if (overlapResult !== value) {
                return overlapResult;
            }
            // 予約バナーとの前後関係チェック
            var endDateResult = (0,validators/* validatePublicBannerEndDate */.zv)(value, helpers, data, "bannersStartedAt", "reservationBannerStartedAt", "reservationBannerEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.overlapReservation", "consoleCampaignBannerSetting.bannersEndedAt.custom.publicBeforeReservation");
            if (endDateResult !== value) {
                return endDateResult;
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.endedAt")),
        bannersStatus: o.boolean().allow(false).optional(),
        reservationBannerStartedAt: o.date().allow(null, "").optional(),
        reservationBannerEndedAt: o.date().allow(null, "").optional()
    };
};
var ConsoleCampaignBannerSettingForm = function(param) {
    var loading = param.loading, bannerSettings = param.bannerSettings, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, isReservationBanners = param.isReservationBanners, reservationBannerStartedAt = param.reservationBannerStartedAt, reservationBannerEndedAt = param.reservationBannerEndedAt;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignBannerSetting").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: ConsoleCampaignBannerSettingForm_schema,
        defaultValues: (0,src_object_spread/* default */.Z)({}, ConsoleCampaignBannerSettingForm_defaultValues)
    }), handleSubmit = ref2.handleSubmit, register = ref2.register, setValue = ref2.setValue, reset = ref2.reset, setError = ref2.setError, control = ref2.control, watch = ref2.watch, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "banners"
    }).fields;
    (0,react.useEffect)(function() {
        // isReservationBannersが変更された時にフォームをリセット
        reset(ConsoleCampaignBannerSettingForm_defaultValues);
    }, [
        isReservationBanners,
        reset
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        // 予約バナーの値を設定
        if (reservationBannerStartedAt || reservationBannerEndedAt) {
            setValue("reservationBannerStartedAt", reservationBannerStartedAt || "");
            setValue("reservationBannerEndedAt", reservationBannerEndedAt || "");
        }
        if (!(bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.length)) {
            reset((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ConsoleCampaignBannerSettingForm_defaultValues), {
                reservationBannerStartedAt: reservationBannerStartedAt || "",
                reservationBannerEndedAt: reservationBannerEndedAt || ""
            }));
            return;
        }
        var ref4, ref5, _uri, ref6, ref7;
        reset({
            banners: (ref = ConsoleCampaignBannerSettingForm_defaultValues.banners) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                var ref, ref1, ref2, ref3, ref6;
                return {
                    link: {
                        externalUrl: (ref5 = (ref4 = (ref = bannerSettings[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.link) === null || ref1 === void 0 ? void 0 : ref1.externalUrl) !== null && ref4 !== void 0 ? ref4 : (ref2 = bannerSettings[index]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.link) === null || ref3 === void 0 ? void 0 : ref3.innerPath) !== null && ref5 !== void 0 ? ref5 : "",
                        innerPath: ""
                    },
                    tmpPath: (_uri = (ref6 = bannerSettings[index]) === null || ref6 === void 0 ? void 0 : ref6.thumbnail.uri) !== null && _uri !== void 0 ? _uri : ""
                };
            }),
            bannersStartedAt: (ref6 = (ref1 = bannerSettings[0]) === null || ref1 === void 0 ? void 0 : ref1.bannersStartedAt) !== null && ref6 !== void 0 ? ref6 : "",
            bannersEndedAt: (ref7 = (ref2 = bannerSettings[0]) === null || ref2 === void 0 ? void 0 : ref2.bannersEndedAt) !== null && ref7 !== void 0 ? ref7 : "",
            bannersStatus: ((ref3 = bannerSettings[0]) === null || ref3 === void 0 ? void 0 : ref3.bannerStatus) === "published" || false,
            reservationBannerStartedAt: reservationBannerStartedAt !== null && reservationBannerStartedAt !== void 0 ? reservationBannerStartedAt : "",
            reservationBannerEndedAt: reservationBannerEndedAt !== null && reservationBannerEndedAt !== void 0 ? reservationBannerEndedAt : ""
        });
    }, [
        bannerSettings,
        reset,
        reservationBannerStartedAt,
        reservationBannerEndedAt,
        setValue, 
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit(values, isReservationBanners).then(function() {
            showMessage(t("registerBannerSuccess"), "success");
        }).catch(function(e) {
            (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: "text.primary",
                            mb: 2,
                            fontSize: "16px",
                            fontWeight: "bold"
                        },
                        children: t("addedBannerImage", "バナー画像を追加")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mb: 3
                        },
                        children: t("campaignBannerSettingDesc", "サービストップ画面に表示するバナーを最大3つまで登録することができます。")
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: (ref = ConsoleCampaignBannerSettingForm_defaultValues.banners) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            borderRadius: 2
                        },
                        width: "100%",
                        height: 124
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: [
                    fields.map(function(field, index) {
                        var ref, ref1, ref2, ref4, ref5;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CampaignBannerCell, {
                            index: index,
                            thumbnailUploadInfo: fileUploadInfo,
                            setValue: setValue,
                            defaultValue: (ref3 = bannerSettings === null || bannerSettings === void 0 ? void 0 : (ref = bannerSettings[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref3 !== void 0 ? ref3 : "",
                            inputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("banners.".concat(index, ".link.externalUrl"))), {
                                error: (ref2 = errors.banners) === null || ref2 === void 0 ? void 0 : (ref4 = ref2[index]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.link) === null || ref5 === void 0 ? void 0 : ref5.externalUrl,
                                type: "text"
                            })
                        }, field.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, {
                        checked: watch("bannersStatus"),
                        onChange: function() {
                            var currentValue = watch("bannersStatus");
                            setValue("bannersStatus", !currentValue, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        content: {
                            title: t("bannerStatus"),
                            description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                sx: {
                                    width: 335,
                                    height: 60,
                                    fontSize: 13,
                                    color: "text.secondary"
                                },
                                children: t("bannerStatusDesc")
                            })
                        },
                        sx: {
                            px: 0,
                            pt: 0,
                            "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                bgcolor: "primary.main"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                                onChange: function(date) {
                                    setValue("bannersStartedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                },
                                value: watch("bannersStartedAt") ? dayjs_min_default()(watch("bannersStartedAt")) : null,
                                title: t("startedAt"),
                                description: t("startedAtDesc"),
                                placeholder: t("startedAtPlaceholder"),
                                error: errors === null || errors === void 0 ? void 0 : errors.bannersStartedAt,
                                titleProps: {
                                    variant: "subtitle1",
                                    color: "text.primary"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                                onChange: function(date) {
                                    setValue("bannersEndedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                },
                                value: watch("bannersEndedAt") ? dayjs_min_default()(watch("bannersEndedAt")) : null,
                                title: t("endedAt"),
                                description: t("endedAtDesc"),
                                placeholder: t("endedAtPlaceholder"),
                                error: errors === null || errors === void 0 ? void 0 : errors.bannersEndedAt,
                                titleProps: {
                                    variant: "subtitle1",
                                    color: "text.primary"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("submit", "登録する")
                })
            })
        ]
    });
};
var CampaignBannerCell = function(param) {
    var index = param.index, defaultValue = param.defaultValue, inputProps = param.inputProps, thumbnailUploadInfo = param.thumbnailUploadInfo, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBusinessEdit").t;
    var ref = (0,react.useState)(""), imageUrl = ref[0], setImageUrl = ref[1];
    (0,react.useEffect)(function() {
        setImageUrl(defaultValue);
    }, [
        defaultValue
    ]);
    var handleUploadFile = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var result, _imageUrl, _imageUploadPath;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        thumbnailUploadInfo.onDrop()
                    ];
                case 1:
                    result = _state.sent();
                    if (!result) return [
                        2
                    ];
                    setImageUrl((_imageUrl = result.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "");
                    setValue("banners.".concat(index, ".tmpPath"), (_imageUploadPath = result.imageUploadPath) !== null && _imageUploadPath !== void 0 ? _imageUploadPath : "", {
                        shouldValidate: true
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        thumbnailUploadInfo,
        setValue,
        index
    ]);
    var handleRemoveUploadFile = (0,react.useCallback)(function() {
        setValue("banners.".concat(index, ".tmpPath"), "");
        setValue("banners.".concat(index, ".link.externalUrl"), "");
        setImageUrl("");
    }, [
        setValue,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderWidth: 1,
                borderColor: "grey.100",
                borderStyle: "dashed",
                bgcolor: "transparent",
                borderRadius: 2,
                width: imageUrl ? "100%" : "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        children: !!imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
                                color: "error"
                            }),
                            color: "error",
                            onClick: handleRemoveUploadFile,
                            children: t("delete", "削除する")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2
                        },
                        children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: imageUrl,
                            sx: {
                                height: 124,
                                width: "100%"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Drop, {
                                    sx: {
                                        width: 56,
                                        height: 46,
                                        color: "grey.400"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.hint",
                                    children: t("addedBannerImageDesc", "幅750px 高さ315px / PNG・JPEG・HEICファイル")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "outlined",
                                    size: "small",
                                    sx: {
                                        width: "fit-content"
                                    },
                                    onClick: handleUploadFile,
                                    children: t("selectFiles", "ファイルを選択")
                                })
                            ]
                        })
                    }),
                    !!imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignBannerSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({}, inputProps))
                    })
                ]
            })
        })
    });
};
var ConsoleCampaignBannerSettingForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBusinessEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: {
                variant: "h6",
                color: "text.primary",
                children: t("linkURL", "リンク先のURL")
            },
            textFieldProps: {
                sx: {
                    mb: 0,
                    fieldset: {
                        border: "none"
                    },
                    input: {
                        p: 0
                    }
                },
                helperText: error === null || error === void 0 ? void 0 : error.message,
                placeholder: t("inputLinkURLPlaceholder", "入力してください (例 https://xxxxxx)")
            },
            error: error,
            ref: ref,
            t: t
        }))
    });
});
var ConsoleCampaignBannerSettingForm_defaultValues = {
    banners: [
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        },
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        },
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        }, 
    ],
    bannersStartedAt: "",
    bannersEndedAt: "",
    bannersStatus: false,
    reservationBannerStartedAt: "",
    reservationBannerEndedAt: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignBannerSetting/template/ConsoleCampaignReservationBannerSettingForm.tsx
















var ConsoleCampaignReservationBannerSettingForm_schema = function(o) {
    return {
        banners: o.array().items(o.object({
            tmpPath: o.string().allow("").optional(),
            link: o.object().when("tmpPath", {
                is: "",
                then: o.object({
                    externalUrl: o.string().optional().allow(""),
                    innerPath: o.string().optional().allow("")
                }).optional(),
                otherwise: o.object({
                    externalUrl: o.string().label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.link.externalUrl")),
                    innerPath: o.string().optional().allow("")
                })
            })
        })),
        bannersStartedAt: o.date().allow("").optional().custom(function(value, helpers) {
            var ref;
            if (!value) {
                return value;
            }
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            // 開始日・終了日の順序チェック
            var dateOrderResult = (0,validators/* validateBannerDateOrder */.n$)(value, helpers, data, "bannersStartedAt", "bannersEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.invalidDateOrder");
            if (dateOrderResult !== value) {
                return dateOrderResult;
            }
            // 公開バナーの終了日時が設定されているかチェック
            var endDateRequiredResult = (0,validators/* validatePublicBannerEndDateRequired */.Jf)(value, helpers, data, "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.publicEndDateRequired");
            if (endDateRequiredResult !== value) {
                return endDateRequiredResult;
            }
            // 公開バナーとの重複チェック
            var overlapResult = (0,validators/* validateReservationBannerOverlap */.Kv)(value, helpers, data, "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.overlapPublic");
            if (overlapResult !== value) {
                return overlapResult;
            }
            // 公開バナーとの前後関係チェック
            var orderResult = (0,validators/* validateReservationBannerEndDate */.pu)(value, helpers, data, "bannersStartedAt", "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersStartedAt.custom.overlapPublic", "consoleCampaignBannerSetting.bannersStartedAt.custom.reservationAfterPublic");
            if (orderResult !== value) {
                return orderResult;
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.startedAt")),
        bannersEndedAt: o.date().allow("").optional().custom(function(value, helpers) {
            var ref;
            if (!value) {
                return value;
            }
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            // 開始日・終了日の順序チェック
            var dateOrderResult = (0,validators/* validateBannerDateOrder */.n$)(value, helpers, data, "bannersStartedAt", "bannersEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.invalidDateOrder");
            if (dateOrderResult !== value) {
                return dateOrderResult;
            }
            // 公開バナーの終了日時が設定されているかチェック
            var endDateRequiredResult = (0,validators/* validatePublicBannerEndDateRequired */.Jf)(value, helpers, data, "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.publicEndDateRequired");
            if (endDateRequiredResult !== value) {
                return endDateRequiredResult;
            }
            // 公開バナーとの重複チェック
            var overlapResult = (0,validators/* validateReservationBannerOverlap */.Kv)(value, helpers, data, "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.overlapPublic");
            if (overlapResult !== value) {
                return overlapResult;
            }
            // 公開バナーとの前後関係チェック
            var endDateResult = (0,validators/* validateReservationBannerEndDate */.pu)(value, helpers, data, "bannersStartedAt", "publicBannerStartedAt", "publicBannerEndedAt", "consoleCampaignBannerSetting.bannersEndedAt.custom.overlapPublic", "consoleCampaignBannerSetting.bannersEndedAt.custom.reservationAfterPublic");
            if (endDateResult !== value) {
                return endDateResult;
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleCampaignBannerSetting.endedAt")),
        bannersStatus: o.boolean().allow(false).optional(),
        publicBannerStartedAt: o.date().allow(null, "").optional(),
        publicBannerEndedAt: o.date().allow(null, "").optional()
    };
};
var ConsoleCampaignReservationBannerSettingForm = function(param) {
    var loading = param.loading, bannerSettings = param.bannerSettings, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, isReservationBanners = param.isReservationBanners, publicBannerStartedAt = param.publicBannerStartedAt, publicBannerEndedAt = param.publicBannerEndedAt;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignBannerSetting").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: ConsoleCampaignReservationBannerSettingForm_schema,
        defaultValues: (0,src_object_spread/* default */.Z)({}, ConsoleCampaignReservationBannerSettingForm_defaultValues)
    }), handleSubmit = ref2.handleSubmit, register = ref2.register, setValue = ref2.setValue, reset = ref2.reset, setError = ref2.setError, control = ref2.control, watch = ref2.watch, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "banners"
    }).fields;
    (0,react.useEffect)(function() {
        // isReservationBannersが変更された時にフォームをリセット
        reset(ConsoleCampaignReservationBannerSettingForm_defaultValues);
    }, [
        isReservationBanners,
        reset
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        // 公開バナーの値を設定
        if (publicBannerStartedAt || publicBannerEndedAt) {
            setValue("publicBannerStartedAt", publicBannerStartedAt || "");
            setValue("publicBannerEndedAt", publicBannerEndedAt || "");
        }
        if (!(bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.length)) {
            reset((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ConsoleCampaignReservationBannerSettingForm_defaultValues), {
                publicBannerStartedAt: publicBannerStartedAt || "",
                publicBannerEndedAt: publicBannerEndedAt || ""
            }));
            return;
        }
        var ref4, ref5, _uri, ref6, ref7;
        reset({
            banners: (ref = ConsoleCampaignReservationBannerSettingForm_defaultValues.banners) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                var ref, ref1, ref2, ref3, ref6;
                return {
                    link: {
                        externalUrl: (ref5 = (ref4 = (ref = bannerSettings[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.link) === null || ref1 === void 0 ? void 0 : ref1.externalUrl) !== null && ref4 !== void 0 ? ref4 : (ref2 = bannerSettings[index]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.link) === null || ref3 === void 0 ? void 0 : ref3.innerPath) !== null && ref5 !== void 0 ? ref5 : "",
                        innerPath: ""
                    },
                    tmpPath: (_uri = (ref6 = bannerSettings[index]) === null || ref6 === void 0 ? void 0 : ref6.thumbnail.uri) !== null && _uri !== void 0 ? _uri : ""
                };
            }),
            bannersStartedAt: (ref6 = (ref1 = bannerSettings[0]) === null || ref1 === void 0 ? void 0 : ref1.bannersStartedAt) !== null && ref6 !== void 0 ? ref6 : "",
            bannersEndedAt: (ref7 = (ref2 = bannerSettings[0]) === null || ref2 === void 0 ? void 0 : ref2.bannersEndedAt) !== null && ref7 !== void 0 ? ref7 : "",
            bannersStatus: ((ref3 = bannerSettings[0]) === null || ref3 === void 0 ? void 0 : ref3.bannerStatus) === "published" || false,
            publicBannerStartedAt: publicBannerStartedAt !== null && publicBannerStartedAt !== void 0 ? publicBannerStartedAt : "",
            publicBannerEndedAt: publicBannerEndedAt !== null && publicBannerEndedAt !== void 0 ? publicBannerEndedAt : ""
        });
    }, [
        bannerSettings,
        reset,
        publicBannerStartedAt,
        publicBannerEndedAt,
        setValue, 
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit(values, isReservationBanners).then(function() {
            showMessage(t("registerBannerSuccess"), "success");
        }).catch(function(e) {
            (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            color: "text.primary",
                            mb: 2,
                            fontSize: "16px",
                            fontWeight: "bold"
                        },
                        children: t("addedBannerImage", "バナー画像を追加")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mb: 3
                        },
                        children: t("campaignBannerSettingDesc", "サービストップ画面に表示するバナーを最大3つまで登録することができます。")
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: (ref = ConsoleCampaignReservationBannerSettingForm_defaultValues.banners) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            borderRadius: 2
                        },
                        width: "100%",
                        height: 124
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: [
                    fields.map(function(field, index) {
                        var ref, ref1, ref2, ref4, ref5;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConsoleCampaignReservationBannerSettingForm_CampaignBannerCell, {
                            index: index,
                            thumbnailUploadInfo: fileUploadInfo,
                            setValue: setValue,
                            defaultValue: (ref3 = bannerSettings === null || bannerSettings === void 0 ? void 0 : (ref = bannerSettings[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref3 !== void 0 ? ref3 : "",
                            inputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("banners.".concat(index, ".link.externalUrl"))), {
                                error: (ref2 = errors.banners) === null || ref2 === void 0 ? void 0 : (ref4 = ref2[index]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.link) === null || ref5 === void 0 ? void 0 : ref5.externalUrl,
                                type: "text"
                            })
                        }, field.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, {
                        checked: watch("bannersStatus"),
                        onChange: function() {
                            var currentValue = watch("bannersStatus");
                            setValue("bannersStatus", !currentValue, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        content: {
                            title: t("bannerStatus"),
                            description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                sx: {
                                    width: 335,
                                    height: 60,
                                    fontSize: 13,
                                    color: "text.secondary"
                                },
                                children: t("bannerStatusDesc")
                            })
                        },
                        sx: {
                            px: 0,
                            pt: 0,
                            "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                bgcolor: "primary.main"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                                onChange: function(date) {
                                    setValue("bannersStartedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                },
                                value: watch("bannersStartedAt") ? dayjs_min_default()(watch("bannersStartedAt")) : null,
                                title: t("startedAt"),
                                description: t("startedAtDesc"),
                                placeholder: t("startedAtPlaceholder"),
                                error: errors === null || errors === void 0 ? void 0 : errors.bannersStartedAt,
                                titleProps: {
                                    variant: "subtitle1",
                                    color: "text.primary"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                                onChange: function(date) {
                                    setValue("bannersEndedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                },
                                value: watch("bannersEndedAt") ? dayjs_min_default()(watch("bannersEndedAt")) : null,
                                title: t("endedAt"),
                                description: t("endedAtDesc"),
                                placeholder: t("endedAtPlaceholder"),
                                error: errors === null || errors === void 0 ? void 0 : errors.bannersEndedAt,
                                titleProps: {
                                    variant: "subtitle1",
                                    color: "text.primary"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: isSubmitting,
                    loading: isSubmitting,
                    children: t("submit", "登録する")
                })
            })
        ]
    });
};
var ConsoleCampaignReservationBannerSettingForm_CampaignBannerCell = function(param) {
    var index = param.index, defaultValue = param.defaultValue, inputProps = param.inputProps, thumbnailUploadInfo = param.thumbnailUploadInfo, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBusinessEdit").t;
    var ref = (0,react.useState)(""), imageUrl = ref[0], setImageUrl = ref[1];
    (0,react.useEffect)(function() {
        setImageUrl(defaultValue);
    }, [
        defaultValue
    ]);
    var handleUploadFile = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var result, _imageUrl, _imageUploadPath;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        thumbnailUploadInfo.onDrop()
                    ];
                case 1:
                    result = _state.sent();
                    if (!result) return [
                        2
                    ];
                    setImageUrl((_imageUrl = result.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "");
                    setValue("banners.".concat(index, ".tmpPath"), (_imageUploadPath = result.imageUploadPath) !== null && _imageUploadPath !== void 0 ? _imageUploadPath : "", {
                        shouldValidate: true
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        thumbnailUploadInfo,
        setValue,
        index
    ]);
    var handleRemoveUploadFile = (0,react.useCallback)(function() {
        setValue("banners.".concat(index, ".tmpPath"), "");
        setValue("banners.".concat(index, ".link.externalUrl"), "");
        setImageUrl("");
    }, [
        setValue,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderWidth: 1,
                borderColor: "grey.100",
                borderStyle: "dashed",
                bgcolor: "transparent",
                borderRadius: 2,
                width: imageUrl ? "100%" : "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        children: !!imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
                                color: "error"
                            }),
                            color: "error",
                            onClick: handleRemoveUploadFile,
                            children: t("delete", "削除する")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2
                        },
                        children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: imageUrl,
                            sx: {
                                height: 124,
                                width: "100%"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Drop, {
                                    sx: {
                                        width: 56,
                                        height: 46,
                                        color: "grey.400"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.hint",
                                    children: t("addedBannerImageDesc", "幅750px 高さ315px / PNG・JPEG・HEICファイル")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "outlined",
                                    size: "small",
                                    sx: {
                                        width: "fit-content"
                                    },
                                    onClick: handleUploadFile,
                                    children: t("selectFiles", "ファイルを選択")
                                })
                            ]
                        })
                    }),
                    !!imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignReservationBannerSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({}, inputProps))
                    })
                ]
            })
        })
    });
};
var ConsoleCampaignReservationBannerSettingForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleBusinessEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: {
                variant: "h6",
                color: "text.primary",
                children: t("linkURL", "リンク先のURL")
            },
            textFieldProps: {
                sx: {
                    mb: 0,
                    fieldset: {
                        border: "none"
                    },
                    input: {
                        p: 0
                    }
                },
                helperText: error === null || error === void 0 ? void 0 : error.message,
                placeholder: t("inputLinkURLPlaceholder", "入力してください (例 https://xxxxxx)")
            },
            error: error,
            ref: ref,
            t: t
        }))
    });
});
var ConsoleCampaignReservationBannerSettingForm_defaultValues = {
    banners: [
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        },
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        },
        {
            link: {
                externalUrl: "",
                innerPath: ""
            },
            tmpPath: ""
        }, 
    ],
    bannersStartedAt: "",
    bannersEndedAt: "",
    bannersStatus: false,
    publicBannerStartedAt: "",
    publicBannerEndedAt: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignBannerSetting/template/index.tsx










var ConsoleCampaignBannerSettingTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit, onTabChange = param.onTabChange;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignBannerSetting").t;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref8.routerNames, routerPages = ref8.routerPages;
    var ref9 = (0,react.useState)(0), tab = ref9[0], setTab = ref9[1];
    var handleTabChange = function(_, newValue) {
        setTab(newValue);
        onTabChange();
    };
    var isReservationBanners = tab === 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCampaignBannerSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleDashboard,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 6
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                value: tab,
                                onChange: handleTabChange,
                                sx: {
                                    borderBottom: "1px solid",
                                    borderColor: "grey.100"
                                },
                                variant: "fullWidth",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                        label: t("tabPublicBanner", "公開バナー"),
                                        sx: {
                                            color: "text.primary"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                        label: t("tabReservationBanner", "予約バナー"),
                                        sx: {
                                            color: "text.primary"
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    isReservationBanners ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignReservationBannerSettingForm, {
                        loading: state.loading,
                        bannerSettings: state.bannerSettingsReservation,
                        fileUploadInfo: {
                            progress: state.progress,
                            onDrop: onDrop
                        },
                        onSubmit: onSubmit,
                        isReservationBanners: isReservationBanners,
                        publicBannerStartedAt: (ref = state.bannerSettings) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.bannersStartedAt,
                        publicBannerEndedAt: (ref2 = state.bannerSettings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.bannersEndedAt
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignBannerSettingForm, {
                        loading: state.loading,
                        bannerSettings: state.bannerSettings,
                        fileUploadInfo: {
                            progress: state.progress,
                            onDrop: onDrop
                        },
                        onSubmit: onSubmit,
                        isReservationBanners: isReservationBanners,
                        reservationBannerStartedAt: (ref4 = state.bannerSettingsReservation) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.bannersStartedAt,
                        reservationBannerEndedAt: (ref6 = state.bannerSettingsReservation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.bannersEndedAt
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/core/resources/useTmpUploader.tsx + 1 modules
var useTmpUploader = __webpack_require__(21366);
// EXTERNAL MODULE: ./src/core/native/camera/index.ts
var camera = __webpack_require__(23087);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignBannerSetting/viewModel.ts






function ConsoleCampaignBannerSetting_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistBanners($artistId: ID!) {\n    artistBanners(artistId: $artistId) {\n      publishedBanners {\n        ...ArtistBannerDetail\n      }\n      reservedBanners {\n        ...ArtistBannerDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCampaignBannerSetting_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleCampaignBannerSetting_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation artistUpdateArtistBanners($input: ArtistUpdateArtistBannersInput!) {\n    artistUpdateArtistBanners(inputs: $input) {\n      id\n      banners {\n        ...ArtistBannerDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCampaignBannerSetting_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var ConsoleCampaignBannerSetting_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignBannerSetting").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var getImage = camera/* getImage */.g;
    var ref = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref.upload, progress = ref.progress;
    var ref1 = (0,useQuery/* useQuery */.aM)(ARTIST_BANNERS_QUERY, {
        variables: {
            artistId: (user === null || user === void 0 ? void 0 : user.uid) || ""
        },
        skip: !(user === null || user === void 0 ? void 0 : user.uid)
    }), data = ref1.data, loading = ref1.loading, refetch = ref1.refetch;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UPDATE_ARTIST_BANNERS), 1), artistUpdateArtistBanners = ref2[0];
    var onDrop = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function onDrop() {
            return _ref.apply(this, arguments);
        };
    }();
    var _publishedBanners, _reservedBanners, ref3;
    return {
        state: {
            bannerSettings: (_publishedBanners = data === null || data === void 0 ? void 0 : data.artistBanners.publishedBanners) !== null && _publishedBanners !== void 0 ? _publishedBanners : null,
            bannerSettingsReservation: (_reservedBanners = data === null || data === void 0 ? void 0 : data.artistBanners.reservedBanners) !== null && _reservedBanners !== void 0 ? _reservedBanners : null,
            loading: loading,
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            progress: progress
        },
        actions: {
            onDrop: function onDrop1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onDrop().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values, isReservationBanners) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _externalUrl, _externalUrl1, submittedValues;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                submittedValues = values.banners.filter(function(param) {
                                    var tmpPath = param.tmpPath, link = param.link;
                                    return tmpPath && link.externalUrl;
                                }).map(function(banner) {
                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, banner), {
                                        link: {
                                            externalUrl: isExternalURL((_externalUrl = banner.link.externalUrl) !== null && _externalUrl !== void 0 ? _externalUrl : "") ? banner.link.externalUrl : null,
                                            innerPath: !isExternalURL((_externalUrl1 = banner.link.externalUrl) !== null && _externalUrl1 !== void 0 ? _externalUrl1 : "") ? banner.link.externalUrl : null
                                        }
                                    });
                                }).reverse();
                                return [
                                    4,
                                    artistUpdateArtistBanners({
                                        variables: {
                                            input: {
                                                banners: submittedValues,
                                                status: values.bannersStatus ? utoniq_core_schema/* BannerStatus.Published */.zbG.Published : utoniq_core_schema/* BannerStatus.Unpublished */.zbG.Unpublished,
                                                startedAt: values.bannersStartedAt || null,
                                                endedAt: values.bannersEndedAt || null,
                                                isReservationBanners: isReservationBanners
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // 登録後にデータを再取得
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onTabChange: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // タブ変更時にデータを再取得
                            return [
                                4,
                                refetch()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var ARTIST_BANNERS_QUERY = (0,lib/* gql */.Ps)(ConsoleCampaignBannerSetting_viewModel_templateObject(), utoniq_core_schema/* ArtistBannerDetailFragmentDoc */.jU6);
var ARTIST_UPDATE_ARTIST_BANNERS = (0,lib/* gql */.Ps)(ConsoleCampaignBannerSetting_viewModel_templateObject1(), utoniq_core_schema/* ArtistBannerDetailFragmentDoc */.jU6);
function isExternalURL(url) {
    if (!url) return false;
    return /^http(s)?:\/\//.test(url);
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignBannerSetting/index.tsx




/**
 * ConsoleCampaignBannerSetting Page
 * Implemented as a practical sample.
 */ var ConsoleCampaignBannerSetting = function() {
    var ref = ConsoleCampaignBannerSetting_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignBannerSettingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/CampaignRankImage/index.tsx


var CampaignRankImage = function(param) {
    var loading = param.loading, _height = param.height, height = _height === void 0 ? 212 : _height, thumbnail = param.thumbnail;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            sx: {
                width: "100%",
                height: height
            }
        });
    }
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
        variant: "square",
        src: (ref1 = (ref = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.smallUri) !== null && ref !== void 0 ? ref : thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri) !== null && ref1 !== void 0 ? ref1 : "",
        sx: {
            width: "100%",
            height: height
        }
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/UploadBox/index.tsx



var FileType;
(function(FileType) {
    FileType["Audio"] = "audio";
    FileType["Magazine"] = "magazine";
    FileType["Video"] = "video";
    FileType["Image"] = "image";
})(FileType || (FileType = {}));
var UploadBox = function(param) {
    var type = param.type, filename = param.filename, applied = param.applied, onRemove = param.onRemove, onClick = param.onClick;
    if (!applied) {
        return null;
    }
    if (type === FileType.Image) {
        return null;
    }
    var Icon = icons[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        sx: {
            bgcolor: "grey.100",
            justifyContent: "space-between",
            height: 50,
            borderRadius: 1,
            px: 5
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 2,
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        fontSize: "small"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: filename
                    })
                ]
            }),
            onRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                size: "small",
                edge: "end",
                onClick: function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    onRemove(event);
                }
            })
        ]
    });
};
var icons = {
    video: dist.Icons.Video,
    audio: dist.Icons.Audio,
    magazine: dist.Icons.Magazine
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleCampaignItemBox/index.tsx











var rarityImage = {
    common: "".concat(config_config/* config.commonStorageUrl */.v.commonStorageUrl, "images/rarity/RarityOne.svg"),
    rare: "".concat(config_config/* config.commonStorageUrl */.v.commonStorageUrl, "images/rarity/RarityTwo.svg"),
    superrare: "".concat(config_config/* config.commonStorageUrl */.v.commonStorageUrl, "images/rarity/RarityThree.svg")
};
var ConsoleCampaignItemBox = function(param) {
    var _item = param.item, rarity = _item.rarity, image = _item.image, benefit = _item.benefit, hasBenefit = _item.hasBenefit, errors = param.errors, onUploadFile = param.onUploadFile, onRemoveFile = param.onRemoveFile, uploading = param.uploading;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var errorMessage = (0,react.useMemo)(function() {
        if (!errors || !errors.image && !errors.benefit) {
            return "";
        }
        return t("pleaseAddThumbnail");
    }, [
        errors,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderColor: errorMessage ? "error.main" : "grey.100",
            bgcolor: "background.default",
            borderStyle: "solid",
            borderRadius: 2,
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                sx: {
                    px: 5,
                    py: 3,
                    bgcolor: "grey.50"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        variant: "square",
                        src: rarityImage[rarity.id],
                        sx: {
                            height: 20,
                            width: "fit-content"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: rarity.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    px: 5,
                    pt: 4,
                    pb: 6
                },
                children: [
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            align: "center",
                            sx: {
                                color: "error.main",
                                py: 4
                            },
                            children: errorMessage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailBox, {
                        onUpload: onUploadFile,
                        image: image,
                        uploading: !!uploading
                    }),
                    hasBenefit && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionBox, {
                        benefit: benefit,
                        onUpload: onUploadFile,
                        onRemove: onRemoveFile
                    })
                ]
            })
        ]
    });
};
var ThumbnailBox = function(param) {
    var image = param.image, onUpload = param.onUpload, uploading = param.uploading;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var ref2 = (0,react.useState)(false), isFlipped = ref2[0], setIsFlipped = ref2[1];
    var ref3 = (0,react.useState)(false), activeUploading = ref3[0], setActiveUploading = ref3[1];
    var handleClickUpload = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setActiveUploading(true);
                    return [
                        4,
                        onUpload("image")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onUpload
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!uploading && (image === null || image === void 0 ? void 0 : (ref = image.front) === null || ref === void 0 ? void 0 : ref.fileUrl) && activeUploading) {
            setActiveUploading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uploading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: t("addThumbnail")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.hint",
                children: t("addThumbnailDesc")
            }),
            activeUploading && uploading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                    target: "common",
                    src: "images/console/loading.png",
                    width: 80
                })
            }),
            (image === null || image === void 0 ? void 0 : (ref = image.front) === null || ref === void 0 ? void 0 : ref.fileUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 3,
                display: activeUploading && uploading ? "none" : "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((ReactCardFlip_default()), {
                        isFlipped: isFlipped,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                size: "large",
                                src: image.front.fileUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                size: "large",
                                src: image.back.uri
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                        bgcolor: "primary.main",
                        color: "white",
                        onClick: function() {
                            return setIsFlipped(function(prevState) {
                                return !prevState;
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        color: "primary",
                        onClick: handleClickUpload,
                        children: t("changeTheImage")
                    })
                ]
            }),
            !(activeUploading && uploading) && !(image === null || image === void 0 ? void 0 : (ref1 = image.front) === null || ref1 === void 0 ? void 0 : ref1.fileUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                size: "medium",
                sx: {
                    width: "fit-content"
                },
                onClick: handleClickUpload,
                children: t("selectFile")
            })
        ]
    });
};
var OptionBox = function(param) {
    var benefit = param.benefit, onUpload = param.onUpload, onRemove = param.onRemove;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var handleClickUpload = (0,react.useCallback)(function() {
        return onUpload("benefit");
    }, [
        onUpload
    ]);
    var handleClickRemove = (0,react.useCallback)(function() {
        onRemove();
    }, [
        onRemove
    ]);
    /**
   * @todo
   * Androidで動画リソースがアップロードできない不具合があるため、一時的に特典アップローダをAndroidのときのみ非表示にしている。
   * https://app.clickup.com/t/908127/UT-5411
   */ var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    if ((deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) === "android") return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 2,
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: t("addBenefit")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("addBenefitNote")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.hint",
                        children: t("addBenefitDesc")
                    })
                ]
            }),
            (benefit === null || benefit === void 0 ? void 0 : benefit.originalFile) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadBox, {
                type: benefit === null || benefit === void 0 ? void 0 : benefit.type,
                onClick: handleClickUpload,
                applied: true,
                onRemove: handleClickRemove,
                filename: benefit.originalFile.name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                size: "medium",
                sx: {
                    width: "fit-content"
                },
                onClick: handleClickUpload,
                children: t("selectFile")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignDetail/template/CampaignItemForm.tsx











var CampaignItemForm_schema = function(o) {
    return {
        items: o.array().items(o.object({
            image: o.object({
                front: {
                    fileUrl: o.string().required(),
                    tmpPath: o.string().required()
                },
                back: {
                    uri: o.string().required()
                }
            }),
            hasBenefit: o.boolean().allow().optional(),
            benefit: o.object({
                uri: o.string().optional().allow(""),
                originalFile: o.any().allow(null).optional(),
                type: o.string()
            }).allow(null).optional(),
            rarity: o.object({
                id: o.string(),
                name: o.string()
            })
        }))
    };
};
var CampaignItemForm = function(param) {
    var items = param.items, onSubmit = param.onSubmit, onUploadFile = param.onUploadFile, uploading = param.uploading;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,core_form/* useForm */.cI)({
        schema: CampaignItemForm_schema,
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: {
            items: []
        }
    }), control = ref3.control, reset = ref3.reset, handleSubmit = ref3.handleSubmit, setValue = ref3.setValue, trigger = ref3.trigger, setError = ref3.setError, _formState = ref3.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    (0,react.useEffect)(function() {
        reset({
            items: items
        }, {
            keepErrors: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items
    ]);
    var onSubmitForm = (0,react.useCallback)(function() {
        setOpen(true);
    }, []);
    var onSubmitEntryCampaign = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(inputs).then(function() {
                                showMessage(t("success"));
                                router.push(routerPages.ConsoleCampaigns);
                            }).catch(function(e) {
                                (0,core_errors/* captureError */.O)(e, "CampaignItemForm");
                                (0,core_form/* handleError */.S3)(e, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmitEntryCampaign(inputs) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        id: "campaign-item-form",
        sx: {
            px: 5,
            py: 3,
            mt: 3
        },
        onSubmit: handleSubmit(onSubmitForm),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemArrayCell, {
                name: "items",
                items: items,
                control: control,
                errors: errors,
                uploading: !!uploading,
                onUploadFile: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(fileType, index) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onUploadFile(fileType, index).then(function(value) {
                                            if ("originalFile" in value) {
                                                setValue("items.".concat(index, ".benefit.originalFile"), value.originalFile);
                                                setValue("items.".concat(index, ".benefit.uri"), value.uri);
                                                setValue("items.".concat(index, ".benefit.type"), value.originalFile.mimeType.includes("video") ? FileType.Video : FileType.Audio);
                                                return trigger("items.".concat(index, ".benefit"));
                                            }
                                            setValue("items.".concat(index, ".image.front"), value);
                                            return trigger("items.".concat(index, ".image.front"));
                                        }).catch(function(error) {
                                            if (error.message === "uploadErrorMaximumSize") {
                                                showError(new Error(t("uploadErrorMaximumSize")));
                                                return;
                                            }
                                            if (error.message === "uploadErrorImageOnly") {
                                                showError(new Error(t("uploadErrorImageOnly")));
                                                return;
                                            }
                                            if (error.message === "uploadErrorAudioOrVideoOnly") {
                                                showError(new Error(t("uploadErrorAudioOrVideoOnly")));
                                                return;
                                            }
                                            showError(error);
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(fileType, index) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onRemoveFile: function(index) {
                    setValue("items.".concat(index, ".benefit"), {
                        uri: "",
                        originalFile: undefined,
                        type: FileType.Image
                    });
                    return trigger("items.".concat(index, ".benefit"));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("entryModalTitle"),
                content: t("entryModalDesc"),
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    onClick: handleSubmit(onSubmitEntryCampaign),
                    sx: {
                        minWidth: 212
                    },
                    loading: isSubmitting,
                    children: t("entryBtn")
                })
            })
        ]
    });
};
var ItemArrayCell = function(param) {
    var name = param.name, control = param.control, errors = param.errors, onUploadFile = param.onUploadFile, onRemoveFile = param.onRemoveFile, uploading = param.uploading;
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: name
    }).fields;
    var itemsWatch = (0,react_hook_form_dist_index_esm/* useWatch */.qo)({
        control: control,
        name: name
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 5,
            children: fields.map(function(field, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConsoleCampaignItemBox, {
                    item: itemsWatch[index],
                    uploading: uploading,
                    onUploadFile: function(fileType) {
                        return onUploadFile(fileType, index);
                    },
                    onRemoveFile: function() {
                        return onRemoveFile(index);
                    },
                    errors: (ref = errors.items) === null || ref === void 0 ? void 0 : ref[index]
                }, field.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignDetail/template/index.tsx















var ConsoleCampaignDetailTemplate = function(param) {
    var state = param.state, onUploadFile = param.onUploadFile, onCampaignApply = param.onCampaignApply;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref2.routerNames, routerPages = ref2.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCampaignDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                customNavigation: state.hasAvatarImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedButtonCell, {}) : null,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleCampaigns,
                    title: (ref = state.campaign) === null || ref === void 0 ? void 0 : ref.title
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignRankImage, {
                        thumbnail: (ref1 = state.campaign) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                        loading: state.loading
                    }),
                    state.loading || !state.campaign ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignDescriptionSkeletonCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignItemsSkeletonCell, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignDescriptionCell, {
                                campaign: state.campaign,
                                eyecatch: state.eyecatch,
                                hasAvatarImage: state.hasAvatarImage
                            }),
                            state.hasAvatarImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignItemForm, {
                                onSubmit: onCampaignApply,
                                items: state.consoleCampaignItems,
                                uploading: state.uploading,
                                onUploadFile: onUploadFile
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CampaignDescriptionCell = function(param) {
    var campaign = param.campaign, eyecatch = param.eyecatch, hasAvatarImage = param.hasAvatarImage;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5,
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        children: campaign === null || campaign === void 0 ? void 0 : campaign.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 4
                        },
                        children: t("contestOverview")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 1
                        },
                        children: campaign === null || campaign === void 0 ? void 0 : campaign.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 4
                        },
                        children: t("dateTime")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 1
                        },
                        children: "".concat(campaign === null || campaign === void 0 ? void 0 : campaign.formattedStartedAt, " 〜 ").concat(campaign === null || campaign === void 0 ? void 0 : campaign.formattedEndedAt)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 4
                        },
                        children: t("entryConditions")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 1
                        },
                        children: campaign === null || campaign === void 0 ? void 0 : (ref = campaign.entryCondition) === null || ref === void 0 ? void 0 : ref.description
                    })
                ]
            }),
            hasAvatarImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 2,
                sx: {
                    pt: 2
                },
                children: [
                    eyecatch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: eyecatch,
                            variant: "square",
                            sx: {
                                width: 220,
                                height: 165
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 220,
                        height: 165
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: t("eyeCatchingImage")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoProfileImageCell, {})
        ]
    });
};
var CampaignDescriptionSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "large",
                width: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "50%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    numberOfLine: 5,
                                    lastWidth: "75%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "50%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "50%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                numberOfLine: 3,
                                lastWidth: "75%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pt: 2,
                                width: 220
                            },
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 165
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "100%"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var CampaignItemsSkeletonCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var items = (0,react.useMemo)(function() {
        return generateItems(t);
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 3,
            mt: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 5,
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignItemBox, {
                    item: item,
                    onUploadFile: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    }),
                    onRemoveFile: function() {}
                }, index);
            })
        })
    });
};
var FixedButtonCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                bgcolor: "grey.50",
                py: 4,
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                form: "campaign-item-form",
                type: "submit",
                size: "large",
                color: "primary",
                sx: {
                    width: 244
                },
                children: t("registerAndEnter")
            })
        })
    });
};
function generateItems(t) {
    var rarities = [
        "superrare_1",
        "rare_1",
        "common_1",
        "common_2",
        "common_3",
        "common_4", 
    ];
    return rarities.map(function(rarityValue) {
        var ref = (0,_sliced_to_array/* default */.Z)(rarityValue.split("_"), 2), rarity = ref[0], index = ref[1];
        return {
            rarity: {
                id: rarity,
                name: "".concat(t(rarity), "_").concat(index)
            },
            hasBenefit: rarity === "superrare" || rarity === "rare",
            benefit: {
                uri: "",
                originalPath: "",
                type: FileType.Audio
            },
            image: {
                front: {
                    fileUrl: "",
                    tmpPath: ""
                },
                back: {
                    uri: ""
                }
            }
        };
    });
}
var NoProfileImageCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            sx: {
                py: 4,
                mt: 4,
                mb: 8,
                bgcolor: "grey.50",
                borderRadius: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flexDirection: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                            color: "error"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            color: "error",
                            sx: {
                                ml: 1
                            },
                            children: t("noProfileImageDescription")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        mt: 3
                    },
                    href: routerPages.ConsoleMyProfileEdit,
                    children: t("profileImageRegister")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/core/native/file/index.ts



/**
 * @description
 * HTML5のinput要素を使用してファイルを選択し、
 * Capacitor File Picker互換のオブジェクトを返す。
 *
 * @param types - 受け入れ可能なファイルタイプの配列（MIME typeまたは拡張子）
 * @returns Promise<CapacitorFile> - 選択されたファイル情報
 */ var pickFile = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(types) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    var input = document.createElement("input");
                    input.type = "file";
                    input.accept = types.join(",");
                    input.multiple = false;
                    input.onchange = function(event) {
                        var ref;
                        var file = (ref = event.target.files) === null || ref === void 0 ? void 0 : ref[0];
                        if (!file) {
                            reject(new Error("キャンセルしました。もう一度お試しください。"));
                            return;
                        }
                        try {
                            var pickedFile = Object.assign(file, {
                                mimeType: file.type
                            });
                            resolve(pickedFile);
                        } catch (error) {
                            (0,core_errors/* captureError */.O)(error, "pickFileWeb");
                            reject(error);
                        }
                    };
                    input.click();
                })
            ];
        });
    });
    return function pickFile(types) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/lib/abyssale/index.ts





// 画像合成サービスAbyssaleのAPIを利用したモジュール
var headers = {
    "Content-Type": "application/json",
    "x-api-key": config_config/* config.abyssaleApiKey */.v.abyssaleApiKey
};
/**
 * @description compositeImage
 * imageTemplateの情報で画像を作成する
 *
 * @param {ImageTemplate} imageTemplate 画像テンプレートの情報
 * @param {File} file ファイルオブジェクト、これがある場合はbase64にエンコードしたデータを画像として送信する
 * @returns {Promise<string>} url 生成された画像のurl
 *
 * cf https://developers.abyssale.com/#generate-image
 */ function compositeImage(imageTemplate, file) {
    return _compositeImage.apply(this, arguments);
}
function _compositeImage() {
    _compositeImage = (0,src_async_to_generator/* default */.Z)(function(imageTemplate, file) {
        var payload;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        convertOverrideValuesToInput(imageTemplate, file)
                    ];
                case 1:
                    payload = _state.sent();
                    return [
                        2,
                        axios/* default.post */.Z.post("https://api.abyssale.com/banner-builder/".concat(imageTemplate.templateId, "/generate"), payload, {
                            headers: headers
                        }).then(function(response) {
                            return response.data.image.url;
                        })
                    ];
            }
        });
    });
    return _compositeImage.apply(this, arguments);
}
function convertOverrideValuesToInput(imageTemplate, file) {
    return _convertOverrideValuesToInput.apply(this, arguments);
}
function _convertOverrideValuesToInput() {
    _convertOverrideValuesToInput = /**
 * @description convertOverrideValuesToInput
 * imageTemplateのデータをAbyssaleのリクエストパラメータに変換する
 *
 * @param imageTemplate Firestoreに定義されているテンプレートデータ
 * @param file (optional) アップロードしたファイル画像
 */ (0,src_async_to_generator/* default */.Z)(function(imageTemplate, file) {
        var elements, image_encoded, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    elements = {};
                    if (!file) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertFileToBase64(file)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = "";
                    _state.label = 3;
                case 3:
                    image_encoded = _tmp;
                    Object.entries(imageTemplate.overrideElements).forEach(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], data = _param[1];
                        switch(data.type){
                            case "text":
                                {
                                    var _value;
                                    var element = {
                                        payload: (_value = data.value) !== null && _value !== void 0 ? _value : ""
                                    };
                                    elements[data.elementName] = element;
                                    break;
                                }
                            case "image":
                                {
                                    var _value1;
                                    var element1 = file ? {
                                        image_encoded: image_encoded
                                    } : {
                                        image_url: (_value1 = data.value) !== null && _value1 !== void 0 ? _value1 : ""
                                    };
                                    elements[data.elementName] = element1;
                                    break;
                                }
                        }
                    });
                    return [
                        2,
                        {
                            template_format_name: imageTemplate.templateFormatName || "",
                            elements: elements
                        }
                    ];
            }
        });
    });
    return _convertOverrideValuesToInput.apply(this, arguments);
}
// file形式の画像をbase64に変換する
function convertFileToBase64(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
            var base64 = reader.result;
            resolve(typeof base64 === "string" ? base64.replace("data:", "data:image/") : "");
        };
    });
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignDetail/viewModel.ts








var _Object;
function ConsoleCampaignDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCampaignDetail($code: String, $artistId: String!) {\n    artist {\n      id\n      avatar {\n        uri\n        smallUri\n        mediumUri\n      }\n    }\n    campaign(code: $code) {\n      ...ConsoleCampaignDetail\n      imageTemplates(artistId: $artistId) {\n        ...EntryCampaignImageTemplates\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleCampaignDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleCampaignDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation EntryCampaign($id: ID!, $inputs: CampaignEntryInput!) {\n    entryCampaign(id: $id, inputs: $inputs) {\n      ...ConsoleCampaignDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCampaignDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleCampaignDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateResource($filePath: String!, $name: String!) {\n    createResource(filePath: $filePath, name: $name) {\n      id\n      uri\n      name\n      type\n      createdAt\n    }\n  }\n"
    ]);
    ConsoleCampaignDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var acceptType = (_Object = Object).assign.apply(_Object, [
    {}
].concat((0,src_to_consumable_array/* default */.Z)(Object.entries(config_config/* config.upload.mimeTypes.audio */.v.upload.mimeTypes.audio).map(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), a = _param[0], b = _param[1];
    return (0,_define_property/* default */.Z)({}, b, "audio");
})), (0,src_to_consumable_array/* default */.Z)(Object.entries(config_config/* config.upload.mimeTypes.video */.v.upload.mimeTypes.video).map(function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), a = _param[0], b = _param[1];
    return (0,_define_property/* default */.Z)({}, b, "video");
}))));
var ConsoleCampaignDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var getImage = camera/* getImage */.g;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleCampaignDetail_viewModel_QUERY, {
        variables: {
            code: router.query.campaignId,
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : ""
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,react.useState)(false), compositing = ref4[0], setCompositing = ref4[1];
    var ref5;
    var ref6 = (0,useTmpUploader/* useUserTmpUploader */.x)((ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : ""), upload = ref6.upload, uploading = ref6.uploading;
    var eyecatch = useEyecatch(data).eyecatch;
    var ref7 = (0,_sliced_to_array/* default */.Z)(useConsoleCampaignItems(data), 1), consoleCampaignItems = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ENTRY_CAMPAIGN), 1), entryCampaign = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_RESOURCE), 1), createResource = ref9[0];
    var ref10, ref11;
    return {
        state: {
            loading: loading,
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            campaign: (ref11 = data === null || data === void 0 ? void 0 : data.campaign) !== null && ref11 !== void 0 ? ref11 : null,
            uploading: uploading || compositing,
            eyecatch: eyecatch,
            consoleCampaignItems: consoleCampaignItems,
            hasAvatarImage: !!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.uri)
        },
        actions: {
            onUploadFile: function onUploadFile(fileType, index) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, file, uploadInfo, template, compositedImage, file1, tmpPath;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(fileType === "image")) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                                ];
                            case 1:
                                file = _state.sent();
                                checkFileLimit(file, "image");
                                setCompositing(true);
                                return [
                                    4,
                                    upload(file)
                                ];
                            case 2:
                                uploadInfo = _state.sent();
                                template = (ref3 = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.imageTemplates) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(param) {
                                    var rarity = param.rarity;
                                    return rarity === consoleCampaignItems[index].rarity.id;
                                })) === null || ref3 === void 0 ? void 0 : ref3.front;
                                if (!template) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    compositeImage(template, file)
                                ];
                            case 3:
                                compositedImage = _state.sent();
                                setCompositing(false);
                                return [
                                    2,
                                    {
                                        fileUrl: compositedImage !== null && compositedImage !== void 0 ? compositedImage : uploadInfo.fileUrl,
                                        tmpPath: compositedImage !== null && compositedImage !== void 0 ? compositedImage : uploadInfo.tmpPath
                                    }
                                ];
                            case 4:
                                setCompositing(false);
                                return [
                                    2,
                                    uploadInfo
                                ];
                            case 5:
                                return [
                                    4,
                                    getBenefit()
                                ];
                            case 6:
                                file1 = _state.sent();
                                checkFileLimit(file1);
                                checkBenefitFile(file1);
                                return [
                                    4,
                                    upload(file1, false)
                                ];
                            case 7:
                                tmpPath = _state.sent().tmpPath;
                                return [
                                    2,
                                    {
                                        uri: tmpPath,
                                        originalFile: file1
                                    }
                                ];
                        }
                    });
                })();
            },
            onCampaignApply: /**
       * @todo フォーム送信してエントリーする機能の実装
       * https://app.clickup.com/t/908127/UT-5240
       */ function onCampaignApply(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, items, inputItems, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(inputs.items.map(function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(item) {
                                            var ref, ref1, uuid, data, ref2, uuid1, data1, data2;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!!item.hasBenefit) return [
                                                            3,
                                                            3
                                                        ];
                                                        return [
                                                            4,
                                                            createUuid()
                                                        ];
                                                    case 1:
                                                        uuid = _state.sent();
                                                        return [
                                                            4,
                                                            createResource({
                                                                variables: {
                                                                    filePath: item.image.front.fileUrl,
                                                                    name: uuid
                                                                }
                                                            })
                                                        ];
                                                    case 2:
                                                        data = _state.sent().data;
                                                        return [
                                                            2,
                                                            {
                                                                type: "wallpaper",
                                                                rarity: item.rarity.id,
                                                                thumbnail: item.image.front.fileUrl,
                                                                thumbnailBack: item.image.back.uri,
                                                                wallpaperResources: {
                                                                    wallpaperResourceId: data === null || data === void 0 ? void 0 : (ref1 = data.createResource) === null || ref1 === void 0 ? void 0 : ref1.id
                                                                }
                                                            }
                                                        ];
                                                    case 3:
                                                        if (!!item.benefit.originalFile) return [
                                                            3,
                                                            6
                                                        ];
                                                        return [
                                                            4,
                                                            createUuid()
                                                        ];
                                                    case 4:
                                                        uuid1 = _state.sent();
                                                        return [
                                                            4,
                                                            createResource({
                                                                variables: {
                                                                    filePath: item.image.front.fileUrl,
                                                                    name: uuid1
                                                                }
                                                            })
                                                        ];
                                                    case 5:
                                                        data1 = _state.sent().data;
                                                        return [
                                                            2,
                                                            {
                                                                type: "wallpaper",
                                                                rarity: item.rarity.id,
                                                                wallpaperResources: {
                                                                    wallpaperResourceId: data1 === null || data1 === void 0 ? void 0 : (ref2 = data1.createResource) === null || ref2 === void 0 ? void 0 : ref2.id
                                                                },
                                                                thumbnail: item.image.front.fileUrl,
                                                                thumbnailBack: item.image.back.uri
                                                            }
                                                        ];
                                                    case 6:
                                                        return [
                                                            4,
                                                            createResource({
                                                                variables: {
                                                                    filePath: item.benefit.uri,
                                                                    name: item.benefit.originalFile.name
                                                                }
                                                            })
                                                        ];
                                                    case 7:
                                                        data2 = _state.sent().data;
                                                        return [
                                                            2,
                                                            {
                                                                type: item.benefit.type,
                                                                rarity: item.rarity.id,
                                                                resourceId: data2 === null || data2 === void 0 ? void 0 : (ref = data2.createResource) === null || ref === void 0 ? void 0 : ref.id,
                                                                thumbnail: item.image.front.fileUrl,
                                                                thumbnailBack: item.image.back.uri
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(item) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                items = _state.sent();
                                inputItems = convertToCampaignEntryItemInput(items);
                                if (!inputItems) throw new Error(t("itemConversionFailed"));
                                return [
                                    4,
                                    entryCampaign({
                                        variables: {
                                            id: (ref = router.query) === null || ref === void 0 ? void 0 : ref.campaignId,
                                            inputs: {
                                                artistId: (ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : "",
                                                items: inputItems
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
// キャンペーンのアイキャッチ画像を合成しurlを返す
function useEyecatch(data) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(""), eyecatch = ref3[0], setEyecatch = ref3[1];
    var eyecatchTemplate = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.imageTemplates) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gacha) === null || ref2 === void 0 ? void 0 : ref2.banner;
    (0,react.useEffect)(function() {
        if (eyecatchTemplate && (eyecatchTemplate === null || eyecatchTemplate === void 0 ? void 0 : eyecatchTemplate.templateId)) {
            (0,src_async_to_generator/* default */.Z)(function() {
                var eyecatchImageUrl;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                compositeImage(eyecatchTemplate)
                            ];
                        case 1:
                            eyecatchImageUrl = _state.sent();
                            setEyecatch(eyecatchImageUrl);
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, [
        eyecatchTemplate
    ]);
    return {
        eyecatch: eyecatch
    };
}
// フォームに対応するアイテム達の状態を初期化して返す
function useConsoleCampaignItems(data) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)([]), consoleCampaignItems = ref4[0], setConsoleCampaignItems = ref4[1];
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaignDetail").t;
    var imageTemplates = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.imageTemplates) === null || ref1 === void 0 ? void 0 : ref1.items;
    (0,react.useEffect)(function() {
        var ref, ref1;
        var ref2;
        setConsoleCampaignItems(convertItems((ref2 = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.entryCondition) === null || ref1 === void 0 ? void 0 : ref1.items) !== null && ref2 !== void 0 ? ref2 : {}, t));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : (ref2 = data.campaign) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.entryCondition) === null || ref3 === void 0 ? void 0 : ref3.items
    ]);
    // 裏面のテンプレート合成
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (!(consoleCampaignItems.length && (imageTemplates === null || imageTemplates === void 0 ? void 0 : imageTemplates.length))) return;
        var backTemplates = {
            superrare: (ref = imageTemplates.find(function(param) {
                var rarity = param.rarity;
                return rarity === "superrare";
            })) === null || ref === void 0 ? void 0 : ref.back,
            rare: (ref1 = imageTemplates.find(function(param) {
                var rarity = param.rarity;
                return rarity === "rare";
            })) === null || ref1 === void 0 ? void 0 : ref1.back,
            common: (ref2 = imageTemplates.find(function(param) {
                var rarity = param.rarity;
                return rarity === "common";
            })) === null || ref2 === void 0 ? void 0 : ref2.back
        };
        (0,src_async_to_generator/* default */.Z)(function() {
            var backImageUrl, _tmp, _tmp1, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        if (!backTemplates.superrare) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            compositeImage(backTemplates.superrare)
                        ];
                    case 1:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp1 = "";
                        _state.label = 3;
                    case 3:
                        _tmp.superrare = _tmp1;
                        if (!backTemplates.rare) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            compositeImage(backTemplates.rare)
                        ];
                    case 4:
                        _tmp2 = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        _tmp2 = "";
                        _state.label = 6;
                    case 6:
                        _tmp.rare = _tmp2;
                        if (!backTemplates.common) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            compositeImage(backTemplates.common)
                        ];
                    case 7:
                        _tmp3 = _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 8:
                        _tmp3 = "";
                        _state.label = 9;
                    case 9:
                        backImageUrl = (_tmp.common = _tmp3, _tmp);
                        setConsoleCampaignItems(function(state) {
                            return state.map(function(item) {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                    image: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item.image), {
                                        back: {
                                            uri: backImageUrl[item.rarity.id]
                                        }
                                    })
                                });
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        imageTemplates,
        consoleCampaignItems.length
    ]);
    return [
        consoleCampaignItems,
        setConsoleCampaignItems
    ];
}
// EntryConditionItemsをConsoleCampaignItemsに変換する
function convertItems(entryConditionItems, t) {
    var rarities = [
        "superrare",
        "rare",
        "common"
    ].filter(function(rarity) {
        return !!entryConditionItems[rarity];
    });
    return rarities.filter(function(rarity) {
        return entryConditionItems && Object.prototype.hasOwnProperty.call(entryConditionItems, rarity);
    }).map(function(rarity) {
        var ref;
        return (0,src_to_consumable_array/* default */.Z)(Array((ref = entryConditionItems[rarity]) === null || ref === void 0 ? void 0 : ref.count)).map(function(_, index) {
            return {
                rarity: {
                    id: rarity,
                    name: "".concat(t(rarity), "_").concat(index + 1)
                },
                hasBenefit: rarity !== "common",
                benefit: {
                    uri: "",
                    originalFile: null,
                    type: FileType.Image
                },
                image: {
                    front: {
                        fileUrl: "",
                        tmpPath: ""
                    },
                    back: {
                        uri: ""
                    }
                }
            };
        }).flat();
    }).flat();
}
// 音声・動画・PDFのファイルを取得する
function getBenefit() {
    return pickFile([
        keys_default()(acceptType).toString()
    ]);
}
function checkFileLimit(file, fileType) {
    var AcceptFileType = fileType || acceptType["mimeType" in file ? file.mimeType : file.type];
    var fileSizeLimit = AcceptFileType === "video" ? config_config/* config.upload.limit.video */.v.upload.limit.video[(0,native_app/* getPlatform */.Xf)()] : config_config/* config.upload.limit */.v.upload.limit[AcceptFileType];
    if (file.size > fileSizeLimit) {
        throw new Error("uploadErrorMaximumSize");
    }
}
function checkBenefitFile(file) {
    if (keys_default()(acceptType).findIndex(function(o) {
        return o === file.mimeType;
    }) === -1) {
        throw new Error("uploadErrorAudioOrVideoOnly");
    }
}
/**
 * @description
 * input用にCampaignEntryItemInput型のアイテムをCampaignEntryItemsInput型に整形
 */ var convertToCampaignEntryItemInput = function(items) {
    if (!(items === null || items === void 0 ? void 0 : items.length)) return;
    return items.reduce(function(acc, current) {
        if (current.rarity === "superrare") {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), {
                superrare: (0,src_to_consumable_array/* default */.Z)((acc === null || acc === void 0 ? void 0 : acc.superrare) || []).concat([
                    (0,src_object_spread/* default */.Z)({}, current)
                ])
            });
        }
        if (current.rarity === "rare") {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), {
                rare: (0,src_to_consumable_array/* default */.Z)((acc === null || acc === void 0 ? void 0 : acc.rare) || []).concat([
                    (0,src_object_spread/* default */.Z)({}, current)
                ])
            });
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, acc), {
            common: (0,src_to_consumable_array/* default */.Z)((acc === null || acc === void 0 ? void 0 : acc.common) || []).concat([
                (0,src_object_spread/* default */.Z)({}, current)
            ])
        });
    }, {});
};
var ConsoleCampaignDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCampaignDetail_viewModel_templateObject(), utoniq_core_schema/* ConsoleCampaignDetailFragmentDoc */.Iwq, utoniq_core_schema/* ImageTemplateFragmentDoc */.ypV, utoniq_core_schema/* EntryCampaignImageTemplatesFragmentDoc */.$H0);
var ENTRY_CAMPAIGN = (0,lib/* gql */.Ps)(ConsoleCampaignDetail_viewModel_templateObject1(), utoniq_core_schema/* ConsoleCampaignDetailFragmentDoc */.Iwq);
var CREATE_RESOURCE = (0,lib/* gql */.Ps)(ConsoleCampaignDetail_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaignDetail/index.tsx




/**
 * ConsoleCampaignDetail Page
 * Implemented as a practical sample.
 */ var ConsoleCampaignDetail = function() {
    var ref = ConsoleCampaignDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/campaign/CampaignBoxSkeleton/index.tsx



var CampaignBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        sx: {
            p: 0,
            mb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    sx: {
                        width: 100,
                        height: 64
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                sx: {
                    pl: 4
                },
                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%"
                }),
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "100%"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/campaign/ConsoleCampaignBox/index.tsx






var ConsoleCampaignBox = function(param) {
    var campaign = param.campaign;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        sx: {
            mt: 0,
            pr: campaign.entryStatus === "canNotEntry" ? 4 : "92px",
            ".MuiListItemSecondaryAction-root": {
                whiteSpace: "pre-wrap",
                textAlign: "center"
            }
        },
        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryStatusChip, {
            id: campaign.id,
            entryStatus: campaign.entryStatus
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "square",
                    sx: {
                        width: 100,
                        height: 64,
                        borderRadius: 2
                    },
                    alt: campaign.title,
                    src: ((ref = campaign.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) || ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                sx: {
                    pl: 4
                },
                primary: campaign.title,
                slotProps: {
                    primary: {
                        variant: "subtitle1",
                        color: campaign.openStatus === "ended" ? "text.hint" : "text.primary",
                        sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2))
                    }
                },
                secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenStatusChip, {
                    openStatus: campaign.openStatus
                })
            })
        ]
    });
};
var EntryStatusChip = function(param) {
    var id = param.id, entryStatus = param.entryStatus;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaigns").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!entryStatus || entryStatus === "canNotEntry") return null;
    return entryStatus === "canEntry" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        href: generatePath(routerPages.ConsoleCampaignDetail, {
            campaignId: id
        }),
        sx: {
            borderRadius: "2px",
            width: 76,
            p: 1
        },
        color: "error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "white",
            children: t(entryStatus)
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            width: 76,
            height: 20,
            borderRadius: "2px",
            bgcolor: "secondary.main",
            py: 1,
            ".MuiChip-label": {
                px: 0
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "white",
            variant: "overline",
            children: t(entryStatus)
        })
    });
};
var OpenStatusChip = function(param) {
    var openStatus = param.openStatus;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaigns").t;
    if (!openStatus) return null;
    var style = function() {
        switch(openStatus){
            case "open":
                return {
                    text: "white",
                    bgcolor: "primary.dark"
                };
            case "willOpen":
                return {
                    text: "text.secondary",
                    bgcolor: "secondary.light"
                };
            case "ended":
            default:
                return {
                    text: "text.disabled",
                    bgcolor: "grey.100"
                };
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 16,
            borderRadius: "2px",
            bgcolor: style.bgcolor,
            p: 1,
            pt: "2px"
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: style.text,
            variant: "overline",
            children: t(openStatus)
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaigns/template/index.tsx









var ConsoleCampaignsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCampaigns").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCampaigns
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 5,
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h3",
                            children: t("title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        loading: state.loading,
                        onFetchMore: onFetchMore,
                        hasNextPage: state.hasNextPage,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 6,
                            sx: {
                                py: 4,
                                px: 5
                            },
                            children: [
                                1,
                                2,
                                3,
                                4,
                                5
                            ].map(function(i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBoxSkeleton, {}, i);
                            })
                        }),
                        nodes: (ref = state.campaigns) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignBox, {
                                campaign: node
                            }, node.id);
                        }),
                        emptyMessage: t("missionEmptyMessage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mb: 3
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaigns/viewModel.ts



function ConsoleCampaigns_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCampaigns(\n    $excludeExpired: Boolean\n    $campaignsPageInput: PageInput\n  ) {\n    campaigns(excludeExpired: $excludeExpired, pageInput: $campaignsPageInput) {\n      ...ConsoleCampaignsConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCampaigns_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ConsoleCampaigns_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleCampaigns_viewModel_QUERY, {
        variables: {
            excludeExpired: false
        }
    }), data = ref3.data, loading = ref3.loading, fetchMore = ref3.fetchMore;
    var ref4, ref5, ref6, ref7;
    return {
        state: {
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            loading: loading,
            artist: (ref5 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref5 !== void 0 ? ref5 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.campaigns) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            campaigns: (ref6 = data === null || data === void 0 ? void 0 : data.campaigns) !== null && ref6 !== void 0 ? ref6 : null,
            currentUser: user,
            membership: (ref7 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.products) !== null && ref7 !== void 0 ? ref7 : undefined
        },
        actions: {
            onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchMore({
                                    variables: {
                                        campaignsPageInput: {
                                            cursor: data === null || data === void 0 ? void 0 : (ref = data.campaigns) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                        }
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var ConsoleCampaigns_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCampaigns_viewModel_templateObject(), utoniq_core_schema/* ConsoleCampaignsConnectionFragmentDoc */.v8J);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCampaigns/index.tsx



var ConsoleCampaigns = function() {
    var ref = ConsoleCampaigns_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCampaignsTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

// EXTERNAL MODULE: ../../node_modules/react-image-crop/dist/ReactCrop.css
var ReactCrop = __webpack_require__(17001);
// EXTERNAL MODULE: ../../node_modules/react-image-crop/dist/index.js
var react_image_crop_dist = __webpack_require__(68555);
// EXTERNAL MODULE: ./src/components/organisms/imageEditor/ImageEditModal.tsx
var ImageEditModal = __webpack_require__(92054);
;// CONCATENATED MODULE: ./src/components/organisms/consoleImageEditor/ConsoleImageEditModal.tsx
















var RatioType;
(function(RatioType) {
    RatioType[RatioType["ORIGINAL"] = 0] = "ORIGINAL";
    RatioType[RatioType["RECTANGLE"] = 1] = "RECTANGLE";
})(RatioType || (RatioType = {}));
var ConsoleImageEditModal = function(param) {
    var open = param.open, src = param.src, artistId = param.artistId, onClose = param.onClose, onSave = param.onSave, onUploadFile = param.onUploadFile;
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    var ref = (0,react.useState)(false), saving = ref[0], setSaving = ref[1];
    var ref1 = (0,react.useState)(RatioType.ORIGINAL), ratioType = ref1[0], setRatioType = ref1[1];
    var ref2 = (0,react.useState)(0), rotate = ref2[0], setRotate = ref2[1];
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var imageRef = (0,react.useRef)();
    var cropRef = (0,react.useRef)();
    var ref3 = (0,react.useState)(undefined), aspect = ref3[0], setAspect = ref3[1];
    var ref4 = (0,react.useState)({
        x: 0,
        y: 0,
        width: 100,
        height: 100,
        unit: "%"
    }), crop = ref4[0], setCrop = ref4[1];
    var handleImageLoaded = (0,react.useCallback)(function(event) {
        var newCrop = (0,ImageEditModal/* getCropBySize */.MC)(event.currentTarget.width, event.currentTarget.height, event.currentTarget.width / event.currentTarget.height);
        setAspect(undefined);
        cropRef.current = newCrop;
        setCrop(newCrop);
        return false;
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAspect(undefined);
        setRatioType(RatioType.ORIGINAL);
        setRotate(0);
    }, []);
    var handleCropImage = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var newCrop, localFile, data, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!imageRef.current || !cropRef.current) {
                        return [
                            2
                        ];
                    }
                    setSaving(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    newCrop = (0,react_image_crop_dist/* convertToPixelCrop */.BB)(cropRef.current, imageRef.current.width, imageRef.current.height);
                    return [
                        4,
                        getCroppedImg(imageRef.current, newCrop, (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem) === "ios", undefined, rotate)
                    ];
                case 2:
                    localFile = _state.sent();
                    return [
                        4,
                        onUploadFile(localFile)
                    ];
                case 3:
                    data = _state.sent();
                    onSave(data, localFile);
                    handleClose();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    /**
       * @todo エラーハンドリングの型付け
       * https://app.clickup.com/t/908127/UT-5180
       */ if (typeof err === "string") {
                        showError(new Error(t(err)));
                    } else {
                        showError(err);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    setSaving(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem,
        onUploadFile,
        onSave,
        showError,
        t,
        rotate,
        handleClose, 
    ]);
    var handleChangeRatio = (0,react.useCallback)(function(ratioType) {
        if (!imageRef.current) {
            return;
        }
        var newCrop = (0,ImageEditModal/* getCropBySize */.MC)(imageRef.current.width, imageRef.current.height, ratioType === RatioType.RECTANGLE ? 16 / 9 : imageRef.current.width / imageRef.current.height);
        setAspect(ratioType === RatioType.RECTANGLE ? 16 / 9 : undefined);
        cropRef.current = newCrop;
        setCrop(newCrop);
        setRatioType(ratioType);
    }, []);
    var handleChangeRotate = (0,react.useCallback)(function() {
        setRotate(function(prevState) {
            return prevState + 90;
        });
    }, []);
    var renderBottomItem = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedBottomCell, {
            ratioType: ratioType,
            onChangeRatioType: handleChangeRatio,
            onChangeRotate: handleChangeRotate
        });
    }, [
        ratioType,
        handleChangeRatio,
        handleChangeRotate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: function() {
            onClose();
            handleClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
            artistId: artistId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        color: "white",
                        onClick: onClose
                    }),
                    title: t("imageEditTitle", "切り抜き"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        loading: saving,
                        color: "primary",
                        sx: {
                            mr: -1,
                            color: "white"
                        },
                        onClick: handleCropImage,
                        children: t("keep")
                    })
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedBottomCell, {
                    ratioType: ratioType,
                    onChangeRatioType: handleChangeRatio,
                    onChangeRotate: handleChangeRotate
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    justifyContent: "center",
                    sx: {
                        height: "100%",
                        width: "100%",
                        bgcolor: "grey.900",
                        p: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactCropStyled, {
                        crop: crop,
                        ruleOfThirds: true,
                        aspect: aspect,
                        minHeight: 200,
                        onChange: function(_, newCrop) {
                            setCrop(newCrop);
                            cropRef.current = newCrop;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            ref: imageRef,
                            src: src,
                            alt: "",
                            style: {
                                transform: "rotate(".concat(rotate, "deg)")
                            },
                            onLoad: handleImageLoaded
                        })
                    })
                })
            })
        })
    });
};
var TO_RADIANS = Math.PI / 180;
function getCroppedImg(image, crop, isIOS) {
    return _getCroppedImg.apply(this, arguments);
}
function _getCroppedImg() {
    _getCroppedImg = (0,src_async_to_generator/* default */.Z)(function(image, crop, isIOS) {
        var maximumPixels, rotate, canvas, pixelRatio, scaleX, scaleY, ctx, requiredPixels, scalar, cropX, cropY, rotateRads, centerX, centerY;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            maximumPixels = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 16777216, rotate = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 0;
            canvas = document.createElement("canvas");
            pixelRatio = window.devicePixelRatio;
            scaleX = image.naturalWidth / image.width;
            scaleY = image.naturalHeight / image.height;
            ctx = canvas.getContext("2d");
            if (!ctx) {
                return [
                    2,
                    Promise.reject("Can not get context")
                ];
            }
            requiredPixels = image.naturalWidth * pixelRatio * image.naturalHeight * pixelRatio;
            scalar = 1;
            if (requiredPixels > maximumPixels && isIOS) {
                scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);
            }
            canvas.width = Math.floor(crop.width * scaleX * pixelRatio * scalar);
            canvas.height = Math.floor(crop.height * scaleY * pixelRatio * scalar);
            ctx.scale(pixelRatio, pixelRatio);
            ctx.imageSmoothingQuality = "high";
            cropX = crop.x * scaleX;
            cropY = crop.y * scaleY;
            rotateRads = rotate * TO_RADIANS;
            centerX = image.naturalWidth / 2;
            centerY = image.naturalHeight / 2;
            ctx.save();
            // Move the crop origin to the canvas origin (0,0)
            ctx.translate(-cropX, -cropY);
            // Move the origin to the center of the original position
            ctx.translate(centerX, centerY);
            // Rotate around the origin
            ctx.rotate(rotateRads);
            // Move the center of the image to the origin (0,0)
            ctx.translate(-centerX, -centerY);
            ctx.drawImage(image, 0, 0, image.naturalWidth * scalar, image.naturalHeight * scalar, 0, 0, image.naturalWidth * scalar, image.naturalHeight * scalar);
            // As a blob
            return [
                2,
                new Promise(function(resolve, reject) {
                    canvas.toBlob(function(blob) {
                        if (!blob) {
                            return reject(/**
             * @todo
             * iOSサイズ制限のため縦横幅が大きい画像をcanvasで出力できない。トリムなしで画像アップできるようにリサイズ処理などを実装する。
             *
             * https://app.clickup.com/t/908127/UT-5179
             */ crop.width * scaleX > 2355 ? "canvasSizeOver" : "canvasIsEmpty");
                        }
                        return resolve(blob);
                    }, "image/jpeg", 1);
                })
            ];
        });
    });
    return _getCroppedImg.apply(this, arguments);
}
var FixedBottomCell = function(param) {
    var ratioType = param.ratioType, onChangeRatioType = param.onChangeRatioType, onChangeRotate = param.onChangeRotate;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.900"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                px: 5,
                bgcolor: "grey.900",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                                variant: "text",
                                sx: {
                                    color: ratioType === RatioType.ORIGINAL ? "primary.main" : "white"
                                },
                                onClick: function() {
                                    return onChangeRatioType(RatioType.ORIGINAL);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Reset, {
                                        fontSize: "small",
                                        color: "inherit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        sx: {
                                            pt: 1
                                        },
                                        color: "inherit",
                                        children: t("originalSize", "元サイズ")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                                variant: "text",
                                sx: {
                                    color: ratioType === RatioType.RECTANGLE ? "primary.main" : "white"
                                },
                                onClick: function() {
                                    return onChangeRatioType(RatioType.RECTANGLE);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Rectangle, {
                                        fontSize: "small",
                                        color: "inherit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        sx: {
                                            pt: 1
                                        },
                                        color: "inherit",
                                        children: t("rectangleSize", "16:9")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                            variant: "text",
                            sx: {
                                color: "white"
                            },
                            onClick: onChangeRotate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Rotate, {
                                    variant: "v2",
                                    fontSize: "small",
                                    color: "inherit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    sx: {
                                        pt: 1
                                    },
                                    color: "inherit",
                                    children: t("rotate", "回転")
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var StyledButton = (0,styled/* default */.ZP)(Button_Button/* default */.Z)(function() {
    return {
        flexDirection: "column",
        p: 0,
        borderRadius: 0,
        textAlign: "center",
        minWidth: 56,
        alignItems: "center"
    };
});
var ReactCropStyled = (0,styled/* default */.ZP)(react_image_crop_dist/* default */.ZP)(function() {
    return {
        "&&": {
            maxHeight: "100%",
            ".ReactCrop__drag-handle": {
                margin: 0,
                "&::after": {
                    width: 40,
                    height: 40,
                    borderWidth: 0,
                    borderStyle: "solid",
                    borderColor: "white",
                    backgroundColor: "transparent"
                }
            },
            ".ReactCrop__crop-selection": {
                borderStyle: "solid"
            },
            "& .ReactCrop__crop-selection": {
                animation: "none",
                backgroundImage: "none",
                borderWidth: 2
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/organisms/consoleImageEditor/useConsoleImageEditor.tsx







var useConsoleImageEditor = function(param) {
    var artistId = param.artistId, callback = param.callback, _initialPath = param.initialPath, initialPath = _initialPath === void 0 ? "" : _initialPath;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var getImage = camera/* getImage */.g;
    var upload = (0,useTmpUploader/* useUserTmpUploader */.x)(artistId).upload;
    var ref1 = (0,react.useState)(""), filePathBeforeCrop = ref1[0], setFilePathBeforeCrop = ref1[1];
    var ref2 = (0,react.useState)(""), filePathAfterCrop = ref2[0], setFilePathAfterCrop = ref2[1];
    var handleGetImage = (0,react.useCallback)(function() {
        return getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image).then(function(file) {
            if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                throw new Error("uploadErrorMaximumSize");
            }
            return file;
        }).catch(function(error) {
            if (error.message === "uploadErrorMaximumSize") {
                showError(new Error(t("uploadErrorMaximumSize")));
                return;
            }
            if (error.message === "uploadErrorImageOnly") {
                showError(new Error(t("uploadErrorImageOnly")));
                return;
            }
            showError(error);
            return;
        });
    }, [
        getImage,
        showError,
        t
    ]);
    var handleChoseFile = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var file;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        handleGetImage()
                    ];
                case 1:
                    file = _state.sent();
                    if (!file) return [
                        2
                    ];
                    setFilePathBeforeCrop(URL.createObjectURL(file));
                    setOpen(true);
                    return [
                        2
                    ];
            }
        });
    }), [
        handleGetImage
    ]);
    var handleRemoveFile = (0,react.useCallback)(function() {
        setFilePathAfterCrop("");
    }, []);
    var handleSave = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFilePathAfterCrop(data.fileUrl);
                        return [
                            4,
                            callback(data)
                        ];
                    case 1:
                        _state.sent();
                        setOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setFilePathAfterCrop(initialPath);
    }, [
        initialPath
    ]);
    var ModalProps = {
        open: open,
        artistId: artistId,
        src: filePathBeforeCrop !== null && filePathBeforeCrop !== void 0 ? filePathBeforeCrop : "",
        onClose: function() {
            return setOpen(false);
        },
        onUploadFile: function(file) {
            return upload(file);
        },
        onSave: handleSave
    };
    return {
        ConsoleImageEditModal: ConsoleImageEditModal,
        ModalProps: ModalProps,
        handleChoseFile: handleChoseFile,
        handleRemoveFile: handleRemoveFile,
        filePathAfterCrop: filePathAfterCrop
    };
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionCreate/template/CollectionCreateForm.tsx















var CollectionCreateForm_schema = function(o) {
    return {
        title: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.title")),
        description: o.string().max(500).label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.description")),
        startedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.startedAt")),
        endedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.endedAt")),
        thumbnailPath: o.string().label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.thumbnailPath")),
        thumbnailResource: o.object().allow(null).optional(),
        hasNft: o.boolean().allow(false).optional(),
        isPublishedFlag: o.boolean().allow(false).optional(),
        isPublishOnStore: o.boolean().allow(false).optional(),
        nft: o.object({
            salesType: o.string().label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.nft.salesType")),
            chains: o.array().items(o.object({
                chainName: o.string().allow("").optional(),
                royalty: o.number().min(0).max(10).label((0,core_form/* tLabel */.TQ)("consoleCollectionCreate.nft.royalty"))
            }))
        })
    };
};
var CollectionCreateForm = function(param) {
    var artistId = param.artistId, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: CollectionCreateForm_schema,
        defaultValues: CollectionCreateForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid, register = ref.register, setValue = ref.setValue, watch = ref.watch, control = ref.control, setError = ref.setError;
    var watchHasNft = watch("hasNft", false);
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "nft.chains"
    }).fields;
    (0,react.useEffect)(function() {
        if (!watchHasNft) {
            setValue("nft", defaultNft, {
                shouldValidate: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        watchHasNft
    ]);
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        inputs = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                            nft: values.hasNft ? values.nft : null,
                            status: values.isPublishedFlag ? utoniq_core_schema/* CollectionStatus.Published */.NbM.Published : utoniq_core_schema/* CollectionStatus.Unpublished */.NbM.Unpublished,
                            startedAt: values.startedAt === "" ? null : values.startedAt,
                            endedAt: values.endedAt === "" ? null : values.endedAt
                        });
                        return [
                            4,
                            onSubmit(inputs).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        setError,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 2,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.title
            }, register("title"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.description
            }, register("description"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionThumbnailInputCell, {
                artistId: artistId,
                watch: watch,
                setValue: setValue,
                error: errors.thumbnailPath,
                thumbnailUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedFlag"),
                    description: t("isPublishedFlagDesc")
                }
            }, register("isPublishedFlag"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInputDateCell, {
                errors: errors,
                setValue: setValue,
                startedAt: watch("startedAt"),
                endedAt: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishOnStore"),
                    description: t("isPublishOnStoreDesc")
                }
            }, register("isPublishOnStore"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: !isValid || isSubmitting,
                    loading: isSubmitting,
                    onClick: handleSubmit(handleOnSubmit),
                    children: t("applyForIssuance")
                })
            })
        ]
    });
};
var CollectionCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            ref: ref
        }, props), {
            t: t
        }))
    });
});
var CollectionThumbnailInputCell = function(param) {
    var artistId = param.artistId, error = param.error, watch = param.watch, setValue = param.setValue, thumbnailUploadInfo = param.thumbnailUploadInfo;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    var ref = useConsoleImageEditor({
        artistId: artistId,
        initialPath: "",
        callback: function callback(data) {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var _tmpPath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setValue("thumbnailPath", (_tmpPath = data.tmpPath) !== null && _tmpPath !== void 0 ? _tmpPath : "", {
                        shouldValidate: true
                    });
                    return [
                        2
                    ];
                });
            })();
        }
    }), ConsoleImageEditModal = ref.ConsoleImageEditModal, ModalProps = ref.ModalProps, filePathAfterCrop = ref.filePathAfterCrop, handleChoseFile = ref.handleChoseFile, handleRemoveFile = ref.handleRemoveFile;
    var thumbnailResource = watch("thumbnailResource");
    var resource = (0,react.useMemo)(function() {
        if (filePathAfterCrop) {
            return {
                id: "",
                resourceName: "",
                imageUploadPath: filePathAfterCrop,
                imageUrl: filePathAfterCrop
            };
        }
    }, [
        filePathAfterCrop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                sx: {
                    p: 0
                },
                shape: "collection",
                t: t,
                resource: resource !== null && resource !== void 0 ? resource : thumbnailResource,
                fileUploadInfo: {
                    type: "image",
                    onDrop: function onDrop() {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            handleChoseFile()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    },
                    progress: thumbnailUploadInfo.progress || 0,
                    description: t("thumbnailPathDescription"),
                    onClose: function onClose() {
                        handleRemoveFile();
                        setValue("thumbnailPath", "", {
                            shouldValidate: true
                        });
                        setValue("thumbnailResource", null, {
                            shouldValidate: true
                        });
                    }
                },
                content: {
                    title: t("thumbnailPathTitle"),
                    contentNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        children: t("thumbnailPathContentNode")
                    })
                }
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleImageEditModal, (0,src_object_spread/* default */.Z)({}, ModalProps))
        ]
    });
};
var ToggleInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var sx = _param.sx, description = _param.description, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sx",
        "description"
    ]);
    return (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                inputRef: ref,
                sx: {
                    px: 0,
                    pt: 0,
                    "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                        bgcolor: "primary.main"
                    }
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: description
            })
        ]
    });
});
var NftInputCell = function(param) {
    var value = param.value, setValue = param.setValue, readOnly = param.readOnly;
    var t = useTranslation("consoleCollectionCreate").t;
    var listItems = [
        {
            value: ItemNftSalesType.UserActivation,
            label: t("sellNormallyAndAllowUsers"),
            disabled: readOnly
        },
        {
            value: ItemNftSalesType.NftSales,
            label: t("soldNFTItem"),
            disabled: readOnly
        }, 
    ];
    return /*#__PURE__*/ _jsxs(CellFrame, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                children: t("sellNFTLabel")
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 3
                },
                children: t("sellNFTDesc")
            }),
            /*#__PURE__*/ _jsx(RadioButtonsGroup, {
                row: false,
                value: value,
                title: "sellNft",
                listItems: listItems,
                onChange: function(newValue) {
                    if (newValue === listItems[1].value) {
                        setValue("nft.salesType", newValue, {
                            shouldValidate: true
                        });
                        return;
                    }
                    setValue("nft.salesType", newValue, {
                        shouldValidate: true
                    });
                },
                t: t
            })
        ]
    });
};
var RoyaltyInputCell = function(param) {
    var inputProps = param.inputProps;
    var ref;
    var t = useTranslation("consoleCollectionCreate").t;
    return /*#__PURE__*/ _jsxs(CellFrame, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                children: t("royaltyNFTLabel")
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 3
                },
                children: t("royaltyNFTDesc")
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                direction: "row",
                alignItems: "center",
                spacing: 2,
                sx: {
                    mb: 5
                },
                children: [
                    /*#__PURE__*/ _jsx(CollectionCreateForm_TextInputCell, _object_spread_props(_object_spread({}, inputProps), {
                        textFieldProps: _object_spread_props(_object_spread({}, inputProps.textFieldProps), {
                            sx: {
                                mb: 0
                            }
                        })
                    })),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        sx: {
                            pb: 4
                        },
                        children: "%"
                    })
                ]
            }),
            !(inputProps === null || inputProps === void 0 ? void 0 : (ref = inputProps.textFieldProps) === null || ref === void 0 ? void 0 : ref.disabled) && /*#__PURE__*/ _jsx(Stack, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "caption",
                    align: "center",
                    sx: {
                        color: "error.main"
                    },
                    children: t("issuanceOfNFTNote")
                })
            })
        ]
    });
};
var CollectionInputDateCell = function(param) {
    var setValue = param.setValue, errors = param.errors, startedAt = param.startedAt, endedAt = param.endedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                onChange: function(date) {
                    setValue("startedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                value: startedAt ? dayjs_min_default()(startedAt) : null,
                title: t("startedAt"),
                description: t("startedAtDesc"),
                placeholder: t("startedAtPlaceholder"),
                error: errors === null || errors === void 0 ? void 0 : errors.startedAt,
                titleProps: {
                    variant: "subtitle1",
                    color: "text.primary"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                onChange: function(date) {
                    setValue("endedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                value: endedAt ? dayjs_min_default()(endedAt) : null,
                title: t("endedAt"),
                description: t("endedAtDesc"),
                placeholder: t("endedAtPlaceholder"),
                error: errors === null || errors === void 0 ? void 0 : errors.endedAt,
                titleProps: {
                    variant: "subtitle1",
                    color: "text.primary"
                }
            })
        ]
    });
};
var defaultNft = {
    salesType: utoniq_core_schema/* ItemNftSalesType.UserActivation */.PxR.UserActivation,
    chains: [
        {
            royalty: 10,
            chainName: "polygon"
        }, 
    ]
};
var CollectionCreateForm_defaultValues = {
    title: "",
    thumbnailPath: "",
    description: "",
    thumbnailResource: null,
    nft: defaultNft,
    hasNft: false,
    startedAt: null,
    endedAt: null,
    isPublishedFlag: false
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionCreate/template/index.tsx










var ConsoleCollectionCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onDrop = param.onDrop;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCollectionCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: routerPages.ConsoleCollections
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_HeadingTextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCreateForm, {
                        artistId: state.artistId,
                        fileUploadInfo: {
                            progress: state.progress,
                            onDrop: onDrop
                        },
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};
var template_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 5,
            mb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                children: t("description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    py: 2
                },
                component: "a",
                target: "_blank",
                href: (0,helpUrl/* getHelpUrl */.R)("collection"),
                children: t("gotoDetail")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionCreate/viewModel.ts




function ConsoleCollectionCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateCollection($inputs: CreateCollectionInput) {\n    createCollection(inputs: $inputs) {\n      ...CollectionsSelectBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollectionCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ConsoleCollectionCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showError = ref.showError, showMessage = ref.showMessage;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    var getImage = camera/* getImage */.g;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref2.upload, progress = ref2.progress;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_COLLECTION, {
        onCompleted: function onCompleted() {
            showMessage(t("createdCollectionSuccessful"), "success");
            router.goBack(routerPages.ConsoleCollections);
        }
    }), 1), createCollection = ref3[0];
    var onDrop = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function onDrop() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4;
    return {
        state: {
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            progress: progress
        },
        actions: {
            onDrop: function onDrop1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onDrop().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(param) {
                var title = param.title, description = param.description, nft = param.nft, thumbnailPath = param.thumbnailPath, isPublishOnStore = param.isPublishOnStore, startedAt = param.startedAt, endedAt = param.endedAt, status = param.status;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createCollection({
                                        variables: {
                                            inputs: {
                                                title: title,
                                                description: description,
                                                nft: nft,
                                                thumbnailPath: thumbnailPath,
                                                isPublishOnStore: isPublishOnStore,
                                                startedAt: startedAt,
                                                endedAt: endedAt,
                                                status: status
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CREATE_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionCreate_viewModel_templateObject(), utoniq_core_schema/* CollectionsSelectBoxFragmentDoc */.eFx);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionCreate/index.tsx




/**
 * ConsoleCollectionCreate Page
 * Implemented as a practical sample.
 */ var ConsoleCollectionCreate = function() {
    var ref = ConsoleCollectionCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/usehooks-ts/esm/index.js + 58 modules
var usehooks_ts_esm = __webpack_require__(919);
;// CONCATENATED MODULE: ./src/components/organisms/console/CollectionPublishedLabel/index.tsx






var CollectionPublishedLabel = function(param) {
    var status = param.status, formattedStartedAt = param.formattedStartedAt, formattedEndedAt = param.formattedEndedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollections").t;
    // 開始済みコレクションかどうか
    var isStartedTerm = !!formattedStartedAt && formattedStartedAt <= values_Date/* DateTime.now */.o.now();
    // 終了済みコレクションかどうか（endedAtがない場合は無期限）
    var isEndedTerm = formattedEndedAt ? formattedEndedAt <= values_Date/* DateTime.now */.o.now() : false;
    // コレクションが公開中かどうか
    var publishing = !!(status === utoniq_core_schema/* CollectionStatus.Published */.NbM.Published && isStartedTerm && !isEndedTerm);
    // 公開中、または公開予定かどうか(公開日時を表示するか)
    var showPublishedAt = status === utoniq_core_schema/* CollectionStatus.Published */.NbM.Published && !isEndedTerm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPublishedChip, {
                publishing: publishing
            }),
            showPublishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                children: publishing ? t("publishedAt", {
                    publishedAt: formattedStartedAt
                }) : t("willBePublishedAt", {
                    publishedAt: formattedStartedAt
                })
            })
        ]
    });
};
var CollectionPublishedChip = function(param) {
    var publishing = param.publishing;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollections").t;
    var content = publishing ? {
        word: t("published"),
        bgcolor: "primary.main"
    } : {
        word: t("unpublish"),
        bgcolor: "grey.300"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultChip, (0,src_object_spread/* default */.Z)({}, content));
};
var DefaultChip = function(param) {
    var word = param.word, bgcolor = param.bgcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        sx: {
            height: 20,
            bgcolor: bgcolor,
            minWidth: 48,
            ".MuiChip-label": {
                px: 2
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                display: "flex"
            },
            variant: "overline",
            color: "common.white",
            children: word
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/item/ItemIcon/index.tsx
var ItemIcon = __webpack_require__(30176);
// EXTERNAL MODULE: ./src/components/organisms/item/ThroughTicketTag/index.tsx
var ThroughTicketTag = __webpack_require__(30047);
;// CONCATENATED MODULE: ./src/components/organisms/console/ItemSelectBox/ItemStatusCell.tsx










var ItemStatusCell = function(param) {
    var salesCondition = param.salesCondition, isPublished = param.isPublished, isDrm = param.isDrm, isPremium = param.isPremium, isThroughTicket = param.isThroughTicket;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    var salesStatusTag = (0,react.useMemo)(function() {
        switch(salesCondition){
            case utoniq_core_schema/* SalesCondition.Active */.HrV.Active:
                return {
                    label: t(utoniq_core_schema/* ItemStatus.Sale */.MsP.Sale),
                    sx: {
                        bgcolor: "secondary.main"
                    },
                    color: "white"
                };
            case utoniq_core_schema/* SalesCondition.Before */.HrV.Before:
                return {
                    label: t(utoniq_core_schema/* ItemStatus.Before */.MsP.Before),
                    sx: {
                        bgcolor: "grey.100",
                        color: "text.secondary"
                    },
                    color: "secondary.main"
                };
            case utoniq_core_schema/* SalesCondition.End */.HrV.End:
                return {
                    label: t(utoniq_core_schema/* ItemStatus.End */.MsP.End),
                    sx: {
                        bgcolor: "grey.100",
                        color: "text.secondary"
                    },
                    color: "secondary.main"
                };
            default:
                return {
                    label: t(utoniq_core_schema/* ItemStatus.Pause */.MsP.Pause),
                    sx: {
                        bgcolor: "grey.100",
                        color: "text.secondary"
                    },
                    color: "secondary.main"
                };
        }
    }, [
        salesCondition,
        t
    ]);
    var publishingStatusTag = (0,react.useMemo)(function() {
        // 公開中
        if (isPublished) {
            return {
                label: t("publish"),
                sx: {
                    bgcolor: "primary.main"
                },
                color: "white"
            };
        }
        return {
            label: t(utoniq_core_schema/* ItemStatus.Private */.MsP.Private),
            sx: {
                bgcolor: "grey.100"
            },
            color: "text.disabled"
        };
    }, [
        isPublished,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: salesStatusTag.color,
                        children: salesStatusTag.label
                    }),
                    sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, salesStatusTag.sx), {
                        p: 1,
                        height: 20,
                        ".MuiChip-label": {
                            px: 0
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: publishingStatusTag.color,
                        children: publishingStatusTag.label
                    }),
                    sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, publishingStatusTag.sx), {
                        p: 1,
                        height: 20,
                        ".MuiChip-label": {
                            px: 0
                        }
                    })
                }),
                isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                    fontSize: "small",
                    sx: {
                        color: "info.main"
                    }
                }),
                isDrm && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "white",
                        children: t("drm")
                    }),
                    sx: {
                        bgcolor: "primary.dark",
                        p: 1,
                        height: 20,
                        ".MuiChip-label": {
                            px: 0
                        }
                    }
                }),
                isThroughTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ItemSelectBox/index.tsx




















var ItemSelectBox = function(param) {
    var item = param.item, artistId = param.artistId, showIcon = param.showIcon, editable = param.editable, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling, onRemove = param.onRemove, menuLabel = param.menuLabel, removeItemConfirmModal = param.removeItemConfirmModal;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref6[0], copy = ref6[1];
    var ref7, ref8;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)(generatePath(routerPages.ArtistStoreItemDetail, {
        artistId: (ref8 = (ref7 = (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref7 !== void 0 ? ref7 : artistId) !== null && ref8 !== void 0 ? ref8 : "#",
        itemId: item.id
    })).onClick;
    var ref9 = (0,react.useState)(false), open = ref9[0], setOpen = ref9[1];
    var ref10 = (0,react.useState)(false), removing = ref10[0], setRemoving = ref10[1];
    var ref11 = (0,react.useState)(null), anchorEl = ref11[0], setAnchorEl = ref11[1];
    var ref12;
    var options = [
        {
            label: item.isPublished ? t("keepPrivateLabel") : t("publishLabel"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setAnchorEl(null);
                                return [
                                    4,
                                    onToggleActive(item.id, item.isPublished)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: item.salesStatus === utoniq_core_schema/* SalesStatus.Active */.Qsp.Active ? t("stopSellingLabel") : t("startSellingLabel"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setAnchorEl(null);
                                return [
                                    4,
                                    onToggleSelling(item.id, item.salesStatus !== utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("copyURLLabel"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(routerPages.ArtistStoreItemDetail, {
                                        artistId: (ref2 = (ref1 = (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : artistId) !== null && ref2 !== void 0 ? ref2 : "#",
                                        itemId: item.id
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("openStoreLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick() {
                onClick();
                setAnchorEl(null);
            }
        },
        {
            label: (ref12 = menuLabel === null || menuLabel === void 0 ? void 0 : menuLabel.deleteLabel) !== null && ref12 !== void 0 ? ref12 : t("deleteLabel"),
            onClick: function onClick() {
                setOpen(true);
                setAnchorEl(null);
            }
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setRemoving(true);
                    return [
                        4,
                        onRemove(item.id).finally(function() {
                            setOpen(false);
                            setRemoving(false);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onRemove,
        item.id
    ]);
    var ref13, _usedNumber, _purchasedNumber, ref14, ref15, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "relative"
                            },
                            children: [
                                showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        zIndex: 1,
                                        marginInline: "auto",
                                        pl: 1,
                                        width: 104,
                                        position: "absolute",
                                        top: 8
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                        type: item.type
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                    size: "small",
                                    src: (ref13 = (ref1 = item.thumbnail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.front) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref13 !== void 0 ? ref13 : ""
                                }),
                                config_config/* config.modules.nft */.v.modules.nft && false && /*#__PURE__*/ 0
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                                    isPremium: item.isPremium,
                                    isPublished: item.isPublished,
                                    salesCondition: item.salesCondition,
                                    isDrm: item.isDrm
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    sx: {
                                        pt: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        color: "text.secondary",
                                                        children: [
                                                            t("remainingQuantity", {
                                                                quantity: item.formattedRemainingNumber
                                                            }),
                                                            item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    t("usedNumber", {
                                                                        usedNumber: (_usedNumber = item.usedNumber) !== null && _usedNumber !== void 0 ? _usedNumber : 0
                                                                    }),
                                                                    "/",
                                                                    (_purchasedNumber = item.purchasedNumber) !== null && _purchasedNumber !== void 0 ? _purchasedNumber : 0
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    item.skuSettings && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusTagCell, {
                                                        number: ((ref3 = item.skuSettings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.units) === null || ref4 === void 0 ? void 0 : ref4.length) || 0
                                                    })
                                                ]
                                            }),
                                            !!item.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: item.paymentType === "prepaid_point" || !item.paymentType ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                                            fontSize: "small"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                            variant: "h5",
                                                            color: "text.secondary",
                                                            children: item.formattedPrice
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                    variant: "h5",
                                                    children: t("price", {
                                                        price: item.formattedPrice
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                    size: "xSmall",
                                    bgcolor: "grey.100",
                                    color: "grey.700",
                                    onClick: handleClick,
                                    sx: {
                                        position: "relative",
                                        zIndex: 2,
                                        transform: "rotate(90deg)"
                                    }
                                }),
                                editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                                    href: generatePath(routerPages.ConsoleItemEdit, {
                                        itemId: item.id
                                    }),
                                    size: "xSmall",
                                    bgcolor: "grey.100",
                                    color: "grey.700",
                                    sx: {
                                        position: "relative",
                                        zIndex: 2
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                    anchorEl: anchorEl,
                                    open: Boolean(anchorEl),
                                    onClose: handleClose,
                                    children: options.map(function(_param) /*#__PURE__*/ {
                                        var icon = _param.icon, label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                                            "icon",
                                            "label"
                                        ]);
                                        return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                                            sx: {
                                                width: 200
                                            },
                                            key: label,
                                            children: [
                                                icon,
                                                label
                                            ]
                                        }));
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1
                },
                href: generatePath(routerPages.ConsoleItemDetail, {
                    itemId: item.id
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: (ref14 = removeItemConfirmModal === null || removeItemConfirmModal === void 0 ? void 0 : removeItemConfirmModal.title) !== null && ref14 !== void 0 ? ref14 : t("deleteItemModalTitle"),
                content: (ref15 = removeItemConfirmModal === null || removeItemConfirmModal === void 0 ? void 0 : removeItemConfirmModal.content) !== null && ref15 !== void 0 ? ref15 : t("deleteItemModalDesc"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    loading: removing,
                    sx: {
                        minWidth: 212
                    },
                    onClick: handleRemove,
                    children: (ref16 = removeItemConfirmModal === null || removeItemConfirmModal === void 0 ? void 0 : removeItemConfirmModal.confirm) !== null && ref16 !== void 0 ? ref16 : t("delete")
                })
            })
        ]
    });
};
var ItemStatusTagCell = function(param) {
    var number = param.number;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        variant: "outlined",
        size: "small",
        disableRipple: true,
        sx: {
            pointerEvents: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "text.hint",
            children: [
                "SKU（",
                number,
                "）"
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ItemSelectBoxSkeleton/index.tsx



var ItemSelectBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5,
                "&:last-child": {
                    pb: 5
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 60,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                numberOfLine: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "50%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "25%"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/template/EventModal.tsx







var EventModal = function(param) {
    var open = param.open, onClose = param.onClose, event = param.event;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    if (!event) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
            open: open,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                ml: "30px"
                            },
                            children: t("eventList")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "small",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pb: 5
                    },
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventItem, {
                        event: event
                    }, event.id)
                })
            ]
        })
    });
};
var EventItem = function(param) {
    var event = param.event;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ConsoleShokufesEventDetail, {
                    eventId: event.id
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        py: 2,
                        px: 3,
                        "&:last-child": {
                            pb: 2
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                src: (ref4 = (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref4 !== void 0 ? ref4 : "",
                                sx: {
                                    width: 100,
                                    height: 66
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 1,
                                sx: {
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                                                event: event
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: t("date", {
                                                    date: event.dateRange
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                        children: event.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("collection", {
                                            number: (ref5 = (ref1 = event.eventCollections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref5 !== void 0 ? ref5 : 0
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/template/ItemSelectBox.tsx






var ItemSelectBox_ItemSelectBox = function(param) {
    var checked = param.checked, item = param.item, onSelect = param.onSelect, showIcon = param.showIcon;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    var ref1, _issuedNumber, _price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2,
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: checked ? "primary.main" : "grey.50",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    alignItems: "center",
                    sx: {
                        position: "relative"
                    },
                    children: [
                        showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                zIndex: 1,
                                marginInline: "auto",
                                pl: 1,
                                width: 104,
                                position: "absolute",
                                top: 8,
                                left: 16
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                type: item.type
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "small",
                            src: (ref1 = (ref = item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: t("issuedNumber", {
                                                        number: (_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                    variant: "h5",
                                                    color: "text.secondary",
                                                    children: t("price", {
                                                        number: (_price = item.price) !== null && _price !== void 0 ? _price : 0
                                                    })
                                                })
                                            ]
                                        }),
                                        item.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            justifyContent: "flex-end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                                sx: {
                                                    color: "info.main"
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                onClick: function() {
                    if (!onSelect || checked) {
                        return;
                    }
                    return onSelect(item.id);
                },
                sx: {
                    position: "absolute",
                    zIndex: 2,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }
            })
        ]
    });
};
var ItemSelectBox_ItemSelectBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 60,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignSelf: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "80%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "80%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    pt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "40%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "20%"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/template/ItemSelectForm.tsx








var ItemSelectForm_schema = function(o) {
    return {
        keyword: o.string().allow("").optional()
    };
};
var ItemSelectForm = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ItemSelectForm_schema,
        defaultValues: ItemSelectForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var keyword = param.keyword;
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ItemSelectForm_defaultValues), {
            keyword: keyword
        }));
    }), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        onSubmit: handleSubmit(onSubmit)
    });
};
var ItemSelectForm_SearchInputCell = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(props, ref) {
    var t = useTranslation("consoleCollectionCreate").t;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ _jsx(SearchInputField, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            t: t
        }))
    });
})));
var ItemSelectForm_defaultValues = {
    keyword: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/template/ItemSelectModal.tsx















var ItemSelectModal = function(param) {
    var artistId = param.artistId, open = param.open, values = param.values, onClose = param.onClose, loading = param.loading, hasNextPage = param.hasNextPage, addingItem = param.addingItem, onFetchMore = param.onFetchMore, items = param.items, onSearch = param.onSearch, onSelect = param.onSelect, nftIssuing = param.nftIssuing, isNft = param.isNft;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var ref2 = (0,react.useState)(""), itemSelected = ref2[0], setItemSelected = ref2[1];
    var ref3 = (0,react.useState)(false), openItemAddingModal = ref3[0], setOpenItemAddingModal = ref3[1];
    var modalRef = (0,react.useRef)(null);
    var addItemToCollection = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            setOpenItemAddingModal(true);
            return [
                2,
                onSelect(itemSelected).then(function() {
                    showMessage(t("editMessage"), "success");
                }).catch(function(e) {
                    showError(e);
                }).finally(function() {
                    setOpenItemAddingModal(false);
                    setItemSelected("");
                })
            ];
        });
    }), [
        itemSelected,
        onSelect,
        showError,
        showMessage,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
                artistId: artistId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                    ref: modalRef,
                    customNavigation: itemSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectModal_FixedBottomCell, {
                        onSelect: function() {
                            return addItemToCollection();
                        },
                        loading: addingItem
                    }) : null,
                    margin: true,
                    header: {
                        left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                            edge: "start",
                            size: "medium",
                            color: "white",
                            sx: {
                                color: "white",
                                ".MuiSvgIcon-root": {
                                    color: "inherit"
                                }
                            },
                            onClick: function() {
                                onClose();
                                setItemSelected("");
                            }
                        }),
                        title: t("itemSelection")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectForm, {
                            onSubmit: onSearch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: items === null || items === void 0 ? void 0 : (ref = items.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBox_ItemSelectBox, {
                                    item: node,
                                    checked: (0,src_to_consumable_array/* default */.Z)(values).concat([
                                        itemSelected
                                    ]).includes(node.id),
                                    onSelect: function(itemId) {
                                        return setItemSelected(itemId);
                                    },
                                    showIcon: true
                                }, node.id);
                            }),
                            emptyMessage: t("emptyItemSelect"),
                            loading: loading,
                            hasNextPage: hasNextPage,
                            onFetchMore: onFetchMore,
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 5,
                                sx: {
                                    pb: 2
                                },
                                children: Array.from(Array(4).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBox_ItemSelectBoxSkeleton, {}, key);
                                })
                            }),
                            modalRef: modalRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCreatingModal, {
                            open: openItemAddingModal,
                            addingItem: addingItem,
                            nftIssuing: nftIssuing,
                            isNft: isNft
                        })
                    ]
                })
            })
        })
    });
};
var ItemSelectModal_FixedBottomCell = function(param) {
    var onSelect = param.onSelect, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                bgcolor: "grey.50",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    minWidth: 244
                },
                onClick: onSelect,
                loading: loading,
                disabled: loading,
                children: t("addSelectedItem")
            })
        })
    });
};
var ItemCreatingModal = function(param) {
    var open = param.open, isNft = param.isNft, addingItem = param.addingItem, nftIssuing = param.nftIssuing;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            id: "modal-inner",
            sx: {
                width: 280,
                borderRadius: 3,
                px: 5,
                py: 7,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "grey.100",
                outline: "none",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        mb: 4
                    },
                    children: t("itemOrdering")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flexDirection: "row",
                    alignItems: "center",
                    sx: {
                        ml: 8,
                        mb: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                height: 40,
                                width: 40,
                                display: "grid",
                                placeItems: "center"
                            },
                            children: addingItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress_CircularProgress/* default */.Z, {
                                size: 30
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RoundCheck, {
                                fontSize: "large"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "start",
                            sx: {
                                ml: 3
                            },
                            children: [
                                isNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "secondary",
                                    children: "STEP1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("step1Description")
                                })
                            ]
                        })
                    ]
                }),
                isNft && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flexDirection: "row",
                    alignItems: "center",
                    sx: {
                        ml: 8,
                        mb: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                height: 40,
                                width: 40,
                                display: "grid",
                                placeItems: "center"
                            },
                            children: addingItem || nftIssuing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress_CircularProgress/* default */.Z, {
                                size: 30
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RoundCheck, {
                                fontSize: "large"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "start",
                            sx: {
                                ml: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "secondary",
                                    children: "STEP2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("step2Description")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/template/index.tsx

























var ConsoleCollectionDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onRemove = param.onRemove, onSelectItems = param.onSelectItems, onSearchItems = param.onSearchItems, onFetchMoreItems = param.onFetchMoreItems, onConnectMetamask = param.onConnectMetamask, onConnectWeb3auth = param.onConnectWeb3auth, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling, onRemoveItemFromCollection = param.onRemoveItemFromCollection;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    var ref14 = (0,router_useRouter/* useRouter */.tv)(), router = ref14.router, routerNames = ref14.routerNames, generatePath = ref14.generatePath, routerPages = ref14.routerPages;
    var ref15 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref15.showMessage, showError = ref15.showError;
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref16[0], copy = ref16[1];
    var ref17;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,lib_url/* generateFullPath */.QP)(routerPages.CollectionDetail, {
        collectionId: (ref17 = (ref = state.collection) === null || ref === void 0 ? void 0 : ref.id) !== null && ref17 !== void 0 ? ref17 : "#"
    })).onClick;
    var ref18 = (0,react.useState)(null), anchorEl = ref18[0], setAnchorEl = ref18[1];
    var ref19 = (0,react.useState)(false), openTrashConfirm = ref19[0], setOpenTrashConfirm = ref19[1];
    var options = [
        {
            label: t("openStoreLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick1() {
                onClick();
                setAnchorEl(null);
            }
        },
        {
            label: t("copyURLLabel"),
            onClick: function onClick1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(routerPages.CollectionDetail, {
                                        collectionId: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.id
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("edit"),
            onClick: function onClick1() {
                var ref;
                handleClose();
                router.push(generatePath(routerPages.ConsoleCollectionEdit, {
                    collectionId: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.id
                }));
            }
        },
        {
            label: t("remove"),
            onClick: function onClick1() {
                handleClose();
                setOpenTrashConfirm(true);
            }
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var ref20, ref21, ref22, ref23, ref24, ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCollectionDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleCollections,
                    title: (ref1 = state.collection) === null || ref1 === void 0 ? void 0 : ref1.title,
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                        edge: "end",
                        size: "medium",
                        onClick: handleClick,
                        color: "white"
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                        anchorEl: anchorEl,
                        open: Boolean(anchorEl),
                        onClose: handleClose,
                        children: options.map(function(option) {
                            var ref;
                            if (config_config/* config.modules.nft */.v.modules.nft && ((ref = state.collection) === null || ref === void 0 ? void 0 : ref.nft) && option.label === t("remove")) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                                onClick: option.onClick,
                                sx: {
                                    width: 200
                                },
                                children: [
                                    option.icon,
                                    option.label
                                ]
                            }, option.label);
                        })
                    }),
                    state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CollectionDetailLoading, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionDetail_template_BannerCell, {
                                thumbnail: (ref20 = (ref2 = state.collection) === null || ref2 === void 0 ? void 0 : ref2.thumbnail) !== null && ref20 !== void 0 ? ref20 : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CollectionOverviewTextCell, {
                                title: (ref21 = (ref3 = state.collection) === null || ref3 === void 0 ? void 0 : ref3.title) !== null && ref21 !== void 0 ? ref21 : "",
                                description: (ref22 = (ref4 = state.collection) === null || ref4 === void 0 ? void 0 : ref4.description) !== null && ref22 !== void 0 ? ref22 : "",
                                artist: (ref23 = (ref5 = state.collection) === null || ref5 === void 0 ? void 0 : ref5.artist) !== null && ref23 !== void 0 ? ref23 : null,
                                status: (ref6 = state.collection) === null || ref6 === void 0 ? void 0 : ref6.status,
                                event: state.event,
                                formattedStartedAt: (ref7 = state.collection) === null || ref7 === void 0 ? void 0 : ref7.formattedStartedAt,
                                formattedEndedAt: (ref8 = state.collection) === null || ref8 === void 0 ? void 0 : ref8.formattedEndedAt
                            })
                        ]
                    }),
                    config_config/* config.modules.nft */.v.modules.nft && ((ref9 = state.collection) === null || ref9 === void 0 ? void 0 : ref9.nft) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NftTextCell, {
                        nft: state.collection.nft
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemImageListCell, {
                        artistId: state.artistId,
                        loading: state.fetching || state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        collectionItems: (ref24 = (ref10 = state.collection) === null || ref10 === void 0 ? void 0 : ref10.collectionItems) !== null && ref24 !== void 0 ? ref24 : null,
                        onToggleActive: onToggleActive,
                        onToggleSelling: onToggleSelling,
                        onRemoveItemFromCollection: onRemoveItemFromCollection
                    }),
                    !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionDetail_template_BaseCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        artistId: state.artistId
                    }, state.itemSelectProps), {
                        values: (ref25 = (ref11 = state.collection) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.collectionItems) === null || ref12 === void 0 ? void 0 : ref12.edges.map(function(param) {
                            var node = param.node;
                            return node.item.id;
                        })) !== null && ref25 !== void 0 ? ref25 : [],
                        onFetchMore: onFetchMoreItems,
                        onSelect: onSelectItems,
                        onSearch: onSearchItems,
                        walletConnecting: state.walletConnecting,
                        isNft: state.isNft,
                        nft: (ref13 = state.collection) === null || ref13 === void 0 ? void 0 : ref13.nft,
                        nftIssuing: state.nftIssuing,
                        hasCryptoWallet: !!state.artistWalletAddress,
                        onConnectWallet: function(walletType) {
                            if (walletType === "metamask") {
                                try {
                                    checkMetamaskInstalled();
                                } catch (e) {
                                    showError(e);
                                }
                                return onConnectMetamask().then(function() {
                                    return showMessage(t("connectedWallet"));
                                });
                            }
                            if (walletType === "web3auth") {
                                return onConnectWeb3auth().then(function() {
                                    return showMessage(t("connectedWallet"));
                                });
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: openTrashConfirm,
                        onClose: function() {
                            return setOpenTrashConfirm(false);
                        },
                        title: t("trashConfirmTitle"),
                        content: t("trashConfirmDesc"),
                        cancelText: t("cancel"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            loading: state.removingCollection,
                            onClick: onRemove,
                            children: t("delete")
                        })
                    })
                ]
            })
        ]
    });
};
var ConsoleCollectionDetail_template_BannerCell = function(param) {
    var thumbnail = param.thumbnail;
    var ref, ref1;
    var thumbnailUri = (ref1 = (ref = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.mediumUri) !== null && ref !== void 0 ? ref : thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
        imageUri: thumbnailUri
    });
};
var template_CollectionOverviewTextCell = function(param) {
    var artist = param.artist, title = param.title, event = param.event, description = param.description, status = param.status, formattedStartedAt = param.formattedStartedAt, formattedEndedAt = param.formattedEndedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "text.hint",
                children: artist === null || artist === void 0 ? void 0 : artist.displayName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    pt: 1
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPublishedLabel, {
                    status: status,
                    formattedStartedAt: formattedStartedAt,
                    formattedEndedAt: formattedEndedAt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 3
                },
                children: description
            }),
            !!event && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "outlined",
                            onClick: function() {
                                return setOpen(true);
                            },
                            sx: {
                                borderColor: "primary.main",
                                color: "primary.main"
                            },
                            children: t("eventListNum")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventModal, {
                        event: event,
                        open: open,
                        onClose: function() {
                            return setOpen(false);
                        }
                    })
                ]
            })
        ]
    });
};
var NftTextCell = function(param) {
    var nft = param.nft;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                        fontSize: "small",
                        filledColor: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("nftSetting")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            width: 85
                        },
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("howToSell")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("royalty")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("chain")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t((ref4 = nft === null || nft === void 0 ? void 0 : nft.salesType) !== null && ref4 !== void 0 ? ref4 : "")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: [
                                    (ref5 = nft === null || nft === void 0 ? void 0 : (ref = nft.chains) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.royalty) !== null && ref5 !== void 0 ? ref5 : 0,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: nft === null || nft === void 0 ? void 0 : (ref2 = nft.chains) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.chainName
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle2",
                    color: "text.secondary",
                    children: t("nftSettingNote")
                })
            })
        ]
    });
};
var template_ItemImageListCell = function(param) {
    var artistId = param.artistId, loading = param.loading, hasNextPage = param.hasNextPage, collectionItems = param.collectionItems, onFetchMore = param.onFetchMore, onRemoveItemFromCollection = param.onRemoveItemFromCollection, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            loading && !(collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.edges) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "large",
                width: "50%",
                sx: {
                    mt: 1,
                    mb: 3
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    pt: 1,
                    pb: 3
                },
                children: t("registeredItem")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: loading,
                hasNextPage: hasNextPage,
                emptyMessage: t("emptyItemMessage"),
                nodes: collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBox, {
                        artistId: artistId,
                        item: node.item,
                        showIcon: true,
                        editable: false,
                        onToggleActive: onToggleActive,
                        onToggleSelling: onToggleSelling,
                        onRemove: onRemoveItemFromCollection,
                        menuLabel: {
                            deleteLabel: t("deleteItemFormCollection", "コレクションから除外")
                        },
                        removeItemConfirmModal: {
                            title: t("deleteItemFromCollectionModalTitle"),
                            content: t("deleteItemFromCollectionModalContent"),
                            confirm: t("deleteItem")
                        }
                    });
                }),
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        pt: 3,
                        pb: 5
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBoxSkeleton, {}, key);
                    })
                })
            })
        ]
    });
};
var ConsoleCollectionDetail_template_BaseCell = function(props) {
    var ref = (0,react.useState)(false), openItemSelect = ref[0], setOpenItemSelect = ref[1];
    var ref1 = (0,react.useState)(false), openWalletConnect = ref1[0], setOpenWalletConnect = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 16,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (props.nft) {
                                        // ウォレットの連携
                                        if (!props.hasCryptoWallet) {
                                            setOpenWalletConnect(true);
                                            return [
                                                2
                                            ];
                                        }
                                    }
                                    setOpenItemSelect(true);
                                    return [
                                        4,
                                        props.onSearch({
                                            keyword: ""
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                open: openItemSelect,
                onClose: function() {
                    return setOpenItemSelect(false);
                }
            }, props), {
                onSelect: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(itemId) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        props.onSelect(itemId)
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenItemSelect(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(itemId) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletConnectDrawer, {
                open: openWalletConnect,
                onClose: function() {
                    return setOpenWalletConnect(false);
                },
                connecting: props.walletConnecting,
                onConnectWallet: props.onConnectWallet
            })
        ]
    });
};
var template_CollectionDetailLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: "calc(100vw *  212 / 375)",
                    maxHeight: "calc(600px * 212 / 375)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "large",
                        width: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "90%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "75%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%",
                    sx: {
                        mt: 1,
                        mb: 3
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 16 modules
var contracts_lib_esm = __webpack_require__(69739);
;// CONCATENATED MODULE: ./src/core/web3/abis/ItemRegistererV3.json
var ItemRegistererV3_namespaceObject = JSON.parse('{"Mt":[{"inputs":[{"internalType":"contract MinimalForwarder","name":"forwarder","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"getChainID","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"invoker","type":"address"},{"internalType":"string","name":"itemId","type":"string"}],"name":"getTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isRegisteredCreator","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"forwarder","type":"address"}],"name":"isTrustedForwarder","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"itemVouchers","outputs":[{"internalType":"string","name":"artistId","type":"string"},{"internalType":"string","name":"itemId","type":"string"},{"internalType":"string","name":"tokenURI","type":"string"},{"internalType":"bytes","name":"signatureByCreator","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"artistId","type":"string"},{"internalType":"address","name":"creatorAddress","type":"address"}],"name":"registerCreatorAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"components":[{"internalType":"string","name":"artistId","type":"string"},{"internalType":"string","name":"itemId","type":"string"},{"internalType":"string","name":"tokenURI","type":"string"},{"internalType":"bytes","name":"signatureByCreator","type":"bytes"}],"internalType":"struct ItemVoucher","name":"voucher","type":"tuple"}],"name":"registerItemVoucherByCreator","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"}]}');
;// CONCATENATED MODULE: ./src/core/web3/index.tsx











var createNftItem = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var itemId, artistId, tokenURI, provider, signer, accounts, contract, minter, voucher, data, forwarder, request, toSign, signature, metaTxRes, metaTxResObj, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    itemId = param.itemId, artistId = param.artistId, tokenURI = param.tokenURI;
                    return [
                        4,
                        connectMetamaskClient()
                    ];
                case 1:
                    _state.sent();
                    provider = new web3_provider/* Web3Provider */.Q(window.ethereum);
                    signer = provider.getSigner();
                    return [
                        4,
                        provider.send("eth_requestAccounts", [])
                    ];
                case 2:
                    accounts = _state.sent();
                    contract = new contracts_lib_esm/* Contract */.CH(config_config/* config.nft.contractAddress.ItemRegisterer */.v.nft.contractAddress.ItemRegisterer, ItemRegistererV3_namespaceObject.Mt, signer);
                    minter = new LazyMinter({
                        contract: contract,
                        signer: signer
                    });
                    return [
                        4,
                        minter.createVoucher({
                            itemId: itemId,
                            artistId: artistId,
                            tokenURI: tokenURI
                        })
                    ];
                case 3:
                    voucher = _state.sent();
                    data = contract.interface.encodeFunctionData("registerItemVoucherByCreator", [
                        {
                            artistId: artistId,
                            itemId: itemId,
                            tokenURI: tokenURI,
                            signatureByCreator: voucher.signature
                        }
                    ]);
                    forwarder = createInstance(provider);
                    return [
                        4,
                        buildRequest(forwarder, {
                            to: config_config/* config.nft.contractAddress.ItemRegisterer */.v.nft.contractAddress.ItemRegisterer,
                            from: accounts[0],
                            data: data
                        })
                    ];
                case 4:
                    request = _state.sent();
                    return [
                        4,
                        buildTypedData(forwarder, request)
                    ];
                case 5:
                    toSign = _state.sent();
                    return [
                        4,
                        signer.provider.send("eth_signTypedData_v4", [
                            accounts[0],
                            JSON.stringify(toSign)
                        ])
                    ];
                case 6:
                    signature = _state.sent();
                    return [
                        4,
                        fetch(config_config/* config.nft.metaTransactionEndpoint */.v.nft.metaTransactionEndpoint, {
                            method: "POST",
                            body: JSON.stringify({
                                signature: signature,
                                request: request
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 7:
                    metaTxRes = _state.sent();
                    return [
                        4,
                        metaTxRes.json()
                    ];
                case 8:
                    metaTxResObj = _state.sent();
                    /**
   * ブロックチェーン側でエラーが発生した時、200番でstatus: 'error'で返ってくるためハンドリング
   */ if (metaTxResObj.status === "error") {
                        e = new Error(i18next/* default.t */.ZP.t("metaTransactionError", {
                            ns: "wallet"
                        }));
                        (0,core_errors/* captureError */.O)(e, "metaTransaction");
                        throw e;
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function createNftItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var EIP712Domain = [
    {
        name: "name",
        type: "string"
    },
    {
        name: "version",
        type: "string"
    },
    {
        name: "chainId",
        type: "uint256"
    },
    {
        name: "verifyingContract",
        type: "address"
    }, 
];
var ForwardRequest = [
    {
        name: "from",
        type: "address"
    },
    {
        name: "to",
        type: "address"
    },
    {
        name: "value",
        type: "uint256"
    },
    {
        name: "gas",
        type: "uint256"
    },
    {
        name: "nonce",
        type: "uint256"
    },
    {
        name: "data",
        type: "bytes"
    }, 
];
function getMetaTxTypeData(chainId, verifyingContract) {
    return {
        types: {
            EIP712Domain: EIP712Domain,
            ForwardRequest: ForwardRequest
        },
        domain: {
            name: "MinimalForwarder",
            version: "0.0.1",
            chainId: chainId,
            verifyingContract: verifyingContract
        },
        primaryType: "ForwardRequest"
    };
}
function buildTypedData(forwarder, request) {
    return _buildTypedData.apply(this, arguments);
}
function _buildTypedData() {
    _buildTypedData = (0,src_async_to_generator/* default */.Z)(function(forwarder, request) {
        var chainId, typeData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        forwarder.provider.getNetwork().then(function(n) {
                            return n.chainId;
                        })
                    ];
                case 1:
                    chainId = _state.sent();
                    typeData = getMetaTxTypeData(chainId, forwarder.address);
                    return [
                        2,
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, typeData), {
                            message: request
                        })
                    ];
            }
        });
    });
    return _buildTypedData.apply(this, arguments);
}
function buildRequest(forwarder, input) {
    return _buildRequest.apply(this, arguments);
}
function _buildRequest() {
    _buildRequest = (0,src_async_to_generator/* default */.Z)(function(forwarder, input) {
        var nonce;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        forwarder.getNonce(input.from).then(function(nonce) {
                            return nonce.toString();
                        })
                    ];
                case 1:
                    nonce = _state.sent();
                    return [
                        2,
                        (0,src_object_spread/* default */.Z)({
                            value: 0,
                            gas: 1e6,
                            nonce: nonce
                        }, input)
                    ];
            }
        });
    });
    return _buildRequest.apply(this, arguments);
}
var forwarderAbi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "from",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "gas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }, 
                ],
                internalType: "struct MinimalForwarder.ForwardRequest",
                name: "req",
                type: "tuple"
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes"
            }, 
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            }, 
        ],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            }
        ],
        name: "getNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "from",
                        type: "address"
                    },
                    {
                        internalType: "address",
                        name: "to",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "gas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes"
                    }, 
                ],
                internalType: "struct MinimalForwarder.ForwardRequest",
                name: "req",
                type: "tuple"
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes"
            }, 
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    }, 
];
function createInstance(provider) {
    return new contracts_lib_esm/* Contract */.CH(config_config/* config.nft.contractAddress.forwarderAddress */.v.nft.contractAddress.forwarderAddress, forwarderAbi, provider);
}
var LazyMinter = /*#__PURE__*/ function() {
    "use strict";
    function LazyMinter(param) {
        var contract = param.contract, signer = param.signer;
        (0,_class_call_check/* default */.Z)(this, LazyMinter);
        this.SIGNING_DOMAIN_NAME = "Utoniq Digital Item";
        this.SIGNING_DOMAIN_VERSION = "1";
        this._domain = null;
        this.contract = contract;
        this.signer = signer;
    }
    var _proto = LazyMinter.prototype;
    /**
   * Creates a new NFTVoucher object and signs it using this LazyMinter's signing key.
   *
   * @param {ethers.BigNumber | number} tokenId the id of the un-minted NFT
   * @param {string} uri the metadata URI to associate with this NFT
   * @param {ethers.BigNumber | number} minPrice the minimum price (in wei) that the creator will accept to redeem this NFT. defaults to zero
   *
   * @returns {NFTVoucher}
   */ _proto.createVoucher = function createVoucher(voucher) {
        var minPrice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(function() {
            var domain, signature;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this._signingDomain()
                        ];
                    case 1:
                        domain = _state.sent();
                        return [
                            4,
                            _this.signer._signTypedData(domain, {
                                ItemVoucher: [
                                    {
                                        name: "itemId",
                                        type: "string"
                                    },
                                    {
                                        name: "artistId",
                                        type: "string"
                                    },
                                    {
                                        name: "tokenURI",
                                        type: "string"
                                    }
                                ]
                            }, voucher)
                        ];
                    case 2:
                        signature = _state.sent();
                        return [
                            2,
                            (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, voucher), {
                                signature: signature
                            })
                        ];
                }
            });
        })();
    };
    /**
   * @private
   * @returns {object} the EIP-721 signing domain, tied to the chainId of the signer
   */ _proto._signingDomain = function _signingDomain() {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(function() {
            var chainId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this._domain != null) {
                            return [
                                2,
                                _this._domain
                            ];
                        }
                        return [
                            4,
                            _this.contract.getChainID()
                        ];
                    case 1:
                        chainId = _state.sent().toBigInt();
                        _this._domain = {
                            name: _this.SIGNING_DOMAIN_NAME,
                            version: _this.SIGNING_DOMAIN_VERSION,
                            verifyingContract: _this.contract.address,
                            chainId: chainId
                        };
                        return [
                            2,
                            _this._domain
                        ];
                }
            });
        })();
    };
    return LazyMinter;
}();

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/viewModel.ts




function ConsoleCollectionDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCollectionDetail($id: ID!, $pageInput: PageInput) {\n    artist {\n      id\n      cryptoWallet {\n        address\n      }\n    }\n    collection(id: $id) {\n      ...ConsoleCollectionDetail\n      collectionItems(pageInput: $pageInput) {\n        ...ConsoleCollectionItemsConnection\n      }\n      userCollection {\n        id\n        ownedItems {\n          itemId\n          ownedCount\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleCollectionDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleCollectionDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCollectionItemsNotInCollection(\n    $filters: ArtistItemsFilterInput\n    $pageInput: PageInput\n    $isNft: Boolean\n  ) {\n    artistItemsNotInCollection(\n      filters: $filters\n      pageInput: $pageInput\n      isNft: $isNft\n    ) {\n      ...ConsoleItemsConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleCollectionDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleCollectionDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddItemToCollection($collectionId: ID!, $itemId: ID!) {\n    addItemToCollection(collectionId: $collectionId, itemId: $itemId) {\n      ...ConsoleCollectionItemDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollectionDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleCollectionDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveItemFromCollection($collectionId: ID!, $itemId: ID!) {\n    removeItemFromCollection(collectionId: $collectionId, itemId: $itemId) {\n      ...ConsoleCollectionItemDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollectionDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConsoleCollectionDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveCollection($id: ID!) {\n    removeCollection(id: $id) {\n      id\n    }\n  }\n"
    ]);
    ConsoleCollectionDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var ConsoleCollectionDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref10 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref10.showMessage, showError = ref10.showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionDetail").t;
    var ref11 = (0,router_useRouter/* useRouter */.tv)(), router = ref11.router, routerPages = ref11.routerPages;
    var collectionId = router.query.collectionId;
    var ref12 = (0,react.useState)(false), walletConnecting = ref12[0], setWalletConnecting = ref12[1];
    var ref13 = (0,react.useState)(false), nftIssuing = ref13[0], setNftIssuing = ref13[1];
    var artistAuthorizeWalletBySignatureMessage = useMetamask().artistAuthorizeWalletBySignatureMessage;
    var ref14 = (0,useQuery/* useQuery */.aM)(ConsoleCollectionDetail_viewModel_QUERY, {
        variables: {
            id: collectionId
        }
    }), loading = ref14.loading, data = ref14.data, networkStatus = ref14.networkStatus, fetchMore = ref14.fetchMore, refetch = ref14.refetch;
    var walletAddress = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.cryptoWallet;
    var isNft = !!(data === null || data === void 0 ? void 0 : (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : ref1.nft);
    var web3authWalletLoading = useWeb3authWalletConnect({
        loading: loading,
        walletAddress: walletAddress === null || walletAddress === void 0 ? void 0 : walletAddress.address,
        isArtist: true,
        refetch: refetch
    }).web3authWalletLoading;
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ARTIST_ITEMS_NOT_IN_COLLECTION, {
        variables: {
            isNft: isNft
        },
        notifyOnNetworkStatusChange: true
    }), 2), getConsoleItems = ref15[0], ref16 = ref15[1], consoleItems = ref16.data, gettingConsoleItems = ref16.loading, fetchMoreConsoleItems = ref16.fetchMore, refetchItems = ref16.refetch;
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ADD_ITEM_TO_COLLECTION), 2), addItemToCollection = ref17[0], ref18 = ref17[1], addingItem = ref18.loading;
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REMOVE_ITEM_FROM_COLLECTION), 2), removeItemFromCollection = ref19[0], ref20 = ref19[1], removingItem = ref20.loading;
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REMOVE_COLLECTION, {
        onCompleted: function onCompleted() {
            showMessage(t("deletedTheCollection"), "success");
            router.goBack(routerPages.ConsoleCollections);
        }
    }), 2), removeCollection = ref21[0], ref22 = ref21[1], removingCollection = ref22.loading;
    // アイテム編集処理
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* PublishItem */.y6d), 1), publishItem = ref23[0];
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnpublishItem */.P1N), 1), unpublishItem = ref24[0];
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* StartSellingItem */.zK4), 1), startSellingItem = ref25[0];
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* StopSellingItem */.s4v), 1), stopSellingItem = ref26[0];
    var ref27, ref28, ref29;
    return {
        state: {
            artistId: (ref27 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref27 !== void 0 ? ref27 : "",
            collectionId: collectionId,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || web3authWalletLoading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref2 = data.collection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collectionItems) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage),
            collection: (ref28 = data === null || data === void 0 ? void 0 : data.collection) !== null && ref28 !== void 0 ? ref28 : null,
            removingItem: removingItem,
            removingCollection: removingCollection,
            itemSelectProps: {
                loading: gettingConsoleItems,
                addingItem: addingItem,
                hasNextPage: !!(consoleItems === null || consoleItems === void 0 ? void 0 : (ref5 = consoleItems.artistItemsNotInCollection) === null || ref5 === void 0 ? void 0 : ref5.pageInfo.hasNextPage),
                items: (ref29 = consoleItems === null || consoleItems === void 0 ? void 0 : consoleItems.artistItemsNotInCollection) !== null && ref29 !== void 0 ? ref29 : null
            },
            isNft: isNft,
            walletConnecting: walletConnecting,
            nftIssuing: nftIssuing,
            nft: data === null || data === void 0 ? void 0 : (ref6 = data.collection) === null || ref6 === void 0 ? void 0 : ref6.nft,
            artistWalletAddress: data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.cryptoWallet) === null || ref8 === void 0 ? void 0 : ref8.address,
            event: data === null || data === void 0 ? void 0 : (ref9 = data.collection) === null || ref9 === void 0 ? void 0 : ref9.event
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: collectionId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.collectionItems) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemove: function onRemove() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    removeCollection({
                                        variables: {
                                            id: collectionId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSearchItems: function onSearchItems() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getConsoleItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectItems: function onSelectItems(itemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setNftIssuing(true);
                        return [
                            2,
                            addItemToCollection({
                                variables: {
                                    collectionId: collectionId,
                                    itemId: itemId
                                }
                            }).then(function() {
                                refetch();
                                refetchItems && refetchItems();
                                if (!isNft) return;
                                var ref;
                                return createNftItem({
                                    itemId: itemId !== null && itemId !== void 0 ? itemId : "",
                                    artistId: (ref = user === null || user === void 0 ? void 0 : user.uid) !== null && ref !== void 0 ? ref : "",
                                    tokenURI: "".concat(config_config/* config.nft.tokenURIPrefix */.v.nft.tokenURIPrefix, "UtoniqDigitalItem/items/").concat(itemId, "/metadata.json")
                                }).then(function() {
                                    return;
                                }).catch(function(e) {
                                    return removeItemFromCollection({
                                        variables: {
                                            collectionId: collectionId,
                                            itemId: itemId
                                        }
                                    }).then(function() {
                                        refetch();
                                        throw e;
                                    });
                                });
                            }).finally(function() {
                                return setNftIssuing(false);
                            })
                        ];
                    });
                })();
            },
            onFetchMoreItems: function onFetchMoreItems() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!fetchMoreConsoleItems) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getConsoleItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMoreConsoleItems({
                                        variables: {
                                            pageInput: {
                                                cursor: consoleItems === null || consoleItems === void 0 ? void 0 : (ref = consoleItems.artistItemsNotInCollection) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            },
                                            isNft: isNft
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onConnectMetamask: function onConnectMetamask() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setWalletConnecting(true);
                        if (walletAddress) {
                            return [
                                2,
                                connectMetamaskClient().catch(function(e) {
                                    return showError(e);
                                }).finally(function() {
                                    setWalletConnecting(false);
                                })
                            ];
                        }
                        return [
                            2,
                            artistAuthorizeWalletBySignatureMessage().then(function() {
                                return refetch();
                            }).catch(function(e) {
                                return showError(e);
                            }).finally(function() {
                                setWalletConnecting(false);
                            })
                        ];
                    });
                })();
            },
            onConnectWeb3auth: function onConnectWeb3auth() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var idToken;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setWalletConnecting(true);
                                if (!walletAddress) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0,auth/* getAccessToken */.hP)({
                                        forceUpdateToken: true
                                    })
                                ];
                            case 1:
                                idToken = _state.sent();
                                if (!idToken) throw new Error("get jwtToke failed");
                                return [
                                    2,
                                    Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                        return m.connectToWeb3Auth(idToken);
                                    }).catch(function(e) {
                                        return showError(e);
                                    }).finally(function() {
                                        setWalletConnecting(false);
                                    })
                                ];
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onToggleSelling: function onToggleSelling(id, isSelling) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isSelling) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    stopSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                stopSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    startSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                startSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Active */.Qsp.Active,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onToggleActive: function onToggleActive(id, isActive) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isActive) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unpublishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                unpublishItem: {
                                                    id: id,
                                                    isPublished: false,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    publishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                publishItem: {
                                                    id: id,
                                                    isPublished: true,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemoveItemFromCollection: function onRemoveItemFromCollection(itemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    removeItemFromCollection({
                                        variables: {
                                            collectionId: collectionId,
                                            itemId: itemId
                                        }
                                    }).then(function() {
                                        showMessage(t("deletedItemFromCollectionSuccess"), "success");
                                    }).catch(function(error) {
                                        return showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleCollectionDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCollectionDetail_viewModel_templateObject(), utoniq_core_schema/* ConsoleCollectionDetailFragmentDoc */.iT3, utoniq_core_schema/* ConsoleCollectionItemsConnectionFragmentDoc */.WCQ);
var ARTIST_ITEMS_NOT_IN_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionDetail_viewModel_templateObject1(), utoniq_core_schema/* ConsoleItemsConnectionFragmentDoc */.p6K, utoniq_core_schema/* ItemSelectBoxFragmentDoc */.S9I, utoniq_core_schema/* ResourceFragmentDoc */.Mpo);
var ADD_ITEM_TO_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionDetail_viewModel_templateObject2(), utoniq_core_schema/* ConsoleCollectionItemDetailFragmentDoc */.YGw);
var REMOVE_ITEM_FROM_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionDetail_viewModel_templateObject3(), utoniq_core_schema/* ConsoleCollectionItemDetailFragmentDoc */.YGw);
var REMOVE_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionDetail_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionDetail/index.tsx




/**
 * ConsoleCollectionDetail Page
 * Implemented as a practical sample.
 */ var ConsoleCollectionDetail = function() {
    var ref = ConsoleCollectionDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/NftCreateModal/index.tsx





var CreateNftStatus;
(function(CreateNftStatus) {
    CreateNftStatus[CreateNftStatus["Error"] = -1] = "Error";
    CreateNftStatus[CreateNftStatus["Creating"] = 0] = "Creating";
    CreateNftStatus[CreateNftStatus["Completed"] = 1] = "Completed";
})(CreateNftStatus || (CreateNftStatus = {}));
var NftCreateModal = function(param) {
    var open = param.open, onClose = param.onClose, steps = param.steps, error = param.error, onRetry = param.onRetry;
    var t = useTranslation("nftCreateModal").t;
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ _jsx(Box, {
            sx: {
                width: 220,
                borderRadius: 3,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "grey.100",
                outline: "none",
                textAlign: "center",
                overflow: "hidden"
            },
            children: /*#__PURE__*/ _jsxs(Stack, {
                sx: {
                    py: 6
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        children: t("title")
                    }),
                    /*#__PURE__*/ _jsx(Stack, {
                        spacing: 4,
                        sx: {
                            pt: 4
                        },
                        children: steps.map(function(step, index) {
                            return /*#__PURE__*/ _jsx(NftCreateModal_Step, {
                                index: index + 1,
                                step: step
                            }, index);
                        })
                    }),
                    !!error && /*#__PURE__*/ _jsxs(Stack, {
                        sx: {
                            pt: 5,
                            px: 5
                        },
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "caption",
                                sx: {
                                    color: "error.main"
                                },
                                children: error
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                size: "small",
                                sx: {
                                    mt: 3,
                                    width: 144
                                },
                                onClick: onRetry,
                                children: t("retry")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "small",
                        variant: "text",
                        sx: {
                            color: "text.secondary",
                            mt: 3
                        },
                        onClick: onClose,
                        children: t("cancel")
                    })
                ]
            })
        })
    });
};
var NftCreateModal_Step = function(param) {
    var index = param.index, step = param.step;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            width: 140
        },
        children: /*#__PURE__*/ _jsxs(Stack, {
            direction: "row",
            spacing: 3,
            alignItems: "center",
            children: [
                step.status === CreateNftStatus.Error && /*#__PURE__*/ _jsx(Icons.Error, {
                    fontSize: "large",
                    sx: {
                        color: "error.main"
                    }
                }),
                step.status === CreateNftStatus.Creating && /*#__PURE__*/ _jsx(CircularProgress, {
                    size: 31,
                    sx: {
                        color: "grey.500"
                    }
                }),
                step.status === CreateNftStatus.Completed && /*#__PURE__*/ _jsx(Icons.Complete, {
                    fontSize: "large",
                    sx: {
                        color: "info.main"
                    }
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    flex: 1,
                    justifyItems: "flex-start",
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "subtitle2",
                            color: "text.secondary",
                            align: "left",
                            children: [
                                "STEP ",
                                index
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            align: "left",
                            children: step.label
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionEdit/template/CollectionEditForm.tsx













var CollectionEditForm_schema = function(o) {
    return {
        title: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.title")),
        description: o.string().max(500).label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.description")),
        startedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.startedAt")),
        endedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.endedAt")),
        thumbnailPath: o.string().label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.thumbnailPath")),
        thumbnailResource: o.object().allow(null).optional(),
        hasNft: o.boolean().allow(false).optional(),
        isPublishedFlag: o.boolean().allow(false).optional(),
        isPublishOnStore: o.boolean().allow(false).optional(),
        nft: o.object({
            salesType: o.string().label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.nft.salesType")),
            chains: o.array().items(o.object({
                id: o.string().allow("").optional(),
                chainName: o.string().allow("").optional(),
                royalty: o.number().min(0).max(20).label((0,core_form/* tLabel */.TQ)("consoleCollectionEdit.nft.royalty"))
            }))
        })
    };
};
var CollectionEditForm = function(param) {
    var artistId = param.artistId, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, collection = param.collection;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionEdit").t;
    var ref = (0,react.useState)(false), openCreateModal = ref[0], setOpenCreateModal = ref[1];
    var ref1 = (0,react.useState)(CreateNftStatus.Creating), createItemStatus = ref1[0], setCreateItemStatus = ref1[1];
    var ref2 = (0,react.useState)(CreateNftStatus.Creating), createNftStatus = ref2[0], setCreateNftStatus = ref2[1];
    var ref3 = (0,react.useState)(""), error = ref3[0], setError = ref3[1];
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,core_form/* useForm */.cI)({
        schema: CollectionEditForm_schema,
        defaultValues: CollectionEditForm_defaultValues
    }), handleSubmit = ref4.handleSubmit, errors = ref4.formState.errors, register = ref4.register, setValue = ref4.setValue, control = ref4.control, watch = ref4.watch, reset = ref4.reset;
    var watchHasNft = watch("hasNft", !!(collection === null || collection === void 0 ? void 0 : collection.nft));
    var isPublishedFlag = (collection === null || collection === void 0 ? void 0 : collection.status) === utoniq_core_schema/* CollectionStatus.Published */.NbM.Published ? true : false;
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "nft.chains"
    }).fields;
    (0,react.useEffect)(function() {
        if (collection === null || collection === void 0 ? void 0 : collection.nft) {
            return;
        }
        if (!watchHasNft) {
            setValue("nft", CollectionEditForm_defaultNft, {
                shouldValidate: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        watchHasNft,
        collection === null || collection === void 0 ? void 0 : collection.nft
    ]);
    (0,react.useEffect)(function() {
        if (collection) {
            var ref, ref1;
            var _description, ref2, _startedAt, _endedAt;
            reset((0,src_object_spread/* default */.Z)({
                title: collection.title,
                description: (_description = collection.description) !== null && _description !== void 0 ? _description : "",
                thumbnailPath: (ref2 = (ref = collection.thumbnail) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref2 !== void 0 ? ref2 : "",
                isPublishOnStore: !!collection.isPublishOnStore,
                startedAt: (_startedAt = collection.startedAt) !== null && _startedAt !== void 0 ? _startedAt : null,
                endedAt: (_endedAt = collection.endedAt) !== null && _endedAt !== void 0 ? _endedAt : null,
                isPublishedFlag: isPublishedFlag,
                thumbnailResource: ((ref1 = collection.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) ? {
                    id: "",
                    resourceName: "",
                    imageUrl: collection.thumbnail.uri,
                    imageUploadPath: collection.thumbnail.uri
                } : null
            }, buildNft(collection.nft)));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collection
    ]);
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        inputs = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                            nft: values.hasNft ? values.nft : null,
                            status: values.isPublishedFlag ? utoniq_core_schema/* CollectionStatus.Published */.NbM.Published : utoniq_core_schema/* CollectionStatus.Unpublished */.NbM.Unpublished,
                            startedAt: values.startedAt === "" ? null : values.startedAt,
                            endedAt: values.endedAt === "" ? null : values.endedAt
                        });
                        if (values.hasNft) {
                            setCreateItemStatus(CreateNftStatus.Creating);
                            setCreateNftStatus(CreateNftStatus.Creating);
                            setOpenCreateModal(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            onSubmit(inputs).then(function() {
                                setOpenCreateModal(false);
                                setCreateItemStatus(CreateNftStatus.Completed);
                                setCreateNftStatus(CreateNftStatus.Completed);
                            }).catch(function(error) {
                                setCreateItemStatus(CreateNftStatus.Error);
                                setCreateNftStatus(CreateNftStatus.Error);
                                setError(error.message);
                                if (!values.hasNft) {
                                    (0,core_form/* handleError */.S3)(error, setError, showError);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(handleOnSubmit),
            id: "collection-edit-form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "textarea",
                    textFieldProps: {
                        multiline: true,
                        rows: 2,
                        InputProps: {
                            sx: {
                                px: 4,
                                py: 3
                            }
                        }
                    },
                    error: errors === null || errors === void 0 ? void 0 : errors.title
                }, register("title"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "textarea",
                    textFieldProps: {
                        multiline: true,
                        rows: 5,
                        InputProps: {
                            sx: {
                                px: 4,
                                py: 3
                            }
                        }
                    },
                    error: errors === null || errors === void 0 ? void 0 : errors.description
                }, register("description"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionThumbnailInputCell, {
                    artistId: artistId,
                    watch: watch,
                    setValue: setValue,
                    error: errors.thumbnailPath,
                    thumbnailUploadInfo: fileUploadInfo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    content: {
                        title: t("isPublishedFlag"),
                        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("isPublishedFlagDesc")
                        })
                    }
                }, register("isPublishedFlag")), {
                    checked: watch("isPublishedFlag")
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInputDateCell, {
                    errors: errors,
                    setValue: setValue,
                    startedAt: watch("startedAt"),
                    endedAt: watch("endedAt")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell, (0,src_object_spread/* default */.Z)({
                    content: {
                        title: t("isPublishOnStore"),
                        description: t("isPublishOnStoreDesc")
                    },
                    checked: !!watch("isPublishOnStore")
                }, register("isPublishOnStore")))
            ]
        })
    });
};
function buildNft(nft) {
    var ref, ref1, ref2, ref3;
    var ref4, ref5, ref6;
    return {
        hasNft: !!nft,
        nft: {
            salesType: (ref4 = nft === null || nft === void 0 ? void 0 : nft.salesType) !== null && ref4 !== void 0 ? ref4 : utoniq_core_schema/* ItemNftSalesType.UserActivation */.PxR.UserActivation,
            chains: [
                {
                    chainName: (ref5 = nft === null || nft === void 0 ? void 0 : (ref = nft.chains) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.chainName) !== null && ref5 !== void 0 ? ref5 : "",
                    royalty: (ref6 = nft === null || nft === void 0 ? void 0 : (ref2 = nft.chains) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.royalty) !== null && ref6 !== void 0 ? ref6 : 10
                }, 
            ]
        }
    };
}
var CollectionEditForm_defaultNft = {
    salesType: utoniq_core_schema/* ItemNftSalesType.UserActivation */.PxR.UserActivation,
    chains: [
        {
            chainName: "",
            royalty: 10
        }, 
    ]
};
var CollectionEditForm_defaultValues = {
    title: "",
    thumbnailPath: "",
    description: "",
    thumbnailResource: null,
    nft: CollectionEditForm_defaultNft,
    hasNft: false,
    isPublishOnStore: false,
    startedAt: null,
    endedAt: null,
    isPublishedFlag: false
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionEdit/template/index.tsx









var ConsoleCollectionEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onDrop = param.onDrop;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionEdit").t;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCollectionEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleCollectionDetail, {
                        collectionId: (ref2 = (ref = state.collection) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "#"
                    })
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_FixedButtonCell, {
                    loading: state.updating || !!state.progress,
                    disabled: state.loading
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionEditForm, {
                    artistId: state.artistId,
                    fileUploadInfo: {
                        progress: state.progress,
                        onDrop: onDrop
                    },
                    collection: state.collection,
                    onSubmit: onSubmit
                })
            })
        ]
    });
};
var template_FixedButtonCell = function(param) {
    var loading = param.loading, disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                display: "flex",
                bgcolor: "grey.50",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                form: "collection-edit-form",
                type: "submit",
                size: "large",
                loading: loading,
                disabled: disabled || loading,
                sx: {
                    width: 244
                },
                children: t("save")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionEdit/viewModel.ts




function ConsoleCollectionEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCollectionEdit($id: ID!) {\n    collection(id: $id) {\n      ...CollectionsSelectBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollectionEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleCollectionEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateCollection($input: UpdateCollectionInput) {\n    updateCollection(inputs: $input) {\n      ...CollectionsSelectBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollectionEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var ConsoleCollectionEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollectionEdit").t;
    var getImage = camera/* getImage */.g;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref2.upload, progress = ref2.progress;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleCollectionEdit_viewModel_QUERY, {
        variables: {
            id: router.query.collectionId
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_COLLECTION, {
        onCompleted: function onCompleted() {
            showMessage(t("editCollectionSuccessful"), "success");
            router.goBack(generatePath(routerPages.ConsoleCollectionDetail, {
                collectionId: router.query.collectionId
            }));
        }
    }), 2), updateCollection = ref4[0], ref5 = ref4[1], updating = ref5.loading;
    var onDrop = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function onDrop() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6, ref7;
    return {
        state: {
            artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
            progress: progress,
            loading: loading,
            updating: updating,
            collection: (ref7 = data === null || data === void 0 ? void 0 : data.collection) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var title = param.title, description = param.description, thumbnailPath = param.thumbnailPath, isPublishOnStore = param.isPublishOnStore, startedAt = param.startedAt, endedAt = param.endedAt, status = param.status;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateCollection({
                                        variables: {
                                            input: {
                                                id: router.query.collectionId,
                                                title: title,
                                                description: description,
                                                thumbnailPath: thumbnailPath,
                                                isPublishOnStore: isPublishOnStore,
                                                startedAt: startedAt,
                                                endedAt: endedAt,
                                                status: status
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onDrop().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleCollectionEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCollectionEdit_viewModel_templateObject(), utoniq_core_schema/* CollectionsSelectBoxFragmentDoc */.eFx);
var UPDATE_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollectionEdit_viewModel_templateObject1(), utoniq_core_schema/* CollectionsSelectBoxFragmentDoc */.eFx);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollectionEdit/index.tsx




/**
 * ConsoleCollectionEdit Page
 * Implemented as a practical sample.
 */ var ConsoleCollectionEdit = function() {
    var ref = ConsoleCollectionEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/CollectionSelectBox/index.tsx


















var CollectionSelectBox = function(param) {
    var collection = param.collection;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollections").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref1[0], copy = ref1[1];
    var ref2;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,lib_url/* generateFullPath */.QP)(routerPages.CollectionDetail, {
        collectionId: (ref2 = collection === null || collection === void 0 ? void 0 : collection.id) !== null && ref2 !== void 0 ? ref2 : "#"
    })).onClick;
    var _mediumUri, ref3;
    var thumbnailUri = (ref3 = (_mediumUri = collection.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : collection.thumbnail.uri) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4 = (0,react.useState)(null), anchorEl = ref4[0], setAnchorEl = ref4[1];
    var options = [
        {
            label: t("openStoreLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick1() {
                onClick();
                setAnchorEl(null);
            }
        },
        {
            label: t("copyURLLabel"),
            onClick: function onClick1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(routerPages.CollectionDetail, {
                                        collectionId: collection === null || collection === void 0 ? void 0 : collection.id
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var _formattedStartedAt, _formattedEndedAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 0,
            bgcolor: "unset",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: 120,
                                    height: "100%",
                                    borderRadius: 2
                                },
                                variant: "square",
                                src: thumbnailUri
                            }),
                            config_config/* config.modules.nft */.v.modules.nft && collection.nft && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    bottom: 4,
                                    right: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                                    fontSize: "medium",
                                    filledColor: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        sx: {
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPublishedLabel, {
                                    status: collection.status,
                                    formattedStartedAt: (_formattedStartedAt = collection.formattedStartedAt) !== null && _formattedStartedAt !== void 0 ? _formattedStartedAt : "",
                                    formattedEndedAt: (_formattedEndedAt = collection.formattedEndedAt) !== null && _formattedEndedAt !== void 0 ? _formattedEndedAt : ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                children: collection.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: t("createdAt", {
                                            createdAt: collection.formattedCreatedAt
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: t("numberRegisteredItems", {
                                            itemCount: collection.itemCount
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                size: "xSmall",
                                bgcolor: "grey.100",
                                color: "grey.700",
                                onClick: handleClick,
                                sx: {
                                    position: "relative",
                                    zIndex: 2,
                                    transform: "rotate(90deg)"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                anchorEl: anchorEl,
                                open: Boolean(anchorEl),
                                onClose: handleClose,
                                children: options.map(function(_param) /*#__PURE__*/ {
                                    var icon = _param.icon, label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                                        "icon",
                                        "label"
                                    ]);
                                    return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                                        sx: {
                                            width: 200
                                        },
                                        key: label,
                                        children: [
                                            icon,
                                            label
                                        ]
                                    }));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1
                },
                href: generatePath(routerPages.ConsoleCollectionDetail, {
                    collectionId: collection.id
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/CollectionSelectBoxSkeleton/index.tsx



var CollectionSelectBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 0,
            bgcolor: "unset"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            flex: 1,
            direction: "row",
            spacing: 4,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    sx: {
                        height: 90,
                        width: 120
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "medium",
                            width: "75%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "50%"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollections/template/index.tsx













var ConsoleCollectionsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onSort = param.onSort;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollections").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref2.routerNames, routerPages = ref2.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleCollections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleDashboard,
                    title: t("title")
                },
                children: [
                    (state.loading || !!((ref = state.collections) === null || ref === void 0 ? void 0 : ref.edges.length)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCell, {
                        onSort: onSort,
                        sort: state.sort
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            pb: 5,
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: (ref1 = state.collections) === null || ref1 === void 0 ? void 0 : ref1.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSelectBox, {
                                    collection: node
                                }, node.id);
                            }),
                            componentProps: {
                                spacing: 6
                            },
                            loading: state.loading || state.refetching,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: onFetchMore,
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 6,
                                children: Array.from(Array(4).keys()).map(function(index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSelectBoxSkeleton, {}, index);
                                })
                            }),
                            emptyMessage: t("emptyMessage")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollections_template_BaseCell, {})
                ]
            })
        ]
    });
};
var ConsoleCollections_template_BaseCell = function() {
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                position: "fixed",
                bottom: 16,
                zIndex: 100,
                maxWidth: 600,
                margin: "0 auto",
                px: 4,
                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "medium",
                color: "primary",
                href: routerPages.ConsoleCollectionCreate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                })
            })
        })
    });
};
var FilterCell = function(param) {
    var onSort = param.onSort, sort = param.sort;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleCollections").t;
    var filterOptions = [
        {
            value: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc,
            label: t("newestOrder")
        },
        {
            value: utoniq_core_schema/* OrderBy.Asc */.d$J.Asc,
            label: t("oldestOrder")
        }, 
    ];
    // sort と filterOptions の value を比較して、一致するインデックスを取得
    var initialSelectedIndex = sort ? filterOptions.findIndex(function(option) {
        return option.value === sort;
    }) : 0;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,react.useState)(filterOptions[initialSelectedIndex]), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var open = Boolean(anchorEl);
    var handleClickListItem = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function(_, option) {
        setSelectedOption(option);
        if (option.value !== selectedOption.value) {
            onSort(option.value);
        }
        setAnchorEl(null);
    };
    (0,react.useEffect)(function() {
        var UrlParams = "?sort=".concat(selectedOption.value);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedOption
    ]);
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                spacing: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        mr: -2
                    },
                    onClick: handleClickListItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                mr: 2
                            },
                            children: selectedOption.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: filterOptions.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        selected: option.value === selectedOption.value,
                        onClick: function(event) {
                            return handleMenuItemClick(event, option);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: option.label
                        })
                    }, option.value);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollections/viewModel.ts



function ConsoleCollections_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleCollections($pageInput: PageInputDate, $orderBy: OrderBy) {\n    artistCollections(pageInput: $pageInput, orderBy: $orderBy) {\n      ...ArtistCollectionsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollections_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleCollections_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewConsoleCollections(\n    $pageInput: PageInputDate\n    $orderBy: OrderBy\n  ) {\n    artistCollections(pageInput: $pageInput, orderBy: $orderBy) {\n      ...ArtistCollectionsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleCollections_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ConsoleCollections_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort") === utoniq_core_schema/* OrderBy.Asc */.d$J.Asc ? utoniq_core_schema/* OrderBy.Asc */.d$J.Asc : utoniq_core_schema/* OrderBy.Desc */.d$J.Desc;
    var isFirstLoadRef = useGetNewestData({
        query: viewModel_FETCH_NEW_COLLECTION,
        variables: {
            orderBy: sort
        },
        fields: [
            {
                fragmentName: "CollectionsSelectBox",
                fieldName: "artistCollections",
                fragment: utoniq_core_schema/* CollectionsSelectBoxFragmentDoc */.eFx
            }, 
        ]
    }).isFirstLoadRef;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleCollections_viewModel_QUERY, {
        variables: {
            orderBy: sort
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore, refetch = ref1.refetch, networkStatus = ref1.networkStatus;
    var isNextFetch = !!data;
    var ref2, ref3;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            loading: loading && !isNextFetch,
            refetching: loading || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            collections: (ref3 = data === null || data === void 0 ? void 0 : data.artistCollections) !== null && ref3 !== void 0 ? ref3 : null,
            sort: sort
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.artistCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSort: function onSort(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        orderBy: value
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleCollections_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCollections_viewModel_templateObject(), utoniq_core_schema/* ArtistCollectionsConnectionFragmentDoc */.q_s);
var viewModel_FETCH_NEW_COLLECTION = (0,lib/* gql */.Ps)(ConsoleCollections_viewModel_templateObject1(), utoniq_core_schema/* ArtistCollectionsConnectionFragmentDoc */.q_s);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCollections/index.tsx




/**
 * ConsoleCollections Page
 * Implemented as a practical sample.
 */ var ConsoleCollections = function() {
    var ref = ConsoleCollections_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCollectionsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@metamask/jazzicon/index.js
var jazzicon = __webpack_require__(26538);
var jazzicon_default = /*#__PURE__*/__webpack_require__.n(jazzicon);
;// CONCATENATED MODULE: ./src/components/organisms/nft/MetamaskAccountIcon/index.tsx



/**
 * @description
 * metamask icon generate by crypto wallet address
 *
 * ref: https://stackoverflow.com/questions/71678374/get-metamask-profile-picture-and-name-use-web3
 */ var MetamaskAccountIcon = function(param) {
    var walletAddress = param.walletAddress;
    var avatarRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var element = avatarRef.current;
        if (element && walletAddress) {
            var addr = walletAddress.slice(2, 10);
            var seed = parseInt(addr, 16);
            var icon = jazzicon_default()(20, seed) //generates a size 20 icon
            ;
            if (element.firstChild) {
                element.removeChild(element.firstChild);
            }
            element.appendChild(icon);
        }
    }, [
        walletAddress,
        avatarRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: avatarRef
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/nft/CryptoWalletAddress/index.tsx





/**
 * @description
 * 仮想通貨ウォレットアドレス表示
 * - アドレスは中心部省略表示
 * - クリックでアドレス全文ClipBoardコピー
 */ var CryptoWalletAddress = function(param) {
    var cryptoWalletAddress = param.cryptoWalletAddress, _variant = param.variant, variant = _variant === void 0 ? "subtitle2" : _variant, _color = param.color, color = _color === void 0 ? "text.secondary" : _color;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var truncateAddress = function(address) {
        var start = address.substr(0, 8);
        var end = address.substr(-6);
        return start + "..." + end;
    };
    var iconSize = {
        subtitle1: {
            height: 16,
            width: 16
        },
        subtitle2: {
            height: 12,
            width: 12
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            onClick: function(e) {
                e.stopPropagation();
                e.preventDefault();
                navigator.clipboard.writeText(cryptoWalletAddress !== null && cryptoWalletAddress !== void 0 ? cryptoWalletAddress : "").then(function() {
                    return showMessage(t("cryptoWalletAddressCopied"), "success");
                });
            },
            /**
         * Unaffected by parent component ripple
         */ onTouchStart: function(e) {
                return e.stopPropagation();
            },
            onMouseDown: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: variant,
                    color: color,
                    children: cryptoWalletAddress && truncateAddress(cryptoWalletAddress)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Copy, {
                    sx: (0,src_object_spread/* default */.Z)({
                        alignSelf: "center",
                        ml: 1
                    }, iconSize[variant]),
                    onClick: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        navigator.clipboard.writeText(cryptoWalletAddress !== null && cryptoWalletAddress !== void 0 ? cryptoWalletAddress : "");
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/truncate.js
var truncate = __webpack_require__(36585);
var truncate_default = /*#__PURE__*/__webpack_require__.n(truncate);
;// CONCATENATED MODULE: ./src/components/organisms/nft/CryptoWalletBalance/index.tsx





/**
 * @description
 * 仮想通貨残高表示
 */ var CryptoWalletBalance = function(param) {
    var cryptoWalletBalance = param.cryptoWalletBalance, _size = param.size, size = _size === void 0 ? "large" : _size, _cryptoCurrency = param.cryptoCurrency, cryptoCurrency = _cryptoCurrency === void 0 ? "polygon" : _cryptoCurrency;
    var iconSize = {
        large: {
            width: 40,
            height: 40
        }
    };
    var TypographySxProps = {
        large: {
            fontSize: 32,
            width: 120,
            ml: 2
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, (0,src_object_spread/* default */.Z)({
                target: "common",
                src: "images/nft/".concat(cryptoCurrency, ".png")
            }, iconSize[size])),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: "text.secondary",
                align: "center",
                sx: (0,src_object_spread/* default */.Z)({
                    fontFamily: "Oswald",
                    fontWeight: "normal",
                    verticalAlign: "center"
                }, TypographySxProps[size]),
                children: cryptoWalletBalance && truncate_default()(cryptoWalletBalance, {
                    length: 8,
                    omission: ""
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCryptocurrencyWallet/template/index.tsx














var ConsoleCryptocurrencyWalletTemplate = function(param) {
    var state = param.state, connectMetamask = param.connectMetamask, _connectWeb3auth = param.connectWeb3auth, connectWeb3auth = _connectWeb3auth === void 0 ? /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2
            ];
        });
    }) : _connectWeb3auth;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), openWalletCreateConfirmModal = ref1[0], setOpenWalletCreateConfirmModal = ref1[1];
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref2.showError, showMessage = ref2.showMessage;
    var ref3 = (0,react.useState)(false), connecting = ref3[0], setConnecting = ref3[1];
    var onConnectMetamask = function() {
        setConnecting(true);
        return connectMetamask().then(function() {
            showMessage(t("connected"), "success");
        }).catch(function(e) {
            (0,core_errors/* captureError */.O)(e, "ConsoleCryptocurrencyWalletTemplate");
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpen(false);
        });
    };
    var onConnectWeb3auth = function() {
        setConnecting(true);
        return connectWeb3auth().catch(function(e) {
            (0,core_errors/* captureError */.O)(e, "ConsoleCryptocurrencyWalletTemplate");
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpen(false);
            setOpenWalletCreateConfirmModal(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId || "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                title: t("connectWallet"),
                back: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleCryptocurrencyWallet
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        py: 5
                    },
                    children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCryptocurrencyWallet_template_LoadingCell, {}) : state.cryptoWallet.walletAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletConnectCell, {
                        cryptoWallet: state.cryptoWallet
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletNotConnectedCell, {
                        onConnectWallet: function() {
                            return setOpen(true);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletConnectDrawer, {
                    open: open,
                    connecting: connecting,
                    onClose: function() {
                        return setOpen(false);
                    },
                    onConnectWallet: function(walletType) {
                        switch(walletType){
                            case "web3auth":
                                return setOpenWalletCreateConfirmModal(true);
                            case "metamask":
                                return onConnectMetamask();
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCryptoWalletConfirmModal, {
                    open: openWalletCreateConfirmModal,
                    loading: connecting,
                    onClose: function() {
                        return setOpenWalletCreateConfirmModal(false);
                    },
                    onCreate: onConnectWeb3auth
                })
            ]
        })
    });
};
var WalletConnectCell = function(param) {
    var cryptoWallet = param.cryptoWallet;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            sx: {
                py: 5,
                borderRadius: 2,
                backgroundColor: "grey.50"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    sx: {
                        mb: 3
                    },
                    children: t("connectWallet")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MetamaskAccountIcon, {
                    walletAddress: cryptoWallet.walletAddress || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        mb: 1
                    },
                    children: cryptoWallet.displayName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletAddress, {
                    cryptoWalletAddress: cryptoWallet.walletAddress
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletBalance, {
                        cryptoWalletBalance: cryptoWallet.balance
                    })
                })
            ]
        })
    });
};
var WalletNotConnectedCell = function(param) {
    var onConnectWallet = param.onConnectWallet;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            sx: {
                py: 5,
                borderRadius: 2,
                backgroundColor: "grey.50"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    sx: {
                        mb: 3
                    },
                    children: t("connectWallet")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        px: 7,
                        mb: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("artistConnectWalletDescription")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: onConnectWallet,
                    sx: {
                        width: 88
                    },
                    children: t("connect")
                })
            ]
        })
    });
};
var ConsoleCryptocurrencyWallet_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                height: 200,
                width: "100%",
                bgcolor: "grey.50",
                borderRadius: 2,
                py: 5
            },
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCryptocurrencyWallet/viewModel.ts



function ConsoleCryptocurrencyWallet_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistCryptoWallet {\n    artist {\n      id\n      displayName\n      cryptoWallet {\n        address\n      }\n    }\n  }\n"
    ]);
    ConsoleCryptocurrencyWallet_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ConsoleCryptocurrencyWallet_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(""), balance = ref4[0], setBalance = ref4[1];
    var ref5 = (0,useQuery/* useQuery */.aM)(ConsoleCryptocurrencyWallet_viewModel_QUERY), data = ref5.data, loading = ref5.loading, refetch = ref5.refetch;
    var cryptoWalletAddress = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.cryptoWallet) === null || ref1 === void 0 ? void 0 : ref1.address;
    var artistAuthorizeWalletBySignatureMessage = useMetamask().artistAuthorizeWalletBySignatureMessage;
    (0,react.useEffect)(function() {
        if (!cryptoWalletAddress) return;
        var t = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var balance;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getBalance(cryptoWalletAddress)
                            ];
                        case 1:
                            balance = _state.sent();
                            setBalance(balance);
                            return [
                                2
                            ];
                    }
                });
            });
            return function t() {
                return _ref.apply(this, arguments);
            };
        }();
        t();
    }, [
        cryptoWalletAddress
    ]);
    var web3authWalletLoading = useWeb3authWalletConnect({
        loading: loading,
        walletAddress: cryptoWalletAddress,
        isArtist: true,
        refetch: refetch
    }).web3authWalletLoading;
    return {
        state: {
            loading: loading || web3authWalletLoading,
            artistId: (data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : ref2.id) || config_config/* config.artistId */.v.artistId || "",
            cryptoWallet: {
                displayName: (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.displayName) || "",
                walletAddress: cryptoWalletAddress || "",
                balance: balance
            }
        },
        actions: {
            connectMetamask: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                artistAuthorizeWalletBySignatureMessage()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            connectWeb3auth: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var idToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,auth/* getAccessToken */.hP)({
                                    forceUpdateToken: true
                                })
                            ];
                        case 1:
                            idToken = _state.sent();
                            if (!idToken) throw new Error("get jwtToke failed");
                            /**
         * web3auth <=> firebase auth連携
         */ return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.connectToWeb3Auth(idToken);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var ConsoleCryptocurrencyWallet_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleCryptocurrencyWallet_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleCryptocurrencyWallet/index.tsx




var ConsoleCryptocurrencyWallet = function() {
    var ref = ConsoleCryptocurrencyWallet_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleCryptocurrencyWalletTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/TableHead/TableHead.js
var TableHead = __webpack_require__(64626);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(3431);
// EXTERNAL MODULE: ../../node_modules/lodash/xor.js
var xor = __webpack_require__(98783);
var xor_default = /*#__PURE__*/__webpack_require__.n(xor);
;// CONCATENATED MODULE: ./src/components/organisms/delivery/DeliveryManagementTag/index.tsx





var DeliveryManagementTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDeliveryManagement").t;
    var bgcolor = (0,react.useMemo)(function() {
        switch(status){
            case utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging:
                return {
                    bgcolor: "primary.main"
                };
            case utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped:
                return {
                    bgcolor: "grey.200"
                };
            default:
                return {
                    bgcolor: ""
                };
        }
    }, [
        status
    ]).bgcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 20,
            borderRadius: "2px",
            bgcolor: bgcolor,
            py: 1,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "white",
            variant: "overline",
            children: t(status)
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDeliveryManagement/template/DeliveryManagementForm.tsx
















var DeliveryManagementForm_schema = function(o) {
    return {
        selectedId: o.array().items(o.string()).optional()
    };
};
var DeliveryManagementForm = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, deliveries = param.deliveries, onFetchMore = param.onFetchMore, onSubmit = param.onSubmit, setDisableDeliveried = param.setDisableDeliveried;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDeliveryManagement").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: DeliveryManagementForm_schema,
        defaultValues: DeliveryManagementForm_defaultValues
    }), setValue = ref.setValue, watch = ref.watch, handleSubmit = ref.handleSubmit;
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    var selectedId = watch("selectedId", []);
    (0,react.useEffect)(function() {
        setDisableDeliveried(!selectedId.length);
    }, [
        selectedId,
        setDisableDeliveried
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values.selectedId).then(function() {
                                setValue("selectedId", []);
                            }).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var headers = [
        {
            key: "itemSerial.serialNumber",
            width: 75
        },
        {
            key: "status",
            width: 72
        },
        {
            key: "item.title",
            width: 142
        },
        {
            key: "itemSerial.sku.unitName",
            width: 80
        },
        {
            key: "user.email",
            width: 140
        },
        {
            key: "deliveryInfo.fullName",
            width: 90
        },
        {
            key: "deliveryInfo.phoneNumber",
            width: 108
        },
        {
            key: "deliveryInfo.address.postalCode",
            width: 76
        },
        {
            key: "deliveryInfo.address.fullAddress",
            width: 140
        },
        {
            key: "formattedAppliedAt",
            width: 95
        },
        {
            key: "formattedShippedAt",
            width: 95
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            id: "delivery-management-form",
            onSubmit: handleOnSubmit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                sx: {
                    maxHeight: windowHeight - 192
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    defaultChecked: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "checkbox",
                                        sx: {
                                            borderBottom: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            color: "primary",
                                            indeterminate: !!(deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.length) && selectedId.length > 0 && selectedId.length < (deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.length),
                                            checked: selectedId.length > 0 && selectedId.length === (deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.length),
                                            onChange: function() {
                                                setValue("selectedId", selectedId.length === (deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.length) ? [] : (deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.map(function(param) {
                                                    var node = param.node;
                                                    return node.id;
                                                })) || []);
                                            }
                                        })
                                    }),
                                    headers.map(function(param) {
                                        var key = param.key, width = param.width;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                height: 40,
                                                p: 0,
                                                minWidth: width
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                sx: {
                                                    width: width
                                                },
                                                children: t(key)
                                            })
                                        });
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                            nodes: deliveries === null || deliveries === void 0 ? void 0 : deliveries.edges.map(function(param) {
                                var node = param.node;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "checkbox",
                                            sx: {
                                                borderBottom: "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                color: "primary",
                                                checked: selectedId.findIndex(function(id) {
                                                    return id === node.id;
                                                }) >= 0 && node.status !== utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped,
                                                disabled: node.status === utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped,
                                                onClick: function() {
                                                    return setValue("selectedId", xor_default()(selectedId, [
                                                        node.id
                                                    ]));
                                                }
                                            })
                                        }),
                                        headers.map(function(param, index) {
                                            var key = param.key, width = param.width;
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                sx: {
                                                    px: 0,
                                                    width: width,
                                                    py: 3,
                                                    borderBottom: "none"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    sx: {
                                                        width: width,
                                                        px: 2,
                                                        borderRightWidth: index + 1 === headers.length ? 0 : 1,
                                                        borderRightStyle: "solid",
                                                        borderRightColor: "grey.100"
                                                    },
                                                    children: [
                                                        key === "itemSerial.serialNumber" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SerialNumber, {
                                                            label: (ref = node.itemSerial) === null || ref === void 0 ? void 0 : ref.formattedSerialNumber
                                                        }),
                                                        key === "status" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryManagementTag, {
                                                            status: node.status
                                                        }),
                                                        key !== "status" && key !== "itemSerial.serialNumber" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.hint",
                                                            sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                            children: get_default()(node, key) || "-"
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    ]
                                }, node.id);
                            }),
                            component: TableRow/* default */.Z,
                            loading: loading,
                            hasNextPage: hasNextPage,
                            onFetchMore: onFetchMore,
                            colSpan: headers.length,
                            emptyMessage: t("deliveryManagementEmpty")
                        })
                    ]
                })
            })
        })
    });
};
var DeliveryManagementForm_defaultValues = {
    selectedId: []
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDeliveryManagement/template/index.tsx












var ConsoleDeliveryManagementTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onSubmit = param.onSubmit, onFilter = param.onFilter, onSetOpenConfirm = param.onSetOpenConfirm;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDeliveryManagement").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2 = (0,react.useState)(true), disabledDeliveried = ref2[0], setDisabledDeliveried = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleDeliveryManagement
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                customNavigation: !state.loading && !((ref = state.deliveries) === null || ref === void 0 ? void 0 : ref.edges.length) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDeliveryManagement_template_FixedButtonCell, {
                    openConfirm: state.openConfirm,
                    onSetOpenConfirm: onSetOpenConfirm,
                    loading: state.merchArtistItemShipCompleting,
                    disabled: disabledDeliveried
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderFilterCell, {
                        onFilter: onFilter
                    }),
                    !state.loading && !((ref1 = state.deliveries) === null || ref1 === void 0 ? void 0 : ref1.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body1",
                        align: "center",
                        sx: {
                            py: 6
                        },
                        color: "text.secondary",
                        children: t("deliveryManagementEmpty")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryManagementForm, {
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        deliveries: state.deliveries,
                        onFetchMore: onFetchMore,
                        onSubmit: onSubmit,
                        setDisableDeliveried: setDisabledDeliveried
                    })
                ]
            })
        ]
    });
};
var HeaderFilterCell = function(param) {
    var onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDeliveryManagement").t;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,react.useState)(0), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var options = [
        {
            label: "all",
            value: undefined
        },
        {
            label: utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped,
            value: utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
        },
        {
            label: utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
            value: utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging
        }, 
    ];
    var handleFilterClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = (0,react.useCallback)(function(event, newIndex) {
        setSelectedIndex(newIndex);
        setAnchorEl(null);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: {
                py: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("deliveryManagement")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        width: "fit-content",
                        mr: -2
                    },
                    onClick: handleFilterClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                pr: 1
                            },
                            children: t(options[selectedIndex]["label"])
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall",
                            sx: {
                                color: "grey.600"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                    anchorEl: anchorEl,
                    open: Boolean(anchorEl),
                    onClose: handleClose,
                    children: options.map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                            sx: {
                                bgcolor: "grey.50",
                                minWidth: 200
                            },
                            selected: index === selectedIndex,
                            onClick: function(event) {
                                handleMenuItemClick(event, index);
                                onFilter(option.value);
                            },
                            children: t(option.label)
                        }, index);
                    })
                })
            ]
        })
    });
};
var ConsoleDeliveryManagement_template_FixedButtonCell = function(param) {
    var loading = param.loading, disabled = param.disabled, openConfirm = param.openConfirm, onSetOpenConfirm = param.onSetOpenConfirm;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDeliveryManagement").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                display: "flex",
                bgcolor: "grey.50",
                justifyContent: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: disabled,
                    onClick: function() {
                        return onSetOpenConfirm(true);
                    },
                    sx: {
                        width: 244
                    },
                    children: t("markDelivered")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: openConfirm,
                    title: t("confirmMarkDeliveredTitle"),
                    content: t("confirmMarkDeliveredDesc"),
                    onClose: function() {
                        return onSetOpenConfirm(false);
                    },
                    cancelText: t("cancel"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        loading: loading,
                        sx: {
                            minWidth: 212
                        },
                        form: "delivery-management-form",
                        type: "submit",
                        children: t("ok")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDeliveryManagement/viewModel.ts




function ConsoleDeliveryManagement_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleDeliveryManagement(\n    $pageInput: PageInput\n    $deliveryItemsStatusFilter: [DeliveryStatus!]\n  ) {\n    artistDeliveryItems(\n      pageInput: $pageInput\n      statusFilter: $deliveryItemsStatusFilter\n    ) {\n      ...ConsoleDeliveryItemsConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleDeliveryManagement_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleDeliveryManagement_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistMerchItemShipComplete(\n    $input: ArtistMerchItemShipCompleteInput!\n  ) {\n    artistMerchItemShipComplete(inputs: $input) {\n      id\n      status\n      serialId\n    }\n  }\n"
    ]);
    ConsoleDeliveryManagement_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





/**
 *
 */ var ConsoleDeliveryManagement_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref3 = (0,react.useState)(false), openConfirm = ref3[0], setOpenConfirm = ref3[1];
    var ref4 = (0,react.useState)([
        utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
        utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
    ]), filterDeliveryStatus = ref4[0], setFilterDeliveryStatus = ref4[1];
    var ref5 = (0,useQuery/* useQuery */.aM)(ConsoleDeliveryManagement_viewModel_QUERY, {
        variables: {
            deliveryItemsStatusFilter: [
                utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
                utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped, 
            ]
        },
        notifyOnNetworkStatusChange: true,
        returnPartialData: true
    }), data = ref5.data, refetch = ref5.refetch, loading = ref5.loading, fetchMore = ref5.fetchMore;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_MERCH_ITEM_SHIP_COMPLETE), 2), artistMerchItemShipComplete = ref6[0], ref7 = ref6[1], merchArtistItemShipCompleting = ref7.loading;
    var ref8, ref9, ref10, ref11;
    return {
        state: {
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistDeliveryItems) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            loading: loading,
            merchArtistItemShipCompleting: merchArtistItemShipCompleting,
            artist: (ref8 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref8 !== void 0 ? ref8 : null,
            user: user,
            openConfirm: openConfirm,
            artistId: (ref9 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref9 !== void 0 ? ref9 : "",
            deliveries: (ref10 = data === null || data === void 0 ? void 0 : data.artistDeliveryItems) !== null && ref10 !== void 0 ? ref10 : null,
            membership: (ref11 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.products) !== null && ref11 !== void 0 ? ref11 : undefined
        },
        actions: {
            onSetOpenConfirm: setOpenConfirm,
            onFilter: function onFilter(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var deliveryItemsStatusFilter;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                deliveryItemsStatusFilter = value ? [
                                    value
                                ] : [
                                    utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
                                    utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
                                ];
                                setFilterDeliveryStatus(deliveryItemsStatusFilter);
                                return [
                                    4,
                                    refetch({
                                        deliveryItemsStatusFilter: deliveryItemsStatusFilter
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            deliveryItemsStatusFilter: filterDeliveryStatus,
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : data.artistDeliveryItems.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistMerchItemShipComplete({
                                        variables: {
                                            input: {
                                                deliveryItemIds: values
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                setOpenConfirm(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleDeliveryManagement_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleDeliveryManagement_viewModel_templateObject(), utoniq_core_schema/* ConsoleDeliveryItemsConnectionFragmentDoc */.q8P);
var ARTIST_MERCH_ITEM_SHIP_COMPLETE = (0,lib/* gql */.Ps)(ConsoleDeliveryManagement_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDeliveryManagement/index.tsx




/**
 * ConsoleDeliveryManagement Page
 * Implemented as a practical sample.
 */ var ConsoleDeliveryManagement = function() {
    var ref = ConsoleDeliveryManagement_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDeliveryManagementTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Fade/Fade.js
var Fade_Fade = __webpack_require__(17055);
;// CONCATENATED MODULE: ./src/components/organisms/digitalMembershipCard/DigitalMembershipCard/index.tsx






/**
 * @description
 * デジタル会員証カード表示コンポーネント
 */ var DigitalMembershipCard = function(param) {
    var cardDesignPath = param.cardDesignPath, textColor = param.textColor, displayAreaColor = param.displayAreaColor, displayName = param.displayName, membershipNumber = param.membershipNumber, planInterval = param.planInterval, joinDate = param.joinDate, favoriteMemberCreatedAt = param.favoriteMemberCreatedAt, _loading = param.loading, loading = _loading === void 0 ? false : _loading, displayAreaSx = param.displayAreaSx, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("digitalMembershipCard").t;
    // 共通スタイル定義
    var typographyStyles = {
        displayName: {
            color: textColor || "#FFFFFF",
            fontSize: {
                xs: "13px",
                sm: "16px"
            },
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%"
        },
        label: {
            color: textColor || "#FFFFFF",
            fontSize: {
                xs: "9px",
                sm: "14px"
            },
            whiteSpace: "nowrap",
            fontWeight: 300,
            flexShrink: 0
        },
        value: {
            color: textColor || "#FFFFFF",
            fontSize: {
                xs: "10px",
                sm: "14px"
            },
            fontWeight: 600,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1
        }
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                px: 5,
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 280,
                sx: {
                    borderRadius: 3
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade_Fade/* default */.Z, {
            in: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    border: "1px solid #e0e0e0",
                    borderRadius: 3,
                    position: "relative",
                    width: "100%",
                    aspectRatio: "856/540",
                    mx: "auto",
                    backgroundImage: "\n              linear-gradient(45deg, #f0f0f0 25%, transparent 25%),\n              linear-gradient(-45deg, #f0f0f0 25%, transparent 25%),\n              linear-gradient(45deg, transparent 75%, #f0f0f0 75%),\n              linear-gradient(-45deg, transparent 75%, #f0f0f0 75%)\n            ",
                    backgroundSize: "20px 20px",
                    backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
                    backgroundColor: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                onClick: onClick,
                children: [
                    cardDesignPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                        component: "img",
                        image: cardDesignPath,
                        sx: {
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 3
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: (0,src_object_spread/* default */.Z)({
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            width: "100%",
                            height: "32.2%",
                            backgroundColor: displayAreaColor || "transparent",
                            borderRadius: "0 0 12px 12px",
                            padding: "8px 0",
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                            minHeight: 0
                        }, displayAreaSx),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    flex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    padding: "0 12px",
                                    minHeight: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: typographyStyles.displayName,
                                    children: [
                                        displayName,
                                        " ",
                                        t("sama")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    flex: 1,
                                    display: "flex",
                                    gap: "8px",
                                    padding: "0 12px",
                                    minHeight: 0
                                },
                                children: [
                                    membershipNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            gap: 1,
                                            paddingLeft: 1,
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: typographyStyles.label,
                                                children: t("membershipNumber")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                sx: typographyStyles.value,
                                                children: membershipNumber
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            gap: 1,
                                            paddingLeft: 1,
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: typographyStyles.label,
                                                children: t("plan")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                sx: typographyStyles.value,
                                                children: planInterval ? planInterval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? t("yearly") : t("monthly") : ""
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    flex: 1,
                                    display: "flex",
                                    gap: "8px",
                                    padding: "0 12px",
                                    minHeight: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            gap: 1,
                                            paddingLeft: 1,
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: typographyStyles.label,
                                                children: t("joinDate")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                sx: typographyStyles.value,
                                                children: joinDate ? new Date(joinDate).toLocaleDateString("ja-JP") : ""
                                            })
                                        ]
                                    }),
                                    favoriteMemberCreatedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            gap: 1,
                                            paddingLeft: 1,
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: typographyStyles.label,
                                                children: t("fanHistory")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                sx: typographyStyles.value,
                                                children: favoriteMemberCreatedAt && joinDate ? function() {
                                                    var favoriteDate = dayjs_min_default()(favoriteMemberCreatedAt).startOf("day");
                                                    var now = dayjs_min_default()().startOf("day");
                                                    var days = now.diff(favoriteDate, "day");
                                                    return days >= 0 ? "".concat(days).concat(t("days")) : "";
                                                }() : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/digitalMembershipCard/DigitalMembershipCardPreview/index.tsx





var DigitalMembershipCardPreview = function(param) {
    var digitalMembershipCard = param.digitalMembershipCard, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _hideMask = param.hideMask, hideMask = _hideMask === void 0 ? false : _hideMask;
    var t = (0,core_i18n/* useTranslation */.$G)("digitalMembershipCardPreview").t;
    var smUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("sm");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            mb: 4,
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                width: "100%",
                maxWidth: 600,
                mx: "auto",
                backgroundColor: "#F5F5F5",
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                p: smUp ? 3 : 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "#9E9E9E",
                        fontSize: "13px",
                        fontWeight: 300,
                        mb: 2
                    },
                    children: t("preview")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        width: "100%",
                        mx: "auto",
                        aspectRatio: "856/540",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        px: "8px"
                    },
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: "100%",
                        sx: {
                            borderRadius: 2
                        }
                    }) : digitalMembershipCard.cardDesignPath || hideMask ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCard, {
                        cardDesignPath: digitalMembershipCard.cardDesignPath,
                        textColor: digitalMembershipCard.textColor,
                        displayAreaColor: digitalMembershipCard.displayAreaColor,
                        displayName: t("exampleDisplayName"),
                        membershipNumber: t("exampleMembershipNumber"),
                        planInterval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month,
                        joinDate: t("exampleJoinDate"),
                        favoriteMemberCreatedAt: t("exampleJoinDate"),
                        loading: loading
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            height: "auto",
                            aspectRatio: "856/540",
                            border: "2px dashed #ccc",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f9f9f9"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                color: "#999",
                                fontSize: "16px",
                                fontWeight: 500
                            },
                            children: t("notSet")
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCard/template/DisableMembershipCardModal.tsx








var DisableMembershipCardModal = function(param) {
    var open = param.open, onClose = param.onClose, onDisable = param.onDisable;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCard").t;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var handleDisable = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                return [
                    2,
                    onDisable().then(function() {
                        onClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleDigitalMembershipCardDisable");
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function handleDisable() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("disableSettingsModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("disableSettingsDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        fullWidth: true,
                        onClick: handleDisable,
                        loading: loading,
                        disabled: loading,
                        children: t("changeSettings")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        children: t("cancel")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCard/template/EnableMembershipCardWarningModal.tsx




var EnableMembershipCardWarningModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCard").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("enableSettingsWarningModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("enableSettingsWarningDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        children: t("cancel")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCard/template/index.tsx












var ConsoleDigitalMembershipCardTemplate = function(param) {
    var state = param.state, onEnableSettings = param.onEnableSettings, onDisableSettings = param.onDisableSettings;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref6.routerPages, router = ref6.router, generatePath = ref6.generatePath;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCard").t;
    var ref7 = (0,react.useState)(false), showDisableModal = ref7[0], setShowDisableModal = ref7[1];
    var ref8 = (0,react.useState)(false), showEnableWarningModal = ref8[0], setShowEnableWarningModal = ref8[1];
    var handleToggleSettings = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (state.enableDigitalMembershipCard) {
                            // 推しメンバー機能を無効化する場合は確認モーダルを表示
                            setShowDisableModal(true);
                            return [
                                2
                            ];
                        }
                        if (!((ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.digitalMembershipCard) === null || ref1 === void 0 ? void 0 : ref1.cardDesignPath)) {
                            // 基本の会員証デザインが設定されていない場合は有効化させない
                            setShowEnableWarningModal(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            onEnableSettings()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleToggleSettings() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDisableSettings = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onDisableSettings()
                        ];
                    case 1:
                        _state.sent();
                        setShowDisableModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDisableSettings() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref9, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMembership,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        flex: 1,
                                        pb: 3
                                    },
                                    children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                variant: "text",
                                                width: "60%",
                                                height: 32,
                                                sx: {
                                                    mb: 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                variant: "text",
                                                width: "80%",
                                                height: 20
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h5",
                                                children: t("settingsTitle")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    mt: 1,
                                                    pt: 1,
                                                    display: "block",
                                                    fontSize: "13px",
                                                    fontStyle: "normal",
                                                    fontWeight: 300,
                                                    lineHeight: "20px"
                                                },
                                                children: t("description")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        ml: 2,
                                        pt: 0.5
                                    },
                                    children: state.loading && !state.changingSettings ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        width: 48,
                                        height: 24,
                                        sx: {
                                            borderRadius: 12
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                        checked: state.enableDigitalMembershipCard,
                                        onChange: handleToggleSettings,
                                        color: "primary",
                                        disabled: state.changingSettings
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                borderWidth: 4,
                                borderColor: "grey.50",
                                mb: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                mb: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: {
                                        fontWeight: 600
                                    },
                                    children: t("defaultCardTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardSection, {
                                    digitalMembershipCard: {
                                        cardDesignPath: (ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.digitalMembershipCard) === null || ref1 === void 0 ? void 0 : ref1.cardDesignPath,
                                        textColor: (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.digitalMembershipCard) === null || ref3 === void 0 ? void 0 : ref3.textColor,
                                        displayAreaColor: (ref9 = (ref4 = state.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.digitalMembershipCard) === null || ref5 === void 0 ? void 0 : ref5.displayAreaColor) !== null && ref9 !== void 0 ? ref9 : undefined
                                    },
                                    loading: state.loading,
                                    onChangeDesign: function() {
                                        return router.push(routerPages.ConsoleDigitalMembershipDefaultCardDesignEdit);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                mb: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: {
                                        fontWeight: 600
                                    },
                                    children: t("favoriteMemberCardsTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        mb: 3,
                                        fontSize: "13px",
                                        fontStyle: "normal",
                                        fontWeight: 300,
                                        lineHeight: "20px"
                                    },
                                    children: t("favoriteMemberCardsDescription")
                                }),
                                state.favoriteMembers.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: state.favoriteMembers.map(function(favoriteMember) {
                                        var ref, ref1, ref2;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(DigitalMembershipCardSection, {
                                            favoriteMember: favoriteMember,
                                            digitalMembershipCard: {
                                                cardDesignPath: (ref = favoriteMember.digitalMembershipCard) === null || ref === void 0 ? void 0 : ref.cardDesignPath,
                                                textColor: (ref1 = favoriteMember.digitalMembershipCard) === null || ref1 === void 0 ? void 0 : ref1.textColor,
                                                displayAreaColor: (ref10 = (ref2 = favoriteMember.digitalMembershipCard) === null || ref2 === void 0 ? void 0 : ref2.displayAreaColor) !== null && ref10 !== void 0 ? ref10 : undefined
                                            },
                                            loading: state.loading,
                                            onChangeDesign: function() {
                                                return router.push(generatePath(routerPages.ConsoleDigitalMembershipCardDesignEdit, {
                                                    favoriteMemberId: favoriteMember.id
                                                }));
                                            }
                                        }, favoriteMember.id);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        backgroundColor: "#F7F9FA",
                                        borderRadius: "8px",
                                        px: "20px",
                                        py: "12px",
                                        mb: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                mb: 2,
                                                fontSize: "13px",
                                                fontStyle: "normal",
                                                fontWeight: 300,
                                                lineHeight: "20px"
                                            },
                                            children: t("noFavoriteMember")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            component: "a",
                                            onClick: function(e) {
                                                router.push(routerPages.ConsoleFavoriteMemberSettings);
                                            },
                                            sx: {
                                                color: "primary.main",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                                textDecoration: "none",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                "&::after": {
                                                    content: '" >"',
                                                    marginLeft: "4px"
                                                }
                                            },
                                            children: t("confirmFavoriteMember")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisableMembershipCardModal, {
                open: showDisableModal,
                onClose: function() {
                    return setShowDisableModal(false);
                },
                onDisable: handleDisableSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnableMembershipCardWarningModal, {
                open: showEnableWarningModal,
                onClose: function() {
                    return setShowEnableWarningModal(false);
                }
            })
        ]
    });
};
var DigitalMembershipCardSection = function(param) {
    var favoriteMember = param.favoriteMember, digitalMembershipCard = param.digitalMembershipCard, _loading = param.loading, loading = _loading === void 0 ? false : _loading, onChangeDesign = param.onChangeDesign;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCard").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            mb: 8
        },
        children: [
            favoriteMember && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 3
                },
                children: [
                    (favoriteMember === null || favoriteMember === void 0 ? void 0 : (ref = favoriteMember.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: favoriteMember.avatar.smallUri,
                        alt: favoriteMember.name,
                        sx: {
                            width: 40,
                            height: 40
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            fontWeight: 600
                        },
                        children: favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardPreview, {
                digitalMembershipCard: digitalMembershipCard,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "flex-start",
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    onClick: onChangeDesign,
                    disabled: loading,
                    sx: {
                        borderColor: "#E0E0E0",
                        color: "#666",
                        "&:hover": {
                            borderColor: "#BDBDBD",
                            backgroundColor: "#F5F5F5"
                        }
                    },
                    children: t("changeDesign")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCard/viewModel.ts




function ConsoleDigitalMembershipCard_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleDigitalMembershipCard {\n    artist {\n      id\n      displayName\n      digitalMembershipCard {\n        cardDesignPath\n        displayAreaColor\n        textColor\n      }\n      settings {\n        features {\n          subscription {\n            enableDigitalMembershipCard\n          }\n        }\n      }\n    }\n    artistFavoriteMembers {\n      id\n      name\n      avatar {\n        uri\n        smallUri\n      }\n      orderNumber\n      digitalMembershipCard {\n        cardDesignPath\n        displayAreaColor\n        textColor\n      }\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipCard_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleDigitalMembershipCard_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation artistUpdateModule($inputs: ArtistUpdateModuleInput!) {\n    artistUpdateModule(inputs: $inputs) {\n      id\n      displayName\n      settings {\n        features {\n          subscription {\n            enableDigitalMembershipCard\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipCard_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ConsoleDigitalMembershipCard_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, routerPages = ref4.routerPages, generatePath = ref4.generatePath;
    var ref5 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref5.showError, showMessage = ref5.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCard").t;
    var ref6 = (0,useQuery/* useQuery */.aM)(ConsoleDigitalMembershipCard_viewModel_QUERY), data = ref6.data, loading = ref6.loading, error = ref6.error, refetch = ref6.refetch;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_CHANGE_DIGITAL_MEMBERSHIP_CARD_MUTATION), 2), changeDigitalMembershipCard = ref7[0], ref8 = ref7[1], changingSettings = ref8.loading;
    var ref9, ref10, ref11, ref12;
    return {
        state: {
            user: user !== null && user !== void 0 ? user : null,
            artistId: (ref9 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref9 !== void 0 ? ref9 : "",
            loading: loading,
            error: error,
            artist: (ref10 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref10 !== void 0 ? ref10 : null,
            favoriteMembers: (ref11 = data === null || data === void 0 ? void 0 : data.artistFavoriteMembers) !== null && ref11 !== void 0 ? ref11 : [],
            enableDigitalMembershipCard: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.enableDigitalMembershipCard) !== null && ref12 !== void 0 ? ref12 : false,
            changingSettings: changingSettings
        },
        actions: {
            onEnableSettings: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                changeDigitalMembershipCard({
                                    variables: {
                                        inputs: {
                                            digitalMembershipCard: true
                                        }
                                    }
                                }).catch(function(error) {
                                    showError(error);
                                    throw error;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            showMessage(t("updateSettingsSuccess"), "success");
                            return [
                                2
                            ];
                    }
                });
            }),
            onDisableSettings: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                changeDigitalMembershipCard({
                                    variables: {
                                        inputs: {
                                            digitalMembershipCard: false
                                        }
                                    }
                                }).catch(function(error) {
                                    showError(error);
                                    throw error;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            showMessage(t("updateSettingsSuccess"), "success");
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var ConsoleDigitalMembershipCard_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipCard_viewModel_templateObject());
var ARTIST_CHANGE_DIGITAL_MEMBERSHIP_CARD_MUTATION = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipCard_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCard/index.tsx




/**
 * ConsoleDigitalMembershipCard Page
 * デジタル会員証画面
 */ var ConsoleDigitalMembershipCard = function() {
    var ref = ConsoleDigitalMembershipCard_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDigitalMembershipCardTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(53242);
// EXTERNAL MODULE: ../../node_modules/@mui/material/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(30680);
// EXTERNAL MODULE: ../../node_modules/react-color/es/index.js + 218 modules
var react_color_es = __webpack_require__(6226);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCardDesignEdit/template/MembershipCardEditForm.tsx











var MembershipCardEditForm_schema = function(o) {
    return {
        textColor: o.string().max(9).label((0,core_form/* tLabel */.TQ)("consoleDigitalMembershipCardDesignEdit.textColor")),
        displayAreaColor: o.string().max(9).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleDigitalMembershipCardDesignEdit.displayAreaColor")),
        cardDesignPath: o.string().label((0,core_form/* tLabel */.TQ)("consoleDigitalMembershipCardDesignEdit.cardDesign")),
        cardDesignResource: o.object().allow(null).optional()
    };
};
var MembershipCardEditForm = function(param) {
    var artistId = param.artistId, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, membershipCard = param.membershipCard;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCardDesignEdit").t;
    var ref = (0,react.useState)(""), error = ref[0], setError = ref[1];
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: MembershipCardEditForm_schema,
        defaultValues: MembershipCardEditForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, register = ref1.register, setValue = ref1.setValue, control = ref1.control, watch = ref1.watch, reset = ref1.reset;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        reset({
            displayAreaColor: (ref = membershipCard === null || membershipCard === void 0 ? void 0 : membershipCard.displayAreaColor) !== null && ref !== void 0 ? ref : "",
            textColor: (ref1 = membershipCard === null || membershipCard === void 0 ? void 0 : membershipCard.textColor) !== null && ref1 !== void 0 ? ref1 : "#FFFFFF",
            cardDesignPath: (ref2 = membershipCard === null || membershipCard === void 0 ? void 0 : membershipCard.cardDesignPath) !== null && ref2 !== void 0 ? ref2 : "",
            cardDesignResource: (membershipCard === null || membershipCard === void 0 ? void 0 : membershipCard.cardDesignPath) ? {
                id: "",
                resourceName: "",
                imageUrl: membershipCard.cardDesignPath,
                imageUploadPath: membershipCard.cardDesignPath
            } : null
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        membershipCard
    ]);
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        inputs = (0,src_object_spread/* default */.Z)({}, values);
                        return [
                            4,
                            onSubmit(inputs).catch(function(error) {
                                setError(error.message);
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        showError
    ]);
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(handleOnSubmit),
            id: "membership-card-edit-form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDesignInputCell, {
                    watch: watch,
                    setValue: setValue,
                    error: errors.cardDesignPath,
                    fileUploadInfo: fileUploadInfo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPickerCell, {
                        label: t("textColor"),
                        value: watch("textColor"),
                        onChange: function(color) {
                            return setValue("textColor", color);
                        },
                        error: errors === null || errors === void 0 ? void 0 : errors.textColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPickerCell, {
                        label: t("displayAreaColor"),
                        value: (ref2 = watch("displayAreaColor")) !== null && ref2 !== void 0 ? ref2 : "",
                        onChange: function(color) {
                            return setValue("displayAreaColor", color);
                        },
                        onClear: function() {
                            return setValue("displayAreaColor", "");
                        },
                        error: errors === null || errors === void 0 ? void 0 : errors.displayAreaColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 6
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardPreview, {
                            digitalMembershipCard: {
                                cardDesignPath: watch("cardDesignPath"),
                                textColor: watch("textColor"),
                                displayAreaColor: (ref3 = watch("displayAreaColor")) !== null && ref3 !== void 0 ? ref3 : ""
                            },
                            loading: isSubmitting,
                            hideMask: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "text.secondary",
                            sx: {
                                mt: 2,
                                textAlign: "center"
                            },
                            children: t("caption")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        mt: 6,
                        mb: 6
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        loading: isSubmitting,
                        type: "submit",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        disabled: !isValid || isSubmitting,
                        children: t("register")
                    })
                })
            ]
        })
    });
};
var MembershipCardEditForm_defaultValues = {
    cardDesignPath: "",
    cardDesignResource: null,
    textColor: "",
    displayAreaColor: ""
};
var ColorPickerCell = function(param) {
    var label = param.label, value = param.value, onChange = param.onChange, onClear = param.onClear, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCardDesignEdit").t;
    var ref = (0,react.useState)(false), displayColorPicker = ref[0], setDisplayColorPicker = ref[1];
    var handleClose = function() {
        setDisplayColorPicker(false);
    };
    var handleColorChange = function(color) {
        onChange(color);
    };
    var handleKeyDown = function(e) {
        if (e.key === "Enter" && displayColorPicker) {
            // カラーピッカーが開いている状態でエンターキー押下でサブミット処理が走らないようにする
            e.preventDefault();
            e.stopPropagation();
            setDisplayColorPicker(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.primary",
                            sx: {
                                mb: 1
                            },
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            fullWidth: true,
                            value: value || "",
                            placeholder: t("colorPlaceholder"),
                            slotProps: {
                                input: {
                                    readOnly: true,
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            sx: {
                                                width: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                backgroundColor: value || "#ffffff",
                                                border: "1px solid #ccc",
                                                mr: 1
                                            }
                                        })
                                    }),
                                    endAdornment: onClear && value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            sx: {
                                                backgroundColor: "#E5ECEF",
                                                borderRadius: "50%",
                                                width: 32,
                                                height: 32,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                "&:hover": {
                                                    backgroundColor: "#d0d0d0"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    onClear();
                                                },
                                                size: "small"
                                            })
                                        })
                                    }) : undefined
                                }
                            },
                            onClick: function() {
                                return setDisplayColorPicker(!displayColorPicker);
                            },
                            onKeyDown: handleKeyDown,
                            sx: {
                                cursor: "pointer",
                                "& .MuiInputBase-input": {
                                    cursor: "pointer"
                                }
                            }
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: error.message
                        })
                    ]
                }),
                displayColorPicker && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        zIndex: 2000
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            },
                            onClick: handleClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            onKeyDown: handleKeyDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_color_es/* ChromePicker */.AI, {
                                color: value || "#ffffff",
                                onChange: function(color) {
                                    return handleColorChange(color.hex);
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var CardDesignInputCell = function(param) {
    var watch = param.watch, setValue = param.setValue, fileUploadInfo = param.fileUploadInfo, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCardDesignEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                sx: {
                    p: 0,
                    width: "100%"
                },
                shape: "card",
                resource: watch("cardDesignResource"),
                t: t,
                fileUploadInfo: {
                    type: "image",
                    onDrop: function onDrop() {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            var resource;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            fileUploadInfo.onDrop()
                                        ];
                                    case 1:
                                        resource = _state.sent();
                                        if (!resource) {
                                            return [
                                                2
                                            ];
                                        }
                                        setValue("cardDesignPath", resource.imageUrl, {
                                            shouldValidate: true
                                        });
                                        setValue("cardDesignResource", (0,src_object_spread/* default */.Z)({}, resource), {
                                            shouldValidate: true
                                        });
                                        return [
                                            2,
                                            resource
                                        ];
                                }
                            });
                        })();
                    },
                    progress: fileUploadInfo.progress || 0,
                    description: t("cardDesignUploaderDescription"),
                    onClose: function onClose() {
                        setValue("cardDesignResource", null, {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                        setValue("cardDesignPath", "", {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                    }
                },
                content: {
                    title: t("cardDesign")
                }
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCardDesignEdit/template/index.tsx






var ConsoleDigitalMembershipCardDesignEditTemplate = function(param) {
    var _state = param.state, artistId = _state.artistId, membershipCard = _state.membershipCard, progress = _state.progress, onSubmit = param.onSubmit, onDrop = param.onDrop;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipCardDesignEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                title: t("title"),
                defaultBackPage: routerPages.ConsoleDigitalMembershipCard,
                back: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleDigitalMembershipDefaultCardDesignEdit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCardEditForm, {
                    artistId: artistId,
                    membershipCard: membershipCard,
                    fileUploadInfo: {
                        progress: progress,
                        onDrop: onDrop
                    },
                    onSubmit: onSubmit
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCardDesignEdit/viewModel.ts




function ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetFavoriteMemberCardDesign($inputs: ArtistFavoriteMembersInput!) {\n    artistFavoriteMembers(inputs: $inputs) {\n      id\n      name\n      digitalMembershipCard {\n        cardDesignPath\n        displayAreaColor\n        textColor\n      }\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateFavoriteMemberDigitalMembershipCard(\n    $inputs: ArtistUpdateDigitalMembershipCardInput!\n  ) {\n    artistUpdateDigitalMembershipCard(inputs: $inputs) {\n      artistFavoriteMembers {\n        id\n        name\n        orderNumber\n        digitalMembershipCard {\n          cardDesignPath\n          displayAreaColor\n          textColor\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConsoleDigitalMembershipCardDesignEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages, generatePath = ref3.generatePath;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref4.showError, showMessage = ref4.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipDefaultCardDesignEdit").t;
    var getImage = camera/* getImage */.g;
    var ref5 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref5.upload, progress = ref5.progress;
    var favoriteMemberId = router.query.favoriteMemberId;
    var ref6 = (0,useQuery/* useQuery */.aM)(ConsoleDigitalMembershipCardDesignEdit_viewModel_QUERY, {
        variables: {
            inputs: {
                favoriteMemberId: favoriteMemberId
            }
        }
    }), data = ref6.data, loading = ref6.loading, error = ref6.error;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_DIGITAL_MEMBERSHIP_CARD, {
        onCompleted: function onCompleted() {
            showMessage(t("editSuccessful"), "success");
            router.goBack(generatePath(routerPages.ConsoleDigitalMembershipCard));
        }
    }), 2), updateFavoriteMemberDigitalMembershipCard = ref7[0], ref8 = ref7[1], updating = ref8.loading;
    var onDrop = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function onDrop() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref9, ref10, ref11;
    return {
        state: {
            artistId: (ref9 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref9 !== void 0 ? ref9 : "",
            favoriteMember: (ref10 = data === null || data === void 0 ? void 0 : (ref = data.artistFavoriteMembers) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref10 !== void 0 ? ref10 : null,
            progress: progress,
            loading: loading,
            membershipCard: (ref11 = data === null || data === void 0 ? void 0 : (ref1 = data.artistFavoriteMembers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.digitalMembershipCard) !== null && ref11 !== void 0 ? ref11 : null
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var cardDesignPath = param.cardDesignPath, textColor = param.textColor, displayAreaColor = param.displayAreaColor;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateFavoriteMemberDigitalMembershipCard({
                                        variables: {
                                            inputs: {
                                                favoriteMemberId: favoriteMemberId,
                                                cardDesignPath: cardDesignPath,
                                                textColor: textColor,
                                                displayAreaColor: displayAreaColor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onDrop().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleDigitalMembershipCardDesignEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject());
var UPDATE_DIGITAL_MEMBERSHIP_CARD = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipCardDesignEdit_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipCardDesignEdit/index.tsx




/**
 * ConsoleDigitalMembershipCardDesignEdit Page
 * 会員証デザインを変更する画面
 */ var ConsoleDigitalMembershipCardDesignEdit = function() {
    var ref = ConsoleDigitalMembershipCardDesignEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDigitalMembershipCardDesignEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipDefaultCardDesignEdit/template/index.tsx






var ConsoleDigitalMembershipDefaultCardDesignEditTemplate = function(param) {
    var _state = param.state, artistId = _state.artistId, membershipCard = _state.membershipCard, progress = _state.progress, onSubmit = param.onSubmit, onDrop = param.onDrop;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipDefaultCardDesignEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                title: t("title"),
                defaultBackPage: routerPages.ConsoleDigitalMembershipCard,
                back: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleDigitalMembershipDefaultCardDesignEdit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCardEditForm, {
                    artistId: artistId,
                    membershipCard: membershipCard,
                    fileUploadInfo: {
                        progress: progress,
                        onDrop: onDrop
                    },
                    onSubmit: onSubmit
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipDefaultCardDesignEdit/viewModel.ts




function ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistDigitalMembershipCard {\n    artistDigitalMembershipCard {\n      cardDesignPath\n      displayAreaColor\n      textColor\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateDigitalMembershipCard(\n    $inputs: ArtistUpdateDigitalMembershipCardInput!\n  ) {\n    artistUpdateDigitalMembershipCard(inputs: $inputs) {\n      artist {\n        id\n        displayName\n        digitalMembershipCard {\n          cardDesignPath\n          displayAreaColor\n          textColor\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDigitalMembershipDefaultCardDesignEdit").t;
    var getImage = camera/* getImage */.g;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref2.upload, progress = ref2.progress;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_QUERY), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_DEFAULT_DIGITAL_MEMBERSHIP_CARD, {
        onCompleted: function onCompleted() {
            showMessage(t("editSuccessful"), "success");
            router.goBack(generatePath(routerPages.ConsoleDigitalMembershipCard));
        }
    }), 2), updateDefaultDigitalMembershipCard = ref4[0], ref5 = ref4[1], updating = ref5.loading;
    var onDrop = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function onDrop() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6, ref7;
    return {
        state: {
            artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
            progress: progress,
            loading: loading,
            membershipCard: (ref7 = data === null || data === void 0 ? void 0 : data.artistDigitalMembershipCard) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var cardDesignPath = param.cardDesignPath, textColor = param.textColor, displayAreaColor = param.displayAreaColor;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateDefaultDigitalMembershipCard({
                                        variables: {
                                            inputs: {
                                                cardDesignPath: cardDesignPath,
                                                textColor: textColor,
                                                displayAreaColor: displayAreaColor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop1() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onDrop().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject());
var UPDATE_DEFAULT_DIGITAL_MEMBERSHIP_CARD = (0,lib/* gql */.Ps)(ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDigitalMembershipDefaultCardDesignEdit/index.tsx




/**
 * ConsoleDigitalMembershipDefaultCardDesignEdit Page
 * 会員証デザインを変更する画面
 */ var ConsoleDigitalMembershipDefaultCardDesignEdit = function() {
    var ref = ConsoleDigitalMembershipDefaultCardDesignEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDigitalMembershipDefaultCardDesignEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomCreate/template/DmRoomCreateForm.tsx











var DmRoomCreateForm_schema = function(o) {
    return {
        title: o.string().min(1).max(30).label((0,core_form/* tLabel */.TQ)("consoleDmRoomCreate.title")),
        startedAt: o.date().custom(function(value, helpers) {
            if (!value) return value;
            var startDate = new Date(value);
            var now = new Date();
            // 未来の日付かチェック
            if (startDate <= now) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleDmRoomCreate.startedAt.custom.future")
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleDmRoomCreate.startedAt")),
        expiredAt: o.date().custom(function(value, helpers) {
            var ref;
            if (!value) return value;
            var expiredDate = new Date(value);
            var now = new Date();
            // 未来の日付かチェック
            if (expiredDate <= now) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleDmRoomCreate.expiredAt.custom.future")
                });
            }
            // startedAtより後の日付かチェック
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            var startedAt = data === null || data === void 0 ? void 0 : data.startedAt;
            if (startedAt) {
                var startDate = new Date(startedAt);
                if (expiredDate <= startDate) {
                    return helpers.message({
                        custom: (0,core_form/* tMessage */.Sd)("consoleDmRoomCreate.expiredAt.custom.over")
                    });
                }
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleDmRoomCreate.expiredAt")),
        accountIds: o.array().items(o.string().min(1).pattern(/^[a-zA-Z0-9_]*$/).label((0,core_form/* tLabel */.TQ)("consoleDmRoomCreate.accountIds")))
    };
};
var DmRoomCreateForm_defaultValues = {
    title: "",
    startedAt: "",
    expiredAt: "",
    accountIds: []
};
var DmRoomCreateForm = function(param) {
    var onSubmit = param.onSubmit;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDmRoomCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: DmRoomCreateForm_schema,
        defaultValues: DmRoomCreateForm_defaultValues
    }), register = ref1.register, setValue = ref1.setValue, watch = ref1.watch, handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, setError = ref1.setError;
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var startedAt = watch("startedAt");
    var expiredAt = watch("expiredAt");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "text"
                }, register("title")), {
                    titleProps: {
                        display: "flex",
                        alignItems: "center",
                        variant: "h5",
                        color: "text.primary"
                    },
                    error: errors === null || errors === void 0 ? void 0 : errors.title,
                    t: t
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        pb: 2,
                        children: t("usagePeriod")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                        onChange: function(date) {
                            setValue("startedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        value: startedAt ? dayjs_min_default()(startedAt) : null,
                        title: t("startedAt"),
                        placeholder: t("startedAtPlaceholder"),
                        error: errors === null || errors === void 0 ? void 0 : errors.startedAt,
                        titleProps: {
                            variant: "subtitle1",
                            color: "text.primary"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                        onChange: function(date) {
                            setValue("expiredAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        value: expiredAt ? dayjs_min_default()(expiredAt) : null,
                        title: t("expiredAt"),
                        placeholder: t("expiredAtPlaceholder"),
                        error: errors === null || errors === void 0 ? void 0 : errors.expiredAt,
                        titleProps: {
                            variant: "subtitle1",
                            color: "text.primary"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "text"
                }, register("accountIds.0")), {
                    titleProps: {
                        children: t("accountIdsTitle"),
                        display: "flex",
                        alignItems: "center",
                        variant: "h5",
                        color: "text.primary"
                    },
                    textFieldProps: {
                        placeholder: t("accountIdsPlaceholder")
                    },
                    error: errors === null || errors === void 0 ? void 0 : (ref = errors.accountIds) === null || ref === void 0 ? void 0 : ref[0],
                    t: t
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                pb: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: isSubmitting,
                    disabled: !isValid,
                    onClick: handleOnSubmit,
                    children: t("create")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomCreate/template/index.tsx









var ConsoleDmRoomCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDmRoomCreate").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleDmRooms
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                        sx: {
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h3",
                            py: 3,
                            children: t("title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomCreateForm, {
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomCreate/viewModel.ts




function ConsoleDmRoomCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistCreateDmRoom($inputs: ArtistCreateDmRoomInput!) {\n    artistCreateDmRoom(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ConsoleDmRoomCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ConsoleDmRoomCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDmRoomCreate").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_DM_ROOM, {
        onCompleted: function onCompleted() {
            showMessage(t("createSuccess"), "success");
            router.goBack(routerPages.ConsoleDmRooms);
        }
    }), 1), createDmRoom = ref1[0];
    var ref2;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : ""
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createDmRoom({
                                        variables: {
                                            inputs: values
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CREATE_DM_ROOM = (0,lib/* gql */.Ps)(ConsoleDmRoomCreate_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomCreate/index.tsx




/**
 * ConsoleDmRoomCreate Page
 * Implemented as a practical sample.
 */ var ConsoleDmRoomCreate = function() {
    var ref = ConsoleDmRoomCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDmRoomCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/reply/ReplyForm/index.tsx
var ReplyForm = __webpack_require__(44545);
;// CONCATENATED MODULE: ./src/components/organisms/dmRoom/DmRoomMessage/index.tsx





/**
 * sendUserId に合致する送信者（アーティストまたはユーザー）を取得
 */ var getSender = function(dmRoom, sendUserId) {
    var ref, ref1;
    if ((dmRoom === null || dmRoom === void 0 ? void 0 : (ref = dmRoom.artist) === null || ref === void 0 ? void 0 : ref.id) === sendUserId) {
        return dmRoom.artist;
    }
    return dmRoom === null || dmRoom === void 0 ? void 0 : (ref1 = dmRoom.users) === null || ref1 === void 0 ? void 0 : ref1.find(function(user) {
        return user.id === sendUserId;
    });
};
var DmRoomMessage = function(param) {
    var userId = param.userId, dmRoom = param.dmRoom, dmRoomMessage = param.dmRoomMessage;
    var ref, ref1, ref2;
    var sender = getSender(dmRoom, dmRoomMessage.sendUserId);
    var isSent = dmRoomMessage.sendUserId === userId;
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: isSent ? "row-reverse" : "row",
            spacing: 2,
            alignItems: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "circular",
                    sizes: "medium",
                    src: (ref3 = sender === null || sender === void 0 ? void 0 : (ref = sender.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    sx: {
                        flexGrow: 1,
                        alignItems: isSent ? "flex-end" : "flex-start",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: isSent ? "row" : "row-reverse",
                            spacing: 2,
                            alignItems: "baseline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.hint",
                                    children: values_Date/* DateTime.formatRelativeSecondAdjust */.o.formatRelativeSecondAdjust(dmRoomMessage.createdAt)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "text.secondary",
                                    sx: {
                                        fontWeight: "bold"
                                    },
                                    children: (ref4 = sender === null || sender === void 0 ? void 0 : sender.displayName) !== null && ref4 !== void 0 ? ref4 : ""
                                })
                            ]
                        }),
                        dmRoomMessage.type === utoniq_core_schema/* DmRoomMessageType.Text */.$R4.Text && /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomTextMessage, {
                            message: dmRoomMessage.message
                        }),
                        dmRoomMessage.type === utoniq_core_schema/* DmRoomMessageType.Image */.$R4.Image && /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomImageMessage, {
                            uri: (ref5 = (ref1 = dmRoomMessage.resources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) !== null && ref5 !== void 0 ? ref5 : ""
                        })
                    ]
                })
            ]
        })
    });
};
/** テキストメッセージ表示 */ var DmRoomTextMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        bgcolor: "grey.50",
        p: 2,
        borderRadius: 1,
        sx: {
            maxWidth: "60%",
            wordBreak: "break-all"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "text.secondary",
            children: message
        })
    });
};
/** 画像メッセージ表示 */ var DmRoomImageMessage = function(param) {
    var uri = param.uri;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        borderRadius: 1,
        sx: {
            maxWidth: "60%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
            component: "img",
            image: uri,
            alt: "image"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/dmRoom/DmRoomMessageSkeleton/index.tsx





var DmRoomMessageSkeleton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return [
        1,
        2,
        3
    ].map(function(key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomMessageBoxSkeleton, {}, key);
    });
};
var DmRoomMessageBoxSkeleton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        width: 28,
                                        height: 28
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "25%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 2,
                            width: "60%",
                            lastWidth: "60%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                pb: 2,
                                justifyContent: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "25%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        width: 28,
                                        height: 28
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                alignItems: "flex-end"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                numberOfLine: 2,
                                width: "60%",
                                lastWidth: "60%"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/dmRoom/DmRoomMessageList/index.tsx








/**
 * 最下部判定とスクロール動作に関する閾値定義
 */ var SCROLL_BOTTOM_THRESHOLD = 100 // 最下部判定の閾値（px）: この範囲内なら「最下部にいる」とみなす
;
var SCROLL_BOTTOM_OFFSET = 100 // 確実に最下部到達するための余剰スクロール（px）
;
var DmRoomMessageList = function(param) {
    var userId = param.userId, messages = param.messages, dmRoom = param.dmRoom, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, emptyMessage = param.emptyMessage, refObject = param.refObject;
    var messageWrapperRef = (0,react.useRef)(null);
    var messageListRef = (0,react.useRef)(null);
    var bottomAnchorRef = (0,react.useRef)(null);
    var hasScrolledRef = (0,react.useRef)(false);
    // 初回ローディング完了時のみ最下部にスクロール
    (0,react.useLayoutEffect)(function() {
        if (!loading && !hasScrolledRef.current && bottomAnchorRef.current) {
            var ref;
            bottomAnchorRef.current.scrollIntoView({
                behavior: "auto",
                block: "end"
            });
            hasScrolledRef.current = true;
            var ref1;
            // 画像読み込みによるレイアウトシフト防止処理
            var images = (ref1 = (ref = messageListRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("img")) !== null && ref1 !== void 0 ? ref1 : [];
            // 全画像の読み込みを待つ
            var imagePromises = Array.from(images).map(function(img) {
                if (img.complete) {
                    return Promise.resolve();
                }
                return new Promise(function(resolve) {
                    img.onload = function() {
                        return resolve();
                    };
                    img.onerror = function() {
                        return resolve() // エラーでも続行
                        ;
                    };
                });
            });
            Promise.all(imagePromises).then(function() {
                if (bottomAnchorRef.current) {
                    bottomAnchorRef.current.scrollIntoView({
                        behavior: "auto",
                        block: "end"
                    });
                    hasScrolledRef.current = true;
                }
            });
        }
    }, [
        loading
    ]);
    // 外部から渡されたrefにメソッドを公開
    (0,react.useImperativeHandle)(refObject, function() {
        return {
            toBottom: function toBottom(forceScroll) {
                if (!messageWrapperRef.current) return;
                // ユーザーが既に最下部にいるかチェック
                var isAtBottom = messageWrapperRef.current.scrollHeight - messageWrapperRef.current.scrollTop <= messageWrapperRef.current.clientHeight + SCROLL_BOTTOM_THRESHOLD;
                // forceScrollが有効、またはユーザーが最下部にいる場合はスクロール
                if (forceScroll || isAtBottom) {
                    /**
         * hack
         * rerenderを待つための遅延
         */ setTimeout(function() {
                        var ref;
                        if (!messageWrapperRef.current) return;
                        var ref1;
                        messageWrapperRef.current.scrollTop = ((ref1 = (ref = messageListRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0) + SCROLL_BOTTOM_OFFSET;
                    }, 0);
                }
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        ref: messageWrapperRef,
        sx: (0,src_object_spread/* default */.Z)({
            /** フッター分の高さを引いた高さ */ height: "calc(100% - 48px)",
            overflowY: "auto"
        }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            ref: messageListRef,
            sx: {
                py: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: messages.map(function(message) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomMessage, {
                            userId: userId,
                            dmRoom: dmRoom,
                            dmRoomMessage: message
                        }, message.id);
                    }),
                    emptyMessage: emptyMessage,
                    loading: loading,
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomMessageSkeleton, {}),
                    hasNextPage: hasNextPage,
                    onFetchMore: onFetchMore,
                    inverted: true,
                    hiddenLoading: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    ref: bottomAnchorRef,
                    sx: {
                        height: 0,
                        visibility: "hidden"
                    },
                    "aria-hidden": "true"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomDetail/template/index.tsx















var consoleDmRoomDetailRef = /*#__PURE__*/ (0,react.createRef)();
var ConsoleDmRoomDetailTemplate = function(param) {
    var state = param.state, onReply = param.onReply, onFetchMore = param.onFetchMore, onReportUser = param.onReportUser;
    var ref, ref1, ref2, ref3;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDmRoomDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref4 = (0,react.useState)(false), open = ref4[0], setOpen = ref4[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var handleReportUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // ユーザー側の情報を通報対象とする(0に対象のユーザーが必ず入っている)
                    return [
                        4,
                        onReportUser((ref7 = (ref = state.dmRoom) === null || ref === void 0 ? void 0 : ref.id) !== null && ref7 !== void 0 ? ref7 : "", (ref8 = (ref1 = state.dmRoom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref8 !== void 0 ? ref8 : "", (ref9 = (ref4 = state.dmRoom) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.users) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.accountId) !== null && ref9 !== void 0 ? ref9 : "")
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onReportUser,
        state.dmRoom
    ]);
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
                styles: {
                    body: {
                        overflow: "hidden"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleDmRooms
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: (ref5 = (ref = state.dmRoom) === null || ref === void 0 ? void 0 : ref.title) !== null && ref5 !== void 0 ? ref5 : "",
                    right: state.dmRoom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                        edge: "end",
                        size: "medium",
                        color: "white",
                        onClick: toggleDrawer(true)
                    }) : undefined
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyForm/* ReplyForm */.I, {
                    onReply: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    onReply(values)
                                ];
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    userId: state.artistId,
                    visibleImage: true,
                    isConsole: true,
                    singleInputMode: true
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomMessageList, {
                    userId: state.artistId,
                    messages: state.messages,
                    dmRoom: state.dmRoom,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    emptyMessage: t("empty"),
                    refObject: consoleDmRoomDetailRef
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                disableEnforceFocus: true,
                open: open,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: (ref1 = state.dmRoom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                divider: true,
                                onClick: handleLoginModal(handleReportUser),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("report")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: toggleDrawer(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useSubscription.js + 1 modules
var useSubscription = __webpack_require__(27862);
// EXTERNAL MODULE: ../../node_modules/@capacitor/browser/dist/esm/index.js
var dist_esm = __webpack_require__(18260);
;// CONCATENATED MODULE: ./src/core/googleForm/index.ts



var openReportForm = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var email, contentType, contentId, userId, accountId, url;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = param.email, contentType = param.contentType, contentId = param.contentId, userId = param.userId, accountId = param.accountId;
                    url = [
                        "https://docs.google.com/forms/d/e/1FAIpQLSdg1CL4rkdJi7Hz-PrVBr3kaP61760PxLucFcM_XOUXoj6S6w/viewform?usp=sharing",
                        "137036600=".concat(email),
                        "666278690=".concat(contentType),
                        "581599158=".concat(contentId),
                        "1854267821=".concat(userId),
                        "384115263=".concat(accountId)
                    ].join("&entry.");
                    return [
                        4,
                        dist_esm/* Browser.open */.A.open({
                            url: url
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function openReportForm(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomDetail/viewModel.ts





function ConsoleDmRoomDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistDmRoomDetail($dmRoomId: ID!) {\n    dmRoom(dmRoomId: $dmRoomId) {\n      id\n      title\n      artist {\n        id\n        displayName\n        accountId\n        avatar {\n          uri\n          smallUri\n        }\n      }\n      users {\n        id\n        displayName\n        accountId\n        avatar {\n          uri\n          smallUri\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleDmRoomDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleDmRoomDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DmRoomOlderMessages($dmRoomId: ID!, $pageInput: PageInput) {\n    dmRoomMessages(dmRoomId: $dmRoomId, pageInput: $pageInput) {\n      ...DmRoomMessageConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleDmRoomDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleDmRoomDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  subscription DmRoomMessageCreated($dmRoomId: ID!) {\n    dmRoomMessageCreated(dmRoomId: $dmRoomId) {\n      ...DmRoomMessageBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleDmRoomDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleDmRoomDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateDmRoomMessage($inputs: CreateDmRoomMessageInput!) {\n    createDmRoomMessage(inputs: $inputs) {\n      ...DmRoomMessageBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleDmRoomDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var DM_ROOM_MESSAGES_PAGE_LIMIT = 20;
var ConsoleDmRoomDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleDmRoomDetail").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var _dmRoomId;
    var ref2 = (0,useQuery/* useQuery */.aM)(DM_ROOM_DETAIL, {
        variables: {
            dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : ""
        }
    }), data = ref2.data, loadingDetail = ref2.loading;
    var _dmRoomId1;
    /** アクセス前に投稿済みのメッセージを取得 */ var ref3 = (0,useQuery/* useQuery */.aM)(DM_ROOM_OLDER_MESSAGES, {
        variables: {
            dmRoomId: (_dmRoomId1 = router.query.dmRoomId) !== null && _dmRoomId1 !== void 0 ? _dmRoomId1 : "",
            /**
         * 初回描画時に画面の高さに満たず再フェッチが起こり
         * レイアウトシフトが起きることを避けるため20件取得
         */ pageInput: {
                limit: DM_ROOM_MESSAGES_PAGE_LIMIT
            }
        },
        /**
       * 一覧画面からの遷移時に最新コメント1件を取得したキャッシュにより
       * 1件のみが先に描画され追加フェッチが走ってしまい
       * レイアウトシフトが起きることを避けるため network-only を設定
       */ fetchPolicy: "network-only",
        nextFetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        onError: function() {
            showError(t("error"));
        }
    }), olderMessagesData = ref3.data, loadingOlderMessages = ref3.loading, fetchMore = ref3.fetchMore;
    var ref4;
    /** アクセスより前のコメント */ var olderMessages = orderBy_default()((ref4 = olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref = olderMessagesData.dmRoomMessages) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
        var node = param.node;
        return node;
    })) !== null && ref4 !== void 0 ? ref4 : [], [
        "createdAt"
    ], [
        "asc"
    ]);
    var _dmRoomId2;
    /** リアルタイムで投稿された最新メッセージを取得 */ var ref5 = (0,useSubscription/* useSubscription */.m)(DM_ROOM_MESSAGE_CREATED, {
        variables: {
            dmRoomId: (_dmRoomId2 = router.query.dmRoomId) !== null && _dmRoomId2 !== void 0 ? _dmRoomId2 : ""
        },
        onData: function() {
            setTimeout(function() {
                var /**
           * ユーザーがメッセージ最下部付近を表示している場合
           * メッセージリストを最下部へスクロールする
           *
           * スクロールの有無は DmRoomMessageList で判断
           */ ref;
                (ref = consoleDmRoomDetailRef.current) === null || ref === void 0 ? void 0 : ref.toBottom();
            }, 0);
        },
        onError: function() {
            showError(t("error"));
        }
    }), dmRoomMessageCreatedData = ref5.data, loadingSubscribedMessages = ref5.loading;
    /** リアルタイムで投稿された最新メッセージを配列化 */ var ref6 = (0,react.useState)([]), subscribedMessages = ref6[0], setSubscribedMessages = ref6[1];
    (0,react.useEffect)(function() {
        if (!dmRoomMessageCreatedData) return;
        setSubscribedMessages(function(prev) {
            if (prev.some(function(message) {
                var ref;
                return (message === null || message === void 0 ? void 0 : message.id) === ((ref = dmRoomMessageCreatedData.dmRoomMessageCreated) === null || ref === void 0 ? void 0 : ref.id);
            })) return prev;
            return orderBy_default()((0,src_to_consumable_array/* default */.Z)(prev).concat([
                dmRoomMessageCreatedData.dmRoomMessageCreated
            ]), [
                "createdAt"
            ], [
                "asc"
            ]);
        });
    }, [
        dmRoomMessageCreatedData
    ]);
    /** 既にエラーを表示済みかを保持する ref */ var hasMismatchError = (0,react.useRef)(false);
    /**
   * メッセージが正常に取得できていない場合にエラー表示を行う
   * 1. API で取得した最新1件と WebSocket で取得した最古1件の重複チェック
   * 2. WebSocket で取得したメッセージのシーケンス番号の整合性チェック
   */ (0,react.useEffect)(function() {
        /**
     * useEffect 内で showError を実行した際
     * 親コンポーネントの state 変更 → 再レンダリング
     * → useEffect の再実行 → showError の実行... のように
     * レンダリングが無限に走ってしまうことを避けるため
     * 一度エラーを表示したら再度エラーを表示しないように制御する
     */ if (hasMismatchError.current) return;
        /** ローディング中はチェックしない */ if (loadingDetail || loadingOlderMessages || loadingSubscribedMessages || olderMessages.length === 0 || subscribedMessages.length === 0) return;
        /** WebSocket から取得した最古のメッセージ */ var oldestSubscribedMessage = subscribedMessages[0];
        /** WebSocket から取得した最新のメッセージ */ var newestSubscribedMessage = subscribedMessages[subscribedMessages.length - 1];
        /** API で取得した最新のメッセージ */ var newestOlderMessage = olderMessages[olderMessages.length - 1];
        /**
     * API で取得した最新1件と WebSocket で取得した最古1件の重複チェック
     *
     * 両方のメッセージが存在し ID が一致しない場合は
     * メッセージ取得中に新たなメッセージが追加され差分が出ている可能性が高いため
     * 画面再読み込みでメッセージ取得からやり直してもらうようユーザにエラーを表示する
     *
     * WebSocket 確立中に送信されたメッセージが取得できていなかった場合を想定している
     */ var hasIdMismatch = (oldestSubscribedMessage === null || oldestSubscribedMessage === void 0 ? void 0 : oldestSubscribedMessage.id) && (newestOlderMessage === null || newestOlderMessage === void 0 ? void 0 : newestOlderMessage.id) && oldestSubscribedMessage.id !== newestOlderMessage.id;
        var ref, ref1;
        /**
     * WebSocket で取得したメッセージのシーケンス番号の整合性チェック
     *
     * 2025年10月時点
     *
     * ネイティブアプリにて DM 詳細画面を開いたままバックグラウンドに移行して
     * 再度フォアグラウンドに戻った際に、バックグラウンド中に複数のメッセージを受信していると
     * 最新メッセージ以外が受信できず、メッセージの欠落が発生してしまう
     *
     * 本来はフォアグラウンド復帰時にメッセージの再取得を行うのが好ましいが
     * リリースを優先し、ユーザーに再読み込みを促すエラーを表示する暫定対応を行う
     *
     * フォアグラウンド復帰時にメッセージの再取得を行うロジックを実装後は
     * hasSeqNoMismatch のチェックは削除して問題ない
     */ var hasSeqNoMismatch = ((ref = newestSubscribedMessage === null || newestSubscribedMessage === void 0 ? void 0 : newestSubscribedMessage.seqNo) !== null && ref !== void 0 ? ref : 0) - ((ref1 = oldestSubscribedMessage === null || oldestSubscribedMessage === void 0 ? void 0 : oldestSubscribedMessage.seqNo) !== null && ref1 !== void 0 ? ref1 : 0) + 1 !== subscribedMessages.length;
        /** いずれかのエラー条件を満たした場合、一度だけエラーを表示 */ if (hasIdMismatch || hasSeqNoMismatch) {
            hasMismatchError.current = true;
            showError(t("mismatchError"));
        }
    }, [
        olderMessages,
        subscribedMessages,
        loadingDetail,
        loadingOlderMessages,
        loadingSubscribedMessages, 
    ]);
    /**
   * @description
   * 投稿済みのメッセージとリアルタイムで取得したメッセージを結合したもの
   * 投稿済みのメッセージの最新1件はリアルタイムで取得した最古1件と重複するため
   * 除外する処理を入れている
   *
   * nodes に長さを持つ配列が渡されると、loading に関わらず
   * skelton を解除するという ScrollFetcher の実装により、
   * 比較的短時間で取得可能な subscribedMessages だけが
   * 先に表示されてしまうことを防ぐために
   * 各クエリの loading 状態による条件分岐を追加している
   */ var messages = loadingDetail || loadingOlderMessages && olderMessages.length === 0 || loadingSubscribedMessages ? [] : (0,src_to_consumable_array/* default */.Z)(olderMessages.filter(function(message) {
        return message !== null && message !== undefined;
    })// 重複回避のため最新1件を除外
    .slice(0, -1)).concat((0,src_to_consumable_array/* default */.Z)(subscribedMessages.filter(function(message) {
        return message !== null && message !== undefined;
    }))).reverse();
    /** メッセージを作成 */ var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DM_ROOM_MESSAGE_CREATE), 1), createDmRoomMessage = ref7[0];
    /** フォームからの入力をもとに、メッセージ作成用の変数を作成 */ var buildCreateDmRoomMessageVariables = function(inputs) {
        /** テキストメッセージの場合 */ if (inputs.content) {
            var _dmRoomId;
            return {
                dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : "",
                message: inputs.content,
                type: utoniq_core_schema/* DmRoomMessageType.Text */.$R4.Text
            };
        }
        var _dmRoomId1;
        /** 画像メッセージの場合 */ return {
            dmRoomId: (_dmRoomId1 = router.query.dmRoomId) !== null && _dmRoomId1 !== void 0 ? _dmRoomId1 : "",
            resources: inputs.resources,
            type: utoniq_core_schema/* DmRoomMessageType.Image */.$R4.Image
        };
    };
    var ref8;
    return {
        state: {
            loading: loadingDetail || loadingOlderMessages,
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            dmRoom: data === null || data === void 0 ? void 0 : data.dmRoom,
            messages: messages,
            hasNextPage: !!(olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref1 = olderMessagesData.dmRoomMessages) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage)
        },
        actions: {
            onReply: function onReply(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createDmRoomMessage({
                                        variables: {
                                            inputs: buildCreateDmRoomMessageVariables(inputs)
                                        }
                                    }).catch(function(error) {
                                        showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _dmRoomId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : "",
                                            pageInput: {
                                                limit: DM_ROOM_MESSAGES_PAGE_LIMIT,
                                                cursor: olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref = olderMessagesData.dmRoomMessages) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    }).catch(function(error) {
                                        showError(t("error"));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "dm-rooms",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var DM_ROOM_DETAIL = (0,lib/* gql */.Ps)(ConsoleDmRoomDetail_viewModel_templateObject());
var DM_ROOM_OLDER_MESSAGES = (0,lib/* gql */.Ps)(ConsoleDmRoomDetail_viewModel_templateObject1(), utoniq_core_schema/* DmRoomMessageConnectionFragmentDoc */.vJ8);
var DM_ROOM_MESSAGE_CREATED = (0,lib/* gql */.Ps)(ConsoleDmRoomDetail_viewModel_templateObject2(), utoniq_core_schema/* DmRoomMessageBoxFragmentDoc */.eBW);
var DM_ROOM_MESSAGE_CREATE = (0,lib/* gql */.Ps)(ConsoleDmRoomDetail_viewModel_templateObject3(), utoniq_core_schema/* DmRoomMessageBoxFragmentDoc */.eBW);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRoomDetail/index.tsx




/**
 * ConsoleDmRoomDetail Page
 * Implemented as a practical sample.
 */ var ConsoleDmRoomDetail = function() {
    var ref = ConsoleDmRoomDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDmRoomDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/dmRoom/DmRoomBox/index.tsx






var /**
 * DMルームのステータス
 */ DmRoomStatus;
(function(DmRoomStatus) {
    DmRoomStatus["Yet"] = "yet";
    DmRoomStatus["Active"] = "active";
    DmRoomStatus["Finished"] = "finished";
})(DmRoomStatus || (DmRoomStatus = {}));
var DmRoomStatusTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRooms").t;
    var ref = (0,react.useMemo)(function() {
        switch(status){
            case DmRoomStatus.Yet:
                return {
                    bgcolor: "primary.main",
                    color: "white"
                };
            case DmRoomStatus.Active:
                return {
                    bgcolor: "secondary.main",
                    color: "white"
                };
            case DmRoomStatus.Finished:
            default:
                return {
                    bgcolor: "grey.100",
                    color: "text.disabled"
                };
        }
    }, [
        status
    ]), bgcolor = ref.bgcolor, color = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 20,
            borderRadius: "2px",
            minWidth: 40,
            bgcolor: bgcolor,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: color,
            variant: "overline",
            component: "p",
            children: t(status)
        })
    });
};
var DmRoomBox = function(param) {
    var dmRoom = param.dmRoom, isConsole = param.isConsole;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRooms").t;
    /**
   * DMルームのステータスを判定する
   */ var getDmRoomStatus = function(startedAt, expiredAt) {
        var now = new Date();
        var startDate = new Date(startedAt);
        var expireDate = new Date(expiredAt);
        if (now < startDate) return DmRoomStatus.Yet;
        if (now >= startDate && now < expireDate) return DmRoomStatus.Active;
        return DmRoomStatus.Finished;
    };
    /**
   * ステータスに応じた日時テキストを取得する
   */ var getDateText = function(status, startedAt, expiredAt) {
        if (status === DmRoomStatus.Yet) {
            return t("startFrom", {
                date: values_Date/* DateTime.format */.o.format(startedAt)
            });
        }
        if (status === DmRoomStatus.Active) {
            return t("endAt", {
                date: values_Date/* DateTime.format */.o.format(expiredAt)
            });
        }
        return null;
    };
    /**
   * 最新メッセージのテキストを取得する
   */ var getLatestMessageText = function(latestMessageNode) {
        var ref;
        if (!latestMessageNode) return "";
        // 画像メッセージの場合
        if (latestMessageNode.type === "IMAGE" || ((ref = latestMessageNode.resources) === null || ref === void 0 ? void 0 : ref.some(function(r) {
            return r.type === "IMAGE";
        }))) {
            return t("sentImage");
        }
        var _message;
        return (_message = latestMessageNode.message) !== null && _message !== void 0 ? _message : "";
    };
    // ステータス判定
    var status = (0,react.useMemo)(function() {
        return getDmRoomStatus(dmRoom.startedAt, dmRoom.expiredAt);
    }, [
        dmRoom.startedAt,
        dmRoom.expiredAt
    ]);
    // 日時表示
    var dateText = (0,react.useMemo)(function() {
        return getDateText(status, dmRoom.startedAt, dmRoom.expiredAt);
    }, [
        status,
        dmRoom.startedAt,
        dmRoom.expiredAt
    ]);
    var _latestMessage;
    // 最新メッセージ
    var latestMessageNode = (_latestMessage = dmRoom.latestMessage) !== null && _latestMessage !== void 0 ? _latestMessage : null;
    var latestMessageText = (0,react.useMemo)(function() {
        return getLatestMessageText(latestMessageNode);
    }, [
        latestMessageNode
    ]);
    // 相対時間
    var relativeTime = (0,react.useMemo)(function() {
        if (!latestMessageNode) return "";
        var _formattedRelativeCreatedAt;
        return (_formattedRelativeCreatedAt = latestMessageNode.formattedRelativeCreatedAt) !== null && _formattedRelativeCreatedAt !== void 0 ? _formattedRelativeCreatedAt : "";
    }, [
        latestMessageNode
    ]);
    // ルーム相手のユーザ
    var recipient = (0,react.useMemo)(function() {
        return isConsole ? dmRoom.users[0] : dmRoom.artist;
    }, [
        isConsole,
        dmRoom.artist,
        dmRoom.users
    ]);
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    py: 2,
                    px: 4,
                    "&:last-child": {
                        pb: 2
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomStatusTag, {
                                    status: status
                                }),
                                dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: dateText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                            children: dmRoom.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "flex-start",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: (ref2 = recipient === null || recipient === void 0 ? void 0 : (ref = recipient.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : undefined,
                                    sx: {
                                        width: 40,
                                        height: 40
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    sx: {
                                        minWidth: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.secondary",
                                                        fontSize: 13,
                                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                        children: (ref3 = recipient === null || recipient === void 0 ? void 0 : recipient.displayName) !== null && ref3 !== void 0 ? ref3 : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        color: "text.hint",
                                                        sx: {
                                                            flexShrink: 0,
                                                            ml: 1
                                                        },
                                                        children: relativeTime
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                children: latestMessageText
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    zIndex: 1
                },
                href: generatePath(isConsole ? routerPages.ConsoleDmRoomDetail : routerPages.DmRoomDetail, {
                    dmRoomId: dmRoom.id
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/dmRoom/DmRoomSkeleton/index.tsx


var DmRoomSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                py: 2,
                px: 4,
                "&:last-child": {
                    pb: 2
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 40,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                width: 200
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        width: "80%",
                        height: 28
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "flex-start",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 40,
                                height: 40
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "text",
                                        width: 100
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "text",
                                        width: "90%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "text",
                                        width: 60
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRooms/template/index.tsx











var ConsoleDmRoomsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRooms").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleDmRooms
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 3,
                            px: 5
                        },
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body1",
                                children: t("description")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            componentProps: {
                                sx: {
                                    pt: 2,
                                    pb: 5
                                },
                                spacing: 5
                            },
                            nodes: (ref = state.dmRooms) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomBox, {
                                    dmRoom: node,
                                    isConsole: true
                                }, node.id);
                            }),
                            onFetchMore: onFetchMore,
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            emptyMessage: t("emptyDmRoom"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 5,
                                sx: {
                                    pb: 7
                                },
                                children: Array.from(Array(4).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomSkeleton, {}, key);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDmRooms_template_BaseCell, {})
                ]
            })
        ]
    });
};
var ConsoleDmRooms_template_BaseCell = function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                position: "fixed",
                bottom: 16,
                zIndex: 5,
                maxWidth: 600,
                margin: "0 auto",
                px: 4,
                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "medium",
                color: "primary",
                onClick: function() {
                    return router.push(routerPages.ConsoleDmRoomCreate);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRooms/viewModel.ts



function ConsoleDmRooms_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleDmRooms($pageInput: PageInput) {\n    artistDmRooms(pageInput: $pageInput) {\n      ...ArtistDmRoomsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleDmRooms_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ConsoleDmRooms_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    // artistDmRoomsクエリを実行しDMルーム一覧を取得
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleDmRooms_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {}
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2, ref3;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            dmRooms: (ref3 = data === null || data === void 0 ? void 0 : data.artistDmRooms) !== null && ref3 !== void 0 ? ref3 : null,
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistDmRooms) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: /**
       * 次のページを取得する（無限スクロール時）
       */ function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            // 最後のカーソル位置から続き取得
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistDmRooms) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
/**
 * アーティスト用DMルーム一覧を取得するクエリ
 */ var ConsoleDmRooms_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleDmRooms_viewModel_templateObject(), utoniq_core_schema/* ArtistDmRoomsConnectionFragmentDoc */.whk);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleDmRooms/index.tsx




/**
 * ConsoleEvents Page
 * Implemented as a practical sample.
 */ var ConsoleDmRooms = function() {
    var ref = ConsoleDmRooms_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleDmRoomsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/lodash/set.js
var set = __webpack_require__(16765);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/components/common.tsx








var common_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            ref: ref
        }, props), {
            t: t
        }))
    });
});
var common_MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: (0,src_object_spread/* default */.Z)({
                variant: "h5",
                color: "text.primary",
                sx: {
                    display: "none"
                }
            }, titleProps),
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, textFieldProps), {
                sx: {
                    mt: 0,
                    mb: 0
                }
            }),
            ref: ref,
            t: t,
            error: error,
            placeholder: "--:--"
        }))
    });
});

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormGroup/FormGroup.js
var FormGroup = __webpack_require__(74607);
// EXTERNAL MODULE: ../../node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(9850);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/components/PickupTimeModal.tsx

















var PickupTimeModal_schema = function(o) {
    return {
        pickupDate: o.array().items(o.string()).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupDate")),
        pickupTime: o.array().items(o.object({
            options: o.object({
                time: o.string().regex(/^([01][0-9]|2[0-3]):([0-5][0-9])$/).messages({
                    "string.empty": (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.time.string.empty")
                }).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupTime.time")),
                availableUserNumber: o.number().min(1).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupTime.availableUserNumber"))
            })
        }))
    };
};
/**
 * @description
 * 一括で受け渡し日時を設定するモーダル
 * react-hook-formのスキーマを持ち、handleSubmit実行時に受取時間stateを更新するようになっている
 */ var PickupTimeModal = function(param) {
    var open = param.open, days = param.days, onSubmit = param.onSubmit, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: PickupTimeModal_schema,
        defaultValues: PickupTimeModal_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isSubmitSuccessful = _formState.isSubmitSuccessful, register = ref.register, setValue = ref.setValue, control = ref.control, trigger = ref.trigger, watch = ref.watch, reset = ref.reset;
    var watchPickupDate = watch("pickupDate");
    var watchPickupTime = watch("pickupTime");
    var ref1 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        keyName: "_id",
        name: "pickupTime"
    }), fields = ref1.fields, append = ref1.append, onRemove = ref1.remove;
    var pickupDateError = (0,react.useMemo)(function() {
        return get_default()(errors.pickupDate, "message");
    }, [
        errors.pickupDate
    ]);
    (0,react.useEffect)(function() {
        if (!isSubmitSuccessful) return;
        reset(PickupTimeModal_defaultValues);
    }, [
        isSubmitSuccessful,
        reset
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        onSubmit(values);
        onClose();
    });
    var handleTriggerOrder = function(errors) {
        if (!watchPickupTime.length) return;
        if (errors) return;
        setValue("pickupTime", orderBy_default()(cloneDeep_default()(watchPickupTime), function(pickupTime) {
            var ref;
            return (pickupTime === null || pickupTime === void 0 ? void 0 : (ref = pickupTime.options) === null || ref === void 0 ? void 0 : ref.time) || "24:00";
        }, [
            "asc"
        ]));
        trigger("pickupTime");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
            open: open,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                ml: "30px"
                            },
                            children: t("selectDateAndSetAll")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "small",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pb: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                py: 2
                            },
                            children: t("eventDate")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                                    row: true,
                                    children: days.map(function(day) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                            value: day,
                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                sx: {
                                                    p: 2
                                                }
                                            }),
                                            label: day,
                                            onChange: function() {
                                                setValue("pickupDate", xor_default()(watchPickupDate, [
                                                    day
                                                ]), {
                                                    shouldValidate: true
                                                });
                                            }
                                        });
                                    })
                                }),
                                !!pickupDateError && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                    error: true,
                                    sx: {
                                        bgcolor: "transparent"
                                    },
                                    children: pickupDateError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                            sx: {
                                py: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                            sx: {
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "normal",
                                                    sx: {
                                                        width: "auto",
                                                        pl: 0,
                                                        pr: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        whiteSpace: "nowrap",
                                                        children: t("deliveryStartTime", "受け渡し開始時間")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "normal",
                                                    sx: {
                                                        width: 100,
                                                        pl: 0,
                                                        pr: 2,
                                                        flex: 1
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 4,
                                                        justifyContent: "flex-end",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "subtitle1",
                                                                children: t("availablePeople", "対応可能人数")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Plus, {
                                                                bgcolor: "primary.main",
                                                                sx: {
                                                                    width: 20,
                                                                    height: 20,
                                                                    "&:hover": {
                                                                        bgcolor: "primary.main",
                                                                        opacity: 0.8
                                                                    },
                                                                    svg: {
                                                                        fontSize: "12px",
                                                                        color: "white"
                                                                    }
                                                                },
                                                                size: "small",
                                                                disabled: fields.length >= 20,
                                                                onClick: function() {
                                                                    append({
                                                                        options: {
                                                                            time: "",
                                                                            availableUserNumber: 0
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                        children: fields.map(function(field, index) {
                                            var ref, ref1;
                                            var _ref = register("pickupTime.".concat(index, ".options.time")), onChangeTime = _ref.onChange, timeInputProps = (0,_object_without_properties/* default */.Z)(_ref, [
                                                "onChange"
                                            ]);
                                            var _ref1 = register("pickupTime.".concat(index, ".options.availableUserNumber")), onChangeAvailableUserNumber = _ref1.onChange, availableUserNumberInputProps = (0,_object_without_properties/* default */.Z)(_ref1, [
                                                "onChange"
                                            ]);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPickupRowTime, {
                                                timeInputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, timeInputProps), {
                                                    onChange: function onChange(event) {
                                                        return (0,src_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            onChangeTime(event)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        return [
                                                                            4,
                                                                            trigger("pickupTime.".concat(index, ".options"))
                                                                        ];
                                                                    case 2:
                                                                        _state.sent();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    },
                                                    onBlur: function onBlur(event) {
                                                        return (0,src_async_to_generator/* default */.Z)(function() {
                                                            var ref, ref1;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            timeInputProps.onBlur(event)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        handleTriggerOrder((ref = errors.pickupTime) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.options);
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    }
                                                }),
                                                availableUserNumberInputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, availableUserNumberInputProps), {
                                                    onChange: function onChange(event) {
                                                        return (0,src_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            onChangeAvailableUserNumber(event)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        return [
                                                                            4,
                                                                            trigger("pickupTime.".concat(index, ".options"))
                                                                        ];
                                                                    case 2:
                                                                        _state.sent();
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    },
                                                    onBlur: function onBlur(event) {
                                                        return (0,src_async_to_generator/* default */.Z)(function() {
                                                            var ref, ref1;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            availableUserNumberInputProps.onBlur(event)
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        handleTriggerOrder((ref = errors.pickupTime) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.options);
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    }
                                                }),
                                                errors: (ref = errors.pickupTime) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.options,
                                                onRemove: function() {
                                                    return onRemove(index);
                                                },
                                                bgcolor: "transparent"
                                            }, field._id);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                type: "button",
                                sx: {
                                    width: 212
                                },
                                onClick: handleOnSubmit,
                                children: t("register")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var PickupTimeModal_defaultValues = {
    pickupDate: [],
    pickupTime: [
        {
            options: {
                time: "",
                availableUserNumber: 0
            }
        }
    ]
};
var ModalPickupRowTime = function(param) {
    var errors = param.errors, timeInputProps = param.timeInputProps, availableUserNumberInputProps = param.availableUserNumberInputProps, onRemove = param.onRemove, bgcolor = param.bgcolor, className = param.className;
    var errorMessage = (0,react.useMemo)(function() {
        var ref, ref1;
        if (errors === null || errors === void 0 ? void 0 : (ref = errors.time) === null || ref === void 0 ? void 0 : ref.message) {
            return errors.time.message;
        }
        if (errors === null || errors === void 0 ? void 0 : (ref1 = errors.availableUserNumber) === null || ref1 === void 0 ? void 0 : ref1.message) {
            return errors.availableUserNumber.message;
        }
        return undefined;
    }, [
        errors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
        className: className,
        sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
            fieldset: {
                border: "solid 1px lightgray"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    borderBottom: "none",
                    pl: 0,
                    pr: 4,
                    pb: 0,
                    position: "relative",
                    div: {
                        xs: {
                            minWidth: "inherit"
                        },
                        "@media(min-width:450px)": {
                            minWidth: "auto",
                            flex: 1
                        }
                    },
                    "p.Mui-error": {
                        height: 0,
                        position: "absolute",
                        bottom: 0,
                        background: "transparent",
                        whiteSpace: "nowrap"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_MaskedInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, timeInputProps), {
                        type: "time",
                        mask: "00:00",
                        textFieldProps: {
                            error: !!(errors === null || errors === void 0 ? void 0 : errors.time),
                            helperText: errorMessage,
                            FormHelperTextProps: {
                                error: !!errors,
                                sx: {
                                    bgcolor: bgcolor
                                }
                            }
                        }
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    width: "auto",
                    borderBottom: "none",
                    pl: 0,
                    pr: 0,
                    pb: 0,
                    div: {
                        minWidth: "inherit"
                    },
                    "p.Mui-error": {
                        height: 0,
                        position: "absolute",
                        bottom: 0,
                        background: "transparent",
                        whiteSpace: "nowrap"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ".MuiFormHelperText-root": {
                                    display: "none"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TextInputCell, (0,src_object_spread/* default */.Z)({
                                type: "number",
                                titleProps: {
                                    display: "none"
                                },
                                textFieldProps: {
                                    sx: {
                                        my: 0,
                                        width: 100
                                    },
                                    error: !!(errors === null || errors === void 0 ? void 0 : errors.availableUserNumber),
                                    helperText: errors ? " " : undefined,
                                    placeholder: "200",
                                    FormHelperTextProps: {
                                        sx: {
                                            bgcolor: bgcolor
                                        }
                                    }
                                }
                            }, availableUserNumberInputProps))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                            size: "small",
                            onClick: onRemove
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/components/PickupTimesEditForm.tsx








/**
 * @description
 * pickupTimeの配列を受け取り、編集するフォーム
 */ 



var PickupTimesEditForm = function(param) {
    var pickupTimes = param.pickupTimes, setPickupTimes = param.setPickupTimes, days = param.days, pickupTimeErrors = param.pickupTimeErrors;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    /**
   * モーダルのフォームを決定したときに受取時間stateを更新する処理日付が一致するものに対して、時間を追加する
   * 入力値から得られた情報を元のステートにマージする
   */ var handleSubmitPickupTimeModal = function(values) {
        if (!values.pickupTime.length) return;
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (!values.pickupDate.includes(node.pickupDate)) return node;
                var _currentUserNumber;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: (0,src_to_consumable_array/* default */.Z)(node.pickupTime).concat((0,src_to_consumable_array/* default */.Z)(values.pickupTime.map(function(param, i) {
                        var options = param.options;
                        var ref;
                        return {
                            options: {
                                time: options.time,
                                availableUserNumber: options.availableUserNumber,
                                currentUserNumber: (_currentUserNumber = (ref = node.pickupTime.find(function(param) {
                                    var _opt = param.options;
                                    return _opt.time === options.time;
                                })) === null || ref === void 0 ? void 0 : ref.options.currentUserNumber) !== null && _currentUserNumber !== void 0 ? _currentUserNumber : 0
                            }
                        };
                    })))// 重複を除外
                    .reduceRight(function(acc, cur) {
                        if (!acc.some(function(e) {
                            return e.options.time === cur.options.time;
                        })) {
                            acc.unshift(cur);
                        }
                        return acc;
                    }, [])// 時間が若い順にソート
                    .sort(function(a, b) {
                        return a.options.time > b.options.time ? 1 : -1;
                    })
                });
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("pickupvalidMinutes", "受け渡し開始時間と対応可能人数")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 1,
                    color: "text.secondary"
                },
                children: t("pickupvalidMinutesNote", "対応可能人数を入力すると、購入者数を制限できます。受け渡しの有効時間内に対応可能な人数を入力してください。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                sx: {
                    pt: 1,
                    color: "text.secondary"
                },
                children: t("pickupvalidMinutesCaution", "※「受け渡し開始時間」は、ユーザーが商品を購入するまでに限り、編集・削除する事ができます。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        size: "medium",
                        onClick: function() {
                            return setOpen(true);
                        },
                        sx: {
                            borderColor: "primary.main",
                            color: "primary.main",
                            mt: 3
                        },
                        children: t("selectDate", "日付を選んで一括設定する")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupTimeModal, {
                        open: open,
                        onClose: function() {
                            return setOpen(false);
                        },
                        days: days,
                        onSubmit: handleSubmitPickupTimeModal
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupTimeForm, {
                pickupTimes: pickupTimes,
                setPickupTimes: setPickupTimes,
                pickupTimeErrors: pickupTimeErrors
            })
        ]
    });
};
/**
 * @description
 * ページ内で受取時間stateを編集するフォーム群
 * stateの日付ごとに時間・受け渡し可能人数を入力するフォームをグルーピングして表示する
 */ var PickupTimeForm = function(param) {
    var pickupTimes = param.pickupTimes, setPickupTimes = param.setPickupTimes, pickupTimeErrors = param.pickupTimeErrors;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            sx: {
                py: 4
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    padding: "normal",
                                    sx: {
                                        width: "auto",
                                        pl: 0,
                                        pr: 2,
                                        borderBottom: "none",
                                        pb: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: t("deliveryStartTime")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    padding: "normal",
                                    sx: {
                                        flex: 1,
                                        pl: 0,
                                        pr: 2,
                                        borderBottom: "none",
                                        pb: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: {
                                            whiteSpace: "nowrap",
                                            textAlign: "right",
                                            position: "relative"
                                        },
                                        children: [
                                            t("currentUserNumber"),
                                            " ",
                                            t("availablePeople")
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                        children: pickupTimes.map(function(pickupTime, index) {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupTimeCell, {
                                pickupTime: pickupTime,
                                setPickupTimes: setPickupTimes,
                                pickupTimeError: (ref = pickupTimeErrors[index]) === null || ref === void 0 ? void 0 : ref.pickupTime
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/**
 * 日付ごとの時間指定フォームを表示するコンポーネント
 */ var PickupTimeCell = function(param) {
    var pickupTime = param.pickupTime, setPickupTimes = param.setPickupTimes, pickupTimeError = param.pickupTimeError;
    var pickup = pickupTime.pickupTime;
    // ゴミ箱アイコンを押した時の処理。該当する時間をstateから除外する
    var handleRemove = function(index) {
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (node.pickupDate !== pickupTime.pickupDate) return node;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: node.pickupTime.filter(function(_, i) {
                        return i !== index;
                    })
                });
            });
        });
    };
    // 日付横の+ボタンを押した時の処理。stateの日付に対応する時間に空の値を追加する
    var handlePlus = function() {
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (node.pickupDate !== pickupTime.pickupDate) return node;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: (0,src_to_consumable_array/* default */.Z)(node.pickupTime).concat([
                        {
                            options: {
                                time: "",
                                availableUserNumber: 0,
                                currentUserNumber: 0
                            }
                        }, 
                    ])
                });
            });
        });
    };
    // ソートと重複除外の処理、個々のフォーム側で入力が終わったときに実行する
    var handleSort = function() {
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (node.pickupDate !== pickupTime.pickupDate) return node;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: node.pickupTime// 重複を除外
                    .reduceRight(function(acc, cur) {
                        if (!acc.some(function(e) {
                            return e.options.time === cur.options.time;
                        })) {
                            acc.unshift(cur);
                        }
                        return acc;
                    }, [])// ソート
                    .sort(function(a, b) {
                        return !b.options.time ? -1 : !a.options.time || a.options.time > b.options.time ? 1 : -1;
                    })
                });
            });
        });
    };
    // 個々のフォームについて、時間を更新する。
    var handleChangeTime = function(input, index) {
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (node.pickupDate !== pickupTime.pickupDate) return node;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: node.pickupTime.map(function(time, i) {
                        if (i !== index) return time;
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, time), {
                            options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, time.options), {
                                time: input
                            })
                        });
                    })
                });
            });
        });
    };
    // 個々のフォームについて、受け渡し可能人数を更新する
    var handleChangeAvailableUserNumber = function(input, index) {
        setPickupTimes(function(state) {
            return state.map(function(node) {
                if (node.pickupDate !== pickupTime.pickupDate) return node;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    pickupTime: node.pickupTime.map(function(time, i) {
                        if (i !== index) return time;
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, time), {
                            options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, time.options), {
                                availableUserNumber: input
                            })
                        });
                    })
                });
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                    colSpan: 3,
                    sx: {
                        borderBottom: "none",
                        pb: 0,
                        px: 0,
                        pt: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            sx: {
                                color: "grey.100"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            sx: {
                                pt: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: values_Date/* DateTime.formatDate */.o.formatDate(pickupTime.pickupDate, "YYYY/MM/DD (ddd)")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Plus, {
                                    bgcolor: "primary.main",
                                    sx: {
                                        bgcolor: "primary.main",
                                        width: 20,
                                        height: 20,
                                        "&:hover": {
                                            bgcolor: "primary.main",
                                            opacity: 0.8
                                        },
                                        svg: {
                                            fontSize: "12px",
                                            color: "white"
                                        }
                                    },
                                    size: "small",
                                    disabled: pickup.length >= 20,
                                    onClick: handlePlus
                                })
                            ]
                        })
                    ]
                })
            }),
            pickup.map(function(param, index) {
                var options = param.options;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupRowTime, {
                    index: index,
                    options: options,
                    onRemove: handleRemove,
                    onBlurTime: handleChangeTime,
                    onBlurAvailableUserNumber: handleChangeAvailableUserNumber,
                    onSort: handleSort,
                    errorTime: pickupTimeError === null || pickupTimeError === void 0 ? void 0 : pickupTimeError[index].options.time
                }, index);
            })
        ]
    });
};
/**
 * 受取時間変更フォームの1つ1つのフォームコンポーネント
 * それぞれがreact-hook-formのスキーマを持ち、個別にバリデーションチェックを行う
 */ var PickupRowTime = function(param) {
    var options = param.options, onRemove = param.onRemove, index = param.index, onBlurTime = param.onBlurTime, onBlurAvailableUserNumber = param.onBlurAvailableUserNumber, onSort = param.onSort, errorTime = param.errorTime;
    var ref, ref1, ref2, ref3;
    // 1度blurを行ったかどうか。これ以降にバリデーションチェックを行うようにする
    var ref4 = (0,react.useState)(false), slotted = ref4[0], setSlotted = ref4[1];
    var _currentUserNumber;
    var schema = function(o) {
        return {
            time: o.string().regex(/^([01][0-9]|2[0-3]):([0-5][0-9])$/).messages({
                "string.empty": (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.time.string.empty")
            }).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupTime.time")),
            availableUserNumber: o.number().min((_currentUserNumber = options.currentUserNumber) !== null && _currentUserNumber !== void 0 ? _currentUserNumber : 1).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupTime.availableUserNumber"))
        };
    };
    var _time, _availableUserNumber;
    var ref5 = (0,core_form/* useForm */.cI)({
        schema: schema,
        defaultValues: {
            time: (_time = options.time) !== null && _time !== void 0 ? _time : "",
            availableUserNumber: (_availableUserNumber = options.availableUserNumber) !== null && _availableUserNumber !== void 0 ? _availableUserNumber : 0
        }
    }), errors = ref5.formState.errors, register = ref5.register, reset = ref5.reset, watch = ref5.watch;
    (0,react.useEffect)(function() {
        var _time, _availableUserNumber;
        reset({
            time: (_time = options.time) !== null && _time !== void 0 ? _time : "",
            availableUserNumber: (_availableUserNumber = options.availableUserNumber) !== null && _availableUserNumber !== void 0 ? _availableUserNumber : 0
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
            fieldset: {
                border: options.currentUserNumber ? "none" : "solid 1px lightgray"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    borderBottom: "none",
                    pl: 0,
                    pr: 0,
                    pb: 0,
                    position: "relative",
                    div: {
                        xs: {
                            minWidth: "72px"
                        },
                        "@media(min-width:450px)": {
                            minWidth: "auto",
                            flex: 1
                        }
                    },
                    "p.Mui-error": {
                        height: 0,
                        position: "absolute",
                        bottom: 0,
                        background: "transparent",
                        whiteSpace: "nowrap"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_MaskedInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("time")), {
                    type: "time",
                    mask: "00:00",
                    textFieldProps: {
                        error: slotted && !options.currentUserNumber && (!!(errors === null || errors === void 0 ? void 0 : errors.time) || !options.currentUserNumber && !watch("time") || !((ref = watch("time")) === null || ref === void 0 ? void 0 : ref.match(/^([01][0-9]|2[0-3]):([0-5][0-9])$/))) || !!errorTime,
                        helperText: slotted && !options.currentUserNumber && (((ref1 = errors.time) === null || ref1 === void 0 ? void 0 : ref1.message) || ((ref2 = errors.availableUserNumber) === null || ref2 === void 0 ? void 0 : ref2.message) || !watch("time") && (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.time.string.empty") || !((ref3 = watch("time")) === null || ref3 === void 0 ? void 0 : ref3.match(/^([01][0-9]|2[0-3]):([0-5][0-9])$/)) && (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.time.string.pattern") || !options.currentUserNumber && !watch("availableUserNumber") && (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.availableUserNumber.number.empty") || watch("availableUserNumber") <= 0 && (0,core_form/* tMessage */.Sd)("consoleEventCollectionReceiveTimeEdit.pickupTime.availableUserNumber.number.invalid")) || errorTime,
                        FormHelperTextProps: {
                            error: !!errors || !!errorTime,
                            sx: {}
                        },
                        onBlur: function(e) {
                            setSlotted(true);
                            onBlurTime(e.target.value, index);
                            if (!Object.keys(errors).length && !!watch("availableUserNumber")) {
                                onSort();
                            }
                        },
                        disabled: !!options.currentUserNumber
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    width: "auto",
                    borderBottom: "none",
                    pl: 0,
                    pr: 0,
                    pb: 0,
                    div: {
                        minWidth: options.currentUserNumber ? "40px" : "inherit"
                    },
                    "p.Mui-error": {
                        height: 0,
                        position: "absolute",
                        bottom: 0,
                        background: "transparent",
                        whiteSpace: "nowrap"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                sx: {
                                    width: 56
                                },
                                align: "right",
                                children: [
                                    options.availableUserNumber && Number(options.currentUserNumber) !== 0 ? options.currentUserNumber : "-",
                                    " ",
                                    "/"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                ".MuiFormHelperText-root": {
                                    display: "none"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("availableUserNumber")), {
                                type: "tel",
                                titleProps: {
                                    display: "none"
                                },
                                textFieldProps: {
                                    sx: {
                                        my: 0,
                                        width: 100
                                    },
                                    error: !!(errors === null || errors === void 0 ? void 0 : errors.availableUserNumber) || slotted && !options.currentUserNumber && (!watch("availableUserNumber") || watch("availableUserNumber") <= 0),
                                    FormHelperTextProps: {
                                        error: !!errors
                                    },
                                    placeholder: "200",
                                    onBlur: function(e) {
                                        setSlotted(true);
                                        onBlurAvailableUserNumber(Number(e.target.value), index);
                                        if (!Object.keys(errors).length && !!watch("availableUserNumber")) {
                                            onSort();
                                        }
                                    }
                                }
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                            size: "small",
                            disabled: !!options.currentUserNumber,
                            onClick: function() {
                                return onRemove(index);
                            }
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/EventCollectionReceiveTimeEditForm.tsx
















/**
 * @description
 * イベント受け渡し情報の編集フォーム
 * このファイルでは以下のデータを管理する
 * - 受け渡し場所、有効時間などの汎用的な情報(react-hook-formのスキーマ)
 * - 受け渡し時間の情報(state)。PickupTimesEditFormコンポーネントに渡す
 *
 * react-hook-formのhandleSubmitを実行した時に、このファイルのスキーマと、受け渡し情報stateを結合してonSubmitアクションを実行する
 */ var EventCollectionReceiveTimeEditForm = function(param) {
    var eventCollection = param.eventCollection, days = param.days, onSubmit = param.onSubmit, submitting = param.submitting, maxValidMinutes = param.maxValidMinutes;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var schema = function(o) {
        return {
            pickupLocation: o.string().label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.pickupLocation")),
            validMinutes: o.number().min(10).max(maxValidMinutes).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.validMinutes")),
            purchaseLimitPerPickup: o.number().min(1).label((0,core_form/* tLabel */.TQ)("consoleEventCollectionReceiveTimeEdit.purchaseLimitPerPickup")).allow("").optional()
        };
    };
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: schema,
        defaultValues: EventCollectionReceiveTimeEditForm_defaultValues
    }), handleSubmit = ref.handleSubmit, errors = ref.formState.errors, register = ref.register, reset = ref.reset, setError = ref.setError;
    var ref1 = (0,react.useState)([]), pickupTimeErrors = ref1[0], setPickupTimeErrors = ref1[1];
    var ref2, _availableUserNumber, _currentUserNumber, ref3;
    var ref4 = (0,react.useState)(days === null || days === void 0 ? void 0 : days.map(function(day) {
        var ref;
        return {
            pickupDate: day,
            pickupTime: (ref3 = eventCollection === null || eventCollection === void 0 ? void 0 : (ref = eventCollection.pickupTime) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                var options = param.options;
                return values_Date/* DateTime.formatDate */.o.formatDate(options.time) === day;
            }).map(function(param) {
                var options = param.options;
                return {
                    options: {
                        time: (ref2 = values_Date/* DateTime.formatDate */.o.formatDate(options.time, "HH:mm")) !== null && ref2 !== void 0 ? ref2 : "",
                        availableUserNumber: (_availableUserNumber = options.availableUserNumber) !== null && _availableUserNumber !== void 0 ? _availableUserNumber : 0,
                        currentUserNumber: (_currentUserNumber = options.currentUserNumber) !== null && _currentUserNumber !== void 0 ? _currentUserNumber : 0
                    }
                };
            })) !== null && ref3 !== void 0 ? ref3 : []
        };
    })), pickupTimes = ref4[0], setPickupTimes = ref4[1];
    (0,react.useEffect)(function() {
        reset({
            validMinutes: String((eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes) || ""),
            pickupLocation: (eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.pickupLocation) || "",
            purchaseLimitPerPickup: (eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup) || undefined
        });
    }, [
        eventCollection
    ]);
    var onHandleSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                                pickupTimes: pickupTimes
                            })).catch(function(errors) {
                                showError(errors);
                                if ((0,_instanceof/* default */.Z)(errors, client_errors/* ApolloError */.cA)) {
                                    var path;
                                    var pickupTimeErrs = [];
                                    errors.graphQLErrors.forEach(function(param) {
                                        var extensions = param.extensions;
                                        var ref, ref1;
                                        extensions === null || extensions === void 0 ? void 0 : (ref = extensions.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(param) {
                                            var errorCode = param.errorCode, userMessage = param.userMessage, pickupTime = param.pickupTime;
                                            switch(errorCode){
                                                case "INVALID_VALID_MINUTES":
                                                    setError("validMinutes", {
                                                        message: userMessage
                                                    });
                                                    break;
                                                case "INVALID_DATE":
                                                    path = getPickupTimePath(pickupTime, pickupTimes);
                                                    if (path) {
                                                        set_default()(pickupTimeErrs, path, userMessage);
                                                    }
                                                    break;
                                                default:
                                            }
                                        });
                                    });
                                    setPickupTimeErrors(pickupTimeErrs);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupLocationInputCell, {
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "text"
                }, register("pickupLocation")),
                error: errors.pickupLocation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseLimitInputCellInputCell, {
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "tel"
                }, register("purchaseLimitPerPickup")),
                error: errors.purchaseLimitPerPickup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketValidMinutesInputCell, {
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number"
                }, register("validMinutes")),
                error: errors.validMinutes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupTimesEditForm, {
                pickupTimes: pickupTimes,
                setPickupTimes: setPickupTimes,
                days: days,
                pickupTimeErrors: pickupTimeErrors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    py: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    onClick: onHandleSubmit,
                    loading: submitting,
                    disabled: submitting || !days.length,
                    sx: {
                        width: 212
                    },
                    children: t("register")
                })
            })
        ]
    });
};
var PickupLocationInputCell = function(param) {
    var inputProps = param.inputProps, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 4,
            pb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputProps), {
                textFieldProps: {
                    placeholder: t("pickupLocationPlaceHolder"),
                    helperText: undefined,
                    sx: {
                        mb: 0
                    }
                }
            })),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};
var PurchaseLimitInputCellInputCell = function(param) {
    var inputProps = param.inputProps, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 4,
            pb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("purchaseLimitPerPickup", "受け渡し商品数の上限")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 1,
                    color: "text.secondary"
                },
                children: t("purchaseLimitPerPickupNote", "ユーザーは受け取りごとにこの上限を超えて商品を購入できなくなります。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputProps), {
                        textFieldProps: {
                            placeholder: t("purchaseLimitPerPickupPlaceHolder"),
                            sx: {
                                minWidth: 90,
                                width: 90,
                                mb: 0
                            },
                            helperText: undefined
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 2
                        },
                        children: t("piece")
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};
var TicketValidMinutesInputCell = function(param) {
    var inputProps = param.inputProps, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("validMinutes", "受け渡しの有効時間")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 1,
                    color: "text.secondary"
                },
                children: t("validMinutesNote", "受け渡し時間を設定すれば、購入者は設定時間外で受け取り時間を指定できなくなります。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputProps), {
                        textFieldProps: {
                            placeholder: "30",
                            sx: {
                                minWidth: 90,
                                width: 90,
                                mb: 0
                            },
                            helperText: undefined
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 2
                        },
                        children: t("point", "分")
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};
var EventCollectionReceiveTimeEditForm_defaultValues = {
    validMinutes: "",
    pickupLocation: ""
};
function getPickupTimePath(pickupTime, pickupTimes) {
    var ref;
    var inputPickupTime = dayjs_min_default()(pickupTime);
    var indexPickupDate = pickupTimes.findIndex(function(p) {
        return p.pickupDate === inputPickupTime.format("YYYY/MM/DD");
    });
    if (indexPickupDate < 0) {
        return "";
    }
    var indexPickupTime = (ref = pickupTimes[indexPickupDate].pickupTime) === null || ref === void 0 ? void 0 : ref.findIndex(function(p) {
        return p.options.time === inputPickupTime.format("HH:mm");
    });
    if (indexPickupTime < 0) {
        return "";
    }
    return "".concat(indexPickupDate, ".pickupTime.").concat(indexPickupTime, ".options.time");
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/index.tsx








var ConsoleEventCollectionReceiveTimeEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                back: true,
                title: (ref = state.eventCollection) === null || ref === void 0 ? void 0 : ref.collection.title,
                defaultBackPage: generatePath(routerPages.ConsoleShokufesEventDetail, {
                    eventId: state.eventId
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventCollectionReceiveTimeEdit_template_HeadingTextCell, {}),
                !state.loading && state.days && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCollectionReceiveTimeEditForm, {
                    eventCollection: state.eventCollection,
                    days: state.days,
                    onSubmit: onSubmit,
                    submitting: state.submitting,
                    maxValidMinutes: state.maxValidMinutes
                })
            ]
        })
    });
};
var ConsoleEventCollectionReceiveTimeEdit_template_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            mt: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            children: t("editDeliveryTime")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/viewModel.ts




function ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleEventCollectionReceiveTimeEdit(\n    $eventId: ID!\n    $collectionId: ID!\n  ) {\n    event(id: $eventId) {\n      ...EventBox\n    }\n    collection(id: $collectionId) {\n      id\n      title\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateEventCollectionPickupTime(\n    $inputs: UpdateEventCollectionPickupTimeInput!\n  ) {\n    updateEventCollectionPickupTime(inputs: $inputs) {\n      ...EventCollectionBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





/**
 *
 */ var ConsoleEventCollectionReceiveTimeEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCollectionReceiveTimeEdit").t;
    var ref3 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref3.showError, showMessage = ref3.showMessage;
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleEventCollectionReceiveTimeEdit_viewModel_QUERY, {
        variables: {
            eventId: router.query.eventId,
            collectionId: router.query.collectionId
        }
    }), data = ref4.data, loading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_EVENT_COLLECTION_PICKUP_TIME), 2), updateEventCollectionPickupTime = ref5[0], ref6 = ref5[1], submitting = ref6.loading;
    var eventCollection = (ref = data === null || data === void 0 ? void 0 : data.event.eventCollections.edges.find(function(param) {
        var node = param.node;
        return node.id === router.query.collectionId;
    })) === null || ref === void 0 ? void 0 : ref.node;
    var ref7, ref8;
    return {
        state: {
            days: (ref7 = data === null || data === void 0 ? void 0 : (ref1 = data.event) === null || ref1 === void 0 ? void 0 : ref1.dateArray) !== null && ref7 !== void 0 ? ref7 : [],
            eventCollection: eventCollection,
            loading: loading,
            submitting: submitting,
            eventId: router.query.eventId,
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            maxValidMinutes: dayjs_min_default()(data === null || data === void 0 ? void 0 : data.event.endedAt).diff(data === null || data === void 0 ? void 0 : data.event.startedAt, "minute") || 0
        },
        actions: {
            onSubmit: function onSubmit(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var flatMappedPickupTime, pickupTime;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                flatMappedPickupTime = inputs.pickupTimes.flatMap(function(item) {
                                    return item.pickupTime.map(function(timeItem) {
                                        return {
                                            options: timeItem.options,
                                            date: item.pickupDate
                                        };
                                    });
                                }).filter(function(item) {
                                    return !!item.options.time || !!item.options.availableUserNumber;
                                });
                                // 入力値をチェックし、無効なものがあればエラーを表示してreturn
                                if (flatMappedPickupTime.some(function(item) {
                                    return !item.options.time.match(/^([01][0-9]|2[0-3]):([0-5][0-9])$/) || !item.options.availableUserNumber || item.options.availableUserNumber <= 0;
                                })) {
                                    showError(t("submitError"));
                                    return [
                                        2
                                    ];
                                }
                                pickupTime = flatMappedPickupTime.sort(function(a, b) {
                                    var aTimestamp = new Date("".concat(a.date, " ").concat(a.options.time)).getTime();
                                    var bTimestamp = new Date("".concat(b.date, " ").concat(b.options.time)).getTime();
                                    return aTimestamp - bTimestamp;
                                }).map(function(item) {
                                    return {
                                        options: {
                                            time: new Date("".concat(item.date, " ").concat(item.options.time)),
                                            availableUserNumber: item.options.availableUserNumber
                                        }
                                    };
                                });
                                return [
                                    4,
                                    updateEventCollectionPickupTime({
                                        variables: {
                                            inputs: {
                                                validMinutes: Number(inputs.validMinutes),
                                                collectionId: router.query.collectionId,
                                                eventId: router.query.eventId,
                                                pickupTime: pickupTime,
                                                pickupLocation: inputs.pickupLocation,
                                                purchaseLimitPerPickup: inputs.purchaseLimitPerPickup ? inputs.purchaseLimitPerPickup : undefined
                                            }
                                        }
                                    }).then(function() {
                                        showMessage(t("submitSuccess"));
                                        router.goBack(generatePath(routerPages.ConsoleShokufesEventDetail, {
                                            eventId: router.query.eventId
                                        }));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleEventCollectionReceiveTimeEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject(), utoniq_core_schema/* EventBoxFragmentDoc */.VTs);
var UPDATE_EVENT_COLLECTION_PICKUP_TIME = (0,lib/* gql */.Ps)(ConsoleEventCollectionReceiveTimeEdit_viewModel_templateObject1(), utoniq_core_schema/* EventCollectionBoxFragmentDoc */.NLe);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCollectionReceiveTimeEdit/index.tsx




/**
 * ConsoleEventCollectionReceiveTimeEdit Page
 * Implemented as a practical sample.
 */ var ConsoleEventCollectionReceiveTimeEdit = function() {
    var ref = ConsoleEventCollectionReceiveTimeEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventCollectionReceiveTimeEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/FixedButtonArea.tsx








var FixedButtonArea = function(param) {
    var mode = param.mode, method = param.method, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    var ref1 = (0,react.useState)(false), openCancel = ref1[0], setOpenCancel = ref1[1];
    var _formState = method.formState, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, isDirty = _formState.isDirty, handleSubmit = method.handleSubmit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                py: 4,
                spacing: 2,
                alignItems: "center",
                sx: {
                    bgcolor: "grey.50"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        color: "primary",
                        sx: {
                            width: 244
                        },
                        onClick: handleSubmit(function() {
                            return setOpenConfirm(true);
                        }),
                        disabled: !isValid || isSubmitting,
                        children: t(mode)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "medium",
                        variant: "text",
                        color: "primary",
                        sx: {
                            width: 244
                        },
                        onClick: function() {
                            if (isDirty) {
                                return setOpenCancel(true);
                            }
                            router.goBack();
                        },
                        children: t("cancel", "キャンセル")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("".concat(mode, "EventModalTitle")),
                content: t("".concat(mode, "EventModalDesc")),
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    onClick: handleSubmit(function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    onSubmit(values).finally(function() {
                                        return setOpenConfirm(false);
                                    })
                                ];
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }()),
                    sx: {
                        minWidth: 212
                    },
                    loading: isSubmitting,
                    children: t("".concat(mode, "EventBtn"))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("".concat(mode, "CancelCreateEventModalTitle")),
                content: t("".concat(mode, "CancelCreateEventModalDesc")),
                open: openCancel,
                onClose: function() {
                    return setOpenCancel(false);
                },
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    onClick: function() {
                        showMessage(t("".concat(mode, "CancelCreateEventSuccess")), "success");
                        router.goBack();
                    },
                    sx: {
                        minWidth: 212
                    },
                    children: t("".concat(mode, "CancelCreateEventBtn"))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/ThumbnailUploadCell.tsx








var ThumbnailUploadCell = function(param) {
    var watch = param.watch, setValue = param.setValue, fileUploadInfo = param.fileUploadInfo, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                sx: {
                    p: 0
                },
                shape: "collection",
                resource: watch("thumbnailResource"),
                t: t,
                requireLabel: {
                    display: true
                },
                fileUploadInfo: {
                    type: "image",
                    onDrop: function onDrop() {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            var resource;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            fileUploadInfo.onDrop()
                                        ];
                                    case 1:
                                        resource = _state.sent();
                                        if (!resource) {
                                            return [
                                                2
                                            ];
                                        }
                                        setValue("thumbnailPath", resource.imageUploadPath, {
                                            shouldValidate: true
                                        });
                                        setValue("thumbnailResource", (0,src_object_spread/* default */.Z)({}, resource), {
                                            shouldValidate: true
                                        });
                                        return [
                                            2,
                                            resource
                                        ];
                                }
                            });
                        })();
                    },
                    progress: fileUploadInfo.progress || 0,
                    description: t("thumbnailUploaderDescription"),
                    onClose: function onClose() {
                        setValue("thumbnailResource", null, {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                        setValue("thumbnailPath", "", {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                    }
                },
                content: {
                    title: t("thumbnailUploaderTitle")
                }
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/Commons.tsx








var Commons_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread/* default */.Z)({
                display: "flex",
                alignItems: "center",
                variant: "h5",
                color: "text.primary"
            }, titleProps),
            textFieldProps: textFieldProps,
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});
var Commons_ToggleInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var sx = _param.sx, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            inputRef: ref,
            sx: (0,src_object_spread/* default */.Z)({
                px: 0,
                pt: 0,
                "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                    bgcolor: "primary.main"
                }
            }, sx)
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/EventInputDateCell.tsx








var EventInputDateCell = function(param) {
    var setValue = param.setValue, errors = param.errors, control = param.control, watch = param.watch, startedAt = param.startedAt, endedAt = param.endedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var ref = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        keyName: "_id",
        name: "closeDate"
    }), fields = ref.fields, append = ref.append, onRemove = ref.remove;
    var disableCloseDate = (0,react.useMemo)(function() {
        if (!startedAt && !endedAt) {
            return true;
        }
        if (startedAt && endedAt) {
            return Math.abs(dayjs_min_default()(startedAt).diff(endedAt, "d", true)) < 2;
        }
        return false;
    }, [
        endedAt,
        startedAt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                pb: 2,
                children: t("date", "開催日")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                onChange: function(date) {
                    setValue("startedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                value: startedAt ? dayjs_min_default()(startedAt) : null,
                title: t("eventStartedAtTitle"),
                placeholder: t("eventStartedAtPlaceholder"),
                error: errors === null || errors === void 0 ? void 0 : errors.startedAt,
                titleProps: {
                    variant: "subtitle1",
                    color: "text.primary"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                onChange: function(date) {
                    setValue("endedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                value: endedAt ? dayjs_min_default()(endedAt) : null,
                title: t("eventEndedAtTitle"),
                placeholder: t("eventEndedAtPlaceholder"),
                error: errors === null || errors === void 0 ? void 0 : errors.startedAt,
                titleProps: {
                    variant: "subtitle1",
                    color: "text.primary"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("eventCloseDateTitle", "休業日")
                    }),
                    fields.map(function(field, index) {
                        var ref, ref1;
                        var closeDate = watch("closeDate.".concat(index, ".date"));
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DatePickerField, {
                                        onChange: function(date) {
                                            setValue("closeDate.".concat(index, ".date"), date, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        },
                                        minDate: startedAt ? dayjs_min_default()(startedAt).add(1, "d") : undefined,
                                        maxDate: endedAt ? dayjs_min_default()(endedAt).subtract(1, "d") : undefined,
                                        value: closeDate ? dayjs_min_default()(closeDate) : null,
                                        textFieldProps: {
                                            inputProps: {
                                                value: closeDate ? dayjs_min_default()(closeDate).format("YYYY/MM/DD") : ""
                                            }
                                        },
                                        placeholder: t("eventCloseDatePlaceholder"),
                                        error: errors === null || errors === void 0 ? void 0 : (ref = errors.closeDate) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.date,
                                        titleProps: {
                                            variant: "subtitle1",
                                            color: "text.primary"
                                        }
                                    })
                                }),
                                (!disableCloseDate || closeDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    alignItems: "center",
                                    mb: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: function() {
                                            return onRemove(index);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {})
                                    })
                                })
                            ]
                        }, field._id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "small",
                            disabled: disableCloseDate,
                            onClick: function() {
                                return append({
                                    date: null
                                });
                            },
                            children: t("addCloseDate", "休業日を追加する")
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@react-google-maps/api/dist/esm.js
var api_dist_esm = __webpack_require__(17871);
;// CONCATENATED MODULE: ./src/components/organisms/functionals/GpsMap/index.tsx










var TOKYO_LOCATION = {
    lat: 35.652832,
    lng: 139.839478
};
var GpsMap = function(_param) {
    var targetData = _param.targetData, currentData = _param.currentData, pinData = _param.pinData, _mapContainerStyle = _param.mapContainerStyle, mapContainerStyle = _mapContainerStyle === void 0 ? {
        height: "100%",
        width: "100%"
    } : _mapContainerStyle, offset = _param.offset, props = (0,_object_without_properties/* default */.Z)(_param, [
        "targetData",
        "currentData",
        "pinData",
        "mapContainerStyle",
        "offset"
    ]);
    var libraries = (0,react.useRef)([
        "places"
    ]);
    var mapInstanceRef = (0,react.useRef)();
    var isLoaded = (0,api_dist_esm/* useJsApiLoader */.Ji)({
        id: "google-map-script",
        googleMapsApiKey: config_config/* config.googleMapApiKey */.v.googleMapApiKey,
        libraries: libraries.current
    }).isLoaded;
    if (!isLoaded) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        sx: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GoogleMapStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                mapContainerStyle: mapContainerStyle,
                options: {
                    fullscreenControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    streetViewControl: false
                },
                zoom: 14
            }, props), {
                onLoad: function(mapInstance) {
                    /**
           * @hack
           * ズーム初期値の設定
           * zoom propsだけでは正しく初期化されないため、読み込み開始後に少し経ってからに設定する
           */ setTimeout(function() {
                        mapInstance === null || mapInstance === void 0 ? void 0 : mapInstance.setZoom(14);
                    }, 150);
                    // default move to tokyo
                    mapInstance.panTo(new google.maps.LatLng(TOKYO_LOCATION.lat, TOKYO_LOCATION.lng));
                    var bounds = new google.maps.LatLngBounds();
                    [
                        targetData,
                        currentData
                    ].forEach(function(data) {
                        if ((data === null || data === void 0 ? void 0 : data.latitude) && (data === null || data === void 0 ? void 0 : data.longitude)) {
                            var latLng = new google.maps.LatLng({
                                lat: data.latitude,
                                lng: data.longitude
                            });
                            bounds.extend(latLng);
                            var radius = get_default()(data, "radius");
                            if (radius) {
                                var centerCircle = new google.maps.Circle({
                                    center: latLng,
                                    radius: radius
                                });
                                if (centerCircle.getBounds()) {
                                    bounds.union(centerCircle.getBounds());
                                }
                            }
                        }
                    });
                    if ([
                        targetData,
                        currentData
                    ].some(function(data) {
                        return (data === null || data === void 0 ? void 0 : data.latitude) && (data === null || data === void 0 ? void 0 : data.longitude);
                    })) {
                        mapInstance.fitBounds(bounds);
                    }
                    mapInstanceRef.current = mapInstance;
                    props.onLoad && props.onLoad(mapInstance);
                },
                children: [
                    (targetData === null || targetData === void 0 ? void 0 : targetData.latitude) && targetData.longitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(Target, (0,src_object_spread/* default */.Z)({}, targetData)),
                    (currentData === null || currentData === void 0 ? void 0 : currentData.latitude) && currentData.longitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(Current, (0,src_object_spread/* default */.Z)({}, currentData)),
                    (pinData === null || pinData === void 0 ? void 0 : pinData.latitude) && pinData.longitude && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, (0,src_object_spread/* default */.Z)({}, pinData))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    position: "absolute",
                    right: 12,
                    bottom: 12 + (offset !== null && offset !== void 0 ? offset : 0)
                },
                children: [
                    (targetData === null || targetData === void 0 ? void 0 : targetData.latitude) && (targetData === null || targetData === void 0 ? void 0 : targetData.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Spot, {
                        size: "medium",
                        bgcolor: "grey.50",
                        color: "grey.600",
                        onClick: function() {
                            var ref;
                            var _latitude, _longitude;
                            (ref = mapInstanceRef.current) === null || ref === void 0 ? void 0 : ref.panTo({
                                lat: (_latitude = targetData.latitude) !== null && _latitude !== void 0 ? _latitude : 0,
                                lng: (_longitude = targetData.longitude) !== null && _longitude !== void 0 ? _longitude : 0
                            });
                        }
                    }),
                    (currentData === null || currentData === void 0 ? void 0 : currentData.latitude) && (currentData === null || currentData === void 0 ? void 0 : currentData.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Direction, {
                        size: "medium",
                        bgcolor: "grey.50",
                        color: "grey.600",
                        onClick: function() {
                            var ref;
                            var _latitude, _longitude;
                            (ref = mapInstanceRef.current) === null || ref === void 0 ? void 0 : ref.panTo({
                                lat: (_latitude = currentData.latitude) !== null && _latitude !== void 0 ? _latitude : 0,
                                lng: (_longitude = currentData.longitude) !== null && _longitude !== void 0 ? _longitude : 0
                            });
                        }
                    })
                ]
            })
        ]
    });
};
var Target = function(param) {
    var latitude = param.latitude, longitude = param.longitude, radius = param.radius;
    var palette = (0,useTheme/* default */.Z)().palette;
    var defaultCircleOptions = {
        strokeColor: palette.info.dark,
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: palette.info.light,
        fillOpacity: 0.5,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
        zIndex: 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* Marker */.Jx, {
                icon: {
                    path: "M20 2C12.26 2 6 8.26 6 16c0 10.5 14 22 14 22s14-11.5 14-22c0-7.74-6.26-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
                    scale: 0.7,
                    fillColor: palette.primary.dark,
                    fillOpacity: 1,
                    strokeWeight: 0,
                    anchor: new google.maps.Point(20, 40)
                },
                zIndex: 2,
                clickable: false,
                position: {
                    lat: latitude,
                    lng: longitude
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* Circle */.Cd, {
                center: {
                    lat: latitude,
                    lng: longitude
                },
                radius: radius !== null && radius !== void 0 ? radius : 100,
                options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, defaultCircleOptions), {
                    radius: radius
                })
            })
        ]
    });
};
var Current = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    if (!latitude || !longitude) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* OverlayView */.xT, {
        mapPaneName: "markerLayer",
        position: {
            lat: latitude,
            lng: longitude
        },
        getPixelPositionOffset: function() {
            return {
                x: -12,
                y: -12
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.CurrentLocation, {})
    });
};
var Pin = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var palette = (0,useTheme/* default */.Z)().palette;
    if (!latitude || !longitude) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(api_dist_esm/* Marker */.Jx, {
        icon: {
            path: "M20 2C12.26 2 6 8.26 6 16c0 10.5 14 22 14 22s14-11.5 14-22c0-7.74-6.26-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
            scale: 0.7,
            fillColor: palette.primary.main,
            fillOpacity: 1,
            strokeWeight: 0,
            anchor: new google.maps.Point(20, 40)
        },
        position: {
            lat: latitude,
            lng: longitude
        }
    });
};
var GoogleMapStyled = (0,styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(api_dist_esm/* GoogleMap */.b6, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        mapContainerClassName: className
    }));
})({
    ".gm-style .gm-style-iw-a": {
        display: "none"
    }
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/AutocompleteForm.tsx











var AutocompleteForm_schema = function(o) {
    return {
        keyword: o.string()
    };
};
var AutocompleteForm = function(param) {
    var onSubmit = param.onSubmit, onGoBack = param.onGoBack;
    var ref = (0,core_form/* useForm */.cI)({
        schema: AutocompleteForm_schema,
        defaultValues: AutocompleteForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(onSubmit), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteForm_SearchInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("keyword")), {
            onChange: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setValue("keyword", event.target.value);
                                return [
                                    4,
                                    handleChangeKeywordDebounce.current()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            textFieldProps: {
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "start",
                        onClick: onGoBack,
                        sx: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Back, {
                            fontSize: "small",
                            sx: {
                                color: "grey.700"
                            }
                        })
                    })
                }
            }
        }))
    });
};
var AutocompleteForm_SearchInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissions").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SearchInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var AutocompleteForm_defaultValues = {
    keyword: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/GPSMapModal.tsx











var GPSMapModal = function(param) {
    var artistId = param.artistId, open = param.open, onClose = param.onClose, onSearch = param.onSearch, predictions = param.predictions, place = param.place, onSelectPlace = param.onSelectPlace, onSpecify = param.onSpecify, currentData = param.currentData;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var gpsMapRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)(), selectedPrediction = ref1[0], setSelectedPrediction = ref1[1];
    var pinData = (0,react.useMemo)(function() {
        if (!(place === null || place === void 0 ? void 0 : place.location.lat) || !(place === null || place === void 0 ? void 0 : place.location.lng)) {
            return undefined;
        }
        return {
            latitude: place.location.lat,
            longitude: place.location.lng
        };
    }, [
        place === null || place === void 0 ? void 0 : place.location
    ]);
    var handleMapLoad = (0,react.useCallback)(function(mapInstance) {
        var ref, ref1;
        if ((place === null || place === void 0 ? void 0 : (ref = place.location) === null || ref === void 0 ? void 0 : ref.lat) && (place === null || place === void 0 ? void 0 : (ref1 = place.location) === null || ref1 === void 0 ? void 0 : ref1.lng)) {
            mapInstance === null || mapInstance === void 0 ? void 0 : mapInstance.panTo(new google.maps.LatLng(place.location.lat, place.location.lng));
            return;
        }
        if ((currentData === null || currentData === void 0 ? void 0 : currentData.latitude) && (currentData === null || currentData === void 0 ? void 0 : currentData.longitude)) {
            mapInstance === null || mapInstance === void 0 ? void 0 : mapInstance.panTo(new google.maps.LatLng(currentData.latitude, currentData.longitude));
        }
    }, [
        currentData,
        place
    ]);
    (0,react.useEffect)(function() {
        handleMapLoad(gpsMapRef.current);
    }, [
        open,
        handleMapLoad
    ]);
    var handleClick = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!event.placeId || !gpsMapRef.current) {
                            return [
                                2
                            ];
                        }
                        setSelectedPrediction(undefined);
                        return [
                            4,
                            onSelectPlace({
                                placeId: event.placeId,
                                map: gpsMapRef.current
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSelectPlace
    ]);
    var _lat, _lng, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        sx: {
            zIndex: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            sx: {
                height: "100dvh"
            },
            header: {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                    edge: "start",
                    size: "medium",
                    sx: {
                        ".MuiSvgIcon-root svg": {
                            color: "white"
                        }
                    },
                    onClick: function() {
                        onClose();
                        setCurrentStep(0);
                    }
                }),
                title: t("positionRaisePin")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        height: "100%",
                        display: currentStep === 0 ? "flex" : "none",
                        transition: "display 300ms ease-in-out"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            sx: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMap, {
                                    currentData: currentData,
                                    onLoad: function(map) {
                                        gpsMapRef.current = map;
                                        handleMapLoad(map);
                                    },
                                    pinData: pinData,
                                    onClick: handleClick
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        top: "32px",
                                        right: 0,
                                        left: 0
                                    },
                                    onClick: function() {
                                        return setCurrentStep(1);
                                    },
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        color: "inherit",
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Search, {
                                            sx: {
                                                color: "grey.700"
                                            }
                                        }),
                                        sx: {
                                            width: 335,
                                            height: 40,
                                            bgcolor: "grey.50"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.secondary",
                                            sx: {
                                                width: "100%",
                                                pl: 2
                                            },
                                            align: "left",
                                            children: t("search")
                                        })
                                    })
                                })
                            ]
                        }),
                        (selectedPrediction || place) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressAreaCell, {
                                prediction: selectedPrediction,
                                place: place,
                                onSpecify: function() {
                                    return onSpecify({
                                        latitude: (_lat = place === null || place === void 0 ? void 0 : place.location.lat) !== null && _lat !== void 0 ? _lat : 0,
                                        longitude: (_lng = place === null || place === void 0 ? void 0 : place.location.lng) !== null && _lng !== void 0 ? _lng : 0,
                                        formattedAddress: (ref2 = place === null || place === void 0 ? void 0 : place.formattedAddress) !== null && ref2 !== void 0 ? ref2 : ""
                                    });
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        height: "100%",
                        display: currentStep === 1 ? "flex" : "none",
                        transition: "display 300ms ease-in-out"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteForm, {
                            onSubmit: onSearch,
                            onGoBack: function() {
                                return setCurrentStep(0);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddressListCell, {
                            predictions: predictions,
                            onSelect: function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(prediction) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!gpsMapRef.current) {
                                                    return [
                                                        2
                                                    ];
                                                }
                                                setSelectedPrediction(undefined);
                                                return [
                                                    4,
                                                    onSelectPlace({
                                                        placeId: prediction.placeId,
                                                        map: gpsMapRef.current
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                setSelectedPrediction(prediction);
                                                setCurrentStep(0);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(prediction) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        })
                    ]
                })
            ]
        })
    });
};
var AddressAreaCell = function(param) {
    var prediction = param.prediction, place = param.place, onSpecify = param.onSpecify;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var addressTitle = prediction ? prediction.mainText : place === null || place === void 0 ? void 0 : place.name;
    var addressDesc = prediction ? prediction.secondaryText : place === null || place === void 0 ? void 0 : place.formattedAddress;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                children: addressTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: addressDesc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    pt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    onClick: onSpecify,
                    children: t("specify")
                })
            })
        ]
    });
};
var SearchAddressListCell = function(param) {
    var predictions = param.predictions, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
            children: predictions.map(function(prediction) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                    component: Box_Box/* default */.Z,
                    divider: true,
                    onClick: function() {
                        return onSelect(prediction);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                            primary: prediction.mainText,
                            secondary: prediction.secondaryText,
                            slotProps: {
                                primary: {
                                    variant: "body2"
                                },
                                secondary: {
                                    variant: "caption",
                                    color: "text.secondary"
                                }
                            }
                        })
                    ]
                }, prediction.placeId);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/EventInputLocationCell.tsx









var EventInputLocationCell = function(param) {
    var artistId = param.artistId, location = param.location, inputApproximateAddress = param.inputApproximateAddress, inputMapUri = param.inputMapUri, setValue = param.setValue, gpsClientInfo = param.gpsClientInfo, place = param.place, predictions = param.predictions, onRequestGPSPermission = param.onRequestGPSPermission, onSelectPlace = param.onSelectPlace, onPlaceSearch = param.onPlaceSearch;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var ref1 = (0,react.useState)(false), openGPSMapModal = ref1[0], setOpenGPSMapModal = ref1[1];
    var currentPlace = (0,react.useMemo)(function() {
        if (place) {
            return place;
        }
        if ((location === null || location === void 0 ? void 0 : location.latitude) && (location === null || location === void 0 ? void 0 : location.longitude)) {
            var _approximateAddress;
            return {
                formattedAddress: (_approximateAddress = location.approximateAddress) !== null && _approximateAddress !== void 0 ? _approximateAddress : "",
                location: {
                    lat: location.latitude,
                    lng: location.longitude
                }
            };
        }
        return null;
    }, [
        location === null || location === void 0 ? void 0 : location.approximateAddress,
        location === null || location === void 0 ? void 0 : location.latitude,
        location === null || location === void 0 ? void 0 : location.longitude,
        place, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                pb: 2,
                children: t("location", "会場")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        pb: 1,
                        children: t("approximateAddressLabel", "地図の設定")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text"
                    }, inputApproximateAddress), {
                        titleProps: {
                            variant: "body2",
                            color: "text.secondary"
                        },
                        textFieldProps: {
                            helperText: inputApproximateAddress === null || inputApproximateAddress === void 0 ? void 0 : (ref = inputApproximateAddress.error) === null || ref === void 0 ? void 0 : ref.message,
                            InputProps: {
                                readOnly: !((location === null || location === void 0 ? void 0 : location.longitude) && (location === null || location === void 0 ? void 0 : location.latitude)),
                                inputProps: {
                                    sx: {
                                        px: 4,
                                        py: 3
                                    }
                                }
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "small",
                            onClick: function() {
                                onRequestGPSPermission();
                                setOpenGPSMapModal(true);
                            },
                            children: t("set", "設定する")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                pt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        pb: 1,
                        children: t("mapUriLabel", "会場MAP")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text"
                    }, inputMapUri), {
                        titleProps: {
                            variant: "body2",
                            color: "text.secondary"
                        }
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GPSMapModal, {
                artistId: artistId,
                currentData: gpsClientInfo === null || gpsClientInfo === void 0 ? void 0 : gpsClientInfo.currentLocation,
                onSearch: onPlaceSearch,
                predictions: predictions,
                onSelectPlace: onSelectPlace,
                place: currentPlace,
                open: openGPSMapModal,
                onSpecify: function(param) {
                    var latitude = param.latitude, longitude = param.longitude, formattedAddress = param.formattedAddress;
                    setValue("location.approximateAddress", formattedAddress, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                    setValue("location.latitude", latitude, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                    setValue("location.longitude", longitude, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                    setOpenGPSMapModal(false);
                },
                onClose: function() {
                    return setOpenGPSMapModal(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/components/EventPublishDateCell.tsx





var EventPublishDateCell = function(param) {
    var watch = param.watch, setValue = param.setValue, errors = param.errors, trigger = param.trigger;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pb: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("publishStartedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        trigger("publishEndedAt");
                    },
                    value: watch("publishStartedAt") ? dayjs_min_default()(watch("publishStartedAt")) : null,
                    placeholder: t("publishStartAtPlaceholder"),
                    error: errors[0],
                    title: t("publishStartAtLabel"),
                    titleProps: {
                        variant: "subtitle1",
                        color: "text.primary"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("publishEndedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: watch("publishEndedAt") ? dayjs_min_default()(watch("publishEndedAt")) : null,
                    placeholder: t("publishEndAtPlaceholder"),
                    error: errors[1],
                    title: t("publishEndAtLabel"),
                    titleProps: {
                        variant: "subtitle1",
                        color: "text.primary"
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/EventCreateForm.tsx









var EventCreateForm_schema = function(o) {
    return {
        title: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleEventCreate.title")),
        description: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleEventCreate.description")),
        startedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.startedAt")),
        endedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.endedAt")),
        closeDate: o.array().items({
            //id of field array
            _id: o.string().optional(),
            date: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.closeDate"))
        }).allow(null).optional(),
        location: o.object({
            latitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.latitude")),
            longitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.longitude")),
            approximateAddress: o.string().when("latitude", {
                is: 0,
                then: o.string().when("mapUri", {
                    is: o.string().exist(),
                    then: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.approximateAddress")),
                    otherwise: o.string().max(50).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.approximateAddress"))
                }),
                otherwise: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.approximateAddress"))
            }),
            mapUri: o.string().when("latitude", {
                is: 0,
                then: o.string().uri().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.mapUri")),
                otherwise: o.string().uri().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.location.mapUri"))
            })
        }).allow(null).optional(),
        thumbnailPath: o.string().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.thumbnailPath")),
        note: o.string().max(1000).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventCreate.note")),
        thumbnailResource: o.object().allow(null).optional(),
        isPublished: o.boolean(),
        publishStartedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventCreate.publishStartedAt")),
        publishEndedAt: o.date().allow(null, "").optional().custom(function(value, helpers) {
            var ref;
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            if (!value) {
                return value;
            }
            var publishStartedAt = (data === null || data === void 0 ? void 0 : data.publishStartedAt) || new Date();
            if (publishStartedAt > value) {
                // 開始日が終了日を過ぎていたらエラー
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleEventCreate.publishEndedAt.custom.over")
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleEventCreate.publishEndedAt"))
    };
};
var EventCreateForm = function(_param) {
    var artistId = _param.artistId, method = _param.method, fileUploadInfo = _param.fileUploadInfo, gpsModalProps = (0,_object_without_properties/* default */.Z)(_param, [
        "artistId",
        "method",
        "fileUploadInfo"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var watch = method.watch, setValue = method.setValue, control = method.control, register = method.register, errors = method.formState.errors, trigger = method.trigger;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailUploadCell, {
                watch: watch,
                setValue: setValue,
                error: errors === null || errors === void 0 ? void 0 : errors.thumbnailPath,
                fileUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title,
                displayRequire: {
                    display: true
                },
                displayCount: {
                    display: true,
                    count: (ref = watch("title")) === null || ref === void 0 ? void 0 : ref.length,
                    limit: 100
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("description")), {
                error: errors === null || errors === void 0 ? void 0 : errors.description,
                displayRequire: {
                    display: true
                },
                displayCount: {
                    display: true,
                    count: (ref1 = watch("description")) === null || ref1 === void 0 ? void 0 : ref1.length,
                    limit: 1000
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("note")), {
                error: errors === null || errors === void 0 ? void 0 : errors.note,
                displayCount: {
                    display: true,
                    count: (ref2 = watch("note")) === null || ref2 === void 0 ? void 0 : ref2.length,
                    limit: 1000
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInputDateCell, {
                errors: errors,
                control: control,
                setValue: setValue,
                watch: watch,
                startedAt: watch("startedAt"),
                endedAt: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInputLocationCell, (0,src_object_spread/* default */.Z)({
                artistId: artistId,
                location: watch("location"),
                setValue: setValue,
                inputApproximateAddress: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("location.approximateAddress")), {
                    error: errors === null || errors === void 0 ? void 0 : (ref3 = errors.location) === null || ref3 === void 0 ? void 0 : ref3.approximateAddress
                }),
                inputMapUri: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("location.mapUri")), {
                    error: errors === null || errors === void 0 ? void 0 : (ref4 = errors.location) === null || ref4 === void 0 ? void 0 : ref4.mapUri
                })
            }, gpsModalProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("isPublishedDesc")
                    })
                }
            }, register("isPublished")), {
                checked: watch("isPublished")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPublishDateCell, {
                watch: watch,
                setValue: setValue,
                errors: [
                    errors.publishStartedAt,
                    errors.publishEndedAt,
                    errors.isPublished, 
                ],
                trigger: trigger
            })
        ]
    });
};
var EventCreateForm_defaultValues = {
    title: "",
    description: "",
    thumbnailPath: "",
    thumbnailResource: null,
    note: "",
    startedAt: null,
    endedAt: null,
    location: {
        latitude: 0,
        longitude: 0,
        approximateAddress: "",
        mapUri: ""
    },
    closeDate: [
        {
            date: null
        }
    ],
    isPublished: false,
    publishStartedAt: null,
    publishEndedAt: null
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/template/index.tsx











var ConsoleEventCreateTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit, onRequestGPSPermission = param.onRequestGPSPermission, onSelectPlace = param.onSelectPlace, onPlaceSearch = param.onPlaceSearch;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerNames = ref.routerNames;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref1 = (0,react.useState)(false), openCancel = ref1[0], setOpenCancel = ref1[1];
    var method = (0,core_form/* useForm */.cI)({
        schema: EventCreateForm_schema,
        defaultValues: EventCreateForm_defaultValues
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    color: "white",
                    onClick: function() {
                        if (method.formState.isDirty) {
                            return setOpenCancel(true);
                        }
                        router.goBack();
                    }
                }),
                title: t("title"),
                type: "modal"
            },
            customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedButtonArea, {
                mode: "create",
                method: method,
                onSubmit: onSubmit
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleShokufesEventCreate
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCreateForm, {
                    artistId: state.artistId,
                    method: method,
                    fileUploadInfo: {
                        progress: state.progress,
                        onDrop: onDrop
                    },
                    predictions: state.predictions,
                    place: state.place,
                    onSelectPlace: onSelectPlace,
                    onPlaceSearch: onPlaceSearch,
                    gpsClientInfo: state.gpsClientInfo,
                    onRequestGPSPermission: onRequestGPSPermission
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    title: t("createCancelCreateEventModalTitle"),
                    content: t("createCancelCreateEventModalDesc"),
                    open: openCancel,
                    onClose: function() {
                        return setOpenCancel(false);
                    },
                    cancelText: t("close"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        onClick: function() {
                            showMessage(t("cancelCreateEventSuccess"), "success");
                            router.goBack();
                        },
                        sx: {
                            minWidth: 212
                        },
                        children: t("createCancelCreateEventBtn")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/pick.js
var pick = __webpack_require__(13888);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventEdit/template/EventEditForm.tsx









var EventEditForm_schema = function(o) {
    return {
        title: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleEventEdit.title")),
        description: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleEventEdit.description")),
        startedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.startedAt")),
        endedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.endedAt")),
        closeDate: o.array().items({
            //id of field array
            _id: o.string().optional(),
            date: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.closeDate"))
        }).allow(null).optional(),
        location: o.object({
            latitude: o.number().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.latitude")),
            longitude: o.number().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.longitude")),
            approximateAddress: o.string().when("latitude", {
                is: 0,
                then: o.string().when("mapUri", {
                    is: o.string().exist(),
                    then: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.approximateAddress")),
                    otherwise: o.string().max(50).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.approximateAddress"))
                }),
                otherwise: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.approximateAddress"))
            }),
            mapUri: o.string().when("latitude", {
                is: 0,
                then: o.string().uri().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.mapUri")),
                otherwise: o.string().uri().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.location.mapUri"))
            })
        }).allow(null).optional(),
        thumbnailPath: o.string().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.thumbnailPath")),
        note: o.string().max(1000).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleEventEdit.note")),
        thumbnailResource: o.object().allow(null).optional(),
        isPublished: o.boolean(),
        publishStartedAt: o.date().allow(null, "").optional().label((0,core_form/* tLabel */.TQ)("consoleEventEdit.publishStartedAt")),
        publishEndedAt: o.date().allow(null, "").optional().custom(function(value, helpers) {
            var ref;
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            if (!value) {
                return value;
            }
            var publishStartedAt = (data === null || data === void 0 ? void 0 : data.publishStartedAt) || new Date();
            if (publishStartedAt > value) {
                // 開始日が終了日を過ぎていたらエラー
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleEventEdit.publishEndedAt.custom.over")
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleEventEdit.publishEndedAt"))
    };
};
var EventEditForm = function(_param) {
    var artistId = _param.artistId, method = _param.method, fileUploadInfo = _param.fileUploadInfo, gpsModalProps = (0,_object_without_properties/* default */.Z)(_param, [
        "artistId",
        "method",
        "fileUploadInfo"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventEdit").t;
    var watch = method.watch, setValue = method.setValue, control = method.control, register = method.register, trigger = method.trigger, errors = method.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailUploadCell, {
                watch: watch,
                setValue: setValue,
                error: errors === null || errors === void 0 ? void 0 : errors.thumbnailPath,
                fileUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title,
                displayRequire: {
                    display: true
                },
                displayCount: {
                    display: true,
                    count: (ref = watch("title")) === null || ref === void 0 ? void 0 : ref.length,
                    limit: 100
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("description")), {
                error: errors === null || errors === void 0 ? void 0 : errors.description,
                displayRequire: {
                    display: true
                },
                displayCount: {
                    display: true,
                    count: (ref1 = watch("description")) === null || ref1 === void 0 ? void 0 : ref1.length,
                    limit: 1000
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("note")), {
                error: errors === null || errors === void 0 ? void 0 : errors.note,
                displayCount: {
                    display: true,
                    count: (ref2 = watch("note")) === null || ref2 === void 0 ? void 0 : ref2.length,
                    limit: 1000
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInputDateCell, {
                errors: errors,
                control: control,
                setValue: setValue,
                watch: watch,
                startedAt: watch("startedAt"),
                endedAt: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInputLocationCell, (0,src_object_spread/* default */.Z)({
                artistId: artistId,
                location: watch("location"),
                setValue: setValue,
                inputApproximateAddress: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("location.approximateAddress")), {
                    error: errors === null || errors === void 0 ? void 0 : (ref3 = errors.location) === null || ref3 === void 0 ? void 0 : ref3.approximateAddress
                }),
                inputMapUri: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("location.mapUri")), {
                    error: errors === null || errors === void 0 ? void 0 : (ref4 = errors.location) === null || ref4 === void 0 ? void 0 : ref4.mapUri
                })
            }, gpsModalProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Commons_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("isPublishedDesc")
                    })
                }
            }, register("isPublished")), {
                checked: watch("isPublished")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPublishDateCell, {
                watch: watch,
                setValue: setValue,
                errors: [
                    errors.publishStartedAt,
                    errors.publishEndedAt
                ],
                trigger: trigger
            })
        ]
    });
};
var EventEditForm_defaultValues = {
    title: "",
    description: "",
    thumbnailPath: "",
    thumbnailResource: null,
    note: "",
    startedAt: null,
    endedAt: null,
    location: {
        latitude: 0,
        longitude: 0,
        approximateAddress: "",
        mapUri: ""
    },
    closeDate: [
        {
            date: null
        }
    ],
    isPublished: false,
    publishStartedAt: null,
    publishEndedAt: null
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventEdit/viewModel.ts







function ConsoleEventEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleEventEdit($id: ID!) {\n    event(id: $id) {\n      ...ConsoleEventEditDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleEventEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateEvent($id: ID!, $input: ArtistUpdateEventInput!) {\n    artistUpdateEvent(id: $id, inputs: $input) {\n      ...ConsoleEventDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









/**
 *
 */ var ConsoleEventEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventEdit").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1;
    var ref2 = useViewModelEvent((ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : ""), state = ref2.state, actions = ref2.actions;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleEventEdit_viewModel_QUERY, {
        variables: {
            id: router.query.eventId
        }
    }).data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UPDATE_EVENT), 2), artistUpdateEvent = ref3[0], ref4 = ref3[1], ref4 = ref4 !== null ? ref4 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref5, ref6;
    return {
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
            artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
            event: (ref6 = data === null || data === void 0 ? void 0 : data.event) !== null && ref6 !== void 0 ? ref6 : null
        }),
        actions: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, actions), {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, input;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                input = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, buildEventUpdate(values)), {
                                    thumbnailPath: values.thumbnailPath === (data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : (ref1 = ref.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) ? undefined : values.thumbnailPath
                                });
                                return [
                                    4,
                                    artistUpdateEvent({
                                        variables: {
                                            id: router.query.eventId,
                                            input: input
                                        }
                                    }).then(function() {
                                        router.goBack();
                                        showMessage(t("updateEventSuccess"), "success");
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        })
    };
});
var ConsoleEventEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleEventEdit_viewModel_templateObject(), utoniq_core_schema/* ConsoleEventEditDetailFragmentDoc */.bNw);
var ARTIST_UPDATE_EVENT = (0,lib/* gql */.Ps)(ConsoleEventEdit_viewModel_templateObject1(), utoniq_core_schema/* ConsoleEventDetailFragmentDoc */.SDW);
function buildEventUpdate(values) {
    var ref;
    return {
        title: values.title,
        description: values.description,
        note: values.note || null,
        location: getLocation(values === null || values === void 0 ? void 0 : values.location) || undefined,
        startedAt: (values === null || values === void 0 ? void 0 : values.startedAt) || null,
        endedAt: (values === null || values === void 0 ? void 0 : values.endedAt) || null,
        status: values.isPublished ? utoniq_core_schema/* EventStatus.Published */.N3X.Published : utoniq_core_schema/* EventStatus.Unpublished */.N3X.Unpublished,
        closeDate: ((ref = values.closeDate) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var date = param.date;
            return !!date;
        }).map(function(param) {
            var date = param.date;
            return date;
        })) || null,
        publishStartedAt: values.publishStartedAt || new Date(),
        publishEndedAt: values.publishEndedAt || null
    };
}
/**
 * @param location
 */ function getLocation(location) {
    if (!location || isEqual_default()(location, EventEditForm_defaultValues.location)) {
        return null;
    }
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, location), {
        mapUri: (0,lib_url/* encodeUrl */.Mq)(location.mapUri)
    });
}

// EXTERNAL MODULE: ../../node_modules/@capacitor/geolocation/dist/esm/index.js
var geolocation_dist_esm = __webpack_require__(71075);
// EXTERNAL MODULE: ../../node_modules/geolib/es/index.js
var geolib_es = __webpack_require__(38736);
;// CONCATENATED MODULE: ./src/core/native/geolocation/index.tsx






var checkPermission = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var location, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(core_dist/* Capacitor.getPlatform */.dV.getPlatform() === "web")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        checkAndRequestPermissionForWeb()
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        geolocation_dist_esm/* Geolocation.checkPermissions */.b.checkPermissions()
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    location = _tmp.location;
                    return [
                        2,
                        location === "granted"
                    ];
            }
        });
    });
    return function checkPermission() {
        return _ref.apply(this, arguments);
    };
}();
var requestPermissions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var permission, location;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        checkPermission()
                    ];
                case 1:
                    permission = _state.sent();
                    if (permission) return [
                        2,
                        permission
                    ];
                    if (core_dist/* Capacitor.getPlatform */.dV.getPlatform() === "web") return [
                        2,
                        permission
                    ];
                    return [
                        4,
                        geolocation_dist_esm/* Geolocation.requestPermissions */.b.requestPermissions()
                    ];
                case 2:
                    location = _state.sent().location;
                    return [
                        2,
                        location === "granted"
                    ];
            }
        });
    });
    return function requestPermissions() {
        return _ref.apply(this, arguments);
    };
}();
var watchPosition = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(opt, callback) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        geolocation_dist_esm/* Geolocation.watchPosition */.b.watchPosition(opt, callback)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function watchPosition(opt, callback) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description
 * 現在地を監視・取得するhooks
 */ var useLocationWatcher = function() {
    var callbackIdRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), permission = ref[0], setPermission = ref[1];
    var ref1 = (0,react.useState)(null), currentLocation = ref1[0], setCurrentLocation = ref1[1];
    var requestPermission = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var permission;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        requestPermissions()
                    ];
                case 1:
                    permission = _state.sent();
                    setPermission(permission);
                    return [
                        2
                    ];
            }
        });
    }), []);
    var watch = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var opt;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    opt = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if (!permission) return [
                        2
                    ];
                    return [
                        4,
                        watchPosition(opt, function(r) {
                            var ref, ref1;
                            setCurrentLocation({
                                latitude: r === null || r === void 0 ? void 0 : (ref = r.coords) === null || ref === void 0 ? void 0 : ref.latitude,
                                longitude: r === null || r === void 0 ? void 0 : (ref1 = r.coords) === null || ref1 === void 0 ? void 0 : ref1.longitude
                            });
                        })
                    ];
                case 1:
                    callbackIdRef.current = _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        permission
    ]);
    var unwatch = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!callbackIdRef.current) return [
                        2
                    ];
                    return [
                        4,
                        geolocation_dist_esm/* Geolocation.clearWatch */.b.clearWatch({
                            id: callbackIdRef.current
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), []);
    return {
        permission: permission,
        currentLocation: currentLocation,
        watch: watch,
        unwatch: unwatch,
        requestPermission: requestPermission
    };
};
/**
 * @description
 * web geolocation APIのpermission確認用
 * Geolocation.checkPermissions()にwebの確認機能がないので、capacitorのpluginを模倣して実装
 * webのgeolocation APIは現在地取得時にpermissionのrequestとcheckを同時にするので、getCurrentPositionの結果でpermissionの有無を確認する
 * (類似機能にweb permissions APIはSafari非対応のため使用しない)
 *
 * ref: https://capacitorjs.com/docs/plugins/web
 */ var checkAndRequestPermissionForWeb = function() {
    return geolocation_dist_esm/* Geolocation.getCurrentPosition */.b.getCurrentPosition().then(function(r) {
        return {
            location: "granted",
            coarseLocation: "granted"
        };
    }).catch(function(e) {
        /**
       * ユーザーキャンセルの場合、エラーは投げずステータスを返す
       */ if (e.message === "User denied Geolocation") return {
            location: "denied",
            coarseLocation: "denied"
        };
        throw e;
    });
};
/**
 * @description
 * 2点間の緯度・経度がradiusの範囲内かどうかを確認するhook
 *
 * @param radius 判定距離（メートル）
 * @returns {Boolean}
 */ var useIsInside = function(param) {
    var locations = param.locations, radius = param.radius;
    var ref = (0,react.useState)(false), isInside = ref[0], setIsInside = ref[1];
    (0,react.useEffect)(function() {
        // 存在チェック
        if (locations.some(function(location) {
            return !(location === null || location === void 0 ? void 0 : location.latitude) || !(location === null || location === void 0 ? void 0 : location.longitude);
        }) || !radius) return;
        var distance = (0,geolib_es.getDistance)(locations[0], locations[1]);
        setIsInside(radius >= distance);
    }, [
        locations,
        radius
    ]);
    return {
        isInside: isInside
    };
};

// EXTERNAL MODULE: ./src/lib/monads/index.ts
var monads = __webpack_require__(94998);
;// CONCATENATED MODULE: ./src/lib/googleMap/places.ts

function getPlacePredictions(input) {
    var autocompleteService = new google.maps.places.AutocompleteService();
    return autocompleteService.getPlacePredictions({
        input: input
    }).then(function(param) {
        var predictions = param.predictions;
        return predictions.map(function(prediction) {
            return {
                placeId: prediction.place_id,
                mainText: prediction.structured_formatting.main_text,
                secondaryText: prediction.structured_formatting.secondary_text,
                description: prediction.description
            };
        });
    });
}
function getDetail(param) {
    var placeId = param.placeId, map = param.map;
    var newService = new google.maps.places.PlacesService(map);
    return (0,monads/* promisifiedResult */.$k)(function(res) {
        newService.getDetails({
            placeId: placeId
        }, function(data) {
            var ref, ref1, ref2, ref3;
            return res(data ? {
                placeId: data.place_id,
                location: {
                    lat: (ref = data.geometry) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.lat(),
                    lng: (ref2 = data.geometry) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.location) === null || ref3 === void 0 ? void 0 : ref3.lng()
                },
                name: data.name,
                formattedAddress: data.formatted_address
            } : data);
        });
    });
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/viewModel.ts






function ConsoleEventCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistCreateEvent($inputs: ArtistCreateEventInput!) {\n    artistCreateEvent(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ConsoleEventCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













/**
 *
 */ var ConsoleEventCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1;
    var ref2 = useViewModelEvent((ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : ""), state = ref2.state, actions = ref2.actions;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_CREATE_EVENT), 1), artistCreateEvent = ref3[0];
    var ref4;
    return {
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : ""
        }),
        actions: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, actions), {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var inputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                inputs = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pick_default()(values, [
                                    "title",
                                    "description",
                                    "thumbnailPath"
                                ])), {
                                    note: (values === null || values === void 0 ? void 0 : values.note) || null,
                                    location: getLocation(values === null || values === void 0 ? void 0 : values.location),
                                    startedAt: (values === null || values === void 0 ? void 0 : values.startedAt) || null,
                                    endedAt: (values === null || values === void 0 ? void 0 : values.endedAt) || null,
                                    status: (values === null || values === void 0 ? void 0 : values.isPublished) ? utoniq_core_schema/* EventStatus.Published */.N3X.Published : utoniq_core_schema/* EventStatus.Unpublished */.N3X.Unpublished,
                                    closeDate: values.closeDate.filter(function(param) {
                                        var date = param.date;
                                        return !!date;
                                    }).map(function(param) {
                                        var date = param.date;
                                        return date;
                                    }),
                                    publishStartedAt: (values === null || values === void 0 ? void 0 : values.publishStartedAt) || new Date(),
                                    publishEndedAt: (values === null || values === void 0 ? void 0 : values.publishEndedAt) || null
                                });
                                return [
                                    4,
                                    artistCreateEvent({
                                        variables: {
                                            inputs: inputs
                                        }
                                    }).then(function() {
                                        router.goBack();
                                        showMessage(t("createEventSuccess"), "success");
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        })
    };
});
var ARTIST_CREATE_EVENT = (0,lib/* gql */.Ps)(ConsoleEventCreate_viewModel_templateObject());
var useViewModelEvent = function(userId) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)([]), predictions = ref[0], setPredictions = ref[1];
    var ref1 = (0,react.useState)(null), place = ref1[0], setPlace = ref1[1];
    var getImage = camera/* getImage */.g;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)(userId), upload = ref2.upload, progress = ref2.progress;
    var ref3 = useLocationWatcher(), permission = ref3.permission, currentLocation = ref3.currentLocation, requestPermission = ref3.requestPermission, watch = ref3.watch, unwatch = ref3.unwatch;
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    var getResource = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function getResource() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        state: {
            progress: progress,
            predictions: predictions,
            place: place,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            }
        },
        actions: {
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onPlaceSearch: function onPlaceSearch(param) {
                var keyword = param.keyword;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var predictions;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!keyword) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    getPlacePredictions(keyword)
                                ];
                            case 1:
                                predictions = _state.sent();
                                setPredictions(predictions);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectPlace: function onSelectPlace(param) {
                var placeId = param.placeId, map = param.map;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getDetail({
                                        placeId: placeId,
                                        map: map
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.isErr()) {
                                    throw result.err();
                                }
                                setPlace(result.unwrap());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRequestGPSPermission: function onRequestGPSPermission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (permission) return [
                                    2
                                ];
                                return [
                                    4,
                                    requestPermission()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventCreate/index.tsx




/**
 * ConsoleEventCreate Page
 * Implemented as a practical sample.
 */ var ConsoleEventCreate = function() {
    var ref = ConsoleEventCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleEventTicketInfoBox/index.tsx








var ConsoleEventTicketInfoBox = function(param) {
    var event = param.event, width = param.width;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref7.routerPages, generatePath = ref7.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            width: width,
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            sx: {
                height: "100%"
            },
            href: generatePath(routerPages.ConsoleShokufesEventDetail, {
                eventId: event.id
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        pb: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                                event: event
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventStatusTag, {
                                status: event.publishStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        pb: 3,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: event.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: "2px",
                                children: [
                                    !!event.dateRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                        children: [
                                            t("date"),
                                            event.dateRange
                                        ]
                                    }),
                                    event.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                        children: [
                                            t("address"),
                                            (ref = event.location) === null || ref === void 0 ? void 0 : ref.approximateAddress
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        pt: 3,
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketPurchaseStatus, (0,src_object_spread/* default */.Z)({}, event === null || event === void 0 ? void 0 : (ref1 = event.preSalesAggregation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.aggregation) === null || ref2 === void 0 ? void 0 : ref2.purchases)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                orientation: "vertical",
                                flexItem: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketUsageStatus, (0,src_object_spread/* default */.Z)({}, event === null || event === void 0 ? void 0 : (ref3 = event.preSalesAggregation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.aggregation) === null || ref4 === void 0 ? void 0 : ref4.ticketUsage, event === null || event === void 0 ? void 0 : (ref5 = event.preSalesAggregation) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.aggregation) === null || ref6 === void 0 ? void 0 : ref6.purchases))
                        ]
                    })
                ]
            })
        })
    });
};
var EventStatusTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var ref = (0,react.useMemo)(function() {
        if (status === utoniq_core_schema/* EventStatus.Published */.N3X.Published) {
            return {
                bgcolor: "primary.main",
                color: "white",
                text: t("available", "公開中")
            };
        }
        return {
            bgcolor: "grey.100",
            color: "text.disabled",
            text: t("private", "非公開")
        };
    }, [
        status,
        t
    ]), bgcolor = ref.bgcolor, color = ref.color, text = ref.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 20,
            borderRadius: "2px",
            minWidth: 40,
            bgcolor: bgcolor,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: color,
            variant: "overline",
            component: "p",
            children: text
        })
    });
};
var TicketPurchaseStatus = function(param) {
    var purchasedNumber = param.purchasedNumber, issuedNumber = param.issuedNumber, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        alignItems: "center",
        spacing: 1,
        sx: sx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                align: "left",
                width: "100%",
                children: t("purchaseStatus", "購入状況")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "secondary.main",
                        children: purchasedNumber || "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        pt: "2px",
                        children: issuedNumber || "-"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: "text.secondary",
                children: t("purchaseStatusNote", "購入数/在庫数")
            })
        ]
    });
};
var TicketUsageStatus = function(param) {
    var ticketUsedCount = param.ticketUsedCount, ticketUnusedCount = param.ticketUnusedCount, purchasedNumber = param.purchasedNumber, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        alignItems: "center",
        spacing: 1,
        sx: sx,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                align: "left",
                width: "100%",
                children: t("usageStatus", "使用状況")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "secondary.main",
                        children: ticketUsedCount || "-"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "warning.main",
                        pt: 1,
                        children: [
                            "(",
                            ticketUnusedCount || "-",
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        pt: "2px",
                        children: purchasedNumber || "-"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: "text.secondary",
                children: t("usageStatusNote", "使用済み(未使用)/購入数")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleEventItem/index.tsx



















var ConsoleEventItem = function(param) {
    var event = param.event, artistId = param.artistId, changingEventStatus = param.changingEventStatus, deletingEvent = param.deletingEvent, onChangeEventStatus = param.onChangeEventStatus, onDeleteEvent = param.onDeleteEvent;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEvents").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var collectionNumber = event.eventCollections.edges.filter(function(param) {
        var node = param.node;
        return node.collection.artistId === artistId;
    }).length;
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            py: 2,
                            px: 4,
                            "&:last-child": {
                                pb: 2
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (ref3 = (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref3 !== void 0 ? ref3 : "",
                                    sx: {
                                        height: 70,
                                        width: 100
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    spacing: 1,
                                    sx: {
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                                                    event: event
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventStatusTag, {
                                                    status: event.publishStatus
                                                })
                                            ]
                                        }),
                                        event.aboutDateRange && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: t("eventDate", {
                                                date: event.aboutDateRange
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                            children: event.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: t("collection", {
                                                number: collectionNumber
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                        size: "xSmall",
                                        bgcolor: "grey.100",
                                        color: "grey.700",
                                        onClick: handleClick,
                                        sx: {
                                            position: "relative",
                                            zIndex: 2,
                                            transform: "rotate(90deg)"
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                        sx: {
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            zIndex: 1
                        },
                        href: generatePath(routerPages.ConsoleShokufesEventDetail, {
                            eventId: event.id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventSettingCell, {
                eventId: event.id,
                anchorEl: anchorEl,
                status: event.status,
                changingEventStatus: changingEventStatus,
                deletingEvent: deletingEvent,
                onChangeEventStatus: onChangeEventStatus,
                onDeleteEvent: onDeleteEvent,
                onClose: function() {
                    return setAnchorEl(null);
                }
            })
        ]
    });
};
var EventSettingCell = function(param) {
    var eventId = param.eventId, _status = param.status, status = _status === void 0 ? utoniq_core_schema/* EventStatus.Unpublished */.N3X.Unpublished : _status, anchorEl = param.anchorEl, onClose = param.onClose, changingEventStatus = param.changingEventStatus, deletingEvent = param.deletingEvent, onChangeEventStatus = param.onChangeEventStatus, onDeleteEvent = param.onDeleteEvent;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEvents").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref2[0], copy = ref2[1];
    var onClick = (0,BrowserLink/* useBrowserLink */.i)(generatePath(routerPages.ShokufesEventDetail, {
        eventId: eventId
    })).onClick;
    var ref3 = (0,react.useState)(false), openChangeStatusModal = ref3[0], setOpenChangeStatusModal = ref3[1];
    var ref4 = (0,react.useState)(false), openDeleteEventModal = ref4[0], setOpenDeleteEventModal = ref4[1];
    var nextEventStatus = status === utoniq_core_schema/* EventStatus.Published */.N3X.Published ? utoniq_core_schema/* EventStatus.Unpublished */.N3X.Unpublished : utoniq_core_schema/* EventStatus.Published */.N3X.Published;
    var options = [
        {
            label: t("copyLink", "リンクをコピー"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(routerPages.ShokufesEventDetail, {
                                        eventId: eventId
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                onClose();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("exploreApps", "アプリを見る"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick() {
                onClick();
                onClose();
            }
        },
        {
            label: t("edit", "編集"),
            onClick: function onClick() {
                router.push(generatePath(routerPages.ConsoleShokufesEventEdit, {
                    eventId: eventId
                }));
                onClose();
            }
        },
        {
            label: t("delete", "削除"),
            onClick: function onClick() {
                setOpenDeleteEventModal(true);
                onClose();
            }
        }, 
    ];
    var handleChangeStatus = function() {
        onChangeEventStatus(nextEventStatus).then(function() {
            showMessage(status === utoniq_core_schema/* EventStatus.Published */.N3X.Published ? t("unpublishedEventSuccess") : t("publishedEventSuccess"));
        }).catch(showError).finally(function() {
            return setOpenChangeStatusModal(false);
        });
    };
    var handleRemoveEvent = function() {
        onDeleteEvent().then(function() {
            showMessage(t("deleteEventSuccess"));
        }).catch(showError).finally(function() {
            return setOpenDeleteEventModal(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: onClose,
                children: options.map(function(_param, index) /*#__PURE__*/ {
                    var icon = _param.icon, label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                        "icon",
                        "label"
                    ]);
                    return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                        sx: {
                            width: 200
                        },
                        key: index,
                        children: [
                            icon,
                            label
                        ]
                    }));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("".concat(nextEventStatus, "ModalTitle")),
                content: t("".concat(nextEventStatus, "ModalDesc")),
                open: openChangeStatusModal,
                onClose: function() {
                    return setOpenChangeStatusModal(false);
                },
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    loading: changingEventStatus,
                    disabled: changingEventStatus,
                    onClick: handleChangeStatus,
                    sx: {
                        minWidth: 212
                    },
                    children: t("".concat(nextEventStatus, "ModalBtn"))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("deleteEventModalTitle"),
                content: t("deleteEventModalDesc"),
                open: openDeleteEventModal,
                onClose: function() {
                    return setOpenDeleteEventModal(false);
                },
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    loading: deletingEvent,
                    disabled: deletingEvent,
                    onClick: handleRemoveEvent,
                    sx: {
                        minWidth: 212
                    },
                    children: t("deleteEventBtn")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gps/GpsMap.tsx






/**
 * @description
 * Modal shaped map component (using google map)
 */ var GpsMapModal = function(param) {
    var title = param.title, targetData = param.targetData, currentData = param.currentData, _open = param.open, open = _open === void 0 ? true : _open, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, isInside = param.isInside, hideAnnotation = param.hideAnnotation;
    var t = (0,core_i18n/* useTranslation */.$G)("gps").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: title || t("area"),
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        size: "medium",
                        color: "inherit",
                        onClick: onClose
                    }),
                    type: "modal"
                },
                sx: {
                    ".BaseLayoutContent": {
                        height: "100vh"
                    }
                },
                children: [
                    !hideAnnotation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: 24,
                            bgcolor: isInside ? "primary.main" : "error.main"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            color: "white",
                            children: isInside ? t("areaExist") : t("areaNotExist")
                        })
                    }),
                    !!(targetData === null || targetData === void 0 ? void 0 : targetData.latitude) && !!(targetData === null || targetData === void 0 ? void 0 : targetData.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMap, {
                        targetData: targetData,
                        currentData: currentData,
                        mapContainerStyle: {
                            height: "calc(100% - 24px)",
                            width: "100%"
                        },
                        offset: 24
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/lib/reactLinkify/index.tsx
var reactLinkify = __webpack_require__(86819);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/ConsoleEventDetail.tsx













var ConsoleEventDetail = function(param) {
    var loading = param.loading, event = param.event, preSales = param.preSales, onOpenMap = param.onOpenMap;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref3;
    var ref4 = (0,BrowserLink/* useBrowserLink */.i)((ref3 = event === null || event === void 0 ? void 0 : (ref = event.location) === null || ref === void 0 ? void 0 : ref.mapUri) !== null && ref3 !== void 0 ? ref3 : ""), openMap = ref4.onClick;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                p: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        numberOfLine: 4
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "25%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "100%"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "25%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "100%"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                children: event === null || event === void 0 ? void 0 : event.title
            }),
            event && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                pt: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                        event: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event), {
                            preSales: preSales
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventStatusTag, {
                        status: event.publishStatus
                    }),
                    !!event.formattedStartedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("publishedAt", {
                            date: event.formattedStartedAt
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        pt: 3
                    },
                    children: event === null || event === void 0 ? void 0 : event.description
                })
            }),
            !!(event === null || event === void 0 ? void 0 : event.dateRange) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("eventDate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: event === null || event === void 0 ? void 0 : event.dateRange
                    })
                ]
            }),
            !!(event === null || event === void 0 ? void 0 : event.formattedEventTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("eventTime")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: event === null || event === void 0 ? void 0 : event.formattedEventTime
                    })
                ]
            }),
            (event === null || event === void 0 ? void 0 : event.location) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("venue")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                variant: "text",
                                size: "small",
                                onClick: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventMap", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        eventId: event === null || event === void 0 ? void 0 : event.id,
                                        type: "consoleEventDetail"
                                    });
                                    onOpenMap();
                                },
                                sx: {
                                    pl: 0,
                                    ml: -2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {
                                        fontSize: "small",
                                        sx: {
                                            color: "primary.main"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "primary.main",
                                        align: "left",
                                        sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                        children: event === null || event === void 0 ? void 0 : (ref1 = event.location) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                                    })
                                ]
                            }),
                            !!(event === null || event === void 0 ? void 0 : (ref2 = event.location) === null || ref2 === void 0 ? void 0 : ref2.mapUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                onClick: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventMapLink", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        eventId: event === null || event === void 0 ? void 0 : event.id,
                                        type: "consoleEventDetail"
                                    });
                                    openMap();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    component: "span",
                                    variant: "subtitle1",
                                    display: "inherit",
                                    minWidth: 90,
                                    children: [
                                        "（",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            component: "span",
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            variant: "subtitle1",
                                            color: "primary",
                                            children: t("venueMap", "会場MAP")
                                        }),
                                        "）"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/TicketPurchaseStatus.tsx



var TicketPurchaseStatus_TicketPurchaseStatus = function(param) {
    var purchasedNumber = param.purchasedNumber, issuedNumber = param.issuedNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        spacing: 2,
        sx: {
            p: 4,
            bgcolor: "grey.50",
            borderRadius: "6px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                align: "left",
                width: "100%",
                children: t("purchaseStatus", "購入状況")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                color: "secondary.main",
                                children: purchasedNumber || "-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: "/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                pt: 1,
                                children: issuedNumber || "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        children: t("purchaseStatusNote", "購入数/在庫数")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/TicketStatusTableCell.tsx




var TicketStatusTableCell = function(param) {
    var preSaleItems = param.preSaleItems;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var _ticketUsedCount, _ticketUnusedCount, _ticketUsedCount1, _ticketUnusedCount1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    padding: "none",
                                    sx: {
                                        border: "none",
                                        width: 100
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("ticketName", "チケット名")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    padding: "none",
                                    sx: {
                                        border: "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        align: "center",
                                        children: t("purchasePerStock", "購入数/\n在庫数")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    padding: "none",
                                    sx: {
                                        border: "none",
                                        minWidth: 110
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        align: "center",
                                        children: t("usedUnusedPerPurchase")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                        children: [
                            !preSaleItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    colSpan: 3,
                                    sx: {
                                        px: 0,
                                        py: 6,
                                        border: "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body1",
                                        color: "text.secondary",
                                        align: "center",
                                        children: t("emptyTicketMessage", "チケット状況はありません")
                                    })
                                })
                            }),
                            preSaleItems === null || preSaleItems === void 0 ? void 0 : preSaleItems.map(function(preSaleItem, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                px: 0,
                                                py: 3,
                                                width: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                variant: "body2",
                                                href: "".concat(generatePath(routerPages.ConsoleItemDetail, {
                                                    itemId: preSaleItem.itemId
                                                }), "?ticketOpen=true"),
                                                children: preSaleItem === null || preSaleItem === void 0 ? void 0 : preSaleItem.item.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                px: 0,
                                                py: 3
                                            },
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                sx: {
                                                    width: "fit-content",
                                                    margin: "0 auto"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        component: "span",
                                                        sx: {
                                                            fontVariantNumeric: "stacked-fractions",
                                                            minWidth: 36
                                                        },
                                                        children: preSaleItem.ticketUsedCount || preSaleItem.ticketUnusedCount ? ((_ticketUsedCount = preSaleItem.ticketUsedCount) !== null && _ticketUsedCount !== void 0 ? _ticketUsedCount : 0) + ((_ticketUnusedCount = preSaleItem.ticketUnusedCount) !== null && _ticketUnusedCount !== void 0 ? _ticketUnusedCount : 0) : "-"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                        sx: {
                                                            borderColor: "text.primary"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        sx: {
                                                            fontVariantNumeric: "stacked-fractions",
                                                            minWidth: 36
                                                        },
                                                        children: preSaleItem.item.issuedNumber || "-"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                px: 0,
                                                py: 3,
                                                minWidth: 110
                                            },
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                sx: {
                                                    width: "fit-content",
                                                    margin: "0 auto"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        component: "span",
                                                        sx: {
                                                            fontVariantNumeric: "stacked-fractions",
                                                            minWidth: 36
                                                        },
                                                        children: [
                                                            preSaleItem.ticketUsedCount || "-",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                                variant: "body2",
                                                                component: "span",
                                                                color: "warning.main",
                                                                sx: {
                                                                    fontVariantNumeric: "stacked-fractions",
                                                                    minWidth: 36
                                                                },
                                                                children: [
                                                                    "(",
                                                                    preSaleItem.ticketUnusedCount || "-",
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                        sx: {
                                                            borderColor: "text.primary"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        sx: {
                                                            fontVariantNumeric: "stacked-fractions",
                                                            minWidth: 36
                                                        },
                                                        children: preSaleItem.ticketUsedCount || preSaleItem.ticketUnusedCount ? ((_ticketUsedCount1 = preSaleItem.ticketUsedCount) !== null && _ticketUsedCount1 !== void 0 ? _ticketUsedCount1 : 0) + ((_ticketUnusedCount1 = preSaleItem.ticketUnusedCount) !== null && _ticketUnusedCount1 !== void 0 ? _ticketUnusedCount1 : 0) : "-"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/TicketUsageStatus.tsx



var TicketUsageStatus_TicketUsageStatus = function(param) {
    var ticketUnusedCount = param.ticketUnusedCount, ticketUsedCount = param.ticketUsedCount, purchasedNumber = param.purchasedNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        flex: 1,
        alignItems: "center",
        spacing: 2,
        sx: {
            p: 4,
            bgcolor: "grey.50",
            borderRadius: "6px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                align: "left",
                width: "100%",
                children: t("usageStatus", "使用状況")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                color: "secondary.main",
                                children: ticketUsedCount || "-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "warning.main",
                                pt: 1,
                                children: [
                                    "(",
                                    ticketUnusedCount || "-",
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: "/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                pt: 1,
                                children: purchasedNumber || "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        children: t("usageStatusNote", "使用済み(未使用)/購入数")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/TicketStatusCell.tsx








var TicketStatusCell = function(param) {
    var preSalesAggregation = param.preSalesAggregation, updatedAt = param.updatedAt, showEmptyState = param.showEmptyState;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        pt: 1,
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                lineHeight: "28px",
                children: t("ticketStatus", "チケット状況")
            }),
            !!updatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    width: "100%",
                    align: "right",
                    children: t("ticketStatusUpdatedAt", {
                        date: updatedAt
                    })
                })
            }),
            (!!(preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : (ref = preSalesAggregation.preSaleItems) === null || ref === void 0 ? void 0 : ref.length) || showEmptyState) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        py: 3,
                        direction: "row",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketPurchaseStatus_TicketPurchaseStatus, (0,src_object_spread/* default */.Z)({}, preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : (ref1 = preSalesAggregation.aggregation) === null || ref1 === void 0 ? void 0 : ref1.purchases)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketUsageStatus_TicketUsageStatus, (0,src_object_spread/* default */.Z)({}, preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : (ref2 = preSalesAggregation.aggregation) === null || ref2 === void 0 ? void 0 : ref2.ticketUsage, preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : (ref3 = preSalesAggregation.aggregation) === null || ref3 === void 0 ? void 0 : ref3.purchases))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        pt: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketStatusTableCell, {
                            preSaleItems: preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : preSalesAggregation.preSaleItems
                        })
                    })
                ]
            }),
            !(preSalesAggregation === null || preSalesAggregation === void 0 ? void 0 : (ref4 = preSalesAggregation.preSaleItems) === null || ref4 === void 0 ? void 0 : ref4.length) && !showEmptyState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                py: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.secondary",
                    align: "center",
                    children: t("emptyTicketMessage", "チケット状況はありません")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsolePreSaleBox/index.tsx



















var ConsolePreSaleBox = function(param) {
    var preSale = param.preSale, onTogglePreSalePublish = param.onTogglePreSalePublish;
    var ref, ref1, ref2;
    var t = (0,dist_es/* useTranslation */.$G)("consoleEventDetail").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), copy = ref4[1];
    var _id;
    var ref5 = (0,BrowserLink/* useBrowserLink */.i)(generatePath(preSale.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? routerPages.LotteryDetail : routerPages.FirstComeFirstServedDetail, {
        preSaleId: (_id = preSale.id) !== null && _id !== void 0 ? _id : "#"
    })), onClickBrowserLink = ref5.onClick;
    var ref6 = (0,react.useState)(null), anchorEl = ref6[0], setAnchorEl = ref6[1];
    var now = dayjs_min_default()().unix() * 1000;
    var isPublished = preSale.isPublished && preSale.startedAt <= now && now <= preSale.endedAt;
    // 応募期間・購入期間の表示
    var applicationPeriod = (0,react.useMemo)(function() {
        var ref, ref1;
        if (preSale.type === "lottery") {
            var ref2, ref3;
            return {
                label: t("applicationPeriod"),
                value: "".concat(values_Date/* DateTime.formatDate */.o.formatDate((ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationStartedAt, "YYYY/MM/DD(ddd) HH:mm"), " 〜 ").concat(values_Date/* DateTime.formatDate */.o.formatDate((ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.applicationEndedAt, "YYYY/MM/DD(ddd) HH:mm"))
            };
        }
        return {
            label: t("purchasablePeriod"),
            value: "".concat(values_Date/* DateTime.formatDate */.o.formatDate((ref = preSale.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.purchasableStartedAt, "YYYY/MM/DD(ddd) HH:mm"), " 〜 ").concat(values_Date/* DateTime.formatDate */.o.formatDate((ref1 = preSale.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableEndedAt, "YYYY/MM/DD(ddd) HH:mm"))
        };
    }, [
        preSale
    ]);
    var options = [
        {
            label: t("applicants"),
            onClick: function onClick() {
                router.push(generatePath(routerPages.ConsoleLotteryManagements, {
                    preSaleId: preSale === null || preSale === void 0 ? void 0 : preSale.id
                }));
            },
            // 応募者管理は抽選の場合のみ表示
            hidden: preSale.type === utoniq_core_schema/* PreSaleType.FirstComeFirstServed */.osN.FirstComeFirstServed
        },
        // {
        //   // TODO: 先行販売の公開・非公開を切り替える
        //   label: preSale.isPublished ? t('unpublish') : t('publish'),
        //   onClick() {
        //     onTogglePreSalePublish(preSale)
        //     setAnchorEl(null)
        //   },
        // },
        {
            label: t("copyURLLabel"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _id;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(preSale.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? routerPages.LotteryDetail : routerPages.FirstComeFirstServedDetail, {
                                        preSaleId: (_id = preSale.id) !== null && _id !== void 0 ? _id : "#"
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("openPreSaleLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick() {
                onClickBrowserLink();
                setAnchorEl(null);
            }
        },
        {
            label: t("edit"),
            onClick: function onClick() {
                router.push(generatePath(routerPages.ConsolePreSaleEdit, {
                    preSaleId: preSale.id,
                    eventId: router.query.eventId
                }));
            }
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var _id1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    px: 2,
                                    pb: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            mb: 2
                                        },
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    sx: {
                                                        ".MuiChip-root": {
                                                            bgcolor: "background.default",
                                                            border: "1px solid",
                                                            borderColor: "grey.500"
                                                        },
                                                        fontSize: "10px",
                                                        fontWeight: 700
                                                    },
                                                    size: "small",
                                                    label: t(preSale === null || preSale === void 0 ? void 0 : preSale.type)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    size: "small",
                                                    label: t(isPublished ? "published" : "unpublished"),
                                                    color: isPublished ? "primary" : "default"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    size: "small",
                                                    sx: // Chipに設定されていないカラーなので、独自に設定する
                                                    preSale.preSaleStatus === "acceptingLottery" ? {
                                                        bgcolor: "info.light",
                                                        color: "default",
                                                        fontSize: "10px",
                                                        fontWeight: 700
                                                    } : preSale.preSaleStatus === "purchasable" ? {
                                                        bgcolor: "secondary.light",
                                                        color: "default",
                                                        fontSize: "10px",
                                                        fontWeight: 700
                                                    } : undefined,
                                                    label: t("".concat(preSale.preSaleStatus)),
                                                    color: preSale.preSaleStatus === "accepting" || preSale.preSaleStatus === "beforeReceiption" ? "secondary" : preSale.preSaleStatus === "soldOut" ? "error" : "default"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    color: "text.secondary",
                                                    variant: "caption",
                                                    sx: {
                                                        pl: 2
                                                    },
                                                    children: t("publishedAt", {
                                                        date: values_Date/* DateTime.formatDate */.o.formatDate(String(preSale.formattedStartedAt))
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: preSale.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 0,
                                sx: {
                                    px: 2,
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        color: "text.secondary",
                                        variant: "caption",
                                        sx: {
                                            fontSize: "10px"
                                        },
                                        children: [
                                            applicationPeriod.label,
                                            applicationPeriod.value
                                        ]
                                    }),
                                    preSale.type === "lottery" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                color: "text.secondary",
                                                variant: "caption",
                                                sx: {
                                                    fontSize: "10px"
                                                },
                                                children: [
                                                    t("resultNoticedAt"),
                                                    values_Date/* DateTime.formatDate */.o.formatDate((ref = preSale.lottery) === null || ref === void 0 ? void 0 : ref.resultNoticedAt, "YYYY/MM/DD(ddd) HH:mm")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                color: "text.secondary",
                                                variant: "caption",
                                                sx: {
                                                    fontSize: "10px"
                                                },
                                                children: [
                                                    t("lotteryPurchasablePeriod"),
                                                    values_Date/* DateTime.formatDate */.o.formatDate((ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.purchasableStartedAt, "YYYY/MM/DD(ddd) HH:mm"),
                                                    " ",
                                                    "〜",
                                                    " ",
                                                    values_Date/* DateTime.formatDate */.o.formatDate((ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.purchasableEndedAt, "YYYY/MM/DD(ddd) HH:mm")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                size: "small",
                                bgcolor: "grey.100",
                                color: "grey.700",
                                onClick: handleClick,
                                sx: {
                                    position: "relative",
                                    zIndex: 2,
                                    transform: "rotate(90deg)"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                anchorEl: anchorEl,
                                open: Boolean(anchorEl),
                                onClose: handleClose,
                                children: options.map(function(_param) {
                                    var icon = _param.icon, label = _param.label, hidden = _param.hidden, option = (0,_object_without_properties/* default */.Z)(_param, [
                                        "icon",
                                        "label",
                                        "hidden"
                                    ]);
                                    return !hidden && /*#__PURE__*/ (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                                        sx: {
                                            width: 200
                                        },
                                        key: label,
                                        children: [
                                            icon,
                                            label
                                        ]
                                    }));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    inset: 0,
                    zIndex: 1
                },
                href: generatePath(routerPages.ConsolePreSaleDetail, {
                    preSaleId: (_id1 = preSale.id) !== null && _id1 !== void 0 ? _id1 : "#"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/event/PreSaleCardSkeleton/index.tsx



var PreSaleCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                height: 80,
                width: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 1,
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "small",
                    width: "100%"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/PreSalesCell.tsx








var PreSalesCell = function(param) {
    var preSales = param.preSales, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, onTogglePreSalePublish = param.onTogglePreSalePublish;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("eventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            px: 5,
            pb: 5
        },
        children: [
            loading && !(preSales === null || preSales === void 0 ? void 0 : (ref = preSales.edges) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h5",
                sx: {
                    pb: 5
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    pb: 5
                },
                children: t("", "関連付けた先行販売")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: preSales === null || preSales === void 0 ? void 0 : preSales.edges.map(function(param, index) {
                    var node = param.node;
                    if (!node) return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, index);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePreSaleBox, {
                        preSale: node,
                        onTogglePreSalePublish: onTogglePreSalePublish
                    }, node.id);
                }),
                componentProps: {
                    spacing: 5
                },
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                emptyMessage: t("preSalesEmpty"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        pt: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleCardSkeleton, {}, key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleEventItem/CollectionStatusCell.tsx








var CollectionStatusCell = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEvents").t;
    var ref = (0,react.useMemo)(function() {
        if (status === utoniq_core_schema/* CollectionStatus.Archived */.NbM.Archived) {
            return {
                label: t(utoniq_core_schema/* CollectionStatus.Archived */.NbM.Archived),
                sx: {
                    bgcolor: "text.disabled"
                }
            };
        }
        if (status === utoniq_core_schema/* CollectionStatus.Published */.NbM.Published) {
            return {
                label: t(utoniq_core_schema/* CollectionStatus.Published */.NbM.Published),
                sx: {
                    bgcolor: "primary.main"
                }
            };
        }
        return {
            label: t(utoniq_core_schema/* CollectionStatus.Unpublished */.NbM.Unpublished),
            sx: {
                bgcolor: "text.disabled"
            }
        };
    }, [
        status,
        t
    ]), label = ref.label, sx = ref.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "white",
                    children: label
                }),
                sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, sx), {
                    p: 1,
                    height: 20,
                    ".MuiChip-label": {
                        px: 0
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/CollectionEventCell.tsx











var CollectionEventCell = function(param) {
    var eventId = param.eventId, collections = param.collections, hasNextPage = param.hasNextPage, loading = param.loading, removingCollection = param.removingCollection, onFetchMore = param.onFetchMore, onRemoveCollectionFromEvent = param.onRemoveCollectionFromEvent;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            px: 5,
            pb: 5
        },
        children: [
            loading && !collections ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h5",
                sx: {
                    pb: 5
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                pb: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("registrationCollection")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                            i18nKey: "registrationCollectionNote",
                            t: t,
                            components: {
                                itemLinkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    variant: "caption",
                                    href: routerPages.ConsoleItems
                                }),
                                collectionLinkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    variant: "caption",
                                    href: routerPages.ConsoleCollections
                                })
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: collections === null || collections === void 0 ? void 0 : collections.map(function(eventCollection, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItemCell, {
                                    eventCollection: eventCollection,
                                    eventId: eventId,
                                    removingCollection: removingCollection,
                                    onRemoveCollectionFromEvent: onRemoveCollectionFromEvent
                                }),
                                (collections === null || collections === void 0 ? void 0 : collections.length) - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                            ]
                        }, eventCollection.collectionId);
                    }),
                    emptyMessage: t("collectionItemEmptyMessage"),
                    loading: loading,
                    hasNextPage: hasNextPage,
                    onFetchMore: onFetchMore,
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItemSkeletonCell, {})
                    })
                })
            })
        ]
    });
};
var CollectionItemCell = function(param) {
    var eventCollection = param.eventCollection, eventId = param.eventId, removingCollection = param.removingCollection, onRemoveCollectionFromEvent = param.onRemoveCollectionFromEvent;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = (0,react.useState)(false), openDeleteCollectionModal = ref3[0], setOpenDeleteCollectionModal = ref3[1];
    // チケットアイテムを含むかどうか。含む場合、受け取り管理ボタンを表示する
    var hasTicketItem = eventCollection.collection.collectionItems.edges.some(function(param) {
        var node = param.node;
        return node.item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket;
    });
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleRemoveCollection = function() {
        onRemoveCollectionFromEvent(collection.id).then(function() {
            return showMessage(t("removeCollectionSuccess"), "success");
        }).finally(function() {
            return setOpenDeleteCollectionModal(false);
        }).catch(showError);
    };
    if (!eventCollection) return null;
    var collection = eventCollection.collection;
    var _pickupTime;
    // 受け取り可能時間
    var pickupTimeArr = ((_pickupTime = eventCollection.pickupTime) !== null && _pickupTime !== void 0 ? _pickupTime : []).map(function(param) {
        var options = param.options;
        return values_Date/* DateTime.formatDate */.o.formatDate(options.time, "HH:mm");
    }).sort();
    var pickupTimeRange = pickupTimeArr.length > 1 ? "".concat(pickupTimeArr[0], "...").concat(pickupTimeArr[pickupTimeArr.length - 1]) : pickupTimeArr[0];
    var _uri;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    pb: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                        sx: {
                            flex: 1,
                            textAlign: "left"
                        },
                        href: generatePath(routerPages.ConsoleCollectionDetail, {
                            collectionId: eventCollection.collectionId
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            flex: 1,
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (_uri = collection.thumbnail.uri) !== null && _uri !== void 0 ? _uri : "",
                                    sx: {
                                        width: 120,
                                        height: 90
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 2,
                                            alignItems: "center",
                                            children: !!collection.status && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionStatusCell, {
                                                status: collection.status
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: collection.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                pt: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    children: t("createdAt", {
                                                        date: collection.formattedCreatedAt
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    children: t("itemCount", {
                                                        number: collection.itemCount
                                                    })
                                                }),
                                                !!pickupTimeArr.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    children: t("deliveryTime", {
                                                        delivery: pickupTimeRange
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                        size: "xSmall",
                        bgcolor: "grey.100",
                        color: "grey.700",
                        onClick: handleClick,
                        sx: {
                            position: "relative",
                            zIndex: 2,
                            transform: "rotate(90deg)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                        anchorEl: anchorEl,
                        open: Boolean(anchorEl),
                        onClose: handleClose,
                        children: [
                            hasTicketItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    return router.push(generatePath(routerPages.ConsoleEventCollectionReceiveTimeEdit, {
                                        collectionId: collection.id,
                                        eventId: eventId
                                    }));
                                },
                                children: t("editDeliveryTime", "受け渡し時間の編集")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                onClick: function() {
                                    setOpenDeleteCollectionModal(true);
                                    setAnchorEl(null);
                                },
                                children: t("removeCollection", "このストアから削除")
                            })
                        ]
                    })
                ]
            }),
            hasTicketItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    mt: 2,
                    a: {
                        fontSize: "13px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        fullWidth: true,
                        variant: "outlined",
                        href: generatePath(routerPages.ConsoleTicketReceives, {
                            collectionId: collection.id,
                            eventId: eventId
                        }),
                        children: t("receiptManagement", "受け取り管理")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        fullWidth: true,
                        variant: "outlined",
                        href: generatePath(routerPages.ConsoleQuantityManagements, {
                            collectionId: collection.id,
                            eventId: eventId
                        }),
                        children: t("quantityManagement", "商品数量の確認")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                title: t("deleteCollectionModalTitle"),
                content: t("deleteCollectionModalDesc"),
                open: openDeleteCollectionModal,
                onClose: function() {
                    return setOpenDeleteCollectionModal(false);
                },
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    size: "large",
                    loading: removingCollection,
                    disabled: removingCollection,
                    onClick: handleRemoveCollection,
                    sx: {
                        minWidth: 212
                    },
                    children: t("deleteCollectionBtn")
                })
            })
        ]
    });
};
var CollectionItemSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    flex: 1,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 120,
                            height: 90,
                            sx: {
                                borderRadius: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 5,
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "h3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        numberOfLine: 3
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 28,
                    height: 28
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/CreatePreSaleActionSheetCell.tsx






var CreatePreSaleActionSheetCell = function(param) {
    var isShow = param.isShow;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var handleClose = function() {
        return setOpen(false);
    };
    var _eventId, _eventId1;
    var items = (0,react.useMemo)(function() {
        return [
            {
                text: t("lotteryTicket"),
                href: generatePath(routerPages.ConsolePreSaleCreate, {
                    preSaleType: "lottery",
                    eventId: (_eventId = router.query.eventId) !== null && _eventId !== void 0 ? _eventId : "#"
                })
            },
            {
                text: t("firstComeFirstServedTicket"),
                href: generatePath(routerPages.ConsolePreSaleCreate, {
                    preSaleType: "firstComeFirstServed",
                    eventId: (_eventId1 = router.query.eventId) !== null && _eventId1 !== void 0 ? _eventId1 : "#"
                })
            }, 
        ];
    }, [
        t,
        generatePath,
        routerPages
    ]);
    if (!isShow) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        position: "fixed",
                        bottom: 16,
                        zIndex: 5,
                        maxWidth: 600,
                        margin: "0 auto",
                        px: 4,
                        pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                        size: "medium",
                        color: "primary",
                        onClick: toggleDrawer(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                            fontSize: "medium",
                            sx: {
                                color: "white"
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: t("selectPreSlaeType")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            items.map(function(param, index) {
                                var text = param.text, href = param.href;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                    component: Stack_Stack/* default */.Z,
                                    sx: {
                                        height: 52
                                    },
                                    spacing: 3,
                                    direction: "row",
                                    onClick: function() {
                                        return router.push(href);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: text
                                    })
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%",
                                        color: "primary.main"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/SelectCollectionModal.tsx














var SelectCollectionModal = function(param) {
    var artistId = param.artistId, open = param.open, onClose = param.onClose, loading = param.loading, hasNextPage = param.hasNextPage, collections = param.collections, addingCollection = param.addingCollection, onFetchMoreSelectCollection = param.onFetchMoreSelectCollection, onAddCollectionsToEvent = param.onAddCollectionsToEvent;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)([]), selectedCollection = ref1[0], setSelectCollection = ref1[1];
    var handleSelectedCollection = (0,react.useCallback)(function(collectionId) {
        setSelectCollection(function(prevState) {
            return xor_default()(prevState, [
                collectionId
            ]);
        });
    }, []);
    var handleAddCollectionsToEvent = (0,react.useCallback)(function() {
        onAddCollectionsToEvent(selectedCollection).then(function() {
            return onClose();
        }).catch(showError);
    }, [
        onAddCollectionsToEvent,
        selectedCollection,
        showError,
        onClose
    ]);
    (0,react.useEffect)(function() {
        if (!open) {
            setSelectCollection([]);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
                artistId: artistId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                    margin: true,
                    header: {
                        title: t("selectCollection", "コレクションを選択"),
                        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "medium",
                            color: "white",
                            onClick: onClose
                        })
                    },
                    customNavigation: selectedCollection.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCollectionModal_FixedBottomCell, {
                        number: selectedCollection.length,
                        onAdd: handleAddCollectionsToEvent,
                        loading: addingCollection
                    }) : null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        componentProps: {
                            sx: {
                                pt: 2
                            }
                        },
                        nodes: collections === null || collections === void 0 ? void 0 : (ref = collections.edges) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCollectionModal_CollectionSelectBox, {
                                    collection: node,
                                    onSelect: function() {
                                        return handleSelectedCollection(node.id);
                                    },
                                    checked: !!selectedCollection.find(function(collectionId) {
                                        return collectionId === node.id;
                                    })
                                })
                            }, index);
                        }),
                        emptyMessage: t("collectionItemEmptyMessage"),
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMoreSelectCollection,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                py: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCollectionModal_CollectionItemSkeletonCell, {})
                        })
                    })
                })
            })
        })
    });
};
var SelectCollectionModal_FixedBottomCell = function(param) {
    var number = param.number, onAdd = param.onAdd, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                bgcolor: "grey.50",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    minWidth: 244
                },
                onClick: onAdd,
                loading: loading,
                disabled: loading,
                children: t("addSelectedCollection", {
                    number: number
                })
            })
        })
    });
};
var SelectCollectionModal_CollectionSelectBox = function(param) {
    var checked = param.checked, collection = param.collection, onSelect = param.onSelect;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2,
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: checked ? "primary.main" : "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            onClick: function() {
                return onSelect(collection.id);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    alignItems: "center",
                    sx: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "small",
                            src: (ref1 = (ref = collection.thumbnail) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref1 !== void 0 ? ref1 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                zIndex: 1,
                                marginInline: "auto",
                                pl: 1,
                                ml: "0 !important",
                                position: "absolute",
                                top: 4,
                                left: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                type: utoniq_core_schema/* ItemType.Image */.qGq.Image
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionStatusCell, {
                                            status: collection.status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: t("publishedAt", {
                                                date: collection.formattedStartedAt
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: collection.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: t("createdAt", {
                                                date: collection.formattedCreatedAt
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: t("itemCount", {
                                                number: collection.itemCount
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var SelectCollectionModal_CollectionItemSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                flex: 1,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 120,
                        height: 90,
                        sx: {
                            borderRadius: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "large"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 5,
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    numberOfLine: 3
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/components/CreateCollectionActionSheetCell.tsx








var CreateCollectionActionSheetCell = function(_param) {
    var artistId = _param.artistId, isShow = _param.isShow, onFetchSelectCollection = _param.onFetchSelectCollection, props = (0,_object_without_properties/* default */.Z)(_param, [
        "artistId",
        "isShow",
        "onFetchSelectCollection"
    ]);
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    if (!isShow) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        position: "fixed",
                        bottom: 16,
                        zIndex: 5,
                        maxWidth: 600,
                        margin: "0 auto",
                        px: 4,
                        pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                        size: "medium",
                        color: "primary",
                        onClick: function() {
                            onFetchSelectCollection();
                            setOpen(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                            fontSize: "medium",
                            sx: {
                                color: "white"
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCollectionModal, (0,src_object_spread/* default */.Z)({
                artistId: artistId,
                open: open,
                onClose: function() {
                    return setOpen(false);
                }
            }, props))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/template/index.tsx


















var ConsoleEventDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onRequestPermission = param.onRequestPermission, onFetchPreSalesMore = param.onFetchPreSalesMore, onTogglePreSalePublish = param.onTogglePreSalePublish, onFetchSelectCollection = param.onFetchSelectCollection, onFetchMoreSelectCollection = param.onFetchMoreSelectCollection, onAddCollectionsToEvent = param.onAddCollectionsToEvent, onRemoveCollectionFromEvent = param.onRemoveCollectionFromEvent, onChangeEventStatus = param.onChangeEventStatus, onDeleteEvent = param.onDeleteEvent;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), openMap = ref10[0], setOpenMap = ref10[1];
    var showSkeleton = state.loading && !state.event;
    var ref11 = (0,react.useState)(state.tab), currentTab = ref11[0], setCurrentTab = ref11[1];
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventDetail").t;
    var ref12 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref12.routerPages, routerNames = ref12.routerNames, generatePath = ref12.generatePath;
    var ref13 = (0,react.useState)(null), anchorEl = ref13[0], setAnchorEl = ref13[1];
    var handleTabChange = (0,react.useCallback)(function(value) {
        var ref;
        setCurrentTab(value);
        var ref1;
        // If you use router.replace, the page will re-render, causing it to scroll to the top.
        // https://stackoverflow.com/a/61596862
        window.history.replaceState(window.history.state, (ref1 = (ref = state.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "", generatePath(routerPages.ConsoleShokufesEventDetail, {
            eventId: state.eventId,
            tab: value === 1 ? "store" : "presale"
        }));
    }, [
        generatePath,
        routerPages.ConsoleShokufesEventDetail,
        (ref = state.event) === null || ref === void 0 ? void 0 : ref.title,
        state.eventId, 
    ]);
    var _preSalesAggregation, ref14, ref15, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                defaultBackPage: routerPages.ConsoleShokufesEvents,
                title: (ref1 = state.event) === null || ref1 === void 0 ? void 0 : ref1.title,
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                    size: "medium",
                    color: "white",
                    edge: "end",
                    onClick: function(event) {
                        return setAnchorEl(event.currentTarget);
                    }
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleShokufesEventDetail
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventSettingCell, {
                    eventId: state.eventId,
                    changingEventStatus: state.changingEventStatus,
                    deletingEvent: state.deletingEvent,
                    anchorEl: anchorEl,
                    status: (ref2 = state.event) === null || ref2 === void 0 ? void 0 : ref2.status,
                    onClose: function() {
                        return setAnchorEl(null);
                    },
                    onChangeEventStatus: onChangeEventStatus,
                    onDeleteEvent: onDeleteEvent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventImageCell, {
                    loading: showSkeleton,
                    thumbnail: (ref3 = state.event) === null || ref3 === void 0 ? void 0 : ref3.thumbnail
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventDetail, {
                    loading: showSkeleton,
                    event: state.event,
                    preSales: state.preSale,
                    onOpenMap: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setOpenMap(true);
                                    return [
                                        4,
                                        onRequestPermission()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                }),
                config_config/* config.modules.preSale */.v.modules.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        state.event && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            px: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketStatusCell, {
                                preSalesAggregation: (_preSalesAggregation = state.event.preSalesAggregation) !== null && _preSalesAggregation !== void 0 ? _preSalesAggregation : null,
                                updatedAt: state.updatedAt,
                                showEmptyState: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            px: 5,
                            pb: 2,
                            lineHeight: "28px",
                            children: t("salesManagement", "販売管理")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                            labels: [
                                t("presales"),
                                t("store")
                            ],
                            value: currentTab,
                            disableAnimateTransitions: true,
                            onChange: handleTabChange,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSalesCell, {
                                    loading: state.loading,
                                    preSales: state.preSale,
                                    hasNextPage: state.hasPresalesNextPage,
                                    onFetchMore: onFetchPreSalesMore,
                                    onTogglePreSalePublish: onTogglePreSalePublish
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionEventCell, {
                                    loading: state.loading,
                                    removingCollection: state.removingCollection,
                                    collections: state.collections,
                                    hasNextPage: state.hasEventCollectionNextPage,
                                    onFetchMore: onFetchMore,
                                    eventId: (ref14 = (ref4 = state.event) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref14 !== void 0 ? ref14 : "",
                                    onRemoveCollectionFromEvent: onRemoveCollectionFromEvent
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePreSaleActionSheetCell, {
                            isShow: currentTab === 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCollectionActionSheetCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            artistId: state.artistId,
                            isShow: currentTab === 1
                        }, state.selectCollection), {
                            onFetchSelectCollection: onFetchSelectCollection,
                            onFetchMoreSelectCollection: onFetchMoreSelectCollection,
                            onAddCollectionsToEvent: onAddCollectionsToEvent
                        }))
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionEventCell, {
                            loading: state.loading,
                            removingCollection: state.removingCollection,
                            collections: state.collections,
                            hasNextPage: state.hasEventCollectionNextPage,
                            onFetchMore: onFetchMore,
                            eventId: (ref15 = (ref5 = state.event) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref15 !== void 0 ? ref15 : "",
                            onRemoveCollectionFromEvent: onRemoveCollectionFromEvent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCollectionActionSheetCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            isShow: true,
                            artistId: state.artistId
                        }, state.selectCollection), {
                            onFetchSelectCollection: onFetchSelectCollection,
                            onFetchMoreSelectCollection: onFetchMoreSelectCollection,
                            onAddCollectionsToEvent: onAddCollectionsToEvent
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapModal, {
                    title: (ref16 = (ref6 = state.event) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.location) === null || ref7 === void 0 ? void 0 : ref7.approximateAddress) !== null && ref16 !== void 0 ? ref16 : "",
                    open: openMap,
                    onClose: function() {
                        return setOpenMap(false);
                    },
                    targetData: (ref8 = state.event) === null || ref8 === void 0 ? void 0 : ref8.location,
                    currentData: (ref9 = state.gpsClientInfo) === null || ref9 === void 0 ? void 0 : ref9.currentLocation,
                    isInside: state.isInside,
                    hideAnnotation: true
                })
            ]
        })
    });
};
var ConsoleEventImageCell = function(param) {
    var loading = param.loading, thumbnail = param.thumbnail;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            width: "100%",
            height: 212
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
        imageUri: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.mediumUri
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/viewModel.ts






function ConsoleEventDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleEventDetail(\n    $id: ID!\n    $idString: String!\n    $eventPreSalePageInput: PageInput\n    $eventCollectionPageInput: PageInput\n  ) {\n    artistPreSales(eventId: $idString, pageInput: $eventPreSalePageInput) {\n      edges {\n        node {\n          ...EventPreSaleBox\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    event(id: $id) {\n      ...ConsoleEventDetail\n      eventCollections(pageInput: $eventCollectionPageInput) {\n        edges {\n          node {\n            ...ConsoleEventDetailCollectionBox\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleEventDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleEventDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SelectCollection($pageInput: PageInputDate) {\n    artistCollections(pageInput: $pageInput) {\n      ...ConsoleEventCollectionSelectConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleEventDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistAddCollectionsToEvent(\n    $inputs: ArtistAddCollecitonToEventInput!\n  ) {\n    artistAddCollectionsToEvent(inputs: $inputs) {\n      id\n      eventCollections(pageInput: { limit: 30 }) {\n        edges {\n          node {\n            ...ConsoleEventDetailCollectionBox\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEventDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleEventDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistRemoveCollectionFromEvent(\n    $inputs: ArtistRemoveCollectionFromEventInput!\n  ) {\n    artistRemoveCollectionFromEvent(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ConsoleEventDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConsoleEventDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistDeleteEvent($id: ID!) {\n    artistDeleteEvent(id: $id) {\n      id\n    }\n  }\n"
    ]);
    ConsoleEventDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







/**
 *
 */ var ConsoleEventDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref3 = (0,react.useState)(values_Date/* DateTime.now */.o.now()), updatedAt = ref3[0];
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleEventDetail_viewModel_QUERY, {
        variables: {
            id: router.query.eventId,
            idString: router.query.eventId
        }
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(SELECT_COLLECTION), 2), getSelectCollection = ref5[0], ref6 = ref5[1], selectCollection = ref6.data, gettingSelectCollection = ref6.loading, fetchMoreSelectCollection = ref6.fetchMore;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUpdatePreSale */.FW0), 1), updatePreSale = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_ADD_COLLECTIONS_TO_EVENT), 2), artistAddCollectionsToEvent = ref8[0], ref9 = ref8[1], addingCollection = ref9.loading;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_REMOVE_COLLECTIONS_FROM_EVENT), 2), artistRemoveCollectionFromEvent = ref10[0], ref11 = ref10[1], removingCollection = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUpdateEvent */.OTx), 2), artistUpdateEvent = ref12[0], ref13 = ref12[1], changingEventStatus = ref13.loading;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_DELETE_EVENT), 2), artistDeleteEvent = ref14[0], ref15 = ref14[1], deletingEvent = ref15.loading;
    var ref16 = useLocationWatcher(), permission = ref16.permission, currentLocation = ref16.currentLocation, requestPermission = ref16.requestPermission, watch = ref16.watch, unwatch = ref16.unwatch;
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    var ref17;
    var isInside = useIsInside({
        locations: [
            (ref17 = data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : ref.location) !== null && ref17 !== void 0 ? ref17 : null,
            currentLocation
        ],
        radius: 1000
    }).isInside;
    var ref18;
    var eventCollections = (0,react.useMemo)(function() {
        return (ref18 = data === null || data === void 0 ? void 0 : data.event.eventCollections.edges.filter(function(param) {
            var node = param.node;
            return node.collection.artistId === (user === null || user === void 0 ? void 0 : user.uid);
        }).map(function(param) {
            var node = param.node;
            return node;
        })) !== null && ref18 !== void 0 ? ref18 : null;
    }, [
        data === null || data === void 0 ? void 0 : data.event.eventCollections.edges,
        user === null || user === void 0 ? void 0 : user.uid
    ]);
    var collections = (0,react.useMemo)(function() {
        if (!(selectCollection === null || selectCollection === void 0 ? void 0 : selectCollection.artistCollections.edges)) {
            return null;
        }
        var artistCollections = selectCollection === null || selectCollection === void 0 ? void 0 : selectCollection.artistCollections.edges.filter(function(param) {
            var node = param.node;
            var ref;
            return !(eventCollections === null || eventCollections === void 0 ? void 0 : eventCollections.find(function(col) {
                return col.id === node.id;
            })) && !(node === null || node === void 0 ? void 0 : (ref = node.event) === null || ref === void 0 ? void 0 : ref.id);
        });
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, selectCollection === null || selectCollection === void 0 ? void 0 : selectCollection.artistCollections), {
            edges: artistCollections
        });
    }, [
        eventCollections,
        selectCollection === null || selectCollection === void 0 ? void 0 : selectCollection.artistCollections
    ]);
    var ref19, ref20, _hasNextPage, _hasNextPage1;
    return {
        state: {
            eventId: router.query.eventId,
            event: (ref19 = data === null || data === void 0 ? void 0 : data.event) !== null && ref19 !== void 0 ? ref19 : null,
            loading: loading,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            },
            tab: router.query.tab === "store" ? 1 : 0,
            collections: eventCollections,
            artistId: (ref20 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref20 !== void 0 ? ref20 : "",
            isInside: isInside,
            removingCollection: removingCollection,
            changingEventStatus: changingEventStatus,
            deletingEvent: deletingEvent,
            hasEventCollectionNextPage: (_hasNextPage = data === null || data === void 0 ? void 0 : data.event.eventCollections.pageInfo.hasNextPage) !== null && _hasNextPage !== void 0 ? _hasNextPage : false,
            hasPresalesNextPage: (_hasNextPage1 = data === null || data === void 0 ? void 0 : data.artistPreSales.pageInfo.hasNextPage) !== null && _hasNextPage1 !== void 0 ? _hasNextPage1 : false,
            // 先行販売チケットのデータ
            preSale: data === null || data === void 0 ? void 0 : data.artistPreSales,
            updatedAt: (data === null || data === void 0 ? void 0 : data.event) ? updatedAt : "",
            selectCollection: {
                loading: gettingSelectCollection,
                hasNextPage: !!(selectCollection === null || selectCollection === void 0 ? void 0 : (ref1 = selectCollection.artistCollections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
                addingCollection: addingCollection,
                collections: collections
            }
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: router.query.eventId,
                                            idString: router.query.eventId,
                                            eventCollectionPageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : data.event.eventCollections.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchPreSalesMore: function onFetchPreSalesMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: router.query.eventId,
                                            idString: router.query.eventId,
                                            eventPreSalePageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : data.artistPreSales.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRequestPermission: function onRequestPermission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.latitude)) return [
                                    2
                                ];
                                return [
                                    4,
                                    requestPermission().catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onTogglePreSalePublish: function onTogglePreSalePublish(preSale) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updatePreSale({
                                        variables: {
                                            id: preSale.id,
                                            inputs: {
                                                title: preSale.title,
                                                description: preSale.description,
                                                itemIds: preSale.itemIds,
                                                startedAt: preSale.startedAt,
                                                endedAt: preSale.endedAt,
                                                note: preSale.note,
                                                isPublished: !preSale.isPublished
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var id = param.id;
                                            return {
                                                artistUpdatePreSale: {
                                                    id: id,
                                                    __typename: "PreSale",
                                                    isPublished: !preSale.isPublished
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMoreSelectCollection: function onFetchMoreSelectCollection() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMoreSelectCollection({
                                        variables: {
                                            pageInput: {
                                                cursor: selectCollection === null || selectCollection === void 0 ? void 0 : (ref = selectCollection.artistCollections) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchSelectCollection: function onFetchSelectCollection() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getSelectCollection()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAddCollectionsToEvent: function onAddCollectionsToEvent(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistAddCollectionsToEvent({
                                        variables: {
                                            inputs: {
                                                eventId: router.query.eventId,
                                                collectionIds: values
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemoveCollectionFromEvent: function onRemoveCollectionFromEvent(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistRemoveCollectionFromEvent({
                                        variables: {
                                            inputs: {
                                                eventId: router.query.eventId,
                                                collectionId: values
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onChangeEventStatus: function onChangeEventStatus(eventStatus) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistUpdateEvent({
                                        variables: {
                                            id: router.query.eventId,
                                            input: {
                                                status: eventStatus
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteEvent: function onDeleteEvent() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistDeleteEvent({
                                        variables: {
                                            id: router.query.eventId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                router.goBack();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleEventDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleEventDetail_viewModel_templateObject(), utoniq_core_schema/* ConsoleEventDetailFragmentDoc */.SDW, utoniq_core_schema/* ConsoleEventDetailCollectionBoxFragmentDoc */.q8i, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* EventPreSaleBoxFragmentDoc */.N_p);
var SELECT_COLLECTION = (0,lib/* gql */.Ps)(ConsoleEventDetail_viewModel_templateObject1(), utoniq_core_schema/* ConsoleEventCollectionSelectConnectionFragmentDoc */.i$4);
var ARTIST_ADD_COLLECTIONS_TO_EVENT = (0,lib/* gql */.Ps)(ConsoleEventDetail_viewModel_templateObject2(), utoniq_core_schema/* ConsoleEventDetailCollectionBoxFragmentDoc */.q8i);
var ARTIST_REMOVE_COLLECTIONS_FROM_EVENT = (0,lib/* gql */.Ps)(ConsoleEventDetail_viewModel_templateObject3());
var ARTIST_DELETE_EVENT = (0,lib/* gql */.Ps)(ConsoleEventDetail_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventDetail/index.tsx




/**
 * ConsoleEventDetail Page
 * Implemented as a practical sample.
 */ var ConsoleEventDetail_ConsoleEventDetail = function() {
    var ref = ConsoleEventDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventEdit/template/index.tsx













var ConsoleEventEditTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit, onRequestGPSPermission = param.onRequestGPSPermission, onSelectPlace = param.onSelectPlace, onPlaceSearch = param.onPlaceSearch;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEventEdit").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerNames = ref1.routerNames;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref2 = (0,react.useState)(false), openCancel = ref2[0], setOpenCancel = ref2[1];
    var method = (0,core_form/* useForm */.cI)({
        schema: EventEditForm_schema,
        defaultValues: EventEditForm_defaultValues
    });
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        if (!state.event) {
            return;
        }
        var _title, _description, ref7, _note, _startedAt, _endedAt, ref8, ref9, ref10, ref11, _publishStartedAt, _publishEndedAt;
        method.reset({
            title: (_title = state.event.title) !== null && _title !== void 0 ? _title : "",
            description: (_description = state.event.description) !== null && _description !== void 0 ? _description : "",
            thumbnailPath: (ref7 = (ref = state.event.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref7 !== void 0 ? ref7 : "",
            thumbnailResource: buildResource(state.event.thumbnail),
            note: (_note = state.event.note) !== null && _note !== void 0 ? _note : "",
            startedAt: (_startedAt = state.event.startedAt) !== null && _startedAt !== void 0 ? _startedAt : null,
            endedAt: (_endedAt = state.event.endedAt) !== null && _endedAt !== void 0 ? _endedAt : null,
            location: {
                latitude: (ref8 = (ref1 = state.event.location) === null || ref1 === void 0 ? void 0 : ref1.latitude) !== null && ref8 !== void 0 ? ref8 : 0,
                longitude: (ref9 = (ref2 = state.event.location) === null || ref2 === void 0 ? void 0 : ref2.longitude) !== null && ref9 !== void 0 ? ref9 : 0,
                approximateAddress: (ref10 = (ref3 = state.event.location) === null || ref3 === void 0 ? void 0 : ref3.approximateAddress) !== null && ref10 !== void 0 ? ref10 : "",
                mapUri: (ref11 = (0,lib_url/* encodeUrl */.Mq)((ref4 = state.event.location) === null || ref4 === void 0 ? void 0 : ref4.mapUri)) !== null && ref11 !== void 0 ? ref11 : ""
            },
            closeDate: ((ref5 = state.event.closeDate) === null || ref5 === void 0 ? void 0 : ref5.length) ? (ref6 = state.event.closeDate) === null || ref6 === void 0 ? void 0 : ref6.map(function(date) {
                return {
                    date: date
                };
            }) : [
                {
                    date: null
                }
            ],
            isPublished: state.event.status === utoniq_core_schema/* EventStatus.Published */.N3X.Published,
            publishStartedAt: (_publishStartedAt = state.event.publishStartedAt) !== null && _publishStartedAt !== void 0 ? _publishStartedAt : state.event.createdAt,
            publishEndedAt: (_publishEndedAt = state.event.publishEndedAt) !== null && _publishEndedAt !== void 0 ? _publishEndedAt : null
        });
    }, [
        state.event
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    color: "white",
                    onClick: function() {
                        if (method.formState.isDirty) {
                            return setOpenCancel(true);
                        }
                        router.goBack();
                    }
                }),
                title: (ref = state.event) === null || ref === void 0 ? void 0 : ref.title,
                type: "modal"
            },
            customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedButtonArea, {
                mode: "update",
                method: method,
                onSubmit: onSubmit
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleShokufesEventEdit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventEditForm, {
                    artistId: state.artistId,
                    method: method,
                    fileUploadInfo: {
                        progress: state.progress,
                        onDrop: onDrop
                    },
                    predictions: state.predictions,
                    place: state.place,
                    onSelectPlace: onSelectPlace,
                    onPlaceSearch: onPlaceSearch,
                    gpsClientInfo: state.gpsClientInfo,
                    onRequestGPSPermission: onRequestGPSPermission
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    title: t("updateCancelCreateEventModalTitle"),
                    content: t("updateCancelCreateEventModalDesc"),
                    open: openCancel,
                    onClose: function() {
                        return setOpenCancel(false);
                    },
                    cancelText: t("close"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        onClick: function() {
                            showMessage(t("updateCancelCreateEventSuccess"), "success");
                            router.goBack();
                        },
                        sx: {
                            minWidth: 212
                        },
                        children: t("updateCancelCreateEventBtn")
                    })
                })
            ]
        })
    });
};
function buildResource(resource) {
    if (!resource) {
        return null;
    }
    var _path, _path1, _mediumUri;
    return {
        id: (_path = resource.path) !== null && _path !== void 0 ? _path : "",
        resourceName: (_path1 = resource.path) !== null && _path1 !== void 0 ? _path1 : "",
        imageUrl: (_mediumUri = resource.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : "",
        imageUploadPath: undefined
    };
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEventEdit/index.tsx




/**
 * ConsoleEventEdit Page
 * Implemented as a practical sample.
 */ var ConsoleEventEdit = function() {
    var ref = ConsoleEventEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleEventItemSkeleton/index.tsx




var ConsoleEventItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    py: 2,
                    px: 4,
                    "&:last-child": {
                        pb: 2
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            sx: {
                                height: 70,
                                width: 100
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium",
                                            width: "20%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium",
                                            width: "60%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    numberOfLine: 2
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEvents/template/index.tsx













var ConsoleEventsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilter = param.onFilter, onChangeEventStatus = param.onChangeEventStatus, onDeleteEvent = param.onDeleteEvent;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEvents").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, routerNames = ref1.routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                right: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    component: "a",
                    sx: {
                        minWidth: 124,
                        mr: -3,
                        color: "white"
                    },
                    variant: "text",
                    target: "_blank",
                    href: routerPages.ShokufesEvents,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                            color: "inherit"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            sx: {
                                ml: 1
                            },
                            color: "inherit",
                            variant: "subtitle1",
                            children: t("viewTheApp")
                        })
                    ]
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleShokufesEvents
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingCell, {
                    loading: state.loading && !state.events,
                    onFilter: onFilter,
                    filter: state.filter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref = state.events) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                        var node = param.node;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventItem, {
                            event: node,
                            artistId: state.artistId,
                            changingEventStatus: state.changingEventStatus,
                            deletingEvent: state.deletingEvent,
                            onChangeEventStatus: function(status) {
                                return onChangeEventStatus(node.id, status);
                            },
                            onDeleteEvent: function() {
                                return onDeleteEvent(node.id);
                            }
                        }, node.id);
                    }),
                    emptyMessage: t("eventEmptyMessage"),
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 5,
                        sx: {
                            pt: 2
                        },
                        children: Array.from(Array(3).keys()).map(function(index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventItemSkeleton, {}, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEvents_template_BaseCell, {})
            ]
        })
    });
};
var HeadingCell = function(param) {
    var loading = param.loading, onFilter = param.onFilter, filter = param.filter;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleEvents").t;
    var options = [
        utoniq_core_schema/* EventFilter.All */.DrI.All,
        utoniq_core_schema/* EventFilter.Ongoing */.DrI.Ongoing,
        utoniq_core_schema/* EventFilter.Upcoming */.DrI.Upcoming,
        utoniq_core_schema/* EventFilter.Finished */.DrI.Finished, 
    ];
    // sort と options を比較して一致した値の添え字を返し、selectedIndex の初期値にする
    var initialSelectedIndex = filter ? options.findIndex(function(option) {
        return option === filter;
    }) : 0;
    var ref = (0,react.useState)(initialSelectedIndex), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var open = Boolean(anchorEl);
    var handleClickItem = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleMenuItemClick = function(index) {
        setSelectedIndex(index);
        onFilter(options[index]);
        setAnchorEl(null);
    };
    (0,react.useEffect)(function() {
        var UrlParams = "?sort=".concat(options[selectedIndex]);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedIndex
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "40%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "10%"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            direction: "row",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    onClick: handleClickItem,
                    sx: {
                        mr: -1
                    },
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        fontSize: "xSmall"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t(options[selectedIndex])
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                    anchorEl: anchorEl,
                    open: open,
                    onClose: handleClose,
                    children: options.map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                            selected: index === selectedIndex,
                            sx: {
                                minWidth: 200
                            },
                            onClick: function() {
                                return handleMenuItemClick(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t(option)
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
var ConsoleEvents_template_BaseCell = function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                position: "fixed",
                bottom: 16,
                zIndex: 5,
                maxWidth: 600,
                margin: "0 auto",
                px: 4,
                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "medium",
                color: "primary",
                onClick: function() {
                    return router.push(routerPages.ConsoleShokufesEventCreate);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEvents/viewModel.ts






function ConsoleEvents_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleEvents($filter: EventFilter!, $pageInput: PageInput) {\n    artistEvents(filter: $filter, pageInput: $pageInput) {\n      edges {\n        node {\n          ... on Event {\n            ...ConsoleEventList\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleEvents_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ConsoleEvents_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var params = new URLSearchParams(window.location.search);
    var eventFilter = params.get("sort");
    // sort と EventFilter を比較して一致する値を取得
    var initialSelectedValue = Object.values(utoniq_core_schema/* EventFilter */.DrI).includes(eventFilter) ? eventFilter : utoniq_core_schema/* EventFilter.All */.DrI.All;
    var ref3 = (0,react.useState)(initialSelectedValue), filter = ref3[0], setFilter = ref3[1];
    var isFirstLoadRef = useGetNewestData({
        query: ConsoleEvents_viewModel_QUERY,
        variables: {
            filter: filter
        },
        fields: [
            {
                fragmentName: "ConsoleEventList",
                fieldName: "artistEvents",
                fragment: utoniq_core_schema/* ConsoleEventListFragmentDoc */.FVw
            }, 
        ]
    }).isFirstLoadRef;
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleEvents_viewModel_QUERY, {
        variables: {
            filter: filter
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore, refetch = ref4.refetch;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUpdateEvent */.OTx), 2), artistUpdateEvent = ref5[0], ref6 = ref5[1], changingEventStatus = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistDeleteEvent */.EOZ), 2), artistDeleteEvent = ref7[0], ref8 = ref7[1], deletingEvent = ref8.loading;
    // fixed issue duplicate events on graphql cached
    var events = (0,react.useMemo)(function() {
        if (!(data === null || data === void 0 ? void 0 : data.artistEvents)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.artistEvents), {
            edges: uniqBy_default()(data.artistEvents.edges, "node.id")
        });
    }, [
        data === null || data === void 0 ? void 0 : data.artistEvents
    ]);
    var ref9, ref10, ref11;
    return {
        state: {
            events: events,
            loading: loading,
            currentUser: user,
            artist: (ref9 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref9 !== void 0 ? ref9 : null,
            changingEventStatus: changingEventStatus,
            deletingEvent: deletingEvent,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistEvents) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            filter: filter,
            membership: (ref11 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.products) !== null && ref11 !== void 0 ? ref11 : undefined
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            filter: filter,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistEvents) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilter: function onFilter(filterType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (filterType === filter) return [
                            2
                        ];
                        refetch({
                            filter: filterType,
                            pageInput: {
                                cursor: null
                            }
                        });
                        setFilter(filterType);
                        return [
                            2
                        ];
                    });
                })();
            },
            onChangeEventStatus: function onChangeEventStatus(eventId, status) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistUpdateEvent({
                                        variables: {
                                            id: eventId,
                                            input: {
                                                status: status
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteEvent: function onDeleteEvent(eventId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistDeleteEvent({
                                        variables: {
                                            id: eventId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleEvents_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleEvents_viewModel_templateObject(), utoniq_core_schema/* ConsoleEventListFragmentDoc */.FVw);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleEvents/index.tsx




/**
 * ConsoleEvents Page
 * Implemented as a practical sample.
 */ var ConsoleEvents = function() {
    var ref = ConsoleEvents_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFans/template/index.tsx










var ConsoleFansTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFans").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                defaultBackPage: routerPages.ConsoleFavoriteMemberSettings,
                title: t("title")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2,
                    pb: 5,
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberHeaderCell, {
                        favoriteMember: state.favoriteMember,
                        loading: state.loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteFansListCell, {
                        fans: state.favoriteMember.fans,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore
                    })
                ]
            })
        })
    });
};
var FavoriteMemberHeaderCell = function(param) {
    var favoriteMember = param.favoriteMember, loading = param.loading;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                textAlign: "center",
                py: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 80,
                    height: 80,
                    sx: {
                        mx: "auto",
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h6",
                    width: "40%",
                    sx: {
                        mx: "auto"
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            textAlign: "center",
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                src: favoriteMember.avatar,
                sx: {
                    width: 80,
                    height: 80,
                    mx: "auto",
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Avatar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                children: favoriteMember.name
            })
        ]
    });
};
var FavoriteFansListCell = function(param) {
    var fans = param.fans, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFans").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: "none",
                                        py: 2,
                                        px: 0,
                                        minWidth: 200
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("memberName")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: "none",
                                        py: 2,
                                        px: 1,
                                        minWidth: 120,
                                        textAlign: "right"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("registrationDate")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        nodes: fans.map(function(fan) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCellCustom, {
                                        userId: fan.id,
                                        sx: {
                                            px: 0,
                                            minWidth: 200
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            sx: {
                                                maxWidth: "100%"
                                            },
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: (ref = fan.avatar) === null || ref === void 0 ? void 0 : ref.uri,
                                                    sx: {
                                                        width: 28,
                                                        height: 28
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: fan.displayName
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCellCustom, {
                                        userId: fan.id,
                                        sx: {
                                            minWidth: 120,
                                            textAlign: "right"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: fan.formattedCreatedAt
                                        })
                                    })
                                ]
                            }, fan.id);
                        }),
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        colSpan: 2,
                        component: TableRow/* default */.Z,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Array.from(Array(3).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                px: 0,
                                                py: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                        variant: "circular",
                                                        width: 28,
                                                        height: 28
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "medium",
                                                        width: "80%"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                px: 0,
                                                py: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "caption",
                                                width: 100
                                            })
                                        })
                                    ]
                                }, key);
                            })
                        })
                    })
                ]
            })
        })
    });
};
var TableCellCustom = function(param) {
    var userId = param.userId, children = param.children, sx = param.sx;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var handleClick = function() {
        router.push(generatePath(routerPages.ConsoleUserDetail, {
            userId: userId
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            px: 1,
            py: 3,
            cursor: "pointer"
        }, sx),
        onClick: handleClick,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFans/viewModel.ts



function ConsoleFans_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistFavoriteMembersForFans(\n    $pageInput: PageInput\n    $inputs: ArtistFavoriteMembersInput!\n  ) {\n    artistFavoriteMembers(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n      fans(pageInput: $pageInput) {\n        edges {\n          node {\n            ... on MyFavoriteMember {\n              id\n              createdAt\n              formattedCreatedAt @client\n              user {\n                id\n                displayName\n                avatar {\n                  uri\n                }\n              }\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleFans_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ConsoleFans_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var favoriteMemberId = router.query.favoriteMemberId;
    var ref4 = (0,useQuery/* useQuery */.aM)(ARTIST_FAVORITE_MEMBERS_FOR_FANS_QUERY, {
        variables: {
            inputs: {
                favoriteMemberId: favoriteMemberId || ""
            },
            pageInput: {
                limit: 10
            }
        },
        skip: !(user === null || user === void 0 ? void 0 : user.uid) || !favoriteMemberId
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var rawFavoriteMember = data === null || data === void 0 ? void 0 : (ref = data.artistFavoriteMembers) === null || ref === void 0 ? void 0 : ref[0];
    var ref5, _displayName, ref6, _formattedCreatedAt;
    var fans = ((ref5 = rawFavoriteMember === null || rawFavoriteMember === void 0 ? void 0 : (ref1 = rawFavoriteMember.fans) === null || ref1 === void 0 ? void 0 : ref1.edges) !== null && ref5 !== void 0 ? ref5 : []).map(function(edge) {
        return edge.node;
    }).map(function(fan) {
        var ref;
        return {
            id: fan.user.id,
            displayName: (_displayName = fan.user.displayName) !== null && _displayName !== void 0 ? _displayName : "",
            avatar: {
                uri: (ref6 = (ref = fan.user.avatar) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref6 !== void 0 ? ref6 : ""
            },
            formattedCreatedAt: (_formattedCreatedAt = fan.formattedCreatedAt) !== null && _formattedCreatedAt !== void 0 ? _formattedCreatedAt : ""
        };
    });
    var pageInfo = rawFavoriteMember === null || rawFavoriteMember === void 0 ? void 0 : (ref2 = rawFavoriteMember.fans) === null || ref2 === void 0 ? void 0 : ref2.pageInfo;
    var ref7, ref8, ref9, ref10, ref11;
    return {
        state: {
            artistId: (ref7 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref7 !== void 0 ? ref7 : "",
            loading: loading,
            hasNextPage: (ref8 = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage) !== null && ref8 !== void 0 ? ref8 : false,
            favoriteMember: {
                id: (ref9 = rawFavoriteMember === null || rawFavoriteMember === void 0 ? void 0 : rawFavoriteMember.id) !== null && ref9 !== void 0 ? ref9 : "",
                name: (ref10 = rawFavoriteMember === null || rawFavoriteMember === void 0 ? void 0 : rawFavoriteMember.name) !== null && ref10 !== void 0 ? ref10 : "",
                avatar: (ref11 = rawFavoriteMember === null || rawFavoriteMember === void 0 ? void 0 : (ref3 = rawFavoriteMember.avatar) === null || ref3 === void 0 ? void 0 : ref3.uri) !== null && ref11 !== void 0 ? ref11 : "",
                fans: fans
            }
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage)) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            inputs: {
                                                favoriteMemberId: favoriteMemberId || ""
                                            },
                                            pageInput: {
                                                cursor: pageInfo.endCursor,
                                                limit: 10
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ARTIST_FAVORITE_MEMBERS_FOR_FANS_QUERY = (0,lib/* gql */.Ps)(ConsoleFans_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFans/index.tsx




/**
 * ConsoleFans Page
 * 推し登録者一覧画面
 */ var ConsoleFans = function() {
    var ref = ConsoleFans_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFansTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/FavoriteMemberForm/FavoriteMemberImageUploadCell.tsx







var FavoriteMemberImageUploadCell = function(param) {
    var onDrop = param.onDrop, setValue = param.setValue, onDelete = param.onDelete, progress = param.progress, defaultResource = param.defaultResource, fieldName = param.fieldName, translationNamespace = param.translationNamespace;
    var t = (0,core_i18n/* useTranslation */.$G)(translationNamespace).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                position: "relative"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                shape: "circle",
                resource: defaultResource,
                t: t,
                fileUploadInfo: {
                    type: "image",
                    onDrop: function onDrop1() {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            var result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onDrop()
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result) {
                                            setValue(fieldName, result.imageUploadPath, {
                                                shouldValidate: true
                                            });
                                        }
                                        return [
                                            2,
                                            result || undefined
                                        ];
                                }
                            });
                        })();
                    },
                    progress: progress,
                    description: t("imageDescription"),
                    onClose: function onClose() {
                        if (onDelete) {
                            onDelete();
                        }
                    }
                },
                content: {
                    title: t("addImage")
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/FavoriteMemberForm/FavoriteMemberNameInputCell.tsx




var FavoriteMemberNameInputCell = function(param) {
    var value = param.value, onChange = param.onChange, error = param.error, translationNamespace = param.translationNamespace, placeholder = param.placeholder;
    var t = (0,core_i18n/* useTranslation */.$G)(translationNamespace).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mb: 2
                },
                children: t("memberName")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                value: value,
                onChange: function(e) {
                    return onChange(e.target.value);
                },
                placeholder: placeholder || t("memberNamePlaceholder"),
                fullWidth: true,
                error: !!error,
                helperText: error === null || error === void 0 ? void 0 : error.message,
                color: "primary"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberCreate/template/FavoriteMemberCreateForm.tsx






var FavoriteMemberCreateForm_schema = function(o) {
    return {
        avatarPath: o.string().allow(null),
        memberName: o.string().max(50).custom(function(value, helpers) {
            // 特殊文字チェック
            var match = value.match(/[=+\-@\t\r\n;,]+/);
            if (match) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("common:inputContainSpecialChars", {
                        label: (0,core_form/* tLabel */.TQ)("consoleFavoriteMemberCreate.memberName")
                    })
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleFavoriteMemberCreate.memberName"))
    };
};
var FavoriteMemberCreateForm = function(param) {
    var onDrop = param.onDrop, onSubmit = param.onSubmit, progress = param.progress, isSubmitting = param.isSubmitting;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberCreate").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: FavoriteMemberCreateForm_schema,
        defaultValues: {
            avatarPath: null,
            memberName: ""
        }
    }), handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid, setValue = ref1.setValue, setError = ref1.setError, watch = ref1.watch;
    var handleFormSubmit = handleSubmit(function(values) {
        return onSubmit({
            avatarPath: values.avatarPath || "",
            name: values.memberName
        }).then(function() {
            setValue("avatarPath", null, {
                shouldValidate: true
            });
            showMessage(t("createSuccess"), "success");
        }).catch(function(error) {
            (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        id: "favorite-member-create-form",
        onSubmit: handleFormSubmit,
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberImageUploadCell, {
                onDrop: onDrop,
                setValue: setValue,
                onDelete: function() {
                    return setValue("avatarPath", null, {
                        shouldValidate: true
                    });
                },
                progress: progress,
                fieldName: "avatarPath",
                translationNamespace: "consoleFavoriteMemberCreate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberNameInputCell, {
                value: watch("memberName"),
                onChange: function(value) {
                    setValue("memberName", value, {
                        shouldValidate: true
                    });
                },
                error: errors === null || errors === void 0 ? void 0 : errors.memberName,
                translationNamespace: "consoleFavoriteMemberCreate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: isSubmitting || !isValid,
                    loading: isSubmitting,
                    children: t("register")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberCreate/template/index.tsx





var ConsoleFavoriteMemberCreateTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                defaultBackPage: routerPages.ConsoleFavoriteMemberSettings,
                title: t("title")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberCreateForm, {
                onSubmit: onSubmit,
                progress: state.progress,
                onDrop: onDrop,
                isSubmitting: state.creatingMember
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberCreate/viewModel.ts





function ConsoleFavoriteMemberCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateFavoriteMember($inputs: ArtistCreateFavoriteMemberInput!) {\n    artistCreateFavoriteMember(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ConsoleFavoriteMemberCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var reloadUser = (0,auth/* useAuth */.aC)().reloadUser;
    var getImage = camera/* getImage */.g;
    var ref1;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)((ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : ""), upload = ref2.upload, progress = ref2.progress;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_FAVORITE_MEMBER_MUTATION), 2), createFavoriteMember = ref3[0], ref4 = ref3[1], creatingMember = ref4.loading;
    var ref5;
    return {
        state: {
            creatingMember: creatingMember,
            artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
            progress: progress
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createFavoriteMember({
                                        variables: {
                                            inputs: {
                                                avatarPath: values.avatarPath,
                                                name: values.name
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    reloadUser()
                                ];
                            case 2:
                                _state.sent();
                                router.goBack(routerPages.ConsoleFavoriteMemberSettings);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                                ];
                            case 1:
                                file = _state.sent();
                                if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                                    throw new Error("uploadErrorMaximumSize");
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUploadPath: tmpPath,
                                        imageUrl: fileUrl
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0,_instanceof/* default */.Z)(error, Error)) {
                                    if (error.message === "uploadErrorMaximumSize") {
                                        showError(new Error(t("uploadErrorMaximumSize")));
                                    } else if (error.message === "uploadErrorImageOnly") {
                                        showError(new Error(t("uploadErrorImageOnly")));
                                    } else {
                                        showError(error);
                                    }
                                } else {
                                    showError(error);
                                }
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CREATE_FAVORITE_MEMBER_MUTATION = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberCreate_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberCreate/index.tsx




/**
 * ConsoleFavoriteMemberCreate Page
 * 推し登録画面
 */ var ConsoleFavoriteMemberCreate = function() {
    var ref = ConsoleFavoriteMemberCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFavoriteMemberCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberEdit/template/FavoriteMemberEditForm.tsx







var FavoriteMemberEditForm_schema = function(o) {
    return {
        memberName: o.string().max(50).custom(function(value, helpers) {
            // 特殊文字チェック
            var match = value.match(/[=+\-@\t\r\n;,]+/);
            if (match) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("common:inputContainSpecialChars", {
                        label: (0,core_form/* tLabel */.TQ)("consoleFavoriteMemberEdit.memberName")
                    })
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("consoleFavoriteMemberEdit.memberName")),
        avatarPath: o.string().allow(null)
    };
};
var FavoriteMemberEditForm = function(param) {
    var onSubmit = param.onSubmit, onDrop = param.onDrop, progress = param.progress, _isSubmitting = param.isSubmitting, isSubmitting = _isSubmitting === void 0 ? false : _isSubmitting, favoriteMember = param.favoriteMember;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: FavoriteMemberEditForm_schema,
        defaultValues: {
            memberName: "",
            avatarPath: null
        }
    }), handleSubmit = ref.handleSubmit, setValue = ref.setValue, watch = ref.watch, reset = ref.reset, errors = ref.formState.errors;
    // 初期値のアバター画像
    var defaultAvatarResource = (0,react.useMemo)(function() {
        return {
            id: "",
            resourceName: "",
            imageUrl: favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.avatar,
            imageUploadPath: favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.avatar
        };
    }, [
        favoriteMember
    ]);
    // 初期値が変更されたときにフォームをリセット
    (0,react.useEffect)(function() {
        reset({
            memberName: favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.name,
            avatarPath: favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.avatar
        });
    }, [
        favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.avatar,
        favoriteMember === null || favoriteMember === void 0 ? void 0 : favoriteMember.name
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit({
            name: values.memberName,
            avatarPath: values.avatarPath || ""
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        id: "favorite-member-edit-form",
        onSubmit: handleOnSubmit,
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberImageUploadCell, {
                onDrop: onDrop,
                setValue: setValue,
                onDelete: function() {
                    setValue("avatarPath", null, {
                        shouldValidate: true
                    });
                },
                progress: progress,
                defaultResource: defaultAvatarResource,
                fieldName: "avatarPath",
                translationNamespace: "consoleFavoriteMemberEdit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberNameInputCell, {
                value: watch("memberName"),
                onChange: function(value) {
                    setValue("memberName", value, {
                        shouldValidate: true
                    });
                },
                error: errors === null || errors === void 0 ? void 0 : errors.memberName,
                translationNamespace: "consoleFavoriteMemberEdit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    variant: "contained",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: isSubmitting || !watch("avatarPath") || !watch("memberName").trim(),
                    loading: isSubmitting,
                    children: t("register")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberEdit/template/index.tsx







var ConsoleFavoriteMemberEditTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                defaultBackPage: routerPages.ConsoleFavoriteMemberSettings,
                title: t("title")
            },
            children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberEditSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberEditForm, {
                onSubmit: onSubmit,
                onDrop: onDrop,
                progress: state.progress,
                isSubmitting: state.updatingMember,
                favoriteMember: state.favoriteMember
            })
        })
    });
};
var FavoriteMemberEditSkeleton = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "text",
                            width: 120,
                            height: 32,
                            sx: {
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "circular",
                            width: 250,
                            height: 250,
                            sx: {
                                borderRadius: "50%",
                                mx: "auto",
                                display: "block"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        width: 100,
                        height: 32,
                        sx: {
                            mb: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 56
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 244,
                    height: 48,
                    sx: {
                        borderRadius: 1,
                        mx: "auto",
                        display: "block"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberEdit/viewModel.ts





function ConsoleFavoriteMemberEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateFavoriteMember($inputs: ArtistUpdateFavoriteMemberInput!) {\n    artistUpdateFavoriteMember(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleFavoriteMemberEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetFavoriteMember($inputs: ArtistFavoriteMembersInput!) {\n    artistFavoriteMembers(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConsoleFavoriteMemberEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showError = ref.showError, showMessage = ref.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberEdit").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router;
    var getImage = camera/* getImage */.g;
    var ref2;
    var ref3 = (0,useTmpUploader/* useUserTmpUploader */.x)((ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : ""), upload = ref3.upload, progress = ref3.progress;
    var favoriteMemberId = router.query.favoriteMemberId;
    var ref4 = (0,useQuery/* useQuery */.aM)(GET_FAVORITE_MEMBER_QUERY, {
        variables: {
            inputs: {
                favoriteMemberId: favoriteMemberId
            }
        }
    }), data = ref4.data, loading = ref4.loading, error = ref4.error;
    var favoriteMember = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2;
        return (data === null || data === void 0 ? void 0 : (ref = data.artistFavoriteMembers) === null || ref === void 0 ? void 0 : ref[0]) ? {
            favoriteMemberId: data.artistFavoriteMembers[0].id,
            name: data.artistFavoriteMembers[0].name,
            avatar: (ref2 = (ref1 = data.artistFavoriteMembers[0].avatar) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref2 !== void 0 ? ref2 : ""
        } : undefined;
    }, [
        data === null || data === void 0 ? void 0 : data.artistFavoriteMembers
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_FAVORITE_MEMBER_MUTATION), 2), updateFavoriteMember = ref5[0], ref6 = ref5[1], updatingMember = ref6.loading;
    var ref7;
    return {
        state: {
            artistId: (ref7 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref7 !== void 0 ? ref7 : "",
            progress: progress,
            favoriteMemberId: favoriteMemberId || "",
            favoriteMember: favoriteMember,
            updatingMember: updatingMember,
            loading: loading
        },
        actions: {
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                                ];
                            case 1:
                                file = _state.sent();
                                if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                                    throw new Error("uploadErrorMaximumSize");
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUploadPath: tmpPath,
                                        imageUrl: fileUrl
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0,_instanceof/* default */.Z)(error, Error)) {
                                    if (error.message === "uploadErrorMaximumSize") {
                                        showError(new Error(t("uploadErrorMaximumSize")));
                                    } else if (error.message === "uploadErrorImageOnly") {
                                        showError(new Error(t("uploadErrorImageOnly")));
                                    } else {
                                        showError(error);
                                    }
                                } else {
                                    showError(error);
                                }
                                return [
                                    2,
                                    null
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateFavoriteMember({
                                        variables: {
                                            inputs: {
                                                id: favoriteMemberId,
                                                avatarPath: values.avatarPath || "",
                                                name: values.name
                                            }
                                        }
                                    }).catch(function(error) {
                                        showError(error);
                                        throw error;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("updateSuccess"), "success");
                                // 更新成功後、推しメンバー一覧に遷移
                                router.goBack(routerPages.ConsoleFavoriteMemberSettings);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var UPDATE_FAVORITE_MEMBER_MUTATION = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberEdit_viewModel_templateObject());
var GET_FAVORITE_MEMBER_QUERY = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberEdit_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberEdit/index.tsx




/**
 * ConsoleFavoriteMemberEdit Page
 * 推し編集画面
 */ var ConsoleFavoriteMemberEdit = function() {
    var ref = ConsoleFavoriteMemberEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFavoriteMemberEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/core/DndProvider.js + 34 modules
var DndProvider = __webpack_require__(8733);
// EXTERNAL MODULE: ../../node_modules/react-dnd-html5-backend/dist/index.js + 12 modules
var react_dnd_html5_backend_dist = __webpack_require__(52797);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/template/components/DeleteFavoriteMemberModal.tsx








var DeleteFavoriteMemberModal = function(param) {
    var open = param.open, onClose = param.onClose, onDelete = param.onDelete, memberId = param.memberId, memberName = param.memberName;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var handleDelete = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                return [
                    2,
                    onDelete(memberId).then(function() {
                        showMessage(t("completeRemoveMember"));
                        onClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleFavoriteMemberDelete");
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("deleteMemberModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("removeMemberDescription", {
                        memberName: memberName
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        fullWidth: true,
                        onClick: handleDelete,
                        loading: loading,
                        disabled: loading,
                        children: t("removeMember")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        children: t("cancel")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/template/components/DisableFavoriteMemberModal.tsx








var DisableFavoriteMemberModal = function(param) {
    var open = param.open, onClose = param.onClose, onDisable = param.onDisable;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var handleDisable = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                return [
                    2,
                    onDisable().then(function() {
                        onClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleFavoriteMemberDisable");
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function handleDisable() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("disableSettingsModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("disableSettingsDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        fullWidth: true,
                        onClick: handleDisable,
                        loading: loading,
                        disabled: loading,
                        children: t("changeSettings")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        children: t("cancel")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/hooks/useDrop/useDrop.js + 9 modules
var useDrop = __webpack_require__(20103);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/hooks/useDrag/useDrag.js + 9 modules
var useDrag = __webpack_require__(92843);
;// CONCATENATED MODULE: ./src/lib/dnd/index.ts



/**
 * hook for dnd vertical
 * @param index
 * @param accept
 * @param onMove
 * @param disabled
 */ var useVerticalDnD = function(param) {
    var index = param.index, accept = param.accept, onMove = param.onMove, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useDrop/* useDrop */.L)({
        accept: accept,
        collect: function collect(monitor) {
            return {
                handlerId: monitor.getHandlerId()
            };
        },
        hover: function hover(item, monitor) {
            var ref1;
            if (!ref.current || disabled) {
                return;
            }
            var dragIndex = item.index;
            var hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            var hoverBoundingRect = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
            // Get vertical middle
            var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            var clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            var hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        },
        drop: function drop(item) {
            // Only call onMove when actually dropping after dragging (for API calls)
            if (!disabled && item.originalIndex !== index) {
                onMove(item.originalIndex, index);
            }
        }
    }), 2), handlerId = ref1[0].handlerId, drop = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useDrag/* useDrag */.c)({
        type: accept,
        item: function() {
            return {
                index: index,
                originalIndex: index
            };
        },
        collect: function(monitor) {
            return {
                opacity: monitor.isDragging() ? 0.4 : 1
            };
        },
        canDrag: !disabled
    }), 3), opacity = ref2[0].opacity, drag = ref2[1], preview = ref2[2];
    preview(drop(ref));
    return {
        ref: ref,
        drag: drag,
        opacity: opacity
    };
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/template/components/FavoriteMemberDragList.tsx







var FavoriteMemberDragList = function(param) {
    var favoriteMembers = param.favoriteMembers, onMove = param.onMove, onGoToEdit = param.onGoToEdit, onGoToCreate = param.onGoToCreate, onGoToUsers = param.onGoToUsers, onDelete = param.onDelete, onShowDeleteModal = param.onShowDeleteModal, loading = param.loading, sortingMember = param.sortingMember;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    if (loading && !sortingMember) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                width: "60%",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 36,
                                height: 17,
                                sx: {
                                    borderRadius: "40px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: Array.from({
                            length: 5
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberSkeleton, {}, index);
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            color: "text.secondary",
                            variant: "body2",
                            sx: {
                                flex: 1,
                                mr: 2
                            },
                            children: t("maxMembersMessage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                width: 36,
                                height: 17,
                                flexShrink: 0,
                                borderRadius: "40px",
                                border: "1px solid",
                                borderColor: "grey.100",
                                backgroundColor: "grey.100",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                px: 5,
                                py: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "primary",
                                children: t("memberCountDisplay", {
                                    current: favoriteMembers.length
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    sx: {
                        // プラスアイコンと設定ボタンが被らないよう空白を設定
                        "&::after": {
                            content: '""',
                            display: "block",
                            height: 50
                        }
                    },
                    children: favoriteMembers.map(function(member, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberItem, {
                            member: member,
                            index: index,
                            onMove: onMove,
                            onGoToEdit: onGoToEdit,
                            onGoToUsers: onGoToUsers,
                            onDelete: onDelete,
                            onShowDeleteModal: onShowDeleteModal,
                            sortingMember: sortingMember
                        }, member.id);
                    })
                })
            ]
        })
    });
};
var FavoriteMemberItem = function(param) {
    var member = param.member, index = param.index, onMove = param.onMove, onGoToEdit = param.onGoToEdit, onGoToUsers = param.onGoToUsers, onDelete = param.onDelete, onShowDeleteModal = param.onShowDeleteModal, sortingMember = param.sortingMember;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var ref1 = useVerticalDnD({
        index: index,
        onMove: onMove,
        accept: "FAVORITE_MEMBER",
        disabled: sortingMember
    }), ref2 = ref1.ref, drag = ref1.drag, opacity = ref1.opacity;
    var ref3 = (0,react.useState)(null), anchorEl = ref3[0], setAnchorEl = ref3[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var options = [
        {
            label: t("editMember"),
            onClick: function onClick() {
                onGoToEdit(member.id);
                handleClose();
            }
        },
        {
            label: t("memberList"),
            onClick: function onClick() {
                onGoToUsers(member.id);
                handleClose();
            }
        },
        {
            label: t("delete"),
            onClick: function onClick() {
                onShowDeleteModal(member);
                handleClose();
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                ref: ref2,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    p: 2,
                    borderRadius: 1,
                    opacity: opacity,
                    position: "relative",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 2,
                        backgroundColor: "transparent",
                        transition: "background-color 0.2s ease"
                    },
                    "&:hover::before": {
                        backgroundColor: "primary.main"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                        size: "small",
                        ref: drag,
                        disableRipple: true,
                        disabled: sortingMember,
                        sx: {
                            mr: 1,
                            opacity: sortingMember ? 0.5 : 1,
                            cursor: sortingMember ? "not-allowed" : "grab"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Sort, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: member.avatar,
                        sx: {
                            width: 40,
                            height: 40,
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: {
                                    wordWrap: "break-word",
                                    wordBreak: "break-all"
                                },
                                children: member.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "text.secondary",
                                children: t("memberCount", {
                                    count: member.fanCount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                backgroundColor: "grey.50"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                size: "small",
                                onClick: handleClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Setting, {
                                    sx: {
                                        color: "black"
                                    }
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                children: options.map(function(param) {
                    var label = param.label, onClick = param.onClick;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        onClick: onClick,
                        children: label
                    }, label);
                })
            })
        ]
    });
};
var FavoriteMemberSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center",
            p: 2,
            borderRadius: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "circular",
                width: 24,
                height: 24,
                sx: {
                    mr: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "circular",
                width: 40,
                height: 40,
                sx: {
                    mr: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        width: "40%",
                        height: 24,
                        sx: {
                            mb: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        width: "30%",
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "circular",
                width: 32,
                height: 32
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/template/components/MaxMembersReachedModal.tsx




var MaxMembersReachedModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("maxMembersReachedModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("maxMembersReachedDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        fullWidth: true,
                        children: t("close")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/template/index.tsx













var ConsoleFavoriteMemberSettingsTemplate = function(param) {
    var state = param.state, onMove = param.onMove, onDelete = param.onDelete, onEnableSettings = param.onEnableSettings, onDisableSettings = param.onDisableSettings, onGoToCreate = param.onGoToCreate, onGoToEdit = param.onGoToEdit, onGoToUsers = param.onGoToUsers;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(null), selectedMember = ref2[0], setSelectedMember = ref2[1];
    var ref3 = (0,react.useState)(false), showDisableModal = ref3[0], setShowDisableModal = ref3[1];
    var ref4 = (0,react.useState)(false), showDeleteModal = ref4[0], setShowDeleteModal = ref4[1];
    var ref5 = (0,react.useState)(null), memberToDelete = ref5[0], setMemberToDelete = ref5[1];
    var ref6 = (0,react.useState)(false), showMaxMembersModal = ref6[0], setShowMaxMembersModal = ref6[1];
    var handleToggleSettings = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.enableFavoriteMember) return [
                            3,
                            1
                        ];
                        // 推しメンバー機能を無効化する場合は確認モーダルを表示
                        setShowDisableModal(true);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            onEnableSettings()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleToggleSettings() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDisableSettings = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onDisableSettings()
                        ];
                    case 1:
                        _state.sent();
                        setShowDisableModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDisableSettings() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteMember = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(memberId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onDelete(memberId)
                        ];
                    case 1:
                        _state.sent();
                        setShowDeleteModal(false);
                        setMemberToDelete(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteMember(memberId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowDeleteModal = function(member) {
        setMemberToDelete(member);
        setShowDeleteModal(true);
    };
    var handleCreateMember = function() {
        if (state.favoriteMembers.length >= 50) {
            setShowMaxMembersModal(true);
        } else {
            onGoToCreate();
        }
    };
    var ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMembership,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            px: 5,
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1,
                                            pb: 3
                                        },
                                        children: state.loading && !state.sortingMember ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "text",
                                                    width: "60%",
                                                    height: 32,
                                                    sx: {
                                                        mb: 1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "text",
                                                    width: "80%",
                                                    height: 20
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h5",
                                                    children: t("settingsTitle")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "text.secondary",
                                                    sx: {
                                                        mt: 1,
                                                        pt: 1,
                                                        display: "block",
                                                        color: "var(--color-Text-Secondary, #798A94)",
                                                        fontSize: "13px",
                                                        fontStyle: "normal",
                                                        fontWeight: 300,
                                                        lineHeight: "20px"
                                                    },
                                                    children: t("description")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            ml: 2,
                                            pt: 0.5
                                        },
                                        children: state.loading && !state.sortingMember ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                            variant: "rectangular",
                                            width: 48,
                                            height: 24,
                                            sx: {
                                                borderRadius: 12
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                            checked: state.enableFavoriteMember,
                                            onChange: handleToggleSettings,
                                            color: "primary",
                                            disabled: state.changingSettings
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                sx: {
                                    borderWidth: 4,
                                    borderColor: "grey.50"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMemberDragList, {
                                favoriteMembers: state.favoriteMembers,
                                onMove: onMove,
                                onGoToEdit: onGoToEdit,
                                onGoToCreate: onGoToCreate,
                                onDelete: onDelete,
                                onGoToUsers: onGoToUsers,
                                onShowDeleteModal: handleShowDeleteModal,
                                loading: state.loading,
                                sortingMember: state.sortingMember
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row-reverse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "fixed",
                                bottom: 16,
                                zIndex: 100,
                                maxWidth: 600,
                                margin: "0 auto",
                                px: 4,
                                pb: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                size: "medium",
                                color: "primary",
                                onClick: handleCreateMember,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                                    fontSize: "medium",
                                    sx: {
                                        color: "white"
                                    }
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisableFavoriteMemberModal, {
                open: showDisableModal,
                onClose: function() {
                    return setShowDisableModal(false);
                },
                onDisable: handleDisableSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteFavoriteMemberModal, {
                open: showDeleteModal,
                onClose: function() {
                    setShowDeleteModal(false);
                    setMemberToDelete(null);
                },
                onDelete: handleDeleteMember,
                memberId: (ref7 = memberToDelete === null || memberToDelete === void 0 ? void 0 : memberToDelete.id) !== null && ref7 !== void 0 ? ref7 : "",
                memberName: (ref8 = memberToDelete === null || memberToDelete === void 0 ? void 0 : memberToDelete.name) !== null && ref8 !== void 0 ? ref8 : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaxMembersReachedModal, {
                open: showMaxMembersModal,
                onClose: function() {
                    return setShowMaxMembersModal(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/viewModel.ts




function ConsoleFavoriteMemberSettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistFavoriteMembers {\n    artist {\n      settings {\n        features {\n          subscription {\n            enableFavoriteMembers\n          }\n        }\n      }\n    }\n    artistFavoriteMembers {\n      id\n      fanCount\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberSettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleFavoriteMemberSettings_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistDeleteFavoriteMember(\n    $inputs: ArtistDeleteFavoriteMemberInput!\n  ) {\n    artistDeleteFavoriteMember(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberSettings_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleFavoriteMemberSettings_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateFavoriteMembersSettings(\n    $inputs: ArtistUpdateFavoriteMembersSettingsInput!\n  ) {\n    artistUpdateFavoriteMembersSettings(inputs: $inputs) {\n      settings {\n        features {\n          subscription {\n            enableFavoriteMembers\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberSettings_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleFavoriteMemberSettings_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateFavoriteMemberSort(\n    $inputs: ArtistUpdateFavoriteMemberSortInput!\n  ) {\n    artistUpdateFavoriteMemberSort(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n      orderNumber\n    }\n  }\n"
    ]);
    ConsoleFavoriteMemberSettings_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var ConsoleFavoriteMemberSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref4.showMessage, showError = ref4.showError;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref5.routerPages, router = ref5.router, generatePath = ref5.generatePath;
    var t = (0,dist_es/* useTranslation */.$G)("consoleFavoriteMemberSettings").t;
    var ref6 = (0,useQuery/* useQuery */.aM)(ARTIST_FAVORITE_MEMBERS_QUERY, {
        skip: !(user === null || user === void 0 ? void 0 : user.uid)
    }), data = ref6.data, loading = ref6.loading, refetch = ref6.refetch;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_DELETE_FAVORITE_MEMBER_MUTATION), 2), deleteFavoriteMember = ref7[0], ref8 = ref7[1], deletingMember = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_CHANGE_FAVORITE_MEMBERS_MUTATION), 2), changeFavoriteMembers = ref9[0], ref10 = ref9[1], changingSettings = ref10.loading;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_SORT_FAVORITE_MEMBER_MUTATION), 2), sortFavoriteMember = ref11[0], ref12 = ref11[1], sortingMember = ref12.loading;
    var favoriteMembers = (0,react.useMemo)(function() {
        var ref;
        var ref1, ref2;
        return (ref2 = data === null || data === void 0 ? void 0 : (ref = data.artistFavoriteMembers) === null || ref === void 0 ? void 0 : ref.map(function(member) {
            var ref;
            return {
                id: member.id,
                name: member.name,
                avatar: (ref1 = (ref = member.avatar) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref1 !== void 0 ? ref1 : "",
                fanCount: member.fanCount
            };
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        data === null || data === void 0 ? void 0 : data.artistFavoriteMembers
    ]);
    var ref13;
    // 推しメンバー機能の有効/無効状態をクエリから取得
    var enableFavoriteMember = (ref13 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.enableFavoriteMembers) !== null && ref13 !== void 0 ? ref13 : false;
    var ref14;
    return {
        state: {
            artistId: (ref14 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref14 !== void 0 ? ref14 : "",
            favoriteMembers: favoriteMembers,
            enableFavoriteMember: enableFavoriteMember,
            loading: loading,
            deletingMember: deletingMember,
            changingSettings: changingSettings,
            sortingMember: sortingMember
        },
        actions: {
            onMove: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(prevIndex, nextIndex) {
                    var memberToMove;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                memberToMove = favoriteMembers[prevIndex];
                                if (!memberToMove) {
                                    throw new Error(t("memberNotFoundError"));
                                }
                                return [
                                    4,
                                    sortFavoriteMember({
                                        variables: {
                                            inputs: {
                                                favoriteMemberId: memberToMove.id,
                                                orderByNumber: nextIndex + 1
                                            }
                                        }
                                    }).catch(function(error) {
                                        showError(error);
                                        throw error;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                showMessage(t("updateOrderSuccess"), "success");
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(prevIndex, nextIndex) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onDelete: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(memberId) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteFavoriteMember({
                                        variables: {
                                            inputs: {
                                                favoriteMemberId: memberId
                                            }
                                        }
                                    }).catch(function(error) {
                                        showError(error);
                                        throw error;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(memberId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onEnableSettings: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                changeFavoriteMembers({
                                    variables: {
                                        inputs: {
                                            enableFavoriteMembers: true
                                        }
                                    }
                                }).catch(function(error) {
                                    showError(error);
                                    throw error;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            showMessage(t("updateSettingsSuccess"), "success");
                            return [
                                2
                            ];
                    }
                });
            }),
            onDisableSettings: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                changeFavoriteMembers({
                                    variables: {
                                        inputs: {
                                            enableFavoriteMembers: false
                                        }
                                    }
                                }).catch(function(error) {
                                    showError(error);
                                    throw error;
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            showMessage(t("updateSettingsSuccess"), "success");
                            return [
                                2
                            ];
                    }
                });
            }),
            onGoToCreate: function() {
                router.push(routerPages.ConsoleFavoriteMemberCreate);
            },
            onGoToEdit: function(favoriteMemberId) {
                router.push(generatePath(routerPages.ConsoleFavoriteMemberEdit, {
                    favoriteMemberId: favoriteMemberId
                }));
            },
            onGoToUsers: function(favoriteMemberId) {
                router.push(generatePath(routerPages.ConsoleFans, {
                    favoriteMemberId: favoriteMemberId
                }));
            }
        }
    };
});
var ARTIST_FAVORITE_MEMBERS_QUERY = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberSettings_viewModel_templateObject());
var ARTIST_DELETE_FAVORITE_MEMBER_MUTATION = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberSettings_viewModel_templateObject1());
var ARTIST_CHANGE_FAVORITE_MEMBERS_MUTATION = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberSettings_viewModel_templateObject2());
var ARTIST_SORT_FAVORITE_MEMBER_MUTATION = (0,lib/* gql */.Ps)(ConsoleFavoriteMemberSettings_viewModel_templateObject3());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleFavoriteMemberSettings/index.tsx






/**
 * ConsoleFavoriteMemberSettings Page
 * 推し設定画面
 */ var ConsoleFavoriteMemberSettings = function() {
    var ref = ConsoleFavoriteMemberSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DndProvider/* DndProvider */.W, {
        backend: react_dnd_html5_backend_dist/* HTML5Backend */.PD,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleFavoriteMemberSettingsTemplate, (0,src_object_spread/* default */.Z)({
            state: state
        }, actions))
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItems/template/index.tsx













var OwnedItemsTemplate = function(param) {
    var state = param.state, onSort = param.onSort, onFetchMore = param.onFetchMore, onFilter = param.onFilter, onFilterResale = param.onFilterResale;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItems").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref = (0,react.useState)(state.filter), currentFilter = ref[0], setCurrnetFilter = ref[1];
    var handleSelectFilter = (0,react.useCallback)(function(value) {
        onFilter(value);
        setCurrnetFilter(value);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyOwnedItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_FilterMenu, {
                onSelect: handleSelectFilter,
                currentFilter: currentFilter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndResaleFilter, {
                currentFilter: currentFilter,
                onSort: onSort,
                onFilterResale: onFilterResale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsCell, {
                organizationPortfolios: state.organizationPortfolios,
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore
            })
        ]
    });
};
var template_FilterMenu = function(param) {
    var currentFilter = param.currentFilter, onSelect = param.onSelect;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
            value: currentFilter,
            onClick: onSelect,
            tags: [
                {
                    value: "general",
                    label: t("general")
                },
                {
                    value: utoniq_core_schema/* ItemType.Video */.qGq.Video,
                    label: t("video")
                },
                {
                    value: utoniq_core_schema/* ItemType.Audio */.qGq.Audio,
                    label: t("sound")
                },
                {
                    value: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                    label: t("wallpaper")
                },
                {
                    value: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
                    label: t("ticket")
                },
                {
                    value: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                    label: t("magazine")
                },
                {
                    value: utoniq_core_schema/* ItemType.Merch */.qGq.Merch,
                    label: t("merch")
                }, 
            ]
        })
    });
};
var sorts = (/* unused pure expression or super */ null && ([
    "filterProcedure",
    "filterArtist",
    "filterDate"
]));
var SortAndResaleFilter = function(param) {
    var currentFilter = param.currentFilter, onSort = param.onSort, onFilterResale = param.onFilterResale;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItems").t;
    var ref = (0,react.useState)(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleMenuItemClick = (0,react.useCallback)(function(event, index) {
        setSelectedIndex(index);
        setAnchorEl(null);
        onSort(index);
    }, [
        onSort
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        display: "flex",
        justifyContent: "space-between",
        sx: {
            pb: 2,
            px: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            flexDirection: "row",
            alignItems: "center",
            children: currentFilter === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && config_config/* config.modules.resale */.v.modules.resale && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "filterResale",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        id: "filterResale",
                        sx: {
                            "&.Mui-checked svg": {
                                color: "primary.main"
                            },
                            pr: 1
                        },
                        onChange: function(_, checked) {
                            onFilterResale(checked);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("resaleFilter")
                    })
                ]
            })
        })
    });
};
var ItemsCell = function(param) {
    var organizationPortfolios = param.organizationPortfolios, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItems").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: organizationPortfolios === null || organizationPortfolios === void 0 ? void 0 : (ref = organizationPortfolios.edges) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        position: "relative",
                        pb: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage/* ItemImage */.R, {
                        component: "div",
                        onClick: function() {
                            var ref;
                            return router.push({
                                pathname: generatePath(routerPages.OwnedItemDetail, {
                                    itemId: item.node.item.id
                                }),
                                search: item.node.item.sku ? "?skuId=".concat(encodeSkuId((ref2 = (ref = item.node.item.sku) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "")) : ""
                            });
                        },
                        item: item.node.item,
                        ownedCount: item.node.number,
                        showIcon: true
                    })
                }, [
                    item.node.item.id,
                    (ref = item.node.item.sku) === null || ref === void 0 ? void 0 : ref.id
                ].join("-"));
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: Grid2/* default */.Z,
            emptyMessage: t("portfolioEmptyMessage"),
            componentProps: {
                container: true,
                spacing: 3
            },
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: {
                size: {
                    xs: 4,
                    md: 3
                },
                sx: {
                    textAlign: "center"
                }
            },
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 3,
                children: Array.from(Array(24).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: {
                            xs: 4,
                            md: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            sx: {
                                width: "100%",
                                height: 166
                            }
                        })
                    }, key);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItems/template/SearchForm.tsx












var template_SearchForm_schema = function(o) {
    return {
        searchTerm: o.string().allow("").optional()
    };
};
var template_SearchForm_defaultValues = {
    searchTerm: ""
};
var SearchForm_SearchForm = function(param) {
    var onFilter = param.onFilter, onSearch = param.onSearch;
    var ref = (0,core_form/* useForm */.cI)({
        schema: template_SearchForm_schema,
        defaultValues: template_SearchForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue;
    var ref1 = (0,react.useState)("general"), currentFilter = ref1[0], setCurrnetFilter = ref1[1];
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var searchTerm = param.searchTerm;
        return onSearch(searchTerm);
    }), 500));
    var handleSelectFilter = (0,react.useCallback)(function(value) {
        onFilter(value);
        setCurrnetFilter(value);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_SearchInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("searchTerm")), {
                    onChange: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setValue("searchTerm", event.target.value);
                                        return [
                                            4,
                                            handleChangeKeywordDebounce.current()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_FilterMenu, {
                onSelect: handleSelectFilter,
                currentFilter: currentFilter
            })
        ]
    });
};
var SearchForm_SearchInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SearchInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItems/template/index.tsx















var ConsoleItemsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onRemove = param.onRemove, onSearch = param.onSearch, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling, onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        sx: {
                            px: 5,
                            py: 3,
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: routerPages.ConsoleItemOrders,
                                variant: "subtitle1",
                                children: t("purchaseHistory")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_SearchForm, {
                        onFilter: onFilter,
                        onSearch: onSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MusicSelectCell, {
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        items: state.items,
                        onFetchMore: onFetchMore,
                        onRemove: onRemove,
                        onToggleActive: onToggleActive,
                        onToggleSelling: onToggleSelling
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItems_template_BaseCell, {})
                ]
            })
        ]
    });
};
var MusicSelectCell = function(param) {
    var items = param.items, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, onRemove = param.onRemove, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: items === null || items === void 0 ? void 0 : items.edges.map(function(param) {
                var node = param.node;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBox, {
                    item: node,
                    onRemove: onRemove,
                    onToggleActive: onToggleActive,
                    onToggleSelling: onToggleSelling,
                    showIcon: true
                }, node.id);
            }),
            loading: loading,
            componentProps: {
                spacing: 5
            },
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            emptyMessage: t("itemEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                sx: {
                    py: 2
                },
                children: Array.from(Array(4).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectBoxSkeleton, {}, key);
                })
            })
        })
    });
};
var ConsoleItems_template_BaseCell = function() {
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 16,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: toggleDrawer(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateItemActionSheet, {
                open: open,
                onClose: toggleDrawer(false)
            })
        ]
    });
};
var CreateItemActionSheet = function(param) {
    var open = param.open, onClose = param.onClose, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var items = (0,react.useMemo)(function() {
        return [
            {
                Icon: dist.Icons.Audio,
                text: t("sound"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Audio */.qGq.Audio
                })
            },
            {
                Icon: dist.Icons.Video,
                text: t("video"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Video */.qGq.Video
                })
            },
            {
                Icon: dist.Icons.Magazine,
                text: t("magazine"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine
                })
            },
            {
                Icon: dist.Icons.Wallpaper,
                text: t("wallpaper"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper
                })
            },
            {
                Icon: dist.Icons.Merch,
                text: t("merch"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Merch */.qGq.Merch
                })
            },
            {
                Icon: dist.Icons.Ticket,
                text: t("ticket"),
                href: generatePath(routerPages.ConsoleItemCreate, {
                    resourceType: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket
                })
            }, 
        ];
    }, [
        generatePath,
        routerPages.ConsoleItemCreate,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        sx: {
            "& .MuiPaper-root": {
                maxWidth: fullWidth ? // 画面幅に依らずドロワーを画面幅いっぱいに広げる
                "100%" : // ドロワーの最大幅を 600 px に制限する
                constants/* constants.ui.layout.mainContentMaxWidth */._.ui.layout.mainContentMaxWidth
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    p: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "grey.600",
                    align: "center",
                    children: t("selectItemTypeTitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                children: [
                    items.map(function(param, index) {
                        var Icon = param.Icon, text = param.text, href = param.href;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                            sx: {
                                height: 52
                            },
                            href: href,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: {
                                        pl: 3
                                    },
                                    children: text
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                        component: Box_Box/* default */.Z,
                        sx: {
                            height: 52
                        },
                        alignItems: "center",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                color: "primary.main"
                            },
                            children: t("cancel")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePosts/template/SearchForm.tsx














var ConsolePosts_template_SearchForm_schema = function(o) {
    return {
        keyword: o.string().allow("").optional(),
        type: o.string().allow("").optional(),
        types: o.array().items(o.string()).optional(),
        storyFilter: o.string().allow("").optional(),
        filter: o.string().allow("").optional()
    };
};
var ConsolePosts_template_SearchForm_defaultValues = {
    keyword: "",
    type: undefined,
    types: undefined,
    storyFilter: undefined,
    filter: "newestOrder"
};
var template_SearchForm_SearchForm = function(param) {
    var onSubmit = param.onSubmit, hiddenFilter = param.hiddenFilter;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsolePosts_template_SearchForm_schema,
        defaultValues: ConsolePosts_template_SearchForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, control = ref.control, getValues = ref.getValues, setValue = ref.setValue, isSubmitted = ref.formState.isSubmitted;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var keyword = param.keyword;
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ConsolePosts_template_SearchForm_defaultValues), {
            keyword: keyword
        }));
    }), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            px: 5,
            pt: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            onSubmit: handleSubmit(onSubmit),
            sx: {
                bgcolor: "transparent"
            },
            children: !(getValues().keyword.length && isSubmitted) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTagCell, {
                    control: control,
                    setValue: setValue,
                    onChange: handleSubmit(function(_param) {
                        var type = _param.type, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "type"
                        ]);
                        var buildSearchParams = function() {
                            // 全選択の場合: 全てのポストを取得（ストーリーも含む）
                            if (type === undefined) {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
                                    storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include
                                });
                            }
                            // ストーリー選択の場合: ストーリーのみを取得
                            if (type === "story") {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
                                    types: [
                                        utoniq_core_schema/* PostType.Video */.hQF.Video,
                                        utoniq_core_schema/* PostType.Image */.hQF.Image
                                    ],
                                    storyFilter: utoniq_core_schema/* StoryFilter.Only */.CkM.Only
                                });
                            }
                            // 特定のタイプ選択の場合: 通常のポストのみを取得
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
                                type: type
                            });
                        };
                        onSubmit(buildSearchParams());
                    })
                })
            })
        })
    });
};
var template_SearchForm_SearchInputCell = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(props, ref) {
    var t = useTranslation("consolePosts").t;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ _jsx(SearchInputField, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            t: t
        }))
    });
})));
var ScrollTagCell = function(param) {
    var control = param.control, setValue = param.setValue, onChange = param.onChange;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePosts").t;
    var type = (0,react_hook_form_dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "type"
    });
    var handleTagClick = function(clickedValue, currentType, setValue, onChange) {
        // 同じタグをクリックした場合はリセット（undefined）、違うタグをクリックした場合は新しい値を設定
        var newType = currentType === clickedValue ? undefined : clickedValue;
        // フォームのフィールドを更新
        setValue("type", newType);
        // フォームの値を送信
        onChange();
    };
    var typeOptions = [
        {
            value: undefined,
            label: t("all")
        },
        {
            value: utoniq_core_schema/* PostType.Video */.hQF.Video,
            label: t("video")
        },
        {
            value: utoniq_core_schema/* PostType.Sound */.hQF.Sound,
            label: t("sound")
        },
        {
            value: utoniq_core_schema/* PostType.Image */.hQF.Image,
            label: t("image")
        },
        {
            value: utoniq_core_schema/* PostType.Text */.hQF.Text,
            label: t("text")
        }, 
    ].concat((0,src_to_consumable_array/* default */.Z)((0,individual/* individualShowStory */.IG)() ? [
        {
            value: "story",
            label: t("story")
        }
    ] : []));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        className: "いむ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
            value: type,
            tags: typeOptions,
            onClick: function(value) {
                return handleTagClick(value, type, setValue, onChange);
            }
        })
    });
};
var SearchForm_FilterCell = function(param) {
    var setValue = param.setValue, onChange = param.onChange;
    var t = useTranslation("consolePosts").t;
    var filterOptions = [
        {
            value: "newestOrder",
            label: t("newestOrder")
        },
        {
            value: "oldestOrder",
            label: t("oldestOrder")
        }, 
    ];
    var ref = useState(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = useState(filterOptions[0]), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var open = Boolean(anchorEl);
    var handleClickListItem = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function(event, option) {
        setSelectedOption(option);
        setValue("filter", option.value);
        onChange();
        setAnchorEl(null);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ _jsxs(CellFrame, {
        sx: {
            py: 1
        },
        children: [
            /*#__PURE__*/ _jsx(Stack, {
                direction: "row-reverse",
                spacing: 2,
                children: /*#__PURE__*/ _jsxs(Button, {
                    variant: "text",
                    sx: {
                        mr: -2
                    },
                    onClick: handleClickListItem,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "caption",
                            sx: {
                                mr: 2
                            },
                            children: selectedOption.label
                        }),
                        /*#__PURE__*/ _jsx(Icons.DownArrow, {
                            fontSize: "xSmall"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Menu, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: filterOptions.map(function(option, index) {
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        selected: option.value === selectedOption.value,
                        onClick: function(event) {
                            return handleMenuItemClick(event, option);
                        },
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "body2",
                            children: option.label
                        })
                    }, option.value);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePosts/template/index.tsx














var ConsolePostsTemplate = function(param) {
    var state = param.state, onFilter = param.onFilter, onFetchMore = param.onFetchMore, onDeletePost = param.onDeletePost;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePosts").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePost
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        sx: {
                            py: 3,
                            px: 5
                        },
                        children: t("postManagement")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SearchForm_SearchForm, {
                        hiddenFilter: !((ref = state.posts) === null || ref === void 0 ? void 0 : ref.edges.length),
                        onSubmit: onFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: (ref1 = state.posts) === null || ref1 === void 0 ? void 0 : ref1.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, {
                                    loadingDeletePost: state.loadingDeletePost,
                                    onDeletePost: onDeletePost,
                                    post: node,
                                    fullWidth: true,
                                    isConsole: true,
                                    userId: state.userId
                                });
                            }),
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: onFetchMore,
                            emptyMessage: t("emptyPost"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                sx: {
                                    pb: 2
                                },
                                children: Array.from(Array(3).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBoxSkeleton, {
                                        fullWidth: true
                                    }, key);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePosts_template_BaseCell, {})
                ]
            })
        ]
    });
};
var ConsolePosts_template_BaseCell = function() {
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 16,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: toggleDrawer(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostActionSheet, {
                open: open,
                onClose: toggleDrawer(false)
            })
        ]
    });
};
var CreatePostActionSheet = function(param) {
    var open = param.open, onClose = param.onClose, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePosts").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var items = (0,react.useMemo)(function() {
        return [
            {
                Icon: dist.Icons.Post,
                text: t("textOnly"),
                href: generatePath(routerPages.ConsolePostCreate, {
                    resourceType: utoniq_core_schema/* PostType.Text */.hQF.Text
                })
            },
            {
                Icon: dist.Icons.Image,
                text: t("image"),
                href: generatePath(routerPages.ConsolePostCreate, {
                    resourceType: utoniq_core_schema/* PostType.Image */.hQF.Image
                })
            },
            {
                Icon: dist.Icons.Audio,
                text: t("sound"),
                href: generatePath(routerPages.ConsolePostCreate, {
                    resourceType: utoniq_core_schema/* PostType.Sound */.hQF.Sound
                })
            },
            {
                Icon: dist.Icons.Video,
                text: t("video"),
                href: generatePath(routerPages.ConsolePostCreate, {
                    resourceType: utoniq_core_schema/* PostType.Video */.hQF.Video
                })
            }, 
        ];
    }, [
        generatePath,
        routerPages.ConsolePostCreate,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        sx: {
            "& .MuiPaper-root": {
                maxWidth: fullWidth ? // 画面幅に依らずドロワーを画面幅いっぱいに広げる
                "100%" : // ドロワーの最大幅を 600 px に制限する
                constants/* constants.ui.layout.mainContentMaxWidth */._.ui.layout.mainContentMaxWidth
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    p: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "grey.600",
                    align: "center",
                    children: t("selectPostType")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                children: [
                    items.map(function(param, index) {
                        var Icon = param.Icon, text = param.text, href = param.href;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                            component: Stack_Stack/* default */.Z,
                            sx: {
                                height: 52
                            },
                            spacing: 3,
                            direction: "row",
                            onClick: function() {
                                return router.push(href);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    fontSize: "small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: text
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                        component: Box_Box/* default */.Z,
                        sx: {
                            height: 52
                        },
                        alignItems: "center",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                color: "primary.main"
                            },
                            children: t("cancel")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleHome/template/index.tsx






















var ConsoleHomeTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref5.routerNames, routerPages = ref5.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleDashboard
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                hasConsoleFooter: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                sx: {
                    position: "relative",
                    height: "100vh"
                },
                fullWidth: true,
                children: [
                    !state.loading && config_config/* config.modules.membership */.v.modules.membership && !((ref = state.artist) === null || ref === void 0 ? void 0 : ref.subscription) && ((ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.paymentType) === "connect" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            href: routerPages.ConsoleMembershipExplain,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                    style: {
                                        width: "100%",
                                        height: "auto"
                                    },
                                    target: "common",
                                    src: "images/console/membership_banner.png"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        right: 16,
                                        bottom: 16,
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: 13,
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                            children: t("seeDetail")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                            fontSize: "xSmall",
                                            color: "white",
                                            sx: {
                                                maxWidth: "10px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    state.loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 5,
                        sx: {
                            pt: 4,
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 124
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 200
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row-reverse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "fixed",
                                bottom: 100,
                                zIndex: 5,
                                maxWidth: 600,
                                margin: "0 auto",
                                px: 4,
                                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                                size: "medium",
                                color: "primary",
                                onClick: function() {
                                    (0,intercom/* updateIntercom */.dC)(user);
                                    (0,intercom/* openIntercom */.B6)();
                                },
                                sx: {
                                    position: "relative",
                                    right: 5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Inquiry, {
                                    fontSize: "medium",
                                    sx: {
                                        color: "white"
                                    }
                                })
                            })
                        })
                    }),
                    !state.loading && state.artist && /*#__PURE__*/ (0,jsx_runtime.jsx)(DataCell, {
                        paymentType: state.artist.paymentType,
                        followerCount: (ref6 = (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : ref2.followerCount) !== null && ref6 !== void 0 ? ref6 : 0,
                        memberships: state.memberships,
                        totalPurchasedNumber: (ref7 = (ref3 = state.artist) === null || ref3 === void 0 ? void 0 : ref3.totalPurchasedNumber) !== null && ref7 !== void 0 ? ref7 : 0,
                        showMembership: config_config/* config.modules.membership */.v.modules.membership && !!((ref4 = state.artist) === null || ref4 === void 0 ? void 0 : ref4.subscription)
                    }),
                    state.campaign && /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignAreaCell, {
                        campaign: state.campaign
                    }),
                    !state.loading && /**
           * utoniq or デジリアの場合、Tipsを表示
           */ [
                        "utoniq",
                        "digirea"
                    ].some(function(key) {
                        return key === config_config/* config.applicationKey */.v.applicationKey;
                    }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TipsCell, {
                        artistId: state.artistId,
                        tips: state.tips
                    }),
                    config_config/* config.modules.event */.v.modules.event && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TicketStatusCell, {
                        loading: state.loading,
                        events: state.events,
                        updatedAt: state.updatedAt
                    })
                ]
            })
        ]
    });
};
var DataCell = function(param) {
    var memberships = param.memberships, paymentType = param.paymentType, followerCount = param.followerCount, showMembership = param.showMembership, totalPurchasedNumber = param.totalPurchasedNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            maxWidth: 600,
            margin: "0 auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                py: 4
            },
            children: [
                config_config/* config.modules.store */.v.modules.store && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                height: 48
                            },
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    children: totalPurchasedNumber
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    align: "center",
                                    children: t("itemSale")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            orientation: "vertical",
                            flexItem: true
                        })
                    ]
                }),
                showMembership && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                height: 48
                            },
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    children: memberships
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    align: "center",
                                    children: t("member")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            orientation: "vertical",
                            flexItem: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    spacing: 1,
                    sx: {
                        height: 48
                    },
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            children: followerCount
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "text.secondary",
                            align: "center",
                            children: t("follower")
                        })
                    ]
                })
            ]
        })
    });
};
{
/**
   * @description
   * Open when function is implemented in the future
   * https://app.clickup.com/t/908127/UT-5043
   */ }var MovieAreaCell = function(param) {
    var videoId = param.videoId;
    var t = useTranslation("consoleHome").t;
    var videoRef = useRef(null);
    var ref = usePlayingResource(), playingResource = ref.playingResource, playResource = ref.playResource;
    useEffect(function() {
        if (playingResource !== videoId) {
            var ref, ref1;
            (ref1 = (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer()) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        }
    }, [
        playingResource,
        videoId
    ]);
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            pt: 5,
            pb: 7,
            px: 5
        },
        children: /*#__PURE__*/ _jsx(Card, {
            sx: {
                bgcolor: "grey.50",
                borderRadius: 2
            },
            elevation: 0,
            children: /*#__PURE__*/ _jsx(CardContent, {
                sx: {
                    p: 5
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    sx: {
                        mb: 1
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h5",
                            sx: {
                                mb: 4
                            },
                            fontWeight: 6,
                            children: t("howToUseUtoniq")
                        }),
                        videoId && /*#__PURE__*/ _jsx(YouTube, {
                            id: videoId,
                            videoId: videoId,
                            opts: {
                                width: "100%",
                                height: "168px"
                            },
                            ref: videoRef,
                            onPlay: function() {
                                return playResource(videoId !== null && videoId !== void 0 ? videoId : "");
                            }
                        }),
                        /*#__PURE__*/ _jsx(Stack, {
                            sx: {
                                pt: 6
                            },
                            direction: "row",
                            justifyContent: "center",
                            children: /*#__PURE__*/ _jsx(Button, {
                                color: "primary",
                                sx: {
                                    minWidth: 244
                                },
                                size: "large",
                                children: t("makeProduct")
                            })
                        })
                    ]
                })
            })
        })
    });
};
var CampaignAreaCell = function(param) {
    var campaign = param.campaign;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 5,
            pb: 7,
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                bgcolor: "grey.50",
                borderRadius: 2
            },
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            mb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Campaign, {
                                sx: {
                                    color: "secondary.main"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h4",
                                children: t("duringCampaignEntry")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            mb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: campaign.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "text.secondary",
                                variant: "body2",
                                children: campaign.note
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            mb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: [
                                    campaign.point,
                                    t("point")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: campaign.content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "#",
                                color: "primary.main",
                                variant: "subtitle1",
                                children: t("clickHere")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var TipsCell = function(param) {
    var artistId = param.artistId, _tips = param.tips, itemCleared = _tips.itemCleared, threadCleared = _tips.threadCleared, postCleared = _tips.postCleared;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var ref1 = (0,react.useState)(false), openItemCreate = ref1[0], setOpenItemCreate = ref1[1];
    var ref2 = (0,react.useState)(false), openPostCreate = ref2[0], setOpenPostCreate = ref2[1];
    var tips = [
        {
            title: t("itemTipTitle"),
            content: t("itemTipContent"),
            isCleared: itemCleared,
            Icon: dist.Icons.OwnedItems,
            isBe: config_config/* config.modules.item */.v.modules.item,
            onClick: function onClick() {
                setOpenItemCreate(true);
            }
        },
        {
            title: t("postTipTitle"),
            content: t("postTipContent"),
            isCleared: postCleared,
            Icon: dist.Icons.Post,
            isBe: true,
            onClick: function onClick() {
                setOpenPostCreate(true);
            }
        },
        {
            title: t("threadTipTitle"),
            content: t("threadTipContent"),
            isCleared: threadCleared,
            Icon: dist.Icons.Thread,
            isBe: config_config/* config.modules.thread */.v.modules.thread,
            onClick: function onClick() {
                router.push(generatePath(routerPages.ArtistThreadCreate, {
                    artistId: artistId
                }));
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            mt: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                px: 5,
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Tips, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        children: t("tips")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                flexWrap: "wrap",
                gap: 3,
                justifyContent: "flex-start",
                sx: function(theme) {
                    return (0,_define_property/* default */.Z)({
                        pt: 2,
                        pl: "20px"
                    }, theme.breakpoints.down("md"), {
                        display: "none"
                    });
                },
                children: tips.map(function(tip, index) {
                    return tip.isBe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TipCard, (0,src_object_spread/* default */.Z)({}, tip), index) : null;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                flexWrap: "wrap",
                sx: (0,src_object_spread/* default */.Z)({
                    pt: 2,
                    overflowX: "scroll",
                    display: {
                        md: "none"
                    }
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    sx: {
                        "& > *:first-of-type": {
                            ml: 5
                        },
                        "& > *:last-child": {
                            mr: 5
                        }
                    },
                    children: tips.map(function(tip, index) {
                        return tip.isBe ? /*#__PURE__*/ (0,react.createElement)(TipCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tip), {
                            key: index
                        })) : null;
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateItemActionSheet, {
                open: openItemCreate,
                onClose: function() {
                    return setOpenItemCreate(false);
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostActionSheet, {
                open: openPostCreate,
                onClose: function() {
                    return setOpenPostCreate(false);
                },
                fullWidth: true
            })
        ]
    });
};
var TipCard = function(param) {
    var isCleared = param.isCleared, title = param.title, content = param.content, Icon = param.Icon, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            width: 152,
            borderRadius: 3
        },
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 3,
                "&:last-child": {
                    pb: 3
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    sx: {
                                        color: isCleared ? "text.hint" : "text.primary"
                                    }
                                }),
                                isCleared && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        width: 12,
                                        height: 12,
                                        borderRadius: "50%",
                                        bgcolor: "secondary.main",
                                        top: 0,
                                        left: 0
                                    },
                                    justifyContent: "center",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                        sx: {
                                            color: "white",
                                            width: 8,
                                            height: 8
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: isCleared ? "text.hint" : "text.primary",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: isCleared ? "text.hint" : "text.secondary",
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        height: 24,
                        mt: 2,
                        borderRadius: 1
                    },
                    fullWidth: true,
                    color: "secondary",
                    disabled: isCleared,
                    onClick: onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        color: "white",
                        children: isCleared ? t("clear") : t("create")
                    })
                })
            ]
        })
    });
};
var template_TicketStatusCell = function(param) {
    var loading = param.loading, events = param.events, updatedAt = param.updatedAt;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleHome").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
                sx: {
                    pt: 2,
                    display: {
                        xs: "none",
                        md: "block"
                    }
                },
                loading: loading,
                allwayShowList: true,
                loadingItemLength: 3,
                spacing: 3,
                title: t("ticketStatusLabel", "チケット状況"),
                titleTypographyProps: {
                    variant: "h4"
                },
                transTypographyProps: {
                    variant: "h6"
                },
                listHref: routerPages.ConsoleShokufesEvents,
                subTitle: updatedAt ? t("subTicketStatusLabel", {
                    date: updatedAt
                }) : undefined,
                subTitleTypographyProps: {
                    sx: {
                        width: "100%"
                    },
                    align: "right",
                    color: "text.secondary"
                },
                items: (ref = events === null || events === void 0 ? void 0 : events.edges.slice(0, 2)) !== null && ref !== void 0 ? ref : [],
                trans: t("eventList", "イベント一覧"),
                renderItem: function(param, i) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventTicketInfoBox, {
                        event: node,
                        width: "calc(50%)"
                    }, i);
                },
                EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    p: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body1",
                        color: "text.secondary",
                        children: t("emptyTicketMessage", "チケット状況はありません")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
                sx: {
                    pt: 2,
                    display: {
                        md: "none"
                    }
                },
                loading: loading,
                allwayShowList: true,
                loadingItemLength: 3,
                spacing: 3,
                title: t("ticketStatusLabel", "チケット状況"),
                titleTypographyProps: {
                    variant: "h4"
                },
                transTypographyProps: {
                    variant: "h6"
                },
                listHref: routerPages.ConsoleShokufesEvents,
                subTitle: updatedAt ? t("subTicketStatusLabel", {
                    date: updatedAt
                }) : undefined,
                subTitleTypographyProps: {
                    sx: {
                        width: "100%"
                    },
                    align: "right",
                    color: "text.secondary"
                },
                items: (ref1 = events === null || events === void 0 ? void 0 : events.edges) !== null && ref1 !== void 0 ? ref1 : [],
                trans: t("eventList", "イベント一覧"),
                renderItem: function(param, i) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleEventTicketInfoBox, {
                        event: node,
                        width: 316
                    }, i);
                },
                EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    p: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body1",
                        color: "text.secondary",
                        children: t("emptyTicketMessage", "チケット状況はありません")
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleHome/viewModel.ts

function ConsoleHome_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleHome($inputs: ArtistThreadChannelsInput!, $limit: Int) {\n    salesReport {\n      totalSales\n      formattedTotalSales @client\n    }\n    artist {\n      id\n      paymentType\n      subscription {\n        products {\n          productId\n        }\n      }\n      status\n      patronCount\n      formattedPatronCount @client\n      followerCount\n      totalPurchasedNumber\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          plans {\n            amount\n            status\n          }\n          content\n        }\n      }\n      posts(pageInput: { limit: $limit }) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n    artistItems(pageInput: { limit: $limit }) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    artistEvents(filter: all) {\n      ...ConsoleEventAggregationConnection\n    }\n    artistThreadChannels(inputs: $inputs, pageInput: { limit: $limit }) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleHome_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ConsoleHome_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref5 = (0,react.useState)(values_Date/* DateTime.now */.o.now()), updatedAt = ref5[0];
    var ref6;
    var ref7 = (0,useQuery/* useQuery */.aM)(ConsoleHome_viewModel_QUERY, {
        variables: {
            inputs: {
                artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
                options: {
                    orderBy: utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt
                }
            },
            limit: 1
        }
    }), data = ref7.data, loading = ref7.loading;
    var ref8, _formattedTotalSales, ref9, ref10, ref11, ref12;
    return {
        state: {
            loading: loading,
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            totalSales: (_formattedTotalSales = data === null || data === void 0 ? void 0 : data.salesReport.formattedTotalSales) !== null && _formattedTotalSales !== void 0 ? _formattedTotalSales : "0",
            memberships: (ref9 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.formattedPatronCount) !== null && ref9 !== void 0 ? ref9 : "0",
            videoId: "",
            campaign: null,
            currentUser: user,
            artist: (ref10 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref10 !== void 0 ? ref10 : null,
            tips: {
                itemCleared: !!(data === null || data === void 0 ? void 0 : data.artistItems.edges.length),
                postCleared: !!(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.posts.edges.length),
                threadCleared: !!(data === null || data === void 0 ? void 0 : (ref2 = data.artistThreadChannels) === null || ref2 === void 0 ? void 0 : ref2.edges.length)
            },
            events: (ref11 = data === null || data === void 0 ? void 0 : data.artistEvents) !== null && ref11 !== void 0 ? ref11 : null,
            updatedAt: loading ? "" : updatedAt,
            membership: (ref12 = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.products) !== null && ref12 !== void 0 ? ref12 : undefined
        },
        actions: {}
    };
});
var ConsoleHome_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleHome_viewModel_templateObject(), utoniq_core_schema/* ConsoleEventAggregationConnectionFragmentDoc */.FQy);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleHome/index.tsx




/**
 * ConsoleHome Page
 * Implemented as a practical sample.
 */ var ConsoleHome = function() {
    var ref = ConsoleHome_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleHomeTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ResourceUploadCell.tsx








var ResourceUploadCell = function(param) {
    var resourceType = param.resourceType, watch = param.watch, fileUploadInfo = param.fileUploadInfo, setValue = param.setValue, error = param.error, onClose = param.onClose, hasCreateResource = param.hasCreateResource;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref = (0,react.useMemo)(function() {
        switch(resourceType){
            case "magazine":
                return {
                    type: "pdf",
                    shape: undefined
                };
            case "video":
                return {
                    type: "video",
                    shape: undefined
                };
            case "audio":
                return {
                    type: "audio",
                    shape: undefined
                };
            default:
                return {
                    type: "image",
                    shape: "square"
                };
        }
    }, [
        resourceType
    ]), type = ref.type, shape = ref.shape;
    var name = (0,react.useMemo)(function() {
        switch(resourceType){
            case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                return "wallpaperResource";
            case utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar:
                return "avatarResource";
            default:
                return "resource";
        }
    }, [
        resourceType
    ]);
    if (resourceType === utoniq_core_schema/* ItemType.Merch */.qGq.Merch) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                sx: {
                    p: 0
                },
                shape: shape,
                resource: watch(name),
                t: t,
                fileUploadInfo: {
                    type: type,
                    onDrop: function onDrop() {
                        return fileUploadInfo.onDrop(resourceType, hasCreateResource).then(function(resource) {
                            if (!resource) {
                                return;
                            }
                            switch(resourceType){
                                case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                                    // createの際のミューテーション引数としてartist.resourceドキュメントのIDをフォーム値に設定する。
                                    setValue("wallpaperResources.wallpaperResourceId", resource.id, {
                                        shouldValidate: true
                                    });
                                    // updateの際はtmpPathをミューテーション引数に指定するため、imageUploadPathのフォーム値を更新する
                                    setValue("wallpaperResource.imageUploadPath", resource.imageUploadPath, {
                                        shouldValidate: true
                                    });
                                    break;
                                case utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar:
                                    setValue("avatarResources.avatarResourceId", resource.id, {
                                        shouldValidate: true
                                    });
                                    break;
                                default:
                                    setValue("resourceId", resource.id, {
                                        shouldValidate: true
                                    });
                                    setValue("resource.imageUploadPath", resource.imageUploadPath, {
                                        shouldValidate: true
                                    });
                                    break;
                            }
                            setValue(name, (0,src_object_spread/* default */.Z)({}, resource));
                            return resource;
                        });
                    },
                    progress: fileUploadInfo.progress || 0,
                    description: t("".concat(resourceType, "UploaderDescription")),
                    onClose: function onClose1() {
                        if (![
                            utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar,
                            utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper
                        ].includes(resourceType)) {
                            setValue("resource", null, {
                                shouldDirty: true
                            });
                        }
                        setValue("resourceId", "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("wallpaperResources.wallpaperResourceId", "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("avatarResources.avatarResourceId", "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("avatarResource", null, {
                            shouldDirty: true
                        });
                        setValue("wallpaperResource", null, {
                            shouldDirty: true
                        });
                        onClose && onClose(resourceType);
                    }
                },
                content: {
                    title: t("".concat(resourceType, "UploaderTitle"))
                }
            }),
            resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 3
                },
                children: t("wallpaperNote")
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PageDirectionInputCell.tsx





var PageDirectionInputCell = function(param) {
    var watch = param.watch, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var pageDirection = watch("metadata.magazine.pageDirection");
    var options = [
        {
            value: utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left,
            label: t("left")
        },
        {
            value: utoniq_core_schema/* MagazinePageDirection.Right */.md6.Right,
            label: t("right")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("pageDirectionLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: pageDirection === option.value ? "contained" : "outlined",
                        onClick: function() {
                            setValue("metadata.magazine.pageDirection", option.value, {
                                shouldDirty: true
                            });
                        },
                        children: option.label
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/Commons.tsx








var components_Commons_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            textFieldProps: textFieldProps,
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});
var components_Commons_ToggleInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var sx = _param.sx, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sx"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            inputRef: ref,
            sx: (0,src_object_spread/* default */.Z)({
                px: 0,
                pt: 0,
                "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                    bgcolor: "primary.main"
                }
            }, sx)
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PrintInputCell.tsx






var PrintInputCell = function(param) {
    var isPrintEnabled = param.isPrintEnabled, printType = param.printType, setValue = param.setValue, printCount = param.printCount;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var options = [
        {
            value: utoniq_core_schema/* WallpaperPrintType.PhotoL */.weL.PhotoL,
            label: t(utoniq_core_schema/* WallpaperPrintType.PhotoL */.weL.PhotoL)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.Photo_2l */.weL.Photo_2l,
            label: t(utoniq_core_schema/* WallpaperPrintType.Photo_2l */.weL.Photo_2l)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.PhotoSquare */.weL.PhotoSquare,
            label: t(utoniq_core_schema/* WallpaperPrintType.PhotoSquare */.weL.PhotoSquare)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.SealL */.weL.SealL,
            label: t(utoniq_core_schema/* WallpaperPrintType.SealL */.weL.SealL)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.Seal_2l */.weL.Seal_2l,
            label: t(utoniq_core_schema/* WallpaperPrintType.Seal_2l */.weL.Seal_2l)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.SealSquare */.weL.SealSquare,
            label: t(utoniq_core_schema/* WallpaperPrintType.SealSquare */.weL.SealSquare)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.Postcard */.weL.Postcard,
            label: t(utoniq_core_schema/* WallpaperPrintType.Postcard */.weL.Postcard)
        },
        {
            value: utoniq_core_schema/* WallpaperPrintType.GlossyPaperA4 */.weL.GlossyPaperA4,
            label: t(utoniq_core_schema/* WallpaperPrintType.GlossyPaperA4 */.weL.GlossyPaperA4)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("printWallpaperLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                        checked: isPrintEnabled,
                        sx: {
                            "&& .Mui-disabled + .MuiSwitch-track": {
                                bgcolor: "grey.100"
                            },
                            "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                bgcolor: "primary.main"
                            }
                        },
                        onChange: function() {
                            if (isPrintEnabled) {
                                setValue("metadata.wallpaper.isPrintEnabled", false, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("metadata.wallpaper.printCount", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("metadata.wallpaper.printType", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                return;
                            }
                            setValue("metadata.wallpaper.isPrintEnabled", true, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            setValue("metadata.wallpaper.printCount", 1, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            setValue("metadata.wallpaper.printType", utoniq_core_schema/* WallpaperPrintType.PhotoL */.weL.PhotoL, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    color: "text.secondary",
                    children: t("printWallpaperDesc")
                })
            }),
            isPrintEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                pt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("printTypeLabel", "印刷タイプ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        value: printType !== null && printType !== void 0 ? printType : "",
                        onChange: function(_, value) {
                            return setValue("metadata.wallpaper.printType", value, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        children: options.map(function(param) {
                            var label = param.label, value = param.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: value,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: label
                            }, value);
                        })
                    })
                ]
            }),
            isPrintEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                pt: 4,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("printCountLabel", "印刷枚数")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                        listItems: Array.from(Array(1).keys()).map(function(key) {
                            return {
                                value: (key + 1).toString(),
                                label: t("sheet", {
                                    number: key + 1
                                })
                            };
                        }),
                        value: (printCount !== null && printCount !== void 0 ? printCount : 1).toString(),
                        onChange: function(value) {
                            return setValue("metadata.wallpaper.printCount", +value, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        formControlProps: {
                            sx: {
                                width: "100%",
                                bgcolor: "grey.50",
                                minHeight: "auto"
                            }
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Collapse/Collapse.js
var Collapse = __webpack_require__(64354);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ContentsAudioInputCell.tsx









var ContentsAudioInputCell = function(param) {
    var resourceType = param.resourceType, audioUploadInfo = param.audioUploadInfo, setValue = param.setValue, watch = param.watch, onClose = param.onClose, hasCreateResource = param.hasCreateResource;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                sx: {
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("contentAudioLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.hint",
                        children: t("optional")
                    }),
                    expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.UpArrow, {
                        size: "medium",
                        onClick: function() {
                            return setExpanded(function(prevState) {
                                return !prevState;
                            });
                        },
                        bgcolor: "transparent"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.DownArrow, {
                        size: "medium",
                        onClick: function() {
                            return setExpanded(function(prevState) {
                                return !prevState;
                            });
                        },
                        bgcolor: "transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                    t: t,
                    sx: {
                        p: 0
                    },
                    resource: watch("resource"),
                    fileUploadInfo: {
                        type: "audio",
                        onDrop: function onDrop() {
                            return audioUploadInfo.onDrop(utoniq_core_schema/* ItemType.Audio */.qGq.Audio, hasCreateResource).then(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(resource) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        if (!resource) {
                                            return [
                                                2
                                            ];
                                        }
                                        if (resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper) {
                                            setValue("wallpaperResources.audioResourceId", resource.id);
                                        } else {
                                            setValue("avatarResources.voiceResourceId", resource.id);
                                        }
                                        setValue("resource", resource);
                                        return [
                                            2,
                                            resource
                                        ];
                                    });
                                });
                                return function(resource) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        },
                        progress: audioUploadInfo.progress || 0,
                        description: t("audioUploaderDescription"),
                        onClose: function onClose1() {
                            if (resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper) {
                                setValue("wallpaperResources.audioResourceId", "");
                            } else {
                                setValue("avatarResources.voiceResourceId", "");
                            }
                            setValue("resource", null);
                            onClose && onClose();
                        }
                    },
                    content: {
                        title: ""
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ItemThumbnailInputCell.tsx









var ItemThumbnailInputCell = function(param) {
    var watch = param.watch, error = param.error, errorBack = param.errorBack, setValue = param.setValue, itemUploadInfo = param.itemUploadInfo, onClose = param.onClose, onBackClose = param.onBackClose, resourceType = param.resourceType, isEdit = param.isEdit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var thumbnailType = watch("thumbnailType");
    var ref = (0,react.useState)(isEdit ? true : false), expanded = ref[0], setExpanded = ref[1];
    var options = (0,react.useMemo)(function() {
        return resourceType === utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar ? [
            {
                value: utoniq_core_schema/* ItemThumbnailType.Passthrough */.gy9.Passthrough,
                label: ""
            }
        ] : [
            {
                value: utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square,
                label: t("square")
            },
            {
                value: utoniq_core_schema/* ItemThumbnailType.Rectangle */.gy9.Rectangle,
                label: t("rectangle")
            }, 
        ];
    }, [
        resourceType,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("thumbnailLabel")
            }),
            resourceType !== utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2,
                    mt: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: thumbnailType === option.value ? "contained" : "outlined",
                        onClick: function() {
                            return setValue("thumbnailType", option.value);
                        },
                        /**
               * NOTE:
               * アイテムのサムネイル型が変更できるようにAPI修正するまで編集UIをdisabledにしている
               * https://app.clickup.com/t/908127/UT-14167
               */ disabled: isEdit && thumbnailType !== option.value,
                        children: option.label
                    }, index);
                })
            }),
            options.map(function(param) {
                var value = param.value;
                return value === thumbnailType && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                        t: t,
                        sx: {
                            p: 0
                        },
                        shape: value === "square" ? "square" : "rectangle",
                        resource: watch("thumbnailResource"),
                        fileUploadInfo: {
                            type: "image",
                            onDrop: function onDrop() {
                                return itemUploadInfo.onDrop(utoniq_core_schema/* ItemType.Image */.qGq.Image).then(function() {
                                    var _ref = (0,src_async_to_generator/* default */.Z)(function(resource) {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if (!(resource === null || resource === void 0 ? void 0 : resource.imageUploadPath)) {
                                                return [
                                                    2
                                                ];
                                            }
                                            setValue("thumbnail", resource.imageUploadPath, {
                                                shouldValidate: true
                                            });
                                            return [
                                                2,
                                                resource
                                            ];
                                        });
                                    });
                                    return function(resource) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            },
                            progress: itemUploadInfo.progress || 0,
                            description: t("".concat(value, "ThumbnailUploaderDescription")),
                            onClose: function onClose1() {
                                setValue("thumbnail", "", {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("thumbnailResource", null);
                                onClose && onClose();
                            }
                        },
                        content: {
                            title: ""
                        }
                    })
                }, value);
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                sx: {
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("thumbnailBackLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.hint",
                        children: t("optional")
                    }),
                    expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.UpArrow, {
                        size: "medium",
                        onClick: function() {
                            return setExpanded(function(prevState) {
                                return !prevState;
                            });
                        },
                        bgcolor: "transparent"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.DownArrow, {
                        size: "medium",
                        onClick: function() {
                            return setExpanded(function(prevState) {
                                return !prevState;
                            });
                        },
                        bgcolor: "transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.hint",
                sx: {
                    size: "11px",
                    lineHeight: "16px",
                    fontWeight: 300
                },
                children: t("thumbnailBackCaution")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: [
                    options.map(function(param) {
                        var value = param.value;
                        return value === thumbnailType && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                                t: t,
                                sx: {
                                    p: 0
                                },
                                shape: value === "square" ? "square" : "rectangle",
                                resource: watch("thumbnailBackResource"),
                                fileUploadInfo: {
                                    type: "image",
                                    onDrop: function onDrop() {
                                        return itemUploadInfo.onDrop(utoniq_core_schema/* ItemType.Image */.qGq.Image).then(function() {
                                            var _ref = (0,src_async_to_generator/* default */.Z)(function(resource) {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    if (!resource) {
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    setValue("thumbnailBack", resource.imageUploadPath, {
                                                        shouldValidate: true
                                                    });
                                                    setValue("isBothThumbnail", false);
                                                    return [
                                                        2,
                                                        resource
                                                    ];
                                                });
                                            });
                                            return function(resource) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }());
                                    },
                                    progress: itemUploadInfo.progress || 0,
                                    description: t("".concat(value, "ThumbnailUploaderDescription")),
                                    onClose: function onClose1() {
                                        setValue("thumbnailBack", "", {
                                            shouldValidate: true,
                                            shouldDirty: true
                                        });
                                        setValue("thumbnailBackResource", null);
                                        setValue("isBothThumbnail", isEdit ? true : false);
                                        onBackClose && onBackClose();
                                    }
                                },
                                content: {
                                    title: ""
                                }
                            })
                        }, value);
                    }),
                    !!errorBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        error: true,
                        children: errorBack.message
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(23883);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ItemImageInputCell.tsx










var ItemImageInputCell = function(param) {
    var fileUploadInfo = param.fileUploadInfo, watch = param.watch, control = param.control, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var fields = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "images",
        keyName: "_id"
    }).fields;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var images = watch("images");
    var ref1;
    var indexAdd = (0,react.useMemo)(function() {
        return (ref1 = images === null || images === void 0 ? void 0 : images.findIndex(function(param) {
            var tmpPath = param.tmpPath;
            return !tmpPath;
        })) !== null && ref1 !== void 0 ? ref1 : 0;
    }, [
        images
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
                onClickAway: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            children: t("imagesLabel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            title: t("imagesDesc"),
                            onClose: function() {
                                return setOpen(false);
                            },
                            open: open,
                            disableHoverListener: true,
                            disableTouchListener: true,
                            arrow: true,
                            slotProps: {
                                popper: {
                                    disablePortal: true
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Info, {
                                onClick: function() {
                                    return setOpen(true);
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: (0,src_object_spread/* default */.Z)({
                    py: 4,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    children: fields.map(function(field, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage, {
                            index: index,
                            fileUploadInfo: fileUploadInfo,
                            setValue: setValue,
                            watch: watch,
                            readOnly: index > indexAdd
                        }, field._id);
                    })
                })
            })
        ]
    });
};
var UploadImage = function(param) {
    var index = param.index, readOnly = param.readOnly, watch = param.watch, setValue = param.setValue, fileUploadInfo = param.fileUploadInfo;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref = (0,react.useState)(""), thumbnailUrl = ref[0], setThumbnailUrl = ref[1];
    var thumbnailWatch = watch("images.".concat(index, ".tmpPath"));
    (0,react.useEffect)(function() {
        setThumbnailUrl(thumbnailWatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            position: "relative",
            width: "fit-content"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    bottom: 4,
                    right: 4,
                    bgcolor: "grey.100",
                    borderRadius: "40px",
                    p: "2px 4px",
                    zIndex: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    component: "p",
                    children: [
                        index + 1,
                        "/30"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThumbnailUploadField, {
                t: t,
                shape: "square",
                readOnly: readOnly,
                thumbnailProps: {
                    src: thumbnailUrl,
                    sx: {
                        img: {
                            objectFit: "contain"
                        }
                    }
                },
                onClose: function() {
                    setThumbnailUrl("");
                    setValue("images.".concat(index, ".tmpPath"), "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                fileUploadInfo: {
                    type: "image",
                    progress: fileUploadInfo.progress,
                    onDrop: function onDrop() {
                        return fileUploadInfo.onDrop(utoniq_core_schema/* ItemType.Image */.qGq.Image).then(function(resource) {
                            if (!resource) return;
                            var _imageUrl;
                            setThumbnailUrl((_imageUrl = resource.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "");
                            setValue("images.".concat(index, ".tmpPath"), resource.imageUploadPath, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            return resource;
                        });
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PriceInputCell.tsx









var PriceInputCell = function(param) {
    var mode = param.mode, resourceType = param.resourceType, hasPrice = param.hasPrice, setValue = param.setValue, inputProps = param.inputProps, _defaultPrice = param.defaultPrice, defaultPrice = _defaultPrice === void 0 ? 0 : _defaultPrice, paymentType = param.paymentType, _disableRadio = param.disableRadio, disableRadio = _disableRadio === void 0 ? false : _disableRadio;
    {
    /**
     * ポイントにも対応するアプリかつ現金払いに対応するアイテムかを判定
     */ }
    var canPaymentOptionSelect = function(hasPrice, paymentType, canPrepaidUse, resourceType) {
        if (!hasPrice || !paymentType || !canPrepaidUse) return false;
        return true // Enable cash payment option for all resource types
        ;
    };
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var options = [
        {
            value: true,
            label: t("availableForSale")
        },
        {
            value: false,
            label: t("notForSale")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            (mode === "create" || hasPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("priceLabel")
            }),
            mode === "create" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            pt: 2
                        },
                        children: t("priceDesc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        sx: {
                            py: 2
                        },
                        children: options.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: hasPrice === option.value ? "contained" : "outlined",
                                onClick: function() {
                                    setValue("hasPrice", option.value);
                                    if (option.value) {
                                        setValue("price", defaultPrice, {
                                            shouldValidate: true,
                                            shouldDirty: false
                                        });
                                    } else {
                                        setValue("price", 0, {
                                            shouldValidate: true,
                                            shouldDirty: true
                                        });
                                    }
                                },
                                children: option.label
                            }, index);
                        })
                    })
                ]
            }) : hasPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("priceForSaleEditDesc")
            }),
            canPaymentOptionSelect(hasPrice, paymentType, !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint, resourceType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                        onChange: function(_, value) {
                            setValue("paymentType", value, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            gap: 3
                        },
                        value: paymentType,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: (0,core_form/* tLabel */.TQ)("consoleItemCreate.paymentType.prepaidPoint"),
                                disabled: disableRadio
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                value: utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: (0,core_form/* tLabel */.TQ)("consoleItemCreate.paymentType.cash"),
                                disabled: disableRadio
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "body2",
                        sx: {
                            mt: 2
                        },
                        children: t("paymentTypeDesc")
                    })
                ]
            }),
            hasPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                            textFieldProps: {
                                sx: {
                                    mb: 0
                                }
                            }
                        }, inputProps)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: {
                                pb: 4
                            },
                            children: paymentType === utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint ? t("point") : t("円")
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/AvailableDateInputCell.tsx





var AvailableDateInputCell = function(param) {
    var values = param.values, setValue = param.setValue, errors = param.errors;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    pb: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("metadata.ticket.startDateOfUse", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: values[0] ? dayjs_min_default()(values[0]) : null,
                    placeholder: t("datePlaceholder"),
                    error: errors[0],
                    title: t("availableDateStartLabel"),
                    titleProps: {
                        variant: "h5",
                        color: "text.primary"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    pb: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("metadata.ticket.endDateOfUse", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: values[1] ? dayjs_min_default()(values[1]) : null,
                    placeholder: t("datePlaceholder"),
                    error: errors[1],
                    title: t("availableDateEndLabel"),
                    titleProps: {
                        variant: "h5",
                        color: "text.primary"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ThroughTicketInputCell.tsx













var ThroughTicketInputCell = function(param) {
    var editable = param.editable, isThroughTicket = param.isThroughTicket, control = param.control, setValue = param.setValue, errors = param.errors, watch = param.watch, register = param.register;
    var ref = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        keyName: "_id",
        name: "metadata.ticket.throughTicket"
    }), fields = ref.fields, append = ref.append, onRemove = ref.remove;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("throughTicketLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                        checked: isThroughTicket,
                        disabled: !editable,
                        sx: {
                            "&& .Mui-disabled + .MuiSwitch-track": {
                                bgcolor: "grey.100"
                            }
                        },
                        onChange: function() {
                            var ref;
                            if (!isThroughTicket && ((ref = watch("metadata.ticket.throughTicket")) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                                setValue("metadata.ticket.throughTicket", [
                                    {
                                        name: ""
                                    }
                                ], {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                            setValue("metadata.ticket.isThroughTicket", !isThroughTicket, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    color: "text.secondary",
                    children: t("throughTicketDesc")
                })
            }),
            isThroughTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "normal",
                                        sx: {
                                            width: "auto",
                                            pl: 0,
                                            pr: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("subTicketAdd")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "normal",
                                        sx: {
                                            width: 30,
                                            px: 0,
                                            textAlign: "center"
                                        },
                                        children: fields.length < 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                bgcolor: "primary.main",
                                                width: 20,
                                                height: 20,
                                                color: "white",
                                                "&:hover": {
                                                    bgcolor: "primary.main",
                                                    opacity: 0.8
                                                },
                                                "&.Mui-disabled": {
                                                    bgcolor: "grey.100",
                                                    color: "grey.300"
                                                }
                                            },
                                            size: "small",
                                            disabled: !editable,
                                            onClick: function() {
                                                return append({
                                                    name: ""
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Plus, {
                                                sx: {
                                                    color: "inherit",
                                                    width: 10,
                                                    height: 10
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                            children: fields.map(function(field, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SubTicketRowCell, {
                                    index: index,
                                    register: register,
                                    editable: !!editable,
                                    error: errors === null || errors === void 0 ? void 0 : errors[index],
                                    value: watch("metadata.ticket.throughTicket.".concat(index)),
                                    setValue: setValue,
                                    onRemove: function() {
                                        return onRemove(index);
                                    }
                                }, field._id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var SubTicketRowCell = function(param) {
    var register = param.register, index = param.index, setValue = param.setValue, value = param.value, error = param.error, editable = param.editable, onRemove = param.onRemove;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                sx: function(theme) {
                    return {
                        borderTop: index !== 0 ? "1px solid ".concat(theme.palette.grey[100]) : "none"
                    };
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                        padding: "normal",
                        sx: {
                            width: "auto",
                            borderBottom: "none",
                            pl: 0,
                            pr: 2,
                            pb: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.primary",
                                mb: 2,
                                children: t("subTicketName")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                type: "text",
                                titleProps: {
                                    sx: {
                                        display: "none"
                                    }
                                },
                                textFieldProps: {
                                    sx: {
                                        m: 0
                                    },
                                    InputProps: {
                                        inputProps: {
                                            sx: {
                                                px: 4,
                                                py: 3,
                                                mb: 0
                                            }
                                        }
                                    },
                                    placeholder: t("subTicketNamePlaceholder")
                                }
                            }, register("metadata.ticket.throughTicket.".concat(index, ".name"))), {
                                onChange: function() {
                                    var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            setValue("metadata.ticket.throughTicket.".concat(index, ".name"), e.target.value, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                error: error === null || error === void 0 ? void 0 : error.name
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                        padding: "normal",
                        sx: {
                            width: 30,
                            borderBottom: "none",
                            px: 0,
                            pb: 0
                        },
                        rowSpan: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                    size: "small",
                                    disabled: !editable,
                                    sx: {
                                        color: "grey.600",
                                        "&.Mui-disabled": {
                                            color: "grey.300"
                                        }
                                    },
                                    onClick: function() {
                                        if (!(value === null || value === void 0 ? void 0 : value.name)) {
                                            onRemove();
                                        } else {
                                            setOpen(true);
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
                                        sx: {
                                            color: "inherit"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                                    open: open,
                                    title: t("removeSubTicketTitle", {
                                        name: ((ref3 = value === null || value === void 0 ? void 0 : (ref = value.name) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 0) <= 20 ? (ref4 = value === null || value === void 0 ? void 0 : value.name) !== null && ref4 !== void 0 ? ref4 : "" : "".concat(value === null || value === void 0 ? void 0 : (ref1 = value.name) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 20), "…")
                                    }),
                                    content: t("removeSubTicketDesc"),
                                    onClose: function() {
                                        return setOpen(false);
                                    },
                                    cancelText: t("close"),
                                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "large",
                                        color: "primary",
                                        sx: {
                                            minWidth: 212
                                        },
                                        onClick: function() {
                                            onRemove();
                                            setOpen(false);
                                        },
                                        children: t("remove")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                    padding: "normal",
                    sx: {
                        width: "auto",
                        borderBottom: "none",
                        pl: 0,
                        pr: 2,
                        py: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.primary",
                            children: t("availableDateStartLabel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                            placeholder: t("datePlaceholder"),
                            error: error === null || error === void 0 ? void 0 : error.startDateOfUse,
                            value: value.startDateOfUse ? dayjs_min_default()(value.startDateOfUse) : null,
                            onChange: function(date) {
                                setValue("metadata.ticket.throughTicket.".concat(index, ".startDateOfUse"), (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                    padding: "normal",
                    sx: {
                        width: "auto",
                        borderBottom: "none",
                        pl: 0,
                        pr: 2,
                        py: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.primary",
                            children: t("availableDateEndLabel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                            placeholder: t("datePlaceholder"),
                            error: error === null || error === void 0 ? void 0 : error.endDateOfUse,
                            value: value.endDateOfUse ? dayjs_min_default()(value.endDateOfUse) : null,
                            onChange: function(date) {
                                setValue("metadata.ticket.throughTicket.".concat(index, ".endDateOfUse"), (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ExpirationDateInputCell.tsx






var ExpirationDateInputCell = function(param) {
    var value = param.value, setValue = param.setValue, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("expirationDateLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("expirationDateDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                    listItems: [
                        {
                            value: "unlimited",
                            label: t("unlimited")
                        },
                        {
                            value: utoniq_core_schema/* TicketItemExpirationTerm.Halfyear */.EQx.Halfyear,
                            label: t("6months")
                        },
                        {
                            value: utoniq_core_schema/* TicketItemExpirationTerm.Oneyear */.EQx.Oneyear,
                            label: t("1year")
                        }, 
                    ],
                    value: value || "unlimited",
                    onChange: function(value) {
                        return setValue("metadata.ticket.expirationTerm", value === "unlimited" ? null : value);
                    },
                    error: !!error,
                    helperText: error === null || error === void 0 ? void 0 : error.message,
                    placeholder: t("metadata.ticket.expiredAtPlaceholder"),
                    formControlProps: {
                        sx: {
                            width: "100%",
                            bgcolor: "grey.50",
                            minHeight: "auto"
                        }
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/AppDeadlineInputCell.tsx






var AppDeadlineInputCell = function(param) {
    var setValue = param.setValue, value = param.value, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("appDeadlineLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("appDeadlineDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    error: error,
                    onChange: function(date) {
                        setValue("metadata.merch.receptionPeriod.endedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: value ? dayjs_min_default()(value) : null,
                    placeholder: t("appDeadlinePlaceholder"),
                    titleProps: {
                        variant: "h5",
                        color: "text.primary"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PersonalInformationRequirementsInputCell.tsx




var personalInformationRequirementsValue = {
    none: "none",
    nameAndTel: "nameAndTel",
    nameAndTelAndAddress: "nameAndTelAndAddress"
};
var PersonalInformationRequirementsInputCell = function(param) {
    var setValue = param.setValue, personalInformationRequirements = param.personalInformationRequirements;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("personalInformationRequirementsLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("personalInformationRequirementsDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                onChange: function(_, value) {
                    setValue("personalInformationRequirements", value, {
                        shouldDirty: true
                    });
                },
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                    mt: 1
                },
                value: personalInformationRequirements,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: personalInformationRequirementsValue.none,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consoleItemCreate.personalInformationRequirementsType.none")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: personalInformationRequirementsValue.nameAndTel,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consoleItemCreate.personalInformationRequirementsType.nameAndTel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        value: personalInformationRequirementsValue.nameAndTelAndAddress,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consoleItemCreate.personalInformationRequirementsType.nameAndTelAndAddress")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/IssueInputCell.tsx







var IssueInputCell = function(param) {
    var hasIssuedNumber = param.hasIssuedNumber, setValue = param.setValue, inputProps = param.inputProps, _defaultNumber = param.defaultNumber, defaultNumber = _defaultNumber === void 0 ? 100 : _defaultNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var options = [
        {
            value: true,
            label: t("limited")
        },
        {
            value: false,
            label: t("noLimit")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("issuedNumberLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("issuedNumberDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: hasIssuedNumber === option.value ? "contained" : "outlined",
                        onClick: function() {
                            setValue("hasIssuedNumber", option.value);
                            if (!option.value) {
                                setValue("issuedNumber", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            } else {
                                setValue("issuedNumber", defaultNumber, {
                                    shouldValidate: true,
                                    shouldDirty: false
                                });
                            }
                        },
                        children: option.label
                    }, index);
                })
            }),
            hasIssuedNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                    textFieldProps: {
                        sx: {
                            mb: 0
                        }
                    }
                }, inputProps))
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@ionic/react/css/core.css
var core = __webpack_require__(91760);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/SkuInputCell.tsx
















var SkuInputCell = function(param) {
    var fields = param.fields, hasIssuedNumber = param.hasIssuedNumber, setValue = param.setValue, trigger = param.trigger, register = param.register, fileUploadInfo = param.fileUploadInfo, watch = param.watch, onAppend = param.onAppend, onRemove = param.onRemove, errors = param.errors, onMove = param.onMove, units = param.units;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var hasSkuWatch = watch("hasSku");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
                            onClickAway: function() {
                                return setOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        children: t("settingSKULabel")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: t("settingSKUDesc"),
                                        onClose: function() {
                                            return setOpen(false);
                                        },
                                        open: open,
                                        disableHoverListener: true,
                                        disableTouchListener: true,
                                        arrow: true,
                                        slotProps: {
                                            popper: {
                                                disablePortal: true
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Info, {
                                            onClick: function() {
                                                return setOpen(true);
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                            sx: {
                                "&& .Mui-disabled + .MuiSwitch-track": {
                                    bgcolor: "grey.100"
                                },
                                "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                    bgcolor: "primary.main"
                                }
                            },
                            checked: hasSkuWatch,
                            onChange: function() {
                                if (hasSkuWatch) {
                                    setValue("skuSettings.units", [], {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                } else {
                                    setValue("skuSettings.units", [
                                        {
                                            unitName: "",
                                            stock: undefined,
                                            order: 1,
                                            thumbnail: undefined,
                                            price: null
                                        }, 
                                    ], {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                }
                                setValue("hasSku", !hasSkuWatch, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                        })
                    })
                ]
            }),
            !!hasSkuWatch && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "normal",
                                        sx: {
                                            width: "auto",
                                            pl: 0,
                                            pr: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("skuValue")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "normal",
                                        sx: {
                                            width: 78,
                                            pl: 0,
                                            pr: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("thumbnail")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "normal",
                                        sx: {
                                            width: 30,
                                            px: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                            sx: {
                                                bgcolor: "primary.main",
                                                width: 20,
                                                height: 20,
                                                "&:hover": {
                                                    bgcolor: "primary.main",
                                                    opacity: 0.8
                                                }
                                            },
                                            size: "small",
                                            disabled: fields.length > 19,
                                            onClick: onAppend,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Plus, {
                                                sx: {
                                                    color: "white",
                                                    width: 10,
                                                    height: 10
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                            children: fields.map(function(field, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SkuUnitCell, {
                                    index: index,
                                    unitLength: fields.length,
                                    fileUploadInfo: fileUploadInfo,
                                    hasIssuedNumber: hasIssuedNumber,
                                    register: register,
                                    setValue: setValue,
                                    onRemove: onRemove,
                                    onMove: onMove,
                                    watch: watch,
                                    errors: errors === null || errors === void 0 ? void 0 : errors.units,
                                    trigger: trigger,
                                    unit: units === null || units === void 0 ? void 0 : units[index]
                                }, field._id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var SkuUnitCell = function(param) {
    var index = param.index, unitLength = param.unitLength, trigger = param.trigger, register = param.register, setValue = param.setValue, errors = param.errors, onRemove = param.onRemove, hasIssuedNumber = param.hasIssuedNumber, fileUploadInfo = param.fileUploadInfo, watch = param.watch, onMove = param.onMove, unit = param.unit;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var unitNameWatch = watch("skuSettings.units.".concat(index, ".unitName"));
    var ref3 = useVerticalDnD({
        index: index,
        onMove: onMove,
        accept: "SKU_ITEM"
    }), ref4 = ref3.ref, drag = ref3.drag, opacity = ref3.opacity;
    (0,react.useEffect)(function() {
        if (!hasIssuedNumber) {
            setValue("skuSettings.units.".concat(index, ".stock"), "", {
                shouldValidate: true,
                shouldDirty: true
            });
        }
    }, [
        hasIssuedNumber
    ]);
    var handleTriggerUnitStock = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all((0,src_to_consumable_array/* default */.Z)(Array(unitLength).keys()).map(function(idx) {
                            return trigger("skuSettings.units.".concat(idx, ".stock"));
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        trigger,
        unitLength
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
        ref: ref4,
        sx: {
            opacity: opacity
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    width: "auto",
                    borderBottom: "none",
                    pl: 0,
                    pr: 2,
                    pb: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "text",
                            titleProps: {
                                sx: {
                                    display: "none"
                                }
                            },
                            textFieldProps: {
                                sx: {
                                    m: 0
                                },
                                placeholder: t("unitNamePlaceholder")
                            }
                        }, register("skuSettings.units.".concat(index, ".unitName"))), {
                            error: errors === null || errors === void 0 ? void 0 : (ref = errors[index]) === null || ref === void 0 ? void 0 : ref.unitName
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "number",
                            titleProps: {
                                sx: {
                                    display: "none"
                                }
                            },
                            textFieldProps: {
                                sx: {
                                    m: 0
                                },
                                placeholder: hasIssuedNumber ? t("stockPlaceholder") : t("stockNoLimitPlaceholder")
                            }
                        }, register("skuSettings.units.".concat(index, ".stock"))), {
                            onChange: function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                setValue("skuSettings.units.".concat(index, ".stock"), event.target.value, {
                                                    shouldValidate: true,
                                                    shouldDirty: true
                                                });
                                                return [
                                                    4,
                                                    handleTriggerUnitStock()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(event) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            disabled: !hasIssuedNumber,
                            error: errors === null || errors === void 0 ? void 0 : (ref1 = errors[index]) === null || ref1 === void 0 ? void 0 : ref1.stock
                        })),
                        unit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                mb: 6,
                                ml: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    children: t("remainingNumber")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    children: watch("skuSettings.units.".concat(index, ".stock")) - ((unit === null || unit === void 0 ? void 0 : unit.purchasedNumber) || 0) - ((unit === null || unit === void 0 ? void 0 : unit.pendingPurchaseNumber) || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    width: 78,
                    borderBottom: "none",
                    pl: 0,
                    pr: 2,
                    pb: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuThumbnail, {
                    index: index,
                    fileUploadInfo: fileUploadInfo,
                    setValue: setValue,
                    watch: watch
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "normal",
                sx: {
                    width: 30,
                    borderBottom: "none",
                    px: 0,
                    pb: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            size: "small",
                            ref: drag,
                            disableRipple: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Sort, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                            size: "small",
                            onClick: function() {
                                return setOpen(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                            open: open,
                            title: t("removeUnitTitle", {
                                unitName: unitNameWatch || "SKU"
                            }),
                            content: t("removeUnitDesc"),
                            onClose: function() {
                                return setOpen(false);
                            },
                            cancelText: t("close"),
                            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                color: "primary",
                                sx: {
                                    minWidth: 212
                                },
                                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                onRemove(index);
                                                return [
                                                    4,
                                                    handleTriggerUnitStock()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: t("remove")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var SkuThumbnail = function(param) {
    var index = param.index, watch = param.watch, setValue = param.setValue, fileUploadInfo = param.fileUploadInfo;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(""), thumbnailUrl = ref1[0], setThumbnailUrl = ref1[1];
    var thumbnailWatch = watch("skuSettings.units.".concat(index, ".thumbnail"));
    var thumbnailTypeWatch = watch("thumbnailType");
    (0,react.useEffect)(function() {
        setThumbnailUrl(thumbnailWatch);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ThumbnailUploadField, {
                t: t,
                shape: thumbnailTypeWatch,
                thumbnailProps: {
                    src: thumbnailUrl,
                    onClick: function onClick() {
                        setOpen(true);
                    }
                },
                fileUploadInfo: {
                    type: "image",
                    progress: fileUploadInfo.progress,
                    onDrop: function onDrop() {
                        return fileUploadInfo.onDrop(utoniq_core_schema/* ItemType.Image */.qGq.Image).then(function(resource) {
                            if (!resource) return;
                            var _imageUrl;
                            setThumbnailUrl((_imageUrl = resource.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "");
                            setValue("skuSettings.units.".concat(index, ".thumbnail"), resource.imageUploadPath, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            return resource;
                        });
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullHeightModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                pt: 5,
                                pb: 3
                            },
                            children: t("thumbnailImage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                mt: 2,
                                mb: 7
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    width: "fit-content"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: function() {
                                            setOpen(false);
                                            setThumbnailUrl("");
                                            setValue("skuSettings.units.".concat(index, ".thumbnail"), null, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        },
                                        sx: {
                                            position: "absolute",
                                            top: 8,
                                            right: 8,
                                            zIndex: 10,
                                            bgcolor: "white",
                                            "&:hover": {
                                                bgcolor: "white",
                                                opacity: 0.8
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Close, {
                                            sx: {
                                                color: "grey.700"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        variant: "square",
                                        sx: {
                                            width: 250,
                                            height: thumbnailTypeWatch === "square" ? 250 : 400
                                        },
                                        src: thumbnailUrl
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                py: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                onClick: function() {
                                    return setOpen(false);
                                },
                                children: t("close")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var FullHeightModal = function(param) {
    var open = param.open, onClose = param.onClose, children = param.children;
    /** IonModalの初期化時にページがスクロールできるようにするための処理 */ (0,react.useEffect)(function() {
        document.body.style.overflow = open ? "hidden" : "scroll";
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
                styles: {
                    "ion-modal#fullHeightModal": {
                        "--height": "auto"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* IonModal */.ki, {
                isOpen: open,
                onDidDismiss: onClose,
                initialBreakpoint: 1,
                breakpoints: [
                    0,
                    1
                ],
                id: "fullHeightModal",
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/LimitIssueInputCell.tsx







var LimitIssueInputCell = function(param) {
    var hasPurchaseLimitByUser = param.hasPurchaseLimitByUser, setValue = param.setValue, inputProps = param.inputProps, _defaultNumber = param.defaultNumber, defaultNumber = _defaultNumber === void 0 ? 1 : _defaultNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var options = [
        {
            value: true,
            label: t("limited")
        },
        {
            value: false,
            label: t("noLimit")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("limitIssuedNumberLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("limitIssuedNumberDescSKU")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: hasPurchaseLimitByUser === option.value ? "contained" : "outlined",
                        onClick: function() {
                            setValue("hasPurchaseLimitByUser", option.value);
                            if (!option.value) {
                                setValue("purchaseLimitByUser", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            } else {
                                setValue("purchaseLimitByUser", defaultNumber, {
                                    shouldValidate: true,
                                    shouldDirty: false
                                });
                            }
                        },
                        children: option.label
                    }, index);
                })
            }),
            hasPurchaseLimitByUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                    textFieldProps: {
                        sx: {
                            mb: 0
                        }
                    }
                }, inputProps))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PerOrderLimitInputCell.tsx







var PerOrderLimitInputCell = function(param) {
    var hasPurchaseLimitPerOrder = param.hasPurchaseLimitPerOrder, setValue = param.setValue, inputProps = param.inputProps, _defaultNumber = param.defaultNumber, defaultNumber = _defaultNumber === void 0 ? 1 : _defaultNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var options = [
        {
            value: true,
            label: t("limited")
        },
        {
            value: false,
            label: t("noLimit")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("perOrderLimitNumberLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("perOrderLimitNumberDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: hasPurchaseLimitPerOrder === option.value ? "contained" : "outlined",
                        onClick: function() {
                            setValue("hasPurchaseLimitPerOrder", option.value);
                            if (!option.value) {
                                setValue("purchaseLimitPerOrder", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            } else {
                                setValue("purchaseLimitPerOrder", defaultNumber, {
                                    shouldValidate: true,
                                    shouldDirty: false
                                });
                            }
                        },
                        children: option.label
                    }, index);
                })
            }),
            hasPurchaseLimitPerOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                    textFieldProps: {
                        sx: {
                            mb: 0
                        }
                    }
                }, inputProps))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/TicketNumberInputCell.tsx








var TicketNumberInputCell = function(param) {
    var watch = param.watch, setValue = param.setValue, register = param.register, errors = param.errors;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var hasAssignedNumberWatch = watch("hasAssignedNumber");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            children: t("ticketNumberLabel", "整理番号")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                            checked: hasAssignedNumberWatch,
                            onChange: function() {
                                if (hasAssignedNumberWatch) {
                                    setValue("metadata.ticket.assignedNumberPrefix", null, {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                    setValue("metadata.ticket.startAssignedNumber", null, {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                }
                                setValue("hasAssignedNumber", !hasAssignedNumberWatch, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("ticketNumberDesc1")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: t("ticketNumberDesc2")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                children: t("ticketNumberDesc3")
            }),
            hasAssignedNumberWatch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    pt: 2,
                    flexWrap: "wrap",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "text"
                        }, register("metadata.ticket.assignedNumberPrefix")), {
                            error: errors === null || errors === void 0 ? void 0 : errors.assignedNumberPrefix
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "number"
                        }, register("metadata.ticket.startAssignedNumber")), {
                            error: errors === null || errors === void 0 ? void 0 : errors.startAssignedNumber
                        }))
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ShareInputCell.tsx







var ShareInputCell = function(param) {
    var value = param.value, endedAt = param.endedAt, setValue = param.setValue, errors = param.errors;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, {
                checked: value,
                onChange: function(event, checked) {
                    setValue("metadata.ticket.distributionEnabled", checked, {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                    if (!checked) {
                        setValue("metadata.ticket.distributionEndedAt", null, {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                    }
                },
                content: {
                    title: t("shareEnabledLabel"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "text.secondary",
                            children: t("shareEnabledDesc")
                        })
                    })
                },
                sx: {
                    pb: 4
                }
            }),
            value && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("metadata.ticket.distributionEndedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || null, {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: endedAt ? dayjs_min_default()(endedAt) : null,
                    title: t("shareDistributionEndedAtTitle"),
                    description: t("shareDistributionEndedAtDesc"),
                    placeholder: t("shareDistributionEndedAtPlaceholder"),
                    error: errors === null || errors === void 0 ? void 0 : (ref = errors.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.distributionEndedAt,
                    titleProps: {
                        variant: "subtitle1",
                        color: "text.primary"
                    }
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(73074);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/PremiumInputCell.tsx








var PremiumInputCell = function(param) {
    var register = param.register, setValue = param.setValue, watch = param.watch, plans = param.plans, defaultValue = param.defaultValue, showCheckboxError = param.showCheckboxError;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var isPremium = watch("isPremium");
    var _ref = register("isPremium"), registerOnChange = _ref.onChange, registerProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "onChange"
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("membersOnly"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "text.secondary",
                            children: t("membersOnlyDesc")
                        })
                    })
                },
                checked: isPremium,
                onChange: function() {
                    if (isPremium) {
                        setValue("purchesablePlanIds", [], {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("isPremium", false, {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    } else {
                        setValue("purchesablePlanIds", defaultValue, {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("isPremium", true, {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    }
                }
            }, registerProps)),
            isPremium && plans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                error: showCheckboxError,
                children: [
                    plans.map(function(plan, index) {
                        var ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                label: plan === null || plan === void 0 ? void 0 : plan.title
                            }, register("purchesablePlanIds")), {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    onChange: function(e) {
                                        var currentPlanIds = watch("purchesablePlanIds") || [];
                                        if (e.target.checked) {
                                            var ref;
                                            // チェックされた場合、planIdを追加
                                            var newPlanIds = (0,src_to_consumable_array/* default */.Z)(currentPlanIds).concat([
                                                (ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : ""
                                            ]);
                                            setValue("purchesablePlanIds", newPlanIds, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        } else {
                                            // チェックが解除された場合、planIdを削除
                                            var newPlanIds1 = currentPlanIds.filter(function(id) {
                                                return id !== (plan === null || plan === void 0 ? void 0 : plan.planId);
                                            });
                                            setValue("purchesablePlanIds", newPlanIds1, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        }
                                    },
                                    checked: ((ref1 = watch("purchesablePlanIds")) === null || ref1 === void 0 ? void 0 : ref1.includes((ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : "")) || false
                                })
                            }), plan === null || plan === void 0 ? void 0 : plan.planId)
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "error.main",
                        children: showCheckboxError ? t("membershipAccessPermissionRequired") : " "
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/ResaleInputCell.tsx









var ResaleInputCell = function(param) {
    var value = param.value, startedAt = param.startedAt, endedAt = param.endedAt, setValue = param.setValue, errors = param.errors;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, {
                checked: value,
                onChange: function(event, checked) {
                    setValue("resaleEnabled", checked, {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                    if (!checked) {
                        setValue("metadata.ticket.resalePeriod.startedAt", "", {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                        setValue("metadata.ticket.resalePeriod.endedAt", "", {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                    }
                },
                content: {
                    title: t("resaleEnabledLabel"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                component: "a",
                                target: "_blank",
                                variant: "caption",
                                href: get_default()(config_config/* config */.v, "helpUrl", "#"),
                                sx: {
                                    alignItems: "center",
                                    display: "flex"
                                },
                                children: [
                                    t("resaleEnabledNote"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                                        fontSize: "xSmall",
                                        color: "inherit",
                                        sx: {
                                            ml: 1
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                children: t("resaleEnabledDesc")
                            })
                        ]
                    })
                },
                sx: {
                    pb: 4
                }
            }),
            value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                        onChange: function(date) {
                            setValue("metadata.ticket.resalePeriod.startedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        value: startedAt ? dayjs_min_default()(startedAt) : null,
                        title: t("resalePeriodStartedAtTitle"),
                        description: t("resalePeriodStartedAtDesc"),
                        placeholder: t("resalePeriodStartedAtPlaceholder"),
                        error: errors === null || errors === void 0 ? void 0 : (ref = errors.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.startedAt,
                        titleProps: {
                            variant: "subtitle1",
                            color: "text.primary"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                        onChange: function(date) {
                            setValue("metadata.ticket.resalePeriod.endedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date) || "", {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                        },
                        value: endedAt ? dayjs_min_default()(endedAt) : null,
                        title: t("resalePeriodEndedAtTitle"),
                        placeholder: t("resalePeriodEndedAtPlaceholder"),
                        error: errors === null || errors === void 0 ? void 0 : (ref3 = errors.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.endedAt,
                        titleProps: {
                            variant: "subtitle1",
                            color: "text.primary"
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/components/SalesDateInputCell.tsx





var SalesDateInputCell = function(param) {
    var values = param.values, setValue = param.setValue, errors = param.errors, trigger = param.trigger;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pb: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("salesStartedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        trigger("salesEndedAt");
                    },
                    value: values[0] ? dayjs_min_default()(values[0]) : null,
                    placeholder: t("datePlaceholder"),
                    error: errors[0],
                    title: t("salesStartAtLabel"),
                    titleProps: {
                        variant: "subtitle1",
                        color: "text.primary"
                    },
                    description: t("salesStartAtDesc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                    onChange: function(date) {
                        setValue("salesEndedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                    },
                    value: values[1] ? dayjs_min_default()(values[1]) : null,
                    placeholder: t("datePlaceholder"),
                    error: errors[1],
                    title: t("salesEndAtLabel"),
                    titleProps: {
                        variant: "subtitle1",
                        color: "text.primary"
                    },
                    description: t("salesEndAtDesc")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/ItemCreateForm.tsx


















var ItemCreateForm_schema = function(o) {
    return {
        title: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.title")).max(100),
        description: o.string().when("type", {
            is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
            then: o.string().optional().allow(null),
            otherwise: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.description"))
        }),
        resourceId: o.string().when("type", {
            switch: [
                {
                    is: utoniq_core_schema/* ItemType.Audio */.qGq.Audio,
                    then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.resourceId.audio"))
                },
                {
                    is: utoniq_core_schema/* ItemType.Video */.qGq.Video,
                    then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.resourceId.video")).required()
                },
                {
                    is: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                    then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.resourceId.magazine")).required()
                }, 
            ],
            otherwise: o.string().allow("").optional()
        }),
        resource: o.object().allow(null).optional(),
        avatarResources: o.object().when("type", {
            is: utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar,
            then: o.object({
                avatarResourceId: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.avatarResources.avatarResourceId")).required(),
                voiceResourceId: o.string().allow("").optional()
            }),
            otherwise: o.object().allow(null).optional()
        }),
        avatarResource: o.object().allow(null).optional(),
        wallpaperResources: o.object().when("type", {
            is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
            then: o.object({
                wallpaperResourceId: o.string().required().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.wallpaperResources.wallpaperResourceId")),
                audioResourceId: o.string().allow("").optional()
            }),
            otherwise: o.object().allow(null).optional()
        }),
        wallpaperResource: o.object().allow(null).optional(),
        hasPrice: o.boolean().optional(),
        price: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.price")).when("hasPrice", [
            {
                is: true,
                then: o.number().required().min(100).max(100000)
            },
            {
                is: false,
                then: o.number().allow(0).optional()
            }, 
        ]),
        paymentType: o.string().when("hasPrice", [
            {
                is: true,
                then: o.string().valid(utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint, utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash)
            },
            {
                is: false,
                then: o.string().valid(utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint, utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash).allow(null).allow("").optional()
            }, 
        ]),
        hasIssuedNumber: o.boolean().optional(),
        issuedNumber: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.issuedNumber")).when("hasIssuedNumber", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        hideSalesNumber: o.boolean().optional(),
        isBothThumbnail: o.boolean().optional(),
        hasPurchaseLimitByUser: o.boolean().optional(),
        purchaseLimitByUser: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.purchaseLimitByUser")).when("hasPurchaseLimitByUser", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        hasPurchaseLimitPerOrder: o.boolean().optional(),
        purchaseLimitPerOrder: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.purchaseLimitPerOrder")).when("hasPurchaseLimitPerOrder", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        isPremium: o.boolean().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.isPremium")).optional(),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.membershipAccessPermission")).items(o.string()).optional().default([]),
        personalInformationRequirements: o.when("type", {
            is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
            then: o.string().optional().label("consoleItemCreate.personalInformationRequirements")
        }),
        type: o.string(),
        salesStatus: o.boolean().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.salesStatus")),
        salesStartedAt: o.date().optional().allow(null),
        salesEndedAt: o.date().optional().allow(null).custom(function(value, helpers) {
            var ref;
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            if (!value) {
                return value;
            }
            var salesStartedAt = (data === null || data === void 0 ? void 0 : data.salesStartedAt) || new Date();
            if (salesStartedAt > value) {
                // 開始日が終了日を過ぎていたらエラー
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleItemCreate.salesEndedAt.custom.over")
                });
            }
            return value;
        }),
        resaleEnabled: o.boolean().optional().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.resaleEnabled")),
        hasAssignedNumber: o.boolean().optional(),
        thumbnailType: o.string().allow("").optional(),
        thumbnail: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.title")),
        thumbnailBack: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.thumbnailBack")).allow("").optional(),
        metadata: o.object().when("type", {
            switch: [
                {
                    is: utoniq_core_schema/* ItemType.Merch */.qGq.Merch,
                    then: o.object({
                        merch: o.object({
                            receptionPeriod: o.object({
                                endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.merch.receptionPeriod.endedAt")).required()
                            })
                        }),
                        ticket: o.object().optional(),
                        magazine: o.object().optional(),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
                    then: o.object({
                        merch: o.object().optional(),
                        magazine: o.object().optional(),
                        ticket: o.object({
                            description: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.description")),
                            expirationTerm: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.expirationTerm")),
                            note: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.note")),
                            resalePeriod: o.object().when(o.ref("....resaleEnabled"), {
                                is: true,
                                then: o.object({
                                    startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.resalePeriod.startedAt")),
                                    endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.resalePeriod.endedAt"))
                                }),
                                otherwise: o.object({
                                    startedAt: o.date().optional().allow("").label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.resalePeriod.startedAt")),
                                    endedAt: o.date().optional().allow("").label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.resalePeriod.endedAt"))
                                })
                            }),
                            assignedNumberPrefix: o.string().when(o.ref("....hasAssignedNumber"), {
                                is: true,
                                then: o.string().max(5).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.assignedNumberPrefix")),
                                otherwise: o.string().optional().allow(null)
                            }),
                            startAssignedNumber: o.string().when(o.ref("....hasAssignedNumber"), {
                                is: true,
                                then: o.string().max(8).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.startAssignedNumber")),
                                otherwise: o.string().optional().allow(null)
                            }),
                            isThroughTicket: o.boolean().optional().allow(null),
                            throughTicket: o.array().when("isThroughTicket", {
                                is: true,
                                then: o.array().items(o.object({
                                    //id of field array
                                    _id: o.string().optional(),
                                    name: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.throughTicket.name")),
                                    startDateOfUse: o.date().optional().allow(null),
                                    endDateOfUse: o.date().optional().allow(null)
                                })),
                                otherwise: o.array().optional().allow(null)
                            }),
                            distributionEnabled: o.boolean().optional().allow(null),
                            distributionEndedAt: o.date().when("distributionEnabled", {
                                is: true,
                                then: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.distributionEndedAt")).required(),
                                otherwise: o.date().optional().allow(null, "")
                            }),
                            startDateOfUse: o.date().optional().allow(null),
                            endDateOfUse: o.date().optional().allow(null)
                        }),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                    then: o.object({
                        ticket: o.object().optional(),
                        merch: o.object().optional(),
                        magazine: o.object({
                            pageDirection: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.magazine.pageDirection"))
                        }),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                    then: o.object({
                        ticket: o.object().optional(),
                        magazine: o.object().optional(),
                        merch: o.object().optional(),
                        wallpaper: o.object({
                            isPrintEnabled: o.boolean().optional().allow(null),
                            printCount: o.number().optional().allow(null),
                            printType: o.string().optional().allow(null)
                        })
                    })
                }, 
            ],
            otherwise: o.object().allow(null).optional()
        }),
        thumbnailResource: o.object().allow(null).optional(),
        thumbnailBackResource: o.object().allow(null).optional(),
        hasSku: o.boolean().optional(),
        images: o.array().items(o.object({
            tmpPath: o.string().optional().allow(""),
            caption: o.string().optional()
        })),
        skuSettings: o.when("hasSku", {
            is: true,
            then: o.object({
                keyName: o.string().optional().allow(null),
                units: o.array().items(o.object({
                    _id: o.string().optional(),
                    id: o.string().optional(),
                    unitName: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.unitName")),
                    price: o.number().optional().allow(null),
                    stock: o.number().optional().allow("")//check total stock less than issuedNumber
                    .custom(function(value, helpers) {
                        var ref;
                        var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 4), units = ref1[1], data = ref1[3];
                        if (!value) {
                            return value;
                        }
                        var issuedNumber = (data === null || data === void 0 ? void 0 : data.issuedNumber) || 0;
                        var totalItemInStock = units === null || units === void 0 ? void 0 : units.reduce(function(currentVal, unit) {
                            return currentVal + +((unit === null || unit === void 0 ? void 0 : unit.stock) || 0);
                        }, 0);
                        if (totalItemInStock > issuedNumber) {
                            return helpers.message({
                                custom: (0,core_form/* tMessage */.Sd)("consoleItemCreate.stock.custom.over")
                            });
                        }
                        if (totalItemInStock < issuedNumber) {
                            return helpers.message({
                                custom: (0,core_form/* tMessage */.Sd)("consoleItemCreate.stock.custom.shortage")
                            });
                        }
                        return value;
                    }),
                    order: o.number(),
                    thumbnail: o.string().optional().allow(null)
                }))
            }),
            otherwise: o.object().optional()
        }),
        isDownloadable: o.when("type", {
            is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
            then: o.boolean().allow(null).optional(),
            otherwise: o.forbidden()
        }).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.isDownloadable"))
    };
};
var ItemCreateForm = function(param) {
    var resourceType = param.resourceType, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, plans = param.plans;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref18 = (0,react.useState)(false), open = ref18[0], setOpen = ref18[1];
    var ref19 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref19.showMessage, showError = ref19.showError;
    var ref20 = (0,core_form/* useForm */.cI)({
        schema: ItemCreateForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ItemCreateForm_defaultValues, defaultResourceValues[resourceType]), {
            type: resourceType
        })
    }), handleSubmit = ref20.handleSubmit, _formState = ref20.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid, register = ref20.register, setValue = ref20.setValue, watch = ref20.watch, setError = ref20.setError, control = ref20.control, trigger = ref20.trigger;
    var ref21 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        keyName: "_id",
        name: "skuSettings.units"
    }), fields = ref21.fields, append = ref21.append, onRemove = ref21.remove, onMove = ref21.move;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref22 = (0,react.useState)(false), showCheckboxError = ref22[0], setCheckboxError = ref22[1];
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setCheckboxError(true);
        } else {
            setCheckboxError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var isFormValid = isValid && !showCheckboxError;
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    onSubmit(values).then(function() {
                        showMessage(t("createdItemSuccessful"), "success");
                    }).catch(function(error) {
                        (0,core_form/* handleError */.S3)(error, setError, showError);
                    }).finally(function() {
                        setOpen(false);
                    })
                ];
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        setError,
        showMessage,
        t,
        showError
    ]);
    var ref23;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        children: [
            resourceType !== utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResourceUploadCell, {
                watch: watch,
                resourceType: resourceType,
                setValue: setValue,
                fileUploadInfo: fileUploadInfo,
                hasCreateResource: true,
                error: errors.resourceId || ((ref = errors.avatarResources) === null || ref === void 0 ? void 0 : ref.avatarResourceId) || ((ref1 = errors.wallpaperResources) === null || ref1 === void 0 ? void 0 : ref1.wallpaperResourceId)
            }),
            resourceType === utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDirectionInputCell, {
                setValue: setValue,
                watch: watch
            }),
            resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isDownloadable"),
                    description: t("isDownloadableDesc")
                },
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                }
            }, register("isDownloadable"))),
            resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper && config_config/* config.modules.eprint */.v.modules.eprint && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintInputCell, {
                setValue: setValue,
                isPrintEnabled: watch("metadata.wallpaper.isPrintEnabled"),
                printType: watch("metadata.wallpaper.printType"),
                printCount: watch("metadata.wallpaper.printCount")
            }),
            (resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper || resourceType === utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsAudioInputCell, {
                resourceType: resourceType,
                watch: watch,
                setValue: setValue,
                audioUploadInfo: fileUploadInfo,
                hasCreateResource: true
            }),
            resourceType === utoniq_core_schema/* ItemType.Audio */.qGq.Audio && false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemThumbnailInputCell, {
                watch: watch,
                resourceType: resourceType,
                setValue: setValue,
                itemUploadInfo: fileUploadInfo,
                error: errors.thumbnail,
                errorBack: errors.thumbnailBack
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageInputCell, {
                watch: watch,
                setValue: setValue,
                control: control,
                fileUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            (config_config/* config.modules.store */.v.modules.store || config_config/* config.modules.preSale */.v.modules.preSale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInputCell, {
                mode: "create",
                resourceType: resourceType,
                hasPrice: watch("hasPrice"),
                paymentType: (ref23 = watch("paymentType")) !== null && ref23 !== void 0 ? ref23 : utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint,
                setValue: setValue,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.price
                }, register("price"))
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: (ref2 = errors.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.description
            }, register("metadata.ticket.description"))) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: (ref4 = errors.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.note
            }, register("metadata.ticket.note"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && !watch("metadata.ticket.isThroughTicket") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableDateInputCell, {
                setValue: setValue,
                values: [
                    watch("metadata.ticket.startDateOfUse"),
                    watch("metadata.ticket.endDateOfUse"), 
                ],
                errors: [
                    (ref6 = errors.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ticket) === null || ref7 === void 0 ? void 0 : ref7.startDateOfUse,
                    (ref8 = errors.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : ref9.endDateOfUse, 
                ]
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketInputCell, {
                editable: true,
                isThroughTicket: watch("metadata.ticket.isThroughTicket"),
                control: control,
                setValue: setValue,
                register: register,
                watch: watch,
                errors: (ref10 = errors.metadata) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.ticket) === null || ref11 === void 0 ? void 0 : ref11.throughTicket
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpirationDateInputCell, {
                setValue: setValue,
                value: watch("metadata.ticket.expirationTerm"),
                error: errors === null || errors === void 0 ? void 0 : (ref12 = errors.metadata) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.ticket) === null || ref13 === void 0 ? void 0 : ref13.expirationTerm
            }),
            resourceType === utoniq_core_schema/* ItemType.Merch */.qGq.Merch && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDeadlineInputCell, {
                setValue: setValue,
                error: (ref14 = errors.metadata) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.merch) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.receptionPeriod) === null || ref16 === void 0 ? void 0 : ref16.endedAt,
                value: watch("metadata.merch.receptionPeriod.endedAt")
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInformationRequirementsInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("personalInformationRequirements")), {
                personalInformationRequirements: watch("personalInformationRequirements"),
                setValue: setValue
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IssueInputCell, {
                hasIssuedNumber: watch("hasIssuedNumber"),
                setValue: setValue,
                inputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.issuedNumber
                }, register("issuedNumber")), {
                    onChange: function onChange(event) {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setValue("issuedNumber", event.target.value);
                                        return [
                                            4,
                                            Promise.all((0,src_to_consumable_array/* default */.Z)(Array(fields.length).keys()).map(function(idx) {
                                                return trigger("skuSettings.units.".concat(idx, ".stock"));
                                            }))
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("salesStatusLabel"),
                    description: t("salesStatusDesc")
                },
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                }
            }, register("salesStatus")), {
                checked: watch("salesStatus")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesDateInputCell, {
                setValue: setValue,
                trigger: trigger,
                errors: [
                    errors.salesStartedAt,
                    errors.salesEndedAt
                ],
                values: [
                    watch("salesStartedAt"),
                    watch("salesEndedAt")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuInputCell, {
                setValue: setValue,
                hasIssuedNumber: watch("hasIssuedNumber"),
                fields: fields,
                watch: watch,
                trigger: trigger,
                register: register,
                onRemove: onRemove,
                fileUploadInfo: fileUploadInfo,
                onMove: onMove,
                errors: errors.skuSettings,
                onAppend: function() {
                    return append({
                        unitName: "",
                        stock: undefined,
                        order: 1,
                        thumbnail: undefined
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitIssueInputCell, {
                hasPurchaseLimitByUser: watch("hasPurchaseLimitByUser"),
                setValue: setValue,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.purchaseLimitByUser
                }, register("purchaseLimitByUser"))
            }),
            config_config/* config.modules.cart */.v.modules.cart && config_config/* config.modules.pickup */.v.modules.pickup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerOrderLimitInputCell, {
                hasPurchaseLimitPerOrder: watch("hasPurchaseLimitPerOrder"),
                setValue: setValue,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.purchaseLimitPerOrder
                }, register("purchaseLimitPerOrder"))
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketNumberInputCell, {
                watch: watch,
                setValue: setValue,
                register: register,
                errors: errors === null || errors === void 0 ? void 0 : (ref17 = errors.metadata) === null || ref17 === void 0 ? void 0 : ref17.ticket
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareInputCell, {
                setValue: setValue,
                value: !!watch("metadata.ticket.distributionEnabled"),
                endedAt: watch("metadata.ticket.distributionEndedAt"),
                errors: errors
            }),
            config_config/* config.modules.membership */.v.modules.membership && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumInputCell, {
                register: register,
                setValue: setValue,
                watch: watch,
                plans: plans,
                defaultValue: plans.map(function(plan) {
                    return (plan === null || plan === void 0 ? void 0 : plan.planId) || "";
                }),
                showCheckboxError: showCheckboxError
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("hideSalesNumberLabel"),
                    description: t("hideSalesNumberDesc")
                },
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                },
                checked: watch("hideSalesNumber")
            }, register("hideSalesNumber"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && config_config/* config.modules.resale */.v.modules.resale && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleInputCell, {
                setValue: setValue,
                value: !!watch("resaleEnabled", false),
                startedAt: watch("metadata.ticket.resalePeriod.startedAt"),
                endedAt: watch("metadata.ticket.resalePeriod.endedAt"),
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: !isFormValid || isSubmitting,
                    onClick: handleSubmit(function() {
                        return setOpen(true);
                    }),
                    children: t("submit")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("confirmSaveTitle"),
                content: t("confirmSaveDesc"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    loading: isSubmitting,
                    disabled: isSubmitting,
                    onClick: handleSubmit(handleOnSubmit),
                    children: t("submit")
                })
            })
        ]
    });
};
var ItemCreateForm_defaultValues = {
    title: "",
    type: utoniq_core_schema/* ItemType.Image */.qGq.Image,
    description: "",
    salesStatus: false,
    salesStartedAt: null,
    salesEndedAt: null,
    isPremium: false,
    personalInformationRequirements: personalInformationRequirementsValue.none,
    price: 0,
    issuedNumber: null,
    hideSalesNumber: true,
    hasPurchaseLimitByUser: false,
    hasPurchaseLimitPerOrder: false,
    purchaseLimitByUser: null,
    purchaseLimitPerOrder: null,
    thumbnail: "",
    copyrights: [],
    images: Array.from(Array(30).keys()).map(function() {
        return {
            tmpPath: "",
            caption: undefined
        };
    }),
    hasPrice: false,
    hasIssuedNumber: false,
    hasSku: false,
    skuSettings: {
        units: []
    },
    thumbnailType: utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square,
    resource: null,
    avatarResource: null,
    wallpaperResource: null,
    thumbnailResource: null,
    thumbnailBackResource: null,
    paymentType: config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint ? utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint : utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash,
    isDownloadable: undefined,
    hasAssignedNumber: false,
    isBothThumbnail: false
};
var _obj;
var defaultResourceValues = (_obj = {}, (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Image */.qGq.Image, {
    resourceId: ""
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Audio */.qGq.Audio, {
    resourceId: ""
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Merch */.qGq.Merch, {
    resourceId: "",
    metadata: {
        merch: {
            receptionPeriod: {
                endedAt: null
            }
        }
    },
    paymentType: config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint ? utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint : utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Video */.qGq.Video, {
    resourceId: ""
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket, {
    resourceId: "",
    description: null,
    hasPrice: true,
    price: 100,
    resaleEnabled: false,
    metadata: {
        ticket: {
            description: "",
            note: null,
            expirationTerm: null,
            resalePeriod: {
                endedAt: "",
                startedAt: ""
            },
            distributionEnabled: false,
            distributionEndedAt: null,
            assignedNumberPrefix: null,
            startAssignedNumber: null,
            isThroughTicket: false,
            throughTicket: null
        }
    }
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine, {
    resourceId: "",
    metadata: {
        magazine: {
            pageDirection: utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left
        }
    },
    paymentType: config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint ? utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint : utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper, {
    wallpaperResources: {
        wallpaperResourceId: ""
    },
    wallpaperResource: null,
    isDownloadable: false,
    metadata: {
        wallpaper: {
            isPrintEnabled: false,
            printCount: null,
            printType: null
        }
    }
}), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar, {
    avatarResources: {
        avatarResourceId: ""
    },
    thumbnailType: utoniq_core_schema/* ItemThumbnailType.Passthrough */.gy9.Passthrough,
    avatarResource: null
}), _obj);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/template/index.tsx










var ConsoleItemCreateTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleItemCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleItems,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemCreate_template_HeadingTextCell, {
                        resourceType: state.resourceType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCreateForm, {
                        fileUploadInfo: {
                            progress: state.progress,
                            onDrop: onDrop
                        },
                        resourceType: state.resourceType,
                        plans: state.plans,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};
var ConsoleItemCreate_template_HeadingTextCell = function(param) {
    var resourceType = param.resourceType;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    py: 3
                },
                children: t("".concat(resourceType, "NewIssueItem"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                component: "a",
                target: "_blank",
                href: "https://help.utoniq.com/ja/articles/8878771",
                variant: "caption",
                sx: {
                    alignItems: "center",
                    display: "flex"
                },
                children: [
                    t("".concat(resourceType, "NewIssueItemNote")),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                        fontSize: "xSmall",
                        color: "inherit",
                        sx: {
                            ml: 1
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/lib/resourceUpload/resourceUpload.ts







var OtherType;
(function(OtherType) {
    OtherType["Csv"] = "csv";
})(OtherType || (OtherType = {}));
var getResource = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(resourceType) {
        var getImage, file, _obj, mimeType, file1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getImage = camera/* getImage */.g;
                    if (![
                        utoniq_core_schema/* ItemType.Image */.qGq.Image,
                        utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                        utoniq_core_schema/* PostType.Image */.hQF.Image,
                        utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar
                    ].includes(resourceType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getImage(config_config/* config.upload.mimeTypes.wallpaper */.v.upload.mimeTypes.wallpaper, capitalizeFirstLetter(resourceType))
                    ];
                case 1:
                    file = _state.sent();
                    if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                        throw new Error("uploadErrorMaximumSize");
                    }
                    return [
                        2,
                        file
                    ];
                case 2:
                    if (![
                        utoniq_core_schema/* ItemType.Audio */.qGq.Audio,
                        utoniq_core_schema/* ItemType.Video */.qGq.Video,
                        utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                        utoniq_core_schema/* PostType.Sound */.hQF.Sound,
                        OtherType.Csv
                    ].includes(resourceType)) return [
                        3,
                        4
                    ];
                    mimeType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Audio */.qGq.Audio, "audio"), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* PostType.Sound */.hQF.Sound, "audio"), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Video */.qGq.Video, "video"), (0,_define_property/* default */.Z)(_obj, utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine, "pdf"), (0,_define_property/* default */.Z)(_obj, OtherType.Csv, "csv"), _obj);
                    return [
                        4,
                        pickFile(config_config/* config.upload.mimeTypes */.v.upload.mimeTypes[mimeType[resourceType]])
                    ];
                case 3:
                    file1 = _state.sent();
                    if (!config_config/* config.upload.mimeTypes */.v.upload.mimeTypes[mimeType[resourceType]].includes(file1.mimeType)) {
                        throw new Error("uploadError".concat(capitalizeFirstLetter(mimeType[resourceType]), "Only"));
                    }
                    if (mimeType[resourceType] === utoniq_core_schema/* ItemType.Video */.qGq.Video) {
                        if (file1.size > config_config/* config.upload.limit */.v.upload.limit[utoniq_core_schema/* ItemType.Video */.qGq.Video][(0,native_app/* getPlatform */.Xf)()]) throw new Error("uploadErrorMaximumSize");
                    } else if (file1.size > config_config/* config.upload.limit */.v.upload.limit[mimeType[resourceType]]) {
                        throw new Error("uploadErrorMaximumSize");
                    }
                    return [
                        2,
                        file1
                    ];
                case 4:
                    throw new Error("resourceType unsupported");
            }
        });
    });
    return function getResource(resourceType) {
        return _ref.apply(this, arguments);
    };
}();
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/viewModel.ts







function ConsoleItemCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateAcceptedItem($inputs: CreateItemInput) {\n    createAcceptedItem(inputs: $inputs) {\n      ...ItemSelectBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ConsoleItemCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemCreate").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, routerPages = ref4.routerPages;
    var ref5 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref5.upload, progress = ref5.progress;
    var data = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistSubscriptionPlan */.P6C).data;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_ACCEPTED_ITEM, {
        onCompleted: function onCompleted() {
            router.goBack(routerPages.ConsoleItems);
        }
    }), 1), createAcceptedItem = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreateResource */.AWZ), 1), createResource = ref7[0];
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7;
            return flatten_default()(data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : ref7.products.map(function(product) {
                var monthPlan = product.plans.find(function(plan) {
                    return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month;
                });
                if (monthPlan) {
                    return [
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, monthPlan), {
                            title: product.title
                        })
                    ];
                }
                return product.plans.map(function(plan) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                        title: product.title
                    });
                });
            }));
        }
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return data.artist.subscription.plans;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products
    ]);
    var ref8;
    return {
        state: {
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            resourceType: router.query.resourceType,
            plans: plans,
            progress: progress
        },
        actions: {
            onDrop: /**
       * ファイルアップロード時に呼ばれる処理
       * @param {ItemType} resourceType リソース型
       * @param {boolean} hasCreateResource artist.resourceドキュメントを作るかどうか、resourceまたはwallpaperResourceをcreateする際のみtrueにする
       */ function onDrop(resourceType, hasCreateResource) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid, ref1, data, _id, _id1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource(resourceType).catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                if (!hasCreateResource) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    createResource({
                                        variables: {
                                            name: uuid,
                                            filePath: tmpPath
                                        }
                                    })
                                ];
                            case 3:
                                data = _state.sent().data;
                                return [
                                    2,
                                    {
                                        id: (_id = data === null || data === void 0 ? void 0 : data.createResource.id) !== null && _id !== void 0 ? _id : uuid,
                                        resourceName: (_id1 = data === null || data === void 0 ? void 0 : data.createResource.id) !== null && _id1 !== void 0 ? _id1 : uuid,
                                        imageUrl: data === null || data === void 0 ? void 0 : (ref1 = data.createResource) === null || ref1 === void 0 ? void 0 : ref1.uri,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                            case 4:
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, personalInformationRequirements, metadata, resaleEnabled, ref2, ref3, ref4, ref5;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (values.type === utoniq_core_schema/* ItemType.Image */.qGq.Image) {
                                    return [
                                        2
                                    ];
                                }
                                personalInformationRequirements = undefined;
                                if (values.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket) {
                                    switch(values.personalInformationRequirements){
                                        case personalInformationRequirementsValue.nameAndTel:
                                            personalInformationRequirements = [
                                                utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName,
                                                utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber, 
                                            ];
                                            break;
                                        case personalInformationRequirementsValue.nameAndTelAndAddress:
                                            personalInformationRequirements = [
                                                utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName,
                                                utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber,
                                                utoniq_core_schema/* PersonalInformationType.Address */.APM.Address, 
                                            ];
                                            break;
                                        default:
                                            personalInformationRequirements = [];
                                            break;
                                    }
                                }
                                metadata = values.metadata, resaleEnabled = values.resaleEnabled;
                                if (values.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && !resaleEnabled && metadata) {
                                    set_default()(metadata, "ticket.resalePeriod", undefined);
                                }
                                if (values.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && metadata) {
                                    ;
                                    set_default()(metadata, "ticket.throughTicket", getThroughTicket(((ref2 = metadata.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) ? (ref3 = metadata.ticket) === null || ref3 === void 0 ? void 0 : ref3.throughTicket : null));
                                    if ((ref4 = metadata.ticket) === null || ref4 === void 0 ? void 0 : ref4.isThroughTicket) {
                                        set_default()(metadata, "ticket.startDateOfUse", null);
                                        set_default()(metadata, "ticket.endDateOfUse", null);
                                    }
                                }
                                if (values.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && (metadata === null || metadata === void 0 ? void 0 : (ref = metadata.ticket) === null || ref === void 0 ? void 0 : ref.startAssignedNumber)) {
                                    set_default()(metadata, "ticket.startAssignedNumber", +metadata.ticket.startAssignedNumber);
                                }
                                return [
                                    4,
                                    createAcceptedItem({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
                                                isDownloadable: values.isDownloadable,
                                                // 壁紙・アバターのとき、resourceIdをnullとして扱う
                                                resourceId: [
                                                    "wallpaper",
                                                    "avatar"
                                                ].includes(values.type) ? null : values.resourceId
                                            }, removeItemInput[values.type]), {
                                                personalInformationRequirements: personalInformationRequirements
                                            }), pick_default()(values, [
                                                "type",
                                                "price",
                                                "title",
                                                "thumbnail",
                                                "isPremium",
                                                "resaleEnabled",
                                                "issuedNumber",
                                                "description",
                                                "thumbnailBack",
                                                "thumbnailType",
                                                "avatarResources",
                                                "wallpaperResources",
                                                "purchaseLimitByUser",
                                                "purchaseLimitPerOrder",
                                                "hideSalesNumber",
                                                "purchesablePlanIds"
                                            ])), {
                                                metadata: metadata,
                                                salesStartedAt: values.salesStartedAt || new Date(),
                                                salesEndedAt: values.salesEndedAt || null,
                                                salesStatus: values.salesStatus ? utoniq_core_schema/* SalesStatus.Active */.Qsp.Active : utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped,
                                                paymentType: values.price > 0 ? values.paymentType : null,
                                                skuSettings: getSkuSettings(values.hasSku, values.issuedNumber, values.skuSettings),
                                                images: (ref1 = values.images) === null || ref1 === void 0 ? void 0 : ref1.filter(function(img) {
                                                    return !!img.tmpPath;
                                                }),
                                                copyrights: []
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var viewModel_obj;
var removeItemInput = (viewModel_obj = {}, (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper, {
    avatarResources: undefined,
    metadata: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Video */.qGq.Video, {
    wallpaperResources: undefined,
    avatarResources: undefined,
    isDownloadable: undefined,
    metadata: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket, {
    resourceId: undefined,
    isDownloadable: undefined,
    wallpaperResources: undefined,
    avatarResources: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Audio */.qGq.Audio, {
    isDownloadable: undefined,
    wallpaperResources: undefined,
    avatarResources: undefined,
    metadata: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar, {
    isDownloadable: undefined,
    wallpaperResources: undefined,
    metadata: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine, {
    isDownloadable: undefined,
    wallpaperResources: undefined,
    avatarResources: undefined,
    metadata: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Merch */.qGq.Merch, {
    isDownloadable: undefined,
    resourceId: undefined,
    wallpaperResources: undefined,
    avatarResources: undefined
}), (0,_define_property/* default */.Z)(viewModel_obj, utoniq_core_schema/* ItemType.Image */.qGq.Image, {}), viewModel_obj);
function getSkuSettings(hasSku, issuedNumber, value) {
    var ref;
    if (!hasSku || !(value === null || value === void 0 ? void 0 : (ref = value.units) === null || ref === void 0 ? void 0 : ref.length)) return undefined;
    var _price;
    return {
        keyName: value === null || value === void 0 ? void 0 : value.keyName,
        units: value.units.map(function(unit, index) {
            return {
                id: unit === null || unit === void 0 ? void 0 : unit.id,
                unitName: unit.unitName,
                stock: unit.stock || (issuedNumber ? 0 : null),
                thumbnail: unit.thumbnail,
                price: (_price = unit.price) !== null && _price !== void 0 ? _price : null,
                order: index + 1
            };
        })
    };
}
function getThroughTicket(throughTicket) {
    var ref;
    return (ref = throughTicket === null || throughTicket === void 0 ? void 0 : throughTicket.map(function(param) {
        var name = param.name, startDateOfUse = param.startDateOfUse, endDateOfUse = param.endDateOfUse;
        return {
            name: name,
            startDateOfUse: startDateOfUse,
            endDateOfUse: endDateOfUse
        };
    })) !== null && ref !== void 0 ? ref : null;
}
var CREATE_ACCEPTED_ITEM = (0,lib/* gql */.Ps)(ConsoleItemCreate_viewModel_templateObject(), utoniq_core_schema/* ItemSelectBoxFragmentDoc */.S9I);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemCreate/index.tsx






/**
 * ConsoleItemCreate Page
 * Implemented as a practical sample.
 */ var ConsoleItemCreate = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DndProvider/* DndProvider */.W, {
        backend: react_dnd_html5_backend_dist/* HTML5Backend */.PD,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
    });
};
var Component = function() {
    var ref = ConsoleItemCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/resourcePlayer/TheoPlayerView.tsx
var TheoPlayerView = __webpack_require__(78811);
// EXTERNAL MODULE: ./src/core/resources/useDRMPlayer.ts
var useDRMPlayer = __webpack_require__(42109);
// EXTERNAL MODULE: ./src/components/organisms/resourcePlayer/SoundPlayer/SoundPlayerControl.tsx
var SoundPlayerControl = __webpack_require__(27186);
;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/SoundPlayer/SoundDRMPlayer.tsx







var SoundDRMPlayer = function(param) {
    var resource = param.resource, autoplay = param.autoplay;
    // sliderを掴んでいるときの値
    var ref = (0,react.useState)(0), slidingValue = ref[0], setSlidingValue = ref[1];
    var ref1 = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            chromeless: true
        }
    }), player = ref1.player, currentTime = ref1.currentTime, ref2 = ref1.ref, accessToken = ref1.accessToken;
    (0,react.useEffect)(function() {
        /**
     * @note
     * DRMの復号処理はplayメソッドに応じて呼び出されるため、マウント時に自動再生→即停止することで音声の事前ロードを行う
     */ if (!(player && accessToken)) return;
        player.play();
        if (!autoplay) player.pause();
    }, [
        player,
        autoplay,
        accessToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            (!player || !(player === null || player === void 0 ? void 0 : player.duration)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    zIndex: 2,
                    inset: 0,
                    margin: "auto",
                    width: "fit-content",
                    height: "100dvh",
                    pointerEvents: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerView */.m, {
                ref: ref2,
                chromeless: true
            }),
            player && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundPlayerControl/* SoundPlayerControl */.Q, {
                sliderValue: slidingValue ? slidingValue : currentTime,
                onChange: function(_, time) {
                    if (typeof time === "number") setSlidingValue(time);
                },
                onChangeCommitted: function(_, time) {
                    if (typeof time === "number") player.currentTime = time;
                    setSlidingValue(0);
                },
                onRewind: function() {
                    player.currentTime = player.currentTime - 10;
                },
                onForward: function() {
                    player.currentTime = player.currentTime + 10;
                },
                onPause: function() {
                    player.pause();
                },
                onPlay: function() {
                    player.paused ? player.play() : player.pause();
                },
                isPlaying: !player.paused,
                duration: player === null || player === void 0 ? void 0 : player.duration
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/SoundPlayer/index.tsx



var SoundPlayer = function(param) {
    var resource = param.resource, autoplay = param.autoplay;
    var ref;
    if (((ref = resource.drm) === null || ref === void 0 ? void 0 : ref.encryptingStatus) === "encrypted") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundDRMPlayer, {
            resource: resource,
            autoplay: autoplay
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundPurePlayer/* SoundPurePlayer */.z, {
        uri: resource.uri || "",
        autoplay: autoplay
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea.tsx




var ThumbnailActionAreaCell = function(param) {
    var onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage, numberImage = param.numberImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        width: "100%",
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            justifyContent: "flex-end",
            sx: {
                mx: -7
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Zoom, {
                    size: "small",
                    bgcolor: "grey.50",
                    color: "grey.700",
                    onClick: onOpenFullScreen,
                    sx: {
                        width: "30px !important",
                        height: "30px !important",
                        svg: {
                            width: 16,
                            height: 16
                        }
                    }
                }),
                !!numberImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: numberImage,
                    sx: {
                        ".MuiBadge-badge": {
                            top: "unset",
                            bottom: -16,
                            bgcolor: "grey.200",
                            color: "white",
                            p: "0"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Image, {
                        size: "small",
                        bgcolor: "grey.50",
                        color: "grey.700",
                        disabled: !numberImage,
                        onClick: onOpenMultipleImage,
                        sx: {
                            width: "30px !important",
                            height: "30px !important",
                            "&.Mui-disabled": {
                                bgcolor: "grey.50"
                            },
                            svg: {
                                width: 16,
                                height: 16
                            }
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/ItemDescription.tsx







/**
 * OwnedItemDetail
 * サムネイル下のアイテム情報を表示している部分
 */ var ItemDescription_ItemDescriptionCell = function(param) {
    var portfolio = param.portfolio;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var ref7 = portfolio || {}, possessionNumber = ref7.number;
    var ref8 = (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item) || {}, rarity = ref8.rarity, title = ref8.title, sku = ref8.sku;
    var issuableNft = !!((ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref === void 0 ? void 0 : ref.chains);
    var isUserProtected = !!(portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected);
    var isThroughTicket = portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.isThroughTicket;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            display: "grid",
            gridTemplateColumns: "1fr",
            py: 3,
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            config_config/* config.modules.nft */.v.modules.nft && issuableNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Nft, {
                                href: generatePath(routerPages.OwnedItemNftItems, {
                                    itemId: (portfolio === null || portfolio === void 0 ? void 0 : (ref4 = portfolio.item) === null || ref4 === void 0 ? void 0 : ref4.id) || "#"
                                }),
                                sx: {
                                    fontSize: "medium"
                                }
                            }),
                            isUserProtected && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.UniqueProtect, {
                                fontSize: "medium"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                textAlign: "center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    sku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        sx: {
                                            mt: 1
                                        },
                                        variant: "body2",
                                        textAlign: "center",
                                        children: sku.unitName
                                    }),
                                    isThroughTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 4,
                children: [
                    (rarity === null || rarity === void 0 ? void 0 : rarity.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                sx: {
                                    py: 2
                                },
                                children: t("rarity")
                            }),
                            ((ref5 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.rarityIconImage) === null || ref5 === void 0 ? void 0 : ref5.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                src: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.rarityIconImage.smallUri,
                                sx: {
                                    height: 12,
                                    width: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: (rarity === null || rarity === void 0 ? void 0 : rarity.name) ? t(rarity.name) : "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                sx: {
                                    py: 2
                                },
                                children: t("possessionNumber")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: possessionNumber
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/SupplementLinkSet.tsx

















/**
 * アイテム詳細ページ下部にあるボタン群のコンポーネント
 */ var SupplementLinkSet_SupplementLinkSetCell = function(param) {
    var itemId = param.itemId, commentCount = param.commentCount, relatedMissions = param.relatedMissions, artistId = param.artistId, hiddenItemInfo = param.hiddenItemInfo, isUserProtected = param.isUserProtected, issuableNft = param.issuableNft, isResaleAvailable = param.isResaleAvailable, isResaled = param.isResaled, onClickMerch = param.onClickMerch, onClickExpansion = param.onClickExpansion, onClickProtectUserItem = param.onClickProtectUserItem, sku = param.sku;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, generateQueryPath = ref1.generateQueryPath;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var supplements = [
        {
            title: "itemInfo",
            hidden: (0,individual/* individualHiddenItemInfo */.Ek)(),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ItemInfo, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: "".concat(generatePath(routerPages.OwnedItemInformation, {
                itemId: itemId
            })).concat(sku ? "?skuId=".concat(encodeSkuId(sku === null || sku === void 0 ? void 0 : sku.id)) : ""),
            color: "text.secondary",
            clickable: true
        },
        {
            title: "expansion",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Zoom, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            onClick: onClickExpansion,
            color: "text.secondary",
            clickable: true
        },
        {
            title: "merch",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Delivery, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            onClick: onClickMerch,
            color: "text.secondary"
        },
        {
            title: "mission",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                invisible: !((ref = relatedMissions === null || relatedMissions === void 0 ? void 0 : relatedMissions.filter(function(o) {
                    return o.label === utoniq_core_schema/* MissionLabel.New */.lH5.New;
                })) === null || ref === void 0 ? void 0 : ref.length),
                sx: {
                    ".MuiBadge-badge": {
                        bgcolor: "grey.200",
                        padding: "2px 3px",
                        height: "auto",
                        width: "auto",
                        minHeight: 15,
                        minWidth: 15,
                        top: 4,
                        right: 4
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Mission, {
                    sx: {
                        mx: "auto",
                        color: "grey.600"
                    }
                })
            }),
            href: generatePath(routerPages.ItemMissions, {
                artistId: artistId,
                itemId: itemId
            }),
            color: "text.secondary",
            disabled: !(relatedMissions === null || relatedMissions === void 0 ? void 0 : relatedMissions.length)
        }, 
    ];
    var ref3;
    var drawerMenu = [
        {
            title: isUserProtected ? "protectLabel" : "unprotectLabel",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Protect, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            component: Box_Box/* default */.Z,
            onClick: onClickProtectUserItem ? /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                onClickProtectUserItem()
                            ];
                        case 1:
                            _state.sent();
                            setOpen(false);
                            return [
                                2
                            ];
                    }
                });
            }) : undefined,
            hidden: !config_config/* config.modules.trade */.v.modules.trade || !onClickProtectUserItem
        },
        {
            title: isResaled ? "resaleLabelResaleOn" : "resaleLabel",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Resale, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: isResaled ? generatePath(routerPages.ResaleManagement) : generateQueryPath(routerPages.ResaleCreate, {
                itemId: itemId
            }, {
                skuId: encodeSkuId((ref3 = sku === null || sku === void 0 ? void 0 : sku.id) !== null && ref3 !== void 0 ? ref3 : "")
            }),
            hidden: !isResaleAvailable
        },
        {
            title: "nftLabel",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: generatePath(routerPages.OwnedItemNftItems, {
                itemId: itemId
            }),
            /** NFT 停止に向けて、NFT 化ページへの動線を塞ぐ */ hidden: true
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2,
                    px: 4,
                    minHeight: 64
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "flex-start",
                        children: [
                            !!(0,array/* filterHiddenItem */.s)(drawerMenu).length && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Menu, {
                                color: "grey.600",
                                sx: {
                                    p: 3
                                },
                                onClick: function() {
                                    return setOpen(true);
                                }
                            }),
                            supplements.map(function(param, index) {
                                var title = param.title, icon = param.icon, onClick = param.onClick, href = param.href, color = param.color, disabled = param.disabled, hidden = param.hidden;
                                if (!onClickExpansion && title === "expansion") return;
                                if (!onClickMerch && title === "merch") return;
                                if (hiddenItemInfo && title === "itemInfo") return;
                                if (hidden) return;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                    sx: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr",
                                        p: 1,
                                        color: color,
                                        borderRadius: 0,
                                        textAlign: "center",
                                        minWidth: 44,
                                        "&.Mui-disabled": {
                                            background: "inherit",
                                            color: "text.disabled",
                                            svg: {
                                                color: "text.disabled"
                                            }
                                        }
                                    },
                                    onClick: onClick,
                                    href: href,
                                    variant: "text",
                                    disabled: disabled,
                                    children: [
                                        icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            sx: {
                                                pt: 1,
                                                color: "inherit"
                                            },
                                            children: t(title)
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            p: 1,
                            borderRadius: 0,
                            minWidth: 44,
                            alignSelf: "stretch",
                            display: "flex",
                            height: "unset",
                            color: "text.secondary"
                        },
                        onClick: function() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_comment", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: artistId,
                                name: "owned_item"
                            });
                        },
                        href: generatePath(routerPages.ItemComment, {
                            itemId: itemId
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Reply, {
                                sx: {
                                    color: "grey.600"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                sx: {
                                    pl: 1,
                                    color: "inherit"
                                },
                                children: commentCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                sx: {
                    zIndex: function(theme) {
                        return theme.zIndex.modal + 2;
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: t("select")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            (0,array/* filterHiddenItem */.s)(drawerMenu).map(function(_param, index) /*#__PURE__*/ {
                                var title = _param.title, icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
                                    "title",
                                    "icon"
                                ]);
                                return (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    sx: {
                                        height: 52
                                    }
                                }, props), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                            children: icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                            primary: t(title),
                                            slotProps: {
                                                primary: {
                                                    variant: "h6",
                                                    sx: {
                                                        pl: 3
                                                    }
                                                }
                                            }
                                        })
                                    ]
                                }), index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: function() {
                                    return setOpen(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                    primary: t("cancel"),
                                    slotProps: {
                                        primary: {
                                            variant: "h6",
                                            align: "center",
                                            color: "primary"
                                        }
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailAudioView.tsx














var OwnedItemDetailAudioView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onClickProtectUserItem = param.onClickProtectUserItem, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), displayResource = ref4[0], setDisplayResource = ref4[1];
    var onClickDisplayResource = function() {
        return setDisplayResource(function(prev) {
            return !prev;
        });
    };
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            position: "relative",
                            ".MuiButtonBase-root": {
                                height: "fit-content"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                onOpenFullScreen: onOpenFullScreen,
                                onOpenMultipleImage: onOpenMultipleImage,
                                numberImage: (ref5 = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref5 !== void 0 ? ref5 : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                loading: loading,
                                flipProps: {
                                    isFlipped: isFlipped
                                },
                                btnPlay: {
                                    type: "back",
                                    onClick: onClickDisplayResource
                                },
                                imageAreaProps: {
                                    thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                                    size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                    onClick: onReverseThumbnail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                        portfolio: portfolio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 4,
                            mb: 2
                        },
                        children: isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOn, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioPlayModal, {
                open: displayResource,
                onClose: onClickDisplayResource,
                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref6 = (ref2 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref3 === void 0 ? void 0 : ref3.chains),
                onClickProtectUserItem: onClickProtectUserItem
            })
        ]
    });
};
var AudioPlayModal = function(param) {
    var open = param.open, item = param.item, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        sx: {
            display: open ? "block" : "none"
        },
        open: true,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
            header: {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    onClick: onClose
                }),
                type: "modal"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                style: {
                    height: "100%"
                },
                children: item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioPlayCell, {
                    item: item,
                    open: open
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    sx: {
                        textAlign: "center"
                    },
                    children: t("itemNotFound")
                })
            })
        })
    });
};
var AudioPlayCell = function(param) {
    var item = param.item, open = param.open;
    var ref, ref1;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto",
            height: "100%",
            bgcolor: "background.default",
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            display: "flex",
            flexDirection: "column",
            sx: {
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref2 !== void 0 ? ref2 : "",
                            sx: {
                                width: 146,
                                height: 146,
                                mt: "80px",
                                mb: 8,
                                img: {
                                    objectFit: "contain"
                                },
                                borderRadius: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundGraph, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                    sx: {
                        position: "relative",
                        py: 6
                    },
                    children: (item === null || item === void 0 ? void 0 : item.resource) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundPlayer, {
                        resource: item === null || item === void 0 ? void 0 : item.resource,
                        autoplay: open
                    })
                })
            ]
        })
    });
};
/**
 * @description
 * Sound Visualizer用SVG
 * 仕様策定中
 */ var SoundGraph = function() {
    var palette = (0,useTheme/* default */.Z)().palette;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "250",
        height: "84",
        viewBox: "0 0 250 84",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: palette.grey[100],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "39",
                width: "2",
                height: "6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "8",
                y: "39",
                width: "2",
                height: "6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "16",
                y: "39",
                width: "2",
                height: "6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "24",
                y: "39",
                width: "2",
                height: "6",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "32",
                y: "37.5",
                width: "2",
                height: "9",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "40",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "48",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "56",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "64",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "72",
                y: "28",
                width: "2",
                height: "28",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "80",
                y: "20",
                width: "2",
                height: "44",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "88",
                y: "16",
                width: "2",
                height: "52",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "96",
                y: "12",
                width: "2",
                height: "60",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "104",
                width: "2",
                height: "84",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "112",
                width: "2",
                height: "84",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "120",
                y: "1.5",
                width: "2",
                height: "81",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "128",
                y: "9",
                width: "2",
                height: "66",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "136",
                y: "12",
                width: "2",
                height: "60",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "144",
                y: "16",
                width: "2",
                height: "52",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "152",
                y: "24",
                width: "2",
                height: "36",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "160",
                y: "32",
                width: "2",
                height: "20",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "168",
                y: "37.5",
                width: "2",
                height: "9",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "176",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "184",
                y: "38.5",
                width: "2",
                height: "7",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "192",
                y: "29.5",
                width: "2",
                height: "25",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "200",
                y: "21.5",
                width: "2",
                height: "41",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "208",
                y: "25.5",
                width: "2",
                height: "33",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "216",
                y: "25.5",
                width: "2",
                height: "33",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "224",
                y: "25.5",
                width: "2",
                height: "33",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "232",
                y: "29.5",
                width: "2",
                height: "25",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "240",
                y: "37.5",
                width: "2",
                height: "9",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "248",
                y: "36",
                width: "2",
                height: "12",
                fill: "currentColor"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDescription.tsx





var ConsoleItemDescription = function(param) {
    var item = param.item, loading = param.loading;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var issuableNft = !!(item === null || item === void 0 ? void 0 : (ref = item.nft) === null || ref === void 0 ? void 0 : ref.chains);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 3,
                width: 250
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "100%"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "small",
                    width: "100%"
                })
            ]
        });
    }
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            display: "grid",
            gridTemplateColumns: "1fr",
            pt: 1,
            gap: 2,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                justifyContent: "center",
                alignItems: "center",
                children: [
                    issuableNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Nft, {
                        href: generatePath(routerPages.OwnedItemNftItems, {
                            itemId: (item === null || item === void 0 ? void 0 : item.id) || "#"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            (item === null || item === void 0 ? void 0 : item.skuSettings) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription_ItemStatusTagCell, {
                                number: ((ref1 = item.skuSettings.units) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
                spacing: 2,
                children: [
                    !!(item === null || item === void 0 ? void 0 : item.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("price")
                            }),
                            (item === null || item === void 0 ? void 0 : item.paymentType) === "prepaid_point" || !(item === null || item === void 0 ? void 0 : item.paymentType) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                        fontSize: "xSmall"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secondary",
                                        children: item === null || item === void 0 ? void 0 : item.formattedPrice
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: [
                                    "￥",
                                    item === null || item === void 0 ? void 0 : item.formattedPrice
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("remainingQuantityPerTotal", "残り数量/全数量")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: [
                                    (ref3 = item === null || item === void 0 ? void 0 : item.formattedRemainingNumber) !== null && ref3 !== void 0 ? ref3 : "0",
                                    "/",
                                    (ref4 = item === null || item === void 0 ? void 0 : item.issuedNumber) !== null && ref4 !== void 0 ? ref4 : "∞"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ConsoleItemDescription_ItemStatusTagCell = function(param) {
    var number = param.number;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 1,
            px: 2,
            borderRadius: "34px",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "grey.400"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "text.secondary",
            component: "p",
            children: [
                "SKU（",
                number,
                "）"
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailAudio.tsx









var ConsoleItemDetailAudio = function(param) {
    var loading = param.loading, item = param.item, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref;
    var ref1 = (0,react.useState)(false), displayResource = ref1[0], setDisplayResource = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        btnPlay: {
                            type: "back",
                            onClick: function() {
                                return setDisplayResource(function(prevState) {
                                    return !prevState;
                                });
                            }
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: 30,
                        height: 30,
                        variant: "circular"
                    }),
                    !loading && isFlipped && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                        size: "small",
                        onClick: onReverseThumbnail,
                        bgcolor: "primary.main",
                        color: "white"
                    }),
                    !loading && !isFlipped && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOn, {
                        size: "small",
                        onClick: onReverseThumbnail,
                        bgcolor: "primary.main",
                        color: "white"
                    })
                ]
            }),
            item && /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioPlayModal, {
                open: displayResource,
                onClose: function() {
                    return setDisplayResource(function(prevState) {
                        return !prevState;
                    });
                },
                item: item
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VoicePlayer/VoicePlayerControl.tsx


var VoicePlayerControl = function(param) {
    var playing = param.playing, onClickPlay = param.onClickPlay, onClickPause = param.onClickPause, _bgcolor = param.bgcolor, bgcolor = _bgcolor === void 0 ? "grey.50" : _bgcolor, color = param.color;
    return playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOn, {
        bgcolor: bgcolor,
        color: color,
        size: "small",
        onClick: onClickPause
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOff, {
        bgcolor: bgcolor,
        color: color,
        size: "small",
        onClick: onClickPlay
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VoicePlayer/VoiceDRMPlayer.tsx





var VoiceDRMPlayer = function(param) {
    var resource = param.resource, bgcolor = param.bgcolor, color = param.color;
    var ref = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            chromeless: true
        }
    }), player = ref.player, ref1 = ref.ref;
    (0,react.useEffect)(function() {
        /**
     * @note
     * DRMの復号処理はplayメソッドに応じて呼び出されるため、マウント時に自動再生→即停止することで音声の事前ロードを行う
     */ if (!player) return;
        player.play();
        player.pause();
    }, [
        player
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerView */.m, {
                ref: ref1,
                chromeless: true
            }),
            player && /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayerControl, {
                playing: !(player.paused || player.ended),
                onClickPause: function() {
                    return player.pause();
                },
                onClickPlay: function() {
                    return player.play();
                },
                bgcolor: bgcolor,
                color: color
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VoicePlayer/VoicePurePlayer.tsx



function VoicePurePlayer(param) {
    var uri = param.uri, bgcolor = param.bgcolor, color = param.color;
    var ref = useAudio({
        uri: uri
    }), play = ref.play, pause = ref.pause, playing = ref.playing;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayerControl, {
        playing: playing,
        onClickPlay: play,
        onClickPause: pause,
        bgcolor: bgcolor,
        color: color
    });
}
/**
 * @description useAudio
 * Audio objectを利用する際のカスタムフック
 *
 * @param {string} uri オーディオのurl
 *
 * @returns {boolean} playing 再生しているかどうかの状態
 * @returns {() => void} play 再生
 * @returns {() => void} pause 一時停止
 * @returns {() => void} stop 停止
 * @returns {() => void} togglePlay 再生/一時停止の切り替え
 */ var useAudio = function(param) {
    var uri = param.uri;
    var ref = (0,react.useState)(new Audio(uri)), audio = ref[0];
    var ref1 = (0,react.useState)(false), playing = ref1[0], setPlaying = ref1[1];
    /**
   * @description
   * audio.pausedなどの変更をコンポーネント側で利用するため
   * audioオブジェクトの再生・停止・終了毎にplayingの状態を更新する
   */ (0,react.useEffect)(function() {
        if (!uri) return;
        audio.addEventListener("play", function() {
            return setPlaying(true);
        });
        audio.addEventListener("pause", function() {
            return setPlaying(false);
        });
        audio.addEventListener("ended", function() {
            return setPlaying(false);
        });
        return function() {
            audio.removeEventListener("play", function() {
                return setPlaying(true);
            });
            audio.removeEventListener("pause", function() {
                return setPlaying(false);
            });
            audio.removeEventListener("ended", function() {
                return setPlaying(false);
            });
            audio.pause();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uri
    ]);
    if ( false || !uri) return {
        playing: false,
        play: function play() {},
        pause: function pause() {},
        stop: function stop() {},
        togglePlay: function togglePlay() {}
    };
    return {
        playing: playing,
        play: function play() {
            audio.play();
        },
        pause: function pause() {
            audio.pause();
        },
        stop: function stop() {
            audio.pause();
            audio.currentTime = 0;
        },
        togglePlay: function togglePlay() {
            if (playing) return audio.pause();
            audio.play();
        }
    };
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VoicePlayer/index.tsx




var VoicePlayer = function(param) {
    var resource = param.resource, bgcolor = param.bgcolor, color = param.color;
    var ref;
    if (((ref = resource.drm) === null || ref === void 0 ? void 0 : ref.encryptingStatus) === "encrypted") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoiceDRMPlayer, {
            resource: resource,
            bgcolor: bgcolor,
            color: color
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePurePlayer, {
        uri: resource.smallUri || "",
        bgcolor: bgcolor,
        color: color
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailAvatar.tsx









var ConsoleItemDetailAvatar = function(param) {
    var loading = param.loading, updating = param.updating, item = param.item, onSettingAvatar = param.onSettingAvatar, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var voiceResource = item === null || item === void 0 ? void 0 : (ref = item.avatarResources) === null || ref === void 0 ? void 0 : ref.voiceResource;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.images) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref2 !== void 0 ? ref2 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            voiceResource && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    display: "grid",
                    placeItems: "center",
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
                    resource: voiceResource,
                    bgcolor: "primary.main",
                    color: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 2,
                    px: 8,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    fullWidth: true,
                    onClick: onSettingAvatar,
                    loading: updating,
                    children: t("avatarButtonWord")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/styles/StyleProvider.tsx + 2 modules
var StyleProvider = __webpack_require__(97645);
// EXTERNAL MODULE: ./src/components/organisms/resourcePlayer/MagazinePlayer/SwipeBackdrop.tsx
var SwipeBackdrop = __webpack_require__(69482);
;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/MagazinePlayer/DRMMagazinePlayer.tsx















var DRMMagazinePlayer = function(param) {
    var resource = param.resource, open = param.open, onClose = param.onClose;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var ref = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            mutedAutoplay: "all"
        },
        isMagazine: true
    }), ref1 = ref.ref, player = ref.player, accessToken = ref.accessToken;
    var ref2 = (0,react.useState)(false), isLastPage = ref2[0], setIsLastPage = ref2[1];
    (0,react.useEffect)(function() {
        if (!player || !open) return;
        if (!accessToken) showError(t("drmAuthorizingError"));
        // THEOPlayer認証後、事前にDRMリソース読み取りを行う
        player.play();
        player.pause();
        // HACK: 起動時に動画の再生位置を3秒に設定する
        player.currentTime = 3;
        setIsLastPage(false);
    }, [
        accessToken,
        open
    ]);
    /**
   * 次のページに遷移する処理
   */ var handleNext = (0,react.useCallback)(function() {
        //  初期化前はスキップ
        if (!player || !player.duration || !player.currentTime) return;
        var ref;
        var currentPage = Math.floor((((ref = player === null || player === void 0 ? void 0 : player.currentTime) !== null && ref !== void 0 ? ref : 3) - 1) / 2);
        var ref1;
        var totalPage = Math.floor((((ref1 = player === null || player === void 0 ? void 0 : player.duration) !== null && ref1 !== void 0 ? ref1 : 0) - 2) / 2);
        /** 再生位置を現在+2秒に変更する */ player.currentTime += 2;
        // HACK: 最後のページ付近でTHEOPlayerのシークが実行されないことがあるため、play()を実行することで最後のページを表示する
        if (currentPage === totalPage - 1) {
            player.play();
            setIsLastPage(true);
            var time = setTimeout(function() {
                player.pause();
                clearTimeout(time);
            }, 1200);
        }
    }, [
        player
    ]);
    /**
   * 前のページに遷移する処理
   */ var handlePrev = (0,react.useCallback)(function() {
        // 初期化前はスキップ
        if (!player) return;
        player.pause();
        setIsLastPage(false);
        /** 再生位置を現在-2秒に変更する */ player.currentTime = Math.floor(player.currentTime) - 2;
        // HACK: 再生位置を奇数に設定するため、時間操作後の現在時間が偶数になった場合は1秒足す
        if (player.currentTime % 2 === 0) player.currentTime++;
    }, [
        player
    ]);
    /**
   * 指定したページにジャンプする処理
   */ var handleJump = (0,react.useCallback)(function(page) {
        if (!player || !player.duration) return;
        player.pause();
        setIsLastPage(false);
        var targetTime = page * 2 + 1;
        if (targetTime > player.duration) {
            player.currentTime = Math.floor(player.duration);
            return;
        }
        player.currentTime = targetTime;
    }, [
        player
    ]);
    if (!accessToken) return null;
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1.0, viewport-fit=cover, minimum-scale=1.0, maximum-scale=2.0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    bgcolor: "background.default",
                    width: "100%",
                    position: "absolute",
                    zIndex: 1,
                    top: 0,
                    left: 0,
                    right: 0,
                    maxWidth: 600,
                    margin: "auto",
                    minHeight: "fit-content",
                    height: "100%",
                    display: "grid",
                    placeItems: "start center",
                    opacity: open && !!(player === null || player === void 0 ? void 0 : player.duration) ? 1 : 0,
                    pointerEvents: open ? "initial" : "none"
                },
                children: [
                    open && /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineUI, {
                        onPrev: handlePrev,
                        onNext: handleNext,
                        onJump: handleJump,
                        currentPage: Math.floor((((ref3 = player === null || player === void 0 ? void 0 : player.currentTime) !== null && ref3 !== void 0 ? ref3 : 3) - 1) / 2),
                        totalPage: Math.floor((((ref4 = player === null || player === void 0 ? void 0 : player.duration) !== null && ref4 !== void 0 ? ref4 : 0) - 2) / 2),
                        onClose: onClose,
                        isLastPage: isLastPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerImageView */.D, {
                        ref: ref1,
                        playable: !!(player === null || player === void 0 ? void 0 : player.duration)
                    })
                ]
            })
        ]
    });
};
/** マガジンプレーヤーを操作するためのUI */ var MagazineUI = function(param) {
    var onPrev = param.onPrev, onNext = param.onNext, onJump = param.onJump, currentPage = param.currentPage, totalPage = param.totalPage, onClose = param.onClose, isLastPage = param.isLastPage;
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)(1), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(true), showBackdrop = ref2[0], setShowBackdrop = ref2[1];
    var handlers = (0,es/* useSwipeable */.QS)({
        onSwipedLeft: function() {
            if (isLastPage) return;
            setShowBackdrop(false);
            onNext();
            setValue(function(state) {
                return state + 1;
            });
        },
        onSwipedRight: function() {
            if (currentPage <= 1) return;
            setShowBackdrop(false);
            onPrev();
            setValue(function(state) {
                return state - 1;
            });
        },
        onTap: function(param) {
            var event = param.event;
            if ((0,_instanceof/* default */.Z)(event.target, HTMLButtonElement)) return;
            if ((0,_instanceof/* default */.Z)(event.target, HTMLSpanElement)) return;
            setShowBackdrop(false);
            setShow(function(state) {
                return !state;
            });
        },
        // PCのときはマウス操作できるようにする
        trackMouse: !(0,StyleProvider/* isMobileDevice */.s2)()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeBackdrop/* SwipeBackdrop */.H, {
                open: showBackdrop
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    position: "absolute",
                    zIndex: 3,
                    top: 20,
                    left: 20
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    onClick: onClose,
                    sx: {
                        bgcolor: "grey.50"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                sx: {
                    width: "100%",
                    zIndex: 2,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%"
                }
            }, handlers), {
                children: show && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "absolute",
                            width: "100%",
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    bgcolor: "rgba(255, 255, 255, 0.6)",
                                    padding: "4px 12px",
                                    width: "100px",
                                    borderRadius: "4px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    textAlign: "center",
                                    children: [
                                        isLastPage ? totalPage : currentPage,
                                        " / ",
                                        totalPage
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "grid",
                                    placeItems: "center",
                                    bgcolor: "grey.100",
                                    width: "100%",
                                    padding: "0 40px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                                    min: 1,
                                    max: totalPage,
                                    value: value,
                                    onChange: function(_, v) {
                                        setShowBackdrop(false);
                                        if (typeof v === "number") {
                                            setValue(v);
                                            onJump(v);
                                        }
                                    },
                                    onChangeCommitted: function(_, v) {
                                        if (typeof v === "number") onJump(v);
                                    }
                                })
                            })
                        ]
                    })
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailMagazine.tsx












var ConsoleItemDetailMagazine = function(param) {
    var loading = param.loading, item = param.item, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onViewMagazine = param.onViewMagazine, onOpenMultipleImage = param.onOpenMultipleImage, onOpenFullScreen = param.onOpenFullScreen;
    var ref;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref1 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        btnPlay: {
                            type: "back",
                            onClick: onViewMagazine
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                    size: "small",
                    onClick: onReverseThumbnail,
                    bgcolor: "primary.main",
                    color: "white"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.MagazineOn, {
                    size: "small",
                    onClick: onReverseThumbnail,
                    bgcolor: "primary.main",
                    color: "white"
                })
            })
        ]
    });
};
var MagazinePlayerModal = function(param) {
    var loading = param.loading, open = param.open, onClose = param.onClose, item = param.item;
    var ref, ref1, ref2, ref3, ref4;
    if (!open) {
        return null;
    }
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                display: "grid",
                placeItems: "center",
                height: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
        });
    }
    if (item === null || item === void 0 ? void 0 : item.isDrm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DRMMagazinePlayer, {
            open: open,
            onClose: onClose,
            resource: item === null || item === void 0 ? void 0 : item.resource
        });
    }
    if ((item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.magazine) === null || ref1 === void 0 ? void 0 : ref1.pageType) === utoniq_core_schema/* MagazinePageType.Image */.TeL.Image) {
        var ref5, ref6;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MangaPlayer, {
            loading: false,
            open: open,
            onClose: onClose,
            item: item !== null && item !== void 0 ? item : undefined,
            hiddenLastPage: true,
            isConsolePage: true,
            direction: (item === null || item === void 0 ? void 0 : (ref5 = item.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.magazine) === null || ref6 === void 0 ? void 0 : ref6.pageDirection) || utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazinePlayer, {
        loading: false,
        open: open,
        onClose: onClose,
        resourceUrl: (item === null || item === void 0 ? void 0 : (ref2 = item.resource) === null || ref2 === void 0 ? void 0 : ref2.uri) || "",
        item: item !== null && item !== void 0 ? item : undefined,
        hiddenLastPage: true,
        isConsolePage: true,
        direction: (item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.magazine) === null || ref4 === void 0 ? void 0 : ref4.pageDirection) || utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left
    });
};
var MagazinePlayer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(691), __webpack_require__.e(2246), __webpack_require__.e(3439)]).then(__webpack_require__.bind(__webpack_require__, 94966)).then(function(md) {
        return md.MagazinePlayer;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94966)
            ];
        }
    },
    ssr: false
});
var MangaPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8331).then(__webpack_require__.bind(__webpack_require__, 78331)).then(function(md) {
        return md.MangaPlayer;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78331)
            ];
        }
    },
    ssr: false
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailMerch.tsx







var ConsoleItemDetailMerch = function(param) {
    var loading = param.loading, item = param.item, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref1 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    href: routerPages.ConsoleDeliveryManagement,
                    children: t("merchButtonWord")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleSupplementLinkArea.tsx









var ConsoleSupplementLinkArea = function(param) {
    var itemId = param.itemId, loading = param.loading, isPublished = param.isPublished, saleStatus = param.saleStatus, onToggleSelling = param.onToggleSelling, onToggleActive = param.onToggleActive, onRemove = param.onRemove, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var supplementLinkLeft = [
        {
            title: "itemInfo",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ItemInfo, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: !loading ? generatePath(routerPages.ConsoleItemInformation, {
                itemId: itemId !== null && itemId !== void 0 ? itemId : "#"
            }) : undefined
        }, 
    ];
    var supplementLinkRight = [
        {
            title: "sale",
            icon: saleStatus === utoniq_core_schema/* SalesStatus.Active */.Qsp.Active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.CheckCircle, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Unpublished, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            onClick: function() {
                return onToggleSelling(itemId, saleStatus === utoniq_core_schema/* SalesStatus.Active */.Qsp.Active);
            }
        },
        {
            title: "release",
            icon: isPublished ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Display, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Hide, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            onClick: function() {
                return onToggleActive(itemId, isPublished);
            }
        },
        {
            title: "edit",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pencil, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            href: !loading ? generatePath(routerPages.ConsoleItemEdit, {
                itemId: itemId
            }) : undefined
        },
        {
            title: "delete",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
                fontSize: "small",
                sx: {
                    mx: "auto",
                    color: "grey.600"
                }
            }),
            onClick: onRemove
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            sx: (0,src_object_spread/* default */.Z)({
                py: 2,
                px: 4,
                minHeight: 64
            }, sx),
            children: [
                supplementLinkLeft,
                supplementLinkRight
            ].map(function(supplementLink, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: supplementLink.map(function(_param, subIndex) {
                        var title = _param.title, icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
                            "title",
                            "icon"
                        ]);
                        if (title === "sale" && loading) return null;
                        if (title === "release" && loading) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            variant: "text",
                            sx: {
                                display: "grid",
                                gridTemplateColumns: "1fr",
                                p: 1,
                                borderRadius: 0,
                                textAlign: "center",
                                minWidth: 44,
                                "&.Mui-disabled": {
                                    background: "inherit",
                                    color: "text.disabled",
                                    ".MuiSvgIcon-root": {
                                        color: "inherit"
                                    },
                                    ".MuiTypography-root": {
                                        color: "text.disabled"
                                    }
                                }
                            },
                            disabled: loading
                        }, props), {
                            children: [
                                icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    sx: {
                                        pt: 1
                                    },
                                    children: t(title !== null && title !== void 0 ? title : "")
                                })
                            ]
                        }), subIndex);
                    })
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailTicket.tsx



















var ConsoleItemDetailTicket = function(param) {
    var loading = param.loading, artistId = param.artistId, item = param.item, ticketOpen = param.ticketOpen, onRemove = param.onRemove, onToggleSelling = param.onToggleSelling, onToggleActive = param.onToggleActive, refetching = param.refetching, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage, ticketFilter = param.ticketFilter, onFilterTicket = param.onFilterTicket, onToggleTicketUsed = param.onToggleTicketUsed;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(ticketOpen === "true"), open = ref3[0], setOpen = ref3[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref4 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref4 !== void 0 ? ref4 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium,
                    isThroughTicket: !!((ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        width: 30,
                        height: 30,
                        variant: "circular"
                    }),
                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Ticket, {
                        size: "small",
                        onClick: function() {
                            return setOpen(true);
                        },
                        bgcolor: "primary.main",
                        color: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketCellModal, {
                artistId: artistId,
                open: open,
                onClose: function() {
                    if (ticketOpen === "true") {
                        return router.goBack();
                    }
                    setOpen(false);
                },
                item: item,
                loading: loading || refetching,
                hasNextPage: hasNextPage,
                onToggleActive: onToggleActive,
                onToggleSelling: onToggleSelling,
                onRemove: onRemove,
                onFetchMore: onFetchMore,
                ticketFilter: ticketFilter,
                onFilterTicket: onFilterTicket,
                onToggleTicketUsed: onToggleTicketUsed
            })
        ]
    });
};
var TicketCellModal = function(param) {
    var open = param.open, onClose = param.onClose, artistId = param.artistId, loading = param.loading, hasNextPage = param.hasNextPage, item = param.item, onRemove = param.onRemove, onToggleSelling = param.onToggleSelling, onToggleActive = param.onToggleActive, onFetchMore = param.onFetchMore, ticketFilter = param.ticketFilter, onFilterTicket = param.onFilterTicket, onToggleTicketUsed = param.onToggleTicketUsed;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var ref17 = (0,react.useState)(false), editable = ref17[0], setEditable = ref17[1];
    var ticketExpired = (0,react.useMemo)(function() {
        var ref, ref1;
        switch(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.expirationTerm){
            case utoniq_core_schema/* TicketItemExpirationTerm.Halfyear */.EQx.Halfyear:
                return t("6months");
            case utoniq_core_schema/* TicketItemExpirationTerm.Oneyear */.EQx.Oneyear:
                return t("1year");
            default:
                return t("unlimited");
        }
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.expirationTerm,
        t
    ]);
    var ref18 = (0,react.useState)(null), ticketModalSerial = ref18[0], setTicketModalSerial = ref18[1];
    var ref19 = (0,react.useState)(), subTicketName = ref19[0], setSubTicketName = ref19[1];
    var ref20 = (0,react.useState)(false), subTicketIsUsed = ref20[0], setSubTicketIsUsed = ref20[1];
    var ref21 = (0,react.useState)(false), ticketButtonModalLoading = ref21[0], setTicketButtonModalLoading = ref21[1];
    //Typeが座席かどうか判定
    var assignedNumberType = (item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.assignedNumberType) === utoniq_core_schema/* TicketItemMetadataAssignedNumberType.Seat */.Nay.Seat ? true : false;
    //通し券かどうか判定
    var isThroughTicket = !!(item === null || item === void 0 ? void 0 : (ref4 = item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.isThroughTicket);
    var ref22, ref23;
    var purchasedNumber = (0,react.useMemo)(function() {
        return (item === null || item === void 0 ? void 0 : item.purchasedNumber) || (item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber) ? ((ref22 = item === null || item === void 0 ? void 0 : item.purchasedNumber) !== null && ref22 !== void 0 ? ref22 : 0) + ((ref23 = item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber) !== null && ref23 !== void 0 ? ref23 : 0) : undefined;
    }, [
        item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber,
        item === null || item === void 0 ? void 0 : item.purchasedNumber
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var _name;
        //サブチケット名
        var name = (ticketModalSerial === null || ticketModalSerial === void 0 ? void 0 : (ref = ticketModalSerial.ticketStatus) === null || ref === void 0 ? void 0 : ref.throughTicket) ? (_name = ticketModalSerial.ticketStatus.throughTicket.name) !== null && _name !== void 0 ? _name : undefined : undefined;
        //サブチケットが使われたかどうか
        var isUsed = (ticketModalSerial === null || ticketModalSerial === void 0 ? void 0 : (ref1 = ticketModalSerial.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.throughTicket) ? !!ticketModalSerial.ticketStatus.throughTicket.isUsed : !!(ticketModalSerial === null || ticketModalSerial === void 0 ? void 0 : (ref2 = ticketModalSerial.ticketStatus) === null || ref2 === void 0 ? void 0 : ref2.isUsed);
        setSubTicketName(name);
        setSubTicketIsUsed(isUsed);
    }, [
        ticketModalSerial
    ]);
    var ref24, ref25, ref26, ref27, ref28;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: function() {
            return onClose();
        },
        sx: {
            zIndex: function(param) {
                var zIndex = param.zIndex;
                return (zIndex === null || zIndex === void 0 ? void 0 : zIndex.modal) - 1;
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleSupplementLinkArea, {
                    loading: false,
                    itemId: (ref24 = item === null || item === void 0 ? void 0 : item.id) !== null && ref24 !== void 0 ? ref24 : "",
                    isPublished: !!(item === null || item === void 0 ? void 0 : item.isPublished),
                    saleStatus: (ref25 = item === null || item === void 0 ? void 0 : item.salesStatus) !== null && ref25 !== void 0 ? ref25 : "",
                    onToggleActive: onToggleActive,
                    onToggleSelling: onToggleSelling,
                    onRemove: onRemove
                }),
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        color: "white",
                        size: "medium",
                        onClick: onClose
                    }),
                    title: t("ticketInfoTitle")
                },
                customNavigationSx: {
                    bgcolor: "background.default",
                    maxWidth: constants/* constants.ui.layout.mainContentMaxWidth */._.ui.layout.mainContentMaxWidth
                },
                sx: {
                    header: {
                        bgcolor: "primary.main",
                        ".MuiTypography-root, svg": {
                            color: "white"
                        }
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 6,
                            sx: {
                                px: 5,
                                pt: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Post, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "grey.600"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    color: "text.secondary",
                                                    children: t("ticketContent")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: item === null || item === void 0 ? void 0 : (ref6 = item.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ticket) === null || ref7 === void 0 ? void 0 : ref7.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Timer, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "grey.600"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    color: "text.secondary",
                                                    children: t("ticketExpiredAt")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: (item === null || item === void 0 ? void 0 : (ref8 = item.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : ref9.expirationTerm) === null ? t("unlimited") : ticketExpired
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "grey.600"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    color: "text.secondary",
                                                    children: t("ticketNote")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: item === null || item === void 0 ? void 0 : (ref10 = item.metadata) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.ticket) === null || ref11 === void 0 ? void 0 : ref11.note
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                color: "text.secondary",
                                                children: t("startAssignedNumber")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: [
                                                item === null || item === void 0 ? void 0 : (ref12 = item.metadata) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.ticket) === null || ref13 === void 0 ? void 0 : ref13.assignedNumberPrefix,
                                                "-",
                                                item === null || item === void 0 ? void 0 : (ref14 = item.metadata) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.ticket) === null || ref15 === void 0 ? void 0 : ref15.startAssignedNumber
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Serial, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "grey.600"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    color: "text.secondary",
                                                    children: t("ticketStatus", "チケット状況")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    justifyContent: "space-between",
                                                    direction: "row",
                                                    alignItems: "center",
                                                    sx: {
                                                        borderWidth: 1,
                                                        borderColor: "grey.100",
                                                        borderStyle: "solid",
                                                        borderRadius: 1,
                                                        p: 3
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            color: "text.secondary",
                                                            sx: {
                                                                maxWidth: 120,
                                                                minWidth: 110
                                                            },
                                                            children: t("purchasePerStock", "購入数/在庫数")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            direction: "row",
                                                            flexWrap: "wrap",
                                                            justifyContent: "flex-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    children: [
                                                                        purchasedNumber !== null && purchasedNumber !== void 0 ? purchasedNumber : "-",
                                                                        "/"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    children: (ref26 = item === null || item === void 0 ? void 0 : item.issuedNumber) !== null && ref26 !== void 0 ? ref26 : "-"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    justifyContent: "space-between",
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    sx: {
                                                        borderWidth: 1,
                                                        borderColor: "grey.100",
                                                        borderStyle: "solid",
                                                        borderRadius: 1,
                                                        p: 3
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            color: "text.secondary",
                                                            sx: {
                                                                maxWidth: 120,
                                                                minWidth: 110
                                                            },
                                                            children: t("usedUnusedPerPurchase", "使用済み(未使用)/\n購入数")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            direction: "row",
                                                            flexWrap: "wrap",
                                                            justifyContent: "flex-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    component: "span",
                                                                    children: [
                                                                        (ref27 = item === null || item === void 0 ? void 0 : item.usedNumber) !== null && ref27 !== void 0 ? ref27 : "-",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                                            variant: "subtitle1",
                                                                            component: "span",
                                                                            color: "warning.main",
                                                                            children: [
                                                                                "(",
                                                                                purchasedNumber ? purchasedNumber - ((ref28 = item === null || item === void 0 ? void 0 : item.usedNumber) !== null && ref28 !== void 0 ? ref28 : 0) : "-",
                                                                                ")"
                                                                            ]
                                                                        }),
                                                                        "/"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    children: purchasedNumber !== null && purchasedNumber !== void 0 ? purchasedNumber : "-"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailTicket_FilterMenu, {
                            filter: ticketFilter,
                            onFilter: onFilterTicket,
                            isThroughTicket: isThroughTicket
                        }),
                        !(item === null || item === void 0 ? void 0 : (ref16 = item.collection) === null || ref16 === void 0 ? void 0 : ref16.isEventPickup) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            sx: {
                                px: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                fullWidth: false,
                                onClick: function() {
                                    return setEditable(function(prevState) {
                                        return !prevState;
                                    });
                                },
                                children: editable ? t("completion", "完了") : t("editUsage", "使用状況を編集する")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SerialTables, {
                            editable: editable,
                            artistId: artistId,
                            loading: loading,
                            item: item,
                            serials: item === null || item === void 0 ? void 0 : item.serials,
                            onFetchMore: onFetchMore,
                            hasNextPage: hasNextPage,
                            setTicketModalSerial: setTicketModalSerial,
                            assignedNumberType: assignedNumberType,
                            ticketFilter: ticketFilter,
                            isThroughTicket: isThroughTicket
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: !!ticketModalSerial,
                onClose: function() {
                    return setTicketModalSerial(null);
                },
                title: t("TicketUseModalTitle", "使用状況を変更しますか？"),
                content: subTicketIsUsed ? t("TicketUseModalUseDesc", "使用状況を使用済みから未使用に変更します。") : t("TicketUseModalUnuseDesc", "使用状況を未使用から使用済みに変更します。"),
                cancelText: t("close", "閉じる"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: ticketButtonModalLoading,
                    disabled: ticketButtonModalLoading,
                    onClick: function() {
                        if (!ticketModalSerial) return;
                        setTicketButtonModalLoading(true);
                        onToggleTicketUsed(ticketModalSerial.id, subTicketIsUsed, subTicketName).finally(function() {
                            setTicketModalSerial(null);
                            setTicketButtonModalLoading(false);
                        });
                    },
                    children: subTicketIsUsed ? t("TicketUseModalUseButton", "未使用に変更する") : t("TicketUseModalUnuseButton", "使用済みに変更する")
                })
            })
        ]
    });
};
var SerialTables = function(param) {
    var editable = param.editable, artistId = param.artistId, serials = param.serials, loading = param.loading, hasNextPage = param.hasNextPage, item = param.item, assignedNumberType = param.assignedNumberType, ticketFilter = param.ticketFilter, isThroughTicket = param.isThroughTicket, onFetchMore = param.onFetchMore, setTicketModalSerial = param.setTicketModalSerial;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,react.useState)(), filter = ref1[0], setFitler = ref1[1];
    (0,react.useEffect)(function() {
        setFitler(ticketFilter);
    }, [
        ticketFilter
    ]);
    //通し券があった場合に、node.ticketStatus.throughTicketの中身を一つずつ取り出して、throughTicket.nameごとの配列をつくる処理
    var mappedTickets = (serials === null || serials === void 0 ? void 0 : serials.edges.map(function(param) {
        var node = param.node;
        var ref;
        var throughTickets = (ref = node.ticketStatus) === null || ref === void 0 ? void 0 : ref.throughTicket;
        //サブチケットがあるか判定
        if (!throughTickets) {
            return [
                node
            ];
        } else {
            var namesArray = (throughTickets === null || throughTickets === void 0 ? void 0 : throughTickets.map(function(ticket) {
                return ticket.name;
            })) || [];
            return namesArray.map(function(name) {
                var ref, ref1;
                var matchedTicket = (ref = node.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : ref1.find(function(ticket) {
                    return ticket.name === name;
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node), {
                    ticketStatus: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, node.ticketStatus), {
                        throughTicket: (0,src_object_spread/* default */.Z)({}, matchedTicket)
                    })
                });
            }) || [];
        }
    })) || [];
    var updatedSerialsArray = mappedTickets.flat();
    //通し券があった場合のフィルター処理
    var filteredTickets = updatedSerialsArray.filter(function(param) {
        var ticketStatus = param.ticketStatus;
        // サブチケットがあるか判定
        if (!(ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.throughTicket)) {
            return true;
        } else {
            switch(filter){
                case "used":
                    var ref;
                    return (ticketStatus === null || ticketStatus === void 0 ? void 0 : (ref = ticketStatus.throughTicket) === null || ref === void 0 ? void 0 : ref.isUsed) === true;
                case "unused":
                    var ref1;
                    return (ticketStatus === null || ticketStatus === void 0 ? void 0 : (ref1 = ticketStatus.throughTicket) === null || ref1 === void 0 ? void 0 : ref1.isUsed) === false;
                default:
                    return true;
            }
        }
    })//配列の要素の前後のシリアルナンバーを比較し、異なっていれば配列の先頭であることを表すisFirstをtrueにする
    .map(function(ticket, index, array) {
        var ref;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ticket), {
            isFirst: index === 0 || ticket.formattedSerialNumber !== ((ref = array[index - 1]) === null || ref === void 0 ? void 0 : ref.formattedSerialNumber)
        });
    });
    var border = {
        borderTop: "1px solid",
        borderColor: "grey.100"
    };
    // サブチケット名カラムのスタイルを取得する関数
    var subTicketColumnStyle = function(index, isFirst) {
        if (index === 0) return {};
        if (isFirst) {
            return border;
        } else {
            return {};
        }
    };
    var _seat, _formattedAssignedNumber, _formattedAssignedNumber1, ref2, _formattedUsedAt, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 4,
            px: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                "aria-label": "serial-number-table",
                sx: {
                    width: "auto",
                    ovrerflowX: "scroll"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: "none",
                                        minWidth: 52,
                                        py: 2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        sx: {
                                            display: "block"
                                        },
                                        children: t("isUsed", "使用状況")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: "none",
                                        minWidth: 84,
                                        py: 2,
                                        px: 2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        sx: {
                                            display: "block"
                                        },
                                        children: t("serialNumber", "シリアルナンバー")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 88,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: assignedNumberType ? t("seat", "座席番号") : t("assignedNumber", "整理番号")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 98,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("subTicketName", "サブチケット名")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 128,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        sx: {
                                            display: "block"
                                        },
                                        children: t("dateOfUse")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 88,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("usedAt", "使用日")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    width: "100%",
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 150,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("fullName", "氏名")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    width: "100%",
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        minWidth: 150,
                                        py: 2,
                                        px: 3
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("owner", "所有者")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    width: "100%",
                                    align: "left",
                                    sx: {
                                        border: "none",
                                        py: 2,
                                        px: 3,
                                        minWidth: "100px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("phoneNumber", "電話番号")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        component: TableRow/* default */.Z,
                        colSpan: 5,
                        nodes: filteredTickets.map(function(serial, index) {
                            var ref, ref1, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            px: 0,
                                            minWidth: 52,
                                            border: "none",
                                            bgcolor: ((ref = serial.user) === null || ref === void 0 ? void 0 : ref.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            sx: {
                                                width: 64
                                            },
                                            children: [
                                                editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: (serial === null || serial === void 0 ? void 0 : (ref1 = serial.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.throughTicket) ? serial.ticketStatus.throughTicket.isUsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Selected, {
                                                        size: "small",
                                                        color: "primary.main",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        onClick: function() {
                                                            return setTicketModalSerial(serial);
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Circle, {
                                                        size: "small",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        onClick: function() {
                                                            return setTicketModalSerial(serial);
                                                        }
                                                    }) : ((ref5 = serial.ticketStatus) === null || ref5 === void 0 ? void 0 : ref5.isUsed) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Selected, {
                                                        size: "small",
                                                        color: "primary.main",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        onClick: function() {
                                                            return setTicketModalSerial(serial);
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Circle, {
                                                        size: "small",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        onClick: function() {
                                                            return setTicketModalSerial(serial);
                                                        }
                                                    })
                                                }),
                                                !editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: (serial === null || serial === void 0 ? void 0 : (ref6 = serial.ticketStatus) === null || ref6 === void 0 ? void 0 : ref6.throughTicket) ? serial.ticketStatus.throughTicket.isUsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                                        color: "primary",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        fontSize: "small"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        align: "center",
                                                        sx: {
                                                            px: 2,
                                                            width: "100%"
                                                        },
                                                        children: "-"
                                                    }) : ((ref7 = serial.ticketStatus) === null || ref7 === void 0 ? void 0 : ref7.isUsed) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                                        color: "primary",
                                                        sx: {
                                                            mx: "auto"
                                                        },
                                                        fontSize: "small"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        align: "center",
                                                        sx: {
                                                            px: 2,
                                                            width: "100%"
                                                        },
                                                        children: "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                    orientation: "vertical",
                                                    flexItem: true,
                                                    sx: {
                                                        height: 20,
                                                        border: "1px solid",
                                                        borderColor: "grey.100"
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            pl: 3,
                                            pr: 0,
                                            border: "none",
                                            bgcolor: ((ref8 = serial.user) === null || ref8 === void 0 ? void 0 : ref8.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            sx: {
                                                pr: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SerialNumber, {
                                                    label: serial.formattedSerialNumber
                                                }),
                                                serial.isNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                                                    fontSize: "small",
                                                    filledColor: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            px: 0,
                                            border: "none",
                                            bgcolor: ((ref9 = serial.user) === null || ref9 === void 0 ? void 0 : ref9.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                    orientation: "vertical",
                                                    flexItem: true,
                                                    sx: {
                                                        height: 20,
                                                        border: "1px solid",
                                                        borderColor: "grey.100"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: isThroughTicket ? assignedNumberType ? (_seat = (ref10 = serial.ticketStatus) === null || ref10 === void 0 ? void 0 : ref10.throughTicket.seat) !== null && _seat !== void 0 ? _seat : "-" : (_formattedAssignedNumber = serial.formattedAssignedNumber) !== null && _formattedAssignedNumber !== void 0 ? _formattedAssignedNumber : "-" : (_formattedAssignedNumber1 = serial.formattedAssignedNumber) !== null && _formattedAssignedNumber1 !== void 0 ? _formattedAssignedNumber1 : "-"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            pl: 0,
                                            pr: 5,
                                            border: "none",
                                            bgcolor: ((ref11 = serial.user) === null || ref11 === void 0 ? void 0 : ref11.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                        orientation: "vertical",
                                                        flexItem: true,
                                                        sx: {
                                                            height: 20,
                                                            border: "1px solid",
                                                            borderColor: "grey.100"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                                    children: (ref2 = (ref12 = serial.ticketStatus) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.throughTicket) === null || ref13 === void 0 ? void 0 : ref13.name) !== null && ref2 !== void 0 ? ref2 : "-"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            px: 0,
                                            border: "none",
                                            bgcolor: ((ref14 = serial.user) === null || ref14 === void 0 ? void 0 : ref14.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                    orientation: "vertical",
                                                    flexItem: true,
                                                    sx: {
                                                        height: 20
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: function() {
                                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                                        var formatDate = function(date) {
                                                            return date ? dayjs_min_default()(date).format("YYYY/MM/DD HH:mm") : "-";
                                                        };
                                                        var ref6;
                                                        var ticket = isThroughTicket ? item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref4 = ref1.throughTicket) === null || ref4 === void 0 ? void 0 : ref4[(ref6 = (ref2 = serial.ticketStatus) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.throughTicket) === null || ref3 === void 0 ? void 0 : ref3.index) !== null && ref6 !== void 0 ? ref6 : 0] : item === null || item === void 0 ? void 0 : (ref5 = item.metadata) === null || ref5 === void 0 ? void 0 : ref5.ticket;
                                                        return [
                                                            ticket === null || ticket === void 0 ? void 0 : ticket.startDateOfUse,
                                                            ticket === null || ticket === void 0 ? void 0 : ticket.endDateOfUse
                                                        ].map(formatDate).join("\n");
                                                    }()
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: {
                                            py: 2,
                                            px: 0,
                                            border: "none",
                                            bgcolor: ((ref15 = serial.user) === null || ref15 === void 0 ? void 0 : ref15.id) === artistId ? "grey.50" : "unset"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                    orientation: "vertical",
                                                    flexItem: true,
                                                    sx: {
                                                        height: 20,
                                                        border: "1px solid",
                                                        borderColor: "grey.100"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: (serial === null || serial === void 0 ? void 0 : (ref16 = serial.ticketStatus) === null || ref16 === void 0 ? void 0 : ref16.throughTicket) ? (_formattedUsedAt = serial.ticketStatus.throughTicket.formattedUsedAt) !== null && _formattedUsedAt !== void 0 ? _formattedUsedAt : "-" : (ref3 = (ref17 = serial.ticketStatus) === null || ref17 === void 0 ? void 0 : ref17.formattedUsedAt) !== null && ref3 !== void 0 ? ref3 : "-"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            pl: 0,
                                            pr: 5,
                                            border: "none",
                                            bgcolor: ((ref18 = serial.user) === null || ref18 === void 0 ? void 0 : ref18.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                        orientation: "vertical",
                                                        flexItem: true,
                                                        sx: {
                                                            height: 20,
                                                            border: "1px solid",
                                                            borderColor: "grey.100"
                                                        }
                                                    })
                                                }),
                                                serial.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: serial.user.fullName
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            pl: 0,
                                            pr: 5,
                                            border: "none",
                                            bgcolor: ((ref19 = serial.user) === null || ref19 === void 0 ? void 0 : ref19.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                        orientation: "vertical",
                                                        flexItem: true,
                                                        sx: {
                                                            height: 20,
                                                            border: "1px solid",
                                                            borderColor: "grey.100"
                                                        }
                                                    })
                                                }),
                                                serial.user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    component: Link/* default */.Z,
                                                    underline: "none",
                                                    href: generatePath(routerPages.ConsoleUserDetail, {
                                                        userId: serial.user.id
                                                    }),
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                            src: (ref4 = (ref20 = serial.user.avatar) === null || ref20 === void 0 ? void 0 : ref20.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                                                            sx: {
                                                                width: 28,
                                                                height: 28
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            children: serial.user.displayName
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: (0,src_object_spread/* default */.Z)({
                                            position: "relative",
                                            py: 2,
                                            px: 0,
                                            border: "none",
                                            bgcolor: ((ref21 = serial.user) === null || ref21 === void 0 ? void 0 : ref21.id) === artistId ? "grey.50" : "unset"
                                        }, subTicketColumnStyle(index, serial.isFirst)),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                    orientation: "vertical",
                                                    flexItem: true,
                                                    sx: {
                                                        height: 20,
                                                        border: "1px solid",
                                                        borderColor: "grey.100"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: (ref22 = serial.user) === null || ref22 === void 0 ? void 0 : ref22.phoneNumber
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, serial.id);
                        }),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                padding: "none",
                                colSpan: 3,
                                sx: {
                                    border: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    spacing: 3,
                                    sx: {
                                        px: 5
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "large",
                                        numberOfLine: 8,
                                        lastWidth: "100%"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
var ConsoleItemDetailTicket_FilterMenu = function(param) {
    var filter = param.filter, onFilter = param.onFilter, isThroughTicket = param.isThroughTicket;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var handleSelect = (0,react.useCallback)(function(value) {
        onFilter(value);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            px: 5,
            pt: 6,
            pb: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                pb: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Serial, {
                        fontSize: "small",
                        sx: {
                            color: "grey.600"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("usageHistory", "使用履歴")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
                value: filter,
                onClick: handleSelect,
                tags: [
                    {
                        value: "general",
                        label: t("general")
                    },
                    {
                        value: "used",
                        label: t("used")
                    },
                    {
                        value: "unused",
                        label: t("unused")
                    }, 
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VideoPlayer/VideoPlayerControl.tsx




var VideoPlayerControl = function(param) {
    var isPlaying = param.isPlaying, duration = param.duration, sliderValue = param.sliderValue, onPlay = param.onPlay, onPause = param.onPause, onRewind = param.onRewind, onForward = param.onForward, onChange = param.onChange, onChangeCommitted = param.onChangeCommitted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            position: "absolute",
            zIndex: 10,
            bottom: 20,
            left: 20,
            right: 20,
            bgcolor: "rgba(18,18,18,0.6)",
            py: 2,
            pr: 6,
            pl: 4,
            borderRadius: 2,
            mb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
        },
        direction: "row",
        flex: 1,
        alignItems: "center",
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.VideoRewind, {
                            onClick: onRewind
                        }),
                        isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.VideoPause, {
                            onClick: onPause
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.VideoPlay, {
                            onClick: onPlay
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.VideoForward, {
                            onClick: onForward
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                        min: 0,
                        max: duration,
                        defaultValue: 0,
                        value: sliderValue,
                        onChange: onChange,
                        onChangeCommitted: onChangeCommitted,
                        sx: {
                            "&.MuiSlider-root": {
                                py: 2
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            "& > span": {
                                color: "#F1F5F6"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: secondToMmss(sliderValue)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: Number.isFinite(duration) && secondToMmss(Math.floor(duration) - Math.floor(sliderValue))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var secondToMmss = function(second) {
    return [
        Math.floor(second / 60),
        Math.floor(second % 60)
    ].map(function(timeNum) {
        return String(timeNum).padStart(2, "0");
    }).join(":");
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VideoPlayer/VideoDRMPlayer.tsx









var VideoDRMPlayer = function(param) {
    var resource = param.resource, autoplay = param.autoplay, open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        // NOTE: DRMの読み込みにrefを参照する必要があるため、モーダル内部の要素は常に出力し、スタイルで表示を制御する
        sx: {
            display: open ? "block" : "none"
        },
        open: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                outline: "none",
                width: "100%",
                height: "100%",
                bgcolor: "black"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoDRMPlayerContent, {
                resource: resource,
                autoplay: autoplay,
                onClose: onClose
            })
        })
    });
};
var VideoDRMPlayerContent = function(param) {
    var resource = param.resource, autoplay = param.autoplay, onClose = param.onClose;
    var ref = (0,react.useState)(0), slidingValue = ref[0], setSlidingValue = ref[1];
    var ref1 = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            chromeless: true
        }
    }), ref2 = ref1.ref, player = ref1.player, currentTime = ref1.currentTime, accessToken = ref1.accessToken;
    (0,react.useEffect)(function() {
        if (!(player && accessToken)) return;
        player === null || player === void 0 ? void 0 : player.play();
        if (!autoplay) player.pause();
    }, [
        player,
        autoplay,
        accessToken
    ]);
    var handleClose = (0,react.useCallback)(function() {
        player === null || player === void 0 ? void 0 : player.pause();
        onClose();
    }, [
        onClose,
        player
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "relative",
                    height: "100%",
                    display: "flex"
                },
                flex: 1,
                children: [
                    (!player || !(player === null || player === void 0 ? void 0 : player.duration)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            zIndex: 2,
                            inset: 0,
                            margin: "auto",
                            width: "fit-content",
                            height: "fit-content",
                            pointerEvents: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerView */.m, {
                        ref: ref2,
                        chromeless: true,
                        type: "video"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    top: 8,
                    right: 8,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    size: "medium",
                    bgcolor: "grey.50",
                    onClick: handleClose
                })
            }),
            player && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerControl, {
                sliderValue: slidingValue ? slidingValue : currentTime,
                onChange: function(_, time) {
                    if (typeof time === "number") setSlidingValue(time);
                },
                onChangeCommitted: function(_, time) {
                    if (typeof time === "number") player.currentTime = time;
                    setSlidingValue(0);
                },
                onRewind: function() {
                    player.currentTime = player.currentTime - 10;
                },
                onForward: function() {
                    player.currentTime = player.currentTime + 10;
                },
                onPause: function() {
                    player.pause();
                },
                onPlay: function() {
                    player.paused ? player.play() : player.pause();
                },
                isPlaying: !(player === null || player === void 0 ? void 0 : player.paused),
                duration: player === null || player === void 0 ? void 0 : player.duration
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(80960);
// EXTERNAL MODULE: ./src/core/resources/useSoundPlayer.tsx
var useSoundPlayer = __webpack_require__(47536);
;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VideoPlayer/VideoPurePlayer.tsx








var VideoPurePlayer = function(param) {
    var uri = param.uri, autoplay = param.autoplay, open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        onClose: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                position: "absolute",
                top: 0,
                zIndex: 10,
                left: 0,
                right: 0,
                bottom: 0,
                outline: "none",
                width: "100%",
                height: "100%",
                bgcolor: "black",
                "video, iframe": {
                    display: "block"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPurePlayerContent, {
                uri: uri,
                autoplay: autoplay,
                onClose: onClose
            })
        })
    });
};
var VideoPurePlayerContent = function(param) {
    var uri = param.uri, autoplay = param.autoplay, onClose = param.onClose;
    var ref = (0,useSoundPlayer/* useSoundPlayer */.u)(uri), player = ref.player, playing = ref.playing, duration = ref.duration, sliderValue = ref.sliderValue, handleDuration = ref.handleDuration, handleProgress = ref.handleProgress, change = ref.change, commitChange = ref.commitChange, rewind = ref.rewind, end = ref.end, play = ref.play, pause = ref.pause, forward = ref.forward, handleError = ref.handleError;
    (0,react.useEffect)(function() {
        if (!player) return;
        autoplay ? play() : pause();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        player,
        autoplay
    ]);
    var handleClose = (0,react.useCallback)(function() {
        pause();
        onClose();
    }, [
        onClose,
        pause
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                ref: player,
                width: "100%",
                height: "100%",
                playsinline: true,
                playIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                url: uri,
                playing: playing,
                onDuration: handleDuration,
                onProgress: handleProgress,
                onEnded: end,
                onError: handleError,
                progressInterval: 100,
                config: {
                    file: {
                        attributes: {
                            poster: "noposter"
                        }
                    }
                }
            }),
            player && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            top: 8,
                            right: 8,
                            pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            size: "medium",
                            bgcolor: "grey.50",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayerControl, {
                        isPlaying: playing,
                        duration: duration !== null && duration !== void 0 ? duration : 0,
                        onChange: change,
                        onChangeCommitted: commitChange,
                        sliderValue: sliderValue !== null && sliderValue !== void 0 ? sliderValue : 0,
                        onPlay: play,
                        onPause: pause,
                        onRewind: rewind,
                        onForward: forward
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VideoPlayer/index.tsx



var VideoPlayer = function(param) {
    var resource = param.resource, autoplay = param.autoplay, open = param.open, onClose = param.onClose;
    var ref;
    if (((ref = resource.drm) === null || ref === void 0 ? void 0 : ref.encryptingStatus) === "encrypted") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoDRMPlayer, {
            autoplay: autoplay,
            open: open,
            onClose: onClose,
            resource: resource
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPurePlayer, {
        autoplay: autoplay,
        open: open,
        onClose: onClose,
        uri: resource.uri
    });
};

// EXTERNAL MODULE: ./src/core/native/privacy/index.ts
var privacy = __webpack_require__(7268);
;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailVideoView.tsx












var OwnedItemDetailVideoView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onClickProtectUserItem = param.onClickProtectUserItem, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), displayResource = ref5[0], setDisplayResource = ref5[1];
    var videoResource = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : ref.resource;
    var onClickItemButton = function() {
        return setDisplayResource(function(prev) {
            return !prev;
        });
    };
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            position: "relative",
                            ".MuiButtonBase-root": {
                                height: "fit-content"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                onOpenFullScreen: onOpenFullScreen,
                                onOpenMultipleImage: onOpenMultipleImage,
                                numberImage: (ref6 = (ref1 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref6 !== void 0 ? ref6 : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                loading: loading,
                                flipProps: {
                                    isFlipped: isFlipped
                                },
                                btnPlay: {
                                    type: "back",
                                    onClick: onClickItemButton
                                },
                                imageAreaProps: {
                                    thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.item) === null || ref2 === void 0 ? void 0 : ref2.thumbnail,
                                    size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                    onClick: onReverseThumbnail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                        portfolio: portfolio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 4,
                            mb: 2
                        },
                        children: videoResource && !isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Video, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref7 = (ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref7 !== void 0 ? ref7 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref4 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref4 === void 0 ? void 0 : ref4.chains),
                onClickProtectUserItem: onClickProtectUserItem
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemResourcePlayerCell, {
                open: displayResource,
                onClose: onClickItemButton,
                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item
            })
        ]
    });
};
var ItemResourcePlayerCell = function(param) {
    var item = param.item, open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: (item === null || item === void 0 ? void 0 : item.resource) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
                open: open,
                autoplay: open,
                onClose: onClose,
                resource: item === null || item === void 0 ? void 0 : item.resource
            })
        })
    });
};
function usePrivacyScreen() {
    (0,react.useEffect)(function() {
        privacy/* enablePrivacyScreen */.a();
        return function() {
            privacy/* disablePrivacyScreen */.G();
        };
    });
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailVideo.tsx









var ConsoleItemDetailVideo = function(param) {
    var loading = param.loading, item = param.item, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref;
    usePrivacyScreen();
    var ref1 = (0,react.useState)(false), displayResource = ref1[0], setDisplayResource = ref1[1];
    var videoResource = item === null || item === void 0 ? void 0 : item.resource;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        btnPlay: {
                            type: "back",
                            onClick: function() {
                                return setDisplayResource(function(prevState) {
                                    return !prevState;
                                });
                            }
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: videoResource && !isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Video, {
                    size: "small",
                    onClick: onReverseThumbnail,
                    bgcolor: "primary.main",
                    color: "white"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                    size: "small",
                    onClick: onReverseThumbnail,
                    bgcolor: "primary.main",
                    color: "white"
                })
            }),
            item && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemResourcePlayerCell, {
                open: displayResource,
                onClose: function() {
                    return setDisplayResource(function(prevState) {
                        return !prevState;
                    });
                },
                item: item
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/ConsoleItemDetailWallpaper.tsx








var ConsoleItemDetailWallpaper = function(param) {
    var loading = param.loading, item = param.item, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1;
    var audioResource = item === null || item === void 0 ? void 0 : (ref = item.wallpaperResources) === null || ref === void 0 ? void 0 : ref.audioResource;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                        onOpenFullScreen: onOpenFullScreen,
                        onOpenMultipleImage: onOpenMultipleImage,
                        numberImage: (ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.images) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref2 !== void 0 ? ref2 : 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                        loading: loading,
                        flipProps: {
                            isFlipped: isFlipped
                        },
                        imageAreaProps: {
                            thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                            size: (item === null || item === void 0 ? void 0 : item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                            onClick: onReverseThumbnail
                        }
                    })
                ]
            }),
            item && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                    salesCondition: item.salesCondition,
                    isPublished: item.isPublished,
                    isDrm: item.isDrm,
                    isPremium: item.isPremium
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDescription, {
                item: item,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 2
                },
                children: audioResource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
                    resource: audioResource,
                    bgcolor: "primary.main",
                    color: "white"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                    size: "small",
                    onClick: function() {
                        onReverseThumbnail();
                    },
                    bgcolor: "primary.main",
                    color: "white"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/template/index.tsx































var ConsoleItemDetailTemplate = function(param) {
    var state = param.state, onToggleSelling = param.onToggleSelling, onToggleActive = param.onToggleActive, onRemove = param.onRemove, onSettingAvatar = param.onSettingAvatar, onFetchMoreSerial = param.onFetchMoreSerial, onFilterTicket = param.onFilterTicket, onToggleTicketUsed = param.onToggleTicketUsed;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    // マガジンアイテムの表示に関する状態
    var ref2 = (0,react.useState)(false), displayResource = ref2[0], setDisplayResource = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleItemDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                safeArea: displayResource ? {
                    pt: 0,
                    pb: 0
                } : undefined,
                header: displayResource ? undefined : {
                    back: true,
                    defaultBackPage: routerPages.ConsoleItems,
                    type: "modal",
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        artistId: state.artistId,
                        itemId: (ref = state.item) === null || ref === void 0 ? void 0 : ref.id
                    }),
                    color: "white"
                },
                sx: {
                    height: "100dvh",
                    // マガジンビュワーのスタイル設定
                    ".BaseLayout": {
                        position: "fixed",
                        width: "100%",
                        top: 0,
                        left: 0
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailCell, {
                    artistId: state.artistId,
                    item: state.item,
                    loading: state.loading,
                    ticketOpen: state.ticketOpen,
                    refetchingSerial: state.refetchingSerial,
                    hasNextSerialPage: state.hasNextSerialPage,
                    onToggleActive: onToggleActive,
                    onToggleSelling: onToggleSelling,
                    onRemove: onRemove,
                    onSettingAvatar: onSettingAvatar,
                    onFetchMoreSerial: onFetchMoreSerial,
                    ticketFilter: state.ticketFilter,
                    onFilterTicket: onFilterTicket,
                    onToggleTicketUsed: onToggleTicketUsed,
                    displayResource: displayResource,
                    setDisplayResource: setDisplayResource
                })
            })
        ]
    });
};
var ItemDetailCell = function(param) {
    var artistId = param.artistId, item = param.item, loading = param.loading, ticketOpen = param.ticketOpen, refetchingSerial = param.refetchingSerial, ticketFilter = param.ticketFilter, hasNextSerialPage = param.hasNextSerialPage, onToggleActive = param.onToggleActive, onToggleSelling = param.onToggleSelling, onRemove = param.onRemove, onSettingAvatar = param.onSettingAvatar, onFetchMoreSerial = param.onFetchMoreSerial, onFilterTicket = param.onFilterTicket, onToggleTicketUsed = param.onToggleTicketUsed, displayResource = param.displayResource, setDisplayResource = param.setDisplayResource;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), openFullScreenModal = ref1[0], setOpenFullScreenModal = ref1[1];
    var ref2 = (0,react.useState)(false), showMultipleImage = ref2[0], setShowMultipleImage = ref2[1];
    var ref3 = (0,react.useState)(false), openTrashConfirm = ref3[0], setOpenTrashConfirm = ref3[1];
    var ref4 = (0,react.useState)(false), removing = ref4[0], setRemoving = ref4[1];
    // カードの表裏に関する状態
    var ref5 = (0,react.useState)(false), isFlipped = ref5[0], setIsFlipped = ref5[1];
    var handleReverseThumbnail = (0,react.useCallback)(function() {
        return setIsFlipped(function(prev) {
            return !prev;
        });
    }, [
        setIsFlipped
    ]);
    var itemDetailComponent = (0,react.useMemo)(function() {
        switch(item === null || item === void 0 ? void 0 : item.type){
            case utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailAvatar, {
                    loading: loading,
                    item: item,
                    updating: false,
                    onSettingAvatar: onSettingAvatar,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            case utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailMagazine, {
                    loading: loading,
                    item: item,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onViewMagazine: function() {
                        return setDisplayResource(true);
                    },
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            case utoniq_core_schema/* ItemType.Merch */.qGq.Merch:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailMerch, {
                    loading: loading,
                    item: item,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            case utoniq_core_schema/* ItemType.Video */.qGq.Video:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailVideo, {
                    loading: loading,
                    item: item,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailWallpaper, {
                    loading: loading,
                    item: item,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            case utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailTicket, {
                    refetching: refetchingSerial,
                    hasNextPage: hasNextSerialPage,
                    loading: loading,
                    item: item,
                    ticketOpen: ticketOpen,
                    artistId: artistId,
                    onToggleActive: onToggleActive,
                    onToggleSelling: onToggleSelling,
                    onRemove: function() {
                        return setOpenTrashConfirm(true);
                    },
                    onFetchMore: onFetchMoreSerial,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    ticketFilter: ticketFilter,
                    onFilterTicket: onFilterTicket,
                    onToggleTicketUsed: onToggleTicketUsed,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailAudio, {
                    loading: loading,
                    item: item,
                    isFlipped: isFlipped,
                    onReverseThumbnail: handleReverseThumbnail,
                    onOpenFullScreen: function() {
                        return setOpenFullScreenModal(true);
                    },
                    onOpenMultipleImage: function() {
                        setOpenFullScreenModal(true);
                        setShowMultipleImage(true);
                    }
                });
        }
    }, [
        item,
        loading,
        onSettingAvatar,
        isFlipped,
        handleReverseThumbnail,
        refetchingSerial,
        hasNextSerialPage,
        artistId,
        onToggleActive,
        onToggleSelling,
        onFetchMoreSerial,
        ticketFilter,
        onFilterTicket,
        onToggleTicketUsed,
        setDisplayResource, 
    ]);
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setRemoving(true);
                    return [
                        4,
                        onRemove().then(function() {
                            showMessage(t("deletedItem"), "success");
                        }).catch(function(error) {
                            return showError(error);
                        }).finally(function() {
                            setOpenTrashConfirm(false);
                            setRemoving(false);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onRemove,
        showMessage,
        t,
        showError
    ]);
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: itemDetailComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleSupplementLinkArea, {
                loading: loading,
                itemId: (ref6 = item === null || item === void 0 ? void 0 : item.id) !== null && ref6 !== void 0 ? ref6 : "#",
                isPublished: !!(item === null || item === void 0 ? void 0 : item.isPublished),
                saleStatus: (ref7 = item === null || item === void 0 ? void 0 : item.salesStatus) !== null && ref7 !== void 0 ? ref7 : "",
                onToggleActive: onToggleActive,
                onToggleSelling: onToggleSelling,
                onRemove: function() {
                    return setOpenTrashConfirm(true);
                },
                sx: {
                    visibility: !displayResource ? "visible" : "hidden"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazinePlayerModal, {
                loading: loading,
                open: displayResource,
                item: item,
                onClose: function() {
                    return setDisplayResource(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailFullScreenModal/* ThumbnailFullScreenModal */.e, {
                isDrm: item === null || item === void 0 ? void 0 : item.isDrm,
                open: openFullScreenModal,
                onClose: function() {
                    setOpenFullScreenModal(false);
                    setShowMultipleImage(false);
                },
                thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                images: item === null || item === void 0 ? void 0 : item.images,
                showMultipleImage: showMultipleImage,
                isFlipped: isFlipped
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openTrashConfirm,
                onClose: function() {
                    return setOpenTrashConfirm(false);
                },
                title: t("deleteItemModalTitle"),
                content: t("deleteItemModalDesc"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    loading: removing,
                    sx: {
                        minWidth: 212
                    },
                    onClick: handleRemove,
                    children: t("deleteBtn")
                })
            })
        ]
    });
};
/**
 * アイテムのオプションメニュー表示
 */ var Option = function(param) {
    var itemId = param.itemId, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref[0], copy = ref[1];
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,lib_url/* generateFullPath */.QP)(routerPages.ArtistStoreItemDetail, {
        artistId: artistId !== null && artistId !== void 0 ? artistId : "#",
        itemId: itemId !== null && itemId !== void 0 ? itemId : "#"
    })).onClick;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var onToggleOption = function(e) {
        setAnchorEl(e.currentTarget);
    };
    var open = !!anchorEl;
    if (!itemId || !artistId) return null;
    var options = [
        {
            label: t("copyURLLabel"),
            disabled: !itemId || !artistId,
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy((0,lib_url/* generateFullPath */.QP)(routerPages.ArtistStoreItemDetail, {
                                        artistId: artistId,
                                        itemId: itemId
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("openStoreLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick() {
                onClick();
                setAnchorEl(null);
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                bgcolor: "transparent",
                color: "white",
                size: "xSmall",
                onClick: onToggleOption
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                id: "item-option",
                open: open,
                anchorEl: anchorEl,
                onClose: function() {
                    return setAnchorEl(null);
                },
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                children: options.map(function(_param) /*#__PURE__*/ {
                    var icon = _param.icon, label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                        "icon",
                        "label"
                    ]);
                    return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                        sx: {
                            width: 200
                        },
                        key: label,
                        children: [
                            icon,
                            label
                        ]
                    }));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/viewModel.ts




function ConsoleItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItemDetail(\n    $id: ID!\n    $pageInput: PageInput\n    $filter: SerialFilter\n    $skuId: String\n  ) {\n    item(id: $id) {\n      ...ItemDescription\n      salesStatus\n      salesStartedAt\n      salesEndedAt\n      salesCondition @client\n      isPublished\n      skuSettings {\n        keyName\n        units {\n          id\n        }\n      }\n      isPremium\n      status @client\n      formattedPrice @client\n      usedNumber\n      pendingPurchaseNumber\n      serials(pageInput: $pageInput, filter: $filter) {\n        ...SerialItemOwners\n      }\n      collection {\n        id\n        isEventPickup\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation artistUseTickets($inputs: UseTicketsInput!) {\n    artistUseTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleItemDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation artistUnuseTickets($inputs: UnuseTicketsInput!) {\n    artistUnuseTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ConsoleItemDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var ref3 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref3.showError, showMessage = ref3.showMessage;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, routerPages = ref4.routerPages;
    var itemId = router.query.itemId;
    var ref5 = (0,useQuery/* useQuery */.aM)(ConsoleItemDetail_viewModel_QUERY, {
        variables: {
            id: itemId
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, networkStatus = ref5.networkStatus, fetchMore = ref5.fetchMore, refetch = ref5.refetch;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref6 = (0,react.useState)("general"), ticketFilter = ref6[0], setTicketFilter = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* PublishItem */.y6d), 1), publishItem = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnpublishItem */.P1N), 1), unpublishItem = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* StartSellingItem */.zK4), 1), startSellingItem = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* StopSellingItem */.s4v), 1), stopSellingItem = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistRemoveItem */.LOl), 1), artistRemoveItem = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_USE_TICKETS), 1), artistUseTicket = ref12[0];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UNUSE_TICKETS), 1), artistUnuseTicket = ref13[0];
    var ref14, ref15;
    return {
        state: {
            artistId: (ref14 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref14 !== void 0 ? ref14 : "",
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            refetchingSerial: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextSerialPage: !!(data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            item: (ref15 = data === null || data === void 0 ? void 0 : data.item) !== null && ref15 !== void 0 ? ref15 : null,
            ticketOpen: router.query.ticketOpen,
            ticketFilter: ticketFilter
        },
        actions: {
            onToggleActive: function onToggleActive(id, isActive) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isActive) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unpublishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                unpublishItem: {
                                                    id: id,
                                                    isPublished: false,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    publishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                publishItem: {
                                                    id: id,
                                                    isPublished: true,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onToggleSelling: function onToggleSelling(id, isSelling) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isSelling) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    stopSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                stopSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    startSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                startSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Active */.Qsp.Active,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemove: function onRemove() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistRemoveItem({
                                        variables: {
                                            id: itemId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                router.goBack(routerPages.ConsoleItems);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSettingAvatar: function onSettingAvatar() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onFetchMoreSerial: function onFetchMoreSerial() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: itemId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilterTicket: function onFilterTicket(filterType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (filterType === ticketFilter) return [
                            2
                        ];
                        setTicketFilter(filterType);
                        refetch({
                            filter: filterType === "general" ? undefined : {
                                ticketUsed: filterType === "used"
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onToggleTicketUsed: // チケットアイテムの使用状況を更新する
            function onToggleTicketUsed(serialId, isUsed, throughTicketName) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isUsed) return [
                                    3,
                                    2
                                ];
                                // チケットを未使用に戻す理
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_unuseTicket", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: data === null || data === void 0 ? void 0 : (ref5 = data.item) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.collection) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.event) === null || ref7 === void 0 ? void 0 : ref7.id,
                                    collectionId: data === null || data === void 0 ? void 0 : (ref8 = data.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.collection) === null || ref9 === void 0 ? void 0 : ref9.id,
                                    asArtist: true
                                });
                                return [
                                    4,
                                    artistUnuseTicket({
                                        variables: {
                                            inputs: {
                                                items: [
                                                    {
                                                        serialIds: [
                                                            serialId
                                                        ],
                                                        itemId: itemId,
                                                        throughTicketName: throughTicketName
                                                    }
                                                ]
                                            }
                                        }
                                    }).then(function() {
                                        return showMessage(t("UnuseTicketSuccess", "使用状況を未使用に変更しました。"));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                // チケットを使用する処理
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_useTicket", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.event) === null || ref2 === void 0 ? void 0 : ref2.id,
                                    collectionId: data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.collection) === null || ref4 === void 0 ? void 0 : ref4.id,
                                    asArtist: true
                                });
                                return [
                                    4,
                                    artistUseTicket({
                                        variables: {
                                            inputs: {
                                                items: [
                                                    {
                                                        itemId: itemId,
                                                        serialIds: [
                                                            serialId
                                                        ],
                                                        throughTicketName: throughTicketName
                                                    }
                                                ]
                                            }
                                        }
                                    }).then(function() {
                                        return showMessage(t("使用状況を使用済みに変更しました。"));
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleItemDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItemDetail_viewModel_templateObject(), utoniq_core_schema/* ItemDescriptionFragmentDoc */.A1h, utoniq_core_schema/* SerialItemOwnersFragmentDoc */.o7b);
var ARTIST_USE_TICKETS = (0,lib/* gql */.Ps)(ConsoleItemDetail_viewModel_templateObject1(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);
var ARTIST_UNUSE_TICKETS = (0,lib/* gql */.Ps)(ConsoleItemDetail_viewModel_templateObject2(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemDetail/index.tsx




/**
 * ConsoleItemDetail Page
 * Implemented as a practical sample.
 */ var ConsoleItemDetail = function() {
    var ref = ConsoleItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(80537);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemEdit/template/ItemEditForm.tsx

















var ItemEditForm_schema = function(o) {
    return {
        title: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.title")).max(100),
        description: o.string().when("type", {
            is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
            then: o.string().optional().allow(null),
            otherwise: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleItemEdit.description"))
        }),
        editResource: o.boolean().optional(),
        resourceId: o.string().when("editResource", {
            is: true,
            then: o.string().when("type", {
                switch: [
                    {
                        is: utoniq_core_schema/* ItemType.Audio */.qGq.Audio,
                        then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.resourceId.audio"))
                    },
                    {
                        is: utoniq_core_schema/* ItemType.Video */.qGq.Video,
                        then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.resourceId.video")).required()
                    },
                    {
                        is: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                        then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.resourceId.magazine")).required()
                    }, 
                ],
                otherwise: o.string().allow("").optional()
            }),
            otherwise: o.string().allow("").optional()
        }),
        resource: o.object().allow(null).optional(),
        editAvatarResource: o.boolean().optional(),
        avatarResources: o.object().when("editAvatarResource", {
            is: true,
            then: o.object().when("type", {
                is: utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar,
                then: o.object({
                    avatarResourceId: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.avatarResources.avatarResourceId")).required(),
                    voiceResourceId: o.string().allow("").optional()
                }),
                otherwise: o.object().allow(null).optional()
            }),
            otherwise: o.object().allow(null).optional()
        }),
        avatarResource: o.object().allow(null).optional(),
        editWallpaperResources: o.boolean().optional(),
        wallpaperResources: o.object().when("editWallpaperResources", {
            is: true,
            then: o.object().when("type", {
                is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                then: o.object({
                    wallpaperResourceId: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.wallpaperResources.wallpaperResourceId")).required(),
                    audioResourceId: o.string().allow("").optional()
                }),
                otherwise: o.object().allow(null).optional()
            }),
            otherwise: o.object().allow(null).optional()
        }),
        wallpaperResource: o.object().allow(null).optional(),
        hasPrice: o.boolean().optional(),
        paymentType: o.string().valid(utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint, utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash).allow(null).optional(),
        price: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.price")).when("hasPrice", [
            {
                is: true,
                then: o.number().required().min(100).max(100000)
            },
            {
                is: false,
                then: o.number().allow(0).optional()
            }, 
        ]),
        hasIssuedNumber: o.boolean().optional(),
        issuedNumber: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.issuedNumber")).when("hasIssuedNumber", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        hideSalesNumber: o.boolean().optional(),
        hasPurchaseLimitByUser: o.boolean().optional(),
        purchaseLimitByUser: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.purchaseLimitByUser")).when("hasPurchaseLimitByUser", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        hasPurchaseLimitPerOrder: o.boolean().optional(),
        purchaseLimitPerOrder: o.number().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.purchaseLimitPerOrder")).when("hasPurchaseLimitPerOrder", [
            {
                is: true,
                then: o.number().required().min(1).max(100000)
            },
            {
                is: false,
                then: o.any().allow(null).optional()
            }, 
        ]),
        isPremium: o.boolean().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.isPremium")).optional(),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.membershipAccessPermission")).items(o.string()).optional().allow(null),
        personalInformationRequirements: o.when("type", {
            is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
            then: o.string().optional().label("consoleItemCreate.personalInformationRequirements")
        }),
        type: o.string(),
        salesStatus: o.boolean().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.salesStatus")),
        salesStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.salesStartedAt")),
        salesEndedAt: o.date().optional().allow(null).custom(function(value, helpers) {
            var ref;
            var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 1), data = ref1[0];
            if (!value) {
                return value;
            }
            var salesStartedAt = (data === null || data === void 0 ? void 0 : data.salesStartedAt) || new Date();
            if (salesStartedAt > value) {
                // 開始日が終了日を過ぎていたらエラー
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("consoleItemCreate.salesEndedAt.custom.over")
                });
            }
            return value;
        }),
        resaleEnabled: o.boolean().optional().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.resaleEnabled")),
        hasAssignedNumber: o.boolean().optional(),
        thumbnailType: o.string().allow("").optional(),
        editThumbnail: o.boolean().optional(),
        isBothThumbnail: o.boolean().optional(),
        editThumbnailBack: o.boolean().optional(),
        thumbnail: o.string().when("editThumbnail", {
            is: true,
            then: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.thumbnail")),
            otherwise: o.string().allow("").optional()
        }),
        thumbnailBack: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.thumbnailBack")).allow("").optional(),
        metadata: o.object().when("type", {
            switch: [
                {
                    is: utoniq_core_schema/* ItemType.Merch */.qGq.Merch,
                    then: o.object({
                        merch: o.object({
                            receptionPeriod: o.object({
                                endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.merch.receptionPeriod.endedAt")).required()
                            })
                        }),
                        magazine: o.object().optional(),
                        ticket: o.object().optional(),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
                    then: o.object({
                        merch: o.object().optional(),
                        magazine: o.object().optional(),
                        ticket: o.object({
                            description: o.string().max(1000).label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.description")),
                            expirationTerm: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.expirationTerm")),
                            note: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.note")),
                            resalePeriod: o.object().when(// get relative references
                            // https://joi.dev/api/?v=17.9.1#refkey-options
                            o.ref("....resaleEnabled"), {
                                is: true,
                                then: o.object({
                                    startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.resalePeriod.startedAt")),
                                    endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.resalePeriod.endedAt"))
                                }),
                                otherwise: o.object({
                                    startedAt: o.date().optional().allow("").label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.resalePeriod.startedAt")),
                                    endedAt: o.date().optional().allow("").label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.resalePeriod.endedAt"))
                                })
                            }),
                            assignedNumberPrefix: o.string().when(o.ref("....hasAssignedNumber"), {
                                is: true,
                                then: o.string().max(5).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.assignedNumberPrefix")),
                                otherwise: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.assignedNumberPrefix"))
                            }),
                            startAssignedNumber: o.string().when(o.ref("....hasAssignedNumber"), {
                                is: true,
                                then: o.string().max(8).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.startAssignedNumber")),
                                otherwise: o.string().optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.startAssignedNumber"))
                            }),
                            isThroughTicket: o.boolean().optional().allow(null),
                            throughTicket: o.array().when("isThroughTicket", {
                                is: true,
                                then: o.array().items(o.object({
                                    //id of field array
                                    _id: o.string().optional(),
                                    name: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.ticket.throughTicket.name")),
                                    startDateOfUse: o.date().optional().allow(null),
                                    endDateOfUse: o.date().optional().allow(null)
                                })),
                                otherwise: o.array().optional().allow(null)
                            }),
                            distributionEnabled: o.boolean().optional().allow(null),
                            distributionEndedAt: o.date().when("distributionEnabled", {
                                is: true,
                                then: o.date().label((0,core_form/* tLabel */.TQ)("consoleItemEdit.metadata.ticket.distributionEndedAt")).required(),
                                otherwise: o.date().optional().allow(null, "")
                            }),
                            startDateOfUse: o.date().optional().allow(null),
                            endDateOfUse: o.date().optional().allow(null)
                        }),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                    then: o.object({
                        ticket: o.object().optional(),
                        merch: o.object().optional(),
                        magazine: o.object({
                            pageDirection: o.string().label((0,core_form/* tLabel */.TQ)("consoleItemCreate.metadata.magazine.pageDirection"))
                        }),
                        wallpaper: o.object().optional()
                    })
                },
                {
                    is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                    then: o.object({
                        ticket: o.object().optional(),
                        merch: o.object().optional(),
                        magazine: o.object().optional(),
                        wallpaper: o.object({
                            isPrintEnabled: o.boolean().optional().allow(null),
                            printCount: o.number().optional().allow(null),
                            printType: o.string().optional().allow(null)
                        })
                    })
                }, 
            ],
            otherwise: o.object().allow(null).optional()
        }),
        thumbnailResource: o.object().allow(null).optional(),
        thumbnailBackResource: o.object().allow(null).optional(),
        hasSku: o.boolean().optional(),
        images: o.array().items(o.object({
            tmpPath: o.string().optional().allow(""),
            caption: o.string().optional()
        })),
        skuSettings: o.when("hasSku", {
            is: true,
            then: o.object({
                keyName: o.string().optional().allow(null),
                units: o.array().items(o.object({
                    _id: o.string().optional(),
                    id: o.string().optional(),
                    unitName: o.string().max(100).label((0,core_form/* tLabel */.TQ)("consoleItemEdit.unitName")),
                    price: o.number().optional().allow(null),
                    stock: o.number().optional().allow("")//check total stock less than issuedNumber
                    .custom(function(value, helpers) {
                        var ref;
                        var ref1 = (0,_sliced_to_array/* default */.Z)((helpers === null || helpers === void 0 ? void 0 : (ref = helpers.state) === null || ref === void 0 ? void 0 : ref.ancestors) || [], 4), units = ref1[1], data = ref1[3];
                        if (!value) {
                            return value;
                        }
                        var issuedNumber = (data === null || data === void 0 ? void 0 : data.issuedNumber) || 0;
                        var totalItemInStock = units === null || units === void 0 ? void 0 : units.reduce(function(currentVal, unit) {
                            return currentVal + +((unit === null || unit === void 0 ? void 0 : unit.stock) || 0);
                        }, 0);
                        if (totalItemInStock > issuedNumber) {
                            return helpers.message({
                                custom: (0,core_form/* tMessage */.Sd)("consoleItemEdit.stock.custom.over")
                            });
                        }
                        if (totalItemInStock < issuedNumber) {
                            return helpers.message({
                                custom: (0,core_form/* tMessage */.Sd)("consoleItemEdit.stock.custom.shortage")
                            });
                        }
                        return value;
                    }),
                    order: o.number().optional(),
                    thumbnail: o.string().optional().allow(null)
                }))
            }),
            otherwise: o.object().optional()
        }),
        isDownloadable: o.when("type", {
            is: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
            then: o.boolean().allow(null).optional(),
            otherwise: o.forbidden()
        }).label((0,core_form/* tLabel */.TQ)("consoleItemCreate.isDownloadable"))
    };
};
var ItemEditForm = function(param) {
    var item = param.item, plans = param.plans, currentPlans = param.currentPlans, fileUploadInfo = param.fileUploadInfo, onSubmit = param.onSubmit, setIsFormValid = param.setIsFormValid;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var ref20 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref20.showMessage, showError = ref20.showError;
    var ref21 = (0,router_useRouter/* useRouter */.tv)(), router = ref21.router, generatePath = ref21.generatePath, routerPages = ref21.routerPages;
    var _id;
    var defaultBackPage = generatePath(routerPages.ConsoleItemDetail, {
        itemId: (_id = item.id) !== null && _id !== void 0 ? _id : "#"
    });
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemEdit").t;
    var resourceType = item.type;
    var ref22 = (0,core_form/* useForm */.cI)({
        schema: ItemEditForm_schema,
        defaultValues: (0,src_object_spread/* default */.Z)({}, ItemEditForm_defaultValues)
    }), handleSubmit = ref22.handleSubmit, _formState = ref22.formState, errors = _formState.errors, isDirty = _formState.isDirty, isValid = _formState.isValid, register = ref22.register, setValue = ref22.setValue, watch = ref22.watch, reset = ref22.reset, setError = ref22.setError, control = ref22.control, trigger = ref22.trigger;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref23 = (0,react.useState)(false), showCheckboxError = ref23[0], setCheckboxError = ref23[1];
    var ref24;
    var defaultPlans = item.purchesablePlanIds && item.purchesablePlanIds.length > 0 ? item.purchesablePlanIds : plans.map(function(plan) {
        return (ref24 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref24 !== void 0 ? ref24 : "";
    });
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setCheckboxError(true);
        } else {
            setCheckboxError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var hasPurchased = (0,react.useMemo)(function() {
        if (!item) return false;
        var _pendingPurchaseNumber;
        return item.purchasedNumber + ((_pendingPurchaseNumber = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0) > 0;
    }, [
        item
    ]);
    var ref25 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        keyName: "_id",
        name: "skuSettings.units"
    }), fields = ref25.fields, append = ref25.append, onRemove = ref25.remove, onMove = ref25.move;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        reset((0,src_object_spread/* default */.Z)({
            title: item.title,
            type: item.type,
            salesStatus: item.salesStatus === utoniq_core_schema/* SalesStatus.Active */.Qsp.Active,
            salesStartedAt: item.salesStartedAt || item.createdAt,
            salesEndedAt: item.salesEndedAt,
            description: item.description,
            isPremium: item.isPremium,
            purchesablePlanIds: currentPlans,
            price: item.price,
            issuedNumber: item.issuedNumber,
            thumbnailType: item.thumbnailType,
            thumbnail: "",
            thumbnailBack: "",
            hasPrice: item.price > 0,
            paymentType: item.paymentType,
            hasIssuedNumber: item.issuedNumber !== null,
            isDownloadable: item.isDownloadable === null ? undefined : item.isDownloadable,
            purchaseLimitByUser: item.purchaseLimitByUser,
            hasPurchaseLimitByUser: isNumber_default()(item.purchaseLimitByUser),
            purchaseLimitPerOrder: item.purchaseLimitPerOrder,
            hasPurchaseLimitPerOrder: isNumber_default()(item.purchaseLimitPerOrder),
            personalInformationRequirements: ((ref = item.personalInformationRequirements) === null || ref === void 0 ? void 0 : ref.length) ? ((ref1 = item.personalInformationRequirements) === null || ref1 === void 0 ? void 0 : ref1.includes("address")) ? personalInformationRequirementsValue.nameAndTelAndAddress : personalInformationRequirementsValue.nameAndTel : personalInformationRequirementsValue.none,
            resaleEnabled: !!item.resaleEnabled,
            hideSalesNumber: item.hideSalesNumber || false,
            hasSku: !!((ref2 = item.skuSettings) === null || ref2 === void 0 ? void 0 : ref2.units.length),
            hasAssignedNumber: !!((ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.assignedNumberPrefix),
            skuSettings: buildSkuSettings(item.skuSettings),
            images: Array.from(Array(30).keys()).map(function(_, index) {
                var ref, ref1, ref2, ref3;
                return {
                    tmpPath: (ref5 = item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref5 !== void 0 ? ref5 : "",
                    caption: (item === null || item === void 0 ? void 0 : (ref2 = item.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[index]) === null || ref3 === void 0 ? void 0 : ref3.caption) || undefined
                };
            })
        }, buildMetadata(item.metadata, item.type), buildItemResources(item)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        item,
        currentPlans
    ]);
    (0,react.useEffect)(function() {
        setIsFormValid(!showCheckboxError);
    }, [
        showCheckboxError
    ]);
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!isDirty) {
                    router.goBack(defaultBackPage);
                    return [
                        2
                    ];
                }
                return [
                    2,
                    onSubmit(values).then(function() {
                        showMessage(t("editItemSuccessful"), "success");
                        router.goBack(defaultBackPage);
                    }).catch(function(error) {
                        (0,core_form/* handleError */.S3)(error, setError, showError);
                    })
                ];
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isDirty,
        onSubmit,
        router,
        showMessage,
        t,
        setError,
        showError
    ]);
    var ref26, _price, _issuedNumber, _limitIssuedNumber, _purchaseLimitPerOrder;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        id: "item-edit-form",
        sx: {
            py: 5
        },
        onSubmit: handleSubmit(handleOnSubmit),
        children: [
            resourceType !== utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResourceUploadCell, {
                watch: watch,
                resourceType: resourceType,
                setValue: setValue,
                fileUploadInfo: fileUploadInfo,
                error: errors.resourceId || ((ref = errors.avatarResources) === null || ref === void 0 ? void 0 : ref.avatarResourceId) || ((ref1 = errors.wallpaperResources) === null || ref1 === void 0 ? void 0 : ref1.wallpaperResourceId),
                hasCreateResource: false,
                onClose: function(resourceType) {
                    switch(resourceType){
                        case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                            setValue("editWallpaperResources", true, {
                                shouldValidate: true
                            });
                            break;
                        case utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar:
                            setValue("editAvatarResource", true, {
                                shouldValidate: true
                            });
                            break;
                        default:
                            setValue("editResource", true, {
                                shouldValidate: true
                            });
                            break;
                    }
                }
            }),
            resourceType === utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDirectionInputCell, {
                setValue: setValue,
                watch: watch
            }),
            resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isDownloadable"),
                    description: t("isDownloadableDesc")
                },
                checked: watch("isDownloadable"),
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                }
            }, register("isDownloadable"))),
            resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper && config_config/* config.modules.eprint */.v.modules.eprint && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintInputCell, {
                setValue: setValue,
                isPrintEnabled: watch("metadata.wallpaper.isPrintEnabled"),
                printType: watch("metadata.wallpaper.printType"),
                printCount: watch("metadata.wallpaper.printCount")
            }),
            (resourceType === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper || resourceType === utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsAudioInputCell, {
                resourceType: resourceType,
                watch: watch,
                setValue: setValue,
                audioUploadInfo: fileUploadInfo,
                hasCreateResource: false
            }),
            resourceType === utoniq_core_schema/* ItemType.Audio */.qGq.Audio && false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemThumbnailInputCell, {
                isEdit: true,
                watch: watch,
                setValue: setValue,
                resourceType: resourceType,
                itemUploadInfo: fileUploadInfo,
                error: errors.thumbnail,
                errorBack: errors.thumbnailBack,
                onClose: function() {
                    setValue("editThumbnail", true, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                onBackClose: function() {
                    setValue("editThumbnailBack", true, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageInputCell, {
                watch: watch,
                setValue: setValue,
                control: control,
                fileUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            (config_config/* config.modules.store */.v.modules.store || config_config/* config.modules.preSale */.v.modules.preSale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInputCell, {
                mode: "edit",
                resourceType: resourceType,
                hasPrice: watch("hasPrice"),
                setValue: setValue,
                paymentType: (ref26 = watch("paymentType")) !== null && ref26 !== void 0 ? ref26 : null,
                defaultPrice: (_price = item.price) !== null && _price !== void 0 ? _price : 0,
                disableRadio: !!((ref2 = item.preSale) === null || ref2 === void 0 ? void 0 : ref2.id),
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.price
                }, register("price"))
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: (ref3 = errors.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.description
            }, register("metadata.ticket.description"))),
            resourceType !== utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: (ref5 = errors.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : ref6.note
            }, register("metadata.ticket.note"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && !watch("metadata.ticket.isThroughTicket") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableDateInputCell, {
                setValue: setValue,
                values: [
                    watch("metadata.ticket.startDateOfUse"),
                    watch("metadata.ticket.endDateOfUse"), 
                ],
                errors: [
                    (ref7 = errors.metadata) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.ticket) === null || ref8 === void 0 ? void 0 : ref8.startDateOfUse,
                    (ref9 = errors.metadata) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.ticket) === null || ref10 === void 0 ? void 0 : ref10.endDateOfUse, 
                ]
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketInputCell, {
                editable: !hasPurchased,
                isThroughTicket: watch("metadata.ticket.isThroughTicket"),
                control: control,
                watch: watch,
                setValue: setValue,
                register: register,
                errors: (ref11 = errors.metadata) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.ticket) === null || ref12 === void 0 ? void 0 : ref12.throughTicket
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpirationDateInputCell, {
                setValue: setValue,
                value: watch("metadata.ticket.expirationTerm"),
                error: errors === null || errors === void 0 ? void 0 : (ref13 = errors.metadata) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.ticket) === null || ref14 === void 0 ? void 0 : ref14.expirationTerm
            }),
            resourceType === utoniq_core_schema/* ItemType.Merch */.qGq.Merch && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDeadlineInputCell, {
                setValue: setValue,
                error: (ref15 = errors.metadata) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.merch) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.receptionPeriod) === null || ref17 === void 0 ? void 0 : ref17.endedAt,
                value: watch("metadata.merch.receptionPeriod.endedAt")
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInformationRequirementsInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("personalInformationRequirements")), {
                personalInformationRequirements: watch("personalInformationRequirements"),
                setValue: setValue
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IssueInputCell, {
                hasIssuedNumber: watch("hasIssuedNumber"),
                defaultNumber: (_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : 100,
                setValue: setValue,
                inputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.issuedNumber
                }, register("issuedNumber")), {
                    onChange: function onChange(event) {
                        return (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setValue("issuedNumber", event.target.value);
                                        return [
                                            4,
                                            Promise.all((0,src_to_consumable_array/* default */.Z)(Array(fields.length).keys()).map(function(idx) {
                                                return trigger("skuSettings.units.".concat(idx, ".stock"));
                                            }))
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    }
                })
            }),
            item.issuedNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mt: "-32px",
                    mb: "32px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: t("remainingNumber")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: (watch("issuedNumber") || 0) - item.purchasedNumber - ((item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber) || 0)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("salesStatusLabel"),
                    description: t("salesStatusDesc")
                },
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                }
            }, register("salesStatus")), {
                checked: watch("salesStatus")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesDateInputCell, {
                setValue: setValue,
                trigger: trigger,
                errors: [
                    errors.salesStartedAt,
                    errors.salesEndedAt
                ],
                values: [
                    watch("salesStartedAt"),
                    watch("salesEndedAt")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuInputCell, {
                setValue: setValue,
                hasIssuedNumber: watch("hasIssuedNumber"),
                fields: fields,
                watch: watch,
                trigger: trigger,
                register: register,
                onRemove: onRemove,
                fileUploadInfo: fileUploadInfo,
                onMove: onMove,
                errors: errors.skuSettings,
                units: (0,individual/* individualRemainingItemCountBySKU */.Qx)() && item.issuedNumber ? (ref18 = item.skuSettings) === null || ref18 === void 0 ? void 0 : ref18.units : undefined,
                onAppend: function() {
                    return append({
                        unitName: "",
                        stock: undefined,
                        order: 1,
                        thumbnail: undefined
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitIssueInputCell, {
                hasPurchaseLimitByUser: watch("hasPurchaseLimitByUser"),
                defaultNumber: (_limitIssuedNumber = item.limitIssuedNumber) !== null && _limitIssuedNumber !== void 0 ? _limitIssuedNumber : 1,
                setValue: setValue,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.purchaseLimitByUser
                }, register("purchaseLimitByUser"))
            }),
            config_config/* config.modules.cart */.v.modules.cart && config_config/* config.modules.pickup */.v.modules.pickup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerOrderLimitInputCell, {
                hasPurchaseLimitPerOrder: watch("hasPurchaseLimitPerOrder"),
                defaultNumber: (_purchaseLimitPerOrder = item.purchaseLimitPerOrder) !== null && _purchaseLimitPerOrder !== void 0 ? _purchaseLimitPerOrder : 1,
                setValue: setValue,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "number",
                    error: errors.purchaseLimitPerOrder
                }, register("purchaseLimitPerOrder"))
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketNumberInputCell, {
                watch: watch,
                setValue: setValue,
                register: register,
                errors: errors === null || errors === void 0 ? void 0 : (ref19 = errors.metadata) === null || ref19 === void 0 ? void 0 : ref19.ticket
            }),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareInputCell, {
                setValue: setValue,
                value: !!watch("metadata.ticket.distributionEnabled"),
                endedAt: watch("metadata.ticket.distributionEndedAt"),
                errors: errors
            }),
            config_config/* config.modules.membership */.v.modules.membership && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumInputCell, {
                register: register,
                setValue: setValue,
                watch: watch,
                plans: plans,
                defaultValue: defaultPlans,
                showCheckboxError: showCheckboxError
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Commons_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("hideSalesNumberLabel"),
                    description: t("hideSalesNumberDesc")
                },
                checked: watch("hideSalesNumber"),
                sx: {
                    "& > div:last-child span": {
                        typography: "body2"
                    }
                }
            }, register("hideSalesNumber"))),
            resourceType === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleInputCell, {
                setValue: setValue,
                value: !!watch("resaleEnabled"),
                startedAt: watch("metadata.ticket.resalePeriod.startedAt"),
                endedAt: watch("metadata.ticket.resalePeriod.endedAt"),
                errors: errors
            })
        ]
    });
};
var ItemEditForm_defaultValues = {
    title: "",
    type: utoniq_core_schema/* ItemType.Image */.qGq.Image,
    description: "",
    isPremium: false,
    salesStatus: false,
    salesStartedAt: null,
    salesEndedAt: null,
    personalInformationRequirements: personalInformationRequirementsValue.none,
    price: 0,
    issuedNumber: null,
    hideSalesNumber: false,
    thumbnail: "",
    copyrights: [],
    hasPrice: false,
    resaleEnabled: false,
    hasIssuedNumber: false,
    hasPurchaseLimitByUser: false,
    purchaseLimitByUser: null,
    hasPurchaseLimitPerOrder: false,
    purchaseLimitPerOrder: null,
    thumbnailType: utoniq_core_schema/* ItemThumbnailType.Rectangle */.gy9.Rectangle,
    metadata: {
        merch: {
            receptionPeriod: {
                endedAt: null
            }
        },
        ticket: {
            description: null,
            note: null,
            expirationTerm: null,
            resalePeriod: {
                startedAt: null,
                endedAt: null
            },
            startAssignedNumber: null,
            assignedNumberPrefix: null,
            isThroughTicket: null,
            throughTicket: null,
            distributionEnabled: false,
            distributionEndedAt: null,
            startDateOfUse: null,
            endDateOfUse: null
        }
    },
    images: Array.from(Array(30).keys()).map(function() {
        return {
            tmpPath: "",
            caption: undefined
        };
    }),
    resource: null,
    avatarResource: null,
    wallpaperResource: null,
    thumbnailResource: null,
    thumbnailBackResource: null,
    skuSettings: null,
    hasSku: false,
    isDownloadable: undefined,
    hasAssignedNumber: false,
    isBothThumbnail: false
};
function buildItemResources(item) {
    var resources = {
        thumbnailResource: ItemEditForm_buildResource(item.thumbnail.front),
        thumbnailBackResource: ItemEditForm_buildResource(item.thumbnail.back),
        resource: ItemEditForm_buildResource(item === null || item === void 0 ? void 0 : item.resource),
        wallpaperResource: null,
        avatarResource: null
    };
    if (item.type === utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper) {
        var ref, ref1;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, resources), {
            resource: ItemEditForm_buildResource(item === null || item === void 0 ? void 0 : (ref = item.wallpaperResources) === null || ref === void 0 ? void 0 : ref.audioResource),
            wallpaperResource: ItemEditForm_buildResource(item === null || item === void 0 ? void 0 : (ref1 = item.wallpaperResources) === null || ref1 === void 0 ? void 0 : ref1.wallpaperResource)
        });
    }
    if (item.type === utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar) {
        var ref2, ref3;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, resources), {
            resource: ItemEditForm_buildResource(item === null || item === void 0 ? void 0 : (ref2 = item.avatarResources) === null || ref2 === void 0 ? void 0 : ref2.voiceResource),
            avatarResource: ItemEditForm_buildResource(item === null || item === void 0 ? void 0 : (ref3 = item.avatarResources) === null || ref3 === void 0 ? void 0 : ref3.avatarResource)
        });
    }
    return resources;
}
function buildSkuSettings(skuSettings) {
    if (!skuSettings) {
        return {
            keyName: undefined,
            units: []
        };
    }
    return {
        keyName: skuSettings.keyName,
        units: skuSettings.units.map(function(param) {
            var id = param.id, unitName = param.unitName, thumbnail = param.thumbnail, stock = param.stock, order = param.order, price = param.price;
            return {
                id: id,
                unitName: unitName,
                thumbnail: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri) || null,
                stock: stock,
                order: order,
                price: price !== null && price !== void 0 ? price : null
            };
        })
    };
}
function buildMetadata(metadata, type) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    if (!metadata) return {};
    var ref14, ref15, ref16, ref17, ref18, ref19, ref20, _printType, _printCount;
    return {
        metadata: {
            ticket: metadata.ticket ? {
                description: (ref14 = (ref = metadata.ticket) === null || ref === void 0 ? void 0 : ref.description) !== null && ref14 !== void 0 ? ref14 : null,
                note: (ref15 = (ref1 = metadata.ticket) === null || ref1 === void 0 ? void 0 : ref1.note) !== null && ref15 !== void 0 ? ref15 : null,
                expirationTerm: (ref16 = (ref2 = metadata.ticket) === null || ref2 === void 0 ? void 0 : ref2.expirationTerm) !== null && ref16 !== void 0 ? ref16 : null,
                assignedNumberPrefix: metadata.ticket.assignedNumberPrefix ? metadata.ticket.assignedNumberPrefix : null,
                startAssignedNumber: metadata.ticket.assignedNumberPrefix ? (ref3 = metadata.ticket.startAssignedNumber) === null || ref3 === void 0 ? void 0 : ref3.toString() : null,
                resalePeriod: type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket ? {
                    startedAt: ((ref4 = metadata.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.startedAt) || "",
                    endedAt: ((ref6 = metadata.ticket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.resalePeriod) === null || ref7 === void 0 ? void 0 : ref7.endedAt) || ""
                } : undefined,
                isThroughTicket: metadata.ticket.isThroughTicket,
                throughTicket: (ref17 = (ref8 = metadata.ticket.throughTicket) === null || ref8 === void 0 ? void 0 : ref8.map(function(param) {
                    var name = param.name, startDateOfUse = param.startDateOfUse, endDateOfUse = param.endDateOfUse;
                    return {
                        name: name,
                        startDateOfUse: startDateOfUse,
                        endDateOfUse: endDateOfUse
                    };
                })) !== null && ref17 !== void 0 ? ref17 : [],
                distributionEndedAt: (ref18 = (ref9 = metadata.ticket) === null || ref9 === void 0 ? void 0 : ref9.distributionEndedAt) !== null && ref18 !== void 0 ? ref18 : null,
                distributionEnabled: !!((ref10 = metadata.ticket) === null || ref10 === void 0 ? void 0 : ref10.distributionEnabled),
                startDateOfUse: (ref19 = (ref11 = metadata.ticket) === null || ref11 === void 0 ? void 0 : ref11.startDateOfUse) !== null && ref19 !== void 0 ? ref19 : null,
                endDateOfUse: (ref20 = (ref12 = metadata.ticket) === null || ref12 === void 0 ? void 0 : ref12.endDateOfUse) !== null && ref20 !== void 0 ? ref20 : null
            } : undefined,
            merch: metadata.merch ? {
                receptionPeriod: {
                    endedAt: (ref13 = metadata.merch.receptionPeriod) === null || ref13 === void 0 ? void 0 : ref13.endedAt
                }
            } : undefined,
            magazine: metadata.magazine ? {
                pageDirection: metadata.magazine.pageDirection
            } : undefined,
            wallpaper: metadata.wallpaper ? {
                isPrintEnabled: !!metadata.wallpaper.isPrintEnabled,
                printType: (_printType = metadata.wallpaper.printType) !== null && _printType !== void 0 ? _printType : null,
                printCount: (_printCount = metadata.wallpaper.printCount) !== null && _printCount !== void 0 ? _printCount : null
            } : undefined
        }
    };
}
function ItemEditForm_buildResource(resource) {
    if (!resource) {
        return null;
    }
    var _name, _name1, _uri;
    return {
        id: (_name = resource.name) !== null && _name !== void 0 ? _name : "",
        resourceName: (_name1 = resource.name) !== null && _name1 !== void 0 ? _name1 : "",
        imageUrl: (_uri = resource.uri) !== null && _uri !== void 0 ? _uri : "",
        imageUploadPath: undefined
    };
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemEdit/template/index.tsx











var ConsoleItemEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onDrop = param.onDrop;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var ref1 = (0,react.useState)(false), isFormValid = ref1[0], setIsFormValid = ref1[1];
    var _itemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleItemEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleItemDetail, {
                        itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
                    }),
                    title: t("title")
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemEdit_template_FixedButtonCell, {
                    updating: state.updating || !!state.progress,
                    disabled: !isFormValid
                }),
                children: state.item && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemEditForm, {
                        item: state.item,
                        plans: state.plans,
                        currentPlans: state.currentPlans,
                        onSubmit: onSubmit,
                        fileUploadInfo: {
                            progress: state.progress,
                            onDrop: onDrop
                        },
                        setIsFormValid: setIsFormValid
                    })
                })
            })
        ]
    });
};
var ConsoleItemEdit_template_FixedButtonCell = function(param) {
    var updating = param.updating, disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                display: "flex",
                bgcolor: "grey.50",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                form: "item-edit-form",
                type: "submit",
                size: "large",
                loading: updating,
                disabled: disabled,
                sx: {
                    width: 244
                },
                children: t("save")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemEdit/viewModel.ts






function ConsoleItemEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItemEdit($itemId: ID!) {\n    item(id: $itemId) {\n      ...ItemSelectBox\n      preSale {\n        id\n      }\n      metadata {\n        magazine {\n          pageDirection\n        }\n        ticket {\n          expirationTerm\n          note\n          description\n          assignedNumberPrefix\n          startAssignedNumber\n          isThroughTicket\n          throughTicket {\n            name\n            startDateOfUse\n            endDateOfUse\n          }\n          distributionEnabled\n          distributionEndedAt\n          startDateOfUse\n          endDateOfUse\n        }\n        merch {\n          receptionPeriod {\n            endedAt\n          }\n        }\n        magazine {\n          pageDirection\n        }\n        wallpaper {\n          isPrintEnabled\n          printCount\n          printType\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleItemEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateItem(\n    $artistUpdateItemId: ID!\n    $inputs: ArtistUpdateItemInput\n  ) {\n    artistUpdateItem(id: $artistUpdateItemId, inputs: $inputs) {\n      ...ItemSelectBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ConsoleItemEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemEdit").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref4.upload, progress = ref4.progress;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleItemEdit_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId
        }
    }).data;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(viewModel_MUTATION), 2), artistUpdateItem = ref5[0], ref6 = ref5[1], updating = ref6.loading;
    var ref7 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistSubscriptionPlan */.P6C), artistSubscriptionPlanData = ref7.data;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref = artistSubscriptionPlanData.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7;
            return flatten_default()(artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref6 = artistSubscriptionPlanData.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : ref7.products.map(function(product) {
                var monthPlan = product.plans.find(function(plan) {
                    return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month;
                });
                if (monthPlan) {
                    return [
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, monthPlan), {
                            title: product.title
                        })
                    ];
                }
                return product.plans.map(function(plan) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                        title: product.title
                    });
                });
            }));
        }
        if (artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref3 = artistSubscriptionPlanData.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return artistSubscriptionPlanData.artist.subscription.plans;
        }
        return [];
    }, [
        artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref = artistSubscriptionPlanData.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref2 = artistSubscriptionPlanData.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products, 
    ]);
    var currentPlans = (0,react.useMemo)(function() {
        if (data === null || data === void 0 ? void 0 : data.item) {
            var ref;
            // isPremiumがtrueで、purchesablePlanIdsが空の場合は、全てのプランを選択
            if (data.item.isPremium && (!data.item.purchesablePlanIds || ((ref = data.item.purchesablePlanIds) === null || ref === void 0 ? void 0 : ref.length) === 0)) {
                var ref1;
                return plans.map(function(plan) {
                    return (ref1 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref1 !== void 0 ? ref1 : "";
                });
            }
            var _purchesablePlanIds;
            return (_purchesablePlanIds = data.item.purchesablePlanIds) !== null && _purchesablePlanIds !== void 0 ? _purchesablePlanIds : [];
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : data.item,
        plans
    ]);
    var ref8, ref9;
    return {
        state: {
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            item: (ref9 = data === null || data === void 0 ? void 0 : data.item) !== null && ref9 !== void 0 ? ref9 : null,
            plans: plans,
            currentPlans: currentPlans,
            updating: updating,
            progress: progress
        },
        actions: {
            onDrop: /**
       * ファイルアップロード時に呼ばれる処理
       * @param {ItemType} resourceType リソース型
       * @param {boolean} hasCreateResource 更新の際はデフォルトfalse
       */ function onDrop(resourceType) {
                var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource(resourceType).catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, [
                                        utoniq_core_schema/* ItemType.Audio */.qGq.Audio,
                                        utoniq_core_schema/* ItemType.Video */.qGq.Video,
                                        utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine
                                    ].includes(resourceType), true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(param) {
                var hasSku = param.hasSku, description = param.description, paymentType = param.paymentType, price = param.price, title = param.title, issuedNumber = param.issuedNumber, thumbnail = param.thumbnail, thumbnailBack = param.thumbnailBack, purchaseLimitByUser = param.purchaseLimitByUser, resource = param.resource, wallpaperResource = param.wallpaperResource, resaleEnabled = param.resaleEnabled, skuSettings = param.skuSettings, type = param.type, salesStatus = param.salesStatus, salesStartedAt = param.salesStartedAt, salesEndedAt = param.salesEndedAt, metadata = param.metadata, personalInformationRequirements = param.personalInformationRequirements, hideSalesNumber = param.hideSalesNumber, images = param.images, isPremium = param.isPremium, purchesablePlanIds = param.purchesablePlanIds, purchaseLimitPerOrder = param.purchaseLimitPerOrder, isDownloadable = param.isDownloadable, isBothThumbnail = param.isBothThumbnail;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, wallpaperResources, resources, ref2, ref3, ref4, inputtedSkuSettings, falsySkuSettings, personalInformationRequirementsInput;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wallpaperResources = type === "wallpaper" && (wallpaperResource === null || wallpaperResource === void 0 ? void 0 : wallpaperResource.imageUploadPath) ? {
                                    wallpaperResources: {
                                        wallpaperResourcePath: wallpaperResource === null || wallpaperResource === void 0 ? void 0 : wallpaperResource.imageUploadPath
                                    }
                                } : undefined;
                                resources = (resource === null || resource === void 0 ? void 0 : resource.imageUploadPath) ? {
                                    resource: {
                                        tmpPath: resource === null || resource === void 0 ? void 0 : resource.imageUploadPath
                                    }
                                } : undefined;
                                if (type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && !resaleEnabled && metadata) {
                                    set_default()(metadata, "ticket.resalePeriod", undefined);
                                }
                                if (type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && metadata) {
                                    ;
                                    set_default()(metadata, "ticket.throughTicket", getThroughTicket(((ref2 = metadata.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) ? (ref3 = metadata.ticket) === null || ref3 === void 0 ? void 0 : ref3.throughTicket : null));
                                    if ((ref4 = metadata.ticket) === null || ref4 === void 0 ? void 0 : ref4.isThroughTicket) {
                                        set_default()(metadata, "ticket.startDateOfUse", null);
                                        set_default()(metadata, "ticket.endDateOfUse", null);
                                    }
                                }
                                if (type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && (metadata === null || metadata === void 0 ? void 0 : (ref = metadata.ticket) === null || ref === void 0 ? void 0 : ref.startAssignedNumber)) {
                                    set_default()(metadata, "ticket.startAssignedNumber", +metadata.ticket.startAssignedNumber);
                                }
                                inputtedSkuSettings = getSkuSettings(hasSku, issuedNumber, skuSettings);
                                falsySkuSettings = (data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : ref1.skuSettings) ? null : undefined;
                                personalInformationRequirementsInput = undefined;
                                if (type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket) {
                                    switch(personalInformationRequirements){
                                        case personalInformationRequirementsValue.nameAndTel:
                                            personalInformationRequirementsInput = [
                                                utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName,
                                                utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber, 
                                            ];
                                            break;
                                        case personalInformationRequirementsValue.nameAndTelAndAddress:
                                            personalInformationRequirementsInput = [
                                                utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName,
                                                utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber,
                                                utoniq_core_schema/* PersonalInformationType.Address */.APM.Address, 
                                            ];
                                            break;
                                        default:
                                            personalInformationRequirementsInput = [];
                                            break;
                                    }
                                }
                                return [
                                    4,
                                    artistUpdateItem({
                                        variables: {
                                            artistUpdateItemId: router.query.itemId,
                                            inputs: (0,src_object_spread/* default */.Z)({
                                                description: description,
                                                paymentType: paymentType,
                                                price: price,
                                                personalInformationRequirements: personalInformationRequirementsInput,
                                                title: title,
                                                issuedNumber: issuedNumber,
                                                thumbnail: thumbnail,
                                                thumbnailBack: thumbnailBack,
                                                isBothThumbnail: isBothThumbnail,
                                                salesStatus: salesStatus ? utoniq_core_schema/* SalesStatus.Active */.Qsp.Active : utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped,
                                                salesStartedAt: salesStartedAt,
                                                salesEndedAt: salesEndedAt,
                                                purchaseLimitByUser: purchaseLimitByUser,
                                                resaleEnabled: resaleEnabled,
                                                purchaseLimitPerOrder: purchaseLimitPerOrder,
                                                isDownloadable: isDownloadable,
                                                metadata: metadata,
                                                hideSalesNumber: hideSalesNumber,
                                                isPremium: isPremium,
                                                purchesablePlanIds: isPremium ? purchesablePlanIds : [],
                                                skuSettings: inputtedSkuSettings !== null && inputtedSkuSettings !== void 0 ? inputtedSkuSettings : falsySkuSettings,
                                                images: images === null || images === void 0 ? void 0 : images.filter(function(img) {
                                                    return !!img.tmpPath;
                                                })
                                            }, wallpaperResources, resources)
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleItemEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItemEdit_viewModel_templateObject(), utoniq_core_schema/* ItemSelectBoxFragmentDoc */.S9I);
var viewModel_MUTATION = (0,lib/* gql */.Ps)(ConsoleItemEdit_viewModel_templateObject1(), utoniq_core_schema/* ItemSelectBoxFragmentDoc */.S9I);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemEdit/index.tsx






var ConsoleItemEdit = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DndProvider/* DndProvider */.W, {
        backend: react_dnd_html5_backend_dist/* HTML5Backend */.PD,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemEdit_Component, {})
    });
};
/**
 * ConsoleItemEdit Page
 * Implemented as a practical sample.
 */ var ConsoleItemEdit_Component = function() {
    var ref = ConsoleItemEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ItemDescriptionSkeleton/index.tsx



var ItemDescriptionSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 7,
                alignItems: "center",
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 60,
                        height: 90
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        width: 20,
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "50%"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 3,
                            lastWidth: "100%"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ItemDescription/index.tsx







var ItemDescription = function(param) {
    var hiddenSku = param.hiddenSku, item = param.item, number = param.number, user = param.user, showRemaining = param.showRemaining, remainingNumber = param.remainingNumber, isThoughTicket = param.isThoughTicket;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 6,
                    mb: 6
                },
                direction: "row",
                spacing: 6,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "small",
                        src: (ref5 = (ref = item === null || item === void 0 ? void 0 : item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref5 !== void 0 ? ref5 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    (item === null || item === void 0 ? void 0 : item.sku) && !hiddenSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: item.sku.unitName
                                    })
                                ]
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        component: Link/* default */.Z,
                                        href: generatePath(routerPages.UserProfile, {
                                            userId: user.id
                                        }),
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                src: (ref6 = (ref1 = user.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref6 !== void 0 ? ref6 : "",
                                                sx: {
                                                    width: 20,
                                                    height: 20
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                children: user.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                        orientation: "vertical",
                                        flexItem: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("possessionNumber")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                children: number !== null && number !== void 0 ? number : "∞"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isThoughTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "white",
                                    children: t("throughTicket", "通し券")
                                }),
                                sx: {
                                    bgcolor: "secondary.main",
                                    p: 1,
                                    height: 20,
                                    ".MuiChip-label": {
                                        px: 0
                                    }
                                }
                            })
                        ]
                    })
                ]
            }),
            !(item === null || item === void 0 ? void 0 : item.hideSalesNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemAsset, {
                user: user,
                item: item,
                showRemaining: showRemaining,
                remainingNumber: remainingNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: (ref7 = item === null || item === void 0 ? void 0 : item.description) !== null && ref7 !== void 0 ? ref7 : item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.description
                })
            })
        ]
    });
};
var ItemAsset = function(param) {
    var user = param.user, item = param.item, showRemaining = param.showRemaining, remainingNumber = param.remainingNumber;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var itemIcon = (0,react.useMemo)(function() {
        switch(item === null || item === void 0 ? void 0 : item.type){
            case utoniq_core_schema/* ItemType.Audio */.qGq.Audio:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Audio, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Video */.qGq.Video:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Video, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Magazine, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Merch */.qGq.Merch:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Merch, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Wallpaper, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Ticket, {
                    fontSize: "xSmall"
                });
            default:
                return null;
        }
    }, [
        item === null || item === void 0 ? void 0 : item.type
    ]);
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 3,
        alignItems: "center",
        children: [
            (item === null || item === void 0 ? void 0 : item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("rarity")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    (item === null || item === void 0 ? void 0 : (ref = item.rarityIconImage) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        variant: "square",
                                        src: item === null || item === void 0 ? void 0 : item.rarityIconImage.smallUri,
                                        sx: {
                                            height: 12,
                                            width: 12
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: (item === null || item === void 0 ? void 0 : (ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.name) ? t(item.rarity.name) : "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                        orientation: "vertical",
                        flexItem: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.hint",
                        children: t("remainingQuantityPerTotal")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: [
                            showRemaining ? "".concat(remainingNumber, "/") : "".concat((item === null || item === void 0 ? void 0 : item.issuedNumber) ? (item === null || item === void 0 ? void 0 : item.issuedNumber) - ((ref5 = item === null || item === void 0 ? void 0 : item.itemObtainedCount) !== null && ref5 !== void 0 ? ref5 : 0) : "∞", "/"),
                            (ref6 = item === null || item === void 0 ? void 0 : item.issuedNumber) !== null && ref6 !== void 0 ? ref6 : "∞"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                orientation: "vertical",
                flexItem: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.hint",
                        children: t("type")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            itemIcon,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t((ref7 = item === null || item === void 0 ? void 0 : item.type) !== null && ref7 !== void 0 ? ref7 : "")
                            })
                        ]
                    })
                ]
            }),
            !!(item === null || item === void 0 ? void 0 : (ref2 = item.purchasableUsers) === null || ref2 === void 0 ? void 0 : ref2.length) && ((ref3 = item.issuedArtist) === null || ref3 === void 0 ? void 0 : ref3.id) === (user === null || user === void 0 ? void 0 : user.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                        orientation: "vertical",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("whoCanPurchase", "購入可能者")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "subtitle2",
                                href: generatePath(routerPages.ConsoleItemInformationLimitUser, {
                                    itemId: item.id
                                }),
                                children: t("specified", "指定あり")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformation/template/index.tsx











var ConsoleItemInformationTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var ref16 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref16.routerNames, routerPages = ref16.routerPages, generatePath = ref16.generatePath;
    var ref17, ref18;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                title: t("title"),
                back: true,
                defaultBackPage: generatePath(routerPages.ConsoleItemDetail, {
                    itemId: state.itemId
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        pt: 3,
                        px: 5
                    },
                    children: state.loading || !state.item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescriptionSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        in: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                            hiddenSku: true,
                            showRemaining: true,
                            remainingNumber: (ref = state.item) === null || ref === void 0 ? void 0 : ref.formattedRemainingNumber,
                            item: state.item,
                            user: null,
                            isThoughTicket: !!((ref1 = state.item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket)
                        })
                    })
                }),
                ((ref3 = state.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.note) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    sx: {
                        my: 4,
                        px: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.600"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    color: "text.secondary",
                                    children: t("ticketNote")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: (ref6 = state.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.metadata) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.ticket) === null || ref8 === void 0 ? void 0 : ref8.note
                        })
                    ]
                }),
                ((ref9 = state.item) === null || ref9 === void 0 ? void 0 : ref9.skuSettings) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuListCell, {
                    loading: state.loading,
                    skuSettings: (ref10 = state.item) === null || ref10 === void 0 ? void 0 : ref10.skuSettings,
                    defaultThumbnailUri: (ref17 = (ref12 = (ref11 = state.item) === null || ref11 === void 0 ? void 0 : ref11.thumbnail.front) === null || ref12 === void 0 ? void 0 : ref12.mediumUri) !== null && ref17 !== void 0 ? ref17 : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SerialOwnersCell, {
                    itemId: state.itemId,
                    itemSerials: (ref18 = (ref13 = state.item) === null || ref13 === void 0 ? void 0 : ref13.serials) !== null && ref18 !== void 0 ? ref18 : null,
                    onFetchMore: onFetchMore,
                    showSku: !!((ref14 = state.item) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.skuSettings) === null || ref15 === void 0 ? void 0 : ref15.units.length),
                    hasNextPage: state.hasNextPage,
                    loading: state.loading || state.fetching
                })
            ]
        })
    });
};
var SkuListCell = function(param) {
    var loading = param.loading, skuSettings = param.skuSettings, defaultThumbnailUri = param.defaultThumbnailUri;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemInformation").t;
    var _length;
    var unitLength = (_length = skuSettings === null || skuSettings === void 0 ? void 0 : skuSettings.units.length) !== null && _length !== void 0 ? _length : 0;
    var ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.secondary",
                sx: {
                    py: 2,
                    px: 5
                },
                children: t("skuLabel", {
                    length: unitLength > 0 ? "（".concat(unitLength, "）") : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pb: 2,
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                py: 2,
                                                px: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: t("skuName", "SKU値")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                width: 100,
                                                py: 2,
                                                px: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: t("inventory", "残り数量/全数量")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                width: 80,
                                                py: 2,
                                                px: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: t("thumbnailImage", "サムネイル画像")
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                                children: [
                                    loading && !(skuSettings === null || skuSettings === void 0 ? void 0 : skuSettings.units) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "small",
                                                    width: 80
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "small",
                                                    width: 40
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                    variant: "rectangular",
                                                    sx: {
                                                        width: 48,
                                                        height: 76
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    !loading && (skuSettings === null || skuSettings === void 0 ? void 0 : (ref = skuSettings.units) === null || ref === void 0 ? void 0 : ref.map(function(unit) {
                                        var ref, ref5, ref6;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: unit.unitName
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: [
                                                            unit.remainingNumber,
                                                            "/",
                                                            unit.stock
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        variant: "square",
                                                        src: (ref4 = (ref3 = (ref2 = (ref1 = (ref = unit.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : (ref5 = unit.thumbnail) === null || ref5 === void 0 ? void 0 : ref5.mediumUri) !== null && ref2 !== void 0 ? ref2 : (ref6 = unit.thumbnail) === null || ref6 === void 0 ? void 0 : ref6.uri) !== null && ref3 !== void 0 ? ref3 : defaultThumbnailUri) !== null && ref4 !== void 0 ? ref4 : "",
                                                        sx: {
                                                            width: 48,
                                                            height: 76
                                                        }
                                                    })
                                                })
                                            ]
                                        }, unit.id);
                                    }))
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var SerialOwnersCell = function(param) {
    var itemId = param.itemId, showSku = param.showSku, loading = param.loading, hasNextPage = param.hasNextPage, itemSerials = param.itemSerials, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var ref2;
    var serials = (ref2 = itemSerials === null || itemSerials === void 0 ? void 0 : (ref = itemSerials.edges) === null || ref === void 0 ? void 0 : ref.map(function(edge) {
        return edge;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    if (!(serials === null || serials === void 0 ? void 0 : serials.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                sx: {
                    py: 2,
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("ownerList")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "subtitle1",
                        href: generatePath(routerPages.ConsoleItemInformationLimitUser, {
                            itemId: itemId
                        }),
                        children: t("availablePurchasers", "購入可能者一覧を見る")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        "aria-label": "serial-number-table",
                        sx: {
                            width: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                minWidth: 84,
                                                py: 2,
                                                px: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: t("serialNumber")
                                            })
                                        }),
                                        showSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                minWidth: 100,
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("sku")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                minWidth: 100,
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("acquisitionDate")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            width: "100%",
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("owner")
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                                loading: loading,
                                hasNextPage: hasNextPage,
                                onFetchMore: onFetchMore,
                                component: TableRow/* default */.Z,
                                colSpan: 3,
                                nodes: serials === null || serials === void 0 ? void 0 : serials.map(function(serial) {
                                    var ref, ref1, ref2, ref3;
                                    var serialUser = serial.node.user;
                                    var isNft = isUserItemSerial(serial) ? !!serial.isNft : !!serial.node.isNft;
                                    var ref4;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    pl: 5,
                                                    pr: 0,
                                                    border: "none",
                                                    bgcolor: isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    sx: {
                                                        pr: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SerialNumber, {
                                                            label: serial.node.formattedSerialNumber
                                                        }),
                                                        isNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                                                            fontSize: "small",
                                                            filledColor: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            showSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0,
                                                    border: "none",
                                                    bgcolor: isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                            orientation: "vertical",
                                                            flexItem: true,
                                                            sx: {
                                                                height: 20
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle2",
                                                            children: (ref = serial.node.sku) === null || ref === void 0 ? void 0 : ref.unitName
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0,
                                                    border: "none",
                                                    bgcolor: isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                            orientation: "vertical",
                                                            flexItem: true,
                                                            sx: {
                                                                height: 20
                                                            }
                                                        }),
                                                        serialUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            children: (ref1 = serial.node) === null || ref1 === void 0 ? void 0 : ref1.formattedObtainedDate
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    pl: 0,
                                                    pr: 5,
                                                    border: "none",
                                                    bgcolor: isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                                orientation: "vertical",
                                                                flexItem: true,
                                                                sx: {
                                                                    height: 20
                                                                }
                                                            })
                                                        }),
                                                        serialUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            component: Link/* default */.Z,
                                                            underline: "none",
                                                            href: generatePath(routerPages.ConsoleUserDetail, {
                                                                userId: serialUser.id
                                                            }),
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                    src: (ref4 = (ref2 = serialUser.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                                                                    sx: {
                                                                        width: 28,
                                                                        height: 28
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "overline",
                                                                    children: (ref3 = serial.node.user) === null || ref3 === void 0 ? void 0 : ref3.displayName
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }),
                                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        colSpan: 3,
                                        sx: {
                                            border: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            spacing: 3,
                                            sx: {
                                                px: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large",
                                                numberOfLine: 8,
                                                lastWidth: "100%"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
function isUserItemSerial(serial) {
    return "serialId" in serial;
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformation/viewModel.ts



function ConsoleItemInformation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItemInformation(\n    $id: ID!\n    $userId: ID\n    $pageInput: PageInput\n    $skuId: String\n  ) {\n    item(id: $id) {\n      ...ItemDescription\n      serials(pageInput: $pageInput) {\n        ...ConsoleSerialItemOwners\n      }\n      itemObtainedCount\n    }\n    user(id: $userId) {\n      ...UserInfo\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleItemInformation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ConsoleItemInformation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var itemId = router.query.itemId;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleItemInformation_viewModel_QUERY, {
        variables: {
            id: itemId,
            userId: user === null || user === void 0 ? void 0 : user.uid
        }
    }), data = ref3.data, fetchMore = ref3.fetchMore, networkStatus = ref3.networkStatus;
    var ref4, ref5, ref6;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            itemId: router.query.itemId,
            userId: user === null || user === void 0 ? void 0 : user.uid,
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            user: (ref5 = data === null || data === void 0 ? void 0 : data.user) !== null && ref5 !== void 0 ? ref5 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            item: (ref6 = data === null || data === void 0 ? void 0 : data.item) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: itemId,
                                            userId: user === null || user === void 0 ? void 0 : user.uid,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleItemInformation_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItemInformation_viewModel_templateObject(), utoniq_core_schema/* ItemDescriptionFragmentDoc */.A1h, utoniq_core_schema/* ConsoleSerialItemOwnersFragmentDoc */.IO_, utoniq_core_schema/* UserInfoFragmentDoc */.IWz);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformation/index.tsx




var ConsoleItemInformation = function() {
    var ref = ConsoleItemInformation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemInformationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformationLimitUser/template/index.tsx









var ConsoleItemInformationLimitUserTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemInformationLimitUser").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath, router = ref2.router;
    var _itemId, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: generatePath(routerPages.ConsoleItemInformation, {
                    itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
                }),
                title: t("title")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    sx: {
                        py: 2
                    },
                    children: state.loading && !state.purchasableUsers ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "20%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "10%"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: t("whoCanPurchase", "購入可能者")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: [
                                    (ref3 = (ref = state.purchasableUsers) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 0,
                                    t("person")
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    sx: {
                        py: 2
                    },
                    children: state.loading && !state.purchasableUsers ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "60%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "20%"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("whoCanPurchase", "購入可能者")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("numberPurchase", "購入数 / 購入可能枚数")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref1 = state.purchasableUsers) === null || ref1 === void 0 ? void 0 : ref1.map(function(purchasableUser) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberCell, {
                            purchasableUser: purchasableUser
                        }, purchasableUser.userId);
                    }),
                    componentProps: {
                        spacing: 0
                    },
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: Array.from(Array(8).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberSkeleton, {}, key);
                        })
                    })
                })
            ]
        })
    });
};
var ref, ref1;
var MemberCell = function(param) {
    var purchasableUser = param.purchasableUser;
    var ref2, ref3, ref4, ref5, ref6;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref1 = (ref = (ref2 = purchasableUser.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.avatar) === null || ref3 === void 0 ? void 0 : ref3.smallUri) !== null && ref !== void 0 ? ref : (ref4 = purchasableUser.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.avatar) === null || ref5 === void 0 ? void 0 : ref5.uri) !== null && ref1 !== void 0 ? ref1 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: (ref6 = purchasableUser.user) === null || ref6 === void 0 ? void 0 : ref6.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        children: [
                            purchasableUser.purchasedCount,
                            "/",
                            purchasableUser.purchasableCount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
        ]
    });
};
var MemberSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "20%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "subtitle1",
                        width: "10%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformationLimitUser/viewModel.ts



function ConsoleItemInformationLimitUser_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItemInformationLimitUser($id: ID!) {\n    item(id: $id) {\n      id\n      purchasableUsers {\n        ...PurchasableUserDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemInformationLimitUser_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ConsoleItemInformationLimitUser_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleItemInformationLimitUser_viewModel_QUERY, {
        variables: {
            id: router.query.itemId
        }
    }), data = ref1.data, loading = ref1.loading;
    var ref2, ref3;
    return {
        state: {
            loading: loading,
            purchasableUsers: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.purchasableUsers) !== null && ref2 !== void 0 ? ref2 : null,
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            hasNextPage: false
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var ConsoleItemInformationLimitUser_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItemInformationLimitUser_viewModel_templateObject(), utoniq_core_schema/* PurchasableUserDetailFragmentDoc */.NuA);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemInformationLimitUser/index.tsx




var ConsoleItemInformationLimitUser = function() {
    var ref = ConsoleItemInformationLimitUser_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemInformationLimitUserTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/OrderedItemBox/index.tsx






var OrderedItemBox = function(param) {
    var orderItem = param.orderItem;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemOrders").t;
    var ref11, _prepaidPoint, _purchaseNumber, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2
        },
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                src: (ref11 = (ref1 = (ref = orderItem.item) === null || ref === void 0 ? void 0 : ref.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref11 !== void 0 ? ref11 : "",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                children: (ref2 = orderItem.item) === null || ref2 === void 0 ? void 0 : ref2.title
                                            }),
                                            !!((ref3 = orderItem.serials) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sku) === null || ref5 === void 0 ? void 0 : ref5.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: (ref6 = orderItem.serials) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sku) === null || ref8 === void 0 ? void 0 : ref8.unitName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                direction: "row",
                                                alignItems: "center",
                                                children: !isNaN((_prepaidPoint = orderItem.prepaidPoint) !== null && _prepaidPoint !== void 0 ? _prepaidPoint : NaN) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                            variant: "h2",
                                                            children: orderItem.prepaidPoint
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                                    variant: "h2",
                                                    children: [
                                                        "\xa5 ",
                                                        orderItem.price
                                                    ]
                                                })
                                            }),
                                            !!orderItem.purchaseNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.hint",
                                                    children: t("quantity", {
                                                        number: (_purchaseNumber = orderItem.purchaseNumber) !== null && _purchaseNumber !== void 0 ? _purchaseNumber : 0
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref12 = (ref9 = orderItem.user) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.avatar) === null || ref10 === void 0 ? void 0 : ref10.smallUri) !== null && ref12 !== void 0 ? ref12 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: orderItem.formattedCreatedAt
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/OrderedItemBoxSkeleton/index.tsx



var OrderedItemBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium",
                                                width: "100%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium",
                                                width: "75%"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large",
                                                width: "30%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small",
                                                width: "45%"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "40%"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemOrders/template/index.tsx









var ConsoleItemOrdersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItemOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleItemOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleItems,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pt: 5,
                        pb: 6
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: state === null || state === void 0 ? void 0 : (ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderedItemBox, {
                                orderItem: node
                            }, node.id);
                        }),
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        emptyMessage: t("emptyData"),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            sx: {
                                pb: 2
                            },
                            children: Array.from(Array(4).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderedItemBoxSkeleton, {}, key);
                            })
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemOrders/viewModel.ts



function ConsoleItemOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItemOrders($pageInput: PageInputDate) {\n    organizationArtistItemOrders(pageInput: $pageInput) {\n      ...ArtistItemOrdersConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItemOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ConsoleItemOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleItemOrders_viewModel_QUERY), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2, ref3;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            currentUser: user,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.organizationArtistItemOrders) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            items: (ref3 = data === null || data === void 0 ? void 0 : data.organizationArtistItemOrders) !== null && ref3 !== void 0 ? ref3 : null,
            loading: loading
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.organizationArtistItemOrders) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleItemOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItemOrders_viewModel_templateObject(), utoniq_core_schema/* ArtistItemOrdersConnectionFragmentDoc */.MOb);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItemOrders/index.tsx




/**
 * ConsoleItemOrders Page
 * Implemented as a practical sample.
 */ var ConsoleItemOrders = function() {
    var ref = ConsoleItemOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemOrdersTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItems/viewModel.ts




function ConsoleItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleItems($filters: ArtistItemsFilterInput, $pageInput: PageInput) {\n    artistItems(filters: $filters, pageInput: $pageInput) {\n      ...ConsoleItemsConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleItems_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PublishItem($id: ID!) {\n    publishItem(id: $id) {\n      id\n      isPublished\n    }\n  }\n"
    ]);
    ConsoleItems_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleItems_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnpublishItem($id: ID!) {\n    unpublishItem(id: $id) {\n      id\n      isPublished\n    }\n  }\n"
    ]);
    ConsoleItems_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleItems_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation StartSellingItem($id: ID!) {\n    startSellingItem(id: $id) {\n      id\n      salesStatus\n    }\n  }\n"
    ]);
    ConsoleItems_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConsoleItems_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation StopSellingItem($id: ID!) {\n    stopSellingItem(id: $id) {\n      id\n      salesStatus\n    }\n  }\n"
    ]);
    ConsoleItems_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ConsoleItems_viewModel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistRemoveItem($id: ID!) {\n    artistRemoveItem(id: $id) {\n      id\n    }\n  }\n"
    ]);
    ConsoleItems_viewModel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var ConsoleItems_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleItems").t;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref4.showError, showMessage = ref4.showMessage;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref5 = (0,useQuery/* useQuery */.aM)(ConsoleItems_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, fetchMore = ref5.fetchMore, loading = ref5.loading, refetch = ref5.refetch;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PUBLIC_ITEM), 1), publishItem = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNPUBLIC_ITEM), 1), unpublishItem = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(START_SELLING_ITEM), 1), startSellingItem = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(STOP_SELLING_ITEM), 1), stopSellingItem = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_REMOVE_ITEM), 1), artistRemoveItem = ref10[0];
    var ref11, ref12, ref13, ref14;
    return {
        state: {
            user: user,
            items: (ref11 = data === null || data === void 0 ? void 0 : data.artistItems) !== null && ref11 !== void 0 ? ref11 : null,
            loading: loading,
            artist: (ref12 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref12 !== void 0 ? ref12 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistItems) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
            artistId: (ref13 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref13 !== void 0 ? ref13 : "",
            membership: (ref14 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products) !== null && ref14 !== void 0 ? ref14 : undefined
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilter: function onFilter(filter) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        refetch({
                            filters: {
                                type: filter === "general" ? null : filter
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onRemove: function onRemove(id) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistRemoveItem({
                                        variables: {
                                            id: id
                                        }
                                    }).then(function() {
                                        showMessage(t("deletedItem"), "success");
                                    }).catch(function(error) {
                                        return showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSearch: function onSearch(searchTerm) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        refetch({
                            filters: {
                                searchTerm: searchTerm
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onToggleActive: function onToggleActive(id, isActive) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isActive) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unpublishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                unpublishItem: {
                                                    id: id,
                                                    isPublished: false,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    publishItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                publishItem: {
                                                    id: id,
                                                    isPublished: true,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onToggleSelling: function onToggleSelling(id, isSelling) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isSelling) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    stopSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                stopSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Stopped */.Qsp.Stopped,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    startSellingItem({
                                        variables: {
                                            id: id
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                startSellingItem: {
                                                    id: id,
                                                    salesStatus: utoniq_core_schema/* SalesStatus.Active */.Qsp.Active,
                                                    __typename: "Item"
                                                }
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};
var ConsoleItems_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject(), utoniq_core_schema/* ConsoleItemsConnectionFragmentDoc */.p6K);
var PUBLIC_ITEM = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject1());
var UNPUBLIC_ITEM = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject2());
var START_SELLING_ITEM = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject3());
var STOP_SELLING_ITEM = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject4());
var ARTIST_REMOVE_ITEM = (0,lib/* gql */.Ps)(ConsoleItems_viewModel_templateObject5());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleItems/index.tsx




/**
 * ConsoleItems Page
 * Implemented as a practical sample.
 */ var ConsoleItems = function() {
    var ref = ConsoleItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleItemsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(46782);
// EXTERNAL MODULE: ../../node_modules/@capacitor/app/dist/esm/index.js
var app_dist_esm = __webpack_require__(68339);
// EXTERNAL MODULE: ../../node_modules/@capacitor/filesystem/dist/esm/index.js
var filesystem_dist_esm = __webpack_require__(22263);
// EXTERNAL MODULE: ../../node_modules/@capacitor-community/media/dist/esm/index.js
var media_dist_esm = __webpack_require__(25953);
;// CONCATENATED MODULE: ./src/core/native/filesystem/index.ts








var filesystem_requestPermissions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var permission, publicStorage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (core_dist/* Capacitor.getPlatform */.dV.getPlatform() === "web") {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        4,
                        filesystem_dist_esm/* Filesystem.checkPermissions */.fy.checkPermissions()
                    ];
                case 1:
                    permission = _state.sent();
                    if (permission.publicStorage === "granted") return [
                        2,
                        true
                    ];
                    if (permission.publicStorage === "denied") throw Error("storageDeniedError");
                    return [
                        4,
                        filesystem_dist_esm/* Filesystem.requestPermissions */.fy.requestPermissions()
                    ];
                case 2:
                    publicStorage = _state.sent().publicStorage;
                    return [
                        2,
                        publicStorage === "granted"
                    ];
            }
        });
    });
    return function requestPermissions() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description save file (only support for mobile)
 * @param {WriteFileOptions} options
 */ var writeFile = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        filesystem_requestPermissions()
                    ];
                case 1:
                    if (!_state.sent()) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        filesystem_dist_esm/* Filesystem.writeFile */.fy.writeFile((0,src_object_spread/* default */.Z)({
                            directory: filesystem_dist_esm/* Directory.Documents */.tP.Documents,
                            encoding: filesystem_dist_esm/* Encoding.UTF8 */.ez.UTF8
                        }, options))
                    ];
            }
        });
    });
    return function writeFile(options) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description 画像をデバイスに保存する
 * @param option MediaSaveOptions
 */ var downloadImageUrl = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        filesystem_requestPermissions()
                    ];
                case 1:
                    if (!_state.sent()) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        media_dist_esm/* Media.savePhoto */.p.savePhoto(options)
                    ];
            }
        });
    });
    return function downloadImageUrl(options) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * メディアが保存されるアルバムがなければ作成する
 * Androidの場合、Albumのidentifierが必須となる
 * @param name アルバム名
 */ var createAlbum = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(name) {
        var ref, albumName, _tmp, albums, album, newAlbums;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0,native_app/* getPlatform */.Xf)() !== "android") {
                        return [
                            2,
                            undefined
                        ];
                    }
                    if (!(name !== null && name !== void 0)) return [
                        3,
                        1
                    ];
                    _tmp = name;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        app_dist_esm/* App.getInfo */.g.getInfo()
                    ];
                case 2:
                    _tmp = _state.sent().name;
                    _state.label = 3;
                case 3:
                    albumName = _tmp;
                    return [
                        4,
                        media_dist_esm/* Media.getAlbums */.p.getAlbums()
                    ];
                case 4:
                    albums = _state.sent();
                    album = albums.albums.find(function(a) {
                        return a.name === albumName;
                    });
                    if (album) {
                        // すでに作成済みの場合
                        return [
                            2,
                            album.identifier
                        ];
                    }
                    // なければアルバム作成
                    return [
                        4,
                        media_dist_esm/* Media.createAlbum */.p.createAlbum({
                            name: albumName
                        })
                    ];
                case 5:
                    _state.sent();
                    return [
                        4,
                        media_dist_esm/* Media.getAlbums */.p.getAlbums()
                    ];
                case 6:
                    newAlbums = _state.sent();
                    return [
                        2,
                        (ref = newAlbums.albums.find(function(a) {
                            return a.name === albumName;
                        })) === null || ref === void 0 ? void 0 : ref.identifier
                    ];
            }
        });
    });
    return function createAlbum(name) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/lib/downloadFile/index.ts







/**
 * @description hook for download file
 * @returns {downloadCsv} use for download csv file
 */ var useDownloadFile = function() {
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    /**
   * @param {string} url
   */ var downloadCsv = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url) {
            var isWindows, filename, result, data, bom, blob, result1, data1, writeFileResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isWindows = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem.includes("windows");
                        filename = getFilename(url, "".concat(Date.now(), ".csv"));
                        if (!((0,native_app/* getPlatform */.Xf)() === "web")) return [
                            3,
                            4
                        ];
                        if (!isWindows) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            fetch(url)
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            4,
                            result.blob()
                        ];
                    case 2:
                        data = _state.sent();
                        bom = new Uint8Array([
                            0xef,
                            0xbb,
                            0xbf
                        ]);
                        blob = new Blob([
                            bom,
                            data
                        ], {
                            type: "text/csv"
                        });
                        return [
                            2,
                            (0,FileSaver_min.saveAs)(blob, filename)
                        ];
                    case 3:
                        return [
                            2,
                            (0,FileSaver_min.saveAs)(url, filename)
                        ];
                    case 4:
                        return [
                            4,
                            fetch(url)
                        ];
                    case 5:
                        result1 = _state.sent();
                        return [
                            4,
                            result1.text()
                        ];
                    case 6:
                        data1 = _state.sent();
                        return [
                            4,
                            writeFile({
                                data: data1,
                                path: filename
                            }).catch(function(error) {
                                //translate error message
                                throw new Error(t(error.message));
                            })
                        ];
                    case 7:
                        writeFileResult = _state.sent();
                        if (!(writeFileResult === null || writeFileResult === void 0 ? void 0 : writeFileResult.uri)) {
                            throw Error(t("fileNotSaved"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadCsv(url) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        downloadCsv: downloadCsv
    };
};
/**
 * @description 画像ダウンロードフック
 * @returns {downloadImage} 画像ダウンロード関数
 */ var useDownlodImage = function() {
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var downloadImage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url) {
            var fileName, albumIdentifier;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fileName = getFilename(url, "".concat(Date.now()));
                        if ((0,native_app/* getPlatform */.Xf)() === "web") {
                            return [
                                2,
                                (0,FileSaver_min.saveAs)(url, fileName)
                            ];
                        }
                        return [
                            4,
                            createAlbum()
                        ];
                    case 1:
                        albumIdentifier = _state.sent();
                        return [
                            4,
                            downloadImageUrl({
                                path: url,
                                fileName: fileName,
                                albumIdentifier: albumIdentifier
                            }).catch(function(error) {
                                throw new Error(t(error.message));
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadImage(url) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        downloadImage: downloadImage
    };
};
/**
 * get filename from url
 * @param {string} url
 * @param {string} defaultName
 */ function getFilename(url, defaultName) {
    var pathname = new URL(url).pathname;
    var ref;
    return (ref = pathname.split("/").pop()) !== null && ref !== void 0 ? ref : defaultName;
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryCsvUpload/template/index.tsx















var ConsoleLotteryCsvUploadTemplate = function(param) {
    var state = param.state, onDrop = param.onDrop, onRemoveCsvFile = param.onRemoveCsvFile, onUpdateLotteryResultFromCsv = param.onUpdateLotteryResultFromCsv;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var _preSaleId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: generatePath(routerPages.ConsoleLotteryManagements, {
                    preSaleId: (_preSaleId = router.query.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
                }),
                title: (ref = state.preSale) === null || ref === void 0 ? void 0 : ref.title
            },
            customNavigation: state.csvData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_FixedBottomCell, {
                winCount: state.csvData.length,
                onUpdateLotteryResultFromCsv: onUpdateLotteryResultFromCsv,
                submitting: state.submitting
            }) : null,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleLotteryCsvUpload_template_HeadingTextCell, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadCsvCell, {
                    applicantsCsvUrl: state.applicantsCsvUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadCsvCell, {
                    csvData: state.csvData,
                    csvUploadInfo: {
                        onDrop: onDrop,
                        progress: state.progress
                    },
                    onRemoveCsvFile: onRemoveCsvFile
                })
            ]
        })
    });
};
var ConsoleLotteryCsvUpload_template_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                pb: 2,
                children: t("bulkRegistrationTitle", "当選者の一括登録")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: t("bulkRegistrationDesc")
            })
        ]
    });
};
var DownloadCsvCell = function(param) {
    var applicantsCsvUrl = param.applicantsCsvUrl;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    var downloadCsv = useDownloadFile().downloadCsv;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 2,
                    pt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {},
                    children: t("downloadCsvLabel")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    pt: 4,
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    disabled: !applicantsCsvUrl,
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Download, {
                        sx: {
                            color: "grey.700"
                        }
                    }),
                    onClick: function() {
                        downloadCsv(applicantsCsvUrl || "").then(function() {
                            return showMessage(t("downloadCsvComplete"), "success");
                        }).catch(showError);
                    },
                    children: t("downloadButton", "ダウンロード")
                })
            })
        ]
    });
};
var UploadCsvCell = function(param) {
    var csvUploadInfo = param.csvUploadInfo, csvData = param.csvData, onRemoveCsvFile = param.onRemoveCsvFile;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(undefined), resource = ref1[0], setResource = ref1[1];
    var ref2 = (0,react.useState)(false), openTrashConfirm = ref2[0], setOpenTrashConfirm = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 2,
                    pt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {},
                    children: t("uploadCsvLabel", "2.更新した応募者リストをアップロード")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 4
                },
                children: [
                    resource && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("uploadCsvNote")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                        t: t,
                        sx: {
                            p: 0
                        },
                        resource: resource,
                        fileUploadInfo: {
                            type: "csv",
                            onDrop: function onDrop() {
                                return csvUploadInfo.onDrop().then(function() {
                                    var _ref = (0,src_async_to_generator/* default */.Z)(function(resource) {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if (!resource) {
                                                return [
                                                    2
                                                ];
                                            }
                                            setResource(resource);
                                            return [
                                                2,
                                                resource
                                            ];
                                        });
                                    });
                                    return function(resource) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            },
                            progress: csvUploadInfo.progress || 0,
                            description: t("csvUploaderDescription"),
                            onConfirmClose: function onConfirmClose() {
                                setOpenTrashConfirm(true);
                            },
                            onClose: function onClose() {}
                        },
                        content: {
                            title: ""
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PotentialWinnersCell, {
                csvData: csvData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openTrashConfirm,
                onClose: function() {
                    return setOpenTrashConfirm(false);
                },
                title: t("trashConfirmTitle"),
                content: t("trashConfirmDesc"),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onRemoveCsvFile().then(function() {
                                            showMessage(t("removeSuccess"), "success");
                                            setResource(undefined);
                                            setOpenTrashConfirm(false);
                                        }).catch(showError)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("delete", "削除する")
                })
            })
        ]
    });
};
var columns = [
    {
        key: "fullName",
        width: 100
    },
    {
        key: "win",
        width: 60
    },
    {
        key: "itemTitle",
        width: 150
    },
    {
        key: "purchaseCount",
        width: 60
    },
    {
        key: "paymentMethod",
        width: 130
    },
    {
        key: "appliedAt",
        width: 150
    }, 
];
var PotentialWinnersCell = function(param) {
    var csvData = param.csvData;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    var renderText = (0,react.useCallback)(function(key, value) {
        if (key === "win") {
            return t("choiceText", {
                number: value
            });
        }
        if (key === "paymentMethod") {
            return t(value);
        }
        return value;
    }, [
        t
    ]);
    if (!csvData.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                sx: {
                    py: 2
                },
                children: t("potentialWinner", {
                    number: csvData.length
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    sx: {
                        width: "auto",
                        ovrerflowX: "scroll"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                children: columns.map(function(col) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            minWidth: col.width,
                                            py: 2,
                                            px: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.hint",
                                            sx: {
                                                display: "block"
                                            },
                                            children: t(col.key)
                                        })
                                    });
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                            loading: false,
                            hasNextPage: false,
                            onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2
                                    ];
                                });
                            }),
                            component: TableRow/* default */.Z,
                            colSpan: columns.length,
                            nodes: csvData.map(function(data, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: columns.map(function(col) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                py: 2,
                                                pl: 0,
                                                pr: 1,
                                                width: col.width
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                sx: {
                                                    minWidth: 0,
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    sx: (0,src_object_spread/* default */.Z)({
                                                        width: col.width
                                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                    children: renderText(col.key, data[col.key])
                                                })
                                            })
                                        }, col.key);
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var template_FixedBottomCell = function(param) {
    var winCount = param.winCount, submitting = param.submitting, onUpdateLotteryResultFromCsv = param.onUpdateLotteryResultFromCsv;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 4,
                    bgcolor: "grey.50",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 244
                    },
                    onClick: function() {
                        return setOpenConfirm(true);
                    },
                    children: t("confirm")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirmTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        pb: 7
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            align: "left",
                            children: t("confirmDesc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            align: "left",
                            children: t("peopleWin", {
                                number: winCount
                            })
                        })
                    ]
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            onUpdateLotteryResultFromCsv().finally(function() {
                                setOpenConfirm(false);
                            });
                            return [
                                2
                            ];
                        });
                    }),
                    loading: submitting,
                    children: t("confirm", "確定する")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/papaparse/papaparse.min.js
var papaparse_min = __webpack_require__(90286);
var papaparse_min_default = /*#__PURE__*/__webpack_require__.n(papaparse_min);
;// CONCATENATED MODULE: ./src/lib/papaparse/index.ts

/**
 * parse csv from url
 * @param {string} fileUrl
 */ function parseCsvFromUrl(fileUrl) {
    return new Promise(function(resolve, reject) {
        return papaparse_min_default().parse(fileUrl, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function complete(results) {
                resolve(results);
            },
            error: function error(error1) {
                reject(error1);
            }
        });
    });
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryCsvUpload/viewModel.ts




function ConsoleLotteryCsvUpload_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleLotteryCsv($preSaleId: ID!, $preSaleIdString: String!) {\n    artistPreSale(id: $preSaleId) {\n      ...ConsolePreSaleTitle\n    }\n    exportPreSaleApplicants(preSaleId: $preSaleIdString) {\n      ...ExportPreSaleApplicants\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleLotteryCsvUpload_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleLotteryCsvUpload_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updatePreSaleLotteryResultFromCsv(\n    $inputs: UpdatePreSaleLotteryResultFromCsvInput!\n  ) {\n    updatePreSaleLotteryResultFromCsv(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ConsoleLotteryCsvUpload_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









/**
 *
 */ var ConsoleLotteryCsvUpload_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,core_i18n/* useTranslation */.$G)(), tCommon = ref.t;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryCsvUpload").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var ref2 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref2.upload, progress = ref2.progress;
    var ref3 = (0,react.useState)([]), csvData = ref3[0], setCsvData = ref3[1];
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, routerPages = ref4.routerPages, generatePath = ref4.generatePath;
    var ref5 = (0,react.useState)(""), csvPath = ref5[0], setCsvPath = ref5[1];
    var data = (0,useQuery/* useQuery */.aM)(ConsoleLotteryCsvUpload_viewModel_QUERY, {
        variables: {
            preSaleId: router.query.preSaleId,
            preSaleIdString: router.query.preSaleId
        }
    }).data;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_PRESALE_LOTTERY_RESULT_FROM_CSV), 2), updatePreSaleLotteryResultFromCsv = ref6[0], ref7 = ref6[1], submitting = ref7.loading;
    var ref8, _csvUrl, ref9;
    return {
        state: {
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            csvData: csvData,
            progress: progress,
            applicantsCsvUrl: (_csvUrl = data === null || data === void 0 ? void 0 : data.exportPreSaleApplicants.csvUrl) !== null && _csvUrl !== void 0 ? _csvUrl : null,
            preSale: (ref9 = data === null || data === void 0 ? void 0 : data.artistPreSale) !== null && ref9 !== void 0 ? ref9 : null,
            submitting: submitting
        },
        actions: {
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid, rawCsvData, winnerData;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource(OtherType.Csv).catch(function(error) {
                                        showError(new Error(tCommon([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    4,
                                    parseCsvFromUrl(fileUrl)
                                ];
                            case 3:
                                rawCsvData = _state.sent();
                                winnerData = rawCsvData.data.filter(function(value) {
                                    return !!value.win;
                                }).map(function(value) {
                                    // 当選したアイテムIDを取得
                                    var win = value.win;
                                    var winItemId = value["choice".concat(win)];
                                    var item = data === null || data === void 0 ? void 0 : data.artistPreSale.items.find(function(item) {
                                        return item.id === winItemId;
                                    });
                                    var purchaseCount = value["purchaseCountChoice".concat(win)];
                                    var ref;
                                    return {
                                        fullName: value.fullName,
                                        win: value.win,
                                        itemTitle: (ref = item === null || item === void 0 ? void 0 : item.title) !== null && ref !== void 0 ? ref : "",
                                        purchaseCount: purchaseCount,
                                        paymentMethod: value.paymentMethod,
                                        appliedAt: value.appliedAt
                                    };
                                });
                                setCsvData(winnerData);
                                setCsvPath(tmpPath);
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onUpdateLotteryResultFromCsv: function onUpdateLotteryResultFromCsv() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updatePreSaleLotteryResultFromCsv({
                                        variables: {
                                            inputs: {
                                                csvPath: csvPath,
                                                preSaleId: router.query.preSaleId,
                                                resultNoticedAt: (ref = data === null || data === void 0 ? void 0 : data.artistPreSale.lottery) === null || ref === void 0 ? void 0 : ref.resultNoticedAt
                                            }
                                        }
                                    }).then(function() {
                                        showMessage(t("successUpdateLotteryResult"));
                                        router.goBack(generatePath(routerPages.ConsoleLotteryManagements, {
                                            preSaleId: router.query.preSaleId
                                        }));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemoveCsvFile: function onRemoveCsvFile() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setCsvData([]);
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var ConsoleLotteryCsvUpload_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleLotteryCsvUpload_viewModel_templateObject(), utoniq_core_schema/* ExportPreSaleApplicantsFragmentDoc */.cdz, utoniq_core_schema/* ConsolePreSaleTitleFragmentDoc */.iGL);
var UPDATE_PRESALE_LOTTERY_RESULT_FROM_CSV = (0,lib/* gql */.Ps)(ConsoleLotteryCsvUpload_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryCsvUpload/index.tsx




/**
 * ConsoleLotteryCsvUpload Page
 * Implemented as a practical sample.
 */ var ConsoleLotteryCsvUpload = function() {
    var ref = ConsoleLotteryCsvUpload_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleLotteryCsvUploadTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/preSale/LotteryChoiceItem/index.tsx






var LotteryChoiceItem = function(param) {
    var index = param.index, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength, choiceItemDetail = param.choiceItemDetail, winChoiceNumber = param.winChoiceNumber, applicantStatus = param.applicantStatus, hidePrice = param.hidePrice, eventTitle = param.eventTitle;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var status = (0,react.useMemo)(function() {
        if (applicantStatus === "30_waiting_lottery") {
            return {
                label: t("30_waiting_lottery"),
                bgcolor: "secondary.main",
                color: "white"
            };
        } else if ((applicantStatus === "10_win" || applicantStatus === "11_win_paid") && winChoiceNumber === index + 1) {
            return {
                label: t(applicantStatus),
                bgcolor: "primary.main",
                color: "white"
            };
        } else if (applicantStatus === "20_waiting_payment" && winChoiceNumber === index + 1) {
            return {
                label: t("20_waiting_payment"),
                bgcolor: "error.main",
                color: "white"
            };
        } else if (applicantStatus === "10_win" && winChoiceNumber === index + 1) {
            return {
                label: t("20_waiting_payment"),
                bgcolor: "error.main",
                color: "white"
            };
        } else if (applicantStatus === "50_invalid") {
            return {
                label: t("50_invalid"),
                bgcolor: "grey.100",
                color: "text.disabled"
            };
        } else if (applicantStatus === "60_canceled") {
            return {
                label: t("60_canceled"),
                bgcolor: "grey.100",
                color: "text.disabled"
            };
        } else {
            return {
                label: t("40_lose"),
                bgcolor: "grey.300",
                color: "text.secondary"
            };
        }
    }, [
        applicantStatus,
        winChoiceNumber,
        index,
        t
    ]);
    if (!(choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : choiceItemDetail.item)) return null;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                variant: "outlined",
                sx: {
                    mt: 2,
                    mb: 1,
                    typography: "subtitle2",
                    height: "20px",
                    lineHeight: 1.8,
                    bgcolor: "background.default",
                    display: "block",
                    border: "1px solid",
                    borderColor: "grey.300"
                },
                size: "small",
                label: t("choicePriority", {
                    number: ++index
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                size: "small",
                sx: {
                    height: 20,
                    borderRadius: "10px",
                    bgcolor: status.bgcolor,
                    py: 1,
                    px: 4,
                    ".MuiChip-label": {
                        px: 0
                    }
                },
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    color: status.color,
                    variant: "subtitle2",
                    children: status.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    mt: 4
                },
                variant: "subtitle1",
                color: "text.secondary",
                children: t("ticketTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    mt: 1
                },
                variant: "body2",
                children: choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : choiceItemDetail.item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    mt: 1
                },
                variant: "body2",
                children: choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : (ref = choiceItemDetail.skuUnit) === null || ref === void 0 ? void 0 : ref.unitName
            }),
            !!eventTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Border, {
                        sx: {
                            my: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("eventTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            mt: 1
                        },
                        variant: "body2",
                        children: eventTitle
                    })
                ]
            }),
            !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Border, {
                        sx: {
                            my: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("price")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            mt: 1
                        },
                        variant: "body2",
                        children: t("priceValue", {
                            price: numeral_default()((ref2 = choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : (ref1 = choiceItemDetail.skuUnit) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref2 !== void 0 ? ref2 : choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : choiceItemDetail.item.price).format("0,0")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Border, {
                sx: {
                    my: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.secondary",
                children: t("applicationNumber")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    mt: 1
                },
                variant: "body2",
                children: t("applicationNumberValue", {
                    count: choiceItemDetail === null || choiceItemDetail === void 0 ? void 0 : choiceItemDetail.count
                })
            })
        ]
    });
};
var Border = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        height: "1px",
        backgroundColor: theme.palette.grey["300"]
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/template/components/TicketDetailsCell.tsx







var TicketDetailsCell = function(param) {
    var choiceItemDetails = param.choiceItemDetails, winChoiceNumber = param.winChoiceNumber, status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagementDetail").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)((winChoiceNumber !== null && winChoiceNumber !== void 0 ? winChoiceNumber : "").toString()), selected = ref1[0], setSelected = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                mt: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("appInfoHead", "応募情報")
                    }),
                     false && /*#__PURE__*/ 0
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: choiceItemDetails.map(function(choiceItemDetail, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LotteryChoiceItem, {
                        index: index,
                        choiceLength: choiceItemDetails === null || choiceItemDetails === void 0 ? void 0 : choiceItemDetails.length,
                        choiceItemDetail: choiceItemDetail,
                        winChoiceNumber: winChoiceNumber,
                        applicantStatus: status,
                        hidePrice: true
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    setSelected((winChoiceNumber !== null && winChoiceNumber !== void 0 ? winChoiceNumber : "").toString());
                    setOpen(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    align: "left",
                    sx: {
                        pb: 3
                    },
                    children: status === "10_win" || status === "11_win_paid" ? t("changeWinTicketTitle", "当選チケットを選択してください。") : t("selectWinTicketTitle", "当選予定に変更するチケットを選択してください。")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        pb: 7,
                        width: "100%"
                    },
                    children: [
                        (status === "10_win" || status === "11_win_paid") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            align: "left",
                            children: t("changeWinTicketDesc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.RadioButtons, {
                            value: selected,
                            onChange: function(value) {
                                setSelected(value);
                            },
                            sx: {
                                px: 2,
                                ".MuiButtonBase-root.MuiRadio-root": {
                                    width: 30,
                                    height: 30
                                }
                            },
                            listItems: [
                                {
                                    value: "",
                                    label: t("allScheduledToRejected", "すべて落選予定")
                                }, 
                            ].concat(Array.from(Array((ref2 = choiceItemDetails === null || choiceItemDetails === void 0 ? void 0 : choiceItemDetails.length) !== null && ref2 !== void 0 ? ref2 : 0).keys()).map(function(index) {
                                return {
                                    value: (index + 1).toString(),
                                    label: t("choice", {
                                        number: index + 1
                                    })
                                };
                            }))
                        })
                    ]
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 200
                    },
                    onClick: function() {},
                    children: t("determine", "確定する")
                }),
                cancelText: t("close")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/template/components/PaymentInfoCell.tsx




var PaymentInfoCell = function(param) {
    var isKonbini = param.isKonbini;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagementDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("paymentInfoHead", "支払い情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    children: isKonbini ? t("convenienceStore") : t("creditCard")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/preSale/LotteryChoicePrice/index.tsx






var LotteryChoicePrice = function(param) {
    var index = param.index, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength, choiceItemDetail = param.choiceItemDetail, winChoiceNumber = param.winChoiceNumber;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var ref4, ref5, ref6, ref7, ref8, ref9;
    // 合計金額
    var totalPrice = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref10, ref11, ref12, ref13;
        return choiceItemDetail.count * ((ref5 = (ref4 = (ref = choiceItemDetail.skuUnit) === null || ref === void 0 ? void 0 : ref.price) !== null && ref4 !== void 0 ? ref4 : (ref1 = choiceItemDetail.item) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref5 !== void 0 ? ref5 : 0) + ((ref7 = (ref2 = choiceItemDetail.fees) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collections) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, fee) {
            return acc + ((ref6 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref6 !== void 0 ? ref6 : 0);
        }, 0)) !== null && ref7 !== void 0 ? ref7 : 0) + ((ref8 = (ref10 = choiceItemDetail.fees) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.konbini) === null || ref11 === void 0 ? void 0 : ref11.fee) !== null && ref8 !== void 0 ? ref8 : 0) + ((ref9 = (ref12 = choiceItemDetail.fees) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.shipping) === null || ref13 === void 0 ? void 0 : ref13.fee) !== null && ref9 !== void 0 ? ref9 : 0);
    }, [
        choiceItemDetail
    ]);
    // 当選済みの場合、当選した商品以外は表示しない
    if (winChoiceNumber && winChoiceNumber !== index + 1) {
        return null;
    }
    var ref10, ref11, ref12, _fee, _fee1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                variant: "outlined",
                sx: {
                    my: 2,
                    typography: "subtitle2",
                    height: "20px",
                    lineHeight: 1.8,
                    bgcolor: "background.default",
                    display: "block",
                    border: "1px solid",
                    borderColor: "grey.300"
                },
                size: "small",
                label: t("choicePriority", {
                    number: ++index
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("totalPrice")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        sx: {
                            mt: 1
                        },
                        variant: "body2",
                        children: [
                            "\xa5",
                            (0,state/* formatNumber */.uf)(choiceItemDetail.count * ((ref11 = (ref10 = (ref = choiceItemDetail.skuUnit) === null || ref === void 0 ? void 0 : ref.price) !== null && ref10 !== void 0 ? ref10 : (ref1 = choiceItemDetail.item) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref11 !== void 0 ? ref11 : 0))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryChoicePrice_Border, {
                sx: {
                    my: 2
                }
            }),
            (ref2 = choiceItemDetail.fees) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collections) === null || ref3 === void 0 ? void 0 : ref3.map(function(fee, index) {
                return fee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                my: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: fee === null || fee === void 0 ? void 0 : fee.feeName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        mt: 1
                                    },
                                    variant: "body2",
                                    children: [
                                        "\xa5",
                                        (0,state/* formatNumber */.uf)((ref12 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref12 !== void 0 ? ref12 : 0)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryChoicePrice_Border, {
                            sx: {
                                my: 2
                            }
                        })
                    ]
                }, index) : null;
            }),
            !!choiceItemDetail.fees.konbini && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: choiceItemDetail.fees.konbini.feeName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                sx: {
                                    mt: 1
                                },
                                variant: "body2",
                                children: [
                                    "\xa5 ",
                                    (0,state/* formatNumber */.uf)((_fee = choiceItemDetail.fees.konbini.fee) !== null && _fee !== void 0 ? _fee : 0)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryChoicePrice_Border, {
                        sx: {
                            my: 2
                        }
                    })
                ]
            }),
            !!choiceItemDetail.fees.shipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: choiceItemDetail.fees.shipping.feeName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                sx: {
                                    mt: 1
                                },
                                variant: "body2",
                                children: [
                                    "\xa5 ",
                                    (0,state/* formatNumber */.uf)((_fee1 = choiceItemDetail.fees.shipping.fee) !== null && _fee1 !== void 0 ? _fee1 : 0)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryChoicePrice_Border, {
                        sx: {
                            my: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("total")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        sx: {
                            mt: 1
                        },
                        variant: "h6",
                        children: [
                            "\xa5 ",
                            (0,state/* formatNumber */.uf)(totalPrice)
                        ]
                    })
                ]
            })
        ]
    });
};
var LotteryChoicePrice_Border = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        height: "1px",
        backgroundColor: theme.palette.grey["300"]
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/template/components/TotalPaymentAmountCell.tsx





var TotalPaymentAmountCell = function(param) {
    var choiceItemDetails = param.choiceItemDetails, winChoiceNumber = param.winChoiceNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagementDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                mt: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("totalPriceHead", "お支払い総額")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: choiceItemDetails.map(function(choiceItemDetail, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LotteryChoicePrice, {
                        index: index,
                        choiceLength: choiceItemDetails === null || choiceItemDetails === void 0 ? void 0 : choiceItemDetails.length,
                        choiceItemDetail: choiceItemDetail,
                        winChoiceNumber: winChoiceNumber
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/template/components/UserInfoCell.tsx






var UserInfoCell = function(param) {
    var user = param.user;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagementDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                mt: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("userInfoHead", "顧客情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("familyName", "氏名")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: user === null || user === void 0 ? void 0 : user.fullName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("shippingAddress", "住所")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("phoneNumber", "電話番号")
                                    }),
                                    (user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                                fontSize: "small",
                                                sx: {
                                                    color: "text.hint",
                                                    mt: -1
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                color: "text.hint",
                                                children: t("verified")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: user === null || user === void 0 ? void 0 : user.formattedPhoneNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("email", "メールアドレス")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: user === null || user === void 0 ? void 0 : user.email
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/template/index.tsx











var ConsoleLotteryManagementDetailTemplate = function(param) {
    var state = param.state;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var _preSaleId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleLotteryManagementDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleLotteryManagements, {
                        preSaleId: (_preSaleId = state.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
                    }),
                    title: (ref = state.preSaleLotteryApplicant) === null || ref === void 0 ? void 0 : ref.preSale.title
                },
                children: state.preSaleLotteryApplicant ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDetailsCell, {
                            choiceItemDetails: state.preSaleLotteryApplicant.choiceItemDetails,
                            winChoiceNumber: state.preSaleLotteryApplicant.winChoiceNumber,
                            status: state.preSaleLotteryApplicant.status
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoCell, {
                            isKonbini: state.preSaleLotteryApplicant.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentAmountCell, {
                            choiceItemDetails: state.preSaleLotteryApplicant.choiceItemDetails,
                            winChoiceNumber: state.preSaleLotteryApplicant.winChoiceNumber
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoCell, {
                            user: state.preSaleLotteryApplicant.user
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDetailsSkeletonCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoSkeletonCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentAmountSkeletonCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoSkeletonCell, {})
                    ]
                })
            })
        ]
    });
};
var TicketDetailsSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "medium",
                            numberOfLine: 5
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 44,
                        sx: {
                            borderRadius: "34px"
                        }
                    })
                ]
            })
        ]
    });
};
var PaymentInfoSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "50%",
                    height: 32
                })
            })
        ]
    });
};
var TotalPaymentAmountSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var UserInfoSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                py: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "large",
                        width: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "large",
                        width: "30%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    bgcolor: "grey.50",
                    p: 5,
                    borderRadius: 2
                },
                children: Array.from(Array(3).keys()).map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "10%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small"
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/viewModel.ts

function ConsoleLotteryManagementDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleLotteryManagementDetail($preSaleId: String!, $userId: ID!) {\n    artistPreSaleLotteryApplicant(preSaleId: $preSaleId, userId: $userId) {\n      ...ArtistPreSaleLotteryApplicantDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleLotteryManagementDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var ConsoleLotteryManagementDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleLotteryManagementDetail_viewModel_QUERY, {
        variables: {
            userId: router.query.userId,
            preSaleId: router.query.preSaleId
        }
    }).data;
    var ref, ref1;
    return {
        state: {
            artistId: (ref = user === null || user === void 0 ? void 0 : user.uid) !== null && ref !== void 0 ? ref : "",
            preSaleId: router.query.preSaleId,
            preSaleLotteryApplicant: (ref1 = data === null || data === void 0 ? void 0 : data.artistPreSaleLotteryApplicant) !== null && ref1 !== void 0 ? ref1 : null
        },
        actions: {}
    };
});
var ConsoleLotteryManagementDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleLotteryManagementDetail_viewModel_templateObject(), utoniq_core_schema/* ArtistPreSaleLotteryApplicantDetailFragmentDoc */.CKM);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagementDetail/index.tsx




/**
 * ConsoleLotteryManagementDetail Page
 * Implemented as a practical sample.
 */ var ConsoleLotteryManagementDetail = function() {
    var ref = ConsoleLotteryManagementDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleLotteryManagementDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/template/components/LotteryApplicantFilterCell.tsx










var LotteryApplicantFilterCell = function(param) {
    var items = param.items, maxChoice = param.maxChoice, filters = param.filters, onFilters = param.onFilters;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref6 = (0,react.useState)(false), openTicketSelect = ref6[0], setOpenTicketSelect = ref6[1];
    var ref7 = (0,react.useState)(false), openChoiceNumberSelect = ref7[0], setOpenChoiceNumberSelect = ref7[1];
    var tickets = (0,react.useMemo)(function() {
        if (!(items === null || items === void 0 ? void 0 : items.length)) {
            return [];
        }
        return flatten_default()(items.map(function(item) {
            var ref, ref1;
            return ((ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.length) ? item.skuSettings.units.map(function(unit) {
                return {
                    item: item,
                    unit: unit
                };
            }) : {
                item: item,
                unit: undefined
            };
        }));
    }, [
        items
    ]);
    var selectedItem = (0,react.useMemo)(function() {
        var ref;
        if (!(items === null || items === void 0 ? void 0 : items.length) || !((ref = filters.choices) === null || ref === void 0 ? void 0 : ref.length)) {
            return null;
        }
        return tickets.find(function(item) {
            var ref, ref1;
            var id = [
                item.item.id,
                (ref = item.unit) === null || ref === void 0 ? void 0 : ref.id
            ].filter(function(o) {
                return !!o;
            }).join(":");
            return (ref1 = filters.choices) === null || ref1 === void 0 ? void 0 : ref1.includes(id);
        });
    }, [
        items === null || items === void 0 ? void 0 : items.length,
        filters.choices,
        tickets
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {}),
                        sx: {
                            "&:hover, &": {
                                maxWidth: 150,
                                borderWidth: ((ref = filters.choices) === null || ref === void 0 ? void 0 : ref.length) ? 2 : 1,
                                borderColor: ((ref1 = filters.choices) === null || ref1 === void 0 ? void 0 : ref1.length) ? "primary.main" : undefined,
                                bgcolor: ((ref2 = filters.choices) === null || ref2 === void 0 ? void 0 : ref2.length) ? "secondary.light" : undefined
                            }
                        },
                        onClick: function() {
                            return setOpenTicketSelect(true);
                        },
                        children: selectedItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: (0,src_object_spread/* default */.Z)({
                                        width: 100
                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                    children: (ref3 = selectedItem.item) === null || ref3 === void 0 ? void 0 : ref3.title
                                }),
                                filters.choices && ((ref4 = filters.choices) === null || ref4 === void 0 ? void 0 : ref4.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "+",
                                        ((ref5 = filters.choices) === null || ref5 === void 0 ? void 0 : ref5.length) - 1
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "text.hint",
                            children: t("ticketName", "チケット/SKU")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {}),
                        onClick: function() {
                            return setOpenChoiceNumberSelect(true);
                        },
                        sx: {
                            "&:hover, &": {
                                maxWidth: 150,
                                borderWidth: filters.choiceNumber ? 2 : 1,
                                borderColor: filters.choiceNumber ? "primary.main" : undefined,
                                bgcolor: filters.choiceNumber ? "secondary.light" : undefined
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: filters.choiceNumber ? undefined : "text.hint",
                            children: filters.choiceNumber ? t("choice".concat(filters.choiceNumber)) : t("choice", "希望数")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelectDrawer, {
                choices: filters.choices,
                open: openTicketSelect,
                tickets: tickets,
                onClose: function() {
                    return setOpenTicketSelect(false);
                },
                onSaveFilter: onFilters
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceNumberSelectDrawer, {
                maxChoice: maxChoice,
                choiceNumber: filters.choiceNumber,
                open: openChoiceNumberSelect,
                onClose: function() {
                    return setOpenChoiceNumberSelect(false);
                },
                onSaveFilter: onFilters
            })
        ]
    });
};
var TicketSelectDrawer = function(param) {
    var open = param.open, choices = param.choices, tickets = param.tickets, onClose = param.onClose, onSaveFilter = param.onSaveFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useState)(undefined), selectedTicket = ref[0], setSelectedTicket = ref[1];
    (0,react.useEffect)(function() {
        setSelectedTicket(choices);
    }, [
        choices
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setSelectedTicket(choices);
        onClose();
    }, [
        choices,
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: handleClose,
        sx: {
            zIndex: function(theme) {
                return theme.zIndex.modal + 3;
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                bgcolor: "background.default",
                maxHeight: "90dvh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        py: 4,
                        px: 3
                    },
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            size: "small",
                            onClick: handleClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            width: "100%",
                            children: t("ticketName", "チケット/SKU")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            width: 30
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    sx: (0,src_object_spread/* default */.Z)({
                        px: 5,
                        overflowY: "auto"
                    }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                    children: tickets.map(function(ticket) {
                        var ref, ref1, ref2;
                        var id = [
                            ticket.item.id,
                            (ref = ticket.unit) === null || ref === void 0 ? void 0 : ref.id
                        ].filter(function(o) {
                            return !!o;
                        }).join(":");
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                py: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    size: "small",
                                    checked: selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.includes(id),
                                    onClick: function() {
                                        setSelectedTicket(function(prevState) {
                                            return xor_default()(prevState, [
                                                id
                                            ]);
                                        });
                                    }
                                }),
                                sx: {
                                    p: 0,
                                    flexDirection: "row-reverse",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    mx: 0
                                },
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    width: "100%",
                                    children: [
                                        (ref1 = ticket.item) === null || ref1 === void 0 ? void 0 : ref1.title,
                                        (ref2 = ticket.unit) === null || ref2 === void 0 ? void 0 : ref2.unitName
                                    ].filter(function(o) {
                                        return !!o;
                                    }).join("/")
                                })
                            })
                        }, id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    py: 4,
                    px: 5,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            onClick: function() {
                                onSaveFilter({
                                    choices: undefined
                                });
                                onClose();
                            },
                            children: t("clearAll", "すべてクリア")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: function() {
                                onSaveFilter({
                                    choices: (selectedTicket === null || selectedTicket === void 0 ? void 0 : selectedTicket.length) ? selectedTicket : undefined
                                });
                                onClose();
                            },
                            children: t("done", "完了")
                        })
                    ]
                })
            ]
        })
    });
};
var ChoiceNumberSelectDrawer = function(param) {
    var open = param.open, maxChoice = param.maxChoice, choiceNumber = param.choiceNumber, onClose = param.onClose, onSaveFilter = param.onSaveFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useState)(undefined), selectedChoiceNumber = ref[0], setSelectedChoiceNumber = ref[1];
    (0,react.useEffect)(function() {
        setSelectedChoiceNumber(choiceNumber);
    }, [
        choiceNumber
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setSelectedChoiceNumber(choiceNumber);
        onClose();
    }, [
        choiceNumber,
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: handleClose,
        sx: {
            zIndex: function(theme) {
                return theme.zIndex.modal + 3;
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                bgcolor: "background.default"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: (0,src_object_spread/* default */.Z)({
                        py: 4,
                        px: 3,
                        overflowY: "auto"
                    }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            size: "small",
                            onClick: handleClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            width: "100%",
                            children: t("choice", "希望数")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            width: 30
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    px: 5,
                    children: Array.from(Array(maxChoice).keys()).map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    size: "small",
                                    checked: selectedChoiceNumber === index + 1,
                                    onClick: function() {
                                        return setSelectedChoiceNumber(function(prevState) {
                                            return prevState === index + 1 ? undefined : index + 1;
                                        });
                                    }
                                }),
                                sx: {
                                    p: 0,
                                    flexDirection: "row-reverse",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    mx: 0
                                },
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    width: "100%",
                                    children: t("choiceText", {
                                        number: index + 1
                                    })
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    py: 4,
                    px: 5,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            onClick: function() {
                                onSaveFilter({
                                    choiceNumber: undefined
                                });
                                onClose();
                            },
                            children: t("clearAll", "すべてクリア")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: function() {
                                onSaveFilter({
                                    choiceNumber: selectedChoiceNumber
                                });
                                onClose();
                            },
                            children: t("done", "完了")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/template/components/LotteryApplicantTableCell.tsx








var LotteryApplicantTableCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, isEditable = param.isEditable, selectedWinners = param.selectedWinners, lotteryApplicants = param.lotteryApplicants, onSelectedWinner = param.onSelectedWinner, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                sx: (0,src_object_spread/* default */.Z)({
                    width: "auto",
                    overflowX: "scroll",
                    mt: 3
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 120,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("fullName")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 70,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("status")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 100,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("choice")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 150,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 80,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("unitName")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 80,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("purchaseCountChoice")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 130,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("paymentMethod")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        minWidth: 150,
                                        py: 2,
                                        px: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.hint",
                                        children: t("appliedAt")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        component: TableRow/* default */.Z,
                        colSpan: 8,
                        nodes: lotteryApplicants === null || lotteryApplicants === void 0 ? void 0 : (ref = lotteryApplicants.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var node = param.node;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 120,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            sx: (0,src_object_spread/* default */.Z)({
                                                width: 120,
                                                pl: 2
                                            }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                            children: node.user.fullName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 70,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            sx: (0,src_object_spread/* default */.Z)({
                                                width: 70
                                            }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryStatusTag, {
                                                    status: node.status
                                                }),
                                                node.winChoiceNumber && !isEditable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: t("winChoiceNUmber", {
                                                        number: node.winChoiceNumber
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 100,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: node.choiceItemDetails.map(function(_, index) {
                                                if (isEditable) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                disabled: node.status === "50_invalid" || node.status === "60_canceled",
                                                                size: "small",
                                                                checked: !!(selectedWinners === null || selectedWinners === void 0 ? void 0 : selectedWinners.includes("".concat(node.id, ":").concat(index + 1))),
                                                                onClick: function() {
                                                                    if (onSelectedWinner) {
                                                                        onSelectedWinner("".concat(node.id, ":").concat(index + 1), node.id);
                                                                    }
                                                                }
                                                            }),
                                                            sx: {
                                                                p: 0
                                                            },
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "body2",
                                                                children: t("choiceText", {
                                                                    number: index + 1
                                                                })
                                                            })
                                                        })
                                                    }, index);
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: t("choiceText", {
                                                        number: index + 1
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 150,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: node.choiceItemDetails.map(function(choiceItemDetail, index) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    sx: (0,src_object_spread/* default */.Z)({
                                                        width: 150
                                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                    children: (ref = choiceItemDetail.item) === null || ref === void 0 ? void 0 : ref.title
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 150,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: node.choiceItemDetails.map(function(choiceItemDetail, index) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    sx: (0,src_object_spread/* default */.Z)({
                                                        height: 20,
                                                        width: 150
                                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                    children: (ref = choiceItemDetail.skuUnit) === null || ref === void 0 ? void 0 : ref.unitName
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 80,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: node.choiceItemDetails.map(function(choiceItemDetail, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    sx: (0,src_object_spread/* default */.Z)({
                                                        width: 80
                                                    }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                                    children: choiceItemDetail.count
                                                }, index);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 130,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            sx: (0,src_object_spread/* default */.Z)({
                                                width: 130
                                            }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                            children: t(node.paymentMethod)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowCell, {
                                        width: 150,
                                        preSaleId: node.preSale.id,
                                        userId: node.user.id,
                                        isEditable: isEditable,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            sx: (0,src_object_spread/* default */.Z)({
                                                width: 150
                                            }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                            children: node.formattedAppliedAt
                                        })
                                    })
                                ]
                            }, node.id);
                        })
                    })
                ]
            })
        })
    });
};
var TableRowCell = function(param) {
    var width = param.width, preSaleId = param.preSaleId, userId = param.userId, isEditable = param.isEditable, children = param.children;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var Component = isEditable ? TableCell/* default */.Z : ButtonBase/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        //@ts-ignore
        component: isEditable ? undefined : TableCell/* default */.Z,
        padding: "none",
        disableRipple: true,
        onClick: function() {
            return !isEditable && router.push(generatePath(routerPages.ConsoleLotteryManagementDetail, {
                preSaleId: preSaleId,
                userId: userId
            }));
        },
        sx: {
            display: "table-cell",
            py: 4,
            pl: 0,
            pr: 1,
            width: width,
            borderBottomWidth: 1,
            borderBottomColor: "grey.100",
            borderBottomStyle: "solid"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            flex: 1,
            sx: {
                minWidth: 0,
                width: "100%"
            },
            children: children
        })
    });
};
var LotteryStatusTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useMemo)(function() {
        switch(status){
            case "30_waiting_lottery":
                return {
                    text: t(status),
                    color: "text.primary",
                    bgcolor: "secondary.light"
                };
            case "40_lose":
                return {
                    text: t(status),
                    color: "white",
                    bgcolor: "grey.300"
                };
            case "10_win":
            case "11_win_paid":
                return {
                    text: t(status),
                    color: "white",
                    bgcolor: "secondary.dark"
                };
            default:
                return {
                    text: t(status),
                    color: "",
                    bgcolor: ""
                };
        }
    }, [
        status,
        t
    ]), text = ref.text, bgcolor = ref.bgcolor, color = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: color,
                children: text
            }),
            sx: {
                bgcolor: bgcolor,
                borderRadius: "2px",
                width: "unset",
                height: 20,
                ".MuiChip-label": {
                    px: 1
                }
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/template/components/LotteryApplicantEditModal.tsx















var LotteryApplicantEditModal = function(param) {
    var artistId = param.artistId, open = param.open, loading = param.loading, hasNextPage = param.hasNextPage, maxChoice = param.maxChoice, items = param.items, filters = param.filters, lotteryApplicants = param.lotteryApplicants, updatingPreSaleLotteryApplicantStatus = param.updatingPreSaleLotteryApplicantStatus, onClose = param.onClose, onFilters = param.onFilters, onSelectedWinner = param.onSelectedWinner, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useState)([]), selectedWinners = ref[0], setSelectedWinners = ref[1];
    var handleSelectAll = (0,react.useCallback)(function() {}, []);
    (0,react.useEffect)(function() {
        if (lotteryApplicants === null || lotteryApplicants === void 0 ? void 0 : lotteryApplicants.edges.length) {
            setSelectedWinners(lotteryApplicants.edges.map(function(param) {
                var node = param.node;
                return node.winChoiceNumber ? "".concat(node.id, ":").concat(node.winChoiceNumber) : "";
            }).filter(function(o) {
                return !!o;
            }));
        }
    }, [
        lotteryApplicants
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
            artistId: artistId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        size: "medium",
                        onClick: onClose,
                        sx: {
                            "svg, svg:hover": {
                                color: "white"
                            }
                        }
                    }),
                    title: t("choiceTitle", {
                        number: selectedWinners.length
                    }),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        width: 80,
                        onClick: handleSelectAll,
                        color: "white",
                        children: t("selectAll", "すべて選択")
                    })
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantEditModal_FixedBottomCell, {
                    disabled: !selectedWinners.length,
                    selectedCount: selectedWinners.length,
                    updatingPreSaleLotteryApplicantStatus: updatingPreSaleLotteryApplicantStatus,
                    onSelectedWinner: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onSelectedWinner(selectedWinners)
                                    ];
                                case 1:
                                    _state.sent();
                                    onClose();
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantFilterCell, {
                        maxChoice: maxChoice,
                        items: items,
                        filters: filters,
                        onFilters: onFilters
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantTableCell, {
                        isEditable: true,
                        loading: loading,
                        hasNextPage: hasNextPage,
                        selectedWinners: selectedWinners,
                        lotteryApplicants: lotteryApplicants,
                        onSelectedWinner: function(id, userId) {
                            return setSelectedWinners(function(prevState) {
                                return xor_default()(prevState, [
                                    id, 
                                ].concat((0,src_to_consumable_array/* default */.Z)(prevState.filter(function(selectedWinner) {
                                    return selectedWinner.includes(userId);
                                }))));
                            });
                        },
                        onFetchMore: onFetchMore
                    })
                ]
            })
        })
    });
};
var LotteryApplicantEditModal_FixedBottomCell = function(param) {
    var disabled = param.disabled, updatingPreSaleLotteryApplicantStatus = param.updatingPreSaleLotteryApplicantStatus, selectedCount = param.selectedCount, onSelectedWinner = param.onSelectedWinner;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 4,
                    bgcolor: "grey.50",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 244
                    },
                    disabled: disabled,
                    onClick: function() {
                        return setOpenConfirm(true);
                    },
                    children: t("decidingWinner", "当選者を決定する")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("decidingWinnerTitle", "当選予定者に決定します。"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    pb: 7,
                    sx: {
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("decidingWinnerDesc", "当選予定者は後ほど変更することもできます。")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("winnerNumber", "当選人数")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("peopleCount", {
                                        number: selectedCount
                                    })
                                })
                            ]
                        })
                    ]
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: updatingPreSaleLotteryApplicantStatus,
                    disabled: updatingPreSaleLotteryApplicantStatus,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onSelectedWinner()
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenConfirm(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("confirm", "確定する")
                }),
                cancelText: t("close")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/template/index.tsx

















var ConsoleLotteryManagementsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilters = param.onFilters, onSelectedWinner = param.onSelectedWinner, onRegisterWinDate = param.onRegisterWinDate;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref16 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref16.routerNames, routerPages = ref16.routerPages, generatePath = ref16.generatePath, router = ref16.router;
    var ref17 = (0,react.useState)(false), openEditModal = ref17[0], setOpenEditModal = ref17[1];
    var ref18, ref19, ref20, ref21, ref22;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleLotteryManagements
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleShokufesEventDetail, {
                        eventId: (ref18 = (ref = state.preSale) === null || ref === void 0 ? void 0 : ref.eventId) !== null && ref18 !== void 0 ? ref18 : "#"
                    }),
                    title: (ref1 = state.preSale) === null || ref1 === void 0 ? void 0 : ref1.title
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleLotteryManagements_template_HeadingTextCell, {
                        preSaleId: state.preSaleId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCell, {
                        updatingResultNoticedAt: state.updatingResultNoticedAt,
                        resultNoticedAt: (ref2 = state.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lottery) === null || ref3 === void 0 ? void 0 : ref3.formattedResultNoticedAt,
                        resultNoticeStatus: (ref4 = state.preSale) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.lottery) === null || ref5 === void 0 ? void 0 : ref5.resultNoticeStatus,
                        onRegisterWinDate: onRegisterWinDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantFilterCell, {
                        maxChoice: (ref19 = (ref6 = state.preSale) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.lottery) === null || ref7 === void 0 ? void 0 : ref7.maxChoice) !== null && ref19 !== void 0 ? ref19 : 3,
                        filters: state.filters,
                        items: (ref20 = (ref8 = state.preSale) === null || ref8 === void 0 ? void 0 : ref8.items) !== null && ref20 !== void 0 ? ref20 : [],
                        onFilters: onFilters
                    }),
                    (((ref9 = state.preSale) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.lottery) === null || ref10 === void 0 ? void 0 : ref10.resultNoticeStatus) === utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.None */.Qxe.None || ((ref11 = state.preSale) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.lottery) === null || ref12 === void 0 ? void 0 : ref12.resultNoticeStatus) === utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.Ready */.Qxe.Ready) && false && /*#__PURE__*/ 0,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantTableCell, {
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        lotteryApplicants: state.lotteryApplicants
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicantEditModal, {
                        artistId: state.artistId,
                        open: openEditModal,
                        updatingPreSaleLotteryApplicantStatus: state.updatingPreSaleLotteryApplicantStatus,
                        items: (ref21 = (ref13 = state.preSale) === null || ref13 === void 0 ? void 0 : ref13.items) !== null && ref21 !== void 0 ? ref21 : [],
                        filters: state.filters,
                        maxChoice: (ref22 = (ref14 = state.preSale) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.lottery) === null || ref15 === void 0 ? void 0 : ref15.maxChoice) !== null && ref22 !== void 0 ? ref22 : 3,
                        lotteryApplicants: state.lotteryApplicants,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        onClose: function() {
                            return setOpenEditModal(false);
                        },
                        onFilters: onFilters,
                        onSelectedWinner: onSelectedWinner
                    })
                ]
            })
        ]
    });
};
var ConsoleLotteryManagements_template_HeadingTextCell = function(param) {
    var preSaleId = param.preSaleId;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            mt: 3,
            mb: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("winnerManagement", "当選者管理")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                        sx: {
                            color: "primary.main"
                        }
                    }),
                    sx: {
                        borderRadius: 1,
                        color: "primary.main",
                        borderColor: "primary.main"
                    },
                    href: generatePath(routerPages.ConsoleLotteryCsvUpload, {
                        preSaleId: preSaleId
                    }),
                    children: t("bulkRegistrationWinners", "当選者の一括登録")
                })
            ]
        })
    });
};
var StepCell = function(param) {
    var resultNoticeStatus = param.resultNoticeStatus, resultNoticedAt = param.resultNoticedAt, updatingResultNoticedAt = param.updatingResultNoticedAt, onRegisterWinDate = param.onRegisterWinDate;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var ref = (0,react.useState)(false), openBulkRegistration = ref[0], setOpenBulkRegistration = ref[1];
    var ref1 = (0,react.useState)(resultNoticedAt !== null && resultNoticedAt !== void 0 ? resultNoticedAt : null), dateTime = ref1[0], setDateTime = ref1[1];
    var step = resultNoticeStatus === utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.Ready */.Qxe.Ready ? "Two" : "One";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            width: "100%",
            bgcolor: "grey.50",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                direction: "row",
                alignItems: "center",
                justifyContent: resultNoticeStatus !== utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.None */.Qxe.None && resultNoticedAt ? "space-between" : "center",
                children: [
                    resultNoticeStatus !== utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.None */.Qxe.None && resultNoticedAt ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        px: 5,
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            resultNoticeStatus !== utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.Done */.Qxe.Done && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                sx: {
                                    color: "primary.main"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                                    i18nKey: resultNoticedAt > values_Date/* DateTime.now */.o.now() ? "winDateLabel" : "wonDateLabel",
                                    t: t,
                                    values: {
                                        date: resultNoticedAt
                                    },
                                    components: {
                                        linkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            component: "span",
                                            variant: "subtitle2",
                                            color: "primary"
                                        })
                                    }
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        px: 5,
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                color: "primary",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "white",
                                    children: t("step".concat(step, "Key"))
                                }),
                                sx: {
                                    height: 16,
                                    borderRadius: "14px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("step".concat(step, "Label"))
                            })
                        ]
                    }),
                    resultNoticeStatus === utoniq_core_schema/* PreSaleLotteryResultNoticeStatus.Ready */.Qxe.Ready && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: function() {
                            return setOpenBulkRegistration(true);
                        },
                        children: t("register", "登録")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openBulkRegistration,
                onClose: function() {
                    return setOpenBulkRegistration(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    align: "left",
                    children: t("bulkRegistrationTitle", "当選確定を当選者にお知らせする日時を入力してください。")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    pb: 7,
                    pt: 3,
                    sx: {
                        textAlign: "left"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
                        title: t("winningDateLabel", "当落発表日時"),
                        titleProps: {
                            sx: {
                                color: "text.primary"
                            }
                        },
                        value: dateTime ? dayjs_min_default()(dateTime) : null,
                        onChange: function(date) {
                            return setDateTime(date);
                        }
                    })
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    disabled: !dateTime,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            if (!dateTime) return [
                                2
                            ];
                            onRegisterWinDate(dateTime).finally(function() {
                                return setOpenBulkRegistration(false);
                            });
                            return [
                                2
                            ];
                        });
                    }),
                    loading: updatingResultNoticedAt,
                    children: t("bulkRegister", "登録する")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/viewModel.ts







function ConsoleLotteryManagements_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleLotteryManagements(\n    $filters: PreSaleLotteryApplicantFilterInputs\n    $pageInput: PageInput\n    $artistPreSaleId: String!\n    $preSaleId: ID!\n  ) {\n    artistPreSaleLotteryApplicants(\n      filters: $filters\n      pageInput: $pageInput\n      preSaleId: $artistPreSaleId\n    ) {\n      ...ArtistPreSaleLotteryApplicantsConnection\n    }\n    artistPreSale(id: $preSaleId) {\n      id\n      title\n      description\n      type\n      preSaleStatus @client\n      eventId\n      lottery {\n        applicationStartedAt\n        applicationEndedAt\n        purchasableStartedAt\n        purchasableEndedAt\n        resultNoticedAt\n        resultNoticeStatus\n        maxChoice\n        formattedResultNoticedAt @client\n        resultNoticeStatus\n      }\n      items {\n        ...PreSaleItemFilter\n      }\n      itemIds\n      isPublished\n      endedAt\n      startedAt\n      note\n      paymentMethods\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleLotteryManagements_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleLotteryManagements_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdatePreSaleLotteryApplicantStatus(\n    $inputs: ArtistUpdatePreSaleLotteryApplicantStatusInput!\n  ) {\n    artistUpdatePreSaleLotteryApplicantStatus(inputs: $inputs) {\n      ...ArtistPreSaleLotteryApplicantDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleLotteryManagements_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleLotteryManagements_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdatePreSaleLotteryResultNoticedAt(\n    $id: ID!\n    $inputs: ArtistUpdatePreSaleInput!\n  ) {\n    artistUpdatePreSale(id: $id, inputs: $inputs) {\n      id\n      isPublished\n      lottery {\n        resultNoticedAt\n      }\n    }\n  }\n"
    ]);
    ConsoleLotteryManagements_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







/**
 *
 */ var ConsoleLotteryManagements_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref5 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref5.showError, showMessage = ref5.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleLotteryManagements").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref6 = (0,react.useState)({}), filters = ref6[0], setFilters = ref6[1];
    var ref7 = (0,useQuery/* useQuery */.aM)(ConsoleLotteryManagements_viewModel_QUERY, {
        variables: {
            preSaleId: router.query.preSaleId,
            artistPreSaleId: router.query.preSaleId,
            filters: {}
        },
        notifyOnNetworkStatusChange: true,
        returnPartialData: true
    }), data = ref7.data, loading = ref7.loading, fetchMore = ref7.fetchMore, refetch = ref7.refetch;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UPDATE_PRESALE_LOTTERY_APPLICANT_STATUS), 2), artistUpdatePreSaleLotteryApplicantStatus = ref8[0], ref9 = ref8[1], updatingPreSaleLotteryApplicantStatus = ref9.loading;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_PRESALE_LOTTERY_RESULT_NOTICED_AT), 2), updatePreSaleLottery = ref10[0], ref11 = ref10[1], updatingResultNoticedAt = ref11.loading;
    var ref12, ref13, ref14, ref15;
    return {
        state: {
            loading: loading,
            updatingResultNoticedAt: updatingResultNoticedAt,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistPreSaleLotteryApplicants) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            filters: filters,
            updatingPreSaleLotteryApplicantStatus: updatingPreSaleLotteryApplicantStatus,
            artistId: (ref12 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref12 !== void 0 ? ref12 : "",
            preSaleId: router.query.preSaleId,
            preSale: (ref13 = data === null || data === void 0 ? void 0 : data.artistPreSale) !== null && ref13 !== void 0 ? ref13 : null,
            lotteryApplicants: (ref14 = data === null || data === void 0 ? void 0 : data.artistPreSaleLotteryApplicants) !== null && ref14 !== void 0 ? ref14 : null,
            isApplied: (data === null || data === void 0 ? void 0 : (ref1 = data.artistPreSale) === null || ref1 === void 0 ? void 0 : ref1.preSaleStatus) === utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting || (data === null || data === void 0 ? void 0 : (ref2 = data.artistPreSale) === null || ref2 === void 0 ? void 0 : ref2.preSaleStatus) === utoniq_core_schema/* PreSaleStatus.Expired */.fu$.Expired,
            winDate: (ref15 = data === null || data === void 0 ? void 0 : (ref3 = data.artistPreSale) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.lottery) === null || ref4 === void 0 ? void 0 : ref4.resultNoticedAt) !== null && ref15 !== void 0 ? ref15 : ""
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            preSaleId: router.query.preSaleId,
                                            artistPreSaleId: router.query.preSaleId,
                                            filters: filters,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistPreSaleLotteryApplicants) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilters: function onFilters(newFilters) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setFilters((0,src_object_spread/* default */.Z)({}, filters, newFilters));
                                return [
                                    4,
                                    refetch({
                                        filters: (0,src_object_spread/* default */.Z)({}, filters, newFilters)
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectedWinner: function onSelectedWinner(items) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.artistPreSaleLotteryApplicants.edges.length)) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    artistUpdatePreSaleLotteryApplicantStatus({
                                        variables: {
                                            inputs: {
                                                preSaleId: router.query.preSaleId,
                                                lotteryResults: data === null || data === void 0 ? void 0 : data.artistPreSaleLotteryApplicants.edges.map(function(param) {
                                                    var node = param.node;
                                                    var item = items.find(function(i) {
                                                        var ref = (0,_sliced_to_array/* default */.Z)(i.split(":"), 1), userId = ref[0];
                                                        return userId === node.id;
                                                    });
                                                    var ref;
                                                    var ref1 = (0,_sliced_to_array/* default */.Z)((ref = item === null || item === void 0 ? void 0 : item.split(":")) !== null && ref !== void 0 ? ref : [], 2), _ = ref1[0], winChoiceNumber = ref1[1];
                                                    return {
                                                        userId: node.id,
                                                        winChoiceNumber: +winChoiceNumber || null
                                                    };
                                                })
                                            }
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRegisterWinDate: function onRegisterWinDate(resultNoticedAt) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _artistPreSale, // @ts-ignore
                    __typename, id, items, preSaleStatus, type, presale, _lottery, _, formattedResultNoticedAt, resultNoticeStatus, lottery;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.artistPreSale)) {
                                    return [
                                        2
                                    ];
                                }
                                _artistPreSale = data.artistPreSale, __typename = _artistPreSale.__typename, id = _artistPreSale.id, items = _artistPreSale.items, preSaleStatus = _artistPreSale.preSaleStatus, type = _artistPreSale.type, presale = (0,_object_without_properties/* default */.Z)(_artistPreSale, [
                                    "__typename",
                                    "id",
                                    "items",
                                    "preSaleStatus",
                                    "type"
                                ]);
                                _lottery = data.artistPreSale.lottery, // @ts-ignore
                                _ = _lottery.__typename, formattedResultNoticedAt = _lottery.formattedResultNoticedAt, resultNoticeStatus = _lottery.resultNoticeStatus, lottery = (0,_object_without_properties/* default */.Z)(_lottery, [
                                    "__typename",
                                    "formattedResultNoticedAt",
                                    "resultNoticeStatus"
                                ]);
                                return [
                                    4,
                                    updatePreSaleLottery({
                                        variables: {
                                            id: router.query.preSaleId,
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, presale), {
                                                lottery: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, lottery), {
                                                    resultNoticedAt: dayjs_min_default()(resultNoticedAt, "YYYY/MM/DD HH:mm")
                                                })
                                            })
                                        }
                                    }).then(function() {
                                        showMessage(t("resultNoticedAtUpdated"));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleLotteryManagements_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleLotteryManagements_viewModel_templateObject(), utoniq_core_schema/* ArtistPreSaleLotteryApplicantsConnectionFragmentDoc */.qfF, utoniq_core_schema/* PreSaleItemFilterFragmentDoc */.XAf);
var ARTIST_UPDATE_PRESALE_LOTTERY_APPLICANT_STATUS = (0,lib/* gql */.Ps)(ConsoleLotteryManagements_viewModel_templateObject1(), utoniq_core_schema/* ArtistPreSaleLotteryApplicantDetailFragmentDoc */.CKM);
var UPDATE_PRESALE_LOTTERY_RESULT_NOTICED_AT = (0,lib/* gql */.Ps)(ConsoleLotteryManagements_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleLotteryManagements/index.tsx




/**
 * ConsoleLotteryManagements Page
 * Implemented as a practical sample.
 */ var ConsoleLotteryManagements = function() {
    var ref = ConsoleLotteryManagements_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleLotteryManagementsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/AvatarGroup/AvatarGroup.js
var AvatarGroup = __webpack_require__(85396);
;// CONCATENATED MODULE: ./src/components/organisms/membership/MembershipCategory/index.tsx





var MembershipCategory = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipDetail").t;
    var ref = (0,react.useMemo)(function() {
        if (status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active) {
            return {
                label: t("published"),
                bgcolor: "primary.main"
            };
        }
        return {
            label: t("unpublish"),
            bgcolor: "grey.300"
        };
    }, [
        t,
        status
    ]), label = ref.label, bgcolor = ref.bgcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 16,
            borderRadius: "2px",
            bgcolor: bgcolor,
            py: 1,
            px: "2px",
            ".MuiChip-label": {
                px: 0
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "white",
            variant: "overline",
            display: "block",
            children: label
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/membership/MembershipProductBox/index.tsx









var MembershipProductBox = function(param) {
    var product = param.product, isDetail = param.isDetail;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipDetail").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var memberships = product.plans.reduce(function(acc, test) {
        var ref;
        acc.members = (0,src_to_consumable_array/* default */.Z)(acc.members).concat((0,src_to_consumable_array/* default */.Z)(((ref = test.patrons) === null || ref === void 0 ? void 0 : ref.edges) || []));
        acc.patronCount += test.patronCount || 0;
        return acc;
    }, {
        members: [],
        patronCount: 0
    });
    var isPublish = (0,react.useMemo)(function() {
        return product.plans.some(function(plan) {
            return plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
        });
    }, [
        product.plans
    ]);
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                bgcolor: "background.default",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "grey.100",
                borderRadius: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    title: product.title,
                    titleTypographyProps: {
                        variant: "h5"
                    },
                    action: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCategory, {
                        status: isPublish ? utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active : utoniq_core_schema/* MembershipSubscriptionPlanStatus.Inactive */.DmA.Inactive
                    }),
                    sx: {
                        bgcolor: "grey.50",
                        borderBottom: function(param) {
                            var palette = param.palette;
                            var ref;
                            return "1px solid ".concat(palette === null || palette === void 0 ? void 0 : (ref = palette.grey) === null || ref === void 0 ? void 0 : ref["100"]);
                        },
                        ".MuiCardHeader-action": {
                            m: 0
                        },
                        px: 5,
                        py: 3
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        pt: 4,
                        px: 5,
                        pb: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            sx: {
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: product.plans.map(function(plan) {
                                        return t(plan.interval);
                                    }).join("/")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: product.plans.map(function(plan) {
                                        return t("circle", {
                                            number: plan.formattedAmount
                                        });
                                    }).join("/")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                py: 3
                            },
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("explanation")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        whiteSpace: "pre-line"
                                    },
                                    children: product.content
                                })
                            ]
                        }),
                        !!product.annualContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 3
                            },
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("explanationAnnual")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        whiteSpace: "pre-line"
                                    },
                                    children: product.annualContent
                                })
                            ]
                        }),
                        !isDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    sx: {
                                        pt: 5
                                    },
                                    spacing: 2,
                                    children: [
                                        memberships.members.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarGroup/* default */.Z, {
                                                    max: 3,
                                                    spacing: "small",
                                                    children: memberships.members.splice(0, 3).map(function(param, index) {
                                                        var node = param.node;
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                            src: (ref3 = (ref = node.user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : "",
                                                            sx: {
                                                                width: 36,
                                                                height: 36,
                                                                zIndex: index
                                                            }
                                                        }, index);
                                                    })
                                                }),
                                                !!memberships.patronCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    color: "text.hint",
                                                    variant: "caption",
                                                    children: t("patronCount", {
                                                        patronCount: memberships.patronCount
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.hint",
                                                children: t("noMembership")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                                                    color: "primary",
                                                    href: generatePath(routerPages.ConsoleMembershipDetail, {
                                                        planId: (ref4 = (ref1 = (ref = product.plans) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                                            var planId = param.planId;
                                                            return planId;
                                                        })) === null || ref1 === void 0 ? void 0 : ref1.join(":")) !== null && ref4 !== void 0 ? ref4 : "#"
                                                    }),
                                                    variant: "subtitle1",
                                                    sx: {
                                                        whiteSpace: "pre-line"
                                                    },
                                                    children: t("detail")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                                    color: "primary",
                                                    fontSize: "xSmall"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembership/template/index.tsx



















var ConsoleMembershipTemplate = function(param) {
    var state = param.state, onChangeRequirePersonalInformation = param.onChangeRequirePersonalInformation, onExportCsv = param.onExportCsv;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMemberShip").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref16 = (0,react.useState)(null), anchorEl = ref16[0], setAnchorEl = ref16[1];
    var options = [
        {
            label: ((ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.requirePersonalInformation) ? t("notCollectPersonalInfo") : t("collectPersonalInfo"),
            onClick: function onClick() {
                onChangeRequirePersonalInformation();
                setAnchorEl(null);
            }
        },
        {
            label: t("exportCsv", "CSVエクスポート"),
            disabled: !((ref2 = state.products) === null || ref2 === void 0 ? void 0 : ref2.length),
            onClick: function onClick() {
                onExportCsv();
                setAnchorEl(null);
            }
        }, 
    ];
    var ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMembership
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembership_template_FixedBottomCell, {
                    disabled: ((ref3 = state.products) === null || ref3 === void 0 ? void 0 : ref3.length) >= 3 || state.loading
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 2,
                        px: 5,
                        pb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            direction: "row",
                            spacing: 2,
                            justifyContent: "space-between",
                            alignItems: "center",
                            py: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h3",
                                    width: "100%",
                                    children: t("title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                    edge: "end",
                                    onClick: function(event) {
                                        return setAnchorEl(event.currentTarget);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                            open: !!anchorEl,
                            anchorEl: anchorEl,
                            onClose: function() {
                                return setAnchorEl(null);
                            },
                            transformOrigin: {
                                horizontal: "right",
                                vertical: "top"
                            },
                            anchorOrigin: {
                                horizontal: "right",
                                vertical: "bottom"
                            },
                            children: options.map(function(_param) /*#__PURE__*/ {
                                var label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                                    "label"
                                ]);
                                return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                                    sx: {
                                        width: 200
                                    },
                                    key: label
                                }), label);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                borderColor: "grey.50",
                                borderWidth: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipIconsCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                borderColor: "grey.50",
                                borderWidth: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                pb: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipNoteCell, {
                            loading: state.loading && !state.artist,
                            totalPlan: (ref4 = state.products) === null || ref4 === void 0 ? void 0 : ref4.length,
                            requirePersonalInformation: !!((ref5 = state.artist) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.subscription) === null || ref6 === void 0 ? void 0 : ref6.requirePersonalInformation),
                            totalFavoriteMembers: state.totalFavoriteMembers,
                            enableFavoriteMembers: (ref17 = (ref7 = state.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.settings) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.features) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : ref10.enableFavoriteMembers) !== null && ref17 !== void 0 ? ref17 : false,
                            enableDigitalMembershipCard: !!((ref11 = state.artist) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.settings) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.features) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.subscription) === null || ref14 === void 0 ? void 0 : ref14.enableDigitalMembershipCard)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            loading: state.loading,
                            hasNextPage: false,
                            componentProps: {
                                spacing: 6
                            },
                            onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2
                                    ];
                                });
                            }),
                            nodes: (ref15 = state.products) === null || ref15 === void 0 ? void 0 : ref15.map(function(product, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipProductBox, {
                                    product: product
                                }, [
                                    product.productId,
                                    index
                                ].join(":"));
                            }),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 6,
                                children: [
                                    0,
                                    1
                                ].map(function(_) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        height: 280,
                                        sx: {
                                            borderRadius: 2
                                        }
                                    }, _);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var MembershipNoteCell = function(param) {
    var loading = param.loading, requirePersonalInformation = param.requirePersonalInformation, enableDigitalMembershipCard = param.enableDigitalMembershipCard, totalPlan = param.totalPlan, totalFavoriteMembers = param.totalFavoriteMembers, enableFavoriteMembers = param.enableFavoriteMembers;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMemberShip").t;
    if (loading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    py: 3,
                    px: 5,
                    "&:last-child": {
                        pb: 3
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        pb: 1,
                        children: t("addedPlanNumber", {
                            number: totalPlan || "-"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        pb: 1,
                        children: [
                            t("personalInfo"),
                            requirePersonalInformation ? t("collect") : t("uncollect")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("favoriteMembers", {
                            status: enableFavoriteMembers ? t("enabled") : t("disabled"),
                            number: totalFavoriteMembers
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("digitalMembershipCardStatus", {
                            status: enableDigitalMembershipCard ? t("enabled") : t("disabled")
                        })
                    })
                ]
            })
        })
    });
};
var MembershipIconButton = function(param) {
    var icon = param.icon, label = param.label, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: {
                        xs: "100%",
                        sm: 164
                    },
                    height: {
                        xs: 48,
                        sm: 64
                    },
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        width: {
                            xs: 36,
                            sm: 44
                        },
                        height: {
                            xs: 36,
                            sm: 44
                        },
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "grey.50",
                        cursor: "pointer",
                        "&:hover": {
                            bgcolor: "grey.300"
                        }
                    },
                    children: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.secondary",
                textAlign: "center",
                sx: {
                    fontSize: {
                        xs: "10px",
                        sm: "13px"
                    }
                },
                children: label
            })
        ]
    });
};
var MembershipIconsCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMemberShip").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var iconButtons = [
        // TODO: UT-19975 カスタム項目管理を実装したら追加する
        // {
        //   icon: <Icons.Survey sx={{ fontSize: 24, color: 'grey.700' }} />,
        //   label: t('customItemManagement'),
        //   onClick: undefined, // 現在はクリックイベントなし
        // },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Group, {
                sx: {
                    fontSize: 24,
                    color: "grey.700"
                }
            }),
            label: t("favoriteMemberSettings"),
            onClick: function() {
                return router.push(routerPages.ConsoleFavoriteMemberSettings);
            }
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembershipCard, {
                sx: {
                    fontSize: 24,
                    color: "grey.700"
                }
            }),
            label: t("digitalMembershipCardSettings"),
            onClick: function() {
                return router.push(routerPages.ConsoleDigitalMembershipCard);
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 2,
            pt: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                backgroundColor: "transparent"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "repeat(".concat(iconButtons.length, ", 1fr)"),
                    gap: 2,
                    p: 2
                },
                children: iconButtons.map(function(button, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipIconButton, {
                        icon: button.icon,
                        label: button.label,
                        onClick: button.onClick
                    }, index);
                })
            })
        })
    });
};
var ConsoleMembership_template_FixedBottomCell = function(param) {
    var disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMemberShip").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                bgcolor: "grey.50",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    minWidth: 244
                },
                disabled: disabled,
                href: routerPages.ConsoleMembershipCreate,
                children: t("addMembership")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembership/viewModel.ts







function ConsoleMembership_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMembership($artistId: ID) {\n    artist(id: $artistId) {\n      id\n      paymentType\n      settings {\n        features {\n          subscription {\n            enableFavoriteMembers\n            enableDigitalMembershipCard\n          }\n        }\n      }\n      subscription {\n        products {\n          productId\n        }\n      }\n      hasArrangingDeliveryItems\n      subscription {\n        requirePersonalInformation\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n    artistFavoriteMembers {\n      id\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembership_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMembership_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistExportPatronsCsv($productIds: [String!]!) {\n    artistExportPatronsCsv(productIds: $productIds) {\n      csvUrl\n    }\n  }\n"
    ]);
    ConsoleMembership_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleMembership_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateSubscriptionRequiredPersonalInformation(\n    $isRequired: Boolean!\n  ) {\n    updateSubscriptionRequirePersonalInformation(isRequired: $isRequired) {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        requirePersonalInformation\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembership_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var ConsoleMembership_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var downloadCsv = useDownloadFile().downloadCsv;
    var ref6 = (0,useQuery/* useQuery */.aM)(ConsoleMembership_viewModel_QUERY, {
        variables: {
            artistId: user === null || user === void 0 ? void 0 : user.uid
        },
        skip: !(user === null || user === void 0 ? void 0 : user.uid)
    }), data = ref6.data, loading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ARTIST_EXPORT_PATRONS_CSV, {
        onCompleted: function onCompleted(param) {
            var artistExportPatronsCsv = param.artistExportPatronsCsv;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(artistExportPatronsCsv === null || artistExportPatronsCsv === void 0 ? void 0 : artistExportPatronsCsv.csvUrl)) {
                                return [
                                    2,
                                    showError(new Error(t("fileNotSaved")))
                                ];
                            }
                            return [
                                4,
                                downloadCsv(artistExportPatronsCsv.csvUrl)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), 1), artistExportPatronsCsv = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_SUBSCRIPTION_REQUIRED_PERSONAL_INFO), 2), updateSubscriptionRequirePersonalInformation = ref8[0], ref9 = ref8[1], ref9 = ref9 !== null ? ref9 : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var products = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            return data.artist.subscription.products;
        }
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            var ref6;
            return data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : ref6.subscription.plans.map(function(plan) {
                return {
                    title: plan.title,
                    content: plan.content,
                    annualContent: null,
                    productId: null,
                    plans: [
                        (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                            interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month
                        })
                    ]
                };
            });
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products
    ]);
    var ref10, ref11, _length, ref12;
    return {
        state: {
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            currentUser: user,
            artist: (ref11 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref11 !== void 0 ? ref11 : null,
            totalFavoriteMembers: (_length = data === null || data === void 0 ? void 0 : data.artistFavoriteMembers.length) !== null && _length !== void 0 ? _length : 0,
            products: products,
            loading: loading,
            membership: (ref12 = data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription) === null || ref5 === void 0 ? void 0 : ref5.products) !== null && ref12 !== void 0 ? ref12 : undefined
        },
        actions: {
            onExportCsv: function onExportCsv() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _productId, productIds;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productIds = products.map(function(product) {
                                    return (_productId = product.productId) !== null && _productId !== void 0 ? _productId : "";
                                }).filter(function(productId) {
                                    return !!productId;
                                });
                                return [
                                    4,
                                    artistExportPatronsCsv({
                                        variables: {
                                            productIds: productIds
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onChangeRequirePersonalInformation: function onChangeRequirePersonalInformation() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, artistClone;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.artist)) return [
                                    2
                                ];
                                artistClone = cloneDeep_default()(data.artist) || {};
                                return [
                                    4,
                                    updateSubscriptionRequirePersonalInformation({
                                        variables: {
                                            isRequired: !((ref = data.artist.subscription) === null || ref === void 0 ? void 0 : ref.requirePersonalInformation)
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var isRequired = param.isRequired;
                                            set_default()(artistClone, "subscription.requirePersonalInformation", isRequired);
                                            return {
                                                updateSubscriptionRequirePersonalInformation: (0,src_object_spread/* default */.Z)({}, artistClone)
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMembership_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMembership_viewModel_templateObject(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp);
var ARTIST_EXPORT_PATRONS_CSV = (0,lib/* gql */.Ps)(ConsoleMembership_viewModel_templateObject1());
var UPDATE_SUBSCRIPTION_REQUIRED_PERSONAL_INFO = (0,lib/* gql */.Ps)(ConsoleMembership_viewModel_templateObject2(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembership/index.tsx




/**
 * ConsoleMembership Page
 * Implemented as a practical sample.
 */ var ConsoleMembership = function() {
    var ref = ConsoleMembership_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembershipTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipCreate/template/components/PriceInputCell.tsx










var PriceInputCell_PriceInputCell = function(param) {
    var watch = param.watch, setValue = param.setValue, control = param.control, register = param.register, hasYearlyPlan = param.hasYearlyPlan;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipCreate").t;
    var ref = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "plans"
    }), planFields = ref.fields;
    var options = [
        {
            value: true,
            label: t("yearlyPaymentAvailable", "年払いあり")
        },
        {
            value: false,
            label: t("yearlyPaymentUnavailable", "年払いなし")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("feeLabel", "会費")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                component: "p",
                variant: "caption",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("feeDesc", "メンバーシップの会費を入力してください。月額費はクレジットカード決済のみ、年額費はコンビニ決済とクレジットカード決済が可能です。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: hasYearlyPlan === option.value ? "contained" : "outlined",
                        sx: {
                            color: hasYearlyPlan === option.value ? "white" : "text.hint"
                        },
                        onClick: function() {
                            if (hasYearlyPlan) {
                                setValue("plans", [
                                    {
                                        interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month,
                                        amount: 480
                                    }, 
                                ], {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("annualContent", null, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            } else {
                                setValue("plans", [
                                    {
                                        interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month,
                                        amount: 480,
                                        membershipNumberPrefix: null
                                    },
                                    {
                                        interval: utoniq_core_schema/* MembershipInterval.Year */.ls9.Year,
                                        amount: 480 * 12,
                                        membershipNumberPrefix: null
                                    }, 
                                ], {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                            }
                        },
                        children: option.label
                    }, index);
                })
            }),
            planFields.map(function(field, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    pt: 2,
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            field.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: t("".concat(field.interval, "lyFee"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                        listItems: monthlyFees,
                                        value: (ref = watch("plans.".concat(index, ".amount"))) === null || ref === void 0 ? void 0 : ref.toString(),
                                        onChange: function(value) {
                                            return setValue("plans.".concat(index, ".amount"), +value);
                                        },
                                        placeholder: t("unselected"),
                                        formControlProps: {
                                            sx: {
                                                minWidth: 164,
                                                width: 164,
                                                pt: 2
                                            }
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    type: "number",
                                    t: t,
                                    titleProps: {
                                        variant: "subtitle1",
                                        color: "text.primary"
                                    }
                                }, register("plans.".concat(index, ".amount"))), {
                                    textFieldProps: {
                                        sx: {
                                            minWidth: 164,
                                            width: 164,
                                            mb: 0
                                        },
                                        FormHelperTextProps: {
                                            sx: {
                                                display: "none"
                                            }
                                        }
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                pt: field.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month ? 6 : 7,
                                children: t("yen")
                            })
                        ]
                    })
                }, field.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: t("feeCaution")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipCreate/template/MembershipCreateForm.tsx













var MembershipCreateForm_schema = function(o) {
    return {
        title: o.string().max(50).allow(null).optional().label((0,core_form/* tLabel */.TQ)("consoleMembershipCreate.title")),
        content: o.string().max(2000).label((0,core_form/* tLabel */.TQ)("consoleMembershipCreate.content")),
        annualContent: o.string().allow(null, "").optional().max(2000).label((0,core_form/* tLabel */.TQ)("consoleMembershipCreate.annualContent")),
        plans: o.array().items({
            amount: o.number(),
            interval: o.string(),
            membershipNumberPrefix: o.string().max(5).optional().allow(null, "").pattern(/^[A-Za-z]*$/).label((0,core_form/* tLabel */.TQ)("consoleMembershipCreate.membershipNumberPrefix"))
        }),
        startMembershipNumber: o.number().integer().min(1).max(99999999).optional().allow(null).label((0,core_form/* tLabel */.TQ)("consoleMembershipCreate.startMembershipNumber"))
    };
};
var MembershipCreateForm = function(param) {
    var onSubmit = param.onSubmit, startMembershipNumber = param.startMembershipNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: MembershipCreateForm_schema,
        defaultValues: MembershipCreateForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue, setError = ref.setError, watch = ref.watch, control = ref.control, _formState = ref.formState, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid, errors = _formState.errors;
    var planWatch = watch("plans");
    var hasYearlyPlan = (planWatch === null || planWatch === void 0 ? void 0 : planWatch.length) === 2;
    var ref1 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "plans"
    }), planFields = ref1.fields;
    (0,react.useEffect)(function() {
        setValue("startMembershipNumber", startMembershipNumber);
    }, [
        startMembershipNumber
    ]);
    var handleOnSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        setError,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "input",
                t: t,
                textFieldProps: {
                    sx: {
                        mb: 0
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInputCell_PriceInputCell, {
                watch: watch,
                setValue: setValue,
                hasYearlyPlan: hasYearlyPlan,
                control: control,
                register: register
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                t: t,
                textFieldProps: {
                    multiline: true,
                    rows: 13,
                    sx: {
                        mb: 0
                    },
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("content")), {
                error: errors === null || errors === void 0 ? void 0 : errors.content
            })),
            hasYearlyPlan && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                t: t,
                textFieldProps: {
                    multiline: true,
                    rows: 13,
                    sx: {
                        mb: 0
                    },
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("annualContent")), {
                error: errors === null || errors === void 0 ? void 0 : errors.annualContent
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("membershipNumberTitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("membershipNumberDesc")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    children: t("membershipNumberPrefixTitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2,
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("membershipNumberPrefixDesc")
                })
            }),
            planFields.map(function(field, index) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "input",
                    t: t,
                    textFieldProps: {
                        sx: {
                            mb: 0
                        },
                        placeholder: t("membershipNumberPrefixPlaceholder")
                    },
                    titleProps: {
                        variant: "h5",
                        color: "text.primary",
                        children: t("".concat(field.interval, "lyMembershipNumberPrefix"))
                    }
                }, register("plans.".concat(index, ".membershipNumberPrefix"))), {
                    error: errors === null || errors === void 0 ? void 0 : (ref = errors.plans) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.membershipNumberPrefix
                }), field.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "input",
                t: t,
                disabled: !!startMembershipNumber,
                textFieldProps: {
                    sx: {
                        mb: 0
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("startMembershipNumberTitle")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: t("startMembershipNumberDesc")
                                })
                            })
                        ]
                    })
                }
            }, register("startMembershipNumber")), {
                error: errors === null || errors === void 0 ? void 0 : errors.startMembershipNumber
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    mt: 7
                },
                children: t("aboutSales")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: "・"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("aboutSalesDetail1")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: "・"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("aboutSalesDetail2")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 4
                },
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        width: 244,
                        py: 3
                    },
                    onClick: handleSubmit(handleOnSubmit),
                    loading: isSubmitting,
                    disabled: !isValid || isSubmitting,
                    children: t("startMembership")
                })
            })
        ]
    });
};
var MembershipCreateForm_defaultValues = {
    title: "",
    content: "",
    annualContent: null,
    plans: [
        {
            amount: 480,
            interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month,
            membershipNumberPrefix: null
        }, 
    ],
    startMembershipNumber: null
};
var monthlyFees = [
    300,
    480,
    500,
    780,
    800,
    980,
    1000,
    1180,
    1200,
    5000,
    8000,
    10000, 
].map(function(amount) {
    return {
        value: amount.toString(),
        label: amount.toString()
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipCreate/template/index.tsx









var ConsoleMembershipCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMembershipCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMembership,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            px: 5,
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("membershipTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "p",
                                variant: "caption",
                                color: "text.secondary",
                                sx: {
                                    pt: 2
                                },
                                children: t("titleDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCreateForm, {
                        startMembershipNumber: state.startMembershipNumber,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipCreate/viewModel.ts







function ConsoleMembershipCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleArtistSubscriptionStartMembershipNumber($artistId: ID) {\n    artist(id: $artistId) {\n      id\n      subscription {\n        startMembershipNumber\n      }\n    }\n  }\n"
    ]);
    ConsoleMembershipCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMembershipCreate_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistRegisterSubscription($inputs: RegisterSubscriptionsInput!) {\n    artistRegisterSubscriptions(inputs: $inputs) {\n      id\n      subscription {\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembershipCreate_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ConsoleMembershipCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipCreate").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleMembershipCreate_viewModel_QUERY, {
        variables: {
            artistId: user === null || user === void 0 ? void 0 : user.uid
        },
        skip: !(user === null || user === void 0 ? void 0 : user.uid)
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_REGISTER_SUBSCRIPTION), 1), artistRegisterSubscription = ref4[0];
    var ref5, ref6;
    return {
        state: {
            artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
            startMembershipNumber: (ref6 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.startMembershipNumber) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {
            onSubmit: function onSubmit(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, plans, rest, _membershipNumberPrefix, plansWithMembershipNumberPrefix, _startMembershipNumber;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                plans = inputs.plans, rest = (0,_object_without_properties/* default */.Z)(inputs, [
                                    "plans"
                                ]);
                                plansWithMembershipNumberPrefix = plans.map(function(plan) {
                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                                        membershipNumberPrefix: (_membershipNumberPrefix = plan.membershipNumberPrefix) !== null && _membershipNumberPrefix !== void 0 ? _membershipNumberPrefix : null
                                    });
                                });
                                return [
                                    4,
                                    artistRegisterSubscription({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
                                                plans: plansWithMembershipNumberPrefix,
                                                startMembershipNumber: rest.startMembershipNumber === (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.startMembershipNumber) ? null : (_startMembershipNumber = rest.startMembershipNumber) !== null && _startMembershipNumber !== void 0 ? _startMembershipNumber : null
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("registerSubscriptionSuccess"));
                                router.replace(routerPages.ConsoleMembership);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMembershipCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMembershipCreate_viewModel_templateObject());
var ARTIST_REGISTER_SUBSCRIPTION = (0,lib/* gql */.Ps)(ConsoleMembershipCreate_viewModel_templateObject1(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipCreate/index.tsx




/**
 * ConsoleMembershipCreate Page
 * Implemented as a practical sample.
 */ var ConsoleMembershipCreate = function() {
    var ref = ConsoleMembershipCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembershipCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/MemberWhetTag/index.tsx




var MemberWhetTag = function(param) {
    var month = param.month;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var ref = (0,react.useMemo)(function() {
        if (month === 1) {
            return {
                bgcolor: "primary.light",
                color: "black"
            };
        }
        if (month > 3) {
            return {
                bgcolor: "primary.main",
                color: "white"
            };
        }
        return {
            bgcolor: "primary.dark",
            color: "white"
        };
    }, [
        month
    ]), bgcolor = ref.bgcolor, color = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 16,
            borderRadius: "2px",
            py: 1,
            bgcolor: bgcolor
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            display: "block",
            sx: {
                color: color,
                textTransform: "unset"
            },
            children: t("monthContinuation", {
                month: month
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipDetail/template/index.tsx














var ConsoleMembershipDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onExportCsv = param.onExportCsv;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipDetail").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMembershipDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMembership,
                    title: (ref = state.product) === null || ref === void 0 ? void 0 : ref.title,
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            mr: -2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                            size: "small",
                            color: "white",
                            href: generatePath(routerPages.ConsoleMembershipEdit, {
                                planId: state.planId
                            })
                        })
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2,
                            pb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    pt: 4,
                                    pb: 3
                                },
                                children: t("membershipDetails")
                            }),
                            state.product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipProductBox, {
                                isDetail: true,
                                product: state.product
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 360
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberContents, {
                        members: state.members,
                        enableFavoriteMembers: state.enableFavoriteMembers,
                        loading: state.loading || state.refetching,
                        hasNextPage: state.hasNextPage,
                        patronCount: state.patronCount,
                        product: state.product,
                        onFetchMore: onFetchMore,
                        onExportCsv: onExportCsv
                    })
                ]
            })
        ]
    });
};
var MemberContents = function(param) {
    var members = param.members, enableFavoriteMembers = param.enableFavoriteMembers, loading = param.loading, patronCount = param.patronCount, hasNextPage = param.hasNextPage, product = param.product, onFetchMore = param.onFetchMore, onExportCsv = param.onExportCsv;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipDetail").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var getPlanInterval = (0,react.useCallback)(function(planId) {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.plans) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
            return plan.planId === planId;
        })) === null || ref1 === void 0 ? void 0 : ref1.interval;
    }, [
        product
    ]);
    // 会員番号の表示判定
    // 会員番号は全員あるかないかの二択のため、最初のメンバーの会員番号の有無で判定
    var shouldShowMemberNumber = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return members === null || members === void 0 ? void 0 : (ref = members.edges) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.node) === null || ref2 === void 0 ? void 0 : ref2.formattedMembershipNumber;
    }, [
        members === null || members === void 0 ? void 0 : members.edges
    ]);
    var ref2, _continueMonth, _paymentMethod, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("registeredMemberNumber")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.hint",
                                children: t("people", {
                                    people: patronCount
                                })
                            })
                        ]
                    }),
                    !!(product === null || product === void 0 ? void 0 : product.productId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                edge: "end",
                                onClick: function(event) {
                                    return setAnchorEl(event.currentTarget);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                open: !!anchorEl,
                                anchorEl: anchorEl,
                                onClose: function() {
                                    return setAnchorEl(null);
                                },
                                transformOrigin: {
                                    horizontal: "right",
                                    vertical: "top"
                                },
                                anchorOrigin: {
                                    horizontal: "right",
                                    vertical: "bottom"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                    sx: {
                                        minWidth: 200
                                    },
                                    disabled: !(members === null || members === void 0 ? void 0 : (ref = members.edges) === null || ref === void 0 ? void 0 : ref.length),
                                    onClick: function() {
                                        var ref;
                                        onExportCsv((ref = product === null || product === void 0 ? void 0 : product.productId) !== null && ref !== void 0 ? ref : "");
                                        setAnchorEl(null);
                                    },
                                    children: t("exportCsv", "CSVエクスポート")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 0,
                                            minWidth: 116
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("username", "ユーザー名")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("fullName", "氏名")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("email", "メールアドレス")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("gender", "性別")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("birthday", "生年月日")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("phoneNumber", "電話番号")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            py: 2,
                                            px: 1,
                                            minWidth: 80
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("address", "住所")
                                        })
                                    }),
                                    shouldShowMemberNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 84,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("memberNumber", "会員番号")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 120,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("durationMembershipDate", "継続期間/入会日")
                                        })
                                    }),
                                    enableFavoriteMembers && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 84,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("favoriteMember", "推しメンバー")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 84,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("paymentMethod", "支払い方法")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 80,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("orderPerPurchase", "注文/購入回数")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: "none",
                                            minWidth: 80,
                                            py: 2,
                                            px: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            component: "p",
                                            children: t("ownedPerUnused", "所有アイテム/\n未使用チケット")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                            nodes: members === null || members === void 0 ? void 0 : members.edges.map(function(param) {
                                var node = param.node;
                                var ref, ref1, ref5, ref6;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                px: 0,
                                                minWidth: 116
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                sx: {
                                                    maxWidth: "100%",
                                                    width: 116
                                                },
                                                spacing: 2,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        src: (ref2 = (ref = node.user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                                                        sx: {
                                                            width: 28,
                                                            height: 28
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                        children: node.user.displayName
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0,
                                                    width: 100
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.user.fullName
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0,
                                                    width: 100
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.user.email
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                children: !node.user.gender ? "" : t("gender_".concat(node.user.gender))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0,
                                                    width: 100
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.user.formattedBirthday
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0,
                                                    width: 100
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.user.formattedPhoneNumber
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0,
                                                    width: 100
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: (ref1 = node.user.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress
                                                })
                                            })
                                        }),
                                        shouldShowMemberNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                children: node.formattedMembershipNumber || ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberWhetTag, {
                                                        month: (_continueMonth = node.continueMonth) !== null && _continueMonth !== void 0 ? _continueMonth : 0
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.secondary",
                                                        children: node.formattedCreatedAt
                                                    })
                                                ]
                                            })
                                        }),
                                        enableFavoriteMembers && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                children: ((ref5 = node.favoriteMember) === null || ref5 === void 0 ? void 0 : ref5.name) || ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                children: t("".concat((_paymentMethod = node.paymentMethod) !== null && _paymentMethod !== void 0 ? _paymentMethod : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard, "_").concat((ref4 = getPlanInterval((ref3 = (ref6 = node.subscription) === null || ref6 === void 0 ? void 0 : ref6.planId) !== null && ref3 !== void 0 ? ref3 : "")) !== null && ref4 !== void 0 ? ref4 : utoniq_core_schema/* MembershipInterval.Month */.ls9.Month))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.purchaseCount
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TableCellCustom, {
                                            userId: node.user.id,
                                            sx: {
                                                minWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: node.ticketUnusedCount
                                                })
                                            })
                                        })
                                    ]
                                }, node.user.id);
                            }),
                            loading: loading,
                            hasNextPage: hasNextPage,
                            onFetchMore: onFetchMore,
                            colSpan: 12,
                            component: TableRow/* default */.Z,
                            emptyMessage: t("noMember"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: Array.from(Array(3).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                            variant: "circular",
                                                            width: 28,
                                                            height: 28
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "medium",
                                                            width: "80%"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "caption",
                                                    width: 60
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    px: 0,
                                                    py: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "caption",
                                                        width: 60
                                                    })
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var template_TableCellCustom = function(param) {
    var userId = param.userId, children = param.children, sx = param.sx;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            px: 1,
            py: 3
        }, sx),
        onClick: function() {
            return router.push(generatePath(routerPages.ConsoleUserDetail, {
                userId: userId
            }));
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipEdit/viewModel.ts






function ConsoleMembershipEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMembershipEdit {\n    artist {\n      id\n      subscription {\n        productId\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembershipEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMembershipEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateSubscription(\n    $artistId: ID!\n    $inputs: UpdateSubscriptionInput!\n  ) {\n    updateSubscription(artistId: $artistId, inputs: $inputs) {\n      id\n      subscription {\n        productId\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembershipEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ConsoleMembershipEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipEdit").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var planIds = router.query.planId.split(":");
    var data = (0,useQuery/* useQuery */.aM)(ConsoleMembershipEdit_viewModel_QUERY).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_SUBSCRIPTION), 1), updateSubscription = ref1[0];
    var product = (0,react.useMemo)(function() {
        return getProductByPlanId(data === null || data === void 0 ? void 0 : data.artist, planIds[0]);
    }, [
        data === null || data === void 0 ? void 0 : data.artist
    ]);
    var ref2;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            product: product
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var content = param.content, title = param.title, annualContent = param.annualContent;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var productId, inputs, ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productId = product === null || product === void 0 ? void 0 : product.productId;
                                inputs = {
                                    title: title,
                                    content: content,
                                    annualContent: annualContent
                                };
                                if (productId) {
                                    inputs.productId = productId;
                                } else {
                                    ;
                                    inputs.planId = planIds[0];
                                    inputs.productId = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.productId;
                                }
                                return [
                                    4,
                                    updateSubscription({
                                        variables: {
                                            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
                                            inputs: inputs
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("updateSubscriptionSuccess"));
                                router.goBack(routerPages.ConsoleMembership);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMembershipEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMembershipEdit_viewModel_templateObject(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp);
var UPDATE_SUBSCRIPTION = (0,lib/* gql */.Ps)(ConsoleMembershipEdit_viewModel_templateObject1(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp);
function getProductByPlanId(artist, planId) {
    var ref, ref1, ref2, ref3;
    if (artist === null || artist === void 0 ? void 0 : (ref = artist.subscription) === null || ref === void 0 ? void 0 : (ref1 = ref.plans) === null || ref1 === void 0 ? void 0 : ref1.length) {
        var plan = artist.subscription.plans.find(function(plan) {
            return plan.planId === planId;
        });
        if (!plan) {
            return null;
        }
        return {
            productId: undefined,
            content: plan.content,
            title: plan.title,
            plan: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month
            }),
            plans: [
                (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                    interval: utoniq_core_schema/* MembershipInterval.Month */.ls9.Month
                }), 
            ]
        };
    }
    if (artist === null || artist === void 0 ? void 0 : (ref2 = artist.subscription) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.length) {
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(artist, planId);
    }
    return null;
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipDetail/viewModel.ts




function ConsoleMembershipDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMembershipDetail(\n    $filters: PatronsFilters\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n  ) {\n    artist {\n      id\n      settings {\n        features {\n          subscription {\n            enableFavoriteMembers\n          }\n        }\n      }\n      subscription {\n        productId\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n      patrons(\n        filters: $filters\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n      ) {\n        edges {\n          node {\n            ...MemberBox\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hits\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleMembershipDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ConsoleMembershipDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var downloadCsv = useDownloadFile().downloadCsv;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var planIds = router.query.planId.split(":");
    var ref11 = (0,useQuery/* useQuery */.aM)(ConsoleMembershipDetail_viewModel_QUERY, {
        variables: {
            filters: {
                planIds: planIds
            },
            pageInput: {
                limit: 10
            },
            pageInputById: {
                limit: 10
            }
        },
        notifyOnNetworkStatusChange: true
    }), data = ref11.data, networkStatus = ref11.networkStatus, fetchMore = ref11.fetchMore;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(utoniq_core_schema/* ArtistExportPatronsCsv */.j2w, {
        onCompleted: function onCompleted(param) {
            var artistExportPatronsCsv = param.artistExportPatronsCsv;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(artistExportPatronsCsv === null || artistExportPatronsCsv === void 0 ? void 0 : artistExportPatronsCsv.csvUrl)) {
                                return [
                                    2,
                                    showError(new Error(t("fileNotSaved")))
                                ];
                            }
                            return [
                                4,
                                downloadCsv(artistExportPatronsCsv.csvUrl)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), 1), artistExportPatronsCsv = ref12[0];
    var product = (0,react.useMemo)(function() {
        return getProductByPlanId(data === null || data === void 0 ? void 0 : data.artist, planIds[0]);
    }, [
        data === null || data === void 0 ? void 0 : data.artist,
        planIds
    ]);
    var ref13, ref14, ref15, ref16;
    return {
        state: {
            artistId: (ref13 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref13 !== void 0 ? ref13 : "",
            enableFavoriteMembers: (ref14 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.enableFavoriteMembers) !== null && ref14 !== void 0 ? ref14 : false,
            planId: router.query.planId,
            members: (ref15 = data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : ref4.patrons) !== null && ref15 !== void 0 ? ref15 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.patrons) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pageInfo) === null || ref7 === void 0 ? void 0 : ref7.hasNextPage),
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            product: product,
            patronCount: (ref16 = data === null || data === void 0 ? void 0 : (ref8 = data.artist) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.patrons) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.pageInfo) === null || ref10 === void 0 ? void 0 : ref10.hits) !== null && ref16 !== void 0 ? ref16 : 0
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            filters: {
                                                planIds: planIds
                                            },
                                            // NOTE: 後方互換性のために残す。utoniqPaginationのmerge処理に必要なため削除NG
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patrons) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor,
                                                limit: 10
                                            },
                                            pageInputById: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.patrons) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor,
                                                limit: 10
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onExportCsv: function onExportCsv(productId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistExportPatronsCsv({
                                        variables: {
                                            productIds: [
                                                productId
                                            ]
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMembershipDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMembershipDetail_viewModel_templateObject(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp, utoniq_core_schema/* MemberBoxFragmentDoc */.M1b);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipDetail/index.tsx




/**
 * ConsoleMembershipDetail Page
 * Implemented as a practical sample.
 */ var ConsoleMembershipDetail = function() {
    var ref = ConsoleMembershipDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembershipDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipEdit/template/MembershipEditForm.tsx









var MembershipEditForm_schema = function(o) {
    return {
        title: o.string().max(50).allow(null).optional().label((0,core_form/* tLabel */.TQ)("consoleMembershipEdit.title")),
        content: o.string().max(2000).label((0,core_form/* tLabel */.TQ)("consoleMembershipEdit.content")),
        annualContent: o.string().allow(null, "").optional().max(2000).label((0,core_form/* tLabel */.TQ)("consoleMembershipEdit.annualContent"))
    };
};
var MembershipEditForm = function(param) {
    var onSubmit = param.onSubmit, product = param.product;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipEdit").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: MembershipEditForm_schema,
        defaultValues: MembershipEditForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, setError = ref1.setError, reset = ref1.reset, _formState = ref1.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid;
    (0,react.useEffect)(function() {
        if (product) {
            reset({
                title: product.title,
                content: product.content,
                annualContent: product.annualContent
            });
        }
    }, [
        product
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit(values).catch(function(error) {
            (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    var _interval;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "input",
                t: t,
                textFieldProps: {
                    sx: {
                        mb: 0
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                pb: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: product === null || product === void 0 ? void 0 : product.plans.map(function(plan) {
                            return t("".concat((_interval = plan.interval) !== null && _interval !== void 0 ? _interval : utoniq_core_schema/* MembershipInterval.Month */.ls9.Month, "lyFee"));
                        }).join("/")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: product === null || product === void 0 ? void 0 : product.plans.map(function(plan) {
                            return "".concat(plan.formattedAmount).concat(t("yen"));
                        }).join("/")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                t: t,
                textFieldProps: {
                    multiline: true,
                    rows: 13,
                    sx: {
                        mb: 0
                    },
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("content")), {
                error: errors === null || errors === void 0 ? void 0 : errors.content
            })),
            (product === null || product === void 0 ? void 0 : product.plans) && (product === null || product === void 0 ? void 0 : (ref = product.plans) === null || ref === void 0 ? void 0 : ref.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                t: t,
                textFieldProps: {
                    multiline: true,
                    rows: 13,
                    sx: {
                        mb: 0
                    },
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                }
            }, register("annualContent")), {
                error: errors === null || errors === void 0 ? void 0 : errors.annualContent
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    mt: 7
                },
                children: t("aboutSales")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: "・"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("aboutSalesDetail1")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: "・"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("aboutSalesDetail2")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 6,
                    mb: 4
                },
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        width: 244,
                        py: 3
                    },
                    onClick: handleOnSubmit,
                    loading: isSubmitting,
                    disabled: !isValid || isSubmitting,
                    children: t("change")
                })
            })
        ]
    });
};
var MembershipEditForm_defaultValues = {
    content: "",
    title: "",
    annualContent: null
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipEdit/template/index.tsx








var ConsoleMembershipEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipEdit").t;
    var _planId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMembershipEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleMembershipDetail, {
                        planId: (_planId = router.query.planId) !== null && _planId !== void 0 ? _planId : "#"
                    }),
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            px: 5,
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("membershipDesc")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "p",
                                variant: "caption",
                                color: "text.secondary",
                                sx: {
                                    pt: 2
                                },
                                children: t("enterMembershipDesc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipEditForm, {
                        product: state.product,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipEdit/index.tsx




/**
 * ConsoleMembershipEdit Page
 * Implemented as a practical sample.
 */ var ConsoleMembershipEdit = function() {
    var ref = ConsoleMembershipEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembershipEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipExplain/template/index.tsx











var ConsoleMembershipExplainTemplate = function(param) {
    var state = param.state;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipExplain").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMembershipExplain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleDashboard,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            mx: 5,
                            mt: 7
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h2",
                                children: t("monthlyMembership")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                sx: {
                                    mt: 2
                                },
                                children: t("content")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mt: 6,
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h4",
                                    children: t("membership")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                sx: {
                                    mt: 2,
                                    mb: 4
                                },
                                children: t("functions")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCell, {
                        app: state.app,
                        loading: state.loading
                    })
                ]
            })
        ]
    });
};
var FeatureCell = function(param) {
    var app = param.app, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMembershipExplain").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var features = [
        {
            title: t("postLimit"),
            content: t("postLimitDetail")
        },
        {
            title: t("saleLimit"),
            content: t("saleLimitDetail")
        },
        {
            title: t("communityPost"),
            content: t("communityPostDetail")
        },
        {
            title: t("membershipManagement"),
            content: t("membershipManagementDetail")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    pb: 1,
                    px: 5,
                    pt: 2
                },
                children: features.map(function(feature, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                style: {
                                    borderRadius: "50%"
                                },
                                target: "common",
                                src: "images/console/membershipExplain_".concat(index + 1, ".png"),
                                width: 120,
                                height: 120
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h4",
                                        children: feature.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: feature.content
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            app && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 5,
                    mb: 4,
                    mx: 5,
                    borderRadius: 2,
                    border: 1,
                    borderColor: "grey.100",
                    pt: 5,
                    px: 7,
                    pb: "64px"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("cannotOpen")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.hint",
                        sx: {
                            mt: 4
                        },
                        children: t("searchBrowser")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Search, {
                                fontSize: "medium"
                            })
                        }),
                        sx: {
                            width: 275,
                            mt: 2
                        },
                        disabled: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            width: "100%",
                            sx: {
                                ml: 7
                            },
                            children: app
                        })
                    })
                ]
            }),
            !app && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                sx: {
                    my: 8,
                    pb: "56px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        width: 244
                    },
                    disabled: !config_config/* config.modules.membership */.v.modules.membership,
                    href: routerPages.ConsoleMembershipCreate,
                    children: t("openMembership")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipExplain/viewModel.ts

function ConsoleMembershipExplain_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMembershipExplain {\n    artist {\n      id\n      subscription {\n        amount\n        content\n        status\n        productId\n        playstore {\n          productId\n        }\n        appstore {\n          productId\n        }\n      }\n    }\n  }\n"
    ]);
    ConsoleMembershipExplain_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ConsoleMembershipExplain_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleMembershipExplain_viewModel_QUERY), data = ref1.data, loading = ref1.loading;
    var app = (0,react.useMemo)(function() {
        var ref;
        return getAppNameByPlatformAndSubscription(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.subscription);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.subscription
    ]);
    var ref2;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            app: app,
            loading: loading
        },
        actions: {}
    };
});
var ConsoleMembershipExplain_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMembershipExplain_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMembershipExplain/index.tsx



/**
 * ConsoleMembershipExplain Page
 * Implemented as a practical sample.
 */ var ConsoleMembershipExplain = function() {
    var state = ConsoleMembershipExplain_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMembershipExplainTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/ItemSelectBox.tsx









var template_ItemSelectBox_ItemSelectBox = function(param) {
    var checked = param.checked, item = param.item, onSelect = param.onSelect, onClose = param.onClose;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref1, _issuedNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2,
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: checked ? "primary.main" : "grey.50",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    alignItems: "center",
                    children: [
                        checked !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: checked,
                            value: checked,
                            disableRipple: true,
                            sx: {
                                "&.Mui-checked svg": {
                                    color: "primary.main"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "small",
                            src: (ref1 = (ref = item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            alignSelf: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                                    salesCondition: item.salesCondition,
                                    isPublished: item.isPublished,
                                    isDrm: item.isDrm,
                                    isPremium: item.isPremium
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)), {
                                        mt: 1
                                    }),
                                    children: t("issuedNumber", {
                                        number: (_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞"
                                    })
                                })
                            ]
                        }),
                        onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignSelf: "flex-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                size: "xSmall",
                                onClick: onClose
                            })
                        })
                    ]
                })
            }),
            onSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                onClick: function() {
                    return onSelect(item.id);
                },
                sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2
                }
            })
        ]
    });
};
var template_ItemSelectBox_ItemSelectBoxSkeleton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 60,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignSelf: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                numberOfLine: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    pt: 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "50%"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/ItemSelectForm.tsx










var template_ItemSelectForm_schema = function(o) {
    return {
        keyword: o.string().allow("").optional()
    };
};
var ItemSelectForm_ItemSelectForm = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: template_ItemSelectForm_schema,
        defaultValues: template_ItemSelectForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var keyword = param.keyword;
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, template_ItemSelectForm_defaultValues), {
            keyword: keyword
        }));
    }), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemSelectForm_SearchInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("keyword")), {
            onChange: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setValue("keyword", event.target.value);
                                return [
                                    4,
                                    handleChangeKeywordDebounce.current()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }()
        }))
    });
};
var template_ItemSelectForm_SearchInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SearchInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var template_ItemSelectForm_defaultValues = {
    keyword: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/ItemSelectModal.tsx











var ItemSelectModal_ItemSelectModal = function(param) {
    var artistId = param.artistId, open = param.open, value = param.value, onClose = param.onClose, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, items = param.items, onSearch = param.onSearch, onSelect = param.onSelect;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref = (0,react.useState)(""), itemSelected = ref[0], setItemSelected = ref[1];
    (0,react.useEffect)(function() {
        setItemSelected(value);
    }, [
        value
    ]);
    var handleSelect = (0,react.useCallback)(function(itemId) {
        setItemSelected(function(prevState) {
            return prevState === itemId ? "" : itemId;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
            artistId: artistId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                customNavigation: itemSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemSelectModal_FixedBottomCell, {
                    onSelect: function() {
                        return onSelect(itemSelected);
                    }
                }) : null,
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        edge: "start",
                        size: "medium",
                        color: "white",
                        sx: {
                            color: "white",
                            ".MuiSvgIcon-root": {
                                color: "inherit"
                            }
                        },
                        onClick: function() {
                            onClose();
                            setItemSelected(value);
                        }
                    }),
                    title: t("itemSelection")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectForm_ItemSelectForm, {
                        onSubmit: onSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: items === null || items === void 0 ? void 0 : items.edges.map(function(param) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemSelectBox_ItemSelectBox, {
                                item: node,
                                checked: itemSelected === node.id,
                                onSelect: handleSelect
                            }, node.id);
                        }),
                        emptyMessage: t("emptyItemSelect"),
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pb: 2
                            },
                            children: Array.from(Array(4).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemSelectBox_ItemSelectBoxSkeleton, {}, key);
                            })
                        })
                    })
                ]
            })
        })
    });
};
var template_ItemSelectModal_FixedBottomCell = function(param) {
    var onSelect = param.onSelect;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            bgcolor: "grey.50",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 244
            },
            onClick: onSelect,
            children: t("addSelectedItem")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/MissionCreateForm.tsx

















var MissionCreateForm_schema = function(o) {
    return {
        title: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.title")),
        description: o.string().max(500).label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.description")),
        content: o.object().when("type", {
            is: utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
            then: o.object().when("isNoQuiz", {
                is: true,
                then: o.object({
                    image: o.object({
                        uri: o.string().allow("").optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.image.uri"))
                    }),
                    answer: o.string().max(50).allow("").optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.answer"))
                }),
                otherwise: o.object({
                    image: o.object({
                        uri: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.image.uri"))
                    }),
                    answer: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.answer"))
                })
            }),
            otherwise: o.object().allow(null).optional()
        }),
        startedAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.startedAt")),
        expiredAt: o.date().optional().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.expiredAt")),
        type: o.string(),
        isPublished: o.boolean(),
        reward: o.object({
            item: o.object({
                id: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.reward.item.id"))
            }).allow(null).optional(),
            gachaTicket: o.object({
                gachaTicketId: o.string(),
                count: o.number()
            }).allow(null).optional()
        }),
        gpsData: o.object().when("hasCheckIn", {
            is: true,
            then: o.object({
                latitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.gpsData.latitude")),
                longitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.gpsData.longitude")),
                approximateAddress: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.gpsData.approximateAddress")),
                radius: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionCreate.gpsData.radius"))
            }),
            otherwise: o.object().allow(null).optional()
        }),
        //local field
        isNoQuiz: o.boolean().optional(),
        contentResource: o.object().allow(null).optional(),
        hasCheckIn: o.boolean().allow(false).optional()
    };
};
var MissionCreateForm = function(param) {
    var loading = param.loading, artistId = param.artistId, items = param.items, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, onSubmit = param.onSubmit, missionType = param.missionType, onSearch = param.onSearch, onPlaceSearch = param.onPlaceSearch, predictions = param.predictions, place = param.place, onSelectPlace = param.onSelectPlace, fileUploadInfo = param.fileUploadInfo, gpsClientInfo = param.gpsClientInfo, onRequestGPSPermission = param.onRequestGPSPermission, removePlace = param.removePlace;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref5 = (0,core_form/* useForm */.cI)({
        schema: MissionCreateForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, MissionCreateForm_defaultValues), {
            type: missionType
        })
    }), handleSubmit = ref5.handleSubmit, _formState = ref5.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid, register = ref5.register, setValue = ref5.setValue, watch = ref5.watch, setError = ref5.setError, trigger = ref5.trigger;
    var _ref = register("isNoQuiz"), isNoQuizRef = _ref.ref, restIsNoQuiz = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref"
    ]);
    var isNoQuizWatch = watch("isNoQuiz");
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(_param) {
            var hasCheckIn, gpsData, content, isNoQuiz, values;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasCheckIn = _param.hasCheckIn, gpsData = _param.gpsData, content = _param.content, isNoQuiz = _param.isNoQuiz, values = (0,_object_without_properties/* default */.Z)(_param, [
                            "hasCheckIn",
                            "gpsData",
                            "content",
                            "isNoQuiz"
                        ]);
                        return [
                            4,
                            onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                                hasCheckIn: hasCheckIn,
                                gpsData: hasCheckIn ? gpsData : null,
                                content: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, content), {
                                    image: !isNoQuiz ? content.image : {
                                        uri: ""
                                    },
                                    answer: !isNoQuiz ? content.answer : ""
                                })
                            })).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("title")), {
                error: errors.title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("description")), {
                error: errors.description
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckInInputCell, {
                setValue: setValue,
                artistId: artistId,
                value: watch("gpsData"),
                hasCheckIn: watch("hasCheckIn"),
                gpsClientInfo: gpsClientInfo,
                onPlaceSearch: onPlaceSearch,
                predictions: predictions,
                place: place,
                onSelectPlace: onSelectPlace,
                onRequestGPSPermission: onRequestGPSPermission,
                removePlace: removePlace,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: (ref = errors.gpsData) === null || ref === void 0 ? void 0 : ref.radius,
                    mask: "00000m"
                }, register("gpsData.radius")),
                inputApproximateAddressProps: (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: (ref1 = errors.gpsData) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                }, register("gpsData.approximateAddress"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("noQuizTitle"),
                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        children: t("noQuizNote")
                    })
                },
                checked: isNoQuizWatch,
                inputRef: isNoQuizRef,
                sx: {
                    mx: -2,
                    mt: 4,
                    mb: -5
                }
            }, restIsNoQuiz), {
                onChange: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue("isNoQuiz", event.target.checked, {
                                        shouldValidate: true,
                                        shouldDirty: true
                                    });
                                    return [
                                        4,
                                        trigger([
                                            "content.answer",
                                            "content.image.uri"
                                        ])
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionImageCell, {
                watch: watch,
                setValue: setValue,
                disabled: isNoQuizWatch,
                error: (ref2 = errors.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.uri,
                fileUploadInfo: fileUploadInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionAnswerCell, {
                inputProps: (0,src_object_spread/* default */.Z)({
                    disabled: isNoQuizWatch,
                    type: "text",
                    error: (ref4 = errors.content) === null || ref4 === void 0 ? void 0 : ref4.answer
                }, register("content.answer"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardCell, {
                items: items,
                artistId: artistId,
                value: watch("reward.item.id"),
                loading: loading,
                setValue: setValue,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                onSearch: onSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell, {
                name: "expiredAt",
                error: errors.expiredAt,
                setValue: setValue,
                value: watch("expiredAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: !isValid || isSubmitting,
                    loading: isSubmitting,
                    onClick: handleOnSubmit,
                    children: t("create")
                })
            })
        ]
    });
};
var CheckInInputCell = function(param) {
    var artistId = param.artistId, hasCheckIn = param.hasCheckIn, setValue = param.setValue, value = param.value, inputProps = param.inputProps, inputApproximateAddressProps = param.inputApproximateAddressProps, onPlaceSearch = param.onPlaceSearch, gpsClientInfo = param.gpsClientInfo, predictions = param.predictions, place = param.place, onSelectPlace = param.onSelectPlace, onRequestGPSPermission = param.onRequestGPSPermission, removePlace = param.removePlace;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var options = [
        {
            value: true,
            label: t("specified")
        },
        {
            value: false,
            label: t("unspecified")
        }, 
    ];
    var currentPlace = (0,react.useMemo)(function() {
        if (place) {
            return place;
        }
        if ((value === null || value === void 0 ? void 0 : value.latitude) && (value === null || value === void 0 ? void 0 : value.longitude)) {
            var _approximateAddress;
            return {
                formattedAddress: (_approximateAddress = value.approximateAddress) !== null && _approximateAddress !== void 0 ? _approximateAddress : "",
                location: {
                    lat: value.latitude,
                    lng: value.longitude
                }
            };
        }
        return null;
    }, [
        place,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("checkInLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("checkInDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                sx: {
                    py: 2,
                    mb: 3
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: hasCheckIn === option.value ? "contained" : "outlined",
                        onClick: function() {
                            if (option.value) {
                                onRequestGPSPermission();
                            }
                            setValue("hasCheckIn", option.value, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            if (!option.value) {
                                setValue("gpsData", {
                                    latitude: 0,
                                    longitude: 0,
                                    radius: "",
                                    approximateAddress: ""
                                }, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                removePlace();
                            }
                        },
                        children: option.label
                    }, index);
                })
            }),
            hasCheckIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 8,
                                pt: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("positionLabel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        pt: 2
                                    },
                                    children: t("positionDesc")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "text",
                                    sx: {
                                        width: "fit-content",
                                        mx: "-6px"
                                    },
                                    onClick: function() {
                                        return setOpen(true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "inherit",
                                        children: t("specifiedMap")
                                    })
                                }),
                                !!(value === null || value === void 0 ? void 0 : value.latitude) && !!(value === null || value === void 0 ? void 0 : value.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                                    textFieldProps: {
                                        sx: {
                                            mb: 0
                                        }
                                    }
                                }, inputApproximateAddressProps))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("radiusLabel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    sx: {
                                        pt: 2
                                    },
                                    children: t("radiusDesc")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_MaskedInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputProps), {
                                    inputProps: {
                                        pattern: "[0-9/]*",
                                        inputMode: "numeric"
                                    },
                                    type: "tel"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GPSMapModal, {
                            currentData: gpsClientInfo === null || gpsClientInfo === void 0 ? void 0 : gpsClientInfo.currentLocation,
                            artistId: artistId,
                            onSearch: onPlaceSearch,
                            predictions: predictions,
                            onSelectPlace: onSelectPlace,
                            place: currentPlace,
                            open: open,
                            onSpecify: function(param) {
                                var latitude = param.latitude, longitude = param.longitude, formattedAddress = param.formattedAddress;
                                setValue("gpsData.approximateAddress", formattedAddress, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("gpsData.latitude", latitude, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setValue("gpsData.longitude", longitude, {
                                    shouldValidate: true,
                                    shouldDirty: true
                                });
                                setOpen(false);
                            },
                            onClose: function() {
                                return setOpen(false);
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var MissionImageCell = function(param) {
    var fileUploadInfo = param.fileUploadInfo, error = param.error, watch = param.watch, setValue = param.setValue, disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                t: t,
                disabled: disabled,
                resource: watch("contentResource.imageUrl") ? (ref = watch("contentResource")) !== null && ref !== void 0 ? ref : undefined : undefined,
                fileUploadInfo: {
                    type: "image",
                    onDrop: function onDrop() {
                        return fileUploadInfo.onDrop().then(function(newResource) {
                            if (!(newResource === null || newResource === void 0 ? void 0 : newResource.imageUploadPath)) {
                                return;
                            }
                            setValue("content.image.uri", newResource.imageUploadPath, {
                                shouldValidate: true,
                                shouldDirty: true
                            });
                            setValue("contentResource", cloneDeep_default()(newResource));
                            return cloneDeep_default()(newResource);
                        });
                    },
                    progress: fileUploadInfo.progress || 0,
                    description: t("imageUploaderDescription"),
                    onClose: function onClose() {
                        setValue("content.image.uri", "", {
                            shouldValidate: true,
                            shouldDirty: true
                        });
                        setValue("contentResource", null);
                    }
                },
                content: {
                    title: t("quizAddImage")
                }
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
};
var MissionAnswerCell = function(param) {
    var inputProps = param.inputProps;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: inputProps.disabled ? "text.disabled" : "text.primary",
                children: t("answerLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: inputProps.disabled ? "text.disabled" : "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("answerDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                textFieldProps: {
                    sx: {
                        mb: 0
                    }
                }
            }, inputProps))
        ]
    });
};
var RewardCell = function(param) {
    var artistId = param.artistId, value = param.value, defaultItem = param.defaultItem, loading = param.loading, hasNextPage = param.hasNextPage, items = param.items, onFetchMore = param.onFetchMore, onSearch = param.onSearch, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(defaultItem), itemSelected = ref1[0], setItemSelected = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("rewardLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("rewardDesc")
            }),
            itemSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemSelectBox_ItemSelectBox, {
                item: itemSelected,
                onClose: function() {
                    setItemSelected(undefined);
                    setValue("reward.item.id", "", {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                sx: {
                    mt: 4
                },
                onClick: function() {
                    setOpen(true);
                    return onSearch({
                        keyword: ""
                    });
                },
                children: t("add")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSelectModal_ItemSelectModal, {
                open: open,
                artistId: artistId,
                onClose: function() {
                    return setOpen(false);
                },
                value: value !== null && value !== void 0 ? value : "",
                onSelect: function(id) {
                    var ref;
                    setItemSelected((ref = items === null || items === void 0 ? void 0 : items.edges.find(function(param) {
                        var node = param.node;
                        return node.id === id;
                    })) === null || ref === void 0 ? void 0 : ref.node);
                    setOpen(false);
                    setValue("reward.item.id", id, {
                        shouldValidate: true,
                        shouldDirty: true
                    });
                },
                items: items,
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                onSearch: onSearch
            })
        ]
    });
};
var MissionCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            textFieldProps: (0,src_object_spread/* default */.Z)({
                label: error ? t("error") : ""
            }, textFieldProps),
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});
var MissionCreateForm_MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            textFieldProps: (0,src_object_spread/* default */.Z)({
                label: error ? t("error") : ""
            }, textFieldProps)
        }, props), {
            ref: ref,
            t: t,
            placeholder: t("".concat(props.name, "Placeholder"))
        }))
    });
});
var DatePickerCell = function(_param) {
    var setValue = _param.setValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setValue"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var value = (0,react.useMemo)(function() {
        return props.value ? dayjs_min_default()(props.value) : null;
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            onChange: function(date) {
                setValue(props.name, (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                    shouldValidate: true,
                    shouldDirty: true
                });
            }
        }, props), {
            value: value,
            title: t("".concat(props.name, "Title")),
            placeholder: t("".concat(props.name, "Placeholder")),
            textFieldProps: {
                label: props.error ? t("error") : ""
            },
            titleProps: {
                variant: "h5",
                color: "text.primary"
            }
        }))
    });
};
var MissionCreateForm_defaultValues = {
    title: "",
    description: "",
    type: utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
    content: {
        answer: "",
        image: {
            uri: ""
        }
    },
    contentResource: null,
    gpsData: {
        longitude: 0,
        latitude: 0,
        radius: "",
        approximateAddress: ""
    },
    isPublished: true,
    expiredAt: null,
    reward: {
        item: {
            id: ""
        },
        gachaTicket: null
    },
    hasCheckIn: false,
    startedAt: null,
    isNoQuiz: false
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/template/index.tsx









var ConsoleMissionCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onDrop = param.onDrop, onFetchMore = param.onFetchMore, onSearch = param.onSearch, onPlaceSearch = param.onPlaceSearch, onSelectPlace = param.onSelectPlace, onRequestGPSPermission = param.onRequestGPSPermission, removePlace = param.removePlace;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMissionCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMissions,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionCreate_template_HeadingTextCell, {
                        missionType: state.missionType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm, {
                        artistId: state.artistId,
                        missionType: state.missionType,
                        onSubmit: onSubmit,
                        predictions: state.predictions,
                        place: state.place,
                        onSelectPlace: onSelectPlace,
                        onPlaceSearch: onPlaceSearch,
                        fileUploadInfo: {
                            onDrop: onDrop,
                            progress: state.progress
                        },
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        items: state.items,
                        onFetchMore: onFetchMore,
                        onSearch: onSearch,
                        gpsClientInfo: state.gpsClientInfo,
                        onRequestGPSPermission: onRequestGPSPermission,
                        removePlace: removePlace
                    })
                ]
            })
        ]
    });
};
var ConsoleMissionCreate_template_HeadingTextCell = function(param) {
    var missionType = param.missionType;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            px: 5,
            mt: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            children: t("".concat(missionType, "MissionCreation"))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/viewModel.ts






function ConsoleMissionCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateMission($inputs: CreateMissionInput!) {\n    createMission(inputs: $inputs) {\n      ...ConsoleMissionBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMissionCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ConsoleMissionCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionCreate").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref1.showError, showMessage = ref1.showMessage;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    var ref3 = (0,react.useState)([]), predictions = ref3[0], setPredictions = ref3[1];
    var ref4 = (0,react.useState)(null), place = ref4[0], setPlace = ref4[1];
    var getImage = camera/* getImage */.g;
    var ref5 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref5.upload, progress = ref5.progress;
    var ref6 = useLocationWatcher(), permission = ref6.permission, currentLocation = ref6.currentLocation, requestPermission = ref6.requestPermission, watch = ref6.watch, unwatch = ref6.unwatch;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(utoniq_core_schema/* ConsoleItems */.YRc), 2), getItems = ref7[0], ref8 = ref7[1], items = ref8.data, loading = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_MISSION, {
        onCompleted: function onCompleted() {
            showMessage(t("createMissionSuccess"), "success");
            router.goBack(routerPages.ConsoleMissions);
        }
    }), 1), createMission = ref9[0];
    var getResource = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function getResource() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    var ref10, ref11;
    return {
        state: {
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            missionType: router.query.missionType,
            progress: progress,
            loading: loading,
            hasNextPage: !!(items === null || items === void 0 ? void 0 : (ref = items.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            items: (ref11 = items === null || items === void 0 ? void 0 : items.artistItems) !== null && ref11 !== void 0 ? ref11 : null,
            predictions: predictions,
            place: place,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            }
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var title = param.title, description = param.description, type = param.type, expiredAt = param.expiredAt, startedAt = param.startedAt, content = param.content, reward = param.reward, gpsData = param.gpsData;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createMission({
                                        variables: {
                                            inputs: {
                                                title: title,
                                                description: description,
                                                type: type,
                                                isPublished: true,
                                                startedAt: startedAt,
                                                expiredAt: expiredAt,
                                                content: content,
                                                reward: reward,
                                                gpsData: buildGpsData(gpsData)
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItems({
                                        variables: {
                                            pageInput: {
                                                cursor: items === null || items === void 0 ? void 0 : (ref = items.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSearch: function onSearch() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onPlaceSearch: function onPlaceSearch(param) {
                var keyword = param.keyword;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var predictions;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!keyword) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    getPlacePredictions(keyword)
                                ];
                            case 1:
                                predictions = _state.sent();
                                setPredictions(predictions);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectPlace: function onSelectPlace(param) {
                var placeId = param.placeId, map = param.map;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getDetail({
                                        placeId: placeId,
                                        map: map
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.isErr()) {
                                    throw result.err();
                                }
                                setPlace(result.unwrap());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            removePlace: function removePlace() {
                setPlace(null);
            },
            onRequestGPSPermission: function onRequestGPSPermission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (permission) return [
                                    2
                                ];
                                return [
                                    4,
                                    requestPermission()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CREATE_MISSION = (0,lib/* gql */.Ps)(ConsoleMissionCreate_viewModel_templateObject(), utoniq_core_schema/* ConsoleMissionBoxFragmentDoc */.$EW);
function buildGpsData(gpsData) {
    if (!(gpsData === null || gpsData === void 0 ? void 0 : gpsData.radius)) {
        return undefined;
    }
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, gpsData), {
        radius: toNumber(String(gpsData.radius))
    });
}
function toNumber(string) {
    var ref;
    return +((ref = string.replace(/[a-z\s]*/g, "")) !== null && ref !== void 0 ? ref : 0);
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionCreate/index.tsx




/**
 * ConsoleMissionCreate Page
 * Implemented as a practical sample.
 */ var ConsoleMissionCreate = function() {
    var ref = ConsoleMissionCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionEdit/template/MissionEditForm.tsx












var MissionEditForm_schema = function(o) {
    return {
        title: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.title")),
        description: o.string().max(500).label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.description")),
        content: o.object().when("type", {
            switch: [
                {
                    is: utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                    then: o.object().when("isNoQuiz", {
                        is: true,
                        then: o.object({
                            image: o.object({
                                uri: o.string().allow("").optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.image.uri"))
                            }),
                            answer: o.string().max(50).allow("").optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.answer"))
                        }),
                        otherwise: o.object({
                            image: o.object({
                                uri: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.image.uri"))
                            }),
                            answer: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.content.quiz.answer"))
                        })
                    })
                },
                {
                    is: utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect,
                    then: o.object({
                        items: o.array().items({
                            itemId: o.string(),
                            requiredCount: o.number()
                        })
                    })
                }, 
            ],
            otherwise: o.object().allow(null).optional()
        }),
        startedAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.startedAt")),
        expiredAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.expiredAt")),
        type: o.string(),
        isPublished: o.boolean(),
        //check mission have the GachaTicket
        isGachaTicket: o.boolean(),
        reward: o.object().when("isGachaTicket", {
            is: true,
            then: o.object({
                item: o.object({
                    id: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.reward.item.id"))
                }).allow(null).optional(),
                gachaTicket: o.object({
                    gachaTicketId: o.string(),
                    count: o.number()
                })
            }),
            otherwise: o.object({
                item: o.object({
                    id: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.reward.item.id"))
                }),
                gachaTicket: o.object({
                    gachaTicketId: o.string(),
                    count: o.number()
                }).allow(null).optional()
            })
        }),
        gpsData: o.object().when("hasCheckIn", {
            is: true,
            then: o.object({
                latitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.gpsData.latitude")),
                longitude: o.number().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.gpsData.longitude")),
                approximateAddress: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.gpsData.approximateAddress")),
                radius: o.string().label((0,core_form/* tLabel */.TQ)("consoleMissionEdit.gpsData.radius"))
            }),
            otherwise: o.object().allow(null).optional()
        }),
        //local field
        isNoQuiz: o.boolean().optional(),
        contentResource: o.object().allow(null).optional(),
        hasCheckIn: o.boolean().allow(false).optional()
    };
};
var MissionEditForm = function(param) {
    var mission = param.mission, onSubmit = param.onSubmit, fileUploadInfo = param.fileUploadInfo, loading = param.loading, items = param.items, hasNextPage = param.hasNextPage, artistId = param.artistId, onSearch = param.onSearch, onPlaceSearch = param.onPlaceSearch, predictions = param.predictions, place = param.place, onSelectPlace = param.onSelectPlace, onFetchMore = param.onFetchMore, gpsClientInfo = param.gpsClientInfo, onRequestGPSPermission = param.onRequestGPSPermission, removePlace = param.removePlace;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionEdit").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, routerPages = ref6.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref7 = (0,core_form/* useForm */.cI)({
        schema: MissionEditForm_schema,
        defaultValues: (0,src_object_spread/* default */.Z)({}, MissionEditForm_defaultValues)
    }), handleSubmit = ref7.handleSubmit, _formState = ref7.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid, isDirty = _formState.isDirty, register = ref7.register, setValue = ref7.setValue, reset = ref7.reset, watch = ref7.watch, setError = ref7.setError, trigger = ref7.trigger;
    var _ref = register("isNoQuiz"), isNoQuizRef = _ref.ref, restIsNoQuiz = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref"
    ]);
    var isNoQuizWatch = watch("isNoQuiz");
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var content = buildContent(mission);
        var ref3;
        reset({
            title: mission.title,
            description: mission.description,
            type: mission.type,
            isPublished: mission.isPublished,
            content: content,
            isGachaTicket: !!(mission === null || mission === void 0 ? void 0 : (ref = mission.reward) === null || ref === void 0 ? void 0 : ref.gachaTicket),
            reward: buildReward(mission.reward),
            hasCheckIn: !!mission.gpsData,
            gpsData: MissionEditForm_buildGpsData(mission.gpsData),
            startedAt: mission.startedAt,
            expiredAt: mission.expiredAt,
            isNoQuiz: !(content.answer && ((ref1 = content.image) === null || ref1 === void 0 ? void 0 : ref1.uri)),
            contentResource: {
                id: "",
                resourceName: "",
                imageUrl: (ref3 = (ref2 = mission.content.image) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref3 !== void 0 ? ref3 : "",
                imageUploadPath: ""
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mission
    ]);
    var onHandleSubmit = handleSubmit(function(_param) {
        var hasCheckIn = _param.hasCheckIn, gpsData = _param.gpsData, content = _param.content, isNoQuiz = _param.isNoQuiz, values = (0,_object_without_properties/* default */.Z)(_param, [
            "hasCheckIn",
            "gpsData",
            "content",
            "isNoQuiz"
        ]);
        if (!isDirty) {
            router.goBack(routerPages.ConsoleMissions);
            return;
        }
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
            hasCheckIn: hasCheckIn,
            gpsData: hasCheckIn ? gpsData : null,
            content: (0,src_object_spread/* default */.Z)({}, content, isNoQuiz ? getContentNoQuiz(values.type) : {})
        })).catch(function(error) {
            (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("title")), {
                error: errors.title
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("description")), {
                error: errors.description
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckInInputCell, {
                artistId: artistId,
                setValue: setValue,
                value: watch("gpsData"),
                hasCheckIn: watch("hasCheckIn"),
                gpsClientInfo: gpsClientInfo,
                onPlaceSearch: onPlaceSearch,
                predictions: predictions,
                place: place,
                onSelectPlace: onSelectPlace,
                onRequestGPSPermission: onRequestGPSPermission,
                removePlace: removePlace,
                inputProps: (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: (ref = errors.gpsData) === null || ref === void 0 ? void 0 : ref.radius,
                    mask: "00000m"
                }, register("gpsData.radius")),
                inputApproximateAddressProps: (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: (ref1 = errors.gpsData) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                }, register("gpsData.approximateAddress"))
            }),
            mission.type === utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        content: {
                            title: t("noQuizTitle"),
                            description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                children: t("noQuizNote")
                            })
                        },
                        checked: isNoQuizWatch,
                        inputRef: isNoQuizRef,
                        sx: {
                            mx: -2,
                            mt: 4,
                            mb: -5
                        }
                    }, restIsNoQuiz), {
                        onChange: function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            setValue("isNoQuiz", event.target.checked, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            return [
                                                4,
                                                trigger([
                                                    "content.answer",
                                                    "content.image.uri"
                                                ])
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(event) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionImageCell, {
                        watch: watch,
                        disabled: isNoQuizWatch,
                        setValue: setValue,
                        error: (ref2 = errors.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.uri,
                        fileUploadInfo: fileUploadInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionAnswerCell, {
                        inputProps: (0,src_object_spread/* default */.Z)({
                            type: "text",
                            disabled: isNoQuizWatch,
                            error: (ref4 = errors.content) === null || ref4 === void 0 ? void 0 : ref4.answer
                        }, register("content.answer"))
                    })
                ]
            }),
            !watch("isGachaTicket") && /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardCell, {
                items: items,
                artistId: artistId,
                value: watch("reward.item.id"),
                defaultItem: (ref8 = (ref5 = mission.reward.item) === null || ref5 === void 0 ? void 0 : ref5.item) !== null && ref8 !== void 0 ? ref8 : undefined,
                loading: loading,
                setValue: setValue,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                onSearch: onSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell, {
                name: "expiredAt",
                error: errors.expiredAt,
                setValue: setValue,
                value: watch("expiredAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: !isValid || isSubmitting || !!fileUploadInfo.progress,
                    loading: isSubmitting || !!fileUploadInfo.progress,
                    onClick: onHandleSubmit,
                    children: t("edit")
                })
            })
        ]
    });
};
var MissionEditForm_defaultValues = {
    title: "",
    description: "",
    type: utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
    content: {
        answer: "",
        image: {
            uri: ""
        }
    },
    contentResource: null,
    gpsData: {
        longitude: 0,
        latitude: 0,
        radius: "",
        approximateAddress: ""
    },
    isPublished: true,
    expiredAt: null,
    reward: {
        item: {
            id: ""
        },
        gachaTicket: null
    },
    isNoQuiz: true,
    hasCheckIn: false,
    startedAt: null
};
function MissionEditForm_buildGpsData(gpsData) {
    if (!gpsData) return null;
    var _radius;
    return {
        approximateAddress: gpsData.approximateAddress,
        latitude: gpsData.latitude,
        longitude: gpsData.longitude,
        radius: String((_radius = gpsData.radius) !== null && _radius !== void 0 ? _radius : 0)
    };
}
function buildReward(reward) {
    var rewardInput = {
        item: null,
        gachaTicket: null
    };
    if (reward === null || reward === void 0 ? void 0 : reward.item) {
        rewardInput.item = {
            id: reward.item.id
        };
    }
    if (reward === null || reward === void 0 ? void 0 : reward.gachaTicket) {
        rewardInput.gachaTicket = {
            gachaTicketId: reward.gachaTicket.gachaTicketId,
            count: reward.gachaTicket.count
        };
    }
    return rewardInput;
}
function buildContent(mission) {
    if ("answer" in mission.content) {
        var ref;
        var ref1;
        return {
            answer: mission.content.answer,
            image: {
                uri: (ref1 = (ref = mission.content.image) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref1 !== void 0 ? ref1 : ""
            }
        };
    }
    if ("items" in mission.content) {
        var ref2;
        return {
            items: (ref2 = mission.content.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
                var itemId = param.itemId, requiredCount = param.requiredCount;
                return {
                    itemId: itemId,
                    requiredCount: requiredCount
                };
            })
        };
    }
    return {};
}
function getContentNoQuiz(missionType) {
    switch(missionType){
        case utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz:
            return {
                answer: "",
                image: {
                    uri: ""
                }
            };
        default:
            return {};
    }
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionEdit/template/index.tsx









var ConsoleMissionEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onDrop = param.onDrop, onSearch = param.onSearch, onFetchMore = param.onFetchMore, onPlaceSearch = param.onPlaceSearch, onSelectPlace = param.onSelectPlace, onRequestGPSPermission = param.onRequestGPSPermission, removePlace = param.removePlace;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionEdit").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMissionEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleMissions,
                    title: t("title")
                },
                children: [
                    ((ref = state.mission) === null || ref === void 0 ? void 0 : ref.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionEdit_template_HeadingTextCell, {
                        missionType: state.mission.type
                    }),
                    state.mission && /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionEditForm, {
                        mission: state.mission,
                        onSubmit: onSubmit,
                        predictions: state.predictions,
                        place: state.place,
                        onSelectPlace: onSelectPlace,
                        onPlaceSearch: onPlaceSearch,
                        fileUploadInfo: {
                            onDrop: onDrop,
                            progress: state.progress
                        },
                        gpsClientInfo: state.gpsClientInfo,
                        artistId: state.artistId,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        items: state.items,
                        onFetchMore: onFetchMore,
                        onSearch: onSearch,
                        onRequestGPSPermission: onRequestGPSPermission,
                        removePlace: removePlace
                    })
                ]
            })
        ]
    });
};
var ConsoleMissionEdit_template_HeadingTextCell = function(param) {
    var missionType = param.missionType;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            px: 5,
            mt: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            children: t("".concat(missionType, "MissionEdit"))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionEdit/viewModel.ts




function ConsoleMissionEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMissionEdit($id: ID!) {\n    mission(id: $id) {\n      ...ConsoleMissionBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMissionEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMissionEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateMission($id: ID!, $inputs: UpdateMissionInput!) {\n    updateMission(id: $id, inputs: $inputs) {\n      ...ConsoleMissionBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMissionEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ConsoleMissionEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissionEdit").t;
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref2.showError, showMessage = ref2.showMessage;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages;
    var ref4 = (0,react.useState)([]), predictions = ref4[0], setPredictions = ref4[1];
    var ref5 = (0,react.useState)(null), place = ref5[0], setPlace = ref5[1];
    var getImage = camera/* getImage */.g;
    var ref6 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref6.upload, progress = ref6.progress;
    var ref7 = useLocationWatcher(), permission = ref7.permission, currentLocation = ref7.currentLocation, requestPermission = ref7.requestPermission, watch = ref7.watch, unwatch = ref7.unwatch;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleMissionEdit_viewModel_QUERY, {
        variables: {
            id: router.query.missionId
        }
    }).data;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(utoniq_core_schema/* ConsoleItems */.YRc), 2), getItems = ref8[0], ref9 = ref8[1], items = ref9.data, loading = ref9.loading;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_MISSION, {
        onCompleted: function onCompleted() {
            showMessage(t("editMissionComplete"), "success");
            router.goBack(routerPages.ConsoleMissions);
        }
    }), 1), updateMission = ref10[0];
    var getResource = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        file = _state.sent();
                        if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            file
                        ];
                }
            });
        });
        return function getResource() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.gpsData)) return;
        requestPermission().catch(showError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.gpsData,
        requestPermission
    ]);
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        watch,
        unwatch,
        permission
    ]);
    var ref11, ref12, ref13;
    return {
        state: {
            artistId: (ref11 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref11 !== void 0 ? ref11 : "",
            mission: (ref12 = data === null || data === void 0 ? void 0 : data.mission) !== null && ref12 !== void 0 ? ref12 : null,
            progress: progress,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            },
            items: (ref13 = items === null || items === void 0 ? void 0 : items.artistItems) !== null && ref13 !== void 0 ? ref13 : null,
            predictions: predictions,
            place: place,
            hasNextPage: !!(items === null || items === void 0 ? void 0 : (ref1 = items.artistItems) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            loading: loading
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var title = param.title, description = param.description, type = param.type, gpsData = param.gpsData, content = param.content, reward = param.reward, startedAt = param.startedAt, expiredAt = param.expiredAt;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateMission({
                                        variables: {
                                            id: router.query.missionId,
                                            inputs: {
                                                title: title,
                                                description: description,
                                                type: type,
                                                isPublished: true,
                                                startedAt: startedAt,
                                                expiredAt: expiredAt,
                                                content: content,
                                                reward: reward,
                                                gpsData: buildGpsData(gpsData)
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDrop: function onDrop() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var file, ref, tmpPath, fileUrl, uuid;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getResource().catch(function(error) {
                                        showError(new Error(t([
                                            error.message,
                                            "interruptedUpload"
                                        ])));
                                    })
                                ];
                            case 1:
                                file = _state.sent();
                                if (!file) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    upload(file, false, true)
                                ];
                            case 2:
                                ref = _state.sent(), tmpPath = ref.tmpPath, fileUrl = ref.fileUrl;
                                uuid = createUuid();
                                return [
                                    2,
                                    {
                                        id: uuid,
                                        resourceName: uuid,
                                        imageUrl: fileUrl,
                                        imageUploadPath: tmpPath
                                    }
                                ];
                        }
                    });
                })();
            },
            onSearch: function onSearch() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItems({
                                        variables: {
                                            pageInput: {
                                                cursor: items === null || items === void 0 ? void 0 : (ref = items.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onPlaceSearch: function onPlaceSearch(param) {
                var keyword = param.keyword;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var predictions;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!keyword) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    getPlacePredictions(keyword)
                                ];
                            case 1:
                                predictions = _state.sent();
                                setPredictions(predictions);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectPlace: function onSelectPlace(param) {
                var placeId = param.placeId, map = param.map;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var result;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getDetail({
                                        placeId: placeId,
                                        map: map
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (result.isErr()) {
                                    throw result.err();
                                }
                                setPlace(result.unwrap());
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            removePlace: function removePlace() {
                setPlace(null);
            },
            onRequestGPSPermission: function onRequestGPSPermission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    requestPermission()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMissionEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMissionEdit_viewModel_templateObject(), utoniq_core_schema/* ConsoleMissionBoxFragmentDoc */.$EW);
var UPDATE_MISSION = (0,lib/* gql */.Ps)(ConsoleMissionEdit_viewModel_templateObject1(), utoniq_core_schema/* ConsoleMissionBoxFragmentDoc */.$EW);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissionEdit/index.tsx




/**
 * ConsoleMissionEdit Page
 * Implemented as a practical sample.
 */ var ConsoleMissionEdit = function() {
    var ref = ConsoleMissionEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleMissionBox/index.tsx










var ConsoleMissionBox = function(param) {
    var mission = param.mission, onDelete = param.onDelete, deletingMission = param.deletingMission;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(false), openModalDelete = ref8[0], setOpenModalDelete = ref8[1];
    var ref9 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref9.showError, showMessage = ref9.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissions").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref10.generatePath, routerPages = ref10.routerPages;
    var nowTime = new Date().getTime();
    var checkInProgress = function() {
        if (mission.startedAt <= nowTime && nowTime <= mission.expiredAt) {
            return "inProgress";
        } else {
            return mission.label;
        }
    };
    var stateLabelRender = (0,react.useMemo)(function() {
        switch(checkInProgress()){
            case utoniq_core_schema/* MissionLabel.New */.lH5.New:
                return {
                    bgColor: "secondary.light",
                    color: "text.secondary"
                };
            case "inProgress":
                return {
                    bgColor: "primary.dark",
                    color: "white"
                };
            case utoniq_core_schema/* MissionLabel.Expired */.lH5.Expired:
                return {
                    bgColor: "grey.100",
                    color: "text.disabled"
                };
            default:
                return {
                    bgColor: "secondary.light",
                    color: "text.secondary"
                };
        }
    }, [
        mission.label
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 4
                            },
                            direction: "row",
                            justifyContent: "space-between",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                    children: mission.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                                            href: generatePath(routerPages.ConsoleMissionEdit, {
                                                missionId: mission.id
                                            }),
                                            size: "small",
                                            color: "grey.700",
                                            bgcolor: "grey.100"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                            onClick: function() {
                                                return setOpenModalDelete(true);
                                            },
                                            size: "small",
                                            color: "grey.700",
                                            bgcolor: "grey.100"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "caption",
                                            color: "text.secondary",
                                            sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(3)),
                                            children: mission.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    sx: {
                                                        bgcolor: stateLabelRender.bgColor,
                                                        height: 16,
                                                        ".MuiChip-label": {
                                                            px: 1
                                                        }
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        sx: {
                                                            display: "flex"
                                                        },
                                                        color: stateLabelRender.color,
                                                        variant: "overline",
                                                        children: t("".concat(checkInProgress()))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    sx: {
                                                        bgcolor: "grey.100",
                                                        height: 16,
                                                        ".MuiChip-label": {
                                                            px: 1
                                                        }
                                                    },
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        sx: {
                                                            display: "flex"
                                                        },
                                                        color: "text.secondary",
                                                        variant: "overline",
                                                        children: mission.type
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        minWidth: 48
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        size: "x-small",
                                        src: ((ref3 = mission === null || mission === void 0 ? void 0 : (ref = mission.reward) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.thumbnail.front) === null || ref3 === void 0 ? void 0 : ref3.smallUri) || ((ref6 = mission === null || mission === void 0 ? void 0 : (ref4 = mission.reward) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gachaTicket) === null || ref5 === void 0 ? void 0 : ref5.gachaTicket.thumbnails) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.reward) === null || ref7 === void 0 ? void 0 : ref7.smallUri) || ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openModalDelete,
                onClose: function() {
                    return setOpenModalDelete(false);
                },
                title: t("deleteTitle"),
                content: t("deleteContent"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            loading: deletingMission,
                            disabled: deletingMission,
                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onDelete(mission).then(function() {
                                                    showMessage(t("deleteMissionComplete"), "success");
                                                    setOpenModalDelete(false);
                                                }).catch(showError)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: t("okDelete")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "text",
                            onClick: function() {
                                setOpenModalDelete(false);
                            },
                            children: t("cancelDelete")
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/ConsoleMissionBoxSkeleton/index.tsx



var ConsoleMissionBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 4
                    },
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "medium",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                                    size: "small",
                                    bgcolor: "grey.100",
                                    color: "grey.700"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                    size: "small",
                                    bgcolor: "grey.100",
                                    color: "grey.700"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            sx: {
                                minWidth: 231
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                minWidth: 48
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {
                                size: "x-small"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissions/template/SearchForm.tsx








var ConsoleMissions_template_SearchForm_schema = function(o) {
    return {
        typeFilter: o.string().allow("").optional(),
        orderBy: o.string().allow("").optional()
    };
};
var ConsoleMissions_template_SearchForm_defaultValues = {
    typeFilter: undefined,
    orderBy: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc
};
var ConsoleMissions_template_SearchForm_SearchForm = function(param) {
    var onSubmit = param.onSubmit, sort = param.sort;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsoleMissions_template_SearchForm_schema,
        defaultValues: ConsoleMissions_template_SearchForm_defaultValues
    }), handleSubmit = ref.handleSubmit, control = ref.control, setValue = ref.setValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
            onSubmit: handleSubmit(onSubmit),
            sx: {
                bgcolor: "transparent"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SearchForm_FilterCell, {
                setValue: setValue,
                onChange: handleSubmit(onSubmit),
                sort: sort
            })
        })
    });
};
var SearchForm_ScrollTagCell = function(param) {
    var control = param.control, setValue = param.setValue, onChange = param.onChange;
    var t = useTranslation("consoleMissions").t;
    var type = useWatch({
        control: control,
        name: "typeFilter"
    });
    return /*#__PURE__*/ _jsx(CellFrame, {
        children: /*#__PURE__*/ _jsx(ScrollTag, {
            value: type,
            tags: [
                {
                    value: undefined,
                    label: t("general")
                },
                {
                    value: MissionType.Quiz,
                    label: t("answer")
                },
                {
                    value: MissionType.TwitterRetweet,
                    label: t("retweet")
                },
                {
                    value: MissionType.TwitterFollow,
                    label: t("follow")
                },
                {
                    value: MissionType.ItemCollect,
                    label: t("multipleItems")
                }, 
            ],
            onClick: function(value) {
                setValue("typeFilter", type === value ? undefined : value);
                onChange();
            }
        })
    });
};
var template_SearchForm_FilterCell = function(param) {
    var setValue = param.setValue, onChange = param.onChange, sort = param.sort;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissions").t;
    var filterOptions = [
        {
            value: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc,
            label: t("newestOrder")
        },
        {
            value: utoniq_core_schema/* OrderBy.Asc */.d$J.Asc,
            label: t("oldestOrder")
        }, 
    ];
    // sort と filterOptions の value を比較して、一致するインデックスを取得
    var initialSelectedIndex = sort ? filterOptions.findIndex(function(option) {
        return option.value === sort;
    }) : 0;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,react.useState)(filterOptions[initialSelectedIndex]), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var open = Boolean(anchorEl);
    var handleClickListItem = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function(event, option) {
        setSelectedOption(option);
        setValue("orderBy", option.value);
        onChange();
        setAnchorEl(null);
    };
    (0,react.useEffect)(function() {
        var UrlParams = "?sort=".concat(selectedOption.value);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedOption
    ]);
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                spacing: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        mr: -2
                    },
                    onClick: handleClickListItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                mr: 2
                            },
                            children: selectedOption.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: filterOptions.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        selected: option.value === selectedOption.value,
                        onClick: function(event) {
                            return handleMenuItemClick(event, option);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: option.label
                        })
                    }, option.value);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissions/template/index.tsx
















var ConsoleMissionsTemplate = function(param) {
    var state = param.state, onSearch = param.onSearch, onDelete = param.onDelete, onFetchMore = param.onFetchMore, onDraftConfirm = param.onDraftConfirm;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissions").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleMissions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            py: 3,
                            px: 5
                        },
                        variant: "h3",
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissions_template_SearchForm_SearchForm, {
                        onSubmit: onSearch,
                        sort: state.sort
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            componentProps: {
                                sx: {
                                    pt: 2,
                                    pb: 5
                                },
                                spacing: 5
                            },
                            nodes: (ref = state.missions) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionBox, {
                                    mission: node,
                                    onDelete: onDelete,
                                    deletingMission: state.deletingMission
                                }, node.id);
                            }),
                            onFetchMore: onFetchMore,
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            emptyMessage: t("emptyMission"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 5,
                                sx: {
                                    pb: 7
                                },
                                children: Array.from(Array(4).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionBoxSkeleton, {}, key);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissions_template_BaseCell, {
                        draftItem: state.draftItem,
                        onDraftConfirm: onDraftConfirm
                    })
                ]
            })
        ]
    });
};
var ConsoleMissions_template_BaseCell = function(param) {
    var draftItem = param.draftItem, onDraftConfirm = param.onDraftConfirm;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMissions").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), openModalDraft = ref2[0], setOpenModalDraft = ref2[1];
    var items = (0,react.useMemo)(function() {
        return [
            {
                Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {}),
                text: t("quiz"),
                href: generatePath(routerPages.ConsoleMissionCreate, {
                    missionType: utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz
                })
            }, 
        ];
    }, [
        generatePath,
        routerPages.ConsoleMissionCreate,
        t
    ]);
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 16,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: function() {
                        if (draftItem) {
                            return setOpenModalDraft(true);
                        }
                        toggleDrawer(true)();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: t("selectMissionType")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            items.map(function(param, index) {
                                var Icon = param.Icon, text = param.text, href = param.href;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                    href: href,
                                    title: text,
                                    primaryTypographyProps: {
                                        variant: "h6"
                                    },
                                    icon: Icon,
                                    sx: {
                                        px: 5
                                    }
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: toggleDrawer(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%",
                                        color: "primary.main"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openModalDraft,
                onClose: function() {
                    return setOpenModalDraft(false);
                },
                title: t("titleDraft"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentModalDraftCell, {
                    data: draftItem
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            loading: false,
                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                var _tmp;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _tmp = draftItem;
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                onDraftConfirm(draftItem)
                                            ];
                                        case 1:
                                            _tmp = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            setOpenModalDraft(false);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: t("okDraft")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "outlined",
                            color: "primary",
                            size: "large",
                            disabled: false,
                            onClick: function() {
                                setOpenModalDraft(false);
                            },
                            children: t("cancelDraft")
                        })
                    ]
                })
            })
        ]
    });
};
var template_ref, template_ref1, ref2;
var ContentModalDraftCell = function(param) {
    var data = param.data;
    var ref3, ref4, ref5;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "unset"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                pt: 6,
                px: 2,
                pb: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        src: (template_ref = (ref5 = (ref3 = data === null || data === void 0 ? void 0 : data.reward.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.thumbnail.front) === null || ref5 === void 0 ? void 0 : ref5.smallUri) !== null && template_ref !== void 0 ? template_ref : "",
                        size: "x-small"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                variant: "subtitle1",
                                align: "left",
                                children: (template_ref1 = data === null || data === void 0 ? void 0 : data.title) !== null && template_ref1 !== void 0 ? template_ref1 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "text.secondary",
                                variant: "caption",
                                align: "left",
                                children: (ref2 = data === null || data === void 0 ? void 0 : data.formattedCreatedAt) !== null && ref2 !== void 0 ? ref2 : ""
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissions/viewModel.ts




function ConsoleMissions_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMissions(\n    $orderBy: OrderBy\n    $pageInput: PageInput\n    $typeFilter: [MissionType!]\n  ) {\n    artistMissions(\n      orderBy: $orderBy\n      pageInput: $pageInput\n      typeFilter: $typeFilter\n    ) {\n      ...ArtistMissionsConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMissions_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMissions_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation deleteMission($id: ID!) {\n    deleteMission(id: $id) {\n      id\n    }\n  }\n"
    ]);
    ConsoleMissions_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ConsoleMissions_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort") === utoniq_core_schema/* OrderBy.Asc */.d$J.Asc ? utoniq_core_schema/* OrderBy.Asc */.d$J.Asc : utoniq_core_schema/* OrderBy.Desc */.d$J.Desc;
    var ref3 = (0,react.useState)({
        orderBy: sort,
        typeFilter: undefined
    }), condition = ref3[0], setCondition = ref3[1];
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleMissions_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            orderBy: condition.orderBy,
            typeFilter: undefined
        }
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore, refetch = ref4.refetch;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_MISSION), 2), deleteMission = ref5[0], ref6 = ref5[1], deletingMission = ref6.loading;
    var ref7, ref8, ref9, ref10;
    return {
        state: {
            user: user,
            artistId: (ref7 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref7 !== void 0 ? ref7 : "",
            missions: (ref8 = data === null || data === void 0 ? void 0 : data.artistMissions) !== null && ref8 !== void 0 ? ref8 : null,
            loading: loading,
            draftItem: null,
            artist: (ref9 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref9 !== void 0 ? ref9 : null,
            deletingMission: deletingMission,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistMissions) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            sort: condition.orderBy,
            membership: (ref10 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.products) !== null && ref10 !== void 0 ? ref10 : undefined
        },
        actions: {
            onSearch: function onSearch(param) {
                var orderBy = param.orderBy, typeFilter = param.typeFilter;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setCondition({
                                    orderBy: orderBy,
                                    typeFilter: typeFilter
                                });
                                return [
                                    4,
                                    refetch({
                                        orderBy: orderBy,
                                        typeFilter: typeFilter ? [
                                            typeFilter
                                        ] : undefined
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDelete: function onDelete(param) {
                var id = param.id;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteMission({
                                        variables: {
                                            id: id
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDraftConfirm: function onDraftConfirm() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            orderBy: condition.orderBy,
                                            typeFilter: condition.typeFilter ? [
                                                condition.typeFilter
                                            ] : undefined,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistMissions) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleMissions_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMissions_viewModel_templateObject(), utoniq_core_schema/* ArtistMissionsConnectionFragmentDoc */.wI_);
var DELETE_MISSION = (0,lib/* gql */.Ps)(ConsoleMissions_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMissions/index.tsx




/**
 * ConsoleMissions Page
 * Implemented as a practical sample.
 */ var ConsoleMissions = function() {
    var ref = ConsoleMissions_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMissionsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/omit.js
var omit = __webpack_require__(17620);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/template/ConsoleSNSLinkEdit.tsx












var ConsoleSNSLinkEdit_Icons = {
    instagram: dist.SnsIcons.Instagram,
    twitter: dist.SnsIcons.Twitter,
    tiktok: dist.SnsIcons.Tiktok,
    facebook: dist.SnsIcons.Facebook,
    youtube: dist.SnsIcons.Youtube
};
var ConsoleSNSLinkEdit_schema = function(o) {
    return {
        url: o.string().uri().label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.link")),
        type: o.string().optional().allow("")
    };
};
var ConsoleSNSLinkEdit = function(param) {
    var open = param.open, artistId = param.artistId, onClose = param.onClose, type = param.type, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsoleSNSLinkEdit_schema,
        defaultValues: {
            url: "",
            type: type
        }
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, reset = ref.reset, register = ref.register;
    var onHandleSubmit = handleSubmit(function(values) {
        onSubmit(values);
        reset();
        onClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
            artistId: artistId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        edge: "start",
                        size: "medium",
                        onClick: onClose,
                        color: "white"
                    }),
                    title: t("snsLinkEditTitle")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        py: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleSNSLinkEdit_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "text"
                        }, register("url")), {
                            snsType: type,
                            error: errors.url
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                pt: 7
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                loading: isSubmitting,
                                size: "large",
                                sx: {
                                    width: 244
                                },
                                disabled: !isValid || isSubmitting,
                                onClick: onHandleSubmit,
                                children: t("register")
                            })
                        })
                    ]
                })
            })
        })
    });
};
var ConsoleSNSLinkEdit_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var snsType = _param.snsType, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "snsType",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var Icon = ConsoleSNSLinkEdit_Icons[snsType];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                ref: ref,
                t: t,
                textFieldProps: {
                    helperText: null,
                    fullWidth: true,
                    sx: {
                        bgcolor: "unset",
                        fieldset: {
                            border: "none"
                        },
                        "& input:-webkit-autofill": {
                            transition: "background-color 5000s ease-in-out 0s"
                        },
                        ".MuiInputBase-root": {
                            pl: 0
                        }
                    },
                    InputProps: {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                            position: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                fontSize: "large",
                                sx: {
                                    color: "grey.700"
                                }
                            })
                        })
                    }
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                color: error ? "error.main" : "grey.100"
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error.message
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/template/ConsoleTextLinkEdit.tsx











var ConsoleTextLinkEdit_schema = function(o) {
    return {
        uri: o.string().uri().label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.uri")),
        content: o.string().max(20).label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.content"))
    };
};
var ConsoleTextLinkEdit = function(param) {
    var open = param.open, artistId = param.artistId, onClose = param.onClose, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsoleTextLinkEdit_schema,
        defaultValues: {
            uri: "",
            content: ""
        }
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, reset = ref.reset, register = ref.register;
    var onHandleSubmit = handleSubmit(function(values) {
        onSubmit(values);
        reset();
        onClose();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
            artistId: artistId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        edge: "start",
                        size: "medium",
                        onClick: onClose,
                        color: "white"
                    }),
                    title: t("textLinkEditTitle")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        py: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTextLinkEdit_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "text"
                        }, register("content")), {
                            error: errors.content
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTextLinkEdit_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            type: "text"
                        }, register("uri")), {
                            error: errors.uri
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                pt: 7
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                loading: isSubmitting,
                                size: "large",
                                sx: {
                                    width: 244
                                },
                                disabled: !isValid || isSubmitting,
                                onClick: onHandleSubmit,
                                children: t("register")
                            })
                        })
                    ]
                })
            })
        })
    });
};
var ConsoleTextLinkEdit_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/template/ProfileEditForm.tsx
















var ProfileEditForm_schema = function(o) {
    return {
        avatarPath: o.string().optional().allow("", null).label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.avatarPath")),
        displayName: o.string().max(50).label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.displayName")),
        accountId: o.string().pattern(new RegExp(/^[a-zA-Z0-9_]*$/)).max(20).label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.accountId")),
        introduction: o.string().max(1000).optional().allow("").label((0,core_form/* tLabel */.TQ)("consoleMyProfileEdit.introduction")),
        sns: o.array().items({
            type: o.string(),
            url: o.string()
        }).optional(),
        textLink: o.array().items({
            content: o.string(),
            uri: o.string()
        }).optional()
    };
};
var ProfileEditForm = function(param) {
    var user = param.user, artistId = param.artistId, onSubmitMyProfile = param.onSubmitMyProfile, onClickAvatar = param.onClickAvatar;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,react.useState)(false), avatarUploading = ref2[0], setAvatarUploading = ref2[1];
    var ref3 = (0,core_form/* useForm */.cI)({
        schema: ProfileEditForm_schema,
        defaultValues: ProfileEditForm_defaultValues
    }), handleSubmit = ref3.handleSubmit, _formState = ref3.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, register = ref3.register, reset = ref3.reset, setValue = ref3.setValue, control = ref3.control, setError = ref3.setError;
    var snsFieldArray = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "sns"
    });
    var textFieldArray = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "textLink"
    });
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!user) {
            return;
        }
        var textLink = user === null || user === void 0 ? void 0 : (ref = user.textLink) === null || ref === void 0 ? void 0 : ref.map(function(v) {
            return omit_default()(v, [
                "__typename"
            ]);
        });
        var _displayName, _introduction, _accountId, ref6, ref7, ref8, ref9, ref10;
        reset({
            displayName: (_displayName = user.displayName) !== null && _displayName !== void 0 ? _displayName : "",
            avatarPath: null,
            introduction: (_introduction = user.introduction) !== null && _introduction !== void 0 ? _introduction : "",
            accountId: (_accountId = user.accountId) !== null && _accountId !== void 0 ? _accountId : "",
            sns: [
                {
                    type: "instagram",
                    url: (ref6 = (ref1 = user.sns) === null || ref1 === void 0 ? void 0 : ref1.instagram) !== null && ref6 !== void 0 ? ref6 : ""
                },
                {
                    type: "twitter",
                    url: (ref7 = (ref2 = user.sns) === null || ref2 === void 0 ? void 0 : ref2.twitter) !== null && ref7 !== void 0 ? ref7 : ""
                },
                {
                    type: "tiktok",
                    url: (ref8 = (ref3 = user.sns) === null || ref3 === void 0 ? void 0 : ref3.tiktok) !== null && ref8 !== void 0 ? ref8 : ""
                },
                {
                    type: "facebook",
                    url: (ref9 = (ref4 = user.sns) === null || ref4 === void 0 ? void 0 : ref4.facebook) !== null && ref9 !== void 0 ? ref9 : ""
                },
                {
                    type: "youtube",
                    url: (ref10 = (ref5 = user.sns) === null || ref5 === void 0 ? void 0 : ref5.youtube) !== null && ref10 !== void 0 ? ref10 : ""
                }, 
            ].filter(function(o) {
                return o.url;
            }),
            textLink: textLink !== null && textLink !== void 0 ? textLink : []
        });
    }, [
        user,
        reset
    ]);
    var onSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmitMyProfile(values).then(function() {
                                showMessage(t("submitSuccess"), "success");
                            }).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleOnClick = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var result, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setAvatarUploading(true);
                    return [
                        4,
                        onClickAvatar().finally(function() {
                            setAvatarUploading(false);
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (!result) {
                        return [
                            2
                        ];
                    }
                    setValue("avatarPath", (ref = result === null || result === void 0 ? void 0 : result.tmpPath) !== null && ref !== void 0 ? ref : null, {
                        shouldValidate: true
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    }), [
        onClickAvatar,
        setValue
    ]);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        sx: {
            px: 5,
            pt: 5,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("profileImage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarUploadCell, (0,src_object_spread/* default */.Z)({
                        onClick: handleOnClick,
                        sx: {
                            pt: 5,
                            pb: 2
                        },
                        avatarProps: {
                            src: (ref4 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref4 !== void 0 ? ref4 : ""
                        },
                        titleProps: {
                            color: "primary.main",
                            sx: {
                                pt: 3
                            },
                            variant: "subtitle1"
                        },
                        type: "image",
                        error: errors === null || errors === void 0 ? void 0 : errors.avatarPath
                    }, register("avatarPath")))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                textFieldProps: {
                    placeholder: t("placeholderName", {
                        maxCharacters: 50
                    })
                },
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                },
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.displayName
            }, register("displayName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                titleProps: {
                    variant: "h5",
                    color: "text.primary"
                },
                textFieldProps: {
                    placeholder: t("placeholderId", {
                        maxCharacters: 20
                    })
                },
                error: errors === null || errors === void 0 ? void 0 : errors.accountId
            }, register("accountId"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SNSInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, snsFieldArray), {
                artistId: artistId
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLinkInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, textFieldArray), {
                artistId: artistId
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroductionInputCell, {
                inputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "textarea"
                }, register("introduction")), {
                    error: errors === null || errors === void 0 ? void 0 : errors.introduction
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    loading: isSubmitting || avatarUploading,
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    disabled: !isValid || isSubmitting || avatarUploading,
                    children: t("register")
                })
            })
        ]
    });
};
var ProfileEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var IntroductionInputCell = function(props) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("introductionLabel")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                sx: {
                    pt: 1
                },
                children: t("introductionNote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                textFieldProps: {
                    multiline: true,
                    placeholder: t("placeholderDescription", {
                        maxCharacters: 1000
                    }),
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, props.inputProps))
        ]
    });
};
var AvatarUploadCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AvatarUploadField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var SNSInputCell = function(param) {
    var fields = param.fields, artistId = param.artistId, append = param.append, remove = param.remove;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), openModal = ref1[0], setOpenModal = ref1[1];
    var ref2 = (0,react.useState)(null), type = ref2[0], setType = ref2[1];
    var items = [
        {
            title: "Instagram",
            value: "instagram"
        },
        {
            title: "Twitter",
            value: "twitter"
        },
        {
            title: "Tiktok",
            value: "tiktok"
        },
        {
            title: "Facebook",
            value: "facebook"
        },
        {
            title: "Youtube",
            value: "youtube"
        }, 
    ];
    var handleSelect = function(value) {
        setType(value);
        setOpen(false);
        setOpenModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("snsLinkEditTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("snsLinkEditDesc")
                    })
                ]
            }),
            fields.map(function(param, index) {
                var id = param.id, type = param.type, url = param.url;
                var Icon = get_default()(ConsoleSNSLinkEdit_Icons, type, Box_Box/* default */.Z);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                minHeight: 52,
                                px: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.700"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    width: "100%",
                                    variant: "caption",
                                    sx: {
                                        wordBreak: "break-all"
                                    },
                                    children: url
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                    size: "xSmall",
                                    sx: {
                                        bgcolor: "grey.50"
                                    },
                                    onClick: function() {
                                        return remove(index);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                    ]
                }, id);
            }),
            fields.length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                sx: {
                    mt: 3
                },
                onClick: function() {
                    return setOpen(true);
                },
                children: t("add")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        align: "center",
                        sx: {
                            p: 5
                        },
                        children: t("selectSnsType")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        children: items.map(function(param) {
                            var title = param.title, value = param.value;
                            var Icon = ConsoleSNSLinkEdit_Icons[value];
                            if (fields.find(function(item) {
                                return item.type === value;
                            })) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    minHeight: 52
                                },
                                onClick: function() {
                                    return handleSelect(value);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            fontSize: "small",
                                            sx: {
                                                color: "grey.700"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: title
                                        })
                                    ]
                                })
                            }, value);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 3
                        },
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            onClick: function() {
                                return setOpen(false);
                            },
                            sx: {
                                width: "fit-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                align: "center",
                                variant: "h5",
                                color: "primary.main",
                                children: t("cancel")
                            })
                        })
                    })
                ]
            }),
            type && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleSNSLinkEdit, {
                type: type,
                open: openModal,
                artistId: artistId,
                onClose: function() {
                    return setOpenModal(false);
                },
                onSubmit: function(values) {
                    setType(null);
                    append(values);
                }
            })
        ]
    });
};
var TextLinkInputCell = function(param) {
    var fields = param.fields, append = param.append, remove = param.remove, artistId = param.artistId;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("textLinkEditTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("textLinkEditDesc")
                    })
                ]
            }),
            fields.map(function(param, index) {
                var content = param.content, id = param.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            sx: {
                                minHeight: 48,
                                px: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    width: "100%",
                                    variant: "body2",
                                    sx: {
                                        wordBreak: "break-all"
                                    },
                                    children: content
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                                    size: "xSmall",
                                    sx: {
                                        bgcolor: "grey.50"
                                    },
                                    onClick: function() {
                                        return remove(index);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                    ]
                }, id);
            }),
            fields.length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                sx: {
                    mt: 3
                },
                onClick: function() {
                    return setOpen(true);
                },
                children: t("add")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTextLinkEdit, {
                open: open,
                artistId: artistId,
                onClose: function() {
                    return setOpen(false);
                },
                onSubmit: function(values) {
                    return append(values);
                }
            })
        ]
    });
};
var ProfileEditForm_defaultValues = {
    avatarPath: null,
    displayName: "",
    accountId: "",
    introduction: "",
    sns: [],
    textLink: []
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/template/index.tsx







var ConsoleMyProfileEditTemplate = function(param) {
    var _state = param.state, user = _state.user, artistId = _state.artistId, onSubmitMyProfile = param.onSubmitMyProfile, onClickAvatar = param.onClickAvatar;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleMyProfileEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                title: t("title"),
                defaultBackPage: routerPages.ConsoleDashboard,
                back: true
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.ConsoleMyProfileEdit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEditForm, {
                    user: user,
                    artistId: artistId,
                    onSubmitMyProfile: onSubmitMyProfile,
                    onClickAvatar: onClickAvatar
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(87622);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ../../node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(34519);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/template/fragments.ts

function template_fragments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ConsoleMyProfileConnection on Artist {\n      id\n      accountId\n      formattedAccountId @client\n      avatar {\n        uri\n        smallUri\n        mediumUri\n        compressedUri\n      }\n      displayName\n      introduction\n      sns {\n        twitter\n        tiktok\n        instagram\n        facebook\n        youtube\n      }\n      profileText\n      textLink {\n        content\n        uri\n      }\n    }\n  "
    ]);
    template_fragments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var fragments_fragments = {
    consoleMyProfile: (0,lib/* gql */.Ps)(template_fragments_templateObject())
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/viewModel.ts




function ConsoleMyProfileEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleMyProfileEdit($artistId: ID) {\n    artist(id: $artistId) {\n      ...ConsoleMyProfileConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMyProfileEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleMyProfileEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateArtistProfile($inputs: ArtistUpdateArtistProfileInput!) {\n    artistUpdateArtistProfile(inputs: $inputs) {\n      ...ConsoleMyProfileConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMyProfileEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleMyProfileEdit_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistSns($inputs: UpdateArtistSnsInput!) {\n    updateArtistSns(inputs: $inputs) {\n      ...ConsoleMyProfileConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMyProfileEdit_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleMyProfileEdit_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistProfileText($profileText: String) {\n    updateArtistProfileText(profileText: $profileText) {\n      ...ConsoleMyProfileConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMyProfileEdit_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ConsoleMyProfileEdit_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistTextLink($inputs: [UpdateArtistTextLinkInput]!) {\n    updateArtistTextLink(inputs: $inputs) {\n      ...ConsoleMyProfileConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleMyProfileEdit_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var ConsoleMyProfileEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var getImage = camera/* getImage */.g;
    var ref1;
    var upload = (0,useTmpUploader/* useUserTmpUploader */.x)((ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : "").upload;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleMyProfileEdit_viewModel_QUERY).data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UPDATE_ARTIST_PROFILE), 1), artistUpdateArtistProfile = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_SNS), 1), updateArtistSns = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_PROFILE_TEXT), 1), updateArtistProfileText = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_TEXT_LINK), 1), updateArtistTextLink = ref5[0];
    var ref6, ref7;
    return {
        state: {
            artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
            user: (ref7 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {
            onSubmitMyProfile: function onSubmitMyProfile(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var snsData, _textLink;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                snsData = mapValues_default()(keyBy_default()(values.sns, "type"), "url");
                                return [
                                    4,
                                    updateArtistSns({
                                        variables: {
                                            inputs: snsData
                                        },
                                        //not need save cache
                                        fetchPolicy: "no-cache"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    updateArtistProfileText({
                                        variables: {
                                            profileText: values.introduction.length ? values.introduction : null
                                        },
                                        //not need save cache
                                        fetchPolicy: "no-cache"
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    updateArtistTextLink({
                                        variables: {
                                            inputs: (_textLink = values.textLink) !== null && _textLink !== void 0 ? _textLink : []
                                        },
                                        //not need save cache
                                        fetchPolicy: "no-cache"
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    artistUpdateArtistProfile({
                                        variables: {
                                            inputs: {
                                                displayName: values.displayName,
                                                accountId: values.accountId,
                                                introduction: values.introduction,
                                                avatarPath: values.avatarPath
                                            }
                                        }
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    router.goBack(routerPages.ConsoleAccountSetting)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickAvatar: function onClickAvatar() {
                return getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image).then(function(file) {
                    if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                        throw new Error("uploadErrorMaximumSize");
                    }
                    return upload(file);
                }).catch(function(error) {
                    if (error.message === "uploadErrorMaximumSize") {
                        showError(new Error(t("uploadErrorMaximumSize")));
                        return;
                    }
                    if (error.message === "uploadErrorImageOnly") {
                        showError(new Error(t("uploadErrorImageOnly")));
                        return;
                    }
                    showError(error);
                    return;
                });
            }
        }
    };
});
var ConsoleMyProfileEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleMyProfileEdit_viewModel_templateObject(), fragments_fragments.consoleMyProfile);
var ARTIST_UPDATE_ARTIST_PROFILE = (0,lib/* gql */.Ps)(ConsoleMyProfileEdit_viewModel_templateObject1(), fragments_fragments.consoleMyProfile);
var UPDATE_ARTIST_SNS = (0,lib/* gql */.Ps)(ConsoleMyProfileEdit_viewModel_templateObject2(), fragments_fragments.consoleMyProfile);
var UPDATE_ARTIST_PROFILE_TEXT = (0,lib/* gql */.Ps)(ConsoleMyProfileEdit_viewModel_templateObject3(), fragments_fragments.consoleMyProfile);
var UPDATE_ARTIST_TEXT_LINK = (0,lib/* gql */.Ps)(ConsoleMyProfileEdit_viewModel_templateObject4(), fragments_fragments.consoleMyProfile);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleMyProfileEdit/index.tsx




/**
 * ConsoleMyProfileEdit Page
 * Implemented as a practical sample.
 */ var ConsoleMyProfileEdit = function() {
    var ref = ConsoleMyProfileEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleMyProfileEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationCreate/template/ConsoleOfficialInformationCreateForm.tsx













var ConsoleOfficialInformationCreateForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationCreate.title")),
        body: o.string().max(3000).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationCreate.body")),
        link: o.string().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationCreate.link")),
        status: o.string().label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationCreate.status"))
    };
};
var ConsoleOfficialInformationCreateForm = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: ConsoleOfficialInformationCreateForm_schema,
        defaultValues: ConsoleOfficialInformationCreateForm_defaultValues
    }), _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, register = ref1.register, setError = ref1.setError, handleSubmit = ref1.handleSubmit;
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 2,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title,
                displayRequire: {
                    display: true
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationCreateForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 4,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("body")), {
                error: errors === null || errors === void 0 ? void 0 : errors.body
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputLinkCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("link")), {
                error: errors === null || errors === void 0 ? void 0 : errors.link
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationCreateForm_ButtonCell, {
                submitting: isSubmitting,
                disabled: isSubmitting || !isValid,
                onSubmit: handleSubmit(function() {
                    return setOpenConfirm(true);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirmCreateTitle"),
                content: t("confirmCreateDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: isSubmitting,
                    disabled: isSubmitting,
                    onClick: handleOnSubmit,
                    children: t("publish")
                }),
                cancelText: t("cancel")
            })
        ]
    });
};
var ConsoleOfficialInformationCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            ref: ref,
            t: t
        }))
    });
});
var TextInputLinkCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("linkTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                pt: 1,
                children: t("linkNote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                titleProps: {
                    sx: {
                        display: "none"
                    }
                },
                ref: ref,
                t: t
            }))
        ]
    });
});
var ConsoleOfficialInformationCreateForm_ButtonCell = function(param) {
    var submitting = param.submitting, disabled = param.disabled, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        pb: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            loading: submitting,
            disabled: disabled,
            onClick: onSubmit,
            children: t("publish")
        })
    });
};
var ConsoleOfficialInformationCreateForm_defaultValues = {
    title: "",
    body: "",
    link: "",
    status: utoniq_core_schema/* ArtistCreateOrganizationNotificationStatus.Published */._F9.Published
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationCreate/template/index.tsx







var ConsoleOfficialInformationCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleOfficialInformationCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationCreateForm, {
                    onSubmit: onSubmit
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationCreate/viewModel.ts




function ConsoleOfficialInformationCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistCreateOrganizationNotification(\n    $inputs: ArtistCreateOrganizationNotificationInput!\n  ) {\n    artistCreateOrganizationNotification(inputs: $inputs) {\n      ...OfficialInformationConsoleBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformationCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var ConsoleOfficialInformationCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationCreate").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_ORGANIZATION_NOTIFICATION, {
        onCompleted: function onCompleted() {
            showMessage(t("createSuccess"), "success");
            router.goBack(routerPages.ConsoleOfficialInformations);
        }
    }), 1), createOrganizationNotification = ref1[0];
    var ref2;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : ""
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var title = param.title, body = param.body, status = param.status, link = param.link, publishedAt = param.publishedAt;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createOrganizationNotification({
                                        variables: {
                                            inputs: {
                                                title: title,
                                                body: body || null,
                                                status: status || null,
                                                link: link || null,
                                                publishedAt: publishedAt || undefined
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var CREATE_ORGANIZATION_NOTIFICATION = (0,lib/* gql */.Ps)(ConsoleOfficialInformationCreate_viewModel_templateObject(), utoniq_core_schema/* OfficialInformationConsoleBoxFragmentDoc */.xLu);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationCreate/index.tsx




/**
 * ConsoleOfficialInformationCreate Page
 * Implemented as a practical sample.
 */ var ConsoleOfficialInformationCreate = function() {
    var ref = ConsoleOfficialInformationCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationEdit/template/ConsoleOfficialInformationEditForm.tsx












var ConsoleOfficialInformationEditForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationEdit.title")),
        body: o.string().max(3000).optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationEdit.body")),
        link: o.string().optional().allow(null, "").label((0,core_form/* tLabel */.TQ)("consoleOfficialInformationEdit.link"))
    };
};
var ConsoleOfficialInformationEditFormForm = function(param) {
    var officialInformation = param.officialInformation, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: ConsoleOfficialInformationEditForm_schema,
        defaultValues: ConsoleOfficialInformationEditForm_defaultValues
    }), _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, reset = ref1.reset, register = ref1.register, setError = ref1.setError, handleSubmit = ref1.handleSubmit;
    (0,react.useEffect)(function() {
        if (!officialInformation) return;
        var _title, _body, _link;
        reset({
            title: (_title = officialInformation.title) !== null && _title !== void 0 ? _title : "",
            body: (_body = officialInformation.body) !== null && _body !== void 0 ? _body : "",
            link: (_link = officialInformation.link) !== null && _link !== void 0 ? _link : ""
        });
    }, [
        officialInformation
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(function(error) {
                                (0,core_form/* handleError */.S3)(error, setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            pt: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 2,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("title")), {
                error: errors === null || errors === void 0 ? void 0 : errors.title,
                displayRequire: {
                    display: true
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 4,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                }
            }, register("body")), {
                error: errors === null || errors === void 0 ? void 0 : errors.body
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditForm_TextInputLinkCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text"
            }, register("link")), {
                error: errors === null || errors === void 0 ? void 0 : errors.link
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditForm_ButtonCell, {
                submitting: isSubmitting,
                disabled: isSubmitting || !isValid,
                onSubmit: handleSubmit(function() {
                    return setOpenConfirm(true);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirmEditTitle"),
                content: t("confirmEditDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: isSubmitting,
                    disabled: isSubmitting,
                    onClick: handleOnSubmit,
                    children: t("change")
                }),
                cancelText: t("cancel")
            })
        ]
    });
};
var ConsoleOfficialInformationEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            ref: ref,
            t: t
        }))
    });
});
var ConsoleOfficialInformationEditForm_TextInputLinkCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("linkTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                pt: 1,
                children: t("linkNote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                titleProps: {
                    sx: {
                        display: "none"
                    }
                },
                ref: ref,
                t: t
            }))
        ]
    });
});
var ConsoleOfficialInformationEditForm_ButtonCell = function(param) {
    var submitting = param.submitting, disabled = param.disabled, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        pb: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            loading: submitting,
            disabled: disabled,
            onClick: onSubmit,
            children: t("save")
        })
    });
};
var ConsoleOfficialInformationEditForm_defaultValues = {
    title: "",
    body: "",
    link: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationEdit/template/index.tsx







var ConsoleOfficialInformationEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleOfficialInformationEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditFormForm, {
                    officialInformation: state.officialInformation,
                    onSubmit: onSubmit
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationEdit/viewModel.ts




function ConsoleOfficialInformationEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleOfficialInformationEdit($id: ID!) {\n    artistOrganizationNotification(id: $id) {\n      ...OfficialInformationConsoleBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformationEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleOfficialInformationEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdateOrganizationNotification(\n    $id: ID!\n    $inputs: ArtistUpdateOrganizationNotificationInput!\n  ) {\n    artistUpdateOrganizationNotification(id: $id, inputs: $inputs) {\n      ...OfficialInformationConsoleBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformationEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





/**
 *
 */ var ConsoleOfficialInformationEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformationEdit").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(ConsoleOfficialInformationEdit_viewModel_QUERY, {
        variables: {
            id: router.query.officialInformationId
        }
    }).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ORGANIZATION_NOTIFICATION, {
        onCompleted: function onCompleted() {
            showMessage(t("editSuccess"), "success");
            router.goBack(routerPages.ConsoleOfficialInformations);
        }
    }), 1), artistUpdateOrganizationNotification = ref1[0];
    var ref2, ref3;
    return {
        state: {
            artistId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            officialInformation: (ref3 = data === null || data === void 0 ? void 0 : data.artistOrganizationNotification) !== null && ref3 !== void 0 ? ref3 : null
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistUpdateOrganizationNotification({
                                        variables: {
                                            id: router.query.officialInformationId,
                                            inputs: {
                                                title: values.title || undefined,
                                                body: values.body || null,
                                                link: values.link || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleOfficialInformationEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleOfficialInformationEdit_viewModel_templateObject(), utoniq_core_schema/* OfficialInformationConsoleBoxFragmentDoc */.xLu);
var UPDATE_ORGANIZATION_NOTIFICATION = (0,lib/* gql */.Ps)(ConsoleOfficialInformationEdit_viewModel_templateObject1(), utoniq_core_schema/* OfficialInformationConsoleBoxFragmentDoc */.xLu);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformationEdit/index.tsx




/**
 * ConsoleOfficialInformationEdit Page
 * Implemented as a practical sample.
 */ var ConsoleOfficialInformationEdit = function() {
    var ref = ConsoleOfficialInformationEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/notification/OfficialInformationConsoleBox/index.tsx













var OfficialInformationConsoleBox = function(param) {
    var officialInformation = param.officialInformation, onDelete = param.onDelete;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformations").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = (0,react.useState)(false), openDeleteConfirm = ref3[0], setOpenDeleteConfirm = ref3[1];
    var ref4 = (0,react.useState)(false), deletingOfficialInformation = ref4[0], setDeletingOfficialInformation = ref4[1];
    var options = [
        {
            label: t("edit", "編集"),
            onClick: function onClick() {
                router.push(generatePath(routerPages.ConsoleOfficialInformationEdit, {
                    officialInformationId: officialInformation.id
                }));
            }
        },
        {
            label: t("delete", "削除"),
            onClick: function onClick() {
                setAnchorEl(null);
                setOpenDeleteConfirm(true);
            }
        }, 
    ];
    var handleDelete = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDeletingOfficialInformation(true);
                        return [
                            4,
                            onDelete(officialInformation.id).then(function() {
                                setOpenDeleteConfirm(false);
                                showMessage(t("deleteOfficialInformationSuccess"), "success");
                            }).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        setDeletingOfficialInformation(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformationTag, {
                                        status: officialInformation.status
                                    }),
                                    officialInformation.status !== "scheduled" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("publishedAt", {
                                            date: values_Date/* DateTime.formatDate */.o.formatDate(officialInformation.publishedAt)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: officialInformation.title
                            }),
                            officialInformation.status === "scheduled" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                        sx: {
                                            width: 12,
                                            height: 12,
                                            color: "primary.main"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "primary.main",
                                        children: t("postedAtInfo", {
                                            date: values_Date/* DateTime.formatDate */.o.formatDate(officialInformation.publishedAt, "LLAHH:mm")
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "text.secondary",
                                children: t("createdAt", {
                                    date: values_Date/* DateTime.formatDate */.o.formatDate(officialInformation.createdAt)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                onClick: function(event) {
                                    return setAnchorEl(event.currentTarget);
                                },
                                size: "xSmall",
                                bgcolor: "grey.50",
                                color: "grey.700",
                                sx: {
                                    transform: "rotate(90deg)"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                open: !!anchorEl,
                                anchorEl: anchorEl,
                                onClose: function() {
                                    return setAnchorEl(null);
                                },
                                transformOrigin: {
                                    horizontal: "right",
                                    vertical: "top"
                                },
                                anchorOrigin: {
                                    horizontal: "right",
                                    vertical: "bottom"
                                },
                                children: options.map(function(_param) /*#__PURE__*/ {
                                    var label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                                        "label"
                                    ]);
                                    return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                                        sx: {
                                            width: 200
                                        },
                                        key: label
                                    }), label);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openDeleteConfirm,
                onClose: function() {
                    return setOpenDeleteConfirm(false);
                },
                title: t("deleteOfficialInformationTitle"),
                content: t("deleteOfficialInformationContent"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: deletingOfficialInformation,
                    disabled: deletingOfficialInformation,
                    onClick: handleDelete,
                    children: t("deleteBtn")
                }),
                cancelText: t("close")
            })
        ]
    });
};
var OfficialInformationTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformations").t;
    var ref = (0,react.useMemo)(function() {
        if (status === "scheduled") {
            return {
                bgColor: "secondary.main",
                color: "white"
            };
        }
        return {
            bgColor: "primary.main",
            color: "white"
        };
    }, [
        status
    ]), bgColor = ref.bgColor, color = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        sx: {
            bgcolor: bgColor,
            height: 20,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                display: "block"
            },
            color: color,
            variant: "overline",
            children: t("".concat(status, "Status"))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/notification/OfficialInformationConsoleBoxSkeleton/index.tsx



var OfficialInformationConsoleBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            flex: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    width: "50%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            flex: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformations/template/index.tsx











var ConsoleOfficialInformationsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilterByPublished = param.onFilterByPublished, onDelete = param.onDelete;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformations").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleOfficialInformations
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_HeaderCell, {
                        loading: state.loading,
                        /**
           * @description
           * Open when function is implemented in the future
           * https://app.clickup.com/t/908127/UT-17780
           */ hiddenFilter: true,
                        isFilterByPublished: state.isFilterByPublished,
                        onFilterByPublished: onFilterByPublished
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        py: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: (ref = state.officialInformations) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformationConsoleBox, {
                                    officialInformation: node,
                                    onDelete: onDelete
                                });
                            }),
                            componentProps: {
                                spacing: 6
                            },
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: onFetchMore,
                            emptyMessage: t("officialInformationEmptyMessage"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 6,
                                sx: {
                                    py: 2
                                },
                                children: Array.from(Array(5).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformationConsoleBoxSkeleton, {}, key);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformations_template_BaseCell, {})
                ]
            })
        ]
    });
};
var template_HeaderCell = function(param) {
    var loading = param.loading, hiddenFilter = param.hiddenFilter, isFilterByPublished = param.isFilterByPublished, onFilterByPublished = param.onFilterByPublished;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOfficialInformations").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                pt: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                py: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "40%"
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                py: 3,
                children: t("title")
            }),
            !hiddenFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: isFilterByPublished,
                        onClick: onFilterByPublished
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("checkBoxLabel", "公開予定のみ表示")
                    })
                })
            })
        ]
    });
};
var ConsoleOfficialInformations_template_BaseCell = function() {
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                position: "fixed",
                bottom: 16,
                zIndex: 5,
                maxWidth: 600,
                margin: "0 auto",
                px: 4,
                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                size: "medium",
                color: "primary",
                href: routerPages.ConsoleOfficialInformationCreate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                    fontSize: "medium",
                    sx: {
                        color: "white"
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformations/viewModel.ts




function ConsoleOfficialInformations_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleOfficialInformations(\n    $status: [OrganizationNotificationStatus!]\n    $pageInput: PageInput\n  ) {\n    artistOrganizationOfficialNotifications(\n      status: $status\n      pageInput: $pageInput\n    ) {\n      ...ConsoleOfficialInformationConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformations_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleOfficialInformations_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewConsoleOfficialInformations(\n    $status: [OrganizationNotificationStatus!]\n  ) {\n    artistOrganizationOfficialNotifications(status: $status) {\n      ...ConsoleOfficialInformationConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformations_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleOfficialInformations_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistArchiveOrganizationNotification($id: ID!) {\n    artistArchiveOrganizationNotification(id: $id) {\n      ...OfficialInformationConsoleBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOfficialInformations_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var ConsoleOfficialInformations_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,react.useState)(false), isFilterByPublished = ref2[0], setIsFilterByPublished = ref2[1];
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_OFFICIAL_INFORMATION,
        variables: {
            status: [
                utoniq_core_schema/* OrganizationNotificationStatus.Published */.fIw.Published, 
            ]
        },
        fields: [
            {
                fragmentName: "OfficialInformationConsoleBox",
                fieldName: "artistOrganizationOfficialNotifications",
                fragment: utoniq_core_schema/* OfficialInformationConsoleBoxFragmentDoc */.xLu
            }, 
        ]
    }).isFirstLoadRef;
    var ref3 = (0,useQuery/* useQuery */.aM)(ConsoleOfficialInformations_viewModel_QUERY, {
        variables: {
            status: [
                utoniq_core_schema/* OrganizationNotificationStatus.Published */.fIw.Published, 
            ]
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref3.data, loading = ref3.loading, fetchMore = ref3.fetchMore;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARCHIVE_ORGANIZATION_NOTIFICATION), 1), archiveOrganizationNotification = ref4[0];
    var isNextFetch = !!data;
    var ref5, ref6;
    return {
        state: {
            artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
            loading: loading && !isNextFetch,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistOrganizationOfficialNotifications) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
            isFilterByPublished: isFilterByPublished,
            officialInformations: (ref6 = data === null || data === void 0 ? void 0 : data.artistOrganizationOfficialNotifications) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            status: [
                                                utoniq_core_schema/* OrganizationNotificationStatus.Published */.fIw.Published
                                            ],
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistOrganizationOfficialNotifications) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilterByPublished: function onFilterByPublished() {
                setIsFilterByPublished(function(prevState) {
                    return !prevState;
                });
            },
            onDelete: function onDelete(id) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    archiveOrganizationNotification({
                                        variables: {
                                            id: id
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleOfficialInformations_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleOfficialInformations_viewModel_templateObject(), utoniq_core_schema/* ConsoleOfficialInformationConnectionFragmentDoc */.kJ);
var FETCH_NEW_OFFICIAL_INFORMATION = (0,lib/* gql */.Ps)(ConsoleOfficialInformations_viewModel_templateObject1(), utoniq_core_schema/* ConsoleOfficialInformationConnectionFragmentDoc */.kJ);
var ARCHIVE_ORGANIZATION_NOTIFICATION = (0,lib/* gql */.Ps)(ConsoleOfficialInformations_viewModel_templateObject2(), utoniq_core_schema/* OfficialInformationConsoleBoxFragmentDoc */.xLu);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOfficialInformations/index.tsx




/**
 * ConsoleOfficialInformations Page
 * Implemented as a practical sample.
 */ var ConsoleOfficialInformations = function() {
    var ref = ConsoleOfficialInformations_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOfficialInformationsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/store/PaymentInfo/index.tsx






var PaymentInfo = function(param) {
    var loading = param.loading, formattedPrepaidPointBalance = param.formattedPrepaidPointBalance, paymentSource = param.paymentSource, purchaseType = param.purchaseType, showNote = param.showNote;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoSkeleton, {});
    switch(purchaseType){
        case "konbini":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        sx: {
                            py: 3
                        },
                        children: t("paymentInfo", "支払い情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                px: 5,
                                py: 3,
                                "&:last-child": {
                                    pb: 3
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("convenienceStore", "コンビニ決済")
                                    }),
                                    showNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: {
                                            display: "block",
                                            mt: 2
                                        },
                                        children: t("convenienceStoreDesc", "ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。")
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        case "cash":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        sx: {
                            py: 3
                        },
                        children: t("paymentInfo", "支払い情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                px: 5,
                                py: 3,
                                "&:last-child": {
                                    pb: 3
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: !paymentSource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("creditCard", "クレジットカード")
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                            height: 25,
                                            src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                            target: "common"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("last4Digits", {
                                                number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            });
        case "prepaid_point":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                color: "text.secondary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        sx: {
                            py: 3
                        },
                        children: t("paymentInfo", "支払い情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                px: 5,
                                py: 3,
                                "&:last-child": {
                                    pb: 3
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    mt: 1,
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                children: t("purchaseByPoint", "ポイントで購入")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "text.secondary",
                                                        children: t("pointBalance", "ポイント残高")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                        point: formattedPrepaidPointBalance
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            });
        default:
            return null;
    }
};
var PaymentInfoSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 6,
                        "&:last-child": {
                            pb: 6
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 32,
                        width: "50%"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/ShippingAddress/index.tsx







var ShippingAddress = function(param) {
    var loading = param.loading, fullName = param.fullName, address = param.address, isPhoneNumberVerified = param.isPhoneNumberVerified, isDeletedUser = param.isDeletedUser, phoneNumber = param.phoneNumber, rightLink = param.rightLink, hideVerified = param.hideVerified, personalInformationRequirements = param.personalInformationRequirements;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    var hasError = (0,react.useMemo)(function() {
        return(// 氏名未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && !fullName || // 電番未認証
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber) && !isPhoneNumberVerified && !hideVerified || // 住所未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && !(address === null || address === void 0 ? void 0 : address.fullAddress));
    }, [
        fullName,
        personalInformationRequirements,
        address,
        isPhoneNumberVerified
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddressSkeleton, {});
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("personalInfo")
                    }),
                    !!rightLink && !isDeletedUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "h5",
                        href: rightLink,
                        children: t("viewDetail", "詳細を見る")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2,
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: isDeletedUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("deletedUser")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "error.main",
                                children: t("personalInfoError", "商品の購入にはお客様情報の登録が必要です。")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    pt: hasError ? 2 : 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("familyName", "氏名")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: fullName ? "text.primary" : "text.hint",
                                        children: fullName !== null && fullName !== void 0 ? fullName : t("unregisteredFullName", "氏名が登録されていません")
                                    })
                                ]
                            }),
                            personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    pt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("address")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: (address === null || address === void 0 ? void 0 : address.fullAddress) ? "text.primary" : "text.hint",
                                        children: (ref = address === null || address === void 0 ? void 0 : address.fullAddress) !== null && ref !== void 0 ? ref : t("unregisteredAddress")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    pt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 3,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: t("phoneNumber")
                                            }),
                                            !isPhoneNumberVerified && !hideVerified ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                                        fontSize: "small",
                                                        sx: {
                                                            color: "error.main",
                                                            mt: -1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        color: "error.main",
                                                        children: t("unverify")
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: !hideVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 1,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                                            fontSize: "small",
                                                            sx: {
                                                                color: "text.hint",
                                                                mt: -1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "body2",
                                                            color: "text.hint",
                                                            children: t("verified")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: phoneNumber
                                    }),
                                    !phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.hint",
                                        children: t("unregistered")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var ShippingAddressSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5,
            mt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h3",
                width: "50%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                    elevation: 0,
                    sx: {
                        borderRadius: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 3,
                            "&:last-child": {
                                pb: 3
                            }
                        },
                        children: Array.from(Array(3).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "50%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "100%"
                                    })
                                ]
                            }, key);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/OrderItemDetailSkeleton/index.tsx




var OrderItemDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "50%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    sx: {
                                        pt: 5
                                    },
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                            variant: "rectangular",
                                            width: 60,
                                            height: 96
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "h3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "small",
                                                    sx: {
                                                        mt: 2
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "medium",
                                                    width: "40%",
                                                    sx: {
                                                        mt: 2
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            width: "30%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "h3"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            width: "30%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "h3"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseProceed/template/ReceiveTimeModal.tsx













var ReceiveTimeModal_schema = function(o) {
    return {
        collectionId: o.string(),
        pickupDate: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.pickupDate")).required(),
        pickupTime: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.pickupTime")).required()
    };
};
var ReceiveTimeModal = function(param) {
    var pickupTime = param.pickupTime, collectionId = param.collectionId, collectionTitle = param.collectionTitle, validMinutes = param.validMinutes, open = param.open, myPickupUsers = param.myPickupUsers, cartItems = param.cartItems, onClose = param.onClose, onSubmit = param.onSubmit, eventCollection = param.eventCollection, sx = param.sx;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    // 受取時間毎の上限を超えた時のエラー表示を行うためのフラグ
    var ref2 = (0,react.useState)(null), errorTime = ref2[0], setErrorTime = ref2[1];
    var ref3 = (0,core_form/* useForm */.cI)({
        schema: ReceiveTimeModal_schema,
        defaultValues: {
            collectionId: collectionId,
            pickupDate: "",
            pickupTime: ""
        }
    }), handleSubmit = ref3.handleSubmit, setValue = ref3.setValue, watch = ref3.watch, _formState = ref3.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    // 入力可能な最初の日付を初期値として設定する
    // NOTE: 購入手続き中に時間外になる可能性があるのでAPIのバリデーション(10分)より5分余分にチェックする
    (0,react.useEffect)(function() {
        var ref, ref1;
        var ref2;
        var availableFirstDateTime = (ref2 = (ref = pickupTime === null || pickupTime === void 0 ? void 0 : pickupTime.find(function(param) {
            var options = param.options;
            var result = options.availableUserNumber > options.currentUserNumber && dayjs_min_default()(options.time).add(validMinutes - 15, "minutes").unix() > dayjs_min_default()().unix();
            return result;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.options) === null || ref1 === void 0 ? void 0 : ref1.time) !== null && ref2 !== void 0 ? ref2 : "";
        setValue("pickupDate", "".concat(values_Date/* DateTime.formatDate */.o.formatDate(availableFirstDateTime, "YYYY/MM/DD")));
        setValue("pickupTime", "".concat(values_Date/* DateTime.formatDate */.o.formatDate(availableFirstDateTime, "HH:mm")));
    }, []);
    // 日付ごとに時間をマッピングしたもの
    var actualPickupTime = Object.entries(pickupTime === null || pickupTime === void 0 ? void 0 : pickupTime.map(function(param) {
        var options = param.options;
        return {
            date: String(values_Date/* DateTime.formatDate */.o.formatDate(options.time, "MM/DD")),
            time: options.time,
            availableUserNumber: options.availableUserNumber - options.currentUserNumber
        };
    }).reduce(function(acc, param) {
        var date = param.date, time = param.time, availableUserNumber = param.availableUserNumber;
        if (!acc[date]) acc[date] = [];
        acc[date].push({
            time: time,
            availableUserNumber: availableUserNumber
        });
        return acc;
    }, {})).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), date = _param[0], times = _param[1];
        return {
            date: date,
            times: times
        };
    });
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        sx: (0,src_object_spread/* default */.Z)({}, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                ml: "30px"
                            },
                            children: t("pickupDateTime", "受け取り日時の選択")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "small",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pb: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                pt: 2
                            },
                            children: collectionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("pickupDate", "受取日")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
                                    value: watch("pickupDate"),
                                    tags: actualPickupTime.map(function(param) {
                                        var date = param.date, times = param.times;
                                        return {
                                            value: String(values_Date/* DateTime.formatDate */.o.formatDate(times[0].time, "YYYY/MM/DD")),
                                            label: date,
                                            // その日の最後の開始時間+有効時間-10分を過ぎた場合は選択不可
                                            disabled: dayjs_min_default()(times.slice(-1)[0].time).add(validMinutes - 10, "minute").unix() < dayjs_min_default()().unix()
                                        };
                                    }),
                                    onClick: function(newValue) {
                                        if (newValue !== watch("pickupDate")) {
                                            setValue("pickupTime", "");
                                        }
                                        setValue("pickupDate", newValue);
                                        setErrorTime(null);
                                    }
                                }),
                                errors.pickupDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                    error: true,
                                    sx: {
                                        bgcolor: "unset"
                                    },
                                    children: errors.pickupDate.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("pickupTime", "受取時間")
                                }),
                                calcurateIsJustNow(eventCollection, dayjs_min_default()("".concat(watch("pickupDate"), " ").concat(watch("pickupTime"))).valueOf()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(JustNowChip, {
                                    hasBubble: true,
                                    sx: {
                                        position: "relative",
                                        left: 8,
                                        top: 2
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveTimeTags, {
                                    value: watch("pickupTime"),
                                    tags: (ref4 = (ref = actualPickupTime.find(function(param) {
                                        var date = param.date;
                                        return date === values_Date/* DateTime.formatDate */.o.formatDate(watch("pickupDate"), "MM/DD");
                                    })) === null || ref === void 0 ? void 0 : (ref1 = ref.times) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
                                        var time = param.time, availableUserNumber = param.availableUserNumber;
                                        return {
                                            value: String(values_Date/* DateTime.formatDate */.o.formatDate(time, "HH:mm")),
                                            label: "".concat(String(values_Date/* DateTime.formatDate */.o.formatDate(time, "HH:mm")), " \n〜 ").concat(String(values_Date/* DateTime.formatDate */.o.formatDate(dayjs_min_default()(time).add(validMinutes, "minute").valueOf(), "HH:mm"))),
                                            // 受付開始時間+有効時間-10分を過ぎた場合は選択不可
                                            disabled: dayjs_min_default()(time).add(validMinutes - 10, "minutes").unix() < dayjs_min_default()().unix() || !availableUserNumber,
                                            availableUserNumber: availableUserNumber
                                        };
                                    })) !== null && ref4 !== void 0 ? ref4 : [],
                                    errorTime: errorTime,
                                    onClick: function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        // 受け取り時間毎の購入制限チェック
                                                        return [
                                                            4,
                                                            checkPurchaseLimitPerPickup({
                                                                collectionId: collectionId,
                                                                date: watch("pickupDate"),
                                                                hour: newValue,
                                                                myPickupUsers: myPickupUsers,
                                                                purchaseLimitPerPickup: eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup,
                                                                cartItems: cartItems,
                                                                message: t("purchaseLimitPerPickupTimeSelectError", {
                                                                    number: eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup
                                                                })
                                                            }).then(function() {
                                                                setValue("pickupTime", newValue);
                                                                setErrorTime(null);
                                                            }).catch(function(e) {
                                                                showError(e);
                                                                setValue("pickupTime", "");
                                                                setErrorTime(newValue);
                                                            })
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(newValue) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()
                                }),
                                errors.pickupTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                    error: true,
                                    sx: {
                                        bgcolor: "unset"
                                    },
                                    children: errors.pickupTime.message
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        py: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 212
                        },
                        onClick: handleSubmit(function(values) {
                            onSubmit(values);
                            onClose();
                        }),
                        children: t("decide", "決定する")
                    })
                })
            ]
        })
    });
};
var ReceiveTimeTags = function(param) {
    var tags = param.tags, value = param.value, onClick = param.onClick, errorTime = param.errorTime;
    var isActive = (0,react.useCallback)(function(tagValue) {
        return tagValue === value;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        flexWrap: "wrap",
        sx: (0,src_object_spread/* default */.Z)({
            py: 2,
            overflowY: "auto"
        }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 2,
            direction: "row",
            children: tags.map(function(tag, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    disabled: tag.disabled,
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "inherit",
                                sx: {
                                    whiteSpace: "pre",
                                    lineHeight: 1.2
                                },
                                children: tag.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "inherit",
                                align: "center",
                                sx: {
                                    whiteSpace: "pre",
                                    lineHeight: 1.2
                                },
                                children: [
                                    !tag.availableUserNumber && "\xd7",
                                    tag.availableUserNumber >= 1 && tag.availableUserNumber < 10 && "△",
                                    tag.availableUserNumber >= 10 && "◯"
                                ]
                            })
                        ]
                    }),
                    onClick: function() {
                        return onClick(tag.value);
                    },
                    color: isActive(tag.value) ? "primary" : "default",
                    variant: isActive(tag.value) ? "filled" : "outlined",
                    sx: {
                        py: "2px",
                        borderRadius: 2,
                        bgcolor: isActive(tag.value) ? "primary.main" : tag.disabled ? "transparent" : "background.default",
                        color: isActive(tag.value) ? "background.default" : "text.hint",
                        borderColor: tag.value === errorTime ? "error.main" : isActive(tag.value) ? "primary.main" : "grey.100",
                        borderWidth: 1,
                        borderStyle: "solid",
                        height: "auto"
                    }
                }, index);
            })
        })
    });
};
/** 「コレクションの、受取時間ごとのアイテム合計数の制限」purchaseLimitPerPickuupをチェックする。選択した受取時間において、アイテムの所持数 + カート総数が上限を超過していればエラーを投げる */ function checkPurchaseLimitPerPickup(_) {
    return _checkPurchaseLimitPerPickup.apply(this, arguments);
}
function _checkPurchaseLimitPerPickup() {
    _checkPurchaseLimitPerPickup = (0,src_async_to_generator/* default */.Z)(function(param) {
        var collectionId, date, hour, myPickupUsers, purchaseLimitPerPickup, cartItems, message, cartItemsCount, targetPickupTime, ref, ownedItemsCount;
        return (0,tslib_es6.__generator)(this, function(_state) {
            collectionId = param.collectionId, date = param.date, hour = param.hour, myPickupUsers = param.myPickupUsers, purchaseLimitPerPickup = param.purchaseLimitPerPickup, cartItems = param.cartItems, message = param.message;
            if (!purchaseLimitPerPickup) return [
                2
            ];
            cartItemsCount = cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(acc, crr) {
                var ref;
                if (((ref = crr.item.collection) === null || ref === void 0 ? void 0 : ref.id) !== collectionId) return acc;
                return acc + crr.count;
            }, 0);
            // カート内アイテムの合計値が上限を超えていればエラー
            if (cartItemsCount && cartItemsCount > purchaseLimitPerPickup) {
                throw new Error(message);
            }
            if (!date || !hour) return [
                2
            ];
            targetPickupTime = dayjs_min_default()("".concat(date, " ").concat(hour)).valueOf();
            ownedItemsCount = (ref = myPickupUsers === null || myPickupUsers === void 0 ? void 0 : myPickupUsers.reduce(function(acc, crr) {
                var ref;
                if (crr.pickupTime !== targetPickupTime) return acc;
                return acc + ((ref = crr.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, crr) {
                    return crr.collectionId === collectionId ? acc + crr.count : acc;
                }, 0));
            }, 0)) !== null && ref !== void 0 ? ref : 0;
            // その時間のアイテム所有合計地とカート内アイテム数合計値が上限を超えていればエラー
            if (!cartItemsCount || cartItemsCount + ownedItemsCount <= purchaseLimitPerPickup) return [
                2
            ];
            throw new Error(message);
        });
    });
    return _checkPurchaseLimitPerPickup.apply(this, arguments);
}
// 与えられた時間が「今すぐ」に当てはまるか算出する
var calcurateIsJustNow = function(eventCollection, time) {
    if (!time || !eventCollection || !(eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes)) return false;
    return dayjs_min_default()().valueOf() > time && dayjs_min_default()(time).add(eventCollection.validMinutes - 10, "minute").valueOf() > dayjs_min_default()().valueOf();
};
// 「今すぐ受け取り」を表示するためのチップコンポーネント
var JustNowChip = function(param) {
    var _hasBubble = param.hasBubble, hasBubble = _hasBubble === void 0 ? false : _hasBubble, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: sx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                position: "relative",
                bgcolor: "like.tap",
                width: "66px",
                height: "16px",
                flexGrow: 0,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                padding: "2px 8px",
                borderRadius: "20px"
            },
            children: [
                hasBubble && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        width: "7px",
                        height: "7px",
                        transform: "rotate(45deg)",
                        bgcolor: "like.tap",
                        right: 0,
                        left: 0,
                        margin: "auto",
                        bottom: "-2.6px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    sx: {
                        color: "white",
                        fontSize: "10px",
                        lineHeight: 1.2,
                        letterSpacing: "normal"
                    },
                    children: t("justNow")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseProceed/template/index.tsx


























var template_schema = function(o) {
    return {
        purchaseType: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.type")),
        fullName: o.string().when("type", {
            is: "konbini",
            then: o.string(),
            otherwise: o.string().optional().allow("")
        }).label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.fullName")),
        receiptDateTimes: o.array().items({
            collectionId: o.string().optional().allow(""),
            hasPickupItem: o.boolean().optional(),
            pickupDate: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.receiptDateTime")).when("hasPickupItem", {
                is: true,
                then: o.required(),
                otherwise: o.optional().allow("")
            }),
            pickupTime: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.receiptDateTime")).when("hasPickupItem", {
                is: true,
                then: o.required(),
                otherwise: o.optional().allow("")
            })
        }).optional()
    };
};
var StoreItemPurchaseProceedTemplate = function(param) {
    var state = param.state, onPurchasePoint = param.onPurchasePoint, onSendVerificationSMS = param.onSendVerificationSMS;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref18 = (0,router_useRouter/* useRouter */.tv)(), router = ref18.router, routerNames = ref18.routerNames, generatePath = ref18.generatePath, routerPages = ref18.routerPages;
    // 受取時間のバリデーションエラーのコレクションIDを格納
    var ref19 = (0,react.useState)([]), purchaseLimitPerPickupErrorIds = ref19[0], setPurchaseLimitPerPickupErrorIds = ref19[1];
    var ref20 = (0,core_form/* useForm */.cI)({
        schema: template_schema,
        defaultValues: {
            purchaseType: "prepaid_point",
            receiptDateTimes: []
        }
    }), watch = ref20.watch, setValue = ref20.setValue, handleSubmit = ref20.handleSubmit, reset = ref20.reset, register = ref20.register, _formState = ref20.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors;
    var purchaseType = watch("purchaseType");
    // 個人情報の登録必須項目
    var personalInformationRequirements = (0,react.useMemo)(function() {
        if (!state.cartItems) return [];
        var result = state.cartItems.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        state.cartItems
    ]);
    var handleProceed = function(value) {
        var ref, ref1;
        var receiptDateTimes = value.receiptDateTimes, rest = (0,_object_without_properties/* default */.Z)(value, [
            "receiptDateTimes"
        ]);
        var ref2;
        // 受け取り時間のフォーマットを修正
        var pickupTimes = (ref2 = (ref = receiptDateTimes === null || receiptDateTimes === void 0 ? void 0 : receiptDateTimes.map(function(param) {
            var collectionId = param.collectionId, pickupDate = param.pickupDate, pickupTime = param.pickupTime;
            return {
                collectionId: collectionId,
                pickupTime: pickupTime ? dayjs_min_default()("".concat(pickupDate, " ").concat(pickupTime)).tz().format() : null
            };
        })) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var pickupTime = param.pickupTime;
            return !!pickupTime;
        })) !== null && ref2 !== void 0 ? ref2 : null;
        (0,storage/* setStoreProceed */.gQ)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
            pickupTimes: pickupTimes
        }));
        var ref3;
        router.replace(generatePath(routerPages.StoreItemPurchaseConfirmation, {
            cartId: (ref3 = (ref1 = state.cart) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : "#"
        }));
    };
    var ref21 = (0,react.useState)(false), openPointPurchaseDrawer = ref21[0], setOpenPointPurchaseDrawer = ref21[1];
    var hasEnoughPoint = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var ref5, ref6;
        var totalPriceFee = getTotalPriceFee({
            totalPrice: (ref = state.cart) === null || ref === void 0 ? void 0 : ref.totalPrice,
            totalSystemFee: (ref6 = (ref1 = state.systemFee) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(total, fee) {
                return total + ((ref5 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref5 !== void 0 ? ref5 : 0);
            }, 0)) !== null && ref6 !== void 0 ? ref6 : 0,
            purchaseType: purchaseType,
            shippingFee: (ref2 = state.shippingFee) === null || ref2 === void 0 ? void 0 : ref2.fee,
            konbiniFee: (ref3 = state.konbiniFee) === null || ref3 === void 0 ? void 0 : ref3.fee
        });
        var ref7;
        return totalPriceFee <= ((ref7 = (ref4 = state.prepaidPointBalance) === null || ref4 === void 0 ? void 0 : ref4.balance) !== null && ref7 !== void 0 ? ref7 : 0);
    }, [
        purchaseType,
        (ref = state.cart) === null || ref === void 0 ? void 0 : ref.totalPrice,
        (ref1 = state.konbiniFee) === null || ref1 === void 0 ? void 0 : ref1.fee,
        (ref2 = state.prepaidPointBalance) === null || ref2 === void 0 ? void 0 : ref2.balance,
        (ref3 = state.shippingFee) === null || ref3 === void 0 ? void 0 : ref3.fee,
        state.systemFee, 
    ]);
    // 入力項目が不足し、次のステップに進めない状態
    var disableToNext = (0,react.useMemo)(function() {
        var ref, // ポイント不足
        ref1, ref2;
        return(// 氏名未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && !state.fullName || // 電番未認証
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber) && !state.isPhoneNumberVerified || // 住所未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && !((ref = state.address) === null || ref === void 0 ? void 0 : ref.fullAddress) || ((ref1 = state.cart) === null || ref1 === void 0 ? void 0 : ref1.paymentType) === "prepaid_point" && !hasEnoughPoint || // 氏名未入力
        purchaseType === "konbini" && !watch("fullName") || // クレカ未登録
        purchaseType === "cash" && !((ref2 = state.paymentSource) === null || ref2 === void 0 ? void 0 : ref2.id) || // コレクションの購入上限を超過した数がカートに入っている
        purchaseLimitPerPickupErrorIds.length > 0);
    }, [
        personalInformationRequirements,
        state.fullName,
        state.isPhoneNumberVerified,
        (ref4 = state.address) === null || ref4 === void 0 ? void 0 : ref4.fullAddress,
        (ref5 = state.cart) === null || ref5 === void 0 ? void 0 : ref5.paymentType,
        (ref6 = state.paymentSource) === null || ref6 === void 0 ? void 0 : ref6.id,
        hasEnoughPoint,
        purchaseType,
        watch("fullName"),
        purchaseLimitPerPickupErrorIds.length, 
    ]);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        var ref2;
        reset({
            fullName: state.fullName,
            purchaseType: (ref = state.cart) === null || ref === void 0 ? void 0 : ref.paymentType,
            receiptDateTimes: (ref2 = (ref1 = state.cartItemsByCollection) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                var eventCollection = param.eventCollection;
                var ref, ref1, ref2, ref3, ref4, ref5;
                var pickupDate = "";
                var pickupTime = "";
                var ref6;
                // 選択可能な受取時間をフィルタ
                var pickuptime = eventCollection === null || eventCollection === void 0 ? void 0 : (ref = eventCollection.pickupTime) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                    var options = param.options;
                    return dayjs_min_default()(options.time).add((ref6 = eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes) !== null && ref6 !== void 0 ? ref6 : 0, "minute").valueOf() > dayjs_min_default()().valueOf();
                });
                // 今すぐ受け取れる商品がある場合、初期値を設定
                if (calcurateIsJustNow(eventCollection, pickuptime === null || pickuptime === void 0 ? void 0 : (ref1 = pickuptime[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.options) === null || ref2 === void 0 ? void 0 : ref2.time)) {
                    var ref7, ref8;
                    pickupDate = values_Date/* DateTime.formatDate */.o.formatDate((ref7 = pickuptime === null || pickuptime === void 0 ? void 0 : pickuptime[0].options) === null || ref7 === void 0 ? void 0 : ref7.time, "YYYY/MM/DD");
                    pickupTime = values_Date/* DateTime.formatDate */.o.formatDate((ref8 = pickuptime === null || pickuptime === void 0 ? void 0 : pickuptime[0].options) === null || ref8 === void 0 ? void 0 : ref8.time, "HH:mm");
                }
                var ref9;
                // コレクションの受け取り時間毎の購入上限のバリデーションも行う
                checkPurchaseLimitPerPickup({
                    collectionId: (ref9 = eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.collectionId) !== null && ref9 !== void 0 ? ref9 : "",
                    date: pickupDate,
                    hour: pickupTime,
                    myPickupUsers: state.myPickupUsers,
                    purchaseLimitPerPickup: eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup,
                    cartItems: state.cartItems,
                    message: t("purchaseLimitPerPickupTimeSelectError", {
                        number: eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup
                    })
                }).catch(function(e) {
                    var ref;
                    setPurchaseLimitPerPickupErrorIds(function(prev) {
                        return (0,src_to_consumable_array/* default */.Z)(prev).concat([
                            (ref = eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.id) !== null && ref !== void 0 ? ref : "", 
                        ]);
                    });
                });
                // 選択枠が1のみの場合、初期値を設定
                if ((eventCollection === null || eventCollection === void 0 ? void 0 : (ref3 = eventCollection.pickupTime) === null || ref3 === void 0 ? void 0 : ref3.length) === 1) {
                    var ref10, ref11;
                    pickupDate = values_Date/* DateTime.formatDate */.o.formatDate((ref10 = eventCollection.pickupTime[0].options) === null || ref10 === void 0 ? void 0 : ref10.time, "YYYY/MM/DD");
                    pickupTime = values_Date/* DateTime.formatDate */.o.formatDate((ref11 = eventCollection.pickupTime[0].options) === null || ref11 === void 0 ? void 0 : ref11.time, "HH:mm");
                }
                return {
                    hasPickupItem: !!(eventCollection === null || eventCollection === void 0 ? void 0 : (ref4 = eventCollection.pickupTime) === null || ref4 === void 0 ? void 0 : ref4.length),
                    collectionId: (eventCollection === null || eventCollection === void 0 ? void 0 : (ref5 = eventCollection.pickupTime) === null || ref5 === void 0 ? void 0 : ref5.length) ? eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.collectionId : "",
                    pickupDate: pickupDate,
                    pickupTime: pickupTime
                };
            })) !== null && ref2 !== void 0 ? ref2 : []
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.fullName,
        (ref7 = state.cartItemsByCollection) === null || ref7 === void 0 ? void 0 : ref7.length
    ]);
    var ref22, ref23, ref24, _paymentSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        header: (0,src_object_spread/* default */.Z)({
            back: true,
            defaultBackPage: generatePath(routerPages.StoreCartDetail, {
                cartId: (ref22 = (ref8 = state.cart) === null || ref8 === void 0 ? void 0 : ref8.id) !== null && ref22 !== void 0 ? ref22 : "#"
            }),
            title: t("title")
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {})
    }, displayResponsive ? {
        responsive: true,
        maxWidth: 1120
    } : {}), {
        children: [
            !!personalInformationRequirements.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddressCell, {
                loading: state.loading,
                fullName: state.fullName,
                address: state.address,
                isPhoneNumberVerified: state.isPhoneNumberVerified,
                phoneNumber: state.phoneNumber,
                sendingVerification: state.sendingVerification,
                onSendVerificationSMS: onSendVerificationSMS,
                personalInformationRequirements: personalInformationRequirements,
                responsive: displayResponsive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StoreItemPurchaseProceed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoCellSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        ((ref9 = state.cart) === null || ref9 === void 0 ? void 0 : ref9.paymentType) === "prepaid_point" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrepaidPointPaymentInfoCell, {
                            hasEnoughPoint: hasEnoughPoint,
                            formattedPrepaidPointBalance: (ref23 = (ref10 = state.prepaidPointBalance) === null || ref10 === void 0 ? void 0 : ref10.balance) !== null && ref23 !== void 0 ? ref23 : "0",
                            openDrawer: function() {
                                return setOpenPointPurchaseDrawer(true);
                            }
                        }),
                        ((ref11 = state.cart) === null || ref11 === void 0 ? void 0 : ref11.paymentType) === "cash" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CashPaymentInfoCell, {
                            paymentSource: state.paymentSource,
                            value: purchaseType,
                            setValue: setValue,
                            error: (ref12 = errors.purchaseType) === null || ref12 === void 0 ? void 0 : ref12.message,
                            konbiniFeeValue: (ref13 = state.konbiniFee) === null || ref13 === void 0 ? void 0 : ref13.fee,
                            originFullNameValue: state.fullName,
                            inputFullNameProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("fullName")), {
                                error: errors.fullName
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailCell, {
                loading: state.loading,
                cartItems: state.cartItems,
                cartItemsByCollection: state.cartItemsByCollection,
                errors: errors.receiptDateTimes,
                setValue: setValue,
                watch: watch,
                paymentType: (ref14 = state.cart) === null || ref14 === void 0 ? void 0 : ref14.paymentType,
                purchaseType: purchaseType,
                systemFee: state.systemFee,
                shippingFee: state.shippingFee,
                konbiniFee: state.konbiniFee,
                totalPrice: (ref15 = state.cart) === null || ref15 === void 0 ? void 0 : ref15.totalPrice,
                formattedTotalPrice: (ref16 = state.cart) === null || ref16 === void 0 ? void 0 : ref16.formattedTotalPrice,
                link: true,
                myPickupUsers: state.myPickupUsers,
                exceededItemCount: state.exceededItemCount,
                purchaseLimitPerPickupErrorIds: purchaseLimitPerPickupErrorIds,
                onRemovePurchaseLimitPerPickupErrorIds: function(collectionId) {
                    return setPurchaseLimitPerPickupErrorIds(purchaseLimitPerPickupErrorIds.filter(function(id) {
                        return id !== collectionId;
                    }));
                },
                responsive: displayResponsive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        pb: 7
                    },
                    children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        sx: {
                            width: 244,
                            height: 44,
                            borderRadius: 34,
                            mx: "auto"
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 212
                        },
                        loading: isSubmitting,
                        onClick: handleSubmit(handleProceed),
                        disabled: disableToNext,
                        children: t("toConfirmOrder", "確認画面に進む")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeDrawer, {
                point: (ref24 = (ref17 = state.prepaidPointBalance) === null || ref17 === void 0 ? void 0 : ref17.balance) !== null && ref24 !== void 0 ? ref24 : 0,
                onPurchase: function(plan, paymentMethod) {
                    return onPurchasePoint(plan, paymentMethod, {
                        // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                        successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.StoreItemPurchaseProceed, {
                            cartId: router.query.cartId
                        })),
                        // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                        cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.StoreItemPurchaseProceed, {
                            cartId: router.query.cartId
                        })),
                        // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                        errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.StoreItemPurchaseProceed, {
                            cartId: router.query.cartId
                        }))
                    });
                },
                open: openPointPurchaseDrawer,
                onClose: function() {
                    return setOpenPointPurchaseDrawer(false);
                },
                loading: state.loading,
                chargeLoading: state.pointChargeLoading,
                purchasablePrepaidPoints: state.purchasablePrepaidPoints,
                paymentSource: (_paymentSource = state.paymentSource) !== null && _paymentSource !== void 0 ? _paymentSource : null,
                enablePointCarrierPayment: state.enablePointCarrierPayment,
                pageName: "StoreItemPurchaseProceed",
                responsive: displayResponsive
            })
        ]
    }));
};
var OrderDetailCell = function(_param) {
    var loading = _param.loading, cartItems = _param.cartItems, cartItemsByCollection = _param.cartItemsByCollection, errors = _param.errors, setValue = _param.setValue, watch = _param.watch, pickupTimes = _param.pickupTimes, hiddenPaymentInfo = _param.hiddenPaymentInfo, myPickupUsers = _param.myPickupUsers, exceededItemCount = _param.exceededItemCount, purchaseLimitPerPickupErrorIds = _param.purchaseLimitPerPickupErrorIds, onRemovePurchaseLimitPerPickupErrorIds = _param.onRemovePurchaseLimitPerPickupErrorIds, responsive = _param.responsive, props = (0,_object_without_properties/* default */.Z)(_param, [
        "loading",
        "cartItems",
        "cartItemsByCollection",
        "errors",
        "setValue",
        "watch",
        "pickupTimes",
        "hiddenPaymentInfo",
        "myPickupUsers",
        "exceededItemCount",
        "purchaseLimitPerPickupErrorIds",
        "onRemovePurchaseLimitPerPickupErrorIds",
        "responsive"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailCellSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("orderDetail", "注文内容")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        p: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            children: cartItemsByCollection === null || cartItemsByCollection === void 0 ? void 0 : cartItemsByCollection.map(function(param, index) {
                                var items = param.items, collection = param.collection, eventCollection = param.eventCollection;
                                var ref, ref1, ref2, ref3, ref4;
                                var pickupTime = (ref = pickupTimes === null || pickupTimes === void 0 ? void 0 : pickupTimes.find(function(param) {
                                    var collectionId = param.collectionId;
                                    return collectionId === (eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.collectionId);
                                })) === null || ref === void 0 ? void 0 : ref.pickupTime;
                                var ref5, ref6;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: [
                                                collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: collection === null || collection === void 0 ? void 0 : collection.title
                                                }),
                                                !!(eventCollection === null || eventCollection === void 0 ? void 0 : (ref1 = eventCollection.pickupTime) === null || ref1 === void 0 ? void 0 : ref1.length) && watch && setValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveTimeCell, {
                                                    validMinutes: Number(eventCollection.validMinutes),
                                                    pickupTime: (ref2 = eventCollection.pickupTime) === null || ref2 === void 0 ? void 0 : ref2.filter(function(param) {
                                                        var options = param.options;
                                                        return dayjs_min_default()(options.time).add(eventCollection.validMinutes ? eventCollection.validMinutes - 15 : 0, "minute").valueOf() > dayjs_min_default()().valueOf();
                                                    }),
                                                    eventCollection: eventCollection,
                                                    collectionId: (ref5 = collection === null || collection === void 0 ? void 0 : collection.id) !== null && ref5 !== void 0 ? ref5 : "",
                                                    collectionTitle: (ref6 = collection === null || collection === void 0 ? void 0 : collection.title) !== null && ref6 !== void 0 ? ref6 : "",
                                                    error: errors === null || errors === void 0 ? void 0 : (ref3 = errors[index]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pickupDate) === null || ref4 === void 0 ? void 0 : ref4.message,
                                                    value: watch("receiptDateTimes.".concat(index)),
                                                    onChange: function(value) {
                                                        setValue("receiptDateTimes.".concat(index), value, {
                                                            shouldValidate: true
                                                        });
                                                        var ref;
                                                        onRemovePurchaseLimitPerPickupErrorIds((ref = collection === null || collection === void 0 ? void 0 : collection.id) !== null && ref !== void 0 ? ref : "");
                                                    },
                                                    myPickupUsers: myPickupUsers,
                                                    cartItems: cartItems,
                                                    exceededItemCount: !!exceededItemCount,
                                                    purchaseLimitPerPickupErrorIds: purchaseLimitPerPickupErrorIds,
                                                    responsive: responsive
                                                }),
                                                !!eventCollection && !(watch && setValue) && pickupTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: [
                                                        t("receiptDateTime"),
                                                        " ",
                                                        values_Date/* DateTime.formatStartEndTime */.o.formatStartEndTime(pickupTime, eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes)
                                                    ]
                                                })
                                            ]
                                        }),
                                        items.map(function(cartItem, _index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_OrderItemCell, {
                                                item: cartItem.item,
                                                quantity: cartItem.count
                                            }, _index);
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        !hiddenPaymentInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                                    responsive: responsive
                                }))
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var TotalPaymentCell = function(param) {
    var paymentType = param.paymentType, totalPrice = param.totalPrice, formattedTotalPrice = param.formattedTotalPrice, systemFee = param.systemFee, shippingFee = param.shippingFee, konbiniFee = param.konbiniFee, purchaseType = param.purchaseType, refundedAmount = param.refundedAmount, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1, ref2;
    var totalSystemFee = (0,react.useMemo)(function() {
        return (ref2 = systemFee === null || systemFee === void 0 ? void 0 : systemFee.reduce(function(total, fee) {
            return total + ((ref1 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref1 !== void 0 ? ref1 : 0);
        }, 0)) !== null && ref2 !== void 0 ? ref2 : 0;
    }, [
        systemFee
    ]);
    var formattedTotalPriceFee = (0,react.useMemo)(function() {
        var totalPriceFee = getTotalPriceFee({
            totalPrice: totalPrice,
            totalSystemFee: totalSystemFee,
            purchaseType: purchaseType,
            shippingFee: shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.fee,
            konbiniFee: konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.fee
        });
        return numeral_default()(totalPriceFee).format("0,0");
    }, [
        totalPrice,
        shippingFee,
        konbiniFee,
        totalSystemFee,
        purchaseType
    ]);
    var ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.secondary",
                                children: t("productPrice", "商品代金")
                            }),
                            paymentType && (paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("itemPrice", "\xa5", {
                                    price: formattedTotalPrice
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                size: "small",
                                point: formattedTotalPrice !== null && formattedTotalPrice !== void 0 ? formattedTotalPrice : 0
                            }))
                        ]
                    }),
                    formattedTotalPrice !== formattedTotalPriceFee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: t("fee", "手数料")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Info, {
                                        size: "xSmall",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        onClick: function() {
                                            return setOpen(true);
                                        }
                                    })
                                ]
                            }),
                            systemFee === null || systemFee === void 0 ? void 0 : systemFee.map(function(fee) {
                                return fee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "text.secondary",
                                            children: [
                                                (ref3 = fee === null || fee === void 0 ? void 0 : fee.feeName) !== null && ref3 !== void 0 ? ref3 : t("systemFee", "システム手数料"),
                                                "："
                                            ]
                                        }),
                                        paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t("itemPrice", "\xa5", {
                                                price: numeral_default()(fee.fee).format("0,0")
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                            size: "small",
                                            point: numeral_default()(fee.fee).format("0,0")
                                        })
                                    ]
                                }, fee.id);
                            }),
                            !!shippingFee && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            (ref4 = shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.feeName) !== null && ref4 !== void 0 ? ref4 : t("deliveryFee", "配送料"),
                                            "："
                                        ]
                                    }),
                                    paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("itemPrice", "\xa5", {
                                            price: (ref5 = shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.fee) !== null && ref5 !== void 0 ? ref5 : 0
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                        size: "small",
                                        point: (ref6 = shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.fee) !== null && ref6 !== void 0 ? ref6 : 0
                                    })
                                ]
                            }),
                            !!konbiniFee && purchaseType === "konbini" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            (ref7 = konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.feeName) !== null && ref7 !== void 0 ? ref7 : t("konbiniFee", "事務手数料（コンビニ決済）"),
                                            "："
                                        ]
                                    }),
                                    paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("itemPrice", "\xa5", {
                                            price: (ref8 = konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.fee) !== null && ref8 !== void 0 ? ref8 : 0
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                        size: "small",
                                        point: (ref9 = konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.fee) !== null && ref9 !== void 0 ? ref9 : 0
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: purchaseType === "konbini" || purchaseType === "cash" ? t("paymentAmount", "支払い金額") : t("paymentAmountPoint", "合計ポイント")
                            }),
                            paymentType && (paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                sx: {
                                    textDecoration: refundedAmount ? "line-through" : "unset"
                                },
                                children: t("itemPrice", "\xa5", {
                                    price: formattedTotalPriceFee
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                point: formattedTotalPriceFee !== null && formattedTotalPriceFee !== void 0 ? formattedTotalPriceFee : 0,
                                sx: {
                                    textDecoration: refundedAmount ? "line-through" : "unset"
                                }
                            }))
                        ]
                    }),
                    !!refundedAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: paymentType === "cash" ? t("refundAmount", "返金金額") : t("refundPoints", "返金ポイント")
                            }),
                            paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: t("itemPrice", "\xa5", {
                                    price: refundedAmount
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                point: refundedAmount !== null && refundedAmount !== void 0 ? refundedAmount : 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommissionModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                paymentType: paymentType,
                shippingFee: shippingFee !== null && shippingFee !== void 0 ? shippingFee : null,
                systemFee: systemFee,
                konbiniFee: purchaseType === "konbini" ? konbiniFee : null,
                responsive: responsive
            })
        ]
    });
};
var ReceiveTimeCell = function(param) {
    var pickupTime = param.pickupTime, collectionId = param.collectionId, collectionTitle = param.collectionTitle, value = param.value, error = param.error, onChange = param.onChange, validMinutes = param.validMinutes, myPickupUsers = param.myPickupUsers, cartItems = param.cartItems, eventCollection = param.eventCollection, exceededItemCount = param.exceededItemCount, purchaseLimitPerPickupErrorIds = param.purchaseLimitPerPickupErrorIds, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var _length;
    // NOTE: 購入手続き中に時間外になる可能性があるのでAPIのバリデーション(10分)より5分余分にチェックする
    var pickupNumber = (_length = pickupTime === null || pickupTime === void 0 ? void 0 : pickupTime.filter(function(param) {
        var options = param.options;
        return dayjs_min_default()(options.time).add(validMinutes - 15, "minute").valueOf() > dayjs_min_default()().valueOf();
    }).length) !== null && _length !== void 0 ? _length : 0;
    // 購入期限を過ぎ、選択可能な受取時間がない場合の判定
    var pickable = !!pickupNumber;
    var buttonText = (value === null || value === void 0 ? void 0 : value.pickupTime) ? values_Date/* DateTime.formatStartEndTime */.o.formatStartEndTime("".concat(value.pickupDate, " ").concat(value.pickupTime), validMinutes) : t("pleaseSelectDateTime", "日時を選択してください");
    if (!pickable) {
        buttonText = t("unpickable");
    } else if (exceededItemCount) {
        buttonText = t("purchaseLimitError");
    } else if (purchaseLimitPerPickupErrorIds.includes(collectionId)) {
        buttonText = t("purchaseLimitPerPickupTimeError", {
            number: eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.purchaseLimitPerPickup
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                fullWidth: true,
                variant: "outlined",
                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {}),
                sx: {
                    borderRadius: 2,
                    borderColor: error ? "error.main" : "grey.400",
                    "&.Mui-disabled": {
                        bgcolor: "background.default",
                        borderColor: error ? "error.main" : "grey.400"
                    }
                },
                onClick: function() {
                    return setOpen(true);
                },
                disabled: !pickable || pickupNumber === 1 || exceededItemCount,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    alignItems: "flex-start",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("receiptDateTime")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                calcurateIsJustNow(eventCollection, Number(dayjs_min_default()("".concat(value === null || value === void 0 ? void 0 : value.pickupDate, " ").concat(value === null || value === void 0 ? void 0 : value.pickupTime)).valueOf())) && /*#__PURE__*/ (0,jsx_runtime.jsx)(JustNowChip, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "button",
                                    color: error || exceededItemCount || purchaseLimitPerPickupErrorIds.includes(collectionId !== null && collectionId !== void 0 ? collectionId : "") ? "error.main" : pickable ? "text.primary" : "text.disabled",
                                    textAlign: "left",
                                    children: buttonText
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveTimeModal, (0,src_object_spread/* default */.Z)({
                pickupTime: pickupTime,
                open: open,
                value: value,
                onClose: function() {
                    return setOpen(false);
                },
                collectionId: collectionId,
                collectionTitle: collectionTitle,
                validMinutes: validMinutes,
                onSubmit: onChange,
                myPickupUsers: myPickupUsers,
                cartItems: cartItems,
                eventCollection: eventCollection
            }, responsive ? {
                sx: {
                    "& .MuiPaper-root": {
                        maxWidth: "100%"
                    }
                }
            } : {}))
        ]
    });
};
var template_OrderItemCell = function(param) {
    var item = param.item, quantity = param.quantity, href = param.href;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var formattedPrice = (0,react.useMemo)(function() {
        var ref;
        if (item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.price) {
            var ref1;
            var ref2;
            return (ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.formattedPrice) !== null && ref2 !== void 0 ? ref2 : "0";
        }
        var ref3;
        return (ref3 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref3 !== void 0 ? ref3 : "0";
    }, [
        item === null || item === void 0 ? void 0 : item.formattedPrice,
        item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.formattedPrice,
        item === null || item === void 0 ? void 0 : (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.price
    ]);
    if (!item) return null;
    // クリック時の遷移先が指定されている場合はリンクを設定
    var Wrapper = function(param) {
        var children = param.children;
        return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: href,
            sx: {
                width: "fit-content"
            },
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 3,
        children: [
            ((ref2 = item.thumbnail.front) === null || ref2 === void 0 ? void 0 : ref2.smallUri) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    size: "small",
                    src: item.thumbnail.front.smallUri
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 60,
                height: 96
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 1,
                sx: {
                    minWidth: 0,
                    pt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    gap: 4,
                                    sx: {
                                        pt: !((ref3 = item.sku) === null || ref3 === void 0 ? void 0 : ref3.unitName) ? 2 : 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                            children: item.title
                                        }),
                                        !!href && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                            fontSize: "xSmall",
                                            sx: {
                                                mb: "3px"
                                            }
                                        })
                                    ]
                                }),
                                !!item.sku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: (ref4 = item.sku) === null || ref4 === void 0 ? void 0 : ref4.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                item.paymentType === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("itemPrice", "\xa5", {
                                        price: formattedPrice
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                    size: "small",
                                    point: formattedPrice
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("itemQuantity", "数量", {
                                        quantity: quantity
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var ShippingAddressCell = function(param) {
    var loading = param.loading, fullName = param.fullName, address = param.address, isPhoneNumberVerified = param.isPhoneNumberVerified, phoneNumber = param.phoneNumber, hiddenLink = param.hiddenLink, sendingVerification = param.sendingVerification, onSendVerificationSMS = param.onSendVerificationSMS, personalInformationRequirements = param.personalInformationRequirements, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddressCellSkeleton, {});
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    px: 5,
                    bgcolor: "grey.50",
                    py: 2,
                    alignItems: responsive ? "center" : undefined
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, responsive ? {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }
                } : {}), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            children: t("personalInfo", "お客様情報")
                        }),
                        !hiddenLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "button",
                            href: personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) ? routerPages.DeliveryInfoSetting : routerPages.StoreUserInfo,
                            onClick: function() {
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_registerShippingInfo", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    type: (address === null || address === void 0 ? void 0 : address.fullAddress) ? "update" : "register"
                                });
                            },
                            children: t("change", "変更する")
                        })
                    ]
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("familyName", "氏名")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: fullName ? "text.primary" : "text.hint",
                                    children: fullName !== null && fullName !== void 0 ? fullName : t("unregisteredFullName", "氏名が登録されていません")
                                })
                            ]
                        }),
                        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("address")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: (address === null || address === void 0 ? void 0 : address.fullAddress) ? "text.primary" : "text.hint",
                                    children: (ref = address === null || address === void 0 ? void 0 : address.fullAddress) !== null && ref !== void 0 ? ref : t("unregisteredAddress")
                                })
                            ]
                        }),
                        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("phoneNumber")
                                        }),
                                        !isPhoneNumberVerified ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "error.main",
                                                        mt: -1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "error.main",
                                                    children: t("unverify")
                                                }),
                                                phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    variant: "text",
                                                    color: "primary",
                                                    loading: sendingVerification,
                                                    onClick: onSendVerificationSMS,
                                                    children: t("verify")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "text.hint",
                                                        mt: -1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.hint",
                                                    children: t("verified")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: phoneNumber
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var PrepaidPointPaymentInfoCell = function(param) {
    var hasEnoughPoint = param.hasEnoughPoint, formattedPrepaidPointBalance = param.formattedPrepaidPointBalance, openDrawer = param.openDrawer;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("paymentInfo", "支払い情報")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        !hasEnoughPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "error.main",
                            children: t("noEnoughPointContent", "ポイント残高が不足しています。")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("purchaseByPoint", "ポイントで購入")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: t("pointBalance", "ポイント残高")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                    point: formattedPrepaidPointBalance
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "small",
                                        onClick: openDrawer,
                                        children: t("charge", "チャージ")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var CashPaymentInfoCell = function(param) {
    var paymentSource = param.paymentSource, value = param.value, setValue = param.setValue, originFullNameValue = param.originFullNameValue, error = param.error, inputFullNameProps = param.inputFullNameProps, konbiniFeeValue = param.konbiniFeeValue;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("paymentInfo", "支払い情報")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 3
                        },
                        children: [
                            !config_config/* config.modules.konbiniPayment */.v.modules.konbiniPayment ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentByCashLabel, {
                                paymentSource: paymentSource
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                fullWidth: true,
                                sx: {
                                    minHeight: "unset"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                                    value: value,
                                    onChange: function(_, value) {
                                        setValue("purchaseType", value, {
                                            shouldValidate: true
                                        });
                                        if (value === "konbini") {
                                            setValue("fullName", originFullNameValue, {
                                                shouldValidate: true
                                            });
                                        }
                                    },
                                    sx: {
                                        gap: function(theme) {
                                            return theme.spacing(4);
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                            value: "cash",
                                            checked: value === "cash",
                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentByCashLabel, {
                                                paymentSource: paymentSource
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                            value: "konbini",
                                            checked: value === "konbini",
                                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        gap: 2,
                                                        alignItems: "baseline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "h5",
                                                                children: t("convenienceStore", "コンビニ決済")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "body2",
                                                                children: t("convenienceStoreNote", {
                                                                    paymentFee: konbiniFeeValue
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        children: t("convenienceStoreDesc")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            value === "konbini" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: {
                                            pt: 4
                                        },
                                        color: "text.secondary",
                                        children: t("storeItemNote")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TextInputCell, (0,src_object_spread/* default */.Z)({
                                        type: "text"
                                    }, inputFullNameProps))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "error",
                        variant: "body2",
                        children: error
                    })
                ]
            })
        ]
    });
};
var PaymentByCashLabel = function(param) {
    var paymentSource = param.paymentSource;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    if (paymentSource) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 3,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                    height: 25,
                    src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource.brand),
                    target: "common"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    children: t("last4Digits", {
                        number: paymentSource.last4
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("creditCard")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "button",
                        href: routerPages.PaymentMethodSetting,
                        children: t("register", "登録")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "error.main",
                children: t("registerNote", "支払い情報が登録されていません")
            })
        ]
    });
};
var template_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "subtitle1",
                color: "text.primary"
            }),
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                label: error ? t("error") : ""
            }, textFieldProps), {
                InputProps: {
                    inputProps: {
                        sx: {
                            p: "14px"
                        }
                    }
                },
                FormHelperTextProps: {
                    sx: {
                        bgcolor: "transparent"
                    }
                },
                sx: {
                    mb: 0,
                    backgroundColor: "transparent"
                }
            }),
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});
var ShippingAddressCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    alignItems: "center",
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "circular",
                            sx: {
                                width: 40,
                                height: 40
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var PaymentInfoCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    spacing: 7,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            sx: {
                                mt: 4
                            },
                            variant: "large",
                            width: "40%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            sx: {
                                mt: 4
                            },
                            variant: "large",
                            width: "40%"
                        })
                    ]
                })
            })
        ]
    });
};
var OrderDetailCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2,
                    px: 5,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "50%"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 3,
                            sx: {
                                pb: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    sx: {
                                        width: 60,
                                        height: 96
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "large",
                                            width: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row-reverse",
                                            sx: {
                                                pt: 4
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large",
                                                width: "40%"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "30%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "30%"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var CommissionModal = function(param) {
    var open = param.open, onClose = param.onClose, paymentType = param.paymentType, systemFee = param.systemFee, shippingFee = param.shippingFee, konbiniFee = param.konbiniFee, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref, ref1;
    var totalSystemFee = (0,react.useMemo)(function() {
        return (ref1 = systemFee === null || systemFee === void 0 ? void 0 : systemFee.reduce(function(total, fee) {
            return total + ((ref = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref !== void 0 ? ref : 0);
        }, 0)) !== null && ref1 !== void 0 ? ref1 : 0;
    }, [
        systemFee
    ]);
    var ref2, ref3;
    var formattedTotalPrice = (0,react.useMemo)(function() {
        return numeral_default()(totalSystemFee + ((ref2 = shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.fee) !== null && ref2 !== void 0 ? ref2 : 0) + ((ref3 = konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.fee) !== null && ref3 !== void 0 ? ref3 : 0)).format("0,0");
    }, [
        totalSystemFee,
        shippingFee,
        konbiniFee
    ]);
    var commissions = (0,src_to_consumable_array/* default */.Z)(systemFee.map(function(fee) {
        var ref;
        return {
            title: t("jointFoodFee", {
                name: fee === null || fee === void 0 ? void 0 : (ref = fee.collectionFee) === null || ref === void 0 ? void 0 : ref.title
            }),
            label: fee === null || fee === void 0 ? void 0 : fee.feeName,
            price: fee === null || fee === void 0 ? void 0 : fee.fee,
            hidden: !(fee === null || fee === void 0 ? void 0 : fee.fee),
            note: fee === null || fee === void 0 ? void 0 : fee.feeDescription
        };
    })).concat([
        {
            title: t("otherFee", "その他手数料"),
            label: konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.feeName,
            price: konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.fee,
            hidden: !konbiniFee,
            note: konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.feeDescription
        },
        {
            title: "",
            label: shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.feeName,
            price: shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.fee,
            hidden: !shippingFee,
            note: shippingFee === null || shippingFee === void 0 ? void 0 : shippingFee.feeDescription
        }, 
    ]);
    var _price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        open: open,
        onClose: onClose
    }, responsive ? {
        sx: {
            "& .MuiPaper-root": {
                maxWidth: "100%"
            }
        }
    } : {}), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            align: "center",
                            sx: {
                                width: "100%",
                                ml: "30px"
                            },
                            children: t("feeBreakdown", "手数料の内訳")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "small",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pb: 5
                    },
                    spacing: 2,
                    children: [
                        (0,array/* filterHiddenItem */.s)(commissions).map(function(commission, index) {
                            return commission && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            !!(commission === null || commission === void 0 ? void 0 : commission.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: commission.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "space-between",
                                                sx: {
                                                    pt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: commission.label
                                                    }),
                                                    paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: [
                                                            "￥",
                                                            numeral_default()(commission.price).format("0,0")
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                        size: "small",
                                                        point: (_price = commission.price) !== null && _price !== void 0 ? _price : 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: commission.note
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("total")
                                }),
                                paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "￥",
                                        formattedTotalPrice
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                    size: "small",
                                    point: formattedTotalPrice
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                sx: {
                                    width: 212
                                },
                                onClick: onClose,
                                children: t("ok")
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
function getTotalPriceFee(param) {
    var totalPrice = param.totalPrice, totalSystemFee = param.totalSystemFee, shippingFee = param.shippingFee, purchaseType = param.purchaseType, konbiniFee = param.konbiniFee;
    if (!totalPrice) {
        return 0;
    }
    return (totalPrice !== null && totalPrice !== void 0 ? totalPrice : 0) + (totalSystemFee !== null && totalSystemFee !== void 0 ? totalSystemFee : 0) + (shippingFee !== null && shippingFee !== void 0 ? shippingFee : 0) + (purchaseType === "konbini" ? konbiniFee !== null && konbiniFee !== void 0 ? konbiniFee : 0 : 0);
}

;// CONCATENATED MODULE: ./src/components/organisms/store/PurchaseInfo/index.tsx





var PurchaseInfo = function(param) {
    var loading = param.loading, artist = param.artist;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseInfoSkeleton, {});
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("storeInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref1 = artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                                sx: {
                                    width: 40,
                                    height: 40
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: artist === null || artist === void 0 ? void 0 : artist.displayName
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var PurchaseInfoSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                sx: {
                                    width: 40,
                                    height: 40
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/store/OrderItem/index.tsx






var OrderItem = function(param) {
    var item = param.item, quantity = param.quantity, sku = param.sku, arrow = param.arrow;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseComplete").t;
    var unitName = (sku === null || sku === void 0 ? void 0 : sku.unitName) || (item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.unitName);
    var uri = (sku === null || sku === void 0 ? void 0 : (ref1 = sku.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) || (item === null || item === void 0 ? void 0 : (ref2 = item.sku) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.uri);
    var formattedPrice = (0,react.useMemo)(function() {
        if (sku === null || sku === void 0 ? void 0 : sku.price) {
            var ref;
            return (ref = sku === null || sku === void 0 ? void 0 : sku.formattedPrice) !== null && ref !== void 0 ? ref : "0";
        }
        var ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref1 !== void 0 ? ref1 : "0";
    }, [
        item === null || item === void 0 ? void 0 : item.formattedPrice,
        sku === null || sku === void 0 ? void 0 : sku.formattedPrice,
        sku === null || sku === void 0 ? void 0 : sku.price
    ]);
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 3,
        className: "orderItem",
        children: [
            uri || (item === null || item === void 0 ? void 0 : (ref4 = item.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.front) === null || ref5 === void 0 ? void 0 : ref5.mediumUri) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                size: "small",
                src: (ref7 = uri || ((ref6 = item === null || item === void 0 ? void 0 : item.thumbnail.front) === null || ref6 === void 0 ? void 0 : ref6.mediumUri)) !== null && ref7 !== void 0 ? ref7 : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 60,
                height: 96
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 1,
                sx: {
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: !unitName ? 2 : 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    arrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                        fontSize: "xSmall",
                                        sx: {
                                            mb: "3px"
                                        }
                                    })
                                ]
                            }),
                            !!unitName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: unitName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "baseline",
                        children: [
                            (item === null || item === void 0 ? void 0 : item.paymentType) === "cash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("itemPrice", "\xa5", {
                                    price: formattedPrice
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                size: "small",
                                point: formattedPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("itemQuantity", "数量", {
                                    quantity: quantity
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrderDetail/template/index.tsx





















var StorePurchaseOrderDetailTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    var ref14 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref14.routerNames, routerPages = ref14.routerPages;
    var itemType = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!state.userCartTransactionOrder) {
            return null;
        }
        return (ref = state.userCartTransactionOrder.items) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.type;
    }, [
        state.userCartTransactionOrder
    ]);
    // 個人情報の登録必須項目
    var personalInformationRequirements = (0,react.useMemo)(function() {
        if (!state.userCartTransactionOrder) {
            return [];
        }
        var result = state.userCartTransactionOrder.items.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        state.userCartTransactionOrder
    ]);
    var isReceiveTime = (0,react.useMemo)(function() {
        var ref;
        return (ref = state.cartItemsByCollection) === null || ref === void 0 ? void 0 : ref.some(function(group) {
            var ref, ref1, ref2;
            return (ref2 = (ref = state.userCartTransactionOrder) === null || ref === void 0 ? void 0 : (ref1 = ref.pickupUsers) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
                var collectionId = param.collectionId;
                var ref;
                return collectionId === ((ref = group.collection) === null || ref === void 0 ? void 0 : ref.id);
            })) === null || ref2 === void 0 ? void 0 : ref2.formattedPickupStartEndTime;
        });
    }, [
        state.cartItemsByCollection,
        state.userCartTransactionOrder
    ]);
    var ref15, ref16, ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                href: routerPages.StorePurchaseOrders
            }),
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StorePurchaseOrderDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_OrderDetailCell, {
                userCartTransactionOrder: state.userCartTransactionOrder,
                canceledAt: state.canceledAt,
                cartItemsByCollection: state.cartItemsByCollection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseInfo, {
                loading: state.loading,
                artist: (ref = state.userCartTransactionOrder) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.issuedArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfo, {
                loading: state.loading && !((ref4 = state.userCartTransactionOrder) === null || ref4 === void 0 ? void 0 : ref4.paymentType),
                formattedPrepaidPointBalance: (ref15 = (ref5 = state.prepaidPointBalance) === null || ref5 === void 0 ? void 0 : ref5.formattedPrepaidPointBarance) !== null && ref15 !== void 0 ? ref15 : 0,
                purchaseType: ((ref6 = state.userCartTransactionOrder) === null || ref6 === void 0 ? void 0 : ref6.isKonbini) ? "konbini" : (ref7 = state.userCartTransactionOrder) === null || ref7 === void 0 ? void 0 : ref7.paymentType,
                paymentSource: state.paymentSource
            }),
            !!personalInformationRequirements.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddress, {
                loading: state.loading,
                fullName: state.fullName,
                address: state.address,
                isPhoneNumberVerified: state.isPhoneNumberVerified,
                phoneNumber: state.phoneNumber,
                personalInformationRequirements: personalInformationRequirements
            }),
            state.loading && !((ref8 = state.userCartTransactionOrder) === null || ref8 === void 0 ? void 0 : ref8.paymentType) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseDetailSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseDetailCell, {
                loading: state.loading,
                purchaseType: ((ref9 = state.userCartTransactionOrder) === null || ref9 === void 0 ? void 0 : ref9.isKonbini) ? "konbini" : (ref10 = state.userCartTransactionOrder) === null || ref10 === void 0 ? void 0 : ref10.paymentType,
                systemFee: state.systemFee,
                shippingFee: state.shippingFee,
                konbiniFee: state.konbiniFee,
                paymentType: (ref11 = state.userCartTransactionOrder) === null || ref11 === void 0 ? void 0 : ref11.paymentType,
                totalPrice: (ref16 = (ref12 = state.userCartTransactionOrder) === null || ref12 === void 0 ? void 0 : ref12.originalTotalAmount) !== null && ref16 !== void 0 ? ref16 : 0,
                refundedAmount: state.refundedAmount,
                formattedTotalPrice: (ref17 = (ref13 = state.userCartTransactionOrder) === null || ref13 === void 0 ? void 0 : ref13.formattedOriginalTotalAmount) !== null && ref17 !== void 0 ? ref17 : "0",
                link: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NoteCell, {
                events: state.events,
                loading: state.loading,
                isReceiveTime: isReceiveTime
            })
        ]
    });
};
var template_OrderDetailCell = function(param) {
    var userCartTransactionOrder = param.userCartTransactionOrder, canceledAt = param.canceledAt, cartItemsByCollection = param.cartItemsByCollection;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, generateQueryPath = ref.generateQueryPath, routerPages = ref.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    if (!userCartTransactionOrder) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemDetailSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        sx: {
                            py: 3
                        },
                        children: t("orderDetail", "注文内容")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            textAlign: "center",
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontWeight: 600
                        },
                        href: routerPages.MyOwnedItems,
                        children: t("ownedItems")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        !!canceledAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(CanceledCell, {
                            canceledAt: canceledAt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pb: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("orderDate", {
                                    date: userCartTransactionOrder.formattedCreatedAt
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 5,
                                children: cartItemsByCollection === null || cartItemsByCollection === void 0 ? void 0 : cartItemsByCollection.map(function(group) {
                                    var ref, ref1;
                                    // コレクションに配送アイテムが含まれているか
                                    var hasMerch = group.items.some(function(item) {
                                        return item.item.type === utoniq_core_schema/* ItemType.Merch */.qGq.Merch;
                                    });
                                    // コレクションに紐づいている受け取り情報
                                    var pickupUser = (ref = userCartTransactionOrder.pickupUsers) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                                        var collectionId = param.collectionId;
                                        var ref;
                                        return collectionId === ((ref = group.collection) === null || ref === void 0 ? void 0 : ref.id);
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        className: "collectionGroup",
                                        children: [
                                            group.collection && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                sx: {
                                                    mb: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: (ref1 = group.collection) === null || ref1 === void 0 ? void 0 : ref1.title
                                                    }),
                                                    !!pickupUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        sx: {
                                                            mt: 2
                                                        },
                                                        variant: "subtitle1",
                                                        children: [
                                                            t("pickupTime"),
                                                            pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.formattedPickupStartEndTime
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                children: group.items.map(function(itm) {
                                                    var ref;
                                                    var skuAmount = itm.skus.reduce(function(acc, sku) {
                                                        var ref;
                                                        if (!sku) return acc;
                                                        var ref1;
                                                        return acc + sku.count * ((ref1 = (ref = sku.sku) === null || ref === void 0 ? void 0 : ref.price) !== null && ref1 !== void 0 ? ref1 : 0);
                                                    }, 0);
                                                    //get total sku has price greater than 0
                                                    var skuCount = itm.skus.reduce(function(acc, sku) {
                                                        var ref;
                                                        if (!(sku === null || sku === void 0 ? void 0 : (ref = sku.sku) === null || ref === void 0 ? void 0 : ref.price)) return acc;
                                                        var ref1;
                                                        return acc + ((ref1 = sku === null || sku === void 0 ? void 0 : sku.count) !== null && ref1 !== void 0 ? ref1 : 0);
                                                    }, 0);
                                                    var _count;
                                                    var item = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itm.item), {
                                                        // 表示金額を、現在のアイテムの金額ではなく、決済時の金額で表示する
                                                        formattedPrice: (0,state/* formatNumber */.uf)((itm.amount - skuAmount) / (((_count = itm.count) !== null && _count !== void 0 ? _count : 1) - skuCount || 1))
                                                    });
                                                    if (!itm.skus.length) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: generatePath(routerPages.OwnedItemDetail, {
                                                                itemId: itm.itemId
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem, {
                                                                item: item,
                                                                quantity: itm.count,
                                                                arrow: true
                                                            }, itm.itemId)
                                                        });
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: (ref = itm.skus) === null || ref === void 0 ? void 0 : ref.map(function(itemSku) {
                                                            return itemSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                href: generateQueryPath(routerPages.OwnedItemDetail, {
                                                                    itemId: itm.itemId
                                                                }, {
                                                                    skuId: encodeSkuId(itemSku.skuId)
                                                                }),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem, {
                                                                    item: item,
                                                                    quantity: itemSku.count,
                                                                    sku: itemSku.sku,
                                                                    arrow: true
                                                                }, itemSku.skuId)
                                                            });
                                                        })
                                                    }, itm.itemId);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    mt: 3
                                                },
                                                children: [
                                                    hasMerch && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                        size: "large",
                                                        variant: "outlined",
                                                        href: routerPages.DeliveryManagement,
                                                        children: t("confirmDelivery", "配送状況を確認する")
                                                    }),
                                                    !!pickupUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                        size: "large",
                                                        variant: "outlined",
                                                        href: generatePath(routerPages.MyOwnedTicketDetail, {
                                                            eventId: pickupUser.eventCollection.eventId,
                                                            collectionId: pickupUser.collectionId,
                                                            pickupUserId: pickupUser.id
                                                        }),
                                                        onClick: function() {
                                                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventPickupDetail", {
                                                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                                                type: "cartTransactionOrder"
                                                            });
                                                        },
                                                        children: t("confirmPickup", "受け取り情報を確認する")
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var PurchaseDetailCell = function(_param) {
    var loading = _param.loading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "loading"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseDetailSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("purchaseDetail")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentCell, (0,src_object_spread/* default */.Z)({}, props))
                })
            })
        ]
    });
};
var PurchaseDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    width: "60%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    width: "40%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small"
                                    })
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
};
var CanceledCell = function(param) {
    var canceledAt = param.canceledAt;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        color: "error",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "white",
                            children: t("refundAvailable", "返金対応")
                        }),
                        size: "small",
                        sx: {
                            height: 18
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("refundAvailableFor", {
                            date: values_Date/* DateTime.formatDate */.o.formatDate(canceledAt)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 2,
                    mb: 4,
                    p: 2,
                    borderColor: "error.main",
                    borderWidth: 1,
                    borderStyle: "solid"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: [
                        t("refundNote"),
                        t("refundNoteLinkPrefix"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "primary",
                            onClick: function() {
                                (0,intercom/* updateIntercom */.dC)(user);
                                (0,intercom/* openIntercom */.B6)();
                            },
                            children: t("refundNoteLink")
                        }),
                        t("refundNoteLinkSuffix")
                    ]
                })
            })
        ]
    });
};
var template_NoteCell = function(param) {
    var events = param.events, isReceiveTime = param.isReceiveTime, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrderDetail").t;
    if (loading || !events.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("notes", "注意事項")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: events.map(function(event) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("notesTitle", {
                                        title: event === null || event === void 0 ? void 0 : event.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: event === null || event === void 0 ? void 0 : event.note
                                })
                            ]
                        });
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrderDetail/template/index.tsx














var ConsoleOrderDetailTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrderDetail").t;
    var ref11 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref11.generatePath, routerPages = ref11.routerPages, routerNames = ref11.routerNames;
    // 個人情報の登録必須項目
    var personalInformationRequirements = (0,react.useMemo)(function() {
        if (!state.transactionOrder) {
            return [];
        }
        var result = state.transactionOrder.items.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        state.transactionOrder
    ]);
    var user = (ref = state.transactionOrder) === null || ref === void 0 ? void 0 : (ref1 = ref.itemOrders) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.user;
    var _userId, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleOrderDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsoleUserOrders, {
                        userId: (_userId = state.userId) !== null && _userId !== void 0 ? _userId : "#"
                    }),
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOrderDetail_template_OrderDetailCell, {
                        loading: state.loading,
                        orderDate: (ref3 = state.transactionOrder) === null || ref3 === void 0 ? void 0 : ref3.formattedCreatedAt,
                        transactionOrder: state.transactionOrder,
                        cartItemsByCollection: state.cartItemsByCollection
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfo, {
                        loading: state.loading,
                        purchaseType: state.purchaseType,
                        paymentSource: user === null || user === void 0 ? void 0 : user.credit,
                        formattedPrepaidPointBalance: state.formattedPrepaidPointBalance
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddress, {
                        loading: state.loading,
                        fullName: (ref12 = user === null || user === void 0 ? void 0 : user.fullName) !== null && ref12 !== void 0 ? ref12 : "",
                        address: user === null || user === void 0 ? void 0 : user.address,
                        isPhoneNumberVerified: user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified,
                        isDeletedUser: (user === null || user === void 0 ? void 0 : user.status) === "archived" || (user === null || user === void 0 ? void 0 : user.status) === "left",
                        phoneNumber: (ref13 = user === null || user === void 0 ? void 0 : user.formattedPhoneNumber) !== null && ref13 !== void 0 ? ref13 : "",
                        rightLink: generatePath(routerPages.ConsoleUserDetail, {
                            userId: (ref14 = user === null || user === void 0 ? void 0 : user.id) !== null && ref14 !== void 0 ? ref14 : "#"
                        }),
                        hideVerified: true,
                        personalInformationRequirements: personalInformationRequirements
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseDetailCell, {
                        loading: state.loading,
                        systemFee: state.systemFee,
                        shippingFee: state.shippingFee,
                        konbiniFee: state.konbiniFee,
                        paymentType: (ref4 = state.transactionOrder) === null || ref4 === void 0 ? void 0 : ref4.paymentType,
                        totalPrice: (ref15 = (ref5 = state.transactionOrder) === null || ref5 === void 0 ? void 0 : ref5.originalTotalAmount) !== null && ref15 !== void 0 ? ref15 : 0,
                        formattedTotalPrice: (ref6 = state.transactionOrder) === null || ref6 === void 0 ? void 0 : ref6.formattedOriginalTotalAmount,
                        purchaseType: state.purchaseType
                    }),
                    state.artistPaymentType === utoniq_core_schema/* ArtistPaymentType.Connect */.bBx.Connect && /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleProfitCell, {
                        loading: state.loading,
                        formattedShippingFee: (ref16 = (ref7 = state.shippingFee) === null || ref7 === void 0 ? void 0 : ref7.formattedFee) !== null && ref16 !== void 0 ? ref16 : "0",
                        formattedSaleProfit: (ref17 = (ref8 = state.transactionOrder) === null || ref8 === void 0 ? void 0 : ref8.formattedSaleProfit) !== null && ref17 !== void 0 ? ref17 : "0",
                        formattedStoreFee: (ref18 = (ref9 = state.transactionOrder) === null || ref9 === void 0 ? void 0 : ref9.formattedStoreFee) !== null && ref18 !== void 0 ? ref18 : "0",
                        formattedTotalAmountWithoutFee: (ref19 = (ref10 = state.transactionOrder) === null || ref10 === void 0 ? void 0 : ref10.formattedTotalAmountWithoutFee) !== null && ref19 !== void 0 ? ref19 : "0"
                    })
                ]
            })
        ]
    });
};
var ConsoleOrderDetail_template_OrderDetailCell = function(param) {
    var loading = param.loading, orderDate = param.orderDate, transactionOrder = param.transactionOrder, cartItemsByCollection = param.cartItemsByCollection;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrderDetail").t;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemDetailSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("orderDetail", "注文内容")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                pb: 3
                            },
                            children: t("orderDate", {
                                date: orderDate
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            children: cartItemsByCollection === null || cartItemsByCollection === void 0 ? void 0 : cartItemsByCollection.map(function(param, index) {
                                var items = param.items, collection = param.collection;
                                var ref;
                                // コレクションに紐づいている受け取り情報
                                var pickupUser = transactionOrder === null || transactionOrder === void 0 ? void 0 : (ref = transactionOrder.pickupUsers) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                                    var collectionId = param.collectionId;
                                    return collectionId === (collection === null || collection === void 0 ? void 0 : collection.id);
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            spacing: 2,
                                            children: [
                                                collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: collection === null || collection === void 0 ? void 0 : collection.title
                                                }),
                                                pickupUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    children: [
                                                        t("pickupTime"),
                                                        pickupUser.formattedPickupStartEndTime
                                                    ]
                                                })
                                            ]
                                        }),
                                        items.map(function(cartItem, _index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_OrderItemCell, {
                                                item: cartItem.item,
                                                quantity: cartItem.count
                                            }, _index);
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var SaleProfitCell = function(param) {
    var loading = param.loading, formattedShippingFee = param.formattedShippingFee, formattedStoreFee = param.formattedStoreFee, formattedSaleProfit = param.formattedSaleProfit, formattedTotalAmountWithoutFee = param.formattedTotalAmountWithoutFee;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrderDetail").t;
    var data = [
        {
            label: t("commodityPrice", "商品代金："),
            value: formattedTotalAmountWithoutFee
        },
        {
            label: t("salePrice", "販売手数料："),
            value: "-".concat(formattedStoreFee)
        },
        {
            label: t("deliveryPrice", "配送料："),
            value: formattedShippingFee
        }, 
    ];
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseDetailSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("saleProfit", "販売利益")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: [
                        data.map(function(d) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: d.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("itemPrice", "\xa5", {
                                            price: d.value
                                        })
                                    })
                                ]
                            });
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("saleProfit", "販売利益")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("itemPrice", "\xa5", {
                                        price: formattedSaleProfit
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/core/cart/index.ts


/**
 * アイテム・SKUの配列をコレクション単位でまとめる
 *
 * @returns {
 *  collection: Collection,
 *  items: Item[]
 *  eventCollection: EventCollectionBoxFragment
 * }
 */ var groupItemsByCollection = function(cartItems) {
    if (!cartItems) return null;
    var collections = cartItems.map(function(cartItem) {
        return cartItem.item.collection;
    });
    var uniqueCollections = collections.filter(function(collection, index) {
        return collections.findIndex(function(element) {
            return (element === null || element === void 0 ? void 0 : element.id) === (collection === null || collection === void 0 ? void 0 : collection.id);
        }) === index;
    });
    return uniqueCollections.map(function(collection) {
        var ref, ref1, ref2, ref3;
        return {
            collection: collection,
            items: cartItems.filter(function(cartItem) {
                var ref;
                return ((ref = cartItem.item.collection) === null || ref === void 0 ? void 0 : ref.id) === (collection === null || collection === void 0 ? void 0 : collection.id);
            }),
            eventCollection: (ref3 = collection === null || collection === void 0 ? void 0 : (ref = collection.event) === null || ref === void 0 ? void 0 : (ref1 = ref.eventCollections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.find(function(param) {
                var node = param.node;
                return node.collectionId === collection.id;
            })) === null || ref3 === void 0 ? void 0 : ref3.node
        };
    })// collection: nullのアイテムを先頭に配置
    .sort(function(a, b) {
        if (a.collection === null) return -1;
        if (b.collection === null) return 1;
        return 0;
    });
};
/**
 * add collection to collection fee
 * @param collectionFees
 * @param collections
 */ var addCollectionToCollectionFee = function(collectionFees, collections) {
    if (!(collectionFees === null || collectionFees === void 0 ? void 0 : collectionFees.length)) return [];
    return collectionFees.map(function(fee) {
        if (!fee) return fee;
        var ref;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fee), {
            collectionFee: (ref = collections === null || collections === void 0 ? void 0 : collections.find(function(collection) {
                var ref, ref1;
                return (collection === null || collection === void 0 ? void 0 : collection.id) === ((ref1 = (ref = fee.id) === null || ref === void 0 ? void 0 : ref.split(":")) === null || ref1 === void 0 ? void 0 : ref1[0]);
            })) !== null && ref !== void 0 ? ref : null
        });
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrderDetail/viewModel.ts

function ConsoleOrderDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleOrderDetail($id: ID!, $userId: String!, $skuId: String) {\n    artist {\n      id\n      paymentType\n    }\n    artistUserCartTransactionOrder(id: $id, userId: $userId) {\n      itemOrders {\n        user {\n          id\n          fullName\n          phoneNumber\n          displayName\n          formattedPhoneNumber @client\n          isPhoneNumberVerified\n          status\n          credit {\n            ...PaymentDetail\n          }\n          ...UserAddress\n        }\n      }\n      ...UserCartTransactionOrderDetail\n    }\n    prepaidPointBalance {\n      lastUpdatedAt\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOrderDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 *
 */ var ConsoleOrderDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref10 = (0,useQuery/* useQuery */.aM)(ConsoleOrderDetail_viewModel_QUERY, {
        variables: {
            id: router.query.orderId,
            userId: router.query.userId
        }
    }), data = ref10.data, loading = ref10.loading;
    var ref11;
    var cartItems = convertUserCartItemsToSku((ref11 = data === null || data === void 0 ? void 0 : (ref = data.artistUserCartTransactionOrder) === null || ref === void 0 ? void 0 : ref.items) !== null && ref11 !== void 0 ? ref11 : null);
    var ref12, ref13, ref14, ref15, ref16, ref17;
    return {
        state: {
            loading: loading,
            userId: router.query.userId,
            transactionOrder: (ref12 = data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrder) !== null && ref12 !== void 0 ? ref12 : null,
            artistPaymentType: (ref13 = data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : ref1.paymentType) !== null && ref13 !== void 0 ? ref13 : null,
            cartItemsByCollection: groupItemsByCollection(cartItems),
            artistId: (ref14 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref14 !== void 0 ? ref14 : "",
            purchaseType: (data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrder.isKonbini) ? "konbini" : data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrder.paymentType,
            systemFee: addCollectionToCollectionFee(data === null || data === void 0 ? void 0 : (ref2 = data.artistUserCartTransactionOrder) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.checkoutFees) === null || ref3 === void 0 ? void 0 : ref3.collections, data === null || data === void 0 ? void 0 : (ref4 = data.artistUserCartTransactionOrder) === null || ref4 === void 0 ? void 0 : ref4.items.map(function(param) {
                var item = param.item;
                return item.collection;
            })),
            formattedPrepaidPointBalance: (ref15 = data === null || data === void 0 ? void 0 : (ref5 = data.prepaidPointBalance) === null || ref5 === void 0 ? void 0 : ref5.formattedPrepaidPointBarance) !== null && ref15 !== void 0 ? ref15 : 0,
            shippingFee: (ref16 = data === null || data === void 0 ? void 0 : (ref6 = data.artistUserCartTransactionOrder) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.checkoutFees) === null || ref7 === void 0 ? void 0 : ref7.shipping) !== null && ref16 !== void 0 ? ref16 : null,
            konbiniFee: (ref17 = data === null || data === void 0 ? void 0 : (ref8 = data.artistUserCartTransactionOrder) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.checkoutFees) === null || ref9 === void 0 ? void 0 : ref9.konbini) !== null && ref17 !== void 0 ? ref17 : null
        },
        actions: {}
    };
});
var ConsoleOrderDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleOrderDetail_viewModel_templateObject(), utoniq_core_schema/* UserCartTransactionOrderDetailFragmentDoc */.DMu);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrderDetail/index.tsx




/**
 * ConsoleOrderDetail Page
 * Implemented as a practical sample.
 */ var ConsoleOrderDetail = function() {
    var ref = ConsoleOrderDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOrderDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/dayjs/locale/ja.js
var ja = __webpack_require__(33214);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Snackbar/Snackbar.js + 1 modules
var Snackbar = __webpack_require__(89265);
;// CONCATENATED MODULE: ./src/components/organisms/store/StorePurchaseHistorySkeleton/index.tsx





var StorePurchaseHistorySkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                width: "30%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "h3"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                width: "calc(70% - 8px)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "h3"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "30%",
                        sx: {
                            pt: 3
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h3",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h3",
                                width: "30%"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js
var LocalizationProvider = __webpack_require__(41633);
// EXTERNAL MODULE: ../../node_modules/@mui/x-date-pickers/AdapterDayjs/AdapterDayjs.js
var AdapterDayjs = __webpack_require__(90740);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrders/template/FilterDateInputCell.tsx









var FilterDateInputCell = function(param) {
    var startDate = param.startDate, endDate = param.endDate, onClose = param.onClose, onApply = param.onApply;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    var ref = (0,react.useState)(""), dateError = ref[0], setDateError = ref[1];
    var ref1 = (0,react.useState)(startDate ? dayjs_min_default()(startDate) : undefined), startDateValue = ref1[0], setStartDateValue = ref1[1];
    var ref2 = (0,react.useState)(endDate ? dayjs_min_default()(endDate) : undefined), endDateValue = ref2[0], setEndDateValue = ref2[1];
    var validateDates = (0,react.useCallback)(function(start, end) {
        if (start && end && dayjs_min_default()(start).isAfter(dayjs_min_default()(end))) {
            setDateError(t("invalidDateRange", "終了日は開始日より後の日付を指定してください。"));
            return false;
        }
        if (!start && end || start && !end) {
            setDateError(t("invalidDateInput", "日付を指定する場合は開始日と終了日が必須です。"));
            return false;
        }
        setDateError("");
        return true;
    }, [
        t
    ]);
    (0,react.useEffect)(function() {
        validateDates(startDateValue, endDateValue);
    }, [
        startDateValue,
        endDateValue,
        validateDates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
            dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
            adapterLocale: "ja",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    p: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    sx: {
                                        width: "100%",
                                        textAlign: "center"
                                    },
                                    children: t("dateFilter", "日付")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                    onClick: onClose,
                                    sx: {
                                        position: "absolute",
                                        right: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Close, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            align: "center",
                            children: t("dateFilterDescription", "絞り込む日付の範囲を指定してください。")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.primary",
                                            children: t("startDate", "開始日")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DatePickerField, {
                                            onChange: function(date) {
                                                if (dayjs_min_default()(date).isValid()) {
                                                    setStartDateValue(dayjs_min_default()(date, "YYYY/MM/DD", "ja"));
                                                } else {
                                                    setStartDateValue(undefined);
                                                }
                                            },
                                            value: startDateValue,
                                            textFieldProps: {
                                                inputProps: {
                                                    value: (startDateValue === null || startDateValue === void 0 ? void 0 : startDateValue.isValid()) ? dayjs_min_default()(startDateValue).format("YYYY/MM/DD") : ""
                                                }
                                            },
                                            placeholder: t("startDatePlaceholder", "1990/11/11")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.primary",
                                            children: t("endDate", "終了日")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DatePickerField, {
                                            onChange: function(date) {
                                                if (dayjs_min_default()(date).isValid()) {
                                                    setEndDateValue(dayjs_min_default()(date, "YYYY/MM/DD", "ja"));
                                                } else {
                                                    setEndDateValue(undefined);
                                                }
                                            },
                                            value: endDateValue,
                                            textFieldProps: {
                                                inputProps: {
                                                    value: (endDateValue === null || endDateValue === void 0 ? void 0 : endDateValue.isValid()) ? dayjs_min_default()(endDateValue).format("YYYY/MM/DD") : ""
                                                }
                                            },
                                            placeholder: t("endDatePlaceholder", "1990/11/11")
                                        })
                                    ]
                                }),
                                dateError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: "error",
                                    variant: "body2",
                                    children: dateError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "contained",
                            onClick: function() {
                                if (!(startDateValue === null || startDateValue === void 0 ? void 0 : startDateValue.isValid()) && !(endDateValue === null || endDateValue === void 0 ? void 0 : endDateValue.isValid())) {
                                    onApply(undefined, undefined);
                                } else {
                                    onApply(startDateValue === null || startDateValue === void 0 ? void 0 : startDateValue.toDate(), endDateValue === null || endDateValue === void 0 ? void 0 : endDateValue.toDate());
                                }
                            },
                            sx: {
                                mt: 2
                            },
                            disabled: Boolean(dateError),
                            children: t("filter", "適用")
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrders/template/index.tsx
















var DownloadCsvButtonCell = function(param) {
    var loading = param.loading, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "small",
            loadingPosition: "start",
            variant: "outlined",
            sx: {
                ".MuiButton-loadingIndicator": {
                    left: "auto",
                    color: "primary.main"
                },
                borderRadius: 1,
                height: 28,
                borderColor: "primary.main",
                color: "primary.main",
                "&.MuiButton-loading": {
                    borderColor: "grey.100"
                },
                ".MuiButton-startIcon": {
                    display: "none"
                }
            },
            onClick: onClick,
            loading: loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "inherit",
                pt: "2px",
                children: loading ? t("downloadNow", "ダウンロード中") : t("exportCsv", "CSVエクスポート")
            })
        })
    });
};
var ConsoleOrdersTemplate = function(param) {
    var state = param.state, onRefetch = param.onRefetch, onFetchMore = param.onFetchMore, onExportCsv = param.onExportCsv, onCloseSnackbar = param.onCloseSnackbar;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2 = (0,react.useState)(false), dateFilterOpen = ref2[0], setDateFilterOpen = ref2[1];
    var handleDateFilterClick = function() {
        setDateFilterOpen(true);
    };
    var handleDateFilterClose = function() {
        setDateFilterOpen(false);
    };
    var handleDateFilterApply = function(startDate, endDate) {
        onRefetch(state.sort, startDate, endDate);
        setDateFilterOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    state.loading && !((ref = state.orderTransactions) === null || ref === void 0 ? void 0 : ref.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "large",
                            width: "70%"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                mt: 2,
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h3",
                                        sx: {
                                            py: 3
                                        },
                                        children: t("orderManagement")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadCsvButtonCell, {
                                        loading: state.isExporting,
                                        onClick: onExportCsv
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                sx: {
                                    py: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            sx: {
                                                borderRadius: 1,
                                                height: 28,
                                                borderColor: state.startDate && state.endDate ? "primary.main" : "grey.400",
                                                color: state.startDate && state.endDate ? "white" : "grey.400",
                                                bgcolor: state.startDate && state.endDate ? "primary.main" : "white",
                                                "&.MuiButton-loading": {
                                                    borderColor: "grey.100"
                                                },
                                                ".MuiButton-startIcon": {
                                                    display: "none"
                                                }
                                            },
                                            onClick: handleDateFilterClick,
                                            endIcon: dateFilterOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.UpArrow, {
                                                fontSize: "xSmall",
                                                sx: {
                                                    color: "inherit"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                                fontSize: "xSmall",
                                                sx: {
                                                    color: "inherit"
                                                }
                                            }),
                                            children: t("dateFilter", "日付")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FillterCell, {
                                        loading: state.loading,
                                        orderTransactions: state.orderTransactions,
                                        onRefetch: onRefetch,
                                        sort: state.sort,
                                        startDate: state.startDate,
                                        endDate: state.endDate
                                    })
                                ]
                            }),
                            state.startDate && state.endDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    py: 1,
                                    px: 3,
                                    bgcolor: "primary.light",
                                    borderRadius: 1,
                                    mb: "8px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    sx: {
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        lineHeight: "20px",
                                        textAlign: "center"
                                    },
                                    children: [
                                        t("startDate", "開始日"),
                                        "：",
                                        dayjs_min_default()(state.startDate).format("YYYY/MM/DD"),
                                        " ",
                                        " ～ ",
                                        t("endDate", "終了日"),
                                        "：",
                                        dayjs_min_default()(state.endDate).format("YYYY/MM/DD")
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: (ref1 = state.orderTransactions) === null || ref1 === void 0 ? void 0 : ref1.edges.map(function(param) {
                            var node = param.node;
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(template_OrderItem, {
                                order: node,
                                artistPaymentType: (ref = state.artist) === null || ref === void 0 ? void 0 : ref.paymentType
                            }, node.id);
                        }),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pt: 2
                            },
                            children: Array.from(Array(2).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseHistorySkeleton, {}, key);
                            })
                        }),
                        componentProps: {
                            spacing: 5
                        },
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        emptyMessage: t("ordersEmpty")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                        anchor: "bottom",
                        open: dateFilterOpen,
                        onClose: handleDateFilterClose,
                        PaperProps: {
                            sx: {
                                borderTopLeftRadius: 16,
                                borderTopRightRadius: 16,
                                maxHeight: "80vh"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDateInputCell, {
                            startDate: state.startDate,
                            endDate: state.endDate,
                            onClose: handleDateFilterClose,
                            onApply: function(startDate, endDate) {
                                return handleDateFilterApply(startDate, endDate);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                        open: state.snackbar.open,
                        autoHideDuration: 6000,
                        onClose: onCloseSnackbar,
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                            onClose: onCloseSnackbar,
                            severity: state.snackbar.severity,
                            sx: {
                                width: "100%"
                            },
                            children: state.snackbar.message
                        })
                    })
                ]
            })
        ]
    });
};
var FillterCell = function(param) {
    var loading = param.loading, orderTransactions = param.orderTransactions, onRefetch = param.onRefetch, sort = param.sort, startDate = param.startDate, endDate = param.endDate;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(sort === utoniq_core_schema/* OrderBy.Desc */.d$J.Desc ? 0 : 1), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var options = [
        {
            label: t("newestOrderDate", "注文日の新しい順"),
            value: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc
        },
        {
            label: t("oldestOrderDate", "注文日の古い順"),
            value: utoniq_core_schema/* OrderBy.Asc */.d$J.Asc
        }, 
    ];
    var handleFilterClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = (0,react.useCallback)(function(event, newIndex) {
        setSelectedIndex(newIndex);
        setAnchorEl(null);
        onRefetch(options[newIndex].value, startDate, endDate);
    }, [
        onRefetch,
        options,
        startDate,
        endDate
    ]);
    (0,react.useEffect)(function() {
        var UrlParams = "?sort=".concat(options[selectedIndex].value);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedIndex
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    if (loading && !(orderTransactions === null || orderTransactions === void 0 ? void 0 : orderTransactions.edges.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            alignItems: "flex-end",
            sx: {
                pb: 3
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "30%"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            sx: {
                pb: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        width: "fit-content",
                        mr: -2
                    },
                    onClick: handleFilterClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                pr: 1
                            },
                            children: (ref = options[selectedIndex]) === null || ref === void 0 ? void 0 : ref.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall",
                            sx: {
                                color: "grey.600"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                    anchorEl: anchorEl,
                    open: Boolean(anchorEl),
                    onClose: handleClose,
                    children: options.map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                            sx: {
                                bgcolor: "grey.50",
                                minWidth: 200
                            },
                            selected: index === selectedIndex,
                            onClick: function(event) {
                                return handleMenuItemClick(event, index);
                            },
                            children: option.label
                        }, index);
                    })
                })
            ]
        })
    });
};
var template_OrderItem = function(param) {
    var order = param.order, artistPaymentType = param.artistPaymentType;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref9.generatePath, routerPages = ref9.routerPages;
    var pickupUser = (ref = order.pickupUsers) === null || ref === void 0 ? void 0 : ref[0];
    var ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ConsoleOrderDetail, {
                    orderId: order.id,
                    userId: (ref10 = (ref1 = order.itemOrders) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref10 !== void 0 ? ref10 : "#"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    children: [
                                        !!((ref4 = order.cancels) === null || ref4 === void 0 ? void 0 : ref4.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            color: "error",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "white",
                                                children: t("refundAvailable", "返金対応")
                                            }),
                                            size: "small",
                                            sx: {
                                                height: 18
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: (ref5 = order.itemOrders) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.user) === null || ref7 === void 0 ? void 0 : ref7.fullName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("orderDate", {
                                        date: order.formattedCreatedAt
                                    })
                                })
                            ]
                        }),
                        !!(pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.formattedPickupStartEndTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("pickupTime", "受け取り時間")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: pickupUser.formattedPickupStartEndTime
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("orderDetails")
                                }),
                                (ref8 = order.items) === null || ref8 === void 0 ? void 0 : ref8.map(function(item, index) {
                                    if (item.skus.length) {
                                        return item.skus.map(function(sku) {
                                            return sku && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 2,
                                                direction: "row",
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        flex: 1,
                                                        sx: {
                                                            minWidth: 0
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                            children: [
                                                                item.item.title,
                                                                " (",
                                                                sku.sku.unitName,
                                                                ")"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: t("quantity", {
                                                            quantity: sku.count
                                                        })
                                                    })
                                                ]
                                            }, sku.skuId);
                                        });
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 2,
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                sx: {
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: item.item.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("quantity", {
                                                    quantity: item.count
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: order.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? t("payment") : t("totalPoint")
                                }),
                                order.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: [
                                        "￥",
                                        order.formattedTotalAmount
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: order.formattedTotalAmount
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!order.formattedSaleProfit && order.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && artistPaymentType === utoniq_core_schema/* ArtistPaymentType.Connect */.bBx.Connect && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("saleProfit", "販売利益")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: [
                                        "￥",
                                        order.formattedSaleProfit
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrders/viewModel.ts






function ConsoleOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleOrders(\n    $orderBy: OrderBy\n    $pageInput: PageInput\n    $userId: String\n    $startDate: Date\n    $endDate: Date\n  ) {\n    artistUserCartTransactionOrders(\n      orderBy: $orderBy\n      pageInput: $pageInput\n      userId: $userId\n      startDate: $startDate\n      endDate: $endDate\n    ) {\n      ...UserCartTransactionOrderConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleOrders_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewConsoleOrders(\n    $orderBy: OrderBy\n    $pageInput: PageInput\n    $userId: String\n    $startDate: Date\n    $endDate: Date\n  ) {\n    artistUserCartTransactionOrders(\n      orderBy: $orderBy\n      pageInput: $pageInput\n      userId: $userId\n      startDate: $startDate\n      endDate: $endDate\n    ) {\n      ...UserCartTransactionOrderConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleOrders_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleOrders_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ExportCsv($startDate: Date, $endDate: Date) {\n    artistExportCartTransactionOrdersCsv(\n      startDate: $startDate\n      endDate: $endDate\n    ) {\n      csvUrl\n    }\n  }\n"
    ]);
    ConsoleOrders_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










/**
 *
 */ var ConsoleOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleOrders").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref2.showError, showMessage = ref2.showMessage;
    var downloadCsv = useDownloadFile().downloadCsv;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort") === utoniq_core_schema/* OrderBy.Asc */.d$J.Asc ? utoniq_core_schema/* OrderBy.Asc */.d$J.Asc : utoniq_core_schema/* OrderBy.Desc */.d$J.Desc;
    var ref3 = (0,react.useState)(sort), orderBy = ref3[0], setOrderBy = ref3[1];
    var ref4 = (0,react.useState)(false), isExporting = ref4[0], setIsExporting = ref4[1];
    var ref5 = (0,react.useState)({
        open: false,
        message: "",
        severity: "success"
    }), snackbar = ref5[0], setSnackbar = ref5[1];
    // ローカルストレージから初期値を取得
    var getStoredDate = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("consoleOrdersDate")
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function getStoredDate() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref6 = (0,react.useState)(undefined), startDate = ref6[0], setStartDate = ref6[1];
    var ref7 = (0,react.useState)(undefined), endDate = ref7[0], setEndDate = ref7[1];
    // 初期値の読み込み
    (0,react.useEffect)(function() {
        var loadDates = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var storedDate, storedStartDate, storedEndDate;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getStoredDate()
                            ];
                        case 1:
                            storedDate = _state.sent();
                            storedStartDate = (storedDate === null || storedDate === void 0 ? void 0 : storedDate.startDate) ? dayjs_min_default()(storedDate.startDate).toDate() : undefined;
                            storedEndDate = (storedDate === null || storedDate === void 0 ? void 0 : storedDate.endDate) ? dayjs_min_default()(storedDate.endDate).toDate() : undefined;
                            setStartDate(storedStartDate);
                            setEndDate(storedEndDate);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadDates() {
                return _ref.apply(this, arguments);
            };
        }();
        loadDates();
    }, []);
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_ORDERS,
        variables: {
            orderBy: orderBy,
            startDate: startDate,
            endDate: endDate
        },
        fields: [
            {
                fragmentName: "UserCartTransactionOrderBox",
                fieldName: "artistUserCartTransactionOrders",
                fragment: utoniq_core_schema/* UserCartTransactionOrderBoxFragmentDoc */.yTi
            }, 
        ]
    }).isFirstLoadRef;
    var ref8 = (0,react.useState)(null), orderTransactions = ref8[0], setOrderTransactions = ref8[1];
    var ref9 = (0,useQuery/* useQuery */.aM)(ConsoleOrders_viewModel_QUERY, {
        variables: {
            orderBy: orderBy,
            startDate: startDate,
            endDate: endDate
        },
        fetchPolicy: "network-only",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            var ref;
            setOrderTransactions((ref = data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrders) !== null && ref !== void 0 ? ref : null);
            isFirstLoadRef.current = false;
        }
    }), data = ref9.data, loading = ref9.loading, fetchMore = ref9.fetchMore, refetch = ref9.refetch;
    var isNextFetch = !!data;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(EXPORT_CSV_QUERY, {
        onCompleted: function onCompleted(param) {
            var artistExportCartTransactionOrdersCsv = param.artistExportCartTransactionOrdersCsv;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(artistExportCartTransactionOrdersCsv === null || artistExportCartTransactionOrdersCsv === void 0 ? void 0 : artistExportCartTransactionOrdersCsv.csvUrl)) {
                                return [
                                    2,
                                    showError(new Error(t("downloadCsvError")))
                                ];
                            }
                            return [
                                4,
                                downloadCsv(artistExportCartTransactionOrdersCsv.csvUrl).then(function() {
                                    showMessage(t("downloadCsvSuccess"), "success");
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        onError: function(error) {
            var ref, ref1, ref2;
            if ((error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === "NO_DATA") {
                showError(new Error(t("noData")));
            } else {
                showError(new Error(t("downloadCsvError")));
            }
        }
    }), 1), artistExportCartTransactionOrdersCsv = ref10[0];
    var handleExportCsv = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsExporting(true);
                        return [
                            4,
                            artistExportCartTransactionOrdersCsv({
                                variables: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            }).finally(function() {
                                setIsExporting(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleExportCsv() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseSnackbar = function() {
        setSnackbar(function(prev) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                open: false
            });
        });
    };
    var ref11, ref12, ref13;
    return {
        state: {
            orderTransactions: orderTransactions,
            loading: loading,
            artistId: (ref11 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref11 !== void 0 ? ref11 : "",
            user: user,
            artist: (ref12 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref12 !== void 0 ? ref12 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrders.pageInfo.hasNextPage),
            sort: orderBy,
            membership: (ref13 = data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.products) !== null && ref13 !== void 0 ? ref13 : undefined,
            startDate: startDate !== null && startDate !== void 0 ? startDate : undefined,
            endDate: endDate !== null && endDate !== void 0 ? endDate : undefined,
            isExporting: isExporting,
            snackbar: snackbar
        },
        actions: {
            onRefetch: function onRefetch(orderBy, inputStartDate, inputEndDate) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setOrderTransactions(null);
                                setOrderBy(orderBy);
                                setStartDate(inputStartDate);
                                setEndDate(inputEndDate);
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("consoleOrdersDate", {
                                        startDate: inputStartDate ? inputStartDate.toISOString() : undefined,
                                        endDate: inputEndDate ? inputEndDate.toISOString() : undefined
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        orderBy: orderBy,
                                        startDate: inputStartDate,
                                        endDate: inputEndDate
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            orderBy: orderBy,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistUserCartTransactionOrders) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onExportCsv: handleExportCsv,
            onCloseSnackbar: handleCloseSnackbar
        }
    };
});
var ConsoleOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleOrders_viewModel_templateObject(), utoniq_core_schema/* UserCartTransactionOrderConnectionFragmentDoc */.at$);
var FETCH_NEW_ORDERS = (0,lib/* gql */.Ps)(ConsoleOrders_viewModel_templateObject1(), utoniq_core_schema/* UserCartTransactionOrderConnectionFragmentDoc */.at$);
var EXPORT_CSV_QUERY = (0,lib/* gql */.Ps)(ConsoleOrders_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleOrders/index.tsx




/**
 * ConsoleOrders Page
 * Implemented as a practical sample.
 */ var ConsoleOrders = function() {
    var ref = ConsoleOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleOrdersTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/deleteCategoryModal.tsx








var DeleteCategoryModal = function(param) {
    var open = param.open, onClose = param.onClose, onDeleteCategory = param.onDeleteCategory, id = param.id;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var onDeletePostCategory = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                return [
                    2,
                    onDeleteCategory({
                        categoryId: id
                    }).then(function() {
                        showMessage(t("completeRemoveCategory"));
                        onClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleCategoryDelete");
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function onDeletePostCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("deleteCategoryModalTitle"),
        innerSx: {
            width: 300
        },
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        fontSize: 13,
                        fontWeight: 300
                    },
                    children: t("removeCategoryDescription")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: "32px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        color: "primary",
                        size: "large",
                        fullWidth: true,
                        onClick: onDeletePostCategory,
                        loading: loading,
                        disabled: loading,
                        children: t("removeCategory")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: "16px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        onClick: onClose,
                        children: t("cancel")
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/updatePostCategoryModal.tsx













var updatePostCategoryModal_schema = function(o) {
    return {
        name: o.string().max(20).label((0,core_form/* tLabel */.TQ)("consoleCreateCategory.name")),
        description: o.string().max(10000).label((0,core_form/* tLabel */.TQ)("consoleCreateCategory.description"))
    };
};
var UpdatePostCategoryModal = function(param) {
    var category = param.category, open = param.open, onClose = param.onClose, onUpdateCategory = param.onUpdateCategory;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: updatePostCategoryModal_schema,
        defaultValues: {
            name: category.name,
            description: category.description
        }
    }), handleSubmit = ref2.handleSubmit, _formState = ref2.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref2.register, setError = ref2.setError, getValues = ref2.getValues, reset = ref2.reset;
    (0,react.useEffect)(function() {
        reset({
            name: category.name,
            description: category.description
        });
    }, [
        category.name,
        category.description
    ]);
    var handleClose = function() {
        reset();
        onClose();
    };
    var onUpdatePostCategory = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                inputs = (0,_extends/* default */.Z)({}, getValues());
                return [
                    2,
                    onUpdateCategory((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                        categoryId: category.id
                    })).then(function() {
                        showMessage(t("completePostCreate"));
                        handleClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleCategoryCreate");
                        (0,core_form/* handleError */.S3)(e, setError, showError);
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function onUpdatePostCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: function() {
            return handleClose();
        },
        innerSx: {
            width: "80vw",
            maxWidth: 500
        },
        title: t("updateCategoryModalTitle"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(onUpdatePostCategory),
            sx: {
                pt: 6
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(updatePostCategoryModal_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    textFieldProps: {
                        variant: "standard",
                        InputProps: {
                            sx: {
                                bgcolor: "background.default",
                                px: 4,
                                py: 3
                            },
                            disableUnderline: true
                        }
                    },
                    titleProps: {
                        variant: "h5",
                        color: "text.primary",
                        textAlign: "left"
                    },
                    error: errors.name
                }, register("name"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(updatePostCategoryModal_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "textarea",
                    textFieldProps: {
                        variant: "standard",
                        multiline: true,
                        rows: 5,
                        InputProps: {
                            sx: {
                                bgcolor: "background.default",
                                px: 4,
                                py: 3
                            },
                            disableUnderline: true
                        }
                    },
                    titleProps: {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    sx: {
                                        color: "text.primary",
                                        textAlign: "left"
                                    },
                                    children: t("descriptionTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        color: "text.secondary",
                                        textAlign: "left"
                                    },
                                    children: t("descriptionDetail")
                                })
                            ]
                        })
                    },
                    error: errors.description
                }, register("description"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    color: "primary",
                    sx: {
                        py: 4,
                        mb: 5,
                        minWidth: 212
                    },
                    onClick: function() {
                        return handleSubmit(onUpdatePostCategory);
                    },
                    loading: loading,
                    disabled: loading,
                    children: t("updateCategory")
                })
            ]
        }),
        cancelText: t("cancel")
    });
};
var updatePostCategoryModal_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/categoryBox.tsx









var CategoryBox = function(param) {
    var category = param.category, divider = param.divider, onDeleteCategory = param.onDeleteCategory, onUpdateCategory = param.onUpdateCategory;
    var ref = (0,react.useState)(false), openUpdate = ref[0], setOpenUpdate = ref[1];
    var toggleUpdateDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpenUpdate(open);
        };
    }, []);
    var ref1 = (0,react.useState)(false), openDelete = ref1[0], setOpenDelete = ref1[1];
    var toggleDeleteDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpenDelete(open);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryMenuListItem, {
                sx: {
                    height: "auto",
                    gridGap: 0,
                    py: 4,
                    color: "text.primary",
                    width: "90vw",
                    maxWidth: 550
                },
                title: category.name,
                primaryTypographyProps: {
                    paddingRight: 8,
                    variant: "h5"
                },
                subTitle: category.description,
                secondaryTypographyProps: {
                    variant: "body2",
                    sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1))
                },
                divider: divider,
                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pencil, {
                            size: "small",
                            onClick: toggleUpdateDrawer(true)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Trash, {
                            size: "small",
                            onClick: toggleDeleteDrawer(true)
                        })
                    ]
                }),
                disableRipple: true,
                disableTouchRipple: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePostCategoryModal, {
                open: openUpdate,
                onClose: toggleUpdateDrawer(false),
                onUpdateCategory: onUpdateCategory,
                category: category
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteCategoryModal, {
                open: openDelete,
                onClose: toggleDeleteDrawer(false),
                onDeleteCategory: onDeleteCategory,
                id: category.id
            })
        ]
    });
};
var CategoryMenuListItem = function(param) {
    var title = param.title, subTitle = param.subTitle, sx = param.sx, primaryTypographyProps = param.primaryTypographyProps, secondaryTypographyProps = param.secondaryTypographyProps, secondaryAction = param.secondaryAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        sx: (0,src_object_spread/* default */.Z)({
            display: "grid",
            gridTemplateColumns: "80% auto",
            gridGap: 16,
            height: {
                xs: 48,
                md: 56
            },
            px: {
                xs: 6,
                md: 7
            },
            py: {
                xs: 2,
                md: 4
            },
            boxSizing: "border-box"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                primary: title,
                secondary: subTitle,
                slotProps: {
                    primary: (0,src_object_spread/* default */.Z)({
                        variant: "body2",
                        paddingRight: 8
                    }, primaryTypographyProps),
                    secondary: (0,src_object_spread/* default */.Z)({
                        variant: "subtitle2"
                    }, secondaryTypographyProps)
                }
            }),
            secondaryAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                justifyContent: "flex-end",
                alignSelf: "flex-end",
                children: secondaryAction
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/conslePostCategoriesSkeleton.tsx






var ConsolePostCategoriesSkelton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Box_Box/* default */.Z, {
            sx: {
                pb: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: Array.from(Array(6).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBoxSkeleton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                sx: {
                                    mx: 5
                                }
                            })
                        ]
                    }, key);
                })
            })
        })
    });
};
var CategoryBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "medium",
            sx: {
                mt: 2,
                maxWidth: "200px"
            },
            width: "20vw"
        }),
        subTitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "medium",
            sx: {
                mt: 2,
                maxWidth: "300px"
            },
            width: "50vw"
        }),
        sx: {
            height: "auto",
            gridGap: 0,
            py: 4,
            color: "text.primary"
        },
        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    size: {
                        xs: 6
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 30,
                        height: 30
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    size: {
                        xs: 6
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 30,
                        height: 30
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/createPostCategoryModal.tsx













var createPostCategoryModal_schema = function(o) {
    return {
        name: o.string().max(20).label((0,core_form/* tLabel */.TQ)("consoleCreateCategory.name")),
        description: o.string().max(10000).label((0,core_form/* tLabel */.TQ)("consoleCreateCategory.description"))
    };
};
var createPostCategoryModal_defaultValues = {
    name: "",
    description: ""
};
var CreatePostCategoryModal = function(param) {
    var open = param.open, onClose = param.onClose, onCreateCategory = param.onCreateCategory;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: createPostCategoryModal_schema,
        defaultValues: (0,src_object_spread/* default */.Z)({}, createPostCategoryModal_defaultValues)
    }), handleSubmit = ref2.handleSubmit, _formState = ref2.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref2.register, setError = ref2.setError, getValues = ref2.getValues, reset = ref2.reset;
    var handleClose = function() {
        reset();
        onClose();
    };
    var onCreatePostCategory = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoading(true);
                inputs = (0,_extends/* default */.Z)({}, getValues());
                return [
                    2,
                    onCreateCategory((0,src_object_spread/* default */.Z)({}, inputs)).then(function() {
                        showMessage(t("completePostCreate"));
                        handleClose();
                    }).catch(function(e) {
                        (0,core_errors/* captureError */.O)(e, "consoleCategoryCreate");
                        (0,core_form/* handleError */.S3)(e, setError, showError);
                    }).finally(function() {
                        setLoading(false);
                    })
                ];
            });
        });
        return function onCreatePostCategory() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: function() {
            return handleClose();
        },
        innerSx: {
            width: "80vw",
            maxWidth: 500
        },
        title: t("createCategoryModalTitle"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(onCreatePostCategory),
            sx: {
                pt: 6
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(createPostCategoryModal_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    textFieldProps: {
                        variant: "standard",
                        InputProps: {
                            sx: {
                                bgcolor: "background.default",
                                px: 4,
                                py: 3
                            },
                            disableUnderline: true
                        }
                    },
                    titleProps: {
                        variant: "h5",
                        color: "text.primary",
                        textAlign: "left"
                    },
                    error: errors.name
                }, register("name"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(createPostCategoryModal_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "textarea",
                    textFieldProps: {
                        variant: "standard",
                        multiline: true,
                        rows: 5,
                        InputProps: {
                            sx: {
                                bgcolor: "background.default",
                                px: 4,
                                py: 3
                            },
                            disableUnderline: true
                        }
                    },
                    titleProps: {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    sx: {
                                        color: "text.primary",
                                        textAlign: "left"
                                    },
                                    children: t("descriptionTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        color: "text.secondary",
                                        textAlign: "left"
                                    },
                                    children: t("descriptionDetail")
                                })
                            ]
                        })
                    },
                    error: errors.description
                }, register("description"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    color: "primary",
                    sx: {
                        py: 4,
                        mb: 5,
                        minWidth: 212
                    },
                    onClick: function() {
                        return handleSubmit(onCreatePostCategory);
                    },
                    loading: loading,
                    disabled: loading,
                    children: t("createCategory")
                })
            ]
        }),
        cancelText: t("cancel")
    });
};
var createPostCategoryModal_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/template/index.tsx













var ConsolePostCategoriesTemplate = function(param) {
    var state = param.state, onCreateCategory = param.onCreateCategory, onUpdateCategory = param.onUpdateCategory, onDeleteCategory = param.onDeleteCategory;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCategories").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePostCategories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: routerPages.ConsolePost
                },
                margin: true,
                hasConsoleFooter: true,
                children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostCategoriesSkelton, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        state.categories.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                            sx: {
                                pt: 6,
                                mb: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h3",
                                    children: t("postCategories")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListCell, {
                                    categories: state.categories,
                                    onUpdateCategory: onUpdateCategory,
                                    onDeleteCategory: onDeleteCategory
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            py: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body1",
                                color: "text.secondary",
                                align: "center",
                                children: t("emptyCategoryMessage", "ポストカテゴリがありません")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostCategories_template_BaseCell, {
                            onCreateCategory: onCreateCategory
                        })
                    ]
                })
            })
        ]
    });
};
var ConsolePostCategories_template_BaseCell = function(param) {
    var onCreateCategory = param.onCreateCategory;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 100,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: toggleDrawer(true),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostCategoryModal, {
                open: open,
                onClose: toggleDrawer(false),
                onCreateCategory: onCreateCategory
            })
        ]
    });
};
var CategoryListCell = function(param) {
    var categories = param.categories, onUpdateCategory = param.onUpdateCategory, onDeleteCategory = param.onDeleteCategory;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                pb: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: categories.map(function(category, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBox, {
                                category: category,
                                divider: true,
                                onUpdateCategory: onUpdateCategory,
                                onDeleteCategory: onDeleteCategory
                            }),
                            categories.length - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                sx: {
                                    mx: 5
                                }
                            })
                        ]
                    }, category.id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/viewModel.ts





function ConsolePostCategories_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistCategoryDetail {\n    artist {\n      id\n      postCategory {\n        categories {\n          id\n          name\n          description\n          createdAt\n          updatedAt\n        }\n      }\n    }\n  }\n"
    ]);
    ConsolePostCategories_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePostCategories_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreatePostCategory($inputs: ArtistCreatePostCategoryInput!) {\n    artistCreatePostCategory(inputs: $inputs) {\n      categories {\n        id\n      }\n    }\n  }\n"
    ]);
    ConsolePostCategories_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsolePostCategories_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdatePostCategory($inputs: ArtistUpdatePostCategoryInput!) {\n    artistUpdatePostCategory(inputs: $inputs) {\n      categories {\n        id\n      }\n    }\n  }\n"
    ]);
    ConsolePostCategories_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsolePostCategories_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeletePostCategory($inputs: ArtistRemovePostCategoryInput!) {\n    artistRemovePostCategory(inputs: $inputs) {\n      categories {\n        id\n      }\n    }\n  }\n"
    ]);
    ConsolePostCategories_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




/**
 *
 */ var ConsolePostCategories_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,useQuery/* useQuery */.aM)(ConsolePostCategories_viewModel_QUERY), data = ref2.data, networkStatus = ref2.networkStatus;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_POST_CATEGORY, {
        refetchQueries: function() {
            return [
                {
                    query: ConsolePostCategories_viewModel_QUERY
                }
            ];
        },
        awaitRefetchQueries: true
    }), 1), createPostCategory = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_POST_CATEGORY, {
        refetchQueries: function() {
            return [
                {
                    query: ConsolePostCategories_viewModel_QUERY
                }
            ];
        },
        awaitRefetchQueries: true
    }), 1), updatePostCategory = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(Delete_POST_CATEGORY, {
        refetchQueries: function() {
            return [
                {
                    query: ConsolePostCategories_viewModel_QUERY
                }
            ];
        },
        awaitRefetchQueries: true
    }), 1), deletePostCategory = ref5[0];
    var categories = (0,react.useMemo)(function() {
        var ref, ref1;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.postCategory) === null || ref1 === void 0 ? void 0 : ref1.categories.length) {
            var ref2, ref3;
            return data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.postCategory) === null || ref3 === void 0 ? void 0 : ref3.categories;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.postCategory) === null || ref1 === void 0 ? void 0 : ref1.categories
    ]);
    var ref6;
    return {
        state: {
            artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
            categories: categories,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading
        },
        actions: {
            onCreateCategory: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createPostCategory({
                                        variables: {
                                            inputs: (0,src_object_spread/* default */.Z)({}, inputs)
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onUpdateCategory: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updatePostCategory({
                                        variables: {
                                            inputs: (0,src_object_spread/* default */.Z)({}, inputs)
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onDeleteCategory: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePostCategory({
                                        variables: {
                                            inputs: (0,src_object_spread/* default */.Z)({}, inputs)
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var ConsolePostCategories_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePostCategories_viewModel_templateObject());
var CREATE_POST_CATEGORY = (0,lib/* gql */.Ps)(ConsolePostCategories_viewModel_templateObject1());
var UPDATE_POST_CATEGORY = (0,lib/* gql */.Ps)(ConsolePostCategories_viewModel_templateObject2());
var Delete_POST_CATEGORY = (0,lib/* gql */.Ps)(ConsolePostCategories_viewModel_templateObject3());

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCategories/index.tsx




/**
 * ConsolePostCategories Page
 * Implemented as a practical sample.
 */ var ConsolePostCategories = function() {
    var ref = ConsolePostCategories_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostCategoriesTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 4 modules
var react_dropzone_dist_es = __webpack_require__(74424);
;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/template/ConsolePostReserve.tsx













var ConsolePostReserve_schema = function(o) {
    return {
        publishedAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consolePostCreate.publishedAt"))
    };
};
var ConsolePostReserve = function(param) {
    var open = param.open, artistId = param.artistId, onClose = param.onClose, onSubmit = param.onSubmit, defaultValue = param.defaultValue, onDelete = param.onDelete;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsolePostReserve_schema,
        defaultValues: {
            publishedAt: null
        }
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors, isValid = _formState.isValid, setValue = ref.setValue, reset = ref.reset, watch = ref.watch;
    var publishedAtWatch = watch("publishedAt");
    (0,react.useEffect)(function() {
        if (open) {
            reset({
                publishedAt: defaultValue !== null && defaultValue !== void 0 ? defaultValue : null
            });
        }
    }, [
        defaultValue,
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
            open: open,
            onClose: function() {
                onClose();
                reset({});
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
                artistId: artistId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                    header: {
                        title: t("title"),
                        left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "start",
                            size: "medium",
                            color: "white",
                            onClick: function() {
                                onClose();
                                reset({});
                            }
                        })
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTextInputCell, {
                                setValue: setValue,
                                error: errors.publishedAt,
                                value: watch("publishedAt")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                spacing: 5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "large",
                                        fullWidth: true,
                                        disabled: isSubmitting || !isValid,
                                        loading: isSubmitting,
                                        onClick: handleSubmit(function() {
                                            var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                onSubmit(values)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            onClose();
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(values) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()),
                                        sx: {
                                            width: 244
                                        },
                                        children: t("set")
                                    }),
                                    onDelete && publishedAtWatch && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        size: "large",
                                        fullWidth: true,
                                        onClick: function() {
                                            onDelete();
                                            onClose();
                                        },
                                        sx: {
                                            width: 244,
                                            color: "error.main"
                                        },
                                        children: t("deleteReserve")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var PostTextInputCell = function(_param) {
    var setValue = _param.setValue, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setValue",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, {
            onChange: function(date) {
                setValue("publishedAt", (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                    shouldValidate: true,
                    shouldDirty: true
                });
            },
            error: error,
            value: props.value ? dayjs_min_default()(props.value) : null,
            title: t("publishedAtLabel"),
            placeholder: t("publishedAtPlaceholder"),
            textFieldProps: {
                label: error ? t("error") : ""
            },
            titleProps: {
                variant: "h5",
                color: "text.primary"
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/template/PostCreateConfirmModal.tsx




var PostCreateConfirmModal = function(param) {
    var open = param.open, onClose = param.onClose, onClick = param.onClick, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("confirmCreateTitle"),
        content: t("confirmCreateMessage"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            onClick: onClick,
            loading: loading,
            disabled: loading,
            children: t("toPost")
        }),
        cancelText: t("cancel"),
        sx: {
            zIndex: zIndex.modal + 2
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/template/PostCreateForm.tsx

































var PostCreateForm_schema = function(o) {
    return {
        content: o.string().max(10000).label((0,core_form/* tLabel */.TQ)("consolePostCreate.content")),
        resource: o.object().when("resourceType", [
            {
                is: "text",
                then: o.any().valid({})
            },
            {
                is: "image",
                then: o.any().allow(null).optional()
            },
            {
                is: "video",
                then: o.object({
                    videoId: o.string().optional().messages({
                        "string.empty": (0,core_form/* tMessage */.Sd)("consolePostCreate.resource.video.string.empty")
                    }),
                    tmpPath: o.string().optional().messages({
                        "string.empty": (0,core_form/* tMessage */.Sd)("consolePostCreate.resource.video.string.empty")
                    })
                }).xor("videoId", "tmpPath").optional().unknown(false).label("ラベル")
            },
            {
                is: "sound",
                then: o.object({
                    tmpPath: o.string().messages({
                        "string.empty": (0,core_form/* tMessage */.Sd)("consolePostCreate.resource.sound.string.empty")
                    })
                })
            }, 
        ]),
        thumbnailPath: o.string().when("resourceType", {
            is: "video",
            then: o.string().when("resource.videoId", {
                is: o.exist(),
                then: o.valid(null).messages({
                    "any.only": (0,core_form/* tMessage */.Sd)("consolePostCreate.thumbnailPath.any.only")
                }),
                otherwise: o.string().optional().allow(null)
            }),
            otherwise: o.string().optional().allow(null)
        }),
        categoryId: o.string().label((0,core_form/* tLabel */.TQ)("consolePostCreate.categoryId")),
        resources: o.array().when("resourceType", {
            is: "image",
            then: o.array().items(o.object({
                tmpPath: o.string().messages({
                    "string.empty": (0,core_form/* tMessage */.Sd)("consolePostCreate.resource.image.string.empty")
                })
            })).label((0,core_form/* tLabel */.TQ)("consolePostCreate.resources")),
            otherwise: o.array().optional().allow(null)
        }),
        membershipAccessPermission: o.string().label((0,core_form/* tLabel */.TQ)("consolePostCreate.membershipAccessPermission")),
        resourceType: o.string().label((0,core_form/* tLabel */.TQ)("consolePostCreate.resourceType")),
        withTwitter: o.boolean().optional()// ストーリー投稿の場合は X（旧 Twitter）連携不可（falseのみ許容）
        .when("isStory", {
            is: true,
            then: o.valid(false).optional().messages({
                "any.only": (0,core_form/* tMessage */.Sd)("consolePostCreate.withTwitter.isStory.any.only")
            }),
            otherwise: o.boolean().optional()
        }).label((0,core_form/* tLabel */.TQ)("consolePostCreate.withTwitter")),
        isStory: o.boolean().optional().when("resourceType", [
            // 画像ポストはストーリー可（true/false/未指定 OK）
            {
                is: "image",
                then: o.boolean().optional()
            },
            // 動画ポストはストーリー可（true/false/未指定 OK）
            {
                is: "video",
                then: o.boolean().optional()
            },
            // テキスト、音声ポストはストーリー不可（false/未指定 限定）
            {
                is: o.any().valid("text", "sound"),
                then: o.valid(false).optional().messages({
                    "any.only": (0,core_form/* tMessage */.Sd)("consolePostCreate.isStory.resourceType.any.only")
                })
            }, 
        ]).label((0,core_form/* tLabel */.TQ)("consolePostCreate.isStory")),
        publishedAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consolePostCreate.publishedAt"))
    };
};
// カテゴリリストの初期値
var defaultCategory = {
    none: "noneCategory"
};
// ポスト公開範囲リストの初期値
var defaultPermission = {
    allUser: "allUser",
    allMember: "allMember"
};
var PostCreateForm_defaultValues = {
    content: "",
    resource: {},
    thumbnailPath: null,
    categoryId: defaultCategory.none,
    membershipAccessPermission: defaultPermission.allUser,
    resourceType: utoniq_core_schema/* PostType.Text */.hQF.Text,
    withTwitter: false,
    resources: [],
    publishedAt: undefined,
    isStory: false
};
var PostCreateForm_obj;
var PostCreateForm_defaultResourceValues = (PostCreateForm_obj = {}, (0,_define_property/* default */.Z)(PostCreateForm_obj, utoniq_core_schema/* PostType.Text */.hQF.Text, {}), (0,_define_property/* default */.Z)(PostCreateForm_obj, utoniq_core_schema/* PostType.Image */.hQF.Image, undefined), (0,_define_property/* default */.Z)(PostCreateForm_obj, utoniq_core_schema/* PostType.Video */.hQF.Video, {
    videoId: ""
}), (0,_define_property/* default */.Z)(PostCreateForm_obj, utoniq_core_schema/* PostType.Sound */.hQF.Sound, {
    tmpPath: ""
}), PostCreateForm_obj);
var PostCreateForm = function(param) {
    var _resourceType = param.resourceType, resourceType = _resourceType === void 0 ? utoniq_core_schema/* PostType.Text */.hQF.Text : _resourceType, fileUploadInfo = param.fileUploadInfo, thumbnailUploadInfo = param.thumbnailUploadInfo, isConnectedTwitter = param.isConnectedTwitter, onSubmitPost = param.onSubmitPost, loadingCreatePost = param.loadingCreatePost, onConnectTwitter = param.onConnectTwitter, withTwitter = param.withTwitter, resourcesUploading = param.resourcesUploading, thumbnailUploading = param.thumbnailUploading, artistId = param.artistId, plans = param.plans, categories = param.categories;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref8 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref8.showMessage, showError = ref8.showError;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), router = ref9.router, routerPages = ref9.routerPages;
    var ref10 = (0,react.useState)(false), open = ref10[0], setOpen = ref10[1];
    var ref11 = (0,core_form/* useForm */.cI)({
        schema: PostCreateForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, PostCreateForm_defaultValues), {
            resource: PostCreateForm_defaultResourceValues[resourceType],
            resourceType: resourceType,
            withTwitter: withTwitter,
            isStory: false
        })
    }), handleSubmit = ref11.handleSubmit, errors = ref11.formState.errors, register = ref11.register, setValue = ref11.setValue, reset = ref11.reset, watch = ref11.watch, control = ref11.control, setError = ref11.setError, getValues = ref11.getValues;
    var isWeb = native_app/* getPlatform */.Xf() === "web";
    var _ref = register("withTwitter"), withTwitterRef = _ref.ref, restWithTwitter = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref"
    ]);
    var _ref1 = register("isStory"), isStoryRef = _ref1.ref, restIsStory = (0,_object_without_properties/* default */.Z)(_ref1, [
        "ref"
    ]);
    var _ref2 = register("membershipAccessPermission"), ref12 = _ref2.ref, rest = (0,_object_without_properties/* default */.Z)(_ref2, [
        "ref"
    ]);
    var withTwitterWatch = watch("withTwitter", withTwitter);
    var isStoryWatch = watch("isStory", false);
    (0,react.useEffect)(function() {
        if (withTwitterWatch && !isConnectedTwitter) {
            setOpen(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        withTwitterWatch
    ]);
    // ストーリー投稿が有効になった場合、withTwitter を false に設定
    (0,react.useEffect)(function() {
        if (isStoryWatch && withTwitterWatch) {
            setValue("withTwitter", false, {
                shouldValidate: true
            });
        }
    }, [
        isStoryWatch,
        withTwitterWatch
    ]);
    (0,react.useEffect)(function() {
        reset((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, PostCreateForm_defaultValues), {
            resource: PostCreateForm_defaultResourceValues[resourceType],
            resourceType: resourceType,
            withTwitter: withTwitter
        }));
        register("resource");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        reset,
        resourceType,
        withTwitter
    ]);
    var ref13 = (0,react.useState)(), confirmModal = ref13[0], setConfirmModal = ref13[1];
    var onCreatePost = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var confirmed, _ref, membershipAccessPermission, inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve) {
                                setConfirmModal({
                                    confirmAction: resolve
                                });
                            })
                        ];
                    case 1:
                        confirmed = _state.sent();
                        // キャンセルされた場合、モーダルを閉じて終了
                        if (!confirmed) {
                            setConfirmModal(undefined);
                            return [
                                2
                            ];
                        }
                        _ref = getValues(), membershipAccessPermission = _ref.membershipAccessPermission, inputs = (0,_object_without_properties/* default */.Z)(_ref, [
                            "membershipAccessPermission"
                        ]);
                        // 投稿確定した場合、投稿処理を実行し終了後モーダルを閉じる
                        return [
                            2,
                            onSubmitPost((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                /**
       * 公開範囲のキーからisPremiumとplanIdの値をミューテーション引数に割り当てる
       * プランを指定しない場合はplanId: nullになる
       */ isPremium: membershipAccessPermission !== defaultPermission.allUser,
                                planId: Object.values(defaultPermission).includes(membershipAccessPermission) ? undefined : membershipAccessPermission,
                                // カテゴリIDがnoneCategoryの場合はカテゴリ未指定としてnullを渡す
                                categoryId: inputs.categoryId === defaultCategory.none ? null : inputs.categoryId
                            })).then(function() {
                                showMessage(t(inputs.publishedAt ? "completePostReserve" : "completePost"), "success", inputs.publishedAt ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "text",
                                    size: "small",
                                    sx: {
                                        color: "white"
                                    },
                                    onClick: function() {
                                        return router.push(routerPages.ConsoleUnpublishedPosts);
                                    },
                                    children: t("display")
                                }) : undefined);
                                router.push(routerPages.ConsolePost);
                            }).catch(function(e) {
                                (0,core_errors/* captureError */.O)(e, "consolePostCreate");
                                (0,core_form/* handleError */.S3)(e, setError, showError);
                            }).finally(function() {
                                setConfirmModal(undefined);
                            })
                        ];
                }
            });
        });
        return function onCreatePost() {
            return _ref.apply(this, arguments);
        };
    }();
    // YouTube の videoId を取得
    var videoId = (0,react_hook_form_dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "resource.videoId"
    });
    // YouTube の videoId が変更された時
    (0,react.useEffect)(function() {
        if (videoId) {
            // サムネイルをリセットする
            setValue("thumbnailPath", null);
        }
    }, [
        videoId
    ]);
    var ref14, ref15, ref16, ref17, ref18, ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                onSubmit: handleSubmit(onCreatePost),
                sx: {
                    py: 6
                },
                children: [
                    resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadCell, {
                        control: control,
                        imageUploadInfo: fileUploadInfo,
                        setValue: setValue,
                        error: get_default()(errors, "resources.message"),
                        resourcesUploading: resourcesUploading
                    }),
                    resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoUploadCell, {
                                videoId: (ref = watch()) === null || ref === void 0 ? void 0 : (ref1 = ref.resource) === null || ref1 === void 0 ? void 0 : ref1.videoId,
                                setValue: setValue,
                                error: (ref2 = errors.resource) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.videoId) === null || ref3 === void 0 ? void 0 : ref3.message,
                                videoUploadInfo: fileUploadInfo,
                                resourcesUploading: resourcesUploading
                            }),
                            !((ref4 = watch()) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resource) === null || ref5 === void 0 ? void 0 : ref5.videoId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateForm_ThumbnailUploadCell, {
                                control: control,
                                thumbnailUploadInfo: thumbnailUploadInfo,
                                setValue: setValue,
                                error: get_default()(errors, "thumbnailPath.message"),
                                thumbnailUploading: thumbnailUploading
                            })
                        ]
                    }),
                    resourceType === utoniq_core_schema/* PostType.Sound */.hQF.Sound && /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioUploadCell, {
                        audioUploadInfo: fileUploadInfo,
                        setValue: setValue,
                        error: (ref6 = errors.resource) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.tmpPath) === null || ref7 === void 0 ? void 0 : ref7.message
                    }),
                    (resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image || resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        sx: {
                            mb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("postCategory")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            onClick: function() {
                                                return router.push(routerPages.ConsolePostCategories);
                                            },
                                            sx: {
                                                textAlign: "right",
                                                alignItems: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: t("editCategory")
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                listItems: (0,src_to_consumable_array/* default */.Z)(Object.values(defaultCategory).map(function(value) {
                                    return {
                                        value: value,
                                        label: t(value)
                                    };
                                })).concat((0,src_to_consumable_array/* default */.Z)(categories.length ? categories.map(function(category) {
                                    return {
                                        value: (ref14 = category === null || category === void 0 ? void 0 : category.id) !== null && ref14 !== void 0 ? ref14 : "",
                                        label: (ref15 = category === null || category === void 0 ? void 0 : category.name) !== null && ref15 !== void 0 ? ref15 : ""
                                    };
                                }) : [])),
                                value: watch("categoryId"),
                                onChange: function(value) {
                                    setValue("categoryId", value);
                                },
                                formControlProps: {
                                    sx: {
                                        width: "100%",
                                        bgcolor: "grey.50",
                                        minHeight: "auto",
                                        mb: 16
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCell, {
                        register: register,
                        error: errors.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReserveInputCell, {
                        artistId: artistId,
                        setValue: setValue,
                        value: watch("publishedAt")
                    }),
                    config_config/* config.platform.includes */.v.platform.includes("web") && /**
           * @description
           * Diica以外の場合、SNS認証機能解放
           * （DiicaはSNS連携時のUtoniqアイコンの表示をしてはいけないため、SNSリンク機能を隠す）
           * ストーリー投稿の場合は X（旧 Twitter）連携機能を非表示
           * X 上で24時間で投稿が削除されず、残り続けることを避けるため
           */ config_config/* config.applicationKey */.v.applicationKey !== "diica" && !isStoryWatch && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread/* default */.Z)({
                        content: {
                            title: t("withTwitter")
                        },
                        checked: withTwitterWatch,
                        inputRef: withTwitterRef,
                        sx: {
                            mx: -2
                        }
                    }, restWithTwitter)),
                    (0,individual/* individualShowStory */.IG)() && (resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image || resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread/* default */.Z)({
                        content: {
                            title: t("isStory"),
                            description: t("storyDesc")
                        },
                        checked: isStoryWatch,
                        inputRef: isStoryRef,
                        sx: {
                            mx: -2
                        }
                    }, restIsStory)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        sx: {
                            mb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    mb: 2
                                },
                                children: t("membershipAccessPermission")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                listItems: (0,src_to_consumable_array/* default */.Z)(Object.values(defaultPermission).map(function(value) {
                                    return {
                                        value: value,
                                        label: t(value)
                                    };
                                })).concat((0,src_to_consumable_array/* default */.Z)(plans.map(function(plan) {
                                    return (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? {
                                        value: (ref16 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref16 !== void 0 ? ref16 : "",
                                        label: t("planOnlyYear", {
                                            name: (ref17 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref17 !== void 0 ? ref17 : ""
                                        })
                                    } : {
                                        value: (ref18 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref18 !== void 0 ? ref18 : "",
                                        label: t("planOnly", {
                                            name: (ref19 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref19 !== void 0 ? ref19 : ""
                                        })
                                    };
                                }))),
                                value: watch("membershipAccessPermission").toString(),
                                onChange: function(value) {
                                    setValue("membershipAccessPermission", value);
                                },
                                formControlProps: {
                                    sx: {
                                        width: "100%",
                                        bgcolor: "grey.50",
                                        minHeight: "auto",
                                        mb: 16
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateForm_ButtonCell, {
                        submitting: loadingCreatePost,
                        resourcesUploading: resourcesUploading,
                        thumbnailUploading: thumbnailUploading,
                        isReserve: !!watch("publishedAt")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: open,
                        onClose: function() {
                            setOpen(false);
                            setValue("withTwitter", false, {
                                shouldValidate: true
                            });
                        },
                        title: t("signUpTwitterTitle"),
                        content: t("signUpTwitterDesc"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    if (isWeb) {
                                        onConnectTwitter().then(function() {
                                            setValue("withTwitter", true);
                                        }).finally(function() {
                                            setOpen(false);
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    dist_esm/* Browser.open */.A.open({
                                        url: "".concat(config_config/* config.domain */.v.domain).concat(routerPages.Integrations)
                                    });
                                    setOpen(false);
                                    return [
                                        2
                                    ];
                                });
                            }),
                            children: t("signUpTwitterBtn")
                        }),
                        cancelText: t("cancel")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateConfirmModal, {
                open: !!confirmModal,
                onClose: function() {
                    return confirmModal === null || confirmModal === void 0 ? void 0 : confirmModal.confirmAction(false);
                },
                onClick: function() {
                    return confirmModal === null || confirmModal === void 0 ? void 0 : confirmModal.confirmAction(true);
                },
                loading: loadingCreatePost
            })
        ]
    });
};
var PostCreateForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var PostCreateForm_ButtonCell = function(param) {
    var submitting = param.submitting, resourcesUploading = param.resourcesUploading, thumbnailUploading = param.thumbnailUploading, isReserve = param.isReserve;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 8,
            mb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            fullWidth: true,
            loading: submitting,
            disabled: resourcesUploading || thumbnailUploading,
            children: !isReserve ? t("toPost") : t("toReserve")
        })
    });
};
var ImageUploadCell = function(param) {
    var imageUploadInfo = param.imageUploadInfo, control = param.control, setValue = param.setValue, error = param.error, resourcesUploading = param.resourcesUploading;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,react.useState)([]), resources = ref[0], setResources = ref[1];
    var ref1 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "resources"
    }), remove = ref1.remove, fields = ref1.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            mb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Image, {
                                sx: {
                                    color: "primary.main"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("imageUploaderTitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Plus, {
                        size: "small",
                        bgcolor: "grey.50",
                        disabled: fields.length >= 10 || resourcesUploading,
                        onClick: function() {
                            return imageUploadInfo.onDrop(true, 10 - fields.length).then(function(resources) {
                                if (!resources) {
                                    return;
                                }
                                var _imageUploadPath;
                                setValue("resources", (0,src_to_consumable_array/* default */.Z)(fields.map(function(param) {
                                    var tmpPath = param.tmpPath;
                                    return {
                                        tmpPath: tmpPath
                                    };
                                })).concat((0,src_to_consumable_array/* default */.Z)(resources.map(function(resource) {
                                    return {
                                        tmpPath: (_imageUploadPath = resource.imageUploadPath) !== null && _imageUploadPath !== void 0 ? _imageUploadPath : ""
                                    };
                                })// get 10 items
                                .slice(0, 10))), {
                                    shouldValidate: true
                                });
                                setResources(function(prevState) {
                                    return (0,src_to_consumable_array/* default */.Z)(prevState).concat((0,src_to_consumable_array/* default */.Z)(resources));
                                });
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("imageUploaderDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                sx: (0,src_object_spread/* default */.Z)({
                    overflowX: "auto",
                    pt: resources.length ? 5 : 0
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    resources.map(function(resource, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "relative",
                                bgcolor: "grey.100"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                    size: "small",
                                    bgcolor: "grey.50",
                                    onClick: function() {
                                        remove(index);
                                        setResources(function(prevState) {
                                            return prevState.filter(function(_, idx) {
                                                return idx !== index;
                                            });
                                        });
                                    },
                                    sx: {
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        zIndex: 2
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: resource.imageUrl,
                                    sx: {
                                        width: 280,
                                        height: 200,
                                        img: {
                                            objectFit: "contain"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        right: 8,
                                        bottom: 8,
                                        bgcolor: "rgba(255,255,255,0.6)",
                                        borderRadius: "40px",
                                        p: "1px 6px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "black",
                                        children: [
                                            index + 1,
                                            "/",
                                            resources.length
                                        ]
                                    })
                                })
                            ]
                        }, resource.id);
                    }),
                    resourcesUploading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            p: 4,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            })
        ]
    });
};
var AudioUploadCell = function(param) {
    var audioUploadInfo = param.audioUploadInfo, setValue = param.setValue, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = audioUploadInfo || {}, onDrop = ref.onDrop, progress = ref.progress;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            mb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.FileUploader, {
                t: t,
                fileUploadInfo: {
                    type: "audio",
                    onDrop: function() {
                        return onDrop().then(function(resources) {
                            var resource = resources === null || resources === void 0 ? void 0 : resources[0];
                            if (!resource) {
                                return;
                            }
                            setValue("resource", {
                                tmpPath: resource.imageUploadPath
                            });
                            return resource;
                        });
                    },
                    progress: progress || 0,
                    description: t("audioUploaderDescription"),
                    onClose: function() {
                        return setValue("resource", {
                            tmpPath: ""
                        });
                    }
                },
                content: {
                    title: t("audioUploaderTitle")
                }
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            })
        ]
    });
};
var VideoUploadCell = function(param) {
    var videoId = param.videoId, setValue = param.setValue, error = param.error, videoUploadInfo = param.videoUploadInfo, resourcesUploading = param.resourcesUploading;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,resources_usePlayingResource/* usePlayingResource */.p)(), playingResource = ref.playingResource, playResource = ref.playResource;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(false), openYoutubeUrlForm = ref2[0], setOpenYoutubeUrlForm = ref2[1];
    var ref3 = (0,react.useState)(""), youtubeUrl = ref3[0], setYoutubeUrl = ref3[1];
    var ref4 = (0,react.useState)(""), uploadedVideoUrl = ref4[0], setUploadedVideoUrl = ref4[1];
    (0,react.useEffect)(function() {
        if (playingResource !== videoId) {
            var ref, ref1;
            (ref1 = (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer()) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        }
    }, [
        playingResource,
        videoId
    ]);
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var getRootProps = (0,react_dropzone_dist_es.useDropzone)({
        accept: config_config/* config.upload.mimeTypes.video */.v.upload.mimeTypes.video
    }).getRootProps;
    var onResetResource = function() {
        setValue("resource", PostCreateForm_defaultResourceValues.video);
        setYoutubeUrl("");
        setUploadedVideoUrl("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            mb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Video, {
                        fontSize: "large",
                        color: "primary",
                        sx: {
                            pr: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            textAlign: "center",
                            verticalAlign: "center"
                        },
                        children: t("attacheVideo")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.ThinPlus, {
                        size: "small",
                        sx: {
                            ml: "auto"
                        },
                        onClick: handleClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                        anchorEl: anchorEl,
                        open: Boolean(anchorEl),
                        onClose: handleClose,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                sx: {
                                    width: 200
                                },
                                onClick: function() {
                                    setAnchorEl(null);
                                    videoUploadInfo.onDrop().then(function(resources) {
                                        var resource = resources === null || resources === void 0 ? void 0 : resources[0];
                                        if (!resource) {
                                            return;
                                        }
                                        var _imageUrl;
                                        setUploadedVideoUrl((_imageUrl = resource.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "");
                                        setValue("resource", {
                                            tmpPath: resource.imageUploadPath
                                        });
                                        return resource;
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getRootProps()), {
                                    children: t("uploadVideo")
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                sx: {
                                    width: 200
                                },
                                onClick: function() {
                                    setOpenYoutubeUrlForm(true);
                                    setAnchorEl(null);
                                },
                                children: t("embedYoutubeVideo")
                            })
                        ]
                    })
                ]
            }),
            videoId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative",
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        bgcolor: "grey.100",
                        sx: {
                            position: "absolute",
                            top: 20,
                            right: 8
                        },
                        onClick: onResetResource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                        id: videoId || "",
                        videoId: videoId || "",
                        opts: {
                            width: "100%",
                            height: "168px"
                        },
                        ref: videoRef,
                        onPlay: function() {
                            return playResource(videoId !== null && videoId !== void 0 ? videoId : "");
                        }
                    })
                ]
            }),
            resourcesUploading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                sx: {
                    bgcolor: "grey.50",
                    width: "100%",
                    height: 168,
                    mt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
            }),
            !resourcesUploading && uploadedVideoUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative",
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        bgcolor: "grey.100",
                        sx: {
                            position: "absolute",
                            top: 20,
                            right: 8,
                            zIndex: 2
                        },
                        onClick: onResetResource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        controls: true,
                        width: "100%",
                        height: "168px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: uploadedVideoUrl,
                            type: "video/mp4"
                        })
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeUrlForm, {
                open: openYoutubeUrlForm,
                onClose: function() {
                    return setOpenYoutubeUrlForm(false);
                },
                videoId: videoId,
                youtubeUrl: youtubeUrl,
                setYoutubeUrl: setYoutubeUrl,
                setValue: setValue,
                error: error
            })
        ]
    });
};
var PostCreateForm_ThumbnailUploadCell = function(param) {
    var thumbnailUploadInfo = param.thumbnailUploadInfo, control = param.control, setValue = param.setValue, error = param.error, thumbnailUploading = param.thumbnailUploading;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,react.useState)(null), resource = ref[0], setResource = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            mb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Image, {
                                sx: {
                                    color: "primary.main"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("thumbnailUploaderTitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Plus, {
                        size: "small",
                        disabled: thumbnailUploading,
                        onClick: function() {
                            return thumbnailUploadInfo.onDrop().then(function(resources) {
                                var uploadedResource = resources === null || resources === void 0 ? void 0 : resources[0];
                                if (!uploadedResource) {
                                    return;
                                }
                                var _imageUploadPath;
                                setValue("thumbnailPath", (_imageUploadPath = uploadedResource.imageUploadPath) !== null && _imageUploadPath !== void 0 ? _imageUploadPath : "");
                                setResource(uploadedResource);
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("thumbnailUploaderDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                sx: (0,src_object_spread/* default */.Z)({
                    overflowX: "auto",
                    pt: resource ? 5 : 0
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    !thumbnailUploading && resource && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative",
                            bgcolor: "grey.100",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                bgcolor: "grey.50",
                                onClick: function() {
                                    setValue("thumbnailPath", null);
                                    setResource(null);
                                },
                                sx: {
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    zIndex: 2
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                src: resource.imageUrl,
                                sx: {
                                    width: "100%",
                                    height: 200,
                                    img: {
                                        objectFit: "contain"
                                    }
                                }
                            })
                        ]
                    }),
                    thumbnailUploading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            p: 4,
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                error: true,
                children: error
            })
        ]
    });
};
var ReserveInputCell = function(param) {
    var artistId = param.artistId, setValue = param.setValue, value = param.value;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "text",
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                    sx: {
                        color: "primary.main"
                    }
                }),
                onClick: function() {
                    return setOpen(true);
                },
                sx: {
                    textAlign: "left",
                    alignItems: "flex-start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: value ? t("postPostedOn", {
                        date: values_Date/* DateTime.formatDate */.o.formatDate(value, "LL HH:mm") || "",
                        fallback: "このポストは{{-date}}に投稿されます。"
                    }) : t("postDateTime", "投稿日時を指定する")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostReserve, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                artistId: artistId,
                defaultValue: value,
                onSubmit: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(value) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            setValue("publishedAt", value.publishedAt);
                            return [
                                2
                            ];
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onDelete: function() {
                    setValue("publishedAt", undefined);
                }
            })
        ]
    });
};
var ContentCell = function(param) {
    var register = param.register, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateForm_TextInputCell, (0,src_object_spread/* default */.Z)({
        type: "textarea",
        textFieldProps: {
            variant: "standard",
            multiline: true,
            rows: 5,
            InputProps: {
                sx: {
                    bgcolor: "background.default"
                },
                disableUnderline: true
            }
        },
        titleProps: {
            variant: "h5",
            color: "text.primary"
        },
        error: error
    }, register("content")));
};
var YoutubeUrlForm = function(param) {
    var open = param.open, onClose = param.onClose, videoId = param.videoId, youtubeUrl = param.youtubeUrl, setYoutubeUrl = param.setYoutubeUrl, setValue = param.setValue, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,resources_usePlayingResource/* usePlayingResource */.p)(), playingResource = ref.playingResource, playResource = ref.playResource;
    var ref1 = (0,react.useState)(""), previewVideoId = ref1[0], setPreviewVideoId = ref1[1];
    (0,react.useEffect)(function() {
        if (playingResource !== videoId) {
            var ref, ref1;
            (ref1 = (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer()) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        }
    }, [
        playingResource,
        videoId
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var videoId = (ref = extractVideoId(youtubeUrl)) !== null && ref !== void 0 ? ref : "";
        setPreviewVideoId(videoId);
    }, [
        youtubeUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                title: t("youtubeUrlFormTitle"),
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                    color: "common.white",
                    onClick: function() {
                        !videoId && setYoutubeUrl("");
                        onClose();
                    }
                }),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    onClick: function() {
                        var videoId = extractVideoId(youtubeUrl);
                        setValue("resource", {
                            videoId: videoId
                        });
                        onClose();
                    },
                    sx: {
                        color: "common.white"
                    },
                    children: t("add")
                })
            },
            margin: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateForm_TextInputCell, {
                    type: "textarea",
                    textFieldProps: {
                        variant: "standard",
                        InputProps: {
                            sx: {
                                bgcolor: "background.default"
                            },
                            disableUnderline: true
                        },
                        placeholder: t("videoUploaderPlaceholder"),
                        defaultValue: youtubeUrl
                    },
                    titleProps: {
                        variant: "h5",
                        color: "text.primary",
                        children: t("videoUploaderTitle"),
                        sx: {
                            pt: 5
                        }
                    },
                    onChange: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                setYoutubeUrl(e.target.value);
                                return [
                                    2
                                ];
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                }),
                previewVideoId && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                    id: previewVideoId || "",
                    videoId: previewVideoId || "",
                    opts: {
                        width: "100%",
                        height: "168px"
                    },
                    ref: videoRef,
                    onPlay: function() {
                        return playResource(previewVideoId !== null && previewVideoId !== void 0 ? previewVideoId : "");
                    }
                }),
                !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                    error: true,
                    children: error
                })
            ]
        })
    });
};
/**
 * extract youtube video id from youtube url
 * @param url
 */ function extractVideoId(url) {
    var res = url.match(/^https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9-_]+)|^https:\/\/youtube\.com\/([a-zA-Z0-9-_]+)|^https:\/\/youtu\.be\/([a-zA-Z0-9-_]+)/);
    if (res) return res[1] || res[2] || res[3];
    return "";
}

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/template/index.tsx








var ConsolePostCreateTemplate = function(param) {
    var state = param.state, onSubmitPost = param.onSubmitPost, onConnectTwitter = param.onConnectTwitter;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePostCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    title: t("title"),
                    back: true,
                    defaultBackPage: routerPages.ConsolePost,
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        href: routerPages.ConsoleUnpublishedPosts,
                        sx: {
                            mr: -1,
                            p: 0,
                            width: 80
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: {
                                color: "white"
                            },
                            children: t("unposted")
                        })
                    })
                },
                margin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCreateForm, {
                    artistId: state.artistId,
                    categories: state.categories,
                    plans: state.plans,
                    withTwitter: state.withTwitter,
                    isConnectedTwitter: state.isConnectedTwitter,
                    resourceType: state.resourceType,
                    fileUploadInfo: state.fileUploadInfo,
                    thumbnailUploadInfo: state.thumbnailUploadInfo,
                    resourcesUploading: state.resourcesUploading,
                    thumbnailUploading: state.thumbnailUploading,
                    onSubmitPost: onSubmitPost,
                    loadingCreatePost: state.loadingCreatePost,
                    onConnectTwitter: onConnectTwitter
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/pages/Integrations/viewModel.ts
var viewModel = __webpack_require__(33769);
;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/viewModel.ts






function ConsolePostCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistSubscriptionPlan {\n    artist {\n      id\n      subscription {\n        plans {\n          planId\n          title\n          interval\n        }\n        products {\n          productId\n          title\n          plans {\n            interval\n            planId\n            amount\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ConsolePostCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePostCreate_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistCategory {\n    artist {\n      id\n      postCategory {\n        categories {\n          id\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    ConsolePostCreate_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsolePostCreate_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreatePost($inputs: CreatePostInput!) {\n    createPost(inputs: $inputs) {\n      ...PostBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePostCreate_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var ConsolePostCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref6 = (0,auth/* useAuth */.aC)(), user = ref6.user, reloadUser = ref6.reloadUser;
    var ref7 = (0,react.useState)(false), withTwitter = ref7[0], setWithTwitter = ref7[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var resourceType = (router.query || {}).resourceType;
    var getImage = camera/* getImage */.g;
    var data = (0,useQuery/* useQuery */.aM)(ConsolePostCreate_viewModel_QUERY).data;
    var ref8 = (0,useQuery/* useQuery */.aM)(POST_CATEGORY_QUERY), artistPostCategory = ref8.data;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_POST), 2), createPost = ref9[0], ref10 = ref9[1], loadingCreatePost = ref10.loading;
    var ref11 = (0,useTmpUploader/* useUserTmpUploader */.x)((user === null || user === void 0 ? void 0 : user.uid) || ""), upload = ref11.upload, progress = ref11.progress;
    var ref12 = (0,react.useState)(false), resourcesUploading = ref12[0], setResourcesUploading = ref12[1];
    var ref13 = (0,react.useState)(false), thumbnailUploading = ref13[0], setThumbnailUploading = ref13[1];
    var ref14 = (0,viewModel/* useTwitterConnection */.B)(), isConnectedTwitter = ref14.connected, connectTwitter = ref14.connectTwitter;
    (0,react.useEffect)(function() {
        setPostTwitterSetting();
        reloadWhenFinishBrowser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * localStorageからtwitter連携投稿に関する状態をセットする
   */ var setPostTwitterSetting = function() {
        (0,storage/* getInputPostOptions */.yh)().then(function(value) {
            setWithTwitter(isConnectedTwitter && value.withTwitter);
        });
    };
    /**
   * アプリ内部ブラウザから戻ってきた時にユーザーの状態を更新する
   */ var reloadWhenFinishBrowser = function() {
        dist_esm/* Browser.addListener */.A.addListener("browserFinished", function() {
            reloadUser().catch(showError);
        });
    };
    var getResource = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(resourceType, multiple, limit) {
            var files, _tmp, platform, file, file1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image)) return [
                            3,
                            5
                        ];
                        if (!multiple) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,camera/* pickImages */.M)(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image, limit)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 3:
                        _tmp = [
                            _state.sent()
                        ];
                        _state.label = 4;
                    case 4:
                        files = _tmp;
                        if (files.every(function(file) {
                            return file.size > config_config/* config.upload.limit.image */.v.upload.limit.image;
                        })) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            files
                        ];
                    case 5:
                        platform = (0,native_app/* getPlatform */.Xf)();
                        if (!(resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            pickFile(config_config/* config.upload.mimeTypes.video */.v.upload.mimeTypes.video)
                        ];
                    case 6:
                        file = _state.sent();
                        if (config_config/* config.upload.mimeTypes.video.findIndex */.v.upload.mimeTypes.video.findIndex(function(o) {
                            return o === file.mimeType;
                        }) === -1) {
                            throw new Error("uploadErrorVideoOnly");
                        }
                        if (file.size > config_config/* config.upload.limit.video */.v.upload.limit.video[platform]) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            [
                                file
                            ]
                        ];
                    case 7:
                        if (!(resourceType === utoniq_core_schema/* PostType.Sound */.hQF.Sound)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            pickFile(config_config/* config.upload.mimeTypes.audio */.v.upload.mimeTypes.audio)
                        ];
                    case 8:
                        file1 = _state.sent();
                        if (config_config/* config.upload.mimeTypes.audio.findIndex */.v.upload.mimeTypes.audio.findIndex(function(o) {
                            return o === file1.mimeType;
                        }) === -1) {
                            throw new Error("uploadErrorAudioOnly");
                        }
                        if (file1.size > config_config/* config.upload.limit.audio */.v.upload.limit.audio) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            [
                                file1
                            ]
                        ];
                    case 9:
                        throw new Error("resourceType Error");
                }
            });
        });
        return function getResource(resourceType, multiple, limit) {
            return _ref.apply(this, arguments);
        };
    }();
    /** サムネイル画像取得用関数 */ var getThumbnailResource = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var files;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image)
                        ];
                    case 1:
                        files = [
                            _state.sent()
                        ];
                        if (files.every(function(file) {
                            return file.size > config_config/* config.upload.limit.image */.v.upload.limit.image;
                        })) {
                            throw new Error("uploadErrorMaximumSize");
                        }
                        return [
                            2,
                            files
                        ];
                }
            });
        });
        return function getThumbnailResource() {
            return _ref.apply(this, arguments);
        };
    }();
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7, ref8, ref9, ref10, ref11;
            if ((data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.products) === null || ref8 === void 0 ? void 0 : ref8.length) > 1) {
                var ref12, ref13;
                // productが複数あるときは全てのplanを返す
                return flatten_default()(data === null || data === void 0 ? void 0 : (ref12 = data.artist) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.subscription) === null || ref13 === void 0 ? void 0 : ref13.products.map(function(product) {
                    return product.plans.map(function(plan) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                            title: product.title
                        });
                    });
                }));
            }
            if ((data === null || data === void 0 ? void 0 : (ref9 = data.artist) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.products) === null || ref11 === void 0 ? void 0 : ref11.length) === 1) {
                var ref14, ref15;
                // NOTE: productが1件のみの場合、デフォルトの「メンバーシップ限定」と役割が重複するため表示するplanを制限する
                // https://app.clickup.com/t/908127/UT-23661
                return flatten_default()(data === null || data === void 0 ? void 0 : (ref14 = data.artist) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.subscription) === null || ref15 === void 0 ? void 0 : ref15.products.map(function(product) {
                    if (product.plans.length > 1) {
                        // product1件で月額と年額のplanがあるときは年額のplanだけ返し月額のplanは表示しない
                        return product.plans.filter(function(plan) {
                            return plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year;
                        }).map(function(plan) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                                title: product.title
                            });
                        });
                    } else {
                        // product1件でplanが1つのときはなにも返さずデフォルトの選択肢のみ表示する
                        return [];
                    }
                }));
            }
        }
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return data.artist.subscription.plans;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products
    ]);
    var categories = (0,react.useMemo)(function() {
        var ref, ref1;
        if (artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref = artistPostCategory.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.postCategory) === null || ref1 === void 0 ? void 0 : ref1.categories.length) {
            var ref2, ref3;
            return artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref2 = artistPostCategory.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.postCategory) === null || ref3 === void 0 ? void 0 : ref3.categories;
        }
        return [];
    }, [
        artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref4 = artistPostCategory.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.postCategory) === null || ref5 === void 0 ? void 0 : ref5.categories
    ]);
    var ref15;
    return {
        state: {
            artistId: (ref15 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref15 !== void 0 ? ref15 : "",
            categories: categories,
            plans: plans,
            withTwitter: withTwitter,
            resourceType: router.query.resourceType,
            isConnectedTwitter: isConnectedTwitter,
            resourcesUploading: resourcesUploading,
            thumbnailUploading: thumbnailUploading,
            loadingCreatePost: loadingCreatePost,
            fileUploadInfo: {
                progress: progress,
                onDrop: function onDrop() {
                    return (0,src_async_to_generator/* default */.Z)(function() {
                        var files;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getResource(resourceType, resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image, resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image ? 10 : 1).catch(function(error) {
                                            showError(new Error(t([
                                                error.message,
                                                "interruptedUpload"
                                            ])));
                                        })
                                    ];
                                case 1:
                                    files = _state.sent();
                                    if (!files || !(files === null || files === void 0 ? void 0 : files.length)) {
                                        return [
                                            2
                                        ];
                                    }
                                    setResourcesUploading(true);
                                    return [
                                        2,
                                        Promise.all(files.map(function(file) {
                                            return upload(file, false, true).then(function(param) {
                                                var tmpPath = param.tmpPath, fileUrl = param.fileUrl;
                                                var uuid = createUuid();
                                                return {
                                                    id: uuid,
                                                    resourceName: uuid,
                                                    imageUrl: fileUrl,
                                                    imageUploadPath: tmpPath
                                                };
                                            });
                                        })).finally(function() {
                                            setResourcesUploading(false);
                                        })
                                    ];
                            }
                        });
                    })();
                }
            },
            /** サムネイル画像アップロード用関数 */ thumbnailUploadInfo: {
                progress: progress,
                onDrop: function onDrop() {
                    return (0,src_async_to_generator/* default */.Z)(function() {
                        var files;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getThumbnailResource().catch(function(error) {
                                            showError(new Error(t([
                                                error.message,
                                                "interruptedUpload"
                                            ])));
                                        })
                                    ];
                                case 1:
                                    files = _state.sent();
                                    if (!files || !(files === null || files === void 0 ? void 0 : files.length)) {
                                        return [
                                            2
                                        ];
                                    }
                                    setThumbnailUploading(true);
                                    return [
                                        2,
                                        Promise.all(files.map(function(file) {
                                            return upload(file, false).then(function(param) {
                                                var tmpPath = param.tmpPath, fileUrl = param.fileUrl;
                                                var uuid = createUuid();
                                                return {
                                                    id: uuid,
                                                    resourceName: uuid,
                                                    imageUrl: fileUrl,
                                                    imageUploadPath: tmpPath
                                                };
                                            });
                                        })).finally(function() {
                                            setThumbnailUploading(false);
                                        })
                                    ];
                            }
                        });
                    })();
                }
            }
        },
        actions: {
            onSubmitPost: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputs) {
                    var _publishedAt;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createPost({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                                publishedAt: (_publishedAt = inputs.publishedAt) !== null && _publishedAt !== void 0 ? _publishedAt : null,
                                                status: inputs.publishedAt ? utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled : utoniq_core_schema/* PostStatus.Published */.$4T.Published
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* setInputPostOptions */.J8)({
                                        withTwitter: !!inputs.withTwitter
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(inputs) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onConnectTwitter: connectTwitter
        }
    };
});
var ConsolePostCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePostCreate_viewModel_templateObject());
var POST_CATEGORY_QUERY = (0,lib/* gql */.Ps)(ConsolePostCreate_viewModel_templateObject1());
var CREATE_POST = (0,lib/* gql */.Ps)(ConsolePostCreate_viewModel_templateObject2(), utoniq_core_schema/* PostBoxFragmentDoc */.cSz);

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostCreate/index.tsx




/**
 * ConsolePostCreate Page
 * Implemented as a practical sample.
 */ var ConsolePostCreate = function() {
    var ref = ConsolePostCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/post/PostDetailBox/index.tsx




var PostDetailBox = function(param) {
    var post = param.post, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, onLike = param.onLike, onBlockArtist = param.onBlockArtist, onReportArtist = param.onReportArtist, onReply = param.onReply, isConsole = param.isConsole, onDeletePost = param.onDeletePost, loadingDeletePost = param.loadingDeletePost, userId = param.userId, _enableEmbedHtml = param.enableEmbedHtml, enableEmbedHtml = _enableEmbedHtml === void 0 ? false : _enableEmbedHtml, onClickShare = param.onClickShare, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, _detail = param.detail, detail = _detail === void 0 ? true : _detail;
    var mediaSxProps = (0,react.useMemo)(function() {
        switch(post === null || post === void 0 ? void 0 : post.resourceType){
            case utoniq_core_schema/* PostType.Sound */.hQF.Sound:
                return {
                    height: "fit-content"
                };
            case utoniq_core_schema/* PostType.Image */.hQF.Image:
                return {
                    height: "100%"
                };
            default:
                return responsive ? {
                    maxHeight: 532
                } : {
                    height: 266
                };
        }
    }, [
        post === null || post === void 0 ? void 0 : post.resourceType,
        responsive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, {
        isConsole: isConsole,
        post: post,
        isMembershipPersonalInformationRequired: isMembershipPersonalInformationRequired,
        userId: userId,
        fullWidth: true,
        fullContent: true,
        responsive: responsive,
        detail: detail,
        loadingDeletePost: loadingDeletePost,
        mediaProps: {
            sx: mediaSxProps
        },
        sx: {
            borderRadius: 0,
            backgroundColor: "transparent",
            backgroundImage: "unset",
            boxShadow: "none",
            iframe: {
                height: responsive ? undefined : 266
            }
        },
        enableEmbedHtml: enableEmbedHtml,
        clickable: false,
        onLike: onLike,
        onReply: onReply,
        onBlockArtist: onBlockArtist,
        onDeletePost: onDeletePost,
        onReportArtist: onReportArtist,
        onClickShare: onClickShare
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/post/PostDetailBoxSkeleton/index.tsx





var PostDetailBoxSkeleton = function(param) {
    var sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: (0,src_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 266
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    px: 5,
                    pt: 5,
                    pb: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        flex: 1,
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "25%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pb: 7
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "medium",
                            numberOfLine: 3,
                            lastWidth: "75%"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/reply/ReplyBoxSkeleton/index.tsx



var ReplyBoxSkeleton = function(param) {
    var divider = param.divider;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                direction: "row",
                spacing: 2,
                sx: {
                    pb: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "circular",
                            width: 28,
                            height: 28
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "25%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    pt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    numberOfLine: 3,
                                    lastWidth: "75%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    pt: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "25%"
                                })
                            })
                        ]
                    })
                ]
            }),
            divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 1
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/reply/ReplyBox/index.tsx










var ReplyBox = function(param) {
    var index = param.index, type = param.type, typeId = param.typeId, userId = param.userId, showReaction = param.showReaction, hiddenReply = param.hiddenReply, divider = param.divider, comment = param.comment, onDeleteComment = param.onDeleteComment, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onReplyToReply = param.onReplyToReply, onClickReply = param.onClickReply, rootCollectionId = param.rootCollectionId, unreadIndex = param.unreadIndex, _disableLikes = param.disableLikes, disableLikes = _disableLikes === void 0 ? false : _disableLikes;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), router = ref7.router, routerPages = ref7.routerPages, generatePath = ref7.generatePath;
    var ref8 = (0,react.useState)(false), open = ref8[0], setOpen = ref8[1];
    var ref9 = (0,react.useState)(false), openFullScreen = ref9[0], setOpenFullScreen = ref9[1];
    var userComment = (0,react.useMemo)(function() {
        return isComment(comment) ? comment.commenter : comment.responder;
    }, [
        comment
    ]);
    var showNew = (0,react.useMemo)(function() {
        return !isNaN(Number(unreadIndex)) && unreadIndex === index;
    }, [
        index,
        unreadIndex
    ]);
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var handleDeleteReply = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onDeleteComment(comment.id).then(function(hiddenMessage) {
                            return !hiddenMessage && showMessage(t("deleteReply"), "success");
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onDeleteComment,
        showMessage,
        t,
        comment
    ]);
    var handleReportUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onReportUser(comment.id, (ref = userComment === null || userComment === void 0 ? void 0 : userComment.id) !== null && ref !== void 0 ? ref : "", (ref1 = userComment === null || userComment === void 0 ? void 0 : userComment.formattedAccountId) !== null && ref1 !== void 0 ? ref1 : "")
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        comment.id,
        onReportUser,
        userComment === null || userComment === void 0 ? void 0 : userComment.formattedAccountId,
        userComment === null || userComment === void 0 ? void 0 : userComment.id, 
    ]);
    var handleBlockUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onBlockUser((ref = userComment === null || userComment === void 0 ? void 0 : userComment.id) !== null && ref !== void 0 ? ref : "").then(function(hiddenMessage) {
                            return !hiddenMessage && showMessage(t("blockUserSuccess"), "success");
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onBlockUser,
        showMessage,
        t,
        userComment
    ]);
    var imageUrl = isComment(comment) ? (ref = comment.resources) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.uri : null;
    // リプライを持つ親コメントかどうか
    var isReplyParent = !hiddenReply && isCommentWithReplies(comment) && !!(comment === null || comment === void 0 ? void 0 : (ref2 = comment.replies) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.edges) === null || ref3 === void 0 ? void 0 : ref3.length);
    if (!userComment) return null;
    var ref10, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            divider && showNew && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerNewStyled, {
                color: "like.tap",
                textAlign: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "like.tap",
                    children: "NEW"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                direction: "row",
                spacing: 2,
                sx: {
                    pb: 2,
                    position: "relative"
                },
                children: [
                    isReplyParent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                        sx: {
                            position: "absolute",
                            zIndex: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        },
                        onClick: function() {
                            if (type && typeId) {
                                router.push(generatePath(routerPages.ReplyDetail, {
                                    type: type,
                                    id: typeId,
                                    commentId: comment.id
                                }));
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            onClick: handleLoginModal(),
                            sx: {
                                position: "relative",
                                zIndex: 2
                            },
                            href: generatePath(routerPages.UserProfile, {
                                userId: (ref10 = userComment === null || userComment === void 0 ? void 0 : userComment.id) !== null && ref10 !== void 0 ? ref10 : "#"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref11 = userComment === null || userComment === void 0 ? void 0 : (ref4 = userComment.avatar) === null || ref4 === void 0 ? void 0 : ref4.smallUri) !== null && ref11 !== void 0 ? ref11 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            zInde: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                onClick: handleLoginModal(),
                                                href: generatePath(routerPages.UserProfile, {
                                                    userId: (ref12 = userComment === null || userComment === void 0 ? void 0 : userComment.id) !== null && ref12 !== void 0 ? ref12 : "#"
                                                }),
                                                sx: {
                                                    textDecoration: "none",
                                                    zIndex: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    color: "text.secondary",
                                                    children: userComment === null || userComment === void 0 ? void 0 : userComment.displayName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.hint",
                                                sx: {
                                                    pl: 2
                                                },
                                                children: comment.formattedCreatedAt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                        sx: {
                                            zIndex: 2
                                        },
                                        onClick: toggleDrawer(true)
                                    })
                                ]
                            }),
                            isComment(comment) && imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                onClick: function() {
                                    return setOpenFullScreen(true);
                                },
                                sx: {
                                    zIndex: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: imageUrl,
                                    sx: {
                                        width: "100%",
                                        height: 255,
                                        my: 1,
                                        borderRadius: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "grey.900",
                                    sx: {
                                        pt: 1,
                                        wordBreak: "break-all"
                                    },
                                    children: comment.content
                                })
                            }),
                            showReaction && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                                    onLikeOrUnlikeComment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 3,
                                        sx: {
                                            py: 2
                                        },
                                        children: [
                                            !disableLikes && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Like, {
                                                        size: "small",
                                                        liked: comment.isLike,
                                                        sx: {
                                                            zIndex: 2
                                                        },
                                                        onClick: handleLoginModal(function() {
                                                            return onLikeOrUnlikeComment && onLikeOrUnlikeComment({
                                                                commentId: comment.id,
                                                                id: rootCollectionId,
                                                                isLike: comment.isLike,
                                                                likeCount: comment.likeCount || 0
                                                            });
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        children: comment.likeCount || 0
                                                    })
                                                ]
                                            }),
                                            isComment(comment) && !hiddenReply && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Reply, {
                                                        size: "small",
                                                        sx: {
                                                            zIndex: 2
                                                        },
                                                        onClick: function() {
                                                            onClickReply();
                                                            if (onReplyToReply) {
                                                                onReplyToReply({
                                                                    accountId: (userComment === null || userComment === void 0 ? void 0 : userComment.accountId) || "",
                                                                    displayName: (userComment === null || userComment === void 0 ? void 0 : userComment.displayName) || "",
                                                                    commentId: comment.id || ""
                                                                });
                                                                return onClickReply();
                                                            }
                                                            if (type && typeId) {
                                                                return router.push(generatePath(routerPages.ReplyDetail, {
                                                                    type: type,
                                                                    id: typeId,
                                                                    commentId: comment.id
                                                                }));
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        children: comment.replyCount
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailFullScreenModal/* ThumbnailFullScreenModal */.e, {
                open: openFullScreen,
                onClose: function() {
                    return setOpenFullScreen(false);
                },
                resource: {
                    uri: imageUrl || ""
                }
            }),
            divider && unreadIndex != (index || 1) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "column-reverse",
                children: isCommentWithReplies(comment) && (comment === null || comment === void 0 ? void 0 : (ref5 = comment.replies) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.edges) === null || ref6 === void 0 ? void 0 : ref6.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pt: 5,
                            pl: "36px",
                            bgcolor: undefined
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyBox, {
                            userId: userId,
                            comment: node,
                            divider: true,
                            showReaction: true,
                            hiddenReply: true,
                            onReportUser: onReportUser,
                            onBlockUser: onBlockUser,
                            onDeleteComment: onDeleteComment,
                            rootCollectionId: rootCollectionId,
                            onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                            onReplyToReply: onReplyToReply,
                            onClickReply: onClickReply
                        })
                    }, node.id);
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: (ref13 = userComment === null || userComment === void 0 ? void 0 : userComment.displayName) !== null && ref13 !== void 0 ? ref13 : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            (userComment === null || userComment === void 0 ? void 0 : userComment.id) === userId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                    component: Box_Box/* default */.Z,
                                    sx: {
                                        height: 52
                                    },
                                    divider: true,
                                    onClick: handleLoginModal(handleDeleteReply),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("delete")
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Box_Box/* default */.Z,
                                        sx: {
                                            height: 52
                                        },
                                        onClick: handleLoginModal(handleReportUser),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("report")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Box_Box/* default */.Z,
                                        sx: {
                                            height: 52
                                        },
                                        divider: true,
                                        onClick: handleLoginModal(handleBlockUser),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("block")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: toggleDrawer(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var DividerNewStyled = (0,styled/* default */.ZP)(Divider_Divider/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        "&::before": {
            width: "100%",
            borderColor: theme.palette.like["tap"]
        },
        "&::after": {
            width: 0
        }
    };
});
function isComment(commentOrReply) {
    return "commenter" in commentOrReply;
}
function isCommentWithReplies(commentOrReply) {
    return "commenter" in commentOrReply;
}

;// CONCATENATED MODULE: ./src/components/organisms/community/CommentList/index.tsx













var CommentList = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var type = param.type, typeId = param.typeId, user = param.user, comments = param.comments, loading = param.loading, onToggleButtonComment = param.onToggleButtonComment, showReaction = param.showReaction, hiddenHeader = param.hiddenHeader, _hiddenNotice = param.hiddenNotice, hiddenNotice = _hiddenNotice === void 0 ? true : _hiddenNotice, hiddenReply = param.hiddenReply, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, onDeleteComment = param.onDeleteComment, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onReplyToReply = param.onReplyToReply, onClickReply = param.onClickReply, _commentCount = param.commentCount, commentCount = _commentCount === void 0 ? 0 : _commentCount, rootCollectionId = param.rootCollectionId, unreadIndex = param.unreadIndex, hiddenReadMore = param.hiddenReadMore, onHiddenReadMore = param.onHiddenReadMore, inverted = param.inverted, _disableLikes = param.disableLikes, disableLikes = _disableLikes === void 0 ? false : _disableLikes, replyFormProps = param.replyFormProps;
    var _$ref, _$ref1, _$ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var scrollBottomRef = (0,react.useRef)(null);
    var _$ref3, _$ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        ref: ref,
        sx: {
            px: 5
        },
        children: [
            !hiddenHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            children: t("comment")
                        }),
                        !!(comments === null || comments === void 0 ? void 0 : (_$ref = comments.edges) === null || _$ref === void 0 ? void 0 : _$ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "text.hint",
                            children: commentCount !== null && commentCount !== void 0 ? commentCount : comments === null || comments === void 0 ? void 0 : (_$ref1 = comments.edges) === null || _$ref1 === void 0 ? void 0 : _$ref1.length
                        })
                    ]
                })
            }),
            !hiddenNotice && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeTextCell, {}),
            replyFormProps && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mb: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyForm/* ReplyForm */.I, (0,src_object_spread/* default */.Z)({}, replyFormProps))
            }),
            onToggleButtonComment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        fullWidth: true,
                        sx: {
                            borderRadius: 0,
                            px: 0,
                            py: 3
                        },
                        onClick: onToggleButtonComment,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: (_$ref3 = user === null || user === void 0 ? void 0 : (_$ref2 = user.avatar) === null || _$ref2 === void 0 ? void 0 : _$ref2.smallUri) !== null && _$ref3 !== void 0 ? _$ref3 : "",
                                    sx: {
                                        width: 28,
                                        height: 28
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "text.disabled",
                                    children: t("sendComment")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                inverted: inverted,
                componentProps: (0,src_object_spread/* default */.Z)({
                    spacing: 5
                }, replyFormProps && {
                    // 画面右側に表示する場合はコメント入力欄以下のみでスクロールするようにする
                    maxHeight: "1400px",
                    overflow: "auto"
                }),
                nodes: comments === null || comments === void 0 ? void 0 : comments.edges.map(function(param, index) {
                    var node = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ReplyBox, {
                        index: index,
                        type: type,
                        typeId: typeId,
                        comment: node,
                        divider: true,
                        showReaction: showReaction,
                        userId: (_$ref4 = user === null || user === void 0 ? void 0 : user.id) !== null && _$ref4 !== void 0 ? _$ref4 : "",
                        onDeleteComment: onDeleteComment,
                        onReportUser: onReportUser,
                        onBlockUser: onBlockUser,
                        onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                        rootCollectionId: rootCollectionId,
                        onReplyToReply: onReplyToReply,
                        onClickReply: onClickReply,
                        hiddenReply: hiddenReply,
                        unreadIndex: unreadIndex,
                        disableLikes: disableLikes
                    }, node.id);
                }),
                emptyMessage: t("emptyReplyMessage"),
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    sx: {
                        pt: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyBoxSkeleton, {
                            divider: true
                        }, index);
                    })
                })
            }),
            hiddenReadMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: function() {
                            var _$ref;
                            scrollBottomRef === null || scrollBottomRef === void 0 ? void 0 : (_$ref = scrollBottomRef.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView({
                                behavior: "smooth",
                                block: "end",
                                inline: "nearest"
                            });
                            onHiddenReadMore && onHiddenReadMore();
                        },
                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                fontSize: "xSmall",
                                sx: {
                                    color: "text.primary"
                                }
                            })
                        }),
                        sx: {
                            position: "absolute",
                            bottom: 12,
                            zIndex: 3,
                            mb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
                            width: "fit-content",
                            py: 1,
                            bgcolor: "grey.100",
                            left: "50%",
                            transform: "translate(-50%, 0)",
                            "&:hover": {
                                bgcolor: "grey.200"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: t("unreadComments")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: scrollBottomRef
                    })
                ]
            })
        ]
    });
});
var NoticeTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                        variant: "caption",
                        href: (0,helpUrl/* getHelpUrl */.R)("thread"),
                        children: t("noticePrefix")
                    }),
                    t("noticeSuffix")
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostDetail/template/index.tsx









var ConsolePostDetailTemplate = function(param) {
    var state = param.state, onLike = param.onLike, onReply = param.onReply, onFetchMore = param.onFetchMore, onDeleteReply = param.onDeleteReply, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onDeletePost = param.onDeletePost;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref4.routerNames, routerPages = ref4.routerPages;
    var ref5 = (0,react.useState)(true), showReply = ref5[0], setShowReply = ref5[1];
    var replyFormRef = (0,react.useRef)(null);
    var shouldShowReplyForm = !state.disableReplies && showReply;
    var ref6, ref7, ref8, _user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePostDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsolePost,
                    color: "white"
                },
                customNavigation: shouldShowReplyForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyForm/* ReplyForm */.I, {
                    onReply: onReply,
                    userId: (ref6 = (ref = state.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref6 !== void 0 ? ref6 : "",
                    ref: replyFormRef
                }) : null,
                children: [
                    !state.loading && (state === null || state === void 0 ? void 0 : state.post) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailBox, {
                            isConsole: true,
                            userId: (ref7 = (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref7 !== void 0 ? ref7 : "",
                            post: state.post,
                            loadingDeletePost: state.loadingDeletePost,
                            enableEmbedHtml: true,
                            onDeletePost: onDeletePost,
                            onLike: function() {
                                if (!state.post) return;
                                onLike(!!(state === null || state === void 0 ? void 0 : state.post.isLike), state === null || state === void 0 ? void 0 : state.post.likeCount);
                            },
                            onReply: function() {
                                return setShowReply(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailBoxSkeleton, {}),
                    !state.disableReplies && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                        showReaction: true,
                        commentCount: (ref2 = state.post) === null || ref2 === void 0 ? void 0 : ref2.replyCount,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        comments: (ref8 = (ref3 = state.post) === null || ref3 === void 0 ? void 0 : ref3.replies) !== null && ref8 !== void 0 ? ref8 : null,
                        user: (_user = state.user) !== null && _user !== void 0 ? _user : null,
                        onFetchMore: onFetchMore,
                        onDeleteComment: onDeleteReply,
                        onReportUser: onReportUser,
                        onBlockUser: onBlockUser,
                        hiddenNotice: true,
                        onClickReply: function() {},
                        onReplyToReply: function() {}
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostDetail/viewModel.ts




function ConsolePostDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePostDetail($postId: ID!, $pageInput: PageInput) {\n    post(id: $postId) {\n      ...PostBox\n      replies(pageInput: $pageInput) {\n        ...RepliesConnection\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      displayName\n      avatar {\n        uri\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsolePostDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePostDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeletePost($postId: ID!) {\n    deletePost(postId: $postId) {\n      ...PostBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePostDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ConsolePostDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, routerPages = ref6.routerPages;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref7 = (0,useQuery/* useQuery */.aM)(ConsolePostDetail_viewModel_QUERY, {
        variables: {
            postId: router.query.postId
        }
    }), data = ref7.data, networkStatus = ref7.networkStatus, fetchMore = ref7.fetchMore, refetch = ref7.refetch;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ReplyPost */.uhm), 1), replyPost = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_POST, {
        onCompleted: function onCompleted() {
            router.goBack(routerPages.ConsolePost);
        }
    }), 2), deletePost = ref10[0], ref11 = ref10[1], loadingDeletePost = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeletePostReply */.A9X), 1), deletePostReply = ref12[0];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikePost */.UsN), 1), unlikePost = ref13[0];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikePost */.UEr), 1), likePost = ref14[0];
    var ref15, ref16, ref17;
    return {
        state: {
            artistId: (ref15 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref15 !== void 0 ? ref15 : "",
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            loadingDeletePost: loadingDeletePost,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            post: (ref16 = data === null || data === void 0 ? void 0 : data.post) !== null && ref16 !== void 0 ? ref16 : null,
            user: (ref17 = data === null || data === void 0 ? void 0 : data.user) !== null && ref17 !== void 0 ? ref17 : null,
            disableReplies: !!((ref3 = data === null || data === void 0 ? void 0 : (ref2 = data.post) === null || ref2 === void 0 ? void 0 : ref2.artist.settings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.features) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.post) === null || ref5 === void 0 ? void 0 : ref5.disableReplies)
        },
        actions: {
            onLike: function onLike(isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: router.query.postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: router.query.postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReply: function onReply(param) {
                var content = param.content;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    replyPost({
                                        variables: {
                                            replyPostInputs: {
                                                postId: router.query.postId,
                                                content: content
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            postId: router.query.postId,
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteReply: function onDeleteReply(replyId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePostReply({
                                        variables: {
                                            deletePostReplyId: replyId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "post-replies",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        postId: router.query.postId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeletePost: function onDeletePost(postId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePost({
                                        variables: {
                                            postId: postId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsolePostDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePostDetail_viewModel_templateObject(), utoniq_core_schema/* RepliesConnectionFragmentDoc */.Q1X, utoniq_core_schema/* PostBoxFragmentDoc */.cSz);
var DELETE_POST = (0,lib/* gql */.Ps)(ConsolePostDetail_viewModel_templateObject1(), utoniq_core_schema/* PostBoxFragmentDoc */.cSz);

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostDetail/index.tsx




/**
 * ConsolePostDetail Page
 * Implemented as a practical sample.
 */ var ConsolePostDetail = function() {
    var ref = ConsolePostDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostEdit/template/PostEditConfirmModal.tsx




var PostEditConfirmModal = function(param) {
    var open = param.open, onClose = param.onClose, onClick = param.onClick, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostEdit").t;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("confirmEditTitle"),
        content: null,
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            onClick: onClick,
            loading: loading,
            disabled: loading,
            children: t("toUpdate")
        }),
        cancelText: t("cancel"),
        sx: {
            zIndex: zIndex.modal + 2
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostEdit/template/PostEditForm.tsx


















var PostEditForm_schema = function(o) {
    return {
        content: o.string().max(10000).label((0,core_form/* tLabel */.TQ)("consolePostEdit.content")),
        categoryId: o.string().optional().label((0,core_form/* tLabel */.TQ)("consolePostEdit.categoryId")),
        membershipAccessPermission: o.string().label((0,core_form/* tLabel */.TQ)("consolePostCreate.membershipAccessPermission")),
        publishedAt: o.date().allow(null).optional().label((0,core_form/* tLabel */.TQ)("consolePostEdit.publishedAt"))
    };
};
// カテゴリリストの初期値
var PostEditForm_defaultCategory = {
    none: "noneCategory"
};
// ポスト公開範囲リストの初期値
var PostEditForm_defaultPermission = {
    allUser: "allUser",
    allMember: "allMember"
};
var PostEditForm_defaultValues = {
    content: "",
    membershipAccessPermission: PostEditForm_defaultPermission.allUser,
    categoryId: PostEditForm_defaultCategory.none
};
var PostEditForm = function(param) {
    var post = param.post, onSubmitPostEdit = param.onSubmitPostEdit, artistId = param.artistId, plans = param.plans, loadingEditPost = param.loadingEditPost, categories = param.categories;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostEdit").t;
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref2.showMessage, showError = ref2.showError;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages;
    var ref4;
    var ref5 = (0,core_form/* useForm */.cI)({
        schema: PostEditForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, PostEditForm_defaultValues), {
            categoryId: (ref4 = (ref = post.category) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : PostEditForm_defaultCategory.none
        })
    }), handleSubmit = ref5.handleSubmit, _formState = ref5.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref5.register, reset = ref5.reset, watch = ref5.watch, setValue = ref5.setValue, setError = ref5.setError, getValues = ref5.getValues;
    var _ref = register("membershipAccessPermission"), ref6 = _ref.ref, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "ref"
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var ref3;
        var rawPermission = post.isPremium ? post.planId ? (ref3 = (ref = plans.find(function(plan) {
            return (plan === null || plan === void 0 ? void 0 : plan.planId) === post.planId;
        })) === null || ref === void 0 ? void 0 : ref.planId) !== null && ref3 !== void 0 ? ref3 : PostEditForm_defaultPermission.allMember : PostEditForm_defaultPermission.allMember : PostEditForm_defaultPermission.allUser;
        var ref4;
        reset({
            content: (ref4 = post === null || post === void 0 ? void 0 : post.content) !== null && ref4 !== void 0 ? ref4 : "",
            membershipAccessPermission: rawPermission,
            publishedAt: post === null || post === void 0 ? void 0 : post.publishedAt,
            categoryId: ((ref1 = post.category) === null || ref1 === void 0 ? void 0 : ref1.id) ? (ref2 = post.category) === null || ref2 === void 0 ? void 0 : ref2.id : PostEditForm_defaultCategory.none
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        post.publishedAt,
        post.content,
        post.planId,
        (ref1 = post.category) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    var ref7 = (0,react.useState)(), confirmModal = ref7[0], setConfirmModal = ref7[1];
    var onEditPost = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var confirmed, _ref, membershipAccessPermission, inputs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(resolve) {
                                setConfirmModal({
                                    confirmAction: resolve
                                });
                            })
                        ];
                    case 1:
                        confirmed = _state.sent();
                        // キャンセルされた場合、モーダルを閉じて終了
                        if (!confirmed) {
                            setConfirmModal(undefined);
                            return [
                                2
                            ];
                        }
                        _ref = getValues(), membershipAccessPermission = _ref.membershipAccessPermission, inputs = (0,_object_without_properties/* default */.Z)(_ref, [
                            "membershipAccessPermission"
                        ]);
                        return [
                            2,
                            onSubmitPostEdit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                /**
       * 公開範囲のキーからisPremiumとplanIdの値をミューテーション引数に割り当てる
       * プランを指定しない場合はplanId: nullになる
       */ isPremium: membershipAccessPermission !== PostEditForm_defaultPermission.allUser,
                                planId: Object.values(PostEditForm_defaultPermission).includes(membershipAccessPermission) ? null : membershipAccessPermission,
                                // カテゴリIDがnoneCategoryの場合はカテゴリ未指定としてnullを渡す
                                categoryId: inputs.categoryId === PostEditForm_defaultCategory.none ? null : inputs.categoryId
                            })).then(function() {
                                showMessage(t("completeEdit"));
                                inputs.publishedAt ? router.replace(routerPages.ConsoleUnpublishedPosts) : router.push(routerPages.ConsolePost);
                            }).catch(function(e) {
                                (0,core_errors/* captureError */.O)(e, "ConsolePostEdit");
                                (0,core_form/* handleError */.S3)(e, setError, showError);
                            }).finally(function() {
                                setConfirmModal(undefined);
                            })
                        ];
                }
            });
        });
        return function onEditPost() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8, ref9, ref10, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                onSubmit: handleSubmit(onEditPost),
                sx: {
                    p: 5
                },
                children: [
                    (post.resourceType === utoniq_core_schema/* PostType.Video */.hQF.Video || post.resourceType === utoniq_core_schema/* PostType.Image */.hQF.Image) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        sx: {
                            mb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("postCategory")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            onClick: function() {
                                                return router.push(routerPages.ConsolePostCategories);
                                            },
                                            sx: {
                                                textAlign: "right",
                                                alignItems: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: t("editCategory")
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                listItems: (0,src_to_consumable_array/* default */.Z)(Object.values(PostEditForm_defaultCategory).map(function(value) {
                                    return {
                                        value: value,
                                        label: t(value)
                                    };
                                })).concat((0,src_to_consumable_array/* default */.Z)(categories ? categories.map(function(category) {
                                    return {
                                        value: (ref8 = category === null || category === void 0 ? void 0 : category.id) !== null && ref8 !== void 0 ? ref8 : "",
                                        label: (ref9 = category === null || category === void 0 ? void 0 : category.name) !== null && ref9 !== void 0 ? ref9 : ""
                                    };
                                }) : [])),
                                value: watch("categoryId"),
                                onChange: function(value) {
                                    setValue("categoryId", value);
                                },
                                formControlProps: {
                                    sx: {
                                        width: "100%",
                                        bgcolor: "grey.50",
                                        minHeight: "auto",
                                        mb: 16
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                        type: "textarea",
                        textFieldProps: {
                            variant: "standard",
                            multiline: true,
                            minRows: 5,
                            maxRows: 12,
                            InputProps: {
                                sx: {
                                    px: 0,
                                    pt: 2,
                                    bgcolor: "background.default"
                                },
                                disableUnderline: true
                            }
                        },
                        titleProps: {
                            variant: "h5",
                            color: "text.primary"
                        },
                        error: errors === null || errors === void 0 ? void 0 : errors.content
                    }, register("content"))),
                    !!(post === null || post === void 0 ? void 0 : post.publishedAt) && (post === null || post === void 0 ? void 0 : post.status) != utoniq_core_schema/* PostStatus.Published */.$4T.Published && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostEditForm_ReserveInputCell, {
                        artistId: artistId,
                        setValue: setValue,
                        value: watch("publishedAt")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        sx: {
                            mb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    mb: 2
                                },
                                children: t("membershipAccessPermission")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                listItems: (0,src_to_consumable_array/* default */.Z)(Object.values(PostEditForm_defaultPermission).map(function(value) {
                                    return {
                                        value: value,
                                        label: t(value)
                                    };
                                })).concat((0,src_to_consumable_array/* default */.Z)(plans.map(function(plan) {
                                    return (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? {
                                        value: (ref10 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref10 !== void 0 ? ref10 : "",
                                        label: t("planOnlyYear", {
                                            name: (ref11 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref11 !== void 0 ? ref11 : ""
                                        })
                                    } : {
                                        value: (ref12 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref12 !== void 0 ? ref12 : "",
                                        label: t("planOnly", {
                                            name: (ref13 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref13 !== void 0 ? ref13 : ""
                                        })
                                    };
                                }))),
                                value: watch("membershipAccessPermission").toString(),
                                onChange: function(value) {
                                    setValue("membershipAccessPermission", value);
                                },
                                formControlProps: {
                                    sx: {
                                        width: "100%",
                                        bgcolor: "grey.50",
                                        minHeight: "auto",
                                        mb: 16
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostEditForm_ButtonCell, {
                        loading: loadingEditPost,
                        isReserve: !!watch("publishedAt")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostEditConfirmModal, {
                open: !!confirmModal,
                onClose: function() {
                    return confirmModal === null || confirmModal === void 0 ? void 0 : confirmModal.confirmAction(false);
                },
                onClick: function() {
                    return confirmModal === null || confirmModal === void 0 ? void 0 : confirmModal.confirmAction(true);
                },
                loading: loadingEditPost
            })
        ]
    });
};
var PostEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var PostEditForm_ReserveInputCell = function(param) {
    var artistId = param.artistId, setValue = param.setValue, value = param.value;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostCreate").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "text",
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                    sx: {
                        color: "primary.main"
                    }
                }),
                onClick: function() {
                    return setOpen(true);
                },
                sx: {
                    textAlign: "left",
                    alignItems: "flex-start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: value ? t("postPostedOn", {
                        date: values_Date/* DateTime.formatDate */.o.formatDate(value, "LL HH:mm") || "",
                        fallback: "このポストは{{-date}}に投稿されます。"
                    }) : t("postDateTime", "投稿日時を指定する")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostReserve, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                artistId: artistId,
                defaultValue: value,
                onSubmit: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(value) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            setValue("publishedAt", value.publishedAt);
                            return [
                                2
                            ];
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        ]
    });
};
var PostEditForm_ButtonCell = function(param) {
    var loading = param.loading, isReserve = param.isReserve;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: !isReserve ? t("submit") : t("reserve")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostEdit/template/index.tsx







var ConsolePostEditTemplate = function(param) {
    var state = param.state, onPostEdit = param.onPostEdit;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePostEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var _postId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePostEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.ConsolePostDetail, {
                        postId: (_postId = router.query.postId) !== null && _postId !== void 0 ? _postId : "#"
                    }),
                    title: t("title")
                },
                children: state.post && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostEditForm, {
                    artistId: state.artistId,
                    categories: state.categories,
                    onSubmitPostEdit: onPostEdit,
                    post: state.post,
                    plans: state.plans,
                    loadingEditPost: state.loadingEditPost
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostEdit/viewModel.ts






function ConsolePostEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePostEdit($postId: ID!, $pageInput: PageInput) {\n    post(id: $postId) {\n      ...PostBox\n      replies(pageInput: $pageInput) {\n        ...RepliesConnection\n      }\n    }\n    artist {\n      id\n      subscription {\n        plans {\n          planId\n          title\n          interval\n        }\n        products {\n          productId\n          title\n          plans {\n            interval\n            planId\n          }\n        }\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsolePostEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePostEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdatePost($postId: ID!, $inputs: UpdatePostInput!) {\n    updatePost(postId: $postId, inputs: $inputs) {\n      ...PostBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePostEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsolePostEdit_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query artistCategory {\n    artist {\n      id\n      postCategory {\n        categories {\n          id\n          name\n        }\n      }\n    }\n  }\n"
    ]);
    ConsolePostEdit_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ConsolePostEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var data = (0,useQuery/* useQuery */.aM)(ConsolePostEdit_viewModel_QUERY, {
        variables: {
            postId: router.query.postId
        }
    }).data;
    var ref6 = (0,useQuery/* useQuery */.aM)(viewModel_POST_CATEGORY_QUERY), artistPostCategory = ref6.data;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_POST), 2), updatePost = ref7[0], ref8 = ref7[1], loadingEditPost = ref8.loading;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7, ref8, ref9, ref10, ref11;
            if ((data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.products) === null || ref8 === void 0 ? void 0 : ref8.length) > 1) {
                var ref12, ref13;
                // productが複数あるときは全てのplanを返す
                return flatten_default()(data === null || data === void 0 ? void 0 : (ref12 = data.artist) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.subscription) === null || ref13 === void 0 ? void 0 : ref13.products.map(function(product) {
                    return product.plans.map(function(plan) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                            title: product.title
                        });
                    });
                }));
            }
            if ((data === null || data === void 0 ? void 0 : (ref9 = data.artist) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.products) === null || ref11 === void 0 ? void 0 : ref11.length) === 1) {
                var ref14, ref15;
                // NOTE: productが1件のみの場合、デフォルトの「メンバーシップ限定」と役割が重複するため表示するplanを制限する
                // https://app.clickup.com/t/908127/UT-23661
                return flatten_default()(data === null || data === void 0 ? void 0 : (ref14 = data.artist) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.subscription) === null || ref15 === void 0 ? void 0 : ref15.products.map(function(product) {
                    if (product.plans.length > 1) {
                        // product1件で月額と年額のplanがあるときは年額のplanだけ返し月額のplanは表示しない
                        return product.plans.filter(function(plan) {
                            return plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year;
                        }).map(function(plan) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                                title: product.title
                            });
                        });
                    } else {
                        // product1件でplanが1つのときはなにも返さずデフォルトの選択肢のみ表示する
                        return [];
                    }
                }));
            }
        }
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return data.artist.subscription.plans;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products
    ]);
    var categories = (0,react.useMemo)(function() {
        var ref, ref1;
        if (artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref = artistPostCategory.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.postCategory) === null || ref1 === void 0 ? void 0 : ref1.categories.length) {
            var ref2, ref3;
            return artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref2 = artistPostCategory.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.postCategory) === null || ref3 === void 0 ? void 0 : ref3.categories;
        }
        return [];
    }, [
        artistPostCategory === null || artistPostCategory === void 0 ? void 0 : (ref4 = artistPostCategory.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.postCategory) === null || ref5 === void 0 ? void 0 : ref5.categories
    ]);
    var ref9;
    return {
        state: {
            artistId: (ref9 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref9 !== void 0 ? ref9 : "",
            categories: categories,
            post: data === null || data === void 0 ? void 0 : data.post,
            plans: plans,
            loadingEditPost: loadingEditPost
        },
        actions: {
            onPostEdit: function onPostEdit(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, publishedAt, _publishedAt;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                publishedAt = undefined;
                                if ((data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : ref.status) === utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled) {
                                    ;
                                    publishedAt = (_publishedAt = inputs.publishedAt) !== null && _publishedAt !== void 0 ? _publishedAt : null;
                                }
                                return [
                                    4,
                                    updatePost({
                                        variables: {
                                            postId: router.query.postId,
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                                publishedAt: publishedAt
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsolePostEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePostEdit_viewModel_templateObject(), utoniq_core_schema/* RepliesConnectionFragmentDoc */.Q1X, utoniq_core_schema/* PostBoxFragmentDoc */.cSz);
var UPDATE_POST = (0,lib/* gql */.Ps)(ConsolePostEdit_viewModel_templateObject1(), utoniq_core_schema/* PostBoxFragmentDoc */.cSz);
var viewModel_POST_CATEGORY_QUERY = (0,lib/* gql */.Ps)(ConsolePostEdit_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ConsolePostEdit/index.tsx




/**
 * ConsolePostEdit Page
 * Implemented as a practical sample.
 */ var ConsolePostEdit = function() {
    var ref = ConsolePostEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePosts/viewModel.ts




function ConsolePosts_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePost(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceType: PostType\n    $resourceTypes: [PostType!]\n    $storyFilter: StoryFilter\n    $status: [PostStatus]\n  ) {\n    artist(id: $artistId) {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceType: $resourceType\n        resourceTypes: $resourceTypes\n        storyFilter: $storyFilter\n        status: $status\n      ) {\n        ...ArtistPosts\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePosts_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ConsolePosts_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref6;
    var ref7 = (0,useQuery/* useQuery */.aM)(ConsolePosts_viewModel_QUERY, {
        variables: {
            artistId: (ref6 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref6 !== void 0 ? ref6 : "",
            status: [
                utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled,
                utoniq_core_schema/* PostStatus.Published */.$4T.Published
            ],
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            pageInput: {
                limit: 10
            },
            pageInputById: {
                limit: 10
            }
        },
        notifyOnNetworkStatusChange: true
    }), data = ref7.data, fetchMore = ref7.fetchMore, refetch = ref7.refetch, networkStatus = ref7.networkStatus;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeletePost */.x92), 2), deletePost = ref8[0], ref9 = ref8[1], loadingDeletePost = ref9.loading;
    var ref10, ref11, ref12, ref13;
    return {
        state: {
            user: user,
            userId: (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) || "",
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            loadingDeletePost: loadingDeletePost,
            artist: (ref11 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref11 !== void 0 ? ref11 : null,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            posts: (ref12 = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.posts) !== null && ref12 !== void 0 ? ref12 : null,
            membership: (ref13 = data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription) === null || ref5 === void 0 ? void 0 : ref5.products) !== null && ref13 !== void 0 ? ref13 : undefined
        },
        actions: {
            onFilter: function onFilter(resourceType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        artistId: (ref = user === null || user === void 0 ? void 0 : user.uid) !== null && ref !== void 0 ? ref : "",
                                        resourceType: resourceType.type,
                                        resourceTypes: resourceType.types,
                                        storyFilter: resourceType.storyFilter,
                                        status: [
                                            utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled,
                                            utoniq_core_schema/* PostStatus.Published */.$4T.Published
                                        ]
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
                                            status: [
                                                utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled,
                                                utoniq_core_schema/* PostStatus.Published */.$4T.Published
                                            ],
                                            // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.posts) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor) || null
                                            },
                                            pageInputById: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.posts) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeletePost: function onDeletePost(postId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePost({
                                        variables: {
                                            postId: postId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsolePosts_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePosts_viewModel_templateObject(), utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);

;// CONCATENATED MODULE: ./src/components/pages/ConsolePosts/index.tsx




/**
 * ConsolePosts Page
 * Implemented as a practical sample.
 */ var ConsolePosts = function() {
    var ref = ConsolePosts_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePostsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/components/DatePickerCell.tsx









var DatePickerCell_DatePickerCell = function(_param) {
    var setValue = _param.setValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setValue"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    var value = (0,react.useMemo)(function() {
        return props.value ? dayjs_min_default()(props.value) : null;
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DateTimePickerField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            onChange: function(date) {
                // @ts-ignore
                setValue(props.name, (0,dayjs/* convertDatePickerValueToDate */.TY)(date), {
                    shouldValidate: true,
                    shouldDirty: true
                });
            }
        }, props), {
            value: value,
            title: t("".concat(props.name, "Title")),
            placeholder: t("".concat(props.name, "Placeholder")),
            description: props.desc,
            textFieldProps: {
                label: props.error ? t("error") : ""
            },
            titleProps: {
                variant: props.name === "resultNoticedAt" ? "h5" : "subtitle1",
                color: "text.primary"
            }
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/components/PaymentMethodsInputCell.tsx




var paymentMethodsValue = {
    both: "both",
    konbini: "konbini",
    credit_card: "credit_card"
};
var PaymentMethodsInputCell = function(param) {
    var setValue = param.setValue, disabled = param.disabled, paymentMethods = param.paymentMethods;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: t("paymentMethodsTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    pt: 2
                },
                children: t("paymentMethodsDesc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                onChange: function(_, value) {
                    // @ts-ignore
                    setValue("paymentMethods", value, {
                        shouldDirty: true
                    });
                },
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                    mt: 1
                },
                value: paymentMethods,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        disabled: disabled,
                        value: paymentMethodsValue.both,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consolePreSaleCreate.paymentMethodsType.both")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        disabled: disabled,
                        value: paymentMethodsValue.credit_card,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consolePreSaleCreate.paymentMethodsType.credit_card")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        disabled: disabled,
                        value: paymentMethodsValue.konbini,
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                        label: (0,core_form/* tLabel */.TQ)("consolePreSaleCreate.paymentMethodsType.konbini")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/components/TextInputCell.tsx








var TextInputCell_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var titleProps = _param.titleProps, textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "titleProps",
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            titleProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, titleProps), {
                variant: "h5",
                color: "text.primary"
            }),
            textFieldProps: textFieldProps,
            ref: ref
        }, props), {
            error: error,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/components/ToggleInputCell.tsx








var ToggleInputCell_ToggleInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var sx = _param.sx, description = _param.description, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sx",
        "description"
    ]);
    return (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ToggleInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                inputRef: ref,
                sx: {
                    px: 0,
                    pt: 0,
                    "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                        bgcolor: "primary.main"
                    }
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                children: description
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/FirstComeFirstServedCreateForm.tsx













var FirstComeFirstServedCreateForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.title")).required(),
        description: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.description")).required(),
        note: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.note")).required(),
        purchasableCount: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableCount")).max(8).required(),
        paymentMethods: o.string().optional().label("consolePreSaleCreate.paymentMethods"),
        purchasableStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableStartedAt")).required(),
        purchasableEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableEndedAt")).required(),
        isPublished: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPublished")),
        startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.startedAt")).required(),
        endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.endedAt")).required(),
        isPremium: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPremium")),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.membershipAccessPermission")).items(o.string()).optional().default([])
    };
};
var FirstComeFirstServedCreateForm = function(param) {
    var onSubmit = param.onSubmit, submitting = param.submitting, plans = param.plans;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: FirstComeFirstServedCreateForm_schema,
        defaultValues: FirstComeFirstServedCreateForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref.register, setValue = ref.setValue, reset = ref.reset, watch = ref.watch;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var isFormValid = isValid && !showError;
    var ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmit),
        sx: {
            pt: 6,
            pb: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.note
            }, register("note"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors.purchasableCount,
                textFieldProps: {
                    placeholder: t("firstComePurchasableCountPlaceholder")
                }
            }, register("purchasableCount"))),
            plans && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mt: 7
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("membershipAccessPermission")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mb: 2
                                        },
                                        children: t("membershipAccessPermissionDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                    sx: {
                                        "&& .Mui-disabled + .MuiSwitch-track": {
                                            bgcolor: "grey.100"
                                        },
                                        "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                            bgcolor: "primary.main"
                                        }
                                    },
                                    checked: (ref2 = watch("isPremium")) !== null && ref2 !== void 0 ? ref2 : false,
                                    onChange: function() {
                                        if (watch("isPremium")) {
                                            setValue("purchesablePlanIds", [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", false, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        } else {
                                            setValue("purchesablePlanIds", plans.map(function(plan) {
                                                return (plan === null || plan === void 0 ? void 0 : plan.planId) || "";
                                            }), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", !watch("isPremium"), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    watch("isPremium") && plans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        error: showError,
                        sx: {
                            mt: 2
                        },
                        children: [
                            plans.map(function(plan, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        label: (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? t("planOnlyYear", {
                                            name: (ref3 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref3 !== void 0 ? ref3 : ""
                                        }) : (ref4 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref4 !== void 0 ? ref4 : "",
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: function(e) {
                                                var currentPlanIds = (watch("purchesablePlanIds") || []).filter(function(id) {
                                                    return id !== null;
                                                });
                                                if (e.target.checked) {
                                                    var ref;
                                                    // チェックされた場合、planIdを追加
                                                    setValue("purchesablePlanIds", (0,src_to_consumable_array/* default */.Z)(currentPlanIds).concat([
                                                        (ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : ""
                                                    ]));
                                                } else {
                                                    // チェックが解除された場合、planIdを削除
                                                    setValue("purchesablePlanIds", currentPlanIds.filter(function(id) {
                                                        return id !== (plan === null || plan === void 0 ? void 0 : plan.planId);
                                                    }));
                                                }
                                            },
                                            checked: ((ref = watch("purchesablePlanIds")) === null || ref === void 0 ? void 0 : ref.includes((ref5 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref5 !== void 0 ? ref5 : "")) || false
                                        })
                                    }, plan === null || plan === void 0 ? void 0 : plan.planId)
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "error.main",
                                children: showError ? t("membershipAccessPermissionRequired") : " "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsInputCell, {
                    paymentMethods: watch("paymentMethods"),
                    setValue: setValue
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4
                },
                children: t("purchasablePeriodFirstComeFirstServed")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableStartedAt",
                desc: t("purchasableStartedAtDesc"),
                error: errors.purchasableStartedAt,
                setValue: setValue,
                value: watch("purchasableStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableEndedAt",
                error: errors.purchasableEndedAt,
                setValue: setValue,
                value: watch("purchasableEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: t("isPublishedDesc")
                }
            }, register("isPublished"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "endedAt",
                error: errors.endedAt,
                setValue: setValue,
                value: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 5,
                    gap: 5
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: submitting,
                    disabled: !isFormValid || submitting,
                    children: t("submit")
                })
            })
        ]
    });
};
var FirstComeFirstServedCreateForm_defaultValues = {
    paymentMethods: "both",
    isPremium: false
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/LotteryCreateForm.tsx













var LotteryCreateForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.title")).required(),
        description: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.description")).required(),
        note: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.note")).required(),
        purchasableCount: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableCount")).min(1).max(99).required(),
        maxChoice: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.maxChoice")).required(),
        applicationStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.applicationStartedAt")).required(),
        applicationEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.applicationEndedAt")).required(),
        resultNoticedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.resultNoticedAt")).required(),
        paymentMethods: o.string().optional().label("consolePreSaleCreate.paymentMethods"),
        purchasableStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableStartedAt")).required(),
        purchasableEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableEndedAt")).required(),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.membershipAccessPermission")).items(o.string()).optional().default([]),
        isPublished: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPublished")),
        isPremium: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPremium")),
        startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.startedAt")).required(),
        endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.endedAt")).required()
    };
};
var LotteryCreateForm = function(param) {
    var onSubmit = param.onSubmit, submitting = param.submitting, plans = param.plans;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: LotteryCreateForm_schema,
        defaultValues: LotteryCreateForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref.register, setValue = ref.setValue, watch = ref.watch;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var isFormValid = isValid && !showError;
    var ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmit),
        sx: {
            pt: 6,
            pb: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.note
            }, register("note"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors.purchasableCount
            }, register("purchasableCount"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mb: 2
                },
                children: t("maxChoice")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    mb: 2
                },
                children: t("maxChoiceDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                listItems: [
                    {
                        value: "1",
                        label: "第1希望まで"
                    },
                    {
                        value: "2",
                        label: "第2希望まで"
                    },
                    {
                        value: "3",
                        label: "第3希望まで"
                    }, 
                ],
                value: watch("maxChoice").toString(),
                onChange: function(value) {
                    setValue("maxChoice", Number(value));
                },
                formControlProps: {
                    sx: {
                        width: "100%",
                        bgcolor: "grey.50",
                        minHeight: "auto",
                        mb: 16
                    }
                }
            }),
            plans && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mt: 7
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("membershipAccessPermission")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mt: 2
                                        },
                                        children: t("membershipAccessPermissionDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                    sx: {
                                        "&& .Mui-disabled + .MuiSwitch-track": {
                                            bgcolor: "grey.100"
                                        },
                                        "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                            bgcolor: "primary.main"
                                        }
                                    },
                                    checked: (ref2 = watch("isPremium")) !== null && ref2 !== void 0 ? ref2 : false,
                                    onChange: function() {
                                        if (watch("isPremium")) {
                                            setValue("purchesablePlanIds", [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", false, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        } else {
                                            setValue("purchesablePlanIds", plans.map(function(plan) {
                                                return (plan === null || plan === void 0 ? void 0 : plan.planId) || "";
                                            }), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", !watch("isPremium"), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    watch("isPremium") && plans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        error: showError,
                        sx: {
                            mt: 2
                        },
                        children: [
                            plans.map(function(plan, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        label: (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? t("planOnlyYear", {
                                            name: (ref3 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref3 !== void 0 ? ref3 : ""
                                        }) : (ref4 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref4 !== void 0 ? ref4 : "",
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: function(e) {
                                                var currentPlanIds = (watch("purchesablePlanIds") || []).filter(function(id) {
                                                    return id !== null;
                                                });
                                                if (e.target.checked) {
                                                    var ref;
                                                    // チェックされた場合、planIdを追加
                                                    setValue("purchesablePlanIds", (0,src_to_consumable_array/* default */.Z)(currentPlanIds).concat([
                                                        (ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : ""
                                                    ]));
                                                } else {
                                                    // チェックが解除された場合、planIdを削除
                                                    setValue("purchesablePlanIds", currentPlanIds.filter(function(id) {
                                                        return id !== (plan === null || plan === void 0 ? void 0 : plan.planId);
                                                    }));
                                                }
                                            },
                                            checked: ((ref = watch("purchesablePlanIds")) === null || ref === void 0 ? void 0 : ref.includes((ref5 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref5 !== void 0 ? ref5 : "")) || false
                                        })
                                    }, plan === null || plan === void 0 ? void 0 : plan.planId)
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "error.main",
                                children: showError ? t("membershipAccessPermissionRequired") : " "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4,
                    mt: 4
                },
                children: t("applicationPeriod")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "applicationStartedAt",
                desc: t("applicationStartedAtDesc"),
                error: errors.applicationStartedAt,
                setValue: setValue,
                value: watch("applicationStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "applicationEndedAt",
                error: errors.applicationEndedAt,
                setValue: setValue,
                value: watch("applicationEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "resultNoticedAt",
                desc: t("resultNoticedAtDesc"),
                error: errors.resultNoticedAt,
                setValue: setValue,
                value: watch("resultNoticedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsInputCell, {
                paymentMethods: watch("paymentMethods"),
                setValue: setValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4
                },
                children: t("purchasablePeriod")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableStartedAt",
                desc: t("purchasableStartedAtDesc"),
                error: errors.purchasableStartedAt,
                setValue: setValue,
                value: watch("purchasableStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableEndedAt",
                error: errors.purchasableEndedAt,
                setValue: setValue,
                value: watch("purchasableEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell_ToggleInputCell, (0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: t("isPublishedDesc")
                }
            }, register("isPublished"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "endedAt",
                error: errors.endedAt,
                setValue: setValue,
                value: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 5,
                    gap: 5
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: submitting,
                    disabled: !isFormValid || submitting,
                    children: t("submit")
                })
            })
        ]
    });
};
var LotteryCreateForm_defaultValues = {
    maxChoice: 1,
    paymentMethods: "both",
    isPremium: false
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/template/index.tsx












var ConsolePreSaleCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, generatePath = ref.generatePath, routerPages = ref.routerPages, router = ref.router;
    var _eventId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsolePreSaleCreate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    title: t("title"),
                    defaultBackPage: generatePath(routerPages.ConsoleShokufesEventDetail, {
                        eventId: (_eventId = router.query.eventId) !== null && _eventId !== void 0 ? _eventId : "#"
                    }),
                    back: true
                },
                margin: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        sx: {
                            py: 3,
                            mt: 5
                        },
                        children: t("".concat(state.preSaleType, "Title"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        component: "a",
                        target: "_blank",
                        href: (0,helpUrl/* getHelpUrl */.R)("preSale"),
                        variant: "caption",
                        sx: {
                            alignItems: "center",
                            display: "flex"
                        },
                        children: [
                            t("".concat(state.preSaleType, "Help")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                                fontSize: "xSmall",
                                color: "inherit",
                                sx: {
                                    ml: 1
                                }
                            })
                        ]
                    }),
                    state.preSaleType === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCreateForm, {
                        plans: state.plans,
                        submitting: state.submitting,
                        onSubmit: onSubmit
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedCreateForm, {
                        plans: state.plans,
                        submitting: state.submitting,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/viewModel.ts






function ConsolePreSaleCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation createPreSale($inputs: ArtistCreatePreSaleInput!) {\n    artistCreatePreSale(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ConsolePreSaleCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 *
 */ var ConsolePreSaleCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var ref5 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref5.showMessage, showError = ref5.showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleCreate").t;
    var preSaleType = (router.query || {}).preSaleType;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_PRE_SALE), 2), createPreSale = ref6[0], ref7 = ref6[1], submitting = ref7.loading;
    var data = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistSubscriptionPlan */.P6C).data;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7;
            return flatten_default()(data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : ref7.products.map(function(product) {
                return product.plans.map(function(plan) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                        title: product.title
                    });
                });
            }));
        }
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return data.artist.subscription.plans;
        }
        return [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : ref1.plans,
        data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products
    ]);
    return {
        state: {
            artistId: (user === null || user === void 0 ? void 0 : user.uid) || "",
            preSaleType: preSaleType,
            submitting: submitting,
            plans: plans
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                    var description, endedAt, isPublished, note, startedAt, title, purchesablePlanIds, isPremium;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                description = values.description, endedAt = values.endedAt, isPublished = values.isPublished, note = values.note, startedAt = values.startedAt, title = values.title, purchesablePlanIds = values.purchesablePlanIds, isPremium = values.isPremium;
                                return [
                                    4,
                                    createPreSale({
                                        variables: {
                                            inputs: {
                                                description: description,
                                                endedAt: endedAt,
                                                isPublished: isPublished,
                                                note: note,
                                                startedAt: startedAt,
                                                title: title,
                                                isPremium: isPremium,
                                                type: preSaleType === "firstComeFirstServed" ? utoniq_core_schema/* PreSaleType.FirstComeFirstServed */.osN.FirstComeFirstServed : utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery,
                                                paymentMethods: values.paymentMethods === "both" ? [
                                                    utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                                    utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini
                                                ] : [
                                                    values.paymentMethods
                                                ],
                                                lottery: preSaleType === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? {
                                                    applicationEndedAt: values.applicationEndedAt,
                                                    applicationStartedAt: values.applicationStartedAt,
                                                    maxChoice: values.maxChoice,
                                                    purchasableCount: values.purchasableCount,
                                                    purchasableEndedAt: values.purchasableEndedAt,
                                                    purchasableStartedAt: values.purchasableStartedAt,
                                                    resultNoticedAt: values.resultNoticedAt
                                                } : undefined,
                                                firstComeFirstServed: preSaleType === "firstComeFirstServed" ? {
                                                    purchasableCount: values.purchasableCount,
                                                    purchasableEndedAt: values.purchasableEndedAt,
                                                    purchasableStartedAt: values.purchasableStartedAt
                                                } : undefined,
                                                eventId: router.query.eventId,
                                                itemIds: [],
                                                purchesablePlanIds: purchesablePlanIds
                                            }
                                        }
                                    }).then(function() {
                                        showMessage(t("successMessage", "先行販売チケットを作成しました"));
                                        router.push(generatePath(routerPages.ConsoleShokufesEventDetail, {
                                            eventId: router.query.eventId
                                        }));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var CREATE_PRE_SALE = (0,lib/* gql */.Ps)(ConsolePreSaleCreate_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleCreate/index.tsx




/**
 * ConsolePreSaleCreate Page
 * Implemented as a practical sample.
 */ var ConsolePreSaleCreate = function() {
    var ref = ConsolePreSaleCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePreSaleCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/PreSaleContentSkeletonCell.tsx






var PreSaleContentSkeletonCell = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "small",
                    width: "25%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 4,
                sx: {
                    pb: 4
                },
                children: Array.from(Array(4).keys()).map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small"
                                    })
                                ]
                            }),
                            3 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                orientation: "vertical",
                                flexItem: true
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2"
            }),
            Array.from(Array(4).keys()).map(function(info, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2"
                        })
                    ]
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/preSale/PreSaleStatusTag/index.tsx





var PreSaleStatusTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var bgcolor = (0,react.useMemo)(function() {
        switch(status){
            case utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting:
                return "primary.main";
            case utoniq_core_schema/* PreSaleStatus.AcceptingLottery */.fu$.AcceptingLottery:
                return "info.light";
            case utoniq_core_schema/* PreSaleStatus.Purchasable */.fu$.Purchasable:
                return "secondary.light";
            case utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption:
                return "secondary.main";
            case utoniq_core_schema/* PreSaleStatus.SoldOut */.fu$.SoldOut:
                return "error.main";
            default:
                return "grey.300";
        }
    }, [
        status
    ]);
    var textColor = (0,react.useMemo)(function() {
        switch(status){
            case utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption:
            case utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting:
            case utoniq_core_schema/* PreSaleStatus.SoldOut */.fu$.SoldOut:
                return "white";
            case utoniq_core_schema/* PreSaleStatus.AcceptingLottery */.fu$.AcceptingLottery:
            case utoniq_core_schema/* PreSaleStatus.Purchasable */.fu$.Purchasable:
                return "text.primary";
            default:
                return "white";
        }
    }, [
        status
    ]);
    if (!status) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: textColor,
            children: t(status)
        }),
        sx: {
            p: 0,
            bgcolor: bgcolor,
            height: 20,
            ".MuiChip-label": {
                p: 1
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/StatusCell.tsx





var StatusCell = function(param) {
    var isLottery = param.isLottery, preSaleStatus = param.preSaleStatus, createdAt = param.createdAt, isPublished = param.isPublished;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 1,
            sx: {
                py: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    flex: 1,
                    minWidth: "fit-content"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        variant: "outlined",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            children: t(isLottery ? "lottery" : "FCFS")
                        }),
                        sx: {
                            bgcolor: "background.default",
                            p: 0,
                            height: 20,
                            ".MuiChip-label": {
                                p: 1
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        size: "small",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "white",
                            children: t(isPublished ? "published" : "unpublished")
                        }),
                        color: isPublished ? "primary" : "default",
                        sx: {
                            height: 20,
                            ".MuiChip-label": {
                                p: 1
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleStatusTag, {
                        status: preSaleStatus
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("publishAt", {
                            createdAt: createdAt
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/PreSaleContentCell.tsx







var PreSaleContentCell = function(param) {
    var preSale = param.preSale;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    var ref, ref1, ref2;
    var labels = (0,react.useMemo)(function() {
        var ref3, ref4, ref5, ref6;
        return (0,array/* filterHiddenItem */.s)([
            {
                title: t("userApply", "応募可能なユーザー"),
                content: preSale.isPremium || preSale.purchesablePlanIds && ((ref3 = preSale.purchesablePlanIds) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 ? t("membersOnly") : t("all")
            },
            {
                title: t("maximumDesiredNumber", "最大希望数"),
                content: (ref = (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.maxChoice) !== null && ref !== void 0 ? ref : 0,
                hidden: !preSale.lottery
            },
            {
                title: t("maximumAppNumber", "応募枚数上限"),
                content: (ref1 = (ref5 = preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.purchasableCount) !== null && ref1 !== void 0 ? ref1 : 0,
                hidden: !preSale.lottery
            },
            {
                title: t("maximumAppNumber", "応募枚数上限"),
                content: (ref2 = (ref6 = preSale.firstComeFirstServed) === null || ref6 === void 0 ? void 0 : ref6.purchasableCount) !== null && ref2 !== void 0 ? ref2 : 0,
                hidden: !preSale.firstComeFirstServed
            }, 
        ]);
    }, [
        preSale.firstComeFirstServed,
        preSale.lottery,
        t
    ]);
    var ref3;
    var preSaleInfos = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref4, ref5, ref6, ref7, ref8;
        return (0,array/* filterHiddenItem */.s)([
            {
                title: t("applicationDate", "先行抽選受付期間"),
                content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref = preSale.lottery) === null || ref === void 0 ? void 0 : ref.formattedApplicationStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.formattedApplicationEndedAt),
                hidden: !preSale.lottery
            },
            {
                title: t("resultNoticeDate", "当落発表予定日"),
                content: preSale === null || preSale === void 0 ? void 0 : (ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.formattedResultNoticedAt,
                hidden: !(preSale === null || preSale === void 0 ? void 0 : (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.formattedResultNoticedAt)
            },
            {
                title: t("paymentDate", "決済期間"),
                content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref5 = preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.formattedPurchasableStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref6 = preSale.lottery) === null || ref6 === void 0 ? void 0 : ref6.formattedPurchasableEndedAt),
                hidden: !preSale.lottery
            },
            {
                title: t("purchasableDate", "購入期間"),
                content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref7 = preSale.firstComeFirstServed) === null || ref7 === void 0 ? void 0 : ref7.formattedPurchasableStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref8 = preSale.firstComeFirstServed) === null || ref8 === void 0 ? void 0 : ref8.formattedPurchasableEndedAt),
                hidden: !preSale.firstComeFirstServed
            },
            {
                title: t("paymentMethod", "決済方法"),
                content: ((ref3 = preSale === null || preSale === void 0 ? void 0 : preSale.paymentMethods) !== null && ref3 !== void 0 ? ref3 : [
                    utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                    utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini, 
                ]).map(function(paymentMethod) {
                    return t(paymentMethod);
                }).join("/")
            },
            {
                title: t("note", "注意事項"),
                content: preSale.note
            }, 
        ]);
    }, [
        t,
        preSale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 4,
                sx: {
                    pb: 4
                },
                children: labels.map(function(param, index) {
                    var title = param.title, content = param.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: content
                                    })
                                ]
                            }),
                            labels.length - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                orientation: "vertical",
                                flexItem: true
                            })
                        ]
                    }, title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: preSale.description
            }),
            preSaleInfos.map(function(info, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: info.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: info.content
                        })
                    ]
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/PreSaleApplicantsCell.tsx









var PreSaleApplicantsCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    // 受付前は表示しない
    if (preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption) return null;
    var isLottery = preSale.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery;
    // 抽選の当落処理前かどうか
    var isBeforeLottery = isLottery && (preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting || preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.AcceptingLottery */.fu$.AcceptingLottery);
    // クレジットカードでの応募・支払い状況のカウント
    var creditCardAggregation = (0,src_object_spread/* default */.Z)({
        failedCount: 0
    }, isLottery ? (ref = preSale.lottery) === null || ref === void 0 ? void 0 : (ref1 = ref.applicantAggregation) === null || ref1 === void 0 ? void 0 : ref1.creditCard : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (ref2 = preSale.firstComeFirstServed) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.applicantAggregation) === null || ref3 === void 0 ? void 0 : ref3.creditCard), {
        appliedQuantity: 0,
        purchasedQuantity: 0,
        failedCount: 0,
        failedQuantity: 0
    }));
    // コンビニ決済での応募・支払い状況のカウント
    var konbiniAggregation = isLottery ? (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.applicantAggregation) === null || ref5 === void 0 ? void 0 : ref5.konbini : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (ref6 = preSale.firstComeFirstServed) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.applicantAggregation) === null || ref7 === void 0 ? void 0 : ref7.konbini), {
        appliedQuantity: 0,
        purchasedQuantity: 0,
        unpaidQuantity: 0
    });
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    // 応募者全体の応募
    var applicants = {
        count: ((ref8 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.appliedCount) !== null && ref8 !== void 0 ? ref8 : 0) + ((ref9 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.appliedCount) !== null && ref9 !== void 0 ? ref9 : 0),
        quantity: ((ref10 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.appliedQuantity) !== null && ref10 !== void 0 ? ref10 : 0) + ((ref11 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.appliedQuantity) !== null && ref11 !== void 0 ? ref11 : 0),
        details: [
            {
                label: t("credit_card", "クレジットカード決済"),
                count: (ref12 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.appliedCount) !== null && ref12 !== void 0 ? ref12 : 0,
                quantity: (ref13 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.appliedQuantity) !== null && ref13 !== void 0 ? ref13 : 0
            },
            {
                label: t("konbini", "コンビニ決済"),
                count: (ref14 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.appliedCount) !== null && ref14 !== void 0 ? ref14 : 0,
                quantity: (ref15 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.appliedQuantity) !== null && ref15 !== void 0 ? ref15 : 0
            }, 
        ]
    };
    var ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
    // 当選者の支払い状況。抽選前の段階では "-" と表示
    var winners = {
        count: isBeforeLottery ? "-" : ((ref16 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedCount) !== null && ref16 !== void 0 ? ref16 : 0) + ((ref17 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedCount) !== null && ref17 !== void 0 ? ref17 : 0) + ((ref18 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedCount) !== null && ref18 !== void 0 ? ref18 : 0) + ((ref19 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidCount) !== null && ref19 !== void 0 ? ref19 : 0),
        quantity: isBeforeLottery ? "-" : ((ref20 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedQuantity) !== null && ref20 !== void 0 ? ref20 : 0) + ((ref21 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedQuantity) !== null && ref21 !== void 0 ? ref21 : 0) + ((ref22 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedQuantity) !== null && ref22 !== void 0 ? ref22 : 0) + ((ref23 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidQuantity) !== null && ref23 !== void 0 ? ref23 : 0),
        details: [
            {
                label: t("creditCardPaymentStatus", "クレジットカード決済入金状況"),
                count: isBeforeLottery ? "-" : ((ref24 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedCount) !== null && ref24 !== void 0 ? ref24 : 0) + ((ref25 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedCount) !== null && ref25 !== void 0 ? ref25 : 0),
                quantity: isBeforeLottery ? "-" : ((ref26 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedQuantity) !== null && ref26 !== void 0 ? ref26 : 0) + ((ref27 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedQuantity) !== null && ref27 !== void 0 ? ref27 : 0),
                items: [
                    {
                        status: t("purchased", "入金済み"),
                        count: isBeforeLottery ? "-" : (ref28 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedCount) !== null && ref28 !== void 0 ? ref28 : 0,
                        quantity: isBeforeLottery ? "-" : (ref29 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.purchasedQuantity) !== null && ref29 !== void 0 ? ref29 : 0
                    }, 
                ].concat((0,src_to_consumable_array/* default */.Z)(isLottery ? [
                    {
                        status: t("failed", "決済失敗"),
                        count: isBeforeLottery ? "-" : (ref30 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedCount) !== null && ref30 !== void 0 ? ref30 : 0,
                        quantity: isBeforeLottery ? "-" : (ref31 = creditCardAggregation === null || creditCardAggregation === void 0 ? void 0 : creditCardAggregation.failedQuantity) !== null && ref31 !== void 0 ? ref31 : 0
                    }, 
                ] : []))
            },
            {
                label: t("konbiniPaymentStatus", "コンビニ決済入金状況"),
                count: isBeforeLottery ? "-" : ((ref32 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedCount) !== null && ref32 !== void 0 ? ref32 : 0) + ((ref33 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidCount) !== null && ref33 !== void 0 ? ref33 : 0),
                quantity: isBeforeLottery ? "-" : ((ref34 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedQuantity) !== null && ref34 !== void 0 ? ref34 : 0) + ((ref35 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidQuantity) !== null && ref35 !== void 0 ? ref35 : 0),
                items: [
                    {
                        status: t("purchased", "入金済み"),
                        count: isBeforeLottery ? "-" : (ref36 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedCount) !== null && ref36 !== void 0 ? ref36 : 0,
                        quantity: isBeforeLottery ? "-" : (ref37 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.purchasedQuantity) !== null && ref37 !== void 0 ? ref37 : 0
                    },
                    {
                        status: t("notPurchased", "未入金"),
                        count: isBeforeLottery ? "-" : (ref38 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidCount) !== null && ref38 !== void 0 ? ref38 : 0,
                        quantity: isBeforeLottery ? "-" : (ref39 = konbiniAggregation === null || konbiniAggregation === void 0 ? void 0 : konbiniAggregation.unpaidQuantity) !== null && ref39 !== void 0 ? ref39 : 0
                    }, 
                ]
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    pt: 1,
                    pb: 2
                },
                children: isLottery ? t("applicantStatus", "応募/当選状況") : t("purchaseStatus", "購入状況")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    borderStyle: "solid",
                    borderRadius: "8px",
                    borderWidth: 1,
                    borderColor: "grey.100",
                    p: 5
                },
                children: [
                    isLottery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: t("applicantsCount", "応募枚数/応募者数")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    flexDirection: "row",
                                    alignItems: "baseline",
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                        variant: "h1",
                                        sx: {
                                            fontFamily: "Oswald"
                                        },
                                        children: applicants.quantity
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("ticket", "枚")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h1",
                                        sx: {
                                            fontFamily: "Oswald"
                                        },
                                        children: " / "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                        variant: "h1",
                                        sx: {
                                            fontFamily: "Oswald"
                                        },
                                        children: applicants.count
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("people", "人")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mt: 2
                                },
                                children: applicants.details.map(function(param) {
                                    var label = param.label, count = param.count, quantity = param.quantity;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mt: -1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    flexDirection: "row",
                                                    alignItems: "baseline",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                        variant: "h6",
                                                        sx: {
                                                            fontFamily: "Oswald"
                                                        },
                                                        children: quantity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: t("ticket", "枚")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: " / "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                        variant: "subtitle2",
                                                        children: count
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: t("people", "人")
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    height: "1px",
                                    bgcolor: "grey.100",
                                    mt: 3
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        className: "winners",
                        sx: {
                            mt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: isLottery ? t("winnersCount", "当選枚数/当選者数") : t("purchaseCount", "購入者数")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    flexDirection: "row",
                                    alignItems: "baseline",
                                    gap: 1
                                },
                                children: [
                                    isLottery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                variant: "h1",
                                                sx: {
                                                    fontFamily: "Oswald"
                                                },
                                                children: winners.quantity
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                children: t("ticket", "枚")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h1",
                                                sx: {
                                                    fontFamily: "Oswald"
                                                },
                                                children: " / "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                        variant: "h1",
                                        sx: {
                                            fontFamily: "Oswald"
                                        },
                                        children: winners.count
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("people", "人")
                                    })
                                ]
                            }),
                            winners.details.map(function(param) {
                                var label = param.label, count = param.count, quantity = param.quantity, items = param.items;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        mt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            sx: {
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "baseline",
                                                gap: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "baseline",
                                                    sx: {
                                                        gap: "2px"
                                                    },
                                                    children: [
                                                        isLottery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                                    variant: "overline",
                                                                    children: quantity
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "overline",
                                                                    children: t("ticket", "枚")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "overline",
                                                                    children: " / "
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                            variant: "overline",
                                                            children: count
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            children: t("people", "人")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        items.map(function(param) {
                                            var status = param.status, count = param.count, quantity = param.quantity;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    mt: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        children: status
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        sx: {
                                                            flexDirection: "row",
                                                            alignItems: "baseline",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            isLottery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                                        variant: "overline",
                                                                        children: quantity
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        variant: "overline",
                                                                        children: t("ticket", "枚")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        variant: "overline",
                                                                        children: " / "
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                                variant: "overline",
                                                                children: count
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "overline",
                                                                children: t("people", "人")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, status);
                                        })
                                    ]
                                }, label);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/ItemSelectBox.tsx






var components_ItemSelectBox_ItemSelectBox = function(param) {
    var checked = param.checked, item = param.item, onSelect = param.onSelect;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    var ref2, _formattedPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2,
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: checked ? "primary.main" : "grey.50",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    alignItems: "center",
                    sx: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                zIndex: 1,
                                marginInline: "auto",
                                pl: 1,
                                width: 104,
                                position: "absolute",
                                top: 8,
                                left: 16
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                type: item.type
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "small",
                            src: (ref2 = (ref = item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemStatusCell, {
                                    isPremium: item.isPremium,
                                    isPublished: item.isPublished,
                                    salesCondition: item.salesCondition,
                                    isDrm: item.isDrm
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(3),
                                    children: item.title
                                }),
                                ((ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: item.sku.unitName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("price", {
                                        number: (_formattedPrice = item.formattedPrice) !== null && _formattedPrice !== void 0 ? _formattedPrice : 0
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                onClick: function() {
                    return onSelect(item.id);
                },
                sx: {
                    position: "absolute",
                    zIndex: 2,
                    inset: 0
                }
            })
        ]
    });
};
var components_ItemSelectBox_ItemSelectBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 60,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignSelf: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "80%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "80%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    pt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "40%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "20%"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/RewardItemsCell.tsx













var RewardItemsCell = function(param) {
    var loading = param.loading, items = param.items, onRemove = param.onRemove;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 2
        },
        children: [
            loading && !(items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pt: 1,
                    pb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4",
                    width: "50%"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    pt: 1,
                    pb: 2
                },
                children: t("registrationTicket", "登録チケット")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: items === null || items === void 0 ? void 0 : items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardItemsCell_ItemSelectBox, {
                        item: item,
                        onRemove: onRemove
                    });
                }),
                emptyMessage: t("preSaleItemEmptyMessage", "登録されたチケットはありません"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    sx: {
                        pb: 2
                    },
                    children: Array.from(Array(2).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectBox_ItemSelectBoxSkeleton, {}, key);
                    })
                }),
                componentProps: {
                    spacing: 2
                },
                loading: loading,
                hasNextPage: false,
                onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })
            })
        ]
    });
};
var RewardItemsCell_ItemSelectBox = function(param) {
    var item = param.item, onRemove = param.onRemove;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onRemove(item.id).catch(function(error) {
                            return showError(error);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onRemove,
        item.id,
        showError
    ]);
    var ref11, _pendingPurchaseNumber, _pendingPurchaseNumber1, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5,
                "&:last-child": {
                    pb: 5
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative",
                            height: "fit-content"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    zIndex: 1,
                                    position: "absolute",
                                    top: 4,
                                    left: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                    type: item.type
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                size: "small",
                                src: (ref11 = (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref11 !== void 0 ? ref11 : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                sx: {
                                    pt: 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        ((ref2 = item.sku) === null || ref2 === void 0 ? void 0 : ref2.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "caption",
                                            children: item.sku.unitName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            spacing: 0,
                                            sx: {
                                                mb: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    color: "text.secondary",
                                                    variant: "body2",
                                                    children: t("purchasedNumber", {
                                                        purchasedNumber: item.purchasedNumber + ((_pendingPurchaseNumber = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0) || "-",
                                                        issuedNumber: item.issuedNumber || "-"
                                                    })
                                                }),
                                                !((ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.throughTicket) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    color: "text.secondary",
                                                    variant: "body2",
                                                    children: t("ticketUsed", {
                                                        used: ((ref6 = item.ticketUsage) === null || ref6 === void 0 ? void 0 : ref6.usedCount) || "-",
                                                        unused: ((ref7 = item.ticketUsage) === null || ref7 === void 0 ? void 0 : ref7.unusedCount) || "-"
                                                    })
                                                }),
                                                (ref8 = item.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.throughTicket) === null || ref10 === void 0 ? void 0 : ref10.map(function(throughTicket, index) {
                                                    var ref, ref1, ref2, ref3;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        color: "text.secondary",
                                                        variant: "body2",
                                                        children: t("throughTicketUsed", {
                                                            name: throughTicket.name,
                                                            used: ((ref = item.throughTicketUsedNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.usedNumber) || "-",
                                                            unused: item.purchasedNumber + ((_pendingPurchaseNumber1 = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber1 !== void 0 ? _pendingPurchaseNumber1 : 0) - ((ref12 = (ref2 = item.throughTicketUsedNumbers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[index]) === null || ref3 === void 0 ? void 0 : ref3.usedNumber) !== null && ref12 !== void 0 ? ref12 : 0) || "-"
                                                        })
                                                    }, index);
                                                })
                                            ]
                                        }),
                                        !!item.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: item.paymentType === "prepaid_point" || !item.paymentType ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                                        fontSize: "small"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: item.formattedPrice
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("price", {
                                                    number: item.formattedPrice
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            size: "xSmall",
                            bgcolor: "grey.100",
                            color: "grey.700",
                            onClick: handleRemove,
                            sx: {
                                position: "relative",
                                zIndex: 2
                            }
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/ItemSelectForm.tsx








var components_ItemSelectForm_schema = function(o) {
    return {
        keyword: o.string().allow("").optional()
    };
};
var components_ItemSelectForm_ItemSelectForm = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: components_ItemSelectForm_schema,
        defaultValues: components_ItemSelectForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var keyword = param.keyword;
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, components_ItemSelectForm_defaultValues), {
            keyword: keyword
        }));
    }), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            py: 5
        },
        onSubmit: handleSubmit(onSubmit)
    });
};
var components_ItemSelectForm_SearchInputCell = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(props, ref) {
    var t = useTranslation("consoleCollectionCreate").t;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ _jsx(SearchInputField, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            t: t
        }))
    });
})));
var components_ItemSelectForm_defaultValues = {
    keyword: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/components/ItemSelectModal.tsx















var components_ItemSelectModal_ItemSelectModal = function(param) {
    var artistId = param.artistId, open = param.open, values = param.values, onClose = param.onClose, loading = param.loading, hasNextPage = param.hasNextPage, addingItem = param.addingItem, onFetchMore = param.onFetchMore, items = param.items, onSearch = param.onSearch, onSelect = param.onSelect;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)([]), itemSelected = ref1[0], setItemSelected = ref1[1];
    /**
   * @HACK
   * フィルタリング後のアイテム表示数が10件に満たない場合、アイテム全てをクエリ取得する or 10件表示するまで自動でrefetchする。
   */ (0,react.useEffect)(function() {
        var ref, ref1;
        if (!loading && hasNextPage && (items === null || items === void 0 ? void 0 : (ref = items.edges) === null || ref === void 0 ? void 0 : ref.length) !== undefined && (items === null || items === void 0 ? void 0 : (ref1 = items.edges) === null || ref1 === void 0 ? void 0 : ref1.length) < 10) {
            onFetchMore();
        }
    }, [
        loading,
        hasNextPage
    ]);
    (0,react.useEffect)(function() {
        setItemSelected(values);
    }, [
        values
    ]);
    var addItemToCollection = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                onSelect(itemSelected).then(function() {
                    onClose();
                }).catch(function(e) {
                    showError(e);
                })
            ];
        });
    }), [
        itemSelected,
        onClose,
        onSelect,
        showError
    ]);
    var handleSelectItem = function(itemId) {
        if (!items) return;
        var item = items.edges.find(function(element) {
            return element.node.id === itemId;
        });
        if (item && (item.node.paymentType !== "cash" || item.node.type !== "ticket")) {
            showError(t("notAllowItemSelect"));
        } else {
            setItemSelected(function(prevState) {
                return xor_default()(prevState, [
                    itemId
                ]);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
                artistId: artistId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                    customNavigation: itemSelected.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectModal_FixedBottomCell, {
                        onSelect: function() {
                            return addItemToCollection();
                        },
                        loading: addingItem,
                        number: itemSelected.length
                    }) : null,
                    margin: true,
                    header: {
                        left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                            edge: "start",
                            size: "medium",
                            color: "white",
                            onClick: function() {
                                onClose();
                                setItemSelected(values);
                            }
                        }),
                        title: t("itemSelection")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectForm_ItemSelectForm, {
                            onSubmit: onSearch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: items === null || items === void 0 ? void 0 : (ref = items.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectBox_ItemSelectBox, {
                                    item: node,
                                    checked: itemSelected.includes(node.id),
                                    onSelect: function(itemId) {
                                        return handleSelectItem(itemId);
                                    }
                                }, node.id);
                            }),
                            emptyMessage: t("emptyItemSelect"),
                            loading: loading,
                            hasNextPage: hasNextPage,
                            onFetchMore: onFetchMore,
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 5,
                                sx: {
                                    pb: 2
                                },
                                children: Array.from(Array(4).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectBox_ItemSelectBoxSkeleton, {}, key);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
var components_ItemSelectModal_FixedBottomCell = function(param) {
    var onSelect = param.onSelect, loading = param.loading, number = param.number;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                py: 4,
                bgcolor: "grey.50",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    minWidth: 244
                },
                onClick: onSelect,
                loading: loading,
                disabled: loading,
                children: t("addSelectedItem", {
                    number: number
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/template/index.tsx




















var ConsolePreSaleDetailTemplate = function(param) {
    var state = param.state, onRemovePreSale = param.onRemovePreSale, onRemove = param.onRemove, onFetchMore = param.onFetchMore, onSelect = param.onSelect, onSearch = param.onSearch;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleDetail").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref10.routerPages, router = ref10.router, generatePath = ref10.generatePath;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref11[0], copy = ref11[1];
    var url = ((ref = state.preSale) === null || ref === void 0 ? void 0 : ref.type) === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? (0,lib_url/* generateFullPath */.QP)(routerPages.LotteryDetail, {
        preSaleId: state.preSaleId
    }) : (0,lib_url/* generateFullPath */.QP)(routerPages.FirstComeFirstServedDetail, {
        preSaleId: state.preSaleId
    });
    var ref12 = (0,BrowserLink/* useBrowserLink */.i)(generatePath(((ref1 = state.preSale) === null || ref1 === void 0 ? void 0 : ref1.type) === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? routerPages.LotteryDetail : routerPages.FirstComeFirstServedDetail, {
        preSaleId: state.preSaleId
    })), onClickBrowserLink = ref12.onClick;
    var ref13 = (0,react.useState)(null), anchorEl = ref13[0], setAnchorEl = ref13[1];
    var ref14 = (0,react.useState)(false), openTrashConfirm = ref14[0], setOpenTrashConfirm = ref14[1];
    var options = [
        {
            label: t("applicants"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        router.push(generatePath(routerPages.ConsoleLotteryManagements, {
                            preSaleId: state.preSaleId
                        }));
                        return [
                            2
                        ];
                    });
                })();
            },
            hidden: ((ref2 = state.preSale) === null || ref2 === void 0 ? void 0 : ref2.type) !== utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery
        },
        {
            label: t("openPreSaleLabel"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                sx: {
                    "&.MuiListItemIcon-root": {
                        minWidth: 24
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                    fontSize: "xSmall"
                })
            }),
            onClick: function onClick() {
                onClickBrowserLink();
                setAnchorEl(null);
            }
        },
        {
            label: t("copyURLLabel"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    copy(url)
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("copyURLSuccess"), "success");
                                setAnchorEl(null);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            label: t("editLabel"),
            onClick: function onClick() {
                var ref;
                var _id;
                router.push(generatePath(routerPages.ConsolePreSaleEdit, {
                    preSaleId: state.preSaleId,
                    eventId: (_id = (ref = state.preSale) === null || ref === void 0 ? void 0 : ref.event.id) !== null && _id !== void 0 ? _id : "#"
                }));
                handleClose();
            }
        }, 
    ];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var _id, ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: ((ref3 = state.preSale) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.event) === null || ref4 === void 0 ? void 0 : ref4.id) ? generatePath(routerPages.ConsoleShokufesEventDetail, {
                    eventId: (_id = (ref5 = state.preSale) === null || ref5 === void 0 ? void 0 : ref5.event.id) !== null && _id !== void 0 ? _id : "#"
                }) : routerPages.ConsoleDashboard,
                title: (ref6 = state.preSale) === null || ref6 === void 0 ? void 0 : ref6.title,
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                    edge: "end",
                    size: "medium",
                    onClick: handleClick,
                    color: "white"
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                    anchorEl: anchorEl,
                    open: Boolean(anchorEl),
                    onClose: handleClose,
                    children: options.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem_MenuItem/* default */.Z, {
                            onClick: option.onClick,
                            sx: {
                                width: 200
                            },
                            hidden: option.hidden,
                            children: [
                                option.icon,
                                option.label
                            ]
                        }, option.label);
                    })
                }),
                state.loading || !state.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSalTitleCellSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleContentSkeletonCell, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSalTitleCell, {
                            title: state.preSale.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusCell, {
                            isPublished: state.preSale.isPublished,
                            isLottery: !!state.preSale.lottery,
                            preSaleStatus: state.preSale.preSaleStatus,
                            createdAt: state.preSale.formattedEndedAt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleContentCell, {
                            preSale: state.preSale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleApplicantsCell, {
                            preSale: state.preSale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePreSaleDetail_template_BaseCell, {
                            artistId: state.artistId,
                            addingItem: state.addingItem,
                            itemSelectProps: state.itemSelectProps,
                            values: (ref15 = (ref7 = state.preSale) === null || ref7 === void 0 ? void 0 : ref7.itemIds) !== null && ref15 !== void 0 ? ref15 : [],
                            onFetchMore: onFetchMore,
                            onSelect: onSelect,
                            onSearch: onSearch
                        }),
                        !!((ref8 = state.preSale) === null || ref8 === void 0 ? void 0 : ref8.preSalesAggregation) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketStatusCell, {
                            preSalesAggregation: state.preSale.preSalesAggregation,
                            updatedAt: state.updatedAt
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardItemsCell, {
                    onRemove: onRemove,
                    loading: state.loading,
                    items: (ref9 = state.preSale) === null || ref9 === void 0 ? void 0 : ref9.items
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: openTrashConfirm,
                    onClose: function() {
                        return setOpenTrashConfirm(false);
                    },
                    title: t("trashConfirmTitle"),
                    content: t("trashConfirmDesc"),
                    cancelText: t("cancel"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        sx: {
                            minWidth: 212
                        },
                        variant: "contained",
                        color: "primary",
                        size: "large",
                        loading: state.removingPreSale,
                        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            onRemovePreSale()
                                        ];
                                    case 1:
                                        _state.sent();
                                        setOpenTrashConfirm(false);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: t("delete")
                    })
                })
            ]
        })
    });
};
var PreSalTitleCell = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: title
        })
    });
};
var PreSalTitleCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "large",
            width: "75%"
        })
    });
};
var ConsolePreSaleDetail_template_BaseCell = function(param) {
    var artistId = param.artistId, values = param.values, addingItem = param.addingItem, itemSelectProps = param.itemSelectProps, onFetchMore = param.onFetchMore, onSelect = param.onSelect, onSearch = param.onSearch;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        setOpen(open);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "fixed",
                    bottom: 16,
                    zIndex: 5,
                    maxWidth: 600,
                    margin: "0 auto",
                    px: 4,
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "medium",
                    color: "primary",
                    onClick: function() {
                        toggleDrawer(true);
                        onSearch({
                            keyword: ""
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.ThinPlus, {
                        fontSize: "medium",
                        sx: {
                            color: "white"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ItemSelectModal_ItemSelectModal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itemSelectProps), {
                values: values,
                artistId: artistId,
                open: open,
                onSearch: onSearch,
                addingItem: addingItem,
                onFetchMore: onFetchMore,
                onSelect: onSelect,
                onClose: function() {
                    return toggleDrawer(false);
                }
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/viewModel.ts




function ConsolePreSaleDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePreSaleDetail($id: ID!) {\n    artistPreSale(id: $id) {\n      ...ConsolePreSaleDetail\n      purchasedCartTransactionOrders {\n        id\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePreSaleDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePreSaleDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePresaleItemSearch(\n    $filters: ArtistItemsFilterInput\n    $pageInput: PageInput\n  ) {\n    artistItems(filters: $filters, pageInput: $pageInput) {\n      edges {\n        node {\n          ...ConsolePreSaleItemSelectBox\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePreSaleDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsolePreSaleDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdatePreSaleItems(\n    $id: ID!\n    $inputs: ArtistUpdatePreSaleInput!\n  ) {\n    artistUpdatePreSale(id: $id, inputs: $inputs) {\n      id\n      items {\n        ...ConsolePreSaleItemSelectedBox\n      }\n      itemIds\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePreSaleDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ConsolePreSaleDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1 = (0,react.useState)(values_Date/* DateTime.now */.o.now()), updatedAt = ref1[0];
    var ref2 = (0,useQuery/* useQuery */.aM)(ConsolePreSaleDetail_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId
        }
    }), data = ref2.data, loading = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(CONSOLE_PRESALE_ITEM_SEARCH, {
        notifyOnNetworkStatusChange: true
    }), 2), getConsoleItems = ref3[0], ref4 = ref3[1], consoleItems = ref4.data, gettingConsoleItems = ref4.loading, fetchMoreConsoleItems = ref4.fetchMore;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UPDATE_PRE_SALE_ITEMS), 2), artistUpdatePreSale = ref5[0], ref6 = ref5[1], addingItem = ref6.loading;
    var ref7, ref8, ref9;
    return {
        state: {
            loading: loading,
            preSale: (ref7 = data === null || data === void 0 ? void 0 : data.artistPreSale) !== null && ref7 !== void 0 ? ref7 : null,
            preSaleId: router.query.preSaleId,
            itemSelectProps: {
                loading: gettingConsoleItems,
                hasNextPage: !!(consoleItems === null || consoleItems === void 0 ? void 0 : (ref = consoleItems.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
                items: (ref8 = consoleItems === null || consoleItems === void 0 ? void 0 : consoleItems.artistItems) !== null && ref8 !== void 0 ? ref8 : null
            },
            artistId: (ref9 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref9 !== void 0 ? ref9 : "",
            addingItem: addingItem,
            removingPreSale: false,
            items: null,
            updatedAt: (data === null || data === void 0 ? void 0 : data.artistPreSale) ? updatedAt : ""
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!fetchMoreConsoleItems) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getConsoleItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMoreConsoleItems({
                                        variables: {
                                            pageInput: {
                                                cursor: consoleItems === null || consoleItems === void 0 ? void 0 : (ref = consoleItems.artistItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemove: function onRemove(itemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var preSale;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                preSale = data === null || data === void 0 ? void 0 : data.artistPreSale;
                                if (!preSale) return [
                                    2
                                ];
                                return [
                                    4,
                                    artistUpdatePreSale({
                                        variables: {
                                            id: router.query.preSaleId,
                                            inputs: {
                                                title: preSale.title,
                                                description: preSale.description,
                                                endedAt: dayjs_min_default()(preSale.endedAt).toISOString(),
                                                startedAt: dayjs_min_default()(preSale.startedAt).toISOString(),
                                                itemIds: preSale.itemIds.filter(function(id) {
                                                    return id !== itemId;
                                                }),
                                                note: preSale.note,
                                                isPublished: preSale.isPublished,
                                                paymentMethods: preSale.paymentMethods
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                artistUpdatePreSale: {
                                                    id: router.query.preSaleId,
                                                    itemIds: preSale.itemIds.filter(function(id) {
                                                        return id !== itemId;
                                                    }),
                                                    items: preSale.items.filter(function(item) {
                                                        return item.id !== itemId;
                                                    }),
                                                    __typename: "PreSale"
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRemovePreSale: function onRemovePreSale() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                //TODO add api remove preSale
                })();
            },
            onSelect: function onSelect(itemIds) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var preSale;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                preSale = data === null || data === void 0 ? void 0 : data.artistPreSale;
                                if (!preSale) return [
                                    2
                                ];
                                return [
                                    4,
                                    artistUpdatePreSale({
                                        variables: {
                                            id: router.query.preSaleId,
                                            inputs: {
                                                title: preSale.title,
                                                description: preSale.description,
                                                endedAt: dayjs_min_default()(preSale.endedAt).toISOString(),
                                                startedAt: dayjs_min_default()(preSale.startedAt).toISOString(),
                                                itemIds: itemIds,
                                                note: preSale.note,
                                                isPublished: preSale.isPublished,
                                                paymentMethods: preSale.paymentMethods
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSearch: function onSearch() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getConsoleItems()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsolePreSaleDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePreSaleDetail_viewModel_templateObject(), utoniq_core_schema/* ConsolePreSaleDetailFragmentDoc */.Jnq);
var CONSOLE_PRESALE_ITEM_SEARCH = (0,lib/* gql */.Ps)(ConsolePreSaleDetail_viewModel_templateObject1(), utoniq_core_schema/* ConsolePreSaleItemSelectBoxFragmentDoc */.IxN);
var ARTIST_UPDATE_PRE_SALE_ITEMS = (0,lib/* gql */.Ps)(ConsolePreSaleDetail_viewModel_templateObject2(), utoniq_core_schema/* ConsolePreSaleItemSelectedBoxFragmentDoc */.mFp);

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleDetail/index.tsx




/**
 * ConsolePreSaleDetail Page
 * Implemented as a practical sample.
 */ var ConsolePreSaleDetail = function() {
    var ref = ConsolePreSaleDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePreSaleDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleEdit/template/LotteryEditForm.tsx











var LotteryEditForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.title")).required(),
        description: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.description")).required(),
        note: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.note")).required(),
        purchasableCount: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableCount")).min(1).max(99).optional(),
        maxChoice: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.maxChoice")).required(),
        applicationStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.applicationStartedAt")).required(),
        applicationEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.applicationEndedAt")).required(),
        resultNoticedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.resultNoticedAt")).required(),
        paymentMethods: o.string().optional().label("consolePreSaleCreate.paymentMethods"),
        purchasableStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableStartedAt")).required(),
        purchasableEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableEndedAt")).required(),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.membershipAccessPermission")).items(o.string()).optional().allow(null),
        isPublished: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPublished")),
        startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.startedAt")).required(),
        endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.endedAt")).required(),
        isPremium: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPremium"))
    };
};
var LotteryEditForm = function(param) {
    var preSale = param.preSale, onSubmit = param.onSubmit, submitting = param.submitting, plans = param.plans;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: LotteryEditForm_schema,
        defaultValues: LotteryEditForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref.register, setValue = ref.setValue, reset = ref.reset, watch = ref.watch;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var ref8;
        reset({
            title: preSale.title,
            description: preSale.description,
            note: preSale.note,
            paymentMethods: getPaymentMethods(preSale.paymentMethods),
            isPublished: preSale.isPublished,
            startedAt: preSale.startedAt,
            endedAt: preSale.endedAt,
            purchasableCount: (ref = preSale.lottery) === null || ref === void 0 ? void 0 : ref.purchasableCount,
            maxChoice: (ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.maxChoice,
            applicationStartedAt: (ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationStartedAt,
            applicationEndedAt: (ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.applicationEndedAt,
            resultNoticedAt: (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.resultNoticedAt,
            purchasableStartedAt: (ref5 = preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.purchasableStartedAt,
            purchasableEndedAt: (ref6 = preSale.lottery) === null || ref6 === void 0 ? void 0 : ref6.purchasableEndedAt,
            purchesablePlanIds: (ref8 = (ref7 = preSale.purchesablePlanIds) === null || ref7 === void 0 ? void 0 : ref7.filter(function(id) {
                return id !== null;
            })) !== null && ref8 !== void 0 ? ref8 : [],
            isPremium: preSale.isPremium
        });
    }, [
        preSale
    ]);
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var isFormValid = isValid && !showError;
    var ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmit),
        sx: {
            pt: 6,
            pb: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.note
            }, register("note"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors.purchasableCount
            }, register("purchasableCount")), {
                disabled: true
            })),
            plans && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("membershipAccessPermission")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mb: 2
                                        },
                                        children: t("membershipAccessPermissionDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                    sx: {
                                        "&& .Mui-disabled + .MuiSwitch-track": {
                                            bgcolor: "grey.100"
                                        },
                                        "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                            bgcolor: "primary.main"
                                        }
                                    },
                                    checked: (ref2 = watch("isPremium")) !== null && ref2 !== void 0 ? ref2 : false,
                                    onChange: function() {
                                        if (watch("isPremium")) {
                                            setValue("purchesablePlanIds", [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", false, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        } else {
                                            var ref;
                                            var ref1;
                                            setValue("purchesablePlanIds", (ref1 = (ref = preSale.purchesablePlanIds) === null || ref === void 0 ? void 0 : ref.filter(function(id) {
                                                return id !== null;
                                            })) !== null && ref1 !== void 0 ? ref1 : [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", !watch("isPremium"), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    watch("isPremium") && plans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        error: showError,
                        sx: {
                            mt: 2
                        },
                        children: [
                            plans.map(function(plan, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        label: (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? t("planOnlyYear", {
                                            name: (ref3 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref3 !== void 0 ? ref3 : ""
                                        }) : (ref4 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref4 !== void 0 ? ref4 : ""
                                    }, register("purchesablePlanIds")), {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: function(e) {
                                                var currentPlanIds = (watch("purchesablePlanIds") || []).filter(function(id) {
                                                    return id !== null;
                                                });
                                                if (e.target.checked) {
                                                    var ref;
                                                    // チェックされた場合、planIdを追加
                                                    setValue("purchesablePlanIds", (0,src_to_consumable_array/* default */.Z)(currentPlanIds).concat([
                                                        (ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : ""
                                                    ]));
                                                } else {
                                                    // チェックが解除された場合、planIdを削除
                                                    setValue("purchesablePlanIds", currentPlanIds.filter(function(id) {
                                                        return id !== (plan === null || plan === void 0 ? void 0 : plan.planId);
                                                    }));
                                                }
                                            },
                                            checked: ((ref = watch("purchesablePlanIds")) === null || ref === void 0 ? void 0 : ref.includes((ref5 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref5 !== void 0 ? ref5 : "")) || false
                                        })
                                    }), plan === null || plan === void 0 ? void 0 : plan.planId)
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "error.main",
                                children: showError ? t("membershipAccessPermissionRequired") : " "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    mt: 8,
                    mb: 2
                },
                children: t("maxChoice")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "text.secondary",
                sx: {
                    mb: 2
                },
                children: t("maxChoiceDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                listItems: [
                    {
                        value: "1",
                        label: "第1希望まで"
                    },
                    {
                        value: "2",
                        label: "第2希望まで"
                    },
                    {
                        value: "3",
                        label: "第3希望まで"
                    }, 
                ],
                value: watch("maxChoice").toString(),
                onChange: function(value) {
                    setValue("maxChoice", Number(value));
                },
                formControlProps: {
                    sx: {
                        width: "100%",
                        bgcolor: "grey.50",
                        minHeight: "auto",
                        mb: 16
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4,
                    mt: 8
                },
                children: t("applicationPeriod")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "applicationStartedAt",
                desc: t("applicationStartedAtDesc"),
                error: errors.applicationStartedAt,
                setValue: setValue,
                value: watch("applicationStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "applicationEndedAt",
                error: errors.applicationEndedAt,
                setValue: setValue,
                value: watch("applicationEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "resultNoticedAt",
                desc: t("resultNoticedAtDesc"),
                error: errors.resultNoticedAt,
                setValue: setValue,
                value: watch("resultNoticedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsInputCell, {
                paymentMethods: watch("paymentMethods"),
                setValue: setValue,
                disabled: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4
                },
                children: t("purchasablePeriod")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableStartedAt",
                desc: t("purchasableStartedAtDesc"),
                error: errors.purchasableStartedAt,
                setValue: setValue,
                value: watch("purchasableStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableEndedAt",
                error: errors.purchasableEndedAt,
                setValue: setValue,
                value: watch("purchasableEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: t("isPublishedDesc")
                }
            }, register("isPublished")), {
                checked: watch("isPublished")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "endedAt",
                error: errors.endedAt,
                setValue: setValue,
                value: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 5,
                    gap: 5
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: submitting,
                    disabled: !isFormValid || submitting,
                    children: t("submit")
                })
            })
        ]
    });
};
var LotteryEditForm_defaultValues = {
    maxChoice: 1,
    paymentMethods: "both"
};
function getPaymentMethods(paymentMethods) {
    if (!paymentMethods || (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) === 0 || paymentMethods.length === 2) {
        return "both";
    }
    return paymentMethods[0];
}

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleEdit/template/FirstComeFirstServedEditForm.tsx












var FirstComeFirstServedEditForm_schema = function(o) {
    return {
        title: o.string().max(30).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.title")).required(),
        description: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.description")).required(),
        note: o.string().max(5000).label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.note")).required(),
        purchasableCount: o.number().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableCount")).max(8).optional(),
        paymentMethods: o.string().optional().label("consolePreSaleCreate.paymentMethods"),
        purchasableStartedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableStartedAt")).required(),
        purchasableEndedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.purchasableEndedAt")).required(),
        isPublished: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPublished")),
        startedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.startedAt")).required(),
        endedAt: o.date().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.endedAt")).required(),
        purchesablePlanIds: o.array().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.membershipAccessPermission")).items(o.string()).optional().allow(null),
        isPremium: o.bool().label((0,core_form/* tLabel */.TQ)("consolePreSaleCreate.isPremium"))
    };
};
var FirstComeFirstServedEditForm = function(param) {
    var preSale = param.preSale, onSubmit = param.onSubmit, submitting = param.submitting, plans = param.plans;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleEdit").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: FirstComeFirstServedEditForm_schema,
        defaultValues: FirstComeFirstServedEditForm_defaultValues
    }), handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, register = ref.register, setValue = ref.setValue, reset = ref.reset, watch = ref.watch;
    var isPremium = watch("isPremium");
    var purchesablePlanIds = watch("purchesablePlanIds");
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        var ref4;
        reset({
            title: preSale.title,
            description: preSale.description,
            note: preSale.note,
            paymentMethods: getPaymentMethods(preSale.paymentMethods),
            isPublished: preSale.isPublished,
            startedAt: preSale.startedAt,
            endedAt: preSale.endedAt,
            purchasableCount: (ref = preSale.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.purchasableCount,
            purchasableStartedAt: (ref1 = preSale.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableStartedAt,
            purchasableEndedAt: (ref2 = preSale.firstComeFirstServed) === null || ref2 === void 0 ? void 0 : ref2.purchasableEndedAt,
            purchesablePlanIds: (ref4 = (ref3 = preSale.purchesablePlanIds) === null || ref3 === void 0 ? void 0 : ref3.filter(function(id) {
                return id !== null;
            })) !== null && ref4 !== void 0 ? ref4 : [],
            isPremium: preSale.isPremium
        });
    }, [
        preSale
    ]);
    (0,react.useEffect)(function() {
        if (isPremium && (!purchesablePlanIds || purchesablePlanIds.length === 0)) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [
        isPremium,
        purchesablePlanIds
    ]);
    var isFormValid = isValid && !showError;
    var ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmit),
        sx: {
            pt: 6,
            pb: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors.title
            }, register("title"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.description
            }, register("description"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors.note
            }, register("note"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInputCell_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors.purchasableCount
            }, register("purchasableCount")), {
                disabled: true
            })),
            plans && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        sx: {
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("membershipAccessPermission")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mb: 2
                                        },
                                        children: t("membershipAccessPermissionDesc")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                    sx: {
                                        "&& .Mui-disabled + .MuiSwitch-track": {
                                            bgcolor: "grey.100"
                                        },
                                        "&& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
                                            bgcolor: "primary.main"
                                        }
                                    },
                                    checked: (ref2 = watch("isPremium")) !== null && ref2 !== void 0 ? ref2 : false,
                                    onChange: function() {
                                        if (watch("isPremium")) {
                                            setValue("purchesablePlanIds", [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", false, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        } else {
                                            var ref;
                                            var ref1;
                                            setValue("purchesablePlanIds", (ref1 = (ref = preSale.purchesablePlanIds) === null || ref === void 0 ? void 0 : ref.filter(function(id) {
                                                return id !== null;
                                            })) !== null && ref1 !== void 0 ? ref1 : [], {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            setValue("isPremium", !watch("isPremium"), {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                        }
                                    }
                                })
                            })
                        ]
                    }),
                    watch("isPremium") && plans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        error: showError,
                        sx: {
                            mt: 2
                        },
                        children: [
                            plans.map(function(plan, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        label: (plan === null || plan === void 0 ? void 0 : plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year ? t("planOnlyYear", {
                                            name: (ref3 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref3 !== void 0 ? ref3 : ""
                                        }) : (ref4 = plan === null || plan === void 0 ? void 0 : plan.title) !== null && ref4 !== void 0 ? ref4 : ""
                                    }, register("purchesablePlanIds")), {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: function(e) {
                                                var currentPlanIds = (watch("purchesablePlanIds") || []).filter(function(id) {
                                                    return id !== null;
                                                });
                                                if (e.target.checked) {
                                                    var ref;
                                                    // チェックされた場合、planIdを追加
                                                    setValue("purchesablePlanIds", (0,src_to_consumable_array/* default */.Z)(currentPlanIds).concat([
                                                        (ref = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref !== void 0 ? ref : ""
                                                    ]));
                                                } else {
                                                    // チェックが解除された場合、planIdを削除
                                                    setValue("purchesablePlanIds", currentPlanIds.filter(function(id) {
                                                        return id !== (plan === null || plan === void 0 ? void 0 : plan.planId);
                                                    }));
                                                }
                                            },
                                            checked: ((ref = watch("purchesablePlanIds")) === null || ref === void 0 ? void 0 : ref.includes((ref5 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref5 !== void 0 ? ref5 : "")) || false
                                        })
                                    }), plan === null || plan === void 0 ? void 0 : plan.planId)
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "error.main",
                                children: showError ? t("membershipAccessPermissionRequired") : " "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mt: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodsInputCell, {
                    paymentMethods: watch("paymentMethods"),
                    setValue: setValue,
                    disabled: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    mb: 4
                },
                children: t("purchasablePeriodFirstComeFirstServed")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableStartedAt",
                desc: t("purchasableStartedAtDesc"),
                error: errors.purchasableStartedAt,
                setValue: setValue,
                value: watch("purchasableStartedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "purchasableEndedAt",
                error: errors.purchasableEndedAt,
                setValue: setValue,
                value: watch("purchasableEndedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleInputCell_ToggleInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                content: {
                    title: t("isPublishedTitle"),
                    description: t("isPublishedDesc")
                }
            }, register("isPublished")), {
                checked: watch("isPublished")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "startedAt",
                error: errors.startedAt,
                setValue: setValue,
                value: watch("startedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerCell_DatePickerCell, {
                name: "endedAt",
                error: errors.endedAt,
                setValue: setValue,
                value: watch("endedAt")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 5,
                    gap: 5
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: submitting,
                    disabled: !isFormValid || submitting,
                    children: t("submit")
                })
            })
        ]
    });
};
var FirstComeFirstServedEditForm_defaultValues = {
    paymentMethods: "both"
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleEdit/template/index.tsx











var ConsolePreSaleEditTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleEdit").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                title: t("title"),
                back: true,
                defaultBackPage: generatePath(routerPages.ConsolePreSaleDetail, {
                    preSaleId: (ref2 = (ref = state.preSale) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "#"
                })
            },
            margin: true,
            children: state.preSale && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        sx: {
                            py: 3,
                            mt: 5
                        },
                        children: t("".concat(state.preSale.type, "Title"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        component: "a",
                        target: "_blank",
                        href: (0,helpUrl/* getHelpUrl */.R)("preSale"),
                        variant: "caption",
                        sx: {
                            alignItems: "center",
                            display: "flex"
                        },
                        children: [
                            t("".concat(state.preSale.type, "Help")),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                                fontSize: "xSmall",
                                color: "inherit",
                                sx: {
                                    ml: 1
                                }
                            })
                        ]
                    }),
                    state.preSale.type === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryEditForm, {
                        onSubmit: onSubmit,
                        preSale: state.preSale,
                        submitting: state.submitting,
                        plans: state.plans
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedEditForm, {
                        onSubmit: onSubmit,
                        preSale: state.preSale,
                        submitting: state.submitting,
                        plans: state.plans
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleEdit/viewModel.ts






function ConsolePreSaleEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsolePreSaleEdit($id: ID!) {\n    artistPreSale(id: $id) {\n      ...ConsolePreSaleEdit\n    }\n  }\n  ",
        "\n"
    ]);
    ConsolePreSaleEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsolePreSaleEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUpdatePreSale($id: ID!, $inputs: ArtistUpdatePreSaleInput!) {\n    artistUpdatePreSale(id: $id, inputs: $inputs) {\n      id\n      isPublished\n      lottery {\n        resultNoticedAt\n      }\n    }\n  }\n"
    ]);
    ConsolePreSaleEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 *
 */ var ConsolePreSaleEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var ref6 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref6.showMessage, showError = ref6.showError;
    var t = (0,core_i18n/* useTranslation */.$G)("consolePreSaleEdit").t;
    var data = (0,useQuery/* useQuery */.aM)(ConsolePreSaleEdit_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId
        }
    }).data;
    var preSaleType = data === null || data === void 0 ? void 0 : (ref = data.artistPreSale) === null || ref === void 0 ? void 0 : ref.type;
    var ref7 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistSubscriptionPlan */.P6C), artistSubscriptionPlanData = ref7.data;
    var plans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref = artistSubscriptionPlanData.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length) {
            var ref6, ref7;
            return flatten_default()(artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref6 = artistSubscriptionPlanData.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.subscription) === null || ref7 === void 0 ? void 0 : ref7.products.map(function(product) {
                return product.plans.map(function(plan) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, plan), {
                        title: product.title
                    });
                });
            }));
        }
        if (artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref3 = artistSubscriptionPlanData.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.plans) === null || ref5 === void 0 ? void 0 : ref5.length) {
            return artistSubscriptionPlanData.artist.subscription.plans;
        }
        return [];
    }, [
        artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref1 = artistSubscriptionPlanData.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.plans,
        artistSubscriptionPlanData === null || artistSubscriptionPlanData === void 0 ? void 0 : (ref3 = artistSubscriptionPlanData.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.products, 
    ]);
    var transPlanIdToPurchesablePlanIds = function(preSale, plans) {
        var ref;
        // isPremiumがtrueで、purchesablePlanIdsが空の場合は、全てのプランを取得
        if (preSale.isPremium && ((ref = preSale.purchesablePlanIds) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            var ref1;
            return plans.map(function(plan) {
                return (ref1 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref1 !== void 0 ? ref1 : "";
            });
        }
        // planIdが設定されている場合は、そのプランの金額以下のプランを取得
        if (preSale.planId) {
            var targetPlan = plans === null || plans === void 0 ? void 0 : plans.find(function(plan) {
                return (plan === null || plan === void 0 ? void 0 : plan.planId) === preSale.planId;
            });
            var currentPlans = plans === null || plans === void 0 ? void 0 : plans.filter(function(plan) {
                return (plan === null || plan === void 0 ? void 0 : plan.amount) && (targetPlan === null || targetPlan === void 0 ? void 0 : targetPlan.amount) ? plan.amount <= targetPlan.amount : false;
            });
            var ref2, ref3;
            return (ref3 = currentPlans === null || currentPlans === void 0 ? void 0 : currentPlans.map(function(plan) {
                return (ref2 = plan === null || plan === void 0 ? void 0 : plan.planId) !== null && ref2 !== void 0 ? ref2 : "";
            })) !== null && ref3 !== void 0 ? ref3 : [];
        } else {
            var ref4;
            var ref5;
            return (ref5 = (ref4 = preSale.purchesablePlanIds) === null || ref4 === void 0 ? void 0 : ref4.filter(function(id) {
                return id !== null;
            })) !== null && ref5 !== void 0 ? ref5 : [];
        }
    };
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_PRESALE), 2), updatePreSale = ref8[0], ref9 = ref8[1], submitting = ref9.loading;
    var ref10;
    return {
        state: {
            preSale: (data === null || data === void 0 ? void 0 : data.artistPreSale) ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.artistPreSale), {
                purchesablePlanIds: transPlanIdToPurchesablePlanIds(data.artistPreSale, plans)
            }) : null,
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            plans: plans,
            submitting: submitting
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, description, endedAt, isPublished, note, startedAt, title, purchesablePlanIds, isPremium, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                description = values.description, endedAt = values.endedAt, isPublished = values.isPublished, note = values.note, startedAt = values.startedAt, title = values.title, purchesablePlanIds = values.purchesablePlanIds, isPremium = values.isPremium;
                                return [
                                    4,
                                    updatePreSale({
                                        variables: {
                                            id: router.query.preSaleId,
                                            inputs: {
                                                description: description,
                                                endedAt: endedAt,
                                                isPublished: isPublished,
                                                note: note,
                                                startedAt: startedAt,
                                                title: title,
                                                purchesablePlanIds: purchesablePlanIds,
                                                itemIds: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.artistPreSale) === null || ref === void 0 ? void 0 : ref.itemIds) !== null && ref1 !== void 0 ? ref1 : [],
                                                isPremium: isPremium,
                                                planId: null,
                                                paymentMethods: values.paymentMethods === "both" ? [
                                                    utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                                    utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini
                                                ] : [
                                                    values.paymentMethods
                                                ],
                                                lottery: preSaleType === utoniq_core_schema/* PreSaleType.Lottery */.osN.Lottery ? {
                                                    applicationEndedAt: values.applicationEndedAt,
                                                    applicationStartedAt: values.applicationStartedAt,
                                                    maxChoice: values.maxChoice,
                                                    purchasableCount: values.purchasableCount,
                                                    purchasableEndedAt: values.purchasableEndedAt,
                                                    purchasableStartedAt: values.purchasableStartedAt,
                                                    resultNoticedAt: values.resultNoticedAt
                                                } : undefined,
                                                firstComeFirstServed: preSaleType === "first_come_first_served" ? {
                                                    purchasableCount: values.purchasableCount,
                                                    purchasableEndedAt: values.purchasableEndedAt,
                                                    purchasableStartedAt: values.purchasableStartedAt
                                                } : undefined
                                            }
                                        }
                                    }).then(function() {
                                        showMessage(t("successMessage", "先行販売チケットを更新しました"));
                                        router.push(generatePath(routerPages.ConsoleShokufesEventDetail, {
                                            eventId: router.query.eventId
                                        }));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsolePreSaleEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsolePreSaleEdit_viewModel_templateObject(), utoniq_core_schema/* ConsolePreSaleEditFragmentDoc */.rC5);
var UPDATE_PRESALE = (0,lib/* gql */.Ps)(ConsolePreSaleEdit_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ConsolePreSaleEdit/index.tsx




/**
 * ConsolePreSaleEdit Page
 * Implemented as a practical sample.
 */ var ConsolePreSaleEdit = function() {
    var ref = ConsolePreSaleEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsolePreSaleEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleQuantityManagements/template/FilterForm.tsx










var FilterForm_schema = function(o) {
    return {
        pickupDate: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.pickupDate")).required(),
        pickupTime: o.string().label((0,core_form/* tLabel */.TQ)("storeItemPurchaseProceed.pickupTime")).optional()
    };
};
var FilterForm = function(param) {
    var eventCollection = param.eventCollection, pickupDate = param.pickupDate, onSubmit = param.onSubmit;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleQuantityManagement").t;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: FilterForm_schema,
        defaultValues: FilterForm_defaultValues
    }), watch = ref1.watch, reset = ref1.reset, setValue = ref1.setValue;
    var watchPickupDate = watch("pickupDate");
    var watchPickupTime = watch("pickupTime");
    (0,react.useEffect)(function() {
        var pickupTime = eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.pickupTime;
        if (!pickupTime) {
            return;
        }
        if (!pickupDate) {
            return;
        }
        if (!pickupTime.some(function(value) {
            return values_Date/* DateTime.formatDate */.o.formatDate(pickupDate, "YYYY/MM/DD") === values_Date/* DateTime.formatDate */.o.formatDate(value.options.time, "YYYY/MM/DD");
        })) {
            reset({
                pickupDate: String(values_Date/* DateTime.formatDate */.o.formatDate(pickupDate, "YYYY/MM/DD")),
                pickupTime: ""
            });
        }
        reset({
            pickupDate: String(values_Date/* DateTime.formatDate */.o.formatDate(pickupDate, "YYYY/MM/DD")),
            pickupTime: "00:00"
        });
    }, []);
    // 日付ごとに時間をマッピングしたもの
    var actualPickupTime = Object.entries((ref = eventCollection.pickupTime) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var options = param.options;
        return {
            date: String(values_Date/* DateTime.formatDate */.o.formatDate(options.time, "MM/DD")),
            time: options.time
        };
    }).reduce(function(acc, param) {
        var date = param.date, time = param.time;
        if (!acc[date]) acc[date] = [];
        acc[date].push({
            time: time
        });
        return acc;
    }, {})).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), date = _param[0], times = _param[1];
        return {
            date: date,
            times: times
        };
    });
    var ref2, ref3;
    var pickupTimes = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            {
                label: t("all", "すべて"),
                value: "00:00"
            }, 
        ].concat((0,src_to_consumable_array/* default */.Z)((ref3 = (ref = actualPickupTime.find(function(param) {
            var date = param.date;
            return date === values_Date/* DateTime.formatDate */.o.formatDate(watchPickupDate, "MM/DD");
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.times) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
            var time = param.time;
            return {
                value: String(values_Date/* DateTime.formatDate */.o.formatDate(time, "HH:mm")),
                label: "".concat(String(values_Date/* DateTime.formatDate */.o.formatDate(time, "HH:mm")), " \n〜 ").concat(String(values_Date/* DateTime.formatDate */.o.formatDate(dayjs_min_default()(time).add((ref2 = eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes) !== null && ref2 !== void 0 ? ref2 : 0, "minute").valueOf(), "HH:mm")))
            };
        })) !== null && ref3 !== void 0 ? ref3 : []));
    }, [
        actualPickupTime,
        eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes,
        t,
        watchPickupDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            mx: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: t("receiptDate", "受取日")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
                value: watchPickupDate,
                tags: actualPickupTime.map(function(param) {
                    var date = param.date, times = param.times;
                    return {
                        value: String(values_Date/* DateTime.formatDate */.o.formatDate(times[0].time, "YYYY/MM/DD")),
                        label: date
                    };
                }),
                onClick: function(val) {
                    setValue("pickupDate", val);
                    setValue("pickupTime", "00:00");
                    onSubmit(dayjs_min_default()("".concat(val, " 00:00:00"), "YYYY/MM/DD HH:mm:ss").toDate());
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
                value: watchPickupTime,
                tags: pickupTimes,
                onClick: function(val) {
                    setValue("pickupTime", val);
                    onSubmit(dayjs_min_default()("".concat(watchPickupDate, " ").concat(val, ":00"), "YYYY/MM/DD HH:mm:ss").toDate());
                }
            })
        ]
    });
};
var FilterForm_defaultValues = {
    pickupDate: "",
    pickupTime: ""
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleQuantityManagements/template/index.tsx














var ConsoleQuantityManagementsTemplate = function(param) {
    var state = param.state, onRefetch = param.onRefetch;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleQuantityManagement").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleQuantityManagements
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Reload, {
                        onClick: function() {
                            return onRefetch();
                        },
                        edge: "end",
                        color: "white",
                        disabled: state.loading
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionTitleCell, {
                        eventName: state.eventName,
                        loading: state.loading && !state.eventCollection
                    }),
                    state.eventCollection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterForm, {
                        pickupDate: state.pickupDate,
                        eventCollection: state.eventCollection,
                        onSubmit: onRefetch
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonFilterForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ReceiveTimeCell, {
                        loading: state.loading,
                        artistAggregatePickupTimeItems: state.artistAggregatePickupTimeItems
                    })
                ]
            })
        ]
    });
};
var CollectionTitleCell = function(param) {
    var loading = param.loading, eventName = param.eventName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h3",
            width: "70%"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            children: eventName
        })
    });
};
var template_ReceiveTimeCell = function(param) {
    var loading = param.loading, artistAggregatePickupTimeItems = param.artistAggregatePickupTimeItems;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleQuantityManagement").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (!loading && !(artistAggregatePickupTimeItems === null || artistAggregatePickupTimeItems === void 0 ? void 0 : artistAggregatePickupTimeItems.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                py: 6
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                align: "center",
                color: "text.secondary",
                children: t("pickupTimeItemEmptyMessage", "登録商品情報はありません")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            sx: {
                mx: "auto",
                pb: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        minWidth: 104,
                                        pt: 1,
                                        pb: 0,
                                        pl: 0,
                                        border: "none"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("skuName", "商品名/SKU名")
                                    })
                                }),
                                [
                                    "purchaseNumber",
                                    "alreadyUsed",
                                    "残り"
                                ].map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            width: 70,
                                            pt: 1,
                                            pb: 0,
                                            pl: 0,
                                            border: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            children: t(item)
                                        })
                                    }, item);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        loading: loading,
                        hasNextPage: false,
                        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2
                                ];
                            });
                        }),
                        component: TableRow/* default */.Z,
                        colSpan: 4,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Array.from(Array(2).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                pl: 0,
                                                py: 1,
                                                border: "none"
                                            },
                                            colSpan: 4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium",
                                                width: "50%"
                                            })
                                        }),
                                        Array.from(Array(3).keys()).map(function(subKey) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        component: "th",
                                                        sx: {
                                                            pl: 0,
                                                            py: 1
                                                        },
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            flex: 1,
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                                    variant: "rectangular",
                                                                    width: 48,
                                                                    height: 48
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                                    flex: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                                                variant: "small",
                                                                                width: "100%"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                                                variant: "small",
                                                                                width: "40%"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            width: 70,
                                                            pl: 0,
                                                            py: 1
                                                        },
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "small",
                                                            width: "100%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            width: 70,
                                                            pl: 0,
                                                            py: 1
                                                        },
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "small",
                                                            width: "100%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        sx: {
                                                            width: 70,
                                                            pl: 0,
                                                            py: 1
                                                        },
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "small",
                                                            width: "100%"
                                                        })
                                                    })
                                                ]
                                            }, subKey);
                                        })
                                    ]
                                }, key);
                            })
                        }),
                        nodes: artistAggregatePickupTimeItems === null || artistAggregatePickupTimeItems === void 0 ? void 0 : artistAggregatePickupTimeItems.map(function(artistAggregatePickupTimeItem, index) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
                            if (typeof artistAggregatePickupTimeItem === "string") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            pb: 1,
                                            pt: 4,
                                            border: "none"
                                        },
                                        colSpan: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: artistAggregatePickupTimeItem
                                        })
                                    })
                                }, index);
                            }
                            var ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        component: "th",
                                        sx: {
                                            pl: 0,
                                            py: 1
                                        },
                                        scope: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            onClick: function() {
                                                return router.push(generatePath(routerPages.ConsoleItemDetail, {
                                                    itemId: artistAggregatePickupTimeItem.itemId
                                                }));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    variant: "square",
                                                    src: (ref13 = (ref12 = artistAggregatePickupTimeItem === null || artistAggregatePickupTimeItem === void 0 ? void 0 : (ref = artistAggregatePickupTimeItem.sku) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref12 !== void 0 ? ref12 : (ref3 = artistAggregatePickupTimeItem.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.front) === null || ref5 === void 0 ? void 0 : ref5.smallUri) !== null && ref13 !== void 0 ? ref13 : "",
                                                    sx: {
                                                        width: 48,
                                                        height: 48
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            children: artistAggregatePickupTimeItem.item.title
                                                        }),
                                                        !!((ref6 = artistAggregatePickupTimeItem.sku) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sku) === null || ref7 === void 0 ? void 0 : ref7.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "caption",
                                                            children: artistAggregatePickupTimeItem.sku.sku.unitName
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 1
                                        },
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: (ref15 = (ref14 = artistAggregatePickupTimeItem === null || artistAggregatePickupTimeItem === void 0 ? void 0 : (ref8 = artistAggregatePickupTimeItem.sku) === null || ref8 === void 0 ? void 0 : ref8.count) !== null && ref14 !== void 0 ? ref14 : artistAggregatePickupTimeItem.count) !== null && ref15 !== void 0 ? ref15 : 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 1
                                        },
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: (ref17 = (ref16 = artistAggregatePickupTimeItem === null || artistAggregatePickupTimeItem === void 0 ? void 0 : (ref9 = artistAggregatePickupTimeItem.sku) === null || ref9 === void 0 ? void 0 : ref9.completedCount) !== null && ref16 !== void 0 ? ref16 : artistAggregatePickupTimeItem.completedCount) !== null && ref17 !== void 0 ? ref17 : 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 1
                                        },
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: ((ref19 = (ref18 = artistAggregatePickupTimeItem === null || artistAggregatePickupTimeItem === void 0 ? void 0 : (ref10 = artistAggregatePickupTimeItem.sku) === null || ref10 === void 0 ? void 0 : ref10.count) !== null && ref18 !== void 0 ? ref18 : artistAggregatePickupTimeItem.count) !== null && ref19 !== void 0 ? ref19 : 0) - ((ref21 = (ref20 = artistAggregatePickupTimeItem === null || artistAggregatePickupTimeItem === void 0 ? void 0 : (ref11 = artistAggregatePickupTimeItem.sku) === null || ref11 === void 0 ? void 0 : ref11.completedCount) !== null && ref20 !== void 0 ? ref20 : artistAggregatePickupTimeItem.completedCount) !== null && ref21 !== void 0 ? ref21 : 0)
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
var SkeletonFilterForm = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleQuantityManagement").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: t("receiptDate", "受取日")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    pb: 4
                },
                children: Array.from(Array(2).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: Array.from(Array(4).keys()).map(function(subKey) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    px: 3,
                                    py: 1,
                                    borderRadius: 14,
                                    border: function(theme) {
                                        return "1px solid ".concat(theme.palette.grey[100]);
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: 40
                                })
                            }, subKey);
                        })
                    }, key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleQuantityManagements/viewModel.ts






function ConsoleQuantityManagements_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleQuantityManagements(\n    $collectionId: String!\n    $eventId: ID!\n    $pickupDate: Date!\n  ) {\n    artistAggregatePickupTimeItems(\n      eventId: $eventId\n      collectionId: $collectionId\n      pickupDate: $pickupDate\n    ) {\n      ...PickupTimeItemsAggregationDetail\n    }\n    event(id: $eventId) {\n      id\n      title\n      eventCollections(pageInput: { limit: 30 }) {\n        edges {\n          node {\n            ...EventCollectionPickupTime\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleQuantityManagements_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ConsoleQuantityManagements_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref1 = (0,react.useState)(dayjs_min_default()().startOf("d").toDate()), pickupDate = ref1[0], setPickupDate = ref1[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref2 = (0,useQuery/* useQuery */.aM)(ConsoleQuantityManagements_viewModel_QUERY, {
        variables: {
            eventId: router.query.eventId,
            collectionId: router.query.collectionId,
            pickupDate: convertToUtc(dayjs_min_default()().toDate())
        },
        returnPartialData: true
    }), data = ref2.data, loading = ref2.loading, refetch = ref2.refetch;
    var eventCollection = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : ref.eventCollections.edges.find(function(param) {
            var node = param.node;
            return node.collectionId === router.query.collectionId;
        })) === null || ref1 === void 0 ? void 0 : ref1.node;
    }, [
        data === null || data === void 0 ? void 0 : data.event,
        router.query.collectionId
    ]);
    var artistAggregatePickupTimeItems = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.artistAggregatePickupTimeItems)) {
            return null;
        }
        var newData = [];
        data === null || data === void 0 ? void 0 : (ref = data.artistAggregatePickupTimeItems) === null || ref === void 0 ? void 0 : ref.forEach(function(aggregatePickupTime) {
            var ref, ref1;
            if (!aggregatePickupTime.pickupTime) {
                return null;
            }
            //check select pickupTime not same aggregatePickupTime.pickupTime
            if (dayjs_min_default()(aggregatePickupTime.pickupTime).format("YYYY/MM/DD HH:mm:ss") !== dayjs_min_default()(pickupDate).format("YYYY/MM/DD HH:mm:ss") && dayjs_min_default()(pickupDate).format("HH:mm:ss") !== "00:00:00") {
                return null;
            }
            if (!((ref = aggregatePickupTime.items) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
                return !!i;
            }).length)) {
                return null;
            }
            newData = newData.concat([
                values_Date/* DateTime.formatStartEndTime */.o.formatStartEndTime(aggregatePickupTime.pickupTime, eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.validMinutes), 
            ].concat((0,src_to_consumable_array/* default */.Z)(flatten_default()((((ref1 = aggregatePickupTime.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
                return !!i;
            })) || []).map(function(item) {
                var ref;
                if (item === null || item === void 0 ? void 0 : (ref = item.skus) === null || ref === void 0 ? void 0 : ref.length) {
                    return item.skus.map(function(sku) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                            sku: sku
                        });
                    });
                }
                return item;
            })))));
        });
        return newData;
    }, [
        data === null || data === void 0 ? void 0 : data.artistAggregatePickupTimeItems,
        eventCollection,
        pickupDate
    ]);
    var ref3, ref4;
    return {
        state: {
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            loading: loading,
            pickupDate: pickupDate,
            eventCollection: eventCollection,
            eventName: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref4 !== void 0 ? ref4 : "",
            artistAggregatePickupTimeItems: artistAggregatePickupTimeItems
        },
        actions: {
            onRefetch: function onRefetch(val) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setPickupDate(val !== null && val !== void 0 ? val : pickupDate);
                                return [
                                    4,
                                    refetch({
                                        eventId: router.query.eventId,
                                        collectionId: router.query.collectionId,
                                        pickupDate: convertToUtc(dayjs_min_default()(val !== null && val !== void 0 ? val : pickupDate).toDate())
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleQuantityManagements_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleQuantityManagements_viewModel_templateObject(), utoniq_core_schema/* PickupTimeItemsAggregationDetailFragmentDoc */.VDD, utoniq_core_schema/* EventCollectionPickupTimeFragmentDoc */.NoV);
function convertToUtc(dateTime) {
    return dayjs_min_default()(dateTime).startOf("d").format("YYYY-MM-DDT00:00:00.000") + "Z";
}

;// CONCATENATED MODULE: ./src/components/pages/ConsoleQuantityManagements/index.tsx




/**
 * ConsoleQuantityManagements Page
 * Implemented as a practical sample.
 */ var ConsoleQuantityManagements = function() {
    var ref = ConsoleQuantityManagements_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleQuantityManagementsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleRevenue/template/RevenueCell.tsx







var RevenueCell = function(param) {
    var loading = param.loading, openingPayout = param.openingPayout, onApply = param.onApply, salesReport = param.salesReport, transactions = param.transactions, artist = param.artist;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    var ref13 = (0,react.useState)(false), open = ref13[0], setOpen = ref13[1];
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref14, ref15, _formattedTotalSales, _formattedTotalSales1, ref16, ref17, ref18, _formattedTotalBalanceNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            px: 5,
            pb: 6,
            pt: 2,
            mb: 3
        },
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueLoadingBoxCell, {
                        title: t("totalSales"),
                        labels: [
                            t("store"),
                            t("membership"),
                            config_config/* config.modules.liveStream */.v.modules.liveStream ? t("tips") : undefined, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueLoadingBoxCell, {
                        title: t("transferableAmount"),
                        labels: [
                            t("currentSavings"),
                            t("AmountInTheTransfer")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueBoxCell, {
                        title: t("totalSales"),
                        value: (ref14 = salesReport === null || salesReport === void 0 ? void 0 : salesReport.formattedTotalSales) !== null && ref14 !== void 0 ? ref14 : "",
                        items: [
                            {
                                label: t("store"),
                                value: (ref15 = salesReport === null || salesReport === void 0 ? void 0 : (ref = salesReport.store) === null || ref === void 0 ? void 0 : ref.formattedTotalSales) !== null && ref15 !== void 0 ? ref15 : ""
                            },
                            {
                                label: t("membership"),
                                value: (_formattedTotalSales = salesReport === null || salesReport === void 0 ? void 0 : salesReport.subscription.formattedTotalSales) !== null && _formattedTotalSales !== void 0 ? _formattedTotalSales : ""
                            },
                            config_config/* config.modules.liveStream */.v.modules.liveStream ? {
                                label: t("tips"),
                                value: (_formattedTotalSales1 = salesReport === null || salesReport === void 0 ? void 0 : salesReport.tip.formattedTotalSales) !== null && _formattedTotalSales1 !== void 0 ? _formattedTotalSales1 : ""
                            } : undefined, 
                        ]
                    }),
                    !!(transactions === null || transactions === void 0 ? void 0 : (ref1 = transactions.edges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueBoxCell, {
                        title: t("transferableAmount"),
                        value: (ref16 = transactions === null || transactions === void 0 ? void 0 : (ref2 = transactions.edges) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.node) === null || ref4 === void 0 ? void 0 : ref4.formattedTotalBalance) !== null && ref16 !== void 0 ? ref16 : "",
                        items: [
                            {
                                label: t("currentSavings"),
                                value: (ref17 = transactions === null || transactions === void 0 ? void 0 : (ref5 = transactions.edges) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.node) === null || ref7 === void 0 ? void 0 : ref7.formattedBalance) !== null && ref17 !== void 0 ? ref17 : ""
                            },
                            {
                                label: t("AmountInTheTransfer"),
                                value: (ref18 = transactions === null || transactions === void 0 ? void 0 : (ref8 = transactions.edges) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.node) === null || ref10 === void 0 ? void 0 : ref10.formattedBalanceInPayout) !== null && ref18 !== void 0 ? ref18 : ""
                            }, 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCell, {}),
            artist && artist.paymentType !== utoniq_core_schema/* ArtistPaymentType.Billing */.bBx.Billing && artist.status === "active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    width: 244,
                    mx: "auto"
                },
                disabled: ((_formattedTotalBalanceNumber = transactions === null || transactions === void 0 ? void 0 : (ref11 = transactions.edges) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.node.formattedTotalBalanceNumber) !== null && _formattedTotalBalanceNumber !== void 0 ? _formattedTotalBalanceNumber : 0) === 0,
                onClick: function() {
                    return setOpen(true);
                },
                children: t("applyForTransfer")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("titleConfirm"),
                content: t("contentConfirm"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        onApply().then(function() {
                            showMessage(t("transferCompleted"), "success");
                            setOpen(false);
                        });
                    },
                    loading: openingPayout,
                    children: t("okConfirm")
                })
            })
        ]
    });
};
var RevenueBoxCell = function(param) {
    var title = param.title, value = param.value, items = param.items;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            mb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        pb: 1
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                            variant: "h1",
                            children: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            children: t("yen")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: items.map(function(item, index) {
                            return item && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                variant: "h6",
                                                children: item.value
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                children: t("yen")
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
var RevenueLoadingBoxCell = function(param) {
    var title = param.title, labels = param.labels;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            mb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        pb: 1
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        width: "50%"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: labels.map(function(label, index) {
                            return label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: 64
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
var ListCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        component: "ul",
        spacing: 3,
        sx: {
            pl: 4,
            pb: 3,
            mb: 5,
            mt: 0
        },
        children: [
            "note1",
            "note2",
            "note3",
            "note4",
            "note5"
        ].map(function(note) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                component: "li",
                variant: "caption",
                children: t(note)
            }, note);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/console/RevanueLabel/index.tsx




var ContentRevenue;
(function(ContentRevenue) {
    ContentRevenue["deposit"] = "deposit";
    ContentRevenue["withdraw"] = "withdraw";
    ContentRevenue["payout"] = "payout";
    ContentRevenue["bill"] = "bill";
})(ContentRevenue || (ContentRevenue = {}));
var RevenueLabel = function(param) {
    var type = param.type;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    var ref = (0,react.useMemo)(function() {
        switch(type){
            case ContentRevenue.deposit:
                return {
                    bgcolor: "primary.light",
                    text: t("deposit")
                };
            case ContentRevenue.withdraw:
                return {
                    bgcolor: "secondary.light",
                    text: t("withdraw")
                };
            case ContentRevenue.payout:
                return {
                    bgcolor: "info.light",
                    text: t("payout")
                };
            case ContentRevenue.bill:
                return {
                    bgcolor: "info.light",
                    text: t("bill")
                };
            default:
                return {
                    bgcolor: "",
                    text: ""
                };
        }
    }, [
        t,
        type
    ]), bgcolor = ref.bgcolor, text = ref.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        display: "initial",
        sx: {
            bgcolor: bgcolor,
            borderRadius: 4,
            py: 1,
            px: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "black",
            children: text
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleRevenue/template/RevenueHistoryCell.tsx








var RevenueHistoryListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, histories = param.histories, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 3
        },
        children: !(histories === null || histories === void 0 ? void 0 : histories.edges.length) && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            sx: {
                py: 6,
                mt: 3
            },
            align: "center",
            color: "text.secondary",
            children: t("noRevenueHistory")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            sx: {
                mx: "auto",
                pb: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        minWidth: 104,
                                        py: 2,
                                        pl: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: t("dateAndTime")
                                    })
                                }),
                                [
                                    "contents",
                                    "amountOfMoney",
                                    "balance"
                                ].map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "left",
                                        sx: {
                                            minWidth: 77,
                                            py: 2,
                                            pl: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("".concat(item))
                                        })
                                    }, item);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        component: TableRow/* default */.Z,
                        colSpan: 4,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Array.from(Array(7).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            component: "th",
                                            sx: {
                                                pl: 0,
                                                py: 5
                                            },
                                            scope: "row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small",
                                                width: "100%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                pl: 0,
                                                py: 5
                                            },
                                            align: "left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium",
                                                width: "100%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                pl: 0,
                                                py: 5
                                            },
                                            align: "left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small",
                                                width: "100%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                pl: 0,
                                                py: 5
                                            },
                                            align: "left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small",
                                                width: "100%"
                                            })
                                        })
                                    ]
                                }, key);
                            })
                        }),
                        nodes: histories === null || histories === void 0 ? void 0 : histories.edges.map(function(param, index) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        component: "th",
                                        sx: {
                                            pl: 0,
                                            py: 5
                                        },
                                        scope: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: node.formattedCreatedAt
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 5
                                        },
                                        align: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueLabel, {
                                            type: node.type
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 5
                                        },
                                        align: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: [
                                                "\xa5",
                                                node.formattedAmount
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            pl: 0,
                                            py: 5
                                        },
                                        align: "left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: [
                                                "\xa5",
                                                node.formattedBalance
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleRevenue/template/index.tsx















var tabs = [
    "salesManagement",
    "revenueHistory", 
];
var ConsoleRevenueTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onApply = param.onApply, onChangeTab = param.onChangeTab, onExportCSV = param.onExportCSV;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref2.showError, showMessage = ref2.showMessage;
    var ref3 = (0,react.useState)(0), tab = ref3[0], setTab = ref3[1];
    var ref4 = (0,react.useState)(false), exportingRevenueTransactions = ref4[0], setExportingRevenueTransactions = ref4[1];
    var ref5 = (0,react.useState)(null), anchorEl = ref5[0], setAnchorEl = ref5[1];
    var open = Boolean(anchorEl);
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setTab(newValue);
                        return [
                            4,
                            onChangeTab({
                                type: newValue ? "revenueHistory" : "salesManagement"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleRevenue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                hasConsoleFooter: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 3,
                            mt: 2
                        },
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                children: t("title")
                            }),
                            tab === 1 && !!((ref = state.histories) === null || ref === void 0 ? void 0 : ref.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "outlined",
                                        size: "small",
                                        sx: {
                                            borderRadius: 1,
                                            borderColor: "primary.main",
                                            minWidth: 148,
                                            "&.Mui-disabled": {
                                                border: "none"
                                            }
                                        },
                                        onClick: handleClick,
                                        disabled: !state.yearOfRevenues.length || exportingRevenueTransactions,
                                        loading: exportingRevenueTransactions,
                                        loadingPosition: "center",
                                        children: exportingRevenueTransactions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.disabled",
                                            sx: {
                                                mb: "-2px"
                                            },
                                            children: t("downloading")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "primary",
                                                    sx: {
                                                        mb: "-2px"
                                                    },
                                                    children: t("exportCsv")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                                    fontSize: "xSmall",
                                                    color: "primary"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                                        anchorEl: anchorEl,
                                        open: open,
                                        onClose: handleClose,
                                        defaultValue: "",
                                        autoFocus: false,
                                        children: state.yearOfRevenues.map(function(year) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                handleClose();
                                                                setExportingRevenueTransactions(true);
                                                                return [
                                                                    4,
                                                                    onExportCSV(year).then(function() {
                                                                        return showMessage(t("downloadCsvSuccess"), "success");
                                                                    }).catch(function(error) {
                                                                        return showError(error);
                                                                    })
                                                                ];
                                                            case 1:
                                                                _state.sent();
                                                                setExportingRevenueTransactions(false);
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }),
                                                value: year,
                                                sx: {
                                                    width: 160
                                                },
                                                children: t("earningsInfo", {
                                                    year: year
                                                })
                                            }, year);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                        value: tab,
                        onChange: handleChangeTab,
                        disableAnimateTransitions: true,
                        labels: tabs.map(function(tab) {
                            return t("".concat(tab));
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueCell, {
                                loading: state.loading,
                                artist: state.artist,
                                salesReport: state.salesReport,
                                transactions: state.transactions,
                                onApply: onApply,
                                openingPayout: state.openingPayout
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RevenueHistoryListCell, {
                                loading: state.loadingHistories,
                                hasNextPage: state.hasNextPageHistories,
                                onFetchMore: onFetchMore,
                                histories: state.histories
                            })
                        ]
                    }),
                    state.artist && ((ref1 = state.artist) === null || ref1 === void 0 ? void 0 : ref1.paymentType) !== utoniq_core_schema/* ArtistPaymentType.Billing */.bBx.Billing && !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuiznessModal, {
                        artist: state.artist
                    })
                ]
            })
        ]
    });
};
/**
 * ビジネス情報・銀行口座情報を登録していない場合に表示するモーダル
 * https://zpl.io/EmZJpwy
 */ var BuiznessModal = function(param) {
    var artist = param.artist;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    (0,react.useEffect)(function() {
        setOpen((artist === null || artist === void 0 ? void 0 : artist.status) !== "active" || !artist.bank || !artist.business);
    }, [
        artist === null || artist === void 0 ? void 0 : artist.status,
        artist === null || artist === void 0 ? void 0 : artist.bank,
        artist === null || artist === void 0 ? void 0 : artist.business
    ]);
    var titleText = !(artist === null || artist === void 0 ? void 0 : artist.bank) && !(artist === null || artist === void 0 ? void 0 : artist.business) ? "businessAndBank" : !(artist === null || artist === void 0 ? void 0 : artist.bank) ? "bank" : "business";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: function() {
            return setOpen(false);
        },
        title: t("".concat(titleText, "ModalTitle")),
        content: t("".concat(titleText, "ModalContent")),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 5,
            children: [
                !(artist === null || artist === void 0 ? void 0 : artist.bank) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    href: routerPages.ConsoleBankEdit,
                    sx: {
                        minWidth: 212
                    },
                    children: t("registerBankButton")
                }),
                !(artist === null || artist === void 0 ? void 0 : artist.business) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    href: routerPages.ConsoleBusinessEdit,
                    sx: {
                        minWidth: 212
                    },
                    children: t("registerBusinessButton")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleRevenue/viewModel.ts




function ConsoleRevenue_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleRevenue {\n    salesReport {\n      totalSales\n      formattedTotalSales @client\n      store {\n        totalSales\n        formattedTotalSales @client\n      }\n      subscription {\n        totalSales\n        formattedTotalSales @client\n      }\n      tip {\n        totalSales\n        formattedTotalSales @client\n      }\n    }\n    transactions {\n      ...TransactionsConnections\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n      status\n      createdAt\n      bank {\n        id\n      }\n      business {\n        firstNameKana\n        firstNameKanji\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleRevenue_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleRevenue_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ExportRevenueTransactions($year: Int!) {\n    exportRevenueTransactions(year: $year) {\n      csvUrl\n    }\n  }\n"
    ]);
    ConsoleRevenue_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleRevenue_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Transactions($pageInputDate: PageInputDate) {\n    transactions(pageInput: $pageInputDate) {\n      ...TransactionsConnections\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleRevenue_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConsoleRevenue_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation OpenPayout {\n    openPayout {\n      id\n      artistId\n      status\n    }\n  }\n"
    ]);
    ConsoleRevenue_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var ConsoleRevenue_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleRevenue").t;
    var downloadCsv = useDownloadFile().downloadCsv;
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleRevenue_viewModel_QUERY), data = ref4.data, loading = ref4.loading;
    var ref5 = (0,useQuery/* useQuery */.aM)(EXPORT_REVENUE_TRANSACTIONS, {
        skip: true,
        nextFetchPolicy: "network-only",
        fetchPolicy: "network-only"
    }), exportRevenueTransactions = ref5.refetch;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(TRANSACTIONS, {}), 2), fetchTransactions = ref6[0], ref7 = ref6[1], histories = ref7.data, fetchMore = ref7.fetchMore, networkStatus = ref7.networkStatus;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ConsoleRevenue_viewModel_MUTATION), 2), openPayout = ref8[0], ref9 = ref8[1], openingPayout = ref9.loading;
    var yearOfRevenues = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.createdAt)) {
            return [];
        }
        var currentYear = dayjs_min_default()().year();
        var diffYear = dayjs_min_default()(dayjs_min_default()()).diff(data.artist.createdAt, "year");
        return Array.from(Array(diffYear + 1).keys()).map(function(key) {
            return currentYear - key;
        })//limit 5 years
        .slice(0, 5);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.createdAt
    ]);
    var ref10, ref11, ref12, ref13, ref14, ref15;
    return {
        state: {
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            salesReport: (ref11 = data === null || data === void 0 ? void 0 : data.salesReport) !== null && ref11 !== void 0 ? ref11 : null,
            transactions: (ref12 = data === null || data === void 0 ? void 0 : data.transactions) !== null && ref12 !== void 0 ? ref12 : null,
            currentUser: user,
            yearOfRevenues: yearOfRevenues,
            loading: loading,
            loadingHistories: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            openingPayout: openingPayout,
            artist: (ref13 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref13 !== void 0 ? ref13 : null,
            histories: (ref14 = histories === null || histories === void 0 ? void 0 : histories.transactions) !== null && ref14 !== void 0 ? ref14 : null,
            hasNextPageHistories: !!(histories === null || histories === void 0 ? void 0 : (ref1 = histories.transactions) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            membership: (ref15 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products) !== null && ref15 !== void 0 ? ref15 : undefined
        },
        actions: {
            onApply: function onApply() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openPayout()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!fetchMore) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchTransactions({
                                        variables: {
                                            pageInputDate: {
                                                limit: 30
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInputDate: {
                                                cursor: (histories === null || histories === void 0 ? void 0 : (ref = histories.transactions) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onChangeTab: function onChangeTab(param) {
                var type = param.type;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "revenueHistory")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchTransactions()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onExportCSV: function onExportCSV(year) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    exportRevenueTransactions({
                                        year: year
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                if (!data.exportRevenueTransactions.csvUrl) {
                                    throw new Error(t("fileNotFound", {
                                        year: year
                                    }));
                                }
                                return [
                                    4,
                                    downloadCsv(data.exportRevenueTransactions.csvUrl)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleRevenue_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleRevenue_viewModel_templateObject(), utoniq_core_schema/* TransactionsConnectionsFragmentDoc */.I5A);
var EXPORT_REVENUE_TRANSACTIONS = (0,lib/* gql */.Ps)(ConsoleRevenue_viewModel_templateObject1());
var TRANSACTIONS = (0,lib/* gql */.Ps)(ConsoleRevenue_viewModel_templateObject2(), utoniq_core_schema/* TransactionsConnectionsFragmentDoc */.I5A);
var ConsoleRevenue_viewModel_MUTATION = (0,lib/* gql */.Ps)(ConsoleRevenue_viewModel_templateObject3());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleRevenue/index.tsx




/**
 * ConsoleRevenue Page
 * Implemented as a practical sample.
 */ var ConsoleRevenue = function() {
    var ref = ConsoleRevenue_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleRevenueTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceives/template/SearchForm.tsx












var ConsoleTicketReceives_template_SearchForm_SearchForm = function(param) {
    var onSubmit = param.onSubmit, artistId = param.artistId;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceives").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref1 = (0,react.useState)({
        type: utoniq_core_schema/* PickupTicketStatus.All */.IWM.All
    }), options = ref1[0], setOptions = ref1[1];
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = (0,react.useState)(0), selectedIndex = ref3[0], setSelectedIndex = ref3[1];
    var debounceChangeKeyword = (0,react.useRef)(debounce_default()(function(opts) {
        onSubmit(opts);
    }, 300));
    var filterOptions = [
        {
            label: t("pickupTimeOrderAsc"),
            value: utoniq_core_schema/* OrderBy.Asc */.d$J.Asc
        },
        {
            label: t("pickupTimeOrderDesc"),
            value: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc
        }, 
    ];
    (0,react.useEffect)(function() {
        setOptions({
            type: utoniq_core_schema/* PickupTicketStatus.All */.IWM.All,
            isHistory: !!router.query.type,
            searchTerm: "",
            orderBy: undefined
        });
    }, [
        router.pathname
    ]);
    var handleClickListItem = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleMenuItemClick = (0,react.useCallback)(function(event, index) {
        setSelectedIndex(index);
        setAnchorEl(null);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleChangeKeyword = (0,react.useCallback)(function(event) {
        setOptions(function(prevState) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                searchTerm: event.target.value
            });
        });
        debounceChangeKeyword.current((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
            searchTerm: event.target.value
        }));
    }, [
        debounceChangeKeyword,
        options
    ]);
    var _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Search, {
                value: options.searchTerm,
                fullWidth: true,
                placeholder: t("searchPlaceholder"),
                onChange: handleChangeKeyword,
                size: "small",
                sx: {
                    minHeight: 40,
                    mb: 2,
                    bgcolor: function(param) {
                        var palette = param.palette;
                        return "".concat(palette.grey[50], "!important");
                    },
                    ".MuiInputBase-root, input": {
                        bgcolor: "unset"
                    }
                },
                onFocus: function() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_pickupSearch", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: artistId,
                        eventId: router.query.eventId,
                        collectionId: router.query.collectionId
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
                value: (_type = options.type) !== null && _type !== void 0 ? _type : undefined,
                tags: [
                    {
                        label: t("all", "すべて"),
                        value: utoniq_core_schema/* PickupTicketStatus.All */.IWM.All
                    },
                    {
                        label: t("unused", "未使用"),
                        value: utoniq_core_schema/* PickupTicketStatus.Unused */.IWM.Unused
                    },
                    {
                        label: t("alreadyUsed", "使用済"),
                        value: utoniq_core_schema/* PickupTicketStatus.Used */.IWM.Used
                    }, 
                ],
                onClick: function(val) {
                    setOptions(function(prevState) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                            type: val
                        });
                    });
                    onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                        type: val
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    onClick: handleClickListItem,
                    sx: {
                        mr: -1
                    },
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        fontSize: "xSmall"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: (ref = filterOptions[selectedIndex]) === null || ref === void 0 ? void 0 : ref.label
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: filterOptions.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        selected: index === selectedIndex,
                        sx: {
                            minWidth: 200
                        },
                        onClick: function(event) {
                            handleMenuItemClick(event, index);
                            setOptions(function(prevState) {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prevState), {
                                    orderBy: option.value
                                });
                            });
                            onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                                orderBy: option.value
                            }));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: option.label
                        })
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceives/template/index.tsx













var ConsoleTicketReceivesTemplate = function(param) {
    var state = param.state, onRefresh = param.onRefresh, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceives").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleTicketReceives
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title"),
                    right: !state.type && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            mr: -1,
                            p: 0,
                            width: "max-content"
                        },
                        href: generatePath(routerPages.ConsoleTicketReceives, {
                            type: "history",
                            eventId: state.eventId,
                            collectionId: state.collectionId
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            sx: {
                                color: "white"
                            },
                            children: t("pastReceiptManagement")
                        })
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 4
                        },
                        children: state.loading && !state.collection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h3",
                            width: "75%"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h3",
                            children: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTicketReceives_template_SearchForm_SearchForm, {
                        artistId: state.artistId,
                        onSubmit: onRefresh
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTicketReceives_template_ReceiveTimeCell, {
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        eventPickupUsers: state.eventPickupUsers,
                        onFetchMore: onFetchMore
                    })
                ]
            })
        ]
    });
};
var ConsoleTicketReceives_template_ReceiveTimeCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, eventPickupUsers = param.eventPickupUsers;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceives").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: eventPickupUsers.map(function(param) {
                var pickupUsers = param.pickupUsers, formattedPickupStartEndTime = param.formattedPickupStartEndTime;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveTimeItemCell, {
                    pickupUsers: pickupUsers,
                    formattedPickupStartEndTime: formattedPickupStartEndTime
                }, formattedPickupStartEndTime);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 0
            },
            emptyMessage: t("receiveTimeEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveTimeItemSkeleton, {})
        })
    });
};
var ReceiveTimeItemCell = function(param) {
    var formattedPickupStartEndTime = param.formattedPickupStartEndTime, pickupUsers = param.pickupUsers;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceives").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var isPaymentByPoint = (0,react.useCallback)(function(pickupUser) {
        return pickupUser.cartTransactionOrders.some(function(value) {
            return value.paymentType === utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint;
        });
    }, []);
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    py: 4
                },
                children: t("pickupTime", {
                    date: formattedPickupStartEndTime
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: pickupUsers.map(function(pickupUser, index) {
                    var ref, ref2, ref3, ref4;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                            href: generatePath(routerPages.ConsoleTicketReceiveDetail, {
                                eventId: pickupUser.eventId,
                                collectionId: pickupUser.collectionId,
                                pickupUserId: pickupUser.id
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                sx: {
                                    px: 4,
                                    py: 3,
                                    "&:last-child": {
                                        pb: 3
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCategory, {
                                                    isUsed: !!pickupUser.isCompleted
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            children: (ref1 = (ref = pickupUser.user) === null || ref === void 0 ? void 0 : ref.fullName) !== null && ref1 !== void 0 ? ref1 : pickupUser.user.displayName
                                                        }),
                                                        !!((ref2 = pickupUser.user) === null || ref2 === void 0 ? void 0 : ref2.formattedPhoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "body2",
                                                            color: "text.secondary",
                                                            children: [
                                                                "（",
                                                                (ref3 = pickupUser.user) === null || ref3 === void 0 ? void 0 : ref3.formattedPhoneNumber,
                                                                "）"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                color: "text.secondary",
                                                children: (ref4 = pickupUser.user) === null || ref4 === void 0 ? void 0 : ref4.email
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 4,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "caption",
                                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(3),
                                                        children: pickupUser.itemsString
                                                    })
                                                }),
                                                isPaymentByPoint(pickupUser) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    justifyContent: "center",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                                            fontSize: "medium"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                            variant: "h5",
                                                            children: pickupUser.formattedActualTotalAmount
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                    variant: "h5",
                                                    children: t("price", {
                                                        price: pickupUser.formattedActualTotalAmount
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
var ExchangeCategory = function(param) {
    var isUsed = param.isUsed;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceives").t;
    var ref = (0,react.useMemo)(function() {
        if (isUsed) return {
            bgcolor: "grey.300",
            text: t("alreadyUsed")
        };
        return {
            bgcolor: "primary.main",
            text: t("unused")
        };
    }, [
        isUsed,
        t
    ]), bgcolor = ref.bgcolor, text = ref.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 20,
            borderRadius: "2px",
            bgcolor: bgcolor,
            py: "2px",
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "white",
            variant: "overline",
            children: text
        })
    });
};
var ReceiveTimeItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "subtitle1",
                    width: "75%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: Array.from(Array(3).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                px: 4,
                                py: 3,
                                "&:last-child": {
                                    pb: 3
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "flex-end",
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        flex: 1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "h3"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        flex: 4,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                            variant: "h3"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small",
                                                numberOfLine: 2
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "h3"
                                        })
                                    })
                                ]
                            })
                        })
                    }, key);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceiveDetail/template/index.tsx













var ConsoleTicketReceiveDetailTemplate = function(param) {
    var state = param.state, onUseTickets = param.onUseTickets, onUnuseTickets = param.onUnuseTickets;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceiveDetail").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleTicketReceiveDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDetailSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoSkeleton, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDetailCell, {
                            pickupUser: state.pickupUser,
                            items: state.items,
                            onUseTickets: onUseTickets,
                            onUnuseTickets: onUnuseTickets
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_UserInfoCell, {
                            user: (ref = state.pickupUser) === null || ref === void 0 ? void 0 : ref.user
                        })
                    ]
                })
            })
        ]
    });
};
var TicketDetailCell = function(param) {
    var pickupUser = param.pickupUser, items = param.items, onUseTickets = param.onUseTickets, onUnuseTickets = param.onUnuseTickets;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceiveDetail").t;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), openUseConfirm = ref1[0], setOpenUseConfirm = ref1[1];
    var ref2 = (0,react.useState)(false), openUnuseConfirm = ref2[0], setOpenUnuseConfirm = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    py: 4
                },
                children: t("ticketIHave", "持っているチケット")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pb: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCategory, {
                                    isUsed: !!(pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isCompleted)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("receiptDate", "受け取り日時：")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.formattedPickupStartEndTime
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            children: pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.user.fullName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                    children: [
                                        t("accountName", "アカウント名"),
                                        ":"
                                    ]
                                }),
                                " ",
                                pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.user.displayName
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                pb: 2,
                                pt: 4
                            },
                            children: pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.collection.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 4,
                            sx: {
                                pb: 4
                            },
                            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                var order = pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.pickupOrder.find(function(param) {
                                    var itemId = param.itemId;
                                    return itemId === item.id;
                                });
                                var quantity = item.item.sku ? order === null || order === void 0 ? void 0 : order.serials.filter(function(param) {
                                    var skuId = param.skuId;
                                    var ref;
                                    return skuId === ((ref = item.item.sku) === null || ref === void 0 ? void 0 : ref.id);
                                }).length : order === null || order === void 0 ? void 0 : order.count;
                                if (!quantity) return null;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedTicketItemCell, {
                                    item: item.item,
                                    quantity: quantity
                                }, index);
                            })
                        }),
                        !(pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isCompleted) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            size: "large",
                            onClick: function() {
                                return setOpenUseConfirm(true);
                            },
                            children: t("markUsed", "使用済みにする")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            variant: "outlined",
                            size: "large",
                            onClick: function() {
                                return setOpenUnuseConfirm(true);
                            },
                            sx: {
                                color: "primary.main",
                                borderColor: "primary.main"
                            },
                            children: t("leaveUnused", "未使用にする")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openUseConfirm,
                title: t("confirmMarkUserTitle"),
                content: "",
                onClose: function() {
                    return setOpenUseConfirm(false);
                },
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: loading,
                    disabled: loading,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setLoading(true);
                                    return [
                                        4,
                                        onUseTickets()
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenUseConfirm(false);
                                    setLoading(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("change")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openUnuseConfirm,
                title: t("confirmUnMarkUserTitle"),
                content: "",
                onClose: function() {
                    return setOpenUnuseConfirm(false);
                },
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: loading,
                    disabled: loading,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setLoading(true);
                                    return [
                                        4,
                                        onUnuseTickets()
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenUnuseConfirm(false);
                                    setLoading(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("change")
                })
            })
        ]
    });
};
var TicketDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "75%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            sx: {
                                pb: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "large",
                                        width: "100%"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "large",
                                        width: "75%"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h3",
                                width: "60%"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 4,
                            sx: {
                                pb: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        width: 60,
                                        height: 96
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "h3",
                                                width: "40%"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: "100%",
                            height: 44,
                            sx: {
                                borderRadius: 34
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var template_UserInfoCell = function(param) {
    var user = param.user;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceiveDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    pb: 3
                },
                children: t("customerInfo", "お客様情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    bgcolor: "transparent",
                    borderColor: "grey.200",
                    borderWidth: 1,
                    borderStyle: "solid"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        py: 4,
                        px: 20,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("shippingAddress", "住所")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("phoneNumber", "電話番号")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: user === null || user === void 0 ? void 0 : user.formattedPhoneNumber
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("email", "メールアドレス")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: user === null || user === void 0 ? void 0 : user.email
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var UserInfoSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "75%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    bgcolor: "transparent",
                    borderColor: "grey.200",
                    borderWidth: 1,
                    borderStyle: "solid"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        py: 4,
                        px: 20,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "30%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "100%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "30%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "100%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 1,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "30%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "100%"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var OwnedTicketItemCell = function(param) {
    var item = param.item, quantity = param.quantity;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleTicketReceiveDetail").t;
    var formattedPrice = (0,react.useMemo)(function() {
        var ref;
        if (item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.price) {
            var ref1;
            var ref2;
            return (ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.formattedPrice) !== null && ref2 !== void 0 ? ref2 : "0";
        }
        var ref3;
        return (ref3 = item === null || item === void 0 ? void 0 : item.formattedPrice) !== null && ref3 !== void 0 ? ref3 : "0";
    }, [
        item === null || item === void 0 ? void 0 : item.formattedPrice,
        item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.formattedPrice,
        item === null || item === void 0 ? void 0 : (ref1 = item.sku) === null || ref1 === void 0 ? void 0 : ref1.price
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 3,
        sx: {
            pb: 4
        },
        children: [
            ((ref2 = item.thumbnail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.front) === null || ref3 === void 0 ? void 0 : ref3.mediumUri) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                size: "small",
                src: item.thumbnail.front.mediumUri
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 60,
                height: 96
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 1,
                sx: {
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: item.title
                            }),
                            !!item.sku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: (ref4 = item.sku) === null || ref4 === void 0 ? void 0 : ref4.unitName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("itemPrice", "\xa5", {
                                    price: formattedPrice
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("itemQuantity", "数量", {
                                    quantity: quantity
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceiveDetail/viewModel.ts




function ConsoleTicketReceiveDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleTicketReceiveDetail(\n    $collectionId: String!\n    $eventId: String!\n    $pickupUserId: ID!\n  ) {\n    artistPickupUser(\n      collectionId: $collectionId\n      eventId: $eventId\n      pickupUserId: $pickupUserId\n    ) {\n      ...PickupUserDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleTicketReceiveDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleTicketReceiveDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUseEventPickupTickets($inputs: UseEventPickupTicketsInput!) {\n    artistUseEventPickupTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleTicketReceiveDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleTicketReceiveDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArtistUnuseEventPickupTickets(\n    $inputs: UnuseEventPickupTicketsInput!\n  ) {\n    artistUnuseEventPickupTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleTicketReceiveDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ConsoleTicketReceiveDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleTicketReceiveDetail_viewModel_QUERY, {
        variables: {
            eventId: router.query.eventId,
            collectionId: router.query.collectionId,
            pickupUserId: router.query.pickupUserId
        }
    }), data = ref1.data, loading = ref1.loading;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_USE_EVENT_PICKUP_TICKETS), 1), artistUseTickets = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ARTIST_UNUSE_EVENT_PICKUP_TICKETS), 1), artistUnuseTickets = ref3[0];
    var ref4, ref5;
    return {
        state: {
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            pickupUser: (ref5 = data === null || data === void 0 ? void 0 : data.artistPickupUser) !== null && ref5 !== void 0 ? ref5 : null,
            loading: loading,
            items: spreadUserItemsBySku(data === null || data === void 0 ? void 0 : (ref = data.artistPickupUser) === null || ref === void 0 ? void 0 : ref.userItems)
        },
        actions: {
            onUseTickets: function onUseTickets() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var items;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                items = data === null || data === void 0 ? void 0 : data.artistPickupUser.ticketItemSerialsInput;
                                if (!items) return [
                                    2
                                ];
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_useTicket", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: router.query.eventId,
                                    collectionId: router.query.collectionId,
                                    asArtist: true
                                });
                                return [
                                    4,
                                    artistUseTickets({
                                        variables: {
                                            inputs: {
                                                eventId: router.query.eventId,
                                                collectionId: router.query.collectionId,
                                                pickupUserId: router.query.pickupUserId
                                            }
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUnuseTickets: function onUnuseTickets() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var items;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                items = data === null || data === void 0 ? void 0 : data.artistPickupUser.ticketItemSerialsInput;
                                if (!items) return [
                                    2
                                ];
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_unuseTicket", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: router.query.eventId,
                                    collectionId: router.query.collectionId,
                                    asArtist: true
                                });
                                return [
                                    4,
                                    artistUnuseTickets({
                                        variables: {
                                            inputs: {
                                                eventId: router.query.eventId,
                                                collectionId: router.query.collectionId,
                                                pickupUserId: router.query.pickupUserId
                                            }
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleTicketReceiveDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleTicketReceiveDetail_viewModel_templateObject(), utoniq_core_schema/* PickupUserDetailFragmentDoc */.gSK);
var ARTIST_USE_EVENT_PICKUP_TICKETS = (0,lib/* gql */.Ps)(ConsoleTicketReceiveDetail_viewModel_templateObject1(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);
var ARTIST_UNUSE_EVENT_PICKUP_TICKETS = (0,lib/* gql */.Ps)(ConsoleTicketReceiveDetail_viewModel_templateObject2(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceiveDetail/index.tsx




/**
 * ConsoleTicketReceiveDetail Page
 * Implemented as a practical sample.
 */ var ConsoleTicketReceiveDetail = function() {
    var ref = ConsoleTicketReceiveDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTicketReceiveDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/values.js
var values = __webpack_require__(98346);
var values_default = /*#__PURE__*/__webpack_require__.n(values);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceives/viewModel.ts



function ConsoleTicketReceives_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleTicketReceives(\n    $collectionId: String!\n    $colId: ID!\n    $eventId: String!\n    $options: EventPickupUsersOptions!\n    $pageInput: PageInput\n  ) {\n    collection(id: $colId) {\n      id\n      title\n      artist {\n        id\n      }\n    }\n    artistEventPickupUsers(\n      collectionId: $collectionId\n      eventId: $eventId\n      options: $options\n      pageInput: $pageInput\n    ) {\n      ...EventPickupUserConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleTicketReceives_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleTicketReceives_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewConsoleTicketReceives(\n    $collectionId: String!\n    $eventId: String!\n    $options: EventPickupUsersOptions!\n    $pageInput: PageInput\n  ) {\n    artistEventPickupUsers(\n      collectionId: $collectionId\n      eventId: $eventId\n      options: $options\n      pageInput: $pageInput\n    ) {\n      ...EventPickupUserConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleTicketReceives_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var ConsoleTicketReceives_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = (0,react.useState)({
        type: utoniq_core_schema/* PickupTicketStatus.All */.IWM.All,
        isHistory: !!router.query.type
    }), filterOptions = ref[0], setFilterOptions = ref[1];
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_TICKET_RECEIVES,
        variables: {
            eventId: router.query.eventId,
            collectionId: router.query.collectionId,
            options: filterOptions
        },
        fields: [
            {
                fragmentName: "PickupUserBox",
                fieldName: "artistEventPickupUsers",
                fragment: utoniq_core_schema/* PickupUserBoxFragmentDoc */.$G_
            }, 
        ]
    }).isFirstLoadRef;
    var ref1 = (0,useQuery/* useQuery */.aM)(ConsoleTicketReceives_viewModel_QUERY, {
        variables: {
            eventId: router.query.eventId,
            collectionId: router.query.collectionId,
            colId: router.query.collectionId,
            options: filterOptions
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref1.data, loading = ref1.loading, refetch = ref1.refetch, fetchMore = ref1.fetchMore;
    (0,react.useEffect)(function() {
        var ref;
        if (loading || !!(data === null || data === void 0 ? void 0 : data.artistEventPickupUsers.edges.length)) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            artistId: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artist.id,
            eventId: router.query.eventId,
            name: "pickupSearch"
        });
    }, [
        loading
    ]);
    var eventPickupUsers = (0,react.useMemo)(function() {
        if (!(data === null || data === void 0 ? void 0 : data.artistEventPickupUsers.edges.length)) return [];
        return values_default()(data.artistEventPickupUsers.edges.reduce(function(acc, param) {
            var node = param.node;
            var _formattedPickupStartEndTime;
            var key = (_formattedPickupStartEndTime = node.formattedPickupStartEndTime) !== null && _formattedPickupStartEndTime !== void 0 ? _formattedPickupStartEndTime : "";
            if (!acc[key]) {
                acc[key] = {
                    formattedPickupStartEndTime: node.formattedPickupStartEndTime,
                    pickupUsers: [
                        node
                    ]
                };
                return acc;
            }
            acc[key].pickupUsers.push(node);
            return acc;
        }, {}));
    }, [
        data === null || data === void 0 ? void 0 : data.artistEventPickupUsers.edges
    ]);
    (0,react.useEffect)(function() {
        setFilterOptions({
            type: utoniq_core_schema/* PickupTicketStatus.All */.IWM.All,
            isHistory: !!router.query.type,
            orderBy: undefined,
            searchTerm: ""
        });
    }, [
        router.query.type
    ]);
    var ref2, ref3;
    return {
        state: {
            collection: (ref2 = data === null || data === void 0 ? void 0 : data.collection) !== null && ref2 !== void 0 ? ref2 : null,
            loading: loading,
            type: router.query.type,
            collectionId: router.query.collectionId,
            eventId: router.query.eventId,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.artistEventPickupUsers.pageInfo.hasNextPage),
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            eventPickupUsers: eventPickupUsers
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            eventId: router.query.eventId,
                                            collectionId: router.query.collectionId,
                                            colId: router.query.collectionId,
                                            options: filterOptions,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.artistEventPickupUsers.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRefresh: function onRefresh(options) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setFilterOptions(options);
                                return [
                                    4,
                                    refetch({
                                        options: options,
                                        eventId: router.query.eventId,
                                        collectionId: router.query.collectionId,
                                        colId: router.query.collectionId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleTicketReceives_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleTicketReceives_viewModel_templateObject(), utoniq_core_schema/* EventPickupUserConnectionFragmentDoc */.mht);
var FETCH_NEW_TICKET_RECEIVES = (0,lib/* gql */.Ps)(ConsoleTicketReceives_viewModel_templateObject1(), utoniq_core_schema/* EventPickupUserConnectionFragmentDoc */.mht);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleTicketReceives/index.tsx




/**
 * ConsoleTicketReceives Page
 * Implemented as a practical sample.
 */ var ConsoleTicketReceives = function() {
    var ref = ConsoleTicketReceives_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleTicketReceivesTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUnpublishedPosts/template/index.tsx










var ConsoleUnpublishedPostsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onDeletePost = param.onDeletePost, onFilter = param.onFilter;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUnpublishedPosts").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref2.routerNames, routerPages = ref2.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleUnpublishedPosts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                hasConsoleFooter: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsolePost,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SearchForm_SearchForm, {
                        hiddenFilter: !((ref = state.posts) === null || ref === void 0 ? void 0 : ref.edges.length),
                        onSubmit: onFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                            nodes: (ref1 = state.posts) === null || ref1 === void 0 ? void 0 : ref1.edges.map(function(param) {
                                var node = param.node;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, {
                                    loadingDeletePost: state.loadingDeletePost,
                                    onDeletePost: onDeletePost,
                                    post: node,
                                    fullWidth: true,
                                    isConsole: true,
                                    userId: state.userId
                                });
                            }),
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: onFetchMore,
                            emptyMessage: t("emptyPost"),
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                sx: {
                                    pb: 2
                                },
                                children: Array.from(Array(3).keys()).map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBoxSkeleton, {
                                        fullWidth: true
                                    }, key);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUnpublishedPosts/viewModel.ts







var ConsoleUnpublishedPosts_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref4;
    var ref5 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ConsolePost */.VjB, {
        variables: {
            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
            status: [
                utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled
            ],
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
            pageInput: {
                limit: 10
            },
            pageInputById: {
                limit: 10
            }
        },
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, fetchMore = ref5.fetchMore, refetch = ref5.refetch, networkStatus = ref5.networkStatus;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeletePost */.x92), 2), deletePost = ref6[0], ref7 = ref6[1], loadingDeletePost = ref7.loading;
    var ref8, ref9, ref10;
    return {
        state: {
            userId: (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) || "",
            artistId: (ref8 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref8 !== void 0 ? ref8 : "",
            loadingDeletePost: loadingDeletePost,
            artist: (ref9 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref9 !== void 0 ? ref9 : null,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.posts) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            posts: (ref10 = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.posts) !== null && ref10 !== void 0 ? ref10 : null
        },
        actions: {
            onFilter: function onFilter(resourceType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        artistId: (ref = user === null || user === void 0 ? void 0 : user.uid) !== null && ref !== void 0 ? ref : "",
                                        resourceType: resourceType.type,
                                        status: [
                                            utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled
                                        ],
                                        resourceTypes: resourceType.types,
                                        storyFilter: resourceType.storyFilter,
                                        // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                        pageInput: {
                                            cursor: null,
                                            limit: 10
                                        },
                                        pageInputById: {
                                            cursor: null,
                                            limit: 10
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistId: (ref4 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref4 !== void 0 ? ref4 : "",
                                            status: [
                                                utoniq_core_schema/* PostStatus.Scheduled */.$4T.Scheduled
                                            ],
                                            // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.posts) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor,
                                                limit: 3
                                            },
                                            pageInputById: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.posts) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor,
                                                limit: 3
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeletePost: function onDeletePost(postId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePost({
                                        variables: {
                                            postId: postId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUnpublishedPosts/index.tsx




/**
 * ConsolePostsSchedule Page
 * Implemented as a practical sample.
 */ var ConsoleUnpublishedPosts = function() {
    var ref = ConsoleUnpublishedPosts_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUnpublishedPostsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserDetail/template/index.tsx
















var ConsoleUserDetailTemplate = function(param) {
    var state = param.state;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref2.routerNames, routerPages = ref2.routerPages;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleUserDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.ConsoleUsers,
                    title: (ref3 = (ref = state.user) === null || ref === void 0 ? void 0 : ref.fullName) !== null && ref3 !== void 0 ? ref3 : (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.displayName
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAreaCell, {
                        user: state.user,
                        loading: state.loading,
                        isFollower: state.isFollower,
                        membership: state.membership
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDataCell, {
                        user: state.user,
                        loading: state.loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipDataCell, {
                        enableFavoriteMembers: state.enableFavoriteMembers,
                        product: state.product,
                        loading: state.loading,
                        membership: state.membership
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDataCell, {
                        orderCount: state.orderCount,
                        user: state.user,
                        loading: state.loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemsDataCell, {
                        user: state.user,
                        loading: state.loading,
                        unusedTicketCount: state.unusedTicketCount
                    })
                ]
            })
        ]
    });
};
var UserAreaCell = function(param) {
    var user = param.user, loading = param.loading, isFollower = param.isFollower, membership = param.membership;
    var ref;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                pt: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        sx: {
                            width: 64,
                            height: 64
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "large",
                                width: "40%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "large",
                                width: "25%"
                            })
                        ]
                    })
                ]
            })
        });
    }
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    src: (ref1 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                    sx: {
                        width: 64,
                        height: 64
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            children: (ref2 = user === null || user === void 0 ? void 0 : user.fullName) !== null && ref2 !== void 0 ? ref2 : user === null || user === void 0 ? void 0 : user.displayName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                isFollower && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowerTag, {}),
                                membership && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberWhetTag, {
                                    month: (ref3 = membership === null || membership === void 0 ? void 0 : membership.continueMonth) !== null && ref3 !== void 0 ? ref3 : 0
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var UserDataCell = function(param) {
    var user = param.user, loading = param.loading;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail").t;
    var ref1, ref2;
    var userData = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                label: t("email"),
                content: user === null || user === void 0 ? void 0 : user.email
            },
            {
                label: t("gender"),
                content: t((ref1 = user === null || user === void 0 ? void 0 : user.gender) !== null && ref1 !== void 0 ? ref1 : "")
            },
            {
                label: t("birthday"),
                content: user === null || user === void 0 ? void 0 : user.formattedBirthday
            },
            {
                label: t("phoneNumber"),
                content: user === null || user === void 0 ? void 0 : user.formattedPhoneNumber
            },
            {
                label: t("address"),
                content: (ref2 = user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress) !== null && ref2 !== void 0 ? ref2 : ""
            }, 
        ];
    }, [
        t,
        user === null || user === void 0 ? void 0 : user.email,
        user === null || user === void 0 ? void 0 : user.gender,
        user === null || user === void 0 ? void 0 : user.formattedBirthday,
        user === null || user === void 0 ? void 0 : user.formattedPhoneNumber,
        user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress, 
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 8,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "15%"
                }),
                userData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                sx: {
                                    py: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "medium",
                                        width: "15%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium",
                                            numberOfLine: data.label === t("address") ? 2 : 1,
                                            width: "60%"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    }, index);
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 8,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                sx: {
                    pb: 1
                },
                children: t("userInformation", "顧客情報")
            }),
            userData.map(function(data, index) {
                return /*#__PURE__*/ (0,react.createElement)(UserDataListCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                    key: index
                }));
            })
        ]
    });
};
var MembershipDataCell = function(param) {
    var loading = param.loading, enableFavoriteMembers = param.enableFavoriteMembers, product = param.product, membership = param.membership;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail").t;
    var ref3;
    var userData = (0,react.useMemo)(function() {
        var ref, ref1;
        return [
            {
                label: t("planName"),
                content: membership === null || membership === void 0 ? void 0 : (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.title
            }, 
        ].concat(// formattedMembershipNumberがあるときだけ表示
        (0,src_to_consumable_array/* default */.Z)((membership === null || membership === void 0 ? void 0 : membership.formattedMembershipNumber) ? [
            {
                label: t("memberNumber"),
                content: membership.formattedMembershipNumber
            }, 
        ] : []), (0,src_to_consumable_array/* default */.Z)(enableFavoriteMembers ? [
            {
                label: t("favoriteMember"),
                content: (membership === null || membership === void 0 ? void 0 : (ref1 = membership.favoriteMember) === null || ref1 === void 0 ? void 0 : ref1.name) || "-"
            }, 
        ] : []), [
            {
                label: t("joinDate"),
                content: membership === null || membership === void 0 ? void 0 : membership.formattedCreatedAt
            },
            {
                label: t("continueMonth"),
                content: t("continueMonthValue", {
                    month: membership === null || membership === void 0 ? void 0 : membership.continueMonth
                })
            },
            {
                label: t("paymentMethod"),
                content: t("".concat((ref3 = membership === null || membership === void 0 ? void 0 : membership.paymentMethod) !== null && ref3 !== void 0 ? ref3 : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard, "_").concat(product === null || product === void 0 ? void 0 : product.plan.interval))
            }, 
        ]);
    }, [
        t,
        membership === null || membership === void 0 ? void 0 : (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.title,
        membership === null || membership === void 0 ? void 0 : membership.formattedMembershipNumber,
        enableFavoriteMembers,
        membership === null || membership === void 0 ? void 0 : (ref1 = membership.favoriteMember) === null || ref1 === void 0 ? void 0 : ref1.name,
        membership === null || membership === void 0 ? void 0 : membership.formattedCreatedAt,
        membership === null || membership === void 0 ? void 0 : membership.continueMonth,
        membership === null || membership === void 0 ? void 0 : membership.paymentMethod,
        product === null || product === void 0 ? void 0 : (ref2 = product.plan) === null || ref2 === void 0 ? void 0 : ref2.interval, 
    ]);
    if (!membership || !product) return null;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 8,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "15%"
                }),
                userData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                sx: {
                                    py: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "medium",
                                        width: "15%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium",
                                            numberOfLine: data.label === t("address") ? 2 : 1,
                                            lastWidth: data.label === t("address") ? "75%" : "60%"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    }, index);
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 8,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                sx: {
                    pb: 1
                },
                children: t("membershipInformation", "メンバーシップ情報")
            }),
            userData.map(function(data, index) {
                return /*#__PURE__*/ (0,react.createElement)(UserDataListCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                    key: index
                }));
            })
        ]
    });
};
var OrderDataCell = function(param) {
    var user = param.user, loading = param.loading, orderCount = param.orderCount;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var userData = (0,react.useMemo)(function() {
        return [
            {
                label: t("orderCount"),
                content: orderCount
            }
        ];
    }, [
        orderCount,
        t
    ]);
    if (!loading && !orderCount) return null;
    if (loading || !user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 8,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "15%"
                }),
                userData.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                sx: {
                                    py: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "medium",
                                        width: "15%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium",
                                            numberOfLine: 1,
                                            lastWidth: "60%"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    }, index);
                })
            ]
        });
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 8,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    pb: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("orderInformation", "注文情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: generatePath(routerPages.ConsoleUserOrders, {
                            userId: (ref1 = user === null || user === void 0 ? void 0 : user.id) !== null && ref1 !== void 0 ? ref1 : "#"
                        }),
                        variant: "text",
                        children: t("orders", "注文一覧")
                    })
                ]
            }),
            userData.map(function(data, index) {
                return /*#__PURE__*/ (0,react.createElement)(UserDataListCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                    key: index
                }));
            })
        ]
    });
};
var UserDataListCell = function(param) {
    var label = param.label, content = param.content, contentProps = param.contentProps, icon = param.icon;
    var ref = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail"), i18n = ref.i18n, t = ref.t;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                alignItems: "center",
                sx: {
                    py: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            minWidth: i18n.language === "en" ? 115 : 65
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        minWidth: 0,
                        children: [
                            (contentProps === null || contentProps === void 0 ? void 0 : contentProps.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                component: "a",
                                variant: "body2"
                            }, contentProps), {
                                sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                children: content
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                variant: "body2"
                            }, contentProps), {
                                sx: label === t("address") ? {
                                    wordBreak: "break-all"
                                } : (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                children: content
                            })),
                            icon,
                            label === t("email") && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:" + content,
                                style: {
                                    lineHeight: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Mail, {
                                    sx: {
                                        ml: 1
                                    },
                                    color: "primary"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
        ]
    });
};
var FollowerTag = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            height: 16,
            borderRadius: "2px",
            py: 1,
            bgcolor: "secondary.main"
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            display: "block",
            sx: {
                color: "white",
                textTransform: "unset"
            },
            children: t("follower")
        })
    });
};
var OwnedItemsDataCell = function(param) {
    var user = param.user, loading = param.loading, unusedTicketCount = param.unusedTicketCount;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 8,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "medium",
                    width: "15%"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 3,
                            alignItems: "center",
                            sx: {
                                py: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    width: "15%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "medium",
                                        numberOfLine: 1,
                                        lastWidth: "60%"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                    ]
                })
            ]
        });
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 8,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    pb: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("ownedItemsInformation", "所有アイテム一覧")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: generatePath(routerPages.ConsoleUserOwnedItems, {
                            userId: (ref1 = user === null || user === void 0 ? void 0 : user.id) !== null && ref1 !== void 0 ? ref1 : "#"
                        }),
                        variant: "text",
                        children: t("toItemsList", "所有アイテム一覧")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDataListCell, {
                label: t("unusedTicket", "未使用チケット"),
                content: unusedTicketCount
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserDetail/viewModel.ts




function ConsoleUserDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleUserDetail($userId: ID!) {\n    artist {\n      id\n      settings {\n        features {\n          subscription {\n            enableFavoriteMembers\n          }\n        }\n      }\n      subscription {\n        productId\n        plans {\n          ...ConsolePlanDetail\n        }\n        products {\n          ...ConsoleProductDetail\n        }\n      }\n    }\n    artistCustomer(userId: $userId) {\n      id\n      purchaseCount\n      ticketUnusedCount\n      follower {\n        id\n      }\n      patron {\n        ...MemberBox\n      }\n      user {\n        ...ConsoleUserDetailUser\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ConsoleUserDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleUserDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchConsoleUserDetail($userId: ID!) {\n    user(id: $userId) {\n      ...ConsoleUserDetailUser\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleUserDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ConsoleUserDetail_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(FETCH_USER, {
        variables: {
            userId: router.query.userId
        }
    }), 2), fetchUserData = ref12[0], ref13 = ref12[1], fetchData = ref13.data;
    var ref14 = (0,useQuery/* useQuery */.aM)(ConsoleUserDetail_viewModel_QUERY, {
        variables: {
            userId: router.query.userId
        },
        onCompleted: function onCompleted(param) {
            var artistCustomer = param.artistCustomer;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!(artistCustomer === null || artistCustomer === void 0 ? void 0 : artistCustomer.user)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                fetchUserData()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), data = ref14.data, loading = ref14.loading;
    var product = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artistCustomer) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId)) return null;
        return getProductByPlanId(data === null || data === void 0 ? void 0 : data.artist, data === null || data === void 0 ? void 0 : (ref3 = data.artistCustomer) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.patron) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription) === null || ref5 === void 0 ? void 0 : ref5.planId);
    }, [
        data === null || data === void 0 ? void 0 : data.artist,
        data === null || data === void 0 ? void 0 : (ref = data.artistCustomer) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId
    ]);
    var ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    return {
        state: {
            loading: loading,
            artistId: (ref15 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref15 !== void 0 ? ref15 : "",
            enableFavoriteMembers: (ref16 = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.settings) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.features) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.subscription) === null || ref6 === void 0 ? void 0 : ref6.enableFavoriteMembers) !== null && ref16 !== void 0 ? ref16 : false,
            product: product,
            membership: (ref17 = data === null || data === void 0 ? void 0 : (ref7 = data.artistCustomer) === null || ref7 === void 0 ? void 0 : ref7.patron) !== null && ref17 !== void 0 ? ref17 : null,
            user: (ref19 = (ref18 = data === null || data === void 0 ? void 0 : (ref8 = data.artistCustomer) === null || ref8 === void 0 ? void 0 : ref8.user) !== null && ref18 !== void 0 ? ref18 : fetchData === null || fetchData === void 0 ? void 0 : fetchData.user) !== null && ref19 !== void 0 ? ref19 : null,
            orderCount: (ref20 = data === null || data === void 0 ? void 0 : (ref9 = data.artistCustomer) === null || ref9 === void 0 ? void 0 : ref9.purchaseCount) !== null && ref20 !== void 0 ? ref20 : 0,
            unusedTicketCount: (ref21 = data === null || data === void 0 ? void 0 : (ref10 = data.artistCustomer) === null || ref10 === void 0 ? void 0 : ref10.ticketUnusedCount) !== null && ref21 !== void 0 ? ref21 : 0,
            isFollower: !!(data === null || data === void 0 ? void 0 : (ref11 = data.artistCustomer) === null || ref11 === void 0 ? void 0 : ref11.follower)
        },
        actions: {}
    };
};
var ConsoleUserDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleUserDetail_viewModel_templateObject(), utoniq_core_schema/* ConsolePlanDetailFragmentDoc */.fzE, utoniq_core_schema/* ConsoleProductDetailFragmentDoc */.Nfp, utoniq_core_schema/* MemberBoxFragmentDoc */.M1b, utoniq_core_schema/* ConsoleUserDetailUserFragmentDoc */.DxF);
var FETCH_USER = (0,lib/* gql */.Ps)(ConsoleUserDetail_viewModel_templateObject1(), utoniq_core_schema/* ConsoleUserDetailUserFragmentDoc */.DxF);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserDetail/index.tsx




/**
 * ConsoleUserDetail Page
 * Implemented as a practical sample.
 */ var ConsoleUserDetail = function() {
    var ref = ConsoleUserDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUserDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOrders/template/index.tsx









var ConsoleUserOrdersTemplate = function(param) {
    var state = param.state, onRefetch = param.onRefetch, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var _userId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: generatePath(routerPages.ConsoleUserDetail, {
                    userId: (_userId = router.query.userId) !== null && _userId !== void 0 ? _userId : "#"
                }),
                title: t("title")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FillterCell, {
                        loading: state.loading,
                        orderTransactions: state.orderTransactions,
                        onRefetch: onRefetch,
                        sort: state.sort
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: (ref = state.orderTransactions) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                            var node = param.node;
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(template_OrderItem, {
                                order: node,
                                artistPaymentType: (ref = state.artist) === null || ref === void 0 ? void 0 : ref.paymentType
                            }, node.id);
                        }),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pt: 2
                            },
                            children: Array.from(Array(2).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseHistorySkeleton, {}, key);
                            })
                        }),
                        componentProps: {
                            spacing: 5
                        },
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        emptyMessage: t("ordersEmpty")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOrders/viewModel.ts









/**
 *
 */ var ConsoleUserOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort") === utoniq_core_schema/* OrderBy.Asc */.d$J.Asc ? utoniq_core_schema/* OrderBy.Asc */.d$J.Asc : utoniq_core_schema/* OrderBy.Desc */.d$J.Desc;
    var ref = (0,react.useState)(sort), orderBy = ref[0], setOrderBy = ref[1];
    var isFirstLoadRef = useGetNewestData({
        query: utoniq_core_schema/* FetchNewConsoleOrders */.hbJ,
        variables: {
            orderBy: orderBy,
            userId: router.query.userId
        },
        fields: [
            {
                fragmentName: "UserCartTransactionOrderBox",
                fieldName: "artistUserCartTransactionOrders",
                fragment: utoniq_core_schema/* UserCartTransactionOrderBoxFragmentDoc */.yTi
            }, 
        ]
    }).isFirstLoadRef;
    var ref1 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ConsoleOrders */.uri, {
        variables: {
            orderBy: orderBy,
            userId: router.query.userId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore, refetch = ref1.refetch;
    var ref2, ref3, ref4;
    return {
        state: {
            orderTransactions: (ref2 = data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrders) !== null && ref2 !== void 0 ? ref2 : null,
            loading: loading,
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            user: user,
            artist: (ref4 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref4 !== void 0 ? ref4 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.artistUserCartTransactionOrders.pageInfo.hasNextPage),
            sort: orderBy
        },
        actions: {
            onRefetch: function onRefetch(orderBy) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setOrderBy(orderBy);
                                return [
                                    4,
                                    refetch({
                                        orderBy: orderBy
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            orderBy: orderBy,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistUserCartTransactionOrders) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOrders/index.tsx




/**
 * ConsoleUserOrders Page
 * Implemented as a practical sample.
 */ var ConsoleUserOrders = function() {
    var ref = ConsoleUserOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUserOrdersTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItemDetail/template/index.tsx











var ConsoleUserOwnedItemDetailTemplate = function(param) {
    var state = param.state, onUseTicketsBluk = param.onUseTicketsBluk;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItemDetail").t;
    var ref2 = (0,react.useReducer)(function(v) {
        return !v;
    }, false), editable = ref2[0], toggleEditable = ref2[1];
    var ref3 = (0,react.useReducer)(function(v) {
        return !v;
    }, false), modalOpen = ref3[0], toggleModalOpen = ref3[1];
    var ref4 = (0,react.useState)(state.initialSelectedSerialIds), selectedSerialIds = ref4[0], setSelectedSerialIds = ref4[1];
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref5.routerPages, generatePath = ref5.generatePath, router = ref5.router;
    var isUsed = (0,react.useMemo)(function() {
        var ref, ref1;
        if (state.throughTicketIndex) {
            var ref2, ref3;
            return !((ref2 = state.portfolio) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.serials) === null || ref3 === void 0 ? void 0 : ref3.filter(function(param) {
                var serial = param.serial;
                var ref, ref1, ref2;
                return state.throughTicketIndex && !(serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+state.throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.isUsed);
            }).length);
        }
        return !((ref = state.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
            var serial = param.serial;
            var ref;
            return !(serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : ref.isUsed);
        }).length);
    }, [
        (ref = state.portfolio) === null || ref === void 0 ? void 0 : ref.serials,
        state.throughTicketIndex
    ]);
    (0,react.useEffect)(function() {
        setSelectedSerialIds(state.initialSelectedSerialIds);
    }, [
        state.initialSelectedSerialIds
    ]);
    var _userId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                defaultBackPage: generatePath(routerPages.ConsoleUserOwnedItems, {
                    userId: (_userId = router.query.userId) !== null && _userId !== void 0 ? _userId : "#"
                }),
                title: t("title", "所有アイテム詳細")
            },
            sx: {
                p: 5
            },
            customNavigation: editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    height: "76px",
                    display: "grid",
                    placeItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    disabled: selectedSerialIds.toString() === state.initialSelectedSerialIds.toString(),
                    onClick: toggleModalOpen,
                    size: "large",
                    sx: {
                        width: 212
                    },
                    children: t("changeStatus", "使用状況を変更する")
                })
            }) : null,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleCell, {
                    portfolio: state.portfolio
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCell, {
                    item: (ref1 = state.portfolio) === null || ref1 === void 0 ? void 0 : ref1.item,
                    isUsed: isUsed,
                    thoughTicket: state.thoughTicket
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketsCell, {
                    portfolio: state.portfolio,
                    editable: editable,
                    toggleEditable: toggleEditable,
                    modalOpen: modalOpen,
                    toggleModalOpen: toggleModalOpen,
                    onUseTicketsBluk: onUseTicketsBluk,
                    submitting: state.submitting,
                    throughTicketIndex: state.throughTicketIndex,
                    selectedSerialIds: selectedSerialIds,
                    setSelectedSerialIds: setSelectedSerialIds
                })
            ]
        })
    });
};
var TitleCell = function(param) {
    var portfolio = param.portfolio;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                children: (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    mt: 2
                },
                children: (ref2 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.description
            })
        ]
    });
};
var ItemCell = function(param) {
    var item = param.item, isUsed = param.isUsed, thoughTicket = param.thoughTicket;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItemDetail").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    if (!item) return null;
    var ref6, _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            flexDirection: "row",
            gap: 4,
            mt: 4,
            px: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            zIndex: 1,
                            marginInline: "auto",
                            pl: 1,
                            width: 104,
                            position: "absolute",
                            top: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                            type: item.type
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "small",
                        src: (ref6 = (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref6 !== void 0 ? ref6 : "",
                        href: generatePath(routerPages.ConsoleItemDetail, {
                            itemId: (_id = item.id) !== null && _id !== void 0 ? _id : "#"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            className: "item-info",
                            sx: {
                                flexDirection: "row",
                                gap: 2
                            },
                            children: [
                                item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    color: isUsed ? "default" : "primary",
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: isUsed ? "text.secondary" : "white",
                                        children: isUsed ? t("statusused", "使用済") : t("statusunused", "未使用")
                                    }),
                                    sx: {
                                        p: 1,
                                        height: 20,
                                        ".MuiChip-label": {
                                            px: 0
                                        }
                                    }
                                }),
                                ((ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    color: "secondary",
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "white",
                                        children: t("throughTicket", "通し券")
                                    }),
                                    sx: {
                                        p: 1,
                                        height: 20,
                                        ".MuiChip-label": {
                                            px: 0
                                        }
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            mt: 2
                        },
                        children: [
                            item.title,
                            " ",
                            thoughTicket === null || thoughTicket === void 0 ? void 0 : thoughTicket.name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        sx: {
                            mt: 2
                        },
                        children: (ref4 = item.sku) === null || ref4 === void 0 ? void 0 : ref4.unitName
                    })
                ]
            })
        ]
    });
};
var TicketsCell = function(param) {
    var portfolio = param.portfolio, throughTicketIndex = param.throughTicketIndex, editable = param.editable, toggleEditable = param.toggleEditable, modalOpen = param.modalOpen, toggleModalOpen = param.toggleModalOpen, onUseTicketsBluk = param.onUseTicketsBluk, submitting = param.submitting, selectedSerialIds = param.selectedSerialIds, setSelectedSerialIds = param.setSelectedSerialIds;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItemDetail").t;
    var ref3;
    var unselectedSerialIds = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref3 = (ref1 = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var id = param.id;
            return !selectedSerialIds.includes(id);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(serial) {
            return serial.id;
        })) !== null && ref3 !== void 0 ? ref3 : [];
    }, [
        portfolio,
        selectedSerialIds
    ]);
    var ref4 = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (throughTicketIndex) {
            var ref3, ref4;
            return {
                used: portfolio === null || portfolio === void 0 ? void 0 : (ref3 = portfolio.serials) === null || ref3 === void 0 ? void 0 : ref3.filter(function(param) {
                    var serial = param.serial;
                    var ref, ref1, ref2;
                    return throughTicketIndex && !(serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.isUsed);
                }).length,
                total: portfolio === null || portfolio === void 0 ? void 0 : (ref4 = portfolio.serials) === null || ref4 === void 0 ? void 0 : ref4.length
            };
        }
        return {
            used: (ref1 = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                var isUsed = param.isUsed;
                return !isUsed;
            })) === null || ref1 === void 0 ? void 0 : ref1.length,
            total: portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.serials) === null || ref2 === void 0 ? void 0 : ref2.length
        };
    }, [
        portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials,
        throughTicketIndex
    ]), used = ref4.used, total = ref4.total;
    var addSerialId = (0,react.useCallback)(function(serialId) {
        setSelectedSerialIds(function(prev) {
            return (0,src_to_consumable_array/* default */.Z)(prev).concat([
                serialId
            ]);
        });
    }, []);
    var removeSerialId = (0,react.useCallback)(function(serialId) {
        setSelectedSerialIds(function(prev) {
            return prev.filter(function(id) {
                return id !== serialId;
            });
        });
    }, []);
    var checkTicketUsed = (0,react.useCallback)(function(serial) {
        var ref, ref1;
        if (throughTicketIndex) {
            var ref2, ref3, ref4, ref5;
            return !!((ref2 = serial.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketStatus) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.throughTicket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[+throughTicketIndex]) === null || ref5 === void 0 ? void 0 : ref5.isUsed);
        }
        return !!((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.isUsed);
    }, [
        throughTicketIndex
    ]);
    var isThroughTicket = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.isThroughTicket;
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 6,
                    pb: "60px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: [
                            t("ownedTickets", "所有チケット"),
                            "（",
                            t("statusused", "未使用"),
                            "：",
                            used,
                            "/",
                            total,
                            "枚）"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            fullWidth: false,
                            onClick: toggleEditable,
                            children: editable ? "" : t("editStatus", "使用状況を編集する")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                            "aria-label": "user-tickets-table",
                            sx: {
                                width: "auto",
                                ovrerflowX: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                sx: {
                                                    border: "none",
                                                    minWidth: 52,
                                                    py: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "text.hint",
                                                    sx: {
                                                        display: "block"
                                                    },
                                                    textAlign: "center",
                                                    children: t("isUsed", "使用\n状況")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                sx: {
                                                    border: "none",
                                                    minWidth: 96,
                                                    py: 2,
                                                    px: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "text.hint",
                                                    sx: {
                                                        display: "block"
                                                    },
                                                    children: t("serialNumber", "シリアルナンバー")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                align: "left",
                                                sx: {
                                                    border: "none",
                                                    minWidth: 88,
                                                    py: 2,
                                                    px: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "text.hint",
                                                    children: t("assignedNumber", "整理番号")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                align: "left",
                                                sx: {
                                                    border: "none",
                                                    minWidth: 88,
                                                    py: 2,
                                                    px: 3
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "text.hint",
                                                    children: t("usedAt", "使用日")
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                    children: portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.serials) === null || ref2 === void 0 ? void 0 : ref2.map(function(serial, index) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                        var isUsed = checkTicketUsed(serial);
                                        var isActive = editable ? selectedSerialIds.includes(serial.id) : isUsed;
                                        var ref7, ref8;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0,
                                                        minWidth: 52,
                                                        border: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        sx: {
                                                            width: 64,
                                                            ".Mui-checked svg.MuiSvgIcon-root": {
                                                                color: "primary.main"
                                                            }
                                                        },
                                                        children: [
                                                            editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                sx: {
                                                                    py: 0
                                                                },
                                                                checked: isActive,
                                                                onChange: function() {
                                                                    isActive ? removeSerialId(serial.id) : addSerialId(serial.id);
                                                                }
                                                            }),
                                                            !editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: isUsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                                                    color: "primary",
                                                                    sx: {
                                                                        mx: "auto"
                                                                    },
                                                                    fontSize: "small"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "overline",
                                                                    align: "center",
                                                                    sx: {
                                                                        px: 2,
                                                                        width: "100%"
                                                                    },
                                                                    children: "-"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                                                orientation: "vertical",
                                                                flexItem: true,
                                                                sx: {
                                                                    height: 20
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        pl: 3,
                                                        pr: 0,
                                                        border: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        sx: {
                                                            pr: 1
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SerialNumber, {
                                                            label: serial.formattedSerialNumber
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0,
                                                        border: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 2,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                                                orientation: "vertical",
                                                                flexItem: true,
                                                                sx: {
                                                                    height: 20
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "overline",
                                                                children: throughTicketIndex && isThroughTicket ? (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[+throughTicketIndex]) === null || ref3 === void 0 ? void 0 : ref3.seat : (ref7 = serial === null || serial === void 0 ? void 0 : (ref4 = serial.serial) === null || ref4 === void 0 ? void 0 : ref4.formattedAssignedNumber) !== null && ref7 !== void 0 ? ref7 : "-"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    padding: "none",
                                                    sx: {
                                                        py: 2,
                                                        px: 0,
                                                        border: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 2,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                                                orientation: "vertical",
                                                                flexItem: true,
                                                                sx: {
                                                                    height: 20
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "overline",
                                                                children: (ref8 = (ref5 = serial.serial) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticketStatus) === null || ref6 === void 0 ? void 0 : ref6.formattedUsedAt) !== null && ref8 !== void 0 ? ref8 : "-"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, serial.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: modalOpen,
                onClose: toggleModalOpen,
                title: t("confirmStatusChange", "使用状況を修正しますか？"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        py: 5,
                        textAlign: "left"
                    },
                    children: [
                        !!selectedSerialIds.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    children: t("used", "使用済み")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        whiteSpace: "pre-wrap"
                                    },
                                    children: portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials.filter(function(param) {
                                        var id = param.id;
                                        return selectedSerialIds.includes(id);
                                    }).map(function(param) {
                                        var serial = param.serial, formattedSerialNumber = param.formattedSerialNumber;
                                        var ref, ref1, ref2;
                                        return isThroughTicket && throughTicketIndex ? serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.seat : (ref5 = serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber) !== null && ref5 !== void 0 ? ref5 : formattedSerialNumber;
                                    }).join(", ")
                                })
                            ]
                        }),
                        !!unselectedSerialIds.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    children: t("unused", "未使用")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: {
                                        whiteSpace: "pre-wrap"
                                    },
                                    children: portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials.filter(function(param) {
                                        var id = param.id;
                                        return unselectedSerialIds.includes(id);
                                    }).map(function(param) {
                                        var serial = param.serial, formattedSerialNumber = param.formattedSerialNumber;
                                        var ref, ref1, ref2;
                                        return isThroughTicket && throughTicketIndex ? serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.seat : (ref6 = serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber) !== null && ref6 !== void 0 ? ref6 : formattedSerialNumber;
                                    }).join(", ")
                                })
                            ]
                        })
                    ]
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    loading: submitting,
                    size: "large",
                    onClick: function() {
                        onUseTicketsBluk(selectedSerialIds, unselectedSerialIds).finally(function() {
                            toggleModalOpen();
                            toggleEditable();
                        });
                    },
                    children: "OK"
                }),
                cancelText: t("close", "閉じる")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItemDetail/viewModel.ts




function ConsoleUserOwnedItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query consoleUserOwnedItemDetail(\n    $itemId: ID!\n    $userId: String!\n    $skuId: String\n  ) {\n    artistPortfolio(id: $itemId, userId: $userId) {\n      ...UserItemDetailBox\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleUserOwnedItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ConsoleUserOwnedItemDetail_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref4.showError, showMessage = ref4.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItemDetail").t;
    var ref5 = (0,useQuery/* useQuery */.aM)(ConsoleUserOwnedItemDetail_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId,
            userId: router.query.userId
        }
    }), data = ref5.data, loading = ref5.loading;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUseTickets */.nXj), 2), artistUseTicket = ref6[0], ref7 = ref6[1], using = ref7.loading;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUnuseTickets */.buL), 2), artistUnuseTicket = ref8[0], ref9 = ref8[1], unusing = ref9.loading;
    var portfolio = (0,react.useMemo)(function() {
        var ref;
        return convertPortfolioItemToSku((ref = data === null || data === void 0 ? void 0 : data.artistPortfolio) !== null && ref !== void 0 ? ref : null, router.query.skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.artistPortfolio,
        router.query.skuId
    ]);
    // 最初に表示する使用済みチケットシリアルのID配列
    var initialSelectedSerialIds = (0,react.useMemo)(function() {
        var ref;
        if (router.query.throughTicketIndex) {
            var ref1;
            var ref2;
            return (ref2 = portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
                var serial = param.serial;
                var ref, ref1, ref2;
                return !!router.query.throughTicketIndex && (serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+router.query.throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.isUsed);
            }).map(function(param) {
                var id = param.id;
                return id;
            })) !== null && ref2 !== void 0 ? ref2 : [];
        }
        var ref3;
        return (ref3 = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var serial = param.serial;
            var ref;
            return serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : ref.isUsed;
        }).map(function(param) {
            var id = param.id;
            return id;
        })) !== null && ref3 !== void 0 ? ref3 : [];
    }, [
        portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials,
        router.query.throughTicketIndex
    ]);
    var thoughTicket = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        if (router.query.throughTicketIndex === undefined) {
            return undefined;
        }
        return data === null || data === void 0 ? void 0 : (ref = data.artistPortfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.throughTicket) === null || ref4 === void 0 ? void 0 : ref4[+router.query.throughTicketIndex];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.artistPortfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.throughTicket,
        router.query.throughTicketIndex, 
    ]);
    var ref10;
    return {
        state: {
            loading: loading,
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            submitting: using || unusing,
            portfolio: portfolio,
            thoughTicket: thoughTicket,
            throughTicketIndex: router.query.throughTicketIndex,
            initialSelectedSerialIds: initialSelectedSerialIds
        },
        actions: {
            onUseTicketsBluk: function onUseTicketsBluk(useSerialIds, unuseSerialIds) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var useInputIds, unuseInputIds;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        useInputIds = useSerialIds.filter(function(id) {
                            return !initialSelectedSerialIds.includes(id);
                        });
                        unuseInputIds = unuseSerialIds.filter(function(id) {
                            return initialSelectedSerialIds.includes(id);
                        });
                        if (!useInputIds.length && !unuseInputIds.length) {
                            return [
                                2
                            ];
                        }
                        return [
                            2,
                            Promise.all([
                                useInputIds.length ? artistUseTicket({
                                    variables: {
                                        inputs: {
                                            items: [
                                                {
                                                    itemId: router.query.itemId,
                                                    serialIds: useInputIds,
                                                    throughTicketName: thoughTicket === null || thoughTicket === void 0 ? void 0 : thoughTicket.name
                                                }
                                            ]
                                        }
                                    }
                                }) : null,
                                unuseInputIds.length ? artistUnuseTicket({
                                    variables: {
                                        inputs: {
                                            items: [
                                                {
                                                    itemId: router.query.itemId,
                                                    serialIds: unuseInputIds,
                                                    throughTicketName: thoughTicket === null || thoughTicket === void 0 ? void 0 : thoughTicket.name
                                                }
                                            ]
                                        }
                                    }
                                }) : null
                            ]).then(function() {
                                return showMessage(t("success", "チケット使用状況を変更しました"));
                            }).catch(showError)
                        ];
                    });
                })();
            }
        }
    };
};
var ConsoleUserOwnedItemDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleUserOwnedItemDetail_viewModel_templateObject(), utoniq_core_schema/* UserItemDetailBoxFragmentDoc */.XRF);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItemDetail/index.tsx




/**
 * ConsoleUserOwnedItemDetail Page
 * Implemented as a practical sample.
 */ var ConsoleUserOwnedItemDetail = function() {
    var ref = ConsoleUserOwnedItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUserOwnedItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/lodash/omitBy.js
var omitBy = __webpack_require__(99686);
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);
;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItems/template/index.tsx



















var ConsoleUserOwnedItemsTemplate = function(param) {
    var state = param.state, onFilter = param.onFilter, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItems").t;
    var ref = (0,react.useReducer)(function(v) {
        onFilter(v ? "general" : utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket);
        return !v;
    }, true), filterTicket = ref[0], toggleFilterTicket = ref[1];
    var ref1 = (0,react.useState)(null), filterStatus = ref1[0], setFilterStatus = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
            header: {
                back: true,
                title: t("title", "所有アイテム一覧")
            },
            sx: {
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        mt: 5,
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUserOwnedItems_template_FilterMenu, {
                            filterTicket: filterTicket,
                            toggleFilterTicket: toggleFilterTicket
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterStatus, {
                            status: filterStatus,
                            setStatus: setFilterStatus
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemsCell, {
                    userId: state.userId,
                    loading: state.loading,
                    portfolios: state.portfolios,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    filterStatus: filterStatus
                })
            ]
        })
    });
};
var ConsoleUserOwnedItems_template_FilterMenu = function(param) {
    var filterTicket = param.filterTicket, toggleFilterTicket = param.toggleFilterTicket;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        onClick: toggleFilterTicket,
        variant: "outlined",
        sx: (0,src_object_spread/* default */.Z)({
            width: "68px",
            height: "28px",
            whiteSpace: "nowrap",
            typography: "subtitle1"
        }, filterTicket ? {
            borderRadius: "14px",
            border: "solid 2px",
            borderColor: "primary.main",
            bgcolor: "primary.light",
            color: "text.primary"
        } : {
            border: "solid 1px",
            borderColor: "grey.100",
            color: "text.hint"
        }),
        children: t("ticket")
    });
};
var FilterStatus = function(param) {
    var status = param.status, setStatus = param.setStatus;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItems").t;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var options = [
        {
            label: t("all"),
            onClick: function() {
                setStatus(null);
                setAnchorEl(null);
            }
        },
        {
            label: t("unused"),
            onClick: function() {
                setStatus("unused");
                setAnchorEl(null);
            }
        },
        {
            label: t("used"),
            onClick: function() {
                setStatus("used");
                setAnchorEl(null);
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                onClick: function(e) {
                    return setAnchorEl(e.currentTarget);
                },
                variant: "outlined",
                sx: (0,src_object_spread/* default */.Z)({
                    height: "28px",
                    px: 2,
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                }, status !== null ? {
                    borderRadius: "14px",
                    border: "solid 2px",
                    borderColor: "primary.main",
                    bgcolor: "primary.light",
                    color: "text.primary",
                    typography: "subtitle1"
                } : {
                    border: "solid 1px",
                    borderColor: "grey.100",
                    color: "text.hint"
                }),
                children: [
                    t("status".concat(status)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        fontSize: "xSmall"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: function() {
                    return setAnchorEl(null);
                },
                children: options.map(function(_param) /*#__PURE__*/ {
                    var label = _param.label, option = (0,_object_without_properties/* default */.Z)(_param, [
                        "label"
                    ]);
                    return (0,react.createElement)(MenuItem_MenuItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, option), {
                        sx: {
                            width: 200
                        },
                        key: label
                    }), label);
                })
            })
        ]
    });
};
var template_ItemsCell = function(param) {
    var portfolios = param.portfolios, loading = param.loading, onFetchMore = param.onFetchMore, hasNextPage = param.hasNextPage, filterStatus = param.filterStatus, userId = param.userId;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            mt: 5,
            pb: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            onFetchMore: onFetchMore,
            hasNextPage: !!hasNextPage,
            emptyMessage: t("emptyMessage"),
            // HACK: filterStatusで内部コンポーネントの表示非表示を制御しているため、余白の調整を行う
            componentProps: {
                spacing: 0
            },
            nodes: portfolios === null || portfolios === void 0 ? void 0 : portfolios.edges.map(function(param) {
                var node = param.node;
                var ref, ref1, ref2, ref3, ref4;
                if ((ref = node.item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : ref2.length) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: node.item.metadata.ticket.throughTicket.map(function(throughTicket, index) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemBox, {
                                userId: userId,
                                filterStatus: filterStatus,
                                item: node.item,
                                serials: node.serials,
                                posessionNumber: node.number,
                                throughTicketIndex: index
                            }, "".concat(node.id, ":").concat((ref = node.item) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : ref1.id, ":").concat(index));
                        })
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBox, {
                    userId: userId,
                    filterStatus: filterStatus,
                    item: node.item,
                    serials: node.serials,
                    posessionNumber: node.number
                }, "".concat(node.id, ":").concat((ref3 = node.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sku) === null || ref4 === void 0 ? void 0 : ref4.id));
            })
        })
    });
};
var ItemBox = function(param) {
    var item = param.item, serials = param.serials, posessionNumber = param.posessionNumber, filterStatus = param.filterStatus, userId = param.userId, throughTicketIndex = param.throughTicketIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUserOwnedItems").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref10.generatePath, routerPages = ref10.routerPages;
    var thoughTicket = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (throughTicketIndex === undefined) {
            return undefined;
        }
        return (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : ref2[throughTicketIndex];
    }, [
        (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.throughTicket,
        throughTicketIndex
    ]);
    // 使用済みのもの
    var usedNumber = (0,react.useMemo)(function() {
        if (!(serials === null || serials === void 0 ? void 0 : serials.length)) {
            return 0;
        }
        if (throughTicketIndex !== undefined) {
            return serials.filter(function(param) {
                var serial = param.serial;
                var ref, ref1, ref2;
                return serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.isUsed;
            }).length;
        }
        return serials.filter(function(param) {
            var isUsed = param.isUsed;
            return isUsed;
        }).length;
    }, [
        serials,
        throughTicketIndex
    ]);
    // すべて使用済みかどうか
    var isUsed = (0,react.useMemo)(function() {
        return posessionNumber === usedNumber;
    }, [
        posessionNumber,
        usedNumber
    ]);
    var href = (0,react.useMemo)(function() {
        var ref;
        var url = generatePath(routerPages.ConsoleUserOwnedItemDetail, {
            itemId: item.id,
            userId: userId
        });
        var searchParams = new URLSearchParams(//remove null and undefined value
        omitBy_default()({
            skuId: (ref = item.sku) === null || ref === void 0 ? void 0 : ref.id,
            throughTicketIndex: throughTicketIndex
        }, (isNil_default())));
        return "".concat(url, "?").concat(searchParams.toString());
    }, [
        generatePath,
        (ref2 = item.sku) === null || ref2 === void 0 ? void 0 : ref2.id,
        item.id,
        userId,
        throughTicketIndex
    ]);
    if (!item || filterStatus === "unused" && isUsed || filterStatus === "used" && !isUsed) return null;
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            pb: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                position: "relative"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                className: "item-thumbnail",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            zIndex: 1,
                                            marginInline: "auto",
                                            pl: 1,
                                            width: 104,
                                            position: "absolute",
                                            top: 24
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemIcon/* ItemIcon */.S, {
                                            type: item.type
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        size: "small",
                                        src: (ref11 = (ref3 = item.thumbnail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.front) === null || ref4 === void 0 ? void 0 : ref4.smallUri) !== null && ref11 !== void 0 ? ref11 : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        className: "item-info",
                                        sx: {
                                            flexDirection: "row",
                                            gap: 2
                                        },
                                        children: [
                                            item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                color: isUsed ? "default" : "primary",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: isUsed ? "text.secondary" : "white",
                                                    children: isUsed ? t("statusused", "使用済") : t("statusunused", "未使用")
                                                }),
                                                sx: {
                                                    p: 1,
                                                    height: 20,
                                                    ".MuiChip-label": {
                                                        px: 0
                                                    }
                                                }
                                            }),
                                            ((ref5 = item.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : ref6.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                color: "secondary",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "white",
                                                    children: t("throughTicket", "通し券")
                                                }),
                                                sx: {
                                                    p: 1,
                                                    height: 20,
                                                    ".MuiChip-label": {
                                                        px: 0
                                                    }
                                                }
                                            })
                                        ]
                                    }),
                                    !!((ref7 = item.preSale) === null || ref7 === void 0 ? void 0 : ref7.event.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        sx: {
                                            mt: 1,
                                            mb: -2
                                        },
                                        color: "text.secondary",
                                        variant: "subtitle2",
                                        children: (ref8 = item.preSale) === null || ref8 === void 0 ? void 0 : ref8.event.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2)), {
                                            mt: 2
                                        }),
                                        children: [
                                            item.title,
                                            " ",
                                            thoughTicket === null || thoughTicket === void 0 ? void 0 : thoughTicket.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: (ref9 = item.sku) === null || ref9 === void 0 ? void 0 : ref9.unitName
                                    }),
                                    item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        sx: {
                                            mt: 1
                                        },
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            t("statusunused", "未使用"),
                                            ":",
                                            " ",
                                            posessionNumber - usedNumber,
                                            "/",
                                            posessionNumber,
                                            "枚"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        sx: {
                                            mt: 1
                                        },
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: [
                                            t("posessionNumber", "所持数"),
                                            ": ",
                                            posessionNumber,
                                            t("numberUnit", "枚")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItems/viewModel.ts



function ConsoleUserOwnedItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query consoleUserOwnedItems(\n    $userId: ID!\n    $type: ItemType\n    $pageInput: PageInput\n  ) {\n    user(id: $userId) {\n      id\n      artistPortfolios(type: $type, pageInput: $pageInput) {\n        ...ConsoleUserOwnedItemsPortfolio\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleUserOwnedItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ConsoleUserOwnedItems_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref4 = (0,useQuery/* useQuery */.aM)(ConsoleUserOwnedItems_viewModel_QUERY, {
        variables: {
            userId: router.query.userId,
            type: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore, refetch = ref4.refetch;
    var ref5, ref6;
    return {
        state: {
            userId: router.query.userId,
            loading: loading,
            filter: utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket,
            artistId: (ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "",
            hasNextPage: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.artistPortfolios) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage,
            portfolios: spreadPortfoliosBySku((ref6 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.artistPortfolios) !== null && ref6 !== void 0 ? ref6 : null)
        },
        actions: {
            onFilter: function onFilter(filter) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        refetch({
                            type: filter === "general" ? null : filter
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                limit: 10,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.artistPortfolios) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};
var ConsoleUserOwnedItems_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleUserOwnedItems_viewModel_templateObject(), utoniq_core_schema/* ConsoleUserOwnedItemsPortfolioFragmentDoc */.XTg);

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUserOwnedItems/index.tsx




/**
 * ConsoleUserOwnedItems Page
 * Implemented as a practical sample.
 */ var ConsoleUserOwnedItems = function() {
    var ref = ConsoleUserOwnedItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUserOwnedItemsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUsers/template/SearchForm.tsx















var ConsoleUsers_template_SearchForm_schema = function(o) {
    return {
        searchTerm: o.string().allow("").optional(),
        orderBy: o.string().allow("").optional()
    };
};
var ConsoleUsers_template_SearchForm_defaultValues = {
    searchTerm: "",
    orderBy: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc
};
var ConsoleUsers_template_SearchForm_SearchForm = function(param) {
    var artistId = param.artistId, onSubmit = param.onSubmit, onFocusInputSearch = param.onFocusInputSearch, onBlurInputSearch = param.onBlurInputSearch, sort = param.sort;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ConsoleUsers_template_SearchForm_schema,
        defaultValues: ConsoleUsers_template_SearchForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, watch = ref.watch, setValue = ref.setValue;
    var handleChangeKeywordDebounce = (0,react.useRef)(debounce_default()(handleSubmit(function(param) {
        var searchTerm = param.searchTerm;
        return onSubmit((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ConsoleUsers_template_SearchForm_defaultValues), {
            searchTerm: searchTerm
        }));
    }), 500));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(onSubmit),
            sx: {
                bgcolor: "transparent"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUsers_template_SearchForm_SearchInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("searchTerm")), {
                    showClearButton: !!watch("searchTerm"),
                    artistId: artistId,
                    onChange: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(event) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setValue("searchTerm", event.target.value);
                                        return [
                                            4,
                                            handleChangeKeywordDebounce.current()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(event) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    onBlur: function(event) {
                        var onBlur = register("searchTerm").onBlur;
                        onBlurInputSearch();
                        return onBlur(event);
                    },
                    textFieldProps: {
                        onFocus: function onFocus() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_customerSearch", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: artistId
                            });
                            onFocusInputSearch();
                        }
                    }
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUsers_template_SearchForm_FilterCell, {
                    setValue: setValue,
                    onChange: handleSubmit(onSubmit),
                    sort: sort
                })
            ]
        })
    });
};
var ConsoleUsers_template_SearchForm_SearchInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var showClearButton = _param.showClearButton, artistId = _param.artistId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "showClearButton",
        "artistId"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        component: Stack_Stack/* default */.Z,
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SearchInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                ref: ref,
                t: t
            })),
            showClearButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "text",
                sx: {
                    minWidth: 86
                },
                onClick: function() {
                    if (props.onChange) {
                        props === null || props === void 0 ? void 0 : props.onChange({
                            target: {
                                value: ""
                            },
                            type: ""
                        });
                    }
                },
                children: t("cancel", "キャンセル")
            })
        ]
    });
});
var ConsoleUsers_template_SearchForm_FilterCell = function(param) {
    var setValue = param.setValue, onChange = param.onChange, sort = param.sort;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    var filterOptions = [
        {
            label: t("newestOrderDate", "注文日の新しい順"),
            value: utoniq_core_schema/* OrderBy.Desc */.d$J.Desc
        },
        {
            label: t("oldestOrderDate", "注文日の古い順"),
            value: utoniq_core_schema/* OrderBy.Asc */.d$J.Asc
        }, 
    ];
    // sort と filterOptions の value を比較して、一致するインデックスを取得
    var initialSelectedIndex = sort ? filterOptions.findIndex(function(option) {
        return option.value === sort;
    }) : 0;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = (0,react.useState)(filterOptions[initialSelectedIndex]), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var open = Boolean(anchorEl);
    var handleClickListItem = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function(event, option) {
        setSelectedOption(option);
        setValue("orderBy", option.value);
        onChange();
        setAnchorEl(null);
    };
    (0,react.useEffect)(function() {
        var UrlParams = "?sort=".concat(selectedOption.value);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedOption
    ]);
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                spacing: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        mr: -2
                    },
                    onClick: handleClickListItem,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                mr: 2
                            },
                            children: selectedOption.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: filterOptions.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        selected: option.value === selectedOption.value,
                        onClick: function(event) {
                            return handleMenuItemClick(event, option);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: option.label
                        })
                    }, option.value);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUsers/template/index.tsx












var ConsoleUsersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onSubmit = param.onSubmit, onDownloadCsv = param.onDownloadCsv;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2 = (0,react.useState)(false), onFocusInputSearch = ref2[0], setOnFocusInputSearch = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ConsoleUsers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsoleBaseLayout/* ConsoleBaseLayout */.f, {
                margin: true,
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsLeft */.p, {}),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistHeaderItems/* ArtistHeaderItemsRight */.d, {
                        artistId: state.artistId
                    })
                },
                children: [
                    state.isFirstLoading && !((ref = state.users) === null || ref === void 0 ? void 0 : ref.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 3,
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "large",
                            width: "70%"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        mt: 2,
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                sx: {
                                    py: 3
                                },
                                children: t("usersManagement")
                            }),
                            !(onFocusInputSearch || state.haveSearchTermValue) && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_DownloadCsvButtonCell, {
                                loading: state.downloadingCsv,
                                onClick: onDownloadCsv
                            })
                        ]
                    }),
                    state.isFirstLoading && !((ref1 = state.users) === null || ref1 === void 0 ? void 0 : ref1.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUsers_template_SearchForm_SearchForm, {
                        artistId: state.artistId,
                        onSubmit: onSubmit,
                        onFocusInputSearch: function() {
                            return setOnFocusInputSearch(true);
                        },
                        onBlurInputSearch: function() {
                            return setOnFocusInputSearch(false);
                        },
                        sort: state.sort
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberListCell, {
                        users: state.users,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        loading: state.loading || state.refresh
                    })
                ]
            })
        ]
    });
};
var MemberListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, users = param.users, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    if (!loading && !(users === null || users === void 0 ? void 0 : users.edges.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            align: "center",
            sx: {
                py: 6
            },
            color: "text.secondary",
            children: t("usersEmpty")
        });
    }
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                "aria-label": "serial-number-table",
                sx: {
                    width: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    width: "100%",
                                    sx: {
                                        border: "none",
                                        py: 0,
                                        px: 0
                                    },
                                    children: loading && !(users === null || users === void 0 ? void 0 : users.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "30%"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("name", "ユーザー名/電話番号")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    sx: {
                                        border: "none",
                                        minWidth: 70,
                                        px: 2,
                                        py: 0
                                    },
                                    children: loading && !(users === null || users === void 0 ? void 0 : users.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "70%"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("purchasesNumber", "購入回数")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: "none",
                                        minWidth: 100,
                                        px: 2,
                                        py: 0
                                    },
                                    children: loading && !(users === null || users === void 0 ? void 0 : users.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "small",
                                        width: "70%"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("lastPurchase", "最終購入日")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        component: TableRow/* default */.Z,
                        colSpan: 3,
                        nodes: users === null || users === void 0 ? void 0 : users.edges.map(function(param) {
                            var user = param.node;
                            var ref, ref3, ref4, ref5, ref6;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        width: "100%",
                                        padding: "none",
                                        sx: {
                                            py: 4,
                                            maxWidth: 100
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 2,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                return router.push(generatePath(routerPages.ConsoleUserDetail, {
                                                    userId: user.userId
                                                }));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: (ref1 = (ref = user.user) === null || ref === void 0 ? void 0 : (ref3 = ref.avatar) === null || ref3 === void 0 ? void 0 : ref3.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                                                    sx: {
                                                        width: 28,
                                                        height: 28
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    sx: {
                                                        minWidth: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            direction: "row",
                                                            spacing: 1,
                                                            sx: {
                                                                minWidth: 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                                    children: (ref2 = (ref4 = user.user) === null || ref4 === void 0 ? void 0 : ref4.fullName) !== null && ref2 !== void 0 ? ref2 : (ref5 = user.user) === null || ref5 === void 0 ? void 0 : ref5.displayName
                                                                }),
                                                                user.patron && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Group, {
                                                                    fontSize: "small",
                                                                    sx: {
                                                                        color: "secondary.main"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: (ref6 = user.user) === null || ref6 === void 0 ? void 0 : ref6.formattedPhoneNumber
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        padding: "none",
                                        sx: {
                                            py: 4,
                                            minWidth: 70,
                                            px: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: user.formattedPurchaseCount
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        sx: {
                                            py: 4,
                                            minWidth: 100,
                                            px: 2
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: user.formattedLastPurchasedAt
                                        })
                                    })
                                ]
                            }, user.id);
                        }),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: Array.from(Array(3).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                py: 4,
                                                maxWidth: 100
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                                        variant: "circular",
                                                        width: 28,
                                                        height: 28
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        flex: 1,
                                                        sx: {
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                                variant: "small",
                                                                width: "50%"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                                variant: "small",
                                                                width: "80%"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                py: 4,
                                                minWidth: 70,
                                                px: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                spacing: 3,
                                                sx: {
                                                    px: 5
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "caption",
                                                    width: 60
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                py: 4,
                                                minWidth: 100,
                                                px: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                spacing: 3,
                                                sx: {
                                                    px: 5
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "caption",
                                                    width: 60
                                                })
                                            })
                                        })
                                    ]
                                }, key);
                            })
                        })
                    })
                ]
            })
        })
    });
};
var SearchFormSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    borderRadius: "22px",
                    bgcolor: "grey.50",
                    px: 6,
                    py: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "60%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 2,
                    py: 2
                },
                alignItems: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "30%"
                })
            })
        ]
    });
};
var template_DownloadCsvButtonCell = function(param) {
    var loading = param.loading, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "small",
            loadingPosition: "start",
            variant: "outlined",
            sx: {
                ".MuiButton-loadingIndicator": {
                    left: "auto",
                    color: "primary.main"
                },
                borderRadius: 1,
                height: 28,
                borderColor: "primary.main",
                color: "primary.main",
                "&.MuiButton-loading": {
                    borderColor: "grey.100"
                },
                ".MuiButton-startIcon": {
                    display: "none"
                }
            },
            onClick: onClick,
            loading: loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "inherit",
                pt: "2px",
                children: loading ? t("downloadNow", "ダウンロード中") : t("exportCsv", "CSVエクスポート")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUsers/viewModel.ts






function ConsoleUsers_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ConsoleUsers(\n    $orderBy: OrderBy\n    $pageInput: PageInput\n    $searchTerm: String\n  ) {\n    artistCustomers(\n      orderBy: $orderBy\n      pageInput: $pageInput\n      searchTerm: $searchTerm\n    ) {\n      ...ArtistCustomerConnection\n    }\n    artist {\n      id\n      paymentType\n      hasArrangingDeliveryItems\n      subscription {\n        products {\n          productId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleUsers_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConsoleUsers_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewConsoleUsers(\n    $orderBy: OrderBy\n    $pageInput: PageInput\n    $searchTerm: String\n  ) {\n    artistCustomers(\n      orderBy: $orderBy\n      pageInput: $pageInput\n      searchTerm: $searchTerm\n    ) {\n      ...ArtistCustomerConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ConsoleUsers_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConsoleUsers_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistExportCustomersCsv {\n    artistExportCustomersCsv {\n      csvUrl\n    }\n  }\n"
    ]);
    ConsoleUsers_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










/**
 *
 */ var ConsoleUsers_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("consoleUsers").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref4.showError, showMessage = ref4.showMessage;
    var downloadCsv = useDownloadFile().downloadCsv;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort") === utoniq_core_schema/* OrderBy.Asc */.d$J.Asc ? utoniq_core_schema/* OrderBy.Asc */.d$J.Asc : utoniq_core_schema/* OrderBy.Desc */.d$J.Desc;
    var ref5 = (0,react.useState)({
        orderBy: sort,
        searchTerm: ""
    }), filter = ref5[0], setFilter = ref5[1];
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_USERS,
        variables: {
            orderBy: filter.orderBy,
            searchTerm: "",
            pageInput: {
                limit: 20
            }
        },
        fields: [
            {
                fragmentName: "ArtistCustomerDetail",
                fieldName: "artistCustomers",
                fragment: utoniq_core_schema/* ArtistCustomerDetailFragmentDoc */.agv
            }, 
        ]
    }).isFirstLoadRef;
    var ref6 = (0,useQuery/* useQuery */.aM)(ConsoleUsers_viewModel_QUERY, {
        variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filter), {
            pageInput: {
                limit: 20
            }
        }),
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref6.data, loading = ref6.loading, fetchMore = ref6.fetchMore, refetch = ref6.refetch, networkStatus = ref6.networkStatus;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ARTIST_EXPORT_CUSTOMERS_CSV, {
        onCompleted: function onCompleted(param) {
            var artistExportCustomersCsv = param.artistExportCustomersCsv;
            return (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(artistExportCustomersCsv === null || artistExportCustomersCsv === void 0 ? void 0 : artistExportCustomersCsv.csvUrl)) {
                                return [
                                    2,
                                    showError(new Error(t("downloadCsvError")))
                                ];
                            }
                            return [
                                4,
                                downloadCsv((artistExportCustomersCsv === null || artistExportCustomersCsv === void 0 ? void 0 : artistExportCustomersCsv.csvUrl) || "").then(function() {
                                    showMessage(t("downloadCsvSuccess", "ダウンロードが完了しました"), "success");
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), 2), artistExportCustomersCsv = ref7[0], ref8 = ref7[1], downloadingCsv = ref8.loading;
    (0,react.useEffect)(function() {
        if (loading || !!(data === null || data === void 0 ? void 0 : data.artistCustomers.edges.length)) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            artistId: user === null || user === void 0 ? void 0 : user.uid,
            name: "customerSearch"
        });
    }, [
        loading
    ]);
    var isNextFetch = !!data;
    var ref9, ref10, ref11, ref12;
    return {
        state: {
            isFirstLoading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && isFirstLoadRef.current,
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            refresh: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            users: (ref9 = data === null || data === void 0 ? void 0 : data.artistCustomers) !== null && ref9 !== void 0 ? ref9 : null,
            downloadingCsv: downloadingCsv,
            haveSearchTermValue: !!filter.searchTerm,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.artistCustomers) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
            artistId: (ref10 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref10 !== void 0 ? ref10 : "",
            user: user,
            artist: (ref11 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref11 !== void 0 ? ref11 : null,
            sort: filter.orderBy,
            membership: (ref12 = data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products) !== null && ref12 !== void 0 ? ref12 : undefined
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, filter), {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.artistCustomers.pageInfo.endCursor,
                                                limit: 20
                                            }
                                        })
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setFilter(values);
                                return [
                                    4,
                                    refetch(values)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDownloadCsv: function onDownloadCsv() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    artistExportCustomersCsv()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ConsoleUsers_viewModel_QUERY = (0,lib/* gql */.Ps)(ConsoleUsers_viewModel_templateObject(), utoniq_core_schema/* ArtistCustomerConnectionFragmentDoc */.Vyt);
var FETCH_NEW_USERS = (0,lib/* gql */.Ps)(ConsoleUsers_viewModel_templateObject1(), utoniq_core_schema/* ArtistCustomerConnectionFragmentDoc */.Vyt);
var ARTIST_EXPORT_CUSTOMERS_CSV = (0,lib/* gql */.Ps)(ConsoleUsers_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/ConsoleUsers/index.tsx




/**
 * ConsoleUsers Page
 * Implemented as a practical sample.
 */ var ConsoleUsers = function() {
    var ref = ConsoleUsers_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsoleUsersTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/customProfile/ItemImage/index.tsx





var ItemImage_ItemImage = function(param) {
    var onClick = param.onClick, item = param.item, selected = param.selected, sx = param.sx, defaultValue = param.defaultValue;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditWallPaper").t;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        sx: {
            position: "relative",
            width: "100%"
        },
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                variant: "square",
                src: (ref1 = (ref = item.thumbnail) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref1 !== void 0 ? ref1 : "",
                sx: (0,src_object_spread/* default */.Z)({
                    minHeight: 70,
                    width: "100%"
                }, sx)
            }),
            (selected === null || selected === void 0 ? void 0 : selected.id) === item.id && item.id !== defaultValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Selected, {
                        fontSize: "medium",
                        sx: {
                            color: "primary.main",
                            position: "absolute",
                            top: -4,
                            right: -4,
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayCell, {
                        sx: {
                            bgcolor: "grey.900",
                            opacity: 0.8
                        },
                        text: t("choosing")
                    })
                ]
            }),
            item.id === defaultValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayCell, {
                sx: {
                    bgcolor: "grey.50",
                    opacity: 0.8
                },
                text: t("setup")
            })
        ]
    });
};
var OverlayCell = function(param) {
    var sx = param.sx, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        flex: 1,
        direction: "row",
        justifyContent: "center",
        sx: (0,src_object_spread/* default */.Z)({
            position: "absolute",
            inset: 0
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: text
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/customProfile/ItemTrash/index.tsx




var ItemTrash = function(param) {
    var selected = param.selected, sx = param.sx, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            width: "100%",
            bgcolor: "grey.50",
            color: "primary.main",
            minHeight: 70,
            opacity: !selected ? 0.5 : 1
        }, sx),
        disabled: !selected,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
            color: "inherit"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/customProfile/ListItemImage/index.tsx









var ListItemImage = function(param) {
    var items = param.items, defaultValue = param.defaultValue, selected = param.selected, onSelected = param.onSelected, sx = param.sx, avatarProps = param.avatarProps, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditWallPaper").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: (0,src_object_spread/* default */.Z)({
            py: 5,
            px: 6
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            component: Grid/* default */.ZP,
            componentProps: {
                spacing: 3,
                container: true
            },
            itemComponent: Grid/* default */.ZP,
            itemComponentProps: {
                item: true,
                xs: 3
            },
            nodes: [
                null
            ].concat((0,src_to_consumable_array/* default */.Z)(items || [])).map(function(item, index) {
                if (!item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTrash, {
                        selected: selected,
                        onClick: function() {
                            return onSelected(item);
                        },
                        sx: avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.sx
                    }, index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage_ItemImage, {
                    item: item,
                    selected: selected,
                    defaultValue: defaultValue,
                    onClick: function() {
                        return onSelected(item);
                    },
                    sx: avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.sx
                }, index);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditAvatar/template/index.tsx








var CustomProfileEditAvatarTemplate = function(param) {
    var state = param.state, onSaveCustomProfile = param.onSaveCustomProfile, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditAvatar").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref3.routerNames, routerPages = ref3.routerPages;
    var ref4 = (0,react.useState)(null), selected = ref4[0], setSelected = ref4[1];
    (0,react.useEffect)(function() {
        if (state.default) {
            setSelected(state.default);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref = state.default) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var handleSaveCustomProfile = function() {
        onSaveCustomProfile((selected === null || selected === void 0 ? void 0 : selected.id) || null).catch(showError);
    };
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            title: t("title"),
            defaultBackPage: routerPages.MyProfile,
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                onClick: handleSaveCustomProfile,
                disabled: state.customProfileUpdating || ((ref1 = state.default) === null || ref1 === void 0 ? void 0 : ref1.id) === (selected === null || selected === void 0 ? void 0 : selected.id),
                loading: state.customProfileUpdating,
                sx: {
                    mr: -1
                },
                children: t("save")
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.CustomProfileEditAvatar
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProfileEditCell, {
                        thumbnail: (ref5 = selected === null || selected === void 0 ? void 0 : selected.thumbnail) !== null && ref5 !== void 0 ? ref5 : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemImage, {
                        items: state.items,
                        defaultValue: (ref6 = (ref2 = state.default) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "",
                        selected: selected,
                        onSelected: setSelected,
                        sx: {
                            minHeight: 276
                        },
                        avatarProps: {
                            sx: {
                                minHeight: 96
                            }
                        },
                        loading: state.fetching,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore
                    })
                ]
            })
        ]
    });
};
var CustomProfileEditCell = function(param) {
    var thumbnail = param.thumbnail;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditAvatar").t;
    if (!(thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    width: "100%",
                    height: 400,
                    bgcolor: "grey.50"
                },
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            align: "center",
                            children: t("avatarNotSetTitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            align: "center",
                            children: t("avatarNotSetDesc")
                        })
                    ]
                })
            })
        });
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                width: "100%",
                height: 400,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundImage: "url('".concat((ref = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri) !== null && ref !== void 0 ? ref : "", "')")
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditAvatar/viewModel.ts




function CustomProfileEditAvatar_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CustomProfileEditAvatar(\n    $organizationPortfoliosType: ItemType\n    $pageInput: PageInput\n  ) {\n    user {\n      id\n      organizationPortfolios(\n        type: $organizationPortfoliosType\n        pageInput: $pageInput\n      ) {\n        ...UserItemsAvatarConnection\n      }\n      customProfile {\n        ...CustomProfileConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    CustomProfileEditAvatar_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var CustomProfileEditAvatar_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,router_useRouter/* useRouter */.tv)(), router = ref11.router, routerPages = ref11.routerPages;
    var ref12 = (0,useQuery/* useQuery */.aM)(QUERY_CUSTOM_PROFILE_AVATAR, {
        variables: {
            organizationPortfoliosType: utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar
        },
        notifyOnNetworkStatusChange: true
    }), data = ref12.data, networkStatus = ref12.networkStatus, fetchMore = ref12.fetchMore;
    var ref13, ref14;
    var items = (ref14 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationPortfolios.edges.map(function(param) {
        var node = param.node;
        var ref, ref1, ref2;
        return {
            id: node.item.id,
            thumbnail: {
                uri: (ref13 = node === null || node === void 0 ? void 0 : (ref = node.item) === null || ref === void 0 ? void 0 : (ref1 = ref.avatarResources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.avatarResource) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref13 !== void 0 ? ref13 : ""
            }
        };
    })) !== null && ref14 !== void 0 ? ref14 : [];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateCustomProfile */.bPY), 2), updateCustomProfile = ref15[0], ref16 = ref15[1], customProfileUpdating = ref16.loading;
    var ref17, ref18;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            customProfileUpdating: customProfileUpdating,
            items: items,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organizationPortfolios) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            default: {
                id: (ref17 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customProfile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.avatarItem) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref17 !== void 0 ? ref17 : "",
                thumbnail: {
                    uri: (ref18 = data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.customProfile) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.avatarItem) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.avatarResources) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.avatarResource) === null || ref10 === void 0 ? void 0 : ref10.smallUri) !== null && ref18 !== void 0 ? ref18 : ""
                }
            }
        },
        actions: {
            onSaveCustomProfile: function onSaveCustomProfile(avatarItemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateCustomProfile({
                                        variables: {
                                            updateCustomProfileInputs: {
                                                avatarItemId: avatarItemId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                router.goBack(routerPages.MyProfile);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            organizationPortfoliosType: utoniq_core_schema/* ItemType.Avatar */.qGq.Avatar,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.organizationPortfolios) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var QUERY_CUSTOM_PROFILE_AVATAR = (0,lib/* gql */.Ps)(CustomProfileEditAvatar_viewModel_templateObject(), utoniq_core_schema/* UserItemsAvatarConnectionFragmentDoc */.FY7, utoniq_core_schema/* CustomProfileConnectionFragmentDoc */.saP);

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditAvatar/index.tsx




/**
 * CustomProfileEditAvatar Page
 * Implemented as a practical sample.
 */ var CustomProfileEditAvatar = function() {
    var ref = CustomProfileEditAvatar_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProfileEditAvatarTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditWallPaper/template/index.tsx








var CustomProfileEditWallPaperTemplate = function(param) {
    var state = param.state, onSaveCustomProfile = param.onSaveCustomProfile, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditWallPaper").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref3.routerNames, routerPages = ref3.routerPages;
    var ref4 = (0,react.useState)(null), selected = ref4[0], setSelected = ref4[1];
    (0,react.useEffect)(function() {
        if (state.default) {
            setSelected(state.default);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref = state.default) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var handleSaveCustomProfile = function() {
        onSaveCustomProfile((selected === null || selected === void 0 ? void 0 : selected.id) || null).catch(showError);
    };
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: routerPages.MyProfile,
            title: t("title"),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                onClick: handleSaveCustomProfile,
                disabled: state.customProfileUpdating || ((ref1 = state.default) === null || ref1 === void 0 ? void 0 : ref1.id) === (selected === null || selected === void 0 ? void 0 : selected.id),
                loading: state.customProfileUpdating,
                sx: {
                    mr: -1
                },
                children: t("save")
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.CustomProfileEditWallPaper
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CustomProfileEditCell, {
                        thumbnail: (ref5 = selected === null || selected === void 0 ? void 0 : selected.thumbnail) !== null && ref5 !== void 0 ? ref5 : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemImage, {
                        items: state.items,
                        defaultValue: (ref6 = (ref2 = state.default) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "",
                        selected: selected,
                        onSelected: setSelected,
                        loading: state.fetching,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        sx: {
                            minHeight: 192
                        }
                    })
                ]
            })
        ]
    });
};
var template_CustomProfileEditCell = function(param) {
    var thumbnail = param.thumbnail;
    var t = (0,core_i18n/* useTranslation */.$G)("customProfileEditWallPaper").t;
    if (!(thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.uri)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    width: "100%",
                    height: 400,
                    bgcolor: "grey.50"
                },
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            align: "center",
                            children: t("wallpaperNotSetTitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            align: "center",
                            children: t("wallpaperNotSetDesc")
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                width: "100%",
                height: 400,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundImage: "url('".concat(thumbnail.uri, "')")
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditWallPaper/viewModel.ts




function CustomProfileEditWallPaper_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CustomProfileEditWallPaper(\n    $organizationPortfoliosType: ItemType\n    $pageInput: PageInput\n  ) {\n    user {\n      id\n      organizationPortfolios(\n        type: $organizationPortfoliosType\n        pageInput: $pageInput\n      ) {\n        ...UserItemsConnection\n      }\n      customProfile {\n        ...CustomProfileConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    CustomProfileEditWallPaper_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CustomProfileEditWallPaper_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateCustomProfile(\n    $updateCustomProfileInputs: UpdateCustomProfileInput\n  ) {\n    updateCustomProfile(inputs: $updateCustomProfileInputs) {\n      id\n      customProfile {\n        ...CustomProfileConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    CustomProfileEditWallPaper_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CustomProfileEditWallPaper_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,router_useRouter/* useRouter */.tv)(), router = ref11.router, routerPages = ref11.routerPages;
    var ref12 = (0,useQuery/* useQuery */.aM)(QUERY_CUSTOM_PROFILE, {
        variables: {
            organizationPortfoliosType: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper
        },
        notifyOnNetworkStatusChange: true
    }), data = ref12.data, fetchMore = ref12.fetchMore, networkStatus = ref12.networkStatus;
    var ref13, ref14;
    var items = (ref14 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationPortfolios.edges.map(function(param) {
        var node = param.node;
        var ref, ref1, ref2;
        return {
            id: node.item.id,
            thumbnail: {
                uri: (ref13 = node === null || node === void 0 ? void 0 : (ref = node.item) === null || ref === void 0 ? void 0 : (ref1 = ref.wallpaperResources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaperResource) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) !== null && ref13 !== void 0 ? ref13 : ""
            }
        };
    })) !== null && ref14 !== void 0 ? ref14 : [];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_CUSTOM_PROFILE), 2), updateCustomProfile = ref15[0], ref16 = ref15[1], customProfileUpdating = ref16.loading;
    var ref17, ref18;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            customProfileUpdating: customProfileUpdating,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organizationPortfolios) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            items: items,
            default: {
                id: (ref17 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customProfile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.wallpaperItem) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref17 !== void 0 ? ref17 : "",
                thumbnail: {
                    uri: (ref18 = data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.customProfile) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.wallpaperItem) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.wallpaperResources) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.wallpaperResource) === null || ref10 === void 0 ? void 0 : ref10.mediumUri) !== null && ref18 !== void 0 ? ref18 : ""
                }
            }
        },
        actions: {
            onSaveCustomProfile: function onSaveCustomProfile(wallpaperItemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateCustomProfile({
                                        variables: {
                                            updateCustomProfileInputs: {
                                                wallpaperItemId: wallpaperItemId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                router.goBack(routerPages.MyProfile);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            organizationPortfoliosType: utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.organizationPortfolios) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var QUERY_CUSTOM_PROFILE = (0,lib/* gql */.Ps)(CustomProfileEditWallPaper_viewModel_templateObject(), utoniq_core_schema/* UserItemsConnectionFragmentDoc */.fM5, utoniq_core_schema/* CustomProfileConnectionFragmentDoc */.saP);
var UPDATE_CUSTOM_PROFILE = (0,lib/* gql */.Ps)(CustomProfileEditWallPaper_viewModel_templateObject1(), utoniq_core_schema/* CustomProfileConnectionFragmentDoc */.saP);

;// CONCATENATED MODULE: ./src/components/pages/CustomProfileEditWallPaper/index.tsx




var CustomProfileEditWallPaper = function() {
    var ref = CustomProfileEditWallPaper_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProfileEditWallPaperTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/settings/DeactivationBox/index.tsx





var DeactivationBox = function(param) {
    var _type = param.type, type = _type === void 0 ? "info" : _type, Icon = param.Icon, title = param.title, description = param.description, actions = param.actions;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 3,
                "&:last-child": {
                    pb: 3
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                fontSize: "small",
                                sx: {
                                    color: type === "error" ? "error.main" : "grey.600"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: {
                                    color: type === "error" ? "error.main" : "grey.600"
                                },
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: description
                    }),
                    !!(actions === null || actions === void 0 ? void 0 : actions.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        children: actions.map(function(action, index) {
                            return /*#__PURE__*/ (0,react.createElement)(Link/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
                                key: index,
                                variant: "caption",
                                color: "primary.main"
                            }));
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Deactivation/template/index.tsx














var DeactivationTemplate = function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Deactivation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    defaultBackPage: routerPages.AccountSetting,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationFirstNotesCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationSecondNotesCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiactivationButton, {})
                ]
            })
        ]
    });
};
var DeactivationFirstNotesCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("deactivation").t;
    var list = [
        {
            title: t("dataErrorTitle"),
            description: t("dataErrorDescription")
        },
        {
            title: t("revertDataErrorTitle"),
            description: t("revertDataErrorDescription")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: t("note")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    pt: 4
                },
                children: list.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationBox, {
                        type: "error",
                        Icon: dist.Icons.Error,
                        title: item.title,
                        description: item.description
                    }, index);
                })
            })
        ]
    });
};
var DeactivationSecondNotesCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("deactivation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var isStandalone = config_config/* config.applicationType */.v.applicationType === "standalone";
    var list = [
        {
            Icon: dist.Icons.Notice,
            title: t("notificationTitle"),
            description: t("notificationDescription"),
            actions: (0,native_app/* getPlatform */.Xf)() !== "web" ? [
                {
                    children: t("changePushNotification"),
                    href: routerPages.PushNotificationSettings
                },
                {
                    children: t("changeEmailNotification"),
                    href: routerPages.EmailNotificationSettings
                }, 
            ] : [
                {
                    children: t("changeEmailNotification"),
                    href: routerPages.EmailNotificationSettings
                }, 
            ]
        },
        {
            Icon: dist.Icons.Thread,
            title: t("threadTitle"),
            hidden: !isStandalone || !config_config/* config.modules.thread */.v.modules.thread,
            description: t("threadDescription"),
            actions: [
                {
                    children: t("useCommunity"),
                    href: config_config/* config.artistId */.v.artistId && generatePath(routerPages.ArtistThreads, {
                        artistId: config_config/* config.artistId */.v.artistId
                    })
                }, 
            ]
        },
        {
            Icon: dist.Icons.Market,
            title: t("tradeTitle"),
            hidden: !isStandalone || !config_config/* config.modules.trade */.v.modules.trade,
            description: t("tradeDescription"),
            actions: [
                {
                    children: t("takeAdvantageTrading"),
                    href: config_config/* config.artistId */.v.artistId && generatePath(routerPages.ArtistTrade, {
                        artistId: config_config/* config.artistId */.v.artistId
                    })
                }, 
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    py: 2
                },
                children: t("beforeWithdrawing")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: (0,array/* filterHiddenItem */.s)(list).map(function(item, index) {
                    return /*#__PURE__*/ (0,react.createElement)(DeactivationBox, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                        key: index
                    }));
                })
            })
        ]
    });
};
var DiactivationButton = function() {
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                minWidth: 244
            },
            href: routerPages.DeactivationConfirm,
            children: t("proceedWithdrawalProcedure")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Deactivation/viewModel.ts

var Deactivation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/Deactivation/index.tsx




/**
 * Deactivation Page
 * Implemented as a practical sample.
 */ var Deactivation = function() {
    var ref = Deactivation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/DeactivationCompletion/template/index.tsx







var DeactivationCompletionTemplate = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DeactivationCompletion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {},
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationCell, {})
            })
        ]
    });
};
var DeactivationCell = function() {
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationCompletion").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("withdrawalProcedureCompleted")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("thankDesc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 3,
                    mt: 4
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    href: routerPages.Top,
                    children: t("topPage")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeactivationCompletion/viewModel.ts

var DeactivationCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/DeactivationCompletion/index.tsx




/**
 * DeactivationCompletion Page
 * Implemented as a practical sample.
 */ var DeactivationCompletion = function() {
    var ref = DeactivationCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/DeactivationConfirm/template/DeactivationConfirmForm.tsx











var DeactivationConfirmForm_schema = function(o) {
    return {
        reasonNumber: o.string().label((0,core_form/* tLabel */.TQ)("deactivationConfirm.reasonNumber")),
        otherReason: o.string().when("reasonNumber", {
            is: "8",
            then: o.string().label((0,core_form/* tLabel */.TQ)("deactivationConfirm.otherReason")),
            otherwise: o.string().allow("").optional()
        }),
        opinion: o.string().allow("").optional().label((0,core_form/* tLabel */.TQ)("deactivationConfirm.opinion"))
    };
};
var DeactivationConfirmForm = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationConfirm").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: DeactivationConfirmForm_schema,
        defaultValues: {
            reasonNumber: "1",
            otherReason: "",
            opinion: ""
        }
    }), handleSubmit = ref.handleSubmit, register = ref.register, setValue = ref.setValue, watch = ref.watch, setError = ref.setError, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    var watchReasonNumber = watch("reasonNumber");
    var listItems = [
        {
            value: "1",
            label: t("artistReason")
        },
        {
            value: "2",
            label: t("favoriteArtistReason")
        },
        {
            value: "3",
            label: t("itemReason")
        },
        {
            value: "4",
            label: t("useAppReason")
        },
        {
            value: "5",
            label: t("functionReason")
        },
        {
            value: "6",
            label: t("priceReason")
        },
        {
            value: "7",
            label: t("privacyReason")
        },
        {
            value: "8",
            label: t("otherReason")
        }, 
    ];
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit(values).catch(function(error) {
            (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: watchReasonNumber === "8" ? 0 : 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButtonsCell, {
                        name: "reasonNumber",
                        setValue: setValue,
                        value: watchReasonNumber,
                        listItems: listItems,
                        error: errors === null || errors === void 0 ? void 0 : errors.reasonNumber
                    }),
                    watchReasonNumber === "8" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationConfirmForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.otherReason
                    }, register("otherReason")))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationConfirmForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 10,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                titleProps: {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("opinionTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("any")
                            })
                        ]
                    })
                },
                error: errors === null || errors === void 0 ? void 0 : errors.opinion
            }, register("opinion"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationConfirmForm_ButtonCell, {
                loading: isSubmitting,
                disabled: isSubmitting || !isValid
            })
        ]
    });
};
var DeactivationConfirmForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationConfirm").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var DeactivationConfirmForm_ButtonCell = function(param) {
    var loading = param.loading, disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationConfirm").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            textAlign: "center",
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            disabled: disabled,
            children: t("submit")
        })
    });
};
var RadioButtonsCell = function(param) {
    var titleProps = param.titleProps, error = param.error, setValue = param.setValue, value = param.value, name = param.name, listItems = param.listItems;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationConfirm").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.RadioButtonsGroup, {
            error: error,
            value: value,
            title: name,
            onChange: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(value) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setValue(name, value, {
                            shouldDirty: true,
                            shouldValidate: true
                        });
                        return [
                            2
                        ];
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }(),
            listItems: listItems,
            titleProps: (0,src_object_spread/* default */.Z)({
                variant: "h5",
                color: "text.primary",
                sx: {
                    alignItems: "center",
                    display: "flex"
                }
            }, titleProps),
            t: t
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeactivationConfirm/template/index.tsx





var DeactivationConfirmTemplate = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("deactivationConfirm").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DeactivationConfirm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.Deactivation,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationConfirmForm, {
                    onSubmit: onSubmit
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeactivationConfirm/viewModel.ts




function DeactivationConfirm_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeactivateUser($input: DeactivateUserInput!) {\n    deactivateUser(inputs: $input) {\n      id\n    }\n  }\n"
    ]);
    DeactivationConfirm_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DeactivationConfirm_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var logout = (0,auth/* useAuth */.aC)().logout;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DEACTIVATE_USER), 1), deactivateUser = ref1[0];
    return {
        state: {},
        actions: {
            onSubmit: function onSubmit(param) {
                var reasonNumber = param.reasonNumber, otherReason = param.otherReason, opinion = param.opinion;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deactivateUser({
                                        variables: {
                                            input: {
                                                reasonNumber: +reasonNumber,
                                                otherReason: otherReason || undefined,
                                                opinion: opinion
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    Promise.all([
                                        logout(),
                                        client.clearStore(),
                                        (0,storage/* clearStorage */.B$)()
                                    ])
                                ];
                            case 2:
                                _state.sent();
                                router.push(routerPages.DeactivationCompletion);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var DEACTIVATE_USER = (0,lib/* gql */.Ps)(DeactivationConfirm_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/DeactivationConfirm/index.tsx




/**
 * DeactivationConfirm Page
 * Implemented as a practical sample.
 */ var DeactivationConfirm = function() {
    var ref = DeactivationConfirm_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationConfirmTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/DeliveryInfoSetting/template/DeliveryInfoSettingForm.tsx












var DeliveryInfoSettingForm_schema = function(o) {
    return {
        phoneNumber: (0,validators/* validatePhoneNumber */.Y0)(o, "deliveryInfoSetting.phoneNumber"),
        fullName: (0,validators/* validateFullName */.fy)(o, "deliveryInfoSetting.fullName"),
        postalCode: o.string().custom(PostalCode/* PostalCode.createValidator */.R.createValidator()).label((0,core_form/* tLabel */.TQ)("deliveryInfoSetting.postalCode")),
        prefecture: (0,validators/* validatePrefecture */.f6)(o, "deliveryInfoSetting.prefecture"),
        city: (0,validators/* validateCity */.Co)(o, "deliveryInfoSetting.city"),
        line1: (0,validators/* validateLine1 */.lT)(o, "deliveryInfoSetting.line1"),
        line2: (0,validators/* validateLine2 */.iT)(o, "deliveryInfoSetting.line2")
    };
};
var DeliveryInfoSettingForm = function(param) {
    var deliveryInfo = param.deliveryInfo, onSubmitSetting = param.onSubmitSetting;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: DeliveryInfoSettingForm_schema,
        defaultValues: DeliveryInfoSettingForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, register = ref1.register, reset = ref1.reset, setError = ref1.setError;
    (0,react.useEffect)(function() {
        if (!deliveryInfo) return;
        var phoneNumber = deliveryInfo.phoneNumber, fullName = deliveryInfo.fullName, address = deliveryInfo.address;
        /**
     * @description
     * データをフォームに合わせるため、__typenameとfullAddressをaddressから除外する
     */ var _ref = address || {}, fullAddress = _ref.fullAddress, __typename = _ref.__typename, addressInput = (0,_object_without_properties/* default */.Z)(_ref, [
            "fullAddress",
            "__typename"
        ]);
        reset((0,src_object_spread/* default */.Z)({
            phoneNumber: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : "",
            fullName: fullName !== null && fullName !== void 0 ? fullName : ""
        }, addressInput));
    }, [
        deliveryInfo,
        reset
    ]);
    var onSubmit = handleSubmit(function(values) {
        var normalizedValues = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
            postalCode: PostalCode/* PostalCode.normalize */.R.normalize(values.postalCode)
        });
        return onSubmitSetting(normalizedValues).then(function() {
            return showMessage(t("submitSuccess"), "success");
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        sx: {
            py: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                error: errors === null || errors === void 0 ? void 0 : errors.phoneNumber
            }, register("phoneNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_DividerCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.fullName
            }, register("fullName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                textFieldProps: {
                    InputProps: {
                        inputProps: {
                            pattern: "\\d{3}-?\\d{4}|\\d{7}",
                            inputMode: "tel",
                            sx: {
                                px: 4,
                                py: 3
                            }
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.postalCode
            }, register("postalCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.prefecture
            }, register("prefecture"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.city
            }, register("city"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line1
            }, register("line1"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line2
            }, register("line2"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var DeliveryInfoSettingForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var DeliveryInfoSettingForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var DeliveryInfoSettingForm_DividerCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
    });
};
var DeliveryInfoSettingForm_defaultValues = {
    phoneNumber: "",
    fullName: "",
    postalCode: "",
    prefecture: "",
    city: "",
    line1: "",
    line2: ""
};

;// CONCATENATED MODULE: ./src/components/pages/DeliveryInfoSetting/template/index.tsx






var DeliveryInfoSettingTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryInfoSetting").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref4.routerNames, routerPages = ref4.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.AccountSetting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DeliveryInfoSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            pt: 2
                        },
                        color: "text.secondary",
                        children: t("label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body1",
                        sx: {
                            pt: 0
                        },
                        children: ((ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress) ? (ref2 = state.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.fullAddress : t("notRegisteredAddress")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingForm, {
                onSubmitSetting: onSubmit,
                deliveryInfo: state.user || {}
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeliveryInfoSetting/viewModel.ts





function DeliveryInfoSetting_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query userDeliveryInfo {\n    user {\n      ...UserDeliveryInfo\n    }\n  }\n  ",
        "\n"
    ]);
    DeliveryInfoSetting_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DeliveryInfoSetting_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateUserDeliveryInfo(\n    $updateUserDeliveryInfoInputs: UserDeliveryInput!\n  ) {\n    updateUserDeliveryInfo(inputs: $updateUserDeliveryInfoInputs) {\n      ...UserDeliveryInfo\n    }\n  }\n  ",
        "\n"
    ]);
    DeliveryInfoSetting_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var DeliveryInfoSetting_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var data = (0,useQuery/* useQuery */.aM)(DeliveryInfoSetting_viewModel_QUERY).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_USER_NOTIFICATION_SETTINGS), 1), updateUserDeliveryInfo = ref1[0];
    var ref2;
    return {
        state: {
            user: (ref2 = data === null || data === void 0 ? void 0 : data.user) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: values.fullName,
                                                phoneNumber: values.phoneNumber,
                                                address: {
                                                    postalCode: values.postalCode,
                                                    prefecture: values.prefecture,
                                                    city: values.city,
                                                    line1: values.line1,
                                                    line2: values.line2
                                                }
                                            }
                                        },
                                        update: function update(cache, param) {
                                            var data = param.data;
                                            var userDeliveryInfoResponse = data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo;
                                            var existingUser = cache.readQuery({
                                                query: DeliveryInfoSetting_viewModel_QUERY
                                            });
                                            if (existingUser && userDeliveryInfoResponse) {
                                                cache.writeQuery({
                                                    query: DeliveryInfoSetting_viewModel_QUERY,
                                                    data: {
                                                        user: (0,src_object_spread/* default */.Z)({}, existingUser.user, userDeliveryInfoResponse)
                                                    }
                                                });
                                            }
                                        }
                                    }).then(function() {
                                        var ref, ref1;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("registerShippingInfo", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            type: (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress) ? "update" : "register"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    router.goBack(routerPages.AccountSetting)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var DeliveryInfoSetting_viewModel_QUERY = (0,lib/* gql */.Ps)(DeliveryInfoSetting_viewModel_templateObject(), utoniq_core_schema/* UserDeliveryInfoFragmentDoc */.I0h);
var UPDATE_USER_NOTIFICATION_SETTINGS = (0,lib/* gql */.Ps)(DeliveryInfoSetting_viewModel_templateObject1(), utoniq_core_schema/* UserDeliveryInfoFragmentDoc */.I0h);

;// CONCATENATED MODULE: ./src/components/pages/DeliveryInfoSetting/index.tsx




var DeliveryInfoSetting = function() {
    var ref = DeliveryInfoSetting_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryInfoSettingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Stepper/Stepper.js
var Stepper = __webpack_require__(35988);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Step/Step.js
var Step_Step = __webpack_require__(20827);
// EXTERNAL MODULE: ../../node_modules/@mui/material/StepConnector/StepConnector.js
var StepConnector = __webpack_require__(12629);
// EXTERNAL MODULE: ../../node_modules/@mui/material/StepConnector/stepConnectorClasses.js
var stepConnectorClasses = __webpack_require__(49597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/StepLabel/StepLabel.js
var StepLabel = __webpack_require__(6774);
// EXTERNAL MODULE: ../../node_modules/@mui/material/StepLabel/stepLabelClasses.js
var stepLabelClasses = __webpack_require__(35304);
;// CONCATENATED MODULE: ./src/components/organisms/management/Status/index.tsx








var artistTheme = dist.themes.artistTheme;
var Status = function(param) {
    var activeStep = param.activeStep;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var steps = (0,react.useMemo)(function() {
        return [
            t("preparingToShip"),
            t("deliveryCompleted")
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            width: "100%",
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
            activeStep: activeStep,
            alternativeLabel: true,
            connector: /*#__PURE__*/ (0,jsx_runtime.jsx)(Status_StepConnector, {}),
            children: steps.map(function(label) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step_Step/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Status_StepLabel, {
                        StepIconComponent: StepIcon,
                        children: label
                    })
                }, label);
            })
        })
    });
};
var StepIcon = function(param) {
    var active = param.active, completed = param.completed, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconRoot, {
        ownerState: {
            active: active,
            completed: completed
        },
        className: className,
        children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Selected, {
            className: "stepIcon-completedIcon",
            fontSize: "small"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "stepIcon-circle"
        })
    });
};
var Status_StepConnector = (0,styled/* default */.ZP)(StepConnector/* default */.Z)(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var currentTheme = getThemeByMode(theme);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "&.".concat(stepConnectorClasses/* default.alternativeLabel */.Z.alternativeLabel), {
        top: 17,
        left: "calc(-50% + 5px)",
        right: "calc(50% + 5px)"
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(stepConnectorClasses/* default.active */.Z.active), (0,_define_property/* default */.Z)({}, "&& .".concat(stepConnectorClasses/* default.line */.Z.line), {
        borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (ref = currentTheme.palette) === null || ref === void 0 ? void 0 : (ref1 = ref.grey) === null || ref1 === void 0 ? void 0 : ref1["900"]
    })), (0,_define_property/* default */.Z)(_obj, "&.".concat(stepConnectorClasses/* default.completed */.Z.completed), (0,_define_property/* default */.Z)({}, "&& .".concat(stepConnectorClasses/* default.line */.Z.line), {
        borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (ref2 = currentTheme.palette) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grey) === null || ref3 === void 0 ? void 0 : ref3["900"]
    })), (0,_define_property/* default */.Z)(_obj, "&& .".concat(stepConnectorClasses/* default.line */.Z.line), {
        borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (ref4 = currentTheme.palette) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grey) === null || ref5 === void 0 ? void 0 : ref5["100"],
        borderTopWidth: 2,
        borderRadius: 1
    }), _obj;
});
var Status_StepLabel = (0,styled/* default */.ZP)(StepLabel/* default */.Z)(function(param) {
    var theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var currentTheme = getThemeByMode(theme);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "&& .".concat(stepLabelClasses/* default.alternativeLabel */.Z.alternativeLabel), {
        marginTop: 8,
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref = currentTheme.palette) === null || ref === void 0 ? void 0 : (ref1 = ref.text) === null || ref1 === void 0 ? void 0 : ref1.disabled
    }), (0,_define_property/* default */.Z)(_obj, "&& .".concat(stepLabelClasses/* default.labelContainer */.Z.labelContainer, " .").concat(stepLabelClasses/* default.completed */.Z.completed), {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref2 = currentTheme.palette) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.text) === null || ref3 === void 0 ? void 0 : ref3.disabled
    }), (0,_define_property/* default */.Z)(_obj, "&& .".concat(stepLabelClasses/* default.active */.Z.active), {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref4 = currentTheme.palette) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.text) === null || ref5 === void 0 ? void 0 : ref5.primary
    }), _obj;
});
var StepIconRoot = (0,styled/* default */.ZP)("div")(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var currentTheme = getThemeByMode(theme);
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref = currentTheme.palette) === null || ref === void 0 ? void 0 : (ref1 = ref.grey) === null || ref1 === void 0 ? void 0 : ref1["100"],
        display: "flex",
        height: 20,
        alignItems: "center"
    }, ownerState.active && {
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref2 = currentTheme.palette) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.grey) === null || ref3 === void 0 ? void 0 : ref3["900"]
    }), {
        "&& .stepIcon-completedIcon": {
            color: currentTheme === null || currentTheme === void 0 ? void 0 : (ref4 = currentTheme.palette) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.grey) === null || ref5 === void 0 ? void 0 : ref5["900"],
            zIndex: 1
        },
        "&& .stepIcon-circle": {
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: ownerState.completed ? currentTheme === null || currentTheme === void 0 ? void 0 : (ref6 = currentTheme.palette) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.grey) === null || ref7 === void 0 ? void 0 : ref7["900"] : currentTheme === null || currentTheme === void 0 ? void 0 : (ref8 = currentTheme.palette) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.grey) === null || ref9 === void 0 ? void 0 : ref9["100"]
        }
    });
});
/**
 * @description if mode is 'dark' return defaultTheme otherwise return artistTheme
 * @param theme
 */ function getThemeByMode(theme) {
    var ref;
    return (theme === null || theme === void 0 ? void 0 : (ref = theme.palette) === null || ref === void 0 ? void 0 : ref.mode) === "dark" ? theme : artistTheme;
}

;// CONCATENATED MODULE: ./src/components/organisms/management/DeliveryManagementBox/index.tsx









var DeliveryManagementBox = function(param) {
    var delivery = param.delivery, onApply = param.onApply, hideSerial = param.hideSerial;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var activeStep = (0,react.useMemo)(function() {
        switch(delivery.status){
            case utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped:
                return 1;
            default:
                return 0;
        }
    }, [
        delivery.status
    ]);
    var isExpire = (0,react.useMemo)(function() {
        var ref, ref1;
        return !!((ref = delivery.item.receptionPeriod) === null || ref === void 0 ? void 0 : ref.formattedEndedAt) && ((ref1 = delivery.item.receptionPeriod) === null || ref1 === void 0 ? void 0 : ref1.formattedEndedAt) < values_Date/* DateTime.now */.o.now();
    }, [
        (ref = delivery.item.receptionPeriod) === null || ref === void 0 ? void 0 : ref.formattedEndedAt
    ]);
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    flex: 1,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: delivery.item.title
                                }),
                                !!((ref1 = delivery.itemSerial) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sku) === null || ref2 === void 0 ? void 0 : ref2.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: (ref3 = delivery.itemSerial) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sku) === null || ref4 === void 0 ? void 0 : ref4.unitName
                                }),
                                (!hideSerial || config_config/* config.applicationKey */.v.applicationKey === "omenz") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: "text.secondary",
                                    variant: "overline",
                                    children: (ref10 = (ref5 = delivery.itemSerial) === null || ref5 === void 0 ? void 0 : ref5.formattedSerialNumber) !== null && ref10 !== void 0 ? ref10 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    sx: {
                                        pt: 1,
                                        mb: 3
                                    },
                                    children: delivery.item.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.secondary",
                                            children: t("applicationDeadLine")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            children: (ref6 = delivery.item.receptionPeriod) === null || ref6 === void 0 ? void 0 : ref6.formattedEndedAt
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "small",
                            src: (ref11 = (ref7 = delivery.item.thumbnail.front) === null || ref7 === void 0 ? void 0 : ref7.smallUri) !== null && ref11 !== void 0 ? ref11 : ""
                        })
                    ]
                }),
                delivery.formattedAppliedAt ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                            activeStep: activeStep
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("applicationDate")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        pt: 1
                                    },
                                    children: delivery.formattedAppliedAt
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                pt: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("shippingAddress")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    sx: {
                                        pt: 1
                                    },
                                    children: (ref8 = delivery.deliveryInfo) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.address) === null || ref9 === void 0 ? void 0 : ref9.fullAddress
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                pt: 5
                            },
                            justifyContent: "center",
                            direction: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                disabled: isExpire,
                                size: "small",
                                sx: {
                                    minWidth: 130
                                },
                                onClick: function() {
                                    return onApply(delivery);
                                },
                                children: t("btnApply")
                            })
                        }),
                        !isExpire && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                mt: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("note")
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeliveryManagement/template/index.tsx

















var DeliveryManagementTemplate = function(param) {
    var state = param.state, onApply = param.onApply, onFetchMore = param.onFetchMore, onChangeStatus = param.onChangeStatus, onSendVerificationSMS = param.onSendVerificationSMS;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref8.routerNames, routerPages = ref8.routerPages;
    var ref9 = (0,react.useState)(+state.initialTab.includes(utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging)), currentTab = ref9[0], setCurrentTab = ref9[1];
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(tab) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCurrentTab(tab);
                        return [
                            4,
                            onChangeStatus(tab ? [
                                utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
                                utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
                            ] : [
                                utoniq_core_schema/* DeliveryStatus.Unapplied */.$Tf.Unapplied
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(tab) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeStatus
    ]);
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: routerPages.Management,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DeliveryManagement
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    pt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CautionText, {
                    type: "info",
                    sx: {
                        bgcolor: "grey.50"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                        i18nKey: "deliveryInfo",
                        t: t,
                        components: {
                            linkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "span",
                                variant: "subtitle2",
                                color: "primary",
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: function() {
                                    (0,intercom/* updateIntercom */.dC)(user);
                                    (0,intercom/* openIntercom */.B6)();
                                }
                            })
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentEmailAddressCell, {
                user: state.user,
                loading: state.sendingVerification,
                onSendVerificationSMS: onSendVerificationSMS
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                // fix bug not show item
                disableAnimateTransitions: true,
                labels: [
                    t("unapplied"),
                    t("applied")
                ],
                value: currentTab,
                onChange: handleChangeTab,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ListCell, {
                        loading: state.loading,
                        applying: state.merchItemDeliveryApplying,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: function() {
                            return onFetchMore([
                                utoniq_core_schema/* DeliveryStatus.Unapplied */.$Tf.Unapplied
                            ]);
                        },
                        onApply: onApply,
                        hasRegisterAddress: !!((ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress),
                        deliveryItems: state.deliveryItems,
                        shortAddress: (ref10 = (ref2 = state.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.shortAddress) !== null && ref10 !== void 0 ? ref10 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ListCell, {
                        loading: state.loading,
                        applying: state.merchItemDeliveryApplying,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: function() {
                            return onFetchMore([
                                utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
                                utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
                            ]);
                        },
                        onApply: onApply,
                        hasRegisterAddress: !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.address) === null || ref5 === void 0 ? void 0 : ref5.fullAddress),
                        deliveryItems: state.deliveryItems,
                        shortAddress: (ref11 = (ref6 = state.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.address) === null || ref7 === void 0 ? void 0 : ref7.shortAddress) !== null && ref11 !== void 0 ? ref11 : ""
                    })
                ]
            })
        ]
    });
};
var CurrentEmailAddressCell = function(param) {
    var user = param.user, loading = param.loading, onSendVerificationSMS = param.onSendVerificationSMS;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4,
            mx: 5,
            border: "solid 1px",
            borderColor: "grey.200",
            borderRadius: "8px",
            mt: 5,
            mb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "space-between",
                flexDirection: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("shippingInfo")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            mr: -2
                        },
                        href: routerPages.DeliveryInfoSetting,
                        onClick: function() {
                            var ref;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_registerShippingInfo", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                type: (user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress) ? "update" : "register"
                            });
                        },
                        children: t((user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.fullAddress) ? "change" : "register")
                    })
                ]
            }),
            !(user === null || user === void 0 ? void 0 : user.address) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                color: "error.main",
                children: t("unregisteredShippingInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    mt: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("shippingAddress")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: (user === null || user === void 0 ? void 0 : (ref1 = user.address) === null || ref1 === void 0 ? void 0 : ref1.fullAddress) ? "text.primary" : "text.hint",
                        children: (ref3 = user === null || user === void 0 ? void 0 : (ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.fullAddress) !== null && ref3 !== void 0 ? ref3 : t("unregisteredShippingAddress")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("phoneNumber")
                            }),
                            !(user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                        fontSize: "small",
                                        sx: {
                                            color: "error.main",
                                            mt: -1
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "error.main",
                                        children: t("unverify")
                                    }),
                                    (user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        color: "primary",
                                        loading: loading,
                                        onClick: onSendVerificationSMS,
                                        children: t("verify")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                        fontSize: "small",
                                        sx: {
                                            color: "text.hint",
                                            mt: -1
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.hint",
                                        children: t("verified")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: user === null || user === void 0 ? void 0 : user.phoneNumber
                    }),
                    !(user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.hint",
                        children: t("unregistered")
                    })
                ]
            })
        ]
    });
};
var template_ListCell = function(param) {
    var loading = param.loading, applying = param.applying, hasNextPage = param.hasNextPage, deliveryItems = param.deliveryItems, hasRegisterAddress = param.hasRegisterAddress, onApply = param.onApply, onFetchMore = param.onFetchMore, hideSerial = param.hideSerial, shortAddress = param.shortAddress;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), openRegister = ref2[0], setOpenRegister = ref2[1];
    var ref3 = (0,react.useState)(null), delivery = ref3[0], setDelivery = ref3[1];
    var handleClose = (0,react.useCallback)(function() {
        setOpen(false);
        setOpenRegister(false);
        setDelivery(null);
    }, []);
    var handleOpenDialogApply = (0,react.useCallback)(function(delivery) {
        if (hasRegisterAddress) {
            setOpen(true);
            setDelivery(delivery);
            return;
        }
        setOpenRegister(true);
    }, [
        hasRegisterAddress
    ]);
    var handleApply = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!delivery) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        onApply(delivery)
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    setDelivery(null);
                    return [
                        2
                    ];
            }
        });
    }), [
        delivery,
        onApply
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: deliveryItems === null || deliveryItems === void 0 ? void 0 : (ref = deliveryItems.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryManagementBox, {
                        delivery: node,
                        onApply: handleOpenDialogApply,
                        hideSerial: !!node.item.hideSalesNumber
                    }, node.id);
                }),
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                componentProps: {
                    spacing: 5
                },
                emptyMessage: t("deliveryEmpty")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                onClose: handleClose,
                open: open,
                title: t("applyForShippingTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        pb: 7
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    textAlign: "left",
                                    children: t("applyForShippingDescription1")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    textAlign: "left",
                                    children: t("applyForShippingDescription2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    align: "left",
                                    children: t("shippingAddress")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            align: "left",
                                            width: "100%",
                                            children: shortAddress
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            href: routerPages.DeliveryInfoSetting,
                                            children: t("changeAddress")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212,
                        whiteSpace: "nowrap"
                    },
                    onClick: handleApply,
                    loading: applying,
                    disabled: !shortAddress,
                    children: t("apply")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                onClose: handleClose,
                open: openRegister,
                title: t("addressNotRegisteredTitle"),
                content: t("addressNotRegisteredDescription"),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    href: routerPages.DeliveryInfoSetting,
                    children: t("registerAddress")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DeliveryManagement/viewModel.ts




function DeliveryManagement_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DeliveryManagement(\n    $pageInput: PageInput\n    $deliveryItemsStatusFilter: [DeliveryStatus!]\n  ) {\n    user {\n      id\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n    deliveryItems(\n      pageInput: $pageInput\n      statusFilter: $deliveryItemsStatusFilter\n    ) {\n      ...DeliveryItemsConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    DeliveryManagement_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DeliveryManagement_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ApplyMerchItemDelivery($applyMerchItemDeliveryIds: [ID!]!) {\n    applyMerchItemDelivery(ids: $applyMerchItemDeliveryIds) {\n      ...DeliveryItemBox\n    }\n  }\n  ",
        "\n"
    ]);
    DeliveryManagement_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DeliveryManagement_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SendVerificationSMS {\n    sendVerificationSMS {\n      phoneNumber\n      id\n    }\n  }\n"
    ]);
    DeliveryManagement_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






/**
 * @note
 * 配送アイテムの初期表示タブ
 * 仕組み上、未申請ステータスを設けないアプリは「申請済み」を初期表示とする
 */ var initialTab = (0,individual/* individualOmitDeliveryStatusUnapplied */.$G)() ? [
    utoniq_core_schema/* DeliveryStatus.Arranging */.$Tf.Arranging,
    utoniq_core_schema/* DeliveryStatus.Shipped */.$Tf.Shipped
] : [
    utoniq_core_schema/* DeliveryStatus.Unapplied */.$Tf.Unapplied
];
var DeliveryManagement_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref2.showError, showMessage = ref2.showMessage;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("deliveryManagement").t;
    var ref4 = (0,useQuery/* useQuery */.aM)(DeliveryManagement_viewModel_QUERY, {
        variables: {
            deliveryItemsStatusFilter: initialTab
        },
        returnPartialData: true
    }), data = ref4.data, refetch = ref4.refetch, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(APPLY_MERCH_ITEM_DELIVERY), 2), applyMerchItemDelivery = ref5[0], ref6 = ref5[1], merchItemDeliveryApplying = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(SEND_VERIFICATION_SMS), 2), sendVerificationSMS = ref7[0], ref8 = ref7[1], sendingVerification = ref8.loading;
    var ref9, ref10;
    return {
        state: {
            initialTab: initialTab,
            loading: loading,
            merchItemDeliveryApplying: merchItemDeliveryApplying,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.deliveryItems) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
            deliveryItems: (ref9 = data === null || data === void 0 ? void 0 : data.deliveryItems) !== null && ref9 !== void 0 ? ref9 : null,
            user: (ref10 = data === null || data === void 0 ? void 0 : data.user) !== null && ref10 !== void 0 ? ref10 : null,
            sendingVerification: sendingVerification
        },
        actions: {
            onChangeStatus: function onChangeStatus(status) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        deliveryItemsStatusFilter: status
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore(status) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            deliveryItemsStatusFilter: status,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.deliveryItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onApply: function onApply(param) {
                var id = param.id;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    applyMerchItemDelivery({
                                        variables: {
                                            applyMerchItemDeliveryIds: [
                                                id
                                            ]
                                        }
                                    }).then(function() {
                                        return showMessage(t("applySuccess"), "success");
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        sendVerificationSMS().then(function() {
                            router.push(routerPages.SMSVerification);
                        }).catch(function(e) {
                            showError(e);
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var DeliveryManagement_viewModel_QUERY = (0,lib/* gql */.Ps)(DeliveryManagement_viewModel_templateObject(), utoniq_core_schema/* UserAddressFragmentDoc */.enF, utoniq_core_schema/* DeliveryItemsConnectionFragmentDoc */.vOB);
var APPLY_MERCH_ITEM_DELIVERY = (0,lib/* gql */.Ps)(DeliveryManagement_viewModel_templateObject1(), utoniq_core_schema/* DeliveryItemBoxFragmentDoc */.rZq);
var SEND_VERIFICATION_SMS = (0,lib/* gql */.Ps)(DeliveryManagement_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/DeliveryManagement/index.tsx




/**
 * DeliveryManagement Page
 * Implemented as a practical sample.
 */ var DeliveryManagement = function() {
    var ref = DeliveryManagement_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryManagementTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/DigitalMembershipCardDetail/template/index.tsx






var DigitalMembershipCardDetailTemplate = function(param) {
    var state = param.state;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, router = ref.router, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("digitalMembershipCardDetail").t;
    var handleClose = function() {
        router.goBack(routerPages.MyProfile);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        safeArea: {
            pt: 0
        },
        navigation: undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                width: "100%",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                    onClick: handleClose,
                    sx: {
                        position: "absolute",
                        top: 16,
                        left: 16,
                        zIndex: 10,
                        color: "text.primary"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        sx: {
                            width: 24,
                            height: 24,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "24px",
                            fontWeight: "bold"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Close, {
                            fontSize: "medium"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardContent, {
                    loading: state.loading,
                    artist: state.artist,
                    currentUser: state.currentUser,
                    patron: state.patron
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        bottom: 16,
                        left: 16,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                        color: "primary.main"
                    },
                    onClick: function() {
                        return router.push(routerPages.MembershipManagement);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MoveIn, {
                            fontSize: "medium",
                            sx: {
                                width: 24,
                                height: 24
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                fontSize: "10px",
                                fontWeight: 500,
                                textAlign: "center"
                            },
                            children: t("membershipManagement")
                        })
                    ]
                })
            ]
        })
    });
};
var DigitalMembershipCardContent = function(param) {
    var loading = param.loading, artist = param.artist, currentUser = param.currentUser, patron = param.patron;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,core_i18n/* useTranslation */.$G)("digitalMembershipCardDetail").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                px: 5,
                width: "100%",
                maxWidth: 400
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 200,
                sx: {
                    borderRadius: 3
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            px: 5,
            width: "100%",
            maxWidth: 600
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCard, {
                cardDesignPath: artist === null || artist === void 0 ? void 0 : (ref = artist.patron) === null || ref === void 0 ? void 0 : (ref1 = ref.userDigitalMembershipCard) === null || ref1 === void 0 ? void 0 : ref1.cardDesignPath,
                textColor: artist === null || artist === void 0 ? void 0 : (ref2 = artist.patron) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.userDigitalMembershipCard) === null || ref3 === void 0 ? void 0 : ref3.textColor,
                displayAreaColor: (artist === null || artist === void 0 ? void 0 : (ref4 = artist.patron) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.userDigitalMembershipCard) === null || ref5 === void 0 ? void 0 : ref5.displayAreaColor) || undefined,
                displayName: currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName,
                membershipNumber: (artist === null || artist === void 0 ? void 0 : (ref6 = artist.patron) === null || ref6 === void 0 ? void 0 : ref6.formattedMembershipNumber) || undefined,
                planInterval: patron === null || patron === void 0 ? void 0 : (ref7 = patron.plan) === null || ref7 === void 0 ? void 0 : ref7.interval,
                joinDate: artist === null || artist === void 0 ? void 0 : (ref8 = artist.patron) === null || ref8 === void 0 ? void 0 : ref8.createdAt,
                favoriteMemberCreatedAt: artist === null || artist === void 0 ? void 0 : (ref9 = artist.patron) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.favoriteMember) === null || ref10 === void 0 ? void 0 : ref10.createdAt,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 3,
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "text.primary",
                            mb: 1
                        },
                        children: (artist === null || artist === void 0 ? void 0 : artist.displayName) || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            fontSize: "14px",
                            color: "text.secondary",
                            mb: 2
                        },
                        children: (patron === null || patron === void 0 ? void 0 : patron.title) || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 0.5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                fontSize: "medium",
                                sx: {
                                    color: "primary.main",
                                    width: 12,
                                    height: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    fontSize: "12px",
                                    color: "primary.main",
                                    fontWeight: 500
                                },
                                children: t("membersOnly")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DigitalMembershipCardDetail/viewModel.ts

function DigitalMembershipCardDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DigitalMembershipCardDetail($artistId: ID!) {\n    artist(id: $artistId) {\n      id\n      displayName\n      avatar {\n        uri\n      }\n      ...ArtistMembershipSubscriptionDetail\n      patron {\n        createdAt\n        user {\n          displayName\n        }\n        subscription {\n          planId\n        }\n        favoriteMember {\n          createdAt\n        }\n        userDigitalMembershipCard {\n          cardDesignPath\n          textColor\n          displayAreaColor\n        }\n        formattedMembershipNumber\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    DigitalMembershipCardDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DigitalMembershipCardDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var ref3 = (0,auth/* useCurrentUser */.xJ)(), userClaims = ref3.userClaims, currentUser = ref3.user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref4 = (0,useQuery/* useQuery */.aM)(DigitalMembershipCardDetail_viewModel_QUERY, {
        variables: {
            artistId: artistId !== null && artistId !== void 0 ? artistId : ""
        },
        skip: !artistId
    }), data = ref4.data, loading = ref4.loading;
    var patron = (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(data === null || data === void 0 ? void 0 : data.artist, data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId);
    var ref5;
    return {
        state: {
            loading: loading,
            artist: (ref5 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref5 !== void 0 ? ref5 : null,
            currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : null,
            patron: patron !== null && patron !== void 0 ? patron : null
        },
        actions: {}
    };
});
var DigitalMembershipCardDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(DigitalMembershipCardDetail_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipSubscriptionDetailFragmentDoc */.lQ9);

;// CONCATENATED MODULE: ./src/components/pages/DigitalMembershipCardDetail/index.tsx



/**
 * DigitalMembershipCardDetail Page
 * Implemented as a practical sample.
 */ var DigitalMembershipCardDetail = function() {
    var state = DigitalMembershipCardDetail_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardDetailTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DmRoomDetail/template/index.tsx












var dmRoomDetailRef = /*#__PURE__*/ (0,react.createRef)();
var DmRoomDetailTemplate = function(param) {
    var state = param.state, onReply = param.onReply, onFetchMore = param.onFetchMore, onReportUser = param.onReportUser, onBlockDm = param.onBlockDm;
    var ref, ref1, ref2, ref3, ref4;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRoomDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref5 = (0,react.useState)(false), open = ref5[0], setOpen = ref5[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var handleReportUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onReportUser((ref5 = (ref = state.dmRoom) === null || ref === void 0 ? void 0 : ref.id) !== null && ref5 !== void 0 ? ref5 : "", (ref6 = (ref1 = state.dmRoom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.artist) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "", (ref7 = (ref3 = state.dmRoom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : ref4.accountId) !== null && ref7 !== void 0 ? ref7 : "")
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onReportUser,
        state.dmRoom
    ]);
    var handleBlockDm = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onBlockDm((ref2 = (ref = state.dmRoom) === null || ref === void 0 ? void 0 : (ref1 = ref.artist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "")
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onBlockDm,
        state.dmRoom
    ]);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref = state.dmRoom) === null || ref === void 0 ? void 0 : (ref1 = ref.artist) === null || ref1 === void 0 ? void 0 : ref1.id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
                styles: {
                    body: {
                        overflow: "hidden"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DmRoomDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    title: (ref6 = (ref2 = state.dmRoom) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref6 !== void 0 ? ref6 : "",
                    back: true,
                    right: state.dmRoom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                        bgcolor: "transparent",
                        color: "grey.700",
                        size: "medium",
                        onClick: toggleDrawer(true)
                    }) : undefined
                },
                navigation: {
                    type: "replyForm",
                    props: {
                        onReply: function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        onReply(values)
                                    ];
                                });
                            });
                            return function(values) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        visibleImage: true,
                        userId: "",
                        singleInputMode: true
                    }
                },
                sx: {
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomMessageList, {
                    userId: state.userId,
                    messages: state.messages,
                    dmRoom: state.dmRoom,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    emptyMessage: t("empty"),
                    refObject: dmRoomDetailRef
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                disableEnforceFocus: true,
                open: open,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: (ref3 = state.dmRoom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : ref4.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                onClick: handleLoginModal(handleReportUser),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("report")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                divider: true,
                                onClick: handleLoginModal(handleBlockDm),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("block")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: toggleDrawer(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DmRoomDetail/viewModel.ts





function DmRoomDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DmRoomDetail($dmRoomId: ID!) {\n    dmRoom(dmRoomId: $dmRoomId) {\n      id\n      title\n      artist {\n        id\n        displayName\n        accountId\n        avatar {\n          uri\n          smallUri\n        }\n      }\n      users {\n        id\n        displayName\n        avatar {\n          uri\n          smallUri\n        }\n      }\n    }\n  }\n"
    ]);
    DmRoomDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DmRoomDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DmRoomOlderMessages($dmRoomId: ID!, $pageInput: PageInput) {\n    dmRoomMessages(dmRoomId: $dmRoomId, pageInput: $pageInput) {\n      ...DmRoomMessageConnection\n    }\n  }\n  ",
        "\n"
    ]);
    DmRoomDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DmRoomDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  subscription DmRoomMessageCreated($dmRoomId: ID!) {\n    dmRoomMessageCreated(dmRoomId: $dmRoomId) {\n      ...DmRoomMessageBox\n    }\n  }\n  ",
        "\n"
    ]);
    DmRoomDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DmRoomDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateDmRoomMessage($inputs: CreateDmRoomMessageInput!) {\n    createDmRoomMessage(inputs: $inputs) {\n      ...DmRoomMessageBox\n    }\n  }\n  ",
        "\n"
    ]);
    DmRoomDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DmRoomDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation BlockDm($inputs: BlockDmRoomInput!) {\n    blockDm(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    DmRoomDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var viewModel_DM_ROOM_MESSAGES_PAGE_LIMIT = 20;
var DmRoomDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRoomDetail").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var ref3 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref3.showError, showMessage = ref3.showMessage;
    var _dmRoomId;
    var ref4 = (0,useQuery/* useQuery */.aM)(viewModel_DM_ROOM_DETAIL, {
        variables: {
            dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : ""
        }
    }), data = ref4.data, loadingDetail = ref4.loading;
    var _dmRoomId1;
    /** アクセス前に投稿済みのメッセージを取得 */ var ref5 = (0,useQuery/* useQuery */.aM)(viewModel_DM_ROOM_OLDER_MESSAGES, {
        variables: {
            dmRoomId: (_dmRoomId1 = router.query.dmRoomId) !== null && _dmRoomId1 !== void 0 ? _dmRoomId1 : "",
            /**
         * 初回描画時に画面の高さに満たず再フェッチが起こり
         * レイアウトシフトが起きることを避けるため20件取得
         */ pageInput: {
                limit: viewModel_DM_ROOM_MESSAGES_PAGE_LIMIT
            }
        },
        /**
       * 一覧画面からの遷移時に最新コメント1件を取得したキャッシュにより
       * 1件のみが先に描画され追加フェッチが走ってしまい
       * レイアウトシフトが起きることを避けるため network-only を設定
       */ fetchPolicy: "network-only",
        nextFetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        onError: function() {
            showError(t("error"));
        }
    }), olderMessagesData = ref5.data, loadingOlderMessages = ref5.loading, fetchMore = ref5.fetchMore;
    var ref6;
    /** アクセスより前のコメント */ var olderMessages = orderBy_default()((ref6 = olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref = olderMessagesData.dmRoomMessages) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
        var node = param.node;
        return node;
    })) !== null && ref6 !== void 0 ? ref6 : [], [
        "createdAt"
    ], [
        "asc"
    ]);
    var _dmRoomId2;
    /** リアルタイムで投稿された最新メッセージを取得 */ var ref7 = (0,useSubscription/* useSubscription */.m)(viewModel_DM_ROOM_MESSAGE_CREATED, {
        variables: {
            dmRoomId: (_dmRoomId2 = router.query.dmRoomId) !== null && _dmRoomId2 !== void 0 ? _dmRoomId2 : ""
        },
        onData: function() {
            setTimeout(function() {
                var /**
           * ユーザーがメッセージ最下部付近を表示している場合
           * メッセージリストを最下部へスクロールする
           *
           * スクロールの有無は DmRoomMessageList で判断
           */ ref;
                (ref = dmRoomDetailRef.current) === null || ref === void 0 ? void 0 : ref.toBottom();
            }, 0);
        },
        onError: function() {
            showError(t("error"));
        }
    }), dmRoomMessageCreatedData = ref7.data, loadingSubscribedMessages = ref7.loading;
    /** リアルタイムで投稿された最新メッセージを配列化 */ var ref8 = (0,react.useState)([]), subscribedMessages = ref8[0], setSubscribedMessages = ref8[1];
    (0,react.useEffect)(function() {
        if (!dmRoomMessageCreatedData) return;
        setSubscribedMessages(function(prev) {
            if (prev.some(function(message) {
                var ref;
                return (message === null || message === void 0 ? void 0 : message.id) === ((ref = dmRoomMessageCreatedData.dmRoomMessageCreated) === null || ref === void 0 ? void 0 : ref.id);
            })) return prev;
            return orderBy_default()((0,src_to_consumable_array/* default */.Z)(prev).concat([
                dmRoomMessageCreatedData.dmRoomMessageCreated
            ]), [
                "createdAt"
            ], [
                "asc"
            ]);
        });
    }, [
        dmRoomMessageCreatedData
    ]);
    /** 既にエラーを表示済みかを保持する ref */ var hasMismatchError = (0,react.useRef)(false);
    /**
   * メッセージが正常に取得できていない場合にエラー表示を行う
   * 1. API で取得した最新1件と WebSocket で取得した最古1件の重複チェック
   * 2. WebSocket で取得したメッセージのシーケンス番号の整合性チェック
   */ (0,react.useEffect)(function() {
        /**
     * useEffect 内で showError を実行した際
     * 親コンポーネントの state 変更 → 再レンダリング
     * → useEffect の再実行 → showError の実行... のように
     * レンダリングが無限に走ってしまうことを避けるため
     * 一度エラーを表示したら再度エラーを表示しないように制御する
     */ if (hasMismatchError.current) return;
        /** ローディング中はチェックしない */ if (loadingDetail || loadingOlderMessages || loadingSubscribedMessages || olderMessages.length === 0 || subscribedMessages.length === 0) return;
        /** WebSocket から取得した最古のメッセージ */ var oldestSubscribedMessage = subscribedMessages[0];
        /** WebSocket から取得した最新のメッセージ */ var newestSubscribedMessage = subscribedMessages[subscribedMessages.length - 1];
        /** API で取得した最新のメッセージ */ var newestOlderMessage = olderMessages[olderMessages.length - 1];
        /**
     * API で取得した最新1件と WebSocket で取得した最古1件の重複チェック
     *
     * 両方のメッセージが存在し ID が一致しない場合は
     * メッセージ取得中に新たなメッセージが追加され差分が出ている可能性が高いため
     * 画面再読み込みでメッセージ取得からやり直してもらうようユーザにエラーを表示する
     *
     * WebSocket 確立中に送信されたメッセージが取得できていなかった場合を想定している
     */ var hasIdMismatch = (oldestSubscribedMessage === null || oldestSubscribedMessage === void 0 ? void 0 : oldestSubscribedMessage.id) && (newestOlderMessage === null || newestOlderMessage === void 0 ? void 0 : newestOlderMessage.id) && oldestSubscribedMessage.id !== newestOlderMessage.id;
        var ref, ref1;
        /**
     * WebSocket で取得したメッセージのシーケンス番号の整合性チェック
     *
     * 2025年10月時点
     *
     * ネイティブアプリにて DM 詳細画面を開いたままバックグラウンドに移行して
     * 再度フォアグラウンドに戻った際に、バックグラウンド中に複数のメッセージを受信していると
     * 最新メッセージ以外が受信できず、メッセージの欠落が発生してしまう
     *
     * 本来はフォアグラウンド復帰時にメッセージの再取得を行うのが好ましいが
     * リリースを優先し、ユーザーに再読み込みを促すエラーを表示する暫定対応を行う
     *
     * フォアグラウンド復帰時にメッセージの再取得を行うロジックを実装後は
     * hasSeqNoMismatch のチェックは削除して問題ない
     */ var hasSeqNoMismatch = ((ref = newestSubscribedMessage === null || newestSubscribedMessage === void 0 ? void 0 : newestSubscribedMessage.seqNo) !== null && ref !== void 0 ? ref : 0) - ((ref1 = oldestSubscribedMessage === null || oldestSubscribedMessage === void 0 ? void 0 : oldestSubscribedMessage.seqNo) !== null && ref1 !== void 0 ? ref1 : 0) + 1 !== subscribedMessages.length;
        /** いずれかのエラー条件を満たした場合、一度だけエラーを表示 */ if (hasIdMismatch || hasSeqNoMismatch) {
            hasMismatchError.current = true;
            showError(t("mismatchError"));
        }
    }, [
        olderMessages,
        subscribedMessages,
        loadingDetail,
        loadingOlderMessages,
        loadingSubscribedMessages, 
    ]);
    /**
   * @description
   * 投稿済みのメッセージとリアルタイムで取得したメッセージを結合したもの
   * 重複したデータは除外する
   *
   * nodes に長さを持つ配列が渡されると、loading に関わらず
   * skelton を解除するという ScrollFetcher の実装により、
   * 比較的短時間で取得可能な subscribedMessages だけが
   * 先に表示されてしまうことを防ぐために
   * 各クエリの loading 状態による条件分岐を追加している
   */ var messages = loadingDetail || loadingOlderMessages && olderMessages.length === 0 || loadingSubscribedMessages ? [] : (0,src_to_consumable_array/* default */.Z)(olderMessages.filter(function(message) {
        return message !== null && message !== undefined;
    })// 重複回避のため最新1件を除外
    .slice(0, -1)).concat((0,src_to_consumable_array/* default */.Z)(subscribedMessages.filter(function(message) {
        return message !== null && message !== undefined;
    }))).reverse();
    /** メッセージを作成 */ var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(viewModel_DM_ROOM_MESSAGE_CREATE), 1), createDmRoomMessage = ref9[0];
    /** DMをブロック */ var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(BLOCK_DM), 1), blockDm = ref10[0];
    /** フォームからの入力をもとに、メッセージ作成用の変数を作成 */ var buildCreateDmRoomMessageVariables = function(inputs) {
        /** テキストメッセージの場合 */ if (inputs.content) {
            var _dmRoomId;
            return {
                dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : "",
                message: inputs.content,
                type: utoniq_core_schema/* DmRoomMessageType.Text */.$R4.Text
            };
        }
        var _dmRoomId1;
        /** 画像メッセージの場合 */ return {
            dmRoomId: (_dmRoomId1 = router.query.dmRoomId) !== null && _dmRoomId1 !== void 0 ? _dmRoomId1 : "",
            resources: inputs.resources,
            type: utoniq_core_schema/* DmRoomMessageType.Image */.$R4.Image
        };
    };
    var ref11;
    return {
        state: {
            loading: loadingDetail || loadingOlderMessages,
            userId: (ref11 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref11 !== void 0 ? ref11 : "",
            dmRoom: data === null || data === void 0 ? void 0 : data.dmRoom,
            messages: messages,
            hasNextPage: !!(olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref1 = olderMessagesData.dmRoomMessages) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage)
        },
        actions: {
            onReply: function onReply(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createDmRoomMessage({
                                        variables: {
                                            inputs: buildCreateDmRoomMessageVariables(inputs)
                                        }
                                    }).catch(function(error) {
                                        showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _dmRoomId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : "",
                                            pageInput: {
                                                limit: viewModel_DM_ROOM_MESSAGES_PAGE_LIMIT,
                                                cursor: olderMessagesData === null || olderMessagesData === void 0 ? void 0 : (ref = olderMessagesData.dmRoomMessages) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    }).catch(function(error) {
                                        showError(t("error"));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "dm-rooms",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockDm: function onBlockDm(targetUserId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _dmRoomId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockDm({
                                        variables: {
                                            inputs: {
                                                dmRoomId: (_dmRoomId = router.query.dmRoomId) !== null && _dmRoomId !== void 0 ? _dmRoomId : "",
                                                targetUserId: targetUserId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                showMessage(t("blockArtistSuccess"), "success");
                                // DM一覧画面に遷移
                                router.push(generatePath(routerPages.DmRooms, {}));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var viewModel_DM_ROOM_DETAIL = (0,lib/* gql */.Ps)(DmRoomDetail_viewModel_templateObject());
var viewModel_DM_ROOM_OLDER_MESSAGES = (0,lib/* gql */.Ps)(DmRoomDetail_viewModel_templateObject1(), utoniq_core_schema/* DmRoomMessageConnectionFragmentDoc */.vJ8);
var viewModel_DM_ROOM_MESSAGE_CREATED = (0,lib/* gql */.Ps)(DmRoomDetail_viewModel_templateObject2(), utoniq_core_schema/* DmRoomMessageBoxFragmentDoc */.eBW);
var viewModel_DM_ROOM_MESSAGE_CREATE = (0,lib/* gql */.Ps)(DmRoomDetail_viewModel_templateObject3(), utoniq_core_schema/* DmRoomMessageBoxFragmentDoc */.eBW);
var BLOCK_DM = (0,lib/* gql */.Ps)(DmRoomDetail_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/DmRoomDetail/index.tsx




/**
 * DmRoomDetail Page
 * Implemented as a practical sample.
 */ var DmRoomDetail = function() {
    var ref = DmRoomDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/DmRooms/template/index.tsx










var DmRoomsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("dmRooms").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.DmRooms
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("title"),
                    back: true
                },
                sx: {
                    pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        componentProps: {
                            sx: {
                                pt: 2,
                                pb: 5
                            },
                            spacing: 5
                        },
                        nodes: (ref = state.dmRooms) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomBox, {
                                dmRoom: node
                            }, node.id);
                        }),
                        onFetchMore: onFetchMore,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        emptyMessage: t("emptyDmRoom"),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                pb: 7
                            },
                            children: Array.from(Array(4).keys()).map(function(key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomSkeleton, {}, key);
                            })
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/DmRooms/viewModel.ts



function DmRooms_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query DmRooms($pageInput: PageInput) {\n    userDmRooms(pageInput: $pageInput) {\n      ...UserDmRoomsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    DmRooms_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DmRooms_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    // userDmRoomsクエリを実行しDMルーム一覧を取得
    var ref1 = (0,useQuery/* useQuery */.aM)(DmRooms_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {}
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2, ref3;
    return {
        state: {
            userId: (ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : "",
            dmRooms: (ref3 = data === null || data === void 0 ? void 0 : data.userDmRooms) !== null && ref3 !== void 0 ? ref3 : null,
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.userDmRooms) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: /**
       * 次のページを取得する（無限スクロール）
       */ function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            // 最後のカーソル位置から続き取得
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.userDmRooms) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
/**
 * ユーザ用DMルーム一覧を取得するクエリ
 */ var DmRooms_viewModel_QUERY = (0,lib/* gql */.Ps)(DmRooms_viewModel_templateObject(), utoniq_core_schema/* UserDmRoomsConnectionFragmentDoc */.M7n);

;// CONCATENATED MODULE: ./src/components/pages/DmRooms/index.tsx




/**
 * DmRooms Page
 * Implemented as a practical sample.
 */ var DmRooms = function() {
    var ref = DmRooms_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DmRoomsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/@firebase/util/dist/index.esm2017.js
var index_esm2017 = __webpack_require__(83395);
;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailAddressInputForm.tsx












var EmailAddressInputForm_defaultValues = {
    email: "",
    password: ""
};
var EmailAddressInputForm_schema = function(o) {
    return {
        email: (0,validators/* validateEmail */.oH)(o, "emailAddressSettings.email"),
        password: o.string().min(8).max(30).label((0,core_form/* tLabel */.TQ)("emailAddressSettings.password"))
    };
};
var EmailAddressSettingForm = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: EmailAddressInputForm_schema,
        mode: "onChange",
        defaultValues: EmailAddressInputForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, reset = ref.reset;
    var t = (0,core_i18n/* useTranslation */.$G)([
        "emailAddressSettings",
        "firebase"
    ]).t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(function(inputs) {
            return onSubmit(inputs).then(function() {
                reset();
            }).catch(function(e) {
                // firebaseの認証エラー
                if ((0,_instanceof/* default */.Z)(e, index_esm2017/* FirebaseError */.ZR) && e.code.startsWith("auth/")) {
                    var message = t(e.code === "auth/wrong-password" ? "emailAddressSettings:wrongPassword" : "firebase:auth.errors.".concat(e.code));
                    showError(new Error(message));
                } else {
                    showError(new Error(t("emailAddressSettings:error")));
                }
            });
        }, function(e) {
            // クライアントでのバリデーションエラー
            showError(new Error(t("emailAddressSettings:error")));
            throw e;
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentEmailTextCell, {
                email: state.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "email",
                error: errors === null || errors === void 0 ? void 0 : errors.email
            }, register("email"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputForm_DescriptionCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var CurrentEmailTextCell = function(param) {
    var email = param.email;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    my: 2,
                    color: "grey.600"
                },
                children: t("currentEmailAddress")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    mt: 2,
                    mb: 7,
                    color: "text.primary"
                },
                children: email
            })
        ]
    });
};
var EmailAddressInputForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var EmailAddressInputForm_DescriptionCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            children: t("emailAddressSettings:emailAddressInputDescription")
        })
    });
};
var EmailAddressInputForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: loading,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailAddressInputFormSNS.tsx












var EmailAddressInputFormSNS_defaultValues = {
    email: ""
};
var EmailAddressInputFormSNS_schema = function(o) {
    return {
        email: (0,validators/* validateEmail */.oH)(o, "emailAddressSettings.email")
    };
};
/**
 * @description
 * SNSでアカウント作成したユーザー用のフォーム
 * パスワード入力欄がなく、認証コードでメアドを更新する。
 */ var EmailAddressSettingFormSNS = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref = (0,core_form/* useForm */.cI)({
        schema: EmailAddressInputFormSNS_schema,
        mode: "onChange",
        defaultValues: EmailAddressInputFormSNS_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, reset = ref.reset;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputFormSNS_CurrentEmailTextCell, {
                email: state.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputFormSNS_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "email",
                error: errors === null || errors === void 0 ? void 0 : errors.email
            }, register("email"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmTextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputFormSNS_ButtonCell, {
                        loading: isSubmitting
                    })
                ]
            })
        ]
    });
};
var EmailAddressInputFormSNS_CurrentEmailTextCell = function(param) {
    var email = param.email;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    my: 2,
                    color: "grey.600"
                },
                children: t("currentEmailAddress")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    mt: 2,
                    mb: 7,
                    color: "text.primary"
                },
                children: email
            })
        ]
    });
};
var EmailAddressInputFormSNS_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var ConfirmTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            children: t("confirm")
        })
    });
};
var EmailAddressInputFormSNS_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: loading,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailAddressInputTemplate.tsx







var EmailAddressInputTemplate = function(param) {
    var state = param.state, sendVerificationMail = param.sendVerificationMail;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title"),
                back: true,
                defaultBackPage: routerPages.AccountSetting
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.EmailSetting
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressSettingForm, {
                    state: state,
                    onSubmit: sendVerificationMail
                })
            ]
        })
    });
};
var EmailAddressInputSocialTemplate = function(param) {
    var state = param.state, sendVerificationMailSocial = param.sendVerificationMailSocial;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title"),
                back: true,
                defaultBackPage: routerPages.AccountSetting
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.EmailSetting
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressSettingFormSNS, {
                    state: state,
                    onSubmit: sendVerificationMailSocial
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailAddressSettingCompleteModal.tsx




/**
 * @description
 * メールアドレス変更後に表示するモーダル
 */ var EmailAddressSettingCompleteModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("emailAddressSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("updateSuccess"),
        content: t("updateSuccessDesc"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: t("back")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailVerificationForm.tsx









var EmailVerificationForm_schema = function(o) {
    return {
        code: o.string().length(6).label((0,core_form/* tLabel */.TQ)("signUp.code"))
    };
};
/**
 *  EmailVerification Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */ var EmailVerificationForm = function(param) {
    var loading = param.loading, onSubmit = param.onSubmit, onResend = param.onResend;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: EmailVerificationForm_schema
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onVerify = handleSubmit(function(values) {
        return onSubmit(values).catch(function(e) {
            return showError(e);
        });
    });
    var onResendAuthMail = function() {
        return onResend().then(function() {
            return showMessage(t("resended"));
        }).catch(function(e) {
            return showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onVerify,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerificationForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.code
            }, register("code"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerificationForm_ButtonCell, {
                loading: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResendButtonCell, {
                onResendAuthMail: onResendAuthMail,
                loading: loading
            })
        ]
    });
};
var EmailVerificationForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            titleProps: {
                sx: {
                    display: "none"
                }
            }
        }))
    });
});
var EmailVerificationForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var ResendButtonCell = function(param) {
    var onResendAuthMail = param.onResendAuthMail, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                textAlign: "right"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                variant: "text",
                onClick: onResendAuthMail,
                loading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("resend")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/EmailVerificationTemplate.tsx







var EmailVerificationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onResend = param.onResend;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerificationForm, {
            loading: state.verifyEmailSending,
            onSubmit: onSubmit,
            onResend: onResend
        })
    });
};
var Layout = function(param) {
    var children = param.children;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.AccountSetting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCell, {}),
            children
        ]
    });
};
var TextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "text.primary",
            children: t("description")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/template/index.tsx





var EmailAddressSettingsTemplate = function(param) {
    var state = param.state, sendVerificationMail = param.sendVerificationMail, sendVerificationMailSocial = param.sendVerificationMailSocial, resendVerificationMail = param.resendVerificationMail, updateEmail = param.updateEmail, onCloseCompleteModal = param.onCloseCompleteModal;
    if (state.isBoundWithSNS) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputSocialTemplate, {
            state: state,
            sendVerificationMailSocial: sendVerificationMailSocial
        });
    }
    return state.step === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressInputTemplate, {
        state: state,
        sendVerificationMail: sendVerificationMail
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressSettingCompleteModal, {
                open: state.step === 2,
                onClose: onCloseCompleteModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerificationTemplate, {
                state: state,
                onSubmit: updateEmail,
                onResend: resendVerificationMail
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/viewModel.ts




function EmailAddressSettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateUserEmail($inputs: UpdateUserEmailInput) {\n    updateUserEmail(inputs: $inputs) {\n      id\n      email\n    }\n  }\n"
    ]);
    EmailAddressSettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var EmailAddressSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,react.useState)(0), step = ref[0], nextStep = ref[1];
    var ref1 = (0,react.useState)({
        email: "",
        password: ""
    }), formValues = ref1[0], setFormValues = ref1[1];
    var ref2 = (0,auth/* useAuth */.aC)(), user = ref2.user, reauthenticateCurrentUserWithPassword = ref2.reauthenticateCurrentUserWithPassword, updateEmail = ref2.updateEmail, isBoundWithSNS = ref2.isBoundWithSNS;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationEmail */.ZCf), 2), sendVerifyEmail = ref4[0], ref5 = ref4[1], verifyEmailSending = ref5.loading;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UpdateUserEmail), 1), updateUserEmail = ref6[0];
    return {
        state: {
            step: step,
            email: (user === null || user === void 0 ? void 0 : user.email) || "",
            isBoundWithSNS: isBoundWithSNS,
            verifyEmailSending: verifyEmailSending
        },
        actions: {
            // step0ではpasswordは使わないが、step1で使うため、stateに保存しておく
            sendVerificationMail: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var email, password;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                email = param.email, password = param.password;
                                return [
                                    4,
                                    reauthenticateCurrentUserWithPassword(password)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: email
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                // sendVerifyEmailで認証コード送信が完了してから、フォームに入力したemailとpasswordをstateに保存する
                                setFormValues({
                                    email: email,
                                    password: password
                                });
                                // step1に進めて、認証コード入力フォームを表示する
                                nextStep(1);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            sendVerificationMailSocial: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var email;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                email = param.email;
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: email
                                        }
                                    }).then(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        (0,storage/* setMailInput */.m8)(email)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    router.push(routerPages.MailAuth);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            resendVerificationMail: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var email;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            email = formValues.email;
                            return [
                                4,
                                sendVerifyEmail({
                                    variables: {
                                        email: email
                                    }
                                }).catch(showError)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            updateEmail: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var code, email, password;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        code = param.code;
                        email = formValues.email, password = formValues.password;
                        return [
                            2,
                            updateEmail(email, password, function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(inputEmail) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    updateUserEmail({
                                                        variables: {
                                                            inputs: {
                                                                email: inputEmail,
                                                                code: code
                                                            }
                                                        }
                                                    }).then(function() {
                                                        // メールアドレス更新後、stepを2に進めて更新完了ダイアログを表示する
                                                        nextStep(2);
                                                    }).catch(function(e) {
                                                        throw e;
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(inputEmail) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onCloseCompleteModal: function() {
                router.push(routerPages.AccountSetting);
            }
        }
    };
});
var UpdateUserEmail = (0,lib/* gql */.Ps)(EmailAddressSettings_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/EmailAddressSettings/index.tsx



/**
 * EmailAddressSettings Page
 * Implemented as a practical sample.
 */ var EmailAddressSettings = function() {
    var ref = EmailAddressSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAddressSettingsTemplate, {
        state: state,
        updateEmail: actions.updateEmail,
        sendVerificationMail: actions.sendVerificationMail,
        resendVerificationMail: actions.resendVerificationMail,
        sendVerificationMailSocial: actions.sendVerificationMailSocial,
        onCloseCompleteModal: actions.onCloseCompleteModal
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/ListSubheader/ListSubheader.js
var ListSubheader = __webpack_require__(89098);
;// CONCATENATED MODULE: ./src/components/pages/EmailNotificationSettings/template/index.tsx









var EmailNotificationSettingsTemplate = function(param) {
    var state = param.state, onToggle = param.onToggle, onArtistToggle = param.onArtistToggle;
    var t = (0,core_i18n/* useTranslation */.$G)("emailNotificationSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var list = (0,react.useMemo)(function() {
        return [
            {
                label: t("postLabel"),
                hidden: false,
                items: [
                    {
                        label: t("newPost"),
                        checked: state.newPost,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.PostNewPost */.tbb.PostNewPost,
                                flag: !state.newPost
                            });
                        }
                    },
                    {
                        label: t("replyComment"),
                        checked: state.replyPost,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.PostReplyPost */.tbb.PostReplyPost,
                                flag: !state.replyPost
                            });
                        }
                    },
                    {
                        label: t("artistReplyPost"),
                        hidden: !state.isArtist,
                        checked: state.artistReplyPost,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Email */.qAq.Email,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.PostReplyPost */.rzv.PostReplyPost,
                                flag: !state.artistReplyPost
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("missionLabel"),
                hidden: false,
                items: [
                    {
                        label: t("replyCommentMission"),
                        checked: state.replyCommentMission,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.MissionReplyCommentMission */.tbb.MissionReplyCommentMission,
                                flag: !state.replyCommentMission
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("campaignLabel"),
                hidden: !config_config/* config.modules.campaign */.v.modules.campaign,
                items: [
                    {
                        label: t("newCampaign"),
                        checked: state.startCampaign,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.CampaignStartCampaign */.tbb.CampaignStartCampaign,
                                flag: !state.startCampaign
                            });
                        }
                    },
                    {
                        label: t("endCampaign"),
                        checked: state.endCampaign,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.CampaignEndCampaign */.tbb.CampaignEndCampaign,
                                flag: !state.endCampaign
                            });
                        }
                    }, 
                ]
            },
            /**
       * @description
       * Open when function is implemented in the future
       */ // {
            //   label: t('campaignLabel'),
            //   hidden: !config.modules.campaign,
            //   items: [
            //     {
            //       label: t('newCampaign'),
            //       checked: state.newCampaign,
            //       onChange() {},
            //     },
            //   ],
            // },
            {
                label: t("threadLabel"),
                hidden: !config_config/* config.modules.thread */.v.modules.thread,
                items: [
                    {
                        label: t("commentCreationThread"),
                        checked: state.commentThread,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.ThreadChannelCommentThread */.tbb.ThreadChannelCommentThread,
                                flag: !state.commentThread
                            });
                        }
                    },
                    {
                        label: t("replyCommentThread"),
                        checked: state.replyCommentThread,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.ThreadChannelReplyCommentThread */.tbb.ThreadChannelReplyCommentThread,
                                flag: !state.replyCommentThread
                            });
                        }
                    },
                    {
                        label: t("newThread"),
                        hidden: !state.isArtist,
                        checked: state.artistNewThread,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Email */.qAq.Email,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.ArtistThreadChannelNewThread */.rzv.ArtistThreadChannelNewThread,
                                flag: !state.artistNewThread
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("gachaLabel"),
                hidden: !config_config/* config.modules.gacha */.v.modules.gacha,
                items: [
                    {
                        label: t("announce"),
                        checked: state.gachaUpcomingExpiry,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.GachaUpcomingExpiry */.tbb.GachaUpcomingExpiry,
                                flag: !state.gachaUpcomingExpiry
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("tradeLabel"),
                hidden: !config_config/* config.modules.trade */.v.modules.trade,
                items: [
                    {
                        label: t("receiveTrade"),
                        checked: state.requestTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeRequestTrade */.tbb.TradeRequestTrade,
                                flag: !state.requestTrade
                            });
                        }
                    },
                    {
                        label: t("commentTrade"),
                        checked: state.commentTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeCommentTrade */.tbb.TradeCommentTrade,
                                flag: !state.commentTrade
                            });
                        }
                    },
                    /**
           * @description
           * Open when function is implemented in the future
           */ // {
                    //   label: t('resultTrade'),
                    //   checked: state.resultTrade,
                    //   onChange() {},
                    // },
                    /**
           * @deprecated it'll remove in the future
           */ {
                        label: t("agreedTrade"),
                        checked: state.agreedTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeAgreedTrade */.tbb.TradeAgreedTrade,
                                flag: !state.agreedTrade
                            });
                        }
                    },
                    /**
           * @deprecated it'll remove in the future
           */ {
                        label: t("declinedTrade"),
                        checked: state.declinedTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeDeclinedTrade */.tbb.TradeDeclinedTrade,
                                flag: !state.declinedTrade
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("membershipLabel"),
                hidden: !state.isArtist,
                items: [
                    {
                        label: t("membership"),
                        checked: state.artistMembershipSubscribe,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Email */.qAq.Email,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.MembershipSubscribe */.rzv.MembershipSubscribe,
                                flag: !state.artistMembershipSubscribe
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("announce"),
                items: [
                    {
                        label: t("announcementOfficial"),
                        checked: state.announcementOfficial,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Email */.yv_.Email,
                                type: utoniq_core_schema/* NotificationSettingsType.AnnouncementOfficial */.tbb.AnnouncementOfficial,
                                flag: !state.announcementOfficial
                            });
                        }
                    }, 
                ]
            }, 
        ];
    }, [
        onArtistToggle,
        onToggle,
        state.agreedTrade,
        state.artistMembershipSubscribe,
        state.artistNewThread,
        state.artistReplyPost,
        state.commentTrade,
        state.declinedTrade,
        state.endCampaign,
        state.isArtist,
        state.newMission,
        state.newPost,
        state.replyPost,
        state.requestTrade,
        state.startCampaign,
        state.startLiveStream,
        state.announcementOfficial,
        state.replyCommentMission,
        state.commentThread,
        state.replyCommentThread,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Setting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.EmailNotificationSettings
            }),
            list.map(function(param, index) {
                var label = param.label, hidden = param.hidden, items = param.items;
                return !hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    sx: {
                        bgcolor: "grey.50"
                    },
                    subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                        sx: {
                            pb: 2,
                            pt: 4,
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            color: "text.hint",
                            children: label
                        })
                    }),
                    children: items.map(function(item, itemIndex) {
                        return !item.hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            divider: true,
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                checked: item.checked,
                                onChange: item.onChange
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                primary: item.label,
                                slotProps: {
                                    primary: {
                                        variant: "body1"
                                    }
                                }
                            })
                        }, "".concat(index, "-").concat(itemIndex));
                    })
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EmailNotificationSettings/viewModel.ts




function EmailNotificationSettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EmailNotificationSettings {\n    user {\n      id\n      ...UserSetting\n    }\n  }\n  ",
        "\n"
    ]);
    EmailNotificationSettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmailNotificationSettings_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistNotificationSettings {\n    artist {\n      id\n      ...ArtistSetting\n    }\n  }\n  ",
        "\n"
    ]);
    EmailNotificationSettings_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmailNotificationSettings_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateUserNotificationSettings(\n    $updateUserNotificationSettingsInputs: UserNotificationSettingsInput!\n  ) {\n    updateUserNotificationSettings(\n      inputs: $updateUserNotificationSettingsInputs\n    ) {\n      ... on User {\n        id\n        ...UserSetting\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    EmailNotificationSettings_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmailNotificationSettings_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistNotificationSettings(\n    $inputs: ArtistNotificationSettingsInput!\n  ) {\n    updateArtistNotificationSettings(inputs: $inputs) {\n      ... on Artist {\n        id\n        ...ArtistSetting\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    EmailNotificationSettings_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var EmailNotificationSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var isArtist = !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist);
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var data = (0,useQuery/* useQuery */.aM)(EmailNotificationSettings_viewModel_QUERY).data;
    var ref42 = (0,useQuery/* useQuery */.aM)(ARTIST_QUERY, {
        skip: !isArtist
    }), artistData = ref42.data;
    var ref43 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(viewModel_UPDATE_USER_NOTIFICATION_SETTINGS), 1), updateUserNotificationSettings = ref43[0];
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_NOTIFICATION_SETTINGS), 1), updateArtistNotificationSettings = ref44[0];
    var notifications = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.settings) === null || ref3 === void 0 ? void 0 : ref3.notifications;
    var artistNotifications = artistData === null || artistData === void 0 ? void 0 : (ref4 = artistData.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.settings) === null || ref5 === void 0 ? void 0 : ref5.notifications;
    return {
        state: {
            isArtist: isArtist,
            newPost: !!(notifications === null || notifications === void 0 ? void 0 : (ref6 = notifications.post) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.newPost) === null || ref7 === void 0 ? void 0 : ref7.email),
            replyPost: !!(notifications === null || notifications === void 0 ? void 0 : (ref8 = notifications.post) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.replyPost) === null || ref9 === void 0 ? void 0 : ref9.email),
            newMission: !!(notifications === null || notifications === void 0 ? void 0 : (ref10 = notifications.mission) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.newMission) === null || ref11 === void 0 ? void 0 : ref11.email),
            replyCommentMission: !!(notifications === null || notifications === void 0 ? void 0 : (ref12 = notifications.mission) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.replyCommentMission) === null || ref13 === void 0 ? void 0 : ref13.email),
            requestTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref14 = notifications.trade) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.requestTrade) === null || ref15 === void 0 ? void 0 : ref15.email),
            commentTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref16 = notifications.trade) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.commentTrade) === null || ref17 === void 0 ? void 0 : ref17.email),
            agreedTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref18 = notifications.trade) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.agreedTrade) === null || ref19 === void 0 ? void 0 : ref19.email),
            declinedTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref20 = notifications.trade) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.declinedTrade) === null || ref21 === void 0 ? void 0 : ref21.email),
            startCampaign: !!(notifications === null || notifications === void 0 ? void 0 : (ref22 = notifications.campaign) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.startCampaign) === null || ref23 === void 0 ? void 0 : ref23.email),
            endCampaign: !!(notifications === null || notifications === void 0 ? void 0 : (ref24 = notifications.campaign) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.endCampaign) === null || ref25 === void 0 ? void 0 : ref25.email),
            startLiveStream: !!(notifications === null || notifications === void 0 ? void 0 : (ref26 = notifications.liveStream) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.startLiveStream) === null || ref27 === void 0 ? void 0 : ref27.email),
            artistReplyPost: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref28 = artistNotifications.post) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.replyPost) === null || ref29 === void 0 ? void 0 : ref29.email),
            artistNewThread: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref30 = artistNotifications.artistThreadChannel) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.newThread) === null || ref31 === void 0 ? void 0 : ref31.email),
            artistMembershipSubscribe: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref32 = artistNotifications.membership) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.subscribe) === null || ref33 === void 0 ? void 0 : ref33.email),
            announcementOfficial: !!(notifications === null || notifications === void 0 ? void 0 : (ref34 = notifications.announcement) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.official) === null || ref35 === void 0 ? void 0 : ref35.email),
            commentThread: !!(notifications === null || notifications === void 0 ? void 0 : (ref36 = notifications.threadChannel) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.commentThread) === null || ref37 === void 0 ? void 0 : ref37.email),
            replyCommentThread: !!(notifications === null || notifications === void 0 ? void 0 : (ref38 = notifications.threadChannel) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.replyCommentThread) === null || ref39 === void 0 ? void 0 : ref39.email),
            gachaUpcomingExpiry: !!(notifications === null || notifications === void 0 ? void 0 : (ref40 = notifications.gacha) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.upcomingExpiry) === null || ref41 === void 0 ? void 0 : ref41.email)
        },
        actions: {
            onToggle: function onToggle(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserNotificationSettings({
                                        variables: {
                                            updateUserNotificationSettingsInputs: value
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            var ref;
                                            var ref1;
                                            var updateUserNotificationSettings = {
                                                id: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "",
                                                settings: {
                                                    notifications: cloneDeep_default()(notifications),
                                                    __typename: "UserSettings"
                                                },
                                                __typename: "User"
                                            };
                                            var ref2 = (0,_sliced_to_array/* default */.Z)(value.type.split("_"), 2), type = ref2[0], subType = ref2[1];
                                            set_default()(updateUserNotificationSettings, "settings.notifications.".concat(type, ".").concat(subType, ".").concat(value.channel), value.flag);
                                            return {
                                                updateUserNotificationSettings: updateUserNotificationSettings
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onArtistToggle: function onArtistToggle(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateArtistNotificationSettings({
                                        variables: {
                                            inputs: value
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            var ref;
                                            var ref1;
                                            var updateArtistNotificationSettings = {
                                                id: (ref1 = artistData === null || artistData === void 0 ? void 0 : (ref = artistData.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "",
                                                settings: {
                                                    notifications: cloneDeep_default()(artistNotifications),
                                                    __typename: "ArtistSettings"
                                                },
                                                __typename: "Artist"
                                            };
                                            var ref2 = (0,_sliced_to_array/* default */.Z)(value.type.split("_"), 2), type = ref2[0], subType = ref2[1];
                                            set_default()(updateArtistNotificationSettings, "settings.notifications.".concat(type, ".").concat(subType, ".").concat(value.channel), value.flag);
                                            return {
                                                updateArtistNotificationSettings: updateArtistNotificationSettings
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var EmailNotificationSettings_viewModel_QUERY = (0,lib/* gql */.Ps)(EmailNotificationSettings_viewModel_templateObject(), utoniq_core_schema/* UserSettingFragmentDoc */.EIs);
var ARTIST_QUERY = (0,lib/* gql */.Ps)(EmailNotificationSettings_viewModel_templateObject1(), utoniq_core_schema/* ArtistSettingFragmentDoc */.JwT);
var viewModel_UPDATE_USER_NOTIFICATION_SETTINGS = (0,lib/* gql */.Ps)(EmailNotificationSettings_viewModel_templateObject2(), utoniq_core_schema/* UserSettingFragmentDoc */.EIs);
var UPDATE_ARTIST_NOTIFICATION_SETTINGS = (0,lib/* gql */.Ps)(EmailNotificationSettings_viewModel_templateObject3(), utoniq_core_schema/* ArtistSettingFragmentDoc */.JwT);

;// CONCATENATED MODULE: ./src/components/pages/EmailNotificationSettings/index.tsx




/**
 * EmailNotificationSettings Page
 * Implemented as a practical sample.
 */ var EmailNotificationSettings = function() {
    var ref = EmailNotificationSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailNotificationSettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/event/StoreCard/index.tsx









var StoreCard = function(param) {
    var eventCollection = param.eventCollection;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var t = (0,dist_es/* useTranslation */.$G)("eventDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var _collectionId, ref6, _uri, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ShokufesEventCollectionDetail, {
                    collectionId: (ref6 = (_collectionId = eventCollection.collectionId) !== null && _collectionId !== void 0 ? _collectionId : eventCollection.collection.id) !== null && ref6 !== void 0 ? ref6 : "#",
                    eventId: eventCollection.eventId
                }),
                onClick: function() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        eventId: eventCollection.eventId,
                        collectionId: eventCollection.collection.id,
                        artistId: eventCollection.collection.artist.id,
                        name: "eventCollection"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                        component: "img",
                        image: (_uri = eventCollection.collection.thumbnail.uri) !== null && _uri !== void 0 ? _uri : "",
                        alt: eventCollection.collection.title,
                        sx: {
                            height: 160
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            p: 5,
                            "&:last-child": {
                                pb: 5
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupLabel, {
                                isEventPickup: !!eventCollection.collection.isEventPickup
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("itemCount", {
                                    count: eventCollection.collection.itemCount
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                sx: (0,src_object_spread/* default */.Z)({
                                    pt: 1
                                }, styles/* styleSets.lineCamp */.k$.lineCamp(2)),
                                children: eventCollection.collection.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                sx: {
                                    pt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: (ref8 = (ref7 = (ref = eventCollection.collection.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref7 !== void 0 ? ref7 : (ref2 = eventCollection.collection.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.avatar) === null || ref3 === void 0 ? void 0 : ref3.uri) !== null && ref8 !== void 0 ? ref8 : "",
                                        sx: {
                                            width: 24,
                                            height: 24
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secodary",
                                        children: (ref4 = eventCollection.collection.artist) === null || ref4 === void 0 ? void 0 : ref4.displayName
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var PickupLabel = function(param) {
    var isEventPickup = param.isEventPickup;
    var t = (0,dist_es/* useTranslation */.$G)("eventDetail").t;
    if (!isEventPickup) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        sx: {
            mr: 2,
            height: 20,
            borderRadius: "2px",
            minWidth: 40,
            ".MuiChip-label": {
                px: 1
            },
            bgcolor: "primary.main"
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: "white",
            variant: "overline",
            children: t("pickup")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EventCollectionDetail/template/index.tsx


















var template_defaultLabels = [
    null
];
var EventCollectionDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onClickShare = param.onClickShare, onChangeLabel = param.onChangeLabel;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref10 = (0,react.useState)(0), currentTab = ref10[0], setCurrentTab = ref10[1];
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var _mediumUri, ref11;
    var thumbnailUri = (ref11 = (_mediumUri = (ref = state.collection) === null || ref === void 0 ? void 0 : ref.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : (ref1 = state.collection) === null || ref1 === void 0 ? void 0 : ref1.thumbnail.uri) !== null && ref11 !== void 0 ? ref11 : "";
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (!state.collection) {
            return;
        }
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "event_store_list",
            item_list_name: "Event Store Items",
            items: (ref = state.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.collectionItems) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
                var node = param.node;
                var ref;
                return {
                    item_id: node.item.id,
                    item_name: node.item.title,
                    item_category: "store_item",
                    item_category2: node.item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: 1,
                    item_category5: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                    price: node.item.price
                };
            })
        });
    }, [
        AnalyticsProvider/* useAnalytics */.z$,
        (ref2 = state.collection) === null || ref2 === void 0 ? void 0 : ref2.id
    ]);
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(number) {
            var ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = state.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.labels) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                            return [
                                2
                            ];
                        }
                        setCurrentTab(number);
                        return [
                            4,
                            onChangeLabel(number === 0, (ref3 = (ref2 = state.collection.labels[number]) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(number) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeLabel,
        (ref3 = state.collection) === null || ref3 === void 0 ? void 0 : ref3.labels
    ]);
    var ref12, ref13, _id, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref4 = state.collection) === null || ref4 === void 0 ? void 0 : ref4.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ShokufesEventCollectionDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionImageCell, {
                        userCartCount: state.userCartCount,
                        loading: state.loading,
                        imageUrl: thumbnailUri,
                        eventId: state.eventId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDetailCell, {
                        loading: state.loading,
                        collection: state.collection,
                        onClickShare: onClickShare
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                        labels: (ref13 = (ref5 = state.collection) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.labels) === null || ref6 === void 0 ? void 0 : ref6.map(function(label) {
                            return (ref12 = label === null || label === void 0 ? void 0 : label.name) !== null && ref12 !== void 0 ? ref12 : "";
                        })) !== null && ref13 !== void 0 ? ref13 : [],
                        hiddenLabel: !((ref7 = state.collection) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.labels) === null || ref8 === void 0 ? void 0 : ref8.length),
                        value: currentTab,
                        disableAnimateTransitions: true,
                        onChange: handleChangeTab,
                        children: (((ref9 = state.collection) === null || ref9 === void 0 ? void 0 : ref9.labels) || template_defaultLabels).map(function(label, index) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StoreCollectionListCell, {
                                loading: state.loading,
                                hasNextPage: state.hasNextPage,
                                collectionItems: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.collectionItems,
                                onFetchMore: function() {
                                    return onFetchMore(index === 0, label === null || label === void 0 ? void 0 : label.name);
                                },
                                artistId: (_id = (ref1 = state.collection) === null || ref1 === void 0 ? void 0 : ref1.artist.id) !== null && _id !== void 0 ? _id : "",
                                collectionId: (ref14 = (ref2 = state.collection) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref14 !== void 0 ? ref14 : "",
                                eventId: state.eventId
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var CollectionImageCell = function(param) {
    var loading = param.loading, imageUrl = param.imageUrl, userCartCount = param.userCartCount, eventId = param.eventId;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (loading && !imageUrl) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 212,
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    "& > *": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    color: "transparent",
                    elevation: 0,
                    sx: {
                        backgroundColor: "transparent"
                    },
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            borderRadius: "50%",
                            width: 44,
                            height: 44,
                            bgcolor: "grey.50"
                        }
                    }),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            borderRadius: "50%",
                            width: 44,
                            height: 44,
                            bgcolor: "grey.50"
                        }
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                elevation: 0,
                position: "absolute",
                color: "transparent",
                sx: {
                    right: "auto",
                    maxWidth: 600,
                    bgcolor: "transparent",
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    bgcolor: "grey.50",
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.ShokufesEventDetail, {
                            eventId: eventId
                        }));
                    }
                }),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    badgeContent: userCartCount,
                    color: "primary",
                    sx: {
                        "& > span": function(param) {
                            var typography = param.typography;
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                top: 8,
                                minWidth: 16,
                                width: 16,
                                height: 16
                            }, typography.overline), {
                                color: "white"
                            });
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Store, {
                        edge: "end",
                        bgcolor: "grey.50",
                        size: "medium",
                        onClick: handleLoginModal(function() {
                            return router.push(routerPages.StoreCartList);
                        }, true)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
                imageUri: imageUrl,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            })
        ]
    });
};
var CollectionDetailCell = function(param) {
    var loading = param.loading, collection = param.collection, onClickShare = param.onClickShare;
    var t = (0,core_i18n/* useTranslation */.$G)("eventCollectionDetail").t;
    if (loading && !collection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                py: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        pb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "20%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "50%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "30%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 38,
                            height: 44
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 3,
                        lastWidth: "60%"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupLabel, {
                                isEventPickup: !!(collection === null || collection === void 0 ? void 0 : collection.isEventPickup)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                children: collection === null || collection === void 0 ? void 0 : collection.artist.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                children: collection === null || collection === void 0 ? void 0 : collection.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("itemNumber", {
                                    number: collection === null || collection === void 0 ? void 0 : collection.itemCount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                            variant: "text",
                            sx: {
                                px: 0,
                                display: "grid",
                                gridTemplateColumns: "1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Share, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.600",
                                        mx: "auto"
                                    },
                                    onClick: onClickShare
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("share")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: collection === null || collection === void 0 ? void 0 : collection.description
            })
        ]
    });
};
var StoreCollectionListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, collectionItems = param.collectionItems, onFetchMore = param.onFetchMore, artistId = param.artistId, collectionId = param.collectionId, eventId = param.eventId;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("eventCollectionDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 5
        },
        children: [
            loading && !(collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.edges) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    py: 2
                },
                children: t("productInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                component: Grid2/* default */.Z,
                componentProps: {
                    spacing: 3,
                    container: true
                },
                itemComponent: Grid2/* default */.Z,
                itemComponentProps: {
                    size: {
                        xs: 4,
                        md: 3
                    }
                },
                nodes: collectionItems === null || collectionItems === void 0 ? void 0 : (ref = collectionItems.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                    var node = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StoreItemArea/* StoreItemArea */.S, {
                        canGoBack: true,
                        collectionId: collectionId,
                        item: node.item,
                        artistId: artistId,
                        eventId: eventId,
                        onClick: function() {
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
                                item_list_id: "event_store_list_".concat(artistId),
                                item_list_name: "Event Store Items",
                                items: [
                                    {
                                        item_id: node.item.id,
                                        item_name: node.item.title,
                                        item_category: "store_item",
                                        item_category2: node.item.type,
                                        item_category3: native_app/* getPlatform */.Xf(),
                                        item_category4: 1,
                                        item_category5: artistId,
                                        price: node.item.price
                                    }, 
                                ]
                            });
                        }
                    }, node.id);
                }),
                emptyMessage: t("productInfoEmptyMessage"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    container: true,
                    spacing: 3,
                    sx: {
                        py: 2
                    },
                    children: Array.from(Array(6).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                            size: {
                                xs: 4,
                                md: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemAreaSkeleton/* StoreItemAreaSkeleton */.E, {})
                        }, key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EventCollectionDetail/viewModel.ts



function EventCollectionDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EventCollectionDetail(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n    $publishedOnly: Boolean\n  ) {\n    userCartCount\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      isEventPickup\n      artist {\n        id\n        displayName\n      }\n      thumbnail {\n        uri\n        mediumUri\n      }\n      labels {\n        id\n        name\n      }\n      itemCount\n      description\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        publishedOnly: $publishedOnly\n        pageInput: $pageInput\n      ) {\n        ...EventCollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    EventCollectionDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventCollectionDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EventCollectionDetailForGuest(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n    $publishedOnly: Boolean\n  ) {\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      isEventPickup\n      artist {\n        id\n        displayName\n      }\n      thumbnail {\n        uri\n        mediumUri\n      }\n      itemCount\n      description\n      labels {\n        name\n        id\n      }\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        publishedOnly: $publishedOnly\n        pageInput: $pageInput\n      ) {\n        ...EventCollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    EventCollectionDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









/**
 *
 */ var EventCollectionDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref5 = (0,react.useState)(false), refetching = ref5[0], setRefetching = ref5[1];
    var ref6 = (0,useQuery/* useQuery */.aM)(EventCollectionDetail_viewModel_QUERY, {
        skip: !user,
        returnPartialData: true,
        variables: {
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            publishedOnly: true,
            pageInput: {
                limit: 12
            }
        }
    }), data = ref6.data, loading = ref6.loading, fetchMore = ref6.fetchMore, refetch = ref6.refetch;
    var ref7 = (0,useQuery/* useQuery */.aM)(EventCollectionDetail_viewModel_QUERY_FOR_GUEST, {
        skip: !!user,
        variables: {
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            pageInput: {
                limit: 12
            }
        }
    }), dataForGuest = ref7.data, loadingForGuest = ref7.loading, fetchMoreForGuest = ref7.fetchMore, refetchForGuest = ref7.refetch;
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: "/events/".concat(data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artistId, "/collections/").concat(router.query.collectionId)
    });
    var ref8, ref9;
    return {
        state: {
            collection: (ref8 = data === null || data === void 0 ? void 0 : data.collection) !== null && ref8 !== void 0 ? ref8 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.collection,
            eventId: router.query.eventId,
            loading: loading || loadingForGuest || refetching,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collectionItems) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage) || !!(dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref3 = dataForGuest.collection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.collectionItems) === null || ref4 === void 0 ? void 0 : ref4.pageInfo.hasNextPage),
            userCartCount: (ref9 = data === null || data === void 0 ? void 0 : data.userCartCount) !== null && ref9 !== void 0 ? ref9 : 0
        },
        actions: {
            onChangeLabel: function onChangeLabel(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetchForGuest({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    refetch({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, currentData, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                currentData = data !== null && data !== void 0 ? data : dataForGuest;
                                if (!(currentData === null || currentData === void 0 ? void 0 : (ref = currentData.collection) === null || ref === void 0 ? void 0 : ref.collectionItems.pageInfo.hasNextPage)) return [
                                    2
                                ];
                                setRefetching(true);
                                if (!!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreForGuest({
                                        variables: {
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                cursor: currentData === null || currentData === void 0 ? void 0 : (ref2 = currentData.collection) === null || ref2 === void 0 ? void 0 : ref2.collectionItems.pageInfo.endCursor,
                                                limit: 12
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                setRefetching(false);
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                cursor: currentData === null || currentData === void 0 ? void 0 : (ref1 = currentData.collection) === null || ref1 === void 0 ? void 0 : ref1.collectionItems.pageInfo.endCursor,
                                                limit: 12
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                setRefetching(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: function onClickShare() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _collection, title, description, thumbnail, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.collection)) return [
                                    2
                                ];
                                _collection = data.collection, title = _collection.title, description = _collection.description, thumbnail = _collection.thumbnail;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    artistId: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                    collectionId: router.query.collectionId,
                                    name: "eventCollectionDetail"
                                });
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: "".concat(title, " | ").concat(t("metaTitle")),
                                        text: description !== null && description !== void 0 ? description : "",
                                        url: url,
                                        dialogTitle: "".concat(title, " | ").concat(t("metaTitle"))
                                    }).then(function() {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                            collectionId: router.query.collectionId,
                                            name: "eventCollectionDetail"
                                        });
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var EventCollectionDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(EventCollectionDetail_viewModel_templateObject(), utoniq_core_schema/* EventCollectionItemsConnectionFragmentDoc */.wb7);
var EventCollectionDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(EventCollectionDetail_viewModel_templateObject1(), utoniq_core_schema/* EventCollectionItemsConnectionFragmentDoc */.wb7);

;// CONCATENATED MODULE: ./src/components/pages/EventCollectionDetail/index.tsx




/**
 * EventCollectionDetail Page
 * Implemented as a practical sample.
 */ var EventCollectionDetail = function() {
    var ref = EventCollectionDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCollectionDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/event/PreSaleCard/index.tsx








var PreSaleCard = function(param) {
    var preSale = param.preSale;
    var t = (0,dist_es/* useTranslation */.$G)("eventDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    // 応募期間・購入期間の表示
    var applicationPeriod = (0,react.useMemo)(function() {
        var ref, ref1;
        if (preSale.type === "lottery") {
            var ref2, ref3;
            return {
                label: t("applicationPeriod"),
                value: "".concat(values_Date/* DateTime.formatDate */.o.formatDate((ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationStartedAt, "YYYY/MM/DD(ddd) HH:mm"), " 〜 ").concat(values_Date/* DateTime.formatDate */.o.formatDate((ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.applicationEndedAt, "YYYY/MM/DD(ddd) HH:mm"))
            };
        }
        return {
            label: t("purchasablePeriod"),
            value: "".concat(values_Date/* DateTime.formatDate */.o.formatDate((ref = preSale.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.purchasableStartedAt, "YYYY/MM/DD(ddd) HH:mm"), " 〜 ").concat(values_Date/* DateTime.formatDate */.o.formatDate((ref1 = preSale.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableEndedAt, "YYYY/MM/DD(ddd) HH:mm"))
        };
    }, [
        preSale
    ]);
    var resaleAvailable = (0,react.useMemo)(function() {
        var ref;
        return preSale.type === utoniq_core_schema/* PreSaleType.FirstComeFirstServed */.osN.FirstComeFirstServed && ((ref = preSale.items) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var isResaleAvailable = param.isResaleAvailable;
            return isResaleAvailable;
        }));
    }, [
        preSale.items,
        preSale.type
    ]);
    var color = (0,react.useMemo)(function() {
        switch(preSale.preSaleStatus){
            case utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting:
                return {
                    color: "primary"
                };
            case utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption:
                return {
                    color: "secondary"
                };
            case utoniq_core_schema/* PreSaleStatus.SoldOut */.fu$.SoldOut:
                return {
                    color: "error"
                };
            default:
                return {
                    color: "default"
                };
        }
    }, [
        preSale.preSaleStatus
    ]).color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            href: preSale.type === "lottery" ? generatePath(routerPages.LotteryDetail, {
                preSaleId: preSale.id
            }) : generatePath(routerPages.FirstComeFirstServedDetail, {
                preSaleId: preSale.id
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            p: 5,
                            pb: 3
                        },
                        children: [
                            preSale.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 0,
                                sx: {
                                    placeItems: "center",
                                    pb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                        fontSize: "small",
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        color: "text.hint",
                                        children: t("isPremium")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: preSale.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                spacing: 1,
                                sx: {
                                    mt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                sx: {
                                                    ".MuiChip-root": {
                                                        bgcolor: "background.default",
                                                        border: "1px solid",
                                                        borderColor: "grey.500",
                                                        display: "grid",
                                                        placeItems: "center"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    size: "small",
                                                    label: t(preSale === null || preSale === void 0 ? void 0 : preSale.type)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                size: "small",
                                                sx: // Chipに設定されていないカラーなので、独自に設定する
                                                preSale.preSaleStatus === "acceptingLottery" ? {
                                                    bgcolor: "info.light",
                                                    color: "default",
                                                    fontSize: "10px",
                                                    fontWeight: 700
                                                } : preSale.preSaleStatus === "purchasable" ? {
                                                    bgcolor: "secondary.light",
                                                    color: "default",
                                                    fontSize: "10px",
                                                    fontWeight: 700
                                                } : undefined,
                                                label: t("".concat(preSale.preSaleStatus)),
                                                color: color
                                            })
                                        ]
                                    }),
                                    resaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "primary.main",
                                        children: t("resaleAvailable")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            bgcolor: "grey.100",
                            px: 5,
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                fontSize: "10px"
                            },
                            children: [
                                applicationPeriod.label,
                                applicationPeriod.value
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/event/StoreCardSkeleton/index.tsx



var StoreCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                height: 160,
                width: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "20%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h6",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        sx: {
                            pt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                sx: {
                                    width: 24,
                                    height: 24
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "20%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EventDetail/template/index.tsx




















var EventDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onRequestPermission = param.onRequestPermission, onFetchPreSalesMore = param.onFetchPreSalesMore;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), openMap = ref5[0], setOpenMap = ref5[1];
    var ref6 = (0,react.useState)(state.tab), currentTab = ref6[0], setCurrentTab = ref6[1];
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), router = ref7.router, generatePath = ref7.generatePath, routerPages = ref7.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("eventDetail").t;
    var handleTabChange = (0,react.useCallback)(function(value) {
        setCurrentTab(value);
        // If you use router.replace, the page will re-render, causing it to scroll to the top.
        // https://stackoverflow.com/a/61596862
        window.history.replaceState(window.history.state, "", generatePath(routerPages.ShokufesEventDetail, {
            eventId: router.query.eventId,
            tab: value === 0 ? "presale" : "store"
        }));
    }, [
        generatePath,
        router,
        routerPages.ShokufesEventDetail
    ]);
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventHeaderCell, {
                currentUser: state.currentUser,
                loading: state.loading,
                user: state.user,
                event: state.event,
                userCartCount: state.userCartCount,
                followArtists: state.followArtists,
                memberArtists: state.memberArtists,
                isArtist: state.isArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_IntroductionCell, {
                event: state.event,
                onClickMap: function() {
                    onRequestPermission();
                    setOpenMap(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventBannerInfoCell, {
                loading: state.loading,
                user: state.user,
                event: state.event
            }),
            ((ref = state.preSale) === null || ref === void 0 ? void 0 : ref.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                labels: [
                    t("presaleTickets"),
                    t("storeCollection")
                ],
                value: currentTab,
                disableAnimateTransitions: true,
                onChange: handleTabChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PreSalesCell, {
                        loading: state.loading,
                        preSales: state.preSale,
                        hasNextPage: state.hasPresalesNextPage,
                        onFetchMore: onFetchPreSalesMore
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCollectionCell, {
                        hasPreSale: true,
                        loading: state.loading,
                        collections: state.collections,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCollectionCell, {
                hasPreSale: false,
                loading: state.loading,
                collections: state.collections,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapModal, {
                title: (ref8 = (ref1 = state.event) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.location) === null || ref2 === void 0 ? void 0 : ref2.approximateAddress) !== null && ref8 !== void 0 ? ref8 : "",
                open: openMap,
                onClose: function() {
                    return setOpenMap(false);
                },
                targetData: (ref3 = state.event) === null || ref3 === void 0 ? void 0 : ref3.location,
                currentData: (ref4 = state.gpsClientInfo) === null || ref4 === void 0 ? void 0 : ref4.currentLocation,
                isInside: state.isInside,
                hideAnnotation: true
            })
        ]
    });
};
var EventHeaderCell = function(param) {
    var loading = param.loading, event = param.event, user = param.user, userCartCount = param.userCartCount, isArtist = param.isArtist, followArtists = param.followArtists, memberArtists = param.memberArtists, currentUser = param.currentUser;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, router = ref2.router;
    var ref3 = (0,react.useState)(false), openSideMenu = ref3[0], setOpenSideMenu = ref3[1];
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4, ref5;
    var imageUri = (ref5 = (ref4 = event === null || event === void 0 ? void 0 : (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref4 !== void 0 ? ref4 : event === null || event === void 0 ? void 0 : (ref1 = event.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref5 !== void 0 ? ref5 : "";
    if (loading && !event) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                pb: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 212,
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    "& > *": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    color: "transparent",
                    elevation: 0,
                    back: true,
                    sx: {
                        backgroundColor: "transparent"
                    },
                    right: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    borderRadius: "50%",
                                    width: 44,
                                    height: 44,
                                    bgcolor: "grey.50"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    borderRadius: "50%",
                                    width: 44,
                                    height: 44,
                                    bgcolor: "grey.50"
                                }
                            })
                        ]
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                elevation: 0,
                position: "absolute",
                sx: {
                    pt: 0,
                    backgroundColor: "transparent",
                    ".MuiButtonBase-root": {
                        bgcolor: "grey.50",
                        color: "text.secondary",
                        "&:hover": {
                            bgcolor: "grey.100"
                        }
                    }
                },
                back: true,
                defaultBackPage: routerPages.ShokufesEvents,
                right: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Notice, {
                            bgcolor: "grey.50",
                            size: "medium",
                            onClick: handleLoginModal(function() {
                                return router.push(routerPages.Notifications);
                            }),
                            color: "text.secondary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            badgeContent: userCartCount,
                            color: "primary",
                            sx: {
                                "& > span": function(param) {
                                    var typography = param.typography;
                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        top: 8,
                                        minWidth: 16,
                                        width: 16,
                                        height: 16
                                    }, typography.overline), {
                                        color: "white"
                                    });
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Store, {
                                edge: "end",
                                bgcolor: "grey.50",
                                size: "medium",
                                onClick: handleLoginModal(function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cart", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        type: "eventDetail",
                                        isAnonymous: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous
                                    });
                                    router.push(routerPages.StoreCartList);
                                }, true)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, {
                hasSafeArea: true,
                bgImage: imageUri,
                imageUri: imageUri,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                open: openSideMenu,
                onClose: function() {
                    return setOpenSideMenu(false);
                },
                user: user,
                isArtist: isArtist,
                followArtists: followArtists,
                memberArtists: memberArtists
            })
        ]
    });
};
var template_IntroductionCell = function(param) {
    var event = param.event, onClickMap = param.onClickMap;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("eventDetail").t;
    var ref3;
    var ref4 = (0,BrowserLink/* useBrowserLink */.i)((ref3 = event === null || event === void 0 ? void 0 : (ref = event.location) === null || ref === void 0 ? void 0 : ref.mapUri) !== null && ref3 !== void 0 ? ref3 : ""), onClickMapLink = ref4.onClick;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    if (!event) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    mt: 5
                },
                children: event.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        mt: 4,
                        wordBreak: "break-all"
                    },
                    children: event.description
                })
            }),
            event.dateRange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            mt: 4
                        },
                        children: t("startedAt", "開催日")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mt: 1
                        },
                        children: event.dateRange
                    })
                ]
            }),
            !!event.formattedEventTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            mt: 4
                        },
                        children: t("eventTime", "開催時間")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mt: 1
                        },
                        children: event.formattedEventTime
                    })
                ]
            }),
            event.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        sx: {
                            mt: 4
                        },
                        children: t("address", "会場")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 1,
                            cursor: "pointer"
                        },
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                minWidth: 0,
                                onClick: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventMap", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        eventId: event === null || event === void 0 ? void 0 : event.id,
                                        type: "eventDetail"
                                    });
                                    onClickMap();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "primary",
                                        align: "left",
                                        sx: (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                        children: (ref1 = event.location) === null || ref1 === void 0 ? void 0 : ref1.approximateAddress
                                    })
                                ]
                            }),
                            !!((ref2 = event.location) === null || ref2 === void 0 ? void 0 : ref2.mapUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                onClick: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventMapLink", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        eventId: event === null || event === void 0 ? void 0 : event.id,
                                        type: "eventDetail"
                                    });
                                    onClickMapLink();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    display: "inherit",
                                    minWidth: 90,
                                    children: [
                                        "（",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            component: "span",
                                            variant: "subtitle1",
                                            color: "primary",
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: t("venueMap", "会場MAP")
                                        }),
                                        "）"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EventBannerInfoCell = function(param) {
    var loading = param.loading, user = param.user, event = param.event;
    var ref, ref1;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                pb: 5
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 100
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "100%",
                        height: 100
                    })
                ]
            })
        });
    }
    if (!(event === null || event === void 0 ? void 0 : (ref = event.banners) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 5,
            children: event === null || event === void 0 ? void 0 : (ref1 = event.banners) === null || ref1 === void 0 ? void 0 : ref1.map(function(banner, index) {
                var ref, ref1, ref5;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            border: "none"
                        },
                        children: ((ref = banner.link) === null || ref === void 0 ? void 0 : ref.externalUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                            component: "a",
                            target: "_blank",
                            href: (0,lib_url/* replaceParameters */.yB)((ref1 = banner.link) === null || ref1 === void 0 ? void 0 : ref1.externalUrl, {
                                uid: (ref2 = user === null || user === void 0 ? void 0 : user.id) !== null && ref2 !== void 0 ? ref2 : ""
                            }) || "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                component: "img",
                                image: banner.thumbnail.mediumUri || ""
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                            href: (0,lib_url/* replaceParameters */.yB)((ref3 = (ref5 = banner.link) === null || ref5 === void 0 ? void 0 : ref5.innerPath) !== null && ref3 !== void 0 ? ref3 : "", {
                                uid: (ref4 = user === null || user === void 0 ? void 0 : user.id) !== null && ref4 !== void 0 ? ref4 : ""
                            }) || "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                component: "img",
                                height: 140,
                                image: banner.thumbnail.mediumUri || ""
                            })
                        })
                    })
                }, index);
            })
        })
    });
};
var template_PreSalesCell = function(param) {
    var preSales = param.preSales, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("eventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: preSales === null || preSales === void 0 ? void 0 : preSales.edges.map(function(param) {
                var node = param.node;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleCard, {
                    preSale: node
                }, node.id);
            }),
            componentProps: {
                spacing: 5
            },
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            emptyMessage: t("storeCollectionEmpty"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    pt: 2
                },
                children: Array.from(Array(3).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleCardSkeleton, {}, key);
                })
            })
        })
    });
};
var StoreCollectionCell = function(param) {
    var hasPreSale = param.hasPreSale, loading = param.loading, hasNextPage = param.hasNextPage, collections = param.collections, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("eventDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: [
            hasPreSale ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: loading && !(collections === null || collections === void 0 ? void 0 : collections.edges.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "50%"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        py: 2
                    },
                    children: t("storeCollection", "販売中のストア")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: collections === null || collections === void 0 ? void 0 : collections.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCard, {
                        eventCollection: node
                    }, node.id);
                }),
                componentProps: {
                    spacing: 5
                },
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                emptyMessage: t("storeCollectionEmpty"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    sx: {
                        pt: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCardSkeleton, {}, key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/EventDetail/viewModel.ts



function EventDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EventDetail(\n    $id: ID!\n    $eventCollectionPageInput: PageInput\n    $eventPreSalePageInput: PageInput\n    $filter: CollectionStatus\n  ) {\n    event(id: $id) {\n      ...EventDetail\n      eventCollections(pageInput: $eventCollectionPageInput, filter: $filter) {\n        edges {\n          node {\n            ...EventDetailCollectionBox\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      preSales(pageInput: $eventPreSalePageInput) {\n        edges {\n          node {\n            ...EventPreSaleBox\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n    userCartCount\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    EventDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var EventDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref10 = (0,auth/* useCurrentUser */.xJ)(), userClaims = ref10.userClaims, currentUser = ref10.user;
    var ref11 = (0,useQuery/* useQuery */.aM)(EventDetail_viewModel_QUERY, {
        variables: {
            id: router.query.eventId,
            filter: utoniq_core_schema/* CollectionStatus.Published */.NbM.Published
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref11.data, loading = ref11.loading, fetchMore = ref11.fetchMore;
    var ref12 = useLocationWatcher(), permission = ref12.permission, currentLocation = ref12.currentLocation, requestPermission = ref12.requestPermission, watch = ref12.watch, unwatch = ref12.unwatch;
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    var ref13;
    var isInside = useIsInside({
        locations: [
            (ref13 = data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : ref.location) !== null && ref13 !== void 0 ? ref13 : null,
            currentLocation
        ],
        radius: 1000
    }).isInside;
    var ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    return {
        state: {
            currentUser: currentUser,
            user: (ref14 = data === null || data === void 0 ? void 0 : data.user) !== null && ref14 !== void 0 ? ref14 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref1 = userClaims.orgs) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[config_config/* config.organizationId */.v.organizationId]) === null || ref2 === void 0 ? void 0 : ref2.artist),
            followArtists: (ref15 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.organizationFollowees) !== null && ref15 !== void 0 ? ref15 : null,
            memberArtists: (ref16 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationPatrons) !== null && ref16 !== void 0 ? ref16 : null,
            loading: loading,
            event: (ref17 = data === null || data === void 0 ? void 0 : data.event) !== null && ref17 !== void 0 ? ref17 : null,
            tab: router.query.tab === "store" ? 1 : 0,
            collections: (ref18 = data === null || data === void 0 ? void 0 : (ref5 = data.event) === null || ref5 === void 0 ? void 0 : ref5.eventCollections) !== null && ref18 !== void 0 ? ref18 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref6 = data.event) === null || ref6 === void 0 ? void 0 : ref6.eventCollections.pageInfo.hasNextPage),
            hasPresalesNextPage: !!(data === null || data === void 0 ? void 0 : (ref7 = data.event) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.preSales) === null || ref8 === void 0 ? void 0 : ref8.pageInfo.hasNextPage),
            isInside: isInside,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            },
            userCartCount: (ref19 = data === null || data === void 0 ? void 0 : data.userCartCount) !== null && ref19 !== void 0 ? ref19 : 0,
            // 先行販売チケットのデータ
            preSale: (ref20 = data === null || data === void 0 ? void 0 : (ref9 = data.event) === null || ref9 === void 0 ? void 0 : ref9.preSales) !== null && ref20 !== void 0 ? ref20 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.event.eventCollections.pageInfo.hasNextPage)) return [
                                    2
                                ];
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: router.query.eventId,
                                            eventCollectionPageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.event.eventCollections.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchPreSalesMore: function onFetchPreSalesMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : (ref1 = ref.preSales) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage)) return [
                                    2
                                ];
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: router.query.eventId,
                                            eventPreSalePageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref2 = data.event) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.preSales) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRequestPermission: function onRequestPermission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!(data === null || data === void 0 ? void 0 : (ref = data.event) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.latitude)) return [
                            2
                        ];
                        requestPermission().catch(showError);
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var EventDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(EventDetail_viewModel_templateObject(), utoniq_core_schema/* EventDetailFragmentDoc */.GOV, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* EventDetailCollectionBoxFragmentDoc */.v_w, utoniq_core_schema/* EventPreSaleBoxFragmentDoc */.N_p);

;// CONCATENATED MODULE: ./src/components/pages/EventDetail/index.tsx




/**
 * EventDetail Page
 * Implemented as a practical sample.
 */ var EventDetail = function() {
    var ref = EventDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/Events/template/index.tsx











var EventsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var t = (0,core_i18n/* useTranslation */.$G)("events").t;
    var ref11 = (0,react.useState)(false), openSideMenu = ref11[0], setOpenSideMenu = ref11[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* StandAloneThemeProvider */.UI, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    bgcolor: "grey.50",
                    badge: ((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask) || !!((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount) || !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
                })
            },
            navigation: {
                type: config_config/* config.applicationType */.v.applicationType === "standalone" ? "artist" : "global",
                props: {
                    hasManagementTask: !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask),
                    unreadNotificationCount: (ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount,
                    hasSettingTask: !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
                }
            },
            sx: {
                pb: 6
            },
            children: [
                !((ref6 = state.events) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.edges) === null || ref7 === void 0 ? void 0 : ref7.length) && (state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "50%"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    align: "center",
                    sx: {
                        py: 6
                    },
                    color: "text.secondary",
                    children: t("emptyMessage")
                })),
                !state.loading && !!((ref8 = state.events) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.edges) === null || ref9 === void 0 ? void 0 : ref9.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        py: 2
                    },
                    children: t("eventLabel")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref10 = state.events) === null || ref10 === void 0 ? void 0 : ref10.edges.map(function(param) {
                        var node = param.node;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                            event: node
                        }, node.id);
                    }),
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 5,
                        sx: {
                            pt: 2
                        },
                        children: Array.from(Array(3).keys()).map(function(index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCardSkeleton, {}, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    isArtist: state.isArtist
                })
            ]
        })
    });
};
var template_SomethingCell = function() {
    return null;
};

;// CONCATENATED MODULE: ./src/components/pages/Events/viewModel.ts





function Events_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Events(\n    $artistId: ID\n    $filter: EventFilter!\n    $pageInput: PageInput\n    $isStandalone: Boolean!\n  ) {\n    user {\n      ...CurrentUser\n    }\n    artist(id: $artistId) @include(if: $isStandalone) {\n      ...ArtistBottomTab\n      currentLive {\n        id\n      }\n    }\n    events(filter: $filter, pageInput: $pageInput) {\n      edges {\n        node {\n          ... on Event {\n            ...EventList\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Events_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Events_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewEvents(\n    $artistId: ID\n    $filter: EventFilter!\n    $pageInput: PageInput\n    $isStandalone: Boolean!\n  ) {\n    artist(id: $artistId) @include(if: $isStandalone) {\n      ...ArtistBottomTab\n      currentLive {\n        id\n      }\n    }\n    events(filter: $filter, pageInput: $pageInput) {\n      edges {\n        node {\n          ... on Event {\n            ...EventList\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Events_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








/**
 *
 */ var Events_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_EVENT,
        variables: {
            artistId: config_config/* config.artistId */.v.artistId,
            filter: utoniq_core_schema/* EventFilter.All */.DrI.All,
            isStandalone: config_config/* config.applicationType */.v.applicationType === "standalone"
        },
        fields: [
            {
                fieldName: "events",
                fragmentName: "EventList",
                fragment: utoniq_core_schema/* EventListFragmentDoc */.cIn
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref5 = (0,useQuery/* useQuery */.aM)(Events_viewModel_QUERY, {
        variables: {
            artistId: config_config/* config.artistId */.v.artistId,
            filter: utoniq_core_schema/* EventFilter.All */.DrI.All,
            isStandalone: config_config/* config.applicationType */.v.applicationType === "standalone"
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref5.data, loading = ref5.loading, fetchMore = ref5.fetchMore;
    // fixed issue duplicate events on graphql cached
    var events = (0,react.useMemo)(function() {
        if (!(data === null || data === void 0 ? void 0 : data.events)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.events), {
            edges: uniqBy_default()(data.events.edges, "node.id")
        });
    }, [
        data === null || data === void 0 ? void 0 : data.events
    ]);
    var ref6, ref7, ref8;
    return {
        state: {
            user: (ref6 = data === null || data === void 0 ? void 0 : data.user) !== null && ref6 !== void 0 ? ref6 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist),
            followArtists: (ref7 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.organizationFollowees) !== null && ref7 !== void 0 ? ref7 : null,
            memberArtists: (ref8 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.organizationPatrons) !== null && ref8 !== void 0 ? ref8 : null,
            events: events,
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref4 = data.events) === null || ref4 === void 0 ? void 0 : ref4.pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            filter: utoniq_core_schema/* EventFilter.All */.DrI.All,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.events) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var Events_viewModel_QUERY = (0,lib/* gql */.Ps)(Events_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* EventListFragmentDoc */.cIn);
var FETCH_NEW_EVENT = (0,lib/* gql */.Ps)(Events_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* EventListFragmentDoc */.cIn);

;// CONCATENATED MODULE: ./src/components/pages/Events/index.tsx




/**
 * Events Page
 * Implemented as a practical sample.
 */ var Events = function() {
    var ref = Events_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/FavoriteMembersSelect/template/index.tsx










var FavoriteMembersSelectTemplate = function(param) {
    var state = param.state, onConfirm = param.onConfirm, onSelectFavoriteMember = param.onSelectFavoriteMember;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("favoriteMembersSelect").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerNames = ref3.routerNames, routerPages = ref3.routerPages;
    var defaultBackPage = (0,react_router/* generatePath */.Gn)(routerPages.MyProfile);
    var ref4 = (0,react.useState)(false), openChangeFavoriteMemberModal = ref4[0], setOpenChangeFavoriteMemberModal = ref4[1];
    var isInitialSelectedFavoriteMember = (0,react.useMemo)(function() {
        return !!state.initialSelectedFavoriteMember && state.initialSelectedFavoriteMember !== "";
    }, [
        state.initialSelectedFavoriteMember
    ]);
    var ref5, _favoriteMembers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.FavoriteMembersSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: false,
                    defaultBackPage: defaultBackPage,
                    title: t("title", "推し設定")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: 2,
                            bgcolor: "grey.50",
                            m: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                p: 2,
                                "&:last-child": {
                                    pb: 2
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: (ref5 = (ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref5 !== void 0 ? ref5 : "",
                                        sx: {
                                            width: 44,
                                            height: 44,
                                            m: 2
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body1",
                                        sx: {
                                            width: "fit-content"
                                        },
                                        children: (ref2 = state.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                        sx: {
                            m: 5,
                            height: "320px",
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipFavoriteMemberSelect, {
                            favoriteMembers: (_favoriteMembers = state.favoriteMembers) !== null && _favoriteMembers !== void 0 ? _favoriteMembers : [],
                            selectedFavoriteMember: state.selectedFavoriteMember,
                            onSelectFavoriteMember: onSelectFavoriteMember
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                            sx: {
                                mx: 5,
                                mb: 3,
                                p: 2,
                                border: "solid 1px",
                                borderColor: "info.main",
                                width: "50%",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "info.main",
                                children: t("note", "※ 推しは設定から90日間変更できません")
                            })
                        })
                    }),
                    state.nextChangeableDate !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            pt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.primary",
                            children: t("nextChangeableDate", "次回変更可能日 : {{-date}}", {
                                date: state.nextChangeableDate
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            my: 4
                        },
                        alignItems: "center",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                disabled: !!state.nextChangeableDate || !state.isPatron || !state.selectedFavoriteMember,
                                loading: state.initialLoading || state.updatingMember,
                                sx: {
                                    width: 212
                                },
                                onClick: function() {
                                    return setOpenChangeFavoriteMemberModal(true);
                                },
                                children: t("submit", "推しを選択")
                            }),
                            isInitialSelectedFavoriteMember && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                size: "small",
                                sx: {
                                    width: 212
                                },
                                onClick: function() {
                                    return router.push(routerPages.MyProfile);
                                },
                                children: t("back", "戻る")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openChangeFavoriteMemberModal,
                onClose: function() {
                    return setOpenChangeFavoriteMemberModal(false);
                },
                title: t("changeFavoriteMember", "推しを変更しますか？"),
                cancelText: t("changeFavoriteMemberCancel", "閉じる"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 8,
                        px: 2,
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("changeFavoriteMemberDescription", "推しメンバーを変更すると、設定中の推し日も新しい日付に変更されます。前の推し日に戻すことはできません。")
                    })
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    loading: state.updatingMember,
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        setOpenChangeFavoriteMemberModal(false);
                        onConfirm();
                    },
                    children: t("changeFavoriteMemberConfirm", "変更する")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FavoriteMembersSelect/viewModel.ts




function FavoriteMembersSelect_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FavoriteMembersSelectWithPatron($artistId: ID) {\n    artist(id: $artistId) {\n      displayName\n      avatar {\n        uri\n      }\n      ...ArtistMembershipFavoriteMembers\n      ...ArtistPatronFavoriteMember\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    FavoriteMembersSelect_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FavoriteMembersSelect_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateMyFavoriteMember($inputs: UpdateMyFavoriteMemberInput!) {\n    updateMyFavoriteMember(inputs: $inputs) {\n      id\n      name\n      avatar {\n        uri\n      }\n    }\n  }\n"
    ]);
    FavoriteMembersSelect_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var FavoriteMembersSelect_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref6 = (0,react.useState)(), selectedFavoriteMember = ref6[0], setSelectedFavoriteMember = ref6[1];
    var ref7 = (0,react.useState)(""), nextChangeableDate = ref7[0], setNextChangeableDate = ref7[1];
    var ref8 = (0,useQuery/* useQuery */.aM)(FavoriteMembersSelect_viewModel_QUERY, {
        variables: {
            artistId: artistId
        }
    }), data = ref8.data, loading = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(FavoriteMembersSelect_viewModel_MUTATION, {
        variables: {
            inputs: {
                artistId: artistId,
                favoriteMemberId: selectedFavoriteMember !== null && selectedFavoriteMember !== void 0 ? selectedFavoriteMember : ""
            }
        }
    }), 2), updateMyFavoriteMember = ref9[0], ref10 = ref9[1], updatingMember = ref10.loading;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        // 初期表示でQUERYの結果が存在する場合はそれをセットする
        setSelectedFavoriteMember(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.favoriteMember) === null || ref2 === void 0 ? void 0 : ref2.id);
        if (data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.patron) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.favoriteMember) === null || ref5 === void 0 ? void 0 : ref5.createdAt) {
            var ref6, ref7, ref8;
            var nextChangeableDate = dayjs_min_default()(data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.patron) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.favoriteMember) === null || ref8 === void 0 ? void 0 : ref8.createdAt).add(91, "day");
            if (dayjs_min_default()(nextChangeableDate).isAfter(dayjs_min_default()(), "day")) {
                // 初期表示でpatron.favoriteMember.createdAtから91日経過しているかを判定
                // 経過していない場合は91日後の日付をnextChangeableDateとしてセットする
                setNextChangeableDate(dayjs_min_default()(nextChangeableDate).format("YYYY/MM/DD"));
            }
        }
    }, [
        data
    ]);
    return {
        state: {
            artist: data === null || data === void 0 ? void 0 : data.artist,
            artistId: artistId,
            nextChangeableDate: nextChangeableDate,
            selectedFavoriteMember: selectedFavoriteMember,
            initialSelectedFavoriteMember: data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.favoriteMember) === null || ref2 === void 0 ? void 0 : ref2.id,
            isPatron: !!(data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : ref3.patron),
            favoriteMembers: data === null || data === void 0 ? void 0 : (ref4 = data.artist) === null || ref4 === void 0 ? void 0 : ref4.favoriteMembers,
            initialLoading: loading,
            updatingMember: updatingMember
        },
        actions: {
            onConfirm: function onConfirm() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateMyFavoriteMember().then(function() {
                                        router.push(generatePath(routerPages.MyProfile));
                                    }).catch(function(error) {
                                        showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSelectFavoriteMember: function onSelectFavoriteMember(favoriteMemberId) {
                setSelectedFavoriteMember(favoriteMemberId);
            }
        }
    };
});
var FavoriteMembersSelect_viewModel_QUERY = (0,lib/* gql */.Ps)(FavoriteMembersSelect_viewModel_templateObject(), utoniq_core_schema/* ArtistMembershipFavoriteMembersFragmentDoc */.kGH, utoniq_core_schema/* ArtistPatronFavoriteMemberFragmentDoc */.F3F);
var FavoriteMembersSelect_viewModel_MUTATION = (0,lib/* gql */.Ps)(FavoriteMembersSelect_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/FavoriteMembersSelect/index.tsx




/**
 * FavoriteMembersSelect Page
 * Implemented as a practical sample.
 */ var FavoriteMembersSelect = function() {
    var ref = FavoriteMembersSelect_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMembersSelectTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedComplete/template/index.tsx








var FirstComeFirstServedCompleteTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedComplete").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var _paymentDeadline;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: state.loading ? "" : state.isKonbini ? t("titleKonbini") : t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.FirstComeFirstServedComplete
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCell, {
                isKonbini: state.isKonbini,
                paymentDeadline: (_paymentDeadline = state.paymentDeadline) !== null && _paymentDeadline !== void 0 ? _paymentDeadline : "",
                isShowUsageTicketNote: state.isShowUsageTicketNote
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ButtonCell, {
                purchaseOrderId: state.purchaseOrderId,
                pendingPurchaseId: state.pendingPurchaseId,
                isKonbini: state.isKonbini,
                voucherUrl: state.voucherUrl
            })
        ]
    });
};
var ResultCell = function(param) {
    var isKonbini = param.isKonbini, paymentDeadline = param.paymentDeadline, isShowUsageTicketNote = param.isShowUsageTicketNote;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedComplete").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: (0,src_object_spread/* default */.Z)({
            pt: 6
        }, isKonbini ? {
            pb: 5
        } : {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                align: "center",
                sx: isKonbini ? {} : {
                    pb: 1
                },
                children: t(isKonbini ? "completeMessageKonbini" : "completeMessage")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                align: "center",
                sx: isKonbini ? {
                    pt: 1,
                    pb: 6
                } : {
                    pt: 1,
                    pb: 5
                },
                children: t(isKonbini ? "completeDescMessageKonbini" : "completeDescMessage")
            }),
            isKonbini && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    borderColor: "error.main",
                    borderWidth: 1,
                    borderStyle: "solid",
                    py: 2,
                    mb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "error.main",
                    align: "center",
                    children: t("paymentDeadline", {
                        date: paymentDeadline
                    })
                })
            })
        ]
    });
};
var template_ButtonCell = function(param) {
    var purchaseOrderId = param.purchaseOrderId, pendingPurchaseId = param.pendingPurchaseId, voucherUrl = param.voucherUrl, isKonbini = param.isKonbini;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedComplete").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)(voucherUrl !== null && voucherUrl !== void 0 ? voucherUrl : ""), onClickVoucherUrl = ref1.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            sx: {
                py: 5
            },
            children: isKonbini ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "contained",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: onClickVoucherUrl,
                        children: t("proceedPaymentProcedure", "決済手順へすすむ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        size: "large",
                        sx: {
                            width: 244,
                            py: 1,
                            height: "auto"
                        },
                        href: generatePath(routerPages.PaymentStatusDetail, {
                            pendingPurchaseId: pendingPurchaseId
                        }),
                        children: t("paymentStatus", "決済状況を確認する")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "contained",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: function() {
                            return router.replace(generatePath(routerPages.StorePurchaseOrders));
                        },
                        children: t("storePurchaseHistory")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            paddingTop: "0px"
                        },
                        href: routerPages.Top,
                        children: t("topPage")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedComplete/viewModel.ts



function FirstComeFirstServedComplete_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FirstComeFirstServedComplete($userCartTransactionOrderId: ID!) {\n    userCartTransactionOrder(id: $userCartTransactionOrderId) {\n      ...UserCartTransactionOrder\n    }\n  }\n  ",
        "\n"
    ]);
    FirstComeFirstServedComplete_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var FirstComeFirstServedComplete_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var cartTransactionOrderId = router.query.cartTransactionOrderId;
    var ref4 = (0,useQuery/* useQuery */.aM)(FirstComeFirstServedComplete_viewModel_QUERY, {
        skip: !cartTransactionOrderId,
        variables: {
            userCartTransactionOrderId: cartTransactionOrderId !== null && cartTransactionOrderId !== void 0 ? cartTransactionOrderId : "#"
        }
    }), data = ref4.data, loading = ref4.loading;
    var isShowUsageTicketNote = (0,react.useMemo)(function() {
        var ref, ref1;
        return !!(data === null || data === void 0 ? void 0 : (ref = data.userCartTransactionOrder) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return item.item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket;
        }));
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.userCartTransactionOrder) === null || ref === void 0 ? void 0 : ref.items
    ]);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 冪等キーを削除
                        return [
                            4,
                            (0,storage/* removePrefernce */.Tq)("idempotencyKey")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var ref5, _paymentType, ref6, ref7;
    return {
        state: {
            loading: loading,
            isKonbini: !!(data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.isKonbini),
            purchaseOrderId: cartTransactionOrderId !== null && cartTransactionOrderId !== void 0 ? cartTransactionOrderId : "#",
            pendingPurchaseId: (ref5 = (ref1 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref5 !== void 0 ? ref5 : "#",
            isShowUsageTicketNote: isShowUsageTicketNote,
            paymentType: (_paymentType = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.paymentType) !== null && _paymentType !== void 0 ? _paymentType : null,
            voucherUrl: (ref6 = (ref2 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref2 === void 0 ? void 0 : ref2.voucherUrl) !== null && ref6 !== void 0 ? ref6 : null,
            paymentDeadline: (ref7 = (ref3 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref3 === void 0 ? void 0 : ref3.formattedExpiredAt) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {}
    };
});
var FirstComeFirstServedComplete_viewModel_QUERY = (0,lib/* gql */.Ps)(FirstComeFirstServedComplete_viewModel_templateObject(), utoniq_core_schema/* UserCartTransactionOrderFragmentDoc */.ygL);

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedComplete/index.tsx




/**
 * FirstComeFirstServedComplete Page
 * Implemented as a practical sample.
 */ var FirstComeFirstServedComplete = function() {
    var ref = FirstComeFirstServedComplete_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedCompleteTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/functionals/PaymentProgressModal/index.tsx



var PaymentProgressModal = function(param) {
    var open = param.open;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentProgress").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            id: "modal-inner",
            sx: {
                width: 280,
                borderRadius: 3,
                px: 5,
                py: 7,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "grey.100",
                outline: "none",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress_CircularProgress/* default */.Z, {
                            size: 28
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            sx: {
                                pb: 3
                            },
                            children: t("paymentProgressTitle")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t("paymentProgressDesc")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/components/FirstComeFirstServedSubTitleCell.tsx





var FirstComeFirstServedSubTitleCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    var contents = [
        {
            title: t("preSale", "先行販売"),
            content: preSale === null || preSale === void 0 ? void 0 : preSale.title
        },
        {
            title: t("purchasableDate", "購入期間"),
            content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref = preSale.firstComeFirstServed) === null || ref === void 0 ? void 0 : ref.formattedPurchasableStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref1 = preSale.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.formattedPurchasableEndedAt)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("information", "公演情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: contents.map(function(content, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: content.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: content.content
                                    })
                                ]
                            }),
                            index < contents.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/components/FirstComeFirstServedPlansCell.tsx







var FirstComeFirstServedPlansCell = function(param) {
    var choice = param.choice, items = param.items;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("purchaseInfo", "購入情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    pt: 3
                },
                children: choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                    var itemId = param.itemId, skuId = param.skuId;
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemSelectedCell, {
                        item: items === null || items === void 0 ? void 0 : items.find(function(item) {
                            return item.id === itemId;
                        }),
                        skuId: skuId,
                        choiceLength: choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.length,
                        count: (ref1 = choice.purchaseCountChoices[index]) === null || ref1 === void 0 ? void 0 : ref1.count,
                        index: index + 1
                    }, skuId !== null && skuId !== void 0 ? skuId : itemId);
                })
            })
        ]
    });
};
var ItemSelectedCell = function(param) {
    var item = param.item, skuId = param.skuId, count = param.count, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength, index = param.index;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    var skuUnit = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!skuId) return undefined;
        return item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.find(function(s) {
            return s.id === skuId;
        });
    }, [
        skuId,
        item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                variant: "outlined",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    children: t("preference", {
                        index: index
                    })
                }),
                sx: {
                    bgcolor: "white",
                    p: 0,
                    height: 20,
                    ".MuiChip-label": {
                        p: 1
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("selectionTicket", "選択チケット")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: item === null || item === void 0 ? void 0 : item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: skuUnit.unitName
                            }),
                            (item === null || item === void 0 ? void 0 : (ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("ticketDetail", "チケット詳細")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("price", "価格")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("pricePerSheet", {
                            price: numeral_default()((skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) || (item === null || item === void 0 ? void 0 : item.price)).format("0,0")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("quantity", "購入枚数")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: [
                            count,
                            t("sheet")
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/components/PaymentInfoCell.tsx






var PaymentInfoCell_PaymentInfoCell = function(param) {
    var paymentSource = param.paymentSource, paymentMethod = param.paymentMethod;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    switch(paymentMethod){
        case utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            children: t("paymentInfo", "支払い情報")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("creditCardInfo", "クレジットカード情報")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                        width: 40,
                                        height: 32,
                                        src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                        target: "common"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("last4Digit", {
                                            number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            children: t("paymentInfo", "支払い情報")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("convenienceStore", "コンビニ決済")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    display: "block",
                                    mt: 2
                                },
                                children: t("convenienceStoreDesc", "ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。")
                            })
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/components/PaymentCell.tsx






var PaymentCell = function(param) {
    var billingStatements = param.billingStatements, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("totalPaymentAmount", "お支払い総額")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                sx: {
                    pt: 3
                },
                children: billingStatements === null || billingStatements === void 0 ? void 0 : billingStatements.map(function(stmt, index) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("preference", {
                                        index: index + 1
                                    })
                                }),
                                sx: {
                                    bgcolor: "white",
                                    p: 0,
                                    height: 20,
                                    ".MuiChip-label": {
                                        p: 1
                                    }
                                }
                            }),
                            stmt === null || stmt === void 0 ? void 0 : (ref = stmt.statements) === null || ref === void 0 ? void 0 : ref.map(function(param, subIndex) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                    ]
                                }, subIndex);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            "￥",
                                            numeral_default()(stmt.totalPrice).format("0,0")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/components/ButtonCell.tsx




var ButtonCell_ButtonCell = function(param) {
    var onSubmit = param.onSubmit, isSubmitting = param.isSubmitting;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    loading: isSubmitting,
                    sx: {
                        width: 212
                    },
                    onClick: onSubmit,
                    children: t("buy", "購入する")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.FirstComeFirstServedDetail, {
                            preSaleId: router.query.preSaleId
                        }));
                    },
                    children: t("back", "戻る")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/template/index.tsx










var FirstComeFirstServedConfirmationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var _preSaleId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.FirstComeFirstServedDetail, {
                preSaleId: (_preSaleId = router.query.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
            }),
            title: t("title")
        },
        children: [
            state.loading && !state.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlansSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PaymentInfoSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSkeletonCell, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        px: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedTitleCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedSubTitleCell, {
                            preSale: state === null || state === void 0 ? void 0 : state.preSale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedPlansCell, {
                            choice: state.choice,
                            items: state === null || state === void 0 ? void 0 : (ref = state.preSale) === null || ref === void 0 ? void 0 : ref.items
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoCell_PaymentInfoCell, {
                            paymentSource: state.paymentSource,
                            paymentMethod: state.paymentMethod
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCell, {
                            billingStatements: state.billingStatements,
                            choiceLength: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCell_ButtonCell, {
                            onSubmit: onSubmit,
                            isSubmitting: state.submitting
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: state.openRequire3DSecureModal,
                onClose: onCloseRequire3DSecureModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: state.openExpiredCardModal,
                onClose: onCloseExpiredCardModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: state.openPaymentErrorModal,
                onClose: onClosePaymentErrorModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentProgressModal, {
                open: state.submitting
            })
        ]
    });
};
var FirstComeFirstServedTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: t("confirmPurchaseDetail", "購入内容の確認")
        })
    });
};
var TitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h4",
            width: "50%"
        })
    });
};
var SubTitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: Array.from(Array(2).keys()).map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    numberOfLine: 2
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
var PlansSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2",
                width: "10%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 2
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                    ]
                })
            })
        ]
    });
};
var template_PaymentInfoSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "50%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                ]
            })
        ]
    });
};
var PaymentSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ButtonSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            flex: 1,
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 244,
                height: 44,
                sx: {
                    borderRadius: "34px"
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/viewModel.ts





function FirstComeFirstServedConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FirstComeFirstServedConfirmation($id: ID!) {\n    preSale(id: $id) {\n      ...FirstComeFirstServedConfirmation\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    FirstComeFirstServedConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FirstComeFirstServedConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseFirstComeFirstServed(\n    $inputs: PurchaseItemImmediatelyInput!\n  ) {\n    purchaseItemImmediately(inputs: $inputs) {\n      id\n      paymentType\n    }\n  }\n"
    ]);
    FirstComeFirstServedConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













/**
 *
 */ var FirstComeFirstServedConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedConfirmation").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, generatePath = ref2.generatePath, routerPages = ref2.routerPages;
    var ref3 = (0,react.useState)(), choice = ref3[0], setChoice = ref3[1];
    var ref4 = (0,useQuery/* useQuery */.aM)(FirstComeFirstServedConfirmation_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId
        }
    }), data = ref4.data, loading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_FIRST_COME_FIRST_SERVED), 2), purchaseFirstComeFirstServed = ref5[0], ref6 = ref5[1], submitting = ref6.loading;
    var ref7 = (0,react.useState)(false), openExpiredCardModal = ref7[0], setOpenExpiredCardModal = ref7[1];
    var ref8 = (0,react.useState)(false), openPaymentErrorModal = ref8[0], setOpenPaymentErrorModal = ref8[1];
    var ref9 = (0,react.useState)(false), openRequire3DSecureModal = ref9[0], setOpenRequire3DSecureModal = ref9[1];
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                        ];
                    case 1:
                        v = _state.sent();
                        // localStorageにデータがない場合、購入ページを表示
                        if (v.preSaleId !== router.query.preSaleId) {
                            router.replace(generatePath(routerPages.FirstComeFirstServedDetail, {
                                preSaleId: router.query.preSaleId
                            }));
                        }
                        return [
                            4,
                            (0,storage/* getPrefrenceString */.hu)("idempotencyKey")
                        ];
                    case 2:
                        if (!!_state.sent()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,storage/* setPreference */.l$)("idempotencyKey", createUuid())
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        setChoice(v);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        storage/* getPrefrenceObject */._d
    ]);
    var isKonbini = (0,react.useMemo)(function() {
        return (choice === null || choice === void 0 ? void 0 : choice.paymentMethod) === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini;
    }, [
        choice === null || choice === void 0 ? void 0 : choice.paymentMethod
    ]);
    var billingStatements = (0,react.useMemo)(function() {
        var ref;
        // 代金や手数料など、支払のすべてをブレイクダウンした配列
        return choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
            var itemId = param.itemId, skuId = param.skuId;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
            var item = data === null || data === void 0 ? void 0 : (ref = data.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(i) {
                return (i === null || i === void 0 ? void 0 : i.id) === itemId;
            });
            var ref16;
            var itemPrice = skuId ? (ref16 = (ref4 = item === null || item === void 0 ? void 0 : (ref2 = item.skuSettings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.units) === null || ref3 === void 0 ? void 0 : ref3.find(function(s) {
                return (s === null || s === void 0 ? void 0 : s.id) === skuId;
            })) === null || ref4 === void 0 ? void 0 : ref4.price) !== null && ref16 !== void 0 ? ref16 : item === null || item === void 0 ? void 0 : item.price : item === null || item === void 0 ? void 0 : item.price;
            var ref17;
            var purchaseCount = (ref17 = choice === null || choice === void 0 ? void 0 : (ref5 = choice.purchaseCountChoices) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[index]) === null || ref6 === void 0 ? void 0 : ref6.count) !== null && ref17 !== void 0 ? ref17 : 0;
            // 代金や手数料など、支払のすべてをブレイクダウンした配列
            var statements = [
                {
                    label: t("totalPrice"),
                    value: "￥".concat(numeral_default()((itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0) * purchaseCount).format("0,0"))
                }, 
            ].concat((0,src_to_consumable_array/* default */.Z)(((item === null || item === void 0 ? void 0 : (ref7 = item.fees) === null || ref7 === void 0 ? void 0 : ref7.collections) || []).map(function(fee) {
                var ref;
                var feeValue = (ref = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref !== void 0 ? ref : 0;
                return {
                    label: fee === null || fee === void 0 ? void 0 : fee.feeName,
                    value: (fee === null || fee === void 0 ? void 0 : fee.per) === "order" ? "￥".concat(numeral_default()(feeValue).format("0,0")) : "￥".concat(numeral_default()(feeValue * purchaseCount).format("0,0"))
                };
            })), (0,src_to_consumable_array/* default */.Z)(isKonbini ? [
                {
                    label: item === null || item === void 0 ? void 0 : (ref8 = item.fees) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.konbini) === null || ref9 === void 0 ? void 0 : ref9.feeName,
                    value: "￥".concat(numeral_default()(item === null || item === void 0 ? void 0 : (ref10 = item.fees) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.konbini) === null || ref11 === void 0 ? void 0 : ref11.fee).format("0,0"))
                }, 
            ] : []));
            var ref18, ref19;
            var totalFee = item === null || item === void 0 ? void 0 : (ref12 = item.fees) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.collections) === null || ref13 === void 0 ? void 0 : ref13.reduce(function(acc, fee) {
                return acc + ((fee === null || fee === void 0 ? void 0 : fee.per) === "order" ? (ref18 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref18 !== void 0 ? ref18 : 0 : ((ref19 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref19 !== void 0 ? ref19 : 0) * purchaseCount);
            }, 0);
            var ref20;
            return {
                statements: statements,
                totalPrice: (itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0) * purchaseCount + (totalFee !== null && totalFee !== void 0 ? totalFee : 0) + (isKonbini ? (ref20 = item === null || item === void 0 ? void 0 : (ref14 = item.fees) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.konbini) === null || ref15 === void 0 ? void 0 : ref15.fee) !== null && ref20 !== void 0 ? ref20 : 0 : 0)
            };
        });
    }, [
        choice === null || choice === void 0 ? void 0 : choice.choices,
        choice === null || choice === void 0 ? void 0 : choice.purchaseCountChoices,
        data === null || data === void 0 ? void 0 : (ref = data.preSale) === null || ref === void 0 ? void 0 : ref.items,
        isKonbini,
        t, 
    ]);
    var item = (0,react.useMemo)(function() {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data.preSale) === null || ref === void 0 ? void 0 : ref.items.find(function(item) {
            return item.id === (choice === null || choice === void 0 ? void 0 : choice.choices[0].itemId);
        });
    }, [
        choice === null || choice === void 0 ? void 0 : choice.choices,
        data === null || data === void 0 ? void 0 : (ref1 = data.preSale) === null || ref1 === void 0 ? void 0 : ref1.items
    ]);
    var ref10;
    return {
        state: {
            loading: loading,
            preSale: data === null || data === void 0 ? void 0 : data.preSale,
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            paymentMethod: (ref10 = choice === null || choice === void 0 ? void 0 : choice.paymentMethod) !== null && ref10 !== void 0 ? ref10 : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
            billingStatements: billingStatements,
            choice: choice,
            submitting: submitting,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal
        },
        actions: {
            onSubmit: function onSubmit() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, idempotencyKey, _totalPrice, _totalPrice1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!choice) return [
                                    2
                                ];
                                return [
                                    4,
                                    (0,storage/* getPrefrenceString */.hu)("idempotencyKey")
                                ];
                            case 1:
                                idempotencyKey = _state.sent();
                                if (!idempotencyKey) {
                                    // 冪等キーがなければエラーを表示する
                                    showError(t("error.idempotencyKeyNotFound"));
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("begin_checkout", {
                                        item_list_id: "preSale_list_".concat(router.query.preSaleId),
                                        item_list_name: "PreSale Items",
                                        type: isKonbini ? "convenience_store" : "credit_card",
                                        value: (_totalPrice = billingStatements === null || billingStatements === void 0 ? void 0 : billingStatements[0].totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : 0,
                                        items: [
                                            {
                                                item_id: item === null || item === void 0 ? void 0 : item.id,
                                                item_name: item === null || item === void 0 ? void 0 : item.title,
                                                item_category: ConversionCategories.preSaleItem,
                                                item_category2: item === null || item === void 0 ? void 0 : item.type,
                                                item_category3: native_app/* getPlatform */.Xf(),
                                                item_category4: choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.skuId,
                                                item_category5: router.query.preSaleId,
                                                price: item === null || item === void 0 ? void 0 : item.price,
                                                quantity: choice === null || choice === void 0 ? void 0 : choice.purchaseCountChoices[0].count
                                            }
                                        ]
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    purchaseFirstComeFirstServed({
                                        variables: {
                                            inputs: {
                                                itemId: choice === null || choice === void 0 ? void 0 : choice.choices[0].itemId,
                                                skuId: choice === null || choice === void 0 ? void 0 : choice.choices[0].skuId,
                                                count: choice === null || choice === void 0 ? void 0 : choice.purchaseCountChoices[0].count,
                                                price: (_totalPrice1 = billingStatements === null || billingStatements === void 0 ? void 0 : billingStatements[0].totalPrice) !== null && _totalPrice1 !== void 0 ? _totalPrice1 : 0,
                                                preSaleId: router.query.preSaleId,
                                                isKonbini: isKonbini,
                                                fullName: isKonbini ? choice === null || choice === void 0 ? void 0 : choice.fullName : undefined
                                            }
                                        },
                                        context: {
                                            headers: {
                                                "x-utoniq-idempotency-key": idempotencyKey
                                            }
                                        }
                                    }).then(function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                                            var data, _totalPrice, ref, ref1, ref2, _id;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = param.data;
                                                        return [
                                                            4,
                                                            (0,storage/* removePrefernce */.Tq)("preSaleLotteryApplicationInput")
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            4,
                                                            analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                                                                transaction_id: generateTransactionId(user === null || user === void 0 ? void 0 : user.uid),
                                                                currency: "JPY",
                                                                type: isKonbini ? "convenience_store" : "credit_card",
                                                                value: (_totalPrice = billingStatements === null || billingStatements === void 0 ? void 0 : billingStatements[0].totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : 0,
                                                                items: [
                                                                    {
                                                                        item_id: (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "",
                                                                        item_name: (ref1 = item === null || item === void 0 ? void 0 : item.title) !== null && ref1 !== void 0 ? ref1 : "",
                                                                        item_category: ConversionCategories.preSaleItem,
                                                                        item_category2: item === null || item === void 0 ? void 0 : item.type,
                                                                        item_category3: native_app/* getPlatform */.Xf(),
                                                                        item_category4: "FirstComeFirstServedConfirmation",
                                                                        item_category5: router.query.preSaleId,
                                                                        price: (ref2 = item === null || item === void 0 ? void 0 : item.price) !== null && ref2 !== void 0 ? ref2 : 0,
                                                                        quantity: choice === null || choice === void 0 ? void 0 : choice.purchaseCountChoices[0].count
                                                                    }
                                                                ]
                                                            })
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        router.replace(generatePath(routerPages.FirstComeFirstServedComplete, {
                                                            cartTransactionOrderId: (_id = data === null || data === void 0 ? void 0 : data.purchaseItemImmediately.id) !== null && _id !== void 0 ? _id : "#",
                                                            preSaleId: router.query.preSaleId
                                                        }));
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(_) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()).catch(function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(e) {
                                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, _, ref9;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("error_preSaleCheckout", {
                                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                                            preSaleId: router.query.preSaleId,
                                                            error: e === null || e === void 0 ? void 0 : e.name,
                                                            errorCode: e === null || e === void 0 ? void 0 : (ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode
                                                        });
                                                        _ = (ref3 = e.graphQLErrors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.extensions) === null || ref5 === void 0 ? void 0 : ref5.errorCode;
                                                        switch(_){
                                                            case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                                                return [
                                                                    3,
                                                                    1
                                                                ];
                                                            case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                                                return [
                                                                    3,
                                                                    3
                                                                ];
                                                            case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                                                return [
                                                                    3,
                                                                    5
                                                                ];
                                                        }
                                                        return [
                                                            3,
                                                            7
                                                        ];
                                                    case 1:
                                                        setOpenRequire3DSecureModal(true);
                                                        // リトライのために冪等キーを更新
                                                        return [
                                                            4,
                                                            (0,storage/* setPreference */.l$)("idempotencyKey", createUuid())
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                    case 3:
                                                        setOpenExpiredCardModal(true);
                                                        // リトライのために冪等キーを更新
                                                        return [
                                                            4,
                                                            (0,storage/* setPreference */.l$)("idempotencyKey", createUuid())
                                                        ];
                                                    case 4:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        setOpenPaymentErrorModal(true);
                                                        // リトライのために冪等キーを更新
                                                        return [
                                                            4,
                                                            (0,storage/* setPreference */.l$)("idempotencyKey", createUuid())
                                                        ];
                                                    case 6:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                    case 7:
                                                        // 指定枚数分連番の座席がない場合、その旨のエラーを表示
                                                        showError((ref9 = (ref7 = e === null || e === void 0 ? void 0 : (ref6 = e.graphQLErrors) === null || ref6 === void 0 ? void 0 : ref6.flatMap(function(param) {
                                                            var extensions = param.extensions;
                                                            var ref, ref1;
                                                            return extensions === null || extensions === void 0 ? void 0 : (ref = extensions.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.map(function(error) {
                                                                return error === null || error === void 0 ? void 0 : error.metadata;
                                                            });
                                                        })) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.userMessage) !== null && ref9 !== void 0 ? ref9 : e);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(e) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
});
var FirstComeFirstServedConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(FirstComeFirstServedConfirmation_viewModel_templateObject(), utoniq_core_schema/* FirstComeFirstServedConfirmationFragmentDoc */.Q5M, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var PURCHASE_FIRST_COME_FIRST_SERVED = (0,lib/* gql */.Ps)(FirstComeFirstServedConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedConfirmation/index.tsx




/**
 * FirstComeFirstServedConfirmation Page
 * Implemented as a practical sample.
 */ var FirstComeFirstServedConfirmation = function() {
    var ref = FirstComeFirstServedConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/FirstComeFirstServedContentCell.tsx






var FirstComeFirstServedContentCell = function(param) {
    var preSale = param.preSale;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        sx: {
                            flex: 1,
                            minWidth: "fit-content"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("firstComeFirstServed", "先着")
                                }),
                                sx: {
                                    bgcolor: "background.default",
                                    p: 0,
                                    height: 20,
                                    ".MuiChip-label": {
                                        p: 1
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedContentCell_PreSaleStatusTag, {
                                status: preSale === null || preSale === void 0 ? void 0 : preSale.preSaleStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        width: "100%",
                        variant: "subtitle1",
                        children: preSale === null || preSale === void 0 ? void 0 : preSale.event.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: preSale === null || preSale === void 0 ? void 0 : preSale.description
            })
        ]
    });
};
var FirstComeFirstServedContentCell_PreSaleStatusTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var bgcolor = (0,react.useMemo)(function() {
        switch(status){
            case utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting:
                return "primary.main";
            case utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption:
                return "secondary.main";
            case utoniq_core_schema/* PreSaleStatus.SoldOut */.fu$.SoldOut:
                return "error.main";
            default:
                return "grey.300";
        }
    }, [
        status
    ]);
    if (!status) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "overline",
            color: "white",
            children: t(status)
        }),
        sx: {
            p: 0,
            bgcolor: bgcolor,
            height: 20,
            ".MuiChip-label": {
                p: 1
            }
        }
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/QuantitySelectModal.tsx









var QuantitySelectModal_schema = function(o) {
    return {
        choiceId: o.string().required(),
        choiceSkuId: o.string().optional().allow(null),
        purchaseCountChoice: o.number().required()
    };
};
var QuantitySelectModal = function(param) {
    var item = param.item, skuId = param.skuId, maxChoice = param.maxChoice, maxSelectItem = param.maxSelectItem, selectedIndex = param.selectedIndex, onGoBack = param.onGoBack, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: QuantitySelectModal_schema,
        defaultValues: {
            purchaseCountChoice: 1,
            choiceId: item === null || item === void 0 ? void 0 : item.id,
            choiceSkuId: skuId
        }
    }), handleSubmit = ref.handleSubmit, setValue = ref.setValue, watch = ref.watch;
    // SKUの指定があればSKUの情報を取得
    var skuUnit = (0,react.useMemo)(function() {
        var ref;
        return skuId ? item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units.find(function(sku) {
            return sku.id === skuId;
        }) : null;
    }, [
        skuId,
        item === null || item === void 0 ? void 0 : item.skuSettings
    ]);
    // SKUの価格があればその価格、なければアイテムの価格を取得
    var formattedPrice = (0,react.useMemo)(function() {
        return (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) ? skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.formattedPrice : item === null || item === void 0 ? void 0 : item.formattedPrice;
    }, [
        skuUnit,
        item === null || item === void 0 ? void 0 : item.formattedPrice
    ]);
    var quantity = (0,react.useMemo)(function() {
        if (!(item === null || item === void 0 ? void 0 : item.issuedNumber)) {
            return maxSelectItem;
        }
        if (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.stock) {
            var _pendingPurchaseNumber, _purchasedNumber;
            var itemMaxSelectItem = skuUnit.stock - ((_pendingPurchaseNumber = skuUnit.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0) - ((_purchasedNumber = skuUnit.purchasedNumber) !== null && _purchasedNumber !== void 0 ? _purchasedNumber : 0);
            return itemMaxSelectItem > maxSelectItem ? maxSelectItem : itemMaxSelectItem;
        }
        var _pendingPurchaseNumber1, _purchasedNumber1;
        var itemMaxSelectItem1 = item.issuedNumber - ((_pendingPurchaseNumber1 = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber1 !== void 0 ? _pendingPurchaseNumber1 : 0) - ((_purchasedNumber1 = item.purchasedNumber) !== null && _purchasedNumber1 !== void 0 ? _purchasedNumber1 : 0);
        return itemMaxSelectItem1 > maxSelectItem ? maxSelectItem : itemMaxSelectItem1;
    }, [
        item === null || item === void 0 ? void 0 : item.issuedNumber,
        item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber,
        item === null || item === void 0 ? void 0 : item.purchasedNumber,
        maxSelectItem,
        skuUnit, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: (0,src_object_spread/* default */.Z)({
                    py: 4,
                    px: 3,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "small",
                        onClick: onGoBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: maxChoice > 1 ? t("selectQuantityTitle", {
                            number: selectedIndex + 1
                        }) : t("selectNumberSheets", "枚数選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: 30
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1
                },
                children: t("performanceInformation", "公演情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5,
                    pt: 2
                },
                children: item === null || item === void 0 ? void 0 : item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5
                },
                children: skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1,
                    mt: 3
                },
                children: t("selectNumberSheets", "枚数選択")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("selectQuantityNote", {
                            max: quantity
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        sx: {
                            pb: 7
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                variant: "h2",
                                children: [
                                    "\xa5",
                                    formattedPrice
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                        listItems: (0,src_to_consumable_array/* default */.Z)(Array(quantity).keys()).map(function(index) {
                                            return {
                                                value: (index + 1).toString(),
                                                label: (index + 1).toString()
                                            };
                                        }),
                                        value: "".concat(watch("purchaseCountChoice")),
                                        onChange: function(value) {
                                            return setValue("purchaseCountChoice", +value);
                                        },
                                        formControlProps: {
                                            sx: {
                                                minWidth: 100,
                                                bgcolor: "grey.50",
                                                minHeight: "auto"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("sheet", "枚")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "center",
                        sx: {
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            onClick: handleSubmit(onSubmit),
                            children: t("addNext", "次へ")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/SkuUnitSelectModal.tsx










var SkuUnitSelectModal = function(param) {
    var isBeforeReceiption = param.isBeforeReceiption, item = param.item, onClose = param.onClose, onGoBack = param.onGoBack, onSelectItem = param.onSelectItem;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var skuUnits = item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 4,
                    px: 3
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "small",
                        onClick: onGoBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: t("selectTicketTitle", "チケットを選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        size: "small",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1
                },
                children: t("performanceInformation", "公演情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5,
                    py: 2
                },
                children: item === null || item === void 0 ? void 0 : item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1,
                    mt: 3
                },
                children: t("typeSelection", "種類選択")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 2,
                sx: (0,src_object_spread/* default */.Z)({
                    p: 5,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: skuUnits === null || skuUnits === void 0 ? void 0 : skuUnits.map(function(itemSku) {
                    var ref, ref1, ref2;
                    var purchaseAvailableNumber = ((ref = itemSku === null || itemSku === void 0 ? void 0 : itemSku.stock) !== null && ref !== void 0 ? ref : 0) - (((ref1 = itemSku === null || itemSku === void 0 ? void 0 : itemSku.purchasedNumber) !== null && ref1 !== void 0 ? ref1 : 0) + ((ref2 = itemSku === null || itemSku === void 0 ? void 0 : itemSku.pendingPurchaseNumber) !== null && ref2 !== void 0 ? ref2 : 0));
                    var isSoldOut = checkSoldOut(itemSku);
                    var resaleAvailable = checkResaleAvailable(item);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                            elevation: 0,
                            sx: {
                                position: "relative",
                                borderRadius: 2,
                                bgcolor: "grey.50"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                    disabled: isSoldOut || isBeforeReceiption,
                                    onClick: function() {
                                        return onSelectItem(itemSku.id);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                                        sx: {
                                            px: 5,
                                            py: 2,
                                            "&:last-child": {
                                                pb: 4
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: isSoldOut || isBeforeReceiption ? "text.disabled" : "text.primary",
                                                        children: itemSku === null || itemSku === void 0 ? void 0 : itemSku.unitName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuUnitStatusCell, {
                                                        amount: purchaseAvailableNumber
                                                    })
                                                ]
                                            }),
                                            isSoldOut && resaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Box_Box/* default */.Z, {
                                                sx: {
                                                    width: "100%",
                                                    height: "20px"
                                                }
                                            })
                                        ]
                                    })
                                }),
                                isSoldOut && resaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    justifyContent: "flex-end",
                                    alignItems: "end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        onClick: function() {
                                            var ref;
                                            router.push({
                                                pathname: generatePath(routerPages.ResaleApplicationDetail, {
                                                    itemId: (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "#"
                                                }),
                                                search: "".concat((itemSku === null || itemSku === void 0 ? void 0 : itemSku.id) ? "?skuId=".concat(encodeSkuId(itemSku.id)) : "")
                                            });
                                        },
                                        sx: {
                                            p: 0,
                                            position: "absolute",
                                            right: "20px",
                                            bottom: "8px",
                                            zIndex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                color: "primary.main",
                                                children: t("toResale", "リセール情報に移動する")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                                color: "primary",
                                                fontSize: "xSmall",
                                                sx: {
                                                    ml: 2
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                })
            })
        ]
    });
};
var SkuUnitStatusCell = function(param) {
    var amount = param.amount;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    if (amount >= 10) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle1",
            color: "text.secondary",
            children: t("onSale")
        });
    }
    if (amount >= 1 && amount < 10) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle1",
            color: "text.secondary",
            children: t("fewLeft")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        variant: "subtitle1",
        color: "error.main",
        children: t("soldOutLabel")
    });
};
var checkSoldOut = function(itemSku) {
    var ref, ref1;
    return (itemSku === null || itemSku === void 0 ? void 0 : itemSku.stock) !== null ? (itemSku === null || itemSku === void 0 ? void 0 : itemSku.stock) === ((ref = itemSku === null || itemSku === void 0 ? void 0 : itemSku.purchasedNumber) !== null && ref !== void 0 ? ref : 0) + ((ref1 = itemSku === null || itemSku === void 0 ? void 0 : itemSku.pendingPurchaseNumber) !== null && ref1 !== void 0 ? ref1 : 0) : false;
};
var checkResaleAvailable = function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (item === null || item === void 0 ? void 0 : item.resaleEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.endedAt) > values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds() && (item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.startedAt) < values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds();
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/TicketSelectModal.tsx










var TicketSelectModal = function(param) {
    var isBeforeReceiption = param.isBeforeReceiption, items = param.items, onClose = param.onClose, onSelectItem = param.onSelectItem;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var itemSkus = (0,react.useMemo)(function() {
        return items.map(function(item) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5;
            return {
                id: item.id,
                title: item.title,
                skuUnitIds: (ref5 = (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.map(function(unit) {
                    return unit.id;
                })) !== null && ref5 !== void 0 ? ref5 : [],
                skuUnits: (ref2 = item.skuSettings) === null || ref2 === void 0 ? void 0 : ref2.units,
                item: item,
                formattedPrice: item.formattedPrice,
                isThroughTicket: (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.isThroughTicket
            };
        }).flat();
    }, [
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 4,
                    px: 3
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: t("selectTicketTitle", "チケットを選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        size: "small",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 2,
                sx: (0,src_object_spread/* default */.Z)({
                    p: 5,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    isBeforeReceiption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "caption",
                        children: t("beforeReceiptionNote", "購入期間前のためチケットは選択できません。")
                    }),
                    itemSkus === null || itemSkus === void 0 ? void 0 : itemSkus.map(function(itemSku) {
                        var item = itemSku === null || itemSku === void 0 ? void 0 : itemSku.item;
                        var ref, ref1, ref2;
                        var purchaseAvailableNumber = ((ref = item === null || item === void 0 ? void 0 : item.issuedNumber) !== null && ref !== void 0 ? ref : 0) - (((ref1 = item === null || item === void 0 ? void 0 : item.purchasedNumber) !== null && ref1 !== void 0 ? ref1 : 0) + ((ref2 = item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber) !== null && ref2 !== void 0 ? ref2 : 0));
                        var haveItemSku = !!itemSku.skuUnitIds.length;
                        var ref3, ref4;
                        var isSoldOut = (item === null || item === void 0 ? void 0 : item.issuedNumber) !== null ? (item === null || item === void 0 ? void 0 : item.issuedNumber) === ((ref3 = item === null || item === void 0 ? void 0 : item.purchasedNumber) !== null && ref3 !== void 0 ? ref3 : 0) + ((ref4 = item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber) !== null && ref4 !== void 0 ? ref4 : 0) : false;
                        var isHaveOneOfSkuSoldOut = checkHaveSoldOut(item, haveItemSku);
                        var resaleAvailable = TicketSelectModal_checkResaleAvailable(item);
                        var disabledCard = (resaleAvailable ? isSoldOut && !haveItemSku : isSoldOut) || isBeforeReceiption;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                                elevation: 0,
                                sx: {
                                    borderRadius: 2,
                                    bgcolor: disabledCard ? "grey.100" : "grey.50"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                        disabled: disabledCard,
                                        onClick: function() {
                                            return onSelectItem(items.find(function(item) {
                                                return item.id === (itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                                            }));
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                                            sx: {
                                                px: 20,
                                                py: 4,
                                                "&:last-child": {
                                                    pb: 4
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: disabledCard ? "text.disabled" : "text.primary",
                                                    children: itemSku === null || itemSku === void 0 ? void 0 : itemSku.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    spacing: 1,
                                                    children: (itemSku === null || itemSku === void 0 ? void 0 : itemSku.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {
                                                        disabled: isSoldOut && !resaleAvailable || isBeforeReceiption
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    sx: {
                                                        pt: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            color: disabledCard ? "text.disabled" : "text.primary",
                                                            children: [
                                                                "\xa5",
                                                                itemSku === null || itemSku === void 0 ? void 0 : itemSku.formattedPrice
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelectModal_TicketStatusCell, {
                                                            amount: purchaseAvailableNumber,
                                                            isInfinite: item.issuedNumber === null
                                                        })
                                                    ]
                                                }),
                                                isHaveOneOfSkuSoldOut && resaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    justifyContent: "flex-end",
                                                    alignItems: "end",
                                                    pt: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        color: "primary.main",
                                                        children: t("resaleAvailable")
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    isSoldOut && resaleAvailable && !haveItemSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        justifyContent: "flex-end",
                                        alignItems: "end",
                                        sx: {
                                            mt: 3
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                            variant: "text",
                                            onClick: function() {
                                                var ref;
                                                router.push({
                                                    pathname: generatePath(routerPages.ResaleApplicationDetail, {
                                                        itemId: (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "#"
                                                    })
                                                });
                                            },
                                            sx: {
                                                p: 0,
                                                position: "absolute",
                                                right: "20px",
                                                bottom: "8px",
                                                zIndex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    color: "primary.main",
                                                    children: t("toResale", "リセール情報に移動する")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                                    color: "primary",
                                                    fontSize: "xSmall",
                                                    sx: {
                                                        ml: 2
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                    })
                ]
            })
        ]
    });
};
var TicketSelectModal_TicketStatusCell = function(param) {
    var amount = param.amount, isInfinite = param.isInfinite;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    if (isInfinite || amount >= 10) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle1",
            color: "text.secondary",
            children: t("onSale")
        });
    }
    if (amount >= 1 && amount < 10) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle1",
            color: "text.secondary",
            children: t("fewLeft")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        variant: "subtitle1",
        color: "error.main",
        children: t("soldOutLabel")
    });
};
var checkHaveSoldOut = function(item, haveItemSku) {
    var ref, ref1;
    if (!haveItemSku) return false;
    var ref2, ref3;
    return item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.some(function(skuUnit) {
        return (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.stock) !== null ? (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.stock) === ((ref2 = skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.purchasedNumber) !== null && ref2 !== void 0 ? ref2 : 0) + ((ref3 = skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.pendingPurchaseNumber) !== null && ref3 !== void 0 ? ref3 : 0) : false;
    });
};
var TicketSelectModal_checkResaleAvailable = function(item) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (item === null || item === void 0 ? void 0 : item.resaleEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.endedAt) > values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds() && (item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.startedAt) < values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds();
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/TicketListCell.tsx
















var MAX_ADD_ITEM = 3;
var MAX_SELECT_ITEM = 8;
var TicketListCell = function(param) {
    var preSaleId = param.preSaleId, items = param.items, preSaleStatus = param.preSaleStatus, _maxChoice = param.maxChoice, maxChoice = _maxChoice === void 0 ? MAX_ADD_ITEM : _maxChoice, _maxSelectItem = param.maxSelectItem, maxSelectItem = _maxSelectItem === void 0 ? MAX_SELECT_ITEM : _maxSelectItem, control = param.control, isBeforeReceiption = param.isBeforeReceiption, isAccessible = param.isAccessible, toggleMembershipModalOpen = param.toggleMembershipModalOpen;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(0), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var ref2 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "choices"
    }), choiceFields = ref2.fields, updateChoice = ref2.update;
    var ref3 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "purchaseCountChoices"
    }), purchaseCountChoiceFields = ref3.fields, updatePurchaseCountChoice = ref3.update;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("selectTicketDetails", "申込内容の選択")
            }),
            maxChoice > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    component: "p",
                    variant: "caption",
                    children: t("selectTicketDesc", {
                        max: maxChoice
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                height: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: choiceFields.map(function(param, index) {
                    var id = param.id, itemId = param.itemId, skuId = param.skuId;
                    var ref, ref1, ref2, ref3;
                    var item = items === null || items === void 0 ? void 0 : items.find(function(param) {
                        var id = param.id;
                        return id === itemId;
                    });
                    var skuUnit = skuId ? item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units.find(function(sku) {
                        return sku.id === skuId;
                    }) : null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                sx: {
                                    p: 4,
                                    borderRadius: 2,
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    pointerEvents: item ? "none" : "unset"
                                },
                                onClick: function() {
                                    // メンバーシップ限定の先着でユーザーが対象外の場合、モーダルを表示
                                    if (!isAccessible) {
                                        toggleMembershipModalOpen();
                                        return;
                                    }
                                    setSelectedIndex(index);
                                    setOpen(true);
                                },
                                children: [
                                    maxChoice > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        lineHeight: "30px",
                                        children: t("preference", {
                                            number: index + 1
                                        })
                                    }),
                                    item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            mr: 7
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                align: "left",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    !!(skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        align: "left",
                                                        children: skuUnit.unitName
                                                    }),
                                                    ((ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 2,
                                                sx: {
                                                    pt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: [
                                                            "\xa5",
                                                            (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) || item.formattedPrice,
                                                            "/"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: [
                                                            (ref3 = purchaseCountChoiceFields[index]) === null || ref3 === void 0 ? void 0 : ref3.count,
                                                            t("sheet", "枚")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        sx: {
                                            py: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "button",
                                                color: "primary",
                                                children: t("selectTicket", "チケットを選択する")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                                                color: "primary"
                                            })
                                        ]
                                    })
                                ]
                            }, id),
                            item && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                size: "small",
                                bgcolor: "grey.50",
                                sx: {
                                    position: "absolute",
                                    zIndex: 2,
                                    right: 16,
                                    top: 16
                                },
                                onClick: function() {
                                    updateChoice(index, {
                                        itemId: ""
                                    });
                                    updatePurchaseCountChoice(index, {
                                        count: 1
                                    });
                                }
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketBottomSheet, {
                preSaleId: preSaleId,
                isBeforeReceiption: isBeforeReceiption,
                items: items,
                selectedIndex: selectedIndex,
                selectedItems: choiceFields,
                preSaleStatus: preSaleStatus,
                open: open,
                maxChoice: maxChoice,
                maxSelectItem: maxSelectItem,
                onClose: function() {
                    return setOpen(false);
                },
                onSubmit: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                        var choiceId, choiceSkuId, purchaseCountChoice;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            choiceId = param.choiceId, choiceSkuId = param.choiceSkuId, purchaseCountChoice = param.purchaseCountChoice;
                            updateChoice(selectedIndex, {
                                itemId: choiceId,
                                skuId: choiceSkuId
                            });
                            updatePurchaseCountChoice(selectedIndex, {
                                count: purchaseCountChoice
                            });
                            return [
                                2
                            ];
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        ]
    });
};
var TicketBottomSheet = function(param) {
    var preSaleId = param.preSaleId, isBeforeReceiption = param.isBeforeReceiption, items = param.items, selectedItems = param.selectedItems, open = param.open, maxChoice = param.maxChoice, preSaleStatus = param.preSaleStatus, selectedIndex = param.selectedIndex, maxSelectItem = param.maxSelectItem, onClose = param.onClose, onSubmit = param.onSubmit;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref = (0,react.useState)(0), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(null), item = ref1[0], setItem = ref1[1];
    var handleOnClose = function() {
        onClose();
        setStep(0);
        setItem(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: handleOnClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            height: "75dvh",
            sx: {
                bgcolor: "background.default"
            },
            children: [
                step === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelectModal, {
                        items: items,
                        preSaleStatus: preSaleStatus,
                        selectedItems: selectedItems,
                        onClose: onClose,
                        onSelectItem: function(item) {
                            var ref, ref1;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
                                item_list_id: "preSale_list_".concat(preSaleId),
                                item_list_name: "PreSale Items",
                                items: [
                                    {
                                        item_id: item === null || item === void 0 ? void 0 : item.id,
                                        item_name: item === null || item === void 0 ? void 0 : item.title,
                                        item_category: ConversionCategories.preSaleItem,
                                        item_category2: item === null || item === void 0 ? void 0 : item.type,
                                        item_category3: native_app/* getPlatform */.Xf(),
                                        item_category4: "FirstComeFirstServedDetail",
                                        item_category5: preSaleId,
                                        price: item === null || item === void 0 ? void 0 : item.price
                                    }, 
                                ]
                            });
                            setItem({
                                item: item,
                                selectSkuId: undefined
                            });
                            if (item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                return setStep(1);
                            }
                            setStep(2);
                        },
                        isBeforeReceiption: isBeforeReceiption
                    })
                }),
                step === 1 && (item === null || item === void 0 ? void 0 : item.item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuUnitSelectModal, {
                        item: item === null || item === void 0 ? void 0 : item.item,
                        selectedItems: selectedItems,
                        onClose: handleOnClose,
                        onGoBack: function() {
                            setStep(0);
                            setItem(null);
                        },
                        isBeforeReceiption: isBeforeReceiption,
                        onSelectItem: function(skuId) {
                            setItem({
                                item: item === null || item === void 0 ? void 0 : item.item,
                                selectSkuId: skuId
                            });
                            setStep(2);
                        }
                    })
                }),
                step === 2 && (item === null || item === void 0 ? void 0 : item.item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelectModal, {
                        item: item.item,
                        skuId: item.selectSkuId,
                        maxChoice: maxChoice,
                        selectedIndex: selectedIndex,
                        onGoBack: function() {
                            var ref, ref1, ref2;
                            if ((ref = item.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.units) === null || ref2 === void 0 ? void 0 : ref2.length) {
                                return setStep(1);
                            }
                            setStep(0);
                        },
                        maxSelectItem: maxSelectItem,
                        onSubmit: function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onSubmit(values)
                                            ];
                                        case 1:
                                            _state.sent();
                                            onClose();
                                            setStep(0);
                                            setItem(null);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(values) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/PaymentInfoCell.tsx











var components_PaymentInfoCell_PaymentInfoCell = function(param) {
    var inputFullNameProps = param.inputFullNameProps, originFullNameValue = param.originFullNameValue, paymentSource = param.paymentSource, paymentFees = param.paymentFees, value = param.value, setValue = param.setValue, error = param.error, onRegister = param.onRegister, paymentMethods = param.paymentMethods, toggleMembershipModalOpen = param.toggleMembershipModalOpen, isAccessible = param.isAccessible;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var konbiniFee = (0,react.useMemo)(function() {
        return paymentFees === null || paymentFees === void 0 ? void 0 : paymentFees.find(function(fee) {
            return fee.feeType === utoniq_core_schema/* FeeType.Konbini */.ntd.Konbini;
        });
    }, [
        paymentFees
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("paymentInfo", "支払い情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 3,
                    ".MuiFormControlLabel-root > span:first-child": {
                        display: paymentMethods.length > 1 ? "block" : "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                            value: value,
                            onChange: function(_, value) {
                                setValue("paymentMethod", value, {
                                    shouldValidate: true
                                });
                                if (value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini) {
                                    setValue("fullName", originFullNameValue, {
                                        shouldValidate: true
                                    });
                                }
                            },
                            sx: {
                                gap: function(theme) {
                                    return theme.spacing(4);
                                }
                            },
                            children: [
                                paymentMethods.includes(utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    value: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                    checked: value === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        onClick: function(e) {
                                            if (!isAccessible) {
                                                e.preventDefault();
                                                toggleMembershipModalOpen();
                                            }
                                        }
                                    }),
                                    label: paymentSource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                                    height: 25,
                                                    src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource.brand),
                                                    target: "common"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: t("last4Digits", {
                                                        number: paymentSource.last4
                                                    })
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: t("creditCard")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                        variant: "text",
                                                        color: "primary",
                                                        onClick: handleLoginModal(onRegister),
                                                        children: t("register", "登録")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.hint",
                                                children: t("creditCardNotRegistered", "支払い情報が登録されていません")
                                            })
                                        ]
                                    })
                                }),
                                paymentMethods.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                paymentMethods.includes(utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    value: utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                    checked: value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        onClick: function(e) {
                                            if (!isAccessible) {
                                                e.preventDefault();
                                                toggleMembershipModalOpen();
                                            }
                                        }
                                    }),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h5",
                                                        children: t("convenienceStore", "コンビニ決済")
                                                    }),
                                                    !!(konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.formattedFee) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: t("convenienceStoreNote", {
                                                            paymentFee: konbiniFee.formattedFee
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: t("convenienceStoreDesc")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    py: 4
                                },
                                color: "text.secondary",
                                children: t("storeItemNote")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfoCell_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                type: "text"
                            }, inputFullNameProps), {
                                textFieldProps: {
                                    sx: {
                                        mb: 0
                                    }
                                }
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: "error",
                variant: "body2",
                children: error
            })
        ]
    });
};
var PaymentInfoCell_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/CommissionListCell.tsx








var CommissionListCell = function(param) {
    var paymentFees = param.paymentFees, isKonbini = param.isKonbini;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    // 手数料を表示用にフォーマットする
    var formattedFees = (0,react.useMemo)(function() {
        var filteredFees = paymentFees === null || paymentFees === void 0 ? void 0 : paymentFees.filter(function(fee) {
            return fee.feeType !== utoniq_core_schema/* FeeType.Konbini */.ntd.Konbini || isKonbini;
        });
        if (!filteredFees || filteredFees.length === 0) {
            return [
                t("emptyFees", "なし")
            ];
        }
        return filteredFees === null || filteredFees === void 0 ? void 0 : filteredFees.map(function(fee) {
            switch(fee.per){
                case "order":
                    return "".concat(fee.feeName, ": ").concat(t("feePerOrder", {
                        fee: "".concat(numeral_default()(fee.fee).format("0,0"))
                    }));
                case "item":
                    return "".concat(fee.feeName, ": ").concat(t("feePerItem", {
                        fee: "".concat(numeral_default()(fee.fee).format("0,0"))
                    }));
                default:
                    return null;
            }
        });
    }, [
        t,
        paymentFees,
        isKonbini
    ]);
    if (isEmpty_default()(formattedFees)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("usageFee", "利用手数料")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 6,
                    px: 1
                },
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "subtitle1",
                        children: t("commission", "手数料")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: formattedFees === null || formattedFees === void 0 ? void 0 : formattedFees.map(function(fee) {
                            return fee;
                        }).join("\n")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/CautionTextCell.tsx




var CautionTextCell = function(param) {
    var note = param.note;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: "26px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("notes", "注意事項")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    component: "p",
                    variant: "caption",
                    color: "text.secondary",
                    children: note
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/ButtonCell.tsx





var components_ButtonCell_ButtonCell = function(param) {
    var onSubmit = param.onSubmit, disabled = param.disabled, isSubmitting = param.isSubmitting;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checked,
                        onClick: function() {
                            return setChecked(function(prevState) {
                                return !prevState;
                            });
                        }
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("checkBoxLabel")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: !checked || disabled,
                    loading: isSubmitting,
                    sx: {
                        width: 212
                    },
                    onClick: onSubmit,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/FirstComeFirstServedDetailForm.tsx













var FirstComeFirstServedDetailForm_schema = function(o) {
    return {
        preSaleId: o.string(),
        paymentMethod: o.string(),
        fullName: o.string().when("paymentMethod", {
            is: utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
            then: o.string().label("氏名"),
            otherwise: o.string().optional().allow(null)
        }),
        choices: o.array().items(o.object({
            itemId: o.string(),
            skuId: o.string().optional().allow(null)
        })),
        purchaseCountChoices: o.array().items(o.object({
            count: o.number()
        })),
        isFirstComeFirstServed: o.boolean().optional()
    };
};
var FirstComeFirstServedDetailForm = function(param) {
    var preSaleId = param.preSaleId, preSale = param.preSale, paymentSource = param.paymentSource, originFullNameValue = param.originFullNameValue, paymentFees = param.paymentFees, onSubmit = param.onSubmit, onReadyPaymentMethod = param.onReadyPaymentMethod, choices = param.choices;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var ref6;
    var ref7 = (0,core_form/* useForm */.cI)({
        schema: FirstComeFirstServedDetailForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, FirstComeFirstServedDetailForm_defaultValues), {
            preSaleId: preSale.id,
            // 予め選択された状態の場合（ストアから直接遷移）
            choices: choices ? [
                {
                    itemId: choices.itemId,
                    skuId: choices.skuId
                }
            ] : FirstComeFirstServedDetailForm_defaultValues.choices,
            purchaseCountChoices: choices ? [
                {
                    count: choices.count
                }
            ] : FirstComeFirstServedDetailForm_defaultValues.purchaseCountChoices,
            paymentMethod: (ref6 = (ref = preSale.paymentMethods) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref6 !== void 0 ? ref6 : FirstComeFirstServedDetailForm_defaultValues.paymentMethod
        })
    }), watch = ref7.watch, setValue = ref7.setValue, handleSubmit = ref7.handleSubmit, register = ref7.register, control = ref7.control, getValues = ref7.getValues, _formState = ref7.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors;
    // メンバーシップ限定モーダルの表示状態
    var ref8 = (0,react.useReducer)(function(state) {
        return !state;
    }, false), membershipModalOpen = ref8[0], toggleMembershipModalOpen = ref8[1];
    var paymentMethodWatch = watch("paymentMethod");
    var isStopSalling = preSale.preSaleStatus !== utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting;
    var isBeforeReceiption = preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption;
    // 離脱時に入力値を保存
    (0,react.useEffect)(function() {
        return function() {
            (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", watch())
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    }, []);
    var _paymentMethods, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            (preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.Accepting */.fu$.Accepting || isBeforeReceiption || preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.SoldOut */.fu$.SoldOut) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketListCell, {
                preSaleId: preSaleId,
                items: preSale.items,
                control: control,
                errors: errors,
                maxChoice: 1,
                preSaleStatus: preSale.preSaleStatus,
                maxSelectItem: (ref1 = preSale.firstComeFirstServed) === null || ref1 === void 0 ? void 0 : ref1.purchasableCount,
                isBeforeReceiption: isBeforeReceiption,
                toggleMembershipModalOpen: toggleMembershipModalOpen,
                isAccessible: preSale.isAccessible
            }),
            !isStopSalling && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PaymentInfoCell_PaymentInfoCell, {
                paymentMethods: (_paymentMethods = preSale.paymentMethods) !== null && _paymentMethods !== void 0 ? _paymentMethods : [
                    utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                    utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini, 
                ],
                paymentFees: paymentFees,
                value: paymentMethodWatch,
                setValue: setValue,
                paymentSource: paymentSource,
                toggleMembershipModalOpen: toggleMembershipModalOpen,
                isAccessible: preSale.isAccessible,
                originFullNameValue: originFullNameValue !== null && originFullNameValue !== void 0 ? originFullNameValue : "",
                inputFullNameProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("fullName")), {
                    error: errors.fullName
                }),
                onRegister: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setTimeout(function() {
                            onReadyPaymentMethod(getValues());
                        }, 300);
                        return [
                            2
                        ];
                    });
                }),
                error: (ref2 = errors.paymentMethod) === null || ref2 === void 0 ? void 0 : ref2.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommissionListCell, {
                paymentFees: paymentFees,
                isKonbini: watch("paymentMethod") === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CautionTextCell, {
                note: preSale.note
            }),
            !isStopSalling && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonCell_ButtonCell, {
                onSubmit: handleSubmit(function(v) {
                    onSubmit(v);
                }),
                disabled: isSubmitting || watch("paymentMethod") === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && !paymentSource || !isEmpty_default()(errors) || !((ref3 = watch("choices")) === null || ref3 === void 0 ? void 0 : ref3.filter(function(param) {
                    var itemId = param.itemId;
                    return itemId;
                }).length),
                isSubmitting: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: membershipModalOpen,
                onClose: toggleMembershipModalOpen,
                title: t("membershipRequired", "メンバーシップへの加入が必要です"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                    size: "large",
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    href: generatePath(routerPages.ArtistMembership, {
                        artistId: (ref9 = preSale === null || preSale === void 0 ? void 0 : (ref4 = preSale.artist) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref9 !== void 0 ? ref9 : "#"
                    }),
                    onClick: function() {
                        /**
                 * TODO:
                 * 年間メンバーシッププラン機能に伴う導線実装が完了したら、先行販売に戻るUIを下記ローカルストレージキーをもとに実装すること
                 * https://zpl.io/kKOkROg
                 */ (0,storage/* setPreference */.l$)("currentPreSaleId", {
                            preSaleId: preSale.id
                        });
                    },
                    children: t("seeDetail")
                })
            })
        ]
    });
};
var FirstComeFirstServedDetailForm_defaultValues = {
    choices: [
        {
            itemId: "",
            skuId: undefined
        }
    ],
    fullName: null,
    paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
    preSaleId: "",
    purchaseCountChoices: [
        {
            count: 1
        }
    ],
    isFirstComeFirstServed: true
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/components/MembershipCell.tsx







var MembershipCell_MembershipCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref6.routerPages, generatePath = ref6.generatePath;
    /** 先行販売に必要なメンバーシップのプラン */ var membershipPlans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        // 登録プランをすべて表示する
        var planIds = (preSale === null || preSale === void 0 ? void 0 : preSale.planId) ? [
            preSale.planId
        ] : (preSale === null || preSale === void 0 ? void 0 : preSale.purchesablePlanIds) || [];
        if (!planIds.length) return [];
        var planData = ((ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.filter(function(products) {
            return products.plans.some(function(plan) {
                return planIds.includes(plan.planId);
            });
        })) || [];
        // 全プラン対象の場合はプラン詳細を表示しない
        return planData.length === ((ref3 = preSale.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.products) === null || ref5 === void 0 ? void 0 : ref5.length) ? [] : planData;
    }, [
        preSale === null || preSale === void 0 ? void 0 : (ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    /** ユーザーの加入しているメンバーシップのプラン */ var currentPatronProduct = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var planId = preSale === null || preSale === void 0 ? void 0 : (ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId;
        if (!planId) return null;
        return (ref3 = preSale.artist.subscription) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.products) === null || ref4 === void 0 ? void 0 : ref4.find(function(products) {
            return products.plans.find(function(plan) {
                return plan.planId === planId;
            });
        });
    }, [
        preSale === null || preSale === void 0 ? void 0 : (ref2 = preSale.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.patron) === null || ref3 === void 0 ? void 0 : ref3.id
    ]);
    if (!preSale.isPremium && (!preSale.purchesablePlanIds || preSale.purchesablePlanIds.length === 0)) return null;
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("condition", "応募条件")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 0,
                        sx: {
                            placeItems: "center",
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                fontSize: "small",
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.hint",
                                children: t("isPremium")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: [
                            preSale.plans.map(function(plan) {
                                return plan === null || plan === void 0 ? void 0 : plan.planTitle;
                            }).join("\n"),
                            t("membershipLimited", "会員の方")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                variant: "outlined",
                sx: {
                    p: 5,
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        pb: "0!important",
                        p: 0
                    },
                    children: preSale.isAccessible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                sx: {
                                                    minWidth: "60px"
                                                },
                                                children: t("planTitle")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: currentPatronProduct === null || currentPatronProduct === void 0 ? void 0 : currentPatronProduct.title
                                            })
                                        ]
                                    }),
                                    !!preSale.isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "white",
                                            children: t("joined")
                                        }),
                                        sx: {
                                            height: 16,
                                            bgcolor: "primary.main",
                                            borderRadius: "2px",
                                            padding: "2px 4px",
                                            ".MuiChip-label": {
                                                px: 0
                                            }
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                sx: {
                                    mt: 3,
                                    pb: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: {
                                            minWidth: "60px"
                                        },
                                        children: t("updatedAt")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: (ref4 = preSale.artist.patron) === null || ref4 === void 0 ? void 0 : ref4.formattedUpdatedAt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1
                                        }
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("membershipBenefit")
                            }),
                            membershipPlans.map(function(plan) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                mt: 2
                                            },
                                            children: plan.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: plan.content
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "grid",
                                    placeItems: "cen"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                                    sx: {
                                        mt: 6,
                                        width: "212px",
                                        mx: "auto"
                                    },
                                    size: "large",
                                    href: generatePath(routerPages.ArtistMembership, {
                                        artistId: (ref7 = preSale === null || preSale === void 0 ? void 0 : (ref5 = preSale.artist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref7 !== void 0 ? ref7 : "#"
                                    }),
                                    onClick: function() {
                                        /**
                     * TODO:
                     * 年間メンバーシッププラン機能に伴う導線実装が完了したら、先行販売に戻るUIを下記ローカルストレージキーをもとに実装すること
                     * https://zpl.io/kKOkROg
                     */ (0,storage/* setPreference */.l$)("currentPreSaleId", {
                                            preSaleId: preSale.id
                                        });
                                    },
                                    children: t("seeDetail")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/template/index.tsx











var FirstComeFirstServedDetailTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onReadyPaymentMethod = param.onReadyPaymentMethod;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("firstComeFirstServedDetail").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref4.routerNames, routerPages = ref4.routerPages, generatePath = ref4.generatePath;
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            defaultBackPage: ((ref = state.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.status) === utoniq_core_schema/* EventStatus.Published */.N3X.Published ? generatePath(routerPages.ShokufesEventDetail, {
                eventId: (ref5 = (ref2 = state.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref5 !== void 0 ? ref5 : "#"
            }) : undefined,
            title: t("title", "販売情報詳細")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.FirstComeFirstServedDetail
            }),
            state.loading || !state.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedTitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedSkeletonCell, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_FirstComeFirstServedTitleCell, {
                        title: state.preSale.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedContentCell, {
                        preSale: state.preSale
                    }),
                    state.preSale.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCell_MembershipCell, {
                        preSale: state.preSale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedDetailForm, {
                        preSaleId: state.preSaleId,
                        preSale: state.preSale,
                        originFullNameValue: state.originFullNameValue,
                        paymentSource: state.paymentSource,
                        onSubmit: onSubmit,
                        onReadyPaymentMethod: onReadyPaymentMethod,
                        paymentFees: state.paymentFees,
                        choices: state.choices
                    })
                ]
            })
        ]
    });
};
var template_FirstComeFirstServedTitleCell = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: title
        })
    });
};
var FirstComeFirstServedTitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h4",
            width: "50%"
        })
    });
};
var FirstComeFirstServedSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                width: "10%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 3,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            borderColor: "grey.100",
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderRadius: 2,
                            px: 4,
                            py: 5,
                            my: 4
                        },
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "25%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "50%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "50%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                ]
            }),
            Array.from(Array(2).keys()).map(function(key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 5,
                        pt: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                py: 1,
                                bgcolor: "grey.50"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 3
                            })
                        })
                    ]
                }, key);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                sx: {
                    py: 4
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 244,
                    height: 44,
                    sx: {
                        borderRadius: "34px"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/core/rootAuth/index.ts
/**
 * @description
 * 他のファンクラブアプリからルート認証を行った際の認証情報をストレージに保存する機構
 * 認証サーバからのリダイレクトでアプリに飛んだ際のクエリパラメータ検証し、セットする
 *
 * このフック自体は 抽選詳細ページ LotteryDetail で利用する
 *
 * https://app.clickup.com/t/908127/UT-15166
 */ 




var useRootAuth = function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = (0,react.useState)({}), rootAuthInfo = ref[0], setRootAuthInfo = ref[1];
    // クエリパラメータをlocalStorageに保存
    (0,react.useEffect)(function() {
        if (router.query.preSaleId && router.query.clientId && router.query.token) {
            (0,storage/* setPreference */.l$)("rootAuthInfo", {
                preSaleId: router.query.preSaleId,
                clientId: router.query.clientId,
                token: router.query.token
            });
        }
    }, [
        router.query.clientId,
        router.query.token,
        router.query.preSaleId
    ]);
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var rootAuthInfo;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("rootAuthInfo")
                        ];
                    case 1:
                        rootAuthInfo = _state.sent();
                        setRootAuthInfo(rootAuthInfo);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router.pathname
    ]);
    return rootAuthInfo;
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/viewModel.ts



function LotteryDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PreSaleLotteryDetail(\n    $id: ID!\n    $preSaleId: String!\n    $clientId: String\n    $token: String\n  ) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      ...PreSaleLotteryDetail\n    }\n    preSaleLotteryApplicant(preSaleId: $preSaleId) {\n      id\n      status\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n    user {\n      ...UserDeliveryDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    LotteryDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PreSaleLotteryDetailForGuest(\n    $id: ID!\n    $clientId: String\n    $token: String\n  ) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      ...PreSaleLotteryDetail\n    }\n  }\n  ",
        "\n"
    ]);
    LotteryDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











/**
 *
 */ var LotteryDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, routerPages = ref5.routerPages;
    var rootAuthInfo = useRootAuth();
    /** 外部アプリのルート認証に失敗したかどうかの状態 */ var ref6 = (0,react.useState)(false), isRootAuthFailed = ref6[0], setIsRootAuthFailed = ref6[1];
    var ref7 = (0,react.useState)(), choice = ref7[0], setChoice = ref7[1];
    var ref8 = (0,useQuery/* useQuery */.aM)(LotteryDetail_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId,
            preSaleId: router.query.preSaleId,
            clientId: rootAuthInfo.clientId,
            token: rootAuthInfo.token
        },
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        onError: function(error) {
            var ref;
            var ref1;
            setIsRootAuthFailed((ref1 = error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.some(function(error) {
                var ref;
                return (error === null || error === void 0 ? void 0 : (ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === "FORBIDDEN";
            })) !== null && ref1 !== void 0 ? ref1 : false);
        }
    }), data = ref8.data, loading = ref8.loading;
    var ref9 = (0,useQuery/* useQuery */.aM)(LotteryDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            id: router.query.preSaleId,
            clientId: rootAuthInfo.clientId,
            token: rootAuthInfo.token
        },
        skip: !!(user === null || user === void 0 ? void 0 : user.isSigned),
        onError: function(error) {
            var ref;
            var ref1;
            setIsRootAuthFailed((ref1 = error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.some(function(error) {
                var ref;
                return (error === null || error === void 0 ? void 0 : (ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === "FORBIDDEN";
            })) !== null && ref1 !== void 0 ? ref1 : false);
        }
    }), dataForGuest = ref9.data, loadingForGuest = ref9.loading;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                        ];
                    case 1:
                        v = _state.sent();
                        // 戻るボタンによる遷移の場合、購入内容を保持する
                        if (v.preSaleId === router.query.preSaleId) {
                            setChoice(v.choices.map(function(c, i) {
                                return {
                                    itemId: c.itemId,
                                    skuId: c.skuId,
                                    count: v.purchaseCountChoices[i].count
                                };
                            }));
                        }
                        // LocalStorageに保存したFormの値保持用の一次データを削除
                        return [
                            4,
                            (0,storage/* removePrefernce */.Tq)("preSaleLotteryApplicationInput")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var ref10;
    var fees = (ref = (ref10 = data === null || data === void 0 ? void 0 : data.preSale) !== null && ref10 !== void 0 ? ref10 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.fees;
    var ref11;
    var paymentFees = (0,react.useMemo)(function() {
        return ((fees === null || fees === void 0 ? void 0 : fees.collections) || []).concat((fees === null || fees === void 0 ? void 0 : fees.konbini) ? [
            fees.konbini
        ] : []).concat((fees === null || fees === void 0 ? void 0 : fees.shipping) ? [
            fees.shipping
        ] : []).filter(function(fee) {
            return !!fee;
        }).map(function(fee) {
            return {
                feeName: fee === null || fee === void 0 ? void 0 : fee.feeName,
                fee: (ref11 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref11 !== void 0 ? ref11 : 0,
                per: fee === null || fee === void 0 ? void 0 : fee.per,
                feeType: fee === null || fee === void 0 ? void 0 : fee.feeType,
                formattedFee: fee === null || fee === void 0 ? void 0 : fee.formattedFee
            };
        });
    }, [
        fees
    ]);
    var ref12, ref13, ref14;
    return {
        state: {
            isRootAuthFailed: isRootAuthFailed,
            preSale: (ref12 = data === null || data === void 0 ? void 0 : data.preSale) !== null && ref12 !== void 0 ? ref12 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.preSale,
            isAppliedUser: !!(data === null || data === void 0 ? void 0 : (ref3 = data.preSaleLotteryApplicant) === null || ref3 === void 0 ? void 0 : ref3.id) && data.preSaleLotteryApplicant.status !== "60_canceled",
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            loading: loading || loadingForGuest,
            originFullNameValue: (ref13 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.fullName) !== null && ref13 !== void 0 ? ref13 : "",
            paymentFees: paymentFees,
            konbiniFee: fees === null || fees === void 0 ? void 0 : fees.konbini,
            choices: choice !== null && choice !== void 0 ? choice : router.query.itemId ? [
                {
                    itemId: router.query.itemId,
                    skuId: router.query.skuId && decodeSkuId(router.query.skuId),
                    count: (ref14 = Number(router.query.quantity)) !== null && ref14 !== void 0 ? ref14 : 1
                }, 
            ] : undefined
        },
        actions: {
            onReadyPaymentMethod: /** クレカ登録画面に遷移する */ function onReadyPaymentMethod(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(values === null || values === void 0 ? void 0 : values.choices.length)) return [
                                    3,
                                    2
                                ];
                                // 内部ストレージに保存し、遷移先で取り出す
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", values)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                router.push(routerPages.PaymentMethodSetting);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!values) return [
                                    2
                                ];
                                // 内部ストレージに保存し、遷移先で取り出す
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", values)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_preSaleLotteryConfirm", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        preSaleId: router.query.preSaleId,
                                        choiceCount: values === null || values === void 0 ? void 0 : values.choices.length,
                                        paymentMethod: values.paymentMethod
                                    })
                                ];
                            case 2:
                                _state.sent();
                                if (needToRegisterUserInfo((ref2 = (ref = data === null || data === void 0 ? void 0 : data.preSale.lottery) === null || ref === void 0 ? void 0 : ref.personalInformationRequirements) !== null && ref2 !== void 0 ? ref2 : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.push((0,react_router/* generatePath */.Gn)(routerPages.LotteryUserInfo, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                if (needToRegisterUserAddress((ref3 = (ref1 = data === null || data === void 0 ? void 0 : data.preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.personalInformationRequirements) !== null && ref3 !== void 0 ? ref3 : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.push((0,react_router/* generatePath */.Gn)(routerPages.LotteryDeliveryInfo, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                router.push((0,react_router/* generatePath */.Gn)(routerPages.LotteryConfirmation, {
                                    preSaleId: router.query.preSaleId
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var LotteryDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryDetail_viewModel_templateObject(), utoniq_core_schema/* PreSaleLotteryDetailFragmentDoc */.FFL, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* UserDeliveryDetailFragmentDoc */.TRY);
var LotteryDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(LotteryDetail_viewModel_templateObject1(), utoniq_core_schema/* PreSaleLotteryDetailFragmentDoc */.FFL);
/**
 *
 * @param personalInformationRequirements
 * @param user
 */ function needToRegisterUserInfo(personalInformationRequirements, user) {
    var requiredFullName = personalInformationRequirements.some(function(req) {
        return req === utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName;
    }) && !(user === null || user === void 0 ? void 0 : user.fullName);
    var requiredBirthday = personalInformationRequirements.some(function(req) {
        return req === utoniq_core_schema/* PersonalInformationType.Birthday */.APM.Birthday;
    }) && !(user === null || user === void 0 ? void 0 : user.birthday);
    var requiredGender = personalInformationRequirements.some(function(req) {
        return req === utoniq_core_schema/* PersonalInformationType.Gender */.APM.Gender;
    }) && !(user === null || user === void 0 ? void 0 : user.gender);
    var requiredPhoneNumber = personalInformationRequirements.some(function(req) {
        return req === utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber;
    }) && (!(user === null || user === void 0 ? void 0 : user.phoneNumber) || !(user === null || user === void 0 ? void 0 : user.isPhoneNumberVerified));
    return requiredFullName || requiredBirthday || requiredGender || requiredPhoneNumber;
}
/**
 *
 * @param personalInformationRequirements
 * @param user
 */ function needToRegisterUserAddress(personalInformationRequirements, user) {
    var ref, ref1, ref2, ref3;
    return (personalInformationRequirements === null || personalInformationRequirements === void 0 ? void 0 : personalInformationRequirements.some(function(req) {
        return req === utoniq_core_schema/* PersonalInformationType.Address */.APM.Address;
    })) && (!(user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.postalCode) || !(user === null || user === void 0 ? void 0 : (ref1 = user.address) === null || ref1 === void 0 ? void 0 : ref1.prefecture) || !(user === null || user === void 0 ? void 0 : (ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.city) || !(user === null || user === void 0 ? void 0 : (ref3 = user.address) === null || ref3 === void 0 ? void 0 : ref3.line1));
}

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/viewModel.ts



function FirstComeFirstServedDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FirstComeFirstServedDetail(\n    $id: ID!\n    $clientId: String\n    $token: String\n  ) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      ...FirstComeFirstServedDetail\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n    user {\n      ...UserDeliveryDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    FirstComeFirstServedDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FirstComeFirstServedDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FirstComeFirstServedDetailForGuest(\n    $id: ID!\n    $clientId: String\n    $token: String\n  ) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      ...FirstComeFirstServedDetailForGuest\n    }\n  }\n  ",
        "\n"
    ]);
    FirstComeFirstServedDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














/**
 *
 */ var FirstComeFirstServedDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var ref5 = (0,react.useState)(), choice = ref5[0], setChoice = ref5[1];
    var rootAuthInfo = useRootAuth();
    var ref6 = (0,useQuery/* useQuery */.aM)(FirstComeFirstServedDetail_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId,
            clientId: rootAuthInfo.clientId,
            token: rootAuthInfo.token
        },
        skip: !(user === null || user === void 0 ? void 0 : user.isSigned),
        onCompleted: function onCompleted(param) {
            var preSale = param.preSale;
            if (preSale) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
                    item_list_id: "preSale_list_".concat(preSale.id),
                    item_list_name: "PreSale Items",
                    items: preSale.items.map(function(item) {
                        return {
                            item_id: item.id,
                            item_name: item.title,
                            item_category: ConversionCategories.preSaleItem,
                            item_category2: item.type,
                            item_category3: native_app/* getPlatform */.Xf(),
                            item_category4: 1,
                            item_category5: preSale.id,
                            price: item.price
                        };
                    })
                });
            }
        }
    }), data = ref6.data, loading = ref6.loading;
    var ref7 = (0,useQuery/* useQuery */.aM)(FirstComeFirstServedDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            id: router.query.preSaleId,
            clientId: rootAuthInfo.clientId,
            token: rootAuthInfo.token
        },
        skip: !!(user === null || user === void 0 ? void 0 : user.isSigned)
    }), dataForGuest = ref7.data, loadingForGuest = ref7.loading;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 画面ロード時に冪等キーをリフレッシュする
                        return [
                            4,
                            (0,storage/* setPreference */.l$)("idempotencyKey", createUuid())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                        ];
                    case 2:
                        v = _state.sent();
                        // 戻るボタンによる遷移の場合、購入内容を保持する
                        if (v.preSaleId === router.query.preSaleId) {
                            setChoice(v.choices.map(function(c, i) {
                                return {
                                    itemId: c.itemId,
                                    skuId: c.skuId,
                                    count: v.purchaseCountChoices[i].count
                                };
                            })[0]);
                        }
                        // LocalStorageに保存したFormの値保持用の一次データを削除
                        return [
                            4,
                            (0,storage/* removePrefernce */.Tq)("preSaleLotteryApplicationInput")
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var ref8;
    var fees = (ref = (ref8 = data === null || data === void 0 ? void 0 : data.preSale) !== null && ref8 !== void 0 ? ref8 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.fees;
    var ref9;
    var paymentFees = (0,react.useMemo)(function() {
        return ((fees === null || fees === void 0 ? void 0 : fees.collections) || []).concat((fees === null || fees === void 0 ? void 0 : fees.konbini) ? [
            fees.konbini
        ] : []).concat((fees === null || fees === void 0 ? void 0 : fees.shipping) ? [
            fees.shipping
        ] : []).filter(function(fee) {
            return !!fee;
        }).map(function(fee) {
            return {
                feeName: fee === null || fee === void 0 ? void 0 : fee.feeName,
                fee: (ref9 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref9 !== void 0 ? ref9 : 0,
                per: fee === null || fee === void 0 ? void 0 : fee.per,
                feeType: fee === null || fee === void 0 ? void 0 : fee.feeType,
                formattedFee: fee === null || fee === void 0 ? void 0 : fee.formattedFee
            };
        });
    }, [
        fees
    ]);
    var ref10, ref11, ref12;
    return {
        state: {
            user: user,
            preSaleId: router.query.preSaleId,
            loading: loading || loadingForGuest,
            preSale: (ref10 = data === null || data === void 0 ? void 0 : data.preSale) !== null && ref10 !== void 0 ? ref10 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.preSale,
            paymentFees: paymentFees,
            originFullNameValue: (ref11 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.fullName) !== null && ref11 !== void 0 ? ref11 : "",
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            choices: choice !== null && choice !== void 0 ? choice : router.query.itemId ? {
                itemId: router.query.itemId,
                skuId: router.query.skuId && decodeSkuId(router.query.skuId),
                count: (ref12 = Number(router.query.quantity)) !== null && ref12 !== void 0 ? ref12 : 1
            } : undefined
        },
        actions: {
            onReadyPaymentMethod: function onReadyPaymentMethod(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(values === null || values === void 0 ? void 0 : values.choices.length)) return [
                                    3,
                                    2
                                ];
                                // 内部ストレージに保存し、遷移先で取り出す
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", values)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                router.push(routerPages.PaymentMethodSetting);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, item, ref6, ref7;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!values) return [
                                    2
                                ];
                                // 内部ストレージに保存し、遷移先で取り出す
                                return [
                                    4,
                                    (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", values)
                                ];
                            case 1:
                                _state.sent();
                                item = data === null || data === void 0 ? void 0 : data.preSale.items.find(function(item) {
                                    var ref, ref1;
                                    return item.id === (values === null || values === void 0 ? void 0 : (ref = values.choices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.itemId);
                                });
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_preSaleFcfsConfirm", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        preSaleId: router.query.preSaleId,
                                        paymentMethod: values === null || values === void 0 ? void 0 : values.paymentMethod
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("add_to_cart", {
                                        item_list_id: "preSale_list_".concat(router.query.preSaleId),
                                        item_list_name: "PreSale Items",
                                        isInstant: true,
                                        isAnonymous: false,
                                        items: [
                                            {
                                                item_id: item === null || item === void 0 ? void 0 : item.id,
                                                item_name: item === null || item === void 0 ? void 0 : item.title,
                                                item_category: ConversionCategories.preSaleItem,
                                                item_category2: item === null || item === void 0 ? void 0 : item.type,
                                                item_category3: native_app/* getPlatform */.Xf(),
                                                item_category4: values === null || values === void 0 ? void 0 : (ref = values.choices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.skuId,
                                                item_category5: router.query.preSaleId,
                                                price: item === null || item === void 0 ? void 0 : item.price,
                                                quantity: (ref2 = values.purchaseCountChoices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.count
                                            }
                                        ]
                                    })
                                ];
                            case 3:
                                _state.sent();
                                if (needToRegisterUserInfo((ref6 = (ref4 = data === null || data === void 0 ? void 0 : data.preSale.firstComeFirstServed) === null || ref4 === void 0 ? void 0 : ref4.personalInformationRequirements) !== null && ref6 !== void 0 ? ref6 : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.push(generatePath(routerPages.LotteryUserInfo, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                if (needToRegisterUserAddress((ref7 = (ref5 = data === null || data === void 0 ? void 0 : data.preSale.firstComeFirstServed) === null || ref5 === void 0 ? void 0 : ref5.personalInformationRequirements) !== null && ref7 !== void 0 ? ref7 : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.push(generatePath(routerPages.LotteryDeliveryInfo, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                router.push(generatePath(routerPages.FirstComeFirstServedConfirmation, {
                                    preSaleId: router.query.preSaleId
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var FirstComeFirstServedDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(FirstComeFirstServedDetail_viewModel_templateObject(), utoniq_core_schema/* FirstComeFirstServedDetailFragmentDoc */.IT7, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* UserDeliveryDetailFragmentDoc */.TRY);
var FirstComeFirstServedDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(FirstComeFirstServedDetail_viewModel_templateObject1(), utoniq_core_schema/* FirstComeFirstServedDetailForGuestFragmentDoc */.KWM);

;// CONCATENATED MODULE: ./src/components/pages/FirstComeFirstServedDetail/index.tsx




/**
 * FirstComeFirstServedDetail Page
 * Implemented as a practical sample.
 */ var FirstComeFirstServedDetail = function() {
    var ref = FirstComeFirstServedDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstComeFirstServedDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/lib/animation/FullScreenAnimationCell.tsx



/**
 * @deprecated remove when animation type changed to video. Please use VideoFullScreen component
 */ var FullScreenAnimationCell = /*#__PURE__*/ (0,react.forwardRef)(function(_, ref) {
    var ANIMATION_WIDTH = 346;
    var ANIMATION_HEIGHT = 614;
    var ASPECT_RATIO = ANIMATION_WIDTH / ANIMATION_HEIGHT;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "grid",
            gridTemplateRows: "1fr",
            height: "100vh",
            overflow: "hidden",
            margin: "auto",
            maxWidth: 600,
            canvas: {
                width: "100%",
                height: "100%",
                zIndex: 1,
                "@media(max-width: 600px)": {
                    width: "calc(100vh * ".concat(ASPECT_RATIO, ")"),
                    overflow: "hidden",
                    marginLeft: "calc((100vh * ".concat(ASPECT_RATIO, " - 100vw) / 2 * -1)")
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
            width: ANIMATION_WIDTH,
            height: ANIMATION_HEIGHT,
            ref: ref
        })
    });
});

;// CONCATENATED MODULE: ./src/components/lib/animation/VideoFullScreen.tsx






var VideoFullScreen = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var sx = param.sx, shouldMute = param.shouldMute;
    var _$ref = (0,react.useState)({}), reactPlayerProps = _$ref[0], setReactPlayerProps = _$ref[1];
    var _$ref1 = (0,react.useState)(false), shouldPlay = _$ref1[0], setShouldPlay = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), isReady = _$ref2[0], setIsReady = _$ref2[1];
    var videoRef = (0,react.useRef)();
    var playerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            init: function init(props) {
                setReactPlayerProps(props);
            },
            handleOnReadyVideo: function handleOnReadyVideo() {
                setIsReady(true);
            },
            playVideo: function playVideo() {
                setShouldPlay(true);
            },
            pauseVideo: function pauseVideo() {
                setShouldPlay(false);
            },
            src: reactPlayerProps.url
        };
    });
    (0,react.useEffect)(function() {
        var _$ref, _$ref1;
        // ReactPlayer内部のplayerを用いて動画リソースを読み込んでから再生する
        var videoElm = ((_$ref = playerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getInternalPlayer()) || ((_$ref1 = videoRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.querySelector("video"));
        var canPlay = videoElm && isReady;
        if (!canPlay) return;
        if (shouldPlay) {
            videoElm.play();
        } else {
            videoElm.pause();
        }
    }, [
        isReady,
        shouldPlay
    ]);
    (0,react.useEffect)(function() {
        var _$ref, _$ref1;
        var videoElm = ((_$ref = playerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getInternalPlayer()) || ((_$ref1 = videoRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.querySelector("video"));
        if (!videoElm) return;
        /**
     * HACK:
     * iOSのNotAllowedError対策
     * React-Player下のvideo要素にmuted属性を直接指定する
     */ if (videoElm && shouldMute) {
            videoElm.setAttribute("muted", "muted");
        }
    }, [
        reactPlayerProps,
        shouldMute
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        className: "videoFullScreen",
        sx: (0,src_object_spread/* default */.Z)({
            display: "grid",
            gridTemplateRows: "1fr",
            height: "100vh",
            overflow: "hidden",
            margin: "auto",
            maxWidth: 600,
            opacity: shouldPlay ? 1 : 0,
            position: "fixed",
            zIndex: 12,
            width: "100%",
            inset: 0,
            pointerEvents: shouldPlay ? "auto" : "none",
            video: {
                objectFit: "cover"
            }
        }, sx),
        ref: videoRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, reactPlayerProps), {
            ref: playerRef,
            width: "100%",
            height: "100%",
            playsInline: true,
            // Safariでのみ発生するNotAllowedErrorを回避するため音声をミュートする
            muted: shouldMute
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/organisms/gacha/GachaTicketDisplay/Purchase.tsx



var Purchase = function(param) {
    var ticket = param.ticket, isPurchasable = param.isPurchasable, onPurchase = param.onPurchase, src = param.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        direction: "row",
        sx: {
            position: "relative",
            bgcolor: "grey.100",
            borderRadius: 3,
            height: 20,
            width: 88
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: 36,
                    height: 32,
                    position: "absolute",
                    left: -12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.GachaTicketThumbnail, {
                    src: src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                variant: "subtitle1",
                children: ticket
            }),
            isPurchasable && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Plus, {
                onClick: onPurchase,
                size: "small",
                color: "white",
                bgcolor: "primary.main",
                sx: {
                    width: 24,
                    height: 24,
                    position: "absolute",
                    right: 0,
                    svg: {
                        width: 15,
                        height: 15
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/HeaderPurchase.tsx





/**
 * @description
 * ガチャ詳細ヘッダー右部に表示するポイント・ガチャチケットの購入ボタン
 * ガチャの種別によってポイント・ガチャチケットのアイコンと所持数を表示する
 *
 */ var HeaderPurchase = function(param) {
    var available = param.available, type = param.type, point = param.point, onClickPoint = param.onClickPoint, ticket = param.ticket, onClickGachaTicket = param.onClickGachaTicket, isGachaTicketPurchasable = param.isGachaTicketPurchasable, gachaTicketThumbnail = param.gachaTicketThumbnail;
    var ref;
    // ユーザー又はガチャが利用できない場合、何も返さない
    if (!available) return null;
    // ポイントで買えるガチャの場合、ポイント用UIを表示
    if (type === utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint && config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchasePoint, {
        onClick: onClickPoint,
        point: point
    });
    // ガチャチケット用UIを表示
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseGachaTicket, {
        ticket: ticket,
        gachaTicketThumbnail: gachaTicketThumbnail,
        isPurchasable: isGachaTicketPurchasable && !!((ref = config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint) === null || ref === void 0 ? void 0 : ref.chargeable),
        onClick: onClickGachaTicket
    });
};
var PurchasePoint = function(param) {
    var onClick = param.onClick, point = param.point;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayPurchase/* PointDisplayPurchase */.u, {
        onClick: onClick,
        point: point
    });
};
var PurchaseGachaTicket = function(param) {
    var ticket = param.ticket, onClick = param.onClick, isPurchasable = param.isPurchasable, gachaTicketThumbnail = param.gachaTicketThumbnail;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            mr: -2,
            ml: "10px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Purchase, {
            ticket: ticket,
            isPurchasable: isPurchasable,
            src: gachaTicketThumbnail,
            onPurchase: onClick
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/DeactivationMemberCell.tsx





var DeactivationMemberCell = function(param) {
    var artistId = param.artistId, artist = param.artist, type = param.type, productTitle = param.productTitle;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 3,
                    "&:last-child": {
                        pb: 3
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                    fontSize: "small",
                                    sx: {
                                        color: "primary.main"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "primary.main",
                                    children: t("".concat(type, "Title"))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            children: t("".concat(type, "Desc"), {
                                displayName: artist === null || artist === void 0 ? void 0 : artist.displayName,
                                planName: productTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "flex-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "caption",
                                href: generatePath(routerPages.ArtistMembership, {
                                    artistId: artistId
                                }),
                                children: t("membershipDetail", "詳しく見る")
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/DescriptionDrawer.tsx








/**
 * @description
 * ガチャ説明表示用ドロワー
 */ var DescriptionDrawer = function(param) {
    var open = param.open, onClose = param.onClose, name = param.name, endAt = param.endAt, deliveryDateText = param.deliveryDateText, desc = param.desc;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 5
                },
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        sx: {
                            width: "100%",
                            ml: "30px"
                        },
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "end",
                        size: "small",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 5,
                sx: {
                    px: 5,
                    pb: 5,
                    height: 240
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: (0,src_object_spread/* default */.Z)({
                            overflowY: "scroll"
                        }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                        children: [
                            endAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                sx: {
                                    pb: 1
                                },
                                children: t("gachaEndAt", {
                                    date: endAt
                                })
                            }),
                            deliveryDateText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                sx: {
                                    pb: 4
                                },
                                children: t("gachaDeliveryDateText", {
                                    date: deliveryDateText
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: desc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                        variant: "caption",
                        width: "fit-content",
                        href: (0,helpUrl/* getHelpUrl */.R)("specifiedCommercialTransactionLaw"),
                        children: t("commercialTransactionLaw")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/GachaInformation.tsx



/**
 * @description
 * 「終了日」「詳細へ」「排出一覧」などのガチャ詳細データ表示
 */ var GachaInformation = function(param) {
    var gachaId = param.gachaId, artistId = param.artistId, endAt = param.endAt, deliveryDateText = param.deliveryDateText, onClickDetail = param.onClickDetail;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        sx: {
            py: 2,
            px: 5
        },
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: [
                    endAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: t("gachaEndAt", {
                            date: endAt
                        })
                    }),
                    deliveryDateText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        children: t("gachaDeliveryDateText", {
                            date: deliveryDateText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        onClick: onClickDetail,
                        children: t("detail")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        size: "small",
                        href: generatePath(routerPages.GachaItemList, {
                            gachaId: gachaId,
                            artistId: artistId !== null && artistId !== void 0 ? artistId : "#"
                        }),
                        children: t("emissionList")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/GachaMembershipTag.tsx





var GachaMembershipTag = function(param) {
    var type = param.type;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            direction: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                    fontSize: "small",
                    sx: {
                        color: "primary.main"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "primary.main",
                    children: t("".concat(type, "Label"))
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/GachaSliderCell.tsx







/**
 * @description
 * ガチャ詳細のカルーセル箇所の表示
 */ var GachaSliderCell = function(param) {
    var initialSlide = param.initialSlide, gachas = param.gachas, onAfterChange = param.onAfterChange;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var swiperRef = (0,react.useRef)(null);
    if (!(gachas === null || gachas === void 0 ? void 0 : (ref = gachas.edges) === null || ref === void 0 ? void 0 : ref.length) || initialSlide === undefined) {
        return null;
    }
    var _mediumUri;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        in: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            ref: swiperRef,
            loop: false,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            initialSlide: initialSlide,
            enabled: gachas.edges.length > 1,
            onSwiper: function() {
                return onAfterChange(initialSlide);
            },
            onSlideChange: function(swiper) {
                return onAfterChange(swiper.activeIndex);
            },
            children: [
                gachas.edges.map(function(param, index) {
                    var node = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    height: "calc(100vw * 3 / 4)",
                                    maxHeight: "calc(600px * 3 / 4)",
                                    width: "100%",
                                    backgroundImage: 'url("'.concat((_mediumUri = node === null || node === void 0 ? void 0 : node.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : "", '")'),
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    backgroundSize: "cover"
                                }
                            }, node.id),
                            node.isSoldOut && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    top: 8,
                                    right: 8
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "white",
                                    sx: {
                                        bgcolor: "error.main",
                                        borderRadius: 1,
                                        py: 2,
                                        px: "10px"
                                    },
                                    children: t("soldOutLabel")
                                })
                            })
                        ]
                    }, index);
                }),
                (((ref1 = swiperRef.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.swiper) === null || ref2 === void 0 ? void 0 : ref2.activeIndex) || 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaSliderCell_PrevArrow, {
                    onClick: function() {
                        var ref;
                        return swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slidePrev();
                    }
                }),
                (((ref3 = swiperRef.current) === null || ref3 === void 0 ? void 0 : ref3.swiper.activeIndex) || 0) < gachas.edges.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaSliderCell_NextArrow, {
                    onClick: function() {
                        var ref;
                        return swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideNext();
                    }
                })
            ]
        })
    });
};
var GachaSliderCell_NextArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.ChevronRight, (0,src_object_spread/* default */.Z)({
        sx: {
            position: "absolute",
            top: "calc(50% - 15px)",
            right: 0,
            zIndex: 2,
            svg: {
                fontSize: "52px",
                color: "white"
            }
        }
    }, props));
};
var GachaSliderCell_PrevArrow = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.ChevronLeft, (0,src_object_spread/* default */.Z)({
        sx: {
            position: "absolute",
            top: "calc(50% - 15px)",
            left: 0,
            zIndex: 2,
            svg: {
                fontSize: "52px",
                color: "white"
            }
        }
    }, props));
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/GpsInformation.tsx










/**
 * @description
 * GPSガチャ用情報表示エリア
 */ var GpsInformation = function(param) {
    var gpsClientInfo = param.gpsClientInfo, gpsGachaData = param.gpsGachaData, isInside = param.isInside;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,react.useState)(false), openMap = ref[0], setOpenMap = ref[1];
    var ref1 = (0,react.useState)(false), openRequestPermission = ref1[0], setOpenRequestPermission = ref1[1];
    if (!gpsGachaData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        id: "gps-info-cell",
        alignItems: "center",
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.secondary",
                sx: {
                    pb: 2
                },
                children: t("gpsDescription")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        px: 3,
                        py: "6px",
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "grey.300",
                        borderRadius: "2px"
                    },
                    children: t("areaName", {
                        areaName: gpsGachaData === null || gpsGachaData === void 0 ? void 0 : gpsGachaData.approximateAddress
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative",
                    width: "100%"
                },
                children: [
                    gpsClientInfo.permission ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Zoom, {
                                size: "medium",
                                onClick: handleLoginModal(function() {
                                    setOpenMap(true);
                                }),
                                bgcolor: "grey.50",
                                color: "grey.600",
                                sx: {
                                    zIndex: 2,
                                    position: "absolute",
                                    right: 12,
                                    top: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    zIndex: 2,
                                    bottom: 12,
                                    left: "50%",
                                    transform: "translateX(-50%)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AreaStatusChip, {
                                        isInside: isInside
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapModal, {
                                        open: openMap,
                                        onClose: function() {
                                            return setOpenMap(false);
                                        },
                                        targetData: gpsGachaData,
                                        currentData: gpsClientInfo.currentLocation,
                                        isInside: isInside
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    zIndex: 1,
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    bgcolor: "rgba(0,0,0,0.72)"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    zIndex: 2,
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    sx: {
                                        height: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            align: "center",
                                            color: "white",
                                            children: t("notGpsPermission")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            sx: {
                                                my: 3
                                            },
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                                                fontSize: "large",
                                                color: "inherit"
                                            }),
                                            onClick: handleLoginModal(function() {
                                                (0,native_app/* openSetting */.as)({
                                                    webSetting: function() {
                                                        return setOpenRequestPermission(true);
                                                    }
                                                });
                                            }),
                                            children: t("toSetting")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (gpsGachaData === null || gpsGachaData === void 0 ? void 0 : gpsGachaData.latitude) && (gpsGachaData === null || gpsGachaData === void 0 ? void 0 : gpsGachaData.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMap, {
                        targetData: gpsGachaData,
                        currentData: gpsClientInfo.currentLocation,
                        mapContainerStyle: {
                            height: 250,
                            width: "100%"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestPermissionModal, {
                open: openRequestPermission,
                onClose: function() {
                    return setOpenRequestPermission(false);
                }
            })
        ]
    });
};
var AreaStatusChip = function(param) {
    var isInside = param.isInside;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            color: isInside ? "primary" : "error",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "white",
                children: isInside ? t("areaExist") : t("areaNotExist")
            }),
            sx: {
                height: 24
            }
        })
    });
};
var RequestPermissionModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Spot, {
                    sx: {
                        width: 60,
                        height: 60
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        py: 3
                    },
                    children: t("permissionModalTitle")
                })
            ]
        }),
        content: t("permissionModalContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                sx: {
                    minWidth: 212
                },
                variant: "text",
                color: "primary",
                size: "large",
                onClick: onClose,
                children: t("close")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/RemainingItemCount.tsx




/**
 * @description
 * 限定ガチャの在庫数表示用コンポーネント
 */ var RemainingItemCount = function(param) {
    var disabled = param.disabled, remainingLimitedItemCount = param.remainingLimitedItemCount, totalLimitedItemCount = param.totalLimitedItemCount, isLimited = param.isLimited;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    if (!isLimited || (0,individual/* individualHideGachaRemainingItemCount */.nm)()) return null;
    var textColor = disabled ? "text.hint" : remainingLimitedItemCount / totalLimitedItemCount < 0.2 ? "error.main" : "text.primary";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        sx: {
            py: 2
        },
        justifyContent: "flex-end",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: textColor,
                children: t("remain", "残り")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: textColor,
                children: [
                    remainingLimitedItemCount,
                    " / ",
                    totalLimitedItemCount
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "overline",
                color: textColor,
                children: t("remainUnit", "個")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/point/PointHeaderDisplay/index.tsx




var PointHeaderDisplay = function(param) {
    var point = param.point, _size = param.size, size = _size === void 0 ? "medium" : _size, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "flex-end",
        direction: "row",
        sx: (0,src_object_spread/* default */.Z)({
            position: "relative",
            bgcolor: size === "large" ? "transparent" : "grey.100",
            borderRadius: 3,
            height: 20,
            minWidth: size === "large" ? 100 : 64,
            px: 2
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: 36,
                    height: 32,
                    position: "absolute",
                    display: "grid",
                    placeItems: "center",
                    left: -12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                    fontSize: size
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                variant: size === "medium" ? "subtitle1" : "h1",
                children: point
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gacha/GachaTicketDisplay/HeaderDisplay.tsx




var HeaderDisplay = function(param) {
    var ticket = param.ticket, _size = param.size, size = _size === void 0 ? "medium" : _size, src = param.src, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "flex-end",
        direction: "row",
        sx: (0,src_object_spread/* default */.Z)({
            position: "relative",
            bgcolor: size === "large" ? "transparent" : "grey.100",
            borderRadius: 3,
            height: 20,
            minWidth: 56,
            px: 2
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: 36,
                    height: 32,
                    position: "absolute",
                    left: -12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.GachaTicketThumbnail, {
                    src: src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                variant: size === "medium" ? "subtitle1" : "h1",
                children: ticket
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/TriggerButtons.tsx






/**
 * @description
 * ガチャを回すボタン[単発, 10連]
 */ var TriggerButtons = function(param) {
    var loading = param.loading, isAccessible = param.isAccessible, isSoldOut = param.isSoldOut, isLimited = param.isLimited, onClickTrigger = param.onClickTrigger, gachaTicket = param.gachaTicket, gpsGachaData = param.gpsGachaData, price = param.price, remainingLimitedItemCount = param.remainingLimitedItemCount, _isPointOnly = param.isPointOnly, isPointOnly = _isPointOnly === void 0 ? false : _isPointOnly, isInside = param.isInside, isShowModalPersonalInfoRequire = param.isShowModalPersonalInfoRequire;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var ref = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)(), showUserInfoModal = ref.showModal;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        id: "gacha-draw-area",
        direction: "row",
        spacing: 5,
        children: [
            /**
         * 売り切れ状態の表示
         */ isSoldOut && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                fullWidth: true,
                disabled: true,
                sx: {
                    bgcolor: "grey.100",
                    height: 72,
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "grey.400",
                    children: t("soldOutBtn")
                })
            }),
            /**
         * 売り切れじゃないとき
         */ !isSoldOut && [
                1,
                10
            ].map(function(number, index) {
                var ref, ref1;
                /**
             * ポイントでしか引けないのガチャの場合
             */ if (isPointOnly) {
                    var requirePoint = (price !== null && price !== void 0 ? price : 0) * number;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GachaDrawButtonBase, {
                        disabled: !isAccessible || // ローディング中か
                        loading || // GPSガチャ且つ、範囲内にいるとき
                        !!gpsGachaData && !isInside || // 限定ガチャ且つ、引く個数分の在庫があるとき
                        isLimited && remainingLimitedItemCount < number,
                        onClick: handleLoginModal(function() {
                            isShowModalPersonalInfoRequire ? showUserInfoModal() : onClickTrigger(number);
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "inherit",
                                children: t("pullAround", {
                                    number: number
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointHeaderDisplay, {
                                point: requirePoint
                            })
                        ]
                    }, index);
                }
                var ref2;
                /**
             * ガチャチケット・ポイント両方で引けるガチャの場合
             */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GachaDrawButtonBase, {
                    disabled: !isAccessible || // ローディング中か
                    loading || // GPSガチャ且つ、範囲内にいるとき
                    !!gpsGachaData && !isInside || // 限定ガチャ且つ、引く個数分の在庫があるとき
                    isLimited && remainingLimitedItemCount < number,
                    onClick: handleLoginModal(function() {
                        isShowModalPersonalInfoRequire ? showUserInfoModal() : onClickTrigger(number);
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "inherit",
                            children: t("pullAround", {
                                number: number
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDisplay, {
                            src: (ref2 = gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref2 !== void 0 ? ref2 : "",
                            ticket: number
                        })
                    ]
                }, index);
            })
        ]
    });
};
/**
 * @description
 * 「ガチャを引く」ボタン用の共通ベースコンポーネント
 */ var GachaDrawButtonBase = function(param) {
    var disabled = param.disabled, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        disabled: disabled,
        fullWidth: true,
        onClick: onClick,
        variant: "contained",
        sx: {
            height: 72,
            borderRadius: 2,
            flexDirection: "column",
            color: "white",
            "&.Mui-disabled .MuiTypography-root": {
                color: "text.disabled"
            },
            "&.Mui-disabled>div": {
                bgcolor: "white"
            },
            "&.Mui-disabled img": {
                filter: "grayscale(95%) opacity(.55)"
            },
            "&.Mui-disabled svg.MuiSvgIcon-root": {
                filter: "grayscale(95%)"
            }
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/GachaBody/index.tsx


















/**
 * @description
 * ガチャの画像・情報・回すボタンの表示
 */ var GachaBody = function(param) {
    var artistId = param.artistId, artist = param.artist, available = param.available, loading = param.loading, initialSlide = param.initialSlide, currentGacha = param.currentGacha, gachas = param.gachas, gachaRolling = param.gachaRolling, gachaTicket = param.gachaTicket, gachaId = param.gachaId, gpsClientInfo = param.gpsClientInfo, user = param.user, onAfterChange = param.onAfterChange, onClickTrigger = param.onClickTrigger;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), openDrawer = ref3[0], setOpenDrawer = ref3[1];
    var _ref = (currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData) || {}, radius = _ref.radius, gachaGpsLocation = (0,_object_without_properties/* default */.Z)(_ref, [
        "radius"
    ]);
    var isInside = useIsInside({
        locations: [
            gachaGpsLocation,
            gpsClientInfo.currentLocation
        ],
        radius: currentGacha === null || currentGacha === void 0 ? void 0 : (ref = currentGacha.gpsData) === null || ref === void 0 ? void 0 : ref.radius
    }).isInside;
    var ref4 = (0,react.useMemo)(function() {
        var product = (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(artist, currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.planId);
        return {
            productTitle: product === null || product === void 0 ? void 0 : product.title,
            membershipType: product ? "planOnly" : "allMembership"
        };
    }, [
        artist,
        currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.planId
    ]), membershipType = ref4.membershipType, productTitle = ref4.productTitle;
    var isShowModalPersonalInfoRequire = !!((currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isPremium) && (artist === null || artist === void 0 ? void 0 : (ref1 = artist.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired) && (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired));
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBody_LoadingCell, {});
    if (!available || !(gachas === null || gachas === void 0 ? void 0 : (ref2 = gachas.edges) === null || ref2 === void 0 ? void 0 : ref2.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCell, {});
    if (initialSlide === undefined) return null;
    var ref5, ref6, ref7, ref8, ref9, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaSliderCell, {
                initialSlide: initialSlide,
                onAfterChange: onAfterChange,
                gachas: gachas
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pt: 3,
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaInformation, {
                        artistId: artistId,
                        gachaId: gachaId,
                        endAt: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.formattedEndAt,
                        deliveryDateText: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.deliveryDateText,
                        onClickDetail: function() {
                            return setOpenDrawer(true);
                        }
                    }),
                    !(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isAccessible) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivationMemberCell, {
                        artistId: artistId,
                        artist: artist,
                        type: membershipType,
                        productTitle: productTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsInformation, {
                        gpsClientInfo: gpsClientInfo,
                        gpsGachaData: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData,
                        isInside: isInside
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            px: 5,
                            pt: 5
                        },
                        children: [
                            (currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isPremium) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaMembershipTag, {
                                    type: membershipType
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerButtons, {
                                loading: gachaRolling,
                                isAccessible: !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isAccessible),
                                isSoldOut: !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isSoldOut),
                                isLimited: !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isLimited),
                                price: (ref5 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.price) !== null && ref5 !== void 0 ? ref5 : 0,
                                remainingLimitedItemCount: (ref6 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.remainingLimitedItemCount) !== null && ref6 !== void 0 ? ref6 : 0,
                                gachaTicket: gachaTicket,
                                gpsGachaData: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData,
                                isPointOnly: (currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gachaRollType) === utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint,
                                isInside: isInside,
                                isShowModalPersonalInfoRequire: isShowModalPersonalInfoRequire,
                                onClickTrigger: onClickTrigger
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingItemCount, {
                                isLimited: !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isLimited),
                                disabled: !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.isSoldOut) || !!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData) && !isInside,
                                remainingLimitedItemCount: (ref7 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.remainingLimitedItemCount) !== null && ref7 !== void 0 ? ref7 : 0,
                                totalLimitedItemCount: (ref8 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.totalLimitedItemCount) !== null && ref8 !== void 0 ? ref8 : 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionDrawer, {
                        open: openDrawer,
                        onClose: function() {
                            return setOpenDrawer(false);
                        },
                        name: (ref9 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.name) !== null && ref9 !== void 0 ? ref9 : "",
                        endAt: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.formattedEndAt,
                        deliveryDateText: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.deliveryDateText,
                        desc: (ref10 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.description) !== null && ref10 !== void 0 ? ref10 : ""
                    })
                ]
            })
        ]
    });
};
/**
 * ガチャのデータが空の時に表示する
 */ var EmptyCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 6,
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            color: "text.secondary",
            align: "center",
            children: t("gachaEmptyMessage")
        })
    });
};
/**
 * ローディング中に表示する
 */ var GachaBody_LoadingCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 315,
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        sx: {
                            mt: 2,
                            mb: 5,
                            px: 5,
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                alignItems: "flex-end",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            size: "small",
                                            children: t("detail")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            variant: "outlined",
                                            size: "small",
                                            children: t("emissionList")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        sx: {
                            py: 2
                        },
                        children: [
                            0,
                            1
                        ].map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                alignItems: "center",
                                sx: {
                                    height: 72,
                                    borderRadius: 2,
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    width: "50%",
                                    sx: {
                                        mt: 3
                                    }
                                })
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 4
                        },
                        alignItems: "flex-end",
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "30%"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gacha/GachaTicketDisplay/Display.tsx



var Display = function(param) {
    var ticket = param.ticket, src = param.src, variant = param.variant, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        direction: "row",
        sx: {
            borderRadius: 3,
            height: 40,
            minWidth: 76
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    mr: 2,
                    mt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.GachaTicketThumbnail, {
                    src: src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                variant: variant || "h4",
                children: ticket
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/PurchaseGachaTicketDrawer.tsx















/**
 * @description
 * チケット購入用アクションシート
 */ var PurchaseGachaTicketDrawer = function(param) {
    var ticket = param.ticket, onClose = param.onClose, gachaId = param.gachaId, artistId = param.artistId, prepaidPointBalance = param.prepaidPointBalance, purchasableGachaTickets = param.purchasableGachaTickets, gachaTicket = param.gachaTicket, open = param.open, setOpenTicketPurchaseConfirmModal = param.setOpenTicketPurchaseConfirmModal, setPurchasableGachaTicket = param.setPurchasableGachaTicket, setOpenPointCharge = param.setOpenPointCharge;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var handleClickGachaTicket = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newPurchasableGachaTicket) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setPurchasableGachaTicket(newPurchasableGachaTicket);
                setOpenTicketPurchaseConfirmModal(true);
                return [
                    2
                ];
            });
        });
        return function(newPurchasableGachaTicket) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
                styles: {
                    "ion-modal#purchaseGachaTicketDrawer": {
                        "--height": "auto"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* IonModal */.ki, {
                className: "parent-modal",
                isOpen: open,
                onDidDismiss: onClose,
                initialBreakpoint: 1,
                breakpoints: [
                    0,
                    1
                ],
                id: "purchaseGachaTicketDrawer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                    sx: {
                        bgcolor: "grey.50",
                        px: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                py: 2
                            },
                            children: t("buyTicket")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                                            ticket: ticket !== null && ticket !== void 0 ? ticket : 0,
                                            src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                            point: (ref2 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref2 !== void 0 ? ref2 : 0,
                                            sx: {
                                                ml: 3
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    color: "primary",
                                    variant: "contained",
                                    size: "small",
                                    onClick: function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_getPrepaidPoint", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            name: "gachaDetail",
                                            gachaId: gachaId,
                                            artistId: artistId,
                                            prepaidPointId: prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.prepaidPointId,
                                            type: "bottomsheet"
                                        });
                                        setOpenPointCharge();
                                    },
                                    sx: {
                                        height: 28
                                    },
                                    children: t("buyPoints")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketChargeButtonCell, {
                            purchasableGachaTickets: purchasableGachaTickets,
                            onPurchaseGachaTicket: handleClickGachaTicket,
                            gachaTicket: gachaTicket
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                width: "fit-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                                variant: "caption",
                                href: (0,helpUrl/* getHelpUrl */.R)("specifiedCommercialTransactionLaw"),
                                sx: {
                                    my: 4
                                },
                                children: t("commercialTransactionLaw")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: onClose,
                            variant: "text",
                            fullWidth: true,
                            sx: {
                                borderRadius: 2,
                                height: 40
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                color: "primary",
                                children: t("cancel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var _displayCount, _prepaidPoints;
var TicketChargeButtonCell = function(param) {
    var purchasableGachaTickets = param.purchasableGachaTickets, onPurchaseGachaTicket = param.onPurchaseGachaTicket, gachaTicket = param.gachaTicket;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 4,
            children: purchasableGachaTickets.map(function(purchasableGachaTicket, index) {
                var ref, ref1;
                return purchasableGachaTicket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    onClick: function() {
                        return onPurchaseGachaTicket(purchasableGachaTicket);
                    },
                    variant: "contained",
                    fullWidth: true,
                    sx: {
                        bgcolor: "grey.100",
                        justifyContent: "space-between",
                        borderRadius: 2,
                        height: 56
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDisplay, {
                            ticket: (_displayCount = purchasableGachaTicket.displayCount) !== null && _displayCount !== void 0 ? _displayCount : 0,
                            src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                            point: (_prepaidPoints = purchasableGachaTicket.prepaidPoints) !== null && _prepaidPoints !== void 0 ? _prepaidPoints : 0
                        })
                    ]
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/Modals/ConfirmTicketChargeModal.tsx




/**
 * @description
 * チケット購入時に表示するモーダル
 */ var ConfirmTicketChargeModal = function(param) {
    var loading = param.loading, open = param.open, count = param.count, price = param.price, onClose = param.onClose, onConfirm = param.onConfirm;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IonInformationModal/* IonInformationModal */.S, {
        open: open,
        onClose: onClose,
        title: t("purchaseConfirmTitle"),
        content: t("purchaseConfirmDesc", {
            count: count,
            price: price
        }),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            loading: loading,
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onConfirm,
            children: t("toBuy")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/Modals/CompleteTicketChargeModal.tsx




/**
 * @description
 * チケット購入後に表示するモーダル
 */ var CompleteTicketChargeModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IonInformationModal/* IonInformationModal */.S, {
        open: open,
        onClose: onClose,
        title: t("purchaseCompleteTitle"),
        content: t("purchaseCompleteDesc"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: t("ok")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/Modals/ErrorTicketChargeModal.tsx






/**
 * @description
 * ポイント不足でチケットが購入できなかった際に表示されるモーダル
 */ var ErrorTicketChargeModal = function(param) {
    var open = param.open, onClose = param.onClose, prepaidPointId = param.prepaidPointId, gachaId = param.gachaId, artistId = param.artistId, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IonInformationModal/* IonInformationModal */.S, {
        open: open,
        onClose: onClose,
        title: t("purchaseErrorTitle"),
        content: t("purchaseErrorDesc"),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: function() {
                onClick();
                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_getPrepaidPoint", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    name: "gachaDetail",
                    prepaidPointId: prepaidPointId,
                    gachaId: gachaId,
                    artistId: artistId,
                    type: "modal"
                });
            },
            children: t("buyPoints")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/Modals/ConfirmPointChargeModal.tsx




/**
 * @description
 * ポイント不足時にポイント購入を促すモーダル
 */ var PointInsufficientModal = function(param) {
    var open = param.open, onClose = param.onClose, onConfirm = param.onConfirm;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IonInformationModal/* IonInformationModal */.S, {
        open: open,
        onClose: onClose,
        title: t("purchasePointConfirmTitle"),
        content: t("purchasePointConfirmDesc"),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onConfirm,
            children: t("toBuy")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gacha/ConfirmationRollGachaByTicketModal/index.tsx




/**
 * @description
 * ガチャを引く確定モーダル（チケット用）
 */ var ConfirmationRollGachaByTicketModal = function(param) {
    var open = param.open, onClose = param.onClose, count = param.count, gachaRolling = param.gachaRolling, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("confirmRollGachaTitle"),
        content: t("confirmRollGachaDesc", {
            number: count
        }),
        cancelText: t("close"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            disabled: gachaRolling,
            loading: gachaRolling,
            onClick: onClick,
            children: t("draw")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gacha/ConfirmationRollGachaByPointModal/index.tsx




var ConfirmationRollGachaByPointModal = function(param) {
    var open = param.open, onClose = param.onClose, price = param.price, count = param.count, gachaRolling = param.gachaRolling, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("confirmRollGachaByPointTitle"),
        content: t("confirmRollGachaByPointDesc", {
            price: price,
            number: count
        }),
        cancelText: t("close"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            disabled: gachaRolling,
            loading: gachaRolling,
            onClick: onClick,
            children: t("draw")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gacha/InsufficientGachaTicketModal/index.tsx





/**
 * @description
 * ガチャチケ・ポイント量対応のガチャで、ガチャチケ不足時にポイントでガチャを引けるモーダル
 */ var InsufficientGachaTicketModal = function(param) {
    var open = param.open, onClose = param.onClose, point = param.point, prepaidPointBalance = param.prepaidPointBalance, onClick = param.onClick, gachaRolling = param.gachaRolling, disabled = param.disabled;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("insufficientGachaTicketTitle"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                pb: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        pb: 8
                    },
                    children: t("insufficientGachaTicketContent")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PointHeaderDisplay, {
                    size: "large",
                    point: point,
                    sx: {
                        alignSelf: "center",
                        mb: 4
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    children: t("prepaidPointBalance", {
                        prepaidPointBalance: prepaidPointBalance
                    })
                })
            ]
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            loading: gachaRolling,
            sx: {
                minWidth: 200
            },
            onClick: onClick,
            disabled: disabled,
            children: t("draw")
        }),
        cancelText: t("close")
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/SkipButton.tsx



var SkipButton = function(param) {
    var onSkip = param.onSkip;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 13,
            pointerEvents: "none",
            maxWidth: "600px",
            px: 4,
            py: 4,
            display: "grid",
            placeContent: "end",
            alignItems: "end"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            onClick: onSkip,
            variant: "text",
            sx: {
                pointerEvents: "auto",
                color: "text.hint"
            },
            children: t("skip", "スキップ")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/components/StandbyTrigger.tsx
/**
 * スタンバイ中のガチャのスワイパー
 * 左から右にスワイプすることでガチャ動画を再生する
 */ 







var StandbyTrigger = function(param) {
    var onPlay = param.onPlay;
    var handlers = (0,es/* useSwipeable */.QS)({
        onSwipedRight: onPlay,
        trackMouse: !(0,StyleProvider/* isMobileDevice */.s2)(),
        delta: 120
    });
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        if (!mounted) {
            setTimeout(function() {
                setMounted(true) // 0.5秒後に表示
                ;
            }, 500);
        }
    }, [
        mounted
    ]);
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            maxWidth: "600px",
            zIndex: 11,
            pointerEvents: "none",
            px: "7.5%",
            py: "80px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            sx: {
                height: "100%",
                display: "grid",
                placeItems: "center",
                pointerEvents: "auto"
            }
        }, handlers), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                in: true,
                timeout: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SwipeGuide, {
                        iconProps: {
                            sx: {
                                width: 115,
                                height: 115,
                                position: "relative",
                                left: "-70px",
                                top: "16px"
                            }
                        }
                    })
                })
            })
        }))
    });
};
var AnimationWrapper = (0,styled/* default */.ZP)("div")({
    animation: "axis 2s infinite linear",
    "@keyframes axis": {
        "0%": {
            transform: "translateX(0) translateY(0)",
            opacity: 0
        },
        "10%": {
            transform: "translateX(0) translateY(0)"
        },
        "15%": {
            opacity: 1
        },
        "20%": {
            transform: "translateX(-25px) translateY(-25px)",
            opacity: 1
        },
        "25%": {
            transform: "translateX(-30px) translateY(-28px)",
            opacity: 1
        },
        "30%": {
            transform: "translateX(-30px) translateY(-30px)",
            opacity: 1
        },
        "50%": {
            transform: "translateX(130px) translateY(-40px)"
        },
        "60%": {
            transform: "translateX(130px) translateY(-40px)",
            opacity: 0.5
        },
        "75%": {
            transform: "translateX(130px) translateY(-40px)",
            opacity: 0
        },
        "100%": {
            transform: "translateX(130px) translateY(-40px)",
            opacity: 0
        }
    }
});

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/index.tsx















/**
 * ガチャ詳細ページ
 * デザイン
 * https://zpl.io/VDgN4LO
 */ var GachaDetailTemplate = function(param) {
    var state = param.state, handleAfterChange = param.handleAfterChange, handlePurchaseGachaTicket = param.handlePurchaseGachaTicket, handlePurchasePoint = param.handlePurchasePoint, handleClickGachaTrigger = param.handleClickGachaTrigger, handleRollGachaByTicket = param.handleRollGachaByTicket, handleRollGachaByPoint = param.handleRollGachaByPoint, onCancelPurchaseGachaTicket = param.onCancelPurchaseGachaTicket, onCancelPurchaseErrorGachaTicket = param.onCancelPurchaseErrorGachaTicket, onCancelPurchaseGachaTicketModal = param.onCancelPurchaseGachaTicketModal, onSkip = param.onSkip, setOpenSideMenu = param.setOpenSideMenu, setOpenGachaTicketPurchaseDrawer = param.setOpenGachaTicketPurchaseDrawer, setOpenPointPurchaseDrawer = param.setOpenPointPurchaseDrawer, setOpenConfirmByTicket = param.setOpenConfirmByTicket, setOpenConfirmByPoint = param.setOpenConfirmByPoint, setOpenInsufficientTicket = param.setOpenInsufficientTicket, setOpenInsufficientPointModal = param.setOpenInsufficientPointModal, setOpenTicketPurchaseConfirmModal = param.setOpenTicketPurchaseConfirmModal, setOpenTicketPurchaseCompleteModal = param.setOpenTicketPurchaseCompleteModal, setPurchasableGachaTicket = param.setPurchasableGachaTicket, handleRollGachaAfterStandingby = param.handleRollGachaAfterStandingby;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    var ref31 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref31.routerPages, generatePath = ref31.generatePath, router = ref31.router;
    // currentGacha が null の場合最新のガチャに遷移する
    if (state.currentGacha === null && !state.loading && state.artistId) {
        router.replace(generatePath(routerPages[state.latestGacha ? "ArtistGachaDetailLatest" : "ArtistGachas"], {
            artistId: state.artistId
        }));
        return null;
    }
    /**
   *  Apngアニメーション再生コンポーネント
   */ if (state.apngAnimationPlaying) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenAnimationCell, {
                ref: state.apngFullScreenRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipButton, {
                onSkip: onSkip
            })
        ]
    });
    var ref32, ref33, _currentGacha, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "artist",
                    props: {
                        isLive: !!state.liveStreamId,
                        hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                        unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount
                    }
                },
                // fixed issue scroll on PC
                sx: {
                    height: "100vh"
                },
                header: {
                    title: (ref2 = state.currentGacha) === null || ref2 === void 0 ? void 0 : ref2.name,
                    left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                        edge: "start",
                        onClick: function() {
                            return setOpenSideMenu(!state.openSideMenu);
                        },
                        color: "icon.line",
                        bgcolor: "icon.background",
                        badge: ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount)
                    }),
                    right: ((ref5 = state.currentGacha) === null || ref5 === void 0 ? void 0 : ref5.isAccessible) && /**
             * ヘッダー右上でポイントまたはチケットを購入できる導線
             */ /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPurchase, {
                        available: !!state.user && !!state.currentGacha,
                        type: (ref6 = state.currentGacha) === null || ref6 === void 0 ? void 0 : ref6.gachaRollType,
                        point: (ref32 = (ref7 = state.prepaidPointBalance) === null || ref7 === void 0 ? void 0 : ref7.formattedPrepaidPointBarance) !== null && ref32 !== void 0 ? ref32 : 0,
                        onClickPoint: function() {
                            return setOpenPointPurchaseDrawer(true);
                        },
                        ticket: (ref33 = state === null || state === void 0 ? void 0 : state.ticket) !== null && ref33 !== void 0 ? ref33 : "",
                        onClickGachaTicket: function() {
                            return setOpenGachaTicketPurchaseDrawer(true);
                        },
                        isGachaTicketPurchasable: !!(state === null || state === void 0 ? void 0 : (ref8 = state.gachaTicket) === null || ref8 === void 0 ? void 0 : ref8.isPurchasable),
                        gachaTicketThumbnail: ((ref9 = state.gachaTicket) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.thumbnails) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.standard) === null || ref11 === void 0 ? void 0 : ref11.smallUri) || ""
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                        title: state.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                        followArtists: state.followArtists,
                        memberArtists: state.memberArtists,
                        open: state.openSideMenu,
                        onClose: function() {
                            return setOpenSideMenu(false);
                        },
                        user: state.user,
                        isArtist: state.isArtist
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBody, {
                        available: state.loading || !!state.latestGacha || !!state.initialSlide,
                        artistId: state.artistId,
                        artist: state.artist,
                        loading: state.loading,
                        initialSlide: state.initialSlide,
                        currentGacha: (_currentGacha = state.currentGacha) !== null && _currentGacha !== void 0 ? _currentGacha : null,
                        gachas: state.gachas,
                        gachaRolling: state.gachaRolling,
                        gachaTicket: state.gachaTicket,
                        gachaId: (ref35 = (ref34 = (ref12 = state.currentGacha) === null || ref12 === void 0 ? void 0 : ref12.id) !== null && ref34 !== void 0 ? ref34 : (ref13 = state.latestGacha) === null || ref13 === void 0 ? void 0 : ref13.id) !== null && ref35 !== void 0 ? ref35 : "",
                        gpsClientInfo: state.gpsClientInfo,
                        user: state.user,
                        onAfterChange: handleAfterChange,
                        onClickTrigger: handleClickGachaTrigger
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseGachaTicketDrawer, {
                        ticket: (ref36 = state === null || state === void 0 ? void 0 : state.ticket) !== null && ref36 !== void 0 ? ref36 : 0,
                        onClose: onCancelPurchaseGachaTicket,
                        gachaId: (ref38 = (ref37 = (ref14 = state.currentGacha) === null || ref14 === void 0 ? void 0 : ref14.id) !== null && ref37 !== void 0 ? ref37 : (ref15 = state.latestGacha) === null || ref15 === void 0 ? void 0 : ref15.id) !== null && ref38 !== void 0 ? ref38 : "",
                        artistId: (ref39 = (ref16 = state.currentGacha) === null || ref16 === void 0 ? void 0 : ref16.artistId) !== null && ref39 !== void 0 ? ref39 : "",
                        prepaidPointBalance: state.prepaidPointBalance,
                        purchasableGachaTickets: (ref40 = (ref17 = state.currentGacha) === null || ref17 === void 0 ? void 0 : ref17.purchasableGachaTickets) !== null && ref40 !== void 0 ? ref40 : [],
                        gachaTicket: state.gachaTicket,
                        open: state.initialSlide !== undefined && state.openGachaTicketPurchaseDrawer,
                        setOpenTicketPurchaseConfirmModal: setOpenTicketPurchaseConfirmModal,
                        setOpenPointCharge: function() {
                            return setOpenPointPurchaseDrawer(true);
                        },
                        setPurchasableGachaTicket: setPurchasableGachaTicket
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeDrawer, {
                        point: (ref41 = (ref18 = state.prepaidPointBalance) === null || ref18 === void 0 ? void 0 : ref18.balance) !== null && ref41 !== void 0 ? ref41 : 0,
                        onPurchase: function(plan, paymentMethod) {
                            return handlePurchasePoint(plan, paymentMethod, {
                                // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                                successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistGachaDetail, {
                                    artistId: router.query.artistId,
                                    gachaId: router.query.gachaId
                                }), "?points=").concat(plan.points),
                                // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                                cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.ArtistGachaDetail, {
                                    artistId: router.query.artistId,
                                    gachaId: router.query.gachaId
                                })),
                                // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                                errorUrl: "".concat(window.location.origin, "/").concat(generatePath(routerPages.ArtistGachaDetail, {
                                    artistId: router.query.artistId,
                                    gachaId: router.query.gachaId
                                }))
                            });
                        },
                        open: state.initialSlide !== undefined && state.openPointPurchaseDrawer,
                        purchasablePrepaidPoints: state.purchasablePrepaidPoints,
                        onClose: function() {
                            setOpenPointPurchaseDrawer(false);
                        },
                        loading: state.loading,
                        chargeLoading: state.pointChargeLoading,
                        paymentSource: state.paymentSource,
                        enablePointCarrierPayment: state.enablePointCarrierPayment,
                        pageName: "gachaDetail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmTicketChargeModal, {
                        loading: state.gachaTicketPurchasing,
                        open: state.openTicketPurchaseConfirmModal,
                        onClose: onCancelPurchaseGachaTicketModal,
                        count: (ref42 = (ref19 = state.purchasableGachaTicket) === null || ref19 === void 0 ? void 0 : ref19.count) !== null && ref42 !== void 0 ? ref42 : 0,
                        price: (ref43 = (ref20 = state.purchasableGachaTicket) === null || ref20 === void 0 ? void 0 : ref20.price) !== null && ref43 !== void 0 ? ref43 : 0,
                        onConfirm: handlePurchaseGachaTicket
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteTicketChargeModal, {
                        open: state.openTicketPurchaseCompleteModal,
                        onClose: function() {
                            setOpenTicketPurchaseCompleteModal(false);
                            setOpenGachaTicketPurchaseDrawer(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTicketChargeModal, {
                        gachaId: (ref45 = (ref44 = (ref21 = state.currentGacha) === null || ref21 === void 0 ? void 0 : ref21.id) !== null && ref44 !== void 0 ? ref44 : (ref22 = state.latestGacha) === null || ref22 === void 0 ? void 0 : ref22.id) !== null && ref45 !== void 0 ? ref45 : "",
                        artistId: (ref46 = (ref23 = state.currentGacha) === null || ref23 === void 0 ? void 0 : ref23.artistId) !== null && ref46 !== void 0 ? ref46 : "",
                        prepaidPointId: (ref47 = (ref24 = state.prepaidPointBalance) === null || ref24 === void 0 ? void 0 : ref24.prepaidPointId) !== null && ref47 !== void 0 ? ref47 : "",
                        open: state.openTicketPurchaseErrorModal,
                        onClick: function() {
                            onCancelPurchaseErrorGachaTicket();
                            setOpenPointPurchaseDrawer(true);
                        },
                        onClose: onCancelPurchaseErrorGachaTicket
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointInsufficientModal, {
                        open: state.openInsufficientPointModal,
                        onClose: function() {
                            return setOpenInsufficientPointModal(false);
                        },
                        onConfirm: function() {
                            setOpenConfirmByPoint(false);
                            setOpenPointPurchaseDrawer(true);
                            setOpenInsufficientPointModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationRollGachaByTicketModal, {
                        open: state.openConfirmByTicket,
                        onClose: function() {
                            return setOpenConfirmByTicket(false);
                        },
                        gachaRolling: state === null || state === void 0 ? void 0 : state.gachaRolling,
                        onClick: handleRollGachaByTicket,
                        count: state.gachaCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationRollGachaByPointModal, {
                        open: state.openConfirmByPoint,
                        onClose: function() {
                            return setOpenConfirmByPoint(false);
                        },
                        gachaRolling: state === null || state === void 0 ? void 0 : state.gachaRolling,
                        onClick: handleRollGachaByPoint,
                        price: ((ref48 = (ref25 = state.currentGacha) === null || ref25 === void 0 ? void 0 : ref25.price) !== null && ref48 !== void 0 ? ref48 : 0) * state.gachaCount,
                        count: state.gachaCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsufficientGachaTicketModal, {
                        open: state.openInsufficientTicket,
                        onClose: function() {
                            return setOpenInsufficientTicket(false);
                        },
                        point: ((ref49 = (ref26 = state.currentGacha) === null || ref26 === void 0 ? void 0 : ref26.price) !== null && ref49 !== void 0 ? ref49 : 0) * state.gachaCount,
                        prepaidPointBalance: (ref50 = (ref27 = state.prepaidPointBalance) === null || ref27 === void 0 ? void 0 : ref27.balance) !== null && ref50 !== void 0 ? ref50 : 0,
                        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            var ref, ref1, ref2, ref3;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (((ref2 = (ref = state.currentGacha) === null || ref === void 0 ? void 0 : ref.price) !== null && ref2 !== void 0 ? ref2 : 0) > ((ref3 = (ref1 = state.prepaidPointBalance) === null || ref1 === void 0 ? void 0 : ref1.balance) !== null && ref3 !== void 0 ? ref3 : 0)) {
                                            setOpenInsufficientTicket(false);
                                            setOpenConfirmByPoint(true);
                                            return [
                                                2
                                            ];
                                        }
                                        return [
                                            4,
                                            handleRollGachaByPoint()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        gachaRolling: state.gachaRolling
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* LoadingWithBackdrop */.W, {
                        open: state.gachaRolling
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFullScreen, {
                ref: state.videoFullscreenRef,
                shouldMute: state.isSafari && !((ref28 = state.currentGacha) === null || ref28 === void 0 ? void 0 : ref28.standByAnimations),
                sx: {
                    zIndex: 11
                }
            }),
            !!((ref29 = state.currentGacha) === null || ref29 === void 0 ? void 0 : ref29.standByAnimations) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFullScreen, {
                ref: state.standbyVideoFullscreenRef,
                shouldMute: false,
                sx: {
                    zIndex: 10
                }
            }),
            !!((ref30 = state.currentGacha) === null || ref30 === void 0 ? void 0 : ref30.standByAnimations) && state.standingBy && /*#__PURE__*/ (0,jsx_runtime.jsx)(StandbyTrigger, {
                onPlay: handleRollGachaAfterStandingby
            }),
            state.playingAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipButton, {
                onSkip: onSkip
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@sentry/capacitor/dist/esm/index.js + 179 modules
var capacitor_dist_esm = __webpack_require__(2528);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/build/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(48485);
// EXTERNAL MODULE: ../../node_modules/apng-js/lib/index.js
var apng_js_lib = __webpack_require__(63124);
var lib_default = /*#__PURE__*/__webpack_require__.n(apng_js_lib);
;// CONCATENATED MODULE: ./src/components/lib/animation/useApingAnimation.tsx






/**
 * @deprecated remove when animation type changed to video
 */ function useApngAnimation(param) {
    var url = param.url;
    var ref = useState(null), apng = ref[0], setApng = ref[1];
    var ref1 = useState(false), playing = ref1[0], setPlaying = ref1[1];
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    var ref3 = useRef(null);
    /**
   * アニメーション画像(apng)を取得
   */ useEffect(function() {
        if (!url) return;
        setError(null);
        generateApng(url).then(function(apng) {
            return setApng(apng);
        }).catch(function(e) {
            captureError(e, "useApngAnimationGenerateApng");
            setError(e);
        });
    }, [
        url
    ]);
    var play = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!apng) throw new Error("the apng file cannot be played.");
                        return [
                            4,
                            setPlaying(true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            playApngAnimation(ref3, apng).then(function(result) {
                                setPlaying(false);
                                return result;
                            })// エラーが出た場合、プレイヤーの停止
                            .catch(function(e) {
                                captureError(e, "useApngAnimationPlayAnimation");
                                setError(e);
                                setPlaying(false);
                            })
                        ];
                }
            });
        });
        return function play() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        error: error,
        playing: playing,
        play: play,
        ref: ref3
    };
}
/**
 * アニメーションの再生
 *
 * @deprecated remove when animation type changed to video
 *
 * @param ref
 * @param apng
 * @returns player
 */ function playApngAnimation(ref, apng) {
    return _playApngAnimation.apply(this, arguments);
}
function _playApngAnimation() {
    _playApngAnimation = (0,src_async_to_generator/* default */.Z)(function(ref, apng) {
        var ctx;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!(ref === null || ref === void 0 ? void 0 : ref.current)) return [
                2
            ];
            ctx = ref.current.getContext("2d");
            if (!ctx) return [
                2
            ];
            return [
                2,
                new Promise(function(res, rej) {
                    apng.getPlayer(ctx).then(function(player) {
                        player.removeAllListeners("end");
                        // stop and rewind at the beginning on every time
                        player.stop();
                        player.on("end", function() {
                            res(player);
                        });
                        player.play();
                    });
                })
            ];
        });
    });
    return _playApngAnimation.apply(this, arguments);
}
/**
 * Apngオブジェクトの生成
 *
 * @deprecated remove when animation type changed to video
 * @param url
 * @returns
 */ function generateApng(url) {
    return fetch(url).then(function(res) {
        return res.arrayBuffer();
    }).then(function(buffer) {
        var parseResult = lib_default()(buffer);
        if ((0,_instanceof/* default */.Z)(parseResult, Error)) throw parseResult;
        return parseResult;
    });
}

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/template/templateStore.ts

















/**
 * @description
 * viewModelの状態とテンプレートの状態・挙動を合わせて管理するフック
 */ var useTemplateStore = function(param) {
    var state = param.state, actions = param.actions;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), router = ref7.router, routerPages = ref7.routerPages, generatePath = ref7.generatePath, routerNames = ref7.routerNames;
    var ref8 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref8.showMessage, showError = ref8.showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var rollingGachaTransactionRef = (0,react.useRef)(null);
    /** サイドメニュー開閉状態 */ var ref9 = (0,react.useState)(false), openSideMenu = ref9[0], setOpenSideMenu = ref9[1];
    /** ガチャチケット購入のドロワー表示状態 */ var ref10 = (0,react.useState)(false), openGachaTicketPurchaseDrawer = ref10[0], setOpenGachaTicketPurchaseDrawer = ref10[1];
    /** ポイントチャージ用ドロワーの表示状態 */ var ref11 = (0,react.useState)(false), openPointPurchaseDrawer = ref11[0], setOpenPointPurchaseDrawer = ref11[1];
    /** チケットでガチャを回すことを確認するモーダルの表示状態 */ var ref12 = (0,react.useState)(false), openConfirmByTicket = ref12[0], setOpenConfirmByTicket = ref12[1];
    /** ポイントでガチャを回すことを確認するモーダルの表示状態 */ var ref13 = (0,react.useState)(false), openConfirmByPoint = ref13[0], setOpenConfirmByPoint = ref13[1];
    /** チケット・ポイント両対応のガチャで、ガチャチケ不足時にポイントでガチャを引けるモーダルの表示状態 */ var ref14 = (0,react.useState)(false), openInsufficientTicket = ref14[0], setOpenInsufficientTicket = ref14[1];
    /**
   * ポイントでガチャを引く際に、ポイントが不足している場合に表示されるモーダルの表示状態
   */ var ref15 = (0,react.useState)(false), openInsufficientPointModal = ref15[0], setOpenInsufficientPointModal = ref15[1];
    /** チケット購入時に表示されるモーダルの表示状態 */ var ref16 = (0,react.useState)(false), openTicketPurchaseConfirmModal = ref16[0], setOpenTicketPurchaseConfirmModal = ref16[1];
    /** チケット購入後に表示されるモーダルの表示状態 */ var ref17 = (0,react.useState)(false), openTicketPurchaseCompleteModal = ref17[0], setOpenTicketPurchaseCompleteModal = ref17[1];
    /** チケット購入エラーが発生した時のモーダルの表示状態 */ var ref18 = (0,react.useState)(false), openTicketPurchaseErrorModal = ref18[0], setOpenTicketPurchaseErrorModal = ref18[1];
    /** ガチャチケット購入時、購入するチケットの枚数の状態 */ var ref19 = (0,react.useState)(null), purchasableGachaTicket = ref19[0], setPurchasableGachaTicket = ref19[1];
    /** ガチャを回す際、それが1回まわすものか10連ガチャかどうかの状態(number) */ var ref20 = (0,react.useState)(0), gachaCount = ref20[0], setGachaCount = ref20[1];
    /** ガチャを回している状態かどうか */ var ref21 = (0,react.useState)(false), gachaRolling = ref21[0], setGachaRolling = ref21[1];
    /** スタンバイ状態かどうか */ var ref22 = (0,react.useState)(false), standingBy = ref22[0], setStandingBy = ref22[1];
    /** スタンバイ・本動画含めて動画を再生している時間かどうか */ var ref23 = (0,react.useState)(false), playingAnimation = ref23[0], setPlayingAnimation = ref23[1];
    /** 動画スキップ処理 */ var ref24 = (0,react.useState)({
        fn: function fn() {}
    }), handleSkip = ref24[0], setHandleSkip = ref24[1];
    var lastGachaOrderIdRef = (0,react.useRef)();
    /** ガチャ一覧の先頭、ルーティングが/gachas/latestの時に遷移するもの */ var latestGacha = ((ref = state.gachas) === null || ref === void 0 ? void 0 : ref.edges.length) ? (ref1 = state.gachas) === null || ref1 === void 0 ? void 0 : ref1.edges[0].node : null;
    /** 現在カルーセル表示しているガチャのインデックス番号 */ var initialSlide = (0,react.useMemo)(function() {
        var ref;
        if (!((ref = state.gachas) === null || ref === void 0 ? void 0 : ref.edges)) return;
        if (state.gachaId === "latest") return 0;
        return state.gachas.edges.findIndex(function(param) {
            var node = param.node;
            return node.id === state.gachaId;
        });
    }, [
        latestGacha === null || latestGacha === void 0 ? void 0 : latestGacha.id,
        state.gachaId,
        state === null || state === void 0 ? void 0 : (ref2 = state.gachas) === null || ref2 === void 0 ? void 0 : ref2.edges
    ]);
    /** 現在カルーセルで表示しているガチャのデータ */ var currentGacha = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (initialSlide === undefined) {
            return null;
        }
        var ref3;
        return (ref3 = (ref = state.gachas) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[initialSlide]) === null || ref2 === void 0 ? void 0 : ref2.node) !== null && ref3 !== void 0 ? ref3 : null;
    }, [
        state.gachas,
        initialSlide
    ]);
    /** GPSガチャの状態 */ var ref25 = useLocationWatcher(), permission = ref25.permission, currentLocation = ref25.currentLocation, requestPermission = ref25.requestPermission, watch = ref25.watch, unwatch = ref25.unwatch;
    // 動画再生コンポーネントのrefオブジェクトを作成する
    var videoFullscreenRef = (0,react.useRef)(null);
    var standbyVideoFullscreenRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData)) return;
        requestPermission().catch(showError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gpsData,
        requestPermission
    ]);
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    /** APNG再生プレイヤーのRef */ var apngFullScreenRef = (0,react.useRef)(null);
    var ref26 = (0,react.useState)(false), apngAnimationPlaying = ref26[0], setApngAnimationPlaying = ref26[1];
    /** カルーセルをスライドした際の挙動 */ var handleAfterChange = (0,react.useCallback)(function(currentSlide) {
        var ref;
        if (!((ref = state.gachas) === null || ref === void 0 ? void 0 : ref.edges)) return;
        var currentGacha = state.gachas.edges[currentSlide];
        if (!currentGacha) return;
        var ref1;
        router.replace({
            pathname: generatePath(routerPages.ArtistGachaDetail, {
                artistId: (ref1 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref1 !== void 0 ? ref1 : "#",
                gachaId: currentGacha.node.id
            }),
            search: location.search
        });
    }, [
        (ref3 = state.gachas) === null || ref3 === void 0 ? void 0 : ref3.edges,
        router,
        generatePath,
        routerPages.ArtistGachaDetail,
        location.search, 
    ]);
    /** ガチャチケットを購入する処理 */ var handlePurchaseGachaTicket = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var _prepaidPoints;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!purchasableGachaTicket) {
                        setOpenTicketPurchaseConfirmModal(false);
                        return [
                            2
                        ];
                    }
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_purchaseByPoint", {
                        category: "".concat(ConversionCategories.gachaTicket, "/GachaDetail"),
                        quantity: purchasableGachaTicket.count,
                        point: (_prepaidPoints = purchasableGachaTicket.prepaidPoints) !== null && _prepaidPoints !== void 0 ? _prepaidPoints : 0,
                        gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
                    });
                    return [
                        4,
                        actions.onPurchaseGachaTicket(purchasableGachaTicket).then(function() {
                            var _prepaidPoints;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("purchaseByPoint", {
                                category: "".concat(ConversionCategories.gachaTicket, "/GachaDetail"),
                                quantity: purchasableGachaTicket.count,
                                point: (_prepaidPoints = purchasableGachaTicket.prepaidPoints) !== null && _prepaidPoints !== void 0 ? _prepaidPoints : 0,
                                gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
                            });
                            setOpenTicketPurchaseConfirmModal(false);
                            setOpenTicketPurchaseCompleteModal(true);
                        }).catch(function(e) {
                            var ref, ref1, ref2;
                            setOpenTicketPurchaseConfirmModal(false);
                            // ポイント不足の場合、モーダルを表示する
                            if ((e === null || e === void 0 ? void 0 : (ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode) === constants/* constants.errorCodes.INSUFFICIENT_PREPAID_POINT_BALANCE */._.errorCodes.INSUFFICIENT_PREPAID_POINT_BALANCE) {
                                var ref3;
                                var ref4;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("error_insufficientPrepaidPoint", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    prepaidPointId: (ref3 = state.prepaidPointBalance) === null || ref3 === void 0 ? void 0 : ref3.prepaidPointId,
                                    gachaId: (ref4 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.id) !== null && ref4 !== void 0 ? ref4 : "",
                                    name: "gachaDetail"
                                });
                                return setOpenTicketPurchaseErrorModal(true);
                            }
                            showError(e);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        purchasableGachaTicket,
        actions.onPurchaseGachaTicket,
        analytics,
        showError,
        currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.id,
        state.prepaidPointBalance, 
    ]);
    /** ガチャチケット購入のアクションシートをキャンセルするに呼ばれる処理 */ var onCancelPurchaseGachaTicket = function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            gachaId: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.id,
            artistId: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.artistId,
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
            type: "bottomsheet",
            name: "purchaseGachaTicket"
        });
        setOpenGachaTicketPurchaseDrawer(false);
    };
    /** チケット確認モーダルをキャンセルで閉じる際に呼ばれる処理 */ var onCancelPurchaseGachaTicketModal = function() {
        var ref;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            gachaId: state.gachaId,
            artistId: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.artistId,
            count: purchasableGachaTicket === null || purchasableGachaTicket === void 0 ? void 0 : purchasableGachaTicket.count,
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
            prepaidPointId: (ref = state.prepaidPointBalance) === null || ref === void 0 ? void 0 : ref.prepaidPointId,
            type: "modal",
            name: "purchaseGachaTicket"
        });
        setOpenTicketPurchaseConfirmModal(false);
    };
    /** チケット購入時にポイント不足によるエラーモーダルを閉じる際に呼ばれる処理 */ var onCancelPurchaseErrorGachaTicket = function() {
        var ref;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            gachaId: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.id,
            artistId: currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.artistId,
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
            prepaidPointId: (ref = state.prepaidPointBalance) === null || ref === void 0 ? void 0 : ref.prepaidPointId,
            type: "modal",
            name: "purchaseGachaTicket"
        });
        setOpenTicketPurchaseErrorModal(false);
    };
    /** ポイント購入処理 */ var handlePurchasePoint = actions.onPurchaseCharge;
    /** ガチャを回すボタンをクリックしたときの処理。条件に応じたモーダルやメッセージを表示する */ var handleClickGachaTrigger = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(count) {
            var ref, standByAnimationUri, ref1, ref2, ref3, ref4, ref5, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                /** 0.回すガチャの個数に関する状態を更新 */ setGachaCount(count);
                standByAnimationUri = (currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.standByAnimations) ? (ref = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.standByAnimations[count === 10 ? "bulk" : "single"]) === null || ref === void 0 ? void 0 : ref.uri : null;
                if (standByAnimationUri) {
                    ;
                    standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref1 = standbyVideoFullscreenRef.current) === null || ref1 === void 0 ? void 0 : ref1.init(function(state) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                            url: standByAnimationUri,
                            playsinline: true,
                            onReady: function onReady() {
                                var ref;
                                (ref = standbyVideoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.handleOnReadyVideo();
                            },
                            onEnded: function onEnded() {
                                setStandingBy(true);
                            },
                            onError: function onError(e) {
                                var ref;
                                (0,core_errors/* captureError */.O)(e, "gachaDetailPlayGachaAnimationVideo");
                                //check videoFullscreen have src value
                                if (videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.src) {
                                    var ref1;
                                    videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref1 = videoFullscreenRef.current) === null || ref1 === void 0 ? void 0 : ref1.playVideo();
                                }
                            }
                        });
                    });
                }
                /**
     * 2.ポイントでしか引けないガチャの場合
     *
     */ if ((currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.gachaRollType) === utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint) {
                    ;
                    ;
                    /**
       * 2-1.所持ポイントが足りない場合、ポイント購入モーダルを表示
       */ if (((ref3 = state === null || state === void 0 ? void 0 : (ref2 = state.prepaidPointBalance) === null || ref2 === void 0 ? void 0 : ref2.balance) !== null && ref3 !== void 0 ? ref3 : 0) < ((ref4 = currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.price) !== null && ref4 !== void 0 ? ref4 : 0) * count) {
                        setOpenInsufficientPointModal(true);
                        return [
                            2
                        ];
                    }
                    /**
       * 2-2.所持ポイントが足りている場合、回す確認モーダル
       */ setOpenConfirmByPoint(true);
                    return [
                        2
                    ];
                }
                /**
     * 3.値段設定がないガチャ（ガチャチケットのみ許容のガチャの場合）
     *
     */ if (!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.price)) {
                    /**
       * 3-1.ガチャチケットが足りない場合
       */ if (state.ticket === null || count > Number(state.ticket)) {
                        /**
         * 3-1-1.ポイントを使用しないアプリの場合、チケットが足りませんとメッセージを表示
         */ if (!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint) {
                            showMessage(t("notEnoughGachaTicket"));
                            return [
                                2
                            ];
                        }
                        /**
         * 3-1-2.ポイントを使用するアプリの場合、ガチャチケット購入モーダルを表示
         */ setOpenGachaTicketPurchaseDrawer(true);
                        return [
                            2
                        ];
                    }
                    /**
       * 3-2.ガチャチケットが足りている場合、ガチャチケットで回す
       */ setOpenConfirmByTicket(true);
                    return [
                        2
                    ];
                }
                /**
     * 4.ガチャチケット・ポイント両方許容のガチャの場合（両方許容且つ値段設定があるガチャの場合）
     *
     */ /**
     * 4-1.ガチャチケットが足りない場合
     */ if (state.ticket === null || count > Number(state.ticket)) {
                    /**
       * 4-1-1.1回引く場合、ポイントで引くか促すモーダルを表示
       */ if (count === 1) {
                        ;
                        ;
                        // ポイントが不足している場合、ポイント購入モーダルを表示
                        if (((ref6 = state === null || state === void 0 ? void 0 : (ref5 = state.prepaidPointBalance) === null || ref5 === void 0 ? void 0 : ref5.balance) !== null && ref6 !== void 0 ? ref6 : 0) < currentGacha.price * count) {
                            setOpenGachaTicketPurchaseDrawer(true);
                            return [
                                2
                            ];
                        } else {
                            setOpenInsufficientTicket(true);
                            return [
                                2
                            ];
                        }
                    }
                    /**
       * 4-1-2.10回引く場合、ガチャチケット購入モーダルを表示
       */ setOpenGachaTicketPurchaseDrawer(true);
                    return [
                        2
                    ];
                }
                /**
     * 4-2.所持チケットがが足りている場合、ガチャを回す確認モーダル表示
     */ setOpenConfirmByTicket(true);
                return [
                    2
                ];
            });
        });
        return function handleClickGachaTrigger(count) {
            return _ref.apply(this, arguments);
        };
    }();
    /** ガチャ処理終了後、結果画面へ遷移する処理 */ var redirectToGachaComplete = (0,react.useCallback)(function(count, gachaResultData) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref = standbyVideoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.pauseVideo();
        videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref1 = videoFullscreenRef.current) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        if (lastGachaOrderIdRef.current === (gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref2 = gachaResultData.rollGacha) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gachaOrder) === null || ref3 === void 0 ? void 0 : ref3.id)) {
            return;
        }
        lastGachaOrderIdRef.current = gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref4 = gachaResultData.rollGacha) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gachaOrder) === null || ref5 === void 0 ? void 0 : ref5.id;
        (ref6 = rollingGachaTransactionRef.current) === null || ref6 === void 0 ? void 0 : ref6.end();
        return router.push(generatePath(count === 10 ? routerPages.TenGachaResult : routerPages.SingleGachaResult, {
            gachaId: gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref7 = gachaResultData.rollGacha) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gachaOrder) === null || ref8 === void 0 ? void 0 : ref8.gachaId,
            gachaOrderId: gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref9 = gachaResultData.rollGacha) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.gachaOrder) === null || ref10 === void 0 ? void 0 : ref10.id
        }));
    }, [
        generatePath,
        router,
        routerPages.SingleGachaResult,
        routerPages.TenGachaResult, 
    ]);
    /**
   * ガチャを回す処理
   * ガチャを回すのに成功した場合：アニメーションの表示は成功・失敗に関わらずガチャ結果画面へと遷移させる。
   * ガチャを回すのに失敗した場合：スナックバーでエラー表示
   */ var handleRollGacha = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(rollType) {
            var callAPISpan;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.id)) return [
                            2
                        ];
                        setGachaRolling(true);
                        rollingGachaTransactionRef.current = (0,capacitor_dist_esm/* startInactiveSpan */.qp)({
                            name: currentGacha.isLimited ? "rollingGachaLimited" : "rollingGachaLimitless",
                            forceTransaction: true
                        }).setAttribute("gachaCount", gachaCount).setAttribute("gachaId", currentGacha.id).setAttribute("rollType", rollType);
                        callAPISpan = (0,capacitor_dist_esm/* startInactiveSpan */.qp)({
                            name: "callAPI",
                            parentSpan: rollingGachaTransactionRef.current
                        });
                        return [
                            4,
                            actions.onRollGacha(gachaCount, currentGacha.id, rollType).then(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                                    var gachaResultData, ref, ref1, ref2, ref3, /**
         * スタンバイ動画がない場合、そのままアニメーションを再生
         */ ref4, rewardAnimationUri, animationApng, ref5;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                gachaResultData = param.data;
                                                callAPISpan.end();
                                                /** スキップ処理を「ガチャ結果先へのリダイレクト」に設定する */ setHandleSkip({
                                                    fn: function fn() {
                                                        setStandingBy(false);
                                                        setPlayingAnimation(false);
                                                        setApngAnimationPlaying(false);
                                                        setGachaRolling(false);
                                                        redirectToGachaComplete(gachaCount, gachaResultData);
                                                    }
                                                });
                                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_rollGacha", {
                                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                                    gachaId: currentGacha.id,
                                                    artistId: (ref = state.artist) === null || ref === void 0 ? void 0 : ref.id,
                                                    /**
           * @description
           * カスタムディメンションは文字列しか計測しないため、数値を文字列変換する
           * https://app.clickup.com/t/908127/UT-9829
           */ count: gachaCount.toString(),
                                                    gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                                    type: rollType
                                                });
                                                rewardAnimationUri = ((ref1 = gachaResultData === null || gachaResultData === void 0 ? void 0 : gachaResultData.rollGacha.gachaOrder.rewardAnimation) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) || ((ref2 = gachaResultData === null || gachaResultData === void 0 ? void 0 : gachaResultData.rollGacha.gachaOrder.rewardAnimation) === null || ref2 === void 0 ? void 0 : ref2.uri);
                                                // アニメーションのリソースがない場合、結果画面にリダイレクト
                                                if (!rewardAnimationUri) return [
                                                    2,
                                                    redirectToGachaComplete(gachaCount, gachaResultData)
                                                ];
                                                if (!!isVideoExt(rewardAnimationUri)) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    generateApng(rewardAnimationUri).catch(function(e) {
                                                        var ref;
                                                        (0,core_errors/* captureError */.O)(e, "gachaDetailGenerateApng");
                                                        (ref = rollingGachaTransactionRef.current) === null || ref === void 0 ? void 0 : ref.setStatus({
                                                            code: spanstatus/* SPAN_STATUS_ERROR */.jt,
                                                            message: "gachaDetailGenerateApngError"
                                                        });
                                                        return;
                                                    })
                                                ];
                                            case 1:
                                                animationApng = _state.sent();
                                                if (!animationApng) return [
                                                    3,
                                                    3
                                                ];
                                                setApngAnimationPlaying(true);
                                                return [
                                                    4,
                                                    playApngAnimation(apngFullScreenRef, animationApng).then(function() {
                                                        setGachaRolling(false);
                                                    }).catch(function(e) {
                                                        var ref;
                                                        (0,core_errors/* captureError */.O)(e, "gachaDetailplayApngAnimation");
                                                        (ref = rollingGachaTransactionRef.current) === null || ref === void 0 ? void 0 : ref.setStatus({
                                                            code: spanstatus/* SPAN_STATUS_ERROR */.jt,
                                                            message: "gachaDetailPlayApngAnimationError"
                                                        });
                                                    }).finally(function() {
                                                        setApngAnimationPlaying(false);
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2,
                                                    redirectToGachaComplete(gachaCount, gachaResultData)
                                                ];
                                            case 4:
                                                /**
         * 動画ファイルがMP4の場合
         * 結果アニメーション動画のvideo要素にURLをセットする
         */ if (!videoFullscreenRef || !(videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : videoFullscreenRef.current)) return [
                                                    2,
                                                    redirectToGachaComplete(gachaCount, gachaResultData)
                                                ];
                                                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref3 = videoFullscreenRef.current) === null || ref3 === void 0 ? void 0 : ref3.init(function(state) {
                                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                                        url: rewardAnimationUri,
                                                        playsinline: true,
                                                        onReady: function onReady() {
                                                            var ref;
                                                            (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.handleOnReadyVideo();
                                                        },
                                                        onEnded: function onEnded() {
                                                            setPlayingAnimation(false);
                                                            redirectToGachaComplete(gachaCount, gachaResultData);
                                                        },
                                                        onError: function onError(e) {
                                                            var ref;
                                                            setPlayingAnimation(false);
                                                            (0,core_errors/* captureError */.O)(e, "gachaDetailPlayGachaAnimationVideo");
                                                            (ref = rollingGachaTransactionRef.current) === null || ref === void 0 ? void 0 : ref.setStatus({
                                                                code: spanstatus/* SPAN_STATUS_ERROR */.jt,
                                                                message: "gachaDetailPlayGachaAnimationVideoError"
                                                            });
                                                            redirectToGachaComplete(gachaCount, gachaResultData);
                                                        }
                                                    });
                                                });
                                                setPlayingAnimation(true);
                                                /**
         * スタンバイ動画がある場合、スタンバイ動画を再生してreturn
         */ if (currentGacha === null || currentGacha === void 0 ? void 0 : currentGacha.standByAnimations) {
                                                    ;
                                                    standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref5 = standbyVideoFullscreenRef.current) === null || ref5 === void 0 ? void 0 : ref5.playVideo();
                                                    return [
                                                        2
                                                    ];
                                                }
                                                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref4 = videoFullscreenRef.current) === null || ref4 === void 0 ? void 0 : ref4.playVideo();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(e) {
                                var ref;
                                showError(e);
                                (ref = rollingGachaTransactionRef.current) === null || ref === void 0 ? void 0 : ref.setStatus({
                                    code: spanstatus/* SPAN_STATUS_ERROR */.jt,
                                    message: "internal_error"
                                }).end();
                                (0,core_errors/* captureError */.O)(e, "gachaDetail");
                            }).finally(function() {
                                setOpenConfirmByTicket(false);
                                setOpenConfirmByPoint(false);
                                setOpenInsufficientTicket(false);
                                setGachaRolling(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRollGacha(rollType) {
            return _ref.apply(this, arguments);
        };
    }();
    // スタンバイ状態からトリガーを引き、ガチャ動画を再生する
    var handleRollGachaAfterStandingby = function() {
        var // アニメーション動画を再生
        ref;
        setStandingBy(false);
        videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.playVideo();
    };
    return {
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
            title: initialSlide ? [
                (ref5 = (ref4 = state.gachas) === null || ref4 === void 0 ? void 0 : ref4.edges[initialSlide]) === null || ref5 === void 0 ? void 0 : ref5.node.name
            ] : [
                routerNames.ArtistGachaDetail,
                (ref6 = state.artist) === null || ref6 === void 0 ? void 0 : ref6.displayName
            ],
            gachaRolling: gachaRolling,
            standingBy: standingBy,
            playingAnimation: playingAnimation,
            apngAnimationPlaying: apngAnimationPlaying,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            },
            videoFullscreenRef: videoFullscreenRef,
            standbyVideoFullscreenRef: standbyVideoFullscreenRef,
            apngFullScreenRef: apngFullScreenRef,
            gachaCount: gachaCount,
            latestGacha: latestGacha,
            initialSlide: initialSlide,
            currentGacha: currentGacha,
            openSideMenu: openSideMenu,
            openGachaTicketPurchaseDrawer: openGachaTicketPurchaseDrawer,
            openPointPurchaseDrawer: openPointPurchaseDrawer,
            openConfirmByTicket: openConfirmByTicket,
            openConfirmByPoint: openConfirmByPoint,
            openInsufficientTicket: openInsufficientTicket,
            openInsufficientPointModal: openInsufficientPointModal,
            openTicketPurchaseConfirmModal: openTicketPurchaseConfirmModal,
            openTicketPurchaseCompleteModal: openTicketPurchaseCompleteModal,
            openTicketPurchaseErrorModal: openTicketPurchaseErrorModal,
            purchasableGachaTicket: purchasableGachaTicket,
            isSafari: (0,native_app/* getPlatform */.Xf)() === "ios" || dist_lib/* isSafari */.G6 || dist_lib/* isIOS */.gn
        }),
        actions: {
            setOpenSideMenu: setOpenSideMenu,
            setOpenGachaTicketPurchaseDrawer: setOpenGachaTicketPurchaseDrawer,
            setOpenPointPurchaseDrawer: setOpenPointPurchaseDrawer,
            setOpenConfirmByTicket: setOpenConfirmByTicket,
            setOpenConfirmByPoint: setOpenConfirmByPoint,
            setOpenInsufficientTicket: setOpenInsufficientTicket,
            setOpenInsufficientPointModal: setOpenInsufficientPointModal,
            setOpenTicketPurchaseConfirmModal: setOpenTicketPurchaseConfirmModal,
            setOpenTicketPurchaseCompleteModal: setOpenTicketPurchaseCompleteModal,
            setPurchasableGachaTicket: setPurchasableGachaTicket,
            handleAfterChange: handleAfterChange,
            handlePurchaseGachaTicket: handlePurchaseGachaTicket,
            handlePurchasePoint: handlePurchasePoint,
            onCancelPurchaseGachaTicket: onCancelPurchaseGachaTicket,
            onCancelPurchaseErrorGachaTicket: onCancelPurchaseErrorGachaTicket,
            onCancelPurchaseGachaTicketModal: onCancelPurchaseGachaTicketModal,
            onSkip: handleSkip.fn,
            handleClickGachaTrigger: handleClickGachaTrigger,
            handleRollGachaByTicket: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        handleRollGacha(utoniq_core_schema/* GachaRollType.GachaTicket */.msy.GachaTicket)
                    ];
                });
            }),
            handleRollGachaByPoint: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        handleRollGacha(utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint)
                    ];
                });
            }),
            handleRollGachaAfterStandingby: handleRollGachaAfterStandingby
        }
    };
};
/** 動画フォーマットがmp4かどうか判定する */ function isVideoExt(url) {
    var ref;
    return ((ref = url.split(/[#?]/)[0].split(".").pop()) === null || ref === void 0 ? void 0 : ref.trim()) === "mp4";
}

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/viewModel.ts




function GachaDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaDetail(\n    $gachasArtistId: ID\n    $gachasPageInput: PageInputDate\n    $gachaTicketId: ID!\n    $platform: String!\n    $purchasablePrepaidPointPageInput: PageInput\n  ) {\n    gachas(artistId: $gachasArtistId, pageInput: $gachasPageInput) {\n      ...GachasDetailConnection\n    }\n    user {\n      ...CurrentUser\n      gachaTicket(id: $gachaTicketId) {\n        ...UserGachaTicketConnection\n      }\n    }\n    gachaTicket(id: $gachaTicketId) {\n      ...GachaTicketConnection\n    }\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n    artist(id: $gachasArtistId) {\n      ...ArtistBottomTab\n      ...ArtistGachaDetail\n    }\n    purchasablePrepaidPoints(\n      platform: $platform\n      pageInput: $purchasablePrepaidPointPageInput\n    ) {\n      ...PurchasablePrepaidPointConnection\n    }\n    paymentSource {\n      ...PrepaidPointsPaymentSource\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GachaDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GachaDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaDetailForGuest(\n    $gachasArtistId: ID\n    $gachasPageInput: PageInputDate\n    $gachaTicketId: ID!\n  ) {\n    gachas(artistId: $gachasArtistId, pageInput: $gachasPageInput) {\n      ...GachasDetailConnection\n    }\n    gachaTicket(id: $gachaTicketId) {\n      ...GachaTicketConnection\n    }\n    artist(id: $gachasArtistId) {\n      ...ArtistBottomTab\n      ...ArtistGachaDetail\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GachaDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GachaDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RollGacha(\n    $rollGachaGachaId: ID!\n    $rollGachaInputs: RollGachaInput!\n  ) {\n    rollGacha(gachaId: $rollGachaGachaId, inputs: $rollGachaInputs) {\n      gachaOrder {\n        id\n        gachaId\n        rewardItems {\n          count\n        }\n        rewardAnimation {\n          uri\n          mediumUri\n          smallUri\n        }\n      }\n    }\n  }\n"
    ]);
    GachaDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GachaDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseGachaTicketByPoint(\n    $gachaTicketId: ID!\n    $inputs: PurchaseGachaTicketPointInput!\n  ) {\n    purchaseGachaTicketByPoint(gachaTicketId: $gachaTicketId, inputs: $inputs) {\n      gachaTicketId\n      count\n    }\n  }\n"
    ]);
    GachaDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GachaDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation PurchaseGachaTicketByPointInBulk(\n    $gachaTicketId: ID!\n    $inputs: PurchaseGachaTicketPointInBulkInput!\n  ) {\n    purchaseGachaTicketByPointInBulk(\n      gachaTicketId: $gachaTicketId\n      inputs: $inputs\n    ) {\n      gachaTicketId\n      count\n    }\n  }\n"
    ]);
    GachaDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var GachaDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref11.user, userClaims = ref11.userClaims;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var ref12 = usePointPurchase(currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid, platform, "gachaDetail"), purchaseByIosAndAndroid = ref12.purchaseByIosAndAndroid, purchaseByWeb = ref12.purchaseByWeb, completeNativePurchase = ref12.completeNativePurchase, setCompleteNativePurchase = ref12.setCompleteNativePurchase, chargeLoading = ref12.chargeLoading;
    var ref13 = (0,useQuery/* useQuery */.aM)(GachaDetail_viewModel_QUERY, {
        variables: {
            gachasArtistId: artistId,
            gachasPageInput: {
                limit: 20
            },
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
            platform: platform
        },
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        notifyOnNetworkStatusChange: true,
        pollInterval: completeNativePurchase ? 2000 : 0,
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref13.data, loading = ref13.loading;
    var isNextFetch = !!data;
    var ref14 = (0,useQuery/* useQuery */.aM)(GachaDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            gachasArtistId: artistId,
            gachasPageInput: {
                limit: 20
            },
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
        },
        skip: !!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), dataForGuest = ref14.data, loadingForGuest = ref14.loading;
    var isNextFetchForGuest = !!dataForGuest;
    /** 決済後、prepaidPointBalanceが更新されたらpollingを停止する処理 */ (0,react.useEffect)(function() {
        setCompleteNativePurchase(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.prepaidPointBalance
    ]);
    /**
   * @description
   * GraphqlCDNのキャッシュ対策のためクエリartist.currentLiveのクエリをgachaDetailとは別で実行
   * https://app.clickup.com/t/908127/UT-8880
   */ var ref15 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistLiveStream */.B5b, {
        variables: {
            artistId: artistId
        },
        skip: !config_config/* config.modules.liveStream */.v.modules.liveStream
    }), dataLiveStream = ref15.data;
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GachaDetail_viewModel_MUTATION), 1), rollGacha = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_GACHA_TICKET_BY_POINT), 2), purchaseGachaTicketByPoint = ref17[0], ref18 = ref17[1], gachaTicketByPointPurchasing = ref18.loading;
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_GACHA_TICKET_BY_POINT_IN_BULK), 2), purchaseGachaTicketByPointInBulk = ref19[0], ref20 = ref19[1], gachaTicketByPointInBulkPurchasing = ref20.loading;
    var ref21, ref22, ref23, ref24, ref25, ref26, ref27, _gachaId, ref28, ref29, ref30, ref31, ref32, ref33;
    return {
        state: {
            // 共通UI
            user: (ref21 = data === null || data === void 0 ? void 0 : data.user) !== null && ref21 !== void 0 ? ref21 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist),
            liveStreamId: dataLiveStream === null || dataLiveStream === void 0 ? void 0 : (ref2 = dataLiveStream.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.currentLive) === null || ref3 === void 0 ? void 0 : ref3.id,
            followArtists: (ref22 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationFollowees) !== null && ref22 !== void 0 ? ref22 : null,
            memberArtists: (ref23 = data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : ref5.organizationPatrons) !== null && ref23 !== void 0 ? ref23 : null,
            // GachaDetailページのUI
            loading: loading && !isNextFetch || loadingForGuest && !isNextFetchForGuest,
            artist: (ref25 = (ref24 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref24 !== void 0 ? ref24 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.artist) !== null && ref25 !== void 0 ? ref25 : null,
            artistId: artistId,
            gachas: (ref27 = (ref26 = data === null || data === void 0 ? void 0 : data.gachas) !== null && ref26 !== void 0 ? ref26 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.gachas) !== null && ref27 !== void 0 ? ref27 : null,
            gachaId: (_gachaId = router.query.gachaId) !== null && _gachaId !== void 0 ? _gachaId : "",
            gachaTicketPurchasing: gachaTicketByPointPurchasing || gachaTicketByPointInBulkPurchasing,
            prepaidPointBalance: (ref28 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref28 !== void 0 ? ref28 : null,
            ticket: (ref29 = loading && !(data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : ref6.gachaTicket) ? "" : data === null || data === void 0 ? void 0 : (ref7 = data.user) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.gachaTicket) === null || ref8 === void 0 ? void 0 : ref8.available) !== null && ref29 !== void 0 ? ref29 : 0,
            gachaTicket: (ref31 = (ref30 = data === null || data === void 0 ? void 0 : data.gachaTicket) !== null && ref30 !== void 0 ? ref30 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.gachaTicket) !== null && ref31 !== void 0 ? ref31 : null,
            purchasablePrepaidPoints: (ref32 = data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints) !== null && ref32 !== void 0 ? ref32 : null,
            pointChargeLoading: chargeLoading,
            paymentSource: (ref33 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref33 !== void 0 ? ref33 : null,
            /** アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref9 = data.organization) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.modules) === null || ref10 === void 0 ? void 0 : ref10.pointCarrierPayment)
        },
        actions: {
            onRollGacha: function onRollGacha(count, gachaId, rollType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            rollGacha({
                                variables: {
                                    rollGachaGachaId: gachaId,
                                    rollGachaInputs: {
                                        count: count,
                                        gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                        rollType: rollType
                                    }
                                }
                            })
                        ];
                    });
                })();
            },
            onPurchaseGachaTicket: function onPurchaseGachaTicket(purchasableGachaTicket) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _prepaidPoints, _prepaidPoints1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            purchasableGachaTicket.count === 1 ? purchaseGachaTicketByPoint({
                                variables: {
                                    gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                    inputs: {
                                        count: purchasableGachaTicket.count,
                                        point: (_prepaidPoints = purchasableGachaTicket.prepaidPoints) !== null && _prepaidPoints !== void 0 ? _prepaidPoints : 0
                                    }
                                }
                            }) : purchaseGachaTicketByPointInBulk({
                                variables: {
                                    gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                    inputs: {
                                        point: (_prepaidPoints1 = purchasableGachaTicket.prepaidPoints) !== null && _prepaidPoints1 !== void 0 ? _prepaidPoints1 : 0
                                    }
                                }
                            })
                        ];
                    });
                })();
            },
            onPurchaseCharge: platform === "web" ? purchaseByWeb : purchaseByIosAndAndroid
        }
    };
});
var GachaDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(GachaDetail_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* GachasDetailConnectionFragmentDoc */._z0, utoniq_core_schema/* GachaTicketConnectionFragmentDoc */.mCK, utoniq_core_schema/* UserGachaTicketConnectionFragmentDoc */.XFl, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* PurchasablePrepaidPointConnectionFragmentDoc */.oBq, utoniq_core_schema/* PrepaidPointsPaymentSourceFragmentDoc */.tE1, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* ArtistGachaDetailFragmentDoc */.n23);
var GachaDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(GachaDetail_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* GachasDetailConnectionFragmentDoc */._z0, utoniq_core_schema/* GachaTicketConnectionFragmentDoc */.mCK, utoniq_core_schema/* ArtistGachaDetailFragmentDoc */.n23);
var GachaDetail_viewModel_MUTATION = (0,lib/* gql */.Ps)(GachaDetail_viewModel_templateObject2());
var PURCHASE_GACHA_TICKET_BY_POINT = (0,lib/* gql */.Ps)(GachaDetail_viewModel_templateObject3());
var PURCHASE_GACHA_TICKET_BY_POINT_IN_BULK = (0,lib/* gql */.Ps)(GachaDetail_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/GachaDetail/index.tsx





/**
 * GachaDetail Page
 * Implemented as a practical sample.
 */ var GachaDetail = function() {
    var ref = useTemplateStore(GachaDetail_viewModel_useViewModel()), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/GachaItemList/template/index.tsx











var GachaItemListTemplate = function(param) {
    var state = param.state;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaItemList").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var _gachaId, _artistId, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.ArtistGachaDetail, {
                gachaId: (_gachaId = router.query.gachaId) !== null && _gachaId !== void 0 ? _gachaId : "#",
                artistId: (ref2 = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId) !== null && ref2 !== void 0 ? ref2 : "#"
            }),
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistGachaDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                sx: {
                    pt: 2,
                    px: 5,
                    pb: 3
                },
                variant: "body2",
                children: t("desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                sx: {
                    px: 5,
                    bgcolor: "grey.50",
                    py: "6px"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("itemName")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t(state.rollAlgorithm === utoniq_core_schema/* GachaRollAlgorithm.Limited */.m$7.Limited ? "remainingCount" : "provided")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                component: List_List/* default */.Z,
                componentProps: {
                    sx: {
                        pt: 4
                    }
                },
                nodes: (ref = state.items) === null || ref === void 0 ? void 0 : ref.map(function(node) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemRateCell, {
                        node: node,
                        rollAlgorithm: state.rollAlgorithm
                    }, node.item.id);
                }),
                loading: state.loading,
                hasNextPage: false,
                onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                }),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    sx: {
                        pt: 2
                    },
                    children: Array.from(Array(6).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
                            sx: {
                                height: "auto",
                                px: 5
                            },
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: 40
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        width: 48,
                                        height: 76
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    width: "50%"
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
};
var GachaItemList_template_ref;
var ItemRateCell = function(param) {
    var rollAlgorithm = param.rollAlgorithm, _node = param.node, item = _node.item, weight = _node.weight, remainingCountInfo = _node.remainingCountInfo;
    var ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
        sx: {
            height: "auto",
            px: 5,
            pt: 0,
            pb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "square",
                    src: (GachaItemList_template_ref = (ref1 = item.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && GachaItemList_template_ref !== void 0 ? GachaItemList_template_ref : "",
                    sx: {
                        width: 48,
                        height: 76
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                disableTypography: true,
                slotProps: {
                    primary: {
                        variant: "overline"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            children: rollAlgorithm === utoniq_core_schema/* GachaRollAlgorithm.Limited */.m$7.Limited ? remainingCountInfo ? "".concat(remainingCountInfo.remainingCount, "/").concat(remainingCountInfo.allCount) : "-/-" : weight
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaItemList/viewModel.ts

function GachaItemList_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaItemList($gachaId: ID!) {\n    gacha(id: $gachaId) {\n      id\n      rollAlgorithm\n      items {\n        remainingCountInfo {\n          remainingCount\n          allCount\n        }\n        ...GachaItemsWithRemainingCountInfo\n      }\n    }\n  }\n  fragment GachaItemsWithRemainingCountInfo on GachaItem {\n    weight\n    remainingCountInfo {\n      remainingCount\n      allCount\n    }\n    item {\n      title\n      id\n      thumbnail {\n        front {\n          uri\n          smallUri\n        }\n      }\n    }\n  }\n"
    ]);
    GachaItemList_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GachaItemList_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref2 = (0,useQuery/* useQuery */.aM)(GachaItemList_viewModel_QUERY, {
        variables: {
            gachaId: router.query.gachaId
        }
    }), data = ref2.data, loading = ref2.loading;
    var ref3, ref4;
    return {
        state: {
            loading: loading,
            rollAlgorithm: (ref3 = data === null || data === void 0 ? void 0 : (ref = data.gacha) === null || ref === void 0 ? void 0 : ref.rollAlgorithm) !== null && ref3 !== void 0 ? ref3 : null,
            items: (ref4 = data === null || data === void 0 ? void 0 : (ref1 = data.gacha) === null || ref1 === void 0 ? void 0 : ref1.items) !== null && ref4 !== void 0 ? ref4 : null
        },
        actions: {}
    };
});
var GachaItemList_viewModel_QUERY = (0,lib/* gql */.Ps)(GachaItemList_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/GachaItemList/index.tsx



/**
 * GachaItemList Page
 * Implemented as a practical sample.
 */ var GachaItemList = function() {
    var state = GachaItemList_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaItemListTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/NftIssuingModal.tsx




var NftIssuingModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("nftIssuingTitle"),
        content: t("nftIssuingContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                width: 244
            },
            onClick: onClose,
            children: "OK"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailMagazineView.tsx


















var OwnedItemDetailMagazineView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onClickProtectUserItem = param.onClickProtectUserItem, onReverseThumbnail = param.onReverseThumbnail, onSetOpenMagazineModal = param.onSetOpenMagazineModal, onViewCollectionMagazine = param.onViewCollectionMagazine, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1, ref2, ref3;
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            position: "relative",
                            ".MuiButtonBase-root": {
                                height: "fit-content"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                onOpenFullScreen: onOpenFullScreen,
                                onOpenMultipleImage: onOpenMultipleImage,
                                numberImage: (ref4 = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref4 !== void 0 ? ref4 : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                loading: loading,
                                flipProps: {
                                    isFlipped: isFlipped
                                },
                                btnPlay: {
                                    type: "back",
                                    onClick: function() {
                                        onSetOpenMagazineModal(true);
                                        if (onViewCollectionMagazine) {
                                            onViewCollectionMagazine();
                                        }
                                    }
                                },
                                imageAreaProps: {
                                    thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                                    size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                    onClick: onReverseThumbnail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                        portfolio: portfolio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 4,
                            mb: 2
                        },
                        children: isFlipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.MagazineOn, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref5 = (ref2 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref5 !== void 0 ? ref5 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref3 === void 0 ? void 0 : ref3.chains),
                onClickProtectUserItem: onClickProtectUserItem
            })
        ]
    });
};
var OwnedItemDetailMagazineView_MagazinePlayerModal = function(param) {
    var open = param.open, loading = param.loading, point = param.point, onClose = param.onClose, portfolio = param.portfolio, purchasingItem = param.purchasingItem, onBuyItem = param.onBuyItem, onClickShare = param.onClickShare, chargeLoading = param.chargeLoading, onPurchaseCharge = param.onPurchaseCharge, purchasablePrepaidPoints = param.purchasablePrepaidPoints, paymentSource = param.paymentSource, enablePointCarrierPayment = param.enablePointCarrierPayment;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,react.useState)(false), openPointCharge = ref15[0], setOpenPointCharge = ref15[1];
    var isDRM = (portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : (ref1 = ref.resource) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.drm) === null || ref2 === void 0 ? void 0 : ref2.encryptingStatus) === "encrypted";
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    if (!(portfolio === null || portfolio === void 0 ? void 0 : portfolio.item) || loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "grid",
            placeItems: "center",
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isDRM ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DRMMagazinePlayer, {
                open: open,
                onClose: onClose,
                resource: portfolio === null || portfolio === void 0 ? void 0 : (ref3 = portfolio.item) === null || ref3 === void 0 ? void 0 : ref3.resource
            }) : (portfolio === null || portfolio === void 0 ? void 0 : (ref4 = portfolio.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.magazine) === null || ref6 === void 0 ? void 0 : ref6.pageType) === utoniq_core_schema/* MagazinePageType.Image */.TeL.Image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailMagazineView_MangaPlayer, {
                loading: loading,
                purchasingItem: purchasingItem,
                open: open,
                onClose: function() {
                    onClose();
                    setOpenPointCharge(false);
                },
                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item,
                point: point,
                onOpenPointCharge: function() {
                    return setOpenPointCharge(true);
                },
                direction: (portfolio === null || portfolio === void 0 ? void 0 : (ref7 = portfolio.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.magazine) === null || ref9 === void 0 ? void 0 : ref9.pageDirection) || utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left,
                onBuyItem: onBuyItem,
                onClickShare: function() {
                    var ref;
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                        itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                        name: "magazineViewer"
                    });
                    onClickShare().then(function() {
                        var ref;
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                            itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                            name: "magazineViewer"
                        });
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailMagazineView_MagazinePlayer, {
                loading: loading,
                purchasingItem: purchasingItem,
                open: open,
                onClose: function() {
                    onClose();
                    setOpenPointCharge(false);
                },
                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item,
                point: point,
                onOpenPointCharge: function() {
                    return setOpenPointCharge(true);
                },
                resourceUrl: (portfolio === null || portfolio === void 0 ? void 0 : (ref10 = portfolio.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.resource) === null || ref11 === void 0 ? void 0 : ref11.uri) || "",
                direction: (portfolio === null || portfolio === void 0 ? void 0 : (ref12 = portfolio.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.metadata) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.magazine) === null || ref14 === void 0 ? void 0 : ref14.pageDirection) || utoniq_core_schema/* MagazinePageDirection.Left */.md6.Left,
                onBuyItem: onBuyItem,
                onClickShare: function() {
                    var ref;
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                        itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                        name: "magazineViewer"
                    });
                    onClickShare().then(function() {
                        var ref;
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                            itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                            name: "magazineViewer"
                        });
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeDrawer, {
                point: point !== null && point !== void 0 ? point : 0,
                onPurchase: onPurchaseCharge,
                open: openPointCharge,
                loading: loading,
                chargeLoading: !!chargeLoading,
                purchasablePrepaidPoints: purchasablePrepaidPoints !== null && purchasablePrepaidPoints !== void 0 ? purchasablePrepaidPoints : null,
                onClose: function() {
                    return setOpenPointCharge(false);
                },
                paymentSource: paymentSource,
                enablePointCarrierPayment: enablePointCarrierPayment,
                pageName: "ownedItemDetail"
            })
        ]
    });
};
var OwnedItemDetailMagazineView_MagazinePlayer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(691), __webpack_require__.e(2246), __webpack_require__.e(3439)]).then(__webpack_require__.bind(__webpack_require__, 94966)).then(function(md) {
        return md.MagazinePlayer;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94966)
            ];
        }
    },
    ssr: false
});
var OwnedItemDetailMagazineView_MangaPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8331).then(__webpack_require__.bind(__webpack_require__, 78331)).then(function(md) {
        return md.MangaPlayer;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78331)
            ];
        }
    },
    ssr: false
});

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailAvatarView.tsx











var OwnedItemDetailAvatarView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onSetAvatar = param.onSetAvatar, onClickProtectUserItem = param.onClickProtectUserItem, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1, ref2, ref3, ref4;
    var voiceResource = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.avatarResources) === null || ref === void 0 ? void 0 : ref.voiceResource;
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            position: "relative",
                            ".MuiButtonBase-root": {
                                height: "fit-content"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                onOpenFullScreen: onOpenFullScreen,
                                onOpenMultipleImage: onOpenMultipleImage,
                                numberImage: (ref5 = (ref1 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref5 !== void 0 ? ref5 : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                loading: loading,
                                flipProps: {
                                    isFlipped: isFlipped
                                },
                                imageAreaProps: {
                                    thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.item) === null || ref2 === void 0 ? void 0 : ref2.thumbnail,
                                    size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                    onClick: onReverseThumbnail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                        portfolio: portfolio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 4,
                            mb: 2
                        },
                        direction: "row",
                        spacing: 6,
                        children: [
                            voiceResource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
                                resource: voiceResource,
                                bgcolor: "primary.main",
                                color: "white"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                                size: "small",
                                onClick: onReverseThumbnail,
                                bgcolor: "primary.main",
                                color: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Avatar, {
                                size: "small",
                                onClick: onSetAvatar,
                                bgcolor: "primary.main",
                                color: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref6 = (ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref4 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref4 === void 0 ? void 0 : ref4.chains),
                onClickProtectUserItem: onClickProtectUserItem
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/ConfirmCustomProfileSettingModal.tsx




var ConfirmCustomProfileSettingModal = function(param) {
    var open = param.open, onClose = param.onClose, onClick = param.onClick, loading = param.loading, type = param.type, unset = param.unset;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    if (!type) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
            open: open,
            onClose: onClose,
            title: t(unset ? "confirmCancelBackground" : "confirmSetBackground"),
            content: "",
            cancelText: t("close"),
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Button, {
                size: "large",
                sx: {
                    width: 212
                },
                onClick: onClick,
                loading: loading,
                children: t(unset ? "allowCancelBackground" : "allowSetBackground")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/lib/react-hooks/useCountDown.tsx


function useCountdown(param) {
    var countStart = param.countStart, _countStop = param.countStop, countStop = _countStop === void 0 ? 0 : _countStop, _intervalMs = param.intervalMs, intervalMs = _intervalMs === void 0 ? 1000 : _intervalMs, _isIncrement = param.isIncrement, isIncrement = _isIncrement === void 0 ? false : _isIncrement;
    var ref = (0,usehooks_ts_esm/* useCounter */.Cf)(countStart), count = ref.count, increment = ref.increment, decrement = ref.decrement, setCount = ref.setCount, resetCounter = ref.reset;
    /*
   * Note: used to control the useInterval
   * running: If true, the interval is running
   * start: Should set running true to trigger interval
   * stop: Should set running false to remove interval.
   */ var ref1 = (0,usehooks_ts_esm/* useBoolean */.kt)(false), isCountdownRunning = ref1.value, startCountdown = ref1.setTrue, stopCountdown = ref1.setFalse;
    // Will set running false and reset the seconds to initial value.
    var resetCountdown = (0,react.useCallback)(function() {
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    var countdownCallback = (0,react.useCallback)(function() {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        } else {
            decrement();
        }
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    (0,usehooks_ts_esm/* useInterval */.Yz)(countdownCallback, isCountdownRunning ? intervalMs : null);
    (0,react.useEffect)(function() {
        if (countStart) {
            setCount(countStart);
        }
    }, [
        countStart
    ]);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}

;// CONCATENATED MODULE: ./src/components/organisms/item/QRCodeBox/index.tsx











var QRCodeBox = function(param) {
    var loading = param.loading, item = param.item, serial = param.serial, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref53 = (0,react.useState)(false), openGenerateQRConfirm = ref53[0], setOpenGenerateQRConfirm = ref53[1];
    var ref54 = (0,react.useState)(false), openGenerateQRComplete = ref54[0], setOpenGenerateQRComplete = ref54[1];
    var ref55 = (0,_sliced_to_array/* default */.Z)(useCountdown({
        countStart: (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaper) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.print) === null || ref3 === void 0 ? void 0 : ref3.expiredAt) / 1000 - dayjs_min_default()().unix(),
        intervalMs: 1000
    }), 2), countDownSeconds = ref55[0], startCountdown = ref55[1].startCountdown;
    var isExpired = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaper) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.print) === null || ref3 === void 0 ? void 0 : ref3.expiredAt) / 1000 < dayjs_min_default()().unix();
    }, [
        serial === null || serial === void 0 ? void 0 : (ref4 = serial.serial) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.wallpaper) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.print) === null || ref7 === void 0 ? void 0 : ref7.expiredAt
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaper) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.print) === null || ref3 === void 0 ? void 0 : ref3.expiredAt) {
            startCountdown();
        }
    }, [
        serial === null || serial === void 0 ? void 0 : (ref8 = serial.serial) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.metadata) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.wallpaper) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.print) === null || ref11 === void 0 ? void 0 : ref11.expiredAt
    ]);
    var ref56, ref57, ref58, ref59;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            borderRadius: 2,
            minHeight: "276px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    px: 5,
                    py: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                src: (ref56 = item === null || item === void 0 ? void 0 : (ref12 = item.thumbnail) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.front) === null || ref13 === void 0 ? void 0 : ref13.mediumUri) !== null && ref56 !== void 0 ? ref56 : "",
                                size: "x-small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: serial === null || serial === void 0 ? void 0 : (ref14 = serial.serial) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.sku) === null || ref15 === void 0 ? void 0 : ref15.unitName
                                    }),
                                    (item === null || item === void 0 ? void 0 : (ref16 = item.metadata) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.wallpaper) === null || ref17 === void 0 ? void 0 : ref17.printType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t(item === null || item === void 0 ? void 0 : (ref18 = item.metadata) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.wallpaper) === null || ref19 === void 0 ? void 0 : ref19.printType)
                                    })
                                ]
                            })
                        ]
                    }),
                    (serial === null || serial === void 0 ? void 0 : (ref20 = serial.serial) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.metadata) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.wallpaper) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.print) === null || ref23 === void 0 ? void 0 : ref23.contentsCode) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        pt: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.sencondary",
                            children: t("serialNumber", {
                                serial: serial === null || serial === void 0 ? void 0 : (ref24 = serial.serial) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.metadata) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.wallpaper) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.print) === null || ref27 === void 0 ? void 0 : ref27.contentsCode
                            })
                        })
                    }),
                    (serial === null || serial === void 0 ? void 0 : (ref28 = serial.serial) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.metadata) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.wallpaper) === null || ref30 === void 0 ? void 0 : ref30.print) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: isExpired ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.sencondary",
                            sx: {
                                p: 7
                            },
                            children: t("dateExpired")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            mt: 6,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: (ref57 = serial === null || serial === void 0 ? void 0 : (ref31 = serial.serial) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.metadata) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.wallpaper) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.print) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.qrcode) === null || ref35 === void 0 ? void 0 : ref35.uri) !== null && ref57 !== void 0 ? ref57 : "",
                                    variant: "square",
                                    sx: {
                                        width: 80,
                                        height: 80
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "text.secondary",
                                    children: t("expirationDate", (0,src_object_spread/* default */.Z)({}, convertSecondsToTime(countDownSeconds)))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        mt: 6,
                        py: 3,
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.QRCode, {
                                fontSize: "small",
                                sx: {
                                    height: 19,
                                    width: 19,
                                    mb: "4px"
                                }
                            }),
                            sx: {
                                minWidth: 244
                            },
                            onClick: function() {
                                return setOpenGenerateQRConfirm(true);
                            },
                            children: t("getQRCode")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openGenerateQRConfirm,
                onClose: function() {
                    return setOpenGenerateQRConfirm(false);
                },
                title: t("generateQRConfirmTitle"),
                content: t("generateQRConfirmContent"),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        width: 212
                    },
                    loading: loading,
                    size: "large",
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onGenerateWallpaperPrintQrcode(serial.serialId).then(function() {
                                            setOpenGenerateQRComplete(true);
                                        }).catch(showError).finally(function() {
                                            setOpenGenerateQRConfirm(false);
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("ok")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openGenerateQRComplete,
                onClose: function() {
                    return setOpenGenerateQRComplete(false);
                },
                title: "",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                    src: (ref58 = item === null || item === void 0 ? void 0 : (ref36 = item.thumbnail) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.front) === null || ref37 === void 0 ? void 0 : ref37.mediumUri) !== null && ref58 !== void 0 ? ref58 : "",
                                    size: "x-small"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    alignItems: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: item === null || item === void 0 ? void 0 : item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: serial === null || serial === void 0 ? void 0 : (ref38 = serial.serial) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.sku) === null || ref39 === void 0 ? void 0 : ref39.unitName
                                        }),
                                        (item === null || item === void 0 ? void 0 : (ref40 = item.metadata) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.wallpaper) === null || ref41 === void 0 ? void 0 : ref41.printType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t(item === null || item === void 0 ? void 0 : (ref42 = item.metadata) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.wallpaper) === null || ref43 === void 0 ? void 0 : ref43.printType)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.sencondary",
                            textAlign: "start",
                            sx: {
                                width: "100%"
                            },
                            children: t("serialNumber", {
                                serial: serial === null || serial === void 0 ? void 0 : (ref44 = serial.serial) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.metadata) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.wallpaper) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.print) === null || ref47 === void 0 ? void 0 : ref47.contentsCode
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            width: "100%",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref59 = serial === null || serial === void 0 ? void 0 : (ref48 = serial.serial) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.metadata) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.wallpaper) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.print) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.qrcode) === null || ref52 === void 0 ? void 0 : ref52.uri) !== null && ref59 !== void 0 ? ref59 : "",
                                variant: "square",
                                sx: {
                                    width: 80,
                                    height: 80,
                                    mt: 6
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            mt: 6,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("QRCodeConfirmDescription")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    textAlign: "start",
                                    children: t("QRCodeConfirmNote")
                                })
                            ]
                        })
                    ]
                }),
                cancelText: t("leavingPrint")
            })
        ]
    });
};
function convertSecondsToTime(seconds) {
    if (seconds <= 0) {
        return {
            day: "00",
            time: "00:00:00"
        };
    }
    var date = new Date(seconds * 1000).toISOString();
    var day = Math.floor(seconds / (24 * 60 * 60)).toString().padStart(2, "0");
    return {
        day: day,
        time: date.substring(11, 19)
    };
}

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/KonbiniPrintModal.tsx











var KonbiniPrintModal = function(param) {
    var QRCodePrinting = param.QRCodePrinting, portfolio = param.portfolio, onClose = param.onClose, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "90dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 4,
                    px: 3
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: 44
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: t("printingContent", "コンビニプリント内容")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        size: "small",
                        onClick: onClose,
                        sx: {
                            width: 44,
                            height: 44,
                            p: "12px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                sx: (0,src_object_spread/* default */.Z)({
                    py: 4,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                alignItems: "center",
                                component: "a",
                                variant: "caption",
                                underline: "none",
                                target: "_blank",
                                display: "flex",
                                href: "https://help.utoniq.com/ja/articles/10329377",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "primary.main",
                                        children: t("printMethod")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                                        color: "primary",
                                        sx: {
                                            height: 12,
                                            width: 12,
                                            ml: 1
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                pt: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.OwnedItems, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("numberOfSheet", {
                                            sheet: (ref1 = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCodeCell, {
                        QRCodePrinting: QRCodePrinting,
                        serials: portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials,
                        item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item,
                        onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
                    })
                ]
            })
        ]
    });
};
var QRCodeCell = function(param) {
    var QRCodePrinting = param.QRCodePrinting, item = param.item, serials = param.serials, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            ".swiper": {
                px: 5,
                maxWidth: "100%"
            },
            ".swiper-pagination-bullet-active": {
                bgcolor: "grey.700"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            slidesPerView: "auto",
            spaceBetween: 20,
            modules: [
                modules/* Pagination */.tl
            ],
            pagination: {
                type: "bullets",
                clickable: true
            },
            enabled: !!serials && serials.length > 1,
            style: {
                paddingBottom: 40
            },
            children: serials === null || serials === void 0 ? void 0 : serials.map(function(serial, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        width: 315
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCodeBox, {
                        loading: QRCodePrinting,
                        item: item,
                        serial: serial,
                        onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
                    })
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailWallpaperView.tsx



















var OwnedItemDetailWallpaperView = function(param) {
    var loading = param.loading, QRCodePrinting = param.QRCodePrinting, portfolio = param.portfolio, user = param.user, isFlipped = param.isFlipped, customProfileUpdating = param.customProfileUpdating, onReverseThumbnail = param.onReverseThumbnail, onClickProtectUserItem = param.onClickProtectUserItem, onSetWallpaper = param.onSetWallpaper, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage, onImageDownload = param.onImageDownload, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var audioResource = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : (ref1 = ref.wallpaperResources) === null || ref1 === void 0 ? void 0 : ref1.audioResource;
    var ref16 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref16.showError, showMessage = ref16.showMessage;
    var ref17 = (0,router_useRouter/* useRouter */.tv)(), router = ref17.router, routerPages = ref17.routerPages;
    var ref18 = (0,react.useState)(false), open = ref18[0], setOpen = ref18[1];
    var ref19 = (0,react.useState)(false), downloading = ref19[0], setDownloading = ref19[1];
    var ref20 = (0,react.useState)(false), changing = ref20[0], setChanging = ref20[1];
    var ref21 = (0,react.useState)(false), openImageDownloadConfirm = ref21[0], setOpenImageDownloadConfirm = ref21[1];
    var ref22 = (0,react.useState)(false), openCustomProfileModal = ref22[0], setOpenCustomProfileModal = ref22[1];
    var ref23 = (0,react.useState)(!!(user === null || user === void 0 ? void 0 : (ref2 = user.customProfile) === null || ref2 === void 0 ? void 0 : ref2.wallpaperItem) && (portfolio === null || portfolio === void 0 ? void 0 : (ref3 = portfolio.item) === null || ref3 === void 0 ? void 0 : ref3.id) === (user === null || user === void 0 ? void 0 : (ref4 = user.customProfile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.wallpaperItem) === null || ref5 === void 0 ? void 0 : ref5.id)), unset = ref23[0], setUnset = ref23[1];
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var handleDownloadImage = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(url) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDownloading(true);
                        return [
                            4,
                            onImageDownload(url).then(function() {
                                (0,native_app/* isNativePlatform */.gx)() && setOpenImageDownloadConfirm(true);
                                setDownloading(false);
                            }).catch(function() {
                                return setDownloading(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownloadImage(url) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetWallpaper = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setChanging(true);
                        return [
                            4,
                            onSetWallpaper().then(function(unsetWallpaper) {
                                setUnset(unsetWallpaper);
                                showMessage(unsetWallpaper ? t("setBackground") : t("cancelBackground"), "info", /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "text",
                                    size: "small",
                                    sx: {
                                        color: "white"
                                    },
                                    loading: loading,
                                    onClick: function() {
                                        return router.push(routerPages.MyProfile);
                                    },
                                    children: t("seeProfile")
                                }));
                            }).catch(function() {
                                return showError(t("noSettingConfirmContent"));
                            }).finally(function() {
                                setOpenCustomProfileModal(false);
                                setChanging(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetWallpaper() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref24, ref25;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmCustomProfileSettingModal, {
                open: openCustomProfileModal,
                onClose: function() {
                    return setOpenCustomProfileModal(false);
                },
                onClick: function() {
                    return handleSetWallpaper();
                },
                loading: changing,
                unset: unset,
                type: portfolio === null || portfolio === void 0 ? void 0 : (ref6 = portfolio.item) === null || ref6 === void 0 ? void 0 : ref6.type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openImageDownloadConfirm,
                onClose: function() {
                    return setOpenImageDownloadConfirm(false);
                },
                content: null,
                title: t("wallpaperDownloaded"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        width: 212
                    },
                    size: "large",
                    onClick: function() {
                        return setOpenImageDownloadConfirm(false);
                    },
                    children: t("ok")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrinterBottomSheet, {
                open: open,
                QRCodePrinting: QRCodePrinting,
                onClose: function() {
                    return setOpen(false);
                },
                portfolio: portfolio,
                onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    flex: "1 0 auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    position: "relative",
                                    ".MuiButtonBase-root": {
                                        height: "fit-content"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                        onOpenFullScreen: onOpenFullScreen,
                                        onOpenMultipleImage: onOpenMultipleImage,
                                        numberImage: (ref24 = portfolio === null || portfolio === void 0 ? void 0 : (ref7 = portfolio.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.images) === null || ref8 === void 0 ? void 0 : ref8.length) !== null && ref24 !== void 0 ? ref24 : 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                        loading: loading,
                                        flipProps: {
                                            isFlipped: isFlipped
                                        },
                                        imageAreaProps: {
                                            thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref9 = portfolio.item) === null || ref9 === void 0 ? void 0 : ref9.thumbnail,
                                            size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                            onClick: onReverseThumbnail
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                                portfolio: portfolio
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    mt: 4,
                                    mb: 2
                                },
                                direction: "row",
                                spacing: 6,
                                children: [
                                    audioResource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
                                        resource: audioResource,
                                        bgcolor: "primary.main",
                                        color: "white"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                                        size: "small",
                                        onClick: onReverseThumbnail,
                                        bgcolor: "primary.main",
                                        color: "white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Background, {
                                        size: "small",
                                        onClick: function() {
                                            return setOpenCustomProfileModal(true);
                                        },
                                        bgcolor: unset ? "grey.100" : "primary.main",
                                        color: unset ? "grey.300" : "white"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    my: 2
                                },
                                spacing: 4,
                                direction: "row",
                                children: [
                                    (portfolio === null || portfolio === void 0 ? void 0 : (ref10 = portfolio.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.metadata) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.wallpaper) === null || ref12 === void 0 ? void 0 : ref12.isPrintEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "outlined",
                                        onClick: function() {
                                            return setOpen(true);
                                        },
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Printer, {
                                            sx: {
                                                color: "grey.700"
                                            }
                                        }),
                                        children: t("storePrint", "コンビニプリント")
                                    }),
                                    (portfolio === null || portfolio === void 0 ? void 0 : (ref13 = portfolio.item) === null || ref13 === void 0 ? void 0 : ref13.isDownloadable) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "outlined",
                                        onClick: function() {
                                            var ref, ref1, ref2;
                                            return handleDownloadImage(portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : (ref1 = ref.wallpaperResources) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaperResource) === null || ref2 === void 0 ? void 0 : ref2.uri);
                                        },
                                        loading: downloading,
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Download, {
                                            sx: {
                                                color: "grey.700"
                                            }
                                        }),
                                        children: t("downloadWallpaper")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                        sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                        itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                        commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                        relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                        artistId: (ref25 = (ref14 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref14 === void 0 ? void 0 : ref14.id) !== null && ref25 !== void 0 ? ref25 : "",
                        isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                        issuableNft: !!((ref15 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref15 === void 0 ? void 0 : ref15.chains),
                        onClickProtectUserItem: onClickProtectUserItem
                    })
                ]
            })
        ]
    });
};
var PrinterBottomSheet = function(param) {
    var QRCodePrinting = param.QRCodePrinting, open = param.open, onClose = param.onClose, portfolio = param.portfolio, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: onClose,
        sx: {
            zIndex: 1300
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            height: "calc(95dvh - ".concat(styles/* styles.safeAreaTop */.W2.safeAreaTop, ")"),
            sx: {
                bgcolor: "background.default"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KonbiniPrintModal, {
                    QRCodePrinting: QRCodePrinting,
                    onClose: onClose,
                    portfolio: portfolio,
                    onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailMerchView.tsx











var OwnedItemDetailMerchView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onClickProtectUserItem = param.onClickProtectUserItem, onReverseThumbnail = param.onReverseThumbnail, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref4.routerPages, router = ref4.router;
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            position: "relative",
                            ".MuiButtonBase-root": {
                                height: "fit-content"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                onOpenFullScreen: onOpenFullScreen,
                                onOpenMultipleImage: onOpenMultipleImage,
                                numberImage: (ref5 = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref5 !== void 0 ? ref5 : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                loading: loading,
                                flipProps: {
                                    isFlipped: isFlipped
                                },
                                imageAreaProps: {
                                    thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                                    size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                    onClick: onReverseThumbnail
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                        portfolio: portfolio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 4,
                            mb: 2
                        },
                        direction: "row",
                        spacing: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Rotate, {
                            size: "small",
                            onClick: onReverseThumbnail,
                            bgcolor: "primary.main",
                            color: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref6 = (ref2 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref3 === void 0 ? void 0 : ref3.chains),
                onClickMerch: function() {
                    return router.push(routerPages.DeliveryManagement);
                },
                onClickProtectUserItem: onClickProtectUserItem
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./src/components/organisms/item/TicketNumberBox/index.tsx











var TicketNumberBox = function(param) {
    var loggedUser = param.loggedUser, item = param.item, serials = param.serials;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var swiperRef = (0,react.useRef)(null);
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref10 = (0,react.useState)(0), throughTicketIndex = ref10[0], setThroughTicketIndex = ref10[1];
    var isThroughTicket = !!(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.isThroughTicket);
    var ref11;
    var throughTickets = (ref11 = item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.throughTicket) !== null && ref11 !== void 0 ? ref11 : [
        {
            name: null
        }, 
    ];
    var showMessWaitAssignSeat = (0,react.useMemo)(function() {
        var ref, ref1;
        return checkShowMessWaitAssignSeat(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.assignedNumberType, serials, throughTicketIndex);
    }, [
        item === null || item === void 0 ? void 0 : (ref4 = item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.assignedNumberType,
        serials,
        throughTicketIndex
    ]);
    if (!(serials === null || serials === void 0 ? void 0 : serials.length) || showMessWaitAssignSeat) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            width: "100%",
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                width: "100%",
                borderRadius: "6px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    px: 4,
                    py: 3,
                    "&:last-child": {
                        pb: 3
                    }
                },
                children: [
                    !!(throughTickets === null || throughTickets === void 0 ? void 0 : throughTickets.length) && isThroughTicket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        pb: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Prev, {
                                onClick: function() {
                                    var ref, ref1;
                                    swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.enable();
                                    swiperRef === null || swiperRef === void 0 ? void 0 : (ref1 = swiperRef.current) === null || ref1 === void 0 ? void 0 : ref1.swiper.slidePrev();
                                },
                                bgcolor: "grey.100",
                                sx: {
                                    bgcolor: "grey.100",
                                    visibility: throughTicketIndex === 0 ? "hidden" : "visible"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    width: "100%",
                                    align: "center",
                                    children: (ref6 = throughTickets[throughTicketIndex]) === null || ref6 === void 0 ? void 0 : ref6.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Next, {
                                bgcolor: "grey.100",
                                onClick: function() {
                                    var ref, ref1;
                                    swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.enable();
                                    swiperRef === null || swiperRef === void 0 ? void 0 : (ref1 = swiperRef.current) === null || ref1 === void 0 ? void 0 : ref1.swiper.slideNext();
                                },
                                sx: {
                                    bgcolor: "grey.100",
                                    visibility: throughTicketIndex + 1 === throughTickets.length ? "hidden" : "visible"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: "6px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketLabel, {
                                serial: serials === null || serials === void 0 ? void 0 : (ref7 = serials[0]) === null || ref7 === void 0 ? void 0 : ref7.serial,
                                assignedNumberType: item === null || item === void 0 ? void 0 : (ref8 = item.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : ref9.assignedNumberType
                            }),
                            (item === null || item === void 0 ? void 0 : item.isTicketDistributionEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("distribute", "分配状況")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ref: swiperRef,
                        loop: false,
                        spaceBetween: 20,
                        allowTouchMove: false,
                        enabled: (throughTickets === null || throughTickets === void 0 ? void 0 : throughTickets.length) > 1,
                        onActiveIndexChange: function(swiper) {
                            return setThroughTicketIndex(swiper.activeIndex);
                        },
                        children: throughTickets === null || throughTickets === void 0 ? void 0 : throughTickets.map(function(_, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketContainer, {
                                    serials: serials,
                                    loggedUser: loggedUser,
                                    isThroughTicket: isThroughTicket,
                                    throughTicketIndex: index,
                                    isTicketDistributionEnabled: !!(item === null || item === void 0 ? void 0 : item.isTicketDistributionEnabled)
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
var TicketLabel = function(param) {
    var assignedNumberType = param.assignedNumberType, serial = param.serial, typographyProps = param.typographyProps;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ticketLabel = (0,react.useMemo)(function() {
        if (assignedNumberType === utoniq_core_schema/* TicketItemMetadataAssignedNumberType.Seat */.Nay.Seat) {
            return t("seatNumberLabel", "座席番号");
        }
        if (serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber) {
            return t("referenceNumberLabel", "整理番号");
        }
        return t("serialNumberLabel", "シリアルナンバー");
    }, [
        assignedNumberType,
        serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        component: "p",
        variant: "caption"
    }, typographyProps), {
        children: ticketLabel
    }));
};
var TicketContainer = function(param) {
    var loggedUser = param.loggedUser, serials = param.serials, throughTicketIndex = param.throughTicketIndex, isThroughTicket = param.isThroughTicket, isTicketDistributionEnabled = param.isTicketDistributionEnabled;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generateQueryPath = ref.generateQueryPath;
    var getTicket = (0,react.useCallback)(function(serial) {
        var ref, ref1;
        var label = getSerialFormatNumber(serial.serial, isThroughTicket ? throughTicketIndex : undefined);
        if (isThroughTicket) {
            var ref2, ref3, ref4;
            return {
                label: label,
                isUsed: (ref2 = serial.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketStatus) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.throughTicket) === null || ref4 === void 0 ? void 0 : ref4[throughTicketIndex].isUsed
            };
        }
        return {
            label: label,
            isUsed: (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.isUsed
        };
    }, [
        isThroughTicket,
        throughTicketIndex
    ]);
    var getTicketStatusNode = (0,react.useCallback)(function(serial, isUsed) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var disabledLink = (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid) === (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.id) || isUsed || !isTicketDistributionEnabled;
        var isOwnerTicket = (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid) === (serial === null || serial === void 0 ? void 0 : (ref3 = serial.serial) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.owner) === null || ref4 === void 0 ? void 0 : ref4.id);
        if ((ref5 = serial.serial) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticketDistributionLink) === null || ref6 === void 0 ? void 0 : ref6.user) {
            var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var ref18;
            return {
                href: generateQueryPath(routerPages.TicketShareCopy, {
                    itemId: router.query.itemId,
                    serialId: serial.serialId
                }, {
                    throughTicketIndex: isThroughTicket ? throughTicketIndex.toString() : ""
                }),
                disabledLink: (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid) === (serial === null || serial === void 0 ? void 0 : (ref10 = serial.serial) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.ticketDistributionLink) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.user) === null || ref12 === void 0 ? void 0 : ref12.id) || isUsed,
                ticketStatusNode: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: (ref18 = isOwnerTicket ? (ref13 = serial.serial.ticketDistributionLink.user.avatar) === null || ref13 === void 0 ? void 0 : ref13.smallUri : (ref14 = serial.serial) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.owner) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.avatar) === null || ref16 === void 0 ? void 0 : ref16.smallUri) !== null && ref18 !== void 0 ? ref18 : "",
                            sx: {
                                width: 16,
                                height: 16
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "text.secondary",
                            children: isOwnerTicket ? t("distributedToUser", {
                                name: serial.serial.ticketDistributionLink.user.displayName
                            }) : t("receivedFromUser", {
                                name: (ref17 = serial.serial.owner) === null || ref17 === void 0 ? void 0 : ref17.displayName
                            })
                        })
                    ]
                })
            };
        }
        if (((ref7 = serial.serial) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.ticketDistributionLink) === null || ref8 === void 0 ? void 0 : ref8.isExpired) && isTicketDistributionEnabled && !isUsed) {
            return {
                href: generateQueryPath(routerPages.TicketShareSelect, {
                    itemId: router.query.itemId,
                    serialId: serial.serialId
                }, {
                    throughTicketIndex: isThroughTicket ? throughTicketIndex.toString() : ""
                }),
                disabledLink: disabledLink,
                ticketStatusNode: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            color: "error",
                            sx: {
                                width: 16,
                                height: 16
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "error.main",
                            children: t("distributionURLExpired", "分配URL期限切れ")
                        })
                    ]
                })
            };
        }
        if (((ref9 = serial.serial) === null || ref9 === void 0 ? void 0 : ref9.ticketDistributionLink) && isTicketDistributionEnabled && !isUsed) {
            return {
                href: generateQueryPath(routerPages.TicketShareCopy, {
                    itemId: router.query.itemId,
                    serialId: serial.serialId
                }, {
                    throughTicketIndex: isThroughTicket ? throughTicketIndex.toString() : ""
                }),
                disabledLink: disabledLink,
                ticketStatusNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "text.secondary",
                    children: t("distribution", "分配中")
                })
            };
        }
        if (isTicketDistributionEnabled) {
            return {
                href: generateQueryPath(routerPages.TicketShareSelect, {
                    itemId: router.query.itemId,
                    serialId: serial.serialId
                }, {
                    throughTicketIndex: isThroughTicket ? throughTicketIndex.toString() : ""
                }),
                disabledLink: disabledLink,
                ticketStatusNode: null
            };
        }
        return {
            href: null,
            disabledLink: disabledLink,
            ticketStatusNode: null
        };
    }, [
        loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid,
        isTicketDistributionEnabled,
        generateQueryPath,
        routerPages.TicketShareCopy,
        routerPages.TicketShareSelect,
        router.query.itemId,
        isThroughTicket,
        throughTicketIndex,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 2,
            children: sortBy_default()(serials, function(serial) {
                return serial.formattedSerialNumber;
            }).map(function(serial) {
                var ref = getTicket(serial), label = ref.label, isUsed = ref.isUsed;
                var ref1 = getTicketStatusNode(serial, !!isUsed), href = ref1.href, disabledLink = ref1.disabledLink, ticketStatusNode = ref1.ticketStatusNode;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    alignItems: "center",
                    justifyContent: "space-between",
                    py: "2px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                isUsed && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                    color: "primary",
                                    sx: {
                                        width: 16,
                                        height: 16
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    component: !disabledLink ? Link/* default */.Z : "p",
                                    href: !disabledLink && href ? href : undefined,
                                    color: !disabledLink ? "primary.main" : "text.primary",
                                    sx: {
                                        whiteSpace: "nowrap"
                                    },
                                    children: label
                                })
                            ]
                        }),
                        ticketStatusNode
                    ]
                }, serial.id);
            })
        })
    });
};
function checkShowMessWaitAssignSeat(assignedNumberType, serials, throughTicketIndex) {
    if (assignedNumberType !== utoniq_core_schema/* TicketItemMetadataAssignedNumberType.Seat */.Nay.Seat || !(serials === null || serials === void 0 ? void 0 : serials.length)) {
        return false;
    }
    var isThroughTicket = serials === null || serials === void 0 ? void 0 : serials.some(function(serial) {
        var ref, ref1, ref2;
        return (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : ref2.length;
    });
    if (isThroughTicket) {
        return serials === null || serials === void 0 ? void 0 : serials.some(function(serial) {
            var ref, ref1, ref2, ref3;
            return ((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[throughTicketIndex]) === null || ref3 === void 0 ? void 0 : ref3.seat) === null;
        });
    }
    return serials === null || serials === void 0 ? void 0 : serials.some(function(serial) {
        var ref;
        return ((ref = serial.serial) === null || ref === void 0 ? void 0 : ref.formattedAssignedNumber) === null;
    });
}
function getSerialFormatNumber(serial, throughTicketIndex) {
    if (throughTicketIndex !== undefined) {
        var ref, ref1, ref2;
        var ref3, ref4, ref5;
        return (ref5 = (ref4 = (ref3 = serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : (ref1 = ref.throughTicket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[+throughTicketIndex]) === null || ref2 === void 0 ? void 0 : ref2.seat) !== null && ref3 !== void 0 ? ref3 : serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber) !== null && ref4 !== void 0 ? ref4 : serial === null || serial === void 0 ? void 0 : serial.formattedSerialNumber) !== null && ref5 !== void 0 ? ref5 : "";
    }
    var ref6, ref7;
    return (ref7 = (ref6 = serial === null || serial === void 0 ? void 0 : serial.formattedAssignedNumber) !== null && ref6 !== void 0 ? ref6 : serial === null || serial === void 0 ? void 0 : serial.formattedSerialNumber) !== null && ref7 !== void 0 ? ref7 : "";
}

;// CONCATENATED MODULE: ./src/components/organisms/item/TicketSelect/index.tsx





var TicketSelect = function(param) {
    var serial = param.serial, throughTicketIndex = param.throughTicketIndex, selected = param.selected, onSelect = param.onSelect;
    var ref, ref1, ref2, ref3;
    var canUseTicket = (0,react.useMemo)(function() {
        var ref;
        return checkUserCanUseTicket((ref = serial.serial) === null || ref === void 0 ? void 0 : ref.ticketStatus, throughTicketIndex);
    }, [
        (ref = serial.serial) === null || ref === void 0 ? void 0 : ref.ticketStatus,
        throughTicketIndex
    ]);
    var label = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (throughTicketIndex !== undefined && ((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : ref2[throughTicketIndex].seat)) {
            var ref4, ref5, ref6;
            return (ref4 = serial.serial) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticketStatus) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.throughTicket) === null || ref6 === void 0 ? void 0 : ref6[throughTicketIndex].seat;
        }
        var ref7;
        return (ref7 = (ref3 = serial.serial) === null || ref3 === void 0 ? void 0 : ref3.formattedAssignedNumber) !== null && ref7 !== void 0 ? ref7 : serial.formattedSerialNumber;
    }, [
        serial.formattedSerialNumber,
        (ref1 = serial.serial) === null || ref1 === void 0 ? void 0 : ref1.formattedAssignedNumber,
        (ref2 = serial.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketStatus) === null || ref3 === void 0 ? void 0 : ref3.throughTicket,
        throughTicketIndex, 
    ]);
    var colorThemeApp = (0,react.useMemo)(function() {
        if (config_config/* config.applicationKey */.v.applicationKey === "greenticket") {
            return {
                icon: "secondary.dark",
                bg: "secondary.light"
            };
        }
        return {
            icon: "primary.main",
            bg: "grey.50"
        };
    }, [
        config_config/* config.applicationKey */.v.applicationKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
        disabled: !canUseTicket,
        sx: {
            width: "100%",
            borderRadius: 2,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: selected ? colorThemeApp.bg : "grey.200",
            bgcolor: selected ? colorThemeApp.bg : "transparent",
            p: 4,
            "&.Mui-disabled": {
                bgcolor: "grey.100",
                borderColor: "grey.100"
            }
        },
        onClick: function() {
            return onSelect(serial.serialId);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            flex: 1,
            direction: "row",
            spacing: 2,
            alignItems: "center",
            children: [
                selected || !canUseTicket ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Complete, {
                    sx: {
                        color: !canUseTicket ? "grey.50" : colorThemeApp.icon
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Ticket, {
                    bgcolor: "grey.50",
                    color: "grey.700",
                    sx: {
                        pointerEvents: "none",
                        width: 24,
                        height: 24,
                        svg: {
                            fontSize: "16px"
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        align: "left",
                        color: !canUseTicket ? "text.disabled" : "text.primary",
                        children: label
                    })
                })
            ]
        })
    });
};
/**
 * check user can use ticket
 * @param ticketStatus
 * @param throughTicketIndex
 */ function checkUserCanUseTicket(ticketStatus, throughTicketIndex) {
    // check ticket expired
    if (ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.isExpired) {
        return false;
    }
    // check throughTicket is used
    if (throughTicketIndex !== undefined) {
        var ref;
        return !(ticketStatus === null || ticketStatus === void 0 ? void 0 : (ref = ticketStatus.throughTicket) === null || ref === void 0 ? void 0 : ref[throughTicketIndex].isUsed);
    }
    return !!(ticketStatus === null || ticketStatus === void 0 ? void 0 : ticketStatus.canUseTicket);
}

;// CONCATENATED MODULE: ./src/components/organisms/item/TicketContainer/index.tsx






var TicketContainer_TicketContainer = function(param) {
    var serials = param.serials, throughTicketIndex = param.throughTicketIndex, onSelectSerial = param.onSelectSerial, selectedSerials = param.selectedSerials;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 2,
            children: sortBy_default()(serials, function(serial) {
                return serial.formattedSerialNumber;
            }).map(function(serial) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelect, {
                    selected: selectedSerials.findIndex(function(id) {
                        return id === serial.serialId;
                    }) >= 0,
                    throughTicketIndex: throughTicketIndex,
                    serial: serial,
                    onSelect: onSelectSerial
                }, serial.serialId);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/SwipeButton/index.tsx






var SwipeButton = function(param) {
    var _size = param.size, size = _size === void 0 ? "medium" : _size, textOn = param.textOn, textOff = param.textOff, loading = param.loading, disabled = param.disabled, succeed = param.succeed, onClick = param.onClick, fullWidth = param.fullWidth, _color = param.color, color = _color === void 0 ? "primary" : _color, _openConfirm = param.openConfirm, openConfirm = _openConfirm === void 0 ? false : _openConfirm, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse;
    var palette = (0,useTheme/* default */.Z)().palette;
    var container = (0,react.useRef)(null);
    var slider = (0,react.useRef)(null);
    var btnSlider = (0,react.useRef)(null);
    var sliderLeft = (0,react.useRef)(0);
    var containerWidth = (0,react.useRef)(0);
    var startX = (0,react.useRef)(0);
    var isDragging = (0,react.useRef)(false);
    var unmounted = (0,react.useRef)(false);
    var ref = (0,react.useState)(false), unlocked = ref[0], setUnlocked = ref[1];
    var width = (size === "large" ? 60 : 44) - 8;
    var isTouchDevice = (0,react.useMemo)(function() {
        if (false) {}
        return "ontouchstart" in document.documentElement;
    }, []);
    var updateSliderStyle = (0,react.useCallback)(function() {
        if (unmounted.current || unlocked) return;
        if (!slider.current) {
            return;
        }
        if (!sliderLeft.current) {
            slider.current.style.left = width - 4 + "px";
        } else {
            slider.current.style.left = sliderLeft.current + width + "px";
        }
        if (!btnSlider.current) return;
        // update bgcolor of btn slide when user scroll about 5px
        if (sliderLeft.current > 5) {
            btnSlider.current.style.backgroundColor = "".concat(palette.grey["200"]);
        } else {
            btnSlider.current.style.backgroundColor = "white";
        }
    }, [
        unlocked,
        palette,
        reverse
    ]);
    var onDrag = (0,react.useCallback)(// eslint-disable-next-line
    function(e) {
        if (unmounted.current || unlocked) return;
        if (isDragging.current) {
            if (isTouchDevice) {
                var ref, ref1, ref2, ref3;
                var ref4, ref5;
                sliderLeft.current = Math.min(Math.max(0, reverse ? startX.current - ((ref4 = (ref = e.touches) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.clientX) !== null && ref4 !== void 0 ? ref4 : 0) : ((ref5 = (ref2 = e.touches) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.clientX) !== null && ref5 !== void 0 ? ref5 : 0) - startX.current), containerWidth.current);
            } else {
                sliderLeft.current = Math.min(Math.max(0, reverse ? startX.current - e.clientX : e.clientX - startX.current), containerWidth.current);
            }
            updateSliderStyle();
        }
    }, [
        isTouchDevice,
        unlocked,
        updateSliderStyle,
        reverse
    ]);
    var reset = (0,react.useCallback)(function() {
        if (unmounted.current) return;
        if (openConfirm) {
            sliderLeft.current = "100%";
            return;
        }
        setUnlocked(false);
        sliderLeft.current = 0;
        updateSliderStyle();
    }, [
        updateSliderStyle,
        openConfirm
    ]);
    var onSuccess = (0,react.useCallback)(function() {
        setUnlocked(true);
        if (container.current) {
            container.current.style.width = container.current.clientWidth + "px";
        }
        onClick().catch(function() {
            return reset();
        });
    }, [
        onClick,
        reset
    ]);
    var stopDrag = (0,react.useCallback)(function() {
        if (unmounted.current || unlocked || !isDragging.current) return;
        isDragging.current = false;
        if (sliderLeft.current > containerWidth.current * 0.9) {
            sliderLeft.current = containerWidth.current;
            onSuccess();
        } else {
            sliderLeft.current = 0;
        }
        updateSliderStyle();
    }, [
        unlocked,
        updateSliderStyle,
        onSuccess
    ]);
    var startDrag = (0,react.useCallback)(function(e) {
        if (unmounted.current || unlocked) return;
        isDragging.current = true;
        if (isTouchDevice && "touches" in e) {
            var ref, ref1;
            var ref2;
            startX.current = (ref2 = (ref = e.touches) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.clientX) !== null && ref2 !== void 0 ? ref2 : 0;
        }
        if (!isTouchDevice && "clientX" in e) {
            var _clientX;
            startX.current = (_clientX = e.clientX) !== null && _clientX !== void 0 ? _clientX : 0;
        }
    }, [
        isTouchDevice,
        unlocked
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (isTouchDevice) {
            document.addEventListener("touchmove", onDrag);
            document.addEventListener("touchend", stopDrag);
        } else {
            document.addEventListener("mousemove", onDrag);
            document.addEventListener("mouseup", stopDrag);
        }
        var ref1;
        containerWidth.current = ((ref1 = (ref = container.current) === null || ref === void 0 ? void 0 : ref.clientWidth) !== null && ref1 !== void 0 ? ref1 : 0) - (width - 4);
        return function() {
            if (isTouchDevice) {
                document.removeEventListener("touchmove", onDrag);
                document.removeEventListener("touchend", stopDrag);
            } else {
                document.removeEventListener("mousemove", onDrag);
                document.removeEventListener("mouseup", stopDrag);
            }
        };
    }, [
        isTouchDevice,
        onDrag,
        stopDrag
    ]);
    (0,react.useEffect)(function() {
        if (succeed !== undefined) {
            setUnlocked(succeed);
            if (!succeed) {
                reset();
            } else {
                sliderLeft.current = containerWidth.current;
                updateSliderStyle();
            }
        }
    }, [
        succeed,
        reset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            disabled: unlocked || loading || succeed || disabled,
            loading: loading,
            disableRipple: true,
            color: color,
            fullWidth: fullWidth,
            sx: {
                borderRadius: 1,
                width: fullWidth ? undefined : 244,
                height: size === "large" ? 60 : 44,
                px: 2,
                py: 1,
                overflow: "hidden",
                "*": {
                    userSelect: "none",
                    WebkitTouchCallout: "none"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    bgcolor: "inherit",
                    visibility: loading ? "hidden" : "visibility"
                },
                alignItems: "center",
                justifyContent: "center",
                ref: container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        ref: slider,
                        onMouseDown: startDrag,
                        onTouchStart: startDrag,
                        alignItems: "center",
                        justifyContent: "center",
                        sx: (0,src_object_spread/* default */.Z)({
                            width: "100%",
                            position: "absolute",
                            height: width,
                            top: 0,
                            left: width - 4,
                            ml: "-100%",
                            zIndex: 2,
                            cursor: "pointer",
                            bgcolor: "inherit"
                        }, unlocked ? {
                            left: "100%",
                            pointerEvents: "none",
                            cursor: "default"
                        } : {}),
                        children: [
                            unlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                style: {
                                    width: "100%"
                                },
                                in: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: size === "large" ? "h5" : "subtitle1",
                                    align: "center",
                                    width: "100%",
                                    color: "text.hint",
                                    children: textOff
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                ref: btnSlider,
                                alignItems: "center",
                                justifyContent: "center",
                                sx: {
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    width: width,
                                    height: width,
                                    bgcolor: unlocked || disabled ? "grey.200" : "white",
                                    borderRadius: 1
                                },
                                children: unlocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                    style: {
                                        height: 20
                                    },
                                    in: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                        sx: {
                                            color: "grey.400",
                                            width: size === "large" ? 28 : 20,
                                            height: size === "large" ? 28 : 20,
                                            mt: size === "large" ? -1 : 0
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                    style: {
                                        height: 20
                                    },
                                    in: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Transition, {
                                        color: color,
                                        sx: {
                                            color: disabled ? "grey.400" : undefined,
                                            width: size === "large" ? 28 : 20,
                                            height: size === "large" ? 28 : 20,
                                            mt: size === "large" ? -1 : 0
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    !unlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        style: {
                            width: "100%"
                        },
                        in: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: size === "large" ? "h5" : "subtitle1",
                            align: "center",
                            width: "100%",
                            color: "white",
                            children: textOn
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/components/resourceView/OwnedItemDetailTicketView.tsx
























var OwnedItemDetailTicketView = function(param) {
    var loading = param.loading, portfolio = param.portfolio, isFlipped = param.isFlipped, onReverseThumbnail = param.onReverseThumbnail, onClickProtectUserItem = param.onClickProtectUserItem, onUseTicket = param.onUseTicket, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage, loggedUser = param.loggedUser;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react.useState)(false), displayResource = ref9[0], setDisplayResource = ref9[1];
    var onClickDisplayResource = function() {
        return setDisplayResource(function(prev) {
            return !prev;
        });
    };
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref10.routerPages, generatePath = ref10.generatePath;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var serialsFiltered = (0,react.useMemo)(function() {
        var ref;
        return portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.filter(function(serial) {
            var ref, ref1, ref2;
            // case not share or user not accept item
            return !((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.id) || // user not accept item and user accept is user login
            serial.serial.ticketDistributionLink.user.id === (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid);
        });
    }, [
        portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials,
        loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.uid
    ]);
    var ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    position: "relative",
                                    ".MuiButtonBase-root": {
                                        height: "fit-content"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailActionAreaCell, {
                                        onOpenFullScreen: onOpenFullScreen,
                                        onOpenMultipleImage: onOpenMultipleImage,
                                        numberImage: (ref11 = (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.images) === null || ref === void 0 ? void 0 : ref.length) !== null && ref11 !== void 0 ? ref11 : 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                                        loading: loading,
                                        flipProps: {
                                            isFlipped: isFlipped
                                        },
                                        imageAreaProps: {
                                            thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                                            size: (portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? "x-large-square" : "x-large",
                                            onClick: onReverseThumbnail
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription_ItemDescriptionCell, {
                                portfolio: portfolio
                            })
                        ]
                    }),
                    (portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collection) === null || ref3 === void 0 ? void 0 : ref3.event) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 2,
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "outlined",
                            href: generatePath(routerPages.MyOwnedTickets, {
                                eventId: portfolio === null || portfolio === void 0 ? void 0 : (ref4 = portfolio.item) === null || ref4 === void 0 ? void 0 : ref4.collection.event.id
                            }),
                            onClick: function() {
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventPickupList", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    type: "ownedItem"
                                });
                            },
                            children: t("toPickup")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketNumberBox, {
                                loggedUser: loggedUser,
                                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item,
                                serials: portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    mt: 4,
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    size: "large",
                                    onClick: onClickDisplayResource,
                                    disabled: !(serialsFiltered === null || serialsFiltered === void 0 ? void 0 : serialsFiltered.length),
                                    children: t("showTicketToUse")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketInfoDrawer, {
                open: displayResource,
                onClose: onClickDisplayResource,
                item: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item,
                serials: serialsFiltered,
                onUseTicket: onUseTicket,
                user: portfolio === null || portfolio === void 0 ? void 0 : portfolio.user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkSet_SupplementLinkSetCell, {
                sku: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.sku,
                itemId: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.id,
                commentCount: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.commentCount,
                relatedMissions: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.relatedMissions,
                artistId: (ref12 = (ref5 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.issuedArtist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref12 !== void 0 ? ref12 : "",
                isUserProtected: portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected,
                issuableNft: !!((ref6 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.nft) === null || ref6 === void 0 ? void 0 : ref6.chains),
                onClickProtectUserItem: onClickProtectUserItem,
                isResaleAvailable: portfolio === null || portfolio === void 0 ? void 0 : (ref7 = portfolio.item) === null || ref7 === void 0 ? void 0 : ref7.isResaleAvailable,
                isResaled: !!(portfolio === null || portfolio === void 0 ? void 0 : (ref8 = portfolio.item) === null || ref8 === void 0 ? void 0 : ref8.userOpenResaleItem)
            })
        ]
    });
};
var TicketInfoDrawer = function(param) {
    var open = param.open, item = param.item, serials = param.serials, onClose = param.onClose, onUseTicket = param.onUseTicket, user = param.user;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref22 = (0,core_i18n/* useTranslation */.$G)(), tCommon = ref22.t;
    var ref23 = (0,react.useState)(false), loading = ref23[0], setLoading = ref23[1];
    var ref24 = (0,react.useState)(true), isRotate = ref24[0], setIsRotate = ref24[1];
    var ref25 = (0,react.useState)([]), selectedSerials = ref25[0], setSelectedSerials = ref25[1];
    var ref26 = (0,react.useState)(undefined), selectedThroughTicketName = ref26[0], setSelectedThroughTicketName = ref26[1];
    var ref27 = (0,react.useState)(0), throughTicketIndex = ref27[0], setThroughTicketIndex = ref27[1];
    var ref28 = (0,react.useState)(false), openConfirm = ref28[0], setOpenConfirm = ref28[1];
    var ref29 = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!serials) {
            return {
                disabled: false,
                formattedUsedAt: null,
                unusedCount: 0,
                succeed: false
            };
        }
        if (item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.isThroughTicket) {
            var ref4, ref5, ref6, ref7;
            var unusedCount = serials.filter(function(serial) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                return ((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.isExpired) || !((ref2 = serial.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketStatus) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.throughTicket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[throughTicketIndex]) === null || ref5 === void 0 ? void 0 : ref5.isUsed);
            }).length;
            var ref8 = (0,_sliced_to_array/* default */.Z)(orderBy_default()(serials.filter(function(serial) {
                var ref, ref1, ref2, ref3;
                return (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[throughTicketIndex]) === null || ref3 === void 0 ? void 0 : ref3.usedAt;
            }), [
                "serial.ticketStatus.throughTicket[".concat(throughTicketIndex, "].usedAt")
            ], [
                "desc"
            ]), 1), lasted = ref8[0];
            var usedAllTicket = !unusedCount;
            var ref9;
            return {
                disabled: usedAllTicket,
                unusedCount: unusedCount,
                formattedUsedAt: (ref9 = lasted === null || lasted === void 0 ? void 0 : (ref4 = lasted.serial) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticketStatus) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.throughTicket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[throughTicketIndex]) === null || ref7 === void 0 ? void 0 : ref7.formattedUsedAt) !== null && ref9 !== void 0 ? ref9 : null,
                succeed: usedAllTicket
            };
        }
        if (serials.length === 1) {
            var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
            var ref19;
            return {
                disabled: !(serials === null || serials === void 0 ? void 0 : (ref10 = serials[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.serial) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.ticketStatus) === null || ref12 === void 0 ? void 0 : ref12.canUseTicket),
                unusedCount: 1,
                formattedUsedAt: (ref19 = serials === null || serials === void 0 ? void 0 : (ref13 = serials[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.serial) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.ticketStatus) === null || ref15 === void 0 ? void 0 : ref15.formattedUsedAt) !== null && ref19 !== void 0 ? ref19 : null,
                succeed: !!(serials === null || serials === void 0 ? void 0 : (ref16 = serials[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.serial) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.ticketStatus) === null || ref18 === void 0 ? void 0 : ref18.formattedUsedAt)
            };
        }
        var unusedCount1 = serials.filter(function(serial) {
            var ref, ref1;
            return !!((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.canUseTicket);
        }).length;
        var usedAllTicket1 = !unusedCount1;
        var ref20 = (0,_sliced_to_array/* default */.Z)(orderBy_default()(serials.filter(function(serial) {
            var ref, ref1;
            return serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.usedAt;
        }), [
            "serial.ticketStatus.usedAt"
        ], [
            "desc"
        ]), 1), lasted1 = ref20[0];
        var ref21;
        return {
            disabled: usedAllTicket1,
            unusedCount: unusedCount1,
            formattedUsedAt: (ref21 = lasted1 === null || lasted1 === void 0 ? void 0 : (ref2 = lasted1.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketStatus) === null || ref3 === void 0 ? void 0 : ref3.formattedUsedAt) !== null && ref21 !== void 0 ? ref21 : null,
            succeed: usedAllTicket1
        };
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.isThroughTicket,
        serials,
        throughTicketIndex
    ]), formattedUsedAt = ref29.formattedUsedAt, disabled = ref29.disabled, unusedCount = ref29.unusedCount, succeed = ref29.succeed;
    var showMessWaitAssignSeat = (0,react.useMemo)(function() {
        var ref, ref1;
        return checkShowMessWaitAssignSeat(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.assignedNumberType, serials, throughTicketIndex);
    }, [
        item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.assignedNumberType,
        serials,
        throughTicketIndex
    ]);
    //set default selected ticket
    (0,react.useEffect)(function() {
        if (disabled || !(serials === null || serials === void 0 ? void 0 : serials.length) || !open || showMessWaitAssignSeat) {
            setSelectedSerials([]);
            return;
        }
        setSelectedSerials(serials.filter(function(serial) {
            var ref, ref1, ref2;
            return checkUserCanUseTicket((ref = serial.serial) === null || ref === void 0 ? void 0 : ref.ticketStatus, (item === null || item === void 0 ? void 0 : (ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) ? throughTicketIndex : undefined);
        }).map(function(serial) {
            return serial.id;
        }));
    }, [
        throughTicketIndex,
        open,
        showMessWaitAssignSeat
    ]);
    var fullName = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        // 転売防止のため、シリアル獲得時にuserからコピーされる氏名を優先して取得する
        // また、基本変わらない前提とし、一番若いシリアルに設定されている氏名を取得する
        var serialFullName = (ref = sortBy_default()(serials, "formattedSerialNumber").filter(function(v) {
            var ref, ref1, ref2;
            return !!((ref = v.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.fullName);
        })[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.serial) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.fullName;
        // 下位互換のため、ない場合はuserの氏名を取得する
        return serialFullName !== null && serialFullName !== void 0 ? serialFullName : user === null || user === void 0 ? void 0 : user.fullName;
    }, [
        serials,
        user === null || user === void 0 ? void 0 : user.fullName
    ]);
    var selectTicketLabel = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if ((item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.assignedNumberType) === utoniq_core_schema/* TicketItemMetadataAssignedNumberType.Seat */.Nay.Seat) {
            return t("seatNumberUse", "使用する座席番号");
        }
        return (serials === null || serials === void 0 ? void 0 : (ref2 = serials[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.serial) === null || ref3 === void 0 ? void 0 : ref3.formattedAssignedNumber) ? t("assignedlNumberUse", "使用する整理番号") : t("serialNumberUse", "使用するシリアルナンバー");
    }, [
        item === null || item === void 0 ? void 0 : (ref4 = item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.assignedNumberType,
        serials,
        t
    ]);
    var handleSelectSerial = (0,react.useCallback)(function(serialId) {
        setSelectedSerials(function(prevState) {
            return xor_default()(prevState, [
                serialId
            ]);
        });
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setSelectedSerials([]);
        onClose();
        setThroughTicketIndex(0);
    }, [
        onClose
    ]);
    var handleRotate = function() {
        setIsRotate(function(e) {
            return !e;
        });
    };
    var handleUseTicket = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    return [
                        4,
                        onUseTicket(selectedSerials, selectedThroughTicketName).finally(function() {
                            setLoading(false);
                            setOpenConfirm(false);
                            setSelectedSerials([]);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onUseTicket,
        selectedSerials,
        selectedThroughTicketName
    ]);
    var getMembershipData = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3, ref4;
        if (!user || !(item === null || item === void 0 ? void 0 : (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id)) return null;
        var membershipData = (ref1 = user.organizationPatrons) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
            var artistId = param.artistId;
            var ref;
            return artistId === (item === null || item === void 0 ? void 0 : (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id);
        });
        if (!(membershipData === null || membershipData === void 0 ? void 0 : (ref2 = membershipData.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : ref3.products)) return null;
        var _artist = membershipData.artist, tmp = _artist.subscription, products = (tmp === void 0 ? {} : tmp).products;
        var matchedProduct = products.find(function(product) {
            return product.plans.some(function(param) {
                var planId = param.planId;
                var ref;
                return planId === ((ref = membershipData.subscription) === null || ref === void 0 ? void 0 : ref.planId);
            });
        });
        if (!matchedProduct) return null;
        var membershipInterval = (ref4 = matchedProduct.plans.find(function(param) {
            var planId = param.planId;
            var ref;
            return planId === ((ref = membershipData.subscription) === null || ref === void 0 ? void 0 : ref.planId);
        })) === null || ref4 === void 0 ? void 0 : ref4.interval;
        var _continueMonth;
        return {
            productTitle: matchedProduct.title,
            membershipInterval: membershipInterval,
            continueMonth: (_continueMonth = membershipData.continueMonth) !== null && _continueMonth !== void 0 ? _continueMonth : 0,
            membershipJoinedAt: membershipData.formattedCreatedAt
        };
    }, [
        user,
        item
    ]);
    var ticket = item === null || item === void 0 ? void 0 : (ref6 = item.metadata) === null || ref6 === void 0 ? void 0 : ref6.ticket;
    var ticketDate = (0,react.useMemo)(function() {
        var ref;
        var now = dayjs_min_default()();
        var isThrough = ticket === null || ticket === void 0 ? void 0 : ticket.isThroughTicket;
        var through = ticket === null || ticket === void 0 ? void 0 : (ref = ticket.throughTicket) === null || ref === void 0 ? void 0 : ref[throughTicketIndex];
        var rawStart = isThrough ? through === null || through === void 0 ? void 0 : through.startDateOfUse : ticket === null || ticket === void 0 ? void 0 : ticket.startDateOfUse;
        var rawEnd = isThrough ? through === null || through === void 0 ? void 0 : through.endDateOfUse : ticket === null || ticket === void 0 ? void 0 : ticket.endDateOfUse;
        var start = rawStart ? dayjs_min_default()(rawStart) : null;
        var end = rawEnd ? dayjs_min_default()(rawEnd) : null;
        if (!start && !end) return {
            enable: true,
            start: start,
            end: end
        };
        if (start && end) {
            return {
                enable: now.isAfter(start) && now.isBefore(end),
                start: start,
                end: end
            };
        }
        // 片方のみある場合、その当日中を判定
        var computedStart = start !== null && start !== void 0 ? start : end === null || end === void 0 ? void 0 : end.startOf("day");
        var computedEnd = end !== null && end !== void 0 ? end : start === null || start === void 0 ? void 0 : start.endOf("day");
        var enable = computedStart && computedEnd ? now.isSame(computedStart) || now.isAfter(computedStart) && now.isBefore(computedEnd) : false;
        return {
            enable: enable,
            start: computedStart,
            end: computedEnd
        };
    }, [
        ticket === null || ticket === void 0 ? void 0 : ticket.isThroughTicket,
        ticket === null || ticket === void 0 ? void 0 : ticket.startDateOfUse,
        ticket === null || ticket === void 0 ? void 0 : ticket.endDateOfUse,
        ticket === null || ticket === void 0 ? void 0 : ticket.throughTicket,
        throughTicketIndex, 
    ]);
    var ref30, ref31, ref32;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: handleClose,
                sx: {
                    height: "95vh",
                    zIndex: function(theme) {
                        return theme.zIndex.modal + 2;
                    }
                },
                PaperProps: {
                    sx: {
                        height: "95vh"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    sx: {
                        height: "100%",
                        bgcolor: "background.default"
                    },
                    overflow: "unset",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flexDirection: "row",
                            alignItems: "center",
                            sx: {
                                px: 5,
                                height: 64
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.ScreenRotate, {
                                    edge: "end",
                                    size: "small",
                                    color: "primary.main",
                                    onClick: handleRotate
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        align: "center",
                                        children: t("ticketInfo")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                    edge: "end",
                                    size: "small",
                                    onClick: handleClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            overflow: "hidden",
                            flex: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                overflow: "scroll",
                                flex: 1,
                                sx: {
                                    transform: isRotate ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.6s "
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        px: 5,
                                        pt: 4,
                                        spacing: 6,
                                        sx: (0,src_object_spread/* default */.Z)({
                                            overflowY: "auto",
                                            pb: 4,
                                            height: "100%"
                                        }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "h4",
                                                                children: item === null || item === void 0 ? void 0 : item.title
                                                            }),
                                                            !!(item === null || item === void 0 ? void 0 : (ref7 = item.sku) === null || ref7 === void 0 ? void 0 : ref7.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "h6",
                                                                children: item === null || item === void 0 ? void 0 : (ref8 = item.sku) === null || ref8 === void 0 ? void 0 : ref8.unitName
                                                            })
                                                        ]
                                                    }),
                                                    !!(item === null || item === void 0 ? void 0 : (ref9 = item.metadata) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.ticket) === null || ref10 === void 0 ? void 0 : ref10.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: item === null || item === void 0 ? void 0 : (ref11 = item.metadata) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.ticket) === null || ref12 === void 0 ? void 0 : ref12.description
                                                    })
                                                ]
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.qrCodeUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    pb: 1
                                                },
                                                alignItems: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    src: item === null || item === void 0 ? void 0 : item.qrCodeUri,
                                                    variant: "square",
                                                    sx: {
                                                        width: 120,
                                                        height: 120
                                                    }
                                                })
                                            }),
                                            ((ref30 = item === null || item === void 0 ? void 0 : item.personalInformationRequirements) !== null && ref30 !== void 0 ? ref30 : []).includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            color: "text.secondary",
                                                            children: t("ticketOwner")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h3",
                                                        children: fullName
                                                    })
                                                ]
                                            }),
                                            getMembershipData() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            color: "text.secondary",
                                                            children: t("membership")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "".concat(t("membership_".concat((ref13 = getMembershipData()) === null || ref13 === void 0 ? void 0 : ref13.membershipInterval)), " ").concat(tCommon("monthContinuation", {
                                                            month: (ref14 = getMembershipData()) === null || ref14 === void 0 ? void 0 : ref14.continueMonth
                                                        }))
                                                    }),
                                                    ((ref15 = getMembershipData()) === null || ref15 === void 0 ? void 0 : ref15.membershipJoinedAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: "".concat(t("joinDate", {
                                                            date: (ref16 = getMembershipData()) === null || ref16 === void 0 ? void 0 : ref16.membershipJoinedAt
                                                        }))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: (ref17 = getMembershipData()) === null || ref17 === void 0 ? void 0 : ref17.productTitle
                                                    })
                                                ]
                                            }),
                                            !!(ticketDate.start && ticketDate.end) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            color: "text.secondary",
                                                            children: t("ticketDateOfUse")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: t("ticketDateOfUseContent", {
                                                            start: ticketDate.start.format("YYYY/MM/DD HH:mm"),
                                                            end: ticketDate.end.format("YYYY/MM/DD HH:mm")
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "h6",
                                                            color: "text.secondary",
                                                            children: selectTicketLabel
                                                        })
                                                    }),
                                                    showMessWaitAssignSeat ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: t("waitAssignYourSeat", "座席番号が割り当てられるまでお待ち下さい。")
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: (item === null || item === void 0 ? void 0 : (ref18 = item.metadata) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.ticket) === null || ref19 === void 0 ? void 0 : ref19.throughTicket) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelectSwiper, {
                                                            serials: serials,
                                                            throughTicketIndex: throughTicketIndex,
                                                            throughTickets: item.metadata.ticket.throughTicket,
                                                            selectedSerials: selectedSerials,
                                                            onSelectSerial: handleSelectSerial,
                                                            onChangeThroughTicketIndex: setThroughTicketIndex,
                                                            onSelectThroughTicketName: setSelectedThroughTicketName
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketContainer_TicketContainer, {
                                                            serials: serials,
                                                            selectedSerials: selectedSerials,
                                                            onSelectSerial: handleSelectSerial
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !showMessWaitAssignSeat && !!unusedCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            mt: 4
                                        },
                                        children: !(formattedUsedAt && !selectedSerials.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            align: "center",
                                            children: [
                                                selectedSerials.length,
                                                "/",
                                                unusedCount,
                                                t("selecting")
                                            ]
                                        })
                                    }),
                                    !ticketDate.enable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            border: "1px solid",
                                            borderColor: "error.main",
                                            py: 2,
                                            px: 4,
                                            mt: 4,
                                            mx: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                                        color: "error",
                                                        sx: {
                                                            fontSize: 20
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: t("checkDate")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: {
                                                    display: "inline-block",
                                                    pt: 1,
                                                    fontSize: "10px"
                                                },
                                                children: t("checkDateDescription")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "error.main",
                                                textAlign: "center",
                                                children: [
                                                    t("ticketStartDateOfUse"),
                                                    (ref31 = (ref20 = ticketDate.start) === null || ref20 === void 0 ? void 0 : ref20.format("YYYY/MM/DD HH:mm")) !== null && ref31 !== void 0 ? ref31 : "-"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "error.main",
                                                textAlign: "center",
                                                children: [
                                                    t("ticketEndDateOfUse"),
                                                    (ref32 = (ref21 = ticketDate.end) === null || ref21 === void 0 ? void 0 : ref21.format("YYYY/MM/DD HH:mm")) !== null && ref32 !== void 0 ? ref32 : "-"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        alignItems: "center",
                                        sx: {
                                            "&>.MuiBox-root:first-child": {
                                                width: "100%"
                                            },
                                            py: 4,
                                            px: 5
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeButton, {
                                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    return [
                                                        2,
                                                        setOpenConfirm(true)
                                                    ];
                                                });
                                            }),
                                            size: "large",
                                            fullWidth: true,
                                            loading: loading,
                                            disabled: disabled || !selectedSerials.length,
                                            succeed: succeed || loading,
                                            textOff: openConfirm ? "" : t("alreadyUsed"),
                                            textOn: t("personCharge"),
                                            openConfirm: openConfirm,
                                            reverse: isRotate,
                                            color: !ticketDate.enable ? "error" : undefined
                                        })
                                    }),
                                    formattedUsedAt && !selectedSerials.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        spacing: 1,
                                        py: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                                fontSize: "xSmall"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.secondary",
                                                children: t("dateOfUse")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                sx: {
                                                    pl: 1
                                                },
                                                children: formattedUsedAt
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        !showMessWaitAssignSeat && !!unusedCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            sx: {
                                px: 5,
                                py: 4,
                                bgcolor: "grey.50"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("personChargeNote")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: openConfirm,
                    onClose: function() {
                        setOpenConfirm(loading !== null && loading !== void 0 ? loading : false);
                    },
                    sx: {
                        zIndex: function(theme) {
                            return theme.zIndex.modal + 3;
                        },
                        "#modal-inner": {
                            transform: isRotate ? "translate(-50%, -50%) rotate(180deg) " : "translate(-50%, -50%)"
                        }
                    },
                    title: t("confirmChargeTitle"),
                    content: t("confirmChargeDesc"),
                    cancelText: loading ? "" : t("close"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        loading: loading,
                        size: "large",
                        fullWidth: true,
                        onClick: handleUseTicket,
                        children: t("ok")
                    })
                })
            })
        ]
    });
};
var TicketSelectSwiper = function(param) {
    var throughTicketIndex = param.throughTicketIndex, serials = param.serials, throughTickets = param.throughTickets, selectedSerials = param.selectedSerials, onSelectSerial = param.onSelectSerial, onChangeThroughTicketIndex = param.onChangeThroughTicketIndex, onSelectThroughTicketName = param.onSelectThroughTicketName;
    var ref;
    var swiperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        onSelectThroughTicketName((ref = throughTickets[0]) === null || ref === void 0 ? void 0 : ref.name);
        return function() {
            var ref;
            return onSelectThroughTicketName((ref = throughTickets[0]) === null || ref === void 0 ? void 0 : ref.name);
        };
    }, [
        onSelectThroughTicketName,
        throughTickets
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Prev, {
                        onClick: function() {
                            var ref;
                            return swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slidePrev();
                        },
                        disabled: !!selectedSerials.length,
                        bgcolor: "grey.50",
                        sx: {
                            bgcolor: "grey.50",
                            visibility: throughTicketIndex === 0 ? "hidden" : "visible"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            width: "100%",
                            align: "center",
                            children: (ref = throughTickets[throughTicketIndex]) === null || ref === void 0 ? void 0 : ref.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Next, {
                        bgcolor: "grey.50",
                        onClick: function() {
                            var ref;
                            return swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideNext();
                        },
                        disabled: !!selectedSerials.length,
                        sx: {
                            bgcolor: "grey.50",
                            visibility: throughTicketIndex + 1 === throughTickets.length ? "hidden" : "visible"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                ref: swiperRef,
                loop: false,
                spaceBetween: 20,
                allowTouchMove: false,
                enabled: throughTickets.length > 1,
                onActiveIndexChange: function(swiper) {
                    var ref;
                    onChangeThroughTicketIndex(swiper.activeIndex);
                    onSelectThroughTicketName((ref = throughTickets[swiper.activeIndex]) === null || ref === void 0 ? void 0 : ref.name);
                },
                children: throughTickets.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        "aria-disabled": !!selectedSerials.length,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketContainer_TicketContainer, {
                            serials: serials,
                            throughTicketIndex: index,
                            selectedSerials: selectedSerials,
                            onSelectSerial: onSelectSerial
                        })
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/template/index.tsx





















var OwnedItemDetailTemplate = function(param) {
    var state = param.state, onSettingAvatar = param.onSettingAvatar, onSettingWallpaper = param.onSettingWallpaper, onProtectUserItem = param.onProtectUserItem, onClickShare = param.onClickShare, onClose = param.onClose, onUseTicket = param.onUseTicket, onPurchaseCharge = param.onPurchaseCharge, onViewCollectionMagazine = param.onViewCollectionMagazine, onBuyItem = param.onBuyItem, onImageDownload = param.onImageDownload, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, routerNames = ref5.routerNames, routerPages = ref5.routerPages;
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ownedItemDetail")).onClick;
    // マガジンアイテムの表示に関する状態
    var ref6 = (0,react.useState)(false), openMagazineModal = ref6[0], setOpenMagazineModal = ref6[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref = state.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            safeArea: openMagazineModal ? {
                pt: 0,
                pb: 0
            } : undefined,
            header: openMagazineModal ? undefined : {
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    size: "medium",
                    onClick: onClose ? onClose : function() {
                        return router.goBack(routerPages.MyOwnedItems);
                    }
                }),
                right: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Share, {
                            onClick: onClickShare,
                            edge: "end",
                            color: "primary.main",
                            size: "small"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                            edge: "end",
                            color: "primary.main",
                            size: "small",
                            onClick: onClick
                        })
                    ]
                })
            },
            sx: {
                minHeight: "unset",
                height: windowHeight
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: ((ref3 = state.portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.title) || routerNames.OwnedItemDetail
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    style: {
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailBody, {
                        loggedUser: state.loggedUser,
                        loading: state.loading,
                        QRCodePrinting: state.QRCodePrinting,
                        loadingOnce: state.loadingOnce,
                        purchasingItem: state.purchasingItem,
                        portfolio: state.portfolio,
                        user: state.user,
                        customProfileUpdating: state.customProfileUpdating,
                        onSettingAvatar: onSettingAvatar,
                        onSettingWallpaper: onSettingWallpaper,
                        onProtectUserItem: onProtectUserItem,
                        protectingItem: state.protectingItem,
                        onUseTicket: onUseTicket,
                        onPurchaseCharge: onPurchaseCharge,
                        purchasablePrepaidPoints: state.purchasablePrepaidPoints,
                        paymentSource: state.paymentSource,
                        point: state.point,
                        chargeLoading: state.chargeLoading,
                        onClickShare: onClickShare,
                        onViewCollectionMagazine: onViewCollectionMagazine,
                        onBuyItem: onBuyItem,
                        onImageDownload: onImageDownload,
                        openMagazineModal: openMagazineModal,
                        setOpenMagazineModal: setOpenMagazineModal,
                        onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode,
                        enablePointCarrierPayment: state.enablePointCarrierPayment
                    })
                })
            ]
        })
    });
};
var ItemDetailBody = function(param) {
    var loading = param.loading, QRCodePrinting = param.QRCodePrinting, loadingOnce = param.loadingOnce, purchasingItem = param.purchasingItem, portfolio = param.portfolio, user = param.user, loggedUser = param.loggedUser, customProfileUpdating = param.customProfileUpdating, onSettingAvatar = param.onSettingAvatar, onSettingWallpaper = param.onSettingWallpaper, protectingItem = param.protectingItem, onProtectUserItem = param.onProtectUserItem, onUseTicket = param.onUseTicket, paymentSource = param.paymentSource, onPurchaseCharge = param.onPurchaseCharge, purchasablePrepaidPoints = param.purchasablePrepaidPoints, point = param.point, chargeLoading = param.chargeLoading, onClickShare = param.onClickShare, onViewCollectionMagazine = param.onViewCollectionMagazine, onBuyItem = param.onBuyItem, onImageDownload = param.onImageDownload, openMagazineModal = param.openMagazineModal, setOpenMagazineModal = param.setOpenMagazineModal, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode, enablePointCarrierPayment = param.enablePointCarrierPayment;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages, generatePath = ref3.generatePath;
    /** アイテム画像を全画面表示するモーダル https://zpl.io/bPyED5M */ var ref4 = (0,react.useState)(false), openFullScreenModal = ref4[0], setOpenFullScreenModal = ref4[1];
    var ref5 = (0,react.useState)(false), showMultipleImage = ref5[0], setShowMultipleImage = ref5[1];
    var handleExtension = function() {
        return setOpenFullScreenModal(true);
    };
    // カードの表裏に関する状態
    var ref6 = (0,react.useState)(false), isFlipped = ref6[0], setIsFlipped = ref6[1];
    var handleReverseThumbnail = (0,react.useCallback)(function() {
        setIsFlipped(function(prev) {
            return !prev;
        });
    }, [
        setIsFlipped
    ]);
    /** プロテクト設定時に表示する確認モーダルの状態 https://zpl.io/jpj6lPW */ var ref7 = (0,react.useState)(false), openProtectModal = ref7[0], setOpenProtectModal = ref7[1];
    var handleProtect = function() {
        if (portfolio === null || portfolio === void 0 ? void 0 : portfolio.isUserProtected) {
            onProtectUserItem();
            return;
        }
        setOpenProtectModal(true);
    };
    /** NFT発行時のモーダル状態 https://zpl.io/B1oAjEk */ var ref8 = (0,react.useState)(false), openNftIssuingModal = ref8[0], setOpenNftIssuingModal = ref8[1];
    (0,react.useEffect)(function() {
        var ref;
        (0,src_async_to_generator/* default */.Z)(function() {
            var ref, itemId, open;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getMagazineHistory */.Kh)()
                        ];
                    case 1:
                        ref = _state.sent(), itemId = ref.itemId, open = ref.open;
                        if (router.query.itemId === itemId) {
                            setOpenMagazineModal(open);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
        if (portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.serials) === null || ref === void 0 ? void 0 : ref.some(function(serial) {
            var ref;
            return (serial === null || serial === void 0 ? void 0 : (ref = serial.nftToken) === null || ref === void 0 ? void 0 : ref.status) === utoniq_core_schema/* ItemNftMintStatus.Processing */.A3P.Processing;
        })) setOpenNftIssuingModal(true);
    }, [
        portfolio
    ]);
    if (openMagazineModal) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailMagazineView_MagazinePlayerModal, {
        loading: loadingOnce,
        portfolio: portfolio,
        open: openMagazineModal,
        onClose: function() {
            setOpenMagazineModal(false);
        },
        onClickShare: onClickShare,
        paymentSource: paymentSource,
        purchasablePrepaidPoints: purchasablePrepaidPoints,
        onPurchaseCharge: function(plan, paymentMethod) {
            return onPurchaseCharge(plan, paymentMethod, {
                // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.OwnedItemDetail, {
                    itemId: router.query.itemId
                }), "?points=").concat(plan.points),
                // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.OwnedItemDetail, {
                    itemId: router.query.itemId
                })),
                // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.OwnedItemDetail, {
                    itemId: router.query.itemId
                }))
            });
        },
        point: point,
        purchasingItem: !!purchasingItem,
        chargeLoading: chargeLoading,
        onBuyItem: onBuyItem,
        enablePointCarrierPayment: enablePointCarrierPayment
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTypeSwitch, {
                loading: loading,
                QRCodePrinting: QRCodePrinting,
                portfolio: portfolio,
                loggedUser: loggedUser,
                user: user,
                customProfileUpdating: customProfileUpdating,
                onSetWallpaper: onSettingWallpaper,
                onSetAvatar: onSettingAvatar,
                onClickProtectUserItem: handleProtect,
                onUseTicket: onUseTicket,
                onExtend: handleExtension,
                onSetOpenMagazineModal: setOpenMagazineModal,
                isFlipped: isFlipped,
                onReverseThumbnail: handleReverseThumbnail,
                onViewCollectionMagazine: onViewCollectionMagazine,
                onOpenFullScreen: function() {
                    return setOpenFullScreenModal(true);
                },
                onOpenMultipleImage: function() {
                    setOpenFullScreenModal(true);
                    setShowMultipleImage(true);
                },
                onImageDownload: onImageDownload,
                onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailFullScreenModal/* ThumbnailFullScreenModal */.e, {
                isDrm: portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : ref.isDrm,
                open: openFullScreenModal,
                onClose: function() {
                    setOpenFullScreenModal(false);
                    setShowMultipleImage(false);
                },
                thumbnail: portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.item) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                images: portfolio === null || portfolio === void 0 ? void 0 : (ref2 = portfolio.item) === null || ref2 === void 0 ? void 0 : ref2.images,
                showMultipleImage: showMultipleImage,
                isFlipped: isFlipped
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NftIssuingModal, {
                open: openNftIssuingModal,
                onClose: function() {
                    return setOpenNftIssuingModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openProtectModal,
                onClose: function() {
                    return setOpenProtectModal(false);
                },
                title: t("protectedModalTitle", "プロテクトに設定します。"),
                content: t("protectedModalContent", "トレード申請中のアイテムの場合、トレード申請が自動的にキャンセルされます。"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    loading: protectingItem,
                    disabled: protectingItem,
                    sx: {
                        minWidth: 200
                    },
                    onClick: function() {
                        return onProtectUserItem().finally(function() {
                            return setOpenProtectModal(false);
                        });
                    },
                    children: t("ok")
                }),
                cancelText: t("close")
            })
        ]
    });
};
var ItemTypeSwitch = function(param) {
    var loading = param.loading, QRCodePrinting = param.QRCodePrinting, portfolio = param.portfolio, loggedUser = param.loggedUser, user = param.user, customProfileUpdating = param.customProfileUpdating, isFlipped = param.isFlipped, onSetWallpaper = param.onSetWallpaper, onExtend = param.onExtend, onSetAvatar = param.onSetAvatar, onClickProtectUserItem = param.onClickProtectUserItem, onUseTicket = param.onUseTicket, onReverseThumbnail = param.onReverseThumbnail, onSetOpenMagazineModal = param.onSetOpenMagazineModal, onViewCollectionMagazine = param.onViewCollectionMagazine, onOpenFullScreen = param.onOpenFullScreen, onOpenMultipleImage = param.onOpenMultipleImage, onImageDownload = param.onImageDownload, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref;
    switch(portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.item) === null || ref === void 0 ? void 0 : ref.type){
        case "audio":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailAudioView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                onReverseThumbnail: onReverseThumbnail,
                onClickProtectUserItem: onClickProtectUserItem,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        case "video":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailVideoView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                onReverseThumbnail: onReverseThumbnail,
                onClickProtectUserItem: onClickProtectUserItem,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        case "magazine":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailMagazineView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                onExpand: onExtend,
                onReverseThumbnail: onReverseThumbnail,
                onClickProtectUserItem: onClickProtectUserItem,
                onSetOpenMagazineModal: onSetOpenMagazineModal,
                onViewCollectionMagazine: onViewCollectionMagazine,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        case "avatar":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailAvatarView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                onReverseThumbnail: onReverseThumbnail,
                onSetAvatar: onSetAvatar,
                onClickProtectUserItem: onClickProtectUserItem,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        case "wallpaper":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailWallpaperView, {
                loading: loading,
                QRCodePrinting: QRCodePrinting,
                portfolio: portfolio,
                user: user,
                customProfileUpdating: customProfileUpdating,
                isFlipped: isFlipped,
                onReverseThumbnail: onReverseThumbnail,
                onSetWallpaper: onSetWallpaper,
                onClickProtectUserItem: onClickProtectUserItem,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage,
                onImageDownload: onImageDownload,
                onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
            });
        case "merch":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailMerchView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                onReverseThumbnail: onReverseThumbnail,
                onClickProtectUserItem: onClickProtectUserItem,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        case "ticket":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailTicketView, {
                loading: loading,
                portfolio: portfolio,
                isFlipped: isFlipped,
                loggedUser: loggedUser,
                onReverseThumbnail: onReverseThumbnail,
                onClickProtectUserItem: onClickProtectUserItem,
                onUseTicket: onUseTicket,
                onOpenFullScreen: onOpenFullScreen,
                onOpenMultipleImage: onOpenMultipleImage
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader, {});
    }
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/components/OwnedItemDetailModal.tsx







/**
 * ガチャ結果画面でアイテムをタップした際に表示されるアイテム詳細モーダル
 * OwnedItemDetailのテンプレートを表示する
 */ var OwnedItemDetailModal = function(param) {
    var open = param.open, loading = param.loading, portfolio = param.portfolio, user = param.user, loggedUser = param.loggedUser, protectingItem = param.protectingItem, onClickShare = param.onClickShare, onSettingAvatar = param.onSettingAvatar, onUseTicket = param.onUseTicket, onSettingWallpaper = param.onSettingWallpaper, onProtectUserItem = param.onProtectUserItem, onClose = param.onClose, onImageDownload = param.onImageDownload, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode, QRCodePrinting = param.QRCodePrinting;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: !(portfolio === null || portfolio === void 0 ? void 0 : portfolio.item) && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            sx: {
                textAlign: "center"
            },
            children: t("itemNotFound")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailTemplate, {
            /**
           * @todo
           * ガチャ挙動修正PRにて修正を行う
           * https://app.clickup.com/t/908127/UT-3461
           */ state: {
                loading: loading && !portfolio,
                customProfileUpdating: false,
                loadingOnce: false,
                portfolio: portfolio,
                protectingItem: protectingItem,
                user: user,
                loggedUser: loggedUser,
                paymentSource: null,
                purchasablePrepaidPoints: null,
                enablePointCarrierPayment: false,
                point: 0,
                chargeLoading: false,
                purchasingItem: false,
                QRCodePrinting: QRCodePrinting
            },
            onSettingAvatar: onSettingAvatar,
            onSettingWallpaper: onSettingWallpaper,
            onClickShare: onClickShare,
            onProtectUserItem: onProtectUserItem,
            onClose: onClose,
            onUseTicket: onUseTicket,
            onImageDownload: onImageDownload,
            onBuyItem: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            onPurchaseCharge: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            onViewCollectionMagazine: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
        })
    });
};

// EXTERNAL MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/LightFrame.tsx
var LightFrame = __webpack_require__(10273);
;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/SingleGachaResult/index.tsx











var SingleGachaResultCell = function(param) {
    var loading = param.loading, rewardItem = param.rewardItem, artistId = param.artistId, ticket = param.ticket, gacha = param.gacha, rollGacha = param.rollGacha, onSelectUserItem = param.onSelectUserItem, isPointOnly = param.isPointOnly, prepaidPointBalance = param.prepaidPointBalance;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    var userItem = rewardItem.userItem, item = rewardItem.item;
    var voiceResource = (ref = item.avatarResources) === null || ref === void 0 ? void 0 : ref.voiceResource;
    var ref5, ref6, _issuedNumber, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                display: "flex",
                flexDirection: "column",
                pt: 2,
                pb: 3,
                px: 5,
                height: "calc(100% - 84px)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                            onClick: function() {
                                return onSelectUserItem(item.id);
                            },
                            sx: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: (0,src_object_spread/* default */.Z)({
                                        position: "absolute",
                                        zIndex: 0,
                                        top: 0,
                                        width: item.thumbnailType === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? 280 : 175,
                                        height: 280
                                    }, (0,LightFrame/* getEmphasisRaritySx */.Qc)((ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.id, 50))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (ref5 = (ref2 = item.thumbnail.front) === null || ref2 === void 0 ? void 0 : ref2.mediumUri) !== null && ref5 !== void 0 ? ref5 : "",
                                    sx: {
                                        width: item.thumbnailType === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? 280 : 175,
                                        height: 280
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            sx: {
                                pt: 5
                            },
                            children: item.title
                        }),
                        voiceResource && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                display: "grid",
                                placeItems: "center",
                                pt: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
                                resource: voiceResource,
                                bgcolor: "primary.main",
                                color: "white"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            sx: {
                                pt: 2,
                                textAlign: "center"
                            },
                            children: [
                                (item === null || item === void 0 ? void 0 : item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            sx: {
                                                mr: 1
                                            },
                                            children: t("rarity")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            variant: "square",
                                            src: (ref6 = item === null || item === void 0 ? void 0 : (ref3 = item.rarityIconImage) === null || ref3 === void 0 ? void 0 : ref3.smallUri) !== null && ref6 !== void 0 ? ref6 : "",
                                            sx: {
                                                height: 20,
                                                width: "fit-content",
                                                mr: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "text.hint",
                                            sx: {
                                                mr: 4
                                            },
                                            children: item === null || item === void 0 ? void 0 : (ref4 = item.rarity) === null || ref4 === void 0 ? void 0 : ref4.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    sx: {
                                        mr: 2
                                    },
                                    children: t("numberOfPossessions")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: [
                                        userItem.number,
                                        (0,individual/* individualHideGachaRemainingItemCount */.nm)() ? t("possessionUnit") : " / ".concat((_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞")
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSetCell, {
                        rollGacha: rollGacha,
                        loading: loading,
                        ticket: ticket,
                        count: 1,
                        artistId: artistId,
                        remainingLimitedItemCount: (ref7 = gacha === null || gacha === void 0 ? void 0 : gacha.remainingLimitedItemCount) !== null && ref7 !== void 0 ? ref7 : 0,
                        totalLimitedItemCount: (ref8 = gacha === null || gacha === void 0 ? void 0 : gacha.totalLimitedItemCount) !== null && ref8 !== void 0 ? ref8 : 0,
                        isLimitedGacha: !!(gacha === null || gacha === void 0 ? void 0 : gacha.isLimited),
                        isPointOnly: isPointOnly,
                        price: (ref9 = gacha === null || gacha === void 0 ? void 0 : gacha.price) !== null && ref9 !== void 0 ? ref9 : 0,
                        prepaidPointBalance: prepaidPointBalance
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(83415);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/createTransitions.js
var createTransitions = __webpack_require__(15633);
;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/AnimationFrame.tsx




/**
 * @description
 * アイテム表示時のアニメーションを付与するラッパー
 */ var AnimationFrame = function(param) {
    var appear = param.appear, emphasisRarityId = param.emphasisRarityId, rarityEffect = param.rarityEffect, flipped = param.flipped, slide = param.slide, growLightTimes = param.growLightTimes, children = param.children, container = param.container, _addEndListener = param.addEndListener, addEndListener = _addEndListener === void 0 ? function() {} : _addEndListener;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
        direction: "up",
        in: appear,
        mountOnEnter: true,
        easing: createTransitions/* easing.easeInOut */.Ui.easeInOut,
        container: container,
        timeout: slide,
        addEndListener: addEndListener,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            children: [
                rarityEffect ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LightFrame/* AnimationRareGrowLightCell */.Cd, {
                    emphasisRarityId: emphasisRarityId,
                    flipped: flipped,
                    animationTime: growLightTimes.rare
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LightFrame/* AnimationGrowLightCell */.fA, {
                    emphasisRarityId: emphasisRarityId,
                    flipped: flipped,
                    animationTime: growLightTimes.common
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    timeout: 5000,
                    children: children
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/ItemWithRarityCell.tsx




/**
 * @description
 * レアリティ表示を含むアイテム表示コンポーネント
 */ var ItemWithRarityCell = function(param) {
    var item = param.item, onClick = param.onClick, flipped = param.flipped;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemReversibleThumbnail, {
                loading: !item,
                imageAreaProps: {
                    thumbnail: item === null || item === void 0 ? void 0 : item.thumbnail,
                    size: "medium-small",
                    onClick: onClick
                },
                flipProps: {
                    isFlipped: !flipped
                }
            }),
            (item === null || item === void 0 ? void 0 : (ref = item.rarityIconImage) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade_Fade/* default */.Z, {
                in: flipped,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "square",
                    src: item.rarityIconImage.smallUri,
                    sx: {
                        mt: 1,
                        height: 24,
                        width: "fit-content",
                        mx: "auto"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/RareItemModal.tsx









/**
 * @description
 * 初めて手に入れたレアアイテムを拡大表示する用のコンポーネント
 */ var RareItemModal = function(param) {
    var rewardItem = param.rewardItem, open = param.open;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    var userItem = rewardItem.userItem, item = rewardItem.item;
    var ref4, ref5, _issuedNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        sx: {
            bgcolor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            sx: {
                display: "flex",
                flexDirection: "column",
                pt: 2,
                pb: 3,
                px: 5,
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: (0,src_object_spread/* default */.Z)({
                                        position: "absolute",
                                        zIndex: 0,
                                        width: 220,
                                        height: item.thumbnailType === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? 220 : 352
                                    }, (0,LightFrame/* getEmphasisRaritySx */.Qc)((ref = item.rarity) === null || ref === void 0 ? void 0 : ref.id, 50))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (ref4 = (ref1 = item.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref4 !== void 0 ? ref4 : "",
                                    sx: {
                                        width: 220,
                                        height: item.thumbnailType === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square ? 220 : 352,
                                        borderRadius: 1
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            pt: 5,
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            sx: {
                                mr: 1
                            },
                            children: item.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        sx: {
                            pt: 2,
                            textAlign: "center"
                        },
                        children: [
                            (item === null || item === void 0 ? void 0 : item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        sx: {
                                            mr: 1
                                        },
                                        children: t("rarity")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        variant: "square",
                                        src: (ref5 = item === null || item === void 0 ? void 0 : (ref2 = item.rarityIconImage) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref5 !== void 0 ? ref5 : "",
                                        sx: {
                                            height: 20,
                                            width: "fit-content",
                                            mr: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        sx: {
                                            mr: 4
                                        },
                                        children: item === null || item === void 0 ? void 0 : (ref3 = item.rarity) === null || ref3 === void 0 ? void 0 : ref3.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                sx: {
                                    mr: 2
                                },
                                children: t("numberOfPossessions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                children: [
                                    userItem.number,
                                    (0,individual/* individualHideGachaRemainingItemCount */.nm)() ? t("possessionUnit") : " / ".concat((_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞")
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/ItemCell.tsx








/**
 * @description
 * アイテム表示コンポーネント
 */ var ItemCell_ItemCell = function(param) {
    var rewardItem = param.rewardItem, rewardItemOrder = param.rewardItemOrder, onClick = param.onClick, animation = param.animation;
    var ref, ref1;
    var item = rewardItem.item;
    var ref2 = (0,react.useRef)(null);
    /**
   * アニメーションの時間設定(ms)
   */ var animationTimes = {
        appearItem: 100,
        slide: 1000,
        allItemAppeared: 2000,
        // アイテムサムネイル反転アニメーションの時間
        flip: {
            common: 1000,
            fistTimeObtainedRare: 6000
        },
        // アイテムが光る演出時間
        growLight: {
            common: 1000,
            rare: 5000
        },
        animationCompleted: 1000
    };
    var ref3 = useGachaResultAnimation(animation, animationTimes, rewardItemOrder), appear = ref3.appear, flipped = ref3.flipped, openRareItemModal = ref3.openRareItemModal, onItemAppeared = ref3.onItemAppeared;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
        justifyContent: "center",
        ref: ref2,
        sx: {
            overflow: "hidden"
        },
        children: [
            animation.skipAnimation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightFrame/* LightFrame */.Y9, {
                            emphasisRarityId: item === null || item === void 0 ? void 0 : (ref = item.rarity) === null || ref === void 0 ? void 0 : ref.id
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWithRarityCell, {
                            item: item,
                            onClick: onClick,
                            flipped: true
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationFrame, {
                appear: appear,
                emphasisRarityId: item === null || item === void 0 ? void 0 : (ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.id,
                rarityEffect: animation.fistTimeObtainedRareEffect,
                flipped: flipped,
                slide: animationTimes.slide,
                growLightTimes: animationTimes.growLight,
                container: ref2.current,
                addEndListener: onItemAppeared,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemWithRarityCell, {
                    item: item,
                    onClick: onClick,
                    flipped: flipped
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RareItemModal, {
                rewardItem: rewardItem,
                open: openRareItemModal
            })
        ]
    });
};
/**
 * ガチャ結果アニメーション用hook
 */ var useGachaResultAnimation = function(animation, animationTimes, rewardItemOrder) {
    var ref = (0,react.useState)(false), appear = ref[0], setAppear = ref[1];
    var ref1 = (0,react.useState)(false), flipped = ref1[0], setFlipped = ref1[1];
    var ref2 = (0,react.useState)(false), openRareItemModal = ref2[0], setOpenRareItemModal = ref2[1];
    /**
   * 最初にslide + opacityでのフェードインでアイテム表示
   * 各アイテム0.1秒毎にアニメーション
   */ (0,react.useEffect)(function() {
        setTimeout(function() {
            return setAppear(true);
        }, (rewardItemOrder + 1) * animationTimes.appearItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * アイテム出現完了時のイベント
   * 最後のアイテム出現完了の2秒後、出現アニメーション完了フラグを立てる
   */ var onItemAppeared = function() {
        if (rewardItemOrder < 9) return;
        setTimeout(function() {
            return animation.setAllItemAppeared(true);
        }, animationTimes.allItemAppeared);
        return;
    };
    /**
   * アイテム全て表示後のアニメーションをコントロールする
   *
   * レア（初回取得）： レア用発光 ＋ 特殊表現 6秒
   * レア（取得済み) or ノーマル： ノーマル用発光 1秒
   */ (0,react.useEffect)(function() {
        if (!animation.allItemAppeared) return;
        if (!animation.startFlip) return;
        setFlipped(true);
        animation.fistTimeObtainedRareEffect && setTimeout(function() {
            setOpenRareItemModal(true);
            setTimeout(function() {
                return setOpenRareItemModal(false);
            }, animationTimes.flip.fistTimeObtainedRare / 2);
        }, animationTimes.growLight.rare / 2);
        setTimeout(function() {
            // 現在のアイテムのアニメーションステータス更新
            animation.setAnimationComplete(function(statuses) {
                return statuses.map(function(status, index) {
                    if (rewardItemOrder !== index) return status;
                    return true;
                });
            });
            // 最後のアイテムの場合、1秒後にアニメーション完了フラグを立てる
            if (rewardItemOrder !== 9) return;
            setTimeout(function() {
                return animation.setCompleteAllAnimation(true);
            }, animationTimes.animationCompleted);
        }, animation.fistTimeObtainedRareEffect ? animationTimes.flip.fistTimeObtainedRare : animationTimes.flip.common);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        animation.allItemAppeared,
        animation.startFlip,
        animation.fistTimeObtainedRareEffect, 
    ]);
    return {
        appear: appear,
        flipped: flipped,
        openRareItemModal: openRareItemModal,
        onItemAppeared: onItemAppeared
    };
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/TenGachaResult/index.tsx












/**
 * @description
 * 10連ガチャ結果の画像表示エリアコンポーネント
 * 3カラム表示で、1行目：3個、2行目：4個、3行目：3個のアイテムを表示する。
 */ var TenGachaResultCell = function(param) {
    var loading = param.loading, ticket = param.ticket, artistId = param.artistId, rewardItems = param.rewardItems, skipAnimation = param.skipAnimation, gacha = param.gacha, rollGacha = param.rollGacha, onSelectUserItem = param.onSelectUserItem, setSkipDisplayAnimation = param.setSkipDisplayAnimation, isPointOnly = param.isPointOnly, prepaidPointBalance = param.prepaidPointBalance;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    var ref = (0,react.useState)(false), allItemAppeared = ref[0], setAllItemAppeared = ref[1];
    var ref1 = (0,react.useState)((0,src_to_consumable_array/* default */.Z)(new Array(10)).map(function() {
        return false;
    })), animationComplete = ref1[0], setAnimationComplete = ref1[1];
    var ref2 = (0,react.useState)(false), completeAllAnimation = ref2[0], setCompleteAllAnimation = ref2[1];
    /**
   * @description
   * 強調表現をするレアリティIDをセットしている。
   * どのレアリティまで強調表現するかはまだ未確定なので、現在はここで静的に入れている。
   */ var emphasis = [
        "rare",
        "superrare",
        "ultrarare",
        "limited", 
    ];
    var rewardItemsWithFistTimeObtainedRareFlag = setFistTimeObtainedRareItemFlag(rewardItems, emphasis);
    var commonItemAnimationProps = {
        emphasis: emphasis,
        allItemAppeared: allItemAppeared,
        skipAnimation: skipAnimation,
        setAllItemAppeared: setAllItemAppeared,
        setAnimationComplete: setAnimationComplete,
        setCompleteAllAnimation: setCompleteAllAnimation
    };
    (0,react.useEffect)(function() {
        // 既に取得したガチャの場合アニメーションをスキップする
        var completedGachas = JSON.parse(sessionStorage.getItem(constants/* constants.storageKeys.COMPLETED_GACHAS */._.storageKeys.COMPLETED_GACHAS) || "[]");
        if (completedGachas.includes(router.pathname)) {
            setSkipDisplayAnimation(true);
            return;
        }
        sessionStorage.setItem(constants/* constants.storageKeys.COMPLETED_GACHAS */._.storageKeys.COMPLETED_GACHAS, JSON.stringify((0,src_to_consumable_array/* default */.Z)(completedGachas).concat([
            router.pathname
        ])));
    }, []);
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        id: "result-cell",
        sx: {
            py: 6,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    height: 480,
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        id: "first-column",
                        sx: {
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                            container: true,
                            direction: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            columnSpacing: 4,
                            children: rewardItemsWithFistTimeObtainedRareFlag.map(function(rewardItem, index) {
                                if (index > 2) return;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCell_ItemCell, {
                                    rewardItem: rewardItem,
                                    rewardItemOrder: index,
                                    onClick: function() {
                                        return onSelectUserItem(rewardItem.itemId);
                                    },
                                    animation: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonItemAnimationProps), {
                                        startFlip: index === 0 ? true : animationComplete[index - 1],
                                        fistTimeObtainedRareEffect: !skipAnimation && rewardItem.fistTimeObtainedRareItem
                                    })
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        id: "second-column",
                        sx: {
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                            container: true,
                            direction: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            flexWrap: "nowrap",
                            columnSpacing: 4,
                            children: rewardItemsWithFistTimeObtainedRareFlag.map(function(rewardItem, index) {
                                if (index < 3 || index > 6) return;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCell_ItemCell, {
                                    rewardItem: rewardItem,
                                    rewardItemOrder: index,
                                    onClick: function() {
                                        return onSelectUserItem(rewardItem.itemId);
                                    },
                                    animation: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonItemAnimationProps), {
                                        startFlip: animationComplete[index - 1],
                                        fistTimeObtainedRareEffect: !skipAnimation && rewardItem.fistTimeObtainedRareItem
                                    })
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        id: "third-column",
                        sx: {
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                            container: true,
                            direction: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            columnSpacing: 4,
                            children: rewardItemsWithFistTimeObtainedRareFlag.map(function(rewardItem, index) {
                                if (index < 7) return;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCell_ItemCell, {
                                    rewardItem: rewardItem,
                                    rewardItemOrder: index,
                                    onClick: function() {
                                        return onSelectUserItem(rewardItem.itemId);
                                    },
                                    animation: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonItemAnimationProps), {
                                        startFlip: animationComplete[index - 1],
                                        fistTimeObtainedRareEffect: !skipAnimation && rewardItem.fistTimeObtainedRareItem
                                    })
                                }, index);
                            })
                        })
                    })
                ]
            }),
            !skipAnimation && !completeAllAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        ml: "auto",
                        maxWidth: 144
                    },
                    onClick: function() {
                        return setSkipDisplayAnimation(true);
                    },
                    children: t("skip")
                })
            }),
            (skipAnimation || completeAllAnimation) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                flexDirection: "column",
                justifyContent: "end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSetCell, {
                        loading: loading,
                        ticket: ticket,
                        count: 10,
                        rollGacha: rollGacha,
                        artistId: artistId,
                        remainingLimitedItemCount: (ref3 = gacha === null || gacha === void 0 ? void 0 : gacha.remainingLimitedItemCount) !== null && ref3 !== void 0 ? ref3 : 0,
                        totalLimitedItemCount: (ref4 = gacha === null || gacha === void 0 ? void 0 : gacha.totalLimitedItemCount) !== null && ref4 !== void 0 ? ref4 : 0,
                        isLimitedGacha: !!(gacha === null || gacha === void 0 ? void 0 : gacha.isLimited),
                        price: (ref5 = gacha === null || gacha === void 0 ? void 0 : gacha.price) !== null && ref5 !== void 0 ? ref5 : 0,
                        isPointOnly: isPointOnly,
                        prepaidPointBalance: prepaidPointBalance
                    })
                })
            })
        ]
    });
};
/**
 * @description
 * 以下条件を全て満たす時、新規レアリティアイテム特殊演出用のフラグを付与する
 *
 * - レアリティがスーパーレアの場合
 * - 新規取得アイテムの場合
 * - ダブった場合、1枚目のアイテムだった場合
 */ var setFistTimeObtainedRareItemFlag = function(rewardItems, emphasis) {
    return rewardItems.map(function(rewardItem, index) {
        var ref, ref1, ref2;
        // スーパーレア・ウルトラレアかどうか
        if (!emphasis.includes((ref = rewardItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.rarity) === null || ref1 === void 0 ? void 0 : ref1.id)) {
            return rewardItem;
        }
        // 新規取得アイテムかどうか
        if ((rewardItem === null || rewardItem === void 0 ? void 0 : rewardItem.count) !== (rewardItem === null || rewardItem === void 0 ? void 0 : (ref2 = rewardItem.userItem) === null || ref2 === void 0 ? void 0 : ref2.number)) return rewardItem;
        // 今回のガチャでアイテムがダブっている場合、表示が1枚目かどうか
        if (rewardItems.some(function(rewardItem) {
            var ref;
            return (rewardItem === null || rewardItem === void 0 ? void 0 : rewardItem.itemId) === ((ref = rewardItems[index]) === null || ref === void 0 ? void 0 : ref.itemId);
        }) && rewardItems.slice(0, index).some(function(rewardItem) {
            var ref;
            return rewardItem.itemId === ((ref = rewardItems[index]) === null || ref === void 0 ? void 0 : ref.itemId);
        })) return rewardItem;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rewardItem), {
            fistTimeObtainedRareItem: true
        });
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/template/index.tsx























var GachaResultTemplate = function(param) {
    var state = param.state, rollGacha = param.rollGacha, rollGachaAfterStandingby = param.rollGachaAfterStandingby, onSelectedItem = param.onSelectedItem, onClickShare = param.onClickShare, onSettingWallpaper = param.onSettingWallpaper, onSkip = param.onSkip, onProtectUserItem = param.onProtectUserItem, onImageDownload = param.onImageDownload, onUseTicket = param.onUseTicket, onSettingAvatar = param.onSettingAvatar, onInitializeStandbyAnimation = param.onInitializeStandbyAnimation, onGenerateWallpaperPrintQrcode = param.onGenerateWallpaperPrintQrcode;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref22 = (0,react.useState)(false), open = ref22[0], setOpen = ref22[1];
    var ref23 = (0,react.useState)(false), skipDisplayAnimation = ref23[0], setSkipDisplayAnimation = ref23[1];
    var ref24 = (0,react.useState)(0), count = ref24[0], setCount = ref24[1];
    var ref25 = (0,react.useState)(false), openConfirm = ref25[0], setOpenConfirm = ref25[1];
    var ref26 = (0,react.useState)(false), openConfirmByPoint = ref26[0], setOpenConfirmByPoint = ref26[1];
    var ref27 = (0,react.useState)(false), openInsufficientGachaTicket = ref27[0], setOpenInsufficientGachaTicket = ref27[1];
    /**
   * rebuild rewardItems from count inside rewardItem
   * ex: length of rewardItems = 1 and rewardItem.count = 3 => length of rewardItems = 3
   * https://app.clickup.com/t/908127/UT-3865
   */ var rewardItems = (0,react.useMemo)(function() {
        var ref;
        if (!((ref = state.gachaOrder) === null || ref === void 0 ? void 0 : ref.rewardItems)) return [];
        var rewardItems = [];
        state.gachaOrder.rewardItems.map(function(rewardItem) {
            var _rewardItems;
            (_rewardItems = rewardItems).push.apply(_rewardItems, (0,src_to_consumable_array/* default */.Z)(Array.from({
                length: rewardItem.count
            }, function() {
                return rewardItem;
            })));
        });
        return rewardItems;
    }, [
        (ref = state.gachaOrder) === null || ref === void 0 ? void 0 : ref.rewardItems
    ]);
    var title = (0,react.useMemo)(function() {
        if (!rewardItems) return "";
        if (rewardItems.length === 1) return routerNames.SingleGachaResult;
        return routerNames.TenGachaResult;
    }, [
        routerNames.SingleGachaResult,
        routerNames.TenGachaResult,
        rewardItems
    ]);
    var onClose = (0,react.useCallback)(function() {
        setOpen(false);
    }, []);
    var onSelectUserItem = (0,react.useCallback)(function(itemId) {
        setOpen(true);
        onSelectedItem(itemId);
    }, [
        onSelectedItem
    ]);
    var isPointOnly = ((ref1 = state.gachaOrder) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gacha) === null || ref2 === void 0 ? void 0 : ref2.gachaRollType) === utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint;
    var hasPriceGacha = !!((ref3 = state.gachaOrder) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.gacha) === null || ref4 === void 0 ? void 0 : ref4.price);
    if (state.apngAnimationPlaying) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenAnimationCell, {
                ref: state.apngFullScreenRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipButton, {
                onSkip: function() {
                    setOpenConfirm(false);
                    setOpenConfirmByPoint(false);
                    setOpenInsufficientGachaTicket(false);
                    onSkip();
                }
            })
        ]
    });
    var _ticket, ref28, ref29, _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref5 = state.gachaOrder) === null || ref5 === void 0 ? void 0 : ref5.gacha.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            header: {
                back: true,
                title: t("title"),
                right: state.gachaOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: state.gachaOrder.gacha.gachaRollType === utoniq_core_schema/* GachaRollType.GachaTicket */.msy.GachaTicket ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDisplay, {
                        src: ((ref6 = state.gachaTicket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.thumbnails) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.standard) === null || ref8 === void 0 ? void 0 : ref8.smallUri) || "",
                        ticket: (_ticket = state.ticket) !== null && _ticket !== void 0 ? _ticket : ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PointHeaderDisplay, {
                        point: state.formattedPrepaidPointBarance
                    })
                })
            },
            sx: {
                height: "100dvh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: title ? title : routerNames.SingleGachaResult
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    id: "result-root",
                    sx: {
                        height: "100%",
                        maxHeight: 812,
                        display: "flex",
                        flexDirection: "column",
                        "& > *:first-of-type": {
                            flex: 1
                        },
                        overflow: rewardItems.length === 1 ? "hidden" : "unset"
                    },
                    children: [
                        !rewardItems.length && state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            id: "loading",
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
                        }),
                        rewardItems.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleGachaResultCell, {
                            rewardItem: rewardItems[0],
                            artistId: (ref9 = state.gachaOrder) === null || ref9 === void 0 ? void 0 : ref9.gacha.artistId,
                            onSelectUserItem: onSelectUserItem,
                            rollGacha: function(count) {
                                setCount(count);
                                onInitializeStandbyAnimation(count);
                                if (!isPointOnly) {
                                    var _ticket;
                                    /**
                   * チケット・ポイント両方で引けるガチャ且つ、チケットが足りない場合、ポイントで引くモーダルを出す
                   */ if (hasPriceGacha && count > ((_ticket = state.ticket) !== null && _ticket !== void 0 ? _ticket : 0)) {
                                        setOpenInsufficientGachaTicket(true);
                                        return;
                                    }
                                    /**
                   * ガチャチケのみ許容のガチャの時、チケットで引くモーダルを出す
                   */ setOpenConfirm(true);
                                    return;
                                }
                                /**
                 * ポイント専用ガチャの時、ポイントで引くモーダルを出す
                 */ setOpenConfirmByPoint(true);
                            },
                            loading: state.gachaRolling,
                            ticket: state.ticket,
                            gacha: (ref10 = state.gachaOrder) === null || ref10 === void 0 ? void 0 : ref10.gacha,
                            isPointOnly: isPointOnly,
                            prepaidPointBalance: state.prepaidPointBalance
                        }),
                        rewardItems.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TenGachaResultCell, {
                            loading: state.gachaRolling,
                            artistId: (ref11 = state.gachaOrder) === null || ref11 === void 0 ? void 0 : ref11.gacha.artistId,
                            rewardItems: rewardItems,
                            ticket: state.ticket,
                            gacha: (ref12 = state.gachaOrder) === null || ref12 === void 0 ? void 0 : ref12.gacha,
                            skipAnimation: skipDisplayAnimation,
                            onSelectUserItem: onSelectUserItem,
                            setSkipDisplayAnimation: setSkipDisplayAnimation,
                            rollGacha: function(count) {
                                setCount(count);
                                onInitializeStandbyAnimation(count);
                                if (!isPointOnly) {
                                    var _ticket;
                                    /**
                   * チケット・ポイント両方で引けるガチャ且つ、チケットが足りない場合、ポイントで引くモーダルを出す
                   */ if (hasPriceGacha && count > ((_ticket = state.ticket) !== null && _ticket !== void 0 ? _ticket : 0)) {
                                        setOpenInsufficientGachaTicket(true);
                                        return;
                                    }
                                    /**
                   * ガチャチケのみ許容のガチャの時、チケットで引くモーダルを出す
                   */ setOpenConfirm(true);
                                    return;
                                }
                                /**
                 * ポイント専用ガチャの時、ポイントで引くモーダルを出す
                 */ setOpenConfirmByPoint(true);
                            },
                            isPointOnly: isPointOnly,
                            prepaidPointBalance: state.prepaidPointBalance
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationRollGachaByTicketModal, {
                    open: openConfirm,
                    onClose: function() {
                        return setOpenConfirm(false);
                    },
                    count: count,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        rollGacha(count, utoniq_core_schema/* GachaRollType.GachaTicket */.msy.GachaTicket)
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenConfirm(false);
                                    setSkipDisplayAnimation(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    gachaRolling: state.gachaRolling
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationRollGachaByPointModal, {
                    open: openConfirmByPoint,
                    onClose: function() {
                        return setOpenConfirmByPoint(false);
                    },
                    count: count,
                    price: ((ref28 = (ref13 = state.gachaOrder) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.gacha) === null || ref14 === void 0 ? void 0 : ref14.price) !== null && ref28 !== void 0 ? ref28 : 0) * count,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        rollGacha(count, utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint)
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenConfirmByPoint(false);
                                    setSkipDisplayAnimation(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    gachaRolling: state.gachaRolling
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InsufficientGachaTicketModal, {
                    open: openInsufficientGachaTicket,
                    onClose: function() {
                        return setOpenInsufficientGachaTicket(false);
                    },
                    point: ((ref29 = (ref15 = state.gachaOrder) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.gacha) === null || ref16 === void 0 ? void 0 : ref16.price) !== null && ref29 !== void 0 ? ref29 : 0) * count,
                    prepaidPointBalance: state.prepaidPointBalance,
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        rollGacha(count, utoniq_core_schema/* GachaRollType.PrepaidPoint */.msy.PrepaidPoint)
                                    ];
                                case 1:
                                    _state.sent();
                                    setOpenConfirm(false);
                                    setSkipDisplayAnimation(false);
                                    setOpenInsufficientGachaTicket(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    gachaRolling: state.gachaRolling
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaDrawErrorModal, {
                    open: (ref17 = state.soldOutModalInfo) === null || ref17 === void 0 ? void 0 : ref17.open,
                    onClose: (ref18 = state.soldOutModalInfo) === null || ref18 === void 0 ? void 0 : ref18.onClose
                }),
                state.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailModal, {
                    open: open,
                    protectingItem: state.protectingItem,
                    portfolio: state.selectedItem,
                    user: state.user,
                    loggedUser: state.loggedUser,
                    loading: state.selectingItem,
                    onClose: onClose,
                    QRCodePrinting: state.QRCodePrinting,
                    onClickShare: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            return [
                                2,
                                onClickShare(state.selectedItem)
                            ];
                        });
                    }),
                    onSettingWallpaper: function() {
                        var ref;
                        return onSettingWallpaper((ref = state.selectedItem) === null || ref === void 0 ? void 0 : ref.item.id);
                    },
                    onProtectUserItem: function() {
                        var ref, ref1;
                        return onProtectUserItem({
                            id: (_id = (ref = state.selectedItem) === null || ref === void 0 ? void 0 : ref.item.id) !== null && _id !== void 0 ? _id : "",
                            isUserProtected: !((ref1 = state.selectedItem) === null || ref1 === void 0 ? void 0 : ref1.isUserProtected)
                        });
                    },
                    onSettingAvatar: function() {
                        var ref;
                        return onSettingAvatar((ref = state.selectedItem) === null || ref === void 0 ? void 0 : ref.item.id);
                    },
                    onUseTicket: function(serialIds, throughTicketName) {
                        var ref;
                        return onUseTicket((ref = state.selectedItem) === null || ref === void 0 ? void 0 : ref.item.id, serialIds, throughTicketName);
                    },
                    onImageDownload: onImageDownload,
                    onGenerateWallpaperPrintQrcode: onGenerateWallpaperPrintQrcode
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFullScreen, {
                    ref: state.videoFullscreenRef,
                    shouldMute: state.isSafari && !((ref19 = state.gachaOrder) === null || ref19 === void 0 ? void 0 : ref19.gacha.standByAnimations),
                    sx: {
                        zIndex: 11
                    }
                }),
                !!((ref20 = state.gachaOrder) === null || ref20 === void 0 ? void 0 : ref20.gacha.standByAnimations) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFullScreen, {
                    ref: state.standbyVideoFullscreenRef,
                    shouldMute: false,
                    sx: {
                        zIndex: 10
                    }
                }),
                !!((ref21 = state.gachaOrder) === null || ref21 === void 0 ? void 0 : ref21.gacha.standByAnimations) && state.standingBy && /*#__PURE__*/ (0,jsx_runtime.jsx)(StandbyTrigger, {
                    onPlay: rollGachaAfterStandingby
                }),
                state.playingAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipButton, {
                    onSkip: onSkip
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* LoadingWithBackdrop */.W, {
                    open: state.gachaRolling
                })
            ]
        })
    });
};
var ButtonSetCell = function(param) {
    var loading = param.loading, rollGacha = param.rollGacha, count = param.count, ticket = param.ticket, artistId = param.artistId, remainingLimitedItemCount = param.remainingLimitedItemCount, totalLimitedItemCount = param.totalLimitedItemCount, isLimitedGacha = param.isLimitedGacha, isPointOnly = param.isPointOnly, price = param.price, prepaidPointBalance = param.prepaidPointBalance;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var disabledRollGacha = (0,react.useMemo)(function() {
        // 在庫不足
        var isInventoryShortage = isLimitedGacha && remainingLimitedItemCount < count;
        // 回してる途中
        if (loading) {
            return true;
        }
        // 限定ガチャで在庫不足の場合
        if (isInventoryShortage) {
            return true;
        }
        // in case roll gacha only by point
        if (isPointOnly) {
            // there are not enough points
            return price * count > prepaidPointBalance;
        }
        // ガチャチケのみ許容のガチャで、チケットが足りないとき
        if (!price && count > (ticket !== null && ticket !== void 0 ? ticket : 0)) return true;
        // in case roll gacha by point or ticket
        // there are still enough tickets
        if (count <= (ticket !== null && ticket !== void 0 ? ticket : 0)) {
            return false;
        }
        // there are not enough points
        return price * count > prepaidPointBalance;
    }, [
        count,
        isLimitedGacha,
        isPointOnly,
        loading,
        prepaidPointBalance,
        price,
        remainingLimitedItemCount,
        ticket, 
    ]);
    // 有限ガチャの場合の残り割合
    var textColor = disabledRollGacha ? "text.hint" : remainingLimitedItemCount / totalLimitedItemCount < 0.2 ? "error.main" : "text.primary";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            sx: {
                py: 5
            },
            direction: "row",
            alignItems: "end",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    variant: "outlined",
                    fullWidth: true,
                    onClick: function() {
                        return router.push(generatePath(routerPages.ArtistCollections, {
                            artistId: artistId !== null && artistId !== void 0 ? artistId : config_config/* config.artistId */.v.artistId
                        }));
                    },
                    children: t("toCollections")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        width: "100%"
                    },
                    children: [
                        isLimitedGacha && !(0,individual/* individualHideGachaRemainingItemCount */.nm)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flexDirection: "row",
                            justifyContent: "center",
                            sx: {
                                width: "100%",
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: textColor,
                                    children: [
                                        t("remaining", "残り"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: textColor,
                                    children: [
                                        remainingLimitedItemCount,
                                        " / ",
                                        totalLimitedItemCount,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: textColor,
                                    children: t("remainUnit", "個")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            variant: "contained",
                            fullWidth: true,
                            onClick: function() {
                                return rollGacha(count);
                            },
                            disabled: disabledRollGacha,
                            children: t("turnAgain")
                        })
                    ]
                })
            ]
        })
    });
};
var GachaDrawErrorModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaResult").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("gachaDrawErrorModalTitle"),
        content: t("gachaDrawErrorModalContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: t("close")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/viewModel.ts






function GachaResult_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaResult($gachaOrderId: ID!, $gachaTicketId: ID!) {\n    user {\n      id\n      gachaOrder(id: $gachaOrderId) {\n        ...GachaOrderDetail\n      }\n      gachaTicket(id: $gachaTicketId) {\n        ...UserGachaTicketConnection\n      }\n      customProfile {\n        ...CustomProfileConnection\n      }\n    }\n    gachaTicket(id: $gachaTicketId) {\n      ...GachaTicketConnection\n    }\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GachaResult_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GachaResult_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaPortfolio($id: ID!, $skuId: String) {\n    portfolio(id: $id) {\n      ...PortfolioConnection\n    }\n  }\n  ",
        "\n"
    ]);
    GachaResult_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var GachaResult_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var ref5 = (0,react.useState)(false), openSoldOutErrorModal = ref5[0], setOpenSoldOutErrorModal = ref5[1];
    /** ガチャを回している状態かどうか */ var ref6 = (0,react.useState)(false), gachaRolling = ref6[0], setGachaRolling = ref6[1];
    /** スタンバイ状態かどうか */ var ref7 = (0,react.useState)(false), standingBy = ref7[0], setStandingBy = ref7[1];
    /** スタンバイ・本動画含めて動画を再生している時間かどうか */ var ref8 = (0,react.useState)(false), playingAnimation = ref8[0], setPlayingAnimation = ref8[1];
    /** 動画スキップ処理 */ var ref9 = (0,react.useState)({
        fn: function fn() {}
    }), handleSkip = ref9[0], setHandleSkip = ref9[1];
    var lastGachaOrderIdRef = (0,react.useRef)();
    // 動画再生コンポーネントのrefオブジェクトを作成する
    var videoFullscreenRef = (0,react.useRef)(null);
    var standbyVideoFullscreenRef = (0,react.useRef)(null);
    // APNG再生プレイヤーRef
    var apngFullScreenRef = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), apngAnimationPlaying = ref10[0], setApngAnimationPlaying = ref10[1];
    var ref11 = (0,useQuery/* useQuery */.aM)(GachaResult_viewModel_QUERY, {
        variables: {
            gachaOrderId: router.query.gachaOrderId,
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
        }
    }), loading = ref11.loading, data = ref11.data;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(PORTFOLIO, {
        returnPartialData: true
    }), 2), getGachaPortfolio = ref12[0], ref13 = ref12[1], selectedItem = ref13.data, selectingItem = ref13.loading, refetch = ref13.refetch;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* RollGacha */.YXi), 1), rollGacha = ref14[0];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateCustomProfile */.bPY), 1), updateCustomProfile = ref15[0];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ProtectUserItem */.E89), 2), protectUserItem = ref16[0], ref17 = ref16[1], protectingItem = ref17.loading;
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UseTickets */.h9A), 1), onUseTickets = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* GenerateWallpaperPrintQrcode */.RG2), 2), generateWallpaperPrintQrcode = ref19[0], ref20 = ref19[1], QRCodePrinting = ref20.loading;
    var redirectToGachaComplete = (0,react.useCallback)(function(count, gachaResultData) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref = standbyVideoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.pauseVideo();
        videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref1 = videoFullscreenRef.current) === null || ref1 === void 0 ? void 0 : ref1.pauseVideo();
        if (lastGachaOrderIdRef.current === (gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref2 = gachaResultData.rollGacha) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gachaOrder) === null || ref3 === void 0 ? void 0 : ref3.id)) {
            return;
        }
        lastGachaOrderIdRef.current = gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref4 = gachaResultData.rollGacha) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gachaOrder) === null || ref5 === void 0 ? void 0 : ref5.id;
        // mutation・アニメーション正常終了後、ガチャ結果画面へ遷移
        return router.push(generatePath(count === 10 ? routerPages.TenGachaResult : routerPages.SingleGachaResult, {
            gachaId: gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref6 = gachaResultData.rollGacha) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.gachaOrder) === null || ref7 === void 0 ? void 0 : ref7.gachaId,
            gachaOrderId: gachaResultData === null || gachaResultData === void 0 ? void 0 : (ref8 = gachaResultData.rollGacha) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.gachaOrder) === null || ref9 === void 0 ? void 0 : ref9.id
        }));
    }, [
        generatePath,
        router,
        routerPages.SingleGachaResult,
        routerPages.TenGachaResult, 
    ]);
    var downloadImage = useDownlodImage().downloadImage;
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: "/ownedItems/".concat(selectedItem === null || selectedItem === void 0 ? void 0 : (ref = selectedItem.portfolio) === null || ref === void 0 ? void 0 : ref.item.id)
    });
    var ref21, ref22, ref23, ref24, ref25, _balance, _formattedPrepaidPointBarance;
    return {
        state: {
            loading: loading,
            user: (ref21 = data === null || data === void 0 ? void 0 : data.user) !== null && ref21 !== void 0 ? ref21 : null,
            loggedUser: user,
            gachaRolling: gachaRolling,
            standingBy: standingBy,
            playingAnimation: playingAnimation,
            apngAnimationPlaying: apngAnimationPlaying,
            protectingItem: protectingItem,
            selectedItem: (ref22 = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.portfolio) !== null && ref22 !== void 0 ? ref22 : null,
            selectingItem: selectingItem,
            gachaOrder: (ref23 = data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.gachaOrder) !== null && ref23 !== void 0 ? ref23 : null,
            ticket: (ref24 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gachaTicket) === null || ref3 === void 0 ? void 0 : ref3.available) !== null && ref24 !== void 0 ? ref24 : null,
            gachaTicket: (ref25 = data === null || data === void 0 ? void 0 : data.gachaTicket) !== null && ref25 !== void 0 ? ref25 : null,
            soldOutModalInfo: {
                open: openSoldOutErrorModal,
                onClose: function() {
                    setOpenSoldOutErrorModal(false);
                }
            },
            videoFullscreenRef: videoFullscreenRef,
            standbyVideoFullscreenRef: standbyVideoFullscreenRef,
            apngFullScreenRef: apngFullScreenRef,
            prepaidPointBalance: (_balance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.balance) !== null && _balance !== void 0 ? _balance : 0,
            formattedPrepaidPointBarance: (_formattedPrepaidPointBarance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.formattedPrepaidPointBarance) !== null && _formattedPrepaidPointBarance !== void 0 ? _formattedPrepaidPointBarance : "0",
            isSafari: (0,native_app/* getPlatform */.Xf)() === "ios" || dist_lib/* isSafari */.G6 || dist_lib/* isIOS */.gn,
            QRCodePrinting: QRCodePrinting
        },
        actions: {
            rollGacha: /**
       * @description
       * ガチャを回す関数
       * ガチャを回すのに成功した場合：アニメーションの表示は成功・失敗に関わらずガチャ結果画面へと遷移させる。
       * ガチャを回すのに失敗した場合：スナックバーでエラー表示
       */ function rollGacha1(count, rollType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setGachaRolling(true);
                        // ガチャを回すmutation
                        return [
                            2,
                            rollGacha({
                                variables: {
                                    rollGachaGachaId: router.query.gachaId,
                                    rollGachaInputs: {
                                        count: count,
                                        gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                        rollType: rollType
                                    }
                                }
                            })// ガチャを回すmutation成功時
                            .then(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                                    var gachaResultData, ref, ref1, ref2, ref3, ref4, ref5, /**
               * スタンバイ動画がない場合、そのままアニメーションを再生
               */ ref6, rewardAnimationUri, animationApng, ref7;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                gachaResultData = param.data;
                                                /** スキップ処理を「ガチャ結果先へのリダイレクト」に設定する */ setHandleSkip({
                                                    fn: function fn() {
                                                        setPlayingAnimation(false);
                                                        setStandingBy(false);
                                                        setApngAnimationPlaying(false);
                                                        setGachaRolling(false);
                                                        redirectToGachaComplete(count, gachaResultData);
                                                    }
                                                });
                                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_rollGachaAgain", {
                                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                                    gachaId: router.query.gachaId,
                                                    artistId: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.gachaOrder) === null || ref1 === void 0 ? void 0 : ref1.gacha.artistId,
                                                    /**
                 * @description
                 * カスタムディメンションは文字列しか計測しないため、数値を文字列変換する
                 * https://app.clickup.com/t/908127/UT-9829
                 */ count: count.toString(),
                                                    gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                                    type: rollType
                                                });
                                                rewardAnimationUri = (ref2 = gachaResultData === null || gachaResultData === void 0 ? void 0 : gachaResultData.rollGacha.gachaOrder.rewardAnimation) === null || ref2 === void 0 ? void 0 : ref2.uri;
                                                /**
               * @description
               * ガチャのアニメーションを再生する処理
               * URLから動画ファイルがAPNGかMP4か判断し、ファイル種別ごとの処理を行う。
               * URLの取得に失敗、またはアニメーション再生に失敗した時はSentry通知だけして結果画面に遷移させる
               */ if (!rewardAnimationUri) {
                                                    return [
                                                        2,
                                                        redirectToGachaComplete(count, gachaResultData)
                                                    ];
                                                }
                                                if (!!isVideoExt(rewardAnimationUri)) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    generateApng(rewardAnimationUri).catch(function(e) {
                                                        (0,core_errors/* captureError */.O)(e, "gachaDetailGenerateApng");
                                                        return;
                                                    })
                                                ];
                                            case 1:
                                                animationApng = _state.sent();
                                                if (!animationApng) return [
                                                    3,
                                                    3
                                                ];
                                                setApngAnimationPlaying(true);
                                                return [
                                                    4,
                                                    playApngAnimation(apngFullScreenRef, animationApng).then(function() {
                                                        setGachaRolling(false);
                                                    }).catch(function(e) {
                                                        (0,core_errors/* captureError */.O)(e, "gachaDetailplayApngAnimation");
                                                    }).finally(function() {
                                                        return setApngAnimationPlaying(false);
                                                    })
                                                ];
                                            case 2:
                                                _state.sent();
                                                _state.label = 3;
                                            case 3:
                                                return [
                                                    2,
                                                    redirectToGachaComplete(count, gachaResultData)
                                                ];
                                            case 4:
                                                /**
               * 動画ファイルがMP4の場合
               * 結果アニメーション動画のvideo要素にURLをセットする
               */ if (!videoFullscreenRef || !videoFullscreenRef.current) {
                                                    return [
                                                        2,
                                                        redirectToGachaComplete(count, gachaResultData)
                                                    ];
                                                }
                                                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref3 = videoFullscreenRef.current) === null || ref3 === void 0 ? void 0 : ref3.init(function(state) {
                                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                                        url: rewardAnimationUri,
                                                        playsinline: true,
                                                        onReady: function onReady() {
                                                            var ref;
                                                            (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.handleOnReadyVideo();
                                                        },
                                                        onEnded: function onEnded() {
                                                            setPlayingAnimation(false);
                                                            setGachaRolling(false);
                                                            redirectToGachaComplete(count, gachaResultData);
                                                        },
                                                        onError: function onError(e) {
                                                            setPlayingAnimation(false);
                                                            (0,core_errors/* captureError */.O)(e, "gachaDetailPlayGachaAnimationVideo");
                                                            redirectToGachaComplete(count, gachaResultData);
                                                        }
                                                    });
                                                });
                                                setPlayingAnimation(true);
                                                /**
               * スタンバイ動画がある場合、スタンバイ動画を再生してreturn
               */ if (data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gachaOrder) === null || ref5 === void 0 ? void 0 : ref5.gacha.standByAnimations) {
                                                    ;
                                                    standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref7 = standbyVideoFullscreenRef.current) === null || ref7 === void 0 ? void 0 : ref7.playVideo();
                                                    return [
                                                        2
                                                    ];
                                                }
                                                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref6 = videoFullscreenRef.current) === null || ref6 === void 0 ? void 0 : ref6.playVideo();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(e) {
                                // ガチャを回したタイミングで売り切れてしまった場合固有のモーダル表示
                                if ((e === null || e === void 0 ? void 0 : e.message) === "There is no item set available.") {
                                    setOpenSoldOutErrorModal(true);
                                }
                                showError(e);
                            }).finally(function() {
                                setGachaRolling(false);
                            })
                        ];
                    });
                })();
            },
            rollGachaAfterStandingby: function rollGachaAfterStandingby() {
                var // アニメーション動画を再生
                ref;
                setStandingBy(false);
                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.playVideo();
            },
            onSelectedItem: function onSelectedItem(itemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getGachaPortfolio({
                                        variables: {
                                            id: itemId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(portfolio) {
                    var ref, ref1, url, _description, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.title,
                                        text: (ref2 = (_description = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.description) !== null && _description !== void 0 ? _description : (ref = portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.description) !== null && ref2 !== void 0 ? ref2 : t("metaDescription"),
                                        url: url,
                                        dialogTitle: portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.title
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(portfolio) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onSettingWallpaper: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(itemId) {
                    var ref, ref1, ref2, unsetWallpaper;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                unsetWallpaper = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.customProfile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaperItem) === null || ref2 === void 0 ? void 0 : ref2.id) === itemId;
                                return [
                                    4,
                                    updateCustomProfile({
                                        variables: {
                                            updateCustomProfileInputs: {
                                                wallpaperItemId: unsetWallpaper ? null : itemId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    unsetWallpaper
                                ];
                        }
                    });
                });
                return function(itemId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onProtectUserItem: function onProtectUserItem(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    protectUserItem({
                                        variables: {
                                            inputs: values
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onImageDownload: function onImageDownload(url) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (isEmpty_default()(url)) return [
                                    2
                                ];
                                _tmp = url;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    downloadImage(url)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            // スタンバイ動画URLをvideo要素にセットする処理
            onInitializeStandbyAnimation: function onInitializeStandbyAnimation(count) {
                var ref, ref1, ref2;
                var standByAnimations = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.gachaOrder) === null || ref1 === void 0 ? void 0 : ref1.gacha.standByAnimations;
                if (!standByAnimations) return;
                standbyVideoFullscreenRef === null || standbyVideoFullscreenRef === void 0 ? void 0 : (ref2 = standbyVideoFullscreenRef.current) === null || ref2 === void 0 ? void 0 : ref2.init(function(state) {
                    var ref;
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        url: (ref = standByAnimations[count === 1 ? "single" : "bulk"]) === null || ref === void 0 ? void 0 : ref.uri,
                        playsinline: true,
                        onReady: function onReady() {
                            var ref;
                            (ref = standbyVideoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.handleOnReadyVideo();
                        },
                        onEnded: function onEnded() {
                            setStandingBy(true);
                        },
                        onError: function onError(e) {
                            var ref;
                            (0,core_errors/* captureError */.O)(e, "gachaDetailPlayGachaAnimationVideo");
                            //check videoFullscreen have src value
                            if (videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref = videoFullscreenRef.current) === null || ref === void 0 ? void 0 : ref.src) {
                                var ref1;
                                videoFullscreenRef === null || videoFullscreenRef === void 0 ? void 0 : (ref1 = videoFullscreenRef.current) === null || ref1 === void 0 ? void 0 : ref1.playVideo();
                            }
                        }
                    });
                });
            },
            // 動画のスキップ処理
            onSkip: handleSkip.fn,
            onUseTicket: function onUseTicket(itemId, serialIds, throughTicketName) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!itemId) return [
                                    2
                                ];
                                return [
                                    4,
                                    onUseTickets({
                                        variables: {
                                            inputs: {
                                                items: [
                                                    {
                                                        itemId: itemId,
                                                        serialIds: serialIds,
                                                        throughTicketName: throughTicketName
                                                    }
                                                ]
                                            }
                                        }
                                    }).catch(function(e) {
                                        showError(e);
                                        /**
           * @note
           * アイテム使用時にエラーが起きた場合
           * SwipeButtonコンポーネントでエラーハンドリングが呼ばれる
           */ throw e;
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSettingAvatar: function onSettingAvatar(avatarItemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!avatarItemId) return [
                                    2
                                ];
                                return [
                                    4,
                                    updateCustomProfile({
                                        variables: {
                                            updateCustomProfileInputs: {
                                                avatarItemId: avatarItemId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGenerateWallpaperPrintQrcode: function onGenerateWallpaperPrintQrcode(serialId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _id;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    generateWallpaperPrintQrcode({
                                        variables: {
                                            inputs: {
                                                itemId: (_id = selectedItem === null || selectedItem === void 0 ? void 0 : (ref = selectedItem.portfolio) === null || ref === void 0 ? void 0 : ref.item.id) !== null && _id !== void 0 ? _id : "",
                                                serialId: serialId
                                            }
                                        }
                                    }).then(function() {
                                        return refetch();
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var GachaResult_viewModel_QUERY = (0,lib/* gql */.Ps)(GachaResult_viewModel_templateObject(), utoniq_core_schema/* GachaOrderDetailFragmentDoc */.kfu, utoniq_core_schema/* GachaTicketConnectionFragmentDoc */.mCK, utoniq_core_schema/* UserGachaTicketConnectionFragmentDoc */.XFl, utoniq_core_schema/* CustomProfileConnectionFragmentDoc */.saP);
var PORTFOLIO = (0,lib/* gql */.Ps)(GachaResult_viewModel_templateObject1(), utoniq_core_schema/* PortfolioConnectionFragmentDoc */.umN);

;// CONCATENATED MODULE: ./src/components/pages/GachaResult/index.tsx




/**
 * GachaResult Page
 * Implemented as a practical sample.
 */ var GachaResult = function() {
    var ref = GachaResult_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaResultTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalArtist/template/index.tsx















var GlobalArtist_template_client = algolia/* client */.Lp();

var GlobalArtistTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("globalArtist").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref6.routerPages, routerNames = ref6.routerNames;
    var ref7 = (0,react.useState)(false), openSideMenu = ref7[0], setOpenSideMenu = ref7[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            }
        },
        header: {
            title: t("title"),
            left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                edge: "start",
                onClick: function() {
                    return setOpenSideMenu(!openSideMenu);
                },
                color: "icon.line",
                bgcolor: "icon.background",
                badge: ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount) || !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
            }),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Search, {
                edge: "end",
                href: routerPages.ArtistSearch,
                bgcolor: "transparent",
                sx: {
                    color: "grey.600"
                }
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.GlobalArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                followArtists: state.followArtists,
                memberArtists: state.memberArtists,
                open: openSideMenu,
                onClose: function() {
                    return setOpenSideMenu(false);
                },
                user: state.user,
                isArtist: state.isArtist
            }),
            state.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingCell, {
                followees: state.followees,
                loading: state.loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                indexName: algolia/* indexes.organizationArtists */.RG.organizationArtists,
                searchClient: GlobalArtist_template_client,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                        filters: algolia/* filters.organizationId */.u8.organizationId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistsCellWithAlgolia, {
                        loading: state.loading
                    })
                ]
            })
        ]
    });
};
var FollowingCell = function(param) {
    var followees = param.followees, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("globalArtist").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1, ref2, _displayName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            title: t("following"),
            titleTypographyProps: {
                variant: "h3"
            },
            sx: {
                pb: 2
            },
            spacing: 4,
            items: (ref1 = followees === null || followees === void 0 ? void 0 : followees.edges) !== null && ref1 !== void 0 ? ref1 : [],
            renderItem: function(param) {
                var node = param.node;
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                    href: generatePath(routerPages.ArtistTop, {
                        artistId: node.artist.id
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: (ref2 = (ref = node.artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                        alt: (_displayName = node.artist.displayName) !== null && _displayName !== void 0 ? _displayName : "",
                        sx: {
                            width: 64,
                            height: 64
                        }
                    })
                }, node.artist.id);
            },
            loading: loading,
            loadingItemLength: 5,
            LoadingComponent: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 64,
                    height: 64
                });
            }
        })
    });
};
/**
 * @todo
 * [UT-3167] Algoliaの検索ロジック切り分け追加時に外す
 * https://app.clickup.com/t/908127/UT-3167
 */ var ArtistsCellWithAlgolia = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, refineNext = param.refineNext, loading = param.loading;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistsLoadingCell, {});
    }
    /**
   * @description
   * algoliaへの依存を避けるために、objectID→idへ変数名を変更
   */ var artists = hits.map(function(artist) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, artist), {
            id: artist.objectID
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ArtistsCell, {
        hasNextPage: hasMore,
        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    refineNext()
                ];
            });
        }),
        artists: artists
    });
});
var template_ArtistsCell = function(param) {
    var artists = param.artists, onFetchMore = param.onFetchMore, hasNextPage = param.hasNextPage;
    var t = (0,core_i18n/* useTranslation */.$G)("globalArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    pb: 4
                },
                children: t("artist")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: false,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                component: Grid2/* default */.Z,
                componentProps: {
                    spacing: 3,
                    container: true
                },
                itemComponent: Grid2/* default */.Z,
                itemComponentProps: {
                    size: {
                        xs: 6,
                        md: 4
                    }
                },
                emptyMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                nodes: artists === null || artists === void 0 ? void 0 : artists.map(function(artist) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistCard, {
                        artist: artist
                    });
                })
            })
        ]
    });
};
var ArtistsLoadingCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("globalArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h3",
                sx: {
                    pb: 4
                },
                children: t("artist")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 5,
                children: Array.from(Array(6).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: {
                            xs: 6,
                            md: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 4,
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "circular",
                                    width: 158,
                                    height: 158
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "50%"
                                })
                            ]
                        })
                    }, key);
                })
            })
        ]
    });
};
var ArtistCard = function(param) {
    var artist = param.artist;
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var ref3, ref4, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                display: "grid",
                gap: 3,
                height: "100%",
                boxShadow: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ArtistTop, {
                    artistId: artist.id
                }),
                sx: {
                    bgcolor: "background.default"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: (ref4 = (ref3 = artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref3 !== void 0 ? ref3 : artist === null || artist === void 0 ? void 0 : (ref1 = artist.avatar) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref4 !== void 0 ? ref4 : "",
                        alt: (ref5 = artist === null || artist === void 0 ? void 0 : artist.displayName) !== null && ref5 !== void 0 ? ref5 : "",
                        sx: {
                            width: 158,
                            height: 158,
                            mx: "auto"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            textAlign: "center"
                        },
                        children: (ref6 = artist === null || artist === void 0 ? void 0 : artist.displayName) !== null && ref6 !== void 0 ? ref6 : ""
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalArtist/index.tsx



/**
 * GlobalArtist Page
 * Implemented as a practical sample.
 */ var GlobalArtist = function() {
    var ref = GlobalArtist_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalArtistTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalCollections/template/index.tsx












var GlobalCollectionsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("globalCollections").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref6 = (0,react.useState)(false), openSideMenu = ref6[0], setOpenSideMenu = ref6[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: {
                type: "global",
                props: {
                    hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                    unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                    hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
                }
            },
            margin: true,
            header: {
                title: t("title"),
                left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                    edge: "start",
                    onClick: function() {
                        return setOpenSideMenu(!openSideMenu);
                    },
                    color: "icon.line",
                    bgcolor: "icon.background",
                    badge: ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount) || !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.GlobalCollections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                    followArtists: state.followArtists,
                    memberArtists: state.memberArtists,
                    open: openSideMenu,
                    onClose: function() {
                        return setOpenSideMenu(false);
                    },
                    user: state.user,
                    isArtist: state.isArtist
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCollections_template_CollectionBannerCell, {
                    userCollections: state.userCollections,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore
                })
            ]
        })
    });
};
var GlobalCollections_template_CollectionBannerCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, userCollections = param.userCollections, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("globalCollections").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: "60px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: userCollections === null || userCollections === void 0 ? void 0 : userCollections.map(function(param, index) {
                var collection = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionBox, {
                    collection: collection,
                    fullWidth: true,
                    sx: {
                        height: "calc((100vw - 40px) * 190 / 335)",
                        maxHeight: "calc(560px * 190 / 335)"
                    },
                    actionAreaProps: {
                        onClick: function onClick() {
                            var ref;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: (ref = collection.collection) === null || ref === void 0 ? void 0 : ref.artistId,
                                collectionId: collection.id,
                                name: "globalCollections"
                            });
                        }
                    }
                }, index);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 5
            },
            emptyMessage: t("collectionEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 6,
                flexDirection: "column",
                sx: {
                    py: 2
                },
                children: Array.from(Array(3).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionBoxSkeleton, {
                        fullWidth: true
                    }, key);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalCollections/viewModel.ts



function GlobalCollections_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GlobalCollections($userId: String, $pageInput: PageInput) {\n    ownedUserCollections(pageInput: $pageInput, userId: $userId) {\n      edges {\n        node {\n          ...UserCollectionBox\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    GlobalCollections_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GlobalCollections_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewGlobalCollections($userId: String, $pageInput: PageInput) {\n    ownedUserCollections(pageInput: $pageInput, userId: $userId) {\n      edges {\n        node {\n          ...UserCollectionBox\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    GlobalCollections_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var GlobalCollections_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var isFirstLoadRef = useGetNewestData({
        query: viewModel_FETCH_NEW_QUERY,
        variables: {
            pageInput: {
                limit: 20
            }
        },
        fields: [
            {
                fieldName: "ownedUserCollections",
                fragment: utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU
            }, 
        ]
    }).isFirstLoadRef;
    var ref6 = (0,useQuery/* useQuery */.aM)(GlobalCollections_viewModel_QUERY, {
        onCompleted: function onCompleted(param) {
            var ownedUserCollections = param.ownedUserCollections;
            isFirstLoadRef.current = false;
            if (!ownedUserCollections.edges.length) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    name: "globalCollections"
                });
            }
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true
    }), data = ref6.data, loading = ref6.loading, fetchMore = ref6.fetchMore;
    var isNextFetch = !!data;
    var ref7, ref8, ref9, ref10;
    return {
        state: {
            loading: loading && !isNextFetch,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.ownedUserCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            userCollections: (ref7 = data === null || data === void 0 ? void 0 : (ref1 = data.ownedUserCollections) === null || ref1 === void 0 ? void 0 : ref1.edges.filter(function(param) {
                var node = param.node;
                return (node === null || node === void 0 ? void 0 : node.itemOwnedCount) >= 1;
            })) !== null && ref7 !== void 0 ? ref7 : null,
            user: (ref8 = data === null || data === void 0 ? void 0 : data.user) !== null && ref8 !== void 0 ? ref8 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref2 = userClaims.orgs) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[config_config/* config.organizationId */.v.organizationId]) === null || ref3 === void 0 ? void 0 : ref3.artist),
            followArtists: (ref9 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationFollowees) !== null && ref9 !== void 0 ? ref9 : null,
            memberArtists: (ref10 = data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : ref5.organizationPatrons) !== null && ref10 !== void 0 ? ref10 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.ownedUserCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var GlobalCollections_viewModel_QUERY = (0,lib/* gql */.Ps)(GlobalCollections_viewModel_templateObject(), utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var viewModel_FETCH_NEW_QUERY = (0,lib/* gql */.Ps)(GlobalCollections_viewModel_templateObject1(), utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU);

;// CONCATENATED MODULE: ./src/components/pages/GlobalCollections/index.tsx



/**
 * GlobalCollections Page
 * Implemented as a practical sample.
 */ var GlobalCollections = function() {
    var ref = GlobalCollections_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCollectionsTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/campaign/CampaignBox/index.tsx




var CampaignBox = function(param) {
    var campaign = param.campaign, onClick = param.onClick;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("globalEvents").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
        sx: {
            p: 0,
            mx: 0,
            mb: 5
        },
        onClick: onClick,
        href: generatePath(routerPages.CampaignDetail, {
            campaignId: campaign.id
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "square",
                    sx: {
                        width: 100,
                        height: 64,
                        borderRadius: 2
                    },
                    alt: "myRank" in campaign ? campaign.myRank.displayName : campaign.title,
                    src: ((ref = campaign.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) || ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                sx: {
                    pl: 4
                },
                primary: "myRank" in campaign ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        campaign.myRank.rank,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            component: "span",
                            variant: "subtitle2",
                            display: "inline",
                            children: t("rank")
                        })
                    ]
                }) : campaign.title,
                secondary: "myRank" in campaign ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    component: "span",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            component: "span",
                            children: campaign.myRank.displayName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            component: "span",
                            color: "text.hint",
                            children: [
                                campaign.myRank.point,
                                "pt"
                            ]
                        })
                    ]
                }) : "",
                slotProps: {
                    primary: {
                        variant: "myRank" in campaign ? "h2" : "h5"
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalEvents/template/index.tsx












var GlobalEventsTemplate = function(param) {
    var state = param.state, onFetchMoreCampaign = param.onFetchMoreCampaign, onFetchMoreMission = param.onFetchMoreMission;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("globalEvents").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref7 = (0,react.useState)(false), openSideMenu = ref7[0], setOpenSideMenu = ref7[1];
    var ref8 = (0,react.useState)(router.query.tab === "mission" ? 1 : 0), currentTab = ref8[0], setCurrentTab = ref8[1];
    var ref9 = (0,react.useState)(0), currentSegment = ref9[0], setCurrentSegment = ref9[1];
    var handleTabChange = (0,react.useCallback)(function(value) {
        setCurrentTab(value);
        router.replace(generatePath(router.query.artistId ? routerPages.ArtistMissions : routerPages.GlobalEvents, {
            tab: value === 1 ? "mission" : undefined,
            artistId: router.query.artistId
        }));
    }, [
        generatePath,
        router,
        routerPages.ArtistMissions,
        routerPages.GlobalEvents
    ]);
    var handleSegmentChange = (0,react.useCallback)(function(value) {
        setCurrentSegment(value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                hasSettingTask: !!(state === null || state === void 0 ? void 0 : (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            }
        },
        header: {
            title: t("title"),
            back: config_config/* config.applicationType */.v.applicationType === "standalone",
            left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                edge: "start",
                onClick: function() {
                    return setOpenSideMenu(!openSideMenu);
                },
                color: "icon.line",
                bgcolor: "icon.background",
                badge: ((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask) || !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount) || !!(state === null || state === void 0 ? void 0 : (ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.GlobalEvents
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                followArtists: state.followArtists,
                memberArtists: state.memberArtists,
                open: openSideMenu,
                isArtist: state.isArtist,
                onClose: function() {
                    return setOpenSideMenu(false);
                },
                user: state.user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                labels: [
                    t("campaigns"),
                    t("missions")
                ],
                value: currentTab,
                disableAnimateTransitions: true,
                onChange: handleTabChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Segment, {
                            labels: [
                                t("campaignsSession"),
                                t("campaignsParticipating")
                            ],
                            value: currentSegment,
                            disableAnimateTransitions: true,
                            onChange: handleSegmentChange,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignsCell, {
                                    loading: state.loading || state.fetching,
                                    hasNextPage: state.hasCampaignNextPage,
                                    campaigns: state.campaigns,
                                    onFetchMoreCampaign: onFetchMoreCampaign
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignsParticipatingCell, {
                                    loading: state.loading || state.fetching,
                                    campaigns: state.campaignsParticipating
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_MissionsCell, {
                        loading: state.loading,
                        hasNextPage: state.hasMissionNextPage,
                        missions: state.missions,
                        onFetchMoreMission: onFetchMoreMission
                    })
                ]
            })
        ]
    });
};
var template_MissionsCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, missions = param.missions, onFetchMoreMission = param.onFetchMoreMission;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("globalEvents").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            mt: 4,
            pb: "64px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: missions === null || missions === void 0 ? void 0 : (ref = missions.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(MissionBox, {
                    fullWidth: true,
                    mission: node,
                    withArtistName: true,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            missionId: node.id,
                            name: "eventMission"
                        });
                    }
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMoreMission,
            componentProps: {
                spacing: 6
            },
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 6,
                children: [
                    1,
                    2,
                    3,
                    4
                ].map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBoxSkeleton, {
                        fullWidth: true
                    }, index);
                })
            }),
            emptyMessage: t("missionNotExist")
        })
    });
};
var CampaignsCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, campaigns = param.campaigns, onFetchMoreCampaign = param.onFetchMoreCampaign;
    var t = (0,core_i18n/* useTranslation */.$G)("globalEvents").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: campaigns === null || campaigns === void 0 ? void 0 : campaigns.edges.map(function(param) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CampaignBox, {
                    campaign: node,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            campaignId: node.id,
                            name: "eventCampaign",
                            tab: "onhold"
                        });
                    }
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMoreCampaign,
            component: List_List/* default */.Z,
            componentProps: {
                spacing: 0
            },
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: [
                    1,
                    2,
                    3,
                    4
                ].map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBoxSkeleton, {}, index);
                })
            }),
            emptyMessage: t("sessionCampaignNotExist")
        })
    });
};
var CampaignsParticipatingCell = function(param) {
    var loading = param.loading, campaigns = param.campaigns;
    var t = (0,core_i18n/* useTranslation */.$G)("globalEvents").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
            children: [
                1,
                2,
                3,
                4
            ].map(function(index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBoxSkeleton, {}, index);
            })
        }) : (campaigns === null || campaigns === void 0 ? void 0 : campaigns.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
            children: campaigns === null || campaigns === void 0 ? void 0 : campaigns.map(function(campaign) {
                return campaign && /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBox, {
                    campaign: campaign,
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            campaignId: campaign.id,
                            name: "eventCampaign",
                            tab: "participating"
                        });
                    }
                }, campaign.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            align: "center",
            sx: {
                py: 6
            },
            color: "text.secondary",
            children: t("participatingCampaignNotExist")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalEvents/viewModel.ts



function GlobalEvents_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GlobalEvents(\n    $typeFilter: [MissionType!]\n    $missionsPageInput: PageInput\n    $campaignsPageInput: PageInput\n  ) {\n    organization {\n      id\n      campaigns(pageInput: $campaignsPageInput) {\n        ...CampaignsConnection\n      }\n      entryCampaignRankings {\n        ...EntryCampaignRankingConnection\n      }\n      missions(typeFilter: $typeFilter, pageInput: $missionsPageInput) {\n        ...MissionsConnection\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GlobalEvents_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GlobalEvents_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewGlobalEvents(\n    $typeFilter: [MissionType!]\n    $missionsPageInput: PageInput\n    $campaignsPageInput: PageInput\n  ) {\n    organization {\n      id\n      campaigns(pageInput: $campaignsPageInput) {\n        ...CampaignsConnection\n      }\n      missions(typeFilter: $typeFilter, pageInput: $missionsPageInput) {\n        ...MissionsConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GlobalEvents_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var GlobalEvents_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var isFirstLoadRef = useGetNewestData({
        query: viewModel_FETCH_NEW_EVENT,
        variables: {
            typeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        fields: [
            {
                fieldName: "organization.campaigns",
                fragmentName: "CampaignBox",
                fragment: utoniq_core_schema/* CampaignBoxFragmentDoc */.mkm
            },
            {
                fieldName: "organization.missions",
                fragmentName: "MissionBox",
                fragment: utoniq_core_schema/* MissionBoxFragmentDoc */.zID
            }, 
        ]
    }).isFirstLoadRef;
    var ref11 = (0,useQuery/* useQuery */.aM)(GlobalEvents_viewModel_QUERY, {
        variables: {
            typeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref11.data, fetchMore = ref11.fetchMore, networkStatus = ref11.networkStatus;
    var isNextFetch = !!data;
    var ref12, ref13, ref14, ref15, ref16, ref17;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading && !isNextFetch,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasMissionNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : (ref1 = ref.missions) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            hasCampaignNextPage: !!(data === null || data === void 0 ? void 0 : (ref2 = data.organization) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.campaigns) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.hasNextPage),
            missions: (ref12 = data === null || data === void 0 ? void 0 : (ref4 = data.organization) === null || ref4 === void 0 ? void 0 : ref4.missions) !== null && ref12 !== void 0 ? ref12 : null,
            campaigns: (ref13 = data === null || data === void 0 ? void 0 : (ref5 = data.organization) === null || ref5 === void 0 ? void 0 : ref5.campaigns) !== null && ref13 !== void 0 ? ref13 : null,
            campaignsParticipating: (ref14 = data === null || data === void 0 ? void 0 : (ref6 = data.organization) === null || ref6 === void 0 ? void 0 : ref6.entryCampaignRankings) !== null && ref14 !== void 0 ? ref14 : null,
            user: (ref15 = data === null || data === void 0 ? void 0 : data.user) !== null && ref15 !== void 0 ? ref15 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref7 = userClaims.orgs) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[config_config/* config.organizationId */.v.organizationId]) === null || ref8 === void 0 ? void 0 : ref8.artist),
            followArtists: (ref16 = data === null || data === void 0 ? void 0 : (ref9 = data.user) === null || ref9 === void 0 ? void 0 : ref9.organizationFollowees) !== null && ref16 !== void 0 ? ref16 : null,
            memberArtists: (ref17 = data === null || data === void 0 ? void 0 : (ref10 = data.user) === null || ref10 === void 0 ? void 0 : ref10.organizationPatrons) !== null && ref17 !== void 0 ? ref17 : null
        },
        actions: {
            onFetchMoreMission: function onFetchMoreMission() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            missionsPageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : (ref1 = ref.missions) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMoreCampaign: function onFetchMoreCampaign() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            campaignsPageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : (ref1 = ref.campaigns) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var GlobalEvents_viewModel_QUERY = (0,lib/* gql */.Ps)(GlobalEvents_viewModel_templateObject(), utoniq_core_schema/* CampaignsConnectionFragmentDoc */.KLx, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN, utoniq_core_schema/* EntryCampaignRankingConnectionFragmentDoc */.Oax, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var viewModel_FETCH_NEW_EVENT = (0,lib/* gql */.Ps)(GlobalEvents_viewModel_templateObject1(), utoniq_core_schema/* CampaignsConnectionFragmentDoc */.KLx, utoniq_core_schema/* MissionsConnectionFragmentDoc */.kPN, utoniq_core_schema/* EntryCampaignRankingConnectionFragmentDoc */.Oax);

;// CONCATENATED MODULE: ./src/components/pages/GlobalEvents/index.tsx



var GlobalEvents = function() {
    var ref = GlobalEvents_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalEventsTemplate, {
        state: state,
        onFetchMoreCampaign: actions.onFetchMoreCampaign,
        onFetchMoreMission: actions.onFetchMoreMission
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/artist/ArtistBoxSkeleton/index.tsx



var ArtistBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 4,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "circular",
                width: 64,
                height: 64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "75%"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankListItemSkeleton/index.tsx


var RankListItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
        height: 72,
        variant: "rectangular",
        sx: {
            borderRadius: 1
        }
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ranking/RankListItem/index.tsx









var RankListItem = function(param) {
    var displayName = param.displayName, avatarUrl = param.avatarUrl, rank = param.rank, point = param.point, userId = param.userId;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            sx: {
                width: "100%",
                bgcolor: "grey.100",
                height: 72,
                borderRadius: 1,
                overflow: "hidden"
            },
            href: userId ? generatePath(routerPages.ArtistRanking, {
                artistId: userId
            }) : "#",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                flex: 1,
                sx: {
                    minWidth: 0
                },
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                sx: {
                                    width: 72,
                                    height: 72
                                },
                                src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    width: 22,
                                    height: 72,
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    backgroundImage: function(param) {
                                        var palette = param.palette;
                                        return "linear-gradient(to bottom right, transparent 50%, ".concat(palette.grey["100"], " 0)");
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        spacing: 2,
                        sx: {
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                align: "center",
                                sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                                    width: "100%"
                                }),
                                children: displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50",
                                    borderRadius: 3,
                                    width: 80,
                                    height: 20,
                                    position: "relative"
                                },
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: {
                                            mt: "2px"
                                        },
                                        children: point || "---"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.EventPoint, {
                                        sx: {
                                            position: "absolute",
                                            left: -4,
                                            top: -2
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                        rank: rank !== null && rank !== void 0 ? rank : 0,
                        size: "large",
                        sx: {
                            pr: 1
                        }
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/community/CommentBox/CommentBox.tsx





var CommentBox = function(param) {
    var c = param.comment, fullWidth = param.fullWidth, sx = param.sx, likeComment = param.likeComment;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: (0,src_object_spread/* default */.Z)({
            width: fullWidth ? "100%" : 315
        }, sx),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
            sx: {
                height: "100%",
                p: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    sx: {
                        p: 0,
                        textDecoration: "none",
                        color: "inherit"
                    },
                    component: Link/* default */.Z,
                    href: generatePath(routerPages.UserProfile, {
                        userId: c.commenter.id
                    }),
                    avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: ((ref = c.commenter.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) || undefined
                    }),
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "subtitle2",
                        children: c.commenter.displayName
                    }),
                    subheader: c.commenter.formattedAccountId,
                    subheaderTypographyProps: {
                        color: "text.secondary",
                        variant: "overline"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: generatePath(routerPages.CommentDetail, {
                        commentId: c.id
                    }),
                    sx: {
                        textDecoration: "none",
                        color: "inherit"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                pt: 4,
                                pb: 5,
                                px: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: c.content
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                            sx: {
                                p: 0,
                                justifyContent: "space-between",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: "text.secondary",
                                    variant: "caption",
                                    children: c.formattedCreatedAt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    spacing: 5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Like, {
                                                    onClick: function(e) {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        likeComment && likeComment();
                                                    },
                                                    onMouseDown: function(e) {
                                                        //disable ripple on parent
                                                        e.stopPropagation();
                                                    },
                                                    onTouchStart: function(e) {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                    },
                                                    disableTouchRipple: !likeComment,
                                                    liked: c.isLike
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    children: c.likeCount
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Reply, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    children: c.replyCount
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, c.id);
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalHome/template/index.tsx
























var GlobalHome_template_client = algolia/* client */.Lp();

var GlobalHomeTemplate = function(param) {
    var state = param.state, onFetchMoreFeeds = param.onFetchMoreFeeds, onFilterFeeds = param.onFilterFeeds, onLikePost = param.onLikePost, onLikeComment = param.onLikeComment;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var mdUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var _organizationArtistRankings, _entryCampaignRankings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            },
            responsive: displayResponsive
        },
        responsive: displayResponsive,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.GlobalHome
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIconCell, {
                    loading: state.loading,
                    isArtist: state.isArtist,
                    organizationFollowees: state.organizationFollowees,
                    organizationPatrons: state.organizationPatrons,
                    user: state.user,
                    prepaidPointBalance: state.prepaidPointBalance,
                    responsive: displayResponsive,
                    enableDmRoom: state.enableDmRoom
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_BannersCell, {
                banners: state.banners,
                loading: state.loading,
                user: state.user,
                responsive: displayResponsive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
                children: [
                    !!((ref3 = state.notifications) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NotificationListsCell, {
                        notifications: state.notifications
                    }),
                    state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalHome_template_ArtistsCell, {
                        loading: true,
                        artists: [],
                        responsive: displayResponsive
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
                        indexName: algolia/* indexes.organizationArtists */.RG.organizationArtists,
                        searchClient: GlobalHome_template_client,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                                filters: algolia/* filters.topDisplayArtists */.u8.topDisplayArtists(state.topDisplayArtistIds)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ArtistsCellWithAlgolia, {
                                loading: state.loading,
                                blockedUsers: state.blockedUsers,
                                topDisplayArtistIds: state.topDisplayArtistIds,
                                responsive: displayResponsive
                            })
                        ]
                    }),
                    state.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationArtistRankingCell, {
                        loading: state.loading,
                        organizationArtistRankings: (_organizationArtistRankings = state.organizationArtistRankings) !== null && _organizationArtistRankings !== void 0 ? _organizationArtistRankings : [],
                        isLoggedIn: state.isLoggedIn
                    }),
                    state.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingCell, {
                        entryCampaignRankings: (_entryCampaignRankings = state.entryCampaignRankings) !== null && _entryCampaignRankings !== void 0 ? _entryCampaignRankings : [],
                        loading: state.loading,
                        isLoggedIn: state.isLoggedIn
                    }),
                    state.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NewMissionsCell, {
                        followArtistMissions: state.followArtistMissions,
                        loading: state.loading,
                        isLoggedIn: state.isLoggedIn
                    }),
                    state.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NewGachasCell, {
                        followArtistGachas: state.followArtistGachas,
                        loading: state.loading,
                        isLoggedIn: state.isLoggedIn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NewEventsCell, {
                        events: state.events,
                        loading: state.loading
                    }),
                    state.isLoggedIn && (displayResponsive && mdUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedCell, {
                        feeds: state.feeds,
                        isLoggedIn: state.isLoggedIn,
                        loading: state.loading,
                        isMembershipPersonalInformationRequired: !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.isMembershipPersonalInformationRequired),
                        onLikePost: onLikePost,
                        onLikeComment: onLikeComment,
                        responsive: displayResponsive
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedScrollListOrganism, {
                        feeds: state.feeds,
                        isLoggedIn: state.isLoggedIn,
                        loading: state.loading,
                        isMembershipPersonalInformationRequired: !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired),
                        onFilter: onFilterFeeds,
                        onLoadMore: onFetchMoreFeeds,
                        onLikePost: onLikePost,
                        onLikeComment: onLikeComment,
                        responsive: displayResponsive
                    }))
                ]
            })
        ]
    });
};
var template_BannersCell = function(param) {
    var banners = param.banners, loading = param.loading, user = param.user, responsive = param.responsive;
    var isMultiple = !!banners && (banners === null || banners === void 0 ? void 0 : banners.length) > 1;
    var smUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("sm");
    });
    var mdUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            sx: {
                width: "90vw",
                maxWidth: responsive ? "750px" : "600px",
                margin: "8px auto 0",
                borderRadius: 2,
                height: "calc(90vw * 184 / 335)",
                maxHeight: "calc(540px * 184 / 335)"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: (0,src_object_spread/* default */.Z)({
            mt: 2,
            ".swiper-pagination-bullet-active": {
                bgcolor: "grey.700"
            }
        }, responsive ? {
            ".banner-swiper .swiper-wrapper": {
                display: "flex",
                alignItems: "center"
            }
        } : {}),
        children: !!(banners === null || banners === void 0 ? void 0 : banners.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            pagination: {
                clickable: true
            },
            modules: [
                modules/* Pagination */.tl
            ],
            loop: isMultiple,
            slidesPerView: responsive ? !mdUp ? 1.1 : "auto" : 1.1,
            centeredSlides: true,
            spaceBetween: responsive ? !smUp ? 10 : !mdUp ? 18 : 48 : 10,
            enabled: isMultiple,
            className: "banner-swiper",
            style: {
                overflow: responsive ? mdUp ? "visible" : undefined : undefined,
                paddingBottom: isMultiple ? 40 : 0
            },
            children: banners.map(function(banner, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, responsive ? {
                    style: {
                        maxWidth: "100%",
                        width: !smUp ? "335px" : !mdUp ? "560px" : "750px",
                        display: "flex",
                        justifyContent: "center"
                    }
                } : {}), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalHome_template_BannerCell, {
                        thumbnail: banner.thumbnail,
                        link: banner.link,
                        text: banner.text,
                        user: user,
                        responsive: responsive
                    })
                }), index);
            })
        })
    });
};
var HeaderIconCell = function(param) {
    var organizationFollowees = param.organizationFollowees, organizationPatrons = param.organizationPatrons, user = param.user, isArtist = param.isArtist, prepaidPointBalance = param.prepaidPointBalance, loading = param.loading, responsive = param.responsive, enableDmRoom = param.enableDmRoom;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1 = (0,react.useState)(false), openSideMenu = ref1[0], setOpenSideMenu = ref1[1];
    if (loading) {
        return null;
    }
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        sx: {
            px: 5,
            pt: 4,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.MyPage, {
                sx: {
                    width: 44,
                    height: 44,
                    color: "grey.600",
                    mr: 3,
                    position: "relative",
                    backgroundColor: "grey.50",
                    svg: {
                        color: "icon.line"
                    }
                },
                onClick: function() {
                    return setOpenSideMenu(!openSideMenu);
                },
                badge: (user === null || user === void 0 ? void 0 : user.hasManagementTask) || !!(user === null || user === void 0 ? void 0 : user.unreadNotificationCount) || !!(user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) ? {
                    badgeContent: "",
                    color: "like",
                    sx: {
                        "& > span": {
                            top: -4,
                            right: -4,
                            minWidth: 12,
                            height: 12
                        }
                    }
                } : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                memberArtists: organizationPatrons,
                followArtists: organizationFollowees,
                open: openSideMenu,
                onClose: function() {
                    return setOpenSideMenu(false);
                },
                user: user,
                isArtist: isArtist,
                responsive: responsive,
                enableDmRoom: enableDmRoom
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                children: !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && !(0,individual/* individualHideWallet */.Bd)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                    point: (ref2 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref2 !== void 0 ? ref2 : 0
                })
            }),
            config_config/* config.modules.campaign */.v.modules.campaign && config_config/* config.modules.mission */.v.modules.mission && // Liella!の場合はイベント導線非表示
            config_config/* config.applicationKey */.v.applicationKey !== "liella" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Event, {
                href: generatePath(routerPages.GlobalEvents),
                sx: {
                    width: 44,
                    height: 44,
                    backgroundColor: "grey.50",
                    color: "grey.600",
                    mr: 3
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Notice, {
                href: routerPages.Notifications,
                sx: {
                    width: 44,
                    height: 44,
                    backgroundColor: "grey.50",
                    color: "grey.600"
                }
            })
        ]
    });
};
var template_NotificationListsCell = function(param) {
    var notifications = param.notifications;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pt: 4,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h3",
                        children: t("officialNotificationLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "h6",
                        href: routerPages.OfficialInformation,
                        children: t("toList")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: notifications === null || notifications === void 0 ? void 0 : notifications.map(function(param, index) {
                    var node = param.node;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(template_NotificationItemCell, {
                        notification: node,
                        divider: (notifications === null || notifications === void 0 ? void 0 : notifications.length) - 1 > index,
                        isExternalLink: node.link ? (0,lib_url/* isExternalLink */.Bm)(node.link) : false
                    }, node.id);
                })
            })
        ]
    });
};
var template_NotificationItemCell = function(param) {
    var notification = param.notification, divider = param.divider, isExternalLink = param.isExternalLink;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var _link;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((_link = notification.link) !== null && _link !== void 0 ? _link : "").onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
        component: isExternalLink ? "p" : Link/* default */.Z,
        href: notification.link || generatePath(routerPages.OfficialInformationDetail, {
            notificationId: notification.id
        }),
        onClick: isExternalLink ? onClick : undefined,
        sx: {
            height: "auto",
            py: 3,
            px: 0
        },
        divider: divider,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                primary: notification.title,
                slotProps: {
                    primary: {
                        variant: "body2",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2)
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Transition, {
                    fontSize: "xSmall"
                })
            })
        ]
    });
};
/**
 * @todo
 * [UT-3167] Algoliaの検索ロジック切り分け追加時に外す
 * https://app.clickup.com/t/908127/UT-3167
 */ var template_ArtistsCellWithAlgolia = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, loading = param.loading, blockedUsers = param.blockedUsers, topDisplayArtistIds = param.topDisplayArtistIds, responsive = param.responsive;
    if ((0,individual/* individualHideArtists */.ii)()) return null;
    /**
   * @description
   * algoliaへの依存を避けるために、objectID→idへ変数名を変更
   */ var artists = hits.filter(function(artist) {
        return blockedUsers.indexOf(artist.objectID) < 0;
    }).map(function(artist) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, artist), {
            id: artist.objectID
        });
    });
    if (!(topDisplayArtistIds === null || topDisplayArtistIds === void 0 ? void 0 : topDisplayArtistIds.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalHome_template_ArtistsCell, {
        artists: artists,
        loading: loading,
        responsive: responsive
    });
    /**
   * topDisplayArtistIdsの配列昇順に表示する
   */ var artistOrderByTopDisplayArtistId = topDisplayArtistIds.map(function(artistId) {
        return artists.find(function(param) {
            var id = param.id;
            return id === artistId;
        });
    }).filter(function(v) {
        return !!v;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalHome_template_ArtistsCell, {
        artists: artistOrderByTopDisplayArtistId,
        loading: loading,
        responsive: responsive
    });
});
var GlobalHome_template_ArtistsCell = function(param) {
    var artists = param.artists, loading = param.loading, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    if ((0,individual/* individualHideArtists */.ii)() && loading) return null;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        sx: {
            pt: 5
        },
        loading: loading,
        title: t("artistLabel"),
        items: artists,
        loadingItemLength: 8,
        LoadingComponent: ArtistBoxSkeleton,
        renderItem: function(artist, i) {
            var ref, ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                    sx: {
                        p: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                        sx: {
                            display: "inline-block",
                            textAlign: "center",
                            width: responsive ? {
                                xs: 64,
                                md: 100
                            } : 64,
                            p: 0,
                            borderRadius: 1
                        },
                        href: generatePath(routerPages.ArtistTop, {
                            artistId: artist.id
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: responsive ? {
                                    width: {
                                        xs: 64,
                                        md: 100
                                    },
                                    height: {
                                        xs: 64,
                                        md: 100
                                    }
                                } : {
                                    width: 64,
                                    height: 64
                                },
                                alt: artist.displayName,
                                src: (ref1 = (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : (ref2 = artist.avatar) === null || ref2 === void 0 ? void 0 : ref2.uri
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                sx: (0,src_object_spread/* default */.Z)({
                                    pt: 3,
                                    display: "block"
                                }, styles/* styleSets.lineCamp */.k$.lineCamp(1)),
                                color: "text.secondary",
                                children: artist.displayName
                            })
                        ]
                    })
                })
            }, i);
        }
    });
};
var OrganizationArtistRankingCell = function(param) {
    var organizationArtistRankings = param.organizationArtistRankings, loading = param.loading, isLoggedIn = param.isLoggedIn;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var showableRankings = organizationArtistRankings === null || organizationArtistRankings === void 0 ? void 0 : organizationArtistRankings.filter(function(edge) {
        var ref;
        var ranking = edge === null || edge === void 0 ? void 0 : edge.node;
        return ranking && ((ref = ranking.latestRankingPeriod) === null || ref === void 0 ? void 0 : ref.periodType) === utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly;
    });
    if (!(showableRankings === null || showableRankings === void 0 ? void 0 : showableRankings.length) || !isLoggedIn) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: loading ? [
            1,
            2,
            3
        ].map(function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pb: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankListItemSkeleton, {})
                })
            }, i);
        }) : (showableRankings === null || showableRankings === void 0 ? void 0 : showableRankings.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                px: 5,
                pb: 6
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h3",
                            sx: {
                                py: 2
                            },
                            children: t("organizationArtistRankingTitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                            variant: "h5",
                            underline: "none",
                            sx: {
                                color: "primary.main"
                            },
                            href: generatePath(routerPages.MyRanking),
                            children: t("toList")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    children: showableRankings.map(function(edge, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                        var ranking = edge === null || edge === void 0 ? void 0 : edge.node;
                        var ref7, ref8, ref9, ref10;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    pt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RankListItem, {
                                    displayName: (ref7 = ranking === null || ranking === void 0 ? void 0 : (ref = ranking.artist) === null || ref === void 0 ? void 0 : ref.displayName) !== null && ref7 !== void 0 ? ref7 : "",
                                    avatarUrl: (ref8 = ranking === null || ranking === void 0 ? void 0 : (ref1 = ranking.artist) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref8 !== void 0 ? ref8 : "",
                                    point: (ref9 = ranking === null || ranking === void 0 ? void 0 : (ref3 = ranking.latestRankingPeriod) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.myRanking) === null || ref4 === void 0 ? void 0 : ref4.point) !== null && ref9 !== void 0 ? ref9 : 0,
                                    rank: (ref10 = ranking === null || ranking === void 0 ? void 0 : (ref5 = ranking.latestRankingPeriod) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.myRanking) === null || ref6 === void 0 ? void 0 : ref6.rank) !== null && ref10 !== void 0 ? ref10 : 0,
                                    userId: ranking === null || ranking === void 0 ? void 0 : ranking.artistId
                                }, index)
                            })
                        }, index);
                    })
                })
            ]
        }) : null
    });
};
var RankingCell = function(param) {
    var entryCampaignRankings = param.entryCampaignRankings, loading = param.loading, isLoggedIn = param.isLoggedIn;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (!isLoggedIn || !(entryCampaignRankings === null || entryCampaignRankings === void 0 ? void 0 : entryCampaignRankings.length) || !config_config/* config.modules.campaign */.v.modules.campaign) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: loading ? [
            1,
            2,
            3
        ].map(function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    backgroundColor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        pt: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBoxSkeleton, {})
                })
            }, i);
        }) : (entryCampaignRankings === null || entryCampaignRankings === void 0 ? void 0 : entryCampaignRankings.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                backgroundColor: "grey.50",
                pt: 3,
                pb: 5,
                mb: 6
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        px: 5,
                        py: 2
                    },
                    children: t("rankingLabel")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    children: entryCampaignRankings.map(function(ranking, index) {
                        var ref;
                        return ranking && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                                href: generatePath(routerPages.CampaignDetail, {
                                    campaignId: ranking.id
                                }),
                                sx: {
                                    p: 0,
                                    mx: 4,
                                    my: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        variant: "square",
                                        sx: {
                                            width: 100,
                                            height: 64,
                                            borderRadius: 2
                                        },
                                        alt: ranking.myRank.displayName,
                                        src: ((ref = ranking.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) || ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: {
                                            pl: 4,
                                            width: "100%"
                                        },
                                        display: "flex",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "h2",
                                                sx: {
                                                    pb: 1
                                                },
                                                children: [
                                                    ranking.myRank.rank,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        component: "p",
                                                        variant: "subtitle2",
                                                        display: "inline",
                                                        children: t("rank")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body1",
                                                        children: ranking.myRank.displayName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        color: "text.hint",
                                                        children: [
                                                            ranking.myRank.point,
                                                            "pt"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        }) : null
    });
};
var template_NewMissionsCell = function(param) {
    var followArtistMissions = param.followArtistMissions, loading = param.loading, isLoggedIn = param.isLoggedIn;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var newMissions = followArtistMissions === null || followArtistMissions === void 0 ? void 0 : followArtistMissions.edges;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    if (!isLoggedIn || !(newMissions === null || newMissions === void 0 ? void 0 : newMissions.length) || !config_config/* config.modules.mission */.v.modules.mission) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("newMissionLabel"),
        items: newMissions,
        trans: t("toList"),
        LoadingComponent: MissionBoxSkeleton,
        listHref: generatePath(routerPages.GlobalEvents, {
            tab: "mission"
        }),
        renderItem: function(mission, i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionBox, {
                    sx: {
                        mt: 0
                    },
                    mission: mission.node,
                    onClick: function() {
                        var ref, ref1, ref2;
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                            artistId: (ref = mission.node) === null || ref === void 0 ? void 0 : ref.artist.id,
                            missionId: (ref1 = mission.node) === null || ref1 === void 0 ? void 0 : ref1.id,
                            type: (ref2 = mission.node) === null || ref2 === void 0 ? void 0 : ref2.type,
                            name: "missions"
                        });
                    }
                })
            }, i);
        },
        EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_EmptyCell, {
            message: t("newMissionEmptyMessage")
        })
    });
};
var template_NewGachasCell = function(param) {
    var followArtistGachas = param.followArtistGachas, loading = param.loading, isLoggedIn = param.isLoggedIn;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    // @ts-ignore
    var gachas = followArtistGachas === null || followArtistGachas === void 0 ? void 0 : followArtistGachas.edges;
    if (!isLoggedIn || !(gachas === null || gachas === void 0 ? void 0 : gachas.length) || !config_config/* config.modules.gacha */.v.modules.gacha) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("newGachasLabel"),
        items: gachas,
        LoadingComponent: GachaBoxSkeleton,
        renderItem: function(gacha, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaBox, {
                    gacha: gacha.node,
                    artistId: gacha.node.artistId
                })
            }, i);
        },
        EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_EmptyCell, {
            message: t("newGachasEmptyMessage")
        })
    });
};
var template_NewEventsCell = function(param) {
    var events = param.events, loading = param.loading;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    if (!(events === null || events === void 0 ? void 0 : (ref = events.edges) === null || ref === void 0 ? void 0 : ref.length) || !config_config/* config.modules.event */.v.modules.event) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("newEventsLabel"),
        listHref: routerPages.ShokufesEvents,
        items: events.edges,
        trans: t("toList"),
        spacing: 4,
        LoadingComponent: GachaBoxSkeleton,
        renderItem: function(event, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
                    event: event.node,
                    sx: {
                        width: 315,
                        height: "100%"
                    }
                })
            }, i);
        }
    });
};
var FeedScrollListOrganism = function(param) {
    var feeds = param.feeds, isLoggedIn = param.isLoggedIn, onLikePost = param.onLikePost, onLikeComment = param.onLikeComment, loading = param.loading, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, responsive = param.responsive;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    if (!isLoggedIn || (0,individual/* individualHideFeed */.Jp)()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            backgroundColor: "background.default",
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    pl: 5,
                    pr: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("feedLabel")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    px: 5,
                    mt: 3
                },
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: [
                        1,
                        2,
                        3
                    ].map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBoxSkeleton, {
                            fullWidth: true
                        }, i);
                    })
                }) : (feeds === null || feeds === void 0 ? void 0 : (ref = feeds.edges) === null || ref === void 0 ? void 0 : ref.length) ? feeds === null || feeds === void 0 ? void 0 : feeds.edges.map(function(param) {
                    var node = param.node;
                    if (!(node && node.data)) {
                        return null;
                    }
                    if ("resourceType" in node.data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, (0,src_object_spread/* default */.Z)({
                                onLike: function() {
                                    if (node && node.data && "resourceType" in node.data) {
                                        var _data = node.data, id = _data.id, isLike = _data.isLike, likeCount = _data.likeCount;
                                        onLikePost(id, isLike, likeCount);
                                    }
                                },
                                post: node.data,
                                isMembershipPersonalInformationRequired: isMembershipPersonalInformationRequired
                            }, responsive ? {
                                responsive: true
                            } : {
                                fullWidth: true
                            }))
                        }, node.id);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBox, {
                            likeComment: function() {
                                node.data && onLikeComment(node.data.id, node.data.isLike, node.data.likeCount);
                            },
                            comment: node.data,
                            fullWidth: true
                        })
                    }, node.id);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(template_EmptyCell, {
                    message: t("feedEmptyMessage")
                })
            })
        ]
    });
};
var FeedCell = function(param) {
    var feeds = param.feeds, isLoggedIn = param.isLoggedIn, onLikePost = param.onLikePost, onLikeComment = param.onLikeComment, loading = param.loading, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("globalHome").t;
    if (!isLoggedIn || (0,individual/* individualHideFeed */.Jp)()) return null;
    if ((!(feeds === null || feeds === void 0 ? void 0 : feeds.edges) || !(feeds === null || feeds === void 0 ? void 0 : feeds.edges.length)) && !loading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            backgroundColor: "background.default",
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    pl: 5,
                    pr: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("feedLabel")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    px: 5,
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_EmptyCell, {
                    message: t("feedEmptyMessage")
                })
            })
        ]
    });
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        title: t("feedLabel"),
        items: (ref = feeds === null || feeds === void 0 ? void 0 : feeds.edges) !== null && ref !== void 0 ? ref : [],
        LoadingComponent: PostBoxSkeleton,
        renderItem: function(p, i) {
            if (!(p.node && p.node.data)) {
                return null;
            }
            if ("resourceType" in p.node.data) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    in: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostBox, {
                        sx: {
                            height: "100%"
                        },
                        onLike: function() {
                            if (p.node && p.node.data && "resourceType" in p.node.data) {
                                var _data = p.node.data, id = _data.id, isLike = _data.isLike, likeCount = _data.likeCount;
                                onLikePost(id, isLike, likeCount);
                            }
                        },
                        post: p.node.data,
                        isMembershipPersonalInformationRequired: isMembershipPersonalInformationRequired
                    })
                }, p.node.id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentBox, {
                    likeComment: function() {
                        p.node.data && onLikeComment(p.node.data.id, p.node.data.isLike, p.node.data.likeCount);
                    },
                    comment: p.node.data
                })
            }, p.node.id);
        }
    });
};
var template_EmptyCell = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 6,
            py: 5,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            color: "text.secondary",
            children: message
        })
    });
};
var GlobalHome_template_BannerCell = function(param) {
    var thumbnail = param.thumbnail, text = param.text, link = param.link, user = param.user, responsive = param.responsive;
    var isExternal = link === null || link === void 0 ? void 0 : link.externalUrl;
    var ref, ref1, ref2;
    var href = isExternal ? (ref = link === null || link === void 0 ? void 0 : link.externalUrl) !== null && ref !== void 0 ? ref : "" : ((ref1 = link === null || link === void 0 ? void 0 : link.innerPath) !== null && ref1 !== void 0 ? ref1 : "") ? (ref2 = link === null || link === void 0 ? void 0 : link.innerPath) !== null && ref2 !== void 0 ? ref2 : "" : "";
    var ref3;
    var replacedUrl = (0,lib_url/* replaceParameters */.yB)(href, {
        uid: (ref3 = user === null || user === void 0 ? void 0 : user.id) !== null && ref3 !== void 0 ? ref3 : ""
    });
    var bannerStyle = responsive ? {
        display: "block",
        width: "100%",
        margin: "0 auto"
    } : {
        display: "block"
    };
    var imgStyle = responsive ? {
        width: "100%",
        objectFit: "contain"
    } : {
        display: "block",
        width: "100%",
        maxWidth: "600px"
    };
    var _mediumUri;
    var bannerSrc = (_mediumUri = thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : thumbnail.uri || "";
    if (isExternal) return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: bannerStyle,
        href: replacedUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
            style: imgStyle,
            src: bannerSrc,
            alt: text
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: bannerStyle,
        href: replacedUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
            style: imgStyle,
            src: bannerSrc,
            alt: text
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/GlobalHome/viewModel.ts




function GlobalHome_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GlobalHome(\n    $pageInput: PageInputDate\n    $type: FeedType\n    $followArtistGachasPageInput: PageInputDate\n    $followArtistMissionsPageInput: PageInput\n    $missionsTypeFilter: [MissionType!]\n  ) {\n    user {\n      ...CurrentUser\n      feeds(pageInput: $pageInput, type: $type) {\n        ...FeedConnection\n      }\n    }\n    organizationOfficialNotifications {\n      ...OrganizationNotificationConnection\n    }\n    organization {\n      id\n      banners {\n        ...BannerConnection\n      }\n      entryCampaignRankings {\n        ...EntryCampaignRankingConnection\n      }\n      followArtistGachas(pageInput: $followArtistGachasPageInput) {\n        ...FollowArtistGachasConnection\n      }\n      followArtistMissions(\n        pageInput: $followArtistMissionsPageInput\n        typeFilter: $missionsTypeFilter\n      ) {\n        ...FollowArtistMissionsConnection\n      }\n      topDisplayArtistIds\n      modules {\n        dmRoom\n      }\n    }\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n    }\n    organizationArtistRankings(pageInput: { limit: 3 }) {\n      ...GlobalHomeOrganizationArtistRankingsConnection\n    }\n    events(filter: all) {\n      edges {\n        node {\n          ...GlobalEvent\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GlobalHome_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GlobalHome_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GlobalHomeForGuest {\n    organization {\n      id\n      banners {\n        ...BannerConnection\n      }\n      topDisplayArtistIds\n      modules {\n        dmRoom\n      }\n    }\n    organizationOfficialNotifications {\n      ...OrganizationNotificationConnection\n    }\n    events(filter: all) {\n      edges {\n        node {\n          ...GlobalEvent\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    GlobalHome_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GlobalHome_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikeComment($likeCommentId: ID!) {\n    likeComment(id: $likeCommentId) {\n      likeCount\n      isLike\n      id\n    }\n  }\n"
    ]);
    GlobalHome_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GlobalHome_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikeComment($unlikeCommentId: ID!) {\n    unlikeComment(id: $unlikeCommentId) {\n      likeCount\n      isLike\n      id\n    }\n  }\n"
    ]);
    GlobalHome_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var GlobalHome_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref24.user, userClaims = ref24.userClaims;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var reloadUser = (0,auth/* useAuth */.aC)().reloadUser;
    var ref25 = (0,useQuery/* useQuery */.aM)(GlobalHome_viewModel_QUERY, {
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        variables: {
            pageInput: {
                limit: 20
            },
            type: utoniq_core_schema/* FeedType.Post */.u5X.Post,
            missionsTypeFilter: [
                utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz,
                utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect
            ]
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref25.data, loading = ref25.loading, fetchMore = ref25.fetchMore, refetch = ref25.refetch;
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : data.organization);
    var ref26 = (0,useQuery/* useQuery */.aM)(GlobalHome_viewModel_QUERY_FOR_GUEST, {
        skip: !!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned),
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), dataForGuest = ref26.data, loadingForGuest = ref26.loading;
    var isNextFetchForGuest = !!(dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.organization);
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikePost */.UEr), 1), likePost = ref27[0];
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikePost */.UsN), 1), unlikePost = ref28[0];
    var ref29 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_COMMENT), 1), likeComment = ref29[0];
    var ref30 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_COMMENT), 1), unlikeComment = ref30[0];
    var ref31;
    var feeds = (ref31 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.feeds) !== null && ref31 !== void 0 ? ref31 : null;
    // GA userProperty
    // 無料会員 or 有料会員: 1つでも有料会員があればpaid userとする
    // エントリー中キャンペーン: 参加中のidをカンマ区切り
    var userType = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous) ? "guest" : (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.organizationPatrons) && data.user.organizationPatrons.length > 0 ? "paid" : "free";
    var entryCampaigns = (data === null || data === void 0 ? void 0 : (ref2 = data.organization) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.entryCampaignRankings) === null || ref3 === void 0 ? void 0 : ref3.map(function(ranking) {
        return ranking === null || ranking === void 0 ? void 0 : ranking.id;
    })) || [];
    analytics === null || analytics === void 0 ? void 0 : analytics.identify(currentUser, omitBy_default()({
        user_type: userType,
        entry_campaigns: entryCampaigns.join(",").slice(0, 36)
    }, function(v) {
        return !v;
    }));
    var location = (0,router_useRouter/* useRouter */.tv)().location;
    (0,router_useRouter/* useTrackPageView */.Px)(function() {
        /**
     * HACK: delay for save
     */ setTimeout(function() {
            return (0,storage/* setRedirectAfterLoginPath */.fu)(location.pathname);
        }, 300);
    });
    (0,react.useEffect)(function() {
        if (currentUser && !loading) {
            reloadUser().catch(showError);
        }
    }, [
        loading
    ]);
    var ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48;
    return {
        state: {
            loading: loading && !isNextFetch || loadingForGuest && !isNextFetchForGuest,
            user: (ref32 = data === null || data === void 0 ? void 0 : data.user) !== null && ref32 !== void 0 ? ref32 : null,
            isLoggedIn: !!currentUser,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref4 = userClaims.orgs) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[config_config/* config.organizationId */.v.organizationId]) === null || ref5 === void 0 ? void 0 : ref5.artist),
            banners: (ref34 = (ref33 = data === null || data === void 0 ? void 0 : (ref6 = data.organization) === null || ref6 === void 0 ? void 0 : ref6.banners) !== null && ref33 !== void 0 ? ref33 : dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref7 = dataForGuest.organization) === null || ref7 === void 0 ? void 0 : ref7.banners) !== null && ref34 !== void 0 ? ref34 : null,
            feeds: feeds,
            prepaidPointBalance: (ref35 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref35 !== void 0 ? ref35 : null,
            entryCampaignRankings: (ref36 = data === null || data === void 0 ? void 0 : (ref8 = data.organization) === null || ref8 === void 0 ? void 0 : ref8.entryCampaignRankings) !== null && ref36 !== void 0 ? ref36 : null,
            followArtistGachas: (ref37 = data === null || data === void 0 ? void 0 : (ref9 = data.organization) === null || ref9 === void 0 ? void 0 : ref9.followArtistGachas) !== null && ref37 !== void 0 ? ref37 : null,
            followArtistMissions: (ref38 = data === null || data === void 0 ? void 0 : (ref10 = data.organization) === null || ref10 === void 0 ? void 0 : ref10.followArtistMissions) !== null && ref38 !== void 0 ? ref38 : null,
            blockedUsers: (ref39 = data === null || data === void 0 ? void 0 : (ref11 = data.user) === null || ref11 === void 0 ? void 0 : ref11.blockedUsers) !== null && ref39 !== void 0 ? ref39 : [],
            organizationFollowees: (ref40 = data === null || data === void 0 ? void 0 : (ref12 = data.user) === null || ref12 === void 0 ? void 0 : ref12.organizationFollowees) !== null && ref40 !== void 0 ? ref40 : null,
            organizationPatrons: (ref41 = data === null || data === void 0 ? void 0 : (ref13 = data.user) === null || ref13 === void 0 ? void 0 : ref13.organizationPatrons) !== null && ref41 !== void 0 ? ref41 : null,
            topDisplayArtistIds: (ref43 = (ref42 = data === null || data === void 0 ? void 0 : (ref14 = data.organization) === null || ref14 === void 0 ? void 0 : ref14.topDisplayArtistIds) !== null && ref42 !== void 0 ? ref42 : dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref15 = dataForGuest.organization) === null || ref15 === void 0 ? void 0 : ref15.topDisplayArtistIds) !== null && ref43 !== void 0 ? ref43 : null,
            notifications: (ref45 = (ref44 = data === null || data === void 0 ? void 0 : (ref16 = data.organizationOfficialNotifications) === null || ref16 === void 0 ? void 0 : ref16.edges.slice(0, 3)) !== null && ref44 !== void 0 ? ref44 : dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref17 = dataForGuest.organizationOfficialNotifications) === null || ref17 === void 0 ? void 0 : ref17.edges.slice(0, 3)) !== null && ref45 !== void 0 ? ref45 : null,
            organizationArtistRankings: (ref46 = data === null || data === void 0 ? void 0 : (ref18 = data.organizationArtistRankings) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.edges) === null || ref19 === void 0 ? void 0 : ref19.filter(function(param) {
                var node = param.node;
                return (node === null || node === void 0 ? void 0 : node.status) === utoniq_core_schema/* RankingStatus.Active */.HBK.Active;
            })) !== null && ref46 !== void 0 ? ref46 : null,
            events: (ref48 = (ref47 = data === null || data === void 0 ? void 0 : data.events) !== null && ref47 !== void 0 ? ref47 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.events) !== null && ref48 !== void 0 ? ref48 : null,
            enableDmRoom: !!(data === null || data === void 0 ? void 0 : (ref20 = data.organization) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.modules) === null || ref21 === void 0 ? void 0 : ref21.dmRoom) || !!(dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref22 = dataForGuest.organization) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.modules) === null || ref23 === void 0 ? void 0 : ref23.dmRoom)
        },
        actions: {
            onFilterFeeds: function() {
                return refetch({
                    type: utoniq_core_schema/* FeedType.Comment */.u5X.Comment
                });
            },
            onFetchMoreFeeds: function() {
                var ref;
                return fetchMore({
                    variables: {
                        cursor: feeds === null || feeds === void 0 ? void 0 : (ref = feeds.pageInfo) === null || ref === void 0 ? void 0 : ref.endCursor,
                        limit: 20
                    }
                });
            },
            onLikePost: function onLikePost(postId, isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeComment: function onLikeComment(commentId, isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikeComment({
                                        variables: {
                                            unlikeCommentId: commentId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikeCommentId = param.unlikeCommentId;
                                            return {
                                                unlikeComment: {
                                                    __typename: "Comment",
                                                    id: unlikeCommentId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likeComment({
                                        variables: {
                                            likeCommentId: commentId
                                        },
                                        optimisticResponse: function(param) {
                                            var likeCommentId = param.likeCommentId;
                                            return {
                                                likeComment: {
                                                    __typename: "Comment",
                                                    id: likeCommentId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var GlobalHome_viewModel_QUERY = (0,lib/* gql */.Ps)(GlobalHome_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* GlobalEventFragmentDoc */.Yje, utoniq_core_schema/* FeedConnectionFragmentDoc */.fzW, utoniq_core_schema/* BannerConnectionFragmentDoc */.dO1, utoniq_core_schema/* EntryCampaignRankingConnectionFragmentDoc */.Oax, utoniq_core_schema/* FollowArtistGachasConnectionFragmentDoc */.MEk, utoniq_core_schema/* FollowArtistMissionsConnectionFragmentDoc */.hB2, utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf, utoniq_core_schema/* GlobalHomeOrganizationArtistRankingsConnectionFragmentDoc */.hMp);
var GlobalHome_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(GlobalHome_viewModel_templateObject1(), utoniq_core_schema/* BannerConnectionFragmentDoc */.dO1, utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf, utoniq_core_schema/* GlobalEventFragmentDoc */.Yje);
var LIKE_COMMENT = (0,lib/* gql */.Ps)(GlobalHome_viewModel_templateObject2());
var UNLIKE_COMMENT = (0,lib/* gql */.Ps)(GlobalHome_viewModel_templateObject3());

;// CONCATENATED MODULE: ./src/components/pages/GlobalHome/index.tsx




/**
 * GlobalHome Page
 * Implemented as a practical sample.
 */ var GlobalHome = function() {
    var ref = GlobalHome_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalHomeTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/post/HtmlRenderer/useSafeHtml.ts
var useSafeHtml = __webpack_require__(85911);
// EXTERNAL MODULE: ./src/components/pages/Errors/NotFoundWeb/index.tsx + 1 modules
var NotFoundWeb = __webpack_require__(5978);
;// CONCATENATED MODULE: ./src/components/pages/HtmlFormRelay/template/index.tsx






// クエリから action と inputs(JSON) を受け取り、自動でPOST送信する
var HtmlFormRelayTemplate = function(param) {
    var state = param.state, actions = param.actions;
    var formRef = (0,react.useRef)(null);
    var inputs = state.inputs;
    var ref = {
        formHtml: '<form action="'.concat(state.action, '" method="').concat(state.method, '">').concat(inputs.map(function(inp) {
            return '<input type="hidden" name="'.concat(inp.name, '" value="').concat(String(inp.value).replace(/"/g, "&quot;"), '" />');
        }).join(""), '<button type="submit">submit</button></form>'),
        isValidAction: state.isValidAction
    }, formHtml = ref.formHtml, isValidAction = ref.isValidAction;
    var safeCheck = (0,useSafeHtml/* useSafeHtml */.Y)({
        text: formHtml
    });
    (0,react.useEffect)(function() {
        var _clientId, _clientToken;
        // ワンタイムトークンの検証は画面表示時の初回のみ
        // トークンが付与されずにアクセスされた場合も検証スタータス更新を行う
        actions.verifyToken({
            clientId: (_clientId = state.clientId) !== null && _clientId !== void 0 ? _clientId : "",
            token: (_clientToken = state.clientToken) !== null && _clientToken !== void 0 ? _clientToken : ""
        }).catch(function() {});
    }, []);
    (0,react.useEffect)(function() {
        if (!state.action || !isValidAction || !formRef.current || !state.verified) return;
        formRef.current.submit();
    }, [
        state.verified,
        state.action,
        isValidAction
    ]);
    if (!(0,individual/* individualShowHtmlFormRelay */.N1)() || safeCheck !== "safe" || !isValidAction || state.verified === false) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: "*",
            render: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFoundWeb/* NotFoundWeb */.c, {});
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        ref: formRef,
        action: state.action,
        method: state.method,
        children: inputs.map(function(inp, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                name: inp.name,
                value: inp.value
            }, "".concat(inp.name, "-").concat(idx));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/HtmlFormRelay/viewModel.ts




function HtmlFormRelay_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyPartnerClientToken($input: VerifyPartnerClientTokenInput!) {\n    verifyPartnerClientToken(input: $input) {\n      valid\n    }\n  }\n"
    ]);
    HtmlFormRelay_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var VERIFY_MUTATION = (0,lib/* gql */.Ps)(HtmlFormRelay_viewModel_templateObject());
var HtmlFormRelay_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var location = (0,react_router/* useLocation */.TH)();
    var searchParams = (0,react.useMemo)(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
    var action = searchParams.get("action") || "";
    var method = (searchParams.get("method") || "post").toLowerCase();
    var inputsJson = searchParams.get("inputs") || "[]";
    var clientId = searchParams.get("clientId");
    var clientToken = searchParams.get("token");
    var inputs = (0,react.useMemo)(function() {
        try {
            var parsed = JSON.parse(inputsJson);
            if (Array.isArray(parsed)) {
                var _value;
                return parsed.filter(function(v) {
                    return v && typeof v.name === "string";
                }).map(function(v) {
                    return {
                        name: String(v.name),
                        value: String((_value = v.value) !== null && _value !== void 0 ? _value : "")
                    };
                });
            }
            return [];
        } catch (e) {
            return [];
        }
    }, [
        inputsJson
    ]);
    var isValidAction = (0,react.useMemo)(function() {
        // actionのドメインが許可されているかをチェック
        // formのactionに指定するドメインを記載すること
        var allowedDomains = [
            "ticket.pia.jp"
        ];
        try {
            var u = new URL(action);
            if (u.search || u.hash) return false;
            if (!allowedDomains.includes(u.hostname)) return false;
            return true;
        } catch (e) {
            return false;
        }
    }, [
        action
    ]);
    var ref = (0,react.useState)(undefined), verified = ref[0], setVerified = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VERIFY_MUTATION), 1), verifyPartnerClientToken = ref1[0];
    return {
        state: {
            action: action,
            method: method,
            inputs: inputs,
            isValidAction: isValidAction,
            clientId: clientId,
            clientToken: clientToken,
            verified: verified
        },
        actions: {
            verifyToken: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var clientId, token, data, e;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                clientId = param.clientId, token = param.token;
                                if (clientId.length === 0 || token.length === 0) {
                                    setVerified(false);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    verifyPartnerClientToken({
                                        variables: {
                                            input: {
                                                clientId: clientId,
                                                token: token
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                data = _state.sent().data;
                                setVerified(data.verifyPartnerClientToken.valid);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                setVerified(false);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/HtmlFormRelay/index.tsx



/**
 * HtmlFormRelay Page
 *
 * ネイティブアプリがポストの本文にformタグを使われた場合に外部ブラウザでsubmit処理を発火させるための画面
 *
 * ネイティブアプリでは特定のドメインでないとPOST処理が行えず、かつドメインを許容するにはネイティブアプリのビルド・審査が必要になる。
 * かつ、遷移先の画面の処理が複雑な場合、アプリ内ブラウザでは挙動の保証ができないため、外部ブラウザで処理を行う。
 * ただし、ネイティブアプリから外部ブラウザにはPOSTでのアクセスができないため、POST = submit処理を自動で行うための画面が必要。
 */ var HtmlFormRelay = function() {
    var ref = HtmlFormRelay_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlFormRelayTemplate, {
        state: state,
        actions: actions
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Integrations/template/index.tsx















var IntegrationsTemplate = function(param) {
    var state = param.state, onConnectTwitter = param.onConnectTwitter, onDisConnectTwitter = param.onDisConnectTwitter;
    var t = (0,core_i18n/* useTranslation */.$G)("integrations").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.AccountSetting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Integrations
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                component: "nav",
                sx: {
                    bgcolor: "grey.50",
                    mb: 7
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkAccountCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    type: "twitter"
                }, state.integrations["twitter"]), {
                    onConnect: onConnectTwitter,
                    onDisConnect: onDisConnectTwitter
                }))
            })
        ]
    });
};
var LinkAccountCell = function(param) {
    var type = param.type, onConnect = param.onConnect, onDisConnect = param.onDisConnect, loading = param.loading, connected = param.connected, displayName = param.displayName, isBound = param.isBound;
    var t = (0,core_i18n/* useTranslation */.$G)("integrations").t;
    var ref = (0,react.useState)(false), connectOpen = ref[0], setConnectOpen = ref[1];
    var ref1 = (0,react.useState)(false), disConnectOpen = ref1[0], setDisConnectOpen = ref1[1];
    var ref2 = (0,react.useState)(false), loadingDisConnect = ref2[0], setLoadingDisConnect = ref2[1];
    var isWeb = native_app/* getPlatform */.Xf() === "web";
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var handleConnect = isWeb ? onConnect : function() {
        return setConnectOpen(true);
    };
    var handleDisConnect = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingDisConnect(true);
                        return [
                            4,
                            onDisConnect()
                        ];
                    case 1:
                        _state.sent();
                        setLoadingDisConnect(false);
                        setDisConnectOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDisConnect() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = connected ? function() {
        return setDisConnectOpen(true);
    } : handleConnect;
    var SNSIcon = function(type) {
        switch(type){
            case "twitter":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Twitter, {
                    fontSize: "medium",
                    color: connected ? undefined : "disabled"
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                component: Box_Box/* default */.Z,
                title: type,
                icon: SNSIcon(type),
                primaryTypographyProps: {
                    variant: "body1"
                },
                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle2",
                    children: displayName
                }),
                onClick: onClick,
                disabled: isBound || loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: connectOpen,
                onClose: function() {
                    return setConnectOpen(false);
                },
                title: t("connectDialogTitle", {
                    provider: type
                }),
                content: t("connectDialogContent", {
                    provider: type
                }),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    onClick: function() {
                        dist_esm/* Browser.open */.A.open({
                            url: "".concat(config_config/* config.domain */.v.domain).concat(routerPages.Integrations)
                        }).then(function() {
                            return setConnectOpen(false);
                        });
                    },
                    children: t("openBrowser")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: disConnectOpen,
                onClose: function() {
                    return setDisConnectOpen(false);
                },
                title: t("disConnectDialogTitle"),
                content: t("disConnectDialogContent", {
                    provider: type
                }),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    onClick: handleDisConnect,
                    loading: loadingDisConnect,
                    children: t("ok")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Integrations/index.tsx



var Integrations = function() {
    var ref = (0,viewModel/* useViewModel */.D)(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsTemplate, {
        state: state,
        onConnectTwitter: actions.connectTwitter,
        onDisConnectTwitter: actions.disConnectTwitter
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ItemComment/template/index.tsx











var ItemCommentTemplate = function(param) {
    var state = param.state, onDeleteComment = param.onDeleteComment, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onFetchMore = param.onFetchMore, onCreateItemComment = param.onCreateItemComment, onReplyToReply = param.onReplyToReply, onRemoveReplyToReply = param.onRemoveReplyToReply;
    var ref;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("itemComment").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)("0"), selectedFilter = ref2[0], setSelectedFilter = ref2[1];
    var replyFormRef = (0,react.useRef)(null);
    var handleOpenFilter = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleCloseFilter = (0,react.useCallback)(function(value) {
        setAnchorEl(null);
        setSelectedFilter(value);
    }, []);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ItemComment
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "replyForm",
                    props: {
                        onReply: function(values) {
                            return onCreateItemComment(values, state.artistId);
                        },
                        visibleImage: true,
                        userId: (ref3 = (ref = state.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "",
                        replyToDisplayName: state.replyToDisplayName,
                        onRemoveReplyToReply: onRemoveReplyToReply,
                        ref: replyFormRef
                    },
                    responsive: displayResponsive
                },
                header: (0,src_object_spread/* default */.Z)({
                    back: true,
                    title: t("title"),
                    /**
           * @description
           * Open when function is implemented in the future
           * https://app.clickup.com/t/908127/UT-4791
           */ right:  false && /*#__PURE__*/ 0
                }, displayResponsive ? {
                    responsive: true,
                    maxWidth: 1120
                } : {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: (0,src_object_spread/* default */.Z)({
                        py: 2
                    }, displayResponsive ? {
                        alignItems: "center"
                    } : {}),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                        type: "items",
                        typeId: state.itemId,
                        hiddenHeader: true,
                        showReaction: true,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        comments: state.comments,
                        user: state.user,
                        onDeleteComment: onDeleteComment,
                        onReportUser: onReportUser,
                        onBlockUser: onBlockUser,
                        onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                        onFetchMore: onFetchMore,
                        onReplyToReply: onReplyToReply,
                        onClickReply: function() {
                            var ref;
                            return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                        }
                    })
                })
            })
        ]
    });
};
var filterOptions = [
    {
        key: "createdOrder",
        value: "0"
    },
    {
        key: "likeOrder",
        value: "1"
    }, 
];

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ./src/core/comment/index.ts


/**
 * @description hook for store accountId and displayName
 */ var useReplyToComment = function() {
    var ref = (0,react.useState)({}), data = ref[0], setData = ref[1];
    var onReplyToReply = (0,react.useCallback)(function(params) {
        (0,react_dom.flushSync)(function() {
            setData({});
        });
        (0,react_dom.flushSync)(function() {
            setData({
                replyToAccountId: params.accountId,
                replyToDisplayName: params.displayName,
                replyToCommentId: params.commentId
            });
        });
    }, []);
    var onRemoveReplyToReply = (0,react.useCallback)(function() {
        setData({});
    }, []);
    return {
        data: data,
        onReplyToReply: onReplyToReply,
        onRemoveReplyToReply: onRemoveReplyToReply
    };
};

;// CONCATENATED MODULE: ./src/components/pages/ItemComment/viewModel.ts





function ItemComment_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemComment($itemId: ID!, $pageInput: PageInput) {\n    item(id: $itemId) {\n      id\n      issuedArtist {\n        id\n      }\n      commentCount\n      comments(pageInput: $pageInput) {\n        ...CommentsConnection\n      }\n    }\n    user {\n      id\n      email\n      displayName\n      accountId\n      formattedAccountId @client\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ItemComment_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemComment_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateItemComment($id: String!, $inputs: CommunityCommentInput!) {\n    createItemComment(id: $id, inputs: $inputs) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    ItemComment_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemComment_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteItemComment($id: String!, $commentId: String!) {\n    deleteItemComment(id: $id, commentId: $commentId) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    ItemComment_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemComment_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikeItemComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    likeItemComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    ItemComment_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemComment_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikeItemComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    unlikeItemComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    ItemComment_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var ItemComment_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showModal = (0,useLoginModal/* useLoginModal */.N)().showModal;
    var ref5 = useReplyToComment(), _data = ref5.data, replyToDisplayName = _data.replyToDisplayName, replyToAccountId = _data.replyToAccountId, replyToCommentId = _data.replyToCommentId, onReplyToReply = ref5.onReplyToReply, onRemoveReplyToReply = ref5.onRemoveReplyToReply;
    var ref6 = (0,useQuery/* useQuery */.aM)(ItemComment_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId
        }
    }), data = ref6.data, loading = ref6.loading, fetchMore = ref6.fetchMore, refetch = ref6.refetch;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_ITEM_COMMENT), 1), createItemComment = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_ITEM_COMMENT), 1), deleteItemComment = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_ITEM_COMMENT), 1), likeItemComment = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_ITEM_COMMENT), 1), unlikeItemComment = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref11[0];
    (0,react.useEffect)(function() {
        if (!user) {
            showModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    var ref12, ref13, ref14;
    return {
        state: {
            loading: loading,
            artistId: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref12 !== void 0 ? ref12 : "",
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref2 = data.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.comments) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.hasNextPage),
            comments: (ref13 = data === null || data === void 0 ? void 0 : (ref4 = data.item) === null || ref4 === void 0 ? void 0 : ref4.comments) !== null && ref13 !== void 0 ? ref13 : null,
            user: (ref14 = data === null || data === void 0 ? void 0 : data.user) !== null && ref14 !== void 0 ? ref14 : null,
            itemId: router.query.itemId,
            replyToDisplayName: replyToDisplayName
        },
        actions: {
            onDeleteComment: function onDeleteComment(commentId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteItemComment({
                                        variables: {
                                            id: router.query.itemId,
                                            commentId: commentId
                                        }
                                    }).then(function() {
                                        var ref, ref1;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_deleteComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                                            name: "itemDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeOrUnlikeComment: function onLikeOrUnlikeComment(param) {
                var commentId = param.commentId, isLike = param.isLike, id = param.id, likeCount = param.likeCount;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikeItemComment({
                                        variables: {
                                            inputs: {
                                                commentId: commentId,
                                                id: id !== null && id !== void 0 ? id : router.query.itemId
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                unlikeItemComment: {
                                                    __typename: "Comment",
                                                    id: commentId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        var ref, ref1;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_unlikeComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                                            name: "itemDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likeItemComment({
                                        variables: {
                                            inputs: {
                                                commentId: commentId,
                                                id: id !== null && id !== void 0 ? id : router.query.itemId
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                likeItemComment: {
                                                    __typename: "Comment",
                                                    id: commentId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        var ref, ref1;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_likeComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                                            name: "itemDetail"
                                        });
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReplyToReply: onReplyToReply,
            onRemoveReplyToReply: onRemoveReplyToReply,
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            itemId: router.query.itemId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.email) !== null && ref1 !== void 0 ? ref1 : "",
                                        contentType: "item-comments",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        itemId: router.query.itemId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCreateItemComment: function onCreateItemComment(inputs, artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createItemComment({
                                        variables: {
                                            id: router.query.itemId,
                                            inputs: (0,src_object_spread/* default */.Z)({
                                                artistId: artistId,
                                                replyToAccountId: replyToAccountId,
                                                replyToId: replyToCommentId
                                            }, inputs)
                                        }
                                    }).then(function() {
                                        var ref, ref1;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
                                            name: "itemDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                onRemoveReplyToReply();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ItemComment_viewModel_QUERY = (0,lib/* gql */.Ps)(ItemComment_viewModel_templateObject(), utoniq_core_schema/* CommentsConnectionFragmentDoc */.M6M);
var CREATE_ITEM_COMMENT = (0,lib/* gql */.Ps)(ItemComment_viewModel_templateObject1(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var DELETE_ITEM_COMMENT = (0,lib/* gql */.Ps)(ItemComment_viewModel_templateObject2(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var LIKE_ITEM_COMMENT = (0,lib/* gql */.Ps)(ItemComment_viewModel_templateObject3());
var UNLIKE_ITEM_COMMENT = (0,lib/* gql */.Ps)(ItemComment_viewModel_templateObject4());

;// CONCATENATED MODULE: ./src/components/pages/ItemComment/index.tsx




/**
 * ItemComment Page
 * Implemented as a practical sample.
 */ var ItemComment = function() {
    var ref = ItemComment_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCommentTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ItemInformation/template/index.tsx

















var ItemInformationTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("item")).onClick;
    var _serials, _user, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
            pb: styles/* styles.safeAreaBottom */.W2.safeAreaBottom,
            overflowY: "scroll"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: [
                    !state.userId ? routerNames.OwnedItemInformation : routerNames.UserItemInformation,
                    (ref = state.item) === null || ref === void 0 ? void 0 : ref.title,
                    (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.displayName, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                title: t("title"),
                back: true,
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                    edge: "end",
                    color: "primary.main",
                    onClick: onClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    width: "100%",
                    maxWidth: 600,
                    margin: "0 auto",
                    pt: "56px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pt: 3,
                            px: 5
                        },
                        children: state.loading || !state.item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescriptionSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                                item: state.item,
                                number: state.number,
                                user: state.user
                            })
                        })
                    }),
                    !!((ref2 = state.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.note) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            my: 4,
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                        fontSize: "small",
                                        sx: {
                                            color: "grey.600"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        color: "text.secondary",
                                        children: t("ticketNote")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: (ref5 = state.item) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ticket) === null || ref7 === void 0 ? void 0 : ref7.note
                            })
                        ]
                    }),
                    !state.loading && !!state.item && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SerialOwnersCell, {
                        serials: (_serials = state.serials) !== null && _serials !== void 0 ? _serials : null,
                        user: (_user = state.user) !== null && _user !== void 0 ? _user : null,
                        itemSerials: (ref10 = (ref8 = state.item) === null || ref8 === void 0 ? void 0 : ref8.serials) !== null && ref10 !== void 0 ? ref10 : null,
                        onFetchMore: onFetchMore,
                        hasNextPage: state.hasNextPage,
                        loading: state.loading || state.fetching,
                        hideSalesNumber: !!((ref9 = state.item) === null || ref9 === void 0 ? void 0 : ref9.hideSalesNumber)
                    })
                ]
            })
        ]
    });
};
var template_SerialOwnersCell = function(param) {
    var showSku = param.showSku, loading = param.loading, hasNextPage = param.hasNextPage, user = param.user, serials = param.serials, itemSerials = param.itemSerials, onFetchMore = param.onFetchMore, hideSalesNumber = param.hideSalesNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("itemInformation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var serialSorted = (0,react.useMemo)(function() {
        if (!serials || !serials.length) {
            return [];
        }
        var ref;
        return sortBy_default()(serials, function(param) {
            var formattedSerialNumber = param.formattedSerialNumber;
            return parseInt((ref = formattedSerialNumber === null || formattedSerialNumber === void 0 ? void 0 : formattedSerialNumber.replace("#", "")) !== null && ref !== void 0 ? ref : "0");
        });
    }, [
        serials
    ]);
    var concatSerial = (0,react.useMemo)(function() {
        // 所持シリアル以外のシリアルについて、SKUがある場合skuIdが一致するの以外を除外する
        var edges = ((itemSerials === null || itemSerials === void 0 ? void 0 : itemSerials.edges) || []).filter(function(param) {
            var node = param.node;
            if (!router.query.skuId || !node || !node.sku) return true;
            return node.sku.id === decodeSkuId(router.query.skuId);
        });
        return (0,src_to_consumable_array/* default */.Z)(serialSorted).concat((0,src_to_consumable_array/* default */.Z)(edges));
    }, [
        serialSorted,
        itemSerials === null || itemSerials === void 0 ? void 0 : itemSerials.edges
    ]);
    if (!!hideSalesNumber && (!(serials === null || serials === void 0 ? void 0 : serials.length) || // O-MENZのアプリは、シリアル非表示設定であっても、自分のアイテムのシリアル番号は分かるにする UT-11803
    config_config/* config.applicationKey */.v.applicationKey !== "omenz")) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.secondary",
                sx: {
                    py: 2,
                    px: 5
                },
                children: t("ownerList")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        "aria-label": "serial-number-table",
                        sx: {
                            width: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: "none",
                                                minWidth: 84,
                                                py: 2,
                                                px: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: t("serialNumber")
                                            })
                                        }),
                                        showSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                minWidth: 100,
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("sku")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                minWidth: 100,
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("acquisitionDate")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            width: "100%",
                                            align: "left",
                                            sx: {
                                                border: "none",
                                                py: 2,
                                                px: 3
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.hint",
                                                children: t("owner")
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* TableScrollFetcher */.Z, {
                                loading: loading,
                                hasNextPage: hasNextPage,
                                onFetchMore: onFetchMore,
                                component: TableRow/* default */.Z,
                                colSpan: 3,
                                nodes: concatSerial === null || concatSerial === void 0 ? void 0 : concatSerial.map(function(serial) {
                                    var ref, ref1, ref2, ref3, ref4, ref5;
                                    if (!template_isUserItemSerial(serial) && serialSorted.find(function(o) {
                                        return o.formattedSerialNumber === serial.node.formattedSerialNumber;
                                    })) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            padding: "none",
                                            sx: {
                                                border: "none"
                                            }
                                        });
                                    }
                                    var serialUser = template_isUserItemSerial(serial) ? user : serial.node.user;
                                    var isNft = template_isUserItemSerial(serial) ? !!serial.isNft : !!serial.node.isNft;
                                    var ref6;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    pl: 5,
                                                    pr: 0,
                                                    border: "none",
                                                    bgcolor: template_isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    sx: {
                                                        pr: 2
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SerialNumber, {
                                                            label: template_isUserItemSerial(serial) ? serial.formattedSerialNumber : serial.node.formattedSerialNumber
                                                        }),
                                                        isNft && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                                                            fontSize: "small",
                                                            filledColor: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            showSku && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0,
                                                    border: "none",
                                                    bgcolor: template_isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                            orientation: "vertical",
                                                            flexItem: true,
                                                            sx: {
                                                                height: 20
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle2",
                                                            children: template_isUserItemSerial(serial) ? (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : ref1.unitName : (ref2 = serial.node.sku) === null || ref2 === void 0 ? void 0 : ref2.unitName
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    px: 0,
                                                    border: "none",
                                                    bgcolor: template_isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                            orientation: "vertical",
                                                            flexItem: true,
                                                            sx: {
                                                                height: 20
                                                            }
                                                        }),
                                                        serialUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            children: template_isUserItemSerial(serial) ? serial.formattedObtainedDate : (ref3 = serial.node) === null || ref3 === void 0 ? void 0 : ref3.formattedObtainedDate
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                padding: "none",
                                                sx: {
                                                    py: 2,
                                                    pl: 0,
                                                    pr: 5,
                                                    border: "none",
                                                    bgcolor: template_isUserItemSerial(serial) ? "grey.50" : "unset"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                                orientation: "vertical",
                                                                flexItem: true,
                                                                sx: {
                                                                    height: 20
                                                                }
                                                            })
                                                        }),
                                                        serialUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                            component: Link/* default */.Z,
                                                            underline: "none",
                                                            href: generatePath(routerPages.UserProfile, {
                                                                userId: serialUser.id
                                                            }),
                                                            direction: "row",
                                                            alignItems: "center",
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                    src: (ref6 = (ref4 = serialUser.avatar) === null || ref4 === void 0 ? void 0 : ref4.smallUri) !== null && ref6 !== void 0 ? ref6 : "",
                                                                    sx: {
                                                                        width: 28,
                                                                        height: 28
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                    variant: "overline",
                                                                    children: template_isUserItemSerial(serial) ? user === null || user === void 0 ? void 0 : user.displayName : (ref5 = serial.node.user) === null || ref5 === void 0 ? void 0 : ref5.displayName
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }),
                                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        padding: "none",
                                        colSpan: showSku ? 4 : 3,
                                        sx: {
                                            border: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            spacing: 3,
                                            sx: {
                                                px: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large",
                                                numberOfLine: 8,
                                                lastWidth: "100%"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
function template_isUserItemSerial(serial) {
    return "serialId" in serial;
}

;// CONCATENATED MODULE: ./src/components/pages/ItemInformation/viewModel.ts



function ItemInformation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemInformation(\n    $id: ID!\n    $userId: ID\n    $pageInput: PageInput\n    $skuId: String\n  ) {\n    item(id: $id) {\n      ...ItemDescription\n      serials(pageInput: $pageInput) {\n        ...SerialItemOwners\n      }\n      itemObtainedCount\n    }\n    user(id: $userId) {\n      ...UserInfo\n    }\n    #use alias for get user logged in\n    userLoggedIn: user {\n      id\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ItemInformation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemInformation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PortfolioDetail($id: ID!, $userId: String, $skuId: String) {\n    portfolio(id: $id, userId: $userId) {\n      ...PortfolioConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ItemInformation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ItemInformation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _query = router.query, itemId = _query.itemId, userId = _query.userId;
    var _skuId;
    var skuId = decodeSkuId((_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : "");
    var ref6 = (0,useQuery/* useQuery */.aM)(ItemInformation_viewModel_QUERY, {
        variables: {
            id: itemId,
            userId: userId
        }
    }), data = ref6.data, fetchMore = ref6.fetchMore, networkStatus = ref6.networkStatus;
    var ref7 = (0,useQuery/* useQuery */.aM)(viewModel_PORTFOLIO, {
        variables: {
            id: itemId,
            userId: userId
        }
    }), portfolio = ref7.data;
    // シリアル一覧。skuIdが指定されている場合は、そのskuIdのシリアルのみを表示する。
    var serials = portfolio === null || portfolio === void 0 ? void 0 : (ref = portfolio.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
        var serial = param.serial;
        var ref;
        if (!skuId) return true;
        return (serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.id) === skuId;
    });
    var ref8, ref9;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            userId: userId,
            user: (ref8 = data === null || data === void 0 ? void 0 : data.user) !== null && ref8 !== void 0 ? ref8 : null,
            number: (ref9 = (ref2 = convertPortfolioItemToSku(portfolio === null || portfolio === void 0 ? void 0 : portfolio.portfolio, router.query.skuId)) === null || ref2 === void 0 ? void 0 : ref2.number) !== null && ref9 !== void 0 ? ref9 : 0,
            serials: serials !== null && serials !== void 0 ? serials : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.serials) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pageInfo) === null || ref5 === void 0 ? void 0 : ref5.hasNextPage),
            item: setItemSku(data === null || data === void 0 ? void 0 : data.item, skuId)
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            id: itemId,
                                            userId: userId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ItemInformation_viewModel_QUERY = (0,lib/* gql */.Ps)(ItemInformation_viewModel_templateObject(), utoniq_core_schema/* ItemDescriptionFragmentDoc */.A1h, utoniq_core_schema/* SerialItemOwnersFragmentDoc */.o7b, utoniq_core_schema/* UserInfoFragmentDoc */.IWz);
var viewModel_PORTFOLIO = (0,lib/* gql */.Ps)(ItemInformation_viewModel_templateObject1(), utoniq_core_schema/* PortfolioConnectionFragmentDoc */.umN);

;// CONCATENATED MODULE: ./src/components/pages/ItemInformation/index.tsx




var ItemInformation = function() {
    var ref = ItemInformation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemInformationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/isArray.js
var isArray = __webpack_require__(86152);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
;// CONCATENATED MODULE: ./src/components/organisms/mission/ItemsMissionBox/index.tsx











var ItemsMissionBox = function(param) {
    var missionId = param.missionId, label = param.label, number = param.number, item = param.item, formattedExpiredAt = param.formattedExpiredAt, onSubmitAnswerItem = param.onSubmitAnswerItem;
    var t = (0,core_i18n/* useTranslation */.$G)("itemMissions").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(0), requiredCount = ref1[0], setRequiredCount = ref1[1];
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var items = (0,react.useMemo)(function() {
        return isArray_default()(item) ? item : [
            item
        ];
    }, [
        item
    ]);
    var handleSubmitAnswerItem = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    setRequiredCount(0);
                    return [
                        4,
                        onSubmitAnswerItem(missionId).then(function(requiredCount) {
                            if (requiredCount) {
                                setRequiredCount(requiredCount);
                                setOpen(true);
                            }
                        }).catch(showError)
                    ];
                case 1:
                    _state.sent();
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        missionId,
        onSubmitAnswerItem,
        showError
    ]);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            mt: 3,
            position: "relative",
            overflow: "visible"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionLabel, {
                label: label,
                sx: {
                    position: "absolute",
                    top: -10,
                    left: 20,
                    zIndex: 1,
                    width: 72,
                    height: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                component: Stack_Stack/* default */.Z,
                flex: 1,
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: items.map(function(param) {
                            var missionItem = param.item, requiredCount = param.requiredCount;
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        src: (ref3 = (ref = missionItem.thumbnail.front) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : "",
                                        size: "x-small"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        justifyContent: "space-between",
                                        sx: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        flex: 1,
                                                        sx: {
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "subtitle1",
                                                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                                children: missionItem.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                                direction: "row",
                                                                spacing: 1,
                                                                children: [
                                                                    ((ref1 = missionItem.rarityIconImage) === null || ref1 === void 0 ? void 0 : ref1.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                        variant: "square",
                                                                        src: missionItem.rarityIconImage.smallUri,
                                                                        sx: {
                                                                            height: 12,
                                                                            width: 12
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                        variant: "overline",
                                                                        children: ((ref2 = missionItem.rarity) === null || ref2 === void 0 ? void 0 : ref2.name) ? t(missionItem.rarity.name) : "-"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        spacing: 1,
                                                        alignItems: "flex-end",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                                                variant: "h1",
                                                                children: requiredCount
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "subtitle1",
                                                                children: t("sheet")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "text.secondary",
                                                        children: t("reward")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: t("gachaTicket", {
                                                            number: number
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, missionItem.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 5
                        },
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                sx: {
                                    width: 244
                                },
                                loading: loading,
                                onClick: handleSubmitAnswerItem,
                                disabled: label === utoniq_core_schema/* MissionLabel.Clear */.lH5.Clear || label === utoniq_core_schema/* MissionLabel.Expired */.lH5.Expired,
                                children: t("toEarn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: t("expirationDate")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("expiration", {
                                            date: formattedExpiredAt
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("noItemConfirmTitle"),
                content: t("noItemConfirmDesc", {
                    number: requiredCount
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: t("ok")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ItemMissions/template/index.tsx







var ItemMissionsTemplate = function(param) {
    var state = param.state, onSubmitAnswerItem = param.onSubmitAnswerItem;
    var t = (0,core_i18n/* useTranslation */.$G)("itemMissions").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ItemMissions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 2
                        },
                        children: t("desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsMissionBoxListCell, {
                        relatedMissions: state.relatedMissions,
                        onSubmitAnswerItem: onSubmitAnswerItem
                    })
                ]
            })
        ]
    });
};
var ItemMissions_template_ref, ItemMissions_template_ref1;
var ItemsMissionBoxListCell = function(param) {
    var relatedMissions = param.relatedMissions, onSubmitAnswerItem = param.onSubmitAnswerItem;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 7,
            children: relatedMissions === null || relatedMissions === void 0 ? void 0 : relatedMissions.map(function(param) {
                var id = param.id, reward = param.reward, content = param.content, label = param.label, formattedExpiredAt = param.formattedExpiredAt;
                var ref2;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemsMissionBox, {
                    missionId: id,
                    item: (ItemMissions_template_ref = content === null || content === void 0 ? void 0 : content.items) !== null && ItemMissions_template_ref !== void 0 ? ItemMissions_template_ref : [],
                    label: label !== null && label !== void 0 ? label : null,
                    formattedExpiredAt: formattedExpiredAt !== null && formattedExpiredAt !== void 0 ? formattedExpiredAt : "",
                    number: (ItemMissions_template_ref1 = (ref2 = reward.gachaTicket) === null || ref2 === void 0 ? void 0 : ref2.count) !== null && ItemMissions_template_ref1 !== void 0 ? ItemMissions_template_ref1 : 0,
                    onSubmitAnswerItem: onSubmitAnswerItem
                }, id);
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(4889);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
;// CONCATENATED MODULE: ./src/components/pages/ItemMissions/viewModel.ts




function ItemMissions_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemMissions($itemId: ID!) {\n    item(id: $itemId) {\n      id\n      relatedMissions {\n        ...RelatedMissionDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ItemMissions_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ItemMissions_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(ItemMissions_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId
        }
    }).data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* AnswerItemCollectMission */.AWP, {
        onCompleted: function onCompleted(data) {
            if (!(data === null || data === void 0 ? void 0 : data.answerItemCollectMission.correct)) {
                return;
            }
            return router.push(generatePath(routerPages.MissionAccomplished, {
                missionId: data.answerItemCollectMission.missionId
            }));
        }
    }), 1), answerItemCollectMission = ref2[0];
    var ref3;
    return {
        state: {
            relatedMissions: (ref3 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.relatedMissions) !== null && ref3 !== void 0 ? ref3 : null
        },
        actions: {
            onSubmitAnswerItem: function onSubmitAnswerItem(missionId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, data, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    answerItemCollectMission({
                                        variables: {
                                            missionId: missionId
                                        }
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                return [
                                    2,
                                    (ref2 = sumBy_default()((ref1 = data === null || data === void 0 ? void 0 : (ref = data.answerItemCollectMission) === null || ref === void 0 ? void 0 : ref.lackItems) !== null && ref1 !== void 0 ? ref1 : [], "requiredCount")) !== null && ref2 !== void 0 ? ref2 : 0
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ItemMissions_viewModel_QUERY = (0,lib/* gql */.Ps)(ItemMissions_viewModel_templateObject(), utoniq_core_schema/* RelatedMissionDetailFragmentDoc */.DhZ);

;// CONCATENATED MODULE: ./src/components/pages/ItemMissions/index.tsx




/**
 * ItemMissions Page
 * Implemented as a practical sample.
 */ var ItemMissions = function() {
    var ref = ItemMissions_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMissionsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ItemOrders/template/index.tsx









var ItemOrdersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("itemOrders").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var ref1;
    //state.itemOrdersのserialsを一つずつ取り出して新しいitemOrdersを作成
    var expandedItemOrders = (0,react.useMemo)(function() {
        var ref, ref2;
        return (ref1 = (ref = state.itemOrders) === null || ref === void 0 ? void 0 : (ref2 = ref.edges) === null || ref2 === void 0 ? void 0 : ref2.filter(function(edge) {
            return edge === null || edge === void 0 ? void 0 : edge.node;
        }).flatMap(function(edge) {
            var _serials;
            // 重複を削除したserials配列を作成
            var uniqueSerials = ((_serials = edge.node.serials) !== null && _serials !== void 0 ? _serials : []).filter(function(serial, index, self) {
                return index === self.findIndex(function(s) {
                    return s.skuId === serial.skuId;
                });
            });
            // 重複を削除したserialsから新しいitemOrdersを作成
            return uniqueSerials.map(function(serial) {
                return {
                    id: edge.node.id,
                    formattedCreatedAt: edge.node.formattedCreatedAt,
                    price: edge.node.price,
                    item: edge.node.item,
                    serial: serial
                };
            });
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        state.itemOrders
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            defaultBackPage: routerPages.Management,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ItemOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: expandedItemOrders.map(function(item) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemOrdersListBox, {
                        item: item
                    }, "".concat(item.id, "-").concat((ref = item.serial) === null || ref === void 0 ? void 0 : ref.id));
                }),
                onFetchMore: onFetchMore,
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                componentProps: {
                    spacing: 5
                },
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemListBoxSkeleton, {
                    fullWidth: true
                }),
                emptyMessage: t("noItem")
            })
        ]
    });
};
var ItemOrdersListBox = function(param) {
    var _item = param.item, item = _item.item, formattedCreatedAt = _item.formattedCreatedAt, serial = _item.serial;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, routerPages = ref6.routerPages, generatePath = ref6.generatePath;
    var ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            mt: 2,
            borderRadius: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            flexDirection: "row",
            alignItems: "stretch",
            sx: {
                p: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flex: 1,
                        p: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: item === null || item === void 0 ? void 0 : item.title
                                }),
                                !!(serial === null || serial === void 0 ? void 0 : (ref = serial.sku) === null || ref === void 0 ? void 0 : ref.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: serial === null || serial === void 0 ? void 0 : (ref1 = serial.sku) === null || ref1 === void 0 ? void 0 : ref1.unitName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: formattedCreatedAt
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                    onClick: function() {
                        var ref;
                        router.push({
                            pathname: generatePath(routerPages.OwnedItemDetail, {
                                itemId: (ref = item === null || item === void 0 ? void 0 : item.id) !== null && ref !== void 0 ? ref : "#"
                            }),
                            search: (serial === null || serial === void 0 ? void 0 : serial.skuId) ? "?skuId=".concat(encodeSkuId(serial.skuId)) : ""
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "small",
                        src: (ref8 = (ref7 = serial === null || serial === void 0 ? void 0 : (ref2 = serial.sku) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.smallUri) !== null && ref7 !== void 0 ? ref7 : item === null || item === void 0 ? void 0 : (ref4 = item.thumbnail) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.front) === null || ref5 === void 0 ? void 0 : ref5.smallUri) !== null && ref8 !== void 0 ? ref8 : ""
                    })
                })
            ]
        })
    });
};
var ItemListBoxSkeleton = function(param) {
    var fullWidth = param.fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        sx: {
            py: 2
        },
        children: [
            1,
            2,
            3,
            4,
            5
        ].map(function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    width: fullWidth ? "100%" : 335,
                    height: 136,
                    borderRadius: 2,
                    mb: 5
                }
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ItemOrders/viewModel.ts



function ItemOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemOrders($pageInput: PageInputDate) {\n    userItemOrders(pageInput: $pageInput) {\n      ...ItemOrdersConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ItemOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ItemOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,useQuery/* useQuery */.aM)(ItemOrders_viewModel_QUERY, {
        variables: {
            pageInput: {
                limit: 30
            }
        }
    }), data = ref2.data, loading = ref2.loading, fetchMore = ref2.fetchMore;
    var pageInfo = data === null || data === void 0 ? void 0 : (ref = data.userItemOrders) === null || ref === void 0 ? void 0 : ref.pageInfo;
    var fetchMorePosts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!(pageInfo && pageInfo.hasNextPage)) return [
                    2
                ];
                fetchMore({
                    variables: {
                        pageInput: {
                            cursor: pageInfo.endCursor || null
                        }
                    }
                });
                return [
                    2
                ];
            });
        });
        return function fetchMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3;
    return {
        state: {
            itemOrders: (ref3 = data === null || data === void 0 ? void 0 : data.userItemOrders) !== null && ref3 !== void 0 ? ref3 : null,
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.userItemOrders) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: fetchMorePosts
        }
    };
});
var ItemOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(ItemOrders_viewModel_templateObject(), utoniq_core_schema/* ItemOrdersConnectionFragmentDoc */.lWT);

;// CONCATENATED MODULE: ./src/components/pages/ItemOrders/index.tsx



var ItemOrders = function() {
    var ref = ItemOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemOrdersTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LanguageSetting/template/index.tsx






var LanguageSettingTemplate = function(param) {
    var state = param.state, onChangeLanguage = param.onChangeLanguage;
    var t = (0,core_i18n/* useTranslation */.$G)("languageSetting").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LanguageSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.Setting,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelectCell, {
                    language: state.language,
                    onChangeLanguage: onChangeLanguage
                })
            })
        ]
    });
};
var LanguageSelectCell = function(param) {
    var language = param.language, onChangeLanguage = param.onChangeLanguage;
    var t = (0,core_i18n/* useTranslation */.$G)("languageSetting").t;
    var languages = [
        /**
     * @description
     * Open when function is implemented in the future
     */ // {
        //   value: 'de',
        //   label: t('deLabel'),
        // },
        // {
        //   value: 'en-GB',
        //   label: t('enGBLabel'),
        // },
        {
            value: "en-US",
            label: t("enUSLabel")
        },
        // {
        //   value: 'es-ES',
        //   label: t('esESLabel'),
        // },
        // {
        //   value: 'es',
        //   label: t('esLabel'),
        // },
        // {
        //   value: 'fr-FR',
        //   label: t('frFRLabel'),
        // },
        // {
        //   value: 'it-IT',
        //   label: t('itITLabel'),
        // },
        // {
        //   value: 'pt-BR',
        //   label: t('ptBRLabel'),
        // },
        // {
        //   value: 'ru-RU',
        //   label: t('ruRULabel'),
        // },
        {
            value: "ja-JP",
            label: t("jaJPLabel")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
            value: language,
            onChange: function(event) {
                return onChangeLanguage(event.target.value);
            },
            children: languages.map(function(param) {
                var label = param.label, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    value: value,
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                    label: label
                }, value);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LanguageSetting/viewModel.ts








var LanguageSetting_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var i18n = (0,core_i18n/* useTranslation */.$G)().i18n;
    //設定されている言語を取得
    var currentLang = (0,core_i18n/* getLongLanguageCode */.FM)(i18n.language);
    var ref = (0,react.useState)(currentLang), language = ref[0], setLanguage = ref[1];
    (0,react.useEffect)(function() {
        (0,storage/* getAppLanguage */.s)().then(function(value) {
            setLanguage(value !== null && value !== void 0 ? value : currentLang);
        });
    }, []);
    return {
        state: {
            language: language
        },
        actions: {
            onChangeLanguage: function onChangeLanguage(lang) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, shortLangCode;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setLanguage(lang);
                                ref = (0,_sliced_to_array/* default */.Z)(lang.split("-"), 1), shortLangCode = ref[0];
                                return [
                                    4,
                                    (0,storage/* setAppLanguage */.$M)(lang)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    i18n.changeLanguage(shortLangCode)
                                ];
                            case 2:
                                _state.sent();
                                // dayJSの言語情報を設定
                                dayjs_min_default().locale(shortLangCode);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/LanguageSetting/index.tsx




/**
 * LanguageSetting Page
 * Implemented as a practical sample.
 */ var LanguageSetting = function() {
    var ref = LanguageSetting_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSettingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetail/template/index.tsx















var LotteryApplicationDetailTemplate = function(param) {
    var state = param.state, onCancelLaffleApplication = param.onCancelLaffleApplication;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var ref18 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref18.routerNames, routerPages = ref18.routerPages;
    var ref19 = (0,react.useState)(false), modalOpen = ref19[0], setModalOpen = ref19[1];
    var handleOpenCancelModal = function() {
        return setModalOpen(true);
    };
    /** コンビニ支払いかどうか */ var isKonbini = (0,react.useMemo)(function() {
        var ref;
        return ((ref = state.preSaleLotteryApplicant) === null || ref === void 0 ? void 0 : ref.paymentMethod) === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini;
    }, [
        (ref = state.preSaleLotteryApplicant) === null || ref === void 0 ? void 0 : ref.paymentMethod
    ]);
    /** 当選したアイテム */ var winChoicedItem = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        return ((ref = state.preSaleLotteryApplicant) === null || ref === void 0 ? void 0 : ref.winChoiceNumber) ? (ref1 = state.preSaleLotteryApplicant) === null || ref1 === void 0 ? void 0 : (ref3 = ref1.choiceItemDetails) === null || ref3 === void 0 ? void 0 : ref3[((ref2 = state.preSaleLotteryApplicant) === null || ref2 === void 0 ? void 0 : ref2.winChoiceNumber) - 1] : null;
    }, [
        (ref1 = state.preSaleLotteryApplicant) === null || ref1 === void 0 ? void 0 : ref1.winChoiceNumber,
        (ref2 = state.preSaleLotteryApplicant) === null || ref2 === void 0 ? void 0 : ref2.choiceItemDetails, 
    ]);
    /** コンビニ未払いの場合の決済導線 */ var renderBottomItem = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        if (!(isKonbini && ((ref = state.preSaleLotteryApplicant) === null || ref === void 0 ? void 0 : ref.status) === "20_waiting_payment")) {
            return null;
        }
        var ref7, ref8;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationDetail_template_FixedBottomCell, {
            expiredAt: (ref7 = (ref1 = state.preSaleLotteryApplicant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cartTransactionOrder) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pendingPurchaseItem) === null || ref3 === void 0 ? void 0 : ref3.formattedExpiredAt) !== null && ref7 !== void 0 ? ref7 : "",
            voucherUrl: (ref8 = (ref4 = state.preSaleLotteryApplicant) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cartTransactionOrder) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pendingPurchaseItem) === null || ref6 === void 0 ? void 0 : ref6.voucherUrl) !== null && ref8 !== void 0 ? ref8 : ""
        });
    }, [
        (ref3 = state.preSaleLotteryApplicant) === null || ref3 === void 0 ? void 0 : ref3.cartTransactionOrder,
        isKonbini
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.LotteryApplications
        },
        customNavigation: renderBottomItem(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryApplicationDetail
            }),
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationDetail_template_LoadingCell, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_StatusCell, {
                        isKonbini: isKonbini,
                        status: (ref4 = state.preSaleLotteryApplicant) === null || ref4 === void 0 ? void 0 : ref4.status,
                        isPaymentError: !!((ref5 = state.preSaleLotteryApplicant) === null || ref5 === void 0 ? void 0 : ref5.isPaymentError),
                        paymentDeadline: (ref6 = state.preSaleLotteryApplicant) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.preSale) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.lottery) === null || ref8 === void 0 ? void 0 : ref8.purchasableEndedAt,
                        preSaleId: (ref9 = state.preSaleLotteryApplicant) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.preSale) === null || ref10 === void 0 ? void 0 : ref10.id,
                        winChoiceNumber: (ref11 = state.preSaleLotteryApplicant) === null || ref11 === void 0 ? void 0 : ref11.winChoiceNumber,
                        winChoicedItem: winChoicedItem
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailCell, {
                        preSaleLotteryApplicant: state.preSaleLotteryApplicant,
                        paymentSource: state.paymentSource,
                        eventTitle: (ref12 = state.preSaleLotteryApplicant) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.preSale) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.event) === null || ref14 === void 0 ? void 0 : ref14.title,
                        onCancel: handleOpenCancelModal,
                        preSaleId: (ref15 = state.preSaleLotteryApplicant) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.preSale) === null || ref16 === void 0 ? void 0 : ref16.id,
                        winChoicedItem: winChoicedItem,
                        isKonbini: isKonbini
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: modalOpen,
                onClose: function() {
                    return setModalOpen(false);
                },
                title: t("cancelModalTitle"),
                content: t("cancelModalDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        onCancelLaffleApplication().then(function() {
                            return setModalOpen(false);
                        });
                    },
                    loading: state.submittingCancel,
                    disabled: ((ref17 = state.preSaleLotteryApplicant) === null || ref17 === void 0 ? void 0 : ref17.status) !== "30_waiting_lottery",
                    children: t("cancelModalButton")
                }),
                cancelText: t("cancelModalClose")
            })
        ]
    });
};
var LotteryApplicationDetail_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 7,
            px: 5,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h6",
                    width: "60%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 2,
                                lastWidth: "25%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            numberOfLine: 5
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 6
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 6
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var template_StatusCell = function(param) {
    var status = param.status, isKonbini = param.isKonbini, paymentDeadline = param.paymentDeadline, isPaymentError = param.isPaymentError, preSaleId = param.preSaleId, winChoiceNumber = param.winChoiceNumber, winChoicedItem = param.winChoicedItem;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    /**
   * 当選時、ボタンを押した時の処理
   * 支払い済み→アイテム詳細へ
   * 支払い待ち
   *   →クレカ(失敗)なら決済ページへ
   *   →コンビニなら非表示
   */ var handleClickWinButton = (0,react.useCallback)(function() {
        if (!winChoicedItem) return;
        if (status === "20_waiting_payment" && isKonbini) return;
        // クレカ失敗なら決済ページへ
        if (status === "20_waiting_payment" && !isKonbini) {
            return router.push(generatePath(routerPages.LotteryApplicationDetailPaymentConfirmation, {
                preSaleId: preSaleId !== null && preSaleId !== void 0 ? preSaleId : "#"
            }));
        }
        // 支払い済みの場合、アイテム詳細へ
        var itemId = winChoicedItem.itemId, skuId = winChoicedItem.skuId;
        return router.push({
            pathname: generatePath(routerPages.OwnedItemDetail, {
                itemId: itemId
            }),
            search: skuId ? "?skuId=".concat(encodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "")) : ""
        });
    }, [
        status,
        winChoiceNumber,
        winChoicedItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 7,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 3,
                alignItems: "center",
                children: [
                    status === "50_invalid" || status === "20_waiting_payment" && !isKonbini || status === "60_canceled" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                        sx: {
                            color: status === "60_canceled" ? "primary.main" : "error.main"
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                        sx: {
                            color: "primary.main"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: isKonbini ? t("konbini_".concat(status, "_title")) : t("".concat(status, "_title"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.secondary",
                    align: "center",
                    children: isKonbini ? t("konbini_".concat(status, "_desc")) : t("".concat(status, "_desc"))
                })
            }),
            status === "20_waiting_payment" && (isPaymentError || isKonbini) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    borderColor: "error.main",
                    borderWidth: 1,
                    borderStyle: "solid",
                    py: 2,
                    mt: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "error.main",
                    align: "center",
                    children: t("paymentDeadline", {
                        date: values_Date/* DateTime.format */.o.format(paymentDeadline)
                    })
                })
            }),
            (isKonbini && status === "11_win_paid" || !isKonbini && [
                "11_win_paid",
                "20_waiting_payment"
            ].includes("".concat(status))) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            py: 2,
                            px: 4,
                            width: 244
                        },
                        onClick: handleClickWinButton,
                        children: t("".concat(status, "_button"))
                    })
                })
            })
        ]
    });
};
var DetailCell = function(param) {
    var preSaleLotteryApplicant = param.preSaleLotteryApplicant, paymentSource = param.paymentSource, onCancel = param.onCancel, winChoicedItem = param.winChoicedItem, preSaleId = param.preSaleId, eventTitle = param.eventTitle, isKonbini = param.isKonbini;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    /**
   * ボタンを表示する条件
   * - 支払い済み、もしくは抽選待ちの場合に表示する
   * - クレカ支払いの場合は、エラー時の支払い待ちの状態に表示する
   * - マチゼロの場合は、キャンセルできない
   */ var isShowButton = (0,react.useMemo)(function() {
        if (!preSaleLotteryApplicant) return false;
        if (isKonbini) {
            return (config_config/* config.applicationKey */.v.applicationKey === "machizero" ? [
                "11_win_paid"
            ] : [
                "11_win_paid",
                "30_waiting_lottery"
            ]).includes(preSaleLotteryApplicant.status);
        }
        return (config_config/* config.applicationKey */.v.applicationKey === "machizero" ? [
            "11_win_paid",
            "20_waiting_payment"
        ] : [
            "11_win_paid",
            "20_waiting_payment",
            "30_waiting_lottery"
        ]).includes(preSaleLotteryApplicant.status);
    }, [
        preSaleLotteryApplicant,
        isKonbini
    ]);
    /** ボタンが押せない条件 */ var isButtonDisabled = (0,react.useMemo)(function() {
        var ref;
        return /** 抽選待ちかつ、応募締切を過ぎた場合 */ (preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.status) === "30_waiting_lottery" && new Date() > new Date((ref = preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.preSale.lottery) === null || ref === void 0 ? void 0 : ref.applicationEndedAt);
    }, [
        preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.status,
        (ref = preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.preSale.lottery) === null || ref === void 0 ? void 0 : ref.applicationEndedAt, 
    ]);
    var isShowUsageTicketNote = (0,react.useMemo)(function() {
        var ref, ref1;
        return preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : (ref = preSaleLotteryApplicant.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket;
        });
    }, [
        preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : (ref1 = preSaleLotteryApplicant.preSale) === null || ref1 === void 0 ? void 0 : ref1.items
    ]);
    if (!preSaleLotteryApplicant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LotteryApplicationItem, {
                title: t("ticketInfo", "抽選情報"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            pt: 3,
                            pb: 2
                        },
                        children: preSaleLotteryApplicant.preSale.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("applicationDate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 3
                        },
                        variant: "body2",
                        children: [
                            values_Date/* DateTime.format */.o.format((ref2 = preSaleLotteryApplicant.preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationStartedAt),
                            " ",
                            "〜",
                            " ",
                            values_Date/* DateTime.format */.o.format((ref3 = preSaleLotteryApplicant.preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.applicationEndedAt)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("resultNoticeDate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 3
                        },
                        variant: "body2",
                        children: values_Date/* DateTime.format */.o.format(preSaleLotteryApplicant.resultNoticedAt)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("purchasableDate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 3
                        },
                        variant: "body2",
                        children: [
                            values_Date/* DateTime.format */.o.format((ref4 = preSaleLotteryApplicant.preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.purchasableStartedAt),
                            " ",
                            "〜",
                            " ",
                            values_Date/* DateTime.format */.o.format((ref5 = preSaleLotteryApplicant.preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.purchasableEndedAt)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("applicatedAt")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 3
                        },
                        variant: "body2",
                        children: values_Date/* DateTime.format */.o.format(preSaleLotteryApplicant.appliedAt)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationItem, {
                title: t("applicationInfo", "応募情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 6,
                    children: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.choiceItemDetails.map(function(choiceItemDetail, index) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryChoiceItem, {
                                index: index,
                                choiceLength: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : (ref = preSaleLotteryApplicant.choiceItemDetails) === null || ref === void 0 ? void 0 : ref.length,
                                eventTitle: eventTitle,
                                choiceItemDetail: choiceItemDetail,
                                winChoiceNumber: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.winChoiceNumber,
                                applicantStatus: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.status
                            })
                        }, index);
                    })
                })
            }),
            [
                "10_win",
                "11_win_paid",
                "20_waiting_payment",
                "30_waiting_lottery", 
            ].includes(preSaleLotteryApplicant.status) && !isKonbini && /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationItem, {
                title: t("paymentInfo", "支払い情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 3,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                    height: 25,
                                    src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                    target: "common"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("last4Digits", {
                                        number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            [
                "10_win",
                "11_win_paid",
                "20_waiting_payment",
                "30_waiting_lottery", 
            ].includes(preSaleLotteryApplicant.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationItem, {
                title: t("totalPriceHead", "お支払い総額"),
                children: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.choiceItemDetails.map(function(choiceItemDetail, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LotteryChoicePrice, {
                        index: index,
                        choiceLength: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : (ref = preSaleLotteryApplicant.choiceItemDetails) === null || ref === void 0 ? void 0 : ref.length,
                        choiceItemDetail: choiceItemDetail,
                        winChoiceNumber: preSaleLotteryApplicant === null || preSaleLotteryApplicant === void 0 ? void 0 : preSaleLotteryApplicant.winChoiceNumber
                    }, index);
                })
            }),
            isShowUsageTicketNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("usageTicketNote")
                })
            }),
            isShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: function() {
                            switch(preSaleLotteryApplicant.status){
                                case "30_waiting_lottery":
                                    if (isButtonDisabled) return;
                                    onCancel();
                                    break;
                                case "20_waiting_payment":
                                    router.push(generatePath(routerPages.LotteryApplicationDetailPaymentConfirmation, {
                                        preSaleId: preSaleId !== null && preSaleId !== void 0 ? preSaleId : "#"
                                    }));
                                    break;
                                default:
                                    (function() {
                                        if (!winChoicedItem) return;
                                        var itemId = winChoicedItem.itemId, skuId = winChoicedItem.skuId;
                                        router.push({
                                            pathname: generatePath(routerPages.OwnedItemDetail, {
                                                itemId: itemId
                                            }),
                                            search: skuId ? "?skuId=".concat(encodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "")) : ""
                                        });
                                    })();
                            }
                        },
                        variant: preSaleLotteryApplicant.status === "30_waiting_lottery" ? "outlined" : "contained",
                        size: "large",
                        sx: {
                            py: 2,
                            px: 4,
                            width: 244
                        },
                        disabled: isButtonDisabled,
                        children: t("".concat(preSaleLotteryApplicant.status, "_button"))
                    })
                })
            })
        ]
    });
};
var LotteryApplicationItem = function(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            sx: {
                pb: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    sx: {
                        bgcolor: "grey.50",
                        py: 1,
                        px: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: title
                    })
                }),
                children
            ]
        })
    });
};
var LotteryApplicationDetail_template_FixedBottomCell = function(param) {
    var expiredAt = param.expiredAt, voucherUrl = param.voucherUrl;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetail").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)(voucherUrl !== null && voucherUrl !== void 0 ? voucherUrl : "").onClick;
    if (!expiredAt || !voucherUrl) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                p: 5
            },
            alignItems: "center",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: t("paymentDeadlineKonbini", {
                        expiredAt: expiredAt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    color: "primary",
                    sx: {
                        width: 160
                    },
                    disabled: !voucherUrl,
                    onClick: onClick,
                    children: t("confirmPayment")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetail/viewModel.ts




function LotteryApplicationDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PreSaleLotteryApplicant($preSaleId: String!) {\n    preSaleLotteryApplicant(preSaleId: $preSaleId) {\n      ...PreSaleLotteryApplicantDetail\n    }\n    paymentSource {\n      ...paymentCreateDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    LotteryApplicationDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryApplicationDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelPreSaleLottery($inputs: CancelPreSaleLotteryInput!) {\n    cancelPreSaleLottery(inputs: $inputs) {\n      ...PreSaleLotteryApplicantDetail\n    }\n  }\n  ",
        "\n"
    ]);
    LotteryApplicationDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var LotteryApplicationDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,useQuery/* useQuery */.aM)(LotteryApplicationDetail_viewModel_QUERY, {
        variables: {
            preSaleId: router.query.preSaleId
        }
    }), data = ref1.data, loading = ref1.loading;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_PRE_SALE_LOTTERY, {
        variables: {
            inputs: {
                preSaleId: router.query.preSaleId
            }
        }
    }), 2), cancelPreSaleLottery = ref2[0], ref3 = ref2[1], submittingCancel = ref3.loading;
    var ref4;
    return {
        state: {
            loading: loading,
            preSaleLotteryApplicant: data === null || data === void 0 ? void 0 : data.preSaleLotteryApplicant,
            paymentSource: (ref4 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref4 !== void 0 ? ref4 : null,
            submittingCancel: submittingCancel
        },
        actions: {
            onCancelLaffleApplication: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_preSaleLotteryCancel", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    preSaleId: router.query.preSaleId
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                cancelPreSaleLottery().then(function() {
                                    router.push(generatePath(routerPages.LotteryApplicationDetailCancelCompletion, {
                                        preSaleId: router.query.preSaleId
                                    }));
                                }).catch(showError)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var LotteryApplicationDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryApplicationDetail_viewModel_templateObject(), utoniq_core_schema/* PreSaleLotteryApplicantDetailFragmentDoc */.CA6, utoniq_core_schema/* PaymentCreateDetailFragmentDoc */.grT);
var CANCEL_PRE_SALE_LOTTERY = (0,lib/* gql */.Ps)(LotteryApplicationDetail_viewModel_templateObject1(), utoniq_core_schema/* PreSaleLotteryApplicantDetailFragmentDoc */.CA6);

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetail/index.tsx




/**
 * LotteryApplicationDetail Page
 * Implemented as a practical sample.
 */ var LotteryApplicationDetail = function() {
    var ref = LotteryApplicationDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailCancelCompletion/template/index.tsx






/**
 * 抽選応募をキャンセルした際に表示するページ
 * https://zpl.io/zwkq0Q3
 */ var LotteryApplicationDetailCancelCompletionTemplate = function() {
    var t = (0,dist_es/* useTranslation */.$G)("lotteryApplicationDetailCancelCompletion").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title")
        },
        sx: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                width: "100%",
                height: "100%",
                display: "grid",
                placeItems: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    textAlign: "center",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: [
                            " ",
                            t("head")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            mt: 6
                        },
                        children: t("desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        href: routerPages.LotteryApplications,
                        sx: {
                            width: "212px",
                            mt: "44px"
                        },
                        children: t("toList")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        href: routerPages.GlobalHome,
                        sx: {
                            mt: "20px"
                        },
                        children: t("topPage")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailCancelCompletion/viewModel.ts





/**
 *
 */ var LotteryApplicationDetailCancelCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    (0,react.useEffect)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("preSaleLotteryCancel", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            preSaleId: router.query.preSaleId
        });
    }, []);
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailCancelCompletion/index.tsx




/**
 * LotteryApplicationDetailCancelCompletion Page
 * Implemented as a practical sample.
 */ var LotteryApplicationDetailCancelCompletion = function() {
    var ref = LotteryApplicationDetailCancelCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationDetailCancelCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/PreSaleItem/index.tsx



var PreSaleItem = function(param) {
    var children = param.children, title = param.title, Icon = param.Icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 3,
            sx: {
                pb: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 1,
                    sx: {
                        bgcolor: "grey.50",
                        py: 1,
                        px: 2
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            fontSize: "small",
                            sx: {
                                color: "grey.600"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "text.secondary",
                            children: title
                        })
                    ]
                }),
                children
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailPaymentConfirmation/template/index.tsx












/**
 * クレカ自動引き落としに失敗した抽選応募の支払いページ
 * https://zpl.io/0PeLGvQ
 */ var LotteryApplicationDetailPaymentConfirmationTemplate = function(param) {
    var state = param.state, onPurchase = param.onPurchase, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetailPaymentConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var _preSaleId, _preSaleId1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title"),
            defaultBackPage: generatePath(routerPages.LotteryApplicationDetail, {
                preSaleId: (_preSaleId = router.query.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
            }),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                edge: "end",
                color: "primary"
            })
        },
        children: [
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentConfirmationSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            disabled: state.loading,
                            loading: state.submitting,
                            onClick: onPurchase,
                            children: t("submit")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            py: 5
                        },
                        children: t("paymentConfirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationContentCell, {
                        billingStatements: state.billingStatements,
                        totalPayment: state.totalPayment,
                        cardNumber: state.cardNumber,
                        brand: state.brand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                sx: {
                                    width: 212
                                },
                                disabled: state.loading,
                                loading: state.submitting,
                                onClick: onPurchase,
                                children: t("submit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    width: 212
                                },
                                onClick: function() {
                                    return router.goBack(generatePath(routerPages.LotteryApplicationDetail, {
                                        preSaleId: (_preSaleId1 = router.query.preSaleId) !== null && _preSaleId1 !== void 0 ? _preSaleId1 : "#"
                                    }));
                                },
                                children: t("back")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: state.openRequire3DSecureModal,
                onClose: onCloseRequire3DSecureModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: state.openExpiredCardModal,
                onClose: onCloseExpiredCardModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: state.openPaymentErrorModal,
                onClose: onClosePaymentErrorModal
            })
        ]
    });
};
var PaymentConfirmationSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 7,
            px: 5,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h6",
                    width: "60%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 2,
                                lastWidth: "25%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            numberOfLine: 5
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 6
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 6
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ConfirmationContentCell = function(param) {
    var billingStatements = param.billingStatements, totalPayment = param.totalPayment, brand = param.brand, cardNumber = param.cardNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetailPaymentConfirmation").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreSaleItem, {
                title: t("paymentInfo"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("creditCardInfo")
                            }),
                            !cardNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "subtitle1",
                                href: routerPages.PaymentMethodSetting,
                                children: t("register")
                            })
                        ]
                    }),
                    !cardNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.hint",
                        children: t("cardInfoNotRegister")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                width: 40,
                                height: 32,
                                src: (0,creditCard/* generateCreditCardLogoPath */.n)(brand),
                                target: "common"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("last4Digit", {
                                    number: cardNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleItem, {
                title: t("totalPayment"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            billingStatements.map(function(param, index) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: "￥".concat(numeral_default()(totalPayment).format("0,0"))
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailPaymentConfirmation/viewModel.ts





function LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LotteryApplicationDetailPaymentPaymentConfirmation(\n    $preSaleId: String!\n  ) {\n    preSaleLotteryApplicant(preSaleId: $preSaleId) {\n      ...PreSaleLotteryApplicantConfirmation\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation payPreSaleLottery($inputs: PayPreSaleLotteryInput!) {\n    payPreSaleLottery(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









/**
 *
 */ var LotteryApplicationDetailPaymentConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplicationDetailPaymentConfirmation").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref3 = (0,useQuery/* useQuery */.aM)(LotteryApplicationDetailPaymentConfirmation_viewModel_QUERY, {
        variables: {
            preSaleId: router.query.preSaleId
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PAY_PRE_SALE_LOTTERY), 2), payPreSaleLottery = ref4[0], ref5 = ref4[1], submitting = ref5.loading;
    var ref6 = (data === null || data === void 0 ? void 0 : data.preSaleLotteryApplicant) || {}, choiceItemDetails = ref6.choiceItemDetails, winChoiceNumber = ref6.winChoiceNumber;
    var winItem = (0,react.useMemo)(function() {
        return choiceItemDetails === null || choiceItemDetails === void 0 ? void 0 : choiceItemDetails[(winChoiceNumber !== null && winChoiceNumber !== void 0 ? winChoiceNumber : 0) - 1];
    }, [
        winChoiceNumber,
        choiceItemDetails
    ]);
    var ref7;
    var ticketPrice = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref7 = (winItem === null || winItem === void 0 ? void 0 : (ref = winItem.skuUnit) === null || ref === void 0 ? void 0 : ref.price) || (winItem === null || winItem === void 0 ? void 0 : (ref1 = winItem.item) === null || ref1 === void 0 ? void 0 : ref1.price)) !== null && ref7 !== void 0 ? ref7 : 0;
    }, [
        winItem
    ]);
    var fees = winItem === null || winItem === void 0 ? void 0 : winItem.fees;
    var ref8;
    var billingStatements = (0,react.useMemo)(function() {
        return [
            {
                label: t("ticketPrice"),
                value: "￥".concat(numeral_default()(ticketPrice * ((ref8 = winItem === null || winItem === void 0 ? void 0 : winItem.count) !== null && ref8 !== void 0 ? ref8 : 0)).format("0,0"))
            }
        ].concat((0,src_to_consumable_array/* default */.Z)(((fees === null || fees === void 0 ? void 0 : fees.collections) || []).map(function(fee) {
            return {
                label: fee === null || fee === void 0 ? void 0 : fee.feeName,
                value: "￥".concat(numeral_default()(fee === null || fee === void 0 ? void 0 : fee.fee).format("0,0"))
            };
        })));
    }, [
        t,
        fees,
        ticketPrice
    ]);
    var totalPayment = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var ref3;
        var konbiniFee = (ref3 = fees === null || fees === void 0 ? void 0 : (ref = fees.konbini) === null || ref === void 0 ? void 0 : ref.fee) !== null && ref3 !== void 0 ? ref3 : 0;
        var ref4;
        var shippingFee = (ref4 = fees === null || fees === void 0 ? void 0 : (ref1 = fees.shipping) === null || ref1 === void 0 ? void 0 : ref1.fee) !== null && ref4 !== void 0 ? ref4 : 0;
        var ref5, ref6;
        var collectionsFee = (ref6 = fees === null || fees === void 0 ? void 0 : (ref2 = fees.collections) === null || ref2 === void 0 ? void 0 : ref2.reduce(function(acc, fee) {
            return acc + ((ref5 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref5 !== void 0 ? ref5 : 0);
        }, 0)) !== null && ref6 !== void 0 ? ref6 : 0;
        var ref7;
        return konbiniFee + shippingFee + collectionsFee + ticketPrice * ((ref7 = winItem === null || winItem === void 0 ? void 0 : winItem.count) !== null && ref7 !== void 0 ? ref7 : 0);
    }, [
        fees,
        ticketPrice
    ]);
    var ref9 = (0,react.useState)(false), openExpiredCardModal = ref9[0], setOpenExpiredCardModal = ref9[1];
    var ref10 = (0,react.useState)(false), openPaymentErrorModal = ref10[0], setOpenPaymentErrorModal = ref10[1];
    var ref11 = (0,react.useState)(false), openRequire3DSecureModal = ref11[0], setOpenRequire3DSecureModal = ref11[1];
    var ref12;
    return {
        state: {
            loading: loading,
            cardNumber: data === null || data === void 0 ? void 0 : (ref = data.paymentSource) === null || ref === void 0 ? void 0 : ref.last4,
            brand: (ref12 = data === null || data === void 0 ? void 0 : (ref1 = data.paymentSource) === null || ref1 === void 0 ? void 0 : ref1.brand) !== null && ref12 !== void 0 ? ref12 : "",
            submitting: submitting,
            totalPayment: totalPayment,
            billingStatements: billingStatements,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal
        },
        actions: {
            onPurchase: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        payPreSaleLottery({
                            variables: {
                                inputs: {
                                    preSaleId: router.query.preSaleId,
                                    price: totalPayment
                                }
                            },
                            context: {
                                headers: {
                                    "x-utoniq-idempotency-key": createUuid()
                                }
                            }
                        }).then(function(order) {
                            var ref, ref1;
                            // StoreItemPurchaseComplete に遷移
                            router.push((0,react_router/* generatePath */.Gn)(routerPages.StoreItemPurchaseComplete, {
                                cartTransactionOrderId: order === null || order === void 0 ? void 0 : (ref = order.data) === null || ref === void 0 ? void 0 : (ref1 = ref.payPreSaleLottery) === null || ref1 === void 0 ? void 0 : ref1.id
                            }));
                        }).catch(function(error) {
                            var ref, ref1, ref2;
                            switch((ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                    setOpenRequire3DSecureModal(true);
                                    return;
                                /**
               * @desciption
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                    setOpenExpiredCardModal(true);
                                    return;
                                /**
               * @desciption
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                    setOpenPaymentErrorModal(true);
                                    return;
                                default:
                                    showError(error);
                                    break;
                            }
                        })
                    ];
                });
            }),
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
});
var LotteryApplicationDetailPaymentConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject(), utoniq_core_schema/* PreSaleLotteryApplicantConfirmationFragmentDoc */.vqx, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var PAY_PRE_SALE_LOTTERY = (0,lib/* gql */.Ps)(LotteryApplicationDetailPaymentConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplicationDetailPaymentConfirmation/index.tsx




/**
 * LotteryApplicationDetailPaymentConfirmation Page
 * Implemented as a practical sample.
 */ var LotteryApplicationDetailPaymentConfirmation = function() {
    var ref = LotteryApplicationDetailPaymentConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationDetailPaymentConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/event/LotteryApplicationCard/index.tsx







var LotteryApplicationCard = function(param) {
    var lotteryApplication = param.lotteryApplication;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplications").t;
    var ref5 = (0,react.useMemo)(function() {
        switch(lotteryApplication.status){
            case "10_win":
            case "11_win_paid":
                return {
                    bgcolor: "primary.main",
                    color: "white"
                };
            case "20_waiting_payment":
                return {
                    bgcolor: "error.main",
                    color: "white"
                };
            case "30_waiting_lottery":
                return {
                    bgcolor: "secondary.main",
                    color: "white"
                };
            case "40_lose":
                return {
                    bgcolor: "grey.300",
                    color: "text.secondary"
                };
            case "50_invalid":
            case "60_canceled":
            default:
                return {
                    bgcolor: "grey.100",
                    color: "text.disabled"
                };
        }
    }, [
        lotteryApplication.status
    ]), bgcolor = ref5.bgcolor, color = ref5.color;
    /**
   * 表示するSKU
   * 当選以外の場合は第一希望のSKUを表示し
   * 当選している場合は当選したSKUを表示する
   */ var sku = (0,react.useMemo)(function() {
        if (!lotteryApplication.winChoiceNumber) {
            return lotteryApplication.choiceItemDetails[0].skuUnit;
        }
        return lotteryApplication.choiceItemDetails[lotteryApplication.winChoiceNumber - 1].skuUnit;
    }, [
        lotteryApplication.winChoiceNumber,
        lotteryApplication.choiceItemDetails
    ]);
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.LotteryApplicationDetail, {
                    preSaleId: lotteryApplication.preSale.id
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            p: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                size: "small",
                                sx: {
                                    height: 20,
                                    borderRadius: "10px",
                                    bgcolor: bgcolor,
                                    py: 1,
                                    px: 4,
                                    ".MuiChip-label": {
                                        px: 0
                                    }
                                },
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: color,
                                    variant: "subtitle2",
                                    children: t(lotteryApplication.status)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: lotteryApplication.preSale.title
                            }),
                            (!!sku || !!lotteryApplication.preSale.event.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: [
                                    (ref6 = lotteryApplication === null || lotteryApplication === void 0 ? void 0 : (ref = lotteryApplication.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref6 !== void 0 ? ref6 : "",
                                    (ref7 = sku === null || sku === void 0 ? void 0 : sku.unitName) !== null && ref7 !== void 0 ? ref7 : "", 
                                ].filter(function(o) {
                                    return !!o;
                                }).join("/")
                            })
                        ]
                    }),
                    !!(lotteryApplication.resultNoticedAt || ((ref2 = lotteryApplication.preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.resultNoticedAt)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            bgcolor: "grey.100",
                            px: 5,
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                fontSize: "10px"
                            },
                            children: [
                                t("resultNoticedAt"),
                                values_Date/* DateTime.formatDate */.o.formatDate(lotteryApplication.resultNoticedAt || ((ref3 = lotteryApplication.preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.resultNoticedAt), "YYYY/MM/DD(ddd) HH:mm")
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/event/LotteryApplicationCardSkeleton/index.tsx



var LotteryApplicationCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h5",
                        width: "20%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                height: 38,
                width: "100%"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplications/template/index.tsx












var LotteryApplicationsTemplate = function(param) {
    var state = param.state, onFilter = param.onFilter, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplications").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref4.routerNames, routerPages = ref4.routerPages;
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                href: routerPages.Management
            }),
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: [
                    routerNames.LotteryApplications
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplications_template_FilterMenu, {
                filter: state.filter,
                onFilter: onFilter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref = state.lotteryApplications) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                        var node = param.node;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationCard, {
                            lotteryApplication: node
                        }, node.id);
                    }),
                    loading: state.loading,
                    hasNextPage: (ref5 = (ref2 = state.lotteryApplications) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.hasNextPage) !== null && ref5 !== void 0 ? ref5 : false,
                    onFetchMore: function() {
                        return onFetchMore(state.filter);
                    },
                    emptyMessage: t("emptyMessage"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        children: Array.from(Array(5).keys()).map(function(index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationCardSkeleton, {}, index);
                        })
                    })
                })
            })
        ]
    });
};
var LotteryApplications_template_FilterMenu = function(param) {
    var filter = param.filter, onFilter = param.onFilter;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryApplications").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var options = (0,react.useMemo)(function() {
        return [
            {
                label: t("general"),
                value: undefined
            },
            {
                label: t("10_win"),
                value: "10_win"
            },
            {
                label: t("11_win_paid"),
                value: "11_win_paid"
            },
            {
                label: t("20_waiting_payment"),
                value: "20_waiting_payment"
            },
            {
                label: t("30_waiting_lottery"),
                value: "30_waiting_lottery"
            },
            {
                label: t("40_lose"),
                value: "40_lose"
            },
            {
                label: t("50_invalid"),
                value: "50_invalid"
            }, 
        ];
    }, []);
    var index = filter === "general" ? 0 : options.findIndex(function(option) {
        return option.value === filter;
    }) !== -1 ? options.findIndex(function(option) {
        return option.value === filter;
    }) : 0;
    var ref2 = (0,react.useState)(index), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleMenuItemClick = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(_, index) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedIndex(index);
                        setAnchorEl(null);
                        return [
                            4,
                            onFilter((ref = options[index]) === null || ref === void 0 ? void 0 : ref.value)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_, index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onFilter,
        options
    ]);
    (0,react.useEffect)(function() {
        if (selectedIndex) {
            var UrlParams = "?filter=".concat(options[selectedIndex].value);
            // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
            window.history.replaceState(null, "", UrlParams);
        } else {
            var UrlParams1 = location.pathname;
            window.history.replaceState(null, "", UrlParams1);
        }
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "flex-end",
                sx: {
                    pb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        width: "fit-content",
                        mr: -2
                    },
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                pr: 1
                            },
                            children: (ref = options[selectedIndex]) === null || ref === void 0 ? void 0 : ref.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall",
                            sx: {
                                color: "grey.600"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: !!anchorEl,
                onClose: handleClose,
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            bgcolor: "grey.100",
                            minWidth: 200
                        },
                        selected: index === selectedIndex,
                        onClick: function(event) {
                            return handleMenuItemClick(event, index);
                        },
                        children: option.label
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplications/viewModel.ts



function LotteryApplications_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PreSaleLotteryApplicants($filter: [String!], $pageInput: PageInput) {\n    preSaleLotteryApplicants(filter: $filter, pageInput: $pageInput) {\n      ...PreSaleLotteryApplicants\n    }\n  }\n  ",
        "\n"
    ]);
    LotteryApplications_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LotteryApplications_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var options = [
        {
            value: undefined
        },
        {
            value: "10_win"
        },
        {
            value: "11_win_paid"
        },
        {
            value: "20_waiting_payment"
        },
        {
            value: "30_waiting_lottery"
        },
        {
            value: "40_lose"
        },
        {
            value: "50_invalid"
        }, 
    ];
    var params = new URLSearchParams(window.location.search);
    var ref1;
    var eventFilter = (ref1 = params.get("filter")) !== null && ref1 !== void 0 ? ref1 : "general";
    var ref2;
    var value = (ref2 = (ref = options.find(function(option) {
        return option.value === eventFilter;
    })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref2 !== void 0 ? ref2 : "general";
    var ref3 = (0,react.useState)(value), filter = ref3[0], setFilter = ref3[1];
    var ref4 = (0,useQuery/* useQuery */.aM)(LotteryApplications_viewModel_QUERY, {
        variables: {
            filter: filter === "general" ? undefined : filter
        },
        notifyOnNetworkStatusChange: true
    }), data = ref4.data, loading = ref4.loading, refetch = ref4.refetch, fetchMore = ref4.fetchMore;
    return {
        state: {
            loading: loading,
            lotteryApplications: data === null || data === void 0 ? void 0 : data.preSaleLotteryApplicants,
            filter: filter
        },
        actions: {
            onFilter: function(filter) {
                setFilter(filter !== null && filter !== void 0 ? filter : "general");
                refetch({
                    filter: filter === "general" ? undefined : filter
                });
            },
            onFetchMore: function onFetchMore(filter) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        fetchMore({
                            variables: {
                                fitlter: filter === "general" ? undefined : filter,
                                pageInput: {
                                    cursor: data === null || data === void 0 ? void 0 : (ref = data.preSaleLotteryApplicants) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                                }
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var LotteryApplications_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryApplications_viewModel_templateObject(), utoniq_core_schema/* PreSaleLotteryApplicantsFragmentDoc */.pe8);

;// CONCATENATED MODULE: ./src/components/pages/LotteryApplications/index.tsx




/**
 * LotteryApplications Page
 * Implemented as a practical sample.
 */ var LotteryApplications = function() {
    var ref = LotteryApplications_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryApplicationsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryCompletion/template/index.tsx





var LotteryCompletionTemplate = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryCompletion").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, routerNames = ref.routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title", "先行販売応募完了")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryCompletion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 6,
                alignItems: "center",
                sx: {
                    pt: "55px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("applicationCompleted", "応募が完了しました")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        align: "center",
                        children: t("applicationCompletedDesc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 4,
                sx: {
                    pt: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: routerPages.LotteryApplications,
                        size: "large",
                        sx: {
                            width: 244
                        },
                        children: t("lotteryApplicationManagement", "抽選応募管理へ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: routerPages.GlobalHome,
                        variant: "text",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        children: t("toTop", "TOPページへ")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryCompletion/viewModel.ts





/**
 *
 */ var LotteryCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    (0,react.useEffect)(function() {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("preSaleLotteryApply", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            preSaleId: router.query.preSaleId
        });
    }, []);
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/LotteryCompletion/index.tsx




/**
 * LotteryCompletion Page
 * Implemented as a practical sample.
 */ var LotteryCompletion = function() {
    var ref = LotteryCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/pages/Errors/Forbidden/template/index.tsx





var ForbiddenTemplate = function(param) {
    var _state = param.state, _useNextRouter = _state.useNextRouter, useNextRouter = _useNextRouter === void 0 ? true : _useNextRouter;
    var t = (0,core_i18n/* useTranslation */.$G)("forbidden").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            maxWidth: 600,
            width: "100%",
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 7,
                    mt: 6
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                        variant: "h1",
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            pt: 2
                        },
                        children: t("message")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "text.secondary",
                        sx: {
                            pt: 5
                        },
                        align: "center",
                        children: t("desc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: useNextRouter ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/home",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        component: "div",
                        size: "large",
                        children: t("goToTopPage")
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    href: "/home",
                    size: "large",
                    children: t("goToTopPage")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Errors/Forbidden/index.tsx


/**
 * Forbidden Page
 * Implemented as a practical sample.
 */ var Forbidden = function(param) {
    var _useNextRouter = param.useNextRouter, useNextRouter = _useNextRouter === void 0 ? true : _useNextRouter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForbiddenTemplate, {
        state: {
            useNextRouter: useNextRouter
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/components/LotterySubTitleCell.tsx






var LotterySubTitleCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    var contents = [
        {
            title: t("preSale", "先行販売"),
            content: preSale.title
        },
        {
            title: t("applicationDate", "先行抽選受付期間"),
            content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref = preSale.lottery) === null || ref === void 0 ? void 0 : ref.formattedApplicationStartedAt, " 〜").concat(preSale === null || preSale === void 0 ? void 0 : (ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.formattedApplicationEndedAt)
        }, 
    ].concat((0,src_to_consumable_array/* default */.Z)((preSale === null || preSale === void 0 ? void 0 : (ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.formattedResultNoticedAt) ? [
        {
            title: t("resultNoticeDate", "当落発表予定日"),
            content: preSale === null || preSale === void 0 ? void 0 : (ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.formattedResultNoticedAt
        }, 
    ] : []), [
        {
            title: t("purchasableDate", "決済期間"),
            content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.formattedPurchasableStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref5 = preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.formattedPurchasableEndedAt)
        }, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("information", "公演情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: contents.map(function(content, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: content.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: content.content
                                    })
                                ]
                            }),
                            index < contents.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/components/LotteryPlansCell.tsx







var LotteryPlansCell = function(param) {
    var choice = param.choice, items = param.items;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("lotteryInformation", "抽選応募情報")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    pt: 3
                },
                children: choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                    var itemId = param.itemId, skuId = param.skuId;
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LotteryPlansCell_ItemSelectedCell, {
                        item: items === null || items === void 0 ? void 0 : items.find(function(item) {
                            return item.id === itemId;
                        }),
                        skuId: skuId,
                        choiceLength: choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.length,
                        count: (ref1 = choice.purchaseCountChoices[index]) === null || ref1 === void 0 ? void 0 : ref1.count,
                        index: index + 1
                    }, skuId !== null && skuId !== void 0 ? skuId : itemId);
                })
            })
        ]
    });
};
var LotteryPlansCell_ItemSelectedCell = function(param) {
    var item = param.item, skuId = param.skuId, count = param.count, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength, index = param.index;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    var skuUnit = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!skuId) return undefined;
        return item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.find(function(s) {
            return s.id === skuId;
        });
    }, [
        skuId,
        item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                variant: "outlined",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    children: t("preference", {
                        index: index
                    })
                }),
                sx: {
                    bgcolor: "white",
                    p: 0,
                    height: 20,
                    ".MuiChip-label": {
                        p: 1
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("ticketName", "チケット名")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: item === null || item === void 0 ? void 0 : item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: skuUnit.unitName
                            }),
                            (item === null || item === void 0 ? void 0 : (ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("ticketDetail", "チケット詳細")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("price", "価格")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("pricePerSheet", {
                            price: numeral_default()((skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) || (item === null || item === void 0 ? void 0 : item.price)).format("0,0")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("quantity", "応募枚数")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: [
                            count,
                            t("sheet")
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/components/PaymentInfoCell.tsx






var template_components_PaymentInfoCell_PaymentInfoCell = function(param) {
    var paymentSource = param.paymentSource, paymentMethod = param.paymentMethod;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    switch(paymentMethod){
        case utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            children: t("paymentInfo", "支払い情報")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("creditCardInfo", "クレジットカード情報")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                        width: 40,
                                        height: 32,
                                        src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                        target: "common"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("last4Digit", {
                                            number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        case utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h5",
                            color: "text.secondary",
                            children: t("paymentInfo", "支払い情報")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: t("convenienceStore", "コンビニ決済")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    display: "block",
                                    mt: 2
                                },
                                children: t("convenienceStoreDesc", "ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。")
                            })
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/components/PaymentCell.tsx






var PaymentCell_PaymentCell = function(param) {
    var billingStatements = param.billingStatements, _choiceLength = param.choiceLength, choiceLength = _choiceLength === void 0 ? 1 : _choiceLength;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 2,
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    color: "text.secondary",
                    children: t("totalPaymentAmount", "お支払い総額")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 5,
                sx: {
                    pt: 3
                },
                children: billingStatements === null || billingStatements === void 0 ? void 0 : billingStatements.map(function(stmt, index) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            choiceLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("preference", {
                                        index: index + 1
                                    })
                                }),
                                sx: {
                                    bgcolor: "white",
                                    p: 0,
                                    height: 20,
                                    ".MuiChip-label": {
                                        p: 1
                                    }
                                }
                            }),
                            stmt === null || stmt === void 0 ? void 0 : (ref = stmt.statements) === null || ref === void 0 ? void 0 : ref.map(function(param, subIndex) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                    ]
                                }, subIndex);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            "￥",
                                            numeral_default()(stmt.totalPrice).format("0,0")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/components/ButtonCell.tsx




var template_components_ButtonCell_ButtonCell = function(param) {
    var onSubmit = param.onSubmit, isSubmitting = param.isSubmitting;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var _preSaleId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    loading: isSubmitting,
                    sx: {
                        width: 212
                    },
                    onClick: onSubmit,
                    children: t("submit", "応募する")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.LotteryDetail, {
                            preSaleId: (_preSaleId = router.query.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
                        }));
                    },
                    children: t("back", "戻る")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/template/index.tsx









var LotteryConfirmationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref2.routerNames, routerPages = ref2.routerPages, generatePath = ref2.generatePath, router = ref2.router;
    var _preSaleId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.LotteryDetail, {
                preSaleId: (_preSaleId = router.query.preSaleId) !== null && _preSaleId !== void 0 ? _preSaleId : "#"
            }),
            title: t("title", "応募情報詳細")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryConfirmation
            }),
            state.loading || !state.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryTitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotterySubTitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPlansSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryConfirmation_template_PaymentInfoSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PaymentSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ButtonSkeletonCell, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryTitleCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotterySubTitleCell, {
                        preSale: state.preSale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPlansCell, {
                        choice: state.choice,
                        items: state.preSale.items
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_components_PaymentInfoCell_PaymentInfoCell, {
                        paymentMethod: state.paymentMethod,
                        paymentSource: state.paymentSource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCell_PaymentCell, {
                        billingStatements: state.billingStatements,
                        choiceLength: (ref = state.choice) === null || ref === void 0 ? void 0 : (ref1 = ref.choices) === null || ref1 === void 0 ? void 0 : ref1.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pb: 4
                        },
                        children: state.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini ? t("noteByKonbini") : t("note")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_components_ButtonCell_ButtonCell, {
                        onSubmit: onSubmit,
                        isSubmitting: state.submitting
                    })
                ]
            })
        ]
    });
};
var LotteryTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: t("confirmApplicationDetail", "応募内容の確認")
        })
    });
};
var LotteryTitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h4",
            width: "50%"
        })
    });
};
var LotterySubTitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: Array.from(Array(3).keys()).map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    numberOfLine: 2
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
var LotteryPlansSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2",
                width: "10%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: Array.from(Array(4).keys()).map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    numberOfLine: 2
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};
var LotteryConfirmation_template_PaymentInfoSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "50%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                ]
            })
        ]
    });
};
var template_PaymentSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 1,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "subtitle1",
                                width: "30%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var template_ButtonSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            flex: 1,
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 244,
                height: 44,
                sx: {
                    borderRadius: "34px"
                }
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/viewModel.ts






function LotteryConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LotteryConfirmation($id: ID!, $clientId: String, $token: String) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      ...PreSaleLotteryConfirmation\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    LotteryConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ApplyPreSaleLottery(\n    $inputs: ApplyPreSaleLotteryInput!\n    $clientId: String\n    $token: String\n  ) {\n    applyPreSaleLottery(inputs: $inputs, clientId: $clientId, token: $token) {\n      id\n    }\n  }\n"
    ]);
    LotteryConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












/**
 *
 */ var LotteryConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages;
    var ref2 = (0,react.useState)(), choice = ref2[0], setChoice = ref2[1];
    var rootAuthInfo = useRootAuth();
    /** 外部アプリのルート認証に失敗したかどうかの状態 */ var ref3 = (0,react.useState)(false), isRootAuthFailed = ref3[0], setIsRootAuthFailed = ref3[1];
    var t = (0,dist_es/* useTranslation */.$G)("lotteryConfirmation").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,useQuery/* useQuery */.aM)(LotteryConfirmation_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId,
            clientId: rootAuthInfo.clientId,
            token: rootAuthInfo.token
        },
        onError: function(error) {
            var ref;
            var ref1;
            setIsRootAuthFailed((ref1 = error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.some(function(error) {
                var ref;
                return (error === null || error === void 0 ? void 0 : (ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === "FORBIDDEN";
            })) !== null && ref1 !== void 0 ? ref1 : false);
        }
    }), data = ref4.data, loading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(APPLY_PRE_SALE_LOTTERY), 2), applyPreSaleLottery = ref5[0], ref6 = ref5[1], submitting = ref6.loading;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                        ];
                    case 1:
                        v = _state.sent();
                        // localStorageにデータがない場合、応募ページを表示
                        if (v.preSaleId !== router.query.preSaleId) {
                            router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryDetail, {
                                preSaleId: router.query.preSaleId
                            }));
                        }
                        setChoice(v);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        storage/* getPrefrenceObject */._d
    ]);
    var isKonbini = (0,react.useMemo)(function() {
        return (choice === null || choice === void 0 ? void 0 : choice.paymentMethod) === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini;
    }, [
        choice === null || choice === void 0 ? void 0 : choice.paymentMethod
    ]);
    var billingStatements = (0,react.useMemo)(function() {
        var ref;
        // 代金や手数料など、支払のすべてをブレイクダウンした配列
        return choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
            var itemId = param.itemId, skuId = param.skuId;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
            var item = data === null || data === void 0 ? void 0 : (ref = data.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(i) {
                return (i === null || i === void 0 ? void 0 : i.id) === itemId;
            });
            var ref16;
            var itemPrice = skuId ? (ref16 = (ref4 = item === null || item === void 0 ? void 0 : (ref2 = item.skuSettings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.units) === null || ref3 === void 0 ? void 0 : ref3.find(function(s) {
                return (s === null || s === void 0 ? void 0 : s.id) === skuId;
            })) === null || ref4 === void 0 ? void 0 : ref4.price) !== null && ref16 !== void 0 ? ref16 : item === null || item === void 0 ? void 0 : item.price : item === null || item === void 0 ? void 0 : item.price;
            var ref17;
            var purchaseCount = (ref17 = choice === null || choice === void 0 ? void 0 : (ref5 = choice.purchaseCountChoices) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[index]) === null || ref6 === void 0 ? void 0 : ref6.count) !== null && ref17 !== void 0 ? ref17 : 0;
            // 代金や手数料など、支払のすべてをブレイクダウンした配列
            var statements = (0,src_to_consumable_array/* default */.Z)([
                {
                    label: t("totalPrice"),
                    value: "￥".concat(numeral_default()((itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0) * purchaseCount).format("0,0"))
                }, 
            ].concat((0,src_to_consumable_array/* default */.Z)(((item === null || item === void 0 ? void 0 : (ref7 = item.fees) === null || ref7 === void 0 ? void 0 : ref7.collections) || []).map(function(fee) {
                var ref;
                var feeValue = (ref = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref !== void 0 ? ref : 0;
                return {
                    label: fee === null || fee === void 0 ? void 0 : fee.feeName,
                    value: (fee === null || fee === void 0 ? void 0 : fee.per) === "order" ? "￥".concat(numeral_default()(feeValue).format("0,0")) : "￥".concat(numeral_default()(feeValue * purchaseCount).format("0,0"))
                };
            })))).concat((0,src_to_consumable_array/* default */.Z)(isKonbini ? [
                {
                    label: item === null || item === void 0 ? void 0 : (ref8 = item.fees) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.konbini) === null || ref9 === void 0 ? void 0 : ref9.feeName,
                    value: "￥".concat(numeral_default()(item === null || item === void 0 ? void 0 : (ref10 = item.fees) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.konbini) === null || ref11 === void 0 ? void 0 : ref11.fee).format("0,0"))
                }, 
            ] : []));
            var ref18, ref19;
            var totalFee = item === null || item === void 0 ? void 0 : (ref12 = item.fees) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.collections) === null || ref13 === void 0 ? void 0 : ref13.reduce(function(acc, fee) {
                return acc + ((fee === null || fee === void 0 ? void 0 : fee.per) === "order" ? (ref18 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref18 !== void 0 ? ref18 : 0 : ((ref19 = fee === null || fee === void 0 ? void 0 : fee.fee) !== null && ref19 !== void 0 ? ref19 : 0) * purchaseCount);
            }, 0);
            var ref20;
            return {
                statements: statements,
                totalPrice: (itemPrice !== null && itemPrice !== void 0 ? itemPrice : 0) * purchaseCount + (totalFee !== null && totalFee !== void 0 ? totalFee : 0) + (isKonbini ? (ref20 = item === null || item === void 0 ? void 0 : (ref14 = item.fees) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.konbini) === null || ref15 === void 0 ? void 0 : ref15.fee) !== null && ref20 !== void 0 ? ref20 : 0 : 0)
            };
        });
    }, [
        choice,
        data === null || data === void 0 ? void 0 : (ref = data.preSale) === null || ref === void 0 ? void 0 : ref.items,
        t
    ]);
    var ref7;
    return {
        state: {
            isRootAuthFailed: isRootAuthFailed,
            preSale: data === null || data === void 0 ? void 0 : data.preSale,
            loading: loading,
            submitting: submitting,
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            choice: choice,
            billingStatements: billingStatements,
            paymentMethod: (ref7 = choice === null || choice === void 0 ? void 0 : choice.paymentMethod) !== null && ref7 !== void 0 ? ref7 : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard
        },
        actions: {
            onSubmit: function onSubmit() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, choices, purchaseCountChoices, ref2, paymentMethod;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                choices = choice === null || choice === void 0 ? void 0 : (ref = choice.choices) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                    var itemId = param.itemId, skuId = param.skuId;
                                    return skuId !== null && skuId !== void 0 ? skuId : itemId;
                                });
                                purchaseCountChoices = choice === null || choice === void 0 ? void 0 : (ref1 = choice.purchaseCountChoices) === null || ref1 === void 0 ? void 0 : ref1.map(function(purchaseCount) {
                                    return purchaseCount.count;
                                });
                                if (!choices || !purchaseCountChoices) return [
                                    2
                                ];
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_preSaleLotteryApply", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        preSaleId: router.query.preSaleId,
                                        choiceCount: choice === null || choice === void 0 ? void 0 : choice.choices.length,
                                        paymentMethod: (choice === null || choice === void 0 ? void 0 : choice.paymentMethod) === "konbini" ? "convenience_store" : "credit_card"
                                    })
                                ];
                            case 1:
                                _state.sent();
                                paymentMethod = (ref2 = choice === null || choice === void 0 ? void 0 : choice.paymentMethod) !== null && ref2 !== void 0 ? ref2 : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard;
                                return [
                                    4,
                                    applyPreSaleLottery({
                                        variables: (0,src_object_spread/* default */.Z)({
                                            inputs: {
                                                preSaleId: router.query.preSaleId,
                                                choices: choices,
                                                purchaseCountChoices: purchaseCountChoices,
                                                paymentMethod: paymentMethod,
                                                fullName: paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini ? choice === null || choice === void 0 ? void 0 : choice.fullName : undefined
                                            }
                                        }, router.query.preSaleId === rootAuthInfo.preSaleId ? {
                                            clientId: rootAuthInfo.clientId,
                                            token: rootAuthInfo.token
                                        } : {})
                                    }).then(function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(applicants) {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        // LocalStorageに保存した一次データを削除
                                                        return [
                                                            4,
                                                            (0,storage/* removePrefernce */.Tq)("preSaleLotteryApplicationInput")
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryCompletion, {
                                                            preSaleId: router.query.preSaleId
                                                        }));
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(applicants) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()).catch(showError)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var LotteryConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryConfirmation_viewModel_templateObject(), utoniq_core_schema/* PreSaleLotteryConfirmationFragmentDoc */.Xdd, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var APPLY_PRE_SALE_LOTTERY = (0,lib/* gql */.Ps)(LotteryConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/LotteryConfirmation/index.tsx





/**
 * LotteryConfirmation Page
 * Implemented as a practical sample.
 */ var LotteryConfirmation = function() {
    var ref = LotteryConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (state.isRootAuthFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Forbidden, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDeliveryInfo/template/LotteryDeliveryForm.tsx












var LotteryDeliveryForm_schema = function(o) {
    return {
        postalCode: o.string().custom(PostalCode/* PostalCode.createValidator */.R.createValidator()).label((0,core_form/* tLabel */.TQ)("lotteryDeliveryInfo.postalCode")),
        prefecture: (0,validators/* validatePrefecture */.f6)(o, "lotteryDeliveryInfo.prefecture"),
        city: (0,validators/* validateCity */.Co)(o, "lotteryDeliveryInfo.city"),
        line1: (0,validators/* validateLine1 */.lT)(o, "lotteryDeliveryInfo.line1"),
        line2: (0,validators/* validateLine2 */.iT)(o, "lotteryDeliveryInfo.line2")
    };
};
var LotteryDeliveryForm = function(param) {
    var user = param.user, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDeliveryInfo").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: LotteryDeliveryForm_schema,
        defaultValues: LotteryDeliveryForm_defaultValues
    }), register = ref.register, handleSubmit = ref.handleSubmit, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    (0,react.useEffect)(function() {
        if (user) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5, ref6, ref7, ref8, ref9;
            reset({
                postalCode: (ref5 = user === null || user === void 0 ? void 0 : (ref = user.address) === null || ref === void 0 ? void 0 : ref.postalCode) !== null && ref5 !== void 0 ? ref5 : "",
                prefecture: (ref6 = user === null || user === void 0 ? void 0 : (ref1 = user.address) === null || ref1 === void 0 ? void 0 : ref1.prefecture) !== null && ref6 !== void 0 ? ref6 : "",
                city: (ref7 = user === null || user === void 0 ? void 0 : (ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.city) !== null && ref7 !== void 0 ? ref7 : "",
                line1: (ref8 = user === null || user === void 0 ? void 0 : (ref3 = user.address) === null || ref3 === void 0 ? void 0 : ref3.line1) !== null && ref8 !== void 0 ? ref8 : "",
                line2: (ref9 = user === null || user === void 0 ? void 0 : (ref4 = user.address) === null || ref4 === void 0 ? void 0 : ref4.line2) !== null && ref9 !== void 0 ? ref9 : ""
            });
        }
    }, [
        user
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var normalizedValues;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        normalizedValues = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                            postalCode: PostalCode/* PostalCode.normalize */.R.normalize(values.postalCode)
                        });
                        return [
                            4,
                            onSubmit(normalizedValues).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    pb: 4
                },
                children: t("preSaleDeliveryNote", "お客様の情報をご入力ください。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                textFieldProps: {
                    InputProps: {
                        inputProps: {
                            pattern: "\\d{3}-?\\d{4}|\\d{7}",
                            inputMode: "tel",
                            sx: {
                                px: 4,
                                py: 3
                            }
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.postalCode
            }, register("postalCode"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.prefecture
            }, register("prefecture"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.city
            }, register("city"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line1
            }, register("line1"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.line2
            }, register("line2"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                alignItems: "center",
                sx: {
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: isSubmitting,
                    disabled: isSubmitting,
                    onClick: handleOnSubmit,
                    children: t("submit")
                })
            })
        ]
    });
};
var LotteryDeliveryForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDeliveryInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var LotteryDeliveryForm_defaultValues = {
    postalCode: "",
    city: "",
    line1: "",
    line2: "",
    prefecture: ""
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDeliveryInfo/template/index.tsx





var LotteryDeliveryInfoTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDeliveryInfo").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryDeliveryInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryForm, {
                user: state.user,
                onSubmit: onSubmit
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDeliveryInfo/viewModel.ts




function LotteryDeliveryInfo_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LotteryDeliveryInfo {\n    user {\n      ...UserDeliveryDetail\n    }\n  }\n  ",
        "\n"
    ]);
    LotteryDeliveryInfo_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LotteryDeliveryInfo_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var data = (0,useQuery/* useQuery */.aM)(LotteryDeliveryInfo_viewModel_QUERY).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserDeliveryInfo */.p2K), 1), updateUserDeliveryInfo = ref1[0];
    var ref2;
    return {
        state: {
            user: (ref2 = data === null || data === void 0 ? void 0 : data.user) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onSubmit: function onSubmit(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, values;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.fullName) !== null && ref2 !== void 0 ? ref2 : "",
                                                phoneNumber: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber) !== null && ref3 !== void 0 ? ref3 : "",
                                                address: value
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                                ];
                            case 2:
                                values = _state.sent();
                                if (values === null || values === void 0 ? void 0 : values.isFirstComeFirstServed) {
                                    return [
                                        2,
                                        router.replace(generatePath(routerPages.FirstComeFirstServedConfirmation, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                router.replace(generatePath(routerPages.LotteryConfirmation, {
                                    preSaleId: router.query.preSaleId
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var LotteryDeliveryInfo_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryDeliveryInfo_viewModel_templateObject(), utoniq_core_schema/* UserDeliveryDetailFragmentDoc */.TRY);

;// CONCATENATED MODULE: ./src/components/pages/LotteryDeliveryInfo/index.tsx




/**
 * LotteryDeliveryInfo Page
 * Implemented as a practical sample.
 */ var LotteryDeliveryInfo = function() {
    var ref = LotteryDeliveryInfo_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDeliveryInfoTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/LotteryContentCell.tsx







var LotteryContentCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref8;
    var ticketInfos = (0,array/* filterHiddenItem */.s)([
        {
            title: t("applicationDate", "受付期間"),
            content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref = preSale.lottery) === null || ref === void 0 ? void 0 : ref.formattedApplicationStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.formattedApplicationEndedAt)
        },
        {
            title: t("resultNoticeDate", "結果発表予定日"),
            content: (ref8 = preSale === null || preSale === void 0 ? void 0 : (ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.formattedResultNoticedAt) !== null && ref8 !== void 0 ? ref8 : "",
            hidden: !(preSale === null || preSale === void 0 ? void 0 : (ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.resultNoticedAt)
        },
        {
            title: t("purchasableDate", "購入期間"),
            content: "".concat(preSale === null || preSale === void 0 ? void 0 : (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.formattedPurchasableStartedAt, " 〜 ").concat(preSale === null || preSale === void 0 ? void 0 : (ref5 = preSale.lottery) === null || ref5 === void 0 ? void 0 : ref5.formattedPurchasableEndedAt),
            hidden: (preSale === null || preSale === void 0 ? void 0 : preSale.preSaleStatus) === utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption
        }, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        sx: {
                            flex: 1,
                            minWidth: "fit-content"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("lottery", "抽選")
                                }),
                                sx: {
                                    bgcolor: "background.default",
                                    p: 0,
                                    height: 20,
                                    ".MuiChip-label": {
                                        p: 1
                                    }
                                }
                            }),
                            !!(preSale === null || preSale === void 0 ? void 0 : (ref6 = preSale.lottery) === null || ref6 === void 0 ? void 0 : ref6.applicationEndedAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreSaleStatusTag, {
                                status: preSale === null || preSale === void 0 ? void 0 : preSale.preSaleStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        width: "100%",
                        variant: "subtitle1",
                        children: preSale === null || preSale === void 0 ? void 0 : (ref7 = preSale.event) === null || ref7 === void 0 ? void 0 : ref7.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: preSale === null || preSale === void 0 ? void 0 : preSale.description
            }),
            ticketInfos.map(function(info, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: info.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: info.content
                        })
                    ]
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/MembershipCell.tsx







var components_MembershipCell_MembershipCell = function(param) {
    var preSale = param.preSale;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref6.routerPages, generatePath = ref6.generatePath;
    /** 先行販売に必要なメンバーシップのプラン */ var membershipPlans = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        // 登録プランをすべて表示する
        var planIds = (preSale === null || preSale === void 0 ? void 0 : preSale.planId) ? [
            preSale.planId
        ] : (preSale === null || preSale === void 0 ? void 0 : preSale.purchesablePlanIds) || [];
        if (!planIds.length) return [];
        var planData = ((ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.subscription) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.filter(function(products) {
            return products.plans.some(function(plan) {
                return planIds.includes(plan.planId);
            });
        })) || [];
        // 全プラン対象の場合はプラン詳細を表示しない
        return planData.length === ((ref3 = preSale.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.products) === null || ref5 === void 0 ? void 0 : ref5.length) ? [] : planData;
    }, [
        preSale === null || preSale === void 0 ? void 0 : (ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    /** ユーザーの加入しているメンバーシップのプラン */ var currentPatronProduct = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var planId = preSale === null || preSale === void 0 ? void 0 : (ref = preSale.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId;
        if (!planId) return null;
        return (ref3 = preSale.artist.subscription) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.products) === null || ref4 === void 0 ? void 0 : ref4.find(function(products) {
            return products.plans.find(function(plan) {
                return plan.planId === planId;
            });
        });
    }, [
        preSale === null || preSale === void 0 ? void 0 : (ref2 = preSale.artist) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.patron) === null || ref3 === void 0 ? void 0 : ref3.id
    ]);
    if (!preSale.isPremium && (!preSale.purchesablePlanIds || preSale.purchesablePlanIds.length === 0)) return null;
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("condition", "応募条件")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 0,
                        sx: {
                            placeItems: "center",
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                fontSize: "small",
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.hint",
                                children: t("isPremium")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: [
                            preSale.plans.map(function(plan) {
                                return plan === null || plan === void 0 ? void 0 : plan.planTitle;
                            }).join("\n"),
                            t("membershipLimited", "会員の方")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                variant: "outlined",
                sx: {
                    p: 5,
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        pb: "0!important",
                        p: 0
                    },
                    children: preSale.isAccessible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                sx: {
                                                    minWidth: "60px"
                                                },
                                                children: t("planTitle")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: currentPatronProduct === null || currentPatronProduct === void 0 ? void 0 : currentPatronProduct.title
                                            })
                                        ]
                                    }),
                                    !!preSale.isAccessible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "overline",
                                            color: "white",
                                            children: t("joined")
                                        }),
                                        sx: {
                                            height: 16,
                                            bgcolor: "primary.main",
                                            borderRadius: "2px",
                                            padding: "2px 4px",
                                            ".MuiChip-label": {
                                                px: 0
                                            }
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                sx: {
                                    mt: 3,
                                    pb: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        sx: {
                                            minWidth: "60px"
                                        },
                                        children: t("updatedAt")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: (ref4 = preSale.artist.patron) === null || ref4 === void 0 ? void 0 : ref4.formattedUpdatedAt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            flex: 1
                                        }
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("membershipBenefit")
                            }),
                            membershipPlans.map(function(plan) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                mt: 2
                                            },
                                            children: plan.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: plan.content
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "grid",
                                    placeItems: "cen"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    sx: {
                                        mt: 6,
                                        width: "212px",
                                        mx: "auto"
                                    },
                                    size: "large",
                                    href: generatePath(routerPages.ArtistMembership, {
                                        artistId: (ref7 = preSale === null || preSale === void 0 ? void 0 : (ref5 = preSale.artist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref7 !== void 0 ? ref7 : "#"
                                    }),
                                    onClick: function() {
                                        /**
                     * TODO:
                     * 年間メンバーシッププラン機能に伴う導線実装が完了したら、先行販売に戻るUIを下記ローカルストレージキーをもとに実装すること
                     * https://zpl.io/kKOkROg
                     */ (0,storage/* setPreference */.l$)("currentPreSaleId", {
                                            preSaleId: preSale.id
                                        });
                                    },
                                    children: t("seeDetail")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/QuantitySelectModal.tsx









var components_QuantitySelectModal_schema = function(o) {
    return {
        choiceId: o.string().required(),
        choiceSkuId: o.string().optional().allow(null),
        purchaseCountChoice: o.number().required()
    };
};
var QuantitySelectModal_QuantitySelectModal = function(param) {
    var item = param.item, skuId = param.skuId, maxChoice = param.maxChoice, maxSelectItem = param.maxSelectItem, selectedIndex = param.selectedIndex, onGoBack = param.onGoBack, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: components_QuantitySelectModal_schema,
        defaultValues: {
            purchaseCountChoice: 1,
            choiceId: item === null || item === void 0 ? void 0 : item.id,
            choiceSkuId: skuId
        }
    }), handleSubmit = ref.handleSubmit, setValue = ref.setValue, watch = ref.watch;
    // SKUの指定があればSKUの情報を取得
    var skuUnit = (0,react.useMemo)(function() {
        var ref;
        return skuId ? item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units.find(function(sku) {
            return sku.id === skuId;
        }) : null;
    }, [
        skuId,
        item === null || item === void 0 ? void 0 : item.skuSettings
    ]);
    // SKUの価格があればその価格、なければアイテムの価格を取得
    var formattedPrice = (0,react.useMemo)(function() {
        return (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) ? skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.formattedPrice : item === null || item === void 0 ? void 0 : item.formattedPrice;
    }, [
        skuUnit,
        item === null || item === void 0 ? void 0 : item.formattedPrice
    ]);
    var quantity = (0,react.useMemo)(function() {
        if (!(item === null || item === void 0 ? void 0 : item.issuedNumber)) {
            return maxSelectItem;
        }
        if (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.stock) {
            var _pendingPurchaseNumber, _purchasedNumber;
            var itemMaxSelectItem = skuUnit.stock - ((_pendingPurchaseNumber = skuUnit.pendingPurchaseNumber) !== null && _pendingPurchaseNumber !== void 0 ? _pendingPurchaseNumber : 0) - ((_purchasedNumber = skuUnit.purchasedNumber) !== null && _purchasedNumber !== void 0 ? _purchasedNumber : 0);
            return itemMaxSelectItem > maxSelectItem ? maxSelectItem : itemMaxSelectItem;
        }
        var _pendingPurchaseNumber1, _purchasedNumber1;
        var itemMaxSelectItem1 = item.issuedNumber - ((_pendingPurchaseNumber1 = item.pendingPurchaseNumber) !== null && _pendingPurchaseNumber1 !== void 0 ? _pendingPurchaseNumber1 : 0) - ((_purchasedNumber1 = item.purchasedNumber) !== null && _purchasedNumber1 !== void 0 ? _purchasedNumber1 : 0);
        return itemMaxSelectItem1 > maxSelectItem ? maxSelectItem : itemMaxSelectItem1;
    }, [
        item === null || item === void 0 ? void 0 : item.issuedNumber,
        item === null || item === void 0 ? void 0 : item.pendingPurchaseNumber,
        item === null || item === void 0 ? void 0 : item.purchasedNumber,
        maxSelectItem,
        skuUnit, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: (0,src_object_spread/* default */.Z)({
                    py: 4,
                    px: 3,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "small",
                        onClick: onGoBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: maxChoice > 1 ? t("selectQuantityTitle", {
                            number: selectedIndex + 1
                        }) : t("selectNumberSheets", "枚数選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: 30
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1
                },
                children: t("performanceInformation", "公演情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5,
                    pt: 2
                },
                children: item === null || item === void 0 ? void 0 : item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5
                },
                children: skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1,
                    mt: 3
                },
                children: t("selectNumberSheets", "枚数選択")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("selectQuantityNote", {
                            max: quantity
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        sx: {
                            pb: 7
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                variant: "h2",
                                children: [
                                    "\xa5",
                                    formattedPrice
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                        listItems: (0,src_to_consumable_array/* default */.Z)(Array(quantity).keys()).map(function(index) {
                                            return {
                                                value: (index + 1).toString(),
                                                label: (index + 1).toString()
                                            };
                                        }),
                                        value: "".concat(watch("purchaseCountChoice")),
                                        onChange: function(value) {
                                            return setValue("purchaseCountChoice", +value);
                                        },
                                        formControlProps: {
                                            sx: {
                                                minWidth: 100,
                                                bgcolor: "grey.50",
                                                minHeight: "auto"
                                            }
                                        },
                                        MenuProps: {
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 400,
                                                    overflowY: "auto"
                                                }
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        children: t("sheet", "枚")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "center",
                        sx: {
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            onClick: handleSubmit(onSubmit),
                            children: t("addNext", "次へ")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/SkuUnitSelectModal.tsx







var SkuUnitSelectModal_SkuUnitSelectModal = function(param) {
    var isBeforeReceiption = param.isBeforeReceiption, item = param.item, selectedItems = param.selectedItems, onClose = param.onClose, onGoBack = param.onGoBack, onSelectItem = param.onSelectItem;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var skuUnits = item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 4,
                    px: 3
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "small",
                        onClick: onGoBack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: t("selectTicketTitle", "チケットを選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        size: "small",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1
                },
                children: t("performanceInformation", "公演情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                width: "100%",
                sx: {
                    px: 5,
                    py: 2
                },
                children: item === null || item === void 0 ? void 0 : item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                width: "100%",
                color: "text.secondary",
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 1,
                    mt: 3
                },
                children: t("typeSelection", "種類選択")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 2,
                sx: (0,src_object_spread/* default */.Z)({
                    p: 5,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: skuUnits === null || skuUnits === void 0 ? void 0 : skuUnits.map(function(itemSku) {
                    var selectedItemIndex = selectedItems.findIndex(function(selectedItem) {
                        return selectedItem.skuId === (itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                    });
                    var isSelectedItem = selectedItemIndex >= 0;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                            elevation: 0,
                            sx: {
                                borderRadius: 2,
                                bgcolor: "grey.50"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                disabled: isSelectedItem || isBeforeReceiption,
                                onClick: function() {
                                    return onSelectItem(itemSku.id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                    sx: {
                                        px: 5,
                                        py: 2,
                                        "&:last-child": {
                                            pb: 4
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: isSelectedItem || isBeforeReceiption ? "text.disabled" : "text.primary",
                                                children: itemSku === null || itemSku === void 0 ? void 0 : itemSku.unitName
                                            }),
                                            isSelectedItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                                        fontSize: "small",
                                                        color: "primary"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "primary.main",
                                                        children: t("selectedIndex", {
                                                            number: selectedItemIndex + 1
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/TicketSelectModal.tsx









var TicketSelectModal_TicketSelectModal = function(param) {
    var isBeforeReceiption = param.isBeforeReceiption, items = param.items, selectedItems = param.selectedItems, onClose = param.onClose, onSelectItem = param.onSelectItem;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var itemSkus = (0,react.useMemo)(function() {
        return items.map(function(item) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5;
            return {
                id: item.id,
                title: item.title,
                skuUnitIds: (ref5 = (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.map(function(unit) {
                    return unit.id;
                })) !== null && ref5 !== void 0 ? ref5 : [],
                skuUnits: (ref2 = item.skuSettings) === null || ref2 === void 0 ? void 0 : ref2.units,
                formattedPrice: item.formattedPrice,
                isThroughTicket: (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.isThroughTicket
            };
        }).flat();
    }, [
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            bgcolor: "background.default",
            height: "75dvh",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    py: 4,
                    px: 3
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        width: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        align: "center",
                        width: "100%",
                        children: t("selectTicketTitle", "チケットを選択")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        size: "small",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                spacing: 2,
                sx: (0,src_object_spread/* default */.Z)({
                    p: 5,
                    overflowY: "auto"
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: [
                    isBeforeReceiption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "caption",
                        children: t("beforeReceiptionNote", "受付期間前のためチケットは選択できません。")
                    }),
                    itemSkus === null || itemSkus === void 0 ? void 0 : itemSkus.map(function(itemSku) {
                        var selectedItemIndexs = selectedItems.map(function(selectedItem, index) {
                            if (selectedItem.itemId === (itemSku === null || itemSku === void 0 ? void 0 : itemSku.id)) {
                                return index;
                            }
                        }).filter(function(selectedItemIndex) {
                            return selectedItemIndex !== undefined;
                        });
                        var isSelectedItem = (selectedItemIndexs === null || selectedItemIndexs === void 0 ? void 0 : selectedItemIndexs.length) > 0 && (!itemSku.skuUnitIds.length || selectedItemIndexs.length === itemSku.skuUnitIds.length);
                        var ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                                elevation: 0,
                                sx: {
                                    borderRadius: 2,
                                    bgcolor: isSelectedItem ? "grey.100" : "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                                    disabled: isSelectedItem || isBeforeReceiption,
                                    onClick: function() {
                                        return onSelectItem(items.find(function(item) {
                                            return item.id === (itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                                        sx: {
                                            px: 20,
                                            py: 4,
                                            "&:last-child": {
                                                pb: 4
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: isSelectedItem || isBeforeReceiption ? "text.disabled" : "text.primary",
                                                children: itemSku === null || itemSku === void 0 ? void 0 : itemSku.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: (itemSku === null || itemSku === void 0 ? void 0 : itemSku.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {
                                                    disabled: isSelectedItem || isBeforeReceiption
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                sx: {
                                                    pt: 2
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        color: isSelectedItem || isBeforeReceiption ? "text.disabled" : "text.primary",
                                                        children: [
                                                            "\xa5",
                                                            itemSku === null || itemSku === void 0 ? void 0 : itemSku.formattedPrice
                                                        ]
                                                    }),
                                                    isSelectedItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        alignItems: "center",
                                                        spacing: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                                                fontSize: "small",
                                                                color: "primary"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "subtitle1",
                                                                color: "primary.main",
                                                                children: itemSku.skuUnitIds.length ? t("choosing") : t("selectedIndex", {
                                                                    number: ((ref = selectedItemIndexs === null || selectedItemIndexs === void 0 ? void 0 : selectedItemIndexs[0]) !== null && ref !== void 0 ? ref : 0) + 1
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }, itemSku === null || itemSku === void 0 ? void 0 : itemSku.id);
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/TicketListCell.tsx













var TicketListCell_MAX_ADD_ITEM = 3;
var TicketListCell_MAX_SELECT_ITEM = 8;
var TicketListCell_TicketListCell = function(param) {
    var items = param.items, _maxChoice = param.maxChoice, maxChoice = _maxChoice === void 0 ? TicketListCell_MAX_ADD_ITEM : _maxChoice, _maxSelectItem = param.maxSelectItem, maxSelectItem = _maxSelectItem === void 0 ? TicketListCell_MAX_SELECT_ITEM : _maxSelectItem, control = param.control, hasEmptyField = param.hasEmptyField, setHasEmptyField = param.setHasEmptyField, isBeforeReceiption = param.isBeforeReceiption, hasValidField = param.hasValidField, isAccessible = param.isAccessible, toggleMembershipModalOpen = param.toggleMembershipModalOpen;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(0), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var ref2 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "choices"
    }), choiceFields = ref2.fields, appendChoice = ref2.append, updateChoice = ref2.update, removeChoice = ref2.remove;
    var ref3 = (0,react_hook_form_dist_index_esm/* useFieldArray */.Dq)({
        control: control,
        name: "purchaseCountChoices"
    }), purchaseCountChoiceFields = ref3.fields, appendPurchaseCountChoice = ref3.append, updatePurchaseCountChoice = ref3.update, removePurchaseCountChoice = ref3.remove;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("selectTicketDetails", "申込内容の選択")
            }),
            maxChoice > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    component: "p",
                    variant: "caption",
                    children: t("selectTicketDesc", {
                        max: maxChoice
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                height: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                children: choiceFields.map(function(param, index) {
                    var id = param.id, itemId = param.itemId, skuId = param.skuId;
                    var ref, ref1, ref2, ref3;
                    var item = items === null || items === void 0 ? void 0 : items.find(function(param) {
                        var id = param.id;
                        return id === itemId;
                    });
                    var skuUnit = skuId ? item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : ref.units.find(function(sku) {
                        return sku.id === skuId;
                    }) : null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                sx: {
                                    p: 4,
                                    borderRadius: 2,
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    pointerEvents: item ? "none" : "unset"
                                },
                                onClick: function() {
                                    // メンバーシップ限定の抽選でユーザーが対象外の場合、モーダルを表示
                                    if (!isAccessible) {
                                        toggleMembershipModalOpen();
                                        return;
                                    }
                                    setSelectedIndex(index);
                                    setOpen(true);
                                },
                                children: [
                                    maxChoice > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        lineHeight: "30px",
                                        children: t("preference", {
                                            number: index + 1
                                        })
                                    }),
                                    item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            mr: 7
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                align: "left",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    !!(skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        align: "left",
                                                        children: skuUnit.unitName
                                                    }),
                                                    ((ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 2,
                                                sx: {
                                                    pt: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: [
                                                            "\xa5",
                                                            (skuUnit === null || skuUnit === void 0 ? void 0 : skuUnit.price) || item.formattedPrice,
                                                            "/"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: [
                                                            (ref3 = purchaseCountChoiceFields[index]) === null || ref3 === void 0 ? void 0 : ref3.count,
                                                            t("sheet", "枚")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        sx: {
                                            py: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "button",
                                                color: "primary",
                                                children: t("selectTicket", "チケットを選択する")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Next, {
                                                color: "primary"
                                            })
                                        ]
                                    })
                                ]
                            }, id),
                            item && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                                size: "small",
                                bgcolor: "grey.50",
                                sx: {
                                    position: "absolute",
                                    zIndex: 2,
                                    right: 16,
                                    top: 16
                                },
                                onClick: function() {
                                    // チケット希望を取り消す処理。1つしかフィールドがない場合は、フィールドを削除せずに初期化する。
                                    if (choiceFields.length === 1) {
                                        updateChoice(index, {
                                            itemId: ""
                                        });
                                        updatePurchaseCountChoice(index, {
                                            count: 1
                                        });
                                        setHasEmptyField(true);
                                        return;
                                    }
                                    removeChoice(index);
                                    removePurchaseCountChoice(index);
                                }
                            })
                        ]
                    });
                })
            }),
            !hasEmptyField && maxChoice - choiceFields.length > 0 && hasValidField && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                justifyContent: "flex-end",
                flex: 1,
                alignItems: "flex-end",
                sx: {
                    pt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    size: "small",
                    onClick: function() {
                        appendChoice({
                            itemId: ""
                        });
                        appendPurchaseCountChoice({
                            count: 1
                        });
                        setHasEmptyField(true);
                    },
                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Plus, {
                        fontSize: "medium",
                        sx: {
                            color: "grey.700"
                        }
                    }),
                    children: t("addSelect", {
                        number: choiceFields.length + 1
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketListCell_TicketBottomSheet, {
                items: items,
                selectedIndex: selectedIndex,
                selectedItems: choiceFields,
                open: open,
                isBeforeReceiption: isBeforeReceiption,
                maxChoice: maxChoice,
                maxSelectItem: maxSelectItem,
                onClose: function() {
                    return setOpen(false);
                },
                onSubmit: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                        var choiceId, choiceSkuId, purchaseCountChoice;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            choiceId = param.choiceId, choiceSkuId = param.choiceSkuId, purchaseCountChoice = param.purchaseCountChoice;
                            updateChoice(selectedIndex, {
                                itemId: choiceId,
                                skuId: choiceSkuId
                            });
                            updatePurchaseCountChoice(selectedIndex, {
                                count: purchaseCountChoice
                            });
                            setHasEmptyField(false);
                            return [
                                2
                            ];
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        ]
    });
};
var TicketListCell_TicketBottomSheet = function(param) {
    var items = param.items, selectedItems = param.selectedItems, open = param.open, maxChoice = param.maxChoice, selectedIndex = param.selectedIndex, maxSelectItem = param.maxSelectItem, onClose = param.onClose, onSubmit = param.onSubmit, isBeforeReceiption = param.isBeforeReceiption;
    var ref = (0,react.useState)(0), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(null), item = ref1[0], setItem = ref1[1];
    var handleOnClose = function() {
        onClose();
        setStep(0);
        setItem(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
        open: open,
        onClose: handleOnClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            height: "75dvh",
            sx: {
                bgcolor: "background.default"
            },
            children: [
                step === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketSelectModal_TicketSelectModal, {
                        items: items,
                        selectedItems: selectedItems,
                        onClose: onClose,
                        isBeforeReceiption: isBeforeReceiption,
                        onSelectItem: function(item) {
                            var ref, ref1;
                            setItem({
                                item: item,
                                selectSkuId: undefined
                            });
                            if (item === null || item === void 0 ? void 0 : (ref = item.skuSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.units) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                return setStep(1);
                            }
                            setStep(2);
                        }
                    })
                }),
                step === 1 && (item === null || item === void 0 ? void 0 : item.item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkuUnitSelectModal_SkuUnitSelectModal, {
                        item: item === null || item === void 0 ? void 0 : item.item,
                        selectedItems: selectedItems,
                        onClose: handleOnClose,
                        onGoBack: function() {
                            setStep(0);
                            setItem(null);
                        },
                        isBeforeReceiption: isBeforeReceiption,
                        onSelectItem: function(skuId) {
                            setItem({
                                item: item === null || item === void 0 ? void 0 : item.item,
                                selectSkuId: skuId
                            });
                            setStep(2);
                        }
                    })
                }),
                step === 2 && (item === null || item === void 0 ? void 0 : item.item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelectModal_QuantitySelectModal, {
                        item: item.item,
                        skuId: item.selectSkuId,
                        maxChoice: maxChoice,
                        selectedIndex: selectedIndex,
                        onGoBack: function() {
                            var ref, ref1, ref2;
                            if ((ref = item.item) === null || ref === void 0 ? void 0 : (ref1 = ref.skuSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.units) === null || ref2 === void 0 ? void 0 : ref2.length) {
                                return setStep(1);
                            }
                            setStep(0);
                        },
                        maxSelectItem: maxSelectItem,
                        onSubmit: function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onSubmit(values)
                                            ];
                                        case 1:
                                            _state.sent();
                                            onClose();
                                            setStep(0);
                                            setItem(null);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(values) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/PaymentInfoCell.tsx











var LotteryDetail_template_components_PaymentInfoCell_PaymentInfoCell = function(param) {
    var value = param.value, setValue = param.setValue, paymentSource = param.paymentSource, originFullNameValue = param.originFullNameValue, error = param.error, inputFullNameProps = param.inputFullNameProps, onRegister = param.onRegister, paymentMethods = param.paymentMethods, paymentFees = param.paymentFees, toggleMembershipModalOpen = param.toggleMembershipModalOpen, isAccessible = param.isAccessible;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var konbiniFee = paymentFees === null || paymentFees === void 0 ? void 0 : paymentFees.find(function(param) {
        var feeType = param.feeType;
        return feeType === "konbini";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("paymentInfo", "支払い情報")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 3,
                    ".MuiFormControlLabel-root > span:first-child": {
                        display: paymentMethods.length > 1 ? "block" : "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                            value: value,
                            onChange: function(event, value) {
                                handleLoginModal(function() {
                                    setValue("paymentMethod", value, {
                                        shouldValidate: true
                                    });
                                    if (value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini) {
                                        setValue("fullName", originFullNameValue, {
                                            shouldValidate: true
                                        });
                                    }
                                })(event);
                            },
                            sx: {
                                gap: function(theme) {
                                    return theme.spacing(4);
                                }
                            },
                            children: [
                                paymentMethods.includes(utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    value: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                    checked: value === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        onClick: function(e) {
                                            if (!isAccessible) {
                                                e.preventDefault();
                                                toggleMembershipModalOpen();
                                            }
                                        }
                                    }),
                                    label: paymentSource ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 3,
                                                alignItems: "center",
                                                sx: {
                                                    mt: 2
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                                        height: 25,
                                                        src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource.brand),
                                                        target: "common"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: t("last4Digits", {
                                                            number: paymentSource.last4
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                sx: {
                                                    mt: 2
                                                },
                                                children: t("registerCreditNote", "当選時に自動決済します。")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h6",
                                                        children: t("creditCard")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                        variant: "text",
                                                        color: "primary",
                                                        onClick: handleLoginModal(onRegister),
                                                        children: t("register", "登録")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                color: "text.hint",
                                                children: t("creditCardNotRegistered", "支払い情報が登録されていません")
                                            })
                                        ]
                                    })
                                }),
                                paymentMethods.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                                paymentMethods.includes(utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    value: utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                    checked: value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        onClick: function(e) {
                                            if (!isAccessible) {
                                                e.preventDefault();
                                                toggleMembershipModalOpen();
                                            }
                                        }
                                    }),
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                alignItems: "center",
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "h5",
                                                        children: t("convenienceStore", "コンビニ決済")
                                                    }),
                                                    !!(konbiniFee === null || konbiniFee === void 0 ? void 0 : konbiniFee.formattedFee) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: t("convenienceStoreNote", {
                                                            paymentFee: konbiniFee.formattedFee
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "caption",
                                                children: t("convenienceStoreDesc")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    value === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    py: 4
                                },
                                color: "text.secondary",
                                children: t("storeItemNote")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PaymentInfoCell_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                type: "text"
                            }, inputFullNameProps), {
                                textFieldProps: {
                                    sx: {
                                        mb: 0
                                    }
                                }
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: "error",
                variant: "body2",
                children: error
            })
        ]
    });
};
var components_PaymentInfoCell_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/CommissionListCell.tsx








var CommissionListCell_CommissionListCell = function(param) {
    var paymentFees = param.paymentFees, isKonbini = param.isKonbini;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    // 手数料を表示用にフォーマットする
    var formattedFees = (0,react.useMemo)(function() {
        var filteredFees = paymentFees === null || paymentFees === void 0 ? void 0 : paymentFees.filter(function(fee) {
            return fee.feeType !== utoniq_core_schema/* FeeType.Konbini */.ntd.Konbini || isKonbini;
        });
        if (!filteredFees || filteredFees.length === 0) {
            return [
                t("emptyFees", "なし")
            ];
        }
        return filteredFees.map(function(fee) {
            switch(fee.per){
                case "order":
                    return "".concat(fee.feeName, ": ").concat(t("feePerOrder", {
                        fee: "".concat(numeral_default()(fee.fee).format("0,0"))
                    }));
                case "item":
                    return "".concat(fee.feeName, ": ").concat(t("feePerItem", {
                        fee: "".concat(numeral_default()(fee.fee).format("0,0"))
                    }));
                default:
                    return null;
            }
        });
    }, [
        t,
        paymentFees,
        isKonbini
    ]);
    if (isEmpty_default()(formattedFees)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("usageFee", "利用手数料")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 6,
                    px: 1
                },
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.secondary",
                        variant: "subtitle1",
                        children: t("commission", "手数料")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: formattedFees === null || formattedFees === void 0 ? void 0 : formattedFees.map(function(fee) {
                            return fee;
                        }).join("\n")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/CautionTextCell.tsx




var CautionTextCell_CautionTextCell = function(param) {
    var note = param.note;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    bgcolor: "grey.50",
                    px: 2,
                    py: 1
                },
                color: "text.secondary",
                children: t("notes", "注意事項")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    component: "p",
                    variant: "caption",
                    color: "text.secondary",
                    children: note
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/components/ButtonCell.tsx






var LotteryDetail_template_components_ButtonCell_ButtonCell = function(param) {
    var onSubmit = param.onSubmit, disabled = param.disabled, isSubmitting = param.isSubmitting;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checked,
                        onClick: handleLoginModal(function() {
                            return setChecked(function(prevState) {
                                return !prevState;
                            });
                        })
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("checkBoxLabel")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: !checked || disabled,
                    loading: isSubmitting,
                    sx: {
                        width: 212
                    },
                    onClick: handleLoginModal(onSubmit),
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/LotteryDetailForm.tsx
















var LotteryDetailForm_schema = function(o) {
    return {
        preSaleId: o.string(),
        paymentMethod: o.string(),
        fullName: o.string().when("paymentMethod", {
            is: utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini,
            then: o.string().label("氏名"),
            otherwise: o.string().optional().allow(null)
        }),
        choices: o.array().items(o.object({
            itemId: o.string(),
            skuId: o.string().optional().allow(null)
        })),
        purchaseCountChoices: o.array().items(o.object({
            count: o.number()
        }))
    };
};
var LotteryDetailForm = function(param) {
    var preSale = param.preSale, paymentSource = param.paymentSource, originFullNameValue = param.originFullNameValue, paymentFees = param.paymentFees, onSubmit = param.onSubmit, onReadyPaymentMethod = param.onReadyPaymentMethod, _selectMultipleItem = param.selectMultipleItem, selectMultipleItem = _selectMultipleItem === void 0 ? true : _selectMultipleItem, choices = param.choices, isAppliedUser = param.isAppliedUser;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), router = ref8.router, generatePath = ref8.generatePath, routerPages = ref8.routerPages;
    var ref9;
    var ref10 = (0,core_form/* useForm */.cI)({
        schema: LotteryDetailForm_schema,
        defaultValues: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, LotteryDetailForm_defaultValues), {
            preSaleId: preSale.id,
            // 予め選択された状態の場合（ストアから直接遷移）
            choices: choices ? choices.map(function(param) {
                var itemId = param.itemId, skuId = param.skuId;
                return {
                    itemId: itemId,
                    skuId: skuId
                };
            }) : LotteryDetailForm_defaultValues.choices,
            purchaseCountChoices: choices ? choices.map(function(param) {
                var count = param.count;
                return {
                    count: count
                };
            }) : LotteryDetailForm_defaultValues.purchaseCountChoices,
            paymentMethod: (ref9 = (ref = preSale.paymentMethods) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref9 !== void 0 ? ref9 : LotteryDetailForm_defaultValues.paymentMethod
        })
    }), watch = ref10.watch, setValue = ref10.setValue, handleSubmit = ref10.handleSubmit, register = ref10.register, control = ref10.control, getValues = ref10.getValues, _formState = ref10.formState, isSubmitting = _formState.isSubmitting, errors = _formState.errors;
    // メンバーシップ限定モーダルの表示状態
    var ref11 = (0,react.useReducer)(function(state) {
        return !state;
    }, false), membershipModalOpen = ref11[0], toggleMembershipModalOpen = ref11[1];
    // 未入力の「第n希望」要素がフィールドに含まれているかどうか
    var ref12 = (0,react.useState)(!(choices === null || choices === void 0 ? void 0 : choices.length)), hasEmptyField = ref12[0], setHasEmptyField = ref12[1];
    // 入力しているフィールドがあるかどうか
    var hasValidField = (0,react.useMemo)(function() {
        return !!watch("choices").filter(function(choice) {
            return choice.itemId;
        }).length && !!watch("purchaseCountChoices").filter(function(_, index) {
            var ref;
            return !!((ref = watch("choices")[index]) === null || ref === void 0 ? void 0 : ref.itemId);
        }).length;
    }, [
        watch("choices"),
        watch("purchaseCountChoices")
    ]);
    var paymentMethodWatch = watch("paymentMethod");
    var isStopSalling = ((ref1 = preSale.lottery) === null || ref1 === void 0 ? void 0 : ref1.applicationStartedAt) > values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds() || ((ref2 = preSale.lottery) === null || ref2 === void 0 ? void 0 : ref2.applicationEndedAt) < values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds();
    var isBeforeReceiption = preSale.preSaleStatus === utoniq_core_schema/* PreSaleStatus.BeforeReceiption */.fu$.BeforeReceiption;
    var filterEmptyItem = (0,react.useCallback)(function() {
        // 配列の中の空要素を除外する処理
        setValue("purchaseCountChoices", watch("purchaseCountChoices").filter(function(_, index) {
            var ref;
            return !!((ref = watch("choices")[index]) === null || ref === void 0 ? void 0 : ref.itemId);
        }));
        setValue("choices", watch("choices").filter(function(choice) {
            return choice.itemId;
        }));
        setHasEmptyField(false);
    }, [
        setValue,
        watch
    ]);
    // 離脱時に入力値を保存
    (0,react.useEffect)(function() {
        return function() {
            (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* setPreference */.l$)("preSaleLotteryApplicationInput", watch())
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    }, []);
    var _paymentMethods, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            (!isStopSalling || isBeforeReceiption) && !isAppliedUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketListCell_TicketListCell, {
                        items: preSale.items,
                        control: control,
                        errors: errors,
                        maxChoice: selectMultipleItem ? (ref3 = preSale.lottery) === null || ref3 === void 0 ? void 0 : ref3.maxChoice : 1,
                        maxSelectItem: (ref4 = preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.purchasableCount,
                        hasEmptyField: hasEmptyField,
                        hasValidField: hasValidField,
                        setHasEmptyField: setHasEmptyField,
                        isBeforeReceiption: isBeforeReceiption,
                        toggleMembershipModalOpen: toggleMembershipModalOpen,
                        isAccessible: preSale.isAccessible
                    }),
                    !isBeforeReceiption && /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDetail_template_components_PaymentInfoCell_PaymentInfoCell, {
                        paymentMethods: (_paymentMethods = preSale.paymentMethods) !== null && _paymentMethods !== void 0 ? _paymentMethods : [
                            utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
                            utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini, 
                        ],
                        isAccessible: preSale.isAccessible,
                        toggleMembershipModalOpen: toggleMembershipModalOpen,
                        paymentFees: paymentFees,
                        value: paymentMethodWatch,
                        setValue: setValue,
                        paymentSource: paymentSource,
                        originFullNameValue: originFullNameValue !== null && originFullNameValue !== void 0 ? originFullNameValue : "",
                        inputFullNameProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, register("fullName")), {
                            error: errors.fullName
                        }),
                        error: (ref5 = errors.paymentMethod) === null || ref5 === void 0 ? void 0 : ref5.message,
                        onRegister: function() {
                            if (hasValidField) {
                                filterEmptyItem();
                            }
                            setTimeout(function() {
                                onReadyPaymentMethod(getValues());
                            }, 300);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommissionListCell_CommissionListCell, {
                paymentFees: paymentFees,
                isKonbini: watch("paymentMethod") === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CautionTextCell_CautionTextCell, {
                note: preSale.note
            }),
            !isStopSalling && !isAppliedUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDetail_template_components_ButtonCell_ButtonCell, {
                onSubmit: handleLoginModal(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                filterEmptyItem();
                                return [
                                    4,
                                    handleSubmit(function(v) {
                                        onSubmit(v);
                                    })()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })),
                disabled: isSubmitting || watch("paymentMethod") === utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard && !paymentSource || !isEmpty_default()(errors) || !((ref6 = watch("choices")) === null || ref6 === void 0 ? void 0 : ref6.filter(function(param) {
                    var itemId = param.itemId;
                    return itemId;
                }).length),
                isSubmitting: isSubmitting
            }),
            isAppliedUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: membershipModalOpen,
                onClose: toggleMembershipModalOpen,
                title: t("membershipRequired", "メンバーシップへの加入が必要です"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    href: generatePath(routerPages.ArtistMembership, {
                        artistId: (ref13 = preSale === null || preSale === void 0 ? void 0 : (ref7 = preSale.artist) === null || ref7 === void 0 ? void 0 : ref7.id) !== null && ref13 !== void 0 ? ref13 : "#"
                    }),
                    onClick: function() {
                        /**
               * TODO:
               * 年間メンバーシッププラン機能に伴う導線実装が完了したら、先行販売に戻るUIを下記ローカルストレージキーをもとに実装すること
               * https://zpl.io/kKOkROg
               */ (0,storage/* setPreference */.l$)("currentPreSaleId", {
                            preSaleId: preSale.id
                        });
                    },
                    children: t("seeDetail")
                })
            })
        ]
    });
};
var LotteryDetailForm_defaultValues = {
    choices: [
        {
            itemId: "",
            skuId: undefined
        }
    ],
    fullName: null,
    paymentMethod: utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard,
    preSaleId: "",
    purchaseCountChoices: [
        {
            count: 1
        }
    ]
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/template/index.tsx










var LotteryDetailTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onReadyPaymentMethod = param.onReadyPaymentMethod;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref4.routerNames, routerPages = ref4.routerPages, generatePath = ref4.generatePath;
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            defaultBackPage: ((ref = state.preSale) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.status) === utoniq_core_schema/* EventStatus.Published */.N3X.Published ? generatePath(routerPages.ShokufesEventDetail, {
                eventId: (ref5 = (ref2 = state.preSale) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.event) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref5 !== void 0 ? ref5 : "#"
            }) : undefined,
            title: t("title", "先行販売情報詳細")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryDetail
            }),
            state.loading || !state.preSale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_LotteryTitleSkeletonCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryContentSkeletonCell, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_LotteryTitleCell, {
                        title: state.preSale.title
                    }),
                    state.isAppliedUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryAppliedUserCell, {
                        preSaleId: state.preSale.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryContentCell, {
                        preSale: state.preSale
                    }),
                    state.preSale.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MembershipCell_MembershipCell, {
                        preSale: state.preSale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDetailForm, {
                        preSale: state.preSale,
                        originFullNameValue: state.originFullNameValue,
                        paymentSource: state.paymentSource,
                        onSubmit: onSubmit,
                        onReadyPaymentMethod: onReadyPaymentMethod,
                        paymentFees: state.paymentFees,
                        choices: state.choices,
                        isAppliedUser: state.isAppliedUser
                    })
                ]
            })
        ]
    });
};
var template_LotteryTitleCell = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: title
        })
    });
};
var LotteryAppliedUserCell = function(param) {
    var preSaleId = param.preSaleId;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CautionText, {
                type: "error",
                children: t("lotteryAppliedUserNote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 5
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    href: generatePath(routerPages.LotteryApplicationDetail, {
                        preSaleId: preSaleId
                    }),
                    children: t("lotteryApplicationDetail", "抽選応募詳細を確認する")
                })
            })
        ]
    });
};
var template_LotteryTitleSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h4",
            width: "50%"
        })
    });
};
var LotteryContentSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                width: "10%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 3,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 2
                        },
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            numberOfLine: 2,
                            variant: "body2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            borderColor: "grey.100",
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderRadius: 2,
                            px: 4,
                            py: 5,
                            my: 4
                        },
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "25%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "50%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "100%",
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "50%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                ]
            }),
            Array.from(Array(2).keys()).map(function(key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 5,
                        pt: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                py: 1,
                                bgcolor: "grey.50"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                numberOfLine: 3
                            })
                        })
                    ]
                }, key);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                sx: {
                    py: 4
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 244,
                    height: 44,
                    sx: {
                        borderRadius: "34px"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryDetail/index.tsx





/**
 * LotteryDetail Page
 * Implemented as a practical sample.
 */ var LotteryDetail = function() {
    var ref = LotteryDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (state.isRootAuthFailed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Forbidden, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryUserInfo/template/LotteryUserForm.tsx















var LotteryUserForm_schema = function(o) {
    return {
        fullName: (0,validators/* validateFullName */.fy)(o, (0,individual/* individualUseFullNameKatakana */.DV)() ? "lotteryUserInfo.fullNameKatakana" : "lotteryUserInfo.fullName"),
        birthday: o.date().label((0,core_form/* tLabel */.TQ)("lotteryUserInfo.birthday")),
        gender: o.string().label((0,core_form/* tLabel */.TQ)("lotteryUserInfo.gender")).messages({
            "string.empty": (0,core_form/* tMessage */.Sd)("lotteryUserInfo.gender.string.empty")
        }),
        phoneNumber: (0,validators/* validatePhoneNumber */.Y0)(o, "lotteryUserInfo.phoneNumber")
    };
};
var LotteryUserForm = function(param) {
    var user = param.user, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: LotteryUserForm_schema,
        defaultValues: LotteryUserForm_defaultValues
    }), register = ref.register, watch = ref.watch, setValue = ref.setValue, handleSubmit = ref.handleSubmit, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    (0,react.useEffect)(function() {
        if (user) {
            var _fullName, _gender, _birthday, _phoneNumber;
            reset({
                fullName: (_fullName = user.fullName) !== null && _fullName !== void 0 ? _fullName : "",
                gender: (_gender = user.gender) !== null && _gender !== void 0 ? _gender : "",
                birthday: (_birthday = user.birthday) !== null && _birthday !== void 0 ? _birthday : "",
                phoneNumber: (_phoneNumber = user.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : ""
            });
        }
    }, [
        user
    ]);
    var handleOnSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    pb: 4
                },
                children: t("preSaleUserNote", "お客様の情報をご入力ください。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryUserForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.fullName
            }, register("fullName")), {
                titleProps: {
                    children: t((0,individual/* individualUseFullNameKatakana */.DV)() ? "fullNameTitleKatakana" : "fullNameTitle")
                },
                textFieldProps: {
                    placeholder: t((0,individual/* individualUseFullNameKatakana */.DV)() ? "fullNamePlaceholderKatakana" : "fullNamePlaceholder")
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInputCell, {
                value: watch("gender"),
                setValue: setValue,
                error: errors === null || errors === void 0 ? void 0 : errors.gender
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryUserForm_DatePickerCell, {
                error: errors.birthday,
                setValue: setValue,
                value: watch("birthday")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryUserForm_MaskedInputCell, (0,src_object_spread/* default */.Z)({
                type: "tel",
                mask: "00000000000",
                error: errors === null || errors === void 0 ? void 0 : errors.phoneNumber
            }, register("phoneNumber"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                alignItems: "center",
                sx: {
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: isSubmitting,
                    disabled: isSubmitting,
                    onClick: handleOnSubmit,
                    children: t("submit")
                })
            })
        ]
    });
};
var LotteryUserForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var RadioInputCell = function(param) {
    var value = param.value, setValue = param.setValue, error = param.error;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.RadioButtonsGroup, {
            value: value,
            error: error,
            title: "gender",
            t: t,
            sx: {
                flexDirection: "row"
            },
            onChange: function(value) {
                setValue("gender", value, {
                    shouldValidate: true
                });
            },
            listItems: [
                {
                    label: t(utoniq_core_schema/* Gender.Female */.Y0t.Female),
                    value: utoniq_core_schema/* Gender.Female */.Y0t.Female
                },
                {
                    label: t(utoniq_core_schema/* Gender.Male */.Y0t.Male),
                    value: utoniq_core_schema/* Gender.Male */.Y0t.Male
                },
                {
                    label: t(utoniq_core_schema/* Gender.None */.Y0t.None),
                    value: utoniq_core_schema/* Gender.None */.Y0t.None
                }, 
            ]
        })
    });
};
var LotteryUserForm_DatePickerCell = function(param) {
    var setValue = param.setValue, error = param.error, value = param.value;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    var birthdayValue = (0,react.useMemo)(function() {
        return value ? dayjs_min_default()(value) : null;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.DatePickerField, {
            error: error,
            onChange: function(date) {
                setValue("birthday", date, {
                    shouldValidate: true,
                    shouldDirty: true
                });
            },
            value: birthdayValue,
            textFieldProps: {
                inputProps: {
                    value: value ? dayjs_min_default()(value).format("YYYY/MM/DD") : ""
                }
            },
            title: t("birthday"),
            placeholder: t("birthdayPlaceholder"),
            titleProps: {
                variant: "subtitle1",
                color: "text.secondary"
            }
        })
    });
};
var LotteryUserForm_MaskedInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var textFieldProps = _param.textFieldProps, error = _param.error, props = (0,_object_without_properties/* default */.Z)(_param, [
        "textFieldProps",
        "error"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MaskedInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            textFieldProps: textFieldProps,
            ref: ref,
            t: t,
            error: error,
            placeholder: t("".concat(props.name, "Placeholder"))
        }))
    });
});
var LotteryUserForm_defaultValues = {
    fullName: "",
    phoneNumber: "",
    birthday: "",
    gender: ""
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryUserInfo/template/index.tsx







var LotteryUserInfoTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onSendVerificationSMS = param.onSendVerificationSMS, onCloseSMSVerificationModal = param.onCloseSMSVerificationModal;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("lotteryUserInfo").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title", "お客様情報入力")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.LotteryUserInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryUserForm, {
                user: state.user,
                onSubmit: onSubmit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: state.openSMSVerificationModal,
                onClose: onCloseSMSVerificationModal,
                title: t("verifyTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t("verifyDesc", {
                        phoneNumber: (ref = state.user) === null || ref === void 0 ? void 0 : ref.formattedPhoneNumber
                    })
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        minWidth: 212,
                        mt: 4
                    },
                    size: "large",
                    onClick: onSendVerificationSMS,
                    loading: state.sendingVerificationLoading,
                    children: t("verify")
                }),
                cancelText: t("close")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/LotteryUserInfo/viewModel.ts




function LotteryUserInfo_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LotteryUserInfo($id: ID!, $clientId: String, $token: String) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      id\n      lottery {\n        personalInformationRequirements\n      }\n      firstComeFirstServed {\n        personalInformationRequirements\n      }\n    }\n    user {\n      ...UserDeliveryDetail\n    }\n  }\n  ",
        "\n"
    ]);
    LotteryUserInfo_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var LotteryUserInfo_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)(false), openSMSVerificationModal = ref1[0], setOpenSMSVerificationModal = ref1[1];
    var t = (0,core_i18n/* useTranslation */.$G)("").t;
    var data = (0,useQuery/* useQuery */.aM)(LotteryUserInfo_viewModel_QUERY, {
        variables: {
            id: router.query.preSaleId
        }
    }).data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserDeliveryInfo */.p2K), 1), updateUserDeliveryInfo = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdatePersonalInformationSettings */.LR), 1), updateUserInfo = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref4[0], ref5 = ref4[1], sendingVerificationLoading = ref5.loading;
    var ref6;
    return {
        state: {
            user: (ref6 = data === null || data === void 0 ? void 0 : data.user) !== null && ref6 !== void 0 ? ref6 : null,
            openSMSVerificationModal: openSMSVerificationModal,
            sendingVerificationLoading: sendingVerificationLoading
        },
        actions: {
            onSubmit: function onSubmit(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, updatedUserDeliveryInfo, values, personalInformationRequirements;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all([
                                        updateUserDeliveryInfo({
                                            variables: {
                                                updateUserDeliveryInfoInputs: {
                                                    fullName: value.fullName,
                                                    phoneNumber: value.phoneNumber,
                                                    address: {
                                                        postalCode: (ref14 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.postalCode) !== null && ref14 !== void 0 ? ref14 : "",
                                                        prefecture: (ref15 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.prefecture) !== null && ref15 !== void 0 ? ref15 : "",
                                                        city: (ref16 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.address) === null || ref5 === void 0 ? void 0 : ref5.city) !== null && ref16 !== void 0 ? ref16 : "",
                                                        line1: (ref17 = data === null || data === void 0 ? void 0 : (ref6 = data.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.address) === null || ref7 === void 0 ? void 0 : ref7.line1) !== null && ref17 !== void 0 ? ref17 : "",
                                                        line2: (ref18 = data === null || data === void 0 ? void 0 : (ref8 = data.user) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.address) === null || ref9 === void 0 ? void 0 : ref9.line2) !== null && ref18 !== void 0 ? ref18 : ""
                                                    }
                                                }
                                            }
                                        }),
                                        updateUserInfo({
                                            variables: {
                                                inputs: {
                                                    birthday: value.birthday,
                                                    gender: value.gender
                                                }
                                            }
                                        })
                                    ])
                                ];
                            case 1:
                                ref19 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                    _state.sent(),
                                    1
                                ]), updatedUserDeliveryInfo = ref19[0];
                                if (!((ref10 = updatedUserDeliveryInfo.data) === null || ref10 === void 0 ? void 0 : ref10.updateUserDeliveryInfo.isPhoneNumberVerified)) {
                                    return [
                                        2,
                                        setOpenSMSVerificationModal(true)
                                    ];
                                }
                                return [
                                    4,
                                    (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                                ];
                            case 2:
                                values = _state.sent();
                                personalInformationRequirements = (values === null || values === void 0 ? void 0 : values.isFirstComeFirstServed) ? data === null || data === void 0 ? void 0 : (ref11 = data.preSale) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.firstComeFirstServed) === null || ref12 === void 0 ? void 0 : ref12.personalInformationRequirements : (ref13 = data === null || data === void 0 ? void 0 : data.preSale.lottery) === null || ref13 === void 0 ? void 0 : ref13.personalInformationRequirements;
                                if (needToRegisterUserAddress(personalInformationRequirements !== null && personalInformationRequirements !== void 0 ? personalInformationRequirements : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryDeliveryInfo, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                if (values === null || values === void 0 ? void 0 : values.isFirstComeFirstServed) {
                                    return [
                                        2,
                                        router.replace((0,react_router/* generatePath */.Gn)(routerPages.FirstComeFirstServedConfirmation, {
                                            preSaleId: router.query.preSaleId
                                        }))
                                    ];
                                }
                                router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryConfirmation, {
                                    preSaleId: router.query.preSaleId
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCloseSMSVerificationModal: function onCloseSMSVerificationModal() {
                setOpenSMSVerificationModal(false);
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                router.replace(routerPages.SMSVerification);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var LotteryUserInfo_viewModel_QUERY = (0,lib/* gql */.Ps)(LotteryUserInfo_viewModel_templateObject(), utoniq_core_schema/* UserDeliveryDetailFragmentDoc */.TRY);

;// CONCATENATED MODULE: ./src/components/pages/LotteryUserInfo/index.tsx




/**
 * LotteryUserInfo Page
 * Implemented as a practical sample.
 */ var LotteryUserInfo = function() {
    var ref = LotteryUserInfo_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryUserInfoTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuth/template/MailAuthForm.tsx









var MailAuthForm_schema = function(o) {
    return {
        code: o.string().length(6).label((0,core_form/* tLabel */.TQ)("mailAuth.code"))
    };
};
var MailAuthForm = function(param) {
    var loading = param.loading, onSubmitMailAuth = param.onSubmitMailAuth, onResendAuthMail = param.onResendAuthMail;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: MailAuthForm_schema
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onVerify = handleSubmit(onSubmitMailAuth);
    var onReSend = function() {
        return onResendAuthMail().then(function() {
            return showMessage(t("resended"));
        }).catch(function(e) {
            return showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onVerify,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.code
            }, register("code"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm_ButtonCell, {
                loading: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm_ResendButtonCell, {
                onResendAuthMail: onReSend,
                loading: loading
            })
        ]
    });
};
var MailAuthForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            titleProps: {
                sx: {
                    display: "none"
                }
            }
        }))
    });
});
var MailAuthForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var MailAuthForm_ResendButtonCell = function(param) {
    var onResendAuthMail = param.onResendAuthMail, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                textAlign: "right"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                variant: "text",
                onClick: onResendAuthMail,
                loading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("resend")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuth/template/index.tsx






var MailAuthTemplate = function(param) {
    var state = param.state, onResendAuthMail = param.onResendAuthMail, onSubmitMailAuth = param.onSubmitMailAuth;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MailAuth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            py: 2
                        },
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm, {
                        loading: state.loading,
                        onResendAuthMail: onResendAuthMail,
                        onSubmitMailAuth: onSubmitMailAuth
                    })
                ]
            })
        ]
    });
};
var MailAuth_template_SomethingCell = function() {
    return null;
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuth/viewModel.ts









var MailAuth_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var updateEmailSocial = (0,auth/* useAuth */.aC)().updateEmailSocial;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationEmail */.ZCf), 2), sendVerifyEmail = ref1[0], ref2 = ref1[1], verifyEmailSending = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SaveOauthToken */.R3y), 1), saveOauthToken = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* VerifyCode */.WcY), 1), verifyCode = ref4[0];
    return {
        state: {
            loading: verifyEmailSending
        },
        actions: {
            onResendAuthMail: function onResendAuthMail() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var value;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* getMailInput */.IO)()
                                ];
                            case 1:
                                value = _state.sent().value;
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: value !== null && value !== void 0 ? value : ""
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmitMailAuth: function onSubmitMailAuth(param) {
                var code = param.code;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var value, data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* getMailInput */.IO)()
                                ];
                            case 1:
                                value = _state.sent().value;
                                return [
                                    4,
                                    verifyCode({
                                        variables: {
                                            code: code,
                                            email: value !== null && value !== void 0 ? value : ""
                                        }
                                    })
                                ];
                            case 2:
                                data = _state.sent().data;
                                if (!(data === null || data === void 0 ? void 0 : data.verifyCode.verified)) throw new Error(t("verifyFailed"));
                                return [
                                    4,
                                    updateEmailSocial(value !== null && value !== void 0 ? value : "").then(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                        var credential;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        (0,storage/* getCredential */.ir)()
                                                    ];
                                                case 1:
                                                    credential = _state.sent();
                                                    if (!credential || !Object.keys(credential).length) return [
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        saveOauthToken({
                                                            variables: {
                                                                inputs: credential
                                                            }
                                                        })
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })).catch(function(e) {
                                        showError(e);
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* removeMailInput */.FD)()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* removeCredential */.jK)()
                                ];
                            case 5:
                                _state.sent();
                                router.push((config_config/* config */.v === null || config_config/* config */.v === void 0 ? void 0 : config_config/* config.artistId */.v.artistId) ? generatePath(routerPages.ArtistTop, {
                                    artistId: config_config/* config.artistId */.v.artistId
                                }) : routerPages.GlobalHome);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/MailAuth/index.tsx




/**
 * MailAuth Page
 * Implemented as a practical sample.
 */ var MailAuth = function() {
    var ref = MailAuth_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuthArtist/template/MailAuthArtistForm.tsx











var MailAuthArtistForm_schema = function(o) {
    return {
        code: o.string().length(6).label((0,core_form/* tLabel */.TQ)("mailAuthArtist.code"))
    };
};
var MailAuthArtistForm = function(param) {
    var loading = param.loading, onSubmit = param.onSubmit, onResendAuthMail = param.onResendAuthMail;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuthArtist").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages;
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: MailAuthArtistForm_schema
    }), handleSubmit = ref2.handleSubmit, register = ref2.register, setError = ref2.setError, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onVerify = handleSubmit(function(values) {
        return onSubmit(values).then(function() {
            router.push(routerPages.ProfileInputArtist);
        }).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    var onReSend = function() {
        return onResendAuthMail().then(function() {
            return showMessage(t("resended"));
        }).catch(function(e) {
            return showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onVerify,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.code
            }, register("code"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthArtistForm_ResendButtonCell, {
                onResendAuthMail: onReSend,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthArtistForm_ButtonCell, {
                loading: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoEmailReceivedCell, {})
        ]
    });
};
var MailAuthArtistForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuthArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            textFieldProps: {
                sx: {
                    mb: 0
                }
            },
            titleProps: {
                sx: {
                    display: "none"
                }
            }
        }))
    });
});
var MailAuthArtistForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var MailAuthArtistForm_ResendButtonCell = function(param) {
    var onResendAuthMail = param.onResendAuthMail, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                textAlign: "right"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                variant: "text",
                onClick: onResendAuthMail,
                loading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    sx: {
                        color: "primary.main"
                    },
                    children: t("resend")
                })
            })
        })
    });
};
/**
 * 認証メールが届かない場合のリンク表示用セル
 */ var NoEmailReceivedCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("noEmailReceived")).onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            component: "span",
            variant: "subtitle1",
            color: "primary.main",
            sx: {
                fontSize: 14,
                cursor: "pointer"
            },
            onClick: onClick,
            children: t("noEmailReceived")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuthArtist/template/index.tsx






var MailAuthArtistTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onResendAuthMail = param.onResendAuthMail;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuthArtist").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MailAuthArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            py: 2
                        },
                        children: t("desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthArtistForm, {
                        loading: state.loading,
                        onSubmit: onSubmit,
                        onResendAuthMail: onResendAuthMail
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MailAuthArtist/viewModel.ts




function MailAuthArtist_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SignupAsArtist($inputs: SignupAsArtistInput!) {\n    signupAsArtist(inputs: $inputs) {\n      id\n      accountId\n      formattedAccountId @client\n      avatar {\n        uri\n        smallUri\n      }\n      displayName\n    }\n  }\n"
    ]);
    MailAuthArtist_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var MailAuthArtist_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuthArtist").t;
    var ref = (0,auth/* useAuth */.aC)(), loginWithEmail = ref.loginWithEmail, getUserClaims = ref.getUserClaims;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* VerifyCode */.WcY), 1), verifyCode = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationEmail */.ZCf, {
        onCompleted: function onCompleted() {
            showMessage(t("resendCodeSuccess"), "success");
        }
    }), 2), sendVerifyEmail = ref2[0], ref3 = ref2[1], verifyEmailSending = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SignupAsArtist */.E9), 1), signupAsArtist = ref4[0];
    return {
        state: {
            loading: verifyEmailSending
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var code = param.code;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, loginPath, singUpInfo, data, signUpAsArtistInputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* getRedirectAfterLoginPath */.CT)()
                                ];
                            case 1:
                                ref = _state.sent(), loginPath = ref.value;
                                return [
                                    4,
                                    (0,storage/* getInputSignUpArtist */.AD)()
                                ];
                            case 2:
                                singUpInfo = _state.sent();
                                return [
                                    4,
                                    verifyCode({
                                        variables: {
                                            code: code,
                                            email: singUpInfo.email
                                        }
                                    })
                                ];
                            case 3:
                                data = _state.sent().data;
                                if (!(data === null || data === void 0 ? void 0 : data.verifyCode.verified)) throw new Error(t("verifyFailed"));
                                signUpAsArtistInputs = omitBy_default()(singUpInfo, function(v) {
                                    return !v;
                                });
                                return [
                                    4,
                                    signupAsArtist({
                                        variables: {
                                            inputs: signUpAsArtistInputs
                                        }
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    loginWithEmail(singUpInfo.email, singUpInfo.password)
                                ];
                            case 5:
                                _state.sent();
                                // get user claims data
                                return [
                                    4,
                                    getUserClaims()
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* setRedirectAfterLoginPath */.fu)(loginPath !== null && loginPath !== void 0 ? loginPath : "")
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onResendAuthMail: function onResendAuthMail() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var email;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* getInputSignUpArtist */.AD)()
                                ];
                            case 1:
                                email = _state.sent().email;
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: email
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var SIGN_UP_AS_ARTIST = (0,lib/* gql */.Ps)(MailAuthArtist_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/MailAuthArtist/index.tsx




/**
 * MailAuthArtist Page
 * Implemented as a practical sample.
 */ var MailAuthArtist = function() {
    var ref = MailAuthArtist_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthArtistTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MailRegister/template/MailRegisterForm.tsx










var MailRegisterForm_schema = function(o) {
    return {
        email: (0,validators/* validateEmail */.oH)(o, "mailRegister.email")
    };
};
var MailRegisterForm = function(param) {
    var onSubmitMailRegister = param.onSubmitMailRegister;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: MailRegisterForm_schema
    }), handleSubmit = ref.handleSubmit, register = ref.register, setError = ref.setError, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmitMailRegister(values).catch(function(error) {
            return (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleOnSubmit,
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailRegisterForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.email
            }, register("email"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailRegisterForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var MailRegisterForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("mailRegister").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var MailRegisterForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailRegister").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MailRegister/template/index.tsx







var MailRegisterTemplate = function(param) {
    var onSubmitMailRegister = param.onSubmitMailRegister, onLogout = param.onLogout;
    var t = (0,core_i18n/* useTranslation */.$G)("mailRegister").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MailRegister
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            whiteSpace: "nowrap",
                            px: 0,
                            ml: -3,
                            mr: -1
                        },
                        onClick: onLogout,
                        children: t("logout")
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MailRegisterForm, {
                        onSubmitMailRegister: onSubmitMailRegister
                    })
                ]
            })
        ]
    });
};
var template_TextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("mailRegister").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "text.primary",
            children: t("desc", {
                appName: config_config/* config.appName */.v.appName
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MailRegister/viewModel.ts











var MailRegister_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var ref1 = (0,auth/* useAuth */.aC)(), logout = ref1.logout, user = ref1.user;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationEmail */.ZCf), 2), sendVerifyEmail = ref2[0], ref3 = ref2[1], verifyEmailSending = ref3.loading;
    (0,react.useEffect)(function() {
        if (!user) router.push(routerPages.Top);
        if (user === null || user === void 0 ? void 0 : user.email) router.push(routerPages.GlobalHome);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        user === null || user === void 0 ? void 0 : user.email
    ]);
    return {
        state: {
            loading: verifyEmailSending
        },
        actions: {
            sendVerificationMail: function sendVerificationMail(param) {
                var email = param.email;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerifyEmail({
                                        variables: {
                                            email: email
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* setMailInput */.m8)(email)
                                ];
                            case 2:
                                _state.sent();
                                router.push(routerPages.MailAuth);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLogout: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    logout(),
                                    client.clearStore(),
                                    (0,storage/* clearStorage */.B$)()
                                ])
                            ];
                        case 1:
                            _state.sent();
                            router.push(routerPages.Top);
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/MailRegister/index.tsx



/**
 * MailRegister Page
 * Implemented as a practical sample.
 */ var MailRegister = function() {
    var ref = MailRegister_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MailRegisterTemplate, {
        state: state,
        onSubmitMailRegister: actions.sendVerificationMail,
        onLogout: actions.onLogout
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Management/template/index.tsx










var ManagementTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("management").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, routerNames = ref.routerNames;
    var items = (0,react.useMemo)(function() {
        return [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Delivery, {
                    fontSize: "medium"
                }),
                title: t("deliveryManagement"),
                hidden: (0,individual/* individualHideDelivery */.QV)(),
                href: routerPages.DeliveryManagement,
                notificationText: state.hasUnappliedDeliveryItems ? t("deliveryManagementNotification") : ""
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MemberShip, {
                    fontSize: "medium"
                }),
                title: t("membershipManagement"),
                hidden: !config_config/* config.modules.membership */.v.modules.membership,
                href: routerPages.MembershipManagement,
                notificationText: state.isMembershipPersonalInformationRequired ? t("membershipManagementNotification") : ""
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.CartHistory, {
                    fontSize: "medium"
                }),
                title: t("storePurchaseOrders"),
                href: routerPages.StorePurchaseOrders,
                hidden: !config_config/* config.modules.cart */.v.modules.cart
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.PurchaseHistory, {
                    fontSize: "medium"
                }),
                title: t("purchaseHistory"),
                hidden: !config_config/* config.modules.item */.v.modules.item,
                href: routerPages.ItemOrders
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Lottery, {
                    fontSize: "medium"
                }),
                title: t("lotteryApplicants"),
                hidden: !config_config/* config.modules.preSale */.v.modules.preSale,
                href: routerPages.LotteryApplications
            },
            {
                hidden: !config_config/* config.modules.cart */.v.modules.cart && !config_config/* config.modules.preSale */.v.modules.preSale,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Wallet, {
                    fontSize: "medium"
                }),
                title: t("paymentStatuses"),
                href: routerPages.PaymentStatuses,
                notificationText: state.hasWaitingPaymentItems ? t("UnsettledItemListNotification") : ""
            },
            {
                hidden: !config_config/* config.modules.resale */.v.modules.resale,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Resale, {
                    fontSize: "medium"
                }),
                title: t("resale"),
                href: generatePath(routerPages.ResaleManagement),
                notificationText: state.hasWaitingResaleRafflePaymentItems ? t("resaleNote") : ""
            }, 
        ];
    }, [
        t,
        routerPages.DeliveryManagement,
        routerPages.MembershipManagement,
        routerPages.StorePurchaseOrders,
        routerPages.ItemOrders,
        routerPages.LotteryApplications,
        routerPages.PaymentStatuses,
        routerPages.ResaleManagement,
        state.hasUnappliedDeliveryItems,
        state.isMembershipPersonalInformationRequired,
        state.hasWaitingPaymentItems,
        state.hasWaitingResaleRafflePaymentItems,
        generatePath, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                href: routerPages.GlobalHome
            }),
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Management
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: (0,array/* filterHiddenItem */.s)(items).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                sx: {
                                    backgroundColor: "grey.50",
                                    py: 2,
                                    px: 5,
                                    height: {
                                        xs: 52,
                                        md: 56
                                    }
                                },
                                title: item.title,
                                icon: item.icon,
                                href: item.href,
                                primaryTypographyProps: {
                                    variant: "body1"
                                },
                                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "like.tap",
                                    children: item.notificationText
                                })
                            }),
                            item.notificationText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                badgeContent: "",
                                color: "like",
                                sx: {
                                    position: "absolute",
                                    top: "18px",
                                    left: "32px",
                                    width: 12,
                                    height: 12,
                                    transform: "scale(0.9)",
                                    "& > span": {
                                        minWidth: 12,
                                        height: 12,
                                        bgcolor: "like.tap"
                                    }
                                }
                            }),
                            items.length - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                        ]
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Management/viewModel.ts

function Management_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Management {\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n"
    ]);
    Management_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Management_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var data = (0,useQuery/* useQuery */.aM)(Management_viewModel_QUERY).data;
    return {
        state: {
            hasUnappliedDeliveryItems: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.hasUnappliedDeliveryItems),
            hasWaitingPaymentItems: !!(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.hasWaitingPaymentItems),
            hasWaitingResaleRafflePaymentItems: !!(data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.hasWaitingResaleRafflePaymentItems),
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.isMembershipPersonalInformationRequired)
        },
        actions: {}
    };
});
var Management_viewModel_QUERY = (0,lib/* gql */.Ps)(Management_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);

;// CONCATENATED MODULE: ./src/components/pages/Management/index.tsx



var Management = function() {
    var state = Management_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/template/components/ResumePlanButton.tsx











var ResumePlanButton = function(param) {
    var membership = param.membership, resumingSubscription = param.resumingSubscription, currentPlan = param.currentPlan, onResumeSubscription = param.onResumeSubscription;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)(false), openConfirm = ref1[0], setOpenConfirm = ref1[1];
    var handleResumeSubscription = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var _paymentMethod;
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                onResumeSubscription(membership.artist.id, (_paymentMethod = membership.paymentMethod) !== null && _paymentMethod !== void 0 ? _paymentMethod : utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard, {
                    // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                    successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.MembershipManagement)),
                    // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                    cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.MembershipManagement)),
                    // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                    errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.MembershipManagement))
                }).catch(function(e) {
                    (0,core_errors/* captureError */.O)(e, "MembershipTemplate");
                    showError(new Error(t("error")));
                }).finally(function() {
                    // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                    // 画面内で操作が行われてしまうことを防ぐため
                    // キャリア決済の場合はモーダルを閉じない
                    if (!(0,escott/* isCarrierPaymentMethod */.ln)(membership.paymentMethod)) setOpenConfirm(false);
                })
            ];
        });
    }), [
        membership,
        onResumeSubscription,
        showError,
        t
    ]);
    // ステータスの詳細は以下の通り
    // active: 有効
    // closed: 非公開（既存メンバーシップ会員は継続可能）
    // stopped: 停止（既存メンバーシップ会員は翌月自動解約）
    if (membership.type !== "stripe" && membership.type !== "escott" || !currentPlan || currentPlan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Stopped */.DmA.Stopped) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                variant: "contained",
                color: "inherit",
                sx: {
                    width: 240,
                    "&.MuiButtonBase-root:hover": {
                        bgcolor: "grey.50"
                    },
                    bgcolor: "grey.50"
                },
                onClick: function() {
                    return setOpenConfirm(true);
                },
                children: t("resumeUpdate")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirm"),
                content: t("resumeConfirmContent"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    onClick: handleResumeSubscription,
                    loading: resumingSubscription,
                    children: t("resumeSubscription")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/template/components/CancelChangePlanButton.tsx










var CancelChangePlanButton = function(param) {
    var type = param.type, artistId = param.artistId, paymentMethod = param.paymentMethod, cancellingChangeSubscription = param.cancellingChangeSubscription, onCancelChangeSubscription = param.onCancelChangeSubscription;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), openConfirm = ref[0], setOpenConfirm = ref[1];
    var handleCancelChangeSubscription = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!paymentMethod) return [
                2
            ];
            return [
                2,
                onCancelChangeSubscription(artistId, paymentMethod, {
                    // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                    successUrl: "".concat(window.location.origin).concat((0,react_router/* generatePath */.Gn)(routerPages.MembershipManagement)),
                    // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                    cancelUrl: "".concat(window.location.origin).concat((0,react_router/* generatePath */.Gn)(routerPages.MembershipManagement)),
                    // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                    errorUrl: "".concat(window.location.origin).concat((0,react_router/* generatePath */.Gn)(routerPages.MembershipManagement))
                }).catch(function(e) {
                    (0,core_errors/* captureError */.O)(e, "MembershipTemplate");
                    showError(new Error(t("error")));
                }).finally(function() {
                    // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                    // 画面内で操作が行われてしまうことを防ぐため
                    // キャリア決済の場合はモーダルを閉じない
                    if (!(0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) setOpenConfirm(false);
                })
            ];
        });
    }), [
        artistId,
        paymentMethod,
        onCancelChangeSubscription,
        showError,
        t
    ]);
    if (type !== "stripe" && type !== "escott") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                variant: "contained",
                color: "inherit",
                sx: {
                    width: 240,
                    "&.MuiButtonBase-root:hover": {
                        bgcolor: "grey.50"
                    },
                    bgcolor: "grey.50"
                },
                onClick: function() {
                    return setOpenConfirm(true);
                },
                children: t("cancelChangePlan")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirm"),
                content: t("cancelChangeConfirmContent"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    onClick: handleCancelChangeSubscription,
                    loading: cancellingChangeSubscription,
                    disabled: cancellingChangeSubscription,
                    children: t("stopSubscription")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/template/components/ChangePlanButton.tsx












var ChangePlanButton = function(param) {
    var type = param.type, artistId = param.artistId, formattedExpiredAt = param.formattedExpiredAt, diffAmountSubscription = param.diffAmountSubscription, currentPlan = param.currentPlan, upgradePlan = param.upgradePlan, downgradePlan = param.downgradePlan, changingSubscription = param.changingSubscription, onUpgradeSubscriptionPlan = param.onUpgradeSubscriptionPlan, onDowngradeSubscriptionPlan = param.onDowngradeSubscriptionPlan, onPreviewSubscriptionUpdate = param.onPreviewSubscriptionUpdate;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), openConfirm = ref1[0], setOpenConfirm = ref1[1];
    var ref2 = (0,react.useState)(false), openExpiredCardModal = ref2[0], setOpenExpiredCardModal = ref2[1];
    var ref3 = (0,react.useState)(false), openPaymentErrorModal = ref3[0], setOpenPaymentErrorModal = ref3[1];
    var ref4 = (0,react.useState)(false), openRequire3DSecureModal = ref4[0], setOpenRequire3DSecureModal = ref4[1];
    var handleChangeSubscription = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!upgradePlan) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        onUpgradeSubscriptionPlan(upgradePlan.planId, artistId).catch(function(e) {
                            var ref, ref1, ref2;
                            (0,core_errors/* captureError */.O)(e, "MembershipTemplate");
                            switch((ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                /**
           * @description
           * 3Dセキュア認証が必要な場合
           */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                    setOpenRequire3DSecureModal(true);
                                    break;
                                /**
           * @description
           * カードが有効期限切れの場合
           */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                    setOpenExpiredCardModal(true);
                                    break;
                                /**
           * @description
           * 何かしらの決済エラーの場合
           */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                    setOpenPaymentErrorModal(true);
                                    break;
                                default:
                                    showError(new Error(t("error")));
                                    break;
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (!downgradePlan) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        onDowngradeSubscriptionPlan(downgradePlan.planId, artistId).catch(function(e) {
                            (0,core_errors/* captureError */.O)(e, "MembershipTemplate");
                            showError(new Error(t("error")));
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    setOpenConfirm(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        downgradePlan,
        artistId,
        onDowngradeSubscriptionPlan,
        onUpgradeSubscriptionPlan,
        showError,
        t,
        upgradePlan, 
    ]);
    // キャリア決済（type === 'escott'）は月額払いしか対応しておらず
    // 現状決済方法の変更もできないため
    // 同一プロダクト内でのプラン変更は行えない
    // そのため動線となるボタンを非表示にする
    // ref. https://utoniq.slack.com/archives/C089QSPGB27/p1745463830109599
    if (type !== "stripe" || !upgradePlan && !downgradePlan) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                color: "inherit",
                sx: {
                    width: 240,
                    "&.MuiButtonBase-root:hover": {
                        bgcolor: "grey.50"
                    },
                    bgcolor: "grey.50"
                },
                loading: loading,
                disabled: loading,
                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setLoading(true);
                                if (!(upgradePlan === null || upgradePlan === void 0 ? void 0 : upgradePlan.planId)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    onPreviewSubscriptionUpdate(artistId, upgradePlan.planId)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                setOpenConfirm(true);
                                setLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                }),
                children: upgradePlan ? t("upgradePlan") : t("downgradePlan")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirm"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            sx: {
                                pb: 7,
                                textAlign: "left"
                            },
                            children: [
                                upgradePlan && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t("yearCourseConfirmContent", {
                                                amount: numeral_default()(diffAmountSubscription !== null && diffAmountSubscription !== void 0 ? diffAmountSubscription : 0).format("0,0")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("yearCourseConfirmFee", {
                                                amount: upgradePlan.formattedAmount
                                            })
                                        })
                                    ]
                                }),
                                downgradePlan && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t("monthCourseConfirmContent")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("monthCourseConfirmFee", {
                                                amount: downgradePlan === null || downgradePlan === void 0 ? void 0 : downgradePlan.formattedAmount,
                                                date: formattedExpiredAt
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                pb: 8,
                                gap: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseCautionText, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WageSettlementMethodLink, {
                                    variant: "caption"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecificCommercialTransactionLawLink, {
                                    variant: "caption"
                                })
                            ]
                        })
                    ]
                }),
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    disabled: changingSubscription,
                    loading: changingSubscription,
                    onClick: handleChangeSubscription,
                    children: t("change")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: openExpiredCardModal,
                onClose: function() {
                    return setOpenExpiredCardModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: openPaymentErrorModal,
                onClose: function() {
                    return setOpenPaymentErrorModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: openRequire3DSecureModal,
                onClose: function() {
                    return setOpenRequire3DSecureModal(false);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/template/components/CancelPlanButton.tsx








var CancelPlanButton = function(param) {
    var type = param.type, artistId = param.artistId, stoppingSubscription = param.stoppingSubscription, onStopSubscription = param.onStopSubscription;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), openConfirm = ref1[0], setOpenConfirm = ref1[1];
    var handleStopSubscription = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                onStopSubscription(artistId).then(function() {
                    return showMessage(t("complete"));
                }).catch(function(e) {
                    (0,core_errors/* captureError */.O)(e, "MembershipTemplate");
                    showError(new Error(t("error")));
                }).finally(function() {
                    return setOpenConfirm(false);
                })
            ];
        });
    }), [
        artistId,
        onStopSubscription,
        showError,
        showMessage,
        t
    ]);
    if (type !== "stripe" && type !== "escott") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                variant: "outlined",
                color: "inherit",
                sx: {
                    width: 240
                },
                onClick: function() {
                    return setOpenConfirm(true);
                },
                children: t("cancelUpdate")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirm"),
                content: t("confirmContent"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    onClick: handleStopSubscription,
                    loading: stoppingSubscription,
                    disabled: stoppingSubscription,
                    children: t("stopSubscription")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/template/index.tsx
















var MembershipTemplate = function(param) {
    var state = param.state, onStopSubscription = param.onStopSubscription, onUpgradeSubscriptionPlan = param.onUpgradeSubscriptionPlan, onDowngradeSubscriptionPlan = param.onDowngradeSubscriptionPlan, onCancelChangeSubscription = param.onCancelChangeSubscription, onResumeSubscription = param.onResumeSubscription, onPreviewSubscriptionUpdate = param.onPreviewSubscriptionUpdate;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref3.routerNames, router = ref3.router;
    var ref4 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref4.showMessage, showError = ref4.showError;
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // ステータスに応じたトーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        switch(router.query.status){
            case "cancel":
                showMessage(t("carrierCancel"));
                break;
            case "error":
                showError(t("carrierError"));
                break;
            default:
                break;
        }
    }, [
        router.query.status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MembershipManagement
            }),
            state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Membership_template_LoadingCell, {}),
            !state.loading && !((ref = state.memberships) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    my: 3
                },
                children: t("emptyMembershipMessage")
            }),
            !state.loading && !!((ref1 = state.memberships) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanListTitleCell, {}),
                    state.isMembershipPersonalInformationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        pb: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredMembershipInfoBox/* RequiredMembershipInfoBox */.k, {
                            visibleLink: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 5,
                        children: (ref2 = state.memberships) === null || ref2 === void 0 ? void 0 : ref2.map(function(membership) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_MembershipCell, {
                                membership: membership,
                                diffAmountSubscription: state.diffAmountSubscription,
                                stoppingSubscription: state.stoppingSubscription,
                                changingSubscription: state.changingSubscription,
                                cancellingChangeSubscription: state.cancellingChangeSubscription,
                                resumingSubscription: state.resumingSubscription,
                                onStopSubscription: onStopSubscription,
                                onUpgradeSubscriptionPlan: onUpgradeSubscriptionPlan,
                                onDowngradeSubscriptionPlan: onDowngradeSubscriptionPlan,
                                onCancelChangeSubscription: onCancelChangeSubscription,
                                onResumeSubscription: onResumeSubscription,
                                onPreviewSubscriptionUpdate: onPreviewSubscriptionUpdate
                            }, membership.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {
                sx: {
                    mt: 5
                }
            })
        ]
    });
};
var PlanListTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h5",
            color: "text.secondary",
            children: t("planCurrently")
        })
    });
};
/**
 * @description
 * メンバーシップ表示用カード
 */ var template_MembershipCell = function(param) {
    var membership = param.membership, diffAmountSubscription = param.diffAmountSubscription, stoppingSubscription = param.stoppingSubscription, changingSubscription = param.changingSubscription, cancellingChangeSubscription = param.cancellingChangeSubscription, resumingSubscription = param.resumingSubscription, onStopSubscription = param.onStopSubscription, onUpgradeSubscriptionPlan = param.onUpgradeSubscriptionPlan, onDowngradeSubscriptionPlan = param.onDowngradeSubscriptionPlan, onCancelChangeSubscription = param.onCancelChangeSubscription, onResumeSubscription = param.onResumeSubscription, onPreviewSubscriptionUpdate = param.onPreviewSubscriptionUpdate;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,core_i18n/* useTranslation */.$G)("membership").t;
    var ref16;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((ref16 = membership === null || membership === void 0 ? void 0 : (ref = membership.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.pendingPurchasePatron) === null || ref1 === void 0 ? void 0 : ref1.voucherUrl) !== null && ref16 !== void 0 ? ref16 : "").onClick;
    var ref17 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref17.routerPages, generatePath = ref17.generatePath;
    var month = (0,react.useMemo)(function() {
        return values_Date/* DateTime.calculateMonthsSince */.o.calculateMonthsSince(membership === null || membership === void 0 ? void 0 : membership.formattedCreatedAt);
    }, [
        membership
    ]);
    var monthSuffix = month > 1 ? "_other" : "_one";
    var currentProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.planId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref2 = membership.subscription) === null || ref2 === void 0 ? void 0 : ref2.planId
    ]);
    var downgradeProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.downgradePlanId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref3 = membership.subscription) === null || ref3 === void 0 ? void 0 : ref3.downgradePlanId
    ]);
    var upgradeProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.upgradePlanId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref4 = membership.subscription) === null || ref4 === void 0 ? void 0 : ref4.upgradePlanId
    ]);
    var ref18 = (0,react.useMemo)(function() {
        if (!currentProduct) {
            return {
                downgradePlan: undefined,
                upgradePlan: undefined
            };
        }
        if ((currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.plan.interval) === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year) {
            var downgradePlan = currentProduct.plans.filter(function(plan) {
                return plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
            }).find(function(plan) {
                return plan.interval === utoniq_core_schema/* MembershipInterval.Month */.ls9.Month;
            });
            return {
                downgradePlan: downgradePlan,
                upgradePlan: undefined
            };
        }
        var upgradePlan = currentProduct.plans.filter(function(plan) {
            return plan.status === utoniq_core_schema/* MembershipSubscriptionPlanStatus.Active */.DmA.Active;
        }).find(function(plan) {
            return plan.interval === utoniq_core_schema/* MembershipInterval.Year */.ls9.Year;
        });
        return {
            downgradePlan: undefined,
            upgradePlan: upgradePlan
        };
    }, [
        currentProduct
    ]), downgradePlan = ref18.downgradePlan, upgradePlan = ref18.upgradePlan;
    var membershipState = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var pendingPurchasePatron = (ref = membership.artist) === null || ref === void 0 ? void 0 : ref.pendingPurchasePatron;
        if (pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : (ref1 = pendingPurchasePatron.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.membership) === null || ref2 === void 0 ? void 0 : ref2.planId) {
            if ((pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : pendingPurchasePatron.status) === utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment) {
                return "KONBINI_WAITING_PAYMENT";
            }
            return;
        }
        /**
     * キャリア決済でプラン加入中に
     * アーティスト側でキャリア決済オプションが OFF になった場合
     *
     * 【 できること 】
     * ・契約更新
     * ・解約申請
     * ・アップグレード申請中のアップグレード
     * ・ダウングレード申請中のダウングレード
     *
     * 【 できないこと 】
     * ・解約申請のキャンセル
     * ・アップグレード申請
     * ・アップグレード申請中のアップグレード申請キャンセル
     * ・ダウングレード申請
     * ・ダウングレード申請中のダウングレード申請キャンセル
     *
     * ref. https://app.clickup.com/t/908127/UT-20671
     */ if (membership.type === "escott" && !((ref3 = membership.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.carrierPayment) && (membership.cancelAtPeriodEnd || membership.upgradeAtNextPeriod || membership.downgradeAtNextPeriod)) {
            return "CARRIER_INACTIVE";
        }
        if (((ref5 = membership.subscription) === null || ref5 === void 0 ? void 0 : ref5.downgradePlanId) || membership.upgradeAtNextPeriod // 次回更新日にアップグレードする場合
        ) {
            return "CHANGED_PLAN";
        }
        if (membership.cancelAtPeriodEnd) {
            return "RESUME";
        }
        return "ACTIVE";
    }, [
        (ref5 = membership.artist) === null || ref5 === void 0 ? void 0 : ref5.pendingPurchasePatron,
        membership.cancelAtPeriodEnd,
        (ref6 = membership.subscription) === null || ref6 === void 0 ? void 0 : ref6.downgradePlanId, 
    ]);
    var isKonbini = membership.paymentMethod === utoniq_core_schema/* PaymentMethod.Konbini */.XL7.Konbini;
    var ref19, _id, ref20, _formattedExpiredAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2,
                bgcolor: "grey.100"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        component: Link/* default */.Z,
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        sx: {
                            pb: 5,
                            width: "fit-content",
                            textDecoration: "none"
                        },
                        href: generatePath(routerPages.ArtistTop, {
                            artistId: membership.artist.id
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref19 = (ref7 = membership.artist) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.avatar) === null || ref8 === void 0 ? void 0 : ref8.smallUri) !== null && ref19 !== void 0 ? ref19 : "",
                                sx: {
                                    width: 44,
                                    height: 44
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        sx: {
                                            width: "fit-content"
                                        },
                                        children: (ref9 = membership.artist) === null || ref9 === void 0 ? void 0 : ref9.displayName
                                    }),
                                    membership.formattedMembershipNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            width: "fit-content"
                                        },
                                        children: [
                                            "会員番号 ",
                                            membership.formattedMembershipNumber
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "text",
                                    href: generatePath(routerPages.ArtistMembership, {
                                        artistId: membership.artist.id
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "primary.main",
                                        children: t("seeOtherPlans")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("".concat(currentProduct === null || currentProduct === void 0 ? void 0 : (ref10 = currentProduct.plan) === null || ref10 === void 0 ? void 0 : ref10.interval, "Fee"))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: t("amount", {
                                                    amount: currentProduct === null || currentProduct === void 0 ? void 0 : (ref11 = currentProduct.plan) === null || ref11 === void 0 ? void 0 : ref11.formattedAmount
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("updateDate")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: membership === null || membership === void 0 ? void 0 : membership.formattedUpdatedAt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("paymentMethod")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: t((membership === null || membership === void 0 ? void 0 : membership.paymentMethod) || utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        sx: {
                            borderColor: "grey.200"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            py: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.content
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        sx: {
                            borderColor: "grey.200"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            py: 5
                        },
                        justifyContent: "center",
                        children: [
                            membershipState === "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "left",
                                children: t("".concat((membership === null || membership === void 0 ? void 0 : membership.paymentMethod) || utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard, "AutoUpdate").concat(monthSuffix), {
                                    count: month,
                                    expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                                })
                            }),
                            membershipState === "CHANGED_PLAN" && downgradeProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "left",
                                color: "text.hint",
                                children: t("cancelChangeNote", {
                                    productTitle: downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title,
                                    expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                                })
                            }),
                            membershipState === "CHANGED_PLAN" && upgradeProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "left",
                                color: "text.hint",
                                children: t("cancelChangeNote", {
                                    productTitle: upgradeProduct === null || upgradeProduct === void 0 ? void 0 : upgradeProduct.title,
                                    expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                                })
                            }),
                            membershipState === "KONBINI_WAITING_PAYMENT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "left",
                                color: "text.hint",
                                children: t("konbiniJoinedNote")
                            }),
                            (membershipState === "RESUME" || membershipState === "CARRIER_INACTIVE") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                align: "left",
                                color: "error.main",
                                children: t("cancelNote", {
                                    expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        alignItems: "center",
                        sx: {
                            pt: 2
                        },
                        spacing: 2,
                        children: [
                            membershipState === "KONBINI_WAITING_PAYMENT" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: t("paymentDeadlineKonbini")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: membership === null || membership === void 0 ? void 0 : (ref12 = membership.artist) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.pendingPurchasePatron) === null || ref13 === void 0 ? void 0 : ref13.formattedExpiredAt
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "text",
                                        onClick: onClick,
                                        children: t("confirmPayment")
                                    })
                                ]
                            }),
                            membershipState === "RESUME" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResumePlanButton, {
                                membership: membership,
                                resumingSubscription: resumingSubscription,
                                currentPlan: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.plan,
                                onResumeSubscription: onResumeSubscription
                            }),
                            membershipState === "CHANGED_PLAN" && !isKonbini && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelChangePlanButton, {
                                type: membership.type,
                                artistId: membership.artistId,
                                paymentMethod: membership.paymentMethod,
                                cancellingChangeSubscription: cancellingChangeSubscription,
                                onCancelChangeSubscription: onCancelChangeSubscription
                            }),
                            membershipState === "ACTIVE" && (isKonbini ? /**
                 * 支払い方法変更への導線
                 * NOTE:
                 * 支払い方法変更APIについて確認中のため、導線を表示していない
                 * https://app.clickup.com/t/908127/UT-15353
                 */  false && /*#__PURE__*/ 0 : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePlanButton, {
                                        type: membership.type,
                                        artistId: membership.artistId,
                                        diffAmountSubscription: diffAmountSubscription,
                                        formattedExpiredAt: (_formattedExpiredAt = membership.formattedExpiredAt) !== null && _formattedExpiredAt !== void 0 ? _formattedExpiredAt : "",
                                        currentPlan: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.plan,
                                        upgradePlan: upgradePlan,
                                        downgradePlan: downgradePlan,
                                        onPreviewSubscriptionUpdate: onPreviewSubscriptionUpdate,
                                        changingSubscription: changingSubscription,
                                        onUpgradeSubscriptionPlan: onUpgradeSubscriptionPlan,
                                        onDowngradeSubscriptionPlan: onDowngradeSubscriptionPlan
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelPlanButton, {
                                        type: membership.type,
                                        artistId: membership.artistId,
                                        stoppingSubscription: stoppingSubscription,
                                        onStopSubscription: onStopSubscription
                                    }),
                                    (membership === null || membership === void 0 ? void 0 : (ref14 = membership.iapSubscription) === null || ref14 === void 0 ? void 0 : ref14.store) === "app_store" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("cancelAtIOS")
                                    }),
                                    (membership === null || membership === void 0 ? void 0 : (ref15 = membership.iapSubscription) === null || ref15 === void 0 ? void 0 : ref15.store) === "play_store" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("cancelAtAndroid")
                                    })
                                ]
                            }))
                        ]
                    })
                ]
            })
        })
    });
};
/**
 * @todo
 * 別タスクでスケルトンローディング実装
 */ var Membership_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            minHeight: "90dvh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Membership/viewModel.ts




function Membership_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query memberships {\n    user {\n      id\n      isMembershipPersonalInformationRequired\n      organizationPatrons {\n        ...PatronDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Membership_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Membership_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation stopSubscriptionProcess($artistId: ID!) {\n    stopSubscriptionProcess(artistId: $artistId) {\n      __typename\n      ... on Patron {\n        id\n        isPersonalInformationRequired\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Membership_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Membership_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation resumeSubscriptionPlanProcess(\n    $artistId: String!\n    $paymentMethod: PaymentMethod\n    $escottInput: EscottMasterInput\n  ) {\n    resumeSubscriptionPlanProcess(\n      artistId: $artistId\n      paymentMethod: $paymentMethod\n      escottInput: $escottInput\n    ) {\n      __typename\n      ... on Patron {\n        id\n      }\n      ... on EscottMasterResult {\n        nextActionUrl\n        parameter {\n          encryptValue\n          merchantId\n          openID\n          operateId\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Membership_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Membership_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    var ref = (0,useQuery/* useQuery */.aM)(MEMBERSHIPS), loading = ref.loading, data = ref.data;
    var user = (data || {}).user;
    var ref1 = user || {}, memberships = ref1.organizationPatrons;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(utoniq_core_schema/* PreviewSubscriptionUpdate */.uTf), 2), previewSubscriptionUpdate = ref2[0], ref3 = ref2[1], previewSubscriptionUpdateData = ref3.data;
    // 外部キャリア決済画面（escott）へのリダイレクト中かどうかを管理するフラグ
    // mutation の完了から escott フォーム送信までに
    // submit ボタンが活性化してしまうのを防ぐために用いている
    var ref4 = (0,react.useState)(false), isRedirectingToEscott = ref4[0], setIsRedirectingToEscott = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(STOP_SUBSCRIPTION_PROCESS, {
        onCompleted: function onCompleted(param) {
            var stopSubscriptionProcess = param.stopSubscriptionProcess;
            switch(stopSubscriptionProcess.__typename){
                // 追加操作を必要とせず退会処理が完了した場合
                // ステータス更新後の Patron ドキュメントが返却される
                case "Patron":
                    if (stopSubscriptionProcess === null || stopSubscriptionProcess === void 0 ? void 0 : stopSubscriptionProcess.isPersonalInformationRequired) {
                        showModal();
                    }
                    break;
                // escott でのサブスクリプション更新プロセスが必要な場合
                // キャリア決済を想定している
                // 現状はキャリア決済であっても Patron が返ってくるのでここには到達しない見込み
                // ref. https://github.com/utoniq/utoniq-mono/blob/feature/UT-18861/api-parent/packages/utoniq-core/docs/CarrierPayment.md#-stopsubscriptionprocess
                // softbank では検証済みで、au, docomo で検証の上、不要であれば分岐ごと削除してもよい
                // もしも到達することになった場合は、復帰画面にてキャッシュの更新を行う処理を組み込む必要がある
                case "EscottMasterResult":
                    (0,escott/* submitEscottForm */.uF)(stopSubscriptionProcess.nextActionUrl, stopSubscriptionProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), stopSubscriptionProcess = ref5[0], ref6 = ref5[1], stoppingSubscription = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpgradeSubscriptionPlanProcess */.lKk, {
        onCompleted: function onCompleted(param) {
            var upgradeSubscriptionPlanProcess = param.upgradeSubscriptionPlanProcess;
            switch(upgradeSubscriptionPlanProcess.__typename){
                // 追加操作を必要とせず復帰処理が完了した場合
                // ステータス更新後の Patron ドキュメントが返却される
                case "Patron":
                    if (upgradeSubscriptionPlanProcess === null || upgradeSubscriptionPlanProcess === void 0 ? void 0 : upgradeSubscriptionPlanProcess.isPersonalInformationRequired) {
                        showModal();
                    }
                    break;
                // escott でのサブスクリプション更新プロセスが必要な場合
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(upgradeSubscriptionPlanProcess.nextActionUrl, upgradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), upgradeSubscriptionPlanProcess = ref7[0], ref8 = ref7[1], upgradingSubscriptionPlan = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DowngradeSubscriptionPlanProcess */.A1e, {
        onCompleted: function onCompleted(param) {
            var downgradeSubscriptionPlanProcess = param.downgradeSubscriptionPlanProcess;
            switch(downgradeSubscriptionPlanProcess.__typename){
                // 追加手続きが不要なケース
                // ステータスの更新された Patron が返される
                case "Patron":
                    if (downgradeSubscriptionPlanProcess === null || downgradeSubscriptionPlanProcess === void 0 ? void 0 : downgradeSubscriptionPlanProcess.isPersonalInformationRequired) {
                        showModal();
                    }
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(downgradeSubscriptionPlanProcess.nextActionUrl, downgradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), downgradeSubscriptionPlanProcess = ref9[0], ref10 = ref9[1], downgradingSubscriptionPlan = ref10.loading;
    /**
   * プラン変更のキャンセル
   * アップグレードのキャンセルもダウングレードのキャンセルも
   * API の実装としては同一の処理であるため
   * cancelDowngradeSubscriptionPlanProcess を参照している
   * ref. https://utoniq.slack.com/archives/C089QSPGB27/p1747637183291179?thread_ts=1747635734.465719&cid=C089QSPGB27
   */ var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CancelDowngradeSubscriptionPlanProcess */.sH, {
        onCompleted: function onCompleted(param) {
            var cancelDowngradeSubscriptionPlanProcess = param.cancelDowngradeSubscriptionPlanProcess;
            switch(cancelDowngradeSubscriptionPlanProcess.__typename){
                // 追加手続きが不要なケース
                // ステータスの更新された Patron が返される
                case "Patron":
                    break;
                // 外部キャリア決済画面にて追加手続きが必要なケース
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(cancelDowngradeSubscriptionPlanProcess.nextActionUrl, cancelDowngradeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), cancelChangeSubscriptionPlanProcess = ref11[0], ref12 = ref11[1], cancellingChangeSubscription = ref12.loading;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(RESUME_SUBSCRIPTION_PLAN_PROCESS, {
        onCompleted: function onCompleted(param) {
            var resumeSubscriptionPlanProcess = param.resumeSubscriptionPlanProcess;
            switch(resumeSubscriptionPlanProcess.__typename){
                // 追加操作を必要とせず復帰処理が完了した場合
                // ステータス更新後の Patron ドキュメントが返却される
                case "Patron":
                    break;
                // escott でのサブスクリプション更新プロセスが必要な場合
                // キャリア決済を想定している
                case "EscottMasterResult":
                    // 外部のキャリア決済画面へフォーム送信によってリダイレクト
                    // 後続処理が外部画面とバックエンドで実行された後に
                    // ステータスに応じて escottInput で指定した画面に復帰する
                    (0,escott/* submitEscottForm */.uF)(resumeSubscriptionPlanProcess.nextActionUrl, resumeSubscriptionPlanProcess.parameter);
                    break;
                default:
                    break;
            }
        }
    }), 2), resumeSubscriptionPlanProcess = ref13[0], ref14 = ref13[1], resumingSubscription = ref14.loading;
    // 外部キャリア決済画面（escott）からブラウザバックした際
    // リダイレクト中かどうかを管理するフラグをリセットする
    // ブラウザバック時に BFCache が効き再読み込みが走らない環境で
    // ローディング状態が解除されないことを防ぐ
    (0,escott/* useBFCacheRestore */.Hy)(function() {
        setIsRedirectingToEscott(false);
    });
    var _diffAmount;
    return {
        state: {
            loading: loading,
            stoppingSubscription: stoppingSubscription,
            changingSubscription: upgradingSubscriptionPlan || downgradingSubscriptionPlan,
            cancellingChangeSubscription: cancellingChangeSubscription || isRedirectingToEscott,
            resumingSubscription: resumingSubscription || isRedirectingToEscott,
            memberships: memberships,
            isMembershipPersonalInformationRequired: !!(user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired),
            diffAmountSubscription: (_diffAmount = previewSubscriptionUpdateData === null || previewSubscriptionUpdateData === void 0 ? void 0 : previewSubscriptionUpdateData.previewSubscriptionUpdate.diffAmount) !== null && _diffAmount !== void 0 ? _diffAmount : 0
        },
        actions: {
            onPreviewSubscriptionUpdate: function onPreviewSubscriptionUpdate(artistId, planId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    previewSubscriptionUpdate({
                                        variables: {
                                            artistId: artistId,
                                            planId: planId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onStopSubscription: function onStopSubscription(artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    stopSubscriptionProcess({
                                        variables: {
                                            artistId: artistId
                                        },
                                        refetchQueries: function refetchQueries() {
                                            return [
                                                {
                                                    query: MEMBERSHIPS
                                                }
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUpgradeSubscriptionPlan: function onUpgradeSubscriptionPlan(planId, artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    upgradeSubscriptionPlanProcess({
                                        variables: {
                                            planId: planId,
                                            artistId: artistId
                                        },
                                        refetchQueries: function refetchQueries() {
                                            return [
                                                {
                                                    query: MEMBERSHIPS
                                                }
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDowngradeSubscriptionPlan: function onDowngradeSubscriptionPlan(planId, artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    downgradeSubscriptionPlanProcess({
                                        variables: {
                                            planId: planId,
                                            artistId: artistId
                                        },
                                        refetchQueries: function refetchQueries() {
                                            return [
                                                {
                                                    query: MEMBERSHIPS
                                                }
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCancelChangeSubscription: function onCancelChangeSubscription(artistId, paymentMethod, escottInput) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // キャリア決済の場合はローディング状態を表す
                                // state.resumingSubscription に渡している
                                // isRedirectingToEscott を true にする
                                // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                                // submit ボタンが活性化するのを防ぐために行う
                                if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                                    setIsRedirectingToEscott(true);
                                }
                                return [
                                    4,
                                    cancelChangeSubscriptionPlanProcess({
                                        variables: {
                                            artistId: artistId,
                                            paymentMethod: paymentMethod,
                                            escottInput: escottInput
                                        },
                                        refetchQueries: function refetchQueries() {
                                            return [
                                                {
                                                    query: MEMBERSHIPS
                                                }
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onResumeSubscription: function onResumeSubscription(artistId, paymentMethod, escottInput) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // キャリア決済の場合はローディング状態を表す
                                // state.resumingSubscription に渡している
                                // isRedirectingToEscott を true にする
                                // mutation の完了から外部キャリア決済画面に遷移するまでの間に
                                // submit ボタンが活性化するのを防ぐために行う
                                if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) {
                                    setIsRedirectingToEscott(true);
                                }
                                return [
                                    4,
                                    resumeSubscriptionPlanProcess({
                                        variables: {
                                            artistId: artistId,
                                            paymentMethod: paymentMethod,
                                            escottInput: escottInput
                                        },
                                        refetchQueries: function refetchQueries() {
                                            return [
                                                {
                                                    query: MEMBERSHIPS
                                                }
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MEMBERSHIPS = (0,lib/* gql */.Ps)(Membership_viewModel_templateObject(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var STOP_SUBSCRIPTION_PROCESS = (0,lib/* gql */.Ps)(Membership_viewModel_templateObject1(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);
var RESUME_SUBSCRIPTION_PLAN_PROCESS = (0,lib/* gql */.Ps)(Membership_viewModel_templateObject2(), utoniq_core_schema/* PatronDetailFragmentDoc */.wvv);

;// CONCATENATED MODULE: ./src/components/pages/Membership/index.tsx




/**
 * Membership Page
 * Implemented as a practical sample.
 */ var Membership = function() {
    var ref = Membership_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MissionAccomplished/template/index.tsx










var MissionAccomplishedTemplate = function(param) {
    var state = param.state;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    if (!state.mission) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.mission.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.MissionAccomplished
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionAccomplished_template_HeadingTextCell, {
                    mission: state.mission
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageAreaCell, {
                    mission: state.mission
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsCell, {
                    mission: state.mission,
                    isFromArtistMission: state.isFromArtistMission
                })
            ]
        })
    });
};
var MissionAccomplished_template_HeadingTextCell = function(param) {
    var mission = param.mission;
    var t = (0,core_i18n/* useTranslation */.$G)("missionAccomplished").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            direction: "column",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    children: t("completedMessage")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    sx: {
                        pt: 2
                    },
                    children: mission.reward.gachaTicket ? t("getGachaTicket") : t("getItem")
                })
            ]
        })
    });
};
var ItemImageAreaCell = function(param) {
    var mission = param.mission;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var t = (0,core_i18n/* useTranslation */.$G)("missionAccomplished").t;
    var ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            children: mission.reward.gachaTicket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            sx: {
                                width: 108,
                                height: 108,
                                bgcolor: "grey.200",
                                borderRadius: 2
                            },
                            src: (ref12 = (ref = mission.reward.gachaTicket.gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.reward) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref12 !== void 0 ? ref12 : "",
                            children: !((ref2 = mission.reward.gachaTicket.gachaTicket.thumbnails) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reward) === null || ref3 === void 0 ? void 0 : ref3.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                color: "text.hint",
                                children: t("gachaTicketImage")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        sx: {
                            zIndex: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                bgcolor: "grey.100",
                                width: 80,
                                height: 20,
                                borderRadius: 3,
                                textAlign: "center",
                                mt: -2,
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                                variant: "body2",
                                children: [
                                    "x",
                                    mission.reward.gachaTicket.count
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    size: ((ref4 = mission.reward.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.item) === null || ref5 === void 0 ? void 0 : ref5.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.Square */.gy9.Square || ((ref6 = mission.reward.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.item) === null || ref7 === void 0 ? void 0 : ref7.thumbnailType) === utoniq_core_schema/* ItemThumbnailType.SquareTemplate */.gy9.SquareTemplate ? "large-square" : "large",
                    src: (ref13 = (ref8 = mission.reward.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.item) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.thumbnail) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.front) === null || ref11 === void 0 ? void 0 : ref11.smallUri) !== null && ref13 !== void 0 ? ref13 : ""
                })
            })
        })
    });
};
var ButtonsCell = function(param) {
    var mission = param.mission, isFromArtistMission = param.isFromArtistMission;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("missionAccomplished").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var goBackRef = (0,react.useMemo)(function() {
        if (mission.noAnswer) {
            return generatePath(!isFromArtistMission ? routerPages.GlobalHome : routerPages.ArtistTop, {
                artistId: mission.artistId
            });
        }
        return generatePath(!isFromArtistMission ? routerPages.GlobalEvents : routerPages.ArtistMissions, {
            tab: "mission",
            artistId: mission.artistId
        });
    }, [
        generatePath,
        isFromArtistMission,
        mission.artistId,
        mission.noAnswer,
        routerPages.ArtistMissions,
        routerPages.ArtistTop,
        routerPages.GlobalEvents,
        routerPages.GlobalHome, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            direction: "column",
            alignItems: "center",
            children: [
                mission.reward.gachaTicket ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    href: generatePath(routerPages.ArtistGachas, {
                        artistId: mission.artistId
                    }),
                    variant: "contained",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    children: t("turnGacha")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    href: generatePath(routerPages.OwnedItemDetail, {
                        itemId: (ref = mission.reward.item) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.id
                    }),
                    variant: "contained",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    children: t("checkItem")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    href: goBackRef,
                    variant: "outlined",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    children: t(mission.noAnswer ? "retrunTop" : "returnMissionList")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MissionAccomplished/viewModel.ts

function MissionAccomplished_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MissionAccomplished($missionId: ID!) {\n    mission(id: $missionId) {\n      id\n      ...MissionRewardConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MissionAccomplished_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var MissionAccomplished_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var data = (0,useQuery/* useQuery */.aM)(MissionAccomplished_viewModel_QUERY, {
        variables: {
            missionId: router.query.missionId
        }
    }).data;
    var ref;
    return {
        state: {
            isFromArtistMission: !!router.query.artistId || config_config/* config.applicationType */.v.applicationType === "standalone",
            mission: (ref = data === null || data === void 0 ? void 0 : data.mission) !== null && ref !== void 0 ? ref : null
        },
        actions: {}
    };
});
var MissionAccomplished_viewModel_QUERY = (0,lib/* gql */.Ps)(MissionAccomplished_viewModel_templateObject(), utoniq_core_schema/* MissionRewardConnectionFragmentDoc */.vX9);

;// CONCATENATED MODULE: ./src/components/pages/MissionAccomplished/index.tsx



/**
 * MissionAccomplished Page
 * Implemented as a practical sample.
 */ var MissionAccomplished = function() {
    var ref = MissionAccomplished_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionAccomplishedTemplate, {
        state: state
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(69089);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(35936);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(290);
;// CONCATENATED MODULE: ./src/components/organisms/mission/MultipleItemsMission/index.tsx





var MultipleItemsMission = function(param) {
    var item = param.item, sheet = param.sheet, ownedCount = param.ownedCount;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    var ref3, _issuedNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                px: 5,
                py: 3
            },
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    src: (ref3 = (ref = item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : "",
                    size: "x-small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    sx: {
                        pt: 2,
                        minWidth: 0
                    },
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    sx: {
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                children: item.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            children: [
                                                ((ref1 = item.rarityIconImage) === null || ref1 === void 0 ? void 0 : ref1.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    variant: "square",
                                                    src: item.rarityIconImage.smallUri,
                                                    sx: {
                                                        height: 12,
                                                        width: 12
                                                    }
                                                }),
                                                !!((ref2 = item.rarity) === null || ref2 === void 0 ? void 0 : ref2.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: t(item.rarity.name)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                            variant: "h1",
                                            children: sheet
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("sheet")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "flex-end",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("numberOfOwned")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    children: [
                                        ownedCount,
                                        "/",
                                        (_issuedNumber = item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gps/AreaNameChip.tsx



var AreaNameChip = function(param) {
    var areaName = param.areaName, sx = param.sx;
    var t = (0,core_i18n/* useTranslation */.$G)("gps").t;
    return areaName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        variant: "outlined",
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle2",
            children: t("areaName", {
                areaName: areaName
            })
        }),
        sx: sx
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/organisms/gps/AreaStatusChip.tsx




var AreaStatusChip_AreaStatusChip = function(param) {
    var isInside = param.isInside;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            color: isInside ? "primary" : "error",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: "white",
                children: isInside ? t("areaExist") : t("areaNotExist")
            }),
            sx: {
                mb: 2
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/gps/RequestPermissionModal.tsx




var RequestPermissionModal_RequestPermissionModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("gachaDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Spot, {
                    sx: {
                        width: 60,
                        height: 60
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    sx: {
                        py: 3
                    },
                    children: t("permissionModalTitle")
                })
            ]
        }),
        content: t("permissionModalContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                sx: {
                    minWidth: 212
                },
                variant: "text",
                color: "primary",
                size: "large",
                onClick: onClose,
                children: t("close")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MissionDetail/template/RetweetForm.tsx








var RetweetForm_schema = function(o) {
    return {
        tweet: o.string()
    };
};
var RetweetForm_defaultValues = {
    tweet: ""
};
var RetweetForm = function(param) {
    var onSubmitTweet = param.onSubmitTweet;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: RetweetForm_schema,
        defaultValues: RetweetForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, errors = ref1.formState.errors;
    var onSubmit = handleSubmit(function(values) {
        return onSubmitTweet(values).then(function() {
            return showMessage(t("success"));
        }).catch(function(e) {
            return showError(e);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
        id: "retweet-form",
        onSubmit: onSubmit,
        sx: {
            bgcolor: "transparent"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RetweetForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: "text",
            error: errors === null || errors === void 0 ? void 0 : errors.tweet
        }, register("tweet")), {
            textFieldProps: {
                sx: {
                    px: 5,
                    bgcolor: "transparent",
                    mb: 0,
                    pb: 0
                },
                multiline: true,
                minRows: 2,
                variant: "standard",
                helperText: "",
                InputProps: {
                    sx: {
                        border: "none"
                    },
                    disableUnderline: true
                }
            }
        }))
    });
};
var RetweetForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/MissionDetail/template/UserAnswerForm.tsx








var UserAnswerForm_defaultValues = {
    answer: ""
};
var UserAnswerForm = function(param) {
    var onSubmitAnswer = param.onSubmitAnswer, isAnswered = param.isAnswered, content = param.content, noAnswer = param.noAnswer;
    var ref;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var schema = function(o) {
        return {
            answer: noAnswer ? o.any().allow(null).optional() : o.string().label((0,core_form/* tLabel */.TQ)("missionDetail.answer")).max(50)
        };
    };
    var ref1 = (0,core_form/* useForm */.cI)({
        schema: schema,
        defaultValues: UserAnswerForm_defaultValues
    }), handleSubmit = ref1.handleSubmit, register = ref1.register, setError = ref1.setError, errors = ref1.formState.errors;
    var onSubmit = handleSubmit(function(values) {
        return onSubmitAnswer(values).catch(function(error) {
            return (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* Form */.l, {
        id: "user-answer-form",
        onSubmit: onSubmit,
        sx: {
            bgcolor: "none"
        },
        children: !noAnswer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        borderRadius: 2,
                        overflow: "hidden",
                        img: {
                            width: "100%",
                            display: "block"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (ref2 = (ref = content.image) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref2 !== void 0 ? ref2 : "",
                        alt: ""
                    })
                }),
                !isAnswered && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAnswerForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: errors === null || errors === void 0 ? void 0 : errors.answer
                }, register("answer")))
            ]
        })
    });
};
var UserAnswerForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread/* default */.Z)({
            ref: ref,
            t: t,
            textFieldProps: {
                sx: {
                    bgcolor: "inherit"
                },
                InputProps: {
                    sx: {
                        bgcolor: "grey.100"
                    }
                },
                FormHelperTextProps: {
                    sx: {
                        bgcolor: "inherit"
                    }
                }
            }
        }, props))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/MissionDetail/template/index.tsx





















/**
 * ミッション詳細ページ
 * https://zpl.io/VK37r4W
 */ var MissionDetailTemplate = function(param) {
    var state = param.state, onSubmitAnswer = param.onSubmitAnswer, onSubmitTweet = param.onSubmitTweet, onSubmitAnswerItem = param.onSubmitAnswerItem, onFollow = param.onFollow, onCloseModal = param.onCloseModal, onFetchMore = param.onFetchMore, onReply = param.onReply, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onDeleteComment = param.onDeleteComment, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onReplyToReply = param.onReplyToReply, onRemoveReplyToReply = param.onRemoveReplyToReply;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var ref20 = (0,react.useState)(false), showReply = ref20[0], setShowReply = ref20[1];
    var _ref = (state === null || state === void 0 ? void 0 : (ref = state.mission) === null || ref === void 0 ? void 0 : ref.gpsData) || {}, radius = _ref.radius, missionGpsLocation = (0,_object_without_properties/* default */.Z)(_ref, [
        "radius"
    ]);
    var ref21 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref21.routerNames, generatePath = ref21.generatePath, routerPages = ref21.routerPages;
    var replyFormRef = (0,react.useRef)(null);
    var isInside = useIsInside({
        locations: [
            missionGpsLocation,
            state.gpsClientInfo.currentLocation
        ],
        radius: radius
    }).isInside;
    var locationInfo = {
        isInside: isInside,
        permission: state === null || state === void 0 ? void 0 : (ref1 = state.gpsClientInfo) === null || ref1 === void 0 ? void 0 : ref1.permission,
        targetData: state === null || state === void 0 ? void 0 : (ref2 = state.mission) === null || ref2 === void 0 ? void 0 : ref2.gpsData,
        currentData: state === null || state === void 0 ? void 0 : state.gpsClientInfo
    };
    var ref22, ref23, ref24;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref3 = state.mission) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : ref4.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: showReply ? {
                type: "replyForm",
                props: {
                    ref: replyFormRef,
                    onReply: onReply,
                    visibleImage: true,
                    userId: (ref22 = (ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref22 !== void 0 ? ref22 : "",
                    replyToDisplayName: state.replyToDisplayName,
                    onRemoveReplyToReply: onRemoveReplyToReply
                }
            } : undefined,
            header: {
                back: true,
                defaultBackPage: ((ref6 = state.mission) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.artist) === null || ref7 === void 0 ? void 0 : ref7.id) ? config_config/* config.applicationType */.v.applicationType === "standalone" ? generatePath(routerPages.GlobalEvents, {
                    tab: "mission"
                }) : generatePath(routerPages.ArtistMissions, {
                    artistId: (ref23 = (ref8 = state.mission) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.artist) === null || ref9 === void 0 ? void 0 : ref9.id) !== null && ref23 !== void 0 ? ref23 : "#"
                }) : undefined,
                title: (ref24 = (ref10 = state.mission) === null || ref10 === void 0 ? void 0 : ref10.title) !== null && ref24 !== void 0 ? ref24 : ""
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.MissionDetail,
                        (ref11 = state.mission) === null || ref11 === void 0 ? void 0 : ref11.title
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionInfoCell, {
                    mission: state.mission,
                    loading: state.loading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionRewardCell, {
                    mission: state.mission,
                    loading: state.loading,
                    user: state.user
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionLoadingSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        ((ref12 = state.mission) === null || ref12 === void 0 ? void 0 : ref12.type) === utoniq_core_schema/* MissionType.Quiz */.hCl.Quiz && /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionQuizCell, {
                            loading: state.submittingAnswer,
                            isAnswered: state.mission.label !== utoniq_core_schema/* MissionLabel.New */.lH5.New,
                            label: state.mission.label,
                            noAnswer: state.mission.noAnswer,
                            onSubmitAnswer: onSubmitAnswer,
                            content: state.mission.content,
                            isGpsMission: state.isGpsMission,
                            locationInfo: locationInfo
                        }),
                        ((ref13 = state.mission) === null || ref13 === void 0 ? void 0 : ref13.type) === utoniq_core_schema/* MissionType.TwitterRetweet */.hCl.TwitterRetweet && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterRetweetMissionCell, {
                            content: state.mission.content,
                            isLinked: state.isLinked,
                            onSubmitTweet: onSubmitTweet
                        }),
                        ((ref14 = state.mission) === null || ref14 === void 0 ? void 0 : ref14.type) === utoniq_core_schema/* MissionType.TwitterRetweet */.hCl.TwitterRetweet && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterRetweetMissionCell, {
                            content: state.mission.content,
                            isLinked: state.isLinked,
                            onSubmitTweet: onSubmitTweet
                        }),
                        ((ref15 = state.mission) === null || ref15 === void 0 ? void 0 : ref15.type) === utoniq_core_schema/* MissionType.TwitterFollow */.hCl.TwitterFollow && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterFollowMissionCell, {
                            content: state.mission.content,
                            isLinked: state.isLinked,
                            onFollow: onFollow
                        }),
                        ((ref16 = state.mission) === null || ref16 === void 0 ? void 0 : ref16.type) === utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleItemsMissionCell, {
                            loading: state.submittingAnswer,
                            content: state.mission.content,
                            isGpsMission: state.isGpsMission,
                            locationInfo: locationInfo,
                            isAnswered: state.mission.label !== utoniq_core_schema/* MissionLabel.New */.lH5.New,
                            onSubmitAnswerItem: onSubmitAnswerItem
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                    type: "missions",
                    typeId: (ref17 = state.mission) === null || ref17 === void 0 ? void 0 : ref17.id,
                    showReaction: true,
                    onToggleButtonComment: function() {
                        return setShowReply(function(prevState) {
                            return !prevState;
                        });
                    },
                    user: state.user,
                    commentCount: (ref18 = state.mission) === null || ref18 === void 0 ? void 0 : ref18.commentCount,
                    comments: state.comments,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    onDeleteComment: onDeleteComment,
                    onReportUser: onReportUser,
                    onBlockUser: onBlockUser,
                    onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                    onReplyToReply: function(params) {
                        setShowReply(true);
                        onReplyToReply && onReplyToReply(params);
                    },
                    onClickReply: function() {
                        var ref;
                        return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionUnaccomplishedCell, {
                    incorrect: state.incorrect,
                    openModal: state.openModal,
                    onCloseModal: onCloseModal,
                    missionType: (ref19 = state.mission) === null || ref19 === void 0 ? void 0 : ref19.type,
                    sheet: state.sheet
                })
            ]
        })
    });
};
var MissionInfoCell = function(param) {
    var mission = param.mission, loading = param.loading;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionInfoSkeleton, {});
    var _label, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 2,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        wordBreak: "break-all"
                    },
                    children: mission === null || mission === void 0 ? void 0 : mission.description
                }),
                mission && /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionLabel, {
                    sx: {
                        borderRadius: "100px",
                        pr: "12px",
                        pl: "12px",
                        height: "20px"
                    },
                    label: (_label = mission.label) !== null && _label !== void 0 ? _label : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 4
                    },
                    direction: "row",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("period")
                                }),
                                !(mission === null || mission === void 0 ? void 0 : mission.noAnswer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("category")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            orientation: "vertical",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("until", {
                                        date: mission === null || mission === void 0 ? void 0 : mission.formattedExpiredAt
                                    })
                                }),
                                !(mission === null || mission === void 0 ? void 0 : mission.noAnswer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    label: t("".concat(mission === null || mission === void 0 ? void 0 : mission.type)),
                                    size: "small"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    spacing: 3,
                    sx: {
                        pt: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: (ref4 = mission === null || mission === void 0 ? void 0 : (ref = mission.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                            alt: (ref5 = mission === null || mission === void 0 ? void 0 : (ref2 = mission.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName) !== null && ref5 !== void 0 ? ref5 : "",
                            sx: {
                                width: 36,
                                height: 36
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            children: mission === null || mission === void 0 ? void 0 : (ref3 = mission.artist) === null || ref3 === void 0 ? void 0 : ref3.displayName
                        })
                    ]
                })
            ]
        })
    });
};
var MissionRewardCell = function(param) {
    var mission = param.mission, loading = param.loading, user = param.user;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionRewardSkelton, {});
    var isRewardItem = !!(mission === null || mission === void 0 ? void 0 : (ref = mission.reward) === null || ref === void 0 ? void 0 : ref.item);
    var isRewardGacha = !!(mission === null || mission === void 0 ? void 0 : (ref1 = mission.reward) === null || ref1 === void 0 ? void 0 : ref1.gachaTicket);
    var ref22, ref23;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                mt: 4,
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    color: "text.primary",
                    variant: "h6",
                    children: t("missionReward")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        py: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                        sx: {
                            px: 2,
                            boxShadow: "none",
                            "&:last-of-type, &:first-of-type": {
                                borderRadius: 2
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                    fontSize: "medium"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 4,
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        isRewardItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                                    size: "xx-small",
                                                    src: (ref22 = (ref5 = mission === null || mission === void 0 ? void 0 : (ref2 = mission.reward) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.thumbnail.front) === null || ref5 === void 0 ? void 0 : ref5.smallUri) !== null && ref22 !== void 0 ? ref22 : ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: mission === null || mission === void 0 ? void 0 : (ref6 = mission.reward) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.item) === null || ref8 === void 0 ? void 0 : ref8.title
                                                })
                                            ]
                                        }),
                                        isRewardGacha && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    sx: {
                                                        "& > *": {
                                                            height: "48px"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                                        size: "x-small",
                                                        src: (ref23 = mission === null || mission === void 0 ? void 0 : (ref9 = mission.reward) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.gachaTicket) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.gachaTicket) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.thumbnails) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.standard) === null || ref13 === void 0 ? void 0 : ref13.uri) !== null && ref23 !== void 0 ? ref23 : ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "h6",
                                                    children: t("gachaTicket")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    sx: {
                                                        flexGrow: 1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle2",
                                                        children: [
                                                            "x",
                                                            mission === null || mission === void 0 ? void 0 : (ref14 = mission.reward) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.gachaTicket) === null || ref15 === void 0 ? void 0 : ref15.count
                                                        ]
                                                    }),
                                                    size: "small",
                                                    sx: {
                                                        backgroundColor: "gray.200",
                                                        borderRadius: "100px",
                                                        pr: "12px",
                                                        pl: "12px",
                                                        height: "20px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    sx: {
                                                        width: 4
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            mt: -4,
                                            mb: 4
                                        },
                                        children: isRewardGacha ? (ref16 = mission === null || mission === void 0 ? void 0 : mission.reward.gachaTicket) === null || ref16 === void 0 ? void 0 : ref16.gachaTicket.description : mission === null || mission === void 0 ? void 0 : (ref17 = mission.reward) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.item) === null || ref19 === void 0 ? void 0 : ref19.description
                                    }),
                                    isRewardItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            pb: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemAsset, {
                                            user: user,
                                            item: mission === null || mission === void 0 ? void 0 : (ref20 = mission.reward) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.item) === null || ref21 === void 0 ? void 0 : ref21.item
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var GpsMapCell = function(param) {
    var locationInfo = param.locationInfo;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("gps").t;
    var ref2 = (0,react.useState)(false), openMap = ref2[0], setOpenMap = ref2[1];
    var ref3 = (0,react.useState)(false), openRequestPermission = ref3[0], setOpenRequestPermission = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                    sx: {
                        mt: 4,
                        px: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        id: "gps-info-cell",
                        alignItems: "center",
                        sx: {
                            py: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "text.secondary",
                                sx: {
                                    pt: 2,
                                    pb: 3
                                },
                                children: t("gpsDescription")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AreaNameChip, {
                                areaName: locationInfo === null || locationInfo === void 0 ? void 0 : (ref = locationInfo.targetData) === null || ref === void 0 ? void 0 : ref.approximateAddress,
                                sx: {
                                    mt: 1,
                                    mb: 5,
                                    height: "auto"
                                }
                            }),
                            (locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.permission) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AreaStatusChip_AreaStatusChip, {
                                        isInside: locationInfo.isInside
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        onClick: function() {
                                            return setOpenMap(true);
                                        },
                                        sx: {
                                            color: "info.main",
                                            mt: 1,
                                            mb: 5
                                        },
                                        children: t("confirmMap")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        align: "center",
                                        children: t("notGpsPermission")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        sx: {
                                            mt: 4,
                                            mb: 7
                                        },
                                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Window, {
                                            fontSize: "large",
                                            color: "inherit"
                                        }),
                                        onClick: function() {
                                            return (0,native_app/* openSetting */.as)({
                                                webSetting: function() {
                                                    return setOpenRequestPermission(true);
                                                }
                                            });
                                        },
                                        children: t("toSetting")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapModal, {
                targetData: locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.targetData,
                currentData: locationInfo === null || locationInfo === void 0 ? void 0 : (ref1 = locationInfo.currentData) === null || ref1 === void 0 ? void 0 : ref1.currentLocation,
                isInside: locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.isInside,
                open: openMap,
                onClose: function() {
                    return setOpenMap(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestPermissionModal_RequestPermissionModal, {
                open: openRequestPermission,
                onClose: function() {
                    return setOpenRequestPermission(false);
                }
            })
        ]
    });
};
var MissionQuizCell = function(param) {
    var loading = param.loading, isAnswered = param.isAnswered, onSubmitAnswer = param.onSubmitAnswer, content = param.content, locationInfo = param.locationInfo, isGpsMission = param.isGpsMission, noAnswer = param.noAnswer, label = param.label;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                    sx: {
                        mt: 4,
                        px: 5
                    },
                    children: [
                        isGpsMission && /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapCell, {
                            locationInfo: locationInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAnswerForm, {
                            isAnswered: isAnswered,
                            onSubmitAnswer: onSubmitAnswer,
                            content: content,
                            noAnswer: noAnswer
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAreaCell, {
                loading: loading,
                disabled: isAnswered || isGpsMission && !(locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.isInside),
                label: t(label === utoniq_core_schema/* MissionLabel.Expired */.lH5.Expired ? "expired" : noAnswer ? "acquire" : "answer"),
                form: "user-answer-form",
                type: "submit"
            })
        ]
    });
};
var TwitterRetweetMissionCell = function(param) {
    var content = param.content, isLinked = param.isLinked, onSubmitTweet = param.onSubmitTweet;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                    sx: {
                        mt: 4,
                        pb: 5,
                        px: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            borderRadius: 2,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    sx: {
                                        width: 36,
                                        height: 36
                                    },
                                    src: (ref3 = (ref = content.twitterProfileImage) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : ""
                                }),
                                action: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Twitter, {
                                    fontSize: "medium"
                                }),
                                title: content.twitterName,
                                subheader: content.twitterUserName,
                                sx: {
                                    px: 5,
                                    pt: 5,
                                    pb: 0
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                sx: {
                                    p: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RetweetForm, {
                                    onSubmitTweet: onSubmitTweet
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                                component: "img",
                                height: "197",
                                image: (ref4 = (ref1 = content.image) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                                sx: {
                                    px: 5,
                                    pt: 5,
                                    pb: 4
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                                sx: {
                                    mx: 5,
                                    borderWidth: 1,
                                    bgcolor: "grey.50",
                                    borderColor: "grey.100",
                                    borderStyle: "solid",
                                    borderRadius: 2,
                                    boxShadow: "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                        avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            sx: {
                                                width: 36,
                                                height: 36
                                            },
                                            src: (ref5 = (ref2 = content.twitterProfileImage) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref5 !== void 0 ? ref5 : ""
                                        }),
                                        title: content.twitterName,
                                        subheader: content.twitterUserName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                        sx: {
                                            pt: 0,
                                            pb: 4,
                                            px: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: content.tweetText
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                                sx: {
                                    px: 5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.hint",
                                    children: content.tweetCreatedAt
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAreaCell, {
                label: isLinked ? t("verification") : t("workWithTwitter"),
                form: "retweet-form",
                type: "submit"
            })
        ]
    });
};
var TwitterFollowMissionCell = function(param) {
    var content = param.content, isLinked = param.isLinked, onFollow = param.onFollow;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    var ref1, _twitterName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                    sx: {
                        mt: 4,
                        pb: 5,
                        px: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            borderRadius: 4,
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                sx: {
                                    px: 5,
                                    pt: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                src: (ref1 = (ref = content.twitterProfileImage) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                                                title: (_twitterName = content.twitterName) !== null && _twitterName !== void 0 ? _twitterName : "",
                                                sx: {
                                                    width: 64,
                                                    height: 64
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h5",
                                                sx: {
                                                    pt: 2
                                                },
                                                children: content.twitterName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                color: "text.hint",
                                                children: content.twitterUserName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        direction: "row",
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Twitter, {
                                            fontSize: "medium"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                sx: {
                                    p: 5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: content.twitterDescription
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAreaCell, {
                label: isLinked ? t("verification") : t("workWithTwitter"),
                onClick: onFollow,
                type: "button"
            })
        ]
    });
};
var MultipleItemsMissionCell = function(param) {
    var loading = param.loading, content = param.content, locationInfo = param.locationInfo, isGpsMission = param.isGpsMission, isAnswered = param.isAnswered, onSubmitAnswerItem = param.onSubmitAnswerItem;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 5,
                px: 5
            },
            children: [
                isGpsMission && /*#__PURE__*/ (0,jsx_runtime.jsx)(GpsMapCell, {
                    locationInfo: locationInfo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    children: (ref = content.items) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleItemsMission, {
                            item: item.item,
                            ownedCount: item.ownedCount,
                            sheet: item.requiredCount
                        }, item.item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 6
                    },
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 244
                        },
                        disabled: isAnswered || loading,
                        loading: loading,
                        onClick: onSubmitAnswerItem,
                        children: t("toEarn")
                    })
                })
            ]
        })
    });
};
var ButtonAreaCell = function(_param) {
    var label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label"
    ]);
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 6,
            display: "grid",
            placeItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            size: "large",
            sx: {
                minWidth: 244
            }
        }, props), {
            onClick: handleLoginModal(props === null || props === void 0 ? void 0 : props.onClick),
            children: label
        }))
    });
};
var MissionUnaccomplishedCell = function(param) {
    var incorrect = param.incorrect, _openModal = param.openModal, openModal = _openModal === void 0 ? false : _openModal, onCloseModal = param.onCloseModal, missionType = param.missionType, sheet = param.sheet;
    var t = (0,core_i18n/* useTranslation */.$G)("missionDetail").t;
    if (missionType === utoniq_core_schema/* MissionType.ItemCollect */.hCl.ItemCollect) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
            open: openModal,
            onClose: onCloseModal,
            title: t("noItemConfirmTitle"),
            content: t("noItemConfirmDesc", {
                number: sheet
            }),
            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "large",
                sx: {
                    width: 212
                },
                onClick: onCloseModal,
                children: t("ok")
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: openModal,
        onClose: onCloseModal,
        sx: {
            textAlign: "center",
            borderRadius: 3
        },
        PaperProps: {
            sx: {
                width: incorrect ? 335 : 280,
                bgcolor: "grey.100",
                backgroundImage: "unset"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                sx: {
                    pt: incorrect ? 5 : 7
                },
                children: incorrect ? t("inCorrectAnswer") : t("conditionError")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                sx: {
                    pb: 7
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: incorrect ? t("tryAgain") : t("errorMessage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: onCloseModal,
                        fullWidth: true,
                        sx: incorrect ? {
                            mt: 6,
                            width: 244
                        } : {
                            mt: 7,
                            width: 212
                        },
                        variant: "outlined",
                        size: "large",
                        children: t("close")
                    })
                ]
            })
        ]
    });
};
var MissionLoadingSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    mt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    height: 335,
                    sx: {
                        bgcolor: "grey.100"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 6
                },
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 244,
                    height: 44,
                    sx: {
                        py: 3,
                        px: 4,
                        color: "text.disabled",
                        borderRadius: "34px",
                        bgcolor: "grey.100"
                    }
                })
            })
        ]
    });
};
var MissionInfoSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            px: 5,
            py: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "medium",
                numberOfLine: 3,
                lastWidth: "75%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                sx: {
                    mt: "44px"
                },
                variant: "small",
                numberOfLine: 1,
                lastWidth: "75%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "50%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    mb: 0,
                    mt: 5
                },
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        sx: {
                            width: 36,
                            height: 36,
                            bgcolor: "grey.100"
                        },
                        variant: "circular"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        sx: {
                            ml: 3
                        },
                        variant: "small",
                        numberOfLine: 1,
                        lastWidth: "25%"
                    })
                ]
            })
        ]
    });
};
// @todo check design
var MissionRewardSkelton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            px: 5,
            py: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "medium",
                numberOfLine: 1,
                lastWidth: "75%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                sx: {
                    width: 36,
                    height: 36,
                    bgcolor: "grey.100"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MissionDetail/viewModel.ts





function MissionDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MissionDetail($missionId: ID!, $pageInput: PageInput) {\n    mission(id: $missionId) {\n      ...MissionDetail\n      reward {\n        item {\n          item {\n            id\n            title\n            description\n            type\n            hideSalesNumber\n            rarity {\n              id\n              name\n            }\n            rarityIconImage {\n              uri\n              smallUri\n            }\n            issuedNumber\n            thumbnail {\n              front {\n                uri\n                smallUri\n              }\n            }\n          }\n        }\n        gachaTicket {\n          count\n          gachaTicket {\n            id\n            name\n            description\n            thumbnails {\n              standard {\n                uri\n              }\n            }\n          }\n        }\n      }\n      comments(pageInput: $pageInput) {\n        ...CommentsConnection\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      email\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    MissionDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AnswerQuizMission(\n    $answerQuizMissionMissionId: String!\n    $answerQuizMissionAnswer: String!\n  ) {\n    answerQuizMission(\n      missionId: $answerQuizMissionMissionId\n      answer: $answerQuizMissionAnswer\n    ) {\n      ...QuizResultConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MissionDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AnswerItemCollectMission($missionId: String!) {\n    answerItemCollectMission(missionId: $missionId) {\n      missionId\n      correct\n      lackItems {\n        itemId\n        requiredCount\n        item {\n          id\n          title\n          hideSalesNumber\n        }\n      }\n      mission {\n        id\n        artist {\n          id\n        }\n        isAccomplished\n      }\n    }\n  }\n"
    ]);
    MissionDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateMissionComment($id: String!, $inputs: CommunityCommentInput!) {\n    createMissionComment(id: $id, inputs: $inputs) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    MissionDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikeMissionComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    likeMissionComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    MissionDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikeMissionComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    unlikeMissionComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    MissionDetail_viewModel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MissionDetail_viewModel_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteMissionComment($id: String!, $commentId: String!) {\n    deleteMissionComment(id: $id, commentId: $commentId) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    MissionDetail_viewModel_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var MissionDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, routerPages = ref6.routerPages, generatePath = ref6.generatePath;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref7 = (0,react.useState)(false), openModal = ref7[0], setOpenModal = ref7[1];
    var ref8 = (0,react.useState)(false), incorrect = ref8[0], setIncorrect = ref8[1];
    var ref9 = (0,react.useState)(), sheet = ref9[0], setSheet = ref9[1];
    var ref10 = useReplyToComment(), _data = ref10.data, replyToDisplayName = _data.replyToDisplayName, replyToAccountId = _data.replyToAccountId, replyToCommentId = _data.replyToCommentId, onReplyToReply = ref10.onReplyToReply, onRemoveReplyToReply = ref10.onRemoveReplyToReply;
    var ref11 = (0,useQuery/* useQuery */.aM)(MissionDetail_viewModel_QUERY, {
        variables: {
            missionId: router.query.missionId
        },
        returnPartialData: true
    }), data = ref11.data, loading = ref11.loading, fetchMore = ref11.fetchMore, refetch = ref11.refetch;
    var ref12 = useLocationWatcher(), permission = ref12.permission, currentLocation = ref12.currentLocation, requestPermission = ref12.requestPermission, watch = ref12.watch, unwatch = ref12.unwatch;
    (0,react.useEffect)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.gpsData)) return;
        requestPermission().catch(showError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.gpsData,
        requestPermission
    ]);
    (0,react.useEffect)(function() {
        if (!permission) return;
        watch().catch(showError);
        return function() {
            unwatch().catch(showError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        permission,
        unwatch,
        watch
    ]);
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ANSWER_QUIZ_MISSION, {
        onCompleted: function onCompleted(data) {
            if (!(data === null || data === void 0 ? void 0 : data.answerQuizMission.correct)) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_incorrect", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    missionId: router.query.missionId,
                    artistId: data === null || data === void 0 ? void 0 : data.answerQuizMission.mission.artist.id
                });
                setOpenModal(true);
                return;
            }
            analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_correct", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                missionId: router.query.missionId,
                artistId: data === null || data === void 0 ? void 0 : data.answerQuizMission.mission.artist.id
            });
            return router.push(router.query.artistId ? generatePath(routerPages.ArtistMissionAccomplished, {
                missionId: router.query.missionId,
                artistId: router.query.artistId
            }) : generatePath(routerPages.MissionAccomplished, {
                missionId: router.query.missionId
            }));
        }
    }), 2), submitAnswer = ref13[0], ref14 = ref13[1], submittingAnswer = ref14.loading;
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ANSWER_ITEM_COLLECT_MISSION, {
        onCompleted: function onCompleted(data) {
            if (!(data === null || data === void 0 ? void 0 : data.answerItemCollectMission.correct)) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_incorrect", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    missionId: router.query.missionId,
                    artistId: data === null || data === void 0 ? void 0 : data.answerItemCollectMission.mission.artist.id
                });
                var _lackItems, ref;
                var requiredCount = (ref = sumBy_default()((_lackItems = data === null || data === void 0 ? void 0 : data.answerItemCollectMission.lackItems) !== null && _lackItems !== void 0 ? _lackItems : [], "requiredCount")) !== null && ref !== void 0 ? ref : 0;
                setSheet(requiredCount);
                setOpenModal(true);
                return;
            }
            analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_correct", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                missionId: router.query.missionId,
                artistId: data === null || data === void 0 ? void 0 : data.answerItemCollectMission.mission.artist.id
            });
            return router.push(router.query.artistId ? generatePath(routerPages.ArtistMissionAccomplished, {
                missionId: data.answerItemCollectMission.missionId,
                artistId: router.query.artistId
            }) : generatePath(routerPages.MissionAccomplished, {
                missionId: data.answerItemCollectMission.missionId
            }));
        }
    }), 2), answerItemCollectMission = ref15[0], ref16 = ref15[1], submittingAnswerItemCollect = ref16.loading;
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_MISSION_COMMENT), 1), createMissionComment = ref17[0];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_MISSION_COMMENT), 1), likeMissionComment = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_MISSION_COMMENT), 1), unlikeMissionComment = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_MISSION_COMMENT), 1), deleteMissionComment = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref21[0];
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : data.mission);
    var ref22, ref23, ref24;
    return {
        state: {
            loading: loading && !isNextFetch,
            submittingAnswer: submittingAnswer || submittingAnswerItemCollect,
            openModal: openModal,
            sheet: sheet,
            incorrect: incorrect,
            disabledItem: true,
            user: (ref22 = data === null || data === void 0 ? void 0 : data.user) !== null && ref22 !== void 0 ? ref22 : null,
            comments: (ref23 = data === null || data === void 0 ? void 0 : (ref1 = data.mission) === null || ref1 === void 0 ? void 0 : ref1.comments) !== null && ref23 !== void 0 ? ref23 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref2 = data.mission) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.comments) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage),
            mission: (ref24 = data === null || data === void 0 ? void 0 : data.mission) !== null && ref24 !== void 0 ? ref24 : null,
            isLinked: false,
            gpsClientInfo: {
                permission: permission,
                currentLocation: currentLocation
            },
            isGpsMission: !!(data === null || data === void 0 ? void 0 : (ref5 = data.mission) === null || ref5 === void 0 ? void 0 : ref5.gpsData),
            replyToDisplayName: replyToDisplayName
        },
        actions: {
            onSubmitAnswer: function onSubmitAnswer(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_answerMission", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    missionId: router.query.missionId,
                                    artistId: data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id
                                });
                                setIncorrect(true);
                                return [
                                    4,
                                    submitAnswer({
                                        variables: {
                                            answerQuizMissionMissionId: router.query.missionId,
                                            answerQuizMissionAnswer: values.answer
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSubmitTweet: function onSubmitTweet() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onSubmitAnswerItem: function onSubmitAnswerItem() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    answerItemCollectMission({
                                        variables: {
                                            missionId: router.query.missionId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFollow: function onFollow() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onCloseModal: function onCloseModal() {
                setOpenModal(false);
            },
            onReplyToReply: onReplyToReply,
            onRemoveReplyToReply: onRemoveReplyToReply,
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            missionId: router.query.missionId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor,
                                                limit: 30
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReply: function onReply(inputs) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, _id;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createMissionComment({
                                        variables: {
                                            id: router.query.missionId,
                                            inputs: (0,src_object_spread/* default */.Z)({
                                                artistId: (_id = data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id) !== null && _id !== void 0 ? _id : "",
                                                replyToId: replyToCommentId,
                                                replyToAccountId: replyToAccountId
                                            }, inputs)
                                        }
                                    }).then(function() {
                                        var ref;
                                        var _id;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            missionId: router.query.missionId,
                                            artistId: (_id = data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id) !== null && _id !== void 0 ? _id : "",
                                            name: "missionDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                onRemoveReplyToReply();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeOrUnlikeComment: function onLikeOrUnlikeComment(param) {
                var isLike = param.isLike, commentId = param.commentId, id = param.id, likeCount = param.likeCount;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikeMissionComment({
                                        variables: {
                                            inputs: {
                                                commentId: commentId,
                                                id: id !== null && id !== void 0 ? id : router.query.missionId
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var commentId = param.inputs.commentId;
                                            return {
                                                unlikeMissionComment: {
                                                    __typename: "Comment",
                                                    id: commentId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_unlikeComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            missionId: router.query.missionId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id,
                                            name: "missionDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likeMissionComment({
                                        variables: {
                                            inputs: {
                                                commentId: commentId,
                                                id: id !== null && id !== void 0 ? id : router.query.missionId
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var commentId = param.inputs.commentId;
                                            return {
                                                likeMissionComment: {
                                                    __typename: "Comment",
                                                    id: commentId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_likeComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            missionId: router.query.missionId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id,
                                            name: "missionDetail"
                                        });
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteComment: function onDeleteComment(commentId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteMissionComment({
                                        variables: {
                                            commentId: commentId,
                                            id: router.query.missionId
                                        }
                                    }).then(function() {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_deleteComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            missionId: router.query.missionId,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.mission) === null || ref === void 0 ? void 0 : ref.artist.id,
                                            name: "missionDetail"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.email) !== null && ref1 !== void 0 ? ref1 : "",
                                        contentType: "mission-comments",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        missionId: router.query.missionId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MissionDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject(), utoniq_core_schema/* CommentsConnectionFragmentDoc */.M6M, utoniq_core_schema/* MissionDetailFragmentDoc */.RsL);
var UPDATE_ANSWER_QUIZ_MISSION = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject1(), utoniq_core_schema/* QuizResultConnectionFragmentDoc */.e1O);
var UPDATE_ANSWER_ITEM_COLLECT_MISSION = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject2());
var CREATE_MISSION_COMMENT = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject3(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var LIKE_MISSION_COMMENT = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject4());
var UNLIKE_MISSION_COMMENT = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject5());
var DELETE_MISSION_COMMENT = (0,lib/* gql */.Ps)(MissionDetail_viewModel_templateObject6(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);

;// CONCATENATED MODULE: ./src/components/pages/MissionDetail/index.tsx




/**
 * MissionDetail Page
 * Implemented as a practical sample.
 */ var MissionDetail = function() {
    var ref = MissionDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MissionDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTickets/template/index.tsx











var MyOwnedTicketsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTickets").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t(state.isHistory ? "titleHistory" : "title")
        },
        children: [
            !state.isHistory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "flex-end",
                flex: 1,
                sx: {
                    py: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    variant: "subtitle1",
                    href: generatePath(routerPages.MyOwnedTicketsHistory, {
                        eventId: router.query.eventId
                    }),
                    children: t("titleHistory", "過去の受け取り商品")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTickets_template_FilterMenu, {
                type: state.type,
                onFilter: onFilter,
                isHistory: state.isHistory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTicketCell, {
                type: state.type,
                pickupUsers: state.pickupUsers,
                loading: state.loading || state.refetching,
                event: state.event,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore
            })
        ]
    });
};
var MyOwnedTicketCell = function(param) {
    var pickupUsers = param.pickupUsers, event = param.event, loading = param.loading, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore, type = param.type;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTickets").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    py: 2
                },
                children: event === null || event === void 0 ? void 0 : event.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: pickupUsers === null || pickupUsers === void 0 ? void 0 : pickupUsers.edges.map(function(param, index) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedTicket, {
                        pickupUser: node,
                        index: index
                    }, index);
                }),
                emptyMessage: t("myOwnedTicketEmptyMessage.".concat(type)),
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedTicketSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedTicketSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedTicketSkeleton, {})
                    ]
                })
            })
        ]
    });
};
var OwnedTicket = function(param) {
    var pickupUser = param.pickupUser, index = param.index;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTickets").t;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref7.generatePath, routerPages = ref7.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var remainingTime = (0,react.useMemo)(function() {
        if (!pickupUser.pickupRemainingTime) return null;
        var _pickupRemainingTime = pickupUser.pickupRemainingTime, hours = _pickupRemainingTime.hours, minutes = _pickupRemainingTime.minutes, expiring = _pickupRemainingTime.expiring;
        var remainingTime = hours || minutes ? [
            hours && hours > 0 ? "".concat(hours).concat(t("time")) : "",
            minutes > 0 ? "".concat(minutes).concat(t("minute")) : "", 
        ].join("") : 1;
        return expiring ? t("countDownTime", {
            remainingTime: remainingTime
        }) : t("countDownTimeUntilPickupStart", {
            remainingTime: remainingTime
        });
    }, [
        pickupUser.pickupRemainingTime,
        t
    ]);
    if (!((ref = pickupUser.eventCollection) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.id)) return null;
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.MyOwnedTicketDetail, {
                    eventId: pickupUser.event.id,
                    collectionId: pickupUser.eventCollection.collection.id,
                    pickupUserId: pickupUser.id
                }),
                onClick: function() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                        artistId: pickupUser.eventCollection.collection.artistId,
                        eventId: pickupUser.event.id,
                        collectionId: pickupUser.eventCollection.collection.id,
                        name: "eventPickup"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    variant: "square",
                                    src: (ref8 = (ref2 = pickupUser.eventCollection.collection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.uri) !== null && ref8 !== void 0 ? ref8 : "",
                                    sx: {
                                        width: 72,
                                        height: 72
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            sx: {
                                                pb: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptTag, {
                                                    receipted: !!pickupUser.isCompleted,
                                                    expired: !!pickupUser.isExpired
                                                }),
                                                remainingTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Notice, {
                                                            fontSize: "xSmall",
                                                            sx: {
                                                                color: ((ref4 = pickupUser.pickupRemainingTime) === null || ref4 === void 0 ? void 0 : ref4.expiring) ? "like.tap" : "primary.main"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            sx: {
                                                                color: ((ref5 = pickupUser.pickupRemainingTime) === null || ref5 === void 0 ? void 0 : ref5.expiring) ? "like.tap" : "primary.main"
                                                            },
                                                            children: remainingTime
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: (ref6 = pickupUser.eventCollection.collection) === null || ref6 === void 0 ? void 0 : ref6.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                pt: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: t("pickupTime", "受け取り時間：")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: pickupUser.formattedPickupStartEndTime
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: t("pickupLocation", "受け取り場所：")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "overline",
                                                            color: "text.secondary",
                                                            children: pickupUser.eventCollection.pickupLocation
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                mt: 4,
                                bgcolor: "grey.100",
                                borderRadius: 1,
                                px: 4,
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("items", "商品内容")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    children: pickupUser.itemsString
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var OwnedTicketSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 90,
                                    height: 64
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            spacing: 2,
                                            sx: {
                                                pb: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "medium"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 3,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "small",
                                                        width: "80%"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "subtitle1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                pt: 1
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "caption",
                                                width: "60%"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                mt: 4,
                                bgcolor: "grey.100",
                                borderRadius: 1,
                                px: 4,
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "20%",
                                    sx: {
                                        bgcolor: "grey.200"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "75%",
                                    sx: {
                                        bgcolor: "grey.200"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var ReceiptTag = function(param) {
    var receipted = param.receipted, expired = param.expired;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTickets").t;
    var ref = (0,react.useMemo)(function() {
        if (expired) {
            return {
                label: t("expired"),
                color: "text.secondary",
                bgcolor: "grey.100",
                variant: "filled",
                disabled: false
            };
        }
        if (receipted) {
            return {
                label: t("isCompleted"),
                color: "text.disabled",
                variant: "outlined"
            };
        }
        return {
            label: t("isNotCompleted"),
            color: "white",
            bgcolor: "primary.main",
            variant: "filled"
        };
    }, [
        expired,
        receipted,
        t
    ]), label = ref.label, color = ref.color, bgcolor = ref.bgcolor, variant = ref.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        size: "small",
        variant: variant,
        sx: {
            height: 20,
            borderRadius: "2px",
            bgcolor: bgcolor,
            py: 1,
            ".MuiChip-label": {
                px: 1
            }
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            color: color,
            variant: "subtitle2",
            sx: {
                whiteSpace: "nowrap"
            },
            children: label
        })
    });
};
var MyOwnedTickets_template_FilterMenu = function(param) {
    var type = param.type, onFilter = param.onFilter, isHistory = param.isHistory;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTickets").t;
    var handleSelect = (0,react.useCallback)(onFilter, [
        onFilter
    ]);
    var tags = isHistory ? [
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.All */.GNT.All,
            label: t("all")
        },
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.Used */.GNT.Used,
            label: t("used")
        },
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.Expired */.GNT.Expired,
            label: t("expired")
        }, 
    ] : [
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.All */.GNT.All,
            label: t("all")
        },
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.Unused */.GNT.Unused,
            label: t("unused")
        },
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.Used */.GNT.Used,
            label: t("used")
        },
        {
            value: utoniq_core_schema/* UserPickupTicketStatus.Expired */.GNT.Expired,
            label: t("expired")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
        value: type,
        onClick: handleSelect,
        tags: tags
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketDetail/template/index.tsx
















var MyOwnedTicketDetailTemplate = function(param) {
    var state = param.state, onUseTicket = param.onUseTicket;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title")
        },
        children: [
            (state === null || state === void 0 ? void 0 : (ref = state.pickupUser) === null || ref === void 0 ? void 0 : ref.isExpired) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCell, {}),
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TicketDetailSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TicketDetailCell, {
                pickupUser: state.pickupUser,
                onUseTicket: onUseTicket,
                loading: state.loading,
                submitting: state.submitting,
                items: state.items
            })
        ]
    });
};
var template_TicketDetailCell = function(param) {
    var pickupUser = param.pickupUser, onUseTicket = param.onUseTicket, loading = param.loading, submitting = param.submitting, items = param.items;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4;
    var ref5 = (0,BrowserLink/* useBrowserLink */.i)((ref4 = pickupUser === null || pickupUser === void 0 ? void 0 : (ref = pickupUser.event) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.mapUri) !== null && ref4 !== void 0 ? ref4 : ""), onClickMapLink = ref5.onClick;
    if (!pickupUser) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pt: 3,
                            pb: 5
                        },
                        children: !!pickupUser.user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    color: "text.secondary",
                                    children: t("customerInfo", "お客様情報")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    spacing: 1,
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("accountName", "アカウント名")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: pickupUser.user.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    spacing: 1,
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("email", "メールアドレス")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: pickupUser.user.email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    spacing: 1,
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("fullName", "氏名")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: pickupUser.user.fullName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    spacing: 1,
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("phoneNumber", "電話番号")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: pickupUser.user.formattedPhoneNumber
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: {
                            py: 3
                        },
                        color: "text.secondary",
                        children: t("ticketInfo", "受け取り先情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInfoCell, {
                        pickupUser: pickupUser
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            mt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("pickupTime")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: pickupUser.formattedPickupStartEndTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("pickupLocation")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: pickupUser.eventCollection.pickupLocation
                            }),
                            !!(pickupUser === null || pickupUser === void 0 ? void 0 : (ref2 = pickupUser.event) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.location) === null || ref3 === void 0 ? void 0 : ref3.mapUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                onClick: function() {
                                    var ref;
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_eventMapLink", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        eventId: (ref = pickupUser.event) === null || ref === void 0 ? void 0 : ref.id,
                                        type: "eventPickup"
                                    });
                                    onClickMapLink();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "primary",
                                    sx: {
                                        cursor: "pointer"
                                    },
                                    children: t("venueMap", "会場MAP")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: {
                                    py: 3
                                },
                                color: "text.secondary",
                                children: t("pickupItems", "受け取り商品")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 2,
                                sx: {
                                    pb: 6
                                },
                                children: items === null || items === void 0 ? void 0 : items.map(function(param, index) {
                                    var item = param.item;
                                    var order = pickupUser.pickupOrder.find(function(param) {
                                        var itemId = param.itemId;
                                        return itemId === item.id;
                                    });
                                    // アイテムの個数。SKUがある場合はitemのskuIdに一致するもののみ表示
                                    var quantity = item.sku ? order === null || order === void 0 ? void 0 : order.serials.filter(function(param) {
                                        var skuId = param.skuId;
                                        var ref;
                                        return skuId === ((ref = item.sku) === null || ref === void 0 ? void 0 : ref.id);
                                    }).length : order === null || order === void 0 ? void 0 : order.count;
                                    if (!quantity) return null;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem, {
                                        item: item,
                                        quantity: quantity,
                                        sku: item.sku
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketUseCell, {
                        loading: loading,
                        submitting: submitting,
                        onUseTicket: onUseTicket,
                        pickupUser: pickupUser
                    })
                ]
            })
        })
    });
};
var CollectionInfoCell = function(param) {
    var pickupUser = param.pickupUser;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketDetail").t;
    var remainingTime = (0,react.useMemo)(function() {
        if (!pickupUser.pickupRemainingTime) return null;
        var _pickupRemainingTime = pickupUser.pickupRemainingTime, hours = _pickupRemainingTime.hours, minutes = _pickupRemainingTime.minutes, expiring = _pickupRemainingTime.expiring;
        var remainingTime = hours || minutes ? [
            hours && hours > 0 ? "".concat(hours).concat(t("time")) : "",
            minutes > 0 ? "".concat(minutes).concat(t("minute")) : "", 
        ].join("") : 1;
        return expiring ? t("countDownTime", {
            remainingTime: remainingTime
        }) : t("countDownTimeUntilPickupStart", {
            remainingTime: remainingTime
        });
    }, [
        pickupUser.pickupRemainingTime,
        t
    ]);
    if (!pickupUser) return null;
    var _uri, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        spacing: 3,
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                variant: "square",
                src: (_uri = pickupUser.eventCollection.collection.thumbnail.uri) !== null && _uri !== void 0 ? _uri : "",
                sx: {
                    width: 72,
                    height: 72,
                    borderRadius: "4px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        sx: {
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiptTag, {
                                receipted: !!pickupUser.isCompleted,
                                expired: !!pickupUser.isExpired
                            }),
                            remainingTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Notice, {
                                        fontSize: "xSmall",
                                        sx: {
                                            color: ((ref = pickupUser.pickupRemainingTime) === null || ref === void 0 ? void 0 : ref.expiring) ? "like.tap" : "primary.main"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        sx: {
                                            color: ((ref1 = pickupUser.pickupRemainingTime) === null || ref1 === void 0 ? void 0 : ref1.expiring) ? "like.tap" : "primary.main"
                                        },
                                        children: remainingTime
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: pickupUser.eventCollection.collection.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flexDirection: "row",
                        alignItems: "center",
                        sx: {
                            mt: 1,
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: "24px",
                                    height: "24px"
                                },
                                src: (ref3 = (ref2 = pickupUser.eventCollection.collection.artist.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref3 !== void 0 ? ref3 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.secondary",
                                children: pickupUser.eventCollection.collection.artist.displayName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ExpiredCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 6,
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                        color: "error"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("receiptExpirationTitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                    i18nKey: "receiptExpirationDesc",
                    t: t
                })
            })
        ]
    });
};
var TicketUseCell = function(param) {
    var onUseTicket = param.onUseTicket, submitting = param.submitting, loading = param.loading, pickupUser = param.pickupUser;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketDetail").t;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: !loading && (pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isCompleted) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                            fontSize: "xSmall"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "overline",
                            color: "text.secondary",
                            children: t("dateOfUse")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            sx: {
                                pl: 1
                            },
                            children: pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.formattedCompletedAt
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            children: t("chargeNote", "ここから先は必ず担当者に操作してもらってください。")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            children: t("chargeDesc", "一度使用済みになったチケットは、未使用の状態には戻せませんのでご注意ください。")
                        })
                    ]
                })
            }),
            (pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isExpired) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 4,
                    px: 4,
                    py: 2,
                    borderColor: "error.main",
                    borderWidth: 1,
                    borderStyle: "solid"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                color: "error",
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t("receiptExpirationTitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        sx: {
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                            i18nKey: "receiptExpirationDesc",
                            t: t
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4,
                    px: 6
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeButton, {
                        loading: loading,
                        color: (pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isExpired) ? "error" : "primary",
                        textOn: t("charge", "担当者操作ボタン"),
                        textOff: t("used", "使用済み"),
                        onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                setOpen(true);
                                return [
                                    2
                                ];
                            });
                        }),
                        succeed: !!(pickupUser === null || pickupUser === void 0 ? void 0 : pickupUser.isCompleted)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: open,
                        onClose: function() {
                            setOpen(submitting !== null && submitting !== void 0 ? submitting : false);
                        },
                        title: t("confirmChargeTitle"),
                        content: t("confirmChargeDesc"),
                        cancelText: submitting ? "" : t("close"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            loading: submitting,
                            size: "large",
                            fullWidth: true,
                            onClick: function() {
                                onUseTicket().finally(function() {
                                    setOpen(false);
                                });
                            },
                            children: t("ok")
                        })
                    })
                ]
            })
        ]
    });
};
var template_TicketDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                mb: 5,
                                mt: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 160,
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 90,
                                    height: 64
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            spacing: 2,
                                            sx: {
                                                pb: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "medium"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 3
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "subtitle1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                pt: 1
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "caption",
                                                width: "60%"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                px: 4,
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body1",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body1",
                                    width: "100%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                mt: 5,
                                mb: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 160,
                                height: 16
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: 60,
                                    height: 96
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            spacing: 2,
                                            sx: {
                                                pb: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                        variant: "medium"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    flex: 3
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "subtitle1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            sx: {
                                                pt: 1
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "caption",
                                                width: "60%"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            sx: {
                                px: 4,
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body1",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body1",
                                    width: "100%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                mt: 5,
                                display: "grid",
                                placeItems: "center",
                                pb: 8
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwipeButton, {
                                disabled: true,
                                loading: false,
                                succeed: false,
                                textOn: "",
                                textOff: "",
                                onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        return [
                                            2
                                        ];
                                    });
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketDetail/viewModel.ts




function MyOwnedTicketDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyOwnedTicketDetail(\n    $pickupUserId: ID!\n    $eventId: String!\n    $collectionId: String!\n  ) {\n    pickupUser(\n      pickupUserId: $pickupUserId\n      eventId: $eventId\n      collectionId: $collectionId\n    ) {\n      ...PickupUser\n    }\n  }\n  ",
        "\n"
    ]);
    MyOwnedTicketDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyOwnedTicketDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UseEventPickupTickets($inputs: UseEventPickupTicketsInput!) {\n    useEventPickupTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    MyOwnedTicketDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var MyOwnedTicketDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _query = router.query, eventId = _query.eventId, collectionId = _query.collectionId, pickupUserId = _query.pickupUserId;
    var ref1 = (0,useQuery/* useQuery */.aM)(MyOwnedTicketDetail_viewModel_QUERY, {
        variables: {
            pickupUserId: pickupUserId,
            eventId: eventId,
            collectionId: collectionId
        }
    }), data = ref1.data, loading = ref1.loading;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(USE_EVENT_PICKUP_TICKETS), 2), mutate = ref2[0], ref3 = ref2[1], submitting = ref3.loading;
    (0,react.useEffect)(function() {
        if (!loading && (data === null || data === void 0 ? void 0 : data.pickupUser)) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_eventPickup", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            eventId: router.query.eventId,
            collectionId: router.query.collectionId,
            status: (data === null || data === void 0 ? void 0 : data.pickupUser.isExpired) ? "expired" : (data === null || data === void 0 ? void 0 : data.pickupUser.isCompleted) ? "completed" : "waitig"
        });
    }, [
        loading,
        data === null || data === void 0 ? void 0 : data.pickupUser
    ]);
    var ref4;
    return {
        state: {
            loading: loading,
            submitting: submitting,
            pickupUser: (ref4 = data === null || data === void 0 ? void 0 : data.pickupUser) !== null && ref4 !== void 0 ? ref4 : null,
            items: spreadUserItemsBySku(data === null || data === void 0 ? void 0 : (ref = data.pickupUser) === null || ref === void 0 ? void 0 : ref.userItems)
        },
        actions: {
            onUseTicket: function onUseTicket() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var items;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                items = data === null || data === void 0 ? void 0 : data.pickupUser.ticketItemSerialsInput;
                                if (!items) return [
                                    2
                                ];
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_useTicket", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    eventId: data === null || data === void 0 ? void 0 : data.pickupUser.eventId,
                                    collectionId: data === null || data === void 0 ? void 0 : data.pickupUser.collectionId,
                                    asArtist: false
                                });
                                return [
                                    4,
                                    mutate({
                                        variables: {
                                            inputs: {
                                                eventId: router.query.eventId,
                                                collectionId: router.query.collectionId,
                                                pickupUserId: router.query.pickupUserId
                                            }
                                        },
                                        refetchQueries: function() {
                                            return [
                                                {
                                                    query: MyOwnedTicketDetail_viewModel_QUERY,
                                                    variables: {
                                                        pickupUserId: pickupUserId,
                                                        eventId: eventId,
                                                        collectionId: collectionId
                                                    }
                                                }, 
                                            ];
                                        },
                                        awaitRefetchQueries: true
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyOwnedTicketDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(MyOwnedTicketDetail_viewModel_templateObject(), utoniq_core_schema/* PickupUserFragmentDoc */.ymY);
var USE_EVENT_PICKUP_TICKETS = (0,lib/* gql */.Ps)(MyOwnedTicketDetail_viewModel_templateObject1(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketDetail/index.tsx




/**
 * MyOwnedTicketDetail Page
 * Implemented as a practical sample.
 */ var MyOwnedTicketDetail = function() {
    var ref = MyOwnedTicketDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTicketDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTickets/viewModel.ts



function MyOwnedTickets_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pickupUsersByEvent(\n    $eventId: ID!\n    $options: PickupUsersByEventOptions!\n    $pageInput: PageInput\n  ) {\n    pickupUsersByEvent(\n      eventId: $eventId\n      options: $options\n      pageInput: $pageInput\n    ) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      edges {\n        node {\n          ...PickupUserListItem\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    MyOwnedTickets_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 *
 */ var MyOwnedTickets_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref4 = (0,react.useState)(utoniq_core_schema/* UserPickupTicketStatus.All */.GNT.All), type = ref4[0], setType = ref4[1];
    var ref5 = (0,useQuery/* useQuery */.aM)(MyOwnedTickets_viewModel_QUERY, {
        variables: {
            eventId: router.query.eventId,
            options: {
                type: utoniq_core_schema/* UserPickupTicketStatus.All */.GNT.All,
                isHistory: false
            }
        },
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, loading = ref5.loading, fetchMore = ref5.fetchMore, refetch = ref5.refetch, networkStatus = ref5.networkStatus;
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (loading || !!(data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.edges.length)) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
            artistId: (ref = data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.edges[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.eventCollection.collection.artistId,
            eventId: router.query.eventId,
            name: "eventPickup"
        });
    }, [
        loading,
        !!(data === null || data === void 0 ? void 0 : (ref = data.pickupUsersByEvent) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length)
    ]);
    var ref6;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            eventId: router.query.eventId,
            event: (ref6 = (ref2 = data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.edges[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.node) === null || ref3 === void 0 ? void 0 : ref3.event) !== null && ref6 !== void 0 ? ref6 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.pageInfo.hasNextPage),
            pickupUsers: data === null || data === void 0 ? void 0 : data.pickupUsersByEvent,
            isHistory: false,
            type: type
        },
        actions: {
            onFilter: function onFilter(inputType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (type === inputType) return [
                                    2
                                ];
                                setType(inputType);
                                return [
                                    4,
                                    refetch({
                                        eventId: router.query.eventId,
                                        options: {
                                            type: inputType,
                                            isHistory: false
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            eventId: router.query.eventId,
                                            options: {
                                                type: type,
                                                isHistory: false
                                            },
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyOwnedTickets_viewModel_QUERY = (0,lib/* gql */.Ps)(MyOwnedTickets_viewModel_templateObject(), utoniq_core_schema/* PickupUserListItemFragmentDoc */.KVm);

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTickets/index.tsx




/**
 * MyOwnedTickets Page
 * Implemented as a practical sample.
 */ var MyOwnedTickets = function() {
    var ref = MyOwnedTickets_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTicketsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketsEventSelection/template/index.tsx













var MyOwnedTicketsEventSelectionTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketsEventSelection").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref7 = (0,react.useState)(false), openSideMenu = ref7[0], setOpenSideMenu = ref7[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            left: config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AvatarNoImage, {
                edge: "start",
                onClick: function() {
                    return setOpenSideMenu(!openSideMenu);
                },
                bgcolor: "grey.50",
                badge: ((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask) || !!((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount) || !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            }),
            back: config_config/* config.applicationType */.v.applicationType === "standalone"
        },
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.hasManagementTask),
                unreadNotificationCount: (ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.unreadNotificationCount,
                hasSettingTask: !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyOwnedTicketsEventSelection
            }),
            state.loading && !state.events ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "large",
                    width: "75%"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                sx: {
                    py: 2
                },
                children: t("selectEvent", "イベントを選択してください")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref6 = state.events) === null || ref6 === void 0 ? void 0 : ref6.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOrderCell, {
                        event: node
                    }, node.id);
                }),
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOrderSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOrderSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOrderSkeleton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreOrderSkeleton, {})
                    ]
                }),
                emptyMessage: t("myOwnedTicketsEventEmptyMessage", "受け取りが必要な商品はありません。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenu, {
                open: openSideMenu,
                onClose: function() {
                    return setOpenSideMenu(false);
                },
                user: state.user,
                followArtists: state.followArtists,
                memberArtists: state.memberArtists,
                isArtist: state.isArtist
            })
        ]
    });
};
var StoreOrderCell = function(param) {
    var event = param.event;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("myOwnedTicketsEventSelection").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    if (!event) return null;
    // 次の受け取り時間
    var nextPickupTime = event.eventCollections.edges.map(function(param) {
        var node = param.node;
        var ref, ref1;
        var nextTime = (ref1 = (ref = node.myPickupUsers) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var pickupTime = param.pickupTime;
            return pickupTime > values_Date/* DateTime.nowUnixMilliseconds */.o.nowUnixMilliseconds();
        })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
            return a.pickupTime - b.pickupTime;
        })[0];
        return {
            pickupTime: nextTime === null || nextTime === void 0 ? void 0 : nextTime.pickupTime,
            formattedPickupStartEndTime: nextTime === null || nextTime === void 0 ? void 0 : nextTime.formattedPickupStartEndTime
        };
    }).filter(function(param) {
        var pickupTime = param.pickupTime;
        return !!pickupTime;
    }).sort(function(a, b) {
        return a.pickupTime - b.pickupTime;
    })[0];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.MyOwnedTickets, {
                    eventId: event.id
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        py: 2,
                        px: 4,
                        "&:last-child": {
                            pb: 2
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                src: (ref2 = (ref = event.thumbnail) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                                sx: {
                                    width: 100,
                                    height: 64
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                                                event: event
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "overline",
                                                color: "text.secondary",
                                                children: [
                                                    t("eventDate", "開催日"),
                                                    " ",
                                                    event.aboutDateRange
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: event.title
                                    }),
                                    (nextPickupTime === null || nextPickupTime === void 0 ? void 0 : nextPickupTime.formattedPickupStartEndTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secondary",
                                        children: [
                                            t("nextPickupTime", "次の受け取り時間"),
                                            nextPickupTime === null || nextPickupTime === void 0 ? void 0 : nextPickupTime.formattedPickupStartEndTime
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var StoreOrderSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    py: 2,
                    px: 4,
                    "&:last-child": {
                        pb: 2
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 100,
                            height: 64
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            flex: 3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "medium",
                                                width: "80%"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "subtitle1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "caption",
                                    width: "75%"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketsEventSelection/viewModel.ts



function MyOwnedTicketsEventSelection_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PickupUserEvents($pageInput: PageInput) {\n    user {\n      ...CurrentUser\n    }\n    pickupUserEvents(pageInput: $pageInput) {\n      edges {\n        node {\n          ... on Event {\n            ...PickupUserEvent\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    MyOwnedTicketsEventSelection_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var MyOwnedTicketsEventSelection_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var ref5 = (0,useQuery/* useQuery */.aM)(MyOwnedTicketsEventSelection_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, loading = ref5.loading, fetchMore = ref5.fetchMore;
    var isNextFetch = !!data;
    var ref6, ref7, ref8, ref9;
    return {
        state: {
            user: (ref6 = data === null || data === void 0 ? void 0 : data.user) !== null && ref6 !== void 0 ? ref6 : null,
            events: (ref7 = data === null || data === void 0 ? void 0 : data.pickupUserEvents) !== null && ref7 !== void 0 ? ref7 : null,
            loading: loading && !isNextFetch,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.pickupUserEvents) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            followArtists: (ref8 = data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.organizationFollowees) !== null && ref8 !== void 0 ? ref8 : null,
            memberArtists: (ref9 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.organizationPatrons) !== null && ref9 !== void 0 ? ref9 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref3 = userClaims.orgs) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[config_config/* config.organizationId */.v.organizationId]) === null || ref4 === void 0 ? void 0 : ref4.artist)
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.pickupUserEvents) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyOwnedTicketsEventSelection_viewModel_QUERY = (0,lib/* gql */.Ps)(MyOwnedTicketsEventSelection_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* PickupUserEventFragmentDoc */.VB8);

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketsEventSelection/index.tsx




/**
 * MyOwnedTicketsEventSelection Page
 * Implemented as a practical sample.
 */ var MyOwnedTicketsEventSelection = function() {
    var ref = MyOwnedTicketsEventSelection_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTicketsEventSelectionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketsHistory/viewModel.ts







var MyOwnedTicketsHistory_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var eventId = router.query.eventId;
    var ref2 = (0,react.useState)(utoniq_core_schema/* UserPickupTicketStatus.All */.GNT.All), type = ref2[0], setType = ref2[1];
    var ref3 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* PickupUsersByEvent */._WY, {
        variables: {
            eventId: eventId,
            options: {
                type: type,
                isHistory: true
            }
        },
        notifyOnNetworkStatusChange: true
    }), data = ref3.data, fetchMore = ref3.fetchMore, refetch = ref3.refetch, networkStatus = ref3.networkStatus;
    var ref4;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            isHistory: true,
            event: (ref4 = (ref = data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.edges[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.event) !== null && ref4 !== void 0 ? ref4 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.pageInfo.hasNextPage),
            pickupUsers: data === null || data === void 0 ? void 0 : data.pickupUsersByEvent,
            type: type
        },
        actions: {
            onFilter: function onFilter(inputType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (type === inputType) return [
                                    2
                                ];
                                setType(inputType);
                                return [
                                    4,
                                    refetch({
                                        options: {
                                            type: inputType,
                                            isHistory: true
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            type: type,
                                            isHistory: true,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.pickupUsersByEvent.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/MyOwnedTicketsHistory/index.tsx




/**
 * MyOwnedTickets Page
 * Implemented as a practical sample.
 */ var MyOwnedTicketsHistory = function() {
    var ref = MyOwnedTicketsHistory_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyOwnedTicketsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/event/EventTicketCard/index.tsx









var EventTicketCard = function(param) {
    var item = param.item, event = param.event, skuId = param.skuId, width = param.width;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), generateQueryPath = ref7.generateQueryPath, routerPages = ref7.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2,
            width: width
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            sx: {
                height: "100%"
            },
            href: generateQueryPath(routerPages.OwnedItemDetail, {
                itemId: item.id
            }, {
                skuId: encodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 4,
                    "&:last-child": {
                        pb: 4
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCategory, {
                        event: event
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        py: 2,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: item.title
                            }),
                            (!!((ref = item.sku) === null || ref === void 0 ? void 0 : ref.unitName) || ((ref1 = item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    !!((ref3 = item.sku) === null || ref3 === void 0 ? void 0 : ref3.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1)), {
                                            maxWidth: 200,
                                            lineHeight: "20px"
                                        }),
                                        children: item.sku.unitName
                                    }),
                                    ((ref4 = item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : ref5.isThroughTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThroughTicketTag/* ThroughTicketTag */.w, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        pt: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                children: event.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                sx: {
                                    pt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Calendar, {
                                        fontSize: "small",
                                        sx: {
                                            color: "grey.700"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secondary",
                                        children: event.dateRange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                sx: {
                                    pt: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Pin, {
                                        fontSize: "small",
                                        sx: {
                                            color: "grey.700"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.secondary",
                                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                        children: (ref6 = event.location) === null || ref6 === void 0 ? void 0 : ref6.approximateAddress
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/membership/membershipCard/index.tsx








/**
 * MembershipCard
 * 会員番号が付与されたメンバーシップを表示するカード
 */ var MembershipCard = function(param) {
    var membership = param.membership, width = param.width;
    var ref, ref1, ref2, ref3, ref4;
    var month = (0,react.useMemo)(function() {
        return values_Date/* DateTime.calculateMonthsSince */.o.calculateMonthsSince(membership === null || membership === void 0 ? void 0 : membership.formattedCreatedAt);
    }, [
        membership
    ]);
    var monthSuffix = month > 1 ? "_other" : "_one";
    var currentProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.planId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.planId
    ]);
    var downgradeProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.downgradePlanId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref1 = membership.subscription) === null || ref1 === void 0 ? void 0 : ref1.downgradePlanId
    ]);
    var upgradeProduct = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(membership.artist, (ref1 = (ref = membership.subscription) === null || ref === void 0 ? void 0 : ref.upgradePlanId) !== null && ref1 !== void 0 ? ref1 : "");
    }, [
        membership.artist,
        (ref2 = membership.subscription) === null || ref2 === void 0 ? void 0 : ref2.upgradePlanId
    ]);
    var membershipState = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var pendingPurchasePatron = (ref = membership.artist) === null || ref === void 0 ? void 0 : ref.pendingPurchasePatron;
        if (pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : (ref1 = pendingPurchasePatron.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.membership) === null || ref2 === void 0 ? void 0 : ref2.planId) {
            if ((pendingPurchasePatron === null || pendingPurchasePatron === void 0 ? void 0 : pendingPurchasePatron.status) === utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment) {
                return "KONBINI_WAITING_PAYMENT";
            }
            return;
        }
        if (membership.type === "escott" && !((ref3 = membership.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : ref4.carrierPayment) && (membership.cancelAtPeriodEnd || membership.upgradeAtNextPeriod || membership.downgradeAtNextPeriod)) {
            return "CARRIER_INACTIVE";
        }
        if (((ref5 = membership.subscription) === null || ref5 === void 0 ? void 0 : ref5.downgradePlanId) || membership.upgradeAtNextPeriod // 次回更新日にアップグレードする場合
        ) {
            return "CHANGED_PLAN";
        }
        if (membership.cancelAtPeriodEnd) {
            return "RESUME";
        }
        return "ACTIVE";
    }, [
        (ref3 = membership.artist) === null || ref3 === void 0 ? void 0 : ref3.pendingPurchasePatron,
        membership.cancelAtPeriodEnd,
        (ref4 = membership.subscription) === null || ref4 === void 0 ? void 0 : ref4.downgradePlanId, 
    ]);
    var t = (0,dist_es/* useTranslation */.$G)("userProfile").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        sx: {
            borderRadius: 2,
            width: width
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 4,
                "&:last-child": {
                    pb: 4
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    size: "small",
                    sx: {
                        height: 20,
                        borderRadius: "2px",
                        minWidth: 40,
                        bgcolor: "primary.main",
                        ".MuiChip-label": {
                            px: 1
                        }
                    },
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "primary.contrastText",
                        variant: "overline",
                        display: "block",
                        children: t("inProgress", "加入中")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    py: 2,
                    spacing: 4,
                    direction: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                        children: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    py: 2,
                    spacing: 4,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                            children: t("membershipNumber", "会員番号")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                            children: membership.formattedMembershipNumber
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    py: 2,
                    spacing: 4,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            sx: {
                                whiteSpace: "nowrap"
                            },
                            children: t("membershipPeriod", "継続期間")
                        }),
                        membershipState === "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            align: "left",
                            children: t("".concat((membership === null || membership === void 0 ? void 0 : membership.paymentMethod) || utoniq_core_schema/* PaymentMethod.CreditCard */.XL7.CreditCard, "AutoUpdate").concat(monthSuffix), {
                                count: month,
                                expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                            })
                        }),
                        membershipState === "CHANGED_PLAN" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            align: "left",
                            children: t("changeNote", {
                                count: month,
                                productTitle: (downgradeProduct === null || downgradeProduct === void 0 ? void 0 : downgradeProduct.title) || (upgradeProduct === null || upgradeProduct === void 0 ? void 0 : upgradeProduct.title),
                                expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                            })
                        }),
                        membershipState === "KONBINI_WAITING_PAYMENT" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            align: "left",
                            color: "text.hint",
                            children: t("konbiniJoinedNote")
                        }),
                        (membershipState === "RESUME" || membershipState === "CARRIER_INACTIVE") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            align: "left",
                            children: t("cancelNote", {
                                count: month,
                                expiredAt: membership === null || membership === void 0 ? void 0 : membership.formattedExpiredAt
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/ImagePlayer/DRMWallpaperPlayer.tsx






var DRMWallpaperPlayer = function(_param) {
    var resource = _param.resource, imageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "resource"
    ]);
    var ref = (0,useDRMPlayer/* useDRMPlayer */.W)({
        source: {
            dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
            hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || ""
        },
        opts: {
            mutedAutoplay: "all"
        }
    }), ref1 = ref.ref, player = ref.player, accessToken = ref.accessToken;
    (0,react.useEffect)(function() {
        if (player && accessToken) player.play();
    }, [
        accessToken
    ]);
    if (!accessToken || !resource) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            width: imageProps === null || imageProps === void 0 ? void 0 : imageProps.width,
            maxWidth: 600,
            margin: "auto",
            minHeight: "fit-content",
            height: "100%",
            display: "grid",
            placeItems: "start center",
            "& .vjs-loading-spinner": {
                display: "none!important"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerImageView */.D, {
                ref: ref1,
                playable: !!(player === null || player === void 0 ? void 0 : player.duration)
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/resourcePlayer/VoicePlayer/SelectableVoicePlayer.tsx










var libraryLocation = config_config/* config.theoPlayerLibraryLocation */.v.theoPlayerLibraryLocation;
var functionsEndpoint = config_config/* config.functionsEndpoint */.v.functionsEndpoint;
/**
 * @description SelectableVoicePlayer
 * 音声アイコンのボタンを押すとメニューが出て、選択した音声を再生するUI
 * https://zpl.io/agEqNAM
 */ var SelectableVoicePlayer = function(param) {
    var resources = param.resources;
    (0,usehooks_ts_esm/* useScript */.Gq)(libraryLocation + "/THEOplayer.js");
    var accessToken = (0,auth/* useAccessToken */.Gu)().accessToken;
    var ref = (0,react.useRef)(null);
    // DRM音源ならtheoPlayer、そうでなければAudioのインスタンスを用意
    var players = resources.map(function(param) {
        var resource = param.resource, label = param.label;
        var ref1;
        if (((ref1 = resource.drm) === null || ref1 === void 0 ? void 0 : ref1.encryptingStatus) === "encrypted") {
            var player = getDRMPlayer({
                accessToken: accessToken,
                dashUri: (resource === null || resource === void 0 ? void 0 : resource.dashUri) || "",
                hlsUri: (resource === null || resource === void 0 ? void 0 : resource.hlsUri) || "",
                ref: ref
            });
            return player ? {
                label: label,
                player: player
            } : null;
        }
        return {
            label: label,
            player: new Audio(resource.uri)
        };
    }).flatMap(function(item) {
        return item !== null ? [
            item
        ] : [];
    });
    (0,react.useEffect)(function() {
        return function() {
            return players.forEach(function(param) {
                var player = param.player;
                return player.pause();
            });
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TheoPlayerView/* TheoPlayerView */.m, {
                ref: ref,
                chromeless: true
            }),
            ref.current && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerControl, {
                players: players
            })
        ]
    });
};
var PlayerControl = function(param) {
    var players = param.players;
    var ref = (0,react.useState)(false), _ = ref[0], observe = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    /**
   * @description
   * 再生終了時にボタンアイコン・チェックマークの表示を変更させる処理
   *
   * 複数個のaudioオブジェクトの再生状態をstateとして管理するのは難しいため、playerのイベントリスナーを登録し、
   * 再生終了毎にPlayerControl内部のstateを更新する事で画面を再描画する。
   */ (0,react.useEffect)(function() {
        players.forEach(function(param) {
            var player = param.player;
            player.addEventListener("ended", function() {
                return observe(function(state) {
                    return !state;
                });
            });
        });
    }, [
        players
    ]);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleMenuClick = function(player) {
        handleClose();
        if (player.paused) {
            player.play();
        } else {
            player.pause();
            player.currentTime = 0;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            players.some(function(param) {
                var player = param.player;
                return !player.paused;
            }) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOn, {
                onClick: handleClick
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOff, {
                onClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: players.map(function(param) {
                    var player = param.player, label = param.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            width: 200
                        },
                        onClick: function() {
                            return handleMenuClick(player);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                !player.paused && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                                    fontSize: "xSmall"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: label
                                })
                            ]
                        })
                    }, label);
                })
            })
        ]
    });
};
function getDRMPlayer(param) {
    var dashUri = param.dashUri, hlsUri = param.hlsUri, accessToken = param.accessToken, ref = param.ref;
    var player = (0,useDRMPlayer/* initTheoPlayer */.L)(ref, {
        chromeless: true
    });
    if (player) {
        player.addEventListener("contentprotectionerror", function() {
            for(var _len = arguments.length, err = new Array(_len), _key = 0; _key < _len; _key++){
                err[_key] = arguments[_key];
            }
            (0,core_errors/* captureError */.O)(err, "getDRMPlayer");
        });
        player.source = {
            sources: [
                {
                    src: dashUri,
                    type: "application/dash+xml",
                    contentProtection: {
                        playready: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/playready"),
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        },
                        widevine: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/widevine"),
                            headers: {
                                "Content-Type": "application/octet-stream",
                                Accept: "application/octet-stream",
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        }
                    }
                },
                {
                    src: hlsUri,
                    type: "application/x-mpegURL",
                    contentProtection: {
                        fairplay: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/fairplay"),
                            certificateURL: config_config/* config.fairplayCertificateUrl */.v.fairplayCertificateUrl,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        }
                    }
                }, 
            ]
        };
    }
    return player;
}

;// CONCATENATED MODULE: ./src/components/pages/MyProfile/template/index.tsx

























var MyProfileTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref6 = (0,core_i18n/* useTranslation */.$G)("myProfile"), t = ref6.t, i18n = ref6.i18n;
    var shouldHideFavoriteMembers = (0,react.useMemo)(function() {
        var ref, ref1;
        // user.organizationPatronsが空配列の場合（メンバーシップに１つも加入していない場合）
        if (!((ref = state.user) === null || ref === void 0 ? void 0 : ref.organizationPatrons) || ((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.organizationPatrons.length) === 0) {
            return true;
        }
        // 全てのuser.organizationPatronsについて、favoriteMemberがnullかつrequiredFavoriteMemberがfalse
        var allPatronsHaveNoRequiredFavoriteMember = state.favoriteMembers.every(function(member) {
            return !member.favoriteMember && !member.requiredFavoriteMember;
        });
        return allPatronsHaveNoRequiredFavoriteMember;
    }, [
        (ref = state.user) === null || ref === void 0 ? void 0 : ref.organizationPatrons
    ]);
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        safeArea: {
            pt: 0
        },
        navigation: {
            type: config_config/* config.applicationType */.v.applicationType === "standalone" ? "artist" : "global",
            props: {
                hasManagementTask: !!((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.hasManagementTask),
                unreadNotificationCount: (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.unreadNotificationCount,
                hasSettingTask: !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.isMembershipPersonalInformationRequired)
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: i18n.exists("myProfile:ogTitle") ? t("ogTitle") : routerNames.MyProfile
            }),
            state.isCustom && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileCustomOrganism, {
                loading: state.loading,
                customProfile: (ref4 = state.user) === null || ref4 === void 0 ? void 0 : ref4.customProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo, {
                loading: state.loading,
                user: state.user,
                currentUser: state.currentUser,
                isCustom: state.isCustom,
                prepaidPointBalance: state.prepaidPointBalance
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonService, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCardCell, {
                digitalMembershipCards: state.favoriteMembers,
                currentUser: state.currentUser,
                patrons: state.patrons
            }),
            !shouldHideFavoriteMembers && /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteMembersCell, {
                favoriteMembers: state.favoriteMembers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfile_template_MembershipCell, {
                membership: state.membership
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventTicketCell, {
                events: state.events
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistRankingCell, {
                rankings: state.artistRankings,
                loading: state.loading
            }),
            config_config/* config.applicationType */.v.applicationType === "organization" && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ArtistCell, {
                loading: state.loading,
                organizationFollowees: (ref7 = (ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.organizationFollowees) !== null && ref7 !== void 0 ? ref7 : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Menu, {
                isArtist: state.isArtist,
                user: state.user
            })
        ]
    });
};
var UserInfo = function(param) {
    var loading = param.loading, user = param.user, currentUser = param.currentUser, isCustom = param.isCustom, prepaidPointBalance = param.prepaidPointBalance;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 0,
            pt: isCustom ? 0 : styles/* styles.safeAreaTop */.W2.safeAreaTop
        },
        children: [
            !isCustom && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                sx: {
                    py: 3,
                    px: 3,
                    mb: 3,
                    height: 56
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                        size: "medium",
                        onClick: function() {
                            return router === null || router === void 0 ? void 0 : router.goBack();
                        }
                    }),
                    !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && typeof (prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) === "number" && !(0,individual/* individualHideWallet */.Bd)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                        point: (ref1 = prepaidPointBalance === null || prepaidPointBalance === void 0 ? void 0 : prepaidPointBalance.balance) !== null && ref1 !== void 0 ? ref1 : ""
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 2,
                    px: 5
                },
                spacing: 3,
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 64,
                        height: 64
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            minWidth: 84
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            width: "100%"
                        },
                        alignItems: "center",
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 2,
                            lastWidth: "50%"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            width: 64,
                            height: 64
                        },
                        src: (ref2 = currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl) !== null && ref2 !== void 0 ? ref2 : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            mt: 3
                        },
                        children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.hint",
                        children: user === null || user === void 0 ? void 0 : user.formattedAccountId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        sx: {
                            mt: 3
                        },
                        children: user === null || user === void 0 ? void 0 : user.introduction
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 3,
                    mt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    sx: {
                        py: 1
                    },
                    href: routerPages.MyProfileEdit,
                    children: t("editProfile")
                })
            })
        ]
    });
};
var template_Menu = function(param) {
    var isArtist = param.isArtist, user = param.user;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var list = (0,react.useMemo)(function() {
        return [
            {
                title: t("console"),
                hidden: !isArtist,
                href: routerPages.ConsoleDashboard,
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Artist, {
                        sx: {
                            color: "grey.400"
                        },
                        fontSize: "medium"
                    });
                }
            },
            {
                title: t("wallet"),
                hidden: !config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint || (0,individual/* individualHideWallet */.Bd)(),
                href: routerPages.Wallet,
                Icon: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Wallet, {
                        sx: {
                            color: "grey.400"
                        },
                        fontSize: "medium"
                    });
                }
            },
            {
                title: t("config"),
                href: routerPages.Setting,
                Icon: function() {
                    return (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                badgeContent: "",
                                color: "like",
                                sx: {
                                    position: "absolute",
                                    color: "white",
                                    top: 8,
                                    right: "-2px",
                                    width: 12,
                                    height: 12,
                                    "& > span": {
                                        fontWeight: "bold",
                                        fontSize: 9,
                                        minWidth: 12,
                                        height: 12,
                                        bgcolor: "like.tap"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Setting, {
                                sx: {
                                    color: "grey.400"
                                },
                                fontSize: "medium"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Setting, {
                        sx: {
                            color: "grey.400"
                        },
                        fontSize: "medium"
                    });
                }
            },
            {
                title: t("manager"),
                href: routerPages.Management,
                Icon: function() {
                    return (user === null || user === void 0 ? void 0 : user.hasUnappliedDeliveryItems) || (user === null || user === void 0 ? void 0 : user.hasWaitingPaymentItems) || (user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                badgeContent: "",
                                color: "like",
                                sx: {
                                    position: "absolute",
                                    color: "white",
                                    top: 8,
                                    right: "-2px",
                                    width: 12,
                                    height: 12,
                                    "& > span": {
                                        fontWeight: "bold",
                                        fontSize: 9,
                                        minWidth: 12,
                                        height: 12,
                                        bgcolor: "like.tap"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Management, {
                                sx: {
                                    color: "grey.400",
                                    mt: 2
                                },
                                fontSize: "medium"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Management, {
                        sx: {
                            color: "grey.400"
                        },
                        fontSize: "medium"
                    });
                }
            }, 
        ];
    }, [
        isArtist,
        routerPages.ConsoleDashboard,
        routerPages.Management,
        routerPages.Setting,
        routerPages.Wallet,
        t,
        user === null || user === void 0 ? void 0 : user.hasUnappliedDeliveryItems,
        user === null || user === void 0 ? void 0 : user.isMembershipPersonalInformationRequired,
        user === null || user === void 0 ? void 0 : user.hasWaitingPaymentItems, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    color: "grey.600",
                    pt: 2,
                    pb: 4,
                    px: 5
                },
                children: t("menu")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    color: "text.primary"
                },
                children: (0,array/* filterHiddenItem */.s)(list).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                            title: item.title,
                            href: item.href,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.Icon, {
                                style: {
                                    fontSize: 24
                                },
                                sx: {
                                    color: "grey.600"
                                }
                            }),
                            sx: {
                                display: "flex",
                                height: {
                                    xs: 52,
                                    md: 56
                                },
                                borderBottom: "1px solid",
                                borderColor: "grey.100",
                                py: 3,
                                px: 5
                            },
                            primaryTypographyProps: {
                                variant: "body1"
                            }
                        })
                    }, index);
                })
            })
        ]
    });
};
var template_ArtistCell = function(param) {
    var organizationFollowees = param.organizationFollowees, loading = param.loading;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                pt: 3,
                py: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        px: 5,
                        py: 2,
                        color: "grey.600"
                    },
                    children: t("artistFollow")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    flexWrap: "wrap",
                    sx: (0,src_object_spread/* default */.Z)({
                        overflowY: "auto",
                        px: 5
                    }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        flexWrap: "nowrap",
                        overflow: "hidden",
                        spacing: 4,
                        sx: {
                            py: 2
                        },
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6
                        ].map(function(i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 64,
                                height: 64
                            }, i);
                        })
                    })
                })
            ]
        });
    }
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            overflow: "hidden",
            pt: 5,
            pb: 4,
            backgroundColor: "background.default"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    px: 5,
                    py: 2,
                    color: "grey.600"
                },
                children: t("artistFollow")
            }),
            !(organizationFollowees === null || organizationFollowees === void 0 ? void 0 : (ref = organizationFollowees.edges) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    py: 6,
                    px: 5,
                    textAlign: "center"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flexWrap: "wrap",
                sx: (0,src_object_spread/* default */.Z)({
                    overflowY: "auto",
                    px: 5
                }, styles/* styleSets.hideScrollbar */.k$.hideScrollbar()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    flexWrap: "nowrap",
                    overflow: "hidden",
                    children: organizationFollowees === null || organizationFollowees === void 0 ? void 0 : (ref1 = organizationFollowees.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                        var node = param.node;
                        var ref, ref1, ref2, ref6, ref7;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                            href: generatePath(routerPages.ArtistTop, {
                                artistId: (ref3 = node === null || node === void 0 ? void 0 : (ref = node.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "#"
                            }),
                            sx: {
                                borderRadius: "50%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    width: 64,
                                    height: 64
                                },
                                alt: (ref4 = node === null || node === void 0 ? void 0 : (ref1 = node.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName) !== null && ref4 !== void 0 ? ref4 : "",
                                src: (ref5 = node === null || node === void 0 ? void 0 : (ref2 = node.artist) === null || ref2 === void 0 ? void 0 : (ref6 = ref2.avatar) === null || ref6 === void 0 ? void 0 : ref6.smallUri) !== null && ref5 !== void 0 ? ref5 : ""
                            })
                        }, node === null || node === void 0 ? void 0 : (ref7 = node.artist) === null || ref7 === void 0 ? void 0 : ref7.id);
                    })
                })
            })
        ]
    });
};
var ButtonService = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var listService = (0,react.useMemo)(function() {
        return [
            {
                key: "pickup",
                hidden: !config_config/* config.modules.pickup */.v.modules.pickup,
                title: t("pickup"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.PickUp, {
                    href: routerPages.MyOwnedTicketsEventSelection,
                    sx: {
                        color: "grey.500"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                key: "item",
                hidden: !config_config/* config.modules.item */.v.modules.item,
                title: t("ownedItem"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.OwnedItems, {
                    href: routerPages.MyOwnedItems,
                    sx: {
                        color: "grey.500"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                key: "cart",
                hidden: !config_config/* config.modules.cart */.v.modules.cart,
                title: t("cart"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Cart, {
                    href: routerPages.StoreCartList,
                    sx: {
                        color: "grey.500"
                    },
                    bgcolor: "grey.50"
                })
            },
            {
                key: "trade",
                hidden: !config_config/* config.modules.trade */.v.modules.trade,
                title: t("applyTrade"),
                IconButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Market, {
                    href: routerPages.MyTrade,
                    sx: {
                        color: "grey.500"
                    },
                    bgcolor: "grey.50"
                })
            }, 
        ];
    }, [
        routerPages.MyOwnedItems,
        routerPages.MyTrade,
        routerPages.MyOwnedTicketsEventSelection,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            height: 116,
            alignItems: "flex-end"
        },
        children: (0,array/* filterHiddenItem */.s)(listService).map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    mx: 2
                },
                children: [
                    item.IconButton,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        textAlign: "center",
                        sx: {
                            mt: 2,
                            height: 44,
                            width: 51
                        },
                        children: item.title
                    })
                ]
            }, index);
        })
    });
};
var MyProfileCustomOrganism = function(param) {
    var customProfile = param.customProfile, loading = param.loading;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref6 = (0,react.useState)(false), open = ref6[0], setOpen = ref6[1];
    var ref7 = (0,react.useState)(false), openCustomProfileHelp = ref7[0], setOpenCustomProfileHelp = ref7[1];
    var avatarUrl = get_default()(customProfile, "avatarItem.avatarResources.avatarResource.mediumUri", null);
    // 背景アイテムがDRMかどうか
    var isDrm = get_default()(customProfile, "wallpaperItem.wallpaperResources.wallpaperResource.drm.encryptingStatus", null) === "encrypted";
    var wallpaperUrl = isDrm ? get_default()(customProfile, "wallpaperItem.wallpaperResources.wallpaperResource.uri", null) : get_default()(customProfile, "wallpaperItem.wallpaperResources.wallpaperResource.mediumUri", null);
    var wallpaperImage = (0,lib_image/* useImage */.d)(wallpaperUrl);
    var wallpaperAspectRatio = !!(wallpaperImage === null || wallpaperImage === void 0 ? void 0 : wallpaperImage.naturalWidth) && !!(wallpaperImage === null || wallpaperImage === void 0 ? void 0 : wallpaperImage.naturalHeight) ? wallpaperImage.naturalHeight / wallpaperImage.naturalWidth : null;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            width: "100%",
            height: 400,
            sx: {
                mb: 4
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            display: "flex",
            position: "relative",
            width: "100%",
            aspectRatio: wallpaperAspectRatio ? "".concat(1 / wallpaperAspectRatio) : undefined,
            maxHeight: isDrm ? undefined : 800,
            mb: 5,
            pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    mr: "auto",
                    position: "absolute",
                    zIndex: 2,
                    top: 12,
                    right: 12,
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                },
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Setting, {
                        size: "small",
                        bgcolor: "grey.50",
                        color: "grey.600",
                        onClick: function() {
                            return setOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAudioPlayer, {
                            audioResource: customProfile === null || customProfile === void 0 ? void 0 : (ref = customProfile.wallpaperItem) === null || ref === void 0 ? void 0 : (ref1 = ref.wallpaperResources) === null || ref1 === void 0 ? void 0 : ref1.audioResource,
                            voiceResource: customProfile === null || customProfile === void 0 ? void 0 : (ref2 = customProfile.avatarItem) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.avatarResources) === null || ref3 === void 0 ? void 0 : ref3.voiceResource
                        })
                    })
                ]
            }),
            wallpaperUrl && !!(wallpaperImage === null || wallpaperImage === void 0 ? void 0 : wallpaperImage.naturalWidth) && !!(wallpaperImage === null || wallpaperImage === void 0 ? void 0 : wallpaperImage.naturalHeight) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                backgroundImage: isDrm ? "none" : 'url("'.concat(wallpaperUrl, '")'),
                                filter: isDrm ? "none" : "blur(20px)",
                                zIndex: 0
                            },
                            children: isDrm && /*#__PURE__*/ (0,jsx_runtime.jsx)(DRMWallpaperPlayer, {
                                resource: customProfile === null || customProfile === void 0 ? void 0 : (ref4 = customProfile.wallpaperItem) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.wallpaperResources) === null || ref5 === void 0 ? void 0 : ref5.wallpaperResource
                            })
                        }),
                        !isDrm && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                position: "absolute",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "img",
                                src: wallpaperUrl,
                                alt: "",
                                sx: {
                                    maxWidth: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    backgroundColor: "#FFFFFF"
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                sx: {
                    backgroundImage: "unset",
                    boxShadow: "none",
                    backgroundColor: "transparent",
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    zIndex: "unset"
                }
            }),
            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Image, {
                    id: "avatar-img",
                    src: avatarUrl,
                    width: 232,
                    style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        margin: "auto",
                        zIndex: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                color: "grey.600",
                                align: "center",
                                sx: {
                                    ml: "30px",
                                    width: "100%"
                                },
                                children: t("customProfileEdit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                                color: "primary.main",
                                onClick: function() {
                                    return setOpenCustomProfileHelp(true);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                sx: {
                                    height: 52
                                },
                                href: routerPages.CustomProfileEditWallPaper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("changeBackground")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                sx: {
                                    height: 52
                                },
                                href: routerPages.CustomProfileEditAvatar,
                                divider: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("changeAvatar")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: function() {
                                    return setOpen(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    color: "primary",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InfoModal, {
                open: openCustomProfileHelp,
                onClose: function() {
                    return setOpenCustomProfileHelp(false);
                },
                type: "help",
                title: t("customProfileHelpTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("changeBackground")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: t("changeBackgroundDesc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("changeAvatar")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: t("changeAvatarDesc")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
// 背景BGMまたはアバターボイスを再生するUI
var ProfileAudioPlayer = function(param) {
    var audioResource = param.audioResource, voiceResource = param.voiceResource;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    if (voiceResource && !audioResource) return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
        color: "grey.600",
        resource: voiceResource
    });
    if (audioResource && !voiceResource) return /*#__PURE__*/ (0,jsx_runtime.jsx)(VoicePlayer, {
        color: "grey.600",
        resource: audioResource
    });
    if (audioResource && voiceResource) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectableVoicePlayer, {
        resources: [
            {
                label: t("wallpaper"),
                resource: audioResource
            },
            {
                label: t("avatar"),
                resource: voiceResource
            }, 
        ]
    });
    return null;
};
var template_ArtistRanking = function(param) {
    var rank = param.rank, user = param.user, userId = param.userId;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            sx: {
                position: "relative",
                width: 64,
                height: 64,
                borderRadius: 1
            },
            href: generatePath(routerPages.ArtistRanking, {
                artistId: userId
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                    size: "medium",
                    rank: rank,
                    sx: {
                        transform: "translateX(-4px)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        width: 28,
                        height: 28,
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        zIndex: 3
                    },
                    src: (ref2 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : ""
                })
            ]
        })
    });
};
var MyProfile_template_MembershipCell = function(param) {
    var membership = param.membership;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    if (!(membership === null || membership === void 0 ? void 0 : membership.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        title: t("membership", "メンバーシップ"),
        titleTypographyProps: {
            variant: "h6",
            color: "grey.600"
        },
        TitleLoadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h6",
            color: "grey.600",
            children: t("membership", "メンバーシップ")
        }),
        sx: {
            ".items": {
                pt: 2,
                pb: 3
            },
            "&>.MuiBox-root": {
                pb: 0
            }
        },
        items: membership !== null && membership !== void 0 ? membership : [],
        spacing: 2,
        renderItem: function(membership, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipCard, {
                    membership: membership,
                    width: 316
                })
            }, membership.id);
        }
    });
};
var FavoriteMembersCell = function(param) {
    var favoriteMembers = param.favoriteMembers;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    px: 5,
                    py: 3,
                    color: "grey.600"
                },
                children: t("favoriteMembers")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5
                },
                children: favoriteMembers.map(function(member, index) {
                    var ref, ref1, ref2;
                    // 推しメンバーが未設定かつ推し設定がOFFの場合にリストに表示しない
                    if (!member.favoriteMember && !member.requiredFavoriteMember) {
                        return null;
                    }
                    var ref3, ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                        href: generatePath(routerPages.FavoriteMembersSelect, {
                            artistId: member.artist.id
                        }),
                        sx: {
                            display: "flex",
                            width: "100%",
                            py: 2,
                            borderRadius: 1,
                            "&:hover": {
                                bgcolor: "grey.50"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                    sx: {
                                        position: "relative"
                                    },
                                    children: [
                                        member.favoriteMember ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            sx: {
                                                width: 48,
                                                height: 48
                                            },
                                            src: (ref3 = (ref = member.favoriteMember) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.uri) !== null && ref3 !== void 0 ? ref3 : ""
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            sx: {
                                                width: 45,
                                                height: 45,
                                                bgcolor: "#FFCDD2",
                                                border: "2px solid",
                                                borderColor: "error.main",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MyPage, {
                                                sx: {
                                                    color: "error.main"
                                                }
                                            })
                                        }),
                                        config_config/* config.applicationType */.v.applicationType !== "standalone" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            sx: {
                                                width: 20,
                                                height: 20,
                                                position: "absolute",
                                                right: -2,
                                                bottom: -2,
                                                border: "2px solid white"
                                            },
                                            src: (ref4 = (ref2 = member.artist.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref4 !== void 0 ? ref4 : ""
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: {
                                        pr: 3
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            fontWeight: "medium",
                                            children: member.favoriteMember ? member.favoriteMember.name : t("noMember")
                                        }),
                                        config_config/* config.applicationType */.v.applicationType !== "standalone" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "caption",
                                            color: "text.secondary",
                                            children: member.artist.displayName
                                        })
                                    ]
                                })
                            ]
                        })
                    }, member.id);
                })
            }),
            favoriteMembers.some(function(member) {
                return !member.favoriteMember && member.requiredFavoriteMember;
            }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 3,
                    mx: 5,
                    p: 2,
                    border: "1px solid",
                    borderColor: "error.main",
                    borderRadius: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                sx: {
                                    color: "error.main"
                                },
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    color: "var(--color-Text-Primary, #20343F)",
                                    fontSize: "11px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "16px"
                                },
                                children: t("favoriteMemberNotRegistered")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        sx: {
                            mt: 1
                        },
                        children: t("favoriteMemberRequiredDescription")
                    })
                ]
            })
        ]
    });
};
var EventTicketCell = function(param) {
    var events = param.events;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    if (!config_config/* config.modules.event */.v.modules.event || !config_config/* config.modules.item */.v.modules.item || !(events === null || events === void 0 ? void 0 : (ref = events.edges) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        title: t("eventTicket", "イベントチケット"),
        listHref: routerPages.MyTickets,
        trans: t("toList", "一覧へ"),
        titleTypographyProps: {
            variant: "h6",
            color: "grey.600"
        },
        transTypographyProps: {
            variant: "subtitle1"
        },
        TitleLoadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h6",
            color: "grey.600",
            children: t("eventTicket", "イベントチケット")
        }),
        sx: {
            ".items": {
                pt: 2,
                pb: 3
            },
            "&>.MuiBox-root": {
                pb: 0
            }
        },
        items: (ref1 = events === null || events === void 0 ? void 0 : events.edges) !== null && ref1 !== void 0 ? ref1 : [],
        spacing: 2,
        renderItem: function(param, index) {
            var node = param.node;
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                children: (ref = node.myPreSaleItems) === null || ref === void 0 ? void 0 : ref.map(function(param, subIndex) {
                    var item = param.item, skuId = param.skuId;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventTicketCard, {
                        event: node,
                        item: setItemSku(item, skuId),
                        skuId: skuId,
                        width: 316
                    }, [
                        index,
                        subIndex
                    ].join("-"));
                })
            }, node.id);
        }
    });
};
var ArtistRankingCell = function(param) {
    var loading = param.loading, rankings = param.rankings;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    if (!loading && !(rankings === null || rankings === void 0 ? void 0 : rankings.length)) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        loadingItemLength: 8,
        title: t("monthlyRanking"),
        titleTypographyProps: {
            variant: "h6",
            color: "grey.600"
        },
        TitleLoadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h6",
            color: "grey.600",
            children: t("monthlyRanking")
        }),
        items: rankings !== null && rankings !== void 0 ? rankings : [],
        spacing: 4,
        LoadingComponent: ArtistRankingSkeleton,
        renderItem: function(param) {
            var node = param.node;
            var ref1, ref2, ref3;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(template_ArtistRanking, {
                rank: (ref = node === null || node === void 0 ? void 0 : (ref1 = node.latestRankingPeriod) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.myRanking) === null || ref2 === void 0 ? void 0 : ref2.rank) !== null && ref !== void 0 ? ref : 0,
                userId: node === null || node === void 0 ? void 0 : (ref3 = node.artist) === null || ref3 === void 0 ? void 0 : ref3.id,
                user: node === null || node === void 0 ? void 0 : node.artist
            }, node === null || node === void 0 ? void 0 : node.id);
        }
    });
};
var ArtistRankingSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            justifyContent: "center",
            sx: {
                position: "relative",
                width: 64,
                height: 64
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    sx: {
                        transform: "translateX(8px) rotate(-45deg)",
                        width: "calc(56px/(0.707*2))",
                        height: "calc(56px/(0.707*2))"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    sx: {
                        width: 28,
                        height: 28,
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        zIndex: 3
                    }
                })
            ]
        })
    });
};
var DigitalMembershipCardCell = function(param) {
    var digitalMembershipCards = param.digitalMembershipCards, patrons = param.patrons, currentUser = param.currentUser;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfile").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var isMultiple = (0,react.useMemo)(function() {
        return digitalMembershipCards.length > 1;
    }, [
        digitalMembershipCards.length
    ]);
    // デジタル会員証を表示するデータ
    var visibleMemberCards = (0,react.useMemo)(function() {
        var membershipWithPatron = digitalMembershipCards.map(function(card, index) {
            return {
                card: card,
                patron: patrons[index]
            };
        });
        return membershipWithPatron.filter(function(membership) {
            return membership.card.userDigitalMembershipCard;
        });
    }, [
        digitalMembershipCards,
        patrons
    ]);
    // デジタル会員証が1件もない場合は、タイトルを含めエリア自体を表示しない
    if (!(digitalMembershipCards === null || digitalMembershipCards === void 0 ? void 0 : digitalMembershipCards.some(function(card) {
        return card.userDigitalMembershipCard;
    }))) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 3,
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                sx: {
                    px: 5,
                    py: 3,
                    color: "grey.600"
                },
                children: t("digitalMembershipCards", "デジタル会員証")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    ".swiper-pagination-bullet-active": {
                        bgcolor: "grey.700"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    pagination: {
                        clickable: true
                    },
                    modules: [
                        modules/* Pagination */.tl
                    ],
                    loop: false,
                    slidesPerView: 1.2,
                    centeredSlides: true,
                    spaceBetween: 10,
                    enabled: isMultiple,
                    style: {
                        paddingBottom: isMultiple ? 40 : 0
                    },
                    children: visibleMemberCards.map(function(param, index) {
                        var card = param.card, patron = param.patron;
                        var ref, ref1, ref2, ref3, ref4;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalMembershipCard, {
                                cardDesignPath: (ref = card.userDigitalMembershipCard) === null || ref === void 0 ? void 0 : ref.cardDesignPath,
                                textColor: (ref1 = card.userDigitalMembershipCard) === null || ref1 === void 0 ? void 0 : ref1.textColor,
                                displayAreaColor: ((ref2 = card.userDigitalMembershipCard) === null || ref2 === void 0 ? void 0 : ref2.displayAreaColor) || undefined,
                                displayName: currentUser === null || currentUser === void 0 ? void 0 : currentUser.displayName,
                                membershipNumber: card.formattedMembershipNumber || undefined,
                                planInterval: patron === null || patron === void 0 ? void 0 : (ref3 = patron.plan) === null || ref3 === void 0 ? void 0 : ref3.interval,
                                joinDate: card.createdAt,
                                favoriteMemberCreatedAt: (ref4 = card.favoriteMember) === null || ref4 === void 0 ? void 0 : ref4.createdAt,
                                onClick: function() {
                                    router.push(generatePath(routerPages.DigitalMembershipCardDetail, {
                                        artistId: card.artist.id
                                    }));
                                },
                                displayAreaSx: {
                                    // Swiperの中ではパディング分を含めて高さが計算されるため、想定より表示エリアの領域が大きくなってしまうので高さを調整する
                                    height: "calc(32.2% - 16px)"
                                }
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/core/myFavorite/useSettingMyFavoriteModal.tsx + 1 modules
var useSettingMyFavoriteModal = __webpack_require__(21657);
;// CONCATENATED MODULE: ./src/components/pages/MyProfile/viewModel.ts



function MyProfile_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyProfile(\n    $artistId: ID\n    $pageInput: PageInput\n    $fetchMyPreSaleEvents: Boolean!\n    $isStandalone: Boolean!\n  ) {\n    user @skip(if: $fetchMyPreSaleEvents) {\n      ...UserConnection\n      organizationFollowees {\n        ...FollowArtists\n      }\n      organizationPatrons {\n        ...PatronDetail\n        ...FavoriteMember\n      }\n    }\n    artist(id: $artistId) @include(if: $isStandalone) {\n      ...ArtistBottomTab\n      currentLive {\n        id\n      }\n    }\n    prepaidPointBalance @skip(if: $fetchMyPreSaleEvents) {\n      prepaidPointId\n      balance\n    }\n    organizationArtistRankings @skip(if: $fetchMyPreSaleEvents) {\n      ...OrganizationArtistRankingsConnection\n    }\n    myPreSaleEvents(filter: all, pageInput: $pageInput) {\n      ...MyPreSaleEventConnection\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    MyProfile_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var MyProfile_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,auth/* useCurrentUser */.xJ)(), userClaims = ref10.userClaims, currentUser = ref10.user;
    var showModal = (0,useSettingMyFavoriteModal/* useSettingMyFavoriteModal */.m)().showModal;
    var ref11 = (0,useQuery/* useQuery */.aM)(MyProfile_viewModel_QUERY, {
        variables: {
            artistId: config_config/* config.artistId */.v.artistId,
            fetchMyPreSaleEvents: false,
            isStandalone: config_config/* config.applicationType */.v.applicationType === "standalone"
        },
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted(param) {
            var myPreSaleEvents = param.myPreSaleEvents, artist = param.artist, user = param.user;
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (artist) {
                                (0,vars/* currentArtistVar */.ag)(artist);
                            }
                            if (!(!(myPreSaleEvents === null || myPreSaleEvents === void 0 ? void 0 : (ref = myPreSaleEvents.edges) === null || ref === void 0 ? void 0 : ref.length) && (myPreSaleEvents === null || myPreSaleEvents === void 0 ? void 0 : myPreSaleEvents.pageInfo.hasNextPage))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                fetchMore({
                                    variables: {
                                        artistId: config_config/* config.artistId */.v.artistId,
                                        fetchMyPreSaleEvents: true,
                                        pageInput: {
                                            cursor: myPreSaleEvents.pageInfo.endCursor
                                        },
                                        isStandalone: config_config/* config.applicationType */.v.applicationType === "standalone"
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), data = ref11.data, loading = ref11.loading, fetchMore = ref11.fetchMore, networkStatus = ref11.networkStatus;
    var isNextFetch = !!data;
    // 会員番号があるメンバーシップを表示
    var displayMembership = (0,react.useMemo)(function() {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationPatrons.filter(function(patron) {
            if (patron.formattedMembershipNumber) {
                return true;
            }
            return false;
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationPatrons
    ]);
    var patrons = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var patrons = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.organizationPatrons.flat().filter(function(item) {
            return item;
        })) !== null && ref1 !== void 0 ? ref1 : [];
        return patrons.map(function(patron) {
            var ref;
            var ref1;
            return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(patron.artist, (ref1 = (ref = patron.subscription) === null || ref === void 0 ? void 0 : ref.planId) !== null && ref1 !== void 0 ? ref1 : "");
        }).filter(function(product) {
            return product != null;
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.organizationPatrons
    ]);
    (0,react.useEffect)(function() {
        if (networkStatus === core_networkStatus/* NetworkStatus.ready */.Ie.ready) {
            // 推しメンバー設定が必要な場合はモーダルを表示
            if (data === null || data === void 0 ? void 0 : data.user) {
                var requiredFavoriteMemberPatron = data.user.organizationPatrons.find(function(patron) {
                    return patron.requiredFavoriteMember;
                });
                if (requiredFavoriteMemberPatron) {
                    showModal({
                        requiredFavoriteMemberArtistId: requiredFavoriteMemberPatron.artistId
                    });
                }
            }
        }
    }, [
        networkStatus,
        data === null || data === void 0 ? void 0 : data.user
    ]);
    var ref12, ref13, ref14, ref15, ref16;
    return {
        state: {
            loading: loading && !isNextFetch,
            fetchingMyPreSaleEvents: networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables || networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            currentUser: currentUser !== null && currentUser !== void 0 ? currentUser : null,
            user: (ref12 = data === null || data === void 0 ? void 0 : data.user) !== null && ref12 !== void 0 ? ref12 : null,
            isCustom: !!((data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.customProfile) === null || ref3 === void 0 ? void 0 : ref3.avatarItem) || (data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.customProfile) === null || ref5 === void 0 ? void 0 : ref5.wallpaperItem)),
            prepaidPointBalance: (ref13 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref13 !== void 0 ? ref13 : null,
            isArtist: !!(userClaims === null || userClaims === void 0 ? void 0 : (ref6 = userClaims.orgs) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[config_config/* config.organizationId */.v.organizationId]) === null || ref7 === void 0 ? void 0 : ref7.artist),
            artistRankings: (ref14 = data === null || data === void 0 ? void 0 : (ref8 = data.organizationArtistRankings) === null || ref8 === void 0 ? void 0 : ref8.edges.filter(function(param) {
                var node = param.node;
                return node.status === utoniq_core_schema/* RankingStatus.Active */.HBK.Active;
            })) !== null && ref14 !== void 0 ? ref14 : null,
            events: (ref15 = data === null || data === void 0 ? void 0 : data.myPreSaleEvents) !== null && ref15 !== void 0 ? ref15 : null,
            membership: displayMembership !== null && displayMembership !== void 0 ? displayMembership : [],
            favoriteMembers: (ref16 = data === null || data === void 0 ? void 0 : (ref9 = data.user) === null || ref9 === void 0 ? void 0 : ref9.organizationPatrons) !== null && ref16 !== void 0 ? ref16 : [],
            patrons: patrons
        },
        actions: {}
    };
});
var MyProfile_viewModel_QUERY = (0,lib/* gql */.Ps)(MyProfile_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* UserConnectionFragmentDoc */.N76, utoniq_core_schema/* FollowArtistsFragmentDoc */.gND, utoniq_core_schema/* OrganizationArtistRankingsConnectionFragmentDoc */.XD9, utoniq_core_schema/* MyPreSaleEventConnectionFragmentDoc */.K1k, utoniq_core_schema/* PatronDetailFragmentDoc */.wvv, utoniq_core_schema/* FavoriteMemberFragmentDoc */.CK2);

;// CONCATENATED MODULE: ./src/components/pages/MyProfile/index.tsx



/**
 * MyProfile Page
 * Implemented as a practical sample.
 */ var MyProfile = function() {
    var state = MyProfile_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyProfileEdit/template/MyProfileEditForm.tsx










var MyProfileEditForm_schema = function(o) {
    return {
        avatarPath: o.string().optional().allow("", null).label((0,core_form/* tLabel */.TQ)("myProfileEdit.avatarPath")),
        displayName: o.string().max(50).custom(function(value, helpers) {
            // 特殊文字チェック
            var match = value.match(/[=+\-@\t\r\n;,]+/);
            if (match) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("common:inputContainSpecialChars", {
                        label: (0,core_form/* tLabel */.TQ)("myProfileEdit.displayName")
                    })
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("myProfileEdit.displayName")),
        accountId: o.string().pattern(new RegExp(/^[a-zA-Z0-9_]*$/)).max(20).label((0,core_form/* tLabel */.TQ)("myProfileEdit.accountId")),
        introduction: o.string().max(150).optional().allow("").label((0,core_form/* tLabel */.TQ)("myProfileEdit.introduction"))
    };
};
/**
 *  MyProfileEdit Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */ var MyProfileEditForm = function(param) {
    var user = param.user, onSubmitMyProfile = param.onSubmitMyProfile, onClickAvatar = param.onClickAvatar;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfileEdit").t;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: MyProfileEditForm_schema,
        defaultValues: MyProfileEditForm_defaultValues
    }), handleSubmit = ref2.handleSubmit, errors = ref2.formState.errors, register = ref2.register, reset = ref2.reset, setValue = ref2.setValue, setError = ref2.setError;
    (0,react.useEffect)(function() {
        if (!user) {
            return;
        }
        var _displayName, _introduction, _accountId;
        reset({
            displayName: (_displayName = user.displayName) !== null && _displayName !== void 0 ? _displayName : "",
            avatarPath: null,
            introduction: (_introduction = user.introduction) !== null && _introduction !== void 0 ? _introduction : "",
            accountId: (_accountId = user.accountId) !== null && _accountId !== void 0 ? _accountId : ""
        });
    }, [
        user,
        reset
    ]);
    var onSubmit = handleSubmit(function(values) {
        return onSubmitMyProfile(values).then(function() {
            setValue("avatarPath", null, {
                shouldValidate: true
            });
            showMessage(t("submitSuccess"), "success");
        }).catch(function(error) {
            (0,core_form/* handleError */.S3)(error, setError, showError);
        });
    });
    var handleOnClick = (0,react.useCallback)(function() {
        var _onClick = (0,src_async_to_generator/* default */.Z)(function() {
            var result, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onClickAvatar()
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result) {
                            return [
                                2
                            ];
                        }
                        setValue("avatarPath", (ref = result === null || result === void 0 ? void 0 : result.tmpPath) !== null && ref !== void 0 ? ref : null, {
                            shouldValidate: true
                        });
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        function onClick() {
            return _onClick.apply(this, arguments);
        }
        return onClick;
    }(), [
        onClickAvatar,
        setValue
    ]);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        id: "my-profile-edit-form",
        onSubmit: onSubmit,
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditForm_AvatarUploadCell, (0,src_object_spread/* default */.Z)({
                onClick: handleOnClick,
                avatarProps: {
                    src: (ref3 = user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref3 !== void 0 ? ref3 : ""
                },
                titleProps: {
                    color: "primary.main",
                    sx: {
                        pt: 2
                    }
                },
                type: "image",
                error: errors === null || errors === void 0 ? void 0 : errors.avatarPath
            }, register("avatarPath"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.displayName
            }, register("displayName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.accountId
            }, register("accountId"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "textarea",
                textFieldProps: {
                    multiline: true,
                    rows: 5,
                    InputProps: {
                        sx: {
                            px: 4,
                            py: 3
                        }
                    }
                },
                error: errors === null || errors === void 0 ? void 0 : errors.introduction
            }, register("introduction")))
        ]
    });
};
var MyProfileEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("myProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var MyProfileEditForm_AvatarUploadCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("myProfileEdit").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AvatarUploadField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var MyProfileEditForm_defaultValues = {
    avatarPath: "",
    displayName: "",
    accountId: "",
    introduction: ""
};

;// CONCATENATED MODULE: ./src/components/pages/MyProfileEdit/template/index.tsx






var MyProfileEditTemplate = function(param) {
    var _state = param.state, user = _state.user, userProfileUpdating = _state.userProfileUpdating, avatarUploading = _state.avatarUploading, onSubmitMyProfile = param.onSubmitMyProfile, onClickAvatar = param.onClickAvatar;
    var t = (0,core_i18n/* useTranslation */.$G)("myProfileEdit").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.MyProfile,
            type: "modal",
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                form: "my-profile-edit-form",
                loading: userProfileUpdating || avatarUploading,
                type: "submit",
                variant: "contained",
                color: "primary",
                sx: {
                    height: 28,
                    whiteSpace: "nowrap"
                },
                children: t("submit")
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyProfileEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditForm, {
                user: user !== null && user !== void 0 ? user : null,
                onSubmitMyProfile: onSubmitMyProfile,
                onClickAvatar: onClickAvatar
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyProfileEdit/viewModel.ts




function MyProfileEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyProfileEdit {\n    user {\n      ...UserConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MyProfileEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyProfileEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateMyProfileEdit($updateUserProfileInputs: UpdateProfileInput!) {\n    updateUserProfile(inputs: $updateUserProfileInputs) {\n      ...UserConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MyProfileEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var MyProfileEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var reloadUser = (0,auth/* useAuth */.aC)().reloadUser;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var getImage = camera/* getImage */.g;
    var ref1;
    var upload = (0,useTmpUploader/* useUserTmpUploader */.x)((ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : "").upload;
    var ref2 = (0,react.useState)(false), avatarUploading = ref2[0], setAvatarUploading = ref2[1];
    var data = (0,useQuery/* useQuery */.aM)(MyProfileEdit_viewModel_QUERY).data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(MyProfileEdit_viewModel_MUTATION), 2), updateUserProfile = ref3[0], ref4 = ref3[1], userProfileUpdating = ref4.loading;
    var ref5;
    return {
        state: {
            userProfileUpdating: userProfileUpdating,
            avatarUploading: avatarUploading,
            user: (ref5 = data === null || data === void 0 ? void 0 : data.user) !== null && ref5 !== void 0 ? ref5 : null
        },
        actions: {
            onSubmitMyProfile: function onSubmitMyProfile(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserProfile({
                                        variables: {
                                            updateUserProfileInputs: {
                                                displayName: values.displayName,
                                                accountId: values.accountId,
                                                introduction: values.introduction,
                                                avatarPath: values.avatarPath
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // re-fetch user from auth
                                return [
                                    4,
                                    reloadUser()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    router.goBack(routerPages.MyProfile)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickAvatar: function onClickAvatar() {
                return getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image).then(function(file) {
                    if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                        throw new Error("uploadErrorMaximumSize");
                    }
                    setAvatarUploading(true);
                    return upload(file);
                }).catch(function(error) {
                    if (error.message === "uploadErrorMaximumSize") {
                        showError(new Error(t("uploadErrorMaximumSize")));
                        return;
                    }
                    if (error.message === "uploadErrorImageOnly") {
                        showError(new Error(t("uploadErrorImageOnly")));
                        return;
                    }
                    showError(error);
                    return;
                }).finally(function() {
                    setAvatarUploading(false);
                });
            }
        }
    };
});
var MyProfileEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(MyProfileEdit_viewModel_templateObject(), utoniq_core_schema/* UserConnectionFragmentDoc */.N76);
var MyProfileEdit_viewModel_MUTATION = (0,lib/* gql */.Ps)(MyProfileEdit_viewModel_templateObject1(), utoniq_core_schema/* UserConnectionFragmentDoc */.N76);

;// CONCATENATED MODULE: ./src/components/pages/MyProfileEdit/index.tsx



/**
 * MyProfileEdit Page
 * Implemented as a practical sample.
 */ var MyProfileEdit = function() {
    var ref = MyProfileEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyProfileEditTemplate, {
        state: state,
        onSubmitMyProfile: actions.onSubmitMyProfile,
        onClickAvatar: actions.onClickAvatar
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyRanking/template/index.tsx















var MyRankingTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onChangePeriod = param.onChangePeriod;
    var t = (0,core_i18n/* useTranslation */.$G)("myRanking").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref = (0,react.useState)(0), currentSegment = ref[0], setCurrentSegment = ref[1];
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ranking")).onClick;
    (0,react.useEffect)(function() {
        setCurrentSegment(state.periodType === utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly ? 0 : 1);
    }, [
        state.periodType
    ]);
    var handleChangeSegment = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(segment) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCurrentSegment(segment);
                        return [
                            4,
                            onChangePeriod(segment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(segment) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangePeriod
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyRanking
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                        edge: "end",
                        color: "primary.main",
                        onClick: onClick
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Segment, {
                    labels: [
                        t("month"),
                        t("total")
                    ],
                    value: currentSegment,
                    disableAnimateTransitions: true,
                    onChange: handleChangeSegment,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_RankingsCell, {
                            loading: state.loading || state.refetching,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: function() {
                                return onFetchMore(currentSegment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly);
                            },
                            rankings: currentSegment === 0 && !state.loading ? state.rankings : null,
                            note: state.period ? t("aggregationPeriod", {
                                period: state.period
                            }) : undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_RankingsCell, {
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: function() {
                                return onFetchMore(currentSegment === 0 ? utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly : utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly);
                            },
                            rankings: currentSegment === 1 && !state.loading ? state.rankings : null
                        })
                    ]
                })
            })
        ]
    });
};
var template_RankingsCell = function(param) {
    var loading = param.loading, rankings = param.rankings, note = param.note, hasNextPage = param.hasNextPage, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("myRanking").t;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            children: [
                !!note && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.hint",
                    children: note
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    children: t("currentStanding")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: rankings === null || rankings === void 0 ? void 0 : rankings.edges.filter(function(param) {
                            var node = param.node;
                            return (node === null || node === void 0 ? void 0 : node.status) === utoniq_core_schema/* RankingStatus.Active */.HBK.Active;
                        }).map(function(param) {
                            var node = param.node;
                            var ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                            return node && /*#__PURE__*/ (0,jsx_runtime.jsx)(RankListItem, {
                                displayName: (ref = (ref4 = node.artist) === null || ref4 === void 0 ? void 0 : ref4.displayName) !== null && ref !== void 0 ? ref : "",
                                avatarUrl: (ref1 = (ref5 = node.artist) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.avatar) === null || ref6 === void 0 ? void 0 : ref6.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                                point: (ref2 = (ref7 = node.latestRankingPeriod) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.myRanking) === null || ref8 === void 0 ? void 0 : ref8.point) !== null && ref2 !== void 0 ? ref2 : 0,
                                rank: (ref3 = (ref9 = node.latestRankingPeriod) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.myRanking) === null || ref10 === void 0 ? void 0 : ref10.rank) !== null && ref3 !== void 0 ? ref3 : 0,
                                userId: node.artistId
                            }, node.id);
                        }),
                        componentProps: {
                            spacing: 2
                        },
                        loading: loading,
                        hasNextPage: hasNextPage,
                        onFetchMore: onFetchMore,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            children: Array.from(Array(4).keys()).map(function(index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RankListItemSkeleton, {}, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyRanking/viewModel.ts



function MyRanking_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyRanking($periodType: RankingPeriodType!, $pageInput: PageInput) {\n    organizationArtistRankings(pageInput: $pageInput) {\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n      edges {\n        node {\n          ... on Ranking {\n            ...RankingBaseConnection\n            latestRankingPeriod(periodType: $periodType) {\n              ...RankingPeriodBaseConnection\n              myRanking {\n                ...RankingUserWithoutIdConnection\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    MyRanking_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var MyRanking_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1 = (0,useQuery/* useQuery */.aM)(MyRanking_viewModel_QUERY, {
        variables: {
            periodType: router.query.tab === "total" ? utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly : utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly,
            pageInput: {
                limit: 10
            }
        },
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), data = ref1.data, networkStatus = ref1.networkStatus;
    var period = (0,react.useMemo)(function() {
        return "".concat(dayjs_min_default()().startOf("month").format("ll"), "〜").concat(dayjs_min_default()().format("ll"));
    }, []);
    var ref2;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading || networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            rankings: (ref2 = data === null || data === void 0 ? void 0 : data.organizationArtistRankings) !== null && ref2 !== void 0 ? ref2 : null,
            hasNextPage: false,
            periodType: router.query.tab === "total" ? utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly : utoniq_core_schema/* RankingPeriodType.Monthly */.$gR.Monthly,
            period: period
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onChangePeriod: function onChangePeriod(periodType) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        router.replace(generatePath(routerPages.MyRanking, {
                            tab: periodType === utoniq_core_schema/* RankingPeriodType.Yearly */.$gR.Yearly ? "total" : "monthly"
                        }));
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var MyRanking_viewModel_QUERY = (0,lib/* gql */.Ps)(MyRanking_viewModel_templateObject(), utoniq_core_schema/* RankingBaseConnectionFragmentDoc */.MHS, utoniq_core_schema/* RankingPeriodBaseConnectionFragmentDoc */.CqK, utoniq_core_schema/* RankingUserWithoutIdConnectionFragmentDoc */.u1C);

;// CONCATENATED MODULE: ./src/components/pages/MyRanking/index.tsx




/**
 * MyRanking Page
 * Implemented as a practical sample.
 */ var MyRanking = function() {
    var ref = MyRanking_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyRankingTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(35838);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
;// CONCATENATED MODULE: ./src/components/pages/MyTickets/template/index.tsx













var MyTicketsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilter = param.onFilter;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("myTickets").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var events = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!((ref = state.events) === null || ref === void 0 ? void 0 : ref.edges)) {
            return undefined;
        }
        var ref2;
        return flatMap_default()((ref1 = state.events) === null || ref1 === void 0 ? void 0 : ref1.edges, function(param) {
            var node = param.node;
            var ref;
            return (ref2 = (ref = node.myPreSaleItems) === null || ref === void 0 ? void 0 : ref.map(function(myPreSaleItem) {
                return (0,src_object_spread/* default */.Z)({
                    event: node
                }, myPreSaleItem);
            })) !== null && ref2 !== void 0 ? ref2 : [];
        });
    }, [
        (ref = state.events) === null || ref === void 0 ? void 0 : ref.edges
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        navigation: {
            type: "global",
            props: {
                hasManagementTask: !!((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.hasManagementTask),
                unreadNotificationCount: (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.unreadNotificationCount,
                hasSettingTask: !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.isMembershipPersonalInformationRequired)
            }
        },
        margin: true,
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyTickets
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyTickets_template_FilterMenu, {
                filter: state.filter,
                onFilter: onFilter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: events === null || events === void 0 ? void 0 : events.map(function(param, index) {
                    var event = param.event, item = param.item, skuId = param.skuId;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventTicketCard, {
                        event: event,
                        item: setItemSku(item, skuId),
                        skuId: skuId
                    }, index);
                }),
                loading: state.loading || state.fetching,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                componentProps: {
                    spacing: 4,
                    pt: 2,
                    pb: 6
                },
                emptyMessage: t("emptyEventTicketMessage"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    flexDirection: "column",
                    sx: {
                        pt: 2,
                        pb: 7
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            sx: {
                                width: "100%",
                                height: 216,
                                borderRadius: 2
                            }
                        }, key);
                    })
                })
            })
        ]
    });
};
var MyTickets_template_FilterMenu = function(param) {
    var filter = param.filter, onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("myTickets").t;
    var handleSelect = (0,react.useCallback)(function(value) {
        onFilter(value);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
        value: filter,
        onClick: handleSelect,
        tags: [
            {
                value: utoniq_core_schema/* EventHeldStatus.All */.bRM.All,
                label: t("all", "すべて")
            },
            {
                value: utoniq_core_schema/* EventHeldStatus.Ongoing */.bRM.Ongoing,
                label: t("clear", "開催中")
            },
            {
                value: utoniq_core_schema/* EventHeldStatus.Upcoming */.bRM.Upcoming,
                label: t("upcoming", "開催予定")
            },
            {
                value: utoniq_core_schema/* EventHeldStatus.Finished */.bRM.Finished,
                label: t("alreadyHeld", "開催済")
            }, 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyTickets/viewModel.ts



function MyTickets_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyTickets(\n    $filter: EventHeldStatus!\n    $pageInput: PageInput\n    $skipUser: Boolean!\n  ) {\n    myPreSaleEvents(filter: $filter, pageInput: $pageInput) {\n      ...MyPreSaleEventConnection\n    }\n    user @skip(if: $skipUser) {\n      id\n      hasWaitingPaymentItems\n      hasUnappliedDeliveryItems\n      hasManagementTask @client\n      unreadNotificationCount\n      isMembershipPersonalInformationRequired\n    }\n  }\n  ",
        "\n"
    ]);
    MyTickets_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var MyTickets_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,react.useState)(utoniq_core_schema/* EventHeldStatus.All */.bRM.All), filter = ref2[0], setFilter = ref2[1];
    var myPreSaleEventsBeforeFetchRef = (0,react.useRef)();
    var isFirstLoadRef = useGetNewestData({
        query: MyTickets_viewModel_QUERY,
        variables: {
            filter: utoniq_core_schema/* EventHeldStatus.All */.bRM.All,
            skipUser: true
        },
        fields: [
            {
                fieldName: "myPreSaleEvents",
                fragmentName: "EventTicketCard",
                fragment: utoniq_core_schema/* EventTicketCardFragmentDoc */.wU5
            }, 
        ]
    }).isFirstLoadRef;
    var ref3 = (0,useQuery/* useQuery */.aM)(MyTickets_viewModel_QUERY, {
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        variables: {
            filter: utoniq_core_schema/* EventHeldStatus.All */.bRM.All,
            skipUser: false
        },
        onCompleted: function onCompleted(param) {
            var myPreSaleEvents = param.myPreSaleEvents;
            return (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isFirstLoadRef.current = false;
                            if (!((!(myPreSaleEvents === null || myPreSaleEvents === void 0 ? void 0 : (ref = myPreSaleEvents.edges) === null || ref === void 0 ? void 0 : ref.length) || ((ref1 = myPreSaleEventsBeforeFetchRef.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.length) === myPreSaleEvents.edges.length) && (myPreSaleEvents === null || myPreSaleEvents === void 0 ? void 0 : myPreSaleEvents.pageInfo.hasNextPage))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                fetchMore({
                                    variables: {
                                        filter: filter,
                                        pageInput: {
                                            cursor: myPreSaleEvents.pageInfo.endCursor
                                        }
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            myPreSaleEventsBeforeFetchRef.current = myPreSaleEvents;
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }), data = ref3.data, fetchMore = ref3.fetchMore, loading = ref3.loading, refetch = ref3.refetch, networkStatus = ref3.networkStatus;
    var isNextFetch = (data === null || data === void 0 ? void 0 : (ref = data.myPreSaleEvents) === null || ref === void 0 ? void 0 : ref.edges) !== undefined;
    var ref4, ref5;
    return {
        state: {
            loading: loading && !isNextFetch,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore || networkStatus === core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables,
            events: (ref4 = data === null || data === void 0 ? void 0 : data.myPreSaleEvents) !== null && ref4 !== void 0 ? ref4 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.myPreSaleEvents) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            user: (ref5 = data === null || data === void 0 ? void 0 : data.user) !== null && ref5 !== void 0 ? ref5 : null,
            filter: filter
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            filter: filter,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.myPreSaleEvents) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilter: function onFilter(newFilter) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setFilter(newFilter);
                                return [
                                    4,
                                    refetch({
                                        filter: newFilter
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyTickets_viewModel_QUERY = (0,lib/* gql */.Ps)(MyTickets_viewModel_templateObject(), utoniq_core_schema/* MyPreSaleEventConnectionFragmentDoc */.K1k);

;// CONCATENATED MODULE: ./src/components/pages/MyTickets/index.tsx




/**
 * MyTickets Page
 * Implemented as a practical sample.
 */ var MyTickets = function() {
    var ref = MyTickets_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyTicketsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/MyTrade/template/index.tsx













var TRADE_STATUS = {
    request: [
        [
            utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress
        ],
        [
            utoniq_core_schema/* TradeNegotiationStatus.Agreed */._JF.Agreed
        ],
        [
            utoniq_core_schema/* TradeNegotiationStatus.BrokenOff */._JF.BrokenOff,
            utoniq_core_schema/* TradeNegotiationStatus.Dropped */._JF.Dropped
        ], 
    ],
    candidate: [
        [
            utoniq_core_schema/* TradeCandidateNegotiationStatus.InProgress */.kzO.InProgress
        ],
        [
            utoniq_core_schema/* TradeCandidateNegotiationStatus.Accepted */.kzO.Accepted
        ],
        [
            utoniq_core_schema/* TradeCandidateNegotiationStatus.Rejected */.kzO.Rejected,
            utoniq_core_schema/* TradeCandidateNegotiationStatus.Dropped */.kzO.Dropped,
            utoniq_core_schema/* TradeCandidateNegotiationStatus.Expired */.kzO.Expired, 
        ], 
    ]
};
var template_tabs = [
    "candidate",
    "request"
];
var MyTradeTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onChangeStatus = param.onChangeStatus, onChangeSegment = param.onChangeSegment;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var t = (0,core_i18n/* useTranslation */.$G)("myTrade").t;
    var ref = (0,react.useState)(state.filter.type === "request" ? 1 : 0), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)({
        type: state.filter.type,
        eventFilter: state.filter.eventFilter
    }), filter = ref1[0], setFilter = ref1[1];
    var handleChangeSegment = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValue(newValue);
                        return [
                            4,
                            onChangeSegment({
                                type: newValue ? "request" : "candidate"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeSegment
    ]);
    (0,react.useEffect)(function() {
        setFilter({
            type: value ? "request" : "candidate",
            eventFilter: "all"
        });
    }, [
        value
    ]);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.MyTrade
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                value: value,
                onChange: handleChangeSegment,
                disableAnimateTransitions: true,
                labels: [
                    t("tradesFiled"),
                    t("tradeApplied")
                ],
                children: template_tabs.map(function(type, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TransactionCell, {
                        type: type,
                        loading: state.loading,
                        hasNextPage: type === "request" ? state.hasNextPageRequest : state.hasNextPageCandidates,
                        trades: type === "request" ? state.tradeRequests : state.tradeCandidates,
                        myUserId: (ref2 = (ref = state.currentUser) === null || ref === void 0 ? void 0 : ref.uid) !== null && ref2 !== void 0 ? ref2 : "",
                        onFetchMore: onFetchMore,
                        onChangeStatus: onChangeStatus,
                        filter: filter
                    }, index);
                })
            })
        ]
    });
};
var TransactionCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, trades = param.trades, onFetchMore = param.onFetchMore, onChangeStatus = param.onChangeStatus, type = param.type, myUserId = param.myUserId, filter = param.filter;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("myTrade").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var open = Boolean(anchorEl);
    var options = (0,react.useMemo)(function() {
        return [
            {
                param: "all",
                label: t("all"),
                value: undefined
            },
            {
                param: "duringTrading",
                label: t("duringTrading"),
                value: 0
            },
            {
                param: "success",
                label: t("success"),
                value: 1
            },
            {
                param: "failure",
                label: t("failure"),
                value: 2
            }, 
        ];
    }, [
        t
    ]);
    var ref3;
    var initialSelectedValue = (ref3 = options.findIndex(function(option) {
        return option.param === filter.eventFilter;
    })) !== null && ref3 !== void 0 ? ref3 : 0;
    var ref4 = (0,react.useState)(initialSelectedValue === -1 ? 0 : initialSelectedValue), selectedIndex = ref4[0], setSelectedIndex = ref4[1];
    (0,react.useEffect)(function() {
        var UrlParams = "?type=".concat(type, "&filter=").concat(options[selectedIndex].param);
        // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
        window.history.replaceState(null, "", UrlParams);
    }, [
        selectedIndex
    ]);
    (0,react.useEffect)(function() {
        onChangeStatus({
            status: TRADE_STATUS[type][selectedIndex - 1],
            type: type
        });
    }, []);
    var handleFilterClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = (0,react.useCallback)(function(event, newIndex) {
        setSelectedIndex(newIndex);
        setAnchorEl(null);
        return onChangeStatus({
            status: TRADE_STATUS[type][newIndex - 1],
            type: type
        });
    }, [
        onChangeStatus,
        type
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleFetchMore = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onFetchMore({
                            status: TRADE_STATUS[type][selectedIndex - 1],
                            type: type
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onFetchMore,
        selectedIndex,
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row-reverse",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: "fit-content",
                            mr: -2
                        },
                        onClick: handleFilterClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    pr: 1
                                },
                                children: options[selectedIndex].label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                                fontSize: "xSmall",
                                sx: {
                                    color: "grey.600"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                        id: "lock-menu",
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        MenuListProps: {
                            "aria-labelledby": "lock-button",
                            role: "listbox"
                        },
                        children: options.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50",
                                    minWidth: 200
                                },
                                selected: index === selectedIndex,
                                onClick: function(event) {
                                    return handleMenuItemClick(event, index);
                                },
                                children: option.label
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: loading,
                hasNextPage: hasNextPage,
                componentProps: {
                    spacing: 4
                },
                onFetchMore: handleFetchMore,
                emptyMessage: t("tradeEmptyMessage"),
                nodes: trades === null || trades === void 0 ? void 0 : (ref = trades.edges) === null || ref === void 0 ? void 0 : ref.map(function(param, index) {
                    var node = param.node;
                    var trades = isTradeNegotiation(node) ? node.tradeNegotiation : node;
                    if (!trades) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBox, {
                        fullWidth: true,
                        myUserId: myUserId,
                        trades: trades,
                        href: generatePath(routerPages.MyTradeDetail, {
                            tradeNegotiationId: isTradeNegotiation(node) ? node.tradeNegotiation.id : node.id
                        })
                    }, index);
                }),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 6,
                    sx: {
                        py: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBoxSkeleton, {
                            fullWidth: true
                        }, key);
                    })
                })
            })
        ]
    });
};
function isTradeNegotiation(data) {
    return "tradeNegotiation" in data;
}

;// CONCATENATED MODULE: ./src/components/pages/MyTrade/viewModel.ts




function MyTrade_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyTrade(\n    $status: [TradeCandidateNegotiationStatus!]\n    $pageInput: PageInput\n  ) {\n    tradeMyCandidates(status: $status, pageInput: $pageInput) {\n      ...TradeMyCandidatesConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MyTrade_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyTrade_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewMyTrade(\n    $status: [TradeCandidateNegotiationStatus!]\n    $pageInput: PageInput\n  ) {\n    tradeMyCandidates(status: $status, pageInput: $pageInput) {\n      ...TradeMyCandidatesConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MyTrade_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MyTrade_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyRequests($status: [TradeNegotiationStatus!], $pageInput: PageInput) {\n    tradeNegotiationsMyRequests(status: $status, pageInput: $pageInput) {\n      ...TradeNegotiationsMyRequestsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    MyTrade_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var MyTrade_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref5.user;
    var params = new URLSearchParams(window.location.search);
    var ref6;
    var eventFilter = (ref6 = params.get("filter")) !== null && ref6 !== void 0 ? ref6 : "all";
    var ref7;
    var type = (ref7 = params.get("type")) !== null && ref7 !== void 0 ? ref7 : "candidate";
    var candidateTradeStatus = [
        {
            key: "all",
            value: undefined
        },
        {
            key: "duringTrading",
            value: [
                utoniq_core_schema/* TradeCandidateNegotiationStatus.InProgress */.kzO.InProgress
            ]
        },
        {
            key: "success",
            value: [
                utoniq_core_schema/* TradeCandidateNegotiationStatus.Accepted */.kzO.Accepted
            ]
        },
        {
            key: "failure",
            value: [
                utoniq_core_schema/* TradeCandidateNegotiationStatus.Rejected */.kzO.Rejected,
                utoniq_core_schema/* TradeCandidateNegotiationStatus.Dropped */.kzO.Dropped,
                utoniq_core_schema/* TradeCandidateNegotiationStatus.Expired */.kzO.Expired, 
            ]
        }, 
    ];
    var ref8 = (0,react.useState)(false), isCalledMyTrade = ref8[0], setIsCalledMyTrade = ref8[1];
    var isFirstLoadRef = useGetNewestData({
        query: MyTrade_viewModel_FETCH_NEW_QUERY,
        variables: {
            pageInput: {
                limit: 30
            },
            status: (ref = candidateTradeStatus.find(function(element) {
                return element.key === eventFilter;
            })) === null || ref === void 0 ? void 0 : ref.value
        },
        fields: [
            {
                fieldName: "tradeMyCandidates",
                fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA,
                uniqByKey: "node.tradeNegotiation.__ref",
                generateNode: function generateNode(cache, data) {
                    return {
                        __typename: "TradeCandidate",
                        tradeNegotiation: cache.writeFragment({
                            fragment: utoniq_core_schema/* TradeBoxFragmentDoc */.CCA,
                            data: get_default()(data, "tradeNegotiation")
                        })
                    };
                }
            }, 
        ]
    }).isFirstLoadRef;
    var ref9 = (0,useQuery/* useQuery */.aM)(MyTrade_viewModel_QUERY, {
        returnPartialData: true,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref9.data, loading = ref9.loading, fetchMore = ref9.fetchMore, refetch = ref9.refetch;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ARTIST_TRADE_NEGOTIATIONS_MY_REQUESTS), 2), getTradeMyRequests = ref10[0], ref11 = ref10[1], myTradeRequests = ref11.data, fetchMoreTradeMyRequest = ref11.fetchMore, refetchTradeMyRequests = ref11.refetch, loadingCandidate = ref11.loading;
    var ref12, ref13;
    return {
        state: {
            loading: loading || loadingCandidate,
            hasNextPageRequest: !!(myTradeRequests === null || myTradeRequests === void 0 ? void 0 : (ref1 = myTradeRequests.tradeNegotiationsMyRequests) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            hasNextPageCandidates: !!(data === null || data === void 0 ? void 0 : (ref3 = data.tradeMyCandidates) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage),
            tradeRequests: (ref12 = myTradeRequests === null || myTradeRequests === void 0 ? void 0 : myTradeRequests.tradeNegotiationsMyRequests) !== null && ref12 !== void 0 ? ref12 : null,
            tradeCandidates: (ref13 = data === null || data === void 0 ? void 0 : data.tradeMyCandidates) !== null && ref13 !== void 0 ? ref13 : null,
            currentUser: currentUser,
            filter: {
                type: type,
                eventFilter: eventFilter
            }
        },
        actions: {
            onFetchMore: function onFetchMore(param) {
                var status = param.status, type = param.type;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "candidate")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            status: status,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref2 = data.tradeMyCandidates) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                fetchMoreTradeMyRequest && fetchMoreTradeMyRequest({
                                    variables: {
                                        status: status,
                                        pageInput: {
                                            cursor: myTradeRequests === null || myTradeRequests === void 0 ? void 0 : (ref = myTradeRequests.tradeNegotiationsMyRequests) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                                        }
                                    }
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onChangeSegment: function onChangeSegment(param) {
                var type = param.type;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "candidate")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetch({
                                        status: undefined
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                if (!!isCalledMyTrade) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    getTradeMyRequests({
                                        variables: {
                                            status: undefined
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                setIsCalledMyTrade(true);
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    4,
                                    refetchTradeMyRequests({
                                        status: undefined
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onChangeStatus: function onChangeStatus(param) {
                var status = param.status, type = param.type;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "candidate")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetch({
                                        status: status
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                if (!!isCalledMyTrade) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    getTradeMyRequests({
                                        variables: {
                                            status: status
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                setIsCalledMyTrade(true);
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    4,
                                    refetchTradeMyRequests({
                                        status: status
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyTrade_viewModel_QUERY = (0,lib/* gql */.Ps)(MyTrade_viewModel_templateObject(), utoniq_core_schema/* TradeMyCandidatesConnectionFragmentDoc */.xyG);
var MyTrade_viewModel_FETCH_NEW_QUERY = (0,lib/* gql */.Ps)(MyTrade_viewModel_templateObject1(), utoniq_core_schema/* TradeMyCandidatesConnectionFragmentDoc */.xyG);
var ARTIST_TRADE_NEGOTIATIONS_MY_REQUESTS = (0,lib/* gql */.Ps)(MyTrade_viewModel_templateObject2(), utoniq_core_schema/* TradeNegotiationsMyRequestsConnectionFragmentDoc */.cCD);

;// CONCATENATED MODULE: ./src/components/pages/MyTrade/index.tsx




/**
 * MyTrade Page
 * Implemented as a practical sample.
 */ var MyTrade = function() {
    var ref = MyTrade_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyTradeTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/organisms/trade/TradeDetailBox/index.tsx
var TradeDetailBox = __webpack_require__(77277);
;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeDetailBoxSkeleton/index.tsx



var TradeDetailBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            position: "relative",
            bgcolor: "background.default",
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    px: 5,
                    py: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        flex: 1,
                        alignItems: "center",
                        spacing: 2,
                        sx: {
                            pb: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TradeArrow, {
                                sx: {
                                    color: "grey.100"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarCell, {
                                direction: "ltr"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        flex: 1,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 60,
                                height: 96
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                justifyContent: "space-between",
                                sx: {
                                    maxWidth: "calc(100% - 136px)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            mr: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            numberOfLine: 2,
                                            lastWidth: "50%"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            ml: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            numberOfLine: 2,
                                            lastWidth: "50%"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 60,
                                height: 96
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 1
            })
        ]
    });
};
var AvatarCell = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? "rtl" : _direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: direction === "rtl" ? "row" : "row-reverse",
        alignItems: "center",
        flex: 1,
        spacing: 2,
        sx: direction === "rtl" ? {
            pr: 5
        } : {
            pl: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 28,
                    height: 28
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                width: "100%"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeMessageBox/index.tsx





var TradeMessageBox = function(param) {
    var message = param.message;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var _id, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        sx: {
                            px: 5,
                            width: "fit-content"
                        },
                        component: Link/* default */.Z,
                        href: generatePath(routerPages.UserProfile, {
                            userId: (_id = message.commenter.id) !== null && _id !== void 0 ? _id : ""
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref2 = (ref = message.commenter.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : "",
                                sx: {
                                    width: 28,
                                    height: 28
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                sx: {
                                    mt: 5
                                },
                                children: message.commenter.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 2,
                            wordBreak: "break-all"
                        },
                        variant: "body2",
                        color: "text.primary",
                        children: message.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        sx: {
                            textAlign: "right",
                            px: 5
                        },
                        children: message.formattedCreatedAt
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    mx: 5
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/trade/TradeMessageBoxSkeleton/index.tsx





var TradeMessageBoxSkeleton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 2,
                        sx: {
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "circular",
                                    width: 28,
                                    height: 28
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "25%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        numberOfLine: 2,
                        lastWidth: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row-reverse",
                        sx: {
                            pt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "25%"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 1
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyTradeDetail/template/TradeAcceptConfirmModal.tsx











var TradeAcceptConfirmModal_schema = function(o) {
    return {
        acceptComment: {
            artistId: o.string().optional().allow("", null),
            content: o.string().optional().allow("", null)
        }
    };
};
var TradeAcceptConfirmModal = function(param) {
    var onClose = param.onClose, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: TradeAcceptConfirmModal_schema,
        defaultValues: TradeAcceptConfirmModal_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, isSubmitting = ref.formState.isSubmitting;
    var handleAcceptConfirm = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values.acceptComment).then(function() {
                                return onClose();
                            }).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        onClose,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                edge: "start",
                size: "medium",
                onClick: onClose
            }),
            title: t("trade")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(handleAcceptConfirm),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    sx: {
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("transactionMessage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("any")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeAcceptConfirmModal_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text"
                    }, register("acceptComment.content")), {
                        textFieldProps: {
                            sx: {
                                px: 4,
                                py: 3,
                                mx: 0,
                                mt: 0,
                                mb: 3,
                                minHeight: 124,
                                bgcolor: "grey.50",
                                width: "100%",
                                borderRadius: 1
                            },
                            multiline: true,
                            minRows: 1,
                            maxRows: 5,
                            variant: "standard",
                            helperText: "",
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography === null || typography === void 0 ? void 0 : typography.body2;
                                }
                            },
                            InputProps: {
                                sx: {
                                    border: "none"
                                },
                                disableUnderline: true
                            }
                        }
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("acceptConfirmNote")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        textAlign: "center",
                        py: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        type: "submit",
                        loading: isSubmitting,
                        size: "large",
                        sx: {
                            minWidth: 244
                        },
                        children: t("trade")
                    })
                })
            ]
        })
    });
};
var TradeAcceptConfirmModal_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var TradeAcceptConfirmModal_defaultValues = {
    acceptComment: {
        artistId: "",
        content: ""
    }
};

;// CONCATENATED MODULE: ./src/components/pages/MyTradeDetail/template/TradeCancelConfirmModal.tsx











var TradeCancelConfirmModal_schema = function(o) {
    return {
        declineComment: {
            artistId: o.string().optional().allow("", null),
            content: o.string().optional().allow("", null)
        }
    };
};
var TradeCancelConfirmModal = function(param) {
    var onClose = param.onClose, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: TradeCancelConfirmModal_schema,
        defaultValues: TradeCancelConfirmModal_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, isSubmitting = ref.formState.isSubmitting;
    var handleCancelConfirm = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values.declineComment).then(function() {
                                return onClose();
                            }).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        onClose,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                edge: "start",
                size: "medium",
                onClick: onClose
            }),
            title: t("refuseTheTrade")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(handleCancelConfirm),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    sx: {
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("transactionMessage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("any")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeCancelConfirmModal_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text"
                    }, register("declineComment.content")), {
                        textFieldProps: {
                            sx: {
                                px: 4,
                                py: 3,
                                mx: 0,
                                mt: 0,
                                mb: 3,
                                minHeight: 124,
                                bgcolor: "grey.50",
                                width: "100%",
                                borderRadius: 1
                            },
                            multiline: true,
                            minRows: 1,
                            maxRows: 5,
                            variant: "standard",
                            helperText: "",
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography === null || typography === void 0 ? void 0 : typography.body2;
                                }
                            },
                            InputProps: {
                                sx: {
                                    border: "none"
                                },
                                disableUnderline: true
                            }
                        }
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.secondary",
                    children: t("cancelConfirmNote")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        textAlign: "center",
                        py: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        type: "submit",
                        loading: isSubmitting,
                        size: "large",
                        variant: "outlined",
                        sx: {
                            minWidth: 244
                        },
                        children: t("refuseTheTrade")
                    })
                })
            ]
        })
    });
};
var TradeCancelConfirmModal_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var TradeCancelConfirmModal_defaultValues = {
    declineComment: {
        artistId: "",
        content: ""
    }
};

;// CONCATENATED MODULE: ./src/components/pages/MyTradeDetail/template/index.tsx



















var MyTradeDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onReply = param.onReply, onDeclineTradeRequest = param.onDeclineTradeRequest, onCancelTradeRequest = param.onCancelTradeRequest, onAcceptTradeRequest = param.onAcceptTradeRequest;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var ref25 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref25.routerNames, generatePath = ref25.generatePath, routerPages = ref25.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref26 = (0,react.useState)(false), openReply = ref26[0], setOpenReply = ref26[1];
    var isMyRequest = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return ((ref = state.user) === null || ref === void 0 ? void 0 : ref.id) === ((ref2 = (ref1 = state.trade) === null || ref1 === void 0 ? void 0 : ref1.request.requestedByUser) === null || ref2 === void 0 ? void 0 : ref2.id);
    }, [
        (ref = state.user) === null || ref === void 0 ? void 0 : ref.id,
        (ref2 = (ref1 = state.trade) === null || ref1 === void 0 ? void 0 : ref1.request.requestedByUser) === null || ref2 === void 0 ? void 0 : ref2.id
    ]);
    var artistId = (ref4 = (ref3 = state.trade) === null || ref3 === void 0 ? void 0 : ref3.candidates[0].candidateItems[0].item.issuedArtist) === null || ref4 === void 0 ? void 0 : ref4.id;
    var title = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!((ref = state.trade) === null || ref === void 0 ? void 0 : ref.status)) {
            return t("title");
        }
        switch((ref1 = state.trade) === null || ref1 === void 0 ? void 0 : ref1.status){
            case utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress:
                return isMyRequest ? t("inProgressSendTitle") : t("inProgressReceiveTitle");
            default:
                var ref2;
                return t("".concat((ref2 = state.trade) === null || ref2 === void 0 ? void 0 : ref2.status, "Title"));
        }
    }, [
        (ref5 = state.trade) === null || ref5 === void 0 ? void 0 : ref5.status,
        t,
        isMyRequest
    ]);
    var handleReply = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onReply({
                                artistId: (ref2 = (ref1 = (ref = state.trade) === null || ref === void 0 ? void 0 : ref.candidates[0].candidateItems[0].item.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "",
                                content: values.content,
                                resources: values.resources
                            }).then(function() {
                                return setOpenReply(false);
                            }).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onReply,
        showError,
        (ref6 = state.trade) === null || ref6 === void 0 ? void 0 : ref6.candidates
    ]);
    var handleAcceptTradeRequest = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(comment) {
            var ref, ref1, ref2, ref3, ref4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onAcceptTradeRequest((ref3 = (ref1 = (ref = state.trade) === null || ref === void 0 ? void 0 : ref.candidates[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : "", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, comment), {
                                artistId: (ref4 = (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref4 !== void 0 ? ref4 : ""
                            })).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(comment) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onAcceptTradeRequest,
        showError,
        (ref7 = state.trade) === null || ref7 === void 0 ? void 0 : ref7.candidates,
        (ref8 = state.user) === null || ref8 === void 0 ? void 0 : ref8.id
    ]);
    var handleDeclineTradeRequest = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(comment) {
            var ref, ref1, ref2, ref3, ref4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onDeclineTradeRequest((ref3 = (ref1 = (ref = state.trade) === null || ref === void 0 ? void 0 : ref.candidates[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref3 !== void 0 ? ref3 : "", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, comment), {
                                artistId: (ref4 = (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref4 !== void 0 ? ref4 : ""
                            })).catch(showError)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(comment) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onDeclineTradeRequest,
        showError,
        (ref9 = state.trade) === null || ref9 === void 0 ? void 0 : ref9.candidates,
        (ref10 = state.user) === null || ref10 === void 0 ? void 0 : ref10.id
    ]);
    var handleCancelTradeRequest = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onCancelTradeRequest((ref2 = (ref1 = (ref = state.trade) === null || ref === void 0 ? void 0 : ref.candidates[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "").catch(showError)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onCancelTradeRequest,
        showError,
        (ref11 = state.trade) === null || ref11 === void 0 ? void 0 : ref11.candidates
    ]);
    /**
   * NFT 停止に向けて、NFTアイテムにリクエストされたトレード詳細ページを表示しない
   * NFT 機能停止後には削除して問題ない
   */ if ((ref14 = (ref13 = (ref12 = state.trade) === null || ref12 === void 0 ? void 0 : ref12.candidates[0]) === null || ref13 === void 0 ? void 0 : ref13.candidateItems[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.nft) === null || ref16 === void 0 ? void 0 : ref16.chains) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    var ref27, ref28, ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: [
                    routerNames.MyTradeDetail
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                customNavigation: ((ref17 = state.trade) === null || ref17 === void 0 ? void 0 : ref17.status) === utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeBottomCell, {
                    openReply: openReply,
                    setOpenReply: setOpenReply,
                    loading: state.loading,
                    onReply: handleReply,
                    userId: (ref27 = (ref18 = state.user) === null || ref18 === void 0 ? void 0 : ref18.id) !== null && ref27 !== void 0 ? ref27 : "",
                    acceptTradeRequesting: state.acceptTradeRequesting,
                    declineTradeRequesting: state.declineTradeRequesting,
                    cancelTradeRequesting: state.cancelTradeRequesting,
                    isMyRequest: isMyRequest,
                    onAcceptTradeRequest: handleAcceptTradeRequest,
                    onDeclineTradeRequest: handleDeclineTradeRequest,
                    onCancelTradeRequest: handleCancelTradeRequest
                }) : undefined,
                header: {
                    back: true,
                    type: "modal",
                    title: title,
                    defaultBackPage: artistId ? config_config/* config.applicationType */.v.applicationType === "standalone" ? generatePath(routerPages.ArtistTop, {
                        artistId: artistId
                    }) : generatePath(routerPages.ArtistTrade, {
                        artistId: artistId
                    }) : undefined
                },
                children: [
                    ((ref19 = state.trade) === null || ref19 === void 0 ? void 0 : ref19.status) === utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyTradeDetail_template_TextCell, {
                        trade: state.trade
                    }),
                    !state.loading && state.trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeDetailBox/* TradeDetailBox */.H, {
                        trade: state.trade,
                        myUserId: (ref28 = (ref20 = state.user) === null || ref20 === void 0 ? void 0 : ref20.id) !== null && ref28 !== void 0 ? ref28 : ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeDetailBoxSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: (ref21 = state.messages) === null || ref21 === void 0 ? void 0 : ref21.edges.map(function(param, index) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeMessageBox, {
                                message: node
                            }, index);
                        }),
                        loading: state.fetching || state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeMessageBoxSkeleton, {})
                        })
                    }),
                    state.loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            px: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                sx: {
                                    py: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                            variant: "circular",
                                            width: 28,
                                            height: 28
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.disabled",
                                        children: t("sendMessage")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 1
                            })
                        ]
                    }),
                    ((ref22 = state.trade) === null || ref22 === void 0 ? void 0 : ref22.status) === utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                px: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                                    component: Box_Box/* default */.Z,
                                    sx: {
                                        px: 0,
                                        py: 3
                                    },
                                    onClick: function() {
                                        return setOpenReply(function(openReply) {
                                            return !openReply;
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                                            sx: {
                                                minWidth: "auto",
                                                pr: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                src: (ref29 = (ref23 = state.user) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.avatar) === null || ref24 === void 0 ? void 0 : ref24.smallUri) !== null && ref29 !== void 0 ? ref29 : "",
                                                sx: {
                                                    width: 28,
                                                    height: 28
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                            primary: t("sendMessage"),
                                            slotProps: {
                                                primary: {
                                                    variant: "body2",
                                                    color: "text.disabled"
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var MyTradeDetail_template_TextCell = function(param) {
    var trade = param.trade;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("tradeAlert")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "text.secondary",
                    children: t("appDeadline", {
                        expiredAt: trade === null || trade === void 0 ? void 0 : trade.formattedExpiredAt
                    })
                })
            ]
        })
    });
};
// トレードを承認したりキャンセルしたりするボタン
var ProceedTradeButtonCell = function(param) {
    var loading = param.loading, isMyRequest = param.isMyRequest, acceptTradeRequesting = param.acceptTradeRequesting, declineTradeRequesting = param.declineTradeRequesting, cancelTradeRequesting = param.cancelTradeRequesting, onAcceptTradeRequest = param.onAcceptTradeRequest, onDeclineTradeRequest = param.onDeclineTradeRequest, onCancelTradeRequest = param.onCancelTradeRequest;
    var t = (0,core_i18n/* useTranslation */.$G)("myTradeDetail").t;
    var ref = (0,react.useState)(false), openAccept = ref[0], setOpenAccept = ref[1];
    var ref1 = (0,react.useState)(false), openDecline = ref1[0], setOpenDecline = ref1[1];
    var ref2 = (0,react.useState)(false), openCancel = ref2[0], setOpenCancel = ref2[1];
    var handleTradeCancel = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onCancelTradeRequest()
                    ];
                case 1:
                    _state.sent();
                    setOpenCancel(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onCancelTradeRequest
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
                sx: {
                    py: 4,
                    textAlign: "center"
                },
                children: isMyRequest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: function() {
                        return setOpenCancel(true);
                    },
                    size: "large",
                    color: "primary",
                    variant: "outlined",
                    sx: {
                        minWidth: 244
                    },
                    loading: loading,
                    children: t("cancelApp")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    direction: "row",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: function() {
                                return setOpenDecline(true);
                            },
                            size: "large",
                            variant: "outlined",
                            sx: {
                                minWidth: 140
                            },
                            children: t("refuseTheTrade")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: function() {
                                return setOpenAccept(true);
                            },
                            size: "large",
                            color: "primary",
                            sx: {
                                minWidth: 140
                            },
                            loading: acceptTradeRequesting,
                            disabled: declineTradeRequesting,
                            children: t("trade")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
                open: openAccept,
                onClose: function() {
                    return setOpenAccept(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    style: {
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeAcceptConfirmModal, {
                        onSubmit: onAcceptTradeRequest,
                        onClose: function() {
                            return setOpenAccept(false);
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
                open: openDecline,
                onClose: function() {
                    return setOpenDecline(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    style: {
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeCancelConfirmModal, {
                        onSubmit: onDeclineTradeRequest,
                        onClose: function() {
                            return setOpenDecline(false);
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openCancel,
                onClose: function() {
                    return setOpenCancel(false);
                },
                title: t("tradeCancelTitle"),
                content: t("tradeCancelDesc"),
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    loading: cancelTradeRequesting,
                    onClick: handleTradeCancel,
                    children: t("cancelApp")
                })
            })
        ]
    });
};
var TradeBottomCell = function(param) {
    var openReply = param.openReply, setOpenReply = param.setOpenReply, onReply = param.onReply, userId = param.userId, loading = param.loading, acceptTradeRequesting = param.acceptTradeRequesting, declineTradeRequesting = param.declineTradeRequesting, cancelTradeRequesting = param.cancelTradeRequesting, isMyRequest = param.isMyRequest, onAcceptTradeRequest = param.onAcceptTradeRequest, onDeclineTradeRequest = param.onDeclineTradeRequest, onCancelTradeRequest = param.onCancelTradeRequest;
    return openReply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* ClickAwayListener */.d, {
        onClickAway: function() {
            setOpenReply(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyForm/* ReplyForm */.I, {
                onReply: onReply,
                userId: userId,
                autoFocus: true
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProceedTradeButtonCell, {
        loading: loading,
        acceptTradeRequesting: acceptTradeRequesting,
        declineTradeRequesting: declineTradeRequesting,
        cancelTradeRequesting: cancelTradeRequesting,
        isMyRequest: isMyRequest,
        onAcceptTradeRequest: onAcceptTradeRequest,
        onDeclineTradeRequest: onDeclineTradeRequest,
        onCancelTradeRequest: onCancelTradeRequest
    });
};

;// CONCATENATED MODULE: ./src/components/pages/MyTradeDetail/viewModel.ts




function MyTradeDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyTradeDetail($tradeNegotiationId: ID!, $pageInput: PageInput) {\n    user {\n      id\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n    tradeNegotiation(id: $tradeNegotiationId) {\n      expiredAt\n      formattedExpiredAt @client\n      ...TradeBox\n      comments(pageInput: $pageInput) {\n        ...CommentsConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    MyTradeDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyTradeDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateTradeComment(\n    $createTradeCommentId: String!\n    $inputs: CommunityCommentInput!\n  ) {\n    createTradeComment(id: $createTradeCommentId, inputs: $inputs) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    MyTradeDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MyTradeDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclineTradeRequest($inputs: DeclineTradeRequestInput!) {\n    declineTradeRequest(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    MyTradeDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MyTradeDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AcceptTradeRequest($inputs: AcceptTradeRequestInput!) {\n    acceptTradeRequest(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    MyTradeDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MyTradeDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelTradeRequest($inputs: CancelTradeRequestInput!) {\n    cancelTradeRequest(inputs: $inputs) {\n      ...TradeBox\n    }\n  }\n  ",
        "\n"
    ]);
    MyTradeDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var MyTradeDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,useQuery/* useQuery */.aM)(MyTradeDetail_viewModel_QUERY, {
        variables: {
            tradeNegotiationId: router.query.tradeNegotiationId
        },
        returnPartialData: true
    }), data = ref4.data, fetchMore = ref4.fetchMore, networkStatus = ref4.networkStatus, refetch = ref4.refetch;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_TRADE_COMMENT), 1), createTradeComment = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ACCEPT_TRADE_REQUEST), 2), acceptTradeRequest = ref6[0], ref7 = ref6[1], acceptTradeRequesting = ref7.loading;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DECLINE_TRADE_REQUEST), 2), declineTradeRequest = ref8[0], ref9 = ref8[1], declineTradeRequesting = ref9.loading;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_TRADE_REQUEST), 2), cancelTradeRequest = ref10[0], ref11 = ref10[1], cancelTradeRequesting = ref11.loading;
    var ref12, ref13, ref14;
    return {
        state: {
            loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
            fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.tradeNegotiation) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            acceptTradeRequesting: acceptTradeRequesting,
            declineTradeRequesting: declineTradeRequesting,
            cancelTradeRequesting: cancelTradeRequesting,
            messages: (ref12 = data === null || data === void 0 ? void 0 : (ref3 = data.tradeNegotiation) === null || ref3 === void 0 ? void 0 : ref3.comments) !== null && ref12 !== void 0 ? ref12 : null,
            user: (ref13 = data === null || data === void 0 ? void 0 : data.user) !== null && ref13 !== void 0 ? ref13 : null,
            trade: (ref14 = data === null || data === void 0 ? void 0 : data.tradeNegotiation) !== null && ref14 !== void 0 ? ref14 : null
        },
        actions: {
            onReply: function onReply(comment) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createTradeComment({
                                        variables: {
                                            createTradeCommentId: router.query.tradeNegotiationId,
                                            inputs: comment
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            tradeNegotiationId: router.query.tradeNegotiationId,
                                            name: "myTrade"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            tradeNegotiationId: router.query.tradeNegotiationId,
                                            pageInput: {
                                                cursor: (ref = data === null || data === void 0 ? void 0 : data.tradeNegotiation.comments) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor,
                                                limit: 30
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAcceptTradeRequest: function onAcceptTradeRequest(tradeCandidateId, acceptComment) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var comment;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                comment = (acceptComment === null || acceptComment === void 0 ? void 0 : acceptComment.content) ? acceptComment : null;
                                return [
                                    4,
                                    acceptTradeRequest({
                                        variables: {
                                            inputs: {
                                                id: router.query.tradeNegotiationId,
                                                tradeCandidateId: tradeCandidateId,
                                                acceptComment: comment
                                            }
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_acceptTrade", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            tradeNegotiationId: router.query.tradeNegotiationId,
                                            withMessage: !!comment
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeclineTradeRequest: function onDeclineTradeRequest(tradeCandidateId, declineComment) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var comment;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                comment = (declineComment === null || declineComment === void 0 ? void 0 : declineComment.content) ? declineComment : null;
                                return [
                                    4,
                                    declineTradeRequest({
                                        variables: {
                                            inputs: {
                                                id: router.query.tradeNegotiationId,
                                                tradeCandidateId: tradeCandidateId,
                                                declineComment: comment
                                            }
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_declineTrade", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            tradeNegotiationId: router.query.tradeNegotiationId,
                                            withMessage: !!comment
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCancelTradeRequest: function onCancelTradeRequest(tradeCandidateId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    cancelTradeRequest({
                                        variables: {
                                            inputs: {
                                                id: router.query.tradeNegotiationId,
                                                tradeCandidateId: tradeCandidateId
                                            }
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancelTrade", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            tradeNegotiationId: router.query.tradeNegotiationId
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var MyTradeDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(MyTradeDetail_viewModel_templateObject(), utoniq_core_schema/* TradeBoxFragmentDoc */.CCA, utoniq_core_schema/* CommentsConnectionFragmentDoc */.M6M);
var CREATE_TRADE_COMMENT = (0,lib/* gql */.Ps)(MyTradeDetail_viewModel_templateObject1(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var DECLINE_TRADE_REQUEST = (0,lib/* gql */.Ps)(MyTradeDetail_viewModel_templateObject2());
var ACCEPT_TRADE_REQUEST = (0,lib/* gql */.Ps)(MyTradeDetail_viewModel_templateObject3());
var CANCEL_TRADE_REQUEST = (0,lib/* gql */.Ps)(MyTradeDetail_viewModel_templateObject4(), utoniq_core_schema/* TradeBoxFragmentDoc */.CCA);

;// CONCATENATED MODULE: ./src/components/pages/MyTradeDetail/index.tsx




/**
 * MyTradeDetail Page
 * Implemented as a practical sample.
 */ var MyTradeDetail = function() {
    var ref = MyTradeDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyTradeDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/MagazineItem/index.tsx








var MagazineItem = function(param) {
    var item = param.item, divider = param.divider, conductorName = param.conductorName;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("newStoreItems").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent",
            borderRadius: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.ArtistStoreItemDetail, {
                    itemId: item.id,
                    artistId: (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id
                }),
                onClick: function() {
                    var ref;
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id,
                        itemId: item.id,
                        name: conductorName
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: (ref4 = (ref1 = item.thumbnail.front) === null || ref1 === void 0 ? void 0 : ref1.mediumUri) !== null && ref4 !== void 0 ? ref4 : "",
                            sx: {
                                height: 96,
                                width: 60
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            py: 2,
                            sx: {
                                minWidth: 0
                            },
                            children: [
                                !!((ref2 = item.collection) === null || ref2 === void 0 ? void 0 : ref2.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.secondary",
                                    children: item.collection.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: item.description
                                }),
                                item.price ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        item.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                            color: "inherit",
                                            variant: "subtitle1",
                                            children: "\xa5 "
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                            color: "inherit",
                                            variant: "subtitle1",
                                            children: item.price
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "primary",
                                    children: t("free", "無料")
                                })
                            ]
                        })
                    ]
                })
            }),
            divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    mt: 2
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/MagazineItemSkeleton/index.tsx



var MagazineItemSkeleton = function(param) {
    var divider = param.divider;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                direction: "row",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 60,
                            height: 96
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "20%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                lastWidth: "33%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "large",
                                width: "18%"
                            })
                        ]
                    })
                ]
            }),
            divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    mt: 2
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NewStoreItems/template/index.tsx










var NewStoreItemsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onPurchaseCharge = param.onPurchaseCharge;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("newStoreItems").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages, routerNames = ref1.routerNames, generatePath = ref1.generatePath;
    var ref2 = (0,react.useState)(false), openPointPurchaseDrawer = ref2[0], setOpenPointPurchaseDrawer = ref2[1];
    var _point;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.NewStoreItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title"),
                    right: state.isLoggedIn && !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayPurchase/* PointDisplayPurchase */.u, {
                        point: state.formattedPoint,
                        onClick: function() {
                            return setOpenPointPurchaseDrawer(true);
                        }
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeDrawer, {
                        point: (_point = state.point) !== null && _point !== void 0 ? _point : 0,
                        onPurchase: function(plan, paymentMethod) {
                            return onPurchaseCharge(plan, paymentMethod, {
                                // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                                successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.NewStoreItems, {
                                    artistId: router.query.artistId
                                }), "?points=").concat(plan.points),
                                // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                                cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.NewStoreItems, {
                                    artistId: router.query.artistId
                                })),
                                // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                                errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.NewStoreItems, {
                                    artistId: router.query.artistId
                                }))
                            });
                        },
                        open: openPointPurchaseDrawer,
                        purchasablePrepaidPoints: state.purchasablePrepaidPoints,
                        onClose: function() {
                            return setOpenPointPurchaseDrawer(false);
                        },
                        loading: state.loading,
                        chargeLoading: state.pointChargeLoading,
                        paymentSource: state.paymentSource,
                        enablePointCarrierPayment: state.enablePointCarrierPayment,
                        pageName: "newStoreItems"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                        nodes: (ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.map(function(param, index) {
                            var node = param.node;
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MagazineItem, {
                                item: node,
                                divider: !!((ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.length) && index < ((ref1 = state.items) === null || ref1 === void 0 ? void 0 : ref1.edges.length) - 1,
                                conductorName: "newItemList"
                            }, node.id);
                        }),
                        componentProps: {
                            spacing: 2
                        },
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        onFetchMore: onFetchMore,
                        emptyMessage: t("emptyMessage"),
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            sx: {
                                pt: 2
                            },
                            children: Array.from(Array(5).keys()).map(function(index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineItemSkeleton, {
                                    divider: index < 4
                                }, index);
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NewStoreItems/viewModel.ts



function NewStoreItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query NewStoreItems(\n    $artistId: ID!\n    $filters: ItemsFilterInput\n    $pageInput: PageInputDate\n    $platform: String!\n    $purchasablePrepaidPointPageInput: PageInput\n  ) {\n    items(artistId: $artistId, filters: $filters, pageInput: $pageInput) {\n      ...NewStoreItemConnection\n    }\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n    purchasablePrepaidPoints(\n      platform: $platform\n      pageInput: $purchasablePrepaidPointPageInput\n    ) {\n      ...PurchasablePrepaidPointConnection\n    }\n    paymentSource {\n      ...PrepaidPointsPaymentSource\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    NewStoreItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









/**
 *
 */ var NewStoreItems_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var ref3 = usePointPurchase(user === null || user === void 0 ? void 0 : user.uid, platform, "newStoreItems"), purchaseByIosAndAndroid = ref3.purchaseByIosAndAndroid, purchaseByWeb = ref3.purchaseByWeb, completeNativePurchase = ref3.completeNativePurchase, setCompleteNativePurchase = ref3.setCompleteNativePurchase, chargeLoading = ref3.chargeLoading;
    var ref4 = (0,useQuery/* useQuery */.aM)(NewStoreItems_viewModel_QUERY, {
        variables: {
            platform: platform,
            artistId: artistId,
            filters: {
                isPublished: true,
                reviewStatus: "accepted",
                salesStatus: "active"
            }
        },
        skip: !user,
        notifyOnNetworkStatusChange: true,
        pollInterval: completeNativePurchase ? 2000 : 0
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    (0,react.useEffect)(function() {
        setCompleteNativePurchase(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : data.prepaidPointBalance
    ]);
    var ref5, _formattedPrepaidPointBarance, ref6, ref7, _balance;
    return {
        state: {
            items: (ref5 = data === null || data === void 0 ? void 0 : data.items) !== null && ref5 !== void 0 ? ref5 : null,
            formattedPoint: (_formattedPrepaidPointBarance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.formattedPrepaidPointBarance) !== null && _formattedPrepaidPointBarance !== void 0 ? _formattedPrepaidPointBarance : "0",
            purchasablePrepaidPoints: (ref6 = data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints) !== null && ref6 !== void 0 ? ref6 : null,
            paymentSource: (ref7 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref7 !== void 0 ? ref7 : null,
            loading: loading,
            artistId: artistId,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.items) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            isLoggedIn: !!(user === null || user === void 0 ? void 0 : user.uid),
            point: (_balance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.balance) !== null && _balance !== void 0 ? _balance : 0,
            pointChargeLoading: chargeLoading,
            /** アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref1 = data.organization) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.modules) === null || ref2 === void 0 ? void 0 : ref2.pointCarrierPayment)
        },
        actions: {
            onPurchaseCharge: platform === "web" ? purchaseByWeb : purchaseByIosAndAndroid,
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistId: artistId,
                                            filters: {
                                                isPublished: true,
                                                reviewStatus: "accepted",
                                                salesStatus: "active"
                                            },
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.items) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var NewStoreItems_viewModel_QUERY = (0,lib/* gql */.Ps)(NewStoreItems_viewModel_templateObject(), utoniq_core_schema/* NewStoreItemConnectionFragmentDoc */.$NO, utoniq_core_schema/* PrepaidPointsPaymentSourceFragmentDoc */.tE1, utoniq_core_schema/* PurchasablePrepaidPointConnectionFragmentDoc */.oBq);

;// CONCATENATED MODULE: ./src/components/pages/NewStoreItems/index.tsx




/**
 * NewStoreItems Page
 * Implemented as a practical sample.
 */ var NewStoreItems = function() {
    var ref = NewStoreItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewStoreItemsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/nft/TokenId/index.tsx






var TokenId = function(param) {
    var tokenId = param.tokenId, _variant = param.variant, variant = _variant === void 0 ? "subtitle1" : _variant, withTitle = param.withTitle;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var iconSize = {
        subtitle1: {
            height: 16,
            width: 16
        },
        subtitle2: {
            height: 12,
            width: 12
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        direction: "row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            onClick: function(e) {
                e.stopPropagation();
                e.preventDefault();
                navigator.clipboard.writeText(tokenId !== null && tokenId !== void 0 ? tokenId : "").then(function() {
                    return showMessage(t("tokenIdCopied"));
                });
            },
            /**
         * Unaffected by parent component ripple
         */ onTouchStart: function(e) {
                return e.stopPropagation();
            },
            onMouseDown: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: variant,
                    children: [
                        withTitle && t("tokenId"),
                        tokenId ? truncate_default()(tokenId, {
                            length: 8
                        }) : t("issuing")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Copy, {
                    sx: (0,src_object_spread/* default */.Z)({
                        alignSelf: "center",
                        ml: 1
                    }, iconSize[variant])
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NftItemDetail/template/index.tsx












var NftItemDetailTemplate = function(param) {
    var state = param.state, onIssueNft = param.onIssueNft, connectMetamask = param.connectMetamask, connectToWeb3auth = param.connectToWeb3auth;
    var ref, ref1, ref2;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.OwnedItemNftItemDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                customNavigation: (state === null || state === void 0 ? void 0 : state.loading) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(NftActionButtonCell, {
                    status: state === null || state === void 0 ? void 0 : (ref = state.nftToken) === null || ref === void 0 ? void 0 : ref.status,
                    tokenDetailUri: (ref3 = state === null || state === void 0 ? void 0 : (ref1 = state.nftToken) === null || ref1 === void 0 ? void 0 : ref1.tokenDetailUri) !== null && ref3 !== void 0 ? ref3 : "",
                    isConnect: state === null || state === void 0 ? void 0 : state.isConnect,
                    loading: state === null || state === void 0 ? void 0 : state.issuing,
                    onIssueNft: onIssueNft
                }),
                header: {
                    back: true
                },
                children: (state === null || state === void 0 ? void 0 : state.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItemDetail_template_LoadingCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(template_WalletConnectCell, {
                            isConnect: state === null || state === void 0 ? void 0 : state.isConnect,
                            connectMetamask: connectMetamask,
                            connectToWeb3auth: connectToWeb3auth
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "column",
                            sx: {
                                pt: 2,
                                px: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItemTitleCell, {
                                    nftActive: state === null || state === void 0 ? void 0 : state.nftActive,
                                    title: state === null || state === void 0 ? void 0 : (ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NftDetailContentsCell, {
                                    nftActive: state === null || state === void 0 ? void 0 : state.nftActive,
                                    nftToken: state === null || state === void 0 ? void 0 : state.nftToken,
                                    item: state === null || state === void 0 ? void 0 : state.item
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var template_WalletConnectCell = function(param) {
    var isConnect = param.isConnect, connectMetamask = param.connectMetamask, connectToWeb3auth = param.connectToWeb3auth;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItemDetail").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,react.useState)(false), openNftConnectDrawer = ref1[0], setOpenNftConnectDrawer = ref1[1];
    var ref2 = (0,react.useState)(false), connecting = ref2[0], setConnecting = ref2[1];
    var ref3 = (0,react.useState)(false), openWalletCreateConfirmModal = ref3[0], setOpenWalletCreateConfirmModal = ref3[1];
    var onConnectWeb3auth = function() {
        setConnecting(true);
        return connectToWeb3auth().catch(function(e) {
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenWalletCreateConfirmModal(false);
            setOpenNftConnectDrawer(false);
        });
    };
    var onConnectMetamask = function() {
        setConnecting(true);
        return connectMetamask().then(function() {
            showMessage(t("connected"));
        }).catch(function(e) {
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenNftConnectDrawer(false);
        });
    };
    if (isConnect) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "column",
        alignItems: "center",
        sx: {
            px: 7,
            py: 5,
            bgcolor: "grey.50",
            mb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                sx: {
                    mb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                        color: "error",
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: t("walletConnectDescription")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                sx: {
                    maxWidth: 88
                },
                onClick: function() {
                    return setOpenNftConnectDrawer(true);
                },
                children: t("connect")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletConnectDrawer, {
                open: openNftConnectDrawer,
                onClose: function() {
                    return setOpenNftConnectDrawer(false);
                },
                connecting: false,
                onConnectWallet: function(walletType) {
                    switch(walletType){
                        case "web3auth":
                            return setOpenWalletCreateConfirmModal(true);
                        case "metamask":
                            return onConnectMetamask();
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCryptoWalletConfirmModal, {
                open: openWalletCreateConfirmModal,
                loading: connecting,
                onClose: function() {
                    return setOpenWalletCreateConfirmModal(false);
                },
                onCreate: onConnectWeb3auth
            })
        ]
    });
};
var NftItemTitleCell = function(param) {
    var nftActive = param.nftActive, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        children: [
            nftActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Nft, {
                filledColor: true,
                sx: {
                    mr: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                children: title
            })
        ]
    });
};
var NftDetailContentsCell = function(param) {
    var nftActive = param.nftActive, nftToken = param.nftToken, item = param.item;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItemDetail").t;
    var ref14, ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("serialNumber"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.primary",
                    children: item.serialNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("tokenId"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenId, {
                    tokenId: item.tokenId
                })
            }),
            nftActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("nftOwner"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.primary",
                        sx: {
                            maxWidth: 200,
                            wordBreak: "break-all"
                        },
                        children: nftToken === null || nftToken === void 0 ? void 0 : nftToken.ownedByUserAddress
                    })
                })
            }),
            nftActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("nftIssuer"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: (ref15 = (ref14 = nftToken === null || nftToken === void 0 ? void 0 : (ref = nftToken.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.issuedArtist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.avatar) === null || ref4 === void 0 ? void 0 : ref4.smallUri) !== null && ref14 !== void 0 ? ref14 : nftToken === null || nftToken === void 0 ? void 0 : (ref5 = nftToken.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.issuedArtist) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.avatar) === null || ref9 === void 0 ? void 0 : ref9.uri) !== null && ref15 !== void 0 ? ref15 : "",
                            sx: {
                                mr: 2,
                                height: 20,
                                width: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.primary",
                            children: nftToken === null || nftToken === void 0 ? void 0 : (ref10 = nftToken.metadata) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.issuedArtist) === null || ref13 === void 0 ? void 0 : ref13.displayName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("blockChain"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    children: [
                        item.chainName === "polygon" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                            target: "common",
                            src: "images/nft/polygon.png",
                            width: 20,
                            height: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.primary",
                            sx: {
                                ml: 2
                            },
                            children: item.chainName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("royalty"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.primary",
                    children: [
                        item.royalty,
                        "%"
                    ]
                })
            }),
            nftActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox, {
                title: t("createdAt"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.primary",
                    children: nftToken === null || nftToken === void 0 ? void 0 : nftToken.formattedCreatedAt
                })
            })
        ]
    });
};
var ContentBox = function(param) {
    var title = param.title, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
            p: 3,
            border: 1,
            borderRadius: 2,
            borderColor: "grey.100",
            mb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                color: "text.secondary",
                children: title
            }),
            value
        ]
    });
};
var NftActionButtonCell = function(param) {
    var status = param.status, tokenDetailUri = param.tokenDetailUri, isConnect = param.isConnect, loading = param.loading, onIssueNft = param.onIssueNft;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        sx: {
            py: 4,
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NftActionButton, {
            status: status,
            tokenDetailUri: tokenDetailUri,
            loading: loading,
            onIssueNft: onIssueNft,
            isConnect: isConnect
        })
    });
};
var NftActionButton = function(param) {
    var status = param.status, tokenDetailUri = param.tokenDetailUri, isConnect = param.isConnect, loading = param.loading, onIssueNft = param.onIssueNft;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItemDetail").t;
    if (status === utoniq_core_schema/* ItemNftMintStatus.Completed */.A3P.Completed) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        variant: "outlined",
        size: "large",
        /** NFT 停止に向けて、ボタンを非活性に */ disabled: true,
        onClick: function() {
            return window.open(tokenDetailUri);
        },
        sx: {
            width: 244
        },
        children: t("viewDetail")
    });
    if (status === utoniq_core_schema/* ItemNftMintStatus.Processing */.A3P.Processing) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        variant: "outlined",
        size: "large",
        disabled: true,
        sx: {
            width: 244
        },
        children: t("issuing")
    });
    if (status === utoniq_core_schema/* ItemNftMintStatus.Failed */.A3P.Failed) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        variant: "outlined",
        size: "large",
        disabled: true,
        sx: {
            width: 244
        },
        children: t("issueFailed")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        size: "large",
        sx: {
            width: 244
        },
        loading: loading,
        onClick: onIssueNft,
        /** NFT 停止に向けて、ボタンを非活性に */ disabled: true,
        children: t("issueNft")
    });
};
var NftItemDetail_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "grid",
            placeItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NftItemDetail/viewModel.ts




function NftItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query NftToken($id: ID!) {\n    user {\n      id\n      cryptoWallet {\n        address\n      }\n    }\n    portfolio(id: $id) {\n      id\n      item {\n        id\n        title\n        nft {\n          chains {\n            chainName\n            royalty\n          }\n        }\n      }\n      serials {\n        serialId\n        formattedSerialNumber\n        tokenId\n        nftToken {\n          ...NftTokenDetail\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    NftItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NftItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation MintItemNft($inputs: MintItemNftInput!) {\n    mintItemNft(inputs: $inputs) {\n      id\n      chain\n      createdAt\n      formattedCreatedAt @client\n      ownedByUserAddress\n      metadata {\n        item {\n          item {\n            id\n            title\n            issuedArtist {\n              id\n              displayName\n              avatar {\n                uri\n              }\n            }\n            nft {\n              chains {\n                chainName\n              }\n            }\n          }\n          itemSerial {\n            id\n            formattedSerialNumber\n          }\n        }\n      }\n      tokenId\n      tokenURI\n      status\n    }\n  }\n"
    ]);
    NftItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var NftItemDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItemDetail").t;
    var ref19 = (0,router_useRouter/* useRouter */.tv)(), router = ref19.router, routerPages = ref19.routerPages, generatePath = ref19.generatePath;
    var ref20 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref20.showMessage, showError = ref20.showError;
    var userAuthorizeWalletBySignatureMessage = useMetamask().userAuthorizeWalletBySignatureMessage;
    var _query = router.query, itemId = _query.itemId, serialId = _query.serialId;
    var ref21 = (0,useQuery/* useQuery */.aM)(NFT_TOKEN, {
        variables: {
            id: itemId
        }
    }), data = ref21.data, loading = ref21.loading, refetch = ref21.refetch;
    var serial = data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.find(function(serial) {
        return serial.serialId === serialId;
    });
    var web3authWalletLoading = useWeb3authWalletConnect({
        loading: loading,
        walletAddress: data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cryptoWallet) === null || ref3 === void 0 ? void 0 : ref3.address,
        isArtist: true,
        refetch: refetch
    }).web3authWalletLoading;
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(MINT_ITEM_NFT), 2), mintItemNft = ref22[0], ref23 = ref22[1], issuing = ref23.loading;
    var _id, _title, ref24, ref25, ref26, ref27, ref28;
    return {
        state: {
            loading: loading || web3authWalletLoading,
            issuing: issuing,
            item: {
                id: (_id = data === null || data === void 0 ? void 0 : (ref4 = data.portfolio) === null || ref4 === void 0 ? void 0 : ref4.item.id) !== null && _id !== void 0 ? _id : null,
                title: (_title = data === null || data === void 0 ? void 0 : (ref5 = data.portfolio) === null || ref5 === void 0 ? void 0 : ref5.item.title) !== null && _title !== void 0 ? _title : null,
                royalty: (ref24 = data === null || data === void 0 ? void 0 : (ref6 = data.portfolio) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.nft) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.chains) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.royalty) !== null && ref24 !== void 0 ? ref24 : null,
                serialNumber: (ref25 = serial === null || serial === void 0 ? void 0 : serial.formattedSerialNumber) !== null && ref25 !== void 0 ? ref25 : null,
                tokenId: (ref26 = serial === null || serial === void 0 ? void 0 : serial.tokenId) !== null && ref26 !== void 0 ? ref26 : null,
                chainName: (ref27 = data === null || data === void 0 ? void 0 : (ref11 = data.portfolio) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.nft) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.chains) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.chainName) !== null && ref27 !== void 0 ? ref27 : null
            },
            nftToken: (ref28 = serial === null || serial === void 0 ? void 0 : serial.nftToken) !== null && ref28 !== void 0 ? ref28 : null,
            isConnect: !!(data === null || data === void 0 ? void 0 : (ref16 = data.user) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.cryptoWallet) === null || ref17 === void 0 ? void 0 : ref17.address),
            nftActive: (serial === null || serial === void 0 ? void 0 : (ref18 = serial.nftToken) === null || ref18 === void 0 ? void 0 : ref18.status) === utoniq_core_schema/* ItemNftMintStatus.Completed */.A3P.Completed
        },
        actions: {
            onIssueNft: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                mintItemNft({
                                    variables: {
                                        inputs: {
                                            itemId: itemId,
                                            serialId: serialId
                                        }
                                    }
                                }).then(function(res) {
                                    showMessage(t("issued"));
                                    router.push(generatePath(routerPages.OwnedItemDetail, {
                                        itemId: itemId
                                    }));
                                }).catch(function(e) {
                                    return showError(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            connectMetamask: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                userAuthorizeWalletBySignatureMessage()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            connectToWeb3auth: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var idToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,auth/* getAccessToken */.hP)({
                                    forceUpdateToken: true
                                })
                            ];
                        case 1:
                            idToken = _state.sent();
                            if (!idToken) throw new Error("get jwtToke failed");
                            /**
         * web3auth <=> firebase auth連携
         */ return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.connectToWeb3Auth(idToken);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var NFT_TOKEN = (0,lib/* gql */.Ps)(NftItemDetail_viewModel_templateObject(), utoniq_core_schema/* NftTokenDetailFragmentDoc */.hAh);
var MINT_ITEM_NFT = (0,lib/* gql */.Ps)(NftItemDetail_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/NftItemDetail/index.tsx




/**
 * NftItemDetail Page
 * Implemented as a practical sample.
 */ var NftItemDetail = function() {
    var ref = NftItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/NftItems/template/index.tsx











var NftItemsTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages, routerNames = ref.routerNames;
    var item = state.item, serials = state.serials;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.OwnedItemNftItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: "NFT",
                    back: true
                },
                children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItems_template_LoadingCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    direction: "column",
                    sx: {
                        pt: 2,
                        px: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItems_template_HeadingTextCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeadingTextCell, {}),
                        (serials === null || serials === void 0 ? void 0 : serials.length) ? serials.map(function(serial) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                divider: true,
                                sx: {
                                    py: 3
                                },
                                disablePadding: true,
                                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButtonCell, {
                                    isNft: !!serial.isNft,
                                    processingItemRegisterer: !serial.tokenId
                                }),
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                    component: Stack_Stack/* default */.Z,
                                    disabled: !serial.tokenId,
                                    onClick: function() {
                                        return router.push(generatePath(routerPages.OwnedItemNftItemDetail, {
                                            itemId: item === null || item === void 0 ? void 0 : item.id,
                                            serialId: serial.id
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                        sx: {
                                            flex: "0 0 auto"
                                        },
                                        primary: serial.formattedSerialNumber,
                                        secondary: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenId, {
                                            tokenId: serial.tokenId,
                                            variant: "subtitle2",
                                            withTitle: true
                                        }),
                                        slotProps: {
                                            primary: {
                                                variant: "h6"
                                            },
                                            secondary: {
                                                variant: "subtitle2",
                                                color: "text.secondary"
                                            }
                                        }
                                    })
                                })
                            }, serial.id);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                p: 4,
                                textAlign: "center"
                            },
                            children: t("serialNotFound")
                        })
                    ]
                })
            })
        ]
    });
};
var NftItems_template_LoadingCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "grid",
            placeItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* Loading */.g, {})
    });
};
var NftItems_template_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                py: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    children: t("issuableNft")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    alignSelf: "end",
                    children: t("free")
                })
            ]
        })
    });
};
var LinkCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
        component: Stack_Stack/* default */.Z,
        href: (0,helpUrl/* getHelpUrl */.R)("howToIssueNft"),
        sx: {
            py: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "primary.main",
                    sx: {
                        mr: 1
                    },
                    children: t("usageLink")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                    sx: {
                        color: "primary.main",
                        height: 12,
                        width: 12
                    }
                })
            ]
        })
    });
};
var SubHeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            sx: {
                pt: 5,
                pb: 1
            },
            children: t("selectSerialNumber")
        })
    });
};
var ActionButtonCell = function(param) {
    var isNft = param.isNft, processingItemRegisterer = param.processingItemRegisterer;
    var t = (0,core_i18n/* useTranslation */.$G)("nftItems").t;
    var StatusLabel = function(param) {
        var color = param.color, bgcolor = param.bgcolor, text = param.text;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                color: color,
                children: text
            }),
            sx: {
                bgcolor: bgcolor,
                borderRadius: "2px",
                minWidth: 84,
                height: 24
            }
        });
    };
    if (processingItemRegisterer) return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusLabel, {
        color: "common.white",
        bgcolor: "secondary.dark",
        text: t("issuing")
    });
    if (isNft) return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusLabel, {
        color: "common.white",
        bgcolor: "secondary.main",
        text: t("issuedNft")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusLabel, {
        color: "text.secondary",
        bgcolor: "grey.100",
        text: t("notIssuedNft")
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NftItems/viewModel.ts





var NftItems_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,device/* useDeviceInfo */.u)(), deviceInfoLoading = ref2.loading, deviceInfo = ref2.deviceInfo;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref3;
    var ref4 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* Portfolio */._Y8, {
        variables: {
            id: router.query.itemId,
            platform: (ref3 = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) !== null && ref3 !== void 0 ? ref3 : ""
        },
        skip: deviceInfoLoading
    }), portfolioData = ref4.data, loading = ref4.loading;
    var ref5, ref6;
    return {
        state: {
            loading: loading,
            item: (ref5 = portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : ref.item) !== null && ref5 !== void 0 ? ref5 : null,
            serials: (ref6 = portfolioData === null || portfolioData === void 0 ? void 0 : (ref1 = portfolioData.portfolio) === null || ref1 === void 0 ? void 0 : ref1.serials) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/NftItems/index.tsx



var NftItems = function() {
    var ref = NftItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItemsTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NotificationDetail/template/index.tsx









var NotificationDetailTemplate = function(param) {
    var _state = param.state, notification = _state.notification, loading = _state.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("notificationDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: generatePath(routerPages.Notifications)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.NotificationDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitleCell, {
                loading: loading,
                title: (ref1 = notification === null || notification === void 0 ? void 0 : notification.title) !== null && ref1 !== void 0 ? ref1 : null,
                official: false,
                date: (ref2 = notification === null || notification === void 0 ? void 0 : notification.formattedDate) !== null && ref2 !== void 0 ? ref2 : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationContentsTextCell, {
                loading: loading,
                body: (ref3 = notification === null || notification === void 0 ? void 0 : notification.body) !== null && ref3 !== void 0 ? ref3 : null
            })
        ]
    });
};
var NotificationTitleCell = function(param) {
    var loading = param.loading, official = param.official, title = param.title, date = param.date, artist = param.artist;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("notifications").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBoxSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            position: "relative"
        },
        children: [
            official && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                gap: 2,
                children: [
                    (artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: artist === null || artist === void 0 ? void 0 : (ref1 = artist.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri,
                        sx: {
                            height: 20,
                            width: 20
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        size: "small",
                        sx: {
                            height: 20,
                            borderRadius: "2px",
                            bgcolor: "secondary.dark",
                            py: 1,
                            ".MuiChip-label": {
                                px: 1
                            }
                        },
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            color: "white",
                            variant: "subtitle2",
                            children: t("official")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h2",
                sx: {
                    pt: 2,
                    wordBreak: "break-word"
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle2",
                sx: {
                    pt: 2,
                    pb: 5,
                    color: "grey.600"
                },
                children: date
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    bgcolor: "grey.100"
                }
            })
        ]
    });
};
var NotificationContentsTextCell = function(param) {
    var loading = param.loading, body = param.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 6,
            pb: 4,
            px: 5,
            userSelect: "text",
            WebkitUserSelect: "text",
            msUserSelect: "text",
            position: "relative"
        },
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "small",
            lastWidth: "75%",
            numberOfLine: 5
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    wordBreak: "break-word"
                },
                children: body
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/NotificationDetail/viewModel.ts

function NotificationDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query NotificationDetail($notificationId: ID!) {\n    organization {\n      id\n      notification(id: $notificationId) {\n        ...NotificationBox\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    NotificationDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NotificationDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1 = (0,useQuery/* useQuery */.aM)(NotificationDetail_viewModel_QUERY, {
        variables: {
            notificationId: router.query.notificationId
        }
    }), data = ref1.data, loading = ref1.loading;
    var ref2;
    // call mutation update unread count -> implemented in the future
    // update badge number by Badge.setCount(-1) function
    return {
        state: {
            loading: loading,
            notification: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : ref.notification) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {}
    };
});
var NotificationDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(NotificationDetail_viewModel_templateObject(), utoniq_core_schema/* NotificationBoxFragmentDoc */.IEM);

;// CONCATENATED MODULE: ./src/components/pages/NotificationDetail/index.tsx



/**
 * NotificationDetail Page
 * Implemented as a practical sample.
 */ var NotificationDetail = function() {
    var state = NotificationDetail_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDetailTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Notifications/template/index.tsx











var NotificationsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilter = param.onFilter;
    var ref, ref1, ref2;
    var ref3 = (0,core_i18n/* useTranslation */.$G)("notifications"), t = ref3.t, i18n = ref3.i18n;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        navigation: {
            type: config_config/* config.applicationType */.v.applicationType === "standalone" ? "artist" : "global",
            props: {
                hasManagementTask: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.hasManagementTask),
                unreadNotificationCount: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.unreadNotificationCount,
                hasSettingTask: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.isMembershipPersonalInformationRequired)
            }
        },
        header: {
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: i18n.exists("notifications:ogTitle") ? t("ogTitle") : routerNames.Notifications
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_NotificationListCell, {
                loading: state.loading || state.refetching,
                notifications: state.notifications,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore
            })
        ]
    });
};
var filters = (/* unused pure expression or super */ null && ([
    "all",
    "official"
]));
var FilterMenuCell = function(param) {
    var onFilter = param.onFilter;
    var t = useTranslation("notifications").t;
    var ref = useState(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = useState(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handleClick = useCallback(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = useCallback(function() {
        setAnchorEl(null);
    }, []);
    var handleMenuItemClick = useCallback(function(event, index) {
        setSelectedIndex(index);
        setAnchorEl(null);
        onFilter(index);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ _jsxs(CellFrame, {
        display: "flex",
        justifyContent: "flex-end",
        sx: {
            pb: 2,
            px: 5
        },
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                variant: "text",
                onClick: handleClick,
                sx: {
                    color: "text.primary",
                    mr: -2
                },
                children: [
                    t(filters[selectedIndex]),
                    /*#__PURE__*/ _jsx(Icons.DownArrow, {
                        sx: {
                            pl: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Menu, {
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: filters.map(function(filter, index) {
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        sx: {
                            bgcolor: "grey.100",
                            width: 200
                        },
                        selected: selectedIndex === index,
                        onClick: function(event) {
                            return handleMenuItemClick(event, index);
                        },
                        children: t(filter)
                    }, index);
                })
            })
        ]
    });
};
var template_NotificationListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, notifications = param.notifications, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("notifications").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: notifications === null || notifications === void 0 ? void 0 : notifications.edges.map(function(param, index) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBox, {
                            notification: node
                        }),
                        (notifications === null || notifications === void 0 ? void 0 : notifications.edges.length) - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                mx: 5
                            }
                        })
                    ]
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 0
            },
            component: List_List/* default */.Z,
            emptyMessage: t("notExist"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: [
                    1,
                    2,
                    3,
                    4,
                    5
                ].map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBoxSkeleton, {}, index);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@capacitor/push-notifications/dist/esm/index.js
var push_notifications_dist_esm = __webpack_require__(96020);
// EXTERNAL MODULE: ../../node_modules/@capawesome/capacitor-badge/dist/esm/index.js
var capacitor_badge_dist_esm = __webpack_require__(79727);
;// CONCATENATED MODULE: ./src/core/native/badge/index.ts





/**
 * get current badge number
 */ var getBadgeCount = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.get */.C.get()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.count || 0
                    ];
            }
        });
    });
    return function getBadgeCount() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * ネイティブのバッジ数を count の数に変更する
 * countが0以下ならクリアする
 * @param {number} count
 */ var setBadgeCount = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(count) {
        var isWeb;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isWeb = native_app/* getPlatform */.Xf() === "web";
                    if (isWeb) return [
                        2
                    ];
                    if (!(typeof count === "number" && count <= 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        clearBadgeCount()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        push_notifications_dist_esm/* PushNotifications.removeAllDeliveredNotifications */.V.removeAllDeliveredNotifications()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
                case 3:
                    if (!count) return [
                        2
                    ];
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.set */.C.set({
                            count: count
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function setBadgeCount(count) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * clear badge number
 */ var clearBadgeCount = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.clear */.C.clear()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function clearBadgeCount() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * request permissions
 * @return Promise<boolean>
 */ var requestBadgePermissions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var isSupported, permissionStatus, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.isSupported */.C.isSupported()
                    ];
                case 1:
                    isSupported = _state.sent().isSupported;
                    if (!isSupported) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.checkPermissions */.C.checkPermissions()
                    ];
                case 2:
                    permissionStatus = _state.sent();
                    if (permissionStatus.display === "granted") {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        4,
                        capacitor_badge_dist_esm/* Badge.requestPermissions */.C.requestPermissions()
                    ];
                case 3:
                    result = _state.sent();
                    return [
                        2,
                        result.display === "granted"
                    ];
            }
        });
    });
    return function requestBadgePermissions() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/Notifications/viewModel.ts




function Notifications_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Notifications(\n    $artistId: ID\n    $notificationsPageInput: PageInputDate\n    $isStandalone: Boolean!\n  ) {\n    artist(id: $artistId) @include(if: $isStandalone) {\n      ...ArtistBottomTab\n      currentLive {\n        id\n      }\n    }\n    organization {\n      id\n      notifications(pageInput: $notificationsPageInput) {\n        ...NotificationsConection\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Notifications_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Notifications_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewNotifications($artistId: ID, $pageInput: PageInputDate) {\n    artist(id: $artistId) {\n      ...ArtistBottomTab\n      currentLive {\n        id\n      }\n    }\n    organization {\n      id\n      notifications(pageInput: $pageInput) {\n        ...NotificationsConection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Notifications_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Notifications_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateLastNotificationReadAt($readAt: Date!) {\n    updateLastNotificationReadAt(readAt: $readAt)\n  }\n"
    ]);
    Notifications_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Notifications_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var isFirstLoadRef = useGetNewestData({
        query: Notifications_viewModel_FETCH_NEW_QUERY,
        variables: {
            artistId: config_config/* config.artistId */.v.artistId,
            pageInput: {
                limit: 30
            }
        },
        identify: {
            __typename: "Organization",
            id: function(data) {
                var ref;
                return data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : ref.id;
            }
        },
        fields: [
            {
                fieldName: "notifications",
                responsePath: "organization.notifications",
                fragment: utoniq_core_schema/* NotificationBoxFragmentDoc */.IEM
            }, 
        ],
        onCompleted: function onCompleted(data) {
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }).isFirstLoadRef;
    var ref3 = (0,useQuery/* useQuery */.aM)(Notifications_viewModel_QUERY, {
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        variables: {
            artistId: config_config/* config.artistId */.v.artistId,
            isStandalone: config_config/* config.applicationType */.v.applicationType === "standalone"
        },
        onCompleted: function onCompleted(data) {
            isFirstLoadRef.current = false;
            if (data === null || data === void 0 ? void 0 : data.artist) {
                (0,vars/* currentArtistVar */.ag)(data.artist);
            }
        }
    }), data = ref3.data, loading = ref3.loading, fetchMore = ref3.fetchMore, networkStatus = ref3.networkStatus;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_LAST_NOTIFICATION_READ_AT), 1), updateLastNotificationReadAt = ref4[0];
    var isNextFetch = !!data;
    (0,react.useEffect)(function() {
        // アクセス時に通知を既読にする
        updateLastNotificationReadAt({
            variables: {
                readAt: new Date()
            }
        }).then(function(param) {
            var data = param.data;
            setBadgeCount(data === null || data === void 0 ? void 0 : data.updateLastNotificationReadAt);
        });
    }, []);
    var ref5, ref6;
    return {
        state: {
            loading: loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : (ref1 = ref.notifications) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            user: (ref5 = data === null || data === void 0 ? void 0 : data.user) !== null && ref5 !== void 0 ? ref5 : null,
            notifications: (ref6 = data === null || data === void 0 ? void 0 : (ref2 = data.organization) === null || ref2 === void 0 ? void 0 : ref2.notifications) !== null && ref6 !== void 0 ? ref6 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            notificationsPageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : (ref1 = ref.notifications) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFilter: function onFilter() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var Notifications_viewModel_QUERY = (0,lib/* gql */.Ps)(Notifications_viewModel_templateObject(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* NotificationsConectionFragmentDoc */.sAq, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var Notifications_viewModel_FETCH_NEW_QUERY = (0,lib/* gql */.Ps)(Notifications_viewModel_templateObject1(), utoniq_core_schema/* ArtistBottomTabFragmentDoc */.hiY, utoniq_core_schema/* NotificationsConectionFragmentDoc */.sAq);
var UPDATE_LAST_NOTIFICATION_READ_AT = (0,lib/* gql */.Ps)(Notifications_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/Notifications/index.tsx




/**
 * Notifications Page
 * Implemented as a practical sample.
 */ var Notifications = function() {
    var ref = Notifications_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformation/template/index.tsx












var OfficialInformationTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("officialInformation").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: (0,src_object_spread/* default */.Z)({
            back: true,
            title: t("title")
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        maxWidth: displayResponsive ? 1120 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.OfficialInformation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformation_template_NotificationListCell, {
                loading: state.loading || state.refetching,
                notifications: state.notifications,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore
            })
        ]
    });
};
var OfficialInformation_template_NotificationListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, notifications = param.notifications, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("officialInformation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: notifications === null || notifications === void 0 ? void 0 : notifications.edges.map(function(param, index) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBox, {
                            notification: node
                        }),
                        (notifications === null || notifications === void 0 ? void 0 : notifications.edges.length) - 1 > index && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                            sx: {
                                mx: 5
                            }
                        })
                    ]
                }, node.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            componentProps: {
                spacing: 0
            },
            component: List_List/* default */.Z,
            emptyMessage: t("notExist"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: [
                    1,
                    2,
                    3,
                    4,
                    5
                ].map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBoxSkeleton, {}, index);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformation/viewModel.ts



function OfficialInformation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query OfficialInformation($pageInput: PageInput) {\n    organizationOfficialNotifications(pageInput: $pageInput) {\n      ...OrganizationNotificationConnection\n    }\n  }\n  ",
        "\n"
    ]);
    OfficialInformation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var OfficialInformation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var isFirstLoadRef = useGetNewestData({
        query: OfficialInformation_viewModel_QUERY,
        variables: {
            pageInput: {
                limit: 20
            }
        },
        fields: [
            {
                fieldName: "notifications",
                fragment: utoniq_core_schema/* NotificationBoxFragmentDoc */.IEM
            }, 
        ]
    }).isFirstLoadRef;
    var ref1 = (0,useQuery/* useQuery */.aM)(OfficialInformation_viewModel_QUERY, {
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        variables: {
            pageInput: {
                limit: 5
            }
        },
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref1.data, loading = ref1.loading, networkStatus = ref1.networkStatus, fetchMore = ref1.fetchMore;
    var isNextFetch = !!data;
    var ref2;
    return {
        state: {
            loading: loading && !isNextFetch,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.organizationOfficialNotifications) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            notifications: (ref2 = data === null || data === void 0 ? void 0 : data.organizationOfficialNotifications) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                limit: 5,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.organizationOfficialNotifications) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var OfficialInformation_viewModel_QUERY = (0,lib/* gql */.Ps)(OfficialInformation_viewModel_templateObject(), utoniq_core_schema/* OrganizationNotificationConnectionFragmentDoc */.UXf);

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformation/index.tsx




/**
 * OfficialInformation Page
 * Implemented as a practical sample.
 */ var OfficialInformation = function() {
    var ref = OfficialInformation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformationDetail/template/index.tsx







var OfficialInformationDetailTemplate = function(param) {
    var _state = param.state, notification = _state.notification, loading = _state.loading;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("officialInformationDetail").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref3.routerNames, generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: (0,src_object_spread/* default */.Z)({
            title: t((notification === null || notification === void 0 ? void 0 : (ref = notification.artist) === null || ref === void 0 ? void 0 : ref.displayName) ? "titleArtist" : "title", {
                displayName: notification === null || notification === void 0 ? void 0 : (ref1 = notification.artist) === null || ref1 === void 0 ? void 0 : ref1.displayName
            }),
            back: true,
            defaultBackPage: generatePath(routerPages.OfficialInformation)
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        maxWidth: displayResponsive ? 1120 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: "".concat((ref4 = notification === null || notification === void 0 ? void 0 : (ref2 = notification.artist) === null || ref2 === void 0 ? void 0 : ref2.displayName) !== null && ref4 !== void 0 ? ref4 : "").concat(routerNames.OfficialInformationDetail)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitleCell, {
                loading: loading,
                title: (ref5 = notification === null || notification === void 0 ? void 0 : notification.title) !== null && ref5 !== void 0 ? ref5 : null,
                official: true,
                date: (ref6 = notification === null || notification === void 0 ? void 0 : notification.formattedCreatedAt) !== null && ref6 !== void 0 ? ref6 : null,
                artist: notification === null || notification === void 0 ? void 0 : notification.artist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationContentsTextCell, {
                loading: loading,
                body: (ref7 = notification === null || notification === void 0 ? void 0 : notification.body) !== null && ref7 !== void 0 ? ref7 : null
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformationDetail/viewModel.ts

function OfficialInformationDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query OfficialInformationDetail($notificationId: ID!) {\n    organizationOfficialNotification(id: $notificationId) {\n      ...OrganizationNotificationBox\n    }\n  }\n  ",
        "\n"
    ]);
    OfficialInformationDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OfficialInformationDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query OfficialInformationDetailArtist($artistId: ID!) {\n    artist(id: $artistId) {\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n"
    ]);
    OfficialInformationDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var OfficialInformationDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = config_config/* config.artistId */.v.artistId) !== null && _artistId !== void 0 ? _artistId : "";
    var ref = (0,useQuery/* useQuery */.aM)(OfficialInformationDetail_viewModel_QUERY, {
        variables: {
            notificationId: router.query.notificationId
        }
    }), data = ref.data, loading = ref.loading;
    var ref1;
    return {
        state: {
            loading: loading,
            notification: (ref1 = data === null || data === void 0 ? void 0 : data.organizationOfficialNotification) !== null && ref1 !== void 0 ? ref1 : null
        },
        actions: {}
    };
});
var OfficialInformationDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(OfficialInformationDetail_viewModel_templateObject(), utoniq_core_schema/* OrganizationNotificationBoxFragmentDoc */.w4V);
var viewModel_ARTIST_QUERY = (0,lib/* gql */.Ps)(OfficialInformationDetail_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/OfficialInformationDetail/index.tsx




/**
 * OfficialInformationDetail Page
 * Implemented as a practical sample.
 */ var OfficialInformationDetail = function() {
    var ref = OfficialInformationDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficialInformationDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/viewModel.ts





function OwnedItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query portfolio(\n    $id: ID!\n    $platform: String!\n    $pageInput: PageInput\n    $skuId: String\n  ) {\n    portfolio(id: $id) {\n      item {\n        metadata {\n          ticket {\n            startDateOfUse\n            endDateOfUse\n            throughTicket {\n              startDateOfUse\n              endDateOfUse\n            }\n          }\n        }\n      }\n      ...PortfolioSku\n    }\n    purchasablePrepaidPoints(platform: $platform, pageInput: $pageInput) {\n      ...PurchasablePrepaidPointConnection\n    }\n    paymentSource {\n      ...PrepaidPointsPaymentSource\n    }\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n    }\n    user {\n      id\n      customProfile {\n        ...CustomProfileConnection\n      }\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    OwnedItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OwnedItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ProtectUserItem($inputs: ProtectUserItemInput!, $skuId: String) {\n    protectUserItem(inputs: $inputs) {\n      ...PortfolioConnection\n    }\n  }\n  ",
        "\n"
    ]);
    OwnedItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OwnedItemDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UseTickets($inputs: UseTicketsInput!) {\n    useTickets(inputs: $inputs) {\n      id\n      obtainedDate\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    OwnedItemDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OwnedItemDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ViewCollectionItem($inputs: ViewCollectionItemInput!) {\n    viewCollectionItem(inputs: $inputs) {\n      id\n      userId\n      latestItemId\n      collectionId\n      viewCount\n    }\n  }\n"
    ]);
    OwnedItemDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OwnedItemDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateWallpaperPrintQrcode(\n    $inputs: GenerateWallpaperPrintQrcodeInput!\n  ) {\n    generateWallpaperPrintQrcode(inputs: $inputs) {\n      id\n      ticketStatus {\n        ...TicketStatusDetail\n      }\n      formattedAssignedNumber\n      sku {\n        id\n        unitName\n      }\n      metadata {\n        ticket {\n          fullName\n        }\n        wallpaper {\n          print {\n            expiredAt\n            contentsCode\n            qrcode {\n              uri\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    OwnedItemDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

















var OwnedItemDetail_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,device/* useDeviceInfo */.u)(), deviceInfoLoading = ref7.loading;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref8 = (0,core_i18n/* useTranslation */.$G)(), tcommon = ref8.t;
    var t = (0,core_i18n/* useTranslation */.$G)("ownedItemDetail").t;
    var ref9 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref9.showError, showMessage = ref9.showMessage;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var ref10 = usePointPurchase(user === null || user === void 0 ? void 0 : user.uid, platform, "magazineViewer"), purchaseByIosAndAndroid = ref10.purchaseByIosAndAndroid, purchaseByWeb = ref10.purchaseByWeb, completeNativePurchase = ref10.completeNativePurchase, setCompleteNativePurchase = ref10.setCompleteNativePurchase, chargeLoading = ref10.chargeLoading;
    var _skuId;
    var ref11 = (0,useQuery/* useQuery */.aM)(OwnedItemDetail_viewModel_PORTFOLIO, {
        variables: {
            id: router.query.itemId,
            platform: platform,
            skuId: decodeSkuId((_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : "")
        },
        returnPartialData: true,
        skip: deviceInfoLoading,
        pollInterval: completeNativePurchase ? 2000 : 0
    }), portfolioData = ref11.data, refetch = ref11.refetch, loading = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateCustomProfile */.bPY), 2), updateCustomProfile = ref12[0], ref13 = ref12[1], customProfileUpdating = ref13.loading;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PROTECT_USER_ITEM), 2), protectUserItem = ref14[0], ref15 = ref14[1], protectingItem = ref15.loading;
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(USE_TICKETS), 1), onUseTickets = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VIEW_COLLECTION_ITEM), 1), viewCollectionItem = ref17[0];
    // 決済後、prepaidPointBalanceが更新されたらpollingを停止する
    (0,react.useEffect)(function() {
        setCompleteNativePurchase(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.prepaidPointBalance
    ]);
    // 閲覧履歴ミューテーションを送信する
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (!(portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collection) === null || ref2 === void 0 ? void 0 : ref2.isPublishOnStore)) return;
    }, [
        portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collection) === null || ref2 === void 0 ? void 0 : ref2.isPublishOnStore
    ]);
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* PurchaseItemImmediately */.BGv), 2), purchaseItemImmediately = ref18[0], ref19 = ref18[1], itemPurchasing = ref19.loading;
    var downloadImage = useDownlodImage().downloadImage;
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GENERATE_WALLPAPER_PRINT_QRCODE), 2), generateWallpaperPrintQrcode = ref20[0], ref21 = ref20[1], QRCodePrinting = ref21.loading;
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: "/userProfile/".concat(user === null || user === void 0 ? void 0 : user.uid, "/ownedItems/").concat(portfolioData === null || portfolioData === void 0 ? void 0 : (ref3 = portfolioData.portfolio) === null || ref3 === void 0 ? void 0 : ref3.item.id)
    });
    var ref22, ref23, ref24, ref25, ref26;
    return {
        state: {
            loading: useInitialLoading(portfolioData, loading),
            QRCodePrinting: QRCodePrinting,
            loadingOnce: loading && !(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.portfolio),
            customProfileUpdating: customProfileUpdating,
            portfolio: convertPortfolioItemToSku((ref22 = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.portfolio) !== null && ref22 !== void 0 ? ref22 : null, router.query.skuId),
            user: (ref23 = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.user) !== null && ref23 !== void 0 ? ref23 : null,
            loggedUser: user,
            paymentSource: (ref24 = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.paymentSource) !== null && ref24 !== void 0 ? ref24 : null,
            purchasablePrepaidPoints: (ref25 = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.purchasablePrepaidPoints) !== null && ref25 !== void 0 ? ref25 : null,
            point: (ref26 = portfolioData === null || portfolioData === void 0 ? void 0 : (ref4 = portfolioData.prepaidPointBalance) === null || ref4 === void 0 ? void 0 : ref4.balance) !== null && ref26 !== void 0 ? ref26 : 0,
            chargeLoading: chargeLoading,
            purchasingItem: itemPurchasing,
            protectingItem: protectingItem,
            /** アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(portfolioData === null || portfolioData === void 0 ? void 0 : (ref5 = portfolioData.organization) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.modules) === null || ref6 === void 0 ? void 0 : ref6.pointCarrierPayment)
        },
        actions: {
            onClickShare: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, url, _description, ref6;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getShortLinkUrl()
                            ];
                        case 1:
                            url = _state.sent();
                            return [
                                4,
                                share/* share */.B({
                                    title: portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : ref.item.title,
                                    text: (ref6 = (_description = portfolioData === null || portfolioData === void 0 ? void 0 : (ref1 = portfolioData.portfolio) === null || ref1 === void 0 ? void 0 : ref1.item.description) !== null && _description !== void 0 ? _description : (ref3 = portfolioData === null || portfolioData === void 0 ? void 0 : (ref2 = portfolioData.portfolio) === null || ref2 === void 0 ? void 0 : ref2.item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : ref4.description) !== null && ref6 !== void 0 ? ref6 : tcommon("metaDescription"),
                                    url: url,
                                    dialogTitle: portfolioData === null || portfolioData === void 0 ? void 0 : (ref5 = portfolioData.portfolio) === null || ref5 === void 0 ? void 0 : ref5.item.title
                                }).catch(function(e) {
                                    return showError(e);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            onSettingAvatar: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                updateCustomProfile({
                                    variables: {
                                        updateCustomProfileInputs: {
                                            avatarItemId: router.query.itemId
                                        }
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            onSettingWallpaper: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, unsetWallpaper;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            unsetWallpaper = (portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.user) === null || ref === void 0 ? void 0 : (ref1 = ref.customProfile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.wallpaperItem) === null || ref2 === void 0 ? void 0 : ref2.id) === router.query.itemId;
                            return [
                                4,
                                updateCustomProfile({
                                    variables: {
                                        updateCustomProfileInputs: {
                                            wallpaperItemId: unsetWallpaper ? null : router.query.itemId
                                        }
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                !unsetWallpaper
                            ];
                    }
                });
            }),
            onProtectUserItem: function onProtectUserItem() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, _id;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    protectUserItem({
                                        variables: {
                                            inputs: {
                                                isUserProtected: !(portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : ref.isUserProtected),
                                                id: (_id = portfolioData === null || portfolioData === void 0 ? void 0 : (ref1 = portfolioData.portfolio) === null || ref1 === void 0 ? void 0 : ref1.item.id) !== null && _id !== void 0 ? _id : ""
                                            }
                                        }
                                    }).then(function(param) {
                                        var data = param.data;
                                        if (data === null || data === void 0 ? void 0 : data.protectUserItem.isUserProtected) {
                                            showMessage(t("setProtectSuccess"));
                                            return;
                                        }
                                        showMessage(t("unsetProtectSuccess"));
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBuyItem: /** マガジンの追加購入 */ function onBuyItem(itemId, price, title) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                                    transaction_id: generateTransactionId(user === null || user === void 0 ? void 0 : user.uid),
                                    currency: "JPY",
                                    type: "convenience_store",
                                    items: [
                                        {
                                            item_id: itemId,
                                            item_name: title,
                                            item_category: ConversionCategories.storeItem,
                                            item_category2: utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine,
                                            item_category3: platform,
                                            item_category4: undefined,
                                            item_category5: portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id,
                                            price: price,
                                            quantity: 1
                                        }
                                    ]
                                });
                                return [
                                    4,
                                    purchaseItemImmediately({
                                        variables: {
                                            inputs: {
                                                itemId: itemId,
                                                price: price,
                                                count: 1
                                            }
                                        },
                                        context: {
                                            headers: {
                                                "x-utoniq-idempotency-key": createUuid()
                                            }
                                        }
                                    }).catch(function(error) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id,
                                            error: error === null || error === void 0 ? void 0 : error.name,
                                            errorCode: error === null || error === void 0 ? void 0 : (ref3 = error.graphQLErrors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.extensions) === null || ref5 === void 0 ? void 0 : ref5.errorCode
                                        });
                                        if ((error === null || error === void 0 ? void 0 : (ref6 = error.graphQLErrors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.extensions) === null || ref8 === void 0 ? void 0 : ref8.errorCode) === "NEED_PATRON") {
                                            showError(new Error(t("needPatronErrorMessage")));
                                            return;
                                        }
                                        showError(error);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUseTicket: function onUseTicket(serialIds, throughTicketName) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    onUseTickets({
                                        variables: {
                                            inputs: {
                                                items: [
                                                    {
                                                        itemId: router.query.itemId,
                                                        serialIds: serialIds,
                                                        throughTicketName: throughTicketName
                                                    }
                                                ]
                                            }
                                        }
                                    }).then(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                        var ref, ref1, ref2, ref3;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : ref3.distributionEnabled)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        refetch()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    showMessage(t("useTicketSuccess"));
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onViewCollectionMagazine: // マガジンの閲覧履歴を送信する
            function onViewCollectionMagazine() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if ((portfolioData === null || portfolioData === void 0 ? void 0 : (ref = portfolioData.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.type) !== utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine || !((ref2 = portfolioData.portfolio) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.collection) === null || ref4 === void 0 ? void 0 : ref4.isPublishOnStore)) return [
                            2
                        ];
                        viewCollectionItem({
                            variables: {
                                inputs: {
                                    collectionId: (ref10 = (ref5 = portfolioData.portfolio) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.collection) === null || ref7 === void 0 ? void 0 : ref7.id) !== null && ref10 !== void 0 ? ref10 : "",
                                    itemId: (ref8 = portfolioData.portfolio) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.item) === null || ref9 === void 0 ? void 0 : ref9.id
                                }
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            // ポイントを購入する
            onPurchaseCharge: platform === "web" ? purchaseByWeb : purchaseByIosAndAndroid,
            onImageDownload: function onImageDownload(url) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (isEmpty_default()(url)) return [
                                    2
                                ];
                                _tmp = url;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    downloadImage(url).catch(function(e) {
                                        showError(e);
                                        throw e;
                                    })
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGenerateWallpaperPrintQrcode: function onGenerateWallpaperPrintQrcode(serialId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    generateWallpaperPrintQrcode({
                                        variables: {
                                            inputs: {
                                                itemId: router.query.itemId,
                                                serialId: serialId
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};
function getSerialIdsByQuantity(serials, quantity) {
    var reverse = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var serialsUnused = (reverse ? _to_consumable_array(serials).reverse() : serials).filter(function(param) {
        var serial = param.serial;
        var ref;
        return serial === null || serial === void 0 ? void 0 : (ref = serial.ticketStatus) === null || ref === void 0 ? void 0 : ref.canUseTicket;
    });
    return serialsUnused.slice(0, quantity).map(function(param) {
        var id = param.id;
        return id;
    });
}
var OwnedItemDetail_viewModel_PORTFOLIO = (0,lib/* gql */.Ps)(OwnedItemDetail_viewModel_templateObject(), utoniq_core_schema/* PortfolioSkuFragmentDoc */.d_s, utoniq_core_schema/* CustomProfileConnectionFragmentDoc */.saP, utoniq_core_schema/* PurchasablePrepaidPointConnectionFragmentDoc */.oBq, utoniq_core_schema/* PrepaidPointsPaymentSourceFragmentDoc */.tE1);
var PROTECT_USER_ITEM = (0,lib/* gql */.Ps)(OwnedItemDetail_viewModel_templateObject1(), utoniq_core_schema/* PortfolioConnectionFragmentDoc */.umN);
var USE_TICKETS = (0,lib/* gql */.Ps)(OwnedItemDetail_viewModel_templateObject2(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);
var VIEW_COLLECTION_ITEM = (0,lib/* gql */.Ps)(OwnedItemDetail_viewModel_templateObject3());
var GENERATE_WALLPAPER_PRINT_QRCODE = (0,lib/* gql */.Ps)(OwnedItemDetail_viewModel_templateObject4(), utoniq_core_schema/* TicketStatusDetailFragmentDoc */.a06);

;// CONCATENATED MODULE: ./src/components/pages/OwnedItemDetail/index.tsx





var OwnedItemDetail = function() {
    var ref, ref1, ref2;
    var ref3 = OwnedItemDetail_viewModel_useViewModel(), state = ref3.state, actions = ref3.actions;
    if (!state.loading && !state.portfolio) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    /**
   * NFT 停止に向けて、NFTアイテムの詳細ページを表示しない
   * NFT 機能停止後には削除して問題ない
   */ if ((ref = state.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nft) === null || ref2 === void 0 ? void 0 : ref2.chains) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/OwnedItems/viewModel.ts



function OwnedItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PortfolioItems(\n    $type: ItemType\n    $pageInput: PageInput\n    $option: PortfoliosOptionInput\n  ) {\n    user {\n      id\n      organizationPortfolios(\n        type: $type\n        pageInput: $pageInput\n        option: $option\n      ) {\n        ...PortfolioItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    OwnedItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OwnedItems_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewPortfolioItems($type: ItemType, $pageInput: PageInput) {\n    user {\n      id\n      organizationPortfolios(type: $type, pageInput: $pageInput) {\n        ...PortfolioItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    OwnedItems_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var OwnedItems_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3;
    var isFirstLoadRef = useGetNewestData({
        query: OwnedItems_viewModel_FETCH_NEW_QUERY,
        variables: {
            pageInput: {
                limit: 24
            }
        },
        identify: {
            __typename: "User",
            id: function(data) {
                var ref;
                return data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id;
            }
        },
        fields: [
            {
                fieldName: "organizationPortfolios",
                responsePath: "user.organizationPortfolios",
                fragment: utoniq_core_schema/* PortfolioItemsDetailFragmentDoc */.PKc
            }, 
        ]
    }).isFirstLoadRef;
    var ref4 = (0,useQuery/* useQuery */.aM)(OwnedItems_viewModel_QUERY, {
        variables: {
            pageInput: {
                limit: 24
            }
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore, refetch = ref4.refetch;
    var ref5;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.organizationPortfolios) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            organizationPortfolios: spreadPortfoliosBySku((ref5 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.organizationPortfolios) !== null && ref5 !== void 0 ? ref5 : null),
            filter: "general"
        },
        actions: {
            onSort: function onSort(key) {},
            onFilterResale: function onFilterResale(resaleEnabled) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        refetch({
                            option: resaleEnabled ? {
                                resaleEnabled: resaleEnabled
                            } : null
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onFilter: function onFilter(filter) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        refetch({
                            type: filter === "general" ? null : filter,
                            option: null
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                limit: 15,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.organizationPortfolios) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};
var OwnedItems_viewModel_QUERY = (0,lib/* gql */.Ps)(OwnedItems_viewModel_templateObject(), utoniq_core_schema/* PortfolioItemsConnectionFragmentDoc */.thw);
var OwnedItems_viewModel_FETCH_NEW_QUERY = (0,lib/* gql */.Ps)(OwnedItems_viewModel_templateObject1(), utoniq_core_schema/* PortfolioItemsConnectionFragmentDoc */.thw);

;// CONCATENATED MODULE: ./src/components/pages/OwnedItems/index.tsx




var OwnedItems = function() {
    var ref = OwnedItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OwnedItemsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordReset/template/PasswordResetForm.tsx









var PasswordResetForm_schema = function(o) {
    return {
        password: o.string().min(8).max(30).label((0,core_form/* tLabel */.TQ)("passwordReset.password"))
    };
};
var PasswordResetForm_defaultValues = {
    password: ""
};
var PasswordResetForm = function(param) {
    var onSubmitPasswordReset = param.onSubmitPasswordReset, onOpenModal = param.onOpenModal;
    var ref = (0,core_form/* useForm */.cI)({
        schema: PasswordResetForm_schema,
        defaultValues: PasswordResetForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmitPasswordReset),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var PasswordResetForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("login").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var PasswordResetForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordReset").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordReset/template/index.tsx









var PasswordResetTemplate = function(param) {
    var state = param.state, onSubmitPasswordReset = param.onSubmitPasswordReset;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordReset").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, routerNames = ref.routerNames;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var onReset = function(values) {
        return onSubmitPasswordReset(values).then(function() {
            setOpen(true);
        }).catch(function(e) {
            showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                "aria-label": "menu",
                onClick: function() {
                    return router.push(routerPages.Top);
                }
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PasswordReset
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordReset_template_TextCell, {
                email: state.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetForm, {
                onSubmitPasswordReset: onReset,
                onOpenModal: function() {
                    return setOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("completeModalTitle"),
                content: t("completeModalDescription"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: function() {
                        return setOpen(false);
                    },
                    sx: {
                        width: 212
                    },
                    size: "large",
                    children: "OK"
                })
            })
        ]
    });
};
var PasswordReset_template_TextCell = function(param) {
    var email = param.email;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordReset").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    py: 2
                },
                children: t("email")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: email
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordReset/viewModel.ts






var PasswordReset_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var confirmPasswordReset = (0,auth/* useAuth */.aC)().confirmPasswordReset;
    var ref = useVerifyPasswordResetCode(), email = ref.email, verifiedCode = ref.verifiedCode;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return {
        state: {
            email: email
        },
        actions: {
            onSubmitPasswordReset: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var password;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        password = param.password;
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_resetPassword");
                        confirmPasswordReset(verifiedCode, password);
                        return [
                            2
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
/**
 * @description
 * パスワードリセットURLのクエリパラメータを基に、コードの正当性を確認して正しければ再設定email,codeを返す。
 *
 * @returns email パスワード再設定するメールアドレス
 * @returns verifiedCode 認証コード
 * @returns loading 認証コード確認中のローディング
 */ var useVerifyPasswordResetCode = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(""), verifiedCode = ref2[0], setVerifiedCode = ref2[1];
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _query = router.query, code = _query.oobCode;
    var verifyPasswordResetCode = (0,auth/* useAuth */.aC)().verifyPasswordResetCode;
    (0,react.useEffect)(function() {
        if (code) {
            setLoading(true);
            verifyPasswordResetCode(code).then(function(email) {
                setEmail(email);
                setVerifiedCode(code);
            }).catch(function(e) {
                return showError(e);
            }).finally(function() {
                return setLoading(false);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        code
    ]);
    return {
        email: email,
        verifiedCode: verifiedCode,
        loading: loading
    };
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordReset/index.tsx



var PasswordReset = function() {
    var ref = PasswordReset_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetTemplate, {
        state: state,
        onSubmitPasswordReset: actions.onSubmitPasswordReset
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordResetSend/template/PasswordResetSendForm.tsx









var PasswordResetSendForm_schema = function(o) {
    return {
        email: o.string().regex(core_form/* formRegex.email */.rE.email).label((0,core_form/* tLabel */.TQ)("passwordResetSend.email"))
    };
};
/**
 *  PasswordResetSend Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */ var PasswordResetSendForm = function(param) {
    var onSubmitPasswordResetSend = param.onSubmitPasswordResetSend;
    var ref = (0,core_form/* useForm */.cI)({
        schema: PasswordResetSendForm_schema
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmitPasswordResetSend),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetSendForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "email",
                error: errors === null || errors === void 0 ? void 0 : errors.email
            }, register("email"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetSendForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var PasswordResetSendForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("passwordResetSend").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var PasswordResetSendForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordResetSend").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordResetSend/template/index.tsx









var PasswordResetSendTemplate = function(param) {
    var state = param.state, onSubmitPasswordResetSend = param.onSubmitPasswordResetSend;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordResetSend").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var onSend = function(inputs) {
        return onSubmitPasswordResetSend(inputs).then(function() {
            return setOpen(true);
        }).catch(function(e) {
            showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Top
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PasswordResetSend
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetSend_template_TextCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetSendForm, {
                onSubmitPasswordResetSend: onSend
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("completeMessage"),
                content: "",
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: function() {
                        return setOpen(false);
                    },
                    sx: {
                        width: 212
                    },
                    size: "large",
                    children: "OK"
                })
            })
        ]
    });
};
var PasswordResetSend_template_TextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("passwordResetSend").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            children: t("description")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordResetSend/viewModel.ts




var PasswordResetSend_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var sendPasswordResetEmail = (0,auth/* useAuth */.aC)().sendPasswordResetEmail;
    return {
        state: {},
        actions: {
            passwordResetSend: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var email;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        email = param.email;
                        return [
                            2,
                            sendPasswordResetEmail(email)
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/PasswordResetSend/index.tsx



var PasswordResetSend = function() {
    var ref = PasswordResetSend_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordResetSendTemplate, {
        state: state,
        onSubmitPasswordResetSend: actions.passwordResetSend
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/template/PasswordSettingForm.tsx









var PasswordSettingForm_schema = function(o) {
    return {
        password: o.string().min(8).label((0,core_form/* tLabel */.TQ)("passwordSettings.password")),
        newPassword: o.string().min(8).label((0,core_form/* tLabel */.TQ)("passwordSettings.newPassword")),
        confirmNewPassword: o.string().min(8).valid(o.ref("newPassword")).messages({
            "any.only": (0,core_form/* tMessage */.Sd)("passwordSetting.confirmNewPassword.valid")
        }).label((0,core_form/* tLabel */.TQ)("passwordSettings.confirmNewPassword"))
    };
};
var PasswordSettingForm_defaultValues = {
    password: "",
    newPassword: "",
    confirmNewPassword: ""
};
var PasswordSettingForm = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)([
        "passwordSettings",
        "firebase"
    ]).t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: PasswordSettingForm_schema,
        mode: "onChange",
        defaultValues: PasswordSettingForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, reset = ref.reset;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(function(inputs) {
            return onSubmit(inputs).then(function() {
                showMessage(t("passwordSettings:registerSuccess"), "success");
                reset();
            }).catch(function(e) {
                return showError(new Error(t("firebase:auth.errors.".concat(e.code))));
            });
        }, function(e) {
            showError(new Error(t("emailAddressSettings:error")));
            throw e;
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.newPassword
            }, register("newPassword"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.confirmNewPassword
            }, register("confirmNewPassword"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var PasswordSettingForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordSettings").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var PasswordSettingForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordSettings").t;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    loading: loading,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "large",
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return router.goBack();
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/template/UnregisteredPasswordSettingForm.tsx









var UnregisteredPasswordSettingForm_schema = function(o) {
    return {
        password: o.string().min(8).label((0,core_form/* tLabel */.TQ)("passwordSettings.password"))
    };
};
var UnregisteredPasswordSettingForm_defaultValues = {
    password: ""
};
var UnregisteredPasswordSettingForm = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)([
        "unregisteredPasswordSettings",
        "firebase"
    ]).t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: UnregisteredPasswordSettingForm_schema,
        mode: "onChange",
        defaultValues: UnregisteredPasswordSettingForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, reset = ref.reset;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(function(inputs) {
            return onSubmit(inputs).then(function() {
                showMessage(t("unregisteredPasswordSettings:registerSuccess"), "success");
                reset();
                router.push(routerPages.AccountSetting);
            }).catch(function(e) {
                return showError(e);
            });
        }, function(e) {
            showError(new Error(t("emailAddressSettings:error")));
            throw e;
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 1
                        },
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("currentPassword")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 7
                        },
                        variant: "body1",
                        children: t("unregistered")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnregisteredPasswordSettingForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnregisteredPasswordSettingForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var UnregisteredPasswordSettingForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("unregisteredPasswordSettings").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var UnregisteredPasswordSettingForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("unregisteredPasswordSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                type: "submit",
                size: "large",
                sx: {
                    width: 244
                },
                loading: loading,
                children: t("submit")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/template/WalletPasswordSettingForm.tsx









var WalletPasswordSettingForm_schema = function(o) {
    return {
        password: o.string().min(8).label((0,core_form/* tLabel */.TQ)("passwordSettings.password"))
    };
};
var WalletPasswordSettingForm_defaultValues = {
    password: ""
};
var WalletPasswordSettingForm = function(param) {
    var email = param.email, onSubmit = param.onSubmit, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)([
        "walletPasswordSettings",
        "firebase"
    ]).t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: WalletPasswordSettingForm_schema,
        mode: "onChange",
        defaultValues: WalletPasswordSettingForm_defaultValues
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, reset = ref.reset;
    var ref1 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref1.showMessage, showError = ref1.showError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(function(inputs) {
            return onSubmit(inputs).then(function() {
                showMessage(t("walletPasswordSettings:registerSuccess"), "success");
                reset();
                onClose && onClose();
            }).catch(function(e) {
                return showError(e);
            });
        }, function(e) {
            showError(new Error(t("emailAddressSettings:error")));
            throw e;
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 1
                        },
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("currentEmailAddress")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        sx: {
                            pb: 7
                        },
                        variant: "body1",
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletPasswordSettingForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletPasswordSettingForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var WalletPasswordSettingForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("walletPasswordSettings").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var WalletPasswordSettingForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("walletPasswordSettings").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 4,
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/template/index.tsx









var PasswordSettingsTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onSubmitUnregisteredPassword = param.onSubmitUnregisteredPassword, onSubmitWalletPassword = param.onSubmitWalletPassword, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("passwordSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: !onClose,
            defaultBackPage: routerPages.AccountSetting,
            left: onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                onClick: onClose,
                sx: {
                    ml: -2
                }
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PasswordSetting
            }),
            !(state === null || state === void 0 ? void 0 : state.forWallet) ? (state === null || state === void 0 ? void 0 : state.hasPassword) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingForm, {
                onSubmit: onSubmit
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnregisteredPasswordSettingForm, {
                onSubmit: onSubmitUnregisteredPassword
            }) : null,
            (state === null || state === void 0 ? void 0 : state.forWallet) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletPasswordSettingForm, {
                email: state.email,
                onSubmit: onSubmitWalletPassword,
                onClose: onClose
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/viewModel.ts





var PasswordSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)("unregisteredPasswordSettings").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    var ref = (0,auth/* useAuth */.aC)(), updatePassword = ref.updatePassword, linkEmail = ref.linkEmail;
    /**
   * @description
   * メールログインのパスワード登録があるかどうか
   */ var hasPassword = !!(user === null || user === void 0 ? void 0 : user.providers.some(function(provider) {
        return (provider === null || provider === void 0 ? void 0 : provider.providerId) === "password";
    }));
    return {
        state: {
            hasPassword: hasPassword,
            forWallet: false
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var password, newPassword;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        password = param.password, newPassword = param.newPassword;
                        return [
                            2,
                            updatePassword(password, newPassword).catch(function(error) {
                                throw error;
                            })
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onSubmitUnregisteredPassword: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var password;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        password = param.password;
                        if (!(user === null || user === void 0 ? void 0 : user.email)) throw new Error(t("unregisteredEmail"));
                        /**
         * @description
         * iOS16ではブラウザでOAuth連携できないため、エラーを表示する
         * https://github.com/firebase/firebase-js-sdk/issues/6716
         */ if ((deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem) === "ios" && Number(deviceInfo.webViewVersion) >= 16.1) {
                            throw new Error(t("iOSOAuthMessage", {
                                ns: "integrations"
                            }));
                        }
                        return [
                            2,
                            linkEmail(user.email, password)
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onSubmitWalletPassword: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            })
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/PasswordSettings/index.tsx




var PasswordSettings = function() {
    var ref = PasswordSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentCreate/template/index.tsx





var PaymentCreateTemplate = function(param) {
    var state = param.state, onSubmitCreatePayment = param.onSubmitCreatePayment;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.PaymentDetail
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PaymentMethodSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateForm, {
                onSubmitCreatePayment: onSubmitCreatePayment
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentCreate/template/fragments.ts

function PaymentCreate_template_fragments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment paymentCreateDetail on CreditCard {\n      id\n      name\n      last4\n      expMonth\n      expYear\n      brand\n    }\n  "
    ]);
    PaymentCreate_template_fragments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function template_fragments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment requiresActionDetail on RequiresAction {\n      status\n      clientSecret\n    }\n  "
    ]);
    template_fragments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var template_fragments_fragments = {
    credit: (0,lib/* gql */.Ps)(PaymentCreate_template_fragments_templateObject()),
    requiresAction: (0,lib/* gql */.Ps)(template_fragments_templateObject1())
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentCreate/viewModel.ts




function PaymentCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation createPaymentMethod($createPaymentMethodToken: String!) {\n    createPaymentMethod(token: $createPaymentMethodToken) {\n      ...paymentCreateDetail\n      ...requiresActionDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    PaymentCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var PaymentCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, location = ref.location;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PAYMENT_METHOD_CREATE), 1), createPaymentMethod = ref1[0];
    return {
        state: {},
        actions: {
            /**
       * @description
       * 一連の処理の流れは以下の通り
       * 1. カード登録に必要なトークンの発行
       * 2. 登録リクエストを投げると、正常終了 or 3DSecure 認証要求
       * 3. （3DSecure 認証が求められた場合のみ）
       *    3DSecure モーダルで認証を行う
       * 4. 適切な画面にリダイレクト
       */ onSubmitCreatePayment: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                    var ref, expMonth, expYear, token, ref1, paymentResponse, clientSecret, result, ref2, redirectPath, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = (0,_sliced_to_array/* default */.Z)(values.expirationDate.split("/"), 2), expMonth = ref[0], expYear = ref[1];
                                return [
                                    4,
                                    (0,stripe/* createTokenWithCard */.xE)({
                                        number: values.cardNumber.replace(/\s/g, ""),
                                        name: values.cardHolder,
                                        cvc: values.securityCode.replace(/\s/g, ""),
                                        expMonth: expMonth,
                                        expYear: expYear
                                    }).catch(function(error) {
                                        throw new Error(t(error.message));
                                    })
                                ];
                            case 1:
                                token = _state.sent();
                                return [
                                    4,
                                    createPaymentMethod({
                                        variables: {
                                            createPaymentMethodToken: token
                                        }
                                    })
                                ];
                            case 2:
                                ref1 = _state.sent(), paymentResponse = ref1.data;
                                if (!(paymentResponse && "clientSecret" in paymentResponse.createPaymentMethod)) return [
                                    3,
                                    4
                                ];
                                clientSecret = paymentResponse.createPaymentMethod.clientSecret;
                                return [
                                    4,
                                    (0,stripe/* confirmCardSetupWithStripe */.gC)(clientSecret)
                                ];
                            case 3:
                                result = _state.sent();
                                if (result.error) throw new Error(result.error.message);
                                _state.label = 4;
                            case 4:
                                /**
         * @description
         * webhook通知〜クレジットカード登録の完了を待つため
         * 暫定的に sleep を加えている
         */ return [
                                    4,
                                    sleep(2000)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* getRedirectAfterCreditCardRegisterPath */.VY)()
                                ];
                            case 6:
                                ref2 = _state.sent(), redirectPath = ref2.value;
                                if (redirectPath) {
                                    router.push(redirectPath);
                                    (0,storage/* removeRedirectAfterCreditCardRegisterPath */.Qm)();
                                } else {
                                    ;
                                    router.goBack(((ref3 = location.state) === null || ref3 === void 0 ? void 0 : ref3.goBackPath) || routerPages.PaymentDetail);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var PAYMENT_METHOD_CREATE = (0,lib/* gql */.Ps)(PaymentCreate_viewModel_templateObject(), template_fragments_fragments.credit, template_fragments_fragments.requiresAction);

;// CONCATENATED MODULE: ./src/components/pages/PaymentCreate/index.tsx



/**
 * PaymentCreate Page
 * Implemented as a practical sample.
 */ var PaymentCreate = function() {
    var ref = PaymentCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCreateTemplate, {
        state: state,
        onSubmitCreatePayment: actions.onSubmitCreatePayment
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentDetail/viewModel.ts




function PaymentDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PaymentDetail {\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n"
    ]);
    PaymentDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaymentDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeletePaymentSource {\n    deletePaymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n"
    ]);
    PaymentDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PaymentDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,useQuery/* useQuery */.aM)(PaymentDetail_viewModel_QUERY), data = ref.data, loading = ref.loading;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PAYMENT_SOURCE_DELETE), 1), deletePaymentSource = ref1[0];
    var paymentDetail = data === null || data === void 0 ? void 0 : data.paymentSource;
    return {
        state: {
            cardNumber: paymentDetail === null || paymentDetail === void 0 ? void 0 : paymentDetail.last4,
            name: (paymentDetail === null || paymentDetail === void 0 ? void 0 : paymentDetail.name) || "",
            expirationDate: "".concat(paymentDetail === null || paymentDetail === void 0 ? void 0 : paymentDetail.expMonth, "/").concat(paymentDetail === null || paymentDetail === void 0 ? void 0 : paymentDetail.expYear),
            visible: loading,
            brand: paymentDetail === null || paymentDetail === void 0 ? void 0 : paymentDetail.brand
        },
        actions: {
            onDeletePaymentSource: function onDeletePaymentSource() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePaymentSource()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PaymentDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(PaymentDetail_viewModel_templateObject(), utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var PAYMENT_SOURCE_DELETE = (0,lib/* gql */.Ps)(PaymentDetail_viewModel_templateObject1(), utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);

;// CONCATENATED MODULE: ./src/components/pages/PaymentDetail/index.tsx




/**
 * PaymentDetail Page
 * Implemented as a practical sample.
 */ var PaymentDetail = function() {
    var ref = PaymentDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/PurchaseItem/index.tsx










var PurchaseItem = function(param) {
    var _clickable = param.clickable, clickable = _clickable === void 0 ? true : _clickable, pendingPurchaseItem = param.pendingPurchaseItem;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatuses").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref10.generatePath, routerPages = ref10.routerPages;
    var paymentType = (0,react.useMemo)(function() {
        var ref;
        return ((ref = pendingPurchaseItem.items) === null || ref === void 0 ? void 0 : ref.some(function(i) {
            return i.item.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash;
        })) ? utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash : utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint;
    }, [
        pendingPurchaseItem.items
    ]);
    var product = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)(pendingPurchaseItem === null || pendingPurchaseItem === void 0 ? void 0 : pendingPurchaseItem.artist, (ref2 = (ref = pendingPurchaseItem.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.membership) === null || ref1 === void 0 ? void 0 : ref1.planId) !== null && ref2 !== void 0 ? ref2 : "");
    }, [
        pendingPurchaseItem === null || pendingPurchaseItem === void 0 ? void 0 : pendingPurchaseItem.artist,
        (ref = pendingPurchaseItem.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.membership) === null || ref1 === void 0 ? void 0 : ref1.planId, 
    ]);
    var price = (0,react.useMemo)(function() {
        var ref;
        if (product) {
            return product.plan.amount;
        }
        var ref1;
        return pendingPurchaseItem.totalPrice + ((ref1 = (ref = pendingPurchaseItem.checkoutFees) === null || ref === void 0 ? void 0 : ref.totalFee) !== null && ref1 !== void 0 ? ref1 : 0);
    }, [
        (ref2 = pendingPurchaseItem.checkoutFees) === null || ref2 === void 0 ? void 0 : ref2.totalFee,
        pendingPurchaseItem.totalPrice,
        product, 
    ]);
    var ref11, ref12, ref13, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                disabled: !clickable || pendingPurchaseItem.status === utoniq_core_schema/* PendingPurchaseItemStatus.Failed */.PAA.Failed,
                href: generatePath(routerPages.PaymentStatusDetail, {
                    pendingPurchaseId: pendingPurchaseItem.id,
                    itemId: (ref11 = pendingPurchaseItem === null || pendingPurchaseItem === void 0 ? void 0 : (ref3 = pendingPurchaseItem.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.itemId) !== null && ref11 !== void 0 ? ref11 : "#"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 5
                        },
                        "*": {
                            color: function(theme) {
                                return pendingPurchaseItem.status === utoniq_core_schema/* PendingPurchaseItemStatus.Failed */.PAA.Failed ? "".concat(theme.palette.text.disabled, "!important") : undefined;
                            }
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 4,
                            sx: {
                                pb: 2
                            },
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SettlementTag, {
                                    status: pendingPurchaseItem.status
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: pendingPurchaseItem.status === utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment ? "primary.main" : "text.disabled",
                                    children: [
                                        t("paymentDeadline"),
                                        "：",
                                        pendingPurchaseItem.formattedExpiredAt
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 2,
                            children: [
                                product ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 2,
                                    py: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            spacing: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: t("orderDetails")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    children: product.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            src: (ref12 = (ref5 = pendingPurchaseItem.artist) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.avatar) === null || ref6 === void 0 ? void 0 : ref6.smallUri) !== null && ref12 !== void 0 ? ref12 : "",
                                            sx: {
                                                width: 48,
                                                height: 48
                                            }
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    children: [
                                        paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "text.secondary",
                                                        children: t("orderDetails")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: (ref7 = pendingPurchaseItem.items) === null || ref7 === void 0 ? void 0 : ref7.map(function(item) {
                                                            if (item.skus.length) {
                                                                return item.skus.map(function(sku) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseItem_ItemDetailCell, {
                                                                        item: item.item,
                                                                        sku: sku.sku,
                                                                        count: sku.count
                                                                    }, sku.skuId);
                                                                });
                                                            }
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseItem_ItemDetailCell, {
                                                                item: item.item,
                                                                count: item.count
                                                            }, item.itemId);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        paymentType === utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            flex: 1,
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    flex: 1,
                                                    spacing: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            color: "text.secondary",
                                                            children: t("orderDetails")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            children: t("purchasePoint", {
                                                                point: (0,state/* formatNumber */.uf)(pendingPurchaseItem.totalPrice + ((ref13 = (ref8 = pendingPurchaseItem.checkoutFees) === null || ref8 === void 0 ? void 0 : ref8.totalFee) !== null && ref13 !== void 0 ? ref13 : 0))
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                                            sx: {
                                                                fontSize: "48px"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            align: "center",
                                                            variant: "subtitle2",
                                                            sx: {
                                                                width: 56,
                                                                borderRadius: "100px",
                                                                bgcolor: "grey.100",
                                                                mt: -2
                                                            },
                                                            children: [
                                                                "\xd7",
                                                                (0,state/* formatNumber */.uf)(pendingPurchaseItem.totalPrice + ((ref14 = (ref9 = pendingPurchaseItem.checkoutFees) === null || ref9 === void 0 ? void 0 : ref9.totalFee) !== null && ref14 !== void 0 ? ref14 : 0))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("payment", "支払金額")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: t("price", {
                                                price: (0,state/* formatNumber */.uf)(price)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var PurchaseItem_ItemDetailCell = function(param) {
    var item = param.item, sku = param.sku, count = param.count;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatuses").t;
    if (!item) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        flex: 1,
        spacing: 2,
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                flex: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                    children: [
                        item.title,
                        " ",
                        !!(sku === null || sku === void 0 ? void 0 : sku.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "(",
                                sku.unitName,
                                ")"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                children: t("itemQuantity", "数量", {
                    quantity: count
                })
            })
        ]
    });
};
var SettlementTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatuses").t;
    var ref = (0,react.useMemo)(function() {
        switch(status){
            case utoniq_core_schema/* PendingPurchaseItemStatus.Completed */.PAA.Completed:
                return {
                    color: "text.disabled",
                    bgcolor: "grey.50",
                    variant: "outlined",
                    borderColor: "text.disabled"
                };
            case utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment:
                return {
                    color: "white",
                    bgcolor: "primary.main",
                    variant: "filled",
                    borderColor: "primary.main"
                };
            default:
                return {
                    color: "text.secondary",
                    bgcolor: "grey.100",
                    variant: "filled",
                    borderColor: "grey.100"
                };
        }
    }, [
        status
    ]), color = ref.color, bgcolor = ref.bgcolor, variant = ref.variant, borderColor = ref.borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "subtitle2",
            color: color,
            children: t(status)
        }),
        variant: "filled",
        sx: {
            bgcolor: bgcolor,
            px: 1,
            py: "2px",
            height: "auto",
            borderRadius: "2px",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: borderColor,
            ".MuiChip-label": {
                px: 0
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatusDetail/template/index.tsx
















var PaymentStatusDetailTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatusDetail").t;
    var ref14 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref14.generatePath, routerPages = ref14.routerPages, routerNames = ref14.routerNames;
    var renderBottomItem = (0,react.useCallback)(function() {
        var ref, ref1, ref2;
        if (((ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.status) !== utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment) {
            return null;
        }
        var ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentStatusDetail_template_FixedBottomCell, {
            expiredAt: (ref3 = (ref1 = state.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.formattedExpiredAt) !== null && ref3 !== void 0 ? ref3 : "",
            voucherUrl: (ref4 = (ref2 = state.pendingPurchaseItem) === null || ref2 === void 0 ? void 0 : ref2.voucherUrl) !== null && ref4 !== void 0 ? ref4 : ""
        });
    }, [
        (ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.formattedExpiredAt,
        (ref1 = state.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.status,
        (ref2 = state.pendingPurchaseItem) === null || ref2 === void 0 ? void 0 : ref2.voucherUrl, 
    ]);
    // 個人情報の登録必須項目
    var personalInformationRequirements = (0,react.useMemo)(function() {
        var ref;
        if (!state.pendingPurchaseItem) {
            return [];
        }
        var result = (ref = state.pendingPurchaseItem.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        state.pendingPurchaseItem
    ]);
    var product = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var ref4;
        return (0,core_membership/* getActiveMembershipSubscriptionProductPlan */.P)((ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.artist, (ref4 = (ref1 = state.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.membership) === null || ref3 === void 0 ? void 0 : ref3.planId) !== null && ref4 !== void 0 ? ref4 : "");
    }, [
        (ref3 = state.pendingPurchaseItem) === null || ref3 === void 0 ? void 0 : ref3.artist,
        (ref4 = state.pendingPurchaseItem) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.membership) === null || ref6 === void 0 ? void 0 : ref6.planId, 
    ]);
    var isCashPaymentType = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (product) return true;
        if (!((ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.items)) return false;
        return (ref1 = state.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.some(function(item) {
            return item.item.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash;
        });
    }, [
        state.pendingPurchaseItem,
        product
    ]);
    var isShowUsageTicketNote = (0,react.useMemo)(function() {
        var ref, ref1;
        return !!((ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return item.item.type === utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket;
        }));
    }, [
        (ref7 = state.pendingPurchaseItem) === null || ref7 === void 0 ? void 0 : ref7.items
    ]);
    var pathButtonComplete = (0,react.useMemo)(function() {
        var ref, ref1;
        if (product) {
            var ref2;
            return generatePath(routerPages.MembershipManagement, {
                artistId: (ref2 = state.pendingPurchaseItem) === null || ref2 === void 0 ? void 0 : ref2.artistId
            });
        }
        return ((ref = state.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.cartTransactionOrderId) ? generatePath(routerPages.StorePurchaseOrderDetail, {
            purchaseOrderId: (ref1 = state.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.cartTransactionOrderId
        }) : routerPages.StorePurchaseOrders;
    }, [
        generatePath,
        product,
        routerPages,
        state.pendingPurchaseItem
    ]);
    var ref15, ref16, ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: routerPages.PaymentStatuses,
            title: t("title")
        },
        customNavigation: renderBottomItem(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PaymentStatusDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            pt: 3,
                            pb: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentStatusDetail_template_OrderDetailCell, {
                            loading: state.loading,
                            formattedTotalPrice: (ref16 = (ref15 = product === null || product === void 0 ? void 0 : (ref8 = product.plan) === null || ref8 === void 0 ? void 0 : ref8.formattedAmount) !== null && ref15 !== void 0 ? ref15 : (ref9 = state.pendingPurchaseItem) === null || ref9 === void 0 ? void 0 : ref9.formattedTotalPrice) !== null && ref16 !== void 0 ? ref16 : "0",
                            orderItems: state.orderItems,
                            status: (ref10 = state.pendingPurchaseItem) === null || ref10 === void 0 ? void 0 : ref10.status,
                            formattedExpiredAt: (ref17 = (ref11 = state.pendingPurchaseItem) === null || ref11 === void 0 ? void 0 : ref11.formattedExpiredAt) !== null && ref17 !== void 0 ? ref17 : "",
                            product: product,
                            shippingFee: state.shippingFee,
                            systemFee: state.systemFee,
                            konbiniFee: state.konbiniFee,
                            totalPrice: (ref12 = state.pendingPurchaseItem) === null || ref12 === void 0 ? void 0 : ref12.totalPrice,
                            purchaseType: isCashPaymentType ? "konbini" : "prepaid_point",
                            paymentType: isCashPaymentType ? utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash : utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseInfo, {
                        loading: state.loading,
                        artist: state.artist
                    }),
                    personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingAddress, {
                        loading: state.loading,
                        fullName: state.fullName,
                        address: state.address,
                        isPhoneNumberVerified: state.isPhoneNumberVerified,
                        phoneNumber: state.phoneNumber,
                        personalInformationRequirements: personalInformationRequirements
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentInfo, {
                        loading: state.loading,
                        formattedPrepaidPointBalance: state.formattedPrepaidPointBarance,
                        purchaseType: "konbini",
                        showNote: true
                    }),
                    isShowUsageTicketNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        component: "p",
                        variant: "caption",
                        color: "text.secondary",
                        children: t("usageTicketNote")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            mt: 6,
                            px: 5,
                            pb: 8
                        },
                        children: ((ref13 = state.pendingPurchaseItem) === null || ref13 === void 0 ? void 0 : ref13.status) === utoniq_core_schema/* PendingPurchaseItemStatus.Completed */.PAA.Completed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "outlined",
                            size: "large",
                            href: pathButtonComplete,
                            children: !product ? t("confirmOrderDetail") : t("viewMembership")
                        })
                    })
                ]
            })
        ]
    });
};
var PaymentStatusDetail_template_OrderDetailCell = function(_param) {
    var loading = _param.loading, product = _param.product, orderItems = _param.orderItems, formattedTotalPrice = _param.formattedTotalPrice, status = _param.status, formattedExpiredAt = _param.formattedExpiredAt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "loading",
        "product",
        "orderItems",
        "formattedTotalPrice",
        "status",
        "formattedExpiredAt"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatusDetail").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItemDetailSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                color: "text.secondary",
                sx: {
                    py: 3
                },
                children: t("orderDetail", "注文内容")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            sx: {
                                pb: 2
                            },
                            alignItems: "center",
                            children: [
                                status && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettlementTag, {
                                    status: status
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: status === utoniq_core_schema/* PendingPurchaseItemStatus.WaitingPayment */.PAA.WaitingPayment ? "primary.main" : "text.disabled",
                                    children: [
                                        t("paymentDeadline"),
                                        "：",
                                        formattedExpiredAt
                                    ]
                                })
                            ]
                        }),
                        product ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: product.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("".concat(product.plan.interval, "Fee"), {
                                        amount: product.plan.formattedAmount
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            children: orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function(orderItem, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_OrderItemCell, {
                                    item: orderItem.item,
                                    quantity: orderItem.count
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                            sx: {
                                my: 3
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                            formattedTotalPrice: formattedTotalPrice
                        }))
                    ]
                })
            })
        ]
    });
};
var PaymentStatusDetail_template_FixedBottomCell = function(param) {
    var expiredAt = param.expiredAt, voucherUrl = param.voucherUrl;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatusDetail").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)(voucherUrl).onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                p: 5
            },
            alignItems: "center",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: t("paymentDeadline", {
                        expiredAt: expiredAt
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    color: "primary",
                    sx: {
                        width: 160
                    },
                    disabled: !voucherUrl,
                    onClick: onClick,
                    children: t("confirmPayment")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatusDetail/viewModel.ts

function PaymentStatusDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreItemUnsettledDetail($pendingPurchaseId: ID!) {\n    pendingPurchaseItem(pendingPurchaseId: $pendingPurchaseId) {\n      ...PendingPurchaseItemDetail\n    }\n    user {\n      id\n      fullName\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n    prepaidPointBalance {\n      lastUpdatedAt\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    PaymentStatusDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PaymentStatusDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref12 = (0,useQuery/* useQuery */.aM)(PaymentStatusDetail_viewModel_QUERY, {
        variables: {
            pendingPurchaseId: router.query.pendingPurchaseId
        }
    }), data = ref12.data, loading = ref12.loading;
    var ref13, ref14, ref15, ref16, ref17, ref18;
    return {
        state: {
            loading: loading,
            pendingPurchaseItem: data === null || data === void 0 ? void 0 : data.pendingPurchaseItem,
            orderItems: convertUserCartItemsToSku(data === null || data === void 0 ? void 0 : data.pendingPurchaseItem.items),
            fullName: (ref13 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.fullName) !== null && ref13 !== void 0 ? ref13 : "",
            address: (ref14 = data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.address) !== null && ref14 !== void 0 ? ref14 : null,
            phoneNumber: (data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.phoneNumber) || "",
            isPhoneNumberVerified: !!(data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.isPhoneNumberVerified),
            artist: (ref15 = data === null || data === void 0 ? void 0 : (ref4 = data.pendingPurchaseItem) === null || ref4 === void 0 ? void 0 : ref4.artist) !== null && ref15 !== void 0 ? ref15 : null,
            systemFee: addCollectionToCollectionFee((ref5 = data === null || data === void 0 ? void 0 : data.pendingPurchaseItem.checkoutFees) === null || ref5 === void 0 ? void 0 : ref5.collections, data === null || data === void 0 ? void 0 : (ref6 = data.pendingPurchaseItem) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.items) === null || ref7 === void 0 ? void 0 : ref7.map(function(param) {
                var item = param.item;
                return item.collection;
            })),
            shippingFee: (ref16 = data === null || data === void 0 ? void 0 : (ref8 = data.pendingPurchaseItem) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.checkoutFees) === null || ref9 === void 0 ? void 0 : ref9.shipping) !== null && ref16 !== void 0 ? ref16 : null,
            konbiniFee: (ref17 = (ref10 = data === null || data === void 0 ? void 0 : data.pendingPurchaseItem.checkoutFees) === null || ref10 === void 0 ? void 0 : ref10.konbini) !== null && ref17 !== void 0 ? ref17 : null,
            formattedPrepaidPointBarance: (ref18 = data === null || data === void 0 ? void 0 : (ref11 = data.prepaidPointBalance) === null || ref11 === void 0 ? void 0 : ref11.formattedPrepaidPointBarance) !== null && ref18 !== void 0 ? ref18 : 0
        },
        actions: {}
    };
});
var PaymentStatusDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(PaymentStatusDetail_viewModel_templateObject(), utoniq_core_schema/* PendingPurchaseItemDetailFragmentDoc */.N6h, utoniq_core_schema/* UserAddressFragmentDoc */.enF);

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatusDetail/index.tsx




/**
 * PaymentStatusDetail Page
 * Implemented as a practical sample.
 */ var PaymentStatusDetail = function() {
    var ref = PaymentStatusDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentStatusDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/PurchaseItemSkeleton/index.tsx




var PurchaseItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 4,
                        alignItems: "center",
                        sx: {
                            pb: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 4,
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "medium"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        flex: 2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: Array.from(Array(3).keys()).map(function(index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 3,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "small"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                    variant: "small"
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "25%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "25%"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatuses/template/index.tsx







var PaymentStatusesTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("paymentStatuses").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Management
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PaymentStatuses
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref = state.pendingPurchaseItems) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseItem, {
                        pendingPurchaseItem: node
                    }, node.id);
                }),
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                emptyMessage: t("noPayments"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    children: Array.from(Array(2).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseItemSkeleton, {}, key);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatuses/viewModel.ts



function PaymentStatuses_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PaymentStatuses($pageInput: PageInputDate) {\n    pendingPurchaseItems(pageInput: $pageInput) {\n      ...PendingPurchaseItemsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    PaymentStatuses_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PaymentStatuses_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var isFirstLoadRef = useGetNewestData({
        query: PaymentStatuses_viewModel_QUERY,
        variables: {},
        fields: [
            {
                fieldName: "pendingPurchaseItems",
                fragmentName: "PendingPurchaseItemDetail",
                fragment: utoniq_core_schema/* PendingPurchaseItemDetailFragmentDoc */.N6h
            }, 
        ]
    }).isFirstLoadRef;
    var ref = (0,useQuery/* useQuery */.aM)(PaymentStatuses_viewModel_QUERY, {
        variables: {},
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore;
    var ref1;
    return {
        state: {
            loading: loading,
            pendingPurchaseItems: (ref1 = data === null || data === void 0 ? void 0 : data.pendingPurchaseItems) !== null && ref1 !== void 0 ? ref1 : null,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.pendingPurchaseItems.pageInfo.hasNextPage)
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.pendingPurchaseItems.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PaymentStatuses_viewModel_QUERY = (0,lib/* gql */.Ps)(PaymentStatuses_viewModel_templateObject(), utoniq_core_schema/* PendingPurchaseItemsConnectionFragmentDoc */.yn4);

;// CONCATENATED MODULE: ./src/components/pages/PaymentStatuses/index.tsx




/**
 * PaymentStatuses Page
 * Implemented as a practical sample.
 */ var PaymentStatuses = function() {
    var ref = PaymentStatuses_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentStatusesTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/pages/PersonalInfoSettings/template/PersonalInfoForm.tsx + 6 modules
var PersonalInfoForm = __webpack_require__(59473);
;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/template/index.tsx










var PersonalInfoSettingsTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onSendVerificationSMS = param.onSendVerificationSMS, onResendVerificationSMS = param.onResendVerificationSMS, onVerificationPhoneNumber = param.onVerificationPhoneNumber, onChangeNeedVerifyPhoneNumber = param.onChangeNeedVerifyPhoneNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var formContext = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        return {
            hasFullName: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.fullName),
            hasPhoneNumber: !!((ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber),
            hasBirthday: !!((ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.birthday),
            hasGender: !!((ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.gender),
            hasPostalCode: !!((ref4 = state.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.address) === null || ref5 === void 0 ? void 0 : ref5.postalCode),
            hasPrefecture: !!((ref6 = state.user) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.address) === null || ref7 === void 0 ? void 0 : ref7.prefecture),
            hasCity: !!((ref8 = state.user) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.address) === null || ref9 === void 0 ? void 0 : ref9.city),
            hasLine1: !!((ref10 = state.user) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.address) === null || ref11 === void 0 ? void 0 : ref11.line1)
        };
    }, [
        state.user
    ]);
    var personalInfoForm = (0,core_form/* useForm */.cI)({
        schema: PersonalInfoForm/* schema */.fK,
        defaultValues: PersonalInfoForm/* defaultValues */.Pg,
        context: formContext
    });
    var reset = personalInfoForm.reset;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!state.user) return;
        var _birthday, _gender, _phoneNumber, _fullName, ref6, ref7, ref8, ref9, ref10;
        reset((0,src_object_spread/* default */.Z)({
            birthday: (_birthday = state.user.birthday) !== null && _birthday !== void 0 ? _birthday : null,
            gender: (_gender = state.user.gender) !== null && _gender !== void 0 ? _gender : null,
            phoneNumber: (_phoneNumber = state.user.phoneNumber) !== null && _phoneNumber !== void 0 ? _phoneNumber : "",
            fullName: (_fullName = state.user.fullName) !== null && _fullName !== void 0 ? _fullName : "",
            postalCode: (ref6 = (ref = state.user.address) === null || ref === void 0 ? void 0 : ref.postalCode) !== null && ref6 !== void 0 ? ref6 : "",
            prefecture: (ref7 = (ref1 = state.user.address) === null || ref1 === void 0 ? void 0 : ref1.prefecture) !== null && ref7 !== void 0 ? ref7 : "",
            city: (ref8 = (ref2 = state.user.address) === null || ref2 === void 0 ? void 0 : ref2.city) !== null && ref8 !== void 0 ? ref8 : "",
            line1: (ref9 = (ref3 = state.user.address) === null || ref3 === void 0 ? void 0 : ref3.line1) !== null && ref9 !== void 0 ? ref9 : "",
            line2: (ref10 = (ref4 = state.user.address) === null || ref4 === void 0 ? void 0 : ref4.line2) !== null && ref10 !== void 0 ? ref10 : "",
            isMembershipPersonalInformationRequired: !!((ref5 = state.user) === null || ref5 === void 0 ? void 0 : ref5.isMembershipPersonalInformationRequired)
        }, formContext));
    }, [
        state.user,
        reset,
        formContext
    ]);
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onSubmit(values).catch(function(e) {
                                return (0,core_form/* handleError */.S3)(e, personalInfoForm.setError, showError);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onSubmit,
        personalInfoForm,
        showError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            defaultBackPage: routerPages.AccountSetting,
            back: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PersonalInfoSettings
            }),
            state.isMembershipPersonalInformationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredMembershipInfoBox/* RequiredMembershipInfoBox */.k, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInfoForm/* PersonalInfoForm */.aH, {
                visibleMoreInfo: true,
                user: state.user,
                personalInfoForm: personalInfoForm,
                isMembershipPersonalInformationRequired: !!state.isMembershipPersonalInformationRequired,
                paymentSource: state.paymentSource,
                submitting: state.submitting,
                onSubmit: handleSubmit,
                needVerifyPhoneNumber: !!state.needVerifyPhoneNumber,
                sendingSMSCode: !!state.sendingSMSCode,
                verifyingSMSCode: !!state.verifyingSMSCode,
                onChangeNeedVerifyPhoneNumber: onChangeNeedVerifyPhoneNumber,
                onVerificationPhoneNumber: onVerificationPhoneNumber,
                onSendVerificationSMS: onSendVerificationSMS,
                onResendVerificationSMS: onResendVerificationSMS
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/viewModel.ts




function PersonalInfoSettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query personalInfo {\n    user {\n      ...PersonalInfo\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    PersonalInfoSettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PersonalInfoSettings_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updatePersonalInformationSettings($inputs: UpdateProfileInput!) {\n    updateUserProfile(inputs: $inputs) {\n      ...PersonalInfo\n    }\n  }\n  ",
        "\n"
    ]);
    PersonalInfoSettings_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var PersonalInfoSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("personalInfoSettings").t;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref1 = (0,react.useState)(false), needVerifyPhoneNumber = ref1[0], setNeedVerifyPhoneNumber = ref1[1];
    var ref2 = (0,useQuery/* useQuery */.aM)(PersonalInfoSettings_viewModel_QUERY), data = ref2.data, refetch = ref2.refetch;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserDeliveryInfo */.p2K), 2), updateUserDeliveryInfo = ref3[0], ref4 = ref3[1], submitting = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* VerifySmsCode */.gkA), 2), verifySMSCode = ref5[0], ref6 = ref5[1], verifyingSMSCode = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref7[0], ref8 = ref7[1], sendingSMSCode = ref8.loading;
    var ref9;
    return {
        state: {
            user: data === null || data === void 0 ? void 0 : data.user,
            submitting: submitting,
            sendingSMSCode: sendingSMSCode,
            paymentSource: (ref9 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref9 !== void 0 ? ref9 : null,
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired),
            verifyingSMSCode: verifyingSMSCode,
            needVerifyPhoneNumber: needVerifyPhoneNumber
        },
        actions: {
            onSubmit: function onSubmit(values) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            updateUserDeliveryInfo({
                                variables: {
                                    updateUserDeliveryInfoInputs: {
                                        fullName: values.fullName,
                                        phoneNumber: values.phoneNumber,
                                        birthday: values.birthday,
                                        gender: values.gender,
                                        address: {
                                            postalCode: values.postalCode,
                                            prefecture: values.prefecture,
                                            city: values.city,
                                            line1: values.line1,
                                            line2: values.line2
                                        }
                                    }
                                }
                            }).then(function(param) {
                                var data = param.data;
                                if (!(data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo.isPhoneNumberVerified)) {
                                    return setNeedVerifyPhoneNumber(true);
                                }
                                showMessage(t("registerSuccess"), "success");
                            })
                        ];
                    });
                })();
            },
            onChangeNeedVerifyPhoneNumber: function onChangeNeedVerifyPhoneNumber(needVerifyPhoneNumber) {
                setNeedVerifyPhoneNumber(needVerifyPhoneNumber);
            },
            onVerificationPhoneNumber: function onVerificationPhoneNumber(param) {
                var code = param.code;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    verifySMSCode({
                                        variables: {
                                            code: code
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                showMessage(t("registerSuccess"), "success");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onResendVerificationSMS: function onResendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PersonalInfoSettings_viewModel_QUERY = (0,lib/* gql */.Ps)(PersonalInfoSettings_viewModel_templateObject(), utoniq_core_schema/* PersonalInfoFragmentDoc */._ml, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var UPDATE_PERSONAL_INFORMATION_SETTINGS = (0,lib/* gql */.Ps)(PersonalInfoSettings_viewModel_templateObject1(), utoniq_core_schema/* PersonalInfoFragmentDoc */._ml);

;// CONCATENATED MODULE: ./src/components/pages/PersonalInfoSettings/index.tsx




var PersonalInfoSettings = function() {
    var ref = PersonalInfoSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInfoSettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/PostDetail/template/index.tsx














var PostDetailTemplate = function(param) {
    var state = param.state, onReply = param.onReply, onLike = param.onLike, onDeleteReply = param.onDeleteReply, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onReportArtist = param.onReportArtist, onLikeOrUnlikeReply = param.onLikeOrUnlikeReply, onFetchMore = param.onFetchMore, onClickShare = param.onClickShare;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var ref26 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref26.routerNames, routerPages = ref26.routerPages, generatePath = ref26.generatePath, router = ref26.router;
    var replyFormRef = (0,react.useRef)(null);
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("postDetail").t;
    var isPcView = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var shouldShowPcOptimizedLayout = (0,react.useMemo)(function() {
        return isPcView && displayResponsive;
    }, [
        isPcView,
        displayResponsive
    ]);
    var handleReportArtist = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!onReportArtist) return [
                        2
                    ];
                    return [
                        4,
                        onReportArtist((ref5 = (ref = state.post) === null || ref === void 0 ? void 0 : ref.id) !== null && ref5 !== void 0 ? ref5 : "", (ref6 = (ref1 = state.post) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.artist) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : "", (ref7 = (ref3 = state.post) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : ref4.formattedAccountId) !== null && ref7 !== void 0 ? ref7 : "")
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onReportArtist,
        (ref = state.post) === null || ref === void 0 ? void 0 : (ref1 = ref.artist) === null || ref1 === void 0 ? void 0 : ref1.formattedAccountId,
        (ref2 = state.post) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.artist) === null || ref3 === void 0 ? void 0 : ref3.id,
        (ref4 = state.post) === null || ref4 === void 0 ? void 0 : ref4.id, 
    ]);
    var handleBlockArtist = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onBlockUser((ref2 = (ref = state.post) === null || ref === void 0 ? void 0 : ref.artistId) !== null && ref2 !== void 0 ? ref2 : "")
                    ];
                case 1:
                    _state.sent();
                    showMessage(t("blockArtistSuccess"), "success");
                    router.push(generatePath(routerPages.ArtistTop, {
                        artistId: (ref1 = state.post) === null || ref1 === void 0 ? void 0 : ref1.artistId
                    }));
                    return [
                        2
                    ];
            }
        });
    }), [
        generatePath,
        onBlockUser,
        router,
        routerPages.ArtistTop,
        showMessage,
        (ref5 = state.post) === null || ref5 === void 0 ? void 0 : ref5.artistId,
        t, 
    ]);
    if (!state.loading && !state.post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    // ユーザーが加入しているメンバーシップよりも上位プランであるかどうか
    var isGraterPlan = !(state === null || state === void 0 ? void 0 : (ref6 = state.post) === null || ref6 === void 0 ? void 0 : ref6.isAccessible) && (state === null || state === void 0 ? void 0 : (ref7 = state.post) === null || ref7 === void 0 ? void 0 : ref7.planId);
    // アクセス可能かつコメント機能が有効であるかどうか
    var shouldShowReplies = ((ref8 = state.post) === null || ref8 === void 0 ? void 0 : ref8.isAccessible) && !state.disableReplies;
    var ref27, ref28, ref29, _user, ref30, ref31, _user1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref9 = state.post) === null || ref9 === void 0 ? void 0 : ref9.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            navigation: /** レスポンシブ適用対象でPC表示の場合は画面の右側に設置するため、コメント入力欄はナビゲーションからは非表示にする */ shouldShowReplies && !shouldShowPcOptimizedLayout ? {
                type: "replyForm",
                props: {
                    ref: replyFormRef,
                    onReply: onReply,
                    userId: (ref27 = (ref10 = state.user) === null || ref10 === void 0 ? void 0 : ref10.id) !== null && ref27 !== void 0 ? ref27 : ""
                },
                responsive: displayResponsive
            } : undefined,
            header: (0,src_object_spread/* default */.Z)({
                back: true,
                defaultBackPage: ((ref11 = state.post) === null || ref11 === void 0 ? void 0 : ref11.artistId) && generatePath(routerPages.ArtistTop, {
                    artistId: (ref12 = state.post) === null || ref12 === void 0 ? void 0 : ref12.artistId
                })
            }, displayResponsive ? {
                responsive: true,
                maxWidth: 1120
            } : {}),
            maxWidth: displayResponsive ? 1120 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: [
                        routerNames.PostDetail,
                        (ref13 = state.post) === null || ref13 === void 0 ? void 0 : ref13.artist.displayName
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: shouldShowPcOptimizedLayout ? {
                        display: "flex",
                        justifyContent: "center",
                        gap: 1
                    } : {},
                    children: [
                        state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailBoxSkeleton, {
                            sx: shouldShowPcOptimizedLayout ? {
                                maxWidth: "736px",
                                flex: 2
                            } : {}
                        }),
                        !state.loading && (state === null || state === void 0 ? void 0 : state.post) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            sx: shouldShowPcOptimizedLayout ? {
                                maxWidth: "736px",
                                flex: 2
                            } : {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailBox, (0,src_object_spread/* default */.Z)({
                                userId: (ref14 = state.user) === null || ref14 === void 0 ? void 0 : ref14.id,
                                post: state.post,
                                isMembershipPersonalInformationRequired: state.isMembershipPersonalInformationRequired,
                                onLike: function() {
                                    if (!state.post) return;
                                    onLike(!!(state === null || state === void 0 ? void 0 : state.post.isLike), state === null || state === void 0 ? void 0 : state.post.likeCount);
                                },
                                onReply: function() {
                                    var ref;
                                    return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                                },
                                onBlockArtist: handleBlockArtist,
                                onReportArtist: handleReportArtist,
                                enableEmbedHtml: true,
                                onClickShare: onClickShare
                            }, displayResponsive ? {
                                responsive: true,
                                detail: true
                            } : {}))
                        }),
                        !(state === null || state === void 0 ? void 0 : state.loading) && !(state === null || state === void 0 ? void 0 : (ref15 = state.post) === null || ref15 === void 0 ? void 0 : ref15.isAccessible) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                            onClose: function() {
                                var ref;
                                return router.goBack(generatePath(routerPages.ArtistTop, {
                                    artistId: state === null || state === void 0 ? void 0 : (ref = state.post) === null || ref === void 0 ? void 0 : ref.artist.id
                                }));
                            },
                            open: true,
                            title: isGraterPlan ? t("viewMemberInfoTitleWithDiff") : t("viewMemberInfoTitle"),
                            //planTitleが存在しない場合に空文字を表示しているが、運用上planTitleはisGraterPlanがtureの場合必ず存在する
                            content: isGraterPlan ? t("viewMemberInfoDescWithDiff", {
                                planTitle: (ref28 = state === null || state === void 0 ? void 0 : (ref16 = state.post) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.plan) === null || ref17 === void 0 ? void 0 : ref17.planTitle) !== null && ref28 !== void 0 ? ref28 : ""
                            }) : t("viewMemberInfoDesc", {
                                displayName: state === null || state === void 0 ? void 0 : (ref18 = state.post) === null || ref18 === void 0 ? void 0 : ref18.artist.displayName
                            }),
                            cancelText: t("close"),
                            buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                color: "primary",
                                sx: {
                                    minWidth: 212
                                },
                                href: (state === null || state === void 0 ? void 0 : (ref19 = state.post) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.artist) === null || ref20 === void 0 ? void 0 : ref20.id) ? generatePath(routerPages.ArtistMembership, {
                                    artistId: state === null || state === void 0 ? void 0 : state.post.artist.id
                                }) : undefined,
                                children: t("seeDetail")
                            })
                        }),
                        (state.loading || shouldShowReplies) && (shouldShowPcOptimizedLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                                loading: state.loading,
                                hasNextPage: state.hasNextPage,
                                commentCount: (ref21 = state.post) === null || ref21 === void 0 ? void 0 : ref21.replyCount,
                                comments: (ref29 = (ref22 = state.post) === null || ref22 === void 0 ? void 0 : ref22.replies) !== null && ref29 !== void 0 ? ref29 : null,
                                user: (_user = state.user) !== null && _user !== void 0 ? _user : null,
                                onFetchMore: onFetchMore,
                                onDeleteComment: onDeleteReply,
                                onReportUser: onReportUser,
                                onBlockUser: onBlockUser,
                                showReaction: true,
                                onLikeOrUnlikeComment: onLikeOrUnlikeReply,
                                hiddenReply: true,
                                onClickReply: function() {},
                                onReplyToReply: function() {},
                                disableLikes: state.disableLikes,
                                // コメント入力欄とヘッダを表示するのはコメント機能が有効であることが確定してから。ローディング中は表示しない
                                replyFormProps: shouldShowReplies ? {
                                    ref: replyFormRef,
                                    onReply: onReply,
                                    userId: (ref30 = (ref23 = state.user) === null || ref23 === void 0 ? void 0 : ref23.id) !== null && ref30 !== void 0 ? ref30 : ""
                                } : undefined,
                                hiddenHeader: !shouldShowReplies
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            commentCount: (ref24 = state.post) === null || ref24 === void 0 ? void 0 : ref24.replyCount,
                            comments: (ref31 = (ref25 = state.post) === null || ref25 === void 0 ? void 0 : ref25.replies) !== null && ref31 !== void 0 ? ref31 : null,
                            user: (_user1 = state.user) !== null && _user1 !== void 0 ? _user1 : null,
                            onFetchMore: onFetchMore,
                            onDeleteComment: onDeleteReply,
                            onReportUser: onReportUser,
                            onBlockUser: onBlockUser,
                            showReaction: true,
                            onLikeOrUnlikeComment: onLikeOrUnlikeReply,
                            hiddenReply: true,
                            onClickReply: function() {},
                            onReplyToReply: function() {},
                            disableLikes: state.disableLikes,
                            // ヘッダを表示するのはコメント機能が有効であることが確定してから。ローディング中は表示しない
                            hiddenHeader: !shouldShowReplies
                        }))
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PostDetail/viewModel.ts




function PostDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PostDetail($postId: ID!, $pageInput: PageInput) {\n    post(id: $postId) {\n      ...PostBox\n      replies(pageInput: $pageInput) {\n        ...RepliesConnection\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    PostDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikePost($likePostPostId: ID!) {\n    likePost(postId: $likePostPostId) {\n      id\n      likeCount\n      isLike\n    }\n  }\n"
    ]);
    PostDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikePost($unlikePostPostId: ID!) {\n    unlikePost(postId: $unlikePostPostId) {\n      id\n      likeCount\n      isLike\n    }\n  }\n"
    ]);
    PostDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ReplyPost($replyPostInputs: ReplyPostInput!) {\n    replyPost(inputs: $replyPostInputs) {\n      ...ReplyBox\n    }\n  }\n  ",
        "\n"
    ]);
    PostDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeletePostReply($deletePostReplyId: ID!) {\n    deletePostReply(id: $deletePostReplyId) {\n      ...ReplyBox\n    }\n  }\n  ",
        "\n"
    ]);
    PostDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation BlockUser($id: ID!) {\n    blockUser(id: $id) {\n      id\n      accountId\n      formattedAccountId @client\n      blockedUsers\n    }\n  }\n"
    ]);
    PostDetail_viewModel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PostDetail_viewModel_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation likePostReply($id: ID!) {\n    likePostReply(id: $id) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    PostDetail_viewModel_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function viewModel_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation unlikePostReply($id: ID!) {\n    unlikePostReply(id: $id) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    viewModel_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}











var PostDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref12 = (0,router_useRouter/* useRouter */.tv)(), router = ref12.router, routerPages = ref12.routerPages, generatePath = ref12.generatePath;
    var ref13 = (0,core_i18n/* useTranslation */.$G)(), tcommon = ref13.t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref14 = (0,useQuery/* useQuery */.aM)(PostDetail_viewModel_QUERY, {
        variables: {
            postId: router.query.postId
        },
        returnPartialData: true
    }), data = ref14.data, loading = ref14.loading, fetchMore = ref14.fetchMore, refetch = ref14.refetch;
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_POST), 1), likePost = ref15[0];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_POST), 1), unlikePost = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REPLY_POST), 1), replyPost = ref17[0];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_POST_REPLY), 1), deletePostReply = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(BLOCK_USER), 1), blockUser = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_POST_REPLY), 1), likePostReply = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_POST_REPLY), 1), unlikePostReply = ref21[0];
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: generatePath(routerPages.PostDetail, {
            postId: router.query.postId
        })
    });
    var ref22, ref23;
    return {
        state: {
            loading: useInitialLoading(data, loading),
            isLoggedIn: !!user,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            post: (ref22 = (0,individual/* individualFilterBannedUserPostComment */.mn)(data === null || data === void 0 ? void 0 : data.post)) !== null && ref22 !== void 0 ? ref22 : null,
            user: (ref23 = data === null || data === void 0 ? void 0 : data.user) !== null && ref23 !== void 0 ? ref23 : null,
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.isMembershipPersonalInformationRequired),
            disableReplies: !!((ref5 = data === null || data === void 0 ? void 0 : (ref4 = data.post) === null || ref4 === void 0 ? void 0 : ref4.artist.settings) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.features) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.post) === null || ref7 === void 0 ? void 0 : ref7.disableReplies),
            disableLikes: !!((ref9 = data === null || data === void 0 ? void 0 : (ref8 = data.post) === null || ref8 === void 0 ? void 0 : ref8.artist.settings) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.features) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.post) === null || ref11 === void 0 ? void 0 : ref11.disableLikes)
        },
        actions: {
            onReply: function onReply(param) {
                var content = param.content;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    replyPost({
                                        variables: {
                                            replyPostInputs: {
                                                postId: router.query.postId,
                                                content: content
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLike: function onLike(isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: router.query.postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: router.query.postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteReply: function onDeleteReply(replyId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deletePostReply({
                                        variables: {
                                            deletePostReplyId: replyId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "post-replies",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportArtist: function onReportArtist(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "post",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(id) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: id
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        postId: router.query.postId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            postId: router.query.postId,
                                            pageInput: {
                                                cursor: (data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor) || null,
                                                limit: 30
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeOrUnlikeReply: function onLikeOrUnlikeReply(param) {
                var commentId = param.commentId, isLike = param.isLike, likeCount = param.likeCount;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePostReply({
                                        variables: {
                                            id: commentId
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                unlikePostReply: {
                                                    id: commentId,
                                                    isLike: !isLike,
                                                    likeCount: --likeCount,
                                                    __typename: "PostReply"
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePostReply({
                                        variables: {
                                            id: commentId
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            return {
                                                likePostReply: {
                                                    id: commentId,
                                                    isLike: !isLike,
                                                    likeCount: ++likeCount,
                                                    __typename: "PostReply"
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: function onClickShare() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, title, url, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                title = data === null || data === void 0 ? void 0 : (ref = data.post) === null || ref === void 0 ? void 0 : ref.artist.displayName;
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: title !== null && title !== void 0 ? title : tcommon("metaTitle"),
                                        text: (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.post) === null || ref1 === void 0 ? void 0 : ref1.content) !== null && ref2 !== void 0 ? ref2 : tcommon("metaDescription"),
                                        url: url,
                                        dialogTitle: title !== null && title !== void 0 ? title : tcommon("metaTitle")
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PostDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject(), utoniq_core_schema/* CurrentUserFragmentDoc */.o0g, utoniq_core_schema/* RepliesConnectionFragmentDoc */.Q1X, utoniq_core_schema/* PostBoxFragmentDoc */.cSz);
var LIKE_POST = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject1());
var UNLIKE_POST = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject2());
var REPLY_POST = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject3(), utoniq_core_schema/* ReplyBoxFragmentDoc */.pO$);
var DELETE_POST_REPLY = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject4(), utoniq_core_schema/* ReplyBoxFragmentDoc */.pO$);
var BLOCK_USER = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject5());
var LIKE_POST_REPLY = (0,lib/* gql */.Ps)(PostDetail_viewModel_templateObject6());
var UNLIKE_POST_REPLY = (0,lib/* gql */.Ps)(viewModel_templateObject7());

;// CONCATENATED MODULE: ./src/components/pages/PostDetail/index.tsx




/**
 * PostDetail Page
 * Implemented as a practical sample.
 */ var PostDetail = function() {
    var ref = PostDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/MembershipRecommendBox.tsx




var MembershipRecommendBox = function(props) {
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        id: "modal-inner",
        sx: (0,src_object_spread/* default */.Z)({
            width: 280,
            borderRadius: 3,
            px: 5,
            py: 7,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "grey.100",
            outline: "none",
            textAlign: "center"
        }, Object.assign({})),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    pb: 3
                },
                children: props.membershipRecommendTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pb: 7
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: props.membershipRecommendText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            color: "primary",
                            size: "large",
                            fullWidth: true,
                            onClick: function() {
                                router.push(generatePath(routerPages.ArtistMembership, {
                                    artistId: props.artistId
                                }));
                            },
                            children: props.recommendButtonText
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/RequiredMembershipRecommendBox.tsx




var RequiredMembershipRecommendBox = function(param) {
    var title = param.title, content = param.content, buttons = param.buttons, cancelText = param.cancelText, sx = param.sx, innerSx = param.innerSx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        id: "modal-inner",
        sx: (0,src_object_spread/* default */.Z)({
            width: 280,
            borderRadius: 3,
            px: 5,
            py: 7,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "grey.100",
            outline: "none",
            textAlign: "center"
        }, Object.assign({}, sx, innerSx)),
        children: [
            typeof title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    pb: 3
                },
                children: title
            }) : title,
            typeof content === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    pb: 7
                },
                children: content
            }) : content,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                alignItems: "center",
                children: [
                    buttons,
                    cancelText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        color: "primary",
                        children: cancelText
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ScrollView.tsx





var ScrollView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        component: "div",
        style: {
            width: "100%",
            height: "100dvh",
            position: "relative",
            overflow: "scroll",
            scrollSnapType: "y mandatory"
        },
        children: props.children
    }));
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(92603);
;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ShortVideoControl.tsx














var ShortVideoControl = function(param) {
    var post = param.post, action = param.action, _state = param.state, isPlaying = _state.isPlaying, duration = _state.duration, currentTime = _state.currentTime;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref8.routerPages, generatePath = ref8.generatePath, router = ref8.router;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref9 = (0,core_i18n/* useTranslation */.$G)(), tcommon = ref9.t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPostVideos").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: generatePath(routerPages.PostVideoDetailModal, {
            postId: post === null || post === void 0 ? void 0 : post.id
        })
    });
    var onClickShare = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var title, url, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        title = post === null || post === void 0 ? void 0 : post.artist.displayName;
                        return [
                            4,
                            getShortLinkUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        return [
                            4,
                            share/* share */.B({
                                title: title !== null && title !== void 0 ? title : tcommon("metaTitle"),
                                text: (ref = post === null || post === void 0 ? void 0 : post.content) !== null && ref !== void 0 ? ref : tcommon("metaDescription"),
                                url: url,
                                dialogTitle: title !== null && title !== void 0 ? title : tcommon("metaTitle")
                            }).catch(function(e) {
                                return showError(e);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickShare() {
            return _ref.apply(this, arguments);
        };
    }();
    // NOTE アーティスト報告機能関連
    var ref10 = (0,react.useState)(false), openDrawer = ref10[0], setOpenDrawer = ref10[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpenDrawer(open);
        };
    }, []);
    var drawerActions = [
        {
            title: t("report"),
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!action.onReportArtist) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    action.onReportArtist()
                                ];
                            case 1:
                                _state.sent();
                                setOpenDrawer(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            divider: false
        },
        {
            title: t("block"),
            hidden: config_config/* config.applicationType */.v.applicationType === "standalone",
            onClick: function onClick() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!action.onBlockArtist) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    action.onBlockArtist()
                                ];
                            case 1:
                                _state.sent();
                                setOpenDrawer(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            divider: true
        },
        {
            title: t("cancel"),
            onClick: toggleDrawer(false),
            codivider: false,
            titleColor: "primary.main"
        }, 
    ];
    /**
   * @description
   * いいね機能を無効化しているか否か
   * 無効化している場合はいいね関連機能を非表示にする
   */ var disableLikes = (ref = post.artist.settings) === null || ref === void 0 ? void 0 : (ref1 = ref.features) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.post) === null || ref2 === void 0 ? void 0 : ref2.disableLikes;
    /**
   * @description
   * コメント機能を無効化しているか否か
   * 無効化している場合はコメント関連機能を非表示にする
   */ var disableReplies = (ref3 = post.artist.settings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.features) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.post) === null || ref5 === void 0 ? void 0 : ref5.disableReplies;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                sx: {
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    background: "linear-gradient(0deg, rgba(51, 51, 51, 0.85) 42%, rgba(0, 0, 0, 0.00) 100%)",
                    boxShadow: "none",
                    zIndex: zIndex.modal + 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            p: 0,
                            pr: "16px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 2
                            },
                            children: [
                                isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Pause, {
                                    onClick: action.pause,
                                    size: "large",
                                    color: "white"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.PlayFilled, {
                                    onClick: action.play,
                                    size: "large",
                                    color: "white"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body1",
                                    color: "white",
                                    sx: {
                                        whiteSpace: "nowrap"
                                    },
                                    children: [
                                        ShortVideoControl_secondToMmss(currentTime),
                                        " / ",
                                        ShortVideoControl_secondToMmss(duration)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                                    sx: {
                                        "& .MuiSlider-thumb": {
                                            width: 0,
                                            height: 0,
                                            "&:focus, &:hover, &.Mui-active": {
                                                boxShadow: "none"
                                            }
                                        },
                                        "& .MuiSlider-track": {
                                            color: "white",
                                            height: "5px"
                                        },
                                        "& .MuiSlider-rail": {
                                            color: "#4d4d4d",
                                            height: "5px"
                                        },
                                        "& .MuiSlider-active": {
                                            color: "none"
                                        }
                                    },
                                    value: currentTime,
                                    max: duration,
                                    onChange: function(_, value) {
                                        return action.seek(value);
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            width: "100%",
                            py: 2,
                            height: "46px"
                        },
                        avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: generatePath(routerPages.UserProfile, {
                                userId: post.artist.id
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: ((ref6 = post.artist.avatar) === null || ref6 === void 0 ? void 0 : ref6.smallUri) || undefined,
                                sx: {
                                    width: 28,
                                    height: 28,
                                    mr: -2,
                                    position: "relative",
                                    zIndex: 2,
                                    color: "white"
                                }
                            })
                        }),
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            underline: "none",
                            href: generatePath(routerPages.UserProfile, {
                                userId: post.artist.id
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    zIndex: 2,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 2,
                                    color: "white"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h5",
                                        color: "white",
                                        children: post.artist.displayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "white",
                                        children: post.formattedRelativePublishedAt
                                    }),
                                    (post === null || post === void 0 ? void 0 : post.category) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: {
                                            py: "2px",
                                            px: "4px",
                                            borderRadius: "2px",
                                            height: "16px",
                                            fontSize: "10px",
                                            color: "white",
                                            bgcolor: "primary.dark",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: post === null || post === void 0 ? void 0 : (ref7 = post.category) === null || ref7 === void 0 ? void 0 : ref7.name
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        }),
                        titleTypographyProps: {
                            sx: {
                                width: "fit-content"
                            }
                        },
                        action: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            sx: {
                                marginTop: "5px",
                                paddingRight: "8px"
                            },
                            children: [
                                post.isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.MembersOnly, {
                                    sx: {
                                        color: "primary.dark",
                                        margin: "6px"
                                    }
                                }),
                                (user === null || user === void 0 ? void 0 : user.uid) !== post.artist.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                    size: "small",
                                    onClick: toggleDrawer(true),
                                    color: "white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActions/* default */.Z, {
                        sx: {
                            py: 0,
                            height: "48px"
                        },
                        children: [
                            !disableLikes && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Like, {
                                        color: "white",
                                        liked: post.isLike,
                                        onClick: handleLoginModal(function(e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            action.onLike();
                                        }),
                                        sx: {
                                            mx: "12px",
                                            marginLeft: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        color: "white",
                                        children: post.likeCount
                                    })
                                ]
                            }),
                            !disableReplies && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        underline: "none",
                                        href: generatePath(routerPages.PostDetail, {
                                            postId: post.id
                                        }),
                                        onClick: function(event) {
                                            if (router.pathname === generatePath(routerPages.PostDetail, {
                                                postId: post.id
                                            })) {
                                                event.preventDefault();
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Reply, {
                                            sx: {
                                                mx: "12px"
                                            },
                                            color: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        underline: "none",
                                        href: generatePath(routerPages.PostDetail, {
                                            postId: post.id
                                        }),
                                        onClick: function(event) {
                                            if (router.pathname === generatePath(routerPages.PostDetail, {
                                                postId: post.id
                                            })) {
                                                event.preventDefault();
                                            }
                                        },
                                        style: {
                                            margin: 0,
                                            marginRight: "16px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            color: "white",
                                            children: post.replyCount
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Share, {
                                onClick: onClickShare,
                                color: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                        sx: {
                            pt: 0,
                            pb: "8px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            underline: "none",
                            href: generatePath(routerPages.PostDetail, {
                                postId: post.id
                            }),
                            onClick: function(event) {
                                if (router.pathname === generatePath(routerPages.PostDetail, {
                                    postId: post.id
                                })) {
                                    event.preventDefault();
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                color: "white",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                variant: "body1",
                                sx: {
                                    minHeight: "5vh",
                                    wordBreak: "break-all",
                                    "&": (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(2))
                                },
                                children: post.content
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                open: openDrawer,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: post.artist.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        children: (0,array/* filterHiddenItem */.s)(drawerActions).map(function(param, index) {
                            var title = param.title, onClick = param.onClick, divider = param.divider, titleColor = param.titleColor;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                divider: divider,
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52,
                                    justifyContent: "center"
                                },
                                onClick: handleLoginModal(onClick),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: titleColor,
                                    variant: "h6",
                                    children: title
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var ShortVideoControl_secondToMmss = function(second) {
    return "".concat(Math.floor(second / 60).toString().padStart(1, "0"), ":").concat(Math.floor(second % 60).toString().padStart(2, "0"));
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ShortVideoPlayer.tsx



function ShortVideoPlayer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  video {\n    object-fit: cover;\n  }\n"
    ]);
    ShortVideoPlayer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledReactPlayer = emotion_styled_browser_esm/* default.div */.Z.div(ShortVideoPlayer_templateObject());
var ShortVideoPlayer = function(param) {
    var post = param.post, videoRef = param.videoRef, playing = param.playing, muted = param.muted, action = param.action, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "600px" : _maxWidth;
    var ref, ref1;
    var ref2 = (0,react.useState)(0), currentTime = ref2[0], setCurrentTime = ref2[1];
    var ref3 = (0,react.useState)(0), duration = ref3[0], setDuration = ref3[1];
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReactPlayer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                onClick: action.togglePlay,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    style: {
                        maxWidth: maxWidth
                    }
                }, displayResponsive ? {
                    width: "100vw",
                    height: "auto"
                } : {
                    width: "100%",
                    height: "100dvh"
                }), {
                    url: (ref4 = (ref = post.resource) === null || ref === void 0 ? void 0 : ref.uri) !== null && ref4 !== void 0 ? ref4 : "",
                    ref: videoRef,
                    playing: playing,
                    progressInterval: 100,
                    onProgress: function(p) {
                        return setCurrentTime(p.playedSeconds);
                    },
                    onSeek: setCurrentTime,
                    onDuration: setDuration,
                    onError: function(e) {
                        // NOTE
                        // 上位コンポーネントでデフォルトでmuted=false（ミュートさせない）に設定している。
                        // モバイル環境では、muted=trueでないとautoplayに失敗し、errorイベントが発生する。
                        // そのうえでautoplayを成功させるため、エラー発生時にのみmuted=trueに設定し直すことでautoplayを成功させる。
                        if (e !== null) {
                            action.defaultMute();
                        }
                    },
                    playsinline: true,
                    loop: true,
                    muted: muted,
                    config: {
                        file: {
                            attributes: {
                                poster: ((ref1 = post.videoThumbnail) === null || ref1 === void 0 ? void 0 : ref1.uri) || "",
                                preload: "metadata"
                            }
                        }
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortVideoControl, {
                post: post,
                state: {
                    currentTime: currentTime,
                    duration: duration,
                    isPlaying: playing
                },
                action: action
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ShortVideoContent.tsx

















var ShortVideoContent = function(param) {
    var posts = param.posts, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, initialIndex = param.initialIndex, muted = param.muted, defaultMute = param.defaultMute, onFetchMore = param.onFetchMore, onLike = param.onLike, onReportArtist = param.onReportArtist, onBlockUser = param.onBlockUser, onClose = param.onClose, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "600px" : _maxWidth;
    var t = (0,core_i18n/* useTranslation */.$G)("artistPostVideos").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var ref1 = (0,core_i18n/* useTranslation */.$G)("membershipUserInfo"), tmembershipUserInfo = ref1.t;
    var showModal = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)().showModal;
    // NOTE 動画プレイヤー制御用のRef
    var videoRefs = (0,react.useRef)([]);
    posts.forEach(function(_, i) {
        videoRefs.current[i] = /*#__PURE__*/ (0,react.createRef)();
    });
    // NOTE 画面スクロール制御用のRef
    var wrapperRefs = (0,react.useRef)([]);
    posts.forEach(function(_, i) {
        wrapperRefs.current[i] = /*#__PURE__*/ (0,react.createRef)();
    });
    var scrollViewRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(initialIndex), playingVideoIndex = ref2[0], setPlayingVideoIndex = ref2[1];
    var ref3 = (0,react.useState)(initialIndex), showingVideoIndex = ref3[0], setShowingVideoIndex = ref3[1];
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    (0,react.useEffect)(function() {
        var scrollView = scrollViewRef.current;
        if (!scrollView) return;
        var observers = [];
        posts.forEach(function(_, i) {
            var wrapper = wrapperRefs.current[i].current;
            if (!wrapper) return;
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio === 1.0) {
                        posts.forEach(function(_, index) {
                            var v = videoRefs.current[index].current;
                            var w = wrapperRefs.current[index].current;
                            if (!w) return;
                            if (w === entry.target) {
                                setPlayingVideoIndex(index);
                                setShowingVideoIndex(index);
                                // 末尾まで残り少なくなったら次の分をロードする
                                // NOTE 4件前になったら追加ロード
                                if (index > posts.length - 4) {
                                    onFetchMore();
                                }
                            } else if (get_default()(v, "player.isReady", false)) {
                                // In some cases, the player is not ready, but the seekTo method is called, leading to errors.
                                // Therefore, it is necessary to check whether the player is ready
                                v === null || v === void 0 ? void 0 : v.seekTo(0);
                            }
                        });
                    }
                });
            };
            var options = {
                root: scrollView,
                threshold: 1
            };
            var observer = new IntersectionObserver(callback, options);
            observer.observe(wrapper);
            observers.push(observer);
        });
        return function() {
            observers.forEach(function(observer) {
                return observer.disconnect();
            });
        };
    }, [
        posts.length
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // NOTE サムネイルタップ時に初期位置をその動画までスクロールさせる（これがないと、どのサムネイルをタップしても一番先頭の動画が表示される）
        var wrapper = (ref = wrapperRefs.current[initialIndex]) === null || ref === void 0 ? void 0 : ref.current;
        if (!wrapper) return;
        wrapper.scrollIntoView();
    }, [
        initialIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollView, {
        ref: scrollViewRef,
        children: posts.map(function(post, idx) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: (0,src_object_spread/* default */.Z)({
                    width: "100%",
                    maxWidth: maxWidth,
                    height: "100dvh",
                    position: "relative",
                    scrollSnapStop: "always",
                    scrollSnapAlign: "start"
                }, displayResponsive ? {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                } : {}),
                ref: wrapperRefs.current[idx],
                children: [
                    post.isStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Limited24hTag, {
                        sx: {
                            position: "absolute",
                            top: "8px",
                            right: "8px"
                        }
                    }),
                    post.isAccessible ? post.isPremium && isMembershipPersonalInformationRequired && ((ref = post.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage_ThumbnailImage, {
                                src: ((ref2 = post.videoThumbnail) === null || ref2 === void 0 ? void 0 : ref2.blurUri) || "",
                                alt: "thumbnail",
                                withBorderRadius: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredMembershipRecommendBox, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    alignItems: "center",
                                    spacing: 3,
                                    pb: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                            sx: {
                                                color: "error.main",
                                                width: 40,
                                                height: 40
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: tmembershipUserInfo("noticeRegisterModalTitleV2")
                                        })
                                    ]
                                }),
                                content: tmembershipUserInfo("noticeRegisterModalDescV2"),
                                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    sx: {
                                        minWidth: 212
                                    },
                                    variant: "contained",
                                    color: "primary",
                                    size: "large",
                                    onClick: function() {
                                        return showModal();
                                    },
                                    children: tmembershipUserInfo("enterYourInfo", "入力する")
                                })
                            })
                        ]
                    }) : showingVideoIndex - 1 <= idx && idx <= showingVideoIndex + 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortVideoPlayer, {
                        post: post,
                        videoRef: videoRefs.current[idx],
                        playing: playingVideoIndex === idx,
                        muted: muted,
                        maxWidth: displayResponsive ? maxWidth : undefined,
                        action: {
                            play: function() {
                                setPlayingVideoIndex(idx);
                            },
                            pause: function() {
                                setPlayingVideoIndex("paused");
                            },
                            togglePlay: function() {
                                setPlayingVideoIndex(function(prev) {
                                    return prev === "paused" ? idx : "paused";
                                });
                            },
                            seek: function(time) {
                                var ref;
                                (ref = videoRefs.current[idx].current) === null || ref === void 0 ? void 0 : ref.seekTo(time);
                            },
                            defaultMute: defaultMute,
                            onLike: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onLike(post.id, post.isLike, post.likeCount)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            onReportArtist: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                var ref, ref1, ref2, ref3, ref4;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!onReportArtist) return [
                                                2
                                            ];
                                            return [
                                                4,
                                                onReportArtist((ref2 = post === null || post === void 0 ? void 0 : post.id) !== null && ref2 !== void 0 ? ref2 : "", (ref3 = post === null || post === void 0 ? void 0 : (ref = post.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "", (ref4 = post === null || post === void 0 ? void 0 : (ref1 = post.artist) === null || ref1 === void 0 ? void 0 : ref1.formattedAccountId) !== null && ref4 !== void 0 ? ref4 : "")
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            onBlockArtist: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                var ref;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onBlockUser((ref = post === null || post === void 0 ? void 0 : post.artistId) !== null && ref !== void 0 ? ref : "")
                                            ];
                                        case 1:
                                            _state.sent();
                                            showMessage(t("blockArtistSuccess"), "success");
                                            router.push(generatePath(routerPages.ArtistTop, {
                                                artistId: post === null || post === void 0 ? void 0 : post.artistId
                                            }));
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            onClose: onClose
                        }
                    }, post.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage_ThumbnailImage, {
                        src: ((ref3 = post.videoThumbnail) === null || ref3 === void 0 ? void 0 : ref3.uri) || "",
                        alt: "thumbnail",
                        withBorderRadius: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailImage_ThumbnailImage, {
                                src: ((ref4 = post.videoThumbnail) === null || ref4 === void 0 ? void 0 : ref4.blurUri) || "",
                                alt: "thumbnail",
                                withBorderRadius: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipRecommendBox, {
                                artistId: post.artistId,
                                membershipRecommendTitle: t("premiumRecommendTitle"),
                                membershipRecommendText: t("premiumRecommendText", {
                                    artistName: post.artist.displayName,
                                    membershipName: post.planId && ((ref5 = post.plan) === null || ref5 === void 0 ? void 0 : ref5.planTitle) ? (ref6 = post.plan) === null || ref6 === void 0 ? void 0 : ref6.planTitle : "プレミアムメンバー"
                                }),
                                recommendButtonText: t("premiumRecommendButton")
                            })
                        ]
                    })
                ]
            }, post.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ArtistPostVideos/template/ShortVideoModal.tsx






var ShortVideoModal = function(param) {
    var open = param.open, onClose = param.onClose, posts = param.posts, isMembershipPersonalInformationRequired = param.isMembershipPersonalInformationRequired, onFetchMore = param.onFetchMore, postIndex = param.postIndex, onReportArtist = param.onReportArtist, onBlockUser = param.onBlockUser, onLike = param.onLike, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    // NOTE Safariでオーディオトラック付きの動画のときにミュートでないと自動再生されない仕様のための対処
    var t = (0,core_i18n/* useTranslation */.$G)("artistPostVideos").t;
    var ref = (0,react.useState)(false), muted = ref[0], setMuted = ref[1];
    var maxWidth = responsive ? "100vw" : "600px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        onClose: onClose,
        disablePortal: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                width: "100%",
                // NOTE BaseLayoutの横幅指定に準拠
                maxWidth: maxWidth,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "black",
                outline: "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        position: "absolute",
                        width: "100%",
                        height: "64px",
                        p: "8px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                            size: "medium",
                            onClick: onClose,
                            color: "white",
                            sx: {
                                zIndex: zIndex.modal + 2,
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    width: "48px",
                                    height: "48px",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    borderRadius: "50%",
                                    transform: "translate(-50%, -50%)"
                                }
                            }
                        }),
                        muted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            size: "medium",
                            sx: {
                                zIndex: zIndex.modal + 2,
                                color: "white",
                                bgcolor: "rgba(0, 0, 0, 0.5)",
                                height: "100%",
                                fontSize: "1rem",
                                px: "16px",
                                py: "6px"
                            },
                            onClick: function() {
                                setMuted(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2
                                },
                                children: [
                                    t("unmute"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.AudioOff, {
                                        color: "white",
                                        sx: {
                                            height: "24px",
                                            width: "24px"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortVideoContent, {
                    initialIndex: postIndex,
                    posts: posts,
                    isMembershipPersonalInformationRequired: isMembershipPersonalInformationRequired,
                    defaultMute: function() {
                        return setMuted(true);
                    },
                    onFetchMore: onFetchMore,
                    onLike: onLike,
                    onReportArtist: onReportArtist,
                    onBlockUser: onBlockUser,
                    onClose: onClose,
                    muted: muted,
                    maxWidth: responsive ? maxWidth : undefined
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PostVideoDetailModal/template/index.tsx










var PostVideoDetailModalTemplate = function(_param) {
    var state = _param.state, actions = (0,_object_without_properties/* default */.Z)(_param, [
        "state"
    ]);
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PostVideoDetailModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostVideoDetailModalCell, (0,src_object_spread/* default */.Z)({
                    state: state
                }, actions))
            })
        ]
    });
};
var PostVideoDetailModalCell = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onLikePost = param.onLikePost, onReportArtist = param.onReportArtist, onBlockUser = param.onBlockUser, onClose = param.onClose;
    var ref;
    if (state.initialLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rounded",
            height: "90%",
            width: "90%"
        })
    });
    if (state.isInvalidPost) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortVideoModal, (0,src_object_spread/* default */.Z)({
        open: true,
        onClose: onClose,
        onFetchMore: onFetchMore,
        onLike: onLikePost,
        onReportArtist: onReportArtist,
        onBlockUser: onBlockUser,
        isMembershipPersonalInformationRequired: !!((ref = state.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired)
    }, state));
};

;// CONCATENATED MODULE: ./src/components/pages/PostVideoDetailModal/viewModel.ts




function PostVideoDetailModal_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VideoDetail($postId: ID!) {\n    post(id: $postId) {\n      ...PostBox\n    }\n  }\n  ",
        "\n"
    ]);
    PostVideoDetailModal_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostVideoDetailModal_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ArtistPostVideosToCurrentVideo(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceType: PostType\n    $storyFilter: StoryFilter\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      id\n      displayName\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceType: $resourceType\n        storyFilter: $storyFilter\n        categoryId: $categoryId\n      ) {\n        ...ArtistPostVideos\n      }\n      currentLive {\n        id\n      }\n    }\n    user {\n      ...CurrentUser\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    PostVideoDetailModal_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostVideoDetailModal_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query FetchNewArtistPostVideosToCurrentVideo(\n    $artistId: ID!\n    $pageInput: PageInputDate\n    $pageInputById: PageInput\n    $resourceType: PostType\n    $storyFilter: StoryFilter\n    $categoryId: String\n  ) {\n    artist(id: $artistId) {\n      id\n      posts(\n        pageInput: $pageInput\n        pageInputById: $pageInputById\n        resourceType: $resourceType\n        storyFilter: $storyFilter\n        categoryId: $categoryId\n      ) {\n        ...ArtistPosts\n      }\n      currentLive {\n        id\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    PostVideoDetailModal_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








/**
 *
 */ var PostVideoDetailModal_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,router_useRouter/* useRouter */.tv)(), router = ref8.router, routerPages = ref8.routerPages, generatePath = ref8.generatePath;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref9 = (0,useQuery/* useQuery */.aM)(POST_DETAIL, {
        variables: {
            postId: router.query.postId
        },
        returnPartialData: true
    }), postData = ref9.data, loadingPost = ref9.loading;
    var ref10, ref11;
    var artistId = (ref11 = (ref10 = postData === null || postData === void 0 ? void 0 : (ref = postData.post) === null || ref === void 0 ? void 0 : ref.artistId) !== null && ref10 !== void 0 ? ref10 : config_config/* config.artistId */.v.artistId) !== null && ref11 !== void 0 ? ref11 : "";
    var postId = router.query.postId;
    var ref12;
    var categoryId = (ref12 = postData === null || postData === void 0 ? void 0 : (ref1 = postData.post) === null || ref1 === void 0 ? void 0 : ref1.categoryId) !== null && ref12 !== void 0 ? ref12 : null;
    // NOTE posts/{postId}/videoへのアクセスであっても投稿タイプが動画でない場合にリダイレクトさせる
    (0,react.useEffect)(function() {
        var autoRedirect = function() {
            var ref, ref1, ref2, ref3;
            var isVideoPost = (postData === null || postData === void 0 ? void 0 : (ref = postData.post) === null || ref === void 0 ? void 0 : ref.resourceType) === utoniq_core_schema/* PostType.Video */.hQF.Video && !!(postData === null || postData === void 0 ? void 0 : (ref1 = postData.post) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resource) === null || ref2 === void 0 ? void 0 : ref2.uri);
            if (!(postData === null || postData === void 0 ? void 0 : (ref3 = postData.post) === null || ref3 === void 0 ? void 0 : ref3.id)) return;
            if (!isVideoPost) {
                var ref4;
                router.replace(generatePath(routerPages.PostDetail, {
                    postId: postData === null || postData === void 0 ? void 0 : (ref4 = postData.post) === null || ref4 === void 0 ? void 0 : ref4.id
                }));
            }
        };
        autoRedirect();
    }, [
        postData === null || postData === void 0 ? void 0 : postData.post
    ]);
    var resourceType = utoniq_core_schema/* PostType.Video */.hQF.Video;
    var isFirstLoadRef = useGetNewestData({
        query: FETCH_NEW_ARTIST_POST_VIDEOS_TO_CURRENT_VIDEO,
        variables: {
            artistId: artistId,
            resourceType: resourceType,
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            pageInput: {
                limit: 12
            },
            pageInputById: {
                limit: 12
            },
            categoryId: categoryId
        },
        identify: {
            __typename: "Artist",
            id: artistId
        },
        fields: [
            {
                fieldName: "posts",
                responsePath: "artist.posts",
                fragment: utoniq_core_schema/* PostBoxFragmentDoc */.cSz
            }, 
        ]
    }).isFirstLoadRef;
    var ref13 = (0,useQuery/* useQuery */.aM)(viewModel_ARTIST_POST_VIDEOS, {
        variables: {
            artistId: artistId,
            resourceType: resourceType,
            storyFilter: utoniq_core_schema/* StoryFilter.Include */.CkM.Include,
            pageInput: {
                limit: 12
            },
            pageInputById: {
                limit: 12
            },
            categoryId: categoryId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        },
        skip: !(postData === null || postData === void 0 ? void 0 : postData.post)
    }), data = ref13.data, fetchMore = ref13.fetchMore, networkStatus = ref13.networkStatus, loading = ref13.loading, refetch = ref13.refetch;
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : (ref2 = data.artist) === null || ref2 === void 0 ? void 0 : ref2.posts);
    var pageInfo = data === null || data === void 0 ? void 0 : (ref3 = data.artist) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.posts) === null || ref4 === void 0 ? void 0 : ref4.pageInfo;
    var fetchMorePosts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(pageInfo && pageInfo.hasNextPage)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchMore({
                                variables: {
                                    artistId: artistId,
                                    // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
                                    pageInput: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 10
                                    },
                                    pageInputById: {
                                        cursor: pageInfo.endCursor || null,
                                        limit: 10
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMorePosts() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikePost */.UEr), 1), likePost = ref14[0];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikePost */.UsN), 1), unlikePost = ref15[0];
    // アーティストブロック機能
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref16[0];
    // NOTE リクエストされたpostIdが現れるまでfetch moreし続ける
    (0,react.useEffect)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artist) === null || ref === void 0 ? void 0 : ref.posts.edges.some(function(edge) {
            return edge.node.id === postId;
        }))) {
            fetchMorePosts();
        }
    }, [
        data === null || data === void 0 ? void 0 : (ref5 = data.artist) === null || ref5 === void 0 ? void 0 : ref5.posts.edges.length
    ]);
    var nodes = (data === null || data === void 0 ? void 0 : (ref6 = data.artist) === null || ref6 === void 0 ? void 0 : ref6.posts.edges// NOTE YouTube動画は対象外とする
    .filter(function(param) {
        var node = param.node;
        var ref;
        return ((ref = node.resource) === null || ref === void 0 ? void 0 : ref.uri) !== null;
    }).map(function(param) {
        var node = param.node;
        return node;
    })) || [];
    var ref17;
    var postIndex = (ref17 = nodes.findIndex(function(node) {
        return node.id === postId;
    })) !== null && ref17 !== void 0 ? ref17 : undefined;
    var onClose = function() {
        router.goBack(generatePath(routerPages.PostDetail, {
            postId: postId
        }));
    };
    var ref18;
    return {
        state: {
            user: data === null || data === void 0 ? void 0 : data.user,
            isInvalidPost: !loadingPost && (postData === null || postData === void 0 ? void 0 : postData.post) === null,
            posts: nodes,
            // NOTE 初期表示時、postIdに一致するポストまで取得し続ける処理の完了しているかどうかを表現する
            initialLoading: ((ref18 = loadingPost !== null && loadingPost !== void 0 ? loadingPost : loading) !== null && ref18 !== void 0 ? ref18 : !isNextFetch) && postIndex === undefined,
            refetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
            artistName: (data === null || data === void 0 ? void 0 : (ref7 = data.artist) === null || ref7 === void 0 ? void 0 : ref7.displayName) || "",
            hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
            postIndex: postIndex
        },
        actions: {
            onFetchMore: fetchMorePosts,
            onLikePost: function onLikePost(postId, isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikePost({
                                        variables: {
                                            unlikePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var unlikePostPostId = param.unlikePostPostId;
                                            return {
                                                unlikePost: {
                                                    __typename: "Post",
                                                    id: unlikePostPostId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likePost({
                                        variables: {
                                            likePostPostId: postId
                                        },
                                        optimisticResponse: function(param) {
                                            var likePostPostId = param.likePostPostId;
                                            return {
                                                likePost: {
                                                    __typename: "Post",
                                                    id: likePostPostId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportArtist: function onReportArtist(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "post",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(id) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: id
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClose: onClose
        }
    };
});
var POST_DETAIL = (0,lib/* gql */.Ps)(PostVideoDetailModal_viewModel_templateObject(), utoniq_core_schema/* PostBoxFragmentDoc */.cSz);
var viewModel_ARTIST_POST_VIDEOS = (0,lib/* gql */.Ps)(PostVideoDetailModal_viewModel_templateObject1(), utoniq_core_schema/* ArtistPostVideosFragmentDoc */._FK, utoniq_core_schema/* CurrentUserFragmentDoc */.o0g);
var FETCH_NEW_ARTIST_POST_VIDEOS_TO_CURRENT_VIDEO = (0,lib/* gql */.Ps)(PostVideoDetailModal_viewModel_templateObject2(), utoniq_core_schema/* ArtistPostsFragmentDoc */.xCJ);

;// CONCATENATED MODULE: ./src/components/pages/PostVideoDetailModal/index.tsx




/**
 * PostVideoDetailModal Page
 * Implemented as a practical sample.
 */ var PostVideoDetailModal = function() {
    var ref = PostVideoDetailModal_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PostVideoDetailModalTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointCharge/template/index.tsx


















var PrepaidPointChargeTemplate = function(param) {
    var state = param.state, onClickCharge = param.onClickCharge, onFetchMore = param.onFetchMore;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerNames = ref2.routerNames, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var isWeb = (0,native_app/* getPlatform */.Xf)() === "web";
    var ref3 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref3.showMessage, showError = ref3.showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,react.useState)(null), purchasedPlan = ref4[0], setPurchasedPlan = ref4[1];
    /** 決済手段 */ var ref5 = (0,react.useState)(null), paymentMethod = ref5[0], setPaymentMethod = ref5[1];
    var ref6 = (0,react.useState)(false), openConfirmModal = ref6[0], setOpenConfirmModal = ref6[1];
    var ref7 = (0,react.useState)(false), openPaymentMethodSelectDrawer = ref7[0], setOpenPaymentMethodSelectDrawer = ref7[1];
    var ref8 = (0,react.useState)(false), openCompleteModal = ref8[0], setOpenCompleteModal = ref8[1];
    var ref9 = (0,react.useState)(false), openCompleteCarrierPaymentModal = ref9[0], setOpenCompleteCarrierPaymentModal = ref9[1];
    var ref10 = (0,react.useState)(false), openExpiredCardModal = ref10[0], setOpenExpiredCardModal = ref10[1];
    var ref11 = (0,react.useState)(false), openPaymentErrorModal = ref11[0], setOpenPaymentErrorModal = ref11[1];
    var ref12 = (0,react.useState)(false), openRequire3DSecureModal = ref12[0], setOpenRequire3DSecureModal = ref12[1];
    var handlePointClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(plan) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setPurchasedPlan(plan);
                if (isWeb) {
                    setOpenPaymentMethodSelectDrawer(true);
                } else {
                    // ネイティブの場合ポイントを含むデジタルアイテムの決済は
                    // IAP を経由して実行するため
                    // プラン選択後すぐに確認モーダルを表示する
                    setOpenConfirmModal(true);
                }
                return [
                    2
                ];
            });
        });
        return function handlePointClick(plan) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePointCharge = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(paymentMethod) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!purchasedPlan || isWeb && !paymentMethod) {
                    setOpenConfirmModal(false);
                    setOpenPaymentMethodSelectDrawer(false);
                    return [
                        2
                    ];
                }
                onClickCharge(purchasedPlan, paymentMethod, {
                    // 外部キャリア決済画面での処理が成功した場合のリダイレクト先
                    successUrl: "".concat(window.location.origin).concat(generatePath(routerPages.PrepaidPointCharge), "?point=").concat(purchasedPlan.points),
                    // 外部キャリア決済画面での処理がキャンセルされた場合のリダイレクト先
                    cancelUrl: "".concat(window.location.origin).concat(generatePath(routerPages.PrepaidPointCharge)),
                    // 外部キャリア決済画面での処理がエラーになった場合のリダイレクト先
                    errorUrl: "".concat(window.location.origin).concat(generatePath(routerPages.PrepaidPointCharge))
                }).then(function() {
                    // キャリア決済の場合は外部キャリア決済画面にて
                    // 追加手続きが必要なため完了モーダルを表示しない
                    if ((0,escott/* isCarrierPaymentMethod */.ln)(paymentMethod)) return;
                    setOpenConfirmModal(false);
                    setOpenPaymentMethodSelectDrawer(false);
                    setOpenCompleteModal(true);
                }).catch(function(e) {
                    var ref, ref1, ref2;
                    switch((ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                        /**
           * @description
           * 3Dセキュア認証が必要な場合
           */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                            setOpenConfirmModal(false);
                            setOpenPaymentMethodSelectDrawer(false);
                            setOpenRequire3DSecureModal(true);
                            break;
                        /**
           * @desciption
           * カードが有効期限切れの場合
           */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                            setOpenConfirmModal(false);
                            setOpenPaymentMethodSelectDrawer(false);
                            setOpenExpiredCardModal(true);
                            break;
                        /**
           * @description
           * 何かしらの決済エラーの場合
           */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                            setOpenConfirmModal(false);
                            setOpenPaymentMethodSelectDrawer(false);
                            setOpenPaymentErrorModal(true);
                            break;
                        default:
                            setOpenConfirmModal(false);
                            setOpenPaymentMethodSelectDrawer(false);
                            showError(e);
                            break;
                    }
                });
                return [
                    2
                ];
            });
        });
        return function handlePointCharge(paymentMethod) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClosePaymentMethodSelectDrawer = function() {
        if (purchasedPlan) {
            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
                productId: purchasedPlan.metadata.id,
                prepaidPointId: purchasedPlan.prepaidPointId,
                type: "bottomsheet",
                name: "purchasePoint"
            });
        }
        setOpenPaymentMethodSelectDrawer(false);
    };
    // 外部キャリア決済画面からのリダイレクトで戻ってきた際
    // トーストメッセージを表示する処理
    (0,react.useEffect)(function() {
        // キャリア決済画面からのリダイレクトで戻ってきたとき以外は何もしない
        // リダイレクト時にはクエリパラメータに status が含まれる
        if (!router.query.status) return;
        // ポイント残高が取得できていない場合は何もしない
        if (state.loading || state.point === null) return;
        switch(router.query.status){
            case "success":
                setOpenCompleteCarrierPaymentModal(true);
                break;
            case "cancel":
                showMessage(t("carrierCancel"));
                break;
            case "error":
                showError(t("carrierError"));
                break;
            default:
                break;
        }
    }, [
        state.loading,
        router.query.status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Wallet
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PrepaidPointCharge
            }),
            state.loading && state.point === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplaySkeletonCell, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PointDisplayCell, {
                point: state.point
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 4,
                sx: {
                    pt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    componentProps: {
                        sx: {
                            pt: 2,
                            pb: 2
                        },
                        spacing: 4
                    },
                    nodes: (ref = state.purchasablePrepaidPoints) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
                        var node = param.node;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(PointChargeCardCell, {
                            plan: node,
                            onClick: function() {
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_point", {
                                    productId: node.metadata.id,
                                    prepaidPointId: node.prepaidPointId,
                                    name: "prepaidPointCharge"
                                });
                                return handlePointClick(node);
                            }
                        }, index);
                    }),
                    onFetchMore: onFetchMore,
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    emptyMessage: t("emptyPurchasablePrepaidPoints"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        sx: {
                            pb: 4
                        },
                        children: Array.from(Array(6).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PointChargeCardSkeletonCell, {}, key);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformationLinksCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethodSelectDrawer, {
                open: openPaymentMethodSelectDrawer,
                onClose: handleClosePaymentMethodSelectDrawer,
                paymentSource: state.paymentSource,
                chargeLoading: state.chargeLoading,
                enablePointCarrierPayment: state.enablePointCarrierPayment,
                onSubmit: function(paymentMethod) {
                    setPaymentMethod(paymentMethod);
                    setOpenConfirmModal(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmPointChargeModal, {
                loading: state.chargeLoading,
                onConfirm: function() {
                    return handlePointCharge(paymentMethod);
                },
                open: openConfirmModal,
                onCancel: function() {
                    if (purchasedPlan) {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_cancel", {
                            productId: purchasedPlan.metadata.id,
                            prepaidPointId: purchasedPlan.prepaidPointId,
                            type: "modal",
                            name: "purchasePoint"
                        });
                    }
                },
                onClose: function() {
                    return setOpenConfirmModal(false);
                },
                point: purchasedPlan === null || purchasedPlan === void 0 ? void 0 : purchasedPlan.points,
                price: purchasedPlan === null || purchasedPlan === void 0 ? void 0 : purchasedPlan.price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletePointChargeModal, {
                open: openCompleteModal,
                onClose: function() {
                    return setOpenCompleteModal(false);
                },
                point: purchasedPlan === null || purchasedPlan === void 0 ? void 0 : purchasedPlan.points
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteCarrierPaymentModal, {
                open: openCompleteCarrierPaymentModal,
                onClose: function() {
                    return setOpenCompleteCarrierPaymentModal(false);
                },
                point: router.query.point
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: openExpiredCardModal,
                onClose: function() {
                    return setOpenExpiredCardModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: openPaymentErrorModal,
                onClose: function() {
                    return setOpenPaymentErrorModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: openRequire3DSecureModal,
                onClose: function() {
                    return setOpenRequire3DSecureModal(false);
                }
            })
        ]
    });
};
var template_PointDisplayCell = function(param) {
    var point = param.point;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                children: t("pointBalance")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                        fontSize: "large"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                        variant: "h1",
                        sx: {
                            ml: 2
                        },
                        children: point
                    })
                ]
            })
        ]
    });
};
var PointDisplaySkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 2,
        alignItems: "center",
        flex: 1,
        sx: {
            pt: 2,
            pb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 96,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: 96,
                height: 36
            })
        ]
    });
};
var PointChargeCardCell = function(param) {
    var plan = param.plan, onClick = param.onClick;
    var ref = plan || {}, points = ref.points, price = ref.price, description = ref.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    sx: {
                        px: 5,
                        py: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                            fontSize: "medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                            variant: "h5",
                            sx: {
                                ml: 2
                            },
                            children: points
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                            variant: "overline",
                            color: "primary.main",
                            sx: {
                                ml: 2
                            },
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.EmphasizedNumber, {
                            variant: "h5",
                            sx: {
                                ml: "auto"
                            },
                            children: [
                                "\xa5",
                                price
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var ConfirmPointChargeModal = function(param) {
    var loading = param.loading, open = param.open, onClose = param.onClose, onCancel = param.onCancel, onConfirm = param.onConfirm, point = param.point, price = param.price;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: function() {
            onCancel();
            onClose();
        },
        title: t("confirmCharge"),
        content: t("confirmChargeDescription", {
            point: point,
            price: price
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        minWidth: 212
                    },
                    variant: "contained",
                    color: "primary",
                    size: "large",
                    onClick: onConfirm,
                    loading: loading,
                    children: t("toBuy")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        minWidth: 212
                    },
                    variant: "text",
                    color: "primary",
                    onClick: onClose,
                    disabled: loading,
                    children: t("cancel")
                })
            ]
        })
    });
};
var CompletePointChargeModal = function(param) {
    var open = param.open, point = param.point, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("completeCharge"),
        content: t("completeChargeDescription", {
            point: point
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: "OK"
        })
    });
};
var CompleteCarrierPaymentModal = function(param) {
    var open = param.open, point = param.point, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("completeCharge"),
        content: t("completeChargeDescription", {
            point: point
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: "OK"
        })
    });
};
var PointChargeCardSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
        variant: "rectangular",
        width: "100%",
        height: 56,
        sx: {
            borderRadius: "2px"
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointCharge/index.tsx




var PrepaidPointCharge = function() {
    var ref = PrepaidPointCharge_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrepaidPointChargeTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/walletHistory/WalletHistoryItem/index.tsx






var TransactionType;
(function(TransactionType) {
    TransactionType["GetCharge"] = "get:charge";
    TransactionType["ConsumePurchase"] = "consume:purchase";
    TransactionType["ConsumeGacha"] = "consume:gacha";
    TransactionType["LoginBonus"] = "get:login";
    TransactionType["ConsumeTip"] = "consume:tip";
    TransactionType["MissionClear"] = "get:missionReward";
    TransactionType["TransferGachaTIcket"] = "get:transferGachaTicket";
})(TransactionType || (TransactionType = {}));
var WalletHistoryItem = function(param) {
    var _transaction = param.transaction, formattedCreatedAt = _transaction.formattedCreatedAt, type = _transaction.type, formattedTransactionPrepaidPoint = _transaction.formattedTransactionPrepaidPoint, description = _transaction.description;
    var t = (0,core_i18n/* useTranslation */.$G)("walletHistory").t;
    var ref = (0,react.useMemo)(function() {
        switch(type){
            case TransactionType.GetCharge:
                return {
                    title: t("pointCharge"),
                    subTitle: formattedCreatedAt
                };
            case TransactionType.ConsumePurchase:
                return {
                    title: t("itemPurchase"),
                    subTitle: formattedCreatedAt
                };
            case TransactionType.ConsumeGacha:
                return {
                    title: t("gachaDraw"),
                    subTitle: formattedCreatedAt
                };
            case TransactionType.LoginBonus:
                return {
                    title: t("loginBonus"),
                    subTitle: formattedCreatedAt
                };
            case TransactionType.ConsumeTip:
                return {
                    title: t("tip"),
                    subTitle: formattedCreatedAt
                };
            case TransactionType.MissionClear:
                return {
                    title: t("missionClear"),
                    subTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            minWidth: 0,
                            mr: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: formattedCreatedAt
                            })
                        ]
                    })
                };
            case TransactionType.TransferGachaTIcket:
                return {
                    title: t("transferGachaTicket"),
                    subTitle: formattedCreatedAt
                };
            default:
                return {
                    title: "",
                    subTitle: formattedCreatedAt
                };
        }
    }, [
        t,
        type,
        formattedCreatedAt,
        description
    ]), title = ref.title, subTitle = ref.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                disableTouchRipple: true,
                component: Box_Box/* default */.Z,
                sx: {
                    px: 5,
                    py: 5,
                    height: "auto",
                    cursor: "initial",
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                },
                title: title,
                subTitle: subTitle,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletHistoryItemIcon, {
                    type: type
                }),
                primaryTypographyProps: {
                    variant: "h6"
                },
                secondaryTypographyProps: {
                    variant: "overline",
                    color: "text.hint"
                },
                secondaryAction: parseFloat(formattedTransactionPrepaidPoint.replace(/,/gi, "")) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                    variant: "h5",
                    color: "primary.main",
                    children: formattedTransactionPrepaidPoint
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                    variant: "h5",
                    color: "text.secondary",
                    children: formattedTransactionPrepaidPoint
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    width: "calc(100% - 40px)",
                    ml: 5
                }
            })
        ]
    });
};
var WalletHistoryItemIcon = function(param) {
    var type = param.type;
    switch(type){
        case TransactionType.ConsumePurchase:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.OwnedItems, {
                fontSize: "large"
            });
        case TransactionType.ConsumeTip:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Tip, {
                fontSize: "large"
            });
        case TransactionType.ConsumeGacha:
        case TransactionType.GetCharge:
        case TransactionType.LoginBonus:
        case TransactionType.MissionClear:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                fontSize: "large"
            });
        case TransactionType.TransferGachaTIcket:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.TicketToPoint, {
                fontSize: "large"
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointOrders/template/index.tsx







var PrepaidPointOrdersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("prepaidPointOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: routerPages.Wallet,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PointOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref = state.prepaidPointTransactions) === null || ref === void 0 ? void 0 : ref.edges.map(function(transaction, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletHistoryItem, {
                        transaction: transaction.node
                    }, index);
                }),
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                component: List_List/* default */.Z,
                emptyMessage: t("prepaidPointEmptyMessage")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointOrders/viewModel.ts



function PrepaidPointOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PrepaidPointOrders($pageInput: PageInput) {\n    prepaidPointTransactions(pageInput: $pageInput) {\n      edges {\n        node {\n          ...PrepaidPointBox\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    PrepaidPointOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PrepaidPointOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,useQuery/* useQuery */.aM)(PrepaidPointOrders_viewModel_QUERY), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.prepaidPointTransactions) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            prepaidPointTransactions: (ref2 = data === null || data === void 0 ? void 0 : data.prepaidPointTransactions) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.prepaidPointTransactions) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PrepaidPointOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(PrepaidPointOrders_viewModel_templateObject(), utoniq_core_schema/* PrepaidPointBoxFragmentDoc */.UVG);

;// CONCATENATED MODULE: ./src/components/pages/PrepaidPointOrders/index.tsx



var PrepaidPointOrders = function() {
    var ref = PrepaidPointOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrepaidPointOrdersTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PrivacySettings/template/index.tsx







var PrivacySettingsTemplate = function(param) {
    var state = param.state, onChange = param.onChange;
    var t = (0,core_i18n/* useTranslation */.$G)("privacySettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PrivacySettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.Setting,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            divider: true,
                            sx: {
                                bgcolor: "grey.50"
                            },
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                checked: state.checked,
                                onChange: onChange
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body1",
                                            children: t("hiddenOwnedItems")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                                            size: "small",
                                            onClick: function() {
                                                return setOpen(true);
                                            }
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: open,
                        onClose: function() {
                            return setOpen(false);
                        },
                        title: t("hiddenOwnedItemsTitle"),
                        content: t("hiddenOwnedItemsDesc"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: t("ok")
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PrivacySettings/viewModel.ts




function PrivacySettings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PrivacySettings {\n    user {\n      id\n      settings {\n        privacy {\n          item\n        }\n      }\n    }\n  }\n"
    ]);
    PrivacySettings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrivacySettings_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateUserPrivacySettings($inputs: UserPrivacySettingsInput!) {\n    updateUserPrivacySettings(inputs: $inputs) {\n      id\n      settings {\n        privacy {\n          item\n        }\n      }\n    }\n  }\n"
    ]);
    PrivacySettings_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PrivacySettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var data = (0,useQuery/* useQuery */.aM)(PrivacySettings_viewModel_QUERY).data;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_USER_PRIVACY_SETTINGS), 1), updateUserPrivacySettings = ref3[0];
    return {
        state: {
            checked: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.privacy) === null || ref2 === void 0 ? void 0 : ref2.item)
        },
        actions: {
            onChange: function onChange() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserPrivacySettings({
                                        variables: {
                                            inputs: {
                                                type: utoniq_core_schema/* PrivacySettingsType.Item */.qMu.Item,
                                                flag: !(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.privacy) === null || ref2 === void 0 ? void 0 : ref2.item)
                                            }
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            var ref, ref1, ref2, ref3;
                                            var ref4;
                                            return {
                                                updateUserPrivacySettings: {
                                                    id: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref4 !== void 0 ? ref4 : "",
                                                    settings: {
                                                        privacy: {
                                                            item: !(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.settings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.privacy) === null || ref3 === void 0 ? void 0 : ref3.item),
                                                            __typename: "PrivacySettings"
                                                        },
                                                        __typename: "UserSettings"
                                                    },
                                                    __typename: "User"
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var PrivacySettings_viewModel_QUERY = (0,lib/* gql */.Ps)(PrivacySettings_viewModel_templateObject());
var UPDATE_USER_PRIVACY_SETTINGS = (0,lib/* gql */.Ps)(PrivacySettings_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/PrivacySettings/index.tsx




/**
 * PrivacySettings Page
 * Implemented as a practical sample.
 */ var PrivacySettings = function() {
    var ref = PrivacySettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacySettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ProfileInputArtist/template/ProfileInputArtistForm.tsx










var ProfileInputArtistForm_schema = function(o) {
    return {
        avatarPath: o.string().optional().allow("", null).label((0,core_form/* tLabel */.TQ)("profileInputArtist.avatarPathTitle")),
        displayName: o.string().max(50).optional().allow("").label((0,core_form/* tLabel */.TQ)("profileInputArtist.displayName")),
        accountId: o.string().pattern(new RegExp(/^[a-zA-Z0-9_]*$/)).max(20).optional().allow("").label((0,core_form/* tLabel */.TQ)("profileInputArtist.accountId")),
        invitationCode: o.string().length(8).optional().allow("").label((0,core_form/* tLabel */.TQ)("profileInputArtist.invitationCode"))
    };
};
var ProfileInputArtistForm = function(param) {
    var hiddenDisplayName = param.hiddenDisplayName, hiddenAccountId = param.hiddenAccountId, hiddenInviteCode = param.hiddenInviteCode, onSubmit = param.onSubmit, onClickAvatar = param.onClickAvatar;
    var t = (0,core_i18n/* useTranslation */.$G)("profileInputArtist").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,core_form/* useForm */.cI)({
        schema: ProfileInputArtistForm_schema,
        defaultValues: {
            avatarPath: "",
            displayName: "",
            accountId: "",
            invitationCode: ""
        }
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, setValue = ref.setValue, setError = ref.setError;
    var handleOnClick = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var result, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onClickAvatar()
                    ];
                case 1:
                    result = _state.sent();
                    if (!result) {
                        return [
                            2
                        ];
                    }
                    setValue("avatarPath", (ref = result === null || result === void 0 ? void 0 : result.tmpPath) !== null && ref !== void 0 ? ref : null, {
                        shouldValidate: true
                    });
                    return [
                        2,
                        result
                    ];
            }
        });
    }), [
        onClickAvatar,
        setValue
    ]);
    var handleOnSubmit = handleSubmit(function(values) {
        return onSubmit(values).catch(function(e) {
            return (0,core_form/* handleError */.S3)(e, setError, showError);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        sx: {
            pb: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleOnSubmit,
            sx: {
                pt: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm_AvatarUploadCell, (0,src_object_spread/* default */.Z)({
                    onClick: handleOnClick,
                    sx: {
                        pt: 5,
                        pb: 2
                    },
                    avatarProps: {
                        sx: {
                            width: 146,
                            height: 146
                        }
                    },
                    titleProps: {
                        color: "primary.main",
                        sx: {
                            pt: 3
                        },
                        variant: "subtitle1"
                    },
                    type: "image",
                    error: errors === null || errors === void 0 ? void 0 : errors.avatarPath
                }, register("avatarPath"))),
                !hiddenDisplayName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: errors === null || errors === void 0 ? void 0 : errors.displayName
                }, register("displayName"))),
                !hiddenAccountId && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "accountId",
                    error: errors === null || errors === void 0 ? void 0 : errors.accountId
                }, register("accountId"))),
                !hiddenInviteCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    error: errors === null || errors === void 0 ? void 0 : errors.invitationCode,
                    type: "number",
                    titleProps: {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("invitationCode")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: [
                                        "(",
                                        t("invitationCodeNote"),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }
                }, register("invitationCode"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm_ButtonCell, {
                    loading: isSubmitting
                })
            ]
        })
    });
};
var ProfileInputArtistForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("profileInputArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var ProfileInputArtistForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("profileInputArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var ProfileInputArtistForm_AvatarUploadCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("profileInputArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pb: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AvatarUploadField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});

;// CONCATENATED MODULE: ./src/components/pages/ProfileInputArtist/template/index.tsx







var ProfileInputArtistTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onClickAvatar = param.onClickAvatar;
    var t = (0,core_i18n/* useTranslation */.$G)("profileInputArtist").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, routerNames = ref.routerNames, router = ref.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ProfileInputArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        color: "primary",
                        sx: {
                            whiteSpace: "nowrap",
                            ml: -6
                        },
                        onClick: function() {
                            (0,storage/* getRedirectAfterLoginPath */.CT)().then(function(loginPath) {
                                router.push(loginPath.value || routerPages.ConsoleDashboard);
                            });
                        },
                        children: t("skip")
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistForm, {
                    hiddenDisplayName: state.hiddenDisplayName,
                    hiddenAccountId: state.hiddenAccountId,
                    hiddenInviteCode: state.hiddenInviteCode,
                    onSubmit: onSubmit,
                    onClickAvatar: onClickAvatar
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ProfileInputArtist/viewModel.ts












var ProfileInputArtist_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,auth/* useAuth */.aC)(), getUserClaims = ref.getUserClaims, reloadUser = ref.reloadUser;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router;
    var ref2 = (0,react.useState)(false), hiddenDisplayName = ref2[0], setHiddenDisplayName = ref2[1];
    var ref3 = (0,react.useState)(false), hiddenAccountId = ref3[0], setHiddenAccountId = ref3[1];
    var ref4 = (0,react.useState)(false), hiddenInviteCode = ref4[0], setHiddenInvitationCode = ref4[1];
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var getImage = camera/* getImage */.g;
    var ref5;
    var upload = (0,useTmpUploader/* useUserTmpUploader */.x)((ref5 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref5 !== void 0 ? ref5 : "").upload;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* ArtistUpdateArtistProfile */.iNS), 1), artistUpdateArtistProfile = ref6[0];
    (0,react.useEffect)(function() {
        (0,storage/* getInputSignUpArtist */.AD)().then(function(param) {
            var displayName = param.displayName, accountId = param.accountId, invitationCode = param.invitationCode;
            setHiddenDisplayName(!!displayName);
            setHiddenAccountId(!!accountId);
            setHiddenInvitationCode(!!invitationCode);
        });
    }, []);
    return {
        state: {
            hiddenDisplayName: hiddenDisplayName,
            hiddenAccountId: hiddenAccountId,
            /**
       * @todo
       * アーティスト登録SNS認証導入時に整理
       */ hiddenInviteCode: true
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var _avatarPath = param.avatarPath, avatarPath = _avatarPath === void 0 ? "" : _avatarPath, displayNameInput = param.displayName, accountIdInput = param.accountId;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, displayName, accountId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* getInputSignUpArtist */.AD)()
                                ];
                            case 1:
                                ref = _state.sent(), displayName = ref.displayName, accountId = ref.accountId;
                                return [
                                    4,
                                    artistUpdateArtistProfile({
                                        variables: {
                                            inputs: {
                                                displayName: displayName !== null && displayName !== void 0 ? displayName : displayNameInput,
                                                accountId: accountId !== null && accountId !== void 0 ? accountId : accountIdInput,
                                                introduction: "",
                                                avatarPath: avatarPath
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                // re-fetch user from auth
                                return [
                                    4,
                                    reloadUser()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* removeInputSignUpArtist */.Jc)()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    getUserClaims().then(function(userClaims) {
                                        (0,storage/* getRedirectAfterLoginPath */.CT)().then(function(loginPath) {
                                            var ref, ref1;
                                            if (userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist) {
                                                router.replace(loginPath.value || routerPages.ConsoleDashboard);
                                            }
                                        });
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickAvatar: function onClickAvatar() {
                return getImage(config_config/* config.upload.mimeTypes.image */.v.upload.mimeTypes.image).then(function(file) {
                    if (file.size > config_config/* config.upload.limit.image */.v.upload.limit.image) {
                        throw new Error("uploadErrorMaximumSize");
                    }
                    return upload(file);
                }).catch(function(error) {
                    if (error.message === "uploadErrorMaximumSize") {
                        showError(new Error(t("uploadErrorMaximumSize")));
                        return;
                    }
                    if (error.message === "uploadErrorImageOnly") {
                        showError(new Error(t("uploadErrorImageOnly")));
                        return;
                    }
                    showError(error);
                    return;
                });
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ProfileInputArtist/index.tsx




/**
 * ProfileInputArtist Page
 * Implemented as a practical sample.
 */ var ProfileInputArtist = function() {
    var ref = ProfileInputArtist_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileInputArtistTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/PushNotificationSettings/template/index.tsx








var PushNotificationSettingsTemplate = function(param) {
    var state = param.state, onToggle = param.onToggle, onArtistToggle = param.onArtistToggle;
    var t = (0,core_i18n/* useTranslation */.$G)("pushNotificationSettings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    var list = (0,react.useMemo)(function() {
        return [
            {
                label: t("postLabel"),
                hidden: false,
                items: [
                    {
                        label: t("newPost"),
                        checked: state.newPost,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.PostNewPost */.tbb.PostNewPost,
                                flag: !state.newPost
                            });
                        }
                    },
                    {
                        label: t("replyComment"),
                        checked: state.replyPost,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.PostReplyPost */.tbb.PostReplyPost,
                                flag: !state.replyPost
                            });
                        }
                    },
                    {
                        label: t("artistReplyPost"),
                        hidden: !state.isArtist,
                        checked: state.artistReplyPost,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Push */.qAq.Push,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.PostReplyPost */.rzv.PostReplyPost,
                                flag: !state.artistReplyPost
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("missionLabel"),
                hidden: false,
                items: [
                    {
                        label: t("replyCommentMission"),
                        checked: state.replyCommentMission,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.MissionReplyCommentMission */.tbb.MissionReplyCommentMission,
                                flag: !state.replyCommentMission
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("campaignLabel"),
                hidden: !config_config/* config.modules.campaign */.v.modules.campaign,
                items: [
                    {
                        label: t("newCampaign"),
                        checked: state.startCampaign,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.CampaignStartCampaign */.tbb.CampaignStartCampaign,
                                flag: !state.startCampaign
                            });
                        }
                    },
                    {
                        label: t("endCampaign"),
                        checked: state.endCampaign,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.CampaignEndCampaign */.tbb.CampaignEndCampaign,
                                flag: !state.endCampaign
                            });
                        }
                    }, 
                ]
            },
            /**
       * @description
       * Open when function is implemented in the future
       */ // {
            //   label: t('campaignLabel'),
            //   hidden: !config.modules.campaign,
            //   items: [
            //     {
            //       label: t('newCampaign'),
            //       checked: state.newCampaign,
            //       onChange() {},
            //     },
            //   ],
            // },
            {
                label: t("threadLabel"),
                hidden: !config_config/* config.modules.thread */.v.modules.thread,
                items: [
                    {
                        label: t("commentCreationThread"),
                        checked: state.commentThread,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.ThreadChannelCommentThread */.tbb.ThreadChannelCommentThread,
                                flag: !state.commentThread
                            });
                        }
                    },
                    {
                        label: t("replyCommentThread"),
                        checked: state.replyCommentThread,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.ThreadChannelReplyCommentThread */.tbb.ThreadChannelReplyCommentThread,
                                flag: !state.replyCommentThread
                            });
                        }
                    },
                    {
                        label: t("newThread"),
                        hidden: !state.isArtist,
                        checked: state.artistNewThread,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Push */.qAq.Push,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.ArtistThreadChannelNewThread */.rzv.ArtistThreadChannelNewThread,
                                flag: !state.artistNewThread
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("gachaLabel"),
                hidden: !config_config/* config.modules.gacha */.v.modules.gacha,
                items: [
                    {
                        label: t("announce"),
                        checked: state.gachaUpcomingExpiry,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.GachaUpcomingExpiry */.tbb.GachaUpcomingExpiry,
                                flag: !state.gachaUpcomingExpiry
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("tradeLabel"),
                hidden: !config_config/* config.modules.trade */.v.modules.trade,
                items: [
                    {
                        label: t("receiveTrade"),
                        checked: state.requestTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeRequestTrade */.tbb.TradeRequestTrade,
                                flag: !state.requestTrade
                            });
                        }
                    },
                    {
                        label: t("commentTrade"),
                        checked: state.commentTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeCommentTrade */.tbb.TradeCommentTrade,
                                flag: !state.commentTrade
                            });
                        }
                    },
                    /**
           * @description
           * Open when function is implemented in the future
           */ // {
                    //   label: t('resultTrade'),
                    //   checked: state.resultTrade,
                    //   onChange() {},
                    // },
                    /**
           * @deprecated it'll remove in the future
           */ {
                        label: t("agreedTrade"),
                        checked: state.agreedTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeAgreedTrade */.tbb.TradeAgreedTrade,
                                flag: !state.agreedTrade
                            });
                        }
                    },
                    /**
           * @deprecated it'll remove in the future
           */ {
                        label: t("declinedTrade"),
                        checked: state.declinedTrade,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.TradeDeclinedTrade */.tbb.TradeDeclinedTrade,
                                flag: !state.declinedTrade
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("membershipLabel"),
                hidden: !state.isArtist,
                items: [
                    {
                        label: t("membership"),
                        checked: state.artistMembershipSubscribe,
                        onChange: function onChange() {
                            return onArtistToggle({
                                channel: utoniq_core_schema/* ArtistNotificationChannelsType.Push */.qAq.Push,
                                type: utoniq_core_schema/* ArtistNotificationSettingsType.MembershipSubscribe */.rzv.MembershipSubscribe,
                                flag: !state.artistMembershipSubscribe
                            });
                        }
                    }, 
                ]
            },
            {
                label: t("announce"),
                items: [
                    {
                        label: t("announcementOfficial"),
                        checked: state.announcementOfficial,
                        onChange: function onChange() {
                            return onToggle({
                                channel: utoniq_core_schema/* NotificationChannelsType.Push */.yv_.Push,
                                type: utoniq_core_schema/* NotificationSettingsType.AnnouncementOfficial */.tbb.AnnouncementOfficial,
                                flag: !state.announcementOfficial
                            });
                        }
                    }, 
                ]
            }, 
        ];
    }, [
        onArtistToggle,
        onToggle,
        state.agreedTrade,
        state.artistMembershipSubscribe,
        state.artistNewThread,
        state.artistReplyPost,
        state.commentTrade,
        state.declinedTrade,
        state.endCampaign,
        state.isArtist,
        state.newMission,
        state.newPost,
        state.replyPost,
        state.requestTrade,
        state.startCampaign,
        state.startLiveStream,
        state.announcementOfficial,
        state.replyCommentMission,
        state.commentThread,
        state.replyCommentThread,
        t, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true,
            defaultBackPage: routerPages.Setting
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.PushNotificationSettings
            }),
            list.map(function(param, index) {
                var label = param.label, hidden = param.hidden, items = param.items;
                return !hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    sx: {
                        bgcolor: "grey.50"
                    },
                    subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
                        sx: {
                            pb: 2,
                            pt: 4,
                            px: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            color: "text.hint",
                            children: label
                        })
                    }),
                    children: items.map(function(item, itemIndex) {
                        return !item.hidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            divider: true,
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                                checked: item.checked,
                                onChange: item.onChange
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                primary: item.label,
                                slotProps: {
                                    primary: {
                                        variant: "body1"
                                    }
                                }
                            })
                        }, "".concat(index, "-").concat(itemIndex));
                    })
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/PushNotificationSettings/viewModel.ts











var PushNotificationSettings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
    var userClaims = (0,auth/* useCurrentUser */.xJ)().userClaims;
    var isArtist = !!(userClaims === null || userClaims === void 0 ? void 0 : (ref = userClaims.orgs) === null || ref === void 0 ? void 0 : (ref1 = ref[config_config/* config.organizationId */.v.organizationId]) === null || ref1 === void 0 ? void 0 : ref1.artist);
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var data = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* EmailNotificationSettings */.Mey).data;
    var ref42 = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* ArtistNotificationSettings */.VOh, {
        skip: !isArtist
    }), artistData = ref42.data;
    var ref43 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserNotificationSettings */.v7$), 1), updateUserNotificationSettings = ref43[0];
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateArtistNotificationSettings */.n4i), 1), updateArtistNotificationSettings = ref44[0];
    var notifications = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.settings) === null || ref3 === void 0 ? void 0 : ref3.notifications;
    var artistNotifications = artistData === null || artistData === void 0 ? void 0 : (ref4 = artistData.artist) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.settings) === null || ref5 === void 0 ? void 0 : ref5.notifications;
    return {
        state: {
            isArtist: isArtist,
            newPost: !!(notifications === null || notifications === void 0 ? void 0 : (ref6 = notifications.post) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.newPost) === null || ref7 === void 0 ? void 0 : ref7.push),
            replyPost: !!(notifications === null || notifications === void 0 ? void 0 : (ref8 = notifications.post) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.replyPost) === null || ref9 === void 0 ? void 0 : ref9.push),
            newMission: !!(notifications === null || notifications === void 0 ? void 0 : (ref10 = notifications.mission) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.newMission) === null || ref11 === void 0 ? void 0 : ref11.push),
            replyCommentMission: !!(notifications === null || notifications === void 0 ? void 0 : (ref12 = notifications.mission) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.replyCommentMission) === null || ref13 === void 0 ? void 0 : ref13.push),
            requestTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref14 = notifications.trade) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.requestTrade) === null || ref15 === void 0 ? void 0 : ref15.push),
            commentTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref16 = notifications.trade) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.commentTrade) === null || ref17 === void 0 ? void 0 : ref17.push),
            agreedTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref18 = notifications.trade) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.agreedTrade) === null || ref19 === void 0 ? void 0 : ref19.push),
            declinedTrade: !!(notifications === null || notifications === void 0 ? void 0 : (ref20 = notifications.trade) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.declinedTrade) === null || ref21 === void 0 ? void 0 : ref21.push),
            startCampaign: !!(notifications === null || notifications === void 0 ? void 0 : (ref22 = notifications.campaign) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.startCampaign) === null || ref23 === void 0 ? void 0 : ref23.push),
            endCampaign: !!(notifications === null || notifications === void 0 ? void 0 : (ref24 = notifications.campaign) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.endCampaign) === null || ref25 === void 0 ? void 0 : ref25.push),
            startLiveStream: !!(notifications === null || notifications === void 0 ? void 0 : (ref26 = notifications.liveStream) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.startLiveStream) === null || ref27 === void 0 ? void 0 : ref27.push),
            artistReplyPost: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref28 = artistNotifications.post) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.replyPost) === null || ref29 === void 0 ? void 0 : ref29.push),
            artistNewThread: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref30 = artistNotifications.artistThreadChannel) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.newThread) === null || ref31 === void 0 ? void 0 : ref31.push),
            artistMembershipSubscribe: !!(artistNotifications === null || artistNotifications === void 0 ? void 0 : (ref32 = artistNotifications.membership) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.subscribe) === null || ref33 === void 0 ? void 0 : ref33.push),
            announcementOfficial: !!(notifications === null || notifications === void 0 ? void 0 : (ref34 = notifications.announcement) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.official) === null || ref35 === void 0 ? void 0 : ref35.push),
            commentThread: !!(notifications === null || notifications === void 0 ? void 0 : (ref36 = notifications.threadChannel) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.commentThread) === null || ref37 === void 0 ? void 0 : ref37.push),
            replyCommentThread: !!(notifications === null || notifications === void 0 ? void 0 : (ref38 = notifications.threadChannel) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.replyCommentThread) === null || ref39 === void 0 ? void 0 : ref39.push),
            gachaUpcomingExpiry: !!(notifications === null || notifications === void 0 ? void 0 : (ref40 = notifications.gacha) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.upcomingExpiry) === null || ref41 === void 0 ? void 0 : ref41.push)
        },
        actions: {
            onToggle: function onToggle(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserNotificationSettings({
                                        variables: {
                                            updateUserNotificationSettingsInputs: value
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            var ref;
                                            var ref1;
                                            var updateUserNotificationSettings = {
                                                id: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "",
                                                settings: {
                                                    notifications: cloneDeep_default()(notifications),
                                                    __typename: "UserSettings"
                                                },
                                                __typename: "User"
                                            };
                                            var ref2 = (0,_sliced_to_array/* default */.Z)(value.type.split("_"), 2), type = ref2[0], subType = ref2[1];
                                            set_default()(updateUserNotificationSettings, "settings.notifications.".concat(type, ".").concat(subType, ".").concat(value.channel), value.flag);
                                            return {
                                                updateUserNotificationSettings: updateUserNotificationSettings
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onArtistToggle: function onArtistToggle(value) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateArtistNotificationSettings({
                                        variables: {
                                            inputs: value
                                        },
                                        optimisticResponse: function optimisticResponse() {
                                            var ref;
                                            var ref1;
                                            var updateArtistNotificationSettings = {
                                                id: (ref1 = artistData === null || artistData === void 0 ? void 0 : (ref = artistData.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "",
                                                settings: {
                                                    notifications: cloneDeep_default()(artistNotifications),
                                                    __typename: "ArtistSettings"
                                                },
                                                __typename: "Artist"
                                            };
                                            var ref2 = (0,_sliced_to_array/* default */.Z)(value.type.split("_"), 2), type = ref2[0], subType = ref2[1];
                                            set_default()(updateArtistNotificationSettings, "settings.notifications.".concat(type, ".").concat(subType, ".").concat(value.channel), value.flag);
                                            return {
                                                updateArtistNotificationSettings: updateArtistNotificationSettings
                                            };
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/PushNotificationSettings/index.tsx




/**
 * PushNotificationSettings Page
 * Implemented as a practical sample.
 */ var PushNotificationSettings = function() {
    var ref = PushNotificationSettings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PushNotificationSettingsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ../../node_modules/react-canvas-confetti/dist/index.js
var react_canvas_confetti_dist = __webpack_require__(67861);
var react_canvas_confetti_dist_default = /*#__PURE__*/__webpack_require__.n(react_canvas_confetti_dist);
;// CONCATENATED MODULE: ./src/lib/canvasConfetti/index.tsx




var CanvasConfetti = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var sx = param.sx;
    var animationInstanceRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            start: function start() {
                setTimeout(nextTickAnimation, 1000);
            }
        };
    });
    var nextTickAnimation = (0,react.useCallback)(function() {
        if (animationInstanceRef.current) {
            animationInstanceRef.current(getAnimationSettings(0.1, 0.3));
            animationInstanceRef.current(getAnimationSettings(0.7, 0.9));
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactCanvasConfettiStyled, {
        // @ts-ignore
        sx: sx,
        refConfetti: function(ref) {
            return animationInstanceRef.current = ref;
        }
    });
});
var ReactCanvasConfettiStyled = (0,styled/* default */.ZP)((react_canvas_confetti_dist_default()))(function() {
    return {
        position: "absolute",
        pointerEvents: "none",
        outline: "none",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0
    };
});
function getAnimationSettings(originXA, originXB) {
    return {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        particleCount: 150,
        origin: {
            x: Math.random() * (originXB - originXA) + originXA,
            y: Math.random() - 0.2
        }
    };
}

;// CONCATENATED MODULE: ./src/components/pages/QRCodeGetGachaTicket/template/index.tsx













var QRCodeGetGachaTicketTemplate = function(param) {
    var state = param.state, onGetGachaTicket = param.onGetGachaTicket;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetGachaTicket").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerNames = ref3.routerNames, routerPages = ref3.routerPages, generatePath = ref3.generatePath;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,react.useState)(false), open = ref4[0], setOpen = ref4[1];
    var ref5 = (0,react.useState)(false), completion = ref5[0], setCompletion = ref5[1];
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCodeGetGachaTicket_template_FixedButtonCell, {
                    onCheck: function() {
                        return setOpen(true);
                    },
                    user: state.user,
                    authenticatedAt: (ref6 = (ref = state.gachaTicket) === null || ref === void 0 ? void 0 : (ref1 = ref.serial) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.authentication) === null || ref2 === void 0 ? void 0 : ref2.authenticatedAt) !== null && ref6 !== void 0 ? ref6 : ""
                }),
                header: {
                    title: completion ? t("title") : "",
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        size: "medium",
                        onClick: function() {
                            return router.push(routerPages.GlobalHome);
                        }
                    }),
                    type: "modal"
                },
                sx: {
                    height: "100dvh"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                        title: routerNames.QRcodeGetGachaTicket
                    }),
                    !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaTicketDescriptionCell, {
                                gachaTicket: state.gachaTicket
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: open,
                        onClose: function() {
                            return setOpen(false);
                        },
                        title: t("titleConfirm"),
                        content: "",
                        cancelText: t("cancelTextConfirm"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            color: "primary",
                            loading: state.submitting,
                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onGetGachaTicket().then(function() {
                                                    setCompletion(true);
                                                }).catch(function(e) {
                                                    return showError(e);
                                                }).finally(function() {
                                                    return setOpen(false);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            sx: {
                                minWidth: 212
                            },
                            children: t("okTextConfirm")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompletionModal, {
                open: completion,
                gachaTicket: state.gachaTicket
            })
        ]
    });
};
var GachaTicketDescriptionCell = function(param) {
    var gachaTicket = param.gachaTicket;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetGachaTicket").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            display: "grid",
            placeItems: "center",
            height: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaTicketCell, {
                    gachaTicket: gachaTicket
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    align: "center",
                    color: "text.secondary",
                    sx: {
                        mt: 5
                    },
                    children: t("gachaTicketDescription")
                })
            ]
        })
    });
};
var QRCodeGetGachaTicket_template_FixedButtonCell = function(param) {
    var user = param.user, authenticatedAt = param.authenticatedAt, onCheck = param.onCheck;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetGachaTicket").t;
    var buttonText = (0,react.useMemo)(function() {
        if (!user) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    color: "primary.main"
                },
                children: t("onCheckTextNotLogin")
            });
        }
        if (authenticatedAt) return t("onCheckTextAcquired");
        return t("onCheckTextDefault");
    }, [
        authenticatedAt,
        t,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
            sx: {
                bgcolor: "grey.50"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4,
                    bgcolor: "grey.50"
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        width: 244
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!user) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0,storage/* setRedirectAfterLoginPath */.fu)(router.pathname)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2,
                                        router.push(routerPages.Top)
                                    ];
                                case 2:
                                    if (!authenticatedAt) return [
                                        2,
                                        onCheck()
                                    ];
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    variant: !user ? "text" : "contained",
                    disabled: !!(user && authenticatedAt),
                    children: buttonText
                })
            })
        })
    });
};
var CompletionModal = function(param) {
    var gachaTicket = param.gachaTicket, open = param.open;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetGachaTicket").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var canvasConfettiRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (open && canvasConfettiRef.current) {
            canvasConfettiRef.current.start();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        canvasConfettiRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
            header: {
                title: t("completionTitle")
            },
            sx: {
                height: "100dvh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                sx: {
                    position: "relative",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            position: "relative",
                            zIndex: 1
                        },
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GachaTicketCell, {
                                gachaTicket: gachaTicket
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pb: 5
                        },
                        spacing: 5,
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            color: "primary",
                            href: routerPages.Top,
                            sx: {
                                position: "relative",
                                zIndex: 1
                            },
                            children: t("goToTop")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasConfetti, {
                        ref: canvasConfettiRef
                    })
                ]
            })
        })
    });
};
var GachaTicketCell = function(param) {
    var gachaTicket = param.gachaTicket;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            sx: {
                pt: 4,
                pb: 6,
                px: 8,
                bgcolor: "grey.50",
                borderRadius: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    component: "img",
                    height: 120,
                    width: 120,
                    src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.reward) === null || ref1 === void 0 ? void 0 : ref1.uri) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    sx: {
                        width: 104,
                        height: 32,
                        borderRadius: 8,
                        bgcolor: "grey.100"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        align: "center",
                        children: [
                            "x",
                            gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref2 = gachaTicket.serial) === null || ref2 === void 0 ? void 0 : ref2.issueCount
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/QRCodeGetGachaTicket/template/fragments.ts

function QRCodeGetGachaTicket_template_fragments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment gachaTicket on GachaTicket {\n      id\n      artistId\n      name\n      thumbnails {\n        reward {\n          uri\n        }\n        standard {\n          uri\n        }\n      }\n      description\n      createdAt\n      updatedAt\n      serialNumber\n      specifiedGachas\n      price\n      isPurchasable\n      artist {\n        id\n        standalone {\n          link {\n            common\n          }\n        }\n      }\n    }\n  "
    ]);
    QRCodeGetGachaTicket_template_fragments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QRCodeGetGachaTicket_template_fragments_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment gachaTicketOrder on GachaTicketOrder {\n      id\n      gachaId\n      orderType\n      createdAt\n      formattedCreatedAt @client\n      count\n      gachaTicketId\n    }\n  "
    ]);
    QRCodeGetGachaTicket_template_fragments_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function fragments_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment gachaTicketSerial on Serial {\n      id\n      authentication {\n        ... on SerialAuthentication {\n          authenticatedAt\n          expiredAt\n        }\n      }\n      createdAt\n      updatedAt\n      issueCount\n    }\n  "
    ]);
    fragments_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var QRCodeGetGachaTicket_template_fragments_fragments = {
    gachaTicket: (0,lib/* gql */.Ps)(QRCodeGetGachaTicket_template_fragments_templateObject()),
    gachaTicketOrder: (0,lib/* gql */.Ps)(QRCodeGetGachaTicket_template_fragments_templateObject1()),
    gachaTicketSerial: (0,lib/* gql */.Ps)(fragments_templateObject2())
};

;// CONCATENATED MODULE: ./src/components/pages/QRCodeGetGachaTicket/viewModel.ts




function QRCodeGetGachaTicket_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GachaTicketSerial($id: ID!, $serialId: ID!) {\n    user {\n      id\n      gachaTicket(id: $id) {\n        available\n      }\n    }\n    gachaTicket(id: $id) {\n      ...gachaTicket\n      serial(id: $serialId) {\n        ...gachaTicketSerial\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    QRCodeGetGachaTicket_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QRCodeGetGachaTicket_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ObtainGachaTicketSerial($id: String!, $serialId: String!) {\n    obtainGachaTicketSerial(gachaTicketId: $id, serialId: $serialId) {\n      ...gachaTicketOrder\n    }\n  }\n  ",
        "\n"
    ]);
    QRCodeGetGachaTicket_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var QRCodeGetGachaTicket_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = router.query || {}, gachaTicketId = ref.gachaTicketId, serialId = ref.serialId;
    var ref1 = (0,useQuery/* useQuery */.aM)(GACHA_TICKET_SERIAL, {
        variables: {
            id: gachaTicketId,
            serialId: serialId
        }
    }), data = ref1.data, queryLoading = ref1.loading;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(OBTAIN_GACHA_TICKET_SERIAL, {
        variables: {
            id: gachaTicketId,
            serialId: serialId
        }
    }), 2), obtain = ref2[0], ref3 = ref2[1], submitting = ref3.loading;
    var ref4;
    return {
        state: {
            loading: queryLoading,
            submitting: submitting,
            user: user,
            gachaTicket: (ref4 = data === null || data === void 0 ? void 0 : data.gachaTicket) !== null && ref4 !== void 0 ? ref4 : null
        },
        actions: {
            onGetGachaTicket: function onGetGachaTicket() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    obtain()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var GACHA_TICKET_SERIAL = (0,lib/* gql */.Ps)(QRCodeGetGachaTicket_viewModel_templateObject(), QRCodeGetGachaTicket_template_fragments_fragments.gachaTicket, QRCodeGetGachaTicket_template_fragments_fragments.gachaTicketSerial);
var OBTAIN_GACHA_TICKET_SERIAL = (0,lib/* gql */.Ps)(QRCodeGetGachaTicket_viewModel_templateObject1(), QRCodeGetGachaTicket_template_fragments_fragments.gachaTicketOrder);

;// CONCATENATED MODULE: ./src/components/pages/QRCodeGetGachaTicket/index.tsx




var QRCodeGetGachaTicket = function() {
    var ref = QRCodeGetGachaTicket_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCodeGetGachaTicketTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItem/template/index.tsx


















var QRcodeGetItemTemplate = function(param) {
    var state = param.state, onGetItem = param.onGetItem;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItem").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref7 = (0,react.useState)(false), open = ref7[0], setOpen = ref7[1];
    var ref8 = (0,react.useState)(false), completion = ref8[0], setCompletion = ref8[1];
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), router = ref9.router, routerNames = ref9.routerNames, routerPages = ref9.routerPages, generatePath = ref9.generatePath;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref10, ref11, ref12, _itemId, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkArea, {
                            pageName: "QRcodeGetItem",
                            itemId: state.itemId,
                            artistId: (ref10 = (ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref10 !== void 0 ? ref10 : "",
                            startItems: [
                                {
                                    type: "itemInfo",
                                    hidden: (0,individual/* individualHiddenItemInfo */.Ek)(),
                                    href: generatePath(routerPages.OwnedItemInformation, {
                                        itemId: (ref11 = (ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref11 !== void 0 ? ref11 : "#"
                                    }),
                                    onClick: handleLoginModal()
                                }, 
                            ],
                            endItems: [
                                {
                                    type: "comment",
                                    title: (ref12 = (ref3 = state.item) === null || ref3 === void 0 ? void 0 : ref3.commentCount) !== null && ref12 !== void 0 ? ref12 : 0
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QRcodeGetItem_template_FixedButtonCell, {
                            onCheck: function() {
                                return setOpen(true);
                            },
                            user: state.user,
                            itemId: (_itemId = state.itemId) !== null && _itemId !== void 0 ? _itemId : "",
                            authenticatedAt: (ref13 = (ref4 = state.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.serial) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.authentication) === null || ref6 === void 0 ? void 0 : ref6.authenticatedAt) !== null && ref13 !== void 0 ? ref13 : ""
                        })
                    ]
                }),
                header: {
                    title: completion ? t("title") : "",
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        size: "medium",
                        onClick: function() {
                            return router.push(routerPages.GlobalHome);
                        }
                    }),
                    type: "modal"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                        title: routerNames.QRcodeGetItem
                    }),
                    !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageCell, {
                                    item: state.item
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ItemDescriptionCell, {
                                    item: state.item
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: open,
                        onClose: function() {
                            return setOpen(false);
                        },
                        title: t("titleConfirm"),
                        content: "",
                        cancelText: t("cancelTextConfirm"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            color: "primary",
                            loading: state.gettingItem,
                            onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                onGetItem().then(function() {
                                                    setCompletion(true);
                                                }).catch(function(e) {
                                                    return showError(e);
                                                }).finally(function() {
                                                    return setOpen(false);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            sx: {
                                minWidth: 212
                            },
                            children: t("okTextConfirm")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CompletionModal, {
                open: completion,
                onClose: function() {},
                item: state.item,
                itemId: state.itemId
            })
        ]
    });
};
var ItemImageCell = function(param) {
    var item = param.item;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItem").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            display: "grid",
            placeItems: "center",
            pt: 2,
            pb: 5,
            gap: 5,
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        mb: 5
                    },
                    children: (item === null || item === void 0 ? void 0 : (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                        size: "large",
                        src: item.thumbnail.front.smallUri
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    sx: {
                        mb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h4",
                            align: "center",
                            children: item === null || item === void 0 ? void 0 : item.title
                        }),
                        (item === null || item === void 0 ? void 0 : item.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            align: "center",
                            children: item.sku.unitName
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "center",
                    spacing: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("serialNumber")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.primary",
                                    children: item === null || item === void 0 ? void 0 : (ref2 = item.serial) === null || ref2 === void 0 ? void 0 : ref2.id
                                }),
                                variant: "filled",
                                size: "small",
                                sx: {
                                    bgcolor: "grey.100",
                                    height: 16
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var template_ItemDescriptionCell = function(param) {
    var item = param.item;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItem").t;
    var itemIcon = (0,react.useMemo)(function() {
        switch(item === null || item === void 0 ? void 0 : item.type){
            case utoniq_core_schema/* ItemType.Audio */.qGq.Audio:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Audio, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Video */.qGq.Video:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Video, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Magazine */.qGq.Magazine:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Magazine, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Merch */.qGq.Merch:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Merch, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Wallpaper */.qGq.Wallpaper:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Wallpaper, {
                    fontSize: "xSmall"
                });
            case utoniq_core_schema/* ItemType.Ticket */.qGq.Ticket:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Ticket, {
                    fontSize: "xSmall"
                });
            default:
                return null;
        }
    }, [
        item === null || item === void 0 ? void 0 : item.type
    ]);
    var ref4, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: (ref4 = item === null || item === void 0 ? void 0 : item.description) !== null && ref4 !== void 0 ? ref4 : item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 3,
                alignItems: "center",
                sx: {
                    pt: 4
                },
                children: [
                    (item === null || item === void 0 ? void 0 : item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("rarity")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            (item === null || item === void 0 ? void 0 : (ref2 = item.rarityIconImage) === null || ref2 === void 0 ? void 0 : ref2.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                variant: "square",
                                                src: item.rarityIconImage.smallUri,
                                                sx: {
                                                    height: 12,
                                                    width: 12
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                children: (item === null || item === void 0 ? void 0 : (ref3 = item.rarity) === null || ref3 === void 0 ? void 0 : ref3.name) ? t(item.rarity.name) : "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                orientation: "vertical",
                                flexItem: true
                            })
                        ]
                    }),
                    !(item === null || item === void 0 ? void 0 : item.hideSalesNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "text.hint",
                                        children: t("numberOfIssues")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: (ref5 = item === null || item === void 0 ? void 0 : item.issuedNumber) !== null && ref5 !== void 0 ? ref5 : "∞"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                                orientation: "vertical",
                                flexItem: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.hint",
                                children: t("type")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    itemIcon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: t((ref6 = item === null || item === void 0 ? void 0 : item.type) !== null && ref6 !== void 0 ? ref6 : "")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var QRcodeGetItem_template_FixedButtonCell = function(param) {
    var onCheck = param.onCheck, user = param.user, authenticatedAt = param.authenticatedAt;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItem").t;
    var buttonText = (0,react.useMemo)(function() {
        if (!user) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    color: "primary.main"
                },
                children: t("onCheckTextNotLogin")
            });
        }
        if (authenticatedAt) {
            return t("onCheckTextAcquired");
        }
        return t("onCheckTextDefault");
    }, [
        user,
        authenticatedAt,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
            sx: {
                bgcolor: "grey.50"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4,
                    bgcolor: "grey.50"
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    color: "primary",
                    sx: {
                        width: 244
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!user) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0,storage/* setRedirectAfterLoginPath */.fu)(router.pathname)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2,
                                        router.push(routerPages.Top)
                                    ];
                                case 2:
                                    if (!authenticatedAt) {
                                        onCheck();
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    variant: !user ? "text" : "contained",
                    disabled: !!(user && authenticatedAt),
                    children: buttonText
                })
            })
        })
    });
};
var template_CompletionModal = function(param) {
    var item = param.item, itemId = param.itemId, open = param.open, onClose = param.onClose;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItem").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generateQueryPath = ref4.generateQueryPath, routerPages = ref4.routerPages;
    var canvasConfettiRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (open && canvasConfettiRef.current) {
            canvasConfettiRef.current.start();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        canvasConfettiRef.current
    ]);
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
            header: {
                title: t("completionTitle")
            },
            sx: {
                height: "100dvh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    position: "relative",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            position: "relative",
                            zIndex: 10
                        },
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                width: "fit-content",
                                img: {
                                    boxShadow: (item === null || item === void 0 ? void 0 : (ref = item.rarity) === null || ref === void 0 ? void 0 : ref.id) === "superrare" || (item === null || item === void 0 ? void 0 : (ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.id) === "ultrarare" ? "0 0 40px yellow" : "none"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                size: "large",
                                src: (ref5 = (ref2 = item === null || item === void 0 ? void 0 : item.thumbnail.front) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref5 !== void 0 ? ref5 : ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pb: 5
                        },
                        spacing: 5,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                href: generateQueryPath(routerPages.OwnedItemDetail, {
                                    itemId: itemId
                                }, {
                                    skuId: encodeSkuId((ref6 = item === null || item === void 0 ? void 0 : (ref3 = item.sku) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : "")
                                }),
                                sx: {
                                    position: "relative",
                                    zIndex: 10
                                },
                                children: t("checkItem")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                color: "primary",
                                href: routerPages.Top,
                                sx: {
                                    position: "relative",
                                    zIndex: 10
                                },
                                children: t("goToTop")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasConfetti, {
                        ref: canvasConfettiRef
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItem/viewModel.ts




function QRcodeGetItem_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ObtainSerial($itemId: ID!, $serialId: ID!) {\n    obtainSerial(itemId: $itemId, serialId: $serialId) {\n      id\n      isPurchased\n      serial(id: $serialId) {\n        id\n        skuId\n        authentication {\n          authenticatedAt\n        }\n      }\n    }\n  }\n"
    ]);
    QRcodeGetItem_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QRcodeGetItem_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query QRcodeGetItem($itemId: ID!, $serialId: ID!, $skuId: String) {\n    item(id: $itemId) {\n      ...ItemDetailBox\n      serial(id: $serialId) {\n        id\n        authentication {\n          authenticatedAt\n        }\n        skuId\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    QRcodeGetItem_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var QRcodeGetItem_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref2 = (0,useQuery/* useQuery */.aM)(QRcodeGetItem_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId,
            serialId: router.query.serialId
        }
    }), data = ref2.data, loading = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(QRcodeGetItem_viewModel_MUTATION, {
        variables: {
            itemId: router.query.itemId,
            serialId: router.query.serialId
        }
    }), 2), getItem = ref3[0], ref4 = ref3[1], gettingItem = ref4.loading;
    var ref5;
    return {
        state: {
            loading: loading,
            itemId: router.query.itemId,
            item: setItemSku(data === null || data === void 0 ? void 0 : data.item, (ref5 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.serial) === null || ref1 === void 0 ? void 0 : ref1.skuId) !== null && ref5 !== void 0 ? ref5 : null),
            user: user !== null && user !== void 0 ? user : null,
            gettingItem: gettingItem
        },
        actions: {
            onGetItem: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getItem()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var QRcodeGetItem_viewModel_MUTATION = (0,lib/* gql */.Ps)(QRcodeGetItem_viewModel_templateObject());
var QRcodeGetItem_viewModel_QUERY = (0,lib/* gql */.Ps)(QRcodeGetItem_viewModel_templateObject1(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItem/index.tsx




/**
 * QRcodeGetItem Page
 * Implemented as a practical sample.
 */ var QRcodeGetItem = function() {
    var ref = QRcodeGetItem_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QRcodeGetItemTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItemMulti/template/GetItemMultiCompletionModal.tsx












var itemMultiCompletionModalRef = /*#__PURE__*/ (0,react.createRef)();
var GetItemMultiCompletionModal = function(param) {
    var items = param.items, loading = param.loading, open = param.open;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItemMulti").t;
    var canvasConfettiRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(itemMultiCompletionModalRef, function() {
        return {
            playConfetti: function playConfetti() {
                var ref;
                (ref = canvasConfettiRef.current) === null || ref === void 0 ? void 0 : ref.start();
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: function() {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("getItemMultiCompleteTitle", "アイテムを獲得しました"),
                    sx: {
                        zIndex: function(theme) {
                            return theme.zIndex.modal + 3;
                        }
                    }
                },
                customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetItemMultiCompletionModal_FixedButtonCell, {}),
                sx: {
                    backgroundColor: "background.default"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: items === null || items === void 0 ? void 0 : items.map(function(itemSerial) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetItemMultiCompletionModal_ItemBox, {
                            itemSerial: itemSerial
                        });
                    }),
                    loading: loading,
                    hasNextPage: false,
                    onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            return [
                                2
                            ];
                        });
                    }),
                    component: Grid2/* default */.Z,
                    componentProps: {
                        container: true,
                        spacing: 3
                    },
                    itemComponent: Grid2/* default */.Z,
                    itemComponentProps: {
                        size: {
                            xs: 4,
                            md: 3
                        },
                        sx: {
                            textAlign: "center"
                        }
                    },
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        container: true,
                        spacing: 3,
                        children: Array.from(Array(12).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                size: {
                                    xs: 4,
                                    md: 3
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    sx: {
                                        width: "100%",
                                        height: 166
                                    }
                                })
                            }, key);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasConfetti, {
                ref: canvasConfettiRef,
                sx: {
                    maxWidth: 600,
                    margin: "0 auto",
                    right: 0
                }
            })
        ]
    });
};
var GetItemMultiCompletionModal_ItemBox = function(param) {
    var itemSerial = param.itemSerial;
    var ref, ref1, ref2;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), generateQueryPath = ref3.generateQueryPath, routerPages = ref3.routerPages;
    var item = itemSerial.item, count = itemSerial.count, sku = itemSerial.sku;
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        flex: 1,
        sx: {
            position: "relative",
            zIndex: 10,
            py: 1
        },
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
            sx: {
                position: "relative",
                width: "fit-content",
                img: {
                    boxShadow: (item === null || item === void 0 ? void 0 : (ref = item.rarity) === null || ref === void 0 ? void 0 : ref.id) === "superrare" || (item === null || item === void 0 ? void 0 : (ref1 = item.rarity) === null || ref1 === void 0 ? void 0 : ref1.id) === "ultrarare" ? "0px 0px 40px 0px rgba(250, 255, 0, 0.6)" : "none"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                    src: (ref4 = (ref2 = item === null || item === void 0 ? void 0 : item.thumbnail.front) === null || ref2 === void 0 ? void 0 : ref2.uri) !== null && ref4 !== void 0 ? ref4 : "",
                    href: generateQueryPath(routerPages.OwnedItemDetail, {
                        itemId: item.id
                    }, {
                        skuId: encodeSkuId((ref5 = sku === null || sku === void 0 ? void 0 : sku.id) !== null && ref5 !== void 0 ? ref5 : "")
                    })
                }),
                count > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    sx: {
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                        zIndex: 11,
                        bgcolor: "secondary.main",
                        borderRadius: "2px",
                        px: "2px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.OwnedItems, {
                            sx: {
                                color: "white",
                                width: 12,
                                height: 12
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            color: "white",
                            children: [
                                "\xd7",
                                count
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var GetItemMultiCompletionModal_FixedButtonCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItemMulti").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
            sx: {
                bgcolor: "grey.50"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 4,
                    bgcolor: "grey.50"
                },
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "outlined",
                        href: routerPages.MyOwnedItems,
                        sx: {
                            position: "relative",
                            zIndex: 10
                        },
                        children: t("checkItems", "アイテムを確認する")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        color: "primary",
                        href: routerPages.Top,
                        sx: {
                            position: "relative",
                            zIndex: 10
                        },
                        children: t("goToTop")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItemMulti/template/index.tsx














var QRcodeGetItemMultiTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onGetItemMulti = param.onGetItemMulti;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItemMulti").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, routerPages = ref3.routerPages, routerNames = ref3.routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                edge: "start",
                size: "medium",
                onClick: function() {
                    return router.push(routerPages.GlobalHome);
                }
            }),
            title: t("title"),
            type: "modal"
        },
        customNavigation: state.loading ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(QRcodeGetItemMulti_template_FixedButtonCell, {
            multiItemId: state.multiItemId,
            isLoggedIn: state.isLoggedIn,
            isAcquired: state.isAcquired,
            canBeObtain: state.canBeObtain,
            gettingItemMulti: state.gettingItemMulti,
            onGetItemMulti: onGetItemMulti
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.QRcodeGetItemMulti
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                loading: state.loading,
                nodes: (ref = state.multiItemSerial) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(itemSerial) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBoxCell, {
                        itemSerial: itemSerial
                    });
                }),
                componentProps: {
                    spacing: 2
                },
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    children: Array.from({
                        length: 7
                    }).map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBoxSkeletonCell, {}, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GetItemMultiCompletionModal, {
                loading: state.loading,
                open: state.showCompletedScreen,
                items: (ref2 = state.multiItemSerial) === null || ref2 === void 0 ? void 0 : ref2.items
            })
        ]
    });
};
var ItemBoxCell = function(param) {
    var itemSerial = param.itemSerial;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItemMulti").t;
    var count = itemSerial.count, item = itemSerial.item, sku = itemSerial.sku;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            src: (ref4 = (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                            size: "x-small"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                            children: item.title
                                        }),
                                        (sku === null || sku === void 0 ? void 0 : sku.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: sku.unitName
                                        })
                                    ]
                                }),
                                item.rarity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        (item === null || item === void 0 ? void 0 : (ref2 = item.rarityIconImage) === null || ref2 === void 0 ? void 0 : ref2.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            variant: "square",
                                            src: item.rarityIconImage.smallUri,
                                            sx: {
                                                height: 12,
                                                width: 12
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            color: "text.secondary",
                                            children: (item === null || item === void 0 ? void 0 : (ref3 = item.rarity) === null || ref3 === void 0 ? void 0 : ref3.name) ? t(item === null || item === void 0 ? void 0 : item.rarity.name) : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                alignItems: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                                        variant: "h1",
                                        children: count
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: t("sheet", "枚")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var ItemBoxSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: "34px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 85,
                    height: 68
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: "100%",
                            height: 15
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: "100%",
                            height: 15
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "50%",
                                    height: 15
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    width: "15%",
                                    height: 15
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var QRcodeGetItemMulti_template_FixedButtonCell = function(param) {
    var isLoggedIn = param.isLoggedIn, isAcquired = param.isAcquired, multiItemId = param.multiItemId, canBeObtain = param.canBeObtain, gettingItemMulti = param.gettingItemMulti, onGetItemMulti = param.onGetItemMulti;
    var t = (0,core_i18n/* useTranslation */.$G)("qrCodeGetItemMulti").t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generateQueryPath = ref.generateQueryPath, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var ref1 = (0,react.useState)(false), openConfirm = ref1[0], setOpenConfirm = ref1[1];
    var ref2 = (0,react.useMemo)(function() {
        if (!isLoggedIn) {
            return {
                label: t("registerMember", "会員登録してアイテムを獲得する"),
                variant: "text",
                onClick: function onClick() {
                    (0,storage/* setRedirectAfterLoginPath */.fu)(router.pathname);
                    return router.push(routerPages.Top);
                }
            };
        }
        if (isAcquired) {
            return {
                label: t("alreadyAcquired", "獲得済み"),
                variant: undefined,
                disabled: true
            };
        }
        if (!canBeObtain) {
            return {
                label: t("currentUnavailable", "現在、獲得できません"),
                variant: undefined,
                disabled: true
            };
        }
        return {
            label: t("acquireItem", "アイテムを獲得する"),
            variant: undefined,
            onClick: function onClick() {
                setOpenConfirm(true);
            }
        };
    }, [
        isLoggedIn,
        isAcquired,
        canBeObtain,
        t,
        router,
        generateQueryPath,
        routerPages.Login, 
    ]), label = ref2.label, disabled = ref2.disabled, variant = ref2.variant, onClick = ref2.onClick;
    var handleAcquireItem = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onGetItemMulti().then(function() {
                            setOpenConfirm(false);
                            router.replace(generatePath(routerPages.QRcodeGetItemMulti, {
                                multiItemId: multiItemId,
                                status: "complete"
                            }));
                            // delay 300ms for modal rendered
                            setTimeout(function() {
                                var ref;
                                return (ref = itemMultiCompletionModalRef.current) === null || ref === void 0 ? void 0 : ref.playConfetti();
                            }, 300);
                        }).catch(function(error) {
                            setOpenConfirm(false);
                            showError(error);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        onGetItemMulti,
        showError,
        router,
        generatePath,
        routerPages.QRcodeGetItemMulti,
        multiItemId, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSafeArea/* BottomSafeArea */.p, {
                sx: {
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        py: 4,
                        bgcolor: "grey.50"
                    },
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        color: "primary",
                        sx: {
                            minWidth: 244
                        },
                        onClick: onClick,
                        variant: variant,
                        disabled: disabled || gettingItemMulti,
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openConfirm,
                onClose: function() {
                    return setOpenConfirm(false);
                },
                title: t("confirmAcquireItemTitle"),
                content: "",
                cancelText: t("cancel"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    loading: gettingItemMulti,
                    disabled: gettingItemMulti,
                    onClick: handleAcquireItem,
                    children: t("earn")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItemMulti/viewModel.ts




function QRcodeGetItemMulti_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query QRcodeGetItemMulti($id: ID!) {\n    multiItemSerials(id: $id) {\n      ...MultiItemSerialDetail\n    }\n  }\n  ",
        "\n"
    ]);
    QRcodeGetItemMulti_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QRcodeGetItemMulti_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation obtainMultiItemSerials($id: ID!) {\n    obtainMultiItemSerials(id: $id) {\n      ...MultiItemSerialDetail\n    }\n  }\n  ",
        "\n"
    ]);
    QRcodeGetItemMulti_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var QRcodeGetItemMulti_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref3 = (0,useQuery/* useQuery */.aM)(QRcodeGetItemMulti_viewModel_QUERY, {
        variables: {
            id: router.query.multiItemId
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(OBTAIN_MULTI_ITEM_SERIALS), 2), getItemMulti = ref4[0], ref5 = ref4[1], gettingItemMulti = ref5.loading;
    var ref6;
    return {
        state: {
            loading: loading,
            hasNextPage: false,
            isLoggedIn: !!user,
            isAcquired: !!(data === null || data === void 0 ? void 0 : (ref = data.multiItemSerials) === null || ref === void 0 ? void 0 : ref.authenticatedAt),
            canBeObtain: !!(data === null || data === void 0 ? void 0 : (ref1 = data.multiItemSerials) === null || ref1 === void 0 ? void 0 : ref1.canBeObtain),
            gettingItemMulti: gettingItemMulti,
            multiItemSerial: (ref6 = data === null || data === void 0 ? void 0 : data.multiItemSerials) !== null && ref6 !== void 0 ? ref6 : null,
            multiItemId: router.query.multiItemId,
            showCompletedScreen: ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.status) === "complete"
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onGetItemMulti: function onGetItemMulti() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItemMulti({
                                        variables: {
                                            id: router.query.multiItemId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var QRcodeGetItemMulti_viewModel_QUERY = (0,lib/* gql */.Ps)(QRcodeGetItemMulti_viewModel_templateObject(), utoniq_core_schema/* MultiItemSerialDetailFragmentDoc */.lVk);
var OBTAIN_MULTI_ITEM_SERIALS = (0,lib/* gql */.Ps)(QRcodeGetItemMulti_viewModel_templateObject1(), utoniq_core_schema/* MultiItemSerialDetailFragmentDoc */.lVk);

;// CONCATENATED MODULE: ./src/components/pages/QRcodeGetItemMulti/index.tsx





/**
 * QRcodeGetItemMulti Page
 * Implemented as a practical sample.
 */ var QRcodeGetItemMulti = function() {
    var ref = QRcodeGetItemMulti_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (!state.loading && !state.multiItemSerial) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QRcodeGetItemMultiTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/RecentViewedItems/template/index.tsx









var RecentViewedItemsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("recentViewedItems").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.RecentViewedItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title"),
                    defaultBackPage: generatePath(routerPages.ArtistTop, {
                        artistId: config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : state.artistId
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.map(function(param, index) {
                        var node = param.node;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(MagazineItem, {
                            item: node.item,
                            divider: !!((ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.length) && index < ((ref1 = state.items) === null || ref1 === void 0 ? void 0 : ref1.edges.length) - 1,
                            conductorName: "recentryStoreViewList"
                        }, node.id);
                    }),
                    componentProps: {
                        spacing: 2
                    },
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    emptyMessage: t("emptyMessage"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            pt: 2
                        },
                        children: Array.from(Array(5).keys()).map(function(index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineItemSkeleton, {
                                divider: index < 4
                            }, index);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/RecentViewedItems/viewModel.ts



function RecentViewedItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query RecentViewedItems($pageInput: PageInput, $artistId: String) {\n    recentlyStoreViewedItems(pageInput: $pageInput, artistId: $artistId) {\n      ...RecentViewedItemConnection\n    }\n  }\n  ",
        "\n"
    ]);
    RecentViewedItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var RecentViewedItems_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var artistId = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId;
    var ref1 = (0,useQuery/* useQuery */.aM)(RecentViewedItems_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            artistId: artistId
        }
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2;
    return {
        state: {
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.recentlyStoreViewedItems) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            loading: loading,
            artistId: artistId !== null && artistId !== void 0 ? artistId : "#",
            items: (ref2 = data === null || data === void 0 ? void 0 : data.recentlyStoreViewedItems) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistId: artistId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.recentlyStoreViewedItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var RecentViewedItems_viewModel_QUERY = (0,lib/* gql */.Ps)(RecentViewedItems_viewModel_templateObject(), utoniq_core_schema/* RecentViewedItemConnectionFragmentDoc */.z19);

;// CONCATENATED MODULE: ./src/components/pages/RecentViewedItems/index.tsx




/**
 * RecentViewedItems Page
 * Implemented as a practical sample.
 */ var RecentViewedItems = function() {
    var ref = RecentViewedItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentViewedItemsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/RecommendCollections/template/index.tsx










var RecommendCollectionsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("recommendCollections").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.RecommendCollections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    nodes: (ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.map(function(param, index) {
                        var node = param.node;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(RecommendCollectionItem, {
                            recentlyViewdCollection: node,
                            divider: !!((ref = state.items) === null || ref === void 0 ? void 0 : ref.edges.length) && index < ((ref1 = state.items) === null || ref1 === void 0 ? void 0 : ref1.edges.length) - 1,
                            conductorName: "recentryViewCollectionList"
                        }, node.id);
                    }),
                    componentProps: {
                        spacing: 4
                    },
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    emptyMessage: t("emptyMessage"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        sx: {
                            pt: 2
                        },
                        children: Array.from(Array(5).keys()).map(function(index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendCollectionItemSkeleton, {
                                divider: index < 4
                            }, index);
                        })
                    })
                })
            })
        ]
    });
};
var RecommendCollectionItem = function(param) {
    var recentlyViewdCollection = param.recentlyViewdCollection, divider = param.divider, conductorName = param.conductorName;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var _mediumUri, ref1;
    var thumbnailUri = (ref1 = (_mediumUri = recentlyViewdCollection.collection.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : recentlyViewdCollection.collection.thumbnail.uri) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent",
            borderRadius: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.StoreCollectionDetail, {
                    artistId: recentlyViewdCollection.collection.artistId,
                    collectionId: recentlyViewdCollection.collection.id
                }),
                onClick: function() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                        artistId: recentlyViewdCollection.collection.artistId,
                        collectionId: recentlyViewdCollection.collection.id,
                        name: conductorName
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            variant: "square",
                            src: thumbnailUri,
                            sx: {
                                height: 60,
                                width: 107,
                                borderRadius: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            py: 2,
                            sx: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: recentlyViewdCollection.collection.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                    children: recentlyViewdCollection.collection.description
                                })
                            ]
                        })
                    ]
                })
            }),
            divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    mt: 4
                }
            })
        ]
    });
};
var RecommendCollectionItemSkeleton = function(param) {
    var divider = param.divider;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                flex: 1,
                direction: "row",
                alignItems: "center",
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 107,
                            height: 60,
                            sx: {
                                borderRadius: 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "45%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "100%"
                            })
                        ]
                    })
                ]
            }),
            divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    mt: 4
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/RecommendCollections/viewModel.ts



function RecommendCollections_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query RecommendCollections($pageInput: PageInput, $artistId: String) {\n    recentlyViewedCollections(pageInput: $pageInput, artistId: $artistId) {\n      ...RecommendCollectionConnection\n    }\n  }\n  ",
        "\n"
    ]);
    RecommendCollections_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var RecommendCollections_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var ref1 = (0,useQuery/* useQuery */.aM)(RecommendCollections_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            artistId: (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId
        }
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.recentlyViewedCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            items: (ref2 = data === null || data === void 0 ? void 0 : data.recentlyViewedCollections) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.recentlyViewedCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var RecommendCollections_viewModel_QUERY = (0,lib/* gql */.Ps)(RecommendCollections_viewModel_templateObject(), utoniq_core_schema/* RecommendCollectionConnectionFragmentDoc */._1v);

;// CONCATENATED MODULE: ./src/components/pages/RecommendCollections/index.tsx




/**
 * RecentViewedItems Page
 * Implemented as a practical sample.
 */ var RecommendCollections = function() {
    var ref = RecommendCollections_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendCollectionsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ReplyDetail/template/index.tsx








var ReplyDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onReply = param.onReply, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onDeleteComment = param.onDeleteComment, onBlockUser = param.onBlockUser, onReportUser = param.onReportUser;
    var ref, ref1, ref2, ref3, ref4;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var replyFormRef = (0,react.useRef)(null);
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var _artistId, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ReplyDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("reply"),
                    back: true
                },
                navigation: {
                    type: "replyForm",
                    props: {
                        ref: replyFormRef,
                        onReply: function(values) {
                            return onReply(values, (_artistId = state.artistId) !== null && _artistId !== void 0 ? _artistId : "");
                        },
                        userId: (ref5 = (ref = state.user) === null || ref === void 0 ? void 0 : ref.id) !== null && ref5 !== void 0 ? ref5 : "",
                        replyToDisplayName: (ref1 = state.comment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.commenter) === null || ref2 === void 0 ? void 0 : ref2.displayName,
                        visibleImage: true
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            px: 4,
                            pt: 5,
                            mb: 5
                        },
                        children: (state === null || state === void 0 ? void 0 : state.comment) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyBox, {
                            comment: state === null || state === void 0 ? void 0 : state.comment,
                            divider: true,
                            userId: (ref6 = state === null || state === void 0 ? void 0 : (ref3 = state.user) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : "",
                            onDeleteComment: onDeleteComment,
                            onReportUser: onReportUser,
                            onBlockUser: onBlockUser,
                            onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                            onClickReply: function() {
                                var ref;
                                return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            },
                            rootCollectionId: state.rootCollectionId,
                            showReaction: true,
                            onReplyToReply: function() {}
                        })
                    }),
                    (state === null || state === void 0 ? void 0 : state.comment) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                        commentCount: (ref4 = state.comment) === null || ref4 === void 0 ? void 0 : ref4.replyCount,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        comments: state.replies,
                        user: state.user,
                        onFetchMore: onFetchMore,
                        onDeleteComment: onDeleteComment,
                        onReportUser: onReportUser,
                        onBlockUser: onBlockUser,
                        onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                        rootCollectionId: state.rootCollectionId,
                        hiddenHeader: true,
                        hiddenNotice: true,
                        hiddenReply: true,
                        showReaction: true,
                        inverted: true,
                        onReplyToReply: function() {},
                        onClickReply: function() {}
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ReplyDetail/viewModel.ts







function ReplyDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ThreadReplyDetail(\n    $id: ID!\n    $commentId: ID!\n    $pageInput: PageInputDate\n  ) {\n    artistThreadChannel(id: $id) {\n      id\n      artistId\n    }\n    artistThreadChannelComment(id: $id, commentId: $commentId) {\n      ... on Comment {\n        ...CommentBoxWithoutReplies\n        replies(pageInput: $pageInput) {\n          edges {\n            node {\n              ... on Comment {\n                ...CommentBoxWithoutReplies\n                replies {\n                  edges {\n                    node {\n                      ... on Comment {\n                        ...CommentBoxWithoutReplies\n                      }\n                    }\n                  }\n                  pageInfo {\n                    hasNextPage\n                    endCursor\n                  }\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      email\n      avatar {\n        uri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ReplyDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReplyDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MissionReplyDetail(\n    $id: ID!\n    $commentId: ID!\n    $pageInput: PageInputDate\n  ) {\n    mission(id: $id) {\n      id\n      artistId\n    }\n    missionComment(id: $id, commentId: $commentId) {\n      ... on Comment {\n        ...CommentBoxWithoutReplies\n        replies(pageInput: $pageInput) {\n          edges {\n            node {\n              ... on Comment {\n                ...CommentBoxWithoutReplies\n                replies {\n                  edges {\n                    node {\n                      ... on Comment {\n                        ...CommentBoxWithoutReplies\n                      }\n                    }\n                  }\n                  pageInfo {\n                    hasNextPage\n                    endCursor\n                  }\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      email\n      avatar {\n        uri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ReplyDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReplyDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemReplyDetail($id: ID!, $commentId: ID!, $pageInput: PageInputDate) {\n    item(id: $id) {\n      id\n      issuedArtist {\n        id\n      }\n    }\n    itemComment(id: $id, commentId: $commentId) {\n      ... on Comment {\n        ...CommentBoxWithoutReplies\n        replies(pageInput: $pageInput) {\n          edges {\n            node {\n              ... on Comment {\n                ...CommentBoxWithoutReplies\n                replies {\n                  edges {\n                    node {\n                      ... on Comment {\n                        ...CommentBoxWithoutReplies\n                      }\n                    }\n                  }\n                  pageInfo {\n                    hasNextPage\n                    endCursor\n                  }\n                }\n              }\n            }\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      email\n      avatar {\n        uri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    ReplyDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ReplyDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref7 = (0,useQuery/* useQuery */.aM)(THREAD_QUERY, {
        variables: {
            id: router.query.id,
            commentId: router.query.commentId,
            pageInput: {
                limit: 10
            }
        },
        skip: router.query.type !== "threads",
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), threadData = ref7.data, threadLoading = ref7.loading, threadFetchMore = ref7.fetchMore, threadRefetch = ref7.refetch;
    var ref8 = (0,useQuery/* useQuery */.aM)(MISSION_QUERY, {
        variables: {
            id: router.query.id,
            commentId: router.query.commentId,
            pageInput: {
                limit: 10
            }
        },
        skip: router.query.type !== "missions",
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), missionData = ref8.data, missionLoading = ref8.loading, missionFetchMore = ref8.fetchMore, missionRefetch = ref8.refetch;
    var ref9 = (0,useQuery/* useQuery */.aM)(ITEM_QUERY, {
        variables: {
            id: router.query.id,
            commentId: router.query.commentId,
            pageInput: {
                limit: 10
            }
        },
        skip: router.query.type !== "items",
        returnPartialData: true,
        notifyOnNetworkStatusChange: true
    }), itemData = ref9.data, itemLoading = ref9.loading, itemFetchMore = ref9.fetchMore, itemRefetch = ref9.refetch;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikeThreadComment */.mtN), 1), likeThreadComment = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikeMissionComment */.KAE), 1), likeMissionComment = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* LikeItemComment */.Wr5), 1), likeItemComment = ref12[0];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikeThreadComment */.LzC), 1), unlikeThreadComment = ref13[0];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikeMissionComment */.SSK), 1), unlikeMissionComment = ref14[0];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UnlikeItemComment */.ZTK), 1), unlikeItemComment = ref15[0];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreateArtistThreadComment */.iym), 1), createArtistThreadComment = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreateMissionComment */.n39), 1), createMissionComment = ref17[0];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreateItemComment */.J3A), 1), createItemComment = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeleteArtistThreadComment */.Zxl), 1), deleteArtistThreadComment = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeleteMissionComment */.Cd8), 1), deleteMissionComment = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* DeleteItemComment */.n5z), 1), deleteItemComment = ref21[0];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref22[0];
    var getRepliesAndComment = (0,react.useCallback)(function(data) {
        if (!data) {
            return {
                replies: null,
                comment: null
            };
        }
        var replies = data.replies, comment = (0,_object_without_properties/* default */.Z)(data, [
            "replies"
        ]);
        return {
            replies: replies,
            comment: comment
        };
    }, []);
    var state = (0,react.useMemo)(function() {
        switch(router.query.type){
            case "threads":
                var ref, ref1, ref2, ref3, ref4;
                var ref5, ref6;
                return (0,src_object_spread/* default */.Z)({
                    rootCollectionId: threadData === null || threadData === void 0 ? void 0 : (ref = threadData.artistThreadChannel) === null || ref === void 0 ? void 0 : ref.id,
                    artistId: (ref5 = threadData === null || threadData === void 0 ? void 0 : (ref1 = threadData.artistThreadChannel) === null || ref1 === void 0 ? void 0 : ref1.artistId) !== null && ref5 !== void 0 ? ref5 : "",
                    user: (ref6 = threadData === null || threadData === void 0 ? void 0 : threadData.user) !== null && ref6 !== void 0 ? ref6 : null,
                    hasNextPage: !!(threadData === null || threadData === void 0 ? void 0 : (ref2 = threadData.artistThreadChannelComment) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.replies) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.pageInfo) === null || ref4 === void 0 ? void 0 : ref4.hasNextPage),
                    loading: threadLoading
                }, getRepliesAndComment(threadData === null || threadData === void 0 ? void 0 : threadData.artistThreadChannelComment));
            case "missions":
                var ref7, ref8, ref9, ref10, ref11;
                var ref12, ref13;
                return (0,src_object_spread/* default */.Z)({
                    rootCollectionId: missionData === null || missionData === void 0 ? void 0 : (ref7 = missionData.mission) === null || ref7 === void 0 ? void 0 : ref7.id,
                    artistId: (ref12 = missionData === null || missionData === void 0 ? void 0 : (ref8 = missionData.mission) === null || ref8 === void 0 ? void 0 : ref8.artistId) !== null && ref12 !== void 0 ? ref12 : "",
                    user: (ref13 = missionData === null || missionData === void 0 ? void 0 : missionData.user) !== null && ref13 !== void 0 ? ref13 : null,
                    hasNextPage: !!(missionData === null || missionData === void 0 ? void 0 : (ref9 = missionData.missionComment) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.replies) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.pageInfo) === null || ref11 === void 0 ? void 0 : ref11.hasNextPage),
                    loading: missionLoading
                }, getRepliesAndComment(missionData === null || missionData === void 0 ? void 0 : missionData.missionComment));
            default:
                var ref14, ref15, ref16, ref17, ref18, ref19;
                var ref20, ref21;
                return (0,src_object_spread/* default */.Z)({
                    rootCollectionId: itemData === null || itemData === void 0 ? void 0 : (ref14 = itemData.item) === null || ref14 === void 0 ? void 0 : ref14.id,
                    artistId: (ref20 = itemData === null || itemData === void 0 ? void 0 : (ref15 = itemData.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.issuedArtist) === null || ref16 === void 0 ? void 0 : ref16.id) !== null && ref20 !== void 0 ? ref20 : "",
                    user: (ref21 = itemData === null || itemData === void 0 ? void 0 : itemData.user) !== null && ref21 !== void 0 ? ref21 : null,
                    hasNextPage: !!(itemData === null || itemData === void 0 ? void 0 : (ref17 = itemData.itemComment) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.replies) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.pageInfo) === null || ref19 === void 0 ? void 0 : ref19.hasNextPage),
                    loading: itemLoading
                }, getRepliesAndComment(itemData === null || itemData === void 0 ? void 0 : itemData.itemComment));
        }
    }, [
        getRepliesAndComment,
        itemData === null || itemData === void 0 ? void 0 : (ref = itemData.item) === null || ref === void 0 ? void 0 : ref.id,
        itemData === null || itemData === void 0 ? void 0 : (ref1 = itemData.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id,
        itemData === null || itemData === void 0 ? void 0 : itemData.itemComment,
        itemData === null || itemData === void 0 ? void 0 : itemData.user,
        itemLoading,
        missionData === null || missionData === void 0 ? void 0 : (ref3 = missionData.mission) === null || ref3 === void 0 ? void 0 : ref3.artistId,
        missionData === null || missionData === void 0 ? void 0 : (ref4 = missionData.mission) === null || ref4 === void 0 ? void 0 : ref4.id,
        missionData === null || missionData === void 0 ? void 0 : missionData.missionComment,
        missionData === null || missionData === void 0 ? void 0 : missionData.user,
        missionLoading,
        router.query.type,
        threadData === null || threadData === void 0 ? void 0 : (ref5 = threadData.artistThreadChannel) === null || ref5 === void 0 ? void 0 : ref5.artistId,
        threadData === null || threadData === void 0 ? void 0 : (ref6 = threadData.artistThreadChannel) === null || ref6 === void 0 ? void 0 : ref6.id,
        threadData === null || threadData === void 0 ? void 0 : threadData.artistThreadChannelComment,
        threadData === null || threadData === void 0 ? void 0 : threadData.user,
        threadLoading, 
    ]);
    return {
        state: state,
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _, ref, ref1, ref2, ref3, ref4, ref5;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = router.query.type;
                                switch(_){
                                    case "threads":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "missions":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "items":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    threadFetchMore({
                                        variables: {
                                            id: router.query.id,
                                            commentId: router.query.commentId,
                                            pageInput: {
                                                cursor: (threadData === null || threadData === void 0 ? void 0 : (ref = threadData.artistThreadChannelComment) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    missionFetchMore({
                                        variables: {
                                            id: router.query.id,
                                            commentId: router.query.commentId,
                                            pageInput: {
                                                cursor: (missionData === null || missionData === void 0 ? void 0 : (ref2 = missionData.missionComment) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.replies) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    itemFetchMore({
                                        variables: {
                                            id: router.query.id,
                                            commentId: router.query.commentId,
                                            pageInput: {
                                                cursor: (itemData === null || itemData === void 0 ? void 0 : (ref4 = itemData.itemComment) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.replies) === null || ref5 === void 0 ? void 0 : ref5.pageInfo.endCursor) || null
                                            }
                                        }
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReply: function onReply(inputs, artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, variables, _;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                variables = {
                                    id: router.query.id,
                                    inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        artistId: artistId
                                    }, inputs), {
                                        replyToId: (ref = router.query) === null || ref === void 0 ? void 0 : ref.commentId,
                                        replyToAccountId: state === null || state === void 0 ? void 0 : (ref1 = state.comment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.commenter) === null || ref2 === void 0 ? void 0 : ref2.accountId
                                    })
                                };
                                _ = router.query.type;
                                switch(_){
                                    case "threads":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "missions":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "items":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    createArtistThreadComment({
                                        variables: variables
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    createMissionComment({
                                        variables: variables
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    createItemComment({
                                        variables: variables
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendComment", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    threadId: router.query.id,
                                    artistId: artistId,
                                    // remove 's' character
                                    name: router.query.type.slice(0, -1)
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeOrUnlikeComment: function onLikeOrUnlikeComment(param) {
                var isLike = param.isLike, commentId = param.commentId, likeCount = param.likeCount, id = param.id;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var variables, optimisticLike, optimisticUnlike, _, _tmp, _tmp1, _tmp2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                variables = {
                                    inputs: {
                                        id: id !== null && id !== void 0 ? id : "",
                                        commentId: commentId
                                    }
                                };
                                optimisticLike = {
                                    __typename: "Comment",
                                    id: commentId,
                                    isLike: true,
                                    likeCount: ++likeCount
                                };
                                optimisticUnlike = {
                                    __typename: "Comment",
                                    id: commentId,
                                    isLike: true,
                                    likeCount: ++likeCount
                                };
                                _ = router.query.type;
                                switch(_){
                                    case "threads":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "missions":
                                        return [
                                            3,
                                            6
                                        ];
                                    case "items":
                                        return [
                                            3,
                                            11
                                        ];
                                }
                                return [
                                    3,
                                    16
                                ];
                            case 1:
                                if (!isLike) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    unlikeThreadComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                unlikeArtistThreadChannelComment: optimisticUnlike
                                            };
                                        }
                                    })
                                ];
                            case 2:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    likeThreadComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                likeArtistThreadChannelComment: optimisticLike
                                            };
                                        }
                                    })
                                ];
                            case 4:
                                _tmp = _state.sent();
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    3,
                                    16
                                ];
                            case 6:
                                if (!isLike) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    unlikeMissionComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                unlikeMissionComment: optimisticUnlike
                                            };
                                        }
                                    })
                                ];
                            case 7:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                return [
                                    4,
                                    likeMissionComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                likeMissionComment: optimisticLike
                                            };
                                        }
                                    })
                                ];
                            case 9:
                                _tmp1 = _state.sent();
                                _state.label = 10;
                            case 10:
                                _tmp1;
                                return [
                                    3,
                                    16
                                ];
                            case 11:
                                if (!isLike) return [
                                    3,
                                    13
                                ];
                                return [
                                    4,
                                    unlikeItemComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                unlikeItemComment: optimisticUnlike
                                            };
                                        }
                                    })
                                ];
                            case 12:
                                _tmp2 = _state.sent();
                                return [
                                    3,
                                    15
                                ];
                            case 13:
                                return [
                                    4,
                                    likeItemComment({
                                        variables: variables,
                                        optimisticResponse: function() {
                                            return {
                                                likeItemComment: optimisticLike
                                            };
                                        }
                                    })
                                ];
                            case 14:
                                _tmp2 = _state.sent();
                                _state.label = 15;
                            case 15:
                                _tmp2;
                                return [
                                    3,
                                    16
                                ];
                            case 16:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteComment: function onDeleteComment(commentId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var variables, _;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                variables = {
                                    id: router.query.id,
                                    commentId: commentId
                                };
                                _ = router.query.type;
                                switch(_){
                                    case "threads":
                                        return [
                                            3,
                                            1
                                        ];
                                    case "missions":
                                        return [
                                            3,
                                            3
                                        ];
                                    case "items":
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    deleteArtistThreadComment({
                                        variables: variables
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    deleteMissionComment({
                                        variables: variables
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    deleteItemComment({
                                        variables: variables
                                    })
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_deleteComment", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    threadId: router.query.id,
                                    artistId: state === null || state === void 0 ? void 0 : state.artistId,
                                    // remove 's' character
                                    name: router.query.type.slice(0, -1)
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var _;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _ = router.query.type;
                                switch(_){
                                    case "threads":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "missions":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "items":
                                        return [
                                            3,
                                            6
                                        ];
                                }
                                return [
                                    3,
                                    8
                                ];
                            case 2:
                                return [
                                    4,
                                    threadRefetch()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 4:
                                return [
                                    4,
                                    missionRefetch()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                return [
                                    4,
                                    itemRefetch()
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref1 = state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : ref.email) !== null && ref1 !== void 0 ? ref1 : "",
                                        // remove 's' character
                                        contentType: router.query.type.slice(0, -1),
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var THREAD_QUERY = (0,lib/* gql */.Ps)(ReplyDetail_viewModel_templateObject(), utoniq_core_schema/* CommentBoxWithoutRepliesFragmentDoc */.Ds5);
var MISSION_QUERY = (0,lib/* gql */.Ps)(ReplyDetail_viewModel_templateObject1(), utoniq_core_schema/* CommentBoxWithoutRepliesFragmentDoc */.Ds5);
var ITEM_QUERY = (0,lib/* gql */.Ps)(ReplyDetail_viewModel_templateObject2(), utoniq_core_schema/* CommentBoxWithoutRepliesFragmentDoc */.Ds5);

;// CONCATENATED MODULE: ./src/components/pages/ReplyDetail/index.tsx




var ReplyDetail = function() {
    var ref = ReplyDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreate/template/index.tsx















var ResaleApplicationCreateTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreate").t;
    var ref = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleApply")), onClickHelp = ref.onClick;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.ResaleApplicationCreatePrecaution, {
                itemId: router.query.itemId
            }),
            title: t("title", "リセール応募"),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                onClick: onClickHelp,
                edge: "end",
                color: "primary"
            })
        },
        children: state.loading || !state.item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationProceedSkeletonCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        py: 5
                    },
                    children: t("resaleInfo", "応募枚数・お支払い方法選択")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationProceedContentCell, {
                    item: state.item,
                    brand: state.brand,
                    cardNumber: state.cardNumber,
                    selectableItemCount: state.selectableItemCount,
                    onSubmit: onSubmit
                })
            ]
        })
    });
};
var ApplicationProceedSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    pt: "42px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 3,
                sx: {
                    pt: "22px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "50%",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "caption",
                        width: "25%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 2,
                        lastWidth: "25%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    pt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: "34px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            pt: 8,
                            pb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                height: 44,
                                width: 212,
                                sx: {
                                    borderRadius: 34
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "15%",
                                sx: {
                                    mt: 2
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ApplicationProceedContentCell = function(param) {
    var item = param.item, selectableItemCount = param.selectableItemCount, cardNumber = param.cardNumber, brand = param.brand, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreate").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var ref1 = (0,react.useState)("1"), selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,react.useMemo)(function() {
        return getItemSkuPrice(item);
    }, [
        item
    ]), itemPrice = ref2.price;
    // 代金
    var price = itemPrice * +selected;
    var ref3;
    // システム手数料
    var purchaseFee = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref3 = item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resaleFee) === null || ref2 === void 0 ? void 0 : ref2.purchaseFee) !== null && ref3 !== void 0 ? ref3 : 0;
    }, [
        item
    ]);
    var totalAmount = (0,react.useMemo)(function() {
        if (!itemPrice) {
            return 0;
        }
        return numeral_default()(price + purchaseFee).format("0,0");
    }, [
        itemPrice,
        selected
    ]);
    var data = [
        {
            label: t("ticketPrice", "代金"),
            value: "￥".concat(numeral_default()(price).format("0,0"))
        },
        {
            label: t("transferFee", "システム手数料"),
            value: "￥".concat(numeral_default()(purchaseFee).format("0,0"))
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("selectTicketNumber"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("selectTicketNumberToSell", "応募枚数を指定してください。", {
                                number: selectableItemCount.toString()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Select, {
                                    listItems: (0,src_to_consumable_array/* default */.Z)(Array(selectableItemCount).keys()).map(function(index) {
                                        return {
                                            value: (index + 1).toString(),
                                            label: (index + 1).toString()
                                        };
                                    }),
                                    value: selected,
                                    onChange: function(value) {
                                        return setSelected(value);
                                    },
                                    formControlProps: {
                                        sx: {
                                            minWidth: 100,
                                            bgcolor: "grey.50",
                                            minHeight: "auto"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: t("sheet")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResaleItem, {
                title: t("paymentInfo"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("creditCardInfo")
                            }),
                            !cardNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "primary.main",
                                onClick: function() {
                                    return router.push(routerPages.PaymentMethodSetting, {
                                        goBackPath: routerPages.ResaleApplicationCreate
                                    });
                                },
                                children: t("register")
                            })
                        ]
                    }),
                    !cardNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.hint",
                        children: t("cardInfoNotRegister")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                width: 40,
                                height: 32,
                                src: (0,creditCard/* generateCreditCardLogoPath */.n)(brand),
                                target: "common"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("last4Digit", {
                                    number: cardNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("totalPayment", "お支払い総額"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            data.map(function(param, index) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            "\xa5",
                                            totalAmount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                alignItems: "center",
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 212
                        },
                        disabled: !cardNumber,
                        onClick: function() {
                            return onSubmit(Number(selected));
                        },
                        children: t("submit", "確認する")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: 212
                        },
                        onClick: function() {
                            return router.goBack(generatePath(routerPages.ResaleApplicationCreatePrecaution, {
                                itemId: router.query.itemId
                            }));
                        },
                        children: t("back", "戻る")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreate/viewModel.ts



function ResaleApplicationCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleApplicationCreate($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n      preSale {\n        id\n        lottery {\n          purchasableCount\n        }\n        firstComeFirstServed {\n          purchasableCount\n        }\n      }\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleApplicationCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleApplicationCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), router = ref9.router, generatePath = ref9.generatePath, routerPages = ref9.routerPages;
    var itemId = router.query.itemId;
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var ref10 = (0,useQuery/* useQuery */.aM)(ResaleApplicationCreate_viewModel_QUERY, {
        variables: {
            id: itemId,
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }), data = ref10.data, loading = ref10.loading;
    var ref11, ref12, ref13, ref14;
    return {
        state: {
            loading: loading,
            item: setItemSku((ref11 = data === null || data === void 0 ? void 0 : data.item) !== null && ref11 !== void 0 ? ref11 : null, skuId),
            cardNumber: data === null || data === void 0 ? void 0 : (ref1 = data.paymentSource) === null || ref1 === void 0 ? void 0 : ref1.last4,
            brand: (ref12 = data === null || data === void 0 ? void 0 : (ref2 = data.paymentSource) === null || ref2 === void 0 ? void 0 : ref2.brand) !== null && ref12 !== void 0 ? ref12 : "",
            // 選択できる応募枚数(最大8枚まで)
            selectableItemCount: (ref14 = (ref13 = data === null || data === void 0 ? void 0 : (ref3 = data.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.preSale) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.lottery) === null || ref5 === void 0 ? void 0 : ref5.purchasableCount) !== null && ref13 !== void 0 ? ref13 : data === null || data === void 0 ? void 0 : (ref6 = data.item) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.preSale) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.firstComeFirstServed) === null || ref8 === void 0 ? void 0 : ref8.purchasableCount) !== null && ref14 !== void 0 ? ref14 : 8
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(quantity) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,storage/* setResaleApplicationInput */.az)({
                                        itemCount: quantity.toString(),
                                        itemId: itemId
                                    }).then(function() {
                                        router.push({
                                            pathname: generatePath(routerPages.ResaleApplicationCreateConfirmation, {
                                                itemId: itemId
                                            }),
                                            search: "".concat(skuId ? "?skuId=".concat(skuId) : "")
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(quantity) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var ResaleApplicationCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleApplicationCreate_viewModel_templateObject(), utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreate/index.tsx




/**
 * ResaleApplicationCreate Page
 * Implemented as a practical sample.
 */ var ResaleApplicationCreate = function() {
    var ref = ResaleApplicationCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateCompletion/template/index.tsx









var ResaleApplicationCreateCompletionTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreateCompletion").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title", "リセール応募完了")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ResultCell, {}),
                !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_DetailCell, {
                    itemResaleRaffleUser: state.itemResaleRaffleUser,
                    raffledAtNext: state.raffledAtNext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    spacing: 4,
                    sx: {
                        pt: "44px",
                        pb: 6
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            href: generatePath(routerPages.ResaleManagement, {
                                tab: "raffle"
                            }),
                            sx: {
                                width: 244,
                                margin: "auto"
                            },
                            color: "primary",
                            children: t("resaleManagementScreen", "リセール管理画面へ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            href: routerPages.Top,
                            size: "large",
                            sx: {
                                width: 244,
                                margin: "auto"
                            },
                            color: "primary",
                            children: t("topPage", "TOPページへ")
                        })
                    ]
                })
            ]
        })
    });
};
var template_ResultCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreateCompletion").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: "55px",
            pb: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            spacing: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    align: "center",
                    children: t("message", "応募が完了しました")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    align: "center",
                    children: t("content")
                })
            ]
        })
    });
};
var template_DetailCell = function(param) {
    var itemResaleRaffleUser = param.itemResaleRaffleUser, raffledAtNext = param.raffledAtNext;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreateCompletion").t;
    var ref7 = (0,react.useMemo)(function() {
        return getItemSkuPrice(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item);
    }, [
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item
    ]), price = ref7.price, formattedPrice = ref7.formattedPrice;
    var ref8, ref9;
    var data = [
        {
            label: t("ticketPrice", "価格"),
            value: "\xa5".concat(formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : 0, "/1").concat(t("perSheet"))
        },
        {
            label: t("applicationNumber", "応募枚数"),
            value: t("applicationNumberValue", {
                number: String(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount)
            })
        },
        {
            label: t("totalAmount", "合計金額"),
            value: "\xa5".concat(numeral_default()(((ref8 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.totalItemPrice) !== null && ref8 !== void 0 ? ref8 : 0) + ((ref9 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.purchaseFee) !== null && ref9 !== void 0 ? ref9 : 0)).format("0,0"))
        },
        {
            label: t("applicationDate", "応募日時"),
            value: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.formattedCreatedAt
        },
        {
            label: t("nextLotteryDate", "次回抽選日時"),
            value: raffledAtNext
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref4 = itemResaleRaffleUser.item) === null || ref4 === void 0 ? void 0 : ref4.title
                                }),
                                !!(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref5 = itemResaleRaffleUser.item) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sku) === null || ref6 === void 0 ? void 0 : ref6.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: itemResaleRaffleUser.item.sku.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 6,
                            children: data.map(function(param, index) {
                                var label = param.label, value = param.value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: value
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateCompletion/viewModel.ts



function ResaleApplicationCreateCompletion_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleApplicationCreateCompletion(\n    $raffleId: ID!\n    $itemId: String!\n    $skuId: String\n  ) {\n    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {\n      ...ItemResaleRaffleUserDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleApplicationCreateCompletion_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 *
 */ var ResaleApplicationCreateCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref2;
    var ref3 = (0,useQuery/* useQuery */.aM)(ResaleApplicationCreateCompletion_viewModel_QUERY, {
        variables: {
            raffleId: router.query.raffleId,
            itemId: router.query.itemId,
            skuId: decodeSkuId((ref2 = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId) !== null && ref2 !== void 0 ? ref2 : "") || undefined
        }
    }), data = ref3.data, loading = ref3.loading;
    var itemResaleRaffleUser = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.itemResaleRaffleUser), {
            item: setItemSku(data.itemResaleRaffleUser.item, (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser,
        (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.skuId
    ]);
    (0,react.useEffect)(function() {
        return function() {
            (0,storage/* removeResaleApplicationInput */.vT)();
        };
    }, []);
    return {
        state: {
            loading: loading,
            itemResaleRaffleUser: itemResaleRaffleUser,
            raffledAtNext: (0,dayjs/* nextRaffleDateTime */.N7)()
        },
        actions: {}
    };
});
var ResaleApplicationCreateCompletion_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleApplicationCreateCompletion_viewModel_templateObject(), utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh);

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateCompletion/index.tsx




/**
 * ResaleApplicationCreateCompletion Page
 * Implemented as a practical sample.
 */ var ResaleApplicationCreateCompletion = function() {
    var ref = ResaleApplicationCreateCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationCreateCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateConfirmation/template/index.tsx














var ResaleApplicationCreateConfirmationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreateConfirmation").t;
    var ref = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleApply")), onClickHelp = ref.onClick;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router, generateQueryPath = ref1.generateQueryPath;
    var _skuId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                back: true,
                title: t("title", "リセール応募"),
                defaultBackPage: generateQueryPath(routerPages.ResaleApplicationCreate, {
                    itemId: router.query.itemId
                }, {
                    skuId: (_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : ""
                }),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                    onClick: onClickHelp,
                    edge: "end",
                    color: "primary"
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        py: 5
                    },
                    children: t("resaleInfo", "最終確認")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationProceedConfirmationContentCell, {
                    submitting: state.submitting,
                    item: state.item,
                    brand: state.brand,
                    selectedCount: state.selectedCount,
                    cardNumber: state.cardNumber,
                    onSubmit: onSubmit
                })
            ]
        })
    });
};
var ApplicationProceedConfirmationContentCell = function(param) {
    var item = param.item, selectedCount = param.selectedCount, cardNumber = param.cardNumber, brand = param.brand, submitting = param.submitting, onSubmit = param.onSubmit;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreateConfirmation").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, routerPages = ref5.routerPages, generateQueryPath = ref5.generateQueryPath;
    var purchaseFee = (item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resaleFee) === null || ref2 === void 0 ? void 0 : ref2.purchaseFee) || 0;
    var ref6 = (0,react.useMemo)(function() {
        return getItemSkuPrice(item);
    }, [
        item
    ]), price = ref6.price, formattedPrice = ref6.formattedPrice;
    var totalAmount = (0,react.useMemo)(function() {
        if (!price) {
            return 0;
        }
        return numeral_default()(price * selectedCount + purchaseFee).format("0,0");
    }, [
        purchaseFee,
        price,
        selectedCount
    ]);
    var data = [
        {
            label: t("ticketPrice", "代金"),
            value: "￥".concat(numeral_default()((price || 0) * selectedCount).format("0,0"))
        },
        {
            label: t("transferFee", "システム手数料"),
            value: "\xa5".concat(numeral_default()(purchaseFee).format("0,0"))
        }, 
    ];
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("applicationInfo", "応募情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketName", "チケット名")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: item === null || item === void 0 ? void 0 : item.title
                                }),
                                !!(item === null || item === void 0 ? void 0 : (ref3 = item.sku) === null || ref3 === void 0 ? void 0 : ref3.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: item === null || item === void 0 ? void 0 : (ref4 = item.sku) === null || ref4 === void 0 ? void 0 : ref4.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketPriceLabel", "価格")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("ticketPriceValue", "\xa5{{price}}/1枚あたり", {
                                        price: formattedPrice || 0
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("applicationNumber", "応募枚数")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        selectedCount,
                                        t("sheet", "枚")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResaleItem, {
                title: t("paymentInfo", "支払い情報"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            children: t("creditCardInfo", "クレジットカード情報")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                width: 40,
                                height: 32,
                                src: (0,creditCard/* generateCreditCardLogoPath */.n)(brand),
                                target: "common"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("last4Digit", {
                                    number: cardNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResaleItem, {
                title: t("totalPayment", "お支払い総額"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            children: [
                                data.map(function(param, index) {
                                    var value = param.value, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "space-between",
                                                sx: {
                                                    py: 2
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        color: "text.secondary",
                                                        children: label
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "body2",
                                                        children: value
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    sx: {
                                        py: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("total", "合計")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: [
                                                "\xa5",
                                                totalAmount
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t("resaleApplicationNote", "応募のみではお支払いは発生しません。\n抽選にて当選後、申請された場合のみ請求されます。")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                alignItems: "center",
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 212
                        },
                        onClick: onSubmit,
                        loading: submitting,
                        disabled: !selectedCount || !cardNumber,
                        children: t("submit", "応募する")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: 212
                        },
                        onClick: function() {
                            var ref;
                            return router.goBack(generateQueryPath(routerPages.ResaleApplicationCreate, {
                                itemId: router.query.itemId
                            }, {
                                skuId: decodeURI((ref7 = item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.id) !== null && ref7 !== void 0 ? ref7 : "")
                            }));
                        },
                        children: t("back", "戻る")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateConfirmation/viewModel.ts




function ResaleApplicationCreateConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleApplicationCreateConfirmation($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleApplicationCreateConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleApplicationCreateConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ApplyResaleItemRaffle($inputs: ApplyResaleItemRaffleInput!) {\n    applyResaleItemRaffle(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ResaleApplicationCreateConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 *
 */ var ResaleApplicationCreateConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, generatePath = ref3.generatePath, routerPages = ref3.routerPages;
    var itemId = router.query.itemId;
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,react.useState)(0), itemCount = ref4[0], setItemCount = ref4[1];
    var data = (0,useQuery/* useQuery */.aM)(ResaleApplicationCreateConfirmation_viewModel_QUERY, {
        variables: {
            id: itemId,
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }).data;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(APPLY_RESALE_ITEM_RAFFLE), 2), applyResaleItemRaffle = ref5[0], ref6 = ref5[1], submitting = ref6.loading;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var v;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getResaleApplicationInput */.I$)()
                        ];
                    case 1:
                        v = _state.sent();
                        setItemCount(Number(v.itemCount));
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        storage/* getResaleApplicationInput */.I$
    ]);
    var ref7;
    return {
        state: {
            cardNumber: data === null || data === void 0 ? void 0 : (ref1 = data.paymentSource) === null || ref1 === void 0 ? void 0 : ref1.last4,
            item: setItemSku((ref7 = data === null || data === void 0 ? void 0 : data.item) !== null && ref7 !== void 0 ? ref7 : null, skuId),
            brand: data === null || data === void 0 ? void 0 : (ref2 = data.paymentSource) === null || ref2 === void 0 ? void 0 : ref2.brand,
            selectedCount: itemCount,
            submitting: submitting
        },
        actions: {
            onSubmit: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    applyResaleItemRaffle({
                        variables: {
                            inputs: {
                                itemId: itemId,
                                itemCount: itemCount,
                                skuId: skuId ? decodeSkuId(skuId) : null
                            }
                        }
                    }).then(function(param) {
                        var data = param.data;
                        router.push({
                            pathname: generatePath(routerPages.ResaleApplicationCreateCompletion, {
                                itemId: itemId,
                                raffleId: data === null || data === void 0 ? void 0 : data.applyResaleItemRaffle.id
                            }),
                            search: "".concat(skuId ? "?skuId=".concat(skuId) : "")
                        });
                    }).catch(showError);
                    return [
                        2
                    ];
                });
            })
        }
    };
});
var ResaleApplicationCreateConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleApplicationCreateConfirmation_viewModel_templateObject(), utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);
var APPLY_RESALE_ITEM_RAFFLE = (0,lib/* gql */.Ps)(ResaleApplicationCreateConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreateConfirmation/index.tsx




/**
 * ResaleApplicationCreateConfirmation Page
 * Implemented as a practical sample.
 */ var ResaleApplicationCreateConfirmation = function() {
    var ref = ResaleApplicationCreateConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationCreateConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreatePrecaution/template/index.tsx











var ResaleApplicationCreatePrecautionTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreatePrecaution").t;
    var ref = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleApply")), onClickHelp = ref.onClick;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, router = ref1.router, generateQueryPath = ref1.generateQueryPath;
    var _skuId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: generateQueryPath(routerPages.ResaleApplicationDetail, {
                    itemId: router.query.itemId
                }, {
                    skuId: (_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : ""
                }),
                title: t("title", "リセール応募"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                    onClick: onClickHelp,
                    edge: "end",
                    color: "primary"
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        py: 5
                    },
                    children: t("resaleInfo", "応募の際の注意事項")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationCreatePrecaution_template_NoteCell, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationContentCell, {
                    purchaseFee: state.purchaseFee
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButtonCell, {
                    onSubmit: onSubmit
                })
            ]
        })
    });
};
var ResaleApplicationCreatePrecaution_template_NoteCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreatePrecaution").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            mb: 5,
            borderColor: "primary.main",
            borderWidth: 1,
            borderStyle: "solid",
            p: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "primary",
            children: t("resaleNote")
        })
    });
};
var ResaleApplicationContentCell = function(param) {
    var purchaseFee = param.purchaseFee;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreatePrecaution").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("purchaseFee", "購入にかかる手数料"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("purchaseFeeDesc", {
                                purchaseFee: purchaseFee
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("purchaseFeeNote")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("ticketPayment", "リセール代金のお支払い"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("ticketPaymentDesc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("ticketPaymentNote")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "primary",
                            children: t("ticketPaymentNotice", "支払い期限は翌日の23:59となりますのでご注意ください。")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("cancelApplication"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                            dense: true,
                            sx: {
                                listStyleType: "disc",
                                pl: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    sx: {
                                        display: "list-item"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("cancelApplicationDesc1")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    sx: {
                                        display: "list-item"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("cancelApplicationDesc2")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    sx: {
                                        display: "list-item"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        children: t("cancelApplicationDesc3")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("cancelApplicationNote")
                        })
                    ]
                })
            })
        ]
    });
};
var SubmitButtonCell = function(param) {
    var onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationCreatePrecaution").t;
    var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 4,
            alignItems: "center",
            sx: {
                pt: 2,
                pb: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checked,
                        onClick: function() {
                            return setChecked(function(prevState) {
                                return !prevState;
                            });
                        }
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("checkBoxLabel")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: !checked,
                    sx: {
                        width: 212
                    },
                    onClick: onSubmit,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    size: "small",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.ResaleApplicationDetail, {
                            itemId: router.query.itemId
                        }));
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreatePrecaution/viewModel.ts



function ResaleApplicationCreatePrecaution_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleApplicationCreatePrecaution($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleApplicationCreatePrecaution_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleApplicationCreatePrecaution_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var itemId = router.query.itemId;
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var data = (0,useQuery/* useQuery */.aM)(ResaleApplicationCreatePrecaution_viewModel_QUERY, {
        variables: {
            id: itemId,
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }).data;
    return {
        state: {
            // 購入手数料
            purchaseFee: (data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.resaleFee) === null || ref4 === void 0 ? void 0 : ref4.purchaseFee) || 0
        },
        actions: {
            onSubmit: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* removeResaleApplicationInput */.vT)()
                            ];
                        case 1:
                            _state.sent();
                            router.push({
                                pathname: generatePath(routerPages.ResaleApplicationCreate, {
                                    itemId: itemId
                                }),
                                search: "".concat(skuId ? "?skuId=".concat(skuId) : "")
                            });
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var ResaleApplicationCreatePrecaution_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleApplicationCreatePrecaution_viewModel_templateObject(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationCreatePrecaution/index.tsx




/**
 * ResaleApplication Page
 * Implemented as a practical sample.
 */ var ResaleApplicationCreatePrecaution = function() {
    var ref = ResaleApplicationCreatePrecaution_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationCreatePrecautionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationDetail/template/index.tsx













var ResaleApplicationDetailTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationDetail").t;
    var ref2 = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleApply")), onClickHelp = ref2.onClick;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref3.routerPages, generatePath = ref3.generatePath, router = ref3.router;
    var ref4, _itemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                back: true,
                defaultBackPage: generatePath(routerPages.ArtistStoreItemDetail, {
                    artistId: (ref4 = (ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref4 !== void 0 ? ref4 : "#",
                    itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
                }),
                title: t("title"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                    onClick: onClickHelp,
                    edge: "end",
                    color: "primary"
                })
            },
            children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            py: 5
                        },
                        children: t("resaleInfo", "リセールチケット情報")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleAppliedUserCell, {
                        itemResaleRaffle: state.itemResaleRaffle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationDetailContentCell, {
                        item: state.item
                    }),
                    !state.itemResaleRaffle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 4,
                            pb: 6
                        },
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            onClick: onSubmit,
                            children: t("submit", "応募手続きを行う")
                        })
                    })
                ]
            })
        })
    });
};
var ResaleApplicationSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "h4",
                            width: "50%"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    bgcolor: "grey.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    height: 20,
                                    width: "100%",
                                    sx: {
                                        bgcolor: "grey.100",
                                        my: "6px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                spacing: 2,
                                sx: {
                                    pt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    numberOfLine: 2,
                                    lastWidth: "25%"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            mt: 4,
                            px: 2,
                            py: 3,
                            borderColor: "grey.50",
                            borderWidth: 1,
                            borderStyle: "solid"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            numberOfLine: 2,
                            lastWidth: "50%"
                        })
                    }),
                    [
                        0,
                        1
                    ].map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            sx: {
                                pt: 5,
                                pb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        bgcolor: "grey.50"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "rectangular",
                                        height: 20,
                                        width: "100%",
                                        sx: {
                                            bgcolor: "grey.100",
                                            my: "6px"
                                        }
                                    })
                                }),
                                [
                                    0,
                                    1,
                                    2
                                ].map(function(key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        spacing: 1,
                                        sx: {
                                            pt: 4
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "body2",
                                            numberOfLine: 2
                                        })
                                    }, key);
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    pt: 8,
                    pb: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 44,
                    width: 212,
                    sx: {
                        borderRadius: 34
                    }
                })
            })
        ]
    });
};
var ResaleAppliedUserCell = function(param) {
    var itemResaleRaffle = param.itemResaleRaffle;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (!itemResaleRaffle) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CautionText, {
                type: "error",
                children: t("alreadyApplied", "すでに応募済みです。")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5,
                    pb: 7
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 244
                    },
                    href: generatePath(routerPages.ResaleRaffleDetail, {
                        itemId: itemResaleRaffle.item.id,
                        raffleId: itemResaleRaffle.id
                    }),
                    children: t("checkResaleApplication", "リセール応募詳細を確認する")
                })
            })
        ]
    });
};
var ResaleApplicationDetailContentCell = function(param) {
    var item = param.item;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleApplicationDetail").t;
    var formattedPrice = (0,react.useMemo)(function() {
        return getItemSkuPrice(item);
    }, [
        item
    ]).formattedPrice;
    var data = [
        {
            label: t("ticketPrice", "チケット価格"),
            value: t("ticketPriceValue", {
                price: formattedPrice || 0
            })
        },
        {
            label: t("exhibitNumber", "出品枚数"),
            value: t("exhibitNumberValue", {
                number: (item === null || item === void 0 ? void 0 : item.resaleOpenCount) || 0
            })
        },
        {
            label: t("applicationNumber", "応募枚数"),
            value: t("applicationNumberValue", {
                number: (item === null || item === void 0 ? void 0 : item.resaleRaffleAppliedCount) || 0
            })
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResaleItem, {
                title: t("ticketTitle", "本チケットは抽選販売となります"),
                Icon: dist.Icons.Error,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("ticketDesc")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                color: "text.secondary",
                                children: t("ticketNote")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        sx: {
                            borderRadius: 2,
                            borderColor: "grey.100",
                            borderWidth: 1,
                            borderStyle: "solid",
                            py: 4,
                            px: 5,
                            mb: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("applicationPeriod", "応募期間", {
                                    date: "".concat((item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.formattedStartedAt) || "").concat(item ? " 〜 " : "").concat((item === null || item === void 0 ? void 0 : (ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resalePeriod) === null || ref5 === void 0 ? void 0 : ref5.formattedEndedAt) || "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("nextLotteryDate", "次回抽選日時", {
                                    date: (0,dayjs/* nextRaffleDateTime */.N7)()
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("exhibitionContent", "チケット情報"),
                Icon: dist.Icons.Post,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: item === null || item === void 0 ? void 0 : item.title
                                }),
                                !!(item === null || item === void 0 ? void 0 : (ref6 = item.sku) === null || ref6 === void 0 ? void 0 : ref6.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: item === null || item === void 0 ? void 0 : (ref7 = item.sku) === null || ref7 === void 0 ? void 0 : ref7.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: item === null || item === void 0 ? void 0 : (ref8 = item.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : ref9.description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("exhibitInfo"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        pt: 5
                    },
                    spacing: 6,
                    children: data.map(function(param, index) {
                        var label = param.label, value = param.value;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: value
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationDetail/viewModel.ts



function ResaleApplicationDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleApplicationDetail(\n    $id: ID!\n    $itemId: String!\n    $userId: String\n    $skuId: String\n  ) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n    userActiveResaleItemRaffle(\n      itemId: $itemId\n      skuId: $skuId\n      userId: $userId\n    ) {\n      ...ItemResaleRaffleUserDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleApplicationDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleApplicationDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var itemId = router.query.itemId;
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var ref3;
    var ref4 = (0,useQuery/* useQuery */.aM)(ResaleApplicationDetail_viewModel_QUERY, {
        variables: {
            id: itemId,
            itemId: itemId,
            userId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }), data = ref4.data, loading = ref4.loading;
    var itemResaleRaffle = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.userActiveResaleItemRaffle)) {
            return null;
        }
        var _skuId;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.userActiveResaleItemRaffle), {
            item: setItemSku((ref = data.userActiveResaleItemRaffle) === null || ref === void 0 ? void 0 : ref.item, (_skuId = data.userActiveResaleItemRaffle.skuId) !== null && _skuId !== void 0 ? _skuId : skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.userActiveResaleItemRaffle,
        skuId
    ]);
    var item = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.item)) {
            return null;
        }
        var ref1;
        return setItemSku(data.item, (ref1 = (ref = data.userActiveResaleItemRaffle) === null || ref === void 0 ? void 0 : ref.skuId) !== null && ref1 !== void 0 ? ref1 : router.query.skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.item,
        data === null || data === void 0 ? void 0 : (ref1 = data.userActiveResaleItemRaffle) === null || ref1 === void 0 ? void 0 : ref1.skuId,
        router.query.skuId
    ]);
    return {
        state: {
            loading: loading,
            item: item,
            itemResaleRaffle: itemResaleRaffle
        },
        actions: {
            onSubmit: function() {
                router.push({
                    pathname: generatePath(routerPages.ResaleApplicationCreatePrecaution, {
                        itemId: itemId
                    }),
                    search: "".concat(skuId ? "?skuId=".concat(skuId) : "")
                });
            }
        }
    };
});
var ResaleApplicationDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleApplicationDetail_viewModel_templateObject(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez, utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh);

;// CONCATENATED MODULE: ./src/components/pages/ResaleApplicationDetail/index.tsx




/**
 * ResaleApplicationDetail Page
 * Implemented as a practical sample.
 */ var ResaleApplicationDetail = function() {
    var ref = ResaleApplicationDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleApplicationDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ExhibitionContentSkeleton/index.tsx




var ExhibitionContentSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "medium",
                width: "25%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "small",
                    numberOfLine: 5
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                height: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5,
                    pb: 8
                },
                spacing: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            numberOfLine: 2
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ExhibitionPeriodSkeleton/index.tsx




var ExhibitionPeriodSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: {
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 20,
                    width: "100%",
                    sx: {
                        bgcolor: "grey.100",
                        my: "6px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                numberOfLine: 2
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ResaleCategory/index.tsx




var ResaleCategory = function(param) {
    var isResaleAvailable = param.isResaleAvailable;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            size: "small",
            sx: {
                width: 76,
                height: 20,
                borderRadius: "2px",
                bgcolor: isResaleAvailable ? "primary.main" : "grey.100",
                py: 1,
                ".MuiChip-label": {
                    px: 0
                }
            },
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: isResaleAvailable ? "white" : "text.secondary",
                variant: "overline",
                children: isResaleAvailable ? t("duringExhibitionPeriod") : t("outsideExhibitionPeriod")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ExhibitionContent/index.tsx







var ExhibitionContent = function(param) {
    var title = param.title, skuName = param.skuName, _price = param.price, price = _price === void 0 ? 0 : _price, _formattedPrice = param.formattedPrice, formattedPrice = _formattedPrice === void 0 ? 0 : _formattedPrice, isResaleAvailable = param.isResaleAvailable, unusedCount = param.unusedCount, metadata = param.metadata;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    bgcolor: "grey.50",
                    py: 1,
                    px: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Post, {
                        fontSize: "small",
                        sx: {
                            color: "grey.600"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("exhibitionContent")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: 3,
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                children: title
                            }),
                            !!skuName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: skuName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCategory, {
                        isResaleAvailable: isResaleAvailable
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: metadata === null || metadata === void 0 ? void 0 : (ref = metadata.ticket) === null || ref === void 0 ? void 0 : ref.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5,
                    pb: 7
                },
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("ticketPrice")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    "\xa5",
                                    formattedPrice,
                                    "/1",
                                    t("perSheet")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("holdingQuantity")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    unusedCount,
                                    t("sheet")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: t("totalAmount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: [
                                    "\xa5",
                                    numeral_default()(unusedCount * price).format("0,0")
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ExhibitionPeriod/index.tsx





var ExhibitionPeriod = function(param) {
    var metadata = param.metadata;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    bgcolor: "grey.50",
                    py: 2,
                    px: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Timer, {
                        fontSize: "small",
                        sx: {
                            color: "grey.600"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("listingPeriod")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: 3,
                    pb: 7
                },
                children: [
                    (metadata === null || metadata === void 0 ? void 0 : (ref = metadata.ticket) === null || ref === void 0 ? void 0 : ref.resalePeriod) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: [
                            metadata === null || metadata === void 0 ? void 0 : (ref1 = metadata.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resalePeriod) === null || ref2 === void 0 ? void 0 : ref2.formattedStartedAt,
                            " 〜",
                            " ",
                            metadata === null || metadata === void 0 ? void 0 : (ref3 = metadata.ticket) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.resalePeriod) === null || ref4 === void 0 ? void 0 : ref4.formattedEndedAt
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("listingPeriodNote")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreate/template/TicketQuantityForm.tsx







var TicketQuantityForm = function(param) {
    var item = param.item, onSubmit = param.onSubmit, serials = param.serials;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    var ref2 = (0,react.useState)([]), selectedSerials = ref2[0], setSelectedSerials = ref2[1];
    var handleSelectSerial = (0,react.useCallback)(function(serialId) {
        setSelectedSerials(function(prevState) {
            return xor_default()(prevState, [
                serialId
            ]);
        });
    }, []);
    //整理番号が設定されているか判定
    var isTicketAdmission = !!(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.assignedNumberPrefix);
    if (!serials.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    bgcolor: "grey.50",
                    py: 2,
                    px: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Ticket, {
                        fontSize: "small",
                        sx: {
                            color: "grey.600"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t(isTicketAdmission ? "selectTicketNumber" : "selectTicketSerialNumber")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: 3,
                    pb: 7
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: t(isTicketAdmission ? "selectTicketNumberToSell" : "selectTicketSerialNumberToSell")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketContainer_TicketContainer, {
                            serials: serials,
                            selectedSerials: selectedSerials,
                            onSelectSerial: handleSelectSerial
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    pt: 3,
                    pb: 7
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    type: "submit",
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return onSubmit(selectedSerials);
                    },
                    disabled: !(item === null || item === void 0 ? void 0 : item.resaleEnabled) || !selectedSerials.length,
                    children: t("submit")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreate/template/index.tsx













var ResaleCreateTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    var ref3 = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleExhibit")), onClickHelp = ref3.onClick;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref4.generatePath, generateQueryPath = ref4.generateQueryPath, routerPages = ref4.routerPages, router = ref4.router, routerNames = ref4.routerNames;
    var ref5 = (0,react.useMemo)(function() {
        return getItemSkuPrice(state.item);
    }, [
        state.item
    ]), price = ref5.price, formattedPrice = ref5.formattedPrice;
    var _itemId, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title"),
            defaultBackPage: generateQueryPath(routerPages.OwnedItemDetail, {
                itemId: (_itemId = state.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
            }, {
                skuId: encodeSkuId((ref6 = (ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref6 !== void 0 ? ref6 : "")
            }),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                edge: "end",
                onClick: onClickHelp,
                color: "primary"
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ResaleCreate
            }),
            state.loading || !state.item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleTitleSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionContentSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionPeriodSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketNumberSkeletonCell, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleTitleCell, {}),
                    state.item.resaleEnabled && !state.isResaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notice, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionContent, {
                        title: state.item.title,
                        skuName: (ref2 = state.item.sku) === null || ref2 === void 0 ? void 0 : ref2.unitName,
                        metadata: state.item.metadata,
                        price: price,
                        unusedCount: state.unusedCount,
                        isResaleAvailable: !!state.item.resaleEnabled && !!state.isResaleAvailable,
                        formattedPrice: formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionPeriod, {
                        metadata: state.item.metadata
                    }),
                    state.item.resaleEnabled && state.isResaleAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketQuantityForm, {
                        item: state.item,
                        serials: state.serials,
                        onSubmit: function(value) {
                            return router.push({
                                pathname: generatePath(routerPages.ResaleCreatePrecaution, {
                                    itemId: state.itemId
                                }),
                                search: "?serialIds=".concat(value.toString()).concat(state.skuId ? "&skuId=".concat(state.skuId) : "")
                            });
                        }
                    })
                ]
            })
        ]
    });
};
var ResaleTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: t("resaleInfo")
        })
    });
};
var ResaleTitleSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h4",
                width: "50%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h4"
                    })
                ]
            })
        ]
    });
};
var Notice = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            p: 2,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "info.main",
            mb: 7
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            sx: {
                color: "info.main"
            },
            children: t("resaleNote")
        })
    });
};
var TicketNumberSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 2,
                sx: {
                    pt: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: "50%",
                        height: 38
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "caption",
                        width: "25%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    pt: 9,
                    pb: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: 212,
                    height: 44,
                    sx: {
                        borderRadius: 34
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreate/viewModel.ts

function ResaleCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleCreate($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n    portfolio(id: $id) {\n      ...PortfolioConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var itemId = router.query.itemId;
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var ref2 = (0,useQuery/* useQuery */.aM)(ResaleCreate_viewModel_QUERY, {
        variables: {
            id: itemId,
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }), data = ref2.data, loading = ref2.loading;
    var portfolio = (0,react.useMemo)(function() {
        if (!skuId) {
            return data === null || data === void 0 ? void 0 : data.portfolio;
        }
        var ref;
        return convertPortfolioItemToSku((ref = data === null || data === void 0 ? void 0 : data.portfolio) !== null && ref !== void 0 ? ref : null, skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.portfolio,
        skuId
    ]);
    var item = (0,react.useMemo)(function() {
        if (!skuId) {
            return data === null || data === void 0 ? void 0 : data.item;
        }
        return setItemSku(data === null || data === void 0 ? void 0 : data.item, skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.item,
        skuId
    ]);
    var isResaleAvailable = (0,react.useMemo)(function() {
        if (!skuId) {
            return portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.isResaleAvailable;
        }
        return portfolio === null || portfolio === void 0 ? void 0 : portfolio.item.skuIsResaleAvailable;
    }, [
        skuId,
        portfolio
    ]);
    var ref3, _length;
    return {
        state: {
            item: item !== null && item !== void 0 ? item : null,
            itemId: itemId,
            skuId: skuId,
            loading: loading,
            serials: (ref3 = portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials) !== null && ref3 !== void 0 ? ref3 : [],
            unusedCount: (_length = portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(serial) {
                var ref, ref1;
                return !!((ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : ref1.canUseTicket);
            }).length) !== null && _length !== void 0 ? _length : 0,
            isResaleAvailable: isResaleAvailable
        },
        actions: {}
    };
});
var ResaleCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleCreate_viewModel_templateObject(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez, utoniq_core_schema/* PortfolioConnectionFragmentDoc */.umN);

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreate/index.tsx




/**
 * ResaleCreate Page
 * Implemented as a practical sample.
 */ var ResaleCreate = function() {
    var ref = ResaleCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreateTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateCompletion/template/index.tsx






var ResaleCreateCompletionTemplate = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreateCompletion").t;
    var windowHeight = (0,dist_module/* useWindowHeight */.AS)();
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title")
        },
        sx: {
            minHeight: "unset",
            height: windowHeight
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            sx: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("message")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        pt: 6,
                        align: "center",
                        children: t("messageDesc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        mt: 6,
                        py: 5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                href: generatePath(routerPages.ResaleManagement),
                                sx: {
                                    width: 244,
                                    margin: "auto"
                                },
                                color: "primary",
                                children: t("resaleManagementScreen")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                href: routerPages.Top,
                                size: "large",
                                sx: {
                                    width: 244,
                                    margin: "auto"
                                },
                                color: "primary",
                                children: t("topPage")
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateCompletion/viewModel.ts


/**
 *
 */ var ResaleCreateCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateCompletion/index.tsx




/**
 * ResaleCreateCompletion Page
 * Implemented as a practical sample.
 */ var ResaleCreateCompletion = function() {
    var ref = ResaleCreateCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreateCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateConfirmation/template/index.tsx












var ResaleCreateConfirmationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreateConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath, routerNames = ref.routerNames;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleExhibit")), onClickHelp = ref1.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title"),
            defaultBackPage: generatePath(routerPages.ResaleApplicationCreate, {
                itemId: router.query.itemId
            }),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                onClick: onClickHelp,
                edge: "end",
                color: "primary"
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ResaleCreateConfirmation
            }),
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleConfirmationSkeletonCell, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ResaleTitleCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ConfirmationContentCell, {
                        item: state.item,
                        serials: state.serials
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SubmitButtonCell, {
                        submitting: state.submitting,
                        onSubmit: onSubmit
                    })
                ]
            })
        ]
    });
};
var template_ResaleTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreateConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: t("resaleInfo")
        })
    });
};
var ResaleConfirmationSkeletonCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h4",
                width: "25%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 8,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 20,
                    width: "100%",
                    sx: {
                        bgcolor: "grey.100",
                        my: "6px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 7
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        numberOfLine: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 4
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        numberOfLine: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: "60px",
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 20,
                    width: "100%",
                    sx: {
                        bgcolor: "grey.100",
                        my: "6px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "small",
                numberOfLine: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: "34px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            pt: 8,
                            pb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                height: 44,
                                width: 212,
                                sx: {
                                    borderRadius: 34
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "15%",
                                sx: {
                                    mt: 2
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var template_ConfirmationContentCell = function(param) {
    var item = param.item, serials = param.serials;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreateConfirmation").t;
    var ticketQuantity = serials.length;
    //整理番号が設定されているか判定
    var isTicketAdmission = !!(item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : ref1.assignedNumberPrefix);
    var price = (0,react.useMemo)(function() {
        return getItemSkuPrice(item);
    }, [
        item
    ]).price;
    var data = [
        {
            label: t("ticketPrice"),
            value: "￥".concat(numeral_default()(price * ticketQuantity).format("0,0"))
        },
        {
            // リセール手数料 = チケット代金 * 代金に対する割合 * 枚数
            label: t("resaleFee"),
            value: "-\xa5".concat(numeral_default()(price * ((item === null || item === void 0 ? void 0 : (ref2 = item.metadata) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticket) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.resaleFee) === null || ref4 === void 0 ? void 0 : ref4.feeRatePerTicket) || 0) * ticketQuantity).format("0,0"))
        },
        {
            // 振り込み手数料 = 1注文あたりの振り込み手数料
            label: t("transferFee"),
            value: "-\xa5".concat(numeral_default()((item === null || item === void 0 ? void 0 : (ref5 = item.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.resaleFee) === null || ref7 === void 0 ? void 0 : ref7.bankTransferFeePerOrder) || 0).format("0,0"))
        }, 
    ];
    var totalAmount = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!price) {
            return 0;
        }
        return numeral_default()(price * ticketQuantity * 0.9 - ((item === null || item === void 0 ? void 0 : (ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resaleFee) === null || ref2 === void 0 ? void 0 : ref2.bankTransferFeePerOrder) || 0)).format("0,0");
    }, [
        item === null || item === void 0 ? void 0 : (ref8 = item.metadata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.ticket) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.resaleFee) === null || ref10 === void 0 ? void 0 : ref10.bankTransferFeePerOrder,
        price,
        ticketQuantity, 
    ]);
    var ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        color: "text.secondary",
                        children: t("exhibitionContent")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("ticketName")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            !!(item === null || item === void 0 ? void 0 : (ref11 = item.sku) === null || ref11 === void 0 ? void 0 : ref11.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: item === null || item === void 0 ? void 0 : (ref12 = item.sku) === null || ref12 === void 0 ? void 0 : ref12.unitName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t(isTicketAdmission ? "serialTicketNumberList" : "serialNumberList")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                                    dense: true,
                                    sx: {
                                        listStyleType: "disc",
                                        pl: 5
                                    },
                                    children: serials.map(function(serial) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                            disableGutters: true,
                                            sx: {
                                                display: "list-item"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: (ref13 = (ref = serial.serial) === null || ref === void 0 ? void 0 : ref.formattedAssignedNumber) !== null && ref13 !== void 0 ? ref13 : serial.formattedSerialNumber
                                            })
                                        }, serial.id);
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        sx: {
                            px: 2,
                            py: 1,
                            bgcolor: "grey.50"
                        },
                        color: "text.secondary",
                        children: t("ticketPayment")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            children: t("ticketPaymentDesc")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 3
                        },
                        children: [
                            data.map(function(param, index) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            "\xa5",
                                            totalAmount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var template_SubmitButtonCell = function(param) {
    var submitting = param.submitting, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreateConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 3,
            alignItems: "center",
            sx: {
                pt: 9,
                pb: 7
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    loading: submitting,
                    onClick: onSubmit,
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.ResaleApplicationCreate, {
                            itemId: router.query.itemId
                        }));
                    },
                    children: t("back")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateConfirmation/viewModel.ts




function ResaleCreateConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleCreateConfirmation($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n    portfolio(id: $id) {\n      ...PortfolioConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleCreateConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleCreateConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateResaleItem($inputs: CreateResaleItemInput!) {\n    createResaleItem(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ResaleCreateConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleCreateConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var itemId = router.query.itemId;
    var serialIds = router.query.serialIds.split(",").filter(function(id) {
        return !!id;
    });
    var skuId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId;
    var ref3 = (0,useQuery/* useQuery */.aM)(ResaleCreateConfirmation_viewModel_QUERY, {
        variables: {
            id: itemId,
            skuId: decodeSkuId(skuId !== null && skuId !== void 0 ? skuId : "") || undefined
        }
    }), data = ref3.data, loading = ref3.loading;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_RESALE_ITEM), 2), createResaleItem = ref4[0], ref5 = ref4[1], submitting = ref5.loading;
    var portfolio = (0,react.useMemo)(function() {
        if (skuId) {
            return data === null || data === void 0 ? void 0 : data.portfolio;
        }
        var ref;
        return convertPortfolioItemToSku((ref = data === null || data === void 0 ? void 0 : data.portfolio) !== null && ref !== void 0 ? ref : null, skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.portfolio,
        skuId
    ]);
    var item = (0,react.useMemo)(function() {
        if (!skuId) {
            return data === null || data === void 0 ? void 0 : data.item;
        }
        return setItemSku(data === null || data === void 0 ? void 0 : data.item, skuId);
    }, [
        data === null || data === void 0 ? void 0 : data.item,
        skuId
    ]);
    var ref6;
    return {
        state: {
            loading: loading,
            submitting: submitting,
            item: item !== null && item !== void 0 ? item : null,
            serials: (ref6 = portfolio === null || portfolio === void 0 ? void 0 : (ref1 = portfolio.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(serial) {
                return serialIds.findIndex(function(id) {
                    return id === serial.id;
                }) >= 0;
            })) !== null && ref6 !== void 0 ? ref6 : []
        },
        actions: {
            onSubmit: function onSubmit() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!(portfolio === null || portfolio === void 0 ? void 0 : portfolio.serials)) return [
                            2
                        ];
                        createResaleItem({
                            variables: {
                                inputs: {
                                    itemId: itemId,
                                    serialIds: serialIds,
                                    skuId: skuId ? decodeSkuId(skuId) : null
                                }
                            }
                        }).then(function() {
                            return router.replace(generatePath(routerPages.ResaleCreateCompletion, {
                                itemId: itemId
                            }));
                        }).catch(function(e) {
                            return showError(e);
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var ResaleCreateConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleCreateConfirmation_viewModel_templateObject(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez, utoniq_core_schema/* PortfolioConnectionFragmentDoc */.umN);
var CREATE_RESALE_ITEM = (0,lib/* gql */.Ps)(ResaleCreateConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreateConfirmation/index.tsx




/**
 * ResaleCreateConfirmation Page
 * Implemented as a practical sample.
 */ var ResaleCreateConfirmation = function() {
    var ref = ResaleCreateConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreateConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreatePrecaution/template/index.tsx











var ResaleCreatePrecautionTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath, routerNames = ref.routerNames;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resaleExhibit")), onClickHelp = ref1.onClick;
    var _itemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title"),
            defaultBackPage: generatePath(routerPages.ResaleCreate, {
                itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "#"
            }),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                onClick: onClickHelp,
                edge: "end",
                color: "primary"
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ResaleCreatePrecaution
            }),
            state.loading || !state.item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResalePrecautionSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreatePrecaution_template_ResaleTitleCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Notice, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrecautionContentCell, {
                        item: state.item
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrecautionNoteCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreatePrecaution_template_SubmitButtonCell, {})
                ]
            })
        ]
    });
};
var ResaleCreatePrecaution_template_ResaleTitleCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h4",
            children: t("resaleInfo")
        })
    });
};
var ResalePrecautionSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h4",
                width: "25%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 6,
                    borderStyle: "solid",
                    borderWidth: 1,
                    borderColor: "grey.100",
                    py: 2,
                    px: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        width: "90%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 6
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    pt: 8,
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "caption",
                        width: "25%",
                        sx: {
                            mb: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 44,
                        width: 212,
                        sx: {
                            borderRadius: 34
                        }
                    })
                ]
            })
        ]
    });
};
var template_Notice = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            p: 2,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "info.main",
            mb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            sx: {
                color: "info.main"
            },
            children: t("resaleNote")
        })
    });
};
var PrecautionContentCell = function(param) {
    var item = param.item;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    var price = (0,react.useMemo)(function() {
        return getItemSkuPrice(item);
    }, [
        item
    ]).price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 9,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                px: 2,
                                py: 1,
                                bgcolor: "grey.50"
                            },
                            color: "text.secondary",
                            children: t("listingFee")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("listingFeeDesc", {
                                    // チケット代金 * リセール手数料の割合
                                    listingFee: price * (((ref = item.metadata) === null || ref === void 0 ? void 0 : (ref1 = ref.ticket) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resaleFee) === null || ref2 === void 0 ? void 0 : ref2.feeRatePerTicket) || 0),
                                    feeRatePerTicket: (((ref3 = item.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticket) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.resaleFee) === null || ref5 === void 0 ? void 0 : ref5.feeRatePerTicket) || 0) * 100,
                                    bankTransferFeePerOrder: (ref6 = item.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.ticket) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.resaleFee) === null || ref8 === void 0 ? void 0 : ref8.bankTransferFeePerOrder
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                px: 2,
                                py: 1,
                                bgcolor: "grey.50"
                            },
                            color: "text.secondary",
                            children: t("ticketPayment")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("ticketPaymentDesc")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: t("ticketPaymentNote")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            sx: {
                                px: 2,
                                py: 1,
                                bgcolor: "grey.50"
                            },
                            color: "text.secondary",
                            children: t("listingCancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                                dense: true,
                                sx: {
                                    listStyleType: "disc",
                                    pl: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        sx: {
                                            display: "list-item"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t("listingCancelDesc1")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                                        disableGutters: true,
                                        sx: {
                                            display: "list-item"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: t("listingCancelDesc2")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var PrecautionNoteCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 9
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1,
                sx: {
                    bgcolor: "grey.50",
                    py: 2,
                    px: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                        fontSize: "small",
                        sx: {
                            color: "grey.600"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("note")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                spacing: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                    dense: true,
                    sx: {
                        listStyleType: "disc",
                        pl: 5
                    },
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ].map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            disableGutters: true,
                            sx: {
                                display: "list-item"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("noteDesc" + item)
                            })
                        }, item);
                    })
                })
            })
        ]
    });
};
var ResaleCreatePrecaution_template_SubmitButtonCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleCreatePrecaution").t;
    var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages, router = ref1.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 2,
            alignItems: "center",
            sx: {
                pt: 3,
                pb: 7
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checked,
                        onClick: function() {
                            return setChecked(function(prevState) {
                                return !prevState;
                            });
                        }
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("checkBoxLabel")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    disabled: !checked,
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        var ref, ref1;
                        return router.push({
                            pathname: generatePath(routerPages.ResaleCreateConfirmation, {
                                itemId: router.query.itemId
                            }),
                            search: "?serialIds=".concat(router.query.serialIds).concat(((ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId) ? "&skuId=".concat((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.skuId) : "")
                        });
                    },
                    children: t("submit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        pt: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        size: "small",
                        sx: {
                            width: 212,
                            display: "block"
                        },
                        onClick: function() {
                            return router.goBack(generatePath(routerPages.ResaleCreate, {
                                itemId: router.query.itemId
                            }));
                        },
                        children: t("back")
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreatePrecaution/viewModel.ts

function ResaleCreatePrecaution_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleCreatePrecaution($id: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleCreatePrecaution_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 *
 */ var ResaleCreatePrecaution_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _skuId;
    var ref = (0,useQuery/* useQuery */.aM)(ResaleCreatePrecaution_viewModel_QUERY, {
        variables: {
            id: router.query.itemId,
            skuId: decodeSkuId((_skuId = router.query.skuId) !== null && _skuId !== void 0 ? _skuId : "") || undefined
        }
    }), data = ref.data, loading = ref.loading;
    var ref1;
    return {
        state: {
            item: setItemSku((ref1 = data === null || data === void 0 ? void 0 : data.item) !== null && ref1 !== void 0 ? ref1 : null, router.query.skuId),
            loading: loading
        },
        actions: {}
    };
});
var ResaleCreatePrecaution_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleCreatePrecaution_viewModel_templateObject(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);

;// CONCATENATED MODULE: ./src/components/pages/ResaleCreatePrecaution/index.tsx




/**
 * ResaleCreatePrecaution Page
 * Implemented as a practical sample.
 */ var ResaleCreatePrecaution = function() {
    var ref = ResaleCreatePrecaution_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCreatePrecautionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ResaleTag/index.tsx





var ResaleItemStatus;
(function(ResaleItemStatus) {
    ResaleItemStatus["Open"] = "10_open";
    ResaleItemStatus["Matched"] = "20_matched";
    ResaleItemStatus["NoMatched"] = "30_no_match";
    ResaleItemStatus["Sold"] = "40_sold";
    ResaleItemStatus["Paid"] = "50_paid";
    ResaleItemStatus["Canceled"] = "60_canceled";
})(ResaleItemStatus || (ResaleItemStatus = {}));
var ResaleRaffleStatus;
(function(ResaleRaffleStatus) {
    ResaleRaffleStatus["Win"] = "10_win";
    ResaleRaffleStatus["Applied"] = "20_applied";
    ResaleRaffleStatus["Invalid"] = "30_invalid";
    ResaleRaffleStatus["Canceled"] = "40_canceled";
    ResaleRaffleStatus["Lost"] = "50_lost";
    ResaleRaffleStatus["Purchased"] = "60_purchased";
})(ResaleRaffleStatus || (ResaleRaffleStatus = {}));
var ResaleTag = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleManagement").t;
    var ref = (0,react.useMemo)(function() {
        switch(status){
            case ResaleItemStatus.Open:
            case ResaleRaffleStatus.Applied:
            default:
                return {
                    bgcolor: "primary.main",
                    color: "white"
                };
            case ResaleItemStatus.Paid:
            case ResaleItemStatus.Sold:
                return {
                    bgcolor: "secondary.main",
                    color: "white"
                };
            case ResaleRaffleStatus.Win:
                return {
                    bgcolor: "error.main",
                    color: "white"
                };
            case ResaleItemStatus.Matched:
                return {
                    bgcolor: "primary.dark",
                    color: "white"
                };
            case ResaleRaffleStatus.Invalid:
            case ResaleRaffleStatus.Lost:
            case ResaleItemStatus.NoMatched:
            case ResaleItemStatus.Canceled:
                return {
                    bgcolor: "grey.100",
                    color: "text.secondary"
                };
            case ResaleRaffleStatus.Purchased:
                return {
                    bgcolor: "primary.dark",
                    color: "white"
                };
        }
    }, [
        status
    ]), bgcolor = ref.bgcolor, color = ref.color;
    if (status === ResaleRaffleStatus.Purchased) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            size: "small",
            sx: {
                height: 20,
                borderRadius: "10px",
                bgcolor: bgcolor,
                py: 1,
                px: 4,
                ".MuiChip-label": {
                    px: 0
                }
            },
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                color: color,
                variant: "subtitle2",
                children: t(status)
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleDetail/template/index.tsx













var ResaleDetailTemplate = function(param) {
    var state = param.state, onCancelListing = param.onCancelListing;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleDetail").t;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        customNavigation: state.resaleItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleDetail_template_FixedBottomCell, {
            submitting: state.submitting,
            handleOpenModal: function() {
                return setModalOpen(true);
            },
            resaleItem: state.resaleItem
        }) : null,
        header: {
            back: true,
            defaultBackPage: generatePath(routerPages.ResaleManagement),
            title: t("title")
        },
        children: [
            state.loading || !state.resaleItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSkeleton, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleDetail_template_StatusCell, {
                        status: state.resaleItem.status
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleDetail_template_DetailCell, {
                        resaleItem: state.resaleItem
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: modalOpen,
                onClose: function() {
                    return setModalOpen(false);
                },
                title: t("confirmCancelListingTitle"),
                content: t("confirmCancelListingDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        width: 212
                    },
                    onClick: function() {
                        onCancelListing().then(function() {
                            return setModalOpen(false);
                        });
                    },
                    disabled: !state.resaleItem,
                    loading: state.submitting,
                    children: t("confirm")
                }),
                cancelText: t("close")
            })
        ]
    });
};
var ResaleDetail_template_StatusCell = function(param) {
    var status = param.status;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleDetail").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("appHelp")).onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 3,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                        sx: {
                            color: "primary.main"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        children: t("".concat(status, "Status"))
                    })
                ]
            }),
            status !== ResaleItemStatus.Matched ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("".concat(status, "StatusDesc"))
                    }),
                    status === ResaleItemStatus.Sold && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            pt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: [
                                t("soldCaption1"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "primary.main",
                                    sx: {
                                        cursor: "pointer"
                                    },
                                    onClick: onClick,
                                    children: t("soldCaptionLink")
                                }),
                                t("soldCaption2")
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        mt: 7,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: "primary.main"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        color: "primary.main",
                        sx: {
                            py: 2,
                            px: 4
                        },
                        children: t("notCancelListingDesc")
                    })
                })
            })
        ]
    });
};
var StatusSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 7
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "h6",
                width: "60%"
            })
        })
    });
};
var ResaleDetail_template_DetailCell = function(param) {
    var resaleItem = param.resaleItem;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleDetail").t;
    var ref18 = (0,react.useMemo)(function() {
        return getItemSkuPrice(resaleItem.item);
    }, [
        resaleItem.item
    ]), price = ref18.price, formattedPrice = ref18.formattedPrice;
    var data = [
        {
            label: t("ticketPrice", "価格"),
            value: "￥".concat(numeral_default()(resaleItem.totalItemPrice).format("0,0"))
        },
        {
            // リセール手数料 = チケット代金 * 代金に対する割合 * 枚数
            label: t("resaleFee", "販売手数料"),
            value: "-\xa5".concat(numeral_default()(price * (((ref = resaleItem.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.feeRatePerTicket) || 0) * resaleItem.itemCount).format("0,0"))
        },
        {
            // 振り込み手数料 = 1件あたりの振り込み手数料
            label: t("transferFee", "振込手数料"),
            value: "-\xa5".concat(numeral_default()(((ref4 = resaleItem.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.resaleFee) === null || ref7 === void 0 ? void 0 : ref7.bankTransferFeePerOrder) || 0).format("0,0"))
        }, 
    ];
    var totalAmount = (0,react.useMemo)(function() {
        return numeral_default()(data.reduce(function(acc, curr) {
            var value = curr.value ? parseInt(curr.value.replace("￥", "").replace("\xa5", "").replace(/,/g, ""), 10) : 0;
            return acc + value;
        }, 0)).format("0,0");
    }, [
        (ref8 = resaleItem.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.metadata) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.ticket) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.resaleFee) === null || ref11 === void 0 ? void 0 : ref11.bankTransferFeePerOrder,
        resaleItem.item.price,
        resaleItem.itemCount, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("ticketInfo", "チケット情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: resaleItem.item.title
                                }),
                                !!(resaleItem === null || resaleItem === void 0 ? void 0 : (ref12 = resaleItem.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.sku) === null || ref13 === void 0 ? void 0 : ref13.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: resaleItem === null || resaleItem === void 0 ? void 0 : (ref14 = resaleItem.item) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.sku) === null || ref15 === void 0 ? void 0 : ref15.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleTag, {
                                    status: resaleItem.status
                                }),
                                resaleItem.status === ResaleItemStatus.Paid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    color: "primary.main",
                                    variant: "subtitle2",
                                    children: t("paid", "振込完了")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                pt: 3
                            },
                            children: (ref16 = resaleItem.item.metadata) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.ticket) === null || ref17 === void 0 ? void 0 : ref17.description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("exhibitionInfo", "出品情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketPrice", "価格")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "\xa5",
                                        formattedPrice,
                                        "/1",
                                        t("perSheet", "枚")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("holdingQuantity", "出品枚数")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        resaleItem.itemCount,
                                        t("sheet")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("exhibitionDate", "出品日時")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: resaleItem.formattedListedAt
                                })
                            ]
                        })
                    ]
                })
            }),
            [
                ResaleItemStatus.Matched,
                ResaleItemStatus.Open,
                ResaleItemStatus.Paid,
                ResaleItemStatus.Sold, 
            ].includes(resaleItem.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("paymentResalePrice", "リセール代金のお支払い"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 3
                    },
                    children: [
                        data.map(function(param, index) {
                            var value = param.value, label = param.label;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        sx: {
                                            py: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: value
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            sx: {
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("total", "合計")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: [
                                        "\xa5",
                                        totalAmount
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var DetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 2,
                        lastWidth: "25%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "body2",
                    numberOfLine: 5
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 6
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 9
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 6
                    })
                ]
            })
        ]
    });
};
var ResaleDetail_template_FixedBottomCell = function(param) {
    var submitting = param.submitting, resaleItem = param.resaleItem, handleOpenModal = param.handleOpenModal;
    var status = resaleItem === null || resaleItem === void 0 ? void 0 : resaleItem.status;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var ref1 = (0,react.useMemo)(function() {
        switch(status){
            case ResaleItemStatus.Open:
            case ResaleItemStatus.Matched:
                return {
                    btnText: t("cancelListing"),
                    variant: "outlined",
                    disabled: status === ResaleItemStatus.Matched,
                    onClick: function onClick() {
                        handleOpenModal();
                    }
                };
            case ResaleItemStatus.Canceled:
            case ResaleItemStatus.Sold:
            case ResaleItemStatus.NoMatched:
            default:
                return {
                    btnText: t("viewTicketDetail"),
                    variant: "contained",
                    disabled: false,
                    onClick: function onClick() {
                        var ref;
                        router.push({
                            pathname: generatePath(routerPages.OwnedItemDetail, {
                                itemId: resaleItem === null || resaleItem === void 0 ? void 0 : (ref = resaleItem.item) === null || ref === void 0 ? void 0 : ref.id
                            }),
                            search: "".concat((resaleItem === null || resaleItem === void 0 ? void 0 : resaleItem.skuId) ? "?skuId=".concat(encodeSkuId(resaleItem.skuId)) : "")
                        });
                    }
                };
        }
    }, [
        status,
        t,
        submitting
    ]), btnText = ref1.btnText, variant = ref1.variant, disabled = ref1.disabled, onClick = ref1.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        sx: {
            py: 4,
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: variant,
            disabled: disabled,
            size: "large",
            sx: {
                width: 244
            },
            onClick: onClick,
            children: btnText
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleDetail/viewModel.ts






function ResaleDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleDetail($id: ID!, $skuId: String) {\n    resaleItem(id: $id) {\n      ...ResaleItemBox\n    }\n    user {\n      ...UserBankAccount\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation cancelResaleItem($inputs: CancelResaleItemInput!, $skuId: String) {\n    cancelResaleItem(inputs: $inputs) {\n      ...ResaleItemBox\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var resaleItemId = router.query.resaleItemId;
    var ref = (0,useQuery/* useQuery */.aM)(ResaleDetail_viewModel_QUERY, {
        variables: {
            id: resaleItemId
        }
    }), data = ref.data, loading = ref.loading;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_RESALE_ITEM), 2), cancelResaleItem = ref1[0], ref2 = ref1[1], submitting = ref2.loading;
    var resaleItem = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.resaleItem)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.resaleItem), {
            item: setItemSku(data === null || data === void 0 ? void 0 : (ref = data.resaleItem) === null || ref === void 0 ? void 0 : ref.item, data.resaleItem.skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.resaleItem
    ]);
    return {
        state: {
            loading: loading,
            submitting: submitting,
            resaleItem: resaleItem,
            user: data === null || data === void 0 ? void 0 : data.user
        },
        actions: {
            onCancelListing: function onCancelListing() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    cancelResaleItem({
                                        variables: {
                                            inputs: {
                                                resaleId: resaleItemId
                                            }
                                        }
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ResaleDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleDetail_viewModel_templateObject(), utoniq_core_schema/* ResaleItemBoxFragmentDoc */.tXg, utoniq_core_schema/* UserBankAccountFragmentDoc */.mXB);
var CANCEL_RESALE_ITEM = (0,lib/* gql */.Ps)(ResaleDetail_viewModel_templateObject1(), utoniq_core_schema/* ResaleItemBoxFragmentDoc */.tXg);

;// CONCATENATED MODULE: ./src/components/pages/ResaleDetail/index.tsx




/**
 * ResaleDetail Page
 * Implemented as a practical sample.
 */ var ResaleDetail = function() {
    var ref = ResaleDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ResaleItemBox/index.tsx








var ResaleItemBox = function(param) {
    var resaleItem = param.resaleItem;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleManagement").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var data = (0,react.useMemo)(function() {
        if (!isResaleRaffle(resaleItem)) {
            return [
                {
                    label: t("exhibitionDate"),
                    value: resaleItem.formattedListedAt
                },
                {
                    label: t("exhibitionPrice"),
                    value: "\xa5".concat(resaleItem.formattedTotalItemPrice)
                },
                {
                    label: t("exhibitionNumber"),
                    value: resaleItem.itemCount
                }, 
            ];
        }
        if (resaleItem.status === ResaleRaffleStatus.Purchased) {
            return [
                {
                    label: t("purchaseDate"),
                    value: resaleItem.formattedCreatedAt
                },
                {
                    label: t("purchasePrice"),
                    value: "\xa5".concat(resaleItem.formattedTotalItemPrice)
                },
                {
                    label: t("purchaseNumber"),
                    value: resaleItem.itemCount
                }, 
            ];
        }
        return [
            {
                label: t("applicationDate"),
                value: resaleItem.formattedCreatedAt
            },
            {
                label: t("applicationPrice"),
                value: "\xa5".concat(resaleItem.formattedTotalItemPrice)
            },
            {
                label: t("applicationNumber"),
                value: resaleItem.itemCount
            }, 
        ];
    }, [
        resaleItem,
        t
    ]);
    var href = (0,react.useMemo)(function() {
        if (!isResaleRaffle(resaleItem)) {
            return generatePath(routerPages.ResaleDetail, {
                resaleItemId: resaleItem.id
            });
        }
        return generatePath(routerPages.ResaleRaffleDetail, {
            itemId: resaleItem.item.id,
            raffleId: resaleItem.id
        });
    }, [
        generatePath,
        resaleItem
    ]);
    var skuName = (0,react.useMemo)(function() {
        var ref;
        var ref1, ref2;
        return (ref2 = (ref = setItemSku(resaleItem === null || resaleItem === void 0 ? void 0 : resaleItem.item, (ref1 = resaleItem === null || resaleItem === void 0 ? void 0 : resaleItem.skuId) !== null && ref1 !== void 0 ? ref1 : null).sku) === null || ref === void 0 ? void 0 : ref.unitName) !== null && ref2 !== void 0 ? ref2 : "";
    }, [
        resaleItem
    ]);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 4
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 1,
                            children: [
                                resaleItem.status !== ResaleRaffleStatus.Purchased && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleTag, {
                                            status: resaleItem.status
                                        }),
                                        resaleItem.status === ResaleItemStatus.Paid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            color: "primary",
                                            children: t("transferCompleted")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                    variant: "h5",
                                    children: resaleItem.item.title
                                }),
                                !!skuName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(2),
                                    variant: "caption",
                                    children: skuName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: data.map(function(param, index) {
                                        var label = param.label, value = param.value;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "overline",
                                                    children: value
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            size: "medium-small",
                            src: (ref2 = (ref = resaleItem.item.thumbnail.front) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref2 !== void 0 ? ref2 : ""
                        })
                    ]
                })
            })
        })
    });
};
function isResaleRaffle(resale) {
    return "createdAt" in resale;
}

;// CONCATENATED MODULE: ./src/components/organisms/item/ResaleItemBoxSkeleton/index.tsx



var ResaleItemBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
        elevation: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
            sx: {
                p: 5,
                "&:last-child": {
                    pb: 5
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        sx: {
                            pt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "25%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "medium",
                                width: "50%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        flex: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "small"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        width: 72,
                        height: 121
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleManagement/template/index.tsx












var ResaleManagementTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleManagement").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    var tabs = (0,react.useMemo)(function() {
        return [
            {
                label: t("listed"),
                value: "listed"
            },
            {
                label: t("raffle"),
                value: "raffle"
            },
            {
                label: t("purchased"),
                value: "purchased"
            }, 
        ];
    }, [
        t
    ]);
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(newValue) {
            var tabs;
            return (0,tslib_es6.__generator)(this, function(_state) {
                tabs = {
                    1: "raffle",
                    2: "purchased"
                };
                router.replace(generatePath(routerPages.ResaleManagement, {
                    tab: tabs[newValue]
                }));
                return [
                    2
                ];
            });
        });
        return function(newValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        generatePath,
        router,
        routerPages.ResaleManagement
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ResaleManagement
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: routerPages.Management,
                    title: t("title")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Tabs, {
                    value: state.tab,
                    onChange: handleChangeTab,
                    disableAnimateTransitions: true,
                    labels: tabs.map(function(param) {
                        var label = param.label;
                        return label;
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCell, {
                            type: "listed",
                            resales: state.resales,
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            onFetchMore: onFetchMore,
                            onFilter: onFilter,
                            filter: state.filter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCell, {
                            type: "raffle",
                            resales: state.resaleRaffles,
                            loading: state.loading,
                            hasNextPage: state.hasNextPageRaffles,
                            onFetchMore: onFetchMore,
                            onFilter: onFilter,
                            filter: state.filter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleCell, {
                            type: "purchased",
                            resales: state.resaleRaffles,
                            loading: state.loading,
                            hasNextPage: state.hasNextPageRaffles,
                            onFetchMore: onFetchMore,
                            onFilter: onFilter,
                            filter: state.filter
                        })
                    ]
                })
            })
        ]
    });
};
var ResaleCell = function(param) {
    var type = param.type, resales = param.resales, loading = param.loading, hasNextPage = param.hasNextPage, filter = param.filter, onFetchMore = param.onFetchMore, onFilter = param.onFilter;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleManagement").t;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var options = (0,react.useMemo)(function() {
        if (type === "listed") {
            return [
                {
                    label: t("all"),
                    value: undefined,
                    param: "all"
                },
                {
                    label: t("exhibiting"),
                    value: [
                        ResaleItemStatus.Open,
                        ResaleItemStatus.Matched
                    ],
                    param: "exhibiting"
                },
                {
                    label: t("failedToSell"),
                    value: [
                        ResaleItemStatus.NoMatched
                    ],
                    param: "failedToSell"
                },
                {
                    label: t("sold"),
                    value: [
                        ResaleItemStatus.Sold,
                        ResaleItemStatus.Paid
                    ],
                    param: "sold"
                },
                {
                    label: t("cancel"),
                    value: [
                        ResaleItemStatus.Canceled
                    ],
                    param: "cancel"
                }, 
            ];
        }
        return [
            {
                label: t("all"),
                value: [
                    ResaleRaffleStatus.Win,
                    ResaleRaffleStatus.Applied,
                    ResaleRaffleStatus.Lost,
                    ResaleRaffleStatus.Invalid,
                    ResaleRaffleStatus.Canceled, 
                ],
                param: "whole"
            },
            {
                label: t("waitingPayment"),
                value: [
                    ResaleRaffleStatus.Win
                ],
                param: "waitingPayment"
            },
            {
                label: t("waitingLottery"),
                value: [
                    ResaleRaffleStatus.Applied
                ],
                param: "waitingLottery"
            },
            {
                label: t("lost"),
                value: [
                    ResaleRaffleStatus.Lost
                ],
                param: "lost"
            },
            {
                label: t("invalid"),
                value: [
                    ResaleRaffleStatus.Invalid
                ],
                param: "invalid"
            },
            {
                label: t("cancel"),
                value: [
                    ResaleRaffleStatus.Canceled
                ],
                param: "revoke"
            }, 
        ];
    }, [
        t,
        type
    ]);
    var selectedOptionIndex = options.findIndex(function(option) {
        return option.param === filter;
    }) ? options.findIndex(function(option) {
        return option.param === filter;
    }) : 0;
    var ref2 = (0,react.useState)(selectedOptionIndex !== -1 ? selectedOptionIndex : 0), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    (0,react.useEffect)(function() {
        if (type !== "purchased") {
            var UrlParams = "?filter=".concat(options[selectedIndex].param);
            // React Routerのhistoryを使うとソート順を変えた際に、スクロール位置が一番上になるため、JavaScriptで直接historyを利用している
            window.history.replaceState(null, "", UrlParams);
        }
    }, [
        selectedIndex
    ]);
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleMenuItemClick = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(event, index) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSelectedIndex(index);
                        setAnchorEl(null);
                        return [
                            4,
                            onFilter(type, (ref = options[index]) === null || ref === void 0 ? void 0 : ref.value)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event, index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onFilter,
        type,
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            type !== "purchased" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "flex-end",
                sx: {
                    pb: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        width: "fit-content",
                        mr: -2
                    },
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            sx: {
                                pr: 1
                            },
                            children: (ref = options[selectedIndex]) === null || ref === void 0 ? void 0 : ref.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                            fontSize: "xSmall",
                            sx: {
                                color: "grey.600"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: !!anchorEl,
                onClose: handleClose,
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            bgcolor: "grey.100",
                            minWidth: 200
                        },
                        selected: index === selectedIndex,
                        onClick: function(event) {
                            return handleMenuItemClick(event, index);
                        },
                        children: option.label
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: resales === null || resales === void 0 ? void 0 : resales.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItemBox, {
                        resaleItem: node
                    }, node.id);
                }),
                loading: loading,
                hasNextPage: hasNextPage,
                onFetchMore: function() {
                    var ref;
                    return onFetchMore(type, (ref = options[selectedIndex]) === null || ref === void 0 ? void 0 : ref.value);
                },
                emptyMessage: t("ticketNotExist"),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    children: Array.from(Array(5).keys()).map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItemBoxSkeleton, {}, index);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleManagement/viewModel.ts




function ResaleManagement_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleManagement(\n    $pageInput: PageInput\n    $status: [String!]\n    $skuId: String\n  ) {\n    resaleItemsByUser(pageInput: $pageInput, status: $status) {\n      ...ResaleConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleManagement_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleManagement_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemResaleRaffleUsers(\n    $pageInput: PageInput\n    $status: [String!]!\n    $skuId: String\n  ) {\n    itemResaleRaffleUsers(pageInput: $pageInput, status: $status) {\n      ...ResaleRaffleConnection\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleManagement_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleManagement_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var params = new URLSearchParams(window.location.search);
    var ref2;
    var eventFilter = (ref2 = params.get("filter")) !== null && ref2 !== void 0 ? ref2 : "";
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref3 = (0,react.useState)(4), tab = ref3[0], setTab = ref3[1];
    var options = [
        {
            label: "exhibiting",
            value: [
                ResaleItemStatus.Open,
                ResaleItemStatus.Matched
            ]
        },
        {
            label: "failedToSell",
            value: [
                ResaleItemStatus.NoMatched
            ]
        },
        {
            label: "sold",
            value: [
                ResaleItemStatus.Sold,
                ResaleItemStatus.Paid
            ]
        },
        {
            label: "cancel",
            value: [
                ResaleItemStatus.Canceled
            ]
        },
        {
            label: "whole",
            value: [
                ResaleRaffleStatus.Win,
                ResaleRaffleStatus.Applied,
                ResaleRaffleStatus.Lost,
                ResaleRaffleStatus.Invalid,
                ResaleRaffleStatus.Canceled, 
            ]
        },
        {
            label: "waitingPayment",
            value: [
                ResaleRaffleStatus.Win
            ]
        },
        {
            label: "waitingLottery",
            value: [
                ResaleRaffleStatus.Applied
            ]
        },
        {
            label: "lost",
            value: [
                ResaleRaffleStatus.Lost
            ]
        },
        {
            label: "invalid",
            value: [
                ResaleRaffleStatus.Invalid
            ]
        },
        {
            label: "revoke",
            value: [
                ResaleRaffleStatus.Canceled
            ]
        }, 
    ];
    var matchingValue = (ref = options.find(function(option) {
        return option.label === eventFilter;
    })) === null || ref === void 0 ? void 0 : ref.value;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ResaleManagement_viewModel_QUERY), 2), getResaleItemsByUser = ref4[0], ref5 = ref4[1], data = ref5.data, loading = ref5.loading, fetchMoreListed = ref5.fetchMore;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(ITEM_RESALE_RAFF_USERS), 2), getItemResaleRaffleUser = ref6[0], ref7 = ref6[1], resaleRaffles = ref7.data, resaleRaffleLoading = ref7.loading, fetchMoreResaleRaffle = ref7.fetchMore;
    (0,react.useEffect)(function() {
        (0,src_async_to_generator/* default */.Z)(function() {
            var _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = router.query.tab;
                        switch(_){
                            case "raffle":
                                return [
                                    3,
                                    1
                                ];
                            case "purchased":
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 1:
                        setTab(1);
                        return [
                            4,
                            getItemResaleRaffleUser(matchingValue ? {
                                variables: {
                                    status: matchingValue
                                }
                            } : {
                                variables: {
                                    status: [
                                        ResaleRaffleStatus.Win,
                                        ResaleRaffleStatus.Applied,
                                        ResaleRaffleStatus.Lost,
                                        ResaleRaffleStatus.Invalid,
                                        ResaleRaffleStatus.Canceled
                                    ]
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                    case 3:
                        setTab(2);
                        return [
                            4,
                            getItemResaleRaffleUser({
                                variables: {
                                    status: [
                                        ResaleRaffleStatus.Purchased
                                    ]
                                }
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        setTab(0);
                        return [
                            4,
                            getResaleItemsByUser({
                                variables: {
                                    status: matchingValue
                                }
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getItemResaleRaffleUser,
        getResaleItemsByUser,
        router.query.tab
    ]);
    var ref8, ref9;
    return {
        state: {
            tab: tab,
            loading: loading || resaleRaffleLoading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.resaleItemsByUser.pageInfo.hasNextPage),
            hasNextPageRaffles: !!(resaleRaffles === null || resaleRaffles === void 0 ? void 0 : (ref1 = resaleRaffles.itemResaleRaffleUsers) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.hasNextPage),
            resales: (ref8 = data === null || data === void 0 ? void 0 : data.resaleItemsByUser) !== null && ref8 !== void 0 ? ref8 : null,
            resaleRaffles: (ref9 = resaleRaffles === null || resaleRaffles === void 0 ? void 0 : resaleRaffles.itemResaleRaffleUsers) !== null && ref9 !== void 0 ? ref9 : null,
            filter: eventFilter
        },
        actions: {
            onFilter: function onFilter(type, status) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "listed")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getResaleItemsByUser({
                                        variables: {
                                            status: status
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                if (!(type === "raffle")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    getItemResaleRaffleUser({
                                        variables: {
                                            status: status !== null && status !== void 0 ? status : [
                                                ResaleRaffleStatus.Win,
                                                ResaleRaffleStatus.Applied,
                                                ResaleRaffleStatus.Lost,
                                                ResaleRaffleStatus.Invalid,
                                                ResaleRaffleStatus.Canceled
                                            ]
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    4,
                                    getItemResaleRaffleUser({
                                        variables: {
                                            status: [
                                                ResaleRaffleStatus.Purchased
                                            ]
                                        }
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore(type, status) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(type === "listed")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreListed({
                                        variables: {
                                            status: status,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.resaleItemsByUser.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                if (!(type === "raffle")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    fetchMoreResaleRaffle({
                                        variables: {
                                            status: status !== null && status !== void 0 ? status : [
                                                ResaleRaffleStatus.Win,
                                                ResaleRaffleStatus.Applied,
                                                ResaleRaffleStatus.Lost,
                                                ResaleRaffleStatus.Invalid
                                            ],
                                            pageInput: {
                                                cursor: resaleRaffles === null || resaleRaffles === void 0 ? void 0 : (ref1 = resaleRaffles.itemResaleRaffleUsers) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    4,
                                    fetchMoreResaleRaffle({
                                        variables: {
                                            status: [
                                                ResaleRaffleStatus.Purchased
                                            ],
                                            pageInput: {
                                                cursor: resaleRaffles === null || resaleRaffles === void 0 ? void 0 : (ref = resaleRaffles.itemResaleRaffleUsers) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ResaleManagement_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleManagement_viewModel_templateObject(), utoniq_core_schema/* ResaleConnectionFragmentDoc */.ZEU);
var ITEM_RESALE_RAFF_USERS = (0,lib/* gql */.Ps)(ResaleManagement_viewModel_templateObject1(), utoniq_core_schema/* ResaleRaffleConnectionFragmentDoc */.xqz);

;// CONCATENATED MODULE: ./src/components/pages/ResaleManagement/index.tsx




/**
 * ResaleManagement Page
 * Implemented as a practical sample.
 */ var ResaleManagement = function() {
    var ref = ResaleManagement_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleManagementTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetail/template/index.tsx













var ResaleRaffleDetailTemplate = function(param) {
    var state = param.state, onCancel = param.onCancel, onPay = param.onPay;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleDetail").t;
    var ref2 = (0,react.useState)(false), openConfirmCancel = ref2[0], setOpenConfirmCancel = ref2[1];
    if (!state.loading && !state.itemResaleRaffleUser) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleDetail_template_FixedBottomCell, {
            status: (ref = state.itemResaleRaffleUser) === null || ref === void 0 ? void 0 : ref.status,
            onClickCancel: function() {
                return setOpenConfirmCancel(true);
            },
            onClickPay: onPay,
            loading: state.loading
        }),
        margin: true,
        header: {
            back: true,
            title: t(((ref1 = state.itemResaleRaffleUser) === null || ref1 === void 0 ? void 0 : ref1.status) === ResaleRaffleStatus.Purchased ? "purchasedTitle" : "title")
        },
        children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusSkeleton, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSkeleton, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleDetail_template_StatusCell, {
                    isError: state.isError,
                    itemResaleRaffleUser: state.itemResaleRaffleUser,
                    onClickPay: onPay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleDetail_template_DetailCell, {
                    itemResaleRaffleUser: state.itemResaleRaffleUser
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: openConfirmCancel,
                    onClose: function() {
                        return setOpenConfirmCancel(false);
                    },
                    title: t("confirmCancelListingTitle"),
                    content: t("confirmCancelListingDesc"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 212
                        },
                        onClick: onCancel,
                        loading: state.submitting,
                        children: t("confirmCancel")
                    }),
                    cancelText: t("close")
                })
            ]
        })
    });
};
var ResaleRaffleDetail_template_StatusCell = function(param) {
    var isError = param.isError, itemResaleRaffleUser = param.itemResaleRaffleUser, onClickPay = param.onClickPay;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 7
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 3,
                alignItems: "center",
                children: isError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            children: t("winningErrorStatus")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) === ResaleRaffleStatus.Win ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                            sx: {
                                color: "error.main"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Check, {
                            sx: {
                                color: "primary.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            children: t("".concat(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status, "Status"))
                        })
                    ]
                })
            }),
            !!t("".concat(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status, "StatusDesc")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) === ResaleRaffleStatus.Win ? "text.primary" : "text.secondary",
                    align: "center",
                    sx: {
                        fontWeight: (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) === ResaleRaffleStatus.Win ? "bold" : "normal"
                    },
                    children: isError ? t("winningErrorDesc") : t("".concat(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status, "StatusDesc"), {
                        updatedAt: String(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.formattedUpdatedAt)
                    })
                })
            }),
            (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) === ResaleRaffleStatus.Win && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            my: 7,
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderColor: "error.main"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "error.main",
                            sx: {
                                py: 2
                            },
                            align: "center",
                            children: t("repaymentExpirationDate", {
                                date: (ref = itemResaleRaffleUser.resaleItems[0]) === null || ref === void 0 ? void 0 : ref.formattedPaymentExpiredAt
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "contained",
                            size: "large",
                            sx: {
                                width: 244
                            },
                            onClick: onClickPay,
                            children: t("repayment")
                        })
                    })
                ]
            })
        ]
    });
};
var ResaleRaffleDetail_template_DetailCell = function(param) {
    var itemResaleRaffleUser = param.itemResaleRaffleUser;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleDetail").t;
    var ref16 = (0,router_useRouter/* useRouter */.tv)(), generateQueryPath = ref16.generateQueryPath, routerPages = ref16.routerPages;
    var ref17 = (0,react.useMemo)(function() {
        return getItemSkuPrice(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item);
    }, [
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item
    ]), price = ref17.price, formattedPrice = ref17.formattedPrice;
    var data = [
        {
            label: t("ticketPrice"),
            value: "￥".concat(numeral_default()(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.totalItemPrice).format("0,0"))
        },
        {
            // 振り込み手数料
            label: t("transferFee"),
            value: "\xa5".concat(numeral_default()(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.bankTransferFeePerOrder).format("0,0"))
        }, 
    ];
    var totalAmount = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!price) {
            return 0;
        }
        return numeral_default()(price * ((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount) || 1) + ((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.bankTransferFeePerOrder) || 0)).format("0,0");
    }, [
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref4 = itemResaleRaffleUser.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.resaleFee) === null || ref7 === void 0 ? void 0 : ref7.bankTransferFeePerOrder,
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount,
        price, 
    ]);
    var ref18, ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("ticketInfo", "チケット情報"),
                Icon: dist.Icons.Post,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref8 = itemResaleRaffleUser.item) === null || ref8 === void 0 ? void 0 : ref8.title
                                }),
                                !!(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref9 = itemResaleRaffleUser.item) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.sku) === null || ref10 === void 0 ? void 0 : ref10.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref11 = itemResaleRaffleUser.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.sku) === null || ref12 === void 0 ? void 0 : ref12.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleTag, {
                            status: (ref18 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) !== null && ref18 !== void 0 ? ref18 : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            sx: {
                                pt: 3
                            },
                            children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref13 = itemResaleRaffleUser.item) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.metadata) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.ticket) === null || ref15 === void 0 ? void 0 : ref15.description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("exhibitionInfo", "応募情報"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketPrice", "価格")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        "\xa5",
                                        formattedPrice,
                                        "/1",
                                        t("perSheet")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("holdingQuantity", "応募枚数")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount,
                                        t("sheet")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("appliedAt", "応募日時")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.formattedCreatedAt
                                })
                            ]
                        })
                    ]
                })
            }),
            [
                ResaleRaffleStatus.Applied,
                ResaleRaffleStatus.Win,
                ResaleRaffleStatus.Purchased, 
            ].includes(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("paymentResalePrice", "お支払い総額"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        pb: 3
                    },
                    children: [
                        data.map(function(param, index) {
                            var value = param.value, label = param.label;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        sx: {
                                            py: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                color: "text.secondary",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                children: value
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            sx: {
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("total")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: [
                                        "\xa5",
                                        totalAmount
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.status) === ResaleRaffleStatus.Purchased && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 4,
                sx: {
                    pb: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    href: generateQueryPath(routerPages.OwnedItemDetail, {
                        itemId: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item.id
                    }, {
                        skuId: encodeSkuId((ref19 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.skuId) !== null && ref19 !== void 0 ? ref19 : "")
                    }),
                    sx: {
                        width: 244,
                        margin: "auto"
                    },
                    color: "primary",
                    children: t("ticketDetail")
                })
            })
        ]
    });
};
var ResaleRaffleDetail_template_FixedBottomCell = function(param) {
    var onClickCancel = param.onClickCancel, onClickPay = param.onClickPay, status = param.status, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleDetail").t;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            alignItems: "center",
            sx: {
                py: 4,
                bgcolor: "grey.50"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    width: 244,
                    height: 44,
                    borderRadius: 34
                }
            })
        });
    }
    if ([
        ResaleRaffleStatus.Lost,
        ResaleRaffleStatus.Invalid,
        ResaleRaffleStatus.Canceled,
        ResaleRaffleStatus.Purchased, 
    ].includes(status || "")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        alignItems: "center",
        sx: {
            py: 4,
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: status === ResaleRaffleStatus.Applied ? "outlined" : "contained",
            size: "large",
            sx: {
                width: 244
            },
            onClick: status === ResaleRaffleStatus.Applied ? onClickCancel : onClickPay,
            children: status === ResaleRaffleStatus.Applied ? t("cancelListing", "抽選をキャンセルする") : t("repayment")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetail/viewModel.ts






function ResaleRaffleDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleRaffleDetail($raffleId: ID!, $itemId: String!, $skuId: String) {\n    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {\n      ...ItemResaleRaffleUserDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleRaffleDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleRaffleDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation cancelResaleItemRaffle(\n    $inputs: CancelResaleItemRaffleInput!\n    $skuId: String\n  ) {\n    cancelResaleItemRaffle(inputs: $inputs) {\n      ...ItemResaleRaffleUserDetail\n    }\n  }\n  ",
        "\n"
    ]);
    ResaleRaffleDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 *
 */ var ResaleRaffleDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var _query = router.query, raffleId = _query.raffleId, itemId = _query.itemId;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,useQuery/* useQuery */.aM)(ResaleRaffleDetail_viewModel_QUERY, {
        variables: {
            raffleId: raffleId,
            itemId: itemId
        }
    }), data = ref1.data, loading = ref1.loading, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_RESALE_ITEM_RAFFLE), 2), cancelResaleItemRaffle = ref2[0], ref3 = ref2[1], submitting = ref3.loading;
    var itemResaleRaffleUser = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser), {
            item: setItemSku(data === null || data === void 0 ? void 0 : (ref = data.itemResaleRaffleUser) === null || ref === void 0 ? void 0 : ref.item, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser.skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser
    ]);
    return {
        state: {
            loading: useInitialLoading(data, loading, error),
            itemResaleRaffleUser: itemResaleRaffleUser,
            isError: false,
            submitting: submitting
        },
        actions: {
            onCancel: function onCancel() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            cancelResaleItemRaffle({
                                variables: {
                                    inputs: {
                                        itemId: itemId,
                                        resaleRaffleId: raffleId
                                    }
                                }
                            }).then(function() {
                                router.push(generatePath(routerPages.ResaleRaffleDetailCancelCompletion, {
                                    raffleId: raffleId,
                                    itemId: itemId
                                }));
                            }).catch(function(e) {
                                showError(e);
                            })
                        ];
                    });
                })();
            },
            onPay: function onPay() {
                router.push(generatePath(routerPages.ResaleRaffleRepaymentConfirmation, {
                    raffleId: raffleId,
                    itemId: itemId
                }));
            }
        }
    };
});
var ResaleRaffleDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleRaffleDetail_viewModel_templateObject(), utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh);
var CANCEL_RESALE_ITEM_RAFFLE = (0,lib/* gql */.Ps)(ResaleRaffleDetail_viewModel_templateObject1(), utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh);

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetail/index.tsx




/**
 * ResaleRaffleDetail Page
 * Implemented as a practical sample.
 */ var ResaleRaffleDetail = function() {
    var ref = ResaleRaffleDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetailCancelCompletion/template/index.tsx





var ResaleRaffleDetailCancelCompletionTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleDetailCancelCompletion").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
            sx: {
                height: "100%"
            },
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        children: t("message")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 6,
                            pb: "44px"
                        },
                        align: "center",
                        children: t("messageDesc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                href: generatePath(routerPages.ResaleManagement, {
                                    tab: "raffle"
                                }),
                                sx: {
                                    width: 244,
                                    margin: "auto"
                                },
                                color: "primary",
                                children: t("resaleManagementScreen")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                href: routerPages.Top,
                                size: "large",
                                sx: {
                                    width: 244,
                                    margin: "auto"
                                },
                                color: "primary",
                                children: t("topPage")
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetailCancelCompletion/viewModel.ts

/**
 *
 */ var ResaleRaffleDetailCancelCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleDetailCancelCompletion/index.tsx




/**
 * resaleRaffleDetailCancelCompletion Page
 * Implemented as a practical sample.
 */ var ResaleRaffleDetailCancelCompletion = function() {
    var ref = ResaleRaffleDetailCancelCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleDetailCancelCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentCompletion/template/index.tsx










var ResaleRaffleRepaymentCompletionTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleRepaymentCompletion").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentCompletion_template_ResultCell, {}),
            state.itemResaleRaffleUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentCompletion_template_DetailCell, {
                itemResaleRaffleUser: state.itemResaleRaffleUser
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                spacing: 4,
                sx: {
                    pt: "44px",
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        href: generatePath(routerPages.ResaleManagement, {
                            tab: "purchased"
                        }),
                        sx: {
                            width: 244,
                            margin: "auto"
                        },
                        color: "primary",
                        children: t("resaleManagementScreen")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        href: routerPages.Top,
                        size: "large",
                        sx: {
                            width: 244,
                            margin: "auto"
                        },
                        color: "primary",
                        children: t("topPage")
                    })
                ]
            })
        ]
    });
};
var ResaleRaffleRepaymentCompletion_template_ResultCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleRepaymentCompletion").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 7
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 6,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    children: t("purchaseCompleted")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    color: "text.secondary",
                    align: "center",
                    children: t("purchaseCompletedDesc")
                })
            ]
        })
    });
};
var ResaleRaffleRepaymentCompletion_template_DetailCell = function(param) {
    var itemResaleRaffleUser = param.itemResaleRaffleUser;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleRepaymentCompletion").t;
    var formattedPrice = (0,react.useMemo)(function() {
        return getItemSkuPrice(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item);
    }, [
        itemResaleRaffleUser
    ]).formattedPrice;
    var data = [
        {
            label: t("ticketPrice"),
            value: "\xa5".concat(formattedPrice, "/1").concat(t("perSheet"))
        },
        {
            label: t("applicationNumber"),
            value: t("applicationNumberValue", {
                number: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount
            })
        },
        {
            label: t("totalAmount"),
            value: "\xa5".concat(numeral_default()(((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.totalItemPrice) || 0) + ((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.purchaseFee) || 0)).format("0,0"))
        },
        {
            label: t("paymentInfo"),
            value: t("creditCard")
        },
        {
            label: t("applicationDate"),
            value: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.formattedCreatedAt
        }, 
    ];
    var skuName = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref = setItemSku(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item, (ref2 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.skuId) !== null && ref2 !== void 0 ? ref2 : null)) === null || ref === void 0 ? void 0 : (ref1 = ref.sku) === null || ref1 === void 0 ? void 0 : ref1.unitName) !== null && ref3 !== void 0 ? ref3 : "";
    }, [
        itemResaleRaffleUser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 5,
                    "&:last-child": {
                        pb: 5
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item.title
                                }),
                                !!skuName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: skuName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 6,
                            children: data.map(function(param, index) {
                                var label = param.label, value = param.value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "body2",
                                            children: value
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentCompletion/viewModel.ts



function ResaleRaffleRepaymentCompletion_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleRaffleRepaymentCompletion(\n    $raffleId: ID!\n    $itemId: String!\n    $skuId: String\n  ) {\n    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {\n      ...ItemResaleRaffleUserDetail\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleRaffleRepaymentCompletion_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var ResaleRaffleRepaymentCompletion_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _query = router.query, raffleId = _query.raffleId, itemId = _query.itemId;
    var ref = (0,useQuery/* useQuery */.aM)(ResaleRaffleRepaymentCompletion_viewModel_QUERY, {
        variables: {
            raffleId: raffleId,
            itemId: itemId
        }
    }), data = ref.data, loading = ref.loading;
    var itemResaleRaffleUser = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser), {
            item: setItemSku(data === null || data === void 0 ? void 0 : (ref = data.itemResaleRaffleUser) === null || ref === void 0 ? void 0 : ref.item, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser.skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser
    ]);
    return {
        state: {
            itemResaleRaffleUser: itemResaleRaffleUser,
            loading: loading
        },
        actions: {}
    };
});
var ResaleRaffleRepaymentCompletion_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleRaffleRepaymentCompletion_viewModel_templateObject(), utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentCompletion/index.tsx




/**
 * ResaleRaffleRepaymentCompletion Page
 * Implemented as a practical sample.
 */ var ResaleRaffleRepaymentCompletion = function() {
    var ref = ResaleRaffleRepaymentCompletion_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentCompletionTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentConfirmation/template/index.tsx















var ResaleRaffleRepaymentConfirmationTemplate = function(param) {
    var state = param.state, onPurchase = param.onPurchase, onCloseError = param.onCloseError, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleRepaymentConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("resalePayment")), onClickHelp = ref1.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title"),
            right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                onClick: onClickHelp,
                edge: "end",
                color: "primary"
            })
        },
        children: [
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentConfirmationSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            py: 6
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            disabled: state.loading || !state.cardNumber,
                            loading: state.submitting,
                            onClick: onPurchase,
                            children: t("submit")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        sx: {
                            py: 5
                        },
                        children: t("resaleInfo")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentConfirmation_template_ConfirmationContentCell, {
                        itemResaleRaffleUser: state.itemResaleRaffleUser,
                        cardNumber: state.cardNumber,
                        brand: state.brand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 3,
                        alignItems: "center",
                        sx: {
                            pb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                sx: {
                                    width: 212
                                },
                                disabled: state.loading || !state.cardNumber,
                                loading: state.submitting,
                                onClick: onPurchase,
                                children: t("submit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "text",
                                sx: {
                                    width: 212
                                },
                                onClick: function() {
                                    return router.goBack();
                                },
                                children: t("back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                        open: state.openError,
                        onClose: onCloseError,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                    fontSize: "large",
                                    sx: {
                                        color: "error.main"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    sx: {
                                        pb: 3
                                    },
                                    children: t("errorTitle")
                                })
                            ]
                        }),
                        content: t("errorDesc"),
                        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 212
                            },
                            href: routerPages.PaymentDetail,
                            children: t("changeRafflePaymentMethod")
                        }),
                        cancelText: t("close")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: state.openRequire3DSecureModal,
                onClose: onCloseRequire3DSecureModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: state.openExpiredCardModal,
                onClose: onCloseExpiredCardModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: state.openPaymentErrorModal,
                onClose: onClosePaymentErrorModal
            })
        ]
    });
};
var ResaleRaffleRepaymentConfirmationSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                sx: {
                    py: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 44,
                    width: 212,
                    sx: {
                        borderRadius: 34
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h4",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    pt: 5,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    [
                        0,
                        1,
                        2
                    ].map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "10%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "body2",
                                    width: "90%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                    sx: {
                                        pt: 3
                                    }
                                })
                            ]
                        }, key);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: 20,
                        width: "100%",
                        sx: {
                            bgcolor: "grey.100",
                            my: "6px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                        sx: {
                            pt: 3
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            height: 20,
                            width: "100%",
                            sx: {
                                bgcolor: "grey.100",
                                my: "6px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            numberOfLine: 2
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    pt: "34px"
                },
                children: [
                    [
                        0,
                        1,
                        2
                    ].map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "30%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "30%"
                                        })
                                    ]
                                }),
                                key < 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                            ]
                        }, key);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        alignItems: "center",
                        sx: {
                            pt: 8,
                            pb: 6
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                height: 44,
                                width: 212,
                                sx: {
                                    borderRadius: 34
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "caption",
                                width: "15%",
                                sx: {
                                    mt: 2
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ResaleRaffleRepaymentConfirmation_template_ConfirmationContentCell = function(param) {
    var itemResaleRaffleUser = param.itemResaleRaffleUser, brand = param.brand, cardNumber = param.cardNumber;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("resaleRaffleRepaymentConfirmation").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref10 = (0,react.useMemo)(function() {
        return getItemSkuPrice(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item);
    }, [
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item
    ]), price = ref10.price, formattedPrice = ref10.formattedPrice;
    var totalAmount = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!price) {
            return 0;
        }
        var ref4;
        return numeral_default()(((ref4 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.totalItemPrice) !== null && ref4 !== void 0 ? ref4 : 0) + ((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.purchaseFee) || 0)).format("0,0");
    }, [
        price,
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref = itemResaleRaffleUser.item) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resaleFee) === null || ref3 === void 0 ? void 0 : ref3.purchaseFee,
        itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.totalItemPrice, 
    ]);
    var data = [
        {
            label: t("ticketPrice"),
            value: "￥".concat(numeral_default()(price * ((itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount) || 0)).format("0,0"))
        },
        {
            label: t("transferFee"),
            value: "\xa5".concat(numeral_default()(((ref4 = itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.item.metadata) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.ticket) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.resaleFee) === null || ref6 === void 0 ? void 0 : ref6.purchaseFee) || 0).format("0,0"))
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("applicationInfo"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketName")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref7 = itemResaleRaffleUser.item) === null || ref7 === void 0 ? void 0 : ref7.title
                                }),
                                !!(itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : (ref8 = itemResaleRaffleUser.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sku) === null || ref9 === void 0 ? void 0 : ref9.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: itemResaleRaffleUser.item.sku.unitName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("ticketPriceLabel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("ticketPriceValue", {
                                        price: formattedPrice
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: t("applicationNumber")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: [
                                        (itemResaleRaffleUser === null || itemResaleRaffleUser === void 0 ? void 0 : itemResaleRaffleUser.itemCount) || 0,
                                        t("sheet")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResaleItem, {
                title: t("paymentInfo"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("creditCardInfo")
                            }),
                            !cardNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                variant: "subtitle1",
                                href: routerPages.PaymentMethodSetting,
                                children: t("register")
                            })
                        ]
                    }),
                    !cardNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.hint",
                        children: t("cardInfoNotRegister")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                width: 40,
                                height: 32,
                                src: (0,creditCard/* generateCreditCardLogoPath */.n)(brand),
                                target: "common"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: t("last4Digit", {
                                    number: cardNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleItem, {
                title: t("totalRafflePayment"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            data.map(function(param, index) {
                                var value = param.value, label = param.label;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            sx: {
                                                py: 2
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    children: value
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                sx: {
                                    py: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("total")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            "\xa5",
                                            totalAmount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentConfirmation/viewModel.ts






function ResaleRaffleRepaymentConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ResaleRaffleRepaymentConfirmation(\n    $raffleId: ID!\n    $itemId: String!\n    $skuId: String\n  ) {\n    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {\n      ...ItemResaleRaffleUserDetail\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ResaleRaffleRepaymentConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResaleRaffleRepaymentConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation purchaseResaleItem($inputs: PurchaseResaleItemInput!) {\n    purchaseResaleItem(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    ResaleRaffleRepaymentConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ResaleRaffleRepaymentConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var ref2 = (0,router_useRouter/* useRouter */.tv)(), router = ref2.router, routerPages = ref2.routerPages, generatePath = ref2.generatePath;
    var _query = router.query, raffleId = _query.raffleId, itemId = _query.itemId;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref3 = (0,useQuery/* useQuery */.aM)(ResaleRaffleRepaymentConfirmation_viewModel_QUERY, {
        variables: {
            raffleId: raffleId,
            itemId: itemId
        }
    }), data = ref3.data, loading = ref3.loading;
    var ref4 = (0,react.useState)(false), openError = ref4[0], setOpenError = ref4[1];
    var ref5 = (0,react.useState)(false), openExpiredCardModal = ref5[0], setOpenExpiredCardModal = ref5[1];
    var ref6 = (0,react.useState)(false), openPaymentErrorModal = ref6[0], setOpenPaymentErrorModal = ref6[1];
    var ref7 = (0,react.useState)(false), openRequire3DSecureModal = ref7[0], setOpenRequire3DSecureModal = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(PURCHASE_RESALE_ITEM), 2), purchaseResaleItem = ref8[0], ref9 = ref8[1], submitting = ref9.loading;
    var itemResaleRaffleUser = (0,react.useMemo)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser)) {
            return null;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser), {
            item: setItemSku(data === null || data === void 0 ? void 0 : (ref = data.itemResaleRaffleUser) === null || ref === void 0 ? void 0 : ref.item, data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser.skuId)
        });
    }, [
        data === null || data === void 0 ? void 0 : data.itemResaleRaffleUser
    ]);
    var ref10;
    return {
        state: {
            loading: loading,
            openError: openError,
            submitting: submitting,
            itemResaleRaffleUser: itemResaleRaffleUser,
            brand: (ref10 = data === null || data === void 0 ? void 0 : (ref = data.paymentSource) === null || ref === void 0 ? void 0 : ref.brand) !== null && ref10 !== void 0 ? ref10 : "",
            cardNumber: data === null || data === void 0 ? void 0 : (ref1 = data.paymentSource) === null || ref1 === void 0 ? void 0 : ref1.last4,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal
        },
        actions: {
            onPurchase: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        purchaseResaleItem({
                            variables: {
                                inputs: {
                                    resaleRaffleId: raffleId,
                                    itemId: itemId
                                }
                            }
                        }).then(function() {
                            router.push(generatePath(generatePath(routerPages.ResaleRaffleRepaymentCompletion, {
                                raffleId: raffleId,
                                itemId: itemId
                            })));
                        }).catch(function(e) {
                            var ref, ref1, ref2;
                            switch((ref = e.graphQLErrors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode){
                                /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                    setOpenRequire3DSecureModal(true);
                                    return;
                                /**
               * @desciption
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                    setOpenExpiredCardModal(true);
                                    return;
                                /**
               * @desciption
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                    setOpenPaymentErrorModal(true);
                                    return;
                                default:
                                    showError(e);
                                    break;
                            }
                        })
                    ];
                });
            }),
            onCloseError: function() {
                setOpenError(false);
            },
            onCloseRequire3DSecureModal: function() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
});
var ResaleRaffleRepaymentConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(ResaleRaffleRepaymentConfirmation_viewModel_templateObject(), utoniq_core_schema/* ItemResaleRaffleUserDetailFragmentDoc */.NHh, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK);
var PURCHASE_RESALE_ITEM = (0,lib/* gql */.Ps)(ResaleRaffleRepaymentConfirmation_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/ResaleRaffleRepaymentConfirmation/index.tsx




/**
 * ResaleRaffleRepaymentConfirmation Page
 * Implemented as a practical sample.
 */ var ResaleRaffleRepaymentConfirmation = function() {
    var ref = ResaleRaffleRepaymentConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResaleRaffleRepaymentConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/SerialNumberSelect/template/RequestTrade.tsx











var RequestTrade_schema = function(o) {
    return {
        requestItemId: o.string(),
        providableItems: o.array().items(o.object({
            itemId: o.string(),
            serialId: o.string()
        })),
        candidateUserId: o.string(),
        candidateItems: o.array().items(o.object({
            itemId: o.string(),
            serialId: o.string()
        })),
        candidateSerialNumber: o.string().optional(),
        requestedByUserId: o.string(),
        requestComment: {
            artistId: o.string().optional().allow("", null),
            content: o.string().min(10).max(200)
        },
        requestSerialNumber: o.string().optional()
    };
};
var RequestTrade = function(param) {
    var serialNumberSelect = param.serialNumberSelect, userTradableUserItems = param.userTradableUserItems, tradeItemDetailSelect = param.tradeItemDetailSelect, onGetUserTradableUserItems = param.onGetUserTradableUserItems, onFetchMoreUserTradableUserItems = param.onFetchMoreUserTradableUserItems, onGetTradeItemDetailSelect = param.onGetTradeItemDetailSelect, onCreateRequestTrade = param.onCreateRequestTrade;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref8 = (0,react.useState)(0), currentStep = ref8[0], setCurrentStep = ref8[1];
    var ref9 = (0,react.useState)(""), candidateSerialNumber = ref9[0], setCandidateSerialNumber = ref9[1];
    var ref10 = (0,react.useState)(""), requestSerialNumber = ref10[0], setRequestSerialNumber = ref10[1];
    var ref11 = (0,react.useState)(""), tradeNegotiationId = ref11[0], setTradeNegotiationId = ref11[1];
    var ref12 = (0,core_form/* useForm */.cI)({
        schema: RequestTrade_schema,
        defaultValues: RequestTrade_defaultValues
    }), handleSubmit = ref12.handleSubmit, setValue = ref12.setValue, getValues = ref12.getValues, register = ref12.register, _formState = ref12.formState, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid, errors = _formState.errors;
    (0,react.useEffect)(function() {
        if (!serialNumberSelect.portfolio) {
            return;
        }
        setValue("candidateItems.0.itemId", serialNumberSelect.portfolio.item.id);
        setValue("requestItemId", serialNumberSelect.portfolio.item.id);
        setValue("candidateUserId", serialNumberSelect.portfolio.user.id);
        // check length of serials = 1 then hidden step 0
        if (serialNumberSelect.portfolio.serials.length === 1) {
            setValue("candidateItems.0.serialId", serialNumberSelect.portfolio.serials[0].serialId);
            var _formattedSerialNumber;
            setCandidateSerialNumber((_formattedSerialNumber = serialNumberSelect.portfolio.serials[0].formattedSerialNumber) !== null && _formattedSerialNumber !== void 0 ? _formattedSerialNumber : "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref = serialNumberSelect.portfolio) === null || ref === void 0 ? void 0 : ref.serials
    ]);
    var handleGoBack = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3;
        if (((ref = serialNumberSelect.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 && currentStep === 1) {
            router.goBack();
            return;
        }
        if (((ref2 = tradeItemDetailSelect.portfolio) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.serials) === null || ref3 === void 0 ? void 0 : ref3.length) === 1 && currentStep === 4) {
            setCurrentStep(2);
            return;
        }
        setCurrentStep(function(prevState) {
            return prevState > 0 ? --prevState : 0;
        });
    }, [
        (ref1 = serialNumberSelect.portfolio) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.serials) === null || ref2 === void 0 ? void 0 : ref2.length,
        currentStep,
        (ref3 = tradeItemDetailSelect.portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.serials) === null || ref4 === void 0 ? void 0 : ref4.length,
        router, 
    ]);
    var handleSelectCandidateSerial = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(serial) {
            var _formattedSerialNumber;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setValue("candidateItems.0.serialId", serial.serialId);
                setCandidateSerialNumber((_formattedSerialNumber = serial.formattedSerialNumber) !== null && _formattedSerialNumber !== void 0 ? _formattedSerialNumber : "");
                setCurrentStep(1);
                return [
                    2
                ];
            });
        });
        return function(serial) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setValue
    ]);
    var handleProvidableItemSelect = (0,react.useCallback)(function(itemId) {
        setValue("providableItems.0.itemId", itemId);
        setCurrentStep(2);
    }, [
        setValue
    ]);
    var handleItemDetailSelect = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, _formattedSerialNumber, ref6;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (((ref = tradeItemDetailSelect.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.length) === 1) {
                ;
                setCurrentStep(4);
                setValue("providableItems.0.serialId", (ref4 = tradeItemDetailSelect.portfolio) === null || ref4 === void 0 ? void 0 : ref4.serials[0].serialId);
                ;
                setRequestSerialNumber((_formattedSerialNumber = (ref5 = tradeItemDetailSelect.portfolio) === null || ref5 === void 0 ? void 0 : ref5.serials[0].formattedSerialNumber) !== null && _formattedSerialNumber !== void 0 ? _formattedSerialNumber : "");
            } else {
                setCurrentStep(3);
            }
            setValue("requestedByUserId", (ref6 = (ref2 = tradeItemDetailSelect.portfolio) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : "");
            return [
                2
            ];
        });
    }), [
        setValue,
        (ref5 = tradeItemDetailSelect.portfolio) === null || ref5 === void 0 ? void 0 : ref5.serials,
        (ref6 = tradeItemDetailSelect.portfolio) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.user) === null || ref7 === void 0 ? void 0 : ref7.id, 
    ]);
    var handleSelectRequestSerial = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(serial) {
            var _formattedSerialNumber;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setValue("providableItems.0.serialId", serial.serialId);
                setRequestSerialNumber((_formattedSerialNumber = serial.formattedSerialNumber) !== null && _formattedSerialNumber !== void 0 ? _formattedSerialNumber : "");
                setCurrentStep(4);
                return [
                    2
                ];
            });
        });
        return function(serial) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setValue
    ]);
    var handleCreateRequestTrade = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(_param) {
            var requestComment, values, dataValues;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestComment = _param.requestComment, values = (0,_object_without_properties/* default */.Z)(_param, [
                            "requestComment"
                        ]);
                        dataValues = (requestComment === null || requestComment === void 0 ? void 0 : requestComment.content) ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                            requestComment: {
                                content: requestComment.content,
                                artistId: values.requestedByUserId
                            }
                        }) : values;
                        return [
                            4,
                            onCreateRequestTrade(dataValues).then(function(res) {
                                setTradeNegotiationId(res);
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onCreateRequestTrade
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps, {
        value: currentStep,
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SerialNumberSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, serialNumberSelect), {
                onTradeConfirm: handleSelectCandidateSerial,
                onClose: router.goBack
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProvidableItemSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userTradableUserItems), {
                onClose: handleGoBack,
                onGetUserTradableUserItems: onGetUserTradableUserItems,
                onFetchMore: onFetchMoreUserTradableUserItems,
                onProvidableItemSelect: handleProvidableItemSelect
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeItemDetailSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tradeItemDetailSelect), {
                onItemDetailSelect: handleItemDetailSelect,
                itemId: getValues("providableItems.0.itemId"),
                onGetTradeItemDetailSelect: onGetTradeItemDetailSelect,
                onClose: handleGoBack
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SerialNumberSelect, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tradeItemDetailSelect), {
                onTradeConfirm: handleSelectRequestSerial,
                onClose: handleGoBack
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeRequestConfirm, {
                loading: isSubmitting,
                register: register,
                isValid: isValid,
                formErrors: errors,
                campaign: null,
                tradeNegotiationId: tradeNegotiationId,
                serialNumberSelect: serialNumberSelect,
                tradeItemDetailSelect: tradeItemDetailSelect,
                onClose: handleGoBack,
                candidateSerialNumber: candidateSerialNumber,
                requestSerialNumber: requestSerialNumber,
                onSubmit: handleSubmit(handleCreateRequestTrade)
            })
        ]
    });
};
var RequestTrade_defaultValues = {
    requestedByUserId: "",
    providableItems: [
        {
            itemId: "",
            serialId: ""
        }
    ],
    candidateUserId: "",
    candidateItems: [
        {
            itemId: "",
            serialId: ""
        }
    ],
    requestItemId: "",
    requestComment: {
        artistId: "",
        content: ""
    }
};
var SerialNumberSelect = dynamic_default()(function() {
    var promise = __webpack_require__.e(/* import() */ 9620).then(__webpack_require__.bind(__webpack_require__, 9620)).then(function(mod) {
        return mod.SerialNumberSelect;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9620)
            ];
        }
    }
});
var ProvidableItemSelect = dynamic_default()(function() {
    var promise = __webpack_require__.e(/* import() */ 9980).then(__webpack_require__.bind(__webpack_require__, 29980)).then(function(mod) {
        return mod.TradeRequestProvidableItemSelect;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29980)
            ];
        }
    }
});
var TradeItemDetailSelect = dynamic_default()(function() {
    var promise = __webpack_require__.e(/* import() */ 230).then(__webpack_require__.bind(__webpack_require__, 80230)).then(function(mod) {
        return mod.TradeItemDetailSelect;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80230)
            ];
        }
    }
});
var TradeRequestConfirm = dynamic_default()(function() {
    var promise = __webpack_require__.e(/* import() */ 6895).then(__webpack_require__.bind(__webpack_require__, 6895)).then(function(mod) {
        return mod.TradeRequestConfirm;
    }).catch(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(error) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            function() {
                                return null;
                            }
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6895)
            ];
        }
    }
});

;// CONCATENATED MODULE: ./src/components/pages/SerialNumberSelect/template/index.tsx







var SerialNumberSelectTemplate = function(_param) {
    var state = _param.state, actions = (0,_object_without_properties/* default */.Z)(_param, [
        "state"
    ]);
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.SerialNumberSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestTrade, (0,src_object_spread/* default */.Z)({}, state, actions))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SerialNumberSelect/viewModel.ts







function SerialNumberSelect_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SerialNumberSelect($itemId: ID!, $userId: String, $skuId: String) {\n    portfolio(id: $itemId, userId: $userId) {\n      ...UserItemBox\n    }\n  }\n  ",
        "\n"
    ]);
    SerialNumberSelect_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SerialNumberSelect_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserTradableUserItems($pageInput: PageInput) {\n    userTradableUserItems(pageInput: $pageInput) {\n      ...UserTradableUserItemsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    SerialNumberSelect_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SerialNumberSelect_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ItemDetailSelect($id: ID!, $userId: String, $skuId: String) {\n    portfolio(id: $id, userId: $userId) {\n      id\n      number\n      type\n      createdAt\n      isSystemProtected\n      isUserProtected\n      item {\n        ...TradeItemDetailSelectItemDetailBox\n      }\n      serials {\n        id\n        isProtected\n        serialId\n        isUsed\n        itemId\n        obtainedDate\n        formattedObtainedDate @client\n        formattedSerialNumber\n      }\n      user {\n        ...UserInfo\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    SerialNumberSelect_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SerialNumberSelect_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateTradeRequest($inputs: CreateTradeRequestInput!) {\n    createTradeRequest(inputs: $inputs) {\n      ...TradeBox\n    }\n  }\n  ",
        "\n"
    ]);
    SerialNumberSelect_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var SerialNumberSelect_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref2 = (0,useQuery/* useQuery */.aM)(SerialNumberSelect_viewModel_QUERY, {
        variables: (0,src_object_spread/* default */.Z)({}, router.query)
    }), data = ref2.data, loading = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GET_USER_TRADABLE_USER_ITEMS, {
        onCompleted: function onCompleted(param) {
            var userTradableUserItems = param.userTradableUserItems;
            if (!userTradableUserItems.edges.length) {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("impression_noData", {
                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                    itemId: router.query.itemId,
                    name: "providableItems"
                });
            }
        }
    }), 2), getUserTradableUserItems = ref3[0], ref4 = ref3[1], userItems = ref4.data, fetchMoreUserTradableUserItems = ref4.fetchMore, networkStatus = ref4.networkStatus;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(GET_ITEM_DETAIL_SELECT, {
        returnPartialData: true
    }), 2), getItemInformation = ref5[0], ref6 = ref5[1], itemDetailSelect = ref6.data, itemInformationLoading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_TRADE_REQUEST), 1), createTradeRequest = ref7[0];
    var ref8, ref9, ref10;
    return {
        state: {
            serialNumberSelect: {
                portfolio: (ref8 = data === null || data === void 0 ? void 0 : data.portfolio) !== null && ref8 !== void 0 ? ref8 : null,
                loading: loading
            },
            userTradableUserItems: {
                loading: networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading,
                fetching: networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore,
                collections: {
                    edges: []
                },
                hasNextPage: !!(userItems === null || userItems === void 0 ? void 0 : (ref = userItems.userTradableUserItems) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage),
                items: (ref9 = userItems === null || userItems === void 0 ? void 0 : userItems.userTradableUserItems) !== null && ref9 !== void 0 ? ref9 : null
            },
            tradeItemDetailSelect: {
                loading: itemInformationLoading,
                portfolio: (ref10 = itemDetailSelect === null || itemDetailSelect === void 0 ? void 0 : itemDetailSelect.portfolio) !== null && ref10 !== void 0 ? ref10 : null
            }
        },
        actions: {
            onTradeConfirm: function onTradeConfirm() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onGetUserTradableUserItems: function onGetUserTradableUserItems() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getUserTradableUserItems({
                                        variables: {
                                            pageInput: {
                                                limit: 12
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMoreUserTradableUserItems: function onFetchMoreUserTradableUserItems() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!fetchMoreUserTradableUserItems) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    fetchMoreUserTradableUserItems({
                                        variables: {
                                            pageInput: {
                                                limit: 12,
                                                cursor: userItems === null || userItems === void 0 ? void 0 : (ref = userItems.userTradableUserItems) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onGetTradeItemDetailSelect: function onGetTradeItemDetailSelect(itemId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getItemInformation({
                                        variables: {
                                            id: itemId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCreateRequestTrade: function onCreateRequestTrade(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var requestComment, values;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestComment = _param.requestComment, values = (0,_object_without_properties/* default */.Z)(_param, [
                                    "requestComment"
                                ]);
                                if (!(requestComment === null || requestComment === void 0 ? void 0 : requestComment.content)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    createTradeRequest({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                                                requestComment: requestComment
                                            })
                                        }
                                    }).then(function(res) {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendTradeRequest", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            withMessage: true
                                        });
                                        var _id;
                                        return (_id = (ref = res.data) === null || ref === void 0 ? void 0 : ref.createTradeRequest.id) !== null && _id !== void 0 ? _id : "";
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    createTradeRequest({
                                        variables: {
                                            inputs: values
                                        }
                                    }).then(function(res) {
                                        var ref;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendTradeRequest", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            itemId: router.query.itemId,
                                            withMessage: false
                                        });
                                        var _id;
                                        return (_id = (ref = res.data) === null || ref === void 0 ? void 0 : ref.createTradeRequest.id) !== null && _id !== void 0 ? _id : "";
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var SerialNumberSelect_viewModel_QUERY = (0,lib/* gql */.Ps)(SerialNumberSelect_viewModel_templateObject(), utoniq_core_schema/* UserItemBoxFragmentDoc */.iu2);
var GET_USER_TRADABLE_USER_ITEMS = (0,lib/* gql */.Ps)(SerialNumberSelect_viewModel_templateObject1(), utoniq_core_schema/* UserTradableUserItemsConnectionFragmentDoc */.e1i);
var GET_ITEM_DETAIL_SELECT = (0,lib/* gql */.Ps)(SerialNumberSelect_viewModel_templateObject2(), utoniq_core_schema/* TradeItemDetailSelectItemDetailBoxFragmentDoc */.oNo, utoniq_core_schema/* UserInfoFragmentDoc */.IWz);
var CREATE_TRADE_REQUEST = (0,lib/* gql */.Ps)(SerialNumberSelect_viewModel_templateObject3(), utoniq_core_schema/* TradeBoxFragmentDoc */.CCA);

;// CONCATENATED MODULE: ./src/components/pages/SerialNumberSelect/index.tsx




/**
 * SerialNumberSelect Page
 * Implemented as a practical sample.
 */ var SerialNumberSelect_SerialNumberSelect = function() {
    var ref = SerialNumberSelect_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SerialNumberSelectTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/Settings/template/index.tsx
















var SettingsTemplate = function(param) {
    var state = param.state, onLogout = param.onLogout;
    var t = (0,core_i18n/* useTranslation */.$G)("settings").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, routerNames = ref.routerNames;
    var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("appHelp")).onClick;
    var list = (0,react.useMemo)(function() {
        return (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) ? [
            {
                title: t("accountSetting"),
                href: routerPages.AccountSetting,
                Icon: dist.Icons.User,
                notificationText: state.isMembershipPersonalInformationRequired ? t("accountSettingNotification") : ""
            },
            {
                title: t("paymentMethod"),
                hidden: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) !== "web",
                href: routerPages.PaymentDetail,
                Icon: dist.Icons.Wallet
            },
            {
                title: t("pushNotification"),
                hidden: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform) === "web",
                href: routerPages.PushNotificationSettings,
                Icon: dist.Icons.Notice
            },
            {
                title: t("emailNotification"),
                href: routerPages.EmailNotificationSettings,
                Icon: dist.Icons.Mail
            },
            {
                title: t("autoFollowSettings"),
                hidden: config_config/* config.applicationType */.v.applicationType === "standalone",
                href: routerPages.AutoFollowSettings,
                Icon: dist.Icons.Group
            },
            {
                title: t("privacySettings"),
                href: routerPages.PrivacySettings,
                Icon: dist.Icons.Key
            },
            {
                title: t("languageSetting"),
                href: routerPages.LanguageSetting,
                Icon: dist.Icons.Language
            },
            {
                title: t("guideUser"),
                Icon: dist.Icons.Help,
                hidden: (0,individual/* individualHideHelp */.qY)(),
                onClick: onClick
            },
            {
                title: t("inquiry"),
                Icon: dist.Icons.Inquiry,
                hidden: (0,individual/* individualHideInquiry */.jv)(),
                onClick: function() {
                    (0,intercom/* updateIntercom */.dC)(user);
                    (0,intercom/* openIntercom */.B6)();
                }
            }, 
        ] : [];
    }, [
        deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform,
        t,
        routerPages.AccountSetting,
        routerPages.PaymentDetail,
        routerPages.PushNotificationSettings,
        routerPages.EmailNotificationSettings,
        routerPages.AutoFollowSettings,
        routerPages.PrivacySettings,
        routerPages.LanguageSetting,
        state.isMembershipPersonalInformationRequired,
        onClick,
        user, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: t("title"),
            back: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Setting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                sx: {
                    bgcolor: "grey.50"
                },
                children: [
                    (0,array/* filterHiddenItem */.s)(list).map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                                    divider: true,
                                    title: item.title,
                                    href: item.href,
                                    target: item.target,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.Icon, {}),
                                    onClick: item.onClick,
                                    primaryTypographyProps: {
                                        variant: "body1"
                                    },
                                    secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "like.tap",
                                        children: item.notificationText
                                    }),
                                    sx: {
                                        backgroundColor: "grey.50",
                                        py: 2,
                                        px: 5,
                                        width: "100%",
                                        height: {
                                            xs: 52,
                                            md: 56
                                        }
                                    }
                                }),
                                item.notificationText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    badgeContent: "",
                                    color: "like",
                                    sx: {
                                        position: "absolute",
                                        top: "18px",
                                        left: "32px",
                                        width: 12,
                                        height: 12,
                                        transform: "scale(0.9)",
                                        "& > span": {
                                            minWidth: 12,
                                            height: 12,
                                            bgcolor: "like.tap"
                                        }
                                    }
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                        component: Box_Box/* default */.Z,
                        divider: true,
                        title: t("signOut"),
                        onClick: onLogout,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Logout, {}),
                        primaryTypographyProps: {
                            variant: "body1"
                        },
                        sx: {
                            backgroundColor: "grey.50",
                            py: 2,
                            px: 5,
                            width: "100%",
                            height: "auto"
                        }
                    }),
                    [
                        "development",
                        "staging"
                    ].includes(config_config/* config.environment */.v.environment) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://forms.clickup.com/f/vpuz-1425/QA13X4VVW4QLB835KT",
                        children: "不具合"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VersionCell, {})
        ]
    });
};
/**
 *
 * @description VersionCell
 * アプリのバージョン + コミットハッシュ表示
 * iOSの場合 CFBundleShortVersionStringを、Androidの場合はパッケージのversionNameを表示する。
 * stg/devの場合は環境名も表示する
 * webの場合は非表示
 */ var VersionCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("settings").t;
    var buildId = config_config/* config.buildId */.v.buildId, releaseVersion = config_config/* config.releaseVersion */.v.releaseVersion;
    var appVersion = (0,native_app/* useAppVersion */.Ql)();
    var isWeb = (0,native_app/* getPlatform */.Xf)() === "web";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle2",
                        align: "center",
                        children: config_config/* config.environment */.v.environment !== "production" && " ".concat(config_config/* config.environment */.v.environment)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        color: "text.hint",
                        variant: "caption",
                        align: "center",
                        sx: {
                            userSelect: "text"
                        },
                        children: "".concat(t("version"), " ").concat(releaseVersion, " ").concat(buildId && "(".concat(buildId.slice(0, 6), ")"))
                    })
                ]
            }),
            !isWeb && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    color: "text.hint",
                    variant: "caption",
                    align: "center",
                    sx: {
                        userSelect: "text"
                    },
                    children: appVersion
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Settings/viewModel.ts



function Settings_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Settings {\n    user {\n      id\n      isMembershipPersonalInformationRequired\n    }\n  }\n"
    ]);
    Settings_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Settings_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var logout = (0,auth/* useAuth */.aC)().logout;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(Settings_viewModel_QUERY).data;
    return {
        state: {
            isMembershipPersonalInformationRequired: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired)
        },
        actions: {
            onLogout: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    logout(),
                                    client.clearStore(),
                                    (0,storage/* clearStorage */.B$)()
                                ])
                            ];
                        case 1:
                            _state.sent();
                            router.push(routerPages.Top);
                            return [
                                2
                            ];
                    }
                });
            })
        }
    };
});
var Settings_viewModel_QUERY = (0,lib/* gql */.Ps)(Settings_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/Settings/index.tsx



/**
 * Settings Page
 * Implemented as a practical sample.
 */ var Settings = function() {
    var ref = Settings_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsTemplate, {
        state: state,
        onLogout: actions.onLogout
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUp/template/SignUpForm.tsx










var SignUpForm_schema = function(o) {
    return {
        displayName: (0,validators/* validateDisplayName */.tZ)(o, "signUp.displayName"),
        email: (0,validators/* validateEmail */.oH)(o, "signUp.email"),
        password: o.string().min(8).max(30).label((0,core_form/* tLabel */.TQ)("signUp.password"))
    };
};
/**
 *  SignUp Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */ var SignUpForm = function(param) {
    var onSubmitSignUp = param.onSubmitSignUp;
    var ref = (0,core_form/* useForm */.cI)({
        schema: SignUpForm_schema
    }), handleSubmit = ref.handleSubmit, register = ref.register, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: handleSubmit(onSubmitSignUp),
        sx: {
            pt: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.displayName
            }, register("displayName"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "email",
                error: errors === null || errors === void 0 ? void 0 : errors.email
            }, register("email"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                error: errors === null || errors === void 0 ? void 0 : errors.password
            }, register("password"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm_ButtonCell, {
                loading: isSubmitting
            })
        ]
    });
};
var SignUpForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var SignUpForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var SignUpForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUp/template/SignUpTemplate.tsx











var SignUpTemplate = function(param) {
    var state = param.state, onSignUpWithGoogle = param.onSignUpWithGoogle, onSignUpWithApple = param.onSignUpWithApple, onSubmitSignUp = param.onSubmitSignUp;
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    title: t("title"),
                    back: true,
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        href: config_config/* config.modules.tutorial */.v.modules.tutorial ? routerPages.Tutorial : routerPages.GlobalHome,
                        sx: {
                            minWidth: 52
                        },
                        children: t("skip")
                    })
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                        title: routerNames.SignUp
                    }),
                    /**
           * @description
           * Diica以外の場合、SNS認証機能解放
           * （DiicaはSNS連携時のUtoniqアイコンの表示をしてはいけないため、SNSリンク機能を隠す）
           */ config_config/* config.applicationKey */.v.applicationKey !== "diica" && (0,native_app/* getPlatform */.Xf)() !== "android" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLoginCell, {
                                onSignUpWithGoogle: onSignUpWithGoogle,
                                onSignUpWithApple: onSignUpWithApple
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementTextCell, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            py: 3
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, {
                        onSubmitSignUp: onSubmitSignUp
                    }),
                    /**
           * @description
           * utoniq・digireaのみアーティスト登録機能へのリンク表示
           */ [
                        "utoniq",
                        "digirea"
                    ].some(function(key) {
                        return key === config_config/* config.applicationKey */.v.applicationKey;
                    }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpTemplate_TextLinkCell, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_loading/* LoadingWithBackdrop */.W, {
                open: state.loading
            })
        ]
    });
};
var SocialLoginCell = function(param) {
    var onSignUpWithGoogle = param.onSignUpWithGoogle, onSignUpWithApple = param.onSignUpWithApple;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            display: "flex",
            justifyContent: "center",
            py: 2,
            gap: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Google, {
                size: "large",
                onClick: onSignUpWithGoogle,
                bgcolor: config_config/* config.theme.dark */.v.theme.dark ? "white" : "grey.50",
                /**
         * @todo
         * Googleログイン実装時に表示する
         * https://app.clickup.com/t/908127/UT-2827
         */ sx: {
                    display: "none"
                }
            }),
            (0,native_app/* getPlatform */.Xf)() !== "android" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Apple, {
                size: "large",
                onClick: onSignUpWithApple,
                bgcolor: config_config/* config.theme.dark */.v.theme.dark ? "white" : "#221f20",
                isDark: config_config/* config.theme.dark */.v.theme.dark
            })
        ]
    });
};
var SupplementTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                color: "text.primary",
                sx: {
                    mx: 3,
                    whiteSpace: "nowrap"
                },
                children: t("or")
            })
        })
    });
};
var SignUpTemplate_TextLinkCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        display: "flex",
        sx: {
            mt: 2,
            py: 4
        },
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
            underline: "none",
            href: routerPages.SignUpArtist,
            variant: "subtitle1",
            children: t("textToRegisterArtist")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUp/template/MailAuthForm.tsx












var template_MailAuthForm_schema = function(o) {
    return {
        code: o.string().length(6).label((0,core_form/* tLabel */.TQ)("signUp.code"))
    };
};
/**
 *  MailAuth Form Organism.
 *
 *  This component is organism layer but is named suffix xxForm,
 *  because all of form components belong to Organism.
 */ var MailAuthForm_MailAuthForm = function(param) {
    var loading = param.loading, onSubmitMailAuth = param.onSubmitMailAuth, onResendAuthMail = param.onResendAuthMail;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var ref = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref.showMessage, showError = ref.showError;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages, generatePath = ref1.generatePath;
    var ref2 = (0,core_form/* useForm */.cI)({
        schema: template_MailAuthForm_schema
    }), handleSubmit = ref2.handleSubmit, register = ref2.register, _formState = ref2.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onVerify = handleSubmit(function(values) {
        return onSubmitMailAuth(values).then(function(redirect) {
            if (!redirect) {
                return;
            }
            config_config/* config.modules.tutorial */.v.modules.tutorial ? router.push(routerPages.Tutorial) : (config_config/* config */.v === null || config_config/* config */.v === void 0 ? void 0 : config_config/* config.artistId */.v.artistId) ? router.push(generatePath(routerPages.ArtistTop, {
                artistId: config_config/* config.artistId */.v.artistId
            })) : router.push(routerPages.GlobalHome);
        }).catch(function(e) {
            return showError(e);
        });
    });
    var onReSend = function() {
        return onResendAuthMail().then(function() {
            return showMessage(t("resended"));
        }).catch(function(e) {
            return showError(e);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onVerify,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_MailAuthForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                type: "text",
                error: errors === null || errors === void 0 ? void 0 : errors.code
            }, register("code"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_MailAuthForm_ResendButtonCell, {
                onResendAuthMail: onReSend,
                loading: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_MailAuthForm_ButtonCell, {
                loading: isSubmitting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm_NoEmailReceivedCell, {})
        ]
    });
};
var template_MailAuthForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            textFieldProps: {
                sx: {
                    mb: 0
                }
            },
            titleProps: {
                sx: {
                    display: "none"
                }
            }
        }))
    });
});
var template_MailAuthForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};
var template_MailAuthForm_ResendButtonCell = function(param) {
    var onResendAuthMail = param.onResendAuthMail, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            sx: {
                textAlign: "right"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                size: "small",
                variant: "text",
                onClick: onResendAuthMail,
                loading: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    color: "text.info",
                    children: t("resend")
                })
            })
        })
    });
};
/**
 * 認証メールが届かない場合のリンク表示用セル
 */ var MailAuthForm_NoEmailReceivedCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("noEmailReceived")).onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            component: "span",
            variant: "subtitle1",
            color: "primary.main",
            sx: {
                fontSize: 14,
                cursor: "pointer"
            },
            onClick: onClick,
            children: t("noEmailReceived")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUp/template/MailAuthTemplate.tsx







var MailAuthTemplate_MailAuthTemplate = function(param) {
    var state = param.state, onSubmitMailAuth = param.onSubmitMailAuth, onResendAuthMail = param.onResendAuthMail;
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthTemplate_TextCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthForm_MailAuthForm, {
                loading: state.verifyEmailSending,
                onSubmitMailAuth: onSubmitMailAuth,
                onResendAuthMail: onResendAuthMail
            })
        ]
    });
};
var MailAuthTemplate_TextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("mailAuth").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "text.primary",
            children: t("description")
        })
    });
};

// EXTERNAL MODULE: ./src/components/pages/SignUp/viewModel.ts + 1 modules
var SignUp_viewModel = __webpack_require__(79465);
;// CONCATENATED MODULE: ./src/components/pages/SignUp/index.tsx





var SignUp = function() {
    var ref = (0,SignUp_viewModel/* useViewModel */.D)(), state = ref.state, actions = ref.actions;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref1 = (0,react.useState)(0), step = ref1[0], nextStep = ref1[1];
    var onSubmitSignUp = function(inputs) {
        return actions.signUp(inputs).then(function() {
            return nextStep(1);
        }).catch(function(e) {
            showError(e);
        });
    };
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpTemplate, {
            state: state,
            onSubmitSignUp: onSubmitSignUp,
            onSignUpWithApple: actions.signUpWithApple,
            onSignUpWithGoogle: actions.signUpWithGoogle
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(MailAuthTemplate_MailAuthTemplate, {
            state: state,
            onSubmitMailAuth: actions.verifyAccount,
            onResendAuthMail: actions.resendVerifyMail
        }), 
    ][step];
};

;// CONCATENATED MODULE: ./src/components/pages/SignUpArtist/template/SignUpArtistForm.tsx










var SignUpArtistForm_schema = function(o) {
    return {
        displayName: o.string().max(50).label((0,core_form/* tLabel */.TQ)("signUpArtist.displayName")),
        accountId: o.string().pattern(new RegExp(/^[a-zA-Z0-9_]*$/)).max(20).label((0,core_form/* tLabel */.TQ)("signUpArtist.accountId")),
        email: o.string().regex(core_form/* formRegex.email */.rE.email).custom(function(value, helpers) {
            // 先頭に記号があるかチェック
            var match = value.match(/^([=+\-@])/);
            if (match) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("common:inputStartsWithSymbol", {
                        symbol: match[1],
                        label: (0,core_form/* tLabel */.TQ)("signUp.email")
                    })
                });
            }
            // 特殊文字チェック
            var specialCharsRegex = /[=;\t\n\r,]/;
            var specialCharsMatch = value.match(specialCharsRegex);
            if (specialCharsMatch) {
                return helpers.message({
                    custom: (0,core_form/* tMessage */.Sd)("common:inputContainSpecialChars", {
                        label: (0,core_form/* tLabel */.TQ)("signUp.email")
                    })
                });
            }
            return value;
        }).label((0,core_form/* tLabel */.TQ)("signUpArtist.email")),
        password: o.string().min(8).max(30).label((0,core_form/* tLabel */.TQ)("signUpArtist.password")),
        invitationCode: o.string().length(8).optional().allow("").label((0,core_form/* tLabel */.TQ)("signUpArtist.invitationCode"))
    };
};
var SignUpArtistForm = function(param) {
    var invitationCode = param.invitationCode, onSignUp = param.onSignUp, onSignUpWithApple = param.onSignUpWithApple, onSignUpWithGoogle = param.onSignUpWithGoogle;
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    var ref = (0,core_form/* useForm */.cI)({
        schema: SignUpArtistForm_schema
    }), handleSubmit = ref.handleSubmit, register = ref.register, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    (0,react.useEffect)(function() {
        if (invitationCode) {
            reset({
                invitationCode: invitationCode
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        invitationCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        sx: {
            pb: 4,
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            onSubmit: handleSubmit(onSignUp),
            sx: {
                pt: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: errors === null || errors === void 0 ? void 0 : errors.displayName
                }, register("displayName"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "text",
                    error: errors === null || errors === void 0 ? void 0 : errors.accountId
                }, register("accountId"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    type: "email",
                    error: errors === null || errors === void 0 ? void 0 : errors.email
                }, register("email"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_PasswordInputCell, (0,src_object_spread/* default */.Z)({
                    error: errors === null || errors === void 0 ? void 0 : errors.password
                }, register("password"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_TextInputCell, (0,src_object_spread/* default */.Z)({
                    error: errors === null || errors === void 0 ? void 0 : errors.invitationCode,
                    type: "number",
                    titleProps: {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("invitationCode")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    children: [
                                        "(",
                                        t("invitationCodeNote"),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }
                }, register("invitationCode"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm_ButtonCell, {
                    loading: isSubmitting
                })
            ]
        })
    });
};
var SocialSignUpCell = function(param) {
    var onSignUpWithApple = param.onSignUpWithApple, onSignUpWithGoogle = param.onSignUpWithGoogle;
    return /*#__PURE__*/ _jsx(CellFrame, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            justifyContent: "center",
            direction: "row",
            spacing: 5,
            sx: {
                py: 3
            },
            children: [
                /*#__PURE__*/ _jsx(IconButton.Google, {
                    sx: {
                        bgcolor: config.theme.dark ? "white" : "grey.50"
                    },
                    onClick: onSignUpWithGoogle
                }),
                getPlatform() !== "android" && /*#__PURE__*/ _jsx(IconButton.Apple, {
                    sx: {
                        bgcolor: config.theme.dark ? "white" : "#221f20"
                    },
                    onClick: onSignUpWithApple,
                    isDark: config.theme.dark
                })
            ]
        })
    });
};
var SignUpArtistForm_SupplementTextCell = function() {
    var t = useTranslation("signUp").t;
    return /*#__PURE__*/ _jsx(CellFrame, {
        children: /*#__PURE__*/ _jsx(Stack, {
            sx: {
                py: 3
            },
            children: /*#__PURE__*/ _jsx(Divider, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    sx: {
                        mx: 3,
                        whiteSpace: "nowrap"
                    },
                    children: t("or")
                })
            })
        })
    });
};
var SignUpArtistForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t
        }))
    });
});
var SignUpArtistForm_PasswordInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    var _$ref1 = (0,react.useState)(false), showPassword = _$ref1[0], setShowPassword = _$ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            type: showPassword ? "text" : "password"
        }, props), {
            textFieldProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.textFieldProps), {
                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (_$ref = props.textFieldProps) === null || _$ref === void 0 ? void 0 : _$ref.InputProps), {
                    inputProps: {
                        variant: "body2",
                        sx: {
                            px: 4,
                            py: 3
                        }
                    },
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Display, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Hide, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            }
                        })
                    })
                })
            }),
            ref: ref,
            t: t
        }))
    });
});
var SignUpArtistForm_ButtonCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("signUp").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            type: "submit",
            size: "large",
            sx: {
                width: 244
            },
            loading: loading,
            children: t("submit")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUpArtist/template/SignUpSwitch.tsx







var SignUpSwitch = function(param) {
    var onSignUpSwitch = param.onSignUpSwitch;
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    var ref = (0,react.useState)(false), open = ref[0], openModal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            sx: {
                                pt: 2,
                                pb: 4
                            },
                            children: t("registerSwitchContent")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                py: 3
                            },
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                type: "submit",
                                size: "large",
                                sx: {
                                    width: 244
                                },
                                onClick: function() {
                                    return openModal(true);
                                },
                                children: t("toRegister")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return openModal(false);
                },
                title: t("titleModalSwitch"),
                content: t("contentModalSwitch"),
                cancelText: t("closeModalSwitch"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 212
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        onSignUpSwitch()
                                    ];
                                case 1:
                                    _state.sent();
                                    openModal(false);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: "ok"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUpArtist/template/index.tsx








var SignUpArtistTemplate = function(param) {
    var state = param.state, onSignUp = param.onSignUp, onSignUpWithApple = param.onSignUpWithApple, onSignUpWithGoogle = param.onSignUpWithGoogle, onSignUpSwitch = param.onSignUpSwitch;
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.SignUpArtist
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    title: t("title"),
                    back: true
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                        width: "100%",
                        src: "images/login/artist_explanation.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtist_template_HeadingTextCell, {}),
                    state.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpSwitch, {
                        onSignUpSwitch: onSignUpSwitch
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistForm, {
                        invitationCode: state.code,
                        onSignUp: onSignUp,
                        onSignUpWithApple: onSignUpWithApple,
                        onSignUpWithGoogle: onSignUpWithGoogle
                    })
                ]
            })
        ]
    });
};
var SignUpArtist_template_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("signUpArtist").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            px: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "h3",
            children: t("artistRegisterScreen")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SignUpArtist/viewModel.ts




function SignUpArtist_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ValidateAccount($input: ValidateAccountInput) {\n    validateAccount(inputs: $input) {\n      accountId\n      email\n    }\n  }\n"
    ]);
    SignUpArtist_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SignUpArtist_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var t = (0,core_i18n/* useTranslation */.$G)("firebase").t;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var refetch = (0,useQuery/* useQuery */.aM)(VALIDATE_ACCOUNT, {
        skip: true
    }).refetch;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationEmail */.ZCf, {
        onCompleted: function onCompleted() {
            router.push(routerPages.MailAuthArtist);
        }
    }), 1), sendVerificationEmail = ref1[0];
    return {
        state: {
            user: user,
            code: router.query.code
        },
        actions: {
            onSignUp: function onSignUp(param) {
                var displayName = param.displayName, accountId = param.accountId, email = param.email, password = param.password, invitationCode = param.invitationCode;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    refetch({
                                        input: {
                                            email: email,
                                            accountId: accountId
                                        }
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                /**
         * @note
         * validateAccountクエリで既存のメールアドレス・アカウントIDがないか確認し、
         * すでに存在している場合はエラーメッセージを表示する
         */ if (!data.validateAccount.email) {
                                    showError(new Error(t("auth.errors.auth/email-already-in-use")));
                                    return [
                                        2
                                    ];
                                }
                                if (!data.validateAccount.accountId) {
                                    showError(new Error(t("auth.errors.auth/uid-already-exists")));
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    sendVerificationEmail({
                                        variables: {
                                            email: email
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* setInputSignUpArtist */._V)({
                                        displayName: displayName,
                                        accountId: accountId,
                                        email: email,
                                        password: password,
                                        invitationCode: invitationCode
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSignUpSwitch: function onSignUpSwitch() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onSignUpWithApple: function onSignUpWithApple() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            },
            onSignUpWithGoogle: function onSignUpWithGoogle() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var VALIDATE_ACCOUNT = (0,lib/* gql */.Ps)(SignUpArtist_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/SignUpArtist/index.tsx




/**
 * SignUpArtist Page
 * Implemented as a practical sample.
 */ var SignUpArtist = function() {
    var ref = SignUpArtist_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpArtistTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/pages/SMSVerification/template/SMSVerificationForm.tsx
var SMSVerificationForm = __webpack_require__(53906);
;// CONCATENATED MODULE: ./src/components/pages/SMSVerification/template/index.tsx






var SMSVerificationTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onResend = param.onResend;
    var t = (0,core_i18n/* useTranslation */.$G)("smsVerification").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.SMSVerification
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: {
                    back: true,
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        sx: {
                            pt: 2
                        },
                        children: t("description", {
                            phoneNumber: state.phoneNumber
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SMSVerificationForm/* SMSVerificationForm */.I, {
                        loading: state.loading,
                        onSubmit: onSubmit,
                        onResend: onResend
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/SMSVerification/viewModel.ts






function SMSVerification_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SMSVerification {\n    user {\n      ...UserDeliveryDetail\n    }\n  }\n  ",
        "\n"
    ]);
    SMSVerification_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SMSVerification_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query preSaleDetail($id: ID!, $clientId: String, $token: String) {\n    preSale(id: $id, clientId: $clientId, token: $token) {\n      id\n      lottery {\n        personalInformationRequirements\n      }\n      firstComeFirstServed {\n        personalInformationRequirements\n      }\n    }\n  }\n"
    ]);
    SMSVerification_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SMSVerification_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifySMSCode($code: String!) {\n    verifySMSCode(code: $code) {\n      verified\n    }\n  }\n"
    ]);
    SMSVerification_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var SMSVerification_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), router = ref1.router, routerPages = ref1.routerPages;
    var rootAuthInfo = useRootAuth();
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("smsVerification").t;
    var ref2 = (0,useQuery/* useQuery */.aM)(SMSVerification_viewModel_QUERY), data = ref2.data, refetch = ref2.refetch;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(PRE_SALE), 1), getPreSaleDetail = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VERIFY_SMS_CODE), 2), verifySMSCode = ref4[0], ref5 = ref4[1], verifying = ref5.loading;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 1), sendVerificationSMS = ref6[0];
    var ref7;
    return {
        state: {
            loading: verifying,
            phoneNumber: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.formattedPhoneNumber) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {
            onSubmit: function onSubmit(param) {
                var code = param.code;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var value, ref, ref1, ref2, ref3, ref4, preSale, personalInformationRequirements, userInfoRegisterRedirect, redirectPath;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    verifySMSCode({
                                        variables: {
                                            code: code
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch()
                                ];
                            case 2:
                                _state.sent();
                                showMessage(t("verificationCodeSuccess"), "success");
                                return [
                                    4,
                                    (0,storage/* getPrefrenceObject */._d)("preSaleLotteryApplicationInput")
                                ];
                            case 3:
                                value = _state.sent();
                                if (!(value === null || value === void 0 ? void 0 : value.preSaleId)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    getPreSaleDetail({
                                        variables: {
                                            id: value.preSaleId,
                                            // クエリパラメータで取得したROOT認証情報を付与する UT-15288
                                            clientId: rootAuthInfo.clientId,
                                            token: rootAuthInfo.token
                                        }
                                    })
                                ];
                            case 4:
                                preSale = _state.sent();
                                personalInformationRequirements = (value === null || value === void 0 ? void 0 : value.isFirstComeFirstServed) ? (ref = preSale.data) === null || ref === void 0 ? void 0 : (ref1 = ref.preSale) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.firstComeFirstServed) === null || ref2 === void 0 ? void 0 : ref2.personalInformationRequirements : (ref4 = (ref3 = preSale.data) === null || ref3 === void 0 ? void 0 : ref3.preSale.lottery) === null || ref4 === void 0 ? void 0 : ref4.personalInformationRequirements;
                                if (needToRegisterUserAddress(personalInformationRequirements !== null && personalInformationRequirements !== void 0 ? personalInformationRequirements : [], data === null || data === void 0 ? void 0 : data.user)) {
                                    return [
                                        2,
                                        router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryDeliveryInfo, {
                                            preSaleId: value.preSaleId
                                        }))
                                    ];
                                }
                                router.goBack();
                                return [
                                    2,
                                    router.replace((0,react_router/* generatePath */.Gn)(routerPages.LotteryConfirmation, {
                                        preSaleId: value.preSaleId
                                    }))
                                ];
                            case 5:
                                return [
                                    4,
                                    (0,storage/* getUserInfoRegisterRedirect */.j6)()
                                ];
                            case 6:
                                userInfoRegisterRedirect = _state.sent();
                                if (!userInfoRegisterRedirect) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    (0,storage/* setUserInfoRegisterRedirect */.Yx)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userInfoRegisterRedirect), {
                                        phoneNumber: true
                                    }))
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                redirectPath = userInfoRegisterRedirect.address ? routerPages.StoreDeliveryInfo : userInfoRegisterRedirect.direction;
                                if (!redirectPath) {
                                    router.goBack();
                                    return [
                                        2
                                    ];
                                }
                                router.push(redirectPath);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onResend: function onResend() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var SMSVerification_viewModel_QUERY = (0,lib/* gql */.Ps)(SMSVerification_viewModel_templateObject(), utoniq_core_schema/* UserDeliveryDetailFragmentDoc */.TRY);
var PRE_SALE = (0,lib/* gql */.Ps)(SMSVerification_viewModel_templateObject1());
var VERIFY_SMS_CODE = (0,lib/* gql */.Ps)(SMSVerification_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/SMSVerification/index.tsx




/**
 * SMSVerification Page
 * Implemented as a practical sample.
 */ var SMSVerification = function() {
    var ref = SMSVerification_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SMSVerificationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCartDetail/template/index.tsx


















var StoreCartDetailTemplate = function(param) {
    var state = param.state, onAddToCart = param.onAddToCart, onRemoveFromCart = param.onRemoveFromCart, onValidateCart = param.onValidateCart;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref4.routerPages, router = ref4.router, generatePath = ref4.generatePath;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        header: (0,src_object_spread/* default */.Z)({
            back: true,
            defaultBackPage: routerPages.StoreCartList,
            title: ((ref = state.cart) === null || ref === void 0 ? void 0 : ref.artist.displayName) ? ((ref1 = state.cart) === null || ref1 === void 0 ? void 0 : ref1.artist.displayName) + t("title") : ""
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        customNavigation: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCartDetail_template_FixedBottomCell, {
            loading: state.loading,
            isSubmitting: state.isSubmitting,
            onValidateCart: onValidateCart,
            isAnonymous: state.isAnonymous,
            personalInformationRequirements: state.personalInformationRequirements
        })
    }, displayResponsive ? {
        customNavigationSx: {
            maxWidth: "100%"
        },
        responsive: true
    } : {}), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreInfoCell, {
                loading: state.loading,
                artist: (ref5 = (ref2 = state.cart) === null || ref2 === void 0 ? void 0 : ref2.artist) !== null && ref5 !== void 0 ? ref5 : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCartDetail_template_OrderDetailCell, {
                loading: state.loading,
                changingQualityCart: state.changingQualityCart,
                cartItems: state.cartItems,
                formattedTotalPrice: (ref6 = (ref3 = state.cart) === null || ref3 === void 0 ? void 0 : ref3.formattedTotalPrice) !== null && ref6 !== void 0 ? ref6 : "0",
                cartItemsByCollection: state.cartItemsByCollection,
                errors: state.errors,
                onAddToCart: onAddToCart,
                addToCartErrors: state.addToCartErrors,
                onRemoveFromCart: onRemoveFromCart
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    pb: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.CautionText, {
                        type: "normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.scondary",
                            children: t("buyItemNote")
                        })
                    })
                })
            })
        ]
    }));
};
var StoreInfoCell = function(param) {
    var loading = param.loading, artist = param.artist;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    if (loading || !artist) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreInfoSkeleton, {});
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("storeInfo")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: !artist ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateCell, {
                    message: t("storeInfoEmptyMessage")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref1 = artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref1 !== void 0 ? ref1 : "",
                                sx: {
                                    width: 40,
                                    height: 40
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        children: artist.displayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: artist.introduction
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var StoreInfoSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    alignItems: "center",
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "circular",
                            sx: {
                                width: 40,
                                height: 40
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var StoreCartDetail_template_OrderDetailCell = function(param) {
    var loading = param.loading, changingQualityCart = param.changingQualityCart, formattedTotalPrice = param.formattedTotalPrice, errors = param.errors, cartItems = param.cartItems, onAddToCart = param.onAddToCart, onRemoveFromCart = param.onRemoveFromCart, cartItemsByCollection = param.cartItemsByCollection, addToCartErrors = param.addToCartErrors;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    var paymentType = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        if (!(cartItemsByCollection === null || cartItemsByCollection === void 0 ? void 0 : cartItemsByCollection.length) || !((ref = cartItemsByCollection[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length) || !((ref3 = (ref2 = cartItemsByCollection[0]) === null || ref2 === void 0 ? void 0 : ref2.items[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.paymentType)) return utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint;
        return cartItemsByCollection[0].items[0].item.paymentType;
    }, [
        cartItemsByCollection
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("orderDetail")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: !(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyStateCell, {
                    message: t("orderDetailEmptyMessage")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            spacing: 5,
                            sx: {
                                mt: 1
                            },
                            children: cartItemsByCollection === null || cartItemsByCollection === void 0 ? void 0 : cartItemsByCollection.map(function(param) {
                                var collection = param.collection, items = param.items;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 4,
                                    children: [
                                        collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: collection === null || collection === void 0 ? void 0 : collection.title
                                        }),
                                        items.map(function(cartItem) {
                                            var ref;
                                            var addToCartError = addToCartErrors === null || addToCartErrors === void 0 ? void 0 : addToCartErrors.find(function(param) {
                                                var itemId = param.itemId;
                                                return itemId === cartItem.item.id;
                                            });
                                            var ref1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCartDetail_template_OrderItemCell, {
                                                        userCartItem: cartItem,
                                                        errors: errors,
                                                        changingQualityCart: changingQualityCart,
                                                        paymentType: paymentType,
                                                        onPlus: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                            var ref;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                onAddToCart(cartItem.item.id, (ref = cartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }),
                                                        onMinus: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                            var ref;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                onRemoveFromCart(cartItem.item.id, 1, (ref = cartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }),
                                                        onDelete: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                                                            var ref;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                onRemoveFromCart(cartItem.item.id, cartItem.count, (ref = cartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id, true);
                                                                return [
                                                                    2
                                                                ];
                                                            });
                                                        }),
                                                        addToCartErrorMessage: addToCartError === null || addToCartError === void 0 ? void 0 : addToCartError.userMessage
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
                                                ]
                                            }, cartItem.item.id + ((ref1 = (ref = cartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : ""));
                                        })
                                    ]
                                }, collection === null || collection === void 0 ? void 0 : collection.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    children: t("paymentAmount")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    gap: 1,
                                    children: [
                                        paymentType === utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: [
                                                paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && "\xa5",
                                                formattedTotalPrice
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var StoreCartDetail_template_OrderItemCell = function(param) {
    var userCartItem = param.userCartItem, errors = param.errors, changingQualityCart = param.changingQualityCart, paymentType = param.paymentType, onPlus = param.onPlus, onMinus = param.onMinus, onDelete = param.onDelete, addToCartErrorMessage = param.addToCartErrorMessage;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var error = (0,react.useMemo)(function() {
        if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
            return;
        }
        return errors.find(function(er) {
            var ref;
            return (er === null || er === void 0 ? void 0 : er.skuId) === ((ref = userCartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id) && er.itemId === userCartItem.item.id;
        });
    }, [
        errors,
        userCartItem.item.id,
        (ref = userCartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var formattedPrice = (0,react.useMemo)(function() {
        var ref;
        if ((ref = userCartItem.item.sku) === null || ref === void 0 ? void 0 : ref.price) {
            var ref1;
            return (ref1 = userCartItem.item.sku) === null || ref1 === void 0 ? void 0 : ref1.formattedPrice;
        }
        return userCartItem.item.formattedPrice;
    }, [
        userCartItem.item.formattedPrice,
        (ref1 = userCartItem.item.sku) === null || ref1 === void 0 ? void 0 : ref1.formattedPrice,
        (ref2 = userCartItem.item.sku) === null || ref2 === void 0 ? void 0 : ref2.price, 
    ]);
    if (!userCartItem.item.issuedArtist) return null;
    var ref7;
    var skuUnitName = (ref7 = (ref3 = userCartItem.item.sku) === null || ref3 === void 0 ? void 0 : ref3.unitName) !== null && ref7 !== void 0 ? ref7 : null;
    var storeLink = generatePath(routerPages.ArtistStoreItemDetail, {
        itemId: userCartItem.item.id,
        artistId: userCartItem.item.issuedArtist.id
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            spacing: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: storeLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        variant: "square",
                        src: (ref4 = userCartItem.item.thumbnail.front) === null || ref4 === void 0 ? void 0 : ref4.uri,
                        sx: {
                            width: 60,
                            height: 96,
                            "& > img": {
                                objectFit: "contain"
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    flex: 1,
                    sx: {
                        minWidth: 0,
                        alignSelf: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            href: storeLink,
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                width: "fit-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    gap: 4,
                                    sx: {
                                        pt: !((ref5 = userCartItem.item.sku) === null || ref5 === void 0 ? void 0 : ref5.unitName) ? 2 : 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,src_object_spread/* default */.Z)({}, styles/* styleSets.lineCamp */.k$.lineCamp(1))), {
                                                whiteSpace: "pre-wrap"
                                            }),
                                            children: userCartItem.item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.RightArrow, {
                                            fontSize: "xSmall",
                                            sx: {
                                                mb: "3px"
                                            }
                                        })
                                    ]
                                }),
                                !!skuUnitName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: skuUnitName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    gap: 1,
                                    children: [
                                        paymentType === utoniq_core_schema/* UserPaymentType.PrepaidPoint */.B9$.PrepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                            sx: {
                                                fontSize: 16
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            sx: {
                                                pt: 1
                                            },
                                            children: [
                                                paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash && "\xa5",
                                                formattedPrice
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            direction: "row-reverse",
                            sx: {
                                pt: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "center",
                                        spacing: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                onClick: onDelete,
                                                disabled: changingQualityCart,
                                                variant: "text",
                                                sx: {
                                                    typography: "overline",
                                                    color: "text.secondary"
                                                },
                                                children: t("delete")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityPicker, {
                                                value: userCartItem.count,
                                                onPlus: onPlus,
                                                onMinus: onMinus,
                                                error: !!error
                                            })
                                        ]
                                    }),
                                    (!!error || !!addToCartErrorMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                        error: true,
                                        sx: {
                                            bgcolor: "transparent"
                                        },
                                        children: addToCartErrorMessage ? addToCartErrorMessage : error === null || error === void 0 ? void 0 : error.userMessage
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var OrderDetailSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2,
                    px: 5,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            spacing: 3,
                            sx: {
                                pb: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    sx: {
                                        width: 60,
                                        height: 96
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    flex: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "large",
                                            width: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            direction: "row-reverse",
                                            sx: {
                                                pt: 4
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                                variant: "large",
                                                width: "40%"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "30%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "30%"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var EmptyStateCell = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            color: "text.secondary",
            align: "center",
            children: message
        })
    });
};
var StoreCartDetail_template_FixedBottomCell = function(param) {
    var loading = param.loading, isSubmitting = param.isSubmitting, onValidateCart = param.onValidateCart, isAnonymous = param.isAnonymous, personalInformationRequirements = param.personalInformationRequirements;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4,
            textAlign: "center",
            bgcolor: "grey.50"
        },
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            sx: {
                width: 244,
                height: 44,
                borderRadius: 34,
                mx: "auto"
            }
        }) : isAnonymous ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                gap: 2,
                maxWidth: "244px",
                m: "auto"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 244
                    },
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,storage/* setRedirectAfterLoginPath */.fu)(personalInformationRequirements.length ? routerPages.StoreUserInfo : router.pathname)
                                    ];
                                case 1:
                                    _state.sent();
                                    router.push(routerPages.SignUp);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    children: t("signUp", "新規登録して購入手続きへ")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    sx: {
                        minWidth: 244
                    },
                    variant: "text",
                    href: "".concat(routerPages.Login, "?redirectUri=").concat(encodeURIComponent(personalInformationRequirements.length ? routerPages.StoreUserInfo : router.pathname)),
                    children: t("login", "ログインして購入手続きへ")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                minWidth: 244
            },
            loading: isSubmitting,
            onClick: onValidateCart,
            children: t("paymentMethodSetting")
        })
    });
};

// EXTERNAL MODULE: ./src/app/router/routes.ts
var routes = __webpack_require__(78351);
;// CONCATENATED MODULE: ./src/components/pages/StoreCartDetail/viewModel.ts







function StoreCartDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserCart($id: ID!) {\n    userCart(id: $id) {\n      ...StoreCardDetail\n    }\n    user {\n      id\n      fullName\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    StoreCartDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StoreCartDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ValidateCart($inputs: ValidateCartInput!) {\n    validateCart(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    StoreCartDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StoreCartDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddToCart($inputs: AddToCartInput!) {\n    addToCart(inputs: $inputs) {\n      id\n      totalCount\n      totalPrice @client\n      formattedTotalPrice @client\n      items {\n        count\n        totalPrice @client\n        formattedTotalPrice @client\n        item {\n          id\n          price\n          hideSalesNumber\n        }\n        skus {\n          skuId\n          count\n          sku {\n            id\n            price\n            formattedPrice @client\n            unitName\n            thumbnail {\n              uri\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    StoreCartDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StoreCartDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveFromCart($inputs: RemoveFromCartInput!) {\n    removeFromCart(inputs: $inputs) {\n      id\n      totalCount\n      totalPrice @client\n      formattedTotalPrice @client\n      items {\n        count\n        totalPrice @client\n        formattedTotalPrice @client\n        item {\n          id\n          price\n          hideSalesNumber\n        }\n        skus {\n          skuId\n          count\n          sku {\n            id\n            price\n            formattedPrice @client\n            unitName\n            thumbnail {\n              uri\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    StoreCartDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var StoreCartDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartDetail").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, routerPages = ref5.routerPages, generatePath = ref5.generatePath;
    var cartId = router.query.cartId;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref6 = (0,useQuery/* useQuery */.aM)(StoreCartDetail_viewModel_QUERY, {
        variables: {
            id: cartId
        },
        onCompleted: function onCompleted(param) {
            var userCart = param.userCart;
            if (!userCart) {
                router.goBack(routerPages.StoreCartList);
            }
        }
    }), data = ref6.data, loading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(VALIDATE_CART, {
        onCompleted: // バリデーションチェック後、カートのアイテムとユーザーの登録状態から適切な遷移先に遷移する
        function onCompleted() {
            return (0,src_async_to_generator/* default */.Z)(function() {
                var userInfoRegisterRedirect, redirectPath;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,storage/* getUserInfoRegisterRedirect */.j6)()
                            ];
                        case 1:
                            userInfoRegisterRedirect = _state.sent();
                            redirectPath = userInfoRegisterRedirect.phoneNumber ? routes/* routes.StoreUserInfo.path */._j.StoreUserInfo.path : userInfoRegisterRedirect.address ? routerPages.StoreDeliveryInfo : userInfoRegisterRedirect.direction;
                            router.push(redirectPath);
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        onError: function onError(e) {
            var ref, ref1, ref2;
            var ref3;
            showError((ref3 = (ref = e.graphQLErrors[0].extensions) === null || ref === void 0 ? void 0 : ref.userMessage) !== null && ref3 !== void 0 ? ref3 : t("verifyCardErrorMessage"));
            var ref4;
            analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                artistId: data === null || data === void 0 ? void 0 : (ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.artist.id,
                error: e.name,
                errorCode: (ref4 = (ref2 = e.graphQLErrors[0].extensions) === null || ref2 === void 0 ? void 0 : ref2.errorCode) !== null && ref4 !== void 0 ? ref4 : ""
            });
        }
    }), 2), validateCart = ref7[0], ref8 = ref7[1], validatingCart = ref8.loading, error = ref8.error;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ADD_TO_CART), 2), addToCart = ref9[0], ref10 = ref9[1], addingToCart = ref10.loading, addToCartError = ref10.error;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REMOVE_FROM_CART), 2), removeFromCart = ref11[0], ref12 = ref11[1], removingFromCart = ref12.loading;
    var ref13;
    // SKUのあるアイテムを分割
    var cartItems = convertUserCartItemsToSku((ref13 = data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.items) !== null && ref13 !== void 0 ? ref13 : null);
    var personalInformationRequirements = (0,react.useMemo)(function() {
        if (!cartItems) return [];
        var result = cartItems.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        cartItems
    ]);
    /** 遷移先をコンテキストにセットする */ (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        // 電番登録が必要か
        var requirePhoneNumber = !((data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.phoneNumber) && (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.isPhoneNumberVerified)) && personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber);
        // 住所登録が必要か
        var requireAddRess = !(data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.fullAddress) && personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address);
        (0,storage/* setUserInfoRegisterRedirect */.Yx)({
            direction: generatePath(routerPages.StoreItemPurchaseProceed, {
                cartId: cartId
            }),
            phoneNumber: requirePhoneNumber,
            address: requireAddRess
        });
    }, [
        data === null || data === void 0 ? void 0 : data.user,
        personalInformationRequirements
    ]);
    (0,react.useEffect)(function() {
        (0,storage/* removeStoreProceed */.N_)();
    }, []);
    var ref14;
    return {
        state: {
            loading: useInitialLoading(data, loading),
            isAnonymous: !!(user === null || user === void 0 ? void 0 : user.isAnonymous),
            cart: (ref14 = data === null || data === void 0 ? void 0 : data.userCart) !== null && ref14 !== void 0 ? ref14 : null,
            isSubmitting: validatingCart,
            cartItems: cartItems,
            changingQualityCart: removingFromCart || addingToCart,
            cartItemsByCollection: groupItemsByCollection(cartItems),
            personalInformationRequirements: personalInformationRequirements,
            errors: error === null || error === void 0 ? void 0 : (ref1 = error.graphQLErrors) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.extensions) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.exception) === null || ref4 === void 0 ? void 0 : ref4.errors,
            addToCartErrors: addToCartError === null || addToCartError === void 0 ? void 0 : addToCartError.graphQLErrors.map(function(e) {
                return e.extensions.exception;
            })
        },
        actions: {
            onValidateCart: function onValidateCart() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(data === null || data === void 0 ? void 0 : data.userCart)) return [
                                    2
                                ];
                                return [
                                    4,
                                    validateCart({
                                        variables: {
                                            inputs: {
                                                cartId: data.userCart.id,
                                                totalPrice: data.userCart.totalPrice,
                                                isKonbini: false
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAddToCart: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(itemId, skuId) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!(data === null || data === void 0 ? void 0 : data.userCart)) return [
                            2
                        ];
                        return [
                            2,
                            addToCart({
                                variables: {
                                    inputs: {
                                        itemId: itemId,
                                        skuId: skuId,
                                        count: 1
                                    }
                                },
                                optimisticResponse: {
                                    addToCart: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.userCart), {
                                        totalCount: data.userCart.totalCount + 1,
                                        items: data.userCart.items.map(function(item) {
                                            if (!skuId) {
                                                return item.item.id === itemId ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                                    count: item.count + 1
                                                }) : item;
                                            }
                                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                                skus: item.skus.map(function(sku) {
                                                    if (sku.skuId !== skuId) return sku;
                                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, sku), {
                                                        count: sku.count + 1
                                                    });
                                                })
                                            });
                                        })
                                    })
                                }
                            }).then(function(param) {
                                var _data = param.data;
                                var ref, ref1, ref2, ref3, ref4;
                                var targetItem = data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.items.find(function(item) {
                                    return item.item.id === itemId;
                                });
                                var ref5;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("add_to_cart", {
                                    item_list_id: "artist_store_list_".concat(data === null || data === void 0 ? void 0 : (ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.artist.id),
                                    item_list_name: "Artist Store Items",
                                    isAnonymous: !!(user === null || user === void 0 ? void 0 : user.isAnonymous),
                                    items: [
                                        {
                                            item_id: itemId,
                                            item_name: targetItem === null || targetItem === void 0 ? void 0 : targetItem.item.title,
                                            item_category: "store_item",
                                            item_category2: targetItem === null || targetItem === void 0 ? void 0 : (ref2 = targetItem.item) === null || ref2 === void 0 ? void 0 : ref2.type,
                                            item_category3: native_app/* getPlatform */.Xf(),
                                            item_category4: skuId,
                                            item_category5: data === null || data === void 0 ? void 0 : (ref3 = data.userCart) === null || ref3 === void 0 ? void 0 : ref3.artist.id,
                                            price: (ref5 = targetItem === null || targetItem === void 0 ? void 0 : (ref4 = targetItem.item) === null || ref4 === void 0 ? void 0 : ref4.price) !== null && ref5 !== void 0 ? ref5 : 0,
                                            quantity: 1
                                        }, 
                                    ]
                                });
                            }).catch(function(e) {
                                var ref, ref1;
                                var ref2;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    artistId: data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.artist.id,
                                    error: e.name,
                                    errorCode: (ref2 = (ref1 = e.graphQLErrors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.errorCode) !== null && ref2 !== void 0 ? ref2 : ""
                                });
                                showError(e);
                            })
                        ];
                    });
                });
                return function(itemId, skuId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onRemoveFromCart: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(itemId, count, skuId, removeAll) {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (!(data === null || data === void 0 ? void 0 : data.userCart)) return [
                            2
                        ];
                        return [
                            2,
                            removeFromCart({
                                variables: {
                                    inputs: {
                                        itemId: itemId,
                                        cartId: cartId,
                                        skuId: skuId,
                                        count: count
                                    }
                                },
                                optimisticResponse: {
                                    removeFromCart: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data.userCart), {
                                        totalCount: data.userCart.totalCount - count,
                                        items: ((ref = data.userCart) === null || ref === void 0 ? void 0 : ref.totalCount) === count ? [] : data.userCart.items.filter(function(item) {
                                            return !(item.item.id === itemId && removeAll);
                                        }).flatMap(function(item) {
                                            if (item.item.id !== itemId) {
                                                return item;
                                            }
                                            if (!skuId) {
                                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                                    count: item.count - count
                                                });
                                            }
                                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                                                skus: item.skus.flatMap(function(sku) {
                                                    if (sku.skuId !== skuId) return sku;
                                                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, sku), {
                                                        count: sku.count - count
                                                    });
                                                })
                                            });
                                        })
                                    })
                                }
                            }).then(function(param) {
                                var _data = param.data;
                                var ref, ref1, ref2, ref3, ref4, ref5;
                                var targetItem = data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.items.find(function(item) {
                                    return item.item.id === itemId;
                                });
                                var ref6;
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("remove_from_cart", {
                                    item_list_id: "artist_store_list_".concat((ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.artist.id),
                                    item_list_name: "Artist Store Items",
                                    isAnonymous: user === null || user === void 0 ? void 0 : user.isAnonymous,
                                    items: [
                                        {
                                            item_id: itemId,
                                            item_name: targetItem === null || targetItem === void 0 ? void 0 : targetItem.item.title,
                                            item_category: "store_item",
                                            item_category2: targetItem === null || targetItem === void 0 ? void 0 : (ref2 = targetItem.item) === null || ref2 === void 0 ? void 0 : ref2.type,
                                            item_category3: native_app/* getPlatform */.Xf(),
                                            item_category4: skuId,
                                            item_category5: data === null || data === void 0 ? void 0 : (ref3 = data.userCart) === null || ref3 === void 0 ? void 0 : ref3.artist.id,
                                            price: ((ref6 = targetItem === null || targetItem === void 0 ? void 0 : (ref4 = targetItem.item) === null || ref4 === void 0 ? void 0 : ref4.price) !== null && ref6 !== void 0 ? ref6 : 0) * count,
                                            quantity: count
                                        }, 
                                    ]
                                });
                                if ((data === null || data === void 0 ? void 0 : (ref5 = data.userCart) === null || ref5 === void 0 ? void 0 : ref5.totalCount) === count) router.replace(routerPages.StoreCartList);
                            }).catch(showError)
                        ];
                    });
                });
                return function(itemId, count, skuId, removeAll) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var StoreCartDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreCartDetail_viewModel_templateObject(), utoniq_core_schema/* StoreCardDetailFragmentDoc */.Q2g, utoniq_core_schema/* UserAddressFragmentDoc */.enF);
var VALIDATE_CART = (0,lib/* gql */.Ps)(StoreCartDetail_viewModel_templateObject1());
var ADD_TO_CART = (0,lib/* gql */.Ps)(StoreCartDetail_viewModel_templateObject2());
var REMOVE_FROM_CART = (0,lib/* gql */.Ps)(StoreCartDetail_viewModel_templateObject3());

;// CONCATENATED MODULE: ./src/components/pages/StoreCartDetail/index.tsx





/**
 * StoreCartDetail Page
 * Implemented as a practical sample.
 */ var StoreCartDetail = function() {
    var ref = StoreCartDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (!state.loading && !state.cart) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCartDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCartList/template/index.tsx















var StoreCartListTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onDeleteCart = param.onDeleteCart;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCartList").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, routerNames = ref1.routerNames;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    // カート削除用state
    var ref2 = (0,react.useState)(null), cart = ref2[0], setCart = ref2[1];
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
        header: (0,src_object_spread/* default */.Z)({
            back: true,
            title: t("title")
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        maxWidth: displayResponsive ? 1120 : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
            sx: displayResponsive ? {
                px: {
                    sm: "20px"
                }
            } : {},
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.StoreCartList
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "large",
                        width: "50%"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        px: 5,
                        py: 2
                    },
                    children: t("cart")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    component: List_List/* default */.Z,
                    nodes: (ref = state.carts) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                        var node = param.node;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                            disablePadding: true,
                            secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
                                size: "small",
                                edge: "end",
                                sx: {
                                    bgcolor: "grey.100"
                                },
                                onClick: function() {
                                    return setCart(node);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Trash, {
                                    fontSize: "xSmall"
                                })
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
                                divider: true,
                                href: generatePath(routerPages.StoreCartDetail, {
                                    cartId: node.id
                                }),
                                onClick: function() {
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("click_select", {
                                        applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                        artistId: node.artist.id,
                                        name: "cartList"
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            src: (ref3 = node === null || node === void 0 ? void 0 : (ref = node.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref3 !== void 0 ? ref3 : "",
                                            sx: {
                                                width: 40,
                                                height: 40
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                        primary: node.artist.displayName,
                                        secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "caption",
                                                    children: t("itemNumber", {
                                                        number: node.totalCount
                                                    })
                                                }),
                                                node.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: [
                                                        "\xa5",
                                                        node.formattedTotalPrice
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                        direction: "row",
                                                        alignItems: "center",
                                                        gap: "2px",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                                                sx: {
                                                                    fontSize: 16
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                                variant: "subtitle2",
                                                                children: node.formattedTotalPrice
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        slotProps: {
                                            primary: {
                                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1)
                                            }
                                        }
                                    })
                                ]
                            })
                        });
                    }),
                    emptyMessage: t("cartEmptyMessage", "カート内に商品はありません。"),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                        children: Array.from(Array(3).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemSkeleton, {}, key);
                        })
                    }),
                    loading: state.loading,
                    hasNextPage: false,
                    onFetchMore: onFetchMore
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                    open: !!cart,
                    onClose: function() {
                        return setCart(null);
                    },
                    title: t("trashConfirmTitle", {
                        title: cart === null || cart === void 0 ? void 0 : cart.artist.displayName
                    }),
                    content: "",
                    cancelText: t("close", "閉じる"),
                    buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        sx: {
                            minWidth: 212
                        },
                        size: "large",
                        onClick: function() {
                            if (!cart) return;
                            analytics === null || analytics === void 0 ? void 0 : analytics.track("click_deleteCart", {
                                applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                artistId: cart.artist.id
                            });
                            onDeleteCart(cart === null || cart === void 0 ? void 0 : cart.id).finally(function() {
                                setCart(null);
                            });
                        },
                        loading: state.deleting,
                        children: t("remove", "削除する")
                    })
                })
            ]
        })
    });
};
var CartItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
        disablePadding: true,
        secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "circular",
            sx: {
                width: 24,
                height: 24
            }
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton_ListItemButton/* default */.Z, {
            divider: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemAvatar_ListItemAvatar/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        sx: {
                            width: 40,
                            height: 40
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                    primary: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "h3",
                        width: "75%"
                    }),
                    secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h4",
                                width: "30%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "h4",
                                width: "30%"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCartList/viewModel.ts




function StoreCartList_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreCartList($pageInput: PageInput) {\n    userCarts(pageInput: $pageInput) {\n      ...UserCartsConnection\n    }\n  }\n  ",
        "\n"
    ]);
    StoreCartList_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StoreCartList_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteCart($inputs: DeleteCartInput!) {\n    deleteCart(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    StoreCartList_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var StoreCartList_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref = (0,useQuery/* useQuery */.aM)(StoreCartList_viewModel_QUERY, {
        notifyOnNetworkStatusChange: true,
        onError: showError
    }), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_CART), 2), deleteCart = ref1[0], ref2 = ref1[1], deleting = ref2.loading;
    (0,react.useEffect)(function() {
        (0,storage/* removeUserInfoRegisterRedirect */.FY)();
    }, []);
    return {
        state: {
            loading: loading,
            deleting: deleting,
            carts: data === null || data === void 0 ? void 0 : data.userCarts
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        fetchMore({
                            variables: {
                                pageInput: {
                                    cursor: data === null || data === void 0 ? void 0 : data.userCarts.pageInfo.endCursor
                                }
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onDeleteCart: function onDeleteCart(cartId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            deleteCart({
                                variables: {
                                    inputs: {
                                        cartId: cartId
                                    }
                                }
                            })
                        ];
                    });
                })();
            }
        }
    };
});
var StoreCartList_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreCartList_viewModel_templateObject(), utoniq_core_schema/* UserCartsConnectionFragmentDoc */.oWV);
var DELETE_CART = (0,lib/* gql */.Ps)(StoreCartList_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/StoreCartList/index.tsx




/**
 * StoreCartList Page
 * Implemented as a practical sample.
 */ var StoreCartList = function() {
    var ref = StoreCartList_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCartListTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionDetails/template/index.tsx



















var StoreCollectionDetailsTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore, onClickShare = param.onClickShare, onChangeLabel = param.onChangeLabel;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(0), currentTab = ref8[0], setCurrentTab = ref8[1];
    var _mediumUri, ref9;
    var thumbnailUri = (ref9 = (_mediumUri = (ref = state.collection) === null || ref === void 0 ? void 0 : ref.thumbnail.mediumUri) !== null && _mediumUri !== void 0 ? _mediumUri : (ref1 = state.collection) === null || ref1 === void 0 ? void 0 : ref1.thumbnail.uri) !== null && ref9 !== void 0 ? ref9 : "";
    var handleChangeTab = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(number) {
            var ref, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((ref = state.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.labels) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                            return [
                                2
                            ];
                        }
                        setCurrentTab(number);
                        return [
                            4,
                            onChangeLabel(number === 0, (ref3 = (ref2 = state.collection.labels[number]) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(number) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeLabel,
        (ref2 = state.collection) === null || ref2 === void 0 ? void 0 : ref2.labels
    ]);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref10, ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            maxWidth: displayResponsive ? 1120 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CollectionImageCell, {
                    loading: state.loading,
                    imageUrl: thumbnailUri,
                    responsive: displayResponsive
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CollectionDetailCell, {
                    loading: state.loading,
                    collection: state.collection,
                    onClickShare: onClickShare,
                    responsive: displayResponsive
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
                    labels: (ref11 = (ref3 = state.collection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.labels) === null || ref4 === void 0 ? void 0 : ref4.map(function(label) {
                        return (ref10 = label === null || label === void 0 ? void 0 : label.name) !== null && ref10 !== void 0 ? ref10 : "";
                    })) !== null && ref11 !== void 0 ? ref11 : [],
                    hiddenLabel: !((ref5 = state.collection) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.labels) === null || ref6 === void 0 ? void 0 : ref6.length),
                    value: currentTab,
                    disableAnimateTransitions: true,
                    onChange: handleChangeTab,
                    children: (((ref7 = state.collection) === null || ref7 === void 0 ? void 0 : ref7.labels) || [
                        null
                    ]).map(function(label, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(template_StoreCollectionListCell, {
                            loading: state.loading,
                            hasNextPage: state.hasNextPage,
                            collectionItems: (ref = state.collection) === null || ref === void 0 ? void 0 : ref.collectionItems,
                            onFetchMore: function() {
                                return onFetchMore(index === 0, label === null || label === void 0 ? void 0 : label.name);
                            },
                            artistId: (ref12 = (ref1 = state.collection) === null || ref1 === void 0 ? void 0 : ref1.artistId) !== null && ref12 !== void 0 ? ref12 : "",
                            responsive: displayResponsive
                        }, index);
                    })
                })
            ]
        })
    });
};
var template_CollectionImageCell = function(param) {
    var loading = param.loading, imageUrl = param.imageUrl, responsive = param.responsive;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (loading && !imageUrl) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 212,
                sx: {
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop,
                    "& > *": {
                        visibility: "visible"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                    color: "transparent",
                    elevation: 0,
                    sx: {
                        backgroundColor: "transparent"
                    },
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            borderRadius: "50%",
                            width: 44,
                            height: 44,
                            bgcolor: "grey.50"
                        }
                    })
                })
            })
        });
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            position: "relative",
            alignItems: responsive ? "center" : undefined
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                elevation: 0,
                position: "absolute",
                color: "transparent",
                maxWidth: responsive ? 1120 : undefined,
                sx: responsive ? {
                    margin: "0 auto",
                    bgcolor: "transparent",
                    pt: 0
                } : {
                    right: "auto",
                    maxWidth: 600,
                    bgcolor: "transparent",
                    pt: 0
                },
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    bgcolor: "grey.50",
                    onClick: function() {
                        return router.goBack(generatePath(routerPages.ArtistStore, {
                            artistId: (ref1 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref1 !== void 0 ? ref1 : "#"
                        }));
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImageArea, (0,src_object_spread/* default */.Z)({
                imageUri: imageUrl,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
            }, responsive ? {
                maxWidth: 1120,
                sx: {
                    margin: "0 auto",
                    width: "100%",
                    maxWidth: 1120
                },
                imageProps: {
                    sx: {
                        // 画面横幅が広がった時に画像が見切れないようにする
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat"
                    }
                }
            } : {}))
        ]
    });
};
var template_StoreCollectionListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, collectionItems = param.collectionItems, onFetchMore = param.onFetchMore, artistId = param.artistId, responsive = param.responsive;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCollectionDetail").t;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 5,
            alignItems: responsive ? "center" : undefined
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: Grid2/* default */.Z,
            componentProps: {
                spacing: 3,
                container: true
            },
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: {
                size: responsive ? {
                    xs: 4,
                    sm: 3
                } : {
                    xs: 4,
                    md: 3
                }
            },
            nodes: collectionItems === null || collectionItems === void 0 ? void 0 : (ref = collectionItems.edges) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var node = param.node;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(StoreItemArea/* StoreItemArea */.S, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    showMenberOnlyIcon: true,
                    trackView: true,
                    item: node.item,
                    artistId: artistId
                }, responsive ? {
                    responsive: true,
                    aspectRatio: "1 / 1"
                } : {}), {
                    onClick: function() {
                        analytics === null || analytics === void 0 ? void 0 : analytics.track("select_item", {
                            item_list_id: "collection_store_list_".concat(router.query.collectionId),
                            item_list_name: "Collection Store Items",
                            items: [
                                {
                                    item_id: node.item.id,
                                    item_name: node.item.title,
                                    item_category: "store_item",
                                    item_category2: node.item.type,
                                    item_category3: native_app/* getPlatform */.Xf(),
                                    item_category4: 1,
                                    item_category5: artistId,
                                    price: node.item.price
                                }, 
                            ]
                        });
                    }
                }), node.item.id);
            }),
            emptyMessage: t("productInfoEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 3,
                sx: {
                    py: 2
                },
                children: Array.from(Array(6).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: responsive ? {
                            xs: 4,
                            sm: 3
                        } : {
                            xs: 4,
                            md: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemAreaSkeleton/* StoreItemAreaSkeleton */.E, {
                            responsive: responsive
                        })
                    }, key);
                })
            })
        })
    });
};
var template_CollectionDetailCell = function(param) {
    var loading = param.loading, collection = param.collection, onClickShare = param.onClickShare, responsive = param.responsive;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCollectionDetail").t;
    if (loading && !collection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                px: 5,
                py: 5,
                alignItems: responsive ? "center" : undefined
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        pb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "20%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "50%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "30%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            width: 38,
                            height: 44
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        numberOfLine: 3,
                        lastWidth: "60%"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 5,
            alignItems: responsive ? "center" : undefined
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                children: collection === null || collection === void 0 ? void 0 : collection.artist.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h3",
                                children: collection === null || collection === void 0 ? void 0 : collection.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "caption",
                                children: t("itemNumber", {
                                    number: collection === null || collection === void 0 ? void 0 : collection.publishedItemCount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                            variant: "text",
                            sx: {
                                px: 0,
                                display: "grid",
                                gridTemplateColumns: "1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Share, {
                                    fontSize: "small",
                                    sx: {
                                        color: "grey.600",
                                        mx: "auto"
                                    },
                                    onClick: onClickShare
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "overline",
                                    color: "text.hint",
                                    children: t("share")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: collection === null || collection === void 0 ? void 0 : collection.description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionDetails/viewModel.ts




function StoreCollectionDetails_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreCollectionDetails(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n    $userId: ID\n  ) {\n    user(id: $userId) {\n      id\n      displayName\n      avatar {\n        uri\n        smallUri\n      }\n    }\n    userCartCount\n    userCarts {\n      ...UserCartsConnection\n    }\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      isEventPickup\n      artist {\n        id\n        displayName\n      }\n      isPublishOnStore\n      thumbnail {\n        uri\n        mediumUri\n      }\n      userCollection(userId: $userId) {\n        ogp {\n          uri\n          smallUri\n        }\n        itemOwnedCount\n        totalOwnedCount\n        totalOwnedItemCount @client\n        ownedItems {\n          itemId\n          ownedCount\n        }\n        id\n        userId\n      }\n      publishedItemCount\n      description\n      labels {\n        name\n        id\n      }\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        pageInput: $pageInput\n        publishedOnly: true\n      ) {\n        ...StoreCollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    StoreCollectionDetails_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StoreCollectionDetails_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreCollectionDetailsForGuest(\n    $collectionId: ID!\n    $collectionItemsLabel: String\n    $collectionItemsFirstLabel: Boolean\n    $pageInput: PageInput\n  ) {\n    collection(id: $collectionId) {\n      id\n      title\n      artistId\n      isEventPickup\n      artist {\n        id\n        displayName\n      }\n      isPublishOnStore\n      thumbnail {\n        uri\n        mediumUri\n      }\n      publishedItemCount\n      description\n      labels {\n        name\n        id\n      }\n      collectionItems(\n        label: $collectionItemsLabel\n        firstLabel: $collectionItemsFirstLabel\n        pageInput: $pageInput\n        publishedOnly: true\n      ) {\n        ...StoreCollectionItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    StoreCollectionDetails_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











/**
 *
 */ var StoreCollectionDetails_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)().t;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref4 = (0,router_useRouter/* useRouter */.tv)(), router = ref4.router, generatePath = ref4.generatePath, routerPages = ref4.routerPages;
    var ref5 = (0,auth/* useAuth */.aC)(), currentUser = ref5.user;
    var artistId = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId;
    var ref6 = (0,useQuery/* useQuery */.aM)(StoreCollectionDetails_viewModel_QUERY, {
        variables: {
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            pageInput: {
                limit: 12
            }
        }
    }), data = ref6.data, loading = ref6.loading, refetch = ref6.refetch, fetchMore = ref6.fetchMore;
    var ref7 = (0,useQuery/* useQuery */.aM)(StoreCollectionDetails_viewModel_QUERY_FOR_GUEST, {
        variables: {
            collectionId: router.query.collectionId,
            collectionItemsFirstLabel: true,
            pageInput: {
                limit: 12
            }
        }
    }), dataForGuest = ref7.data, loadingForGuest = ref7.loading, refetchForGuest = ref7.refetch, fetchMoreForGuest = ref7.fetchMore;
    var hasData = (0,react.useMemo)(function() {
        var ref;
        return !!((ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : ref.collection);
    }, [
        data,
        dataForGuest
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!hasData) return;
        analytics === null || analytics === void 0 ? void 0 : analytics.track("view_item_list", {
            item_list_id: "collection_store_list_".concat(router.query.collectionId),
            item_list_name: "Collection Store Items",
            items: (ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.collectionItems.edges.map(function(param) {
                var node = param.node;
                return {
                    item_id: node.item.id,
                    item_name: node.item.title,
                    item_category: "store_item",
                    item_category2: node.item.type,
                    item_category3: native_app/* getPlatform */.Xf(),
                    item_category4: 1,
                    item_category5: router.query.artistId,
                    price: node.item.price
                };
            })
        });
    }, [
        hasData
    ]);
    var getShortLinkUrl = (0,shortLink/* useCreateShortLink */.s)({
        path: generatePath(routerPages.StoreCollectionDetail, (0,src_object_spread/* default */.Z)({}, router.query))
    });
    var ref8;
    return {
        state: {
            loading: loading || loadingForGuest,
            hasNextPage: !!((ref = data !== null && data !== void 0 ? data : dataForGuest) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.collectionItems) === null || ref2 === void 0 ? void 0 : ref2.pageInfo.hasNextPage),
            collection: (ref8 = (ref3 = data !== null && data !== void 0 ? data : dataForGuest) === null || ref3 === void 0 ? void 0 : ref3.collection) !== null && ref8 !== void 0 ? ref8 : null
        },
        actions: {
            onChangeLabel: function onChangeLabel(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!currentUser) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refetchForGuest({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    refetch({
                                        collectionId: router.query.collectionId,
                                        collectionItemsLabel: isFirstLabel ? undefined : name,
                                        collectionItemsFirstLabel: isFirstLabel
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore(isFirstLabel, name) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!currentUser) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchMoreForGuest({
                                        variables: {
                                            collectionId: router.query.collectionId,
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                limit: 12,
                                                cursor: dataForGuest === null || dataForGuest === void 0 ? void 0 : (ref2 = dataForGuest.collection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.collectionItems) === null || ref3 === void 0 ? void 0 : ref3.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            collectionId: router.query.collectionId,
                                            collectionItemsLabel: isFirstLabel ? undefined : name,
                                            collectionItemsFirstLabel: isFirstLabel,
                                            pageInput: {
                                                limit: 12,
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.collectionItems) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onClickShare: function onClickShare() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, url;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_share", {
                                    applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                    artistId: artistId,
                                    collectionId: router.query.collectionId,
                                    name: "collectionStore"
                                });
                                return [
                                    4,
                                    getShortLinkUrl()
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    4,
                                    share/* share */.B({
                                        title: data === null || data === void 0 ? void 0 : (ref = data.collection) === null || ref === void 0 ? void 0 : ref.title,
                                        text: (data === null || data === void 0 ? void 0 : (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : ref1.description) || "",
                                        url: url,
                                        dialogTitle: data === null || data === void 0 ? void 0 : (ref2 = data.collection) === null || ref2 === void 0 ? void 0 : ref2.title
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_shareMethod", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: artistId,
                                            collectionId: router.query.collectionId,
                                            name: "storeCollectionDetail"
                                        });
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var StoreCollectionDetails_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreCollectionDetails_viewModel_templateObject(), utoniq_core_schema/* StoreCollectionItemsConnectionFragmentDoc */.Mn_, utoniq_core_schema/* UserCartsConnectionFragmentDoc */.oWV);
var StoreCollectionDetails_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(StoreCollectionDetails_viewModel_templateObject1(), utoniq_core_schema/* StoreCollectionItemsConnectionFragmentDoc */.Mn_);

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionDetails/index.tsx




/**
 * StoreCollectionDetails Page
 * Implemented as a practical sample.
 */ var StoreCollectionDetails = function() {
    var ref = StoreCollectionDetails_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCollectionDetailsTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionsSelect/template/index.tsx











var StoreCollectionsSelectTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeCollectionsSelect").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StoreCollectionsSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                margin: true,
                header: (0,src_object_spread/* default */.Z)({
                    back: true,
                    title: t("title", "コレクションから探す"),
                    defaultBackPage: generatePath(routerPages.ArtistStore, {
                        artistId: (ref2 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref2 !== void 0 ? ref2 : "#"
                    }),
                    right: state.isLoggedIn && !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 1,
                        sx: {
                            mr: -2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointDisplayPurchase/* PointDisplayPurchase */.u, {
                            point: state.point
                        })
                    })
                }, displayResponsive ? {
                    responsive: true,
                    maxWidth: 1120
                } : {}),
                maxWidth: displayResponsive ? 1120 : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                    loading: state.loading,
                    hasNextPage: state.hasNextPage,
                    onFetchMore: onFetchMore,
                    component: Grid2/* default */.Z,
                    componentProps: {
                        spacing: 3,
                        container: true
                    },
                    itemComponent: Grid2/* default */.Z,
                    itemComponentProps: {
                        size: displayResponsive ? {
                            xs: 6,
                            md: 4
                        } : {
                            xs: 6,
                            md: 6
                        }
                    },
                    nodes: (ref = state.collections) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                        var node = param.node;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreCollectionBox, (0,src_object_spread/* default */.Z)({
                            conductorName: "storeCollectionList",
                            collection: node
                        }, displayResponsive ? {
                            responsive: true,
                            height: "auto"
                        } : {}), node.id);
                    }),
                    loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        container: true,
                        spacing: 3,
                        children: Array.from(Array(6).keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                size: displayResponsive ? {
                                    xs: 6,
                                    md: 4
                                } : {
                                    xs: 6,
                                    md: 6
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistStoreCollectionBoxSkeleton, {})
                            }, key);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionsSelect/viewModel.ts



function StoreCollectionsSelect_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreCollectionsSelect($artistId: String!, $pageInput: PageInput) {\n    prepaidPointBalance {\n      balance\n      prepaidPointId\n      formattedPrepaidPointBarance @client\n    }\n    storeCollections(artistId: $artistId, pageInput: $pageInput) {\n      edges {\n        node {\n          ... on Collection {\n            ...ArtistStoreCollectionBox\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    StoreCollectionsSelect_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 *
 */ var StoreCollectionsSelect_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref1;
    var artistId = (ref1 = config_config/* config.applicationType */.v.applicationType === "standalone" ? config_config/* config.artistId */.v.artistId : router.query.artistId) !== null && ref1 !== void 0 ? ref1 : "#";
    var ref2 = (0,useQuery/* useQuery */.aM)(StoreCollectionsSelect_viewModel_QUERY, {
        variables: {
            artistId: artistId
        },
        notifyOnNetworkStatusChange: true
    }), data = ref2.data, loading = ref2.loading, fetchMore = ref2.fetchMore;
    var ref3, ref4, _formattedPrepaidPointBarance;
    return {
        state: {
            loading: loading,
            artistId: (ref3 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref3 !== void 0 ? ref3 : "",
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.storeCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            collections: (ref4 = data === null || data === void 0 ? void 0 : data.storeCollections) !== null && ref4 !== void 0 ? ref4 : null,
            isLoggedIn: !!(user === null || user === void 0 ? void 0 : user.uid),
            point: (_formattedPrepaidPointBarance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.formattedPrepaidPointBarance) !== null && _formattedPrepaidPointBarance !== void 0 ? _formattedPrepaidPointBarance : "0"
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistId: artistId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.storeCollections) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var StoreCollectionsSelect_viewModel_QUERY = (0,lib/* default */.ZP)(StoreCollectionsSelect_viewModel_templateObject(), utoniq_core_schema/* ArtistStoreCollectionBoxFragmentDoc */.CaL);

;// CONCATENATED MODULE: ./src/components/pages/StoreCollectionsSelect/index.tsx




/**
 * StoreCollectionsSelect Page
 * Implemented as a practical sample.
 */ var StoreCollectionsSelect = function() {
    var ref = StoreCollectionsSelect_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCollectionsSelectTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreDeliveryInfo/template/index.tsx






var StoreDeliveryInfoTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit;
    var t = (0,core_i18n/* useTranslation */.$G)("storeDeliveryInfo").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StoreDeliveryInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        py: 2
                    },
                    children: t("label")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoForm, {
                onSubmitSetting: onSubmit,
                deliveryInfo: state.user || {},
                // don't need anything action
                onClose: function() {}
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreDeliveryInfo/viewModel.ts









var StoreDeliveryInfo_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(utoniq_core_schema/* UserDeliveryInfo */.UM7).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* UpdateUserDeliveryInfo */.p2K), 1), updateUserDeliveryInfo = ref1[0];
    var ref2;
    return {
        state: {
            user: (ref2 = data === null || data === void 0 ? void 0 : data.user) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                    var ref, ref1, ref2, ref3, userInfoRegisterRedirect, redirectPath;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.fullName) !== null && ref2 !== void 0 ? ref2 : "",
                                                phoneNumber: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber) !== null && ref3 !== void 0 ? ref3 : "",
                                                address: {
                                                    postalCode: values.postalCode,
                                                    prefecture: values.prefecture,
                                                    city: values.city,
                                                    line1: values.line1,
                                                    line2: values.line2
                                                }
                                            }
                                        },
                                        update: function update(cache, param) {
                                            var data = param.data;
                                            var userDeliveryInfoResponse = data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo;
                                            var existingUser = cache.readQuery({
                                                query: utoniq_core_schema/* UserDeliveryInfo */.UM7
                                            });
                                            if (existingUser && userDeliveryInfoResponse) {
                                                cache.writeQuery({
                                                    query: utoniq_core_schema/* UserDeliveryInfo */.UM7,
                                                    data: {
                                                        user: (0,src_object_spread/* default */.Z)({}, existingUser.user, userDeliveryInfoResponse)
                                                    }
                                                });
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    (0,storage/* getUserInfoRegisterRedirect */.j6)()
                                ];
                            case 2:
                                userInfoRegisterRedirect = _state.sent();
                                redirectPath = userInfoRegisterRedirect.direction;
                                if (!redirectPath) {
                                    router.goBack(routerPages.AccountSetting);
                                    return [
                                        2
                                    ];
                                }
                                router.push(redirectPath);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/StoreDeliveryInfo/index.tsx




var StoreDeliveryInfo = function() {
    var ref = StoreDeliveryInfo_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDeliveryInfoTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemCompleteFree/template/index.tsx








var StoreItemCompleteFreeTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseComplete").t;
    var ref28 = (0,router_useRouter/* useRouter */.tv)(), generateQueryPath = ref28.generateQueryPath, generatePath = ref28.generatePath, routerPages = ref28.routerPages, routerNames = ref28.routerNames;
    var ref29, ref30, _issuedNumber, ref31, ref32;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            header: {
                title: state.isFreeItem ? t("obtainTitle") : t("purchaseTitle")
            },
            margin: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.StoreItemPurchaseComplete
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        pt: 2,
                        pb: 5
                    },
                    children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            width: "fit-content"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: 175,
                                height: 280
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    mt: 5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "large",
                                    width: "50%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    mt: 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    mt: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "medium",
                                    width: "50%"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                                        size: "large",
                                        src: (ref29 = (ref = state.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.front) === null || ref3 === void 0 ? void 0 : ref3.mediumUri) !== null && ref29 !== void 0 ? ref29 : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        alignItems: "center",
                                        spacing: 1,
                                        sx: {
                                            pb: 2,
                                            pt: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h4",
                                                children: (ref4 = state.portfolio) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.item) === null || ref5 === void 0 ? void 0 : ref5.title
                                            }),
                                            !!((ref6 = state.portfolio) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.item) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sku) === null || ref8 === void 0 ? void 0 : ref8.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "h6",
                                                children: (ref9 = state.portfolio) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sku) === null || ref11 === void 0 ? void 0 : ref11.unitName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "center",
                                        spacing: 4,
                                        children: [
                                            ((ref12 = state.portfolio) === null || ref12 === void 0 ? void 0 : ref12.item.rarity) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 1,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.hint",
                                                        children: t("rarity")
                                                    }),
                                                    ((ref14 = (ref13 = state.portfolio) === null || ref13 === void 0 ? void 0 : ref13.item.rarityIconImage) === null || ref14 === void 0 ? void 0 : ref14.smallUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                        variant: "square",
                                                        src: (ref15 = state.portfolio) === null || ref15 === void 0 ? void 0 : ref15.item.rarityIconImage.smallUri,
                                                        sx: {
                                                            height: 12,
                                                            width: 12
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        children: ((ref17 = (ref16 = state.portfolio) === null || ref16 === void 0 ? void 0 : ref16.item.rarity) === null || ref17 === void 0 ? void 0 : ref17.name) ? t((ref18 = state.portfolio) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.item) === null || ref19 === void 0 ? void 0 : ref19.rarity.name) : "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        color: "text.hint",
                                                        children: t("possessionNumber")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                        variant: "overline",
                                                        children: [
                                                            (ref30 = (ref20 = state.portfolio) === null || ref20 === void 0 ? void 0 : ref20.number) !== null && ref30 !== void 0 ? ref30 : 0,
                                                            !((ref21 = state.portfolio) === null || ref21 === void 0 ? void 0 : ref21.item.hideSalesNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    "/",
                                                                    (_issuedNumber = (ref22 = state.portfolio) === null || ref22 === void 0 ? void 0 : ref22.item.issuedNumber) !== null && _issuedNumber !== void 0 ? _issuedNumber : "∞"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                alignItems: "center",
                                sx: {
                                    pt: 6
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "outlined",
                                    sx: {
                                        width: "fit-content",
                                        px: 4,
                                        py: 1
                                    },
                                    href: generatePath(routerPages.ItemComment, {
                                        itemId: state.itemId
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Reply, {
                                                color: "inherit",
                                                fontSize: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "button",
                                                children: (ref31 = (ref23 = state.portfolio) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.item) === null || ref24 === void 0 ? void 0 : ref24.commentCount) !== null && ref31 !== void 0 ? ref31 : 0
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    alignItems: "center",
                    sx: {
                        p: 5
                    },
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "large",
                            sx: {
                                width: 244
                            },
                            href: generateQueryPath(routerPages.OwnedItemDetail, {
                                itemId: state.itemId
                            }, {
                                skuId: encodeSkuId((ref32 = (ref25 = state.portfolio) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.item) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.sku) === null || ref27 === void 0 ? void 0 : ref27.id) !== null && ref32 !== void 0 ? ref32 : "")
                            }),
                            children: t("checkTheItem")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            href: generatePath(routerPages.ArtistStore, {
                                artistId: state.artistId
                            }),
                            size: "large",
                            variant: "text",
                            color: "primary",
                            sx: {
                                width: 244
                            },
                            children: t("continueToBuy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            href: generatePath(routerPages.ArtistTop, {
                                artistId: state.artistId
                            }),
                            size: "large",
                            variant: "text",
                            color: "primary",
                            sx: {
                                width: 244
                            },
                            children: t("toTop")
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemCompleteFree/viewModel.ts

function StoreItemCompleteFree_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreItemCompleteFree($id: ID!) {\n    portfolio(id: $id) {\n      id\n      number\n      item {\n        ...StoreItemCompleteDetail\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    StoreItemCompleteFree_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StoreItemCompleteFree_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var ref3 = (0,useQuery/* useQuery */.aM)(StoreItemCompleteFree_viewModel_QUERY, {
        variables: {
            id: router.query.itemId
        }
    }), data = ref3.data, loading = ref3.loading;
    var _itemId, ref4;
    return {
        state: {
            artistId: artistId,
            loading: loading,
            itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "",
            portfolio: (ref4 = convertPortfolioItemToSku(data === null || data === void 0 ? void 0 : data.portfolio, (ref = router.query) === null || ref === void 0 ? void 0 : ref.skuId)) !== null && ref4 !== void 0 ? ref4 : null,
            isFreeItem: (data === null || data === void 0 ? void 0 : (ref1 = data.portfolio) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.price) === 0
        },
        actions: {}
    };
});
var StoreItemCompleteFree_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreItemCompleteFree_viewModel_templateObject(), utoniq_core_schema/* StoreItemCompleteDetailFragmentDoc */.mIc);

;// CONCATENATED MODULE: ./src/components/pages/StoreItemCompleteFree/index.tsx




/**
 * StoreItemCompleteFree Page
 * Implemented as a practical sample.
 */ var StoreItemCompleteFree = function() {
    var ref = StoreItemCompleteFree_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemCompleteFreeTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseComplete/template/index.tsx











var StoreItemPurchaseCompleteTemplate = function(param) {
    var state = param.state;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseComplete").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var _paymentDeadline;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: (0,src_object_spread/* default */.Z)({
            title: state.loading ? "" : state.isKonbini ? t("titleKonbini") : t("title"),
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                href: routerPages.Top
            })
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {}),
        maxWidth: displayResponsive ? 600 : undefined,
        children: [
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemPurchaseComplete_template_ResultCell, {
                isKonbini: state.isKonbini,
                paymentDeadline: (_paymentDeadline = state.paymentDeadline) !== null && _paymentDeadline !== void 0 ? _paymentDeadline : ""
            }),
            !state.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemPurchaseComplete_template_ButtonCell, {
                purchaseOrderId: state.purchaseOrderId,
                isKonbini: state.isKonbini,
                voucherUrl: state.voucherUrl,
                pendingPurchaseItemId: state.pendingPurchaseItemId
            })
        ]
    });
};
var StoreItemPurchaseComplete_template_ResultCell = function(param) {
    var isKonbini = param.isKonbini, paymentDeadline = param.paymentDeadline;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseComplete").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 6,
            pb: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentFrame/* ContentFrame */.y, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h5",
                    align: "center",
                    children: t(isKonbini ? "completeMessageKonbini" : "completeMessage")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    align: "center",
                    sx: {
                        pt: 1
                    },
                    children: t(isKonbini ? "completeDescMessageKonbini" : "completeDescMessage")
                }),
                isKonbini && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        borderColor: "error.main",
                        borderWidth: 1,
                        borderStyle: "solid",
                        py: 2,
                        mt: 6
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "error.main",
                        align: "center",
                        children: t("paymentDeadline", {
                            date: paymentDeadline
                        })
                    })
                })
            ]
        })
    });
};
var StoreItemPurchaseComplete_template_ButtonCell = function(param) {
    var purchaseOrderId = param.purchaseOrderId, pendingPurchaseItemId = param.pendingPurchaseItemId, voucherUrl = param.voucherUrl, isKonbini = param.isKonbini;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseComplete").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, generatePath = ref.generatePath;
    var ref1 = (0,BrowserLink/* useBrowserLink */.i)(voucherUrl !== null && voucherUrl !== void 0 ? voucherUrl : ""), onClickVoucherUrl = ref1.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 4,
                alignItems: "center",
                sx: {
                    py: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "contained",
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: voucherUrl ? onClickVoucherUrl : function() {
                            return router.replace(generatePath(routerPages.StorePurchaseOrderDetail, {
                                purchaseOrderId: purchaseOrderId
                            }), {
                                state: {
                                    from: routerPages.StorePurchaseOrders
                                }
                            });
                        },
                        children: t(isKonbini ? "paymentProcedure" : "checkOwnedTicket")
                    }),
                    isKonbini ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        size: "large",
                        sx: {
                            width: 244,
                            py: 1,
                            height: "auto"
                        },
                        href: generatePath(routerPages.PaymentStatusDetail, {
                            pendingPurchaseId: pendingPurchaseItemId
                        }),
                        children: t("paymentStatus", "決済状況を確認する")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        variant: "text",
                        href: routerPages.Top,
                        children: t("topPage")
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseComplete/viewModel.ts

function StoreItemPurchaseComplete_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreItemPurchaseComplete($userCartTransactionOrderId: ID!) {\n    userCartTransactionOrder(id: $userCartTransactionOrderId) {\n      ...UserCartTransactionOrder\n    }\n  }\n  ",
        "\n"
    ]);
    StoreItemPurchaseComplete_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






/**
 *
 */ var StoreItemPurchaseComplete_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var cartTransactionOrderId = router.query.cartTransactionOrderId;
    var ref3 = (0,useQuery/* useQuery */.aM)(StoreItemPurchaseComplete_viewModel_QUERY, {
        skip: !cartTransactionOrderId,
        variables: {
            userCartTransactionOrderId: cartTransactionOrderId !== null && cartTransactionOrderId !== void 0 ? cartTransactionOrderId : "#"
        }
    }), data = ref3.data, loading = ref3.loading;
    (0,react.useEffect)(function() {
        (0,storage/* removeStoreProceed */.N_)();
    }, []);
    var _id, _paymentType, ref4, ref5, _itemId, ref6;
    return {
        state: {
            loading: loading,
            isKonbini: !!(data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.isKonbini),
            purchaseOrderId: (_id = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.id) !== null && _id !== void 0 ? _id : "",
            paymentType: (_paymentType = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.paymentType) !== null && _paymentType !== void 0 ? _paymentType : null,
            voucherUrl: (ref4 = (ref = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref === void 0 ? void 0 : ref.voucherUrl) !== null && ref4 !== void 0 ? ref4 : null,
            paymentDeadline: (ref5 = (ref1 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref1 === void 0 ? void 0 : ref1.formattedExpiredAt) !== null && ref5 !== void 0 ? ref5 : null,
            itemId: (_itemId = router.query.itemId) !== null && _itemId !== void 0 ? _itemId : "",
            pendingPurchaseItemId: (ref6 = (ref2 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.pendingPurchaseItem) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref6 !== void 0 ? ref6 : ""
        },
        actions: {}
    };
});
var StoreItemPurchaseComplete_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreItemPurchaseComplete_viewModel_templateObject(), utoniq_core_schema/* UserCartTransactionOrderFragmentDoc */.ygL);

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseComplete/index.tsx




/**
 * StoreItemPurchaseComplete Page
 * Implemented as a practical sample.
 */ var StoreItemPurchaseComplete = function() {
    var ref = StoreItemPurchaseComplete_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemPurchaseCompleteTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseConfirmation/template/index.tsx


















var StoreItemPurchaseConfirmationTemplate = function(param) {
    var state = param.state, onCheckout = param.onCheckout, onSendVerificationSMS = param.onSendVerificationSMS, onCloseRequire3DSecureModal = param.onCloseRequire3DSecureModal, onCloseExpiredCardModal = param.onCloseExpiredCardModal, onClosePaymentErrorModal = param.onClosePaymentErrorModal;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseConfirmation").t;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref10.routerNames, routerPages = ref10.routerPages, generatePath = ref10.generatePath, router = ref10.router;
    var hasMerchItem = (0,react.useMemo)(function() {
        if (!state.cartItems) return false;
        return state.cartItems.some(function(item) {
            return item.item.type === utoniq_core_schema/* ItemType.Merch */.qGq.Merch;
        });
    }, [
        state.cartItems
    ]);
    // 個人情報の登録必須項目
    var personalInformationRequirements = (0,react.useMemo)(function() {
        if (!state.cartItems) return [];
        var result = state.cartItems.reduce(function(acc, item) {
            var requirements = item.item.personalInformationRequirements;
            return Array.isArray(requirements) ? acc.concat(requirements) : acc;
        }, []);
        return (0,src_to_consumable_array/* default */.Z)(new Set(result));
    }, [
        state.cartItems
    ]);
    var ref11;
    // 入力項目が不足し、次のステップに進めない状態
    var disableToNext = (0,react.useMemo)(function() {
        var ref, // ポイント不足
        ref1, ref2, ref3;
        return(// 氏名未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && !state.fullName || // 電番未認証
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber) && !state.isPhoneNumberVerified || // 住所未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && !((ref = state.address) === null || ref === void 0 ? void 0 : ref.fullAddress) || ((ref1 = state.cart) === null || ref1 === void 0 ? void 0 : ref1.paymentType) === "prepaid_point" && state.cart.totalPrice > ((ref11 = (ref2 = state.prepaidPointBalance) === null || ref2 === void 0 ? void 0 : ref2.balance) !== null && ref11 !== void 0 ? ref11 : 0) || // 氏名未入力
        state.purchaseType === "konbini" && !state.fullName || // クレカ未登録
        state.purchaseType === "cash" && !((ref3 = state.paymentSource) === null || ref3 === void 0 ? void 0 : ref3.id));
    }, [
        state.fullName,
        personalInformationRequirements,
        state.cart,
        state.purchaseType,
        state.address,
        state.isPhoneNumberVerified,
        (ref = state.prepaidPointBalance) === null || ref === void 0 ? void 0 : ref.balance,
        (ref1 = state.paymentSource) === null || ref1 === void 0 ? void 0 : ref1.id, 
    ]);
    var isReceiveTime = (0,react.useMemo)(function() {
        var ref;
        return (ref = state.cartItemsByCollection) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var eventCollection = param.eventCollection;
            var ref, ref1;
            return (ref1 = (ref = state.pickupTimes) === null || ref === void 0 ? void 0 : ref.find(function(param) {
                var collectionId = param.collectionId;
                return collectionId === (eventCollection === null || eventCollection === void 0 ? void 0 : eventCollection.collectionId);
            })) === null || ref1 === void 0 ? void 0 : ref1.pickupTime;
        });
    }, [
        state.cartItemsByCollection,
        state.pickupTimes
    ]);
    var displayResponsive = (0,individual/* individualDisplayResponsive */.f0)();
    var ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        header: (0,src_object_spread/* default */.Z)({
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                onClick: function() {
                    var ref, ref1;
                    return router.replace(((ref = state.cart) === null || ref === void 0 ? void 0 : ref.id) ? generatePath(routerPages.StoreItemPurchaseProceed, {
                        cartId: (ref12 = (ref1 = state.cart) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref12 !== void 0 ? ref12 : "#"
                    }) : routerPages.StoreCartList);
                }
            }),
            title: t("title")
        }, displayResponsive ? {
            responsive: true,
            maxWidth: 1120
        } : {})
    }, displayResponsive ? {
        responsive: true,
        maxWidth: 1120
    } : {}), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StoreItemPurchaseConfirmation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BillingDetailCell, {
                purchaseType: state.purchaseType,
                systemFee: state.systemFee,
                shippingFee: state.shippingFee,
                konbiniFee: state.konbiniFee,
                totalPrice: (ref2 = state.cart) === null || ref2 === void 0 ? void 0 : ref2.totalPrice,
                formattedTotalPrice: (ref3 = state.cart) === null || ref3 === void 0 ? void 0 : ref3.formattedTotalPrice,
                paymentType: (ref4 = state.cart) === null || ref4 === void 0 ? void 0 : ref4.paymentType
            }),
            !!personalInformationRequirements.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ShippingAddressCell, {
                loading: state.loading,
                fullName: state.fullName,
                address: state.address,
                isPhoneNumberVerified: state.isPhoneNumberVerified,
                phoneNumber: state.phoneNumber,
                onSendVerificationSMS: onSendVerificationSMS,
                personalInformationRequirements: personalInformationRequirements
            }),
            state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PaymentInfoCellSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(template_PaymentInfoCell, {
                formattedPrepaidPointBalance: (ref13 = (ref5 = state.prepaidPointBalance) === null || ref5 === void 0 ? void 0 : ref5.formattedPrepaidPointBarance) !== null && ref13 !== void 0 ? ref13 : 0,
                paymentSource: state.paymentSource,
                purchaseType: state.purchaseType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailCell, {
                cartItemsByCollection: state.cartItemsByCollection,
                pickupTimes: state.pickupTimes,
                loading: state.loading,
                purchaseType: state.purchaseType,
                systemFee: state.systemFee,
                shippingFee: state.shippingFee,
                konbiniFee: state.konbiniFee,
                totalPrice: (ref6 = state.cart) === null || ref6 === void 0 ? void 0 : ref6.totalPrice,
                formattedTotalPrice: (ref7 = state.cart) === null || ref7 === void 0 ? void 0 : ref7.formattedTotalPrice,
                paymentType: (ref8 = state.cart) === null || ref8 === void 0 ? void 0 : ref8.paymentType,
                hiddenPaymentInfo: true,
                purchaseLimitPerPickupErrorIds: [],
                onRemovePurchaseLimitPerPickupErrorIds: function() {},
                responsive: displayResponsive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmOrderCell, {
                loading: state.loading,
                submitting: state.submitting,
                onClick: onCheckout,
                disabled: disableToNext,
                isReceiveTime: isReceiveTime,
                sx: {
                    pt: 0
                },
                events: state.events,
                cartId: (ref9 = state.cart) === null || ref9 === void 0 ? void 0 : ref9.id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Require3DSecureModal, {
                open: state.openRequire3DSecureModal,
                onClose: onCloseRequire3DSecureModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredCardModal, {
                open: state.openExpiredCardModal,
                onClose: onCloseExpiredCardModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentErrorModal, {
                open: state.openPaymentErrorModal,
                onClose: onClosePaymentErrorModal
            })
        ]
    }));
};
var BillingDetailCell = function(props) {
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseConfirmation").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("billingDetail", "ご請求内容")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPaymentCell, (0,src_object_spread/* default */.Z)({}, props))
                })
            })
        ]
    });
};
var template_ShippingAddressCell = function(param) {
    var fullName = param.fullName, address = param.address, isPhoneNumberVerified = param.isPhoneNumberVerified, phoneNumber = param.phoneNumber, loading = param.loading, onSendVerificationSMS = param.onSendVerificationSMS, personalInformationRequirements = param.personalInformationRequirements;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseConfirmation").t;
    var hasError = (0,react.useMemo)(function() {
        return(// 氏名未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.FullName */.APM.FullName) && !fullName || // 電番未認証
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.PhoneNumber */.APM.PhoneNumber) && !isPhoneNumberVerified || // 住所未登録
        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && !(address === null || address === void 0 ? void 0 : address.fullAddress));
    }, [
        fullName,
        personalInformationRequirements,
        address,
        isPhoneNumberVerified
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ShippingAddressCellSkeleton, {});
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("personalInfo", "お客様情報")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body2",
                            color: "error.main",
                            children: t("personalInfoError", "商品の購入にはお客様情報の登録が必要です。")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: hasError ? 2 : 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("familyName", "氏名")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: fullName ? "text.primary" : "text.hint",
                                    children: fullName !== null && fullName !== void 0 ? fullName : t("unregisteredFullName", "氏名が登録されていません")
                                })
                            ]
                        }),
                        personalInformationRequirements.includes(utoniq_core_schema/* PersonalInformationType.Address */.APM.Address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("address")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    color: (address === null || address === void 0 ? void 0 : address.fullAddress) ? "text.primary" : "text.hint",
                                    children: (ref = address === null || address === void 0 ? void 0 : address.fullAddress) !== null && ref !== void 0 ? ref : t("unregisteredAddress")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 3,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "text.secondary",
                                            children: t("phoneNumber")
                                        }),
                                        !isPhoneNumberVerified ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Error, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "error.main",
                                                        mt: -1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "error.main",
                                                    children: t("unverify")
                                                }),
                                                phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                    variant: "text",
                                                    color: "primary",
                                                    loading: loading,
                                                    onClick: onSendVerificationSMS,
                                                    children: t("verify")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Success, {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "text.hint",
                                                        mt: -1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "body2",
                                                    color: "text.hint",
                                                    children: t("verified")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: phoneNumber
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var template_PaymentInfoCell = function(param) {
    var formattedPrepaidPointBalance = param.formattedPrepaidPointBalance, paymentSource = param.paymentSource, purchaseType = param.purchaseType;
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseConfirmation").t;
    switch(purchaseType){
        case "konbini":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "text.secondary",
                                children: t("paymentInfo", "支払い情報")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: {
                                p: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h5",
                                    children: t("convenienceStore", "コンビニ決済")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    sx: {
                                        display: "block",
                                        mt: 2
                                    },
                                    children: t("convenienceStoreDesc", "ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    sx: {
                                        pt: 1
                                    },
                                    color: "grey.700",
                                    children: t("storeItemNote")
                                })
                            ]
                        })
                    })
                ]
            });
        case "cash":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "text.secondary",
                                children: t("paymentInfo", "支払い情報")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                p: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                        height: 25,
                                        src: (0,creditCard/* generateCreditCardLogoPath */.n)(paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.brand),
                                        target: "common"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h6",
                                        children: t("last4Digits", {
                                            number: paymentSource === null || paymentSource === void 0 ? void 0 : paymentSource.last4
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        case "prepaid_point":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
                sx: {
                    pb: 4
                },
                color: "text.secondary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50",
                            px: 5,
                            py: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                color: "text.secondary",
                                children: t("paymentInfo", "支払い情報")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                p: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                mt: 1,
                                justifyContent: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t("purchaseByPoint", "ポイントで購入")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            spacing: 2,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    color: "text.secondary",
                                                    children: t("pointBalance", "ポイント残高")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                                                    point: formattedPrepaidPointBalance
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            });
        default:
            return null;
    }
};
var ButtonConfirmOrderCell = function(_param) {
    var submitting = _param.submitting, loading = _param.loading, sx = _param.sx, isReceiveTime = _param.isReceiveTime, events = _param.events, cartId = _param.cartId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "submitting",
        "loading",
        "sx",
        "isReceiveTime",
        "events",
        "cartId"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseConfirmation").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
            variant: "rectangular",
            sx: {
                width: 244,
                height: 44,
                borderRadius: 34,
                mx: "auto"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        color: "text.secondary",
        children: [
            !!events.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    px: 5,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.secondary",
                        children: t("notes", "注意事項")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        p: 5
                    },
                    children: [
                        events.map(function(event) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 1,
                                sx: {
                                    pb: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "text.secondary",
                                        children: t("notesTitle", {
                                            title: event === null || event === void 0 ? void 0 : event.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        color: "text.secondary",
                                        variant: "caption",
                                        children: event === null || event === void 0 ? void 0 : event.note
                                    })
                                ]
                            }, event === null || event === void 0 ? void 0 : event.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            alignItems: "center",
                            sx: {
                                pt: 4
                            },
                            children: [
                                !!events.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    color: "text.secondary",
                                    sx: {
                                        pb: 2
                                    },
                                    children: t("agreeNote", "上記の注意事項に同意して")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    size: "large",
                                    sx: {
                                        width: 212
                                    },
                                    loading: submitting
                                }, props), {
                                    children: t("confirmOrder", "注文を確定する")
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    onClick: function() {
                                        return router.goBack(cartId ? generatePath(routerPages.StoreItemPurchaseProceed, {
                                            cartId: cartId
                                        }) : routerPages.StoreCartList);
                                    },
                                    size: "large",
                                    variant: "text",
                                    sx: {
                                        width: 212,
                                        mt: 2
                                    },
                                    children: t("close", "戻る")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var template_ShippingAddressCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 5,
            mt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 3,
                    alignItems: "center",
                    sx: {
                        px: 5,
                        py: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "circular",
                            sx: {
                                width: 40,
                                height: 40
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            flex: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                    variant: "small",
                                    width: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        pt: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                            variant: "small",
                                            width: "85%"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var template_PaymentInfoCellSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    px: 5,
                    py: 2,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                    variant: "h3",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentFrame/* ContentFrame */.y, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5,
                        py: 3
                    },
                    spacing: 7,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            sx: {
                                mt: 4
                            },
                            variant: "large",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            sx: {
                                mt: 4
                            },
                            variant: "large",
                            width: "100%"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseConfirmation/viewModel.tsx




function StoreItemPurchaseConfirmation_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation checkoutCart($inputs: CheckoutCartInput!) {\n    checkoutCart(inputs: $inputs) {\n      id\n      isKonbini\n    }\n  }\n"
    ]);
    StoreItemPurchaseConfirmation_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StoreItemPurchaseConfirmation_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreItemPurchaseConfirmation($cartId: ID!, $isKonbini: Boolean) {\n    userCart(id: $cartId) {\n      ...UserCartStoreItemPurchaseConfirmation\n      checkoutFees(isKonbini: $isKonbini) {\n        totalFee\n        shipping {\n          ...FeeDetail\n        }\n        collections {\n          ...CollectionFeeDetail\n        }\n        konbini {\n          ...FeeDetail\n        }\n      }\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n    user {\n      id\n      fullName\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n    prepaidPointBalance {\n      lastUpdatedAt\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    StoreItemPurchaseConfirmation_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var StoreItemPurchaseConfirmation_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref14.showError, handleClose = ref14.handleClose;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var ref15 = (0,react.useState)({}), ref16 = ref15[0], fullName = ref16.fullName, purchaseType = ref16.purchaseType, pickupTimes = ref16.pickupTimes, setStoreProceed = ref15[1];
    var t = (0,core_i18n/* useTranslation */.$G)("storeItemPurchaseProceed").t;
    var ref17 = (0,router_useRouter/* useRouter */.tv)(), router = ref17.router, generatePath = ref17.generatePath, routerPages = ref17.routerPages;
    var cartId = router.query.cartId;
    var deviceInfo = device/* useDeviceInfo */.u().deviceInfo;
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(StoreItemPurchaseConfirmation_viewModel_QUERY, {
        variables: {
            cartId: cartId,
            isKonbini: purchaseType === "konbini"
        }
    }), 2), getStoreItemPurchase = ref18[0], ref19 = ref18[1], data = ref19.data, loading = ref19.loading;
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref20[0], ref21 = ref20[1], sendingVerification = ref21.loading;
    (0,react.useEffect)(function() {
        (0,storage/* removeUserInfoRegisterRedirect */.FY)();
        (0,src_async_to_generator/* default */.Z)(function() {
            var value;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getStoreProceed */.tq)()
                        ];
                    case 1:
                        value = _state.sent();
                        setStoreProceed(value);
                        return [
                            4,
                            getStoreItemPurchase({
                                variables: {
                                    cartId: cartId,
                                    isKonbini: value.purchaseType === "konbini"
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    /* チェックアウト */ var ref22 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CHECKOUT_CART), 2), checkoutCart = ref22[0], ref23 = ref22[1], checkingOut = ref23.loading;
    var ref24;
    var cartItems = convertUserCartItemsToSku((ref24 = data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.items) !== null && ref24 !== void 0 ? ref24 : null);
    var ref25 = (0,react.useState)(false), openExpiredCardModal = ref25[0], setOpenExpiredCardModal = ref25[1];
    var ref26 = (0,react.useState)(false), openPaymentErrorModal = ref26[0], setOpenPaymentErrorModal = ref26[1];
    var ref27 = (0,react.useState)(false), openRequire3DSecureModal = ref27[0], setOpenRequire3DSecureModal = ref27[1];
    var ref28, ref29, ref30, ref31, ref32, ref33;
    return {
        state: {
            cart: data === null || data === void 0 ? void 0 : data.userCart,
            cartItems: cartItems,
            cartItemsByCollection: groupItemsByCollection(cartItems),
            events: (ref28 = data === null || data === void 0 ? void 0 : (ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.items.map(function(param) {
                var item = param.item;
                var ref;
                return (ref = item.collection) === null || ref === void 0 ? void 0 : ref.event;
            }).filter(function(_event, i, self) {
                return self.indexOf(_event) === i && !!_event;
            })) !== null && ref28 !== void 0 ? ref28 : [],
            fullName: fullName !== null && fullName !== void 0 ? fullName : (data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.fullName) || "",
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            address: (ref29 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.address) !== null && ref29 !== void 0 ? ref29 : null,
            phoneNumber: (ref30 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.phoneNumber) !== null && ref30 !== void 0 ? ref30 : "",
            isPhoneNumberVerified: !!(data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : ref5.isPhoneNumberVerified),
            prepaidPointBalance: (ref31 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref31 !== void 0 ? ref31 : null,
            isCardRegistered: !!(data === null || data === void 0 ? void 0 : (ref6 = data.paymentSource) === null || ref6 === void 0 ? void 0 : ref6.last4),
            purchaseType: purchaseType,
            loading: loading,
            submitting: checkingOut,
            pickupTimes: pickupTimes !== null && pickupTimes !== void 0 ? pickupTimes : null,
            systemFee: addCollectionToCollectionFee(data === null || data === void 0 ? void 0 : (ref7 = data.userCart) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.checkoutFees) === null || ref8 === void 0 ? void 0 : ref8.collections, data === null || data === void 0 ? void 0 : (ref9 = data.userCart) === null || ref9 === void 0 ? void 0 : ref9.items.map(function(param) {
                var item = param.item;
                return item.collection;
            })),
            shippingFee: (ref32 = data === null || data === void 0 ? void 0 : (ref10 = data.userCart) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.checkoutFees) === null || ref11 === void 0 ? void 0 : ref11.shipping) !== null && ref32 !== void 0 ? ref32 : null,
            konbiniFee: (ref33 = data === null || data === void 0 ? void 0 : (ref12 = data.userCart) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.checkoutFees) === null || ref13 === void 0 ? void 0 : ref13.konbini) !== null && ref33 !== void 0 ? ref33 : null,
            sendingVerification: sendingVerification,
            openExpiredCardModal: openExpiredCardModal,
            openPaymentErrorModal: openPaymentErrorModal,
            openRequire3DSecureModal: openRequire3DSecureModal
        },
        actions: {
            onCheckout: function onCheckout() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2, ref3, purchaseTypeAnalytics, isKonbini, ref4, ref5, inputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                purchaseTypeAnalytics = purchaseType === "konbini" ? "convenience_store" : purchaseType === "cash" ? "credit_card" : "prepaid_point";
                                return [
                                    4,
                                    analytics === null || analytics === void 0 ? void 0 : analytics.track("begin_checkout", {
                                        item_list_id: "artist_store_list_".concat(data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.artist.id),
                                        item_list_name: "Artist Store Items",
                                        type: purchaseTypeAnalytics,
                                        value: data === null || data === void 0 ? void 0 : (ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.totalPrice,
                                        items: cartItems.map(function(cartItem) {
                                            var ref, ref1;
                                            return {
                                                item_id: cartItem.item.id,
                                                item_name: cartItem.item.title,
                                                item_category: ConversionCategories.storeItem,
                                                item_category2: cartItem.item.type,
                                                item_category3: native_app/* getPlatform */.Xf(),
                                                item_category4: (ref = cartItem.item.sku) === null || ref === void 0 ? void 0 : ref.id,
                                                item_category5: data === null || data === void 0 ? void 0 : (ref1 = data.userCart) === null || ref1 === void 0 ? void 0 : ref1.artist.id,
                                                price: cartItem.totalPrice,
                                                quantity: cartItem.count
                                            };
                                        })
                                    })
                                ];
                            case 1:
                                _state.sent();
                                if (!(data === null || data === void 0 ? void 0 : data.userCart)) return [
                                    2
                                ];
                                isKonbini = purchaseType === "konbini";
                                inputs = isKonbini ? {
                                    cartId: cartId,
                                    totalPrice: data.userCart.totalPrice + ((ref4 = (ref2 = data.userCart.checkoutFees) === null || ref2 === void 0 ? void 0 : ref2.totalFee) !== null && ref4 !== void 0 ? ref4 : 0),
                                    isKonbini: isKonbini,
                                    fullName: fullName,
                                    pickupTimes: pickupTimes
                                } : {
                                    cartId: cartId,
                                    totalPrice: data.userCart.totalPrice + ((ref5 = (ref3 = data.userCart.checkoutFees) === null || ref3 === void 0 ? void 0 : ref3.totalFee) !== null && ref5 !== void 0 ? ref5 : 0),
                                    isKonbini: isKonbini,
                                    pickupTimes: pickupTimes
                                };
                                return [
                                    2,
                                    checkoutCart({
                                        variables: {
                                            inputs: inputs
                                        },
                                        context: {
                                            headers: {
                                                "x-utoniq-idempotency-key": createUuid()
                                            }
                                        }
                                    }).then(function(param) {
                                        var _data = param.data;
                                        var ref, ref1;
                                        var ref2, _totalPrice;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.ecommerce({
                                            transaction_id: generateTransactionId((ref2 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref2 !== void 0 ? ref2 : ""),
                                            currency: "JPY",
                                            type: purchaseTypeAnalytics,
                                            value: data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.totalPrice,
                                            items: cartItems.map(function(cartItem) {
                                                var ref;
                                                return {
                                                    item_category: ConversionCategories.storeItem,
                                                    item_category2: "cart",
                                                    item_category3: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.platform,
                                                    item_category4: "StoreItemPurchaseConfirmation",
                                                    item_category5: (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.artist.id,
                                                    price: (_totalPrice = cartItem.totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : 0,
                                                    quantity: cartItem.count,
                                                    item_id: cartItem.item.id,
                                                    item_name: cartItem.item.title
                                                };
                                            })
                                        });
                                        if (_data === null || _data === void 0 ? void 0 : (ref1 = _data.checkoutCart) === null || ref1 === void 0 ? void 0 : ref1.id) {
                                            var ref3;
                                            router.replace(generatePath(routerPages.StoreItemPurchaseComplete, {
                                                cartTransactionOrderId: _data === null || _data === void 0 ? void 0 : (ref3 = _data.checkoutCart) === null || ref3 === void 0 ? void 0 : ref3.id
                                            }));
                                        }
                                    }).catch(function(error) {
                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                                        var ref10;
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("error_cart_checkout", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.artist.id,
                                            error: error.name,
                                            errorCode: (ref10 = (ref1 = error.graphQLErrors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.errorCode) !== null && ref10 !== void 0 ? ref10 : ""
                                        });
                                        if (error === null || error === void 0 ? void 0 : (ref2 = error.graphQLErrors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.extensions) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.exception) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.errors) === null || ref6 === void 0 ? void 0 : ref6.some(function(err) {
                                            return (err === null || err === void 0 ? void 0 : err.errorCode) === "ITEM_PURCHASE_LIMIT";
                                        })) {
                                            showError(new Error(t("itemPurchaseLimitErrorMessage")), undefined, undefined, undefined, /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                sx: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    handleClose();
                                                    router.goBack(generatePath(routerPages.StoreItemPurchaseProceed, {
                                                        cartId: cartId
                                                    }));
                                                },
                                                variant: "subtitle1",
                                                color: "white",
                                                children: t("changeQuantity")
                                            }));
                                            return;
                                        }
                                        switch((ref7 = error.graphQLErrors) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.extensions) === null || ref9 === void 0 ? void 0 : ref9.errorCode){
                                            case constants/* constants.errorCodes.NEED_PATRON */._.errorCodes.NEED_PATRON:
                                                showError(new Error(t("needPatronErrorMessage")));
                                                return;
                                            /**
               * @description
               * 3Dセキュア認証が必要な場合
               */ case constants/* constants.errorCodes.REQUIRE_3D_SECURE */._.errorCodes.REQUIRE_3D_SECURE:
                                                setOpenRequire3DSecureModal(true);
                                                return;
                                            /**
               * @desciption
               * カードが有効期限切れの場合
               */ case constants/* constants.errorCodes.EXPIRED_CARD */._.errorCodes.EXPIRED_CARD:
                                                setOpenExpiredCardModal(true);
                                                return;
                                            /**
               * @desciption
               * 何かしらの決済エラーの場合
               */ case constants/* constants.errorCodes.PAYMENT_ERROR */._.errorCodes.PAYMENT_ERROR:
                                                setOpenPaymentErrorModal(true);
                                                return;
                                            default:
                                                showError(error);
                                                break;
                                        }
                                    })
                                ];
                        }
                    });
                })();
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        sendVerificationSMS().then(function() {
                            router.push(routerPages.SMSVerification);
                        }).catch(function(e) {
                            showError(e);
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onCloseRequire3DSecureModal: function onCloseRequire3DSecureModal() {
                setOpenRequire3DSecureModal(false);
            },
            onCloseExpiredCardModal: function onCloseExpiredCardModal() {
                setOpenExpiredCardModal(false);
            },
            onClosePaymentErrorModal: function onClosePaymentErrorModal() {
                setOpenPaymentErrorModal(false);
            }
        }
    };
});
var CHECKOUT_CART = (0,lib/* gql */.Ps)(StoreItemPurchaseConfirmation_viewModel_templateObject());
var StoreItemPurchaseConfirmation_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreItemPurchaseConfirmation_viewModel_templateObject1(), utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* UserAddressFragmentDoc */.enF, utoniq_core_schema/* UserCartStoreItemPurchaseConfirmationFragmentDoc */.dlO, utoniq_core_schema/* FeeDetailFragmentDoc */.hKb, utoniq_core_schema/* CollectionFeeDetailFragmentDoc */.JQf);

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseConfirmation/index.tsx




/**
 * StoreItem Page
 * Implemented as a practical sample.
 */ var StoreItemPurchaseConfirmation = function() {
    var ref = StoreItemPurchaseConfirmation_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemPurchaseConfirmationTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseProceed/viewModel.ts




function StoreItemPurchaseProceed_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreItemPurchaseProceed(\n    $cartId: ID!\n    $platform: String!\n    $purchasablePrepaidPointPageInput: PageInput\n    $isKonbini: Boolean\n  ) {\n    userCart(id: $cartId) {\n      ...UserCartStoreItemPurchaseProceed\n      checkoutFees(isKonbini: $isKonbini) {\n        totalFee\n        shipping {\n          ...FeeDetail\n        }\n        collections {\n          ...CollectionFeeDetail\n        }\n        konbini {\n          ...FeeDetail\n        }\n      }\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n    user {\n      id\n      fullName\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n    prepaidPointBalance {\n      lastUpdatedAt\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n    purchasablePrepaidPoints(\n      platform: $platform\n      pageInput: $purchasablePrepaidPointPageInput\n    ) {\n      ...PurchasablePrepaidPointConnection\n    }\n    organization {\n      id\n      modules {\n        pointCarrierPayment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    StoreItemPurchaseProceed_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StoreItemPurchaseProceed_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var linkingAnonymousAccount = (0,vars/* useLinkingAnonymousAccountState */.Oz)();
    var ref15 = (0,router_useRouter/* useRouter */.tv)(), router = ref15.router, routerPages = ref15.routerPages;
    var cartId = router.query.cartId;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var platform = (0,native_app/* getPlatform */.Xf)();
    var ref16 = usePointPurchase(user === null || user === void 0 ? void 0 : user.uid, platform, "artistStoreItemDetail"), purchaseByIosAndAndroid = ref16.purchaseByIosAndAndroid, purchaseByWeb = ref16.purchaseByWeb, chargeLoading = ref16.chargeLoading;
    var ref17 = (0,useQuery/* useQuery */.aM)(StoreItemPurchaseProceed_viewModel_QUERY, {
        variables: {
            cartId: cartId,
            purchasablePrepaidPointPageInput: {
                limit: 30
            },
            platform: platform,
            isKonbini: true
        },
        // waiting for linking anonymous account
        skip: linkingAnonymousAccount
    }), data = ref17.data, loading = ref17.loading;
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref18[0], ref19 = ref18[1], sendingVerification = ref19.loading;
    var ref20;
    var cartItems = convertUserCartItemsToSku((ref20 = data === null || data === void 0 ? void 0 : (ref = data.userCart) === null || ref === void 0 ? void 0 : ref.items) !== null && ref20 !== void 0 ? ref20 : null);
    // カートのアイテムをコレクションごとにグルーピングしたもの
    var cartItemsByCollection = groupItemsByCollection(cartItems);
    // 購入済みイベントコレクションアイテムの受取時間と個数
    var myPickupUsers = extractMyPickupUsers(cartItemsByCollection);
    // カート内容のアイテムが購入制限を超過しているか
    var exceededItemCount = cartItems === null || cartItems === void 0 ? void 0 : cartItems.some(function(cartItem) {
        // 注文ごとの上限とカート内容を比較
        var exceedPurchaseLimitPerOrder = !!cartItem.item.purchaseLimitPerOrder && cartItem.item.purchaseLimitPerOrder < cartItem.count;
        // アイテム単位の上限とユーザーの所持数+カート内容を比較
        var exceedPurchaseLimitByUser = !!cartItem.item.purchaseLimitByUser && cartItem.item.purchaseLimitByUser - (cartItem.item.ownedCount || 0) < cartItem.count;
        return exceedPurchaseLimitPerOrder || exceedPurchaseLimitByUser;
    });
    var ref21, ref22, ref23, ref24, ref25, ref26;
    return {
        state: {
            loading: loading || linkingAnonymousAccount,
            cart: data === null || data === void 0 ? void 0 : data.userCart,
            cartItems: cartItems,
            cartItemsByCollection: cartItemsByCollection,
            fullName: (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.fullName) || "",
            paymentSource: data === null || data === void 0 ? void 0 : data.paymentSource,
            address: (ref21 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.address) !== null && ref21 !== void 0 ? ref21 : null,
            phoneNumber: (ref22 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber) !== null && ref22 !== void 0 ? ref22 : "",
            isPhoneNumberVerified: !!(data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.isPhoneNumberVerified),
            prepaidPointBalance: (ref23 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref23 !== void 0 ? ref23 : null,
            purchasablePrepaidPoints: (ref24 = data === null || data === void 0 ? void 0 : data.purchasablePrepaidPoints) !== null && ref24 !== void 0 ? ref24 : null,
            pointChargeLoading: chargeLoading,
            isCardRegistered: !!(data === null || data === void 0 ? void 0 : (ref5 = data.paymentSource) === null || ref5 === void 0 ? void 0 : ref5.last4),
            systemFee: addCollectionToCollectionFee(data === null || data === void 0 ? void 0 : (ref6 = data.userCart) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.checkoutFees) === null || ref7 === void 0 ? void 0 : ref7.collections, data === null || data === void 0 ? void 0 : (ref8 = data.userCart) === null || ref8 === void 0 ? void 0 : ref8.items.map(function(param) {
                var item = param.item;
                return item.collection;
            })),
            shippingFee: (ref25 = data === null || data === void 0 ? void 0 : (ref9 = data.userCart) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.checkoutFees) === null || ref10 === void 0 ? void 0 : ref10.shipping) !== null && ref25 !== void 0 ? ref25 : null,
            konbiniFee: (ref26 = data === null || data === void 0 ? void 0 : (ref11 = data.userCart) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.checkoutFees) === null || ref12 === void 0 ? void 0 : ref12.konbini) !== null && ref26 !== void 0 ? ref26 : null,
            sendingVerification: sendingVerification,
            myPickupUsers: myPickupUsers,
            exceededItemCount: exceededItemCount,
            /** アプリ毎に設定されているポイント購入のキャリア決済が有効かどうか */ enablePointCarrierPayment: !!(data === null || data === void 0 ? void 0 : (ref13 = data.organization) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.modules) === null || ref14 === void 0 ? void 0 : ref14.pointCarrierPayment)
        },
        actions: {
            // ポイントのチャージ
            onPurchasePoint: platform === "web" ? purchaseByWeb : purchaseByIosAndAndroid,
            onSendVerificationSMS: // 電番認証SMS送信
            function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        sendVerificationSMS().then(function() {
                            router.push(routerPages.SMSVerification);
                        }).catch(function(e) {
                            showError(e);
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    };
});
var StoreItemPurchaseProceed_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreItemPurchaseProceed_viewModel_templateObject(), utoniq_core_schema/* PurchasablePrepaidPointConnectionFragmentDoc */.oBq, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* UserAddressFragmentDoc */.enF, utoniq_core_schema/* UserCartStoreItemPurchaseProceedFragmentDoc */.hcq, utoniq_core_schema/* FeeDetailFragmentDoc */.hKb, utoniq_core_schema/* CollectionFeeDetailFragmentDoc */.JQf);
/**
 * カート内容から購入済みイベントコレクションアイテムの受取時間と個数を返す
 * @param cartItemsByCollection カート内容をコレクションごとにグルーピングしたもの
 */ var extractMyPickupUsers = function(cartItemsByCollection) {
    if (!cartItemsByCollection) return [];
    // コレクションごとに購入済みアイテムの受取時間と個数を抽出
    var myPickupUsers = cartItemsByCollection.flatMap(function(param) {
        var collection = param.collection;
        var ref;
        return collection === null || collection === void 0 ? void 0 : (ref = collection.event) === null || ref === void 0 ? void 0 : ref.eventCollections.edges.flatMap(function(param) {
            var node = param.node;
            var ref;
            return (ref = node.myPickupUsers) === null || ref === void 0 ? void 0 : ref.map(function(myPickupUser) {
                return myPickupUser.cartTransactionOrders.flatMap(function(order) {
                    return order.items.flatMap(function(item) {
                        return {
                            itemId: item.itemId,
                            count: item.count,
                            pickupTime: myPickupUser.pickupTime,
                            collectionId: node.collectionId
                        };
                    });
                });
            });
        });
    }).filter(Boolean);
    if (!myPickupUsers.length) return [];
    // pickupTime単位でまとめるためのオブジェクトを用意
    var groupedByPickupTime = {};
    // pickupTimeをキーに { itemId: count } の集計を行う
    myPickupUsers.flat().forEach(function(item) {
        var pickupTime = item === null || item === void 0 ? void 0 : item.pickupTime;
        var itemId = (item === null || item === void 0 ? void 0 : item.itemId) || "";
        var collectionId = (item === null || item === void 0 ? void 0 : item.collectionId) || "";
        if (!groupedByPickupTime[pickupTime]) {
            groupedByPickupTime[pickupTime] = {};
        }
        if (!groupedByPickupTime[pickupTime][itemId]) {
            groupedByPickupTime[pickupTime][itemId] = {
                count: 0,
                collectionId: collectionId
            };
        }
        groupedByPickupTime[pickupTime][itemId].count += (item === null || item === void 0 ? void 0 : item.count) || 0;
    });
    // オブジェクトの整型
    var result = Object.keys(groupedByPickupTime).map(function(pickupTime) {
        var items = Object.keys(groupedByPickupTime[parseInt(pickupTime)]).map(function(itemId) {
            var itemInfo = groupedByPickupTime[parseInt(pickupTime)][itemId];
            return {
                itemId: itemId,
                count: itemInfo.count,
                collectionId: itemInfo.collectionId
            };
        });
        return {
            pickupTime: parseInt(pickupTime),
            items: items
        };
    });
    return result;
};

;// CONCATENATED MODULE: ./src/components/pages/StoreItemPurchaseProceed/index.tsx




/**
 * StoreItem Page
 * Implemented as a practical sample.
 */ var StoreItemPurchaseProceed = function() {
    var ref = StoreItemPurchaseProceed_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreItemPurchaseProceedTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/core/order/index.ts
/**
 * ストア購入履歴のアイテムの内容をコレクション単位でグルーピングする
 * @param items ストア購入履歴のアイテムフィールド
 * @returns
 */ var groupOrderItemsByCollection = function(items) {
    if (!items) return [];
    var ref = items.reduce(function(acc, item) {
        var collection = item.item.collection ? {
            id: item.item.collection.id,
            title: item.item.collection.title
        } : null;
        if (collection) {
            var existingCollection = acc.collections.find(function(it) {
                var ref;
                return ((ref = it.collection) === null || ref === void 0 ? void 0 : ref.id) === collection.id;
            });
            if (!existingCollection) {
                acc.collections.push({
                    collection: collection,
                    items: [
                        item
                    ]
                });
            } else {
                existingCollection.items.push(item);
            }
        } else {
            acc.nullCollectionItems.push(item);
        }
        return acc;
    }, {
        collections: [],
        nullCollectionItems: []
    }), collections = ref.collections, nullCollectionItems = ref.nullCollectionItems;
    // コレクションに関連づいていないアイテムは collection: null でグルーピングする
    if (nullCollectionItems.length) {
        collections.push({
            collection: null,
            items: nullCollectionItems
        });
    }
    return collections;
};

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrderDetail/viewModel.ts

function StorePurchaseOrderDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StorePurchaseOrderDetail($id: ID!, $skuId: String) {\n    userCartTransactionOrder(id: $id) {\n      ...StorePurchaseHistory\n    }\n    user {\n      id\n      fullName\n      phoneNumber\n      formattedPhoneNumber @client\n      isPhoneNumberVerified\n      ...UserAddress\n    }\n    paymentSource {\n      ...PaymentDetail\n    }\n    prepaidPointBalance {\n      lastUpdatedAt\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    StorePurchaseOrderDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StorePurchaseOrderDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref11 = (0,useQuery/* useQuery */.aM)(StorePurchaseOrderDetail_viewModel_QUERY, {
        variables: {
            id: router.query.purchaseOrderId
        }
    }), data = ref11.data, loading = ref11.loading;
    var ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    return {
        state: {
            loading: loading,
            userCartTransactionOrder: (ref12 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder) !== null && ref12 !== void 0 ? ref12 : null,
            cartItemsByCollection: groupOrderItemsByCollection(data === null || data === void 0 ? void 0 : (ref = data.userCartTransactionOrder) === null || ref === void 0 ? void 0 : ref.items),
            events: (ref13 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.items.map(function(param) {
                var item = param.item;
                var ref;
                return item === null || item === void 0 ? void 0 : (ref = item.collection) === null || ref === void 0 ? void 0 : ref.event;
            }).filter(function(_event, i, self) {
                return self.indexOf(_event) === i && !!_event;
            })) !== null && ref13 !== void 0 ? ref13 : [],
            prepaidPointBalance: (ref14 = data === null || data === void 0 ? void 0 : data.prepaidPointBalance) !== null && ref14 !== void 0 ? ref14 : null,
            paymentSource: (ref15 = data === null || data === void 0 ? void 0 : data.paymentSource) !== null && ref15 !== void 0 ? ref15 : null,
            fullName: (data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.fullName) || "",
            address: (ref16 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.address) !== null && ref16 !== void 0 ? ref16 : null,
            phoneNumber: (ref17 = data === null || data === void 0 ? void 0 : (ref3 = data.user) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber) !== null && ref17 !== void 0 ? ref17 : "",
            isPhoneNumberVerified: !!(data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.isPhoneNumberVerified),
            systemFee: addCollectionToCollectionFee((ref5 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.checkoutFees) === null || ref5 === void 0 ? void 0 : ref5.collections, data === null || data === void 0 ? void 0 : (ref6 = data.userCartTransactionOrder) === null || ref6 === void 0 ? void 0 : ref6.items.map(function(param) {
                var item = param.item;
                return item.collection;
            })),
            shippingFee: (ref18 = (ref7 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.checkoutFees) === null || ref7 === void 0 ? void 0 : ref7.shipping) !== null && ref18 !== void 0 ? ref18 : null,
            konbiniFee: (ref19 = (ref8 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.checkoutFees) === null || ref8 === void 0 ? void 0 : ref8.konbini) !== null && ref19 !== void 0 ? ref19 : null,
            refundedAmount: (ref9 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.cancels) === null || ref9 === void 0 ? void 0 : ref9.reduce(function(acc, param) {
                var refundedAmount = param.refundedAmount;
                return acc + refundedAmount;
            }, 0),
            canceledAt: (ref10 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrder.cancels) === null || ref10 === void 0 ? void 0 : ref10.map(function(param) {
                var canceledAt = param.canceledAt;
                return canceledAt;
            }).sort(function(a, b) {
                return b - a;
            })[0]
        },
        actions: {}
    };
});
var StorePurchaseOrderDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(StorePurchaseOrderDetail_viewModel_templateObject(), utoniq_core_schema/* StorePurchaseHistoryFragmentDoc */.Dy2, utoniq_core_schema/* PaymentDetailFragmentDoc */.fFK, utoniq_core_schema/* UserAddressFragmentDoc */.enF);

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrderDetail/index.tsx




/**
 * StorePurchaseOrderDetail Page
 * Implemented as a practical sample.
 */ var StorePurchaseOrderDetail = function() {
    var ref = StorePurchaseOrderDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseOrderDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/store/StorePurchaseHistory/index.tsx







var StorePurchaseHistory = function(param) {
    var purchaseHistory = param.purchaseHistory;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrganismFrame */.o, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                href: generatePath(routerPages.StorePurchaseOrderDetail, {
                    purchaseOrderId: purchaseHistory.id
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 5,
                        "&:last-child": {
                            pb: 5
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                !!((ref = purchaseHistory.cancels) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    color: "error",
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "overline",
                                        color: "white",
                                        children: t("refundAvailable", "返金対応")
                                    }),
                                    size: "small",
                                    sx: {
                                        height: 18
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: t("orderDate", {
                                        date: purchaseHistory.formattedCreatedAt
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: t("orderDetails")
                                }),
                                purchaseHistory.items.map(function(item, index) {
                                    if (item.skus.length) {
                                        return item.skus.map(function(sku) {
                                            return sku && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                spacing: 2,
                                                direction: "row",
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                        flex: 1,
                                                        sx: {
                                                            minWidth: 0
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                            children: [
                                                                item.item.title,
                                                                " (",
                                                                sku.sku.unitName,
                                                                ")"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                        variant: "subtitle1",
                                                        children: t("quantity", {
                                                            quantity: sku.count
                                                        })
                                                    })
                                                ]
                                            }, sku.skuId);
                                        });
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        spacing: 2,
                                        direction: "row",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                flex: 1,
                                                sx: {
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                    variant: "subtitle1",
                                                    sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                                    children: item.item.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: t("quantity", {
                                                    quantity: item.count
                                                })
                                            })
                                        ]
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            sx: {
                                pt: 3
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    color: "text.secondary",
                                    children: purchaseHistory.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? t("payment") : t("totalPoint")
                                }),
                                purchaseHistory.paymentType === utoniq_core_schema/* UserPaymentType.Cash */.B9$.Cash ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: [
                                        "￥",
                                        purchaseHistory.formattedTotalAmount
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: purchaseHistory.formattedTotalAmount
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrders/template/index.tsx










var StorePurchaseOrdersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    var ref2 = (0,react.useState)(null), anchorEl = ref2[0], setAnchorEl = ref2[1];
    var ref3 = (0,react.useState)(0), selectedIndex = ref3[0], setSelectedIndex = ref3[1];
    var options = [
        {
            label: t("all", "すべて"),
            value: undefined
        },
        {
            label: t("purchase", "購入"),
            value: "purchase"
        },
        {
            label: t("refund", "返金対応"),
            value: "refund"
        }, 
    ];
    var handleFilterClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = (0,react.useCallback)(function(event, newIndex) {
        setSelectedIndex(newIndex);
        setAnchorEl(null);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Back, {
                edge: "start",
                size: "medium",
                href: routerPages.Management
            }),
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StorePurchaseOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTagCell, {
                loading: state.loading && !state.purchaseHistories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref = state.purchaseHistories) === null || ref === void 0 ? void 0 : ref.edges.map(function(param) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseHistory, {
                        purchaseHistory: node
                    }, node.id);
                }),
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    sx: {
                        pt: 2
                    },
                    children: Array.from(Array(3).keys()).map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseHistorySkeleton, {}, key);
                    })
                }),
                componentProps: {
                    spacing: 5
                },
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                emptyMessage: t("storePurchaseHistoryEmpty")
            })
        ]
    });
};
var HeaderTagCell = function(param) {
    var loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("storePurchaseOrders").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 2,
            pb: 4
        },
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "h3",
            width: "60%"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        bgcolor: "grey.50"
                    },
                    href: routerPages.DeliveryManagement,
                    children: t("checkDeliveryStatus")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        bgcolor: "grey.50"
                    },
                    href: routerPages.PaymentStatuses,
                    children: t("ordersAwaitingPayment")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrders/viewModel.ts



function StorePurchaseOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StorePurchaseOrders($pageInput: PageInput, $skuId: String) {\n    userCartTransactionOrders(pageInput: $pageInput) {\n      ...StorePurchaseOrderConnection\n    }\n  }\n  ",
        "\n"
    ]);
    StorePurchaseOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StorePurchaseOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,useQuery/* useQuery */.aM)(StorePurchaseOrders_viewModel_QUERY), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore;
    var ref1;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : data.userCartTransactionOrders.pageInfo.hasNextPage),
            purchaseHistories: (ref1 = data === null || data === void 0 ? void 0 : data.userCartTransactionOrders) !== null && ref1 !== void 0 ? ref1 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : data.userCartTransactionOrders.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var StorePurchaseOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(StorePurchaseOrders_viewModel_templateObject(), utoniq_core_schema/* StorePurchaseOrderConnectionFragmentDoc */.pt2);

;// CONCATENATED MODULE: ./src/components/pages/StorePurchaseOrders/index.tsx




/**
 * StorePurchaseOrders Page
 * Implemented as a practical sample.
 */ var StorePurchaseOrders = function() {
    var ref = StorePurchaseOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StorePurchaseOrdersTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreRequestProvidableItemSearch/viewModel.ts

function StoreRequestProvidableItemSearch_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query StoreRequestProvidableItemSearch {\n    prepaidPointBalance {\n      prepaidPointId\n      balance\n      formattedPrepaidPointBarance @client\n    }\n  }\n"
    ]);
    StoreRequestProvidableItemSearch_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StoreRequestProvidableItemSearch_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var data = (0,useQuery/* useQuery */.aM)(StoreRequestProvidableItemSearch_viewModel_QUERY).data;
    var ref1, ref2;
    return {
        state: {
            artistId: artistId,
            isLoggedIn: !!user,
            userLoggedInId: (ref1 = user === null || user === void 0 ? void 0 : user.uid) !== null && ref1 !== void 0 ? ref1 : "",
            keyword: router.query.keyword,
            point: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.prepaidPointBalance) === null || ref === void 0 ? void 0 : ref.formattedPrepaidPointBarance) !== null && ref2 !== void 0 ? ref2 : ""
        },
        actions: {}
    };
});
var StoreRequestProvidableItemSearch_viewModel_QUERY = (0,lib/* default */.ZP)(StoreRequestProvidableItemSearch_viewModel_templateObject());

;// CONCATENATED MODULE: ./src/components/pages/StoreRequestProvidableItemSearch/index.tsx




/**
 * StoreRequestProvidableItemSearch Page
 * Implemented as a practical sample.
 */ var StoreRequestProvidableItemSearch = function() {
    var ref = StoreRequestProvidableItemSearch_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(template/* StoreRequestProvidableItemSearchTemplate */.Pf, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/StoreUserInfo/template/index.tsx







var StoreUserInfoTemplate = function(param) {
    var state = param.state, onSubmit = param.onSubmit, onCloseSMSVerificationModal = param.onCloseSMSVerificationModal, onSendVerificationSMS = param.onSendVerificationSMS;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("storeUserInfo").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            title: t("title"),
            back: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.StoreUserInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    my: 4
                },
                children: t("label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreUserInfoForm, {
                onSubmitSetting: onSubmit,
                deliveryInfo: state.user || {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: state.openSMSVerificationModal,
                onClose: onCloseSMSVerificationModal,
                title: t("verifyTitle"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t("verifyDesc", {
                        phoneNumber: (ref = state.user) === null || ref === void 0 ? void 0 : ref.formattedPhoneNumber
                    })
                }),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: {
                        minWidth: 212,
                        mt: 4
                    },
                    size: "large",
                    onClick: onSendVerificationSMS,
                    loading: state.sendingVerificationLoading,
                    children: t("verify")
                }),
                cancelText: t("close")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/StoreUserInfo/viewModel.ts







function StoreUserInfo_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query storeUserInfo {\n    user {\n      id\n      formattedPhoneNumber @client\n      ...UserDeliveryInfo\n    }\n  }\n  ",
        "\n"
    ]);
    StoreUserInfo_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StoreUserInfo_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation updateStoreUserInfo(\n    $updateUserDeliveryInfoInputs: UserDeliveryInput!\n  ) {\n    updateUserDeliveryInfo(inputs: $updateUserDeliveryInfoInputs) {\n      ...UserDeliveryInfo\n    }\n  }\n  ",
        "\n"
    ]);
    StoreUserInfo_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StoreUserInfo_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, routerPages = ref.routerPages;
    var data = (0,useQuery/* useQuery */.aM)(StoreUserInfo_viewModel_QUERY).data;
    var ref1 = (0,react.useState)(false), openSMSVerificationModal = ref1[0], setOpenSMSVerificationModal = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_USER_INFORMATION_SETTINGS), 1), updateUserDeliveryInfo = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* SendVerificationSms */.D85), 2), sendVerificationSMS = ref3[0], ref4 = ref3[1], sendingVerificationLoading = ref4.loading;
    return {
        state: {
            user: data === null || data === void 0 ? void 0 : data.user,
            openSMSVerificationModal: openSMSVerificationModal,
            sendingVerificationLoading: sendingVerificationLoading
        },
        actions: {
            onSubmit: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                    var ref, _ref, fullAddress, __typename, addressInput, userInfoRegisterRedirect;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.address) || {
                                    postalCode: "",
                                    prefecture: "",
                                    city: "",
                                    line1: "",
                                    line2: ""
                                }, fullAddress = _ref.fullAddress, __typename = _ref.__typename, addressInput = (0,_object_without_properties/* default */.Z)(_ref, [
                                    "fullAddress",
                                    "__typename"
                                ]);
                                return [
                                    4,
                                    (0,storage/* getUserInfoRegisterRedirect */.j6)()
                                ];
                            case 1:
                                userInfoRegisterRedirect = _state.sent();
                                return [
                                    2,
                                    updateUserDeliveryInfo({
                                        variables: {
                                            updateUserDeliveryInfoInputs: {
                                                fullName: values.fullName,
                                                phoneNumber: values.phoneNumber,
                                                address: addressInput
                                            }
                                        },
                                        update: function update(cache, param) {
                                            var data = param.data;
                                            return (0,src_async_to_generator/* default */.Z)(function() {
                                                var userDeliveryInfoResponse, existingUser;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    userDeliveryInfoResponse = data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo;
                                                    existingUser = cache.readQuery({
                                                        query: StoreUserInfo_viewModel_QUERY
                                                    });
                                                    if (existingUser && userDeliveryInfoResponse) {
                                                        cache.writeQuery({
                                                            query: StoreUserInfo_viewModel_QUERY,
                                                            data: {
                                                                user: (0,src_object_spread/* default */.Z)({}, existingUser.user, userDeliveryInfoResponse)
                                                            }
                                                        });
                                                    }
                                                    return [
                                                        2
                                                    ];
                                                });
                                            })();
                                        }
                                    }).then(function() {
                                        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                                            var data, redirectPath;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = param.data;
                                                        if (!(data === null || data === void 0 ? void 0 : data.updateUserDeliveryInfo.isPhoneNumberVerified)) {
                                                            setOpenSMSVerificationModal(true);
                                                            return [
                                                                2,
                                                                "verifyPhoneNumber"
                                                            ];
                                                        }
                                                        return [
                                                            4,
                                                            (0,storage/* setUserInfoRegisterRedirect */.Yx)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, userInfoRegisterRedirect), {
                                                                phoneNumber: true
                                                            }))
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        redirectPath = userInfoRegisterRedirect.address ? routerPages.StoreDeliveryInfo : userInfoRegisterRedirect.direction;
                                                        if (!redirectPath) {
                                                            router.goBack(routerPages.Setting);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        router.push(redirectPath);
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(_) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                        }
                    });
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            onCloseSMSVerificationModal: function() {
                setOpenSMSVerificationModal(false);
            },
            onSendVerificationSMS: function onSendVerificationSMS() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    sendVerificationSMS()
                                ];
                            case 1:
                                _state.sent();
                                router.push(routerPages.SMSVerification);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var StoreUserInfo_viewModel_QUERY = (0,lib/* gql */.Ps)(StoreUserInfo_viewModel_templateObject(), utoniq_core_schema/* UserDeliveryInfoFragmentDoc */.I0h);
var UPDATE_USER_INFORMATION_SETTINGS = (0,lib/* gql */.Ps)(StoreUserInfo_viewModel_templateObject1(), utoniq_core_schema/* UserDeliveryInfoFragmentDoc */.I0h);

;// CONCATENATED MODULE: ./src/components/pages/StoreUserInfo/index.tsx




var StoreUserInfo = function() {
    var ref = StoreUserInfo_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreUserInfoTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/pages/ThreadCreate/template/index.tsx + 2 modules
var ThreadCreate_template = __webpack_require__(32988);
;// CONCATENATED MODULE: ./src/components/pages/ThreadCreate/viewModel.ts







function ThreadCreate_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ThreadCreate($id: ID) {\n    artist(id: $id) {\n      patron {\n        id\n      }\n      id\n      displayName\n      avatar {\n        uri\n      }\n    }\n    user {\n      id\n      avatar {\n        uri\n      }\n      displayName\n    }\n  }\n"
    ]);
    ThreadCreate_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThreadCreate_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateArtistThreadChannel($inputs: CreateArtistThreadInput!) {\n    createArtistThreadChannel(inputs: $inputs) {\n      ...ThreadBox\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadCreate_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ThreadCreate_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref = (0,react.useState)(false), openCommunityNote = ref[0], setOpenCommunityNote = ref[1];
    var _artistId;
    var artistId = (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId;
    var data = (0,useQuery/* useQuery */.aM)(ThreadCreate_viewModel_QUERY, {
        variables: {
            id: artistId
        }
    }).data;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_ARTIST_THREAD_CHANNEL), 1), createArtistThreadChannel = ref1[0];
    (0,react.useEffect)(function() {
        (0,storage/* getAcceptCommunityNote */.n8)().then(function(value) {
            setOpenCommunityNote(!value.value);
        });
    }, []);
    var ref2, ref3;
    return {
        state: {
            artistId: artistId,
            artist: (ref2 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref2 !== void 0 ? ref2 : null,
            user: (ref3 = data === null || data === void 0 ? void 0 : data.user) !== null && ref3 !== void 0 ? ref3 : null,
            openCommunityNote: openCommunityNote
        },
        actions: {
            onCreateThread: function onCreateThread(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var thumbnail, inputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                thumbnail = _param.thumbnail, inputs = (0,_object_without_properties/* default */.Z)(_param, [
                                    "thumbnail"
                                ]);
                                return [
                                    4,
                                    createArtistThreadChannel({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                                status: utoniq_core_schema/* ThreadStatus.Published */.SVj.Published,
                                                artistId: artistId,
                                                thumbnail: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath) ? {
                                                    tmpPath: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath
                                                } : undefined
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSaveDraft: function onSaveDraft(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var thumbnail, inputs;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                thumbnail = _param.thumbnail, inputs = (0,_object_without_properties/* default */.Z)(_param, [
                                    "thumbnail"
                                ]);
                                return [
                                    4,
                                    createArtistThreadChannel({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                                status: utoniq_core_schema/* ThreadStatus.Draft */.SVj.Draft,
                                                artistId: artistId,
                                                thumbnail: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath) ? {
                                                    tmpPath: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath
                                                } : undefined
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onAcceptCommunityNote: function onAcceptCommunityNote(param) {
                var accept = param.accept;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!accept) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0,storage/* setAcceptCommunityNote */.Jy)("true")
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                setOpenCommunityNote(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ThreadCreate_viewModel_QUERY = (0,lib/* gql */.Ps)(ThreadCreate_viewModel_templateObject());
var CREATE_ARTIST_THREAD_CHANNEL = (0,lib/* gql */.Ps)(ThreadCreate_viewModel_templateObject1(), utoniq_core_schema/* ThreadBoxFragmentDoc */.bid);

;// CONCATENATED MODULE: ./src/components/pages/ThreadCreate/index.tsx




/**
 * ThreadCreate Page
 * Implemented as a practical sample.
 */ var ThreadCreate = function() {
    var ref = ThreadCreate_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCreate_template/* ThreadCreateTemplate */.e$, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/organisms/community/ThreadDetailBoxSkeleton/index.tsx



var ThreadDetailBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "unset",
            borderRadius: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 281
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "large",
                        numberOfLine: 2,
                        lastWidth: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        sx: {
                            pt: 9,
                            pb: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "circular",
                                width: 28,
                                height: 28
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "small",
                                width: "25%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "medium",
                        numberOfLine: 3,
                        lastWidth: "75%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    height: 56
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/community/ThreadDetailBox/index.tsx











var ThreadDetailBox = function(param) {
    var thread = param.thread, currentUser = param.currentUser, _paddingImage = param.paddingImage, paddingImage = _paddingImage === void 0 ? 0 : _paddingImage, onLikeOrUnlike = param.onLikeOrUnlike, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onDeleteThread = param.onDeleteThread, onReply = param.onReply;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var t = (0,core_i18n/* useTranslation */.$G)("threadDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref8 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref8.showMessage, showError = ref8.showError;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref9.generatePath, routerPages = ref9.routerPages;
    var ref10 = (0,react.useState)(false), open = ref10[0], setOpen = ref10[1];
    var toggleDrawer = (0,react.useCallback)(function(open) {
        return function() {
            setOpen(open);
        };
    }, []);
    var handleReportUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onReportUser(thread.id, (ref2 = (ref = thread.createdByUser) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "", (ref3 = (ref1 = thread.createdByUser) === null || ref1 === void 0 ? void 0 : ref1.formattedAccountId) !== null && ref3 !== void 0 ? ref3 : "")
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onReportUser,
        thread
    ]);
    var handleBlockUser = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        onBlockUser((ref1 = (ref = thread.createdByUser) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "").then(function(hiddenMessage) {
                            return !hiddenMessage && showMessage(t("blockUserSuccess"), "success");
                        })
                    ];
                case 1:
                    _state.sent();
                    setOpen(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        onBlockUser,
        showMessage,
        t,
        thread.createdByUser
    ]);
    var handleDeleteThread = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        onDeleteThread(thread.id)
                    ];
                case 1:
                    _state.sent();
                    showMessage(t("deleteComplete"), "success");
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if ((0,_instanceof/* default */.Z)(error, Error)) showError(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        onDeleteThread,
        showError,
        showMessage,
        t,
        thread.id
    ]);
    var _category, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
        elevation: 0,
        sx: {
            bgcolor: "transparent",
            borderRadius: 0,
            zIndex: 1,
            position: "relative"
        },
        children: [
            ((ref = thread.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: paddingImage
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia_CardMedia/* default */.Z, {
                    component: "img",
                    height: "280",
                    image: thread.thumbnail.mediumUri,
                    alt: thread.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent_CardContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h4",
                        children: thread.name
                    }),
                    !(!thread.isOfficial && !thread.category) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCategory/* ThreadCategory */.v, {
                        isOfficial: thread.isOfficial,
                        category: (_category = thread.category) !== null && _category !== void 0 ? _category : ""
                    }),
                    thread.createdByUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        sx: {
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        component: Link/* default */.Z,
                                        onClick: handleLoginModal(),
                                        href: generatePath(routerPages.UserProfile, {
                                            userId: (ref1 = thread.createdByUser) === null || ref1 === void 0 ? void 0 : ref1.id
                                        }),
                                        direction: "row",
                                        spacing: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                src: (ref11 = (ref2 = thread.createdByUser) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.avatar) === null || ref3 === void 0 ? void 0 : ref3.smallUri) !== null && ref11 !== void 0 ? ref11 : "",
                                                sx: {
                                                    width: 28,
                                                    height: 28
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                color: "text.secondary",
                                                children: (ref4 = thread.createdByUser) === null || ref4 === void 0 ? void 0 : ref4.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "text.hint",
                                        children: thread.formattedCreatedAt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.More, {
                                size: "small",
                                onClick: toggleDrawer(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reactLinkify/* LinkifyBox */.X, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                pt: 3,
                                wordBreak: "break-all"
                            },
                            children: thread.description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                sx: {
                    pt: 0,
                    pb: 3,
                    px: 5,
                    justifyContent: "flex-end",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Like, {
                                    onClick: handleLoginModal(function() {
                                        return onLikeOrUnlike(!!thread.isLike, thread.likeCount);
                                    }),
                                    liked: !!thread.isLike
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: thread.likeCount
                                })
                            ]
                        }),
                        onReply && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Reply, {
                                    onClick: handleLoginModal(onReply)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "caption",
                                    children: thread.commentCount
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer_Drawer/* default */.ZP, {
                disableEnforceFocus: true,
                open: open,
                onClose: toggleDrawer(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            p: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "h6",
                            color: "grey.600",
                            align: "center",
                            children: (ref5 = thread.createdByUser) === null || ref5 === void 0 ? void 0 : ref5.displayName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List_List/* default */.Z, {
                        children: [
                            (currentUser === null || currentUser === void 0 ? void 0 : currentUser.formattedAccountId) !== ((ref6 = thread.createdByUser) === null || ref6 === void 0 ? void 0 : ref6.formattedAccountId) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Box_Box/* default */.Z,
                                        sx: {
                                            height: 52
                                        },
                                        onClick: handleLoginModal(handleReportUser),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("report")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Box_Box/* default */.Z,
                                        sx: {
                                            height: 52
                                        },
                                        divider: true,
                                        onClick: handleLoginModal(handleBlockUser),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("block")
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Link/* default */.Z,
                                        onClick: handleLoginModal(),
                                        sx: {
                                            height: 52
                                        },
                                        href: generatePath(routerPages.ArtistThreadEdit, {
                                            threadId: thread.id,
                                            artistId: (ref7 = thread.createdByUser) === null || ref7 === void 0 ? void 0 : ref7.id
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("edit")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                        component: Box_Box/* default */.Z,
                                        sx: {
                                            height: 52
                                        },
                                        divider: true,
                                        onClick: handleLoginModal(handleDeleteThread),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                            variant: "h6",
                                            children: t("delete")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton_ListItemButton/* default */.Z, {
                                component: Box_Box/* default */.Z,
                                sx: {
                                    height: 52
                                },
                                alignItems: "center",
                                onClick: toggleDrawer(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "center",
                                    sx: {
                                        width: "100%"
                                    },
                                    children: t("cancel")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ThreadDetail/template/index.tsx















var ThreadDetailTemplate = function(param) {
    var state = param.state, onLikeOrUnlike = param.onLikeOrUnlike, onReply = param.onReply, onFetchMore = param.onFetchMore, onDeleteComment = param.onDeleteComment, onReportUserComment = param.onReportUserComment, onBlockUserComment = param.onBlockUserComment, onReportUser = param.onReportUser, onBlockUser = param.onBlockUser, onReplyToReply = param.onReplyToReply, onDeleteThread = param.onDeleteThread, onLikeOrUnlikeComment = param.onLikeOrUnlikeComment, onRemoveReplyToReply = param.onRemoveReplyToReply, onUpdateArtistThreadMuteStatus = param.onUpdateArtistThreadMuteStatus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref11.routerNames, generatePath = ref11.generatePath, routerPages = ref11.routerPages;
    var replyFormRef = (0,react.useRef)(null);
    var bottomSheetRef = (0,react.useRef)(null);
    var commentListRef = (0,react.useRef)(null);
    var ref12 = (0,react.useState)(false), open = ref12[0], setOpen = ref12[1];
    var ref13 = (0,react.useState)(false), hiddenReadMore = ref13[0], setHiddenReadMore = ref13[1];
    (0,react.useEffect)(function() {
        setHiddenReadMore(!isNaN(Number(state.unreadIndex)));
    }, [
        state.unreadIndex
    ]);
    /**
   * hidden button unread comment when user scroll to bottom
   */ (0,react.useEffect)(function() {
        var handleScroll = function handleScroll(event) {
            var artistThemeProvider = this.document.getElementsByClassName("artist-theme-provider").item(0);
            if (!artistThemeProvider) {
                return;
            }
            if (artistThemeProvider.scrollHeight <= artistThemeProvider.clientHeight + this.scrollY + 50) {
                setHiddenReadMore(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        var bottomSheet = bottomSheetRef.current;
        return function() {
            bottomSheet === null || bottomSheet === void 0 ? void 0 : bottomSheet.dismiss();
            setOpen(false);
        };
    }, []);
    if (!state.loading && !state.thread) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    var ref14, ref15, ref16, ref17, ref18;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref = state.thread) === null || ref === void 0 ? void 0 : ref.artistId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: ((ref1 = state.thread) === null || ref1 === void 0 ? void 0 : ref1.name) || routerNames.ArtistThreadDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "replyForm",
                    props: {
                        ref: replyFormRef,
                        onReply: function(values) {
                            var ref;
                            return onReply(values, (ref14 = (ref = state.thread) === null || ref === void 0 ? void 0 : ref.artistId) !== null && ref14 !== void 0 ? ref14 : "");
                        },
                        visibleImage: true,
                        userId: (ref15 = (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref15 !== void 0 ? ref15 : "",
                        replyToDisplayName: state.replyToDisplayName,
                        onRemoveReplyToReply: onRemoveReplyToReply
                    }
                },
                showScrollBar: true,
                scrollFromBottom: !state.loading,
                header: {
                    back: true,
                    defaultBackPage: ((ref3 = state.thread) === null || ref3 === void 0 ? void 0 : ref3.artistId) ? config_config/* config.applicationType */.v.applicationType === "standalone" ? generatePath(routerPages.ArtistTop, {
                        artistId: (ref16 = (ref4 = state.thread) === null || ref4 === void 0 ? void 0 : ref4.artistId) !== null && ref16 !== void 0 ? ref16 : "#"
                    }) : generatePath(routerPages.ArtistThreads, {
                        artistId: (ref17 = (ref5 = state.thread) === null || ref5 === void 0 ? void 0 : ref5.artistId) !== null && ref17 !== void 0 ? ref17 : "#"
                    }) : undefined,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        flex: 1,
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        sx: {
                            mx: 6
                        },
                        onClick: function() {
                            return setOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h5",
                                sx: styles/* styleSets.lineCamp */.k$.lineCamp(1),
                                align: "center",
                                children: (ref18 = (ref6 = state.thread) === null || ref6 === void 0 ? void 0 : ref6.name) !== null && ref18 !== void 0 ? ref18 : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                fontSize: "small",
                                sx: {
                                    color: "grey.600"
                                }
                            })
                        ]
                    }),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        sx: {
                            ml: -8
                        },
                        children: ((ref7 = state.thread) === null || ref7 === void 0 ? void 0 : ref7.isAllowNotification) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOn, {
                            size: "small",
                            onClick: onUpdateArtistThreadMuteStatus,
                            sx: {
                                color: "grey.600"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.AudioOff, {
                            size: "small",
                            onClick: onUpdateArtistThreadMuteStatus,
                            sx: {
                                color: "grey.600"
                            }
                        })
                    })
                },
                children: [
                    state.loading || !state.thread ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadDetailBoxSkeleton, {}) : !state.hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadDetailBox, {
                            onDeleteThread: onDeleteThread,
                            currentUser: state.user,
                            thread: state.thread,
                            onLikeOrUnlike: onLikeOrUnlike,
                            onBlockUser: onBlockUser,
                            onReportUser: onReportUser,
                            onReply: function() {
                                var ref;
                                return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            mt: 3
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                        ref: commentListRef,
                        type: "threads",
                        hiddenHeader: true,
                        hiddenNotice: true,
                        inverted: true,
                        typeId: (ref8 = state.thread) === null || ref8 === void 0 ? void 0 : ref8.id,
                        commentCount: (ref9 = state.thread) === null || ref9 === void 0 ? void 0 : ref9.commentCount,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        comments: state.comments,
                        user: state.user,
                        onFetchMore: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                            var ref, ref1, beforeOffsetHeight;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        beforeOffsetHeight = (ref1 = (ref = commentListRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0;
                                        return [
                                            4,
                                            onFetchMore()
                                        ];
                                    case 1:
                                        _state.sent();
                                        /**
             * @hack keep current scroll position
             */ if (dist_lib/* isSafari */.G6 || (0,native_app/* getPlatform */.Xf)() === "ios") {
                                            setTimeout(function() {
                                                var ref;
                                                var ref1;
                                                var afterOffsetHeight = (ref1 = (ref = commentListRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0;
                                                window.scrollTo({
                                                    top: afterOffsetHeight - beforeOffsetHeight
                                                });
                                            }, 0);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        onDeleteComment: onDeleteComment,
                        onReportUser: onReportUserComment,
                        onBlockUser: onBlockUserComment,
                        onReplyToReply: onReplyToReply,
                        onLikeOrUnlikeComment: onLikeOrUnlikeComment,
                        onClickReply: function() {
                            var ref;
                            return (ref = replyFormRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                        },
                        rootCollectionId: (ref10 = state.thread) === null || ref10 === void 0 ? void 0 : ref10.id,
                        showReaction: true,
                        unreadIndex: state.unreadIndex,
                        hiddenReadMore: hiddenReadMore,
                        onHiddenReadMore: function() {
                            return setHiddenReadMore(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomSheet/* BottomSheet */.R, {
                ref: bottomSheetRef,
                open: open,
                breakpoints: [
                    0,
                    2 / 3,
                    1
                ],
                initialBreakpoint: 2 / 3,
                onClose: function() {
                    return setOpen(false);
                },
                handle: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                    header: {
                        right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                            edge: "end",
                            size: "medium",
                            onClick: function() {
                                return setOpen(false);
                            }
                        }),
                        sx: {
                            pt: 0
                        }
                    },
                    safeArea: {
                        pt: 0
                    },
                    children: state.thread && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadDetailBox, {
                        paddingImage: 5,
                        onDeleteThread: onDeleteThread,
                        currentUser: state.user,
                        thread: state.thread,
                        onLikeOrUnlike: onLikeOrUnlike,
                        onBlockUser: onBlockUser,
                        onReportUser: onReportUser
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/lodash/findLastIndex.js
var findLastIndex = __webpack_require__(30446);
var findLastIndex_default = /*#__PURE__*/__webpack_require__.n(findLastIndex);
;// CONCATENATED MODULE: ./src/components/pages/ThreadDetail/viewModel.ts





function ThreadDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ThreadDetail($artistThreadChannelId: ID!, $pageInput: PageInput) {\n    artistThreadChannel(id: $artistThreadChannelId) {\n      ...ThreadBox\n      comments(pageInput: $pageInput) {\n        ...CommentsConnection\n      }\n    }\n    user {\n      id\n      accountId\n      formattedAccountId @client\n      email\n      avatar {\n        uri\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    ThreadDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikeArtistThreadChannel($likeArtistThreadChannelId: ID!) {\n    likeArtistThreadChannel(id: $likeArtistThreadChannelId) {\n      id\n      likeCount\n      isLike\n    }\n  }\n"
    ]);
    ThreadDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikeArtistThreadChannel($unlikeArtistThreadChannelId: ID!) {\n    unlikeArtistThreadChannel(id: $unlikeArtistThreadChannelId) {\n      id\n      likeCount\n      isLike\n    }\n  }\n"
    ]);
    ThreadDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateArtistThreadComment(\n    $id: String!\n    $inputs: CommunityCommentInput!\n  ) {\n    createArtistThreadComment(id: $id, inputs: $inputs) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadDetail_viewModel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteArtistThreadComment($id: String!, $commentId: String!) {\n    deleteArtistThreadComment(id: $id, commentId: $commentId) {\n      ...CommentBox\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadDetail_viewModel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArchiveArtistThreadChannel($archiveArtistThreadChannelId: ID!) {\n    archiveArtistThreadChannel(id: $archiveArtistThreadChannelId) {\n      ...ThreadBox\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadDetail_viewModel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LikeThreadComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    likeArtistThreadChannelComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    ThreadDetail_viewModel_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ThreadDetail_viewModel_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UnlikeThreadComment($inputs: CommunityCommentLikeUnlikeInput!) {\n    unlikeArtistThreadChannelComment(inputs: $inputs) {\n      id\n      isLike\n      likeCount\n    }\n  }\n"
    ]);
    ThreadDetail_viewModel_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function viewModel_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateThreadUnread($inputs: UpdateUnreadInput!) {\n    updateUserUnread(inputs: $inputs) {\n      id\n      lastReadAt\n      parentId\n      totalUnreadMentionCount\n      unreadMentionCount\n      unreadType\n    }\n  }\n"
    ]);
    viewModel_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistThreadMuteStatus($id: ID!) {\n    updateArtistThreadMuteStatus(id: $id) {\n      id\n      isAllowNotification\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}














var ThreadDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    var ref9 = (0,router_useRouter/* useRouter */.tv)(), router = ref9.router, generatePath = ref9.generatePath, routerPages = ref9.routerPages;
    var ref10 = useReplyToComment(), _data = ref10.data, replyToDisplayName = _data.replyToDisplayName, replyToAccountId = _data.replyToAccountId, replyToCommentId = _data.replyToCommentId, onReplyToReply = ref10.onReplyToReply, onRemoveReplyToReply = ref10.onRemoveReplyToReply;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var threadId = router.query.threadId;
    var ref11 = (0,useQuery/* useQuery */.aM)(ThreadDetail_viewModel_QUERY, {
        variables: {
            artistThreadChannelId: threadId
        },
        returnPartialData: true,
        onCompleted: function(data) {
            if (!(data === null || data === void 0 ? void 0 : data.artistThreadChannel.artist)) return;
            var ref;
            (0,vars/* currentArtistVar */.ag)((ref = pick_default()(data === null || data === void 0 ? void 0 : data.artistThreadChannel.artist, [
                "id",
                "avatar",
                "displayName",
                "accountId",
                "formattedAccountId",
                "totalUnreadMentionCount", 
            ])) !== null && ref !== void 0 ? ref : null);
        }
    }), data = ref11.data, loading = ref11.loading, error = ref11.error, fetchMore = ref11.fetchMore, refetch = ref11.refetch;
    var ref12;
    var artistId = (ref12 = data === null || data === void 0 ? void 0 : (ref = data.artistThreadChannel) === null || ref === void 0 ? void 0 : ref.artistId) !== null && ref12 !== void 0 ? ref12 : "";
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(utoniq_core_schema/* ArtistThreads */.Qqj, {
        onCompleted: function onCompleted() {
            router.goBack(generatePath(routerPages.ArtistThreads, {
                artistId: artistId
            }));
        }
    }), 1), refetchArtistThreads = ref13[0];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_ARTIST_THREAD_CHANNEL), 1), likeArtistThreadChannel = ref14[0];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_ARTIST_THREAD_CHANNEL), 1), unlikeArtistThreadChannel = ref15[0];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CREATE_ARTIST_THREAD_COMMENT), 1), createArtistThreadComment = ref16[0];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_ARTIST_THREAD_COMMENT), 1), deleteArtistThreadComment = ref17[0];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* BlockUser */._89), 1), blockUser = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DELETE_THREAD, {
        onCompleted: function onCompleted() {
            router.goBack(generatePath(routerPages.ArtistThreads, {
                artistId: artistId
            }));
        }
    }), 1), deleteThread = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LIKE_THREAD_COMMENT), 1), likeComment = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNLIKE_THREAD_COMMENT), 1), unlikeComment = ref21[0];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_THREAD_UNREAD), 1), updateThreadUnread = ref22[0];
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_THREAD_MUTE_STATUS), 1), updateArtistThreadMuteStatus = ref23[0];
    var handleUpdateThreadUnread = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (user === null || user === void 0 ? void 0 : user.isAnonymous) return [
                        2
                    ];
                    if (!artistId && !threadId) return [
                        2
                    ];
                    /**
     * アクセス時に未読数の更新を行う
     * ネイティブの場合、バッジ数を更新する
     */ return [
                        4,
                        updateThreadUnread({
                            variables: {
                                inputs: {
                                    artistId: artistId,
                                    parentId: threadId,
                                    userUnreadType: utoniq_core_schema/* UserUnreadType.ArtistThread */.Pgp.ArtistThread
                                }
                            },
                            // no need to update new lastReadAt to graphql cache
                            fetchPolicy: "no-cache"
                        }).then(function(res) {
                            var ref;
                            if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.updateUserUnread) {
                                var ref1, ref2;
                                var ref3;
                                setBadgeCount((ref3 = (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.updateUserUnread) === null || ref2 === void 0 ? void 0 : ref2.totalUnreadMentionCount) !== null && ref3 !== void 0 ? ref3 : 0);
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        artistId,
        threadId,
        updateThreadUnread
    ]);
    (0,react.useEffect)(function() {
        if (loading || !(user === null || user === void 0 ? void 0 : user.uid)) return;
        handleUpdateThreadUnread();
    }, [
        handleUpdateThreadUnread,
        loading,
        user === null || user === void 0 ? void 0 : user.uid
    ]);
    var isNextFetch = !!(data === null || data === void 0 ? void 0 : data.artistThreadChannel);
    /**
   * @description
   * 未読コメントの位置を表示するためのインデックス
   * 未読コメント(メンションではない)に対する要件・API・デザインがFIXするまで実装しない
   */ var unreadIndex = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.artistThreadChannel) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : ref1.edges.length) || (data === null || data === void 0 ? void 0 : (ref2 = data.artistThreadChannel) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.userUnread) === null || ref3 === void 0 ? void 0 : ref3.lastReadAt) === undefined) {
            return undefined;
        }
        var lastIndex = findLastIndex_default()(data === null || data === void 0 ? void 0 : (ref4 = data.artistThreadChannel) === null || ref4 === void 0 ? void 0 : ref4.comments.edges, function(param) {
            var node = param.node;
            var ref, ref1;
            return node.createdAt >= (data === null || data === void 0 ? void 0 : (ref = data.artistThreadChannel) === null || ref === void 0 ? void 0 : (ref1 = ref.userUnread) === null || ref1 === void 0 ? void 0 : ref1.lastReadAt);
        });
        return lastIndex >= 0 ? lastIndex : undefined;
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.artistThreadChannel) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.comments) === null || ref2 === void 0 ? void 0 : ref2.edges,
        data === null || data === void 0 ? void 0 : (ref3 = data.artistThreadChannel) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.userUnread) === null || ref4 === void 0 ? void 0 : ref4.lastReadAt, 
    ]);
    var ref24, ref25, ref26;
    return {
        state: {
            loading: useInitialLoading(data, loading && !isNextFetch, error),
            hasNextPage: (data === null || data === void 0 ? void 0 : (ref5 = data.artistThreadChannel) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.comments) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pageInfo) === null || ref7 === void 0 ? void 0 : ref7.hasNextPage) || false,
            thread: (ref24 = data === null || data === void 0 ? void 0 : data.artistThreadChannel) !== null && ref24 !== void 0 ? ref24 : null,
            comments: (ref25 = data === null || data === void 0 ? void 0 : (ref8 = data.artistThreadChannel) === null || ref8 === void 0 ? void 0 : ref8.comments) !== null && ref25 !== void 0 ? ref25 : null,
            user: (ref26 = data === null || data === void 0 ? void 0 : data.user) !== null && ref26 !== void 0 ? ref26 : null,
            replyToDisplayName: replyToDisplayName,
            unreadIndex: unreadIndex
        },
        actions: {
            onLikeOrUnlike: function onLikeOrUnlike(isLike, likeCount) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikeArtistThreadChannel({
                                        variables: {
                                            unlikeArtistThreadChannelId: threadId
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var unlikeArtistThreadChannelId = param.unlikeArtistThreadChannelId;
                                            return {
                                                unlikeArtistThreadChannel: {
                                                    __typename: "ArtistThreadChannel",
                                                    id: unlikeArtistThreadChannelId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_unlikeThread", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: artistId,
                                            threadId: threadId
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likeArtistThreadChannel({
                                        variables: {
                                            likeArtistThreadChannelId: threadId
                                        },
                                        optimisticResponse: function optimisticResponse(param) {
                                            var likeArtistThreadChannelId = param.likeArtistThreadChannelId;
                                            return {
                                                likeArtistThreadChannel: {
                                                    __typename: "ArtistThreadChannel",
                                                    id: likeArtistThreadChannelId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_likeThread", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            artistId: artistId,
                                            threadId: threadId
                                        });
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReply: function onReply(inputs, artistId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    createArtistThreadComment({
                                        variables: {
                                            id: threadId,
                                            inputs: (0,src_object_spread/* default */.Z)({
                                                artistId: artistId,
                                                replyToId: replyToCommentId,
                                                replyToAccountId: replyToAccountId
                                            }, inputs)
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_sendComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            threadId: threadId,
                                            artistId: artistId,
                                            name: "thread"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    handleUpdateThreadUnread()
                                ];
                            case 2:
                                _state.sent();
                                onRemoveReplyToReply();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReportUserComment: function onReportUserComment(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref = user === null || user === void 0 ? void 0 : user.email) !== null && ref !== void 0 ? ref : "",
                                        contentType: "thread-comments",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteComment: function onDeleteComment(commentId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteArtistThreadComment({
                                        variables: {
                                            id: threadId,
                                            commentId: commentId
                                        }
                                    }).then(function() {
                                        analytics === null || analytics === void 0 ? void 0 : analytics.track("click_deleteComment", {
                                            applicationKey: config_config/* config.applicationKey */.v.applicationKey,
                                            threadId: threadId,
                                            artistId: artistId,
                                            name: "thread"
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUserComment: function onBlockUserComment(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    refetch({
                                        artistThreadChannelId: threadId
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onBlockUser: function onBlockUser(userId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, artistId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    blockUser({
                                        variables: {
                                            id: userId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                artistId = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.artistThreadChannel.artist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "";
                                return [
                                    4,
                                    refetchArtistThreads({
                                        variables: {
                                            inputs: {
                                                artistId: artistId,
                                                options: {
                                                    orderBy: utoniq_core_schema/* ArtistThreadChannelOrderByType.CreatedAt */.TuN.CreatedAt
                                                }
                                            },
                                            artistId: artistId
                                        }
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onReplyToReply: onReplyToReply,
            onRemoveReplyToReply: onRemoveReplyToReply,
            onReportUser: function onReportUser(contentId, userId, accountId) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    openReportForm({
                                        email: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.email) !== null && ref1 !== void 0 ? ref1 : "",
                                        contentType: "thread",
                                        contentId: contentId,
                                        userId: userId,
                                        accountId: accountId
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            artistThreadChannelId: threadId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.artistThreadChannel) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor,
                                                limit: 10
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onDeleteThread: function onDeleteThread() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    deleteThread({
                                        variables: {
                                            archiveArtistThreadChannelId: threadId
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onLikeOrUnlikeComment: function onLikeOrUnlikeComment(param) {
                var isLike = param.isLike, commentId = param.commentId, likeCount = param.likeCount, id = param.id;
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLike) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    unlikeComment({
                                        variables: {
                                            inputs: {
                                                id: id !== null && id !== void 0 ? id : "",
                                                commentId: commentId
                                            }
                                        },
                                        optimisticResponse: function(param) {
                                            var inputs = param.inputs;
                                            return {
                                                unlikeArtistThreadChannelComment: {
                                                    __typename: "Comment",
                                                    id: inputs.commentId,
                                                    isLike: false,
                                                    likeCount: --likeCount
                                                }
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    likeComment({
                                        variables: {
                                            inputs: {
                                                id: id !== null && id !== void 0 ? id : "",
                                                commentId: commentId
                                            }
                                        },
                                        optimisticResponse: function(param) {
                                            var inputs = param.inputs;
                                            return {
                                                likeArtistThreadChannelComment: {
                                                    __typename: "Comment",
                                                    id: inputs.commentId,
                                                    isLike: true,
                                                    likeCount: ++likeCount
                                                }
                                            };
                                        }
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onUpdateArtistThreadMuteStatus: function onUpdateArtistThreadMuteStatus() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    updateArtistThreadMuteStatus({
                                        variables: {
                                            id: threadId
                                        },
                                        optimisticResponse: function() {
                                            return {
                                                updateArtistThreadMuteStatus: {
                                                    __typename: "ArtistThreadChannel",
                                                    id: threadId,
                                                    isAllowNotification: !(data === null || data === void 0 ? void 0 : data.artistThreadChannel.isAllowNotification)
                                                }
                                            };
                                        }
                                    }).catch(function(e) {
                                        return showError(e);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ThreadDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject(), utoniq_core_schema/* ThreadBoxFragmentDoc */.bid, utoniq_core_schema/* CommentsConnectionFragmentDoc */.M6M);
var LIKE_ARTIST_THREAD_CHANNEL = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject1());
var UNLIKE_ARTIST_THREAD_CHANNEL = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject2());
var CREATE_ARTIST_THREAD_COMMENT = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject3(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var DELETE_ARTIST_THREAD_COMMENT = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject4(), utoniq_core_schema/* CommentBoxFragmentDoc */.f2S);
var DELETE_THREAD = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject5(), utoniq_core_schema/* ThreadBoxFragmentDoc */.bid);
var LIKE_THREAD_COMMENT = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject6());
var UNLIKE_THREAD_COMMENT = (0,lib/* gql */.Ps)(ThreadDetail_viewModel_templateObject7());
var UPDATE_THREAD_UNREAD = (0,lib/* gql */.Ps)(viewModel_templateObject8());
var UPDATE_ARTIST_THREAD_MUTE_STATUS = (0,lib/* gql */.Ps)(_templateObject9());

;// CONCATENATED MODULE: ./src/components/pages/ThreadDetail/index.tsx




/**
 * ThreadDetail Page
 * Implemented as a practical sample.
 */ var ThreadDetail = function() {
    var ref = ThreadDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

// EXTERNAL MODULE: ./src/components/pages/ThreadCreate/template/ThreadCreatePreview.tsx
var ThreadCreatePreview = __webpack_require__(48354);
// EXTERNAL MODULE: ./src/components/organisms/imageEditor/useImageEditor.tsx
var useImageEditor = __webpack_require__(22019);
;// CONCATENATED MODULE: ./src/components/pages/ThreadEdit/template/ThreadEditForm.tsx














var ThreadEditForm_schema = function(o) {
    return {
        thumbnail: o.object({
            tmpPath: o.string().allow("").optional(),
            fileUrl: o.string().allow("").optional()
        }).allow("").optional(),
        name: o.string().label((0,core_form/* tLabel */.TQ)("threadEdit.name")),
        description: o.string().label((0,core_form/* tLabel */.TQ)("threadEdit.description")),
        category: o.string().label((0,core_form/* tLabel */.TQ)("threadEdit.category")).allow("").optional(),
        isPremium: o.boolean().label((0,core_form/* tLabel */.TQ)("threadEdit.isPremium")).allow(false).optional()
    };
};
var ThreadEditForm_defaultValues = {
    name: "",
    description: "",
    thumbnail: {
        tmpPath: "",
        fileUrl: ""
    },
    isPremium: false,
    category: undefined
};
var ThreadEditForm = function(param) {
    var hasPatron = param.hasPatron, onSubmit = param.onSubmit, register = param.register, errors = param.errors, control = param.control, setValue = param.setValue, thread = param.thread, categoryOptions = param.categoryOptions, userId = param.userId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCell, {
                setValue: setValue,
                thumbnail: thread === null || thread === void 0 ? void 0 : thread.thumbnail,
                userId: userId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.name
                    }, register("name")), {
                        textFieldProps: {
                            minRows: 1,
                            maxRows: 5,
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography.h4;
                                }
                            },
                            variant: "standard",
                            InputProps: {
                                sx: {
                                    border: "none",
                                    px: 0,
                                    pt: 5,
                                    pb: 0
                                },
                                disableUnderline: true
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditForm_TextInputCell, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        type: "text",
                        error: errors === null || errors === void 0 ? void 0 : errors.description
                    }, register("description")), {
                        textFieldProps: {
                            minRows: 3,
                            maxRows: 10,
                            inputProps: {
                                sx: function(param) {
                                    var typography = param.typography;
                                    return typography.body1;
                                }
                            },
                            variant: "standard",
                            InputProps: {
                                sx: {
                                    border: "none",
                                    px: 0,
                                    pt: 5,
                                    pb: 0
                                },
                                disableUnderline: true
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditForm_HeadingTextCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditForm_ThreadTypeCell, {
                        control: control,
                        setValue: setValue,
                        categoryOptions: categoryOptions
                    }),
                    hasPatron && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberSetCell, {
                        control: control,
                        setValue: setValue
                    })
                ]
            })
        ]
    });
};
var ImageCell = function(param) {
    var setValue = param.setValue, userId = param.userId, thumbnail = param.thumbnail;
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    var ref = (0,useImageEditor/* useImageEditor */.O)({
        userId: userId,
        callback: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        setValue("thumbnail", data, {
                            shouldDirty: true
                        })
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        initialPath: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.fileUrl
    }), ImageEditModal = ref.ImageEditModal, ModalProps = ref.ModalProps, handleChoseFile = ref.handleChoseFile, handleRemoveFile = ref.handleRemoveFile, filePathAfterCrop = ref.filePathAfterCrop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        children: [
            filePathAfterCrop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        src: filePathAfterCrop,
                        variant: "square",
                        sx: {
                            width: "100%",
                            height: 281
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        onClick: handleRemoveFile,
                        size: "small",
                        bgcolor: "grey.50",
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 1
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    px: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    variant: "text",
                    sx: {
                        ml: -2
                    },
                    onClick: handleChoseFile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Image, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle1",
                            color: "text.secondary",
                            sx: {
                                ml: 2
                            },
                            children: t("attachImage")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageEditModal, (0,src_object_spread/* default */.Z)({}, ModalProps))
        ]
    });
};
var ThreadEditForm_TextInputCell = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var textFieldProps = _param.textFieldProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "textFieldProps"
    ]);
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextInputField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            t: t,
            textFieldProps: (0,src_object_spread/* default */.Z)({
                sx: {
                    p: 0,
                    m: 0,
                    bgcolor: "transparent",
                    width: "100%"
                },
                multiline: true,
                helperText: ""
            }, textFieldProps)
        }))
    });
});
var ThreadEditForm_HeadingTextCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    children: t("selectCategory")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    children: t("any")
                })
            ]
        })
    });
};
var ThreadEditForm_ThreadTypeCell = function(param) {
    var control = param.control, setValue = param.setValue, categoryOptions = param.categoryOptions;
    var category = (0,react_hook_form_dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "category"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ScrollTag, {
            value: category,
            tags: categoryOptions,
            onClick: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(value) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setValue("category", category === value ? undefined : value, {
                            shouldDirty: true
                        });
                        return [
                            2
                        ];
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }()
        })
    });
};
var MemberSetCell = function(param) {
    var control = param.control, setValue = param.setValue;
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    var isPremium = (0,react_hook_form_dist_index_esm/* useWatch */.qo)({
        control: control,
        name: "isPremium"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem_ListItem/* default */.ZP, {
                    secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Switch, {
                        checked: isPremium,
                        onChange: function(event, checked) {
                            setValue("isPremium", checked);
                        }
                    }),
                    sx: {
                        p: 0,
                        ".MuiListItemSecondaryAction-root": {
                            right: 0
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                        primary: t("membersOnly"),
                        slotProps: {
                            primary: {
                                variant: "subtitle1"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                sx: {
                    pt: 3,
                    pb: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Help, {
                        fontSize: "xSmall"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: t("membersOnlyNote")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/ThreadEdit/template/index.tsx














var ThreadEditTemplate = function(param) {
    var state = param.state, onEditThread = param.onEditThread;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,core_i18n/* useTranslation */.$G)("threadCreate").t;
    var ref5 = (0,router_useRouter/* useRouter */.tv)(), router = ref5.router, routerNames = ref5.routerNames, generatePath = ref5.generatePath, routerPages = ref5.routerPages;
    var _threadId;
    var defaultBackPage = generatePath(routerPages.ArtistThreadDetail, {
        threadId: (_threadId = router.query.threadId) !== null && _threadId !== void 0 ? _threadId : "#"
    });
    var ref6 = (0,messages_useMessage/* useMessage */.UD)(), showMessage = ref6.showMessage, showError = ref6.showError;
    var ref7 = (0,react.useState)(false), open = ref7[0], setOpen = ref7[1];
    var ref8 = (0,react.useState)(false), artistDraftSaving = ref8[0], setArtistDraftSaving = ref8[1];
    var ref9 = (0,react.useState)(false), artistEditing = ref9[0], setArtistEditing = ref9[1];
    var ref10 = (0,react.useState)(false), openPreview = ref10[0], setOpenPreview = ref10[1];
    var ref11 = (0,core_form/* useForm */.cI)({
        schema: ThreadEditForm_schema,
        defaultValues: ThreadEditForm_defaultValues
    }), handleSubmit = ref11.handleSubmit, register = ref11.register, control = ref11.control, setValue = ref11.setValue, getValues = ref11.getValues, reset = ref11.reset, setError = ref11.setError, _formState = ref11.formState, errors = _formState.errors, isValid = _formState.isValid, isDirty = _formState.isDirty;
    var categoryOptions = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            return {
                value: category,
                label: t([
                    "category_".concat(category),
                    category
                ])
            };
        });
    }, [
        t
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!state.thread) {
            return;
        }
        var _category, ref1;
        reset({
            category: (_category = state.thread.category) !== null && _category !== void 0 ? _category : undefined,
            description: state.thread.description,
            isPremium: state.thread.isPremium,
            name: state.thread.name,
            thumbnail: {
                fileUrl: (ref1 = (ref = state.thread.thumbnail) === null || ref === void 0 ? void 0 : ref.mediumUri) !== null && ref1 !== void 0 ? ref1 : ""
            }
        });
    }, [
        state.thread,
        reset
    ]);
    var onSubmit = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isDirty) {
                            return [
                                2,
                                router.goBack(defaultBackPage)
                            ];
                        }
                        setArtistEditing(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onEditThread(values)
                        ];
                    case 2:
                        _state.sent();
                        router.goBack(defaultBackPage);
                        showMessage(t("updateComplete"), "success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0,core_form/* handleError */.S3)(error, setError, showError);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setArtistEditing(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleSaveDraft = handleSubmit(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setArtistDraftSaving(true);
                try {
                    /**
       * @description
       * 下書き保存機能は別タスクにて実装
       * https://app.clickup.com/t/908127/UT-5151
       *
       * await onSaveDraft(values)
       * setOpen(false)
       */ router.goBack(defaultBackPage);
                } catch (error) {
                    showError(error);
                }
                setArtistDraftSaving(false);
                return [
                    2
                ];
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var handleShowPreview = (0,react.useCallback)(function() {
        setOpenPreview(true);
    }, []);
    var handleCloseWithoutSave = (0,react.useCallback)(function() {
        setOpen(false);
        router.goBack(defaultBackPage);
    }, [
        router,
        defaultBackPage
    ]);
    var ref12, _user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.ArtistThreadEdit
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                navigation: {
                    type: "threadForm",
                    props: {
                        disabled: !isValid,
                        onConfirmSaveDraft: handleSaveDraft,
                        onShowPreview: handleShowPreview
                    }
                },
                header: {
                    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                        edge: "start",
                        onClick: function() {
                            /**
                 * @description
                 * 下書き保存機能は別タスクにて実装
                 * https://app.clickup.com/t/908127/UT-5151
                 *
                 * if (isDirty) {
                 *  setOpen(true)
                 *  return
                 * }
                 */ return router.goBack(defaultBackPage);
                        }
                    }),
                    title: t("title"),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        type: "submit",
                        size: "small",
                        disabled: !isValid,
                        loading: artistEditing,
                        onClick: onSubmit,
                        sx: {
                            mr: -1
                        },
                        children: t("public")
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditForm, {
                    hasPatron: !!(state === null || state === void 0 ? void 0 : (ref = state.artist) === null || ref === void 0 ? void 0 : (ref1 = ref.patron) === null || ref1 === void 0 ? void 0 : ref1.id),
                    control: control,
                    errors: errors,
                    onSubmit: onSubmit,
                    register: register,
                    thread: getValues(),
                    setValue: setValue,
                    userId: (ref12 = (ref2 = state.user) === null || ref2 === void 0 ? void 0 : ref2.id) !== null && ref12 !== void 0 ? ref12 : "",
                    categoryOptions: categoryOptions
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                title: t("draftTitle"),
                content: t("draftDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            loading: artistDraftSaving,
                            onClick: handleSaveDraft,
                            children: t("saveToDraft")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            sx: {
                                minWidth: 212
                            },
                            variant: "outlined",
                            color: "primary",
                            size: "large",
                            disabled: artistDraftSaving,
                            onClick: handleCloseWithoutSave,
                            children: t("closeWithoutSave")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
                open: openPreview,
                onClose: function() {
                    return setOpenPreview(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadCreatePreview/* ThreadCreatePreview */.d, {
                    artistId: (ref3 = state.thread) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.artist) === null || ref4 === void 0 ? void 0 : ref4.id,
                    onClose: function() {
                        return setOpenPreview(false);
                    },
                    thread: getValues(),
                    categoryOptions: categoryOptions,
                    user: (_user = state.user) !== null && _user !== void 0 ? _user : null
                })
            })
        ]
    });
};
var ActionLinkCell = function(param) {
    var onConfirmSaveDraft = param.onConfirmSaveDraft, onShowPreview = param.onShowPreview, disabled = param.disabled;
    var t = useTranslation("threadCreate").t;
    var actions = [
        {
            title: t("saveDraft"),
            onClick: onConfirmSaveDraft
        },
        {
            title: t("preview"),
            onClick: onShowPreview
        }, 
    ];
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            bgcolor: "background.default"
        },
        children: /*#__PURE__*/ _jsx(Stack, {
            direction: "row",
            spacing: 3,
            sx: {
                p: 3
            },
            children: actions.map(function(action, index) {
                /**
           * @description
           * 下書き保存機能は別タスクにて実装
           * https://app.clickup.com/t/908127/UT-5151
           */ if (action.title === t("saveDraft")) return;
                return /*#__PURE__*/ _jsx(Button, {
                    variant: "text",
                    onClick: action.onClick,
                    disabled: disabled,
                    disableElevation: true,
                    sx: {
                        bgcolor: "transparent",
                        color: "text.primary",
                        "&.Mui-disabled": {
                            bgcolor: "transparent",
                            color: "text.disabled"
                        }
                    },
                    children: action.title
                }, index);
            })
        })
    });
};
var categories = [
    utoniq_core_schema/* ArtistThreadCategory.TradeCall */.KCB.TradeCall,
    utoniq_core_schema/* ArtistThreadCategory.Event */.KCB.Event,
    utoniq_core_schema/* ArtistThreadCategory.Request */.KCB.Request,
    utoniq_core_schema/* ArtistThreadCategory.Faq */.KCB.Faq, 
];

;// CONCATENATED MODULE: ./src/components/pages/ThreadEdit/viewModel.ts







function ThreadEdit_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ThreadEdit($artistThreadChannelId: ID!, $artistId: ID) {\n    artistThreadChannel(id: $artistThreadChannelId) {\n      ...ThreadBox\n    }\n    artist(id: $artistId) {\n      id\n      displayName\n      avatar {\n        uri\n      }\n      patron {\n        id\n      }\n    }\n    user {\n      id\n      avatar {\n        uri\n      }\n      displayName\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadEdit_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ThreadEdit_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateArtistThreadChannel(\n    $updateArtistThreadChannelId: ID!\n    $inputs: UpdateArtistThreadInput!\n  ) {\n    updateArtistThreadChannel(\n      id: $updateArtistThreadChannelId\n      inputs: $inputs\n    ) {\n      ...ThreadBox\n    }\n  }\n  ",
        "\n"
    ]);
    ThreadEdit_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ThreadEdit_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var _artistId;
    var data = (0,useQuery/* useQuery */.aM)(ThreadEdit_viewModel_QUERY, {
        variables: {
            artistThreadChannelId: router.query.threadId,
            artistId: (_artistId = router.query.artistId) !== null && _artistId !== void 0 ? _artistId : config_config/* config.artistId */.v.artistId
        }
    }).data;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* CreateArtistThreadChannel */.hZp), 1), createArtistThreadChannel = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UPDATE_ARTIST_THREAD_CHANNEL), 1), updateArtistThreadChannel = ref1[0];
    var ref2, ref3, ref4;
    return {
        state: {
            thread: (ref2 = data === null || data === void 0 ? void 0 : data.artistThreadChannel) !== null && ref2 !== void 0 ? ref2 : null,
            artist: (ref3 = data === null || data === void 0 ? void 0 : data.artist) !== null && ref3 !== void 0 ? ref3 : null,
            user: (ref4 = data === null || data === void 0 ? void 0 : data.user) !== null && ref4 !== void 0 ? ref4 : null
        },
        actions: {
            onEditThread: function onEditThread(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var thumbnail, inputs, ref, name, description, category;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                thumbnail = _param.thumbnail, inputs = (0,_object_without_properties/* default */.Z)(_param, [
                                    "thumbnail"
                                ]);
                                name = inputs.name, description = inputs.description, category = inputs.category;
                                return [
                                    4,
                                    updateArtistThreadChannel({
                                        variables: {
                                            updateArtistThreadChannelId: (ref = router.query) === null || ref === void 0 ? void 0 : ref.threadId,
                                            inputs: {
                                                name: name,
                                                description: description,
                                                category: category,
                                                status: utoniq_core_schema/* ThreadStatus.Published */.SVj.Published,
                                                thumbnail: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath) ? {
                                                    tmpPath: thumbnail.tmpPath
                                                } : undefined
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onSaveDraft: function onSaveDraft(_param) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var thumbnail, inputs, ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                thumbnail = _param.thumbnail, inputs = (0,_object_without_properties/* default */.Z)(_param, [
                                    "thumbnail"
                                ]);
                                return [
                                    4,
                                    createArtistThreadChannel({
                                        variables: {
                                            inputs: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputs), {
                                                status: utoniq_core_schema/* ThreadStatus.Draft */.SVj.Draft,
                                                artistId: (ref = user === null || user === void 0 ? void 0 : user.uid) !== null && ref !== void 0 ? ref : "",
                                                thumbnail: (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.tmpPath) ? {
                                                    tmpPath: thumbnail.tmpPath
                                                } : undefined
                                            })
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var ThreadEdit_viewModel_QUERY = (0,lib/* gql */.Ps)(ThreadEdit_viewModel_templateObject(), utoniq_core_schema/* ThreadBoxFragmentDoc */.bid);
var UPDATE_ARTIST_THREAD_CHANNEL = (0,lib/* gql */.Ps)(ThreadEdit_viewModel_templateObject1(), utoniq_core_schema/* ThreadBoxFragmentDoc */.bid);

;// CONCATENATED MODULE: ./src/components/pages/ThreadEdit/index.tsx




/**
 * ThreadCreate Page
 * Implemented as a practical sample.
 */ var ThreadEdit = function() {
    var ref = ThreadEdit_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadEditTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/TicketCharge/template/index.tsx














var TicketChargeTemplate = function(param) {
    var state = param.state, onPurchaseGachaTicket = param.onPurchaseGachaTicket;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref1 = (0,react.useState)(false), openModalConfirm = ref1[0], setOpenModalConfirm = ref1[1];
    var ref2 = (0,react.useState)(false), openModalComplete = ref2[0], setOpenModalComplete = ref2[1];
    var ref3 = (0,react.useState)(false), openModalError = ref3[0], setOpenModalError = ref3[1];
    var ref4 = (0,react.useState)(null), plan = ref4[0], setPlan = ref4[1];
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var handleClickTicketCharge = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(count, prepaidPoint, price) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setPlan({
                    count: count,
                    prepaidPoint: prepaidPoint,
                    price: price
                });
                setOpenModalConfirm(true);
                return [
                    2
                ];
            });
        });
        return function(count, prepaidPoint, price) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var handlePurchaseTicket = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!plan) {
                setOpenModalConfirm(false);
                return [
                    2
                ];
            }
            onPurchaseGachaTicket(plan.count, plan.prepaidPoint).then(function() {
                setOpenModalConfirm(false);
                setOpenModalComplete(true);
            }).catch(function(e) {
                setOpenModalConfirm(false);
                if (e.message === "Insufficient Prepaid Point balance.") {
                    return setOpenModalError(true);
                }
                if ((0,_instanceof/* default */.Z)(e, Error)) showError(e);
            });
            return [
                2
            ];
        });
    }), [
        plan,
        onPurchaseGachaTicket,
        showError
    ]);
    var _prepaidPoints, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        margin: true,
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.GachaTicketPurchase
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDisplayCell, {
                ticket: state.ticket,
                gachaTicket: state.gachaTicket
            }),
            (ref = state.purchasableGachaTickets) === null || ref === void 0 ? void 0 : ref.map(function(gachaTicket, index) {
                return gachaTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TicketChargeButtonCell, {
                    ticket: gachaTicket.displayCount,
                    price: gachaTicket.formattedPrice || "0",
                    point: gachaTicket.formattedPrepaidPoint || "0",
                    gachaTicket: state.gachaTicket,
                    onClick: function() {
                        return handleClickTicketCharge(gachaTicket.count, (_prepaidPoints = gachaTicket.prepaidPoints) !== null && _prepaidPoints !== void 0 ? _prepaidPoints : 0, gachaTicket.formattedPrice || "0");
                    }
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_TextLinkCell, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ConfirmTicketChargeModal, {
                loading: state.gachaTicketByPointPurchasing || state.gachaTicketByPointInBulkPurchasing,
                open: openModalConfirm,
                onClose: function() {
                    return setOpenModalConfirm(false);
                },
                count: (ref5 = plan === null || plan === void 0 ? void 0 : plan.count) !== null && ref5 !== void 0 ? ref5 : 0,
                price: (ref6 = plan === null || plan === void 0 ? void 0 : plan.price) !== null && ref6 !== void 0 ? ref6 : 0,
                onConfirm: handlePurchaseTicket
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CompleteTicketChargeModal, {
                open: openModalComplete,
                onClose: function() {
                    return setOpenModalComplete(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ErrorTicketChargeModal, {
                open: openModalError,
                onClose: function() {
                    return setOpenModalError(false);
                }
            })
        ]
    });
};
var TicketDisplayCell = function(param) {
    var ticket = param.ticket, gachaTicket = param.gachaTicket;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 2
        },
        alignContent: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                align: "center",
                sx: {
                    pb: 1
                },
                children: t("gachaTicket")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                ticket: ticket !== null && ticket !== void 0 ? ticket : "",
                src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || "",
                variant: "h1"
            })
        ]
    });
};
var template_TicketChargeButtonCell = function(param) {
    var ticket = param.ticket, point = param.point, onClick = param.onClick, gachaTicket = param.gachaTicket;
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            sx: {
                borderRadius: 2
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                onClick: onClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: {
                        height: 56,
                        mr: 3,
                        ml: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDisplay, {
                                ticket: ticket,
                                src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || "",
                                sx: {
                                    bgcolor: "transparent"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.PointDisplay, {
                            point: point
                        })
                    ]
                })
            })
        })
    });
};
var template_TextLinkCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
            elevation: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                sx: {
                    p: 4,
                    "&:last-child": {
                        pb: 4
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 2,
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            color: "text.secondary",
                            children: t("cancelPurchaseNote")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            spacing: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                                    variant: "subtitle1",
                                    href: (0,helpUrl/* getHelpUrl */.R)("wageSettlementMethod"),
                                    children: t("wageSettlementMethod")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserLink/* BrowserLink */.V, {
                                    variant: "subtitle1",
                                    href: (0,helpUrl/* getHelpUrl */.R)("specifiedCommercialTransactionLaw"),
                                    children: t("specifiedCommercialTransactionLaw")
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var template_ConfirmTicketChargeModal = function(param) {
    var loading = param.loading, open = param.open, count = param.count, price = param.price, onClose = param.onClose, onConfirm = param.onConfirm;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("purchaseConfirmTitle"),
        content: t("purchaseConfirmDesc", {
            count: count,
            price: price
        }),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onConfirm,
            loading: loading,
            children: t("toBuy")
        })
    });
};
var template_CompleteTicketChargeModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("purchaseCompleteTitle"),
        content: t("purchaseCompleteDesc"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            onClick: onClose,
            children: t("ok")
        })
    });
};
var template_ErrorTicketChargeModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketCharge").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("purchaseErrorTitle"),
        content: t("purchaseErrorDesc"),
        cancelText: t("cancel"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            sx: {
                minWidth: 212
            },
            variant: "contained",
            color: "primary",
            size: "large",
            href: routerPages.PrepaidPointCharge,
            children: t("buyPoints")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketCharge/viewModel.ts




function TicketCharge_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TicketCharge(\n    $inputs: PurchasableGachaTicketInput\n    $gachaTicketId: ID!\n  ) {\n    user {\n      id\n      gachaTicket(id: $gachaTicketId) {\n        ...UserGachaTicketConnection\n      }\n    }\n    purchasableGachaTickets(inputs: $inputs) {\n      price\n      displayCount\n      count\n      prepaidPoints\n      formattedPrice @client\n      formattedPrepaidPoint @client\n    }\n    gachaTicket(id: $gachaTicketId) {\n      ...GachaTicketConnection\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    TicketCharge_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TicketCharge_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1;
    var data = (0,useQuery/* useQuery */.aM)(TicketCharge_viewModel_QUERY, {
        variables: {
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
        }
    }).data;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* PurchaseGachaTicketByPoint */.ojn), 2), purchaseGachaTicketByPoint = ref2[0], ref3 = ref2[1], gachaTicketByPointPurchasing = ref3.loading;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* PurchaseGachaTicketByPointInBulk */.vNH), 2), purchaseGachaTicketByPointInBulk = ref4[0], ref5 = ref4[1], gachaTicketByPointInBulkPurchasing = ref5.loading;
    var ref6, ref7, ref8;
    return {
        state: {
            gachaTicketByPointPurchasing: gachaTicketByPointPurchasing,
            gachaTicketByPointInBulkPurchasing: gachaTicketByPointInBulkPurchasing,
            purchasableGachaTickets: (ref6 = data === null || data === void 0 ? void 0 : data.purchasableGachaTickets) !== null && ref6 !== void 0 ? ref6 : null,
            ticket: (ref7 = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.gachaTicket) === null || ref1 === void 0 ? void 0 : ref1.available) !== null && ref7 !== void 0 ? ref7 : null,
            gachaTicket: (ref8 = data === null || data === void 0 ? void 0 : data.gachaTicket) !== null && ref8 !== void 0 ? ref8 : null
        },
        actions: {
            onPurchaseGachaTicket: function onPurchaseGachaTicket(count, prepaidPoints) {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(count === 1)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    purchaseGachaTicketByPoint({
                                        variables: {
                                            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                            inputs: {
                                                count: count,
                                                point: prepaidPoints !== null && prepaidPoints !== void 0 ? prepaidPoints : 0
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    purchaseGachaTicketByPointInBulk({
                                        variables: {
                                            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId),
                                            inputs: {
                                                point: prepaidPoints !== null && prepaidPoints !== void 0 ? prepaidPoints : 0
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var TicketCharge_viewModel_QUERY = (0,lib/* default */.ZP)(TicketCharge_viewModel_templateObject(), utoniq_core_schema/* UserGachaTicketConnectionFragmentDoc */.XFl, utoniq_core_schema/* GachaTicketConnectionFragmentDoc */.mCK);

;// CONCATENATED MODULE: ./src/components/pages/TicketCharge/index.tsx



/**
 * TicketCharge Page
 * Implemented as a practical sample.
 */ var TicketCharge = function() {
    var ref = TicketCharge_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketChargeTemplate, {
        state: state,
        onPurchaseGachaTicket: actions.onPurchaseGachaTicket
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ticketHistory/TicketHistoryItem/index.tsx




var TicketHistoryItem = function(param) {
    var _gachaTicketOrder = param.gachaTicketOrder, formattedCreatedAt = _gachaTicketOrder.formattedCreatedAt, count = _gachaTicketOrder.count, title = _gachaTicketOrder.title;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketOrders").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                disableTouchRipple: true,
                component: Box_Box/* default */.Z,
                sx: {
                    px: 5,
                    py: 4,
                    height: "auto",
                    cursor: "initial",
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                },
                title: t("".concat(title)),
                subTitle: formattedCreatedAt,
                primaryTypographyProps: {
                    variant: "h6"
                },
                secondaryTypographyProps: {
                    variant: "overline",
                    color: "text.hint"
                },
                secondaryAction: count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                    variant: "h5",
                    color: "primary.main",
                    children: "+" + count
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                    variant: "h5",
                    color: "text.secondary",
                    children: count
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {
                sx: {
                    width: "calc(100% - 40px)",
                    ml: 6
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketOrders/template/index.tsx







var TicketOrdersTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketOrders").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, routerPages = ref1.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            defaultBackPage: routerPages.Wallet,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.TicketOrders
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                nodes: (ref = state.gachaTicketOrders) === null || ref === void 0 ? void 0 : ref.edges.map(function(gachaTicket) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketHistoryItem, {
                        gachaTicketOrder: gachaTicket.node
                    }, gachaTicket.node.id);
                }),
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                component: List_List/* default */.Z,
                onFetchMore: onFetchMore
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketOrders/viewModel.ts



function TicketOrders_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TicketOrders($pageInput: PageInput) {\n    gachaTicketOrders(pageInput: $pageInput) {\n      ...GachaTicketOrdersConnection\n    }\n  }\n  ",
        "\n"
    ]);
    TicketOrders_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 *
 */ var TicketOrders_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref;
    var ref1 = (0,useQuery/* useQuery */.aM)(TicketOrders_viewModel_QUERY), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var ref2;
    return {
        state: {
            loading: loading,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.gachaTicketOrders) === null || ref === void 0 ? void 0 : ref.pageInfo.hasNextPage),
            gachaTicketOrders: (ref2 = data === null || data === void 0 ? void 0 : data.gachaTicketOrders) !== null && ref2 !== void 0 ? ref2 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.gachaTicketOrders) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var TicketOrders_viewModel_QUERY = (0,lib/* gql */.Ps)(TicketOrders_viewModel_templateObject(), utoniq_core_schema/* GachaTicketOrdersConnectionFragmentDoc */.gc5);

;// CONCATENATED MODULE: ./src/components/pages/TicketOrders/index.tsx



/**
 * ticketHistory Page
 * Implemented as a practical sample.
 */ var TicketOrders = function() {
    var ref = TicketOrders_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketOrdersTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareConfirm/template/index.tsx













var TicketShareConfirmTemplate = function(param) {
    var state = param.state, onReceive = param.onReceive;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareConfirm").t;
    var ref3 = (0,router_useRouter/* useRouter */.tv)(), router = ref3.router, generatePath = ref3.generatePath, routerPages = ref3.routerPages, routerNames = ref3.routerNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref = state.data) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.issuedArtist) === null || ref2 === void 0 ? void 0 : ref2.id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            header: {
                back: false,
                title: t("title"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "start",
                    onClick: function() {
                        return router.replace(generatePath(routerPages.GlobalHome));
                    }
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.TicketShareConfirm
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareConfirmSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareConfirmCell, {
                    loading: state.receiving,
                    data: state.data,
                    ticketNumber: state.ticketNumber,
                    formattedExpiredAt: state.formattedExpiredAt,
                    invalidTicketDistribution: state.invalidTicketDistribution,
                    onReceive: onReceive
                })
            ]
        })
    });
};
var TicketShareConfirmCell = function(param) {
    var loading = param.loading, invalidTicketDistribution = param.invalidTicketDistribution, data = param.data, ticketNumber = param.ticketNumber, onReceive = param.onReceive;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareConfirm").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    if (!data || (data === null || data === void 0 ? void 0 : data.userId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
            sx: {
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    py: 5,
                    children: t("checkTicketDetails")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareConfirmNoticeCell, {
                    data: data
                })
            ]
        });
    }
    var ref18, _seat;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h4",
                py: 5,
                children: t("checkTicketDetails")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareConfirmNoticeCell, {
                data: data
            }),
            (data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.preSale) === null || ref1 === void 0 ? void 0 : ref1.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 1,
                        sx: {
                            py: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: "text.secondary",
                                children: t("preSale")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: data === null || data === void 0 ? void 0 : (ref2 = data.item) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.preSale) === null || ref3 === void 0 ? void 0 : ref3.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: t("ticketInformation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: data === null || data === void 0 ? void 0 : (ref4 = data.item) === null || ref4 === void 0 ? void 0 : ref4.title
                            }),
                            !!(data === null || data === void 0 ? void 0 : (ref5 = data.serial) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sku) === null || ref6 === void 0 ? void 0 : ref6.unitName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "body2",
                                children: data === null || data === void 0 ? void 0 : (ref7 = data.serial) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sku) === null || ref8 === void 0 ? void 0 : ref8.unitName
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketLabel, {
                        serial: data === null || data === void 0 ? void 0 : data.serial,
                        assignedNumberType: data === null || data === void 0 ? void 0 : (ref9 = data.item) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.metadata) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.ticket) === null || ref11 === void 0 ? void 0 : ref11.assignedNumberType,
                        typographyProps: {
                            variant: "subtitle1",
                            color: "text.secondary"
                        }
                    }),
                    data === null || data === void 0 ? void 0 : (ref12 = data.serial) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.ticketStatus) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.throughTicket) === null || ref14 === void 0 ? void 0 : ref14.map(function(throughTicket, index) {
                        var ref, ref1, ref2;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            spacing: 1,
                            pb: ((ref18 = data === null || data === void 0 ? void 0 : (ref = data.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketStatus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.throughTicket) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref18 !== void 0 ? ref18 : 0) > index + 1 ? 1 : 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    color: "text.secondary",
                                    children: throughTicket.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    variant: "body2",
                                    children: (_seat = throughTicket.seat) !== null && _seat !== void 0 ? _seat : ticketNumber
                                })
                            ]
                        }, index);
                    }),
                    !(data === null || data === void 0 ? void 0 : (ref15 = data.serial) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.ticketStatus) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.throughTicket) === null || ref17 === void 0 ? void 0 : ref17.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "body2",
                        children: ticketNumber
                    })
                ]
            }),
            !invalidTicketDistribution && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 4
                },
                spacing: 3,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    loading: loading,
                    sx: {
                        width: 244
                    },
                    onClick: handleLoginModal(onReceive),
                    children: t("receiveTicket")
                })
            })
        ]
    });
};
var TicketShareConfirmNoticeCell = function(param) {
    var data = param.data;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareConfirm").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ticketDistribution")).onClick;
    if (!data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            sx: {
                p: 3,
                borderColor: "error.main",
                borderWidth: 1,
                borderStyle: "solid"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            fontSize: "small",
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: t("urlInvalid", "受け取りができません")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("urlInvalidNote3", "このチケットは分配URLが無効のため受け取りできません。")
                })
            ]
        });
    }
    if (data === null || data === void 0 ? void 0 : data.userId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            sx: {
                p: 3,
                borderColor: "error.main",
                borderWidth: 1,
                borderStyle: "solid"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            fontSize: "small",
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: t("urlInvalid", "受け取りができません")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("urlInvalidNote4", "このチケットはすでに受け取られています。")
                })
            ]
        });
    }
    if (data === null || data === void 0 ? void 0 : data.isExpired) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            sx: {
                p: 3,
                borderColor: "error.main",
                borderWidth: 1,
                borderStyle: "solid"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            fontSize: "small",
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: t("urlInvalid", "受け取りができません")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                        i18nKey: "urlInvalidNote2",
                        t: t,
                        components: {
                            linkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                component: "span",
                                variant: "caption",
                                color: "primary",
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: onClick
                            })
                        }
                    })
                })
            ]
        });
    }
    if (data === null || data === void 0 ? void 0 : data.item.ownedCount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            sx: {
                p: 3,
                borderColor: "error.main",
                borderWidth: 1,
                borderStyle: "solid"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            fontSize: "small",
                            sx: {
                                color: "error.main"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: t("urlInvalid", "受け取りができません")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("urlInvalidNote1")
                })
            ]
        });
    }
    if (data === null || data === void 0 ? void 0 : data.formattedExpiredAt) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "caption",
            align: "center",
            color: "error.main",
            component: "p",
            p: 2,
            sx: {
                width: "100%",
                borderColor: "error.main",
                borderWidth: 1,
                borderStyle: "solid"
            },
            children: t("receiptExpirationDate", {
                expiredAt: data.formattedExpiredAt
            })
        });
    }
    return null;
};
var TicketShareConfirmSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 6
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: "20px",
                    width: "50%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    py: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: "15px",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "45%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    py: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: "15px",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "45%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 3,
                sx: {
                    py: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "rectangular",
                        height: "15px",
                        width: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        width: "45%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 6,
                    width: "100%"
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: "44px",
                    width: "50%",
                    sx: {
                        borderRadius: "34px"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareConfirm/viewModel.ts




function TicketShareConfirm_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TicketDistributionLink($token: String!) {\n    ticketDistributionLink(token: $token) {\n      ...TicketShareConfirm\n    }\n  }\n  ",
        "\n"
    ]);
    TicketShareConfirm_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TicketShareConfirm_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ReceiveTicketDistribution($inputs: ReceiveTicketDistributionInput!) {\n    receiveTicketDistribution(inputs: $inputs) {\n      id\n      distributionId\n    }\n  }\n"
    ]);
    TicketShareConfirm_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 *
 */ var TicketShareConfirm_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref5.showError, showMessage = ref5.showMessage;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareConfirm").t;
    var ref6 = (0,router_useRouter/* useRouter */.tv)(), router = ref6.router, generatePath = ref6.generatePath, routerPages = ref6.routerPages;
    var ref7 = (0,useQuery/* useQuery */.aM)(TicketShareConfirm_viewModel_QUERY, {
        variables: {
            token: router.query.token
        }
    }), data = ref7.data, loading = ref7.loading;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(RECEIVE_TICKET_DISTRIBUTION), 2), receiveTicketDistribution = ref8[0], ref9 = ref8[1], receiving = ref9.loading;
    var invalidTicketDistribution = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return !!(data === null || data === void 0 ? void 0 : (ref = data.ticketDistributionLink) === null || ref === void 0 ? void 0 : ref.isExpired) || !!(data === null || data === void 0 ? void 0 : (ref1 = data.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.userId) || !!(data === null || data === void 0 ? void 0 : (ref2 = data.ticketDistributionLink) === null || ref2 === void 0 ? void 0 : ref2.item.ownedCount);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.ticketDistributionLink) === null || ref === void 0 ? void 0 : ref.isExpired,
        data === null || data === void 0 ? void 0 : (ref1 = data.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.userId,
        data === null || data === void 0 ? void 0 : (ref2 = data.ticketDistributionLink) === null || ref2 === void 0 ? void 0 : ref2.item.ownedCount, 
    ]);
    var ticketNumber = (0,react.useMemo)(function() {
        var ref;
        return getSerialFormatNumber(data === null || data === void 0 ? void 0 : (ref = data.ticketDistributionLink) === null || ref === void 0 ? void 0 : ref.serial);
    }, [
        data === null || data === void 0 ? void 0 : (ref3 = data.ticketDistributionLink) === null || ref3 === void 0 ? void 0 : ref3.serial
    ]);
    var ref10, ref11;
    return {
        state: {
            loading: loading,
            receiving: receiving,
            data: (ref10 = data === null || data === void 0 ? void 0 : data.ticketDistributionLink) !== null && ref10 !== void 0 ? ref10 : null,
            formattedExpiredAt: (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.ticketDistributionLink) === null || ref4 === void 0 ? void 0 : ref4.formattedExpiredAt) !== null && ref11 !== void 0 ? ref11 : null,
            invalidTicketDistribution: invalidTicketDistribution,
            ticketNumber: ticketNumber
        },
        actions: {
            onReceive: function onReceive() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    receiveTicketDistribution({
                                        variables: {
                                            inputs: {
                                                token: router.query.token
                                            }
                                        }
                                    }).then(function() {
                                        var ref, ref1, ref2, ref3, ref4;
                                        router.replace({
                                            pathname: generatePath(routerPages.OwnedItemDetail, {
                                                itemId: data === null || data === void 0 ? void 0 : (ref = data.ticketDistributionLink) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.id
                                            }),
                                            search: (data === null || data === void 0 ? void 0 : (ref2 = data.ticketDistributionLink) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.serial) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sku) === null || ref4 === void 0 ? void 0 : ref4.id) ? "?skuId=".concat(encodeSkuId(data.ticketDistributionLink.serial.sku.id)) : ""
                                        });
                                        showMessage(t("receivedTicketSuccess"));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var TicketShareConfirm_viewModel_QUERY = (0,lib/* gql */.Ps)(TicketShareConfirm_viewModel_templateObject(), utoniq_core_schema/* TicketShareConfirmFragmentDoc */.XUR);
var RECEIVE_TICKET_DISTRIBUTION = (0,lib/* gql */.Ps)(TicketShareConfirm_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/TicketShareConfirm/index.tsx




/**
 * TicketShareConfirm Page
 * Implemented as a practical sample.
 */ var TicketShareConfirm = function() {
    var ref = TicketShareConfirm_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareConfirmTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareCopy/template/index.tsx
















var TicketShareCopyTemplate = function(param) {
    var state = param.state, onRegenerateTicketDistribution = param.onRegenerateTicketDistribution, onCancelTicketDistribution = param.onCancelTicketDistribution;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareCopy").t;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref1.routerNames, router = ref1.router;
    var ticketNumber = (0,react.useMemo)(function() {
        var ref;
        return getSerialFormatNumber((ref = state.serial) === null || ref === void 0 ? void 0 : ref.serial, state.throughTicketIndex);
    }, [
        (ref = state.serial) === null || ref === void 0 ? void 0 : ref.serial,
        state.throughTicketIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            header: {
                title: t("title"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "end",
                    onClick: function() {
                        return router.goBack();
                    }
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.TicketShareCopy
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopySkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopyContentCell, {
                    regenerating: state.regenerating,
                    regenerated: state.regenerated,
                    isFirstGenerate: state.isFirstGenerate,
                    canceling: state.canceling,
                    serial: state.serial,
                    ticketNumber: ticketNumber,
                    onCancelTicketDistribution: onCancelTicketDistribution,
                    onRegenerateTicketDistribution: onRegenerateTicketDistribution
                })
            ]
        })
    });
};
var TicketShareCopyContentCell = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    if (!((ref = props.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.serial) === null || ref1 === void 0 ? void 0 : ref1.ticketDistributionLink)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopyCancelCell, (0,src_object_spread/* default */.Z)({}, props));
    }
    if ((ref2 = props.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.serial) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ticketDistributionLink) === null || ref4 === void 0 ? void 0 : ref4.user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopyUserCancelCell, (0,src_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopyCell, (0,src_object_spread/* default */.Z)({}, props));
};
var TicketShareCopyCell = function(param) {
    var canceling = param.canceling, regenerating = param.regenerating, regenerated = param.regenerated, isFirstGenerate = param.isFirstGenerate, serial = param.serial, ticketNumber = param.ticketNumber, onRegenerateTicketDistribution = param.onRegenerateTicketDistribution, onCancelTicketDistribution = param.onCancelTicketDistribution;
    var ref, ref1, ref2, ref3;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareCopy").t;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,usehooks_ts_esm/* useCopyToClipboard */.m9)(), 2), _ = ref4[0], copy = ref4[1];
    var showMessage = (0,messages_useMessage/* useMessage */.UD)().showMessage;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var ref5 = (0,react.useState)(false), openReissue = ref5[0], setOpenReissue = ref5[1];
    var ref6 = (0,react.useState)(false), openCancelConfirm = ref6[0], setOpenCancelConfirm = ref6[1];
    var link = (0,react.useMemo)(function() {
        var ref, ref1;
        var token = serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.token;
        if (!token) {
            return "";
        }
        return (0,lib_url/* generateFullPath */.QP)(routerPages.TicketShareConfirm, {
            token: token
        });
    }, [
        routerPages.TicketShareConfirm,
        serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.token, 
    ]);
    var formattedExpiredAt = (0,react.useMemo)(function() {
        var ref, ref1;
        return serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.formattedExpiredAt;
    }, [
        serial === null || serial === void 0 ? void 0 : (ref2 = serial.serial) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketDistributionLink) === null || ref3 === void 0 ? void 0 : ref3.formattedExpiredAt
    ]);
    var handleCopy = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            copy(t("note", {
                                link: link,
                                expired: formattedExpiredAt
                            }))
                        ];
                    case 1:
                        _state.sent();
                        showMessage(t("copyURLSuccess"));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCopy() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReissueUrl = function() {
        onRegenerateTicketDistribution().finally(function() {
            setOpenReissue(false);
        });
    };
    var handleCancelDistribution = function() {
        onCancelTicketDistribution().finally(function() {
            setOpenCancelConfirm(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                pb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        children: t("distribute", "分配中")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: ticketNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    children: t(regenerated ? "descriptionRegenerated" : isFirstGenerate ? "descriptionFirstGenerate" : "description")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2,
                    mt: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 4,
                        "&:last-child": {
                            pb: 4
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        component: "p",
                        children: t("note", {
                            link: link,
                            expired: formattedExpiredAt
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    mt: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("notes")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 4
                },
                spacing: 3,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        size: "large",
                        sx: {
                            width: 244
                        },
                        onClick: handleCopy,
                        children: t("makeCopy")
                    }),
                    !isFirstGenerate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                variant: "outlined",
                                sx: {
                                    width: 244
                                },
                                onClick: function() {
                                    return setOpenReissue(true);
                                },
                                children: t("reissue")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                size: "large",
                                variant: "text",
                                sx: {
                                    width: 244
                                },
                                onClick: function() {
                                    return setOpenCancelConfirm(true);
                                },
                                children: t("cancelDistribution")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openReissue,
                onClose: function() {
                    return setOpenReissue(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        pb: 3
                    },
                    children: t("reissueTitle")
                }),
                content: "",
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    loading: regenerating,
                    size: "large",
                    fullWidth: true,
                    onClick: handleReissueUrl,
                    children: t("OK")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openCancelConfirm,
                onClose: function() {
                    return setOpenCancelConfirm(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        pb: 3
                    },
                    children: t("cancelConfirmTitle")
                }),
                content: "",
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    loading: canceling,
                    size: "large",
                    fullWidth: true,
                    onClick: handleCancelDistribution,
                    children: t("OK")
                })
            })
        ]
    });
};
var TicketShareCopySkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            p: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            width: "50%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 2,
                    mt: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        p: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "45%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "100%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "45%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "100%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "45%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                        variant: "body2",
                                        width: "100%"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2",
                width: "50%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2",
                width: "45%",
                sx: {
                    mt: 4
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                variant: "body2",
                width: "100%",
                sx: {
                    mt: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    py: 6,
                    width: "100%"
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: "44px",
                    width: "50%",
                    sx: {
                        borderRadius: "34px"
                    }
                })
            })
        ]
    });
};
var TicketShareCopyCancelCell = function(param) {
    var ticketNumber = param.ticketNumber;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareCopy").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), router = ref.router, generatePath = ref.generatePath, routerPages = ref.routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "overline",
                        color: "text.secondary",
                        children: t("cancelDistribute", "分配キャンセル")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: ticketNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 4
                },
                spacing: 3,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    variant: "text",
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return router.replace(generatePath(routerPages.TicketShareSelect, {
                            itemId: router.query.itemId,
                            serialId: router.query.serialId
                        }));
                    },
                    children: t("redoDistribute", "分配をやり直す")
                })
            })
        ]
    });
};
var TicketShareCopyUserCancelCell = function(param) {
    var serial = param.serial, canceling = param.canceling, ticketNumber = param.ticketNumber, onCancelTicketDistribution = param.onCancelTicketDistribution;
    var ref, ref1, ref2;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareCopy").t;
    var ref3 = (0,react.useState)(false), openCancelConfirm = ref3[0], setOpenCancelConfirm = ref3[1];
    var user = serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.user;
    var handleCancelDistribution = function() {
        onCancelTicketDistribution().finally(function() {
            setOpenCancelConfirm(false);
        });
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                src: (ref4 = user === null || user === void 0 ? void 0 : (ref2 = user.avatar) === null || ref2 === void 0 ? void 0 : ref2.smallUri) !== null && ref4 !== void 0 ? ref4 : "",
                                sx: {
                                    width: 16,
                                    height: 16
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "overline",
                                color: "text.secondary",
                                children: t("distributedToUser", {
                                    name: user === null || user === void 0 ? void 0 : user.displayName
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: ticketNumber
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    p: 4
                },
                spacing: 3,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    variant: "text",
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return setOpenCancelConfirm(true);
                    },
                    children: t("cancelDistribution", "分配をキャンセルする")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openCancelConfirm,
                onClose: function() {
                    return setOpenCancelConfirm(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        pb: 3
                    },
                    children: t("cancelConfirmTitle")
                }),
                content: "",
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    loading: canceling,
                    size: "large",
                    fullWidth: true,
                    onClick: handleCancelDistribution,
                    children: t("OK")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareCopy/viewModel.ts




function TicketShareCopy_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TicketShareCopy($id: ID!) {\n    portfolio(id: $id) {\n      serials {\n        ...TicketShareCopyUserItemSerial\n      }\n      item {\n        issuedArtist {\n          id\n        }\n        metadata {\n          ticket {\n            isThroughTicket\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    TicketShareCopy_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TicketShareCopy_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation regenerateTicketDistributionLink(\n    $inputs: RegenerateTicketDistributionLinkInput!\n  ) {\n    regenerateTicketDistributionLink(inputs: $inputs) {\n      id\n      distributionId\n      expiredAt\n      formattedExpiredAt @client\n      token\n    }\n  }\n"
    ]);
    TicketShareCopy_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TicketShareCopy_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation cancelTicketDistribution($inputs: CancelTicketDistributionInput!) {\n    cancelTicketDistribution(inputs: $inputs) {\n      id\n      distributionId\n      expiredAt\n      formattedExpiredAt @client\n      token\n      serialId\n    }\n  }\n"
    ]);
    TicketShareCopy_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







/**
 *
 */ var TicketShareCopy_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareCopy").t;
    var ref6 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref6.showError, showMessage = ref6.showMessage;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref7 = (0,react.useState)(false), regenerated = ref7[0], setRegenerated = ref7[1];
    var ref8 = (0,useQuery/* useQuery */.aM)(TicketShareCopy_viewModel_QUERY, {
        variables: {
            id: router.query.itemId
        }
    }), data = ref8.data, loading = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CANCEL_TICKET_DISTRIBUTION), 2), cancelTicketDistribution = ref9[0], ref10 = ref9[1], canceling = ref10.loading;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(REGENERATE_TICKET_DISTRIBUTION_LINK), 2), regenerateTicketDistributionLink = ref11[0], ref12 = ref11[1], regenerating = ref12.loading;
    var ref13;
    var serial = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref13 = data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.find(function(serial) {
            var ref;
            return (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : ref.id) === router.query.serialId;
        })) !== null && ref13 !== void 0 ? ref13 : null;
    }, [
        data === null || data === void 0 ? void 0 : data.portfolio,
        router.query.serialId
    ]);
    var ref14;
    return {
        state: {
            loading: useInitialLoading(data, loading),
            canceling: canceling,
            regenerating: regenerating,
            serial: serial,
            isFirstGenerate: router.query.isFirstGenerate === "true",
            regenerated: regenerated,
            throughTicketIndex: ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : ref.item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) ? router.query.throughTicketIndex : undefined,
            artistId: (ref14 = data === null || data === void 0 ? void 0 : (ref3 = data.portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.issuedArtist) === null || ref5 === void 0 ? void 0 : ref5.id) !== null && ref14 !== void 0 ? ref14 : ""
        },
        actions: {
            onRegenerateTicketDistribution: function onRegenerateTicketDistribution() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    regenerateTicketDistributionLink({
                                        variables: {
                                            inputs: {
                                                token: (ref2 = serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.token) !== null && ref2 !== void 0 ? ref2 : ""
                                            }
                                        }
                                    }).then(function() {
                                        showMessage(t("regenerateURLSuccess"), "success");
                                        setRegenerated(true);
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onCancelTicketDistribution: function onCancelTicketDistribution() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    cancelTicketDistribution({
                                        variables: {
                                            inputs: {
                                                token: (ref2 = serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.token) !== null && ref2 !== void 0 ? ref2 : ""
                                            }
                                        }
                                    }).then(function() {
                                        return showMessage(t("canceledDistributionSuccess"), "success");
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var TicketShareCopy_viewModel_QUERY = (0,lib/* gql */.Ps)(TicketShareCopy_viewModel_templateObject(), utoniq_core_schema/* TicketShareCopyUserItemSerialFragmentDoc */.Q$W);
var REGENERATE_TICKET_DISTRIBUTION_LINK = (0,lib/* gql */.Ps)(TicketShareCopy_viewModel_templateObject1());
var CANCEL_TICKET_DISTRIBUTION = (0,lib/* gql */.Ps)(TicketShareCopy_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/TicketShareCopy/index.tsx





/**
 * TicketShareCopy Page
 * Implemented as a practical sample.
 */ var TicketShareCopy = function() {
    var ref = TicketShareCopy_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (!state.loading && !state.serial) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareCopyTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareSelect/template/index.tsx













var TicketShareSelectTemplate = function(param) {
    var state = param.state, onGenerateTicketDistribution = param.onGenerateTicketDistribution, onRegenerateTicketDistribution = param.onRegenerateTicketDistribution;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareSelect").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, router = ref.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: state.artistId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title", "チケットの分配"),
                right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    edge: "end",
                    onClick: function() {
                        return router.goBack();
                    }
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                    title: routerNames.TicketShareSelect
                }),
                state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareSelectSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareSelectCell, {
                    serial: state.serial,
                    assignedNumberType: state.assignedNumberType,
                    generating: state.generating,
                    throughTicketIndex: state.throughTicketIndex,
                    regenerating: state.regenerating,
                    onGenerateTicketDistribution: onGenerateTicketDistribution,
                    onRegenerateTicketDistribution: onRegenerateTicketDistribution
                })
            ]
        })
    });
};
var TicketShareSelectCell = function(param) {
    var generating = param.generating, regenerating = param.regenerating, throughTicketIndex = param.throughTicketIndex, serial = param.serial, assignedNumberType = param.assignedNumberType, onGenerateTicketDistribution = param.onGenerateTicketDistribution, onRegenerateTicketDistribution = param.onRegenerateTicketDistribution;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("ticketShareSelect").t;
    var ref2 = (0,react.useState)(false), openRegenerate = ref2[0], setOpenRegenerate = ref2[1];
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ticketDistribution")).onClick;
    var isExpired = !!(serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.isExpired);
    var ticketNumber = (0,react.useMemo)(function() {
        return getSerialFormatNumber(serial === null || serial === void 0 ? void 0 : serial.serial, throughTicketIndex);
    }, [
        serial === null || serial === void 0 ? void 0 : serial.serial,
        throughTicketIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: [
            isExpired ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    p: 3,
                    borderColor: "error.main",
                    borderWidth: 1,
                    borderStyle: "solid"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                                fontSize: "small",
                                sx: {
                                    color: "error.main"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t("expiredTitle", "分配URL有効期限切れ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Trans */.cC, {
                            i18nKey: "expiredNote",
                            t: t,
                            components: {
                                linkTag: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    component: "span",
                                    variant: "caption",
                                    color: "primary",
                                    sx: {
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setOpenRegenerate(true);
                                    }
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "caption",
                        color: "primary.main",
                        sx: {
                            cursor: "pointer"
                        },
                        onClick: onClick,
                        children: t("getHelp", "ヘルプを見る")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body2",
                children: t("description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                pt: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketLabel, {
                        serial: serial === null || serial === void 0 ? void 0 : serial.serial,
                        assignedNumberType: assignedNumberType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                        elevation: 0,
                        sx: {
                            borderRadius: "6px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                            sx: {
                                p: 3,
                                "&:last-child": {
                                    pb: 3
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: ticketNumber
                            })
                        })
                    })
                ]
            }),
            !isExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "caption",
                component: "p",
                pt: 3,
                children: t("note")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                pt: 5,
                alignItems: "center",
                children: isExpired ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    variant: "outlined",
                    loading: generating,
                    sx: {
                        width: 244
                    },
                    onClick: function() {
                        return setOpenRegenerate(true);
                    },
                    children: t("reissueDistribution")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    size: "large",
                    loading: generating,
                    sx: {
                        width: 244
                    },
                    onClick: onGenerateTicketDistribution,
                    children: t("issueDistribution")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openRegenerate,
                onClose: function() {
                    return setOpenRegenerate(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    sx: {
                        pb: 3
                    },
                    children: t("reissueTitle")
                }),
                content: "",
                cancelText: t("close"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    loading: regenerating,
                    size: "large",
                    fullWidth: true,
                    onClick: onRegenerateTicketDistribution,
                    children: t("reissueConfirm")
                })
            })
        ]
    });
};
var TicketShareSelectSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "body2",
                            width: "50%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                elevation: 0,
                sx: {
                    borderRadius: 0,
                    mt: 5,
                    bgcolor: "grey.50"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                    sx: {
                        px: 2,
                        py: 3,
                        "&:last-child": {
                            pb: 3
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                                variant: "body2",
                                width: "50%"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 1,
                mt: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "body2",
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                mt: 5,
                p: 2,
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    height: 44,
                    width: 244,
                    sx: {
                        borderRadius: "34px"
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/TicketShareSelect/viewModel.ts




function TicketShareSelect_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TicketShareSelect($id: ID!) {\n    portfolio(id: $id) {\n      item {\n        metadata {\n          ticket {\n            assignedNumberType\n            isThroughTicket\n          }\n        }\n        issuedArtist {\n          id\n        }\n      }\n      serials {\n        ...TicketShareSelectUserItemSerial\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    TicketShareSelect_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TicketShareSelect_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GenerateTicketDistributionLink(\n    $inputs: GenerateTicketDistributionLinkInput!\n  ) {\n    generateTicketDistributionLink(inputs: $inputs) {\n      id\n    }\n  }\n"
    ]);
    TicketShareSelect_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 *
 */ var TicketShareSelect_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,router_useRouter/* useRouter */.tv)(), router = ref10.router, generateQueryPath = ref10.generateQueryPath, routerPages = ref10.routerPages;
    var showError = (0,messages_useMessage/* useMessage */.UD)().showError;
    var ref11 = (0,useQuery/* useQuery */.aM)(TicketShareSelect_viewModel_QUERY, {
        variables: {
            id: router.query.itemId
        }
    }), data = ref11.data, loading = ref11.loading;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(GENERATE_TICKET_DISTRIBUTION_LINK), 2), generateTicketDistributionLink = ref12[0], ref13 = ref12[1], generating = ref13.loading;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(utoniq_core_schema/* RegenerateTicketDistributionLink */.C$9), 2), regenerateTicketDistributionLink = ref14[0], ref15 = ref14[1], regenerating = ref15.loading;
    var ref16;
    var serial = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref16 = data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.find(function(serial) {
            var ref;
            return (serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : ref.id) === router.query.serialId;
        })) !== null && ref16 !== void 0 ? ref16 : null;
    }, [
        data === null || data === void 0 ? void 0 : data.portfolio,
        router.query.serialId
    ]);
    var ref17, ref18;
    return {
        state: {
            loading: useInitialLoading(data, loading),
            generating: generating,
            regenerating: regenerating,
            serial: serial,
            throughTicketIndex: ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : ref.item.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticket) === null || ref2 === void 0 ? void 0 : ref2.isThroughTicket) ? router.query.throughTicketIndex : undefined,
            assignedNumberType: (ref17 = data === null || data === void 0 ? void 0 : (ref3 = data.portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metadata) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ticket) === null || ref6 === void 0 ? void 0 : ref6.assignedNumberType) !== null && ref17 !== void 0 ? ref17 : null,
            artistId: (ref18 = data === null || data === void 0 ? void 0 : (ref7 = data.portfolio) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.issuedArtist) === null || ref9 === void 0 ? void 0 : ref9.id) !== null && ref18 !== void 0 ? ref18 : ""
        },
        actions: {
            onGenerateTicketDistribution: function onGenerateTicketDistribution() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    generateTicketDistributionLink({
                                        variables: {
                                            inputs: {
                                                itemId: router.query.itemId,
                                                serialId: router.query.serialId
                                            }
                                        }
                                    }).then(function() {
                                        var _throughTicketIndex;
                                        router.replace(generateQueryPath(routerPages.TicketShareCopy, {
                                            itemId: router.query.itemId,
                                            serialId: router.query.serialId
                                        }, {
                                            throughTicketIndex: (_throughTicketIndex = router.query.throughTicketIndex) !== null && _throughTicketIndex !== void 0 ? _throughTicketIndex : "",
                                            isFirstGenerate: "true"
                                        }));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            onRegenerateTicketDistribution: function onRegenerateTicketDistribution() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1, ref2;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    regenerateTicketDistributionLink({
                                        variables: {
                                            inputs: {
                                                token: (ref2 = serial === null || serial === void 0 ? void 0 : (ref = serial.serial) === null || ref === void 0 ? void 0 : (ref1 = ref.ticketDistributionLink) === null || ref1 === void 0 ? void 0 : ref1.token) !== null && ref2 !== void 0 ? ref2 : ""
                                            }
                                        }
                                    }).then(function() {
                                        var _throughTicketIndex;
                                        router.replace(generateQueryPath(routerPages.TicketShareCopy, {
                                            itemId: router.query.itemId,
                                            serialId: router.query.serialId
                                        }, {
                                            throughTicketIndex: (_throughTicketIndex = router.query.throughTicketIndex) !== null && _throughTicketIndex !== void 0 ? _throughTicketIndex : ""
                                        }));
                                    }).catch(showError)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var TicketShareSelect_viewModel_QUERY = (0,lib/* gql */.Ps)(TicketShareSelect_viewModel_templateObject(), utoniq_core_schema/* TicketShareSelectUserItemSerialFragmentDoc */.zQo);
var GENERATE_TICKET_DISTRIBUTION_LINK = (0,lib/* gql */.Ps)(TicketShareSelect_viewModel_templateObject1());

;// CONCATENATED MODULE: ./src/components/pages/TicketShareSelect/index.tsx





/**
 * TicketShareSelect Page
 * Implemented as a practical sample.
 */ var TicketShareSelect = function() {
    var ref = TicketShareSelect_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (!state.loading && !state.serial) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketShareSelectTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/Top/template/index.tsx











var TopTemplate = function(param) {
    var onSkipSignUp = param.onSkipSignUp;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, router = ref.router;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    height: "100dvh",
                    maxHeight: 812,
                    display: "flex",
                    flexDirection: "column",
                    "& > *:first-of-type": {
                        flex: 1
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLogoCell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            height: "fit-content"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Top_template_ButtonCell, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginCell, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrationNoteCell, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var TopLogoCell = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            py: 6,
            display: "grid",
            placeItems: "center",
            backgroundImage: "url(".concat(config_config/* config.appStorageUrl */.v.appStorageUrl, "images/login/login_background.jpg)"),
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative"
        },
        children: [
            ![
                "kohmihirose"
            ].includes(config_config/* config.applicationKey */.v.applicationKey) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.backgroundImageWithGradient */.k$.backgroundImageWithGradient()), {
                            position: "absolute",
                            height: 36,
                            width: "100%",
                            top: 0,
                            zIndex: 2,
                            transform: "rotate(180deg)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles/* styleSets.backgroundImageWithGradient */.k$.backgroundImageWithGradient()), {
                            position: "absolute",
                            height: 88,
                            width: "100%",
                            bottom: 0,
                            zIndex: 2
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                src: "images/login/login_foreground.png",
                style: {
                    objectFit: "contain",
                    width: "80%",
                    maxWidth: 320
                }
            })
        ]
    });
};
var Top_template_ButtonCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("top").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 244
            },
            href: routerPages.SignUp,
            children: t("signUp")
        })
    });
};
var LoginCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("top").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    width: 244,
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    variant: "outlined",
                    color: "inherit",
                    size: "large",
                    fullWidth: true,
                    href: routerPages.Login,
                    children: t("login")
                })
            })
        })
    });
};
var SkipCell = function(param) {
    var onSkipSignUp = param.onSkipSignUp;
    var t = useTranslation("top").t;
    var routerPages = useRouter().routerPages;
    return /*#__PURE__*/ _jsx(CellFrame, {
        sx: {
            display: "grid",
            placeItems: "center",
            py: 7
        },
        children: /*#__PURE__*/ _jsx(Button, {
            variant: "text",
            href: routerPages.GlobalHome,
            onClick: onSkipSignUp,
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                children: t("skipSignUp")
            })
        })
    });
};
var RegistrationNoteCell = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("top").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            textAlign: "center",
            px: 8,
            py: 4
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            variant: "caption",
            color: "text.hint",
            children: [
                t("agreement.before"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    component: "a",
                    color: "primary",
                    href: (0,terms/* termsOfServiceUrl */.o)(),
                    children: t("agreement.term")
                }),
                t("agreement.between"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    component: "a",
                    color: "primary",
                    href: "https://about.utoniq.com/privacy-policy",
                    children: t("agreement.privacy")
                }),
                t("agreement.after")
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Top/viewModel.ts


var Top_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var analytics = (0,AnalyticsProvider/* useAnalytics */.z$)().analytics;
    return {
        state: {},
        actions: {
            skipSignUp: function() {
                analytics === null || analytics === void 0 ? void 0 : analytics.track("click_skipSignUp");
            }
        }
    };
});

;// CONCATENATED MODULE: ./src/components/pages/Top/index.tsx



var Top = function() {
    var ref = Top_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopTemplate, {
        state: state,
        onSkipSignUp: actions.skipSignUp
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/tutorial/TutorialStep.tsx









var TutorialStep = function(param) {
    var image = param.image, title = param.title, caption = param.caption, onNextStep = param.onNextStep, onSkip = param.onSkip, currentStep = param.currentStep, stepLength = param.stepLength;
    var t = (0,core_i18n/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtistThemeProvider/* StandAloneThemeProvider */.UI, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
                sx: {
                    position: "relative"
                },
                children: [
                    !(0,individual/* individualHideTutorialSkip */.Lz)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            top: 10,
                            right: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "text",
                            onClick: onSkip,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "h6",
                                children: t("tutorialSkip")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            width: "100%",
                            height: "100vh"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                                style: {
                                    height: "calc(100vw * 1170 / 1125)",
                                    maxHeight: "calc(600px * 1170 / 1125)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* StorageImage */.s, {
                                    src: image.uri,
                                    style: {
                                        objectFit: "cover",
                                        width: "100%",
                                        height: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: (0,src_object_spread/* default */.Z)({
                                    px: 7
                                }, styles/* styleSets.extraExtraSmallMedia */.k$.extraExtraSmallMedia({
                                    px: 4
                                })),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            mb: 4
                                        },
                                        align: "center",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "text.secondary",
                                        align: "center",
                                        children: caption
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                direction: "row",
                                                spacing: 2,
                                                sx: (0,src_object_spread/* default */.Z)({
                                                    py: 8
                                                }, styles/* styleSets.extraExtraSmallMedia */.k$.extraExtraSmallMedia({
                                                    py: 6
                                                })),
                                                children: Array.from(Array(stepLength).keys()).map(function(index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                        sx: {
                                                            width: 8,
                                                            height: 8,
                                                            borderRadius: "50%",
                                                            backgroundColor: currentStep === index ? "primary.main" : "grey.200"
                                                        }
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                size: "large",
                                                sx: {
                                                    minWidth: 244,
                                                    mb: 4
                                                },
                                                onClick: onNextStep,
                                                children: currentStep === stepLength - 1 ? t("tutorialStart") : t("tutorialNext")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Tutorial/template/index.tsx










var TutorialTemplate = function() {
    var t = (0,core_i18n/* useTranslation */.$G)("common").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, router = ref.router, routerPages = ref.routerPages;
    var ref1 = (0,react.useState)(0), currentStep = ref1[0], setCurrentStep = ref1[1];
    var images = (0,react.useMemo)(function() {
        return config_config/* config.tutorials */.v.tutorials;
    }, []);
    var handleSkip = (0,react.useCallback)(function() {
        (0,storage/* getRedirectAfterLoginPath */.CT)().then(function(param) {
            var value = param.value;
            return router.replace(value !== null && value !== void 0 ? value : routerPages.GlobalHome);
        });
    }, [
        router,
        routerPages.GlobalHome
    ]);
    var handleNextSteps = (0,react.useCallback)(function() {
        if (currentStep === images.length - 1) {
            handleSkip();
            return;
        }
        setCurrentStep(function(prev) {
            return prev + 1;
        });
    }, [
        currentStep,
        handleSkip,
        images.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Tutorial
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {
                    value: currentStep,
                    children: images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialStep, {
                            image: {
                                uri: image
                            },
                            caption: t("tutorialCaption".concat(index)),
                            title: t("tutorialTitle".concat(index)),
                            onNextStep: handleNextSteps,
                            onSkip: handleSkip,
                            currentStep: currentStep,
                            stepLength: images.length
                        }, index);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Tutorial/viewModel.ts

var Tutorial_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    return {
        state: {},
        actions: {}
    };
});

;// CONCATENATED MODULE: ./src/components/pages/Tutorial/index.tsx



/**
 * Tutorial Page
 * Implemented as a practical sample.
 */ var Tutorial = function() {
    var ref = Tutorial_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Ulink/template/index.tsx

var UlinkTemplate = function() {
    return null;
};

// EXTERNAL MODULE: ./src/components/pages/Ulink/viewModel.ts
var Ulink_viewModel = __webpack_require__(74389);
;// CONCATENATED MODULE: ./src/components/pages/Ulink/index.tsx



var Ulink = function() {
    var ref = (0,Ulink_viewModel/* useViewModel */.Dz)(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UlinkTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserItemDetail/template/index.tsx
















var UserItemDetailTemplate = function(param) {
    var state = param.state;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref7.routerNames, routerPages = ref7.routerPages, generatePath = ref7.generatePath;
    var t = (0,core_i18n/* useTranslation */.$G)("userItemDetail").t;
    var onClick = (0,BrowserLink/* useBrowserLink */.i)((0,helpUrl/* getHelpUrl */.R)("ownedItemDetail")).onClick;
    var _userId, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArtistThemeProvider/* ArtistThemeProvider */.rr, {
        artistId: (ref = state.item) === null || ref === void 0 ? void 0 : (ref1 = ref.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: ((ref2 = state.item) === null || ref2 === void 0 ? void 0 : ref2.title) || routerNames.UserItemDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    type: "modal",
                    defaultBackPage: generatePath(routerPages.UserOwnedItems, {
                        userId: (_userId = state.userId) !== null && _userId !== void 0 ? _userId : "#"
                    }),
                    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Help, {
                        edge: "end",
                        color: "primary.main",
                        size: "small",
                        onClick: onClick
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                    style: {
                        height: "100%"
                    },
                    children: state.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItemDetailCell, {
                        item: state.item,
                        userId: state.userId,
                        itemId: state.itemId,
                        loading: state.loading,
                        hasItem: state.hasItem,
                        disabledTrade: state.disabledTrade,
                        posessionNumber: state.posessionNumber,
                        avatarUri: (ref9 = (ref8 = (ref3 = state.user) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.avatar) === null || ref4 === void 0 ? void 0 : ref4.smallUri) !== null && ref8 !== void 0 ? ref8 : (ref5 = state.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.avatar) === null || ref6 === void 0 ? void 0 : ref6.uri) !== null && ref9 !== void 0 ? ref9 : ""
                    })
                })
            })
        ]
    });
};
var UserItemDetailCell = function(param) {
    var item = param.item, userId = param.userId, itemId = param.itemId, loading = param.loading, hasItem = param.hasItem, disabledTrade = param.disabledTrade, posessionNumber = param.posessionNumber, avatarUri = param.avatarUri;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("userItemDetail").t;
    var handleLoginModal = (0,privateAction/* usePrivateAction */.r)().handleLoginModal;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref1.routerPages, generatePath = ref1.generatePath, router = ref1.router;
    var ref2 = (0,react.useState)(false), openNotTradeConfirm = ref2[0], setOpenNotTradeConfirm = ref2[1];
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageArea, {
                item: item,
                loading: loading,
                noItem: !hasItem,
                possessionNumber: posessionNumber !== null && posessionNumber !== void 0 ? posessionNumber : 0,
                avatarUri: avatarUri
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementLinkArea, {
                itemId: itemId,
                artistId: (ref3 = item === null || item === void 0 ? void 0 : (ref = item.issuedArtist) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : "",
                startItems: [
                    {
                        type: "itemInfo",
                        hidden: (0,individual/* individualHiddenItemInfo */.Ek)(),
                        onClick: handleLoginModal(),
                        href: "".concat(generatePath(userId ? routerPages.UserItemInformation : routerPages.OwnedItemInformation, {
                            itemId: itemId,
                            userId: userId
                        })).concat((item === null || item === void 0 ? void 0 : item.sku) ? "?skuId=".concat(encodeSkuId(item === null || item === void 0 ? void 0 : item.sku.id)) : "")
                    },
                    {
                        type: "trade",
                        hidden: !!(item === null || item === void 0 ? void 0 : item.hideSalesNumber),
                        onClick: handleLoginModal(function() {
                            if (disabledTrade) {
                                setOpenNotTradeConfirm(true);
                                return;
                            }
                            router.push(generatePath(routerPages.SerialNumberSelect, {
                                itemId: itemId,
                                userId: userId
                            }));
                        }),
                        active: !disabledTrade
                    }, 
                ],
                endItems: [
                    {
                        type: "comment",
                        title: (ref4 = item === null || item === void 0 ? void 0 : item.commentCount) !== null && ref4 !== void 0 ? ref4 : 0
                    }
                ],
                pageName: "user_item_detail"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
                open: openNotTradeConfirm,
                onClose: function() {
                    return setOpenNotTradeConfirm(false);
                },
                title: t("notTradeConfirmTitle"),
                content: (item === null || item === void 0 ? void 0 : item.sku) ? t("notTradeConfirmSKUDesc") : t("notTradeConfirmDesc"),
                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    color: "primary",
                    sx: {
                        minWidth: 212
                    },
                    size: "large",
                    onClick: function() {
                        return setOpenNotTradeConfirm(false);
                    },
                    children: "OK"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserItemDetail/viewModel.ts

function UserItemDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserItemDetail(\n    $itemId: ID!\n    $userId: String\n    $uid: ID!\n    $skuId: String\n  ) {\n    portfolio(id: $itemId, userId: $userId) {\n      ...UserItemDetailBox\n    }\n    user(id: $uid) {\n      id\n      avatar {\n        uri\n        smallUri\n      }\n    }\n    userLoggedIn: user {\n      id\n    }\n  }\n  ",
        "\n"
    ]);
    UserItemDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserItemDetail_viewModel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserItemDetailForGuest($id: ID!, $userId: ID!, $skuId: String) {\n    item(id: $id) {\n      ...ItemDetailBox\n    }\n    user(id: $userId) {\n      id\n      avatar {\n        uri\n        smallUri\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    UserItemDetail_viewModel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserItemDetail_viewModel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query HasItemUserItemDetail($itemId: ID!, $userId: String) {\n    portfolio(id: $itemId, userId: $userId) {\n      id\n      serials {\n        serial {\n          skuId\n        }\n      }\n    }\n  }\n"
    ]);
    UserItemDetail_viewModel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var UserItemDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, // 物販アイテムの場合、所持シリアルがすべてプロテクトされている場合トレード不可
    ref4, ref5, ref6, ref7;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref8 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref8.user;
    var showModal = (0,useLoginModal/* useLoginModal */.N)().showModal;
    var ref9 = (0,useQuery/* useQuery */.aM)(UserItemDetail_viewModel_QUERY, {
        variables: {
            itemId: router.query.itemId,
            userId: router.query.userId,
            uid: router.query.userId
        },
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned)
    }), data = ref9.data, loading = ref9.loading;
    var ref10 = (0,useQuery/* useQuery */.aM)(UserItemDetail_viewModel_QUERY_FOR_GUEST, {
        variables: {
            id: router.query.itemId,
            userId: router.query.userId
        },
        skip: currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned
    }), dataForGuest = ref10.data, loadingForGuest = ref10.loading;
    var hasItem = !!((ref = (0,useQuery/* useQuery */.aM)(HAS_ITEM_QUERY, {
        variables: {
            itemId: router.query.itemId,
            userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid
        },
        skip: !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSigned)
    })) === null || ref === void 0 ? void 0 : ref.data);
    (0,react.useEffect)(function() {
        if (!currentUser) {
            showModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentUser
    ]);
    var tradableSerials = (0,react.useMemo)(function() {
        var ref, ref1;
        return data === null || data === void 0 ? void 0 : (ref = data.portfolio) === null || ref === void 0 ? void 0 : (ref1 = ref.serials) === null || ref1 === void 0 ? void 0 : ref1.filter(function(serial) {
            return !serial.isProtected;
        });
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.portfolio) === null || ref1 === void 0 ? void 0 : ref1.serials
    ]);
    var ref11, ref12, ref13, ref14, ref15;
    return {
        state: {
            loading: loading || loadingForGuest,
            isLoggedIn: !!currentUser,
            hasItem: hasItem,
            hasNextPage: false,
            disabledTrade: !!((data === null || data === void 0 ? void 0 : (ref2 = data.portfolio) === null || ref2 === void 0 ? void 0 : ref2.isUserProtected) || (data === null || data === void 0 ? void 0 : (ref3 = data.portfolio) === null || ref3 === void 0 ? void 0 : ref3.isSystemProtected) || (data === null || data === void 0 ? void 0 : (ref4 = data.portfolio) === null || ref4 === void 0 ? void 0 : ref4.item.type) === utoniq_core_schema/* ItemType.Merch */.qGq.Merch && (tradableSerials === null || tradableSerials === void 0 ? void 0 : tradableSerials.length) === 0 || // SKUを持っているアイテムはトレードできない
            !!(data === null || data === void 0 ? void 0 : (ref5 = data.portfolio) === null || ref5 === void 0 ? void 0 : ref5.item.sku)),
            posessionNumber: (ref12 = (ref6 = convertPortfolioItemToSku((ref11 = data === null || data === void 0 ? void 0 : data.portfolio) !== null && ref11 !== void 0 ? ref11 : null, router.query.skuId)) === null || ref6 === void 0 ? void 0 : ref6.number) !== null && ref12 !== void 0 ? ref12 : 0,
            item: setItemSku((ref14 = (ref13 = data === null || data === void 0 ? void 0 : (ref7 = data.portfolio) === null || ref7 === void 0 ? void 0 : ref7.item) !== null && ref13 !== void 0 ? ref13 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.item) !== null && ref14 !== void 0 ? ref14 : null, router.query.skuId),
            userId: router.query.userId,
            itemId: router.query.itemId,
            user: (ref15 = data === null || data === void 0 ? void 0 : data.user) !== null && ref15 !== void 0 ? ref15 : dataForGuest === null || dataForGuest === void 0 ? void 0 : dataForGuest.user
        },
        actions: {}
    };
});
var UserItemDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(UserItemDetail_viewModel_templateObject(), utoniq_core_schema/* UserItemDetailBoxFragmentDoc */.XRF);
var UserItemDetail_viewModel_QUERY_FOR_GUEST = (0,lib/* gql */.Ps)(UserItemDetail_viewModel_templateObject1(), utoniq_core_schema/* ItemDetailBoxFragmentDoc */.Sez);
var HAS_ITEM_QUERY = (0,lib/* gql */.Ps)(UserItemDetail_viewModel_templateObject2());

;// CONCATENATED MODULE: ./src/components/pages/UserItemDetail/index.tsx





/**
 * UserItemDetail Page
 * Implemented as a practical sample.
 */ var UserItemDetail = function() {
    var ref = UserItemDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    if (!state.loading && !state.item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound/* NotFound */.T, {
            useNextRouter: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItemDetailTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/UserOwnedItems/template/index.tsx











var UserOwnedItemsTemplate = function(param) {
    var state = param.state, onFilter = param.onFilter, onFetchMore = param.onFetchMore;
    var t = (0,core_i18n/* useTranslation */.$G)("userOwnedItems").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref.routerNames, routerPages = ref.routerPages, generatePath = ref.generatePath;
    var _userId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: [
                    routerNames.UserOwnedItems,
                    state.userName
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
                header: {
                    back: true,
                    defaultBackPage: generatePath(routerPages.UserProfile, {
                        userId: (_userId = state.userId) !== null && _userId !== void 0 ? _userId : "#"
                    }),
                    title: t("title")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(template_SelectButtonCell, {
                        onFilter: onFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserOwnedItems_template_ItemImageListCell, {
                        userId: state.userId,
                        loading: state.loading,
                        hasNextPage: state.hasNextPage,
                        portfolios: state.portfolios,
                        onFetchMore: onFetchMore
                    })
                ]
            })
        ]
    });
};
var template_filters = [
    "filterProcedure"
];
var template_SelectButtonCell = function(param) {
    var onFilter = param.onFilter;
    var t = (0,core_i18n/* useTranslation */.$G)("userOwnedItems").t;
    var ref = (0,react.useState)(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handleClick = (0,react.useCallback)(function(event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0,react.useCallback)(function() {
        setAnchorEl(null);
    }, []);
    var handleMenuItemClick = (0,react.useCallback)(function(event, index) {
        setSelectedIndex(index);
        setAnchorEl(null);
        onFilter(index);
    }, [
        onFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        display: "flex",
        justifyContent: "flex-end",
        sx: {
            pb: 2,
            px: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                variant: "text",
                onClick: handleClick,
                sx: {
                    color: "text.primary",
                    mr: -2
                },
                children: [
                    t(template_filters[selectedIndex]),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.DownArrow, {
                        sx: {
                            pl: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu/* default */.Z, {
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: template_filters.map(function(filter, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem_MenuItem/* default */.Z, {
                        sx: {
                            bgcolor: "grey.50"
                        },
                        selected: selectedIndex === index,
                        onClick: function(event) {
                            return handleMenuItemClick(event, index);
                        },
                        children: t(filter)
                    }, index);
                })
            })
        ]
    });
};
var UserOwnedItems_template_ItemImageListCell = function(param) {
    var loading = param.loading, hasNextPage = param.hasNextPage, portfolios = param.portfolios, onFetchMore = param.onFetchMore, userId = param.userId;
    var t = (0,core_i18n/* useTranslation */.$G)("userOwnedItems").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, generatePath = ref.generatePath, router = ref.router;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            py: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
            nodes: portfolios === null || portfolios === void 0 ? void 0 : portfolios.edges.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ItemImage/* ItemImage */.R, {
                    onClick: function() {
                        var ref;
                        return router.push({
                            pathname: generatePath(routerPages.UserItemDetail, {
                                userId: userId,
                                itemId: item.node.item.id
                            }),
                            search: item.node.item.sku ? "?skuId=".concat(encodeSkuId((ref1 = (ref = item.node.item.sku) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : "")) : ""
                        });
                    },
                    item: item.node.item,
                    ownedCount: item.node.number,
                    showIcon: true
                }, item.node.item.id);
            }),
            loading: loading,
            hasNextPage: hasNextPage,
            onFetchMore: onFetchMore,
            component: Grid2/* default */.Z,
            componentProps: {
                container: true,
                spacing: 3
            },
            emptyMessage: t("userOwnedItemEmptyMessage"),
            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                container: true,
                spacing: 3,
                children: Array.from(Array(9).keys()).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        size: {
                            xs: 4,
                            md: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                            variant: "rectangular",
                            sx: {
                                width: "100%",
                                height: 166
                            }
                        })
                    }, key);
                })
            }),
            itemComponent: Grid2/* default */.Z,
            itemComponentProps: {
                size: {
                    xs: 4,
                    md: 3
                },
                sx: {
                    textAlign: "center"
                }
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserOwnedItems/viewModel.ts



function UserOwnedItems_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserOwnedItems($type: ItemType, $pageInput: PageInput, $userId: ID) {\n    user(id: $userId) {\n      id\n      displayName\n      organizationPortfolios(type: $type, pageInput: $pageInput) {\n        ...UserOwnedItemsConnection\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    UserOwnedItems_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var UserOwnedItems_viewModel_useViewModel = function() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var isFirstLoadRef = useGetNewestData({
        query: UserOwnedItems_viewModel_QUERY,
        variables: {
            userId: router.query.userId
        },
        fields: [
            {
                fieldName: "events",
                fragmentName: "UserOwnedItemDetail",
                fragment: utoniq_core_schema/* UserOwnedItemDetailFragmentDoc */.v9e
            }, 
        ]
    }).isFirstLoadRef;
    var ref5 = (0,useQuery/* useQuery */.aM)(UserOwnedItems_viewModel_QUERY, {
        variables: {
            userId: router.query.userId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
        onCompleted: function onCompleted() {
            isFirstLoadRef.current = false;
        }
    }), data = ref5.data, loading = ref5.loading, fetchMore = ref5.fetchMore;
    var ref6;
    return {
        state: {
            loading: loading,
            userId: router.query.userId,
            userName: (data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.displayName) || "",
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organizationPortfolios) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageInfo) === null || ref3 === void 0 ? void 0 : ref3.hasNextPage),
            portfolios: spreadPortfoliosBySku((ref6 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.organizationPortfolios) !== null && ref6 !== void 0 ? ref6 : null)
        },
        actions: {
            onFilter: function onFilter(key) {},
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            userId: router.query.userId,
                                            pageInput: {
                                                cursor: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.organizationPortfolios) === null || ref1 === void 0 ? void 0 : ref1.pageInfo.endCursor
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
};
var UserOwnedItems_viewModel_QUERY = (0,lib/* gql */.Ps)(UserOwnedItems_viewModel_templateObject(), utoniq_core_schema/* UserOwnedItemsConnectionFragmentDoc */.fsd);

;// CONCATENATED MODULE: ./src/components/pages/UserOwnedItems/index.tsx



/**
 * UserOwnedItems Page
 * Implemented as a practical sample.
 */ var UserOwnedItems = function() {
    var ref = UserOwnedItems_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserOwnedItemsTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore,
        onFilter: actions.onFilter
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/item/ItemBoxSkeleton/index.tsx



var ItemBoxSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageAreaSkeleton, {})
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserProfile/template/index.tsx













var UserProfileTemplate = function(param) {
    var state = param.state;
    var ref, ref1;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        safeArea: {
            pt: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: ((ref = state.user) === null || ref === void 0 ? void 0 : ref.displayName) || routerNames.UserProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCustomProfile, {
                isCustom: state.isCustom,
                user: state.user
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_UserInfo, {
                user: state.user,
                loading: state.loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_ArtistRankingCell, {
                rankings: state.organizationArtistRankings,
                loading: state.loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(template_CampaignRankingCell, {
                rankings: state.rankings,
                loading: state.loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCollectionCell, {
                userId: state.userId,
                collections: state.collections,
                loading: state.loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserOwnedItemCell, {
                items: state.items,
                userId: (ref2 = (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "",
                loading: state.loading
            })
        ]
    });
};
var template_UserInfo = function(param) {
    var user = param.user, loading = param.loading;
    var ref;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            sx: {
                py: 2,
                px: 5
            },
            spacing: 3,
            alignItems: "center",
            flex: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    width: 64,
                    height: 64
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        minWidth: 84
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "medium",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                            variant: "small",
                            width: "100%"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        width: "100%"
                    },
                    alignItems: "center",
                    spacing: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
                        variant: "small",
                        numberOfLine: 2,
                        lastWidth: "50%"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            px: 0,
            mb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            sx: {
                px: 5
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        width: 64,
                        height: 64
                    },
                    src: (user === null || user === void 0 ? void 0 : (ref = user.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) || undefined
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h4",
                    sx: {
                        mt: 3
                    },
                    children: user === null || user === void 0 ? void 0 : user.displayName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "text.hint",
                    children: user === null || user === void 0 ? void 0 : user.formattedAccountId
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    sx: {
                        mt: 3
                    },
                    children: user === null || user === void 0 ? void 0 : user.introduction
                })
            ]
        })
    });
};
var template_CampaignRankingCell = function(param) {
    var rankings = param.rankings, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    if (!config_config/* config.modules.campaign */.v.modules.campaign) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            px: 5,
            pb: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h5",
                sx: {
                    py: 2,
                    color: "grey.600"
                },
                children: t("joinCampaign")
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: [
                    1,
                    2,
                    3
                ].map(function(i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBoxSkeleton, {}, i);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                children: !!rankings && (rankings === null || rankings === void 0 ? void 0 : rankings.length) > 0 ? rankings === null || rankings === void 0 ? void 0 : rankings.map(function(ranking) {
                    var ref, ref1, ref2, ref3, ref4;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListItem_ListItem/* default */.ZP, {
                        sx: {
                            p: 0,
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                variant: "square",
                                sx: {
                                    width: 100,
                                    height: 64,
                                    borderRadius: 2
                                },
                                alt: ranking === null || ranking === void 0 ? void 0 : (ref = ranking.myRank) === null || ref === void 0 ? void 0 : ref.displayName,
                                src: (ranking === null || ranking === void 0 ? void 0 : (ref1 = ranking.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || undefined
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: {
                                    pl: 4,
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            pb: 1
                                        },
                                        children: [
                                            ranking === null || ranking === void 0 ? void 0 : (ref2 = ranking.myRank) === null || ref2 === void 0 ? void 0 : ref2.rank,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "subtitle2",
                                                component: "p",
                                                display: "inline",
                                                children: t("rank")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                                variant: "body1",
                                                children: ranking === null || ranking === void 0 ? void 0 : (ref3 = ranking.myRank) === null || ref3 === void 0 ? void 0 : ref3.displayName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
                                                variant: "body2",
                                                color: "text.hint",
                                                children: [
                                                    ranking === null || ranking === void 0 ? void 0 : (ref4 = ranking.myRank) === null || ref4 === void 0 ? void 0 : ref4.point,
                                                    "pt"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, ranking === null || ranking === void 0 ? void 0 : ranking.id);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body1",
                    color: "text.secondary",
                    align: "center",
                    children: t("campaignNotExist")
                })
            })
        ]
    });
};
var UserOwnedItemCell = function(param) {
    var items = param.items, userId = param.userId, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    var ref = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref.generatePath, routerPages = ref.routerPages;
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            pt: (items === null || items === void 0 ? void 0 : items.edges.length) ? 10 : 0,
            mb: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
            loading: loading,
            loadingItemLength: 6,
            title: t("ownedItems"),
            titleTypographyProps: {
                variant: "h5",
                color: "grey.600"
            },
            listHref: userId && generatePath(routerPages.UserOwnedItems, {
                userId: userId
            }),
            items: (ref1 = items === null || items === void 0 ? void 0 : items.edges) !== null && ref1 !== void 0 ? ref1 : [],
            trans: t("toList"),
            LoadingComponent: ItemBoxSkeleton,
            renderItem: function(param, index) {
                var item = param.node.item;
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card_Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea_CardActionArea/* default */.Z, {
                        href: generatePath(routerPages.UserItemDetail, {
                            userId: userId,
                            itemId: item.id
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.ItemImageArea, {
                            src: (ref2 = (ref = item.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.front) === null || ref1 === void 0 ? void 0 : ref1.smallUri) !== null && ref2 !== void 0 ? ref2 : ""
                        })
                    })
                }, index);
            },
            EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "body1",
                color: "text.secondary",
                align: "center",
                children: t("itemNotExist")
            })
        })
    });
};
var UserCollectionCell = function(param) {
    var collections = param.collections, userId = param.userId, loading = param.loading;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        loadingItemLength: 6,
        title: t("collection"),
        titleTypographyProps: {
            variant: "h5",
            color: "grey.600"
        },
        items: collections !== null && collections !== void 0 ? collections : [],
        LoadingComponent: CollectionBoxSkeleton,
        renderItem: function(param, index) {
            var node = param.node;
            return node.collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionBox, {
                collection: node,
                userId: userId,
                sx: {
                    height: 156
                }
            }, index);
        },
        EmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
            variant: "body1",
            color: "text.secondary",
            align: "center",
            children: t("collectionNotExist")
        })
    });
};
var UserCustomProfile = function(param) {
    var isCustom = param.isCustom, user = param.user;
    var avatarUrl = get_default()(user, "customProfile.avatarItem.avatarResources.avatarResource.smallUri", null);
    var wallpaperUrl = get_default()(user, "customProfile.wallpaperItem.wallpaperResources.wallpaperResource.mediumUri", null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* OrganismFrame */.o, {
        sx: isCustom ? {
            position: "relative",
            width: "100%",
            height: "400px",
            mb: 5
        } : {
            height: function(theme) {
                return theme.mixins.toolbar.minHeight;
            },
            mb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                back: true,
                position: "absolute",
                sx: {
                    backgroundImage: "unset",
                    boxShadow: "none",
                    backgroundColor: "transparent",
                    pt: styles/* styles.safeAreaTop */.W2.safeAreaTop
                }
            }),
            wallpaperUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    id: "wallpaper-img",
                    component: "img",
                    src: wallpaperUrl,
                    sx: {
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center"
                    }
                })
            }),
            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    id: "avatar-img",
                    component: "img",
                    src: avatarUrl,
                    sx: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        m: "auto",
                        height: function(theme) {
                            return "calc(100% - ".concat(theme.mixins.toolbar.minHeight, "px)");
                        }
                    }
                })
            })
        ]
    });
};
var template_ArtistRankingCell = function(param) {
    var loading = param.loading, rankings = param.rankings;
    var ref;
    var t = (0,core_i18n/* useTranslation */.$G)("userProfile").t;
    if (!loading && !((ref = rankings === null || rankings === void 0 ? void 0 : rankings.filter(function(param) {
        var node = param.node;
        return !!node.latestRankingPeriod;
    })) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalList, {
        loading: loading,
        loadingItemLength: 8,
        title: t("monthlyRanking"),
        titleTypographyProps: {
            variant: "h5",
            color: "grey.600"
        },
        TitleLoadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.SkeletonText, {
            variant: "medium",
            width: "25%"
        }),
        items: rankings !== null && rankings !== void 0 ? rankings : [],
        spacing: 4,
        LoadingComponent: template_ArtistRankingSkeleton,
        renderItem: function(param) {
            var node = param.node;
            var ref;
            return (node === null || node === void 0 ? void 0 : node.latestRankingPeriod) && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile_template_ArtistRanking, {
                rank: (ref1 = (ref = node.latestRankingPeriod.myRanking) === null || ref === void 0 ? void 0 : ref.rank) !== null && ref1 !== void 0 ? ref1 : 0,
                artistId: node.artistId,
                artist: node.artist
            }, node.latestRankingPeriod.id);
        }
    });
};
var UserProfile_template_ArtistRanking = function(param) {
    var rank = param.rank, artist = param.artist, artistId = param.artistId;
    var ref;
    var ref1 = (0,router_useRouter/* useRouter */.tv)(), generatePath = ref1.generatePath, routerPages = ref1.routerPages;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
            sx: {
                position: "relative",
                width: 64,
                height: 64,
                borderRadius: 1
            },
            href: generatePath(routerPages.ArtistRanking, {
                artistId: artistId
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                    size: "medium",
                    rank: rank,
                    sx: {
                        transform: "translateX(-4px)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    sx: {
                        width: 28,
                        height: 28,
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        zIndex: 3
                    },
                    src: (ref2 = artist === null || artist === void 0 ? void 0 : (ref = artist.avatar) === null || ref === void 0 ? void 0 : ref.smallUri) !== null && ref2 !== void 0 ? ref2 : ""
                })
            ]
        })
    });
};
var template_ArtistRankingSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            justifyContent: "center",
            sx: {
                position: "relative",
                width: 64,
                height: 64
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    sx: {
                        transform: "translateX(8px) rotate(-45deg)",
                        width: "calc(56px/(0.707*2))",
                        height: "calc(56px/(0.707*2))"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "circular",
                    sx: {
                        width: 28,
                        height: 28,
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        zIndex: 3
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserProfile/viewModel.ts

function UserProfile_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserProfile(\n    $id: ID\n    $userId: String\n    $pageInput: PageInput\n    $pageInputCollection: PageInput\n  ) {\n    user(id: $id) {\n      ...UserCommonWithCustomProfileConnection\n      organizationPortfolios(pageInput: $pageInput) {\n        ...PortfoliosConnection\n      }\n    }\n    organization {\n      id\n      entryCampaignRankings(id: $id) {\n        ...EntryCampaignRankingConnection\n      }\n    }\n    ownedUserCollections(userId: $userId, pageInput: $pageInputCollection) {\n      edges {\n        node {\n          ...UserCollectionBox\n        }\n      }\n    }\n    organizationArtistRankings(userId: $userId) {\n      edges {\n        node {\n          ... on Ranking {\n            ...RankingBaseConnection\n            latestRankingPeriod(periodType: monthly) {\n              ...RankingPeriodBaseConnection\n              myRanking(userId: $userId) {\n                ...RankingUserWithoutIdConnection\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    UserProfile_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var UserProfile_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var userId = router.query.userId;
    var ref5 = (0,useQuery/* useQuery */.aM)(UserProfile_viewModel_QUERY, {
        variables: {
            id: userId,
            userId: userId,
            pageInputCollection: {
                limit: 10
            }
        }
    }), data = ref5.data, loading = ref5.loading;
    var ref6, ref7;
    return {
        state: {
            loading: loading,
            user: (data === null || data === void 0 ? void 0 : data.user) || null,
            userId: userId,
            isCustom: !!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.customProfile),
            rankings: (data === null || data === void 0 ? void 0 : (ref1 = data.organization) === null || ref1 === void 0 ? void 0 : ref1.entryCampaignRankings) || null,
            items: (data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : ref2.organizationPortfolios) || null,
            collections: (ref6 = data === null || data === void 0 ? void 0 : (ref3 = data.ownedUserCollections) === null || ref3 === void 0 ? void 0 : ref3.edges.filter(function(param) {
                var node = param.node;
                return (node === null || node === void 0 ? void 0 : node.itemOwnedCount) && node.itemOwnedCount >= 1;
            })) !== null && ref6 !== void 0 ? ref6 : null,
            organizationArtistRankings: (ref7 = data === null || data === void 0 ? void 0 : (ref4 = data.organizationArtistRankings) === null || ref4 === void 0 ? void 0 : ref4.edges.filter(function(param) {
                var node = param.node;
                return node.status === utoniq_core_schema/* RankingStatus.Active */.HBK.Active;
            })) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {}
    };
});
var UserProfile_viewModel_QUERY = (0,lib/* gql */.Ps)(UserProfile_viewModel_templateObject(), utoniq_core_schema/* UserCommonWithCustomProfileConnectionFragmentDoc */.P6N, utoniq_core_schema/* PortfoliosConnectionFragmentDoc */.LP_, utoniq_core_schema/* EntryCampaignRankingConnectionFragmentDoc */.Oax, utoniq_core_schema/* UserCollectionBoxFragmentDoc */.ltU, utoniq_core_schema/* RankingBaseConnectionFragmentDoc */.MHS, utoniq_core_schema/* RankingPeriodBaseConnectionFragmentDoc */.CqK, utoniq_core_schema/* RankingUserWithoutIdConnectionFragmentDoc */.u1C);

;// CONCATENATED MODULE: ./src/components/pages/UserProfile/index.tsx



/**
 * UserProfile Page
 * Implemented as a practical sample.
 */ var UserProfile = function() {
    var state = UserProfile_viewModel_useViewModel().state;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileTemplate, {
        state: state
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserTradeDetail/template/index.tsx










var UserTradeDetailTemplate = function(param) {
    var state = param.state, onFetchMore = param.onFetchMore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,core_i18n/* useTranslation */.$G)("userTradeDetail").t;
    var ref7 = (0,router_useRouter/* useRouter */.tv)(), routerNames = ref7.routerNames, generatePath = ref7.generatePath, routerPages = ref7.routerPages;
    var artistId = (ref1 = (ref = state.trade) === null || ref === void 0 ? void 0 : ref.candidates[0].candidateItems[0].item.issuedArtist) === null || ref1 === void 0 ? void 0 : ref1.id;
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            title: ((ref2 = state.trade) === null || ref2 === void 0 ? void 0 : ref2.status) ? t((ref3 = state.trade) === null || ref3 === void 0 ? void 0 : ref3.status) : "",
            back: true,
            type: "modal",
            defaultBackPage: artistId ? config_config/* config.applicationType */.v.applicationType === "standalone" ? generatePath(routerPages.ArtistTop, {
                artistId: artistId
            }) : generatePath(routerPages.ArtistTrade, {
                artistId: artistId
            }) : undefined
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.UserTradeDetail
            }),
            ((ref4 = state.trade) === null || ref4 === void 0 ? void 0 : ref4.status) === utoniq_core_schema/* TradeNegotiationStatus.InProgress */._JF.InProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTradeDetail_template_TextCell, {
                trade: state.trade
            }),
            !state.loading && state.trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeDetailBox/* TradeDetailBox */.H, {
                trade: state.trade,
                myUserId: (ref8 = (ref5 = state.currentUser) === null || ref5 === void 0 ? void 0 : ref5.uid) !== null && ref8 !== void 0 ? ref8 : ""
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeDetailBoxSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollFetcher/* ScrollFetcher */.x, {
                componentProps: {
                    spacing: 0
                },
                nodes: (ref6 = state.messages) === null || ref6 === void 0 ? void 0 : ref6.edges.map(function(param, index) {
                    var node = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeMessageBox, {
                        message: node
                    }, index);
                }),
                loading: state.loading,
                hasNextPage: state.hasNextPage,
                onFetchMore: onFetchMore,
                loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        px: 5
                    },
                    children: [
                        1,
                        2,
                        3
                    ].map(function(key) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeMessageBoxSkeleton, {}, key);
                    })
                })
            })
        ]
    });
};
var UserTradeDetail_template_TextCell = function(param) {
    var trade = param.trade;
    var t = (0,core_i18n/* useTranslation */.$G)("userTradeDetail").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        sx: {
            py: 2,
            bgcolor: "grey.50"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            spacing: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "caption",
                    children: t("tradeAlert")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "overline",
                    color: "text.secondary",
                    children: t("appDeadline", {
                        expiredAt: trade === null || trade === void 0 ? void 0 : trade.formattedExpiredAt
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/UserTradeDetail/viewModel.ts



function UserTradeDetail_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserTradeDetail($tradeNegotiationId: ID!, $pageInput: PageInput) {\n    tradeNegotiation(id: $tradeNegotiationId) {\n      expiredAt\n      formattedExpiredAt @client\n      ...TradeBox\n      comments(pageInput: $pageInput) {\n        ...CommentsConnection\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    UserTradeDetail_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var UserTradeDetail_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,auth/* useCurrentUser */.xJ)(), currentUser = ref4.user;
    var router = (0,router_useRouter/* useRouter */.tv)().router;
    var ref5 = (0,useQuery/* useQuery */.aM)(UserTradeDetail_viewModel_QUERY, {
        variables: {
            tradeNegotiationId: router.query.tradeNegotiationId
        },
        returnPartialData: true
    }), data = ref5.data, loading = ref5.loading, fetchMore = ref5.fetchMore;
    var ref6, ref7;
    return {
        state: {
            loading: loading,
            currentUser: currentUser,
            hasNextPage: !!(data === null || data === void 0 ? void 0 : (ref = data.tradeNegotiation) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage),
            messages: (ref6 = data === null || data === void 0 ? void 0 : (ref3 = data.tradeNegotiation) === null || ref3 === void 0 ? void 0 : ref3.comments) !== null && ref6 !== void 0 ? ref6 : null,
            trade: (ref7 = data === null || data === void 0 ? void 0 : data.tradeNegotiation) !== null && ref7 !== void 0 ? ref7 : null
        },
        actions: {
            onFetchMore: function onFetchMore() {
                return (0,src_async_to_generator/* default */.Z)(function() {
                    var ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchMore({
                                        variables: {
                                            tradeNegotiationId: router.query.tradeNegotiationId,
                                            pageInput: {
                                                cursor: (ref = data === null || data === void 0 ? void 0 : data.tradeNegotiation.comments) === null || ref === void 0 ? void 0 : ref.pageInfo.endCursor,
                                                limit: 30
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    };
});
var UserTradeDetail_viewModel_QUERY = (0,lib/* gql */.Ps)(UserTradeDetail_viewModel_templateObject(), utoniq_core_schema/* TradeBoxFragmentDoc */.CCA, utoniq_core_schema/* CommentsConnectionFragmentDoc */.M6M);

;// CONCATENATED MODULE: ./src/components/pages/UserTradeDetail/index.tsx



/**
 * UserTradeDetail Page
 * Implemented as a practical sample.
 */ var UserTradeDetail = function() {
    var ref = UserTradeDetail_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTradeDetailTemplate, {
        state: state,
        onFetchMore: actions.onFetchMore
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/nft/MetamaskWalletConnectInfoModal/index.tsx








/**
 * @description
 * モバイルアプリ用のメタマスクアプリとUtoniqアプリ連携の使い方説明用モーダル
 */ var MetamaskWalletConnectInfoModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,core_i18n/* useTranslation */.$G)("metamaskWalletConnectInfoModal").t;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenModal/* FullscreenModal */.O, {
        open: open,
        onClose: onClose,
        sx: {
            zIndex: zIndex.modal + 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
            margin: true,
            header: {
                title: t("title"),
                left: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.IconButton.Close, {
                    onClick: onClose,
                    sx: {
                        ml: -2
                    }
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        py: 2
                    },
                    children: t("howTo")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    gap: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContent, {
                            stepNumber: 1,
                            title: t("step1.title"),
                            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: {
                                            pb: 2
                                        },
                                        children: t("step1.content1")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.TextLink, {
                                        variant: "caption",
                                        onClick: function() {
                                            return (0,native_app/* marketOpen */.Pd)({
                                                iosAppId: "1438144202",
                                                androidAppId: "io.metamask"
                                            });
                                        },
                                        children: t("step1.content2")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContent, {
                            stepNumber: 2,
                            title: t("step2.title"),
                            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: {
                                            pb: 2
                                        },
                                        children: t("step2.content1")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "caption",
                                        color: "error",
                                        sx: {
                                            pb: 2
                                        },
                                        children: t("step2.content2")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        alignSelf: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                            sx: {
                                                mt: 3
                                            },
                                            fullWidth: false,
                                            onClick: function() {
                                                return window.open("https://metamask.app.link/dapp/".concat(config_config/* config.domain */.v.domain, "/login?redirectUri=").concat(location.pathname));
                                            },
                                            children: t("step2.content3")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var StepContent = function(param) {
    var stepNumber = param.stepNumber, title = param.title, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            p: 3,
            bgcolor: "grey.50",
            borderRadius: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                label: "STEP ".concat(stepNumber),
                style: {
                    borderRadius: 60
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    py: 2
                },
                children: title
            }),
            content
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Wallet/template/WalletPasswordSettingModal.tsx





/**
 * @description
 * 仮想通貨ウォレット連携前提の、Utoniq側のauthへのメアド・パスワード認証登録フォーム用モーダル
 */ var WalletPasswordSettingModal = function(param) {
    var open = param.open, onClose = param.onClose, onSubmit = param.onSubmit, _email = param.email, email = _email === void 0 ? "" : _email;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        open: open,
        sx: {
            zIndex: zIndex.modal + 3
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordSettingsTemplate, {
            state: {
                hasPassword: false,
                forWallet: true,
                email: email
            },
            onSubmit: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            onSubmitUnregisteredPassword: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            }),
            onSubmitWalletPassword: onSubmit,
            onClose: onClose
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Wallet/template/index.tsx
















var WalletTemplate = function(param) {
    var state = param.state, connectMetamask = param.connectMetamask, connectToWeb3auth = param.connectToWeb3auth, openTorusWallet = param.openTorusWallet, onSubmitPasswordSetting = param.onSubmitPasswordSetting;
    var ref, ref1;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var routerNames = (0,router_useRouter/* useRouter */.tv)().routerNames;
    var ref2 = (0,react.useState)(false), openNftConnectDrawer = ref2[0], setOpenNftConnectDrawer = ref2[1];
    var ref3 = (0,messages_useMessage/* useMessage */.UD)(), showError = ref3.showError, showMessage = ref3.showMessage;
    var ref4 = (0,react.useState)(false), connecting = ref4[0], setConnecting = ref4[1];
    var ref5 = (0,react.useState)(false), openWalletCreateConfirmModal = ref5[0], setOpenWalletCreateConfirmModal = ref5[1];
    var ref6 = (0,react.useState)(false), openPasswordRequireModal = ref6[0], setOpenPasswordRequireModal = ref6[1];
    var ref7 = (0,react.useState)(false), openWalletPasswordSettingModal = ref7[0], setOpenWalletPasswordSettingModal = ref7[1];
    var ref8 = (0,react.useState)(false), openMetamaskWalletConnectInfoModal = ref8[0], setOpenMetamaskWalletConnectInfoModal = ref8[1];
    var onConnectWeb3auth = function() {
        setConnecting(true);
        return connectToWeb3auth().catch(function(e) {
            (0,core_errors/* captureError */.O)(e, "walletTemplate");
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenWalletCreateConfirmModal(false);
            setOpenNftConnectDrawer(false);
        });
    };
    var onConnectMetamask = function() {
        setConnecting(true);
        return connectMetamask().then(function() {
            showMessage(t("connected"));
        }).catch(function(e) {
            (0,core_errors/* captureError */.O)(e, "walletTemplate");
            showError(e);
        }).finally(function() {
            setConnecting(false);
            setOpenNftConnectDrawer(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout/* BaseLayout */.I, {
        header: {
            back: true,
            title: t("title")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                title: routerNames.Wallet
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletChargePoint, {
                loading: state.loading,
                pointBalance: state.pointBalance,
                ticket: state.ticket,
                gachaTicket: state.gachaTicket,
                cryptoWallet: state.cryptoWallet,
                onConnectWallet: function() {
                    return setOpenNftConnectDrawer(true);
                },
                onOpenWallet: function() {
                    return openTorusWallet();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCell, {
                isPurchasable: !!((ref = state.gachaTicket) === null || ref === void 0 ? void 0 : ref.isPurchasable)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCryptoWalletConfirmModal, {
                open: openWalletCreateConfirmModal,
                loading: connecting,
                onClose: function() {
                    return setOpenWalletCreateConfirmModal(false);
                },
                onCreate: onConnectWeb3auth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletConnectDrawer, {
                open: openNftConnectDrawer,
                onClose: function() {
                    return setOpenNftConnectDrawer(false);
                },
                connecting: connecting,
                onConnectWallet: function(walletType) {
                    switch(walletType){
                        case "web3auth":
                            return setOpenWalletCreateConfirmModal(true);
                        case "metamask":
                            var ref;
                            /**
               * @description
               * パスワード認証未済の場合はパスワード登録を促す
               */ if (!((ref = state.user) === null || ref === void 0 ? void 0 : ref.providers.some(function(provider) {
                                return provider.providerId === "password";
                            }))) {
                                return setOpenPasswordRequireModal(true);
                            }
                            /**
               * @description
               * nativeアプリ内且つメタマスクアプリ内でない場合、動線表示用のモーダルを表示
               */ if (!isMetamaskInstalled() && (0,native_app/* getPlatform */.Xf)() !== "web") {
                                return setOpenMetamaskWalletConnectInfoModal(true);
                            }
                            return onConnectMetamask();
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordRequireModal, {
                open: openPasswordRequireModal,
                onClose: function() {
                    return setOpenPasswordRequireModal(false);
                },
                onClick: function() {
                    return setOpenWalletPasswordSettingModal(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletPasswordSettingModal, {
                open: openWalletPasswordSettingModal,
                onClose: function() {
                    setOpenPasswordRequireModal(false);
                    setOpenWalletPasswordSettingModal(false);
                },
                onSubmit: onSubmitPasswordSetting,
                email: (ref1 = state.user) === null || ref1 === void 0 ? void 0 : ref1.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetamaskWalletConnectInfoModal, {
                open: openMetamaskWalletConnectInfoModal,
                onClose: function() {
                    return setOpenMetamaskWalletConnectInfoModal(false);
                }
            })
        ]
    });
};
var WalletChargePoint = function(param) {
    var loading = param.loading, pointBalance = param.pointBalance, ticket = param.ticket, gachaTicket = param.gachaTicket, cryptoWallet = param.cryptoWallet, onConnectWallet = param.onConnectWallet, onOpenWallet = param.onOpenWallet;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 4,
        sx: {
            pt: 4,
            mx: 5
        },
        children: [
            !!config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "column",
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    pt: 5,
                    pb: 6,
                    borderRadius: 2,
                    backgroundColor: "grey.50"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                        variant: "h6",
                        color: "text.secondary",
                        children: t("pointBalance")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Point, {
                        point: pointBalance,
                        loading: loading
                    }),
                    config_config/* config.modules.prepaidPoint.chargeable */.v.modules.prepaidPoint.chargeable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: routerPages.PrepaidPointCharge,
                        children: t("charge")
                    })
                ]
            }),
            config_config/* config.modules.nft */.v.modules.nft ? loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: {
                    bgcolor: "grey.50",
                    height: 200,
                    width: "100%",
                    borderRadius: 2
                }
            }) : cryptoWallet.walletAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet_template_WalletConnectCell, {
                cryptoWallet: cryptoWallet,
                onOpenWallet: onOpenWallet
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(template_WalletNotConnectedCell, {
                onConnectWallet: onConnectWallet
            }) : null
        ]
    });
};
var MenuCell = function(param) {
    var isPurchasable = param.isPurchasable;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var routerPages = (0,router_useRouter/* useRouter */.tv)().routerPages;
    var list = (0,react.useMemo)(function() {
        return [
            {
                title: t("pointOrders"),
                hidden: !config_config/* config.modules.prepaidPoint */.v.modules.prepaidPoint,
                href: routerPages.PointOrders
            },
            {
                title: t("ticketOrders"),
                hidden: !config_config/* config.modules.gacha */.v.modules.gacha,
                href: routerPages.TicketOrders
            }, 
        ];
    }, [
        routerPages.PointOrders,
        routerPages.TicketOrders,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* CellFrame */.p, {
        sx: {
            pt: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "h6",
                color: "text.secondary",
                sx: {
                    py: 2,
                    px: 5
                },
                children: t("menu")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_List/* default */.Z, {
                sx: {
                    pt: 2
                },
                children: (0,array/* filterHiddenItem */.s)(list).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MenuListItem, {
                        divider: true,
                        title: item.title,
                        href: item.href,
                        sx: {
                            height: {
                                xs: 52,
                                md: 56
                            },
                            bgcolor: "grey.50"
                        },
                        primaryTypographyProps: {
                            variant: "body1"
                        }
                    }, index);
                })
            })
        ]
    });
};
var Point = function(param) {
    var point = param.point, loading = param.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            sx: {
                mt: 1,
                mb: 4
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Point, {
                    fontSize: "large"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    sx: {
                        ml: 2,
                        minHeight: 36,
                        minWidth: 36
                    },
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Fade, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.EmphasizedNumber, {
                            variant: "h1",
                            align: "center",
                            children: loading ? null : point ? point : 0
                        })
                    })
                })
            ]
        })
    });
};
var Ticket = function(param) {
    var ticket = param.ticket, loading = param.loading, gachaTicket = param.gachaTicket;
    var ref, ref1;
    return /*#__PURE__*/ _jsx(CellFrame, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            direction: "row",
            sx: {
                mt: 1
            },
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(GachaTicketThumbnail, {
                    src: (gachaTicket === null || gachaTicket === void 0 ? void 0 : (ref = gachaTicket.thumbnails) === null || ref === void 0 ? void 0 : (ref1 = ref.standard) === null || ref1 === void 0 ? void 0 : ref1.smallUri) || ""
                }),
                /*#__PURE__*/ _jsx(Box, {
                    sx: {
                        ml: 2,
                        minHeight: 36,
                        minWidth: 36
                    },
                    children: loading ? /*#__PURE__*/ _jsx(Box, {}) : /*#__PURE__*/ _jsx(Fade, {
                        children: /*#__PURE__*/ _jsx(EmphasizedNumber, {
                            variant: "h1",
                            align: "center",
                            children: loading ? null : ticket ? ticket : 0
                        })
                    })
                })
            ]
        })
    });
};
var Wallet_template_WalletConnectCell = function(param) {
    var cryptoWallet = param.cryptoWallet, onOpenWallet = param.onOpenWallet;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            sx: {
                py: 5,
                borderRadius: 2,
                backgroundColor: "grey.50"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    sx: {
                        mb: 3
                    },
                    children: t("connectWallet")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MetamaskAccountIcon, {
                    walletAddress: cryptoWallet.walletAddress || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "subtitle1",
                    sx: {
                        mb: 1
                    },
                    children: cryptoWallet.displayName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletAddress, {
                    cryptoWalletAddress: cryptoWallet.walletAddress
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        my: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoWalletBalance, {
                        cryptoWalletBalance: cryptoWallet.balance
                    })
                }),
                cryptoWallet.walletType === utoniq_core_schema/* CryptoWalletType.Web3auth */.dwW.Web3auth && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: onOpenWallet,
                    children: t("openCryptoWallet")
                })
            ]
        })
    });
};
var template_WalletNotConnectedCell = function(param) {
    var onConnectWallet = param.onConnectWallet;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CellFrame */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            sx: {
                py: 5,
                borderRadius: 2,
                backgroundColor: "grey.50"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "h6",
                    color: "text.secondary",
                    sx: {
                        mb: 3
                    },
                    children: t("connectWallet")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    sx: {
                        px: 7,
                        mb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                            color: "warning",
                            sx: {
                                mr: 2
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                            variant: "caption",
                            children: t("connectWalletDescription")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: onConnectWallet,
                    children: t("connect")
                })
            ]
        })
    });
};
var PasswordRequireModal = function(param) {
    var open = param.open, onClose = param.onClose, onClick = param.onClick;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var zIndex = (0,useTheme/* default */.Z)().zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: t("passwordRequireModalTitle"),
        content: t("passwordRequireModalContent"),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            size: "large",
            sx: {
                width: 212
            },
            onClick: onClick,
            children: t("toSetting")
        }),
        cancelText: t("close"),
        sx: {
            zIndex: zIndex.modal + 2
        }
    });
};

;// CONCATENATED MODULE: ./src/components/pages/Wallet/viewModel.ts



function Wallet_viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Wallet($gachaTicketId: ID!) {\n    user {\n      id\n      displayName\n      gachaTicket(id: $gachaTicketId) {\n        available\n        formattedAvailable @client\n      }\n      cryptoWallet {\n        address\n        walletType\n      }\n    }\n    prepaidPointBalance {\n      balance\n      formattedPrepaidPointBarance @client\n    }\n    gachaTicket(id: $gachaTicketId) {\n      ...GachaTicketConnection\n    }\n  }\n  ",
        "\n"
    ]);
    Wallet_viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Wallet_viewModel_useViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var user = (0,auth/* useCurrentUser */.xJ)().user;
    var linkEmail = (0,auth/* useAuth */.aC)().linkEmail;
    var deviceInfo = (0,device/* useDeviceInfo */.u)().deviceInfo;
    var t = (0,core_i18n/* useTranslation */.$G)("wallet").t;
    var ref7 = (0,react.useState)(""), balance = ref7[0], setBalance = ref7[1];
    var ref8 = (0,useQuery/* useQuery */.aM)(Wallet_viewModel_QUERY, {
        variables: {
            gachaTicketId: "organization:".concat(config_config/* config.organizationId */.v.organizationId)
        }
    }), data = ref8.data, loading = ref8.loading, refetch = ref8.refetch;
    var walletAddress = data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref1 = ref.cryptoWallet) === null || ref1 === void 0 ? void 0 : ref1.address;
    var userAuthorizeWalletBySignatureMessage = useMetamask().userAuthorizeWalletBySignatureMessage;
    var web3authWalletLoading = useWeb3authWalletConnect({
        loading: loading,
        walletAddress: walletAddress,
        isArtist: false,
        refetch: refetch
    }).web3authWalletLoading;
    (0,react.useEffect)(function() {
        if (!config_config/* config.modules.nft */.v.modules.nft || !walletAddress) return;
        var t = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var balance;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getBalance(walletAddress)
                            ];
                        case 1:
                            balance = _state.sent();
                            setBalance(balance);
                            return [
                                2
                            ];
                    }
                });
            });
            return function t() {
                return _ref.apply(this, arguments);
            };
        }();
        t();
    }, [
        walletAddress
    ]);
    var _formattedPrepaidPointBarance, ref9, ref10, ref11, ref12;
    return {
        state: {
            loading: loading || web3authWalletLoading,
            user: user,
            pointBalance: (_formattedPrepaidPointBarance = data === null || data === void 0 ? void 0 : data.prepaidPointBalance.formattedPrepaidPointBarance) !== null && _formattedPrepaidPointBarance !== void 0 ? _formattedPrepaidPointBarance : null,
            ticket: (ref9 = data === null || data === void 0 ? void 0 : (ref2 = data.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.gachaTicket) === null || ref3 === void 0 ? void 0 : ref3.formattedAvailable) !== null && ref9 !== void 0 ? ref9 : null,
            gachaTicket: (ref10 = data === null || data === void 0 ? void 0 : data.gachaTicket) !== null && ref10 !== void 0 ? ref10 : null,
            cryptoWallet: {
                displayName: (ref11 = data === null || data === void 0 ? void 0 : (ref4 = data.user) === null || ref4 === void 0 ? void 0 : ref4.displayName) !== null && ref11 !== void 0 ? ref11 : null,
                walletAddress: walletAddress !== null && walletAddress !== void 0 ? walletAddress : null,
                balance: balance,
                walletType: (ref12 = data === null || data === void 0 ? void 0 : (ref5 = data.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cryptoWallet) === null || ref6 === void 0 ? void 0 : ref6.walletType) !== null && ref12 !== void 0 ? ref12 : null
            }
        },
        actions: {
            connectMetamask: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                userAuthorizeWalletBySignatureMessage()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                refetch()
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            connectToWeb3auth: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var idToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,auth/* getAccessToken */.hP)({
                                    forceUpdateToken: true
                                })
                            ];
                        case 1:
                            idToken = _state.sent();
                            if (!idToken) throw new Error("get jwtToke failed");
                            /**
         * web3auth <=> firebase auth連携
         */ return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.connectToWeb3Auth(idToken);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            openTorusWallet: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                var idToken;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,auth/* getAccessToken */.hP)({
                                    forceUpdateToken: true
                                })
                            ];
                        case 1:
                            idToken = _state.sent();
                            if (!idToken) throw new Error("get jwtToke failed");
                            return [
                                4,
                                Promise.all(/* import() */[__webpack_require__.e(2182), __webpack_require__.e(7713), __webpack_require__.e(9535)]).then(__webpack_require__.bind(__webpack_require__, 45275)).then(function(m) {
                                    return m.openTorusWallet(idToken);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            onSubmitPasswordSetting: function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
                    var password;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        password = param.password;
                        if (!(user === null || user === void 0 ? void 0 : user.email)) throw new Error(t("unregisteredEmail"));
                        /**
         * @description
         * iOS16ではブラウザでOAuth連携できないため、エラーを表示する
         * https://github.com/firebase/firebase-js-sdk/issues/6716
         */ if ((deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.operatingSystem) === "ios" && Number(deviceInfo.webViewVersion) >= 16.1) {
                            throw new Error(t("iOSOAuthMessage", {
                                ns: "integrations"
                            }));
                        }
                        return [
                            2,
                            linkEmail(user.email, password)
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }
    };
});
var Wallet_viewModel_QUERY = (0,lib/* gql */.Ps)(Wallet_viewModel_templateObject(), utoniq_core_schema/* GachaTicketConnectionFragmentDoc */.mCK);

;// CONCATENATED MODULE: ./src/components/pages/Wallet/index.tsx




var Wallet = function() {
    var ref = Wallet_viewModel_useViewModel(), state = ref.state, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletTemplate, (0,src_object_spread/* default */.Z)({
        state: state
    }, actions));
};

;// CONCATENATED MODULE: ./src/components/pages/index.tsx



















































































































































































































































/***/ }),

/***/ 80042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W2": function() { return /* binding */ styles; },
/* harmony export */   "k$": function() { return /* binding */ styleSets; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);




var dark = _config__WEBPACK_IMPORTED_MODULE_0__/* .config.theme.dark */ .v.theme.dark;
var styles = {
    safeAreaTop: "env(safe-area-inset-top, 0)",
    safeAreaBottom: "env(safe-area-inset-bottom, 0)",
    negativeSafeAreaTop: "calc(-1 * env(safe-area-inset-top, 0))"
};
var styleSets = {
    /**
   * 指定した要素いっぱいに画像を表示し、下部から上方向へ背景色のグラデーションをかけるスタイル（バナー等で使用）
   * @param src 表示する画像URL
   * @param start グラデーションの始点が上から何%の位置にあるか。
   * @param bgcolor background color
   */ backgroundImageWithGradient: function(src) {
        var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, bgcolor = arguments.length > 2 ? arguments[2] : void 0;
        return {
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundImage: "linear-gradient(to bottom, rgba(".concat(dark ? "0,0,0" : "255,255,255", ",0) ").concat(start, "%, ").concat(bgcolor ? bgcolor : dark ? "#121212" : "#ffffff", ' 100%), url("').concat(src !== null && src !== void 0 ? src : "", '")')
        };
    },
    /**
   * Render an ellipsis "..." to represent the clipped text
   * @param lines number of lines
   */ lineCamp: function(lines) {
        if (lines === 1) {
            return {
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap"
            };
        }
        return {
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "-webkit-box",
            // allows limiting of the contents of a block container to the specified number of lines
            // -Although it is a webkit prefix, it works with chrome etc. because it is implemented with the same name in rendering engines other than safari.
            WebkitLineClamp: "".concat(lines),
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal"
        };
    },
    // portrait phones, less than 375px
    extraExtraSmallMedia: function extraExtraSmallMedia(sx) {
        return {
            "@media only screen and (max-width: 375px)": sx
        };
    },
    /**
   * 横幅いっぱいに表示する背景画像の高さを返す
   * GlobalHome等で用いる
   * @param ratio 画像の縦横比
   * @param maxWidth 背景画像の最大横幅。指定しない場合は画面のブレークポイントでのみリサイズ、指定すると画面横幅の変動に応じて最大横幅までリサイズする。
   */ bgImageHeight: function bgImageHeight(ratio, maxWidth, responsive) {
        if (!responsive) {
            return {
                xs: "calc(100vw * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")"),
                sm: "calc(600px * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")")
            };
        } else {
            return {
                xs: "calc(100vw * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")"),
                sm: maxWidth && maxWidth > 600 ? "calc(100vw * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")") : "calc(600px * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")"),
                md: maxWidth && maxWidth > 1120 ? "calc(100vw * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")") : "calc(1120px * ".concat(ratio !== null && ratio !== void 0 ? ratio : 1, ")")
            };
        }
    },
    /**
   * 縦横のスクロールバーを非表示にする
   */ hideScrollbar: function hideScrollbar() {
        return {
            scrollbarWidth: "none",
            "::-webkit-scrollbar": {
                height: 0,
                width: 0,
                display: "none",
                MozAppearance: "none",
                WebkitAppearance: "none"
            }
        };
    }
};


/***/ }),

/***/ 89693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ makeViewModel; }
/* harmony export */ });
/**
 * Function that makes view model.
 * This function constrains page components to separate into state and action logic.
 *
 * ```ts
 *
 * export const viewModel = makeViewModel({
 *   useState(defaultState) {
 *     // write state logic here
 *
 *
 *    // return state on a page
 *    return {
 *    }
 *   },
 *   useAction(state) {
 *    // write action logic here
 *
 *     // return actions.
 *     return {
 *       updateProfile: mutate
 *     }
 *   }
 * })
 *
 * ```
 *
 * then Use view model on page component.
 *
 * const SamplePage: Page = () => {
 *   const state = viewModel.useState({})
 *   const { updateProfile } = viewModel.useAction(state)
 * }
 */ var makeViewModel = function(callback) {
    return function() {
        var ref = callback(), state = ref.state, actions = ref.actions;
        return {
            state: state,
            actions: actions
        };
    };
};


/***/ }),

/***/ 60705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useLoginModal; },
/* harmony export */   "U": function() { return /* binding */ LoginModalProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _lib_errorHandler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91386);






var Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({});
function useLoginModal() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(Context);
}
var LoginModalProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var showModal = function() {
        setOpen(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Context.Provider, {
        value: {
            showModal: showModal
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginModal, {
                open: open,
                onClose: function() {
                    return setOpen(false);
                }
            })
        ]
    });
};
var LoginModal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(__webpack_require__.e(/* import() */ 8058).then(__webpack_require__.bind(__webpack_require__, 18058)).then(function(m) {
    return m.LoginModal;
}).catch(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_lib_errorHandler__WEBPACK_IMPORTED_MODULE_5__/* .handleChunkLoadError */ .Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18058)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 11534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ generateCreditCardLogoPath; }
/* harmony export */ });
var generateCreditCardLogoPath = function(brand) {
    if (!brand) return "";
    // パスカルケースのブランド名の形式に正規化するマッパー
    // ブランドが増えたらここに追加する
    var brandMap = {
        americanexpress: "AmericanExpress",
        amex: "AmericanExpress",
        jcb: "JCB",
        mastercard: "MasterCard",
        visa: "Visa"
    };
    // 入力値を正規化（小文字化＆スペース・アンダースコア削除）
    var normalizedBrand = brand.toLowerCase().replace(/[\s_]+/g, "");
    // 事前定義されたブランドならマッピング、それ以外はそのまま
    var pascalCaseBrand = brandMap[normalizedBrand] || brand;
    return "images/creditcard/".concat(pascalCaseBrand.replace(/\s+/g, ""), "_logo.png");
};


/***/ }),

/***/ 85362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ individualOmitDeliveryStatusUnapplied; },
/* harmony export */   "Bd": function() { return /* binding */ individualHideWallet; },
/* harmony export */   "DG": function() { return /* binding */ individualHideItemIssuedNumber; },
/* harmony export */   "DV": function() { return /* binding */ individualUseFullNameKatakana; },
/* harmony export */   "Ek": function() { return /* binding */ individualHiddenItemInfo; },
/* harmony export */   "H9": function() { return /* binding */ individualHideArtistNewPosts; },
/* harmony export */   "IG": function() { return /* binding */ individualShowStory; },
/* harmony export */   "Jp": function() { return /* binding */ individualHideFeed; },
/* harmony export */   "Lz": function() { return /* binding */ individualHideTutorialSkip; },
/* harmony export */   "Mq": function() { return /* binding */ individualHideStoreItemInfo; },
/* harmony export */   "N1": function() { return /* binding */ individualShowHtmlFormRelay; },
/* harmony export */   "QV": function() { return /* binding */ individualHideDelivery; },
/* harmony export */   "Qx": function() { return /* binding */ individualRemainingItemCountBySKU; },
/* harmony export */   "SH": function() { return /* binding */ individualHideTwitterAuth; },
/* harmony export */   "f0": function() { return /* binding */ individualDisplayResponsive; },
/* harmony export */   "ii": function() { return /* binding */ individualHideArtists; },
/* harmony export */   "jv": function() { return /* binding */ individualHideInquiry; },
/* harmony export */   "lb": function() { return /* binding */ individualHideStoreSupplementLink; },
/* harmony export */   "mn": function() { return /* binding */ individualFilterBannedUserPostComment; },
/* harmony export */   "nm": function() { return /* binding */ individualHideGachaRemainingItemCount; },
/* harmony export */   "qY": function() { return /* binding */ individualHideHelp; }
/* harmony export */ });
/* unused harmony export individualHideArtistTopGradientMask */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);
/**
 * @description
 * 特定のアプリケーションでの特別対応処理をまとめたもの
 */ 


/**
 * @description
 * OAuthクライアント制限のため、RESERVED_CLIENT_IDが取得できないアプリはTwitter認証を非表示にする
 * https://app.clickup.com/t/864egmuz3
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideTwitterAuth = function() {
    var TARGET_APPLICATION_KEYS = [
        "diica",
        "ndp",
        "kanonshizaki",
        "kowacomi",
        "rocomacoaco",
        "liella",
        "liyuu",
        "kiramune",
        "starrise",
        "waipoke",
        "playdeck",
        "aqours", 
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ポスト詳細のコメント一覧から、特定のユーザーのコメントを除外する
 * @param {Maybe<PostDetailQuery['post']>} post ポスト詳細のデータ
 * @returns {Maybe<PostDetailQuery['post']>} コメントフィルタリング後のポスト詳細のデータ
 * cf
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=2508-56289&t=4X9KSOYM0lNd7t3M-1
 */ var individualFilterBannedUserPostComment = function(post) {
    var ref, ref1;
    if (!(post === null || post === void 0 ? void 0 : post.replies)) return post;
    var TARGET_USER_IDS = [
        "mMdsjMWaciQIxHgPvG0nZBDiwGl1"
    ];
    var ref2;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, post), {
        replies: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, post === null || post === void 0 ? void 0 : post.replies), {
            edges: post === null || post === void 0 ? void 0 : (ref = post.replies) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
                var node = param.node;
                var ref;
                return !TARGET_USER_IDS.includes((ref2 = node === null || node === void 0 ? void 0 : (ref = node.responder) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : "");
            })
        })
    });
};
/**
 * アイテム詳細ページの補足リンク領域にて、一部アプリでアイテム「情報」ページ導線の非表示フラグをONにする
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 * cf SupplementLinkArea
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=3885-91376&t=4X9KSOYM0lNd7t3M-1
 */ var individualHiddenItemInfo = function() {
    var TARGET_APPLICATION_KEYS = [
        "omenz"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ユーザーが保有しているアイテムの発行数を非表示にする
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 *
 * cf
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=2628-55046&t=4X9KSOYM0lNd7t3M-1
 */ var individualHideItemIssuedNumber = function() {
    var TARGET_APPLICATION_KEYS = [
        "omenz"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * 一部アプリのガチャページにおいて、在庫数・アイテム発行数を非表示にする
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 * cf
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=9916-193363&t=4X9KSOYM0lNd7t3M-1
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=180-22&t=4X9KSOYM0lNd7t3M-1
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=9916-193152&t=4X9KSOYM0lNd7t3M-1
 * https://www.figma.com/design/N0P35PTdaWpdnUY2ZFJbcA/App-Design?node-id=9916-194000&t=4X9KSOYM0lNd7t3M-1
 */ var individualHideGachaRemainingItemCount = function() {
    var TARGET_APPLICATION_KEYS = [
        "liella",
        "kiramune",
        "liyuu",
        "omenz",
        "waipoke",
        "aqours",
        "machizero",
        "lana",
        "diica", 
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * アイテム編集画面でSKU毎の残数を表示するかどうかのフラグ
 * パフォーマンスのため、アサイーのみ表示する
 *
 * @return {Boolean} true: 表示する, false: 表示しない
 */ var individualRemainingItemCountBySKU = function() {
    var TARGET_APPLICATION_KEYS = [
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * 氏名をカタカナで入力させるかどうかの判定
 * アサイーなど、現場で用いるアプリケーションでは氏名をカタカナで入力させる
 *
 * @return {Boolean} true: カタカナで入力させる, false: カタカナで入力させない
 */ var individualUseFullNameKatakana = function() {
    var TARGET_APPLICATION_KEYS = [
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * チュートリアルのスキップ導線を非表示にするかどうかの判定
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideTutorialSkip = function() {
    var TARGET_APPLICATION_KEYS = [
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ストア詳細ページのシェアボタン・情報の導線を非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideStoreSupplementLink = function() {
    var TARGET_APPLICATION_KEYS = [
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ストア詳細ページのアイテム情報の欄(種別・発行数・所有枚数)の表示をOFFにする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideStoreItemInfo = function() {
    var TARGET_APPLICATION_KEYS = [
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * アーティストトップのグラデーションマスクの表示をOFFにする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideArtistTopGradientMask = function() {
    var TARGET_APPLICATION_KEYS = [
        "yokohamameguri",
        "iloveacai"
    ];
    return TARGET_APPLICATION_KEYS.includes(config.applicationKey);
};
/**
 * アーティストトップの新着ポスト表示をOFFにする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideArtistNewPosts = function() {
    var TARGET_APPLICATION_KEYS = [
        "lana",
        "standalone_stg"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ウォレットを非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideWallet = function() {
    var TARGET_APPLICATION_KEYS = [
        "playdeck"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * 配送を非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideDelivery = function() {
    var TARGET_APPLICATION_KEYS = [
        "playdeck"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * グローバルホームでフィードを非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideFeed = function() {
    var TARGET_APPLICATION_KEYS = [
        "machizero"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * グローバルホームでアーティストを非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideArtists = function() {
    var TARGET_APPLICATION_KEYS = [
        "machizero"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * 配送ステータス「未申請」を設けない
 * 配送管理画面の初期表示タブに影響する
 *
 * @return {Boolean} true: 「未申請」を設けない, false: 「未申請」を設ける
 */ var individualOmitDeliveryStatusUnapplied = function() {
    var TARGET_APPLICATION_KEYS = [
        "machizero"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * レスポンシブ表示を行うかどうか
 *
 * 2025/08/04時点
 * 2025年6月に対応したレスポンシブ対応で再検討が必要な部分があり、一部のサイトを除いて展開できない。
 * ブランチの統合に伴い、展開する必要のあるサイトのみレスポンシブ表示を行うよう、個別分岐を設ける。
 * レスポンシブ対応の再検討が終わり、全サイトに展開できるようになったら除外する。
 *
 * @return {Boolean} true: レスポンシブ表示対象, false: レスポンシブ表示対象外
 */ var individualDisplayResponsive = function() {
    var TARGET_APPLICATION_KEYS = [
        "jonishirei",
        "jonishirei-stg",
        "abarerukun",
        "abarerukun-stg",
        "yt-unaverage",
        "yt-unaverage-stg",
        "lana",
        "lana-stg",
        "standalone_stg",
        "kyra",
        "kyra-stg", 
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ご利用ガイドを非表示にする
 *
 * ご利用ガイドを個別に作成しているサイトは標準のご利用ガイドを非表示にする
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideHelp = function() {
    var TARGET_APPLICATION_KEYS = [
        "yt-unaverage",
        "yt-unaverage-stg",
        "etoneigefc",
        "etoneigefc-stg",
        "kyra",
        "kyra-stg", 
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * お問い合わせフォームを非表示にする
 *
 * 2025年8月時点：お問い合わせの運用負荷を下げるため、問い合わせフローを全体的に見直し中。
 * ここで定義したアプリでは、個別にお問い合わせへの導線を設けるため、見直し完了までは個別に非表示の分岐を作る。
 *
 * @return {Boolean} true: 非表示にする, false: 非表示にしない
 */ var individualHideInquiry = function() {
    var TARGET_APPLICATION_KEYS = [
        "yt-unaverage",
        "yt-unaverage-stg",
        "etoneigefc",
        "etoneigefc-stg",
        "kyra",
        "kyra-stg", 
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * @description
 * 24時間限定公開のストーリー機能を表示するかどうか
 *
 * WAIWAI（Etoneige サイトの顧客）からの要望で開発された、
 * 画像または YouTube 以外の動画ポストを24時間限定で公開する機能の表示制御
 *
 * フィードが表示されるグローバルホームを持たず、
 * ポスト機能も使用しないことを前提とした
 * Etoneige でのみ使用されることを想定している。
 *
 * 2025年8〜9月の開発リソース逼迫により、
 * フィードに関連する functions の動作検証が完了していない状態だが、
 * デリバリーを優先してフィードへの動線がなく直接的な影響が発生しない
 * Etoneige でのみ展開することとなった。
 *
 * 本機能は ⚠️ Etoneige 以外には展開しない ⚠️ こと。
 * 現状のコードはフィード表示での正常な動作を担保できていないため、
 * フィード表示がある他サイトに導入した場合、
 * 予期せぬ不具合が発生するリスクがある。
 *
 * Etoneige 以外で本機能を展開する際には、必ず以下の対応を完了させること。
 * ・API による ON/OFF 制御の開発
 * ・フィードに関連する functions の挙動の調査と動作検証
 *
 * @return {Boolean} true: 表示する, false: 表示しない
 */ var individualShowStory = function() {
    var TARGET_APPLICATION_KEYS = [
        "etoneigefc",
        "etoneigefc-stg"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};
/**
 * ネイティブアプリ → WebブラウザへのHTMLフォームのリレーページを表示するかどうか
 *
 * ポスト投稿でチケットぴあなどのルート限定タグを使用する、かつネイティブアプリがある場合は指定を入れる
 *
 * @returns {Boolean} true: 表示する, false: 表示しない
 */ var individualShowHtmlFormRelay = function() {
    var TARGET_APPLICATION_KEYS = [
        "etoneigefc",
        "etoneigefc-stg"
    ];
    return TARGET_APPLICATION_KEYS.includes(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey);
};


/***/ }),

/***/ 17470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ isAvailableLiveStream; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);

/**
 * ライブ配信が可能かどうかを返す
 * ユートニックアプリは原則ライブ配信は非公開だが、特定のアーティストのみ、アーティストIDを以下に指定することで配信を行えるにしている
 * https://app.clickup.com/t/908127/UT-12276
 */ var isAvailableLiveStream = function(artistId) {
    if (!_config__WEBPACK_IMPORTED_MODULE_0__/* .config.modules.liveStream */ .v.modules.liveStream) return false;
    if (_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey !== "utoniq") return true;
    if (!artistId) return false;
    if (_config__WEBPACK_IMPORTED_MODULE_0__/* .config.environment */ .v.environment !== "production") return true;
    return [
        // 江藤彩也香
        "RITUzcsJXSRY3GUotrUhODJzC5k1",
        // 松岡里果
        "d7BCGfNv1PVWQJOeJHMfVv6whJ92",
        // 検証用stgアーティスト
        "G1AT0lhFhBQoE6D34CzsNShtobC2",
        // ウソツキ
        "RDSfDmG1hoXzu0p1cYRg2RNbu3o1", 
    ].includes(artistId);
};


/***/ }),

/***/ 91535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ SettingUserInfoModalProvider; },
  "C": function() { return /* binding */ useSettingUserInfoModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Snackbar/Snackbar.js + 1 modules
var Snackbar = __webpack_require__(89265);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Alert/Alert.js + 4 modules
var Alert = __webpack_require__(701);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
// EXTERNAL MODULE: ./src/config/config.ts
var config = __webpack_require__(90860);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ./src/core/native/storage/index.ts
var storage = __webpack_require__(57782);
;// CONCATENATED MODULE: ./src/components/organisms/membership/NeedSettingPersonalUserSnackbar/useNeedSettingPersonalUserSnackbar.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query NeedSettingPersonalUserSnackbar($id: ID, $skipArtist: Boolean!) {\n    user {\n      id\n      isMembershipPersonalInformationRequired\n    }\n    artist(id: $id) @skip(if: $skipArtist) {\n      id\n      patron {\n        id\n        isPersonalInformationRequired\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var needSettingPersonalUserSnackbarRef = (0,react.createRef)();
var useNeedSettingPersonalUserSnackbar = function(user) {
    var ref;
    // store the artistId when it is shown
    var showedArtistRef = (0,react.useRef)([]);
    var showedSnackbarOnMyProfile = (0,react.useRef)(false);
    var ref1 = (0,useRouter/* useRouter */.tv)(), location = ref1.location, routerPages = ref1.routerPages;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isRegisterNewMembership = ref3[0], setIsRegisterNewMembership = ref3[1];
    var isMyProfilePage = (0,react.useMemo)(function() {
        return location.pathname === routerPages.MyProfile;
    }, [
        location.pathname
    ]);
    // get artistId from url
    var artistId = (0,react.useMemo)(function() {
        var ref;
        if (config/* config.applicationType */.v.applicationType === "standalone") {
            return config/* config.artistId */.v.artistId;
        }
        // router.query.artistId is undefined because this component is placed outside the Route component of react-router
        var match = (0,react_router/* matchPath */.LX)(location.pathname, {
            path: "/artists/:artistId",
            strict: false
        });
        return match === null || match === void 0 ? void 0 : (ref = match.params) === null || ref === void 0 ? void 0 : ref.artistId;
    }, [
        location.pathname
    ]);
    var skipQuery = (0,react.useMemo)(function() {
        if (!(user === null || user === void 0 ? void 0 : user.uid)) {
            return true;
        }
        if (isMyProfilePage) {
            return false;
        }
        return !artistId;
    }, [
        artistId,
        isMyProfilePage,
        user === null || user === void 0 ? void 0 : user.uid
    ]);
    var data = (0,useQuery/* useQuery */.aM)(QUERY, {
        skip: skipQuery,
        variables: {
            id: artistId,
            skipArtist: !artistId
        },
        onCompleted: function onCompleted(param) {
            var artist = param.artist, _$user = param.user;
            var ref, ref1;
            if ((_$user === null || _$user === void 0 ? void 0 : _$user.isMembershipPersonalInformationRequired) && isMyProfilePage && !showedSnackbarOnMyProfile.current) {
                showedSnackbarOnMyProfile.current = true;
                setOpen(true);
                return;
            }
            if (!artist) {
                return;
            }
            var artistExisted = !!showedArtistRef.current.find(function(artistId) {
                return artistId === artist.id;
            });
            if (!(artist === null || artist === void 0 ? void 0 : (ref = artist.patron) === null || ref === void 0 ? void 0 : ref.isPersonalInformationRequired)) {
                showedArtistRef.current = showedArtistRef.current.filter(function(artistId) {
                    return artistId !== artist.id;
                });
            }
            if ((artist === null || artist === void 0 ? void 0 : (ref1 = artist.patron) === null || ref1 === void 0 ? void 0 : ref1.isPersonalInformationRequired) && !artistExisted) {
                setOpen(true);
                showedArtistRef.current.push(artist.id);
                return;
            }
        }
    }).data;
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,storage/* getRegisterNewMembership */.bs)()
                        ];
                    case 1:
                        setIsRegisterNewMembership.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        open
    ]);
    (0,react.useImperativeHandle)(needSettingPersonalUserSnackbarRef, function() {
        return {
            triggerShowMessage: function triggerShowMessage(isRegisterNewMembership) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (isRegisterNewMembership !== undefined) {
                            setIsRegisterNewMembership(isRegisterNewMembership);
                        }
                        setOpen(true);
                        return [
                            2
                        ];
                    });
                })();
            }
        };
    });
    // お客様情報未入力 → 登録完了した場合はスナックバーを非表示にする
    (0,react.useEffect)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired)) {
            setOpen(false);
        }
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired
    ]);
    return {
        open: open,
        type: !isRegisterNewMembership ? "resume" : "input",
        onClose: function onClose() {
            setOpen(false);
        }
    };
};
var QUERY = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/components/organisms/membership/NeedSettingPersonalUserSnackbar/index.tsx






var NeedSettingPersonalUserSnackbar = function(param) {
    var user = param.user;
    var t = (0,i18n/* useTranslation */.$G)().t;
    var ref = useSettingUserInfoModal(), isOpen = ref.isOpen, showModal = ref.showModal;
    var ref1 = useNeedSettingPersonalUserSnackbar(user), open = ref1.open, type = ref1.type, onClose = ref1.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: open && !isOpen,
        onClose: onClose,
        id: "NeedSettingPersonalUserSnackbar",
        autoHideDuration: 6000,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        sx: {
            bottom: {
                xs: 70,
                md: 70
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            color: "info",
            variant: "filled",
            severity: "success",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Icons.Info, {
                fontSize: "small",
                sx: {
                    color: "white"
                }
            }),
            sx: {
                padding: "6px 16px",
                width: "100%",
                maxWidth: 600 - 32,
                mx: 5,
                ".MuiAlert-message": {
                    width: "100%"
                }
            },
            action: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "inherit",
                size: "small",
                variant: "text",
                onClick: function() {
                    return showModal();
                },
                children: t(type)
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                color: "white",
                children: t(type === "input" ? "needRegistrationCustomerInfo" : "registrationMembershipUncomplete")
            })
        })
    });
};

// EXTERNAL MODULE: ./src/lib/errorHandler/chunkLoadError.ts
var chunkLoadError = __webpack_require__(91386);
// EXTERNAL MODULE: ./src/clients/utoniq-core/schema.ts
var schema = __webpack_require__(66517);
// EXTERNAL MODULE: ./src/core/architecture/ViewModel.ts
var ViewModel = __webpack_require__(89693);
;// CONCATENATED MODULE: ./src/core/membership/viewModel.ts

function viewModel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PersonalInfo {\n    user {\n      ...PersonalInfo\n    }\n  }\n  ",
        "\n"
    ]);
    viewModel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var useMembershipViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var data = (0,useQuery/* useQuery */.aM)(viewModel_QUERY).data;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var isPersonalInfoComplete = function(user) {
        var ref, ref1, ref2, ref3;
        if (!user) return false;
        return !!(user.fullName && user.phoneNumber && user.isPhoneNumberVerified && user.birthday && user.gender && ((ref = user.address) === null || ref === void 0 ? void 0 : ref.postalCode) && ((ref1 = user.address) === null || ref1 === void 0 ? void 0 : ref1.prefecture) && ((ref2 = user.address) === null || ref2 === void 0 ? void 0 : ref2.city) && ((ref3 = user.address) === null || ref3 === void 0 ? void 0 : ref3.line1));
    };
    return {
        state: {
            user: user,
            isPersonalInfoComplete: isPersonalInfoComplete(user)
        },
        actions: {}
    };
});
var viewModel_QUERY = (0,lib/* gql */.Ps)(viewModel_templateObject(), schema/* PersonalInfoFragmentDoc */._ml);

;// CONCATENATED MODULE: ./src/core/membership/useSettingUserInfoModal.tsx










var Context = /*#__PURE__*/ (0,react.createContext)({});
function useSettingUserInfoModal() {
    return (0,react.useContext)(Context);
}
var SettingUserInfoModalProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), isSuccessModalOpen = ref1[0], setSuccessModalOpen = ref1[1];
    var ref2 = (0,react.useState)(), showOptions = ref2[0], setShowOptions = ref2[1];
    var state = useMembershipViewModel().state;
    // 個人情報の状態に基づいてモーダルの初期表示状態を設定
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = state.user) === null || ref === void 0 ? void 0 : ref.isMembershipPersonalInformationRequired) && !state.isPersonalInfoComplete) {
            setOpen(true);
        }
    }, [
        state.user,
        state.isPersonalInfoComplete
    ]);
    var showModal = (0,react.useCallback)(function(options) {
        setOpen(true);
        setShowOptions(options);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Context.Provider, {
        value: {
            showModal: showModal,
            isOpen: open,
            isSuccessModalOpen: isSuccessModalOpen
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipUserInfoModal, {
                open: open,
                onClose: function() {
                    var ref;
                    setOpen(false);
                    showOptions === null || showOptions === void 0 ? void 0 : (ref = showOptions.onClose) === null || ref === void 0 ? void 0 : ref.call(showOptions);
                    if (showOptions === null || showOptions === void 0 ? void 0 : showOptions.showSnackbarWhenClose) {
                        var ref1;
                        (ref1 = needSettingPersonalUserSnackbarRef.current) === null || ref1 === void 0 ? void 0 : ref1.triggerShowMessage(showOptions === null || showOptions === void 0 ? void 0 : showOptions.isRegisterNewMembership);
                    }
                },
                onCompleted: function() {
                    return setOpen(false);
                },
                registerUserInfoSuccessModal: isSuccessModalOpen,
                setRegisterUserInfoSuccessModal: setSuccessModalOpen
            }),
            state.user && /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedSettingPersonalUserSnackbar, {
                user: state.user
            })
        ]
    });
};
var MembershipUserInfoModal = dynamic_default()(config/* config.modules.membership */.v.modules.membership ? __webpack_require__.e(/* import() */ 4529).then(__webpack_require__.bind(__webpack_require__, 44529)).then(function(m) {
    return m.MembershipUserInfoModal;
}).catch(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(error) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,chunkLoadError/* handleChunkLoadError */.Z)(error)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        function() {
                            return null;
                        }
                    ];
            }
        });
    });
    return function(error) {
        return _ref.apply(this, arguments);
    };
}()) : Promise.resolve(function() {
    return null;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44529)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 21657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ SettingMyFavoriteModalProvider; },
  "m": function() { return /* binding */ useSettingMyFavoriteModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(79312);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(43411);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(38677);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
// EXTERNAL MODULE: ../utoniq-ui/dist/index.js
var dist = __webpack_require__(63588);
// EXTERNAL MODULE: ./src/core/i18n/index.ts
var i18n = __webpack_require__(95626);
// EXTERNAL MODULE: ./src/core/membership/useSettingUserInfoModal.tsx + 3 modules
var useSettingUserInfoModal = __webpack_require__(91535);
// EXTERNAL MODULE: ./src/core/router/useRouter.tsx + 1 modules
var useRouter = __webpack_require__(61631);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(85697);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(81548);
// EXTERNAL MODULE: ./src/core/architecture/ViewModel.ts
var ViewModel = __webpack_require__(89693);
;// CONCATENATED MODULE: ./src/core/myFavorite/viewModel.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query requiredFavoriteMember {\n    user {\n      id\n      organizationPatrons {\n        id\n        artistId\n        requiredFavoriteMember\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var useMyFavoriteViewModel = (0,ViewModel/* makeViewModel */.e)(function() {
    var data = (0,useQuery/* useQuery */.aM)(QUERY).data;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var ref = (0,useRouter/* useRouter */.tv)(), routerPages = ref.routerPages, router = ref.router, location = ref.location;
    var isOpen = useSettingMyFavoriteModal().isOpen;
    var isRequiredFavoriteMember = function(user) {
        if (!user) return {
            artistId: "",
            requiredFavoriteMember: false
        };
        var found = user.organizationPatrons.find(function(patron) {
            return patron.requiredFavoriteMember;
        });
        return found !== null && found !== void 0 ? found : {
            artistId: "",
            requiredFavoriteMember: false
        };
    };
    return {
        state: {
            artistId: isRequiredFavoriteMember(user).artistId,
            isRequiredFavoriteMember: isRequiredFavoriteMember(user).requiredFavoriteMember
        },
        actions: {}
    };
});
var QUERY = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/core/myFavorite/useSettingMyFavoriteModal.tsx









var Context = /*#__PURE__*/ (0,react.createContext)({});
function useSettingMyFavoriteModal() {
    return (0,react.useContext)(Context);
}
var SettingMyFavoriteModalProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)({}), showOptions = ref1[0], setShowOptions = ref1[1];
    var state = useMyFavoriteViewModel().state;
    var ref2 = (0,useRouter/* useRouter */.tv)(), routerPages = ref2.routerPages, router = ref2.router;
    var ref3 = (0,useSettingUserInfoModal/* useSettingUserInfoModal */.C)(), isSettingUserInfoModalOpen = ref3.isOpen, isSuccessModalOpen = ref3.isSuccessModalOpen;
    // 推しメンバー設定要否に基づいてモーダルの初期表示状態を設定
    (0,react.useEffect)(function() {
        if (state.isRequiredFavoriteMember && !isSettingUserInfoModalOpen && !isSuccessModalOpen && router.pathname !== routerPages.MyProfile && router.pathname !== routerPages.FavoriteMembersSelect) {
            setShowOptions({
                requiredFavoriteMemberArtistId: state.artistId
            });
            setOpen(true);
        }
    }, [
        state.isRequiredFavoriteMember,
        isSettingUserInfoModalOpen,
        isSuccessModalOpen, 
    ]);
    var showModal = (0,react.useCallback)(function(options) {
        setShowOptions(options);
        setOpen(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Context.Provider, {
        value: {
            showModal: showModal,
            isOpen: open
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingMyFavoriteModal, {
                open: open,
                onClose: function() {
                    setOpen(false);
                    router.push((0,react_router/* generatePath */.Gn)(routerPages.FavoriteMembersSelect, {
                        artistId: showOptions.requiredFavoriteMemberArtistId
                    }));
                    // 都度artistIdをセットするためにリセット
                    setShowOptions({});
                }
            })
        ]
    });
};
var SettingMyFavoriteModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var t = (0,i18n/* useTranslation */.$G)("settingMyFavotite").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.InformationModal, {
        open: open,
        onClose: onClose,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "h5",
            sx: {
                pb: 3
            },
            children: t("title", "推しメンバーが登録されていません")
        }),
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body2",
            sx: {
                px: 5,
                pb: 7
            },
            children: t("description", "メンバーシップ限定コンテンツをお楽しみいただくために必要な項目を入力してください。")
        }),
        buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            spacing: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                sx: {
                    minWidth: 212
                },
                variant: "contained",
                color: "primary",
                size: "large",
                onClick: function() {
                    return onClose();
                },
                children: t("register", "登録する")
            })
        }),
        sx: {
            minWidth: 300
        }
    });
};


/***/ }),

/***/ 23087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ pickImages; },
/* harmony export */   "g": function() { return /* binding */ getImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _capacitor_camera__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68203);




/**
 * @description
 * file or nativeAPIで端末 or カメラで画像を取得する
 * web/ios/android共通で使用できる（@capacitor/cameraを使用）
 *
 * @returns getImage 画像取得・カメラ起動APIを呼び出すメソッド。file形式で画像を返す。
 */ var getImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var accepts, type, image, ref, dataType, base64String, ref1, _, imageType, fileName;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accepts = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [
                        "image/*"
                    ], type = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "Image";
                    return [
                        4,
                        _capacitor_camera__WEBPACK_IMPORTED_MODULE_0__/* .Camera.getPhoto */ .V1.getPhoto({
                            allowEditing: true,
                            resultType: _capacitor_camera__WEBPACK_IMPORTED_MODULE_0__/* .CameraResultType.DataUrl */ .dk.DataUrl,
                            source: _capacitor_camera__WEBPACK_IMPORTED_MODULE_0__/* .CameraSource.Photos */ .oK.Photos
                        })
                    ];
                case 1:
                    image = _state.sent();
                    if (!(image === null || image === void 0 ? void 0 : image.dataUrl)) throw new Error("get photo failed");
                    ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(image.dataUrl.split(";"), 2), dataType = ref[0], base64String = ref[1];
                    ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dataType.split(":"), 2), _ = ref1[0], imageType = ref1[1];
                    if (!accepts.some(function(accept) {
                        return new RegExp(accept, "i").test(imageType);
                    })) throw new Error("uploadError".concat(type, "Only"));
                    fileName = "".concat(Math.random());
                    // convert base64 to File
                    return [
                        2,
                        convert4Base64toFile(base64String.split(",")[1], fileName, image.format)
                    ];
            }
        });
    });
    return function getImage() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description
 * file or nativeAPIで端末 or カメラで画像を取得する
 * web/ios/android共通で使用できる（@capacitor/cameraを使用）
 *
 * @returns pickImages 画像取得・カメラ起動APIを呼び出すメソッド。file形式で画像を返す。
 */ var pickImages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var accepts, limit, images;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accepts = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [
                        "image/*"
                    ], limit = _arguments.length > 1 ? _arguments[1] : void 0;
                    return [
                        4,
                        _capacitor_camera__WEBPACK_IMPORTED_MODULE_0__/* .Camera.pickImages */ .V1.pickImages({
                            limit: limit
                        })
                    ];
                case 1:
                    images = _state.sent();
                    if (!images.photos.length) throw new Error("get photos failed");
                    if (limit && images.photos.length > limit) throw new Error("uploadLimitError");
                    // check image type
                    if (images.photos.every(function(photo) {
                        return !accepts.some(function(accept) {
                            return new RegExp(accept, "i").test("image/".concat(photo.format));
                        });
                    })) {
                        throw new Error("uploadErrorImageOnly");
                    }
                    // convert blob url array to File
                    return [
                        2,
                        Promise.all(images.photos.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(value) {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                convertBlobUrlToFile(value.webPath, // generate random file name
                                                Math.random().toString(), value.format)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(value) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
            }
        });
    });
    return function pickImages() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @description
 * base64からFileへ変換メソッド
 * [Reference] https://qiita.com/ns777/items/24f1a48fd9301ff3dcdb
 *
 * @param base64 base64 URL
 * @param fileName generate file name
 * @param fileType generate file type
 * @returns {File}
 */ var convert4Base64toFile = function convert4Base64toFile(base64, fileName, fileType) {
    // decode base64
    var bin = atob(base64.replace(/^.*,/, ""));
    // to binary
    var buffer = new Uint8Array(bin.length);
    for(var i = 0; i < bin.length; i++){
        buffer[i] = bin.charCodeAt(i);
    }
    // create file object
    return new File([
        buffer.buffer
    ], fileName, {
        type: fileType
    });
};
/**
 * @description
 * convert blobUrl to File
 *
 * @param blobUrl URL
 * @param fileName generate file name
 * @param fileType generate file type
 * @returns {File}
 */ var convertBlobUrlToFile = function(blobUrl, fileName, fileType) {
    return fetch(blobUrl).then(function(res) {
        return res.blob();
    }).then(function(blob) {
        return new File([
            blob
        ], fileName, {
            type: fileType
        });
    });
};


/***/ }),

/***/ 81291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ browserDetect; },
/* harmony export */   "u": function() { return /* binding */ useDeviceInfo; }
/* harmony export */ });
/* harmony import */ var _capacitor_device__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52845);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30226);



var useDeviceInfo = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), deviceInfo = ref1[0], setDeviceInfo = ref1[1];
    var showError = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useMessage */ .UD)().showError;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setLoading(true);
        _capacitor_device__WEBPACK_IMPORTED_MODULE_0__/* .Device.getInfo */ .A.getInfo().then(function(r) {
            return setDeviceInfo(r);
        }).catch(function(e) {
            return showError(e);
        }).finally(function() {
            return setLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        loading: loading,
        deviceInfo: deviceInfo
    };
};
/**
 * @description detect browser name by user agent.
 */ function browserDetect() {
    var userAgent = navigator.userAgent;
    if (userAgent.match(/chrome|chromium|crios/i)) {
        return "Chrome";
    }
    if (userAgent.match(/firefox|fxios/i)) {
        return "Firefox";
    }
    if (userAgent.match(/safari/i)) {
        return "Safari";
    }
    if (userAgent.match(/opr\//i)) {
        return "Opera";
    }
    if (userAgent.match(/edg/i)) {
        return "Edge";
    }
    return null;
}


/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ disablePrivacyScreen; },
/* harmony export */   "a": function() { return /* binding */ enablePrivacyScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _capacitor_community_privacy_screen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57894);
/* harmony import */ var _core_native__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76250);




var enablePrivacyScreen = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (_core_native__WEBPACK_IMPORTED_MODULE_3__/* .getPlatform */ .Xf() === "web") return [
                        2
                    ];
                    return [
                        4,
                        _capacitor_community_privacy_screen__WEBPACK_IMPORTED_MODULE_0__/* .PrivacyScreen.enable */ .J.enable()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function enablePrivacyScreen() {
        return _ref.apply(this, arguments);
    };
}();
var disablePrivacyScreen = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (_core_native__WEBPACK_IMPORTED_MODULE_3__/* .getPlatform */ .Xf() === "web") return [
                        2
                    ];
                    return [
                        4,
                        _capacitor_community_privacy_screen__WEBPACK_IMPORTED_MODULE_0__/* .PrivacyScreen.disable */ .J.disable()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function disablePrivacyScreen() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 47440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ share; }
/* harmony export */ });
/* harmony import */ var _capacitor_share__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8959);
/* harmony import */ var share_api_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69170);
/* harmony import */ var share_api_polyfill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(share_api_polyfill__WEBPACK_IMPORTED_MODULE_1__);

/**
 * @description
 * WebShareAPIはブラウザによって非対応（PC Chrome等）なのでpolyfillを入れて対応
 * https://wp-kyoto.net/use-webshare-api-with-polyfil-and-capacitor/
 */ 
var share = function(opt) {
    return _capacitor_share__WEBPACK_IMPORTED_MODULE_0__/* .Share.share */ .m.share(opt).catch(function(e) {
        /**
     * @description
     * ネイティブでのシェア取り消しなど、ユーザー動作起因のキャンセルの場合エラーは投げない
     */ if (e.message === "Share canceled" || e.message === "Abort due to cancellation of share.") return;
        throw e;
    });
};


/***/ }),

/***/ 83587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ StorageImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63588);
/* harmony import */ var utoniq_ui__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90860);






/**
 * @description
 * Cloud StorageのURLを参照するImageコンポーネント
 *
 * @param target
 * URLの参照先を指定する
 * appの場合はアプリ毎ディレクトリを
 * commonの場合は共通ディレクトリを参照する
 * cf ) https://app.clickup.com/908127/v/dc/vpuz-82/vpuz-7325
 */ var StorageImage = function(_param) {
    var _target = _param.target, target = _target === void 0 ? "app" : _target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "target"
    ]);
    var storageUrl = target === "app" ? _config__WEBPACK_IMPORTED_MODULE_3__/* .config.appStorageUrl */ .v.appStorageUrl : _config__WEBPACK_IMPORTED_MODULE_3__/* .config.commonStorageUrl */ .v.commonStorageUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utoniq_ui__WEBPACK_IMPORTED_MODULE_1__.Image, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        src: new URL(props.src || "", storageUrl).href
    }));
};


/***/ }),

/***/ 42109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ initTheoPlayer; },
/* harmony export */   "W": function() { return /* binding */ useDRMPlayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(919);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90860);
/* harmony import */ var _core_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16083);
/* harmony import */ var _core_errors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83342);
/* harmony import */ var _core_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95626);
/* harmony import */ var _core_messages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30226);







var license = _config__WEBPACK_IMPORTED_MODULE_2__/* .config.theoPlayerLicenseKey */ .v.theoPlayerLicenseKey;
var libraryLocation = _config__WEBPACK_IMPORTED_MODULE_2__/* .config.theoPlayerLibraryLocation */ .v.theoPlayerLibraryLocation;
var functionsEndpoint = _config__WEBPACK_IMPORTED_MODULE_2__/* .config.functionsEndpoint */ .v.functionsEndpoint;
var useDRMPlayer = function(param) {
    var _source = param.source, dashUri = _source.dashUri, hlsUri = _source.hlsUri, _onPlay = param.onPlay, onPlay = _onPlay === void 0 ? function() {} : _onPlay, _opts = param.opts, opts = _opts === void 0 ? {
        chromeless: false,
        mutedAutoplay: "none"
    } : _opts, _isMagazine = param.isMagazine, isMagazine = _isMagazine === void 0 ? false : _isMagazine;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), player = ref1[0], setPlayer = ref1[1];
    var accessToken = (0,_core_auth__WEBPACK_IMPORTED_MODULE_3__/* .useAccessToken */ .Gu)().accessToken;
    var status = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_1__/* .useScript */ .Gq)(libraryLocation + "/THEOplayer.js");
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), currentTime = ref2[0], setCurrentTime = ref2[1];
    var showError = (0,_core_messages__WEBPACK_IMPORTED_MODULE_4__/* .useMessage */ .UD)().showError;
    var t = (0,_core_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!(ref.current && status === "ready" && accessToken)) return function() {};
        var player = initTheoPlayer(ref, opts);
        if (!player) return function() {};
        player.source = {
            sources: [
                {
                    src: dashUri,
                    type: "application/dash+xml",
                    contentProtection: {
                        playready: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/playready"),
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        },
                        widevine: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/widevine"),
                            headers: {
                                "Content-Type": "application/octet-stream",
                                Accept: "application/octet-stream",
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        }
                    }
                },
                {
                    src: hlsUri,
                    type: "application/x-mpegURL",
                    contentProtection: {
                        fairplay: {
                            licenseAcquisitionURL: "".concat(functionsEndpoint, "/drm/fairplay"),
                            certificateURL: _config__WEBPACK_IMPORTED_MODULE_2__/* .config.fairplayCertificateUrl */ .v.fairplayCertificateUrl,
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        }
                    }
                }, 
            ]
        };
        //hidden play icon on android
        var videoElement = player.element.querySelector("video:not([src])");
        videoElement === null || videoElement === void 0 ? void 0 : videoElement.setAttribute("poster", "noposter");
        if (opts.mutedAutoplay === "all") {
            player.autoplay = true;
        }
        player.addEventListener("play", onPlay);
        player.addEventListener("timeupdate", function(e) {
            return setCurrentTime(e.currentTime);
        });
        player === null || player === void 0 ? void 0 : player.addEventListener("error", function(e) {
            (0,_core_errors__WEBPACK_IMPORTED_MODULE_6__/* .captureError */ .O)(e, "useDRMPlayer");
            showError(t("theoPlayerError"));
        });
        player.addEventListener("ended", function() {
            // マガジンアイテムの場合はcurrentTimeを0に戻さない
            if (!isMagazine) {
                setCurrentTime(0);
            }
            player.pause();
        });
        setPlayer(player);
        return player.destroy;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref.current,
        status,
        accessToken
    ]);
    return {
        player: player,
        currentTime: currentTime,
        ref: ref,
        accessToken: accessToken
    };
};
/**
 * プレイヤーの初期化
 */ function initTheoPlayer(ref, param) {
    var chromeless = param.chromeless, mutedAutoplay = param.mutedAutoplay;
    if ( false || !window.THEOplayer) return null;
    var Player = chromeless ? window.THEOplayer.ChromelessPlayer : window.THEOplayer.Player;
    if (ref.current) {
        return new Player(ref.current, {
            license: license,
            libraryLocation: libraryLocation,
            mutedAutoplay: mutedAutoplay
        });
    }
    return null;
}


/***/ }),

/***/ 47536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useSoundPlayer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _core_resources__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31986);




/**
 * 音声プレイヤーを扱うためのカスタムフック

  @param {string} uri 再生したいリソースのURL

  @description
  フックの戻り値をReactPlayerコンポーネントおよびSoundPlayerControlに渡すことでオーディオ再生を行うことができる。
 *
 * -- ReactPlayerに注入する --
 * @returns player uriの音声を再生するaudioタグのref値
 * @returns playing プレイヤーが現在再生しているかどうか。SoundPlayerControlにも使用する
 * @returns duration 音声リソースの再生時間
 * @returns isUriUnavailable エラーでリソースが再生できない場合true
 * @returns sliderValue スライダーUIの現在の再生位置
 * @returns handleDuration リソースの再生時間を取得する際のコールバック。再生時間をプレイヤーに表示するのに用いる。
 * @returns handleProgress 再生が進む毎に呼び出される処理
 * @returns handleError エラーが起きた際の処理
 *
 * -- SoundPlayerControlに注入する --
 * @returns play 音声を再生するメソッド
 * @returns pause 音声を停止するメソッド
 * @returns change スライダーのホイールを動かしているときの処理
 * @returns commitChange スライダーのホイールを離したときの処理
 * @returns rewind 巻き戻しボタンを押した時の処理
 * @returns forward 早送りボタンを押した時の処理
 */ function useSoundPlayer(uri) {
    var ref = (0,_core_resources__WEBPACK_IMPORTED_MODULE_1__/* .usePlayingResource */ .p)(), playingResource = ref.playingResource, playResource = ref.playResource, pauseResource = ref.pauseResource;
    var player = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        isUriUnavailable: false,
        duration: 0,
        isPlaying: false,
        progress: 0,
        isSeeking: false,
        valueWhileSeeking: 0
    }), state = ref1[0], setState = ref1[1];
    var mergeState = function(obj) {
        return setState(function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state, obj);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref, ref1, ref2;
        (ref1 = (ref = player.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer()) === null || ref1 === void 0 ? void 0 : ref1.load();
        mergeState({
            duration: (ref2 = player.current) === null || ref2 === void 0 ? void 0 : ref2.getDuration()
        });
        mergeState({
            isUriUnavailable: false
        });
    }, [
        player
    ]);
    return {
        player: player,
        playing: state.isPlaying && playingResource === uri,
        duration: state.duration,
        isUriUnavailable: state.isUriUnavailable,
        sliderValue: state.isSeeking ? state.valueWhileSeeking : state.progress,
        handleDuration: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(duration) {
            mergeState({
                duration: duration
            });
        }, []),
        handleProgress: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
            var progress = param.playedSeconds;
            mergeState({
                progress: progress
            });
        }, []),
        handleError: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            // const mediaError = err?.target?.error
            mergeState({
                isUriUnavailable: true
            });
        }, []),
        play: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    isPlaying: true
                });
            });
            playResource(uri);
        }, [
            playResource,
            uri
        ]),
        pause: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    isPlaying: false
                });
            });
            pauseResource();
        }, [
            pauseResource
        ]),
        change: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(_, value) {
            mergeState({
                isSeeking: true,
                valueWhileSeeking: value
            });
        }, []),
        commitChange: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(_, value) {
            var ref;
            mergeState({
                progress: value,
                valueWhileSeeking: 0,
                isSeeking: false
            });
            (ref = player.current) === null || ref === void 0 ? void 0 : ref.seekTo(value, "seconds");
        }, []),
        rewind: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            if (player && player.current) {
                var ref, ref1;
                var newTime = Math.max(((ref = player.current) === null || ref === void 0 ? void 0 : ref.getCurrentTime()) - 10, 0);
                mergeState({
                    progress: newTime
                });
                (ref1 = player.current) === null || ref1 === void 0 ? void 0 : ref1.seekTo(newTime, "seconds");
            }
        }, []),
        forward: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            if (player && player.current) {
                var ref, ref1, ref2;
                var newTime = Math.min(((ref = player.current) === null || ref === void 0 ? void 0 : ref.getCurrentTime()) + 10, (ref1 = player.current) === null || ref1 === void 0 ? void 0 : ref1.getDuration());
                mergeState({
                    progress: newTime
                });
                (ref2 = player.current) === null || ref2 === void 0 ? void 0 : ref2.seekTo(newTime, "seconds");
            }
        }, []),
        end: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
            var ref;
            (ref = player.current) === null || ref === void 0 ? void 0 : ref.seekTo(0, "seconds");
            mergeState({
                progress: 0,
                isPlaying: false
            });
            pauseResource();
        }, [
            pauseResource
        ])
    };
}


/***/ }),

/***/ 21366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useUserTmpUploader; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/firebase/storage/dist/esm/index.esm.js + 1 modules
var index_esm = __webpack_require__(71540);
// EXTERNAL MODULE: ./node_modules/mime/dist/src/index.js + 3 modules
var src = __webpack_require__(27432);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(15153);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/core/resources/storagePaths.ts
var storagePaths = {
    /**
   * temporary uploaded user files.
   *
   */ userTmpDir: "/tmp/"
};

;// CONCATENATED MODULE: ./src/core/resources/useTmpUploader.tsx
// @ts-nocheck







function useUserTmpUploader(userId) {
    var ref1 = (0,react.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react.useState)(false), uploading = ref2[0], setUploading = ref2[1];
    return {
        upload: /**
     * upload a file to user's tmp dir
     */ function upload(file, base64, hasExt) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var ext, filePath, storage, storageRef, snapshot, _tmp, task, _tmp1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setUploading(true);
                            ext = hasExt ? ".".concat(getExtFile(file)) : "";
                            filePath = path_browserify_default().join(storagePaths.userTmpDir.replace(":userId", userId), String(Math.round(Math.random() * 1000000000)) + ext);
                            storage = (0,index_esm/* getStorage */.cF)();
                            storageRef = (0,index_esm/* ref */.iH)(storage, filePath);
                            if (!base64) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0,index_esm/* uploadString */.sf)(storageRef, file === null || file === void 0 ? void 0 : file.data, "base64", {
                                    contentType: file === null || file === void 0 ? void 0 : file.mimeType
                                })
                            ];
                        case 1:
                            snapshot = _state.sent();
                            setProgress(0);
                            _tmp = {
                                tmpPath: snapshot.ref.fullPath
                            };
                            return [
                                4,
                                (0,index_esm/* getDownloadURL */.Jt)(snapshot.ref)
                            ];
                        case 2:
                            return [
                                2,
                                (_tmp.fileUrl = _state.sent(), _tmp)
                            ];
                        case 3:
                            task = (0,index_esm/* uploadBytesResumable */.B0)(storageRef, file, {
                                contentType: src/* default.getType */.Z.getType(file === null || file === void 0 ? void 0 : file.type)
                            });
                            task.on("state_changed", function(snap) {
                                var progress = snap.bytesTransferred / snap.totalBytes * 100;
                                setProgress(Math.min(progress, 100));
                            });
                            return [
                                4,
                                task.then(function() {
                                    return setProgress(0);
                                }).catch(function(e) {
                                    throw e;
                                }).finally(function() {
                                    return setUploading(false);
                                })
                            ];
                        case 4:
                            _state.sent();
                            _tmp1 = {
                                tmpPath: task.snapshot.ref.fullPath
                            };
                            return [
                                4,
                                (0,index_esm/* getDownloadURL */.Jt)(task.snapshot.ref)
                            ];
                        case 5:
                            return [
                                2,
                                (_tmp1.fileUrl = _state.sent(), _tmp1)
                            ];
                    }
                });
            })();
        },
        progress: progress,
        uploading: uploading
    };
}
function getExtFile(file) {
    // for image file
    if ("type" in file) {
        return file.type === "jpeg" ? "jpg" : file.type;
    }
    // for other file (video, pdf, audio)
    return src/* default.getExtension */.Z.getExtension(file.mimeType) || "";
}


/***/ }),

/***/ 80321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ termsOfServiceUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);

var termsOfServiceUrl = function() {
    switch(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.applicationKey */ .v.applicationKey){
        case "playdeck":
            return "https://utoniq.notion.site/PLAYDECK-1b498c44c7d580a6ab10e8f58db0cb31";
        default:
            return "https://about.utoniq.com/terms";
    }
};


/***/ }),

/***/ 17745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ validatePublicBannerOverlap; },
/* harmony export */   "A6": function() { return /* binding */ validatePostalCodeConditional; },
/* harmony export */   "Co": function() { return /* binding */ validateCity; },
/* harmony export */   "DD": function() { return /* binding */ validateFullNameConditional; },
/* harmony export */   "Fy": function() { return /* binding */ validatePrefectureConditional; },
/* harmony export */   "Jf": function() { return /* binding */ validatePublicBannerEndDateRequired; },
/* harmony export */   "Kv": function() { return /* binding */ validateReservationBannerOverlap; },
/* harmony export */   "Nm": function() { return /* binding */ validateLine2Conditional; },
/* harmony export */   "Ol": function() { return /* binding */ validateBirthdayConditional; },
/* harmony export */   "Su": function() { return /* binding */ validateCityConditional; },
/* harmony export */   "Y0": function() { return /* binding */ validatePhoneNumber; },
/* harmony export */   "bA": function() { return /* binding */ validatePhoneNumberConditional; },
/* harmony export */   "c0": function() { return /* binding */ validateLine1Conditional; },
/* harmony export */   "f6": function() { return /* binding */ validatePrefecture; },
/* harmony export */   "fy": function() { return /* binding */ validateFullName; },
/* harmony export */   "iT": function() { return /* binding */ validateLine2; },
/* harmony export */   "lT": function() { return /* binding */ validateLine1; },
/* harmony export */   "n$": function() { return /* binding */ validateBannerDateOrder; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "pu": function() { return /* binding */ validateReservationBannerEndDate; },
/* harmony export */   "tZ": function() { return /* binding */ validateDisplayName; },
/* harmony export */   "zv": function() { return /* binding */ validatePublicBannerEndDate; }
/* harmony export */ });
/* harmony import */ var _core_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38679);
/* harmony import */ var _core_entities_values_PostalCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56903);



/**
 * 氏名（fullName）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大50文字まで
 * 2. 特殊文字を含まない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateFullName = function(o, labelKey) {
    return o.string().max(50).custom(function(value, helpers) {
        var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        if (value && /^\s*$/.test(value)) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ氏名（fullName）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validateFullNameConditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validateFullName(o, condition.labelKey),
        otherwise: o.string().when(flag, {
            is: true,
            then: validateFullName(o, condition.labelKey),
            otherwise: o.string().max(50).optional().allow(null, "").custom(function(value, helpers) {
                var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
                if (match) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                if (value && /^\s*$/.test(value)) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                return value;
            }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 都道府県（prefecture）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大150文字まで
 * 2. 特殊文字を含まない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validatePrefecture = function(o, labelKey) {
    return o.string().max(150).custom(function(value, helpers) {
        var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        if (value && /^\s*$/.test(value)) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ都道府県（prefecture）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validatePrefectureConditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validatePrefecture(o, condition.labelKey),
        otherwise: o.string().when(flag, {
            is: true,
            then: validatePrefecture(o, condition.labelKey),
            otherwise: o.string().max(150).optional().allow(null, "").custom(function(value, helpers) {
                // 特殊文字チェック
                var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
                if (match) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                // スペースチェック
                if (value && /^\s*$/.test(value)) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                return value;
            }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 市区町村（city）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大150文字まで
 * 2. 特殊文字を含まない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateCity = function(o, labelKey) {
    return o.string().max(150).custom(function(value, helpers) {
        var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        if (value && /^\s*$/.test(value)) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ市区町村（city）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validateCityConditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validateCity(o, condition.labelKey),
        otherwise: o.string().when(flag, {
            is: true,
            then: validateCity(o, condition.labelKey),
            otherwise: o.string().max(150).optional().allow(null, "").custom(function(value, helpers) {
                // 特殊文字チェック
                var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
                if (match) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                // スペースチェック
                if (value && /^\s*$/.test(value)) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                return value;
            }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 番地（line1）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大150文字まで
 * 2. ハイフンで始まらない
 * 3. 特殊文字を含まない（ハイフンは除く）
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateLine1 = function(o, labelKey) {
    return o.string().max(150).custom(function(value, helpers) {
        var match = value === null || value === void 0 ? void 0 : value.match(/^-.*$/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputStartsWithSymbol", {
                    symbol: match[0].slice(0, 1),
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        var specialCharsRegex = value === null || value === void 0 ? void 0 : value.match(/[=+@\t\r\n;,]+/);
        if (specialCharsRegex) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        if (value && /^\s*$/.test(value)) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ番地（line1）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validateLine1Conditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validateLine1(o, condition.labelKey),
        otherwise: o.string().when(flag, {
            is: true,
            then: validateLine1(o, condition.labelKey),
            otherwise: o.string().max(150).optional().allow(null, "").custom(function(value, helpers) {
                // 先頭に記号があるかチェック
                var match = value === null || value === void 0 ? void 0 : value.match(/^-.*$/);
                if (match) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputStartsWithSymbol", {
                            symbol: match[0].slice(0, 1),
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                // 特殊文字チェック
                var specialCharsRegex = value === null || value === void 0 ? void 0 : value.match(/[=+@\t\r\n;,]+/);
                if (specialCharsRegex) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                // スペースチェック
                if (value && /^\s*$/.test(value)) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                return value;
            }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 建物名（line2）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大150文字まで
 * 2. 特殊文字を含まない
 * 3. 任意項目
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateLine2 = function(o, labelKey) {
    return o.string().optional().allow("").max(150).custom(function(value, helpers) {
        var match = value.match(/[=+\-@\t\r\n;,]+/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ建物名（line2）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @returns バリデーションチェーン
 */ var validateLine2Conditional = function(o, condition) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validateLine2(o, condition.labelKey),
        otherwise: o.string().optional().allow(null, "").max(150).custom(function(value, helpers) {
            // 特殊文字チェック
            var match = value === null || value === void 0 ? void 0 : value.match(/[=+\-@\t\r\n;,]+/);
            if (match) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                        label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                    })
                });
            }
            return value;
        }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
    });
};
/**
 * メールアドレス（email）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 有効なメールアドレス形式
 * 2. 特殊文字（=, +, -, @）で始まらない
 * 3. 特殊文字（=, ;, タブ, 改行, キャリッジリターン, カンマ）を含まない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateEmail = function(o, labelKey) {
    return o.string().regex(_core_form__WEBPACK_IMPORTED_MODULE_0__/* .formRegex.email */ .rE.email).custom(function(value, helpers) {
        var match = value.match(/^([=+\-@])/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputStartsWithSymbol", {
                    symbol: match[1],
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        var specialCharsRegex = /[=;\t\n\r,]/;
        var specialCharsMatch = value.match(specialCharsRegex);
        if (specialCharsMatch) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 表示名（displayName）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大50文字まで
 * 2. 特殊文字を含まない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validateDisplayName = function(o, labelKey) {
    return o.string().max(50).custom(function(value, helpers) {
        var match = value.match(/[=+\-@\t\r\n;,]+/);
        if (match) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputContainSpecialChars", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 電話番号（phoneNumber）のバリデーション関数
 * 以下の条件をバリデーション：
 * 1. 最大15文字まで
 * 2. スペースのみの入力でない
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param labelKey - ラベルの翻訳キー
 * @returns バリデーションチェーン
 */ var validatePhoneNumber = function(o, labelKey) {
    return o.string().max(15).custom(function(value, helpers) {
        // スペースチェック
        if (value && /^\s*$/.test(value)) {
            return helpers.message({
                custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                    label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey)
                })
            });
        }
        return value;
    }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(labelKey));
};
/**
 * 条件付きバリデーションを持つ電話番号（phoneNumber）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validatePhoneNumberConditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: validatePhoneNumber(o, condition.labelKey),
        otherwise: o.string().when(flag, {
            is: true,
            then: validatePhoneNumber(o, condition.labelKey),
            otherwise: o.string().max(15).optional().allow(null, "").custom(function(value, helpers) {
                // スペースチェック
                if (value && /^\s*$/.test(value)) {
                    return helpers.message({
                        custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)("common:inputCannotBeOnlySpaces", {
                            label: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)
                        })
                    });
                }
                return value;
            }).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 条件付きバリデーションを持つ生年月日（birthday）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validateBirthdayConditional = function(o, condition, flag) {
    return o.date().when(condition.field, {
        is: condition.value,
        then: o.date().label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)),
        otherwise: o.date().when(flag, {
            is: true,
            then: o.date().label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)),
            otherwise: o.date().optional().allow(null, "").label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * 条件付きバリデーションを持つ郵便番号（postalCode）のバリデーション関数
 * 他のフィールドの値に依存するバリデーションが必要な場合に使用
 *
 * @param o - バリデーションオブジェクト（スキーマ定義から）
 * @param condition - 条件オブジェクト（field: フィールド名, value: 値, labelKey: ラベルの翻訳キー）
 * @param flag - 追加のバリデーションのためのフラグフィールド名
 * @returns バリデーションチェーン
 */ var validatePostalCodeConditional = function(o, condition, flag) {
    return o.string().when(condition.field, {
        is: condition.value,
        then: o.string().custom(_core_entities_values_PostalCode__WEBPACK_IMPORTED_MODULE_1__/* .PostalCode.createValidator */ .R.createValidator(true)).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)),
        otherwise: o.string().when(flag, {
            is: true,
            then: o.string().custom(_core_entities_values_PostalCode__WEBPACK_IMPORTED_MODULE_1__/* .PostalCode.createValidator */ .R.createValidator(true)).label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey)),
            otherwise: o.string().custom(_core_entities_values_PostalCode__WEBPACK_IMPORTED_MODULE_1__/* .PostalCode.createValidator */ .R.createValidator(false)).optional().allow(null, "").label((0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tLabel */ .TQ)(condition.labelKey))
        })
    });
};
/**
 * バナーの開始日・終了日の基本バリデーション
 * 開始日が終了日より後の場合はエラー
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param startField - 開始日フィールド名
 * @param endField - 終了日フィールド名
 * @param messageKey - エラーメッセージキー
 * @returns バリデーション結果
 */ var validateBannerDateOrder = function(value, helpers, data, startField, endField, messageKey) {
    if (!value) {
        return value;
    }
    var startDate = data[startField] ? data[startField] : new Date();
    var endDate = data[endField];
    if (startDate && endDate && startDate > endDate) {
        return helpers.message({
            custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
        });
    }
    return value;
};
/**
 * 公開バナーと予約バナーの重複チェック
 * 公開バナーが予約バナーの期間内に開始する場合をチェック
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param reservationStartField - 予約バナー開始日フィールド名
 * @param reservationEndField - 予約バナー終了日フィールド名
 * @param messageKey - エラーメッセージキー
 * @returns バリデーション結果
 */ var validatePublicBannerOverlap = function(value, helpers, data, reservationStartField, reservationEndField, messageKey) {
    if (!value) {
        return value;
    }
    var reservationStart = data[reservationStartField] && new Date(data[reservationStartField]);
    var reservationEnd = data[reservationEndField] && new Date(data[reservationEndField]);
    if (reservationStart) {
        if (reservationEnd) {
            // 公開バナーが予約バナーの期間内に開始する場合
            if (value > reservationStart && value < reservationEnd) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
                });
            }
        } else {
            // 公開バナーと予約バナーの重複チェック
            if (value > reservationStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
                });
            }
        }
    }
    return value;
};
/**
 * 公開バナーの終了日と予約バナーの前後関係チェック
 * 公開バナーの期間が予約バナーの期間を完全に包含する場合をチェック
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param startField - 開始日フィールド名
 * @param reservationStartField - 予約バナー開始日フィールド名
 * @param reservationEndField - 予約バナー終了日フィールド名
 * @param overlapMessageKey - 重複エラーメッセージキー
 * @param orderMessageKey - 前後関係エラーメッセージキー
 * @returns バリデーション結果
 */ var validatePublicBannerEndDate = function(value, helpers, data, startField, reservationStartField, reservationEndField, overlapMessageKey, orderMessageKey) {
    if (!value) {
        return value;
    }
    var startDate = data[startField];
    var reservationStart = data[reservationStartField] && new Date(data[reservationStartField]);
    var reservationEnd = data[reservationEndField] && new Date(data[reservationEndField]);
    if (reservationStart) {
        if (reservationEnd) {
            // 公開バナーの期間が予約バナーの期間を完全に包含する場合
            if (startDate && startDate < reservationStart && value > reservationStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(overlapMessageKey)
                });
            }
            // 公開バナーの終了日が予約バナーの開始日より後の場合
            if (value > reservationStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(orderMessageKey)
                });
            }
        }
        return value;
    }
    return value;
};
/**
 * 予約バナーと公開バナーの重複チェック
 * 予約バナーが公開バナーの期間内に開始する場合をチェック
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param publicStartField - 公開バナー開始日フィールド名
 * @param publicEndField - 公開バナー終了日フィールド名
 * @param messageKey - エラーメッセージキー
 * @returns バリデーション結果
 */ var validateReservationBannerOverlap = function(value, helpers, data, publicStartField, publicEndField, messageKey) {
    if (!value) {
        return value;
    }
    var publicStart = data[publicStartField] && new Date(data[publicStartField]);
    var publicEnd = data[publicEndField] && new Date(data[publicEndField]);
    if (publicStart) {
        if (publicEnd) {
            // 予約バナーが公開バナーの期間内に開始する場合
            if (value >= publicStart && value < publicEnd) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
                });
            }
        } else {
            // 予約バナーと公開バナーの重複チェック
            if (value >= publicStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
                });
            }
        }
    }
    return value;
};
/**
 * 予約バナーの終了日と公開バナーの前後関係チェック
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param startField - 開始日フィールド名
 * @param publicStartField - 公開バナー開始日フィールド名
 * @param publicEndField - 公開バナー終了日フィールド名
 * @param overlapMessageKey - 重複エラーメッセージキー
 * @param orderMessageKey - 前後関係エラーメッセージキー
 * @returns バリデーション結果
 */ var validateReservationBannerEndDate = function(value, helpers, data, startField, publicStartField, publicEndField, overlapMessageKey, orderMessageKey) {
    if (!value) {
        return value;
    }
    var startDate = data[startField];
    var publicStart = data[publicStartField] && new Date(data[publicStartField]);
    var publicEnd = data[publicEndField] && new Date(data[publicEndField]);
    if (publicStart) {
        if (publicEnd) {
            // 予約バナーの期間が公開バナーの期間を完全に包含する場合
            if (startDate && startDate < publicStart && value > publicStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(overlapMessageKey)
                });
            }
            // 公開バナーの開始日が予約バナーの終了日よりも後にある場合
            if (publicStart >= value) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(orderMessageKey)
                });
            }
        } else {
            // 無期限の場合は公開バナーの開始日を基準にする
            if (value >= publicStart) {
                return helpers.message({
                    custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(overlapMessageKey)
                });
            }
        }
    }
    return value;
};
/**
 * 公開バナーの終了日時が設定されているかチェック
 * 予約バナーを作成する際に公開バナーに終了日時が必要
 *
 * @param value - バリデーション対象の値
 * @param helpers - バリデーションヘルパー
 * @param data - フォームデータ
 * @param publicStartField - 公開バナー開始日フィールド名
 * @param publicEndField - 公開バナー終了日フィールド名
 * @param messageKey - エラーメッセージキー
 * @returns バリデーション結果
 */ var validatePublicBannerEndDateRequired = function(value, helpers, data, publicStartField, publicEndField, messageKey) {
    if (!value) {
        return value;
    }
    var publicStart = data[publicStartField] && new Date(data[publicStartField]);
    var publicEnd = data[publicEndField];
    // 公開バナーの開始日時が設定されているかチェック
    if (!publicStart || publicStart === "") {
        return helpers.message({
            custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
        });
    }
    // 公開バナーの終了日時が設定されているかチェック
    if (!publicEnd || publicEnd === "") {
        return helpers.message({
            custom: (0,_core_form__WEBPACK_IMPORTED_MODULE_0__/* .tMessage */ .Sd)(messageKey)
        });
    }
    return value;
};


/***/ }),

/***/ 40681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ client; },
/* harmony export */   "RG": function() { return /* binding */ indexes; },
/* harmony export */   "u8": function() { return /* binding */ filters; }
/* harmony export */ });
/* harmony import */ var algoliasearch_lite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43931);
/* harmony import */ var algoliasearch_lite__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);


var prefixes = {
    development: "dev_",
    staging: "stg_",
    production: "prod_"
};
var indexes = {
    organizationArtists: prefixes[_config__WEBPACK_IMPORTED_MODULE_0__/* .config.environment */ .v.environment] + "organization_artists_replica_followerCount_desc",
    items: prefixes[_config__WEBPACK_IMPORTED_MODULE_0__/* .config.environment */ .v.environment] + "items",
    itemsPriceAsc: prefixes[_config__WEBPACK_IMPORTED_MODULE_0__/* .config.environment */ .v.environment] + "items_replica_price_asc",
    itemsPriceDesc: prefixes[_config__WEBPACK_IMPORTED_MODULE_0__/* .config.environment */ .v.environment] + "items_replica_price_desc"
};
var filters = {
    organizationId: "organizationId:".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.organizationId */ .v.organizationId),
    /**
   * @description
   * トップ表示アーティスト用フィルター
   * 指定したアーティストIDのみ表示、指定がない場合は全表示
   */ topDisplayArtists: function(topDisplayArtistIds) {
        if (!(topDisplayArtistIds === null || topDisplayArtistIds === void 0 ? void 0 : topDisplayArtistIds.length)) return "organizationId:".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.organizationId */ .v.organizationId);
        return "organizationId:".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.organizationId */ .v.organizationId, " AND ") + "".concat(topDisplayArtistIds.map(function(id) {
            return "objectID:".concat(id);
        }).join(" OR "));
    },
    itemStoreArtist: function itemStoreArtist(artistId, publishedAtTimestamp, // 除外するアイテムID、アイテム詳細で当該アイテムは一覧から除外する
    itemId, // 作品一覧のキーワード検索を行っているかどうか
    hasKeyword) {
        if (!artistId) return;
        // 検索フィルター
        var filters = [
            "issuedByArtistId:".concat(artistId),
            "isPublished:true",
            "salesStatus:active",
            "review.status:accepted",
            "publishedAtTimestamp <= ".concat(publishedAtTimestamp),
            itemId ? "NOT objectID:".concat(itemId) : "", 
        ];
        // キーワード検索を行っていない場合、ストアコレクション内のアイテムは除外する
        if (!hasKeyword) {
            filters.push("NOT isCollectionSales:true");
        }
        return filters.filter(function(o) {
            return !!o;
        }).join(" AND ");
    }
};
function client() {
    return algoliasearch_lite__WEBPACK_IMPORTED_MODULE_1___default()("VA2ZJ3N9DB", "6a135579de7a9a4898d51f876722411c");
}


/***/ }),

/***/ 79832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ buildEventDateArray; },
/* harmony export */   "s": function() { return /* binding */ filterHiddenItem; }
/* harmony export */ });
/* harmony import */ var _lib_dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28879);
/* harmony import */ var _lib_dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_lib_dayjs__WEBPACK_IMPORTED_MODULE_0__);

/**
 * filter hidden item of array
 * @param data
 */ function filterHiddenItem(data) {
    return data.filter(function(param) {
        var hidden = param.hidden;
        return !hidden;
    });
}
/**
 * build event date array
 * @param event
 * @param {string} month
 */ function buildEventDateArray(event, month) {
    var dateArray = [];
    var startDayInMonth = _lib_dayjs__WEBPACK_IMPORTED_MODULE_0___default()(month, "YYYYMM").startOf("months").startOf("day");
    var daysInMonth = startDayInMonth.daysInMonth();
    Array.from({
        length: daysInMonth
    }).forEach(function(_, index) {
        var ref;
        var date = startDayInMonth.add(index, "d");
        var dateFormated = +date.format("YYYYMMDD");
        var closeDate = (ref = event.closeDate) === null || ref === void 0 ? void 0 : ref.map(function(closeDate) {
            return +_lib_dayjs__WEBPACK_IMPORTED_MODULE_0___default()(closeDate).format("YYYYMMDD");
        });
        var startedAtFormated = +_lib_dayjs__WEBPACK_IMPORTED_MODULE_0___default()(event.startedAt).format("YYYYMMDD");
        var endedAtFormated = +_lib_dayjs__WEBPACK_IMPORTED_MODULE_0___default()(event.endedAt).format("YYYYMMDD");
        if ((closeDate === null || closeDate === void 0 ? void 0 : closeDate.length) && closeDate.includes(dateFormated)) {
            return;
        }
        if (!event.startedAt && !event.endedAt) {
            return dateArray.push(date.format("YYYY/MM/DD"));
        }
        if (event.startedAt && !event.endedAt && dateFormated >= startedAtFormated) {
            return dateArray.push(date.format("YYYY/MM/DD"));
        }
        if (event.endedAt && !event.startedAt && dateFormated <= endedAtFormated) {
            return dateArray.push(date.format("YYYY/MM/DD"));
        }
        if (event.startedAt && event.endedAt && endedAtFormated >= dateFormated && startedAtFormated <= dateFormated) {
            return dateArray.push(date.format("YYYY/MM/DD"));
        }
    });
    return dateArray;
}


/***/ }),

/***/ 16:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getHelpUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87394);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90860);




/**
 * @description
 * Helpリンク用URL管理用ファイル
 * コメントを参考に追加していってください
 *
 * - getHelpUrl: ヘルプURL取得関数
 * - intercomArticleParamMap: intercom articlesのマップ
 * - helpUrlMap: 全てのヘルプURLのマップ
 */ /**
 * @description
 * ヘルプURL取得関数
 * @param key ヘルプURLのキー
 */ var getHelpUrl = function(key) {
    return helpUrlMap[key];
};
var intercomArticleBaseUrl = "https://help.utoniq.com/ja/articles/";
var getIntercomArticleUrl = function(articleParam) {
    return "".concat(intercomArticleBaseUrl).concat(articleParam);
};
/**
 * @description
 * intercom helpページのパラメーターMap
 * articleを追加した際は以下に キー:記事ID で追加してください。
 * https://app.intercom.com/a/apps/ofcvelff/articles/articles/list/all
 */ var intercomArticleParamMap = {
    noEmailReceived: 3969424,
    item: 6174903,
    serialNumber: 5916146,
    audioItem: "6681730#h_f3e810a6bd",
    videoItem: "6681730#h_bc1df8d50a",
    magazineItem: "6681730#h_0b7814f193",
    wallpaperItem: "6681730#h_4ef1149295",
    avatarItem: "6681730#h_d55aaf5425",
    merchItem: "6681730#h_1d76277b1a",
    thread: 6308816,
    liveStream: 6308816,
    howToIssueNft: 6367004,
    ownedItemDetail: 6174903,
    createCryptoWallet: 6739506,
    ranking: 6972549,
    resaleExhibit: 8061242,
    resaleApply: 8061252,
    resalePayment: "8061252#h_deb4ff030f",
    preSale: "8965589",
    ticketDistribution: "9758683-チケットの分配機能について",
    collection: "9586892-コレクションについて"
};
/**
 * 資金決済法に関するドキュメント
 * アプリケーションキーごとにドキュメントURLを定義すること
 * 未定義の場合は「デジリアトレカ」のドキュメントが使用されるので注意
 */ var wageSettlementMethodMap = {
    diica: "https://about.utoniq.com/diica_financial_agreement",
    sdp: "https://about.utoniq.com/digitalsdp_financial_agreement",
    "yt-unaverage": "https://about.utoniq.com/yt-unaverage_financial_agreement",
    "yt-unaverage-stg": "https://about.utoniq.com/yt-unaverage_financial_agreement",
    etoneigefc: "https://about.utoniq.com/financial_agreement/etoneigefc",
    "etoneigefc-stg": "https://about.utoniq.com/financial_agreement/etoneigefc",
    kyra: "https://about.utoniq.com/financial_agreement/kyra",
    "kyra-stg": "https://about.utoniq.com/financial_agreement/kyra"
};
var _applicationKey;
/**
 * @description
 * ヘルプURLのマップ
 *  - intercomのarticleの場合： intercomArticleParamMapに追加
 *  - intercom以外の場合： helpUrlMapsに直接追加
 *  - アプリ毎に動的なヘルプURLの場合： アプリ毎のconfigで管理し、helpUrlMapに追加
 */ var helpUrlMap = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, Object.fromEntries(Object.entries(intercomArticleParamMap).map(function(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], _$param = _param[1];
    return [
        key,
        getIntercomArticleUrl(_$param), 
    ];
}))), {
    /**
   * アプリ毎個別のヘルプURL
   * - intercomのcollectionsに作成する。アプリ毎に動的なためconfigにてURLを管理する
   * - https://app.intercom.com/a/apps/ofcvelff/articles/site/collections
   */ appHelp: _config__WEBPACK_IMPORTED_MODULE_3__/* .config.helpUrl */ .v.helpUrl,
    /**
   * 特定商取引法に基づく表記の表示URL
   */ specifiedCommercialTransactionLaw: "https://about.utoniq.com/tokushoho",
    /**
   * 資金決済法に基づく表示URL
   * - 現在、DiicaとSDPのみ資金決済法の表示を出し分けているため以下表示リンクを分けている
   */ wageSettlementMethod: (_applicationKey = wageSettlementMethodMap[_config__WEBPACK_IMPORTED_MODULE_3__/* .config.applicationKey */ .v.applicationKey]) !== null && _applicationKey !== void 0 ? _applicationKey : "https://about.utoniq.com/financial_agreement"
});



/***/ }),

/***/ 66419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

// 画像URLからImageオブジェクトを返す
function useImage(src) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), image = ref[0], setImage = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!src) return;
        var img = new Image();
        img.src = src;
        var handleOnload = function() {
            setImage(img);
        };
        img.addEventListener("load", handleOnload);
        return function() {
            img.removeEventListener("load", handleOnload);
        };
    }, [
        src
    ]);
    return image;
}


/***/ }),

/***/ 94998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ promisifiedResult; }
/* harmony export */ });
/* harmony import */ var _hqoss_monads__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74987);


function promisifiedResult(callback) {
    return new Promise(function(res, rej) {
        // resultを返すので、rejectせず、resultのエラーで返す
        callback(function(result) {
            return res((0,_hqoss_monads__WEBPACK_IMPORTED_MODULE_0__.Ok)(result));
        }, function(error) {
            return res((0,_hqoss_monads__WEBPACK_IMPORTED_MODULE_0__/* .Err */ .UG)(error));
        });
    });
}


/***/ }),

/***/ 14514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ usePrivateAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16083);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60705);


/**
 *
 * @description used to handle functions that require the user to be logged in
 * @example
 * const { handleLoginModal } = usePrivateAction()
 * ...
 * <Component {...otherProps} onClick={handleLoginModal()} />
 * ...
 */ var usePrivateAction = function() {
    var user = (0,_core__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUser */ .xJ)().user;
    var showModal = (0,_core__WEBPACK_IMPORTED_MODULE_2__/* .useLoginModal */ .N)().showModal;
    /**
   *
   * 未ログインユーザーの場合にログインモーダルが表示されること。
   * 引数の関数はログインしていた場合に実行されること
   * @param {function} action
   * @return function
   */ var handleLoginModal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(action) {
        var allowAnonymous = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return function(event) {
            if (allowAnonymous ? !user : !(user === null || user === void 0 ? void 0 : user.isSigned)) {
                event.preventDefault();
                showModal();
                return;
            }
            action && action(event);
        };
    }, [
        user,
        showModal
    ]);
    return {
        isLoggedIn: !!(user === null || user === void 0 ? void 0 : user.isSigned),
        handleLoginModal: handleLoginModal
    };
};


/***/ }),

/***/ 86819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ LinkifyBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12363);
/* harmony import */ var react_linkify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3546);



var LinkifyBox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: {
            ".linkify": {
                color: "primary.main",
                textDecoration: "none"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_linkify__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            componentDecorator: function(decoratedHref, decoratedText, key) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: "_blank",
                    style: {
                        textDecoration: "none"
                    },
                    href: decoratedHref,
                    className: "linkify",
                    children: decoratedText
                }, key);
            },
            children: children
        })
    });
};


/***/ }),

/***/ 36604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bm": function() { return /* binding */ isExternalLink; },
/* harmony export */   "Kh": function() { return /* binding */ getArtistAppLink; },
/* harmony export */   "Mq": function() { return /* binding */ encodeUrl; },
/* harmony export */   "QP": function() { return /* binding */ generateFullPath; },
/* harmony export */   "yB": function() { return /* binding */ replaceParameters; }
/* harmony export */ });
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16550);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90860);


/**
 * @description
 * URLのクエリパラメータのうち、{key}の文字をkeyMapで指定した値に置換する
 * e.g.
 * {
 *  url: https://example.com?name={name},
 *  keyMap: { name: "alice" }
 * }
 * ↓
 * https://example.com?name=alice
 */ var replaceParameters = function(url, keyMap) {
    var replacedUrl = url;
    Object.keys(keyMap).forEach(function(key) {
        replacedUrl = replacedUrl.replace("{".concat(key, "}"), keyMap[key]);
    });
    return replacedUrl;
};
/**
 * @description generate domain + path
 * @param path
 * @param options
 * @example
 * path: /test/:testId
 * option: testId: 100
 * ↓
 * https://example.com/test/100
 */ var generateFullPath = function(path, options) {
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* .config.domain */ .v.domain).concat((0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .generatePath */ .Gn)(path, options));
};
var encodeUrl = function(url) {
    if (!url) return url;
    var isEncoded = decodeURI(url) !== url;
    if (!isEncoded) return encodeURI(url);
    return url;
};
/**
 * Determines whether a given URL is an external link.
 * An external link is defined as a link with a protocol of `http` or `https`
 * @param {string} url - The URL to check. Can be absolute (e.g., "https://example.com") or relative (e.g., "/about").
 */ var isExternalLink = function(url) {
    // Define a regular expression to match URLs with `http` or `https` protocol
    var externalLinkRegex = /^https?:\/\/([^/]+)/i;
    // Match the given URL against the regex to extract the protocol and host
    return !!url.match(externalLinkRegex);
};
/**
 * Get artist app link by type
 * @param appLinks
 * @param type
 */ var getArtistAppLink = function(appLinks, type) {
    return appLinks === null || appLinks === void 0 ? void 0 : appLinks.find(function(appLink) {
        return (appLink === null || appLink === void 0 ? void 0 : appLink.type) === type;
    });
};


/***/ }),

/***/ 74465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useCreateShortLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _components_pages_Ulink_viewModel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74389);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90860);







var useCreateShortLink = function(param) {
    var path = param.path;
    var redirectUrl = _config__WEBPACK_IMPORTED_MODULE_1__/* .config.domain */ .v.domain + path;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(_components_pages_Ulink_viewModel__WEBPACK_IMPORTED_MODULE_4__/* .CREATE_SHORT_LINK_QUERY */ .T8), 1), createShortLink = ref[0];
    var createLink = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var ref, data, ref1, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        createShortLink({
                            variables: {
                                redirectUrl: redirectUrl
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        (ref1 = data === null || data === void 0 ? void 0 : (ref = data.createShortLink) === null || ref === void 0 ? void 0 : ref.shortLink) !== null && ref1 !== void 0 ? ref1 : redirectUrl
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        redirectUrl
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        redirectUrl,
        createShortLink
    ]);
    return createLink;
};


/***/ }),

/***/ 46601:
/***/ (function() {

/* (ignored) */

/***/ })

}]);